webpackJsonp([1,0],[
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks () {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback (callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return input != null && Object.prototype.toString.call(input) === '[object Object]';
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return (Object.getOwnPropertyNames(obj).length === 0);
	        } else {
	            var k;
	            for (k in obj) {
	                if (obj.hasOwnProperty(k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	    }
	
	    function isDate(input) {
	        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	    }
	
	    function map(arr, fn) {
	        var res = [], i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty           : false,
	            unusedTokens    : [],
	            unusedInput     : [],
	            overflow        : -2,
	            charsLeftOver   : 0,
	            nullInput       : false,
	            invalidMonth    : null,
	            invalidFormat   : false,
	            userInvalidated : false,
	            iso             : false,
	            parsedDateParts : [],
	            meridiem        : null,
	            rfc2822         : false,
	            weekdayMismatch : false
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this);
	            var len = t.length >>> 0;
	
	            for (var i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m);
	            var parsedParts = some.call(flags.parsedDateParts, function (i) {
	                return i != null;
	            });
	            var isNowValid = !isNaN(m._d.getTime()) &&
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.weekdayMismatch &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated &&
	                (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid = isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            }
	            else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid (flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        }
	        else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = hooks.momentProperties = [];
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i = 0; i < momentProperties.length; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    var updateInProgress = false;
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment (obj) {
	        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	    }
	
	    function absFloor (number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if ((dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    function warn(msg) {
	        if (hooks.suppressDeprecationWarnings === false &&
	                (typeof console !==  'undefined') && console.warn) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [];
	                var arg;
	                for (var i = 0; i < arguments.length; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (var key in arguments[0]) {
	                            arg += key + ': ' + arguments[0][key] + ', ';
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	    function set (config) {
	        var prop, i;
	        for (i in config) {
	            prop = config[i];
	            if (isFunction(prop)) {
	                this[i] = prop;
	            } else {
	                this['_' + i] = prop;
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' + (/\d{1,2}/).source);
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig), prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (hasOwnProp(parentConfig, prop) &&
	                    !hasOwnProp(childConfig, prop) &&
	                    isObject(parentConfig[prop])) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i, res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    };
	
	    function calendar (key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    var defaultLongDateFormat = {
	        LTS  : 'h:mm:ss A',
	        LT   : 'h:mm A',
	        L    : 'MM/DD/YYYY',
	        LL   : 'MMMM D, YYYY',
	        LLL  : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    };
	
	    function longDateFormat (key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	            return val.slice(1);
	        });
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate () {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d';
	    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal (number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future : 'in %s',
	        past   : '%s ago',
	        s  : 'a few seconds',
	        ss : '%d seconds',
	        m  : 'a minute',
	        mm : '%d minutes',
	        h  : 'an hour',
	        hh : '%d hours',
	        d  : 'a day',
	        dd : '%d days',
	        M  : 'a month',
	        MM : '%d months',
	        y  : 'a year',
	        yy : '%d years'
	    };
	
	    function relativeTime (number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return (isFunction(output)) ?
	            output(number, withoutSuffix, string, isFuture) :
	            output.replace(/%d/i, number);
	    }
	
	    function pastFuture (diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias (unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [];
	        for (var u in unitsObj) {
	            units.push({unit: u, priority: priorities[u]});
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	    var formatFunctions = {};
	
	    var formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken (token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(func.apply(this, arguments), token);
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens), i, length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '', i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var match1         = /\d/;            //       0 - 9
	    var match2         = /\d\d/;          //      00 - 99
	    var match3         = /\d{3}/;         //     000 - 999
	    var match4         = /\d{4}/;         //    0000 - 9999
	    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	    var match1to2      = /\d\d?/;         //       0 - 99
	    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	    var match1to3      = /\d{1,3}/;       //       0 - 999
	    var match1to4      = /\d{1,4}/;       //       0 - 9999
	    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	    var matchUnsigned  = /\d+/;           //       0 - inf
	    var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	    // any word (or two) characters or numbers including two/three word month in arabic.
	    // includes scottish gaelic two word and hyphenated months
	    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
	
	    var regexes = {};
	
	    function addRegexToken (token, regex, strictRegex) {
	        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	            return (isStrict && strictRegex) ? strictRegex : regex;
	        };
	    }
	
	    function getParseRegexForToken (token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	            return p1 || p2 || p3 || p4;
	        }));
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken (token, callback) {
	        var i, func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken (token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0;
	    var MONTH = 1;
	    var DATE = 2;
	    var HOUR = 3;
	    var MINUTE = 4;
	    var SECOND = 5;
	    var MILLISECOND = 6;
	    var WEEK = 7;
	    var WEEKDAY = 8;
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? '' + y : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY',   4],       0, 'year');
	    addFormatToken(0, ['YYYYY',  5],       0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y',      matchSigned);
	    addRegexToken('YY',     match1to2, match2);
	    addRegexToken('YYYY',   match1to4, match4);
	    addRegexToken('YYYYY',  match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear () {
	        return isLeapYear(this.year());
	    }
	
	    function makeGetSet (unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get (mom, unit) {
	        return mom.isValid() ?
	            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	    }
	
	    function set$1 (mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
	            }
	            else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet (units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	
	    function stringSet (units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units);
	            for (var i = 0; i < prioritized.length; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M',    match1to2);
	    addRegexToken('MM',   match1to2, match2);
	    addRegexToken('MMM',  function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	    function localeMonths (m, format) {
	        if (!m) {
	            return isArray(this._months) ? this._months :
	                this._months['standalone'];
	        }
	        return isArray(this._months) ? this._months[m.month()] :
	            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	    function localeMonthsShort (m, format) {
	        if (!m) {
	            return isArray(this._monthsShort) ? this._monthsShort :
	                this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i, ii, mom, llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse (monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth (mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth (value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth () {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    var defaultMonthsShortRegex = matchWord;
	    function monthsShortRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict ?
	                this._monthsShortStrictRegex : this._monthsShortRegex;
	        }
	    }
	
	    var defaultMonthsRegex = matchWord;
	    function monthsRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict ?
	                this._monthsStrictRegex : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    }
	
	    function createDate (y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate (y) {
	        var date;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            var args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear, resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek, resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w',  match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W',  match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek (mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek () {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear () {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek (input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek (input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d',    match1to2);
	    addRegexToken('e',    match1to2);
	    addRegexToken('E',    match1to2);
	    addRegexToken('dd',   function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd',   function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd',   function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays (ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	    function localeWeekdays (m, format) {
	        var weekdays = isArray(this._weekdays) ? this._weekdays :
	            this._weekdays[(m && m !== true && this._weekdays.isFormat.test(format)) ? 'format' : 'standalone'];
	        return (m === true) ? shiftWeekdays(weekdays, this._week.dow)
	            : (m) ? weekdays[m.day()] : weekdays;
	    }
	
	    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	    function localeWeekdaysShort (m) {
	        return (m === true) ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	    }
	
	    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	    function localeWeekdaysMin (m) {
	        return (m === true) ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse (weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
	            }
	            if (!this._weekdaysParse[i]) {
	                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    var defaultWeekdaysRegex = matchWord;
	    function weekdaysRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict ?
	                this._weekdaysStrictRegex : this._weekdaysRegex;
	        }
	    }
	
	    var defaultWeekdaysShortRegex = matchWord;
	    function weekdaysShortRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict ?
	                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	        }
	    }
	
	    var defaultWeekdaysMinRegex = matchWord;
	    function weekdaysMinRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict ?
	                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	        }
	    }
	
	
	    function computeWeekdaysParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom, minp, shortp, longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = this.weekdaysMin(mom, '');
	            shortp = this.weekdaysShort(mom, '');
	            longp = this.weekdays(mom, '');
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 7; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    function meridiem (token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem (isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a',  matchMeridiem);
	    addRegexToken('A',  matchMeridiem);
	    addRegexToken('H',  match1to2);
	    addRegexToken('h',  match1to2);
	    addRegexToken('k',  match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM (input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return ((input + '').toLowerCase().charAt(0) === 'p');
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	    function localeMeridiem (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	
	    // MOMENTS
	
	    // Setting the hour should keep the time, because the user explicitly
	    // specified which hour they want. So trying to maintain the same hour (in
	    // a new timezone) makes sense. Adding/subtracting hours does not follow
	    // this rule.
	    var getSetHour = makeGetSet('Hours', true);
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse
	    };
	
	    // internal storage for locale config files
	    var locales = {};
	    var localeFamilies = {};
	    var globalLocale;
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0, j, next, locale, split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (!locales[name] && (typeof module !== 'undefined') &&
	                module && module.exports) {
	            try {
	                oldLocale = globalLocale._abbr;
	                var aliasedRequire = require;
	                __webpack_require__(446)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {}
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale (key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            }
	            else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            }
	            else {
	                if ((typeof console !==  'undefined') && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale (name, config) {
	        if (config !== null) {
	            var locale, parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple('defineLocaleOverride',
	                        'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale, tmpLocale, parentConfig = baseConfig;
	            // MERGE
	            tmpLocale = loadLocale(name);
	            if (tmpLocale != null) {
	                parentConfig = tmpLocale._config;
	            }
	            config = mergeConfigs(parentConfig, config);
	            locale = new Locale(config);
	            locale.parentLocale = locales[name];
	            locales[name] = locale;
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale (key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow (m) {
	        var overflow;
	        var a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	                -1;
	
	            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray (config) {
	        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (config._a[HOUR] === 24 &&
	                config._a[MINUTE] === 0 &&
	                config._a[SECOND] === 0 &&
	                config._a[MILLISECOND] === 0) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            var curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	    var isoDates = [
	        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	        ['YYYY-DDD', /\d{4}-\d{3}/],
	        ['YYYY-MM', /\d{4}-\d\d/, false],
	        ['YYYYYYMMDD', /[+-]\d{10}/],
	        ['YYYYMMDD', /\d{8}/],
	        // YYYYMM is NOT allowed by the standard
	        ['GGGG[W]WWE', /\d{4}W\d{3}/],
	        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	        ['YYYYDDD', /\d{7}/]
	    ];
	
	    // iso time formats and regexes
	    var isoTimes = [
	        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	        ['HH:mm', /\d\d:\d\d/],
	        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	        ['HHmmss', /\d\d\d\d\d\d/],
	        ['HHmm', /\d\d\d\d/],
	        ['HH', /\d\d/]
	    ];
	
	    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	    // date from iso format
	    function configFromISO(config) {
	        var i, l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime, dateFormat, timeFormat, tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;
	
	    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10)
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    var obsOffsets = {
	        UT: 0,
	        GMT: 0,
	        EDT: -4 * 60,
	        EST: -5 * 60,
	        CDT: -5 * 60,
	        CST: -6 * 60,
	        MDT: -6 * 60,
	        MST: -7 * 60,
	        PDT: -7 * 60,
	        PST: -8 * 60
	    };
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10);
	            var m = hm % 100, h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i));
	        if (match) {
	            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from iso format or fallback
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        // Final attempt, use Input Fallback
	        hooks.createFromInputFallback(config);
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	        'discouraged and will be removed in an upcoming major release. Please refer to ' +
	        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i, parsedInput, tokens, token, skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0;
	
	        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	            // console.log('token', token, 'parsedInput', parsedInput,
	            //         'regex', getParseRegexForToken(token, config));
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                }
	                else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            }
	            else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	
	    function meridiemFixWrap (locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	
	            scoreToBeat,
	            i,
	            currentScore;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (!isValid(tempConfig)) {
	                continue;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (scoreToBeat == null || currentScore < scoreToBeat) {
	                scoreToBeat = currentScore;
	                bestMoment = tempConfig;
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i);
	        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	            return obj && parseInt(obj, 10);
	        });
	
	        configFromArray(config);
	    }
	
	    function createFromConfig (config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig (config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({nullInput: true});
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        }  else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC (input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if ((isObject(input) && isObjectEmpty(input)) ||
	                (isArray(input) && input.length === 0)) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other < this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    var prototypeMax = deprecate(
	        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other > this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +(new Date());
	    };
	
	    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	    function isDurationValid(m) {
	        for (var key in m) {
	            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	                return false;
	            }
	        }
	
	        var unitHasDecimal = false;
	        for (var i = 0; i < ordering.length; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration (duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds = +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days +
	            weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months +
	            quarters * 3 +
	            years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration (obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound (number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // FORMATTING
	
	    function offset (token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset();
	            var sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z',  matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher);
	
	        if (matches === null) {
	            return null;
	        }
	
	        var chunk   = matches[matches.length - 1] || [];
	        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ?
	          0 :
	          parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset (m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset (input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone (input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC (keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal (keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset () {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            }
	            else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset (input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime () {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted () {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {};
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted = this.isValid() &&
	                compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal () {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset () {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc () {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	    // and further modified to allow for strings containing both week and day
	    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration (input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms : input._milliseconds,
	                d  : input._days,
	                M  : input._months
	            };
	        } else if (isNumber(input)) {
	            duration = {};
	            if (key) {
	                duration[key] = input;
	            } else {
	                duration.milliseconds = input;
	            }
	        } else if (!!(match = aspNetRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y  : 0,
	                d  : toInt(match[DATE])                         * sign,
	                h  : toInt(match[HOUR])                         * sign,
	                m  : toInt(match[MINUTE])                       * sign,
	                s  : toInt(match[SECOND])                       * sign,
	                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	            };
	        } else if (!!(match = isoRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y : parseIso(match[2], sign),
	                M : parseIso(match[3], sign),
	                w : parseIso(match[4], sign),
	                d : parseIso(match[5], sign),
	                h : parseIso(match[6], sign),
	                m : parseIso(match[7], sign),
	                s : parseIso(match[8], sign)
	            };
	        } else if (duration == null) {// checks for null or undefined
	            duration = {};
	        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso (inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months = other.month() - base.month() +
	            (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return {milliseconds: 0, months: 0};
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	                tmp = val; val = period; period = tmp;
	            }
	
	            val = typeof val === 'string' ? +val : val;
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract (mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add      = createAdder(1, 'add');
	    var subtract = createAdder(-1, 'subtract');
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6 ? 'sameElse' :
	                diff < -1 ? 'lastWeek' :
	                diff < 0 ? 'lastDay' :
	                diff < 1 ? 'sameDay' :
	                diff < 2 ? 'nextDay' :
	                diff < 7 ? 'nextWeek' : 'sameElse';
	    }
	
	    function calendar$1 (time, formats) {
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	    }
	
	    function clone () {
	        return new Moment(this);
	    }
	
	    function isAfter (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween (from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
	    }
	
	    function isSame (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	        }
	    }
	
	    function isSameOrAfter (input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore (input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff (input, units, asFloat) {
	        var that,
	            zoneDelta,
	            output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year': output = monthDiff(this, that) / 12; break;
	            case 'month': output = monthDiff(this, that); break;
	            case 'quarter': output = monthDiff(this, that) / 3; break;
	            case 'second': output = (this - that) / 1e3; break; // 1000
	            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
	            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
	            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default: output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff (a, b) {
	        // difference in months
	        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2, adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString () {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true;
	        var m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect () {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment';
	        var zone = '';
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        var prefix = '[' + func + '("]';
	        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        var suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format (inputString) {
	        if (!inputString) {
	            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow (withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow (withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale (key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData () {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000;
	    var MS_PER_MINUTE = 60 * MS_PER_SECOND;
	    var MS_PER_HOUR = 60 * MS_PER_MINUTE;
	    var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return (dividend % divisor + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf (units) {
	        var time;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
	                break;
	            case 'isoWeek':
	                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf (units) {
	        var time;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
	                break;
	            case 'isoWeek':
	                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf () {
	        return this._d.valueOf() - ((this._offset || 0) * 60000);
	    }
	
	    function unix () {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate () {
	        return new Date(this.valueOf());
	    }
	
	    function toArray () {
	        var m = this;
	        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	    }
	
	    function toObject () {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds()
	        };
	    }
	
	    function toJSON () {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2 () {
	        return isValid(this);
	    }
	
	    function parsingFlags () {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt () {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict
	        };
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken (token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg',     'weekYear');
	    addWeekYearFormatToken('ggggg',    'weekYear');
	    addWeekYearFormatToken('GGGG',  'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	
	    // PARSING
	
	    addRegexToken('G',      matchSigned);
	    addRegexToken('g',      matchSigned);
	    addRegexToken('GG',     match1to2, match2);
	    addRegexToken('gg',     match1to2, match2);
	    addRegexToken('GGGG',   match1to4, match4);
	    addRegexToken('gggg',   match1to4, match4);
	    addRegexToken('GGGGG',  match1to6, match6);
	    addRegexToken('ggggg',  match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input,
	                this.week(),
	                this.weekday(),
	                this.localeData()._week.dow,
	                this.localeData()._week.doy);
	    }
	
	    function getSetISOWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input, this.isoWeek(), this.isoWeekday(), 1, 4);
	    }
	
	    function getISOWeeksInYear () {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getWeeksInYear () {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter (input) {
	        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D',  match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict ?
	          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	          locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD',  match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear (input) {
	        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m',  match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s',  match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S',    match1to3, match1);
	    addRegexToken('SS',   match1to3, match2);
	    addRegexToken('SSS',  match1to3, match3);
	
	    var token;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	    // MOMENTS
	
	    var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z',  0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr () {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName () {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add               = add;
	    proto.calendar          = calendar$1;
	    proto.clone             = clone;
	    proto.diff              = diff;
	    proto.endOf             = endOf;
	    proto.format            = format;
	    proto.from              = from;
	    proto.fromNow           = fromNow;
	    proto.to                = to;
	    proto.toNow             = toNow;
	    proto.get               = stringGet;
	    proto.invalidAt         = invalidAt;
	    proto.isAfter           = isAfter;
	    proto.isBefore          = isBefore;
	    proto.isBetween         = isBetween;
	    proto.isSame            = isSame;
	    proto.isSameOrAfter     = isSameOrAfter;
	    proto.isSameOrBefore    = isSameOrBefore;
	    proto.isValid           = isValid$2;
	    proto.lang              = lang;
	    proto.locale            = locale;
	    proto.localeData        = localeData;
	    proto.max               = prototypeMax;
	    proto.min               = prototypeMin;
	    proto.parsingFlags      = parsingFlags;
	    proto.set               = stringSet;
	    proto.startOf           = startOf;
	    proto.subtract          = subtract;
	    proto.toArray           = toArray;
	    proto.toObject          = toObject;
	    proto.toDate            = toDate;
	    proto.toISOString       = toISOString;
	    proto.inspect           = inspect;
	    proto.toJSON            = toJSON;
	    proto.toString          = toString;
	    proto.unix              = unix;
	    proto.valueOf           = valueOf;
	    proto.creationData      = creationData;
	    proto.year       = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear    = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month       = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week           = proto.weeks        = getSetWeek;
	    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	    proto.weeksInYear    = getWeeksInYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.date       = getSetDayOfMonth;
	    proto.day        = proto.days             = getSetDayOfWeek;
	    proto.weekday    = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear  = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset            = getSetOffset;
	    proto.utc                  = setOffsetToUTC;
	    proto.local                = setOffsetToLocal;
	    proto.parseZone            = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST                = isDaylightSavingTime;
	    proto.isLocal              = isLocal;
	    proto.isUtcOffset          = isUtcOffset;
	    proto.isUtc                = isUtc;
	    proto.isUTC                = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	    function createUnix (input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone () {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat (string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar        = calendar;
	    proto$1.longDateFormat  = longDateFormat;
	    proto$1.invalidDate     = invalidDate;
	    proto$1.ordinal         = ordinal;
	    proto$1.preparse        = preParsePostFormat;
	    proto$1.postformat      = preParsePostFormat;
	    proto$1.relativeTime    = relativeTime;
	    proto$1.pastFuture      = pastFuture;
	    proto$1.set             = set;
	
	    proto$1.months            =        localeMonths;
	    proto$1.monthsShort       =        localeMonthsShort;
	    proto$1.monthsParse       =        localeMonthsParse;
	    proto$1.monthsRegex       = monthsRegex;
	    proto$1.monthsShortRegex  = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays       =        localeWeekdays;
	    proto$1.weekdaysMin    =        localeWeekdaysMin;
	    proto$1.weekdaysShort  =        localeWeekdaysShort;
	    proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	    proto$1.weekdaysRegex       =        weekdaysRegex;
	    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1 (format, index, field, setter) {
	        var locale = getLocale();
	        var utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl (format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl (localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0;
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths (format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort (format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (toInt(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	    var mathAbs = Math.abs;
	
	    function abs () {
	        var data           = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days         = mathAbs(this._days);
	        this._months       = mathAbs(this._months);
	
	        data.milliseconds  = mathAbs(data.milliseconds);
	        data.seconds       = mathAbs(data.seconds);
	        data.minutes       = mathAbs(data.minutes);
	        data.hours         = mathAbs(data.hours);
	        data.months        = mathAbs(data.months);
	        data.years         = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1 (duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days         += direction * other._days;
	        duration._months       += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1 (input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1 (input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil (number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble () {
	        var milliseconds = this._milliseconds;
	        var days         = this._days;
	        var months       = this._months;
	        var data         = this._data;
	        var seconds, minutes, hours, years, monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0))) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds           = absFloor(milliseconds / 1000);
	        data.seconds      = seconds % 60;
	
	        minutes           = absFloor(seconds / 60);
	        data.minutes      = minutes % 60;
	
	        hours             = absFloor(minutes / 60);
	        data.hours        = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days   = days;
	        data.months = months;
	        data.years  = years;
	
	        return this;
	    }
	
	    function daysToMonths (days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return days * 4800 / 146097;
	    }
	
	    function monthsToDays (months) {
	        // the reverse of daysToMonths
	        return months * 146097 / 4800;
	    }
	
	    function as (units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days;
	        var months;
	        var milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':   return months;
	                case 'quarter': return months / 3;
	                case 'year':    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week'   : return days / 7     + milliseconds / 6048e5;
	                case 'day'    : return days         + milliseconds / 864e5;
	                case 'hour'   : return days * 24    + milliseconds / 36e5;
	                case 'minute' : return days * 1440  + milliseconds / 6e4;
	                case 'second' : return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	                default: throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1 () {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs (alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms');
	    var asSeconds      = makeAs('s');
	    var asMinutes      = makeAs('m');
	    var asHours        = makeAs('h');
	    var asDays         = makeAs('d');
	    var asWeeks        = makeAs('w');
	    var asMonths       = makeAs('M');
	    var asQuarters     = makeAs('Q');
	    var asYears        = makeAs('y');
	
	    function clone$1 () {
	        return createDuration(this);
	    }
	
	    function get$2 (units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds');
	    var seconds      = makeGetter('seconds');
	    var minutes      = makeGetter('minutes');
	    var hours        = makeGetter('hours');
	    var days         = makeGetter('days');
	    var months       = makeGetter('months');
	    var years        = makeGetter('years');
	
	    function weeks () {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round;
	    var thresholds = {
	        ss: 44,         // a few seconds to seconds
	        s : 45,         // seconds to minute
	        m : 45,         // minutes to hour
	        h : 22,         // hours to day
	        d : 26,         // days to month
	        M : 11          // months to year
	    };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	        var duration = createDuration(posNegDuration).abs();
	        var seconds  = round(duration.as('s'));
	        var minutes  = round(duration.as('m'));
	        var hours    = round(duration.as('h'));
	        var days     = round(duration.as('d'));
	        var months   = round(duration.as('M'));
	        var years    = round(duration.as('y'));
	
	        var a = seconds <= thresholds.ss && ['s', seconds]  ||
	                seconds < thresholds.s   && ['ss', seconds] ||
	                minutes <= 1             && ['m']           ||
	                minutes < thresholds.m   && ['mm', minutes] ||
	                hours   <= 1             && ['h']           ||
	                hours   < thresholds.h   && ['hh', hours]   ||
	                days    <= 1             && ['d']           ||
	                days    < thresholds.d   && ['dd', days]    ||
	                months  <= 1             && ['M']           ||
	                months  < thresholds.M   && ['MM', months]  ||
	                years   <= 1             && ['y']           || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding (roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof(roundingFunction) === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold (threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize (withSuffix) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var locale = this.localeData();
	        var output = relativeTime$1(this, !withSuffix, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return ((x > 0) - (x < 0)) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000;
	        var days         = abs$1(this._days);
	        var months       = abs$1(this._months);
	        var minutes, hours, years;
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes           = absFloor(seconds / 60);
	        hours             = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years  = absFloor(months / 12);
	        months %= 12;
	
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        var Y = years;
	        var M = months;
	        var D = days;
	        var h = hours;
	        var m = minutes;
	        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	        var total = this.asSeconds();
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        var totalSign = total < 0 ? '-' : '';
	        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return totalSign + 'P' +
	            (Y ? ymSign + Y + 'Y' : '') +
	            (M ? ymSign + M + 'M' : '') +
	            (D ? daysSign + D + 'D' : '') +
	            ((h || m || s) ? 'T' : '') +
	            (h ? hmsSign + h + 'H' : '') +
	            (m ? hmsSign + m + 'M' : '') +
	            (s ? hmsSign + s + 'S' : '');
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid        = isValid$1;
	    proto$2.abs            = abs;
	    proto$2.add            = add$1;
	    proto$2.subtract       = subtract$1;
	    proto$2.as             = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds      = asSeconds;
	    proto$2.asMinutes      = asMinutes;
	    proto$2.asHours        = asHours;
	    proto$2.asDays         = asDays;
	    proto$2.asWeeks        = asWeeks;
	    proto$2.asMonths       = asMonths;
	    proto$2.asQuarters     = asQuarters;
	    proto$2.asYears        = asYears;
	    proto$2.valueOf        = valueOf$1;
	    proto$2._bubble        = bubble;
	    proto$2.clone          = clone$1;
	    proto$2.get            = get$2;
	    proto$2.milliseconds   = milliseconds;
	    proto$2.seconds        = seconds;
	    proto$2.minutes        = minutes;
	    proto$2.hours          = hours;
	    proto$2.days           = days;
	    proto$2.weeks          = weeks;
	    proto$2.months         = months;
	    proto$2.years          = years;
	    proto$2.humanize       = humanize;
	    proto$2.toISOString    = toISOString$1;
	    proto$2.toString       = toISOString$1;
	    proto$2.toJSON         = toISOString$1;
	    proto$2.locale         = locale;
	    proto$2.localeData     = localeData;
	
	    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	    proto$2.lang = lang;
	
	    // Side effect imports
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input, 10) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    // Side effect imports
	
	
	    hooks.version = '2.24.0';
	
	    setHookCallback(createLocal);
	
	    hooks.fn                    = proto;
	    hooks.min                   = min;
	    hooks.max                   = max;
	    hooks.now                   = now;
	    hooks.utc                   = createUTC;
	    hooks.unix                  = createUnix;
	    hooks.months                = listMonths;
	    hooks.isDate                = isDate;
	    hooks.locale                = getSetGlobalLocale;
	    hooks.invalid               = createInvalid;
	    hooks.duration              = createDuration;
	    hooks.isMoment              = isMoment;
	    hooks.weekdays              = listWeekdays;
	    hooks.parseZone             = createInZone;
	    hooks.localeData            = getLocale;
	    hooks.isDuration            = isDuration;
	    hooks.monthsShort           = listMonthsShort;
	    hooks.weekdaysMin           = listWeekdaysMin;
	    hooks.defineLocale          = defineLocale;
	    hooks.updateLocale          = updateLocale;
	    hooks.locales               = listLocales;
	    hooks.weekdaysShort         = listWeekdaysShort;
	    hooks.normalizeUnits        = normalizeUnits;
	    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat        = getCalendarFormat;
	    hooks.prototype             = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD',                             // <input type="date" />
	        TIME: 'HH:mm',                                  // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW',                             // <input type="week" />
	        MONTH: 'YYYY-MM'                                // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(224)(module)))

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	module.exports = function normalizeComponent (
	  rawScriptExports,
	  compiledTemplate,
	  scopeId,
	  cssModules
	) {
	  var esModule
	  var scriptExports = rawScriptExports = rawScriptExports || {}
	
	  // ES6 modules interop
	  var type = typeof rawScriptExports.default
	  if (type === 'object' || type === 'function') {
	    esModule = rawScriptExports
	    scriptExports = rawScriptExports.default
	  }
	
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (compiledTemplate) {
	    options.render = compiledTemplate.render
	    options.staticRenderFns = compiledTemplate.staticRenderFns
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = scopeId
	  }
	
	  // inject cssModules
	  if (cssModules) {
	    var computed = options.computed || (options.computed = {})
	    Object.keys(cssModules).forEach(function (key) {
	      var module = cssModules[key]
	      computed[key] = function () { return module }
	    })
	  }
	
	  return {
	    esModule: esModule,
	    exports: scriptExports,
	    options: options
	  }
	}


/***/ }),
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(29);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ }),
/* 6 */,
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * vuex v2.5.0
	 * (c) 2017 Evan You
	 * @license MIT
	 */
	'use strict';
	
	var applyMixin = function (Vue) {
	  var version = Number(Vue.version.split('.')[0]);
	
	  if (version >= 2) {
	    Vue.mixin({ beforeCreate: vuexInit });
	  } else {
	    // override init and inject vuex init procedure
	    // for 1.x backwards compatibility.
	    var _init = Vue.prototype._init;
	    Vue.prototype._init = function (options) {
	      if ( options === void 0 ) options = {};
	
	      options.init = options.init
	        ? [vuexInit].concat(options.init)
	        : vuexInit;
	      _init.call(this, options);
	    };
	  }
	
	  /**
	   * Vuex init hook, injected into each instances init hooks list.
	   */
	
	  function vuexInit () {
	    var options = this.$options;
	    // store injection
	    if (options.store) {
	      this.$store = typeof options.store === 'function'
	        ? options.store()
	        : options.store;
	    } else if (options.parent && options.parent.$store) {
	      this.$store = options.parent.$store;
	    }
	  }
	};
	
	var devtoolHook =
	  typeof window !== 'undefined' &&
	  window.__VUE_DEVTOOLS_GLOBAL_HOOK__;
	
	function devtoolPlugin (store) {
	  if (!devtoolHook) { return }
	
	  store._devtoolHook = devtoolHook;
	
	  devtoolHook.emit('vuex:init', store);
	
	  devtoolHook.on('vuex:travel-to-state', function (targetState) {
	    store.replaceState(targetState);
	  });
	
	  store.subscribe(function (mutation, state) {
	    devtoolHook.emit('vuex:mutation', mutation, state);
	  });
	}
	
	/**
	 * Get the first item that pass the test
	 * by second argument function
	 *
	 * @param {Array} list
	 * @param {Function} f
	 * @return {*}
	 */
	/**
	 * Deep copy the given object considering circular structure.
	 * This function caches all nested objects and its copies.
	 * If it detects circular structure, use cached copy to avoid infinite loop.
	 *
	 * @param {*} obj
	 * @param {Array<Object>} cache
	 * @return {*}
	 */
	
	
	/**
	 * forEach for object
	 */
	function forEachValue (obj, fn) {
	  Object.keys(obj).forEach(function (key) { return fn(obj[key], key); });
	}
	
	function isObject (obj) {
	  return obj !== null && typeof obj === 'object'
	}
	
	function isPromise (val) {
	  return val && typeof val.then === 'function'
	}
	
	function assert (condition, msg) {
	  if (!condition) { throw new Error(("[vuex] " + msg)) }
	}
	
	var Module = function Module (rawModule, runtime) {
	  this.runtime = runtime;
	  this._children = Object.create(null);
	  this._rawModule = rawModule;
	  var rawState = rawModule.state;
	  this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
	};
	
	var prototypeAccessors$1 = { namespaced: { configurable: true } };
	
	prototypeAccessors$1.namespaced.get = function () {
	  return !!this._rawModule.namespaced
	};
	
	Module.prototype.addChild = function addChild (key, module) {
	  this._children[key] = module;
	};
	
	Module.prototype.removeChild = function removeChild (key) {
	  delete this._children[key];
	};
	
	Module.prototype.getChild = function getChild (key) {
	  return this._children[key]
	};
	
	Module.prototype.update = function update (rawModule) {
	  this._rawModule.namespaced = rawModule.namespaced;
	  if (rawModule.actions) {
	    this._rawModule.actions = rawModule.actions;
	  }
	  if (rawModule.mutations) {
	    this._rawModule.mutations = rawModule.mutations;
	  }
	  if (rawModule.getters) {
	    this._rawModule.getters = rawModule.getters;
	  }
	};
	
	Module.prototype.forEachChild = function forEachChild (fn) {
	  forEachValue(this._children, fn);
	};
	
	Module.prototype.forEachGetter = function forEachGetter (fn) {
	  if (this._rawModule.getters) {
	    forEachValue(this._rawModule.getters, fn);
	  }
	};
	
	Module.prototype.forEachAction = function forEachAction (fn) {
	  if (this._rawModule.actions) {
	    forEachValue(this._rawModule.actions, fn);
	  }
	};
	
	Module.prototype.forEachMutation = function forEachMutation (fn) {
	  if (this._rawModule.mutations) {
	    forEachValue(this._rawModule.mutations, fn);
	  }
	};
	
	Object.defineProperties( Module.prototype, prototypeAccessors$1 );
	
	var ModuleCollection = function ModuleCollection (rawRootModule) {
	  // register root module (Vuex.Store options)
	  this.register([], rawRootModule, false);
	};
	
	ModuleCollection.prototype.get = function get (path) {
	  return path.reduce(function (module, key) {
	    return module.getChild(key)
	  }, this.root)
	};
	
	ModuleCollection.prototype.getNamespace = function getNamespace (path) {
	  var module = this.root;
	  return path.reduce(function (namespace, key) {
	    module = module.getChild(key);
	    return namespace + (module.namespaced ? key + '/' : '')
	  }, '')
	};
	
	ModuleCollection.prototype.update = function update$1 (rawRootModule) {
	  update([], this.root, rawRootModule);
	};
	
	ModuleCollection.prototype.register = function register (path, rawModule, runtime) {
	    var this$1 = this;
	    if ( runtime === void 0 ) runtime = true;
	
	  if (false) {
	    assertRawModule(path, rawModule);
	  }
	
	  var newModule = new Module(rawModule, runtime);
	  if (path.length === 0) {
	    this.root = newModule;
	  } else {
	    var parent = this.get(path.slice(0, -1));
	    parent.addChild(path[path.length - 1], newModule);
	  }
	
	  // register nested modules
	  if (rawModule.modules) {
	    forEachValue(rawModule.modules, function (rawChildModule, key) {
	      this$1.register(path.concat(key), rawChildModule, runtime);
	    });
	  }
	};
	
	ModuleCollection.prototype.unregister = function unregister (path) {
	  var parent = this.get(path.slice(0, -1));
	  var key = path[path.length - 1];
	  if (!parent.getChild(key).runtime) { return }
	
	  parent.removeChild(key);
	};
	
	function update (path, targetModule, newModule) {
	  if (false) {
	    assertRawModule(path, newModule);
	  }
	
	  // update target module
	  targetModule.update(newModule);
	
	  // update nested modules
	  if (newModule.modules) {
	    for (var key in newModule.modules) {
	      if (!targetModule.getChild(key)) {
	        if (false) {
	          console.warn(
	            "[vuex] trying to add a new module '" + key + "' on hot reloading, " +
	            'manual reload is needed'
	          );
	        }
	        return
	      }
	      update(
	        path.concat(key),
	        targetModule.getChild(key),
	        newModule.modules[key]
	      );
	    }
	  }
	}
	
	var functionAssert = {
	  assert: function (value) { return typeof value === 'function'; },
	  expected: 'function'
	};
	
	var objectAssert = {
	  assert: function (value) { return typeof value === 'function' ||
	    (typeof value === 'object' && typeof value.handler === 'function'); },
	  expected: 'function or object with "handler" function'
	};
	
	var assertTypes = {
	  getters: functionAssert,
	  mutations: functionAssert,
	  actions: objectAssert
	};
	
	function assertRawModule (path, rawModule) {
	  Object.keys(assertTypes).forEach(function (key) {
	    if (!rawModule[key]) { return }
	
	    var assertOptions = assertTypes[key];
	
	    forEachValue(rawModule[key], function (value, type) {
	      assert(
	        assertOptions.assert(value),
	        makeAssertionMessage(path, key, type, value, assertOptions.expected)
	      );
	    });
	  });
	}
	
	function makeAssertionMessage (path, key, type, value, expected) {
	  var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";
	  if (path.length > 0) {
	    buf += " in module \"" + (path.join('.')) + "\"";
	  }
	  buf += " is " + (JSON.stringify(value)) + ".";
	  return buf
	}
	
	var Vue; // bind on install
	
	var Store = function Store (options) {
	  var this$1 = this;
	  if ( options === void 0 ) options = {};
	
	  // Auto install if it is not done yet and `window` has `Vue`.
	  // To allow users to avoid auto-installation in some cases,
	  // this code should be placed here. See #731
	  if (!Vue && typeof window !== 'undefined' && window.Vue) {
	    install(window.Vue);
	  }
	
	  if (false) {
	    assert(Vue, "must call Vue.use(Vuex) before creating a store instance.");
	    assert(typeof Promise !== 'undefined', "vuex requires a Promise polyfill in this browser.");
	    assert(this instanceof Store, "Store must be called with the new operator.");
	  }
	
	  var plugins = options.plugins; if ( plugins === void 0 ) plugins = [];
	  var strict = options.strict; if ( strict === void 0 ) strict = false;
	
	  var state = options.state; if ( state === void 0 ) state = {};
	  if (typeof state === 'function') {
	    state = state() || {};
	  }
	
	  // store internal state
	  this._committing = false;
	  this._actions = Object.create(null);
	  this._actionSubscribers = [];
	  this._mutations = Object.create(null);
	  this._wrappedGetters = Object.create(null);
	  this._modules = new ModuleCollection(options);
	  this._modulesNamespaceMap = Object.create(null);
	  this._subscribers = [];
	  this._watcherVM = new Vue();
	
	  // bind commit and dispatch to self
	  var store = this;
	  var ref = this;
	  var dispatch = ref.dispatch;
	  var commit = ref.commit;
	  this.dispatch = function boundDispatch (type, payload) {
	    return dispatch.call(store, type, payload)
	  };
	  this.commit = function boundCommit (type, payload, options) {
	    return commit.call(store, type, payload, options)
	  };
	
	  // strict mode
	  this.strict = strict;
	
	  // init root module.
	  // this also recursively registers all sub-modules
	  // and collects all module getters inside this._wrappedGetters
	  installModule(this, state, [], this._modules.root);
	
	  // initialize the store vm, which is responsible for the reactivity
	  // (also registers _wrappedGetters as computed properties)
	  resetStoreVM(this, state);
	
	  // apply plugins
	  plugins.forEach(function (plugin) { return plugin(this$1); });
	
	  if (Vue.config.devtools) {
	    devtoolPlugin(this);
	  }
	};
	
	var prototypeAccessors = { state: { configurable: true } };
	
	prototypeAccessors.state.get = function () {
	  return this._vm._data.$$state
	};
	
	prototypeAccessors.state.set = function (v) {
	  if (false) {
	    assert(false, "Use store.replaceState() to explicit replace store state.");
	  }
	};
	
	Store.prototype.commit = function commit (_type, _payload, _options) {
	    var this$1 = this;
	
	  // check object-style commit
	  var ref = unifyObjectStyle(_type, _payload, _options);
	    var type = ref.type;
	    var payload = ref.payload;
	    var options = ref.options;
	
	  var mutation = { type: type, payload: payload };
	  var entry = this._mutations[type];
	  if (!entry) {
	    if (false) {
	      console.error(("[vuex] unknown mutation type: " + type));
	    }
	    return
	  }
	  this._withCommit(function () {
	    entry.forEach(function commitIterator (handler) {
	      handler(payload);
	    });
	  });
	  this._subscribers.forEach(function (sub) { return sub(mutation, this$1.state); });
	
	  if (
	    false
	  ) {
	    console.warn(
	      "[vuex] mutation type: " + type + ". Silent option has been removed. " +
	      'Use the filter functionality in the vue-devtools'
	    );
	  }
	};
	
	Store.prototype.dispatch = function dispatch (_type, _payload) {
	    var this$1 = this;
	
	  // check object-style dispatch
	  var ref = unifyObjectStyle(_type, _payload);
	    var type = ref.type;
	    var payload = ref.payload;
	
	  var action = { type: type, payload: payload };
	  var entry = this._actions[type];
	  if (!entry) {
	    if (false) {
	      console.error(("[vuex] unknown action type: " + type));
	    }
	    return
	  }
	
	  this._actionSubscribers.forEach(function (sub) { return sub(action, this$1.state); });
	
	  return entry.length > 1
	    ? Promise.all(entry.map(function (handler) { return handler(payload); }))
	    : entry[0](payload)
	};
	
	Store.prototype.subscribe = function subscribe (fn) {
	  return genericSubscribe(fn, this._subscribers)
	};
	
	Store.prototype.subscribeAction = function subscribeAction (fn) {
	  return genericSubscribe(fn, this._actionSubscribers)
	};
	
	Store.prototype.watch = function watch (getter, cb, options) {
	    var this$1 = this;
	
	  if (false) {
	    assert(typeof getter === 'function', "store.watch only accepts a function.");
	  }
	  return this._watcherVM.$watch(function () { return getter(this$1.state, this$1.getters); }, cb, options)
	};
	
	Store.prototype.replaceState = function replaceState (state) {
	    var this$1 = this;
	
	  this._withCommit(function () {
	    this$1._vm._data.$$state = state;
	  });
	};
	
	Store.prototype.registerModule = function registerModule (path, rawModule, options) {
	    if ( options === void 0 ) options = {};
	
	  if (typeof path === 'string') { path = [path]; }
	
	  if (false) {
	    assert(Array.isArray(path), "module path must be a string or an Array.");
	    assert(path.length > 0, 'cannot register the root module by using registerModule.');
	  }
	
	  this._modules.register(path, rawModule);
	  installModule(this, this.state, path, this._modules.get(path), options.preserveState);
	  // reset store to update getters...
	  resetStoreVM(this, this.state);
	};
	
	Store.prototype.unregisterModule = function unregisterModule (path) {
	    var this$1 = this;
	
	  if (typeof path === 'string') { path = [path]; }
	
	  if (false) {
	    assert(Array.isArray(path), "module path must be a string or an Array.");
	  }
	
	  this._modules.unregister(path);
	  this._withCommit(function () {
	    var parentState = getNestedState(this$1.state, path.slice(0, -1));
	    Vue.delete(parentState, path[path.length - 1]);
	  });
	  resetStore(this);
	};
	
	Store.prototype.hotUpdate = function hotUpdate (newOptions) {
	  this._modules.update(newOptions);
	  resetStore(this, true);
	};
	
	Store.prototype._withCommit = function _withCommit (fn) {
	  var committing = this._committing;
	  this._committing = true;
	  fn();
	  this._committing = committing;
	};
	
	Object.defineProperties( Store.prototype, prototypeAccessors );
	
	function genericSubscribe (fn, subs) {
	  if (subs.indexOf(fn) < 0) {
	    subs.push(fn);
	  }
	  return function () {
	    var i = subs.indexOf(fn);
	    if (i > -1) {
	      subs.splice(i, 1);
	    }
	  }
	}
	
	function resetStore (store, hot) {
	  store._actions = Object.create(null);
	  store._mutations = Object.create(null);
	  store._wrappedGetters = Object.create(null);
	  store._modulesNamespaceMap = Object.create(null);
	  var state = store.state;
	  // init all modules
	  installModule(store, state, [], store._modules.root, true);
	  // reset vm
	  resetStoreVM(store, state, hot);
	}
	
	function resetStoreVM (store, state, hot) {
	  var oldVm = store._vm;
	
	  // bind store public getters
	  store.getters = {};
	  var wrappedGetters = store._wrappedGetters;
	  var computed = {};
	  forEachValue(wrappedGetters, function (fn, key) {
	    // use computed to leverage its lazy-caching mechanism
	    computed[key] = function () { return fn(store); };
	    Object.defineProperty(store.getters, key, {
	      get: function () { return store._vm[key]; },
	      enumerable: true // for local getters
	    });
	  });
	
	  // use a Vue instance to store the state tree
	  // suppress warnings just in case the user has added
	  // some funky global mixins
	  var silent = Vue.config.silent;
	  Vue.config.silent = true;
	  store._vm = new Vue({
	    data: {
	      $$state: state
	    },
	    computed: computed
	  });
	  Vue.config.silent = silent;
	
	  // enable strict mode for new vm
	  if (store.strict) {
	    enableStrictMode(store);
	  }
	
	  if (oldVm) {
	    if (hot) {
	      // dispatch changes in all subscribed watchers
	      // to force getter re-evaluation for hot reloading.
	      store._withCommit(function () {
	        oldVm._data.$$state = null;
	      });
	    }
	    Vue.nextTick(function () { return oldVm.$destroy(); });
	  }
	}
	
	function installModule (store, rootState, path, module, hot) {
	  var isRoot = !path.length;
	  var namespace = store._modules.getNamespace(path);
	
	  // register in namespace map
	  if (module.namespaced) {
	    store._modulesNamespaceMap[namespace] = module;
	  }
	
	  // set state
	  if (!isRoot && !hot) {
	    var parentState = getNestedState(rootState, path.slice(0, -1));
	    var moduleName = path[path.length - 1];
	    store._withCommit(function () {
	      Vue.set(parentState, moduleName, module.state);
	    });
	  }
	
	  var local = module.context = makeLocalContext(store, namespace, path);
	
	  module.forEachMutation(function (mutation, key) {
	    var namespacedType = namespace + key;
	    registerMutation(store, namespacedType, mutation, local);
	  });
	
	  module.forEachAction(function (action, key) {
	    var type = action.root ? key : namespace + key;
	    var handler = action.handler || action;
	    registerAction(store, type, handler, local);
	  });
	
	  module.forEachGetter(function (getter, key) {
	    var namespacedType = namespace + key;
	    registerGetter(store, namespacedType, getter, local);
	  });
	
	  module.forEachChild(function (child, key) {
	    installModule(store, rootState, path.concat(key), child, hot);
	  });
	}
	
	/**
	 * make localized dispatch, commit, getters and state
	 * if there is no namespace, just use root ones
	 */
	function makeLocalContext (store, namespace, path) {
	  var noNamespace = namespace === '';
	
	  var local = {
	    dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
	      var args = unifyObjectStyle(_type, _payload, _options);
	      var payload = args.payload;
	      var options = args.options;
	      var type = args.type;
	
	      if (!options || !options.root) {
	        type = namespace + type;
	        if (false) {
	          console.error(("[vuex] unknown local action type: " + (args.type) + ", global type: " + type));
	          return
	        }
	      }
	
	      return store.dispatch(type, payload)
	    },
	
	    commit: noNamespace ? store.commit : function (_type, _payload, _options) {
	      var args = unifyObjectStyle(_type, _payload, _options);
	      var payload = args.payload;
	      var options = args.options;
	      var type = args.type;
	
	      if (!options || !options.root) {
	        type = namespace + type;
	        if (false) {
	          console.error(("[vuex] unknown local mutation type: " + (args.type) + ", global type: " + type));
	          return
	        }
	      }
	
	      store.commit(type, payload, options);
	    }
	  };
	
	  // getters and state object must be gotten lazily
	  // because they will be changed by vm update
	  Object.defineProperties(local, {
	    getters: {
	      get: noNamespace
	        ? function () { return store.getters; }
	        : function () { return makeLocalGetters(store, namespace); }
	    },
	    state: {
	      get: function () { return getNestedState(store.state, path); }
	    }
	  });
	
	  return local
	}
	
	function makeLocalGetters (store, namespace) {
	  var gettersProxy = {};
	
	  var splitPos = namespace.length;
	  Object.keys(store.getters).forEach(function (type) {
	    // skip if the target getter is not match this namespace
	    if (type.slice(0, splitPos) !== namespace) { return }
	
	    // extract local getter type
	    var localType = type.slice(splitPos);
	
	    // Add a port to the getters proxy.
	    // Define as getter property because
	    // we do not want to evaluate the getters in this time.
	    Object.defineProperty(gettersProxy, localType, {
	      get: function () { return store.getters[type]; },
	      enumerable: true
	    });
	  });
	
	  return gettersProxy
	}
	
	function registerMutation (store, type, handler, local) {
	  var entry = store._mutations[type] || (store._mutations[type] = []);
	  entry.push(function wrappedMutationHandler (payload) {
	    handler.call(store, local.state, payload);
	  });
	}
	
	function registerAction (store, type, handler, local) {
	  var entry = store._actions[type] || (store._actions[type] = []);
	  entry.push(function wrappedActionHandler (payload, cb) {
	    var res = handler.call(store, {
	      dispatch: local.dispatch,
	      commit: local.commit,
	      getters: local.getters,
	      state: local.state,
	      rootGetters: store.getters,
	      rootState: store.state
	    }, payload, cb);
	    if (!isPromise(res)) {
	      res = Promise.resolve(res);
	    }
	    if (store._devtoolHook) {
	      return res.catch(function (err) {
	        store._devtoolHook.emit('vuex:error', err);
	        throw err
	      })
	    } else {
	      return res
	    }
	  });
	}
	
	function registerGetter (store, type, rawGetter, local) {
	  if (store._wrappedGetters[type]) {
	    if (false) {
	      console.error(("[vuex] duplicate getter key: " + type));
	    }
	    return
	  }
	  store._wrappedGetters[type] = function wrappedGetter (store) {
	    return rawGetter(
	      local.state, // local state
	      local.getters, // local getters
	      store.state, // root state
	      store.getters // root getters
	    )
	  };
	}
	
	function enableStrictMode (store) {
	  store._vm.$watch(function () { return this._data.$$state }, function () {
	    if (false) {
	      assert(store._committing, "Do not mutate vuex store state outside mutation handlers.");
	    }
	  }, { deep: true, sync: true });
	}
	
	function getNestedState (state, path) {
	  return path.length
	    ? path.reduce(function (state, key) { return state[key]; }, state)
	    : state
	}
	
	function unifyObjectStyle (type, payload, options) {
	  if (isObject(type) && type.type) {
	    options = payload;
	    payload = type;
	    type = type.type;
	  }
	
	  if (false) {
	    assert(typeof type === 'string', ("Expects string as the type, but found " + (typeof type) + "."));
	  }
	
	  return { type: type, payload: payload, options: options }
	}
	
	function install (_Vue) {
	  if (Vue && _Vue === Vue) {
	    if (false) {
	      console.error(
	        '[vuex] already installed. Vue.use(Vuex) should be called only once.'
	      );
	    }
	    return
	  }
	  Vue = _Vue;
	  applyMixin(Vue);
	}
	
	var mapState = normalizeNamespace(function (namespace, states) {
	  var res = {};
	  normalizeMap(states).forEach(function (ref) {
	    var key = ref.key;
	    var val = ref.val;
	
	    res[key] = function mappedState () {
	      var state = this.$store.state;
	      var getters = this.$store.getters;
	      if (namespace) {
	        var module = getModuleByNamespace(this.$store, 'mapState', namespace);
	        if (!module) {
	          return
	        }
	        state = module.context.state;
	        getters = module.context.getters;
	      }
	      return typeof val === 'function'
	        ? val.call(this, state, getters)
	        : state[val]
	    };
	    // mark vuex getter for devtools
	    res[key].vuex = true;
	  });
	  return res
	});
	
	var mapMutations = normalizeNamespace(function (namespace, mutations) {
	  var res = {};
	  normalizeMap(mutations).forEach(function (ref) {
	    var key = ref.key;
	    var val = ref.val;
	
	    res[key] = function mappedMutation () {
	      var args = [], len = arguments.length;
	      while ( len-- ) args[ len ] = arguments[ len ];
	
	      var commit = this.$store.commit;
	      if (namespace) {
	        var module = getModuleByNamespace(this.$store, 'mapMutations', namespace);
	        if (!module) {
	          return
	        }
	        commit = module.context.commit;
	      }
	      return typeof val === 'function'
	        ? val.apply(this, [commit].concat(args))
	        : commit.apply(this.$store, [val].concat(args))
	    };
	  });
	  return res
	});
	
	var mapGetters = normalizeNamespace(function (namespace, getters) {
	  var res = {};
	  normalizeMap(getters).forEach(function (ref) {
	    var key = ref.key;
	    var val = ref.val;
	
	    val = namespace + val;
	    res[key] = function mappedGetter () {
	      if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
	        return
	      }
	      if (false) {
	        console.error(("[vuex] unknown getter: " + val));
	        return
	      }
	      return this.$store.getters[val]
	    };
	    // mark vuex getter for devtools
	    res[key].vuex = true;
	  });
	  return res
	});
	
	var mapActions = normalizeNamespace(function (namespace, actions) {
	  var res = {};
	  normalizeMap(actions).forEach(function (ref) {
	    var key = ref.key;
	    var val = ref.val;
	
	    res[key] = function mappedAction () {
	      var args = [], len = arguments.length;
	      while ( len-- ) args[ len ] = arguments[ len ];
	
	      var dispatch = this.$store.dispatch;
	      if (namespace) {
	        var module = getModuleByNamespace(this.$store, 'mapActions', namespace);
	        if (!module) {
	          return
	        }
	        dispatch = module.context.dispatch;
	      }
	      return typeof val === 'function'
	        ? val.apply(this, [dispatch].concat(args))
	        : dispatch.apply(this.$store, [val].concat(args))
	    };
	  });
	  return res
	});
	
	var createNamespacedHelpers = function (namespace) { return ({
	  mapState: mapState.bind(null, namespace),
	  mapGetters: mapGetters.bind(null, namespace),
	  mapMutations: mapMutations.bind(null, namespace),
	  mapActions: mapActions.bind(null, namespace)
	}); };
	
	function normalizeMap (map) {
	  return Array.isArray(map)
	    ? map.map(function (key) { return ({ key: key, val: key }); })
	    : Object.keys(map).map(function (key) { return ({ key: key, val: map[key] }); })
	}
	
	function normalizeNamespace (fn) {
	  return function (namespace, map) {
	    if (typeof namespace !== 'string') {
	      map = namespace;
	      namespace = '';
	    } else if (namespace.charAt(namespace.length - 1) !== '/') {
	      namespace += '/';
	    }
	    return fn(namespace, map)
	  }
	}
	
	function getModuleByNamespace (store, helper, namespace) {
	  var module = store._modulesNamespaceMap[namespace];
	  if (false) {
	    console.error(("[vuex] module namespace not found in " + helper + "(): " + namespace));
	  }
	  return module
	}
	
	var index = {
	  Store: Store,
	  install: install,
	  version: '2.5.0',
	  mapState: mapState,
	  mapMutations: mapMutations,
	  mapGetters: mapGetters,
	  mapActions: mapActions,
	  createNamespacedHelpers: createNamespacedHelpers
	};
	
	module.exports = index;


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(333);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  } else {
	    return (0, _from2.default)(arr);
	  }
	};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _promise = __webpack_require__(15);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (fn) {
	  return function () {
	    var gen = fn.apply(this, arguments);
	    return new _promise2.default(function (resolve, reject) {
	      function step(key, arg) {
	        try {
	          var info = gen[key](arg);
	          var value = info.value;
	        } catch (error) {
	          reject(error);
	          return;
	        }
	
	        if (info.done) {
	          resolve(value);
	        } else {
	          return _promise2.default.resolve(value).then(function (value) {
	            step("next", value);
	          }, function (err) {
	            step("throw", err);
	          });
	        }
	      }
	
	      return step("next");
	    });
	  };
	};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(448);


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.11';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      // Use `util.types` for Node.js 10+.
	      var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	      if (types) {
	        return types;
	      }
	
	      // Legacy `process.binding('util')` for Node.js < 10.
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      if (isSet(value)) {
	        value.forEach(function(subValue) {
	          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	        });
	
	        return result;
	      }
	
	      if (isMap(value)) {
	        value.forEach(function(subValue, key) {
	          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	        });
	
	        return result;
	      }
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        if (isObject(srcValue)) {
	          stack || (stack = new Stack);
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = safeGet(object, key),
	          srcValue = safeGet(source, key),
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || isFunction(objValue)) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      var index = -1;
	      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array == null ? 0 : array.length,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(array);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return new Ctor;
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return new Ctor;
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      var type = typeof value;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	
	      return !!length &&
	        (type == 'number' ||
	          (type != 'symbol' && reIsUint.test(value))) &&
	            (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Gets the value at `key`, unless `key` is "__proto__".
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the property to get.
	     * @returns {*} Returns the property value.
	     */
	    function safeGet(object, key) {
	      if (key == '__proto__') {
	        return;
	      }
	
	      return object[key];
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (string.charCodeAt(0) === 46 /* . */) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, subString) {
	        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            timeWaiting = wait - timeSinceLastCall;
	
	        return maxing
	          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	          : timeWaiting;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(object, sources) {
	      object = Object(object);
	
	      var index = -1;
	      var length = sources.length;
	      var guard = length > 2 ? sources[2] : undefined;
	
	      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	        length = 1;
	      }
	
	      while (++index < length) {
	        var source = sources[index];
	        var props = keysIn(source);
	        var propsIndex = -1;
	        var propsLength = props.length;
	
	        while (++propsIndex < propsLength) {
	          var key = props[propsIndex];
	          var value = object[key];
	
	          if (value === undefined ||
	              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	            object[key] = source[key];
	          }
	        }
	      }
	
	      return object;
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrim, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimEnd, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = (lodashFunc.name + ''),
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(224)(module)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.regex = exports.ref = exports.len = exports.req = exports.withParams = undefined;
	
	var _withParams = __webpack_require__(611);
	
	var _withParams2 = _interopRequireDefault(_withParams);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.withParams = _withParams2.default;
	
	// "required" core, used in almost every validator to allow empty values
	
	var req = exports.req = function req(value) {
	  if (Array.isArray(value)) return !!value.length;
	  if (value === undefined || value === null || value === false) {
	    return false;
	  }
	
	  if (value instanceof Date) {
	    // invalid date won't pass
	    return !isNaN(value.getTime());
	  }
	
	  if (typeof value === 'object') {
	    for (var _ in value) {
	      return true;
	    }return false;
	  }
	
	  return !!String(value).length;
	};
	
	// get length in type-agnostic way
	var len = exports.len = function len(value) {
	  if (Array.isArray(value)) return value.length;
	  if (typeof value === 'object') {
	    return Object.keys(value).length;
	  }
	  return String(value).length;
	};
	
	// resolve referenced value
	var ref = exports.ref = function ref(reference, vm, parentVm) {
	  return typeof reference === 'function' ? reference.call(vm, parentVm) : parentVm[reference];
	};
	
	// regex based validator template
	var regex = exports.regex = function regex(type, expr) {
	  return (0, _withParams2.default)({ type: type }, function (value) {
	    return !req(value) || expr.test(value);
	  });
	};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.maxValue = exports.minValue = exports.and = exports.or = exports.url = exports.sameAs = exports.requiredUnless = exports.requiredIf = exports.required = exports.minLength = exports.maxLength = exports.macAddress = exports.ipAddress = exports.email = exports.between = exports.numeric = exports.alphaNum = exports.alpha = undefined;
	
	var _alpha = __webpack_require__(592);
	
	var _alpha2 = _interopRequireDefault(_alpha);
	
	var _alphaNum = __webpack_require__(593);
	
	var _alphaNum2 = _interopRequireDefault(_alphaNum);
	
	var _numeric = __webpack_require__(603);
	
	var _numeric2 = _interopRequireDefault(_numeric);
	
	var _between = __webpack_require__(595);
	
	var _between2 = _interopRequireDefault(_between);
	
	var _email = __webpack_require__(596);
	
	var _email2 = _interopRequireDefault(_email);
	
	var _ipAddress = __webpack_require__(597);
	
	var _ipAddress2 = _interopRequireDefault(_ipAddress);
	
	var _macAddress = __webpack_require__(598);
	
	var _macAddress2 = _interopRequireDefault(_macAddress);
	
	var _maxLength = __webpack_require__(599);
	
	var _maxLength2 = _interopRequireDefault(_maxLength);
	
	var _minLength = __webpack_require__(601);
	
	var _minLength2 = _interopRequireDefault(_minLength);
	
	var _required = __webpack_require__(605);
	
	var _required2 = _interopRequireDefault(_required);
	
	var _requiredIf = __webpack_require__(606);
	
	var _requiredIf2 = _interopRequireDefault(_requiredIf);
	
	var _requiredUnless = __webpack_require__(607);
	
	var _requiredUnless2 = _interopRequireDefault(_requiredUnless);
	
	var _sameAs = __webpack_require__(608);
	
	var _sameAs2 = _interopRequireDefault(_sameAs);
	
	var _url = __webpack_require__(609);
	
	var _url2 = _interopRequireDefault(_url);
	
	var _or = __webpack_require__(604);
	
	var _or2 = _interopRequireDefault(_or);
	
	var _and = __webpack_require__(594);
	
	var _and2 = _interopRequireDefault(_and);
	
	var _minValue = __webpack_require__(602);
	
	var _minValue2 = _interopRequireDefault(_minValue);
	
	var _maxValue = __webpack_require__(600);
	
	var _maxValue2 = _interopRequireDefault(_maxValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.alpha = _alpha2.default;
	exports.alphaNum = _alphaNum2.default;
	exports.numeric = _numeric2.default;
	exports.between = _between2.default;
	exports.email = _email2.default;
	exports.ipAddress = _ipAddress2.default;
	exports.macAddress = _macAddress2.default;
	exports.maxLength = _maxLength2.default;
	exports.minLength = _minLength2.default;
	exports.required = _required2.default;
	exports.requiredIf = _requiredIf2.default;
	exports.requiredUnless = _requiredUnless2.default;
	exports.sameAs = _sameAs2.default;
	exports.url = _url2.default;
	exports.or = _or2.default;
	exports.and = _and2.default;
	exports.minValue = _minValue2.default;
	exports.maxValue = _maxValue2.default;

/***/ }),
/* 14 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.5.7' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(359), __esModule: true };

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(71);
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  typeof document.createElement -> undefined
	 */
	function isStandardBrowserEnv() {
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined' &&
	    typeof document.createElement === 'function'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object' && !isArray(obj)) {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim
	};


/***/ }),
/* 17 */,
/* 18 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(88)('wks');
	var uid = __webpack_require__(91);
	var Symbol = __webpack_require__(18).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(18);
	var core = __webpack_require__(14);
	var ctx = __webpack_require__(37);
	var hide = __webpack_require__(31);
	var has = __webpack_require__(41);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * sweetalert2 v6.11.5
	 * Released under the MIT License.
	 */
	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.Sweetalert2 = factory());
	}(this, (function () { 'use strict';
	
	var defaultParams = {
	  title: '',
	  titleText: '',
	  text: '',
	  html: '',
	  type: null,
	  customClass: '',
	  target: 'body',
	  animation: true,
	  allowOutsideClick: true,
	  allowEscapeKey: true,
	  allowEnterKey: true,
	  showConfirmButton: true,
	  showCancelButton: false,
	  preConfirm: null,
	  confirmButtonText: 'OK',
	  confirmButtonAriaLabel: '',
	  confirmButtonColor: '#3085d6',
	  confirmButtonClass: null,
	  cancelButtonText: 'Cancel',
	  cancelButtonAriaLabel: '',
	  cancelButtonColor: '#aaa',
	  cancelButtonClass: null,
	  buttonsStyling: true,
	  reverseButtons: false,
	  focusConfirm: true,
	  focusCancel: false,
	  showCloseButton: false,
	  closeButtonAriaLabel: 'Close this dialog',
	  showLoaderOnConfirm: false,
	  imageUrl: null,
	  imageWidth: null,
	  imageHeight: null,
	  imageAlt: '',
	  imageClass: null,
	  timer: null,
	  width: 500,
	  padding: 20,
	  background: '#fff',
	  input: null,
	  inputPlaceholder: '',
	  inputValue: '',
	  inputOptions: {},
	  inputAutoTrim: true,
	  inputClass: null,
	  inputAttributes: {},
	  inputValidator: null,
	  grow: false,
	  position: 'center',
	  progressSteps: [],
	  currentProgressStep: null,
	  progressStepsDistance: '40px',
	  onBeforeOpen: null,
	  onOpen: null,
	  onClose: null,
	  useRejections: true
	};
	
	var swalPrefix = 'swal2-';
	
	var prefix = function prefix(items) {
	  var result = {};
	  for (var i in items) {
	    result[items[i]] = swalPrefix + items[i];
	  }
	  return result;
	};
	
	var swalClasses = prefix(['container', 'shown', 'iosfix', 'modal', 'overlay', 'fade', 'show', 'hide', 'noanimation', 'close', 'title', 'content', 'buttonswrapper', 'confirm', 'cancel', 'icon', 'image', 'input', 'file', 'range', 'select', 'radio', 'checkbox', 'textarea', 'inputerror', 'validationerror', 'progresssteps', 'activeprogressstep', 'progresscircle', 'progressline', 'loading', 'styled', 'top', 'top-left', 'top-right', 'center', 'center-left', 'center-right', 'bottom', 'bottom-left', 'bottom-right', 'grow-row', 'grow-column', 'grow-fullscreen']);
	
	var iconTypes = prefix(['success', 'warning', 'info', 'question', 'error']);
	
	var consolePrefix = 'SweetAlert2:';
	
	/*
	 * Set hover, active and focus-states for buttons (source: http://www.sitepoint.com/javascript-generate-lighter-darker-color)
	 */
	var colorLuminance = function colorLuminance(hex, lum) {
	  // Validate hex string
	  hex = String(hex).replace(/[^0-9a-f]/gi, '');
	  if (hex.length < 6) {
	    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
	  }
	  lum = lum || 0;
	
	  // Convert to decimal and change luminosity
	  var rgb = '#';
	  for (var i = 0; i < 3; i++) {
	    var c = parseInt(hex.substr(i * 2, 2), 16);
	    c = Math.round(Math.min(Math.max(0, c + c * lum), 255)).toString(16);
	    rgb += ('00' + c).substr(c.length);
	  }
	
	  return rgb;
	};
	
	var uniqueArray = function uniqueArray(arr) {
	  var result = [];
	  for (var i in arr) {
	    if (result.indexOf(arr[i]) === -1) {
	      result.push(arr[i]);
	    }
	  }
	  return result;
	};
	
	/**
	 * Standardise console warnings
	 * @param message
	 */
	var warn = function warn(message) {
	  console.warn(consolePrefix + ' ' + message);
	};
	
	/**
	 * Standardise console errors
	 * @param message
	 */
	var error = function error(message) {
	  console.error(consolePrefix + ' ' + message);
	};
	
	// Remember state in cases where opening and handling a modal will fiddle with it.
	var states = {
	  previousWindowKeyDown: null,
	  previousActiveElement: null,
	  previousBodyPadding: null
	
	  /*
	   * Add modal + overlay to DOM
	   */
	};var init = function init(params) {
	  // Clean up the old modal if it exists
	  var c = getContainer();
	  if (c) {
	    c.parentNode.removeChild(c);
	  }
	
	  if (typeof document === 'undefined') {
	    error('SweetAlert2 requires document to initialize');
	    return;
	  }
	
	  var container = document.createElement('div');
	  container.className = swalClasses.container;
	  container.innerHTML = sweetHTML;
	
	  var targetElement = typeof params.target === 'string' ? document.querySelector(params.target) : params.target;
	  targetElement.appendChild(container);
	
	  var modal = getModal();
	  var input = getChildByClass(modal, swalClasses.input);
	  var file = getChildByClass(modal, swalClasses.file);
	  var range = modal.querySelector('.' + swalClasses.range + ' input');
	  var rangeOutput = modal.querySelector('.' + swalClasses.range + ' output');
	  var select = getChildByClass(modal, swalClasses.select);
	  var checkbox = modal.querySelector('.' + swalClasses.checkbox + ' input');
	  var textarea = getChildByClass(modal, swalClasses.textarea);
	
	  input.oninput = function () {
	    sweetAlert.resetValidationError();
	  };
	
	  file.onchange = function () {
	    sweetAlert.resetValidationError();
	  };
	
	  range.oninput = function () {
	    sweetAlert.resetValidationError();
	    rangeOutput.value = range.value;
	  };
	
	  range.onchange = function () {
	    sweetAlert.resetValidationError();
	    range.previousSibling.value = range.value;
	  };
	
	  select.onchange = function () {
	    sweetAlert.resetValidationError();
	  };
	
	  checkbox.onchange = function () {
	    sweetAlert.resetValidationError();
	  };
	
	  textarea.oninput = function () {
	    sweetAlert.resetValidationError();
	  };
	
	  return modal;
	};
	
	/*
	 * Manipulate DOM
	 */
	
	var sweetHTML = ('\n <div role="dialog" aria-modal="true" aria-labelledby="' + swalClasses.title + '" aria-describedby="' + swalClasses.content + '" class="' + swalClasses.modal + '" tabindex="-1">\n   <ul class="' + swalClasses.progresssteps + '"></ul>\n   <div class="' + swalClasses.icon + ' ' + iconTypes.error + '">\n     <span class="swal2-x-mark"><span class="swal2-x-mark-line-left"></span><span class="swal2-x-mark-line-right"></span></span>\n   </div>\n   <div class="' + swalClasses.icon + ' ' + iconTypes.question + '">?</div>\n   <div class="' + swalClasses.icon + ' ' + iconTypes.warning + '">!</div>\n   <div class="' + swalClasses.icon + ' ' + iconTypes.info + '">i</div>\n   <div class="' + swalClasses.icon + ' ' + iconTypes.success + '">\n     <div class="swal2-success-circular-line-left"></div>\n     <span class="swal2-success-line-tip"></span> <span class="swal2-success-line-long"></span>\n     <div class="swal2-success-ring"></div> <div class="swal2-success-fix"></div>\n     <div class="swal2-success-circular-line-right"></div>\n   </div>\n   <img class="' + swalClasses.image + '" />\n   <h2 class="' + swalClasses.title + '" id="' + swalClasses.title + '"></h2>\n   <div id="' + swalClasses.content + '" class="' + swalClasses.content + '"></div>\n   <input class="' + swalClasses.input + '" />\n   <input type="file" class="' + swalClasses.file + '" />\n   <div class="' + swalClasses.range + '">\n     <output></output>\n     <input type="range" />\n   </div>\n   <select class="' + swalClasses.select + '"></select>\n   <div class="' + swalClasses.radio + '"></div>\n   <label for="' + swalClasses.checkbox + '" class="' + swalClasses.checkbox + '">\n     <input type="checkbox" />\n   </label>\n   <textarea class="' + swalClasses.textarea + '"></textarea>\n   <div class="' + swalClasses.validationerror + '" id="' + swalClasses.validationerror + '"></div>\n   <div class="' + swalClasses.buttonswrapper + '">\n     <button type="button" class="' + swalClasses.confirm + '">OK</button>\n     <button type="button" class="' + swalClasses.cancel + '">Cancel</button>\n   </div>\n   <button type="button" class="' + swalClasses.close + '">\xD7</button>\n </div>\n').replace(/(^|\n)\s*/g, '');
	
	var getContainer = function getContainer() {
	  return document.body.querySelector('.' + swalClasses.container);
	};
	
	var getModal = function getModal() {
	  return getContainer() ? getContainer().querySelector('.' + swalClasses.modal) : null;
	};
	
	var getIcons = function getIcons() {
	  var modal = getModal();
	  return modal.querySelectorAll('.' + swalClasses.icon);
	};
	
	var elementByClass = function elementByClass(className) {
	  return getContainer() ? getContainer().querySelector('.' + className) : null;
	};
	
	var getTitle = function getTitle() {
	  return elementByClass(swalClasses.title);
	};
	
	var getContent = function getContent() {
	  return elementByClass(swalClasses.content);
	};
	
	var getImage = function getImage() {
	  return elementByClass(swalClasses.image);
	};
	
	var getProgressSteps = function getProgressSteps() {
	  return elementByClass(swalClasses.progresssteps);
	};
	
	var getValidationError = function getValidationError() {
	  return elementByClass(swalClasses.validationerror);
	};
	
	var getConfirmButton = function getConfirmButton() {
	  return elementByClass(swalClasses.confirm);
	};
	
	var getCancelButton = function getCancelButton() {
	  return elementByClass(swalClasses.cancel);
	};
	
	var getButtonsWrapper = function getButtonsWrapper() {
	  return elementByClass(swalClasses.buttonswrapper);
	};
	
	var getCloseButton = function getCloseButton() {
	  return elementByClass(swalClasses.close);
	};
	
	var getFocusableElements = function getFocusableElements() {
	  var focusableElementsWithTabindex = Array.from(getModal().querySelectorAll('[tabindex]:not([tabindex="-1"]):not([tabindex="0"])'))
	  // sort according to tabindex
	  .sort(function (a, b) {
	    a = parseInt(a.getAttribute('tabindex'));
	    b = parseInt(b.getAttribute('tabindex'));
	    if (a > b) {
	      return 1;
	    } else if (a < b) {
	      return -1;
	    }
	    return 0;
	  });
	
	  var otherFocusableElements = Array.prototype.slice.call(getModal().querySelectorAll('button, input:not([type=hidden]), textarea, select, a, [tabindex="0"]'));
	
	  return uniqueArray(focusableElementsWithTabindex.concat(otherFocusableElements));
	};
	
	var hasClass = function hasClass(elem, className) {
	  if (elem.classList) {
	    return elem.classList.contains(className);
	  }
	  return false;
	};
	
	var focusInput = function focusInput(input) {
	  input.focus();
	
	  // place cursor at end of text in text input
	  if (input.type !== 'file') {
	    // http://stackoverflow.com/a/2345915/1331425
	    var val = input.value;
	    input.value = '';
	    input.value = val;
	  }
	};
	
	var addClass = function addClass(elem, className) {
	  if (!elem || !className) {
	    return;
	  }
	  var classes = className.split(/\s+/).filter(Boolean);
	  classes.forEach(function (className) {
	    elem.classList.add(className);
	  });
	};
	
	var removeClass = function removeClass(elem, className) {
	  if (!elem || !className) {
	    return;
	  }
	  var classes = className.split(/\s+/).filter(Boolean);
	  classes.forEach(function (className) {
	    elem.classList.remove(className);
	  });
	};
	
	var getChildByClass = function getChildByClass(elem, className) {
	  for (var i = 0; i < elem.childNodes.length; i++) {
	    if (hasClass(elem.childNodes[i], className)) {
	      return elem.childNodes[i];
	    }
	  }
	};
	
	var show = function show(elem, display) {
	  if (!display) {
	    display = 'block';
	  }
	  elem.style.opacity = '';
	  elem.style.display = display;
	};
	
	var hide = function hide(elem) {
	  elem.style.opacity = '';
	  elem.style.display = 'none';
	};
	
	var empty = function empty(elem) {
	  while (elem.firstChild) {
	    elem.removeChild(elem.firstChild);
	  }
	};
	
	// borrowed from jquery $(elem).is(':visible') implementation
	var isVisible = function isVisible(elem) {
	  return elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length;
	};
	
	var removeStyleProperty = function removeStyleProperty(elem, property) {
	  if (elem.style.removeProperty) {
	    elem.style.removeProperty(property);
	  } else {
	    elem.style.removeAttribute(property);
	  }
	};
	
	var animationEndEvent = function () {
	  var testEl = document.createElement('div');
	  var transEndEventNames = {
	    'WebkitAnimation': 'webkitAnimationEnd',
	    'OAnimation': 'oAnimationEnd oanimationend',
	    'animation': 'animationend'
	  };
	  for (var i in transEndEventNames) {
	    if (transEndEventNames.hasOwnProperty(i) && testEl.style[i] !== undefined) {
	      return transEndEventNames[i];
	    }
	  }
	
	  return false;
	}();
	
	// Reset previous window keydown handler and focued element
	var resetPrevState = function resetPrevState() {
	  window.onkeydown = states.previousWindowKeyDown;
	  if (states.previousActiveElement && states.previousActiveElement.focus) {
	    var x = window.scrollX;
	    var y = window.scrollY;
	    states.previousActiveElement.focus();
	    if (x && y) {
	      // IE has no scrollX/scrollY support
	      window.scrollTo(x, y);
	    }
	  }
	};
	
	// Measure width of scrollbar
	// https://github.com/twbs/bootstrap/blob/master/js/modal.js#L279-L286
	var measureScrollbar = function measureScrollbar() {
	  var supportsTouch = 'ontouchstart' in window || navigator.msMaxTouchPoints;
	  if (supportsTouch) {
	    return 0;
	  }
	  var scrollDiv = document.createElement('div');
	  scrollDiv.style.width = '50px';
	  scrollDiv.style.height = '50px';
	  scrollDiv.style.overflow = 'scroll';
	  document.body.appendChild(scrollDiv);
	  var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	  document.body.removeChild(scrollDiv);
	  return scrollbarWidth;
	};
	
	/**
	 * Inject a string of CSS into the page header
	 *
	 * @param {String} css
	 */
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var modalParams = _extends({}, defaultParams);
	var queue = [];
	
	/*
	 * Check for the existence of Promise
	 * Hopefully to avoid many github issues
	 */
	if (typeof Promise === 'undefined') {
	  error('This package requires a Promise library, please include a shim to enable it in this browser (See: https://github.com/limonte/sweetalert2/wiki/Migration-from-SweetAlert-to-SweetAlert2#1-ie-support)');
	}
	
	/**
	 * Set type, text and actions on modal
	 *
	 * @param params
	 * @returns {boolean}
	 */
	var setParameters = function setParameters(params) {
	  // If a custom element is set, determine if it is valid
	  if (typeof params.target === 'string' && !document.querySelector(params.target) || typeof params.target !== 'string' && !params.target.appendChild) {
	    warn('Target parameter is not valid, defaulting to "body"');
	    params.target = 'body';
	  }
	
	  var modal = void 0;
	  var oldModal = getModal();
	  var targetElement = typeof params.target === 'string' ? document.querySelector(params.target) : params.target;
	  // If the model target has changed, refresh the modal
	  if (oldModal && targetElement && oldModal.parentNode !== targetElement.parentNode) {
	    modal = init(params);
	  } else {
	    modal = oldModal || init(params);
	  }
	
	  for (var param in params) {
	    if (!sweetAlert.isValidParameter(param)) {
	      warn('Unknown parameter "' + param + '"');
	    }
	  }
	
	  // Set modal width
	  modal.style.width = typeof params.width === 'number' ? params.width + 'px' : params.width;
	
	  modal.style.padding = params.padding + 'px';
	  modal.style.background = params.background;
	  var successIconParts = modal.querySelectorAll('[class^=swal2-success-circular-line], .swal2-success-fix');
	  for (var i = 0; i < successIconParts.length; i++) {
	    successIconParts[i].style.background = params.background;
	  }
	
	  var container = getContainer();
	  var title = getTitle();
	  var content = getContent();
	  var buttonsWrapper = getButtonsWrapper();
	  var confirmButton = getConfirmButton();
	  var cancelButton = getCancelButton();
	  var closeButton = getCloseButton();
	
	  // Title
	  if (params.titleText) {
	    title.innerText = params.titleText;
	  } else {
	    title.innerHTML = params.title.split('\n').join('<br />');
	  }
	
	  // Content
	  if (params.text || params.html) {
	    if (_typeof(params.html) === 'object') {
	      content.innerHTML = '';
	      if (0 in params.html) {
	        for (var _i = 0; _i in params.html; _i++) {
	          content.appendChild(params.html[_i].cloneNode(true));
	        }
	      } else {
	        content.appendChild(params.html.cloneNode(true));
	      }
	    } else if (params.html) {
	      content.innerHTML = params.html;
	    } else if (params.text) {
	      content.textContent = params.text;
	    }
	    show(content);
	  } else {
	    hide(content);
	  }
	
	  // Position
	  if (params.position in swalClasses) {
	    addClass(container, swalClasses[params.position]);
	  }
	
	  // Grow
	  if (params.grow && typeof params.grow === 'string') {
	    var growClass = 'grow-' + params.grow;
	    if (growClass in swalClasses) {
	      addClass(container, swalClasses[growClass]);
	    }
	  }
	
	  // Close button
	  if (params.showCloseButton) {
	    closeButton.setAttribute('aria-label', params.closeButtonAriaLabel);
	    show(closeButton);
	  } else {
	    hide(closeButton);
	  }
	
	  // Custom Class
	  modal.className = swalClasses.modal;
	  if (params.customClass) {
	    addClass(modal, params.customClass);
	  }
	
	  // Progress steps
	  var progressStepsContainer = getProgressSteps();
	  var currentProgressStep = parseInt(params.currentProgressStep === null ? sweetAlert.getQueueStep() : params.currentProgressStep, 10);
	  if (params.progressSteps.length) {
	    show(progressStepsContainer);
	    empty(progressStepsContainer);
	    if (currentProgressStep >= params.progressSteps.length) {
	      warn('Invalid currentProgressStep parameter, it should be less than progressSteps.length ' + '(currentProgressStep like JS arrays starts from 0)');
	    }
	    params.progressSteps.forEach(function (step, index) {
	      var circle = document.createElement('li');
	      addClass(circle, swalClasses.progresscircle);
	      circle.innerHTML = step;
	      if (index === currentProgressStep) {
	        addClass(circle, swalClasses.activeprogressstep);
	      }
	      progressStepsContainer.appendChild(circle);
	      if (index !== params.progressSteps.length - 1) {
	        var line = document.createElement('li');
	        addClass(line, swalClasses.progressline);
	        line.style.width = params.progressStepsDistance;
	        progressStepsContainer.appendChild(line);
	      }
	    });
	  } else {
	    hide(progressStepsContainer);
	  }
	
	  // Icon
	  var icons = getIcons();
	  for (var _i2 = 0; _i2 < icons.length; _i2++) {
	    hide(icons[_i2]);
	  }
	  if (params.type) {
	    var validType = false;
	    for (var iconType in iconTypes) {
	      if (params.type === iconType) {
	        validType = true;
	        break;
	      }
	    }
	    if (!validType) {
	      error('Unknown alert type: ' + params.type);
	      return false;
	    }
	    var icon = modal.querySelector('.' + swalClasses.icon + '.' + iconTypes[params.type]);
	    show(icon);
	
	    // Animate icon
	    if (params.animation) {
	      switch (params.type) {
	        case 'success':
	          addClass(icon, 'swal2-animate-success-icon');
	          addClass(icon.querySelector('.swal2-success-line-tip'), 'swal2-animate-success-line-tip');
	          addClass(icon.querySelector('.swal2-success-line-long'), 'swal2-animate-success-line-long');
	          break;
	        case 'error':
	          addClass(icon, 'swal2-animate-error-icon');
	          addClass(icon.querySelector('.swal2-x-mark'), 'swal2-animate-x-mark');
	          break;
	        default:
	          break;
	      }
	    }
	  }
	
	  // Custom image
	  var image = getImage();
	  if (params.imageUrl) {
	    image.setAttribute('src', params.imageUrl);
	    image.setAttribute('alt', params.imageAlt);
	    show(image);
	
	    if (params.imageWidth) {
	      image.setAttribute('width', params.imageWidth);
	    } else {
	      image.removeAttribute('width');
	    }
	
	    if (params.imageHeight) {
	      image.setAttribute('height', params.imageHeight);
	    } else {
	      image.removeAttribute('height');
	    }
	
	    image.className = swalClasses.image;
	    if (params.imageClass) {
	      addClass(image, params.imageClass);
	    }
	  } else {
	    hide(image);
	  }
	
	  // Cancel button
	  if (params.showCancelButton) {
	    cancelButton.style.display = 'inline-block';
	  } else {
	    hide(cancelButton);
	  }
	
	  // Confirm button
	  if (params.showConfirmButton) {
	    removeStyleProperty(confirmButton, 'display');
	  } else {
	    hide(confirmButton);
	  }
	
	  // Buttons wrapper
	  if (!params.showConfirmButton && !params.showCancelButton) {
	    hide(buttonsWrapper);
	  } else {
	    show(buttonsWrapper);
	  }
	
	  // Edit text on confirm and cancel buttons
	  confirmButton.innerHTML = params.confirmButtonText;
	  cancelButton.innerHTML = params.cancelButtonText;
	
	  // ARIA labels for confirm and cancel buttons
	  confirmButton.setAttribute('aria-label', params.confirmButtonAriaLabel);
	  cancelButton.setAttribute('aria-label', params.cancelButtonAriaLabel);
	
	  // Set buttons to selected background colors
	  if (params.buttonsStyling) {
	    confirmButton.style.backgroundColor = params.confirmButtonColor;
	    cancelButton.style.backgroundColor = params.cancelButtonColor;
	  }
	
	  // Add buttons custom classes
	  confirmButton.className = swalClasses.confirm;
	  addClass(confirmButton, params.confirmButtonClass);
	  cancelButton.className = swalClasses.cancel;
	  addClass(cancelButton, params.cancelButtonClass);
	
	  // Buttons styling
	  if (params.buttonsStyling) {
	    addClass(confirmButton, swalClasses.styled);
	    addClass(cancelButton, swalClasses.styled);
	  } else {
	    removeClass(confirmButton, swalClasses.styled);
	    removeClass(cancelButton, swalClasses.styled);
	
	    confirmButton.style.backgroundColor = confirmButton.style.borderLeftColor = confirmButton.style.borderRightColor = '';
	    cancelButton.style.backgroundColor = cancelButton.style.borderLeftColor = cancelButton.style.borderRightColor = '';
	  }
	
	  // CSS animation
	  if (params.animation === true) {
	    removeClass(modal, swalClasses.noanimation);
	  } else {
	    addClass(modal, swalClasses.noanimation);
	  }
	
	  // showLoaderOnConfirm && preConfirm
	  if (params.showLoaderOnConfirm && !params.preConfirm) {
	    warn('showLoaderOnConfirm is set to true, but preConfirm is not defined.\n' + 'showLoaderOnConfirm should be used together with preConfirm, see usage example:\n' + 'https://limonte.github.io/sweetalert2/#ajax-request');
	  }
	};
	
	/**
	 * Animations
	 *
	 * @param animation
	 * @param onBeforeOpen
	 * @param onComplete
	 */
	var openModal = function openModal(animation, onBeforeOpen, onComplete) {
	  var container = getContainer();
	  var modal = getModal();
	
	  if (onBeforeOpen !== null && typeof onBeforeOpen === 'function') {
	    onBeforeOpen(modal);
	  }
	
	  if (animation) {
	    addClass(modal, swalClasses.show);
	    addClass(container, swalClasses.fade);
	    removeClass(modal, swalClasses.hide);
	  } else {
	    removeClass(modal, swalClasses.fade);
	  }
	  show(modal);
	
	  // scrolling is 'hidden' until animation is done, after that 'auto'
	  container.style.overflowY = 'hidden';
	  if (animationEndEvent && !hasClass(modal, swalClasses.noanimation)) {
	    modal.addEventListener(animationEndEvent, function swalCloseEventFinished() {
	      modal.removeEventListener(animationEndEvent, swalCloseEventFinished);
	      container.style.overflowY = 'auto';
	    });
	  } else {
	    container.style.overflowY = 'auto';
	  }
	
	  addClass(document.documentElement, swalClasses.shown);
	  addClass(document.body, swalClasses.shown);
	  addClass(container, swalClasses.shown);
	  fixScrollbar();
	  iOSfix();
	  states.previousActiveElement = document.activeElement;
	  if (onComplete !== null && typeof onComplete === 'function') {
	    setTimeout(function () {
	      onComplete(modal);
	    });
	  }
	};
	
	var fixScrollbar = function fixScrollbar() {
	  // for queues, do not do this more than once
	  if (states.previousBodyPadding !== null) {
	    return;
	  }
	  // if the body has overflow
	  if (document.body.scrollHeight > window.innerHeight) {
	    // add padding so the content doesn't shift after removal of scrollbar
	    states.previousBodyPadding = document.body.style.paddingRight;
	    document.body.style.paddingRight = measureScrollbar() + 'px';
	  }
	};
	
	var undoScrollbar = function undoScrollbar() {
	  if (states.previousBodyPadding !== null) {
	    document.body.style.paddingRight = states.previousBodyPadding;
	    states.previousBodyPadding = null;
	  }
	};
	
	// Fix iOS scrolling http://stackoverflow.com/q/39626302/1331425
	var iOSfix = function iOSfix() {
	  var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
	  if (iOS && !hasClass(document.body, swalClasses.iosfix)) {
	    var offset = document.body.scrollTop;
	    document.body.style.top = offset * -1 + 'px';
	    addClass(document.body, swalClasses.iosfix);
	  }
	};
	
	var undoIOSfix = function undoIOSfix() {
	  if (hasClass(document.body, swalClasses.iosfix)) {
	    var offset = parseInt(document.body.style.top, 10);
	    removeClass(document.body, swalClasses.iosfix);
	    document.body.style.top = '';
	    document.body.scrollTop = offset * -1;
	  }
	};
	
	// SweetAlert entry point
	var sweetAlert = function sweetAlert() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  if (args[0] === undefined) {
	    error('SweetAlert2 expects at least 1 attribute!');
	    return false;
	  }
	
	  var params = _extends({}, modalParams);
	
	  switch (_typeof(args[0])) {
	    case 'string':
	      params.title = args[0];
	      params.html = args[1];
	      params.type = args[2];
	
	      break;
	
	    case 'object':
	      _extends(params, args[0]);
	      params.extraParams = args[0].extraParams;
	
	      if (params.input === 'email' && params.inputValidator === null) {
	        params.inputValidator = function (email) {
	          return new Promise(function (resolve, reject) {
	            var emailRegex = /^[a-zA-Z0-9.+_-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
	            if (emailRegex.test(email)) {
	              resolve();
	            } else {
	              reject('Invalid email address');
	            }
	          });
	        };
	      }
	
	      if (params.input === 'url' && params.inputValidator === null) {
	        params.inputValidator = function (url) {
	          return new Promise(function (resolve, reject) {
	            // taken from https://stackoverflow.com/a/3809435/1331425
	            var urlRegex = /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)$/;
	            if (urlRegex.test(url)) {
	              resolve();
	            } else {
	              reject('Invalid URL');
	            }
	          });
	        };
	      }
	      break;
	
	    default:
	      error('Unexpected type of argument! Expected "string" or "object", got ' + _typeof(args[0]));
	      return false;
	  }
	
	  setParameters(params);
	
	  var container = getContainer();
	  var modal = getModal();
	
	  return new Promise(function (resolve, reject) {
	    // Close on timer
	    if (params.timer) {
	      modal.timeout = setTimeout(function () {
	        sweetAlert.closeModal(params.onClose);
	        if (params.useRejections) {
	          reject('timer');
	        } else {
	          resolve({ dismiss: 'timer' });
	        }
	      }, params.timer);
	    }
	
	    // Get input element by specified type or, if type isn't specified, by params.input
	    var getInput = function getInput(inputType) {
	      inputType = inputType || params.input;
	      if (!inputType) {
	        return null;
	      }
	      switch (inputType) {
	        case 'select':
	        case 'textarea':
	        case 'file':
	          return getChildByClass(modal, swalClasses[inputType]);
	        case 'checkbox':
	          return modal.querySelector('.' + swalClasses.checkbox + ' input');
	        case 'radio':
	          return modal.querySelector('.' + swalClasses.radio + ' input:checked') || modal.querySelector('.' + swalClasses.radio + ' input:first-child');
	        case 'range':
	          return modal.querySelector('.' + swalClasses.range + ' input');
	        default:
	          return getChildByClass(modal, swalClasses.input);
	      }
	    };
	
	    // Get the value of the modal input
	    var getInputValue = function getInputValue() {
	      var input = getInput();
	      if (!input) {
	        return null;
	      }
	      switch (params.input) {
	        case 'checkbox':
	          return input.checked ? 1 : 0;
	        case 'radio':
	          return input.checked ? input.value : null;
	        case 'file':
	          return input.files.length ? input.files[0] : null;
	        default:
	          return params.inputAutoTrim ? input.value.trim() : input.value;
	      }
	    };
	
	    // input autofocus
	    if (params.input) {
	      setTimeout(function () {
	        var input = getInput();
	        if (input) {
	          focusInput(input);
	        }
	      }, 0);
	    }
	
	    var confirm = function confirm(value) {
	      if (params.showLoaderOnConfirm) {
	        sweetAlert.showLoading();
	      }
	
	      if (params.preConfirm) {
	        params.preConfirm(value, params.extraParams).then(function (preConfirmValue) {
	          sweetAlert.closeModal(params.onClose);
	          resolve(preConfirmValue || value);
	        }, function (error$$1) {
	          sweetAlert.hideLoading();
	          if (error$$1) {
	            sweetAlert.showValidationError(error$$1);
	          }
	        });
	      } else {
	        sweetAlert.closeModal(params.onClose);
	        if (params.useRejections) {
	          resolve(value);
	        } else {
	          resolve({ value: value });
	        }
	      }
	    };
	
	    // Mouse interactions
	    var onButtonEvent = function onButtonEvent(event) {
	      var e = event || window.event;
	      var target = e.target || e.srcElement;
	      var confirmButton = getConfirmButton();
	      var cancelButton = getCancelButton();
	      var targetedConfirm = confirmButton && (confirmButton === target || confirmButton.contains(target));
	      var targetedCancel = cancelButton && (cancelButton === target || cancelButton.contains(target));
	
	      switch (e.type) {
	        case 'mouseover':
	        case 'mouseup':
	          if (params.buttonsStyling) {
	            if (targetedConfirm) {
	              confirmButton.style.backgroundColor = colorLuminance(params.confirmButtonColor, -0.1);
	            } else if (targetedCancel) {
	              cancelButton.style.backgroundColor = colorLuminance(params.cancelButtonColor, -0.1);
	            }
	          }
	          break;
	        case 'mouseout':
	          if (params.buttonsStyling) {
	            if (targetedConfirm) {
	              confirmButton.style.backgroundColor = params.confirmButtonColor;
	            } else if (targetedCancel) {
	              cancelButton.style.backgroundColor = params.cancelButtonColor;
	            }
	          }
	          break;
	        case 'mousedown':
	          if (params.buttonsStyling) {
	            if (targetedConfirm) {
	              confirmButton.style.backgroundColor = colorLuminance(params.confirmButtonColor, -0.2);
	            } else if (targetedCancel) {
	              cancelButton.style.backgroundColor = colorLuminance(params.cancelButtonColor, -0.2);
	            }
	          }
	          break;
	        case 'click':
	          // Clicked 'confirm'
	          if (targetedConfirm && sweetAlert.isVisible()) {
	            sweetAlert.disableButtons();
	            if (params.input) {
	              var inputValue = getInputValue();
	
	              if (params.inputValidator) {
	                sweetAlert.disableInput();
	                params.inputValidator(inputValue, params.extraParams).then(function () {
	                  sweetAlert.enableButtons();
	                  sweetAlert.enableInput();
	                  confirm(inputValue);
	                }, function (error$$1) {
	                  sweetAlert.enableButtons();
	                  sweetAlert.enableInput();
	                  if (error$$1) {
	                    sweetAlert.showValidationError(error$$1);
	                  }
	                });
	              } else {
	                confirm(inputValue);
	              }
	            } else {
	              confirm(true);
	            }
	
	            // Clicked 'cancel'
	          } else if (targetedCancel && sweetAlert.isVisible()) {
	            sweetAlert.disableButtons();
	            sweetAlert.closeModal(params.onClose);
	            if (params.useRejections) {
	              reject('cancel');
	            } else {
	              resolve({ dismiss: 'cancel' });
	            }
	          }
	          break;
	        default:
	      }
	    };
	
	    var buttons = modal.querySelectorAll('button');
	    for (var i = 0; i < buttons.length; i++) {
	      buttons[i].onclick = onButtonEvent;
	      buttons[i].onmouseover = onButtonEvent;
	      buttons[i].onmouseout = onButtonEvent;
	      buttons[i].onmousedown = onButtonEvent;
	    }
	
	    // Closing modal by close button
	    getCloseButton().onclick = function () {
	      sweetAlert.closeModal(params.onClose);
	      if (params.useRejections) {
	        reject('close');
	      } else {
	        resolve({ dismiss: 'close' });
	      }
	    };
	
	    // Closing modal by overlay click
	    container.onclick = function (e) {
	      if (e.target !== container) {
	        return;
	      }
	      if (params.allowOutsideClick) {
	        sweetAlert.closeModal(params.onClose);
	        if (params.useRejections) {
	          reject('overlay');
	        } else {
	          resolve({ dismiss: 'overlay' });
	        }
	      }
	    };
	
	    var buttonsWrapper = getButtonsWrapper();
	    var confirmButton = getConfirmButton();
	    var cancelButton = getCancelButton();
	
	    // Reverse buttons (Confirm on the right side)
	    if (params.reverseButtons) {
	      confirmButton.parentNode.insertBefore(cancelButton, confirmButton);
	    } else {
	      confirmButton.parentNode.insertBefore(confirmButton, cancelButton);
	    }
	
	    // Focus handling
	    var setFocus = function setFocus(index, increment) {
	      var focusableElements = getFocusableElements(params.focusCancel);
	      // search for visible elements and select the next possible match
	      for (var _i3 = 0; _i3 < focusableElements.length; _i3++) {
	        index = index + increment;
	
	        // rollover to first item
	        if (index === focusableElements.length) {
	          index = 0;
	
	          // go to last item
	        } else if (index === -1) {
	          index = focusableElements.length - 1;
	        }
	
	        // determine if element is visible
	        var el = focusableElements[index];
	        if (isVisible(el)) {
	          return el.focus();
	        }
	      }
	    };
	
	    var handleKeyDown = function handleKeyDown(event) {
	      var e = event || window.event;
	
	      if (e.key === 'Enter') {
	        if (e.target === getInput()) {
	          if (e.target.tagName.toLowerCase() === 'textarea') {
	            return; // do not submit
	          }
	          sweetAlert.clickConfirm();
	          e.preventDefault();
	        }
	
	        // TAB
	      } else if (e.key === 'Tab') {
	        var targetElement = e.target || e.srcElement;
	
	        var focusableElements = getFocusableElements(params.focusCancel);
	        var btnIndex = -1; // Find the button - note, this is a nodelist, not an array.
	        for (var _i4 = 0; _i4 < focusableElements.length; _i4++) {
	          if (targetElement === focusableElements[_i4]) {
	            btnIndex = _i4;
	            break;
	          }
	        }
	
	        if (!e.shiftKey) {
	          // Cycle to the next button
	          setFocus(btnIndex, 1);
	        } else {
	          // Cycle to the prev button
	          setFocus(btnIndex, -1);
	        }
	        e.stopPropagation();
	        e.preventDefault();
	
	        // ARROWS - switch focus between buttons
	      } else if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'Arrowdown'].indexOf(e.key) !== -1) {
	        // focus Cancel button if Confirm button is currently focused
	        if (document.activeElement === confirmButton && isVisible(cancelButton)) {
	          cancelButton.focus();
	          // and vice versa
	        } else if (document.activeElement === cancelButton && isVisible(confirmButton)) {
	          confirmButton.focus();
	        }
	
	        // ESC
	      } else if ((e.key === 'Escape' || e.key === 'Esc') && params.allowEscapeKey === true) {
	        sweetAlert.closeModal(params.onClose);
	        if (params.useRejections) {
	          reject('esc');
	        } else {
	          resolve({ dismiss: 'esc' });
	        }
	      }
	    };
	
	    if (!window.onkeydown || window.onkeydown.toString() !== handleKeyDown.toString()) {
	      states.previousWindowKeyDown = window.onkeydown;
	      window.onkeydown = handleKeyDown;
	    }
	
	    // Loading state
	    if (params.buttonsStyling) {
	      confirmButton.style.borderLeftColor = params.confirmButtonColor;
	      confirmButton.style.borderRightColor = params.confirmButtonColor;
	    }
	
	    /**
	     * Show spinner instead of Confirm button and disable Cancel button
	     */
	    sweetAlert.hideLoading = sweetAlert.disableLoading = function () {
	      if (!params.showConfirmButton) {
	        hide(confirmButton);
	        if (!params.showCancelButton) {
	          hide(getButtonsWrapper());
	        }
	      }
	      removeClass(buttonsWrapper, swalClasses.loading);
	      removeClass(modal, swalClasses.loading);
	      modal.removeAttribute('aria-busy');
	      confirmButton.disabled = false;
	      cancelButton.disabled = false;
	    };
	
	    sweetAlert.getTitle = function () {
	      return getTitle();
	    };
	    sweetAlert.getContent = function () {
	      return getContent();
	    };
	    sweetAlert.getInput = function () {
	      return getInput();
	    };
	    sweetAlert.getImage = function () {
	      return getImage();
	    };
	    sweetAlert.getButtonsWrapper = function () {
	      return getButtonsWrapper();
	    };
	    sweetAlert.getConfirmButton = function () {
	      return getConfirmButton();
	    };
	    sweetAlert.getCancelButton = function () {
	      return getCancelButton();
	    };
	
	    sweetAlert.enableButtons = function () {
	      confirmButton.disabled = false;
	      cancelButton.disabled = false;
	    };
	
	    sweetAlert.disableButtons = function () {
	      confirmButton.disabled = true;
	      cancelButton.disabled = true;
	    };
	
	    sweetAlert.enableConfirmButton = function () {
	      confirmButton.disabled = false;
	    };
	
	    sweetAlert.disableConfirmButton = function () {
	      confirmButton.disabled = true;
	    };
	
	    sweetAlert.enableInput = function () {
	      var input = getInput();
	      if (!input) {
	        return false;
	      }
	      if (input.type === 'radio') {
	        var radiosContainer = input.parentNode.parentNode;
	        var radios = radiosContainer.querySelectorAll('input');
	        for (var _i5 = 0; _i5 < radios.length; _i5++) {
	          radios[_i5].disabled = false;
	        }
	      } else {
	        input.disabled = false;
	      }
	    };
	
	    sweetAlert.disableInput = function () {
	      var input = getInput();
	      if (!input) {
	        return false;
	      }
	      if (input && input.type === 'radio') {
	        var radiosContainer = input.parentNode.parentNode;
	        var radios = radiosContainer.querySelectorAll('input');
	        for (var _i6 = 0; _i6 < radios.length; _i6++) {
	          radios[_i6].disabled = true;
	        }
	      } else {
	        input.disabled = true;
	      }
	    };
	
	    // Show block with validation error
	    sweetAlert.showValidationError = function (error$$1) {
	      var validationError = getValidationError();
	      validationError.innerHTML = error$$1;
	      show(validationError);
	
	      var input = getInput();
	      if (input) {
	        input.setAttribute('aria-invalid', true);
	        input.setAttribute('aria-describedBy', swalClasses.validationerror);
	        focusInput(input);
	        addClass(input, swalClasses.inputerror);
	      }
	    };
	
	    // Hide block with validation error
	    sweetAlert.resetValidationError = function () {
	      var validationError = getValidationError();
	      hide(validationError);
	
	      var input = getInput();
	      if (input) {
	        input.removeAttribute('aria-invalid');
	        input.removeAttribute('aria-describedBy');
	        removeClass(input, swalClasses.inputerror);
	      }
	    };
	
	    sweetAlert.getProgressSteps = function () {
	      return params.progressSteps;
	    };
	
	    sweetAlert.setProgressSteps = function (progressSteps) {
	      params.progressSteps = progressSteps;
	      setParameters(params);
	    };
	
	    sweetAlert.showProgressSteps = function () {
	      show(getProgressSteps());
	    };
	
	    sweetAlert.hideProgressSteps = function () {
	      hide(getProgressSteps());
	    };
	
	    sweetAlert.enableButtons();
	    sweetAlert.hideLoading();
	    sweetAlert.resetValidationError();
	
	    // inputs
	    var inputTypes = ['input', 'file', 'range', 'select', 'radio', 'checkbox', 'textarea'];
	    var input = void 0;
	    for (var _i7 = 0; _i7 < inputTypes.length; _i7++) {
	      var inputClass = swalClasses[inputTypes[_i7]];
	      var inputContainer = getChildByClass(modal, inputClass);
	      input = getInput(inputTypes[_i7]);
	
	      // set attributes
	      if (input) {
	        for (var j in input.attributes) {
	          if (input.attributes.hasOwnProperty(j)) {
	            var attrName = input.attributes[j].name;
	            if (attrName !== 'type' && attrName !== 'value') {
	              input.removeAttribute(attrName);
	            }
	          }
	        }
	        for (var attr in params.inputAttributes) {
	          input.setAttribute(attr, params.inputAttributes[attr]);
	        }
	      }
	
	      // set class
	      inputContainer.className = inputClass;
	      if (params.inputClass) {
	        addClass(inputContainer, params.inputClass);
	      }
	
	      hide(inputContainer);
	    }
	
	    var populateInputOptions = void 0;
	    switch (params.input) {
	      case 'text':
	      case 'email':
	      case 'password':
	      case 'number':
	      case 'tel':
	      case 'url':
	        input = getChildByClass(modal, swalClasses.input);
	        input.value = params.inputValue;
	        input.placeholder = params.inputPlaceholder;
	        input.type = params.input;
	        show(input);
	        break;
	      case 'file':
	        input = getChildByClass(modal, swalClasses.file);
	        input.placeholder = params.inputPlaceholder;
	        input.type = params.input;
	        show(input);
	        break;
	      case 'range':
	        var range = getChildByClass(modal, swalClasses.range);
	        var rangeInput = range.querySelector('input');
	        var rangeOutput = range.querySelector('output');
	        rangeInput.value = params.inputValue;
	        rangeInput.type = params.input;
	        rangeOutput.value = params.inputValue;
	        show(range);
	        break;
	      case 'select':
	        var select = getChildByClass(modal, swalClasses.select);
	        select.innerHTML = '';
	        if (params.inputPlaceholder) {
	          var placeholder = document.createElement('option');
	          placeholder.innerHTML = params.inputPlaceholder;
	          placeholder.value = '';
	          placeholder.disabled = true;
	          placeholder.selected = true;
	          select.appendChild(placeholder);
	        }
	        populateInputOptions = function populateInputOptions(inputOptions) {
	          for (var optionValue in inputOptions) {
	            var option = document.createElement('option');
	            option.value = optionValue;
	            option.innerHTML = inputOptions[optionValue];
	            if (params.inputValue.toString() === optionValue) {
	              option.selected = true;
	            }
	            select.appendChild(option);
	          }
	          show(select);
	          select.focus();
	        };
	        break;
	      case 'radio':
	        var radio = getChildByClass(modal, swalClasses.radio);
	        radio.innerHTML = '';
	        populateInputOptions = function populateInputOptions(inputOptions) {
	          for (var radioValue in inputOptions) {
	            var radioInput = document.createElement('input');
	            var radioLabel = document.createElement('label');
	            var radioLabelSpan = document.createElement('span');
	            radioInput.type = 'radio';
	            radioInput.name = swalClasses.radio;
	            radioInput.value = radioValue;
	            if (params.inputValue.toString() === radioValue) {
	              radioInput.checked = true;
	            }
	            radioLabelSpan.innerHTML = inputOptions[radioValue];
	            radioLabel.appendChild(radioInput);
	            radioLabel.appendChild(radioLabelSpan);
	            radioLabel.for = radioInput.id;
	            radio.appendChild(radioLabel);
	          }
	          show(radio);
	          var radios = radio.querySelectorAll('input');
	          if (radios.length) {
	            radios[0].focus();
	          }
	        };
	        break;
	      case 'checkbox':
	        var checkbox = getChildByClass(modal, swalClasses.checkbox);
	        var checkboxInput = getInput('checkbox');
	        checkboxInput.type = 'checkbox';
	        checkboxInput.value = 1;
	        checkboxInput.id = swalClasses.checkbox;
	        checkboxInput.checked = Boolean(params.inputValue);
	        var label = checkbox.getElementsByTagName('span');
	        if (label.length) {
	          checkbox.removeChild(label[0]);
	        }
	        label = document.createElement('span');
	        label.innerHTML = params.inputPlaceholder;
	        checkbox.appendChild(label);
	        show(checkbox);
	        break;
	      case 'textarea':
	        var textarea = getChildByClass(modal, swalClasses.textarea);
	        textarea.value = params.inputValue;
	        textarea.placeholder = params.inputPlaceholder;
	        show(textarea);
	        break;
	      case null:
	        break;
	      default:
	        error('Unexpected type of input! Expected "text", "email", "password", "number", "tel", "select", "radio", "checkbox", "textarea", "file" or "url", got "' + params.input + '"');
	        break;
	    }
	
	    if (params.input === 'select' || params.input === 'radio') {
	      if (params.inputOptions instanceof Promise) {
	        sweetAlert.showLoading();
	        params.inputOptions.then(function (inputOptions) {
	          sweetAlert.hideLoading();
	          populateInputOptions(inputOptions);
	        });
	      } else if (_typeof(params.inputOptions) === 'object') {
	        populateInputOptions(params.inputOptions);
	      } else {
	        error('Unexpected type of inputOptions! Expected object or Promise, got ' + _typeof(params.inputOptions));
	      }
	    }
	
	    openModal(params.animation, params.onBeforeOpen, params.onOpen);
	
	    if (!params.allowEnterKey) {
	      if (document.activeElement) {
	        document.activeElement.blur();
	      }
	    } else if (params.focusCancel && isVisible(cancelButton)) {
	      cancelButton.focus();
	    } else if (params.focusConfirm && isVisible(confirmButton)) {
	      confirmButton.focus();
	    } else {
	      setFocus(-1, 1);
	    }
	
	    // fix scroll
	    getContainer().scrollTop = 0;
	  });
	};
	
	/*
	 * Global function to determine if swal2 modal is shown
	 */
	sweetAlert.isVisible = function () {
	  return !!getModal();
	};
	
	/*
	 * Global function for chaining sweetAlert modals
	 */
	sweetAlert.queue = function (steps) {
	  queue = steps;
	  var resetQueue = function resetQueue() {
	    queue = [];
	    document.body.removeAttribute('data-swal2-queue-step');
	  };
	  var queueResult = [];
	  return new Promise(function (resolve, reject) {
	    (function step(i, callback) {
	      if (i < queue.length) {
	        document.body.setAttribute('data-swal2-queue-step', i);
	
	        sweetAlert(queue[i]).then(function (result) {
	          queueResult.push(result);
	          step(i + 1, callback);
	        }, function (dismiss) {
	          resetQueue();
	          reject(dismiss);
	        });
	      } else {
	        resetQueue();
	        resolve(queueResult);
	      }
	    })(0);
	  });
	};
	
	/*
	 * Global function for getting the index of current modal in queue
	 */
	sweetAlert.getQueueStep = function () {
	  return document.body.getAttribute('data-swal2-queue-step');
	};
	
	/*
	 * Global function for inserting a modal to the queue
	 */
	sweetAlert.insertQueueStep = function (step, index) {
	  if (index && index < queue.length) {
	    return queue.splice(index, 0, step);
	  }
	  return queue.push(step);
	};
	
	/*
	 * Global function for deleting a modal from the queue
	 */
	sweetAlert.deleteQueueStep = function (index) {
	  if (typeof queue[index] !== 'undefined') {
	    queue.splice(index, 1);
	  }
	};
	
	/*
	 * Global function to close sweetAlert
	 */
	sweetAlert.close = sweetAlert.closeModal = function (onComplete) {
	  var container = getContainer();
	  var modal = getModal();
	  if (!modal) {
	    return;
	  }
	  removeClass(modal, swalClasses.show);
	  addClass(modal, swalClasses.hide);
	  clearTimeout(modal.timeout);
	
	  resetPrevState();
	
	  var removeModalAndResetState = function removeModalAndResetState() {
	    if (container.parentNode) {
	      container.parentNode.removeChild(container);
	    }
	    removeClass(document.documentElement, swalClasses.shown);
	    removeClass(document.body, swalClasses.shown);
	    undoScrollbar();
	    undoIOSfix();
	  };
	
	  // If animation is supported, animate
	  if (animationEndEvent && !hasClass(modal, swalClasses.noanimation)) {
	    modal.addEventListener(animationEndEvent, function swalCloseEventFinished() {
	      modal.removeEventListener(animationEndEvent, swalCloseEventFinished);
	      if (hasClass(modal, swalClasses.hide)) {
	        removeModalAndResetState();
	      }
	    });
	  } else {
	    // Otherwise, remove immediately
	    removeModalAndResetState();
	  }
	  if (onComplete !== null && typeof onComplete === 'function') {
	    setTimeout(function () {
	      onComplete(modal);
	    });
	  }
	};
	
	/*
	 * Global function to click 'Confirm' button
	 */
	sweetAlert.clickConfirm = function () {
	  return getConfirmButton().click();
	};
	
	/*
	 * Global function to click 'Cancel' button
	 */
	sweetAlert.clickCancel = function () {
	  return getCancelButton().click();
	};
	
	/**
	 * Show spinner instead of Confirm button and disable Cancel button
	 */
	sweetAlert.showLoading = sweetAlert.enableLoading = function () {
	  var modal = getModal();
	  if (!modal) {
	    sweetAlert('');
	  }
	  modal = getModal();
	  var buttonsWrapper = getButtonsWrapper();
	  var confirmButton = getConfirmButton();
	  var cancelButton = getCancelButton();
	
	  show(buttonsWrapper);
	  show(confirmButton, 'inline-block');
	  addClass(buttonsWrapper, swalClasses.loading);
	  addClass(modal, swalClasses.loading);
	  confirmButton.disabled = true;
	  cancelButton.disabled = true;
	
	  modal.setAttribute('aria-busy', true);
	  modal.focus();
	};
	
	/**
	 * Is valid parameter
	 * @param {String} paramName
	 */
	sweetAlert.isValidParameter = function (paramName) {
	  return defaultParams.hasOwnProperty(paramName) || paramName === 'extraParams';
	};
	
	/**
	 * Set default params for each popup
	 * @param {Object} userParams
	 */
	sweetAlert.setDefaults = function (userParams) {
	  if (!userParams || (typeof userParams === 'undefined' ? 'undefined' : _typeof(userParams)) !== 'object') {
	    return error('the argument for setDefaults() is required and has to be a object');
	  }
	
	  for (var param in userParams) {
	    if (!sweetAlert.isValidParameter(param)) {
	      warn('Unknown parameter "' + param + '"');
	      delete userParams[param];
	    }
	  }
	
	  _extends(modalParams, userParams);
	};
	
	/**
	 * Reset default params for each popup
	 */
	sweetAlert.resetDefaults = function () {
	  modalParams = _extends({}, defaultParams);
	};
	
	sweetAlert.noop = function () {};
	
	sweetAlert.version = '6.11.5';
	
	sweetAlert.default = sweetAlert;
	
	return sweetAlert;
	
	})));
	if (window.Sweetalert2) window.sweetAlert = window.swal = window.Sweetalert2;


/***/ }),
/* 24 */,
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(32);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	if (true) {
	  module.exports = __webpack_require__(590)
	} else {
	  module.exports = require('./vue.common.dev.js')
	}


/***/ }),
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(355), __esModule: true };

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(53)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(34);
	var createDesc = __webpack_require__(57);
	module.exports = __webpack_require__(30) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 32 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 33 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(25);
	var IE8_DOM_DEFINE = __webpack_require__(365);
	var toPrimitive = __webpack_require__(383);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(30) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 35 */,
/* 36 */,
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(39);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 38 */,
/* 39 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 40 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 41 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(79);
	var defined = __webpack_require__(51);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(381)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(82)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 44 */,
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(225);

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(16);
	var normalizeHeaderName = __webpack_require__(239);
	
	var PROTECTION_PREFIX = /^\)\]\}',?\n/;
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(67);
	  } else if (typeof process !== 'undefined') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(67);
	  }
	  return adapter;
	}
	
	var defaults = {
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      data = data.replace(PROTECTION_PREFIX, '');
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	
	defaults.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMehtodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(66)))

/***/ }),
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(40);
	var TAG = __webpack_require__(19)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 51 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(32);
	var document = __webpack_require__(18).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 53 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 54 */
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(39);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(377);
	var enumBugKeys = __webpack_require__(77);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 57 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(34).f;
	var has = __webpack_require__(41);
	var TAG = __webpack_require__(19)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(88)('keys');
	var uid = __webpack_require__(91);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 60 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(60);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(51);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(50);
	var ITERATOR = __webpack_require__(19)('iterator');
	var Iterators = __webpack_require__(33);
	module.exports = __webpack_require__(14).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(388);
	var global = __webpack_require__(18);
	var hide = __webpack_require__(31);
	var Iterators = __webpack_require__(33);
	var TO_STRING_TAG = __webpack_require__(19)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	!function(t,e){ true?module.exports=e(__webpack_require__(92)):"function"==typeof define&&define.amd?define(["highcharts"],e):"object"==typeof exports?exports.HighchartsVue=e(require("highcharts")):t.HighchartsVue=e(t.highcharts)}("undefined"!=typeof self?self:this,function(t){return function(t){function e(n){if(r[n])return r[n].exports;var o=r[n]={i:n,l:!1,exports:{}};return t[n].call(o.exports,o,o.exports,e),o.l=!0,o.exports}var r={};return e.m=t,e.c=r,e.d=function(t,r,n){e.o(t,r)||Object.defineProperty(t,r,{configurable:!1,enumerable:!0,get:n})},e.n=function(t){var r=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(r,"a",r),r},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="",e(e.s=0)}([function(t,e,r){"use strict";function n(t,e){var r=e&&e.tagName||"highcharts";t.component(r,o.a)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=n;var o=r(1);r.d(e,"Chart",function(){return o.a})},function(t,e,r){"use strict";function n(t){if(Array.isArray(t)){for(var e=0,r=new Array(t.length);e<t.length;e++)r[e]=t[e];return r}return Array.from(t)}var o=r(2),c=r.n(o),i={template:'<div ref="chart"></div>',render:function(t){return t("div",{ref:"chart"})},props:{constructorType:{type:String,default:"chart"},options:{type:Object,required:!0},callback:Function,updateArgs:{type:Array,default:function(){return[!0,!0]}}},watch:{options:{handler:function(t){var e;(e=this.chart).update.apply(e,[Object.assign({},t)].concat(n(this.updateArgs)))},deep:!0}},mounted:function(){this.options&&c.a[this.constructorType]?this.chart=c.a[this.constructorType](this.$refs.chart,Object.assign({},this.options),this.callback?this.callback:null):this.options?console.warn("'".concat(this.constructorType,"' constructor-type is incorrect. Sometimes this error is casued by the fact, that the corresponding module wasn't imported.")):console.warn('The "options" parameter was not passed.')},beforeDestroy:function(){this.chart&&this.chart.destroy()}};e.a=i},function(e,r){e.exports=t}])});

/***/ }),
/* 66 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(16);
	var settle = __webpack_require__(231);
	var buildURL = __webpack_require__(234);
	var parseHeaders = __webpack_require__(240);
	var isURLSameOrigin = __webpack_require__(238);
	var createError = __webpack_require__(70);
	var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(233);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	    var loadEvent = 'onreadystatechange';
	    var xDomain = false;
	
	    // For IE 8/9 CORS support
	    // Only supports POST and GET calls and doesn't returns the response headers.
	    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
	    if (("production") !== 'test' &&
	        typeof window !== 'undefined' &&
	        window.XDomainRequest && !('withCredentials' in request) &&
	        !isURLSameOrigin(config.url)) {
	      request = new window.XDomainRequest();
	      loadEvent = 'onload';
	      xDomain = true;
	      request.onprogress = function handleProgress() {};
	      request.ontimeout = function handleTimeout() {};
	    }
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password || '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    // Listen for ready state
	    request[loadEvent] = function handleLoad() {
	      if (!request || (request.readyState !== 4 && !xDomain)) {
	        return;
	      }
	
	      // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      // With one exception: request that using file: protocol, most browsers
	      // will return status as 0 even though it's a successful request
	      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	        return;
	      }
	
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        // IE sends 1223 instead of 204 (https://github.com/mzabriskie/axios/issues/201)
	        status: request.status === 1223 ? 204 : request.status,
	        statusText: request.status === 1223 ? 'No Content' : request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED'));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      var cookies = __webpack_require__(236);
	
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
	          cookies.read(config.xsrfCookieName) :
	          undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (config.withCredentials) {
	      request.withCredentials = true;
	    }
	
	    // Add responseType to request if needed
	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        if (request.responseType !== 'json') {
	          throw e;
	        }
	      }
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }
	
	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }
	
	    if (requestData === undefined) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ }),
/* 68 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;


/***/ }),
/* 69 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var enhanceError = __webpack_require__(230);
	
	/**
	 * Create an Error with the specified message, config, error code, and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 @ @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, response);
	};


/***/ }),
/* 71 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ }),
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(353), __esModule: true };

/***/ }),
/* 77 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(18).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(40);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(33);
	var ITERATOR = __webpack_require__(19)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(25);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(54);
	var $export = __webpack_require__(20);
	var redefine = __webpack_require__(379);
	var hide = __webpack_require__(31);
	var Iterators = __webpack_require__(33);
	var $iterCreate = __webpack_require__(368);
	var setToStringTag = __webpack_require__(58);
	var getPrototypeOf = __webpack_require__(376);
	var ITERATOR = __webpack_require__(19)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(19)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 84 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	var getKeys = __webpack_require__(56);
	var toIObject = __webpack_require__(42);
	var isEnum = __webpack_require__(84).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) if (isEnum.call(O, key = keys[i++])) {
	      result.push(isEntries ? [key, O[key]] : O[key]);
	    } return result;
	  };
	};


/***/ }),
/* 86 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(25);
	var isObject = __webpack_require__(32);
	var newPromiseCapability = __webpack_require__(55);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(14);
	var global = __webpack_require__(18);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(54) ? 'pure' : 'global',
	  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(25);
	var aFunction = __webpack_require__(39);
	var SPECIES = __webpack_require__(19)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(37);
	var invoke = __webpack_require__(366);
	var html = __webpack_require__(78);
	var cel = __webpack_require__(52);
	var global = __webpack_require__(18);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(40)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 91 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*
	 Highcharts JS v7.1.1 (2019-04-09)
	
	 (c) 2009-2018 Torstein Honsi
	
	 License: www.highcharts.com/license
	*/
	(function(Q,K){"object"===typeof module&&module.exports?(K["default"]=K,module.exports=Q.document?K(Q):K): true?!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return K(Q)}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):(Q.Highcharts&&Q.Highcharts.error(16,!0),Q.Highcharts=K(Q))})("undefined"!==typeof window?window:this,function(Q){function K(a,C,I,F){a.hasOwnProperty(C)||(a[C]=F.apply(null,I))}var G={};K(G,"parts/Globals.js",[],function(){var a="undefined"===typeof Q?"undefined"!==typeof window?window:{}:Q,C=a.document,
	I=a.navigator&&a.navigator.userAgent||"",F=C&&C.createElementNS&&!!C.createElementNS("http://www.w3.org/2000/svg","svg").createSVGRect,k=/(edge|msie|trident)/i.test(I)&&!a.opera,e=-1!==I.indexOf("Firefox"),q=-1!==I.indexOf("Chrome"),t=e&&4>parseInt(I.split("Firefox/")[1],10);return{product:"Highcharts",version:"7.1.1",deg2rad:2*Math.PI/360,doc:C,hasBidiBug:t,hasTouch:C&&void 0!==C.documentElement.ontouchstart,isMS:k,isWebKit:-1!==I.indexOf("AppleWebKit"),isFirefox:e,isChrome:q,isSafari:!q&&-1!==I.indexOf("Safari"),
	isTouchDevice:/(Mobile|Android|Windows Phone)/.test(I),SVG_NS:"http://www.w3.org/2000/svg",chartCount:0,seriesTypes:{},symbolSizes:{},svg:F,win:a,marginNames:["plotTop","marginRight","marginBottom","plotLeft"],noop:function(){},charts:[],dateFormats:{}}});K(G,"parts/Utilities.js",[G["parts/Globals.js"]],function(a){a.timers=[];var C=a.charts,I=a.doc,F=a.win;a.error=function(k,e,q){var t=a.isNumber(k)?"Highcharts error #"+k+": www.highcharts.com/errors/"+k:k,u=function(){if(e)throw Error(t);F.console&&
	console.log(t)};q?a.fireEvent(q,"displayError",{code:k,message:t},u):u()};a.Fx=function(a,e,q){this.options=e;this.elem=a;this.prop=q};a.Fx.prototype={dSetter:function(){var a=this.paths[0],e=this.paths[1],q=[],t=this.now,u=a.length,v;if(1===t)q=this.toD;else if(u===e.length&&1>t)for(;u--;)v=parseFloat(a[u]),q[u]=isNaN(v)?e[u]:t*parseFloat(e[u]-v)+v;else q=e;this.elem.attr("d",q,null,!0)},update:function(){var a=this.elem,e=this.prop,q=this.now,t=this.options.step;if(this[e+"Setter"])this[e+"Setter"]();
	else a.attr?a.element&&a.attr(e,q,null,!0):a.style[e]=q+this.unit;t&&t.call(a,q,this)},run:function(k,e,q){var t=this,u=t.options,v=function(a){return v.stopped?!1:t.step(a)},p=F.requestAnimationFrame||function(a){setTimeout(a,13)},h=function(){for(var d=0;d<a.timers.length;d++)a.timers[d]()||a.timers.splice(d--,1);a.timers.length&&p(h)};k!==e||this.elem["forceAnimate:"+this.prop]?(this.startTime=+new Date,this.start=k,this.end=e,this.unit=q,this.now=this.start,this.pos=0,v.elem=this.elem,v.prop=
	this.prop,v()&&1===a.timers.push(v)&&p(h)):(delete u.curAnim[this.prop],u.complete&&0===Object.keys(u.curAnim).length&&u.complete.call(this.elem))},step:function(k){var e=+new Date,q,t=this.options,u=this.elem,v=t.complete,p=t.duration,h=t.curAnim;u.attr&&!u.element?k=!1:k||e>=p+this.startTime?(this.now=this.end,this.pos=1,this.update(),q=h[this.prop]=!0,a.objectEach(h,function(a){!0!==a&&(q=!1)}),q&&v&&v.call(u),k=!1):(this.pos=t.easing((e-this.startTime)/p),this.now=this.start+(this.end-this.start)*
	this.pos,this.update(),k=!0);return k},initPath:function(k,e,q){function t(a){var b,g;for(c=a.length;c--;)b="M"===a[c]||"L"===a[c],g=/[a-zA-Z]/.test(a[c+3]),b&&g&&a.splice(c+1,0,a[c+1],a[c+2],a[c+1],a[c+2])}function u(a,d){for(;a.length<g;){a[0]=d[g-a.length];var n=a.slice(0,b);[].splice.apply(a,[0,0].concat(n));w&&(n=a.slice(a.length-b),[].splice.apply(a,[a.length,0].concat(n)),c--)}a[0]="M"}function v(a,c){for(var d=(g-a.length)/b;0<d&&d--;)l=a.slice().splice(a.length/z-b,b*z),l[0]=c[g-b-d*b],m&&
	(l[b-6]=l[b-2],l[b-5]=l[b-1]),[].splice.apply(a,[a.length/z,0].concat(l)),w&&d--}e=e||"";var p,h=k.startX,d=k.endX,m=-1<e.indexOf("C"),b=m?7:3,g,l,c;e=e.split(" ");q=q.slice();var w=k.isArea,z=w?2:1,J;m&&(t(e),t(q));if(h&&d){for(c=0;c<h.length;c++)if(h[c]===d[0]){p=c;break}else if(h[0]===d[d.length-h.length+c]){p=c;J=!0;break}void 0===p&&(e=[])}e.length&&a.isNumber(p)&&(g=q.length+p*z*b,J?(u(e,q),v(q,e)):(u(q,e),v(e,q)));return[e,q]},fillSetter:function(){a.Fx.prototype.strokeSetter.apply(this,arguments)},
	strokeSetter:function(){this.elem.attr(this.prop,a.color(this.start).tweenTo(a.color(this.end),this.pos),null,!0)}};a.merge=function(){var k,e=arguments,q,t={},u=function(e,p){"object"!==typeof e&&(e={});a.objectEach(p,function(h,d){!a.isObject(h,!0)||a.isClass(h)||a.isDOMElement(h)?e[d]=p[d]:e[d]=u(e[d]||{},h)});return e};!0===e[0]&&(t=e[1],e=Array.prototype.slice.call(e,2));q=e.length;for(k=0;k<q;k++)t=u(t,e[k]);return t};a.pInt=function(a,e){return parseInt(a,e||10)};a.isString=function(a){return"string"===
	typeof a};a.isArray=function(a){a=Object.prototype.toString.call(a);return"[object Array]"===a||"[object Array Iterator]"===a};a.isObject=function(k,e){return!!k&&"object"===typeof k&&(!e||!a.isArray(k))};a.isDOMElement=function(k){return a.isObject(k)&&"number"===typeof k.nodeType};a.isClass=function(k){var e=k&&k.constructor;return!(!a.isObject(k,!0)||a.isDOMElement(k)||!e||!e.name||"Object"===e.name)};a.isNumber=function(a){return"number"===typeof a&&!isNaN(a)&&Infinity>a&&-Infinity<a};a.erase=
	function(a,e){for(var k=a.length;k--;)if(a[k]===e){a.splice(k,1);break}};a.defined=function(a){return void 0!==a&&null!==a};a.attr=function(k,e,q){var t;a.isString(e)?a.defined(q)?k.setAttribute(e,q):k&&k.getAttribute&&((t=k.getAttribute(e))||"class"!==e||(t=k.getAttribute(e+"Name"))):a.defined(e)&&a.isObject(e)&&a.objectEach(e,function(a,e){k.setAttribute(e,a)});return t};a.splat=function(k){return a.isArray(k)?k:[k]};a.syncTimeout=function(a,e,q){if(e)return setTimeout(a,e,q);a.call(0,q)};a.clearTimeout=
	function(k){a.defined(k)&&clearTimeout(k)};a.extend=function(a,e){var k;a||(a={});for(k in e)a[k]=e[k];return a};a.pick=function(){var a=arguments,e,q,t=a.length;for(e=0;e<t;e++)if(q=a[e],void 0!==q&&null!==q)return q};a.css=function(k,e){a.isMS&&!a.svg&&e&&void 0!==e.opacity&&(e.filter="alpha(opacity\x3d"+100*e.opacity+")");a.extend(k.style,e)};a.createElement=function(k,e,q,t,u){k=I.createElement(k);var v=a.css;e&&a.extend(k,e);u&&v(k,{padding:0,border:"none",margin:0});q&&v(k,q);t&&t.appendChild(k);
	return k};a.extendClass=function(k,e){var q=function(){};q.prototype=new k;a.extend(q.prototype,e);return q};a.pad=function(a,e,q){return Array((e||2)+1-String(a).replace("-","").length).join(q||0)+a};a.relativeLength=function(a,e,q){return/%$/.test(a)?e*parseFloat(a)/100+(q||0):parseFloat(a)};a.wrap=function(a,e,q){var k=a[e];a[e]=function(){var a=Array.prototype.slice.call(arguments),e=arguments,p=this;p.proceed=function(){k.apply(p,arguments.length?arguments:e)};a.unshift(k);a=q.apply(this,a);
	p.proceed=null;return a}};a.datePropsToTimestamps=function(k){a.objectEach(k,function(e,q){a.isObject(e)&&"function"===typeof e.getTime?k[q]=e.getTime():(a.isObject(e)||a.isArray(e))&&a.datePropsToTimestamps(e)})};a.formatSingle=function(k,e,q){var t=/\.([0-9])/,u=a.defaultOptions.lang;/f$/.test(k)?(q=(q=k.match(t))?q[1]:-1,null!==e&&(e=a.numberFormat(e,q,u.decimalPoint,-1<k.indexOf(",")?u.thousandsSep:""))):e=(q||a.time).dateFormat(k,e);return e};a.format=function(k,e,q){for(var t="{",u=!1,v,p,h,
	d,m=[],b;k;){t=k.indexOf(t);if(-1===t)break;v=k.slice(0,t);if(u){v=v.split(":");p=v.shift().split(".");d=p.length;b=e;for(h=0;h<d;h++)b&&(b=b[p[h]]);v.length&&(b=a.formatSingle(v.join(":"),b,q));m.push(b)}else m.push(v);k=k.slice(t+1);t=(u=!u)?"}":"{"}m.push(k);return m.join("")};a.getMagnitude=function(a){return Math.pow(10,Math.floor(Math.log(a)/Math.LN10))};a.normalizeTickInterval=function(k,e,q,t,u){var v,p=k;q=a.pick(q,1);v=k/q;e||(e=u?[1,1.2,1.5,2,2.5,3,4,5,6,8,10]:[1,2,2.5,5,10],!1===t&&(1===
	q?e=e.filter(function(a){return 0===a%1}):.1>=q&&(e=[1/q])));for(t=0;t<e.length&&!(p=e[t],u&&p*q>=k||!u&&v<=(e[t]+(e[t+1]||e[t]))/2);t++);return p=a.correctFloat(p*q,-Math.round(Math.log(.001)/Math.LN10))};a.stableSort=function(a,e){var k=a.length,t,u;for(u=0;u<k;u++)a[u].safeI=u;a.sort(function(a,p){t=e(a,p);return 0===t?a.safeI-p.safeI:t});for(u=0;u<k;u++)delete a[u].safeI};a.arrayMin=function(a){for(var e=a.length,k=a[0];e--;)a[e]<k&&(k=a[e]);return k};a.arrayMax=function(a){for(var e=a.length,
	k=a[0];e--;)a[e]>k&&(k=a[e]);return k};a.destroyObjectProperties=function(k,e){a.objectEach(k,function(a,t){a&&a!==e&&a.destroy&&a.destroy();delete k[t]})};a.discardElement=function(k){var e=a.garbageBin;e||(e=a.createElement("div"));k&&e.appendChild(k);e.innerHTML=""};a.correctFloat=function(a,e){return parseFloat(a.toPrecision(e||14))};a.setAnimation=function(k,e){e.renderer.globalAnimation=a.pick(k,e.options.chart.animation,!0)};a.animObject=function(k){return a.isObject(k)?a.merge(k):{duration:k?
	500:0}};a.timeUnits={millisecond:1,second:1E3,minute:6E4,hour:36E5,day:864E5,week:6048E5,month:24192E5,year:314496E5};a.numberFormat=function(k,e,q,t){k=+k||0;e=+e;var u=a.defaultOptions.lang,v=(k.toString().split(".")[1]||"").split("e")[0].length,p,h,d=k.toString().split("e");-1===e?e=Math.min(v,20):a.isNumber(e)?e&&d[1]&&0>d[1]&&(p=e+ +d[1],0<=p?(d[0]=(+d[0]).toExponential(p).split("e")[0],e=p):(d[0]=d[0].split(".")[0]||0,k=20>e?(d[0]*Math.pow(10,d[1])).toFixed(e):0,d[1]=0)):e=2;h=(Math.abs(d[1]?
	d[0]:k)+Math.pow(10,-Math.max(e,v)-1)).toFixed(e);v=String(a.pInt(h));p=3<v.length?v.length%3:0;q=a.pick(q,u.decimalPoint);t=a.pick(t,u.thousandsSep);k=(0>k?"-":"")+(p?v.substr(0,p)+t:"");k+=v.substr(p).replace(/(\d{3})(?=\d)/g,"$1"+t);e&&(k+=q+h.slice(-e));d[1]&&0!==+k&&(k+="e"+d[1]);return k};Math.easeInOutSine=function(a){return-.5*(Math.cos(Math.PI*a)-1)};a.getStyle=function(k,e,q){if("width"===e)return Math.max(0,Math.min(k.offsetWidth,k.scrollWidth,k.getBoundingClientRect&&"none"===a.getStyle(k,
	"transform",!1)?Math.floor(k.getBoundingClientRect().width):Infinity)-a.getStyle(k,"padding-left")-a.getStyle(k,"padding-right"));if("height"===e)return Math.max(0,Math.min(k.offsetHeight,k.scrollHeight)-a.getStyle(k,"padding-top")-a.getStyle(k,"padding-bottom"));F.getComputedStyle||a.error(27,!0);if(k=F.getComputedStyle(k,void 0))k=k.getPropertyValue(e),a.pick(q,"opacity"!==e)&&(k=a.pInt(k));return k};a.inArray=function(a,e,q){return e.indexOf(a,q)};a.find=Array.prototype.find?function(a,e){return a.find(e)}:
	function(a,e){var k,t=a.length;for(k=0;k<t;k++)if(e(a[k],k))return a[k]};a.keys=Object.keys;a.offset=function(a){var e=I.documentElement;a=a.parentElement||a.parentNode?a.getBoundingClientRect():{top:0,left:0};return{top:a.top+(F.pageYOffset||e.scrollTop)-(e.clientTop||0),left:a.left+(F.pageXOffset||e.scrollLeft)-(e.clientLeft||0)}};a.stop=function(k,e){for(var q=a.timers.length;q--;)a.timers[q].elem!==k||e&&e!==a.timers[q].prop||(a.timers[q].stopped=!0)};a.objectEach=function(a,e,q){for(var k in a)a.hasOwnProperty(k)&&
	e.call(q||a[k],a[k],k,a)};a.objectEach({map:"map",each:"forEach",grep:"filter",reduce:"reduce",some:"some"},function(k,e){a[e]=function(a){return Array.prototype[k].apply(a,[].slice.call(arguments,1))}});a.addEvent=function(k,e,q,t){var u,v=k.addEventListener||a.addEventListenerPolyfill;u="function"===typeof k&&k.prototype?k.prototype.protoEvents=k.prototype.protoEvents||{}:k.hcEvents=k.hcEvents||{};a.Point&&k instanceof a.Point&&k.series&&k.series.chart&&(k.series.chart.runTrackerClick=!0);v&&v.call(k,
	e,q,!1);u[e]||(u[e]=[]);u[e].push(q);t&&a.isNumber(t.order)&&(q.order=t.order,u[e].sort(function(a,h){return a.order-h.order}));return function(){a.removeEvent(k,e,q)}};a.removeEvent=function(k,e,q){function t(h,d){var m=k.removeEventListener||a.removeEventListenerPolyfill;m&&m.call(k,h,d,!1)}function u(h){var d,m;k.nodeName&&(e?(d={},d[e]=!0):d=h,a.objectEach(d,function(a,d){if(h[d])for(m=h[d].length;m--;)t(d,h[d][m])}))}var v,p;["protoEvents","hcEvents"].forEach(function(a){var d=k[a];d&&(e?(v=
	d[e]||[],q?(p=v.indexOf(q),-1<p&&(v.splice(p,1),d[e]=v),t(e,q)):(u(d),d[e]=[])):(u(d),k[a]={}))})};a.fireEvent=function(k,e,q,t){var u,v,p,h,d;q=q||{};I.createEvent&&(k.dispatchEvent||k.fireEvent)?(u=I.createEvent("Events"),u.initEvent(e,!0,!0),a.extend(u,q),k.dispatchEvent?k.dispatchEvent(u):k.fireEvent(e,u)):["protoEvents","hcEvents"].forEach(function(m){if(k[m])for(v=k[m][e]||[],p=v.length,q.target||a.extend(q,{preventDefault:function(){q.defaultPrevented=!0},target:k,type:e}),h=0;h<p;h++)(d=v[h])&&
	!1===d.call(k,q)&&q.preventDefault()});t&&!q.defaultPrevented&&t.call(k,q)};a.animate=function(k,e,q){var t,u="",v,p,h;a.isObject(q)||(h=arguments,q={duration:h[2],easing:h[3],complete:h[4]});a.isNumber(q.duration)||(q.duration=400);q.easing="function"===typeof q.easing?q.easing:Math[q.easing]||Math.easeInOutSine;q.curAnim=a.merge(e);a.objectEach(e,function(d,h){a.stop(k,h);p=new a.Fx(k,q,h);v=null;"d"===h?(p.paths=p.initPath(k,k.d,e.d),p.toD=e.d,t=0,v=1):k.attr?t=k.attr(h):(t=parseFloat(a.getStyle(k,
	h))||0,"opacity"!==h&&(u="px"));v||(v=d);v&&v.match&&v.match("px")&&(v=v.replace(/px/g,""));p.run(t,v,u)})};a.seriesType=function(k,e,q,t,u){var v=a.getOptions(),p=a.seriesTypes;v.plotOptions[k]=a.merge(v.plotOptions[e],q);p[k]=a.extendClass(p[e]||function(){},t);p[k].prototype.type=k;u&&(p[k].prototype.pointClass=a.extendClass(a.Point,u));return p[k]};a.uniqueKey=function(){var a=Math.random().toString(36).substring(2,9),e=0;return function(){return"highcharts-"+a+"-"+e++}}();a.isFunction=function(a){return"function"===
	typeof a};F.jQuery&&(F.jQuery.fn.highcharts=function(){var k=[].slice.call(arguments);if(this[0])return k[0]?(new (a[a.isString(k[0])?k.shift():"Chart"])(this[0],k[0],k[1]),this):C[a.attr(this[0],"data-highcharts-chart")]})});K(G,"parts/Color.js",[G["parts/Globals.js"]],function(a){var C=a.isNumber,I=a.merge,F=a.pInt;a.Color=function(k){if(!(this instanceof a.Color))return new a.Color(k);this.init(k)};a.Color.prototype={parsers:[{regex:/rgba\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]?(?:\.[0-9]+)?)\s*\)/,
	parse:function(a){return[F(a[1]),F(a[2]),F(a[3]),parseFloat(a[4],10)]}},{regex:/rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/,parse:function(a){return[F(a[1]),F(a[2]),F(a[3]),1]}}],names:{white:"#ffffff",black:"#000000"},init:function(k){var e,q,t,u;if((this.input=k=this.names[k&&k.toLowerCase?k.toLowerCase():""]||k)&&k.stops)this.stops=k.stops.map(function(e){return new a.Color(e[1])});else if(k&&k.charAt&&"#"===k.charAt()&&(e=k.length,k=parseInt(k.substr(1),16),7===e?q=[(k&16711680)>>
	16,(k&65280)>>8,k&255,1]:4===e&&(q=[(k&3840)>>4|(k&3840)>>8,(k&240)>>4|k&240,(k&15)<<4|k&15,1])),!q)for(t=this.parsers.length;t--&&!q;)u=this.parsers[t],(e=u.regex.exec(k))&&(q=u.parse(e));this.rgba=q||[]},get:function(a){var e=this.input,k=this.rgba,t;this.stops?(t=I(e),t.stops=[].concat(t.stops),this.stops.forEach(function(e,k){t.stops[k]=[t.stops[k][0],e.get(a)]})):t=k&&C(k[0])?"rgb"===a||!a&&1===k[3]?"rgb("+k[0]+","+k[1]+","+k[2]+")":"a"===a?k[3]:"rgba("+k.join(",")+")":e;return t},brighten:function(a){var e,
	k=this.rgba;if(this.stops)this.stops.forEach(function(e){e.brighten(a)});else if(C(a)&&0!==a)for(e=0;3>e;e++)k[e]+=F(255*a),0>k[e]&&(k[e]=0),255<k[e]&&(k[e]=255);return this},setOpacity:function(a){this.rgba[3]=a;return this},tweenTo:function(a,e){var k=this.rgba,t=a.rgba;t.length&&k&&k.length?(a=1!==t[3]||1!==k[3],e=(a?"rgba(":"rgb(")+Math.round(t[0]+(k[0]-t[0])*(1-e))+","+Math.round(t[1]+(k[1]-t[1])*(1-e))+","+Math.round(t[2]+(k[2]-t[2])*(1-e))+(a?","+(t[3]+(k[3]-t[3])*(1-e)):"")+")"):e=a.input||
	"none";return e}};a.color=function(k){return new a.Color(k)}});K(G,"parts/SvgRenderer.js",[G["parts/Globals.js"]],function(a){var C,I,F=a.addEvent,k=a.animate,e=a.attr,q=a.charts,t=a.color,u=a.css,v=a.createElement,p=a.defined,h=a.deg2rad,d=a.destroyObjectProperties,m=a.doc,b=a.extend,g=a.erase,l=a.hasTouch,c=a.isArray,w=a.isFirefox,z=a.isMS,J=a.isObject,D=a.isString,A=a.isWebKit,n=a.merge,x=a.noop,B=a.objectEach,E=a.pick,H=a.pInt,f=a.removeEvent,r=a.splat,N=a.stop,M=a.svg,L=a.SVG_NS,P=a.symbolSizes,
	O=a.win;C=a.SVGElement=function(){return this};b(C.prototype,{opacity:1,SVG_NS:L,textProps:"direction fontSize fontWeight fontFamily fontStyle color lineHeight width textAlign textDecoration textOverflow textOutline cursor".split(" "),init:function(y,f){this.element="span"===f?v(f):m.createElementNS(this.SVG_NS,f);this.renderer=y;a.fireEvent(this,"afterInit")},animate:function(y,f,b){var c=a.animObject(E(f,this.renderer.globalAnimation,!0));E(m.hidden,m.msHidden,m.webkitHidden,!1)&&(c.duration=0);
	0!==c.duration?(b&&(c.complete=b),k(this,y,c)):(this.attr(y,null,b),a.objectEach(y,function(a,y){c.step&&c.step.call(this,a,{prop:y,pos:1})},this));return this},complexColor:function(y,f,b){var r=this.renderer,d,g,l,h,S,m,L,w,x,e,z,M=[],N;a.fireEvent(this.renderer,"complexColor",{args:arguments},function(){y.radialGradient?g="radialGradient":y.linearGradient&&(g="linearGradient");g&&(l=y[g],S=r.gradients,L=y.stops,e=b.radialReference,c(l)&&(y[g]=l={x1:l[0],y1:l[1],x2:l[2],y2:l[3],gradientUnits:"userSpaceOnUse"}),
	"radialGradient"===g&&e&&!p(l.gradientUnits)&&(h=l,l=n(l,r.getRadialAttr(e,h),{gradientUnits:"userSpaceOnUse"})),B(l,function(a,y){"id"!==y&&M.push(y,a)}),B(L,function(a){M.push(a)}),M=M.join(","),S[M]?z=S[M].attr("id"):(l.id=z=a.uniqueKey(),S[M]=m=r.createElement(g).attr(l).add(r.defs),m.radAttr=h,m.stops=[],L.forEach(function(y){0===y[1].indexOf("rgba")?(d=a.color(y[1]),w=d.get("rgb"),x=d.get("a")):(w=y[1],x=1);y=r.createElement("stop").attr({offset:y[0],"stop-color":w,"stop-opacity":x}).add(m);
	m.stops.push(y)})),N="url("+r.url+"#"+z+")",b.setAttribute(f,N),b.gradient=M,y.toString=function(){return N})})},applyTextOutline:function(y){var f=this.element,b,c,r;-1!==y.indexOf("contrast")&&(y=y.replace(/contrast/g,this.renderer.getContrast(f.style.fill)));y=y.split(" ");b=y[y.length-1];(c=y[0])&&"none"!==c&&a.svg&&(this.fakeTS=!0,y=[].slice.call(f.getElementsByTagName("tspan")),this.ySetter=this.xSetter,c=c.replace(/(^[\d\.]+)(.*?)$/g,function(a,y,f){return 2*y+f}),this.removeTextOutline(y),
	r=f.firstChild,y.forEach(function(a,y){0===y&&(a.setAttribute("x",f.getAttribute("x")),y=f.getAttribute("y"),a.setAttribute("y",y||0),null===y&&f.setAttribute("y",0));a=a.cloneNode(1);e(a,{"class":"highcharts-text-outline",fill:b,stroke:b,"stroke-width":c,"stroke-linejoin":"round"});f.insertBefore(a,r)}))},removeTextOutline:function(a){for(var y=a.length,f;y--;)f=a[y],"highcharts-text-outline"===f.getAttribute("class")&&g(a,this.element.removeChild(f))},symbolCustomAttribs:"x y width height r start end innerR anchorX anchorY rounded".split(" "),
	attr:function(y,f,b,c){var r,d=this.element,g,l=this,n,h,m=this.symbolCustomAttribs;"string"===typeof y&&void 0!==f&&(r=y,y={},y[r]=f);"string"===typeof y?l=(this[y+"Getter"]||this._defaultGetter).call(this,y,d):(B(y,function(f,b){n=!1;c||N(this,b);this.symbolName&&-1!==a.inArray(b,m)&&(g||(this.symbolAttr(y),g=!0),n=!0);!this.rotation||"x"!==b&&"y"!==b||(this.doTransform=!0);n||(h=this[b+"Setter"]||this._defaultSetter,h.call(this,f,b,d),!this.styledMode&&this.shadows&&/^(width|height|visibility|x|y|d|transform|cx|cy|r)$/.test(b)&&
	this.updateShadows(b,f,h))},this),this.afterSetters());b&&b.call(this);return l},afterSetters:function(){this.doTransform&&(this.updateTransform(),this.doTransform=!1)},updateShadows:function(a,f,b){for(var y=this.shadows,c=y.length;c--;)b.call(y[c],"height"===a?Math.max(f-(y[c].cutHeight||0),0):"d"===a?this.d:f,a,y[c])},addClass:function(a,f){var y=this.attr("class")||"";f||(a=(a||"").split(/ /g).reduce(function(a,f){-1===y.indexOf(f)&&a.push(f);return a},y?[y]:[]).join(" "));a!==y&&this.attr("class",
	a);return this},hasClass:function(a){return-1!==(this.attr("class")||"").split(" ").indexOf(a)},removeClass:function(a){return this.attr("class",(this.attr("class")||"").replace(a,""))},symbolAttr:function(a){var y=this;"x y r start end width height innerR anchorX anchorY clockwise".split(" ").forEach(function(f){y[f]=E(a[f],y[f])});y.attr({d:y.renderer.symbols[y.symbolName](y.x,y.y,y.width,y.height,y)})},clip:function(a){return this.attr("clip-path",a?"url("+this.renderer.url+"#"+a.id+")":"none")},
	crisp:function(a,f){var y;f=f||a.strokeWidth||0;y=Math.round(f)%2/2;a.x=Math.floor(a.x||this.x||0)+y;a.y=Math.floor(a.y||this.y||0)+y;a.width=Math.floor((a.width||this.width||0)-2*y);a.height=Math.floor((a.height||this.height||0)-2*y);p(a.strokeWidth)&&(a.strokeWidth=f);return a},css:function(a){var y=this.styles,f={},c=this.element,r,d="",g,l=!y,n=["textOutline","textOverflow","width"];a&&a.color&&(a.fill=a.color);y&&B(a,function(a,b){a!==y[b]&&(f[b]=a,l=!0)});l&&(y&&(a=b(y,f)),a&&(null===a.width||
	"auto"===a.width?delete this.textWidth:"text"===c.nodeName.toLowerCase()&&a.width&&(r=this.textWidth=H(a.width))),this.styles=a,r&&!M&&this.renderer.forExport&&delete a.width,c.namespaceURI===this.SVG_NS?(g=function(a,y){return"-"+y.toLowerCase()},B(a,function(a,y){-1===n.indexOf(y)&&(d+=y.replace(/([A-Z])/g,g)+":"+a+";")}),d&&e(c,"style",d)):u(c,a),this.added&&("text"===this.element.nodeName&&this.renderer.buildText(this),a&&a.textOutline&&this.applyTextOutline(a.textOutline)));return this},getStyle:function(a){return O.getComputedStyle(this.element||
	this,"").getPropertyValue(a)},strokeWidth:function(){if(!this.renderer.styledMode)return this["stroke-width"]||0;var a=this.getStyle("stroke-width"),f;a.indexOf("px")===a.length-2?a=H(a):(f=m.createElementNS(L,"rect"),e(f,{width:a,"stroke-width":0}),this.element.parentNode.appendChild(f),a=f.getBBox().width,f.parentNode.removeChild(f));return a},on:function(a,f){var y=this,b=y.element;l&&"click"===a?(b.ontouchstart=function(a){y.touchEventFired=Date.now();a.preventDefault();f.call(b,a)},b.onclick=
	function(a){(-1===O.navigator.userAgent.indexOf("Android")||1100<Date.now()-(y.touchEventFired||0))&&f.call(b,a)}):b["on"+a]=f;return this},setRadialReference:function(a){var y=this.renderer.gradients[this.element.gradient];this.element.radialReference=a;y&&y.radAttr&&y.animate(this.renderer.getRadialAttr(a,y.radAttr));return this},translate:function(a,f){return this.attr({translateX:a,translateY:f})},invert:function(a){this.inverted=a;this.updateTransform();return this},updateTransform:function(){var a=
	this.translateX||0,f=this.translateY||0,b=this.scaleX,c=this.scaleY,r=this.inverted,d=this.rotation,g=this.matrix,l=this.element;r&&(a+=this.width,f+=this.height);a=["translate("+a+","+f+")"];p(g)&&a.push("matrix("+g.join(",")+")");r?a.push("rotate(90) scale(-1,1)"):d&&a.push("rotate("+d+" "+E(this.rotationOriginX,l.getAttribute("x"),0)+" "+E(this.rotationOriginY,l.getAttribute("y")||0)+")");(p(b)||p(c))&&a.push("scale("+E(b,1)+" "+E(c,1)+")");a.length&&l.setAttribute("transform",a.join(" "))},toFront:function(){var a=
	this.element;a.parentNode.appendChild(a);return this},align:function(a,f,b){var y,c,r,d,l={};c=this.renderer;r=c.alignedObjects;var n,h;if(a){if(this.alignOptions=a,this.alignByTranslate=f,!b||D(b))this.alignTo=y=b||"renderer",g(r,this),r.push(this),b=null}else a=this.alignOptions,f=this.alignByTranslate,y=this.alignTo;b=E(b,c[y],c);y=a.align;c=a.verticalAlign;r=(b.x||0)+(a.x||0);d=(b.y||0)+(a.y||0);"right"===y?n=1:"center"===y&&(n=2);n&&(r+=(b.width-(a.width||0))/n);l[f?"translateX":"x"]=Math.round(r);
	"bottom"===c?h=1:"middle"===c&&(h=2);h&&(d+=(b.height-(a.height||0))/h);l[f?"translateY":"y"]=Math.round(d);this[this.placed?"animate":"attr"](l);this.placed=!0;this.alignAttr=l;return this},getBBox:function(a,f){var y,c=this.renderer,r,d=this.element,l=this.styles,g,n=this.textStr,m,L=c.cache,w=c.cacheKeys,x=d.namespaceURI===this.SVG_NS,B;f=E(f,this.rotation);r=f*h;g=c.styledMode?d&&C.prototype.getStyle.call(d,"font-size"):l&&l.fontSize;p(n)&&(B=n.toString(),-1===B.indexOf("\x3c")&&(B=B.replace(/[0-9]/g,
	"0")),B+=["",f||0,g,this.textWidth,l&&l.textOverflow].join());B&&!a&&(y=L[B]);if(!y){if(x||c.forExport){try{(m=this.fakeTS&&function(a){[].forEach.call(d.querySelectorAll(".highcharts-text-outline"),function(y){y.style.display=a})})&&m("none"),y=d.getBBox?b({},d.getBBox()):{width:d.offsetWidth,height:d.offsetHeight},m&&m("")}catch(Z){}if(!y||0>y.width)y={width:0,height:0}}else y=this.htmlGetBBox();c.isSVG&&(a=y.width,c=y.height,x&&(y.height=c={"11px,17":14,"13px,20":16}[l&&l.fontSize+","+Math.round(c)]||
	c),f&&(y.width=Math.abs(c*Math.sin(r))+Math.abs(a*Math.cos(r)),y.height=Math.abs(c*Math.cos(r))+Math.abs(a*Math.sin(r))));if(B&&0<y.height){for(;250<w.length;)delete L[w.shift()];L[B]||w.push(B);L[B]=y}}return y},show:function(a){return this.attr({visibility:a?"inherit":"visible"})},hide:function(){return this.attr({visibility:"hidden"})},fadeOut:function(a){var y=this;y.animate({opacity:0},{duration:a||150,complete:function(){y.attr({y:-9999})}})},add:function(a){var y=this.renderer,f=this.element,
	b;a&&(this.parentGroup=a);this.parentInverted=a&&a.inverted;void 0!==this.textStr&&y.buildText(this);this.added=!0;if(!a||a.handleZ||this.zIndex)b=this.zIndexSetter();b||(a?a.element:y.box).appendChild(f);if(this.onAdd)this.onAdd();return this},safeRemoveChild:function(a){var y=a.parentNode;y&&y.removeChild(a)},destroy:function(){var a=this,f=a.element||{},b=a.renderer,c=b.isSVG&&"SPAN"===f.nodeName&&a.parentGroup,r=f.ownerSVGElement,d=a.clipPath;f.onclick=f.onmouseout=f.onmouseover=f.onmousemove=
	f.point=null;N(a);d&&r&&([].forEach.call(r.querySelectorAll("[clip-path],[CLIP-PATH]"),function(a){-1<a.getAttribute("clip-path").indexOf(d.element.id)&&a.removeAttribute("clip-path")}),a.clipPath=d.destroy());if(a.stops){for(r=0;r<a.stops.length;r++)a.stops[r]=a.stops[r].destroy();a.stops=null}a.safeRemoveChild(f);for(b.styledMode||a.destroyShadows();c&&c.div&&0===c.div.childNodes.length;)f=c.parentGroup,a.safeRemoveChild(c.div),delete c.div,c=f;a.alignTo&&g(b.alignedObjects,a);B(a,function(f,y){delete a[y]});
	return null},shadow:function(a,f,b){var y=[],c,r,d=this.element,l,g,n,h;if(!a)this.destroyShadows();else if(!this.shadows){g=E(a.width,3);n=(a.opacity||.15)/g;h=this.parentInverted?"(-1,-1)":"("+E(a.offsetX,1)+", "+E(a.offsetY,1)+")";for(c=1;c<=g;c++)r=d.cloneNode(0),l=2*g+1-2*c,e(r,{stroke:a.color||"#000000","stroke-opacity":n*c,"stroke-width":l,transform:"translate"+h,fill:"none"}),r.setAttribute("class",(r.getAttribute("class")||"")+" highcharts-shadow"),b&&(e(r,"height",Math.max(e(r,"height")-
	l,0)),r.cutHeight=l),f?f.element.appendChild(r):d.parentNode&&d.parentNode.insertBefore(r,d),y.push(r);this.shadows=y}return this},destroyShadows:function(){(this.shadows||[]).forEach(function(a){this.safeRemoveChild(a)},this);this.shadows=void 0},xGetter:function(a){"circle"===this.element.nodeName&&("x"===a?a="cx":"y"===a&&(a="cy"));return this._defaultGetter(a)},_defaultGetter:function(a){a=E(this[a+"Value"],this[a],this.element?this.element.getAttribute(a):null,0);/^[\-0-9\.]+$/.test(a)&&(a=parseFloat(a));
	return a},dSetter:function(a,f,b){a&&a.join&&(a=a.join(" "));/(NaN| {2}|^$)/.test(a)&&(a="M 0 0");this[f]!==a&&(b.setAttribute(f,a),this[f]=a)},dashstyleSetter:function(a){var f,y=this["stroke-width"];"inherit"===y&&(y=1);if(a=a&&a.toLowerCase()){a=a.replace("shortdashdotdot","3,1,1,1,1,1,").replace("shortdashdot","3,1,1,1").replace("shortdot","1,1,").replace("shortdash","3,1,").replace("longdash","8,3,").replace(/dot/g,"1,3,").replace("dash","4,3,").replace(/,$/,"").split(",");for(f=a.length;f--;)a[f]=
	H(a[f])*y;a=a.join(",").replace(/NaN/g,"none");this.element.setAttribute("stroke-dasharray",a)}},alignSetter:function(a){var f={left:"start",center:"middle",right:"end"};f[a]&&(this.alignValue=a,this.element.setAttribute("text-anchor",f[a]))},opacitySetter:function(a,f,b){this[f]=a;b.setAttribute(f,a)},titleSetter:function(a){var f=this.element.getElementsByTagName("title")[0];f||(f=m.createElementNS(this.SVG_NS,"title"),this.element.appendChild(f));f.firstChild&&f.removeChild(f.firstChild);f.appendChild(m.createTextNode(String(E(a),
	"").replace(/<[^>]*>/g,"").replace(/&lt;/g,"\x3c").replace(/&gt;/g,"\x3e")))},textSetter:function(a){a!==this.textStr&&(delete this.bBox,this.textStr=a,this.added&&this.renderer.buildText(this))},setTextPath:function(f,b){var y=this.element,c={textAnchor:"text-anchor"},r,d=!1,l,g=this.textPathWrapper,h=!g;b=n(!0,{enabled:!0,attributes:{dy:-5,startOffset:"50%",textAnchor:"middle"}},b);r=b.attributes;if(f&&b&&b.enabled){this.options&&this.options.padding&&(r.dx=-this.options.padding);g||(this.textPathWrapper=
	g=this.renderer.createElement("textPath"),d=!0);l=g.element;(b=f.element.getAttribute("id"))||f.element.setAttribute("id",b=a.uniqueKey());if(h)for(f=y.getElementsByTagName("tspan");f.length;)f[0].setAttribute("y",0),l.appendChild(f[0]);d&&g.add({element:this.text?this.text.element:y});l.setAttributeNS("http://www.w3.org/1999/xlink","href",this.renderer.url+"#"+b);p(r.dy)&&(l.parentNode.setAttribute("dy",r.dy),delete r.dy);p(r.dx)&&(l.parentNode.setAttribute("dx",r.dx),delete r.dx);a.objectEach(r,
	function(a,f){l.setAttribute(c[f]||f,a)});y.removeAttribute("transform");this.removeTextOutline.call(g,[].slice.call(y.getElementsByTagName("tspan")));this.applyTextOutline=this.updateTransform=x}else g&&(delete this.updateTransform,delete this.applyTextOutline,this.destroyTextPath(y,f));return this},destroyTextPath:function(a,f){var y;f.element.setAttribute("id","");for(y=this.textPathWrapper.element.childNodes;y.length;)a.firstChild.appendChild(y[0]);a.firstChild.removeChild(this.textPathWrapper.element);
	delete f.textPathWrapper},fillSetter:function(a,f,b){"string"===typeof a?b.setAttribute(f,a):a&&this.complexColor(a,f,b)},visibilitySetter:function(a,f,b){"inherit"===a?b.removeAttribute(f):this[f]!==a&&b.setAttribute(f,a);this[f]=a},zIndexSetter:function(a,f){var b=this.renderer,y=this.parentGroup,c=(y||b).element||b.box,r,d=this.element,l,g,b=c===b.box;r=this.added;var n;p(a)?(d.setAttribute("data-z-index",a),a=+a,this[f]===a&&(r=!1)):p(this[f])&&d.removeAttribute("data-z-index");this[f]=a;if(r){(a=
	this.zIndex)&&y&&(y.handleZ=!0);f=c.childNodes;for(n=f.length-1;0<=n&&!l;n--)if(y=f[n],r=y.getAttribute("data-z-index"),g=!p(r),y!==d)if(0>a&&g&&!b&&!n)c.insertBefore(d,f[n]),l=!0;else if(H(r)<=a||g&&(!p(a)||0<=a))c.insertBefore(d,f[n+1]||null),l=!0;l||(c.insertBefore(d,f[b?3:0]||null),l=!0)}return l},_defaultSetter:function(a,f,b){b.setAttribute(f,a)}});C.prototype.yGetter=C.prototype.xGetter;C.prototype.translateXSetter=C.prototype.translateYSetter=C.prototype.rotationSetter=C.prototype.verticalAlignSetter=
	C.prototype.rotationOriginXSetter=C.prototype.rotationOriginYSetter=C.prototype.scaleXSetter=C.prototype.scaleYSetter=C.prototype.matrixSetter=function(a,f){this[f]=a;this.doTransform=!0};C.prototype["stroke-widthSetter"]=C.prototype.strokeSetter=function(a,f,b){this[f]=a;this.stroke&&this["stroke-width"]?(C.prototype.fillSetter.call(this,this.stroke,"stroke",b),b.setAttribute("stroke-width",this["stroke-width"]),this.hasStroke=!0):"stroke-width"===f&&0===a&&this.hasStroke&&(b.removeAttribute("stroke"),
	this.hasStroke=!1)};I=a.SVGRenderer=function(){this.init.apply(this,arguments)};b(I.prototype,{Element:C,SVG_NS:L,init:function(a,f,b,c,r,d,l){var y;y=this.createElement("svg").attr({version:"1.1","class":"highcharts-root"});l||y.css(this.getStyle(c));c=y.element;a.appendChild(c);e(a,"dir","ltr");-1===a.innerHTML.indexOf("xmlns")&&e(c,"xmlns",this.SVG_NS);this.isSVG=!0;this.box=c;this.boxWrapper=y;this.alignedObjects=[];this.url=(w||A)&&m.getElementsByTagName("base").length?O.location.href.split("#")[0].replace(/<[^>]*>/g,
	"").replace(/([\('\)])/g,"\\$1").replace(/ /g,"%20"):"";this.createElement("desc").add().element.appendChild(m.createTextNode("Created with Highcharts 7.1.1"));this.defs=this.createElement("defs").add();this.allowHTML=d;this.forExport=r;this.styledMode=l;this.gradients={};this.cache={};this.cacheKeys=[];this.imgCount=0;this.setSize(f,b,!1);var g;w&&a.getBoundingClientRect&&(f=function(){u(a,{left:0,top:0});g=a.getBoundingClientRect();u(a,{left:Math.ceil(g.left)-g.left+"px",top:Math.ceil(g.top)-g.top+
	"px"})},f(),this.unSubPixelFix=F(O,"resize",f))},definition:function(a){function f(a,c){var y;r(a).forEach(function(a){var r=b.createElement(a.tagName),d={};B(a,function(a,f){"tagName"!==f&&"children"!==f&&"textContent"!==f&&(d[f]=a)});r.attr(d);r.add(c||b.defs);a.textContent&&r.element.appendChild(m.createTextNode(a.textContent));f(a.children||[],r);y=r});return y}var b=this;return f(a)},getStyle:function(a){return this.style=b({fontFamily:'"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif',
	fontSize:"12px"},a)},setStyle:function(a){this.boxWrapper.css(this.getStyle(a))},isHidden:function(){return!this.boxWrapper.getBBox().width},destroy:function(){var a=this.defs;this.box=null;this.boxWrapper=this.boxWrapper.destroy();d(this.gradients||{});this.gradients=null;a&&(this.defs=a.destroy());this.unSubPixelFix&&this.unSubPixelFix();return this.alignedObjects=null},createElement:function(a){var f=new this.Element;f.init(this,a);return f},draw:x,getRadialAttr:function(a,f){return{cx:a[0]-a[2]/
	2+f.cx*a[2],cy:a[1]-a[2]/2+f.cy*a[2],r:f.r*a[2]}},truncate:function(a,f,b,c,r,d,l){var y=this,g=a.rotation,n,h=c?1:0,L=(b||c).length,w=L,x=[],B=function(a){f.firstChild&&f.removeChild(f.firstChild);a&&f.appendChild(m.createTextNode(a))},p=function(d,g){g=g||d;if(void 0===x[g])if(f.getSubStringLength)try{x[g]=r+f.getSubStringLength(0,c?g+1:g)}catch(aa){}else y.getSpanWidth&&(B(l(b||c,d)),x[g]=r+y.getSpanWidth(a,f));return x[g]},e,z;a.rotation=0;e=p(f.textContent.length);if(z=r+e>d){for(;h<=L;)w=Math.ceil((h+
	L)/2),c&&(n=l(c,w)),e=p(w,n&&n.length-1),h===L?h=L+1:e>d?L=w-1:h=w;0===L?B(""):b&&L===b.length-1||B(n||l(b||c,w))}c&&c.splice(0,w);a.actualWidth=e;a.rotation=g;return z},escapes:{"\x26":"\x26amp;","\x3c":"\x26lt;","\x3e":"\x26gt;","'":"\x26#39;",'"':"\x26quot;"},buildText:function(a){var f=a.element,b=this,c=b.forExport,r=E(a.textStr,"").toString(),y=-1!==r.indexOf("\x3c"),d=f.childNodes,g,l=e(f,"x"),n=a.styles,h=a.textWidth,w=n&&n.lineHeight,x=n&&n.textOutline,p=n&&"ellipsis"===n.textOverflow,z=
	n&&"nowrap"===n.whiteSpace,N=n&&n.fontSize,P,A,D=d.length,n=h&&!a.added&&this.box,k=function(a){var c;b.styledMode||(c=/(px|em)$/.test(a&&a.style.fontSize)?a.style.fontSize:N||b.style.fontSize||12);return w?H(w):b.fontMetrics(c,a.getAttribute("style")?a:f).h},J=function(a,f){B(b.escapes,function(b,c){f&&-1!==f.indexOf(b)||(a=a.toString().replace(new RegExp(b,"g"),c))});return a},O=function(a,f){var b;b=a.indexOf("\x3c");a=a.substring(b,a.indexOf("\x3e")-b);b=a.indexOf(f+"\x3d");if(-1!==b&&(b=b+f.length+
	1,f=a.charAt(b),'"'===f||"'"===f))return a=a.substring(b+1),a.substring(0,a.indexOf(f))};P=[r,p,z,w,x,N,h].join();if(P!==a.textCache){for(a.textCache=P;D--;)f.removeChild(d[D]);y||x||p||h||-1!==r.indexOf(" ")?(n&&n.appendChild(f),y?(r=b.styledMode?r.replace(/<(b|strong)>/g,'\x3cspan class\x3d"highcharts-strong"\x3e').replace(/<(i|em)>/g,'\x3cspan class\x3d"highcharts-emphasized"\x3e'):r.replace(/<(b|strong)>/g,'\x3cspan style\x3d"font-weight:bold"\x3e').replace(/<(i|em)>/g,'\x3cspan style\x3d"font-style:italic"\x3e'),
	r=r.replace(/<a/g,"\x3cspan").replace(/<\/(b|strong|i|em|a)>/g,"\x3c/span\x3e").split(/<br.*?>/g)):r=[r],r=r.filter(function(a){return""!==a}),r.forEach(function(r,y){var d,n=0,w=0;r=r.replace(/^\s+|\s+$/g,"").replace(/<span/g,"|||\x3cspan").replace(/<\/span>/g,"\x3c/span\x3e|||");d=r.split("|||");d.forEach(function(r){if(""!==r||1===d.length){var x={},B=m.createElementNS(b.SVG_NS,"tspan"),P,E;(P=O(r,"class"))&&e(B,"class",P);if(P=O(r,"style"))P=P.replace(/(;| |^)color([ :])/,"$1fill$2"),e(B,"style",
	P);(E=O(r,"href"))&&!c&&(e(B,"onclick",'location.href\x3d"'+E+'"'),e(B,"class","highcharts-anchor"),b.styledMode||u(B,{cursor:"pointer"}));r=J(r.replace(/<[a-zA-Z\/](.|\n)*?>/g,"")||" ");if(" "!==r){B.appendChild(m.createTextNode(r));n?x.dx=0:y&&null!==l&&(x.x=l);e(B,x);f.appendChild(B);!n&&A&&(!M&&c&&u(B,{display:"block"}),e(B,"dy",k(B)));if(h){var D=r.replace(/([^\^])-/g,"$1- ").split(" "),x=!z&&(1<d.length||y||1<D.length);E=0;var H=k(B);if(p)g=b.truncate(a,B,r,void 0,0,Math.max(0,h-parseInt(N||
	12,10)),function(a,f){return a.substring(0,f)+"\u2026"});else if(x)for(;D.length;)D.length&&!z&&0<E&&(B=m.createElementNS(L,"tspan"),e(B,{dy:H,x:l}),P&&e(B,"style",P),B.appendChild(m.createTextNode(D.join(" ").replace(/- /g,"-"))),f.appendChild(B)),b.truncate(a,B,null,D,0===E?w:0,h,function(a,f){return D.slice(0,f).join(" ").replace(/- /g,"-")}),w=a.actualWidth,E++}n++}}});A=A||f.childNodes.length}),p&&g&&a.attr("title",J(a.textStr,["\x26lt;","\x26gt;"])),n&&n.removeChild(f),x&&a.applyTextOutline&&
	a.applyTextOutline(x)):f.appendChild(m.createTextNode(J(r)))}},getContrast:function(a){a=t(a).rgba;a[0]*=1;a[1]*=1.2;a[2]*=.5;return 459<a[0]+a[1]+a[2]?"#000000":"#FFFFFF"},button:function(a,f,r,c,d,g,l,h,L,w){var y=this.label(a,f,r,L,null,null,w,null,"button"),m=0,B=this.styledMode;y.attr(n({padding:8,r:2},d));if(!B){var x,p,e,M;d=n({fill:"#f7f7f7",stroke:"#cccccc","stroke-width":1,style:{color:"#333333",cursor:"pointer",fontWeight:"normal"}},d);x=d.style;delete d.style;g=n(d,{fill:"#e6e6e6"},g);
	p=g.style;delete g.style;l=n(d,{fill:"#e6ebf5",style:{color:"#000000",fontWeight:"bold"}},l);e=l.style;delete l.style;h=n(d,{style:{color:"#cccccc"}},h);M=h.style;delete h.style}F(y.element,z?"mouseover":"mouseenter",function(){3!==m&&y.setState(1)});F(y.element,z?"mouseout":"mouseleave",function(){3!==m&&y.setState(m)});y.setState=function(a){1!==a&&(y.state=m=a);y.removeClass(/highcharts-button-(normal|hover|pressed|disabled)/).addClass("highcharts-button-"+["normal","hover","pressed","disabled"][a||
	0]);B||y.attr([d,g,l,h][a||0]).css([x,p,e,M][a||0])};B||y.attr(d).css(b({cursor:"default"},x));return y.on("click",function(a){3!==m&&c.call(y,a)})},crispLine:function(a,f){a[1]===a[4]&&(a[1]=a[4]=Math.round(a[1])-f%2/2);a[2]===a[5]&&(a[2]=a[5]=Math.round(a[2])+f%2/2);return a},path:function(a){var f=this.styledMode?{}:{fill:"none"};c(a)?f.d=a:J(a)&&b(f,a);return this.createElement("path").attr(f)},circle:function(a,f,b){a=J(a)?a:void 0===a?{}:{x:a,y:f,r:b};f=this.createElement("circle");f.xSetter=
	f.ySetter=function(a,f,b){b.setAttribute("c"+f,a)};return f.attr(a)},arc:function(a,f,b,r,c,d){J(a)?(r=a,f=r.y,b=r.r,a=r.x):r={innerR:r,start:c,end:d};a=this.symbol("arc",a,f,b,b,r);a.r=b;return a},rect:function(a,f,b,r,c,d){c=J(a)?a.r:c;var g=this.createElement("rect");a=J(a)?a:void 0===a?{}:{x:a,y:f,width:Math.max(b,0),height:Math.max(r,0)};this.styledMode||(void 0!==d&&(a.strokeWidth=d,a=g.crisp(a)),a.fill="none");c&&(a.r=c);g.rSetter=function(a,f,b){g.r=a;e(b,{rx:a,ry:a})};g.rGetter=function(){return g.r};
	return g.attr(a)},setSize:function(a,f,b){var r=this.alignedObjects,c=r.length;this.width=a;this.height=f;for(this.boxWrapper.animate({width:a,height:f},{step:function(){this.attr({viewBox:"0 0 "+this.attr("width")+" "+this.attr("height")})},duration:E(b,!0)?void 0:0});c--;)r[c].align()},g:function(a){var f=this.createElement("g");return a?f.attr({"class":"highcharts-"+a}):f},image:function(a,f,r,c,d,g){var l={preserveAspectRatio:"none"},n,y=function(a,f){a.setAttributeNS?a.setAttributeNS("http://www.w3.org/1999/xlink",
	"href",f):a.setAttribute("hc-svg-href",f)},h=function(f){y(n.element,a);g.call(n,f)};1<arguments.length&&b(l,{x:f,y:r,width:c,height:d});n=this.createElement("image").attr(l);g?(y(n.element,"data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw\x3d\x3d"),l=new O.Image,F(l,"load",h),l.src=a,l.complete&&h({})):y(n.element,a);return n},symbol:function(a,f,r,c,d,g){var l=this,n,y=/^url\((.*?)\)$/,h=y.test(a),L=!h&&(this.symbols[a]?a:"circle"),w=L&&this.symbols[L],B=p(f)&&w&&w.call(this.symbols,
	Math.round(f),Math.round(r),c,d,g),x,e;w?(n=this.path(B),l.styledMode||n.attr("fill","none"),b(n,{symbolName:L,x:f,y:r,width:c,height:d}),g&&b(n,g)):h&&(x=a.match(y)[1],n=this.image(x),n.imgwidth=E(P[x]&&P[x].width,g&&g.width),n.imgheight=E(P[x]&&P[x].height,g&&g.height),e=function(){n.attr({width:n.width,height:n.height})},["width","height"].forEach(function(a){n[a+"Setter"]=function(a,f){var b={},r=this["img"+f],c="width"===f?"translateX":"translateY";this[f]=a;p(r)&&(g&&"within"===g.backgroundSize&&
	this.width&&this.height&&(r=Math.round(r*Math.min(this.width/this.imgwidth,this.height/this.imgheight))),this.element&&this.element.setAttribute(f,r),this.alignByTranslate||(b[c]=((this[f]||0)-r)/2,this.attr(b)))}}),p(f)&&n.attr({x:f,y:r}),n.isImg=!0,p(n.imgwidth)&&p(n.imgheight)?e():(n.attr({width:0,height:0}),v("img",{onload:function(){var a=q[l.chartIndex];0===this.width&&(u(this,{position:"absolute",top:"-999em"}),m.body.appendChild(this));P[x]={width:this.width,height:this.height};n.imgwidth=
	this.width;n.imgheight=this.height;n.element&&e();this.parentNode&&this.parentNode.removeChild(this);l.imgCount--;if(!l.imgCount&&a&&a.onload)a.onload()},src:x}),this.imgCount++));return n},symbols:{circle:function(a,f,b,r){return this.arc(a+b/2,f+r/2,b/2,r/2,{start:.5*Math.PI,end:2.5*Math.PI,open:!1})},square:function(a,f,b,r){return["M",a,f,"L",a+b,f,a+b,f+r,a,f+r,"Z"]},triangle:function(a,f,b,r){return["M",a+b/2,f,"L",a+b,f+r,a,f+r,"Z"]},"triangle-down":function(a,f,b,r){return["M",a,f,"L",a+b,
	f,a+b/2,f+r,"Z"]},diamond:function(a,f,b,r){return["M",a+b/2,f,"L",a+b,f+r/2,a+b/2,f+r,a,f+r/2,"Z"]},arc:function(a,f,b,r,c){var d=c.start,g=c.r||b,l=c.r||r||b,n=c.end-.001;b=c.innerR;r=E(c.open,.001>Math.abs(c.end-c.start-2*Math.PI));var y=Math.cos(d),h=Math.sin(d),L=Math.cos(n),n=Math.sin(n),d=.001>c.end-d-Math.PI?0:1;c=["M",a+g*y,f+l*h,"A",g,l,0,d,E(c.clockwise,1),a+g*L,f+l*n];p(b)&&c.push(r?"M":"L",a+b*L,f+b*n,"A",b,b,0,d,0,a+b*y,f+b*h);c.push(r?"":"Z");return c},callout:function(a,f,b,r,c){var d=
	Math.min(c&&c.r||0,b,r),g=d+6,l=c&&c.anchorX;c=c&&c.anchorY;var n;n=["M",a+d,f,"L",a+b-d,f,"C",a+b,f,a+b,f,a+b,f+d,"L",a+b,f+r-d,"C",a+b,f+r,a+b,f+r,a+b-d,f+r,"L",a+d,f+r,"C",a,f+r,a,f+r,a,f+r-d,"L",a,f+d,"C",a,f,a,f,a+d,f];l&&l>b?c>f+g&&c<f+r-g?n.splice(13,3,"L",a+b,c-6,a+b+6,c,a+b,c+6,a+b,f+r-d):n.splice(13,3,"L",a+b,r/2,l,c,a+b,r/2,a+b,f+r-d):l&&0>l?c>f+g&&c<f+r-g?n.splice(33,3,"L",a,c+6,a-6,c,a,c-6,a,f+d):n.splice(33,3,"L",a,r/2,l,c,a,r/2,a,f+d):c&&c>r&&l>a+g&&l<a+b-g?n.splice(23,3,"L",l+6,f+
	r,l,f+r+6,l-6,f+r,a+d,f+r):c&&0>c&&l>a+g&&l<a+b-g&&n.splice(3,3,"L",l-6,f,l,f-6,l+6,f,b-d,f);return n}},clipRect:function(f,b,r,c){var d=a.uniqueKey()+"-",g=this.createElement("clipPath").attr({id:d}).add(this.defs);f=this.rect(f,b,r,c,0).add(g);f.id=d;f.clipPath=g;f.count=0;return f},text:function(a,f,b,r){var c={};if(r&&(this.allowHTML||!this.forExport))return this.html(a,f,b);c.x=Math.round(f||0);b&&(c.y=Math.round(b));p(a)&&(c.text=a);a=this.createElement("text").attr(c);r||(a.xSetter=function(a,
	f,b){var r=b.getElementsByTagName("tspan"),c,d=b.getAttribute(f),g;for(g=0;g<r.length;g++)c=r[g],c.getAttribute(f)===d&&c.setAttribute(f,a);b.setAttribute(f,a)});return a},fontMetrics:function(a,f){a=!this.styledMode&&/px/.test(a)||!O.getComputedStyle?a||f&&f.style&&f.style.fontSize||this.style&&this.style.fontSize:f&&C.prototype.getStyle.call(f,"font-size");a=/px/.test(a)?H(a):12;f=24>a?a+3:Math.round(1.2*a);return{h:f,b:Math.round(.8*f),f:a}},rotCorr:function(a,f,b){var r=a;f&&b&&(r=Math.max(r*
	Math.cos(f*h),4));return{x:-a/3*Math.sin(f*h),y:r}},label:function(r,c,d,g,l,h,L,w,m){var y=this,B=y.styledMode,x=y.g("button"!==m&&"label"),e=x.text=y.text("",0,0,L).attr({zIndex:1}),z,M,P=0,N=3,E=0,A,D,H,k,J,O={},v,t,q=/^url\((.*?)\)$/.test(g),u=B||q,S=function(){return B?z.strokeWidth()%2/2:(v?parseInt(v,10):0)%2/2},U,R,T;m&&x.addClass("highcharts-"+m);U=function(){var a=e.element.style,f={};M=(void 0===A||void 0===D||J)&&p(e.textStr)&&e.getBBox();x.width=(A||M.width||0)+2*N+E;x.height=(D||M.height||
	0)+2*N;t=N+Math.min(y.fontMetrics(a&&a.fontSize,e).b,M?M.height:Infinity);u&&(z||(x.box=z=y.symbols[g]||q?y.symbol(g):y.rect(),z.addClass(("button"===m?"":"highcharts-label-box")+(m?" highcharts-"+m+"-box":"")),z.add(x),a=S(),f.x=a,f.y=(w?-t:0)+a),f.width=Math.round(x.width),f.height=Math.round(x.height),z.attr(b(f,O)),O={})};R=function(){var a=E+N,f;f=w?0:t;p(A)&&M&&("center"===J||"right"===J)&&(a+={center:.5,right:1}[J]*(A-M.width));if(a!==e.x||f!==e.y)e.attr("x",a),e.hasBoxWidthChanged&&(M=e.getBBox(!0),
	U()),void 0!==f&&e.attr("y",f);e.x=a;e.y=f};T=function(a,f){z?z.attr(a,f):O[a]=f};x.onAdd=function(){e.add(x);x.attr({text:r||0===r?r:"",x:c,y:d});z&&p(l)&&x.attr({anchorX:l,anchorY:h})};x.widthSetter=function(f){A=a.isNumber(f)?f:null};x.heightSetter=function(a){D=a};x["text-alignSetter"]=function(a){J=a};x.paddingSetter=function(a){p(a)&&a!==N&&(N=x.padding=a,R())};x.paddingLeftSetter=function(a){p(a)&&a!==E&&(E=a,R())};x.alignSetter=function(a){a={left:0,center:.5,right:1}[a];a!==P&&(P=a,M&&x.attr({x:H}))};
	x.textSetter=function(a){void 0!==a&&e.attr({text:a});U();R()};x["stroke-widthSetter"]=function(a,f){a&&(u=!0);v=this["stroke-width"]=a;T(f,a)};B?x.rSetter=function(a,f){T(f,a)}:x.strokeSetter=x.fillSetter=x.rSetter=function(a,f){"r"!==f&&("fill"===f&&a&&(u=!0),x[f]=a);T(f,a)};x.anchorXSetter=function(a,f){l=x.anchorX=a;T(f,Math.round(a)-S()-H)};x.anchorYSetter=function(a,f){h=x.anchorY=a;T(f,a-k)};x.xSetter=function(a){x.x=a;P&&(a-=P*((A||M.width)+2*N),x["forceAnimate:x"]=!0);H=Math.round(a);x.attr("translateX",
	H)};x.ySetter=function(a){k=x.y=Math.round(a);x.attr("translateY",k)};var F=x.css;L={css:function(a){if(a){var f={};a=n(a);x.textProps.forEach(function(b){void 0!==a[b]&&(f[b]=a[b],delete a[b])});e.css(f);"width"in f&&U();"fontSize"in f&&(U(),R())}return F.call(x,a)},getBBox:function(){return{width:M.width+2*N,height:M.height+2*N,x:M.x-N,y:M.y-N}},destroy:function(){f(x.element,"mouseenter");f(x.element,"mouseleave");e&&(e=e.destroy());z&&(z=z.destroy());C.prototype.destroy.call(x);x=y=U=R=T=null}};
	B||(L.shadow=function(a){a&&(U(),z&&z.shadow(a));return x});return b(x,L)}});a.Renderer=I});K(G,"parts/Html.js",[G["parts/Globals.js"]],function(a){var C=a.attr,I=a.createElement,F=a.css,k=a.defined,e=a.extend,q=a.isFirefox,t=a.isMS,u=a.isWebKit,v=a.pick,p=a.pInt,h=a.SVGElement,d=a.SVGRenderer,m=a.win;e(h.prototype,{htmlCss:function(a){var b="SPAN"===this.element.tagName&&a&&"width"in a,d=v(b&&a.width,void 0),c;b&&(delete a.width,this.textWidth=d,c=!0);a&&"ellipsis"===a.textOverflow&&(a.whiteSpace=
	"nowrap",a.overflow="hidden");this.styles=e(this.styles,a);F(this.element,a);c&&this.htmlUpdateTransform();return this},htmlGetBBox:function(){var a=this.element;return{x:a.offsetLeft,y:a.offsetTop,width:a.offsetWidth,height:a.offsetHeight}},htmlUpdateTransform:function(){if(this.added){var a=this.renderer,d=this.element,l=this.translateX||0,c=this.translateY||0,h=this.x||0,m=this.y||0,e=this.textAlign||"left",D={left:0,center:.5,right:1}[e],A=this.styles,n=A&&A.whiteSpace;F(d,{marginLeft:l,marginTop:c});
	!a.styledMode&&this.shadows&&this.shadows.forEach(function(a){F(a,{marginLeft:l+1,marginTop:c+1})});this.inverted&&[].forEach.call(d.childNodes,function(b){a.invertChild(b,d)});if("SPAN"===d.tagName){var A=this.rotation,x=this.textWidth&&p(this.textWidth),B=[A,e,d.innerHTML,this.textWidth,this.textAlign].join(),E;(E=x!==this.oldTextWidth)&&!(E=x>this.oldTextWidth)&&((E=this.textPxLength)||(F(d,{width:"",whiteSpace:n||"nowrap"}),E=d.offsetWidth),E=E>x);E&&(/[ \-]/.test(d.textContent||d.innerText)||
	"ellipsis"===d.style.textOverflow)?(F(d,{width:x+"px",display:"block",whiteSpace:n||"normal"}),this.oldTextWidth=x,this.hasBoxWidthChanged=!0):this.hasBoxWidthChanged=!1;B!==this.cTT&&(n=a.fontMetrics(d.style.fontSize,d).b,!k(A)||A===(this.oldRotation||0)&&e===this.oldAlign||this.setSpanRotation(A,D,n),this.getSpanCorrection(!k(A)&&this.textPxLength||d.offsetWidth,n,D,A,e));F(d,{left:h+(this.xCorr||0)+"px",top:m+(this.yCorr||0)+"px"});this.cTT=B;this.oldRotation=A;this.oldAlign=e}}else this.alignOnAdd=
	!0},setSpanRotation:function(a,d,l){var b={},g=this.renderer.getTransformKey();b[g]=b.transform="rotate("+a+"deg)";b[g+(q?"Origin":"-origin")]=b.transformOrigin=100*d+"% "+l+"px";F(this.element,b)},getSpanCorrection:function(a,d,l){this.xCorr=-a*l;this.yCorr=-d}});e(d.prototype,{getTransformKey:function(){return t&&!/Edge/.test(m.navigator.userAgent)?"-ms-transform":u?"-webkit-transform":q?"MozTransform":m.opera?"-o-transform":""},html:function(b,d,l){var c=this.createElement("span"),g=c.element,
	m=c.renderer,p=m.isSVG,D=function(a,b){["opacity","visibility"].forEach(function(c){a[c+"Setter"]=function(d,l,f){var r=a.div?a.div.style:b;h.prototype[c+"Setter"].call(this,d,l,f);r&&(r[l]=d)}});a.addedSetters=!0},A=a.charts[m.chartIndex],A=A&&A.styledMode;c.textSetter=function(a){a!==g.innerHTML&&(delete this.bBox,delete this.oldTextWidth);this.textStr=a;g.innerHTML=v(a,"");c.doTransform=!0};p&&D(c,c.element.style);c.xSetter=c.ySetter=c.alignSetter=c.rotationSetter=function(a,b){"align"===b&&(b=
	"textAlign");c[b]=a;c.doTransform=!0};c.afterSetters=function(){this.doTransform&&(this.htmlUpdateTransform(),this.doTransform=!1)};c.attr({text:b,x:Math.round(d),y:Math.round(l)}).css({position:"absolute"});A||c.css({fontFamily:this.style.fontFamily,fontSize:this.style.fontSize});g.style.whiteSpace="nowrap";c.css=c.htmlCss;p&&(c.add=function(a){var b,d=m.box.parentNode,l=[];if(this.parentGroup=a){if(b=a.div,!b){for(;a;)l.push(a),a=a.parentGroup;l.reverse().forEach(function(a){function f(f,b){a[b]=
	f;"translateX"===b?r.left=f+"px":r.top=f+"px";a.doTransform=!0}var r,g=C(a.element,"class");g&&(g={className:g});b=a.div=a.div||I("div",g,{position:"absolute",left:(a.translateX||0)+"px",top:(a.translateY||0)+"px",display:a.display,opacity:a.opacity,pointerEvents:a.styles&&a.styles.pointerEvents},b||d);r=b.style;e(a,{classSetter:function(a){return function(f){this.element.setAttribute("class",f);a.className=f}}(b),on:function(){l[0].div&&c.on.apply({element:l[0].div},arguments);return a},translateXSetter:f,
	translateYSetter:f});a.addedSetters||D(a)})}}else b=d;b.appendChild(g);c.added=!0;c.alignOnAdd&&c.htmlUpdateTransform();return c});return c}})});K(G,"parts/Time.js",[G["parts/Globals.js"]],function(a){var C=a.defined,I=a.extend,F=a.merge,k=a.pick,e=a.timeUnits,q=a.win;a.Time=function(a){this.update(a,!1)};a.Time.prototype={defaultOptions:{},update:function(a){var e=k(a&&a.useUTC,!0),v=this;this.options=a=F(!0,this.options||{},a);this.Date=a.Date||q.Date||Date;this.timezoneOffset=(this.useUTC=e)&&
	a.timezoneOffset;this.getTimezoneOffset=this.timezoneOffsetFunction();(this.variableTimezone=!(e&&!a.getTimezoneOffset&&!a.timezone))||this.timezoneOffset?(this.get=function(a,h){var d=h.getTime(),m=d-v.getTimezoneOffset(h);h.setTime(m);a=h["getUTC"+a]();h.setTime(d);return a},this.set=function(a,h,d){var m;if("Milliseconds"===a||"Seconds"===a||"Minutes"===a&&0===h.getTimezoneOffset()%60)h["set"+a](d);else m=v.getTimezoneOffset(h),m=h.getTime()-m,h.setTime(m),h["setUTC"+a](d),a=v.getTimezoneOffset(h),
	m=h.getTime()+a,h.setTime(m)}):e?(this.get=function(a,h){return h["getUTC"+a]()},this.set=function(a,h,d){return h["setUTC"+a](d)}):(this.get=function(a,h){return h["get"+a]()},this.set=function(a,h,d){return h["set"+a](d)})},makeTime:function(e,q,v,p,h,d){var m,b,g;this.useUTC?(m=this.Date.UTC.apply(0,arguments),b=this.getTimezoneOffset(m),m+=b,g=this.getTimezoneOffset(m),b!==g?m+=g-b:b-36E5!==this.getTimezoneOffset(m-36E5)||a.isSafari||(m-=36E5)):m=(new this.Date(e,q,k(v,1),k(p,0),k(h,0),k(d,0))).getTime();
	return m},timezoneOffsetFunction:function(){var e=this,k=this.options,v=q.moment;if(!this.useUTC)return function(a){return 6E4*(new Date(a)).getTimezoneOffset()};if(k.timezone){if(v)return function(a){return 6E4*-v.tz(a,k.timezone).utcOffset()};a.error(25)}return this.useUTC&&k.getTimezoneOffset?function(a){return 6E4*k.getTimezoneOffset(a)}:function(){return 6E4*(e.timezoneOffset||0)}},dateFormat:function(e,k,v){if(!a.defined(k)||isNaN(k))return a.defaultOptions.lang.invalidDate||"";e=a.pick(e,"%Y-%m-%d %H:%M:%S");
	var p=this,h=new this.Date(k),d=this.get("Hours",h),m=this.get("Day",h),b=this.get("Date",h),g=this.get("Month",h),l=this.get("FullYear",h),c=a.defaultOptions.lang,w=c.weekdays,z=c.shortWeekdays,J=a.pad,h=a.extend({a:z?z[m]:w[m].substr(0,3),A:w[m],d:J(b),e:J(b,2," "),w:m,b:c.shortMonths[g],B:c.months[g],m:J(g+1),o:g+1,y:l.toString().substr(2,2),Y:l,H:J(d),k:d,I:J(d%12||12),l:d%12||12,M:J(p.get("Minutes",h)),p:12>d?"AM":"PM",P:12>d?"am":"pm",S:J(h.getSeconds()),L:J(Math.floor(k%1E3),3)},a.dateFormats);
	a.objectEach(h,function(a,b){for(;-1!==e.indexOf("%"+b);)e=e.replace("%"+b,"function"===typeof a?a.call(p,k):a)});return v?e.substr(0,1).toUpperCase()+e.substr(1):e},resolveDTLFormat:function(e){return a.isObject(e,!0)?e:(e=a.splat(e),{main:e[0],from:e[1],to:e[2]})},getTimeTicks:function(a,q,v,p){var h=this,d=[],m,b={},g;m=new h.Date(q);var l=a.unitRange,c=a.count||1,w;p=k(p,1);if(C(q)){h.set("Milliseconds",m,l>=e.second?0:c*Math.floor(h.get("Milliseconds",m)/c));l>=e.second&&h.set("Seconds",m,l>=
	e.minute?0:c*Math.floor(h.get("Seconds",m)/c));l>=e.minute&&h.set("Minutes",m,l>=e.hour?0:c*Math.floor(h.get("Minutes",m)/c));l>=e.hour&&h.set("Hours",m,l>=e.day?0:c*Math.floor(h.get("Hours",m)/c));l>=e.day&&h.set("Date",m,l>=e.month?1:Math.max(1,c*Math.floor(h.get("Date",m)/c)));l>=e.month&&(h.set("Month",m,l>=e.year?0:c*Math.floor(h.get("Month",m)/c)),g=h.get("FullYear",m));l>=e.year&&h.set("FullYear",m,g-g%c);l===e.week&&(g=h.get("Day",m),h.set("Date",m,h.get("Date",m)-g+p+(g<p?-7:0)));g=h.get("FullYear",
	m);p=h.get("Month",m);var z=h.get("Date",m),J=h.get("Hours",m);q=m.getTime();h.variableTimezone&&(w=v-q>4*e.month||h.getTimezoneOffset(q)!==h.getTimezoneOffset(v));q=m.getTime();for(m=1;q<v;)d.push(q),q=l===e.year?h.makeTime(g+m*c,0):l===e.month?h.makeTime(g,p+m*c):!w||l!==e.day&&l!==e.week?w&&l===e.hour&&1<c?h.makeTime(g,p,z,J+m*c):q+l*c:h.makeTime(g,p,z+m*c*(l===e.day?1:7)),m++;d.push(q);l<=e.hour&&1E4>d.length&&d.forEach(function(a){0===a%18E5&&"000000000"===h.dateFormat("%H%M%S%L",a)&&(b[a]="day")})}d.info=
	I(a,{higherRanks:b,totalRange:l*c});return d}}});K(G,"parts/Options.js",[G["parts/Globals.js"]],function(a){var C=a.color,I=a.merge;a.defaultOptions={colors:"#7cb5ec #434348 #90ed7d #f7a35c #8085e9 #f15c80 #e4d354 #2b908f #f45b5b #91e8e1".split(" "),symbols:["circle","diamond","square","triangle","triangle-down"],lang:{loading:"Loading...",months:"January February March April May June July August September October November December".split(" "),shortMonths:"Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" "),
	weekdays:"Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "),decimalPoint:".",numericSymbols:"kMGTPE".split(""),resetZoom:"Reset zoom",resetZoomTitle:"Reset zoom level 1:1",thousandsSep:" "},global:{},time:a.Time.prototype.defaultOptions,chart:{styledMode:!1,borderRadius:0,colorCount:10,defaultSeriesType:"line",ignoreHiddenSeries:!0,spacing:[10,10,15,10],resetZoomButton:{theme:{zIndex:6},position:{align:"right",x:-10,y:10}},width:null,height:null,borderColor:"#335cad",backgroundColor:"#ffffff",
	plotBorderColor:"#cccccc"},title:{text:"Chart title",align:"center",margin:15,widthAdjust:-44},subtitle:{text:"",align:"center",widthAdjust:-44},plotOptions:{},labels:{style:{position:"absolute",color:"#333333"}},legend:{enabled:!0,align:"center",alignColumns:!0,layout:"horizontal",labelFormatter:function(){return this.name},borderColor:"#999999",borderRadius:0,navigation:{activeColor:"#003399",inactiveColor:"#cccccc"},itemStyle:{color:"#333333",cursor:"pointer",fontSize:"12px",fontWeight:"bold",
	textOverflow:"ellipsis"},itemHoverStyle:{color:"#000000"},itemHiddenStyle:{color:"#cccccc"},shadow:!1,itemCheckboxStyle:{position:"absolute",width:"13px",height:"13px"},squareSymbol:!0,symbolPadding:5,verticalAlign:"bottom",x:0,y:0,title:{style:{fontWeight:"bold"}}},loading:{labelStyle:{fontWeight:"bold",position:"relative",top:"45%"},style:{position:"absolute",backgroundColor:"#ffffff",opacity:.5,textAlign:"center"}},tooltip:{enabled:!0,animation:a.svg,borderRadius:3,dateTimeLabelFormats:{millisecond:"%A, %b %e, %H:%M:%S.%L",
	second:"%A, %b %e, %H:%M:%S",minute:"%A, %b %e, %H:%M",hour:"%A, %b %e, %H:%M",day:"%A, %b %e, %Y",week:"Week from %A, %b %e, %Y",month:"%B %Y",year:"%Y"},footerFormat:"",padding:8,snap:a.isTouchDevice?25:10,headerFormat:'\x3cspan style\x3d"font-size: 10px"\x3e{point.key}\x3c/span\x3e\x3cbr/\x3e',pointFormat:'\x3cspan style\x3d"color:{point.color}"\x3e\u25cf\x3c/span\x3e {series.name}: \x3cb\x3e{point.y}\x3c/b\x3e\x3cbr/\x3e',backgroundColor:C("#f7f7f7").setOpacity(.85).get(),borderWidth:1,shadow:!0,
	style:{color:"#333333",cursor:"default",fontSize:"12px",pointerEvents:"none",whiteSpace:"nowrap"}},credits:{enabled:!0,href:"https://www.highcharts.com?credits",position:{align:"right",x:-10,verticalAlign:"bottom",y:-5},style:{cursor:"pointer",color:"#999999",fontSize:"9px"},text:"Highcharts.com"}};a.setOptions=function(C){a.defaultOptions=I(!0,a.defaultOptions,C);a.time.update(I(a.defaultOptions.global,a.defaultOptions.time),!1);return a.defaultOptions};a.getOptions=function(){return a.defaultOptions};
	a.defaultPlotOptions=a.defaultOptions.plotOptions;a.time=new a.Time(I(a.defaultOptions.global,a.defaultOptions.time));a.dateFormat=function(C,k,e){return a.time.dateFormat(C,k,e)}});K(G,"parts/Tick.js",[G["parts/Globals.js"]],function(a){var C=a.correctFloat,I=a.defined,F=a.destroyObjectProperties,k=a.fireEvent,e=a.isNumber,q=a.merge,t=a.pick,u=a.deg2rad;a.Tick=function(a,e,h,d,m){this.axis=a;this.pos=e;this.type=h||"";this.isNewLabel=this.isNew=!0;this.parameters=m||{};this.tickmarkOffset=this.parameters.tickmarkOffset;
	this.options=this.parameters.options;h||d||this.addLabel()};a.Tick.prototype={addLabel:function(){var e=this,p=e.axis,h=p.options,d=p.chart,m=p.categories,b=p.names,g=e.pos,l=t(e.options&&e.options.labels,h.labels),c=p.tickPositions,w=g===c[0],z=g===c[c.length-1],m=this.parameters.category||(m?t(m[g],b[g],g):g),k=e.label,c=c.info,D,A,n,x;p.isDatetimeAxis&&c&&(A=d.time.resolveDTLFormat(h.dateTimeLabelFormats[!h.grid&&c.higherRanks[g]||c.unitName]),D=A.main);e.isFirst=w;e.isLast=z;e.formatCtx={axis:p,
	chart:d,isFirst:w,isLast:z,dateTimeLabelFormat:D,tickPositionInfo:c,value:p.isLog?C(p.lin2log(m)):m,pos:g};h=p.labelFormatter.call(e.formatCtx,this.formatCtx);if(x=A&&A.list)e.shortenLabel=function(){for(n=0;n<x.length;n++)if(k.attr({text:p.labelFormatter.call(a.extend(e.formatCtx,{dateTimeLabelFormat:x[n]}))}),k.getBBox().width<p.getSlotWidth(e)-2*t(l.padding,5))return;k.attr({text:""})};if(I(k))k&&k.textStr!==h&&(!k.textWidth||l.style&&l.style.width||k.styles.width||k.css({width:null}),k.attr({text:h}));
	else{if(e.label=k=I(h)&&l.enabled?d.renderer.text(h,0,0,l.useHTML).add(p.labelGroup):null)d.styledMode||k.css(q(l.style)),k.textPxLength=k.getBBox().width;e.rotation=0}},getLabelSize:function(){return this.label?this.label.getBBox()[this.axis.horiz?"height":"width"]:0},handleOverflow:function(a){var e=this.axis,h=e.options.labels,d=a.x,m=e.chart.chartWidth,b=e.chart.spacing,g=t(e.labelLeft,Math.min(e.pos,b[3])),b=t(e.labelRight,Math.max(e.isRadial?0:e.pos+e.len,m-b[1])),l=this.label,c=this.rotation,
	w={left:0,center:.5,right:1}[e.labelAlign||l.attr("align")],z=l.getBBox().width,k=e.getSlotWidth(this),D=k,A=1,n,x={};if(c||"justify"!==t(h.overflow,"justify"))0>c&&d-w*z<g?n=Math.round(d/Math.cos(c*u)-g):0<c&&d+w*z>b&&(n=Math.round((m-d)/Math.cos(c*u)));else if(m=d+(1-w)*z,d-w*z<g?D=a.x+D*(1-w)-g:m>b&&(D=b-a.x+D*w,A=-1),D=Math.min(k,D),D<k&&"center"===e.labelAlign&&(a.x+=A*(k-D-w*(k-Math.min(z,D)))),z>D||e.autoRotation&&(l.styles||{}).width)n=D;n&&(this.shortenLabel?this.shortenLabel():(x.width=
	Math.floor(n),(h.style||{}).textOverflow||(x.textOverflow="ellipsis"),l.css(x)))},getPosition:function(e,p,h,d){var m=this.axis,b=m.chart,g=d&&b.oldChartHeight||b.chartHeight;e={x:e?a.correctFloat(m.translate(p+h,null,null,d)+m.transB):m.left+m.offset+(m.opposite?(d&&b.oldChartWidth||b.chartWidth)-m.right-m.left:0),y:e?g-m.bottom+m.offset-(m.opposite?m.height:0):a.correctFloat(g-m.translate(p+h,null,null,d)-m.transB)};k(this,"afterGetPosition",{pos:e});return e},getLabelPosition:function(a,e,h,d,
	m,b,g,l){var c=this.axis,w=c.transA,z=c.reversed,p=c.staggerLines,D=c.tickRotCorr||{x:0,y:0},A=m.y,n=d||c.reserveSpaceDefault?0:-c.labelOffset*("center"===c.labelAlign?.5:1),x={};I(A)||(A=0===c.side?h.rotation?-8:-h.getBBox().height:2===c.side?D.y+8:Math.cos(h.rotation*u)*(D.y-h.getBBox(!1,0).height/2));a=a+m.x+n+D.x-(b&&d?b*w*(z?-1:1):0);e=e+A-(b&&!d?b*w*(z?1:-1):0);p&&(h=g/(l||1)%p,c.opposite&&(h=p-h-1),e+=c.labelOffset/p*h);x.x=a;x.y=Math.round(e);k(this,"afterGetLabelPosition",{pos:x,tickmarkOffset:b,
	index:g});return x},getMarkPath:function(a,e,h,d,m,b){return b.crispLine(["M",a,e,"L",a+(m?0:-h),e+(m?h:0)],d)},renderGridLine:function(a,e,h){var d=this.axis,m=d.options,b=this.gridLine,g={},l=this.pos,c=this.type,w=t(this.tickmarkOffset,d.tickmarkOffset),z=d.chart.renderer,p=c?c+"Grid":"grid",k=m[p+"LineWidth"],A=m[p+"LineColor"],m=m[p+"LineDashStyle"];b||(d.chart.styledMode||(g.stroke=A,g["stroke-width"]=k,m&&(g.dashstyle=m)),c||(g.zIndex=1),a&&(e=0),this.gridLine=b=z.path().attr(g).addClass("highcharts-"+
	(c?c+"-":"")+"grid-line").add(d.gridGroup));if(b&&(h=d.getPlotLinePath(l+w,b.strokeWidth()*h,a,"pass")))b[a||this.isNew?"attr":"animate"]({d:h,opacity:e})},renderMark:function(a,e,h){var d=this.axis,m=d.options,b=d.chart.renderer,g=this.type,l=g?g+"Tick":"tick",c=d.tickSize(l),w=this.mark,z=!w,p=a.x;a=a.y;var k=t(m[l+"Width"],!g&&d.isXAxis?1:0),m=m[l+"Color"];c&&(d.opposite&&(c[0]=-c[0]),z&&(this.mark=w=b.path().addClass("highcharts-"+(g?g+"-":"")+"tick").add(d.axisGroup),d.chart.styledMode||w.attr({stroke:m,
	"stroke-width":k})),w[z?"attr":"animate"]({d:this.getMarkPath(p,a,c[0],w.strokeWidth()*h,d.horiz,b),opacity:e}))},renderLabel:function(a,p,h,d){var m=this.axis,b=m.horiz,g=m.options,l=this.label,c=g.labels,w=c.step,m=t(this.tickmarkOffset,m.tickmarkOffset),z=!0,k=a.x;a=a.y;l&&e(k)&&(l.xy=a=this.getLabelPosition(k,a,l,b,c,m,d,w),this.isFirst&&!this.isLast&&!t(g.showFirstLabel,1)||this.isLast&&!this.isFirst&&!t(g.showLastLabel,1)?z=!1:!b||c.step||c.rotation||p||0===h||this.handleOverflow(a),w&&d%w&&
	(z=!1),z&&e(a.y)?(a.opacity=h,l[this.isNewLabel?"attr":"animate"](a),this.isNewLabel=!1):(l.attr("y",-9999),this.isNewLabel=!0))},render:function(e,p,h){var d=this.axis,m=d.horiz,b=this.pos,g=t(this.tickmarkOffset,d.tickmarkOffset),b=this.getPosition(m,b,g,p),g=b.x,l=b.y,d=m&&g===d.pos+d.len||!m&&l===d.pos?-1:1;h=t(h,1);this.isActive=!0;this.renderGridLine(p,h,d);this.renderMark(b,h,d);this.renderLabel(b,p,h,e);this.isNew=!1;a.fireEvent(this,"afterRender")},destroy:function(){F(this,this.axis)}}});
	K(G,"parts/Axis.js",[G["parts/Globals.js"]],function(a){var C=a.addEvent,I=a.animObject,F=a.arrayMax,k=a.arrayMin,e=a.color,q=a.correctFloat,t=a.defaultOptions,u=a.defined,v=a.deg2rad,p=a.destroyObjectProperties,h=a.extend,d=a.fireEvent,m=a.format,b=a.getMagnitude,g=a.isArray,l=a.isNumber,c=a.isString,w=a.merge,z=a.normalizeTickInterval,J=a.objectEach,D=a.pick,A=a.removeEvent,n=a.seriesTypes,x=a.splat,B=a.syncTimeout,E=a.Tick,H=function(){this.init.apply(this,arguments)};a.extend(H.prototype,{defaultOptions:{dateTimeLabelFormats:{millisecond:{main:"%H:%M:%S.%L",
	range:!1},second:{main:"%H:%M:%S",range:!1},minute:{main:"%H:%M",range:!1},hour:{main:"%H:%M",range:!1},day:{main:"%e. %b"},week:{main:"%e. %b"},month:{main:"%b '%y"},year:{main:"%Y"}},endOnTick:!1,labels:{enabled:!0,indentation:10,x:0,style:{color:"#666666",cursor:"default",fontSize:"11px"}},maxPadding:.01,minorTickLength:2,minorTickPosition:"outside",minPadding:.01,showEmpty:!0,startOfWeek:1,startOnTick:!1,tickLength:10,tickPixelInterval:100,tickmarkPlacement:"between",tickPosition:"outside",title:{align:"middle",
	style:{color:"#666666"}},type:"linear",minorGridLineColor:"#f2f2f2",minorGridLineWidth:1,minorTickColor:"#999999",lineColor:"#ccd6eb",lineWidth:1,gridLineColor:"#e6e6e6",tickColor:"#ccd6eb"},defaultYAxisOptions:{endOnTick:!0,maxPadding:.05,minPadding:.05,tickPixelInterval:72,showLastLabel:!0,labels:{x:-8},startOnTick:!0,title:{rotation:270,text:"Values"},stackLabels:{allowOverlap:!1,enabled:!1,formatter:function(){return a.numberFormat(this.total,-1)},style:{color:"#000000",fontSize:"11px",fontWeight:"bold",
	textOutline:"1px contrast"}},gridLineWidth:1,lineWidth:0},defaultLeftAxisOptions:{labels:{x:-15},title:{rotation:270}},defaultRightAxisOptions:{labels:{x:15},title:{rotation:90}},defaultBottomAxisOptions:{labels:{autoRotation:[-45],x:0},margin:15,title:{rotation:0}},defaultTopAxisOptions:{labels:{autoRotation:[-45],x:0},margin:15,title:{rotation:0}},init:function(a,b){var f=b.isX,r=this;r.chart=a;r.horiz=a.inverted&&!r.isZAxis?!f:f;r.isXAxis=f;r.coll=r.coll||(f?"xAxis":"yAxis");d(this,"init",{userOptions:b});
	r.opposite=b.opposite;r.side=b.side||(r.horiz?r.opposite?0:2:r.opposite?1:3);r.setOptions(b);var c=this.options,l=c.type;r.labelFormatter=c.labels.formatter||r.defaultLabelFormatter;r.userOptions=b;r.minPixelPadding=0;r.reversed=c.reversed;r.visible=!1!==c.visible;r.zoomEnabled=!1!==c.zoomEnabled;r.hasNames="category"===l||!0===c.categories;r.categories=c.categories||r.hasNames;r.names||(r.names=[],r.names.keys={});r.plotLinesAndBandsGroups={};r.isLog="logarithmic"===l;r.isDatetimeAxis="datetime"===
	l;r.positiveValuesOnly=r.isLog&&!r.allowNegativeLog;r.isLinked=u(c.linkedTo);r.ticks={};r.labelEdge=[];r.minorTicks={};r.plotLinesAndBands=[];r.alternateBands={};r.len=0;r.minRange=r.userMinRange=c.minRange||c.maxZoom;r.range=c.range;r.offset=c.offset||0;r.stacks={};r.oldStacks={};r.stacksTouched=0;r.max=null;r.min=null;r.crosshair=D(c.crosshair,x(a.options.tooltip.crosshairs)[f?0:1],!1);b=r.options.events;-1===a.axes.indexOf(r)&&(f?a.axes.splice(a.xAxis.length,0,r):a.axes.push(r),a[r.coll].push(r));
	r.series=r.series||[];a.inverted&&!r.isZAxis&&f&&void 0===r.reversed&&(r.reversed=!0);J(b,function(a,f){C(r,f,a)});r.lin2log=c.linearToLogConverter||r.lin2log;r.isLog&&(r.val2lin=r.log2lin,r.lin2val=r.lin2log);d(this,"afterInit")},setOptions:function(a){this.options=w(this.defaultOptions,"yAxis"===this.coll&&this.defaultYAxisOptions,[this.defaultTopAxisOptions,this.defaultRightAxisOptions,this.defaultBottomAxisOptions,this.defaultLeftAxisOptions][this.side],w(t[this.coll],a));d(this,"afterSetOptions",
	{userOptions:a})},defaultLabelFormatter:function(){var f=this.axis,b=this.value,c=f.chart.time,d=f.categories,l=this.dateTimeLabelFormat,g=t.lang,n=g.numericSymbols,g=g.numericSymbolMagnitude||1E3,e=n&&n.length,h,x=f.options.labels.format,f=f.isLog?Math.abs(b):f.tickInterval;if(x)h=m(x,this,c);else if(d)h=b;else if(l)h=c.dateFormat(l,b);else if(e&&1E3<=f)for(;e--&&void 0===h;)c=Math.pow(g,e+1),f>=c&&0===10*b%c&&null!==n[e]&&0!==b&&(h=a.numberFormat(b/c,-1)+n[e]);void 0===h&&(h=1E4<=Math.abs(b)?a.numberFormat(b,
	-1):a.numberFormat(b,-1,void 0,""));return h},getSeriesExtremes:function(){var a=this,b=a.chart,c;d(this,"getSeriesExtremes",null,function(){a.hasVisibleSeries=!1;a.dataMin=a.dataMax=a.threshold=null;a.softThreshold=!a.isXAxis;a.buildStacks&&a.buildStacks();a.series.forEach(function(f){if(f.visible||!b.options.chart.ignoreHiddenSeries){var r=f.options,d=r.threshold,g,n;a.hasVisibleSeries=!0;a.positiveValuesOnly&&0>=d&&(d=null);if(a.isXAxis)r=f.xData,r.length&&(c=f.getXExtremes(r),g=c.min,n=c.max,
	l(g)||g instanceof Date||(r=r.filter(l),c=f.getXExtremes(r),g=c.min,n=c.max),r.length&&(a.dataMin=Math.min(D(a.dataMin,g),g),a.dataMax=Math.max(D(a.dataMax,n),n)));else if(f.getExtremes(),n=f.dataMax,g=f.dataMin,u(g)&&u(n)&&(a.dataMin=Math.min(D(a.dataMin,g),g),a.dataMax=Math.max(D(a.dataMax,n),n)),u(d)&&(a.threshold=d),!r.softThreshold||a.positiveValuesOnly)a.softThreshold=!1}})});d(this,"afterGetSeriesExtremes")},translate:function(a,b,c,d,g,n){var f=this.linkedParent||this,r=1,e=0,h=d?f.oldTransA:
	f.transA;d=d?f.oldMin:f.min;var x=f.minPixelPadding;g=(f.isOrdinal||f.isBroken||f.isLog&&g)&&f.lin2val;h||(h=f.transA);c&&(r*=-1,e=f.len);f.reversed&&(r*=-1,e-=r*(f.sector||f.len));b?(a=(a*r+e-x)/h+d,g&&(a=f.lin2val(a))):(g&&(a=f.val2lin(a)),a=l(d)?r*(a-d)*h+e+r*x+(l(n)?h*n:0):void 0);return a},toPixels:function(a,b){return this.translate(a,!1,!this.horiz,null,!0)+(b?0:this.pos)},toValue:function(a,b){return this.translate(a-(b?0:this.pos),!0,!this.horiz,null,!0)},getPlotLinePath:function(a,b,c,g,
	n){var f=this,r=f.chart,e=f.left,h=f.top,x,m,B,w,L=c&&r.oldChartHeight||r.chartHeight,z=c&&r.oldChartWidth||r.chartWidth,p,k=f.transB,A,E=function(a,f,b){if("pass"!==g&&a<f||a>b)g?a=Math.min(Math.max(f,a),b):p=!0;return a};A={value:a,lineWidth:b,old:c,force:g,translatedValue:n};d(this,"getPlotLinePath",A,function(d){n=D(n,f.translate(a,null,null,c));n=Math.min(Math.max(-1E5,n),1E5);x=B=Math.round(n+k);m=w=Math.round(L-n-k);l(n)?f.horiz?(m=h,w=L-f.bottom,x=B=E(x,e,e+f.width)):(x=e,B=z-f.right,m=w=
	E(m,h,h+f.height)):(p=!0,g=!1);d.path=p&&!g?null:r.renderer.crispLine(["M",x,m,"L",B,w],b||1)});return A.path},getLinearTickPositions:function(a,b,c){var f,r=q(Math.floor(b/a)*a);c=q(Math.ceil(c/a)*a);var d=[],g;q(r+a)===r&&(g=20);if(this.single)return[b];for(b=r;b<=c;){d.push(b);b=q(b+a,g);if(b===f)break;f=b}return d},getMinorTickInterval:function(){var a=this.options;return!0===a.minorTicks?D(a.minorTickInterval,"auto"):!1===a.minorTicks?null:a.minorTickInterval},getMinorTickPositions:function(){var a=
	this,b=a.options,c=a.tickPositions,d=a.minorTickInterval,g=[],l=a.pointRangePadding||0,n=a.min-l,l=a.max+l,e=l-n;if(e&&e/d<a.len/3)if(a.isLog)this.paddedTicks.forEach(function(f,b,r){b&&g.push.apply(g,a.getLogTickPositions(d,r[b-1],r[b],!0))});else if(a.isDatetimeAxis&&"auto"===this.getMinorTickInterval())g=g.concat(a.getTimeTicks(a.normalizeTimeTickInterval(d),n,l,b.startOfWeek));else for(b=n+(c[0]-n)%d;b<=l&&b!==g[0];b+=d)g.push(b);0!==g.length&&a.trimTicks(g);return g},adjustForMinRange:function(){var a=
	this.options,b=this.min,c=this.max,d,g,l,n,e,h,x,m;this.isXAxis&&void 0===this.minRange&&!this.isLog&&(u(a.min)||u(a.max)?this.minRange=null:(this.series.forEach(function(a){h=a.xData;for(n=x=a.xIncrement?1:h.length-1;0<n;n--)if(e=h[n]-h[n-1],void 0===l||e<l)l=e}),this.minRange=Math.min(5*l,this.dataMax-this.dataMin)));c-b<this.minRange&&(g=this.dataMax-this.dataMin>=this.minRange,m=this.minRange,d=(m-c+b)/2,d=[b-d,D(a.min,b-d)],g&&(d[2]=this.isLog?this.log2lin(this.dataMin):this.dataMin),b=F(d),
	c=[b+m,D(a.max,b+m)],g&&(c[2]=this.isLog?this.log2lin(this.dataMax):this.dataMax),c=k(c),c-b<m&&(d[0]=c-m,d[1]=D(a.min,c-m),b=F(d)));this.min=b;this.max=c},getClosest:function(){var a;this.categories?a=1:this.series.forEach(function(f){var b=f.closestPointRange,r=f.visible||!f.chart.options.chart.ignoreHiddenSeries;!f.noSharedTooltip&&u(b)&&r&&(a=u(a)?Math.min(a,b):b)});return a},nameToX:function(a){var f=g(this.categories),b=f?this.categories:this.names,c=a.options.x,d;a.series.requireSorting=!1;
	u(c)||(c=!1===this.options.uniqueNames?a.series.autoIncrement():f?b.indexOf(a.name):D(b.keys[a.name],-1));-1===c?f||(d=b.length):d=c;void 0!==d&&(this.names[d]=a.name,this.names.keys[a.name]=d);return d},updateNames:function(){var a=this,b=this.names;0<b.length&&(Object.keys(b.keys).forEach(function(a){delete b.keys[a]}),b.length=0,this.minRange=this.userMinRange,(this.series||[]).forEach(function(f){f.xIncrement=null;if(!f.points||f.isDirtyData)a.max=Math.max(a.max,f.xData.length-1),f.processData(),
	f.generatePoints();f.data.forEach(function(b,c){var r;b&&b.options&&void 0!==b.name&&(r=a.nameToX(b),void 0!==r&&r!==b.x&&(b.x=r,f.xData[c]=r))})}))},setAxisTranslation:function(a){var f=this,b=f.max-f.min,g=f.axisPointRange||0,l,e=0,h=0,x=f.linkedParent,m=!!f.categories,B=f.transA,w=f.isXAxis;if(w||m||g)l=f.getClosest(),x?(e=x.minPointOffset,h=x.pointRangePadding):f.series.forEach(function(a){var b=m?1:w?D(a.options.pointRange,l,0):f.axisPointRange||0,r=a.options.pointPlacement;g=Math.max(g,b);if(!f.single||
	m)a=n.xrange&&a instanceof n.xrange?!w:w,e=Math.max(e,a&&c(r)?0:b/2),h=Math.max(h,a&&"on"===r?0:b)}),x=f.ordinalSlope&&l?f.ordinalSlope/l:1,f.minPointOffset=e*=x,f.pointRangePadding=h*=x,f.pointRange=Math.min(g,b),w&&(f.closestPointRange=l);a&&(f.oldTransA=B);f.translationSlope=f.transA=B=f.staticScale||f.len/(b+h||1);f.transB=f.horiz?f.left:f.bottom;f.minPixelPadding=B*e;d(this,"afterSetAxisTranslation")},minFromRange:function(){return this.max-this.range},setTickInterval:function(f){var c=this,
	g=c.chart,n=c.options,e=c.isLog,h=c.isDatetimeAxis,x=c.isXAxis,m=c.isLinked,B=n.maxPadding,w=n.minPadding,p,k=n.tickInterval,A=n.tickPixelInterval,E=c.categories,H=l(c.threshold)?c.threshold:null,J=c.softThreshold,t,v,C;h||E||m||this.getTickAmount();v=D(c.userMin,n.min);C=D(c.userMax,n.max);m?(c.linkedParent=g[c.coll][n.linkedTo],p=c.linkedParent.getExtremes(),c.min=D(p.min,p.dataMin),c.max=D(p.max,p.dataMax),n.type!==c.linkedParent.options.type&&a.error(11,1,g)):(!J&&u(H)&&(c.dataMin>=H?(p=H,w=0):
	c.dataMax<=H&&(t=H,B=0)),c.min=D(v,p,c.dataMin),c.max=D(C,t,c.dataMax));e&&(c.positiveValuesOnly&&!f&&0>=Math.min(c.min,D(c.dataMin,c.min))&&a.error(10,1,g),c.min=q(c.log2lin(c.min),15),c.max=q(c.log2lin(c.max),15));c.range&&u(c.max)&&(c.userMin=c.min=v=Math.max(c.dataMin,c.minFromRange()),c.userMax=C=c.max,c.range=null);d(c,"foundExtremes");c.beforePadding&&c.beforePadding();c.adjustForMinRange();!(E||c.axisPointRange||c.usePercentage||m)&&u(c.min)&&u(c.max)&&(g=c.max-c.min)&&(!u(v)&&w&&(c.min-=
	g*w),!u(C)&&B&&(c.max+=g*B));l(n.softMin)&&!l(c.userMin)&&n.softMin<c.min&&(c.min=v=n.softMin);l(n.softMax)&&!l(c.userMax)&&n.softMax>c.max&&(c.max=C=n.softMax);l(n.floor)&&(c.min=Math.min(Math.max(c.min,n.floor),Number.MAX_VALUE));l(n.ceiling)&&(c.max=Math.max(Math.min(c.max,n.ceiling),D(c.userMax,-Number.MAX_VALUE)));J&&u(c.dataMin)&&(H=H||0,!u(v)&&c.min<H&&c.dataMin>=H?c.min=c.options.minRange?Math.min(H,c.max-c.minRange):H:!u(C)&&c.max>H&&c.dataMax<=H&&(c.max=c.options.minRange?Math.max(H,c.min+
	c.minRange):H));c.tickInterval=c.min===c.max||void 0===c.min||void 0===c.max?1:m&&!k&&A===c.linkedParent.options.tickPixelInterval?k=c.linkedParent.tickInterval:D(k,this.tickAmount?(c.max-c.min)/Math.max(this.tickAmount-1,1):void 0,E?1:(c.max-c.min)*A/Math.max(c.len,A));x&&!f&&c.series.forEach(function(a){a.processData(c.min!==c.oldMin||c.max!==c.oldMax)});c.setAxisTranslation(!0);c.beforeSetTickPositions&&c.beforeSetTickPositions();c.postProcessTickInterval&&(c.tickInterval=c.postProcessTickInterval(c.tickInterval));
	c.pointRange&&!k&&(c.tickInterval=Math.max(c.pointRange,c.tickInterval));f=D(n.minTickInterval,c.isDatetimeAxis&&c.closestPointRange);!k&&c.tickInterval<f&&(c.tickInterval=f);h||e||k||(c.tickInterval=z(c.tickInterval,null,b(c.tickInterval),D(n.allowDecimals,!(.5<c.tickInterval&&5>c.tickInterval&&1E3<c.max&&9999>c.max)),!!this.tickAmount));this.tickAmount||(c.tickInterval=c.unsquish());this.setTickPositions()},setTickPositions:function(){var f=this.options,c,b=f.tickPositions;c=this.getMinorTickInterval();
	var g=f.tickPositioner,l=f.startOnTick,n=f.endOnTick;this.tickmarkOffset=this.categories&&"between"===f.tickmarkPlacement&&1===this.tickInterval?.5:0;this.minorTickInterval="auto"===c&&this.tickInterval?this.tickInterval/5:c;this.single=this.min===this.max&&u(this.min)&&!this.tickAmount&&(parseInt(this.min,10)===this.min||!1!==f.allowDecimals);this.tickPositions=c=b&&b.slice();!c&&(!this.ordinalPositions&&(this.max-this.min)/this.tickInterval>Math.max(2*this.len,200)?(c=[this.min,this.max],a.error(19,
	!1,this.chart)):c=this.isDatetimeAxis?this.getTimeTicks(this.normalizeTimeTickInterval(this.tickInterval,f.units),this.min,this.max,f.startOfWeek,this.ordinalPositions,this.closestPointRange,!0):this.isLog?this.getLogTickPositions(this.tickInterval,this.min,this.max):this.getLinearTickPositions(this.tickInterval,this.min,this.max),c.length>this.len&&(c=[c[0],c.pop()],c[0]===c[1]&&(c.length=1)),this.tickPositions=c,g&&(g=g.apply(this,[this.min,this.max])))&&(this.tickPositions=c=g);this.paddedTicks=
	c.slice(0);this.trimTicks(c,l,n);this.isLinked||(this.single&&2>c.length&&!this.categories&&(this.min-=.5,this.max+=.5),b||g||this.adjustTickAmount());d(this,"afterSetTickPositions")},trimTicks:function(a,c,b){var f=a[0],g=a[a.length-1],l=this.minPointOffset||0;d(this,"trimTicks");if(!this.isLinked){if(c&&-Infinity!==f)this.min=f;else for(;this.min-l>a[0];)a.shift();if(b)this.max=g;else for(;this.max+l<a[a.length-1];)a.pop();0===a.length&&u(f)&&!this.options.tickPositions&&a.push((g+f)/2)}},alignToOthers:function(){var a=
	{},c,b=this.options;!1===this.chart.options.chart.alignTicks||!1===b.alignTicks||!1===b.startOnTick||!1===b.endOnTick||this.isLog||this.chart[this.coll].forEach(function(f){var b=f.options,b=[f.horiz?b.left:b.top,b.width,b.height,b.pane].join();f.series.length&&(a[b]?c=!0:a[b]=1)});return c},getTickAmount:function(){var a=this.options,c=a.tickAmount,b=a.tickPixelInterval;!u(a.tickInterval)&&this.len<b&&!this.isRadial&&!this.isLog&&a.startOnTick&&a.endOnTick&&(c=2);!c&&this.alignToOthers()&&(c=Math.ceil(this.len/
	b)+1);4>c&&(this.finalTickAmt=c,c=5);this.tickAmount=c},adjustTickAmount:function(){var a=this.options,c=this.tickInterval,b=this.tickPositions,d=this.tickAmount,g=this.finalTickAmt,l=b&&b.length,n=D(this.threshold,this.softThreshold?0:null),e;if(this.hasData()){if(l<d){for(e=this.min;b.length<d;)b.length%2||e===n?b.push(q(b[b.length-1]+c)):b.unshift(q(b[0]-c));this.transA*=(l-1)/(d-1);this.min=a.startOnTick?b[0]:Math.min(this.min,b[0]);this.max=a.endOnTick?b[b.length-1]:Math.max(this.max,b[b.length-
	1])}else l>d&&(this.tickInterval*=2,this.setTickPositions());if(u(g)){for(c=a=b.length;c--;)(3===g&&1===c%2||2>=g&&0<c&&c<a-1)&&b.splice(c,1);this.finalTickAmt=void 0}}},setScale:function(){var a=this.series.some(function(a){return a.isDirtyData||a.isDirty||a.xAxis.isDirty}),c;this.oldMin=this.min;this.oldMax=this.max;this.oldAxisLength=this.len;this.setAxisSize();(c=this.len!==this.oldAxisLength)||a||this.isLinked||this.forceRedraw||this.userMin!==this.oldUserMin||this.userMax!==this.oldUserMax||
	this.alignToOthers()?(this.resetStacks&&this.resetStacks(),this.forceRedraw=!1,this.getSeriesExtremes(),this.setTickInterval(),this.oldUserMin=this.userMin,this.oldUserMax=this.userMax,this.isDirty||(this.isDirty=c||this.min!==this.oldMin||this.max!==this.oldMax)):this.cleanStacks&&this.cleanStacks();d(this,"afterSetScale")},setExtremes:function(a,c,b,g,l){var f=this,n=f.chart;b=D(b,!0);f.series.forEach(function(a){delete a.kdTree});l=h(l,{min:a,max:c});d(f,"setExtremes",l,function(){f.userMin=a;
	f.userMax=c;f.eventArgs=l;b&&n.redraw(g)})},zoom:function(a,c){var f=this.dataMin,b=this.dataMax,g=this.options,l=Math.min(f,D(g.min,f)),n=Math.max(b,D(g.max,b));a={newMin:a,newMax:c};d(this,"zoom",a,function(a){var c=a.newMin,d=a.newMax;if(c!==this.min||d!==this.max)this.allowZoomOutside||(u(f)&&(c<l&&(c=l),c>n&&(c=n)),u(b)&&(d<l&&(d=l),d>n&&(d=n))),this.displayBtn=void 0!==c||void 0!==d,this.setExtremes(c,d,!1,void 0,{trigger:"zoom"});a.zoomed=!0});return a.zoomed},setAxisSize:function(){var f=
	this.chart,c=this.options,b=c.offsets||[0,0,0,0],d=this.horiz,g=this.width=Math.round(a.relativeLength(D(c.width,f.plotWidth-b[3]+b[1]),f.plotWidth)),l=this.height=Math.round(a.relativeLength(D(c.height,f.plotHeight-b[0]+b[2]),f.plotHeight)),n=this.top=Math.round(a.relativeLength(D(c.top,f.plotTop+b[0]),f.plotHeight,f.plotTop)),c=this.left=Math.round(a.relativeLength(D(c.left,f.plotLeft+b[3]),f.plotWidth,f.plotLeft));this.bottom=f.chartHeight-l-n;this.right=f.chartWidth-g-c;this.len=Math.max(d?g:
	l,0);this.pos=d?c:n},getExtremes:function(){var a=this.isLog;return{min:a?q(this.lin2log(this.min)):this.min,max:a?q(this.lin2log(this.max)):this.max,dataMin:this.dataMin,dataMax:this.dataMax,userMin:this.userMin,userMax:this.userMax}},getThreshold:function(a){var f=this.isLog,c=f?this.lin2log(this.min):this.min,f=f?this.lin2log(this.max):this.max;null===a||-Infinity===a?a=c:Infinity===a?a=f:c>a?a=c:f<a&&(a=f);return this.translate(a,0,1,0,1)},autoLabelAlign:function(a){var f=(D(a,0)-90*this.side+
	720)%360;a={align:"center"};d(this,"autoLabelAlign",a,function(a){15<f&&165>f?a.align="right":195<f&&345>f&&(a.align="left")});return a.align},tickSize:function(a){var f=this.options,c=f[a+"Length"],b=D(f[a+"Width"],"tick"===a&&this.isXAxis&&!this.categories?1:0),g;b&&c&&("inside"===f[a+"Position"]&&(c=-c),g=[c,b]);a={tickSize:g};d(this,"afterTickSize",a);return a.tickSize},labelMetrics:function(){var a=this.tickPositions&&this.tickPositions[0]||0;return this.chart.renderer.fontMetrics(this.options.labels.style&&
	this.options.labels.style.fontSize,this.ticks[a]&&this.ticks[a].label)},unsquish:function(){var a=this.options.labels,c=this.horiz,b=this.tickInterval,d=b,g=this.len/(((this.categories?1:0)+this.max-this.min)/b),l,n=a.rotation,e=this.labelMetrics(),h,x=Number.MAX_VALUE,m,B=this.max-this.min,w=function(a){var f=a/(g||1),f=1<f?Math.ceil(f):1;f*b>B&&Infinity!==a&&Infinity!==g&&(f=Math.ceil(B/b));return q(f*b)};c?(m=!a.staggerLines&&!a.step&&(u(n)?[n]:g<D(a.autoRotationLimit,80)&&a.autoRotation))&&m.forEach(function(a){var f;
	if(a===n||a&&-90<=a&&90>=a)h=w(Math.abs(e.h/Math.sin(v*a))),f=h+Math.abs(a/360),f<x&&(x=f,l=a,d=h)}):a.step||(d=w(e.h));this.autoRotation=m;this.labelRotation=D(l,n);return d},getSlotWidth:function(a){var f=this.chart,c=this.horiz,b=this.options.labels,d=Math.max(this.tickPositions.length-(this.categories?0:1),1),g=f.margin[3];return a&&a.slotWidth||c&&2>(b.step||0)&&!b.rotation&&(this.staggerLines||1)*this.len/d||!c&&(b.style&&parseInt(b.style.width,10)||g&&g-f.spacing[3]||.33*f.chartWidth)},renderUnsquish:function(){var a=
	this.chart,b=a.renderer,d=this.tickPositions,g=this.ticks,l=this.options.labels,n=l&&l.style||{},e=this.horiz,h=this.getSlotWidth(),x=Math.max(1,Math.round(h-2*(l.padding||5))),m={},B=this.labelMetrics(),w=l.style&&l.style.textOverflow,z,p,k=0,A;c(l.rotation)||(m.rotation=l.rotation||0);d.forEach(function(a){(a=g[a])&&a.label&&a.label.textPxLength>k&&(k=a.label.textPxLength)});this.maxLabelLength=k;if(this.autoRotation)k>x&&k>B.h?m.rotation=this.labelRotation:this.labelRotation=0;else if(h&&(z=x,
	!w))for(p="clip",x=d.length;!e&&x--;)if(A=d[x],A=g[A].label)A.styles&&"ellipsis"===A.styles.textOverflow?A.css({textOverflow:"clip"}):A.textPxLength>h&&A.css({width:h+"px"}),A.getBBox().height>this.len/d.length-(B.h-B.f)&&(A.specificTextOverflow="ellipsis");m.rotation&&(z=k>.5*a.chartHeight?.33*a.chartHeight:k,w||(p="ellipsis"));if(this.labelAlign=l.align||this.autoLabelAlign(this.labelRotation))m.align=this.labelAlign;d.forEach(function(a){var f=(a=g[a])&&a.label,c=n.width,b={};f&&(f.attr(m),a.shortenLabel?
	a.shortenLabel():z&&!c&&"nowrap"!==n.whiteSpace&&(z<f.textPxLength||"SPAN"===f.element.tagName)?(b.width=z,w||(b.textOverflow=f.specificTextOverflow||p),f.css(b)):f.styles&&f.styles.width&&!b.width&&!c&&f.css({width:null}),delete f.specificTextOverflow,a.rotation=m.rotation)},this);this.tickRotCorr=b.rotCorr(B.b,this.labelRotation||0,0!==this.side)},hasData:function(){return this.series.some(function(a){return a.hasData()})||this.options.showEmpty&&u(this.min)&&u(this.max)},addTitle:function(a){var f=
	this.chart.renderer,c=this.horiz,b=this.opposite,d=this.options.title,g,l=this.chart.styledMode;this.axisTitle||((g=d.textAlign)||(g=(c?{low:"left",middle:"center",high:"right"}:{low:b?"right":"left",middle:"center",high:b?"left":"right"})[d.align]),this.axisTitle=f.text(d.text,0,0,d.useHTML).attr({zIndex:7,rotation:d.rotation||0,align:g}).addClass("highcharts-axis-title"),l||this.axisTitle.css(w(d.style)),this.axisTitle.add(this.axisGroup),this.axisTitle.isNew=!0);l||d.style.width||this.isRadial||
	this.axisTitle.css({width:this.len});this.axisTitle[a?"show":"hide"](!0)},generateTick:function(a){var f=this.ticks;f[a]?f[a].addLabel():f[a]=new E(this,a)},getOffset:function(){var a=this,c=a.chart,b=c.renderer,g=a.options,l=a.tickPositions,n=a.ticks,e=a.horiz,h=a.side,x=c.inverted&&!a.isZAxis?[1,0,3,2][h]:h,m,B,w=0,z,p=0,k=g.title,A=g.labels,E=0,H=c.axisOffset,c=c.clipOffset,q=[-1,1,1,-1][h],t=g.className,v=a.axisParent;m=a.hasData();a.showAxis=B=m||D(g.showEmpty,!0);a.staggerLines=a.horiz&&A.staggerLines;
	a.axisGroup||(a.gridGroup=b.g("grid").attr({zIndex:g.gridZIndex||1}).addClass("highcharts-"+this.coll.toLowerCase()+"-grid "+(t||"")).add(v),a.axisGroup=b.g("axis").attr({zIndex:g.zIndex||2}).addClass("highcharts-"+this.coll.toLowerCase()+" "+(t||"")).add(v),a.labelGroup=b.g("axis-labels").attr({zIndex:A.zIndex||7}).addClass("highcharts-"+a.coll.toLowerCase()+"-labels "+(t||"")).add(v));m||a.isLinked?(l.forEach(function(c,b){a.generateTick(c,b)}),a.renderUnsquish(),a.reserveSpaceDefault=0===h||2===
	h||{1:"left",3:"right"}[h]===a.labelAlign,D(A.reserveSpace,"center"===a.labelAlign?!0:null,a.reserveSpaceDefault)&&l.forEach(function(a){E=Math.max(n[a].getLabelSize(),E)}),a.staggerLines&&(E*=a.staggerLines),a.labelOffset=E*(a.opposite?-1:1)):J(n,function(a,c){a.destroy();delete n[c]});k&&k.text&&!1!==k.enabled&&(a.addTitle(B),B&&!1!==k.reserveSpace&&(a.titleOffset=w=a.axisTitle.getBBox()[e?"height":"width"],z=k.offset,p=u(z)?0:D(k.margin,e?5:10)));a.renderLine();a.offset=q*D(g.offset,H[h]?H[h]+
	(g.margin||0):0);a.tickRotCorr=a.tickRotCorr||{x:0,y:0};b=0===h?-a.labelMetrics().h:2===h?a.tickRotCorr.y:0;p=Math.abs(E)+p;E&&(p=p-b+q*(e?D(A.y,a.tickRotCorr.y+8*q):A.x));a.axisTitleMargin=D(z,p);a.getMaxLabelDimensions&&(a.maxLabelDimensions=a.getMaxLabelDimensions(n,l));e=this.tickSize("tick");H[h]=Math.max(H[h],a.axisTitleMargin+w+q*a.offset,p,l&&l.length&&e?e[0]+q*a.offset:0);g=g.offset?0:2*Math.floor(a.axisLine.strokeWidth()/2);c[x]=Math.max(c[x],g);d(this,"afterGetOffset")},getLinePath:function(a){var c=
	this.chart,b=this.opposite,f=this.offset,d=this.horiz,g=this.left+(b?this.width:0)+f,f=c.chartHeight-this.bottom-(b?this.height:0)+f;b&&(a*=-1);return c.renderer.crispLine(["M",d?this.left:g,d?f:this.top,"L",d?c.chartWidth-this.right:g,d?f:c.chartHeight-this.bottom],a)},renderLine:function(){this.axisLine||(this.axisLine=this.chart.renderer.path().addClass("highcharts-axis-line").add(this.axisGroup),this.chart.styledMode||this.axisLine.attr({stroke:this.options.lineColor,"stroke-width":this.options.lineWidth,
	zIndex:7}))},getTitlePosition:function(){var a=this.horiz,c=this.left,b=this.top,g=this.len,l=this.options.title,n=a?c:b,e=this.opposite,h=this.offset,x=l.x||0,m=l.y||0,B=this.axisTitle,w=this.chart.renderer.fontMetrics(l.style&&l.style.fontSize,B),B=Math.max(B.getBBox(null,0).height-w.h-1,0),g={low:n+(a?0:g),middle:n+g/2,high:n+(a?g:0)}[l.align],c=(a?b+this.height:c)+(a?1:-1)*(e?-1:1)*this.axisTitleMargin+[-B,B,w.f,-B][this.side],a={x:a?g+x:c+(e?this.width:0)+h+x,y:a?c+m-(e?this.height:0)+h:g+m};
	d(this,"afterGetTitlePosition",{titlePosition:a});return a},renderMinorTick:function(a){var c=this.chart.hasRendered&&l(this.oldMin),b=this.minorTicks;b[a]||(b[a]=new E(this,a,"minor"));c&&b[a].isNew&&b[a].render(null,!0);b[a].render(null,!1,1)},renderTick:function(a,c){var b=this.isLinked,f=this.ticks,d=this.chart.hasRendered&&l(this.oldMin);if(!b||a>=this.min&&a<=this.max)f[a]||(f[a]=new E(this,a)),d&&f[a].isNew&&f[a].render(c,!0,-1),f[a].render(c)},render:function(){var c=this,b=c.chart,g=c.options,
	n=c.isLog,e=c.isLinked,h=c.tickPositions,x=c.axisTitle,m=c.ticks,w=c.minorTicks,z=c.alternateBands,p=g.stackLabels,k=g.alternateGridColor,A=c.tickmarkOffset,H=c.axisLine,D=c.showAxis,q=I(b.renderer.globalAnimation),t,v;c.labelEdge.length=0;c.overlap=!1;[m,w,z].forEach(function(a){J(a,function(a){a.isActive=!1})});if(c.hasData()||e)c.minorTickInterval&&!c.categories&&c.getMinorTickPositions().forEach(function(a){c.renderMinorTick(a)}),h.length&&(h.forEach(function(a,b){c.renderTick(a,b)}),A&&(0===
	c.min||c.single)&&(m[-1]||(m[-1]=new E(c,-1,null,!0)),m[-1].render(-1))),k&&h.forEach(function(f,d){v=void 0!==h[d+1]?h[d+1]+A:c.max-A;0===d%2&&f<c.max&&v<=c.max+(b.polar?-A:A)&&(z[f]||(z[f]=new a.PlotLineOrBand(c)),t=f+A,z[f].options={from:n?c.lin2log(t):t,to:n?c.lin2log(v):v,color:k},z[f].render(),z[f].isActive=!0)}),c._addedPlotLB||((g.plotLines||[]).concat(g.plotBands||[]).forEach(function(a){c.addPlotBandOrLine(a)}),c._addedPlotLB=!0);[m,w,z].forEach(function(a){var c,f=[],d=q.duration;J(a,function(a,
	c){a.isActive||(a.render(c,!1,0),a.isActive=!1,f.push(c))});B(function(){for(c=f.length;c--;)a[f[c]]&&!a[f[c]].isActive&&(a[f[c]].destroy(),delete a[f[c]])},a!==z&&b.hasRendered&&d?d:0)});H&&(H[H.isPlaced?"animate":"attr"]({d:this.getLinePath(H.strokeWidth())}),H.isPlaced=!0,H[D?"show":"hide"](!0));x&&D&&(g=c.getTitlePosition(),l(g.y)?(x[x.isNew?"attr":"animate"](g),x.isNew=!1):(x.attr("y",-9999),x.isNew=!0));p&&p.enabled&&c.renderStackTotals();c.isDirty=!1;d(this,"afterRender")},redraw:function(){this.visible&&
	(this.render(),this.plotLinesAndBands.forEach(function(a){a.render()}));this.series.forEach(function(a){a.isDirty=!0})},keepProps:"extKey hcEvents names series userMax userMin".split(" "),destroy:function(a){var c=this,b=c.stacks,f=c.plotLinesAndBands,g;d(this,"destroy",{keepEvents:a});a||A(c);J(b,function(a,c){p(a);b[c]=null});[c.ticks,c.minorTicks,c.alternateBands].forEach(function(a){p(a)});if(f)for(a=f.length;a--;)f[a].destroy();"stackTotalGroup axisLine axisTitle axisGroup gridGroup labelGroup cross scrollbar".split(" ").forEach(function(a){c[a]&&
	(c[a]=c[a].destroy())});for(g in c.plotLinesAndBandsGroups)c.plotLinesAndBandsGroups[g]=c.plotLinesAndBandsGroups[g].destroy();J(c,function(a,b){-1===c.keepProps.indexOf(b)&&delete c[b]})},drawCrosshair:function(a,c){var b,f=this.crosshair,g=D(f.snap,!0),l,n=this.cross;d(this,"drawCrosshair",{e:a,point:c});a||(a=this.cross&&this.cross.e);if(this.crosshair&&!1!==(u(c)||!g)){g?u(c)&&(l=D(c.crosshairPos,this.isXAxis?c.plotX:this.len-c.plotY)):l=a&&(this.horiz?a.chartX-this.pos:this.len-a.chartY+this.pos);
	u(l)&&(b=this.getPlotLinePath(c&&(this.isXAxis?c.x:D(c.stackY,c.y)),null,null,null,l)||null);if(!u(b)){this.hideCrosshair();return}g=this.categories&&!this.isRadial;n||(this.cross=n=this.chart.renderer.path().addClass("highcharts-crosshair highcharts-crosshair-"+(g?"category ":"thin ")+f.className).attr({zIndex:D(f.zIndex,2)}).add(),this.chart.styledMode||(n.attr({stroke:f.color||(g?e("#ccd6eb").setOpacity(.25).get():"#cccccc"),"stroke-width":D(f.width,1)}).css({"pointer-events":"none"}),f.dashStyle&&
	n.attr({dashstyle:f.dashStyle})));n.show().attr({d:b});g&&!f.width&&n.attr({"stroke-width":this.transA});this.cross.e=a}else this.hideCrosshair();d(this,"afterDrawCrosshair",{e:a,point:c})},hideCrosshair:function(){this.cross&&this.cross.hide();d(this,"afterHideCrosshair")}});return a.Axis=H});K(G,"parts/DateTimeAxis.js",[G["parts/Globals.js"]],function(a){var C=a.Axis,I=a.getMagnitude,F=a.normalizeTickInterval,k=a.timeUnits;C.prototype.getTimeTicks=function(){return this.chart.time.getTimeTicks.apply(this.chart.time,
	arguments)};C.prototype.normalizeTimeTickInterval=function(a,q){var e=q||[["millisecond",[1,2,5,10,20,25,50,100,200,500]],["second",[1,2,5,10,15,30]],["minute",[1,2,5,10,15,30]],["hour",[1,2,3,4,6,8,12]],["day",[1,2]],["week",[1,2]],["month",[1,2,3,4,6]],["year",null]];q=e[e.length-1];var u=k[q[0]],v=q[1],p;for(p=0;p<e.length&&!(q=e[p],u=k[q[0]],v=q[1],e[p+1]&&a<=(u*v[v.length-1]+k[e[p+1][0]])/2);p++);u===k.year&&a<5*u&&(v=[1,2,5]);a=F(a/u,v,"year"===q[0]?Math.max(I(a/u),1):1);return{unitRange:u,
	count:a,unitName:q[0]}}});K(G,"parts/LogarithmicAxis.js",[G["parts/Globals.js"]],function(a){var C=a.Axis,I=a.getMagnitude,F=a.normalizeTickInterval,k=a.pick;C.prototype.getLogTickPositions=function(a,q,t,u){var e=this.options,p=this.len,h=[];u||(this._minorAutoInterval=null);if(.5<=a)a=Math.round(a),h=this.getLinearTickPositions(a,q,t);else if(.08<=a)for(var p=Math.floor(q),d,m,b,g,l,e=.3<a?[1,2,4]:.15<a?[1,2,4,6,8]:[1,2,3,4,5,6,7,8,9];p<t+1&&!l;p++)for(m=e.length,d=0;d<m&&!l;d++)b=this.log2lin(this.lin2log(p)*
	e[d]),b>q&&(!u||g<=t)&&void 0!==g&&h.push(g),g>t&&(l=!0),g=b;else q=this.lin2log(q),t=this.lin2log(t),a=u?this.getMinorTickInterval():e.tickInterval,a=k("auto"===a?null:a,this._minorAutoInterval,e.tickPixelInterval/(u?5:1)*(t-q)/((u?p/this.tickPositions.length:p)||1)),a=F(a,null,I(a)),h=this.getLinearTickPositions(a,q,t).map(this.log2lin),u||(this._minorAutoInterval=a/5);u||(this.tickInterval=a);return h};C.prototype.log2lin=function(a){return Math.log(a)/Math.LN10};C.prototype.lin2log=function(a){return Math.pow(10,
	a)}});K(G,"parts/PlotLineOrBand.js",[G["parts/Globals.js"],G["parts/Axis.js"]],function(a,C){var I=a.arrayMax,F=a.arrayMin,k=a.defined,e=a.destroyObjectProperties,q=a.erase,t=a.merge,u=a.pick;a.PlotLineOrBand=function(a,e){this.axis=a;e&&(this.options=e,this.id=e.id)};a.PlotLineOrBand.prototype={render:function(){a.fireEvent(this,"render");var e=this,p=e.axis,h=p.horiz,d=e.options,m=d.label,b=e.label,g=d.to,l=d.from,c=d.value,w=k(l)&&k(g),z=k(c),q=e.svgElem,D=!q,A=[],n=d.color,x=u(d.zIndex,0),B=d.events,
	A={"class":"highcharts-plot-"+(w?"band ":"line ")+(d.className||"")},E={},H=p.chart.renderer,f=w?"bands":"lines";p.isLog&&(l=p.log2lin(l),g=p.log2lin(g),c=p.log2lin(c));p.chart.styledMode||(z?(A.stroke=n,A["stroke-width"]=d.width,d.dashStyle&&(A.dashstyle=d.dashStyle)):w&&(n&&(A.fill=n),d.borderWidth&&(A.stroke=d.borderColor,A["stroke-width"]=d.borderWidth)));E.zIndex=x;f+="-"+x;(n=p.plotLinesAndBandsGroups[f])||(p.plotLinesAndBandsGroups[f]=n=H.g("plot-"+f).attr(E).add());D&&(e.svgElem=q=H.path().attr(A).add(n));
	if(z)A=p.getPlotLinePath(c,q.strokeWidth());else if(w)A=p.getPlotBandPath(l,g,d);else return;(D||!q.d)&&A&&A.length?(q.attr({d:A}),B&&a.objectEach(B,function(a,c){q.on(c,function(a){B[c].apply(e,[a])})})):q&&(A?(q.show(!0),q.animate({d:A})):q.d&&(q.hide(),b&&(e.label=b=b.destroy())));m&&k(m.text)&&A&&A.length&&0<p.width&&0<p.height&&!A.isFlat?(m=t({align:h&&w&&"center",x:h?!w&&4:10,verticalAlign:!h&&w&&"middle",y:h?w?16:10:w?6:-4,rotation:h&&!w&&90},m),this.renderLabel(m,A,w,x)):b&&b.hide();return e},
	renderLabel:function(a,e,h,d){var m=this.label,b=this.axis.chart.renderer;m||(m={align:a.textAlign||a.align,rotation:a.rotation,"class":"highcharts-plot-"+(h?"band":"line")+"-label "+(a.className||"")},m.zIndex=d,this.label=m=b.text(a.text,0,0,a.useHTML).attr(m).add(),this.axis.chart.styledMode||m.css(a.style));d=e.xBounds||[e[1],e[4],h?e[6]:e[1]];e=e.yBounds||[e[2],e[5],h?e[7]:e[2]];h=F(d);b=F(e);m.align(a,!1,{x:h,y:b,width:I(d)-h,height:I(e)-b});m.show(!0)},destroy:function(){q(this.axis.plotLinesAndBands,
	this);delete this.axis;e(this)}};a.extend(C.prototype,{getPlotBandPath:function(a,e){var h=this.getPlotLinePath(e,null,null,!0),d=this.getPlotLinePath(a,null,null,!0),m=[],b=this.horiz,g=1,l;a=a<this.min&&e<this.min||a>this.max&&e>this.max;if(d&&h)for(a&&(l=d.toString()===h.toString(),g=0),a=0;a<d.length;a+=6)b&&h[a+1]===d[a+1]?(h[a+1]+=g,h[a+4]+=g):b||h[a+2]!==d[a+2]||(h[a+2]+=g,h[a+5]+=g),m.push("M",d[a+1],d[a+2],"L",d[a+4],d[a+5],h[a+4],h[a+5],h[a+1],h[a+2],"z"),m.isFlat=l;return m},addPlotBand:function(a){return this.addPlotBandOrLine(a,
	"plotBands")},addPlotLine:function(a){return this.addPlotBandOrLine(a,"plotLines")},addPlotBandOrLine:function(e,p){var h=(new a.PlotLineOrBand(this,e)).render(),d=this.userOptions;h&&(p&&(d[p]=d[p]||[],d[p].push(e)),this.plotLinesAndBands.push(h));return h},removePlotBandOrLine:function(a){for(var e=this.plotLinesAndBands,h=this.options,d=this.userOptions,m=e.length;m--;)e[m].id===a&&e[m].destroy();[h.plotLines||[],d.plotLines||[],h.plotBands||[],d.plotBands||[]].forEach(function(b){for(m=b.length;m--;)b[m].id===
	a&&q(b,b[m])})},removePlotBand:function(a){this.removePlotBandOrLine(a)},removePlotLine:function(a){this.removePlotBandOrLine(a)}})});K(G,"parts/Tooltip.js",[G["parts/Globals.js"]],function(a){var C=a.doc,I=a.extend,F=a.format,k=a.isNumber,e=a.merge,q=a.pick,t=a.splat,u=a.syncTimeout,v=a.timeUnits;a.Tooltip=function(){this.init.apply(this,arguments)};a.Tooltip.prototype={init:function(a,e){this.chart=a;this.options=e;this.crosshairs=[];this.now={x:0,y:0};this.isHidden=!0;this.split=e.split&&!a.inverted;
	this.shared=e.shared||this.split;this.outside=e.outside&&!this.split},cleanSplit:function(a){this.chart.series.forEach(function(e){var d=e&&e.tt;d&&(!d.isActive||a?e.tt=d.destroy():d.isActive=!1)})},applyFilter:function(){var a=this.chart;a.renderer.definition({tagName:"filter",id:"drop-shadow-"+a.index,opacity:.5,children:[{tagName:"feGaussianBlur","in":"SourceAlpha",stdDeviation:1},{tagName:"feOffset",dx:1,dy:1},{tagName:"feComponentTransfer",children:[{tagName:"feFuncA",type:"linear",slope:.3}]},
	{tagName:"feMerge",children:[{tagName:"feMergeNode"},{tagName:"feMergeNode","in":"SourceGraphic"}]}]});a.renderer.definition({tagName:"style",textContent:".highcharts-tooltip-"+a.index+"{filter:url(#drop-shadow-"+a.index+")}"})},getLabel:function(){var e=this,h=this.chart.renderer,d=this.chart.styledMode,m=this.options,b,g;this.label||(this.outside&&(this.container=b=a.doc.createElement("div"),b.className="highcharts-tooltip-container",a.css(b,{position:"absolute",top:"1px",pointerEvents:m.style&&
	m.style.pointerEvents}),a.doc.body.appendChild(b),this.renderer=h=new a.Renderer(b,0,0)),this.split?this.label=h.g("tooltip"):(this.label=h.label("",0,0,m.shape||"callout",null,null,m.useHTML,null,"tooltip").attr({padding:m.padding,r:m.borderRadius}),d||this.label.attr({fill:m.backgroundColor,"stroke-width":m.borderWidth}).css(m.style).shadow(m.shadow)),d&&(this.applyFilter(),this.label.addClass("highcharts-tooltip-"+this.chart.index)),this.outside&&(g={x:this.label.xSetter,y:this.label.ySetter},
	this.label.xSetter=function(a,c){g[c].call(this.label,e.distance);b.style.left=a+"px"},this.label.ySetter=function(a,c){g[c].call(this.label,e.distance);b.style.top=a+"px"}),this.label.attr({zIndex:8}).add());return this.label},update:function(a){this.destroy();e(!0,this.chart.options.tooltip.userOptions,a);this.init(this.chart,e(!0,this.options,a))},destroy:function(){this.label&&(this.label=this.label.destroy());this.split&&this.tt&&(this.cleanSplit(this.chart,!0),this.tt=this.tt.destroy());this.renderer&&
	(this.renderer=this.renderer.destroy(),a.discardElement(this.container));a.clearTimeout(this.hideTimer);a.clearTimeout(this.tooltipTimeout)},move:function(e,h,d,m){var b=this,g=b.now,l=!1!==b.options.animation&&!b.isHidden&&(1<Math.abs(e-g.x)||1<Math.abs(h-g.y)),c=b.followPointer||1<b.len;I(g,{x:l?(2*g.x+e)/3:e,y:l?(g.y+h)/2:h,anchorX:c?void 0:l?(2*g.anchorX+d)/3:d,anchorY:c?void 0:l?(g.anchorY+m)/2:m});b.getLabel().attr(g);l&&(a.clearTimeout(this.tooltipTimeout),this.tooltipTimeout=setTimeout(function(){b&&
	b.move(e,h,d,m)},32))},hide:function(e){var h=this;a.clearTimeout(this.hideTimer);e=q(e,this.options.hideDelay,500);this.isHidden||(this.hideTimer=u(function(){h.getLabel()[e?"fadeOut":"hide"]();h.isHidden=!0},e))},getAnchor:function(a,e){var d=this.chart,h=d.pointer,b=d.inverted,g=d.plotTop,l=d.plotLeft,c=0,w=0,z,k;a=t(a);this.followPointer&&e?(void 0===e.chartX&&(e=h.normalize(e)),a=[e.chartX-d.plotLeft,e.chartY-g]):a[0].tooltipPos?a=a[0].tooltipPos:(a.forEach(function(a){z=a.series.yAxis;k=a.series.xAxis;
	c+=a.plotX+(!b&&k?k.left-l:0);w+=(a.plotLow?(a.plotLow+a.plotHigh)/2:a.plotY)+(!b&&z?z.top-g:0)}),c/=a.length,w/=a.length,a=[b?d.plotWidth-w:c,this.shared&&!b&&1<a.length&&e?e.chartY-g:b?d.plotHeight-c:w]);return a.map(Math.round)},getPosition:function(a,e,d){var h=this.chart,b=this.distance,g={},l=h.inverted&&d.h||0,c,w=this.outside,z=w?C.documentElement.clientWidth-2*b:h.chartWidth,k=w?Math.max(C.body.scrollHeight,C.documentElement.scrollHeight,C.body.offsetHeight,C.documentElement.offsetHeight,
	C.documentElement.clientHeight):h.chartHeight,p=h.pointer.chartPosition,A=["y",k,e,(w?p.top-b:0)+d.plotY+h.plotTop,w?0:h.plotTop,w?k:h.plotTop+h.plotHeight],n=["x",z,a,(w?p.left-b:0)+d.plotX+h.plotLeft,w?0:h.plotLeft,w?z:h.plotLeft+h.plotWidth],x=!this.followPointer&&q(d.ttBelow,!h.inverted===!!d.negative),B=function(a,c,f,d,n,e){var h=f<d-b,m=d+b+f<c,B=d-b-f;d+=b;if(x&&m)g[a]=d;else if(!x&&h)g[a]=B;else if(h)g[a]=Math.min(e-f,0>B-l?B:B-l);else if(m)g[a]=Math.max(n,d+l+f>c?d:d+l);else return!1},E=
	function(a,c,f,d){var l;d<b||d>c-b?l=!1:g[a]=d<f/2?1:d>c-f/2?c-f-2:d-f/2;return l},H=function(a){var b=A;A=n;n=b;c=a},f=function(){!1!==B.apply(0,A)?!1!==E.apply(0,n)||c||(H(!0),f()):c?g.x=g.y=0:(H(!0),f())};(h.inverted||1<this.len)&&H();f();return g},defaultFormatter:function(a){var e=this.points||t(this),d;d=[a.tooltipFooterHeaderFormatter(e[0])];d=d.concat(a.bodyFormatter(e));d.push(a.tooltipFooterHeaderFormatter(e[0],!0));return d},refresh:function(e,h){var d=this.chart,m=this.options,b,g=e,l,
	c={},w,z=[];w=m.formatter||this.defaultFormatter;var c=this.shared,k=d.styledMode,p=[];m.enabled&&(a.clearTimeout(this.hideTimer),this.followPointer=t(g)[0].series.tooltipOptions.followPointer,l=this.getAnchor(g,h),h=l[0],b=l[1],!c||g.series&&g.series.noSharedTooltip?c=g.getLabelConfig():(p=d.pointer.getActiveSeries(g),d.series.forEach(function(a){(a.options.inactiveOtherPoints||-1===p.indexOf(a))&&a.setState("inactive",!0)}),g.forEach(function(a){a.setState("hover");z.push(a.getLabelConfig())}),
	c={x:g[0].category,y:g[0].y},c.points=z,g=g[0]),this.len=z.length,w=w.call(c,this),c=g.series,this.distance=q(c.tooltipOptions.distance,16),!1===w?this.hide():(d=this.getLabel(),this.isHidden&&d.attr({opacity:1}).show(),this.split?this.renderSplit(w,t(e)):(m.style.width&&!k||d.css({width:this.chart.spacingBox.width}),d.attr({text:w&&w.join?w.join(""):w}),d.removeClass(/highcharts-color-[\d]+/g).addClass("highcharts-color-"+q(g.colorIndex,c.colorIndex)),k||d.attr({stroke:m.borderColor||g.color||c.color||
	"#666666"}),this.updatePosition({plotX:h,plotY:b,negative:g.negative,ttBelow:g.ttBelow,h:l[2]||0})),this.isHidden=!1),a.fireEvent(this,"refresh"))},renderSplit:function(e,h){var d=this,m=[],b=this.chart,g=b.renderer,l=!0,c=this.options,w=0,z,k=this.getLabel(),p=b.plotTop;a.isString(e)&&(e=[!1,e]);e.slice(0,h.length+1).forEach(function(a,n){if(!1!==a&&""!==a){n=h[n-1]||{isHeader:!0,plotX:h[0].plotX,plotY:b.plotHeight};var e=n.series||d,B=e.tt,A=n.series||{},H="highcharts-color-"+q(n.colorIndex,A.colorIndex,
	"none");B||(B={padding:c.padding,r:c.borderRadius},b.styledMode||(B.fill=c.backgroundColor,B.stroke=c.borderColor||n.color||A.color||"#333333",B["stroke-width"]=c.borderWidth),e.tt=B=g.label(null,null,null,(n.isHeader?c.headerShape:c.shape)||"callout",null,null,c.useHTML).addClass("highcharts-tooltip-box "+H).attr(B).add(k));B.isActive=!0;B.attr({text:a});b.styledMode||B.css(c.style).shadow(c.shadow);a=B.getBBox();A=a.width+B.strokeWidth();n.isHeader?(w=a.height,b.xAxis[0].opposite&&(z=!0,p-=w),A=
	Math.max(0,Math.min(n.plotX+b.plotLeft-A/2,b.chartWidth+(b.scrollablePixels?b.scrollablePixels-b.marginRight:0)-A))):A=n.plotX+b.plotLeft-q(c.distance,16)-A;0>A&&(l=!1);a=(n.series&&n.series.yAxis&&n.series.yAxis.pos)+(n.plotY||0);a-=p;n.isHeader&&(a=z?-w:b.plotHeight+w);m.push({target:a,rank:n.isHeader?1:0,size:e.tt.getBBox().height+1,point:n,x:A,tt:B})}});this.cleanSplit();c.positioner&&m.forEach(function(a){var b=c.positioner.call(d,a.tt.getBBox().width,a.size,a.point);a.x=b.x;a.align=0;a.target=
	b.y;a.rank=q(b.rank,a.rank)});a.distribute(m,b.plotHeight+w);m.forEach(function(a){var g=a.point,e=g.series;a.tt.attr({visibility:void 0===a.pos?"hidden":"inherit",x:l||g.isHeader||c.positioner?a.x:g.plotX+b.plotLeft+d.distance,y:a.pos+p,anchorX:g.isHeader?g.plotX+b.plotLeft:g.plotX+e.xAxis.pos,anchorY:g.isHeader?b.plotTop+b.plotHeight/2:g.plotY+e.yAxis.pos})})},updatePosition:function(a){var e=this.chart,d=this.getLabel(),m=(this.options.positioner||this.getPosition).call(this,d.width,d.height,a),
	b=a.plotX+e.plotLeft;a=a.plotY+e.plotTop;var g;this.outside&&(g=(this.options.borderWidth||0)+2*this.distance,this.renderer.setSize(d.width+g,d.height+g,!1),b+=e.pointer.chartPosition.left-m.x,a+=e.pointer.chartPosition.top-m.y);this.move(Math.round(m.x),Math.round(m.y||0),b,a)},getDateFormat:function(a,e,d,m){var b=this.chart.time,g=b.dateFormat("%m-%d %H:%M:%S.%L",e),l,c,h={millisecond:15,second:12,minute:9,hour:6,day:3},z="millisecond";for(c in v){if(a===v.week&&+b.dateFormat("%w",e)===d&&"00:00:00.000"===
	g.substr(6)){c="week";break}if(v[c]>a){c=z;break}if(h[c]&&g.substr(h[c])!=="01-01 00:00:00.000".substr(h[c]))break;"week"!==c&&(z=c)}c&&(l=b.resolveDTLFormat(m[c]).main);return l},getXDateFormat:function(a,e,d){e=e.dateTimeLabelFormats;var h=d&&d.closestPointRange;return(h?this.getDateFormat(h,a.x,d.options.startOfWeek,e):e.day)||e.year},tooltipFooterHeaderFormatter:function(e,h){var d=h?"footer":"header",m=e.series,b=m.tooltipOptions,g=b.xDateFormat,l=m.xAxis,c=l&&"datetime"===l.options.type&&k(e.key),
	w=b[d+"Format"];h={isFooter:h,labelConfig:e};a.fireEvent(this,"headerFormatter",h,function(a){c&&!g&&(g=this.getXDateFormat(e,b,l));c&&g&&(e.point&&e.point.tooltipDateKeys||["key"]).forEach(function(a){w=w.replace("{point."+a+"}","{point."+a+":"+g+"}")});m.chart.styledMode&&(w=this.styledModeFormat(w));a.text=F(w,{point:e,series:m},this.chart.time)});return h.text},bodyFormatter:function(a){return a.map(function(a){var d=a.series.tooltipOptions;return(d[(a.point.formatPrefix||"point")+"Formatter"]||
	a.point.tooltipFormatter).call(a.point,d[(a.point.formatPrefix||"point")+"Format"]||"")})},styledModeFormat:function(a){return a.replace('style\x3d"font-size: 10px"','class\x3d"highcharts-header"').replace(/style="color:{(point|series)\.color}"/g,'class\x3d"highcharts-color-{$1.colorIndex}"')}}});K(G,"parts/Pointer.js",[G["parts/Globals.js"]],function(a){var C=a.addEvent,I=a.attr,F=a.charts,k=a.color,e=a.css,q=a.defined,t=a.extend,u=a.find,v=a.fireEvent,p=a.isNumber,h=a.isObject,d=a.offset,m=a.pick,
	b=a.splat,g=a.Tooltip;a.Pointer=function(a,c){this.init(a,c)};a.Pointer.prototype={init:function(a,c){this.options=c;this.chart=a;this.runChartClick=c.chart.events&&!!c.chart.events.click;this.pinchDown=[];this.lastValidTouch={};g&&(a.tooltip=new g(a,c.tooltip),this.followTouchMove=m(c.tooltip.followTouchMove,!0));this.setDOMEvents()},zoomOption:function(a){var c=this.chart,b=c.options.chart,d=b.zoomType||"",c=c.inverted;/touch/.test(a.type)&&(d=m(b.pinchType,d));this.zoomX=a=/x/.test(d);this.zoomY=
	d=/y/.test(d);this.zoomHor=a&&!c||d&&c;this.zoomVert=d&&!c||a&&c;this.hasZoom=a||d},normalize:function(a,c){var b;b=a.touches?a.touches.length?a.touches.item(0):a.changedTouches[0]:a;c||(this.chartPosition=c=d(this.chart.container));return t(a,{chartX:Math.round(b.pageX-c.left),chartY:Math.round(b.pageY-c.top)})},getCoordinates:function(a){var c={xAxis:[],yAxis:[]};this.chart.axes.forEach(function(b){c[b.isXAxis?"xAxis":"yAxis"].push({axis:b,value:b.toValue(a[b.horiz?"chartX":"chartY"])})});return c},
	findNearestKDPoint:function(a,c,b){var d;a.forEach(function(a){var g=!(a.noSharedTooltip&&c)&&0>a.options.findNearestPointBy.indexOf("y");a=a.searchPoint(b,g);if((g=h(a,!0))&&!(g=!h(d,!0)))var g=d.distX-a.distX,l=d.dist-a.dist,e=(a.series.group&&a.series.group.zIndex)-(d.series.group&&d.series.group.zIndex),g=0<(0!==g&&c?g:0!==l?l:0!==e?e:d.series.index>a.series.index?-1:1);g&&(d=a)});return d},getPointFromEvent:function(a){a=a.target;for(var c;a&&!c;)c=a.point,a=a.parentNode;return c},getChartCoordinatesFromPoint:function(a,
	c){var b=a.series,d=b.xAxis,b=b.yAxis,g=m(a.clientX,a.plotX),e=a.shapeArgs;if(d&&b)return c?{chartX:d.len+d.pos-g,chartY:b.len+b.pos-a.plotY}:{chartX:g+d.pos,chartY:a.plotY+b.pos};if(e&&e.x&&e.y)return{chartX:e.x,chartY:e.y}},getHoverData:function(a,c,b,d,g,e){var l,n=[];d=!(!d||!a);var x=c&&!c.stickyTracking?[c]:b.filter(function(a){return a.visible&&!(!g&&a.directTouch)&&m(a.options.enableMouseTracking,!0)&&a.stickyTracking});c=(l=d?a:this.findNearestKDPoint(x,g,e))&&l.series;l&&(g&&!c.noSharedTooltip?
	(x=b.filter(function(a){return a.visible&&!(!g&&a.directTouch)&&m(a.options.enableMouseTracking,!0)&&!a.noSharedTooltip}),x.forEach(function(a){var c=u(a.points,function(a){return a.x===l.x&&!a.isNull});h(c)&&(a.chart.isBoosting&&(c=a.getPoint(c)),n.push(c))})):n.push(l));return{hoverPoint:l,hoverSeries:c,hoverPoints:n}},runPointActions:function(b,c){var d=this.chart,g=d.tooltip&&d.tooltip.options.enabled?d.tooltip:void 0,e=g?g.shared:!1,l=c||d.hoverPoint,h=l&&l.series||d.hoverSeries,h=this.getHoverData(l,
	h,d.series,"touchmove"!==b.type&&(!!c||h&&h.directTouch&&this.isDirectTouch),e,b),n=[],x,l=h.hoverPoint;x=h.hoverPoints;c=(h=h.hoverSeries)&&h.tooltipOptions.followPointer;e=e&&h&&!h.noSharedTooltip;if(l&&(l!==d.hoverPoint||g&&g.isHidden)){(d.hoverPoints||[]).forEach(function(a){-1===x.indexOf(a)&&a.setState()});if(d.hoverSeries!==h)h.onMouseOver();n=this.getActiveSeries(x);d.series.forEach(function(a){(a.options.inactiveOtherPoints||-1===n.indexOf(a))&&a.setState("inactive",!0)});(x||[]).forEach(function(a){a.setState("hover")});
	d.hoverPoint&&d.hoverPoint.firePointEvent("mouseOut");if(!l.series)return;l.firePointEvent("mouseOver");d.hoverPoints=x;d.hoverPoint=l;g&&g.refresh(e?x:l,b)}else c&&g&&!g.isHidden&&(l=g.getAnchor([{}],b),g.updatePosition({plotX:l[0],plotY:l[1]}));this.unDocMouseMove||(this.unDocMouseMove=C(d.container.ownerDocument,"mousemove",function(c){var b=F[a.hoverChartIndex];if(b)b.pointer.onDocumentMouseMove(c)}));d.axes.forEach(function(c){var d=m(c.crosshair.snap,!0),g=d?a.find(x,function(a){return a.series[c.coll]===
	c}):void 0;g||!d?c.drawCrosshair(b,g):c.hideCrosshair()})},getActiveSeries:function(a){var c=[],b;(a||[]).forEach(function(a){b=a.series;c.push(b);b.linkedParent&&c.push(b.linkedParent);b.linkedSeries&&(c=c.concat(b.linkedSeries));b.navigatorSeries&&c.push(b.navigatorSeries)});return c},reset:function(a,c){var d=this.chart,g=d.hoverSeries,e=d.hoverPoint,l=d.hoverPoints,h=d.tooltip,n=h&&h.shared?l:e;a&&n&&b(n).forEach(function(c){c.series.isCartesian&&void 0===c.plotX&&(a=!1)});if(a)h&&n&&b(n).length&&
	(h.refresh(n),h.shared&&l?l.forEach(function(a){a.setState(a.state,!0);a.series.isCartesian&&(a.series.xAxis.crosshair&&a.series.xAxis.drawCrosshair(null,a),a.series.yAxis.crosshair&&a.series.yAxis.drawCrosshair(null,a))}):e&&(e.setState(e.state,!0),d.axes.forEach(function(a){a.crosshair&&a.drawCrosshair(null,e)})));else{if(e)e.onMouseOut();l&&l.forEach(function(a){a.setState()});if(g)g.onMouseOut();h&&h.hide(c);this.unDocMouseMove&&(this.unDocMouseMove=this.unDocMouseMove());d.axes.forEach(function(a){a.hideCrosshair()});
	this.hoverX=d.hoverPoints=d.hoverPoint=null}},scaleGroups:function(a,c){var b=this.chart,d;b.series.forEach(function(g){d=a||g.getPlotBox();g.xAxis&&g.xAxis.zoomEnabled&&g.group&&(g.group.attr(d),g.markerGroup&&(g.markerGroup.attr(d),g.markerGroup.clip(c?b.clipRect:null)),g.dataLabelsGroup&&g.dataLabelsGroup.attr(d))});b.clipRect.attr(c||b.clipBox)},dragStart:function(a){var c=this.chart;c.mouseIsDown=a.type;c.cancelClick=!1;c.mouseDownX=this.mouseDownX=a.chartX;c.mouseDownY=this.mouseDownY=a.chartY},
	drag:function(a){var c=this.chart,b=c.options.chart,d=a.chartX,g=a.chartY,e=this.zoomHor,l=this.zoomVert,n=c.plotLeft,h=c.plotTop,m=c.plotWidth,E=c.plotHeight,p,f=this.selectionMarker,r=this.mouseDownX,q=this.mouseDownY,t=b.panKey&&a[b.panKey+"Key"];f&&f.touch||(d<n?d=n:d>n+m&&(d=n+m),g<h?g=h:g>h+E&&(g=h+E),this.hasDragged=Math.sqrt(Math.pow(r-d,2)+Math.pow(q-g,2)),10<this.hasDragged&&(p=c.isInsidePlot(r-n,q-h),c.hasCartesianSeries&&(this.zoomX||this.zoomY)&&p&&!t&&!f&&(this.selectionMarker=f=c.renderer.rect(n,
	h,e?1:m,l?1:E,0).attr({"class":"highcharts-selection-marker",zIndex:7}).add(),c.styledMode||f.attr({fill:b.selectionMarkerFill||k("#335cad").setOpacity(.25).get()})),f&&e&&(d-=r,f.attr({width:Math.abs(d),x:(0<d?0:d)+r})),f&&l&&(d=g-q,f.attr({height:Math.abs(d),y:(0<d?0:d)+q})),p&&!f&&b.panning&&c.pan(a,b.panning)))},drop:function(a){var c=this,b=this.chart,d=this.hasPinched;if(this.selectionMarker){var g={originalEvent:a,xAxis:[],yAxis:[]},l=this.selectionMarker,h=l.attr?l.attr("x"):l.x,n=l.attr?
	l.attr("y"):l.y,m=l.attr?l.attr("width"):l.width,B=l.attr?l.attr("height"):l.height,k;if(this.hasDragged||d)b.axes.forEach(function(b){if(b.zoomEnabled&&q(b.min)&&(d||c[{xAxis:"zoomX",yAxis:"zoomY"}[b.coll]])){var f=b.horiz,e="touchend"===a.type?b.minPixelPadding:0,l=b.toValue((f?h:n)+e),f=b.toValue((f?h+m:n+B)-e);g[b.coll].push({axis:b,min:Math.min(l,f),max:Math.max(l,f)});k=!0}}),k&&v(b,"selection",g,function(a){b.zoom(t(a,d?{animation:!1}:null))});p(b.index)&&(this.selectionMarker=this.selectionMarker.destroy());
	d&&this.scaleGroups()}b&&p(b.index)&&(e(b.container,{cursor:b._cursor}),b.cancelClick=10<this.hasDragged,b.mouseIsDown=this.hasDragged=this.hasPinched=!1,this.pinchDown=[])},onContainerMouseDown:function(a){a=this.normalize(a);2!==a.button&&(this.zoomOption(a),a.preventDefault&&a.preventDefault(),this.dragStart(a))},onDocumentMouseUp:function(b){F[a.hoverChartIndex]&&F[a.hoverChartIndex].pointer.drop(b)},onDocumentMouseMove:function(a){var c=this.chart,b=this.chartPosition;a=this.normalize(a,b);!b||
	this.inClass(a.target,"highcharts-tracker")||c.isInsidePlot(a.chartX-c.plotLeft,a.chartY-c.plotTop)||this.reset()},onContainerMouseLeave:function(b){var c=F[a.hoverChartIndex];c&&(b.relatedTarget||b.toElement)&&(c.pointer.reset(),c.pointer.chartPosition=null)},onContainerMouseMove:function(b){var c=this.chart;q(a.hoverChartIndex)&&F[a.hoverChartIndex]&&F[a.hoverChartIndex].mouseIsDown||(a.hoverChartIndex=c.index);b=this.normalize(b);b.preventDefault||(b.returnValue=!1);"mousedown"===c.mouseIsDown&&
	this.drag(b);!this.inClass(b.target,"highcharts-tracker")&&!c.isInsidePlot(b.chartX-c.plotLeft,b.chartY-c.plotTop)||c.openMenu||this.runPointActions(b)},inClass:function(a,c){for(var b;a;){if(b=I(a,"class")){if(-1!==b.indexOf(c))return!0;if(-1!==b.indexOf("highcharts-container"))return!1}a=a.parentNode}},onTrackerMouseOut:function(a){var c=this.chart.hoverSeries;a=a.relatedTarget||a.toElement;this.isDirectTouch=!1;if(!(!c||!a||c.stickyTracking||this.inClass(a,"highcharts-tooltip")||this.inClass(a,
	"highcharts-series-"+c.index)&&this.inClass(a,"highcharts-tracker")))c.onMouseOut()},onContainerClick:function(a){var c=this.chart,b=c.hoverPoint,d=c.plotLeft,g=c.plotTop;a=this.normalize(a);c.cancelClick||(b&&this.inClass(a.target,"highcharts-tracker")?(v(b.series,"click",t(a,{point:b})),c.hoverPoint&&b.firePointEvent("click",a)):(t(a,this.getCoordinates(a)),c.isInsidePlot(a.chartX-d,a.chartY-g)&&v(c,"click",a)))},setDOMEvents:function(){var b=this,c=b.chart.container,d=c.ownerDocument;c.onmousedown=
	function(a){b.onContainerMouseDown(a)};c.onmousemove=function(a){b.onContainerMouseMove(a)};c.onclick=function(a){b.onContainerClick(a)};this.unbindContainerMouseLeave=C(c,"mouseleave",b.onContainerMouseLeave);a.unbindDocumentMouseUp||(a.unbindDocumentMouseUp=C(d,"mouseup",b.onDocumentMouseUp));a.hasTouch&&(c.ontouchstart=function(a){b.onContainerTouchStart(a)},c.ontouchmove=function(a){b.onContainerTouchMove(a)},a.unbindDocumentTouchEnd||(a.unbindDocumentTouchEnd=C(d,"touchend",b.onDocumentTouchEnd)))},
	destroy:function(){var b=this;b.unDocMouseMove&&b.unDocMouseMove();this.unbindContainerMouseLeave();a.chartCount||(a.unbindDocumentMouseUp&&(a.unbindDocumentMouseUp=a.unbindDocumentMouseUp()),a.unbindDocumentTouchEnd&&(a.unbindDocumentTouchEnd=a.unbindDocumentTouchEnd()));clearInterval(b.tooltipTimeout);a.objectEach(b,function(a,d){b[d]=null})}}});K(G,"parts/TouchPointer.js",[G["parts/Globals.js"]],function(a){var C=a.charts,I=a.extend,F=a.noop,k=a.pick;I(a.Pointer.prototype,{pinchTranslate:function(a,
	k,t,u,v,p){this.zoomHor&&this.pinchTranslateDirection(!0,a,k,t,u,v,p);this.zoomVert&&this.pinchTranslateDirection(!1,a,k,t,u,v,p)},pinchTranslateDirection:function(a,k,t,u,v,p,h,d){var e=this.chart,b=a?"x":"y",g=a?"X":"Y",l="chart"+g,c=a?"width":"height",w=e["plot"+(a?"Left":"Top")],z,q,D=d||1,A=e.inverted,n=e.bounds[a?"h":"v"],x=1===k.length,B=k[0][l],E=t[0][l],H=!x&&k[1][l],f=!x&&t[1][l],r;t=function(){!x&&20<Math.abs(B-H)&&(D=d||Math.abs(E-f)/Math.abs(B-H));q=(w-E)/D+B;z=e["plot"+(a?"Width":"Height")]/
	D};t();k=q;k<n.min?(k=n.min,r=!0):k+z>n.max&&(k=n.max-z,r=!0);r?(E-=.8*(E-h[b][0]),x||(f-=.8*(f-h[b][1])),t()):h[b]=[E,f];A||(p[b]=q-w,p[c]=z);p=A?1/D:D;v[c]=z;v[b]=k;u[A?a?"scaleY":"scaleX":"scale"+g]=D;u["translate"+g]=p*w+(E-p*B)},pinch:function(a){var e=this,t=e.chart,u=e.pinchDown,v=a.touches,p=v.length,h=e.lastValidTouch,d=e.hasZoom,m=e.selectionMarker,b={},g=1===p&&(e.inClass(a.target,"highcharts-tracker")&&t.runTrackerClick||e.runChartClick),l={};1<p&&(e.initiated=!0);d&&e.initiated&&!g&&
	a.preventDefault();[].map.call(v,function(a){return e.normalize(a)});"touchstart"===a.type?([].forEach.call(v,function(a,b){u[b]={chartX:a.chartX,chartY:a.chartY}}),h.x=[u[0].chartX,u[1]&&u[1].chartX],h.y=[u[0].chartY,u[1]&&u[1].chartY],t.axes.forEach(function(a){if(a.zoomEnabled){var b=t.bounds[a.horiz?"h":"v"],c=a.minPixelPadding,d=a.toPixels(k(a.options.min,a.dataMin)),g=a.toPixels(k(a.options.max,a.dataMax)),e=Math.max(d,g);b.min=Math.min(a.pos,Math.min(d,g)-c);b.max=Math.max(a.pos+a.len,e+c)}}),
	e.res=!0):e.followTouchMove&&1===p?this.runPointActions(e.normalize(a)):u.length&&(m||(e.selectionMarker=m=I({destroy:F,touch:!0},t.plotBox)),e.pinchTranslate(u,v,b,m,l,h),e.hasPinched=d,e.scaleGroups(b,l),e.res&&(e.res=!1,this.reset(!1,0)))},touch:function(e,q){var t=this.chart,u,v;if(t.index!==a.hoverChartIndex)this.onContainerMouseLeave({relatedTarget:!0});a.hoverChartIndex=t.index;1===e.touches.length?(e=this.normalize(e),(v=t.isInsidePlot(e.chartX-t.plotLeft,e.chartY-t.plotTop))&&!t.openMenu?
	(q&&this.runPointActions(e),"touchmove"===e.type&&(q=this.pinchDown,u=q[0]?4<=Math.sqrt(Math.pow(q[0].chartX-e.chartX,2)+Math.pow(q[0].chartY-e.chartY,2)):!1),k(u,!0)&&this.pinch(e)):q&&this.reset()):2===e.touches.length&&this.pinch(e)},onContainerTouchStart:function(a){this.zoomOption(a);this.touch(a,!0)},onContainerTouchMove:function(a){this.touch(a)},onDocumentTouchEnd:function(e){C[a.hoverChartIndex]&&C[a.hoverChartIndex].pointer.drop(e)}})});K(G,"parts/MSPointer.js",[G["parts/Globals.js"]],function(a){var C=
	a.addEvent,I=a.charts,F=a.css,k=a.doc,e=a.extend,q=a.noop,t=a.Pointer,u=a.removeEvent,v=a.win,p=a.wrap;if(!a.hasTouch&&(v.PointerEvent||v.MSPointerEvent)){var h={},d=!!v.PointerEvent,m=function(){var b=[];b.item=function(a){return this[a]};a.objectEach(h,function(a){b.push({pageX:a.pageX,pageY:a.pageY,target:a.target})});return b},b=function(b,d,c,e){"touch"!==b.pointerType&&b.pointerType!==b.MSPOINTER_TYPE_TOUCH||!I[a.hoverChartIndex]||(e(b),e=I[a.hoverChartIndex].pointer,e[d]({type:c,target:b.currentTarget,
	preventDefault:q,touches:m()}))};e(t.prototype,{onContainerPointerDown:function(a){b(a,"onContainerTouchStart","touchstart",function(a){h[a.pointerId]={pageX:a.pageX,pageY:a.pageY,target:a.currentTarget}})},onContainerPointerMove:function(a){b(a,"onContainerTouchMove","touchmove",function(a){h[a.pointerId]={pageX:a.pageX,pageY:a.pageY};h[a.pointerId].target||(h[a.pointerId].target=a.currentTarget)})},onDocumentPointerUp:function(a){b(a,"onDocumentTouchEnd","touchend",function(a){delete h[a.pointerId]})},
	batchMSEvents:function(a){a(this.chart.container,d?"pointerdown":"MSPointerDown",this.onContainerPointerDown);a(this.chart.container,d?"pointermove":"MSPointerMove",this.onContainerPointerMove);a(k,d?"pointerup":"MSPointerUp",this.onDocumentPointerUp)}});p(t.prototype,"init",function(a,b,c){a.call(this,b,c);this.hasZoom&&F(b.container,{"-ms-touch-action":"none","touch-action":"none"})});p(t.prototype,"setDOMEvents",function(a){a.apply(this);(this.hasZoom||this.followTouchMove)&&this.batchMSEvents(C)});
	p(t.prototype,"destroy",function(a){this.batchMSEvents(u);a.call(this)})}});K(G,"parts/Legend.js",[G["parts/Globals.js"]],function(a){var C=a.addEvent,I=a.css,F=a.discardElement,k=a.defined,e=a.fireEvent,q=a.isFirefox,t=a.marginNames,u=a.merge,v=a.pick,p=a.setAnimation,h=a.stableSort,d=a.win,m=a.wrap;a.Legend=function(a,d){this.init(a,d)};a.Legend.prototype={init:function(a,d){this.chart=a;this.setOptions(d);d.enabled&&(this.render(),C(this.chart,"endResize",function(){this.legend.positionCheckboxes()}),
	this.proximate?this.unchartrender=C(this.chart,"render",function(){this.legend.proximatePositions();this.legend.positionItems()}):this.unchartrender&&this.unchartrender())},setOptions:function(a){var b=v(a.padding,8);this.options=a;this.chart.styledMode||(this.itemStyle=a.itemStyle,this.itemHiddenStyle=u(this.itemStyle,a.itemHiddenStyle));this.itemMarginTop=a.itemMarginTop||0;this.padding=b;this.initialItemY=b-5;this.symbolWidth=v(a.symbolWidth,16);this.pages=[];this.proximate="proximate"===a.layout&&
	!this.chart.inverted},update:function(a,d){var b=this.chart;this.setOptions(u(!0,this.options,a));this.destroy();b.isDirtyLegend=b.isDirtyBox=!0;v(d,!0)&&b.redraw();e(this,"afterUpdate")},colorizeItem:function(a,d){a.legendGroup[d?"removeClass":"addClass"]("highcharts-legend-item-hidden");if(!this.chart.styledMode){var b=this.options,c=a.legendItem,g=a.legendLine,h=a.legendSymbol,m=this.itemHiddenStyle.color,b=d?b.itemStyle.color:m,k=d?a.color||m:m,p=a.options&&a.options.marker,n={fill:k};c&&c.css({fill:b,
	color:b});g&&g.attr({stroke:k});h&&(p&&h.isMarker&&(n=a.pointAttribs(),d||(n.stroke=n.fill=m)),h.attr(n))}e(this,"afterColorizeItem",{item:a,visible:d})},positionItems:function(){this.allItems.forEach(this.positionItem,this);this.chart.isResizing||this.positionCheckboxes()},positionItem:function(a){var b=this.options,d=b.symbolPadding,b=!b.rtl,c=a._legendItemPos,e=c[0],c=c[1],h=a.checkbox;if((a=a.legendGroup)&&a.element)a[k(a.translateY)?"animate":"attr"]({translateX:b?e:this.legendWidth-e-2*d-4,
	translateY:c});h&&(h.x=e,h.y=c)},destroyItem:function(a){var b=a.checkbox;["legendItem","legendLine","legendSymbol","legendGroup"].forEach(function(b){a[b]&&(a[b]=a[b].destroy())});b&&F(a.checkbox)},destroy:function(){function a(a){this[a]&&(this[a]=this[a].destroy())}this.getAllItems().forEach(function(b){["legendItem","legendGroup"].forEach(a,b)});"clipRect up down pager nav box title group".split(" ").forEach(a,this);this.display=null},positionCheckboxes:function(){var a=this.group&&this.group.alignAttr,
	d,e=this.clipHeight||this.legendHeight,c=this.titleHeight;a&&(d=a.translateY,this.allItems.forEach(function(b){var g=b.checkbox,h;g&&(h=d+c+g.y+(this.scrollOffset||0)+3,I(g,{left:a.translateX+b.checkboxOffset+g.x-20+"px",top:h+"px",display:this.proximate||h>d-6&&h<d+e-6?"":"none"}))},this))},renderTitle:function(){var a=this.options,d=this.padding,e=a.title,c=0;e.text&&(this.title||(this.title=this.chart.renderer.label(e.text,d-3,d-4,null,null,null,a.useHTML,null,"legend-title").attr({zIndex:1}),
	this.chart.styledMode||this.title.css(e.style),this.title.add(this.group)),e.width||this.title.css({width:this.maxLegendWidth+"px"}),a=this.title.getBBox(),c=a.height,this.offsetWidth=a.width,this.contentGroup.attr({translateY:c}));this.titleHeight=c},setText:function(b){var d=this.options;b.legendItem.attr({text:d.labelFormat?a.format(d.labelFormat,b,this.chart.time):d.labelFormatter.call(b)})},renderItem:function(a){var b=this.chart,d=b.renderer,c=this.options,e=this.symbolWidth,h=c.symbolPadding,
	m=this.itemStyle,k=this.itemHiddenStyle,p="horizontal"===c.layout?v(c.itemDistance,20):0,n=!c.rtl,x=a.legendItem,B=!a.series,E=!B&&a.series.drawLegendSymbol?a.series:a,H=E.options,H=this.createCheckboxForItem&&H&&H.showCheckbox,p=e+h+p+(H?20:0),f=c.useHTML,r=a.options.className;x||(a.legendGroup=d.g("legend-item").addClass("highcharts-"+E.type+"-series highcharts-color-"+a.colorIndex+(r?" "+r:"")+(B?" highcharts-series-"+a.index:"")).attr({zIndex:1}).add(this.scrollGroup),a.legendItem=x=d.text("",
	n?e+h:-h,this.baseline||0,f),b.styledMode||x.css(u(a.visible?m:k)),x.attr({align:n?"left":"right",zIndex:2}).add(a.legendGroup),this.baseline||(this.fontMetrics=d.fontMetrics(b.styledMode?12:m.fontSize,x),this.baseline=this.fontMetrics.f+3+this.itemMarginTop,x.attr("y",this.baseline)),this.symbolHeight=c.symbolHeight||this.fontMetrics.f,E.drawLegendSymbol(this,a),this.setItemEvents&&this.setItemEvents(a,x,f));H&&!a.checkbox&&this.createCheckboxForItem(a);this.colorizeItem(a,a.visible);!b.styledMode&&
	m.width||x.css({width:(c.itemWidth||this.widthOption||b.spacingBox.width)-p});this.setText(a);b=x.getBBox();a.itemWidth=a.checkboxOffset=c.itemWidth||a.legendItemWidth||b.width+p;this.maxItemWidth=Math.max(this.maxItemWidth,a.itemWidth);this.totalItemWidth+=a.itemWidth;this.itemHeight=a.itemHeight=Math.round(a.legendItemHeight||b.height||this.symbolHeight)},layoutItem:function(a){var b=this.options,d=this.padding,c="horizontal"===b.layout,e=a.itemHeight,h=b.itemMarginBottom||0,m=this.itemMarginTop,
	k=c?v(b.itemDistance,20):0,p=this.maxLegendWidth,b=b.alignColumns&&this.totalItemWidth>p?this.maxItemWidth:a.itemWidth;c&&this.itemX-d+b>p&&(this.itemX=d,this.lastLineHeight&&(this.itemY+=m+this.lastLineHeight+h),this.lastLineHeight=0);this.lastItemY=m+this.itemY+h;this.lastLineHeight=Math.max(e,this.lastLineHeight);a._legendItemPos=[this.itemX,this.itemY];c?this.itemX+=b:(this.itemY+=m+e+h,this.lastLineHeight=e);this.offsetWidth=this.widthOption||Math.max((c?this.itemX-d-(a.checkbox?0:k):b)+d,this.offsetWidth)},
	getAllItems:function(){var a=[];this.chart.series.forEach(function(b){var d=b&&b.options;b&&v(d.showInLegend,k(d.linkedTo)?!1:void 0,!0)&&(a=a.concat(b.legendItems||("point"===d.legendType?b.data:b)))});e(this,"afterGetAllItems",{allItems:a});return a},getAlignment:function(){var a=this.options;return this.proximate?a.align.charAt(0)+"tv":a.floating?"":a.align.charAt(0)+a.verticalAlign.charAt(0)+a.layout.charAt(0)},adjustMargins:function(a,d){var b=this.chart,c=this.options,g=this.getAlignment(),
	e=void 0!==b.options.title.margin?b.titleOffset+b.options.title.margin:0;g&&[/(lth|ct|rth)/,/(rtv|rm|rbv)/,/(rbh|cb|lbh)/,/(lbv|lm|ltv)/].forEach(function(h,l){h.test(g)&&!k(a[l])&&(b[t[l]]=Math.max(b[t[l]],b.legend[(l+1)%2?"legendHeight":"legendWidth"]+[1,-1,-1,1][l]*c[l%2?"x":"y"]+v(c.margin,12)+d[l]+(0===l&&(0===b.titleOffset?0:e))))})},proximatePositions:function(){var b=this.chart,d=[],e="left"===this.options.align;this.allItems.forEach(function(c){var g,h;h=e;var l;c.yAxis&&c.points&&(c.xAxis.options.reversed&&
	(h=!h),g=a.find(h?c.points:c.points.slice(0).reverse(),function(b){return a.isNumber(b.plotY)}),h=c.legendGroup.getBBox().height,l=c.yAxis.top-b.plotTop,c.visible?(g=g?g.plotY:c.yAxis.height,g+=l-.3*h):g=l+c.yAxis.height,d.push({target:g,size:h,item:c}))},this);a.distribute(d,b.plotHeight);d.forEach(function(a){a.item._legendItemPos[1]=b.plotTop-b.spacing[0]+a.pos})},render:function(){var b=this.chart,d=b.renderer,l=this.group,c,m,k,p=this.box,q=this.options,A=this.padding;this.itemX=A;this.itemY=
	this.initialItemY;this.lastItemY=this.offsetWidth=0;this.widthOption=a.relativeLength(q.width,b.spacingBox.width-A);c=b.spacingBox.width-2*A-q.x;-1<["rm","lm"].indexOf(this.getAlignment().substring(0,2))&&(c/=2);this.maxLegendWidth=this.widthOption||c;l||(this.group=l=d.g("legend").attr({zIndex:7}).add(),this.contentGroup=d.g().attr({zIndex:1}).add(l),this.scrollGroup=d.g().add(this.contentGroup));this.renderTitle();c=this.getAllItems();h(c,function(a,b){return(a.options&&a.options.legendIndex||0)-
	(b.options&&b.options.legendIndex||0)});q.reversed&&c.reverse();this.allItems=c;this.display=m=!!c.length;this.itemHeight=this.totalItemWidth=this.maxItemWidth=this.lastLineHeight=0;c.forEach(this.renderItem,this);c.forEach(this.layoutItem,this);c=(this.widthOption||this.offsetWidth)+A;k=this.lastItemY+this.lastLineHeight+this.titleHeight;k=this.handleOverflow(k);k+=A;p||(this.box=p=d.rect().addClass("highcharts-legend-box").attr({r:q.borderRadius}).add(l),p.isNew=!0);b.styledMode||p.attr({stroke:q.borderColor,
	"stroke-width":q.borderWidth||0,fill:q.backgroundColor||"none"}).shadow(q.shadow);0<c&&0<k&&(p[p.isNew?"attr":"animate"](p.crisp.call({},{x:0,y:0,width:c,height:k},p.strokeWidth())),p.isNew=!1);p[m?"show":"hide"]();b.styledMode&&"none"===l.getStyle("display")&&(c=k=0);this.legendWidth=c;this.legendHeight=k;m&&(d=b.spacingBox,/(lth|ct|rth)/.test(this.getAlignment())&&(p=d.y+b.titleOffset,d=u(d,{y:0<b.titleOffset?p+=b.options.title.margin:p})),l.align(u(q,{width:c,height:k,verticalAlign:this.proximate?
	"top":q.verticalAlign}),!0,d));this.proximate||this.positionItems();e(this,"afterRender")},handleOverflow:function(a){var b=this,d=this.chart,c=d.renderer,e=this.options,h=e.y,m=this.padding,h=d.spacingBox.height+("top"===e.verticalAlign?-h:h)-m,k=e.maxHeight,p,n=this.clipRect,x=e.navigation,B=v(x.animation,!0),E=x.arrowSize||12,H=this.nav,f=this.pages,r,q=this.allItems,t=function(a){"number"===typeof a?n.attr({height:a}):n&&(b.clipRect=n.destroy(),b.contentGroup.clip());b.contentGroup.div&&(b.contentGroup.div.style.clip=
	a?"rect("+m+"px,9999px,"+(m+a)+"px,0)":"auto")},L=function(a){b[a]=c.circle(0,0,1.3*E).translate(E/2,E/2).add(H);d.styledMode||b[a].attr("fill","rgba(0,0,0,0.0001)");return b[a]};"horizontal"!==e.layout||"middle"===e.verticalAlign||e.floating||(h/=2);k&&(h=Math.min(h,k));f.length=0;a>h&&!1!==x.enabled?(this.clipHeight=p=Math.max(h-20-this.titleHeight-m,0),this.currentPage=v(this.currentPage,1),this.fullHeight=a,q.forEach(function(a,b){var c=a._legendItemPos[1],d=Math.round(a.legendItem.getBBox().height),
	e=f.length;if(!e||c-f[e-1]>p&&(r||c)!==f[e-1])f.push(r||c),e++;a.pageIx=e-1;r&&(q[b-1].pageIx=e-1);b===q.length-1&&c+d-f[e-1]>p&&c!==r&&(f.push(c),a.pageIx=e);c!==r&&(r=c)}),n||(n=b.clipRect=c.clipRect(0,m,9999,0),b.contentGroup.clip(n)),t(p),H||(this.nav=H=c.g().attr({zIndex:1}).add(this.group),this.up=c.symbol("triangle",0,0,E,E).add(H),L("upTracker").on("click",function(){b.scroll(-1,B)}),this.pager=c.text("",15,10).addClass("highcharts-legend-navigation"),d.styledMode||this.pager.css(x.style),
	this.pager.add(H),this.down=c.symbol("triangle-down",0,0,E,E).add(H),L("downTracker").on("click",function(){b.scroll(1,B)})),b.scroll(0),a=h):H&&(t(),this.nav=H.destroy(),this.scrollGroup.attr({translateY:1}),this.clipHeight=0);return a},scroll:function(a,d){var b=this.pages,c=b.length,e=this.currentPage+a;a=this.clipHeight;var g=this.options.navigation,h=this.pager,m=this.padding;e>c&&(e=c);0<e&&(void 0!==d&&p(d,this.chart),this.nav.attr({translateX:m,translateY:a+this.padding+7+this.titleHeight,
	visibility:"visible"}),[this.up,this.upTracker].forEach(function(a){a.attr({"class":1===e?"highcharts-legend-nav-inactive":"highcharts-legend-nav-active"})}),h.attr({text:e+"/"+c}),[this.down,this.downTracker].forEach(function(a){a.attr({x:18+this.pager.getBBox().width,"class":e===c?"highcharts-legend-nav-inactive":"highcharts-legend-nav-active"})},this),this.chart.styledMode||(this.up.attr({fill:1===e?g.inactiveColor:g.activeColor}),this.upTracker.css({cursor:1===e?"default":"pointer"}),this.down.attr({fill:e===
	c?g.inactiveColor:g.activeColor}),this.downTracker.css({cursor:e===c?"default":"pointer"})),this.scrollOffset=-b[e-1]+this.initialItemY,this.scrollGroup.animate({translateY:this.scrollOffset}),this.currentPage=e,this.positionCheckboxes())}};a.LegendSymbolMixin={drawRectangle:function(a,d){var b=a.symbolHeight,c=a.options.squareSymbol;d.legendSymbol=this.chart.renderer.rect(c?(a.symbolWidth-b)/2:0,a.baseline-b+1,c?b:a.symbolWidth,b,v(a.options.symbolRadius,b/2)).addClass("highcharts-point").attr({zIndex:3}).add(d.legendGroup)},
	drawLineMarker:function(a){var b=this.options,d=b.marker,c=a.symbolWidth,e=a.symbolHeight,h=e/2,m=this.chart.renderer,k=this.legendGroup;a=a.baseline-Math.round(.3*a.fontMetrics.b);var p={};this.chart.styledMode||(p={"stroke-width":b.lineWidth||0},b.dashStyle&&(p.dashstyle=b.dashStyle));this.legendLine=m.path(["M",0,a,"L",c,a]).addClass("highcharts-graph").attr(p).add(k);d&&!1!==d.enabled&&c&&(b=Math.min(v(d.radius,h),h),0===this.symbol.indexOf("url")&&(d=u(d,{width:e,height:e}),b=0),this.legendSymbol=
	d=m.symbol(this.symbol,c/2-b,a-b,2*b,2*b,d).addClass("highcharts-point").add(k),d.isMarker=!0)}};(/Trident\/7\.0/.test(d.navigator&&d.navigator.userAgent)||q)&&m(a.Legend.prototype,"positionItem",function(a,d){var b=this,c=function(){d._legendItemPos&&a.call(b,d)};c();b.bubbleLegend||setTimeout(c)})});K(G,"parts/Chart.js",[G["parts/Globals.js"]],function(a){var C=a.addEvent,I=a.animate,F=a.animObject,k=a.attr,e=a.doc,q=a.Axis,t=a.createElement,u=a.defaultOptions,v=a.discardElement,p=a.charts,h=a.css,
	d=a.defined,m=a.extend,b=a.find,g=a.fireEvent,l=a.isNumber,c=a.isObject,w=a.isString,z=a.Legend,J=a.marginNames,D=a.merge,A=a.objectEach,n=a.Pointer,x=a.pick,B=a.pInt,E=a.removeEvent,H=a.seriesTypes,f=a.splat,r=a.syncTimeout,N=a.win,M=a.Chart=function(){this.getArgs.apply(this,arguments)};a.chart=function(a,b,c){return new M(a,b,c)};m(M.prototype,{callbacks:[],getArgs:function(){var a=[].slice.call(arguments);if(w(a[0])||a[0].nodeName)this.renderTo=a.shift();this.init(a[0],a[1])},init:function(b,
	d){var f,e=b.series,n=b.plotOptions||{};g(this,"init",{args:arguments},function(){b.series=null;f=D(u,b);A(f.plotOptions,function(a,b){c(a)&&(a.tooltip=n[b]&&D(n[b].tooltip)||void 0)});f.tooltip.userOptions=b.chart&&b.chart.forExport&&b.tooltip.userOptions||b.tooltip;f.series=b.series=e;this.userOptions=b;var h=f.chart,m=h.events;this.margin=[];this.spacing=[];this.bounds={h:{},v:{}};this.labelCollectors=[];this.callback=d;this.isResizing=0;this.options=f;this.axes=[];this.series=[];this.time=b.time&&
	Object.keys(b.time).length?new a.Time(b.time):a.time;this.styledMode=h.styledMode;this.hasCartesianSeries=h.showAxes;var l=this;l.index=p.length;p.push(l);a.chartCount++;m&&A(m,function(a,b){C(l,b,a)});l.xAxis=[];l.yAxis=[];l.pointCount=l.colorCounter=l.symbolCounter=0;g(l,"afterInit");l.firstRender()})},initSeries:function(b){var c=this.options.chart;(c=H[b.type||c.type||c.defaultSeriesType])||a.error(17,!0,this);c=new c;c.init(this,b);return c},orderSeries:function(a){var b=this.series;for(a=a||
	0;a<b.length;a++)b[a]&&(b[a].index=a,b[a].name=b[a].getName())},isInsidePlot:function(a,b,c){var d=c?b:a;a=c?a:b;return 0<=d&&d<=this.plotWidth&&0<=a&&a<=this.plotHeight},redraw:function(b){g(this,"beforeRedraw");var c=this.axes,d=this.series,f=this.pointer,e=this.legend,n=this.userOptions.legend,h=this.isDirtyLegend,l,x,r=this.hasCartesianSeries,B=this.isDirtyBox,k,p=this.renderer,E=p.isHidden(),w=[];this.setResponsive&&this.setResponsive(!1);a.setAnimation(b,this);E&&this.temporaryDisplay();this.layOutTitles();
	for(b=d.length;b--;)if(k=d[b],k.options.stacking&&(l=!0,k.isDirty)){x=!0;break}if(x)for(b=d.length;b--;)k=d[b],k.options.stacking&&(k.isDirty=!0);d.forEach(function(a){a.isDirty&&("point"===a.options.legendType?(a.updateTotals&&a.updateTotals(),h=!0):n&&(n.labelFormatter||n.labelFormat)&&(h=!0));a.isDirtyData&&g(a,"updatedData")});h&&e&&e.options.enabled&&(e.render(),this.isDirtyLegend=!1);l&&this.getStacks();r&&c.forEach(function(a){a.updateNames();a.setScale()});this.getMargins();r&&(c.forEach(function(a){a.isDirty&&
	(B=!0)}),c.forEach(function(a){var b=a.min+","+a.max;a.extKey!==b&&(a.extKey=b,w.push(function(){g(a,"afterSetExtremes",m(a.eventArgs,a.getExtremes()));delete a.eventArgs}));(B||l)&&a.redraw()}));B&&this.drawChartBox();g(this,"predraw");d.forEach(function(a){(B||a.isDirty)&&a.visible&&a.redraw();a.isDirtyData=!1});f&&f.reset(!0);p.draw();g(this,"redraw");g(this,"render");E&&this.temporaryDisplay(!0);w.forEach(function(a){a.call()})},get:function(a){function c(b){return b.id===a||b.options&&b.options.id===
	a}var d,f=this.series,e;d=b(this.axes,c)||b(this.series,c);for(e=0;!d&&e<f.length;e++)d=b(f[e].points||[],c);return d},getAxes:function(){var a=this,b=this.options,c=b.xAxis=f(b.xAxis||{}),b=b.yAxis=f(b.yAxis||{});g(this,"getAxes");c.forEach(function(a,b){a.index=b;a.isX=!0});b.forEach(function(a,b){a.index=b});c.concat(b).forEach(function(b){new q(a,b)});g(this,"afterGetAxes")},getSelectedPoints:function(){var a=[];this.series.forEach(function(b){a=a.concat((b[b.hasGroupedData?"points":"data"]||
	[]).filter(function(a){return a.selected}))});return a},getSelectedSeries:function(){return this.series.filter(function(a){return a.selected})},setTitle:function(a,b,c){var d=this,f=d.options,e=d.styledMode,g;g=f.title=D(!e&&{style:{color:"#333333",fontSize:f.isStock?"16px":"18px"}},f.title,a);f=f.subtitle=D(!e&&{style:{color:"#666666"}},f.subtitle,b);[["title",a,g],["subtitle",b,f]].forEach(function(a,b){var c=a[0],f=d[c],g=a[1];a=a[2];f&&g&&(d[c]=f=f.destroy());a&&!f&&(d[c]=d.renderer.text(a.text,
	0,0,a.useHTML).attr({align:a.align,"class":"highcharts-"+c,zIndex:a.zIndex||4}).add(),d[c].update=function(a){d.setTitle(!b&&a,b&&a)},e||d[c].css(a.style))});d.layOutTitles(c)},layOutTitles:function(a){var b=0,c,d=this.renderer,f=this.spacingBox;["title","subtitle"].forEach(function(a){var c=this[a],e=this.options[a];a="title"===a?-3:e.verticalAlign?0:b+2;var g;c&&(this.styledMode||(g=e.style.fontSize),g=d.fontMetrics(g,c).b,c.css({width:(e.width||f.width+e.widthAdjust)+"px"}).align(m({y:a+g},e),
	!1,"spacingBox"),e.floating||e.verticalAlign||(b=Math.ceil(b+c.getBBox(e.useHTML).height)))},this);c=this.titleOffset!==b;this.titleOffset=b;!this.isDirtyBox&&c&&(this.isDirtyBox=this.isDirtyLegend=c,this.hasRendered&&x(a,!0)&&this.isDirtyBox&&this.redraw())},getChartSize:function(){var b=this.options.chart,c=b.width,b=b.height,f=this.renderTo;d(c)||(this.containerWidth=a.getStyle(f,"width"));d(b)||(this.containerHeight=a.getStyle(f,"height"));this.chartWidth=Math.max(0,c||this.containerWidth||600);
	this.chartHeight=Math.max(0,a.relativeLength(b,this.chartWidth)||(1<this.containerHeight?this.containerHeight:400))},temporaryDisplay:function(b){var c=this.renderTo;if(b)for(;c&&c.style;)c.hcOrigStyle&&(a.css(c,c.hcOrigStyle),delete c.hcOrigStyle),c.hcOrigDetached&&(e.body.removeChild(c),c.hcOrigDetached=!1),c=c.parentNode;else for(;c&&c.style;){e.body.contains(c)||c.parentNode||(c.hcOrigDetached=!0,e.body.appendChild(c));if("none"===a.getStyle(c,"display",!1)||c.hcOricDetached)c.hcOrigStyle={display:c.style.display,
	height:c.style.height,overflow:c.style.overflow},b={display:"block",overflow:"hidden"},c!==this.renderTo&&(b.height=0),a.css(c,b),c.offsetWidth||c.style.setProperty("display","block","important");c=c.parentNode;if(c===e.body)break}},setClassName:function(a){this.container.className="highcharts-container "+(a||"")},getContainer:function(){var b,c=this.options,d=c.chart,f,n;b=this.renderTo;var x=a.uniqueKey(),r,E;b||(this.renderTo=b=d.renderTo);w(b)&&(this.renderTo=b=e.getElementById(b));b||a.error(13,
	!0,this);f=B(k(b,"data-highcharts-chart"));l(f)&&p[f]&&p[f].hasRendered&&p[f].destroy();k(b,"data-highcharts-chart",this.index);b.innerHTML="";d.skipClone||b.offsetWidth||this.temporaryDisplay();this.getChartSize();f=this.chartWidth;n=this.chartHeight;h(b,{overflow:"hidden"});this.styledMode||(r=m({position:"relative",overflow:"hidden",width:f+"px",height:n+"px",textAlign:"left",lineHeight:"normal",zIndex:0,"-webkit-tap-highlight-color":"rgba(0,0,0,0)"},d.style));this.container=b=t("div",{id:x},r,
	b);this._cursor=b.style.cursor;this.renderer=new (a[d.renderer]||a.Renderer)(b,f,n,null,d.forExport,c.exporting&&c.exporting.allowHTML,this.styledMode);this.setClassName(d.className);if(this.styledMode)for(E in c.defs)this.renderer.definition(c.defs[E]);else this.renderer.setStyle(d.style);this.renderer.chartIndex=this.index;g(this,"afterGetContainer")},getMargins:function(a){var b=this.spacing,c=this.margin,f=this.titleOffset;this.resetMargins();f&&!d(c[0])&&(this.plotTop=Math.max(this.plotTop,f+
	this.options.title.margin+b[0]));this.legend&&this.legend.display&&this.legend.adjustMargins(c,b);g(this,"getMargins");a||this.getAxisMargins()},getAxisMargins:function(){var a=this,b=a.axisOffset=[0,0,0,0],c=a.margin;a.hasCartesianSeries&&a.axes.forEach(function(a){a.visible&&a.getOffset()});J.forEach(function(f,e){d(c[e])||(a[f]+=b[e])});a.setChartSize()},reflow:function(b){var c=this,f=c.options.chart,g=c.renderTo,n=d(f.width)&&d(f.height),h=f.width||a.getStyle(g,"width"),f=f.height||a.getStyle(g,
	"height"),g=b?b.target:N;if(!n&&!c.isPrinting&&h&&f&&(g===N||g===e)){if(h!==c.containerWidth||f!==c.containerHeight)a.clearTimeout(c.reflowTimeout),c.reflowTimeout=r(function(){c.container&&c.setSize(void 0,void 0,!1)},b?100:0);c.containerWidth=h;c.containerHeight=f}},setReflow:function(a){var b=this;!1===a||this.unbindReflow?!1===a&&this.unbindReflow&&(this.unbindReflow=this.unbindReflow()):(this.unbindReflow=C(N,"resize",function(a){b.reflow(a)}),C(this,"destroy",this.unbindReflow))},setSize:function(b,
	c,d){var f=this,e=f.renderer,n;f.isResizing+=1;a.setAnimation(d,f);f.oldChartHeight=f.chartHeight;f.oldChartWidth=f.chartWidth;void 0!==b&&(f.options.chart.width=b);void 0!==c&&(f.options.chart.height=c);f.getChartSize();f.styledMode||(n=e.globalAnimation,(n?I:h)(f.container,{width:f.chartWidth+"px",height:f.chartHeight+"px"},n));f.setChartSize(!0);e.setSize(f.chartWidth,f.chartHeight,d);f.axes.forEach(function(a){a.isDirty=!0;a.setScale()});f.isDirtyLegend=!0;f.isDirtyBox=!0;f.layOutTitles();f.getMargins();
	f.redraw(d);f.oldChartHeight=null;g(f,"resize");r(function(){f&&g(f,"endResize",null,function(){--f.isResizing})},F(n).duration)},setChartSize:function(a){var b=this.inverted,c=this.renderer,f=this.chartWidth,d=this.chartHeight,e=this.options.chart,n=this.spacing,h=this.clipOffset,l,m,x,r;this.plotLeft=l=Math.round(this.plotLeft);this.plotTop=m=Math.round(this.plotTop);this.plotWidth=x=Math.max(0,Math.round(f-l-this.marginRight));this.plotHeight=r=Math.max(0,Math.round(d-m-this.marginBottom));this.plotSizeX=
	b?r:x;this.plotSizeY=b?x:r;this.plotBorderWidth=e.plotBorderWidth||0;this.spacingBox=c.spacingBox={x:n[3],y:n[0],width:f-n[3]-n[1],height:d-n[0]-n[2]};this.plotBox=c.plotBox={x:l,y:m,width:x,height:r};f=2*Math.floor(this.plotBorderWidth/2);b=Math.ceil(Math.max(f,h[3])/2);c=Math.ceil(Math.max(f,h[0])/2);this.clipBox={x:b,y:c,width:Math.floor(this.plotSizeX-Math.max(f,h[1])/2-b),height:Math.max(0,Math.floor(this.plotSizeY-Math.max(f,h[2])/2-c))};a||this.axes.forEach(function(a){a.setAxisSize();a.setAxisTranslation()});
	g(this,"afterSetChartSize",{skipAxes:a})},resetMargins:function(){g(this,"resetMargins");var a=this,b=a.options.chart;["margin","spacing"].forEach(function(f){var d=b[f],e=c(d)?d:[d,d,d,d];["Top","Right","Bottom","Left"].forEach(function(c,d){a[f][d]=x(b[f+c],e[d])})});J.forEach(function(b,c){a[b]=x(a.margin[c],a.spacing[c])});a.axisOffset=[0,0,0,0];a.clipOffset=[0,0,0,0]},drawChartBox:function(){var a=this.options.chart,b=this.renderer,c=this.chartWidth,f=this.chartHeight,d=this.chartBackground,
	e=this.plotBackground,n=this.plotBorder,h,l=this.styledMode,m=this.plotBGImage,x=a.backgroundColor,r=a.plotBackgroundColor,B=a.plotBackgroundImage,k,p=this.plotLeft,E=this.plotTop,w=this.plotWidth,H=this.plotHeight,z=this.plotBox,A=this.clipRect,q=this.clipBox,t="animate";d||(this.chartBackground=d=b.rect().addClass("highcharts-background").add(),t="attr");if(l)h=k=d.strokeWidth();else{h=a.borderWidth||0;k=h+(a.shadow?8:0);x={fill:x||"none"};if(h||d["stroke-width"])x.stroke=a.borderColor,x["stroke-width"]=
	h;d.attr(x).shadow(a.shadow)}d[t]({x:k/2,y:k/2,width:c-k-h%2,height:f-k-h%2,r:a.borderRadius});t="animate";e||(t="attr",this.plotBackground=e=b.rect().addClass("highcharts-plot-background").add());e[t](z);l||(e.attr({fill:r||"none"}).shadow(a.plotShadow),B&&(m?m.animate(z):this.plotBGImage=b.image(B,p,E,w,H).add()));A?A.animate({width:q.width,height:q.height}):this.clipRect=b.clipRect(q);t="animate";n||(t="attr",this.plotBorder=n=b.rect().addClass("highcharts-plot-border").attr({zIndex:1}).add());
	l||n.attr({stroke:a.plotBorderColor,"stroke-width":a.plotBorderWidth||0,fill:"none"});n[t](n.crisp({x:p,y:E,width:w,height:H},-n.strokeWidth()));this.isDirtyBox=!1;g(this,"afterDrawChartBox")},propFromSeries:function(){var a=this,b=a.options.chart,c,f=a.options.series,d,e;["inverted","angular","polar"].forEach(function(g){c=H[b.type||b.defaultSeriesType];e=b[g]||c&&c.prototype[g];for(d=f&&f.length;!e&&d--;)(c=H[f[d].type])&&c.prototype[g]&&(e=!0);a[g]=e})},linkSeries:function(){var a=this,b=a.series;
	b.forEach(function(a){a.linkedSeries.length=0});b.forEach(function(b){var c=b.options.linkedTo;w(c)&&(c=":previous"===c?a.series[b.index-1]:a.get(c))&&c.linkedParent!==b&&(c.linkedSeries.push(b),b.linkedParent=c,b.visible=x(b.options.visible,c.options.visible,b.visible))});g(this,"afterLinkSeries")},renderSeries:function(){this.series.forEach(function(a){a.translate();a.render()})},renderLabels:function(){var a=this,b=a.options.labels;b.items&&b.items.forEach(function(c){var f=m(b.style,c.style),
	d=B(f.left)+a.plotLeft,e=B(f.top)+a.plotTop+12;delete f.left;delete f.top;a.renderer.text(c.html,d,e).attr({zIndex:2}).css(f).add()})},render:function(){var a=this.axes,b=this.renderer,c=this.options,f=0,d,e,g;this.setTitle();this.legend=new z(this,c.legend);this.getStacks&&this.getStacks();this.getMargins(!0);this.setChartSize();c=this.plotWidth;a.some(function(a){if(a.horiz&&a.visible&&a.options.labels.enabled&&a.series.length)return f=21,!0});d=this.plotHeight=Math.max(this.plotHeight-f,0);a.forEach(function(a){a.setScale()});
	this.getAxisMargins();e=1.1<c/this.plotWidth;g=1.05<d/this.plotHeight;if(e||g)a.forEach(function(a){(a.horiz&&e||!a.horiz&&g)&&a.setTickInterval(!0)}),this.getMargins();this.drawChartBox();this.hasCartesianSeries&&a.forEach(function(a){a.visible&&a.render()});this.seriesGroup||(this.seriesGroup=b.g("series-group").attr({zIndex:3}).add());this.renderSeries();this.renderLabels();this.addCredits();this.setResponsive&&this.setResponsive();this.hasRendered=!0},addCredits:function(a){var b=this;a=D(!0,
	this.options.credits,a);a.enabled&&!this.credits&&(this.credits=this.renderer.text(a.text+(this.mapCredits||""),0,0).addClass("highcharts-credits").on("click",function(){a.href&&(N.location.href=a.href)}).attr({align:a.position.align,zIndex:8}),b.styledMode||this.credits.css(a.style),this.credits.add().align(a.position),this.credits.update=function(a){b.credits=b.credits.destroy();b.addCredits(a)})},destroy:function(){var b=this,c=b.axes,f=b.series,d=b.container,e,n=d&&d.parentNode;g(b,"destroy");
	b.renderer.forExport?a.erase(p,b):p[b.index]=void 0;a.chartCount--;b.renderTo.removeAttribute("data-highcharts-chart");E(b);for(e=c.length;e--;)c[e]=c[e].destroy();this.scroller&&this.scroller.destroy&&this.scroller.destroy();for(e=f.length;e--;)f[e]=f[e].destroy();"title subtitle chartBackground plotBackground plotBGImage plotBorder seriesGroup clipRect credits pointer rangeSelector legend resetZoomButton tooltip renderer".split(" ").forEach(function(a){var c=b[a];c&&c.destroy&&(b[a]=c.destroy())});
	d&&(d.innerHTML="",E(d),n&&v(d));A(b,function(a,c){delete b[c]})},firstRender:function(){var b=this,c=b.options;if(!b.isReadyToRender||b.isReadyToRender()){b.getContainer();b.resetMargins();b.setChartSize();b.propFromSeries();b.getAxes();(a.isArray(c.series)?c.series:[]).forEach(function(a){b.initSeries(a)});b.linkSeries();g(b,"beforeRender");n&&(b.pointer=new n(b,c));b.render();if(!b.renderer.imgCount&&b.onload)b.onload();b.temporaryDisplay(!0)}},onload:function(){[this.callback].concat(this.callbacks).forEach(function(a){a&&
	void 0!==this.index&&a.apply(this,[this])},this);g(this,"load");g(this,"render");d(this.index)&&this.setReflow(this.options.chart.reflow);this.onload=null}})});K(G,"parts/ScrollablePlotArea.js",[G["parts/Globals.js"]],function(a){var C=a.addEvent,I=a.Chart;C(I,"afterSetChartSize",function(C){var k=this.options.chart.scrollablePlotArea;(k=k&&k.minWidth)&&!this.renderer.forExport&&(this.scrollablePixels=k=Math.max(0,k-this.chartWidth))&&(this.plotWidth+=k,this.clipBox.width+=k,C.skipAxes||this.axes.forEach(function(e){1===
	e.side?e.getPlotLinePath=function(){var k=this.right,t;this.right=k-e.chart.scrollablePixels;t=a.Axis.prototype.getPlotLinePath.apply(this,arguments);this.right=k;return t}:(e.setAxisSize(),e.setAxisTranslation())}))});C(I,"render",function(){this.scrollablePixels?(this.setUpScrolling&&this.setUpScrolling(),this.applyFixed()):this.fixedDiv&&this.applyFixed()});I.prototype.setUpScrolling=function(){this.scrollingContainer=a.createElement("div",{className:"highcharts-scrolling"},{overflowX:"auto",WebkitOverflowScrolling:"touch"},
	this.renderTo);this.innerContainer=a.createElement("div",{className:"highcharts-inner-container"},null,this.scrollingContainer);this.innerContainer.appendChild(this.container);this.setUpScrolling=null};I.prototype.moveFixedElements=function(){var a=this.container,k=this.fixedRenderer;[this.inverted?".highcharts-xaxis":".highcharts-yaxis",this.inverted?".highcharts-xaxis-labels":".highcharts-yaxis-labels",".highcharts-contextbutton",".highcharts-credits",".highcharts-legend",".highcharts-reset-zoom",
	".highcharts-subtitle",".highcharts-title",".highcharts-legend-checkbox"].forEach(function(e){[].forEach.call(a.querySelectorAll(e),function(a){(a.namespaceURI===k.SVG_NS?k.box:k.box.parentNode).appendChild(a);a.style.pointerEvents="auto"})})};I.prototype.applyFixed=function(){var F,k=!this.fixedDiv,e=this.options.chart.scrollablePlotArea;k&&(this.fixedDiv=a.createElement("div",{className:"highcharts-fixed"},{position:"absolute",overflow:"hidden",pointerEvents:"none",zIndex:2},null,!0),this.renderTo.insertBefore(this.fixedDiv,
	this.renderTo.firstChild),this.renderTo.style.overflow="visible",this.fixedRenderer=F=new a.Renderer(this.fixedDiv,0,0),this.scrollableMask=F.path().attr({fill:a.color(this.options.chart.backgroundColor||"#fff").setOpacity(a.pick(e.opacity,.85)).get(),zIndex:-1}).addClass("highcharts-scrollable-mask").add(),this.moveFixedElements(),C(this,"afterShowResetZoom",this.moveFixedElements));this.fixedRenderer.setSize(this.chartWidth,this.chartHeight);F=this.chartWidth+this.scrollablePixels;a.stop(this.container);
	this.container.style.width=F+"px";this.renderer.boxWrapper.attr({width:F,height:this.chartHeight,viewBox:[0,0,F,this.chartHeight].join(" ")});this.chartBackground.attr({width:F});k&&e.scrollPositionX&&(this.scrollingContainer.scrollLeft=this.scrollablePixels*e.scrollPositionX);e=this.axisOffset;k=this.plotTop-e[0]-1;e=this.plotTop+this.plotHeight+e[2];F=this.plotLeft+this.plotWidth-this.scrollablePixels;this.scrollableMask.attr({d:this.scrollablePixels?["M",0,k,"L",this.plotLeft-1,k,"L",this.plotLeft-
	1,e,"L",0,e,"Z","M",F,k,"L",this.chartWidth,k,"L",this.chartWidth,e,"L",F,e,"Z"]:["M",0,0]})}});K(G,"parts/Point.js",[G["parts/Globals.js"]],function(a){var C,I=a.extend,F=a.erase,k=a.fireEvent,e=a.format,q=a.isArray,t=a.isNumber,u=a.pick,v=a.uniqueKey,p=a.defined,h=a.removeEvent;a.Point=C=function(){};a.Point.prototype={init:function(a,e,b){this.series=a;this.applyOptions(e,b);this.id=p(this.id)?this.id:v();this.resolveColor();a.chart.pointCount++;k(this,"afterInit");return this},resolveColor:function(){var a=
	this.series,e;e=a.chart.options.chart.colorCount;var b=a.chart.styledMode;b||this.options.color||(this.color=a.color);a.options.colorByPoint?(b||(e=a.options.colors||a.chart.options.colors,this.color=this.color||e[a.colorCounter],e=e.length),b=a.colorCounter,a.colorCounter++,a.colorCounter===e&&(a.colorCounter=0)):b=a.colorIndex;this.colorIndex=u(this.colorIndex,b)},applyOptions:function(a,e){var b=this.series,d=b.options.pointValKey||b.pointValKey;a=C.prototype.optionsToObject.call(this,a);I(this,
	a);this.options=this.options?I(this.options,a):a;a.group&&delete this.group;a.dataLabels&&delete this.dataLabels;d&&(this.y=this[d]);if(this.isNull=u(this.isValid&&!this.isValid(),null===this.x||!t(this.y,!0)))this.formatPrefix="null";this.selected&&(this.state="select");"name"in this&&void 0===e&&b.xAxis&&b.xAxis.hasNames&&(this.x=b.xAxis.nameToX(this));void 0===this.x&&b&&(this.x=void 0===e?b.autoIncrement(this):e);return this},setNestedProperty:function(d,e,b){b.split(".").reduce(function(b,d,
	c,h){b[d]=h.length-1===c?e:a.isObject(b[d],!0)?b[d]:{};return b[d]},d);return d},optionsToObject:function(d){var e={},b=this.series,g=b.options.keys,h=g||b.pointArrayMap||["y"],c=h.length,k=0,p=0;if(t(d)||null===d)e[h[0]]=d;else if(q(d))for(!g&&d.length>c&&(b=typeof d[0],"string"===b?e.name=d[0]:"number"===b&&(e.x=d[0]),k++);p<c;)g&&void 0===d[k]||(0<h[p].indexOf(".")?a.Point.prototype.setNestedProperty(e,d[k],h[p]):e[h[p]]=d[k]),k++,p++;else"object"===typeof d&&(e=d,d.dataLabels&&(b._hasPointLabels=
	!0),d.marker&&(b._hasPointMarkers=!0));return e},getClassName:function(){return"highcharts-point"+(this.selected?" highcharts-point-select":"")+(this.negative?" highcharts-negative":"")+(this.isNull?" highcharts-null-point":"")+(void 0!==this.colorIndex?" highcharts-color-"+this.colorIndex:"")+(this.options.className?" "+this.options.className:"")+(this.zone&&this.zone.className?" "+this.zone.className.replace("highcharts-negative",""):"")},getZone:function(){var a=this.series,e=a.zones,a=a.zoneAxis||
	"y",b=0,g;for(g=e[b];this[a]>=g.value;)g=e[++b];this.nonZonedColor||(this.nonZonedColor=this.color);this.color=g&&g.color&&!this.options.color?g.color:this.nonZonedColor;return g},destroy:function(){var a=this.series.chart,e=a.hoverPoints,b;a.pointCount--;e&&(this.setState(),F(e,this),e.length||(a.hoverPoints=null));if(this===a.hoverPoint)this.onMouseOut();if(this.graphic||this.dataLabel||this.dataLabels)h(this),this.destroyElements();this.legendItem&&a.legend.destroyItem(this);for(b in this)this[b]=
	null},destroyElements:function(a){var d=this,b=[],e,h;a=a||{graphic:1,dataLabel:1};a.graphic&&b.push("graphic","shadowGroup");a.dataLabel&&b.push("dataLabel","dataLabelUpper","connector");for(h=b.length;h--;)e=b[h],d[e]&&(d[e]=d[e].destroy());["dataLabel","connector"].forEach(function(b){var c=b+"s";a[b]&&d[c]&&(d[c].forEach(function(a){a.element&&a.destroy()}),delete d[c])})},getLabelConfig:function(){return{x:this.category,y:this.y,color:this.color,colorIndex:this.colorIndex,key:this.name||this.category,
	series:this.series,point:this,percentage:this.percentage,total:this.total||this.stackTotal}},tooltipFormatter:function(a){var d=this.series,b=d.tooltipOptions,g=u(b.valueDecimals,""),h=b.valuePrefix||"",c=b.valueSuffix||"";d.chart.styledMode&&(a=d.chart.tooltip.styledModeFormat(a));(d.pointArrayMap||["y"]).forEach(function(b){b="{point."+b;if(h||c)a=a.replace(RegExp(b+"}","g"),h+b+"}"+c);a=a.replace(RegExp(b+"}","g"),b+":,."+g+"f}")});return e(a,{point:this,series:this.series},d.chart.time)},firePointEvent:function(a,
	e,b){var d=this,h=this.series.options;(h.point.events[a]||d.options&&d.options.events&&d.options.events[a])&&this.importEvents();"click"===a&&h.allowPointSelect&&(b=function(a){d.select&&d.select(null,a.ctrlKey||a.metaKey||a.shiftKey)});k(this,a,e,b)},visible:!0}});K(G,"parts/Series.js",[G["parts/Globals.js"]],function(a){var C=a.addEvent,I=a.animObject,F=a.arrayMax,k=a.arrayMin,e=a.correctFloat,q=a.defaultOptions,t=a.defaultPlotOptions,u=a.defined,v=a.erase,p=a.extend,h=a.fireEvent,d=a.isArray,m=
	a.isNumber,b=a.isString,g=a.merge,l=a.objectEach,c=a.pick,w=a.removeEvent,z=a.splat,J=a.SVGElement,D=a.syncTimeout,A=a.win;a.Series=a.seriesType("line",null,{lineWidth:2,allowPointSelect:!1,showCheckbox:!1,animation:{duration:1E3},events:{},marker:{lineWidth:0,lineColor:"#ffffff",enabledThreshold:2,radius:4,states:{normal:{animation:!0},hover:{animation:{duration:50},enabled:!0,radiusPlus:2,lineWidthPlus:1},select:{fillColor:"#cccccc",lineColor:"#000000",lineWidth:2}}},point:{events:{}},dataLabels:{align:"center",
	formatter:function(){return null===this.y?"":a.numberFormat(this.y,-1)},padding:5,style:{fontSize:"11px",fontWeight:"bold",color:"contrast",textOutline:"1px contrast"},verticalAlign:"bottom",x:0,y:0},cropThreshold:300,opacity:1,pointRange:0,softThreshold:!0,states:{normal:{animation:!0},hover:{animation:{duration:50},lineWidthPlus:1,marker:{},halo:{size:10,opacity:.25}},select:{animation:{duration:0}},inactive:{animation:{duration:50},opacity:.2}},stickyTracking:!0,turboThreshold:1E3,findNearestPointBy:"x"},
	{isCartesian:!0,pointClass:a.Point,sorted:!0,requireSorting:!0,directTouch:!1,axisTypes:["xAxis","yAxis"],colorCounter:0,parallelArrays:["x","y"],coll:"series",cropShoulder:1,init:function(a,b){h(this,"init",{options:b});var d=this,e,g=a.series,f;d.chart=a;d.options=b=d.setOptions(b);d.linkedSeries=[];d.bindAxes();p(d,{name:b.name,state:"",visible:!1!==b.visible,selected:!0===b.selected});e=b.events;l(e,function(a,b){d.hcEvents&&d.hcEvents[b]&&-1!==d.hcEvents[b].indexOf(a)||C(d,b,a)});if(e&&e.click||
	b.point&&b.point.events&&b.point.events.click||b.allowPointSelect)a.runTrackerClick=!0;d.getColor();d.getSymbol();d.parallelArrays.forEach(function(a){d[a+"Data"]||(d[a+"Data"]=[])});d.points||d.setData(b.data,!1);d.isCartesian&&(a.hasCartesianSeries=!0);g.length&&(f=g[g.length-1]);d._i=c(f&&f._i,-1)+1;a.orderSeries(this.insert(g));h(this,"afterInit")},insert:function(a){var b=this.options.index,d;if(m(b)){for(d=a.length;d--;)if(b>=c(a[d].options.index,a[d]._i)){a.splice(d+1,0,this);break}-1===d&&
	a.unshift(this);d+=1}else a.push(this);return c(d,a.length-1)},bindAxes:function(){var b=this,c=b.options,d=b.chart,e;h(this,"bindAxes",null,function(){(b.axisTypes||[]).forEach(function(g){d[g].forEach(function(a){e=a.options;if(c[g]===e.index||void 0!==c[g]&&c[g]===e.id||void 0===c[g]&&0===e.index)b.insert(a.series),b[g]=a,a.isDirty=!0});b[g]||b.optionalAxis===g||a.error(18,!0,d)})})},updateParallelArrays:function(a,b){var c=a.series,d=arguments,e=m(b)?function(d){var f="y"===d&&c.toYData?c.toYData(a):
	a[d];c[d+"Data"][b]=f}:function(a){Array.prototype[b].apply(c[a+"Data"],Array.prototype.slice.call(d,2))};c.parallelArrays.forEach(e)},hasData:function(){return this.visible&&void 0!==this.dataMax&&void 0!==this.dataMin||this.visible&&this.yData&&0<this.yData.length},autoIncrement:function(){var a=this.options,b=this.xIncrement,d,e=a.pointIntervalUnit,g=this.chart.time,b=c(b,a.pointStart,0);this.pointInterval=d=c(this.pointInterval,a.pointInterval,1);e&&(a=new g.Date(b),"day"===e?g.set("Date",a,g.get("Date",
	a)+d):"month"===e?g.set("Month",a,g.get("Month",a)+d):"year"===e&&g.set("FullYear",a,g.get("FullYear",a)+d),d=a.getTime()-b);this.xIncrement=b+d;return b},setOptions:function(a){var b=this.chart,d=b.options,e=d.plotOptions,n=(b.userOptions||{}).plotOptions||{},f=e[this.type],l=g(a);a=b.styledMode;h(this,"setOptions",{userOptions:l});this.userOptions=l;b=g(f,e.series,l);this.tooltipOptions=g(q.tooltip,q.plotOptions.series&&q.plotOptions.series.tooltip,q.plotOptions[this.type].tooltip,d.tooltip.userOptions,
	e.series&&e.series.tooltip,e[this.type].tooltip,l.tooltip);this.stickyTracking=c(l.stickyTracking,n[this.type]&&n[this.type].stickyTracking,n.series&&n.series.stickyTracking,this.tooltipOptions.shared&&!this.noSharedTooltip?!0:b.stickyTracking);null===f.marker&&delete b.marker;this.zoneAxis=b.zoneAxis;d=this.zones=(b.zones||[]).slice();!b.negativeColor&&!b.negativeFillColor||b.zones||(e={value:b[this.zoneAxis+"Threshold"]||b.threshold||0,className:"highcharts-negative"},a||(e.color=b.negativeColor,
	e.fillColor=b.negativeFillColor),d.push(e));d.length&&u(d[d.length-1].value)&&d.push(a?{}:{color:this.color,fillColor:this.fillColor});h(this,"afterSetOptions",{options:b});return b},getName:function(){return c(this.options.name,"Series "+(this.index+1))},getCyclic:function(a,b,d){var e,g=this.chart,f=this.userOptions,h=a+"Index",n=a+"Counter",l=d?d.length:c(g.options.chart[a+"Count"],g[a+"Count"]);b||(e=c(f[h],f["_"+h]),u(e)||(g.series.length||(g[n]=0),f["_"+h]=e=g[n]%l,g[n]+=1),d&&(b=d[e]));void 0!==
	e&&(this[h]=e);this[a]=b},getColor:function(){this.chart.styledMode?this.getCyclic("color"):this.options.colorByPoint?this.options.color=null:this.getCyclic("color",this.options.color||t[this.type].color,this.chart.options.colors)},getSymbol:function(){this.getCyclic("symbol",this.options.marker.symbol,this.chart.options.symbols)},findPointIndex:function(a,b){var c=a.id;a=a.x;var d=this.points,e,f;c&&(f=(c=this.chart.get(c))&&c.index,void 0!==f&&(e=!0));void 0===f&&m(a)&&(f=this.xData.indexOf(a,b));
	-1!==f&&void 0!==f&&this.cropped&&(f=f>=this.cropStart?f-this.cropStart:f);!e&&d[f]&&d[f].touched&&(f=void 0);return f},drawLegendSymbol:a.LegendSymbolMixin.drawLineMarker,updateData:function(b){var c=this.options,d=this.points,e=[],g,f,h,n=this.requireSorting,l=b.length===d.length,k=!0;this.xIncrement=null;b.forEach(function(b,f){var r,k=a.defined(b)&&this.pointClass.prototype.optionsToObject.call({series:this},b)||{};r=k.x;if(k.id||m(r))if(r=this.findPointIndex(k,h),-1===r||void 0===r?e.push(b):
	d[r]&&b!==c.data[r]?(d[r].update(b,!1,null,!1),d[r].touched=!0,n&&(h=r+1)):d[r]&&(d[r].touched=!0),!l||f!==r||this.hasDerivedData)g=!0},this);if(g)for(b=d.length;b--;)(f=d[b])&&!f.touched&&f.remove(!1);else l?b.forEach(function(a,b){d[b].update&&a!==d[b].y&&d[b].update(a,!1,null,!1)}):k=!1;d.forEach(function(a){a&&(a.touched=!1)});if(!k)return!1;e.forEach(function(a){this.addPoint(a,!1,null,null,!1)},this);return!0},setData:function(e,g,h,l){var n=this,f=n.points,r=f&&f.length||0,k,x=n.options,p=
	n.chart,B=null,w=n.xAxis,z=x.turboThreshold,E=this.xData,A=this.yData,q=(k=n.pointArrayMap)&&k.length,t=x.keys,D=0,u=1,v;e=e||[];k=e.length;g=c(g,!0);!1!==l&&k&&r&&!n.cropped&&!n.hasGroupedData&&n.visible&&!n.isSeriesBoosting&&(v=this.updateData(e));if(!v){n.xIncrement=null;n.colorCounter=0;this.parallelArrays.forEach(function(a){n[a+"Data"].length=0});if(z&&k>z){for(h=0;null===B&&h<k;)B=e[h],h++;if(m(B))for(h=0;h<k;h++)E[h]=this.autoIncrement(),A[h]=e[h];else if(d(B))if(q)for(h=0;h<k;h++)B=e[h],
	E[h]=B[0],A[h]=B.slice(1,q+1);else for(t&&(D=t.indexOf("x"),u=t.indexOf("y"),D=0<=D?D:0,u=0<=u?u:1),h=0;h<k;h++)B=e[h],E[h]=B[D],A[h]=B[u];else a.error(12,!1,p)}else for(h=0;h<k;h++)void 0!==e[h]&&(B={series:n},n.pointClass.prototype.applyOptions.apply(B,[e[h]]),n.updateParallelArrays(B,h));A&&b(A[0])&&a.error(14,!0,p);n.data=[];n.options.data=n.userOptions.data=e;for(h=r;h--;)f[h]&&f[h].destroy&&f[h].destroy();w&&(w.minRange=w.userMinRange);n.isDirty=p.isDirtyBox=!0;n.isDirtyData=!!f;h=!1}"point"===
	x.legendType&&(this.processData(),this.generatePoints());g&&p.redraw(h)},processData:function(b){var c=this.xData,d=this.yData,e=c.length,g;g=0;var f,h,n=this.xAxis,l,m=this.options;l=m.cropThreshold;var k=this.getExtremesFromAll||m.getExtremesFromAll,p=this.isCartesian,m=n&&n.val2lin,w=n&&n.isLog,z=this.requireSorting,A,q;if(p&&!this.isDirty&&!n.isDirty&&!this.yAxis.isDirty&&!b)return!1;n&&(b=n.getExtremes(),A=b.min,q=b.max);p&&this.sorted&&!k&&(!l||e>l||this.forceCrop)&&(c[e-1]<A||c[0]>q?(c=[],
	d=[]):this.yData&&(c[0]<A||c[e-1]>q)&&(g=this.cropData(this.xData,this.yData,A,q),c=g.xData,d=g.yData,g=g.start,f=!0));for(l=c.length||1;--l;)e=w?m(c[l])-m(c[l-1]):c[l]-c[l-1],0<e&&(void 0===h||e<h)?h=e:0>e&&z&&(a.error(15,!1,this.chart),z=!1);this.cropped=f;this.cropStart=g;this.processedXData=c;this.processedYData=d;this.closestPointRange=h},cropData:function(a,b,d,e,g){var f=a.length,h=0,n=f,l;g=c(g,this.cropShoulder);for(l=0;l<f;l++)if(a[l]>=d){h=Math.max(0,l-g);break}for(d=l;d<f;d++)if(a[d]>
	e){n=d+g;break}return{xData:a.slice(h,n),yData:b.slice(h,n),start:h,end:n}},generatePoints:function(){var a=this.options,b=a.data,c=this.data,d,e=this.processedXData,f=this.processedYData,g=this.pointClass,l=e.length,m=this.cropStart||0,k,w=this.hasGroupedData,a=a.keys,A,q=[],t;c||w||(c=[],c.length=b.length,c=this.data=c);a&&w&&(this.options.keys=!1);for(t=0;t<l;t++)k=m+t,w?(A=(new g).init(this,[e[t]].concat(z(f[t]))),A.dataGroup=this.groupMap[t],A.dataGroup.options&&(A.options=A.dataGroup.options,
	p(A,A.dataGroup.options),delete A.dataLabels)):(A=c[k])||void 0===b[k]||(c[k]=A=(new g).init(this,b[k],e[t])),A&&(A.index=k,q[t]=A);this.options.keys=a;if(c&&(l!==(d=c.length)||w))for(t=0;t<d;t++)t!==m||w||(t+=l),c[t]&&(c[t].destroyElements(),c[t].plotX=void 0);this.data=c;this.points=q;h(this,"afterGeneratePoints")},getXExtremes:function(a){return{min:k(a),max:F(a)}},getExtremes:function(a){var b=this.yAxis,c=this.processedXData,e,g=[],f=0;e=this.xAxis.getExtremes();var n=e.min,l=e.max,p,w,A=this.requireSorting?
	this.cropShoulder:0,z,q;a=a||this.stackedYData||this.processedYData||[];e=a.length;for(q=0;q<e;q++)if(w=c[q],z=a[q],p=(m(z,!0)||d(z))&&(!b.positiveValuesOnly||z.length||0<z),w=this.getExtremesFromAll||this.options.getExtremesFromAll||this.cropped||(c[q+A]||w)>=n&&(c[q-A]||w)<=l,p&&w)if(p=z.length)for(;p--;)"number"===typeof z[p]&&(g[f++]=z[p]);else g[f++]=z;this.dataMin=k(g);this.dataMax=F(g);h(this,"afterGetExtremes")},translate:function(){this.processedXData||this.processData();this.generatePoints();
	var a=this.options,b=a.stacking,g=this.xAxis,l=g.categories,k=this.yAxis,f=this.points,r=f.length,p=!!this.modifyValue,w,A=this.pointPlacementToXValue(),z=m(A),q=a.threshold,t=a.startFromThreshold?q:0,D,v,J,C,F=this.zoneAxis||"y",I=Number.MAX_VALUE;for(w=0;w<r;w++){var G=f[w],K=G.x;v=G.y;var V=G.low,Q=b&&k.stacks[(this.negStacks&&v<(t?0:q)?"-":"")+this.stackKey],W,X;k.positiveValuesOnly&&null!==v&&0>=v&&(G.isNull=!0);G.plotX=D=e(Math.min(Math.max(-1E5,g.translate(K,0,0,0,1,A,"flags"===this.type)),
	1E5));b&&this.visible&&!G.isNull&&Q&&Q[K]&&(C=this.getStackIndicator(C,K,this.index),W=Q[K],X=W.points[C.key]);d(X)&&(V=X[0],v=X[1],V===t&&C.key===Q[K].base&&(V=c(m(q)&&q,k.min)),k.positiveValuesOnly&&0>=V&&(V=null),G.total=G.stackTotal=W.total,G.percentage=W.total&&G.y/W.total*100,G.stackY=v,W.setOffset(this.pointXOffset||0,this.barW||0));G.yBottom=u(V)?Math.min(Math.max(-1E5,k.translate(V,0,1,0,1)),1E5):null;p&&(v=this.modifyValue(v,G));G.plotY=v="number"===typeof v&&Infinity!==v?Math.min(Math.max(-1E5,
	k.translate(v,0,1,0,1)),1E5):void 0;G.isInside=void 0!==v&&0<=v&&v<=k.len&&0<=D&&D<=g.len;G.clientX=z?e(g.translate(K,0,0,0,1,A)):D;G.negative=G[F]<(a[F+"Threshold"]||q||0);G.category=l&&void 0!==l[G.x]?l[G.x]:G.x;G.isNull||(void 0!==J&&(I=Math.min(I,Math.abs(D-J))),J=D);G.zone=this.zones.length&&G.getZone()}this.closestPointRangePx=I;h(this,"afterTranslate")},getValidPoints:function(a,b,c){var d=this.chart;return(a||this.points||[]).filter(function(a){return b&&!d.isInsidePlot(a.plotX,a.plotY,d.inverted)?
	!1:c||!a.isNull})},setClip:function(a){var b=this.chart,c=this.options,d=b.renderer,e=b.inverted,f=this.clipBox,g=f||b.clipBox,h=this.sharedClipKey||["_sharedClip",a&&a.duration,a&&a.easing,g.height,c.xAxis,c.yAxis].join(),n=b[h],l=b[h+"m"];n||(a&&(g.width=0,e&&(g.x=b.plotSizeX),b[h+"m"]=l=d.clipRect(e?b.plotSizeX+99:-99,e?-b.plotLeft:-b.plotTop,99,e?b.chartWidth:b.chartHeight)),b[h]=n=d.clipRect(g),n.count={length:0});a&&!n.count[this.index]&&(n.count[this.index]=!0,n.count.length+=1);!1!==c.clip&&
	(this.group.clip(a||f?n:b.clipRect),this.markerGroup.clip(l),this.sharedClipKey=h);a||(n.count[this.index]&&(delete n.count[this.index],--n.count.length),0===n.count.length&&h&&b[h]&&(f||(b[h]=b[h].destroy()),b[h+"m"]&&(b[h+"m"]=b[h+"m"].destroy())))},animate:function(a){var b=this.chart,c=I(this.options.animation),d;a?this.setClip(c):(d=this.sharedClipKey,(a=b[d])&&a.animate({width:b.plotSizeX,x:0},c),b[d+"m"]&&b[d+"m"].animate({width:b.plotSizeX+99,x:b.inverted?0:-99},c),this.animate=null)},afterAnimate:function(){this.setClip();
	h(this,"afterAnimate");this.finishedAnimating=!0},drawPoints:function(){var a=this.points,b=this.chart,d,e,g,f,h,l=this.options.marker,m,k,p,w=this[this.specialGroup]||this.markerGroup;d=this.xAxis;var A,z=c(l.enabled,!d||d.isRadial?!0:null,this.closestPointRangePx>=l.enabledThreshold*l.radius);if(!1!==l.enabled||this._hasPointMarkers)for(d=0;d<a.length;d++)if(e=a[d],h=(f=e.graphic)?"animate":"attr",m=e.marker||{},k=!!e.marker,g=z&&void 0===m.enabled||m.enabled,p=!1!==e.isInside,g&&!e.isNull){g=c(m.symbol,
	this.symbol);A=this.markerAttribs(e,e.selected&&"select");f?f[p?"show":"hide"](!0).animate(A):p&&(0<A.width||e.hasImage)&&(e.graphic=f=b.renderer.symbol(g,A.x,A.y,A.width,A.height,k?m:l).add(w));if(f&&!b.styledMode)f[h](this.pointAttribs(e,e.selected&&"select"));f&&f.addClass(e.getClassName(),!0)}else f&&(e.graphic=f.destroy())},markerAttribs:function(a,b){var d=this.options.marker,e=a.marker||{},g=e.symbol||d.symbol,f=c(e.radius,d.radius);b&&(d=d.states[b],b=e.states&&e.states[b],f=c(b&&b.radius,
	d&&d.radius,f+(d&&d.radiusPlus||0)));a.hasImage=g&&0===g.indexOf("url");a.hasImage&&(f=0);a={x:Math.floor(a.plotX)-f,y:a.plotY-f};f&&(a.width=a.height=2*f);return a},pointAttribs:function(a,b){var d=this.options.marker,e=a&&a.options,g=e&&e.marker||{},f=this.color,h=e&&e.color,n=a&&a.color,e=c(g.lineWidth,d.lineWidth),l=a&&a.zone&&a.zone.color;a=1;f=h||l||n||f;h=g.fillColor||d.fillColor||f;f=g.lineColor||d.lineColor||f;b&&(d=d.states[b],b=g.states&&g.states[b]||{},e=c(b.lineWidth,d.lineWidth,e+c(b.lineWidthPlus,
	d.lineWidthPlus,0)),h=b.fillColor||d.fillColor||h,f=b.lineColor||d.lineColor||f,a=c(b.opacity,d.opacity,a));return{stroke:f,"stroke-width":e,fill:h,opacity:a}},destroy:function(b){var c=this,d=c.chart,e=/AppleWebKit\/533/.test(A.navigator.userAgent),g,f,n=c.data||[],m,k;h(c,"destroy");b||w(c);(c.axisTypes||[]).forEach(function(a){(k=c[a])&&k.series&&(v(k.series,c),k.isDirty=k.forceRedraw=!0)});c.legendItem&&c.chart.legend.destroyItem(c);for(f=n.length;f--;)(m=n[f])&&m.destroy&&m.destroy();c.points=
	null;a.clearTimeout(c.animationTimeout);l(c,function(a,b){a instanceof J&&!a.survive&&(g=e&&"group"===b?"hide":"destroy",a[g]())});d.hoverSeries===c&&(d.hoverSeries=null);v(d.series,c);d.orderSeries();l(c,function(a,d){b&&"hcEvents"===d||delete c[d]})},getGraphPath:function(a,b,c){var d=this,e=d.options,f=e.step,g,h=[],n=[],l;a=a||d.points;(g=a.reversed)&&a.reverse();(f={right:1,center:2}[f]||f&&3)&&g&&(f=4-f);!e.connectNulls||b||c||(a=this.getValidPoints(a));a.forEach(function(g,m){var k=g.plotX,
	r=g.plotY,p=a[m-1];(g.leftCliff||p&&p.rightCliff)&&!c&&(l=!0);g.isNull&&!u(b)&&0<m?l=!e.connectNulls:g.isNull&&!b?l=!0:(0===m||l?m=["M",g.plotX,g.plotY]:d.getPointSpline?m=d.getPointSpline(a,g,m):f?(m=1===f?["L",p.plotX,r]:2===f?["L",(p.plotX+k)/2,p.plotY,"L",(p.plotX+k)/2,r]:["L",k,p.plotY],m.push("L",k,r)):m=["L",k,r],n.push(g.x),f&&(n.push(g.x),2===f&&n.push(g.x)),h.push.apply(h,m),l=!1)});h.xMap=n;return d.graphPath=h},drawGraph:function(){var a=this,b=this.options,c=(this.gappedPath||this.getGraphPath).call(this),
	d=this.chart.styledMode,e=[["graph","highcharts-graph"]];d||e[0].push(b.lineColor||this.color||"#cccccc",b.dashStyle);e=a.getZonesGraphs(e);e.forEach(function(f,e){var g=f[0],h=a[g],n=h?"animate":"attr";h?(h.endX=a.preventGraphAnimation?null:c.xMap,h.animate({d:c})):c.length&&(a[g]=h=a.chart.renderer.path(c).addClass(f[1]).attr({zIndex:1}).add(a.group));h&&!d&&(g={stroke:f[2],"stroke-width":b.lineWidth,fill:a.fillGraph&&a.color||"none"},f[3]?g.dashstyle=f[3]:"square"!==b.linecap&&(g["stroke-linecap"]=
	g["stroke-linejoin"]="round"),h[n](g).shadow(2>e&&b.shadow));h&&(h.startX=c.xMap,h.isArea=c.isArea)})},getZonesGraphs:function(a){this.zones.forEach(function(b,c){c=["zone-graph-"+c,"highcharts-graph highcharts-zone-graph-"+c+" "+(b.className||"")];this.chart.styledMode||c.push(b.color||this.color,b.dashStyle||this.options.dashStyle);a.push(c)},this);return a},applyZones:function(){var a=this,b=this.chart,d=b.renderer,e=this.zones,g,f,h=this.clips||[],l,m=this.graph,k=this.area,p=Math.max(b.chartWidth,
	b.chartHeight),w=this[(this.zoneAxis||"y")+"Axis"],A,z,q=b.inverted,t,D,u,v,J=!1;e.length&&(m||k)&&w&&void 0!==w.min&&(z=w.reversed,t=w.horiz,m&&!this.showLine&&m.hide(),k&&k.hide(),A=w.getExtremes(),e.forEach(function(e,n){g=z?t?b.plotWidth:0:t?0:w.toPixels(A.min)||0;g=Math.min(Math.max(c(f,g),0),p);f=Math.min(Math.max(Math.round(w.toPixels(c(e.value,A.max),!0)||0),0),p);J&&(g=f=w.toPixels(A.max));D=Math.abs(g-f);u=Math.min(g,f);v=Math.max(g,f);w.isXAxis?(l={x:q?v:u,y:0,width:D,height:p},t||(l.x=
	b.plotHeight-l.x)):(l={x:0,y:q?v:u,width:p,height:D},t&&(l.y=b.plotWidth-l.y));q&&d.isVML&&(l=w.isXAxis?{x:0,y:z?u:v,height:l.width,width:b.chartWidth}:{x:l.y-b.plotLeft-b.spacingBox.x,y:0,width:l.height,height:b.chartHeight});h[n]?h[n].animate(l):(h[n]=d.clipRect(l),m&&a["zone-graph-"+n].clip(h[n]),k&&a["zone-area-"+n].clip(h[n]));J=e.value>A.max;a.resetZones&&0===f&&(f=void 0)}),this.clips=h)},invertGroups:function(a){function b(){["group","markerGroup"].forEach(function(b){c[b]&&(d.renderer.isVML&&
	c[b].attr({width:c.yAxis.len,height:c.xAxis.len}),c[b].width=c.yAxis.len,c[b].height=c.xAxis.len,c[b].invert(a))})}var c=this,d=c.chart,e;c.xAxis&&(e=C(d,"resize",b),C(c,"destroy",e),b(a),c.invertGroups=b)},plotGroup:function(a,b,c,d,e){var f=this[a],g=!f;g&&(this[a]=f=this.chart.renderer.g().attr({zIndex:d||.1}).add(e));f.addClass("highcharts-"+b+" highcharts-series-"+this.index+" highcharts-"+this.type+"-series "+(u(this.colorIndex)?"highcharts-color-"+this.colorIndex+" ":"")+(this.options.className||
	"")+(f.hasClass("highcharts-tracker")?" highcharts-tracker":""),!0);f.attr({visibility:c})[g?"attr":"animate"](this.getPlotBox());return f},getPlotBox:function(){var a=this.chart,b=this.xAxis,c=this.yAxis;a.inverted&&(b=c,c=this.xAxis);return{translateX:b?b.left:a.plotLeft,translateY:c?c.top:a.plotTop,scaleX:1,scaleY:1}},render:function(){var a=this,b=a.chart,c,d=a.options,e=!!a.animate&&b.renderer.isSVG&&I(d.animation).duration,f=a.visible?"inherit":"hidden",g=d.zIndex,l=a.hasRendered,m=b.seriesGroup,
	k=b.inverted;h(this,"render");c=a.plotGroup("group","series",f,g,m);a.markerGroup=a.plotGroup("markerGroup","markers",f,g,m);e&&a.animate(!0);c.inverted=a.isCartesian||a.invertable?k:!1;a.drawGraph&&(a.drawGraph(),a.applyZones());a.visible&&a.drawPoints();a.drawDataLabels&&a.drawDataLabels();a.redrawPoints&&a.redrawPoints();a.drawTracker&&!1!==a.options.enableMouseTracking&&a.drawTracker();a.invertGroups(k);!1===d.clip||a.sharedClipKey||l||c.clip(b.clipRect);e&&a.animate();l||(a.animationTimeout=
	D(function(){a.afterAnimate()},e));a.isDirty=!1;a.hasRendered=!0;h(a,"afterRender")},redraw:function(){var a=this.chart,b=this.isDirty||this.isDirtyData,d=this.group,e=this.xAxis,g=this.yAxis;d&&(a.inverted&&d.attr({width:a.plotWidth,height:a.plotHeight}),d.animate({translateX:c(e&&e.left,a.plotLeft),translateY:c(g&&g.top,a.plotTop)}));this.translate();this.render();b&&delete this.kdTree},kdAxisArray:["clientX","plotY"],searchPoint:function(a,b){var c=this.xAxis,d=this.yAxis,e=this.chart.inverted;
	return this.searchKDTree({clientX:e?c.len-a.chartY+c.pos:a.chartX-c.pos,plotY:e?d.len-a.chartX+d.pos:a.chartY-d.pos},b,a)},buildKDTree:function(a){function b(a,d,e){var f,g;if(g=a&&a.length)return f=c.kdAxisArray[d%e],a.sort(function(a,b){return a[f]-b[f]}),g=Math.floor(g/2),{point:a[g],left:b(a.slice(0,g),d+1,e),right:b(a.slice(g+1),d+1,e)}}this.buildingKdTree=!0;var c=this,d=-1<c.options.findNearestPointBy.indexOf("y")?2:1;delete c.kdTree;D(function(){c.kdTree=b(c.getValidPoints(null,!c.directTouch),
	d,d);c.buildingKdTree=!1},c.options.kdNow||a&&"touchstart"===a.type?0:1)},searchKDTree:function(a,b,c){function d(a,b,c,l){var n=b.point,m=e.kdAxisArray[c%l],k,r,p=n;r=u(a[f])&&u(n[f])?Math.pow(a[f]-n[f],2):null;k=u(a[g])&&u(n[g])?Math.pow(a[g]-n[g],2):null;k=(r||0)+(k||0);n.dist=u(k)?Math.sqrt(k):Number.MAX_VALUE;n.distX=u(r)?Math.sqrt(r):Number.MAX_VALUE;m=a[m]-n[m];k=0>m?"left":"right";r=0>m?"right":"left";b[k]&&(k=d(a,b[k],c+1,l),p=k[h]<p[h]?k:n);b[r]&&Math.sqrt(m*m)<p[h]&&(a=d(a,b[r],c+1,l),
	p=a[h]<p[h]?a:p);return p}var e=this,f=this.kdAxisArray[0],g=this.kdAxisArray[1],h=b?"distX":"dist";b=-1<e.options.findNearestPointBy.indexOf("y")?2:1;this.kdTree||this.buildingKdTree||this.buildKDTree(c);if(this.kdTree)return d(a,this.kdTree,b,b)},pointPlacementToXValue:function(){var a=this.options.pointPlacement;"between"===a&&(a=.5);m(a)&&(a*=c(this.options.pointRange||this.xAxis.pointRange));return a}})});K(G,"parts/Stacking.js",[G["parts/Globals.js"]],function(a){var C=a.Axis,I=a.Chart,F=a.correctFloat,
	k=a.defined,e=a.destroyObjectProperties,q=a.format,t=a.objectEach,u=a.pick,v=a.Series;a.StackItem=function(a,e,d,m,b){var g=a.chart.inverted;this.axis=a;this.isNegative=d;this.options=e;this.x=m;this.total=null;this.points={};this.stack=b;this.rightCliff=this.leftCliff=0;this.alignOptions={align:e.align||(g?d?"left":"right":"center"),verticalAlign:e.verticalAlign||(g?"middle":d?"bottom":"top"),y:u(e.y,g?4:d?14:-6),x:u(e.x,g?d?-6:6:0)};this.textAlign=e.textAlign||(g?d?"right":"left":"center")};a.StackItem.prototype=
	{destroy:function(){e(this,this.axis)},render:function(a){var e=this.axis.chart,d=this.options,m=d.format,m=m?q(m,this,e.time):d.formatter.call(this);this.label?this.label.attr({text:m,visibility:"hidden"}):this.label=e.renderer.text(m,null,null,d.useHTML).css(d.style).attr({align:this.textAlign,rotation:d.rotation,visibility:"hidden"}).add(a);this.label.labelrank=e.plotHeight},setOffset:function(a,e){var d=this.axis,h=d.chart,b=d.translate(d.usePercentage?100:this.total,0,0,0,1),g=d.translate(0),
	g=k(b)&&Math.abs(b-g);a=h.xAxis[0].translate(this.x)+a;d=k(b)&&this.getStackBox(h,this,a,b,e,g,d);(e=this.label)&&d&&(e.align(this.alignOptions,null,d),d=e.alignAttr,e[!1===this.options.crop||h.isInsidePlot(d.x,d.y)?"show":"hide"](!0))},getStackBox:function(a,e,d,m,b,g,l){var c=e.axis.reversed,h=a.inverted;a=l.height+l.pos-(h?a.plotLeft:a.plotTop);e=e.isNegative&&!c||!e.isNegative&&c;return{x:h?e?m:m-g:d,y:h?a-d-b:e?a-m-g:a-m,width:h?g:b,height:h?b:g}}};I.prototype.getStacks=function(){var a=this;
	a.yAxis.forEach(function(a){a.stacks&&a.hasVisibleSeries&&(a.oldStacks=a.stacks)});a.series.forEach(function(e){!e.options.stacking||!0!==e.visible&&!1!==a.options.chart.ignoreHiddenSeries||(e.stackKey=e.type+u(e.options.stack,""))})};C.prototype.buildStacks=function(){var a=this.series,e=u(this.options.reversedStacks,!0),d=a.length,m;if(!this.isXAxis){this.usePercentage=!1;for(m=d;m--;)a[e?m:d-m-1].setStackedPoints();for(m=0;m<d;m++)a[m].modifyStacks()}};C.prototype.renderStackTotals=function(){var a=
	this.chart,e=a.renderer,d=this.stacks,m=this.stackTotalGroup;m||(this.stackTotalGroup=m=e.g("stack-labels").attr({visibility:"visible",zIndex:6}).add());m.translate(a.plotLeft,a.plotTop);t(d,function(a){t(a,function(a){a.render(m)})})};C.prototype.resetStacks=function(){var a=this,e=a.stacks;a.isXAxis||t(e,function(d){t(d,function(e,b){e.touched<a.stacksTouched?(e.destroy(),delete d[b]):(e.total=null,e.cumulative=null)})})};C.prototype.cleanStacks=function(){var a;this.isXAxis||(this.oldStacks&&(a=
	this.stacks=this.oldStacks),t(a,function(a){t(a,function(a){a.cumulative=a.total})}))};v.prototype.setStackedPoints=function(){if(this.options.stacking&&(!0===this.visible||!1===this.chart.options.chart.ignoreHiddenSeries)){var e=this.processedXData,h=this.processedYData,d=[],m=h.length,b=this.options,g=b.threshold,l=u(b.startFromThreshold&&g,0),c=b.stack,b=b.stacking,w=this.stackKey,z="-"+w,q=this.negStacks,t=this.yAxis,A=t.stacks,n=t.oldStacks,x,B,E,v,f,r,C;t.stacksTouched+=1;for(f=0;f<m;f++)r=
	e[f],C=h[f],x=this.getStackIndicator(x,r,this.index),v=x.key,E=(B=q&&C<(l?0:g))?z:w,A[E]||(A[E]={}),A[E][r]||(n[E]&&n[E][r]?(A[E][r]=n[E][r],A[E][r].total=null):A[E][r]=new a.StackItem(t,t.options.stackLabels,B,r,c)),E=A[E][r],null!==C?(E.points[v]=E.points[this.index]=[u(E.cumulative,l)],k(E.cumulative)||(E.base=v),E.touched=t.stacksTouched,0<x.index&&!1===this.singleStacks&&(E.points[v][0]=E.points[this.index+","+r+",0"][0])):E.points[v]=E.points[this.index]=null,"percent"===b?(B=B?w:z,q&&A[B]&&
	A[B][r]?(B=A[B][r],E.total=B.total=Math.max(B.total,E.total)+Math.abs(C)||0):E.total=F(E.total+(Math.abs(C)||0))):E.total=F(E.total+(C||0)),E.cumulative=u(E.cumulative,l)+(C||0),null!==C&&(E.points[v].push(E.cumulative),d[f]=E.cumulative);"percent"===b&&(t.usePercentage=!0);this.stackedYData=d;t.oldStacks={}}};v.prototype.modifyStacks=function(){var a=this,e=a.stackKey,d=a.yAxis.stacks,m=a.processedXData,b,g=a.options.stacking;a[g+"Stacker"]&&[e,"-"+e].forEach(function(e){for(var c=m.length,h,l;c--;)if(h=
	m[c],b=a.getStackIndicator(b,h,a.index,e),l=(h=d[e]&&d[e][h])&&h.points[b.key])a[g+"Stacker"](l,h,c)})};v.prototype.percentStacker=function(a,e,d){e=e.total?100/e.total:0;a[0]=F(a[0]*e);a[1]=F(a[1]*e);this.stackedYData[d]=a[1]};v.prototype.getStackIndicator=function(a,e,d,m){!k(a)||a.x!==e||m&&a.key!==m?a={x:e,index:0,key:m}:a.index++;a.key=[d,e,a.index].join();return a}});K(G,"parts/Dynamics.js",[G["parts/Globals.js"]],function(a){var C=a.addEvent,I=a.animate,F=a.Axis,k=a.Chart,e=a.createElement,
	q=a.css,t=a.defined,u=a.erase,v=a.extend,p=a.fireEvent,h=a.isNumber,d=a.isObject,m=a.isArray,b=a.merge,g=a.objectEach,l=a.pick,c=a.Point,w=a.Series,z=a.seriesTypes,J=a.setAnimation,D=a.splat;a.cleanRecursively=function(b,c){var e={};g(b,function(g,h){if(d(b[h],!0)&&c[h])g=a.cleanRecursively(b[h],c[h]),Object.keys(g).length&&(e[h]=g);else if(d(b[h])||b[h]!==c[h])e[h]=b[h]});return e};v(k.prototype,{addSeries:function(a,b,c){var d,e=this;a&&(b=l(b,!0),p(e,"addSeries",{options:a},function(){d=e.initSeries(a);
	e.isDirtyLegend=!0;e.linkSeries();p(e,"afterAddSeries",{series:d});b&&e.redraw(c)}));return d},addAxis:function(a,c,d,e){var g=c?"xAxis":"yAxis",h=this.options;a=b(a,{index:this[g].length,isX:c});c=new F(this,a);h[g]=D(h[g]||{});h[g].push(a);l(d,!0)&&this.redraw(e);return c},showLoading:function(a){var b=this,c=b.options,d=b.loadingDiv,g=c.loading,h=function(){d&&q(d,{left:b.plotLeft+"px",top:b.plotTop+"px",width:b.plotWidth+"px",height:b.plotHeight+"px"})};d||(b.loadingDiv=d=e("div",{className:"highcharts-loading highcharts-loading-hidden"},
	null,b.container),b.loadingSpan=e("span",{className:"highcharts-loading-inner"},null,d),C(b,"redraw",h));d.className="highcharts-loading";b.loadingSpan.innerHTML=a||c.lang.loading;b.styledMode||(q(d,v(g.style,{zIndex:10})),q(b.loadingSpan,g.labelStyle),b.loadingShown||(q(d,{opacity:0,display:""}),I(d,{opacity:g.style.opacity||.5},{duration:g.showDuration||0})));b.loadingShown=!0;h()},hideLoading:function(){var a=this.options,b=this.loadingDiv;b&&(b.className="highcharts-loading highcharts-loading-hidden",
	this.styledMode||I(b,{opacity:0},{duration:a.loading.hideDuration||100,complete:function(){q(b,{display:"none"})}}));this.loadingShown=!1},propsRequireDirtyBox:"backgroundColor borderColor borderWidth borderRadius plotBackgroundColor plotBackgroundImage plotBorderColor plotBorderWidth plotShadow shadow".split(" "),propsRequireReflow:"margin marginTop marginRight marginBottom marginLeft spacing spacingTop spacingRight spacingBottom spacingLeft".split(" "),propsRequireUpdateSeries:"chart.inverted chart.polar chart.ignoreHiddenSeries chart.type colors plotOptions time tooltip".split(" "),
	collectionsWithUpdate:"xAxis yAxis zAxis series colorAxis pane".split(" "),update:function(c,d,e,m){var k=this,n={credits:"addCredits",title:"setTitle",subtitle:"setSubtitle"},f,r,w,z,q=[];p(k,"update",{options:c});c.isResponsiveOptions||k.setResponsive(!1,!0);c=a.cleanRecursively(c,k.options);if(f=c.chart){b(!0,k.options.chart,f);"className"in f&&k.setClassName(f.className);"reflow"in f&&k.setReflow(f.reflow);if("inverted"in f||"polar"in f||"type"in f)k.propFromSeries(),r=!0;"alignTicks"in f&&(r=
	!0);g(f,function(a,b){-1!==k.propsRequireUpdateSeries.indexOf("chart."+b)&&(w=!0);-1!==k.propsRequireDirtyBox.indexOf(b)&&(k.isDirtyBox=!0);-1!==k.propsRequireReflow.indexOf(b)&&(z=!0)});!k.styledMode&&"style"in f&&k.renderer.setStyle(f.style)}!k.styledMode&&c.colors&&(this.options.colors=c.colors);c.plotOptions&&b(!0,this.options.plotOptions,c.plotOptions);g(c,function(a,b){if(k[b]&&"function"===typeof k[b].update)k[b].update(a,!1);else if("function"===typeof k[n[b]])k[n[b]](a);"chart"!==b&&-1!==
	k.propsRequireUpdateSeries.indexOf(b)&&(w=!0)});this.collectionsWithUpdate.forEach(function(a){var b;c[a]&&("series"===a&&(b=[],k[a].forEach(function(a,c){a.options.isInternal||b.push(l(a.options.index,c))})),D(c[a]).forEach(function(c,d){(d=t(c.id)&&k.get(c.id)||k[a][b?b[d]:d])&&d.coll===a&&(d.update(c,!1),e&&(d.touched=!0));if(!d&&e)if("series"===a)k.addSeries(c,!1).touched=!0;else if("xAxis"===a||"yAxis"===a)k.addAxis(c,"xAxis"===a,!1).touched=!0}),e&&k[a].forEach(function(a){a.touched||a.options.isInternal?
	delete a.touched:q.push(a)}))});q.forEach(function(a){a.remove&&a.remove(!1)});r&&k.axes.forEach(function(a){a.update({},!1)});w&&k.series.forEach(function(a){a.update({},!1)});c.loading&&b(!0,k.options.loading,c.loading);r=f&&f.width;f=f&&f.height;a.isString(f)&&(f=a.relativeLength(f,r||k.chartWidth));z||h(r)&&r!==k.chartWidth||h(f)&&f!==k.chartHeight?k.setSize(r,f,m):l(d,!0)&&k.redraw(m);p(k,"afterUpdate",{options:c,redraw:d,animation:m})},setSubtitle:function(a){this.setTitle(void 0,a)}});v(c.prototype,
	{update:function(a,b,c,e){function g(){h.applyOptions(a);null===h.y&&k&&(h.graphic=k.destroy());d(a,!0)&&(k&&k.element&&a&&a.marker&&void 0!==a.marker.symbol&&(h.graphic=k.destroy()),a&&a.dataLabels&&h.dataLabel&&(h.dataLabel=h.dataLabel.destroy()),h.connector&&(h.connector=h.connector.destroy()));m=h.index;f.updateParallelArrays(h,m);p.data[m]=d(p.data[m],!0)||d(a,!0)?h.options:l(a,p.data[m]);f.isDirty=f.isDirtyData=!0;!f.fixedBox&&f.hasCartesianSeries&&(n.isDirtyBox=!0);"point"===p.legendType&&
	(n.isDirtyLegend=!0);b&&n.redraw(c)}var h=this,f=h.series,k=h.graphic,m,n=f.chart,p=f.options;b=l(b,!0);!1===e?g():h.firePointEvent("update",{options:a},g)},remove:function(a,b){this.series.removePoint(this.series.data.indexOf(this),a,b)}});v(w.prototype,{addPoint:function(a,b,c,d,e){var g=this.options,f=this.data,h=this.chart,k=this.xAxis,k=k&&k.hasNames&&k.names,m=g.data,n,w,z=this.xData,q,x;b=l(b,!0);n={series:this};this.pointClass.prototype.applyOptions.apply(n,[a]);x=n.x;q=z.length;if(this.requireSorting&&
	x<z[q-1])for(w=!0;q&&z[q-1]>x;)q--;this.updateParallelArrays(n,"splice",q,0,0);this.updateParallelArrays(n,q);k&&n.name&&(k[x]=n.name);m.splice(q,0,a);w&&(this.data.splice(q,0,null),this.processData());"point"===g.legendType&&this.generatePoints();c&&(f[0]&&f[0].remove?f[0].remove(!1):(f.shift(),this.updateParallelArrays(n,"shift"),m.shift()));!1!==e&&p(this,"addPoint",{point:n});this.isDirtyData=this.isDirty=!0;b&&h.redraw(d)},removePoint:function(a,b,c){var d=this,e=d.data,g=e[a],f=d.points,h=d.chart,
	k=function(){f&&f.length===e.length&&f.splice(a,1);e.splice(a,1);d.options.data.splice(a,1);d.updateParallelArrays(g||{series:d},"splice",a,1);g&&g.destroy();d.isDirty=!0;d.isDirtyData=!0;b&&h.redraw()};J(c,h);b=l(b,!0);g?g.firePointEvent("remove",null,k):k()},remove:function(a,b,c,d){function e(){g.destroy(d);g.remove=null;f.isDirtyLegend=f.isDirtyBox=!0;f.linkSeries();l(a,!0)&&f.redraw(b)}var g=this,f=g.chart;!1!==c?p(g,"remove",null,e):e()},update:function(c,d){c=a.cleanRecursively(c,this.userOptions);
	p(this,"update",{options:c});var e=this,g=e.chart,h=e.userOptions,k,f=e.initialType||e.type,m=c.type||h.type||g.options.chart.type,n=!(this.hasDerivedData||c.dataGrouping||m&&m!==this.type||void 0!==c.pointStart||c.pointInterval||c.pointIntervalUnit||c.keys),w=z[f].prototype,q,t=["group","markerGroup","dataLabelsGroup"],A=["navigatorSeries","baseSeries"],D=e.finishedAnimating&&{animation:!1},u={};n&&(A.push("data","isDirtyData","points","processedXData","processedYData","xIncrement"),!1!==c.visible&&
	A.push("area","graph"),e.parallelArrays.forEach(function(a){A.push(a+"Data")}),c.data&&this.setData(c.data,!1));c=b(h,D,{index:void 0===h.index?e.index:h.index,pointStart:l(h.pointStart,e.xData[0])},!n&&{data:e.options.data},c);A=t.concat(A);A.forEach(function(a){A[a]=e[a];delete e[a]});e.remove(!1,null,!1,!0);for(q in w)e[q]=void 0;z[m||f]?v(e,z[m||f].prototype):a.error(17,!0,g);A.forEach(function(a){e[a]=A[a]});e.init(g,c);n&&this.points&&(k=e.options,!1===k.visible?(u.graphic=1,u.dataLabel=1):
	(k.marker&&!1===k.marker.enabled&&(u.graphic=1),k.dataLabels&&!1===k.dataLabels.enabled&&(u.dataLabel=1)),this.points.forEach(function(a){a&&a.series&&(a.resolveColor(),Object.keys(u).length&&a.destroyElements(u),!1===k.showInLegend&&a.legendItem&&g.legend.destroyItem(a))},this));c.zIndex!==h.zIndex&&t.forEach(function(a){e[a]&&e[a].attr({zIndex:c.zIndex})});e.initialType=f;g.linkSeries();p(this,"afterUpdate");l(d,!0)&&g.redraw(n?void 0:!1)},setName:function(a){this.name=this.options.name=this.userOptions.name=
	a;this.chart.isDirtyLegend=!0}});v(F.prototype,{update:function(a,c){var d=this.chart,e=a&&a.events||{};a=b(this.userOptions,a);d.options[this.coll].indexOf&&(d.options[this.coll][d.options[this.coll].indexOf(this.userOptions)]=a);g(d.options[this.coll].events,function(a,b){"undefined"===typeof e[b]&&(e[b]=void 0)});this.destroy(!0);this.init(d,v(a,{events:e}));d.isDirtyBox=!0;l(c,!0)&&d.redraw()},remove:function(a){for(var b=this.chart,c=this.coll,d=this.series,e=d.length;e--;)d[e]&&d[e].remove(!1);
	u(b.axes,this);u(b[c],this);m(b.options[c])?b.options[c].splice(this.options.index,1):delete b.options[c];b[c].forEach(function(a,b){a.options.index=a.userOptions.index=b});this.destroy();b.isDirtyBox=!0;l(a,!0)&&b.redraw()},setTitle:function(a,b){this.update({title:a},b)},setCategories:function(a,b){this.update({categories:a},b)}})});K(G,"parts/AreaSeries.js",[G["parts/Globals.js"]],function(a){var C=a.color,I=a.pick,F=a.Series,k=a.seriesType;k("area","line",{softThreshold:!1,threshold:0},{singleStacks:!1,
	getStackPoints:function(e){var k=[],t=[],u=this.xAxis,v=this.yAxis,p=v.stacks[this.stackKey],h={},d=this.index,m=v.series,b=m.length,g,l=I(v.options.reversedStacks,!0)?1:-1,c;e=e||this.points;if(this.options.stacking){for(c=0;c<e.length;c++)e[c].leftNull=e[c].rightNull=null,h[e[c].x]=e[c];a.objectEach(p,function(a,b){null!==a.total&&t.push(b)});t.sort(function(a,b){return a-b});g=m.map(function(a){return a.visible});t.forEach(function(a,e){var m=0,w,z;if(h[a]&&!h[a].isNull)k.push(h[a]),[-1,1].forEach(function(k){var m=
	1===k?"rightNull":"leftNull",n=0,q=p[t[e+k]];if(q)for(c=d;0<=c&&c<b;)w=q.points[c],w||(c===d?h[a][m]=!0:g[c]&&(z=p[a].points[c])&&(n-=z[1]-z[0])),c+=l;h[a][1===k?"rightCliff":"leftCliff"]=n});else{for(c=d;0<=c&&c<b;){if(w=p[a].points[c]){m=w[1];break}c+=l}m=v.translate(m,0,1,0,1);k.push({isNull:!0,plotX:u.translate(a,0,0,0,1),x:a,plotY:m,yBottom:m})}})}return k},getGraphPath:function(a){var e=F.prototype.getGraphPath,k=this.options,u=k.stacking,v=this.yAxis,p,h,d=[],m=[],b=this.index,g,l=v.stacks[this.stackKey],
	c=k.threshold,w=v.getThreshold(k.threshold),z,k=k.connectNulls||"percent"===u,J=function(e,h,k){var n=a[e];e=u&&l[n.x].points[b];var p=n[k+"Null"]||0;k=n[k+"Cliff"]||0;var z,q,n=!0;k||p?(z=(p?e[0]:e[1])+k,q=e[0]+k,n=!!p):!u&&a[h]&&a[h].isNull&&(z=q=c);void 0!==z&&(m.push({plotX:g,plotY:null===z?w:v.getThreshold(z),isNull:n,isCliff:!0}),d.push({plotX:g,plotY:null===q?w:v.getThreshold(q),doCurve:!1}))};a=a||this.points;u&&(a=this.getStackPoints(a));for(p=0;p<a.length;p++)if(h=a[p].isNull,g=I(a[p].rectPlotX,
	a[p].plotX),z=I(a[p].yBottom,w),!h||k)k||J(p,p-1,"left"),h&&!u&&k||(m.push(a[p]),d.push({x:p,plotX:g,plotY:z})),k||J(p,p+1,"right");p=e.call(this,m,!0,!0);d.reversed=!0;h=e.call(this,d,!0,!0);h.length&&(h[0]="L");h=p.concat(h);e=e.call(this,m,!1,k);h.xMap=p.xMap;this.areaPath=h;return e},drawGraph:function(){this.areaPath=[];F.prototype.drawGraph.apply(this);var a=this,k=this.areaPath,t=this.options,u=[["area","highcharts-area",this.color,t.fillColor]];this.zones.forEach(function(e,k){u.push(["zone-area-"+
	k,"highcharts-area highcharts-zone-area-"+k+" "+e.className,e.color||a.color,e.fillColor||t.fillColor])});u.forEach(function(e){var p=e[0],h=a[p],d=h?"animate":"attr",m={};h?(h.endX=a.preventGraphAnimation?null:k.xMap,h.animate({d:k})):(m.zIndex=0,h=a[p]=a.chart.renderer.path(k).addClass(e[1]).add(a.group),h.isArea=!0);a.chart.styledMode||(m.fill=I(e[3],C(e[2]).setOpacity(I(t.fillOpacity,.75)).get()));h[d](m);h.startX=k.xMap;h.shiftUnit=t.step?2:1})},drawLegendSymbol:a.LegendSymbolMixin.drawRectangle})});
	K(G,"parts/SplineSeries.js",[G["parts/Globals.js"]],function(a){var C=a.pick;a=a.seriesType;a("spline","line",{},{getPointSpline:function(a,F,k){var e=F.plotX,q=F.plotY,t=a[k-1];k=a[k+1];var u,v,p,h;if(t&&!t.isNull&&!1!==t.doCurve&&!F.isCliff&&k&&!k.isNull&&!1!==k.doCurve&&!F.isCliff){a=t.plotY;p=k.plotX;k=k.plotY;var d=0;u=(1.5*e+t.plotX)/2.5;v=(1.5*q+a)/2.5;p=(1.5*e+p)/2.5;h=(1.5*q+k)/2.5;p!==u&&(d=(h-v)*(p-e)/(p-u)+q-h);v+=d;h+=d;v>a&&v>q?(v=Math.max(a,q),h=2*q-v):v<a&&v<q&&(v=Math.min(a,q),h=
	2*q-v);h>k&&h>q?(h=Math.max(k,q),v=2*q-h):h<k&&h<q&&(h=Math.min(k,q),v=2*q-h);F.rightContX=p;F.rightContY=h}F=["C",C(t.rightContX,t.plotX),C(t.rightContY,t.plotY),C(u,e),C(v,q),e,q];t.rightContX=t.rightContY=null;return F}})});K(G,"parts/AreaSplineSeries.js",[G["parts/Globals.js"]],function(a){var C=a.seriesTypes.area.prototype,I=a.seriesType;I("areaspline","spline",a.defaultPlotOptions.area,{getStackPoints:C.getStackPoints,getGraphPath:C.getGraphPath,drawGraph:C.drawGraph,drawLegendSymbol:a.LegendSymbolMixin.drawRectangle})});
	K(G,"parts/ColumnSeries.js",[G["parts/Globals.js"]],function(a){var C=a.animObject,I=a.color,F=a.extend,k=a.defined,e=a.isNumber,q=a.merge,t=a.pick,u=a.Series,v=a.seriesType,p=a.svg;v("column","line",{borderRadius:0,crisp:!0,groupPadding:.2,marker:null,pointPadding:.1,minPointLength:0,cropThreshold:50,pointRange:null,states:{hover:{halo:!1,brightness:.1},select:{color:"#cccccc",borderColor:"#000000"}},dataLabels:{align:null,verticalAlign:null,y:null},softThreshold:!1,startFromThreshold:!0,stickyTracking:!1,
	tooltip:{distance:6},threshold:0,borderColor:"#ffffff"},{cropShoulder:0,directTouch:!0,trackerGroups:["group","dataLabelsGroup"],negStacks:!0,init:function(){u.prototype.init.apply(this,arguments);var a=this,d=a.chart;d.hasRendered&&d.series.forEach(function(d){d.type===a.type&&(d.isDirty=!0)})},getColumnMetrics:function(){var a=this,d=a.options,e=a.xAxis,b=a.yAxis,g=e.options.reversedStacks,g=e.reversed&&!g||!e.reversed&&g,k,c={},p=0;!1===d.grouping?p=1:a.chart.series.forEach(function(d){var e=d.options,
	g=d.yAxis,h;d.type!==a.type||!d.visible&&a.chart.options.chart.ignoreHiddenSeries||b.len!==g.len||b.pos!==g.pos||(e.stacking?(k=d.stackKey,void 0===c[k]&&(c[k]=p++),h=c[k]):!1!==e.grouping&&(h=p++),d.columnIndex=h)});var z=Math.min(Math.abs(e.transA)*(e.ordinalSlope||d.pointRange||e.closestPointRange||e.tickInterval||1),e.len),q=z*d.groupPadding,u=(z-2*q)/(p||1),d=Math.min(d.maxPointWidth||e.len,t(d.pointWidth,u*(1-2*d.pointPadding)));a.columnMetrics={width:d,offset:(u-d)/2+(q+((a.columnIndex||0)+
	(g?1:0))*u-z/2)*(g?-1:1)};return a.columnMetrics},crispCol:function(a,d,e,b){var g=this.chart,h=this.borderWidth,c=-(h%2?.5:0),h=h%2?.5:1;g.inverted&&g.renderer.isVML&&(h+=1);this.options.crisp&&(e=Math.round(a+e)+c,a=Math.round(a)+c,e-=a);b=Math.round(d+b)+h;c=.5>=Math.abs(d)&&.5<b;d=Math.round(d)+h;b-=d;c&&b&&(--d,b+=1);return{x:a,y:d,width:e,height:b}},translate:function(){var a=this,d=a.chart,e=a.options,b=a.dense=2>a.closestPointRange*a.xAxis.transA,b=a.borderWidth=t(e.borderWidth,b?0:1),g=a.yAxis,
	l=e.threshold,c=a.translatedThreshold=g.getThreshold(l),p=t(e.minPointLength,5),z=a.getColumnMetrics(),q=z.width,D=a.barW=Math.max(q,1+2*b),A=a.pointXOffset=z.offset;d.inverted&&(c-=.5);e.pointPadding&&(D=Math.ceil(D));u.prototype.translate.apply(a);a.points.forEach(function(b){var e=t(b.yBottom,c),h=999+Math.abs(e),m=q,h=Math.min(Math.max(-h,b.plotY),g.len+h),n=b.plotX+A,f=D,r=Math.min(h,e),z,w=Math.max(h,e)-r;p&&Math.abs(w)<p&&(w=p,z=!g.reversed&&!b.negative||g.reversed&&b.negative,b.y===l&&a.dataMax<=
	l&&g.min<l&&(z=!z),r=Math.abs(r-c)>p?e-p:c-(z?p:0));k(b.options.pointWidth)&&(m=f=Math.ceil(b.options.pointWidth),n-=Math.round((m-q)/2));b.barX=n;b.pointWidth=m;b.tooltipPos=d.inverted?[g.len+g.pos-d.plotLeft-h,a.xAxis.len-n-f/2,w]:[n+f/2,h+g.pos-d.plotTop,w];b.shapeType=a.pointClass.prototype.shapeType||"rect";b.shapeArgs=a.crispCol.apply(a,b.isNull?[n,c,f,0]:[n,r,f,w])})},getSymbol:a.noop,drawLegendSymbol:a.LegendSymbolMixin.drawRectangle,drawGraph:function(){this.group[this.dense?"addClass":"removeClass"]("highcharts-dense-data")},
	pointAttribs:function(a,d){var e=this.options,b,g=this.pointAttrToOptions||{};b=g.stroke||"borderColor";var h=g["stroke-width"]||"borderWidth",c=a&&a.color||this.color,k=a&&a[b]||e[b]||this.color||c,p=a&&a[h]||e[h]||this[h]||0,g=a&&a.dashStyle||e.dashStyle,u=t(e.opacity,1),D;a&&this.zones.length&&(D=a.getZone(),c=a.options.color||D&&D.color||this.color,D&&(k=D.borderColor||k,g=D.dashStyle||g,p=D.borderWidth||p));d&&(a=q(e.states[d],a.options.states&&a.options.states[d]||{}),d=a.brightness,c=a.color||
	void 0!==d&&I(c).brighten(a.brightness).get()||c,k=a[b]||k,p=a[h]||p,g=a.dashStyle||g,u=t(a.opacity,u));b={fill:c,stroke:k,"stroke-width":p,opacity:u};g&&(b.dashstyle=g);return b},drawPoints:function(){var a=this,d=this.chart,k=a.options,b=d.renderer,g=k.animationLimit||250,l;a.points.forEach(function(c){var h=c.graphic,m=h&&d.pointCount<g?"animate":"attr";if(e(c.plotY)&&null!==c.y){l=c.shapeArgs;h&&h.element.nodeName!==c.shapeType&&(h=h.destroy());if(h)h[m](q(l));else c.graphic=h=b[c.shapeType](l).add(c.group||
	a.group);if(k.borderRadius)h[m]({r:k.borderRadius});d.styledMode||h[m](a.pointAttribs(c,c.selected&&"select")).shadow(!1!==c.allowShadow&&k.shadow,null,k.stacking&&!k.borderRadius);h.addClass(c.getClassName(),!0)}else h&&(c.graphic=h.destroy())})},animate:function(a){var d=this,e=this.yAxis,b=d.options,g=this.chart.inverted,h={},c=g?"translateX":"translateY",k;p&&(a?(h.scaleY=.001,a=Math.min(e.pos+e.len,Math.max(e.pos,e.toPixels(b.threshold))),g?h.translateX=a-e.len:h.translateY=a,d.clipBox&&d.setClip(),
	d.group.attr(h)):(k=d.group.attr(c),d.group.animate({scaleY:1},F(C(d.options.animation),{step:function(a,b){h[c]=k+b.pos*(e.pos-k);d.group.attr(h)}})),d.animate=null))},remove:function(){var a=this,d=a.chart;d.hasRendered&&d.series.forEach(function(d){d.type===a.type&&(d.isDirty=!0)});u.prototype.remove.apply(a,arguments)}})});K(G,"parts/BarSeries.js",[G["parts/Globals.js"]],function(a){a=a.seriesType;a("bar","column",null,{inverted:!0})});K(G,"parts/ScatterSeries.js",[G["parts/Globals.js"]],function(a){var C=
	a.Series,I=a.seriesType;I("scatter","line",{lineWidth:0,findNearestPointBy:"xy",jitter:{x:0,y:0},marker:{enabled:!0},tooltip:{headerFormat:'\x3cspan style\x3d"color:{point.color}"\x3e\u25cf\x3c/span\x3e \x3cspan style\x3d"font-size: 10px"\x3e {series.name}\x3c/span\x3e\x3cbr/\x3e',pointFormat:"x: \x3cb\x3e{point.x}\x3c/b\x3e\x3cbr/\x3ey: \x3cb\x3e{point.y}\x3c/b\x3e\x3cbr/\x3e"}},{sorted:!1,requireSorting:!1,noSharedTooltip:!0,trackerGroups:["group","markerGroup","dataLabelsGroup"],takeOrdinalPosition:!1,
	drawGraph:function(){this.options.lineWidth&&C.prototype.drawGraph.call(this)},applyJitter:function(){var a=this,k=this.options.jitter,e=this.points.length;k&&this.points.forEach(function(q,t){["x","y"].forEach(function(u,v){var p,h="plot"+u.toUpperCase(),d,m;k[u]&&!q.isNull&&(p=a[u+"Axis"],m=k[u]*p.transA,p&&!p.isLog&&(d=Math.max(0,q[h]-m),p=Math.min(p.len,q[h]+m),v=1E4*Math.sin(t+v*e),q[h]=d+(p-d)*(v-Math.floor(v)),"x"===u&&(q.clientX=q.plotX)))})})}});a.addEvent(C,"afterTranslate",function(){this.applyJitter&&
	this.applyJitter()})});K(G,"mixins/centered-series.js",[G["parts/Globals.js"]],function(a){var C=a.deg2rad,I=a.isNumber,F=a.pick,k=a.relativeLength;a.CenteredSeriesMixin={getCenter:function(){var a=this.options,q=this.chart,t=2*(a.slicedOffset||0),u=q.plotWidth-2*t,q=q.plotHeight-2*t,v=a.center,v=[F(v[0],"50%"),F(v[1],"50%"),a.size||"100%",a.innerSize||0],p=Math.min(u,q),h,d;for(h=0;4>h;++h)d=v[h],a=2>h||2===h&&/%$/.test(d),v[h]=k(d,[u,q,p,v[2]][h])+(a?t:0);v[3]>v[2]&&(v[3]=v[2]);return v},getStartAndEndRadians:function(a,
	k){a=I(a)?a:0;k=I(k)&&k>a&&360>k-a?k:a+360;return{start:C*(a+-90),end:C*(k+-90)}}}});K(G,"parts/PieSeries.js",[G["parts/Globals.js"]],function(a){var C=a.addEvent,I=a.CenteredSeriesMixin,F=a.defined,k=I.getStartAndEndRadians,e=a.merge,q=a.noop,t=a.pick,u=a.Point,v=a.Series,p=a.seriesType,h=a.setAnimation;p("pie","line",{center:[null,null],clip:!1,colorByPoint:!0,dataLabels:{allowOverlap:!0,connectorPadding:5,distance:30,enabled:!0,formatter:function(){return this.point.isNull?void 0:this.point.name},
	softConnector:!0,x:0,connectorShape:"fixedOffset",crookDistance:"70%"},ignoreHiddenPoint:!0,inactiveOtherPoints:!0,legendType:"point",marker:null,size:null,showInLegend:!1,slicedOffset:10,stickyTracking:!1,tooltip:{followPointer:!0},borderColor:"#ffffff",borderWidth:1,states:{hover:{brightness:.1}}},{isCartesian:!1,requireSorting:!1,directTouch:!0,noSharedTooltip:!0,trackerGroups:["group","dataLabelsGroup"],axisTypes:[],pointAttribs:a.seriesTypes.column.prototype.pointAttribs,animate:function(a){var d=
	this,b=d.points,e=d.startAngleRad;a||(b.forEach(function(a){var b=a.graphic,g=a.shapeArgs;b&&(b.attr({r:a.startR||d.center[3]/2,start:e,end:e}),b.animate({r:g.r,start:g.start,end:g.end},d.options.animation))}),d.animate=null)},hasData:function(){return!!this.processedXData.length},updateTotals:function(){var a,e=0,b=this.points,g=b.length,h,c=this.options.ignoreHiddenPoint;for(a=0;a<g;a++)h=b[a],e+=c&&!h.visible?0:h.isNull?0:h.y;this.total=e;for(a=0;a<g;a++)h=b[a],h.percentage=0<e&&(h.visible||!c)?
	h.y/e*100:0,h.total=e},generatePoints:function(){v.prototype.generatePoints.call(this);this.updateTotals()},getX:function(a,e,b){var d=this.center,h=this.radii?this.radii[b.index]:d[2]/2;return d[0]+(e?-1:1)*Math.cos(Math.asin(Math.max(Math.min((a-d[1])/(h+b.labelDistance),1),-1)))*(h+b.labelDistance)+(0<b.labelDistance?(e?-1:1)*this.options.dataLabels.padding:0)},translate:function(a){this.generatePoints();var d=0,b=this.options,e=b.slicedOffset,h=e+(b.borderWidth||0),c,p,z=k(b.startAngle,b.endAngle),
	q=this.startAngleRad=z.start,z=(this.endAngleRad=z.end)-q,u=this.points,A,n,x=b.dataLabels.distance,b=b.ignoreHiddenPoint,v,E=u.length,H;a||(this.center=a=this.getCenter());for(v=0;v<E;v++){H=u[v];H.labelDistance=t(H.options.dataLabels&&H.options.dataLabels.distance,x);this.maxLabelDistance=Math.max(this.maxLabelDistance||0,H.labelDistance);c=q+d*z;if(!b||H.visible)d+=H.percentage/100;p=q+d*z;H.shapeType="arc";H.shapeArgs={x:a[0],y:a[1],r:a[2]/2,innerR:a[3]/2,start:Math.round(1E3*c)/1E3,end:Math.round(1E3*
	p)/1E3};p=(p+c)/2;p>1.5*Math.PI?p-=2*Math.PI:p<-Math.PI/2&&(p+=2*Math.PI);H.slicedTranslation={translateX:Math.round(Math.cos(p)*e),translateY:Math.round(Math.sin(p)*e)};A=Math.cos(p)*a[2]/2;n=Math.sin(p)*a[2]/2;H.tooltipPos=[a[0]+.7*A,a[1]+.7*n];H.half=p<-Math.PI/2||p>Math.PI/2?1:0;H.angle=p;c=Math.min(h,H.labelDistance/5);H.labelPosition={natural:{x:a[0]+A+Math.cos(p)*H.labelDistance,y:a[1]+n+Math.sin(p)*H.labelDistance},"final":{},alignment:0>H.labelDistance?"center":H.half?"right":"left",connectorPosition:{breakAt:{x:a[0]+
	A+Math.cos(p)*c,y:a[1]+n+Math.sin(p)*c},touchingSliceAt:{x:a[0]+A,y:a[1]+n}}}}},drawGraph:null,redrawPoints:function(){var a=this,h=a.chart,b=h.renderer,g,k,c,p,z=a.options.shadow;!z||a.shadowGroup||h.styledMode||(a.shadowGroup=b.g("shadow").attr({zIndex:-1}).add(a.group));a.points.forEach(function(d){var l={};k=d.graphic;if(!d.isNull&&k){p=d.shapeArgs;g=d.getTranslate();if(!h.styledMode){var m=d.shadowGroup;z&&!m&&(m=d.shadowGroup=b.g("shadow").add(a.shadowGroup));m&&m.attr(g);c=a.pointAttribs(d,
	d.selected&&"select")}d.delayedRendering?(k.setRadialReference(a.center).attr(p).attr(g),h.styledMode||k.attr(c).attr({"stroke-linejoin":"round"}).shadow(z,m),d.delayRendering=!1):(k.setRadialReference(a.center),h.styledMode||e(!0,l,c),e(!0,l,p,g),k.animate(l));k.attr({visibility:d.visible?"inherit":"hidden"});k.addClass(d.getClassName())}else k&&(d.graphic=k.destroy())})},drawPoints:function(){var a=this.chart.renderer;this.points.forEach(function(d){d.graphic||(d.graphic=a[d.shapeType](d.shapeArgs).add(d.series.group),
	d.delayedRendering=!0)})},searchPoint:q,sortByAngle:function(a,e){a.sort(function(a,d){return void 0!==a.angle&&(d.angle-a.angle)*e})},drawLegendSymbol:a.LegendSymbolMixin.drawRectangle,getCenter:I.getCenter,getSymbol:q},{init:function(){u.prototype.init.apply(this,arguments);var a=this,e;a.name=t(a.name,"Slice");e=function(b){a.slice("select"===b.type)};C(a,"select",e);C(a,"unselect",e);return a},isValid:function(){return a.isNumber(this.y,!0)&&0<=this.y},setVisible:function(a,e){var b=this,d=b.series,
	h=d.chart,c=d.options.ignoreHiddenPoint;e=t(e,c);a!==b.visible&&(b.visible=b.options.visible=a=void 0===a?!b.visible:a,d.options.data[d.data.indexOf(b)]=b.options,["graphic","dataLabel","connector","shadowGroup"].forEach(function(c){if(b[c])b[c][a?"show":"hide"](!0)}),b.legendItem&&h.legend.colorizeItem(b,a),a||"hover"!==b.state||b.setState(""),c&&(d.isDirty=!0),e&&h.redraw())},slice:function(a,e,b){var d=this.series;h(b,d.chart);t(e,!0);this.sliced=this.options.sliced=F(a)?a:!this.sliced;d.options.data[d.data.indexOf(this)]=
	this.options;this.graphic.animate(this.getTranslate());this.shadowGroup&&this.shadowGroup.animate(this.getTranslate())},getTranslate:function(){return this.sliced?this.slicedTranslation:{translateX:0,translateY:0}},haloPath:function(a){var d=this.shapeArgs;return this.sliced||!this.visible?[]:this.series.chart.renderer.symbols.arc(d.x,d.y,d.r+a,d.r+a,{innerR:this.shapeArgs.r-1,start:d.start,end:d.end})},connectorShapes:{fixedOffset:function(a,e,b){var d=e.breakAt;e=e.touchingSliceAt;return["M",a.x,
	a.y].concat(b.softConnector?["C",a.x+("left"===a.alignment?-5:5),a.y,2*d.x-e.x,2*d.y-e.y,d.x,d.y]:["L",d.x,d.y]).concat(["L",e.x,e.y])},straight:function(a,e){e=e.touchingSliceAt;return["M",a.x,a.y,"L",e.x,e.y]},crookedLine:function(d,e,b){e=e.touchingSliceAt;var g=this.series,h=g.center[0],c=g.chart.plotWidth,k=g.chart.plotLeft,g=d.alignment,m=this.shapeArgs.r;b=a.relativeLength(b.crookDistance,1);b="left"===g?h+m+(c+k-h-m)*(1-b):k+(h-m)*b;h=["L",b,d.y];if("left"===g?b>d.x||b<e.x:b<d.x||b>e.x)h=
	[];return["M",d.x,d.y].concat(h).concat(["L",e.x,e.y])}},getConnectorPath:function(){var a=this.labelPosition,e=this.series.options.dataLabels,b=e.connectorShape,g=this.connectorShapes;g[b]&&(b=g[b]);return b.call(this,{x:a.final.x,y:a.final.y,alignment:a.alignment},a.connectorPosition,e)}})});K(G,"parts/DataLabels.js",[G["parts/Globals.js"]],function(a){var C=a.arrayMax,I=a.defined,F=a.extend,k=a.format,e=a.merge,q=a.noop,t=a.pick,u=a.relativeLength,v=a.Series,p=a.seriesTypes,h=a.stableSort,d=a.isArray,
	m=a.splat;a.distribute=function(b,d,e){function c(a,b){return a.target-b.target}var g,k=!0,l=b,m=[],p;p=0;var n=l.reducedLen||d;for(g=b.length;g--;)p+=b[g].size;if(p>n){h(b,function(a,b){return(b.rank||0)-(a.rank||0)});for(p=g=0;p<=n;)p+=b[g].size,g++;m=b.splice(g-1,b.length)}h(b,c);for(b=b.map(function(a){return{size:a.size,targets:[a.target],align:t(a.align,.5)}});k;){for(g=b.length;g--;)k=b[g],p=(Math.min.apply(0,k.targets)+Math.max.apply(0,k.targets))/2,k.pos=Math.min(Math.max(0,p-k.size*k.align),
	d-k.size);g=b.length;for(k=!1;g--;)0<g&&b[g-1].pos+b[g-1].size>b[g].pos&&(b[g-1].size+=b[g].size,b[g-1].targets=b[g-1].targets.concat(b[g].targets),b[g-1].align=.5,b[g-1].pos+b[g-1].size>d&&(b[g-1].pos=d-b[g-1].size),b.splice(g,1),k=!0)}l.push.apply(l,m);g=0;b.some(function(b){var c=0;if(b.targets.some(function(){l[g].pos=b.pos+c;if(Math.abs(l[g].pos-l[g].target)>e)return l.slice(0,g+1).forEach(function(a){delete a.pos}),l.reducedLen=(l.reducedLen||d)-.1*d,l.reducedLen>.1*d&&a.distribute(l,d,e),!0;
	c+=l[g].size;g++}))return!0});h(l,c)};v.prototype.drawDataLabels=function(){function b(a,b){var c=b.filter;return c?(b=c.operator,a=a[c.property],c=c.value,"\x3e"===b&&a>c||"\x3c"===b&&a<c||"\x3e\x3d"===b&&a>=c||"\x3c\x3d"===b&&a<=c||"\x3d\x3d"===b&&a==c||"\x3d\x3d\x3d"===b&&a===c?!0:!1):!0}function g(a,b){var c=[],f;if(d(a)&&!d(b))c=a.map(function(a){return e(a,b)});else if(d(b)&&!d(a))c=b.map(function(b){return e(a,b)});else if(d(a)||d(b))for(f=Math.max(a.length,b.length);f--;)c[f]=e(a[f],b[f]);
	else c=e(a,b);return c}var h=this,c=h.chart,p=h.options,q=p.dataLabels,u=h.points,D,A=h.hasRendered||0,n,x=a.animObject(p.animation).duration,v=Math.min(x,200),E=t(q.defer,0<v),H=c.renderer,q=g(g(c.options.plotOptions&&c.options.plotOptions.series&&c.options.plotOptions.series.dataLabels,c.options.plotOptions&&c.options.plotOptions[h.type]&&c.options.plotOptions[h.type].dataLabels),q);a.fireEvent(this,"drawDataLabels");if(d(q)||q.enabled||h._hasPointLabels)n=h.plotGroup("dataLabelsGroup","data-labels",
	E&&!A?"hidden":"inherit",q.zIndex||6),E&&(n.attr({opacity:+A}),A||setTimeout(function(){var a=h.dataLabelsGroup;a&&(h.visible&&n.show(!0),a[p.animation?"animate":"attr"]({opacity:1},{duration:v}))},x-v)),u.forEach(function(d){D=m(g(q,d.dlOptions||d.options&&d.options.dataLabels));D.forEach(function(e,f){var g=e.enabled&&(!d.isNull||d.dataLabelOnNull)&&b(d,e),l,m,r,q,z=d.dataLabels?d.dataLabels[f]:d.dataLabel,x=d.connectors?d.connectors[f]:d.connector,u=!z;g&&(l=d.getLabelConfig(),m=t(e[d.formatPrefix+
	"Format"],e.format),l=I(m)?k(m,l,c.time):(e[d.formatPrefix+"Formatter"]||e.formatter).call(l,e),m=e.style,r=e.rotation,c.styledMode||(m.color=t(e.color,m.color,h.color,"#000000"),"contrast"===m.color&&(d.contrastColor=H.getContrast(d.color||h.color),m.color=e.inside||0>t(e.distance,d.labelDistance)||p.stacking?d.contrastColor:"#000000"),p.cursor&&(m.cursor=p.cursor)),q={r:e.borderRadius||0,rotation:r,padding:e.padding,zIndex:1},c.styledMode||(q.fill=e.backgroundColor,q.stroke=e.borderColor,q["stroke-width"]=
	e.borderWidth),a.objectEach(q,function(a,b){void 0===a&&delete q[b]}));!z||g&&I(l)?g&&I(l)&&(z?q.text=l:(d.dataLabels=d.dataLabels||[],z=d.dataLabels[f]=r?H.text(l,0,-9999).addClass("highcharts-data-label"):H.label(l,0,-9999,e.shape,null,null,e.useHTML,null,"data-label"),f||(d.dataLabel=z),z.addClass(" highcharts-data-label-color-"+d.colorIndex+" "+(e.className||"")+(e.useHTML?" highcharts-tracker":""))),z.options=e,z.attr(q),c.styledMode||z.css(m).shadow(e.shadow),z.added||z.add(n),e.textPath&&z.setTextPath(d.getDataLabelPath&&
	d.getDataLabelPath(z)||d.graphic,e.textPath),h.alignDataLabel(d,z,e,null,u)):(d.dataLabel=d.dataLabel&&d.dataLabel.destroy(),d.dataLabels&&(1===d.dataLabels.length?delete d.dataLabels:delete d.dataLabels[f]),f||delete d.dataLabel,x&&(d.connector=d.connector.destroy(),d.connectors&&(1===d.connectors.length?delete d.connectors:delete d.connectors[f])))})});a.fireEvent(this,"afterDrawDataLabels")};v.prototype.alignDataLabel=function(a,d,e,c,h){var b=this.chart,g=this.isCartesian&&b.inverted,k=t(a.dlBox&&
	a.dlBox.centerX,a.plotX,-9999),l=t(a.plotY,-9999),n=d.getBBox(),m,p=e.rotation,q=e.align,u=this.visible&&(a.series.forceDL||b.isInsidePlot(k,Math.round(l),g)||c&&b.isInsidePlot(k,g?c.x+1:c.y+c.height-1,g)),f="justify"===t(e.overflow,"justify");if(u&&(m=b.renderer.fontMetrics(b.styledMode?void 0:e.style.fontSize,d).b,c=F({x:g?this.yAxis.len-l:k,y:Math.round(g?this.xAxis.len-k:l),width:0,height:0},c),F(e,{width:n.width,height:n.height}),p?(f=!1,k=b.renderer.rotCorr(m,p),k={x:c.x+e.x+c.width/2+k.x,y:c.y+
	e.y+{top:0,middle:.5,bottom:1}[e.verticalAlign]*c.height},d[h?"attr":"animate"](k).attr({align:q}),l=(p+720)%360,l=180<l&&360>l,"left"===q?k.y-=l?n.height:0:"center"===q?(k.x-=n.width/2,k.y-=n.height/2):"right"===q&&(k.x-=n.width,k.y-=l?0:n.height),d.placed=!0,d.alignAttr=k):(d.align(e,null,c),k=d.alignAttr),f&&0<=c.height?a.isLabelJustified=this.justifyDataLabel(d,e,k,n,c,h):t(e.crop,!0)&&(u=b.isInsidePlot(k.x,k.y)&&b.isInsidePlot(k.x+n.width,k.y+n.height)),e.shape&&!p))d[h?"attr":"animate"]({anchorX:g?
	b.plotWidth-a.plotY:a.plotX,anchorY:g?b.plotHeight-a.plotX:a.plotY});u||(d.attr({y:-9999}),d.placed=!1)};v.prototype.justifyDataLabel=function(a,d,e,c,h,k){var b=this.chart,g=d.align,l=d.verticalAlign,n,m,p=a.box?0:a.padding||0;n=e.x+p;0>n&&("right"===g?d.align="left":d.x=-n,m=!0);n=e.x+c.width-p;n>b.plotWidth&&("left"===g?d.align="right":d.x=b.plotWidth-n,m=!0);n=e.y+p;0>n&&("bottom"===l?d.verticalAlign="top":d.y=-n,m=!0);n=e.y+c.height-p;n>b.plotHeight&&("top"===l?d.verticalAlign="bottom":d.y=b.plotHeight-
	n,m=!0);m&&(a.placed=!k,a.align(d,null,h));return m};p.pie&&(p.pie.prototype.dataLabelPositioners={radialDistributionY:function(a){return a.top+a.distributeBox.pos},radialDistributionX:function(a,d,e,c){return a.getX(e<d.top+2||e>d.bottom-2?c:e,d.half,d)},justify:function(a,d,e){return e[0]+(a.half?-1:1)*(d+a.labelDistance)},alignToPlotEdges:function(a,d,e,c){a=a.getBBox().width;return d?a+c:e-a-c},alignToConnectors:function(a,d,e,c){var b=0,g;a.forEach(function(a){g=a.dataLabel.getBBox().width;g>
	b&&(b=g)});return d?b+c:e-b-c}},p.pie.prototype.drawDataLabels=function(){var b=this,d=b.data,h,c=b.chart,k=b.options.dataLabels,m=k.connectorPadding,p,q=c.plotWidth,u=c.plotHeight,n=c.plotLeft,x=Math.round(c.chartWidth/3),B,E=b.center,H=E[2]/2,f=E[1],r,F,G,L,K=[[],[]],O,y,S,Q,R=[0,0,0,0],T=b.dataLabelPositioners,Y;b.visible&&(k.enabled||b._hasPointLabels)&&(d.forEach(function(a){a.dataLabel&&a.visible&&a.dataLabel.shortened&&(a.dataLabel.attr({width:"auto"}).css({width:"auto",textOverflow:"clip"}),
	a.dataLabel.shortened=!1)}),v.prototype.drawDataLabels.apply(b),d.forEach(function(a){a.dataLabel&&(a.visible?(K[a.half].push(a),a.dataLabel._pos=null,!I(k.style.width)&&!I(a.options.dataLabels&&a.options.dataLabels.style&&a.options.dataLabels.style.width)&&a.dataLabel.getBBox().width>x&&(a.dataLabel.css({width:.7*x}),a.dataLabel.shortened=!0)):(a.dataLabel=a.dataLabel.destroy(),a.dataLabels&&1===a.dataLabels.length&&delete a.dataLabels))}),K.forEach(function(d,e){var g,l,p=d.length,z=[],x;if(p)for(b.sortByAngle(d,
	e-.5),0<b.maxLabelDistance&&(g=Math.max(0,f-H-b.maxLabelDistance),l=Math.min(f+H+b.maxLabelDistance,c.plotHeight),d.forEach(function(a){0<a.labelDistance&&a.dataLabel&&(a.top=Math.max(0,f-H-a.labelDistance),a.bottom=Math.min(f+H+a.labelDistance,c.plotHeight),x=a.dataLabel.getBBox().height||21,a.distributeBox={target:a.labelPosition.natural.y-a.top+x/2,size:x,rank:a.y},z.push(a.distributeBox))}),g=l+x-g,a.distribute(z,g,g/5)),Q=0;Q<p;Q++){h=d[Q];G=h.labelPosition;r=h.dataLabel;S=!1===h.visible?"hidden":
	"inherit";y=g=G.natural.y;z&&I(h.distributeBox)&&(void 0===h.distributeBox.pos?S="hidden":(L=h.distributeBox.size,y=T.radialDistributionY(h)));delete h.positionIndex;if(k.justify)O=T.justify(h,H,E);else switch(k.alignTo){case "connectors":O=T.alignToConnectors(d,e,q,n);break;case "plotEdges":O=T.alignToPlotEdges(r,e,q,n);break;default:O=T.radialDistributionX(b,h,y,g)}r._attr={visibility:S,align:G.alignment};r._pos={x:O+k.x+({left:m,right:-m}[G.alignment]||0),y:y+k.y-10};G.final.x=O;G.final.y=y;t(k.crop,
	!0)&&(F=r.getBBox().width,g=null,O-F<m&&1===e?(g=Math.round(F-O+m),R[3]=Math.max(g,R[3])):O+F>q-m&&0===e&&(g=Math.round(O+F-q+m),R[1]=Math.max(g,R[1])),0>y-L/2?R[0]=Math.max(Math.round(-y+L/2),R[0]):y+L/2>u&&(R[2]=Math.max(Math.round(y+L/2-u),R[2])),r.sideOverflow=g)}}),0===C(R)||this.verifyDataLabelOverflow(R))&&(this.placeDataLabels(),this.points.forEach(function(a){Y=e(k,a.options.dataLabels);if(p=t(Y.connectorWidth,1)){var d;B=a.connector;if((r=a.dataLabel)&&r._pos&&a.visible&&0<a.labelDistance){S=
	r._attr.visibility;if(d=!B)a.connector=B=c.renderer.path().addClass("highcharts-data-label-connector  highcharts-color-"+a.colorIndex+(a.className?" "+a.className:"")).add(b.dataLabelsGroup),c.styledMode||B.attr({"stroke-width":p,stroke:Y.connectorColor||a.color||"#666666"});B[d?"attr":"animate"]({d:a.getConnectorPath()});B.attr("visibility",S)}else B&&(a.connector=B.destroy())}}))},p.pie.prototype.placeDataLabels=function(){this.points.forEach(function(a){var b=a.dataLabel,d;b&&a.visible&&((d=b._pos)?
	(b.sideOverflow&&(b._attr.width=Math.max(b.getBBox().width-b.sideOverflow,0),b.css({width:b._attr.width+"px",textOverflow:(this.options.dataLabels.style||{}).textOverflow||"ellipsis"}),b.shortened=!0),b.attr(b._attr),b[b.moved?"animate":"attr"](d),b.moved=!0):b&&b.attr({y:-9999}));delete a.distributeBox},this)},p.pie.prototype.alignDataLabel=q,p.pie.prototype.verifyDataLabelOverflow=function(a){var b=this.center,d=this.options,c=d.center,e=d.minSize||80,h,k=null!==d.size;k||(null!==c[0]?h=Math.max(b[2]-
	Math.max(a[1],a[3]),e):(h=Math.max(b[2]-a[1]-a[3],e),b[0]+=(a[3]-a[1])/2),null!==c[1]?h=Math.max(Math.min(h,b[2]-Math.max(a[0],a[2])),e):(h=Math.max(Math.min(h,b[2]-a[0]-a[2]),e),b[1]+=(a[0]-a[2])/2),h<b[2]?(b[2]=h,b[3]=Math.min(u(d.innerSize||0,h),h),this.translate(b),this.drawDataLabels&&this.drawDataLabels()):k=!0);return k});p.column&&(p.column.prototype.alignDataLabel=function(a,d,h,c,k){var b=this.chart.inverted,g=a.series,l=a.dlBox||a.shapeArgs,m=t(a.below,a.plotY>t(this.translatedThreshold,
	g.yAxis.len)),n=t(h.inside,!!this.options.stacking);l&&(c=e(l),0>c.y&&(c.height+=c.y,c.y=0),l=c.y+c.height-g.yAxis.len,0<l&&(c.height-=l),b&&(c={x:g.yAxis.len-c.y-c.height,y:g.xAxis.len-c.x-c.width,width:c.height,height:c.width}),n||(b?(c.x+=m?0:c.width,c.width=0):(c.y+=m?c.height:0,c.height=0)));h.align=t(h.align,!b||n?"center":m?"right":"left");h.verticalAlign=t(h.verticalAlign,b||n?"middle":m?"top":"bottom");v.prototype.alignDataLabel.call(this,a,d,h,c,k);a.isLabelJustified&&a.contrastColor&&d.css({color:a.contrastColor})})});
	K(G,"modules/overlapping-datalabels.src.js",[G["parts/Globals.js"]],function(a){var C=a.Chart,G=a.isArray,F=a.objectEach,k=a.pick,e=a.addEvent,q=a.fireEvent;e(C,"render",function(){var a=[];(this.labelCollectors||[]).forEach(function(e){a=a.concat(e())});(this.yAxis||[]).forEach(function(e){e.options.stackLabels&&!e.options.stackLabels.allowOverlap&&F(e.stacks,function(e){F(e,function(e){a.push(e.label)})})});(this.series||[]).forEach(function(e){var q=e.options.dataLabels;e.visible&&(!1!==q.enabled||
	e._hasPointLabels)&&e.points.forEach(function(e){e.visible&&(G(e.dataLabels)?e.dataLabels:e.dataLabel?[e.dataLabel]:[]).forEach(function(h){var d=h.options;h.labelrank=k(d.labelrank,e.labelrank,e.shapeArgs&&e.shapeArgs.height);d.allowOverlap||a.push(h)})})});this.hideOverlappingLabels(a)});C.prototype.hideOverlappingLabels=function(a){var e=this,k=a.length,p=e.renderer,h,d,m,b,g,l,c=function(a,b,c,d,e,g,h,k){return!(e>a+c||e+h<a||g>b+d||g+k<b)};m=function(a){var b,c,d,e=a.box?0:a.padding||0;d=0;if(a&&
	(!a.alignAttr||a.placed))return b=a.alignAttr||{x:a.attr("x"),y:a.attr("y")},c=a.parentGroup,a.width||(d=a.getBBox(),a.width=d.width,a.height=d.height,d=p.fontMetrics(null,a.element).h),{x:b.x+(c.translateX||0)+e,y:b.y+(c.translateY||0)+e-d,width:a.width-2*e,height:a.height-2*e}};for(d=0;d<k;d++)if(h=a[d])h.oldOpacity=h.opacity,h.newOpacity=1,h.absoluteBox=m(h);a.sort(function(a,b){return(b.labelrank||0)-(a.labelrank||0)});for(d=0;d<k;d++)for(l=(m=a[d])&&m.absoluteBox,h=d+1;h<k;++h)if(g=(b=a[h])&&
	b.absoluteBox,l&&g&&m!==b&&0!==m.newOpacity&&0!==b.newOpacity&&(g=c(l.x,l.y,l.width,l.height,g.x,g.y,g.width,g.height)))(m.labelrank<b.labelrank?m:b).newOpacity=0;a.forEach(function(a){var b,c;a&&(c=a.newOpacity,a.oldOpacity!==c&&(a.alignAttr&&a.placed?(c?a.show(!0):b=function(){a.hide()},a.alignAttr.opacity=c,a[a.isOld?"animate":"attr"](a.alignAttr,null,b),q(e,"afterHideOverlappingLabels")):a.attr({opacity:c})),a.isOld=!0)})}});K(G,"parts/Interaction.js",[G["parts/Globals.js"]],function(a){var C=
	a.addEvent,G=a.Chart,F=a.createElement,k=a.css,e=a.defaultOptions,q=a.defaultPlotOptions,t=a.extend,u=a.fireEvent,v=a.hasTouch,p=a.isObject,h=a.Legend,d=a.merge,m=a.pick,b=a.Point,g=a.Series,l=a.seriesTypes,c=a.svg,w;w=a.TrackerMixin={drawTrackerPoint:function(){var a=this,b=a.chart,c=b.pointer,d=function(a){var b=c.getPointFromEvent(a);void 0!==b&&(c.isDirectTouch=!0,b.onMouseOver(a))};a.points.forEach(function(a){a.graphic&&(a.graphic.element.point=a);a.dataLabel&&(a.dataLabel.div?a.dataLabel.div.point=
	a:a.dataLabel.element.point=a)});a._hasTracking||(a.trackerGroups.forEach(function(e){if(a[e]){a[e].addClass("highcharts-tracker").on("mouseover",d).on("mouseout",function(a){c.onTrackerMouseOut(a)});if(v)a[e].on("touchstart",d);!b.styledMode&&a.options.cursor&&a[e].css(k).css({cursor:a.options.cursor})}}),a._hasTracking=!0);u(this,"afterDrawTracker")},drawTrackerGraph:function(){var a=this,b=a.options,d=b.trackByArea,e=[].concat(d?a.areaPath:a.graphPath),g=e.length,h=a.chart,k=h.pointer,l=h.renderer,
	m=h.options.tooltip.snap,f=a.tracker,p,q=function(){if(h.hoverSeries!==a)a.onMouseOver()},t="rgba(192,192,192,"+(c?.0001:.002)+")";if(g&&!d)for(p=g+1;p--;)"M"===e[p]&&e.splice(p+1,0,e[p+1]-m,e[p+2],"L"),(p&&"M"===e[p]||p===g)&&e.splice(p,0,"L",e[p-2]+m,e[p-1]);f?f.attr({d:e}):a.graph&&(a.tracker=l.path(e).attr({visibility:a.visible?"visible":"hidden",zIndex:2}).addClass(d?"highcharts-tracker-area":"highcharts-tracker-line").add(a.group),h.styledMode||a.tracker.attr({"stroke-linejoin":"round",stroke:t,
	fill:d?t:"none","stroke-width":a.graph.strokeWidth()+(d?0:2*m)}),[a.tracker,a.markerGroup].forEach(function(a){a.addClass("highcharts-tracker").on("mouseover",q).on("mouseout",function(a){k.onTrackerMouseOut(a)});b.cursor&&!h.styledMode&&a.css({cursor:b.cursor});if(v)a.on("touchstart",q)}));u(this,"afterDrawTracker")}};l.column&&(l.column.prototype.drawTracker=w.drawTrackerPoint);l.pie&&(l.pie.prototype.drawTracker=w.drawTrackerPoint);l.scatter&&(l.scatter.prototype.drawTracker=w.drawTrackerPoint);
	t(h.prototype,{setItemEvents:function(a,c,e){var h=this,g=h.chart.renderer.boxWrapper,k=a instanceof b,l="highcharts-legend-"+(k?"point":"series")+"-active",m=h.chart.styledMode;(e?c:a.legendGroup).on("mouseover",function(){h.allItems.forEach(function(b){a!==b&&b.setState("inactive",!k)});a.setState("hover");a.visible&&g.addClass(l);m||c.css(h.options.itemHoverStyle)}).on("mouseout",function(){h.styledMode||c.css(d(a.visible?h.itemStyle:h.itemHiddenStyle));h.allItems.forEach(function(b){a!==b&&b.setState("",
	!k)});g.removeClass(l);a.setState()}).on("click",function(b){var c=function(){a.setVisible&&a.setVisible()};g.removeClass(l);b={browserEvent:b};a.firePointEvent?a.firePointEvent("legendItemClick",b,c):u(a,"legendItemClick",b,c)})},createCheckboxForItem:function(a){a.checkbox=F("input",{type:"checkbox",className:"highcharts-legend-checkbox",checked:a.selected,defaultChecked:a.selected},this.options.itemCheckboxStyle,this.chart.container);C(a.checkbox,"click",function(b){u(a.series||a,"checkboxClick",
	{checked:b.target.checked,item:a},function(){a.select()})})}});t(G.prototype,{showResetZoom:function(){function a(){b.zoomOut()}var b=this,c=e.lang,d=b.options.chart.resetZoomButton,h=d.theme,g=h.states,k="chart"===d.relativeTo||"spaceBox"===d.relativeTo?null:"plotBox";u(this,"beforeShowResetZoom",null,function(){b.resetZoomButton=b.renderer.button(c.resetZoom,null,null,a,h,g&&g.hover).attr({align:d.position.align,title:c.resetZoomTitle}).addClass("highcharts-reset-zoom").add().align(d.position,!1,
	k)});u(this,"afterShowResetZoom")},zoomOut:function(){u(this,"selection",{resetSelection:!0},this.zoom)},zoom:function(b){var c=this,d,e=c.pointer,h=!1,g=c.inverted?e.mouseDownX:e.mouseDownY,k;!b||b.resetSelection?(c.axes.forEach(function(a){d=a.zoom()}),e.initiated=!1):b.xAxis.concat(b.yAxis).forEach(function(b){var k=b.axis,f=c.inverted?k.left:k.top,l=c.inverted?f+k.width:f+k.height,m=k.isXAxis,n=!1;if(!m&&g>=f&&g<=l||m||!a.defined(g))n=!0;e[m?"zoomX":"zoomY"]&&n&&(d=k.zoom(b.min,b.max),k.displayBtn&&
	(h=!0))});k=c.resetZoomButton;h&&!k?c.showResetZoom():!h&&p(k)&&(c.resetZoomButton=k.destroy());d&&c.redraw(m(c.options.chart.animation,b&&b.animation,100>c.pointCount))},pan:function(a,b){var c=this,d=c.hoverPoints,e;u(this,"pan",{originalEvent:a},function(){d&&d.forEach(function(a){a.setState()});("xy"===b?[1,0]:[1]).forEach(function(b){b=c[b?"xAxis":"yAxis"][0];var d=b.horiz,h=a[d?"chartX":"chartY"],d=d?"mouseDownX":"mouseDownY",g=c[d],f=(b.pointRange||0)/2,k=b.reversed&&!c.inverted||!b.reversed&&
	c.inverted?-1:1,l=b.getExtremes(),m=b.toValue(g-h,!0)+f*k,k=b.toValue(g+b.len-h,!0)-f*k,n=k<m,g=n?k:m,m=n?m:k,k=Math.min(l.dataMin,f?l.min:b.toValue(b.toPixels(l.min)-b.minPixelPadding)),f=Math.max(l.dataMax,f?l.max:b.toValue(b.toPixels(l.max)+b.minPixelPadding)),n=k-g;0<n&&(m+=n,g=k);n=m-f;0<n&&(m=f,g-=n);b.series.length&&g!==l.min&&m!==l.max&&(b.setExtremes(g,m,!1,!1,{trigger:"pan"}),e=!0);c[d]=h});e&&c.redraw(!1);k(c.container,{cursor:"move"})})}});t(b.prototype,{select:function(a,b){var c=this,
	d=c.series,e=d.chart;a=m(a,!c.selected);c.firePointEvent(a?"select":"unselect",{accumulate:b},function(){c.selected=c.options.selected=a;d.options.data[d.data.indexOf(c)]=c.options;c.setState(a&&"select");b||e.getSelectedPoints().forEach(function(a){var b=a.series;a.selected&&a!==c&&(a.selected=a.options.selected=!1,b.options.data[b.data.indexOf(a)]=a.options,a.setState(e.hoverPoints&&b.options.inactiveOtherPoints?"inactive":""),a.firePointEvent("unselect"))})})},onMouseOver:function(a){var b=this.series.chart,
	c=b.pointer;a=a?c.normalize(a):c.getChartCoordinatesFromPoint(this,b.inverted);c.runPointActions(a,this)},onMouseOut:function(){var a=this.series.chart;this.firePointEvent("mouseOut");this.series.options.inactiveOtherPoints||(a.hoverPoints||[]).forEach(function(a){a.setState()});a.hoverPoints=a.hoverPoint=null},importEvents:function(){if(!this.hasImportedEvents){var b=this,c=d(b.series.options.point,b.options).events;b.events=c;a.objectEach(c,function(a,c){C(b,c,a)});this.hasImportedEvents=!0}},setState:function(a,
	b){var c=Math.floor(this.plotX),d=this.plotY,e=this.series,h=this.state,g=e.options.states[a||"normal"]||{},k=q[e.type].marker&&e.options.marker,l=k&&!1===k.enabled,f=k&&k.states&&k.states[a||"normal"]||{},p=!1===f.enabled,v=e.stateMarkerGraphic,z=this.marker||{},w=e.chart,C=e.halo,F,y,G,I=k&&e.markerAttribs;a=a||"";if(!(a===this.state&&!b||this.selected&&"select"!==a||!1===g.enabled||a&&(p||l&&!1===f.enabled)||a&&z.states&&z.states[a]&&!1===z.states[a].enabled)){this.state=a;I&&(F=e.markerAttribs(this,
	a));if(this.graphic)h&&this.graphic.removeClass("highcharts-point-"+h),a&&this.graphic.addClass("highcharts-point-"+a),w.styledMode||(y=e.pointAttribs(this,a),G=m(w.options.chart.animation,g.animation),e.options.inactiveOtherPoints&&((this.dataLabels||[]).forEach(function(a){a&&a.animate({opacity:y.opacity},G)}),this.connector&&this.connector.animate({opacity:y.opacity},G)),this.graphic.animate(y,G)),F&&this.graphic.animate(F,m(w.options.chart.animation,f.animation,k.animation)),v&&v.hide();else{if(a&&
	f){h=z.symbol||e.symbol;v&&v.currentSymbol!==h&&(v=v.destroy());if(v)v[b?"animate":"attr"]({x:F.x,y:F.y});else h&&(e.stateMarkerGraphic=v=w.renderer.symbol(h,F.x,F.y,F.width,F.height).add(e.markerGroup),v.currentSymbol=h);!w.styledMode&&v&&v.attr(e.pointAttribs(this,a))}v&&(v[a&&w.isInsidePlot(c,d,w.inverted)?"show":"hide"](),v.element.point=this)}(a=g.halo)&&a.size?(C||(e.halo=C=w.renderer.path().add((this.graphic||v).parentGroup)),C.show()[b?"animate":"attr"]({d:this.haloPath(a.size)}),C.attr({"class":"highcharts-halo highcharts-color-"+
	m(this.colorIndex,e.colorIndex)+(this.className?" "+this.className:""),zIndex:-1}),C.point=this,w.styledMode||C.attr(t({fill:this.color||e.color,"fill-opacity":a.opacity},a.attributes))):C&&C.point&&C.point.haloPath&&C.animate({d:C.point.haloPath(0)},null,C.hide);u(this,"afterSetState")}},haloPath:function(a){return this.series.chart.renderer.symbols.circle(Math.floor(this.plotX)-a,this.plotY-a,2*a,2*a)}});t(g.prototype,{onMouseOver:function(){var a=this.chart,b=a.hoverSeries;if(b&&b!==this)b.onMouseOut();
	this.options.events.mouseOver&&u(this,"mouseOver");this.setState("hover");a.hoverSeries=this},onMouseOut:function(){var a=this.options,b=this.chart,c=b.tooltip,d=b.hoverPoint;b.hoverSeries=null;if(d)d.onMouseOut();this&&a.events.mouseOut&&u(this,"mouseOut");!c||this.stickyTracking||c.shared&&!this.noSharedTooltip||c.hide();b.series.forEach(function(a){a.setState("",!0)})},setState:function(a,b){var c=this,d=c.options,e=c.graph,h=d.inactiveOtherPoints,g=d.states,k=d.lineWidth,l=d.opacity,f=m(g[a||
	"normal"]&&g[a||"normal"].animation,c.chart.options.chart.animation),d=0;a=a||"";if(c.state!==a&&([c.group,c.markerGroup,c.dataLabelsGroup].forEach(function(b){b&&(c.state&&b.removeClass("highcharts-series-"+c.state),a&&b.addClass("highcharts-series-"+a))}),c.state=a,!c.chart.styledMode)){if(g[a]&&!1===g[a].enabled)return;a&&(k=g[a].lineWidth||k+(g[a].lineWidthPlus||0),l=m(g[a].opacity,l));if(e&&!e.dashstyle)for(g={"stroke-width":k},e.animate(g,f);c["zone-graph-"+d];)c["zone-graph-"+d].attr(g),d+=
	1;h||[c.group,c.markerGroup,c.dataLabelsGroup,c.labelBySeries].forEach(function(a){a&&a.animate({opacity:l},f)})}b&&h&&c.points&&c.points.forEach(function(b){b.setState&&b.setState(a)})},setVisible:function(a,b){var c=this,d=c.chart,e=c.legendItem,g,h=d.options.chart.ignoreHiddenSeries,k=c.visible;g=(c.visible=a=c.options.visible=c.userOptions.visible=void 0===a?!k:a)?"show":"hide";["group","dataLabelsGroup","markerGroup","tracker","tt"].forEach(function(a){if(c[a])c[a][g]()});if(d.hoverSeries===
	c||(d.hoverPoint&&d.hoverPoint.series)===c)c.onMouseOut();e&&d.legend.colorizeItem(c,a);c.isDirty=!0;c.options.stacking&&d.series.forEach(function(a){a.options.stacking&&a.visible&&(a.isDirty=!0)});c.linkedSeries.forEach(function(b){b.setVisible(a,!1)});h&&(d.isDirtyBox=!0);u(c,g);!1!==b&&d.redraw()},show:function(){this.setVisible(!0)},hide:function(){this.setVisible(!1)},select:function(a){this.selected=a=this.options.selected=void 0===a?!this.selected:a;this.checkbox&&(this.checkbox.checked=a);
	u(this,a?"select":"unselect")},drawTracker:w.drawTrackerGraph})});K(G,"parts/Responsive.js",[G["parts/Globals.js"]],function(a){var C=a.Chart,G=a.isArray,F=a.isObject,k=a.pick,e=a.splat;C.prototype.setResponsive=function(e,k){var q=this.options.responsive,t=[],p=this.currentResponsive;!k&&q&&q.rules&&q.rules.forEach(function(h){void 0===h._id&&(h._id=a.uniqueKey());this.matchResponsiveRule(h,t,e)},this);k=a.merge.apply(0,t.map(function(e){return a.find(q.rules,function(a){return a._id===e}).chartOptions}));
	k.isResponsiveOptions=!0;t=t.toString()||void 0;t!==(p&&p.ruleIds)&&(p&&this.update(p.undoOptions,e),t?(p=this.currentOptions(k),p.isResponsiveOptions=!0,this.currentResponsive={ruleIds:t,mergedOptions:k,undoOptions:p},this.update(k,e)):this.currentResponsive=void 0)};C.prototype.matchResponsiveRule=function(a,e){var q=a.condition;(q.callback||function(){return this.chartWidth<=k(q.maxWidth,Number.MAX_VALUE)&&this.chartHeight<=k(q.maxHeight,Number.MAX_VALUE)&&this.chartWidth>=k(q.minWidth,0)&&this.chartHeight>=
	k(q.minHeight,0)}).call(this)&&e.push(a._id)};C.prototype.currentOptions=function(q){function t(q,p,h,d){var m;a.objectEach(q,function(a,g){if(!d&&-1<["series","xAxis","yAxis"].indexOf(g))for(a=e(a),h[g]=[],m=0;m<a.length;m++)p[g][m]&&(h[g][m]={},t(a[m],p[g][m],h[g][m],d+1));else F(a)?(h[g]=G(a)?[]:{},t(a,p[g]||{},h[g],d+1)):h[g]=k(p[g],null)})}var u={};t(q,this.options,u,0);return u}});K(G,"masters/highcharts.src.js",[G["parts/Globals.js"]],function(a){return a});G["masters/highcharts.src.js"]._modules=
	G;return G["masters/highcharts.src.js"]});
	//# sourceMappingURL=highcharts.js.map

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	 Highcharts JS v7.1.1 (2019-04-09)
	
	 Exporting module
	
	 (c) 2010-2019 Torstein Honsi
	
	 License: www.highcharts.com/license
	*/
	(function(f){"object"===typeof module&&module.exports?(f["default"]=f,module.exports=f): true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(92)], __WEBPACK_AMD_DEFINE_RESULT__ = function(h){f(h);f.Highcharts=h;return f}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):f("undefined"!==typeof Highcharts?Highcharts:void 0)})(function(f){function h(c,C,f,n){c.hasOwnProperty(C)||(c[C]=n.apply(null,f))}f=f?f._modules:{};h(f,"modules/full-screen.src.js",[f["parts/Globals.js"]],function(c){c.FullScreen=function(c){this.init(c.parentNode)};c.FullScreen.prototype=
	{init:function(c){c.requestFullscreen?c.requestFullscreen():c.mozRequestFullScreen?c.mozRequestFullScreen():c.webkitRequestFullscreen?c.webkitRequestFullscreen():c.msRequestFullscreen&&c.msRequestFullscreen()}}});h(f,"mixins/navigation.js",[],function(){return{initUpdate:function(c){c.navigation||(c.navigation={updates:[],update:function(c,f){this.updates.forEach(function(n){n.update.call(n.context,c,f)})}})},addUpdate:function(c,f){f.navigation||this.initUpdate(f);f.navigation.updates.push({update:c,
	context:f})}}});h(f,"modules/exporting.src.js",[f["parts/Globals.js"],f["mixins/navigation.js"]],function(c,f){var h=c.defaultOptions,n=c.doc,A=c.Chart,v=c.addEvent,C=c.removeEvent,D=c.fireEvent,r=c.createElement,E=c.discardElement,w=c.css,p=c.merge,t=c.pick,F=c.objectEach,y=c.extend,J=c.isTouchDevice,z=c.win,H=z.navigator.userAgent,G=c.SVGRenderer,I=c.Renderer.prototype.symbols,K=/Edge\/|Trident\/|MSIE /.test(H),L=/firefox/i.test(H);y(h.lang,{viewFullscreen:"View in full screen",printChart:"Print chart",
	downloadPNG:"Download PNG image",downloadJPEG:"Download JPEG image",downloadPDF:"Download PDF document",downloadSVG:"Download SVG vector image",contextButtonTitle:"Chart context menu"});h.navigation||(h.navigation={});p(!0,h.navigation,{buttonOptions:{theme:{},symbolSize:14,symbolX:12.5,symbolY:10.5,align:"right",buttonSpacing:3,height:22,verticalAlign:"top",width:24}});p(!0,h.navigation,{menuStyle:{border:"1px solid #999999",background:"#ffffff",padding:"5px 0"},menuItemStyle:{padding:"0.5em 1em",
	color:"#333333",background:"none",fontSize:J?"14px":"11px",transition:"background 250ms, color 250ms"},menuItemHoverStyle:{background:"#335cad",color:"#ffffff"},buttonOptions:{symbolFill:"#666666",symbolStroke:"#666666",symbolStrokeWidth:3,theme:{padding:5}}});h.exporting={type:"image/png",url:"https://export.highcharts.com/",printMaxWidth:780,scale:2,buttons:{contextButton:{className:"highcharts-contextbutton",menuClassName:"highcharts-contextmenu",symbol:"menu",titleKey:"contextButtonTitle",menuItems:"viewFullscreen printChart separator downloadPNG downloadJPEG downloadPDF downloadSVG".split(" ")}},
	menuItemDefinitions:{viewFullscreen:{textKey:"viewFullscreen",onclick:function(){this.fullscreen=new c.FullScreen(this.container)}},printChart:{textKey:"printChart",onclick:function(){this.print()}},separator:{separator:!0},downloadPNG:{textKey:"downloadPNG",onclick:function(){this.exportChart()}},downloadJPEG:{textKey:"downloadJPEG",onclick:function(){this.exportChart({type:"image/jpeg"})}},downloadPDF:{textKey:"downloadPDF",onclick:function(){this.exportChart({type:"application/pdf"})}},downloadSVG:{textKey:"downloadSVG",
	onclick:function(){this.exportChart({type:"image/svg+xml"})}}}};c.post=function(b,a,c){var d=r("form",p({method:"post",action:b,enctype:"multipart/form-data"},c),{display:"none"},n.body);F(a,function(a,b){r("input",{type:"hidden",name:b,value:a},null,d)});d.submit();E(d)};y(A.prototype,{sanitizeSVG:function(b,a){var c=b.indexOf("\x3c/svg\x3e")+6,d=b.substr(c);b=b.substr(0,c);a&&a.exporting&&a.exporting.allowHTML&&d&&(d='\x3cforeignObject x\x3d"0" y\x3d"0" width\x3d"'+a.chart.width+'" height\x3d"'+
	a.chart.height+'"\x3e\x3cbody xmlns\x3d"http://www.w3.org/1999/xhtml"\x3e'+d+"\x3c/body\x3e\x3c/foreignObject\x3e",b=b.replace("\x3c/svg\x3e",d+"\x3c/svg\x3e"));b=b.replace(/zIndex="[^"]+"/g,"").replace(/symbolName="[^"]+"/g,"").replace(/jQuery[0-9]+="[^"]+"/g,"").replace(/url\(("|&quot;)(\S+)("|&quot;)\)/g,"url($2)").replace(/url\([^#]+#/g,"url(#").replace(/<svg /,'\x3csvg xmlns:xlink\x3d"http://www.w3.org/1999/xlink" ').replace(/ (|NS[0-9]+\:)href=/g," xlink:href\x3d").replace(/\n/," ").replace(/(fill|stroke)="rgba\(([ 0-9]+,[ 0-9]+,[ 0-9]+),([ 0-9\.]+)\)"/g,
	'$1\x3d"rgb($2)" $1-opacity\x3d"$3"').replace(/&nbsp;/g,"\u00a0").replace(/&shy;/g,"\u00ad");this.ieSanitizeSVG&&(b=this.ieSanitizeSVG(b));return b},getChartHTML:function(){this.styledMode&&this.inlineStyles();return this.container.innerHTML},getSVG:function(b){var a,u,d,f,m,k=p(this.options,b);u=r("div",null,{position:"absolute",top:"-9999em",width:this.chartWidth+"px",height:this.chartHeight+"px"},n.body);d=this.renderTo.style.width;m=this.renderTo.style.height;d=k.exporting.sourceWidth||k.chart.width||
	/px$/.test(d)&&parseInt(d,10)||(k.isGantt?800:600);m=k.exporting.sourceHeight||k.chart.height||/px$/.test(m)&&parseInt(m,10)||400;y(k.chart,{animation:!1,renderTo:u,forExport:!0,renderer:"SVGRenderer",width:d,height:m});k.exporting.enabled=!1;delete k.data;k.series=[];this.series.forEach(function(a){f=p(a.userOptions,{animation:!1,enableMouseTracking:!1,showCheckbox:!1,visible:a.visible});f.isInternal||k.series.push(f)});this.axes.forEach(function(a){a.userOptions.internalKey||(a.userOptions.internalKey=
	c.uniqueKey())});a=new c.Chart(k,this.callback);b&&["xAxis","yAxis","series"].forEach(function(d){var c={};b[d]&&(c[d]=b[d],a.update(c))});this.axes.forEach(function(b){var d=c.find(a.axes,function(a){return a.options.internalKey===b.userOptions.internalKey}),e=b.getExtremes(),u=e.userMin,e=e.userMax;d&&(void 0!==u&&u!==d.min||void 0!==e&&e!==d.max)&&d.setExtremes(u,e,!0,!1)});d=a.getChartHTML();D(this,"getSVG",{chartCopy:a});d=this.sanitizeSVG(d,k);k=null;a.destroy();E(u);return d},getSVGForExport:function(b,
	a){var c=this.options.exporting;return this.getSVG(p({chart:{borderRadius:0}},c.chartOptions,a,{exporting:{sourceWidth:b&&b.sourceWidth||c.sourceWidth,sourceHeight:b&&b.sourceHeight||c.sourceHeight}}))},getFilename:function(){var b=this.userOptions.title&&this.userOptions.title.text,a=this.options.exporting.filename;if(a)return a;"string"===typeof b&&(a=b.toLowerCase().replace(/<\/?[^>]+(>|$)/g,"").replace(/[\s_]+/g,"-").replace(/[^a-z0-9\-]/g,"").replace(/^[\-]+/g,"").replace(/[\-]+/g,"-").substr(0,
	24).replace(/[\-]+$/g,""));if(!a||5>a.length)a="chart";return a},exportChart:function(b,a){a=this.getSVGForExport(b,a);b=p(this.options.exporting,b);c.post(b.url,{filename:b.filename||this.getFilename(),type:b.type,width:b.width||0,scale:b.scale,svg:a},b.formAttributes)},print:function(){function b(b){(a.fixedDiv?[a.fixedDiv,a.scrollingContainer]:[a.container]).forEach(function(a){b.appendChild(a)})}var a=this,c=[],d=n.body,f=d.childNodes,m=a.options.exporting.printMaxWidth,k,e;if(!a.isPrinting){a.isPrinting=
	!0;a.pointer.reset(null,0);D(a,"beforePrint");if(e=m&&a.chartWidth>m)k=[a.options.chart.width,void 0,!1],a.setSize(m,void 0,!1);[].forEach.call(f,function(a,b){1===a.nodeType&&(c[b]=a.style.display,a.style.display="none")});b(d);setTimeout(function(){z.focus();z.print();setTimeout(function(){b(a.renderTo);[].forEach.call(f,function(a,b){1===a.nodeType&&(a.style.display=c[b])});a.isPrinting=!1;e&&a.setSize.apply(a,k);D(a,"afterPrint")},1E3)},1)}},contextMenu:function(b,a,u,d,f,m,k){var e=this,x=e.options.navigation,
	l=e.chartWidth,q=e.chartHeight,h="cache-"+b,g=e[h],B=Math.max(f,m),p;g||(e.exportContextMenu=e[h]=g=r("div",{className:b},{position:"absolute",zIndex:1E3,padding:B+"px",pointerEvents:"auto"},e.fixedDiv||e.container),p=r("div",{className:"highcharts-menu"},null,g),e.styledMode||w(p,y({MozBoxShadow:"3px 3px 10px #888",WebkitBoxShadow:"3px 3px 10px #888",boxShadow:"3px 3px 10px #888"},x.menuStyle)),g.hideMenu=function(){w(g,{display:"none"});k&&k.setState(0);e.openMenu=!1;c.clearTimeout(g.hideTimer);
	D(e,"exportMenuHidden")},e.exportEvents.push(v(g,"mouseleave",function(){g.hideTimer=setTimeout(g.hideMenu,500)}),v(g,"mouseenter",function(){c.clearTimeout(g.hideTimer)}),v(n,"mouseup",function(a){e.pointer.inClass(a.target,b)||g.hideMenu()}),v(g,"click",function(){e.openMenu&&g.hideMenu()})),a.forEach(function(a){"string"===typeof a&&(a=e.options.exporting.menuItemDefinitions[a]);if(c.isObject(a,!0)){var b;a.separator?b=r("hr",null,null,p):(b=r("div",{className:"highcharts-menu-item",onclick:function(b){b&&
	b.stopPropagation();g.hideMenu();a.onclick&&a.onclick.apply(e,arguments)},innerHTML:a.text||e.options.lang[a.textKey]},null,p),e.styledMode||(b.onmouseover=function(){w(this,x.menuItemHoverStyle)},b.onmouseout=function(){w(this,x.menuItemStyle)},w(b,y({cursor:"pointer"},x.menuItemStyle))));e.exportDivElements.push(b)}}),e.exportDivElements.push(p,g),e.exportMenuWidth=g.offsetWidth,e.exportMenuHeight=g.offsetHeight);a={display:"block"};u+e.exportMenuWidth>l?a.right=l-u-f-B+"px":a.left=u-B+"px";d+m+
	e.exportMenuHeight>q&&"top"!==k.alignOptions.verticalAlign?a.bottom=q-d-B+"px":a.top=d+m-B+"px";w(g,a);e.openMenu=!0},addButton:function(b){var a=this,c=a.renderer,d=p(a.options.navigation.buttonOptions,b),f=d.onclick,m=d.menuItems,k,e,h=d.symbolSize||12;a.btnCount||(a.btnCount=0);a.exportDivElements||(a.exportDivElements=[],a.exportSVGElements=[]);if(!1!==d.enabled){var l=d.theme,q=l.states,n=q&&q.hover,q=q&&q.select,g;a.styledMode||(l.fill=t(l.fill,"#ffffff"),l.stroke=t(l.stroke,"none"));delete l.states;
	f?g=function(b){b&&b.stopPropagation();f.call(a,b)}:m&&(g=function(b){b&&b.stopPropagation();a.contextMenu(e.menuClassName,m,e.translateX,e.translateY,e.width,e.height,e);e.setState(2)});d.text&&d.symbol?l.paddingLeft=t(l.paddingLeft,25):d.text||y(l,{width:d.width,height:d.height,padding:0});a.styledMode||(l["stroke-linecap"]="round",l.fill=t(l.fill,"#ffffff"),l.stroke=t(l.stroke,"none"));e=c.button(d.text,0,0,g,l,n,q).addClass(b.className).attr({title:t(a.options.lang[d._titleKey||d.titleKey],"")});
	e.menuClassName=b.menuClassName||"highcharts-menu-"+a.btnCount++;d.symbol&&(k=c.symbol(d.symbol,d.symbolX-h/2,d.symbolY-h/2,h,h,{width:h,height:h}).addClass("highcharts-button-symbol").attr({zIndex:1}).add(e),a.styledMode||k.attr({stroke:d.symbolStroke,fill:d.symbolFill,"stroke-width":d.symbolStrokeWidth||1}));e.add(a.exportingGroup).align(y(d,{width:e.width,x:t(d.x,a.buttonOffset)}),!0,"spacingBox");a.buttonOffset+=(e.width+d.buttonSpacing)*("right"===d.align?-1:1);a.exportSVGElements.push(e,k)}},
	destroyExport:function(b){var a=b?b.target:this;b=a.exportSVGElements;var f=a.exportDivElements,d=a.exportEvents,h;b&&(b.forEach(function(b,d){b&&(b.onclick=b.ontouchstart=null,h="cache-"+b.menuClassName,a[h]&&delete a[h],a.exportSVGElements[d]=b.destroy())}),b.length=0);a.exportingGroup&&(a.exportingGroup.destroy(),delete a.exportingGroup);f&&(f.forEach(function(b,d){c.clearTimeout(b.hideTimer);C(b,"mouseleave");a.exportDivElements[d]=b.onmouseout=b.onmouseover=b.ontouchstart=b.onclick=null;E(b)}),
	f.length=0);d&&(d.forEach(function(b){b()}),d.length=0)}});G.prototype.inlineToAttributes="fill stroke strokeLinecap strokeLinejoin strokeWidth textAnchor x y".split(" ");G.prototype.inlineBlacklist=[/-/,/^(clipPath|cssText|d|height|width)$/,/^font$/,/[lL]ogical(Width|Height)$/,/perspective/,/TapHighlightColor/,/^transition/,/^length$/];G.prototype.unstyledElements=["clipPath","defs","desc"];A.prototype.inlineStyles=function(){function b(b){return b.replace(/([A-Z])/g,function(b,a){return"-"+a.toLowerCase()})}
	function a(c){function u(a,g){q=v=!1;if(h){for(r=h.length;r--&&!v;)v=h[r].test(g);q=!v}"transform"===g&&"none"===a&&(q=!0);for(r=f.length;r--&&!q;)q=f[r].test(g)||"function"===typeof a;q||m[g]===a&&"svg"!==c.nodeName||e[c.nodeName][g]===a||(-1!==d.indexOf(g)?c.setAttribute(b(g),a):n+=b(g)+":"+a+";")}var g,m,n="",t,q,v,r;if(1===c.nodeType&&-1===k.indexOf(c.nodeName)){g=z.getComputedStyle(c,null);m="svg"===c.nodeName?{}:z.getComputedStyle(c.parentNode,null);e[c.nodeName]||(x=l.getElementsByTagName("svg")[0],
	t=l.createElementNS(c.namespaceURI,c.nodeName),x.appendChild(t),e[c.nodeName]=p(z.getComputedStyle(t,null)),"text"===c.nodeName&&delete e.text.fill,x.removeChild(t));if(L||K)for(var w in g)u(g[w],w);else F(g,u);n&&(g=c.getAttribute("style"),c.setAttribute("style",(g?g+";":"")+n));"svg"===c.nodeName&&c.setAttribute("stroke-width","1px");"text"!==c.nodeName&&[].forEach.call(c.children||c.childNodes,a)}}var c=this.renderer,d=c.inlineToAttributes,f=c.inlineBlacklist,h=c.inlineWhitelist,k=c.unstyledElements,
	e={},x,l,c=n.createElement("iframe");w(c,{width:"1px",height:"1px",visibility:"hidden"});n.body.appendChild(c);l=c.contentWindow.document;l.open();l.write('\x3csvg xmlns\x3d"http://www.w3.org/2000/svg"\x3e\x3c/svg\x3e');l.close();a(this.container.querySelector("svg"));x.parentNode.removeChild(x)};I.menu=function(b,a,c,d){return["M",b,a+2.5,"L",b+c,a+2.5,"M",b,a+d/2+.5,"L",b+c,a+d/2+.5,"M",b,a+d-1.5,"L",b+c,a+d-1.5]};I.menuball=function(b,a,c,d){b=[];d=d/3-2;return b=b.concat(this.circle(c-d,a,d,d),
	this.circle(c-d,a+d+4,d,d),this.circle(c-d,a+2*(d+4),d,d))};A.prototype.renderExporting=function(){var b=this,a=b.options.exporting,c=a.buttons,d=b.isDirtyExporting||!b.exportSVGElements;b.buttonOffset=0;b.isDirtyExporting&&b.destroyExport();d&&!1!==a.enabled&&(b.exportEvents=[],b.exportingGroup=b.exportingGroup||b.renderer.g("exporting-group").attr({zIndex:3}).add(),F(c,function(a){b.addButton(a)}),b.isDirtyExporting=!1);v(b,"destroy",b.destroyExport)};v(A,"init",function(){var b=this;b.exporting=
	{update:function(a,c){b.isDirtyExporting=!0;p(!0,b.options.exporting,a);t(c,!0)&&b.redraw()}};f.addUpdate(function(a,c){b.isDirtyExporting=!0;p(!0,b.options.navigation,a);t(c,!0)&&b.redraw()},b)});A.prototype.callbacks.push(function(b){b.renderExporting();v(b,"redraw",b.renderExporting)})});h(f,"masters/modules/exporting.src.js",[],function(){})});
	//# sourceMappingURL=exporting.js.map

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var af = moment.defineLocale('af', {
	        months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	        weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM : function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Vandag om] LT',
	            nextDay : '[Môre om] LT',
	            nextWeek : 'dddd [om] LT',
	            lastDay : '[Gister om] LT',
	            lastWeek : '[Laas] dddd [om] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'oor %s',
	            past : '%s gelede',
	            s : '\'n paar sekondes',
	            ss : '%d sekondes',
	            m : '\'n minuut',
	            mm : '%d minute',
	            h : '\'n uur',
	            hh : '%d ure',
	            d : '\'n dag',
	            dd : '%d dae',
	            M : '\'n maand',
	            MM : '%d maande',
	            y : '\'n jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week : {
	            dow : 1, // Maandag is die eerste dag van die week.
	            doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        }
	    });
	
	    return af;
	
	})));


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arDz = moment.defineLocale('ar-dz', {
	        months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return arDz;
	
	})));


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arKw = moment.defineLocale('ar-kw', {
	        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return arKw;
	
	})));


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '1',
	        '2': '2',
	        '3': '3',
	        '4': '4',
	        '5': '5',
	        '6': '6',
	        '7': '7',
	        '8': '8',
	        '9': '9',
	        '0': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months = [
	        'يناير',
	        'فبراير',
	        'مارس',
	        'أبريل',
	        'مايو',
	        'يونيو',
	        'يوليو',
	        'أغسطس',
	        'سبتمبر',
	        'أكتوبر',
	        'نوفمبر',
	        'ديسمبر'
	    ];
	
	    var arLy = moment.defineLocale('ar-ly', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            ss : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return arLy;
	
	})));


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arMa = moment.defineLocale('ar-ma', {
	        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return arMa;
	
	})));


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    };
	
	    var arSa = moment.defineLocale('ar-sa', {
	        months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return arSa;
	
	})));


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arTn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss : '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return arTn;
	
	})));


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months = [
	        'يناير',
	        'فبراير',
	        'مارس',
	        'أبريل',
	        'مايو',
	        'يونيو',
	        'يوليو',
	        'أغسطس',
	        'سبتمبر',
	        'أكتوبر',
	        'نوفمبر',
	        'ديسمبر'
	    ];
	
	    var ar = moment.defineLocale('ar', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            ss : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return ar;
	
	})));


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı'
	    };
	
	    var az = moment.defineLocale('az', {
	        months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	        monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	        weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[sabah saat] LT',
	            nextWeek : '[gələn həftə] dddd [saat] LT',
	            lastDay : '[dünən] LT',
	            lastWeek : '[keçən həftə] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s əvvəl',
	            s : 'birneçə saniyə',
	            ss : '%d saniyə',
	            m : 'bir dəqiqə',
	            mm : '%d dəqiqə',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir il',
	            yy : '%d il'
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM : function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal : function (number) {
	            if (number === 0) {  // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = number % 100 - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return az;
	
	})));


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            'dd': 'дзень_дні_дзён',
	            'MM': 'месяц_месяцы_месяцаў',
	            'yy': 'год_гады_гадоў'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months : {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	        },
	        monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	        weekdays : {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/
	        },
	        weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	        },
	        calendar : {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'праз %s',
	            past : '%s таму',
	            s : 'некалькі секунд',
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithPlural,
	            hh : relativeTimeWithPlural,
	            d : 'дзень',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM : function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return be;
	
	})));


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var bg = moment.defineLocale('bg', {
	        months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Днес в] LT',
	            nextDay : '[Утре в] LT',
	            nextWeek : 'dddd [в] LT',
	            lastDay : '[Вчера в] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[В изминалата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[В изминалия] dddd [в] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'след %s',
	            past : 'преди %s',
	            s : 'няколко секунди',
	            ss : '%d секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дни',
	            M : 'месец',
	            MM : '%d месеца',
	            y : 'година',
	            yy : '%d години'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return bg;
	
	})));


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var bm = moment.defineLocale('bm', {
	        months : 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
	        monthsShort : 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	        weekdays : 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	        weekdaysShort : 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	        weekdaysMin : 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'MMMM [tile] D [san] YYYY',
	            LLL : 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	            LLLL : 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
	        },
	        calendar : {
	            sameDay : '[Bi lɛrɛ] LT',
	            nextDay : '[Sini lɛrɛ] LT',
	            nextWeek : 'dddd [don lɛrɛ] LT',
	            lastDay : '[Kunu lɛrɛ] LT',
	            lastWeek : 'dddd [tɛmɛnen lɛrɛ] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s kɔnɔ',
	            past : 'a bɛ %s bɔ',
	            s : 'sanga dama dama',
	            ss : 'sekondi %d',
	            m : 'miniti kelen',
	            mm : 'miniti %d',
	            h : 'lɛrɛ kelen',
	            hh : 'lɛrɛ %d',
	            d : 'tile kelen',
	            dd : 'tile %d',
	            M : 'kalo kelen',
	            MM : 'kalo %d',
	            y : 'san kelen',
	            yy : 'san %d'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return bm;
	
	})));


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '১',
	        '2': '২',
	        '3': '৩',
	        '4': '৪',
	        '5': '৫',
	        '6': '৬',
	        '7': '৭',
	        '8': '৮',
	        '9': '৯',
	        '0': '০'
	    },
	    numberMap = {
	        '১': '1',
	        '২': '2',
	        '৩': '3',
	        '৪': '4',
	        '৫': '5',
	        '৬': '6',
	        '৭': '7',
	        '৮': '8',
	        '৯': '9',
	        '০': '0'
	    };
	
	    var bn = moment.defineLocale('bn', {
	        months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	        monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	        weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	        weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm সময়',
	            LTS : 'A h:mm:ss সময়',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm সময়',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	        },
	        calendar : {
	            sameDay : '[আজ] LT',
	            nextDay : '[আগামীকাল] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[গতকাল] LT',
	            lastWeek : '[গত] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s পরে',
	            past : '%s আগে',
	            s : 'কয়েক সেকেন্ড',
	            ss : '%d সেকেন্ড',
	            m : 'এক মিনিট',
	            mm : '%d মিনিট',
	            h : 'এক ঘন্টা',
	            hh : '%d ঘন্টা',
	            d : 'এক দিন',
	            dd : '%d দিন',
	            M : 'এক মাস',
	            MM : '%d মাস',
	            y : 'এক বছর',
	            yy : '%d বছর'
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'রাত' && hour >= 4) ||
	                    (meridiem === 'দুপুর' && hour < 5) ||
	                    meridiem === 'বিকাল') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return bn;
	
	})));


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '༡',
	        '2': '༢',
	        '3': '༣',
	        '4': '༤',
	        '5': '༥',
	        '6': '༦',
	        '7': '༧',
	        '8': '༨',
	        '9': '༩',
	        '0': '༠'
	    },
	    numberMap = {
	        '༡': '1',
	        '༢': '2',
	        '༣': '3',
	        '༤': '4',
	        '༥': '5',
	        '༦': '6',
	        '༧': '7',
	        '༨': '8',
	        '༩': '9',
	        '༠': '0'
	    };
	
	    var bo = moment.defineLocale('bo', {
	        months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	        weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[དི་རིང] LT',
	            nextDay : '[སང་ཉིན] LT',
	            nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay : '[ཁ་སང] LT',
	            lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ལ་',
	            past : '%s སྔན་ལ',
	            s : 'ལམ་སང',
	            ss : '%d སྐར་ཆ།',
	            m : 'སྐར་མ་གཅིག',
	            mm : '%d སྐར་མ',
	            h : 'ཆུ་ཚོད་གཅིག',
	            hh : '%d ཆུ་ཚོད',
	            d : 'ཉིན་གཅིག',
	            dd : '%d ཉིན་',
	            M : 'ཟླ་བ་གཅིག',
	            MM : '%d ཟླ་བ',
	            y : 'ལོ་གཅིག',
	            yy : '%d ལོ'
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                    (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                    meridiem === 'དགོང་དག') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return bo;
	
	})));


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            'mm': 'munutenn',
	            'MM': 'miz',
	            'dd': 'devezh'
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            'm': 'v',
	            'b': 'v',
	            'd': 'z'
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var br = moment.defineLocale('br', {
	        months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	        monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h[e]mm A',
	            LTS : 'h[e]mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [a viz] MMMM YYYY',
	            LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	            LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	        },
	        calendar : {
	            sameDay : '[Hiziv da] LT',
	            nextDay : '[Warc\'hoazh da] LT',
	            nextWeek : 'dddd [da] LT',
	            lastDay : '[Dec\'h da] LT',
	            lastWeek : 'dddd [paset da] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'a-benn %s',
	            past : '%s \'zo',
	            s : 'un nebeud segondennoù',
	            ss : '%d eilenn',
	            m : 'ur vunutenn',
	            mm : relativeTimeWithMutation,
	            h : 'un eur',
	            hh : '%d eur',
	            d : 'un devezh',
	            dd : relativeTimeWithMutation,
	            M : 'ur miz',
	            MM : relativeTimeWithMutation,
	            y : 'ur bloaz',
	            yy : specialMutationForYears
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	        ordinal : function (number) {
	            var output = (number === 1) ? 'añ' : 'vet';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return br;
	
	})));


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            ss     : translate,
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return bs;
	
	})));


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ca = moment.defineLocale('ca', {
	        months : {
	            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	            format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
	            isFormat: /D[oD]?(\s)+MMMM/
	        },
	        monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	        weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin : 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM [de] YYYY',
	            ll : 'D MMM YYYY',
	            LLL : 'D MMMM [de] YYYY [a les] H:mm',
	            lll : 'D MMM YYYY, H:mm',
	            LLLL : 'dddd D MMMM [de] YYYY [a les] H:mm',
	            llll : 'ddd D MMM YYYY, H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextDay : function () {
	                return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastDay : function () {
	                return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'd\'aquí %s',
	            past : 'fa %s',
	            s : 'uns segons',
	            ss : '%d segons',
	            m : 'un minut',
	            mm : '%d minuts',
	            h : 'una hora',
	            hh : '%d hores',
	            d : 'un dia',
	            dd : '%d dies',
	            M : 'un mes',
	            MM : '%d mesos',
	            y : 'un any',
	            yy : '%d anys'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal : function (number, period) {
	            var output = (number === 1) ? 'r' :
	                (number === 2) ? 'n' :
	                (number === 3) ? 'r' :
	                (number === 4) ? 't' : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ca;
	
	})));


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	
	    var monthsParse = [/^led/i, /^úno/i, /^bře/i, /^dub/i, /^kvě/i, /^(čvn|červen$|června)/i, /^(čvc|červenec|července)/i, /^srp/i, /^zář/i, /^říj/i, /^lis/i, /^pro/i];
	    // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	    // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	    var monthsRegex = /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;
	
	    function plural(n) {
	        return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':  // a few seconds / in a few seconds / a few seconds ago
	                return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekund');
	                } else {
	                    return result + 'sekundami';
	                }
	                break;
	            case 'm':  // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	                break;
	            case 'h':  // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':  // a day / in a day / a day ago
	                return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	                break;
	            case 'M':  // a month / in a month / a month ago
	                return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	                break;
	            case 'y':  // a year / in a year / a year ago
	                return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	                break;
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsRegex : monthsRegex,
	        monthsShortRegex : monthsRegex,
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsStrictRegex : /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
	        monthsShortStrictRegex : /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	        weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm',
	            l : 'D. M. YYYY'
	        },
	        calendar : {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'před %s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cs;
	
	})));


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var cv = moment.defineLocale('cv', {
	        months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	        monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	        weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	        },
	        calendar : {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (output) {
	                var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	                return output + affix;
	            },
	            past : '%s каялла',
	            s : 'пӗр-ик ҫеккунт',
	            ss : '%d ҫеккунт',
	            m : 'пӗр минут',
	            mm : '%d минут',
	            h : 'пӗр сехет',
	            hh : '%d сехет',
	            d : 'пӗр кун',
	            dd : '%d кун',
	            M : 'пӗр уйӑх',
	            MM : '%d уйӑх',
	            y : 'пӗр ҫул',
	            yy : '%d ҫул'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	        ordinal : '%d-мӗш',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return cv;
	
	})));


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            ss: '%d eiliad',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                    'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cy;
	
	})));


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var da = moment.defineLocale('da', {
	        months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay : '[i dag kl.] LT',
	            nextDay : '[i morgen kl.] LT',
	            nextWeek : 'på dddd [kl.] LT',
	            lastDay : '[i går kl.] LT',
	            lastWeek : '[i] dddd[s kl.] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'få sekunder',
	            ss : '%d sekunder',
	            m : 'et minut',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dage',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'et år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return da;
	
	})));


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deAt = moment.defineLocale('de-at', {
	        months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return deAt;
	
	})));


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deCh = moment.defineLocale('de-ch', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return deCh;
	
	})));


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return de;
	
	})));


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'ޖެނުއަރީ',
	        'ފެބްރުއަރީ',
	        'މާރިޗު',
	        'އޭޕްރީލު',
	        'މޭ',
	        'ޖޫން',
	        'ޖުލައި',
	        'އޯގަސްޓު',
	        'ސެޕްޓެމްބަރު',
	        'އޮކްޓޯބަރު',
	        'ނޮވެމްބަރު',
	        'ޑިސެމްބަރު'
	    ], weekdays = [
	        'އާދިއްތަ',
	        'ހޯމަ',
	        'އަންގާރަ',
	        'ބުދަ',
	        'ބުރާސްފަތި',
	        'ހުކުރު',
	        'ހޮނިހިރު'
	    ];
	
	    var dv = moment.defineLocale('dv', {
	        months : months,
	        monthsShort : months,
	        weekdays : weekdays,
	        weekdaysShort : weekdays,
	        weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat : {
	
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/M/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM : function (input) {
	            return 'މފ' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar : {
	            sameDay : '[މިއަދު] LT',
	            nextDay : '[މާދަމާ] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[އިއްޔެ] LT',
	            lastWeek : '[ފާއިތުވި] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ތެރޭގައި %s',
	            past : 'ކުރިން %s',
	            s : 'ސިކުންތުކޮޅެއް',
	            ss : 'd% ސިކުންތު',
	            m : 'މިނިޓެއް',
	            mm : 'މިނިޓު %d',
	            h : 'ގަޑިއިރެއް',
	            hh : 'ގަޑިއިރު %d',
	            d : 'ދުވަހެއް',
	            dd : 'ދުވަސް %d',
	            M : 'މަހެއް',
	            MM : 'މަސް %d',
	            y : 'އަހަރެއް',
	            yy : 'އަހަރު %d'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 7,  // Sunday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return dv;
	
	})));


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	        monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	        months : function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return this._monthsNominativeEl;
	            } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	        weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM : function (input) {
	            return ((input + '').toLowerCase()[0] === 'μ');
	        },
	        meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendarEl : {
	            sameDay : '[Σήμερα {}] LT',
	            nextDay : '[Αύριο {}] LT',
	            nextWeek : 'dddd [{}] LT',
	            lastDay : '[Χθες {}] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        calendar : function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	        },
	        relativeTime : {
	            future : 'σε %s',
	            past : '%s πριν',
	            s : 'λίγα δευτερόλεπτα',
	            ss : '%d δευτερόλεπτα',
	            m : 'ένα λεπτό',
	            mm : '%d λεπτά',
	            h : 'μία ώρα',
	            hh : '%d ώρες',
	            d : 'μία μέρα',
	            dd : '%d μέρες',
	            M : 'ένας μήνας',
	            MM : '%d μήνες',
	            y : 'ένας χρόνος',
	            yy : '%d χρόνια'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4st is the first week of the year.
	        }
	    });
	
	    return el;
	
	})));


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enSG = moment.defineLocale('en-SG', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enSG;
	
	})));


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enAu = moment.defineLocale('en-au', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enAu;
	
	})));


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enCa = moment.defineLocale('en-ca', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'YYYY-MM-DD',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY h:mm A',
	            LLLL : 'dddd, MMMM D, YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    return enCa;
	
	})));


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enGb = moment.defineLocale('en-gb', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enGb;
	
	})));


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enIe = moment.defineLocale('en-ie', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enIe;
	
	})));


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enIl = moment.defineLocale('en-il', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    return enIl;
	
	})));


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enNz = moment.defineLocale('en-nz', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enNz;
	
	})));


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var eo = moment.defineLocale('eo', {
	        months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	        weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	        weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D[-a de] MMMM, YYYY',
	            LLL : 'D[-a de] MMMM, YYYY HH:mm',
	            LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar : {
	            sameDay : '[Hodiaŭ je] LT',
	            nextDay : '[Morgaŭ je] LT',
	            nextWeek : 'dddd [je] LT',
	            lastDay : '[Hieraŭ je] LT',
	            lastWeek : '[pasinta] dddd [je] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'post %s',
	            past : 'antaŭ %s',
	            s : 'sekundoj',
	            ss : '%d sekundoj',
	            m : 'minuto',
	            mm : '%d minutoj',
	            h : 'horo',
	            hh : '%d horoj',
	            d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	            dd : '%d tagoj',
	            M : 'monato',
	            MM : '%d monatoj',
	            y : 'jaro',
	            yy : '%d jaroj'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}a/,
	        ordinal : '%da',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return eo;
	
	})));


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esDo = moment.defineLocale('es-do', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return esDo;
	
	})));


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esUs = moment.defineLocale('es-us', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'MM/DD/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return esUs;
	
	})));


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var es = moment.defineLocale('es', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex : monthsRegex,
	        monthsShortRegex : monthsRegex,
	        monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return es;
	
	})));


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            'ss': [number + 'sekundi', number + 'sekundit'],
	            'm' : ['ühe minuti', 'üks minut'],
	            'mm': [number + ' minuti', number + ' minutit'],
	            'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	            'hh': [number + ' tunni', number + ' tundi'],
	            'd' : ['ühe päeva', 'üks päev'],
	            'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	            'MM': [number + ' kuu', number + ' kuud'],
	            'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	            'yy': [number + ' aasta', number + ' aastat']
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	        monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	        weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	        weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat : {
	            LT   : 'H:mm',
	            LTS : 'H:mm:ss',
	            L    : 'DD.MM.YYYY',
	            LL   : 'D. MMMM YYYY',
	            LLL  : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[Täna,] LT',
	            nextDay  : '[Homme,] LT',
	            nextWeek : '[Järgmine] dddd LT',
	            lastDay  : '[Eile,] LT',
	            lastWeek : '[Eelmine] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s pärast',
	            past   : '%s tagasi',
	            s      : processRelativeTime,
	            ss     : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : '%d päeva',
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return et;
	
	})));


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var eu = moment.defineLocale('eu', {
	        months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	        monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	        weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY[ko] MMMM[ren] D[a]',
	            LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l : 'YYYY-M-D',
	            ll : 'YYYY[ko] MMM D[a]',
	            lll : 'YYYY[ko] MMM D[a] HH:mm',
	            llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	        },
	        calendar : {
	            sameDay : '[gaur] LT[etan]',
	            nextDay : '[bihar] LT[etan]',
	            nextWeek : 'dddd LT[etan]',
	            lastDay : '[atzo] LT[etan]',
	            lastWeek : '[aurreko] dddd LT[etan]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s barru',
	            past : 'duela %s',
	            s : 'segundo batzuk',
	            ss : '%d segundo',
	            m : 'minutu bat',
	            mm : '%d minutu',
	            h : 'ordu bat',
	            hh : '%d ordu',
	            d : 'egun bat',
	            dd : '%d egun',
	            M : 'hilabete bat',
	            MM : '%d hilabete',
	            y : 'urte bat',
	            yy : '%d urte'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return eu;
	
	})));


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '۱',
	        '2': '۲',
	        '3': '۳',
	        '4': '۴',
	        '5': '۵',
	        '6': '۶',
	        '7': '۷',
	        '8': '۸',
	        '9': '۹',
	        '0': '۰'
	    }, numberMap = {
	        '۱': '1',
	        '۲': '2',
	        '۳': '3',
	        '۴': '4',
	        '۵': '5',
	        '۶': '6',
	        '۷': '7',
	        '۸': '8',
	        '۹': '9',
	        '۰': '0'
	    };
	
	    var fa = moment.defineLocale('fa', {
	        months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar : {
	            sameDay : '[امروز ساعت] LT',
	            nextDay : '[فردا ساعت] LT',
	            nextWeek : 'dddd [ساعت] LT',
	            lastDay : '[دیروز ساعت] LT',
	            lastWeek : 'dddd [پیش] [ساعت] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'در %s',
	            past : '%s پیش',
	            s : 'چند ثانیه',
	            ss : 'ثانیه d%',
	            m : 'یک دقیقه',
	            mm : '%d دقیقه',
	            h : 'یک ساعت',
	            hh : '%d ساعت',
	            d : 'یک روز',
	            dd : '%d روز',
	            M : 'یک ماه',
	            MM : '%d ماه',
	            y : 'یک سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/[۰-۹]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}م/,
	        ordinal : '%dم',
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12 // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return fa;
	
	})));


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
	        numbersFuture = [
	            'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	            numbersPast[7], numbersPast[8], numbersPast[9]
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'ss':
	                return isFuture ? 'sekunnin' : 'sekuntia';
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	        monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	        weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	        weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'Do MMMM[ta] YYYY',
	            LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l : 'D.M.YYYY',
	            ll : 'Do MMM YYYY',
	            lll : 'Do MMM YYYY, [klo] HH.mm',
	            llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	        },
	        calendar : {
	            sameDay : '[tänään] [klo] LT',
	            nextDay : '[huomenna] [klo] LT',
	            nextWeek : 'dddd [klo] LT',
	            lastDay : '[eilen] [klo] LT',
	            lastWeek : '[viime] dddd[na] [klo] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s päästä',
	            past : '%s sitten',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fi;
	
	})));


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var fo = moment.defineLocale('fo', {
	        months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	        weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D. MMMM, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Í dag kl.] LT',
	            nextDay : '[Í morgin kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[Í gjár kl.] LT',
	            lastWeek : '[síðstu] dddd [kl] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'um %s',
	            past : '%s síðani',
	            s : 'fá sekund',
	            ss : '%d sekundir',
	            m : 'ein minuttur',
	            mm : '%d minuttir',
	            h : 'ein tími',
	            hh : '%d tímar',
	            d : 'ein dagur',
	            dd : '%d dagar',
	            M : 'ein mánaður',
	            MM : '%d mánaðir',
	            y : 'eitt ár',
	            yy : '%d ár'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fo;
	
	})));


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var frCa = moment.defineLocale('fr-ca', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        }
	    });
	
	    return frCa;
	
	})));


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var frCh = moment.defineLocale('fr-ch', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return frCh;
	
	})));


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var fr = moment.defineLocale('fr', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fr;
	
	})));


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	    var fy = moment.defineLocale('fy', {
	        months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact : true,
	        weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	        weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'oer %s',
	            past : '%s lyn',
	            s : 'in pear sekonden',
	            ss : '%d sekonden',
	            m : 'ien minút',
	            mm : '%d minuten',
	            h : 'ien oere',
	            hh : '%d oeren',
	            d : 'ien dei',
	            dd : '%d dagen',
	            M : 'ien moanne',
	            MM : '%d moannen',
	            y : 'ien jier',
	            yy : '%d jierren'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fy;
	
	})));


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	    var months = [
	        'Eanáir', 'Feabhra', 'Márta', 'Aibreán', 'Bealtaine', 'Méitheamh', 'Iúil', 'Lúnasa', 'Meán Fómhair', 'Deaireadh Fómhair', 'Samhain', 'Nollaig'
	    ];
	
	    var monthsShort = ['Eaná', 'Feab', 'Márt', 'Aibr', 'Beal', 'Méit', 'Iúil', 'Lúna', 'Meán', 'Deai', 'Samh', 'Noll'];
	
	    var weekdays = ['Dé Domhnaigh', 'Dé Luain', 'Dé Máirt', 'Dé Céadaoin', 'Déardaoin', 'Dé hAoine', 'Dé Satharn'];
	
	    var weekdaysShort = ['Dom', 'Lua', 'Mái', 'Céa', 'Déa', 'hAo', 'Sat'];
	
	    var weekdaysMin = ['Do', 'Lu', 'Má', 'Ce', 'Dé', 'hA', 'Sa'];
	
	    var ga = moment.defineLocale('ga', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Inniu ag] LT',
	            nextDay: '[Amárach ag] LT',
	            nextWeek: 'dddd [ag] LT',
	            lastDay: '[Inné aig] LT',
	            lastWeek: 'dddd [seo caite] [ag] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'i %s',
	            past: '%s ó shin',
	            s: 'cúpla soicind',
	            ss: '%d soicind',
	            m: 'nóiméad',
	            mm: '%d nóiméad',
	            h: 'uair an chloig',
	            hh: '%d uair an chloig',
	            d: 'lá',
	            dd: '%d lá',
	            M: 'mí',
	            MM: '%d mí',
	            y: 'bliain',
	            yy: '%d bliain'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ga;
	
	})));


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	    ];
	
	    var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	    var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	    var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	    var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsParseExact : true,
	        weekdays : weekdays,
	        weekdaysShort : weekdaysShort,
	        weekdaysMin : weekdaysMin,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[An-diugh aig] LT',
	            nextDay : '[A-màireach aig] LT',
	            nextWeek : 'dddd [aig] LT',
	            lastDay : '[An-dè aig] LT',
	            lastWeek : 'dddd [seo chaidh] [aig] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ann an %s',
	            past : 'bho chionn %s',
	            s : 'beagan diogan',
	            ss : '%d diogan',
	            m : 'mionaid',
	            mm : '%d mionaidean',
	            h : 'uair',
	            hh : '%d uairean',
	            d : 'latha',
	            dd : '%d latha',
	            M : 'mìos',
	            MM : '%d mìosan',
	            y : 'bliadhna',
	            yy : '%d bliadhna'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
	        ordinal : function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return gd;
	
	})));


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var gl = moment.defineLocale('gl', {
	        months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	        monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            lastDay : function () {
	                return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	            },
	            lastWeek : function () {
	                return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past : 'hai %s',
	            s : 'uns segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'unha hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return gl;
	
	})));


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['thodde secondanim', 'thodde second'],
	            'ss': [number + ' secondanim', number + ' second'],
	            'm': ['eka mintan', 'ek minute'],
	            'mm': [number + ' mintanim', number + ' mintam'],
	            'h': ['eka voran', 'ek vor'],
	            'hh': [number + ' voranim', number + ' voram'],
	            'd': ['eka disan', 'ek dis'],
	            'dd': [number + ' disanim', number + ' dis'],
	            'M': ['eka mhoinean', 'ek mhoino'],
	            'MM': [number + ' mhoineanim', number + ' mhoine'],
	            'y': ['eka vorsan', 'ek voros'],
	            'yy': [number + ' vorsanim', number + ' vorsam']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var gomLatn = moment.defineLocale('gom-latn', {
	        months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
	        monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
	        weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	        weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'A h:mm [vazta]',
	            LTS : 'A h:mm:ss [vazta]',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY A h:mm [vazta]',
	            LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
	            llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
	        },
	        calendar : {
	            sameDay: '[Aiz] LT',
	            nextDay: '[Faleam] LT',
	            nextWeek: '[Ieta to] dddd[,] LT',
	            lastDay: '[Kal] LT',
	            lastWeek: '[Fatlo] dddd[,] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s',
	            past : '%s adim',
	            s : processRelativeTime,
	            ss : processRelativeTime,
	            m : processRelativeTime,
	            mm : processRelativeTime,
	            h : processRelativeTime,
	            hh : processRelativeTime,
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(er)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // the ordinal 'er' only applies to day of the month
	                case 'D':
	                    return number + 'er';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /rati|sokalli|donparam|sanje/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'rati') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'sokalli') {
	                return hour;
	            } else if (meridiem === 'donparam') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'sanje') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'rati';
	            } else if (hour < 12) {
	                return 'sokalli';
	            } else if (hour < 16) {
	                return 'donparam';
	            } else if (hour < 20) {
	                return 'sanje';
	            } else {
	                return 'rati';
	            }
	        }
	    });
	
	    return gomLatn;
	
	})));


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	            '1': '૧',
	            '2': '૨',
	            '3': '૩',
	            '4': '૪',
	            '5': '૫',
	            '6': '૬',
	            '7': '૭',
	            '8': '૮',
	            '9': '૯',
	            '0': '૦'
	        },
	        numberMap = {
	            '૧': '1',
	            '૨': '2',
	            '૩': '3',
	            '૪': '4',
	            '૫': '5',
	            '૬': '6',
	            '૭': '7',
	            '૮': '8',
	            '૯': '9',
	            '૦': '0'
	        };
	
	    var gu = moment.defineLocale('gu', {
	        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
	        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
	        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm વાગ્યે',
	            LTS: 'A h:mm:ss વાગ્યે',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
	        },
	        calendar: {
	            sameDay: '[આજ] LT',
	            nextDay: '[કાલે] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ગઇકાલે] LT',
	            lastWeek: '[પાછલા] dddd, LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s મા',
	            past: '%s પેહલા',
	            s: 'અમુક પળો',
	            ss: '%d સેકંડ',
	            m: 'એક મિનિટ',
	            mm: '%d મિનિટ',
	            h: 'એક કલાક',
	            hh: '%d કલાક',
	            d: 'એક દિવસ',
	            dd: '%d દિવસ',
	            M: 'એક મહિનો',
	            MM: '%d મહિનો',
	            y: 'એક વર્ષ',
	            yy: '%d વર્ષ'
	        },
	        preparse: function (string) {
	            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'રાત') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'સવાર') {
	                return hour;
	            } else if (meridiem === 'બપોર') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'સાંજ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'રાત';
	            } else if (hour < 10) {
	                return 'સવાર';
	            } else if (hour < 17) {
	                return 'બપોર';
	            } else if (hour < 20) {
	                return 'સાંજ';
	            } else {
	                return 'રાત';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6 // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return gu;
	
	})));


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var he = moment.defineLocale('he', {
	        months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	        monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	        weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [ב]MMMM YYYY',
	            LLL : 'D [ב]MMMM YYYY HH:mm',
	            LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	            l : 'D/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[היום ב־]LT',
	            nextDay : '[מחר ב־]LT',
	            nextWeek : 'dddd [בשעה] LT',
	            lastDay : '[אתמול ב־]LT',
	            lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'בעוד %s',
	            past : 'לפני %s',
	            s : 'מספר שניות',
	            ss : '%d שניות',
	            m : 'דקה',
	            mm : '%d דקות',
	            h : 'שעה',
	            hh : function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d : 'יום',
	            dd : function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M : 'חודש',
	            MM : function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y : 'שנה',
	            yy : function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            }
	        },
	        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM : function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        }
	    });
	
	    return he;
	
	})));


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var hi = moment.defineLocale('hi', {
	        months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	        monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm बजे',
	            LTS : 'A h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[कल] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[कल] LT',
	            lastWeek : '[पिछले] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s में',
	            past : '%s पहले',
	            s : 'कुछ ही क्षण',
	            ss : '%d सेकंड',
	            m : 'एक मिनट',
	            mm : '%d मिनट',
	            h : 'एक घंटा',
	            hh : '%d घंटे',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महीने',
	            MM : '%d महीने',
	            y : 'एक वर्ष',
	            yy : '%d वर्ष'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return hi;
	
	})));


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months : {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	        },
	        monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            ss     : translate,
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return hr;
	
	})));


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number;
	        switch (key) {
	            case 's':
	                return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	            case 'ss':
	                return num + (isFuture || withoutSuffix) ? ' másodperc' : ' másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	        monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	        weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY. MMMM D.',
	            LLL : 'YYYY. MMMM D. H:mm',
	            LLLL : 'YYYY. MMMM D., dddd H:mm'
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar : {
	            sameDay : '[ma] LT[-kor]',
	            nextDay : '[holnap] LT[-kor]',
	            nextWeek : function () {
	                return week.call(this, true);
	            },
	            lastDay : '[tegnap] LT[-kor]',
	            lastWeek : function () {
	                return week.call(this, false);
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s múlva',
	            past : '%s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return hu;
	
	})));


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var hyAm = moment.defineLocale('hy-am', {
	        months : {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	        },
	        monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	        weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY թ.',
	            LLL : 'D MMMM YYYY թ., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	        },
	        calendar : {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s հետո',
	            past : '%s առաջ',
	            s : 'մի քանի վայրկյան',
	            ss : '%d վայրկյան',
	            m : 'րոպե',
	            mm : '%d րոպե',
	            h : 'ժամ',
	            hh : '%d ժամ',
	            d : 'օր',
	            dd : '%d օր',
	            M : 'ամիս',
	            MM : '%d ամիս',
	            y : 'տարի',
	            yy : '%d տարի'
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem : function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return hyAm;
	
	})));


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var id = moment.defineLocale('id', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Besok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kemarin pukul] LT',
	            lastWeek : 'dddd [lalu pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lalu',
	            s : 'beberapa detik',
	            ss : '%d detik',
	            m : 'semenit',
	            mm : '%d menit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return id;
	
	})));


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	            case 'ss':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum');
	                }
	                return result + 'sekúnda';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	        weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	        },
	        calendar : {
	            sameDay : '[í dag kl.] LT',
	            nextDay : '[á morgun kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[í gær kl.] LT',
	            lastWeek : '[síðasta] dddd [kl.] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'eftir %s',
	            past : 'fyrir %s síðan',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : 'klukkustund',
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return is;
	
	})));


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var itCh = moment.defineLocale('it-ch', {
	        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past : '%s fa',
	            s : 'alcuni secondi',
	            ss : '%d secondi',
	            m : 'un minuto',
	            mm : '%d minuti',
	            h : 'un\'ora',
	            hh : '%d ore',
	            d : 'un giorno',
	            dd : '%d giorni',
	            M : 'un mese',
	            MM : '%d mesi',
	            y : 'un anno',
	            yy : '%d anni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return itCh;
	
	})));


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var it = moment.defineLocale('it', {
	        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past : '%s fa',
	            s : 'alcuni secondi',
	            ss : '%d secondi',
	            m : 'un minuto',
	            mm : '%d minuti',
	            h : 'un\'ora',
	            hh : '%d ore',
	            d : 'un giorno',
	            dd : '%d giorni',
	            M : 'un mese',
	            MM : '%d mesi',
	            y : 'un anno',
	            yy : '%d anni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return it;
	
	})));


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ja = moment.defineLocale('ja', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日 dddd HH:mm',
	            l : 'YYYY/MM/DD',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日(ddd) HH:mm'
	        },
	        meridiemParse: /午前|午後/i,
	        isPM : function (input) {
	            return input === '午後';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar : {
	            sameDay : '[今日] LT',
	            nextDay : '[明日] LT',
	            nextWeek : function (now) {
	                if (now.week() < this.week()) {
	                    return '[来週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            lastDay : '[昨日] LT',
	            lastWeek : function (now) {
	                if (this.week() < now.week()) {
	                    return '[先週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}日/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s後',
	            past : '%s前',
	            s : '数秒',
	            ss : '%d秒',
	            m : '1分',
	            mm : '%d分',
	            h : '1時間',
	            hh : '%d時間',
	            d : '1日',
	            dd : '%d日',
	            M : '1ヶ月',
	            MM : '%dヶ月',
	            y : '1年',
	            yy : '%d年'
	        }
	    });
	
	    return ja;
	
	})));


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var jv = moment.defineLocale('jv', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar : {
	            sameDay : '[Dinten puniko pukul] LT',
	            nextDay : '[Mbenjang pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kala wingi pukul] LT',
	            lastWeek : 'dddd [kepengker pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'wonten ing %s',
	            past : '%s ingkang kepengker',
	            s : 'sawetawis detik',
	            ss : '%d detik',
	            m : 'setunggal menit',
	            mm : '%d menit',
	            h : 'setunggal jam',
	            hh : '%d jam',
	            d : 'sedinten',
	            dd : '%d dinten',
	            M : 'sewulan',
	            MM : '%d wulan',
	            y : 'setaun',
	            yy : '%d taun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return jv;
	
	})));


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ka = moment.defineLocale('ka', {
	        months : {
	            standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	            format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	        },
	        monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays : {
	            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	            isFormat: /(წინა|შემდეგ)/
	        },
	        weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[დღეს] LT[-ზე]',
	            nextDay : '[ხვალ] LT[-ზე]',
	            lastDay : '[გუშინ] LT[-ზე]',
	            nextWeek : '[შემდეგ] dddd LT[-ზე]',
	            lastWeek : '[წინა] dddd LT-ზე',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                    s.replace(/ი$/, 'ში') :
	                    s + 'ში';
	            },
	            past : function (s) {
	                if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if ((/წელი/).test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	            },
	            s : 'რამდენიმე წამი',
	            ss : '%d წამი',
	            m : 'წუთი',
	            mm : '%d წუთი',
	            h : 'საათი',
	            hh : '%d საათი',
	            d : 'დღე',
	            dd : '%d დღე',
	            M : 'თვე',
	            MM : '%d თვე',
	            y : 'წელი',
	            yy : '%d წელი'
	        },
	        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal : function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week : {
	            dow : 1,
	            doy : 7
	        }
	    });
	
	    return ka;
	
	})));


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші'
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	        monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	        weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгін сағат] LT',
	            nextDay : '[Ертең сағат] LT',
	            nextWeek : 'dddd [сағат] LT',
	            lastDay : '[Кеше сағат] LT',
	            lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ішінде',
	            past : '%s бұрын',
	            s : 'бірнеше секунд',
	            ss : '%d секунд',
	            m : 'бір минут',
	            mm : '%d минут',
	            h : 'бір сағат',
	            hh : '%d сағат',
	            d : 'бір күн',
	            dd : '%d күн',
	            M : 'бір ай',
	            MM : '%d ай',
	            y : 'бір жыл',
	            yy : '%d жыл'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return kk;
	
	})));


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '១',
	        '2': '២',
	        '3': '៣',
	        '4': '៤',
	        '5': '៥',
	        '6': '៦',
	        '7': '៧',
	        '8': '៨',
	        '9': '៩',
	        '0': '០'
	    }, numberMap = {
	        '១': '1',
	        '២': '2',
	        '៣': '3',
	        '៤': '4',
	        '៥': '5',
	        '៦': '6',
	        '៧': '7',
	        '៨': '8',
	        '៩': '9',
	        '០': '0'
	    };
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ព្រឹក|ល្ងាច/,
	        isPM: function (input) {
	            return input === 'ល្ងាច';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ព្រឹក';
	            } else {
	                return 'ល្ងាច';
	            }
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            ss: '%d វិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ'
	        },
	        dayOfMonthOrdinalParse : /ទី\d{1,2}/,
	        ordinal : 'ទី%d',
	        preparse: function (string) {
	            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return km;
	
	})));


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '೧',
	        '2': '೨',
	        '3': '೩',
	        '4': '೪',
	        '5': '೫',
	        '6': '೬',
	        '7': '೭',
	        '8': '೮',
	        '9': '೯',
	        '0': '೦'
	    },
	    numberMap = {
	        '೧': '1',
	        '೨': '2',
	        '೩': '3',
	        '೪': '4',
	        '೫': '5',
	        '೬': '6',
	        '೭': '7',
	        '೮': '8',
	        '೯': '9',
	        '೦': '0'
	    };
	
	    var kn = moment.defineLocale('kn', {
	        months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
	        monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
	        weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	        weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[ಇಂದು] LT',
	            nextDay : '[ನಾಳೆ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ನಿನ್ನೆ] LT',
	            lastWeek : '[ಕೊನೆಯ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ನಂತರ',
	            past : '%s ಹಿಂದೆ',
	            s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
	            ss : '%d ಸೆಕೆಂಡುಗಳು',
	            m : 'ಒಂದು ನಿಮಿಷ',
	            mm : '%d ನಿಮಿಷ',
	            h : 'ಒಂದು ಗಂಟೆ',
	            hh : '%d ಗಂಟೆ',
	            d : 'ಒಂದು ದಿನ',
	            dd : '%d ದಿನ',
	            M : 'ಒಂದು ತಿಂಗಳು',
	            MM : '%d ತಿಂಗಳು',
	            y : 'ಒಂದು ವರ್ಷ',
	            yy : '%d ವರ್ಷ'
	        },
	        preparse: function (string) {
	            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ರಾತ್ರಿ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	                return hour;
	            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ಸಂಜೆ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ರಾತ್ರಿ';
	            } else if (hour < 10) {
	                return 'ಬೆಳಿಗ್ಗೆ';
	            } else if (hour < 17) {
	                return 'ಮಧ್ಯಾಹ್ನ';
	            } else if (hour < 20) {
	                return 'ಸಂಜೆ';
	            } else {
	                return 'ರಾತ್ರಿ';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	        ordinal : function (number) {
	            return number + 'ನೇ';
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return kn;
	
	})));


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ko = moment.defineLocale('ko', {
	        months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY년 MMMM D일',
	            LLL : 'YYYY년 MMMM D일 A h:mm',
	            LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
	            l : 'YYYY.MM.DD.',
	            ll : 'YYYY년 MMMM D일',
	            lll : 'YYYY년 MMMM D일 A h:mm',
	            llll : 'YYYY년 MMMM D일 dddd A h:mm'
	        },
	        calendar : {
	            sameDay : '오늘 LT',
	            nextDay : '내일 LT',
	            nextWeek : 'dddd LT',
	            lastDay : '어제 LT',
	            lastWeek : '지난주 dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s 후',
	            past : '%s 전',
	            s : '몇 초',
	            ss : '%d초',
	            m : '1분',
	            mm : '%d분',
	            h : '한 시간',
	            hh : '%d시간',
	            d : '하루',
	            dd : '%d일',
	            M : '한 달',
	            MM : '%d달',
	            y : '일 년',
	            yy : '%d년'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '일';
	                case 'M':
	                    return number + '월';
	                case 'w':
	                case 'W':
	                    return number + '주';
	                default:
	                    return number;
	            }
	        },
	        meridiemParse : /오전|오후/,
	        isPM : function (token) {
	            return token === '오후';
	        },
	        meridiem : function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        }
	    });
	
	    return ko;
	
	})));


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    },
	    months = [
	        'کانونی دووەم',
	        'شوبات',
	        'ئازار',
	        'نیسان',
	        'ئایار',
	        'حوزەیران',
	        'تەمموز',
	        'ئاب',
	        'ئەیلوول',
	        'تشرینی یەكەم',
	        'تشرینی دووەم',
	        'كانونی یەکەم'
	    ];
	
	
	    var ku = moment.defineLocale('ku', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split('_'),
	        weekdaysShort : 'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
	        weekdaysMin : 'ی_د_س_چ_پ_ه_ش'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ئێواره‌|به‌یانی/,
	        isPM: function (input) {
	            return /ئێواره‌/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'به‌یانی';
	            } else {
	                return 'ئێواره‌';
	            }
	        },
	        calendar : {
	            sameDay : '[ئه‌مرۆ كاتژمێر] LT',
	            nextDay : '[به‌یانی كاتژمێر] LT',
	            nextWeek : 'dddd [كاتژمێر] LT',
	            lastDay : '[دوێنێ كاتژمێر] LT',
	            lastWeek : 'dddd [كاتژمێر] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'له‌ %s',
	            past : '%s',
	            s : 'چه‌ند چركه‌یه‌ك',
	            ss : 'چركه‌ %d',
	            m : 'یه‌ك خوله‌ك',
	            mm : '%d خوله‌ك',
	            h : 'یه‌ك كاتژمێر',
	            hh : '%d كاتژمێر',
	            d : 'یه‌ك ڕۆژ',
	            dd : '%d ڕۆژ',
	            M : 'یه‌ك مانگ',
	            MM : '%d مانگ',
	            y : 'یه‌ك ساڵ',
	            yy : '%d ساڵ'
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12 // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return ku;
	
	})));


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү'
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	        monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	        weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгүн саат] LT',
	            nextDay : '[Эртең саат] LT',
	            nextWeek : 'dddd [саат] LT',
	            lastDay : '[Кечээ саат] LT',
	            lastWeek : '[Өткөн аптанын] dddd [күнү] [саат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ичинде',
	            past : '%s мурун',
	            s : 'бирнече секунд',
	            ss : '%d секунд',
	            m : 'бир мүнөт',
	            mm : '%d мүнөт',
	            h : 'бир саат',
	            hh : '%d саат',
	            d : 'бир күн',
	            dd : '%d күн',
	            M : 'бир ай',
	            MM : '%d ай',
	            y : 'бир жыл',
	            yy : '%d жыл'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return ky;
	
	})));


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eng Minutt', 'enger Minutt'],
	            'h': ['eng Stonn', 'enger Stonn'],
	            'd': ['een Dag', 'engem Dag'],
	            'M': ['ee Mount', 'engem Mount'],
	            'y': ['ee Joer', 'engem Joer']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10, firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            }
	        },
	        relativeTime : {
	            future : processFutureTime,
	            past : processPastTime,
	            s : 'e puer Sekonnen',
	            ss : '%d Sekonnen',
	            m : processRelativeTime,
	            mm : '%d Minutten',
	            h : processRelativeTime,
	            hh : '%d Stonnen',
	            d : processRelativeTime,
	            dd : '%d Deeg',
	            M : processRelativeTime,
	            MM : '%d Méint',
	            y : processRelativeTime,
	            yy : '%d Joer'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lb;
	
	})));


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var lo = moment.defineLocale('lo', {
	        months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar : {
	            sameDay : '[ມື້ນີ້ເວລາ] LT',
	            nextDay : '[ມື້ອື່ນເວລາ] LT',
	            nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ອີກ %s',
	            past : '%sຜ່ານມາ',
	            s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	            ss : '%d ວິນາທີ' ,
	            m : '1 ນາທີ',
	            mm : '%d ນາທີ',
	            h : '1 ຊົ່ວໂມງ',
	            hh : '%d ຊົ່ວໂມງ',
	            d : '1 ມື້',
	            dd : '%d ມື້',
	            M : '1 ເດືອນ',
	            MM : '%d ເດືອນ',
	            y : '1 ປີ',
	            yy : '%d ປີ'
	        },
	        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	        ordinal : function (number) {
	            return 'ທີ່' + number;
	        }
	    });
	
	    return lo;
	
	})));


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var units = {
	        'ss' : 'sekundė_sekundžių_sekundes',
	        'm' : 'minutė_minutės_minutę',
	        'mm': 'minutės_minučių_minutes',
	        'h' : 'valanda_valandos_valandą',
	        'hh': 'valandos_valandų_valandas',
	        'd' : 'diena_dienos_dieną',
	        'dd': 'dienos_dienų_dienas',
	        'M' : 'mėnuo_mėnesio_mėnesį',
	        'MM': 'mėnesiai_mėnesių_mėnesius',
	        'y' : 'metai_metų_metus',
	        'yy': 'metai_metų_metus'
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months : {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
	        },
	        monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays : {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	            isFormat: /dddd HH:mm/
	        },
	        weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY [m.] MMMM D [d.]',
	            LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l : 'YYYY-MM-DD',
	            ll : 'YYYY [m.] MMMM D [d.]',
	            lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	        },
	        calendar : {
	            sameDay : '[Šiandien] LT',
	            nextDay : '[Rytoj] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[Vakar] LT',
	            lastWeek : '[Praėjusį] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'po %s',
	            past : 'prieš %s',
	            s : translateSeconds,
	            ss : translate,
	            m : translateSingular,
	            mm : translate,
	            h : translateSingular,
	            hh : translate,
	            d : translateSingular,
	            dd : translate,
	            M : translateSingular,
	            MM : translate,
	            y : translateSingular,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	        ordinal : function (number) {
	            return number + '-oji';
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lt;
	
	})));


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var units = {
	        'ss': 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	        'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'h': 'stundas_stundām_stunda_stundas'.split('_'),
	        'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	        'd': 'dienas_dienām_diena_dienas'.split('_'),
	        'dd': 'dienas_dienām_diena_dienas'.split('_'),
	        'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'y': 'gada_gadiem_gads_gadi'.split('_'),
	        'yy': 'gada_gadiem_gads_gadi'.split('_')
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	        weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY.',
	            LL : 'YYYY. [gada] D. MMMM',
	            LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	        },
	        calendar : {
	            sameDay : '[Šodien pulksten] LT',
	            nextDay : '[Rīt pulksten] LT',
	            nextWeek : 'dddd [pulksten] LT',
	            lastDay : '[Vakar pulksten] LT',
	            lastWeek : '[Pagājušā] dddd [pulksten] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'pēc %s',
	            past : 'pirms %s',
	            s : relativeSeconds,
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithSingular,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithSingular,
	            hh : relativeTimeWithPlural,
	            d : relativeTimeWithSingular,
	            dd : relativeTimeWithPlural,
	            M : relativeTimeWithSingular,
	            MM : relativeTimeWithPlural,
	            y : relativeTimeWithSingular,
	            yy : relativeTimeWithPlural
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lv;
	
	})));


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['sekund', 'sekunda', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'nekoliko sekundi',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mjesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return me;
	
	})));


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mi = moment.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            ss: '%d hēkona',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return mi;
	
	})));


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mk = moment.defineLocale('mk', {
	        months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Денес во] LT',
	            nextDay : '[Утре во] LT',
	            nextWeek : '[Во] dddd [во] LT',
	            lastDay : '[Вчера во] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'после %s',
	            past : 'пред %s',
	            s : 'неколку секунди',
	            ss : '%d секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дена',
	            M : 'месец',
	            MM : '%d месеци',
	            y : 'година',
	            yy : '%d години'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return mk;
	
	})));


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ml = moment.defineLocale('ml', {
	        months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	        monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	        weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm -നു',
	            LTS : 'A h:mm:ss -നു',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm -നു',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	        },
	        calendar : {
	            sameDay : '[ഇന്ന്] LT',
	            nextDay : '[നാളെ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ഇന്നലെ] LT',
	            lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s കഴിഞ്ഞ്',
	            past : '%s മുൻപ്',
	            s : 'അൽപ നിമിഷങ്ങൾ',
	            ss : '%d സെക്കൻഡ്',
	            m : 'ഒരു മിനിറ്റ്',
	            mm : '%d മിനിറ്റ്',
	            h : 'ഒരു മണിക്കൂർ',
	            hh : '%d മണിക്കൂർ',
	            d : 'ഒരു ദിവസം',
	            dd : '%d ദിവസം',
	            M : 'ഒരു മാസം',
	            MM : '%d മാസം',
	            y : 'ഒരു വർഷം',
	            yy : '%d വർഷം'
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                    meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                    meridiem === 'വൈകുന്നേരം') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        }
	    });
	
	    return ml;
	
	})));


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 's':
	                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
	            case 'ss':
	                return number + (withoutSuffix ? ' секунд' : ' секундын');
	            case 'm':
	            case 'mm':
	                return number + (withoutSuffix ? ' минут' : ' минутын');
	            case 'h':
	            case 'hh':
	                return number + (withoutSuffix ? ' цаг' : ' цагийн');
	            case 'd':
	            case 'dd':
	                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
	            case 'M':
	            case 'MM':
	                return number + (withoutSuffix ? ' сар' : ' сарын');
	            case 'y':
	            case 'yy':
	                return number + (withoutSuffix ? ' жил' : ' жилийн');
	            default:
	                return number;
	        }
	    }
	
	    var mn = moment.defineLocale('mn', {
	        months : 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split('_'),
	        monthsShort : '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
	        weekdaysShort : 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
	        weekdaysMin : 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY оны MMMMын D',
	            LLL : 'YYYY оны MMMMын D HH:mm',
	            LLLL : 'dddd, YYYY оны MMMMын D HH:mm'
	        },
	        meridiemParse: /ҮӨ|ҮХ/i,
	        isPM : function (input) {
	            return input === 'ҮХ';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ҮӨ';
	            } else {
	                return 'ҮХ';
	            }
	        },
	        calendar : {
	            sameDay : '[Өнөөдөр] LT',
	            nextDay : '[Маргааш] LT',
	            nextWeek : '[Ирэх] dddd LT',
	            lastDay : '[Өчигдөр] LT',
	            lastWeek : '[Өнгөрсөн] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s дараа',
	            past : '%s өмнө',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + ' өдөр';
	                default:
	                    return number;
	            }
	        }
	    });
	
	    return mn;
	
	})));


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture)
	    {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's': output = 'काही सेकंद'; break;
	                case 'ss': output = '%d सेकंद'; break;
	                case 'm': output = 'एक मिनिट'; break;
	                case 'mm': output = '%d मिनिटे'; break;
	                case 'h': output = 'एक तास'; break;
	                case 'hh': output = '%d तास'; break;
	                case 'd': output = 'एक दिवस'; break;
	                case 'dd': output = '%d दिवस'; break;
	                case 'M': output = 'एक महिना'; break;
	                case 'MM': output = '%d महिने'; break;
	                case 'y': output = 'एक वर्ष'; break;
	                case 'yy': output = '%d वर्षे'; break;
	            }
	        }
	        else {
	            switch (string) {
	                case 's': output = 'काही सेकंदां'; break;
	                case 'ss': output = '%d सेकंदां'; break;
	                case 'm': output = 'एका मिनिटा'; break;
	                case 'mm': output = '%d मिनिटां'; break;
	                case 'h': output = 'एका तासा'; break;
	                case 'hh': output = '%d तासां'; break;
	                case 'd': output = 'एका दिवसा'; break;
	                case 'dd': output = '%d दिवसां'; break;
	                case 'M': output = 'एका महिन्या'; break;
	                case 'MM': output = '%d महिन्यां'; break;
	                case 'y': output = 'एका वर्षा'; break;
	                case 'yy': output = '%d वर्षां'; break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm वाजता',
	            LTS : 'A h:mm:ss वाजता',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm वाजता',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[उद्या] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            ss: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात्री') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळी') {
	                return hour;
	            } else if (meridiem === 'दुपारी') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'सायंकाळी') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात्री';
	            } else if (hour < 10) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return mr;
	
	})));


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var msMy = moment.defineLocale('ms-my', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            ss : '%d saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return msMy;
	
	})));


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ms = moment.defineLocale('ms', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            ss : '%d saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return ms;
	
	})));


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mt = moment.defineLocale('mt', {
	        months : 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split('_'),
	        monthsShort : 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	        weekdays : 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split('_'),
	        weekdaysShort : 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	        weekdaysMin : 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Illum fil-]LT',
	            nextDay : '[Għada fil-]LT',
	            nextWeek : 'dddd [fil-]LT',
	            lastDay : '[Il-bieraħ fil-]LT',
	            lastWeek : 'dddd [li għadda] [fil-]LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'f’ %s',
	            past : '%s ilu',
	            s : 'ftit sekondi',
	            ss : '%d sekondi',
	            m : 'minuta',
	            mm : '%d minuti',
	            h : 'siegħa',
	            hh : '%d siegħat',
	            d : 'ġurnata',
	            dd : '%d ġranet',
	            M : 'xahar',
	            MM : '%d xhur',
	            y : 'sena',
	            yy : '%d sni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return mt;
	
	})));


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '၁',
	        '2': '၂',
	        '3': '၃',
	        '4': '၄',
	        '5': '၅',
	        '6': '၆',
	        '7': '၇',
	        '8': '၈',
	        '9': '၉',
	        '0': '၀'
	    }, numberMap = {
	        '၁': '1',
	        '၂': '2',
	        '၃': '3',
	        '၄': '4',
	        '၅': '5',
	        '၆': '6',
	        '၇': '7',
	        '၈': '8',
	        '၉': '9',
	        '၀': '0'
	    };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            ss : '%d စက္ကန့်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်'
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return my;
	
	})));


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var nb = moment.defineLocale('nb', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'noen sekunder',
	            ss : '%d sekunder',
	            m : 'ett minutt',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dager',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nb;
	
	})));


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var ne = moment.defineLocale('ne', {
	        months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	        monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	        weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'Aको h:mm बजे',
	            LTS : 'Aको h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[भोलि] LT',
	            nextWeek : '[आउँदो] dddd[,] LT',
	            lastDay : '[हिजो] LT',
	            lastWeek : '[गएको] dddd[,] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sमा',
	            past : '%s अगाडि',
	            s : 'केही क्षण',
	            ss : '%d सेकेण्ड',
	            m : 'एक मिनेट',
	            mm : '%d मिनेट',
	            h : 'एक घण्टा',
	            hh : '%d घण्टा',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महिना',
	            MM : '%d महिना',
	            y : 'एक बर्ष',
	            yy : '%d बर्ष'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return ne;
	
	})));


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	    var monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nlBe = moment.defineLocale('nl-be', {
	        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'over %s',
	            past : '%s geleden',
	            s : 'een paar seconden',
	            ss : '%d seconden',
	            m : 'één minuut',
	            mm : '%d minuten',
	            h : 'één uur',
	            hh : '%d uur',
	            d : 'één dag',
	            dd : '%d dagen',
	            M : 'één maand',
	            MM : '%d maanden',
	            y : 'één jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nlBe;
	
	})));


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	    var monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nl = moment.defineLocale('nl', {
	        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'over %s',
	            past : '%s geleden',
	            s : 'een paar seconden',
	            ss : '%d seconden',
	            m : 'één minuut',
	            mm : '%d minuten',
	            h : 'één uur',
	            hh : '%d uur',
	            d : 'één dag',
	            dd : '%d dagen',
	            M : 'één maand',
	            MM : '%d maanden',
	            y : 'één jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nl;
	
	})));


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var nn = moment.defineLocale('nn', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	        weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s sidan',
	            s : 'nokre sekund',
	            ss : '%d sekund',
	            m : 'eit minutt',
	            mm : '%d minutt',
	            h : 'ein time',
	            hh : '%d timar',
	            d : 'ein dag',
	            dd : '%d dagar',
	            M : 'ein månad',
	            MM : '%d månader',
	            y : 'eit år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nn;
	
	})));


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '੧',
	        '2': '੨',
	        '3': '੩',
	        '4': '੪',
	        '5': '੫',
	        '6': '੬',
	        '7': '੭',
	        '8': '੮',
	        '9': '੯',
	        '0': '੦'
	    },
	    numberMap = {
	        '੧': '1',
	        '੨': '2',
	        '੩': '3',
	        '੪': '4',
	        '੫': '5',
	        '੬': '6',
	        '੭': '7',
	        '੮': '8',
	        '੯': '9',
	        '੦': '0'
	    };
	
	    var paIn = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
	        months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	        weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm ਵਜੇ',
	            LTS : 'A h:mm:ss ਵਜੇ',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	        },
	        calendar : {
	            sameDay : '[ਅਜ] LT',
	            nextDay : '[ਕਲ] LT',
	            nextWeek : '[ਅਗਲਾ] dddd, LT',
	            lastDay : '[ਕਲ] LT',
	            lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ਵਿੱਚ',
	            past : '%s ਪਿਛਲੇ',
	            s : 'ਕੁਝ ਸਕਿੰਟ',
	            ss : '%d ਸਕਿੰਟ',
	            m : 'ਇਕ ਮਿੰਟ',
	            mm : '%d ਮਿੰਟ',
	            h : 'ਇੱਕ ਘੰਟਾ',
	            hh : '%d ਘੰਟੇ',
	            d : 'ਇੱਕ ਦਿਨ',
	            dd : '%d ਦਿਨ',
	            M : 'ਇੱਕ ਮਹੀਨਾ',
	            MM : '%d ਮਹੀਨੇ',
	            y : 'ਇੱਕ ਸਾਲ',
	            yy : '%d ਸਾਲ'
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return paIn;
	
	})));


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
	        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	    function plural(n) {
	        return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix  ? 'godzina'  : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months : function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return monthsNominative;
	            } else if (format === '') {
	                // Hack: if format empty we know this is used to generate
	                // RegExp by moment. Give then back both valid forms of months
	                // in RegExp ready format.
	                return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	        weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	        weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W niedzielę o] LT';
	
	                    case 2:
	                        return '[We wtorek o] LT';
	
	                    case 3:
	                        return '[W środę o] LT';
	
	                    case 6:
	                        return '[W sobotę o] LT';
	
	                    default:
	                        return '[W] dddd [o] LT';
	                }
	            },
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : '%s temu',
	            s : 'kilka sekund',
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : '1 dzień',
	            dd : '%d dni',
	            M : 'miesiąc',
	            MM : translate,
	            y : 'rok',
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pl;
	
	})));


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ptBr = moment.defineLocale('pt-br', {
	        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'poucos segundos',
	            ss : '%d segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal : '%dº'
	    });
	
	    return ptBr;
	
	})));


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var pt = moment.defineLocale('pt', {
	        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'segundos',
	            ss : '%d segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pt;
	
	})));


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                'ss': 'secunde',
	                'mm': 'minute',
	                'hh': 'ore',
	                'dd': 'zile',
	                'MM': 'luni',
	                'yy': 'ani'
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	        monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'peste %s',
	            past : '%s în urmă',
	            s : 'câteva secunde',
	            ss : relativeTimeWithPlural,
	            m : 'un minut',
	            mm : relativeTimeWithPlural,
	            h : 'o oră',
	            hh : relativeTimeWithPlural,
	            d : 'o zi',
	            dd : relativeTimeWithPlural,
	            M : 'o lună',
	            MM : relativeTimeWithPlural,
	            y : 'un an',
	            yy : relativeTimeWithPlural
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return ro;
	
	})));


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            'hh': 'час_часа_часов',
	            'dd': 'день_дня_дней',
	            'MM': 'месяц_месяца_месяцев',
	            'yy': 'год_года_лет'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months : {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	        },
	        monthsShort : {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	        },
	        weekdays : {
	            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	        },
	        weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соотвествует только сокращённым формам
	        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., H:mm',
	            LLLL : 'dddd, D MMMM YYYY г., H:mm'
	        },
	        calendar : {
	            sameDay: '[Сегодня, в] LT',
	            nextDay: '[Завтра, в] LT',
	            lastDay: '[Вчера, в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'через %s',
	            past : '%s назад',
	            s : 'несколько секунд',
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'час',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM : function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ru;
	
	})));


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'جنوري',
	        'فيبروري',
	        'مارچ',
	        'اپريل',
	        'مئي',
	        'جون',
	        'جولاءِ',
	        'آگسٽ',
	        'سيپٽمبر',
	        'آڪٽوبر',
	        'نومبر',
	        'ڊسمبر'
	    ];
	    var days = [
	        'آچر',
	        'سومر',
	        'اڱارو',
	        'اربع',
	        'خميس',
	        'جمع',
	        'ڇنڇر'
	    ];
	
	    var sd = moment.defineLocale('sd', {
	        months : months,
	        monthsShort : months,
	        weekdays : days,
	        weekdaysShort : days,
	        weekdaysMin : days,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd، D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /صبح|شام/,
	        isPM : function (input) {
	            return 'شام' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar : {
	            sameDay : '[اڄ] LT',
	            nextDay : '[سڀاڻي] LT',
	            nextWeek : 'dddd [اڳين هفتي تي] LT',
	            lastDay : '[ڪالهه] LT',
	            lastWeek : '[گزريل هفتي] dddd [تي] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s پوء',
	            past : '%s اڳ',
	            s : 'چند سيڪنڊ',
	            ss : '%d سيڪنڊ',
	            m : 'هڪ منٽ',
	            mm : '%d منٽ',
	            h : 'هڪ ڪلاڪ',
	            hh : '%d ڪلاڪ',
	            d : 'هڪ ڏينهن',
	            dd : '%d ڏينهن',
	            M : 'هڪ مهينو',
	            MM : '%d مهينا',
	            y : 'هڪ سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sd;
	
	})));


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var se = moment.defineLocale('se', {
	        months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	        monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	        weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	        weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'MMMM D. [b.] YYYY',
	            LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s geažes',
	            past : 'maŋit %s',
	            s : 'moadde sekunddat',
	            ss: '%d sekunddat',
	            m : 'okta minuhta',
	            mm : '%d minuhtat',
	            h : 'okta diimmu',
	            hh : '%d diimmut',
	            d : 'okta beaivi',
	            dd : '%d beaivvit',
	            M : 'okta mánnu',
	            MM : '%d mánut',
	            y : 'okta jahki',
	            yy : '%d jagit'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return se;
	
	})));


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	        monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	        weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	        weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'a h:mm',
	            LTS : 'a h:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY MMMM D',
	            LLL : 'YYYY MMMM D, a h:mm',
	            LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	        },
	        calendar : {
	            sameDay : '[අද] LT[ට]',
	            nextDay : '[හෙට] LT[ට]',
	            nextWeek : 'dddd LT[ට]',
	            lastDay : '[ඊයේ] LT[ට]',
	            lastWeek : '[පසුගිය] dddd LT[ට]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sකින්',
	            past : '%sකට පෙර',
	            s : 'තත්පර කිහිපය',
	            ss : 'තත්පර %d',
	            m : 'මිනිත්තුව',
	            mm : 'මිනිත්තු %d',
	            h : 'පැය',
	            hh : 'පැය %d',
	            d : 'දිනය',
	            dd : 'දින %d',
	            M : 'මාසය',
	            MM : 'මාස %d',
	            y : 'වසර',
	            yy : 'වසර %d'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	        ordinal : function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM : function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        }
	    });
	
	    return si;
	
	})));


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_'),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return (n > 1) && (n < 5);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':  // a few seconds / in a few seconds / a few seconds ago
	                return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
	                } else {
	                    return result + 'sekundami';
	                }
	                break;
	            case 'm':  // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	                break;
	            case 'h':  // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':  // a day / in a day / a day ago
	                return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	                break;
	            case 'M':  // a month / in a month / a month ago
	                return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	                break;
	            case 'y':  // a year / in a year / a year ago
	                return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	                break;
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months : months,
	        monthsShort : monthsShort,
	        weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'pred %s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sk;
	
	})));


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	            case 'ss':
	                if (number === 1) {
	                    result += withoutSuffix ? 'sekundo' : 'sekundi';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	                } else {
	                    result += 'sekund';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danes ob] LT',
	            nextDay  : '[jutri ob] LT',
	
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay  : '[včeraj ob] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'čez %s',
	            past   : 'pred %s',
	            s      : processRelativeTime,
	            ss     : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : processRelativeTime,
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return sl;
	
	})));


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sq = moment.defineLocale('sq', {
	        months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	        monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	        weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Sot në] LT',
	            nextDay : '[Nesër në] LT',
	            nextWeek : 'dddd [në] LT',
	            lastDay : '[Dje në] LT',
	            lastWeek : 'dddd [e kaluar në] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'në %s',
	            past : '%s më parë',
	            s : 'disa sekonda',
	            ss : '%d sekonda',
	            m : 'një minutë',
	            mm : '%d minuta',
	            h : 'një orë',
	            hh : '%d orë',
	            d : 'një ditë',
	            dd : '%d ditë',
	            M : 'një muaj',
	            MM : '%d muaj',
	            y : 'një vit',
	            yy : '%d vite'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sq;
	
	})));


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['секунда', 'секунде', 'секунди'],
	            m: ['један минут', 'једне минуте'],
	            mm: ['минут', 'минуте', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            dd: ['дан', 'дана', 'дана'],
	            MM: ['месец', 'месеца', 'месеци'],
	            yy: ['година', 'године', 'година']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var srCyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay  : '[јуче у] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past   : 'пре %s',
	            s      : 'неколико секунди',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'дан',
	            dd     : translator.translate,
	            M      : 'месец',
	            MM     : translator.translate,
	            y      : 'годину',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return srCyrl;
	
	})));


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['sekunda', 'sekunde', 'sekundi'],
	            m: ['jedan minut', 'jedne minute'],
	            mm: ['minut', 'minute', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'pre %s',
	            s      : 'nekoliko sekundi',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return sr;
	
	})));


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ss = moment.defineLocale('ss', {
	        months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	        monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	        weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Namuhla nga] LT',
	            nextDay : '[Kusasa nga] LT',
	            nextWeek : 'dddd [nga] LT',
	            lastDay : '[Itolo nga] LT',
	            lastWeek : 'dddd [leliphelile] [nga] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'nga %s',
	            past : 'wenteka nga %s',
	            s : 'emizuzwana lomcane',
	            ss : '%d mzuzwana',
	            m : 'umzuzu',
	            mm : '%d emizuzu',
	            h : 'lihora',
	            hh : '%d emahora',
	            d : 'lilanga',
	            dd : '%d emalanga',
	            M : 'inyanga',
	            MM : '%d tinyanga',
	            y : 'umnyaka',
	            yy : '%d iminyaka'
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : '%d',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ss;
	
	})));


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sv = moment.defineLocale('sv', {
	        months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : 'för %s sedan',
	            s : 'några sekunder',
	            ss : '%d sekunder',
	            m : 'en minut',
	            mm : '%d minuter',
	            h : 'en timme',
	            hh : '%d timmar',
	            d : 'en dag',
	            dd : '%d dagar',
	            M : 'en månad',
	            MM : '%d månader',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'e' :
	                (b === 1) ? 'a' :
	                (b === 2) ? 'a' :
	                (b === 3) ? 'e' : 'e';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sv;
	
	})));


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sw = moment.defineLocale('sw', {
	        months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	        weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[leo saa] LT',
	            nextDay : '[kesho saa] LT',
	            nextWeek : '[wiki ijayo] dddd [saat] LT',
	            lastDay : '[jana] LT',
	            lastWeek : '[wiki iliyopita] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s baadaye',
	            past : 'tokea %s',
	            s : 'hivi punde',
	            ss : 'sekunde %d',
	            m : 'dakika moja',
	            mm : 'dakika %d',
	            h : 'saa limoja',
	            hh : 'masaa %d',
	            d : 'siku moja',
	            dd : 'masiku %d',
	            M : 'mwezi mmoja',
	            MM : 'miezi %d',
	            y : 'mwaka mmoja',
	            yy : 'miaka %d'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return sw;
	
	})));


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '௧',
	        '2': '௨',
	        '3': '௩',
	        '4': '௪',
	        '5': '௫',
	        '6': '௬',
	        '7': '௭',
	        '8': '௮',
	        '9': '௯',
	        '0': '௦'
	    }, numberMap = {
	        '௧': '1',
	        '௨': '2',
	        '௩': '3',
	        '௪': '4',
	        '௫': '5',
	        '௬': '6',
	        '௭': '7',
	        '௮': '8',
	        '௯': '9',
	        '௦': '0'
	    };
	
	    var ta = moment.defineLocale('ta', {
	        months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	        weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	        weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, HH:mm',
	            LLLL : 'dddd, D MMMM YYYY, HH:mm'
	        },
	        calendar : {
	            sameDay : '[இன்று] LT',
	            nextDay : '[நாளை] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[நேற்று] LT',
	            lastWeek : '[கடந்த வாரம்] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s இல்',
	            past : '%s முன்',
	            s : 'ஒரு சில விநாடிகள்',
	            ss : '%d விநாடிகள்',
	            m : 'ஒரு நிமிடம்',
	            mm : '%d நிமிடங்கள்',
	            h : 'ஒரு மணி நேரம்',
	            hh : '%d மணி நேரம்',
	            d : 'ஒரு நாள்',
	            dd : '%d நாட்கள்',
	            M : 'ஒரு மாதம்',
	            MM : '%d மாதங்கள்',
	            y : 'ஒரு வருடம்',
	            yy : '%d ஆண்டுகள்'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}வது/,
	        ordinal : function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை';  // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return ta;
	
	})));


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var te = moment.defineLocale('te', {
	        months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	        monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	        weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[నేడు] LT',
	            nextDay : '[రేపు] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[నిన్న] LT',
	            lastWeek : '[గత] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s లో',
	            past : '%s క్రితం',
	            s : 'కొన్ని క్షణాలు',
	            ss : '%d సెకన్లు',
	            m : 'ఒక నిమిషం',
	            mm : '%d నిమిషాలు',
	            h : 'ఒక గంట',
	            hh : '%d గంటలు',
	            d : 'ఒక రోజు',
	            dd : '%d రోజులు',
	            M : 'ఒక నెల',
	            MM : '%d నెలలు',
	            y : 'ఒక సంవత్సరం',
	            yy : '%d సంవత్సరాలు'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}వ/,
	        ordinal : '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return te;
	
	})));


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tet = moment.defineLocale('tet', {
	        months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
	        weekdaysMin : 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Ohin iha] LT',
	            nextDay: '[Aban iha] LT',
	            nextWeek: 'dddd [iha] LT',
	            lastDay: '[Horiseik iha] LT',
	            lastWeek: 'dddd [semana kotuk] [iha] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'iha %s',
	            past : '%s liuba',
	            s : 'minutu balun',
	            ss : 'minutu %d',
	            m : 'minutu ida',
	            mm : 'minutu %d',
	            h : 'oras ida',
	            hh : 'oras %d',
	            d : 'loron ida',
	            dd : 'loron %d',
	            M : 'fulan ida',
	            MM : 'fulan %d',
	            y : 'tinan ida',
	            yy : 'tinan %d'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tet;
	
	})));


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-ум',
	        1: '-ум',
	        2: '-юм',
	        3: '-юм',
	        4: '-ум',
	        5: '-ум',
	        6: '-ум',
	        7: '-ум',
	        8: '-ум',
	        9: '-ум',
	        10: '-ум',
	        12: '-ум',
	        13: '-ум',
	        20: '-ум',
	        30: '-юм',
	        40: '-ум',
	        50: '-ум',
	        60: '-ум',
	        70: '-ум',
	        80: '-ум',
	        90: '-ум',
	        100: '-ум'
	    };
	
	    var tg = moment.defineLocale('tg', {
	        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split('_'),
	        weekdaysShort : 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
	        weekdaysMin : 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Имрӯз соати] LT',
	            nextDay : '[Пагоҳ соати] LT',
	            lastDay : '[Дирӯз соати] LT',
	            nextWeek : 'dddd[и] [ҳафтаи оянда соати] LT',
	            lastWeek : 'dddd[и] [ҳафтаи гузашта соати] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'баъди %s',
	            past : '%s пеш',
	            s : 'якчанд сония',
	            m : 'як дақиқа',
	            mm : '%d дақиқа',
	            h : 'як соат',
	            hh : '%d соат',
	            d : 'як рӯз',
	            dd : '%d рӯз',
	            M : 'як моҳ',
	            MM : '%d моҳ',
	            y : 'як сол',
	            yy : '%d сол'
	        },
	        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'шаб') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'субҳ') {
	                return hour;
	            } else if (meridiem === 'рӯз') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'бегоҳ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'шаб';
	            } else if (hour < 11) {
	                return 'субҳ';
	            } else if (hour < 16) {
	                return 'рӯз';
	            } else if (hour < 19) {
	                return 'бегоҳ';
	            } else {
	                return 'шаб';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1th is the first week of the year.
	        }
	    });
	
	    return tg;
	
	})));


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var th = moment.defineLocale('th', {
	        months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	        monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY เวลา H:mm',
	            LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar : {
	            sameDay : '[วันนี้ เวลา] LT',
	            nextDay : '[พรุ่งนี้ เวลา] LT',
	            nextWeek : 'dddd[หน้า เวลา] LT',
	            lastDay : '[เมื่อวานนี้ เวลา] LT',
	            lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'อีก %s',
	            past : '%sที่แล้ว',
	            s : 'ไม่กี่วินาที',
	            ss : '%d วินาที',
	            m : '1 นาที',
	            mm : '%d นาที',
	            h : '1 ชั่วโมง',
	            hh : '%d ชั่วโมง',
	            d : '1 วัน',
	            dd : '%d วัน',
	            M : '1 เดือน',
	            MM : '%d เดือน',
	            y : '1 ปี',
	            yy : '%d ปี'
	        }
	    });
	
	    return th;
	
	})));


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tlPh = moment.defineLocale('tl-ph', {
	        months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	        monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	        weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'MM/D/YYYY',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY HH:mm',
	            LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'sa loob ng %s',
	            past : '%s ang nakalipas',
	            s : 'ilang segundo',
	            ss : '%d segundo',
	            m : 'isang minuto',
	            mm : '%d minuto',
	            h : 'isang oras',
	            hh : '%d oras',
	            d : 'isang araw',
	            dd : '%d araw',
	            M : 'isang buwan',
	            MM : '%d buwan',
	            y : 'isang taon',
	            yy : '%d taon'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tlPh;
	
	})));


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	        time.slice(0, -3) + 'leS' :
	        (output.indexOf('jar') !== -1) ?
	        time.slice(0, -3) + 'waQ' :
	        (output.indexOf('DIS') !== -1) ?
	        time.slice(0, -3) + 'nem' :
	        time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	        time.slice(0, -3) + 'Hu’' :
	        (output.indexOf('jar') !== -1) ?
	        time.slice(0, -3) + 'wen' :
	        (output.indexOf('DIS') !== -1) ?
	        time.slice(0, -3) + 'ben' :
	        time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'ss':
	                return numberNoun + ' lup';
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	        ten = Math.floor((number % 100) / 10),
	        one = number % 10,
	        word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	        }
	        return (word === '') ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	        monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : translateFuture,
	            past : translatePast,
	            s : 'puS lup',
	            ss : translate,
	            m : 'wa’ tup',
	            mm : translate,
	            h : 'wa’ rep',
	            hh : translate,
	            d : 'wa’ jaj',
	            dd : translate,
	            M : 'wa’ jar',
	            MM : translate,
	            y : 'wa’ DIS',
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tlh;
	
	})));


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    var suffixes = {
	        1: '\'inci',
	        5: '\'inci',
	        8: '\'inci',
	        70: '\'inci',
	        80: '\'inci',
	        2: '\'nci',
	        7: '\'nci',
	        20: '\'nci',
	        50: '\'nci',
	        3: '\'üncü',
	        4: '\'üncü',
	        100: '\'üncü',
	        6: '\'ncı',
	        9: '\'uncu',
	        10: '\'uncu',
	        30: '\'uncu',
	        60: '\'ıncı',
	        90: '\'ıncı'
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	        monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	        weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	        weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[yarın saat] LT',
	            nextWeek : '[gelecek] dddd [saat] LT',
	            lastDay : '[dün] LT',
	            lastWeek : '[geçen] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s önce',
	            s : 'birkaç saniye',
	            ss : '%d saniye',
	            m : 'bir dakika',
	            mm : '%d dakika',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir yıl',
	            yy : '%d yıl'
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {  // special case for zero
	                        return number + '\'ıncı';
	                    }
	                    var a = number % 10,
	                        b = number % 100 - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return tr;
	
	})));


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM [dallas] YYYY',
	            LLL : 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM : function (input) {
	            return 'd\'o' === input.toLowerCase();
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'd\'o' : 'D\'O';
	            } else {
	                return isLower ? 'd\'a' : 'D\'A';
	            }
	        },
	        calendar : {
	            sameDay : '[oxhi à] LT',
	            nextDay : '[demà à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[ieiri à] LT',
	            lastWeek : '[sür el] dddd [lasteu à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'osprei %s',
	            past : 'ja%s',
	            s : processRelativeTime,
	            ss : processRelativeTime,
	            m : processRelativeTime,
	            mm : processRelativeTime,
	            h : processRelativeTime,
	            hh : processRelativeTime,
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['viensas secunds', '\'iensas secunds'],
	            'ss': [number + ' secunds', '' + number + ' secunds'],
	            'm': ['\'n míut', '\'iens míut'],
	            'mm': [number + ' míuts', '' + number + ' míuts'],
	            'h': ['\'n þora', '\'iensa þora'],
	            'hh': [number + ' þoras', '' + number + ' þoras'],
	            'd': ['\'n ziua', '\'iensa ziua'],
	            'dd': [number + ' ziuas', '' + number + ' ziuas'],
	            'M': ['\'n mes', '\'iens mes'],
	            'MM': [number + ' mesen', '' + number + ' mesen'],
	            'y': ['\'n ar', '\'iens ar'],
	            'yy': [number + ' ars', '' + number + ' ars']
	        };
	        return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	    }
	
	    return tzl;
	
	})));


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tzmLatn = moment.defineLocale('tzm-latn', {
	        months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dadkh s yan %s',
	            past : 'yan %s',
	            s : 'imik',
	            ss : '%d imik',
	            m : 'minuḍ',
	            mm : '%d minuḍ',
	            h : 'saɛa',
	            hh : '%d tassaɛin',
	            d : 'ass',
	            dd : '%d ossan',
	            M : 'ayowr',
	            MM : '%d iyyirn',
	            y : 'asgas',
	            yy : '%d isgasn'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return tzmLatn;
	
	})));


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tzm = moment.defineLocale('tzm', {
	        months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past : 'ⵢⴰⵏ %s',
	            s : 'ⵉⵎⵉⴽ',
	            ss : '%d ⵉⵎⵉⴽ',
	            m : 'ⵎⵉⵏⵓⴺ',
	            mm : '%d ⵎⵉⵏⵓⴺ',
	            h : 'ⵙⴰⵄⴰ',
	            hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d : 'ⴰⵙⵙ',
	            dd : '%d oⵙⵙⴰⵏ',
	            M : 'ⴰⵢoⵓⵔ',
	            MM : '%d ⵉⵢⵢⵉⵔⵏ',
	            y : 'ⴰⵙⴳⴰⵙ',
	            yy : '%d ⵉⵙⴳⴰⵙⵏ'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return tzm;
	
	})));


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js language configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ugCn = moment.defineLocale('ug-cn', {
	        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
	            '_'
	        ),
	        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
	            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm'
	        },
	        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                meridiem === 'يېرىم كېچە' ||
	                meridiem === 'سەھەر' ||
	                meridiem === 'چۈشتىن بۇرۇن'
	            ) {
	                return hour;
	            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
	                return hour + 12;
	            } else {
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return 'يېرىم كېچە';
	            } else if (hm < 900) {
	                return 'سەھەر';
	            } else if (hm < 1130) {
	                return 'چۈشتىن بۇرۇن';
	            } else if (hm < 1230) {
	                return 'چۈش';
	            } else if (hm < 1800) {
	                return 'چۈشتىن كېيىن';
	            } else {
	                return 'كەچ';
	            }
	        },
	        calendar: {
	            sameDay: '[بۈگۈن سائەت] LT',
	            nextDay: '[ئەتە سائەت] LT',
	            nextWeek: '[كېلەركى] dddd [سائەت] LT',
	            lastDay: '[تۆنۈگۈن] LT',
	            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s كېيىن',
	            past: '%s بۇرۇن',
	            s: 'نەچچە سېكونت',
	            ss: '%d سېكونت',
	            m: 'بىر مىنۇت',
	            mm: '%d مىنۇت',
	            h: 'بىر سائەت',
	            hh: '%d سائەت',
	            d: 'بىر كۈن',
	            dd: '%d كۈن',
	            M: 'بىر ئاي',
	            MM: '%d ئاي',
	            y: 'بىر يىل',
	            yy: '%d يىل'
	        },
	
	        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '-كۈنى';
	                case 'w':
	                case 'W':
	                    return number + '-ھەپتە';
	                default:
	                    return number;
	            }
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ugCn;
	
	})));


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	            'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            'dd': 'день_дні_днів',
	            'MM': 'місяць_місяці_місяців',
	            'yy': 'рік_роки_років'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	            'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	            'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	            'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	        };
	
	        if (m === true) {
	            return weekdays['nominative'].slice(1, 7).concat(weekdays['nominative'].slice(0, 1));
	        }
	        if (!m) {
	            return weekdays['nominative'];
	        }
	
	        var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	            'accusative' :
	            ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	                'genitive' :
	                'nominative');
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months : {
	            'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	            'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	        },
	        monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	        weekdays : weekdaysCaseReplace,
	        weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY р.',
	            LLL : 'D MMMM YYYY р., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	        },
	        calendar : {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past : '%s тому',
	            s : 'декілька секунд',
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'годину',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'місяць',
	            MM : relativeTimeWithPlural,
	            y : 'рік',
	            yy : relativeTimeWithPlural
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return uk;
	
	})));


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'جنوری',
	        'فروری',
	        'مارچ',
	        'اپریل',
	        'مئی',
	        'جون',
	        'جولائی',
	        'اگست',
	        'ستمبر',
	        'اکتوبر',
	        'نومبر',
	        'دسمبر'
	    ];
	    var days = [
	        'اتوار',
	        'پیر',
	        'منگل',
	        'بدھ',
	        'جمعرات',
	        'جمعہ',
	        'ہفتہ'
	    ];
	
	    var ur = moment.defineLocale('ur', {
	        months : months,
	        monthsShort : months,
	        weekdays : days,
	        weekdaysShort : days,
	        weekdaysMin : days,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd، D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /صبح|شام/,
	        isPM : function (input) {
	            return 'شام' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar : {
	            sameDay : '[آج بوقت] LT',
	            nextDay : '[کل بوقت] LT',
	            nextWeek : 'dddd [بوقت] LT',
	            lastDay : '[گذشتہ روز بوقت] LT',
	            lastWeek : '[گذشتہ] dddd [بوقت] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s بعد',
	            past : '%s قبل',
	            s : 'چند سیکنڈ',
	            ss : '%d سیکنڈ',
	            m : 'ایک منٹ',
	            mm : '%d منٹ',
	            h : 'ایک گھنٹہ',
	            hh : '%d گھنٹے',
	            d : 'ایک دن',
	            dd : '%d دن',
	            M : 'ایک ماہ',
	            MM : '%d ماہ',
	            y : 'ایک سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ur;
	
	})));


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var uzLatn = moment.defineLocale('uz-latn', {
	        months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
	        monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	        weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
	        weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	        weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar : {
	            sameDay : '[Bugun soat] LT [da]',
	            nextDay : '[Ertaga] LT [da]',
	            nextWeek : 'dddd [kuni soat] LT [da]',
	            lastDay : '[Kecha soat] LT [da]',
	            lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'Yaqin %s ichida',
	            past : 'Bir necha %s oldin',
	            s : 'soniya',
	            ss : '%d soniya',
	            m : 'bir daqiqa',
	            mm : '%d daqiqa',
	            h : 'bir soat',
	            hh : '%d soat',
	            d : 'bir kun',
	            dd : '%d kun',
	            M : 'bir oy',
	            MM : '%d oy',
	            y : 'bir yil',
	            yy : '%d yil'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return uzLatn;
	
	})));


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var uz = moment.defineLocale('uz', {
	        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бугун соат] LT [да]',
	            nextDay : '[Эртага] LT [да]',
	            nextWeek : 'dddd [куни соат] LT [да]',
	            lastDay : '[Кеча соат] LT [да]',
	            lastWeek : '[Утган] dddd [куни соат] LT [да]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'Якин %s ичида',
	            past : 'Бир неча %s олдин',
	            s : 'фурсат',
	            ss : '%d фурсат',
	            m : 'бир дакика',
	            mm : '%d дакика',
	            h : 'бир соат',
	            hh : '%d соат',
	            d : 'бир кун',
	            dd : '%d кун',
	            M : 'бир ой',
	            MM : '%d ой',
	            y : 'бир йил',
	            yy : '%d йил'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return uz;
	
	})));


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var vi = moment.defineLocale('vi', {
	        months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	        monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	        weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /sa|ch/i,
	        isPM : function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM [năm] YYYY',
	            LLL : 'D MMMM [năm] YYYY HH:mm',
	            LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	            l : 'DD/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần rồi lúc] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s tới',
	            past : '%s trước',
	            s : 'vài giây',
	            ss : '%d giây' ,
	            m : 'một phút',
	            mm : '%d phút',
	            h : 'một giờ',
	            hh : '%d giờ',
	            d : 'một ngày',
	            dd : '%d ngày',
	            M : 'một tháng',
	            MM : '%d tháng',
	            y : 'một năm',
	            yy : '%d năm'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return vi;
	
	})));


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var xPseudo = moment.defineLocale('x-pseudo', {
	        months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	        monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	        weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[T~ódá~ý át] LT',
	            nextDay : '[T~ómó~rró~w át] LT',
	            nextWeek : 'dddd [át] LT',
	            lastDay : '[Ý~ést~érdá~ý át] LT',
	            lastWeek : '[L~ást] dddd [át] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'í~ñ %s',
	            past : '%s á~gó',
	            s : 'á ~féw ~sécó~ñds',
	            ss : '%d s~écóñ~ds',
	            m : 'á ~míñ~úté',
	            mm : '%d m~íñú~tés',
	            h : 'á~ñ hó~úr',
	            hh : '%d h~óúrs',
	            d : 'á ~dáý',
	            dd : '%d d~áýs',
	            M : 'á ~móñ~th',
	            MM : '%d m~óñt~hs',
	            y : 'á ~ýéár',
	            yy : '%d ý~éárs'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return xPseudo;
	
	})));


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var yo = moment.defineLocale('yo', {
	        months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
	        monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	        weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	        weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	        weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Ònì ni] LT',
	            nextDay : '[Ọ̀la ni] LT',
	            nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
	            lastDay : '[Àna ni] LT',
	            lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ní %s',
	            past : '%s kọjá',
	            s : 'ìsẹjú aayá die',
	            ss :'aayá %d',
	            m : 'ìsẹjú kan',
	            mm : 'ìsẹjú %d',
	            h : 'wákati kan',
	            hh : 'wákati %d',
	            d : 'ọjọ́ kan',
	            dd : 'ọjọ́ %d',
	            M : 'osù kan',
	            MM : 'osù %d',
	            y : 'ọdún kan',
	            yy : 'ọdún %d'
	        },
	        dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
	        ordinal : 'ọjọ́ %d',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return yo;
	
	})));


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhCn = moment.defineLocale('zh-cn', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日Ah点mm分',
	            LLLL : 'YYYY年M月D日ddddAh点mm分',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' ||
	                    meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s内',
	            past : '%s前',
	            s : '几秒',
	            ss : '%d 秒',
	            m : '1 分钟',
	            mm : '%d 分钟',
	            h : '1 小时',
	            hh : '%d 小时',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 个月',
	            MM : '%d 个月',
	            y : '1 年',
	            yy : '%d 年'
	        },
	        week : {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return zhCn;
	
	})));


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhHk = moment.defineLocale('zh-hk', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日dddd HH:mm',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd' :
	                case 'D' :
	                case 'DDD' :
	                    return number + '日';
	                case 'M' :
	                    return number + '月';
	                case 'w' :
	                case 'W' :
	                    return number + '週';
	                default :
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            ss : '%d 秒',
	            m : '1 分鐘',
	            mm : '%d 分鐘',
	            h : '1 小時',
	            hh : '%d 小時',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 個月',
	            MM : '%d 個月',
	            y : '1 年',
	            yy : '%d 年'
	        }
	    });
	
	    return zhHk;
	
	})));


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhTw = moment.defineLocale('zh-tw', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日dddd HH:mm',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天] LT',
	            nextDay : '[明天] LT',
	            nextWeek : '[下]dddd LT',
	            lastDay : '[昨天] LT',
	            lastWeek : '[上]dddd LT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd' :
	                case 'D' :
	                case 'DDD' :
	                    return number + '日';
	                case 'M' :
	                    return number + '月';
	                case 'w' :
	                case 'W' :
	                    return number + '週';
	                default :
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            ss : '%d 秒',
	            m : '1 分鐘',
	            mm : '%d 分鐘',
	            h : '1 小時',
	            hh : '%d 小時',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 個月',
	            MM : '%d 個月',
	            y : '1 年',
	            yy : '%d 年'
	        }
	    });
	
	    return zhTw;
	
	})));


/***/ }),
/* 221 */,
/* 222 */,
/* 223 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.pushParams = pushParams;
	exports.popParams = popParams;
	exports.withParams = withParams;
	
	var stack = [];
	
	// exported for tests
	var target = exports.target = null;
	var _setTarget = exports._setTarget = function _setTarget(x) {
	  exports.target = target = x;
	};
	
	function pushParams() {
	  if (target !== null) {
	    stack.push(target);
	  }
	  exports.target = target = {};
	}
	
	function popParams() {
	  var lastTarget = target;
	  var newTarget = exports.target = target = stack.pop() || null;
	  if (newTarget) {
	    if (!Array.isArray(newTarget.$sub)) {
	      newTarget.$sub = [];
	    }
	    newTarget.$sub.push(lastTarget);
	  }
	  return lastTarget;
	}
	
	function addParams(params) {
	  if (typeof params === 'object' && !Array.isArray(params)) {
	    exports.target = target = _extends({}, target, params);
	  } else {
	    throw new Error('params must be an object');
	  }
	}
	
	function withParamsDirect(params, validator) {
	  return withParamsClosure(function (add) {
	    return function () {
	      add(params);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return validator.apply(this, args);
	    };
	  });
	}
	
	function withParamsClosure(closure) {
	  var validator = closure(addParams);
	  return function () {
	    pushParams();
	    try {
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return validator.apply(this, args);
	    } finally {
	      popParams();
	    }
	  };
	}
	
	function withParams(paramsOrClosure, maybeValidator) {
	  if (typeof paramsOrClosure === 'object' && maybeValidator !== undefined) {
	    return withParamsDirect(paramsOrClosure, maybeValidator);
	  }
	  return withParamsClosure(paramsOrClosure);
	}

/***/ }),
/* 224 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(16);
	var bind = __webpack_require__(71);
	var Axios = __webpack_require__(227);
	var defaults = __webpack_require__(46);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(instanceConfig) {
	  return createInstance(utils.merge(defaults, instanceConfig));
	};
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(68);
	axios.CancelToken = __webpack_require__(226);
	axios.isCancel = __webpack_require__(69);
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(241);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Cancel = __webpack_require__(68);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(46);
	var utils = __webpack_require__(16);
	var InterceptorManager = __webpack_require__(228);
	var dispatchRequest = __webpack_require__(229);
	var isAbsoluteURL = __webpack_require__(237);
	var combineURLs = __webpack_require__(235);
	
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = utils.merge({
	      url: arguments[0]
	    }, arguments[1]);
	  }
	
	  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
	
	  // Support baseURL config
	  if (config.baseURL && !isAbsoluteURL(config.url)) {
	    config.url = combineURLs(config.baseURL, config.url);
	  }
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(16);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(16);
	var transformData = __webpack_require__(232);
	var isCancel = __webpack_require__(69);
	var defaults = __webpack_require__(46);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData(
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData(
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};


/***/ }),
/* 230 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 @ @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	  error.response = response;
	  return error;
	};


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var createError = __webpack_require__(70);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  // Note: status is not exposed by XDomainRequest
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response
	    ));
	  }
	};


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(16);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ }),
/* 233 */
/***/ (function(module, exports) {

	'use strict';
	
	// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js
	
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	function E() {
	  this.message = 'String contains an invalid character';
	}
	E.prototype = new Error;
	E.prototype.code = 5;
	E.prototype.name = 'InvalidCharacterError';
	
	function btoa(input) {
	  var str = String(input);
	  var output = '';
	  for (
	    // initialize result and counter
	    var block, charCode, idx = 0, map = chars;
	    // if the next str index does not exist:
	    //   change the mapping table to "="
	    //   check if d has no fractional digits
	    str.charAt(idx | 0) || (map = '=', idx % 1);
	    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
	    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
	  ) {
	    charCode = str.charCodeAt(idx += 3 / 4);
	    if (charCode > 0xFF) {
	      throw new E();
	    }
	    block = block << 8 | charCode;
	  }
	  return output;
	}
	
	module.exports = btoa;


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(16);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      }
	
	      if (!utils.isArray(val)) {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ }),
/* 235 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '');
	};


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(16);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	  (function standardBrowserEnv() {
	    return {
	      write: function write(name, value, expires, path, domain, secure) {
	        var cookie = [];
	        cookie.push(name + '=' + encodeURIComponent(value));
	
	        if (utils.isNumber(expires)) {
	          cookie.push('expires=' + new Date(expires).toGMTString());
	        }
	
	        if (utils.isString(path)) {
	          cookie.push('path=' + path);
	        }
	
	        if (utils.isString(domain)) {
	          cookie.push('domain=' + domain);
	        }
	
	        if (secure === true) {
	          cookie.push('secure');
	        }
	
	        document.cookie = cookie.join('; ');
	      },
	
	      read: function read(name) {
	        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	        return (match ? decodeURIComponent(match[3]) : null);
	      },
	
	      remove: function remove(name) {
	        this.write(name, '', Date.now() - 86400000);
	      }
	    };
	  })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return {
	      write: function write() {},
	      read: function read() { return null; },
	      remove: function remove() {}
	    };
	  })()
	);


/***/ }),
/* 237 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(16);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	  (function standardBrowserEnv() {
	    var msie = /(msie|trident)/i.test(navigator.userAgent);
	    var urlParsingNode = document.createElement('a');
	    var originURL;
	
	    /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	    function resolveURL(url) {
	      var href = url;
	
	      if (msie) {
	        // IE needs attribute set twice to normalize properties
	        urlParsingNode.setAttribute('href', href);
	        href = urlParsingNode.href;
	      }
	
	      urlParsingNode.setAttribute('href', href);
	
	      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	      return {
	        href: urlParsingNode.href,
	        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	        host: urlParsingNode.host,
	        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	        hostname: urlParsingNode.hostname,
	        port: urlParsingNode.port,
	        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	                  urlParsingNode.pathname :
	                  '/' + urlParsingNode.pathname
	      };
	    }
	
	    originURL = resolveURL(window.location.href);
	
	    /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	    return function isURLSameOrigin(requestURL) {
	      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	      return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	    };
	  })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return function isURLSameOrigin() {
	      return true;
	    };
	  })()
	);


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(16);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(16);
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	    }
	  });
	
	  return parsed;
	};


/***/ }),
/* 241 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ }),
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(349), __esModule: true };

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(350), __esModule: true };

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(351), __esModule: true };

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(352), __esModule: true };

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(354), __esModule: true };

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(356), __esModule: true };

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(357), __esModule: true };

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(358), __esModule: true };

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(338);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty2.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _isIterable2 = __webpack_require__(335);
	
	var _isIterable3 = _interopRequireDefault(_isIterable2);
	
	var _getIterator2 = __webpack_require__(334);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if ((0, _isIterable3.default)(Object(arr))) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();

/***/ }),
/* 343 */
/***/ (function(module, exports) {

	// file : bwip-js/browser-bitmap.js
	// 
	// bwip-js bitmap interface for an HTML canvas.
	//
	// Copyright (c) 2011-2018 Mark Warren
	//
	// Licensed MIT.  See the LICENSE file in the bwip-js root directory
	// for the extended copyright notice.
	"use strict";
	
	module.exports = Bitmap;
	
	// bgcolor is optional, defaults to #fff
	function Bitmap(cvsid, rot, bgcolor) {
		var rgb  = [0, 0, 0];
		var padx = 0;	// padding-x
		var pady = 0;	// padding-y
	
		// Initialized in imageinfo()
		var imgwidth, imgheight, cvs, ctx, idata, bytes;
	
		this.pad = function(x, y) {
			if (rot == 'R' || rot == 'L') {
				padx = y;
				pady = x;
			} else {
				padx = x;
				pady = y;
			}
		}
	
		// Sets the final size for the drawing surface and maximum number of
		// colors.  If fonts are lazy-loaded and not available when the cross-compiled
		// code is executing, the number of colors can be wrong.
		this.imageinfo = function(width, height, ncolors) {
			if (rot == 'R' || rot == 'L') {
				imgwidth  = height;
				imgheight = width;
			} else {
				imgwidth  = width;
				imgheight = height;
			}
	
			cvs  = cvsid instanceof window.HTMLCanvasElement
							? cvsid : document.getElementById(cvsid);
			cvs.width  = imgwidth + 2*padx;
			cvs.height = imgheight + 2*pady;
	
			// Convert from cmyk?
			if (bgcolor && bgcolor.length == 8) {
				var c = parseInt(bgcolor.substr(0,2), 16) / 255;
				var m = parseInt(bgcolor.substr(2,2), 16) / 255;
				var y = parseInt(bgcolor.substr(4,2), 16) / 255;
				var k = parseInt(bgcolor.substr(6,2), 16) / 255;
				var r = Math.floor((1-c) * (1-k) * 255);
				var g = Math.floor((1-m) * (1-k) * 255);
				var b = Math.floor((1-y) * (1-k) * 255);
				bgcolor = 'rgb(' + r + ',' + g + ',' + b + ')';
			} else if (bgcolor) {
				bgcolor = '#' + bgcolor;
			}
	
			ctx = cvs.getContext('2d');
			ctx.fillStyle = bgcolor || '#fff';
			ctx.fillRect(0, 0, cvs.width, cvs.height);
			ctx.fillStyle = '#000';
	
			idata = ctx.getImageData(padx, pady, imgwidth, imgheight);
			bytes = idata.data;
		}
	
		this.color = function(r, g, b) {
			rgb = [r, g, b];
		}
	
		// a is the alpha-level of the pixel [0 .. 255]
		this.set = function(x, y, a) {
			// PostScript builds bottom-up, we build top-down.
			if (rot == 'N') {
				y = imgheight - y - 1;
			} else if (rot == 'I') {
				x = imgwidth - x - 1;
			} else {
				y = imgwidth - y;
				if (rot == 'L') {
					var t = y;
					y = imgheight - x - 1;
					x = t - 1;
				} else {
					var t = x;
					x = imgwidth - y;
					y = t;
				}
			}
	
			// alpha-blend with the existing pixel
			var idx = (y * imgwidth + x) * 4
			a = a / 255;
			bytes[idx+0] = (bytes[idx+0] * (1 - a) + rgb[0] * a)|0;
			bytes[idx+1] = (bytes[idx+1] * (1 - a) + rgb[1] * a)|0;
			bytes[idx+2] = (bytes[idx+2] * (1 - a) + rgb[2] * a)|0;
			bytes[idx+3] = 255;
		}
	
		this.finalize = function(callback) {
			ctx.putImageData(idata, padx, pady);
			callback(null, cvsid);
		}
	}


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	// file: bwip-js/browser-bwipjs.js
	//
	// Copyright (c) 2011-2018 Mark Warren
	//
	// See the LICENSE file in the bwip-js root directory
	// for the extended copyright notice.
	//
	"use strict";
	
	var bwipp = __webpack_require__(347),
		bwipjs = __webpack_require__(346),
		Bitmap = __webpack_require__(343),
		fontlib = __webpack_require__(345)
		;
	
	// This module's one and only export is the canvas rendering.
	// `cvs` is either an id to a canvas element, or the actual canvas element.
	// `opts` is the bwip-js/BWIPP options object.
	// `callback` has the usual node callback signature:
	//
	//		function (err, cvs)
	//
	// Where cvs is the same parameter as passed into this call.
	module.exports = function toCanvas(cvs, opts, callback) {
		// Make a mutable copy of the user's options
		var vals = {};
		for (var id in opts) {
			vals[id] = opts[id];
		}
	
		// Set the defaults
		var scale	= vals.scale || 2;
		var scaleX	= +vals.scaleX || scale;
		var scaleY	= +vals.scaleY || scaleX;
		var rot		= vals.rotate || 'N';
		var mono	= vals.monochrome || false;
		var padX	= +vals.paddingwidth || 0;
		var padY	= +vals.paddingheight || 0;
	
		// The required parameters
		var bcid	= vals.bcid;
		var text	= vals.text;
	
		if (!text) {
			return callback('Bar code text not specified.');
		}
		if (!bcid) {
			return callback('Bar code type not specified.');
		}
		// Remove the non-BWIPP options
		delete vals.scale;
		delete vals.scaleX;
		delete vals.scaleY;
		delete vals.rotate;
		delete vals.text;
		delete vals.bcid;
		delete vals.monochrome;
		delete vals.paddingwidth;
		delete vals.paddingheight;
	
		// Initialize a barcode writer object.  This is the interface between
		// the low-level BWIPP code, the font manager, and the Bitmap object.
		var bw = new bwipjs(fontlib, mono);
	
		// Fix a disconnect in the BWIPP rendering logic
		if (vals.alttext) {
			vals.includetext = true;
		}
		// We use mm rather than inches for height - except pharmacode2 height
		// which is already in mm.
		if (+vals.height && bcid != 'pharmacode2') {
			vals.height = vals.height / 25.4 || 0.5;
		}
		// Likewise, width
		if (+vals.width) {
			vals.width = vals.width / 25.4 || 0;
		}
	
		// Override the `backgroundcolor` option.
		if (vals.backgroundcolor) {
			bw.bitmap(new Bitmap(cvs, rot, parseInt(''+vals.backgroundcolor, 16)));
			delete vals.backgroundcolor;
		} else {
			bw.bitmap(new Bitmap(cvs, rot));
		}
	
		// Add optional padding and scale the image.
		bw.bitmap().pad(padX*scaleX || 0, padY*scaleY || 0);
		bw.scale(scaleX, scaleY);
	
		// Call into the BWIPP cross-compiled code
		try {
			bwipp()(bw, bcid, text, vals);
	
			// Let the font manager demand-load any fonts.
			fontlib.loadfonts(function(err) {
				if (err) {
					callback(err);
				} else {
					bw.render(callback);
				}
			});
		} catch (e) {
			callback(e.stack || e);
		}
	}
	
	module.exports.bwipjs_version = bwipjs.VERSION;
	module.exports.bwipp_version = bwipp.VERSION;


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// file : bwip-js/browser-fonts.js
	//
	// Defines a browser-based font manager.
	//
	// Copyright (c) 2011-2018 Mark Warren
	//
	// Licensed MIT.  See the LICENSE file in the bwip-js root directory
	// for the extended copyright notice.
	"use strict";
	
	// bwipjs needs the following interfaces:
	//  lookup(fontname)    returns fontid
	//  monochrome(bool)    set the fonts to monochrome or anti-aliased
	//  getglyph(fontid, charcode, width, height)
	//
	// And the user-level code needs an onready event to notify when it is safe
	// to start making bar codes.  And a loadfonts() to demand-load font bitmaps.
	module.exports = {
		lookup:lookup,
		monochrome:monochrome,
		getglyph:getglyph,
		loadfonts:loadfonts,
		onready:onready,
	};
	
	// Module globals, wrapped.  The name bwipjs_fonts is known to the font-descriptions.
	var bwipjs_fonts = {
		monocolor: false,	// aka monochrome
		fontsets: [],
		names: {},
		toload:	{},
		onready: null,
	};
	
	function onready(callback) {
		bwipjs_fonts.onready = callback;
	}
	
	function lookup(name) {
		var fontid = bwipjs_fonts.names[name.toUpperCase()];
		return fontid === undefined ? 1 : fontid;		// OCR B default
	}
	
	function monochrome(mono) {
		bwipjs_fonts.monocolor = mono;
	}
	
	function loadfonts(callback) {
		var count = 0;
		for (var temp in bwipjs_fonts.toload) {
			(function(fontpath, font) {
				var xhr = new XMLHttpRequest;
				var root = (typeof process == 'object' && "object" == 'object' &&
							({"NODE_ENV":"production","DOMAIN":".urcamp.edu.br","API_URL":"https://api.sou.urcamp.edu.br/","APP_VERSION":"5678-3b736317"}).PUBLIC_URL) || '';
				xhr.open('GET', root + '/bwipjs-fonts/' + fontpath, true);
				xhr.responseType = 'arraybuffer';
				xhr.onload = function(e) {
					if (xhr.status == 200) {
						font.bytes = new Uint8Array(xhr.response);
						font.view  = new DataView(xhr.response);
					}
					if (--count == 0) {
						callback();
					}
				}
	
				count++;
				xhr.send(null);
			})(temp, bwipjs_fonts.toload[temp]);
		}
		bwipjs_fonts.toload = {};
	
		if (!count) {
			callback();
		}
	}
	
	
	// `width` and `height` are the same size, scaled respectively by the
	// x,y factors.  Because bar code width is what we care about, font
	// width is the only metric we use to match the font.
	function getglyph(fontid, charcode, width, height) {
		if (fontid < 0 || fontid >= bwipjs_fonts.fontsets.length) {
			if (bwipjs_fonts.fontsets.length < 2) {
				throw 'bwipjs: fonts are not loaded';
			}
			fontid = 1;		// OCR B default
		}
		var fontset = bwipjs_fonts.fontsets[fontid];
		if (width < fontset.minsize) {
			width = fontset.minsize;
		} else if (width > fontset.maxsize) {
			width = fontset.maxsize;
		}
	
		// Find the largest size not exceeding
		var size = width;
		while (size > 5 && !fontset.sizes[size]) {
			size--;
		}
		if (size == 5) {
			throw 'font-size not supported (' + width + ')';
		}
	
		var key  = (bwipjs_fonts.monocolor ? 'm' : 'a') + size;
		var font = fontset.fonts[key];
	
		// Need to demand-load the font bitmap?
		if (!font) {
			fontset.fonts[key] = font = { glyphs:[] };
			bwipjs_fonts.toload['fnt' + fontid + (bwipjs_fonts.monocolor ? 'm-' : 'a-') + size + '.bin'] = font;
		}
	
		// Convert the charcode to a glyph index.  Simple 7-bit printable ascii.
		// No special mapping supported.
		if (charcode < fontset.minchar || charcode > fontset.maxchar) {
			charcode = fontset.minchar;
		}
		charcode -= fontset.minchar;
	
		var glyph = font.glyphs[charcode];
		if (!glyph) {
			var glidx = charcode * 5;
			var metrics = fontset.metrics[key];
			font.glyphs[charcode] = glyph = {
					advance: metrics[glidx + 0],
					top:	 metrics[glidx + 1],
					left:	 metrics[glidx + 2],
					width:	 metrics[glidx + 3],
					height:	 metrics[glidx + 4],
				};
		}
	
		// Once the glyph bitmaps have been loaded, we can initialize the remainder of each glyph
		if (!glyph.offset && font.bytes) {
			glyph.offset = font.view.getUint32(charcode * 4, true) + 10;
			glyph.bytes  = font.bytes;
		}
	
		return glyph;
	}
	
	//--APPENDFONTS-MARKER--
	; // fix semi-colon insertion bug
	// fnt0-desc.js
	// $ node genfont 0
	(function() {
	  var desc = {"name":"OCR-A","minsize":8,"maxsize":108,"minchar":32,"maxchar":126,"sizes":{"8":8,"9":9,"10":10,"12":12,"16":16,"18":18,"20":20,"24":24,"27":27,"30":30,"32":32,"36":36,"40":40,"45":45,"48":48,"50":50,"54":54,"56":56,"60":60,"63":63,"64":64,"70":70,"72":72,"80":80,"81":81,"84":84,"90":90,"96":96,"108":108},"metrics":{"m8":[5,0,0,0,0,5,6,2,1,6,5,6,0,5,3,5,6,0,5,6,5,6,1,3,6,5,6,1,3,6,5,5,1,4,5,5,6,2,1,4,5,6,2,3,6,5,6,0,3,6,5,5,0,5,5,5,5,0,5,5,5,3,2,2,3,5,3,0,5,1,5,2,2,1,1,5,6,0,5,6,5,6,1,3,6,5,6,1,3,6,5,6,1,3,6,5,6,0,4,6,5,6,1,4,6,5,6,0,4,6,5,6,1,3,6,5,6,0,4,6,5,6,1,4,6,5,6,1,3,6,5,4,2,1,3,5,5,2,2,5,5,5,0,5,5,5,4,0,5,2,5,5,0,5,5,5,6,0,5,6,5,6,1,3,6,5,6,0,5,6,5,6,1,3,6,5,6,1,4,6,5,6,0,4,6,5,6,1,4,6,5,6,1,4,6,5,6,1,3,6,5,6,1,3,6,5,6,0,5,6,5,6,1,3,6,5,6,1,4,6,5,6,1,4,6,5,6,1,3,6,5,6,1,3,6,5,6,1,3,6,5,6,1,3,6,5,6,1,3,6,5,6,1,3,6,5,6,1,3,6,5,6,1,3,6,5,6,1,3,6,5,6,1,3,6,5,6,1,3,6,5,6,0,5,6,5,6,1,3,6,5,6,0,5,6,5,6,1,4,6,5,6,0,5,6,5,6,0,4,6,5,5,0,5,5,5,0,0,5,1,5,6,1,3,3,5,4,1,3,4,5,6,1,3,6,5,4,1,4,4,5,6,1,3,6,5,4,1,3,4,5,6,1,4,6,5,4,1,3,6,5,6,1,3,6,5,6,1,4,6,5,6,1,3,8,5,6,1,4,6,5,6,1,4,6,5,4,1,3,4,5,4,1,3,4,5,4,1,3,4,5,4,1,3,6,5,4,1,3,6,5,4,1,3,4,5,4,1,3,4,5,6,0,5,6,5,4,1,3,4,5,4,1,3,4,5,4,1,4,4,5,4,0,5,4,5,4,1,3,6,5,4,0,5,4,5,6,0,5,6,5,6,2,1,6,5,6,0,5,6,5,6,1,3,3],"a8":[5,0,0,0,0,5,6,2,1,6,5,6,0,5,3,5,6,0,5,6,5,6,1,3,6,5,6,0,4,6,5,5,1,4,5,5,6,1,2,4,5,6,2,3,6,5,6,0,3,6,5,5,0,5,5,5,5,0,5,5,5,3,1,3,3,5,3,0,5,1,5,2,1,2,2,5,6,0,5,6,5,6,1,3,6,5,6,0,4,6,5,6,1,3,6,5,6,0,4,6,5,6,1,4,6,5,6,0,4,6,5,6,1,3,6,5,6,0,4,6,5,6,1,4,6,5,6,1,3,6,5,5,1,2,5,5,5,1,3,5,5,5,0,5,5,5,4,0,5,2,5,5,0,5,5,5,6,0,5,6,5,6,1,3,6,5,6,0,5,6,5,6,1,3,6,5,6,1,4,6,5,6,0,4,6,5,6,1,4,6,5,6,1,4,6,5,6,1,3,6,5,6,1,3,6,5,6,0,5,6,5,6,1,3,6,5,6,1,4,6,5,6,1,4,6,5,6,1,3,6,5,6,1,3,6,5,6,1,3,6,5,6,1,3,6,5,6,1,3,6,5,6,1,3,6,5,6,1,3,6,5,6,1,3,6,5,6,1,3,6,5,6,1,3,6,5,6,1,3,6,5,6,0,5,6,5,6,1,3,6,5,6,0,5,6,5,6,1,4,6,5,6,0,5,6,5,6,0,4,6,5,5,0,5,5,5,0,0,5,1,5,6,1,3,3,5,4,1,3,4,5,6,1,3,6,5,4,1,4,4,5,6,1,3,6,5,4,1,3,4,5,6,1,4,6,5,4,1,3,6,5,6,1,3,6,5,6,1,3,6,5,6,1,3,8,5,6,1,4,6,5,6,1,4,6,5,4,1,3,4,5,4,1,3,4,5,4,1,3,4,5,4,1,3,6,5,4,1,3,6,5,4,1,3,4,5,4,1,3,4,5,6,0,5,6,5,4,1,3,4,5,4,1,3,4,5,4,1,4,4,5,4,0,5,4,5,4,1,3,6,5,4,0,5,4,5,6,0,5,6,5,6,2,1,6,5,6,0,5,6,5,6,1,3,3],"m9":[6,0,0,0,0,6,6,2,1,6,6,6,0,5,4,6,6,1,4,6,6,6,1,4,6,6,6,1,4,6,6,6,1,4,6,6,6,2,2,4,6,6,2,3,6,6,6,1,3,6,6,6,0,5,6,6,6,0,5,5,6,3,2,2,3,6,3,0,5,1,6,3,2,2,2,6,6,0,5,6,6,6,1,4,6,6,6,1,4,6,6,6,1,4,6,6,6,0,5,6,6,6,1,4,6,6,6,1,4,6,6,6,1,4,6,6,6,0,5,6,6,6,1,4,6,6,6,1,4,6,6,6,2,2,5,6,6,2,3,6,6,6,0,5,6,6,5,0,5,3,6,6,0,5,6,6,6,1,5,6,6,6,1,4,6,6,6,0,5,6,6,6,1,4,6,6,6,1,5,6,6,6,1,4,6,6,6,1,5,6,6,6,1,5,6,6,6,1,4,6,6,6,1,4,6,6,6,0,5,6,6,6,1,4,6,6,6,1,4,6,6,6,1,5,6,6,6,1,4,6,6,6,1,4,6,6,6,1,4,6,6,6,1,4,6,6,6,1,4,6,6,6,1,4,6,6,6,1,4,6,6,6,1,4,6,6,6,1,4,6,6,6,1,4,6,6,6,1,4,6,6,6,0,5,6,6,6,1,4,6,6,6,0,5,6,6,6,1,5,6,6,6,0,5,6,6,6,1,4,6,6,5,0,5,4,6,0,0,5,1,6,6,1,4,3,6,5,1,4,5,6,6,1,4,6,6,5,1,5,5,6,6,1,4,6,6,5,1,4,5,6,6,1,4,6,6,5,1,4,7,6,6,1,4,6,6,6,1,4,6,6,6,1,3,8,6,6,1,5,6,6,6,1,4,6,6,5,1,4,5,6,5,1,4,5,6,5,1,4,5,6,5,1,4,7,6,5,1,4,7,6,5,1,4,5,6,5,1,4,5,6,7,1,5,7,6,5,1,4,5,6,5,1,4,5,6,5,1,4,5,6,5,0,5,5,6,5,1,4,7,6,5,0,5,5,6,6,0,5,6,6,6,2,1,6,6,6,0,5,6,6,6,1,4,3],"a9":[6,0,0,0,0,6,6,2,1,6,6,6,0,5,3,6,6,1,4,6,6,6,1,4,6,6,6,1,4,6,6,6,1,4,6,6,6,2,2,4,6,6,2,3,6,6,6,1,3,6,6,6,0,5,6,6,6,0,5,5,6,3,1,3,3,6,3,0,5,1,6,3,2,2,2,6,6,0,5,6,6,6,1,4,6,6,6,1,4,6,6,6,1,4,6,6,6,0,5,6,6,6,1,4,6,6,6,1,4,6,6,6,1,4,6,6,6,0,5,6,6,6,1,4,6,6,6,1,4,6,6,6,2,2,5,6,6,2,3,6,6,6,0,5,6,6,5,0,5,3,6,6,0,5,6,6,6,1,5,6,6,6,1,4,6,6,6,0,5,6,6,6,1,4,6,6,6,1,5,6,6,6,1,4,6,6,6,1,5,6,6,6,1,5,6,6,6,1,4,6,6,6,1,4,6,6,6,0,5,6,6,6,1,4,6,6,6,1,4,6,6,6,1,5,6,6,6,1,4,6,6,6,1,4,6,6,6,1,4,6,6,6,1,4,6,6,6,1,4,6,6,6,1,4,6,6,6,1,4,6,6,6,1,4,6,6,6,1,4,6,6,6,1,4,6,6,6,1,4,6,6,6,0,5,6,6,6,1,4,6,6,6,0,5,6,6,6,1,5,6,6,6,0,5,6,6,6,1,4,6,6,5,0,5,4,6,0,0,5,1,6,6,1,4,3,6,5,1,4,5,6,6,1,4,6,6,5,1,5,5,6,6,1,4,6,6,5,1,4,5,6,6,1,4,6,6,5,1,4,7,6,6,1,4,6,6,6,1,4,6,6,6,1,4,8,6,6,1,5,6,6,6,1,4,6,6,5,1,4,5,6,5,1,4,5,6,5,1,4,5,6,5,1,4,7,6,5,1,4,7,6,5,1,4,5,6,5,1,4,5,6,7,1,5,7,6,5,1,4,5,6,5,1,4,5,6,5,1,4,5,6,5,0,5,5,6,5,1,4,7,6,5,0,5,5,6,6,0,5,6,6,6,2,1,6,6,6,0,5,6,6,6,1,4,3],"m10":[7,0,0,0,0,7,7,2,1,7,7,7,0,6,4,7,7,1,5,6,7,7,1,4,7,7,7,1,5,7,7,6,1,5,6,7,7,2,2,4,7,7,2,3,7,7,7,1,3,7,7,7,1,5,7,7,6,1,5,5,7,3,2,3,3,7,4,1,5,1,7,3,2,2,2,7,7,1,5,7,7,7,1,4,7,7,7,1,4,7,7,7,1,4,7,7,7,0,5,7,7,7,1,5,7,7,7,1,4,7,7,7,1,4,7,7,7,1,4,7,7,7,1,5,7,7,7,1,4,7,7,6,2,2,5,7,7,2,3,7,7,7,1,5,7,7,5,1,5,3,7,7,1,5,7,7,7,1,5,7,7,7,1,4,7,7,7,0,6,7,7,7,1,4,7,7,7,1,5,7,7,7,1,4,7,7,7,1,5,7,7,7,1,5,7,7,7,1,4,7,7,7,1,4,7,7,7,1,5,7,7,7,1,4,7,7,7,1,5,7,7,7,1,5,7,7,7,1,4,7,7,7,1,4,7,7,7,1,4,7,7,7,1,4,7,7,7,1,4,7,7,7,1,4,7,7,7,1,4,7,7,7,1,4,7,7,7,1,4,7,7,7,1,4,7,7,7,1,4,7,7,7,1,5,7,7,7,1,4,7,7,7,0,6,7,7,7,1,5,7,7,7,1,5,7,7,7,0,5,7,7,6,0,6,5,7,0,1,5,1,7,7,1,4,4,7,5,1,4,5,7,7,1,4,7,7,5,1,5,5,7,7,1,4,7,7,5,1,4,5,7,7,1,5,7,7,5,1,4,7,7,7,1,4,7,7,7,1,4,7,7,7,1,4,9,7,7,1,5,7,7,7,1,4,7,7,5,1,4,5,7,5,1,4,5,7,5,1,4,5,7,5,1,4,7,7,5,1,4,7,7,5,1,4,5,7,5,1,4,5,7,7,1,5,7,7,5,1,4,5,7,5,1,4,5,7,5,1,5,5,7,5,1,5,5,7,5,1,4,7,7,5,1,5,5,7,7,1,5,7,7,7,3,1,7,7,7,1,5,7,7,7,1,4,3],"a10":[7,0,0,0,0,7,7,2,1,7,7,7,0,6,4,7,7,1,5,6,7,7,1,4,7,7,7,1,5,7,7,6,1,5,6,7,7,2,2,4,7,7,2,3,7,7,7,1,3,7,7,7,1,5,7,7,6,1,5,5,7,3,2,3,3,7,4,1,5,1,7,3,2,2,2,7,7,1,5,7,7,7,1,4,7,7,7,1,4,7,7,7,1,4,7,7,7,0,5,7,7,7,1,5,7,7,7,1,4,7,7,7,1,4,7,7,7,1,4,7,7,7,1,5,7,7,7,1,4,7,7,6,2,2,5,7,7,2,3,7,7,7,1,5,7,7,5,1,5,3,7,7,1,5,7,7,7,1,5,7,7,7,1,4,7,7,7,0,6,7,7,7,1,4,7,7,7,1,5,7,7,7,1,4,7,7,7,1,5,7,7,7,1,5,7,7,7,1,4,7,7,7,1,4,7,7,7,1,5,7,7,7,1,4,7,7,7,1,5,7,7,7,1,5,7,7,7,1,4,7,7,7,1,4,7,7,7,1,4,7,7,7,1,4,7,7,7,1,4,7,7,7,1,4,7,7,7,1,4,7,7,7,1,4,7,7,7,1,4,7,7,7,1,4,7,7,7,1,4,7,7,7,1,5,7,7,7,1,4,7,7,7,0,6,7,7,7,1,5,7,7,7,1,5,7,7,7,0,5,7,7,6,0,6,5,7,0,1,5,1,7,7,1,4,4,7,5,1,4,5,7,7,1,4,7,7,5,1,5,5,7,7,1,4,7,7,5,1,4,5,7,7,1,5,7,7,5,1,4,7,7,7,1,4,7,7,7,1,4,7,7,7,1,4,9,7,7,1,5,7,7,7,1,4,7,7,5,1,4,5,7,5,1,4,5,7,5,1,4,5,7,5,1,4,7,7,5,1,4,7,7,5,1,4,5,7,5,1,4,5,7,7,1,5,7,7,5,1,4,5,7,5,1,4,5,7,5,1,5,5,7,5,1,5,5,7,5,1,4,7,7,5,1,5,5,7,7,1,5,7,7,7,3,1,7,7,7,1,5,7,7,7,1,4,3],"m12":[8,0,0,0,0,8,8,3,1,8,8,8,1,6,4,8,8,0,7,7,8,8,1,5,8,8,8,1,5,8,8,7,1,6,7,8,8,3,2,5,8,8,3,3,8,8,8,2,3,8,8,8,1,5,8,8,8,0,7,7,8,4,2,3,4,8,4,1,6,1,8,3,3,2,2,8,8,1,6,8,8,8,1,5,8,8,8,1,5,8,8,8,1,5,8,8,8,0,6,8,8,8,1,6,8,8,8,0,6,8,8,8,1,5,8,8,8,0,6,8,8,8,1,5,8,8,8,1,5,8,8,7,3,2,6,8,8,2,3,8,8,8,1,6,8,8,6,1,6,3,8,8,1,6,8,8,8,0,7,8,8,8,1,5,8,8,8,1,6,8,8,8,1,5,8,8,8,1,6,8,8,8,0,6,8,8,8,1,6,8,8,8,1,6,8,8,8,1,6,8,8,8,1,5,8,8,8,0,7,8,8,8,2,4,8,8,8,1,5,8,8,8,1,6,8,8,8,1,5,8,8,8,1,5,8,8,8,1,5,8,8,8,1,5,8,8,8,1,5,8,8,8,1,5,8,8,8,1,5,8,8,8,1,5,8,8,8,1,5,8,8,8,1,5,8,8,8,1,5,8,8,8,1,6,8,8,8,1,5,8,8,8,1,6,8,8,8,1,6,8,8,8,1,6,8,8,8,1,5,8,8,7,1,6,6,8,0,1,6,1,8,8,1,5,4,8,6,1,5,6,8,8,1,5,8,8,6,1,6,6,8,8,1,5,8,8,6,1,5,6,8,8,1,6,8,8,6,1,5,8,8,8,1,5,8,8,8,2,4,8,8,8,1,5,10,8,8,1,6,8,8,8,2,5,8,8,6,1,5,6,8,6,1,5,6,8,6,1,5,6,8,6,1,5,8,8,6,1,5,8,8,6,1,5,6,8,6,1,5,6,8,8,0,7,8,8,6,1,5,6,8,6,1,5,6,8,6,1,6,6,8,6,1,6,6,8,6,1,5,8,8,6,1,6,6,8,8,0,7,8,8,8,3,1,8,8,8,0,7,8,8,8,1,5,3],"a12":[8,0,0,0,0,8,8,3,2,8,8,8,1,6,4,8,8,0,7,7,8,8,1,6,8,8,8,1,6,8,8,8,1,6,8,8,8,2,3,5,8,8,2,4,8,8,8,2,3,8,8,8,1,5,8,8,8,0,7,7,8,4,2,4,4,8,5,1,6,2,8,4,2,3,3,8,8,1,6,8,8,8,1,6,8,8,8,1,6,8,8,8,1,6,8,8,8,0,7,8,8,8,1,6,8,8,8,0,7,8,8,8,0,7,8,8,8,0,7,8,8,8,1,6,8,8,8,1,6,8,8,8,2,3,7,8,8,2,4,8,8,8,1,6,8,8,6,1,6,4,8,8,1,6,8,8,8,0,7,8,8,8,1,6,8,8,8,1,6,8,8,8,1,6,8,8,8,1,6,8,8,8,0,7,8,8,8,1,6,8,8,8,1,6,8,8,8,1,6,8,8,8,1,6,8,8,8,0,7,8,8,8,1,5,8,8,8,1,5,8,8,8,1,6,8,8,8,1,6,8,8,8,1,6,8,8,8,1,6,8,8,8,1,6,8,8,8,1,6,8,8,8,1,6,8,8,8,1,6,8,8,8,1,6,8,8,8,1,6,8,8,8,1,6,8,8,8,1,6,8,8,8,1,6,8,8,8,1,6,8,8,8,1,6,8,8,8,1,6,8,8,8,1,6,8,8,8,1,6,8,8,7,1,6,6,8,0,1,6,2,8,8,1,5,4,8,6,1,6,6,8,8,1,6,8,8,6,1,6,6,8,8,1,6,8,8,6,1,6,6,8,8,1,6,8,8,6,1,6,8,8,8,1,6,8,8,9,2,4,9,8,9,1,6,11,8,8,1,6,8,8,8,2,5,8,8,6,1,6,6,8,6,1,6,6,8,6,1,6,6,8,7,1,6,9,8,6,1,6,8,8,6,1,6,6,8,6,1,6,6,8,8,0,7,8,8,6,1,6,6,8,6,1,6,6,8,6,1,6,6,8,6,1,6,6,8,6,1,6,8,8,6,1,6,6,8,8,0,7,8,8,8,3,2,8,8,8,0,7,8,8,8,1,6,4],"m16":[10,0,0,0,0,10,11,4,2,11,10,11,1,8,5,10,11,1,8,10,10,11,2,6,11,10,11,2,7,11,10,10,2,7,10,10,11,4,3,7,10,11,4,4,11,10,11,2,4,11,10,10,1,7,9,10,9,1,7,7,10,5,3,4,5,10,6,1,8,2,10,5,4,3,3,10,11,1,8,11,10,11,2,6,11,10,11,2,6,11,10,11,2,6,11,10,11,1,7,11,10,11,2,6,11,10,11,1,7,11,10,11,2,6,11,10,11,1,7,11,10,11,2,6,11,10,11,2,7,11,10,10,4,3,8,10,10,3,4,10,10,10,1,8,9,10,8,1,8,4,10,10,1,8,9,10,11,1,8,11,10,11,2,6,11,10,11,1,8,11,10,11,2,6,11,10,11,2,7,11,10,11,1,7,11,10,11,2,7,11,10,11,2,7,11,10,11,2,6,11,10,11,2,6,11,10,11,1,7,11,10,11,2,6,11,10,11,2,7,11,10,11,2,7,11,10,11,2,6,11,10,11,2,6,11,10,11,2,6,11,10,11,2,6,11,10,11,2,6,11,10,11,2,6,11,10,11,2,6,11,10,11,2,6,11,10,11,2,6,11,10,11,2,6,11,10,11,2,6,11,10,11,1,8,11,10,11,2,6,11,10,11,1,8,11,10,11,2,7,11,10,11,1,8,11,10,11,1,7,11,10,9,1,8,8,10,0,1,8,1,10,11,2,6,6,10,8,2,6,8,10,11,2,6,11,10,8,2,7,8,10,11,2,6,11,10,8,2,6,8,10,11,1,7,11,10,8,2,6,11,10,11,2,6,11,10,11,2,7,11,10,11,2,6,14,10,11,2,7,11,10,11,2,7,11,10,8,2,6,8,10,8,2,6,8,10,8,2,6,8,10,8,2,6,11,10,8,2,6,11,10,8,2,6,8,10,8,2,6,8,10,11,1,8,11,10,8,2,6,8,10,8,2,6,8,10,8,2,6,8,10,8,1,8,8,10,8,2,6,11,10,8,1,8,8,10,11,1,7,11,10,11,4,1,11,10,11,1,7,11,10,11,2,6,5],"a16":[10,0,0,0,0,10,11,4,3,11,10,11,1,8,6,10,11,1,8,10,10,11,1,8,11,10,11,2,7,11,10,10,1,8,10,10,11,4,3,7,10,11,3,5,11,10,11,2,5,11,10,10,1,7,9,10,9,1,7,8,10,5,3,4,5,10,7,1,8,3,10,5,4,3,3,10,11,1,8,11,10,11,1,8,11,10,11,2,7,11,10,11,1,8,11,10,11,1,8,11,10,11,2,6,11,10,11,1,8,11,10,11,1,8,11,10,11,1,8,11,10,11,1,8,11,10,11,1,8,11,10,10,4,3,8,10,10,3,4,10,10,10,1,8,9,10,8,1,8,5,10,10,1,8,9,10,11,1,8,11,10,11,1,8,11,10,11,1,8,11,10,11,1,8,11,10,11,1,8,11,10,11,1,8,11,10,11,1,8,11,10,11,1,8,11,10,11,1,8,11,10,11,1,8,11,10,11,1,7,11,10,11,2,6,11,10,11,1,8,11,10,11,1,8,11,10,11,1,8,11,10,11,1,8,11,10,11,1,8,11,10,11,1,8,11,10,11,1,8,11,10,11,1,8,11,10,11,1,8,11,10,11,1,8,11,10,11,1,8,11,10,11,1,8,11,10,11,1,8,11,10,11,1,8,11,10,11,1,8,11,10,11,1,8,11,10,11,1,8,11,10,11,1,8,11,10,11,1,8,11,10,9,1,8,8,10,0,1,8,2,10,11,2,6,6,10,8,1,8,8,10,11,1,8,11,10,8,1,8,8,10,11,1,8,11,10,8,1,8,8,10,11,1,7,11,10,8,1,8,11,10,11,1,8,11,10,11,2,7,11,10,11,2,7,14,10,11,1,8,11,10,11,2,7,11,10,8,1,8,8,10,8,1,8,8,10,8,1,8,8,10,9,1,8,12,10,8,1,8,11,10,8,1,8,8,10,8,1,8,8,10,11,1,8,11,10,8,1,8,8,10,8,1,8,8,10,8,1,8,8,10,8,1,8,8,10,8,1,8,11,10,8,1,8,8,10,11,1,7,11,10,11,4,2,11,10,11,1,7,11,10,11,1,8,5],"m18":[12,0,0,0,0,12,13,5,2,13,12,13,1,9,7,12,13,1,9,11,12,13,2,8,13,12,13,2,8,13,12,12,2,8,12,12,13,4,3,8,12,13,4,5,13,12,13,3,5,13,12,12,2,8,11,12,11,1,10,10,12,6,3,5,6,12,7,1,9,2,12,5,4,3,3,12,13,1,9,13,12,13,2,8,13,12,13,2,8,13,12,13,2,8,13,12,13,1,9,13,12,13,2,8,13,12,13,1,9,13,12,13,2,8,13,12,13,1,9,13,12,13,2,8,13,12,13,2,8,13,12,11,4,3,9,12,11,3,5,11,12,12,1,9,11,12,9,1,9,5,12,12,1,9,11,12,13,1,9,13,12,13,2,8,13,12,13,1,9,13,12,13,2,8,13,12,13,2,9,13,12,13,1,9,13,12,13,2,9,13,12,13,2,9,13,12,13,2,8,13,12,13,2,8,13,12,13,1,10,13,12,13,2,7,13,12,13,2,8,13,12,13,2,9,13,12,13,2,8,13,12,13,2,8,13,12,13,2,8,13,12,13,2,8,13,12,13,2,8,13,12,13,2,8,13,12,13,2,8,13,12,13,2,8,13,12,13,2,8,13,12,13,2,8,13,12,13,2,8,13,12,13,1,9,13,12,13,2,8,13,12,13,1,9,13,12,13,2,8,13,12,13,1,9,13,12,13,2,8,13,12,10,1,9,8,12,0,1,9,2,12,13,2,7,6,12,9,2,8,9,12,13,2,8,13,12,9,2,9,9,12,13,2,8,13,12,9,2,8,9,12,13,2,8,13,12,9,2,8,12,12,13,2,8,13,12,13,3,7,13,12,13,2,7,16,12,13,2,9,13,12,13,3,7,13,12,9,2,8,9,12,9,2,8,9,12,9,2,8,9,12,10,2,8,13,12,9,2,8,12,12,9,2,8,9,12,9,2,8,9,12,12,1,9,12,12,9,2,8,9,12,9,2,8,9,12,9,2,8,9,12,9,1,9,9,12,9,2,8,12,12,9,1,9,9,12,13,1,10,13,12,13,5,2,13,12,13,1,10,13,12,13,2,8,6],"a18":[12,0,0,0,0,12,13,4,3,13,12,13,1,9,6,12,13,1,9,11,12,13,2,8,13,12,13,2,8,13,12,12,2,8,12,12,13,4,3,8,12,13,4,5,13,12,13,3,5,13,12,12,2,8,11,12,11,1,9,10,12,6,3,5,6,12,7,1,9,3,12,5,4,3,3,12,13,1,9,13,12,13,2,8,13,12,13,2,8,13,12,13,2,8,13,12,13,1,9,13,12,13,2,8,13,12,13,1,9,13,12,13,1,9,13,12,13,1,9,13,12,13,2,8,13,12,13,2,8,13,12,11,4,3,9,12,11,3,5,11,12,12,1,9,11,12,9,1,9,5,12,12,1,9,11,12,13,1,9,13,12,13,2,8,13,12,13,1,9,13,12,13,2,8,13,12,13,2,9,13,12,13,1,9,13,12,13,2,9,13,12,13,2,9,13,12,13,2,8,13,12,13,2,8,13,12,13,1,9,13,12,13,2,7,13,12,13,2,8,13,12,13,2,9,13,12,13,2,8,13,12,13,2,8,13,12,13,2,8,13,12,13,2,8,13,12,13,2,8,13,12,13,2,8,13,12,13,2,8,13,12,13,2,8,13,12,13,2,8,13,12,13,2,8,13,12,13,2,8,13,12,13,1,9,13,12,13,2,8,13,12,13,1,9,13,12,13,2,8,13,12,13,1,9,13,12,13,2,8,13,12,10,1,9,8,12,0,1,9,2,12,13,2,7,6,12,9,2,8,9,12,13,2,8,13,12,9,2,9,9,12,13,2,8,13,12,9,2,8,9,12,13,2,8,13,12,9,2,8,12,12,13,2,8,13,12,14,3,7,14,12,14,2,7,17,12,13,2,9,13,12,13,3,7,13,12,9,2,8,9,12,9,2,8,9,12,9,2,8,9,12,10,2,8,13,12,9,2,8,12,12,9,2,8,9,12,9,2,8,9,12,12,1,9,12,12,9,2,8,9,12,9,2,8,9,12,9,2,8,9,12,9,1,9,9,12,9,2,8,12,12,9,1,9,9,12,13,1,9,13,12,13,5,2,13,12,13,1,9,13,12,13,2,8,6],"m20":[13,0,0,0,0,13,14,5,3,14,13,14,1,10,7,13,14,2,9,13,13,14,2,9,14,13,14,2,9,14,13,13,2,9,13,13,14,5,4,8,13,14,5,5,14,13,14,3,5,14,13,13,1,10,12,13,12,1,10,10,13,7,4,5,7,13,8,2,9,3,13,5,5,4,3,13,14,2,9,14,13,14,2,9,14,13,14,2,9,14,13,14,2,9,14,13,14,2,9,14,13,14,2,9,14,13,14,2,9,14,13,14,2,9,14,13,14,1,10,14,13,14,2,9,14,13,14,2,9,14,13,11,5,4,9,13,12,4,6,12,13,13,2,9,12,13,10,2,9,5,13,13,2,9,12,13,14,2,10,14,13,14,2,9,14,13,14,1,10,14,13,14,2,9,14,13,14,2,9,14,13,14,2,9,14,13,14,2,9,14,13,14,2,9,14,13,14,2,8,14,13,14,2,9,14,13,14,1,10,14,13,14,3,7,14,13,14,2,9,14,13,14,2,9,14,13,14,2,9,14,13,14,2,9,14,13,14,2,9,14,13,14,2,9,14,13,14,2,9,14,13,14,2,9,14,13,14,2,9,14,13,14,2,9,14,13,14,2,9,14,13,14,2,9,14,13,14,2,9,14,13,14,2,9,14,13,14,2,9,14,13,14,1,10,14,13,14,2,10,14,13,14,2,9,14,13,14,1,10,14,13,11,1,10,9,13,0,2,9,2,13,14,2,8,7,13,10,2,9,10,13,14,2,9,14,13,10,2,9,10,13,14,2,9,14,13,10,2,9,10,13,14,2,9,14,13,10,2,9,14,13,14,2,9,14,13,15,3,7,15,13,15,3,7,19,13,14,2,9,14,13,14,3,7,14,13,10,2,9,10,13,10,2,9,10,13,10,2,9,10,13,11,2,9,15,13,10,2,9,14,13,10,2,9,10,13,10,2,9,10,13,14,2,10,14,13,10,2,9,10,13,10,2,9,10,13,10,2,9,10,13,10,2,9,10,13,10,2,9,14,13,10,2,9,10,13,14,1,10,14,13,14,5,2,14,13,14,1,10,14,13,14,2,9,6],"a20":[13,0,0,0,0,13,14,5,3,14,13,14,1,10,7,13,14,2,9,12,13,14,2,9,14,13,14,2,9,14,13,13,2,9,13,13,14,5,4,8,13,14,5,5,14,13,14,3,5,14,13,13,1,10,12,13,12,1,10,10,13,7,4,5,7,13,8,2,9,3,13,5,5,4,3,13,14,2,9,14,13,14,2,9,14,13,14,2,9,14,13,14,2,9,14,13,14,2,9,14,13,14,2,9,14,13,14,2,9,14,13,14,2,9,14,13,14,1,10,14,13,14,2,9,14,13,14,2,9,14,13,11,5,4,9,13,12,4,6,12,13,13,2,9,12,13,10,2,9,5,13,13,2,9,12,13,14,2,10,14,13,14,2,9,14,13,14,1,10,14,13,14,2,9,14,13,14,2,9,14,13,14,2,9,14,13,14,2,9,14,13,14,2,9,14,13,14,2,8,14,13,14,2,9,14,13,14,1,10,14,13,14,3,7,14,13,14,2,9,14,13,14,2,9,14,13,14,2,9,14,13,14,2,9,14,13,14,2,9,14,13,14,2,9,14,13,14,2,9,14,13,14,2,9,14,13,14,2,9,14,13,14,2,9,14,13,14,2,9,14,13,14,2,9,14,13,14,2,9,14,13,14,2,9,14,13,14,2,9,14,13,14,1,10,14,13,14,2,10,14,13,14,2,9,14,13,14,1,10,14,13,11,1,10,9,13,0,2,9,2,13,14,2,8,7,13,10,2,9,10,13,14,2,9,14,13,10,2,9,10,13,14,2,9,14,13,10,2,9,10,13,14,2,9,14,13,10,2,9,14,13,14,2,9,14,13,15,3,7,15,13,15,3,7,19,13,14,2,9,14,13,14,3,7,14,13,10,2,9,10,13,10,2,9,10,13,10,2,9,10,13,11,2,9,15,13,10,2,9,14,13,10,2,9,10,13,10,2,9,10,13,14,2,10,14,13,10,2,9,10,13,10,2,9,10,13,10,2,9,10,13,10,2,9,10,13,10,2,9,14,13,10,2,9,10,13,14,1,10,14,13,14,5,2,14,13,14,1,10,14,13,14,2,9,6],"m24":[16,0,0,0,0,16,17,6,3,17,16,17,2,11,8,16,17,2,12,15,16,17,2,11,17,16,17,2,11,17,16,15,2,12,15,16,17,6,4,10,16,17,6,6,17,16,17,4,6,17,16,15,2,12,14,16,14,2,12,12,16,8,4,6,8,16,9,2,11,3,16,7,6,4,4,16,17,2,11,17,16,17,2,11,17,16,17,2,11,17,16,17,2,11,17,16,17,2,11,17,16,17,3,10,17,16,17,2,11,17,16,17,2,11,17,16,17,2,11,17,16,17,2,11,17,16,17,2,11,17,16,14,6,4,11,16,15,4,6,15,16,15,2,11,14,16,12,2,11,6,16,15,2,11,14,16,17,2,12,17,16,17,2,11,17,16,17,2,11,17,16,17,2,11,17,16,17,2,11,17,16,17,2,11,17,16,17,2,11,17,16,17,2,11,17,16,17,2,11,17,16,17,2,11,17,16,17,2,12,17,16,17,3,9,17,16,17,2,11,17,16,17,2,11,17,16,17,2,11,17,16,17,2,11,17,16,17,2,11,17,16,17,2,11,17,16,17,2,11,17,16,17,2,11,17,16,17,2,11,17,16,17,2,11,17,16,17,2,11,17,16,17,2,11,17,16,17,2,11,17,16,17,2,11,17,16,17,2,11,17,16,17,2,11,17,16,17,2,12,17,16,17,2,11,17,16,17,2,11,17,16,14,2,11,12,16,0,2,11,2,16,17,3,9,8,16,12,2,11,12,16,17,2,11,17,16,12,2,11,12,16,17,2,11,17,16,12,2,11,12,16,17,2,11,17,16,12,2,11,17,16,17,2,11,17,16,18,3,9,18,16,18,3,9,23,16,17,2,11,17,16,17,3,9,17,16,12,2,11,12,16,12,2,11,12,16,12,2,11,12,16,13,2,11,18,16,12,2,11,17,16,12,2,11,12,16,12,3,10,12,16,16,2,12,16,16,12,2,11,12,16,12,2,11,12,16,12,2,11,12,16,12,2,11,12,16,12,2,11,17,16,12,2,11,12,16,17,2,12,17,16,17,7,2,17,16,17,2,12,17,16,17,2,11,8],"a24":[16,0,0,0,0,16,17,6,3,17,16,17,2,11,8,16,17,2,12,15,16,17,2,11,17,16,17,2,11,17,16,15,2,12,15,16,17,5,5,10,16,17,5,7,17,16,17,4,6,17,16,15,2,12,14,16,14,2,12,12,16,8,4,7,8,16,9,2,11,3,16,7,6,4,4,16,17,2,11,17,16,17,2,11,17,16,17,2,11,17,16,17,2,11,17,16,17,2,11,17,16,17,2,11,17,16,17,2,11,17,16,17,1,12,17,16,17,2,11,17,16,17,2,12,17,16,17,2,12,17,16,14,6,4,11,16,15,4,7,15,16,15,2,11,14,16,12,2,11,7,16,15,2,11,14,16,17,2,12,17,16,17,2,11,17,16,17,2,11,17,16,17,2,11,17,16,17,2,11,17,16,17,2,11,17,16,17,2,11,17,16,17,2,11,17,16,17,2,12,17,16,17,2,11,17,16,17,2,12,17,16,17,3,9,17,16,17,2,11,17,16,17,2,11,17,16,17,2,11,17,16,17,2,11,17,16,17,2,11,17,16,17,2,11,17,16,17,2,11,17,16,17,2,11,17,16,17,2,11,17,16,17,2,11,17,16,17,2,11,17,16,17,2,11,17,16,17,2,11,17,16,17,2,11,17,16,17,2,11,17,16,17,2,11,17,16,17,2,12,17,16,17,2,11,17,16,17,2,11,17,16,14,2,11,12,16,0,2,11,3,16,17,3,9,8,16,12,2,12,12,16,17,2,11,17,16,12,2,11,12,16,17,2,11,17,16,12,2,11,12,16,17,2,11,17,16,12,2,11,17,16,17,2,11,17,16,18,3,9,18,16,18,3,10,23,16,17,2,11,17,16,17,3,9,17,16,12,2,12,12,16,12,2,11,12,16,12,2,11,12,16,13,2,11,18,16,12,2,11,17,16,12,2,11,12,16,12,2,11,12,16,16,2,12,16,16,12,2,11,12,16,12,2,11,12,16,12,2,12,12,16,12,2,11,12,16,12,2,11,17,16,12,2,11,12,16,17,2,12,17,16,17,6,3,17,16,17,2,12,17,16,17,2,11,8],"m27":[18,0,0,0,0,18,19,7,4,19,18,19,2,13,9,18,19,2,13,17,18,19,3,11,19,18,19,3,12,19,18,17,3,12,17,18,19,6,5,11,18,19,6,6,19,18,19,5,6,19,18,17,3,12,15,18,15,3,12,12,18,8,5,7,8,18,11,2,13,4,18,8,6,5,5,18,19,2,13,19,18,19,3,11,19,18,19,3,11,19,18,19,3,11,19,18,19,2,12,19,18,19,3,12,19,18,19,2,12,19,18,19,3,11,19,18,19,3,11,19,18,19,3,11,19,18,19,3,12,19,18,16,6,5,13,18,17,5,7,17,18,17,2,13,15,18,14,2,13,8,18,17,2,13,15,18,19,2,13,19,18,19,3,11,19,18,19,2,13,19,18,19,3,11,19,18,19,3,12,19,18,19,2,12,19,18,19,3,12,19,18,19,3,12,19,18,19,3,12,19,18,19,3,11,19,18,19,3,12,19,18,19,4,9,19,18,19,3,12,19,18,19,3,12,19,18,19,3,11,19,18,19,3,11,19,18,19,3,11,19,18,19,3,11,19,18,19,3,11,19,18,19,3,11,19,18,19,3,11,19,18,19,3,11,19,18,19,3,11,19,18,19,3,11,19,18,19,3,11,19,18,19,2,13,19,18,19,3,11,19,18,19,2,13,19,18,19,3,12,19,18,19,2,13,19,18,19,2,12,19,18,15,2,13,12,18,0,2,13,2,18,19,3,11,9,18,14,3,11,14,18,19,3,11,19,18,14,3,12,14,18,19,3,11,19,18,14,3,11,14,18,19,3,12,19,18,14,3,11,19,18,19,3,11,19,18,20,4,10,20,18,20,3,10,25,18,19,3,12,19,18,19,4,10,19,18,14,3,11,14,18,14,3,11,14,18,14,3,11,14,18,14,3,11,19,18,14,3,11,19,18,14,3,11,14,18,14,3,11,14,18,19,2,13,19,18,14,3,11,14,18,14,3,11,14,18,14,3,12,14,18,14,2,13,14,18,14,3,11,19,18,14,2,13,14,18,19,3,12,19,18,19,8,2,19,18,19,3,12,19,18,19,3,11,9],"a27":[18,0,0,0,0,18,19,7,4,19,18,19,2,13,9,18,19,2,13,17,18,19,2,13,19,18,19,3,12,19,18,17,2,13,17,18,19,6,5,11,18,19,6,6,19,18,19,5,6,19,18,17,3,12,15,18,15,3,12,12,18,9,5,7,9,18,11,2,13,4,18,8,6,5,5,18,19,2,13,19,18,19,2,13,19,18,19,3,12,19,18,19,2,13,19,18,19,2,13,19,18,19,3,12,19,18,19,2,13,19,18,19,3,12,19,18,19,3,12,19,18,19,2,13,19,18,19,2,13,19,18,16,6,5,13,18,17,5,7,17,18,17,2,13,15,18,14,2,13,8,18,17,2,13,15,18,19,2,13,19,18,19,2,13,19,18,19,2,13,19,18,19,2,13,19,18,19,2,13,19,18,19,2,13,19,18,19,2,13,19,18,19,2,13,19,18,19,2,13,19,18,19,2,13,19,18,19,3,12,19,18,19,4,10,19,18,19,2,13,19,18,19,2,13,19,18,19,2,13,19,18,19,2,13,19,18,19,2,13,19,18,19,2,13,19,18,19,2,13,19,18,19,2,13,19,18,19,2,13,19,18,19,2,13,19,18,19,2,13,19,18,19,2,13,19,18,19,2,13,19,18,19,2,13,19,18,19,2,13,19,18,19,2,13,19,18,19,2,13,19,18,19,2,13,19,18,19,2,13,19,18,15,2,13,12,18,0,2,13,3,18,19,3,11,9,18,14,2,13,14,18,19,2,13,19,18,14,2,13,14,18,19,2,13,19,18,14,2,13,14,18,19,3,12,19,18,14,2,13,19,18,19,2,13,19,18,20,4,10,20,18,20,3,10,25,18,19,2,13,19,18,19,4,10,19,18,14,2,13,14,18,14,2,13,14,18,14,2,13,14,18,14,2,13,19,18,14,2,13,19,18,14,2,13,14,18,14,3,12,14,18,19,2,13,19,18,14,2,13,14,18,14,2,13,14,18,14,2,13,14,18,14,2,13,14,18,14,2,13,19,18,14,2,13,14,18,19,3,12,19,18,19,7,3,19,18,19,3,12,19,18,19,2,13,9],"m30":[20,0,0,0,0,20,21,8,4,21,20,21,2,15,10,20,21,3,14,18,20,21,3,13,21,20,21,3,13,21,20,19,3,14,19,20,21,7,5,12,20,21,7,7,21,20,21,5,7,21,20,19,2,15,17,20,18,2,15,15,20,10,6,8,10,20,12,2,15,4,20,8,7,5,5,20,21,2,15,21,20,21,3,13,21,20,21,3,13,21,20,21,3,13,21,20,21,2,14,21,20,21,4,12,21,20,21,3,13,21,20,21,3,13,21,20,21,2,14,21,20,21,3,14,21,20,21,3,13,21,20,18,7,5,15,20,19,6,8,19,20,19,2,15,17,20,15,2,15,8,20,19,2,15,17,20,21,3,14,21,20,21,3,13,21,20,21,2,15,21,20,21,3,13,21,20,21,3,14,21,20,21,3,13,21,20,21,3,14,21,20,21,3,14,21,20,21,3,14,21,20,21,3,13,21,20,21,2,15,21,20,21,4,11,21,20,21,3,14,21,20,21,3,14,21,20,21,3,13,21,20,21,3,13,21,20,21,3,13,21,20,21,3,13,21,20,21,3,13,21,20,21,3,13,21,20,21,3,13,21,20,21,3,13,21,20,21,3,13,21,20,21,3,13,21,20,21,3,13,21,20,21,2,15,21,20,21,3,13,21,20,21,2,15,21,20,21,3,14,21,20,21,2,15,21,20,21,2,14,21,20,17,2,15,14,20,0,2,15,3,20,21,4,11,10,20,15,3,13,15,20,21,3,13,21,20,15,3,14,15,20,21,3,13,21,20,15,3,13,15,20,21,3,13,21,20,15,3,13,21,20,21,3,13,21,20,22,4,11,22,20,22,4,11,28,20,21,3,14,21,20,21,4,11,21,20,15,3,13,15,20,15,3,13,15,20,15,3,13,15,20,16,3,13,22,20,15,3,13,21,20,15,3,13,15,20,15,3,13,15,20,20,3,14,20,20,15,3,13,15,20,15,3,13,15,20,15,3,14,15,20,15,2,15,15,20,15,3,13,21,20,15,2,15,15,20,21,2,15,21,20,21,8,3,21,20,21,2,15,21,20,21,3,13,10],"a30":[20,0,0,0,0,20,21,8,4,21,20,21,2,15,10,20,21,3,14,18,20,21,3,13,21,20,21,3,13,21,20,19,3,14,19,20,21,7,5,12,20,21,7,7,21,20,21,5,7,21,20,19,2,15,17,20,18,2,15,15,20,10,6,8,10,20,12,2,15,4,20,8,7,5,5,20,21,2,15,21,20,21,3,13,21,20,21,3,13,21,20,21,3,13,21,20,21,2,14,21,20,21,4,12,21,20,21,3,13,21,20,21,3,13,21,20,21,2,14,21,20,21,3,14,21,20,21,3,13,21,20,18,7,5,15,20,19,6,8,19,20,19,2,15,17,20,15,2,15,8,20,19,2,15,17,20,21,3,14,21,20,21,3,13,21,20,21,2,15,21,20,21,3,13,21,20,21,3,14,21,20,21,3,13,21,20,21,3,14,21,20,21,3,14,21,20,21,3,14,21,20,21,3,13,21,20,21,2,15,21,20,21,4,11,21,20,21,3,14,21,20,21,3,14,21,20,21,3,13,21,20,21,3,13,21,20,21,3,13,21,20,21,3,13,21,20,21,3,13,21,20,21,3,13,21,20,21,3,13,21,20,21,3,13,21,20,21,3,13,21,20,21,3,13,21,20,21,3,13,21,20,21,2,15,21,20,21,3,13,21,20,21,2,15,21,20,21,3,14,21,20,21,2,15,21,20,21,2,14,21,20,17,2,15,14,20,0,2,15,3,20,21,4,11,10,20,15,3,13,15,20,21,3,13,21,20,15,3,14,15,20,21,3,13,21,20,15,3,13,15,20,21,3,13,21,20,15,3,13,21,20,21,3,13,21,20,22,4,11,22,20,22,4,11,28,20,21,3,14,21,20,21,4,11,21,20,15,3,14,15,20,15,3,13,15,20,15,3,13,15,20,16,3,13,22,20,15,3,13,21,20,15,3,13,15,20,15,3,13,15,20,20,3,14,20,20,15,3,13,15,20,15,3,13,15,20,15,3,14,15,20,15,2,15,15,20,15,3,13,21,20,15,2,15,15,20,21,2,15,21,20,21,8,3,21,20,21,2,15,21,20,21,3,13,10],"m32":[21,0,0,0,0,21,22,8,4,22,21,22,3,15,11,21,22,3,15,18,21,22,3,14,22,21,22,3,15,22,21,20,3,15,20,21,22,7,6,13,21,22,7,8,22,21,22,5,8,22,21,21,3,15,19,21,19,3,15,15,21,10,6,8,10,21,13,3,15,4,21,9,7,6,5,21,22,3,15,22,21,22,3,14,22,21,22,3,14,22,21,22,3,14,22,21,22,2,15,22,21,22,4,13,22,21,22,3,14,22,21,22,3,14,22,21,22,3,14,22,21,22,3,15,22,21,22,3,14,22,21,18,7,6,14,21,20,6,9,20,21,21,3,15,19,21,16,3,15,9,21,21,3,15,19,21,22,3,15,22,21,22,3,14,22,21,22,3,15,22,21,22,3,14,22,21,22,3,15,22,21,22,3,14,22,21,22,3,15,22,21,22,3,15,22,21,22,3,14,22,21,22,3,14,22,21,22,3,15,22,21,22,5,11,22,21,22,3,15,22,21,22,3,15,22,21,22,3,14,22,21,22,3,14,22,21,22,3,14,22,21,22,3,14,22,21,22,3,14,22,21,22,3,14,22,21,22,3,14,22,21,22,3,14,22,21,22,3,14,22,21,22,3,14,22,21,22,3,14,22,21,22,3,15,22,21,22,3,14,22,21,22,3,15,22,21,22,3,15,22,21,22,3,15,22,21,22,3,14,22,21,18,3,15,15,21,0,3,15,3,21,22,4,12,11,21,16,3,14,16,21,22,3,14,22,21,16,3,15,16,21,22,3,14,22,21,16,3,14,16,21,22,4,13,22,21,16,3,14,22,21,22,3,14,22,21,24,5,12,24,21,24,4,11,30,21,22,3,15,22,21,22,5,12,22,21,16,3,14,16,21,16,3,14,16,21,16,3,14,16,21,17,3,14,23,21,16,3,14,22,21,16,3,14,16,21,16,3,14,16,21,21,3,15,21,21,16,3,14,16,21,16,3,14,16,21,16,3,15,16,21,16,3,15,16,21,16,3,14,22,21,16,3,15,16,21,22,3,15,22,21,22,9,3,22,21,22,3,15,22,21,22,3,14,10],"a32":[21,0,0,0,0,21,22,8,4,22,21,22,3,15,11,21,22,3,15,18,21,22,3,14,22,21,22,3,15,22,21,20,3,15,20,21,22,7,6,13,21,22,7,8,22,21,22,5,8,22,21,21,3,15,19,21,19,3,15,15,21,10,6,8,10,21,13,3,15,4,21,9,7,6,5,21,22,3,15,22,21,22,3,14,22,21,22,3,14,22,21,22,3,14,22,21,22,2,15,22,21,22,4,13,22,21,22,3,14,22,21,22,3,14,22,21,22,3,14,22,21,22,3,15,22,21,22,3,14,22,21,18,7,6,14,21,20,6,9,20,21,21,3,15,19,21,16,3,15,9,21,21,3,15,19,21,22,3,15,22,21,22,3,14,22,21,22,3,15,22,21,22,3,14,22,21,22,3,15,22,21,22,3,14,22,21,22,3,15,22,21,22,3,15,22,21,22,3,14,22,21,22,3,14,22,21,22,3,15,22,21,22,5,11,22,21,22,3,15,22,21,22,3,15,22,21,22,3,14,22,21,22,3,14,22,21,22,3,14,22,21,22,3,14,22,21,22,3,14,22,21,22,3,14,22,21,22,3,14,22,21,22,3,14,22,21,22,3,14,22,21,22,3,14,22,21,22,3,14,22,21,22,3,15,22,21,22,3,14,22,21,22,3,15,22,21,22,3,15,22,21,22,3,15,22,21,22,3,14,22,21,18,3,15,15,21,0,3,15,3,21,22,4,12,11,21,16,3,14,16,21,22,3,14,22,21,16,3,15,16,21,22,3,14,22,21,16,3,14,16,21,22,4,13,22,21,16,3,14,22,21,22,3,14,22,21,24,5,12,24,21,24,4,11,30,21,22,3,15,22,21,22,5,12,22,21,16,3,14,16,21,16,3,14,16,21,16,3,14,16,21,17,3,14,23,21,16,3,14,22,21,16,3,14,16,21,16,3,14,16,21,21,3,15,21,21,16,3,14,16,21,16,3,14,16,21,16,3,15,16,21,16,3,15,16,21,16,3,14,22,21,16,3,15,16,21,22,3,15,22,21,22,9,3,22,21,22,3,15,22,21,22,3,14,10],"m36":[23,0,0,0,0,23,25,9,5,25,23,25,3,17,12,23,25,3,17,21,23,25,4,15,25,23,25,4,15,25,23,22,4,16,22,23,25,8,6,15,23,25,8,8,25,23,25,6,8,25,23,23,3,17,21,23,21,3,17,17,23,11,7,9,11,23,15,3,17,5,23,10,8,6,6,23,25,3,17,25,23,25,4,15,25,23,25,4,15,25,23,25,4,15,25,23,25,3,16,25,23,25,4,15,25,23,25,3,16,25,23,25,4,15,25,23,25,3,16,25,23,25,4,15,25,23,25,4,16,25,23,21,8,6,17,23,22,7,9,22,23,23,3,17,21,23,18,3,17,10,23,23,3,17,21,23,25,3,17,25,23,25,4,15,25,23,25,3,17,25,23,25,4,15,25,23,25,4,16,25,23,25,3,16,25,23,25,4,16,25,23,25,4,16,25,23,25,4,15,25,23,25,4,15,25,23,25,3,17,25,23,25,5,13,25,23,25,4,16,25,23,25,4,16,25,23,25,4,15,25,23,25,4,15,25,23,25,4,15,25,23,25,4,15,25,23,25,4,15,25,23,25,4,15,25,23,25,4,15,25,23,25,4,15,25,23,25,4,15,25,23,25,4,15,25,23,25,4,15,25,23,25,3,17,25,23,25,4,15,25,23,25,3,17,25,23,25,4,15,25,23,25,3,17,25,23,25,3,16,25,23,20,3,17,16,23,0,3,17,3,23,25,5,13,12,23,18,4,15,18,23,25,4,15,25,23,18,4,16,18,23,25,4,15,25,23,18,4,15,18,23,25,3,15,25,23,18,4,15,25,23,25,4,15,25,23,27,5,13,27,23,27,4,14,34,23,25,4,16,25,23,25,5,13,25,23,18,3,16,18,23,18,4,15,18,23,18,4,15,18,23,19,4,15,26,23,18,4,15,25,23,18,4,15,18,23,18,4,15,18,23,24,3,17,24,23,18,4,15,18,23,18,4,15,18,23,18,3,17,18,23,18,3,17,18,23,18,4,15,25,23,18,3,17,18,23,25,3,17,25,23,25,10,3,25,23,25,3,17,25,23,25,4,15,11],"a36":[23,0,0,0,0,23,25,9,5,25,23,25,3,17,12,23,25,3,17,21,23,25,4,15,25,23,25,4,15,25,23,22,4,16,22,23,25,8,6,15,23,25,8,8,25,23,25,6,8,25,23,23,3,17,21,23,21,3,17,17,23,11,7,9,11,23,15,3,17,5,23,10,8,6,6,23,25,3,17,25,23,25,4,15,25,23,25,4,15,25,23,25,4,15,25,23,25,3,16,25,23,25,4,15,25,23,25,3,16,25,23,25,4,15,25,23,25,3,16,25,23,25,4,15,25,23,25,4,16,25,23,21,8,6,17,23,22,7,9,22,23,23,3,17,21,23,18,3,17,10,23,23,3,17,21,23,25,3,17,25,23,25,4,15,25,23,25,3,17,25,23,25,4,15,25,23,25,4,16,25,23,25,3,16,25,23,25,4,16,25,23,25,4,16,25,23,25,4,15,25,23,25,4,15,25,23,25,3,17,25,23,25,5,13,25,23,25,4,16,25,23,25,4,16,25,23,25,4,15,25,23,25,4,15,25,23,25,4,15,25,23,25,4,15,25,23,25,4,15,25,23,25,4,15,25,23,25,4,15,25,23,25,4,15,25,23,25,4,15,25,23,25,4,15,25,23,25,4,15,25,23,25,3,17,25,23,25,4,15,25,23,25,3,17,25,23,25,4,15,25,23,25,3,17,25,23,25,3,16,25,23,20,3,17,16,23,0,3,17,3,23,25,5,13,12,23,18,4,15,18,23,25,4,15,25,23,18,4,16,18,23,25,4,15,25,23,18,4,15,18,23,25,3,15,25,23,18,4,15,25,23,25,4,15,25,23,27,5,13,27,23,27,4,14,34,23,25,4,16,25,23,25,5,13,25,23,18,3,16,18,23,18,4,15,18,23,18,4,15,18,23,19,4,15,26,23,18,4,15,25,23,18,4,15,18,23,18,4,15,18,23,24,3,17,24,23,18,4,15,18,23,18,4,15,18,23,18,3,17,18,23,18,3,17,18,23,18,4,15,25,23,18,3,17,18,23,25,3,17,25,23,25,10,3,25,23,25,3,17,25,23,25,4,15,11],"m40":[26,0,0,0,0,26,28,10,5,28,26,28,3,19,14,26,28,3,19,24,26,28,4,18,28,26,28,4,17,28,26,25,4,18,25,26,28,9,7,16,26,28,9,10,28,26,28,7,10,28,26,26,4,19,23,26,24,4,19,20,26,13,7,11,13,26,16,3,19,5,26,12,9,7,7,26,28,3,19,28,26,28,4,18,28,26,28,4,18,28,26,28,4,18,28,26,28,4,18,28,26,28,5,16,28,26,28,3,19,28,26,28,4,18,28,26,28,4,18,28,26,28,4,18,28,26,28,4,18,28,26,24,9,7,19,26,25,7,11,25,26,26,3,19,23,26,20,3,19,11,26,26,3,19,23,26,28,3,19,28,26,28,4,18,28,26,28,3,19,28,26,28,4,18,28,26,28,4,18,28,26,28,3,19,28,26,28,4,18,28,26,28,4,18,28,26,28,4,18,28,26,28,4,18,28,26,28,4,19,28,26,28,6,14,28,26,28,4,18,28,26,28,4,18,28,26,28,4,18,28,26,28,4,18,28,26,28,4,18,28,26,28,4,18,28,26,28,4,18,28,26,28,4,18,28,26,28,4,18,28,26,28,4,18,28,26,28,4,18,28,26,28,4,18,28,26,28,4,18,28,26,28,3,19,28,26,28,4,18,28,26,28,3,19,28,26,28,4,18,28,26,28,3,19,28,26,28,4,18,28,26,22,3,19,18,26,0,3,19,4,26,28,5,15,13,26,20,4,18,20,26,28,4,18,28,26,20,4,18,20,26,28,4,18,28,26,20,4,18,20,26,28,4,17,28,26,20,4,18,28,26,28,4,18,28,26,29,6,15,29,26,29,5,15,37,26,28,4,18,28,26,28,6,15,28,26,20,4,19,20,26,20,4,18,20,26,20,4,18,20,26,22,4,18,30,26,20,4,18,28,26,20,4,18,20,26,20,4,18,20,26,27,3,19,27,26,20,4,18,20,26,20,4,18,20,26,20,4,18,20,26,20,3,19,20,26,20,4,18,28,26,20,3,19,20,26,28,4,19,28,26,28,11,4,28,26,28,4,19,28,26,28,4,18,13],"a40":[26,0,0,0,0,26,28,10,5,28,26,28,3,19,13,26,28,3,19,24,26,28,4,18,28,26,28,4,17,28,26,25,4,18,25,26,28,9,7,16,26,28,9,10,28,26,28,7,10,28,26,26,4,19,23,26,24,4,19,20,26,13,7,11,13,26,16,3,19,5,26,12,9,7,7,26,28,3,19,28,26,28,4,18,28,26,28,4,18,28,26,28,4,18,28,26,28,4,18,28,26,28,5,16,28,26,28,3,19,28,26,28,4,18,28,26,28,4,18,28,26,28,4,18,28,26,28,4,18,28,26,24,9,7,19,26,25,7,11,25,26,26,3,19,23,26,20,3,19,11,26,26,3,19,23,26,28,3,19,28,26,28,4,18,28,26,28,3,19,28,26,28,4,18,28,26,28,4,18,28,26,28,3,19,28,26,28,4,18,28,26,28,4,18,28,26,28,4,18,28,26,28,4,18,28,26,28,4,19,28,26,28,6,14,28,26,28,4,18,28,26,28,4,18,28,26,28,4,18,28,26,28,4,18,28,26,28,4,18,28,26,28,4,18,28,26,28,4,18,28,26,28,4,18,28,26,28,4,18,28,26,28,4,18,28,26,28,4,18,28,26,28,4,18,28,26,28,4,18,28,26,28,3,19,28,26,28,4,18,28,26,28,3,19,28,26,28,4,18,28,26,28,3,19,28,26,28,4,18,28,26,22,3,19,18,26,0,3,19,4,26,28,5,15,13,26,20,4,18,20,26,28,4,18,28,26,20,4,18,20,26,28,4,18,28,26,20,4,18,20,26,28,4,17,28,26,20,4,18,28,26,28,4,18,28,26,29,6,15,29,26,29,5,15,37,26,28,4,18,28,26,28,6,15,28,26,20,4,19,20,26,20,4,18,20,26,20,4,18,20,26,22,4,18,30,26,20,4,18,28,26,20,4,18,20,26,20,4,18,20,26,27,3,19,27,26,20,4,18,20,26,20,4,18,20,26,20,4,18,20,26,20,3,19,20,26,20,4,18,28,26,20,3,19,20,26,28,4,19,28,26,28,11,4,28,26,28,4,19,28,26,28,4,18,13],"m45":[29,0,0,0,0,29,32,12,6,32,29,32,4,21,15,29,32,4,22,27,29,32,5,20,32,29,32,5,20,32,29,28,5,21,28,29,32,11,8,18,29,32,11,11,32,29,32,8,11,32,29,29,4,22,26,29,27,4,22,22,29,14,9,12,14,29,18,4,21,6,29,13,11,8,8,29,32,4,21,32,29,32,5,20,32,29,32,5,20,32,29,32,5,20,32,29,32,4,21,32,29,32,6,19,32,29,32,4,21,32,29,32,5,20,32,29,32,4,21,32,29,32,5,20,32,29,32,5,20,32,29,27,11,8,22,29,29,9,12,29,29,29,4,21,26,29,23,4,21,13,29,29,4,21,26,29,32,4,22,32,29,32,5,20,32,29,32,4,21,32,29,32,5,20,32,29,32,5,21,32,29,32,4,21,32,29,32,5,21,32,29,32,5,21,32,29,32,5,20,32,29,32,5,20,32,29,32,4,22,32,29,32,7,16,32,29,32,5,21,32,29,32,5,21,32,29,32,5,20,32,29,32,5,20,32,29,32,5,20,32,29,32,5,20,32,29,32,5,20,32,29,32,5,20,32,29,32,5,20,32,29,32,5,20,32,29,32,5,20,32,29,32,5,20,32,29,32,5,20,32,29,32,4,21,32,29,32,5,20,32,29,32,4,21,32,29,32,5,21,32,29,32,4,21,32,29,32,4,21,32,29,25,4,21,20,29,0,4,21,4,29,32,6,17,15,29,23,5,19,23,29,32,5,20,32,29,23,5,21,23,29,32,5,20,32,29,23,5,20,23,29,32,5,20,32,29,23,5,20,32,29,32,5,20,32,29,34,7,17,34,29,34,6,17,43,29,32,5,21,32,29,32,7,17,32,29,23,4,21,23,29,23,5,20,23,29,23,5,20,23,29,24,5,20,33,29,23,5,20,32,29,23,5,20,23,29,23,4,21,23,29,30,4,22,30,29,23,5,20,23,29,23,5,20,23,29,23,4,21,23,29,23,4,21,23,29,23,5,20,32,29,23,4,21,23,29,32,4,22,32,29,32,13,4,32,29,32,4,22,32,29,32,5,20,15],"a45":[29,0,0,0,0,29,32,12,6,32,29,32,4,21,15,29,32,4,22,27,29,32,5,20,32,29,32,5,20,32,29,28,5,21,28,29,32,11,8,18,29,32,11,11,32,29,32,8,11,32,29,29,4,22,26,29,27,4,22,22,29,14,9,12,14,29,18,4,21,6,29,13,11,8,8,29,32,4,21,32,29,32,5,20,32,29,32,5,20,32,29,32,5,20,32,29,32,4,21,32,29,32,6,19,32,29,32,4,21,32,29,32,5,20,32,29,32,4,21,32,29,32,5,20,32,29,32,5,20,32,29,27,11,8,22,29,29,9,12,29,29,29,4,21,26,29,23,4,21,13,29,29,4,21,26,29,32,4,22,32,29,32,5,20,32,29,32,4,21,32,29,32,5,20,32,29,32,5,21,32,29,32,4,21,32,29,32,5,21,32,29,32,5,21,32,29,32,5,20,32,29,32,5,20,32,29,32,4,22,32,29,32,7,16,32,29,32,5,21,32,29,32,5,21,32,29,32,5,20,32,29,32,5,20,32,29,32,5,20,32,29,32,5,20,32,29,32,5,20,32,29,32,5,20,32,29,32,5,20,32,29,32,5,20,32,29,32,5,20,32,29,32,5,20,32,29,32,5,20,32,29,32,4,21,32,29,32,5,20,32,29,32,4,21,32,29,32,5,21,32,29,32,4,21,32,29,32,4,21,32,29,25,4,21,20,29,0,4,21,4,29,32,6,17,15,29,23,5,19,23,29,32,5,20,32,29,23,5,21,23,29,32,5,20,32,29,23,5,20,23,29,32,5,20,32,29,23,5,20,32,29,32,5,20,32,29,34,7,17,34,29,34,6,17,43,29,32,5,21,32,29,32,7,17,32,29,23,4,21,23,29,23,5,20,23,29,23,5,20,23,29,24,5,20,33,29,23,5,20,32,29,23,5,20,23,29,23,4,21,23,29,30,4,22,30,29,23,5,20,23,29,23,5,20,23,29,23,4,21,23,29,23,4,21,23,29,23,5,20,32,29,23,4,21,23,29,32,4,22,32,29,32,13,4,32,29,32,4,22,32,29,32,5,20,15],"m48":[31,0,0,0,0,31,34,12,7,34,31,34,4,23,16,31,34,4,23,29,31,34,5,21,34,31,34,5,22,34,31,30,5,22,30,31,34,11,9,19,31,34,11,11,34,31,34,9,11,34,31,31,4,22,28,31,28,4,22,22,31,15,9,13,15,31,19,4,23,6,31,13,11,9,8,31,34,4,23,34,31,34,5,21,34,31,34,5,21,34,31,34,5,21,34,31,34,4,22,34,31,34,6,20,34,31,34,4,22,34,31,34,5,21,34,31,34,4,22,34,31,34,5,21,34,31,34,5,22,34,31,28,11,9,23,31,30,9,13,30,31,31,4,23,28,31,25,4,23,14,31,31,4,23,28,31,34,4,22,34,31,34,5,21,34,31,34,4,23,34,31,34,5,21,34,31,34,5,22,34,31,34,4,22,34,31,34,5,22,34,31,34,5,22,34,31,34,5,22,34,31,34,5,21,34,31,34,4,22,34,31,34,7,17,34,31,34,5,22,34,31,34,5,22,34,31,34,5,21,34,31,34,5,21,34,31,34,5,21,34,31,34,5,21,34,31,34,5,21,34,31,34,5,21,34,31,34,5,21,34,31,34,5,21,34,31,34,5,21,34,31,34,5,21,34,31,34,5,21,34,31,34,4,23,34,31,34,5,21,34,31,34,4,23,34,31,34,5,21,34,31,34,4,23,34,31,34,5,21,34,31,27,4,23,22,31,0,4,23,4,31,34,7,18,16,31,25,5,21,25,31,34,5,21,34,31,25,5,22,25,31,34,5,21,34,31,25,5,21,25,31,34,5,20,34,31,25,5,21,34,31,34,5,21,34,31,35,7,18,35,31,35,6,18,44,31,34,5,22,34,31,34,7,18,34,31,25,5,21,25,31,25,5,21,25,31,25,5,21,25,31,25,5,21,34,31,25,5,21,34,31,25,5,21,25,31,25,4,22,25,31,33,4,22,33,31,25,5,21,25,31,25,5,21,25,31,25,4,22,25,31,25,4,23,25,31,25,5,21,34,31,25,4,23,25,31,34,4,22,34,31,34,13,4,34,31,34,4,22,34,31,34,5,21,16],"a48":[31,0,0,0,0,31,34,12,7,34,31,34,4,23,16,31,34,4,23,29,31,34,5,21,34,31,34,5,22,34,31,30,5,22,30,31,34,11,9,19,31,34,11,11,34,31,34,9,11,34,31,31,4,22,28,31,28,4,22,22,31,15,9,13,15,31,19,4,23,6,31,13,11,9,8,31,34,4,23,34,31,34,5,21,34,31,34,5,21,34,31,34,5,21,34,31,34,4,22,34,31,34,6,20,34,31,34,4,22,34,31,34,5,21,34,31,34,4,22,34,31,34,5,21,34,31,34,5,22,34,31,28,11,9,23,31,30,9,13,30,31,31,4,23,28,31,25,4,23,14,31,31,4,23,28,31,34,4,22,34,31,34,5,21,34,31,34,4,23,34,31,34,5,21,34,31,34,5,22,34,31,34,4,22,34,31,34,5,22,34,31,34,5,22,34,31,34,5,22,34,31,34,5,21,34,31,34,4,22,34,31,34,7,17,34,31,34,5,22,34,31,34,5,22,34,31,34,5,21,34,31,34,5,21,34,31,34,5,21,34,31,34,5,21,34,31,34,5,21,34,31,34,5,21,34,31,34,5,21,34,31,34,5,21,34,31,34,5,21,34,31,34,5,21,34,31,34,5,21,34,31,34,4,23,34,31,34,5,21,34,31,34,4,23,34,31,34,5,21,34,31,34,4,23,34,31,34,5,21,34,31,27,4,23,22,31,0,4,23,4,31,34,7,18,16,31,25,5,21,25,31,34,5,21,34,31,25,5,22,25,31,34,5,21,34,31,25,5,21,25,31,34,5,20,34,31,25,5,21,34,31,34,5,21,34,31,35,7,18,35,31,35,6,18,44,31,34,5,22,34,31,34,7,18,34,31,25,5,21,25,31,25,5,21,25,31,25,5,21,25,31,25,5,21,34,31,25,5,21,34,31,25,5,21,25,31,25,4,22,25,31,33,4,22,33,31,25,5,21,25,31,25,5,21,25,31,25,4,22,25,31,25,4,23,25,31,25,5,21,34,31,25,4,23,25,31,34,4,22,34,31,34,13,4,34,31,34,4,22,34,31,34,5,21,16],"m50":[33,0,0,0,0,33,35,13,7,35,33,35,5,23,17,33,35,5,23,30,33,35,5,23,35,33,35,5,22,35,33,32,5,23,32,33,35,12,9,20,33,35,12,12,35,33,35,9,12,35,33,32,5,23,29,33,29,5,23,23,33,16,10,14,16,33,19,5,23,6,33,14,12,9,8,33,35,5,23,35,33,35,5,23,35,33,35,5,23,35,33,35,5,23,35,33,35,5,23,35,33,35,6,22,35,33,35,5,23,35,33,35,5,23,35,33,35,5,23,35,33,35,5,23,35,33,35,5,23,35,33,29,12,9,23,33,31,10,14,31,33,32,5,23,29,33,26,5,23,15,33,32,5,23,29,33,35,5,24,35,33,35,5,23,35,33,35,4,24,35,33,35,5,23,35,33,35,5,23,35,33,35,5,23,35,33,35,5,23,35,33,35,5,23,35,33,35,5,23,35,33,35,5,23,35,33,35,5,23,35,33,35,7,19,35,33,35,5,23,35,33,35,5,23,35,33,35,5,23,35,33,35,5,23,35,33,35,5,23,35,33,35,5,23,35,33,35,5,23,35,33,35,5,23,35,33,35,5,23,35,33,35,5,23,35,33,35,5,23,35,33,35,5,23,35,33,35,5,23,35,33,35,5,23,35,33,35,5,23,35,33,35,5,23,35,33,35,5,24,35,33,35,5,23,35,33,35,4,24,35,33,28,5,23,23,33,0,5,23,5,33,35,7,19,17,33,26,5,23,26,33,35,5,23,35,33,26,5,23,26,33,35,5,23,35,33,26,5,23,26,33,35,6,22,35,33,26,5,23,36,33,35,5,23,35,33,37,7,18,37,33,37,7,19,47,33,35,5,23,35,33,35,7,18,35,33,26,5,24,26,33,26,5,23,26,33,26,5,23,26,33,27,5,23,37,33,26,5,23,36,33,26,5,23,26,33,26,5,23,26,33,34,5,24,34,33,26,5,23,26,33,26,5,23,26,33,26,5,23,26,33,26,5,23,26,33,26,5,23,36,33,26,5,23,26,33,35,5,23,35,33,35,14,5,35,33,35,5,23,35,33,35,5,23,16],"a50":[33,0,0,0,0,33,35,13,7,35,33,35,5,23,17,33,35,5,23,30,33,35,5,23,35,33,35,5,22,35,33,32,5,23,32,33,35,12,9,20,33,35,12,12,35,33,35,9,12,35,33,32,5,23,29,33,29,5,23,23,33,16,10,14,16,33,19,5,23,6,33,14,12,9,8,33,35,5,23,35,33,35,5,23,35,33,35,5,23,35,33,35,5,23,35,33,35,5,23,35,33,35,6,22,35,33,35,5,23,35,33,35,5,23,35,33,35,5,23,35,33,35,5,23,35,33,35,5,23,35,33,29,12,9,23,33,31,10,14,31,33,32,5,23,29,33,26,5,23,15,33,32,5,23,29,33,35,5,24,35,33,35,5,23,35,33,35,4,24,35,33,35,5,23,35,33,35,5,23,35,33,35,5,23,35,33,35,5,23,35,33,35,5,23,35,33,35,5,23,35,33,35,5,23,35,33,35,5,23,35,33,35,7,19,35,33,35,5,23,35,33,35,5,23,35,33,35,5,23,35,33,35,5,23,35,33,35,5,23,35,33,35,5,23,35,33,35,5,23,35,33,35,5,23,35,33,35,5,23,35,33,35,5,23,35,33,35,5,23,35,33,35,5,23,35,33,35,5,23,35,33,35,5,23,35,33,35,5,23,35,33,35,5,23,35,33,35,5,24,35,33,35,5,23,35,33,35,4,24,35,33,28,5,23,23,33,0,5,23,5,33,35,7,19,17,33,26,5,23,26,33,35,5,23,35,33,26,5,23,26,33,35,5,23,35,33,26,5,23,26,33,35,6,22,35,33,26,5,23,36,33,35,5,23,35,33,37,7,18,37,33,37,7,19,47,33,35,5,23,35,33,35,7,18,35,33,26,5,24,26,33,26,5,23,26,33,26,5,23,26,33,27,5,23,37,33,26,5,23,36,33,26,5,23,26,33,26,5,23,26,33,34,5,24,34,33,26,5,23,26,33,26,5,23,26,33,26,5,23,26,33,26,5,23,26,33,26,5,23,36,33,26,5,23,26,33,35,5,23,35,33,35,14,5,35,33,35,5,23,35,33,35,5,23,16],"m54":[35,0,0,0,0,35,38,14,7,38,35,38,5,25,18,35,38,5,25,33,35,38,5,25,38,35,38,5,25,38,35,34,5,25,34,35,38,13,10,22,35,38,13,13,38,35,38,10,13,38,35,34,5,25,30,35,32,5,25,25,35,17,10,15,17,35,21,5,25,7,35,15,13,10,9,35,38,5,25,38,35,38,5,25,38,35,38,5,25,38,35,38,5,25,38,35,38,5,25,38,35,38,7,22,38,35,38,5,25,38,35,38,5,25,38,35,38,5,25,38,35,38,5,25,38,35,38,5,24,38,35,32,13,10,26,35,34,10,15,34,35,34,5,25,30,35,28,5,25,16,35,34,5,25,30,35,38,5,25,38,35,38,5,25,38,35,38,5,25,38,35,38,5,25,38,35,38,5,25,38,35,38,5,25,38,35,38,5,25,38,35,38,5,25,38,35,38,5,25,38,35,38,5,25,38,35,38,5,25,38,35,38,8,19,38,35,38,5,25,38,35,38,5,25,38,35,38,5,25,38,35,38,5,25,38,35,38,5,25,38,35,38,5,25,38,35,38,5,25,38,35,38,5,25,38,35,38,5,25,38,35,38,5,25,38,35,38,5,25,38,35,38,5,25,38,35,38,5,25,38,35,38,5,25,38,35,38,5,25,38,35,38,5,25,38,35,38,5,26,38,35,38,5,25,38,35,38,5,25,38,35,30,5,25,24,35,0,5,25,5,35,38,7,21,18,35,28,5,24,28,35,38,5,25,38,35,28,5,25,28,35,38,5,25,38,35,28,5,25,28,35,38,6,23,38,35,28,5,25,38,35,38,5,25,38,35,40,8,20,40,35,40,8,20,50,35,38,5,25,38,35,38,8,20,38,35,28,5,25,28,35,28,5,25,28,35,28,5,25,28,35,29,5,25,39,35,28,5,25,38,35,28,5,25,28,35,28,5,25,28,35,37,5,25,37,35,28,5,25,28,35,28,5,25,28,35,28,5,25,28,35,28,5,25,28,35,28,5,25,38,35,28,5,25,28,35,38,5,25,38,35,38,15,5,38,35,38,5,25,38,35,38,5,25,17],"a54":[35,0,0,0,0,35,38,14,7,38,35,38,5,25,18,35,38,5,25,33,35,38,5,25,38,35,38,5,25,38,35,34,5,25,34,35,38,13,10,22,35,38,13,13,38,35,38,10,13,38,35,34,5,25,30,35,32,5,25,25,35,17,10,15,17,35,21,5,25,7,35,15,13,10,9,35,38,5,25,38,35,38,5,25,38,35,38,5,25,38,35,38,5,25,38,35,38,5,25,38,35,38,7,22,38,35,38,5,25,38,35,38,5,25,38,35,38,5,25,38,35,38,5,25,38,35,38,5,24,38,35,32,13,10,26,35,34,10,15,34,35,34,5,25,30,35,28,5,25,16,35,34,5,25,30,35,38,5,25,38,35,38,5,25,38,35,38,5,25,38,35,38,5,25,38,35,38,5,25,38,35,38,5,25,38,35,38,5,25,38,35,38,5,25,38,35,38,5,25,38,35,38,5,25,38,35,38,5,25,38,35,38,8,19,38,35,38,5,25,38,35,38,5,25,38,35,38,5,25,38,35,38,5,25,38,35,38,5,25,38,35,38,5,25,38,35,38,5,25,38,35,38,5,25,38,35,38,5,25,38,35,38,5,25,38,35,38,5,25,38,35,38,5,25,38,35,38,5,25,38,35,38,5,25,38,35,38,5,25,38,35,38,5,25,38,35,38,5,26,38,35,38,5,25,38,35,38,5,25,38,35,30,5,25,24,35,0,5,25,5,35,38,7,21,18,35,28,5,24,28,35,38,5,25,38,35,28,5,25,28,35,38,5,25,38,35,28,5,25,28,35,38,6,23,38,35,28,5,25,38,35,38,5,25,38,35,40,8,20,40,35,40,8,20,50,35,38,5,25,38,35,38,8,20,38,35,28,5,25,28,35,28,5,25,28,35,28,5,25,28,35,29,5,25,39,35,28,5,25,38,35,28,5,25,28,35,28,5,25,28,35,37,5,25,37,35,28,5,25,28,35,28,5,25,28,35,28,5,25,28,35,28,5,25,28,35,28,5,25,38,35,28,5,25,28,35,38,5,25,38,35,38,15,5,38,35,38,5,25,38,35,38,5,25,17],"m56":[36,0,0,0,0,36,39,14,8,39,36,39,5,26,18,36,39,6,26,33,36,39,6,25,39,36,39,6,25,39,36,35,6,26,35,36,39,13,10,23,36,39,13,13,39,36,39,10,13,39,36,36,6,26,32,36,32,6,26,26,36,18,11,15,18,36,22,5,26,7,36,15,13,10,9,36,39,5,26,39,36,39,6,25,39,36,39,6,25,39,36,39,6,25,39,36,39,6,25,39,36,39,7,23,39,36,39,6,25,39,36,39,6,25,39,36,39,6,25,39,36,39,6,25,39,36,39,6,25,39,36,33,13,10,27,36,35,11,15,35,36,36,5,26,32,36,29,5,26,16,36,36,5,26,32,36,39,6,26,39,36,39,6,25,39,36,39,5,26,39,36,39,6,25,39,36,39,6,25,39,36,39,6,25,39,36,39,6,25,39,36,39,6,25,39,36,39,6,25,39,36,39,6,25,39,36,39,6,26,39,36,39,8,20,39,36,39,6,25,39,36,39,6,25,39,36,39,6,25,39,36,39,6,25,39,36,39,6,25,39,36,39,6,25,39,36,39,6,25,39,36,39,6,25,39,36,39,6,25,39,36,39,6,25,39,36,39,6,25,39,36,39,6,25,39,36,39,6,25,39,36,39,5,26,39,36,39,6,25,39,36,39,5,26,39,36,39,6,25,39,36,39,5,26,39,36,39,5,26,39,36,31,5,26,25,36,0,5,26,5,36,39,8,21,18,36,29,6,24,29,36,39,6,25,39,36,29,6,25,29,36,39,6,25,39,36,29,6,25,29,36,39,7,23,39,36,29,6,25,40,36,39,6,25,39,36,41,8,21,41,36,41,8,20,52,36,39,6,25,39,36,39,8,21,39,36,29,5,26,29,36,29,6,25,29,36,29,6,25,29,36,30,6,25,41,36,29,6,25,40,36,29,6,25,29,36,29,5,26,29,36,38,6,26,38,36,29,6,25,29,36,29,6,25,29,36,29,5,26,29,36,29,5,26,29,36,29,6,25,40,36,29,5,26,29,36,39,6,26,39,36,39,16,5,39,36,39,6,26,39,36,39,6,25,18],"a56":[36,0,0,0,0,36,39,14,8,39,36,39,5,26,18,36,39,6,26,33,36,39,6,25,39,36,39,6,25,39,36,35,6,26,35,36,39,13,10,23,36,39,13,13,39,36,39,10,13,39,36,36,6,26,32,36,32,6,26,26,36,18,11,15,18,36,22,5,26,7,36,15,13,10,9,36,39,5,26,39,36,39,6,25,39,36,39,6,25,39,36,39,6,25,39,36,39,6,25,39,36,39,7,23,39,36,39,6,25,39,36,39,6,25,39,36,39,6,25,39,36,39,6,25,39,36,39,6,25,39,36,33,13,10,27,36,35,11,15,35,36,36,5,26,32,36,29,5,26,16,36,36,5,26,32,36,39,6,26,39,36,39,6,25,39,36,39,5,26,39,36,39,6,25,39,36,39,6,25,39,36,39,6,25,39,36,39,6,25,39,36,39,6,25,39,36,39,6,25,39,36,39,6,25,39,36,39,6,26,39,36,39,8,20,39,36,39,6,25,39,36,39,6,25,39,36,39,6,25,39,36,39,6,25,39,36,39,6,25,39,36,39,6,25,39,36,39,6,25,39,36,39,6,25,39,36,39,6,25,39,36,39,6,25,39,36,39,6,25,39,36,39,6,25,39,36,39,6,25,39,36,39,5,26,39,36,39,6,25,39,36,39,5,26,39,36,39,6,25,39,36,39,5,26,39,36,39,5,26,39,36,31,5,26,25,36,0,5,26,5,36,39,8,21,18,36,29,6,24,29,36,39,6,25,39,36,29,6,25,29,36,39,6,25,39,36,29,6,25,29,36,39,7,23,39,36,29,6,25,40,36,39,6,25,39,36,41,8,21,41,36,41,8,20,52,36,39,6,25,39,36,39,8,21,39,36,29,5,26,29,36,29,6,25,29,36,29,6,25,29,36,30,6,25,41,36,29,6,25,40,36,29,6,25,29,36,29,5,26,29,36,38,6,26,38,36,29,6,25,29,36,29,6,25,29,36,29,5,26,29,36,29,5,26,29,36,29,6,25,40,36,29,5,26,29,36,39,6,26,39,36,39,16,5,39,36,39,6,26,39,36,39,6,25,18],"m60":[39,0,0,0,0,39,42,15,8,42,39,42,6,28,19,39,42,5,28,36,39,42,6,27,42,39,42,6,27,42,39,37,6,27,37,39,42,14,11,24,39,42,14,14,42,39,42,11,14,42,39,38,6,27,34,39,34,6,27,27,39,19,11,16,19,39,24,6,27,8,39,17,14,11,10,39,42,6,27,42,39,42,6,27,42,39,42,6,27,42,39,42,6,27,42,39,42,6,27,42,39,42,7,24,42,39,42,5,28,42,39,42,6,27,42,39,42,6,27,42,39,42,6,26,42,39,42,6,27,42,39,35,14,11,28,39,37,11,16,37,39,38,6,27,34,39,31,6,27,17,39,38,6,27,34,39,42,5,28,42,39,42,6,27,42,39,42,5,29,42,39,42,6,27,42,39,42,6,27,42,39,42,5,28,42,39,42,6,27,42,39,42,6,27,42,39,42,6,27,42,39,42,6,27,42,39,42,6,27,42,39,42,9,21,42,39,42,6,27,42,39,42,6,27,42,39,42,6,27,42,39,42,6,27,42,39,42,6,27,42,39,42,6,27,42,39,42,6,27,42,39,42,6,27,42,39,42,6,27,42,39,42,6,27,42,39,42,6,27,42,39,42,6,27,42,39,42,6,27,42,39,42,6,27,42,39,42,6,26,42,39,42,6,27,42,39,42,6,27,42,39,42,6,27,42,39,42,6,27,42,39,33,6,27,27,39,0,6,27,5,39,42,8,23,20,39,31,6,26,31,39,42,6,27,42,39,31,6,27,31,39,42,6,27,42,39,31,6,27,31,39,42,7,25,42,39,31,6,27,42,39,42,6,27,42,39,45,9,23,45,39,45,8,22,56,39,42,6,27,42,39,42,9,23,42,39,31,6,27,31,39,31,6,27,31,39,31,6,27,31,39,31,6,27,42,39,31,6,27,42,39,31,6,27,31,39,31,6,26,31,39,41,5,28,41,39,31,6,27,31,39,31,6,27,31,39,31,6,27,31,39,31,6,27,31,39,31,6,26,42,39,31,6,27,31,39,42,6,27,42,39,42,17,5,42,39,42,6,27,42,39,42,6,27,19],"a60":[39,0,0,0,0,39,42,15,8,42,39,42,6,28,20,39,42,5,28,36,39,42,6,27,42,39,42,6,27,42,39,37,6,27,37,39,42,14,11,24,39,42,14,14,42,39,42,11,14,42,39,38,6,27,34,39,34,6,27,27,39,19,11,16,19,39,24,6,27,8,39,17,14,11,10,39,42,6,27,42,39,42,6,27,42,39,42,6,27,42,39,42,6,27,42,39,42,6,27,42,39,42,7,24,42,39,42,5,28,42,39,42,6,27,42,39,42,6,27,42,39,42,6,26,42,39,42,6,27,42,39,35,14,11,28,39,37,11,16,37,39,38,6,27,34,39,31,6,27,17,39,38,6,27,34,39,42,5,28,42,39,42,6,27,42,39,42,5,29,42,39,42,6,27,42,39,42,6,27,42,39,42,5,28,42,39,42,6,27,42,39,42,6,27,42,39,42,6,27,42,39,42,6,27,42,39,42,6,27,42,39,42,9,21,42,39,42,6,27,42,39,42,6,27,42,39,42,6,27,42,39,42,6,27,42,39,42,6,27,42,39,42,6,27,42,39,42,6,27,42,39,42,6,27,42,39,42,6,27,42,39,42,6,27,42,39,42,6,27,42,39,42,6,27,42,39,42,6,27,42,39,42,6,27,42,39,42,6,26,42,39,42,6,27,42,39,42,6,27,42,39,42,6,27,42,39,42,6,27,42,39,33,6,27,27,39,0,6,27,5,39,42,8,23,20,39,31,6,26,31,39,42,6,27,42,39,31,6,27,31,39,42,6,27,42,39,31,6,27,31,39,42,7,25,42,39,31,6,27,42,39,42,6,27,42,39,45,9,23,45,39,45,8,22,56,39,42,6,27,42,39,42,9,23,42,39,31,6,27,31,39,31,6,27,31,39,31,6,27,31,39,31,6,27,42,39,31,6,27,42,39,31,6,27,31,39,31,6,26,31,39,41,5,28,41,39,31,6,27,31,39,31,6,27,31,39,31,6,27,31,39,31,6,27,31,39,31,6,26,42,39,31,6,27,31,39,42,6,27,42,39,42,17,5,42,39,42,6,27,42,39,42,6,27,19],"m63":[41,0,0,0,0,41,44,16,8,44,41,44,6,29,21,41,44,6,29,37,41,44,6,28,44,41,44,6,28,44,41,40,6,29,40,41,44,15,11,25,41,44,15,15,44,41,44,11,15,44,41,40,6,29,36,41,37,6,29,30,41,20,12,17,20,41,25,6,28,8,41,18,15,11,11,41,44,6,28,44,41,44,6,28,44,41,44,6,28,44,41,44,6,28,44,41,44,5,29,44,41,44,8,25,44,41,44,6,28,44,41,44,6,28,44,41,44,6,28,44,41,44,6,29,44,41,44,6,29,44,41,37,15,11,30,41,40,12,17,40,41,40,6,28,36,41,32,6,28,18,41,40,6,28,36,41,44,6,29,44,41,44,6,28,44,41,44,6,28,44,41,44,6,28,44,41,44,6,29,44,41,44,6,28,44,41,44,6,29,44,41,44,6,29,44,41,44,6,28,44,41,44,6,28,44,41,44,6,29,44,41,44,9,23,44,41,44,6,29,44,41,44,6,29,44,41,44,6,28,44,41,44,6,28,44,41,44,6,28,44,41,44,6,28,44,41,44,6,28,44,41,44,6,28,44,41,44,6,28,44,41,44,6,28,44,41,44,6,28,44,41,44,6,28,44,41,44,6,28,44,41,44,6,28,44,41,44,6,28,44,41,44,6,28,44,41,44,6,29,44,41,44,6,28,44,41,44,6,28,44,41,35,6,28,28,41,0,6,28,6,41,44,9,23,21,41,32,6,29,32,41,44,6,28,44,41,32,6,29,32,41,44,6,28,44,41,32,6,28,32,41,44,7,26,44,41,32,6,28,44,41,44,6,28,44,41,46,9,23,46,41,46,9,23,58,41,44,6,29,44,41,44,9,23,44,41,32,6,29,32,41,32,6,28,32,41,32,6,28,32,41,34,6,28,46,41,32,6,28,44,41,32,6,28,32,41,32,6,28,32,41,42,6,29,42,41,32,6,28,32,41,32,6,28,32,41,32,6,29,32,41,32,6,28,32,41,32,6,28,44,41,32,6,28,32,41,44,6,29,44,41,44,17,6,44,41,44,6,29,44,41,44,6,28,20],"a63":[41,0,0,0,0,41,44,16,8,44,41,44,6,29,21,41,44,6,29,37,41,44,6,28,44,41,44,6,28,44,41,40,6,29,40,41,44,15,11,25,41,44,15,15,44,41,44,11,15,44,41,40,6,29,36,41,37,6,29,30,41,20,12,17,20,41,25,6,28,8,41,18,15,11,11,41,44,6,28,44,41,44,6,28,44,41,44,6,28,44,41,44,6,28,44,41,44,5,29,44,41,44,8,25,44,41,44,6,28,44,41,44,6,28,44,41,44,6,28,44,41,44,6,29,44,41,44,6,29,44,41,37,15,11,30,41,40,12,17,40,41,40,6,28,36,41,32,6,28,18,41,40,6,28,36,41,44,6,29,44,41,44,6,28,44,41,44,6,28,44,41,44,6,28,44,41,44,6,29,44,41,44,6,28,44,41,44,6,29,44,41,44,6,29,44,41,44,6,28,44,41,44,6,28,44,41,44,6,29,44,41,44,9,23,44,41,44,6,29,44,41,44,6,29,44,41,44,6,28,44,41,44,6,28,44,41,44,6,28,44,41,44,6,28,44,41,44,6,28,44,41,44,6,28,44,41,44,6,28,44,41,44,6,28,44,41,44,6,28,44,41,44,6,28,44,41,44,6,28,44,41,44,6,28,44,41,44,6,28,44,41,44,6,28,44,41,44,6,29,44,41,44,6,28,44,41,44,6,28,44,41,35,6,28,28,41,0,6,28,6,41,44,9,23,21,41,32,6,29,32,41,44,6,28,44,41,32,6,29,32,41,44,6,28,44,41,32,6,28,32,41,44,7,26,44,41,32,6,28,44,41,44,6,28,44,41,46,9,23,46,41,46,9,23,58,41,44,6,29,44,41,44,9,23,44,41,32,6,29,32,41,32,6,28,32,41,32,6,28,32,41,34,6,28,46,41,32,6,28,44,41,32,6,28,32,41,32,6,28,32,41,42,6,29,42,41,32,6,28,32,41,32,6,28,32,41,32,6,29,32,41,32,6,28,32,41,32,6,28,44,41,32,6,28,32,41,44,6,29,44,41,44,17,6,44,41,44,6,29,44,41,44,6,28,20],"m64":[42,0,0,0,0,42,45,16,9,45,42,45,6,30,21,42,45,6,30,38,42,45,7,28,45,42,45,7,29,45,42,40,7,29,40,42,45,15,12,26,42,45,15,15,45,42,45,12,15,45,42,41,6,30,37,42,38,6,30,30,42,21,12,17,21,42,25,6,30,8,42,18,15,12,11,42,45,6,30,45,42,45,7,28,45,42,45,7,28,45,42,45,7,28,45,42,45,6,29,45,42,45,8,26,45,42,45,6,29,45,42,45,7,28,45,42,45,6,29,45,42,45,7,29,45,42,45,7,29,45,42,38,15,12,31,42,40,12,18,40,42,41,6,30,37,42,33,6,30,18,42,41,6,30,37,42,45,6,30,45,42,45,7,28,45,42,45,6,30,45,42,45,7,28,45,42,45,7,29,45,42,45,6,29,45,42,45,7,29,45,42,45,7,29,45,42,45,7,28,45,42,45,7,28,45,42,45,6,30,45,42,45,9,24,45,42,45,7,29,45,42,45,7,29,45,42,45,7,28,45,42,45,7,28,45,42,45,7,28,45,42,45,7,28,45,42,45,7,28,45,42,45,7,28,45,42,45,7,28,45,42,45,7,28,45,42,45,7,28,45,42,45,7,28,45,42,45,7,28,45,42,45,6,30,45,42,45,7,28,45,42,45,6,30,45,42,45,7,29,45,42,45,6,30,45,42,45,6,29,45,42,36,6,30,29,42,0,6,30,6,42,45,9,24,21,42,33,7,28,33,42,45,7,28,45,42,33,7,29,33,42,45,7,28,45,42,33,7,28,33,42,45,8,27,45,42,33,7,28,45,42,45,7,28,45,42,47,9,23,47,42,47,9,23,59,42,45,7,29,45,42,45,9,23,45,42,33,6,30,33,42,33,7,28,33,42,33,7,28,33,42,34,7,28,46,42,33,7,28,45,42,33,7,28,33,42,33,6,29,33,42,43,6,30,43,42,33,7,28,33,42,33,7,28,33,42,33,6,30,33,42,33,6,30,33,42,33,7,28,45,42,33,6,30,33,42,45,6,30,45,42,45,18,6,45,42,45,6,30,45,42,45,7,28,20],"a64":[42,0,0,0,0,42,45,16,9,45,42,45,6,30,21,42,45,6,30,38,42,45,7,28,45,42,45,7,29,45,42,40,7,29,40,42,45,15,12,26,42,45,15,15,45,42,45,12,15,45,42,41,6,30,37,42,38,6,30,30,42,21,12,17,21,42,25,6,30,8,42,18,15,12,11,42,45,6,30,45,42,45,7,28,45,42,45,7,28,45,42,45,7,28,45,42,45,6,29,45,42,45,8,26,45,42,45,6,29,45,42,45,7,28,45,42,45,6,29,45,42,45,7,29,45,42,45,7,29,45,42,38,15,12,31,42,40,12,18,40,42,41,6,30,37,42,33,6,30,18,42,41,6,30,37,42,45,6,30,45,42,45,7,28,45,42,45,6,30,45,42,45,7,28,45,42,45,7,29,45,42,45,6,29,45,42,45,7,29,45,42,45,7,29,45,42,45,7,28,45,42,45,7,28,45,42,45,6,30,45,42,45,9,24,45,42,45,7,29,45,42,45,7,29,45,42,45,7,28,45,42,45,7,28,45,42,45,7,28,45,42,45,7,28,45,42,45,7,28,45,42,45,7,28,45,42,45,7,28,45,42,45,7,28,45,42,45,7,28,45,42,45,7,28,45,42,45,7,28,45,42,45,6,30,45,42,45,7,28,45,42,45,6,30,45,42,45,7,29,45,42,45,6,30,45,42,45,6,29,45,42,36,6,30,29,42,0,6,30,6,42,45,9,24,21,42,33,7,28,33,42,45,7,28,45,42,33,7,29,33,42,45,7,28,45,42,33,7,28,33,42,45,8,27,45,42,33,7,28,45,42,45,7,28,45,42,47,9,23,47,42,47,9,23,59,42,45,7,29,45,42,45,9,23,45,42,33,6,30,33,42,33,7,28,33,42,33,7,28,33,42,34,7,28,46,42,33,7,28,45,42,33,7,28,33,42,33,6,29,33,42,43,6,30,43,42,33,7,28,33,42,33,7,28,33,42,33,6,30,33,42,33,6,30,33,42,33,7,28,45,42,33,6,30,33,42,45,6,30,45,42,45,18,6,45,42,45,6,30,45,42,45,7,28,20],"m70":[46,0,0,0,0,46,49,18,10,49,46,49,7,32,23,46,49,6,33,41,46,49,7,31,49,46,49,7,32,49,46,43,7,32,43,46,49,16,13,28,46,49,16,16,49,46,49,13,16,49,46,44,7,32,39,46,40,7,32,32,46,22,13,19,22,46,28,7,32,9,46,20,16,13,12,46,49,7,32,49,46,49,7,31,49,46,49,7,31,49,46,49,7,31,49,46,49,6,32,49,46,49,9,28,49,46,49,6,32,49,46,49,7,31,49,46,49,7,31,49,46,49,7,31,49,46,49,7,32,49,46,41,16,13,33,46,44,13,19,44,46,44,7,32,39,46,36,7,32,20,46,44,7,32,39,46,49,6,32,49,46,49,7,31,49,46,49,6,33,49,46,49,7,31,49,46,49,7,32,49,46,49,6,32,49,46,49,7,32,49,46,49,7,32,49,46,49,7,31,49,46,49,7,31,49,46,49,7,32,49,46,49,10,25,49,46,49,7,32,49,46,49,7,32,49,46,49,7,31,49,46,49,7,31,49,46,49,7,31,49,46,49,7,31,49,46,49,7,31,49,46,49,7,31,49,46,49,7,31,49,46,49,7,31,49,46,49,7,31,49,46,49,7,31,49,46,49,7,31,49,46,49,7,32,49,46,49,7,31,49,46,49,7,32,49,46,49,7,31,49,46,49,7,32,49,46,49,7,31,49,46,39,7,32,31,46,0,7,32,6,46,49,10,26,23,46,36,7,30,36,46,49,7,31,49,46,36,7,32,36,46,49,7,31,49,46,36,7,31,36,46,49,8,29,49,46,36,7,31,49,46,49,7,31,49,46,52,10,26,52,46,52,9,26,65,46,49,7,32,49,46,49,10,26,49,46,36,7,32,36,46,36,7,31,36,46,36,7,31,36,46,37,7,31,50,46,36,7,31,49,46,36,7,31,36,46,36,7,31,36,46,47,6,32,47,46,36,7,31,36,46,36,7,31,36,46,36,6,33,36,46,36,7,32,36,46,36,7,31,49,46,36,7,32,36,46,49,7,32,49,46,49,20,6,49,46,49,7,32,49,46,49,7,31,22],"a70":[46,0,0,0,0,46,49,18,10,49,46,49,7,32,23,46,49,6,33,41,46,49,7,31,49,46,49,7,32,49,46,43,7,32,43,46,49,16,13,28,46,49,16,16,49,46,49,13,16,49,46,44,7,32,39,46,40,7,32,32,46,22,13,19,22,46,28,7,32,9,46,20,16,13,12,46,49,7,32,49,46,49,7,31,49,46,49,7,31,49,46,49,7,31,49,46,49,6,32,49,46,49,9,28,49,46,49,6,32,49,46,49,7,31,49,46,49,7,31,49,46,49,7,31,49,46,49,7,32,49,46,41,16,13,33,46,44,13,19,44,46,44,7,32,39,46,36,7,32,20,46,44,7,32,39,46,49,6,32,49,46,49,7,31,49,46,49,6,33,49,46,49,7,31,49,46,49,7,32,49,46,49,6,32,49,46,49,7,32,49,46,49,7,32,49,46,49,7,31,49,46,49,7,31,49,46,49,7,32,49,46,49,10,25,49,46,49,7,32,49,46,49,7,32,49,46,49,7,31,49,46,49,7,31,49,46,49,7,31,49,46,49,7,31,49,46,49,7,31,49,46,49,7,31,49,46,49,7,31,49,46,49,7,31,49,46,49,7,31,49,46,49,7,31,49,46,49,7,31,49,46,49,7,32,49,46,49,7,31,49,46,49,7,32,49,46,49,7,31,49,46,49,7,32,49,46,49,7,31,49,46,39,7,32,31,46,0,7,32,6,46,49,10,26,23,46,36,7,30,36,46,49,7,31,49,46,36,7,32,36,46,49,7,31,49,46,36,7,31,36,46,49,8,29,49,46,36,7,31,49,46,49,7,31,49,46,52,10,26,52,46,52,9,26,65,46,49,7,32,49,46,49,10,26,49,46,36,7,32,36,46,36,7,31,36,46,36,7,31,36,46,37,7,31,50,46,36,7,31,49,46,36,7,31,36,46,36,7,31,36,46,47,6,32,47,46,36,7,31,36,46,36,7,31,36,46,36,6,33,36,46,36,7,32,36,46,36,7,31,49,46,36,7,32,36,46,49,7,32,49,46,49,20,6,49,46,49,7,32,49,46,49,7,31,22],"m72":[47,0,0,0,0,47,51,19,10,51,47,51,7,33,24,47,51,7,34,44,47,51,7,33,51,47,51,7,33,51,47,45,7,34,45,47,51,17,13,29,47,51,17,17,51,47,51,13,17,51,47,46,7,33,41,47,42,7,33,33,47,24,14,20,24,47,28,7,33,9,47,20,17,13,12,47,51,7,33,51,47,51,7,33,51,47,51,7,33,51,47,51,7,33,51,47,51,7,33,51,47,51,9,30,51,47,51,7,33,51,47,51,7,33,51,47,51,7,33,51,47,51,7,34,51,47,51,7,33,51,47,42,17,13,34,47,45,14,20,45,47,46,7,33,41,47,37,7,33,20,47,46,7,33,41,47,51,7,34,51,47,51,7,33,51,47,51,7,33,51,47,51,7,33,51,47,51,7,33,51,47,51,7,33,51,47,51,7,33,51,47,51,7,33,51,47,51,7,33,51,47,51,7,33,51,47,51,7,33,51,47,51,11,26,51,47,51,7,33,51,47,51,7,33,51,47,51,7,33,51,47,51,7,33,51,47,51,7,33,51,47,51,7,33,51,47,51,7,33,51,47,51,7,33,51,47,51,7,33,51,47,51,7,33,51,47,51,7,33,51,47,51,7,33,51,47,51,7,33,51,47,51,7,33,51,47,51,7,33,51,47,51,7,33,51,47,51,7,34,51,47,51,7,33,51,47,51,6,34,51,47,40,7,33,32,47,0,7,33,7,47,51,10,27,24,47,37,7,33,37,47,51,7,33,51,47,37,7,33,37,47,51,7,33,51,47,37,7,33,37,47,51,8,31,51,47,37,7,33,51,47,51,7,33,51,47,53,11,26,53,47,53,10,27,67,47,51,7,33,51,47,51,11,26,51,47,37,7,34,37,47,37,7,33,37,47,37,7,33,37,47,39,7,33,53,47,37,7,33,51,47,37,7,33,37,47,37,7,33,37,47,49,7,34,49,47,37,7,33,37,47,37,7,33,37,47,37,7,34,37,47,37,7,33,37,47,37,7,33,51,47,37,7,33,37,47,51,7,33,51,47,51,20,7,51,47,51,7,33,51,47,51,7,33,23],"a72":[47,0,0,0,0,47,51,19,10,51,47,51,7,33,24,47,51,7,34,44,47,51,7,33,51,47,51,7,33,51,47,45,7,34,45,47,51,17,13,29,47,51,17,17,51,47,51,13,17,51,47,46,7,33,41,47,42,7,33,33,47,24,14,20,24,47,28,7,33,9,47,20,17,13,12,47,51,7,33,51,47,51,7,33,51,47,51,7,33,51,47,51,7,33,51,47,51,7,33,51,47,51,9,30,51,47,51,7,33,51,47,51,7,33,51,47,51,7,33,51,47,51,7,34,51,47,51,7,33,51,47,42,17,13,34,47,45,14,20,45,47,46,7,33,41,47,37,7,33,20,47,46,7,33,41,47,51,7,34,51,47,51,7,33,51,47,51,7,33,51,47,51,7,33,51,47,51,7,33,51,47,51,7,33,51,47,51,7,33,51,47,51,7,33,51,47,51,7,33,51,47,51,7,33,51,47,51,7,33,51,47,51,11,26,51,47,51,7,33,51,47,51,7,33,51,47,51,7,33,51,47,51,7,33,51,47,51,7,33,51,47,51,7,33,51,47,51,7,33,51,47,51,7,33,51,47,51,7,33,51,47,51,7,33,51,47,51,7,33,51,47,51,7,33,51,47,51,7,33,51,47,51,7,33,51,47,51,7,33,51,47,51,7,33,51,47,51,7,34,51,47,51,7,33,51,47,51,6,34,51,47,40,7,33,32,47,0,7,33,7,47,51,10,27,24,47,37,7,33,37,47,51,7,33,51,47,37,7,33,37,47,51,7,33,51,47,37,7,33,37,47,51,8,31,51,47,37,7,33,51,47,51,7,33,51,47,53,11,26,53,47,53,10,27,67,47,51,7,33,51,47,51,11,26,51,47,37,7,34,37,47,37,7,33,37,47,37,7,33,37,47,39,7,33,53,47,37,7,33,51,47,37,7,33,37,47,37,7,33,37,47,49,7,34,49,47,37,7,33,37,47,37,7,33,37,47,37,7,34,37,47,37,7,33,37,47,37,7,33,51,47,37,7,33,37,47,51,7,33,51,47,51,20,7,51,47,51,7,33,51,47,51,7,33,23],"m80":[52,0,0,0,0,52,56,21,11,56,52,56,7,38,26,52,56,7,38,48,52,56,8,36,56,52,56,8,36,56,52,50,8,37,50,52,56,19,14,32,52,56,19,18,56,52,56,15,18,56,52,51,7,37,45,52,46,7,37,37,52,25,15,22,25,52,31,8,36,10,52,22,19,14,13,52,56,8,36,56,52,56,8,36,56,52,56,8,36,56,52,56,8,36,56,52,56,8,36,56,52,56,10,32,56,52,56,7,37,56,52,56,8,36,56,52,56,7,37,56,52,56,8,36,56,52,56,8,36,56,52,47,19,14,38,52,50,15,21,50,52,51,8,36,45,52,41,8,36,23,52,51,8,36,45,52,56,7,37,56,52,56,8,36,56,52,56,7,38,56,52,56,8,36,56,52,56,8,36,56,52,56,7,37,56,52,56,8,36,56,52,56,8,36,56,52,56,8,36,56,52,56,8,36,56,52,56,7,37,56,52,56,12,28,56,52,56,8,36,56,52,56,8,36,56,52,56,8,36,56,52,56,8,36,56,52,56,8,36,56,52,56,8,36,56,52,56,8,36,56,52,56,8,36,56,52,56,8,36,56,52,56,8,36,56,52,56,8,36,56,52,56,8,36,56,52,56,8,36,56,52,56,8,36,56,52,56,8,36,56,52,56,8,36,56,52,56,8,36,56,52,56,8,36,56,52,56,8,36,56,52,44,8,36,35,52,0,8,36,7,52,56,11,30,26,52,41,8,35,41,52,56,8,36,56,52,41,8,36,41,52,56,8,36,56,52,41,8,36,41,52,56,9,33,56,52,41,8,36,56,52,56,8,36,56,52,59,12,29,59,52,59,11,30,74,52,56,8,36,56,52,56,12,29,56,52,41,8,36,41,52,41,8,36,41,52,41,8,36,41,52,42,8,36,57,52,41,8,36,56,52,41,8,36,41,52,41,8,36,41,52,54,7,37,54,52,41,8,36,41,52,41,8,36,41,52,41,7,37,41,52,41,8,36,41,52,41,8,36,56,52,41,8,36,41,52,56,7,37,56,52,56,22,7,56,52,56,7,37,56,52,56,8,36,25],"a80":[52,0,0,0,0,52,56,21,11,56,52,56,7,38,26,52,56,7,38,48,52,56,8,36,56,52,56,8,36,56,52,50,8,37,50,52,56,19,14,32,52,56,19,18,56,52,56,15,18,56,52,51,7,37,45,52,46,7,37,37,52,25,15,22,25,52,31,8,36,10,52,22,19,14,13,52,56,8,36,56,52,56,8,36,56,52,56,8,36,56,52,56,8,36,56,52,56,8,36,56,52,56,10,32,56,52,56,7,37,56,52,56,8,36,56,52,56,7,37,56,52,56,8,36,56,52,56,8,36,56,52,47,19,14,38,52,50,15,21,50,52,51,8,36,45,52,41,8,36,23,52,51,8,36,45,52,56,7,37,56,52,56,8,36,56,52,56,7,38,56,52,56,8,36,56,52,56,8,36,56,52,56,7,37,56,52,56,8,36,56,52,56,8,36,56,52,56,8,36,56,52,56,8,36,56,52,56,7,37,56,52,56,12,28,56,52,56,8,36,56,52,56,8,36,56,52,56,8,36,56,52,56,8,36,56,52,56,8,36,56,52,56,8,36,56,52,56,8,36,56,52,56,8,36,56,52,56,8,36,56,52,56,8,36,56,52,56,8,36,56,52,56,8,36,56,52,56,8,36,56,52,56,8,36,56,52,56,8,36,56,52,56,8,36,56,52,56,8,36,56,52,56,8,36,56,52,56,8,36,56,52,44,8,36,35,52,0,8,36,7,52,56,11,30,26,52,41,8,35,41,52,56,8,36,56,52,41,8,36,41,52,56,8,36,56,52,41,8,36,41,52,56,9,33,56,52,41,8,36,56,52,56,8,36,56,52,59,12,29,59,52,59,11,30,74,52,56,8,36,56,52,56,12,29,56,52,41,8,36,41,52,41,8,36,41,52,41,8,36,41,52,42,8,36,57,52,41,8,36,56,52,41,8,36,41,52,41,8,36,41,52,54,7,37,54,52,41,8,36,41,52,41,8,36,41,52,41,7,37,41,52,41,8,36,41,52,41,8,36,56,52,41,8,36,41,52,56,7,37,56,52,56,22,7,56,52,56,7,37,56,52,56,8,36,25],"m81":[53,0,0,0,0,53,57,20,11,57,53,57,7,37,26,53,57,7,37,48,53,57,8,35,57,53,57,8,35,57,53,50,8,36,50,53,57,19,14,33,53,57,19,18,57,53,57,15,18,57,53,51,7,37,45,53,47,7,37,37,53,26,15,21,26,53,33,8,36,11,53,23,19,14,14,53,57,8,36,57,53,57,8,35,57,53,57,8,35,57,53,57,8,35,57,53,57,7,36,57,53,57,10,32,57,53,57,7,36,57,53,57,8,35,57,53,57,7,36,57,53,57,8,35,57,53,57,8,36,57,53,48,19,14,39,53,51,15,21,51,53,51,8,36,45,53,41,8,36,22,53,51,8,36,45,53,57,7,37,57,53,57,8,35,57,53,57,7,37,57,53,57,8,35,57,53,57,8,36,57,53,57,7,36,57,53,57,8,36,57,53,57,8,36,57,53,57,8,36,57,53,57,8,35,57,53,57,7,37,57,53,57,12,28,57,53,57,8,36,57,53,57,8,36,57,53,57,8,35,57,53,57,8,35,57,53,57,8,35,57,53,57,8,35,57,53,57,8,35,57,53,57,8,35,57,53,57,8,35,57,53,57,8,35,57,53,57,8,35,57,53,57,8,35,57,53,57,8,35,57,53,57,8,36,57,53,57,8,35,57,53,57,8,36,57,53,57,8,36,57,53,57,8,36,57,53,57,8,35,57,53,45,8,36,36,53,0,8,36,7,53,57,11,30,26,53,41,8,35,41,53,57,8,35,57,53,41,8,36,41,53,57,8,35,57,53,41,8,35,41,53,57,9,33,57,53,41,8,35,56,53,57,8,35,57,53,60,12,29,60,53,60,11,29,75,53,57,8,36,57,53,57,12,29,57,53,41,8,36,41,53,41,8,35,41,53,41,8,35,41,53,43,8,35,58,53,41,8,35,56,53,41,8,35,41,53,41,8,35,41,53,54,7,37,54,53,41,8,35,41,53,41,8,35,41,53,41,7,37,41,53,41,8,36,41,53,41,8,35,56,53,41,8,36,41,53,57,7,37,57,53,57,22,7,57,53,57,7,37,57,53,57,8,35,26],"a81":[53,0,0,0,0,53,57,20,11,57,53,57,7,37,26,53,57,7,37,48,53,57,8,35,57,53,57,8,35,57,53,50,8,36,50,53,57,19,14,33,53,57,19,18,57,53,57,15,18,57,53,51,7,37,45,53,47,7,37,37,53,26,15,21,26,53,33,8,36,11,53,23,19,14,14,53,57,8,36,57,53,57,8,35,57,53,57,8,35,57,53,57,8,35,57,53,57,7,36,57,53,57,10,32,57,53,57,7,36,57,53,57,8,35,57,53,57,7,36,57,53,57,8,35,57,53,57,8,36,57,53,48,19,14,39,53,51,15,21,51,53,51,8,36,45,53,41,8,36,22,53,51,8,36,45,53,57,7,37,57,53,57,8,35,57,53,57,7,37,57,53,57,8,35,57,53,57,8,36,57,53,57,7,36,57,53,57,8,36,57,53,57,8,36,57,53,57,8,36,57,53,57,8,35,57,53,57,7,37,57,53,57,12,28,57,53,57,8,36,57,53,57,8,36,57,53,57,8,35,57,53,57,8,35,57,53,57,8,35,57,53,57,8,35,57,53,57,8,35,57,53,57,8,35,57,53,57,8,35,57,53,57,8,35,57,53,57,8,35,57,53,57,8,35,57,53,57,8,35,57,53,57,8,36,57,53,57,8,35,57,53,57,8,36,57,53,57,8,36,57,53,57,8,36,57,53,57,8,35,57,53,45,8,36,36,53,0,8,36,7,53,57,11,30,26,53,41,8,35,41,53,57,8,35,57,53,41,8,36,41,53,57,8,35,57,53,41,8,35,41,53,57,9,33,57,53,41,8,35,56,53,57,8,35,57,53,60,12,29,60,53,60,11,29,75,53,57,8,36,57,53,57,12,29,57,53,41,8,36,41,53,41,8,35,41,53,41,8,35,41,53,43,8,35,58,53,41,8,35,56,53,41,8,35,41,53,41,8,35,41,53,54,7,37,54,53,41,8,35,41,53,41,8,35,41,53,41,7,37,41,53,41,8,36,41,53,41,8,35,56,53,41,8,36,41,53,57,7,37,57,53,57,22,7,57,53,57,7,37,57,53,57,8,35,26],"m84":[55,0,0,0,0,55,59,22,11,59,55,59,8,39,28,55,59,8,39,50,55,59,9,38,59,55,59,9,37,59,55,53,9,38,53,55,59,20,15,34,55,59,20,20,59,55,59,15,20,59,55,53,9,39,47,55,49,9,39,39,55,27,16,23,27,55,33,8,39,11,55,24,20,15,14,55,59,8,39,59,55,59,9,38,59,55,59,9,38,59,55,59,9,38,59,55,59,8,39,59,55,59,10,35,59,55,59,8,39,59,55,59,9,38,59,55,59,9,38,59,55,59,9,38,59,55,59,9,38,59,55,49,20,15,39,55,52,16,23,52,55,53,8,39,47,55,43,8,39,24,55,53,8,39,47,55,59,8,39,59,55,59,9,38,59,55,59,8,39,59,55,59,9,38,59,55,59,9,39,59,55,59,8,39,59,55,59,9,39,59,55,59,9,39,59,55,59,9,37,59,55,59,9,38,59,55,59,9,39,59,55,59,12,31,59,55,59,9,39,59,55,59,9,39,59,55,59,9,38,59,55,59,9,38,59,55,59,9,38,59,55,59,9,38,59,55,59,9,38,59,55,59,9,38,59,55,59,9,38,59,55,59,9,38,59,55,59,9,38,59,55,59,9,38,59,55,59,9,38,59,55,59,8,39,59,55,59,9,37,59,55,59,8,39,59,55,59,9,38,59,55,59,8,39,59,55,59,8,39,59,55,47,8,39,38,55,0,8,39,8,55,59,12,31,27,55,43,9,38,43,55,59,9,38,59,55,43,9,39,43,55,59,9,38,59,55,43,9,38,43,55,59,10,35,59,55,43,9,38,59,55,59,9,38,59,55,62,12,31,62,55,62,12,31,78,55,59,9,39,59,55,59,12,31,59,55,43,8,39,43,55,43,9,38,43,55,43,9,38,43,55,45,9,38,61,55,43,9,38,59,55,43,9,38,43,55,43,8,38,43,55,56,8,39,56,55,43,9,38,43,55,43,9,38,43,55,43,8,39,43,55,43,8,39,43,55,43,9,37,59,55,43,8,39,43,55,59,9,39,59,55,59,24,8,59,55,59,9,39,59,55,59,9,38,27],"a84":[55,0,0,0,0,55,59,22,11,59,55,59,8,39,27,55,59,8,39,50,55,59,9,38,59,55,59,9,37,59,55,53,9,38,53,55,59,20,15,34,55,59,20,20,59,55,59,15,20,59,55,53,9,39,47,55,49,9,39,39,55,27,16,23,27,55,33,8,39,11,55,24,20,15,14,55,59,8,39,59,55,59,9,38,59,55,59,9,38,59,55,59,9,38,59,55,59,8,39,59,55,59,10,35,59,55,59,8,39,59,55,59,9,38,59,55,59,9,38,59,55,59,9,38,59,55,59,9,38,59,55,49,20,15,39,55,52,16,23,52,55,53,8,39,47,55,43,8,39,24,55,53,8,39,47,55,59,8,39,59,55,59,9,38,59,55,59,8,39,59,55,59,9,38,59,55,59,9,39,59,55,59,8,39,59,55,59,9,39,59,55,59,9,39,59,55,59,9,37,59,55,59,9,38,59,55,59,9,39,59,55,59,12,31,59,55,59,9,39,59,55,59,9,39,59,55,59,9,38,59,55,59,9,38,59,55,59,9,38,59,55,59,9,38,59,55,59,9,38,59,55,59,9,38,59,55,59,9,38,59,55,59,9,38,59,55,59,9,38,59,55,59,9,38,59,55,59,9,38,59,55,59,8,39,59,55,59,9,37,59,55,59,8,39,59,55,59,9,38,59,55,59,8,39,59,55,59,8,39,59,55,47,8,39,38,55,0,8,39,8,55,59,12,31,27,55,43,9,38,43,55,59,9,38,59,55,43,9,39,43,55,59,9,38,59,55,43,9,38,43,55,59,10,35,59,55,43,9,38,59,55,59,9,38,59,55,62,12,31,62,55,62,12,31,78,55,59,9,39,59,55,59,12,31,59,55,43,8,39,43,55,43,9,38,43,55,43,9,38,43,55,45,9,38,61,55,43,9,38,59,55,43,9,38,43,55,43,8,38,43,55,56,8,39,56,55,43,9,38,43,55,43,9,38,43,55,43,8,39,43,55,43,8,39,43,55,43,9,37,59,55,43,8,39,43,55,59,9,39,59,55,59,24,8,59,55,59,9,39,59,55,59,9,38,27],"m90":[59,0,0,0,0,59,63,23,12,63,59,63,8,41,29,59,63,9,40,53,59,63,9,39,63,59,63,9,40,63,59,56,9,40,56,59,63,21,16,36,59,63,21,20,63,59,63,17,20,63,59,57,9,40,51,59,53,9,40,42,59,29,17,24,29,59,36,8,41,12,59,25,21,16,15,59,63,8,41,63,59,63,9,39,63,59,63,9,39,63,59,63,9,39,63,59,63,8,40,63,59,63,11,36,63,59,63,9,39,63,59,63,9,39,63,59,63,9,39,63,59,63,9,40,63,59,63,9,40,63,59,53,21,16,43,59,56,17,24,56,59,57,8,41,51,59,46,8,41,25,59,57,8,41,51,59,63,9,40,63,59,63,9,39,63,59,63,8,41,63,59,63,9,39,63,59,63,9,40,63,59,63,9,39,63,59,63,9,40,63,59,63,9,40,63,59,63,9,40,63,59,63,9,39,63,59,63,9,40,63,59,63,13,32,63,59,63,9,40,63,59,63,9,40,63,59,63,9,39,63,59,63,9,39,63,59,63,9,39,63,59,63,9,39,63,59,63,9,39,63,59,63,9,39,63,59,63,9,39,63,59,63,9,39,63,59,63,9,39,63,59,63,9,39,63,59,63,9,39,63,59,63,8,41,63,59,63,9,39,63,59,63,8,41,63,59,63,9,40,63,59,63,8,41,63,59,63,9,39,63,59,50,8,41,40,59,0,8,41,8,59,63,12,33,29,59,46,9,39,46,59,63,9,39,63,59,46,9,40,46,59,63,9,39,63,59,46,9,39,46,59,63,11,36,63,59,46,9,39,63,59,63,9,39,63,59,67,13,32,67,59,67,13,32,84,59,63,9,40,63,59,63,13,32,63,59,46,8,41,46,59,46,9,39,46,59,46,9,39,46,59,48,9,39,65,59,46,9,39,63,59,46,9,39,46,59,46,9,39,46,59,60,9,40,60,59,46,9,39,46,59,46,9,39,46,59,46,8,41,46,59,46,8,41,46,59,46,9,39,63,59,46,8,41,46,59,63,9,40,63,59,63,25,8,63,59,63,9,40,63,59,63,9,39,28],"a90":[59,0,0,0,0,59,63,23,12,63,59,63,8,41,29,59,63,9,40,53,59,63,9,39,63,59,63,9,40,63,59,56,9,40,56,59,63,21,16,36,59,63,21,20,63,59,63,17,20,63,59,57,9,40,51,59,53,9,40,42,59,29,17,24,29,59,36,8,41,12,59,25,21,16,15,59,63,8,41,63,59,63,9,39,63,59,63,9,39,63,59,63,9,39,63,59,63,8,40,63,59,63,11,36,63,59,63,9,39,63,59,63,9,39,63,59,63,9,39,63,59,63,9,40,63,59,63,9,40,63,59,53,21,16,43,59,56,17,24,56,59,57,8,41,51,59,46,8,41,25,59,57,8,41,51,59,63,9,40,63,59,63,9,39,63,59,63,8,41,63,59,63,9,39,63,59,63,9,40,63,59,63,9,39,63,59,63,9,40,63,59,63,9,40,63,59,63,9,40,63,59,63,9,39,63,59,63,9,40,63,59,63,13,32,63,59,63,9,40,63,59,63,9,40,63,59,63,9,39,63,59,63,9,39,63,59,63,9,39,63,59,63,9,39,63,59,63,9,39,63,59,63,9,39,63,59,63,9,39,63,59,63,9,39,63,59,63,9,39,63,59,63,9,39,63,59,63,9,39,63,59,63,8,41,63,59,63,9,39,63,59,63,8,41,63,59,63,9,40,63,59,63,8,41,63,59,63,9,39,63,59,50,8,41,40,59,0,8,41,8,59,63,12,33,29,59,46,9,39,46,59,63,9,39,63,59,46,9,40,46,59,63,9,39,63,59,46,9,39,46,59,63,11,36,63,59,46,9,39,63,59,63,9,39,63,59,67,13,32,67,59,67,13,32,84,59,63,9,40,63,59,63,13,32,63,59,46,8,41,46,59,46,9,39,46,59,46,9,39,46,59,48,9,39,65,59,46,9,39,63,59,46,9,39,46,59,46,9,39,46,59,60,9,40,60,59,46,9,39,46,59,46,9,39,46,59,46,8,41,46,59,46,8,41,46,59,46,9,39,63,59,46,8,41,46,59,63,9,40,63,59,63,25,8,63,59,63,9,40,63,59,63,9,39,28],"m96":[62,0,0,0,0,62,67,24,13,67,62,67,9,43,32,62,67,9,44,56,62,67,10,42,67,62,67,10,42,67,62,60,10,43,60,62,67,22,17,39,62,67,22,22,67,62,67,18,22,67,62,61,9,43,54,62,56,9,43,45,62,31,18,26,31,62,38,9,43,12,62,27,22,17,16,62,67,9,43,67,62,67,10,42,67,62,67,10,42,67,62,67,10,42,67,62,67,9,43,67,62,67,12,39,67,62,67,9,43,67,62,67,10,42,67,62,67,9,43,67,62,67,10,43,67,62,67,10,42,67,62,56,22,17,45,62,60,18,26,60,62,61,9,43,54,62,49,9,43,27,62,61,9,43,54,62,67,9,44,67,62,67,10,42,67,62,67,9,43,67,62,67,10,42,67,62,67,10,43,67,62,67,9,43,67,62,67,10,43,67,62,67,10,43,67,62,67,10,43,67,62,67,10,42,67,62,67,9,43,67,62,67,14,34,67,62,67,10,43,67,62,67,10,43,67,62,67,10,42,67,62,67,10,42,67,62,67,10,42,67,62,67,10,42,67,62,67,10,42,67,62,67,10,42,67,62,67,10,42,67,62,67,10,42,67,62,67,10,42,67,62,67,10,42,67,62,67,10,42,67,62,67,9,43,67,62,67,10,42,67,62,67,9,43,67,62,67,10,43,67,62,67,9,43,67,62,67,10,42,67,62,53,9,43,43,62,0,9,43,9,62,67,13,35,31,62,49,10,42,49,62,67,10,42,67,62,49,10,43,49,62,67,10,42,67,62,49,10,42,49,62,67,11,39,67,62,49,10,42,67,62,67,10,42,67,62,71,14,34,71,62,71,13,35,89,62,67,10,43,67,62,67,14,34,67,62,49,9,44,49,62,49,10,42,49,62,49,10,42,49,62,51,10,42,69,62,49,10,42,67,62,49,10,42,49,62,49,9,43,49,62,64,9,44,64,62,49,10,42,49,62,49,10,42,49,62,49,9,44,49,62,49,9,43,49,62,49,10,42,67,62,49,9,43,49,62,67,9,43,67,62,67,26,9,67,62,67,9,43,67,62,67,10,42,30],"a96":[62,0,0,0,0,62,67,24,13,67,62,67,9,43,31,62,67,9,44,56,62,67,10,42,67,62,67,10,42,67,62,60,10,43,60,62,67,22,17,39,62,67,22,22,67,62,67,18,22,67,62,61,9,43,54,62,56,9,43,45,62,31,18,26,31,62,38,9,43,12,62,27,22,17,16,62,67,9,43,67,62,67,10,42,67,62,67,10,42,67,62,67,10,42,67,62,67,9,43,67,62,67,12,39,67,62,67,9,43,67,62,67,10,42,67,62,67,9,43,67,62,67,10,43,67,62,67,10,42,67,62,56,22,17,45,62,60,18,26,60,62,61,9,43,54,62,49,9,43,27,62,61,9,43,54,62,67,9,44,67,62,67,10,42,67,62,67,9,43,67,62,67,10,42,67,62,67,10,43,67,62,67,9,43,67,62,67,10,43,67,62,67,10,43,67,62,67,10,43,67,62,67,10,42,67,62,67,9,43,67,62,67,14,34,67,62,67,10,43,67,62,67,10,43,67,62,67,10,42,67,62,67,10,42,67,62,67,10,42,67,62,67,10,42,67,62,67,10,42,67,62,67,10,42,67,62,67,10,42,67,62,67,10,42,67,62,67,10,42,67,62,67,10,42,67,62,67,10,42,67,62,67,9,43,67,62,67,10,42,67,62,67,9,43,67,62,67,10,43,67,62,67,9,43,67,62,67,10,42,67,62,53,9,43,43,62,0,9,43,9,62,67,13,35,31,62,49,10,42,49,62,67,10,42,67,62,49,10,43,49,62,67,10,42,67,62,49,10,42,49,62,67,11,39,67,62,49,10,42,67,62,67,10,42,67,62,71,14,34,71,62,71,13,35,89,62,67,10,43,67,62,67,14,34,67,62,49,9,44,49,62,49,10,42,49,62,49,10,42,49,62,51,10,42,69,62,49,10,42,67,62,49,10,42,49,62,49,9,43,49,62,64,9,44,64,62,49,10,42,49,62,49,10,42,49,62,49,9,44,49,62,49,9,43,49,62,49,10,42,67,62,49,9,43,49,62,67,9,43,67,62,67,26,9,67,62,67,9,43,67,62,67,10,42,30],"m108":[70,0,0,0,0,70,76,27,14,76,70,76,10,49,35,70,76,10,49,64,70,76,11,48,76,70,76,11,47,76,70,68,11,48,68,70,76,25,19,43,70,76,25,25,76,70,76,19,25,76,70,68,11,48,60,70,63,11,48,50,70,35,20,29,35,70,43,10,49,14,70,30,25,19,18,70,76,10,49,76,70,76,11,48,76,70,76,11,48,76,70,76,11,48,76,70,76,11,48,76,70,76,13,43,76,70,76,10,49,76,70,76,11,48,76,70,76,11,48,76,70,76,11,48,76,70,76,11,48,76,70,63,25,19,51,70,67,20,29,67,70,68,10,49,60,70,55,10,49,30,70,68,10,49,60,70,76,10,49,76,70,76,11,48,76,70,76,10,49,76,70,76,11,48,76,70,76,11,48,76,70,76,10,49,76,70,76,11,48,76,70,76,11,48,76,70,76,11,47,76,70,76,11,48,76,70,76,11,48,76,70,76,15,39,76,70,76,11,48,76,70,76,11,48,76,70,76,11,48,76,70,76,11,48,76,70,76,11,48,76,70,76,11,48,76,70,76,11,48,76,70,76,11,48,76,70,76,11,48,76,70,76,11,48,76,70,76,11,48,76,70,76,11,48,76,70,76,11,48,76,70,76,10,49,76,70,76,11,47,76,70,76,10,49,76,70,76,11,48,76,70,76,10,49,76,70,76,10,49,76,70,60,10,49,48,70,0,10,49,10,70,76,15,39,35,70,55,11,48,55,70,76,11,48,76,70,55,11,48,55,70,76,11,48,76,70,55,11,48,55,70,76,12,44,76,70,55,11,48,76,70,76,11,48,76,70,80,15,38,80,70,80,15,39,101,70,76,11,48,76,70,76,15,39,76,70,55,10,50,55,70,55,11,48,55,70,55,11,48,55,70,57,11,48,78,70,55,11,48,76,70,55,11,48,55,70,55,10,48,55,70,72,10,49,72,70,55,11,48,55,70,55,11,48,55,70,55,10,50,55,70,55,10,49,55,70,55,11,47,76,70,55,10,49,55,70,76,11,48,76,70,76,30,10,76,70,76,11,48,76,70,76,11,48,35],"a108":[70,0,0,0,0,70,76,27,14,76,70,76,10,49,35,70,76,10,49,64,70,76,11,48,76,70,76,11,47,76,70,68,11,48,68,70,76,25,19,43,70,76,25,25,76,70,76,19,25,76,70,68,11,48,60,70,63,11,48,50,70,35,20,29,35,70,43,10,49,14,70,30,25,19,18,70,76,10,49,76,70,76,11,48,76,70,76,11,48,76,70,76,11,48,76,70,76,11,48,76,70,76,13,43,76,70,76,10,49,76,70,76,11,48,76,70,76,11,48,76,70,76,11,48,76,70,76,11,48,76,70,63,25,19,51,70,67,20,29,67,70,68,10,49,60,70,55,10,49,30,70,68,10,49,60,70,76,10,49,76,70,76,11,48,76,70,76,10,49,76,70,76,11,48,76,70,76,11,48,76,70,76,10,49,76,70,76,11,48,76,70,76,11,48,76,70,76,11,47,76,70,76,11,48,76,70,76,11,48,76,70,76,15,39,76,70,76,11,48,76,70,76,11,48,76,70,76,11,48,76,70,76,11,48,76,70,76,11,48,76,70,76,11,48,76,70,76,11,48,76,70,76,11,48,76,70,76,11,48,76,70,76,11,48,76,70,76,11,48,76,70,76,11,48,76,70,76,11,48,76,70,76,10,49,76,70,76,11,47,76,70,76,10,49,76,70,76,11,48,76,70,76,10,49,76,70,76,10,49,76,70,60,10,49,48,70,0,10,49,10,70,76,15,39,35,70,55,11,48,55,70,76,11,48,76,70,55,11,48,55,70,76,11,48,76,70,55,11,48,55,70,76,12,44,76,70,55,11,48,76,70,76,11,48,76,70,80,15,38,80,70,80,15,39,101,70,76,11,48,76,70,76,15,39,76,70,55,10,50,55,70,55,11,48,55,70,55,11,48,55,70,57,11,48,78,70,55,11,48,76,70,55,11,48,55,70,55,10,48,55,70,72,10,49,72,70,55,11,48,55,70,55,11,48,55,70,55,10,50,55,70,55,10,49,55,70,55,11,47,76,70,55,10,49,55,70,76,11,48,76,70,76,30,10,76,70,76,11,48,76,70,76,11,48,35]},"fonts":{}};
	  if (typeof bwipjs_fonts == "object") {
	    bwipjs_fonts.fontsets[0] = desc;
	    bwipjs_fonts.names["OCR-A"] = 0;
	  } else {
	    module.exports = desc;
	  }
	})();
	// fnt1-desc.js
	// $ node genfont 1
	(function() {
	  var desc = {"name":"OCR-B","minsize":8,"maxsize":108,"minchar":32,"maxchar":126,"sizes":{"8":8,"9":9,"10":10,"12":12,"16":16,"18":18,"20":20,"24":24,"27":27,"30":30,"32":32,"36":36,"40":40,"45":45,"48":48,"50":50,"54":54,"56":56,"60":60,"63":63,"64":64,"70":70,"72":72,"80":80,"81":81,"84":84,"90":90,"96":96,"108":108},"metrics":{"m8":[5,0,0,0,0,5,6,2,1,7,5,6,1,3,2,5,6,0,4,6,5,6,1,4,6,5,6,1,4,6,5,6,1,4,6,5,6,2,1,4,5,6,2,3,6,5,6,1,3,6,5,5,0,5,4,5,5,0,5,5,5,2,1,3,3,5,3,0,5,1,5,1,2,2,1,5,6,1,3,6,5,6,1,4,6,5,6,0,3,6,5,6,0,4,6,5,6,0,4,6,5,6,0,5,6,5,6,0,4,6,5,6,1,4,6,5,6,1,4,6,5,6,1,3,6,5,6,1,4,6,5,3,2,2,3,5,3,1,3,5,5,5,0,5,5,5,4,0,5,3,5,5,0,5,5,5,6,1,3,7,5,6,1,3,6,5,5,0,5,5,5,5,1,3,5,5,5,1,3,5,5,5,1,3,5,5,5,1,4,5,5,5,1,3,5,5,5,1,3,5,5,5,1,3,5,5,5,1,3,5,5,5,1,3,5,5,5,1,4,5,5,5,1,4,5,5,5,1,3,5,5,5,1,3,5,5,5,1,3,5,5,5,1,3,5,5,5,1,3,5,5,5,1,3,5,5,5,1,3,5,5,5,0,5,5,5,5,1,3,5,5,5,0,5,5,5,5,1,3,5,5,5,0,5,5,5,5,0,5,5,5,5,1,4,5,5,6,1,4,6,5,6,1,3,6,5,6,0,4,6,5,6,0,5,4,5,-1,0,5,1,5,6,2,1,1,5,4,1,3,4,5,6,1,4,6,5,4,1,3,4,5,6,1,3,6,5,4,1,4,4,5,6,0,5,6,5,4,1,3,5,5,6,1,3,6,5,6,1,2,6,5,6,0,3,7,5,6,1,4,6,5,6,2,3,6,5,4,1,4,4,5,4,1,3,4,5,4,1,4,4,5,4,1,4,5,5,4,1,3,5,5,4,1,3,4,5,4,1,3,4,5,6,1,4,6,5,4,1,3,4,5,4,0,5,4,5,4,1,4,4,5,4,1,4,4,5,4,0,5,5,5,4,1,4,4,5,6,0,5,6,5,6,2,1,7,5,6,0,5,6,5,5,0,5,1],"a8":[5,0,0,0,0,5,6,2,1,7,5,6,1,3,3,5,6,0,4,6,5,6,1,4,6,5,6,1,4,6,5,6,1,4,6,5,6,2,1,4,5,6,2,3,6,5,6,1,3,6,5,5,0,5,4,5,5,0,5,5,5,2,1,3,3,5,3,0,5,1,5,2,2,2,2,5,6,1,3,6,5,6,1,4,6,5,6,0,3,6,5,6,0,4,6,5,6,0,4,6,5,6,0,5,6,5,6,0,4,6,5,6,1,4,6,5,6,1,4,6,5,6,1,3,6,5,6,1,4,6,5,3,2,2,3,5,3,1,3,5,5,5,0,5,5,5,4,0,5,3,5,5,0,5,5,5,6,1,3,7,5,6,1,3,6,5,5,0,5,5,5,5,1,3,5,5,5,1,3,5,5,5,1,3,5,5,5,1,4,5,5,5,1,3,5,5,5,1,3,5,5,5,1,3,5,5,5,1,3,5,5,5,1,3,5,5,5,1,4,5,5,5,1,4,5,5,5,1,3,5,5,5,1,3,5,5,5,1,3,5,5,5,1,3,5,5,5,1,3,5,5,5,1,3,5,5,5,1,3,5,5,5,0,5,5,5,5,1,3,5,5,5,0,5,5,5,5,1,3,5,5,5,0,5,5,5,5,0,5,5,5,5,1,4,5,5,6,1,4,6,5,6,1,3,6,5,6,0,4,6,5,6,0,5,4,5,-1,0,5,1,5,6,2,1,2,5,4,1,3,4,5,6,1,4,6,5,4,1,3,4,5,6,1,3,6,5,4,1,4,4,5,6,0,5,6,5,4,1,3,5,5,6,1,3,6,5,6,1,3,6,5,6,0,3,7,5,6,1,4,6,5,6,2,3,6,5,4,1,4,4,5,4,1,3,4,5,4,1,4,4,5,4,1,4,5,5,4,1,3,5,5,4,1,3,4,5,4,1,3,4,5,6,1,4,6,5,4,1,3,4,5,4,0,5,4,5,4,1,4,4,5,4,1,4,4,5,4,0,5,5,5,4,1,4,4,5,6,0,5,6,5,6,2,1,7,5,6,0,5,6,5,5,0,5,1],"m9":[6,0,0,0,0,6,7,2,1,8,6,6,1,4,3,6,6,1,4,6,6,7,1,4,7,6,6,1,4,6,6,6,1,4,6,6,7,2,1,4,6,6,2,3,6,6,6,1,3,6,6,6,0,5,5,6,6,0,5,5,6,3,1,4,4,6,3,0,5,1,6,2,2,2,2,6,6,1,4,6,6,6,1,4,6,6,7,1,3,7,6,6,1,4,6,6,6,0,5,6,6,7,0,5,7,6,6,1,4,6,6,7,1,4,7,6,6,1,5,6,6,6,1,4,6,6,6,1,4,6,6,4,2,2,4,6,4,1,3,6,6,6,0,5,6,6,4,0,5,2,6,6,0,5,6,6,6,1,4,7,6,6,1,4,6,6,6,0,5,6,6,6,1,4,6,6,6,1,4,6,6,6,1,4,6,6,6,1,4,6,6,6,2,4,6,6,6,1,4,6,6,6,1,4,6,6,6,0,5,6,6,6,1,3,6,6,6,1,5,6,6,6,1,5,6,6,6,1,4,6,6,6,1,4,6,6,6,1,4,6,6,6,1,4,6,6,6,1,4,6,6,6,1,4,6,6,6,1,4,6,6,6,0,5,6,6,6,1,4,6,6,6,0,5,6,6,6,1,4,6,6,6,1,4,6,6,6,0,5,6,6,6,1,4,6,6,6,2,4,6,6,6,1,4,6,6,6,0,4,6,6,7,0,5,5,6,-1,0,5,1,6,6,2,1,2,6,4,1,4,4,6,6,1,4,6,6,4,1,4,4,6,6,1,4,6,6,4,1,4,4,6,6,0,5,6,6,4,1,4,6,6,6,1,4,6,6,6,2,2,6,6,6,1,3,7,6,6,1,4,6,6,6,2,3,6,6,4,1,4,4,6,4,1,4,4,6,4,1,4,4,6,4,1,4,5,6,4,1,4,5,6,4,2,3,4,6,4,1,4,4,6,6,1,4,6,6,4,1,4,4,6,4,0,5,4,6,4,1,4,4,6,4,1,4,4,6,4,0,5,5,6,4,1,4,4,6,6,0,5,6,6,6,2,1,8,6,6,1,5,6,6,6,1,4,2],"a9":[6,0,0,0,0,6,7,2,1,8,6,6,1,4,3,6,6,1,4,6,6,7,1,4,7,6,6,1,4,6,6,6,1,4,6,6,7,2,1,4,6,6,2,3,6,6,6,1,3,6,6,6,0,5,5,6,6,0,5,5,6,3,1,4,4,6,3,0,5,1,6,2,2,2,2,6,6,1,4,6,6,6,1,4,6,6,7,1,3,7,6,6,1,4,6,6,6,0,5,6,6,7,0,5,7,6,6,1,4,6,6,7,1,4,7,6,6,1,5,6,6,6,1,4,6,6,6,1,4,6,6,4,2,2,4,6,4,1,3,6,6,6,0,5,6,6,4,0,5,2,6,6,0,5,6,6,6,1,4,7,6,6,1,4,6,6,6,0,5,6,6,6,1,4,6,6,6,1,4,6,6,6,1,4,6,6,6,1,4,6,6,6,2,4,6,6,6,1,4,6,6,6,1,4,6,6,6,0,5,6,6,6,1,3,6,6,6,1,5,6,6,6,1,5,6,6,6,1,4,6,6,6,1,4,6,6,6,1,4,6,6,6,1,4,6,6,6,1,4,6,6,6,1,4,6,6,6,1,4,6,6,6,0,5,6,6,6,1,4,6,6,6,0,5,6,6,6,1,4,6,6,6,1,4,6,6,6,0,5,6,6,6,1,4,6,6,6,2,4,6,6,6,1,4,6,6,6,0,4,6,6,7,0,5,5,6,-1,0,5,1,6,6,2,1,2,6,4,1,4,4,6,6,1,4,6,6,4,1,4,4,6,6,1,4,6,6,4,1,4,4,6,6,0,5,6,6,4,1,4,6,6,6,1,4,6,6,6,1,3,6,6,6,1,3,7,6,6,1,4,6,6,6,2,3,6,6,4,1,4,4,6,4,1,4,4,6,4,1,4,4,6,4,1,4,5,6,4,1,4,5,6,4,2,3,4,6,4,1,4,4,6,6,1,4,6,6,4,1,4,4,6,4,0,5,4,6,4,1,4,4,6,4,1,4,4,6,4,0,5,5,6,4,1,4,4,6,6,0,5,6,6,6,2,1,8,6,6,1,5,6,6,6,1,4,2],"m10":[7,0,0,0,0,7,7,3,1,8,7,7,1,4,3,7,7,0,5,7,7,7,1,5,7,7,7,1,5,7,7,7,1,5,7,7,7,2,2,4,7,7,2,3,7,7,7,1,3,7,7,6,1,5,5,7,7,1,5,7,7,2,1,4,4,7,4,1,5,1,7,2,2,2,2,7,7,1,4,7,7,7,1,5,7,7,7,1,3,7,7,7,0,5,7,7,7,0,5,7,7,7,1,5,7,7,7,1,4,7,7,7,1,5,7,7,7,0,6,7,7,7,1,4,7,7,7,1,5,7,7,5,2,2,5,7,5,0,4,7,7,7,1,5,7,7,5,1,5,3,7,7,1,5,7,7,7,1,4,8,7,7,1,4,7,7,7,1,5,7,7,7,1,4,7,7,7,1,4,7,7,7,1,4,7,7,7,1,5,7,7,7,2,4,7,7,7,1,4,7,7,7,1,4,7,7,7,1,5,7,7,7,1,3,7,7,7,1,5,7,7,7,1,5,7,7,7,1,4,7,7,7,1,4,7,7,7,1,4,7,7,7,1,4,7,7,7,1,4,7,7,7,1,4,7,7,7,1,4,7,7,7,1,5,7,7,7,1,4,7,7,7,0,6,7,7,7,1,4,7,7,7,1,5,7,7,7,1,5,7,7,7,1,5,7,7,7,2,4,7,7,7,1,4,7,7,7,1,4,7,7,7,1,5,4,7,-1,1,5,1,7,7,2,1,2,7,5,1,4,5,7,7,1,5,7,7,5,1,4,5,7,7,1,4,7,7,5,1,5,5,7,7,1,5,7,7,5,1,4,7,7,7,1,4,7,7,7,2,3,7,7,7,1,3,9,7,7,2,4,7,7,7,2,3,7,7,5,1,5,5,7,5,1,4,5,7,5,1,5,5,7,5,1,5,7,7,5,1,4,7,7,5,2,3,5,7,5,1,4,5,7,7,0,5,7,7,5,1,4,5,7,5,1,5,5,7,5,1,5,5,7,5,1,5,5,7,5,1,5,7,7,5,1,5,5,7,7,1,6,7,7,7,3,1,9,7,7,0,6,7,7,6,1,5,1],"a10":[7,0,0,0,0,7,7,3,1,8,7,7,1,4,3,7,7,0,5,7,7,7,1,5,7,7,7,1,5,7,7,7,1,5,7,7,7,2,2,4,7,7,2,3,7,7,7,1,3,7,7,6,1,5,5,7,7,1,5,7,7,2,1,4,4,7,4,1,5,1,7,2,2,3,2,7,7,1,4,7,7,7,1,5,7,7,7,1,3,7,7,7,0,5,7,7,7,0,5,7,7,7,1,5,7,7,7,1,4,7,7,7,1,5,7,7,7,0,6,7,7,7,1,4,7,7,7,1,5,7,7,5,2,2,5,7,5,1,3,7,7,7,1,5,7,7,5,1,5,3,7,7,1,5,7,7,7,1,4,8,7,7,1,4,7,7,7,1,5,7,7,7,1,4,7,7,7,1,4,7,7,7,1,4,7,7,7,1,5,7,7,7,2,4,7,7,7,1,5,7,7,7,1,4,7,7,7,1,5,7,7,7,1,3,7,7,7,1,5,7,7,7,1,5,7,7,7,1,4,7,7,7,1,4,7,7,7,1,4,7,7,7,1,4,7,7,7,1,4,7,7,7,1,4,7,7,7,1,4,7,7,7,1,5,7,7,7,1,4,7,7,7,0,6,7,7,7,1,4,7,7,7,1,5,7,7,7,1,5,7,7,7,1,5,7,7,7,2,4,7,7,7,1,4,7,7,7,1,4,7,7,7,1,5,4,7,-1,1,5,1,7,7,2,1,2,7,5,1,4,5,7,7,1,5,7,7,5,1,4,5,7,7,1,4,7,7,5,1,5,5,7,7,1,5,7,7,5,1,4,7,7,7,1,4,7,7,7,2,3,7,7,7,1,3,9,7,7,2,4,7,7,7,2,3,7,7,5,1,5,5,7,5,1,4,5,7,5,1,5,5,7,5,1,5,7,7,5,1,4,7,7,5,2,3,5,7,5,1,4,5,7,7,0,5,7,7,5,1,4,5,7,5,1,5,5,7,5,1,5,5,7,5,1,5,5,7,5,1,5,7,7,5,1,5,5,7,7,1,6,7,7,7,3,1,9,7,7,0,6,7,7,6,1,5,1],"m12":[8,0,0,0,0,8,9,3,1,10,8,8,2,4,3,8,8,1,5,8,8,9,1,6,9,8,8,1,6,8,8,8,1,6,8,8,9,3,2,5,8,8,3,4,8,8,8,1,4,8,8,8,0,7,7,8,8,0,7,7,8,3,1,5,5,8,4,1,6,1,8,2,3,3,2,8,8,1,5,8,8,8,1,6,8,8,9,1,4,9,8,8,1,5,8,8,8,0,6,8,8,9,0,7,9,8,8,1,5,8,8,9,1,6,9,8,8,1,6,8,8,8,1,5,8,8,8,1,6,8,8,6,3,2,6,8,6,1,4,8,8,8,1,6,8,8,6,1,6,4,8,8,1,6,8,8,8,2,4,9,8,8,1,5,8,8,8,1,6,8,8,8,1,5,8,8,8,2,4,8,8,8,2,4,8,8,8,2,5,8,8,8,2,4,8,8,8,1,5,8,8,8,2,4,8,8,8,1,5,8,8,8,1,4,8,8,8,1,6,8,8,8,2,5,8,8,8,1,5,8,8,8,1,5,8,8,8,1,5,8,8,8,2,4,8,8,8,1,5,8,8,8,2,4,8,8,8,2,4,8,8,8,0,7,8,8,8,1,5,8,8,8,1,6,8,8,8,1,5,8,8,8,1,6,8,8,8,1,5,8,8,8,1,6,8,8,8,2,5,8,8,8,1,5,8,8,8,1,5,8,8,9,1,6,6,8,-2,1,6,1,8,8,3,1,2,8,6,1,5,6,8,8,1,6,8,8,6,2,4,6,8,8,1,5,8,8,6,1,6,6,8,8,1,5,8,8,6,1,5,8,8,8,2,4,8,8,8,2,3,8,8,8,1,4,10,8,8,2,5,8,8,8,3,4,8,8,6,1,6,6,8,6,1,5,6,8,6,1,6,6,8,6,1,6,8,8,6,1,5,8,8,6,2,4,6,8,6,2,4,6,8,8,1,6,8,8,6,1,5,6,8,6,1,6,6,8,6,1,6,6,8,6,1,6,6,8,6,1,6,8,8,6,1,6,6,8,8,1,6,8,8,8,3,1,11,8,8,1,6,8,8,8,1,6,2],"a12":[8,0,0,0,0,8,9,3,2,10,8,8,1,5,4,8,8,1,6,8,8,9,1,6,9,8,8,1,6,8,8,8,1,6,8,8,9,3,2,5,8,8,2,5,8,8,8,1,5,8,8,8,0,7,7,8,8,0,7,7,8,3,1,5,5,8,5,1,6,2,8,3,3,3,3,8,8,1,5,8,8,8,1,6,8,8,9,1,4,9,8,8,1,6,8,8,9,0,7,9,8,9,0,7,9,8,9,1,6,9,8,9,1,6,9,8,9,1,6,9,8,8,1,6,8,8,8,1,6,8,8,6,2,3,6,8,6,1,5,8,8,8,1,6,8,8,6,1,6,4,8,8,1,6,8,8,8,1,5,9,8,8,1,6,8,8,8,1,6,8,8,8,1,6,8,8,8,1,5,8,8,8,1,6,8,8,8,1,6,8,8,8,2,4,8,8,8,1,5,8,8,8,1,6,8,8,8,1,5,8,8,8,1,5,8,8,8,1,6,8,8,8,1,6,8,8,8,1,6,8,8,8,1,6,8,8,8,1,6,8,8,8,1,6,8,8,8,1,6,8,8,8,1,6,8,8,8,1,6,8,8,8,0,7,8,8,8,1,6,8,8,8,1,6,8,8,8,1,6,8,8,8,1,6,8,8,8,1,5,8,8,8,1,6,8,8,8,2,5,8,8,8,1,5,8,8,8,1,5,8,8,9,1,6,6,8,-1,1,6,2,8,8,2,2,3,8,6,1,6,6,8,8,1,6,8,8,6,1,6,6,8,8,1,6,8,8,6,1,6,6,8,8,1,5,8,8,6,1,6,9,8,8,1,6,8,8,8,2,3,8,8,8,1,4,10,8,8,1,6,8,8,8,2,5,8,8,6,1,6,6,8,6,1,6,6,8,6,1,6,6,8,6,1,6,8,8,6,1,6,8,8,6,2,5,6,8,6,1,6,6,8,8,1,6,8,8,6,1,6,6,8,6,1,6,6,8,6,1,6,6,8,6,1,6,6,8,6,1,6,8,8,6,1,6,6,8,8,1,6,8,8,8,3,2,11,8,8,1,6,8,8,8,1,6,3],"m16":[10,0,0,0,0,10,12,4,2,13,10,11,2,6,5,10,11,1,7,11,10,12,2,6,12,10,11,2,6,11,10,11,2,6,11,10,12,4,3,7,10,11,4,4,11,10,11,2,4,11,10,10,2,7,8,10,10,2,7,9,10,3,2,6,6,10,6,1,8,1,10,3,3,4,3,10,11,2,6,11,10,11,2,6,11,10,12,1,5,12,10,11,1,7,11,10,11,1,7,11,10,12,1,8,12,10,11,2,6,11,10,12,2,6,12,10,11,2,7,11,10,11,2,6,11,10,11,2,6,11,10,8,4,3,8,10,8,2,5,11,10,11,1,8,11,10,8,1,8,5,10,11,1,8,11,10,11,2,6,12,10,11,2,6,11,10,11,1,8,11,10,11,2,6,11,10,11,2,6,11,10,11,2,6,11,10,11,2,6,11,10,11,3,5,11,10,11,2,7,11,10,11,2,6,11,10,11,1,7,11,10,11,2,5,11,10,11,2,7,11,10,11,2,7,11,10,11,2,6,11,10,11,2,6,11,10,11,2,6,11,10,11,2,6,11,10,11,2,6,11,10,11,2,6,11,10,11,2,6,11,10,11,1,7,11,10,11,2,6,11,10,11,1,8,11,10,11,2,6,11,10,11,1,8,11,10,11,1,7,11,10,11,1,8,11,10,11,3,6,11,10,11,2,6,11,10,11,1,6,11,10,12,1,8,7,10,-2,1,8,1,10,11,4,2,3,10,8,2,6,8,10,11,2,6,11,10,8,2,6,8,10,11,2,6,11,10,8,2,7,8,10,11,1,7,11,10,8,2,6,11,10,11,2,6,11,10,11,3,4,11,10,11,2,5,14,10,11,3,6,11,10,11,4,4,11,10,8,2,6,8,10,8,2,6,8,10,8,2,6,8,10,8,2,6,11,10,8,2,6,11,10,8,3,5,8,10,8,2,6,8,10,10,2,6,10,10,8,2,6,8,10,8,1,8,8,10,8,2,6,8,10,8,2,7,8,10,8,1,8,11,10,7,2,7,7,10,11,1,8,11,10,11,5,1,14,10,11,1,8,11,10,10,1,8,2],"a16":[10,0,0,0,0,10,12,4,3,13,10,11,1,7,5,10,11,1,8,11,10,12,1,8,12,10,11,1,8,11,10,11,1,8,11,10,12,4,3,7,10,11,3,5,11,10,11,2,5,11,10,10,1,8,8,10,10,1,8,9,10,3,2,6,6,10,6,1,8,2,10,3,3,4,3,10,11,2,6,11,10,11,1,8,11,10,12,1,6,12,10,11,1,8,11,10,11,1,8,11,10,12,1,8,12,10,11,2,6,11,10,12,1,8,12,10,11,2,7,11,10,11,1,8,11,10,11,1,8,11,10,8,4,3,8,10,8,2,5,11,10,11,1,8,11,10,8,1,8,5,10,11,1,8,11,10,11,2,6,12,10,11,1,8,11,10,11,1,8,11,10,11,1,8,11,10,11,2,6,11,10,11,2,6,11,10,11,2,6,11,10,11,3,6,11,10,11,1,8,11,10,11,2,6,11,10,11,1,7,11,10,11,1,6,11,10,11,1,8,11,10,11,2,7,11,10,11,1,8,11,10,11,1,8,11,10,11,1,8,11,10,11,2,7,11,10,11,1,7,11,10,11,2,6,11,10,11,2,6,11,10,11,1,7,11,10,11,1,8,11,10,11,1,8,11,10,11,1,8,11,10,11,1,8,11,10,11,1,7,11,10,11,1,8,11,10,11,3,6,11,10,11,2,6,11,10,11,1,7,11,10,12,1,8,7,10,-2,1,8,2,10,11,3,3,3,10,8,1,7,8,10,11,1,8,11,10,8,2,6,8,10,11,1,8,11,10,8,2,7,8,10,11,1,7,11,10,8,1,8,11,10,11,2,6,11,10,11,3,5,11,10,11,2,5,14,10,11,2,7,11,10,11,3,5,11,10,8,1,8,8,10,8,1,8,8,10,8,1,8,8,10,8,1,8,11,10,8,1,8,11,10,8,3,6,8,10,8,2,6,8,10,10,2,6,10,10,8,1,8,8,10,8,1,8,8,10,8,1,8,8,10,8,2,7,8,10,8,1,8,11,10,8,2,7,8,10,11,1,8,11,10,11,4,2,14,10,11,1,8,11,10,10,1,8,3],"m18":[12,0,0,0,0,12,13,5,2,14,12,12,3,6,5,12,12,2,8,12,12,13,2,8,13,12,12,2,8,12,12,12,2,9,12,12,13,4,3,7,12,12,4,6,12,12,12,2,6,12,12,11,1,10,9,12,11,1,10,10,12,4,2,7,7,12,7,1,9,2,12,3,4,4,3,12,12,2,7,12,12,12,2,8,12,12,13,2,6,13,12,12,2,8,12,12,13,1,9,13,12,13,2,9,13,12,13,2,8,13,12,13,2,8,13,12,13,1,10,13,12,12,2,9,12,12,12,2,8,12,12,9,4,3,9,12,9,3,5,12,12,12,1,9,11,12,9,1,9,6,12,12,1,9,11,12,13,2,7,14,12,13,2,8,13,12,12,1,9,12,12,12,2,8,12,12,12,2,7,12,12,12,3,7,12,12,12,2,8,12,12,12,3,7,12,12,12,2,7,12,12,12,2,8,12,12,12,2,8,12,12,12,2,6,12,12,12,2,9,12,12,12,2,8,12,12,12,2,8,12,12,12,2,8,12,12,12,2,8,12,12,12,2,8,12,12,12,2,8,12,12,12,2,8,12,12,12,2,8,12,12,12,1,10,12,12,12,2,8,12,12,12,1,9,12,12,12,2,8,12,12,12,2,8,12,12,12,2,8,12,12,12,2,8,12,12,12,3,7,12,12,12,2,7,12,12,12,2,7,12,12,13,1,9,8,12,-2,1,9,2,12,12,4,3,3,12,9,2,8,9,12,12,2,8,12,12,9,3,7,9,12,12,2,8,12,12,9,2,8,9,12,12,2,8,12,12,9,2,8,12,12,12,2,8,12,12,12,3,5,12,12,12,2,5,15,12,12,3,8,12,12,12,4,6,12,12,9,2,8,9,12,9,2,8,9,12,9,2,8,9,12,9,2,8,12,12,9,2,8,12,12,9,3,7,9,12,9,3,7,9,12,12,2,8,12,12,9,2,8,9,12,9,1,9,9,12,9,2,8,9,12,9,2,8,9,12,9,1,9,12,12,9,2,8,9,12,12,2,9,12,12,12,5,2,16,12,12,1,9,12,12,11,2,8,2],"a18":[12,0,0,0,0,12,13,4,3,15,12,12,3,6,6,12,12,2,8,12,12,13,2,8,13,12,12,2,8,12,12,12,2,8,12,12,13,4,3,7,12,12,4,6,12,12,12,2,6,12,12,11,1,10,9,12,11,1,10,10,12,4,2,7,7,12,7,1,9,2,12,4,4,4,4,12,12,2,7,12,12,12,2,8,12,12,13,2,6,13,12,12,2,8,12,12,13,1,9,13,12,13,2,9,13,12,13,2,8,13,12,13,2,8,13,12,13,1,10,13,12,12,2,9,12,12,12,2,8,12,12,9,4,3,9,12,9,3,5,12,12,12,1,9,11,12,9,1,9,6,12,12,1,9,11,12,13,2,7,14,12,13,2,8,13,12,12,1,9,12,12,12,2,8,12,12,12,2,7,12,12,12,3,7,12,12,12,2,8,12,12,12,3,7,12,12,12,2,7,12,12,12,2,8,12,12,12,2,8,12,12,12,2,6,12,12,12,2,8,12,12,12,2,8,12,12,12,2,8,12,12,12,2,8,12,12,12,2,8,12,12,12,2,8,12,12,12,2,8,12,12,12,2,8,12,12,12,2,8,12,12,12,1,10,12,12,12,2,8,12,12,12,1,9,12,12,12,2,8,12,12,12,2,8,12,12,12,2,8,12,12,12,2,8,12,12,12,3,7,12,12,12,2,7,12,12,12,2,7,12,12,13,1,9,8,12,-2,1,9,2,12,12,4,3,4,12,9,2,8,9,12,12,2,8,12,12,9,3,7,9,12,12,2,8,12,12,9,2,8,9,12,12,2,8,12,12,9,2,8,12,12,12,2,8,12,12,12,3,5,12,12,12,2,5,15,12,12,3,7,12,12,12,4,6,12,12,9,2,8,9,12,9,2,8,9,12,9,2,8,9,12,9,2,8,12,12,9,2,8,12,12,9,3,7,9,12,9,3,7,9,12,12,2,8,12,12,9,2,8,9,12,9,1,9,9,12,9,2,8,9,12,9,2,8,9,12,9,1,9,12,12,9,2,8,9,12,12,2,9,12,12,12,5,2,16,12,12,1,9,12,12,11,2,8,2],"m20":[13,0,0,0,0,13,14,5,3,15,13,14,3,7,6,13,14,1,10,14,13,14,2,9,14,13,14,2,9,14,13,14,2,10,14,13,14,5,3,8,13,14,5,6,14,13,14,3,6,14,13,12,2,10,10,13,13,2,10,12,13,5,2,8,8,13,8,2,10,2,13,4,4,4,4,13,14,3,7,14,13,14,2,9,14,13,14,2,6,14,13,14,2,9,14,13,14,2,9,14,13,14,1,10,14,13,14,1,9,14,13,14,2,9,14,13,14,1,10,14,13,14,2,10,14,13,14,2,9,14,13,9,5,4,9,13,9,2,7,13,13,13,2,10,12,13,10,2,10,6,13,13,2,10,12,13,15,2,8,16,13,15,2,9,15,13,14,2,9,14,13,14,2,9,14,13,14,3,7,14,13,14,3,8,14,13,14,3,9,14,13,14,4,7,14,13,14,2,9,14,13,14,2,9,14,13,14,3,8,14,13,14,2,7,14,13,14,2,9,14,13,14,2,9,14,13,14,2,9,14,13,14,2,9,14,13,14,2,9,14,13,14,2,9,14,13,14,2,9,14,13,14,3,8,14,13,14,3,8,14,13,14,2,10,14,13,14,2,9,14,13,14,2,10,14,13,14,2,9,14,13,14,2,9,14,13,14,2,10,14,13,14,2,9,14,13,14,4,8,14,13,14,3,7,14,13,14,1,8,14,13,14,2,10,8,13,-2,2,10,2,13,14,5,3,3,13,10,2,8,10,13,14,2,9,14,13,10,3,7,10,13,14,2,9,14,13,10,2,9,10,13,14,2,8,14,13,10,2,9,13,13,14,3,7,14,13,14,3,5,14,13,14,2,7,17,13,14,3,8,14,13,14,4,6,14,13,10,2,9,10,13,10,2,9,10,13,10,2,9,10,13,10,2,9,13,13,10,2,9,13,13,10,4,7,10,13,10,3,8,10,13,13,1,9,13,13,10,2,9,10,13,10,2,9,10,13,10,2,9,10,13,10,2,9,10,13,10,2,10,13,13,10,2,9,10,13,14,1,11,14,13,14,6,2,17,13,14,1,11,14,13,13,2,9,3],"a20":[13,0,0,0,0,13,14,5,3,15,13,14,3,7,6,13,14,1,10,14,13,14,2,9,14,13,14,2,9,14,13,14,2,10,14,13,14,5,3,8,13,14,5,6,14,13,14,3,6,14,13,12,2,10,10,13,12,2,10,11,13,5,2,8,8,13,8,2,10,2,13,4,4,4,4,13,14,3,7,14,13,14,2,9,14,13,14,2,6,14,13,14,2,9,14,13,14,2,9,14,13,14,1,10,14,13,14,2,8,14,13,14,2,9,14,13,14,1,10,14,13,14,2,10,14,13,14,2,9,14,13,9,5,4,9,13,9,2,7,13,13,13,2,10,12,13,10,2,10,6,13,13,2,10,12,13,15,2,8,16,13,15,2,9,15,13,14,2,9,14,13,14,2,9,14,13,14,3,7,14,13,14,3,8,14,13,14,3,8,14,13,14,4,7,14,13,14,2,9,14,13,14,2,9,14,13,14,3,8,14,13,14,2,7,14,13,14,2,9,14,13,14,2,9,14,13,14,2,9,14,13,14,2,9,14,13,14,2,9,14,13,14,2,9,14,13,14,2,9,14,13,14,3,8,14,13,14,3,8,14,13,14,2,10,14,13,14,2,9,14,13,14,2,10,14,13,14,2,9,14,13,14,2,9,14,13,14,2,10,14,13,14,2,9,14,13,14,4,7,14,13,14,3,7,14,13,14,2,7,14,13,14,2,10,8,13,-2,2,10,2,13,14,5,3,4,13,10,2,8,10,13,14,2,9,14,13,10,3,7,10,13,14,2,9,14,13,10,2,9,10,13,14,2,8,14,13,10,2,9,13,13,14,3,7,14,13,14,3,5,14,13,14,2,7,17,13,14,3,8,14,13,14,4,6,14,13,10,2,9,10,13,10,2,9,10,13,10,2,9,10,13,10,2,9,13,13,10,2,9,13,13,10,4,7,10,13,10,3,8,10,13,13,1,9,13,13,10,2,9,10,13,10,2,9,10,13,10,2,9,10,13,10,2,9,10,13,10,2,10,13,13,10,2,9,10,13,14,2,10,14,13,14,6,2,17,13,14,2,10,14,13,13,2,9,3],"m24":[16,0,0,0,0,16,17,6,3,19,16,17,3,9,7,16,17,2,11,17,16,17,3,10,17,16,17,3,10,17,16,17,3,10,17,16,17,6,4,9,16,17,6,7,17,16,17,3,7,17,16,15,2,12,12,16,14,2,12,12,16,5,3,9,9,16,9,2,12,2,16,4,5,5,4,16,17,3,9,17,16,17,3,10,17,16,17,3,7,17,16,17,3,10,17,16,16,2,11,16,16,17,2,12,17,16,16,2,10,16,16,17,3,10,17,16,16,2,11,16,16,17,3,10,17,16,17,3,10,17,16,12,6,4,12,16,12,3,7,16,16,16,2,12,15,16,12,2,12,7,16,16,2,12,15,16,17,3,9,19,16,17,2,11,17,16,17,2,11,17,16,17,2,11,17,16,17,3,9,17,16,17,4,8,17,16,17,3,10,17,16,17,4,8,17,16,17,3,10,17,16,17,3,9,17,16,17,3,10,17,16,17,3,7,17,16,17,3,11,17,16,17,3,10,17,16,17,2,11,17,16,17,3,10,17,16,17,3,10,17,16,17,3,10,17,16,17,2,11,17,16,17,3,9,17,16,17,3,9,17,16,17,2,12,17,16,17,3,10,17,16,17,2,11,17,16,17,2,11,17,16,17,2,11,17,16,17,3,10,17,16,17,2,11,17,16,17,5,9,17,16,17,3,9,17,16,17,2,9,17,16,17,2,12,10,16,-2,2,12,3,16,17,6,3,4,16,12,3,9,12,16,17,3,10,17,16,12,4,8,12,16,17,3,10,17,16,12,3,11,12,16,17,3,10,17,16,12,3,10,16,16,17,3,9,17,16,17,4,6,17,16,17,3,7,21,16,17,4,9,17,16,17,6,7,17,16,12,3,10,12,16,12,3,10,12,16,12,3,10,12,16,12,3,10,16,16,12,3,10,16,16,12,4,9,12,16,12,4,8,12,16,15,2,10,15,16,12,3,10,12,16,12,2,12,12,16,12,3,10,12,16,12,3,10,12,16,12,2,12,16,16,11,3,10,11,16,17,2,11,17,16,17,7,2,21,16,17,2,11,17,16,15,2,11,3],"a24":[16,0,0,0,0,16,17,6,3,19,16,17,3,9,7,16,17,2,11,17,16,17,2,12,17,16,17,2,12,17,16,17,2,11,17,16,17,6,4,9,16,17,5,8,17,16,17,3,8,17,16,15,2,12,12,16,15,2,12,13,16,5,3,9,9,16,9,2,12,3,16,5,5,5,5,16,17,3,9,17,16,17,2,12,17,16,17,3,7,17,16,17,3,10,17,16,17,2,11,17,16,17,2,12,17,16,17,2,11,17,16,17,2,12,17,16,17,2,12,17,16,17,2,11,17,16,17,2,12,17,16,12,6,4,12,16,12,3,7,16,16,16,2,12,15,16,12,2,12,8,16,16,2,12,15,16,17,3,9,19,16,17,2,11,17,16,17,2,11,17,16,17,2,12,17,16,17,3,9,17,16,17,3,10,17,16,17,3,10,17,16,17,4,8,17,16,17,2,11,17,16,17,3,10,17,16,17,3,10,17,16,17,2,9,17,16,17,2,12,17,16,17,3,10,17,16,17,2,11,17,16,17,2,11,17,16,17,2,11,17,16,17,3,10,17,16,17,2,11,17,16,17,3,10,17,16,17,3,10,17,16,17,2,12,17,16,17,2,11,17,16,17,2,11,17,16,17,2,11,17,16,17,2,11,17,16,17,3,10,17,16,17,2,11,17,16,17,4,10,17,16,17,3,9,17,16,17,2,10,17,16,17,2,12,10,16,-2,2,12,3,16,17,6,3,5,16,12,2,11,12,16,17,2,12,17,16,12,3,10,12,16,17,2,11,17,16,12,3,11,12,16,17,3,10,17,16,12,2,11,17,16,17,3,10,17,16,17,4,6,17,16,17,3,8,21,16,17,3,10,17,16,17,5,8,17,16,12,2,12,12,16,12,2,11,12,16,12,2,12,12,16,12,2,12,16,16,12,2,11,16,16,12,4,9,12,16,12,3,10,12,16,15,2,10,15,16,12,2,11,12,16,12,2,12,12,16,12,2,12,12,16,12,3,10,12,16,12,2,12,16,16,12,3,10,12,16,17,2,12,17,16,17,6,3,21,16,17,2,11,17,16,15,2,11,4],"m27":[18,0,0,0,0,18,19,7,3,21,18,19,4,9,8,18,19,2,12,19,18,19,3,11,19,18,19,3,11,19,18,19,3,11,19,18,19,7,4,10,18,19,6,7,19,18,19,4,7,19,18,16,3,12,13,18,16,3,12,14,18,6,3,10,10,18,11,2,13,3,18,5,6,6,5,18,19,4,10,19,18,19,3,11,19,18,19,3,8,19,18,19,3,11,19,18,18,2,12,18,18,19,2,13,19,18,18,3,10,18,18,19,3,11,19,18,18,3,12,18,18,19,3,11,19,18,19,3,11,19,18,13,6,5,13,18,13,4,8,17,18,17,2,13,16,18,13,2,13,8,18,17,2,13,16,18,20,3,10,22,18,20,3,12,20,18,19,2,13,19,18,19,3,11,19,18,19,4,9,19,18,19,4,10,19,18,19,4,11,19,18,19,5,9,19,18,19,3,11,19,18,19,3,11,19,18,19,4,10,19,18,19,3,9,19,18,19,3,12,19,18,19,3,12,19,18,19,3,12,19,18,19,3,11,19,18,19,3,11,19,18,19,3,12,19,18,19,3,12,19,18,19,4,10,19,18,19,4,10,19,18,19,3,12,19,18,19,3,11,19,18,19,2,13,19,18,19,3,12,19,18,19,3,12,19,18,19,3,12,19,18,19,3,12,19,18,19,5,9,19,18,19,4,10,19,18,19,3,9,19,18,19,2,13,11,18,-3,2,13,3,18,19,6,4,5,18,13,3,10,13,18,19,3,11,19,18,13,4,9,13,18,19,3,11,19,18,13,3,12,13,18,19,3,10,19,18,13,3,11,18,18,19,4,9,19,18,19,4,7,19,18,19,3,8,23,18,19,4,10,19,18,19,6,7,19,18,13,3,11,13,18,13,3,11,13,18,13,3,11,13,18,13,3,11,17,18,13,3,11,17,18,13,5,9,13,18,13,4,9,13,18,16,3,10,16,18,13,3,11,13,18,13,2,13,13,18,13,3,11,13,18,13,3,11,13,18,13,2,13,17,18,12,3,11,12,18,19,2,13,19,18,19,8,2,23,18,19,2,13,19,18,17,3,12,4],"a27":[18,0,0,0,0,18,19,7,3,21,18,19,4,9,8,18,19,2,13,19,18,19,2,13,19,18,19,2,13,19,18,19,2,13,19,18,19,7,4,10,18,19,6,7,19,18,19,4,7,19,18,16,3,12,13,18,16,3,12,14,18,6,3,10,10,18,11,2,13,3,18,5,6,6,5,18,19,4,10,19,18,19,2,13,19,18,19,3,8,19,18,19,3,11,19,18,19,2,13,19,18,19,2,13,19,18,19,3,11,19,18,19,2,13,19,18,19,2,13,19,18,19,2,12,19,18,19,2,13,19,18,13,6,5,13,18,13,4,8,17,18,17,2,13,16,18,13,2,13,8,18,17,2,13,16,18,20,3,11,22,18,20,2,13,20,18,19,2,13,19,18,19,2,13,19,18,19,3,11,19,18,19,4,10,19,18,19,3,12,19,18,19,5,9,19,18,19,3,11,19,18,19,3,11,19,18,19,4,10,19,18,19,3,9,19,18,19,3,12,19,18,19,3,12,19,18,19,2,13,19,18,19,3,12,19,18,19,2,13,19,18,19,3,12,19,18,19,2,13,19,18,19,3,11,19,18,19,3,11,19,18,19,2,13,19,18,19,3,12,19,18,19,2,13,19,18,19,2,13,19,18,19,3,12,19,18,19,3,12,19,18,19,3,12,19,18,19,5,9,19,18,19,4,10,19,18,19,3,9,19,18,19,2,13,11,18,-3,2,13,3,18,19,6,4,5,18,13,3,11,13,18,19,3,12,19,18,13,4,10,13,18,19,2,13,19,18,13,3,12,13,18,19,3,11,19,18,13,2,12,18,18,19,3,11,19,18,19,4,7,19,18,19,3,8,23,18,19,4,10,19,18,19,6,7,19,18,13,2,13,13,18,13,3,11,13,18,13,2,13,13,18,13,3,12,17,18,13,2,13,17,18,13,4,10,13,18,13,3,11,13,18,16,3,10,16,18,13,3,11,13,18,13,2,13,13,18,13,2,13,13,18,13,3,11,13,18,13,2,13,17,18,13,3,11,13,18,19,2,13,19,18,19,7,3,23,18,19,2,13,19,18,17,3,12,4],"m30":[20,0,0,0,0,20,21,8,4,23,20,21,4,11,9,20,21,2,14,21,20,21,3,14,21,20,21,3,14,21,20,21,3,13,21,20,21,7,5,11,20,21,7,8,21,20,21,5,8,21,20,18,2,15,14,20,19,2,15,17,20,6,4,11,11,20,12,2,15,3,20,5,6,6,5,20,21,4,11,21,20,21,3,14,21,20,21,3,9,21,20,21,3,13,21,20,21,2,14,21,20,21,3,14,21,20,21,3,12,21,20,21,3,14,21,20,21,2,15,21,20,21,3,14,21,20,21,3,14,21,20,15,7,6,15,20,15,3,10,20,20,19,2,15,18,20,14,2,15,8,20,19,2,15,18,20,21,4,11,23,20,21,3,14,21,20,21,3,14,21,20,21,3,14,21,20,21,4,11,21,20,21,4,12,21,20,21,4,13,21,20,21,5,11,21,20,21,3,13,21,20,21,4,12,21,20,21,4,11,21,20,21,3,10,21,20,21,3,14,21,20,21,4,13,21,20,21,3,14,21,20,21,3,13,21,20,21,3,13,21,20,21,4,13,21,20,21,3,14,21,20,21,4,12,21,20,21,4,12,21,20,21,2,15,21,20,21,3,13,21,20,21,2,15,21,20,21,3,13,21,20,21,3,13,21,20,21,3,13,21,20,21,3,13,21,20,21,5,11,21,20,21,4,11,21,20,21,3,11,21,20,21,2,15,12,20,-3,2,15,3,20,21,7,4,5,20,14,3,13,14,20,21,3,14,21,20,14,4,11,14,20,21,3,13,21,20,14,3,13,14,20,21,3,13,21,20,14,3,13,19,20,21,4,11,21,20,21,5,7,21,20,21,4,9,26,20,21,5,12,21,20,21,7,9,21,20,14,3,14,14,20,14,3,13,14,20,14,3,14,14,20,14,3,14,19,20,14,3,13,19,20,14,5,11,14,20,14,4,12,14,20,19,3,13,19,20,14,3,13,14,20,14,3,14,14,20,14,3,13,14,20,14,3,13,14,20,14,2,15,19,20,14,3,13,14,20,21,2,14,21,20,21,8,3,26,20,21,2,15,21,20,19,3,13,5],"a30":[20,0,0,0,0,20,21,8,4,23,20,21,4,11,9,20,21,2,14,21,20,21,3,14,21,20,21,3,14,21,20,21,3,14,21,20,21,7,5,11,20,21,7,8,21,20,21,5,8,21,20,18,2,15,14,20,18,2,15,16,20,6,4,11,11,20,12,2,15,3,20,6,6,6,6,20,21,4,11,21,20,21,3,14,21,20,21,3,9,21,20,21,3,13,21,20,21,2,14,21,20,21,3,14,21,20,21,3,12,21,20,21,3,14,21,20,21,2,15,21,20,21,3,14,21,20,21,3,14,21,20,15,7,6,15,20,15,3,10,20,20,19,2,15,18,20,14,2,15,8,20,19,2,15,18,20,21,4,11,23,20,21,3,14,21,20,21,3,14,21,20,21,3,14,21,20,21,4,11,21,20,21,4,12,21,20,21,4,13,21,20,21,5,11,21,20,21,3,13,21,20,21,4,12,21,20,21,4,11,21,20,21,3,10,21,20,21,3,14,21,20,21,4,13,21,20,21,3,14,21,20,21,3,13,21,20,21,3,13,21,20,21,4,13,21,20,21,3,14,21,20,21,4,12,21,20,21,4,12,21,20,21,2,15,21,20,21,3,13,21,20,21,2,15,21,20,21,3,13,21,20,21,3,13,21,20,21,3,13,21,20,21,3,13,21,20,21,5,11,21,20,21,4,11,21,20,21,3,11,21,20,21,2,15,12,20,-3,2,15,3,20,21,7,4,6,20,14,3,13,14,20,21,3,14,21,20,14,4,11,14,20,21,3,13,21,20,14,3,13,14,20,21,3,13,21,20,14,3,13,19,20,21,4,11,21,20,21,5,7,21,20,21,4,9,26,20,21,5,12,21,20,21,7,9,21,20,14,3,14,14,20,14,3,13,14,20,14,3,14,14,20,14,3,14,19,20,14,3,13,19,20,14,5,11,14,20,14,4,12,14,20,19,3,13,19,20,14,3,13,14,20,14,3,14,14,20,14,3,13,14,20,14,3,13,14,20,14,2,15,19,20,14,3,13,14,20,21,2,14,21,20,21,8,3,26,20,21,2,15,21,20,19,3,13,5],"m32":[21,0,0,0,0,21,23,8,4,25,21,22,5,11,9,21,22,3,14,22,21,23,3,14,23,21,22,3,14,22,21,22,3,14,22,21,23,8,5,12,21,22,7,9,22,21,22,4,9,22,21,19,3,15,15,21,19,3,15,17,21,7,4,12,12,21,13,3,15,4,21,6,7,7,6,21,22,4,12,22,21,22,3,14,22,21,23,4,9,23,21,22,3,14,22,21,22,3,14,22,21,23,3,15,23,21,22,3,13,22,21,23,3,14,23,21,22,3,15,22,21,22,3,14,22,21,22,3,14,22,21,15,7,6,15,21,15,4,10,21,21,21,3,15,20,21,15,3,15,9,21,21,3,15,20,21,23,4,12,25,21,23,3,14,23,21,22,3,15,22,21,22,3,14,22,21,22,4,12,22,21,22,5,12,22,21,22,4,13,22,21,22,6,11,22,21,22,3,13,22,21,22,4,13,22,21,22,4,13,22,21,22,4,10,22,21,22,4,14,22,21,22,4,14,22,21,22,3,14,22,21,22,4,13,22,21,22,3,14,22,21,22,4,13,22,21,22,3,15,22,21,22,4,13,22,21,22,4,12,22,21,22,3,15,22,21,22,4,13,22,21,22,3,15,22,21,22,3,14,22,21,22,3,14,22,21,22,4,13,22,21,22,3,14,22,21,22,6,12,22,21,22,4,12,22,21,22,3,12,22,21,23,3,15,13,21,-3,3,15,4,21,22,7,4,5,21,15,4,12,15,21,22,3,14,22,21,15,5,11,15,21,22,3,14,22,21,15,4,14,15,21,22,4,13,22,21,15,3,14,21,21,22,4,12,22,21,22,5,8,22,21,22,4,9,27,21,22,5,12,22,21,22,7,9,22,21,15,3,14,15,21,15,4,13,15,21,15,3,14,15,21,15,3,14,20,21,15,3,14,20,21,15,6,11,15,21,15,4,12,15,21,20,3,13,20,21,15,4,13,15,21,15,3,15,15,21,15,3,14,15,21,15,4,13,15,21,15,3,15,20,21,15,4,13,15,21,22,3,15,22,21,22,9,3,27,21,22,3,15,22,21,20,3,14,5],"a32":[21,0,0,0,0,21,23,8,4,25,21,22,5,11,10,21,22,3,14,22,21,23,3,14,23,21,22,3,14,22,21,22,3,14,22,21,23,8,5,12,21,22,7,9,22,21,22,4,9,22,21,19,3,15,15,21,19,3,15,17,21,7,4,12,12,21,13,3,15,4,21,6,7,7,6,21,22,4,12,22,21,22,3,14,22,21,23,4,9,23,21,22,3,14,22,21,22,3,14,22,21,23,3,15,23,21,22,3,13,22,21,23,3,14,23,21,22,3,15,22,21,22,3,14,22,21,22,3,14,22,21,15,7,6,15,21,15,4,10,21,21,21,3,15,20,21,15,3,15,9,21,21,3,15,20,21,23,4,12,25,21,23,3,14,23,21,22,3,15,22,21,22,3,14,22,21,22,4,12,22,21,22,5,12,22,21,22,4,13,22,21,22,6,11,22,21,22,3,13,22,21,22,4,13,22,21,22,4,12,22,21,22,4,10,22,21,22,4,14,22,21,22,4,14,22,21,22,3,14,22,21,22,4,13,22,21,22,3,14,22,21,22,4,13,22,21,22,3,15,22,21,22,4,13,22,21,22,4,12,22,21,22,3,15,22,21,22,4,13,22,21,22,3,15,22,21,22,3,14,22,21,22,3,14,22,21,22,4,13,22,21,22,3,14,22,21,22,6,11,22,21,22,4,12,22,21,22,3,12,22,21,23,3,15,13,21,-3,3,15,4,21,22,7,4,6,21,15,4,12,15,21,22,3,14,22,21,15,5,11,15,21,22,3,14,22,21,15,4,14,15,21,22,4,13,22,21,15,3,14,21,21,22,4,12,22,21,22,5,8,22,21,22,4,9,27,21,22,5,12,22,21,22,7,9,22,21,15,3,14,15,21,15,4,13,15,21,15,3,14,15,21,15,3,14,20,21,15,3,14,20,21,15,6,11,15,21,15,4,12,15,21,20,3,13,20,21,15,4,13,15,21,15,3,15,15,21,15,3,14,15,21,15,4,13,15,21,15,3,15,20,21,15,4,13,15,21,22,3,15,22,21,22,9,3,27,21,22,3,15,22,21,20,3,14,5],"m36":[23,0,0,0,0,23,25,9,5,27,23,25,5,13,10,23,25,3,16,25,23,25,4,15,25,23,25,4,15,25,23,25,4,15,25,23,25,9,6,13,23,25,8,9,25,23,25,6,9,25,23,22,3,17,18,23,22,3,17,19,23,7,5,13,13,23,14,3,17,4,23,6,8,8,6,23,25,5,13,25,23,25,4,15,25,23,25,4,10,25,23,25,3,15,25,23,24,3,16,24,23,25,3,17,25,23,24,4,14,24,23,25,4,15,25,23,24,4,16,24,23,25,4,15,25,23,25,4,15,25,23,17,8,7,17,23,17,5,11,24,23,23,3,17,21,23,17,3,17,10,23,23,3,17,21,23,26,5,13,28,23,26,4,16,26,23,25,3,17,25,23,25,4,15,25,23,25,5,13,25,23,25,5,13,25,23,25,5,14,25,23,25,7,12,25,23,25,4,15,25,23,25,4,14,25,23,25,5,13,25,23,25,4,11,25,23,25,4,16,25,23,25,4,15,25,23,25,4,15,25,23,25,4,15,25,23,25,4,15,25,23,25,4,15,25,23,25,4,16,25,23,25,5,13,25,23,25,5,13,25,23,25,3,17,25,23,25,4,15,25,23,25,3,17,25,23,25,4,15,25,23,25,4,15,25,23,25,4,15,25,23,25,4,15,25,23,25,7,13,25,23,25,5,13,25,23,25,3,13,25,23,25,3,17,14,23,-4,3,17,4,23,25,8,5,6,23,17,4,14,17,23,25,4,15,25,23,17,5,13,17,23,25,4,15,25,23,17,4,15,17,23,25,4,15,25,23,17,4,14,23,23,25,5,13,25,23,25,6,9,25,23,25,5,11,31,23,25,5,13,25,23,25,8,10,25,23,17,4,15,17,23,17,4,15,17,23,17,4,15,17,23,17,4,15,23,23,17,4,15,23,23,17,6,13,17,23,17,5,13,17,23,22,4,14,22,23,17,4,15,17,23,17,3,17,17,23,17,4,15,17,23,17,4,15,17,23,17,3,17,23,23,17,4,15,17,23,25,3,17,25,23,25,10,3,31,23,25,3,17,25,23,23,4,16,6],"a36":[23,0,0,0,0,23,25,9,5,27,23,25,5,13,11,23,25,3,16,25,23,25,4,15,25,23,25,4,15,25,23,25,4,15,25,23,25,9,6,13,23,25,8,9,25,23,25,6,9,25,23,22,3,17,18,23,22,3,17,19,23,7,5,13,13,23,14,3,17,4,23,7,8,8,7,23,25,5,13,25,23,25,4,15,25,23,25,4,10,25,23,25,3,15,25,23,24,3,16,24,23,25,3,17,25,23,24,4,14,24,23,25,4,15,25,23,24,4,16,24,23,25,4,15,25,23,25,4,15,25,23,17,8,7,17,23,17,5,11,24,23,23,3,17,21,23,17,3,17,10,23,23,3,17,21,23,26,5,13,28,23,26,4,16,26,23,25,3,17,25,23,25,4,15,25,23,25,5,13,25,23,25,5,13,25,23,25,5,14,25,23,25,7,12,25,23,25,4,15,25,23,25,4,14,25,23,25,5,13,25,23,25,4,11,25,23,25,4,16,25,23,25,4,15,25,23,25,4,15,25,23,25,4,15,25,23,25,4,15,25,23,25,4,15,25,23,25,4,16,25,23,25,5,13,25,23,25,5,13,25,23,25,3,17,25,23,25,4,15,25,23,25,3,17,25,23,25,4,15,25,23,25,4,15,25,23,25,4,15,25,23,25,4,15,25,23,25,7,13,25,23,25,5,13,25,23,25,3,13,25,23,25,3,17,14,23,-4,3,17,4,23,25,8,5,7,23,17,4,14,17,23,25,4,15,25,23,17,5,13,17,23,25,4,15,25,23,17,4,15,17,23,25,4,15,25,23,17,4,14,23,23,25,5,13,25,23,25,6,9,25,23,25,5,11,31,23,25,5,13,25,23,25,8,10,25,23,17,4,15,17,23,17,4,15,17,23,17,4,15,17,23,17,4,15,23,23,17,4,15,23,23,17,6,13,17,23,17,5,13,17,23,22,4,14,22,23,17,4,15,17,23,17,3,17,17,23,17,4,15,17,23,17,4,15,17,23,17,3,17,23,23,17,4,15,17,23,25,3,17,25,23,25,10,3,31,23,25,3,17,25,23,23,4,16,6],"m40":[26,0,0,0,0,26,28,10,5,31,26,28,6,14,12,26,28,3,19,28,26,28,4,18,28,26,28,4,18,28,26,28,4,18,28,26,28,10,6,15,26,28,9,11,28,26,28,6,11,28,26,24,3,20,19,26,25,3,20,22,26,8,5,15,15,26,16,3,19,5,26,7,9,9,7,26,28,6,14,28,26,28,4,18,28,26,28,5,12,28,26,28,4,17,28,26,28,4,18,28,26,28,3,19,28,26,28,5,16,28,26,28,4,18,28,26,28,3,19,28,26,28,4,18,28,26,28,4,18,28,26,19,9,7,19,26,19,5,12,26,26,26,3,19,24,26,19,3,19,11,26,26,3,19,24,26,30,5,15,33,26,30,4,18,31,26,29,4,18,29,26,29,4,19,29,26,29,6,15,30,26,29,6,16,29,26,29,6,17,29,26,29,8,14,29,26,29,4,18,30,26,30,5,16,30,26,29,5,16,29,26,30,5,13,31,26,30,5,18,30,26,30,5,18,30,26,30,4,18,30,26,30,5,17,30,26,29,4,18,30,26,29,5,17,29,26,29,4,19,29,26,29,6,15,29,26,29,6,15,30,26,29,3,20,29,26,30,5,17,31,26,30,4,19,30,26,30,4,18,30,26,30,4,18,30,26,30,4,18,30,26,29,5,17,29,26,28,7,15,28,26,28,6,14,28,26,28,4,15,28,26,28,3,19,15,26,-3,3,19,5,26,28,9,5,7,26,19,4,17,19,26,28,4,18,28,26,19,6,15,19,26,28,4,18,28,26,19,4,17,19,26,28,5,16,28,26,19,4,17,26,26,28,6,15,28,26,28,6,10,28,26,28,4,12,35,26,28,6,16,28,26,28,9,11,28,26,19,4,18,19,26,19,4,18,19,26,19,4,18,19,26,19,4,18,26,26,19,4,18,26,26,19,7,15,19,26,19,6,15,19,26,25,4,16,25,26,19,4,18,19,26,19,4,18,19,26,19,4,18,19,26,19,5,16,19,26,19,3,19,26,26,19,5,16,19,26,28,4,19,28,26,28,11,4,34,26,28,3,20,28,26,25,4,18,6],"a40":[26,0,0,0,0,26,28,10,5,31,26,28,6,14,12,26,28,3,19,28,26,28,4,18,28,26,28,4,18,28,26,28,4,18,28,26,28,10,6,15,26,28,9,11,28,26,28,6,11,28,26,24,3,20,19,26,25,3,20,22,26,8,5,15,15,26,16,3,19,5,26,8,9,9,8,26,28,6,14,28,26,28,4,18,28,26,28,5,12,28,26,28,4,17,28,26,28,4,18,28,26,28,3,19,28,26,28,5,16,28,26,28,4,18,28,26,28,3,19,28,26,28,4,18,28,26,28,4,18,28,26,19,9,7,19,26,19,5,12,26,26,26,3,19,24,26,19,3,19,11,26,26,3,19,24,26,30,5,15,33,26,30,4,18,31,26,29,4,18,29,26,29,4,19,29,26,29,6,15,30,26,29,6,16,29,26,29,6,17,29,26,29,8,14,29,26,29,4,18,30,26,29,5,16,29,26,29,5,16,29,26,29,5,13,30,26,29,5,18,29,26,29,5,18,29,26,29,4,18,29,26,29,5,17,29,26,29,4,18,30,26,29,5,17,29,26,29,4,19,29,26,29,6,15,29,26,29,6,15,30,26,29,3,20,29,26,29,5,17,30,26,29,4,19,29,26,29,4,18,29,26,29,4,18,29,26,29,4,18,29,26,29,5,17,29,26,28,7,15,28,26,28,6,14,28,26,28,4,15,28,26,28,3,19,15,26,-3,3,19,5,26,28,9,5,7,26,19,4,17,19,26,28,4,18,28,26,19,6,15,19,26,28,4,18,28,26,19,4,17,19,26,28,5,16,28,26,19,4,17,26,26,28,6,15,28,26,28,6,10,28,26,28,4,12,35,26,28,6,16,28,26,28,9,11,28,26,19,4,18,19,26,19,4,18,19,26,19,4,18,19,26,19,4,18,26,26,19,4,18,26,26,19,7,15,19,26,19,6,15,19,26,25,4,16,25,26,19,4,18,19,26,19,4,18,19,26,19,4,18,19,26,19,5,16,19,26,19,3,19,26,26,19,5,16,19,26,28,4,19,28,26,28,11,4,34,26,28,3,20,28,26,25,4,18,6],"m45":[29,0,0,0,0,29,32,12,6,35,29,31,7,16,13,29,31,4,20,32,29,32,5,20,32,29,31,5,20,32,29,31,5,20,32,29,32,11,7,17,29,31,10,12,32,29,31,7,12,32,29,27,4,22,21,29,27,4,22,24,29,9,6,16,16,29,18,4,21,5,29,8,10,10,8,29,31,7,16,32,29,31,5,20,32,29,32,5,13,32,29,31,5,19,31,29,31,4,20,32,29,32,4,22,32,29,31,5,18,32,29,32,5,20,33,29,31,4,22,31,29,31,5,19,32,29,31,5,20,31,29,21,10,8,21,29,21,6,13,29,29,29,4,21,27,29,22,4,21,13,29,29,4,21,27,29,33,6,16,36,29,33,5,20,34,29,32,4,21,32,29,32,4,21,32,29,33,6,17,34,29,32,7,16,32,29,32,6,18,32,29,32,8,15,32,29,33,5,18,34,29,34,6,17,34,29,32,6,16,32,29,34,5,14,35,29,34,5,20,34,29,34,6,19,34,29,34,4,20,34,29,34,5,19,34,29,33,5,19,34,29,32,6,18,32,29,33,5,20,33,29,32,6,17,32,29,33,6,17,34,29,32,4,20,32,29,34,5,19,35,29,34,4,21,34,29,34,4,20,34,29,34,5,19,34,29,34,4,20,34,29,32,5,19,32,29,31,9,16,32,29,31,7,16,32,29,31,5,16,32,29,32,4,21,18,29,-5,4,21,5,29,31,10,6,8,29,22,5,18,23,29,31,5,20,32,29,22,7,16,23,29,31,5,19,32,29,22,5,20,23,29,31,5,18,32,29,22,5,19,30,29,31,6,17,32,29,31,7,11,32,29,31,6,13,38,29,31,7,17,32,29,31,10,12,31,29,22,5,20,23,29,22,5,19,23,29,22,5,20,23,29,22,5,20,29,29,22,5,19,29,29,22,8,16,23,29,22,6,17,23,29,28,5,17,29,29,22,5,19,23,29,22,4,21,23,29,22,5,20,23,29,22,5,19,23,29,22,4,21,29,29,21,5,19,21,29,31,5,21,32,29,31,13,4,38,29,31,4,21,32,29,29,5,20,7],"a45":[29,0,0,0,0,29,32,12,6,35,29,31,7,16,13,29,31,4,20,32,29,32,5,20,32,29,31,5,20,32,29,31,5,20,32,29,32,11,7,17,29,31,10,12,32,29,31,7,12,32,29,27,4,22,21,29,27,4,22,24,29,9,6,16,16,29,18,4,21,5,29,8,10,10,8,29,31,7,16,32,29,31,5,20,32,29,32,5,13,32,29,31,5,19,31,29,31,4,20,32,29,32,4,22,32,29,31,5,18,32,29,32,5,20,33,29,31,4,22,31,29,31,5,19,32,29,31,5,20,31,29,21,10,8,21,29,21,6,13,29,29,29,4,21,27,29,22,4,21,13,29,29,4,21,27,29,33,6,16,36,29,33,5,20,34,29,32,4,21,32,29,32,4,21,32,29,33,6,17,34,29,32,7,16,32,29,32,6,18,32,29,32,8,15,32,29,33,5,18,34,29,33,6,17,33,29,32,6,16,32,29,33,5,14,34,29,33,5,20,33,29,33,6,19,33,29,33,4,20,33,29,33,5,19,33,29,33,5,19,34,29,32,6,18,32,29,33,5,20,33,29,32,6,17,32,29,33,6,17,34,29,32,4,20,32,29,33,5,19,34,29,33,4,21,33,29,33,4,20,33,29,33,5,19,33,29,33,4,20,33,29,32,5,19,32,29,31,9,16,32,29,31,7,16,32,29,31,5,16,32,29,32,4,21,18,29,-5,4,21,5,29,31,10,6,8,29,22,5,18,23,29,31,5,20,32,29,22,7,16,23,29,31,5,19,32,29,22,5,20,23,29,31,5,18,32,29,22,5,19,30,29,31,6,17,32,29,31,7,11,32,29,31,6,13,38,29,31,7,17,32,29,31,10,12,31,29,22,5,20,23,29,22,5,19,23,29,22,5,20,23,29,22,5,20,29,29,22,5,19,29,29,22,8,16,23,29,22,6,17,23,29,28,5,17,29,29,22,5,19,23,29,22,4,21,23,29,22,5,20,23,29,22,5,19,23,29,22,4,21,29,29,21,5,19,21,29,31,5,21,32,29,31,13,4,38,29,31,4,21,32,29,29,5,20,7],"m48":[31,0,0,0,0,31,34,12,6,37,31,33,7,17,14,31,33,4,21,34,31,34,5,21,34,31,33,5,21,34,31,33,5,21,34,31,34,12,7,18,31,33,11,12,34,31,33,8,12,34,31,29,4,22,23,31,28,4,22,24,31,9,6,17,17,31,20,4,22,6,31,9,10,10,9,31,33,7,17,34,31,33,5,21,34,31,34,6,13,34,31,33,5,20,33,31,32,4,21,33,31,34,4,22,34,31,32,5,19,33,31,34,5,21,35,31,32,4,22,32,31,33,5,20,34,31,33,5,21,33,31,23,11,9,23,31,23,6,15,31,31,31,4,22,29,31,23,4,22,14,31,31,4,22,29,31,35,6,18,38,31,36,5,21,37,31,34,5,21,35,31,34,5,21,34,31,35,7,17,36,31,34,7,18,34,31,34,7,19,34,31,34,9,16,35,31,35,5,20,36,31,36,6,18,37,31,34,6,18,34,31,36,6,15,37,31,36,5,21,36,31,36,6,20,36,31,36,5,21,36,31,36,5,20,36,31,35,5,21,36,31,34,6,20,35,31,35,5,22,36,31,34,6,18,35,31,35,6,18,36,31,34,4,22,35,31,36,5,20,37,31,36,4,22,36,31,36,5,21,36,31,36,5,21,36,31,36,5,20,36,31,34,5,20,34,31,33,9,17,34,31,33,7,17,34,31,33,5,17,34,31,34,4,22,19,31,-4,4,22,6,31,33,11,7,8,31,23,5,19,24,31,33,5,21,34,31,23,7,17,24,31,33,5,20,34,31,23,5,21,24,31,33,6,19,34,31,23,5,20,31,31,33,7,17,34,31,33,8,12,34,31,33,6,13,41,31,33,7,18,34,31,33,11,13,33,31,23,5,21,24,31,23,5,20,24,31,23,5,21,24,31,23,5,21,31,31,23,5,20,31,31,23,9,16,24,31,23,7,17,24,31,29,5,19,30,31,23,5,20,24,31,23,4,22,24,31,23,5,21,24,31,23,6,19,24,31,23,4,22,31,31,22,6,19,22,31,33,4,22,34,31,33,13,4,41,31,33,4,22,34,31,31,5,21,8],"a48":[31,0,0,0,0,31,34,12,6,37,31,33,7,17,14,31,33,4,21,34,31,34,5,21,34,31,33,5,21,34,31,33,5,21,34,31,34,12,7,18,31,33,11,12,34,31,33,8,12,34,31,29,4,22,23,31,28,4,22,24,31,9,6,17,17,31,20,4,22,6,31,9,10,10,9,31,33,7,17,34,31,33,5,21,34,31,34,6,13,34,31,33,5,20,33,31,32,4,21,33,31,34,4,22,34,31,32,5,19,33,31,34,5,21,35,31,32,4,22,32,31,33,5,20,34,31,33,5,21,33,31,23,11,9,23,31,23,6,15,31,31,31,4,22,29,31,23,4,22,14,31,31,4,22,29,31,35,6,18,38,31,36,5,21,37,31,34,5,21,35,31,34,5,21,34,31,35,7,17,36,31,34,7,18,34,31,34,7,19,34,31,34,9,16,35,31,35,5,20,36,31,35,6,18,36,31,34,6,18,34,31,35,6,15,36,31,35,5,21,36,31,35,6,20,35,31,35,5,21,36,31,35,5,20,36,31,35,5,21,36,31,34,6,20,35,31,35,5,22,36,31,34,6,18,35,31,35,6,18,36,31,34,4,22,35,31,35,5,20,36,31,35,4,22,36,31,35,5,21,36,31,35,5,21,36,31,35,5,20,36,31,34,5,20,34,31,33,9,17,34,31,33,7,17,34,31,33,5,17,34,31,34,4,22,19,31,-4,4,22,6,31,33,11,7,9,31,23,5,19,24,31,33,5,21,34,31,23,7,17,24,31,33,5,20,34,31,23,5,21,24,31,33,6,19,34,31,23,5,20,31,31,33,7,17,34,31,33,8,12,34,31,33,6,13,41,31,33,7,18,34,31,33,11,13,33,31,23,5,21,24,31,23,5,20,24,31,23,5,21,24,31,23,5,21,31,31,23,5,20,31,31,23,9,16,24,31,23,7,17,24,31,29,5,19,30,31,23,5,20,24,31,23,4,22,24,31,23,5,21,24,31,23,6,19,24,31,23,4,22,31,31,22,6,19,22,31,33,4,22,34,31,33,13,4,41,31,33,4,22,34,31,31,5,21,8],"m50":[33,0,0,0,0,33,35,13,6,38,33,35,7,18,14,33,35,4,22,36,33,35,5,22,35,33,35,5,22,36,33,35,5,22,36,33,35,12,8,18,33,35,11,13,36,33,35,7,13,36,33,30,5,22,24,33,31,5,22,27,33,10,7,17,18,33,20,4,24,6,33,9,11,11,9,33,35,7,18,36,33,35,5,22,36,33,35,6,14,35,33,35,5,20,35,33,35,4,22,36,33,35,4,23,35,33,35,6,19,36,33,35,5,22,36,33,35,5,23,35,33,35,5,21,36,33,35,5,22,35,33,24,11,9,24,33,24,6,15,32,33,32,4,24,30,33,24,4,24,14,33,32,4,24,30,33,37,6,20,40,33,37,5,23,38,33,35,5,22,36,33,35,5,21,35,33,36,7,18,37,33,35,7,18,35,33,35,7,20,35,33,35,9,17,36,33,36,5,22,37,33,37,6,19,38,33,35,7,18,35,33,37,6,15,38,33,37,6,22,37,33,37,6,21,37,33,37,5,22,37,33,37,6,20,37,33,36,5,21,37,33,35,6,21,35,33,36,5,23,37,33,35,7,18,35,33,36,7,18,37,33,35,5,22,36,33,37,6,20,38,33,37,4,24,37,33,37,5,22,37,33,37,5,22,37,33,37,6,20,37,33,35,6,20,35,33,35,9,17,36,33,35,7,18,36,33,35,5,17,36,33,35,4,24,19,33,-5,4,24,6,33,35,11,7,8,33,24,6,19,25,33,35,5,22,36,33,24,7,18,25,33,35,5,21,36,33,24,6,22,25,33,35,6,20,37,33,24,5,20,33,33,35,7,18,37,33,35,8,12,36,33,35,6,14,43,33,35,8,18,36,33,35,11,13,35,33,24,5,22,26,33,24,6,20,26,33,24,5,22,25,33,24,5,22,32,33,24,5,21,32,33,24,9,17,26,33,24,7,18,25,33,31,5,19,32,33,24,6,20,25,33,24,5,22,25,33,24,5,21,25,33,24,6,20,25,33,24,4,24,32,33,24,6,20,24,33,35,5,23,36,33,35,14,4,43,33,35,4,23,36,33,33,5,22,9],"a50":[33,0,0,0,0,33,35,13,6,38,33,35,7,18,15,33,35,4,22,36,33,35,5,22,35,33,35,5,22,36,33,35,5,22,36,33,35,12,8,18,33,35,11,13,36,33,35,7,13,36,33,30,5,22,24,33,31,5,22,27,33,10,7,17,18,33,20,4,24,6,33,9,11,11,9,33,35,7,18,36,33,35,5,22,36,33,35,6,14,35,33,35,5,20,35,33,35,4,22,36,33,35,4,23,35,33,35,6,19,36,33,35,5,22,36,33,35,5,23,35,33,35,5,21,36,33,35,5,22,35,33,24,11,9,24,33,24,6,15,32,33,32,4,24,30,33,24,4,24,14,33,32,4,24,30,33,37,6,20,40,33,37,5,23,38,33,35,5,22,36,33,35,5,21,35,33,36,7,18,37,33,35,7,18,35,33,35,7,20,35,33,35,9,17,36,33,36,5,22,37,33,36,6,19,37,33,35,7,18,35,33,36,6,15,37,33,36,6,22,37,33,36,6,21,36,33,36,5,22,37,33,36,6,20,37,33,36,5,21,37,33,35,6,21,35,33,36,5,23,37,33,35,7,18,35,33,36,7,18,37,33,35,5,22,36,33,36,6,20,37,33,36,4,24,37,33,36,5,22,37,33,36,5,22,37,33,36,6,20,37,33,35,6,20,35,33,35,9,17,36,33,35,7,18,36,33,35,5,17,36,33,35,4,24,19,33,-5,4,24,6,33,35,11,7,9,33,24,6,19,25,33,35,5,22,36,33,24,7,18,25,33,35,5,21,36,33,24,6,22,25,33,35,6,20,37,33,24,5,20,33,33,35,7,18,36,33,35,8,12,36,33,35,6,14,43,33,35,8,18,36,33,35,11,13,35,33,24,5,22,25,33,24,6,20,25,33,24,5,22,25,33,24,5,22,32,33,24,5,21,32,33,24,9,17,25,33,24,7,18,25,33,31,5,19,32,33,24,6,20,25,33,24,5,22,25,33,24,5,21,25,33,24,6,20,25,33,24,4,24,32,33,24,6,20,24,33,35,5,23,36,33,35,14,4,43,33,35,4,23,36,33,33,5,22,9],"m54":[35,0,0,0,0,35,38,14,7,42,35,37,8,20,16,35,37,5,24,38,35,38,6,23,39,35,37,5,24,38,35,37,5,24,38,35,38,13,8,20,35,37,12,14,39,35,37,9,14,39,35,32,5,25,25,35,33,5,25,29,35,10,7,19,19,35,21,5,25,6,35,10,11,12,10,35,37,8,19,39,35,37,5,24,38,35,38,6,16,39,35,37,6,22,37,35,37,5,24,38,35,38,5,25,39,35,37,7,21,38,35,38,5,24,39,35,37,5,25,38,35,37,5,25,38,35,37,5,24,38,35,26,12,10,26,35,26,7,16,35,35,34,5,25,31,35,26,5,25,15,35,34,5,25,31,35,40,7,20,44,35,40,5,25,41,35,38,5,24,39,35,38,5,25,38,35,39,8,19,40,35,38,8,20,38,35,38,8,22,38,35,38,10,19,39,35,38,6,23,39,35,40,7,21,41,35,38,8,19,38,35,40,6,18,41,35,40,6,24,40,35,40,7,23,40,35,40,5,24,40,35,40,6,23,40,35,39,6,23,40,35,38,7,22,39,35,39,5,25,40,35,38,7,21,39,35,39,7,21,40,35,38,5,25,39,35,40,6,23,41,35,40,5,25,40,35,40,5,24,40,35,40,6,23,40,35,40,6,23,40,35,38,6,22,38,35,37,10,19,38,35,37,8,19,39,35,37,6,19,38,35,38,5,25,21,35,-5,5,25,6,35,37,12,7,9,35,26,6,22,27,35,37,6,23,38,35,26,8,19,27,35,37,5,24,38,35,26,6,23,27,35,37,7,21,38,35,26,6,22,35,35,37,7,20,38,35,37,9,13,38,35,37,7,15,46,35,37,8,20,38,35,37,12,15,37,35,26,5,24,27,35,26,6,23,27,35,26,5,24,27,35,26,6,23,35,35,26,5,24,35,35,26,10,19,27,35,26,8,20,27,35,34,6,21,35,35,26,6,23,27,35,26,5,25,27,35,26,5,24,27,35,26,7,21,27,35,26,5,25,35,35,26,7,21,26,35,37,5,25,38,35,37,15,5,46,35,37,5,25,38,35,35,6,23,9],"a54":[35,0,0,0,0,35,38,14,7,42,35,37,8,20,16,35,37,5,24,38,35,38,6,23,39,35,37,5,24,38,35,37,5,24,38,35,38,13,8,20,35,37,12,14,39,35,37,9,14,39,35,32,5,25,25,35,33,5,25,29,35,10,7,19,19,35,21,5,25,6,35,10,11,12,10,35,37,8,19,39,35,37,5,24,38,35,38,6,16,39,35,37,6,22,37,35,37,5,24,38,35,38,5,25,39,35,37,7,21,38,35,38,5,24,39,35,37,5,25,38,35,37,5,25,38,35,37,5,24,38,35,26,12,10,26,35,26,7,16,35,35,34,5,25,31,35,26,5,25,15,35,34,5,25,31,35,40,7,20,44,35,40,5,25,41,35,38,5,24,39,35,38,5,25,38,35,39,8,19,40,35,38,8,20,38,35,38,8,22,38,35,38,10,19,39,35,38,6,23,39,35,39,7,21,40,35,38,8,19,38,35,39,6,18,40,35,39,6,24,40,35,39,7,23,39,35,39,5,24,40,35,39,6,23,40,35,39,6,23,40,35,38,7,22,39,35,39,5,25,40,35,38,7,21,39,35,39,7,21,40,35,38,5,25,39,35,39,6,23,40,35,39,5,25,40,35,39,5,24,40,35,39,6,23,40,35,39,6,23,40,35,38,6,22,38,35,37,10,19,38,35,37,8,19,39,35,37,6,19,38,35,38,5,25,21,35,-5,5,25,6,35,37,12,7,10,35,26,6,22,27,35,37,6,23,38,35,26,8,19,27,35,37,5,24,38,35,26,6,23,27,35,37,7,21,38,35,26,6,22,35,35,37,7,20,38,35,37,9,13,38,35,37,7,15,46,35,37,8,20,38,35,37,12,15,37,35,26,5,24,27,35,26,6,23,27,35,26,5,24,27,35,26,6,23,35,35,26,5,24,35,35,26,10,19,27,35,26,8,20,27,35,34,6,21,35,35,26,6,23,27,35,26,5,25,27,35,26,5,24,27,35,26,7,21,27,35,26,5,25,35,35,26,7,21,26,35,37,5,25,38,35,37,15,5,46,35,37,5,25,38,35,35,6,23,9],"m56":[36,0,0,0,0,36,39,14,7,43,36,39,8,20,16,36,39,5,25,40,36,39,6,24,40,36,39,6,24,40,36,39,6,24,40,36,39,14,9,20,36,39,13,15,40,36,39,8,15,40,36,33,5,25,26,36,34,5,25,29,36,11,7,20,20,36,22,5,26,6,36,10,12,12,10,36,39,8,20,40,36,39,6,24,40,36,39,7,16,40,36,39,6,23,39,36,38,5,25,39,36,39,5,26,40,36,38,6,22,39,36,39,6,24,40,36,38,5,26,39,36,39,6,25,40,36,39,6,24,40,36,27,13,10,27,36,27,7,17,36,36,36,5,26,33,36,27,5,26,16,36,36,5,26,33,36,41,7,21,45,36,42,6,25,43,36,40,5,26,41,36,40,6,25,40,36,41,8,20,42,36,40,8,21,40,36,40,8,22,40,36,40,10,19,41,36,41,6,23,42,36,41,7,22,43,36,40,7,21,40,36,41,6,18,42,36,41,6,25,41,36,41,7,24,41,36,41,6,24,41,36,41,6,24,41,36,41,6,24,42,36,40,7,23,41,36,41,6,25,42,36,40,8,21,41,36,41,8,21,42,36,40,5,25,41,36,41,6,24,42,36,41,5,26,41,36,41,6,24,41,36,41,6,24,41,36,41,6,23,41,36,40,6,23,40,36,39,10,20,40,36,39,8,20,40,36,39,6,20,40,36,39,5,26,21,36,-5,5,26,7,36,39,13,8,9,36,27,6,23,28,36,39,6,24,40,36,27,8,20,28,36,39,6,24,40,36,27,6,24,28,36,39,7,22,40,36,27,6,23,37,36,39,8,20,40,36,39,9,14,41,36,39,7,15,48,36,39,9,21,40,36,39,13,15,39,36,27,6,24,28,36,27,6,24,28,36,27,6,24,28,36,27,6,24,36,36,27,6,24,36,36,27,10,20,28,36,27,8,21,28,36,35,5,22,36,36,27,6,24,28,36,27,5,26,28,36,27,6,24,28,36,27,7,22,28,36,27,5,26,36,36,26,7,22,26,36,39,5,26,40,36,39,15,5,48,36,39,5,26,40,36,36,6,24,9],"a56":[36,0,0,0,0,36,39,14,7,43,36,39,8,20,17,36,39,5,25,40,36,39,6,24,40,36,39,6,24,40,36,39,6,24,40,36,39,14,9,20,36,39,13,15,40,36,39,8,15,40,36,33,5,25,26,36,34,5,25,29,36,11,7,20,20,36,22,5,26,6,36,10,12,12,10,36,39,8,20,40,36,39,6,24,40,36,39,7,16,40,36,39,6,23,39,36,38,5,25,39,36,39,5,26,40,36,38,6,22,39,36,39,6,24,40,36,38,5,26,39,36,39,6,25,40,36,39,6,24,40,36,27,13,10,27,36,27,7,17,36,36,36,5,26,33,36,27,5,26,16,36,36,5,26,33,36,41,7,21,45,36,42,6,25,43,36,40,5,26,41,36,40,6,25,40,36,41,8,20,42,36,40,8,21,40,36,40,8,22,40,36,40,10,19,41,36,41,6,23,42,36,40,7,22,42,36,40,7,21,40,36,40,6,18,41,36,40,6,25,41,36,40,7,24,40,36,40,6,24,41,36,40,6,24,41,36,41,6,24,42,36,40,7,23,41,36,41,6,25,42,36,40,8,21,41,36,41,8,21,42,36,40,5,25,41,36,40,6,24,41,36,40,5,26,41,36,40,6,24,41,36,40,6,24,41,36,40,6,23,41,36,40,6,23,40,36,39,10,20,40,36,39,8,20,40,36,39,6,20,40,36,39,5,26,21,36,-5,5,26,7,36,39,13,8,10,36,27,6,23,28,36,39,6,24,40,36,27,8,20,28,36,39,6,24,40,36,27,6,24,28,36,39,7,22,40,36,27,6,23,37,36,39,8,20,40,36,39,9,14,41,36,39,7,15,48,36,39,9,21,40,36,39,13,15,39,36,27,6,24,28,36,27,6,24,28,36,27,6,24,28,36,27,6,24,36,36,27,6,24,36,36,27,10,20,28,36,27,8,21,28,36,35,5,22,36,36,27,6,24,28,36,27,5,26,28,36,27,6,24,28,36,27,7,22,28,36,27,5,26,36,36,26,7,22,26,36,39,5,26,40,36,39,15,5,48,36,39,5,26,40,36,36,6,24,9],"m60":[39,0,0,0,0,39,42,16,8,46,39,42,9,22,17,39,42,6,27,43,39,42,6,27,44,39,42,6,27,43,39,42,6,27,43,39,42,15,9,22,39,42,14,16,43,39,42,9,16,43,39,36,6,27,28,39,36,6,27,31,39,12,8,22,22,39,24,6,28,7,39,10,13,13,11,39,42,9,21,43,39,42,6,27,43,39,42,7,17,43,39,42,6,25,42,39,41,6,26,42,39,42,5,28,43,39,41,7,24,42,39,42,6,27,43,39,41,6,27,42,39,42,6,27,43,39,42,6,27,43,39,29,14,11,30,39,29,8,18,39,39,38,6,28,35,39,29,6,28,17,39,38,6,28,35,39,44,7,22,48,39,44,6,26,45,39,43,6,27,44,39,43,6,27,43,39,44,9,21,45,39,43,9,22,43,39,43,9,24,43,39,43,11,20,44,39,44,7,25,45,39,45,8,23,46,39,43,9,21,43,39,45,7,19,46,39,45,7,26,45,39,45,8,26,45,39,45,6,27,45,39,45,7,25,45,39,44,6,27,45,39,43,8,25,44,39,44,6,27,45,39,43,8,23,44,39,44,8,23,45,39,43,6,27,44,39,45,7,25,46,39,45,6,28,45,39,45,6,27,45,39,45,7,26,45,39,45,7,25,45,39,43,7,25,43,39,42,11,21,43,39,42,9,21,43,39,42,6,21,43,39,42,6,28,23,39,-6,6,28,7,39,42,14,8,10,39,29,7,24,30,39,42,7,26,43,39,29,9,21,30,39,42,6,26,43,39,29,7,26,30,39,42,8,23,44,39,29,6,25,39,39,42,8,22,43,39,42,10,15,43,39,42,7,18,52,39,42,9,22,43,39,42,14,16,42,39,29,6,27,30,39,29,7,25,30,39,29,6,27,30,39,29,7,26,39,39,29,6,26,39,39,29,11,21,30,39,29,9,22,30,39,37,6,23,38,39,29,7,25,30,39,29,6,27,30,39,29,6,27,30,39,29,7,25,30,39,29,6,28,39,39,28,7,25,28,39,42,5,28,43,39,42,17,5,51,39,42,5,28,43,39,39,6,27,10],"a60":[39,0,0,0,0,39,42,16,8,46,39,42,9,22,18,39,42,6,27,43,39,42,6,27,44,39,42,6,27,43,39,42,6,27,43,39,42,15,9,22,39,42,14,16,43,39,42,9,16,43,39,36,6,27,28,39,36,6,27,31,39,12,8,22,22,39,24,6,28,7,39,10,13,13,11,39,42,9,21,43,39,42,6,27,43,39,42,7,17,43,39,42,6,25,42,39,41,6,26,42,39,42,5,28,43,39,41,7,24,42,39,42,6,27,43,39,41,6,27,42,39,42,6,27,43,39,42,6,27,43,39,29,14,11,30,39,29,8,18,39,39,38,6,28,35,39,29,6,28,17,39,38,6,28,35,39,44,7,22,48,39,44,6,26,45,39,43,6,27,44,39,43,6,27,43,39,44,9,21,45,39,43,9,22,43,39,43,9,24,43,39,43,11,20,44,39,44,7,25,45,39,44,8,23,45,39,43,9,21,43,39,44,7,19,45,39,44,7,26,45,39,44,8,26,44,39,44,6,27,45,39,44,7,25,45,39,44,6,27,45,39,43,8,25,44,39,44,6,27,45,39,43,8,23,44,39,44,8,23,45,39,43,6,27,44,39,44,7,25,45,39,44,6,28,45,39,44,6,27,45,39,44,7,26,45,39,44,7,25,45,39,43,7,25,43,39,42,11,21,43,39,42,9,21,43,39,42,6,21,43,39,42,6,28,23,39,-6,6,28,7,39,42,14,8,11,39,29,7,24,30,39,42,7,26,43,39,29,9,21,30,39,42,6,26,43,39,29,7,26,30,39,42,8,23,44,39,29,6,25,39,39,42,8,22,43,39,42,10,15,43,39,42,7,18,52,39,42,9,22,43,39,42,14,16,42,39,29,6,27,30,39,29,7,25,30,39,29,6,27,30,39,29,7,26,39,39,29,6,26,39,39,29,11,21,30,39,29,9,22,30,39,37,6,23,38,39,29,7,25,30,39,29,6,27,30,39,29,6,27,30,39,29,7,25,30,39,29,6,28,39,39,28,7,25,28,39,42,5,28,43,39,42,17,5,51,39,42,5,28,43,39,38,6,27,9],"m63":[41,0,0,0,0,41,44,16,8,48,41,44,9,23,18,41,44,5,30,45,41,44,6,29,45,41,44,6,29,45,41,44,6,29,45,41,44,15,10,23,41,44,14,17,45,41,44,10,17,45,41,37,5,30,29,41,38,5,30,32,41,13,8,23,23,41,25,6,29,7,41,10,13,14,11,41,44,9,22,45,41,44,6,29,45,41,44,8,18,45,41,44,7,26,44,41,43,6,28,44,41,44,6,29,45,41,43,7,25,44,41,44,6,29,45,41,43,6,29,44,41,44,6,29,45,41,44,6,29,46,41,30,14,12,31,41,30,9,19,41,41,40,6,29,37,41,31,6,29,19,41,40,6,29,37,41,46,8,24,50,41,46,6,29,47,41,45,6,28,46,41,45,6,29,45,41,46,9,23,47,41,45,9,24,45,41,45,9,25,45,41,45,12,22,46,41,45,7,27,46,41,47,8,25,48,41,45,9,22,45,41,47,7,21,48,41,47,7,28,47,41,47,8,27,47,41,47,6,29,47,41,47,7,27,47,41,46,6,28,47,41,45,8,27,47,41,46,6,29,47,41,45,9,24,47,41,46,9,24,47,41,45,5,30,46,41,47,7,27,48,41,47,6,29,47,41,47,6,28,47,41,47,7,26,47,41,47,7,26,47,41,45,7,26,45,41,44,12,22,45,41,44,9,22,45,41,44,7,22,45,41,44,6,29,24,41,-6,6,29,7,41,44,14,9,11,41,31,7,25,32,41,44,7,28,45,41,30,9,23,31,41,44,6,28,45,41,31,7,26,32,41,44,8,25,45,41,30,6,27,41,41,44,9,23,46,41,44,10,16,45,41,44,8,18,54,41,44,10,24,46,41,44,14,18,44,41,30,6,29,32,41,30,7,27,32,41,31,6,29,32,41,30,7,28,40,41,30,6,28,40,41,30,11,23,32,41,31,9,24,32,41,39,7,25,40,41,30,7,27,31,41,30,6,28,32,41,30,6,28,32,41,30,8,25,32,41,30,6,29,40,41,30,8,25,30,41,44,6,29,45,41,44,17,6,53,41,44,6,29,45,41,41,7,27,11],"a63":[41,0,0,0,0,41,44,16,8,48,41,44,9,23,19,41,44,5,30,45,41,44,6,29,45,41,44,6,29,45,41,44,6,29,45,41,44,15,10,23,41,44,14,17,45,41,44,10,17,45,41,37,5,30,29,41,38,5,30,32,41,13,8,23,23,41,25,6,29,7,41,10,13,14,11,41,44,9,22,45,41,44,6,29,45,41,44,8,18,45,41,44,7,26,44,41,43,6,28,44,41,44,6,29,45,41,43,7,25,44,41,44,6,29,45,41,43,6,29,44,41,44,6,29,45,41,44,6,29,46,41,30,14,12,31,41,30,9,19,41,41,40,6,29,37,41,31,6,29,19,41,40,6,29,37,41,46,8,24,50,41,46,6,29,47,41,45,6,28,46,41,45,6,29,45,41,46,9,23,47,41,45,9,24,45,41,45,9,25,45,41,45,12,22,46,41,45,7,27,46,41,46,8,25,47,41,45,9,22,45,41,46,7,21,47,41,46,7,28,47,41,46,8,27,46,41,46,6,29,47,41,46,7,27,47,41,46,6,28,47,41,45,8,27,47,41,46,6,29,47,41,45,9,24,47,41,46,9,24,47,41,45,5,30,46,41,46,7,27,47,41,46,6,29,47,41,46,6,28,47,41,46,7,26,47,41,46,7,26,47,41,45,7,26,45,41,44,12,22,45,41,44,9,22,45,41,44,7,22,45,41,44,6,29,24,41,-6,6,29,7,41,44,14,9,11,41,31,7,25,32,41,44,7,28,45,41,30,9,23,31,41,44,6,28,45,41,31,7,26,32,41,44,8,25,45,41,30,6,27,41,41,44,9,23,46,41,44,10,16,45,41,44,8,18,54,41,44,10,24,46,41,44,14,18,44,41,30,6,29,32,41,30,7,27,32,41,31,6,29,32,41,30,7,28,40,41,30,6,28,40,41,30,11,23,32,41,31,9,24,32,41,39,7,25,40,41,30,7,27,31,41,30,6,28,32,41,30,6,28,32,41,30,8,25,32,41,30,6,29,40,41,30,8,25,30,41,44,6,29,45,41,44,17,6,53,41,44,6,29,45,41,41,7,27,11],"m64":[42,0,0,0,0,42,45,17,8,49,42,44,9,24,18,42,44,6,30,45,42,45,7,29,46,42,44,7,29,45,42,44,7,28,45,42,45,16,10,23,42,44,15,17,46,42,44,10,17,46,42,38,6,30,30,42,39,6,30,34,42,12,9,23,23,42,25,6,30,7,42,10,14,14,11,42,44,9,23,46,42,44,7,29,45,42,45,8,19,46,42,44,7,27,44,42,44,6,29,45,42,45,6,30,47,42,44,7,26,45,42,45,7,29,46,42,44,6,30,45,42,44,7,29,45,42,44,7,29,45,42,30,15,12,31,42,30,8,20,41,42,41,6,30,38,42,32,6,30,20,42,41,6,30,38,42,47,8,24,51,42,48,6,29,49,42,46,6,30,47,42,46,7,29,46,42,47,9,24,48,42,46,9,25,46,42,46,9,26,46,42,46,12,22,47,42,47,7,27,48,42,47,8,26,48,42,46,9,24,46,42,47,7,21,48,42,47,7,29,48,42,47,8,28,47,42,47,7,29,48,42,47,7,28,48,42,47,7,28,48,42,46,8,28,47,42,47,7,29,48,42,46,9,25,47,42,47,9,25,48,42,46,6,30,47,42,47,7,28,48,42,47,6,30,48,42,47,7,28,48,42,47,7,28,48,42,47,7,28,48,42,46,8,26,46,42,44,12,23,45,42,44,9,23,46,42,44,7,23,45,42,45,6,30,24,42,-7,6,30,7,42,44,15,9,11,42,32,7,26,33,42,44,7,29,45,42,31,10,23,32,42,44,7,28,45,42,32,7,27,33,42,44,8,26,45,42,31,7,27,42,42,44,9,24,46,42,44,10,16,46,42,44,8,18,55,42,44,10,25,45,42,44,15,19,44,42,31,7,29,33,42,31,7,28,33,42,32,7,29,33,42,31,7,29,42,42,31,7,28,42,42,31,12,23,32,42,32,9,25,33,42,40,6,26,41,42,31,7,28,32,42,31,6,30,32,42,31,7,28,32,42,31,8,26,32,42,31,6,30,42,42,30,8,26,30,42,44,6,30,45,42,44,18,6,54,42,44,6,30,45,42,42,7,28,11],"a64":[42,0,0,0,0,42,45,17,8,49,42,44,9,24,19,42,44,6,30,45,42,45,7,29,46,42,44,7,29,45,42,44,7,28,45,42,45,16,10,23,42,44,15,17,46,42,44,10,17,46,42,38,6,30,30,42,39,6,30,34,42,12,9,23,23,42,25,6,30,7,42,10,14,14,11,42,44,9,23,46,42,44,7,29,45,42,45,8,19,46,42,44,7,27,44,42,44,6,29,45,42,45,6,30,47,42,44,7,26,45,42,45,7,29,46,42,44,6,30,45,42,44,7,29,45,42,44,7,29,45,42,30,15,12,31,42,30,8,20,41,42,41,6,30,38,42,32,6,30,20,42,41,6,30,38,42,47,8,24,51,42,48,6,29,49,42,46,6,30,47,42,46,7,29,46,42,47,9,24,48,42,46,9,25,46,42,46,9,26,46,42,46,12,22,47,42,47,7,27,48,42,46,8,26,47,42,46,9,24,46,42,46,7,21,47,42,46,7,29,48,42,46,8,28,46,42,46,7,29,48,42,46,7,28,48,42,47,7,28,48,42,46,8,28,47,42,47,7,29,48,42,46,9,25,47,42,47,9,25,48,42,46,6,30,47,42,46,7,28,47,42,46,6,30,48,42,46,7,28,48,42,46,7,28,48,42,46,7,28,48,42,46,8,26,46,42,44,12,23,45,42,44,9,23,46,42,44,7,23,45,42,45,6,30,24,42,-7,6,30,7,42,44,15,9,11,42,32,7,26,33,42,44,7,29,45,42,31,10,23,32,42,44,7,28,45,42,32,7,27,33,42,44,8,26,45,42,31,7,27,42,42,44,9,24,45,42,44,10,16,46,42,44,8,18,55,42,44,10,25,45,42,44,15,19,44,42,31,7,29,32,42,31,7,28,32,42,32,7,29,33,42,31,7,29,42,42,31,7,28,42,42,31,12,23,32,42,32,9,25,33,42,40,6,26,41,42,31,7,28,32,42,31,6,30,32,42,31,7,28,32,42,31,8,26,32,42,31,6,30,42,42,30,8,26,30,42,44,6,30,45,42,44,18,6,54,42,44,6,30,45,42,42,7,28,11],"m70":[46,0,0,0,0,46,49,18,9,54,46,49,10,27,20,46,49,7,32,50,46,49,7,31,50,46,49,7,31,50,46,49,7,31,50,46,49,17,11,25,46,49,16,18,50,46,49,11,18,50,46,41,7,32,32,46,42,7,32,36,46,13,10,25,25,46,28,7,32,8,46,11,15,15,12,46,49,10,25,50,46,49,7,31,50,46,49,8,20,50,46,49,8,29,49,46,47,7,31,48,46,49,7,32,50,46,47,8,28,48,46,49,7,31,50,46,47,7,32,49,46,49,7,31,50,46,49,7,31,50,46,33,16,13,34,46,33,10,21,45,46,44,7,32,40,46,34,7,32,20,46,44,7,32,40,46,51,9,26,56,46,52,7,31,53,46,50,7,31,51,46,50,7,31,50,46,51,10,25,52,46,50,10,26,50,46,50,10,28,50,46,50,13,23,52,46,50,7,30,51,46,52,9,27,53,46,50,10,24,50,46,52,8,22,53,46,52,8,30,52,46,52,9,29,52,46,52,7,31,52,46,52,8,29,52,46,51,7,30,52,46,50,9,29,52,46,51,7,31,52,46,50,9,27,52,46,51,9,27,52,46,50,6,32,51,46,52,8,29,53,46,52,6,32,52,46,52,7,31,52,46,52,8,29,52,46,52,8,28,52,46,50,8,29,50,46,49,13,25,50,46,49,10,25,50,46,49,7,25,50,46,49,7,32,26,46,-7,7,32,8,46,49,16,10,12,46,34,8,28,35,46,49,8,30,50,46,34,11,24,35,46,49,7,31,50,46,34,8,30,35,46,49,8,28,51,46,34,7,30,46,46,49,10,26,50,46,49,11,18,50,46,49,9,20,61,46,49,11,26,50,46,49,16,19,49,46,34,7,31,35,46,34,8,29,35,46,34,7,31,35,46,34,8,30,46,46,34,7,31,46,46,34,13,24,35,46,34,10,26,35,46,43,8,27,44,46,34,8,29,35,46,34,7,32,35,46,34,7,31,35,46,34,9,28,35,46,34,7,32,46,46,33,9,28,33,46,49,7,32,50,46,49,20,6,59,46,49,6,32,50,46,45,8,30,11],"a70":[46,0,0,0,0,46,49,18,9,54,46,49,10,27,21,46,49,7,32,50,46,49,7,31,50,46,49,7,31,50,46,49,7,31,50,46,49,17,11,25,46,49,16,18,50,46,49,11,18,50,46,41,7,32,32,46,42,7,32,36,46,13,10,25,25,46,28,7,32,8,46,11,15,15,12,46,49,10,25,50,46,49,7,31,50,46,49,8,20,50,46,49,8,29,49,46,47,7,31,48,46,49,7,32,50,46,47,8,28,48,46,49,7,31,50,46,47,7,32,49,46,49,7,31,50,46,49,7,31,50,46,33,16,13,34,46,33,10,21,45,46,44,7,32,40,46,34,7,32,20,46,44,7,32,40,46,51,9,26,56,46,52,7,31,53,46,50,7,31,51,46,50,7,31,50,46,51,10,25,52,46,50,10,26,50,46,50,10,28,50,46,50,13,23,52,46,50,7,30,51,46,51,9,27,52,46,50,10,24,50,46,51,8,22,52,46,51,8,30,52,46,51,9,29,51,46,51,7,31,52,46,51,8,29,52,46,51,7,30,52,46,50,9,29,52,46,51,7,31,52,46,50,9,27,52,46,51,9,27,52,46,50,6,32,51,46,51,8,29,52,46,51,6,32,52,46,51,7,31,52,46,51,8,29,52,46,51,8,28,52,46,50,8,29,50,46,49,13,25,50,46,49,10,25,50,46,49,7,25,50,46,49,7,32,26,46,-7,7,32,8,46,49,16,10,12,46,34,8,28,35,46,49,8,30,50,46,34,11,24,35,46,49,7,31,50,46,34,8,30,35,46,49,8,28,51,46,34,7,30,46,46,49,10,26,50,46,49,11,18,50,46,49,9,20,61,46,49,11,26,50,46,49,16,19,49,46,34,7,31,35,46,34,8,29,35,46,34,7,31,35,46,34,8,30,46,46,34,7,31,46,46,34,13,24,35,46,34,10,26,35,46,43,8,27,44,46,34,8,29,35,46,34,7,32,35,46,34,7,31,35,46,34,9,28,35,46,34,7,32,46,46,33,9,28,33,46,49,7,32,50,46,49,20,6,59,46,49,6,32,50,46,45,8,30,11],"m72":[47,0,0,0,0,47,50,19,9,55,47,50,10,27,21,47,50,7,33,52,47,50,8,31,51,47,50,7,32,51,47,50,7,31,51,47,50,18,11,25,47,50,17,19,51,47,50,11,19,51,47,43,7,32,34,47,42,7,32,36,47,14,10,26,26,47,28,7,33,8,47,12,16,16,13,47,50,11,25,51,47,50,7,32,51,47,50,9,20,51,47,50,8,30,50,47,49,7,32,50,47,50,7,33,51,47,49,9,28,50,47,50,7,32,51,47,49,6,33,50,47,50,7,32,51,47,50,7,32,51,47,35,17,13,36,47,35,10,21,47,47,46,7,33,42,47,35,7,33,21,47,46,7,33,42,47,52,9,27,57,47,53,7,32,54,47,53,7,32,54,47,51,7,32,51,47,52,10,26,53,47,51,10,27,51,47,51,10,28,51,47,51,13,24,52,47,52,8,30,53,47,53,9,28,54,47,51,10,26,51,47,53,8,23,54,47,53,8,31,53,47,53,9,30,53,47,53,7,32,53,47,53,8,30,53,47,52,7,31,53,47,51,9,30,52,47,52,7,32,54,47,51,10,27,52,47,52,10,26,53,47,51,7,32,52,47,53,8,30,54,47,53,7,32,53,47,53,7,32,53,47,53,8,30,53,47,53,8,30,53,47,51,8,30,51,47,50,14,25,51,47,50,11,25,51,47,50,8,25,51,47,50,7,33,27,47,-7,7,33,8,47,50,17,10,12,47,35,8,29,36,47,50,8,31,51,47,35,11,25,36,47,50,7,31,51,47,35,8,31,36,47,50,9,28,51,47,35,8,30,47,47,50,10,26,51,47,50,12,18,52,47,50,10,20,62,47,50,11,27,51,47,50,16,19,50,47,35,7,32,36,47,35,8,30,36,47,35,7,32,36,47,35,8,31,47,47,35,7,31,47,47,35,13,25,36,47,35,10,27,36,47,44,8,27,45,47,35,8,30,36,47,35,7,33,36,47,35,7,32,36,47,35,9,29,36,47,35,7,33,47,47,33,9,30,33,47,50,6,33,51,47,50,20,6,61,47,50,7,33,51,47,47,8,31,12],"a72":[47,0,0,0,0,47,50,19,9,55,47,50,10,27,21,47,50,7,33,52,47,50,8,31,51,47,50,7,32,51,47,50,7,31,51,47,50,18,11,25,47,50,17,19,51,47,50,11,19,51,47,43,7,32,34,47,42,7,32,36,47,14,10,26,26,47,28,7,33,8,47,12,16,16,13,47,50,11,25,51,47,50,7,32,51,47,50,9,20,51,47,50,8,30,50,47,49,7,32,50,47,50,7,33,51,47,49,9,28,50,47,50,7,32,51,47,49,6,33,50,47,50,7,32,51,47,50,7,32,51,47,35,17,13,36,47,35,10,21,47,47,46,7,33,42,47,35,7,33,21,47,46,7,33,42,47,52,9,27,57,47,53,7,32,54,47,52,7,32,53,47,51,7,32,51,47,52,10,26,53,47,51,10,27,51,47,51,10,28,51,47,51,13,24,52,47,52,8,30,53,47,52,9,28,53,47,51,10,26,51,47,52,8,23,53,47,52,8,31,53,47,52,9,30,52,47,52,7,32,53,47,52,8,30,53,47,52,7,31,53,47,51,9,30,52,47,52,7,32,54,47,51,10,27,52,47,52,10,26,53,47,51,7,32,52,47,52,8,30,53,47,52,7,32,53,47,52,7,32,53,47,52,8,30,53,47,52,8,30,53,47,51,8,30,51,47,50,14,25,51,47,50,11,25,51,47,50,8,25,51,47,50,7,33,27,47,-7,7,33,8,47,50,17,10,13,47,35,8,29,36,47,50,8,31,51,47,35,11,25,36,47,50,7,31,51,47,35,8,31,36,47,50,9,28,51,47,35,8,30,47,47,50,10,26,51,47,50,12,18,52,47,50,10,20,62,47,50,11,27,51,47,50,16,19,50,47,35,7,32,36,47,35,8,30,36,47,35,7,32,36,47,35,8,31,47,47,35,7,31,47,47,35,13,25,36,47,35,10,27,36,47,44,8,27,45,47,35,8,30,36,47,35,7,33,36,47,35,7,32,36,47,35,9,29,36,47,35,7,33,47,47,33,9,30,33,47,50,6,33,51,47,50,20,6,61,47,50,7,33,51,47,46,8,31,11],"m80":[52,0,0,0,0,52,56,21,11,61,52,55,12,30,23,52,55,7,37,56,52,56,8,36,57,52,55,8,36,56,52,55,8,36,56,52,56,20,13,29,52,55,18,21,57,52,55,13,21,57,52,47,8,37,36,52,48,8,37,41,52,16,11,28,29,52,32,8,37,9,52,13,17,18,14,52,55,12,28,57,52,55,8,36,56,52,56,10,23,57,52,55,9,33,55,52,54,8,35,55,52,56,8,37,57,52,54,9,32,55,52,56,8,36,57,52,54,7,37,56,52,55,8,35,56,52,55,8,36,56,52,38,19,15,39,52,38,11,24,52,52,51,8,37,47,52,39,8,37,23,52,51,8,37,47,52,59,10,29,65,52,59,8,35,61,52,59,8,36,61,52,57,8,36,57,52,58,12,29,59,52,57,12,30,57,52,57,11,32,57,52,57,15,27,58,52,58,9,34,59,52,59,10,32,61,52,57,12,29,57,52,59,9,26,60,52,59,9,35,60,52,59,10,34,59,52,59,8,36,60,52,59,9,34,60,52,59,8,36,60,52,57,10,34,59,52,58,8,36,59,52,57,11,31,59,52,58,11,30,59,52,57,8,37,58,52,59,9,34,60,52,59,8,37,60,52,59,8,36,60,52,59,9,34,60,52,59,10,33,60,52,57,10,33,57,52,55,15,28,56,52,55,12,28,57,52,55,9,28,56,52,56,8,37,30,52,-8,8,37,9,52,55,19,11,13,52,39,9,32,40,52,55,9,35,56,52,39,12,29,40,52,55,8,35,56,52,39,9,34,40,52,55,10,31,57,52,39,8,34,53,52,55,11,30,56,52,55,13,20,56,52,55,10,23,68,52,55,12,30,56,52,55,18,22,55,52,39,8,36,40,52,39,9,34,40,52,39,8,36,40,52,39,9,35,52,52,39,8,35,52,52,39,15,28,40,52,39,11,30,40,52,49,9,31,50,52,39,9,34,40,52,39,8,36,40,52,39,8,36,40,52,39,10,32,40,52,39,8,37,52,52,38,10,33,38,52,55,7,37,56,52,55,23,7,68,52,55,8,37,56,52,52,9,35,13],"a80":[52,0,0,0,0,52,56,21,11,61,52,55,12,30,24,52,55,7,37,56,52,56,8,36,57,52,55,8,36,56,52,55,8,36,56,52,56,20,13,29,52,55,18,21,57,52,55,13,21,57,52,47,8,37,36,52,48,8,37,41,52,16,11,28,29,52,32,8,37,9,52,13,17,18,14,52,55,12,28,57,52,55,8,36,56,52,56,10,23,57,52,55,9,33,55,52,54,8,35,55,52,56,8,37,57,52,54,9,32,55,52,56,8,36,57,52,54,7,37,56,52,55,8,35,56,52,55,8,36,56,52,38,19,15,39,52,38,11,24,52,52,51,8,37,47,52,39,8,37,23,52,51,8,37,47,52,59,10,29,65,52,59,8,35,61,52,58,8,36,60,52,57,8,36,57,52,58,12,29,59,52,57,12,30,57,52,57,11,32,57,52,57,15,27,58,52,58,9,34,59,52,58,10,32,60,52,57,12,29,57,52,58,9,26,59,52,58,9,35,60,52,58,10,34,58,52,58,8,36,60,52,58,9,34,60,52,59,8,36,60,52,57,10,34,59,52,58,8,36,59,52,57,11,31,59,52,58,11,30,59,52,57,8,37,59,52,58,9,34,59,52,58,8,37,60,52,58,8,36,60,52,58,9,34,60,52,58,10,33,60,52,57,10,33,57,52,55,15,28,56,52,55,12,28,57,52,55,9,28,56,52,56,8,37,30,52,-8,8,37,9,52,55,19,11,14,52,39,9,32,40,52,55,9,35,56,52,39,12,29,40,52,55,8,35,56,52,39,9,34,40,52,55,10,31,57,52,39,8,34,53,52,55,11,30,56,52,55,13,20,56,52,55,10,23,68,52,55,12,30,56,52,55,18,22,55,52,39,8,36,40,52,39,9,34,40,52,39,8,36,40,52,39,9,35,52,52,39,8,35,52,52,39,15,28,40,52,39,11,30,40,52,49,9,31,50,52,39,9,34,40,52,39,8,36,40,52,39,8,36,40,52,39,10,32,40,52,39,8,37,52,52,38,10,33,38,52,55,7,37,56,52,55,23,7,68,52,55,8,37,56,52,52,9,35,13],"m81":[53,0,0,0,0,53,57,21,10,62,53,56,12,29,23,53,56,8,36,57,53,57,8,36,59,53,56,8,36,57,53,56,8,35,57,53,57,20,13,29,53,56,18,21,58,53,56,12,21,58,53,48,7,37,37,53,48,7,37,41,53,16,11,28,29,53,32,8,36,9,53,13,17,17,14,53,56,12,28,58,53,56,8,36,57,53,57,9,23,58,53,56,9,33,56,53,55,8,35,56,53,57,7,37,58,53,55,10,31,56,53,57,8,36,58,53,55,8,36,56,53,56,8,35,57,53,56,8,36,57,53,39,19,15,40,53,39,11,24,52,53,51,8,36,47,53,39,8,36,23,53,51,8,36,47,53,60,10,30,66,53,60,8,36,62,53,59,8,36,61,53,58,8,36,58,53,59,12,28,60,53,58,12,30,58,53,58,11,32,58,53,58,15,27,59,53,59,9,34,60,53,60,10,32,61,53,58,11,29,58,53,60,9,26,61,53,60,9,35,60,53,60,10,34,60,53,60,8,36,60,53,60,9,34,60,53,59,8,35,60,53,58,10,34,59,53,59,8,36,60,53,58,11,31,59,53,59,11,30,60,53,58,7,37,59,53,60,9,34,61,53,60,8,36,60,53,60,8,36,60,53,60,9,34,60,53,60,9,33,60,53,58,10,32,58,53,56,15,28,57,53,56,12,28,58,53,56,9,28,57,53,56,8,36,30,53,-8,8,36,9,53,56,19,11,14,53,39,9,32,40,53,56,9,35,57,53,39,12,28,40,53,56,8,35,57,53,39,9,34,40,53,56,10,31,57,53,39,8,34,53,53,56,11,30,57,53,56,13,20,57,53,56,10,23,69,53,56,12,30,58,53,56,18,22,57,53,39,8,36,40,53,39,9,34,40,53,39,8,36,40,53,39,9,35,52,53,39,8,35,52,53,39,15,27,40,53,39,11,30,40,53,49,9,31,50,53,39,9,34,40,53,39,8,36,41,53,39,8,35,41,53,39,10,32,41,53,39,8,36,52,53,38,10,32,38,53,56,7,37,57,53,56,22,7,69,53,56,7,37,57,53,52,9,34,13],"a81":[53,0,0,0,0,53,57,21,10,62,53,56,12,29,24,53,56,8,36,57,53,57,8,36,59,53,56,8,36,57,53,56,8,35,57,53,57,20,13,29,53,56,18,21,58,53,56,12,21,58,53,48,7,37,37,53,48,7,37,41,53,16,11,28,29,53,32,8,36,9,53,13,17,17,14,53,56,12,28,58,53,56,8,36,57,53,57,9,23,58,53,56,9,33,56,53,55,8,35,56,53,57,7,37,58,53,55,10,31,56,53,57,8,36,58,53,55,8,36,56,53,56,8,35,57,53,56,8,36,57,53,39,19,15,40,53,39,11,24,52,53,51,8,36,47,53,39,8,36,23,53,51,8,36,47,53,60,10,30,66,53,60,8,36,62,53,58,8,36,60,53,58,8,36,58,53,59,12,28,60,53,58,12,30,58,53,58,11,32,58,53,58,15,27,59,53,59,9,34,60,53,59,10,32,60,53,58,11,29,58,53,59,9,26,60,53,59,9,35,60,53,59,10,34,59,53,59,8,36,60,53,59,9,34,60,53,59,8,35,60,53,58,10,34,59,53,59,8,36,60,53,58,11,31,59,53,59,11,30,60,53,58,7,37,59,53,59,9,34,60,53,59,8,36,60,53,59,8,36,60,53,59,9,34,60,53,59,9,33,60,53,58,10,32,58,53,56,15,28,57,53,56,12,28,58,53,56,9,28,57,53,56,8,36,30,53,-8,8,36,9,53,56,19,11,14,53,39,9,32,40,53,56,9,35,57,53,39,12,28,40,53,56,8,35,57,53,39,9,34,40,53,56,10,31,57,53,39,8,34,53,53,56,11,30,58,53,56,13,20,57,53,56,10,23,69,53,56,12,30,58,53,56,18,22,57,53,39,8,36,41,53,39,9,34,41,53,39,8,36,40,53,39,9,35,52,53,39,8,35,52,53,39,15,27,41,53,39,11,30,40,53,49,9,31,50,53,39,9,34,40,53,39,8,36,41,53,39,8,35,41,53,39,10,32,41,53,39,8,36,52,53,38,10,32,38,53,56,7,37,57,53,56,22,7,69,53,56,7,37,57,53,52,9,34,13],"m84":[55,0,0,0,0,55,59,22,11,65,55,58,12,31,24,55,58,8,39,60,55,59,9,38,60,55,58,9,38,59,55,58,9,38,59,55,59,21,13,30,55,58,19,23,60,55,58,13,23,60,55,50,8,40,39,55,51,8,40,44,55,16,12,29,30,55,34,8,39,10,55,14,18,18,15,55,58,13,29,60,55,58,9,38,59,55,59,10,25,60,55,58,10,35,58,55,58,8,38,59,55,59,8,39,61,55,58,10,34,59,55,59,9,38,60,55,58,8,39,59,55,58,9,38,59,55,58,9,38,59,55,41,20,16,42,55,41,11,26,55,55,53,8,39,49,55,42,8,39,26,55,53,8,39,49,55,62,10,31,68,55,62,8,37,64,55,61,9,37,62,55,60,9,38,60,55,62,12,31,63,55,60,12,33,60,55,60,12,34,60,55,60,16,29,61,55,61,9,36,62,55,62,11,34,63,55,60,13,30,60,55,62,10,27,63,55,62,10,38,62,55,62,11,37,62,55,62,9,38,62,55,62,10,36,62,55,62,9,38,63,55,60,11,36,61,55,62,9,39,63,55,60,12,33,61,55,62,12,32,63,55,60,8,40,62,55,62,10,36,63,55,62,8,39,62,55,62,9,38,62,55,62,10,35,62,55,62,10,36,62,55,60,10,35,60,55,58,16,30,59,55,58,13,29,60,55,58,9,30,59,55,58,8,39,31,55,-8,8,39,10,55,58,20,12,14,55,42,10,34,43,55,58,9,38,59,55,41,13,30,42,55,58,9,37,59,55,42,10,36,43,55,58,10,34,59,55,41,9,36,55,55,58,12,32,60,55,58,14,22,60,55,58,11,24,72,55,58,13,32,59,55,58,19,24,59,55,41,9,38,43,55,41,10,36,43,55,42,9,38,43,55,41,9,38,55,55,41,9,37,55,55,41,15,31,42,55,42,12,32,43,55,52,9,34,53,55,41,10,36,42,55,41,8,39,42,55,41,9,38,42,55,41,11,33,42,55,41,8,39,55,55,40,11,34,40,55,58,8,39,59,55,58,24,8,71,55,58,8,39,59,55,55,9,37,15],"a84":[55,0,0,0,0,55,59,22,11,65,55,58,12,31,25,55,58,8,39,60,55,59,9,38,60,55,58,9,38,59,55,58,9,38,59,55,59,21,13,30,55,58,19,23,60,55,58,13,23,60,55,50,8,40,39,55,51,8,40,44,55,16,12,29,30,55,34,8,39,10,55,14,18,18,15,55,58,13,29,60,55,58,9,38,59,55,59,10,25,60,55,58,10,35,58,55,58,8,38,59,55,59,8,39,61,55,58,10,34,59,55,59,9,38,60,55,58,8,39,59,55,58,9,38,59,55,58,9,38,59,55,41,20,16,42,55,41,11,26,55,55,53,8,39,49,55,42,8,39,26,55,53,8,39,49,55,62,10,31,68,55,62,8,37,64,55,60,9,37,61,55,60,9,38,60,55,62,12,31,63,55,60,12,33,60,55,60,12,34,60,55,60,16,29,61,55,61,9,36,62,55,61,11,34,62,55,60,13,30,60,55,61,10,27,62,55,61,10,38,62,55,61,11,37,61,55,61,9,38,62,55,61,10,36,62,55,62,9,38,63,55,60,11,36,61,55,62,9,39,63,55,60,12,33,61,55,62,12,32,63,55,60,8,40,61,55,61,10,36,62,55,61,8,39,62,55,61,9,38,62,55,61,10,35,62,55,61,10,36,62,55,60,10,35,60,55,58,16,30,59,55,58,13,29,60,55,58,9,30,59,55,58,8,39,31,55,-8,8,39,10,55,58,20,12,15,55,42,10,34,43,55,58,9,38,59,55,41,13,30,42,55,58,9,37,59,55,42,10,36,43,55,58,10,34,59,55,41,9,36,55,55,58,12,32,59,55,58,14,22,60,55,58,11,24,72,55,58,13,32,59,55,58,19,24,59,55,41,9,38,42,55,41,10,36,42,55,42,9,38,43,55,41,9,38,55,55,41,9,37,55,55,41,15,31,42,55,42,12,32,43,55,52,9,34,53,55,41,10,36,42,55,41,8,39,42,55,41,9,38,42,55,41,11,33,42,55,41,8,39,55,55,40,11,34,40,55,58,8,39,59,55,58,24,8,71,55,58,8,39,59,55,55,9,37,15],"m90":[59,0,0,0,0,59,63,23,12,69,59,62,13,33,26,59,62,9,40,63,59,63,9,40,65,59,62,9,40,63,59,62,9,40,63,59,63,22,14,32,59,62,20,23,64,59,62,14,23,64,59,53,9,40,41,59,54,9,40,46,59,17,12,31,32,59,36,8,41,10,59,15,19,19,16,59,62,13,31,64,59,62,9,40,63,59,63,11,25,64,59,62,10,38,62,59,61,9,39,62,59,63,9,41,65,59,61,11,35,62,59,63,9,40,64,59,61,9,40,63,59,62,9,40,63,59,62,9,40,63,59,44,21,17,45,59,44,12,27,59,59,57,8,41,52,59,44,8,41,26,59,57,8,41,52,59,66,11,34,72,59,66,9,41,68,59,66,9,41,68,59,64,9,40,64,59,65,13,33,66,59,64,13,34,64,59,64,13,36,64,59,64,17,31,65,59,65,10,38,66,59,66,11,36,68,59,64,13,32,64,59,66,11,29,67,59,66,10,40,67,59,66,11,39,66,59,66,9,41,67,59,66,10,38,67,59,66,9,40,67,59,64,11,39,66,59,65,9,42,66,59,64,12,36,66,59,65,11,36,66,59,64,8,42,65,59,66,10,38,67,59,66,9,41,67,59,66,9,40,67,59,66,10,39,67,59,66,10,38,67,59,64,11,37,64,59,62,17,31,63,59,62,13,31,64,59,62,10,31,63,59,63,8,41,34,59,-9,8,41,10,59,62,21,12,15,59,44,10,36,45,59,62,10,39,63,59,43,13,32,44,59,62,9,39,63,59,44,10,38,45,59,62,11,35,64,59,43,9,38,58,59,62,12,33,64,59,62,14,23,64,59,62,12,26,77,59,62,14,33,64,59,62,20,25,63,59,43,9,40,45,59,43,10,38,45,59,44,9,40,45,59,43,10,39,58,59,43,9,39,58,59,43,16,31,45,59,44,12,34,45,59,56,10,34,57,59,43,10,38,44,59,43,9,40,45,59,43,9,39,45,59,43,11,35,45,59,43,8,41,58,59,42,11,36,42,59,62,9,41,63,59,62,25,8,76,59,62,8,41,63,59,58,10,38,15],"a90":[59,0,0,0,0,59,63,23,12,69,59,62,13,33,26,59,62,9,40,63,59,63,9,40,65,59,62,9,40,63,59,62,9,40,63,59,63,22,14,32,59,62,20,23,64,59,62,14,23,64,59,53,9,40,41,59,54,9,40,46,59,17,12,31,32,59,36,8,41,10,59,15,19,19,16,59,62,13,31,64,59,62,9,40,63,59,63,11,25,64,59,62,10,38,62,59,61,9,39,62,59,63,9,41,65,59,61,11,35,62,59,63,9,40,64,59,61,9,40,63,59,62,9,40,63,59,62,9,40,63,59,44,21,17,45,59,44,12,27,59,59,57,8,41,52,59,44,8,41,26,59,57,8,41,52,59,66,11,34,72,59,66,9,41,68,59,65,9,41,67,59,64,9,40,64,59,65,13,33,66,59,64,13,34,64,59,64,13,36,64,59,64,17,31,65,59,65,10,38,66,59,65,11,36,67,59,64,13,32,64,59,65,11,29,66,59,65,10,40,67,59,65,11,39,65,59,65,9,41,67,59,65,10,38,67,59,66,9,40,67,59,64,11,39,66,59,65,9,42,66,59,64,12,36,66,59,65,11,36,66,59,64,8,42,65,59,65,10,38,66,59,65,9,41,67,59,65,9,40,67,59,65,10,39,67,59,65,10,38,67,59,64,11,37,64,59,62,17,31,63,59,62,13,31,64,59,62,10,31,63,59,63,8,41,34,59,-9,8,41,10,59,62,21,12,16,59,44,10,36,45,59,62,10,39,63,59,43,13,32,44,59,62,9,39,63,59,44,10,38,45,59,62,11,35,64,59,43,9,38,58,59,62,12,33,64,59,62,14,23,64,59,62,12,26,77,59,62,14,33,64,59,62,20,25,63,59,43,9,40,45,59,43,10,38,45,59,44,9,40,45,59,43,10,39,58,59,43,9,39,58,59,43,16,31,45,59,44,12,34,45,59,56,10,34,57,59,43,10,38,44,59,43,9,40,45,59,43,9,39,45,59,43,11,35,45,59,43,8,41,58,59,42,11,36,42,59,62,9,41,63,59,62,25,8,76,59,62,8,41,63,59,58,10,38,15],"m96":[62,0,0,0,0,62,67,25,12,73,62,67,14,34,28,62,67,9,43,68,62,67,10,41,68,62,67,10,41,68,62,67,10,41,68,62,67,23,15,34,62,67,22,24,68,62,67,15,24,68,62,57,10,42,44,62,58,10,42,49,62,18,13,33,34,62,38,9,43,11,62,16,20,21,17,62,67,14,33,68,62,67,10,41,68,62,67,12,26,68,62,67,10,40,67,62,66,10,41,67,62,67,9,43,69,62,66,11,37,67,62,67,10,41,68,62,66,9,43,67,62,67,10,42,68,62,67,10,41,68,62,47,22,18,48,62,47,13,29,62,62,61,9,43,56,62,47,9,43,28,62,61,9,43,56,62,71,12,35,78,62,71,10,41,73,62,70,10,42,72,62,68,10,41,68,62,70,14,34,71,62,68,14,35,68,62,68,13,37,68,62,68,18,32,69,62,70,10,40,71,62,70,12,37,72,62,68,14,34,68,62,70,11,30,72,62,70,11,41,71,62,70,12,40,70,62,70,10,41,71,62,70,11,39,71,62,70,10,41,71,62,68,12,39,69,62,70,10,42,72,62,68,13,37,69,62,70,12,37,71,62,68,10,42,70,62,70,11,39,71,62,70,9,43,71,62,70,10,41,71,62,70,11,40,71,62,70,12,38,71,62,68,11,39,68,62,67,18,33,68,62,67,14,33,68,62,67,10,33,68,62,67,9,43,36,62,-9,9,43,11,62,67,22,13,16,62,47,11,37,48,62,67,11,40,68,62,46,14,34,48,62,67,10,40,68,62,47,11,41,48,62,67,12,37,69,62,46,10,39,62,62,67,13,35,70,62,67,15,24,68,62,67,13,26,83,62,67,15,35,69,62,67,21,25,68,62,46,10,41,49,62,46,11,39,49,62,47,10,41,48,62,46,11,40,62,62,46,10,40,62,62,46,17,33,48,62,47,12,37,48,62,60,10,36,61,62,46,11,39,47,62,46,9,43,48,62,46,10,41,48,62,46,12,38,48,62,46,9,43,62,62,46,12,38,46,62,67,9,43,68,62,67,27,8,81,62,67,9,43,68,62,63,10,41,17],"a96":[62,0,0,0,0,62,67,25,12,73,62,67,14,34,28,62,67,9,43,68,62,67,10,41,68,62,67,10,41,68,62,67,10,41,68,62,67,23,15,34,62,67,22,24,68,62,67,15,24,68,62,57,10,42,44,62,58,10,42,49,62,18,13,33,34,62,38,9,43,11,62,16,20,21,17,62,67,14,33,68,62,67,10,41,68,62,67,12,26,68,62,67,10,40,67,62,66,10,41,67,62,67,9,43,69,62,66,11,37,67,62,67,10,41,68,62,66,9,43,67,62,67,10,42,68,62,67,10,41,68,62,47,22,18,48,62,47,13,29,62,62,61,9,43,56,62,47,9,43,28,62,61,9,43,56,62,71,12,35,78,62,71,10,41,73,62,69,10,42,71,62,68,10,41,68,62,70,14,34,71,62,68,14,35,68,62,68,13,37,68,62,68,18,32,69,62,70,10,40,71,62,69,12,37,71,62,68,14,34,68,62,69,11,30,71,62,69,11,41,71,62,69,12,40,69,62,69,10,41,71,62,69,11,39,71,62,70,10,41,71,62,68,12,39,69,62,70,10,42,72,62,68,13,37,69,62,70,12,37,71,62,68,10,42,70,62,69,11,39,70,62,69,9,43,71,62,69,10,41,71,62,69,11,40,71,62,69,12,38,71,62,68,11,39,68,62,67,18,33,68,62,67,14,33,68,62,67,10,33,68,62,67,9,43,36,62,-9,9,43,11,62,67,22,13,17,62,47,11,37,48,62,67,11,40,68,62,46,14,34,48,62,67,10,40,68,62,47,11,41,48,62,67,12,37,69,62,46,10,39,62,62,67,13,35,69,62,67,15,24,68,62,67,13,26,83,62,67,15,35,69,62,67,21,25,68,62,46,10,41,48,62,46,11,39,48,62,47,10,41,48,62,46,11,40,62,62,46,10,40,62,62,46,17,33,48,62,47,12,37,48,62,60,10,36,61,62,46,11,39,47,62,46,9,43,48,62,46,10,41,48,62,46,12,38,48,62,46,9,43,62,62,46,12,38,46,62,67,9,43,68,62,67,27,8,81,62,67,9,43,68,62,63,10,41,17],"m108":[70,0,0,0,0,70,75,28,14,82,70,75,15,40,31,70,75,10,49,77,70,75,11,48,76,70,75,11,48,76,70,75,11,48,76,70,75,26,17,38,70,75,24,28,77,70,75,17,28,77,70,64,10,50,50,70,65,10,50,56,70,20,15,37,38,70,43,10,49,12,70,18,23,23,19,70,75,16,37,77,70,75,11,48,76,70,75,13,31,77,70,75,12,45,75,70,74,10,48,75,70,75,10,49,76,70,74,13,42,75,70,75,11,48,76,70,74,11,49,75,70,75,11,48,76,70,75,11,48,76,70,52,25,20,53,70,52,15,32,70,70,68,10,49,62,70,53,10,49,32,70,68,10,49,62,70,80,14,40,87,70,80,11,49,82,70,79,11,49,80,70,77,11,50,77,70,79,16,39,80,70,77,16,41,77,70,77,15,44,77,70,77,20,37,78,70,78,12,46,80,70,79,14,43,81,70,77,16,38,77,70,79,13,35,81,70,79,12,48,80,70,79,14,47,79,70,79,11,49,80,70,79,12,47,80,70,79,11,49,80,70,77,14,46,78,70,79,11,50,80,70,77,15,43,78,70,79,14,43,81,70,77,10,50,79,70,79,12,47,80,70,79,10,50,80,70,79,11,49,80,70,79,12,46,80,70,79,12,46,80,70,77,13,44,77,70,75,20,38,76,70,75,16,37,77,70,75,12,38,76,70,75,10,49,40,70,-10,10,49,13,70,75,25,15,18,70,53,12,43,55,70,75,12,47,77,70,52,16,39,54,70,75,11,47,76,70,53,12,45,54,70,75,13,43,77,70,52,11,45,70,70,75,15,40,77,70,75,17,27,77,70,75,14,30,93,70,75,16,40,77,70,75,24,30,76,70,52,11,48,54,70,52,12,46,54,70,53,11,48,55,70,52,12,47,70,70,52,11,47,70,70,52,19,38,54,70,53,14,42,55,70,67,12,42,68,70,52,12,46,54,70,52,11,48,54,70,52,11,48,54,70,52,14,42,54,70,52,10,49,70,70,51,14,42,51,70,75,10,49,76,70,75,30,10,91,70,75,10,49,76,70,70,12,46,18],"a108":[70,0,0,0,0,70,75,28,14,82,70,75,15,40,32,70,75,10,49,77,70,75,11,48,76,70,75,11,48,76,70,75,11,48,76,70,75,26,17,38,70,75,24,28,77,70,75,17,28,77,70,64,10,50,50,70,65,10,50,56,70,20,15,37,38,70,43,10,49,12,70,18,23,23,19,70,75,16,37,77,70,75,11,48,76,70,75,13,31,77,70,75,12,45,75,70,74,10,48,75,70,75,10,49,76,70,74,13,42,75,70,75,11,48,76,70,74,11,49,75,70,75,11,48,76,70,75,11,48,76,70,52,25,20,53,70,52,15,32,70,70,68,10,49,62,70,53,10,49,32,70,68,10,49,62,70,80,14,40,87,70,80,11,49,82,70,78,11,49,79,70,77,11,50,77,70,79,16,39,80,70,77,16,41,77,70,77,15,44,77,70,77,20,37,78,70,78,12,46,80,70,78,14,43,80,70,77,16,38,77,70,78,13,35,80,70,78,12,48,80,70,78,14,47,78,70,78,11,49,80,70,78,12,47,80,70,79,11,49,80,70,77,14,46,78,70,79,11,50,80,70,77,15,43,78,70,79,14,43,81,70,77,10,50,79,70,78,12,47,79,70,78,10,50,80,70,78,11,49,80,70,78,12,46,80,70,78,12,46,80,70,77,13,44,77,70,75,20,38,76,70,75,16,37,77,70,75,12,38,76,70,75,10,49,40,70,-10,10,49,13,70,75,25,15,19,70,53,12,43,55,70,75,12,47,77,70,52,16,39,54,70,75,11,47,76,70,53,12,45,54,70,75,13,43,77,70,52,11,45,70,70,75,15,40,77,70,75,17,27,77,70,75,14,30,93,70,75,16,40,77,70,75,24,30,76,70,52,11,48,54,70,52,12,46,54,70,53,11,48,55,70,52,12,47,70,70,52,11,47,70,70,52,19,38,54,70,53,14,42,55,70,67,12,42,68,70,52,12,46,54,70,52,11,48,54,70,52,11,48,54,70,52,14,42,54,70,52,10,49,70,70,51,14,42,51,70,75,10,49,76,70,75,30,10,91,70,75,10,49,76,70,70,12,46,18]},"fonts":{}};
	  if (typeof bwipjs_fonts == "object") {
	    bwipjs_fonts.fontsets[1] = desc;
	    bwipjs_fonts.names["OCR-B"] = 1;
	  } else {
	    module.exports = desc;
	  }
	})();
	// fnt2-desc.js
	(function() {
	  var desc = { name:"Symbol", minsize:10, maxsize:90, minchar:48, maxchar:57,
	    sizes:{10:10,20:20,30:30,40:40,50:50,60:60,70:70,80:80,90:90}, fonts:{},
	    metrics:{
	a10:[4,4,0,3,2,4,4,1,3,2,4,4,1,3,2,4,4,2,2,2,30,30,0,30,30],
	a20:[8,8,1,6,6,8,8,1,6,6,8,8,1,7,6,8,8,1,7,6,60,60,0,60,60],
	a30:[12,12,1,10,10,12,12,1,10,10,12,12,1,10,10,12,12,2,10,10,90,90,0,90,90],
	a40:[14,16,0,14,14,14,16,0,14,14,14,16,0,14,14,14,16,0,14,14,120,120,0,120,120],
	a50:[18,20,0,17,18,18,20,1,17,18,18,20,1,17,18,18,20,2,16,18,150,150,0,150,150],
	a60:[22,24,1,20,22,22,24,1,20,22,22,24,1,21,22,22,24,1,21,22,180,180,0,180,180],
	a70:[26,28,1,24,26,26,28,1,24,26,26,28,1,24,26,26,28,2,24,26,210,210,0,210,210],
	a80:[28,32,1,26,30,28,32,1,26,30,28,32,1,26,30,28,32,1,26,30,240,240,0,240,240],
	a90:[32,36,0,31,34,32,36,1,31,34,32,36,1,31,34,32,36,2,30,34,272,272,1,270,270],
	m10:[4,4,1,2,2,4,4,1,2,2,4,4,2,2,2,4,4,2,2,2,30,30,0,30,30],
	m20:[8,8,1,6,6,8,8,1,6,6,8,8,1,6,6,8,8,1,6,6,60,60,0,60,60],
	m30:[12,12,2,8,10,12,12,2,8,10,12,12,2,8,10,12,12,2,8,10,90,90,0,90,90],
	m40:[14,16,1,12,14,14,16,1,12,14,14,16,1,12,14,14,16,1,12,14,120,120,0,120,120],
	m50:[18,20,1,16,18,18,20,1,16,18,18,20,1,16,18,18,20,1,16,18,150,150,0,150,150],
	m60:[22,24,1,20,22,22,24,1,20,22,22,24,1,20,22,22,24,1,20,22,180,180,0,180,180],
	m70:[26,28,2,22,26,26,28,2,22,26,26,28,2,22,26,26,28,2,22,26,210,210,0,210,210],
	m80:[28,32,1,26,30,28,32,1,26,30,28,32,1,26,30,28,32,1,26,30,240,240,0,240,240],
	m90:[32,36,1,30,34,32,36,1,30,34,32,36,1,30,34,32,36,1,30,34,272,272,1,270,270],
	    }
	  };
	  if (typeof bwipjs_fonts == "object") {
	    bwipjs_fonts.fontsets[2] = desc;
	    bwipjs_fonts.names.SYMBOL = 2;
	  } else {
	    module.exports = desc;
	  }
	})();
	// fnt3-desc.js
	// $ node genfont Inconsolata fonts/Inconsolata.otf 3 108
	(function() {
	  var desc = {"name":"Inconsolata","minsize":8,"maxsize":108,"minchar":32,"maxchar":126,"sizes":{"8":8,"9":9,"10":10,"12":12,"16":16,"18":18,"20":20,"24":24,"27":27,"30":30,"32":32,"36":36,"40":40,"45":45,"48":48,"50":50,"54":54,"56":56,"60":60,"63":63,"64":64,"70":70,"72":72,"80":80,"81":81,"84":84,"90":90,"96":96,"108":108},"metrics":{"m8":[4,0,0,0,0,4,6,1,2,6,4,6,0,4,3,4,6,0,5,6,4,6,0,4,7,4,6,0,5,6,4,6,0,5,6,4,6,1,2,3,4,6,1,3,8,4,6,0,4,8,4,5,0,4,5,4,5,0,4,5,4,1,1,2,3,4,3,0,4,1,4,1,1,2,1,4,6,0,4,7,4,6,0,4,6,4,6,0,3,6,4,6,0,4,6,4,6,0,4,6,4,6,0,4,6,4,6,0,4,6,4,6,0,4,6,4,6,0,4,6,4,6,0,4,6,4,6,0,4,6,4,4,1,2,4,4,4,1,2,6,4,5,0,4,5,4,4,0,4,3,4,5,0,5,5,4,6,0,4,6,4,6,0,5,6,4,6,0,5,6,4,6,0,4,6,4,6,0,5,6,4,6,0,4,6,4,6,0,4,6,4,6,0,4,6,4,6,0,4,6,4,6,0,4,6,4,6,0,4,6,4,6,0,4,6,4,6,0,5,7,4,6,0,4,6,4,6,0,4,6,4,6,0,4,6,4,6,0,5,6,4,6,0,4,6,4,6,0,5,8,4,6,0,4,6,4,6,0,4,6,4,6,0,4,6,4,6,0,4,6,4,6,0,5,6,4,6,0,5,6,4,6,0,5,6,4,6,0,5,6,4,6,0,4,6,4,6,1,3,7,4,6,0,4,7,4,6,0,4,7,4,6,0,4,4,4,0,0,5,1,4,6,1,2,3,4,4,0,4,4,4,6,0,4,6,4,4,0,4,4,4,6,0,4,6,4,4,0,4,4,4,6,0,5,6,4,5,0,5,7,4,6,0,4,6,4,6,0,4,6,4,6,0,4,8,4,6,0,5,7,4,6,0,4,6,4,4,0,5,4,4,4,0,4,4,4,4,0,4,4,4,4,0,4,6,4,4,0,4,6,4,4,0,4,4,4,4,0,4,4,4,6,0,4,6,4,4,0,4,4,4,4,0,4,4,4,4,0,5,4,4,4,0,4,4,4,4,0,4,6,4,4,0,4,4,4,6,0,4,8,4,6,1,2,8,4,6,0,4,8,4,4,0,5,2],"a8":[4,0,0,0,0,4,6,1,2,6,4,6,0,4,3,4,6,0,5,6,4,6,0,4,7,4,6,0,5,6,4,6,0,5,6,4,6,1,2,3,4,6,1,3,8,4,6,0,4,8,4,5,0,4,5,4,5,0,4,5,4,1,1,2,3,4,3,0,4,1,4,1,1,2,1,4,6,0,4,7,4,6,0,4,6,4,6,0,3,6,4,6,0,4,6,4,6,0,4,6,4,6,0,4,6,4,6,0,4,6,4,6,0,4,6,4,6,0,4,6,4,6,0,4,6,4,6,0,4,6,4,4,1,2,4,4,4,1,2,6,4,5,0,4,5,4,4,0,4,3,4,5,0,5,5,4,6,0,4,6,4,6,0,5,6,4,6,0,5,6,4,6,0,4,6,4,6,0,5,6,4,6,0,4,6,4,6,0,4,6,4,6,0,4,6,4,6,0,4,6,4,6,0,4,6,4,6,0,4,6,4,6,0,4,6,4,6,0,5,7,4,6,0,4,6,4,6,0,4,6,4,6,0,4,6,4,6,0,5,6,4,6,0,4,6,4,6,0,5,8,4,6,0,4,6,4,6,0,4,6,4,6,0,4,6,4,6,0,4,6,4,6,0,5,6,4,6,0,5,6,4,6,0,5,6,4,6,0,5,6,4,6,0,4,6,4,6,1,3,7,4,6,0,4,7,4,6,0,4,7,4,6,0,4,4,4,0,0,5,1,4,6,1,2,3,4,4,0,4,4,4,6,0,4,6,4,4,0,4,4,4,6,0,4,6,4,4,0,4,4,4,6,0,5,6,4,5,0,5,7,4,6,0,4,6,4,6,0,4,6,4,6,0,4,8,4,6,0,5,7,4,6,0,4,6,4,4,0,5,4,4,4,0,4,4,4,4,0,4,4,4,4,0,4,6,4,4,0,4,6,4,4,0,4,4,4,4,0,4,4,4,6,0,4,6,4,4,0,4,4,4,4,0,4,4,4,4,0,5,4,4,4,0,4,4,4,4,0,4,6,4,4,0,4,4,4,6,0,4,8,4,6,1,2,8,4,6,0,4,8,4,4,0,5,2],"m9":[5,0,0,0,0,5,7,1,2,7,5,7,1,3,4,5,7,0,5,7,5,7,0,5,8,5,7,0,5,7,5,7,0,5,7,5,7,1,3,4,5,7,1,4,9,5,7,0,4,9,5,6,0,5,5,5,6,0,5,5,5,1,1,2,3,5,4,0,5,2,5,2,1,2,2,5,7,0,5,8,5,7,0,5,7,5,7,0,3,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,5,1,2,5,5,5,1,2,7,5,6,0,5,6,5,5,0,5,4,5,6,0,5,6,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,4,7,5,7,0,5,7,5,7,0,5,8,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,9,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,1,3,8,5,7,0,5,8,5,7,0,4,8,5,7,0,4,4,5,0,0,5,1,5,7,1,3,3,5,5,0,5,5,5,7,0,5,7,5,5,0,5,5,5,7,0,5,7,5,5,0,5,5,5,7,0,5,7,5,5,0,5,7,5,7,0,5,7,5,7,0,4,7,5,7,0,4,9,5,7,0,5,8,5,7,0,5,7,5,5,0,5,5,5,5,0,5,5,5,5,0,5,5,5,5,0,5,7,5,5,0,5,7,5,5,0,5,5,5,5,0,5,5,5,6,0,5,6,5,5,0,5,5,5,5,0,5,5,5,5,0,5,5,5,5,0,5,5,5,5,0,5,7,5,5,0,5,5,5,7,0,4,9,5,7,2,1,9,5,7,0,5,9,5,5,0,5,2],"a9":[5,0,0,0,0,5,7,1,2,7,5,7,1,3,4,5,7,0,5,7,5,7,0,5,8,5,7,0,5,7,5,7,0,5,7,5,7,1,3,4,5,7,1,4,9,5,7,0,4,9,5,6,0,5,5,5,6,0,5,5,5,1,1,2,3,5,4,0,5,2,5,2,1,2,2,5,7,0,5,8,5,7,0,5,7,5,7,0,3,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,5,1,2,5,5,5,1,2,7,5,6,0,5,6,5,5,0,5,4,5,6,0,5,6,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,4,7,5,7,0,5,7,5,7,0,5,8,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,9,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,1,3,8,5,7,0,5,8,5,7,0,4,8,5,7,0,4,4,5,0,0,5,1,5,7,1,3,3,5,5,0,5,5,5,7,0,5,7,5,5,0,5,5,5,7,0,5,7,5,5,0,5,5,5,7,0,5,7,5,5,0,5,7,5,7,0,5,7,5,7,0,4,7,5,7,0,4,9,5,7,0,5,8,5,7,0,5,7,5,5,0,5,5,5,5,0,5,5,5,5,0,5,5,5,5,0,5,7,5,5,0,5,7,5,5,0,5,5,5,5,0,5,5,5,6,0,5,6,5,5,0,5,5,5,5,0,5,5,5,5,0,5,5,5,5,0,5,5,5,5,0,5,7,5,5,0,5,5,5,7,0,4,9,5,7,2,1,9,5,7,0,5,9,5,5,0,5,2],"m10":[5,0,0,0,0,5,8,1,3,8,5,8,1,4,4,5,7,0,6,7,5,8,0,5,9,5,7,0,6,7,5,7,0,6,7,5,8,2,2,4,5,8,1,4,10,5,8,0,4,10,5,6,0,5,5,5,6,0,5,5,5,2,1,3,4,5,4,0,5,1,5,2,1,3,2,5,8,0,5,9,5,7,0,5,7,5,7,0,4,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,5,1,3,5,5,5,1,3,7,5,7,0,5,7,5,5,0,5,4,5,7,0,6,7,5,8,0,5,8,5,7,0,6,7,5,7,0,6,7,5,7,0,5,7,5,7,0,6,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,6,8,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,6,7,5,7,0,5,7,5,7,0,6,9,5,7,0,6,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,6,7,5,7,0,6,7,5,7,0,6,7,5,7,0,6,7,5,7,0,5,7,5,8,1,4,10,5,8,0,5,9,5,8,0,4,10,5,7,1,4,4,5,0,0,6,1,5,8,1,3,4,5,5,0,5,5,5,8,0,5,8,5,5,0,5,5,5,8,0,5,8,5,5,0,5,5,5,8,0,6,8,5,6,0,6,8,5,8,0,5,8,5,8,1,4,8,5,8,0,5,10,5,8,0,6,9,5,8,0,5,8,5,5,0,6,5,5,5,0,5,5,5,5,0,5,5,5,5,0,5,7,5,5,0,5,7,5,5,1,4,5,5,5,0,5,5,5,7,0,5,7,5,5,0,5,5,5,5,0,5,5,5,5,0,6,5,5,5,0,5,5,5,5,0,5,7,5,5,0,5,5,5,7,0,5,9,5,8,2,2,10,5,7,1,4,9,5,5,0,6,2],"a10":[5,0,0,0,0,5,8,1,3,8,5,8,1,4,4,5,7,0,6,7,5,8,0,5,9,5,7,0,6,7,5,7,0,6,7,5,8,2,2,4,5,8,1,4,10,5,8,0,4,10,5,6,0,5,5,5,6,0,5,5,5,2,1,3,4,5,4,0,5,1,5,2,1,3,2,5,8,0,5,9,5,7,0,5,7,5,7,0,4,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,5,1,3,5,5,5,1,3,7,5,7,0,5,7,5,5,0,5,4,5,7,0,6,7,5,8,0,5,8,5,7,0,6,7,5,7,0,6,7,5,7,0,5,7,5,7,0,6,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,6,8,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,6,7,5,7,0,5,7,5,7,0,6,9,5,7,0,6,7,5,7,0,5,7,5,7,0,5,7,5,7,0,5,7,5,7,0,6,7,5,7,0,6,7,5,7,0,6,7,5,7,0,6,7,5,7,0,5,7,5,8,1,4,10,5,8,0,5,9,5,8,0,4,10,5,7,1,4,4,5,0,0,6,1,5,8,1,3,4,5,5,0,5,5,5,8,0,5,8,5,5,0,5,5,5,8,0,5,8,5,5,0,5,5,5,8,0,6,8,5,6,0,6,8,5,8,0,5,8,5,8,1,4,8,5,8,0,5,10,5,8,0,6,9,5,8,0,5,8,5,5,0,6,5,5,5,0,5,5,5,5,0,5,5,5,5,0,5,7,5,5,0,5,7,5,5,1,4,5,5,5,0,5,5,5,7,0,5,7,5,5,0,5,5,5,5,0,5,5,5,5,0,6,5,5,5,0,5,5,5,5,0,5,7,5,5,0,5,5,5,7,0,5,9,5,8,2,2,10,5,7,1,4,9,5,5,0,6,2],"m12":[6,0,0,0,0,6,9,2,2,9,6,9,1,5,4,6,9,0,7,9,6,9,0,6,10,6,9,0,7,9,6,9,0,7,10,6,9,2,3,4,6,9,1,5,12,6,9,0,5,12,6,7,0,6,6,6,7,0,6,6,6,2,2,2,5,6,5,0,6,2,6,2,2,2,2,6,9,0,6,10,6,9,0,6,9,6,9,1,3,9,6,9,0,6,9,6,9,0,6,9,6,9,0,6,9,6,9,0,6,9,6,9,0,6,9,6,9,1,5,9,6,9,0,6,9,6,9,0,6,9,6,6,2,2,6,6,6,2,2,9,6,8,0,6,8,6,6,0,6,4,6,8,0,7,8,6,9,0,6,9,6,9,0,7,9,6,9,0,7,9,6,9,0,6,9,6,9,0,7,9,6,9,0,6,9,6,9,0,6,9,6,9,1,5,9,6,9,0,6,9,6,9,0,6,9,6,9,1,5,9,6,9,0,6,9,6,9,0,7,10,6,9,0,6,9,6,9,0,6,9,6,9,0,6,9,6,9,0,7,9,6,9,0,6,9,6,9,0,7,12,6,9,0,7,9,6,9,0,6,9,6,9,0,6,9,6,9,0,6,9,6,9,0,7,9,6,9,0,7,9,6,9,0,7,9,6,9,0,7,9,6,9,0,6,9,6,9,1,5,11,6,9,0,6,10,6,9,1,4,11,6,9,1,5,5,6,0,0,7,2,6,9,1,4,4,6,6,0,6,6,6,9,0,6,9,6,6,0,6,6,6,9,0,6,9,6,6,0,6,6,6,9,0,7,9,6,7,0,7,10,6,9,0,6,9,6,9,1,5,9,6,9,0,5,12,6,9,0,7,10,6,9,1,5,9,6,6,0,7,6,6,6,0,6,6,6,6,0,6,6,6,6,0,6,9,6,6,0,6,9,6,6,1,5,6,6,6,0,6,6,6,8,0,6,8,6,6,0,6,6,6,6,0,6,6,6,6,0,7,6,6,6,0,6,6,6,6,0,6,9,6,6,0,6,6,6,9,0,6,12,6,9,2,2,11,6,9,1,5,12,6,6,0,7,2],"a12":[6,0,0,0,0,6,9,2,2,9,6,9,1,5,4,6,9,0,7,9,6,9,0,6,10,6,9,0,7,9,6,9,0,7,10,6,9,2,3,4,6,9,1,5,12,6,9,0,5,12,6,7,0,6,6,6,7,0,6,6,6,2,2,2,5,6,5,0,6,2,6,2,2,2,2,6,9,0,6,10,6,9,0,6,9,6,9,1,3,9,6,9,0,6,9,6,9,0,6,9,6,9,0,6,9,6,9,0,6,9,6,9,0,6,9,6,9,1,5,9,6,9,0,6,9,6,9,0,6,9,6,6,2,2,6,6,6,2,2,9,6,8,0,6,8,6,6,0,6,4,6,8,0,7,8,6,9,0,6,9,6,9,0,7,9,6,9,0,7,9,6,9,0,6,9,6,9,0,7,9,6,9,0,6,9,6,9,0,6,9,6,9,1,5,9,6,9,0,6,9,6,9,0,6,9,6,9,1,5,9,6,9,0,6,9,6,9,0,7,10,6,9,0,6,9,6,9,0,6,9,6,9,0,6,9,6,9,0,7,9,6,9,0,6,9,6,9,0,7,12,6,9,0,7,9,6,9,0,6,9,6,9,0,6,9,6,9,0,6,9,6,9,0,7,9,6,9,0,7,9,6,9,0,7,9,6,9,0,7,9,6,9,0,6,9,6,9,1,5,11,6,9,0,6,10,6,9,1,4,11,6,9,1,5,5,6,0,0,7,2,6,9,1,4,4,6,6,0,6,6,6,9,0,6,9,6,6,0,6,6,6,9,0,6,9,6,6,0,6,6,6,9,0,7,9,6,7,0,7,10,6,9,0,6,9,6,9,1,5,9,6,9,0,5,12,6,9,0,7,10,6,9,1,5,9,6,6,0,7,6,6,6,0,6,6,6,6,0,6,6,6,6,0,6,9,6,6,0,6,9,6,6,1,5,6,6,6,0,6,6,6,8,0,6,8,6,6,0,6,6,6,6,0,6,6,6,6,0,7,6,6,6,0,6,6,6,6,0,6,9,6,6,0,6,6,6,9,0,6,12,6,9,2,2,11,6,9,1,5,12,6,6,0,7,2],"m16":[9,0,0,0,0,9,12,3,3,12,9,12,1,6,5,9,11,0,9,11,9,12,1,7,13,9,11,0,9,11,9,11,0,9,12,9,12,3,3,5,9,12,2,6,15,9,12,1,6,16,9,9,0,8,8,9,10,0,8,9,9,2,2,4,5,9,6,1,7,2,9,2,3,3,2,9,12,1,7,13,9,11,0,8,11,9,11,1,5,11,9,11,1,7,11,9,11,1,7,11,9,11,0,8,11,9,11,1,7,11,9,11,1,7,11,9,11,1,7,11,9,11,1,7,11,9,11,1,7,11,9,8,3,3,8,9,8,2,4,11,9,10,0,8,10,9,8,0,8,6,9,10,0,9,10,9,12,1,7,12,9,11,0,9,11,9,11,0,9,11,9,11,0,8,11,9,11,0,9,11,9,11,0,8,11,9,11,1,7,11,9,11,1,7,11,9,11,0,8,11,9,11,0,8,11,9,11,1,6,11,9,11,0,8,11,9,11,0,9,12,9,11,1,7,11,9,11,0,8,11,9,11,0,8,11,9,11,0,9,11,9,11,1,7,11,9,11,0,9,14,9,11,0,9,11,9,11,0,8,11,9,11,0,8,11,9,11,0,8,11,9,11,0,9,11,9,11,0,9,11,9,11,0,9,11,9,11,0,9,11,9,11,0,8,11,9,12,2,6,14,9,12,1,7,13,9,12,1,6,14,9,11,1,6,6,9,0,0,9,2,9,12,2,4,5,9,8,0,8,8,9,12,1,7,12,9,8,0,8,8,9,12,0,8,12,9,8,0,8,8,9,12,1,8,12,9,9,0,9,12,9,12,1,7,12,9,12,1,6,12,9,12,0,7,16,9,12,1,8,13,9,12,1,7,12,9,8,0,9,8,9,8,1,7,8,9,8,0,8,8,9,8,1,7,11,9,8,0,8,11,9,8,1,7,8,9,8,0,8,8,9,11,1,7,11,9,8,1,7,8,9,8,0,8,8,9,8,0,9,8,9,8,0,8,8,9,8,0,8,11,9,8,0,8,8,9,12,0,8,15,9,12,3,2,15,9,12,1,7,15,9,8,0,9,3],"a16":[9,0,0,0,0,9,12,3,3,12,9,12,1,6,5,9,11,0,9,11,9,12,1,7,13,9,11,0,9,11,9,11,0,9,12,9,12,3,3,5,9,12,2,6,15,9,12,1,6,16,9,9,0,8,8,9,10,0,8,9,9,2,2,4,5,9,6,1,7,2,9,2,3,3,2,9,12,1,7,13,9,11,0,8,11,9,11,1,5,11,9,11,1,7,11,9,11,1,7,11,9,11,0,8,11,9,11,1,7,11,9,11,1,7,11,9,11,1,7,11,9,11,1,7,11,9,11,1,7,11,9,8,3,3,8,9,8,2,4,11,9,10,0,8,10,9,8,0,8,6,9,10,0,9,10,9,12,1,7,12,9,11,0,9,11,9,11,0,9,11,9,11,0,8,11,9,11,0,9,11,9,11,0,8,11,9,11,1,7,11,9,11,1,7,11,9,11,0,8,11,9,11,0,8,11,9,11,1,6,11,9,11,0,8,11,9,11,0,9,12,9,11,1,7,11,9,11,0,8,11,9,11,0,8,11,9,11,0,9,11,9,11,1,7,11,9,11,0,9,14,9,11,0,9,11,9,11,0,8,11,9,11,0,8,11,9,11,0,8,11,9,11,0,9,11,9,11,0,9,11,9,11,0,9,11,9,11,0,9,11,9,11,0,8,11,9,12,2,6,14,9,12,1,7,13,9,12,1,6,14,9,11,1,6,6,9,0,0,9,2,9,12,2,4,5,9,8,0,8,8,9,12,1,7,12,9,8,0,8,8,9,12,0,8,12,9,8,0,8,8,9,12,1,8,12,9,9,0,9,12,9,12,1,7,12,9,12,1,6,12,9,12,0,7,16,9,12,1,8,13,9,12,1,7,12,9,8,0,9,8,9,8,1,7,8,9,8,0,8,8,9,8,1,7,11,9,8,0,8,11,9,8,1,7,8,9,8,0,8,8,9,11,1,7,11,9,8,1,7,8,9,8,0,8,8,9,8,0,9,8,9,8,0,8,8,9,8,0,8,11,9,8,0,8,8,9,12,0,8,15,9,12,3,2,15,9,12,1,7,15,9,8,0,9,3],"m18":[10,0,0,0,0,10,13,3,3,13,10,13,2,6,6,10,13,0,10,13,10,13,1,8,14,10,13,0,10,13,10,13,0,10,14,10,13,4,3,6,10,13,2,7,17,10,13,1,7,17,10,11,0,9,9,10,11,0,9,9,10,2,3,3,6,10,7,1,8,2,10,3,3,3,3,10,13,1,8,14,10,13,0,9,13,10,13,1,5,13,10,13,1,8,13,10,13,1,8,13,10,13,0,9,13,10,13,1,8,13,10,13,1,8,13,10,13,1,8,13,10,13,1,8,13,10,13,1,8,13,10,9,3,3,9,10,9,3,3,13,10,11,0,9,11,10,9,0,9,6,10,11,0,10,11,10,13,1,8,13,10,13,0,10,13,10,13,0,10,13,10,13,0,9,13,10,13,0,10,13,10,13,1,8,13,10,13,1,8,13,10,13,1,8,13,10,13,0,9,13,10,13,1,8,13,10,13,1,7,13,10,13,0,9,13,10,13,0,10,14,10,13,1,8,13,10,13,0,9,13,10,13,0,9,13,10,13,0,10,13,10,13,1,8,13,10,13,0,10,17,10,13,1,9,13,10,13,0,9,13,10,13,0,9,13,10,13,0,9,13,10,13,0,10,13,10,13,0,10,13,10,13,0,10,13,10,13,0,10,13,10,13,0,9,13,10,13,2,7,15,10,13,1,8,14,10,13,1,7,15,10,13,1,7,7,10,0,0,10,2,10,14,2,5,6,10,9,0,9,9,10,13,1,8,13,10,9,1,8,9,10,13,0,9,13,10,9,0,9,9,10,13,1,9,13,10,10,0,10,14,10,13,1,8,13,10,13,1,7,13,10,13,0,8,17,10,13,1,9,14,10,13,1,8,13,10,9,0,10,9,10,9,1,8,9,10,9,0,9,9,10,9,1,8,13,10,9,0,9,13,10,9,1,8,9,10,9,1,8,9,10,12,1,8,12,10,9,1,8,9,10,9,0,9,9,10,9,0,10,9,10,9,0,9,9,10,9,0,9,13,10,9,0,9,9,10,13,1,7,17,10,13,4,2,16,10,13,1,8,17,10,9,0,10,3],"a18":[10,0,0,0,0,10,13,3,3,13,10,13,2,6,6,10,13,0,10,13,10,13,1,8,14,10,13,0,10,13,10,13,0,10,14,10,13,4,3,6,10,13,2,7,17,10,13,1,7,17,10,11,0,9,9,10,11,0,9,9,10,2,3,3,6,10,7,1,8,2,10,3,3,3,3,10,13,1,8,14,10,13,0,9,13,10,13,1,5,13,10,13,1,8,13,10,13,1,8,13,10,13,0,9,13,10,13,1,8,13,10,13,1,8,13,10,13,1,8,13,10,13,1,8,13,10,13,1,8,13,10,9,3,3,9,10,9,3,3,13,10,11,0,9,11,10,9,0,9,6,10,11,0,10,11,10,13,1,8,13,10,13,0,10,13,10,13,0,10,13,10,13,0,9,13,10,13,0,10,13,10,13,1,8,13,10,13,1,8,13,10,13,1,8,13,10,13,0,9,13,10,13,1,8,13,10,13,1,7,13,10,13,0,9,13,10,13,0,10,14,10,13,1,8,13,10,13,0,9,13,10,13,0,9,13,10,13,0,10,13,10,13,1,8,13,10,13,0,10,17,10,13,1,9,13,10,13,0,9,13,10,13,0,9,13,10,13,0,9,13,10,13,0,10,13,10,13,0,10,13,10,13,0,10,13,10,13,0,10,13,10,13,0,9,13,10,13,2,7,15,10,13,1,8,14,10,13,1,7,15,10,13,1,7,7,10,0,0,10,2,10,14,2,5,6,10,9,0,9,9,10,13,1,8,13,10,9,1,8,9,10,13,0,9,13,10,9,0,9,9,10,13,1,9,13,10,10,0,10,14,10,13,1,8,13,10,13,1,7,13,10,13,0,8,17,10,13,1,9,14,10,13,1,8,13,10,9,0,10,9,10,9,1,8,9,10,9,0,9,9,10,9,1,8,13,10,9,0,9,13,10,9,1,8,9,10,9,1,8,9,10,12,1,8,12,10,9,1,8,9,10,9,0,9,9,10,9,0,10,9,10,9,0,9,9,10,9,0,9,13,10,9,0,9,9,10,13,1,7,17,10,13,4,2,16,10,13,1,8,17,10,9,0,10,3],"m20":[11,0,0,0,0,11,15,3,4,15,11,15,2,7,7,11,14,0,11,14,11,15,1,9,17,11,14,0,11,14,11,14,0,11,15,11,15,4,3,7,11,15,2,8,19,11,15,1,7,19,11,12,0,10,10,11,12,0,10,10,11,3,3,4,7,11,8,1,9,2,11,3,3,4,3,11,15,1,9,16,11,14,1,9,14,11,14,1,6,14,11,14,1,9,14,11,14,1,9,14,11,14,1,9,14,11,14,1,9,14,11,14,1,9,14,11,14,1,9,14,11,14,1,9,14,11,14,1,9,14,11,10,3,4,10,11,10,3,4,14,11,13,0,10,12,11,10,0,10,7,11,13,0,11,12,11,15,1,9,15,11,14,0,11,14,11,14,0,11,14,11,14,1,9,14,11,14,0,11,14,11,14,1,9,14,11,14,1,9,14,11,14,1,9,14,11,14,0,10,14,11,14,1,9,14,11,14,1,8,14,11,14,1,9,14,11,14,0,11,15,11,14,1,9,14,11,14,0,10,14,11,14,1,9,14,11,14,0,11,14,11,14,1,9,14,11,14,0,11,18,11,14,1,10,14,11,14,1,9,14,11,14,0,10,14,11,14,1,9,14,11,14,0,11,14,11,14,0,11,14,11,14,0,11,14,11,14,0,11,14,11,14,1,9,14,11,15,2,7,18,11,15,1,9,16,11,15,1,7,18,11,14,2,7,7,11,0,0,11,2,11,15,3,4,6,11,10,1,9,10,11,15,1,9,15,11,10,1,9,10,11,15,0,10,15,11,10,1,9,10,11,15,1,10,15,11,11,0,11,15,11,15,1,9,15,11,15,2,7,15,11,15,1,8,19,11,15,1,10,16,11,15,1,9,15,11,10,0,11,10,11,10,1,9,10,11,10,0,10,10,11,10,1,9,14,11,10,0,10,14,11,10,2,8,10,11,10,1,9,10,11,13,1,9,13,11,10,1,9,10,11,10,0,10,10,11,10,0,11,10,11,10,1,9,10,11,10,0,10,14,11,10,1,9,10,11,14,1,8,18,11,15,4,3,19,11,14,1,9,18,11,10,0,11,4],"a20":[11,0,0,0,0,11,15,3,4,15,11,15,2,7,7,11,14,0,11,14,11,15,1,9,17,11,14,0,11,14,11,14,0,11,15,11,15,4,3,7,11,15,2,8,19,11,15,1,7,19,11,12,0,10,10,11,12,0,10,10,11,3,3,4,7,11,8,1,9,2,11,3,3,4,3,11,15,1,9,16,11,14,1,9,14,11,14,1,6,14,11,14,1,9,14,11,14,1,9,14,11,14,1,9,14,11,14,1,9,14,11,14,1,9,14,11,14,1,9,14,11,14,1,9,14,11,14,1,9,14,11,10,3,4,10,11,10,3,4,14,11,13,0,10,12,11,10,0,10,7,11,13,0,11,12,11,15,1,9,15,11,14,0,11,14,11,14,0,11,14,11,14,1,9,14,11,14,0,11,14,11,14,1,9,14,11,14,1,9,14,11,14,1,9,14,11,14,0,10,14,11,14,1,9,14,11,14,1,8,14,11,14,1,9,14,11,14,0,11,15,11,14,1,9,14,11,14,0,10,14,11,14,1,9,14,11,14,0,11,14,11,14,1,9,14,11,14,0,11,18,11,14,1,10,14,11,14,1,9,14,11,14,0,10,14,11,14,1,9,14,11,14,0,11,14,11,14,0,11,14,11,14,0,11,14,11,14,0,11,14,11,14,1,9,14,11,15,2,7,18,11,15,1,9,16,11,15,1,7,18,11,14,2,7,7,11,0,0,11,2,11,15,3,4,6,11,10,1,9,10,11,15,1,9,15,11,10,1,9,10,11,15,0,10,15,11,10,1,9,10,11,15,1,10,15,11,11,0,11,15,11,15,1,9,15,11,15,2,7,15,11,15,1,8,19,11,15,1,10,16,11,15,1,9,15,11,10,0,11,10,11,10,1,9,10,11,10,0,10,10,11,10,1,9,14,11,10,0,10,14,11,10,2,8,10,11,10,1,9,10,11,13,1,9,13,11,10,1,9,10,11,10,0,10,10,11,10,0,11,10,11,10,1,9,10,11,10,0,10,14,11,10,1,9,10,11,14,1,8,18,11,15,4,3,19,11,14,1,9,18,11,10,0,11,4],"m24":[13,0,0,0,0,13,18,4,4,18,13,18,2,9,8,13,17,0,13,17,13,17,1,11,19,13,17,0,13,17,13,17,0,13,18,13,18,5,4,8,13,18,3,9,23,13,18,1,9,23,13,14,1,11,12,13,14,1,11,12,13,3,4,4,8,13,9,1,11,2,13,4,4,4,4,13,18,1,11,20,13,17,1,11,17,13,17,2,6,17,13,17,1,11,17,13,17,1,10,17,13,17,1,11,17,13,17,1,11,17,13,17,1,11,17,13,17,2,10,17,13,17,1,11,17,13,17,1,11,17,13,12,4,4,12,13,11,4,4,16,13,15,0,12,14,13,12,1,11,8,13,15,1,12,14,13,18,1,11,18,13,17,0,13,17,13,17,0,13,17,13,17,1,11,17,13,17,1,12,17,13,17,1,11,17,13,17,1,11,17,13,17,2,10,17,13,17,0,12,17,13,17,1,11,17,13,17,2,9,17,13,17,1,11,17,13,17,1,12,18,13,17,1,11,17,13,17,1,11,17,13,17,1,11,17,13,17,0,13,17,13,17,1,11,17,13,17,0,13,22,13,17,1,12,17,13,17,1,11,17,13,17,0,12,17,13,17,1,11,17,13,17,0,13,17,13,17,0,13,17,13,17,1,12,17,13,17,0,13,17,13,17,1,11,17,13,18,3,8,21,13,18,1,11,20,13,18,2,8,21,13,17,2,9,9,13,0,0,13,3,13,18,3,6,7,13,12,1,11,12,13,18,1,11,18,13,12,1,11,12,13,18,1,11,18,13,12,1,11,12,13,18,1,12,18,13,13,0,13,18,13,18,1,11,18,13,17,2,9,17,13,17,1,9,22,13,18,1,12,19,13,18,2,9,18,13,12,0,13,12,13,12,1,11,12,13,12,1,11,12,13,12,1,11,17,13,12,1,11,17,13,12,2,10,12,13,12,1,11,12,13,16,1,11,16,13,12,1,11,12,13,12,1,11,12,13,12,0,13,12,13,12,1,11,12,13,12,0,12,17,13,12,1,11,12,13,17,1,10,22,13,17,5,3,21,13,17,2,10,22,13,12,1,12,4],"a24":[13,0,0,0,0,13,18,4,4,18,13,18,2,9,8,13,17,0,13,17,13,17,1,11,19,13,17,0,13,17,13,17,0,13,18,13,18,5,4,8,13,18,3,9,23,13,18,1,9,23,13,14,1,11,12,13,14,1,11,12,13,3,4,4,8,13,9,1,11,2,13,4,4,4,4,13,18,1,11,20,13,17,1,11,17,13,17,2,6,17,13,17,1,11,17,13,17,1,10,17,13,17,1,11,17,13,17,1,11,17,13,17,1,11,17,13,17,2,10,17,13,17,1,11,17,13,17,1,11,17,13,12,4,4,12,13,11,4,4,16,13,15,0,12,14,13,12,1,11,8,13,15,1,12,14,13,18,1,11,18,13,17,0,13,17,13,17,0,13,17,13,17,1,11,17,13,17,1,12,17,13,17,1,11,17,13,17,1,11,17,13,17,2,10,17,13,17,0,12,17,13,17,1,11,17,13,17,2,9,17,13,17,1,11,17,13,17,1,12,18,13,17,1,11,17,13,17,1,11,17,13,17,1,11,17,13,17,0,13,17,13,17,1,11,17,13,17,0,13,22,13,17,1,12,17,13,17,1,11,17,13,17,0,12,17,13,17,1,11,17,13,17,0,13,17,13,17,0,13,17,13,17,1,12,17,13,17,0,13,17,13,17,1,11,17,13,18,3,8,21,13,18,1,11,20,13,18,2,8,21,13,17,2,9,9,13,0,0,13,3,13,18,3,6,7,13,12,1,11,12,13,18,1,11,18,13,12,1,11,12,13,18,1,11,18,13,12,1,11,12,13,18,1,12,18,13,13,0,13,18,13,18,1,11,18,13,17,2,9,17,13,17,1,9,22,13,18,1,12,19,13,18,2,9,18,13,12,0,13,12,13,12,1,11,12,13,12,1,11,12,13,12,1,11,17,13,12,1,11,17,13,12,2,10,12,13,12,1,11,12,13,16,1,11,16,13,12,1,11,12,13,12,1,11,12,13,12,0,13,12,13,12,1,11,12,13,12,0,12,17,13,12,1,11,12,13,17,1,10,22,13,17,5,3,21,13,17,2,10,22,13,12,1,12,4],"m27":[15,0,0,0,0,15,20,5,4,20,15,20,3,9,9,15,19,0,14,19,15,19,1,13,21,15,19,0,14,19,15,19,1,13,20,15,20,5,5,9,15,20,3,10,26,15,20,2,9,26,15,16,1,13,13,15,16,1,12,13,15,3,4,5,8,15,11,2,11,3,15,4,5,4,4,15,20,1,12,22,15,19,1,12,19,15,19,2,7,19,15,19,2,11,19,15,19,1,12,19,15,19,1,12,19,15,19,1,12,19,15,19,1,12,19,15,19,2,11,19,15,19,1,12,19,15,19,1,12,19,15,13,5,4,13,15,13,4,5,18,15,17,0,14,16,15,13,1,12,9,15,17,1,13,16,15,20,1,12,20,15,19,0,14,19,15,19,0,14,19,15,19,1,13,19,15,19,1,13,19,15,19,1,13,19,15,19,1,12,19,15,19,2,11,19,15,19,1,13,19,15,19,1,12,19,15,19,2,10,19,15,19,1,13,19,15,19,1,13,20,15,19,1,12,19,15,19,1,13,19,15,19,1,12,19,15,19,0,14,19,15,19,1,12,19,15,19,0,14,24,15,19,1,13,19,15,19,1,12,19,15,19,0,14,19,15,19,1,12,19,15,19,0,14,19,15,19,0,14,19,15,19,1,13,19,15,19,0,14,19,15,19,1,13,19,15,20,3,9,23,15,20,1,12,22,15,20,2,9,23,15,19,2,10,10,15,0,0,14,3,15,20,3,7,8,15,14,1,12,14,15,20,1,13,20,15,14,1,13,14,15,20,1,12,20,15,14,1,12,14,15,20,1,13,20,15,14,1,13,19,15,20,1,12,20,15,20,2,10,20,15,20,1,10,26,15,20,1,13,21,15,20,2,11,20,15,14,1,13,14,15,14,1,12,14,15,14,1,13,14,15,14,1,13,19,15,14,1,12,19,15,14,2,12,14,15,14,1,12,14,15,18,1,12,18,15,14,1,12,14,15,14,1,13,14,15,14,0,14,14,15,14,1,12,14,15,14,0,14,19,15,14,1,12,14,15,19,1,11,24,15,20,6,3,25,15,19,2,11,24,15,14,1,13,5],"a27":[15,0,0,0,0,15,20,5,4,20,15,20,3,9,9,15,19,0,14,19,15,19,1,13,21,15,19,0,14,19,15,19,1,13,20,15,20,5,5,9,15,20,3,10,26,15,20,2,9,26,15,16,1,13,13,15,16,1,12,13,15,3,4,5,8,15,11,2,11,3,15,4,5,4,4,15,20,1,12,22,15,19,1,12,19,15,19,2,7,19,15,19,2,11,19,15,19,1,12,19,15,19,1,12,19,15,19,1,12,19,15,19,1,12,19,15,19,2,11,19,15,19,1,12,19,15,19,1,12,19,15,13,5,4,13,15,13,4,5,18,15,17,0,14,16,15,13,1,12,9,15,17,1,13,16,15,20,1,12,20,15,19,0,14,19,15,19,0,14,19,15,19,1,13,19,15,19,1,13,19,15,19,1,13,19,15,19,1,12,19,15,19,2,11,19,15,19,1,13,19,15,19,1,12,19,15,19,2,10,19,15,19,1,13,19,15,19,1,13,20,15,19,1,12,19,15,19,1,13,19,15,19,1,12,19,15,19,0,14,19,15,19,1,12,19,15,19,0,14,24,15,19,1,13,19,15,19,1,12,19,15,19,0,14,19,15,19,1,12,19,15,19,0,14,19,15,19,0,14,19,15,19,1,13,19,15,19,0,14,19,15,19,1,13,19,15,20,3,9,23,15,20,1,12,22,15,20,2,9,23,15,19,2,10,10,15,0,0,14,3,15,20,3,7,8,15,14,1,12,14,15,20,1,13,20,15,14,1,13,14,15,20,1,12,20,15,14,1,12,14,15,20,1,13,20,15,14,1,13,19,15,20,1,12,20,15,20,2,10,20,15,20,1,10,26,15,20,1,13,21,15,20,2,11,20,15,14,1,13,14,15,14,1,12,14,15,14,1,13,14,15,14,1,13,19,15,14,1,12,19,15,14,2,12,14,15,14,1,12,14,15,18,1,12,18,15,14,1,12,14,15,14,1,13,14,15,14,0,14,14,15,14,1,12,14,15,14,0,14,19,15,14,1,12,14,15,19,1,11,24,15,20,6,3,25,15,19,2,11,24,15,14,1,13,5],"m30":[16,0,0,0,0,16,22,5,5,22,16,22,3,10,9,16,21,0,16,21,16,22,1,14,24,16,21,0,16,21,16,21,1,15,22,16,22,6,5,9,16,22,4,10,28,16,22,2,10,28,16,17,1,14,14,16,17,1,14,14,16,4,5,5,10,16,12,2,12,3,16,4,5,5,4,16,22,2,13,24,16,21,1,14,21,16,21,2,8,21,16,21,2,13,21,16,21,2,12,21,16,21,1,14,21,16,21,2,13,21,16,21,2,13,21,16,21,2,12,21,16,21,1,14,21,16,21,2,13,21,16,15,5,5,15,16,14,5,5,20,16,19,1,14,18,16,15,1,14,10,16,19,1,15,18,16,22,2,13,22,16,21,1,15,21,16,21,0,16,21,16,21,1,14,21,16,21,1,15,21,16,21,1,14,21,16,21,1,14,21,16,21,2,13,21,16,21,1,14,21,16,21,1,14,21,16,21,2,12,21,16,21,1,14,21,16,21,1,15,22,16,21,2,13,21,16,21,1,14,21,16,21,1,14,21,16,21,0,16,21,16,21,1,14,21,16,21,0,16,27,16,21,1,15,21,16,21,1,14,21,16,21,1,14,21,16,21,1,14,21,16,21,0,16,21,16,21,0,16,21,16,21,1,15,21,16,21,0,16,21,16,21,1,14,21,16,22,4,10,26,16,22,2,13,24,16,22,2,10,26,16,21,3,11,10,16,0,1,15,3,16,22,4,7,9,16,15,1,14,15,16,22,1,14,22,16,15,1,14,15,16,22,1,14,22,16,15,1,14,15,16,22,2,14,22,16,16,1,15,22,16,22,2,13,22,16,22,3,10,22,16,22,1,12,28,16,22,2,14,23,16,22,2,12,22,16,15,1,15,15,16,15,2,12,15,16,15,1,14,15,16,15,1,14,21,16,15,1,14,21,16,15,3,12,15,16,15,1,14,15,16,20,2,13,20,16,15,2,13,15,16,15,1,14,15,16,15,0,16,15,16,15,1,14,15,16,15,0,15,21,16,15,1,14,15,16,21,1,13,27,16,22,7,3,27,16,21,2,13,27,16,15,1,15,5],"a30":[16,0,0,0,0,16,22,5,5,22,16,22,3,10,9,16,21,0,16,21,16,22,1,14,24,16,21,0,16,21,16,21,1,15,22,16,22,6,5,9,16,22,4,10,28,16,22,2,10,28,16,17,1,14,14,16,17,1,14,14,16,4,5,5,10,16,12,2,12,3,16,4,5,5,4,16,22,2,13,24,16,21,1,14,21,16,21,2,8,21,16,21,2,13,21,16,21,2,12,21,16,21,1,14,21,16,21,2,13,21,16,21,2,13,21,16,21,2,12,21,16,21,1,14,21,16,21,2,13,21,16,15,5,5,15,16,14,5,5,20,16,19,1,14,18,16,15,1,14,10,16,19,1,15,18,16,22,2,13,22,16,21,1,15,21,16,21,0,16,21,16,21,1,14,21,16,21,1,15,21,16,21,1,14,21,16,21,1,14,21,16,21,2,13,21,16,21,1,14,21,16,21,1,14,21,16,21,2,12,21,16,21,1,14,21,16,21,1,15,22,16,21,2,13,21,16,21,1,14,21,16,21,1,14,21,16,21,0,16,21,16,21,1,14,21,16,21,0,16,27,16,21,1,15,21,16,21,1,14,21,16,21,1,14,21,16,21,1,14,21,16,21,0,16,21,16,21,0,16,21,16,21,1,15,21,16,21,0,16,21,16,21,1,14,21,16,22,4,10,26,16,22,2,13,24,16,22,2,10,26,16,21,3,11,10,16,0,1,15,3,16,22,4,7,9,16,15,1,14,15,16,22,1,14,22,16,15,1,14,15,16,22,1,14,22,16,15,1,14,15,16,22,2,14,22,16,16,1,15,22,16,22,2,13,22,16,22,3,10,22,16,22,1,12,28,16,22,2,14,23,16,22,2,12,22,16,15,1,15,15,16,15,2,12,15,16,15,1,14,15,16,15,1,14,21,16,15,1,14,21,16,15,3,12,15,16,15,1,14,15,16,20,2,13,20,16,15,2,13,15,16,15,1,14,15,16,15,0,16,15,16,15,1,14,15,16,15,0,15,21,16,15,1,14,15,16,21,1,13,27,16,22,7,3,27,16,21,2,13,27,16,15,1,15,5],"m32":[17,0,0,0,0,17,23,6,5,23,17,23,3,11,9,17,22,0,17,22,17,23,2,14,25,17,22,0,17,22,17,22,1,16,23,17,23,7,5,9,17,24,4,11,30,17,23,2,11,30,17,18,1,15,15,17,19,1,15,16,17,4,5,6,10,17,12,2,13,3,17,4,6,5,4,17,23,2,14,25,17,22,1,15,22,17,22,3,8,22,17,22,2,14,22,17,22,2,13,22,17,22,1,15,22,17,22,2,14,22,17,22,2,14,22,17,22,2,13,22,17,22,2,14,22,17,22,2,14,22,17,16,6,5,16,17,15,5,6,21,17,20,1,15,19,17,16,1,15,11,17,20,1,16,19,17,23,2,13,23,17,22,1,16,22,17,22,0,17,22,17,22,1,15,22,17,22,1,16,22,17,22,1,15,22,17,22,2,14,22,17,22,2,14,22,17,22,1,15,22,17,22,1,15,22,17,22,2,12,22,17,22,1,15,22,17,22,1,16,23,17,22,2,14,22,17,22,1,15,22,17,22,1,15,22,17,22,1,16,22,17,22,2,14,22,17,22,1,16,28,17,22,1,16,22,17,22,1,15,22,17,22,1,15,22,17,22,1,15,22,17,22,0,17,22,17,22,0,17,22,17,22,1,16,22,17,22,0,17,22,17,22,1,15,22,17,23,4,11,27,17,23,2,14,25,17,23,2,11,27,17,22,3,11,11,17,0,1,16,3,17,24,4,7,10,17,16,1,14,16,17,23,2,14,23,17,16,1,15,16,17,23,1,15,23,17,16,1,15,16,17,23,2,15,23,17,17,1,16,23,17,23,2,13,23,17,23,3,11,23,17,23,1,13,30,17,23,2,15,24,17,23,2,13,23,17,16,1,16,16,17,16,2,13,16,17,16,1,15,16,17,16,2,14,22,17,16,1,15,22,17,16,3,13,16,17,16,1,15,16,17,21,2,14,21,17,16,2,14,16,17,16,1,15,16,17,16,0,17,16,17,16,1,15,16,17,16,0,16,22,17,16,1,15,16,17,23,1,14,29,17,23,7,3,29,17,23,3,13,29,17,16,1,16,6],"a32":[17,0,0,0,0,17,23,6,5,23,17,23,3,11,9,17,22,0,17,22,17,23,2,14,25,17,22,0,17,22,17,22,1,16,23,17,23,7,5,9,17,24,4,11,30,17,23,2,11,30,17,18,1,15,15,17,19,1,15,16,17,4,5,6,10,17,12,2,13,3,17,4,6,5,4,17,23,2,14,25,17,22,1,15,22,17,22,3,8,22,17,22,2,14,22,17,22,2,13,22,17,22,1,15,22,17,22,2,14,22,17,22,2,14,22,17,22,2,13,22,17,22,2,14,22,17,22,2,14,22,17,16,6,5,16,17,15,5,6,21,17,20,1,15,19,17,16,1,15,11,17,20,1,16,19,17,23,2,13,23,17,22,1,16,22,17,22,0,17,22,17,22,1,15,22,17,22,1,16,22,17,22,1,15,22,17,22,2,14,22,17,22,2,14,22,17,22,1,15,22,17,22,1,15,22,17,22,2,12,22,17,22,1,15,22,17,22,1,16,23,17,22,2,14,22,17,22,1,15,22,17,22,1,15,22,17,22,1,16,22,17,22,2,14,22,17,22,1,16,28,17,22,1,16,22,17,22,1,15,22,17,22,1,15,22,17,22,1,15,22,17,22,0,17,22,17,22,0,17,22,17,22,1,16,22,17,22,0,17,22,17,22,1,15,22,17,23,4,11,27,17,23,2,14,25,17,23,2,11,27,17,22,3,11,11,17,0,1,16,3,17,24,4,7,10,17,16,1,14,16,17,23,2,14,23,17,16,1,15,16,17,23,1,15,23,17,16,1,15,16,17,23,2,15,23,17,17,1,16,23,17,23,2,13,23,17,23,3,11,23,17,23,1,13,30,17,23,2,15,24,17,23,2,13,23,17,16,1,16,16,17,16,2,13,16,17,16,1,15,16,17,16,2,14,22,17,16,1,15,22,17,16,3,13,16,17,16,1,15,16,17,21,2,14,21,17,16,2,14,16,17,16,1,15,16,17,16,0,17,16,17,16,1,15,16,17,16,0,16,22,17,16,1,15,16,17,23,1,14,29,17,23,7,3,29,17,23,3,13,29,17,16,1,16,6],"m36":[19,0,0,0,0,19,26,7,5,26,19,26,4,12,11,19,25,0,19,25,19,26,2,16,28,19,25,1,18,25,19,25,1,18,26,19,26,8,5,11,19,26,5,12,33,19,26,2,13,33,19,21,1,17,17,19,21,1,17,17,19,4,6,6,11,19,14,2,15,4,19,5,6,6,5,19,26,2,15,28,19,25,1,17,25,19,25,3,9,25,19,25,2,16,25,19,25,2,15,25,19,25,1,17,25,19,25,2,16,25,19,25,2,16,25,19,25,3,14,25,19,25,2,16,25,19,25,2,15,25,19,17,6,6,17,19,17,6,6,24,19,22,1,17,21,19,18,1,17,12,19,22,1,18,21,19,26,2,15,26,19,25,1,18,25,19,25,0,19,25,19,25,1,17,25,19,25,1,18,25,19,25,2,16,25,19,25,2,16,25,19,25,3,14,25,19,25,1,17,25,19,25,2,16,25,19,25,3,13,25,19,25,1,17,25,19,25,1,18,26,19,25,2,16,25,19,25,1,17,25,19,25,1,17,25,19,25,1,18,25,19,25,2,16,25,19,25,1,18,32,19,25,2,17,25,19,25,1,17,25,19,25,1,17,25,19,25,1,17,25,19,25,0,19,25,19,25,0,19,25,19,25,1,18,25,19,25,1,18,25,19,25,1,17,25,19,26,5,12,30,19,26,2,15,28,19,26,3,12,30,19,25,3,13,12,19,0,1,18,4,19,27,5,8,11,19,18,1,16,18,19,26,2,16,26,19,18,2,16,18,19,26,1,17,26,19,18,1,17,18,19,26,2,17,26,19,19,1,18,26,19,26,2,15,26,19,26,3,13,26,19,26,1,14,33,19,26,2,17,27,19,26,3,14,26,19,18,1,18,18,19,18,2,15,18,19,18,1,17,18,19,18,2,16,25,19,18,1,17,25,19,18,3,15,18,19,18,2,16,18,19,23,2,16,23,19,18,2,16,18,19,18,1,17,18,19,18,0,19,18,19,18,1,17,18,19,18,0,18,25,19,18,1,17,18,19,25,2,14,32,19,26,8,3,32,19,25,3,15,32,19,18,1,18,6],"a36":[19,0,0,0,0,19,26,7,5,26,19,26,4,12,11,19,25,0,19,25,19,26,2,16,28,19,25,1,18,25,19,25,1,18,26,19,26,8,5,11,19,26,5,12,33,19,26,2,13,33,19,21,1,17,17,19,21,1,17,17,19,4,6,6,11,19,14,2,15,4,19,5,6,6,5,19,26,2,15,28,19,25,1,17,25,19,25,3,9,25,19,25,2,16,25,19,25,2,15,25,19,25,1,17,25,19,25,2,16,25,19,25,2,16,25,19,25,3,14,25,19,25,2,16,25,19,25,2,15,25,19,17,6,6,17,19,17,6,6,24,19,22,1,17,21,19,18,1,17,12,19,22,1,18,21,19,26,2,15,26,19,25,1,18,25,19,25,0,19,25,19,25,1,17,25,19,25,1,18,25,19,25,2,16,25,19,25,2,16,25,19,25,3,14,25,19,25,1,17,25,19,25,2,16,25,19,25,3,13,25,19,25,1,17,25,19,25,1,18,26,19,25,2,16,25,19,25,1,17,25,19,25,1,17,25,19,25,1,18,25,19,25,2,16,25,19,25,1,18,32,19,25,2,17,25,19,25,1,17,25,19,25,1,17,25,19,25,1,17,25,19,25,0,19,25,19,25,0,19,25,19,25,1,18,25,19,25,1,18,25,19,25,1,17,25,19,26,5,12,30,19,26,2,15,28,19,26,3,12,30,19,25,3,13,12,19,0,1,18,4,19,27,5,8,11,19,18,1,16,18,19,26,2,16,26,19,18,2,16,18,19,26,1,17,26,19,18,1,17,18,19,26,2,17,26,19,19,1,18,26,19,26,2,15,26,19,26,3,13,26,19,26,1,14,33,19,26,2,17,27,19,26,3,14,26,19,18,1,18,18,19,18,2,15,18,19,18,1,17,18,19,18,2,16,25,19,18,1,17,25,19,18,3,15,18,19,18,2,16,18,19,23,2,16,23,19,18,2,16,18,19,18,1,17,18,19,18,0,19,18,19,18,1,17,18,19,18,0,18,25,19,18,1,17,18,19,25,2,14,32,19,26,8,3,32,19,25,3,15,32,19,18,1,18,6],"m40":[22,0,0,0,0,22,29,7,6,30,22,29,4,14,12,22,28,1,20,28,22,29,2,18,32,22,28,1,20,29,22,28,1,20,29,22,29,8,6,12,22,29,5,14,37,22,29,3,13,37,22,23,1,19,19,22,23,1,19,19,22,5,7,7,13,22,15,3,16,3,22,5,7,6,6,22,29,2,17,31,22,28,2,18,29,22,27,3,10,28,22,28,3,16,28,22,27,2,17,28,22,27,2,18,27,22,27,2,18,28,22,28,2,17,29,22,27,3,16,27,22,28,2,18,29,22,28,2,17,29,22,19,7,6,20,22,19,7,7,27,22,25,1,19,23,22,19,1,19,12,22,25,1,20,23,22,29,2,17,30,22,28,1,20,29,22,28,0,21,29,22,27,2,18,27,22,28,1,20,29,22,27,2,18,28,22,27,2,17,27,22,27,3,16,27,22,28,1,19,29,22,27,2,18,28,22,27,3,15,28,22,27,2,18,28,22,28,1,20,29,22,27,2,17,28,22,27,1,19,28,22,27,2,18,28,22,28,1,20,29,22,27,2,18,27,22,28,1,20,35,22,27,2,19,27,22,28,2,18,29,22,27,1,19,28,22,27,2,18,28,22,27,1,20,28,22,27,0,22,28,22,27,1,20,27,22,27,1,20,27,22,27,2,18,28,22,29,5,14,33,22,29,2,17,31,22,29,3,13,33,22,27,4,14,13,22,0,1,20,4,22,29,6,8,11,22,21,2,17,22,22,29,2,18,30,22,21,2,18,22,22,29,1,19,30,22,21,2,18,22,22,29,2,19,29,22,21,1,20,29,22,29,2,17,29,22,29,4,14,29,22,29,2,15,37,22,29,2,19,30,22,29,3,16,29,22,21,1,20,22,22,21,2,17,21,22,21,1,19,22,22,21,2,18,29,22,21,1,19,29,22,21,4,16,22,22,21,2,17,22,22,26,2,18,27,22,20,2,17,21,22,20,1,19,21,22,20,0,21,21,22,20,2,18,20,22,20,0,20,28,22,20,2,18,21,22,28,2,16,35,22,29,9,4,36,22,28,3,17,35,22,21,1,20,8],"a40":[22,0,0,0,0,22,29,7,6,30,22,29,4,14,12,22,28,1,20,28,22,29,2,18,32,22,28,1,20,29,22,28,1,20,29,22,29,8,6,12,22,29,5,14,37,22,29,3,13,37,22,23,1,19,19,22,23,1,19,19,22,5,7,7,13,22,15,3,16,3,22,5,7,6,6,22,29,2,17,31,22,28,2,18,29,22,27,3,10,28,22,28,3,16,28,22,27,2,17,28,22,27,2,18,27,22,27,2,18,28,22,28,2,17,29,22,27,3,16,27,22,28,2,18,29,22,28,2,17,29,22,19,7,6,20,22,19,7,7,27,22,25,1,19,23,22,19,1,19,12,22,25,1,20,23,22,29,2,17,30,22,28,1,20,29,22,28,0,21,29,22,27,2,18,27,22,28,1,20,29,22,27,2,18,28,22,27,2,17,27,22,27,3,16,27,22,28,1,19,29,22,27,2,18,28,22,27,3,15,28,22,27,2,18,28,22,28,1,20,29,22,27,2,17,28,22,27,1,19,28,22,27,2,18,28,22,28,1,20,29,22,27,2,18,27,22,28,1,20,35,22,27,2,19,27,22,28,2,18,29,22,27,1,19,28,22,27,2,18,28,22,27,1,20,28,22,27,0,22,28,22,27,1,20,27,22,27,1,20,27,22,27,2,18,28,22,29,5,14,33,22,29,2,17,31,22,29,3,13,33,22,27,4,14,13,22,0,1,20,4,22,29,6,8,11,22,21,2,17,22,22,29,2,18,30,22,21,2,18,22,22,29,1,19,30,22,21,2,18,22,22,29,2,19,29,22,21,1,20,29,22,29,2,17,29,22,29,4,14,29,22,29,2,15,37,22,29,2,19,30,22,29,3,16,29,22,21,1,20,22,22,21,2,17,21,22,21,1,19,22,22,21,2,18,29,22,21,1,19,29,22,21,4,16,22,22,21,2,17,22,22,26,2,18,27,22,20,2,17,21,22,20,1,19,21,22,20,0,21,21,22,20,2,18,20,22,20,0,20,28,22,20,2,18,21,22,28,2,16,35,22,29,9,4,36,22,28,3,17,35,22,21,1,20,8],"m45":[24,0,0,0,0,24,33,8,7,34,24,33,5,14,14,24,31,1,22,31,24,32,2,20,35,24,31,1,22,32,24,31,1,22,32,24,33,9,7,14,24,33,6,15,42,24,33,3,15,42,24,26,1,21,21,24,26,2,20,21,24,5,7,8,14,24,17,3,18,4,24,5,8,7,6,24,33,3,18,36,24,31,2,20,32,24,31,4,11,32,24,31,3,18,31,24,31,3,18,32,24,31,2,20,31,24,31,3,19,32,24,31,3,18,32,24,31,3,18,31,24,31,2,19,32,24,31,3,18,32,24,21,8,7,22,24,21,7,8,30,24,28,1,21,26,24,22,2,20,14,24,28,1,22,26,24,33,3,18,34,24,31,1,22,32,24,31,0,23,32,24,31,2,20,31,24,31,1,22,32,24,31,2,20,32,24,31,2,19,31,24,31,3,18,31,24,31,1,21,32,24,31,2,20,32,24,31,3,17,32,24,31,2,20,32,24,31,2,21,32,24,31,3,18,32,24,31,1,21,32,24,31,2,20,32,24,31,1,22,32,24,31,2,20,31,24,31,1,22,39,24,31,2,21,31,24,31,2,20,32,24,31,1,21,32,24,31,2,20,32,24,31,1,22,32,24,31,0,24,32,24,31,1,22,31,24,31,1,22,31,24,31,2,20,32,24,33,6,14,38,24,33,3,18,36,24,33,3,15,38,24,31,4,16,15,24,0,1,22,4,24,33,6,10,13,24,23,2,19,24,24,33,2,20,34,24,23,2,20,24,24,33,2,20,34,24,23,2,20,24,24,33,2,21,33,24,23,1,22,32,24,33,3,18,33,24,32,4,15,32,24,32,2,17,41,24,33,3,20,34,24,33,3,18,33,24,23,1,22,24,24,23,3,18,23,24,23,1,21,24,24,23,2,20,32,24,23,2,19,32,24,23,4,18,24,24,23,2,19,24,24,29,3,19,30,24,23,2,19,24,24,23,1,21,24,24,23,0,23,24,24,23,2,20,23,24,23,1,22,32,24,23,2,20,24,24,32,2,18,40,24,32,10,4,40,24,32,4,18,40,24,23,1,22,8],"a45":[24,0,0,0,0,24,33,8,7,34,24,33,5,14,14,24,31,1,22,31,24,32,2,20,35,24,31,1,22,32,24,31,1,22,32,24,33,9,7,14,24,33,6,15,42,24,33,3,15,42,24,26,1,21,21,24,26,2,20,21,24,5,7,8,14,24,17,3,18,4,24,5,8,7,6,24,33,3,18,36,24,31,2,20,32,24,31,4,11,32,24,31,3,18,31,24,31,3,18,32,24,31,2,20,31,24,31,3,19,32,24,31,3,18,32,24,31,3,18,31,24,31,2,19,32,24,31,3,18,32,24,21,8,7,22,24,21,7,8,30,24,28,1,21,26,24,22,2,20,14,24,28,1,22,26,24,33,3,18,34,24,31,1,22,32,24,31,0,23,32,24,31,2,20,31,24,31,1,22,32,24,31,2,20,32,24,31,2,19,31,24,31,3,18,31,24,31,1,21,32,24,31,2,20,32,24,31,3,17,32,24,31,2,20,32,24,31,2,21,32,24,31,3,18,32,24,31,1,21,32,24,31,2,20,32,24,31,1,22,32,24,31,2,20,31,24,31,1,22,39,24,31,2,21,31,24,31,2,20,32,24,31,1,21,32,24,31,2,20,32,24,31,1,22,32,24,31,0,24,32,24,31,1,22,31,24,31,1,22,31,24,31,2,20,32,24,33,6,14,38,24,33,3,18,36,24,33,3,15,38,24,31,4,16,15,24,0,1,22,4,24,33,6,10,13,24,23,2,19,24,24,33,2,20,34,24,23,2,20,24,24,33,2,20,34,24,23,2,20,24,24,33,2,21,33,24,23,1,22,32,24,33,3,18,33,24,32,4,15,32,24,32,2,17,41,24,33,3,20,34,24,33,3,18,33,24,23,1,22,24,24,23,3,18,23,24,23,1,21,24,24,23,2,20,32,24,23,2,19,32,24,23,4,18,24,24,23,2,19,24,24,29,3,19,30,24,23,2,19,24,24,23,1,21,24,24,23,0,23,24,24,23,2,20,23,24,23,1,22,32,24,23,2,20,24,24,32,2,18,40,24,32,10,4,40,24,32,4,18,40,24,23,1,22,8],"m48":[26,0,0,0,0,26,35,9,7,36,26,35,5,16,14,26,33,1,24,33,26,34,3,21,37,26,33,1,24,34,26,33,1,24,34,26,35,10,7,14,26,35,7,16,44,26,35,3,16,45,26,27,2,22,22,26,28,2,22,23,26,6,8,8,15,26,18,3,20,4,26,6,9,7,7,26,35,3,20,38,26,33,2,22,34,26,33,4,12,34,26,33,3,20,33,26,33,3,19,34,26,33,2,22,33,26,33,3,21,34,26,33,3,20,34,26,33,4,19,33,26,33,3,20,34,26,33,3,20,34,26,22,9,7,23,26,22,8,8,31,26,30,1,23,28,26,23,2,22,15,26,30,2,23,28,26,35,3,20,36,26,33,1,24,34,26,33,0,26,34,26,33,2,22,33,26,33,2,23,34,26,33,2,22,34,26,33,3,20,33,26,33,3,20,33,26,33,1,23,34,26,33,2,22,34,26,33,4,17,34,26,33,2,22,34,26,33,2,23,34,26,33,3,20,34,26,33,2,22,34,26,33,2,22,34,26,33,1,24,34,26,33,3,21,33,26,33,1,24,41,26,33,2,23,33,26,33,2,22,34,26,33,1,23,34,26,33,2,22,34,26,33,1,24,34,26,33,0,26,34,26,33,2,23,33,26,33,1,24,33,26,33,2,22,34,26,35,6,16,40,26,35,3,20,38,26,35,4,16,40,26,33,4,17,16,26,0,1,24,5,26,35,7,10,13,26,25,2,21,26,26,35,3,21,36,26,25,2,22,26,26,35,2,22,36,26,25,2,22,26,26,35,3,23,35,26,25,1,24,34,26,35,3,20,35,26,34,5,16,34,26,34,2,18,44,26,35,3,22,36,26,35,4,18,35,26,25,1,24,26,26,25,3,20,25,26,25,2,22,26,26,25,3,21,34,26,25,2,21,34,26,25,5,19,26,26,25,2,21,26,26,31,3,21,32,26,24,3,20,25,26,24,2,22,25,26,24,0,25,25,26,24,2,22,24,26,24,1,23,34,26,24,2,22,25,26,34,2,20,43,26,34,11,4,42,26,34,4,20,43,26,25,2,23,9],"a48":[26,0,0,0,0,26,35,9,7,36,26,35,5,16,14,26,33,1,24,33,26,34,3,21,37,26,33,1,24,34,26,33,1,24,34,26,35,10,7,14,26,35,7,16,44,26,35,3,16,45,26,27,2,22,22,26,28,2,22,23,26,6,8,8,15,26,18,3,20,4,26,6,9,7,7,26,35,3,20,38,26,33,2,22,34,26,33,4,12,34,26,33,3,20,33,26,33,3,19,34,26,33,2,22,33,26,33,3,21,34,26,33,3,20,34,26,33,4,19,33,26,33,3,20,34,26,33,3,20,34,26,22,9,7,23,26,22,8,8,31,26,30,1,23,28,26,23,2,22,15,26,30,2,23,28,26,35,3,20,36,26,33,1,24,34,26,33,0,26,34,26,33,2,22,33,26,33,2,23,34,26,33,2,22,34,26,33,3,20,33,26,33,3,20,33,26,33,1,23,34,26,33,2,22,34,26,33,4,17,34,26,33,2,22,34,26,33,2,23,34,26,33,3,20,34,26,33,2,22,34,26,33,2,22,34,26,33,1,24,34,26,33,3,21,33,26,33,1,24,41,26,33,2,23,33,26,33,2,22,34,26,33,1,23,34,26,33,2,22,34,26,33,1,24,34,26,33,0,26,34,26,33,2,23,33,26,33,1,24,33,26,33,2,22,34,26,35,6,16,40,26,35,3,20,38,26,35,4,16,40,26,33,4,17,16,26,0,1,24,5,26,35,7,10,13,26,25,2,21,26,26,35,3,21,36,26,25,2,22,26,26,35,2,22,36,26,25,2,22,26,26,35,3,23,35,26,25,1,24,34,26,35,3,20,35,26,34,5,16,34,26,34,2,18,44,26,35,3,22,36,26,35,4,18,35,26,25,1,24,26,26,25,3,20,25,26,25,2,22,26,26,25,3,21,34,26,25,2,21,34,26,25,5,19,26,26,25,2,21,26,26,31,3,21,32,26,24,3,20,25,26,24,2,22,25,26,24,0,25,25,26,24,2,22,24,26,24,1,23,34,26,24,2,22,25,26,34,2,20,43,26,34,11,4,42,26,34,4,20,43,26,25,2,23,9],"m50":[27,0,0,0,0,27,37,9,8,38,27,36,6,16,14,27,34,1,25,34,27,36,3,22,39,27,35,1,26,36,27,34,1,25,35,27,36,11,7,14,27,36,7,16,46,27,36,3,17,46,27,28,2,23,23,27,29,2,23,24,27,6,8,9,16,27,19,3,21,4,27,6,9,8,7,27,36,3,21,39,27,34,2,23,35,27,34,4,13,35,27,34,3,21,34,27,34,3,20,35,27,34,2,23,34,27,34,3,22,35,27,35,3,21,36,27,34,4,20,34,27,35,3,21,36,27,34,3,21,35,27,23,9,8,24,27,23,8,9,33,27,31,1,24,29,27,24,2,23,15,27,31,2,24,29,27,36,3,21,37,27,35,1,25,36,27,35,0,27,36,27,34,2,23,34,27,34,2,24,35,27,34,2,23,35,27,34,3,21,34,27,34,4,20,34,27,34,1,24,35,27,34,2,23,35,27,34,4,18,35,27,34,2,23,35,27,34,2,24,35,27,34,3,21,35,27,34,2,23,35,27,34,2,23,35,27,34,1,25,35,27,34,3,22,34,27,34,1,25,43,27,34,3,23,34,27,34,2,23,35,27,34,1,24,35,27,34,2,23,35,27,34,1,25,35,27,34,0,27,35,27,34,2,24,34,27,34,1,25,34,27,34,2,23,35,27,37,7,16,42,27,36,3,21,39,27,37,4,16,42,27,34,5,17,16,27,-1,1,25,4,27,37,7,11,14,27,26,2,22,27,27,36,3,22,37,27,26,3,22,27,27,36,2,23,37,27,26,2,23,27,27,37,3,24,37,27,26,2,24,36,27,36,3,21,36,27,36,5,17,36,27,36,2,19,46,27,36,3,23,37,27,36,4,19,36,27,26,2,24,27,27,26,3,21,26,27,26,2,23,27,27,26,3,22,36,27,26,2,22,36,27,26,5,20,27,27,26,3,21,27,27,32,3,21,33,27,25,3,21,26,27,25,2,23,26,27,25,0,26,26,27,25,2,23,25,27,25,1,24,35,27,25,2,23,26,27,35,2,21,44,27,36,11,5,45,27,35,4,21,44,27,26,2,24,9],"a50":[27,0,0,0,0,27,37,9,8,38,27,36,6,16,14,27,34,1,25,34,27,36,3,22,39,27,35,1,26,36,27,34,1,25,35,27,36,11,7,14,27,36,7,16,46,27,36,3,17,46,27,28,2,23,23,27,29,2,23,24,27,6,8,9,16,27,19,3,21,4,27,6,9,8,7,27,36,3,21,39,27,34,2,23,35,27,34,4,13,35,27,34,3,21,34,27,34,3,20,35,27,34,2,23,34,27,34,3,22,35,27,35,3,21,36,27,34,4,20,34,27,35,3,21,36,27,34,3,21,35,27,23,9,8,24,27,23,8,9,33,27,31,1,24,29,27,24,2,23,15,27,31,2,24,29,27,36,3,21,37,27,35,1,25,36,27,35,0,27,36,27,34,2,23,34,27,34,2,24,35,27,34,2,23,35,27,34,3,21,34,27,34,4,20,34,27,34,1,24,35,27,34,2,23,35,27,34,4,18,35,27,34,2,23,35,27,34,2,24,35,27,34,3,21,35,27,34,2,23,35,27,34,2,23,35,27,34,1,25,35,27,34,3,22,34,27,34,1,25,43,27,34,3,23,34,27,34,2,23,35,27,34,1,24,35,27,34,2,23,35,27,34,1,25,35,27,34,0,27,35,27,34,2,24,34,27,34,1,25,34,27,34,2,23,35,27,37,7,16,42,27,36,3,21,39,27,37,4,16,42,27,34,5,17,16,27,-1,1,25,4,27,37,7,11,14,27,26,2,22,27,27,36,3,22,37,27,26,3,22,27,27,36,2,23,37,27,26,2,23,27,27,37,3,24,37,27,26,2,24,36,27,36,3,21,36,27,36,5,17,36,27,36,2,19,46,27,36,3,23,37,27,36,4,19,36,27,26,2,24,27,27,26,3,21,26,27,26,2,23,27,27,26,3,22,36,27,26,2,22,36,27,26,5,20,27,27,26,3,21,27,27,32,3,21,33,27,25,3,21,26,27,25,2,23,26,27,25,0,26,26,27,25,2,23,25,27,25,1,24,35,27,25,2,23,26,27,35,2,21,44,27,36,11,5,45,27,35,4,21,44,27,26,2,24,9],"m54":[29,0,0,0,0,29,39,10,8,40,29,39,6,18,16,29,37,1,27,37,29,38,3,24,41,29,37,1,28,38,29,37,2,26,38,29,39,12,7,16,29,39,8,17,50,29,39,4,18,50,29,31,2,25,25,29,31,2,25,25,29,6,9,9,16,29,21,4,22,5,29,6,10,8,7,29,39,3,23,42,29,37,2,25,38,29,37,5,13,38,29,37,4,22,37,29,37,4,21,38,29,37,2,25,37,29,37,3,23,38,29,37,3,23,38,29,37,4,22,37,29,37,3,23,38,29,37,3,23,38,29,25,10,8,26,29,25,9,9,35,29,33,1,26,31,29,26,2,25,17,29,33,2,26,31,29,39,3,23,40,29,37,1,27,38,29,37,0,29,38,29,37,2,25,37,29,37,2,26,38,29,37,3,24,38,29,37,3,23,37,29,37,4,22,37,29,37,2,25,38,29,37,3,24,38,29,37,4,20,38,29,37,2,25,38,29,37,2,26,38,29,37,3,23,38,29,37,2,25,38,29,37,2,25,38,29,37,1,27,38,29,37,3,24,37,29,37,1,27,46,29,37,3,25,37,29,37,2,25,38,29,37,1,26,38,29,37,2,25,38,29,37,1,27,38,29,37,0,29,38,29,37,2,26,37,29,37,1,27,37,29,37,2,25,38,29,40,7,18,46,29,39,3,23,42,29,40,4,18,46,29,37,5,19,18,29,-1,1,27,4,29,40,8,11,16,29,28,2,24,29,29,39,3,24,40,29,28,3,24,29,29,39,2,25,40,29,28,2,24,29,29,40,3,26,40,29,28,2,26,39,29,39,4,22,39,29,39,5,19,39,29,39,2,21,50,29,39,3,25,40,29,39,4,21,39,29,28,2,26,29,29,28,3,23,28,29,28,2,25,29,29,28,3,24,38,29,28,2,24,38,29,28,5,22,29,29,28,3,23,29,29,35,4,22,36,29,27,3,23,28,29,27,2,25,28,29,27,0,28,28,29,27,2,25,27,29,27,1,26,38,29,27,2,25,28,29,38,3,21,48,29,39,12,5,48,29,38,5,22,48,29,28,2,26,10],"a54":[29,0,0,0,0,29,39,10,8,40,29,39,6,18,16,29,37,1,27,37,29,38,3,24,41,29,37,1,28,38,29,37,2,26,38,29,39,12,7,16,29,39,8,17,50,29,39,4,18,50,29,31,2,25,25,29,31,2,25,25,29,6,9,9,16,29,21,4,22,5,29,6,10,8,7,29,39,3,23,42,29,37,2,25,38,29,37,5,13,38,29,37,4,22,37,29,37,4,21,38,29,37,2,25,37,29,37,3,23,38,29,37,3,23,38,29,37,4,22,37,29,37,3,23,38,29,37,3,23,38,29,25,10,8,26,29,25,9,9,35,29,33,1,26,31,29,26,2,25,17,29,33,2,26,31,29,39,3,23,40,29,37,1,27,38,29,37,0,29,38,29,37,2,25,37,29,37,2,26,38,29,37,3,24,38,29,37,3,23,37,29,37,4,22,37,29,37,2,25,38,29,37,3,24,38,29,37,4,20,38,29,37,2,25,38,29,37,2,26,38,29,37,3,23,38,29,37,2,25,38,29,37,2,25,38,29,37,1,27,38,29,37,3,24,37,29,37,1,27,46,29,37,3,25,37,29,37,2,25,38,29,37,1,26,38,29,37,2,25,38,29,37,1,27,38,29,37,0,29,38,29,37,2,26,37,29,37,1,27,37,29,37,2,25,38,29,40,7,18,46,29,39,3,23,42,29,40,4,18,46,29,37,5,19,18,29,-1,1,27,4,29,40,8,11,16,29,28,2,24,29,29,39,3,24,40,29,28,3,24,29,29,39,2,25,40,29,28,2,24,29,29,40,3,26,40,29,28,2,26,39,29,39,4,22,39,29,39,5,19,39,29,39,2,21,50,29,39,3,25,40,29,39,4,21,39,29,28,2,26,29,29,28,3,23,28,29,28,2,25,29,29,28,3,24,38,29,28,2,24,38,29,28,5,22,29,29,28,3,23,29,29,35,4,22,36,29,27,3,23,28,29,27,2,25,28,29,27,0,28,28,29,27,2,25,27,29,27,1,26,38,29,27,2,25,28,29,38,3,21,48,29,39,12,5,48,29,38,5,22,48,29,28,2,26,10],"m56":[30,0,0,0,0,30,41,10,9,42,30,41,6,18,17,30,38,1,28,38,30,40,3,25,43,30,39,1,29,40,30,39,2,28,40,30,41,12,8,17,30,41,8,18,52,30,41,4,19,52,30,32,2,26,26,30,32,2,26,26,30,7,9,10,18,30,21,4,22,5,30,7,10,8,8,30,41,3,24,44,30,38,3,25,39,30,38,5,14,39,30,38,4,23,38,30,38,4,22,39,30,38,2,26,38,30,38,3,24,39,30,39,4,23,40,30,38,4,23,38,30,39,3,24,40,30,39,4,23,40,30,26,10,8,27,30,26,9,10,37,30,35,2,26,33,30,27,2,26,17,30,35,2,27,33,30,41,3,24,42,30,39,1,28,40,30,39,0,30,40,30,38,2,26,38,30,38,2,27,39,30,38,3,25,39,30,38,3,24,38,30,38,4,23,38,30,39,2,26,40,30,38,3,25,39,30,38,4,21,39,30,38,2,26,39,30,38,2,27,39,30,38,3,24,39,30,38,2,26,39,30,38,3,25,39,30,39,1,28,40,30,38,3,25,38,30,39,1,28,49,30,38,3,26,38,30,38,3,25,39,30,38,1,27,39,30,38,3,25,39,30,38,1,28,39,30,38,1,29,39,30,38,2,27,38,30,38,1,28,38,30,38,3,25,39,30,41,7,19,47,30,41,3,24,44,30,41,4,19,47,30,38,5,20,18,30,-1,2,27,4,30,41,8,12,16,30,29,2,25,30,30,41,3,25,42,30,29,3,25,30,30,41,2,26,42,30,29,2,25,30,30,41,3,27,41,30,29,2,27,40,30,41,4,23,41,30,40,6,18,40,30,40,2,22,51,30,41,3,26,42,30,41,4,22,41,30,29,2,27,30,30,29,4,23,29,30,29,2,26,30,30,29,3,25,40,30,29,2,25,40,30,29,5,23,30,30,29,3,24,30,30,36,4,23,37,30,28,3,24,29,30,28,2,26,29,30,28,0,30,29,30,28,2,26,28,30,28,1,27,39,30,28,3,25,29,30,39,3,22,49,30,40,13,5,50,30,39,5,23,49,30,29,2,27,10],"a56":[30,0,0,0,0,30,41,10,9,42,30,41,6,18,17,30,38,1,28,38,30,40,3,25,43,30,39,1,29,40,30,39,2,28,40,30,41,12,8,17,30,41,8,18,52,30,41,4,19,52,30,32,2,26,26,30,32,2,26,26,30,7,9,10,18,30,21,4,22,5,30,7,10,8,8,30,41,3,24,44,30,38,3,25,39,30,38,5,14,39,30,38,4,23,38,30,38,4,22,39,30,38,2,26,38,30,38,3,24,39,30,39,4,23,40,30,38,4,23,38,30,39,3,24,40,30,39,4,23,40,30,26,10,8,27,30,26,9,10,37,30,35,2,26,33,30,27,2,26,17,30,35,2,27,33,30,41,3,24,42,30,39,1,28,40,30,39,0,30,40,30,38,2,26,38,30,38,2,27,39,30,38,3,25,39,30,38,3,24,38,30,38,4,23,38,30,39,2,26,40,30,38,3,25,39,30,38,4,21,39,30,38,2,26,39,30,38,2,27,39,30,38,3,24,39,30,38,2,26,39,30,38,3,25,39,30,39,1,28,40,30,38,3,25,38,30,39,1,28,49,30,38,3,26,38,30,38,3,25,39,30,38,1,27,39,30,38,3,25,39,30,38,1,28,39,30,38,1,29,39,30,38,2,27,38,30,38,1,28,38,30,38,3,25,39,30,41,7,19,47,30,41,3,24,44,30,41,4,19,47,30,38,5,20,18,30,-1,2,27,4,30,41,8,12,16,30,29,2,25,30,30,41,3,25,42,30,29,3,25,30,30,41,2,26,42,30,29,2,25,30,30,41,3,27,41,30,29,2,27,40,30,41,4,23,41,30,40,6,18,40,30,40,2,22,51,30,41,3,26,42,30,41,4,22,41,30,29,2,27,30,30,29,4,23,29,30,29,2,26,30,30,29,3,25,40,30,29,2,25,40,30,29,5,23,30,30,29,3,24,30,30,36,4,23,37,30,28,3,24,29,30,28,2,26,29,30,28,0,30,29,30,28,2,26,28,30,28,1,27,39,30,28,3,25,29,30,39,3,22,49,30,40,13,5,50,30,39,5,23,49,30,29,2,27,10],"m60":[32,0,0,0,0,32,44,11,9,45,32,44,7,19,18,32,41,1,30,41,32,43,3,27,47,32,42,1,31,43,32,41,2,30,42,32,44,13,8,18,32,44,8,20,56,32,44,4,20,56,32,34,2,28,28,32,34,2,28,28,32,7,10,10,18,32,23,4,24,5,32,7,11,9,8,32,44,4,25,47,32,41,3,27,42,32,41,5,15,42,32,41,4,25,41,32,41,4,24,42,32,41,3,27,41,32,41,4,25,42,32,41,4,25,42,32,41,5,23,41,32,41,3,26,42,32,41,4,25,42,32,28,11,9,29,32,28,10,10,39,32,37,2,28,34,32,29,2,28,18,32,37,2,29,34,32,44,4,25,45,32,41,2,29,42,32,42,0,32,43,32,41,3,27,41,32,41,2,29,42,32,41,3,27,42,32,41,3,26,41,32,41,4,25,41,32,41,2,28,42,32,41,3,27,42,32,41,5,22,42,32,41,3,27,42,32,41,2,29,42,32,41,4,25,42,32,41,2,28,42,32,41,3,27,42,32,41,1,30,42,32,41,3,27,41,32,41,1,30,51,32,41,3,28,41,32,41,3,27,42,32,41,2,28,42,32,41,3,27,42,32,41,1,30,42,32,41,1,31,42,32,41,2,29,41,32,41,1,30,41,32,41,3,27,42,32,44,8,20,50,32,44,4,25,47,32,44,5,19,50,32,41,6,21,19,32,-1,2,29,5,32,44,9,12,17,32,31,3,26,32,32,44,3,27,45,32,31,3,27,32,32,44,2,28,45,32,31,3,26,32,32,44,4,28,44,32,31,2,29,43,32,44,4,25,44,32,43,6,20,43,32,43,3,22,55,32,44,4,27,45,32,44,5,23,44,32,31,2,29,32,32,31,4,24,31,32,31,2,28,32,32,31,3,27,42,32,31,2,27,42,32,31,6,24,32,32,31,3,26,32,32,39,4,25,40,32,30,4,25,31,32,30,2,28,31,32,30,0,32,31,32,30,3,27,30,32,30,1,29,42,32,30,3,27,31,32,42,3,24,53,32,43,14,5,53,32,42,5,24,53,32,31,2,29,11],"a60":[32,0,0,0,0,32,44,11,9,45,32,44,7,19,18,32,41,1,30,41,32,43,3,27,47,32,42,1,31,43,32,41,2,30,42,32,44,13,8,18,32,44,8,20,56,32,44,4,20,56,32,34,2,28,28,32,34,2,28,28,32,7,10,10,18,32,23,4,24,5,32,7,11,9,8,32,44,4,25,47,32,41,3,27,42,32,41,5,15,42,32,41,4,25,41,32,41,4,24,42,32,41,3,27,41,32,41,4,25,42,32,41,4,25,42,32,41,5,23,41,32,41,3,26,42,32,41,4,25,42,32,28,11,9,29,32,28,10,10,39,32,37,2,28,34,32,29,2,28,18,32,37,2,29,34,32,44,4,25,45,32,41,2,29,42,32,42,0,32,43,32,41,3,27,41,32,41,2,29,42,32,41,3,27,42,32,41,3,26,41,32,41,4,25,41,32,41,2,28,42,32,41,3,27,42,32,41,5,22,42,32,41,3,27,42,32,41,2,29,42,32,41,4,25,42,32,41,2,28,42,32,41,3,27,42,32,41,1,30,42,32,41,3,27,41,32,41,1,30,51,32,41,3,28,41,32,41,3,27,42,32,41,2,28,42,32,41,3,27,42,32,41,1,30,42,32,41,1,31,42,32,41,2,29,41,32,41,1,30,41,32,41,3,27,42,32,44,8,20,50,32,44,4,25,47,32,44,5,19,50,32,41,6,21,19,32,-1,2,29,5,32,44,9,12,17,32,31,3,26,32,32,44,3,27,45,32,31,3,27,32,32,44,2,28,45,32,31,3,26,32,32,44,4,28,44,32,31,2,29,43,32,44,4,25,44,32,43,6,20,43,32,43,3,22,55,32,44,4,27,45,32,44,5,23,44,32,31,2,29,32,32,31,4,24,31,32,31,2,28,32,32,31,3,27,42,32,31,2,27,42,32,31,6,24,32,32,31,3,26,32,32,39,4,25,40,32,30,4,25,31,32,30,2,28,31,32,30,0,32,31,32,30,3,27,30,32,30,1,29,42,32,30,3,27,31,32,42,3,24,53,32,43,14,5,53,32,42,5,24,53,32,31,2,29,11],"m63":[34,0,0,0,0,34,46,12,8,47,34,46,7,20,19,34,43,1,31,43,34,45,3,28,49,34,44,1,32,45,34,43,2,30,44,34,46,13,9,19,34,46,9,20,58,34,46,4,21,58,34,36,2,29,29,34,36,2,29,29,34,7,10,11,19,34,24,4,25,5,34,7,11,9,8,34,46,4,26,49,34,43,3,27,44,34,43,5,15,44,34,43,4,26,43,34,43,4,25,44,34,43,3,28,43,34,43,4,26,44,34,43,4,26,44,34,43,5,24,43,34,43,4,26,44,34,43,4,26,44,34,29,11,9,30,34,29,10,11,41,34,39,2,29,36,34,30,2,29,19,34,39,2,30,36,34,46,4,25,47,34,43,2,29,44,34,44,0,33,45,34,43,3,28,43,34,43,2,30,44,34,43,3,28,44,34,43,3,27,43,34,43,5,25,43,34,43,2,29,44,34,43,3,27,44,34,43,5,22,44,34,43,3,28,44,34,43,2,30,44,34,43,4,26,44,34,43,2,29,44,34,43,3,28,44,34,43,1,31,44,34,43,3,28,43,34,43,1,31,54,34,43,3,28,43,34,43,3,28,44,34,43,2,29,44,34,43,3,28,44,34,43,1,31,44,34,43,1,32,44,34,43,2,30,43,34,43,1,31,43,34,43,3,28,44,34,46,8,20,53,34,46,4,26,49,34,46,5,20,53,34,43,6,21,20,34,-1,2,30,5,34,46,9,13,18,34,32,3,26,33,34,46,3,28,47,34,32,3,28,33,34,46,2,28,47,34,32,3,27,33,34,46,4,29,46,34,33,2,30,45,34,46,4,25,46,34,45,6,21,45,34,45,3,23,57,34,46,4,28,47,34,46,5,24,46,34,32,2,30,33,34,32,4,25,32,34,32,2,29,33,34,32,3,28,44,34,32,2,28,44,34,32,6,25,33,34,32,3,27,33,34,41,4,26,42,34,32,4,26,33,34,32,2,29,33,34,32,1,31,33,34,32,3,28,32,34,32,1,30,44,34,32,3,27,33,34,44,3,25,56,34,45,14,5,56,34,44,6,24,56,34,32,2,30,11],"a63":[34,0,0,0,0,34,46,12,8,47,34,46,7,20,19,34,43,1,31,43,34,45,3,28,49,34,44,1,32,45,34,43,2,30,44,34,46,13,9,19,34,46,9,20,58,34,46,4,21,58,34,36,2,29,29,34,36,2,29,29,34,7,10,11,19,34,24,4,25,5,34,7,11,9,8,34,46,4,26,49,34,43,3,27,44,34,43,5,15,44,34,43,4,26,43,34,43,4,25,44,34,43,3,28,43,34,43,4,26,44,34,43,4,26,44,34,43,5,24,43,34,43,4,26,44,34,43,4,26,44,34,29,11,9,30,34,29,10,11,41,34,39,2,29,36,34,30,2,29,19,34,39,2,30,36,34,46,4,25,47,34,43,2,29,44,34,44,0,33,45,34,43,3,28,43,34,43,2,30,44,34,43,3,28,44,34,43,3,27,43,34,43,5,25,43,34,43,2,29,44,34,43,3,27,44,34,43,5,22,44,34,43,3,28,44,34,43,2,30,44,34,43,4,26,44,34,43,2,29,44,34,43,3,28,44,34,43,1,31,44,34,43,3,28,43,34,43,1,31,54,34,43,3,28,43,34,43,3,28,44,34,43,2,29,44,34,43,3,28,44,34,43,1,31,44,34,43,1,32,44,34,43,2,30,43,34,43,1,31,43,34,43,3,28,44,34,46,8,20,53,34,46,4,26,49,34,46,5,20,53,34,43,6,21,20,34,-1,2,30,5,34,46,9,13,18,34,32,3,26,33,34,46,3,28,47,34,32,3,28,33,34,46,2,28,47,34,32,3,27,33,34,46,4,29,46,34,33,2,30,45,34,46,4,25,46,34,45,6,21,45,34,45,3,23,57,34,46,4,28,47,34,46,5,24,46,34,32,2,30,33,34,32,4,25,32,34,32,2,29,33,34,32,3,28,44,34,32,2,28,44,34,32,6,25,33,34,32,3,27,33,34,41,4,26,42,34,32,4,26,33,34,32,2,29,33,34,32,1,31,33,34,32,3,28,32,34,32,1,30,44,34,32,3,27,33,34,44,3,25,56,34,45,14,5,56,34,44,6,24,56,34,32,2,30,11],"m64":[35,0,0,0,0,35,47,12,9,48,35,47,7,21,19,35,44,1,32,44,35,45,4,28,49,35,44,1,33,45,35,44,2,32,45,35,47,14,9,19,35,47,9,21,59,35,46,4,22,59,35,36,2,30,29,35,37,3,29,30,35,8,11,11,20,35,24,4,26,5,35,8,12,9,9,35,46,4,27,49,35,44,3,29,45,35,44,6,15,45,35,44,5,26,44,35,44,4,26,45,35,44,3,29,44,35,44,4,27,45,35,44,4,27,45,35,44,5,25,44,35,44,4,27,45,35,44,4,27,45,35,30,12,9,31,35,30,11,11,42,35,40,2,30,37,35,31,3,29,20,35,40,2,31,37,35,46,4,26,47,35,44,2,31,45,35,44,0,34,45,35,44,3,29,44,35,44,2,31,45,35,44,3,29,45,35,44,4,27,44,35,44,5,26,44,35,44,2,30,45,35,44,3,28,45,35,44,5,23,45,35,44,3,29,45,35,44,2,31,45,35,44,4,27,45,35,44,2,30,45,35,44,3,29,45,35,44,2,31,45,35,44,4,28,44,35,44,2,31,55,35,44,3,30,44,35,44,3,29,45,35,44,2,30,45,35,44,3,29,45,35,44,1,33,45,35,44,1,33,45,35,44,2,31,44,35,44,1,32,44,35,44,3,29,45,35,47,9,20,54,35,46,4,27,49,35,47,5,21,54,35,44,6,22,21,35,-1,2,31,5,35,47,9,13,18,35,33,3,27,34,35,46,4,28,47,35,33,3,29,34,35,46,3,28,47,35,33,3,28,34,35,47,4,30,47,35,33,2,31,45,35,46,4,26,46,35,46,6,22,46,35,46,3,24,59,35,46,4,30,47,35,46,5,25,46,35,33,2,31,34,35,33,4,26,33,35,33,2,30,34,35,33,4,28,45,35,33,2,29,45,35,33,6,26,34,35,33,3,28,34,35,41,4,27,42,35,32,4,27,33,35,32,2,30,33,35,32,1,33,33,35,32,3,29,32,35,32,1,31,45,35,32,3,29,33,35,45,3,26,57,35,46,14,6,57,35,45,6,25,57,35,33,2,31,11],"a64":[35,0,0,0,0,35,47,12,9,48,35,47,7,21,19,35,44,1,32,44,35,45,4,28,49,35,44,1,33,45,35,44,2,32,45,35,47,14,9,19,35,47,9,21,59,35,46,4,22,59,35,36,2,30,29,35,37,3,29,30,35,8,11,11,20,35,24,4,26,5,35,8,12,9,9,35,46,4,27,49,35,44,3,29,45,35,44,6,15,45,35,44,5,26,44,35,44,4,26,45,35,44,3,29,44,35,44,4,27,45,35,44,4,27,45,35,44,5,25,44,35,44,4,27,45,35,44,4,27,45,35,30,12,9,31,35,30,11,11,42,35,40,2,30,37,35,31,3,29,20,35,40,2,31,37,35,46,4,26,47,35,44,2,31,45,35,44,0,34,45,35,44,3,29,44,35,44,2,31,45,35,44,3,29,45,35,44,4,27,44,35,44,5,26,44,35,44,2,30,45,35,44,3,28,45,35,44,5,23,45,35,44,3,29,45,35,44,2,31,45,35,44,4,27,45,35,44,2,30,45,35,44,3,29,45,35,44,2,31,45,35,44,4,28,44,35,44,2,31,55,35,44,3,30,44,35,44,3,29,45,35,44,2,30,45,35,44,3,29,45,35,44,1,33,45,35,44,1,33,45,35,44,2,31,44,35,44,1,32,44,35,44,3,29,45,35,47,9,20,54,35,46,4,27,49,35,47,5,21,54,35,44,6,22,21,35,-1,2,31,5,35,47,9,13,18,35,33,3,27,34,35,46,4,28,47,35,33,3,29,34,35,46,3,28,47,35,33,3,28,34,35,47,4,30,47,35,33,2,31,45,35,46,4,26,46,35,46,6,22,46,35,46,3,24,59,35,46,4,30,47,35,46,5,25,46,35,33,2,31,34,35,33,4,26,33,35,33,2,30,34,35,33,4,28,45,35,33,2,29,45,35,33,6,26,34,35,33,3,28,34,35,41,4,27,42,35,32,4,27,33,35,32,2,30,33,35,32,1,33,33,35,32,3,29,32,35,32,1,31,45,35,32,3,29,33,35,45,3,26,57,35,46,14,6,57,35,45,6,25,57,35,33,2,31,11],"m70":[38,0,0,0,0,38,51,13,10,52,38,51,8,22,20,38,48,1,35,48,38,50,4,31,54,38,48,2,35,49,38,48,2,35,49,38,51,15,10,20,38,51,10,23,65,38,51,5,23,65,38,40,3,32,32,38,40,3,32,33,38,8,12,12,21,38,27,5,28,6,38,8,13,10,9,38,51,4,29,55,38,48,3,31,49,38,48,6,17,49,38,48,5,29,48,38,48,5,28,49,38,48,3,32,48,38,48,4,30,49,38,48,5,29,49,38,48,5,28,48,38,48,4,30,49,38,48,5,29,49,38,32,13,10,33,38,32,12,12,45,38,43,2,33,40,38,34,3,32,22,38,43,2,34,40,38,51,4,29,52,38,48,2,34,49,38,48,1,36,49,38,48,3,32,48,38,48,3,33,49,38,48,4,31,49,38,48,4,30,48,38,48,5,28,48,38,48,2,33,49,38,48,4,30,49,38,48,6,25,49,38,48,3,32,49,38,48,3,33,49,38,48,4,30,49,38,48,3,32,49,38,48,3,32,49,38,48,2,34,49,38,48,4,31,48,38,48,2,34,60,38,48,4,32,48,38,48,3,32,49,38,48,2,33,49,38,48,3,32,49,38,48,1,36,49,38,48,1,36,49,38,48,3,33,48,38,48,2,34,48,38,48,3,32,49,38,51,9,23,58,38,51,4,29,55,38,51,6,22,58,38,48,7,24,23,38,-1,2,34,6,38,51,10,14,19,38,36,3,30,37,38,51,4,31,52,38,36,4,31,37,38,51,3,31,52,38,36,3,31,37,38,51,4,33,51,38,36,2,34,50,38,51,5,28,51,38,50,7,23,50,38,50,3,27,64,38,51,4,33,52,38,51,5,27,51,38,36,2,34,37,38,36,5,28,36,38,36,3,32,37,38,36,4,31,49,38,36,3,31,49,38,36,7,28,37,38,36,4,30,37,38,45,5,29,46,38,35,4,30,36,38,35,2,33,36,38,35,1,36,36,38,35,3,32,35,38,35,1,34,49,38,35,3,31,36,38,49,3,28,62,38,50,16,6,62,38,49,6,28,62,38,36,3,33,12],"a70":[38,0,0,0,0,38,51,13,10,52,38,51,8,22,20,38,48,1,35,48,38,50,4,31,54,38,48,2,35,49,38,48,2,35,49,38,51,15,10,20,38,51,10,23,65,38,51,5,23,65,38,40,3,32,32,38,40,3,32,33,38,8,12,12,21,38,27,5,28,6,38,8,13,10,9,38,51,4,29,55,38,48,3,31,49,38,48,6,17,49,38,48,5,29,48,38,48,5,28,49,38,48,3,32,48,38,48,4,30,49,38,48,5,29,49,38,48,5,28,48,38,48,4,30,49,38,48,5,29,49,38,32,13,10,33,38,32,12,12,45,38,43,2,33,40,38,34,3,32,22,38,43,2,34,40,38,51,4,29,52,38,48,2,34,49,38,48,1,36,49,38,48,3,32,48,38,48,3,33,49,38,48,4,31,49,38,48,4,30,48,38,48,5,28,48,38,48,2,33,49,38,48,4,30,49,38,48,6,25,49,38,48,3,32,49,38,48,3,33,49,38,48,4,30,49,38,48,3,32,49,38,48,3,32,49,38,48,2,34,49,38,48,4,31,48,38,48,2,34,60,38,48,4,32,48,38,48,3,32,49,38,48,2,33,49,38,48,3,32,49,38,48,1,36,49,38,48,1,36,49,38,48,3,33,48,38,48,2,34,48,38,48,3,32,49,38,51,9,23,58,38,51,4,29,55,38,51,6,22,58,38,48,7,24,23,38,-1,2,34,6,38,51,10,14,19,38,36,3,30,37,38,51,4,31,52,38,36,4,31,37,38,51,3,31,52,38,36,3,31,37,38,51,4,33,51,38,36,2,34,50,38,51,5,28,51,38,50,7,23,50,38,50,3,27,64,38,51,4,33,52,38,51,5,27,51,38,36,2,34,37,38,36,5,28,36,38,36,3,32,37,38,36,4,31,49,38,36,3,31,49,38,36,7,28,37,38,36,4,30,37,38,45,5,29,46,38,35,4,30,36,38,35,2,33,36,38,35,1,36,36,38,35,3,32,35,38,35,1,34,49,38,35,3,31,36,38,49,3,28,62,38,50,16,6,62,38,49,6,28,62,38,36,3,33,12],"m72":[39,0,0,0,0,39,52,14,10,53,39,52,8,23,21,39,49,1,36,49,39,51,4,32,55,39,50,2,36,51,39,49,2,36,51,39,52,16,9,21,39,52,10,24,66,39,52,5,24,66,39,41,3,33,33,39,41,3,33,33,39,8,12,12,22,39,27,5,29,6,39,9,13,11,10,39,52,4,30,56,39,49,3,32,50,39,49,6,18,50,39,49,5,30,49,39,49,5,28,50,39,49,3,33,49,39,49,4,31,50,39,49,5,30,50,39,49,6,28,49,39,49,4,31,50,39,49,5,29,50,39,33,13,11,34,39,33,12,12,47,39,44,2,34,41,39,35,3,33,22,39,44,3,34,41,39,52,4,30,54,39,50,2,35,51,39,50,1,37,51,39,49,3,33,49,39,49,3,34,50,39,49,4,32,50,39,49,4,31,49,39,49,5,29,49,39,49,2,34,50,39,49,4,31,50,39,49,6,26,50,39,49,3,33,50,39,49,3,34,50,39,49,5,30,50,39,49,3,33,50,39,49,3,33,50,39,49,2,35,50,39,49,4,32,49,39,49,2,35,61,39,49,4,33,49,39,49,3,33,50,39,49,2,34,50,39,49,3,33,50,39,49,1,37,50,39,49,1,37,50,39,49,3,34,49,39,49,2,35,49,39,49,3,33,50,39,53,10,23,60,39,52,4,30,56,39,53,6,23,60,39,49,7,25,23,39,-1,2,35,6,39,53,10,15,20,39,37,3,31,38,39,52,4,32,53,39,37,4,32,38,39,52,3,32,53,39,37,3,32,38,39,53,4,34,53,39,37,2,35,51,39,52,5,29,52,39,51,7,24,51,39,51,3,27,65,39,52,5,33,53,39,52,6,27,52,39,37,2,35,38,39,37,5,29,37,39,37,3,33,39,39,37,4,32,50,39,37,3,32,50,39,37,7,29,38,39,37,4,31,38,39,47,5,30,48,39,36,4,31,37,39,36,3,33,37,39,36,1,37,37,39,36,3,33,36,39,36,1,35,50,39,36,3,32,37,39,50,4,28,63,39,51,16,6,63,39,50,7,28,63,39,37,3,34,12],"a72":[39,0,0,0,0,39,52,14,10,53,39,52,8,23,21,39,49,1,36,49,39,51,4,32,55,39,50,2,36,51,39,49,2,36,51,39,52,16,9,21,39,52,10,24,66,39,52,5,24,66,39,41,3,33,33,39,41,3,33,33,39,8,12,12,22,39,27,5,29,6,39,9,13,11,10,39,52,4,30,56,39,49,3,32,50,39,49,6,18,50,39,49,5,30,49,39,49,5,28,50,39,49,3,33,49,39,49,4,31,50,39,49,5,30,50,39,49,6,28,49,39,49,4,31,50,39,49,5,29,50,39,33,13,11,34,39,33,12,12,47,39,44,2,34,41,39,35,3,33,22,39,44,3,34,41,39,52,4,30,54,39,50,2,35,51,39,50,1,37,51,39,49,3,33,49,39,49,3,34,50,39,49,4,32,50,39,49,4,31,49,39,49,5,29,49,39,49,2,34,50,39,49,4,31,50,39,49,6,26,50,39,49,3,33,50,39,49,3,34,50,39,49,5,30,50,39,49,3,33,50,39,49,3,33,50,39,49,2,35,50,39,49,4,32,49,39,49,2,35,61,39,49,4,33,49,39,49,3,33,50,39,49,2,34,50,39,49,3,33,50,39,49,1,37,50,39,49,1,37,50,39,49,3,34,49,39,49,2,35,49,39,49,3,33,50,39,53,10,23,60,39,52,4,30,56,39,53,6,23,60,39,49,7,25,23,39,-1,2,35,6,39,53,10,15,20,39,37,3,31,38,39,52,4,32,53,39,37,4,32,38,39,52,3,32,53,39,37,3,32,38,39,53,4,34,53,39,37,2,35,51,39,52,5,29,52,39,51,7,24,51,39,51,3,27,65,39,52,5,33,53,39,52,6,27,52,39,37,2,35,38,39,37,5,29,37,39,37,3,33,39,39,37,4,32,50,39,37,3,32,50,39,37,7,29,38,39,37,4,31,38,39,47,5,30,48,39,36,4,31,37,39,36,3,33,37,39,36,1,37,37,39,36,3,33,36,39,36,1,35,50,39,36,3,32,37,39,50,4,28,63,39,51,16,6,63,39,50,7,28,63,39,37,3,34,12],"m80":[43,0,0,0,0,43,58,15,11,60,43,58,9,25,23,43,55,2,39,55,43,57,5,34,62,43,55,2,39,56,43,55,3,38,57,43,58,17,10,23,43,58,11,25,73,43,58,6,25,74,43,45,3,36,36,43,46,3,36,38,43,9,13,13,24,43,30,5,32,6,43,9,15,11,11,43,58,5,32,62,43,55,4,35,57,43,54,7,19,55,43,55,6,32,55,43,54,5,31,55,43,54,4,35,54,43,54,5,33,56,43,55,5,33,56,43,54,6,31,54,43,55,5,33,56,43,55,5,32,56,43,37,15,11,39,43,37,13,13,52,43,49,2,37,45,43,38,3,36,24,43,49,3,37,45,43,58,5,32,60,43,55,2,38,57,43,55,1,40,56,43,54,4,35,54,43,55,3,37,56,43,54,4,35,55,43,54,4,34,54,43,54,6,31,54,43,55,3,36,56,43,54,4,34,55,43,54,6,29,55,43,54,4,35,56,43,55,3,37,56,43,54,5,33,55,43,54,3,36,55,43,54,4,35,55,43,55,2,38,56,43,54,4,35,54,43,55,2,38,68,43,54,4,36,54,43,55,4,35,56,43,54,2,38,55,43,54,4,35,56,43,54,2,39,55,43,54,1,41,55,43,54,3,37,54,43,54,2,38,54,43,54,4,36,55,43,58,11,25,66,43,58,5,32,62,43,58,6,26,66,43,54,7,28,25,43,-1,2,38,6,43,58,11,16,22,43,41,4,33,43,43,58,5,34,60,43,41,4,35,43,43,58,3,35,59,43,41,4,34,42,43,58,5,36,58,43,41,3,38,56,43,58,5,32,58,43,57,8,26,57,43,57,4,29,73,43,58,5,36,59,43,58,6,30,58,43,41,3,37,42,43,41,5,32,41,43,41,3,36,43,43,41,5,35,56,43,41,3,35,56,43,41,8,31,42,43,41,4,34,42,43,52,5,33,53,43,40,5,33,42,43,40,3,36,41,43,40,1,40,41,43,40,3,36,40,43,40,1,39,56,43,40,4,35,41,43,56,4,31,70,43,57,18,6,71,43,56,7,31,70,43,41,3,38,14],"a80":[43,0,0,0,0,43,58,15,11,60,43,58,9,25,23,43,55,2,39,55,43,57,5,34,62,43,55,2,39,56,43,55,3,38,57,43,58,17,10,23,43,58,11,25,73,43,58,6,25,74,43,45,3,36,36,43,46,3,36,38,43,9,13,13,24,43,30,5,32,6,43,9,15,11,11,43,58,5,32,62,43,55,4,35,57,43,54,7,19,55,43,55,6,32,55,43,54,5,31,55,43,54,4,35,54,43,54,5,33,56,43,55,5,33,56,43,54,6,31,54,43,55,5,33,56,43,55,5,32,56,43,37,15,11,39,43,37,13,13,52,43,49,2,37,45,43,38,3,36,24,43,49,3,37,45,43,58,5,32,60,43,55,2,38,57,43,55,1,40,56,43,54,4,35,54,43,55,3,37,56,43,54,4,35,55,43,54,4,34,54,43,54,6,31,54,43,55,3,36,56,43,54,4,34,55,43,54,6,29,55,43,54,4,35,56,43,55,3,37,56,43,54,5,33,55,43,54,3,36,55,43,54,4,35,55,43,55,2,38,56,43,54,4,35,54,43,55,2,38,68,43,54,4,36,54,43,55,4,35,56,43,54,2,38,55,43,54,4,35,56,43,54,2,39,55,43,54,1,41,55,43,54,3,37,54,43,54,2,38,54,43,54,4,36,55,43,58,11,25,66,43,58,5,32,62,43,58,6,26,66,43,54,7,28,25,43,-1,2,38,6,43,58,11,16,22,43,41,4,33,43,43,58,5,34,60,43,41,4,35,43,43,58,3,35,59,43,41,4,34,42,43,58,5,36,58,43,41,3,38,56,43,58,5,32,58,43,57,8,26,57,43,57,4,29,73,43,58,5,36,59,43,58,6,30,58,43,41,3,37,42,43,41,5,32,41,43,41,3,36,43,43,41,5,35,56,43,41,3,35,56,43,41,8,31,42,43,41,4,34,42,43,52,5,33,53,43,40,5,33,42,43,40,3,36,41,43,40,1,40,41,43,40,3,36,40,43,40,1,39,56,43,40,4,35,41,43,56,4,31,70,43,57,18,6,71,43,56,7,31,70,43,41,3,38,14],"m81":[44,0,0,0,0,44,59,15,12,61,44,59,9,26,24,44,55,2,40,55,44,57,5,36,62,44,56,2,41,57,44,56,3,39,58,44,59,18,10,24,44,59,12,26,75,44,59,6,26,75,44,46,3,38,37,44,46,3,37,37,44,9,14,13,24,44,31,6,32,7,44,10,15,11,12,44,59,5,34,63,44,55,4,36,57,44,55,7,20,56,44,55,6,33,55,44,55,6,32,56,44,55,4,36,55,44,55,5,34,57,44,56,5,34,57,44,55,6,32,55,44,56,5,34,57,44,56,5,34,57,44,37,15,11,39,44,37,14,13,52,44,50,2,39,46,44,39,3,37,25,44,50,3,38,46,44,59,5,33,61,44,56,2,39,58,44,56,1,42,57,44,55,4,36,55,44,55,3,38,56,44,55,4,37,56,44,55,5,34,55,44,55,6,33,55,44,56,3,38,57,44,55,4,36,56,44,55,7,29,56,44,55,4,36,57,44,55,3,39,56,44,55,5,34,56,44,55,3,38,56,44,55,4,36,56,44,56,2,40,57,44,55,5,35,55,44,56,2,40,70,44,55,4,37,55,44,55,4,36,56,44,55,2,39,56,44,55,4,36,57,44,55,2,40,56,44,55,1,42,56,44,55,3,38,55,44,55,2,40,55,44,55,4,37,56,44,59,11,26,67,44,59,5,34,63,44,59,7,26,67,44,55,8,28,26,44,-1,2,39,7,44,59,12,16,22,44,41,4,34,43,44,59,5,35,61,44,41,4,36,43,44,59,3,37,60,44,41,4,35,42,44,59,5,38,59,44,42,3,39,58,44,59,6,32,59,44,58,8,27,58,44,58,4,30,74,44,59,5,37,60,44,59,6,31,59,44,41,3,39,42,44,41,5,33,41,44,41,3,38,43,44,41,5,36,56,44,41,3,36,56,44,41,8,33,42,44,41,4,35,42,44,52,6,33,53,44,40,5,34,42,44,40,3,37,41,44,40,1,41,41,44,40,4,36,40,44,40,1,40,56,44,40,4,36,41,44,56,4,32,71,44,58,18,7,72,44,56,8,32,71,44,41,3,39,13],"a81":[44,0,0,0,0,44,59,15,12,61,44,59,9,26,24,44,55,2,40,55,44,57,5,36,62,44,56,2,41,57,44,56,3,39,58,44,59,18,10,24,44,59,12,26,75,44,59,6,26,75,44,46,3,38,37,44,46,3,37,37,44,9,14,13,24,44,31,6,32,7,44,10,15,11,12,44,59,5,34,63,44,55,4,36,57,44,55,7,20,56,44,55,6,33,55,44,55,6,32,56,44,55,4,36,55,44,55,5,34,57,44,56,5,34,57,44,55,6,32,55,44,56,5,34,57,44,56,5,34,57,44,37,15,11,39,44,37,14,13,52,44,50,2,39,46,44,39,3,37,25,44,50,3,38,46,44,59,5,33,61,44,56,2,39,58,44,56,1,42,57,44,55,4,36,55,44,55,3,38,56,44,55,4,37,56,44,55,5,34,55,44,55,6,33,55,44,56,3,38,57,44,55,4,36,56,44,55,7,29,56,44,55,4,36,57,44,55,3,39,56,44,55,5,34,56,44,55,3,38,56,44,55,4,36,56,44,56,2,40,57,44,55,5,35,55,44,56,2,40,70,44,55,4,37,55,44,55,4,36,56,44,55,2,39,56,44,55,4,36,57,44,55,2,40,56,44,55,1,42,56,44,55,3,38,55,44,55,2,40,55,44,55,4,37,56,44,59,11,26,67,44,59,5,34,63,44,59,7,26,67,44,55,8,28,26,44,-1,2,39,7,44,59,12,16,22,44,41,4,34,43,44,59,5,35,61,44,41,4,36,43,44,59,3,37,60,44,41,4,35,42,44,59,5,38,59,44,42,3,39,58,44,59,6,32,59,44,58,8,27,58,44,58,4,30,74,44,59,5,37,60,44,59,6,31,59,44,41,3,39,42,44,41,5,33,41,44,41,3,38,43,44,41,5,36,56,44,41,3,36,56,44,41,8,33,42,44,41,4,35,42,44,52,6,33,53,44,40,5,34,42,44,40,3,37,41,44,40,1,41,41,44,40,4,36,40,44,40,1,40,56,44,40,4,36,41,44,56,4,32,71,44,58,18,7,72,44,56,8,32,71,44,41,3,39,13],"m84":[45,0,0,0,0,45,61,16,11,63,45,61,9,27,24,45,57,2,41,56,45,59,5,36,64,45,58,2,41,59,45,58,3,40,60,45,61,18,11,24,45,61,12,26,77,45,61,6,27,77,45,47,3,38,38,45,48,3,38,39,45,10,14,14,26,45,32,6,33,7,45,10,15,12,12,45,61,5,34,65,45,57,4,36,59,45,57,7,20,58,45,57,6,34,57,45,57,6,32,58,45,57,4,37,57,45,57,5,35,59,45,58,5,35,59,45,57,6,33,57,45,58,5,35,59,45,58,6,33,59,45,39,15,12,41,45,39,14,14,55,45,52,3,38,48,45,40,3,38,25,45,52,3,39,48,45,61,5,34,63,45,58,2,40,60,45,58,1,42,59,45,57,4,37,57,45,57,3,39,58,45,57,4,37,58,45,57,5,35,57,45,57,6,33,57,45,58,3,38,59,45,57,4,36,58,45,57,7,29,58,45,57,4,37,59,45,57,3,39,58,45,57,5,35,58,45,57,3,38,58,45,57,4,37,58,45,58,2,40,59,45,57,5,36,57,45,58,2,40,72,45,57,4,38,57,45,57,4,37,58,45,57,2,40,58,45,57,4,37,59,45,57,2,41,58,45,57,1,43,58,45,57,3,39,57,45,57,2,40,57,45,57,4,38,58,45,61,11,27,70,45,61,5,34,65,45,61,7,26,70,45,57,8,28,26,45,-1,3,39,7,45,61,12,17,23,45,43,4,35,45,45,61,5,36,63,45,43,4,37,45,45,61,3,37,62,45,43,4,36,44,45,61,5,38,61,45,43,3,40,59,45,61,6,33,61,45,60,8,28,60,45,60,4,31,76,45,61,5,38,62,45,61,6,32,61,45,43,3,39,44,45,43,6,33,43,45,43,3,38,45,45,43,5,37,59,45,43,3,37,59,45,43,8,33,44,45,43,4,36,44,45,54,6,34,55,45,42,5,35,44,45,42,3,38,43,45,42,1,42,43,45,42,4,37,42,45,42,1,41,58,45,42,4,36,43,45,59,4,33,74,45,60,19,7,74,45,59,8,32,74,45,43,3,40,14],"a84":[45,0,0,0,0,45,61,16,11,63,45,61,9,27,24,45,57,2,41,56,45,59,5,36,64,45,58,2,41,59,45,58,3,40,60,45,61,18,11,24,45,61,12,26,77,45,61,6,27,77,45,47,3,38,38,45,48,3,38,39,45,10,14,14,26,45,32,6,33,7,45,10,15,12,12,45,61,5,34,65,45,57,4,36,59,45,57,7,20,58,45,57,6,34,57,45,57,6,32,58,45,57,4,37,57,45,57,5,35,59,45,58,5,35,59,45,57,6,33,57,45,58,5,35,59,45,58,6,33,59,45,39,15,12,41,45,39,14,14,55,45,52,3,38,48,45,40,3,38,25,45,52,3,39,48,45,61,5,34,63,45,58,2,40,60,45,58,1,42,59,45,57,4,37,57,45,57,3,39,58,45,57,4,37,58,45,57,5,35,57,45,57,6,33,57,45,58,3,38,59,45,57,4,36,58,45,57,7,29,58,45,57,4,37,59,45,57,3,39,58,45,57,5,35,58,45,57,3,38,58,45,57,4,37,58,45,58,2,40,59,45,57,5,36,57,45,58,2,40,72,45,57,4,38,57,45,57,4,37,58,45,57,2,40,58,45,57,4,37,59,45,57,2,41,58,45,57,1,43,58,45,57,3,39,57,45,57,2,40,57,45,57,4,38,58,45,61,11,27,70,45,61,5,34,65,45,61,7,26,70,45,57,8,28,26,45,-1,3,39,7,45,61,12,17,23,45,43,4,35,45,45,61,5,36,63,45,43,4,37,45,45,61,3,37,62,45,43,4,36,44,45,61,5,38,61,45,43,3,40,59,45,61,6,33,61,45,60,8,28,60,45,60,4,31,76,45,61,5,38,62,45,61,6,32,61,45,43,3,39,44,45,43,6,33,43,45,43,3,38,45,45,43,5,37,59,45,43,3,37,59,45,43,8,33,44,45,43,4,36,44,45,54,6,34,55,45,42,5,35,44,45,42,3,38,43,45,42,1,42,43,45,42,4,37,42,45,42,1,41,58,45,42,4,36,43,45,59,4,33,74,45,60,19,7,74,45,59,8,32,74,45,43,3,40,14],"m90":[49,0,0,0,0,49,65,17,12,67,49,65,10,28,26,49,61,2,44,60,49,64,5,39,69,49,62,2,44,64,49,62,3,43,64,49,65,19,12,26,49,65,13,28,82,49,65,6,29,83,49,51,3,41,41,49,51,4,40,41,49,10,15,15,27,49,34,6,35,7,49,11,17,12,13,49,65,6,36,70,49,61,4,39,63,49,61,8,21,62,49,61,6,36,61,49,61,6,35,63,49,61,4,40,61,49,61,6,37,63,49,62,6,36,64,49,61,7,35,61,49,62,5,37,64,49,62,6,36,64,49,42,17,12,44,49,42,15,15,59,49,56,3,41,52,49,43,4,40,27,49,56,3,42,52,49,65,6,36,67,49,62,2,43,64,49,62,1,45,63,49,61,4,40,61,49,62,3,42,64,49,61,5,39,62,49,61,5,37,61,49,61,7,35,61,49,62,3,41,63,49,61,5,38,62,49,61,7,32,62,49,61,4,40,63,49,62,4,41,63,49,61,6,36,62,49,61,3,41,62,49,61,4,40,62,49,62,2,43,63,49,61,5,39,61,49,62,2,43,77,49,61,5,40,61,49,61,4,40,63,49,61,2,42,62,49,61,4,40,63,49,61,2,44,62,49,61,1,46,62,49,61,3,42,61,49,61,2,43,61,49,61,4,40,62,49,66,12,28,75,49,65,6,36,70,49,66,7,29,75,49,61,8,31,28,49,-1,3,42,7,49,66,13,18,25,49,46,4,38,48,49,65,5,39,67,49,46,5,39,48,49,65,4,39,67,49,46,4,39,48,49,66,5,41,66,49,46,3,43,63,49,65,6,36,65,49,64,9,29,64,49,64,4,33,82,49,65,6,40,66,49,65,7,34,65,49,46,3,42,47,49,46,6,36,46,49,46,3,41,48,49,46,5,39,63,49,46,4,38,63,49,46,9,35,47,49,46,5,37,48,49,58,6,37,59,49,45,5,37,47,49,45,3,41,46,49,45,1,45,46,49,45,4,40,45,49,45,2,43,62,49,45,4,39,46,49,63,4,35,79,49,64,20,7,79,49,63,8,35,79,49,46,3,43,15],"a90":[49,0,0,0,0,49,65,17,12,67,49,65,10,28,26,49,61,2,44,60,49,64,5,39,69,49,62,2,44,64,49,62,3,43,64,49,65,19,12,26,49,65,13,28,82,49,65,6,29,83,49,51,3,41,41,49,51,4,40,41,49,10,15,15,27,49,34,6,35,7,49,11,17,12,13,49,65,6,36,70,49,61,4,39,63,49,61,8,21,62,49,61,6,36,61,49,61,6,35,63,49,61,4,40,61,49,61,6,37,63,49,62,6,36,64,49,61,7,35,61,49,62,5,37,64,49,62,6,36,64,49,42,17,12,44,49,42,15,15,59,49,56,3,41,52,49,43,4,40,27,49,56,3,42,52,49,65,6,36,67,49,62,2,43,64,49,62,1,45,63,49,61,4,40,61,49,62,3,42,64,49,61,5,39,62,49,61,5,37,61,49,61,7,35,61,49,62,3,41,63,49,61,5,38,62,49,61,7,32,62,49,61,4,40,63,49,62,4,41,63,49,61,6,36,62,49,61,3,41,62,49,61,4,40,62,49,62,2,43,63,49,61,5,39,61,49,62,2,43,77,49,61,5,40,61,49,61,4,40,63,49,61,2,42,62,49,61,4,40,63,49,61,2,44,62,49,61,1,46,62,49,61,3,42,61,49,61,2,43,61,49,61,4,40,62,49,66,12,28,75,49,65,6,36,70,49,66,7,29,75,49,61,8,31,28,49,-1,3,42,7,49,66,13,18,25,49,46,4,38,48,49,65,5,39,67,49,46,5,39,48,49,65,4,39,67,49,46,4,39,48,49,66,5,41,66,49,46,3,43,63,49,65,6,36,65,49,64,9,29,64,49,64,4,33,82,49,65,6,40,66,49,65,7,34,65,49,46,3,42,47,49,46,6,36,46,49,46,3,41,48,49,46,5,39,63,49,46,4,38,63,49,46,9,35,47,49,46,5,37,48,49,58,6,37,59,49,45,5,37,47,49,45,3,41,46,49,45,1,45,46,49,45,4,40,45,49,45,2,43,62,49,45,4,39,46,49,63,4,35,79,49,64,20,7,79,49,63,8,35,79,49,46,3,43,15],"m96":[52,0,0,0,0,52,70,18,13,72,52,70,11,30,28,52,65,2,47,64,52,68,6,41,73,52,66,2,47,68,52,66,3,46,68,52,70,20,13,28,52,70,14,30,88,52,69,7,30,88,52,54,4,43,44,52,55,4,43,45,52,11,16,15,29,52,36,7,37,7,52,11,18,13,13,52,69,6,39,74,52,65,5,41,67,52,65,8,23,66,52,65,7,38,65,52,65,7,37,67,52,65,4,42,65,52,65,6,40,67,52,66,6,39,68,52,65,7,37,65,52,66,6,39,68,52,66,6,39,68,52,44,18,13,46,52,44,16,15,62,52,59,3,44,55,52,46,4,43,29,52,59,3,45,55,52,69,6,39,71,52,66,3,45,68,52,66,1,49,67,52,65,4,43,65,52,66,4,44,68,52,65,5,42,66,52,65,5,40,65,52,65,7,38,65,52,66,3,44,68,52,65,5,41,66,52,65,8,33,66,52,65,4,43,67,52,66,4,44,67,52,65,6,39,66,52,65,4,43,66,52,65,5,42,66,52,66,2,46,68,52,65,5,42,65,52,66,2,46,82,52,65,5,43,65,52,65,5,42,67,52,65,3,44,66,52,65,5,42,67,52,65,2,47,66,52,65,1,49,66,52,65,4,44,65,52,65,2,46,65,52,65,5,42,66,52,70,13,30,80,52,69,6,39,74,52,70,8,30,80,52,65,9,32,30,52,-1,3,45,8,52,70,14,19,26,52,49,4,41,51,52,69,6,41,71,52,49,5,42,51,52,69,4,42,71,52,49,4,42,51,52,70,6,44,70,52,49,3,46,67,52,69,7,37,69,52,68,10,31,68,52,68,4,36,87,52,69,6,43,70,52,69,7,36,69,52,49,3,45,50,52,49,6,38,49,52,49,4,43,51,52,49,6,41,67,52,49,4,41,67,52,49,10,37,50,52,49,5,40,51,52,62,7,39,63,52,48,6,39,50,52,48,3,44,49,52,48,1,48,49,52,48,4,43,48,52,48,2,46,67,52,48,5,41,49,52,67,5,37,84,52,68,21,8,84,52,67,9,37,84,52,49,4,45,16],"a96":[52,0,0,0,0,52,70,18,13,72,52,70,11,30,28,52,65,2,47,64,52,68,6,41,73,52,66,2,47,68,52,66,3,46,68,52,70,20,13,28,52,70,14,30,88,52,69,7,30,88,52,54,4,43,44,52,55,4,43,45,52,11,16,15,29,52,36,7,37,7,52,11,18,13,13,52,69,6,39,74,52,65,5,41,67,52,65,8,23,66,52,65,7,38,65,52,65,7,37,67,52,65,4,42,65,52,65,6,40,67,52,66,6,39,68,52,65,7,37,65,52,66,6,39,68,52,66,6,39,68,52,44,18,13,46,52,44,16,15,62,52,59,3,44,55,52,46,4,43,29,52,59,3,45,55,52,69,6,39,71,52,66,3,45,68,52,66,1,49,67,52,65,4,43,65,52,66,4,44,68,52,65,5,42,66,52,65,5,40,65,52,65,7,38,65,52,66,3,44,68,52,65,5,41,66,52,65,8,33,66,52,65,4,43,67,52,66,4,44,67,52,65,6,39,66,52,65,4,43,66,52,65,5,42,66,52,66,2,46,68,52,65,5,42,65,52,66,2,46,82,52,65,5,43,65,52,65,5,42,67,52,65,3,44,66,52,65,5,42,67,52,65,2,47,66,52,65,1,49,66,52,65,4,44,65,52,65,2,46,65,52,65,5,42,66,52,70,13,30,80,52,69,6,39,74,52,70,8,30,80,52,65,9,32,30,52,-1,3,45,8,52,70,14,19,26,52,49,4,41,51,52,69,6,41,71,52,49,5,42,51,52,69,4,42,71,52,49,4,42,51,52,70,6,44,70,52,49,3,46,67,52,69,7,37,69,52,68,10,31,68,52,68,4,36,87,52,69,6,43,70,52,69,7,36,69,52,49,3,45,50,52,49,6,38,49,52,49,4,43,51,52,49,6,41,67,52,49,4,41,67,52,49,10,37,50,52,49,5,40,51,52,62,7,39,63,52,48,6,39,50,52,48,3,44,49,52,48,1,48,49,52,48,4,43,48,52,48,2,46,67,52,48,5,41,49,52,67,5,37,84,52,68,21,8,84,52,67,9,37,84,52,49,4,45,16],"m108":[58,0,0,0,0,58,78,20,15,80,58,78,12,34,31,58,74,2,53,73,58,76,6,47,82,58,74,3,53,76,58,74,4,51,76,58,78,23,14,31,58,78,15,34,99,58,78,8,34,99,58,61,4,49,49,58,61,5,47,49,58,12,18,17,32,58,41,8,42,9,58,13,20,14,15,58,78,7,43,84,58,74,5,47,76,58,73,10,25,74,58,74,8,43,74,58,73,7,42,75,58,73,5,47,73,58,73,7,44,75,58,74,7,44,76,58,73,8,42,73,58,74,6,45,76,58,74,7,43,76,58,50,20,14,52,58,50,18,17,70,58,67,3,50,62,58,52,5,47,33,58,67,4,50,62,58,78,7,43,80,58,74,3,51,76,58,74,1,55,75,58,73,5,48,73,58,74,4,50,76,58,73,6,47,74,58,73,6,45,73,58,73,8,42,73,58,74,4,49,76,58,73,6,46,74,58,73,9,38,74,58,73,5,48,75,58,74,4,50,75,58,73,7,44,74,58,73,4,49,74,58,73,5,47,74,58,74,3,51,76,58,73,6,46,73,58,74,3,51,92,58,73,6,48,73,58,73,5,47,75,58,73,3,50,74,58,73,5,47,75,58,73,2,53,74,58,73,1,55,74,58,73,4,50,73,58,73,3,51,73,58,73,5,48,74,58,79,14,34,90,58,78,7,43,84,58,79,9,34,90,58,73,10,37,34,58,-2,3,51,8,58,79,15,22,30,58,55,5,45,57,58,78,6,47,80,58,55,6,47,57,58,78,5,47,80,58,55,5,46,57,58,79,7,49,79,58,56,4,51,77,58,78,7,43,78,58,77,11,35,77,58,77,5,39,98,58,78,7,48,79,58,78,8,41,78,58,55,4,50,56,58,55,7,43,55,58,55,4,49,57,58,55,6,47,75,58,55,4,47,75,58,55,11,42,56,58,55,6,45,57,58,70,7,44,72,58,54,7,44,56,58,54,4,49,55,58,54,1,54,55,58,54,5,47,54,58,54,2,51,75,58,54,5,47,55,58,75,5,42,94,58,77,24,9,95,58,75,10,42,94,58,55,4,51,18],"a108":[58,0,0,0,0,58,78,20,15,80,58,78,12,34,31,58,74,2,53,73,58,76,6,47,82,58,74,3,53,76,58,74,4,51,76,58,78,23,14,31,58,78,15,34,99,58,78,8,34,99,58,61,4,49,49,58,61,5,47,49,58,12,18,17,32,58,41,8,42,9,58,13,20,14,15,58,78,7,43,84,58,74,5,47,76,58,73,10,25,74,58,74,8,43,74,58,73,7,42,75,58,73,5,47,73,58,73,7,44,75,58,74,7,44,76,58,73,8,42,73,58,74,6,45,76,58,74,7,43,76,58,50,20,14,52,58,50,18,17,70,58,67,3,50,62,58,52,5,47,33,58,67,4,50,62,58,78,7,43,80,58,74,3,51,76,58,74,1,55,75,58,73,5,48,73,58,74,4,50,76,58,73,6,47,74,58,73,6,45,73,58,73,8,42,73,58,74,4,49,76,58,73,6,46,74,58,73,9,38,74,58,73,5,48,75,58,74,4,50,75,58,73,7,44,74,58,73,4,49,74,58,73,5,47,74,58,74,3,51,76,58,73,6,46,73,58,74,3,51,92,58,73,6,48,73,58,73,5,47,75,58,73,3,50,74,58,73,5,47,75,58,73,2,53,74,58,73,1,55,74,58,73,4,50,73,58,73,3,51,73,58,73,5,48,74,58,79,14,34,90,58,78,7,43,84,58,79,9,34,90,58,73,10,37,34,58,-2,3,51,8,58,79,15,22,30,58,55,5,45,57,58,78,6,47,80,58,55,6,47,57,58,78,5,47,80,58,55,5,46,57,58,79,7,49,79,58,56,4,51,77,58,78,7,43,78,58,77,11,35,77,58,77,5,39,98,58,78,7,48,79,58,78,8,41,78,58,55,4,50,56,58,55,7,43,55,58,55,4,49,57,58,55,6,47,75,58,55,4,47,75,58,55,11,42,56,58,55,6,45,57,58,70,7,44,72,58,54,7,44,56,58,54,4,49,55,58,54,1,54,55,58,54,5,47,54,58,54,2,51,75,58,54,5,47,55,58,75,5,42,94,58,77,24,9,95,58,75,10,42,94,58,55,4,51,18]},"fonts":{}};
	  if (typeof bwipjs_fonts == "object") {
	    bwipjs_fonts.fontsets[3] = desc;
	    bwipjs_fonts.names["INCONSOLATA"] = 3;
	  } else {
	    module.exports = desc;
	  }
	})();
	if (bwipjs_fonts.onready) { bwipjs_fonts.onready.call(null); }
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(66)))

/***/ }),
/* 346 */
/***/ (function(module, exports) {

	// file : bwip-js/bwipjs.js
	//
	// Graphics-context interface to the BWIPP cross-compiled code
	
	// Math.floor(), etc. are notoriously slow.  Caching seems to help.
	var floor = Math.floor;
	var round = Math.round;
	var ceil  = Math.ceil;
	
	// fontlib : fixedfont or freetype
	function BWIPJS(fontlib, monochrome) {
		if (this.constructor !== BWIPJS) {
			return new BWIPJS(fontlib, monochrome);
		}
		this.bmap	 = null;// Bitmap interface
		this.gstk	 = [];	// Graphics save/restore stack
		this.cmds	 = [];	// Graphics primitives to replay when rendering
		this.rgbmap  = {};	// Unique RGB entries used with the fonts
		this.ncolors = 0;	// Number of unique RGBA entries
		this.fontlib = fontlib;
	
		this.reset();
	
		// Bounding box
		this.minx = this.miny = Infinity;
		this.maxx = this.maxy = 0;
	
		fontlib.monochrome(monochrome);
	}
	
	BWIPJS.prototype.bitmap = function(bitmap) {
		if (bitmap) {
			this.bmap = bitmap;
		}
		return this.bmap;
	}
	
	// All graphics state that must be saved/restored is given a prefix of g_
	BWIPJS.prototype.reset = function() {
		// Current Transform Matrix - since we don't do rotation, we can fake
		// the matrix math
		this.g_tdx	= 0;		// CTM x-offset
		this.g_tdy	= 0;		// CTM y-offset
		this.g_tsx	= 1;		// CTM x-scale factor
		this.g_tsy	= 1;		// CTM y-scale factor
	
		this.g_posx	= 0;		// current x position
		this.g_posy	= 0;		// current y position
		this.g_penw	= 1;		// current line/pen width
		this.g_path	= [];		// current path
		this.g_font	= null;		// current font object
		this.g_rgb  = [0,0,0];	// current color (black)
	}
	BWIPJS.prototype.save = function() {
		// clone all g_ properties
		var ctx = {};
		for (var id in this) {
			if (id.indexOf('g_') == 0) {
				ctx[id] = clone(this[id]);
			}
		}
		this.gstk.push(ctx);
	
		// Perform a deep clone of the graphics state properties
		function clone(v) {
			if (v instanceof Array) {
				var t = [];
				for (var i = 0; i < v.length; i++)
					t[i] = clone(v[i]);
				return t;
			}
			if (v instanceof Object) {
				var t = {};
				for (var id in v)
					t[id] = clone(v[id]);
				return t;
			}
			return v;
		}
	}
	BWIPJS.prototype.restore = function() {
		if (!this.gstk.length) {
			throw new Error('grestore: stack underflow');
		}
		var ctx = this.gstk.pop();
		for (var id in ctx) {
			this[id] = ctx[id];
		}
		// Color is part of the bitmap interface and must be restored separately.
		var self = this;
		var r = this.g_rgb[0], g = this.g_rgb[1], b = this.g_rgb[2];
		this.cmds.push(function() {
			self.bmap.color(r, g, b);
		});
	}
	// Per the postscript spec:
	//	As discussed in Section 4.4.1, Current Path, points entered into a path
	//	are immediately converted to device coordinates by the current
	//	transformation matrix (CTM); subsequent modifications to the CTM do not
	//	affect existing points.  `currentpoint` computes the user space
	//	coordinates corresponding to the current point according to the current
	//	value of the CTM. Thus, if a current point is set and then the CTM is
	//	changed, the coordinates returned by currentpoint will be different
	//	from those that were originally specified for the point. 
	BWIPJS.prototype.currpos = function() {
		return { x:(this.g_posx-this.g_tdx)/this.g_tsx,
				 y:(this.g_posy-this.g_tdy)/this.g_tsy
			};
	}
	BWIPJS.prototype.currfont = function() {
		return this.g_font;
	}
	BWIPJS.prototype.findfont = function(name) {
		return { FontName:name };
	}
	BWIPJS.prototype.translate = function(x, y) {
		this.g_tdx = this.g_tsx * x;
		this.g_tdy = this.g_tsy * y;
	}
	BWIPJS.prototype.scale = function(x, y) {
		this.g_tsx *= x;
		this.g_tsy *= y;
	}
	BWIPJS.prototype.setlinewidth = function(w) {
		this.g_penw = w;
	}
	BWIPJS.prototype.setfont = function(f) {
		this.g_font = f;
	}
	BWIPJS.prototype.getfont = function() {
		return this.fontlib.lookup(this.g_font.FontName.toString());
	}
	// Special function to replace setanycolor in BWIPP
	// Takes a string of hex digits either 6 chars in length (rrggbb) or
	// 8 chars (ccmmyykk).
	BWIPJS.prototype.setcolor = function(s) {
		if (s.length == 6) {
			var r = parseInt(s.substr(0,2), 16);
			var g = parseInt(s.substr(2,2), 16);
			var b = parseInt(s.substr(4,2), 16);
		} else if (s.length == 8) {
			var c = parseInt(s.substr(0,2), 16) / 255;
			var m = parseInt(s.substr(2,2), 16) / 255;
			var y = parseInt(s.substr(4,2), 16) / 255;
			var k = parseInt(s.substr(6,2), 16) / 255;
			var r = round((1-c) * (1-k) * 255);
			var g = round((1-m) * (1-k) * 255);
			var b = round((1-y) * (1-k) * 255);
		} else {
			throw 'bwipp.setcolor: invalid string length (' + s + ')' ;
		}
	
		// Set the color in the bitmap
		var self = this;
		self.cmds.push(function() {
			self.bmap.color(r, g, b);
		});
	
		this.g_rgb = [ r, g, b ];
	}
	BWIPJS.prototype.newpath = function() {
		this.g_path = [];
	}
	BWIPJS.prototype.closepath = function() {
		if (this.g_path.length)  {
			var c0 = this.g_path[0];
			var c1 = this.g_path[this.g_path.length-1];
			this.g_path.push([ c1[0], c1[1] ]);
			this.g_path.push(['c']);
			this.g_path.push([ c0[0], c0[1] ]);
		}
	}
	BWIPJS.prototype.moveto = function(x,y) {
		this.g_posx = this.g_tdx + this.g_tsx * x;
		this.g_posy = this.g_tdy + this.g_tsy * y;
	}
	BWIPJS.prototype.rmoveto = function(x,y) {
		this.g_posx += this.g_tsx * x;
		this.g_posy += this.g_tsy * y;
	}
	BWIPJS.prototype.lineto = function(x,y) {
		this.g_path.push([this.g_posx, this.g_posy]);
		this.g_path.push(['l']);
		this.g_posx = this.g_tdx + this.g_tsx * x;
		this.g_posy = this.g_tdy + this.g_tsy * y;
		this.g_path.push([this.g_posx, this.g_posy]);
	}
	BWIPJS.prototype.rlineto = function(x,y) {
		this.g_path.push([this.g_posx, this.g_posy]);
		this.g_path.push(['l']);
		this.g_posx += this.g_tsx * x;
		this.g_posy += this.g_tsy * y;
		this.g_path.push([this.g_posx, this.g_posy]);
	}
	BWIPJS.prototype.stringwidth = function(str) {
		var font = this.getfont();
		var size = (+this.g_font.FontSize || 10) * this.g_tsx;
	
		// str may be a uint8-string or normal string
		var cca = typeof str === 'string';
	
		// Width, ascent, and descent of the char-path.
		// Font metrics are always available.
		var w = 0, a = 0, d = 0;
		for (var i = 0; i < str.length; i++) {
			var cd = cca ? str.charCodeAt(i) : str[i];
			var glyph = this.fontlib.getglyph(font, cd, size, size); // no y-scaling
			w += glyph.advance;
			a = Math.max(a, glyph.top);
			d = Math.max(d, glyph.height-glyph.top);
		}
		return { w:w/this.g_tsx, h:(a+d)/this.g_tsy,
			 a:a/this.g_tsy, d:d/this.g_tsy };
	}
	BWIPJS.prototype.charpath = function(str, b) {
		var sw = this.stringwidth(str);
	
		// Emulate the char-path by placing a rectangle around it
		this.rlineto(0, sw.a);
		this.rlineto(sw.w, 0);
		this.rlineto(0, -sw.h);
	}
	BWIPJS.prototype.pathbbox = function() {
		if (!this.g_path.length)	throw new Error('pathbbox: --nocurrentpoint--');
		var pth = this.g_path;
		var llx = pth[0][0];
		var lly = pth[0][1];
		var urx = 0;
		var ury = 0;
		for (var i = 2, inc = 2; i < pth.length; i += inc) {
			if (llx > pth[i][0]) llx = pth[i][0];
			if (urx < pth[i][0]) urx = pth[i][0];
			if (lly > pth[i][1]) lly = pth[i][1];
			if (ury < pth[i][1]) ury = pth[i][1];
			inc = (inc == 2 ? 1 : 2);
		}
	
		// Convert to user-space coordinates
		var rv = {	llx:(llx-this.g_tdx)/this.g_tsx,
					lly:(lly-this.g_tdy)/this.g_tsy,
					urx:(urx-this.g_tdx)/this.g_tsx,
					ury:(ury-this.g_tdy)/this.g_tsy };
		return rv;
	}
	BWIPJS.prototype.stroke = function() {
		var self = this;
		var penx = this.g_penw*this.g_tsx;
		var peny = this.g_penw*this.g_tsy;
		var path = this.g_path;
		var segs = this.g_path.length / 3;	// number of line segments
		if (this.g_path[this.g_path.length-2][0] == 'c')
			segs--;
	
		// Track number of colors
		var rgb = (this.g_rgb[0] << 16) | (this.g_rgb[1] << 8) | this.g_rgb[2];
		if (!this.rgbmap[rgb]) {
			this.rgbmap[rgb] = 1;
			this.ncolors += 1;
		}
	
		// Calcuate the bounding boxes
		for (var i = 0; i < path.length; ) {
			var s = path[i++];	// start point
			var a = path[i++];	// opcode
			var e = path[i++];	// end point
			if (a[0] == 'l') {
				this.linebbox(s[0], s[1], e[0], e[1], penx, peny);
			}
		}
	
		// Render the lines
		this.cmds.push(function() {
			// Draw the lines
			for (var i = 0; i < path.length; ) {
				var s = path[i++];	// start point
				var a = path[i++];	// opcode
				var e = path[i++];	// end point
				if (a[0] == 'l') {
					self.drawline(true, s[0], s[1], e[0], e[1], penx, peny, segs > 1);
				}
			}
		});
	
		this.g_path = [];
	}
	// Fix sources of rounding error by making the scale-factors integral.
	// Currently, only floor is being used.
	BWIPJS.prototype.floorscale = function() {
		this.g_tsx = floor(this.g_tsx) || 1;
		this.g_tsy = floor(this.g_tsy) || 1;
	}
	BWIPJS.prototype.ceilscale = function() {
		this.g_tsx = ceil(this.g_tsx) || 1;
		this.g_tsy = ceil(this.g_tsy) || 1;
	}
	BWIPJS.prototype.roundscale = function() {
		this.g_tsx = round(this.g_tsx) || 1;
		this.g_tsy = round(this.g_tsy) || 1;
	}
	
	// source is an 8-bit bitmask
	// This implementation is optimized for 2D bar codes.  That is, it does not
	// distort the image due to rounding errors.  Every pixel is scaled
	// identically, so the resulting image may be smaller by a few pixels than
	// the scaling factor would require.  The transform matrix is not used.
	BWIPJS.prototype.imagemask = function(width, height, source) {
		var tx = floor(this.g_tdx);
		var ty = floor(this.g_tdy);
		var dx = floor(this.g_tsx / width);		// pixel width
		var dy = floor(this.g_tsy / height);	// pixel height
		var rl = ceil(width / 8); 		// row length (bytes per row)
		var y0 = ty + height * dy;
		var x0;
		var self = this;
	
		if (!dx || !dy) {
			throw new Error('Image scaled to zero size.');
		}
	
		// Track number of colors
		var rgb = (this.g_rgb[0] << 16) | (this.g_rgb[1] << 8) | this.g_rgb[2];
		if (!this.rgbmap[rgb]) {
			this.rgbmap[rgb] = 1;
			this.ncolors += 1;
		}
	
		this.bbox(tx, ty, dx * width, dy * height);
		this.cmds.push(function() {
			var minx = self.minx;
			var miny = self.miny;
			for (var y = 0; y < height; y++) {
				x0 = tx;
				y0 -= dy;
				for (var x = 0; x < width; x++) {
					var by = source[y*rl + (x>>>3)];
					var bt = by & (1 << 7-(x&7));
					if (bt) {
						var x1 = x0 + dx;
						var y1 = y0 + dy;
						for (var j = y0; j < y1; j++) {
							for (var k = x0; k < x1; k++) {
								self.bmap.set(k-minx,j-miny,255);
							}
						}
					}
					x0 += dx;
				}
			}
		});
	}
	// dx,dy are inter-character gaps
	BWIPJS.prototype.show = function(str, dx, dy) {
		if (!str.length) {
			return;
		}
	
		// Capture current graphics state
		var self = this;
		var font = self.getfont();
		var size = +self.g_font.FontSize || 10;
		var tsx	 = self.g_tsx;
		var tsy  = self.g_tsy;
		var posx = floor(self.g_posx);
		var posy = floor(self.g_posy);
		var r	 = self.g_rgb[0];
		var g	 = self.g_rgb[1];
		var b	 = self.g_rgb[2];
		var szx  = floor(size * tsx);
		var szy	 = floor(size * tsy);
	
		// The string can be either a uint8-string or regular string
		var cca = typeof str === 'string';
	
		// Convert dx,dy to device space
		dx = floor(self.g_tsx * dx);
		dy = floor(self.g_tsy * dy);
	
		// Estimate number of colors
		var rgb = (r << 16) | (g << 8) | b;
		var nalpha = self.rgbmap[rgb];
		if (!nalpha) {
			self.ncolors += 256;
		} else if (nalpha == 1) {
			self.ncolors += 255;
		}
		self.rgbmap[rgb] = 256;
	
		// Bounding box.  Use the actual glyph sizes.
		var base = floor(self.g_posy) + dy;		// loop invariant
		for (var i = 0; i < str.length; i++) {
			var ch = cca ? str.charCodeAt(i) : str[i];
			var glyph = self.fontlib.getglyph(font, ch, szx, szx);	// no y-scaling
	
			// The OCR glyphs seem to be about a point right compared to the
			// font metrics hard-coded into BWIPP.  This is especially apparent
			// in the EAN and UPC codes where the bars mix with the text.
			var left = floor(this.g_posx) + glyph.left;
			if (font <= 1) { // && ch >= 48 && ch <= 57) {
				left -= floor(1.0 * tsx);
			}
			self.bbox(left, base+glyph.top-glyph.height, glyph.width, glyph.height);
			this.g_posx += glyph.advance + dx;
		}
		this.g_posx -= dx;	// overshot
		this.maxicount = 0;
	
		self.cmds.push(function() {
			var minx = self.minx;
			var miny = self.miny;
	
			// PostScript renders bottom-up, so we must render the glyphs inverted.
			for (var i = 0; i < str.length; i++) {
				var ch = cca ? str.charCodeAt(i) : str[i];
				var glyph = self.fontlib.getglyph(font, ch, szx, szx);	// no y-scaling
	
				// The OCR glyphs seem to be about a point right compared to the
				// font metrics hard-coded into BWIPP.  This is especially apparent
				// in the EAN and UPC codes where the bars mix with the text.
				var top  = posy + glyph.top + dy - 1;
				var left = posx + glyph.left;
				if (font <= 1) { // && ch >= 48 && ch <= 57) {
					left -= floor(1.0 * tsx);
				}
				var w = glyph.width;
				var h = glyph.height;
				var b = glyph.bytes;
				var o = glyph.offset;		// offset into bytes
	
				for (var x = 0; x < w; x++) {
					for (var y = 0; y < h; y++) {
						var a = b[o + y * w + x];
						if (a)
							self.bmap.set(left+x-minx, top-y-miny, a);
					}
				}
				posx += glyph.advance + dx;
			}
		});
	}
	
	// Line algorithm that produces a more symmetric line than Bresenham's
	//
	// optmz == boolean 
	// x1,y1 == starting coordinates
	// x2,y2 == ending coordinates
	// penx,peny == pen dimensions
	// merge == multi-line : merge the end points
	//
	// When optmz is true, we use the fast vertical/horizontal line drawing
	// optimizations.  This works well for single lines.
	// When optmz is false, we always use the arbitrary line drawing alg, as
	// it better connects one line with the next.
	BWIPJS.prototype.drawline = function(optmz, x1, y1, x2, y2, penx, peny, merge) {
		var minx = this.minx;
		var miny = this.miny;
	
		if (optmz && (x1 == x2 || y1 == y2)) {
			var lx = round(penx);
			var ly = round(peny);
	
			if (y2 < y1) { var t = y1; y1 = y2; y2 = t; }
			if (x2 < x1) { var t = x1; x1 = x2; x2 = t; }
	
			// Horizontal or vertical line?
			if (x1 == x2) {
				// Vertical line
				x1 = floor(x1 - lx/2);
				x2 = floor(x2 + lx/2);
				y1 = floor(y1 - (merge ? ly/2 : 0));
				y2 = floor(y2 + (merge ? ly/2 : 0));
			} else {
				// Horizontal line
				y1 = floor(y1 - ly/2);
				y2 = floor(y2 + ly/2);
				x1 = floor(x1 - (merge ? lx/2 : 0));
				x2 = floor(x2 + (merge ? lx/2 : 0));
			}
			for (var y = y1; y < y2; y++) {
				for (var x = x1; x < x2; x++) {
					this.bmap.set(x-minx,y-miny,255);
				}
			}
			return;
		}
	
		// Draw an arbitrary line
		x1 = floor(x1);
		x2 = floor(x2);
		y1 = floor(y1);
		y2 = floor(y2);
	
		var du = Math.abs(x2-x1);
		var dv = Math.abs(y2-y1);
		var kx = (x2 < x1 ? -1 : 1);
		var ky = (y2 < y1 ? -1 : 1);
		var x  = x1;
		var y  = y1;
		var d  = 0;
	
		// Calculate the effect of pen width
		var penw = floor(Math.sqrt(penx*penx + peny*peny));
		var pixh = round(Math.sqrt((penw*penw)/((dv*dv)/(du*du)+1))) || 1;
		var pixw = round(Math.sqrt(penw*penw-pixh*pixh)) || 1;
	
		if (du >= dv) {
			// Increment on x
			while (x != x2) {
				for (var j = 0; j < pixh; j++) {
					this.bmap.set(x-minx, y+j-miny, 255);
				}
				d += dv;
				if (d >= du) {
					d -= du;
					y += ky;
				}
				x += kx;
			}
			for (var j = 0; j < pixh; j++) {
				this.bmap.set(x-minx, y+j-miny, 255);
			}
		} else {
			// Increment on y
			while (y != y2) {
				for (var j = 0; j < pixw; j++) {
					this.bmap.set(x+j-minx, y-miny, 255);
				}
				d += du;
				if (d >= dv) {
					d -= dv;
					x += kx;
				}
				y += ky;
			}
			for (var j = 0; j < pixw; j++) {
				this.bmap.set(x+j-minx, y-miny, 255);
			}
		}
	} // end of drawline()
	
	// Bounding box for a line.  The renderers only draw orthogonal lines.
	// Maxicode is drawn using a font.
	BWIPJS.prototype.linebbox = function(x0, y0, x1, y1, penw, penh) {
	    if (x0 > x1) {
			var t = x0;
			x0 = x1;
			x1 = t;
	    }
	    if (y0 > y1) {
			var t = y0;
			y0 = y1;
			y1 = t;
	    }
		penw = round(penw);
		penh = round(penh);
	    if (x0 == x1) {
	        // vertical line
			var xl = floor(x0 - penw/2);
			var xr = floor(x0 + penw/2);
	        this.bbox(floor(xl), floor(y0), xr-xl, floor(y1-y0));
	    } else if (y0 == y1) {
	        // horizontal line
	        this.bbox(x0, y0 - penh/2, x1-x0, penh);
	    } else {
	        this.bbox(x0, y0, x1-x0, y1-y0);
	    }
	}
	// Track the bounding box of the image
	BWIPJS.prototype.bbox = function(x, y, w, h) {
		if (this.minx > x) {
	        this.minx = x;
	    }
	    if (this.maxx < x + w - 1) {
	        this.maxx = x + w - 1;
	    }
	    if (this.miny > y) {
	        this.miny = y;
	    }
	    if (this.maxy < y + h - 1) {
	        this.maxy = y + h - 1;
	    }
	}
	BWIPJS.prototype.render = function(callback) {
		this.minx = floor(this.minx);
		this.miny = floor(this.miny);
		this.maxx = floor(this.maxx);
		this.maxy = floor(this.maxy);
	
		// Tell the bitmap about the image
		if (this.bmap.imageinfo) {
			this.bmap.imageinfo(this.maxx - this.minx + 1,
								this.maxy - this.miny + 1,
								this.ncolors);
		}
	
		// Draw the image to the bitmap
		for (var i = 0, l = this.cmds.length; i < l; i++) {
			this.cmds[i]();
		}
	
		if (this.bmap.finalize) {
			this.bmap.finalize(callback);
		}
	}
	
	BWIPJS.VERSION = '1.7.3 (2019-04-23)';
	if (typeof module === 'object' && module.exports) {
		module.exports = BWIPJS;
	}


/***/ }),
/* 347 */
/***/ (function(module, exports) {

	// bwip-js // Barcode Writer in Pure JavaScript
	// https://github.com/metafloor/bwip-js
	//
	// This code was automatically generated from:
	// Barcode Writer in Pure PostScript - Version 2018-02-04
	//
	// Copyright (c) 2011-2019 Mark Warren
	// Copyright (c) 2004-2019 Terry Burton
	//
	// Licensed MIT. See the LICENSE file in the bwip-js root directory.
	"use strict";
	
	function BWIPP() {
		// bwip-js/barcode-hdr.js
		//
		// This code is injected above the cross-compiled barcode.ps.
	
		// The BWIPJS object (graphics interface)
		var $$ = null;
	
		// The global dictionary.  Each renderer and encoder declare a
		// $1 local dict.
		var $0 = {
			$error: {} // the postscript error object
		};
	
		var $j = 0; // stack pointer
		var $k = []; // operand stack
		var $b = {}; // break symbol
	
		// Array ctor
		//	$a()	: Build a new array up to the Infinity-marker on the stack.
		//	$a(arr)	: Convert native array to a "view" of the array.
		//	$a(len)	: Create a new array of length `len`
		function $a(a) {
			if (!arguments.length) {
				for (var i = $j - 1; i >= 0 && $k[i] !== Infinity; i--);
				if (i < 0) {
					throw new Error('array-marker-not-found');
				}
				a = $k.splice(i + 1, $j - 1 - i);
				$j = i;
			} else if (!(a instanceof Array)) {
				a = new Array(+arguments[0]);
				for (var i = 0, l = a.length; i < l; i++) {
					a[i] = null;
				}
			}
			a.b = a; // base array
			a.o = 0; // offset into base
			return a;
		}
	
		// dict ctor
		//	$d() : look for the Infinity marker on the stack
		function $d() {
			var d = {};
			for (var i = $j - 1; i >= 0 && $k[i] !== Infinity; i -= 2) {
				if ($k[i - 1] === Infinity) {
					throw new Error('dict-malformed-stack');
				}
				// Unlike javascript, postscript dict keys differentiate between
				// numbers and the string representation of a number.
				var k = $k[i - 1]; // "key" into the dict entry
				var t = typeof k;
				if (t === 'number') {
					d['\uffff' + k] = $k[i];
				} else if (t === 'string') {
					d[k] = $k[i];
				} else if (k instanceof Uint8Array) {
					d[$z(k)] = $k[i];
				} else {
					throw 'dict-not-a-valid-key(' + k + ')';
				}
			}
			if (i < 0) {
				throw 'dict-marker-not-found';
			}
			$j = i;
			return d;
		}
	
		// string ctor
		//	s(number)	: create zero-filled string of number-length
		//	s(string)	: make a copy of the string
		//	s(uint8[])	: make a copy of the string
		//
		// Returns a Uint8Array-string.
		function $s(v) {
			var t = typeof v;
			if (t === 'number') {
				return new Uint8Array(v);
			}
			if (t !== 'string') {
				v = '' + v;
			}
			var s = new Uint8Array(v.length);
			for (var i = 0; i < v.length; i++) {
				s[i] = v.charCodeAt(i);
			}
			return s;
		}
	
		// Primarily designed to convert uint8-string to string, but will call the
		// the toString() method on any value.
		function $z(s) {
			if (s instanceof Uint8Array) {
				// Postscript treats nul-char as end of string, even if string is
				// longer.
				for (var i = 0, l = s.length; i < l && s[i]; i++);
				if (i < l) {
					return String.fromCharCode.apply(null, s.subarray(0, i));
				}
				return String.fromCharCode.apply(null, s)
			}
			return '' + s;
		}
	
		// Copies source to dest and returns a view of just the copied characters
		function $strcpy(dst, src) {
			if (typeof dst === 'string') {
				dst = $s(dst);
			}
			if (src instanceof Uint8Array) {
				for (var i = 0, l = src.length; i < l; i++) {
					dst[i] = src[i];
				}
			} else {
				for (var i = 0, l = src.length; i < l; i++) {
					dst[i] = src.charCodeAt(i);
				}
			}
			return src.length < dst.length ? dst.subarray(0, src.length) : dst;
		}
	
		// Copies source to dest and should (but doesn't) return a view of just the copied elements
		function $arrcpy(dst, src) {
			for (var i = 0, l = src.length; i < l; i++) {
				dst[i] = src[i];
			}
			dst.length = src.length;
			return dst;
		}
	
		// cvs operator - convert a value to its string representation
		//	s : string to store into
		//	v : any value
		function $cvs(s, v) {
			var t = typeof v;
			if (t == 'number' || t == 'boolean' || v === null) {
				v = '' + v;
			} else if (t !== 'string') {
				v = '--nostringval--';
			}
			for (var i = 0, l = v.length; i < l; i++) {
				s[i] = v.charCodeAt(i);
			}
			$k[$j++] = i < s.length ? s.subarray(0, i) : s;
		}
		// cvrs operator - convert a number to a radix string
		//	s : string to store into
		//	n : number
		//	r : radix
		function $cvrs(s, n, r) {
			return $strcpy(s, (~~n).toString(r).toUpperCase());
		}
	
		// get operator
		//	s : source
		//	k : key
		function $get(s, k) {
			if (s instanceof Uint8Array) {
				return s[k];
			}
			if (typeof s === 'string') {
				return s.charCodeAt(k);
			}
			if (s instanceof Array) {
				return s.b[s.o + k];
			}
			// Must be a dict object : with postscript dict objects, a number key
			// is differerent than its string representation.  postscript uses
			// 8-bit strings, so \uffff can never be in a key value.
			if (typeof k === 'number') {
				return s['\uffff' + k];
			}
			if (k instanceof Uint8Array) {
				return s[$z(k)];
			}
			return s[k];
		}
	
		// put operator
		//	d : dest
		//	k : key
		//	v : value
		function $put(d, k, v) {
			if (d instanceof Uint8Array) {
				d[k] = v;
			} else if (d instanceof Array) {
				d.b[d.o + k] = v;
			} else if (typeof d == 'object') {
				if (k instanceof Uint8Array) {
					d[$z(k)] = v;
				} else {
					d[typeof k == 'number' ? '\uffff' + k : k] = v;
				}
			} else {
				throw 'put-not-writable-' + (typeof d);
			}
		}
	
		// getinterval operator
		//	s : src
		//	o : offset
		//	l : length
		function $geti(s, o, l) {
			if (s instanceof Uint8Array) {
				return s.subarray(o, o + l);
			}
			if (s instanceof Array) {
				var a = new Array(l);
				a.b = s.b; // base array
				a.o = s.o + o; // offset into base
				return a;
			}
			// Must be a string
			return s.substr(o, l);
		}
	
		// putinterval operator
		//	d : dst
		//	o : offset
		//	s : src
		function $puti(d, o, s) {
			if (d instanceof Uint8Array) {
				if (typeof s == 'string') {
					for (var i = 0, l = s.length; i < l; i++) {
						d[o + i] = s.charCodeAt(i);
					}
				} else {
					// When both d and s are the same, we want to copy
					// backwards, which works for the general case as well.
					for (var i = s.length - 1; i >= 0; i--) {
						d[o + i] = s[i];
					}
				}
			} else if (d instanceof Array) {
				// Operate on the base arrays
				var darr = d.b;
				var doff = o + d.o;
				var sarr = s.b;
				var soff = s.o;
	
				for (var i = 0, l = s.length; i < l; i++) {
					darr[doff + i] = sarr[soff + i];
				}
			} else {
				throw 'putinterval-not-writable-' + (typeof d);
			}
		}
	
		// type operator
		function $type(v) {
			// null can be mis-typed - get it out of the way
			if (v === null || v === undefined) {
				return 'nulltype';
			}
			var t = typeof v;
			if (t == 'number') {
				return v % 1 ? 'realtype' : 'integertype';
			}
			if (t == 'boolean') {
				return 'booleantype';
			}
			if (t == 'string' || v instanceof Uint8Array) {
				return 'stringtype';
			}
			if (t == 'function') {
				return 'operatortype';
			}
			if (v instanceof Array) {
				return 'arraytype';
			}
			return 'dicttype';
			// filetype
			// fonttype
			// gstatetype
			// marktype	(v === Infinity)
			// nametype
			// savetype
		}
	
		// search operator
		//		string seek search suffix match prefix true %if-found
		//						   string false				%if-not-found
		function $search(str, seek) {
			if (!(str instanceof Uint8Array)) {
				str = $s(str);
			}
			var ls = str.length;
	
			// Virtually all uses of search in BWIPP are for single-characters.
			// Optimize for that case.
			if (seek.length == 1) {
				var lk = 1;
				var cd = seek instanceof Uint8Array ? seek[0] : seek.charCodeAt(0);
				for (var i = 0; i < ls && str[i] != cd; i++);
			} else {
				// Slow path, 
				if (!(seek instanceof Uint8Array)) {
					seek = $(seek);
				}
				var lk = seek.length;
				var cd = seek[0];
				for (var i = 0; i < ls && str[i] != cd; i++);
				while (i < ls) {
					for (var j = 1; j < lk && str[i + j] === seek[j]; j++);
					if (j === lk) {
						break;
					}
					for (i++; i < ls && str[i] != cd; i++);
				}
			}
			if (i < ls) {
				$k[$j++] = str.subarray(i + lk);
				$k[$j++] = str.subarray(i, i + lk);
				$k[$j++] = str.subarray(0, i);
				$k[$j++] = true;
			} else {
				$k[$j++] = str;
				$k[$j++] = false;
			}
		}
	
		// The callback is omitted when forall is being used just to push onto the
		// stack.
		function $forall(o, cb) {
			if (o instanceof Uint8Array) {
				for (var i = 0, l = o.length; i < l; i++) {
					$k[$j++] = o[i];
					if (cb && cb() == $b) break;
				}
			} else if (o instanceof Array) {
				// The array may be a view.
				for (var a = o.b, i = o.o, l = o.o + o.length; i < l; i++) {
					$k[$j++] = a[i];
					if (cb && cb() == $b) break;
				}
			} else if (typeof o === 'string') {
				for (var i = 0, l = o.length; i < l; i++) {
					$k[$j++] = o.charCodeAt(i);
					if (cb && cb() == $b) break;
				}
			} else {
				for (var id in o) {
					$k[$j++] = id;
					$k[$j++] = o[id];
					if (cb && cb() == $b) break;
				}
			}
		}
	
		function $cleartomark() {
			while ($j > 0 && $k[--$j] !== Infinity);
		}
	
		function $counttomark() {
			for (var i = $j - 1; i >= 0 && $k[i] !== Infinity; i--);
			return $j - i - 1;
		}
	
		function $aload(a) {
			for (var i = 0, l = a.length, b = a.b, o = a.o; i < l; i++) {
				$k[$j++] = b[o + i];
			}
			// This push has been optimized out.  See $.aload() in psc.js.
			//$k[$j++] = a;
		}
	
		function $astore(a) {
			for (var i = 0, l = a.length, b = a.b, o = a.o + l - 1; i < l; i++) {
				b[o - i] = $k[--$j];
			}
			$k[$j++] = a;
		}
	
		function $eq(a, b) {
			if (typeof a === 'string' && typeof b === 'string') {
				return a == b;
			}
			if (a instanceof Uint8Array && b instanceof Uint8Array) {
				if (a.length != b.length) {
					return false;
				}
				for (var i = 0, l = a.length; i < l; i++) {
					if (a[i] != b[i]) {
						return false;
					}
				}
				return true;
			}
			if (a instanceof Uint8Array && typeof b === 'string' ||
				b instanceof Uint8Array && typeof a === 'string') {
				if (a instanceof Uint8Array) {
					a = $z(a);
				} else {
					b = $z(b);
				}
				return a == b;
			}
			return a == b;
		}
	
		function $ne(a, b) {
			return !$eq(a, b);
		}
	
		function $lt(a, b) {
			if (a instanceof Uint8Array) {
				a = $z(a);
			}
			if (b instanceof Uint8Array) {
				b = $z(b);
			}
			return a < b;
		}
	
		function $le(a, b) {
			if (a instanceof Uint8Array) {
				a = $z(a);
			}
			if (b instanceof Uint8Array) {
				b = $z(b);
			}
			return a <= b;
		}
	
		function $gt(a, b) {
			if (a instanceof Uint8Array) {
				a = $z(a);
			}
			if (b instanceof Uint8Array) {
				b = $z(b);
			}
			return a > b;
		}
	
		function $ge(a, b) {
			if (a instanceof Uint8Array) {
				a = $z(a);
			}
			if (b instanceof Uint8Array) {
				b = $z(b);
			}
			return a >= b;
		}
	
		function $an(a, b) { // and
			return (typeof a === 'boolean') ? a && b : a & b;
		}
	
		function $or(a, b) { // or
			return (typeof a === 'boolean') ? a || b : a | b;
		}
	
		function $xo(a, b) { // xor
			return (typeof a === 'boolean') ? !a && b || a && !b : a ^ b;
		}
	
		// DEBUG-BEGIN
		function $stack() {
			console.log('[[[');
			for (var i = $j - 1; i >= 0; i--) {
				console.log(tostring($k[i]));
			}
			console.log(']]]');
	
			function tostring(v) {
				// null can be mis-typed - get it out of the way
				if (v === null) {
					return 'null';
				} else if (v === undefined) {
					return '<undefined>';
				} else if (v instanceof Array) {
					var s = '<array,' + v.o + ',' + v.length + '>[';
					for (var j = v.o, a = v.b, l = v.length + v.o; j < l; j++) {
						s += (j == v.o ? '' : ',') + tostring(a[j]);
					}
					return s + ']';
				} else if (v instanceof Uint8Array) {
					return '(' + $z[v] + ')';
				} else if (typeof v === 'object') {
					var s = '<<';
					for (var id in v) {
						s += (s.length == 7 ? '' : ',') + id + ':' + tostring(v[id]);
					}
					return s + '>>';
				} else if (typeof v === 'string') {
					return '"' + v + '"';
				} else {
					return '' + v;
				}
			}
		}
		// DEBUG-END
		$0.raiseerror = function() {
			$0.$error.errorinfo = $k[--$j]; /*55*/
			$0.$error.errorname = $k[--$j]; /*56*/
			$0.$error.command = null; /*57*/
			$0.$error.newerror = true; /*58*/
			throw new Error($0.$error.errorname + ": " + $0.$error.errorinfo); /*59*/
		};
		$0.ean5 = function() {
			var $1 = {}; /*756*/
			$1.options = $k[--$j]; /*758*/
			$1.barcode = $k[--$j]; /*759*/
			$1.dontdraw = false; /*761*/
			$1.includetext = false; /*762*/
			$1.textfont = "Helvetica"; /*763*/
			$1.textsize = 12; /*764*/
			$1.textxoffset = 0; /*765*/
			$1.textyoffset = "unset"; /*766*/
			$1.height = 0.7; /*767*/
			$forall($1.options, function() { /*778*/
				var _3 = $k[--$j]; /*778*/
				$1[$k[--$j]] = _3; /*778*/
			}); /*778*/
			$1.textfont = "" + $1.textfont; /*780*/
			$1.textsize = +$1.textsize; /*781*/
			$1.height = +$1.height; /*782*/
			$1.textxoffset = +$1.textxoffset; /*783*/
			if ($eq($1.textyoffset, "unset")) { /*787*/
				$1.textyoffset = ($1.height * 72) + 1; /*785*/
			} else { /*787*/
				$1.textyoffset = +$1.textyoffset; /*787*/
			} /*787*/
			if ($1.barcode.length != 5) { /*793*/
				$k[$j++] = "bwipp.ean5badLength"; /*792*/
				$k[$j++] = "EAN-5 add-on must be 5 digits"; /*792*/
				$0.raiseerror(); /*792*/
			} /*792*/
			$forall($1.barcode, function() { /*798*/
				var _E = $k[--$j]; /*795*/
				if ((_E < 48) || (_E > 57)) { /*797*/
					$k[$j++] = "bwipp.ean5badCharacter"; /*796*/
					$k[$j++] = "EAN-5 add-on must contain only digits"; /*796*/
					$0.raiseerror(); /*796*/
				} /*796*/
			}); /*796*/
			$1.encs = $a(["3211", "2221", "2122", "1411", "1132", "1231", "1114", "1312", "1213", "3112", "112", "11"]); /*805*/
			$1.barchars = "0123456789"; /*808*/
			$1.mirrormaps = $a(["11000", "10100", "10010", "10001", "01100", "00110", "00011", "01010", "01001", "00101"]); /*814*/
			$1.checksum = 0; /*815*/
			for (var _H = 0; _H <= 4; _H += 1) { /*824*/
				$1.i = _H; /*817*/
				$1.barchar = $get($1.barcode, $1.i) - 48; /*818*/
				if (($1.i % 2) == 0) { /*822*/
					$1.checksum = ($1.barchar * 3) + $1.checksum; /*820*/
				} else { /*822*/
					$1.checksum = ($1.barchar * 9) + $1.checksum; /*822*/
				} /*822*/
			} /*822*/
			$1.checksum = $1.checksum % 10; /*825*/
			$1.mirrormap = $get($1.mirrormaps, $1.checksum); /*826*/
			$1.sbs = $s(31); /*828*/
			$1.txt = $a(5); /*829*/
			for (var _W = 0; _W <= 4; _W += 1) { /*859*/
				$1.i = _W; /*832*/
				if ($1.i == 0) { /*838*/
					$puti($1.sbs, 0, $get($1.encs, 10)); /*836*/
				} else { /*838*/
					$puti($1.sbs, (($1.i - 1) * 6) + 7, $get($1.encs, 11)); /*838*/
				} /*838*/
				$search($1.barchars, $geti($1.barcode, $1.i, 1)); /*842*/
				$j--; /*843*/
				$1.indx = $k[--$j].length; /*844*/
				$j -= 2; /*845*/
				$1.enc = $get($1.encs, $1.indx); /*846*/
				if ($get($1.mirrormap, $1.i) == 49) { /*856*/
					$1.enclen = $1.enc.length; /*848*/
					$1.revenc = $s($1.enclen); /*849*/
					for (var _v = 0, _u = $1.enclen - 1; _v <= _u; _v += 1) { /*854*/
						$1.j = _v; /*851*/
						$1.char = $get($1.enc, $1.j); /*852*/
						$put($1.revenc, ($1.enclen - $1.j) - 1, $1.char); /*853*/
					} /*853*/
					$1.enc = $1.revenc; /*855*/
				} /*855*/
				$puti($1.sbs, ($1.i * 6) + 3, $1.enc); /*857*/
				$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), ((($1.i - 1) * 9) + 13) + $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])); /*858*/
			} /*858*/
			$k[$j++] = Infinity; /*873*/
			$k[$j++] = "ren"; /*865*/
			$k[$j++] = $0.renlinear; /*865*/
			$k[$j++] = "sbs"; /*865*/
			$k[$j++] = Infinity; /*865*/
			var _1I = $1.sbs; /*864*/
			for (var _1J = 0, _1K = _1I.length; _1J < _1K; _1J++) { /*864*/
				$k[$j++] = $get(_1I, _1J) - 48; /*864*/
			} /*864*/
			var _1M = $a(); /*865*/
			$k[$j++] = _1M; /*866*/
			$k[$j++] = "bhs"; /*866*/
			$k[$j++] = Infinity; /*866*/
			for (var _1N = 0, _1O = 16; _1N < _1O; _1N++) { /*865*/
				$k[$j++] = $1.height; /*865*/
			} /*865*/
			var _1Q = $a(); /*866*/
			$k[$j++] = _1Q; /*867*/
			$k[$j++] = "bbs"; /*867*/
			$k[$j++] = Infinity; /*867*/
			for (var _1R = 0, _1S = 16; _1R < _1S; _1R++) { /*866*/
				$k[$j++] = 0; /*866*/
			} /*866*/
			var _1T = $a(); /*867*/
			$k[$j++] = _1T; /*869*/
			if ($1.includetext) { /*869*/
				$k[$j++] = "txt"; /*868*/
				$k[$j++] = $1.txt; /*868*/
			} /*868*/
			$k[$j++] = "opt"; /*873*/
			$k[$j++] = $1.options; /*873*/
			$k[$j++] = "guardrightpos"; /*873*/
			$k[$j++] = 10; /*873*/
			$k[$j++] = "guardrightypos"; /*873*/
			$k[$j++] = $1.textyoffset + 4; /*873*/
			$k[$j++] = "bordertop"; /*873*/
			$k[$j++] = 10; /*873*/
			var _1Y = $d(); /*873*/
			$k[$j++] = _1Y; /*876*/
			if (!$1.dontdraw) { /*876*/
				$0.renlinear(); /*876*/
			} /*876*/
		};
		$0.ean2 = function() {
			var $1 = {}; /*903*/
			$1.options = $k[--$j]; /*905*/
			$1.barcode = $k[--$j]; /*906*/
			$1.dontdraw = false; /*908*/
			$1.includetext = false; /*909*/
			$1.textfont = "Helvetica"; /*910*/
			$1.textsize = 12; /*911*/
			$1.textxoffset = 0; /*912*/
			$1.textyoffset = "unset"; /*913*/
			$1.height = 0.7; /*914*/
			$forall($1.options, function() { /*925*/
				var _3 = $k[--$j]; /*925*/
				$1[$k[--$j]] = _3; /*925*/
			}); /*925*/
			$1.textfont = "" + $1.textfont; /*927*/
			$1.textsize = +$1.textsize; /*928*/
			$1.height = +$1.height; /*929*/
			$1.textxoffset = +$1.textxoffset; /*930*/
			if ($eq($1.textyoffset, "unset")) { /*934*/
				$1.textyoffset = ($1.height * 72) + 1; /*932*/
			} else { /*934*/
				$1.textyoffset = +$1.textyoffset; /*934*/
			} /*934*/
			if ($1.barcode.length != 2) { /*940*/
				$k[$j++] = "bwipp.ean2badLength"; /*939*/
				$k[$j++] = "EAN-2 add-on must be 2 digits"; /*939*/
				$0.raiseerror(); /*939*/
			} /*939*/
			$forall($1.barcode, function() { /*945*/
				var _E = $k[--$j]; /*942*/
				if ((_E < 48) || (_E > 57)) { /*944*/
					$k[$j++] = "bwipp.ean2badCharacter"; /*943*/
					$k[$j++] = "EAN-2 add-on must contain only digits"; /*943*/
					$0.raiseerror(); /*943*/
				} /*943*/
			}); /*943*/
			$1.encs = $a(["3211", "2221", "2122", "1411", "1132", "1231", "1114", "1312", "1213", "3112", "112", "11"]); /*952*/
			$1.barchars = "0123456789"; /*955*/
			$1.mirrormap = $get($a(["00", "01", "10", "11"]), (~~$z($geti($1.barcode, 0, 2))) % 4); /*958*/
			$1.sbs = $s(13); /*960*/
			$1.txt = $a(2); /*961*/
			for (var _M = 0; _M <= 1; _M += 1) { /*991*/
				$1.i = _M; /*964*/
				if ($1.i == 0) { /*970*/
					$puti($1.sbs, 0, $get($1.encs, 10)); /*968*/
				} else { /*970*/
					$puti($1.sbs, (($1.i - 1) * 6) + 7, $get($1.encs, 11)); /*970*/
				} /*970*/
				$search($1.barchars, $geti($1.barcode, $1.i, 1)); /*974*/
				$j--; /*975*/
				$1.indx = $k[--$j].length; /*976*/
				$j -= 2; /*977*/
				$1.enc = $get($1.encs, $1.indx); /*978*/
				if ($get($1.mirrormap, $1.i) == 49) { /*988*/
					$1.enclen = $1.enc.length; /*980*/
					$1.revenc = $s($1.enclen); /*981*/
					for (var _l = 0, _k = $1.enclen - 1; _l <= _k; _l += 1) { /*986*/
						$1.j = _l; /*983*/
						$1.char = $get($1.enc, $1.j); /*984*/
						$put($1.revenc, ($1.enclen - $1.j) - 1, $1.char); /*985*/
					} /*985*/
					$1.enc = $1.revenc; /*987*/
				} /*987*/
				$puti($1.sbs, ($1.i * 6) + 3, $1.enc); /*989*/
				$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), ((($1.i - 1) * 9) + 13) + $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])); /*990*/
			} /*990*/
			$k[$j++] = Infinity; /*1005*/
			$k[$j++] = "ren"; /*997*/
			$k[$j++] = $0.renlinear; /*997*/
			$k[$j++] = "sbs"; /*997*/
			$k[$j++] = Infinity; /*997*/
			var _18 = $1.sbs; /*996*/
			for (var _19 = 0, _1A = _18.length; _19 < _1A; _19++) { /*996*/
				$k[$j++] = $get(_18, _19) - 48; /*996*/
			} /*996*/
			var _1C = $a(); /*997*/
			$k[$j++] = _1C; /*998*/
			$k[$j++] = "bhs"; /*998*/
			$k[$j++] = Infinity; /*998*/
			for (var _1D = 0, _1E = 12; _1D < _1E; _1D++) { /*997*/
				$k[$j++] = $1.height; /*997*/
			} /*997*/
			var _1G = $a(); /*998*/
			$k[$j++] = _1G; /*999*/
			$k[$j++] = "bbs"; /*999*/
			$k[$j++] = Infinity; /*999*/
			for (var _1H = 0, _1I = 12; _1H < _1I; _1H++) { /*998*/
				$k[$j++] = 0; /*998*/
			} /*998*/
			var _1J = $a(); /*999*/
			$k[$j++] = _1J; /*1001*/
			if ($1.includetext) { /*1001*/
				$k[$j++] = "txt"; /*1000*/
				$k[$j++] = $1.txt; /*1000*/
			} /*1000*/
			$k[$j++] = "opt"; /*1005*/
			$k[$j++] = $1.options; /*1005*/
			$k[$j++] = "guardrightpos"; /*1005*/
			$k[$j++] = 10; /*1005*/
			$k[$j++] = "guardrightypos"; /*1005*/
			$k[$j++] = $1.textyoffset + 4; /*1005*/
			$k[$j++] = "bordertop"; /*1005*/
			$k[$j++] = 10; /*1005*/
			var _1O = $d(); /*1005*/
			$k[$j++] = _1O; /*1008*/
			if (!$1.dontdraw) { /*1008*/
				$0.renlinear(); /*1008*/
			} /*1008*/
		};
		$0.ean13 = function() {
			var $1 = {}; /*1037*/
			$1.options = $k[--$j]; /*1039*/
			$1.barcode = $k[--$j]; /*1040*/
			$1.dontdraw = false; /*1042*/
			$1.includetext = false; /*1043*/
			$1.textfont = "Helvetica"; /*1044*/
			$1.textsize = 12; /*1045*/
			$1.textxoffset = -10; /*1046*/
			$1.textyoffset = -4.5; /*1047*/
			$1.height = 1; /*1048*/
			$1.addongap = 12; /*1049*/
			$1.addontextfont = "unset"; /*1050*/
			$1.addontextsize = "unset"; /*1051*/
			$1.addontextxoffset = "unset"; /*1052*/
			$1.addontextyoffset = "unset"; /*1053*/
			$forall($1.options, function() { /*1064*/
				var _3 = $k[--$j]; /*1064*/
				$1[$k[--$j]] = _3; /*1064*/
			}); /*1064*/
			$1.textfont = "" + $1.textfont; /*1066*/
			$1.textsize = +$1.textsize; /*1067*/
			$1.textxoffset = +$1.textxoffset; /*1068*/
			$1.textyoffset = +$1.textyoffset; /*1069*/
			$1.height = +$1.height; /*1070*/
			$1.addongap = +$1.addongap; /*1071*/
			if ($ne($1.addontextfont, "unset")) { /*1072*/
				$1.addontextfont = "" + $1.addontextfont; /*1072*/
			} /*1072*/
			if ($ne($1.addontextsize, "unset")) { /*1073*/
				$1.addontextsize = +$1.addontextsize; /*1073*/
			} /*1073*/
			if ($ne($1.addontextxoffset, "unset")) { /*1074*/
				$1.addontextxoffset = +$1.addontextxoffset; /*1074*/
			} /*1074*/
			if ($ne($1.addontextyoffset, "unset")) { /*1075*/
				$1.addontextyoffset = +$1.addontextyoffset; /*1075*/
			} /*1075*/
			$search($1.barcode, " "); /*1078*/
			if ($k[--$j]) { /*1084*/
				$1.barcode = $k[--$j]; /*1079*/
				$j--; /*1080*/
				$1.addon = $k[--$j]; /*1081*/
			} else { /*1084*/
				$j--; /*1083*/
				$1.addon = ""; /*1084*/
			} /*1084*/
			if (($1.barcode.length != 12) && ($1.barcode.length != 13)) { /*1090*/
				$k[$j++] = "bwipp.ean13badLength"; /*1089*/
				$k[$j++] = "EAN-13 must be 12 or 13 digits"; /*1089*/
				$0.raiseerror(); /*1089*/
			} /*1089*/
			$forall($1.barcode, function() { /*1095*/
				var _Q = $k[--$j]; /*1092*/
				if ((_Q < 48) || (_Q > 57)) { /*1094*/
					$k[$j++] = "bwipp.ean13badCharacter"; /*1093*/
					$k[$j++] = "EAN-13 must contain only digits"; /*1093*/
					$0.raiseerror(); /*1093*/
				} /*1093*/
			}); /*1093*/
			if ((($1.addon.length != 0) && ($1.addon.length != 2)) && ($1.addon.length != 5)) { /*1098*/
				$k[$j++] = "bwipp.ean13badAddOnLength"; /*1097*/
				$k[$j++] = "Add-on for EAN-13 must be 2 or 5 digits"; /*1097*/
				$0.raiseerror(); /*1097*/
			} /*1097*/
			$1.pad = $s(13); /*1101*/
			$1.checksum = 0; /*1102*/
			for (var _V = 0; _V <= 11; _V += 1) { /*1111*/
				$1.i = _V; /*1104*/
				$1.barchar = $get($1.barcode, $1.i) - 48; /*1105*/
				if (($1.i % 2) == 0) { /*1109*/
					$1.checksum = $1.barchar + $1.checksum; /*1107*/
				} else { /*1109*/
					$1.checksum = ($1.barchar * 3) + $1.checksum; /*1109*/
				} /*1109*/
			} /*1109*/
			$1.checksum = (10 - ($1.checksum % 10)) % 10; /*1112*/
			if ($1.barcode.length == 13) { /*1117*/
				if ($get($1.barcode, 12) != ($1.checksum + 48)) { /*1116*/
					$k[$j++] = "bwipp.ean13badCheckDigit"; /*1115*/
					$k[$j++] = "Incorrect EAN-13 check digit provided"; /*1115*/
					$0.raiseerror(); /*1115*/
				} /*1115*/
			} /*1115*/
			$puti($1.pad, 0, $1.barcode); /*1118*/
			$put($1.pad, 12, $1.checksum + 48); /*1119*/
			$1.barcode = $1.pad; /*1120*/
			$1.encs = $a(["3211", "2221", "2122", "1411", "1132", "1231", "1114", "1312", "1213", "3112", "111", "11111", "111"]); /*1127*/
			$1.barchars = "0123456789"; /*1130*/
			$1.mirrormaps = $a(["000000", "001011", "001101", "001110", "010011", "011001", "011100", "010101", "010110", "011010"]); /*1136*/
			$1.sbs = $s(59); /*1138*/
			$1.txt = $a(13); /*1139*/
			$puti($1.sbs, 0, $get($1.encs, 10)); /*1142*/
			$1.mirrormap = $get($1.mirrormaps, $get($1.barcode, 0) - 48); /*1145*/
			$put($1.txt, 0, $a([$geti($1.barcode, 0, 1), $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])); /*1146*/
			for (var _17 = 1; _17 <= 6; _17 += 1) { /*1169*/
				$1.i = _17; /*1151*/
				$search($1.barchars, $geti($1.barcode, $1.i, 1)); /*1152*/
				$j--; /*1153*/
				$1.indx = $k[--$j].length; /*1154*/
				$j -= 2; /*1155*/
				$1.enc = $get($1.encs, $1.indx); /*1156*/
				if ($get($1.mirrormap, $1.i - 1) == 49) { /*1166*/
					$1.enclen = $1.enc.length; /*1158*/
					$1.revenc = $s($1.enclen); /*1159*/
					for (var _1O = 0, _1N = $1.enclen - 1; _1O <= _1N; _1O += 1) { /*1164*/
						$1.j = _1O; /*1161*/
						$1.char = $get($1.enc, $1.j); /*1162*/
						$put($1.revenc, ($1.enclen - $1.j) - 1, $1.char); /*1163*/
					} /*1163*/
					$1.enc = $1.revenc; /*1165*/
				} /*1165*/
				$puti($1.sbs, (($1.i - 1) * 4) + 3, $1.enc); /*1167*/
				$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), ((($1.i - 1) * 7) + 14) + $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])); /*1168*/
			} /*1168*/
			$puti($1.sbs, ((7 - 1) * 4) + 3, $get($1.encs, 11)); /*1172*/
			for (var _1o = 7; _1o <= 12; _1o += 1) { /*1185*/
				$1.i = _1o; /*1177*/
				$search($1.barchars, $geti($1.barcode, $1.i, 1)); /*1178*/
				$j--; /*1179*/
				$1.indx = $k[--$j].length; /*1180*/
				$j -= 2; /*1181*/
				$1.enc = $get($1.encs, $1.indx); /*1182*/
				$puti($1.sbs, (($1.i - 1) * 4) + 8, $1.enc); /*1183*/
				$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), ((($1.i - 1) * 7) + 18) + $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])); /*1184*/
			} /*1184*/
			$puti($1.sbs, 56, $get($1.encs, 12)); /*1188*/
			$k[$j++] = Infinity; /*1190*/
			var _2E = $1.sbs; /*1190*/
			for (var _2F = 0, _2G = _2E.length; _2F < _2G; _2F++) { /*1190*/
				$k[$j++] = $get(_2E, _2F) - 48; /*1190*/
			} /*1190*/
			$1.sbs = $a(); /*1190*/
			if ($1.includetext) { /*1197*/
				$k[$j++] = Infinity; /*1192*/
				$k[$j++] = $1.height; /*1192*/
				$k[$j++] = $1.height; /*1192*/
				for (var _2M = 0, _2N = 12; _2M < _2N; _2M++) { /*1192*/
					$k[$j++] = $1.height - 0.075; /*1192*/
				} /*1192*/
				$k[$j++] = $1.height; /*1192*/
				$k[$j++] = $1.height; /*1192*/
				for (var _2R = 0, _2S = 12; _2R < _2S; _2R++) { /*1192*/
					$k[$j++] = $1.height - 0.075; /*1192*/
				} /*1192*/
				$k[$j++] = $1.height; /*1192*/
				$k[$j++] = $1.height; /*1192*/
				$1.bhs = $a(); /*1192*/
				$k[$j++] = Infinity; /*1193*/
				$k[$j++] = 0; /*1193*/
				$k[$j++] = 0; /*1193*/
				for (var _2X = 0, _2Y = 12; _2X < _2Y; _2X++) { /*1193*/
					$k[$j++] = 0.075; /*1193*/
				} /*1193*/
				$k[$j++] = 0; /*1193*/
				$k[$j++] = 0; /*1193*/
				for (var _2Z = 0, _2a = 12; _2Z < _2a; _2Z++) { /*1193*/
					$k[$j++] = 0.075; /*1193*/
				} /*1193*/
				$k[$j++] = 0; /*1193*/
				$k[$j++] = 0; /*1193*/
				$1.bbs = $a(); /*1193*/
			} else { /*1197*/
				$k[$j++] = Infinity; /*1195*/
				for (var _2c = 0, _2d = 30; _2c < _2d; _2c++) { /*1195*/
					$k[$j++] = $1.height; /*1195*/
				} /*1195*/
				$1.bhs = $a(); /*1195*/
				$k[$j++] = Infinity; /*1196*/
				for (var _2g = 0, _2h = 30; _2g < _2h; _2g++) { /*1196*/
					$k[$j++] = 0; /*1196*/
				} /*1196*/
				$1.bbs = $a(); /*1196*/
				$1.txt = $a([]); /*1197*/
			} /*1197*/
			$1.guardrightypos = 0; /*1199*/
			if ($ne($1.addon, "")) { /*1220*/
				$k[$j++] = "addopts"; /*1210*/
				$k[$j++] = Infinity; /*1210*/
				$k[$j++] = "dontdraw"; /*1207*/
				$k[$j++] = true; /*1207*/
				$k[$j++] = "includetext"; /*1207*/
				$k[$j++] = true; /*1207*/
				$k[$j++] = "height"; /*1207*/
				$k[$j++] = $1.height - 0.15; /*1207*/
				$k[$j++] = "textxoffset"; /*1207*/
				if ($1.addontextxoffset != "unset") { /*1207*/
					$k[$j++] = $1.addontextxoffset; /*1207*/
				} else { /*1207*/
					$k[$j++] = 95 + $1.addongap; /*1207*/
				} /*1207*/
				if ($1.addontextyoffset != "unset") { /*1208*/
					$k[$j++] = "textyoffset"; /*1208*/
					$k[$j++] = $1.addontextyoffset; /*1208*/
				} /*1208*/
				var _2s = ($1.addontextsize != "unset") ? $1.addontextsize : $1.textsize; /*1209*/
				var _2u = $ne($1.addontextfont, "unset") ? $1.addontextfont : $1.textfont; /*1210*/
				$k[$j++] = "textsize"; /*1210*/
				$k[$j++] = _2s; /*1210*/
				$k[$j++] = "textfont"; /*1210*/
				$k[$j++] = _2u; /*1210*/
				var _2v = $d(); /*1210*/
				$1[$k[--$j]] = _2v; /*1211*/
				if ($1.addon.length == 2) { /*1212*/
					$k[$j++] = $1.addon; /*1212*/
					$k[$j++] = $1.addopts; /*1212*/
					$0.ean2(); /*1212*/
				} /*1212*/
				if ($1.addon.length == 5) { /*1213*/
					$k[$j++] = $1.addon; /*1213*/
					$k[$j++] = $1.addopts; /*1213*/
					$0.ean5(); /*1213*/
				} /*1213*/
				$1.addcode = $k[--$j]; /*1214*/
				$k[$j++] = Infinity; /*1215*/
				$aload($1.sbs); /*1215*/
				$k[$j++] = $1.addongap; /*1215*/
				$aload($1.addcode.sbs); /*1215*/
				$1.sbs = $a(); /*1215*/
				$k[$j++] = Infinity; /*1216*/
				$aload($1.bhs); /*1216*/
				$forall($1.addcode.bhs, function() { /*1216*/
					var _3C = $k[--$j]; /*1216*/
					$k[$j++] = _3C - 0.075; /*1216*/
				}); /*1216*/
				$1.bhs = $a(); /*1216*/
				$k[$j++] = Infinity; /*1217*/
				$aload($1.bbs); /*1217*/
				$forall($1.addcode.bbs, function() { /*1217*/
					var _3H = $k[--$j]; /*1217*/
					$k[$j++] = _3H + 0.075; /*1217*/
				}); /*1217*/
				$1.bbs = $a(); /*1217*/
				$k[$j++] = Infinity; /*1218*/
				$aload($1.txt); /*1218*/
				$aload($1.addcode.txt); /*1218*/
				$1.txt = $a(); /*1218*/
				$1.guardrightypos = ($1.height * 72) - 6; /*1219*/
			} /*1219*/
			var _3U = {
				ren: $0.renlinear,
				sbs: $1.sbs,
				bhs: $1.bhs,
				bbs: $1.bbs,
				txt: $1.txt,
				opt: $1.options,
				guardrightpos: 10,
				guardrightypos: $1.guardrightypos,
				borderbottom: 5
			}; /*1232*/
			$k[$j++] = _3U; /*1235*/
			if (!$1.dontdraw) { /*1235*/
				$0.renlinear(); /*1235*/
			} /*1235*/
		};
		$0.ean8 = function() {
			var $1 = {}; /*1264*/
			$1.options = $k[--$j]; /*1266*/
			$1.barcode = $k[--$j]; /*1267*/
			$1.dontdraw = false; /*1269*/
			$1.includetext = false; /*1270*/
			$1.textfont = "Helvetica"; /*1271*/
			$1.textsize = 12; /*1272*/
			$1.textxoffset = 4; /*1273*/
			$1.textyoffset = -4.5; /*1274*/
			$1.height = 1; /*1275*/
			$1.addongap = 12; /*1276*/
			$1.addontextfont = "unset"; /*1277*/
			$1.addontextsize = "unset"; /*1278*/
			$1.addontextxoffset = "unset"; /*1279*/
			$1.addontextyoffset = "unset"; /*1280*/
			$forall($1.options, function() { /*1291*/
				var _3 = $k[--$j]; /*1291*/
				$1[$k[--$j]] = _3; /*1291*/
			}); /*1291*/
			$1.textfont = "" + $1.textfont; /*1293*/
			$1.textsize = +$1.textsize; /*1294*/
			$1.textxoffset = +$1.textxoffset; /*1295*/
			$1.textyoffset = +$1.textyoffset; /*1296*/
			$1.height = +$1.height; /*1297*/
			$1.addongap = +$1.addongap; /*1298*/
			if ($ne($1.addontextfont, "unset")) { /*1299*/
				$1.addontextfont = "" + $1.addontextfont; /*1299*/
			} /*1299*/
			if ($ne($1.addontextsize, "unset")) { /*1300*/
				$1.addontextsize = +$1.addontextsize; /*1300*/
			} /*1300*/
			if ($ne($1.addontextxoffset, "unset")) { /*1301*/
				$1.addontextxoffset = +$1.addontextxoffset; /*1301*/
			} /*1301*/
			if ($ne($1.addontextyoffset, "unset")) { /*1302*/
				$1.addontextyoffset = +$1.addontextyoffset; /*1302*/
			} /*1302*/
			$search($1.barcode, " "); /*1305*/
			if ($k[--$j]) { /*1311*/
				$1.barcode = $k[--$j]; /*1306*/
				$j--; /*1307*/
				$1.addon = $k[--$j]; /*1308*/
			} else { /*1311*/
				$j--; /*1310*/
				$1.addon = ""; /*1311*/
			} /*1311*/
			if (($1.barcode.length != 7) && ($1.barcode.length != 8)) { /*1317*/
				$k[$j++] = "bwipp.ean8badLength"; /*1316*/
				$k[$j++] = "EAN-8 must be 7 or 8 digits"; /*1316*/
				$0.raiseerror(); /*1316*/
			} /*1316*/
			$forall($1.barcode, function() { /*1322*/
				var _Q = $k[--$j]; /*1319*/
				if ((_Q < 48) || (_Q > 57)) { /*1321*/
					$k[$j++] = "bwipp.ean8badCharacter"; /*1320*/
					$k[$j++] = "EAN-8 must contain only digits"; /*1320*/
					$0.raiseerror(); /*1320*/
				} /*1320*/
			}); /*1320*/
			if ((($1.addon.length != 0) && ($1.addon.length != 2)) && ($1.addon.length != 5)) { /*1325*/
				$k[$j++] = "bwipp.ean8badAddOnLength"; /*1324*/
				$k[$j++] = "Add-on for EAN-8 must be 2 or 5 digits"; /*1324*/
				$0.raiseerror(); /*1324*/
			} /*1324*/
			$1.pad = $s(8); /*1328*/
			$1.checksum = 0; /*1329*/
			for (var _V = 0; _V <= 6; _V += 1) { /*1338*/
				$1.i = _V; /*1331*/
				$1.barchar = $get($1.barcode, $1.i) - 48; /*1332*/
				if (($1.i % 2) != 0) { /*1336*/
					$1.checksum = $1.barchar + $1.checksum; /*1334*/
				} else { /*1336*/
					$1.checksum = ($1.barchar * 3) + $1.checksum; /*1336*/
				} /*1336*/
			} /*1336*/
			$1.checksum = (10 - ($1.checksum % 10)) % 10; /*1339*/
			if ($1.barcode.length == 8) { /*1344*/
				if ($get($1.barcode, 7) != ($1.checksum + 48)) { /*1343*/
					$k[$j++] = "bwipp.ean8badCheckDigit"; /*1342*/
					$k[$j++] = "Incorrect EAN-8 check digit provided"; /*1342*/
					$0.raiseerror(); /*1342*/
				} /*1342*/
			} /*1342*/
			$puti($1.pad, 0, $1.barcode); /*1345*/
			$put($1.pad, 7, $1.checksum + 48); /*1346*/
			$1.barcode = $1.pad; /*1347*/
			$1.encs = $a(["3211", "2221", "2122", "1411", "1132", "1231", "1114", "1312", "1213", "3112", "111", "11111", "111"]); /*1354*/
			$1.barchars = "0123456789"; /*1357*/
			$1.sbs = $s(43); /*1359*/
			$1.txt = $a(8); /*1360*/
			$puti($1.sbs, 0, $get($1.encs, 10)); /*1363*/
			for (var _u = 0; _u <= 3; _u += 1) { /*1376*/
				$1.i = _u; /*1368*/
				$search($1.barchars, $geti($1.barcode, $1.i, 1)); /*1369*/
				$j--; /*1370*/
				$1.indx = $k[--$j].length; /*1371*/
				$j -= 2; /*1372*/
				$1.enc = $get($1.encs, $1.indx); /*1373*/
				$puti($1.sbs, ($1.i * 4) + 3, $1.enc); /*1374*/
				$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), ($1.i * 7) + $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])); /*1375*/
			} /*1375*/
			$puti($1.sbs, (4 * 4) + 3, $get($1.encs, 11)); /*1379*/
			for (var _1K = 4; _1K <= 7; _1K += 1) { /*1392*/
				$1.i = _1K; /*1384*/
				$search($1.barchars, $geti($1.barcode, $1.i, 1)); /*1385*/
				$j--; /*1386*/
				$1.indx = $k[--$j].length; /*1387*/
				$j -= 2; /*1388*/
				$1.enc = $get($1.encs, $1.indx); /*1389*/
				$puti($1.sbs, ($1.i * 4) + 8, $1.enc); /*1390*/
				$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), (($1.i * 7) + $1.textxoffset) + 4, $1.textyoffset, $1.textfont, $1.textsize])); /*1391*/
			} /*1391*/
			$puti($1.sbs, 40, $get($1.encs, 12)); /*1395*/
			$k[$j++] = Infinity; /*1397*/
			var _1k = $1.sbs; /*1397*/
			for (var _1l = 0, _1m = _1k.length; _1l < _1m; _1l++) { /*1397*/
				$k[$j++] = $get(_1k, _1l) - 48; /*1397*/
			} /*1397*/
			$1.sbs = $a(); /*1397*/
			if ($1.includetext) { /*1404*/
				$k[$j++] = Infinity; /*1399*/
				$k[$j++] = $1.height; /*1399*/
				$k[$j++] = $1.height; /*1399*/
				for (var _1s = 0, _1t = 8; _1s < _1t; _1s++) { /*1399*/
					$k[$j++] = $1.height - 0.075; /*1399*/
				} /*1399*/
				$k[$j++] = $1.height; /*1399*/
				$k[$j++] = $1.height; /*1399*/
				for (var _1x = 0, _1y = 8; _1x < _1y; _1x++) { /*1399*/
					$k[$j++] = $1.height - 0.075; /*1399*/
				} /*1399*/
				$k[$j++] = $1.height; /*1399*/
				$k[$j++] = $1.height; /*1399*/
				$1.bhs = $a(); /*1399*/
				$k[$j++] = Infinity; /*1400*/
				$k[$j++] = 0; /*1400*/
				$k[$j++] = 0; /*1400*/
				for (var _23 = 0, _24 = 8; _23 < _24; _23++) { /*1400*/
					$k[$j++] = 0.075; /*1400*/
				} /*1400*/
				$k[$j++] = 0; /*1400*/
				$k[$j++] = 0; /*1400*/
				for (var _25 = 0, _26 = 8; _25 < _26; _25++) { /*1400*/
					$k[$j++] = 0.075; /*1400*/
				} /*1400*/
				$k[$j++] = 0; /*1400*/
				$k[$j++] = 0; /*1400*/
				$1.bbs = $a(); /*1400*/
			} else { /*1404*/
				$k[$j++] = Infinity; /*1402*/
				for (var _28 = 0, _29 = 22; _28 < _29; _28++) { /*1402*/
					$k[$j++] = $1.height; /*1402*/
				} /*1402*/
				$1.bhs = $a(); /*1402*/
				$k[$j++] = Infinity; /*1403*/
				for (var _2C = 0, _2D = 22; _2C < _2D; _2C++) { /*1403*/
					$k[$j++] = 0; /*1403*/
				} /*1403*/
				$1.bbs = $a(); /*1403*/
				$1.txt = $a([]); /*1404*/
			} /*1404*/
			$1.guardrightypos = 0; /*1406*/
			if ($ne($1.addon, "")) { /*1427*/
				$k[$j++] = "addopts"; /*1417*/
				$k[$j++] = Infinity; /*1417*/
				$k[$j++] = "dontdraw"; /*1414*/
				$k[$j++] = true; /*1414*/
				$k[$j++] = "includetext"; /*1414*/
				$k[$j++] = true; /*1414*/
				$k[$j++] = "height"; /*1414*/
				$k[$j++] = $1.height - 0.15; /*1414*/
				$k[$j++] = "textxoffset"; /*1414*/
				if ($1.addontextxoffset != "unset") { /*1414*/
					$k[$j++] = $1.addontextxoffset; /*1414*/
				} else { /*1414*/
					$k[$j++] = 67 + $1.addongap; /*1414*/
				} /*1414*/
				if ($1.addontextyoffset != "unset") { /*1415*/
					$k[$j++] = "textyoffset"; /*1415*/
					$k[$j++] = $1.addontextyoffset; /*1415*/
				} /*1415*/
				var _2O = ($1.addontextsize != "unset") ? $1.addontextsize : $1.textsize; /*1416*/
				var _2Q = $ne($1.addontextfont, "unset") ? $1.addontextfont : $1.textfont; /*1417*/
				$k[$j++] = "textsize"; /*1417*/
				$k[$j++] = _2O; /*1417*/
				$k[$j++] = "textfont"; /*1417*/
				$k[$j++] = _2Q; /*1417*/
				var _2R = $d(); /*1417*/
				$1[$k[--$j]] = _2R; /*1418*/
				if ($1.addon.length == 2) { /*1419*/
					$k[$j++] = $1.addon; /*1419*/
					$k[$j++] = $1.addopts; /*1419*/
					$0.ean2(); /*1419*/
				} /*1419*/
				if ($1.addon.length == 5) { /*1420*/
					$k[$j++] = $1.addon; /*1420*/
					$k[$j++] = $1.addopts; /*1420*/
					$0.ean5(); /*1420*/
				} /*1420*/
				$1.addcode = $k[--$j]; /*1421*/
				$k[$j++] = Infinity; /*1422*/
				$aload($1.sbs); /*1422*/
				$k[$j++] = $1.addongap; /*1422*/
				$aload($1.addcode.sbs); /*1422*/
				$1.sbs = $a(); /*1422*/
				$k[$j++] = Infinity; /*1423*/
				$aload($1.bhs); /*1423*/
				$forall($1.addcode.bhs, function() { /*1423*/
					var _2i = $k[--$j]; /*1423*/
					$k[$j++] = _2i - 0.075; /*1423*/
				}); /*1423*/
				$1.bhs = $a(); /*1423*/
				$k[$j++] = Infinity; /*1424*/
				$aload($1.bbs); /*1424*/
				$forall($1.addcode.bbs, function() { /*1424*/
					var _2n = $k[--$j]; /*1424*/
					$k[$j++] = _2n + 0.075; /*1424*/
				}); /*1424*/
				$1.bbs = $a(); /*1424*/
				$k[$j++] = Infinity; /*1425*/
				$aload($1.txt); /*1425*/
				$aload($1.addcode.txt); /*1425*/
				$1.txt = $a(); /*1425*/
				$1.guardrightypos = ($1.height * 72) - 6; /*1426*/
			} /*1426*/
			var _30 = {
				ren: $0.renlinear,
				sbs: $1.sbs,
				bhs: $1.bhs,
				bbs: $1.bbs,
				txt: $1.txt,
				opt: $1.options,
				guardleftpos: 10,
				guardrightpos: 10,
				guardrightypos: $1.guardrightypos,
				borderbottom: 5
			}; /*1440*/
			$k[$j++] = _30; /*1443*/
			if (!$1.dontdraw) { /*1443*/
				$0.renlinear(); /*1443*/
			} /*1443*/
		};
		$0.upca = function() {
			var $1 = {}; /*1472*/
			$1.options = $k[--$j]; /*1474*/
			$1.barcode = $k[--$j]; /*1475*/
			$1.dontdraw = false; /*1477*/
			$1.includetext = false; /*1478*/
			$1.textfont = "Helvetica"; /*1479*/
			$1.textsize = 12; /*1480*/
			$1.textxoffset = -7; /*1481*/
			$1.textyoffset = -4.5; /*1482*/
			$1.height = 1; /*1483*/
			$1.addongap = 12; /*1484*/
			$1.addontextfont = "unset"; /*1485*/
			$1.addontextsize = "unset"; /*1486*/
			$1.addontextxoffset = "unset"; /*1487*/
			$1.addontextyoffset = "unset"; /*1488*/
			$forall($1.options, function() { /*1499*/
				var _3 = $k[--$j]; /*1499*/
				$1[$k[--$j]] = _3; /*1499*/
			}); /*1499*/
			$1.textfont = "" + $1.textfont; /*1501*/
			$1.textsize = +$1.textsize; /*1502*/
			$1.textxoffset = +$1.textxoffset; /*1503*/
			$1.textyoffset = +$1.textyoffset; /*1504*/
			$1.height = +$1.height; /*1505*/
			$1.addongap = +$1.addongap; /*1506*/
			if ($ne($1.addontextfont, "unset")) { /*1507*/
				$1.addontextfont = "" + $1.addontextfont; /*1507*/
			} /*1507*/
			if ($ne($1.addontextsize, "unset")) { /*1508*/
				$1.addontextsize = +$1.addontextsize; /*1508*/
			} /*1508*/
			if ($ne($1.addontextxoffset, "unset")) { /*1509*/
				$1.addontextxoffset = +$1.addontextxoffset; /*1509*/
			} /*1509*/
			if ($ne($1.addontextyoffset, "unset")) { /*1510*/
				$1.addontextyoffset = +$1.addontextyoffset; /*1510*/
			} /*1510*/
			$search($1.barcode, " "); /*1513*/
			if ($k[--$j]) { /*1519*/
				$1.barcode = $k[--$j]; /*1514*/
				$j--; /*1515*/
				$1.addon = $k[--$j]; /*1516*/
			} else { /*1519*/
				$j--; /*1518*/
				$1.addon = ""; /*1519*/
			} /*1519*/
			if (($1.barcode.length == 7) || ($1.barcode.length == 8)) { /*1565*/
				$forall($1.barcode, function() { /*1529*/
					var _Q = $k[--$j]; /*1526*/
					if ((_Q < 48) || (_Q > 57)) { /*1528*/
						$k[$j++] = "bwipp.upcAupcEbadCharacter"; /*1527*/
						$k[$j++] = "UPC-E must contain only digits"; /*1527*/
						$0.raiseerror(); /*1527*/
					} /*1527*/
				}); /*1527*/
				var _S = $get($1.barcode, 0); /*1530*/
				if ((_S != 48) && (_S != 49)) { /*1532*/
					$k[$j++] = "bwipp.upcAupcEbadNumberSystem"; /*1531*/
					$k[$j++] = "UPC-E must have number system 0 or 1"; /*1531*/
					$0.raiseerror(); /*1531*/
				} /*1531*/
				for (var _T = 0, _U = 1; _T < _U; _T++) { /*1560*/
					var _W = ($1.barcode.length == 8) ? 12 : 11; /*1534*/
					$1.upcacode = $s(_W); /*1534*/
					if (($get($1.barcode, 6) - 48) <= 2) { /*1541*/
						$puti($1.upcacode, 0, $geti($1.barcode, 0, 3)); /*1536*/
						$puti($1.upcacode, 3, $geti($1.barcode, 6, 1)); /*1537*/
						$puti($1.upcacode, 4, "0000"); /*1538*/
						$puti($1.upcacode, 8, $geti($1.barcode, 3, 3)); /*1539*/
						break; /*1540*/
					} /*1540*/
					if (($get($1.barcode, 6) - 48) == 3) { /*1547*/
						$puti($1.upcacode, 0, $geti($1.barcode, 0, 4)); /*1543*/
						$puti($1.upcacode, 4, "00000"); /*1544*/
						$puti($1.upcacode, 9, $geti($1.barcode, 4, 2)); /*1545*/
						break; /*1546*/
					} /*1546*/
					if (($get($1.barcode, 6) - 48) == 4) { /*1553*/
						$puti($1.upcacode, 0, $geti($1.barcode, 0, 5)); /*1549*/
						$puti($1.upcacode, 5, "00000"); /*1550*/
						$puti($1.upcacode, 10, $geti($1.barcode, 5, 1)); /*1551*/
						break; /*1552*/
					} /*1552*/
					if (($get($1.barcode, 6) - 48) >= 5) { /*1559*/
						$puti($1.upcacode, 0, $geti($1.barcode, 0, 6)); /*1555*/
						$puti($1.upcacode, 6, "0000"); /*1556*/
						$puti($1.upcacode, 10, $geti($1.barcode, 6, 1)); /*1557*/
						break; /*1558*/
					} /*1558*/
				} /*1558*/
				if ($1.barcode.length == 8) { /*1563*/
					$puti($1.upcacode, 11, $geti($1.barcode, 7, 1)); /*1562*/
				} /*1562*/
				$1.barcode = $1.upcacode; /*1564*/
			} /*1564*/
			if (($1.barcode.length != 11) && ($1.barcode.length != 12)) { /*1570*/
				$k[$j++] = "bwipp.upcAbadLength"; /*1569*/
				$k[$j++] = "UPC-A must be 11 or 12 digits"; /*1569*/
				$0.raiseerror(); /*1569*/
			} /*1569*/
			var _1I = $1.barcode; /*1571*/
			for (var _1J = 0, _1K = _1I.length; _1J < _1K; _1J++) { /*1575*/
				var _1L = $get(_1I, _1J); /*1575*/
				if ((_1L < 48) || (_1L > 57)) { /*1574*/
					$k[$j++] = "bwipp.upcAbadCharacter"; /*1573*/
					$k[$j++] = "UPC-A must contain only digits"; /*1573*/
					$0.raiseerror(); /*1573*/
				} /*1573*/
			} /*1573*/
			if ((($1.addon.length != 0) && ($1.addon.length != 2)) && ($1.addon.length != 5)) { /*1578*/
				$k[$j++] = "bwipp.upcAbadAddOnLength"; /*1577*/
				$k[$j++] = "Add-on for UPC-A must be 2 or 5 digits"; /*1577*/
				$0.raiseerror(); /*1577*/
			} /*1577*/
			$1.pad = $s(12); /*1581*/
			$1.checksum = 0; /*1582*/
			for (var _1Q = 0; _1Q <= 10; _1Q += 1) { /*1591*/
				$1.i = _1Q; /*1584*/
				$1.barchar = $get($1.barcode, $1.i) - 48; /*1585*/
				if (($1.i % 2) != 0) { /*1589*/
					$1.checksum = $1.checksum + $1.barchar; /*1587*/
				} else { /*1589*/
					$1.checksum = $1.checksum + ($1.barchar * 3); /*1589*/
				} /*1589*/
			} /*1589*/
			$1.checksum = (10 - ($1.checksum % 10)) % 10; /*1592*/
			if ($1.barcode.length == 12) { /*1597*/
				if ($get($1.barcode, 11) != ($1.checksum + 48)) { /*1596*/
					$k[$j++] = "bwipp.upcAbadCheckDigit"; /*1595*/
					$k[$j++] = "Incorrect UPC check digit provided"; /*1595*/
					$0.raiseerror(); /*1595*/
				} /*1595*/
			} /*1595*/
			$puti($1.pad, 0, $1.barcode); /*1598*/
			$put($1.pad, 11, $1.checksum + 48); /*1599*/
			$1.barcode = $1.pad; /*1600*/
			$1.encs = $a(["3211", "2221", "2122", "1411", "1132", "1231", "1114", "1312", "1213", "3112", "111", "11111", "111"]); /*1607*/
			$1.barchars = "0123456789"; /*1610*/
			$1.sbs = $s(59); /*1612*/
			$1.txt = $a(12); /*1613*/
			$puti($1.sbs, 0, $get($1.encs, 10)); /*1616*/
			for (var _1p = 0; _1p <= 5; _1p += 1) { /*1633*/
				$1.i = _1p; /*1621*/
				$search($1.barchars, $geti($1.barcode, $1.i, 1)); /*1622*/
				$j--; /*1623*/
				$1.indx = $k[--$j].length; /*1624*/
				$j -= 2; /*1625*/
				$1.enc = $get($1.encs, $1.indx); /*1626*/
				$puti($1.sbs, ($1.i * 4) + 3, $1.enc); /*1627*/
				if ($1.i == 0) { /*1631*/
					$put($1.txt, 0, $a([$geti($1.barcode, 0, 1), $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize - 2])); /*1629*/
				} else { /*1631*/
					$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), (($1.i * 7) + 11) + $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])); /*1631*/
				} /*1631*/
			} /*1631*/
			$puti($1.sbs, (6 * 4) + 3, $get($1.encs, 11)); /*1636*/
			for (var _2O = 6; _2O <= 11; _2O += 1) { /*1653*/
				$1.i = _2O; /*1641*/
				$search($1.barchars, $geti($1.barcode, $1.i, 1)); /*1642*/
				$j--; /*1643*/
				$1.indx = $k[--$j].length; /*1644*/
				$j -= 2; /*1645*/
				$1.enc = $get($1.encs, $1.indx); /*1646*/
				$puti($1.sbs, ($1.i * 4) + 8, $1.enc); /*1647*/
				if ($1.i == 11) { /*1651*/
					$put($1.txt, 11, $a([$geti($1.barcode, 11, 1), $1.textxoffset + 103, $1.textyoffset, $1.textfont, $1.textsize - 2])); /*1649*/
				} else { /*1651*/
					$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), (($1.i * 7) + $1.textxoffset) + 15, $1.textyoffset, $1.textfont, $1.textsize])); /*1651*/
				} /*1651*/
			} /*1651*/
			$puti($1.sbs, 56, $get($1.encs, 12)); /*1656*/
			$k[$j++] = Infinity; /*1658*/
			var _2x = $1.sbs; /*1658*/
			for (var _2y = 0, _2z = _2x.length; _2y < _2z; _2y++) { /*1658*/
				$k[$j++] = $get(_2x, _2y) - 48; /*1658*/
			} /*1658*/
			$1.sbs = $a(); /*1658*/
			if ($1.includetext) { /*1665*/
				$k[$j++] = Infinity; /*1660*/
				for (var _33 = 0, _34 = 4; _33 < _34; _33++) { /*1660*/
					$k[$j++] = $1.height; /*1660*/
				} /*1660*/
				for (var _36 = 0, _37 = 10; _36 < _37; _36++) { /*1660*/
					$k[$j++] = $1.height - 0.075; /*1660*/
				} /*1660*/
				$k[$j++] = $1.height; /*1660*/
				$k[$j++] = $1.height; /*1660*/
				for (var _3B = 0, _3C = 10; _3B < _3C; _3B++) { /*1660*/
					$k[$j++] = $1.height - 0.075; /*1660*/
				} /*1660*/
				for (var _3E = 0, _3F = 4; _3E < _3F; _3E++) { /*1660*/
					$k[$j++] = $1.height; /*1660*/
				} /*1660*/
				$1.bhs = $a(); /*1660*/
				$k[$j++] = Infinity; /*1661*/
				$k[$j++] = 0; /*1661*/
				$k[$j++] = 0; /*1661*/
				$k[$j++] = 0; /*1661*/
				$k[$j++] = 0; /*1661*/
				for (var _3I = 0, _3J = 10; _3I < _3J; _3I++) { /*1661*/
					$k[$j++] = 0.075; /*1661*/
				} /*1661*/
				$k[$j++] = 0; /*1661*/
				$k[$j++] = 0; /*1661*/
				for (var _3K = 0, _3L = 10; _3K < _3L; _3K++) { /*1661*/
					$k[$j++] = 0.075; /*1661*/
				} /*1661*/
				$k[$j++] = 0; /*1661*/
				$k[$j++] = 0; /*1661*/
				$k[$j++] = 0; /*1661*/
				$k[$j++] = 0; /*1661*/
				$1.bbs = $a(); /*1661*/
			} else { /*1665*/
				$k[$j++] = Infinity; /*1663*/
				for (var _3N = 0, _3O = 30; _3N < _3O; _3N++) { /*1663*/
					$k[$j++] = $1.height; /*1663*/
				} /*1663*/
				$1.bhs = $a(); /*1663*/
				$k[$j++] = Infinity; /*1664*/
				for (var _3R = 0, _3S = 30; _3R < _3S; _3R++) { /*1664*/
					$k[$j++] = 0; /*1664*/
				} /*1664*/
				$1.bbs = $a(); /*1664*/
				$1.txt = $a([]); /*1665*/
			} /*1665*/
			$1.guardrightypos = 0; /*1667*/
			if ($ne($1.addon, "")) { /*1688*/
				$k[$j++] = "addopts"; /*1678*/
				$k[$j++] = Infinity; /*1678*/
				$k[$j++] = "dontdraw"; /*1675*/
				$k[$j++] = true; /*1675*/
				$k[$j++] = "includetext"; /*1675*/
				$k[$j++] = true; /*1675*/
				$k[$j++] = "height"; /*1675*/
				$k[$j++] = $1.height - 0.15; /*1675*/
				$k[$j++] = "textxoffset"; /*1675*/
				if ($1.addontextxoffset != "unset") { /*1675*/
					$k[$j++] = $1.addontextxoffset; /*1675*/
				} else { /*1675*/
					$k[$j++] = 95 + $1.addongap; /*1675*/
				} /*1675*/
				if ($1.addontextyoffset != "unset") { /*1676*/
					$k[$j++] = "textyoffset"; /*1676*/
					$k[$j++] = $1.addontextyoffset; /*1676*/
				} /*1676*/
				var _3d = ($1.addontextsize != "unset") ? $1.addontextsize : $1.textsize; /*1677*/
				var _3f = $ne($1.addontextfont, "unset") ? $1.addontextfont : $1.textfont; /*1678*/
				$k[$j++] = "textsize"; /*1678*/
				$k[$j++] = _3d; /*1678*/
				$k[$j++] = "textfont"; /*1678*/
				$k[$j++] = _3f; /*1678*/
				var _3g = $d(); /*1678*/
				$1[$k[--$j]] = _3g; /*1679*/
				if ($1.addon.length == 2) { /*1680*/
					$k[$j++] = $1.addon; /*1680*/
					$k[$j++] = $1.addopts; /*1680*/
					$0.ean2(); /*1680*/
				} /*1680*/
				if ($1.addon.length == 5) { /*1681*/
					$k[$j++] = $1.addon; /*1681*/
					$k[$j++] = $1.addopts; /*1681*/
					$0.ean5(); /*1681*/
				} /*1681*/
				$1.addcode = $k[--$j]; /*1682*/
				$k[$j++] = Infinity; /*1683*/
				$aload($1.sbs); /*1683*/
				$k[$j++] = $1.addongap; /*1683*/
				$aload($1.addcode.sbs); /*1683*/
				$1.sbs = $a(); /*1683*/
				$k[$j++] = Infinity; /*1684*/
				$aload($1.bhs); /*1684*/
				$forall($1.addcode.bhs, function() { /*1684*/
					var _3x = $k[--$j]; /*1684*/
					$k[$j++] = _3x - 0.075; /*1684*/
				}); /*1684*/
				$1.bhs = $a(); /*1684*/
				$k[$j++] = Infinity; /*1685*/
				$aload($1.bbs); /*1685*/
				$forall($1.addcode.bbs, function() { /*1685*/
					var _42 = $k[--$j]; /*1685*/
					$k[$j++] = _42 + 0.075; /*1685*/
				}); /*1685*/
				$1.bbs = $a(); /*1685*/
				$k[$j++] = Infinity; /*1686*/
				$aload($1.txt); /*1686*/
				$aload($1.addcode.txt); /*1686*/
				$1.txt = $a(); /*1686*/
				$1.guardrightypos = ($1.height * 72) - 6; /*1687*/
			} /*1687*/
			var _4F = {
				ren: $0.renlinear,
				sbs: $1.sbs,
				bhs: $1.bhs,
				bbs: $1.bbs,
				txt: $1.txt,
				opt: $1.options,
				guardrightpos: 10,
				guardrightypos: $1.guardrightypos,
				borderbottom: 5
			}; /*1700*/
			$k[$j++] = _4F; /*1703*/
			if (!$1.dontdraw) { /*1703*/
				$0.renlinear(); /*1703*/
			} /*1703*/
		};
		$0.upce = function() {
			var $1 = {}; /*1732*/
			$1.options = $k[--$j]; /*1734*/
			$1.barcode = $k[--$j]; /*1735*/
			$1.dontdraw = false; /*1737*/
			$1.includetext = false; /*1738*/
			$1.textfont = "Helvetica"; /*1739*/
			$1.textsize = 12; /*1740*/
			$1.textxoffset = -7; /*1741*/
			$1.textyoffset = -4.5; /*1742*/
			$1.height = 1; /*1743*/
			$1.addongap = 12; /*1744*/
			$1.addontextfont = "unset"; /*1745*/
			$1.addontextsize = "unset"; /*1746*/
			$1.addontextxoffset = "unset"; /*1747*/
			$1.addontextyoffset = "unset"; /*1748*/
			$forall($1.options, function() { /*1759*/
				var _3 = $k[--$j]; /*1759*/
				$1[$k[--$j]] = _3; /*1759*/
			}); /*1759*/
			$1.textfont = "" + $1.textfont; /*1761*/
			$1.textsize = +$1.textsize; /*1762*/
			$1.textxoffset = +$1.textxoffset; /*1763*/
			$1.textyoffset = +$1.textyoffset; /*1764*/
			$1.height = +$1.height; /*1765*/
			$1.addongap = +$1.addongap; /*1766*/
			if ($ne($1.addontextfont, "unset")) { /*1767*/
				$1.addontextfont = "" + $1.addontextfont; /*1767*/
			} /*1767*/
			if ($ne($1.addontextsize, "unset")) { /*1768*/
				$1.addontextsize = +$1.addontextsize; /*1768*/
			} /*1768*/
			if ($ne($1.addontextxoffset, "unset")) { /*1769*/
				$1.addontextxoffset = +$1.addontextxoffset; /*1769*/
			} /*1769*/
			if ($ne($1.addontextyoffset, "unset")) { /*1770*/
				$1.addontextyoffset = +$1.addontextyoffset; /*1770*/
			} /*1770*/
			$search($1.barcode, " "); /*1773*/
			if ($k[--$j]) { /*1779*/
				$1.barcode = $k[--$j]; /*1774*/
				$j--; /*1775*/
				$1.addon = $k[--$j]; /*1776*/
			} else { /*1779*/
				$j--; /*1778*/
				$1.addon = ""; /*1779*/
			} /*1779*/
			if (($1.barcode.length == 11) || ($1.barcode.length == 12)) { /*1821*/
				$forall($1.barcode, function() { /*1789*/
					var _Q = $k[--$j]; /*1786*/
					if ((_Q < 48) || (_Q > 57)) { /*1788*/
						$k[$j++] = "bwipp.upcEupcAbadCharacter"; /*1787*/
						$k[$j++] = "UPC-A must contain only digits"; /*1787*/
						$0.raiseerror(); /*1787*/
					} /*1787*/
				}); /*1787*/
				for (var _R = 0, _S = 1; _R < _S; _R++) { /*1816*/
					var _U = ($1.barcode.length == 12) ? 8 : 7; /*1791*/
					$1.upcecode = $s(_U); /*1791*/
					if ((($get($1.barcode, 3) - 48) <= 2) && $eq($geti($1.barcode, 4, 4), "0000")) { /*1797*/
						$puti($1.upcecode, 0, $geti($1.barcode, 0, 3)); /*1793*/
						$puti($1.upcecode, 3, $geti($1.barcode, 8, 3)); /*1794*/
						$puti($1.upcecode, 6, $geti($1.barcode, 3, 1)); /*1795*/
						break; /*1796*/
					} /*1796*/
					if ($eq($geti($1.barcode, 4, 5), "00000")) { /*1803*/
						$puti($1.upcecode, 0, $geti($1.barcode, 0, 4)); /*1799*/
						$puti($1.upcecode, 4, $geti($1.barcode, 9, 2)); /*1800*/
						$puti($1.upcecode, 6, "3"); /*1801*/
						break; /*1802*/
					} /*1802*/
					if ($eq($geti($1.barcode, 5, 5), "00000")) { /*1809*/
						$puti($1.upcecode, 0, $geti($1.barcode, 0, 5)); /*1805*/
						$puti($1.upcecode, 5, $geti($1.barcode, 10, 1)); /*1806*/
						$puti($1.upcecode, 6, "4"); /*1807*/
						break; /*1808*/
					} /*1808*/
					if ((($get($1.barcode, 10) - 48) >= 5) && $eq($geti($1.barcode, 6, 4), "0000")) { /*1814*/
						$puti($1.upcecode, 0, $geti($1.barcode, 0, 6)); /*1811*/
						$puti($1.upcecode, 6, $geti($1.barcode, 10, 1)); /*1812*/
						break; /*1813*/
					} /*1813*/
					$k[$j++] = "bwipp.upcEupcAnotCompressible"; /*1815*/
					$k[$j++] = "UPC-A cannot be converted to a UPC-E"; /*1815*/
					$0.raiseerror(); /*1815*/
				} /*1815*/
				if ($1.barcode.length == 12) { /*1819*/
					$puti($1.upcecode, 7, $geti($1.barcode, 11, 1)); /*1818*/
				} /*1818*/
				$1.barcode = $1.upcecode; /*1820*/
			} /*1820*/
			if (($1.barcode.length != 7) && ($1.barcode.length != 8)) { /*1826*/
				$k[$j++] = "bwipp.upcEbadLength"; /*1825*/
				$k[$j++] = "UPC-E must be 7 or 8 digits"; /*1825*/
				$0.raiseerror(); /*1825*/
			} /*1825*/
			var _1I = $1.barcode; /*1827*/
			for (var _1J = 0, _1K = _1I.length; _1J < _1K; _1J++) { /*1831*/
				var _1L = $get(_1I, _1J); /*1831*/
				if ((_1L < 48) || (_1L > 57)) { /*1830*/
					$k[$j++] = "bwipp.upcEbadCharacter"; /*1829*/
					$k[$j++] = "UPC-E must contain only digits"; /*1829*/
					$0.raiseerror(); /*1829*/
				} /*1829*/
			} /*1829*/
			if ((($1.addon.length != 0) && ($1.addon.length != 2)) && ($1.addon.length != 5)) { /*1834*/
				$k[$j++] = "bwipp.upcEbadAddOnLength"; /*1833*/
				$k[$j++] = "Add-on for UPC-E must be 2 or 5 digits"; /*1833*/
				$0.raiseerror(); /*1833*/
			} /*1833*/
			var _1Q = $get($1.barcode, 0); /*1837*/
			if ((_1Q != 48) && (_1Q != 49)) { /*1839*/
				$k[$j++] = "bwipp.upcEbadNumberSystem"; /*1838*/
				$k[$j++] = "UPC-E must have number system 0 or 1"; /*1838*/
				$0.raiseerror(); /*1838*/
			} /*1838*/
			$1.encs = $a(["3211", "2221", "2122", "1411", "1132", "1231", "1114", "1312", "1213", "3112", "111", "111111"]); /*1846*/
			$1.barchars = "0123456789"; /*1849*/
			$1.mirrormaps = $a(["000111", "001011", "001101", "001110", "010011", "011001", "011100", "010101", "010110", "011010"]); /*1854*/
			for (var _1T = 0, _1U = 1; _1T < _1U; _1T++) { /*1884*/
				$1.upcacode = $s(11); /*1858*/
				if (($get($1.barcode, 6) - 48) <= 2) { /*1865*/
					$puti($1.upcacode, 0, $geti($1.barcode, 0, 3)); /*1860*/
					$puti($1.upcacode, 3, $geti($1.barcode, 6, 1)); /*1861*/
					$puti($1.upcacode, 4, "0000"); /*1862*/
					$puti($1.upcacode, 8, $geti($1.barcode, 3, 3)); /*1863*/
					break; /*1864*/
				} /*1864*/
				if (($get($1.barcode, 6) - 48) == 3) { /*1871*/
					$puti($1.upcacode, 0, $geti($1.barcode, 0, 4)); /*1867*/
					$puti($1.upcacode, 4, "00000"); /*1868*/
					$puti($1.upcacode, 9, $geti($1.barcode, 4, 2)); /*1869*/
					break; /*1870*/
				} /*1870*/
				if (($get($1.barcode, 6) - 48) == 4) { /*1877*/
					$puti($1.upcacode, 0, $geti($1.barcode, 0, 5)); /*1873*/
					$puti($1.upcacode, 5, "00000"); /*1874*/
					$puti($1.upcacode, 10, $geti($1.barcode, 5, 1)); /*1875*/
					break; /*1876*/
				} /*1876*/
				if (($get($1.barcode, 6) - 48) >= 5) { /*1883*/
					$puti($1.upcacode, 0, $geti($1.barcode, 0, 6)); /*1879*/
					$puti($1.upcacode, 6, "0000"); /*1880*/
					$puti($1.upcacode, 10, $geti($1.barcode, 6, 1)); /*1881*/
					break; /*1882*/
				} /*1882*/
			} /*1882*/
			$1.checksum = 0; /*1885*/
			for (var _29 = 0; _29 <= 10; _29 += 1) { /*1894*/
				$1.i = _29; /*1887*/
				$1.barchar = $get($1.upcacode, $1.i) - 48; /*1888*/
				if (($1.i % 2) != 0) { /*1892*/
					$1.checksum = $1.checksum + $1.barchar; /*1890*/
				} else { /*1892*/
					$1.checksum = $1.checksum + ($1.barchar * 3); /*1892*/
				} /*1892*/
			} /*1892*/
			$1.checksum = (10 - ($1.checksum % 10)) % 10; /*1895*/
			if ($1.barcode.length == 8) { /*1900*/
				if ($get($1.barcode, 7) != ($1.checksum + 48)) { /*1899*/
					$k[$j++] = "bwipp.upcEbadCheckDigit"; /*1898*/
					$k[$j++] = "Incorrect UPC check digit provided"; /*1898*/
					$0.raiseerror(); /*1898*/
				} /*1898*/
			} /*1898*/
			$1.pad = $s(8); /*1901*/
			$puti($1.pad, 0, $1.barcode); /*1902*/
			$put($1.pad, 7, $1.checksum + 48); /*1903*/
			$1.barcode = $1.pad; /*1904*/
			$1.txt = $a(8); /*1905*/
			$put($1.txt, 0, $a([$geti($1.barcode, 0, 1), $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize - 2])); /*1906*/
			$1.mirrormap = $get($1.mirrormaps, $1.checksum); /*1909*/
			if ($get($1.barcode, 0) == 48) { /*1923*/
				$1.invt = $s($1.mirrormap.length); /*1913*/
				for (var _2l = 0, _2k = $1.mirrormap.length - 1; _2l <= _2k; _2l += 1) { /*1921*/
					$1.i = _2l; /*1915*/
					if ($get($1.mirrormap, $1.i) == 48) { /*1919*/
						$put($1.invt, $1.i, 49); /*1917*/
					} else { /*1919*/
						$put($1.invt, $1.i, 48); /*1919*/
					} /*1919*/
				} /*1919*/
				$1.mirrormap = $1.invt; /*1922*/
			} /*1922*/
			$1.sbs = $s(33); /*1925*/
			$puti($1.sbs, 0, $get($1.encs, 10)); /*1928*/
			for (var _2y = 1; _2y <= 6; _2y += 1) { /*1950*/
				$1.i = _2y; /*1931*/
				$search($1.barchars, $geti($1.barcode, $1.i, 1)); /*1933*/
				$j--; /*1934*/
				$1.indx = $k[--$j].length; /*1935*/
				$j -= 2; /*1936*/
				$1.enc = $get($1.encs, $1.indx); /*1937*/
				if ($get($1.mirrormap, $1.i - 1) == 49) { /*1947*/
					$1.enclen = $1.enc.length; /*1939*/
					$1.revenc = $s($1.enclen); /*1940*/
					for (var _3F = 0, _3E = $1.enclen - 1; _3F <= _3E; _3F += 1) { /*1945*/
						$1.j = _3F; /*1942*/
						$1.char = $get($1.enc, $1.j); /*1943*/
						$put($1.revenc, ($1.enclen - $1.j) - 1, $1.char); /*1944*/
					} /*1944*/
					$1.enc = $1.revenc; /*1946*/
				} /*1946*/
				$puti($1.sbs, (($1.i - 1) * 4) + 3, $1.enc); /*1948*/
				$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), ((($1.i - 1) * 7) + 11) + $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])); /*1949*/
			} /*1949*/
			$put($1.txt, 7, $a([$geti($1.barcode, 7, 1), ((6 * 7) + 18) + $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize - 2])); /*1952*/
			$puti($1.sbs, 27, $get($1.encs, 11)); /*1955*/
			$k[$j++] = Infinity; /*1957*/
			var _3n = $1.sbs; /*1957*/
			for (var _3o = 0, _3p = _3n.length; _3o < _3p; _3o++) { /*1957*/
				$k[$j++] = $get(_3n, _3o) - 48; /*1957*/
			} /*1957*/
			$1.sbs = $a(); /*1957*/
			if ($1.includetext) { /*1964*/
				$k[$j++] = Infinity; /*1959*/
				$k[$j++] = $1.height; /*1959*/
				$k[$j++] = $1.height; /*1959*/
				for (var _3v = 0, _3w = 12; _3v < _3w; _3v++) { /*1959*/
					$k[$j++] = $1.height - 0.075; /*1959*/
				} /*1959*/
				$k[$j++] = $1.height; /*1959*/
				$k[$j++] = $1.height; /*1959*/
				$k[$j++] = $1.height; /*1959*/
				$1.bhs = $a(); /*1959*/
				$k[$j++] = Infinity; /*1960*/
				$k[$j++] = 0; /*1960*/
				$k[$j++] = 0; /*1960*/
				for (var _42 = 0, _43 = 12; _42 < _43; _42++) { /*1960*/
					$k[$j++] = 0.075; /*1960*/
				} /*1960*/
				$k[$j++] = 0; /*1960*/
				$k[$j++] = 0; /*1960*/
				$k[$j++] = 0; /*1960*/
				$1.bbs = $a(); /*1960*/
			} else { /*1964*/
				$k[$j++] = Infinity; /*1962*/
				for (var _45 = 0, _46 = 17; _45 < _46; _45++) { /*1962*/
					$k[$j++] = $1.height; /*1962*/
				} /*1962*/
				$1.bhs = $a(); /*1962*/
				$k[$j++] = Infinity; /*1963*/
				for (var _49 = 0, _4A = 17; _49 < _4A; _49++) { /*1963*/
					$k[$j++] = 0; /*1963*/
				} /*1963*/
				$1.bbs = $a(); /*1963*/
				$1.txt = $a([]); /*1964*/
			} /*1964*/
			$1.guardrightypos = 0; /*1966*/
			if ($ne($1.addon, "")) { /*1987*/
				$k[$j++] = "addopts"; /*1977*/
				$k[$j++] = Infinity; /*1977*/
				$k[$j++] = "dontdraw"; /*1974*/
				$k[$j++] = true; /*1974*/
				$k[$j++] = "includetext"; /*1974*/
				$k[$j++] = true; /*1974*/
				$k[$j++] = "height"; /*1974*/
				$k[$j++] = $1.height - 0.15; /*1974*/
				$k[$j++] = "textxoffset"; /*1974*/
				if ($1.addontextxoffset != "unset") { /*1974*/
					$k[$j++] = $1.addontextxoffset; /*1974*/
				} else { /*1974*/
					$k[$j++] = 51 + $1.addongap; /*1974*/
				} /*1974*/
				if ($1.addontextyoffset != "unset") { /*1975*/
					$k[$j++] = "textyoffset"; /*1975*/
					$k[$j++] = $1.addontextyoffset; /*1975*/
				} /*1975*/
				var _4L = ($1.addontextsize != "unset") ? $1.addontextsize : $1.textsize; /*1976*/
				var _4N = $ne($1.addontextfont, "unset") ? $1.addontextfont : $1.textfont; /*1977*/
				$k[$j++] = "textsize"; /*1977*/
				$k[$j++] = _4L; /*1977*/
				$k[$j++] = "textfont"; /*1977*/
				$k[$j++] = _4N; /*1977*/
				var _4O = $d(); /*1977*/
				$1[$k[--$j]] = _4O; /*1978*/
				if ($1.addon.length == 2) { /*1979*/
					$k[$j++] = $1.addon; /*1979*/
					$k[$j++] = $1.addopts; /*1979*/
					$0.ean2(); /*1979*/
				} /*1979*/
				if ($1.addon.length == 5) { /*1980*/
					$k[$j++] = $1.addon; /*1980*/
					$k[$j++] = $1.addopts; /*1980*/
					$0.ean5(); /*1980*/
				} /*1980*/
				$1.addcode = $k[--$j]; /*1981*/
				$k[$j++] = Infinity; /*1982*/
				$aload($1.sbs); /*1982*/
				$k[$j++] = $1.addongap; /*1982*/
				$aload($1.addcode.sbs); /*1982*/
				$1.sbs = $a(); /*1982*/
				$k[$j++] = Infinity; /*1983*/
				$aload($1.bhs); /*1983*/
				$forall($1.addcode.bhs, function() { /*1983*/
					var _4f = $k[--$j]; /*1983*/
					$k[$j++] = _4f - 0.075; /*1983*/
				}); /*1983*/
				$1.bhs = $a(); /*1983*/
				$k[$j++] = Infinity; /*1984*/
				$aload($1.bbs); /*1984*/
				$forall($1.addcode.bbs, function() { /*1984*/
					var _4k = $k[--$j]; /*1984*/
					$k[$j++] = _4k + 0.075; /*1984*/
				}); /*1984*/
				$1.bbs = $a(); /*1984*/
				$k[$j++] = Infinity; /*1985*/
				$aload($1.txt); /*1985*/
				$aload($1.addcode.txt); /*1985*/
				$1.txt = $a(); /*1985*/
				$1.guardrightypos = ($1.height * 72) - 6; /*1986*/
			} /*1986*/
			var _4x = {
				ren: $0.renlinear,
				sbs: $1.sbs,
				bhs: $1.bhs,
				bbs: $1.bbs,
				txt: $1.txt,
				opt: $1.options,
				guardrightpos: 10,
				guardrightypos: $1.guardrightypos,
				borderbottom: 5
			}; /*1999*/
			$k[$j++] = _4x; /*2002*/
			if (!$1.dontdraw) { /*2002*/
				$0.renlinear(); /*2002*/
			} /*2002*/
		};
		$0.isbn = function() {
			var $1 = {}; /*2030*/
			$1.options = $k[--$j]; /*2032*/
			$1.barcode = $k[--$j]; /*2033*/
			$1.dontdraw = false; /*2035*/
			$1.includetext = false; /*2036*/
			$1.isbntextfont = "OCR-A"; /*2037*/
			$1.isbntextsize = 8; /*2038*/
			$1.isbntextxoffset = "unset"; /*2039*/
			$1.isbntextyoffset = "unset"; /*2040*/
			$1.height = 1; /*2041*/
			$1.addongap = 12; /*2042*/
			$1.legacy = false; /*2043*/
			$forall($1.options, function() { /*2054*/
				var _3 = $k[--$j]; /*2054*/
				$1[$k[--$j]] = _3; /*2054*/
			}); /*2054*/
			$1.isbntextfont = "" + $1.isbntextfont; /*2056*/
			$1.isbntextsize = +$1.isbntextsize; /*2057*/
			if ($ne($1.isbntextxoffset, "unset")) { /*2058*/
				$1.isbntextxoffset = +$1.isbntextxoffset; /*2058*/
			} /*2058*/
			if ($ne($1.isbntextyoffset, "unset")) { /*2059*/
				$1.isbntextyoffset = +$1.isbntextyoffset; /*2059*/
			} /*2059*/
			$1.height = +$1.height; /*2060*/
			$1.addongap = +$1.addongap; /*2061*/
			$search($1.barcode, " "); /*2064*/
			if ($k[--$j]) { /*2070*/
				$1.barcode = $k[--$j]; /*2065*/
				$j--; /*2066*/
				$1.addon = $k[--$j]; /*2067*/
			} else { /*2070*/
				$j--; /*2069*/
				$1.addon = ""; /*2070*/
			} /*2070*/
			if ((($1.barcode.length != 15) && ($1.barcode.length != 17)) && (($1.barcode.length != 11) && ($1.barcode.length != 13))) { /*2077*/
				$k[$j++] = "bwipp.isbnBadLength"; /*2076*/
				$k[$j++] = "ISBN-13 must be 15 or 17 characters including dashes. ISBN-10 must be 11 or 13 characters including dashes"; /*2076*/
				$0.raiseerror(); /*2076*/
			} /*2076*/
			if ((($1.addon.length != 0) && ($1.addon.length != 2)) && ($1.addon.length != 5)) { /*2080*/
				$k[$j++] = "bwipp.isbnBadAddOnLength"; /*2079*/
				$k[$j++] = "Add-on for ISBN must be 2 or 5 digits"; /*2079*/
				$0.raiseerror(); /*2079*/
			} /*2079*/
			if ($1.barcode.length >= 15) { /*2144*/
				var _Q = $geti($1.barcode, 0, 4); /*2082*/
				if ($ne(_Q, "978-") && $ne(_Q, "979-")) { /*2084*/
					$k[$j++] = "bwipp.isbn13badPrefix"; /*2083*/
					$k[$j++] = "ISBN-13 prefix must be 978- or 979-"; /*2083*/
					$0.raiseerror(); /*2083*/
				} /*2083*/
				$1.wasdash = false; /*2085*/
				$1.numdash = 0; /*2085*/
				$1.numdigit = 0; /*2085*/
				$forall($geti($1.barcode, 5, 9), function() { /*2099*/
					var _T = $k[--$j]; /*2087*/
					$k[$j++] = _T; /*2094*/
					if (_T == 45) { /*2094*/
						if ($1.wasdash) { /*2091*/
							$k[$j++] = "bwipp.isbn13adjacentDashes"; /*2090*/
							$k[$j++] = "ISBN-13 does not permit adjacent dashes"; /*2090*/
							$0.raiseerror(); /*2090*/
						} /*2090*/
						$1.wasdash = true; /*2092*/
						$1.numdash = $1.numdash + 1; /*2093*/
					} /*2093*/
					var _W = $k[--$j]; /*2095*/
					if ((_W >= 48) && (_W <= 57)) { /*2098*/
						$1.wasdash = false; /*2096*/
						$1.numdigit = $1.numdigit + 1; /*2097*/
					} /*2097*/
				}); /*2097*/
				if (($1.numdash != 2) || ($1.numdigit != 7)) { /*2102*/
					$k[$j++] = "bwipp.isbn13numDashesDigits"; /*2101*/
					$k[$j++] = "Incorrect number of dashes and digits for ISBN-13"; /*2101*/
					$0.raiseerror(); /*2101*/
				} /*2101*/
				var _b = $get($1.barcode, 14); /*2103*/
				if ((_b < 48) || (_b > 57)) { /*2105*/
					$k[$j++] = "bwipp.isbn13character15"; /*2104*/
					$k[$j++] = "ISBN-13 character 15 must be a digit"; /*2104*/
					$0.raiseerror(); /*2104*/
				} /*2104*/
				if ($1.barcode.length == 17) { /*2113*/
					if ($ne($geti($1.barcode, 15, 1), "-")) { /*2109*/
						$k[$j++] = "bwipp.isbn13character16"; /*2108*/
						$k[$j++] = "ISBN-13 penultimate character must be a dash"; /*2108*/
						$0.raiseerror(); /*2108*/
					} /*2108*/
					var _g = $get($1.barcode, 16); /*2110*/
					if ((_g < 48) || (_g > 57)) { /*2112*/
						$k[$j++] = "bwipp.isbn13character17"; /*2111*/
						$k[$j++] = "ISBN-13 final character must be a digit"; /*2111*/
						$0.raiseerror(); /*2111*/
					} /*2111*/
				} /*2111*/
			} else { /*2144*/
				var _i = $get($1.barcode, 0); /*2115*/
				if ((_i < 48) || (_i > 57)) { /*2117*/
					$k[$j++] = "bwipp.isbn10FirstDigit"; /*2116*/
					$k[$j++] = "ISBN-10 first character must be a digit"; /*2116*/
					$0.raiseerror(); /*2116*/
				} /*2116*/
				$1.wasdash = false; /*2118*/
				$1.numdash = 0; /*2118*/
				$1.numdigit = 0; /*2118*/
				$forall($geti($1.barcode, 1, 9), function() { /*2132*/
					var _l = $k[--$j]; /*2120*/
					$k[$j++] = _l; /*2127*/
					if (_l == 45) { /*2127*/
						if ($1.wasdash) { /*2124*/
							$k[$j++] = "bwipp.isbn10adjacentDashes"; /*2123*/
							$k[$j++] = "ISBN-10 does not permit adjacent dashes"; /*2123*/
							$0.raiseerror(); /*2123*/
						} /*2123*/
						$1.wasdash = true; /*2125*/
						$1.numdash = $1.numdash + 1; /*2126*/
					} /*2126*/
					var _o = $k[--$j]; /*2128*/
					if ((_o >= 48) && (_o <= 57)) { /*2131*/
						$1.wasdash = false; /*2129*/
						$1.numdigit = $1.numdigit + 1; /*2130*/
					} /*2130*/
				}); /*2130*/
				if (($1.numdash != 2) || ($1.numdigit != 7)) { /*2135*/
					$k[$j++] = "bwipp.isbn10numDashesDigits"; /*2134*/
					$k[$j++] = "Incorrect number of dashes and digits for ISBN-10"; /*2134*/
					$0.raiseerror(); /*2134*/
				} /*2134*/
				var _t = $get($1.barcode, 10); /*2136*/
				if ((_t < 48) || (_t > 57)) { /*2138*/
					$k[$j++] = "bwipp.isbn10character11"; /*2137*/
					$k[$j++] = "ISBN-10 character 11 must be a digit"; /*2137*/
					$0.raiseerror(); /*2137*/
				} /*2137*/
				if ($1.barcode.length == 13) { /*2146*/
					if ($ne($geti($1.barcode, 11, 1), "-")) { /*2142*/
						$k[$j++] = "bwipp.isbn10character12"; /*2141*/
						$k[$j++] = "ISBN-10 penultimate character must be a dash"; /*2141*/
						$0.raiseerror(); /*2141*/
					} /*2141*/
					var _y = $get($1.barcode, 12); /*2143*/
					if (((_y < 48) || (_y > 57)) && (_y != 88)) { /*2145*/
						$k[$j++] = "bwipp.isbn10character13"; /*2144*/
						$k[$j++] = "ISBN-10 final character must be a digit or X"; /*2144*/
						$0.raiseerror(); /*2144*/
					} /*2144*/
				} /*2144*/
			} /*2144*/
			$1.isbntxt = $1.barcode; /*2149*/
			if ($1.isbntxt.length <= 13) { /*2175*/
				$1.isbn = $s(10); /*2153*/
				$1.checksum = 0; /*2154*/
				$1.i = 0; /*2155*/
				$1.n = 0; /*2155*/
				for (;;) { /*2167*/
					$1.isbnchar = $get($1.isbntxt, $1.i) - 48; /*2157*/
					if ($1.isbnchar != -3) { /*2164*/
						$put($1.isbn, $1.n, $1.isbnchar + 48); /*2159*/
						if ($1.n < 9) { /*2162*/
							$1.checksum = $1.checksum + ((10 - $1.n) * $1.isbnchar); /*2161*/
						} /*2161*/
						$1.n = $1.n + 1; /*2163*/
					} /*2163*/
					$1.i = $1.i + 1; /*2165*/
					if ($1.i == $1.isbntxt.length) { /*2166*/
						break; /*2166*/
					} /*2166*/
				} /*2166*/
				var _1I = (11 - ($1.checksum % 11)) % 11; /*2168*/
				$k[$j++] = "checksum"; /*2168*/
				$k[$j++] = _1I; /*2168*/
				if (_1I == 10) { /*2168*/
					$j--; /*2168*/
					$k[$j++] = 40; /*2168*/
				} /*2168*/
				var _1J = $k[--$j]; /*2168*/
				$1[$k[--$j]] = _1J + 48; /*2168*/
				$1.isbn = $geti($1.isbn, 0, 9); /*2169*/
				if ($1.isbntxt.length == 13) { /*2174*/
					if ($get($1.isbntxt, 12) != $1.checksum) { /*2173*/
						$k[$j++] = "bwipp.isbn10badCheckDigit"; /*2172*/
						$k[$j++] = "Incorrect ISBN-10 check digit provided"; /*2172*/
						$0.raiseerror(); /*2172*/
					} /*2172*/
				} /*2172*/
			} /*2172*/
			if ((!$1.legacy) || ($1.isbntxt.length >= 15)) { /*2211*/
				if ($1.isbntxt.length <= 13) { /*2185*/
					$1.pad = $s(15); /*2181*/
					$puti($1.pad, 0, "978-"); /*2182*/
					$puti($1.pad, 4, $geti($1.isbntxt, 0, 11)); /*2183*/
					$1.isbntxt = $1.pad; /*2184*/
				} /*2184*/
				$1.isbn = $s(13); /*2188*/
				$1.checksum = 0; /*2189*/
				$1.i = 0; /*2190*/
				$1.n = 0; /*2190*/
				for (;;) { /*2202*/
					$1.isbnchar = $get($1.isbntxt, $1.i) - 48; /*2192*/
					if ($1.isbnchar != -3) { /*2199*/
						$put($1.isbn, $1.n, $1.isbnchar + 48); /*2194*/
						if ($1.n < 12) { /*2197*/
							$k[$j++] = "checksum"; /*2196*/
							$k[$j++] = $1.isbnchar; /*2196*/
							if (($1.n % 2) != 0) { /*2196*/
								var _1l = $k[--$j]; /*2196*/
								$k[$j++] = _1l * 3; /*2196*/
							} /*2196*/
							var _1n = $k[--$j]; /*2196*/
							$1[$k[--$j]] = _1n + $1.checksum; /*2196*/
						} /*2196*/
						$1.n = $1.n + 1; /*2198*/
					} /*2198*/
					$1.i = $1.i + 1; /*2200*/
					if ($1.i == $1.isbntxt.length) { /*2201*/
						break; /*2201*/
					} /*2201*/
				} /*2201*/
				$1.checksum = ((10 - ($1.checksum % 10)) % 10) + 48; /*2203*/
				$1.isbn = $geti($1.isbn, 0, 12); /*2204*/
				if ($1.isbntxt.length == 17) { /*2209*/
					if ($get($1.isbntxt, 16) != $1.checksum) { /*2208*/
						$k[$j++] = "bwipp.isbn13badCheckDigit"; /*2207*/
						$k[$j++] = "Incorrect ISBN-13 check digit provided"; /*2207*/
						$0.raiseerror(); /*2207*/
					} /*2207*/
				} /*2207*/
			} /*2207*/
			var _21 = ($1.isbn.length == 12) ? 22 : 18; /*2214*/
			$1.pad = $s(_21); /*2214*/
			$puti($1.pad, 0, "ISBN "); /*2215*/
			$puti($1.pad, 5, $1.isbntxt); /*2216*/
			$put($1.pad, $1.pad.length - 2, 45); /*2217*/
			$put($1.pad, $1.pad.length - 1, $1.checksum); /*2218*/
			$1.isbntxt = $1.pad; /*2219*/
			$1.barcode = $s(12); /*2222*/
			if ($1.isbn.length == 9) { /*2227*/
				$puti($1.barcode, 0, "978"); /*2224*/
				$puti($1.barcode, 3, $1.isbn); /*2225*/
			} else { /*2227*/
				$puti($1.barcode, 0, $1.isbn); /*2227*/
			} /*2227*/
			if ($ne($1.addon, "")) { /*2237*/
				var _2L = $s((12 + $1.addon.length) + 1); /*2232*/
				$puti(_2L, 0, $1.barcode); /*2233*/
				$puti(_2L, 12, " "); /*2234*/
				$puti(_2L, 13, $1.addon); /*2235*/
				$1.barcode = _2L; /*2236*/
			} /*2236*/
			$1.options.dontdraw = true; /*2240*/
			$1.options.addongap = $1.addongap; /*2241*/
			$k[$j++] = "args"; /*2242*/
			$k[$j++] = $1.barcode; /*2242*/
			$k[$j++] = $1.options; /*2242*/
			$0.ean13(); /*2242*/
			var _2T = $k[--$j]; /*2242*/
			$1[$k[--$j]] = _2T; /*2242*/
			if ($1.includetext) { /*2261*/
				if ($1.isbntextxoffset == "unset") { /*2248*/
					$k[$j++] = "isbntextxoffset"; /*2247*/
					if ($1.isbn.length == 9) { /*2247*/
						$k[$j++] = -1; /*2247*/
					} else { /*2247*/
						$k[$j++] = -12; /*2247*/
					} /*2247*/
					var _2Y = $k[--$j]; /*2247*/
					$1[$k[--$j]] = _2Y; /*2247*/
				} /*2247*/
				if ($1.isbntextyoffset == "unset") { /*2251*/
					$1.isbntextyoffset = ($1.height * 72) + 3; /*2250*/
				} /*2250*/
				var _2d = $1.args.txt !== undefined; /*2252*/
				if (_2d) { /*2259*/
					$1.txt = $1.args.txt; /*2253*/
					$1.newtxt = $a($1.txt.length + 1); /*2254*/
					$puti($1.newtxt, 0, $1.txt); /*2255*/
					$put($1.newtxt, $1.newtxt.length - 1, $a([$1.isbntxt, $1.isbntextxoffset, $1.isbntextyoffset, $1.isbntextfont, $1.isbntextsize])); /*2256*/
					$1.args.txt = $1.newtxt; /*2257*/
				} else { /*2259*/
					$1.args.txt = $a([$a([$1.isbntxt, $1.isbntextxoffset, $1.isbntextyoffset, $1.isbntextfont, $1.isbntextsize])]); /*2259*/
				} /*2259*/
			} /*2259*/
			$1.args.opt = $1.options; /*2263*/
			$k[$j++] = $1.args; /*2266*/
			if (!$1.dontdraw) { /*2266*/
				$0.renlinear(); /*2266*/
			} /*2266*/
		};
		$0.ismn = function() {
			var $1 = {}; /*2294*/
			$1.options = $k[--$j]; /*2296*/
			$1.barcode = $k[--$j]; /*2297*/
			$1.dontdraw = false; /*2299*/
			$1.includetext = false; /*2300*/
			$1.ismntextfont = "OCR-A"; /*2301*/
			$1.ismntextsize = 8; /*2302*/
			$1.ismntextxoffset = "unset"; /*2303*/
			$1.ismntextyoffset = "unset"; /*2304*/
			$1.height = 1; /*2305*/
			$1.addongap = 12; /*2306*/
			$1.legacy = false; /*2307*/
			$forall($1.options, function() { /*2318*/
				var _3 = $k[--$j]; /*2318*/
				$1[$k[--$j]] = _3; /*2318*/
			}); /*2318*/
			$1.ismntextfont = "" + $1.ismntextfont; /*2320*/
			$1.ismntextsize = +$1.ismntextsize; /*2321*/
			if ($ne($1.ismntextxoffset, "unset")) { /*2322*/
				$1.ismntextxoffset = +$1.ismntextxoffset; /*2322*/
			} /*2322*/
			if ($ne($1.ismntextyoffset, "unset")) { /*2323*/
				$1.ismntextyoffset = +$1.ismntextyoffset; /*2323*/
			} /*2323*/
			$1.height = +$1.height; /*2324*/
			$1.addongap = +$1.addongap; /*2325*/
			$search($1.barcode, " "); /*2328*/
			if ($k[--$j]) { /*2334*/
				$1.barcode = $k[--$j]; /*2329*/
				$j--; /*2330*/
				$1.addon = $k[--$j]; /*2331*/
			} else { /*2334*/
				$j--; /*2333*/
				$1.addon = ""; /*2334*/
			} /*2334*/
			if ((($1.barcode.length != 15) && ($1.barcode.length != 17)) && (($1.barcode.length != 11) && ($1.barcode.length != 13))) { /*2341*/
				$k[$j++] = "bwipp.ismnBadLength"; /*2340*/
				$k[$j++] = "ISMN-13 must be 15 or 17 characters including dashes. ISMN-10 must be 11 or 13 characters including dashes"; /*2340*/
				$0.raiseerror(); /*2340*/
			} /*2340*/
			if ((($1.addon.length != 0) && ($1.addon.length != 2)) && ($1.addon.length != 5)) { /*2344*/
				$k[$j++] = "bwipp.ismnBadAddOnLength"; /*2343*/
				$k[$j++] = "Add-on for ISMN must be 2 or 5 digits"; /*2343*/
				$0.raiseerror(); /*2343*/
			} /*2343*/
			if ($1.barcode.length >= 15) { /*2411*/
				if ($ne($geti($1.barcode, 0, 4), "979-")) { /*2348*/
					$k[$j++] = "bwipp.ismn13badPrefix"; /*2347*/
					$k[$j++] = "ISMN-13 prefix must be 979-"; /*2347*/
					$0.raiseerror(); /*2347*/
				} /*2347*/
				$1.wasdash = false; /*2349*/
				$1.numdash = 0; /*2349*/
				$1.numdigit = 0; /*2349*/
				$forall($geti($1.barcode, 5, 9), function() { /*2363*/
					var _T = $k[--$j]; /*2351*/
					$k[$j++] = _T; /*2358*/
					if (_T == 45) { /*2358*/
						if ($1.wasdash) { /*2355*/
							$k[$j++] = "bwipp.ismn13adjacentDashes"; /*2354*/
							$k[$j++] = "ISMN-13 does not permit adjacent dashes"; /*2354*/
							$0.raiseerror(); /*2354*/
						} /*2354*/
						$1.wasdash = true; /*2356*/
						$1.numdash = $1.numdash + 1; /*2357*/
					} /*2357*/
					var _W = $k[--$j]; /*2359*/
					if ((_W >= 48) && (_W <= 57)) { /*2362*/
						$1.wasdash = false; /*2360*/
						$1.numdigit = $1.numdigit + 1; /*2361*/
					} /*2361*/
				}); /*2361*/
				if (($1.numdash != 2) || ($1.numdigit != 7)) { /*2366*/
					$k[$j++] = "bwipp.ismn13numDashesDigits"; /*2365*/
					$k[$j++] = "Incorrect number of dashes and digits for ISMN-13"; /*2365*/
					$0.raiseerror(); /*2365*/
				} /*2365*/
				var _b = $get($1.barcode, 14); /*2367*/
				if ((_b < 48) || (_b > 57)) { /*2369*/
					$k[$j++] = "bwipp.ismn13character15"; /*2368*/
					$k[$j++] = "ISMN-13 character 15 must be a digit"; /*2368*/
					$0.raiseerror(); /*2368*/
				} /*2368*/
				if ($1.barcode.length == 17) { /*2377*/
					if ($ne($geti($1.barcode, 15, 1), "-")) { /*2373*/
						$k[$j++] = "bwipp.ismn13character16"; /*2372*/
						$k[$j++] = "ISMN-13 penultimate character must be a dash"; /*2372*/
						$0.raiseerror(); /*2372*/
					} /*2372*/
					var _g = $get($1.barcode, 16); /*2374*/
					if ((_g < 48) || (_g > 57)) { /*2376*/
						$k[$j++] = "bwipp.ismn13character17"; /*2375*/
						$k[$j++] = "ISMN-13 final character must be a digit"; /*2375*/
						$0.raiseerror(); /*2375*/
					} /*2375*/
				} /*2375*/
			} else { /*2411*/
				if ($ne($geti($1.barcode, 0, 2), "M-")) { /*2381*/
					$k[$j++] = "bwipp.ismn10badPrefix"; /*2380*/
					$k[$j++] = "ISMN-10 prefix must be M-"; /*2380*/
					$0.raiseerror(); /*2380*/
				} /*2380*/
				var _k = $get($1.barcode, 2); /*2382*/
				if ((_k < 48) || (_k > 57)) { /*2384*/
					$k[$j++] = "bwipp.ismn10character3"; /*2383*/
					$k[$j++] = "ISMN-10 character 3 must be a digit"; /*2383*/
					$0.raiseerror(); /*2383*/
				} /*2383*/
				$1.wasdash = false; /*2385*/
				$1.numdash = 0; /*2385*/
				$1.numdigit = 0; /*2385*/
				$forall($geti($1.barcode, 3, 7), function() { /*2399*/
					var _n = $k[--$j]; /*2387*/
					$k[$j++] = _n; /*2394*/
					if (_n == 45) { /*2394*/
						if ($1.wasdash) { /*2391*/
							$k[$j++] = "bwipp.ismn10adjacentDashes"; /*2390*/
							$k[$j++] = "ISMN-10 does not permit adjacent dashes"; /*2390*/
							$0.raiseerror(); /*2390*/
						} /*2390*/
						$1.wasdash = true; /*2392*/
						$1.numdash = $1.numdash + 1; /*2393*/
					} /*2393*/
					var _q = $k[--$j]; /*2395*/
					if ((_q >= 48) && (_q <= 57)) { /*2398*/
						$1.wasdash = false; /*2396*/
						$1.numdigit = $1.numdigit + 1; /*2397*/
					} /*2397*/
				}); /*2397*/
				if (($1.numdash != 1) || ($1.numdigit != 6)) { /*2402*/
					$k[$j++] = "bwipp.ismn10numDashesDigits"; /*2401*/
					$k[$j++] = "Incorrect number of dashes and digits for ISMN-10"; /*2401*/
					$0.raiseerror(); /*2401*/
				} /*2401*/
				var _v = $get($1.barcode, 10); /*2403*/
				if ((_v < 48) || (_v > 57)) { /*2405*/
					$k[$j++] = "bwipp.ismn10character11"; /*2404*/
					$k[$j++] = "ISMN-10 character 11 must be a digit"; /*2404*/
					$0.raiseerror(); /*2404*/
				} /*2404*/
				if ($1.barcode.length == 13) { /*2413*/
					if ($ne($geti($1.barcode, 11, 1), "-")) { /*2409*/
						$k[$j++] = "bwipp.ismn10character12"; /*2408*/
						$k[$j++] = "ISMN-10 penultimate character must be a dash"; /*2408*/
						$0.raiseerror(); /*2408*/
					} /*2408*/
					var _10 = $get($1.barcode, 12); /*2410*/
					if (((_10 < 48) || (_10 > 57)) && (_10 != 88)) { /*2412*/
						$k[$j++] = "bwipp.ismn10character13"; /*2411*/
						$k[$j++] = "ISMN-10 final character must be a digit or X"; /*2411*/
						$0.raiseerror(); /*2411*/
					} /*2411*/
				} /*2411*/
			} /*2411*/
			$1.ismntxt = $1.barcode; /*2416*/
			$1.legacytxt = ""; /*2419*/
			if ($1.ismntxt.length <= 13) { /*2426*/
				$1.legacytxt = $1.ismntxt; /*2421*/
				$1.pad = $s($1.ismntxt.length + 4); /*2422*/
				$puti($1.pad, 0, "979-0-"); /*2423*/
				$puti($1.pad, 6, $geti($1.ismntxt, 2, $1.ismntxt.length - 2)); /*2424*/
				$1.ismntxt = $1.pad; /*2425*/
			} /*2425*/
			$1.ismn = $s(13); /*2429*/
			$1.checksum = 0; /*2430*/
			$1.i = 0; /*2431*/
			$1.n = 0; /*2431*/
			for (;;) { /*2447*/
				$1.ismnchar = $get($1.ismntxt, $1.i) - 48; /*2433*/
				if ($1.ismnchar != -3) { /*2444*/
					$put($1.ismn, $1.n, $1.ismnchar + 48); /*2435*/
					if ($1.n < 12) { /*2442*/
						if (($1.n % 2) == 0) { /*2440*/
							$1.checksum = $1.ismnchar + $1.checksum; /*2438*/
						} else { /*2440*/
							$1.checksum = ($1.ismnchar * 3) + $1.checksum; /*2440*/
						} /*2440*/
					} /*2440*/
					$1.n = $1.n + 1; /*2443*/
				} /*2443*/
				$1.i = $1.i + 1; /*2445*/
				if ($1.i == $1.ismntxt.length) { /*2446*/
					break; /*2446*/
				} /*2446*/
			} /*2446*/
			$1.checksum = ((10 - ($1.checksum % 10)) % 10) + 48; /*2448*/
			if (($1.barcode.length == 13) || ($1.barcode.length == 17)) { /*2455*/
				var _1X = $1.barcode; /*2452*/
				if ($get(_1X, _1X.length - 1) != $1.checksum) { /*2454*/
					$k[$j++] = "bwipp.ismnBadCheckDigit"; /*2453*/
					$k[$j++] = "Incorrect ISMN check digit provided"; /*2453*/
					$0.raiseerror(); /*2453*/
				} /*2453*/
			} /*2453*/
			if ($1.legacy && $ne($1.legacytxt, "")) { /*2462*/
				$1.ismntxt = $1.legacytxt; /*2459*/
				$1.pad = $s(18); /*2460*/
			} else { /*2462*/
				$1.pad = $s(22); /*2462*/
			} /*2462*/
			$puti($1.pad, 0, "ISMN "); /*2464*/
			$puti($1.pad, 5, $1.ismntxt); /*2465*/
			$put($1.pad, $1.pad.length - 2, 45); /*2466*/
			$put($1.pad, $1.pad.length - 1, $1.checksum); /*2467*/
			$1.ismntxt = $1.pad; /*2468*/
			$1.barcode = $geti($1.ismn, 0, 12); /*2471*/
			if ($ne($1.addon, "")) { /*2480*/
				var _1s = $s((12 + $1.addon.length) + 1); /*2475*/
				$puti(_1s, 0, $1.barcode); /*2476*/
				$puti(_1s, 12, " "); /*2477*/
				$puti(_1s, 13, $1.addon); /*2478*/
				$1.barcode = _1s; /*2479*/
			} /*2479*/
			$1.options.dontdraw = true; /*2483*/
			$1.options.addongap = $1.addongap; /*2484*/
			$k[$j++] = "args"; /*2485*/
			$k[$j++] = $1.barcode; /*2485*/
			$k[$j++] = $1.options; /*2485*/
			$0.ean13(); /*2485*/
			var _20 = $k[--$j]; /*2485*/
			$1[$k[--$j]] = _20; /*2485*/
			if ($1.includetext) { /*2504*/
				if ($1.ismntextxoffset == "unset") { /*2491*/
					$k[$j++] = "ismntextxoffset"; /*2490*/
					if ($1.ismntxt.length == 18) { /*2490*/
						$k[$j++] = -1; /*2490*/
					} else { /*2490*/
						$k[$j++] = -12; /*2490*/
					} /*2490*/
					var _25 = $k[--$j]; /*2490*/
					$1[$k[--$j]] = _25; /*2490*/
				} /*2490*/
				if ($1.ismntextyoffset == "unset") { /*2494*/
					$1.ismntextyoffset = ($1.height * 72) + 3; /*2493*/
				} /*2493*/
				var _2A = $1.args.txt !== undefined; /*2495*/
				if (_2A) { /*2502*/
					$1.txt = $1.args.txt; /*2496*/
					$1.newtxt = $a($1.txt.length + 1); /*2497*/
					$puti($1.newtxt, 0, $1.txt); /*2498*/
					$put($1.newtxt, $1.newtxt.length - 1, $a([$1.ismntxt, $1.ismntextxoffset, $1.ismntextyoffset, $1.ismntextfont, $1.ismntextsize])); /*2499*/
					$1.args.txt = $1.newtxt; /*2500*/
				} else { /*2502*/
					$1.args.txt = $a([$a([$1.ismntxt, $1.ismntextxoffset, $1.ismntextyoffset, $1.ismntextfont, $1.ismntextsize])]); /*2502*/
				} /*2502*/
			} /*2502*/
			$1.args.opt = $1.options; /*2506*/
			$k[$j++] = $1.args; /*2509*/
			if (!$1.dontdraw) { /*2509*/
				$0.renlinear(); /*2509*/
			} /*2509*/
		};
		$0.issn = function() {
			var $1 = {}; /*2537*/
			$1.options = $k[--$j]; /*2539*/
			$1.issntxt = $k[--$j]; /*2540*/
			$1.dontdraw = false; /*2542*/
			$1.includetext = false; /*2543*/
			$1.issntextfont = "OCR-A"; /*2544*/
			$1.issntextsize = 8; /*2545*/
			$1.issntextxoffset = "unset"; /*2546*/
			$1.issntextyoffset = "unset"; /*2547*/
			$1.height = 1; /*2548*/
			$1.addongap = 12; /*2549*/
			$forall($1.options, function() { /*2560*/
				var _3 = $k[--$j]; /*2560*/
				$1[$k[--$j]] = _3; /*2560*/
			}); /*2560*/
			$1.issntextfont = "" + $1.issntextfont; /*2562*/
			$1.issntextsize = +$1.issntextsize; /*2563*/
			if ($ne($1.issntextxoffset, "unset")) { /*2564*/
				$1.issntextxoffset = +$1.issntextxoffset; /*2564*/
			} /*2564*/
			if ($ne($1.issntextyoffset, "unset")) { /*2565*/
				$1.issntextyoffset = +$1.issntextyoffset; /*2565*/
			} /*2565*/
			$1.height = +$1.height; /*2566*/
			$1.addongap = +$1.addongap; /*2567*/
			$search($1.issntxt, " "); /*2570*/
			if ($k[--$j]) { /*2576*/
				$1.issntxt = $k[--$j]; /*2571*/
				$j--; /*2572*/
				$1.seqvar = $k[--$j]; /*2573*/
			} else { /*2576*/
				$j--; /*2575*/
				$1.seqvar = "00"; /*2576*/
			} /*2576*/
			$search($1.seqvar, " "); /*2580*/
			if ($k[--$j]) { /*2586*/
				$1.seqvar = $k[--$j]; /*2581*/
				$j--; /*2582*/
				$1.addon = $k[--$j]; /*2583*/
			} else { /*2586*/
				$j--; /*2585*/
				$1.addon = ""; /*2586*/
			} /*2586*/
			if (($1.issntxt.length != 8) && ($1.issntxt.length != 9)) { /*2592*/
				$k[$j++] = "bwipp.issnBadLength"; /*2591*/
				$k[$j++] = "ISSN must be 8 or 9 characters including dash, in the format XXXX-XXXX"; /*2591*/
				$0.raiseerror(); /*2591*/
			} /*2591*/
			$forall($geti($1.issntxt, 0, 4), function() { /*2597*/
				var _P = $k[--$j]; /*2594*/
				if ((_P < 48) || (_P > 57)) { /*2596*/
					$k[$j++] = "bwipp.issnFirstThroughFourthNotNumeric"; /*2595*/
					$k[$j++] = "ISSN first four characters must be numeral characters"; /*2595*/
					$0.raiseerror(); /*2595*/
				} /*2595*/
			}); /*2595*/
			if ($ne($geti($1.issntxt, 4, 1), "-")) { /*2600*/
				$k[$j++] = "bwipp.issnNeedsDash"; /*2599*/
				$k[$j++] = "ISSN fifth character must be a dash"; /*2599*/
				$0.raiseerror(); /*2599*/
			} /*2599*/
			$forall($geti($1.issntxt, 5, 3), function() { /*2605*/
				var _U = $k[--$j]; /*2602*/
				if ((_U < 48) || (_U > 57)) { /*2604*/
					$k[$j++] = "bwipp.issnSixthThroughEighthNotNumeric"; /*2603*/
					$k[$j++] = "ISSN sixth through eighth characters must be numerals"; /*2603*/
					$0.raiseerror(); /*2603*/
				} /*2603*/
			}); /*2603*/
			if ($1.issntxt.length == 9) { /*2610*/
				var _X = $get($1.issntxt, 8); /*2607*/
				if (((_X < 48) || (_X > 57)) && (_X != 88)) { /*2609*/
					$k[$j++] = "bwipp.issnNinthCharacterBadFormat"; /*2608*/
					$k[$j++] = "ISSN ninth character must be a number or the character X"; /*2608*/
					$0.raiseerror(); /*2608*/
				} /*2608*/
			} /*2608*/
			if ($1.seqvar.length != 2) { /*2613*/
				$k[$j++] = "bwipp.issnBadSequenceVariantLength"; /*2612*/
				$k[$j++] = "Sequence variant for ISSN must be 2 digits"; /*2612*/
				$0.raiseerror(); /*2612*/
			} /*2612*/
			$forall($1.seqvar, function() { /*2618*/
				var _a = $k[--$j]; /*2615*/
				if ((_a < 48) || (_a > 57)) { /*2617*/
					$k[$j++] = "bwipp.issnSequenceVariantBadCharacter"; /*2616*/
					$k[$j++] = "Sequence variant for ISSN must contain only digits"; /*2616*/
					$0.raiseerror(); /*2616*/
				} /*2616*/
			}); /*2616*/
			if ((($1.addon.length != 0) && ($1.addon.length != 2)) && ($1.addon.length != 5)) { /*2621*/
				$k[$j++] = "bwipp.issnBadAddOnLength"; /*2620*/
				$k[$j++] = "Add-on for ISSN must be 2 or 5 digits"; /*2620*/
				$0.raiseerror(); /*2620*/
			} /*2620*/
			$1.issn = $s(8); /*2624*/
			$1.checksum = 0; /*2625*/
			$1.i = 0; /*2626*/
			$1.n = 0; /*2626*/
			for (;;) { /*2638*/
				$1.issnchar = $get($1.issntxt, $1.i) - 48; /*2628*/
				if ($1.issnchar != -3) { /*2635*/
					$put($1.issn, $1.n, $1.issnchar + 48); /*2630*/
					if ($1.n < 7) { /*2633*/
						$1.checksum = $1.checksum + ($1.issnchar * (8 - $1.n)); /*2632*/
					} /*2632*/
					$1.n = $1.n + 1; /*2634*/
				} /*2634*/
				$1.i = $1.i + 1; /*2636*/
				if ($1.i == $1.issntxt.length) { /*2637*/
					break; /*2637*/
				} /*2637*/
			} /*2637*/
			$1.checksum = (11 - ($1.checksum % 11)) % 11; /*2639*/
			var _w = $1.checksum + 48; /*2640*/
			$k[$j++] = "checksum"; /*2640*/
			$k[$j++] = _w; /*2640*/
			if (_w == 58) { /*2640*/
				$j--; /*2640*/
				$k[$j++] = 88; /*2640*/
			} /*2640*/
			var _x = $k[--$j]; /*2640*/
			$1[$k[--$j]] = _x; /*2640*/
			if ($1.issntxt.length == 9) { /*2645*/
				if ($get($1.issntxt, 8) != $1.checksum) { /*2644*/
					$k[$j++] = "bwipp.issnBadCheckDigit"; /*2643*/
					$k[$j++] = "Incorrect ISSN check digit provided"; /*2643*/
					$0.raiseerror(); /*2643*/
				} /*2643*/
			} /*2643*/
			$1.pad = $s(14); /*2648*/
			$puti($1.pad, 0, "ISSN "); /*2649*/
			$puti($1.pad, 5, $1.issntxt); /*2650*/
			$put($1.pad, 13, $1.checksum); /*2651*/
			$1.issntxt = $1.pad; /*2652*/
			$1.barcode = $geti($1.issn, 0, 7); /*2655*/
			$1.barcode = $s(12); /*2658*/
			$puti($1.barcode, 0, "977"); /*2659*/
			$puti($1.barcode, 3, $1.issn); /*2660*/
			$puti($1.barcode, 10, $1.seqvar); /*2661*/
			if ($ne($1.addon, "")) { /*2670*/
				var _1K = $s((12 + $1.addon.length) + 1); /*2665*/
				$puti(_1K, 0, $1.barcode); /*2666*/
				$puti(_1K, 12, " "); /*2667*/
				$puti(_1K, 13, $1.addon); /*2668*/
				$1.barcode = _1K; /*2669*/
			} /*2669*/
			$1.options.dontdraw = true; /*2673*/
			$1.options.addongap = $1.addongap; /*2674*/
			$k[$j++] = "args"; /*2675*/
			$k[$j++] = $1.barcode; /*2675*/
			$k[$j++] = $1.options; /*2675*/
			$0.ean13(); /*2675*/
			var _1S = $k[--$j]; /*2675*/
			$1[$k[--$j]] = _1S; /*2675*/
			if ($1.includetext) { /*2692*/
				if ($1.issntextxoffset == "unset") { /*2679*/
					$1.issntextxoffset = 10; /*2679*/
				} /*2679*/
				if ($1.issntextyoffset == "unset") { /*2682*/
					$1.issntextyoffset = ($1.height * 72) + 3; /*2681*/
				} /*2681*/
				var _1Z = $1.args.txt !== undefined; /*2683*/
				if (_1Z) { /*2690*/
					$1.txt = $1.args.txt; /*2684*/
					$1.newtxt = $a($1.txt.length + 1); /*2685*/
					$puti($1.newtxt, 0, $1.txt); /*2686*/
					$put($1.newtxt, $1.newtxt.length - 1, $a([$1.issntxt, $1.issntextxoffset, $1.issntextyoffset, $1.issntextfont, $1.issntextsize])); /*2687*/
					$1.args.txt = $1.newtxt; /*2688*/
				} else { /*2690*/
					$1.args.txt = $a([$a([$1.issntxt, $1.issntextxoffset, $1.issntextyoffset, $1.issntextfont, $1.issntextsize])]); /*2690*/
				} /*2690*/
			} /*2690*/
			$1.args.opt = $1.options; /*2694*/
			$k[$j++] = $1.args; /*2697*/
			if (!$1.dontdraw) { /*2697*/
				$0.renlinear(); /*2697*/
			} /*2697*/
		};
		$0.code128 = function() {
			var $1 = {}; /*2724*/
			$1.options = $k[--$j]; /*2726*/
			$1.barcode = $k[--$j]; /*2727*/
			$1.dontdraw = false; /*2729*/
			$1.includetext = false; /*2730*/
			$1.textfont = "Courier"; /*2731*/
			$1.textsize = 10; /*2732*/
			$1.textxoffset = 0; /*2733*/
			$1.textyoffset = -8.5; /*2734*/
			$1.height = 1; /*2735*/
			$1.encoding = "auto"; /*2736*/
			$1.raw = false; /*2737*/
			$1.parse = false; /*2738*/
			$1.parsefnc = false; /*2739*/
			$forall($1.options, function() { /*2750*/
				var _3 = $k[--$j]; /*2750*/
				$1[$k[--$j]] = _3; /*2750*/
			}); /*2750*/
			$1.textfont = "" + $1.textfont; /*2752*/
			$1.textsize = +$1.textsize; /*2753*/
			$1.textxoffset = +$1.textxoffset; /*2754*/
			$1.textyoffset = +$1.textyoffset; /*2755*/
			$1.height = +$1.height; /*2756*/
			$1.barlen = $1.barcode.length; /*2779*/
			$1.sta = -1; /*2782*/
			$1.stb = -2; /*2782*/
			$1.stc = -3; /*2782*/
			$1.swa = -4; /*2783*/
			$1.swb = -5; /*2783*/
			$1.swc = -6; /*2783*/
			$1.fn1 = -7; /*2784*/
			$1.fn2 = -8; /*2784*/
			$1.fn3 = -9; /*2784*/
			$1.fn4 = -10; /*2785*/
			$1.sft = -11; /*2785*/
			$1.stp = -12; /*2785*/
			$1.lka = -13; /*2786*/
			$1.lkc = -14; /*2786*/
			$1.charmaps = $a([$a([32, 32, "00"]), $a(["!", "!", "01"]), $a(["\"", "\"", "02"]), $a(["#", "#", "03"]), $a(["$", "$", "04"]), $a(["%", "%", "05"]), $a(["&", "&", "06"]), $a(["'", "'", "07"]), $a([40, 40, "08"]), $a([41, 41, "09"]), $a(["*", "*", "10"]), $a(["+", "+", "11"]), $a([",", ",", "12"]), $a(["-", "-", "13"]), $a([".", ".", "14"]), $a(["/", "/", "15"]), $a(["0", "0", "16"]), $a(["1", "1", "17"]), $a(["2", "2", "18"]), $a(["3", "3", "19"]), $a(["4", "4", "20"]), $a(["5", "5", "21"]), $a(["6", "6", "22"]), $a(["7", "7", "23"]), $a(["8", "8", "24"]), $a(["9", "9", "25"]), $a([":", ":", "26"]), $a([";", ";", "27"]), $a(["<", "<", "28"]), $a(["=", "=", "29"]), $a([">", ">", "30"]), $a(["?", "?", "31"]), $a(["@", "@", "32"]), $a(["A", "A", "33"]), $a(["B", "B", "34"]), $a(["C", "C", "35"]), $a(["D", "D", "36"]), $a(["E", "E", "37"]), $a(["F", "F", "38"]), $a(["G", "G", "39"]), $a(["H", "H", "40"]), $a(["I", "I", "41"]), $a(["J", "J", "42"]), $a(["K", "K", "43"]), $a(["L", "L", "44"]), $a(["M", "M", "45"]), $a(["N", "N", "46"]), $a(["O", "O", "47"]), $a(["P", "P", "48"]), $a(["Q", "Q", "49"]), $a(["R", "R", "50"]), $a(["S", "S", "51"]), $a(["T", "T", "52"]), $a(["U", "U", "53"]), $a(["V", "V", "54"]), $a(["W", "W", "55"]), $a(["X", "X", "56"]), $a(["Y", "Y", "57"]), $a(["Z", "Z", "58"]), $a(["[", "[", "59"]), $a([92, 92, "60"]), $a(["]", "]", "61"]), $a(["^", "^", "62"]), $a(["_", "_", "63"]), $a([0, "`", "64"]), $a([1, "a", "65"]), $a([2, "b", "66"]), $a([3, "c", "67"]), $a([4, "d", "68"]), $a([5, "e", "69"]), $a([6, "f", "70"]), $a([7, "g", "71"]), $a([8, "h", "72"]), $a([9, "i", "73"]), $a([10, "j", "74"]), $a([11, "k", "75"]), $a([12, "l", "76"]), $a([13, "m", "77"]), $a([14, "n", "78"]), $a([15, "o", "79"]), $a([16, "p", "80"]), $a([17, "q", "81"]), $a([18, "r", "82"]), $a([19, "s", "83"]), $a([20, "t", "84"]), $a([21, "u", "85"]), $a([22, "v", "86"]), $a([23, "w", "87"]), $a([24, "x", "88"]), $a([25, "y", "89"]), $a([26, "z", "90"]), $a([27, "{", "91"]), $a([28, "|", "92"]), $a([29, "}", "93"]), $a([30, "~", "94"]), $a([31, 127, "95"]), $a([$1.fn3, $1.fn3, "96"]), $a([$1.fn2, $1.fn2, "97"]), $a([$1.sft, $1.sft, "98"]), $a([$1.swc, $1.swc, "99"]), $a([$1.swb, $1.fn4, $1.swb]), $a([$1.fn4, $1.swa, $1.swa]), $a([$1.fn1, $1.fn1, $1.fn1]), $a([$1.sta, $1.sta, $1.sta]), $a([$1.stb, $1.stb, $1.stb]), $a([$1.stc, $1.stc, $1.stc]), $a([$1.stp, $1.stp, $1.stp])]); /*2827*/
			$1.charvals = $a([{}, {}, {}]); /*2830*/
			for (var _2R = 0, _2Q = $1.charmaps.length - 1; _2R <= _2Q; _2R += 1) { /*2839*/
				$1.i = _2R; /*2832*/
				$1.encs = $get($1.charmaps, $1.i); /*2833*/
				for (var _2V = 0; _2V <= 2; _2V += 1) { /*2838*/
					$1.j = _2V; /*2835*/
					var _2Y = $get($1.encs, $1.j); /*2836*/
					$k[$j++] = _2Y; /*2836*/
					if ($eq($type(_2Y), "stringtype")) { /*2836*/
						var _2b = $get($k[--$j], 0); /*2836*/
						$k[$j++] = _2b; /*2836*/
					} /*2836*/
					$put($get($1.charvals, $1.j), $k[--$j], $1.i); /*2837*/
				} /*2837*/
			} /*2837*/
			$1.seta = $get($1.charvals, 0); /*2840*/
			$1.setb = $get($1.charvals, 1); /*2841*/
			$1.setc = $get($1.charvals, 2); /*2842*/
			$put($1.seta, $1.lka, $get($1.seta, $1.swb)); /*2845*/
			$put($1.seta, $1.lkc, $get($1.seta, $1.swc)); /*2845*/
			$put($1.setb, $1.lka, $get($1.setb, $1.swc)); /*2846*/
			$put($1.setb, $1.lkc, $get($1.setb, $1.swa)); /*2846*/
			$put($1.setc, $1.lka, $get($1.setc, $1.swa)); /*2847*/
			$put($1.setc, $1.lkc, $get($1.setc, $1.swb)); /*2847*/
			if ($1.raw) { /*2849*/
				$1.encoding = "raw"; /*2849*/
			} /*2849*/
			if ($eq($1.encoding, "raw")) { /*2863*/
				$1.cws = $a($1.barlen); /*2852*/
				$1.i = 0; /*2853*/
				$1.j = 0; /*2853*/
				for (;;) { /*2860*/
					if ($1.i == $1.barlen) { /*2855*/
						break; /*2855*/
					} /*2855*/
					$1.cw = ~~$z($geti($1.barcode, $1.i + 1, 3)); /*2856*/
					$put($1.cws, $1.j, $1.cw); /*2857*/
					$1.i = $1.i + 4; /*2858*/
					$1.j = $1.j + 1; /*2859*/
				} /*2859*/
				$1.cws = $geti($1.cws, 0, $1.j); /*2861*/
				$1.text = ""; /*2862*/
			} /*2862*/
			if ($eq($1.encoding, "auto")) { /*3113*/
				var _3e = {
					FNC1: $1.fn1,
					FNC2: $1.fn2,
					FNC3: $1.fn3,
					LNKA: $1.lka,
					LNKC: $1.lkc
				}; /*2873*/
				$1.fncvals = _3e; /*2874*/
				$1.msg = $a($1.barlen); /*2877*/
				$1.text = $s($1.barlen); /*2878*/
				$1.i = 0; /*2879*/
				$1.j = 0; /*2879*/
				for (;;) { /*2895*/
					if ($1.i == $1.barlen) { /*2880*/
						break; /*2880*/
					} /*2880*/
					$1.char = $get($1.barcode, $1.i); /*2881*/
					$put($1.text, $1.j, $1.char); /*2882*/
					if (($1.parsefnc && ($1.char == 94)) && ($1.i < ($1.barlen - 4))) { /*2891*/
						if ($get($1.barcode, $1.i + 1) != 94) { /*2889*/
							$1.char = $get($1.fncvals, $geti($1.barcode, $1.i + 1, 4)); /*2885*/
							$puti($1.text, $1.j, " "); /*2886*/
							$1.i = $1.i + 4; /*2887*/
						} else { /*2889*/
							$1.i = $1.i + 1; /*2889*/
						} /*2889*/
					} /*2889*/
					$put($1.msg, $1.j, $1.char); /*2892*/
					$1.i = $1.i + 1; /*2893*/
					$1.j = $1.j + 1; /*2894*/
				} /*2894*/
				$1.msg = $geti($1.msg, 0, $1.j); /*2896*/
				$1.msglen = $1.msg.length; /*2897*/
				$1.text = $geti($1.text, 0, $1.j); /*2898*/
				$k[$j++] = Infinity; /*2901*/
				for (var _4K = 0, _4L = $1.msglen; _4K < _4L; _4K++) { /*2901*/
					$k[$j++] = 0; /*2901*/
				} /*2901*/
				$k[$j++] = 0; /*2901*/
				$1.numSA = $a(); /*2901*/
				$k[$j++] = Infinity; /*2902*/
				for (var _4O = 0, _4P = $1.msglen; _4O < _4P; _4O++) { /*2902*/
					$k[$j++] = 0; /*2902*/
				} /*2902*/
				$k[$j++] = 0; /*2902*/
				$1.numEA = $a(); /*2902*/
				for (var _4S = $1.msglen - 1; _4S >= 0; _4S -= 1) { /*2912*/
					$1.i = _4S; /*2904*/
					if ($get($1.msg, $1.i) >= 0) { /*2911*/
						if ($get($1.msg, $1.i) >= 128) { /*2909*/
							$put($1.numEA, $1.i, $get($1.numEA, $1.i + 1) + 1); /*2907*/
						} else { /*2909*/
							$put($1.numSA, $1.i, $get($1.numSA, $1.i + 1) + 1); /*2909*/
						} /*2909*/
					} /*2909*/
				} /*2909*/
				$1.ea = false; /*2915*/
				$1.msgtmp = $a([]); /*2915*/
				for (var _4m = 0, _4l = $1.msglen - 1; _4m <= _4l; _4m += 1) { /*2930*/
					$1.i = _4m; /*2917*/
					$1.c = $get($1.msg, $1.i); /*2918*/
					if ((!$xo($1.ea, $1.c < 128)) && ($1.c >= 0)) { /*2928*/
						if ($1.ea) { /*2920*/
							$k[$j++] = $1.numSA; /*2920*/
						} else { /*2920*/
							$k[$j++] = $1.numEA; /*2920*/
						} /*2920*/
						var _4y = $get($k[--$j], $1.i); /*2920*/
						var _51 = ((_4y + $1.i) == $1.msglen) ? 3 : 5; /*2921*/
						if (_4y < _51) { /*2926*/
							$k[$j++] = Infinity; /*2923*/
							$aload($1.msgtmp); /*2923*/
							$k[$j++] = $1.fn4; /*2923*/
							$1.msgtmp = $a(); /*2923*/
						} else { /*2926*/
							$k[$j++] = Infinity; /*2925*/
							$aload($1.msgtmp); /*2925*/
							$k[$j++] = $1.fn4; /*2925*/
							$k[$j++] = $1.fn4; /*2925*/
							$1.msgtmp = $a(); /*2925*/
							$1.ea = !$1.ea; /*2926*/
						} /*2926*/
					} /*2926*/
					$k[$j++] = Infinity; /*2929*/
					$aload($1.msgtmp); /*2929*/
					if ($1.c >= 0) { /*2929*/
						$k[$j++] = $1.c & 127; /*2929*/
					} else { /*2929*/
						$k[$j++] = $1.c; /*2929*/
					} /*2929*/
					$1.msgtmp = $a(); /*2929*/
				} /*2929*/
				$1.msg = $1.msgtmp; /*2931*/
				$1.msglen = $1.msg.length; /*2932*/
				$1.numsscr = function() {
					$1.n = 0; /*2936*/
					$1.s = 0; /*2936*/
					$1.p = $k[--$j]; /*2937*/
					for (;;) { /*2948*/
						if ($1.p >= $1.msglen) { /*2938*/
							break; /*2938*/
						} /*2938*/
						var _5M = $get($1.msg, $1.p); /*2939*/
						var _5O = $get($1.setc, _5M) !== undefined; /*2940*/
						$k[$j++] = _5M; /*2940*/
						if (!_5O) { /*2940*/
							$j--; /*2940*/
							break; /*2940*/
						} /*2940*/
						if ($k[--$j] == $1.fn1) { /*2944*/
							if (($1.s % 2) == 0) { /*2943*/
								$1.s = $1.s + 1; /*2943*/
							} else { /*2943*/
								break; /*2943*/
							} /*2943*/
						} /*2943*/
						$1.n = $1.n + 1; /*2945*/
						$1.s = $1.s + 1; /*2946*/
						$1.p = $1.p + 1; /*2947*/
					} /*2947*/
					$k[$j++] = $1.n; /*2949*/
					$k[$j++] = $1.s; /*2949*/
				}; /*2950*/
				$1.enca = function() {
					$put($1.cws, $1.j, $get($1.seta, $k[--$j])); /*2954*/
					$1.j = $1.j + 1; /*2955*/
				}; /*2956*/
				$1.encb = function() {
					$put($1.cws, $1.j, $get($1.setb, $k[--$j])); /*2958*/
					$1.j = $1.j + 1; /*2959*/
				}; /*2960*/
				$1.encc = function() {
					var _5k = $k[--$j]; /*2962*/
					$k[$j++] = _5k; /*2966*/
					if ($ne($type(_5k), "arraytype")) { /*2965*/
						var _5o = $get($1.setc, $k[--$j]); /*2963*/
						$k[$j++] = _5o; /*2963*/
					} else { /*2965*/
						$aload($k[--$j]); /*2965*/
						var _5q = $k[--$j]; /*2965*/
						var _5r = $k[--$j]; /*2965*/
						$k[$j++] = (_5q - 48) + ((_5r - 48) * 10); /*2965*/
					} /*2965*/
					$put($1.cws, $1.j, $k[--$j]); /*2967*/
					$1.j = $1.j + 1; /*2968*/
				}; /*2969*/
				$1.anotb = function() {
					var _5w = $k[--$j]; /*2972*/
					var _5y = $get($1.seta, _5w) !== undefined; /*2972*/
					var _60 = $get($1.setb, _5w) !== undefined; /*2972*/
					$k[$j++] = _5y && (!_60); /*2972*/
				}; /*2972*/
				$1.bnota = function() {
					var _61 = $k[--$j]; /*2973*/
					var _63 = $get($1.setb, _61) !== undefined; /*2973*/
					var _65 = $get($1.seta, _61) !== undefined; /*2973*/
					$k[$j++] = _63 && (!_65); /*2973*/
				}; /*2973*/
				$k[$j++] = Infinity; /*2976*/
				for (var _67 = 0, _68 = $1.msg.length; _67 < _68; _67++) { /*2976*/
					$k[$j++] = 0; /*2976*/
				} /*2976*/
				$k[$j++] = 9999; /*2976*/
				$1.nextanotb = $a(); /*2976*/
				$k[$j++] = Infinity; /*2977*/
				for (var _6B = 0, _6C = $1.msg.length; _6B < _6C; _6B++) { /*2977*/
					$k[$j++] = 0; /*2977*/
				} /*2977*/
				$k[$j++] = 9999; /*2977*/
				$1.nextbnota = $a(); /*2977*/
				for (var _6F = $1.msg.length - 1; _6F >= 0; _6F -= 1) { /*2990*/
					$1.i = _6F; /*2979*/
					$k[$j++] = $get($1.msg, $1.i); /*2980*/
					if ($1.anotb() == $b) break; /*2980*/
					if ($k[--$j]) { /*2983*/
						$put($1.nextanotb, $1.i, 0); /*2981*/
					} else { /*2983*/
						$put($1.nextanotb, $1.i, $get($1.nextanotb, $1.i + 1) + 1); /*2983*/
					} /*2983*/
					$k[$j++] = $get($1.msg, $1.i); /*2985*/
					if ($1.bnota() == $b) break; /*2985*/
					if ($k[--$j]) { /*2988*/
						$put($1.nextbnota, $1.i, 0); /*2986*/
					} else { /*2988*/
						$put($1.nextbnota, $1.i, $get($1.nextbnota, $1.i + 1) + 1); /*2988*/
					} /*2988*/
				} /*2988*/
				$1.abeforeb = function() {
					var _6c = $k[--$j]; /*2993*/
					$k[$j++] = $lt($get($1.nextanotb, _6c), $get($1.nextbnota, _6c)); /*2993*/
				}; /*2993*/
				$1.bbeforea = function() {
					var _6h = $k[--$j]; /*2994*/
					$k[$j++] = $lt($get($1.nextbnota, _6h), $get($1.nextanotb, _6h)); /*2994*/
				}; /*2994*/
				$1.cws = $a(($1.barcode.length * 2) + 3); /*2996*/
				$1.j = 0; /*2999*/
				if ($1.msglen > 0) { /*3000*/
					$k[$j++] = 0; /*3000*/
					if ($1.numsscr() == $b) return $b; /*3000*/
				} else { /*3000*/
					$k[$j++] = -1; /*3000*/
					$k[$j++] = -1; /*3000*/
				} /*3000*/
				$1.nums = $k[--$j]; /*3000*/
				$1.nchars = $k[--$j]; /*3000*/
				for (;;) { /*3025*/
					if ($1.msglen == 0) { /*3006*/
						$k[$j++] = $1.stb; /*3003*/
						if ($1.enca() == $b) break; /*3003*/
						$1.cset = "setb"; /*3004*/
						break; /*3005*/
					} /*3005*/
					if (($1.msglen == 2) && ($1.nums == 2)) { /*3011*/
						$k[$j++] = $1.stc; /*3008*/
						if ($1.enca() == $b) break; /*3008*/
						$1.cset = "setc"; /*3009*/
						break; /*3010*/
					} /*3010*/
					if ($1.nums >= 4) { /*3016*/
						$k[$j++] = $1.stc; /*3013*/
						if ($1.enca() == $b) break; /*3013*/
						$1.cset = "setc"; /*3014*/
						break; /*3015*/
					} /*3015*/
					$k[$j++] = 0; /*3017*/
					if ($1.abeforeb() == $b) break; /*3017*/
					if ($k[--$j]) { /*3021*/
						$k[$j++] = $1.sta; /*3018*/
						if ($1.enca() == $b) break; /*3018*/
						$1.cset = "seta"; /*3019*/
						break; /*3020*/
					} /*3020*/
					$k[$j++] = $1.stb; /*3022*/
					if ($1.enca() == $b) break; /*3022*/
					$1.cset = "setb"; /*3023*/
					break; /*3024*/
				} /*3024*/
				$1.i = 0; /*3028*/
				for (;;) { /*3111*/
					if ($1.i == $1.msglen) { /*3029*/
						break; /*3029*/
					} /*3029*/
					$k[$j++] = $1.i; /*3031*/
					if ($1.numsscr() == $b) break; /*3031*/
					$1.nums = $k[--$j]; /*3031*/
					$1.nchars = $k[--$j]; /*3031*/
					for (;;) { /*3109*/
						if ((($eq($1.cset, "seta") || $eq($1.cset, "setb")) && ($1.nums >= 4)) && ($get($1.msg, $1.i) != $1.fn1)) { /*3048*/
							if (($1.nums % 2) == 0) { /*3046*/
								$k[$j++] = $1.swc; /*3038*/
								if ($eq($1.cset, "seta")) { /*3038*/
									if ($1.enca() == $b) break; /*3038*/
								} else { /*3038*/
									if ($1.encb() == $b) break; /*3038*/
								} /*3038*/
								$1.cset = "setc"; /*3039*/
								break; /*3040*/
							} else { /*3046*/
								$k[$j++] = $get($1.msg, $1.i); /*3042*/
								if ($eq($1.cset, "seta")) { /*3042*/
									if ($1.enca() == $b) break; /*3042*/
								} else { /*3042*/
									if ($1.encb() == $b) break; /*3042*/
								} /*3042*/
								$1.i = $1.i + 1; /*3043*/
								$k[$j++] = $1.swc; /*3044*/
								if ($eq($1.cset, "seta")) { /*3044*/
									if ($1.enca() == $b) break; /*3044*/
								} else { /*3044*/
									if ($1.encb() == $b) break; /*3044*/
								} /*3044*/
								$1.cset = "setc"; /*3045*/
								break; /*3046*/
							} /*3046*/
						} /*3046*/
						$k[$j++] = $eq($1.cset, "setb"); /*3049*/
						$k[$j++] = $get($1.msg, $1.i); /*3049*/
						if ($1.anotb() == $b) break; /*3049*/
						var _7R = $k[--$j]; /*3049*/
						if (($k[--$j] && _7R)) { /*3061*/
							if ($1.i < ($1.msglen - 1)) { /*3057*/
								$k[$j++] = $1.i + 1; /*3051*/
								if ($1.bbeforea() == $b) break; /*3051*/
								if ($k[--$j]) { /*3056*/
									$k[$j++] = $1.sft; /*3052*/
									if ($1.encb() == $b) break; /*3052*/
									$k[$j++] = $get($1.msg, $1.i); /*3053*/
									if ($1.enca() == $b) break; /*3053*/
									$1.i = $1.i + 1; /*3054*/
									break; /*3055*/
								} /*3055*/
							} /*3055*/
							$k[$j++] = $1.swa; /*3058*/
							if ($1.encb() == $b) break; /*3058*/
							$1.cset = "seta"; /*3059*/
							break; /*3060*/
						} /*3060*/
						$k[$j++] = $eq($1.cset, "seta"); /*3062*/
						$k[$j++] = $get($1.msg, $1.i); /*3062*/
						if ($1.bnota() == $b) break; /*3062*/
						var _7h = $k[--$j]; /*3062*/
						if (($k[--$j] && _7h)) { /*3074*/
							if ($1.i < ($1.msglen - 1)) { /*3070*/
								$k[$j++] = $1.i + 1; /*3064*/
								if ($1.abeforeb() == $b) break; /*3064*/
								if ($k[--$j]) { /*3069*/
									$k[$j++] = $1.sft; /*3065*/
									if ($1.enca() == $b) break; /*3065*/
									$k[$j++] = $get($1.msg, $1.i); /*3066*/
									if ($1.encb() == $b) break; /*3066*/
									$1.i = $1.i + 1; /*3067*/
									break; /*3068*/
								} /*3068*/
							} /*3068*/
							$k[$j++] = $1.swb; /*3071*/
							if ($1.enca() == $b) break; /*3071*/
							$1.cset = "setb"; /*3072*/
							break; /*3073*/
						} /*3073*/
						if ($eq($1.cset, "setc") && ($1.nums < 2)) { /*3084*/
							$k[$j++] = $1.i; /*3076*/
							if ($1.abeforeb() == $b) break; /*3076*/
							if ($k[--$j]) { /*3080*/
								$k[$j++] = $1.swa; /*3077*/
								if ($1.encc() == $b) break; /*3077*/
								$1.cset = "seta"; /*3078*/
								break; /*3079*/
							} /*3079*/
							$k[$j++] = $1.swb; /*3081*/
							if ($1.encc() == $b) break; /*3081*/
							$1.cset = "setb"; /*3082*/
							break; /*3083*/
						} /*3083*/
						if ($eq($1.cset, "seta")) { /*3091*/
							$k[$j++] = $get($1.msg, $1.i); /*3088*/
							if ($1.enca() == $b) break; /*3088*/
							$1.i = $1.i + 1; /*3089*/
							break; /*3090*/
						} /*3090*/
						if ($eq($1.cset, "setb")) { /*3096*/
							$k[$j++] = $get($1.msg, $1.i); /*3093*/
							if ($1.encb() == $b) break; /*3093*/
							$1.i = $1.i + 1; /*3094*/
							break; /*3095*/
						} /*3095*/
						if ($eq($1.cset, "setc")) { /*3106*/
							if ($get($1.msg, $1.i) == $1.fn1) { /*3103*/
								$k[$j++] = $1.fn1; /*3099*/
								if ($1.encc() == $b) break; /*3099*/
								$1.i = $1.i + 1; /*3100*/
							} else { /*3103*/
								$k[$j++] = $geti($1.msg, $1.i, 2); /*3102*/
								if ($1.encc() == $b) break; /*3102*/
								$1.i = $1.i + 2; /*3103*/
							} /*3103*/
							break; /*3105*/
						} /*3105*/
						break; /*3108*/
					} /*3108*/
				} /*3108*/
				$1.cws = $geti($1.cws, 0, $1.j); /*3112*/
			} /*3112*/
			var _8O = $a($1.j + 2); /*3116*/
			$puti(_8O, 0, $1.cws); /*3116*/
			$1.cws = _8O; /*3116*/
			$1.csum = $get($1.cws, 0); /*3117*/
			for (var _8U = 1, _8T = $1.j - 1; _8U <= _8T; _8U += 1) { /*3121*/
				$1.i = _8U; /*3119*/
				$1.csum = $1.csum + ($get($1.cws, $1.i) * $1.i); /*3120*/
			} /*3120*/
			$1.csum = $1.csum % 103; /*3122*/
			$put($1.cws, $1.j, $1.csum); /*3123*/
			$put($1.cws, $1.j + 1, $get($1.seta, $1.stp)); /*3124*/
			$1.encs = $a(["212222", "222122", "222221", "121223", "121322", "131222", "122213", "122312", "132212", "221213", "221312", "231212", "112232", "122132", "122231", "113222", "123122", "123221", "223211", "221132", "221231", "213212", "223112", "312131", "311222", "321122", "321221", "312212", "322112", "322211", "212123", "212321", "232121", "111323", "131123", "131321", "112313", "132113", "132311", "211313", "231113", "231311", "112133", "112331", "132131", "113123", "113321", "133121", "313121", "211331", "231131", "213113", "213311", "213131", "311123", "311321", "331121", "312113", "312311", "332111", "314111", "221411", "431111", "111224", "111422", "121124", "121421", "141122", "141221", "112214", "112412", "122114", "122411", "142112", "142211", "241211", "221114", "413111", "241112", "134111", "111242", "121142", "121241", "114212", "124112", "124211", "411212", "421112", "421211", "212141", "214121", "412121", "111143", "111341", "131141", "114113", "114311", "411113", "411311", "113141", "114131", "311141", "411131", "211412", "211214", "211232", "2331112"]); /*3144*/
			$1.sbs = $s(($1.cws.length * 6) + 1); /*3147*/
			for (var _8o = 0, _8n = $1.cws.length - 1; _8o <= _8n; _8o += 1) { /*3151*/
				$1.i = _8o; /*3149*/
				$puti($1.sbs, $1.i * 6, $get($1.encs, $get($1.cws, $1.i))); /*3150*/
			} /*3150*/
			$k[$j++] = Infinity; /*3161*/
			$k[$j++] = "ren"; /*3157*/
			$k[$j++] = $0.renlinear; /*3157*/
			$k[$j++] = "sbs"; /*3157*/
			$k[$j++] = Infinity; /*3157*/
			var _8w = $1.sbs; /*3156*/
			for (var _8x = 0, _8y = _8w.length; _8x < _8y; _8x++) { /*3156*/
				$k[$j++] = $get(_8w, _8x) - 48; /*3156*/
			} /*3156*/
			var _90 = $a(); /*3157*/
			$k[$j++] = _90; /*3158*/
			$k[$j++] = "bhs"; /*3158*/
			$k[$j++] = Infinity; /*3158*/
			for (var _92 = 0, _93 = ~~(($1.sbs.length + 1) / 2); _92 < _93; _92++) { /*3157*/
				$k[$j++] = $1.height; /*3157*/
			} /*3157*/
			var _95 = $a(); /*3158*/
			$k[$j++] = _95; /*3159*/
			$k[$j++] = "bbs"; /*3159*/
			$k[$j++] = Infinity; /*3159*/
			for (var _97 = 0, _98 = ~~(($1.sbs.length + 1) / 2); _97 < _98; _97++) { /*3158*/
				$k[$j++] = 0; /*3158*/
			} /*3158*/
			var _99 = $a(); /*3159*/
			$k[$j++] = _99; /*3161*/
			$k[$j++] = "txt"; /*3161*/
			$k[$j++] = $a([$a([$1.text, $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])]); /*3161*/
			$k[$j++] = "textxalign"; /*3161*/
			$k[$j++] = "center"; /*3161*/
			$k[$j++] = "opt"; /*3161*/
			$k[$j++] = $1.options; /*3161*/
			var _9I = $d(); /*3161*/
			$k[$j++] = _9I; /*3164*/
			if (!$1.dontdraw) { /*3164*/
				$0.renlinear(); /*3164*/
			} /*3164*/
		};
		$0["gs1-128"] = function() {
			var $1 = {}; /*3192*/
			$1.options = $k[--$j]; /*3194*/
			$1.barcode = $k[--$j]; /*3195*/
			$1.dontdraw = false; /*3197*/
			$1.includetext = false; /*3198*/
			$1.textfont = "Courier"; /*3199*/
			$1.textsize = 10; /*3200*/
			$1.textxoffset = 0; /*3201*/
			$1.textyoffset = -8.5; /*3202*/
			$1.height = 0.5; /*3203*/
			$1.linkagea = false; /*3204*/
			$1.linkagec = false; /*3205*/
			$forall($1.options, function() { /*3216*/
				var _3 = $k[--$j]; /*3216*/
				$1[$k[--$j]] = _3; /*3216*/
			}); /*3216*/
			$1.textfont = "" + $1.textfont; /*3218*/
			$1.textsize = +$1.textsize; /*3219*/
			$1.textxoffset = +$1.textxoffset; /*3220*/
			$1.textyoffset = +$1.textyoffset; /*3221*/
			$1.height = +$1.height; /*3222*/
			$1.text = $1.barcode; /*3224*/
			$1.expand = function() {
				$1.in = $k[--$j]; /*3228*/
				$1.out = $s($1.in.length); /*3229*/
				$1.j = 0; /*3230*/
				$k[$j++] = $1.in; /*3244*/
				for (;;) { /*3244*/
					$search($k[--$j], "^"); /*3233*/
					if ($k[--$j]) { /*3242*/
						var _H = $k[--$j]; /*3234*/
						$puti($1.out, $1.j, _H); /*3234*/
						$1.j = (_H.length + $1.j) + 1; /*3235*/
						$j--; /*3236*/
						var _L = $k[--$j]; /*3237*/
						$put($1.out, $1.j - 1, ~~$z($geti(_L, 0, 3))); /*3237*/
						$k[$j++] = $geti(_L, 3, _L.length - 3); /*3238*/
					} else { /*3242*/
						var _Q = $k[--$j]; /*3240*/
						$puti($1.out, $1.j, _Q); /*3240*/
						$1.j = _Q.length + $1.j; /*3241*/
						$k[$j++] = $geti($1.out, 0, $1.j); /*3242*/
						break; /*3242*/
					} /*3242*/
				} /*3242*/
			}; /*3245*/
			$1.ais = $a([]); /*3248*/
			$1.vals = $a([]); /*3249*/
			var _Z = $1.barcode; /*3250*/
			$k[$j++] = $geti(_Z, 1, _Z.length - 1); /*3263*/
			for (;;) { /*3263*/
				var _b = $k[--$j]; /*3252*/
				$k[$j++] = _b; /*3252*/
				if ($eq(_b, "")) { /*3252*/
					break; /*3252*/
				} /*3252*/
				$search($k[--$j], ")"); /*3253*/
				$j--; /*3253*/
				var _d = $k[--$j]; /*3254*/
				var _e = $k[--$j]; /*3254*/
				var _f = $k[--$j]; /*3255*/
				$k[$j++] = _d; /*3255*/
				$search(_f, "("); /*3255*/
				if ($k[--$j]) { /*3258*/
					var _h = $k[--$j]; /*3256*/
					var _i = $k[--$j]; /*3256*/
					var _j = $k[--$j]; /*3256*/
					var _k = $k[--$j]; /*3256*/
					$k[$j++] = _j; /*3256*/
					$k[$j++] = _k; /*3256*/
					$k[$j++] = _h; /*3256*/
				} else { /*3258*/
					var _l = $k[--$j]; /*3258*/
					var _m = $k[--$j]; /*3258*/
					$k[$j++] = ""; /*3258*/
					$k[$j++] = _m; /*3258*/
					$k[$j++] = _l; /*3258*/
				} /*3258*/
				$k[$j++] = Infinity; /*3260*/
				$aload($1.ais); /*3260*/
				var _p = $k[$j - 1 - ($counttomark() + 2)]; /*3260*/
				$k[$j++] = _p; /*3260*/
				$1.ais = $a(); /*3260*/
				$k[$j++] = Infinity; /*3261*/
				$aload($1.vals); /*3261*/
				var _t = $k[$j - 1 - ($counttomark() + 1)]; /*3261*/
				$k[$j++] = _t; /*3261*/
				if ($1.expand() == $b) break; /*3261*/
				$1.vals = $a(); /*3261*/
				$j -= 2; /*3262*/
			} /*3262*/
			$j--; /*3264*/
			$1.aifixed = {}; /*3269*/
			$k[$j++] = Infinity; /*3271*/
			for (var _v = 0; _v <= 4; _v += 1) { /*3271*/
				$k[$j++] = _v; /*3271*/
			} /*3271*/
			var _w = $a(); /*3271*/
			for (var _x = 0, _y = _w.length; _x < _y; _x++) { /*3274*/
				var _11 = $strcpy($s(2), "00"); /*3273*/
				$put(_11, 1, $get(_w, _x) + 48); /*3273*/
				$put($1.aifixed, _11, _11); /*3273*/
			} /*3273*/
			$k[$j++] = Infinity; /*3279*/
			for (var _13 = 11; _13 <= 20; _13 += 1) { /*3276*/
				$k[$j++] = _13; /*3276*/
			} /*3276*/
			$k[$j++] = 23; /*3278*/
			for (var _14 = 31; _14 <= 36; _14 += 1) { /*3278*/
				$k[$j++] = _14; /*3278*/
			} /*3278*/
			$k[$j++] = 41; /*3279*/
			var _15 = $a(); /*3279*/
			for (var _16 = 0, _17 = _15.length; _16 < _17; _16++) { /*3282*/
				var _1A = $cvrs($s(2), $get(_15, _16), 10); /*3281*/
				$put($1.aifixed, _1A, _1A); /*3281*/
			} /*3281*/
			$1.fnc1 = -1; /*3285*/
			$1.c128 = $a([$1.fnc1]); /*3286*/
			for (var _1G = 0, _1F = $1.ais.length - 1; _1G <= _1F; _1G += 1) { /*3302*/
				$1.i = _1G; /*3288*/
				$1.ai = $get($1.ais, $1.i); /*3289*/
				$1.val = $get($1.vals, $1.i); /*3290*/
				var _1Q = $a(($1.c128.length + $1.ai.length) + $1.val.length); /*3291*/
				$puti(_1Q, 0, $1.c128); /*3292*/
				$k[$j++] = _1Q; /*3293*/
				$k[$j++] = _1Q; /*3293*/
				$k[$j++] = $1.c128.length; /*3293*/
				$k[$j++] = $1.ai; /*3293*/
				$k[$j++] = Infinity; /*3293*/
				var _1U = $k[--$j]; /*3293*/
				var _1V = $k[--$j]; /*3293*/
				$k[$j++] = _1U; /*3293*/
				$forall(_1V); /*3293*/
				var _1W = $a(); /*3293*/
				var _1X = $k[--$j]; /*3293*/
				$puti($k[--$j], _1X, _1W); /*3293*/
				var _1Z = $k[--$j]; /*3294*/
				$k[$j++] = _1Z; /*3294*/
				$k[$j++] = _1Z; /*3294*/
				$k[$j++] = $1.c128.length + $1.ai.length; /*3294*/
				$k[$j++] = $1.val; /*3294*/
				$k[$j++] = Infinity; /*3294*/
				var _1d = $k[--$j]; /*3294*/
				var _1e = $k[--$j]; /*3294*/
				$k[$j++] = _1d; /*3294*/
				$forall(_1e); /*3294*/
				var _1f = $a(); /*3294*/
				var _1g = $k[--$j]; /*3294*/
				$puti($k[--$j], _1g, _1f); /*3294*/
				$1.c128 = $k[--$j]; /*3295*/
				var _1o = $get($1.aifixed, $geti($1.ai, 0, 2)) !== undefined; /*3296*/
				if (($1.i != ($1.ais.length - 1)) && (!_1o)) { /*3301*/
					var _1q = $a($1.c128.length + 1); /*3297*/
					$puti(_1q, 0, $1.c128); /*3298*/
					$put(_1q, $1.c128.length, $1.fnc1); /*3299*/
					$1.c128 = _1q; /*3300*/
				} /*3300*/
			} /*3300*/
			$1.barcode = $s(($1.c128.length + 1) * 5); /*3305*/
			$1.i = 0; /*3306*/
			$1.j = 0; /*3306*/
			for (;;) { /*3316*/
				if ($1.i == $1.c128.length) { /*3307*/
					break; /*3307*/
				} /*3307*/
				var _20 = $get($1.c128, $1.i); /*3308*/
				$k[$j++] = _20; /*3313*/
				if (_20 == $1.fnc1) { /*3312*/
					$j--; /*3309*/
					$puti($1.barcode, $1.j, "^FNC1"); /*3309*/
					$1.j = $1.j + 4; /*3310*/
				} else { /*3312*/
					$put($1.barcode, $1.j, $k[--$j]); /*3312*/
				} /*3312*/
				$1.i = $1.i + 1; /*3314*/
				$1.j = $1.j + 1; /*3315*/
			} /*3315*/
			if ($1.linkagea || $1.linkagec) { /*3320*/
				$k[$j++] = $1.barcode; /*3318*/
				$k[$j++] = $1.j; /*3318*/
				if ($1.linkagea) { /*3318*/
					$k[$j++] = "^LNKA"; /*3318*/
				} else { /*3318*/
					$k[$j++] = "^LNKC"; /*3318*/
				} /*3318*/
				var _2F = $k[--$j]; /*3318*/
				var _2G = $k[--$j]; /*3318*/
				$puti($k[--$j], _2G, _2F); /*3318*/
				$1.j = $1.j + 5; /*3319*/
			} /*3319*/
			$1.barcode = $geti($1.barcode, 0, $1.j); /*3321*/
			$1.options.height = $1.height; /*3324*/
			$1.options.dontdraw = true; /*3325*/
			$1.options.parsefnc = true; /*3326*/
			$k[$j++] = "args"; /*3327*/
			$k[$j++] = $1.barcode; /*3327*/
			$k[$j++] = $1.options; /*3327*/
			$0.code128(); /*3327*/
			var _2S = $k[--$j]; /*3327*/
			$1[$k[--$j]] = _2S; /*3327*/
			$1.args.txt = $a([$a([$1.text, $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])]); /*3329*/
			$1.args.textxalign = "center"; /*3330*/
			$1.args.opt = $1.options; /*3331*/
			$k[$j++] = $1.args; /*3334*/
			if (!$1.dontdraw) { /*3334*/
				$0.renlinear(); /*3334*/
			} /*3334*/
		};
		$0.ean14 = function() {
			var $1 = {}; /*3362*/
			$1.options = $k[--$j]; /*3364*/
			$1.barcode = $k[--$j]; /*3365*/
			$1.dontdraw = false; /*3367*/
			$1.includetext = false; /*3368*/
			$1.textfont = "Courier"; /*3369*/
			$1.textsize = 10; /*3370*/
			$1.textxoffset = 0; /*3371*/
			$1.textyoffset = -8.5; /*3372*/
			$1.height = 1; /*3373*/
			$forall($1.options, function() { /*3384*/
				var _3 = $k[--$j]; /*3384*/
				$1[$k[--$j]] = _3; /*3384*/
			}); /*3384*/
			$1.textfont = "" + $1.textfont; /*3386*/
			$1.textsize = +$1.textsize; /*3387*/
			$1.textxoffset = +$1.textxoffset; /*3388*/
			$1.textyoffset = +$1.textyoffset; /*3389*/
			$1.height = +$1.height; /*3390*/
			$1.text = $1.barcode; /*3393*/
			var _B = $1.barcode; /*3394*/
			$k[$j++] = $s(_B.length); /*3395*/
			$k[$j++] = 0; /*3395*/
			$forall(_B, function() { /*3395*/
				var _D = $k[--$j]; /*3395*/
				$k[$j++] = _D; /*3395*/
				if (_D != 32) { /*3395*/
					var _E = $k[--$j]; /*3395*/
					var _F = $k[--$j]; /*3395*/
					var _G = $k[--$j]; /*3395*/
					$put(_G, _F, _E); /*3395*/
					$k[$j++] = _G; /*3395*/
					$k[$j++] = _F + 1; /*3395*/
				} else { /*3395*/
					$j--; /*3395*/
				} /*3395*/
			}); /*3395*/
			var _H = $k[--$j]; /*3396*/
			$1.barcode = $geti($k[--$j], 0, _H); /*3396*/
			$1.hasspace = $1.text.length != $1.barcode.length; /*3397*/
			if ($ne($geti($1.barcode, 0, 4), "(01)")) { /*3402*/
				$k[$j++] = "bwipp.ean14badAI"; /*3401*/
				$k[$j++] = "GS1-14 must begin with (01) application identifier"; /*3401*/
				$0.raiseerror(); /*3401*/
			} /*3401*/
			if (($1.barcode.length != 17) && ($1.barcode.length != 18)) { /*3405*/
				$k[$j++] = "bwipp.ean14badLength"; /*3404*/
				$k[$j++] = "GS1-14 must be 13 or 14 digits"; /*3404*/
				$0.raiseerror(); /*3404*/
			} /*3404*/
			$forall($geti($1.barcode, 4, $1.barcode.length - 4), function() { /*3410*/
				var _T = $k[--$j]; /*3407*/
				if ((_T < 48) || (_T > 57)) { /*3409*/
					$k[$j++] = "bwipp.ean14badCharacter"; /*3408*/
					$k[$j++] = "GS1-14 must contain only digits"; /*3408*/
					$0.raiseerror(); /*3408*/
				} /*3408*/
			}); /*3408*/
			$1.checksum = 0; /*3413*/
			for (var _U = 0; _U <= 12; _U += 1) { /*3417*/
				$1.i = _U; /*3415*/
				$k[$j++] = "checksum"; /*3416*/
				$k[$j++] = $1.checksum; /*3416*/
				$k[$j++] = $get($1.barcode, $1.i + 4) - 48; /*3416*/
				if (($1.i % 2) == 0) { /*3416*/
					var _a = $k[--$j]; /*3416*/
					$k[$j++] = _a * 3; /*3416*/
				} /*3416*/
				var _b = $k[--$j]; /*3416*/
				var _c = $k[--$j]; /*3416*/
				$1[$k[--$j]] = _c + _b; /*3416*/
			} /*3416*/
			$1.checksum = (10 - ($1.checksum % 10)) % 10; /*3418*/
			if ($1.barcode.length == 18) { /*3432*/
				if ($get($1.barcode, 17) != ($1.checksum + 48)) { /*3422*/
					$k[$j++] = "bwipp.ean14badCheckDigit"; /*3421*/
					$k[$j++] = "Incorrect GS1-14 check digit provided"; /*3421*/
					$0.raiseerror(); /*3421*/
				} /*3421*/
			} else { /*3432*/
				var _j = $s(18); /*3424*/
				$puti(_j, 0, $1.barcode); /*3425*/
				$put(_j, 17, $1.checksum + 48); /*3426*/
				$1.barcode = _j; /*3427*/
				var _o = $1.hasspace ? 2 : 1; /*3428*/
				var _p = $s($1.text.length + _o); /*3428*/
				$puti(_p, _p.length - 2, " "); /*3429*/
				$put(_p, _p.length - 1, $1.checksum + 48); /*3430*/
				$puti(_p, 0, $1.text); /*3431*/
				$1.text = _p; /*3432*/
			} /*3432*/
			$1.gtin = $geti($1.barcode, 4, 14); /*3434*/
			$1.barcode = $s(21); /*3437*/
			$puti($1.barcode, 0, "^FNC101"); /*3438*/
			$puti($1.barcode, 7, $1.gtin); /*3439*/
			$1.options.dontdraw = true; /*3442*/
			$1.options.parsefnc = true; /*3443*/
			$k[$j++] = "args"; /*3444*/
			$k[$j++] = $1.barcode; /*3444*/
			$k[$j++] = $1.options; /*3444*/
			$0.code128(); /*3444*/
			var _12 = $k[--$j]; /*3444*/
			$1[$k[--$j]] = _12; /*3444*/
			$1.args.txt = $a([$a([$1.text, $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])]); /*3446*/
			$1.args.textxalign = "center"; /*3447*/
			$1.args.opt = $1.options; /*3448*/
			$k[$j++] = $1.args; /*3451*/
			if (!$1.dontdraw) { /*3451*/
				$0.renlinear(); /*3451*/
			} /*3451*/
		};
		$0.sscc18 = function() {
			var $1 = {}; /*3479*/
			$1.options = $k[--$j]; /*3481*/
			$1.barcode = $k[--$j]; /*3482*/
			$1.dontdraw = false; /*3484*/
			$1.includetext = false; /*3485*/
			$1.textfont = "Courier"; /*3486*/
			$1.textsize = 10; /*3487*/
			$1.textxoffset = 0; /*3488*/
			$1.textyoffset = -8.5; /*3489*/
			$1.height = 1; /*3490*/
			$forall($1.options, function() { /*3501*/
				var _3 = $k[--$j]; /*3501*/
				$1[$k[--$j]] = _3; /*3501*/
			}); /*3501*/
			$1.textfont = "" + $1.textfont; /*3503*/
			$1.textsize = +$1.textsize; /*3504*/
			$1.textxoffset = +$1.textxoffset; /*3505*/
			$1.textyoffset = +$1.textyoffset; /*3506*/
			$1.height = +$1.height; /*3507*/
			$1.text = $1.barcode; /*3510*/
			var _B = $1.barcode; /*3511*/
			$k[$j++] = $s(_B.length); /*3512*/
			$k[$j++] = 0; /*3512*/
			$forall(_B, function() { /*3512*/
				var _D = $k[--$j]; /*3512*/
				$k[$j++] = _D; /*3512*/
				if (_D != 32) { /*3512*/
					var _E = $k[--$j]; /*3512*/
					var _F = $k[--$j]; /*3512*/
					var _G = $k[--$j]; /*3512*/
					$put(_G, _F, _E); /*3512*/
					$k[$j++] = _G; /*3512*/
					$k[$j++] = _F + 1; /*3512*/
				} else { /*3512*/
					$j--; /*3512*/
				} /*3512*/
			}); /*3512*/
			var _H = $k[--$j]; /*3513*/
			$1.barcode = $geti($k[--$j], 0, _H); /*3513*/
			$1.hasspace = $1.text.length != $1.barcode.length; /*3514*/
			if ($ne($geti($1.barcode, 0, 4), "(00)")) { /*3519*/
				$k[$j++] = "bwipp.sscc18badAI"; /*3518*/
				$k[$j++] = "SSCC-18 must begin with (00) application identifier"; /*3518*/
				$0.raiseerror(); /*3518*/
			} /*3518*/
			if (($1.barcode.length != 21) && ($1.barcode.length != 22)) { /*3522*/
				$k[$j++] = "bwipp.sscc18badLength"; /*3521*/
				$k[$j++] = "SSCC-18 must be 17 or 18 digits"; /*3521*/
				$0.raiseerror(); /*3521*/
			} /*3521*/
			$forall($geti($1.barcode, 4, $1.barcode.length - 4), function() { /*3527*/
				var _T = $k[--$j]; /*3524*/
				if ((_T < 48) || (_T > 57)) { /*3526*/
					$k[$j++] = "bwipp.sscc18badCharacter"; /*3525*/
					$k[$j++] = "SSCC-18 must contain only digits"; /*3525*/
					$0.raiseerror(); /*3525*/
				} /*3525*/
			}); /*3525*/
			$1.checksum = 0; /*3530*/
			for (var _U = 0; _U <= 16; _U += 1) { /*3534*/
				$1.i = _U; /*3532*/
				$k[$j++] = "checksum"; /*3533*/
				$k[$j++] = $1.checksum; /*3533*/
				$k[$j++] = $get($1.barcode, $1.i + 4) - 48; /*3533*/
				if (($1.i % 2) == 0) { /*3533*/
					var _a = $k[--$j]; /*3533*/
					$k[$j++] = _a * 3; /*3533*/
				} /*3533*/
				var _b = $k[--$j]; /*3533*/
				var _c = $k[--$j]; /*3533*/
				$1[$k[--$j]] = _c + _b; /*3533*/
			} /*3533*/
			$1.checksum = (10 - ($1.checksum % 10)) % 10; /*3535*/
			if ($1.barcode.length == 22) { /*3549*/
				if ($get($1.barcode, 21) != ($1.checksum + 48)) { /*3539*/
					$k[$j++] = "bwipp.sscc18badCheckDigit"; /*3538*/
					$k[$j++] = "Incorrect SSCC-18 check digit provided"; /*3538*/
					$0.raiseerror(); /*3538*/
				} /*3538*/
			} else { /*3549*/
				var _j = $s(22); /*3541*/
				$puti(_j, 0, $1.barcode); /*3542*/
				$put(_j, 21, $1.checksum + 48); /*3543*/
				$1.barcode = _j; /*3544*/
				var _o = $1.hasspace ? 2 : 1; /*3545*/
				var _p = $s($1.text.length + _o); /*3545*/
				$puti(_p, _p.length - 2, " "); /*3546*/
				$put(_p, _p.length - 1, $1.checksum + 48); /*3547*/
				$puti(_p, 0, $1.text); /*3548*/
				$1.text = _p; /*3549*/
			} /*3549*/
			$1.sscc = $geti($1.barcode, 4, 18); /*3551*/
			$1.barcode = $s(25); /*3554*/
			$puti($1.barcode, 0, "^FNC100"); /*3555*/
			$puti($1.barcode, 7, $1.sscc); /*3556*/
			$1.options.dontdraw = true; /*3559*/
			$1.options.parsefnc = true; /*3560*/
			$k[$j++] = "args"; /*3561*/
			$k[$j++] = $1.barcode; /*3561*/
			$k[$j++] = $1.options; /*3561*/
			$0.code128(); /*3561*/
			var _12 = $k[--$j]; /*3561*/
			$1[$k[--$j]] = _12; /*3561*/
			$1.args.txt = $a([$a([$1.text, $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])]); /*3563*/
			$1.args.textxalign = "center"; /*3564*/
			$1.args.opt = $1.options; /*3565*/
			$k[$j++] = $1.args; /*3568*/
			if (!$1.dontdraw) { /*3568*/
				$0.renlinear(); /*3568*/
			} /*3568*/
		};
		$0.code39 = function() {
			var $1 = {}; /*3595*/
			$1.options = $k[--$j]; /*3597*/
			$1.barcode = $k[--$j]; /*3598*/
			$1.dontdraw = false; /*3600*/
			$1.includecheck = false; /*3601*/
			$1.validatecheck = false; /*3602*/
			$1.includetext = false; /*3603*/
			$1.includecheckintext = false; /*3604*/
			$1.hidestars = false; /*3605*/
			$1.textfont = "Courier"; /*3606*/
			$1.textsize = 10; /*3607*/
			$1.textyoffset = -8.5; /*3608*/
			$1.height = 1; /*3609*/
			$forall($1.options, function() { /*3620*/
				var _3 = $k[--$j]; /*3620*/
				$1[$k[--$j]] = _3; /*3620*/
			}); /*3620*/
			$1.textfont = "" + $1.textfont; /*3622*/
			$1.textsize = +$1.textsize; /*3623*/
			$1.textyoffset = +$1.textyoffset; /*3624*/
			$1.height = +$1.height; /*3625*/
			$1.barchars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%"; /*3628*/
			$1.charvals = {}; /*3629*/
			for (var _9 = 0; _9 <= 42; _9 += 1) { /*3630*/
				$put($1.charvals, $geti($1.barchars, _9, 1), _9); /*3630*/
			} /*3630*/
			for (var _F = 0, _E = $1.barcode.length - 1; _F <= _E; _F += 1) { /*3637*/
				var _J = $get($1.charvals, $geti($1.barcode, _F, 1)) !== undefined; /*3634*/
				if (!_J) { /*3636*/
					$k[$j++] = "bwipp.code39badCharacter"; /*3635*/
					$k[$j++] = "Code 39 must contain only digits, capital letters, spaces and the symbols -.$/+%"; /*3635*/
					$0.raiseerror(); /*3635*/
				} /*3635*/
			} /*3635*/
			$k[$j++] = "barlen"; /*3639*/
			$k[$j++] = $1.barcode.length; /*3639*/
			if ($1.validatecheck) { /*3639*/
				var _M = $k[--$j]; /*3639*/
				$k[$j++] = _M - 1; /*3639*/
			} /*3639*/
			var _N = $k[--$j]; /*3639*/
			$1[$k[--$j]] = _N; /*3639*/
			$1.checksum = 0; /*3641*/
			for (var _R = 0, _Q = $1.barlen - 1; _R <= _Q; _R += 1) { /*3645*/
				$1.checksum = $get($1.charvals, $geti($1.barcode, _R, 1)) + $1.checksum; /*3644*/
			} /*3644*/
			$1.checksum = $1.checksum % 43; /*3646*/
			if ($1.validatecheck) { /*3653*/
				if ($get($1.barcode, $1.barlen) != $get($1.barchars, $1.checksum)) { /*3650*/
					$k[$j++] = "bwipp.code39badCheckDigit"; /*3649*/
					$k[$j++] = "Incorrect Code 39 check digit provided"; /*3649*/
					$0.raiseerror(); /*3649*/
				} /*3649*/
				$1.barcode = $geti($1.barcode, 0, $1.barlen); /*3651*/
				$1.includecheck = true; /*3652*/
			} /*3652*/
			$1.encs = $a(["1113313111", "3113111131", "1133111131", "3133111111", "1113311131", "3113311111", "1133311111", "1113113131", "3113113111", "1133113111", "3111131131", "1131131131", "3131131111", "1111331131", "3111331111", "1131331111", "1111133131", "3111133111", "1131133111", "1111333111", "3111111331", "1131111331", "3131111311", "1111311331", "3111311311", "1131311311", "1111113331", "3111113311", "1131113311", "1111313311", "3311111131", "1331111131", "3331111111", "1311311131", "3311311111", "1331311111", "1311113131", "3311113111", "1331113111", "1313131111", "1313111311", "1311131311", "1113131311", "1311313111"]); /*3666*/
			var _l = $1.includecheck ? 3 : 2; /*3668*/
			$1.sbs = $s(($1.barlen + _l) * 10); /*3668*/
			var _p = $1.includecheck ? 3 : 2; /*3669*/
			$1.txt = $a($1.barlen + _p); /*3669*/
			$puti($1.sbs, 0, $get($1.encs, 43)); /*3672*/
			if (!$1.hidestars) { /*3676*/
				$put($1.txt, 0, $a(["*", 0, $1.textyoffset, $1.textfont, $1.textsize])); /*3674*/
			} else { /*3676*/
				$put($1.txt, 0, $a(["", 0, $1.textyoffset, $1.textfont, $1.textsize])); /*3676*/
			} /*3676*/
			for (var _17 = 0, _16 = $1.barlen - 1; _17 <= _16; _17 += 1) { /*3684*/
				$1.i = _17; /*3680*/
				$1.indx = $get($1.charvals, $geti($1.barcode, $1.i, 1)); /*3681*/
				$puti($1.sbs, ($1.i * 10) + 10, $get($1.encs, $1.indx)); /*3682*/
				$put($1.txt, $1.i + 1, $a([$geti($1.barcode, $1.i, 1), ($1.i + 1) * 16, $1.textyoffset, $1.textfont, $1.textsize])); /*3683*/
			} /*3683*/
			if ($1.includecheck) { /*3705*/
				$puti($1.sbs, ($1.barlen * 10) + 10, $get($1.encs, $1.checksum)); /*3688*/
				if ($1.includecheckintext) { /*3692*/
					$put($1.txt, $1.barlen + 1, $a([$geti($1.barchars, $1.checksum, 1), ($1.barlen + 1) * 16, $1.textyoffset, $1.textfont, $1.textsize])); /*3690*/
				} else { /*3692*/
					$put($1.txt, $1.barlen + 1, $a(["", ($1.barlen + 1) * 16, $1.textyoffset, $1.textfont, $1.textsize])); /*3692*/
				} /*3692*/
				$puti($1.sbs, ($1.barlen * 10) + 20, $get($1.encs, 43)); /*3694*/
				if (!$1.hidestars) { /*3698*/
					$put($1.txt, $1.barlen + 2, $a(["*", ($1.barlen + 2) * 16, $1.textyoffset, $1.textfont, $1.textsize])); /*3696*/
				} else { /*3698*/
					$put($1.txt, $1.barlen + 2, $a(["", ($1.barlen + 2) * 16, $1.textyoffset, $1.textfont, $1.textsize])); /*3698*/
				} /*3698*/
			} else { /*3705*/
				$puti($1.sbs, ($1.barlen * 10) + 10, $get($1.encs, 43)); /*3701*/
				if (!$1.hidestars) { /*3705*/
					$put($1.txt, $1.barlen + 1, $a(["*", ($1.barlen + 1) * 16, $1.textyoffset, $1.textfont, $1.textsize])); /*3703*/
				} else { /*3705*/
					$put($1.txt, $1.barlen + 1, $a(["", ($1.barlen + 1) * 16, $1.textyoffset, $1.textfont, $1.textsize])); /*3705*/
				} /*3705*/
			} /*3705*/
			$k[$j++] = Infinity; /*3718*/
			$k[$j++] = "ren"; /*3713*/
			$k[$j++] = $0.renlinear; /*3713*/
			$k[$j++] = "sbs"; /*3713*/
			$k[$j++] = Infinity; /*3713*/
			var _2S = $1.sbs; /*3712*/
			for (var _2T = 0, _2U = _2S.length; _2T < _2U; _2T++) { /*3712*/
				$k[$j++] = $get(_2S, _2T) - 48; /*3712*/
			} /*3712*/
			var _2W = $a(); /*3713*/
			$k[$j++] = _2W; /*3714*/
			$k[$j++] = "bhs"; /*3714*/
			$k[$j++] = Infinity; /*3714*/
			for (var _2Y = 0, _2Z = ~~(($1.sbs.length + 1) / 2); _2Y < _2Z; _2Y++) { /*3713*/
				$k[$j++] = $1.height; /*3713*/
			} /*3713*/
			var _2b = $a(); /*3714*/
			$k[$j++] = _2b; /*3715*/
			$k[$j++] = "bbs"; /*3715*/
			$k[$j++] = Infinity; /*3715*/
			for (var _2d = 0, _2e = ~~(($1.sbs.length + 1) / 2); _2d < _2e; _2d++) { /*3714*/
				$k[$j++] = 0; /*3714*/
			} /*3714*/
			var _2f = $a(); /*3715*/
			$k[$j++] = _2f; /*3717*/
			if ($1.includetext) { /*3717*/
				$k[$j++] = "txt"; /*3716*/
				$k[$j++] = $1.txt; /*3716*/
			} /*3716*/
			$k[$j++] = "opt"; /*3718*/
			$k[$j++] = $1.options; /*3718*/
			var _2j = $d(); /*3718*/
			$k[$j++] = _2j; /*3721*/
			if (!$1.dontdraw) { /*3721*/
				$0.renlinear(); /*3721*/
			} /*3721*/
		};
		$0.code39ext = function() {
			var $1 = {}; /*3749*/
			$1.options = $k[--$j]; /*3751*/
			$1.barcode = $k[--$j]; /*3752*/
			$1.dontdraw = false; /*3754*/
			$1.includetext = false; /*3755*/
			$1.parse = false; /*3756*/
			$forall($1.options, function() { /*3767*/
				var _3 = $k[--$j]; /*3767*/
				$1[$k[--$j]] = _3; /*3767*/
			}); /*3767*/
			$forall($1.barcode, function() { /*3795*/
				if ($k[--$j] >= 128) { /*3794*/
					$k[$j++] = "bwipp.code39extBadCharacter"; /*3793*/
					$k[$j++] = "Code 39 Extended must contain only ASCII characters"; /*3793*/
					$0.raiseerror(); /*3793*/
				} /*3793*/
			}); /*3793*/
			$1.barlen = $1.barcode.length; /*3797*/
			$1.extencs = $a(["%U", "$A", "$B", "$C", "$D", "$E", "$F", "$G", "$H", "$I", "$J", "$K", "$L", "$M", "$N", "$O", "$P", "$Q", "$R", "$S", "$T", "$U", "$V", "$W", "$X", "$Y", "$Z", "%A", "%B", "%C", "%D", "%E", " ", "/A", "/B", "/C", "/D", "/E", "/F", "/G", "/H", "/I", "/J", "/K", "/L", "-", ".", "/O", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "/Z", "%F", "%G", "%H", "%I", "%J", "%V", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "%K", "%L", "%M", "%N", "%O", "%W", "+A", "+B", "+C", "+D", "+E", "+F", "+G", "+H", "+I", "+J", "+K", "+L", "+M", "+N", "+O", "+P", "+Q", "+R", "+S", "+T", "+U", "+V", "+W", "+X", "+Y", "+Z", "%P", "%Q", "%R", "%S", "%T"]); /*3809*/
			$1.newcode = $s($1.barlen * 2); /*3811*/
			$1.newtext = $s($1.barlen * 2); /*3812*/
			$1.j = 0; /*3813*/
			for (var _F = 0, _E = $1.barlen - 1; _F <= _E; _F += 1) { /*3821*/
				$1.i = _F; /*3815*/
				$1.extchar = $get($1.extencs, $get($1.barcode, $1.i)); /*3816*/
				$puti($1.newcode, $1.j, $1.extchar); /*3817*/
				$put($1.newtext, $1.j, $get($1.barcode, $1.i)); /*3818*/
				if ($1.extchar.length != 1) { /*3819*/
					$puti($1.newtext, $1.j + 1, " "); /*3819*/
				} /*3819*/
				$1.j = $1.j + $1.extchar.length; /*3820*/
			} /*3820*/
			$1.newcode = $geti($1.newcode, 0, $1.j); /*3822*/
			$1.newtext = $geti($1.newtext, 0, $1.j); /*3823*/
			$1.options.dontdraw = true; /*3826*/
			$k[$j++] = "args"; /*3827*/
			$k[$j++] = $1.newcode; /*3827*/
			$k[$j++] = $1.options; /*3827*/
			$0.code39(); /*3827*/
			var _h = $k[--$j]; /*3827*/
			$1[$k[--$j]] = _h; /*3827*/
			if ($1.includetext) { /*3839*/
				$1.txt = $1.args.txt; /*3831*/
				for (var _o = 0, _n = $1.newtext.length - 1; _o <= _n; _o += 1) { /*3837*/
					$1.i = _o; /*3833*/
					$1.txtentry = $get($1.txt, $1.i + 1); /*3834*/
					$put($1.txtentry, 0, $geti($1.newtext, $1.i, 1)); /*3835*/
					$put($1.txt, $1.i + 1, $1.txtentry); /*3836*/
				} /*3836*/
				$1.args.txt = $1.txt; /*3838*/
			} /*3838*/
			$1.args.opt = $1.options; /*3840*/
			$k[$j++] = $1.args; /*3843*/
			if (!$1.dontdraw) { /*3843*/
				$0.renlinear(); /*3843*/
			} /*3843*/
		};
		$0.code32 = function() {
			var $1 = {}; /*3871*/
			$1.options = $k[--$j]; /*3873*/
			$1.barcode = $k[--$j]; /*3874*/
			$1.dontdraw = false; /*3876*/
			$1.includetext = false; /*3877*/
			$1.textfont = "Courier"; /*3878*/
			$1.textsize = 10; /*3879*/
			$1.textyoffset = -8.5; /*3880*/
			$1.textxoffset = 0; /*3881*/
			$1.height = 1; /*3882*/
			$forall($1.options, function() { /*3893*/
				var _3 = $k[--$j]; /*3893*/
				$1[$k[--$j]] = _3; /*3893*/
			}); /*3893*/
			$1.textfont = "" + $1.textfont; /*3895*/
			$1.textsize = +$1.textsize; /*3896*/
			$1.textyoffset = +$1.textyoffset; /*3897*/
			$1.height = +$1.height; /*3898*/
			if (($1.barcode.length != 8) && ($1.barcode.length != 9)) { /*3903*/
				$k[$j++] = "bwipp.code32badLength"; /*3902*/
				$k[$j++] = "Italian Pharmacode must be 8 or 9 digits"; /*3902*/
				$0.raiseerror(); /*3902*/
			} /*3902*/
			$forall($1.barcode, function() { /*3908*/
				var _C = $k[--$j]; /*3905*/
				if ((_C < 48) || (_C > 57)) { /*3907*/
					$k[$j++] = "bwipp.code32badCharacter"; /*3906*/
					$k[$j++] = "Italian Pharmacode must contain only digits"; /*3906*/
					$0.raiseerror(); /*3906*/
				} /*3906*/
			}); /*3906*/
			$1.checksum = 0; /*3911*/
			for (var _D = 0; _D <= 7; _D += 1) { /*3916*/
				$1.i = _D; /*3913*/
				$k[$j++] = $get($1.barcode, $1.i) - 48; /*3914*/
				if (($1.i % 2) != 0) { /*3914*/
					var _I = $k[--$j]; /*3914*/
					$k[$j++] = _I * 2; /*3914*/
				} /*3914*/
				var _J = $k[--$j]; /*3914*/
				$k[$j++] = _J; /*3914*/
				if (_J > 9) { /*3914*/
					var _K = $k[--$j]; /*3914*/
					$k[$j++] = _K - 9; /*3914*/
				} /*3914*/
				$1.checksum = $k[--$j] + $1.checksum; /*3915*/
			} /*3915*/
			$1.checksum = $1.checksum % 10; /*3917*/
			if ($1.barcode.length == 9) { /*3922*/
				if ($get($1.barcode, 8) != ($1.checksum + 48)) { /*3921*/
					$k[$j++] = "bwipp.code32badCheckDigit"; /*3920*/
					$k[$j++] = "Incorrect Italian Pharmacode check digit provided"; /*3920*/
					$0.raiseerror(); /*3920*/
				} /*3920*/
			} /*3920*/
			var _S = $s(10); /*3923*/
			$puti(_S, 0, $1.barcode); /*3924*/
			$put(_S, 8, $1.checksum + 48); /*3925*/
			$1.text = _S; /*3926*/
			$1.val = $cvrs($1.barcode, ~~$z($1.text), 32); /*3929*/
			$1.barcode = $s(6); /*3930*/
			for (var _Z = 0; _Z <= 5; _Z += 1) { /*3931*/
				$put($1.barcode, _Z, 48); /*3931*/
			} /*3931*/
			$puti($1.barcode, 6 - $1.val.length, $1.val); /*3932*/
			for (var _e = 0; _e <= 5; _e += 1) { /*3939*/
				var _g = $get($1.barcode, _e); /*3936*/
				$k[$j++] = _e; /*3937*/
				$k[$j++] = _g; /*3937*/
				$k[$j++] = _g; /*3937*/
				for (var _h = 0, _i = "AEIO".length; _h < _i; _h++) { /*3937*/
					if ($k[--$j] >= $get("AEIO", _h)) { /*3937*/
						var _l = $k[--$j]; /*3937*/
						$k[$j++] = _l + 1; /*3937*/
					} /*3937*/
					var _m = $k[--$j]; /*3937*/
					$k[$j++] = _m; /*3937*/
					$k[$j++] = _m; /*3937*/
				} /*3937*/
				$j--; /*3937*/
				var _o = $k[--$j]; /*3938*/
				$put($1.barcode, $k[--$j], _o); /*3938*/
			} /*3938*/
			$puti($1.text, 1, $geti($1.text, 0, 9)); /*3942*/
			$put($1.text, 0, 65); /*3943*/
			$1.options.dontdraw = true; /*3946*/
			$k[$j++] = "args"; /*3947*/
			$k[$j++] = $1.barcode; /*3947*/
			$k[$j++] = $1.options; /*3947*/
			$0.code39(); /*3947*/
			var _x = $k[--$j]; /*3947*/
			$1[$k[--$j]] = _x; /*3947*/
			$1.args.txt = $a([$a([$1.text, $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])]); /*3949*/
			$1.args.textxalign = "center"; /*3950*/
			$1.args.opt = $1.options; /*3951*/
			$k[$j++] = $1.args; /*3954*/
			if (!$1.dontdraw) { /*3954*/
				$0.renlinear(); /*3954*/
			} /*3954*/
		};
		$0.pzn = function() {
			var $1 = {}; /*3982*/
			$1.options = $k[--$j]; /*3984*/
			$1.barcode = $k[--$j]; /*3985*/
			$1.dontdraw = false; /*3987*/
			$1.includetext = false; /*3988*/
			$1.textfont = "Courier"; /*3989*/
			$1.textsize = 10; /*3990*/
			$1.textyoffset = -8.5; /*3991*/
			$1.textxoffset = 0; /*3992*/
			$1.height = 1; /*3993*/
			$1.pzn8 = false; /*3994*/
			$forall($1.options, function() { /*4005*/
				var _3 = $k[--$j]; /*4005*/
				$1[$k[--$j]] = _3; /*4005*/
			}); /*4005*/
			$1.textfont = "" + $1.textfont; /*4007*/
			$1.textsize = +$1.textsize; /*4008*/
			$1.textyoffset = +$1.textyoffset; /*4009*/
			$1.textxoffset = +$1.textxoffset; /*4010*/
			$1.height = +$1.height; /*4011*/
			if ($1.pzn8) { /*4020*/
				if (($1.barcode.length != 7) && ($1.barcode.length != 8)) { /*4017*/
					$k[$j++] = "bwipp.pzn8badLength"; /*4016*/
					$k[$j++] = "PZN8 must be 7 or 8 digits"; /*4016*/
					$0.raiseerror(); /*4016*/
				} /*4016*/
			} else { /*4020*/
				if (($1.barcode.length != 6) && ($1.barcode.length != 7)) { /*4021*/
					$k[$j++] = "bwipp.pzn7badLength"; /*4020*/
					$k[$j++] = "PZN7 must be 6 or 7 digits"; /*4020*/
					$0.raiseerror(); /*4020*/
				} /*4020*/
			} /*4020*/
			$forall($1.barcode, function() { /*4027*/
				var _G = $k[--$j]; /*4024*/
				if ((_G < 48) || (_G > 57)) { /*4026*/
					$k[$j++] = "bwipp.pznBadCharacter"; /*4025*/
					$k[$j++] = "PZN must contain only digits"; /*4025*/
					$0.raiseerror(); /*4025*/
				} /*4025*/
			}); /*4025*/
			var _I = $1.pzn8 ? 9 : 8; /*4030*/
			$1.msglen = _I; /*4030*/
			$1.checksum = 0; /*4031*/
			for (var _L = 0, _K = $1.msglen - 3; _L <= _K; _L += 1) { /*4036*/
				$1.i = _L; /*4033*/
				var _R = $1.pzn8 ? 1 : 2; /*4034*/
				$1.checksum = (($get($1.barcode, $1.i) - 48) * ($1.i + _R)) + $1.checksum; /*4035*/
			} /*4035*/
			$1.checksum = $1.checksum % 11; /*4037*/
			if ($1.checksum == 10) { /*4040*/
				$k[$j++] = "bwipp.pznBadInputSequence"; /*4039*/
				$k[$j++] = "Incorrect PZN input sequence provided"; /*4039*/
				$0.raiseerror(); /*4039*/
			} /*4039*/
			if ($1.barcode.length == ($1.msglen - 1)) { /*4045*/
				if ($get($1.barcode, $1.msglen - 2) != ($1.checksum + 48)) { /*4044*/
					$k[$j++] = "bwipp.pznBadCheckDigit"; /*4043*/
					$k[$j++] = "Incorrect PZN check digit provided"; /*4043*/
					$0.raiseerror(); /*4043*/
				} /*4043*/
			} /*4043*/
			var _c = $s($1.msglen); /*4046*/
			$put(_c, 0, 45); /*4047*/
			$puti(_c, 1, $1.barcode); /*4048*/
			$put(_c, $1.msglen - 1, $1.checksum + 48); /*4049*/
			$1.msg = _c; /*4050*/
			$1.options.dontdraw = true; /*4053*/
			$k[$j++] = "args"; /*4054*/
			$k[$j++] = $1.msg; /*4054*/
			$k[$j++] = $1.options; /*4054*/
			$0.code39(); /*4054*/
			var _j = $k[--$j]; /*4054*/
			$1[$k[--$j]] = _j; /*4054*/
			$1.text = $s($1.msglen + 5); /*4057*/
			$puti($1.text, 0, "PZN - "); /*4058*/
			$puti($1.text, 6, $geti($1.msg, 1, $1.msglen - 1)); /*4059*/
			$1.args.txt = $a([$a([$1.text, $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])]); /*4061*/
			$1.args.textxalign = "center"; /*4062*/
			$1.args.opt = $1.options; /*4063*/
			$k[$j++] = $1.args; /*4066*/
			if (!$1.dontdraw) { /*4066*/
				$0.renlinear(); /*4066*/
			} /*4066*/
		};
		$0.code93 = function() {
			var $1 = {}; /*4093*/
			$1.options = $k[--$j]; /*4095*/
			$1.barcode = $k[--$j]; /*4096*/
			$1.dontdraw = false; /*4098*/
			$1.includecheck = false; /*4099*/
			$1.includetext = false; /*4100*/
			$1.textfont = "Courier"; /*4101*/
			$1.textsize = 10; /*4102*/
			$1.textyoffset = -8.5; /*4103*/
			$1.height = 1; /*4104*/
			$1.parsefnc = false; /*4105*/
			$forall($1.options, function() { /*4116*/
				var _3 = $k[--$j]; /*4116*/
				$1[$k[--$j]] = _3; /*4116*/
			}); /*4116*/
			$1.textfont = "" + $1.textfont; /*4118*/
			$1.textsize = +$1.textsize; /*4119*/
			$1.textyoffset = +$1.textyoffset; /*4120*/
			$1.height = +$1.height; /*4121*/
			$1.encs = $a(["131112", "111213", "111312", "111411", "121113", "121212", "121311", "111114", "131211", "141111", "211113", "211212", "211311", "221112", "221211", "231111", "112113", "112212", "112311", "122112", "132111", "111123", "111222", "111321", "121122", "131121", "212112", "212211", "211122", "211221", "221121", "222111", "112122", "112221", "122121", "123111", "121131", "311112", "311211", "321111", "112131", "113121", "211131", "121221", "312111", "311121", "122211", "111141", "1111411"]); /*4134*/
			$1.barchars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%"; /*4137*/
			$1.barlen = $1.barcode.length; /*4139*/
			$1.sft1 = -1; /*4142*/
			$1.sft2 = -2; /*4142*/
			$1.sft3 = -3; /*4142*/
			$1.sft4 = -4; /*4142*/
			var _F = {
				"SFT$": $1.sft1,
				"SFT%": $1.sft2,
				"SFT/": $1.sft3,
				"SFT+": $1.sft4
			}; /*4147*/
			$1.fncvals = _F; /*4148*/
			$1.msg = $a($1.barlen); /*4151*/
			$1.i = 0; /*4152*/
			$1.j = 0; /*4152*/
			for (;;) { /*4166*/
				if ($1.i == $1.barlen) { /*4153*/
					break; /*4153*/
				} /*4153*/
				$1.char = $get($1.barcode, $1.i); /*4154*/
				if (($1.parsefnc && ($1.char == 94)) && ($1.i < ($1.barlen - 4))) { /*4162*/
					if ($get($1.barcode, $1.i + 1) != 94) { /*4160*/
						$1.char = $get($1.fncvals, $geti($1.barcode, $1.i + 1, 4)); /*4157*/
						$1.i = $1.i + 4; /*4158*/
					} else { /*4160*/
						$1.i = $1.i + 1; /*4160*/
					} /*4160*/
				} /*4160*/
				$put($1.msg, $1.j, $1.char); /*4163*/
				$1.i = $1.i + 1; /*4164*/
				$1.j = $1.j + 1; /*4165*/
			} /*4165*/
			$1.msg = $geti($1.msg, 0, $1.j); /*4167*/
			$1.msglen = $1.msg.length; /*4168*/
			if ($1.includecheck) { /*4173*/
				$1.sbs = $s(($1.msglen * 6) + 25); /*4171*/
			} else { /*4173*/
				$1.sbs = $s(($1.msglen * 6) + 13); /*4173*/
			} /*4173*/
			$1.txt = $a($1.msglen); /*4175*/
			$puti($1.sbs, 0, $get($1.encs, 47)); /*4178*/
			$1.checksum1 = 0; /*4180*/
			$1.checksum2 = 0; /*4180*/
			for (var _w = 0, _v = $1.msglen - 1; _w <= _v; _w += 1) { /*4199*/
				$1.i = _w; /*4182*/
				var _z = $get($1.msg, $1.i); /*4184*/
				$k[$j++] = _z; /*4193*/
				if (_z < 0) { /*4192*/
					$1.indx = 42 - $k[--$j]; /*4185*/
					$1.char = " "; /*4186*/
				} else { /*4192*/
					var _11 = $s(1); /*4188*/
					$put(_11, 0, $k[--$j]); /*4188*/
					$1.char = _11; /*4188*/
					$search($1.barchars, $1.char); /*4189*/
					$j--; /*4190*/
					$1.indx = $k[--$j].length; /*4191*/
					$j -= 2; /*4192*/
				} /*4192*/
				$1.enc = $get($1.encs, $1.indx); /*4194*/
				$puti($1.sbs, ($1.i * 6) + 6, $1.enc); /*4195*/
				$put($1.txt, $1.i, $a([$1.char, ($1.i * 9) + 9, $1.textyoffset, $1.textfont, $1.textsize])); /*4196*/
				$1.checksum1 = $1.checksum1 + ((((($1.msglen - $1.i) - 1) % 20) + 1) * $1.indx); /*4197*/
				$1.checksum2 = $1.checksum2 + (((($1.msglen - $1.i) % 15) + 1) * $1.indx); /*4198*/
			} /*4198*/
			if ($1.includecheck) { /*4211*/
				$1.checksum1 = $1.checksum1 % 47; /*4203*/
				$1.checksum2 = ($1.checksum2 + $1.checksum1) % 47; /*4204*/
				$puti($1.sbs, ($1.msglen * 6) + 6, $get($1.encs, $1.checksum1)); /*4205*/
				$puti($1.sbs, ($1.msglen * 6) + 12, $get($1.encs, $1.checksum2)); /*4206*/
				$puti($1.sbs, ($1.msglen * 6) + 18, $get($1.encs, 48)); /*4208*/
			} else { /*4211*/
				$puti($1.sbs, ($1.msglen * 6) + 6, $get($1.encs, 48)); /*4211*/
			} /*4211*/
			$k[$j++] = Infinity; /*4223*/
			$k[$j++] = "ren"; /*4218*/
			$k[$j++] = $0.renlinear; /*4218*/
			$k[$j++] = "sbs"; /*4218*/
			$k[$j++] = Infinity; /*4218*/
			var _1o = $1.sbs; /*4217*/
			for (var _1p = 0, _1q = _1o.length; _1p < _1q; _1p++) { /*4217*/
				$k[$j++] = $get(_1o, _1p) - 48; /*4217*/
			} /*4217*/
			var _1s = $a(); /*4218*/
			$k[$j++] = _1s; /*4219*/
			$k[$j++] = "bhs"; /*4219*/
			$k[$j++] = Infinity; /*4219*/
			for (var _1u = 0, _1v = ~~(($1.sbs.length + 1) / 2); _1u < _1v; _1u++) { /*4218*/
				$k[$j++] = $1.height; /*4218*/
			} /*4218*/
			var _1x = $a(); /*4219*/
			$k[$j++] = _1x; /*4220*/
			$k[$j++] = "bbs"; /*4220*/
			$k[$j++] = Infinity; /*4220*/
			for (var _1z = 0, _20 = ~~(($1.sbs.length + 1) / 2); _1z < _20; _1z++) { /*4219*/
				$k[$j++] = 0; /*4219*/
			} /*4219*/
			var _21 = $a(); /*4220*/
			$k[$j++] = _21; /*4222*/
			if ($1.includetext) { /*4222*/
				$k[$j++] = "txt"; /*4221*/
				$k[$j++] = $1.txt; /*4221*/
			} /*4221*/
			$k[$j++] = "opt"; /*4223*/
			$k[$j++] = $1.options; /*4223*/
			var _25 = $d(); /*4223*/
			$k[$j++] = _25; /*4226*/
			if (!$1.dontdraw) { /*4226*/
				$0.renlinear(); /*4226*/
			} /*4226*/
		};
		$0.code93ext = function() {
			var $1 = {}; /*4254*/
			$1.options = $k[--$j]; /*4256*/
			$1.barcode = $k[--$j]; /*4257*/
			$1.dontdraw = false; /*4259*/
			$1.includetext = false; /*4260*/
			$1.parse = false; /*4261*/
			$forall($1.options, function() { /*4272*/
				var _3 = $k[--$j]; /*4272*/
				$1[$k[--$j]] = _3; /*4272*/
			}); /*4272*/
			$1.barlen = $1.barcode.length; /*4295*/
			$1.extencs = $a(["^SFT%U", "^SFT$A", "^SFT$B", "^SFT$C", "^SFT$D", "^SFT$E", "^SFT$F", "^SFT$G", "^SFT$H", "^SFT$I", "^SFT$J", "^SFT$K", "^SFT$L", "^SFT$M", "^SFT$N", "^SFT$O", "^SFT$P", "^SFT$Q", "^SFT$R", "^SFT$S", "^SFT$T", "^SFT$U", "^SFT$V", "^SFT$W", "^SFT$X", "^SFT$Y", "^SFT$Z", "^SFT%A", "^SFT%B", "^SFT%C", "^SFT%D", "^SFT%E", " ", "^SFT/A", "^SFT/B", "^SFT/C", "^SFT/D", "^SFT/E", "^SFT/F", "^SFT/G", "^SFT/H", "^SFT/I", "^SFT/J", "^SFT/K", "^SFT/L", "-", ".", "^SFT/O", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "^SFT/Z", "^SFT%F", "^SFT%G", "^SFT%H", "^SFT%I", "^SFT%J", "^SFT%V", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "^SFT%K", "^SFT%L", "^SFT%M", "^SFT%N", "^SFT%O", "^SFT%W", "^SFT+A", "^SFT+B", "^SFT+C", "^SFT+D", "^SFT+E", "^SFT+F", "^SFT+G", "^SFT+H", "^SFT+I", "^SFT+J", "^SFT+K", "^SFT+L", "^SFT+M", "^SFT+N", "^SFT+O", "^SFT+P", "^SFT+Q", "^SFT+R", "^SFT+S", "^SFT+T", "^SFT+U", "^SFT+V", "^SFT+W", "^SFT+X", "^SFT+Y", "^SFT+Z", "^SFT%P", "^SFT%Q", "^SFT%R", "^SFT%S", "^SFT%T"]); /*4315*/
			$1.newcode = $s($1.barlen * 6); /*4317*/
			$1.newtext = $s($1.barlen * 6); /*4318*/
			$1.j = 0; /*4319*/
			$1.k = 0; /*4319*/
			for (var _D = 0, _C = $1.barlen - 1; _D <= _C; _D += 1) { /*4329*/
				$1.i = _D; /*4321*/
				$1.extchar = $get($1.extencs, $get($1.barcode, $1.i)); /*4322*/
				$1.extlen = $1.extchar.length; /*4323*/
				$puti($1.newcode, $1.j, $1.extchar); /*4324*/
				$put($1.newtext, $1.k, $get($1.barcode, $1.i)); /*4325*/
				if ($1.extlen != 1) { /*4326*/
					$puti($1.newtext, $1.k + 1, " "); /*4326*/
				} /*4326*/
				$1.j = $1.j + $1.extlen; /*4327*/
				var _Z = ($1.extlen == 1) ? 1 : 2; /*4328*/
				$1.k = $1.k + _Z; /*4328*/
			} /*4328*/
			$1.newcode = $geti($1.newcode, 0, $1.j); /*4330*/
			$1.newtext = $geti($1.newtext, 0, $1.k); /*4331*/
			$1.options.dontdraw = true; /*4334*/
			$1.options.parsefnc = true; /*4335*/
			$k[$j++] = "args"; /*4336*/
			$k[$j++] = $1.newcode; /*4336*/
			$k[$j++] = $1.options; /*4336*/
			$0.code93(); /*4336*/
			var _k = $k[--$j]; /*4336*/
			$1[$k[--$j]] = _k; /*4336*/
			if ($1.includetext) { /*4348*/
				$1.txt = $1.args.txt; /*4340*/
				for (var _r = 0, _q = $1.newtext.length - 1; _r <= _q; _r += 1) { /*4346*/
					$1.i = _r; /*4342*/
					$1.txtentry = $get($1.txt, $1.i); /*4343*/
					$put($1.txtentry, 0, $geti($1.newtext, $1.i, 1)); /*4344*/
					$put($1.txt, $1.i, $1.txtentry); /*4345*/
				} /*4345*/
				$1.args.txt = $1.txt; /*4347*/
			} /*4347*/
			$1.args.opt = $1.options; /*4349*/
			$k[$j++] = $1.args; /*4352*/
			if (!$1.dontdraw) { /*4352*/
				$0.renlinear(); /*4352*/
			} /*4352*/
		};
		$0.interleaved2of5 = function() {
			var $1 = {}; /*4379*/
			$1.options = $k[--$j]; /*4381*/
			$1.barcode = $k[--$j]; /*4382*/
			$1.dontdraw = false; /*4384*/
			$1.includecheck = false; /*4385*/
			$1.includetext = false; /*4386*/
			$1.includecheckintext = false; /*4387*/
			$1.textfont = "Courier"; /*4388*/
			$1.textsize = 10; /*4389*/
			$1.textyoffset = -8.5; /*4390*/
			$1.height = 1; /*4391*/
			$forall($1.options, function() { /*4402*/
				var _3 = $k[--$j]; /*4402*/
				$1[$k[--$j]] = _3; /*4402*/
			}); /*4402*/
			$1.textfont = "" + $1.textfont; /*4404*/
			$1.textsize = +$1.textsize; /*4405*/
			$1.textyoffset = +$1.textyoffset; /*4406*/
			$1.height = +$1.height; /*4407*/
			$forall($1.barcode, function() { /*4414*/
				var _A = $k[--$j]; /*4411*/
				if ((_A < 48) || (_A > 57)) { /*4413*/
					$k[$j++] = "bwipp.interleaved2of5badCharacter"; /*4412*/
					$k[$j++] = "Interleaved 2 of 5 must contain only digits"; /*4412*/
					$0.raiseerror(); /*4412*/
				} /*4412*/
			}); /*4412*/
			$1.barlen = $1.barcode.length; /*4416*/
			if (((($1.barlen % 2) == 0) && $1.includecheck) || ((($1.barlen % 2) != 0) && (!$1.includecheck))) { /*4427*/
				$1.pad = $s($1.barlen + 1); /*4422*/
				$put($1.pad, 0, 48); /*4423*/
				$puti($1.pad, 1, $1.barcode); /*4424*/
				$1.barcode = $1.pad; /*4425*/
				$1.barlen = $1.barlen + 1; /*4426*/
			} /*4426*/
			if ($1.includecheck) { /*4446*/
				$1.checksum = 0; /*4431*/
				for (var _Q = 0, _P = $1.barlen - 1; _Q <= _P; _Q += 1) { /*4439*/
					$1.i = _Q; /*4433*/
					if (($1.i % 2) == 0) { /*4437*/
						$1.checksum = $1.checksum + (($get($1.barcode, $1.i) - 48) * 3); /*4435*/
					} else { /*4437*/
						$1.checksum = $1.checksum + ($get($1.barcode, $1.i) - 48); /*4437*/
					} /*4437*/
				} /*4437*/
				$1.checksum = (10 - ($1.checksum % 10)) % 10; /*4440*/
				$1.pad = $s($1.barlen + 1); /*4441*/
				$puti($1.pad, 0, $1.barcode); /*4442*/
				$put($1.pad, $1.barlen, $1.checksum + 48); /*4443*/
				$1.barcode = $1.pad; /*4444*/
				$1.barlen = $1.barlen + 1; /*4445*/
			} /*4445*/
			$1.encs = $a(["11221", "21112", "12112", "22111", "11212", "21211", "12211", "11122", "21121", "12121", "1111", "2111"]); /*4453*/
			$1.barchars = "0123456789"; /*4456*/
			$1.sbs = $s(($1.barlen * 5) + 8); /*4457*/
			$1.txt = $a($1.barlen); /*4458*/
			$puti($1.sbs, 0, $get($1.encs, 10)); /*4461*/
			for (var _u = 0, _t = $1.barlen - 1; _u <= _t; _u += 2) { /*4495*/
				$1.i = _u; /*4464*/
				$search($1.barchars, $geti($1.barcode, $1.i, 1)); /*4466*/
				$j--; /*4467*/
				$1.indx = $k[--$j].length; /*4468*/
				$j -= 2; /*4469*/
				$1.enca = $get($1.encs, $1.indx); /*4470*/
				$search($1.barchars, $geti($1.barcode, $1.i + 1, 1)); /*4472*/
				$j--; /*4473*/
				$1.indx = $k[--$j].length; /*4474*/
				$j -= 2; /*4475*/
				$1.encb = $get($1.encs, $1.indx); /*4476*/
				$1.intl = $s($1.enca.length * 2); /*4479*/
				for (var _1F = 0, _1E = $1.enca.length - 1; _1F <= _1E; _1F += 1) { /*4486*/
					$1.j = _1F; /*4481*/
					$1.achar = $get($1.enca, $1.j); /*4482*/
					$1.bchar = $get($1.encb, $1.j); /*4483*/
					$put($1.intl, $1.j * 2, $1.achar); /*4484*/
					$put($1.intl, ($1.j * 2) + 1, $1.bchar); /*4485*/
				} /*4485*/
				$puti($1.sbs, ($1.i * 5) + 4, $1.intl); /*4488*/
				$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), ($1.i * 9) + 4, $1.textyoffset, $1.textfont, $1.textsize])); /*4489*/
				if (($1.includecheck && (!$1.includecheckintext)) && (($1.barlen - 2) == $1.i)) { /*4493*/
					$put($1.txt, $1.i + 1, $a([" ", (($1.i + 1) * 9) + 4, $1.textyoffset, $1.textfont, $1.textsize])); /*4491*/
				} else { /*4493*/
					$put($1.txt, $1.i + 1, $a([$geti($1.barcode, $1.i + 1, 1), (($1.i + 1) * 9) + 4, $1.textyoffset, $1.textfont, $1.textsize])); /*4493*/
				} /*4493*/
			} /*4493*/
			$puti($1.sbs, ($1.barlen * 5) + 4, $get($1.encs, 11)); /*4498*/
			$k[$j++] = Infinity; /*4511*/
			$k[$j++] = "ren"; /*4504*/
			$k[$j++] = $0.renlinear; /*4504*/
			$k[$j++] = "sbs"; /*4504*/
			$k[$j++] = Infinity; /*4504*/
			var _24 = $1.sbs; /*4503*/
			for (var _25 = 0, _26 = _24.length; _25 < _26; _25++) { /*4503*/
				$k[$j++] = $get(_24, _25) - 48; /*4503*/
			} /*4503*/
			var _28 = $a(); /*4504*/
			$k[$j++] = _28; /*4505*/
			$k[$j++] = "bhs"; /*4505*/
			$k[$j++] = Infinity; /*4505*/
			for (var _2A = 0, _2B = ~~(($1.sbs.length + 1) / 2); _2A < _2B; _2A++) { /*4504*/
				$k[$j++] = $1.height; /*4504*/
			} /*4504*/
			var _2D = $a(); /*4505*/
			$k[$j++] = _2D; /*4506*/
			$k[$j++] = "bbs"; /*4506*/
			$k[$j++] = Infinity; /*4506*/
			for (var _2F = 0, _2G = ~~(($1.sbs.length + 1) / 2); _2F < _2G; _2F++) { /*4505*/
				$k[$j++] = 0; /*4505*/
			} /*4505*/
			var _2H = $a(); /*4506*/
			$k[$j++] = _2H; /*4508*/
			if ($1.includetext) { /*4508*/
				$k[$j++] = "txt"; /*4507*/
				$k[$j++] = $1.txt; /*4507*/
			} /*4507*/
			$k[$j++] = "barratio"; /*4511*/
			$k[$j++] = 2; /*4511*/
			$k[$j++] = "spaceratio"; /*4511*/
			$k[$j++] = 2; /*4511*/
			$k[$j++] = "opt"; /*4511*/
			$k[$j++] = $1.options; /*4511*/
			var _2L = $d(); /*4511*/
			$k[$j++] = _2L; /*4514*/
			if (!$1.dontdraw) { /*4514*/
				$0.renlinear(); /*4514*/
			} /*4514*/
		};
		$0.itf14 = function() {
			var $1 = {}; /*4542*/
			$1.options = $k[--$j]; /*4544*/
			$1.barcode = $k[--$j]; /*4545*/
			$1.dontdraw = false; /*4547*/
			$1.includetext = false; /*4548*/
			$1.includecheckintext = true; /*4549*/
			$1.textfont = "Courier"; /*4550*/
			$1.textsize = 10; /*4551*/
			$1.textxoffset = 0; /*4552*/
			$1.textyoffset = 3; /*4553*/
			$1.height = 0.5; /*4554*/
			$1.showborder = true; /*4555*/
			$1.borderwidth = 4; /*4556*/
			$1.borderleft = 15; /*4557*/
			$1.borderright = 15; /*4558*/
			$forall($1.options, function() { /*4569*/
				var _3 = $k[--$j]; /*4569*/
				$1[$k[--$j]] = _3; /*4569*/
			}); /*4569*/
			$1.textfont = "" + $1.textfont; /*4571*/
			$1.textsize = +$1.textsize; /*4572*/
			$1.textxoffset = +$1.textxoffset; /*4573*/
			$1.textyoffset = +$1.textyoffset; /*4574*/
			$1.height = +$1.height; /*4575*/
			$1.borderwidth = +$1.borderwidth; /*4576*/
			$1.borderleft = +$1.borderleft; /*4577*/
			$1.borderright = +$1.borderright; /*4578*/
			$1.text = $1.barcode; /*4581*/
			var _E = $1.barcode; /*4582*/
			$k[$j++] = $s(_E.length); /*4583*/
			$k[$j++] = 0; /*4583*/
			$forall(_E, function() { /*4583*/
				var _G = $k[--$j]; /*4583*/
				$k[$j++] = _G; /*4583*/
				if (_G != 32) { /*4583*/
					var _H = $k[--$j]; /*4583*/
					var _I = $k[--$j]; /*4583*/
					var _J = $k[--$j]; /*4583*/
					$put(_J, _I, _H); /*4583*/
					$k[$j++] = _J; /*4583*/
					$k[$j++] = _I + 1; /*4583*/
				} else { /*4583*/
					$j--; /*4583*/
				} /*4583*/
			}); /*4583*/
			var _K = $k[--$j]; /*4584*/
			$1.barcode = $geti($k[--$j], 0, _K); /*4584*/
			$1.hasspace = $1.text.length != $1.barcode.length; /*4585*/
			if (($1.barcode.length != 13) && ($1.barcode.length != 14)) { /*4590*/
				$k[$j++] = "bwipp.itf14badLength"; /*4589*/
				$k[$j++] = "ITF-14 must be 13 or 14 digits"; /*4589*/
				$0.raiseerror(); /*4589*/
			} /*4589*/
			$forall($1.barcode, function() { /*4595*/
				var _S = $k[--$j]; /*4592*/
				if ((_S < 48) || (_S > 57)) { /*4594*/
					$k[$j++] = "bwipp.itf14badCharacter"; /*4593*/
					$k[$j++] = "ITF-14 must contain only digits"; /*4593*/
					$0.raiseerror(); /*4593*/
				} /*4593*/
			}); /*4593*/
			$1.checksum = 0; /*4598*/
			for (var _T = 0; _T <= 12; _T += 1) { /*4602*/
				$1.i = _T; /*4600*/
				$k[$j++] = "checksum"; /*4601*/
				$k[$j++] = $1.checksum; /*4601*/
				$k[$j++] = $get($1.barcode, $1.i) - 48; /*4601*/
				if (($1.i % 2) == 0) { /*4601*/
					var _Z = $k[--$j]; /*4601*/
					$k[$j++] = _Z * 3; /*4601*/
				} /*4601*/
				var _a = $k[--$j]; /*4601*/
				var _b = $k[--$j]; /*4601*/
				$1[$k[--$j]] = _b + _a; /*4601*/
			} /*4601*/
			$1.checksum = (10 - ($1.checksum % 10)) % 10; /*4603*/
			if ($1.barcode.length == 14) { /*4617*/
				if ($get($1.barcode, 13) != ($1.checksum + 48)) { /*4607*/
					$k[$j++] = "bwipp.itf14badCheckDigit"; /*4606*/
					$k[$j++] = "Incorrect ITF-14 check digit provided"; /*4606*/
					$0.raiseerror(); /*4606*/
				} /*4606*/
			} else { /*4617*/
				var _i = $s(14); /*4609*/
				$puti(_i, 0, $1.barcode); /*4610*/
				$put(_i, 13, $1.checksum + 48); /*4611*/
				$1.barcode = _i; /*4612*/
				var _n = $1.hasspace ? 2 : 1; /*4613*/
				var _o = $s($1.text.length + _n); /*4613*/
				$puti(_o, _o.length - 2, " "); /*4614*/
				$put(_o, _o.length - 1, $1.checksum + 48); /*4615*/
				$puti(_o, 0, $1.text); /*4616*/
				$1.text = _o; /*4617*/
			} /*4617*/
			$1.options.dontdraw = true; /*4621*/
			$1.options.showborder = $1.showborder; /*4622*/
			$1.options.borderwidth = $1.borderwidth; /*4623*/
			$1.options.borderleft = $1.borderleft; /*4624*/
			$1.options.borderright = $1.borderright; /*4625*/
			$1.options.height = $1.height; /*4626*/
			$1.options.textyoffset = $1.textyoffset; /*4627*/
			$k[$j++] = "args"; /*4628*/
			$k[$j++] = $1.barcode; /*4628*/
			$k[$j++] = $1.options; /*4628*/
			$0.interleaved2of5(); /*4628*/
			var _16 = $k[--$j]; /*4628*/
			$1[$k[--$j]] = _16; /*4628*/
			$1.args.txt = $a([$a([$1.text, $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])]); /*4630*/
			$1.args.textxalign = "center"; /*4631*/
			$1.args.opt = $1.options; /*4632*/
			$k[$j++] = $1.args; /*4635*/
			if (!$1.dontdraw) { /*4635*/
				$0.renlinear(); /*4635*/
			} /*4635*/
		};
		$0.identcode = function() {
			var $1 = {}; /*4663*/
			$1.options = $k[--$j]; /*4665*/
			$1.barcode = $k[--$j]; /*4666*/
			$1.dontdraw = false; /*4668*/
			$1.includetext = false; /*4669*/
			$1.textfont = "Courier"; /*4670*/
			$1.textsize = 10; /*4671*/
			$1.textxoffset = 0; /*4672*/
			$1.textyoffset = -8.5; /*4673*/
			$1.height = 1; /*4674*/
			$forall($1.options, function() { /*4685*/
				var _3 = $k[--$j]; /*4685*/
				$1[$k[--$j]] = _3; /*4685*/
			}); /*4685*/
			$1.textfont = "" + $1.textfont; /*4687*/
			$1.textsize = +$1.textsize; /*4688*/
			$1.textxoffset = +$1.textxoffset; /*4689*/
			$1.textyoffset = +$1.textyoffset; /*4690*/
			$1.height = +$1.height; /*4691*/
			if (($1.barcode.length != 11) && ($1.barcode.length != 12)) { /*4696*/
				$k[$j++] = "bwipp.identcodeBadLength"; /*4695*/
				$k[$j++] = "Deutsche Post Identcode must be 11 or 12 digits"; /*4695*/
				$0.raiseerror(); /*4695*/
			} /*4695*/
			$forall($1.barcode, function() { /*4701*/
				var _D = $k[--$j]; /*4698*/
				if ((_D < 48) || (_D > 57)) { /*4700*/
					$k[$j++] = "bwipp.identcodeBadCharacter"; /*4699*/
					$k[$j++] = "Deutsche Post Identcode must contain only digits"; /*4699*/
					$0.raiseerror(); /*4699*/
				} /*4699*/
			}); /*4699*/
			$1.checksum = 0; /*4704*/
			for (var _E = 0; _E <= 10; _E += 1) { /*4708*/
				$1.i = _E; /*4706*/
				$k[$j++] = "checksum"; /*4707*/
				$k[$j++] = $1.checksum; /*4707*/
				$k[$j++] = $get($1.barcode, $1.i) - 48; /*4707*/
				if (($1.i % 2) == 0) { /*4707*/
					var _K = $k[--$j]; /*4707*/
					$k[$j++] = _K * 4; /*4707*/
				} else { /*4707*/
					var _L = $k[--$j]; /*4707*/
					$k[$j++] = _L * 9; /*4707*/
				} /*4707*/
				var _M = $k[--$j]; /*4707*/
				var _N = $k[--$j]; /*4707*/
				$1[$k[--$j]] = _N + _M; /*4707*/
			} /*4707*/
			$1.checksum = (10 - ($1.checksum % 10)) % 10; /*4709*/
			if ($1.barcode.length == 12) { /*4714*/
				if ($get($1.barcode, 11) != ($1.checksum + 48)) { /*4713*/
					$k[$j++] = "bwipp.identcodeBadCheckDigit"; /*4712*/
					$k[$j++] = "Incorrect Deutsche Post Identcode check digit provided"; /*4712*/
					$0.raiseerror(); /*4712*/
				} /*4712*/
			} /*4712*/
			var _U = $s(12); /*4715*/
			$puti(_U, 0, $1.barcode); /*4716*/
			$put(_U, 11, $1.checksum + 48); /*4717*/
			$1.barcode = _U; /*4718*/
			$1.text = $strcpy($s(16), "  .       .     "); /*4721*/
			$puti($1.text, 0, $geti($1.barcode, 0, 2)); /*4722*/
			$puti($1.text, 3, $geti($1.barcode, 2, 3)); /*4723*/
			$puti($1.text, 7, $geti($1.barcode, 5, 3)); /*4724*/
			$puti($1.text, 11, $geti($1.barcode, 8, 3)); /*4725*/
			$puti($1.text, 15, $geti($1.barcode, 11, 1)); /*4726*/
			$1.options.dontdraw = true; /*4729*/
			$1.options.includecheck = false; /*4730*/
			$k[$j++] = "args"; /*4731*/
			$k[$j++] = $1.barcode; /*4731*/
			$k[$j++] = $1.options; /*4731*/
			$0.interleaved2of5(); /*4731*/
			var _s = $k[--$j]; /*4731*/
			$1[$k[--$j]] = _s; /*4731*/
			$1.args.txt = $a([$a([$1.text, $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])]); /*4733*/
			$1.args.textxalign = "center"; /*4734*/
			$1.args.opt = $1.options; /*4735*/
			$k[$j++] = $1.args; /*4738*/
			if (!$1.dontdraw) { /*4738*/
				$0.renlinear(); /*4738*/
			} /*4738*/
		};
		$0.leitcode = function() {
			var $1 = {}; /*4766*/
			$1.options = $k[--$j]; /*4768*/
			$1.barcode = $k[--$j]; /*4769*/
			$1.dontdraw = false; /*4771*/
			$1.includetext = false; /*4772*/
			$1.textfont = "Courier"; /*4773*/
			$1.textsize = 10; /*4774*/
			$1.textxoffset = 0; /*4775*/
			$1.textyoffset = -8.5; /*4776*/
			$1.height = 1; /*4777*/
			$forall($1.options, function() { /*4788*/
				var _3 = $k[--$j]; /*4788*/
				$1[$k[--$j]] = _3; /*4788*/
			}); /*4788*/
			$1.textfont = "" + $1.textfont; /*4790*/
			$1.textsize = +$1.textsize; /*4791*/
			$1.textxoffset = +$1.textxoffset; /*4792*/
			$1.textyoffset = +$1.textyoffset; /*4793*/
			$1.height = +$1.height; /*4794*/
			if (($1.barcode.length != 13) && ($1.barcode.length != 14)) { /*4799*/
				$k[$j++] = "bwipp.leitcodeBadLength"; /*4798*/
				$k[$j++] = "Deutsche Post Leitcode must be 13 or 14 digits"; /*4798*/
				$0.raiseerror(); /*4798*/
			} /*4798*/
			$forall($1.barcode, function() { /*4804*/
				var _D = $k[--$j]; /*4801*/
				if ((_D < 48) || (_D > 57)) { /*4803*/
					$k[$j++] = "bwipp.leitcodeBadCharacter"; /*4802*/
					$k[$j++] = "Deutsche Post Leitcode must contain only digits"; /*4802*/
					$0.raiseerror(); /*4802*/
				} /*4802*/
			}); /*4802*/
			$1.checksum = 0; /*4807*/
			for (var _E = 0; _E <= 12; _E += 1) { /*4811*/
				$1.i = _E; /*4809*/
				$k[$j++] = "checksum"; /*4810*/
				$k[$j++] = $1.checksum; /*4810*/
				$k[$j++] = $get($1.barcode, $1.i) - 48; /*4810*/
				if (($1.i % 2) == 0) { /*4810*/
					var _K = $k[--$j]; /*4810*/
					$k[$j++] = _K * 4; /*4810*/
				} else { /*4810*/
					var _L = $k[--$j]; /*4810*/
					$k[$j++] = _L * 9; /*4810*/
				} /*4810*/
				var _M = $k[--$j]; /*4810*/
				var _N = $k[--$j]; /*4810*/
				$1[$k[--$j]] = _N + _M; /*4810*/
			} /*4810*/
			$1.checksum = (10 - ($1.checksum % 10)) % 10; /*4812*/
			if ($1.barcode.length == 14) { /*4817*/
				if ($get($1.barcode, 13) != ($1.checksum + 48)) { /*4816*/
					$k[$j++] = "bwipp.leitcodeBadCheckDigit"; /*4815*/
					$k[$j++] = "Incorrect Deutsche Post Leitcode check digit provided"; /*4815*/
					$0.raiseerror(); /*4815*/
				} /*4815*/
			} /*4815*/
			var _U = $s(14); /*4818*/
			$puti(_U, 0, $1.barcode); /*4819*/
			$put(_U, 13, $1.checksum + 48); /*4820*/
			$1.barcode = _U; /*4821*/
			$1.text = $strcpy($s(18), "     .   .   .    "); /*4824*/
			$puti($1.text, 0, $geti($1.barcode, 0, 5)); /*4825*/
			$puti($1.text, 6, $geti($1.barcode, 5, 3)); /*4826*/
			$puti($1.text, 10, $geti($1.barcode, 8, 3)); /*4827*/
			$puti($1.text, 14, $geti($1.barcode, 11, 2)); /*4828*/
			$puti($1.text, 17, $geti($1.barcode, 13, 1)); /*4829*/
			$1.options.dontdraw = true; /*4832*/
			$1.options.includecheck = false; /*4833*/
			$k[$j++] = "args"; /*4834*/
			$k[$j++] = $1.barcode; /*4834*/
			$k[$j++] = $1.options; /*4834*/
			$0.interleaved2of5(); /*4834*/
			var _s = $k[--$j]; /*4834*/
			$1[$k[--$j]] = _s; /*4834*/
			$1.args.txt = $a([$a([$1.text, $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])]); /*4836*/
			$1.args.textxalign = "center"; /*4837*/
			$1.args.opt = $1.options; /*4838*/
			$k[$j++] = $1.args; /*4841*/
			if (!$1.dontdraw) { /*4841*/
				$0.renlinear(); /*4841*/
			} /*4841*/
		};
		$0.databaromni = function() {
			var $1 = {}; /*4869*/
			$1.options = $k[--$j]; /*4871*/
			$1.barcode = $k[--$j]; /*4872*/
			$1.dontdraw = false; /*4874*/
			$1.height = 33 / 72; /*4875*/
			$1.linkage = false; /*4876*/
			$1.format = "omni"; /*4877*/
			$1.barxmult = 33; /*4878*/
			$forall($1.options, function() { /*4889*/
				var _3 = $k[--$j]; /*4889*/
				$1[$k[--$j]] = _3; /*4889*/
			}); /*4889*/
			if ($eq($1.format, "truncated")) { /*4891*/
				$1.height = 13 / 72; /*4891*/
			} /*4891*/
			$1.height = +$1.height; /*4892*/
			$1.barxmult = ~~$1.barxmult; /*4893*/
			if ($ne($geti($1.barcode, 0, 4), "(01)")) { /*4898*/
				$k[$j++] = "bwipp.databaromniBadAI"; /*4897*/
				$k[$j++] = "GS1 DataBar Omnidirectional must begin with (01) application identifier"; /*4897*/
				$0.raiseerror(); /*4897*/
			} /*4897*/
			if (($1.barcode.length != 17) && ($1.barcode.length != 18)) { /*4901*/
				$k[$j++] = "bwipp.databaromniBadLength"; /*4900*/
				$k[$j++] = "GS1 DataBar Omnidirectional must be 13 or 14 digits"; /*4900*/
				$0.raiseerror(); /*4900*/
			} /*4900*/
			$forall($geti($1.barcode, 4, $1.barcode.length - 4), function() { /*4906*/
				var _F = $k[--$j]; /*4903*/
				if ((_F < 48) || (_F > 57)) { /*4905*/
					$k[$j++] = "bwipp.databaromniBadCharacter"; /*4904*/
					$k[$j++] = "GS1 DataBar Omnidirectional must contain only digits"; /*4904*/
					$0.raiseerror(); /*4904*/
				} /*4904*/
			}); /*4904*/
			$1.checksum = 0; /*4909*/
			for (var _G = 0; _G <= 12; _G += 1) { /*4913*/
				$1.i = _G; /*4911*/
				$k[$j++] = "checksum"; /*4912*/
				$k[$j++] = $1.checksum; /*4912*/
				$k[$j++] = $get($1.barcode, $1.i + 4) - 48; /*4912*/
				if (($1.i % 2) == 0) { /*4912*/
					var _M = $k[--$j]; /*4912*/
					$k[$j++] = _M * 3; /*4912*/
				} /*4912*/
				var _N = $k[--$j]; /*4912*/
				var _O = $k[--$j]; /*4912*/
				$1[$k[--$j]] = _O + _N; /*4912*/
			} /*4912*/
			$1.checksum = (10 - ($1.checksum % 10)) % 10; /*4914*/
			if ($1.barcode.length == 18) { /*4919*/
				if ($get($1.barcode, 17) != ($1.checksum + 48)) { /*4918*/
					$k[$j++] = "bwipp.databaromniBadCheckDigit"; /*4917*/
					$k[$j++] = "Incorrect GS1 DataBar Omnidirectional check digit provided"; /*4917*/
					$0.raiseerror(); /*4917*/
				} /*4917*/
			} /*4917*/
			var _V = $s(18); /*4920*/
			$puti(_V, 0, $1.barcode); /*4921*/
			$put(_V, 17, $1.checksum + 48); /*4922*/
			$1.barcode = _V; /*4923*/
			$1.txt = $a($1.barcode.length); /*4926*/
			for (var _c = 0, _b = $1.barcode.length - 1; _c <= _b; _c += 1) { /*4930*/
				$1.i = _c; /*4928*/
				$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), 0, 0, "", 0])); /*4929*/
			} /*4929*/
			$1.ncr = function() {
				var _j = $k[--$j]; /*4933*/
				var _k = $k[--$j]; /*4933*/
				var _l = _k - _j; /*4933*/
				if (_j < (_k - _j)) { /*4933*/
					var _ = _l; /*4933*/
					_l = _j; /*4933*/
					_j = _; /*4933*/
				} /*4933*/
				$k[$j++] = _l; /*4940*/
				$k[$j++] = 1; /*4940*/
				$k[$j++] = 1; /*4940*/
				for (var _n = _k, _m = _j + 1; _n >= _m; _n -= 1) { /*4940*/
					var _o = $k[--$j]; /*4936*/
					var _p = $k[--$j]; /*4937*/
					var _q = $k[--$j]; /*4937*/
					$k[$j++] = _q; /*4939*/
					$k[$j++] = _p; /*4939*/
					$k[$j++] = _o * _n; /*4939*/
					if ($le(_p, _q)) { /*4939*/
						var _r = $k[--$j]; /*4938*/
						var _s = $k[--$j]; /*4938*/
						$k[$j++] = _s + 1; /*4938*/
						$k[$j++] = ~~(_r / _s); /*4938*/
					} /*4938*/
				} /*4938*/
				for (;;) { /*4944*/
					var _t = $k[--$j]; /*4942*/
					var _u = $k[--$j]; /*4942*/
					var _v = $k[--$j]; /*4942*/
					$k[$j++] = _v; /*4942*/
					$k[$j++] = _u; /*4942*/
					$k[$j++] = _t; /*4942*/
					if ($gt(_u, _v)) { /*4942*/
						break; /*4942*/
					} /*4942*/
					var _w = $k[--$j]; /*4943*/
					var _x = $k[--$j]; /*4943*/
					$k[$j++] = _x + 1; /*4943*/
					$k[$j++] = ~~(_w / _x); /*4943*/
				} /*4943*/
				var _y = $k[--$j]; /*4945*/
				var _z = $k[--$j]; /*4945*/
				var _10 = $k[--$j]; /*4945*/
				$k[$j++] = _y; /*4945*/
			}; /*4946*/
			$1.getRSSwidths = function() {
				$1.oe = $k[--$j]; /*4949*/
				$1.el = $k[--$j]; /*4950*/
				$1.mw = $k[--$j]; /*4951*/
				$1.nm = $k[--$j]; /*4952*/
				$1.val = $k[--$j]; /*4953*/
				$1.out = $a($1.el); /*4954*/
				$1.mask = 0; /*4955*/
				for (var _1A = 0, _19 = $1.el - 2; _1A <= _19; _1A += 1) { /*4982*/
					$1.bar = _1A; /*4957*/
					$1.ew = 1; /*4958*/
					var _1C = $1.bar; /*4959*/
					$1.mask = $1.mask | ((_1C < 0 ? 1 >>> -_1C : 1 << _1C)); /*4959*/
					for (;;) { /*4978*/
						$k[$j++] = "sval"; /*4960*/
						$k[$j++] = ($1.nm - $1.ew) - 1; /*4960*/
						$k[$j++] = ($1.el - $1.bar) - 2; /*4960*/
						if ($1.ncr() == $b) break; /*4960*/
						var _1H = $k[--$j]; /*4960*/
						$1[$k[--$j]] = _1H; /*4960*/
						if (($1.oe && ($1.mask == 0)) && (((($1.nm - $1.ew) - ($1.el * 2)) + ($1.bar * 2)) >= -2)) { /*4963*/
							$k[$j++] = "sval"; /*4962*/
							$k[$j++] = $1.sval; /*4962*/
							$k[$j++] = (($1.nm - $1.ew) - $1.el) + $1.bar; /*4962*/
							$k[$j++] = ($1.el - $1.bar) - 2; /*4962*/
							if ($1.ncr() == $b) break; /*4962*/
							var _1W = $k[--$j]; /*4962*/
							var _1X = $k[--$j]; /*4962*/
							$1[$k[--$j]] = _1X - _1W; /*4962*/
						} /*4962*/
						if (($1.el - $1.bar) > 2) { /*4972*/
							$1.lval = 0; /*4965*/
							for (var _1h = ((($1.nm - $1.ew) - $1.el) + $1.bar) + 2, _1g = $1.mw + 1; _1h >= _1g; _1h -= 1) { /*4969*/
								$k[$j++] = (($1.nm - _1h) - $1.ew) - 1; /*4967*/
								$k[$j++] = ($1.el - $1.bar) - 3; /*4967*/
								if ($1.ncr() == $b) break; /*4967*/
								$1.lval = $k[--$j] + $1.lval; /*4968*/
							} /*4968*/
							$1.sval = $1.sval - ($1.lval * (($1.el - $1.bar) - 1)); /*4970*/
						} else { /*4972*/
							if (($1.nm - $1.ew) > $1.mw) { /*4972*/
								$1.sval = $1.sval - 1; /*4972*/
							} /*4972*/
						} /*4972*/
						$1.val = $1.val - $1.sval; /*4974*/
						if ($1.val < 0) { /*4975*/
							break; /*4975*/
						} /*4975*/
						$1.ew = $1.ew + 1; /*4976*/
						var _21 = $1.bar; /*4977*/
						$1.mask = $1.mask & (~((_21 < 0 ? 1 >>> -_21 : 1 << _21))); /*4977*/
					} /*4977*/
					$1.val = $1.val + $1.sval; /*4979*/
					$1.nm = $1.nm - $1.ew; /*4980*/
					$put($1.out, $1.bar, $1.ew); /*4981*/
				} /*4981*/
				$put($1.out, $1.el - 1, $1.nm); /*4983*/
				$k[$j++] = $1.out; /*4984*/
			}; /*4985*/
			$k[$j++] = Infinity; /*4990*/
			var _2E = $1.linkage ? 1 : 0; /*4988*/
			$k[$j++] = _2E; /*4989*/
			$forall($geti($1.barcode, 4, 13), function() { /*4989*/
				var _2H = $k[--$j]; /*4989*/
				$k[$j++] = _2H - 48; /*4989*/
			}); /*4989*/
			$1.binval = $a(); /*4990*/
			for (var _2J = 0; _2J <= 12; _2J += 1) { /*4996*/
				$1.i = _2J; /*4993*/
				var _2K = $1.binval; /*4994*/
				var _2L = $1.i; /*4994*/
				$put(_2K, _2L + 1, $get(_2K, _2L + 1) + (($get($1.binval, $1.i) % 4537077) * 10)); /*4994*/
				$put($1.binval, $1.i, ~~($get($1.binval, $1.i) / 4537077)); /*4995*/
			} /*4995*/
			$1.right = $get($1.binval, 13) % 4537077; /*4997*/
			var _2X = $1.binval; /*4998*/
			$put(_2X, 13, ~~($get(_2X, 13) / 4537077)); /*4998*/
			$1.left = 0; /*5000*/
			$1.i = true; /*5001*/
			for (var _2Z = 0; _2Z <= 13; _2Z += 1) { /*5011*/
				$1.j = _2Z; /*5003*/
				var _2c = $get($1.binval, $1.j); /*5004*/
				$k[$j++] = _2c; /*5010*/
				if ((_2c == 0) && $1.i) { /*5009*/
					$j--; /*5006*/
				} else { /*5009*/
					$1.i = false; /*5008*/
					$1.left = $1.left + ($k[--$j] * (~~Math.pow(10, 13 - $1.j))); /*5009*/
				} /*5009*/
			} /*5009*/
			$1.d1 = ~~($1.left / 1597); /*5013*/
			$1.d2 = $1.left % 1597; /*5014*/
			$1.d3 = ~~($1.right / 1597); /*5015*/
			$1.d4 = $1.right % 1597; /*5016*/
			$1.tab164 = $a([160, 0, 12, 4, 8, 1, 161, 1, 960, 161, 10, 6, 6, 3, 80, 10, 2014, 961, 8, 8, 4, 5, 31, 34, 2714, 2015, 6, 10, 3, 6, 10, 70, 2840, 2715, 4, 12, 1, 8, 1, 126]); /*5024*/
			$1.tab154 = $a([335, 0, 5, 10, 2, 7, 4, 84, 1035, 336, 7, 8, 4, 5, 20, 35, 1515, 1036, 9, 6, 6, 3, 48, 10, 1596, 1516, 11, 4, 8, 1, 81, 1]); /*5031*/
			$1.i = 0; /*5033*/
			for (;;) { /*5043*/
				if ($1.d1 <= $get($1.tab164, $1.i)) { /*5041*/
					$forall($geti($1.tab164, $1.i + 1, 7)); /*5035*/
					$1.d1te = $k[--$j]; /*5036*/
					$1.d1to = $k[--$j]; /*5036*/
					$1.d1mwe = $k[--$j]; /*5037*/
					$1.d1mwo = $k[--$j]; /*5037*/
					$1.d1ele = $k[--$j]; /*5038*/
					$1.d1elo = $k[--$j]; /*5038*/
					$1.d1gs = $k[--$j]; /*5039*/
					break; /*5040*/
				} /*5040*/
				$1.i = $1.i + 8; /*5042*/
			} /*5042*/
			$1.i = 0; /*5045*/
			for (;;) { /*5055*/
				if ($1.d2 <= $get($1.tab154, $1.i)) { /*5053*/
					$forall($geti($1.tab154, $1.i + 1, 7)); /*5047*/
					$1.d2te = $k[--$j]; /*5048*/
					$1.d2to = $k[--$j]; /*5048*/
					$1.d2mwe = $k[--$j]; /*5049*/
					$1.d2mwo = $k[--$j]; /*5049*/
					$1.d2ele = $k[--$j]; /*5050*/
					$1.d2elo = $k[--$j]; /*5050*/
					$1.d2gs = $k[--$j]; /*5051*/
					break; /*5052*/
				} /*5052*/
				$1.i = $1.i + 8; /*5054*/
			} /*5054*/
			$1.i = 0; /*5057*/
			for (;;) { /*5067*/
				if ($1.d3 <= $get($1.tab164, $1.i)) { /*5065*/
					$forall($geti($1.tab164, $1.i + 1, 7)); /*5059*/
					$1.d3te = $k[--$j]; /*5060*/
					$1.d3to = $k[--$j]; /*5060*/
					$1.d3mwe = $k[--$j]; /*5061*/
					$1.d3mwo = $k[--$j]; /*5061*/
					$1.d3ele = $k[--$j]; /*5062*/
					$1.d3elo = $k[--$j]; /*5062*/
					$1.d3gs = $k[--$j]; /*5063*/
					break; /*5064*/
				} /*5064*/
				$1.i = $1.i + 8; /*5066*/
			} /*5066*/
			$1.i = 0; /*5069*/
			for (;;) { /*5079*/
				if ($1.d4 <= $get($1.tab154, $1.i)) { /*5077*/
					$forall($geti($1.tab154, $1.i + 1, 7)); /*5071*/
					$1.d4te = $k[--$j]; /*5072*/
					$1.d4to = $k[--$j]; /*5072*/
					$1.d4mwe = $k[--$j]; /*5073*/
					$1.d4mwo = $k[--$j]; /*5073*/
					$1.d4ele = $k[--$j]; /*5074*/
					$1.d4elo = $k[--$j]; /*5074*/
					$1.d4gs = $k[--$j]; /*5075*/
					break; /*5076*/
				} /*5076*/
				$1.i = $1.i + 8; /*5078*/
			} /*5078*/
			$k[$j++] = "d1wo"; /*5081*/
			$k[$j++] = ~~(($1.d1 - $1.d1gs) / $1.d1te); /*5081*/
			$k[$j++] = $1.d1elo; /*5081*/
			$k[$j++] = $1.d1mwo; /*5081*/
			$k[$j++] = 4; /*5081*/
			$k[$j++] = false; /*5081*/
			if ($1.getRSSwidths() == $b) return $b; /*5081*/
			var _3q = $k[--$j]; /*5081*/
			$1[$k[--$j]] = _3q; /*5081*/
			$k[$j++] = "d1we"; /*5082*/
			$k[$j++] = ($1.d1 - $1.d1gs) % $1.d1te; /*5082*/
			$k[$j++] = $1.d1ele; /*5082*/
			$k[$j++] = $1.d1mwe; /*5082*/
			$k[$j++] = 4; /*5082*/
			$k[$j++] = true; /*5082*/
			if ($1.getRSSwidths() == $b) return $b; /*5082*/
			var _3x = $k[--$j]; /*5082*/
			$1[$k[--$j]] = _3x; /*5082*/
			$k[$j++] = "d2wo"; /*5083*/
			$k[$j++] = ($1.d2 - $1.d2gs) % $1.d2to; /*5083*/
			$k[$j++] = $1.d2elo; /*5083*/
			$k[$j++] = $1.d2mwo; /*5083*/
			$k[$j++] = 4; /*5083*/
			$k[$j++] = true; /*5083*/
			if ($1.getRSSwidths() == $b) return $b; /*5083*/
			var _44 = $k[--$j]; /*5083*/
			$1[$k[--$j]] = _44; /*5083*/
			$k[$j++] = "d2we"; /*5084*/
			$k[$j++] = ~~(($1.d2 - $1.d2gs) / $1.d2to); /*5084*/
			$k[$j++] = $1.d2ele; /*5084*/
			$k[$j++] = $1.d2mwe; /*5084*/
			$k[$j++] = 4; /*5084*/
			$k[$j++] = false; /*5084*/
			if ($1.getRSSwidths() == $b) return $b; /*5084*/
			var _4B = $k[--$j]; /*5084*/
			$1[$k[--$j]] = _4B; /*5084*/
			$k[$j++] = "d3wo"; /*5085*/
			$k[$j++] = ~~(($1.d3 - $1.d3gs) / $1.d3te); /*5085*/
			$k[$j++] = $1.d3elo; /*5085*/
			$k[$j++] = $1.d3mwo; /*5085*/
			$k[$j++] = 4; /*5085*/
			$k[$j++] = false; /*5085*/
			if ($1.getRSSwidths() == $b) return $b; /*5085*/
			var _4I = $k[--$j]; /*5085*/
			$1[$k[--$j]] = _4I; /*5085*/
			$k[$j++] = "d3we"; /*5086*/
			$k[$j++] = ($1.d3 - $1.d3gs) % $1.d3te; /*5086*/
			$k[$j++] = $1.d3ele; /*5086*/
			$k[$j++] = $1.d3mwe; /*5086*/
			$k[$j++] = 4; /*5086*/
			$k[$j++] = true; /*5086*/
			if ($1.getRSSwidths() == $b) return $b; /*5086*/
			var _4P = $k[--$j]; /*5086*/
			$1[$k[--$j]] = _4P; /*5086*/
			$k[$j++] = "d4wo"; /*5087*/
			$k[$j++] = ($1.d4 - $1.d4gs) % $1.d4to; /*5087*/
			$k[$j++] = $1.d4elo; /*5087*/
			$k[$j++] = $1.d4mwo; /*5087*/
			$k[$j++] = 4; /*5087*/
			$k[$j++] = true; /*5087*/
			if ($1.getRSSwidths() == $b) return $b; /*5087*/
			var _4W = $k[--$j]; /*5087*/
			$1[$k[--$j]] = _4W; /*5087*/
			$k[$j++] = "d4we"; /*5088*/
			$k[$j++] = ~~(($1.d4 - $1.d4gs) / $1.d4to); /*5088*/
			$k[$j++] = $1.d4ele; /*5088*/
			$k[$j++] = $1.d4mwe; /*5088*/
			$k[$j++] = 4; /*5088*/
			$k[$j++] = false; /*5088*/
			if ($1.getRSSwidths() == $b) return $b; /*5088*/
			var _4d = $k[--$j]; /*5088*/
			$1[$k[--$j]] = _4d; /*5088*/
			$1.d1w = $a(8); /*5090*/
			for (var _4g = 0; _4g <= 3; _4g += 1) { /*5095*/
				$1.i = _4g; /*5092*/
				$put($1.d1w, $1.i * 2, $get($1.d1wo, $1.i)); /*5093*/
				$put($1.d1w, ($1.i * 2) + 1, $get($1.d1we, $1.i)); /*5094*/
			} /*5094*/
			$1.d2w = $a(8); /*5097*/
			for (var _4s = 0; _4s <= 3; _4s += 1) { /*5102*/
				$1.i = _4s; /*5099*/
				$put($1.d2w, 7 - ($1.i * 2), $get($1.d2wo, $1.i)); /*5100*/
				$put($1.d2w, 6 - ($1.i * 2), $get($1.d2we, $1.i)); /*5101*/
			} /*5101*/
			$1.d3w = $a(8); /*5104*/
			for (var _54 = 0; _54 <= 3; _54 += 1) { /*5109*/
				$1.i = _54; /*5106*/
				$put($1.d3w, 7 - ($1.i * 2), $get($1.d3wo, $1.i)); /*5107*/
				$put($1.d3w, 6 - ($1.i * 2), $get($1.d3we, $1.i)); /*5108*/
			} /*5108*/
			$1.d4w = $a(8); /*5111*/
			for (var _5G = 0; _5G <= 3; _5G += 1) { /*5116*/
				$1.i = _5G; /*5113*/
				$put($1.d4w, $1.i * 2, $get($1.d4wo, $1.i)); /*5114*/
				$put($1.d4w, ($1.i * 2) + 1, $get($1.d4we, $1.i)); /*5115*/
			} /*5115*/
			$k[$j++] = Infinity; /*5123*/
			var _5R = $1.d1w; /*5119*/
			for (var _5S = 0, _5T = _5R.length; _5S < _5T; _5S++) { /*5119*/
				$k[$j++] = $get(_5R, _5S); /*5119*/
			} /*5119*/
			var _5V = $1.d2w; /*5120*/
			for (var _5W = 0, _5X = _5V.length; _5W < _5X; _5W++) { /*5120*/
				$k[$j++] = $get(_5V, _5W); /*5120*/
			} /*5120*/
			var _5Z = $1.d3w; /*5121*/
			for (var _5a = 0, _5b = _5Z.length; _5a < _5b; _5a++) { /*5121*/
				$k[$j++] = $get(_5Z, _5a); /*5121*/
			} /*5121*/
			var _5d = $1.d4w; /*5122*/
			for (var _5e = 0, _5f = _5d.length; _5e < _5f; _5e++) { /*5122*/
				$k[$j++] = $get(_5d, _5e); /*5122*/
			} /*5122*/
			$1.widths = $a(); /*5123*/
			$1.checkweights = $a([1, 3, 9, 27, 2, 6, 18, 54, 58, 72, 24, 8, 29, 36, 12, 4, 74, 51, 17, 32, 37, 65, 48, 16, 64, 34, 23, 69, 49, 68, 46, 59]); /*5130*/
			$1.checkwidths = $a([3, 8, 2, 1, 1, 3, 5, 5, 1, 1, 3, 3, 7, 1, 1, 3, 1, 9, 1, 1, 2, 7, 4, 1, 1, 2, 5, 6, 1, 1, 2, 3, 8, 1, 1, 1, 5, 7, 1, 1, 1, 3, 9, 1, 1]); /*5136*/
			$1.checksum = 0; /*5138*/
			for (var _5k = 0; _5k <= 31; _5k += 1) { /*5142*/
				$1.i = _5k; /*5140*/
				$1.checksum = $1.checksum + ($get($1.widths, $1.i) * $get($1.checkweights, $1.i)); /*5141*/
			} /*5141*/
			$1.checksum = $1.checksum % 79; /*5143*/
			if ($1.checksum >= 8) { /*5144*/
				$1.checksum = $1.checksum + 1; /*5144*/
			} /*5144*/
			if ($1.checksum >= 72) { /*5145*/
				$1.checksum = $1.checksum + 1; /*5145*/
			} /*5145*/
			$1.checklt = $geti($1.checkwidths, (~~($1.checksum / 9)) * 5, 5); /*5146*/
			$1.checkrtrev = $geti($1.checkwidths, ($1.checksum % 9) * 5, 5); /*5147*/
			$1.checkrt = $a(5); /*5148*/
			for (var _64 = 0; _64 <= 4; _64 += 1) { /*5152*/
				$1.i = _64; /*5150*/
				$put($1.checkrt, $1.i, $get($1.checkrtrev, 4 - $1.i)); /*5151*/
			} /*5151*/
			if ($eq($1.format, "omni") || $eq($1.format, "truncated")) { /*5271*/
				$k[$j++] = Infinity; /*5160*/
				var _6C = $1.d1w; /*5158*/
				$k[$j++] = 1; /*5158*/
				for (var _6D = 0, _6E = _6C.length; _6D < _6E; _6D++) { /*5158*/
					$k[$j++] = $get(_6C, _6D); /*5158*/
				} /*5158*/
				$forall($1.checklt); /*5158*/
				var _6H = $1.d2w; /*5158*/
				for (var _6I = 0, _6J = _6H.length; _6I < _6J; _6I++) { /*5158*/
					$k[$j++] = $get(_6H, _6I); /*5158*/
				} /*5158*/
				var _6L = $1.d4w; /*5159*/
				for (var _6M = 0, _6N = _6L.length; _6M < _6N; _6M++) { /*5159*/
					$k[$j++] = $get(_6L, _6M); /*5159*/
				} /*5159*/
				var _6P = $1.checkrt; /*5159*/
				for (var _6Q = 0, _6R = _6P.length; _6Q < _6R; _6Q++) { /*5159*/
					$k[$j++] = $get(_6P, _6Q); /*5159*/
				} /*5159*/
				var _6T = $1.d3w; /*5159*/
				for (var _6U = 0, _6V = _6T.length; _6U < _6V; _6U++) { /*5159*/
					$k[$j++] = $get(_6T, _6U); /*5159*/
				} /*5159*/
				$k[$j++] = 1; /*5159*/
				$k[$j++] = 1; /*5159*/
				$1.sbs = $a(); /*5160*/
				$k[$j++] = Infinity; /*5169*/
				$k[$j++] = "ren"; /*5166*/
				$k[$j++] = $0.renlinear; /*5166*/
				$k[$j++] = "sbs"; /*5166*/
				$k[$j++] = $1.sbs; /*5166*/
				$k[$j++] = "bhs"; /*5166*/
				$k[$j++] = Infinity; /*5166*/
				for (var _6a = 0, _6b = ~~(($1.sbs.length + 1) / 2); _6a < _6b; _6a++) { /*5165*/
					$k[$j++] = $1.height; /*5165*/
				} /*5165*/
				var _6d = $a(); /*5166*/
				$k[$j++] = _6d; /*5167*/
				$k[$j++] = "bbs"; /*5167*/
				$k[$j++] = Infinity; /*5167*/
				for (var _6f = 0, _6g = ~~(($1.sbs.length + 1) / 2); _6f < _6g; _6f++) { /*5166*/
					$k[$j++] = 0; /*5166*/
				} /*5166*/
				var _6h = $a(); /*5167*/
				$k[$j++] = _6h; /*5169*/
				$k[$j++] = "txt"; /*5169*/
				$k[$j++] = $1.txt; /*5169*/
				$k[$j++] = "textxalign"; /*5169*/
				$k[$j++] = "center"; /*5169*/
				$k[$j++] = "opt"; /*5169*/
				$k[$j++] = $1.options; /*5169*/
				var _6k = $d(); /*5169*/
				$k[$j++] = _6k; /*5172*/
				if (!$1.dontdraw) { /*5172*/
					$0.renlinear(); /*5172*/
				} /*5172*/
			} else { /*5271*/
				$k[$j++] = Infinity; /*5176*/
				var _6m = $1.d1w; /*5176*/
				$k[$j++] = 1; /*5176*/
				$k[$j++] = 1; /*5176*/
				for (var _6n = 0, _6o = _6m.length; _6n < _6o; _6n++) { /*5176*/
					$k[$j++] = $get(_6m, _6n); /*5176*/
				} /*5176*/
				$forall($1.checklt); /*5176*/
				var _6r = $1.d2w; /*5176*/
				for (var _6s = 0, _6t = _6r.length; _6s < _6t; _6s++) { /*5176*/
					$k[$j++] = $get(_6r, _6s); /*5176*/
				} /*5176*/
				$k[$j++] = 1; /*5176*/
				$k[$j++] = 1; /*5176*/
				$k[$j++] = 0; /*5176*/
				$1.top = $a(); /*5176*/
				$k[$j++] = Infinity; /*5177*/
				var _6w = $1.d4w; /*5177*/
				$k[$j++] = 1; /*5177*/
				$k[$j++] = 1; /*5177*/
				for (var _6x = 0, _6y = _6w.length; _6x < _6y; _6x++) { /*5177*/
					$k[$j++] = $get(_6w, _6x); /*5177*/
				} /*5177*/
				var _70 = $1.checkrt; /*5177*/
				for (var _71 = 0, _72 = _70.length; _71 < _72; _71++) { /*5177*/
					$k[$j++] = $get(_70, _71); /*5177*/
				} /*5177*/
				var _74 = $1.d3w; /*5177*/
				for (var _75 = 0, _76 = _74.length; _75 < _76; _75++) { /*5177*/
					$k[$j++] = $get(_74, _75); /*5177*/
				} /*5177*/
				$k[$j++] = 1; /*5177*/
				$k[$j++] = 1; /*5177*/
				$k[$j++] = 0; /*5177*/
				$1.bot = $a(); /*5177*/
				for (var _79 = 0; _79 <= 24; _79 += 2) { /*5182*/
					$1.i = _79; /*5179*/
					for (var _7D = 0, _7E = $get($1.top, $1.i); _7D < _7E; _7D++) { /*5180*/
						$k[$j++] = 0; /*5180*/
					} /*5180*/
					for (var _7I = 0, _7J = $get($1.top, $1.i + 1); _7I < _7J; _7I++) { /*5181*/
						$k[$j++] = 1; /*5181*/
					} /*5181*/
				} /*5181*/
				$astore($a(50)); /*5183*/
				$1.top = $k[--$j]; /*5183*/
				for (var _7M = 0; _7M <= 24; _7M += 2) { /*5188*/
					$1.i = _7M; /*5185*/
					for (var _7Q = 0, _7R = $get($1.bot, $1.i); _7Q < _7R; _7Q++) { /*5186*/
						$k[$j++] = 1; /*5186*/
					} /*5186*/
					for (var _7V = 0, _7W = $get($1.bot, $1.i + 1); _7V < _7W; _7V++) { /*5187*/
						$k[$j++] = 0; /*5187*/
					} /*5187*/
				} /*5187*/
				$astore($a(50)); /*5189*/
				$1.bot = $k[--$j]; /*5189*/
				if ($eq($1.format, "stacked")) { /*5208*/
					$k[$j++] = Infinity; /*5193*/
					for (var _7a = 0, _7b = 50; _7a < _7b; _7a++) { /*5193*/
						$k[$j++] = 0; /*5193*/
					} /*5193*/
					$1.sep = $a(); /*5193*/
					for (var _7d = 4; _7d <= 45; _7d += 1) { /*5201*/
						$1.i = _7d; /*5195*/
						if ($eq($get($1.top, $1.i), $get($1.bot, $1.i))) { /*5199*/
							$put($1.sep, $1.i, 1 - $get($1.top, $1.i)); /*5197*/
						} else { /*5199*/
							$put($1.sep, $1.i, 1 - $get($1.sep, $1.i - 1)); /*5199*/
						} /*5199*/
					} /*5199*/
					$k[$j++] = Infinity; /*5206*/
					for (var _7u = 0, _7v = 5; _7u < _7v; _7u++) { /*5203*/
						$aload($1.top); /*5203*/
					} /*5203*/
					$aload($1.sep); /*5204*/
					for (var _7y = 0, _7z = 7; _7y < _7z; _7y++) { /*5205*/
						$aload($1.bot); /*5205*/
					} /*5205*/
					$1.pixs = $a(); /*5206*/
					$1.pixy = ~~($1.pixs.length / 50); /*5207*/
				} /*5207*/
				if ($eq($1.format, "stackedomni")) { /*5258*/
					$k[$j++] = Infinity; /*5212*/
					$forall($1.top, function() { /*5212*/
						var _85 = $k[--$j]; /*5212*/
						$k[$j++] = 1 - _85; /*5212*/
					}); /*5212*/
					$1.sep1 = $a(); /*5212*/
					$puti($1.sep1, 0, $a([0, 0, 0, 0])); /*5213*/
					$puti($1.sep1, 46, $a([0, 0, 0, 0])); /*5214*/
					for (var _8B = 18; _8B <= 30; _8B += 1) { /*5227*/
						$1.i = _8B; /*5216*/
						if ($get($1.top, $1.i) == 0) { /*5224*/
							if ($get($1.top, $1.i - 1) == 1) { /*5221*/
								$k[$j++] = 1; /*5219*/
							} else { /*5221*/
								var _8L = ($get($1.sep1, $1.i - 1) == 0) ? 1 : 0; /*5221*/
								$k[$j++] = _8L; /*5221*/
							} /*5221*/
						} else { /*5224*/
							$k[$j++] = 0; /*5224*/
						} /*5224*/
						$put($1.sep1, $1.i, $k[--$j]); /*5226*/
					} /*5226*/
					$k[$j++] = Infinity; /*5228*/
					$k[$j++] = 0; /*5228*/
					$k[$j++] = 0; /*5228*/
					$k[$j++] = 0; /*5228*/
					$k[$j++] = 0; /*5228*/
					for (var _8P = 0, _8Q = 21; _8P < _8Q; _8P++) { /*5228*/
						$k[$j++] = 0; /*5228*/
						$k[$j++] = 1; /*5228*/
					} /*5228*/
					$k[$j++] = 0; /*5228*/
					$k[$j++] = 0; /*5228*/
					$k[$j++] = 0; /*5228*/
					$k[$j++] = 0; /*5228*/
					$1.sep2 = $a(); /*5228*/
					$k[$j++] = Infinity; /*5229*/
					$forall($1.bot, function() { /*5229*/
						var _8T = $k[--$j]; /*5229*/
						$k[$j++] = 1 - _8T; /*5229*/
					}); /*5229*/
					$1.sep3 = $a(); /*5229*/
					$puti($1.sep3, 0, $a([0, 0, 0, 0])); /*5230*/
					$puti($1.sep3, 46, $a([0, 0, 0, 0])); /*5231*/
					for (var _8Z = 19; _8Z <= 31; _8Z += 1) { /*5244*/
						$1.i = _8Z; /*5233*/
						if ($get($1.bot, $1.i) == 0) { /*5241*/
							if ($get($1.bot, $1.i - 1) == 1) { /*5238*/
								$k[$j++] = 1; /*5236*/
							} else { /*5238*/
								var _8j = ($get($1.sep3, $1.i - 1) == 0) ? 1 : 0; /*5238*/
								$k[$j++] = _8j; /*5238*/
							} /*5238*/
						} else { /*5241*/
							$k[$j++] = 0; /*5241*/
						} /*5241*/
						$put($1.sep3, $1.i, $k[--$j]); /*5243*/
					} /*5243*/
					$1.f3 = $a([1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1]); /*5245*/
					$k[$j++] = true; /*5246*/
					for (var _8o = 0; _8o <= 12; _8o += 1) { /*5246*/
						var _8t = $k[--$j]; /*5246*/
						$k[$j++] = _8t && $eq($get($1.bot, _8o + 19), $get($1.f3, _8o)); /*5246*/
					} /*5246*/
					if ($k[--$j]) { /*5249*/
						$puti($1.sep3, 19, $a([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0])); /*5248*/
					} /*5248*/
					$k[$j++] = Infinity; /*5256*/
					for (var _8y = 0, _8z = $1.barxmult; _8y < _8z; _8y++) { /*5251*/
						$aload($1.top); /*5251*/
					} /*5251*/
					$aload($1.sep1); /*5252*/
					$aload($1.sep2); /*5253*/
					$aload($1.sep3); /*5254*/
					for (var _95 = 0, _96 = $1.barxmult; _95 < _96; _95++) { /*5255*/
						$aload($1.bot); /*5255*/
					} /*5255*/
					$1.pixs = $a(); /*5256*/
					$1.pixy = ~~($1.pixs.length / 50); /*5257*/
				} /*5257*/
				var _9E = {
					ren: $0.renmatrix,
					pixs: $1.pixs,
					pixx: 50,
					pixy: $1.pixy,
					height: $1.pixy / 72,
					width: 50 / 72,
					opt: $1.options
				}; /*5268*/
				$k[$j++] = _9E; /*5271*/
				if (!$1.dontdraw) { /*5271*/
					$0.renmatrix(); /*5271*/
				} /*5271*/
			} /*5271*/
		};
		$0.databarstacked = function() {
			var $1 = {}; /*5301*/
			$1.options = $k[--$j]; /*5303*/
			$1.barcode = $k[--$j]; /*5304*/
			$1.dontdraw = false; /*5306*/
			$forall($1.options, function() { /*5317*/
				var _3 = $k[--$j]; /*5317*/
				$1[$k[--$j]] = _3; /*5317*/
			}); /*5317*/
			if ($ne($geti($1.barcode, 0, 4), "(01)")) { /*5322*/
				$k[$j++] = "bwipp.databarstackedBadAI"; /*5321*/
				$k[$j++] = "GS1 DataBar Stacked must begin with (01) application identifier"; /*5321*/
				$0.raiseerror(); /*5321*/
			} /*5321*/
			if (($1.barcode.length != 17) && ($1.barcode.length != 18)) { /*5325*/
				$k[$j++] = "bwipp.databarstackedBadLength"; /*5324*/
				$k[$j++] = "GS1 DataBar Stacked must be 13 or 14 digits"; /*5324*/
				$0.raiseerror(); /*5324*/
			} /*5324*/
			$forall($geti($1.barcode, 4, $1.barcode.length - 4), function() { /*5330*/
				var _C = $k[--$j]; /*5327*/
				if ((_C < 48) || (_C > 57)) { /*5329*/
					$k[$j++] = "bwipp.databarstackedBadCharacter"; /*5328*/
					$k[$j++] = "GS1 DataBar Stacked must contain only digits"; /*5328*/
					$0.raiseerror(); /*5328*/
				} /*5328*/
			}); /*5328*/
			$1.checksum = 0; /*5333*/
			for (var _D = 0; _D <= 12; _D += 1) { /*5337*/
				$1.i = _D; /*5335*/
				$k[$j++] = "checksum"; /*5336*/
				$k[$j++] = $1.checksum; /*5336*/
				$k[$j++] = $get($1.barcode, $1.i + 4) - 48; /*5336*/
				if (($1.i % 2) == 0) { /*5336*/
					var _J = $k[--$j]; /*5336*/
					$k[$j++] = _J * 3; /*5336*/
				} /*5336*/
				var _K = $k[--$j]; /*5336*/
				var _L = $k[--$j]; /*5336*/
				$1[$k[--$j]] = _L + _K; /*5336*/
			} /*5336*/
			$1.checksum = (10 - ($1.checksum % 10)) % 10; /*5338*/
			if ($1.barcode.length == 18) { /*5343*/
				if ($get($1.barcode, 17) != ($1.checksum + 48)) { /*5342*/
					$k[$j++] = "bwipp.databarstackedBadCheckDigit"; /*5341*/
					$k[$j++] = "Incorrect GS1 DataBar Stacked check digit provided"; /*5341*/
					$0.raiseerror(); /*5341*/
				} /*5341*/
			} /*5341*/
			var _S = $s(18); /*5344*/
			$puti(_S, 0, $1.barcode); /*5345*/
			$put(_S, 17, $1.checksum + 48); /*5346*/
			$1.barcode = _S; /*5347*/
			$1.options.dontdraw = true; /*5350*/
			$1.options.format = "stacked"; /*5351*/
			$k[$j++] = "args"; /*5353*/
			$k[$j++] = $1.barcode; /*5353*/
			$k[$j++] = $1.options; /*5353*/
			$0.databaromni(); /*5353*/
			var _Z = $k[--$j]; /*5353*/
			$1[$k[--$j]] = _Z; /*5353*/
			$1.args.opt = $1.options; /*5355*/
			$k[$j++] = $1.args; /*5358*/
			if (!$1.dontdraw) { /*5358*/
				$0.renmatrix(); /*5358*/
			} /*5358*/
		};
		$0.databarstackedomni = function() {
			var $1 = {}; /*5386*/
			$1.options = $k[--$j]; /*5388*/
			$1.barcode = $k[--$j]; /*5389*/
			$1.dontdraw = false; /*5391*/
			$forall($1.options, function() { /*5402*/
				var _3 = $k[--$j]; /*5402*/
				$1[$k[--$j]] = _3; /*5402*/
			}); /*5402*/
			if ($ne($geti($1.barcode, 0, 4), "(01)")) { /*5407*/
				$k[$j++] = "bwipp.databarstackedomniBadAI"; /*5406*/
				$k[$j++] = "GS1 DataBar Stacked Omnidirectional must begin with (01) application identifier"; /*5406*/
				$0.raiseerror(); /*5406*/
			} /*5406*/
			if (($1.barcode.length != 17) && ($1.barcode.length != 18)) { /*5410*/
				$k[$j++] = "bwipp.databarstackedomniBadLength"; /*5409*/
				$k[$j++] = "GS1 DataBar Stacked Omnidirectional must be 13 or 14 digits"; /*5409*/
				$0.raiseerror(); /*5409*/
			} /*5409*/
			$forall($geti($1.barcode, 4, $1.barcode.length - 4), function() { /*5415*/
				var _C = $k[--$j]; /*5412*/
				if ((_C < 48) || (_C > 57)) { /*5414*/
					$k[$j++] = "bwipp.databarstackedomniBadCharacter"; /*5413*/
					$k[$j++] = "GS1 DataBar Stacked Omnidirectional must contain only digits"; /*5413*/
					$0.raiseerror(); /*5413*/
				} /*5413*/
			}); /*5413*/
			$1.checksum = 0; /*5418*/
			for (var _D = 0; _D <= 12; _D += 1) { /*5422*/
				$1.i = _D; /*5420*/
				$k[$j++] = "checksum"; /*5421*/
				$k[$j++] = $1.checksum; /*5421*/
				$k[$j++] = $get($1.barcode, $1.i + 4) - 48; /*5421*/
				if (($1.i % 2) == 0) { /*5421*/
					var _J = $k[--$j]; /*5421*/
					$k[$j++] = _J * 3; /*5421*/
				} /*5421*/
				var _K = $k[--$j]; /*5421*/
				var _L = $k[--$j]; /*5421*/
				$1[$k[--$j]] = _L + _K; /*5421*/
			} /*5421*/
			$1.checksum = (10 - ($1.checksum % 10)) % 10; /*5423*/
			if ($1.barcode.length == 18) { /*5428*/
				if ($get($1.barcode, 17) != ($1.checksum + 48)) { /*5427*/
					$k[$j++] = "bwipp.databarstackedomniBadCheckDigit"; /*5426*/
					$k[$j++] = "Incorrect GS1 DataBar Stacked Omnidirectional check digit provided"; /*5426*/
					$0.raiseerror(); /*5426*/
				} /*5426*/
			} /*5426*/
			var _S = $s(18); /*5429*/
			$puti(_S, 0, $1.barcode); /*5430*/
			$put(_S, 17, $1.checksum + 48); /*5431*/
			$1.barcode = _S; /*5432*/
			$1.options.dontdraw = true; /*5435*/
			$1.options.format = "stackedomni"; /*5436*/
			$k[$j++] = "args"; /*5438*/
			$k[$j++] = $1.barcode; /*5438*/
			$k[$j++] = $1.options; /*5438*/
			$0.databaromni(); /*5438*/
			var _Z = $k[--$j]; /*5438*/
			$1[$k[--$j]] = _Z; /*5438*/
			$1.args.opt = $1.options; /*5440*/
			$k[$j++] = $1.args; /*5443*/
			if (!$1.dontdraw) { /*5443*/
				$0.renmatrix(); /*5443*/
			} /*5443*/
		};
		$0.databartruncated = function() {
			var $1 = {}; /*5471*/
			$1.options = $k[--$j]; /*5473*/
			$1.barcode = $k[--$j]; /*5474*/
			$1.dontdraw = false; /*5476*/
			$forall($1.options, function() { /*5487*/
				var _3 = $k[--$j]; /*5487*/
				$1[$k[--$j]] = _3; /*5487*/
			}); /*5487*/
			if ($ne($geti($1.barcode, 0, 4), "(01)")) { /*5492*/
				$k[$j++] = "bwipp.databartruncatedBadAI"; /*5491*/
				$k[$j++] = "GS1 DataBar Truncated must begin with (01) application identifier"; /*5491*/
				$0.raiseerror(); /*5491*/
			} /*5491*/
			if (($1.barcode.length != 17) && ($1.barcode.length != 18)) { /*5495*/
				$k[$j++] = "bwipp.databartruncatedBadLength"; /*5494*/
				$k[$j++] = "GS1 DataBar Truncated must be 13 or 14 digits"; /*5494*/
				$0.raiseerror(); /*5494*/
			} /*5494*/
			$forall($geti($1.barcode, 4, $1.barcode.length - 4), function() { /*5500*/
				var _C = $k[--$j]; /*5497*/
				if ((_C < 48) || (_C > 57)) { /*5499*/
					$k[$j++] = "bwipp.databartruncatedBadCharacter"; /*5498*/
					$k[$j++] = "GS1 DataBar Truncated must contain only digits"; /*5498*/
					$0.raiseerror(); /*5498*/
				} /*5498*/
			}); /*5498*/
			$1.checksum = 0; /*5503*/
			for (var _D = 0; _D <= 12; _D += 1) { /*5507*/
				$1.i = _D; /*5505*/
				$k[$j++] = "checksum"; /*5506*/
				$k[$j++] = $1.checksum; /*5506*/
				$k[$j++] = $get($1.barcode, $1.i + 4) - 48; /*5506*/
				if (($1.i % 2) == 0) { /*5506*/
					var _J = $k[--$j]; /*5506*/
					$k[$j++] = _J * 3; /*5506*/
				} /*5506*/
				var _K = $k[--$j]; /*5506*/
				var _L = $k[--$j]; /*5506*/
				$1[$k[--$j]] = _L + _K; /*5506*/
			} /*5506*/
			$1.checksum = (10 - ($1.checksum % 10)) % 10; /*5508*/
			if ($1.barcode.length == 18) { /*5513*/
				if ($get($1.barcode, 17) != ($1.checksum + 48)) { /*5512*/
					$k[$j++] = "bwipp.databartruncatedBadCheckDigit"; /*5511*/
					$k[$j++] = "Incorrect GS1 DataBar Truncated check digit provided"; /*5511*/
					$0.raiseerror(); /*5511*/
				} /*5511*/
			} /*5511*/
			var _S = $s(18); /*5514*/
			$puti(_S, 0, $1.barcode); /*5515*/
			$put(_S, 17, $1.checksum + 48); /*5516*/
			$1.barcode = _S; /*5517*/
			$1.options.dontdraw = true; /*5520*/
			$1.options.format = "truncated"; /*5521*/
			$k[$j++] = "args"; /*5523*/
			$k[$j++] = $1.barcode; /*5523*/
			$k[$j++] = $1.options; /*5523*/
			$0.databaromni(); /*5523*/
			var _Z = $k[--$j]; /*5523*/
			$1[$k[--$j]] = _Z; /*5523*/
			$1.args.opt = $1.options; /*5525*/
			$k[$j++] = $1.args; /*5528*/
			if (!$1.dontdraw) { /*5528*/
				$0.renlinear(); /*5528*/
			} /*5528*/
		};
		$0.databarlimited = function() {
			var $1 = {}; /*5555*/
			$1.options = $k[--$j]; /*5557*/
			$1.barcode = $k[--$j]; /*5558*/
			$1.dontdraw = false; /*5560*/
			$1.height = 10 / 72; /*5561*/
			$1.linkage = false; /*5562*/
			$forall($1.options, function() { /*5573*/
				var _3 = $k[--$j]; /*5573*/
				$1[$k[--$j]] = _3; /*5573*/
			}); /*5573*/
			$1.height = +$1.height; /*5575*/
			if ($ne($geti($1.barcode, 0, 4), "(01)")) { /*5580*/
				$k[$j++] = "bwipp.databarlimitedBadAI"; /*5579*/
				$k[$j++] = "GS1 DataBar Limited must begin with (01) application identifier"; /*5579*/
				$0.raiseerror(); /*5579*/
			} /*5579*/
			if (($1.barcode.length != 17) && ($1.barcode.length != 18)) { /*5583*/
				$k[$j++] = "bwipp.databarlimitedBadLength"; /*5582*/
				$k[$j++] = "GS1 DataBar Limited must be 13 or 14 digits"; /*5582*/
				$0.raiseerror(); /*5582*/
			} /*5582*/
			var _B = $get($1.barcode, 4); /*5584*/
			if ((_B < 48) || (_B > 49)) { /*5586*/
				$k[$j++] = "bwipp.databarlimitedBadStartDigit"; /*5585*/
				$k[$j++] = "GS1 DataBar Limited must begin with 0 or 1"; /*5585*/
				$0.raiseerror(); /*5585*/
			} /*5585*/
			$forall($geti($1.barcode, 5, $1.barcode.length - 5), function() { /*5591*/
				var _F = $k[--$j]; /*5588*/
				if ((_F < 48) || (_F > 57)) { /*5590*/
					$k[$j++] = "bwipp.databarlimitedBadCharacter"; /*5589*/
					$k[$j++] = "GS1 DataBar Limited must contain only digits"; /*5589*/
					$0.raiseerror(); /*5589*/
				} /*5589*/
			}); /*5589*/
			$1.checksum = 0; /*5594*/
			for (var _G = 0; _G <= 12; _G += 1) { /*5598*/
				$1.i = _G; /*5596*/
				$k[$j++] = "checksum"; /*5597*/
				$k[$j++] = $1.checksum; /*5597*/
				$k[$j++] = $get($1.barcode, $1.i + 4) - 48; /*5597*/
				if (($1.i % 2) == 0) { /*5597*/
					var _M = $k[--$j]; /*5597*/
					$k[$j++] = _M * 3; /*5597*/
				} /*5597*/
				var _N = $k[--$j]; /*5597*/
				var _O = $k[--$j]; /*5597*/
				$1[$k[--$j]] = _O + _N; /*5597*/
			} /*5597*/
			$1.checksum = (10 - ($1.checksum % 10)) % 10; /*5599*/
			if ($1.barcode.length == 18) { /*5604*/
				if ($get($1.barcode, 17) != ($1.checksum + 48)) { /*5603*/
					$k[$j++] = "bwipp.databarlimitedBadCheckDigit"; /*5602*/
					$k[$j++] = "Incorrect GS1 DataBar Limited check digit provided"; /*5602*/
					$0.raiseerror(); /*5602*/
				} /*5602*/
			} /*5602*/
			var _V = $s(18); /*5605*/
			$puti(_V, 0, $1.barcode); /*5606*/
			$put(_V, 17, $1.checksum + 48); /*5607*/
			$1.barcode = _V; /*5608*/
			$k[$j++] = Infinity; /*5613*/
			$forall($geti($1.barcode, 4, 13), function() { /*5612*/
				var _a = $k[--$j]; /*5612*/
				$k[$j++] = _a - 48; /*5612*/
			}); /*5612*/
			$1.binval = $a(); /*5613*/
			if ($1.linkage) { /*5620*/
				$1.linkval = $a([2, 0, 1, 5, 1, 3, 3, 5, 3, 1, 0, 9, 6]); /*5615*/
				for (var _g = 0, _f = $1.binval.length - 1; _g <= _f; _g += 1) { /*5619*/
					$1.i = _g; /*5617*/
					$put($1.binval, $1.i, $get($1.binval, $1.i) + $get($1.linkval, $1.i)); /*5618*/
				} /*5618*/
			} /*5618*/
			$1.txt = $a($1.barcode.length); /*5623*/
			for (var _t = 0, _s = $1.barcode.length - 1; _t <= _s; _t += 1) { /*5627*/
				$1.i = _t; /*5625*/
				$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), 0, 0, "", 0])); /*5626*/
			} /*5626*/
			$1.ncr = function() {
				var _10 = $k[--$j]; /*5630*/
				var _11 = $k[--$j]; /*5630*/
				var _12 = _11 - _10; /*5630*/
				if (_10 < (_11 - _10)) { /*5630*/
					var _ = _12; /*5630*/
					_12 = _10; /*5630*/
					_10 = _; /*5630*/
				} /*5630*/
				$k[$j++] = _12; /*5637*/
				$k[$j++] = 1; /*5637*/
				$k[$j++] = 1; /*5637*/
				for (var _14 = _11, _13 = _10 + 1; _14 >= _13; _14 -= 1) { /*5637*/
					var _15 = $k[--$j]; /*5633*/
					var _16 = $k[--$j]; /*5634*/
					var _17 = $k[--$j]; /*5634*/
					$k[$j++] = _17; /*5636*/
					$k[$j++] = _16; /*5636*/
					$k[$j++] = _15 * _14; /*5636*/
					if ($le(_16, _17)) { /*5636*/
						var _18 = $k[--$j]; /*5635*/
						var _19 = $k[--$j]; /*5635*/
						$k[$j++] = _19 + 1; /*5635*/
						$k[$j++] = ~~(_18 / _19); /*5635*/
					} /*5635*/
				} /*5635*/
				for (;;) { /*5641*/
					var _1A = $k[--$j]; /*5639*/
					var _1B = $k[--$j]; /*5639*/
					var _1C = $k[--$j]; /*5639*/
					$k[$j++] = _1C; /*5639*/
					$k[$j++] = _1B; /*5639*/
					$k[$j++] = _1A; /*5639*/
					if ($gt(_1B, _1C)) { /*5639*/
						break; /*5639*/
					} /*5639*/
					var _1D = $k[--$j]; /*5640*/
					var _1E = $k[--$j]; /*5640*/
					$k[$j++] = _1E + 1; /*5640*/
					$k[$j++] = ~~(_1D / _1E); /*5640*/
				} /*5640*/
				var _1F = $k[--$j]; /*5642*/
				var _1G = $k[--$j]; /*5642*/
				var _1H = $k[--$j]; /*5642*/
				$k[$j++] = _1F; /*5642*/
			}; /*5643*/
			$1.getRSSwidths = function() {
				$1.oe = $k[--$j]; /*5646*/
				$1.el = $k[--$j]; /*5647*/
				$1.mw = $k[--$j]; /*5648*/
				$1.nm = $k[--$j]; /*5649*/
				$1.val = $k[--$j]; /*5650*/
				$1.out = $a($1.el); /*5651*/
				$1.mask = 0; /*5652*/
				for (var _1R = 0, _1Q = $1.el - 2; _1R <= _1Q; _1R += 1) { /*5679*/
					$1.bar = _1R; /*5654*/
					$1.ew = 1; /*5655*/
					var _1T = $1.bar; /*5656*/
					$1.mask = $1.mask | ((_1T < 0 ? 1 >>> -_1T : 1 << _1T)); /*5656*/
					for (;;) { /*5675*/
						$k[$j++] = "sval"; /*5657*/
						$k[$j++] = ($1.nm - $1.ew) - 1; /*5657*/
						$k[$j++] = ($1.el - $1.bar) - 2; /*5657*/
						if ($1.ncr() == $b) break; /*5657*/
						var _1Y = $k[--$j]; /*5657*/
						$1[$k[--$j]] = _1Y; /*5657*/
						if (($1.oe && ($1.mask == 0)) && (((($1.nm - $1.ew) - ($1.el * 2)) + ($1.bar * 2)) >= -2)) { /*5660*/
							$k[$j++] = "sval"; /*5659*/
							$k[$j++] = $1.sval; /*5659*/
							$k[$j++] = (($1.nm - $1.ew) - $1.el) + $1.bar; /*5659*/
							$k[$j++] = ($1.el - $1.bar) - 2; /*5659*/
							if ($1.ncr() == $b) break; /*5659*/
							var _1n = $k[--$j]; /*5659*/
							var _1o = $k[--$j]; /*5659*/
							$1[$k[--$j]] = _1o - _1n; /*5659*/
						} /*5659*/
						if (($1.el - $1.bar) > 2) { /*5669*/
							$1.lval = 0; /*5662*/
							for (var _1y = ((($1.nm - $1.ew) - $1.el) + $1.bar) + 2, _1x = $1.mw + 1; _1y >= _1x; _1y -= 1) { /*5666*/
								$k[$j++] = (($1.nm - _1y) - $1.ew) - 1; /*5664*/
								$k[$j++] = ($1.el - $1.bar) - 3; /*5664*/
								if ($1.ncr() == $b) break; /*5664*/
								$1.lval = $k[--$j] + $1.lval; /*5665*/
							} /*5665*/
							$1.sval = $1.sval - ($1.lval * (($1.el - $1.bar) - 1)); /*5667*/
						} else { /*5669*/
							if (($1.nm - $1.ew) > $1.mw) { /*5669*/
								$1.sval = $1.sval - 1; /*5669*/
							} /*5669*/
						} /*5669*/
						$1.val = $1.val - $1.sval; /*5671*/
						if ($1.val < 0) { /*5672*/
							break; /*5672*/
						} /*5672*/
						$1.ew = $1.ew + 1; /*5673*/
						var _2I = $1.bar; /*5674*/
						$1.mask = $1.mask & (~((_2I < 0 ? 1 >>> -_2I : 1 << _2I))); /*5674*/
					} /*5674*/
					$1.val = $1.val + $1.sval; /*5676*/
					$1.nm = $1.nm - $1.ew; /*5677*/
					$put($1.out, $1.bar, $1.ew); /*5678*/
				} /*5678*/
				$put($1.out, $1.el - 1, $1.nm); /*5680*/
				$k[$j++] = $1.out; /*5681*/
			}; /*5682*/
			for (var _2U = 0; _2U <= 11; _2U += 1) { /*5688*/
				$1.i = _2U; /*5685*/
				var _2V = $1.binval; /*5686*/
				var _2W = $1.i; /*5686*/
				$put(_2V, _2W + 1, $get(_2V, _2W + 1) + (($get($1.binval, $1.i) % 2013571) * 10)); /*5686*/
				$put($1.binval, $1.i, ~~($get($1.binval, $1.i) / 2013571)); /*5687*/
			} /*5687*/
			$1.d2 = $get($1.binval, 12) % 2013571; /*5689*/
			var _2i = $1.binval; /*5690*/
			$put(_2i, 12, ~~($get(_2i, 12) / 2013571)); /*5690*/
			$1.d1 = 0; /*5692*/
			$1.i = true; /*5693*/
			for (var _2k = 0; _2k <= 12; _2k += 1) { /*5703*/
				$1.j = _2k; /*5695*/
				var _2n = $get($1.binval, $1.j); /*5696*/
				$k[$j++] = _2n; /*5702*/
				if ((_2n == 0) && $1.i) { /*5701*/
					$j--; /*5698*/
				} else { /*5701*/
					$1.i = false; /*5700*/
					$1.d1 = $1.d1 + ($k[--$j] * (~~Math.pow(10, 12 - $1.j))); /*5701*/
				} /*5701*/
			} /*5701*/
			$1.tab267 = $a([183063, 0, 17, 9, 6, 3, 6538, 28, 820063, 183064, 13, 13, 5, 4, 875, 728, 1000775, 820064, 9, 17, 3, 6, 28, 6454, 1491020, 1000776, 15, 11, 5, 4, 2415, 203, 1979844, 1491021, 11, 15, 4, 5, 203, 2408, 1996938, 1979845, 19, 7, 8, 1, 17094, 1, 2013570, 1996939, 7, 19, 1, 8, 1, 16632]); /*5713*/
			$1.i = 0; /*5715*/
			for (;;) { /*5725*/
				if ($1.d1 <= $get($1.tab267, $1.i)) { /*5723*/
					$forall($geti($1.tab267, $1.i + 1, 7)); /*5717*/
					$1.d1te = $k[--$j]; /*5718*/
					$1.d1to = $k[--$j]; /*5718*/
					$1.d1mwe = $k[--$j]; /*5719*/
					$1.d1mwo = $k[--$j]; /*5719*/
					$1.d1ele = $k[--$j]; /*5720*/
					$1.d1elo = $k[--$j]; /*5720*/
					$1.d1gs = $k[--$j]; /*5721*/
					break; /*5722*/
				} /*5722*/
				$1.i = $1.i + 8; /*5724*/
			} /*5724*/
			$1.i = 0; /*5727*/
			for (;;) { /*5737*/
				if ($1.d2 <= $get($1.tab267, $1.i)) { /*5735*/
					$forall($geti($1.tab267, $1.i + 1, 7)); /*5729*/
					$1.d2te = $k[--$j]; /*5730*/
					$1.d2to = $k[--$j]; /*5730*/
					$1.d2mwe = $k[--$j]; /*5731*/
					$1.d2mwo = $k[--$j]; /*5731*/
					$1.d2ele = $k[--$j]; /*5732*/
					$1.d2elo = $k[--$j]; /*5732*/
					$1.d2gs = $k[--$j]; /*5733*/
					break; /*5734*/
				} /*5734*/
				$1.i = $1.i + 8; /*5736*/
			} /*5736*/
			$k[$j++] = "d1wo"; /*5739*/
			$k[$j++] = ~~(($1.d1 - $1.d1gs) / $1.d1te); /*5739*/
			$k[$j++] = $1.d1elo; /*5739*/
			$k[$j++] = $1.d1mwo; /*5739*/
			$k[$j++] = 7; /*5739*/
			$k[$j++] = false; /*5739*/
			if ($1.getRSSwidths() == $b) return $b; /*5739*/
			var _3S = $k[--$j]; /*5739*/
			$1[$k[--$j]] = _3S; /*5739*/
			$k[$j++] = "d1we"; /*5740*/
			$k[$j++] = ($1.d1 - $1.d1gs) % $1.d1te; /*5740*/
			$k[$j++] = $1.d1ele; /*5740*/
			$k[$j++] = $1.d1mwe; /*5740*/
			$k[$j++] = 7; /*5740*/
			$k[$j++] = true; /*5740*/
			if ($1.getRSSwidths() == $b) return $b; /*5740*/
			var _3Z = $k[--$j]; /*5740*/
			$1[$k[--$j]] = _3Z; /*5740*/
			$k[$j++] = "d2wo"; /*5741*/
			$k[$j++] = ~~(($1.d2 - $1.d2gs) / $1.d2te); /*5741*/
			$k[$j++] = $1.d2elo; /*5741*/
			$k[$j++] = $1.d2mwo; /*5741*/
			$k[$j++] = 7; /*5741*/
			$k[$j++] = false; /*5741*/
			if ($1.getRSSwidths() == $b) return $b; /*5741*/
			var _3g = $k[--$j]; /*5741*/
			$1[$k[--$j]] = _3g; /*5741*/
			$k[$j++] = "d2we"; /*5742*/
			$k[$j++] = ($1.d2 - $1.d2gs) % $1.d2te; /*5742*/
			$k[$j++] = $1.d2ele; /*5742*/
			$k[$j++] = $1.d2mwe; /*5742*/
			$k[$j++] = 7; /*5742*/
			$k[$j++] = true; /*5742*/
			if ($1.getRSSwidths() == $b) return $b; /*5742*/
			var _3n = $k[--$j]; /*5742*/
			$1[$k[--$j]] = _3n; /*5742*/
			$1.d1w = $a(14); /*5744*/
			for (var _3q = 0; _3q <= 6; _3q += 1) { /*5749*/
				$1.i = _3q; /*5746*/
				$put($1.d1w, $1.i * 2, $get($1.d1wo, $1.i)); /*5747*/
				$put($1.d1w, ($1.i * 2) + 1, $get($1.d1we, $1.i)); /*5748*/
			} /*5748*/
			$1.d2w = $a(14); /*5751*/
			for (var _42 = 0; _42 <= 6; _42 += 1) { /*5756*/
				$1.i = _42; /*5753*/
				$put($1.d2w, $1.i * 2, $get($1.d2wo, $1.i)); /*5754*/
				$put($1.d2w, ($1.i * 2) + 1, $get($1.d2we, $1.i)); /*5755*/
			} /*5755*/
			$k[$j++] = Infinity; /*5761*/
			var _4D = $1.d1w; /*5759*/
			for (var _4E = 0, _4F = _4D.length; _4E < _4F; _4E++) { /*5759*/
				$k[$j++] = $get(_4D, _4E); /*5759*/
			} /*5759*/
			var _4H = $1.d2w; /*5760*/
			for (var _4I = 0, _4J = _4H.length; _4I < _4J; _4I++) { /*5760*/
				$k[$j++] = $get(_4H, _4I); /*5760*/
			} /*5760*/
			$1.widths = $a(); /*5761*/
			$1.checkweights = $a([1, 3, 9, 27, 81, 65, 17, 51, 64, 14, 42, 37, 22, 66, 20, 60, 2, 6, 18, 54, 73, 41, 34, 13, 39, 28, 84, 74]); /*5766*/
			$k[$j++] = Infinity; /*5782*/
			for (var _4N = 0; _4N <= 43; _4N += 1) { /*5769*/
				$k[$j++] = _4N; /*5769*/
			} /*5769*/
			$k[$j++] = 45; /*5771*/
			$k[$j++] = 52; /*5771*/
			$k[$j++] = 57; /*5771*/
			for (var _4O = 63; _4O <= 66; _4O += 1) { /*5771*/
				$k[$j++] = _4O; /*5771*/
			} /*5771*/
			for (var _4P = 73; _4P <= 79; _4P += 1) { /*5772*/
				$k[$j++] = _4P; /*5772*/
			} /*5772*/
			$k[$j++] = 82; /*5774*/
			for (var _4Q = 126; _4Q <= 130; _4Q += 1) { /*5774*/
				$k[$j++] = _4Q; /*5774*/
			} /*5774*/
			$k[$j++] = 132; /*5776*/
			for (var _4R = 141; _4R <= 146; _4R += 1) { /*5776*/
				$k[$j++] = _4R; /*5776*/
			} /*5776*/
			for (var _4S = 210; _4S <= 217; _4S += 1) { /*5777*/
				$k[$j++] = _4S; /*5777*/
			} /*5777*/
			$k[$j++] = 220; /*5779*/
			for (var _4T = 316; _4T <= 320; _4T += 1) { /*5779*/
				$k[$j++] = _4T; /*5779*/
			} /*5779*/
			$k[$j++] = 322; /*5781*/
			$k[$j++] = 323; /*5781*/
			$k[$j++] = 326; /*5781*/
			$k[$j++] = 337; /*5781*/
			$1.checkseq = $a(); /*5782*/
			$1.checksum = 0; /*5784*/
			for (var _4V = 0; _4V <= 27; _4V += 1) { /*5788*/
				$1.i = _4V; /*5786*/
				$1.checksum = $1.checksum + ($get($1.widths, $1.i) * $get($1.checkweights, $1.i)); /*5787*/
			} /*5787*/
			$1.checksum = $1.checksum % 89; /*5789*/
			$1.seq = $get($1.checkseq, $1.checksum); /*5790*/
			$k[$j++] = "swidths"; /*5791*/
			$k[$j++] = ~~($1.seq / 21); /*5791*/
			$k[$j++] = 8; /*5791*/
			$k[$j++] = 3; /*5791*/
			$k[$j++] = 6; /*5791*/
			$k[$j++] = false; /*5791*/
			if ($1.getRSSwidths() == $b) return $b; /*5791*/
			var _4i = $k[--$j]; /*5791*/
			$1[$k[--$j]] = _4i; /*5791*/
			$k[$j++] = "bwidths"; /*5792*/
			$k[$j++] = $1.seq % 21; /*5792*/
			$k[$j++] = 8; /*5792*/
			$k[$j++] = 3; /*5792*/
			$k[$j++] = 6; /*5792*/
			$k[$j++] = false; /*5792*/
			if ($1.getRSSwidths() == $b) return $b; /*5792*/
			var _4l = $k[--$j]; /*5792*/
			$1[$k[--$j]] = _4l; /*5792*/
			$1.checkwidths = $a([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1]); /*5794*/
			for (var _4o = 0; _4o <= 5; _4o += 1) { /*5799*/
				$1.i = _4o; /*5796*/
				$put($1.checkwidths, $1.i * 2, $get($1.swidths, $1.i)); /*5797*/
				$put($1.checkwidths, ($1.i * 2) + 1, $get($1.bwidths, $1.i)); /*5798*/
			} /*5798*/
			$k[$j++] = Infinity; /*5803*/
			var _4z = $1.d1w; /*5802*/
			$k[$j++] = 1; /*5802*/
			for (var _50 = 0, _51 = _4z.length; _50 < _51; _50++) { /*5802*/
				$k[$j++] = $get(_4z, _50); /*5802*/
			} /*5802*/
			var _53 = $1.checkwidths; /*5802*/
			for (var _54 = 0, _55 = _53.length; _54 < _55; _54++) { /*5802*/
				$k[$j++] = $get(_53, _54); /*5802*/
			} /*5802*/
			var _57 = $1.d2w; /*5802*/
			for (var _58 = 0, _59 = _57.length; _58 < _59; _58++) { /*5802*/
				$k[$j++] = $get(_57, _58); /*5802*/
			} /*5802*/
			$k[$j++] = 1; /*5802*/
			$k[$j++] = 1; /*5802*/
			$1.sbs = $a(); /*5803*/
			$k[$j++] = Infinity; /*5813*/
			$k[$j++] = "ren"; /*5810*/
			$k[$j++] = $0.renlinear; /*5810*/
			$k[$j++] = "sbs"; /*5810*/
			$k[$j++] = $1.sbs; /*5810*/
			$k[$j++] = "bhs"; /*5810*/
			$k[$j++] = Infinity; /*5810*/
			for (var _5E = 0, _5F = ~~(($1.sbs.length + 1) / 2); _5E < _5F; _5E++) { /*5809*/
				$k[$j++] = $1.height; /*5809*/
			} /*5809*/
			var _5H = $a(); /*5810*/
			$k[$j++] = _5H; /*5811*/
			$k[$j++] = "bbs"; /*5811*/
			$k[$j++] = Infinity; /*5811*/
			for (var _5J = 0, _5K = ~~(($1.sbs.length + 1) / 2); _5J < _5K; _5J++) { /*5810*/
				$k[$j++] = 0; /*5810*/
			} /*5810*/
			var _5L = $a(); /*5811*/
			$k[$j++] = _5L; /*5813*/
			$k[$j++] = "txt"; /*5813*/
			$k[$j++] = $1.txt; /*5813*/
			$k[$j++] = "textxalign"; /*5813*/
			$k[$j++] = "center"; /*5813*/
			$k[$j++] = "opt"; /*5813*/
			$k[$j++] = $1.options; /*5813*/
			var _5O = $d(); /*5813*/
			$k[$j++] = _5O; /*5816*/
			if (!$1.dontdraw) { /*5816*/
				$0.renlinear(); /*5816*/
			} /*5816*/
		};
		$0.databarexpanded = function() {
			var $1 = {}; /*5844*/
			$1.options = $k[--$j]; /*5846*/
			$1.barcode = $k[--$j]; /*5847*/
			$1.dontdraw = false; /*5849*/
			$1.height = 34 / 72; /*5850*/
			$1.format = "expanded"; /*5851*/
			$1.segments = -1; /*5852*/
			$1.linkage = false; /*5853*/
			$1.barxmult = 34; /*5854*/
			$forall($1.options, function() { /*5865*/
				var _3 = $k[--$j]; /*5865*/
				$1[$k[--$j]] = _3; /*5865*/
			}); /*5865*/
			$1.height = +$1.height; /*5867*/
			$1.segments = ~~$1.segments; /*5868*/
			$1.barxmult = ~~$1.barxmult; /*5869*/
			if ($1.segments == -1) { /*5873*/
				var _A = $eq($1.format, "expandedstacked") ? 4 : 22; /*5872*/
				$1.segments = _A; /*5872*/
			} /*5872*/
			$1.expand = function() {
				$1.in = $k[--$j]; /*5877*/
				$1.out = $s($1.in.length); /*5878*/
				$1.j = 0; /*5879*/
				$k[$j++] = $1.in; /*5893*/
				for (;;) { /*5893*/
					$search($k[--$j], "^"); /*5882*/
					if ($k[--$j]) { /*5891*/
						var _H = $k[--$j]; /*5883*/
						$puti($1.out, $1.j, _H); /*5883*/
						$1.j = (_H.length + $1.j) + 1; /*5884*/
						$j--; /*5885*/
						var _L = $k[--$j]; /*5886*/
						$put($1.out, $1.j - 1, ~~$z($geti(_L, 0, 3))); /*5886*/
						$k[$j++] = $geti(_L, 3, _L.length - 3); /*5887*/
					} else { /*5891*/
						var _Q = $k[--$j]; /*5889*/
						$puti($1.out, $1.j, _Q); /*5889*/
						$1.j = _Q.length + $1.j; /*5890*/
						$k[$j++] = $geti($1.out, 0, $1.j); /*5891*/
						break; /*5891*/
					} /*5891*/
				} /*5891*/
			}; /*5894*/
			$1.ais = $a([]); /*5897*/
			$1.vals = $a([]); /*5898*/
			var _Z = $1.barcode; /*5899*/
			$k[$j++] = $geti(_Z, 1, _Z.length - 1); /*5912*/
			for (;;) { /*5912*/
				var _b = $k[--$j]; /*5901*/
				$k[$j++] = _b; /*5901*/
				if ($eq(_b, "")) { /*5901*/
					break; /*5901*/
				} /*5901*/
				$search($k[--$j], ")"); /*5902*/
				$j--; /*5902*/
				var _d = $k[--$j]; /*5903*/
				var _e = $k[--$j]; /*5903*/
				var _f = $k[--$j]; /*5904*/
				$k[$j++] = _d; /*5904*/
				$search(_f, "("); /*5904*/
				if ($k[--$j]) { /*5907*/
					var _h = $k[--$j]; /*5905*/
					var _i = $k[--$j]; /*5905*/
					var _j = $k[--$j]; /*5905*/
					var _k = $k[--$j]; /*5905*/
					$k[$j++] = _j; /*5905*/
					$k[$j++] = _k; /*5905*/
					$k[$j++] = _h; /*5905*/
				} else { /*5907*/
					var _l = $k[--$j]; /*5907*/
					var _m = $k[--$j]; /*5907*/
					$k[$j++] = ""; /*5907*/
					$k[$j++] = _m; /*5907*/
					$k[$j++] = _l; /*5907*/
				} /*5907*/
				$k[$j++] = Infinity; /*5909*/
				$aload($1.ais); /*5909*/
				var _p = $k[$j - 1 - ($counttomark() + 2)]; /*5909*/
				$k[$j++] = _p; /*5909*/
				$1.ais = $a(); /*5909*/
				$k[$j++] = Infinity; /*5910*/
				$aload($1.vals); /*5910*/
				var _t = $k[$j - 1 - ($counttomark() + 1)]; /*5910*/
				$k[$j++] = _t; /*5910*/
				if ($1.expand() == $b) break; /*5910*/
				$1.vals = $a(); /*5910*/
				$j -= 2; /*5911*/
			} /*5911*/
			$j--; /*5913*/
			for (;;) { /*6000*/
				if ($1.ais.length == 2) { /*5925*/
					if ($eq($get($1.ais, 0), "01") && $eq($get($1.ais, 1), "3103")) { /*5924*/
						if ($eq($geti($get($1.vals, 0), 0, 1), "9") && ((~~$z($get($1.vals, 1))) <= 32767)) { /*5923*/
							$k[$j++] = "0100"; /*5922*/
							$k[$j++] = false; /*5922*/
							break; /*5922*/
						} /*5922*/
					} /*5922*/
				} /*5922*/
				if ($1.ais.length == 2) { /*5934*/
					if ($eq($get($1.ais, 0), "01") && $eq($get($1.ais, 1), "3202")) { /*5933*/
						if ($eq($geti($get($1.vals, 0), 0, 1), "9") && ((~~$z($get($1.vals, 1))) <= 9999)) { /*5932*/
							$k[$j++] = "0101"; /*5931*/
							$k[$j++] = false; /*5931*/
							break; /*5931*/
						} /*5931*/
					} /*5931*/
				} /*5931*/
				if ($1.ais.length == 2) { /*5943*/
					if ($eq($get($1.ais, 0), "01") && $eq($get($1.ais, 1), "3203")) { /*5942*/
						if ($eq($geti($get($1.vals, 0), 0, 1), "9") && ((~~$z($get($1.vals, 1))) <= 22767)) { /*5941*/
							$k[$j++] = "0101"; /*5940*/
							$k[$j++] = false; /*5940*/
							break; /*5940*/
						} /*5940*/
					} /*5940*/
				} /*5940*/
				var _1Q = $1.ais.length; /*5946*/
				if ((_1Q == 2) || (_1Q == 3)) { /*5976*/
					$k[$j++] = "ai310x"; /*5947*/
					$k[$j++] = false; /*5947*/
					for (var _1R = 3100; _1R <= 3109; _1R += 1) { /*5947*/
						var _1W = $k[--$j]; /*5947*/
						$k[$j++] = _1W || $eq($cvrs($s(4), _1R, 10), $get($1.ais, 1)); /*5947*/
					} /*5947*/
					var _1X = $k[--$j]; /*5947*/
					$1[$k[--$j]] = _1X; /*5947*/
					$k[$j++] = "ai320x"; /*5948*/
					$k[$j++] = false; /*5948*/
					for (var _1Z = 3200; _1Z <= 3209; _1Z += 1) { /*5948*/
						var _1e = $k[--$j]; /*5948*/
						$k[$j++] = _1e || $eq($cvrs($s(4), _1Z, 10), $get($1.ais, 1)); /*5948*/
					} /*5948*/
					var _1f = $k[--$j]; /*5948*/
					$1[$k[--$j]] = _1f; /*5948*/
					if ($1.ais.length == 3) { /*5952*/
						var _1i = $a(["11", "13", "15", "17"]); /*5950*/
						$k[$j++] = "aibad"; /*5950*/
						$k[$j++] = true; /*5950*/
						for (var _1j = 0, _1k = _1i.length; _1j < _1k; _1j++) { /*5950*/
							var _1o = $k[--$j]; /*5950*/
							$k[$j++] = _1o && $ne($get(_1i, _1j), $get($1.ais, 2)); /*5950*/
						} /*5950*/
						var _1p = $k[--$j]; /*5950*/
						$1[$k[--$j]] = _1p; /*5950*/
					} else { /*5952*/
						$1.aibad = false; /*5952*/
					} /*5952*/
					if (($eq($get($1.ais, 0), "01") && ($1.ai310x || $1.ai320x)) && (!$1.aibad)) { /*5975*/
						if ($1.ais.length == 3) { /*5972*/
							$k[$j++] = $eq($geti($get($1.vals, 0), 0, 1), "9") && ((~~$z($get($1.vals, 1))) <= 99999); /*5967*/
							if ($1.vals && ((~~2) <= 999999)) { /*5967*/
								if ($1.ai310x && $eq($get($1.ais, 2), "11")) { /*5959*/
									$k[$j++] = "0111000"; /*5959*/
									$k[$j++] = false; /*5959*/
									break; /*5959*/
								} /*5959*/
								if ($1.ai320x && $eq($get($1.ais, 2), "11")) { /*5960*/
									$k[$j++] = "0111001"; /*5960*/
									$k[$j++] = false; /*5960*/
									break; /*5960*/
								} /*5960*/
								if ($1.ai310x && $eq($get($1.ais, 2), "13")) { /*5961*/
									$k[$j++] = "0111010"; /*5961*/
									$k[$j++] = false; /*5961*/
									break; /*5961*/
								} /*5961*/
								if ($1.ai320x && $eq($get($1.ais, 2), "13")) { /*5962*/
									$k[$j++] = "0111011"; /*5962*/
									$k[$j++] = false; /*5962*/
									break; /*5962*/
								} /*5962*/
								if ($1.ai310x && $eq($get($1.ais, 2), "15")) { /*5963*/
									$k[$j++] = "0111100"; /*5963*/
									$k[$j++] = false; /*5963*/
									break; /*5963*/
								} /*5963*/
								if ($1.ai320x && $eq($get($1.ais, 2), "15")) { /*5964*/
									$k[$j++] = "0111101"; /*5964*/
									$k[$j++] = false; /*5964*/
									break; /*5964*/
								} /*5964*/
								if ($1.ai310x && $eq($get($1.ais, 2), "17")) { /*5965*/
									$k[$j++] = "0111110"; /*5965*/
									$k[$j++] = false; /*5965*/
									break; /*5965*/
								} /*5965*/
								if ($1.ai320x && $eq($get($1.ais, 2), "17")) { /*5966*/
									$k[$j++] = "0111111"; /*5966*/
									$k[$j++] = false; /*5966*/
									break; /*5966*/
								} /*5966*/
							} /*5966*/
						} else { /*5972*/
							if ($eq($geti($get($1.vals, 0), 0, 1), "9") && ((~~$z($get($1.vals, 1))) <= 99999)) { /*5973*/
								if ($1.ai310x) { /*5971*/
									$k[$j++] = "0111000"; /*5971*/
									$k[$j++] = false; /*5971*/
									break; /*5971*/
								} /*5971*/
								if ($1.ai320x) { /*5972*/
									$k[$j++] = "0111001"; /*5972*/
									$k[$j++] = false; /*5972*/
									break; /*5972*/
								} /*5972*/
							} /*5972*/
						} /*5972*/
					} /*5972*/
				} /*5972*/
				if ($1.ais.length >= 2) { /*5984*/
					$k[$j++] = "ai392x"; /*5980*/
					$k[$j++] = false; /*5980*/
					for (var _2Z = 3920; _2Z <= 3923; _2Z += 1) { /*5980*/
						var _2e = $k[--$j]; /*5980*/
						$k[$j++] = _2e || $eq($cvrs($s(4), _2Z, 10), $get($1.ais, 1)); /*5980*/
					} /*5980*/
					var _2f = $k[--$j]; /*5980*/
					$1[$k[--$j]] = _2f; /*5980*/
					if ($eq($get($1.ais, 0), "01") && $1.ai392x) { /*5983*/
						if ($eq($geti($get($1.vals, 0), 0, 1), "9")) { /*5982*/
							$k[$j++] = "01100"; /*5982*/
							$k[$j++] = true; /*5982*/
							break; /*5982*/
						} /*5982*/
					} /*5982*/
				} /*5982*/
				if ($1.ais.length >= 2) { /*5992*/
					$k[$j++] = "ai393x"; /*5988*/
					$k[$j++] = false; /*5988*/
					for (var _2o = 3930; _2o <= 3933; _2o += 1) { /*5988*/
						var _2t = $k[--$j]; /*5988*/
						$k[$j++] = _2t || $eq($cvrs($s(4), _2o, 10), $get($1.ais, 1)); /*5988*/
					} /*5988*/
					var _2u = $k[--$j]; /*5988*/
					$1[$k[--$j]] = _2u; /*5988*/
					if ($eq($get($1.ais, 0), "01") && $1.ai393x) { /*5991*/
						if ($eq($geti($get($1.vals, 0), 0, 1), "9")) { /*5990*/
							$k[$j++] = "01101"; /*5990*/
							$k[$j++] = true; /*5990*/
							break; /*5990*/
						} /*5990*/
					} /*5990*/
				} /*5990*/
				if ($eq($get($1.ais, 0), "01")) { /*5995*/
					$k[$j++] = "1"; /*5995*/
					$k[$j++] = true; /*5995*/
					break; /*5995*/
				} /*5995*/
				$k[$j++] = "00"; /*5998*/
				$k[$j++] = true; /*5998*/
				break; /*5998*/
			} /*5998*/
			$1.gpfallow = $k[--$j]; /*6001*/
			$1.method = $k[--$j]; /*6002*/
			$1.conv12to40 = function() {
				var _37 = $strcpy($s(40), "0000000000000000000000000000000000000000"); /*6005*/
				var _38 = $k[--$j]; /*6006*/
				var _3C = $cvrs($s(10), ~~$z($geti(_38, 0, 3)), 2); /*6006*/
				$puti($geti(_37, 0, 10), 10 - _3C.length, _3C); /*6006*/
				var _3G = $cvrs($s(10), ~~$z($geti(_38, 3, 3)), 2); /*6007*/
				$puti($geti(_37, 10, 10), 10 - _3G.length, _3G); /*6007*/
				var _3K = $cvrs($s(10), ~~$z($geti(_38, 6, 3)), 2); /*6008*/
				$puti($geti(_37, 20, 10), 10 - _3K.length, _3K); /*6008*/
				var _3O = $cvrs($s(10), ~~$z($geti(_38, 9, 3)), 2); /*6009*/
				$puti($geti(_37, 30, 10), 10 - _3O.length, _3O); /*6009*/
				$k[$j++] = _37; /*6010*/
			}; /*6011*/
			$1.conv13to44 = function() {
				var _3Q = $strcpy($s(44), "00000000000000000000000000000000000000000000"); /*6014*/
				var _3R = $k[--$j]; /*6015*/
				var _3V = $cvrs($s(4), ~~$z($geti(_3R, 0, 1)), 2); /*6015*/
				$puti($geti(_3Q, 0, 4), 4 - _3V.length, _3V); /*6015*/
				$k[$j++] = _3Q; /*6016*/
				$k[$j++] = _3Q; /*6016*/
				$k[$j++] = $geti(_3R, 1, 12); /*6016*/
				if ($1.conv12to40() == $b) return $b; /*6016*/
				var _3X = $k[--$j]; /*6016*/
				$puti($k[--$j], 4, _3X); /*6016*/
			}; /*6017*/
			$1.tobin = function() {
				var _3a = $s($k[--$j]); /*6020*/
				$k[$j++] = _3a; /*6020*/
				for (var _3c = 0, _3b = _3a.length - 1; _3c <= _3b; _3c += 1) { /*6020*/
					var _3d = $k[--$j]; /*6020*/
					$put(_3d, _3c, 48); /*6020*/
					$k[$j++] = _3d; /*6020*/
				} /*6020*/
				var _3e = $k[--$j]; /*6021*/
				var _3h = $cvrs($s(_3e.length), $k[--$j], 2); /*6021*/
				$puti(_3e, _3e.length - _3h.length, _3h); /*6021*/
				$k[$j++] = _3e; /*6021*/
			}; /*6022*/
			if ($eq($1.method, "00")) { /*6027*/
				$1.cdf = $a([]); /*6025*/
				$1.gpf = $a([]); /*6026*/
			} /*6026*/
			if ($eq($1.method, "1")) { /*6035*/
				$k[$j++] = "cdf"; /*6030*/
				$k[$j++] = $geti($get($1.vals, 0), 0, 13); /*6030*/
				if ($1.conv13to44() == $b) return $b; /*6030*/
				var _3p = $k[--$j]; /*6030*/
				$1[$k[--$j]] = _3p; /*6030*/
				$k[$j++] = Infinity; /*6031*/
				var _3r = $1.cdf; /*6031*/
				for (var _3s = 0, _3t = _3r.length; _3s < _3t; _3s++) { /*6031*/
					$k[$j++] = $get(_3r, _3s) - 48; /*6031*/
				} /*6031*/
				$1.cdf = $a(); /*6031*/
				$1.gpf = $a([]); /*6032*/
				$1.ais = $geti($1.ais, 1, $1.ais.length - 1); /*6033*/
				$1.vals = $geti($1.vals, 1, $1.vals.length - 1); /*6034*/
			} /*6034*/
			if ($eq($1.method, "0100")) { /*6045*/
				$1.cdf = $s(55); /*6038*/
				$k[$j++] = $1.cdf; /*6039*/
				$k[$j++] = 0; /*6039*/
				$k[$j++] = $geti($get($1.vals, 0), 1, 12); /*6039*/
				if ($1.conv12to40() == $b) return $b; /*6039*/
				var _49 = $k[--$j]; /*6039*/
				var _4A = $k[--$j]; /*6039*/
				$puti($k[--$j], _4A, _49); /*6039*/
				$k[$j++] = $1.cdf; /*6040*/
				$k[$j++] = 40; /*6040*/
				$k[$j++] = ~~$z($get($1.vals, 1)); /*6040*/
				$k[$j++] = 15; /*6040*/
				if ($1.tobin() == $b) return $b; /*6040*/
				var _4F = $k[--$j]; /*6040*/
				var _4G = $k[--$j]; /*6040*/
				$puti($k[--$j], _4G, _4F); /*6040*/
				$k[$j++] = Infinity; /*6041*/
				var _4I = $1.cdf; /*6041*/
				for (var _4J = 0, _4K = _4I.length; _4J < _4K; _4J++) { /*6041*/
					$k[$j++] = $get(_4I, _4J) - 48; /*6041*/
				} /*6041*/
				$1.cdf = $a(); /*6041*/
				$1.gpf = $a([]); /*6042*/
				$1.ais = $a([]); /*6043*/
				$1.vals = $a([]); /*6044*/
			} /*6044*/
			if ($eq($1.method, "0101")) { /*6060*/
				$1.cdf = $s(55); /*6048*/
				$k[$j++] = $1.cdf; /*6049*/
				$k[$j++] = 0; /*6049*/
				$k[$j++] = $geti($get($1.vals, 0), 1, 12); /*6049*/
				if ($1.conv12to40() == $b) return $b; /*6049*/
				var _4W = $k[--$j]; /*6049*/
				var _4X = $k[--$j]; /*6049*/
				$puti($k[--$j], _4X, _4W); /*6049*/
				if ($eq($get($1.ais, 1), "3202")) { /*6053*/
					$k[$j++] = ~~$z($get($1.vals, 1)); /*6051*/
					$k[$j++] = 15; /*6051*/
					if ($1.tobin() == $b) return $b; /*6051*/
				} else { /*6053*/
					$k[$j++] = (~~$z($get($1.vals, 1))) + 10000; /*6053*/
					$k[$j++] = 15; /*6053*/
					if ($1.tobin() == $b) return $b; /*6053*/
				} /*6053*/
				$puti($1.cdf, 40, $k[--$j]); /*6055*/
				$k[$j++] = Infinity; /*6056*/
				var _4h = $1.cdf; /*6056*/
				for (var _4i = 0, _4j = _4h.length; _4i < _4j; _4i++) { /*6056*/
					$k[$j++] = $get(_4h, _4i) - 48; /*6056*/
				} /*6056*/
				$1.cdf = $a(); /*6056*/
				$1.gpf = $a([]); /*6057*/
				$1.ais = $a([]); /*6058*/
				$1.vals = $a([]); /*6059*/
			} /*6059*/
			if ($1.method.length == 7) { /*6081*/
				$1.cdf = $s(76); /*6063*/
				$k[$j++] = $1.cdf; /*6064*/
				$k[$j++] = 0; /*6064*/
				$k[$j++] = $geti($get($1.vals, 0), 1, 12); /*6064*/
				if ($1.conv12to40() == $b) return $b; /*6064*/
				var _4v = $k[--$j]; /*6064*/
				var _4w = $k[--$j]; /*6064*/
				$puti($k[--$j], _4w, _4v); /*6064*/
				var _4y = $s(6); /*6065*/
				$puti(_4y, 0, $geti($get($1.ais, 1), 3, 1)); /*6065*/
				$puti(_4y, 1, $geti($get($1.vals, 1), 1, 5)); /*6066*/
				$k[$j++] = ~~$z(_4y); /*6066*/
				$k[$j++] = 20; /*6066*/
				if ($1.tobin() == $b) return $b; /*6066*/
				$puti($1.cdf, 40, $k[--$j]); /*6067*/
				if ($1.ais.length == 3) { /*6074*/
					var _59 = $get($1.vals, 2); /*6069*/
					$k[$j++] = ((~~$z($geti(_59, 0, 2))) * 384) + ((((~~$z($geti(_59, 2, 2))) - 1) * 32) + (~~$z($geti(_59, 4, 2)))); /*6072*/
				} else { /*6074*/
					$k[$j++] = 38400; /*6074*/
				} /*6074*/
				$k[$j++] = 16; /*6076*/
				if ($1.tobin() == $b) return $b; /*6076*/
				$puti($1.cdf, 60, $k[--$j]); /*6076*/
				$k[$j++] = Infinity; /*6077*/
				var _5F = $1.cdf; /*6077*/
				for (var _5G = 0, _5H = _5F.length; _5G < _5H; _5G++) { /*6077*/
					$k[$j++] = $get(_5F, _5G) - 48; /*6077*/
				} /*6077*/
				$1.cdf = $a(); /*6077*/
				$1.gpf = $a([]); /*6078*/
				$1.ais = $a([]); /*6079*/
				$1.vals = $a([]); /*6080*/
			} /*6080*/
			if ($eq($1.method, "01100")) { /*6091*/
				$1.cdf = $s(42); /*6084*/
				$k[$j++] = $1.cdf; /*6085*/
				$k[$j++] = 0; /*6085*/
				$k[$j++] = $geti($get($1.vals, 0), 1, 12); /*6085*/
				if ($1.conv12to40() == $b) return $b; /*6085*/
				var _5T = $k[--$j]; /*6085*/
				var _5U = $k[--$j]; /*6085*/
				$puti($k[--$j], _5U, _5T); /*6085*/
				$k[$j++] = $1.cdf; /*6086*/
				$k[$j++] = 40; /*6086*/
				$k[$j++] = ~~$z($geti($get($1.ais, 1), 3, 1)); /*6086*/
				$k[$j++] = 2; /*6086*/
				if ($1.tobin() == $b) return $b; /*6086*/
				var _5a = $k[--$j]; /*6086*/
				var _5b = $k[--$j]; /*6086*/
				$puti($k[--$j], _5b, _5a); /*6086*/
				$k[$j++] = Infinity; /*6087*/
				var _5d = $1.cdf; /*6087*/
				for (var _5e = 0, _5f = _5d.length; _5e < _5f; _5e++) { /*6087*/
					$k[$j++] = $get(_5d, _5e) - 48; /*6087*/
				} /*6087*/
				$1.cdf = $a(); /*6087*/
				$k[$j++] = Infinity; /*6088*/
				$forall($get($1.vals, 1)); /*6088*/
				$1.gpf = $a(); /*6088*/
				$1.ais = $geti($1.ais, 2, $1.ais.length - 2); /*6089*/
				$1.vals = $geti($1.vals, 2, $1.vals.length - 2); /*6090*/
			} /*6090*/
			if ($eq($1.method, "01101")) { /*6102*/
				$1.cdf = $s(52); /*6094*/
				$k[$j++] = $1.cdf; /*6095*/
				$k[$j++] = 0; /*6095*/
				$k[$j++] = $geti($get($1.vals, 0), 1, 12); /*6095*/
				if ($1.conv12to40() == $b) return $b; /*6095*/
				var _5x = $k[--$j]; /*6095*/
				var _5y = $k[--$j]; /*6095*/
				$puti($k[--$j], _5y, _5x); /*6095*/
				$k[$j++] = $1.cdf; /*6096*/
				$k[$j++] = 40; /*6096*/
				$k[$j++] = ~~$z($geti($get($1.ais, 1), 3, 1)); /*6096*/
				$k[$j++] = 2; /*6096*/
				if ($1.tobin() == $b) return $b; /*6096*/
				var _64 = $k[--$j]; /*6096*/
				var _65 = $k[--$j]; /*6096*/
				$puti($k[--$j], _65, _64); /*6096*/
				$k[$j++] = $1.cdf; /*6097*/
				$k[$j++] = 42; /*6097*/
				$k[$j++] = ~~$z($geti($get($1.vals, 1), 0, 3)); /*6097*/
				$k[$j++] = 10; /*6097*/
				if ($1.tobin() == $b) return $b; /*6097*/
				var _6B = $k[--$j]; /*6097*/
				var _6C = $k[--$j]; /*6097*/
				$puti($k[--$j], _6C, _6B); /*6097*/
				$k[$j++] = Infinity; /*6098*/
				var _6E = $1.cdf; /*6098*/
				for (var _6F = 0, _6G = _6E.length; _6F < _6G; _6F++) { /*6098*/
					$k[$j++] = $get(_6E, _6F) - 48; /*6098*/
				} /*6098*/
				$1.cdf = $a(); /*6098*/
				$k[$j++] = Infinity; /*6099*/
				var _6K = $get($1.vals, 1); /*6099*/
				$forall($geti(_6K, 3, _6K.length - 3)); /*6099*/
				$1.gpf = $a(); /*6099*/
				$1.ais = $geti($1.ais, 2, $1.ais.length - 2); /*6100*/
				$1.vals = $geti($1.vals, 2, $1.vals.length - 2); /*6101*/
			} /*6101*/
			if ($1.gpfallow) { /*6108*/
				$1.vlf = $a(2); /*6106*/
			} else { /*6108*/
				$1.vlf = $a([]); /*6108*/
			} /*6108*/
			$1.aifixed = {}; /*6114*/
			$k[$j++] = Infinity; /*6116*/
			for (var _6W = 0; _6W <= 4; _6W += 1) { /*6116*/
				$k[$j++] = _6W; /*6116*/
			} /*6116*/
			var _6X = $a(); /*6116*/
			for (var _6Y = 0, _6Z = _6X.length; _6Y < _6Z; _6Y++) { /*6119*/
				var _6c = $strcpy($s(2), "00"); /*6118*/
				$put(_6c, 1, $get(_6X, _6Y) + 48); /*6118*/
				$put($1.aifixed, _6c, _6c); /*6118*/
			} /*6118*/
			$k[$j++] = Infinity; /*6124*/
			for (var _6e = 11; _6e <= 20; _6e += 1) { /*6121*/
				$k[$j++] = _6e; /*6121*/
			} /*6121*/
			$k[$j++] = 23; /*6123*/
			for (var _6f = 31; _6f <= 36; _6f += 1) { /*6123*/
				$k[$j++] = _6f; /*6123*/
			} /*6123*/
			$k[$j++] = 41; /*6124*/
			var _6g = $a(); /*6124*/
			for (var _6h = 0, _6i = _6g.length; _6h < _6i; _6h++) { /*6127*/
				var _6l = $cvrs($s(2), $get(_6g, _6h), 10); /*6126*/
				$put($1.aifixed, _6l, _6l); /*6126*/
			} /*6126*/
			$1.fnc1 = -1; /*6129*/
			$1.lnumeric = -2; /*6129*/
			$1.lalphanumeric = -3; /*6129*/
			$1.liso646 = -4; /*6129*/
			$k[$j++] = "numeric"; /*6141*/
			$k[$j++] = Infinity; /*6141*/
			for (var _6n = 0; _6n <= 119; _6n += 1) { /*6140*/
				var _6p = $strcpy($s(2), "00"); /*6133*/
				var _6r = $cvrs($s(2), _6n, 11); /*6133*/
				$puti(_6p, 2 - _6r.length, _6r); /*6134*/
				$k[$j++] = _6n; /*6135*/
				$k[$j++] = _6p; /*6135*/
				if ($get(_6p, 0) == 65) { /*6135*/
					var _6t = $k[--$j]; /*6135*/
					$put(_6t, 0, 94); /*6135*/
					$k[$j++] = _6t; /*6135*/
				} /*6135*/
				var _6u = $k[--$j]; /*6136*/
				$k[$j++] = _6u; /*6136*/
				if ($get(_6u, 1) == 65) { /*6136*/
					var _6w = $k[--$j]; /*6136*/
					$put(_6w, 1, 94); /*6136*/
					$k[$j++] = _6w; /*6136*/
				} /*6136*/
				var _6x = $k[--$j]; /*6137*/
				var _70 = $strcpy($s(7), "0000000"); /*6138*/
				var _72 = $cvrs($s(7), $k[--$j] + 8, 2); /*6138*/
				$puti(_70, 7 - _72.length, _72); /*6139*/
				$k[$j++] = _6x; /*6139*/
				$k[$j++] = _70; /*6139*/
			} /*6139*/
			$k[$j++] = $1.lalphanumeric; /*6141*/
			$k[$j++] = "0000"; /*6141*/
			var _74 = $d(); /*6141*/
			$1[$k[--$j]] = _74; /*6142*/
			$k[$j++] = "alphanumeric"; /*6151*/
			$k[$j++] = Infinity; /*6151*/
			for (var _76 = 48; _76 <= 57; _76 += 1) { /*6145*/
				$k[$j++] = _76; /*6145*/
				$k[$j++] = _76 - 43; /*6145*/
				$k[$j++] = 5; /*6145*/
				if ($1.tobin() == $b) break; /*6145*/
			} /*6145*/
			$k[$j++] = $1.fnc1; /*6147*/
			$k[$j++] = "01111"; /*6147*/
			for (var _78 = 65; _78 <= 90; _78 += 1) { /*6147*/
				$k[$j++] = _78; /*6147*/
				$k[$j++] = _78 - 33; /*6147*/
				$k[$j++] = 6; /*6147*/
				if ($1.tobin() == $b) break; /*6147*/
			} /*6147*/
			$k[$j++] = 42; /*6149*/
			$k[$j++] = "111010"; /*6149*/
			for (var _79 = 44; _79 <= 47; _79 += 1) { /*6149*/
				$k[$j++] = _79; /*6149*/
				$k[$j++] = _79 + 15; /*6149*/
				$k[$j++] = 6; /*6149*/
				if ($1.tobin() == $b) break; /*6149*/
			} /*6149*/
			$k[$j++] = $1.lnumeric; /*6151*/
			$k[$j++] = "000"; /*6151*/
			$k[$j++] = $1.liso646; /*6151*/
			$k[$j++] = "00100"; /*6151*/
			var _7C = $d(); /*6151*/
			$1[$k[--$j]] = _7C; /*6152*/
			$k[$j++] = "iso646"; /*6166*/
			$k[$j++] = Infinity; /*6166*/
			for (var _7E = 48; _7E <= 57; _7E += 1) { /*6155*/
				$k[$j++] = _7E; /*6155*/
				$k[$j++] = _7E - 43; /*6155*/
				$k[$j++] = 5; /*6155*/
				if ($1.tobin() == $b) break; /*6155*/
			} /*6155*/
			$k[$j++] = $1.fnc1; /*6157*/
			$k[$j++] = "01111"; /*6157*/
			for (var _7G = 65; _7G <= 90; _7G += 1) { /*6157*/
				$k[$j++] = _7G; /*6157*/
				$k[$j++] = _7G - 1; /*6157*/
				$k[$j++] = 7; /*6157*/
				if ($1.tobin() == $b) break; /*6157*/
			} /*6157*/
			for (var _7H = 97; _7H <= 122; _7H += 1) { /*6158*/
				$k[$j++] = _7H; /*6158*/
				$k[$j++] = _7H - 7; /*6158*/
				$k[$j++] = 7; /*6158*/
				if ($1.tobin() == $b) break; /*6158*/
			} /*6158*/
			$k[$j++] = 33; /*6161*/
			$k[$j++] = "11101000"; /*6161*/
			$k[$j++] = 34; /*6161*/
			$k[$j++] = "11101001"; /*6161*/
			for (var _7I = 37; _7I <= 47; _7I += 1) { /*6161*/
				$k[$j++] = _7I; /*6161*/
				$k[$j++] = _7I + 197; /*6161*/
				$k[$j++] = 8; /*6161*/
				if ($1.tobin() == $b) break; /*6161*/
			} /*6161*/
			for (var _7J = 58; _7J <= 63; _7J += 1) { /*6162*/
				$k[$j++] = _7J; /*6162*/
				$k[$j++] = _7J + 187; /*6162*/
				$k[$j++] = 8; /*6162*/
				if ($1.tobin() == $b) break; /*6162*/
			} /*6162*/
			$k[$j++] = 95; /*6166*/
			$k[$j++] = "11111011"; /*6166*/
			$k[$j++] = 32; /*6166*/
			$k[$j++] = "11111100"; /*6166*/
			$k[$j++] = $1.lnumeric; /*6166*/
			$k[$j++] = "000"; /*6166*/
			$k[$j++] = $1.lalphanumeric; /*6166*/
			$k[$j++] = "00100"; /*6166*/
			var _7M = $d(); /*6166*/
			$1[$k[--$j]] = _7M; /*6167*/
			for (var _7Q = 0, _7P = $1.ais.length - 1; _7Q <= _7P; _7Q += 1) { /*6185*/
				$1.i = _7Q; /*6171*/
				$1.ai = $get($1.ais, $1.i); /*6172*/
				$1.val = $get($1.vals, $1.i); /*6173*/
				var _7a = $a(($1.gpf.length + $1.ai.length) + $1.val.length); /*6174*/
				$puti(_7a, 0, $1.gpf); /*6175*/
				$k[$j++] = _7a; /*6176*/
				$k[$j++] = _7a; /*6176*/
				$k[$j++] = $1.gpf.length; /*6176*/
				$k[$j++] = $1.ai; /*6176*/
				$k[$j++] = Infinity; /*6176*/
				var _7e = $k[--$j]; /*6176*/
				var _7f = $k[--$j]; /*6176*/
				$k[$j++] = _7e; /*6176*/
				$forall(_7f); /*6176*/
				var _7g = $a(); /*6176*/
				var _7h = $k[--$j]; /*6176*/
				$puti($k[--$j], _7h, _7g); /*6176*/
				var _7j = $k[--$j]; /*6177*/
				$k[$j++] = _7j; /*6177*/
				$k[$j++] = _7j; /*6177*/
				$k[$j++] = $1.gpf.length + $1.ai.length; /*6177*/
				$k[$j++] = $1.val; /*6177*/
				$k[$j++] = Infinity; /*6177*/
				var _7n = $k[--$j]; /*6177*/
				var _7o = $k[--$j]; /*6177*/
				$k[$j++] = _7n; /*6177*/
				$forall(_7o); /*6177*/
				var _7p = $a(); /*6177*/
				var _7q = $k[--$j]; /*6177*/
				$puti($k[--$j], _7q, _7p); /*6177*/
				$1.gpf = $k[--$j]; /*6178*/
				var _7y = $get($1.aifixed, $geti($1.ai, 0, 2)) !== undefined; /*6179*/
				if (($1.i != ($1.ais.length - 1)) && (!_7y)) { /*6184*/
					var _80 = $a($1.gpf.length + 1); /*6180*/
					$puti(_80, 0, $1.gpf); /*6181*/
					$put(_80, $1.gpf.length, $1.fnc1); /*6182*/
					$1.gpf = _80; /*6183*/
				} /*6183*/
			} /*6183*/
			$1.rembits = function() {
				var _84 = $k[--$j]; /*6189*/
				var _85 = 48; /*6191*/
				var _86 = (~~Math.ceil(_84 / 12)) * 12; /*6191*/
				if (((~~Math.ceil(_84 / 12)) * 12) < 48) { /*6191*/
					var _ = _85; /*6191*/
					_85 = _86; /*6191*/
					_86 = _; /*6191*/
				} /*6191*/
				var _87 = ~~(_86 / 12); /*6192*/
				$k[$j++] = _84; /*6196*/
				$k[$j++] = _86; /*6196*/
				$k[$j++] = _87; /*6196*/
				if ((_87 % $1.segments) == 1) { /*6195*/
					var _89 = $k[--$j]; /*6193*/
					var _8A = $k[--$j]; /*6193*/
					$k[$j++] = (_89 + 1) * 12; /*6193*/
				} else { /*6195*/
					$j--; /*6195*/
				} /*6195*/
				var _8B = $k[--$j]; /*6197*/
				var _8C = $k[--$j]; /*6197*/
				$k[$j++] = _8B - _8C; /*6197*/
			}; /*6198*/
			$1.encode = function() {
				var _8D = $k[--$j]; /*6201*/
				$k[$j++] = _8D; /*6201*/
				if ($ne(_8D, "raw")) { /*6201*/
					var _8E = $k[--$j]; /*6201*/
					var _8G = $get(_8E, $k[--$j]); /*6201*/
					$k[$j++] = _8G; /*6201*/
				} else { /*6201*/
					$j--; /*6201*/
				} /*6201*/
				$k[$j++] = Infinity; /*6202*/
				var _8H = $k[--$j]; /*6202*/
				var _8I = $k[--$j]; /*6202*/
				$k[$j++] = _8H; /*6202*/
				$forall(_8I, function() { /*6202*/
					var _8J = $k[--$j]; /*6202*/
					$k[$j++] = _8J - 48; /*6202*/
				}); /*6202*/
				var _8K = $a(); /*6202*/
				$puti($1.gpfenc, $1.j, _8K); /*6204*/
				$1.j = _8K.length + $1.j; /*6205*/
			}; /*6206*/
			$k[$j++] = Infinity; /*6209*/
			for (var _8P = 0, _8Q = $1.gpf.length; _8P < _8Q; _8P++) { /*6209*/
				$k[$j++] = 0; /*6209*/
			} /*6209*/
			$k[$j++] = 0; /*6209*/
			$k[$j++] = -1; /*6209*/
			$1.numericruns = $a(); /*6209*/
			$k[$j++] = Infinity; /*6210*/
			for (var _8T = 0, _8U = $1.gpf.length; _8T < _8U; _8T++) { /*6210*/
				$k[$j++] = 0; /*6210*/
			} /*6210*/
			$k[$j++] = 0; /*6210*/
			$1.alphanumericruns = $a(); /*6210*/
			$k[$j++] = Infinity; /*6211*/
			for (var _8X = 0, _8Y = $1.gpf.length; _8X < _8Y; _8X++) { /*6211*/
				$k[$j++] = 0; /*6211*/
			} /*6211*/
			$k[$j++] = 9999; /*6211*/
			$1.nextiso646only = $a(); /*6211*/
			for (var _8b = $1.gpf.length - 1; _8b >= 0; _8b -= 1) { /*6233*/
				$1.i = _8b; /*6213*/
				var _8g = $strcpy($s(2), "00"); /*6215*/
				var _8j = $get($1.gpf, $1.i); /*6216*/
				$k[$j++] = $get($1.gpf, $1.i); /*6216*/
				$k[$j++] = _8g; /*6216*/
				$k[$j++] = _8g; /*6216*/
				$k[$j++] = 0; /*6216*/
				$k[$j++] = _8j; /*6216*/
				if (_8j == $1.fnc1) { /*6216*/
					$j--; /*6216*/
					$k[$j++] = 94; /*6216*/
				} /*6216*/
				var _8l = $k[--$j]; /*6216*/
				var _8m = $k[--$j]; /*6216*/
				$put($k[--$j], _8m, _8l); /*6216*/
				if ($1.i < ($1.gpf.length - 1)) { /*6217*/
					var _8q = $k[--$j]; /*6217*/
					var _8t = $get($1.gpf, $1.i + 1); /*6217*/
					$k[$j++] = _8q; /*6217*/
					$k[$j++] = _8q; /*6217*/
					$k[$j++] = 1; /*6217*/
					$k[$j++] = _8t; /*6217*/
					if (_8t == $1.fnc1) { /*6217*/
						$j--; /*6217*/
						$k[$j++] = 94; /*6217*/
					} /*6217*/
					var _8v = $k[--$j]; /*6217*/
					var _8w = $k[--$j]; /*6217*/
					$put($k[--$j], _8w, _8v); /*6217*/
				} /*6217*/
				var _90 = $get($1.numeric, $k[--$j]) !== undefined; /*6218*/
				if (_90) { /*6221*/
					$put($1.numericruns, $1.i, $get($1.numericruns, $1.i + 2) + 2); /*6219*/
				} else { /*6221*/
					$put($1.numericruns, $1.i, 0); /*6221*/
				} /*6221*/
				var _98 = $k[--$j]; /*6223*/
				var _9A = $get($1.alphanumeric, _98) !== undefined; /*6223*/
				$k[$j++] = _98; /*6227*/
				if (_9A) { /*6226*/
					$put($1.alphanumericruns, $1.i, $get($1.alphanumericruns, $1.i + 1) + 1); /*6224*/
				} else { /*6226*/
					$put($1.alphanumericruns, $1.i, 0); /*6226*/
				} /*6226*/
				var _9I = $k[--$j]; /*6228*/
				var _9K = $get($1.iso646, _9I) !== undefined; /*6228*/
				var _9M = $get($1.alphanumeric, _9I) !== undefined; /*6228*/
				if (_9K && (!_9M)) { /*6231*/
					$put($1.nextiso646only, $1.i, 0); /*6229*/
				} else { /*6231*/
					$put($1.nextiso646only, $1.i, $get($1.nextiso646only, $1.i + 1) + 1); /*6231*/
				} /*6231*/
			} /*6231*/
			$1.gpfenc = $a(252); /*6236*/
			$1.i = 0; /*6237*/
			$1.j = 0; /*6237*/
			$1.mode = "numeric"; /*6237*/
			for (;;) { /*6327*/
				if ($1.i == $1.gpf.length) { /*6239*/
					break; /*6239*/
				} /*6239*/
				for (;;) { /*6326*/
					if ($eq($1.mode, "numeric")) { /*6275*/
						if ($1.i <= ($1.gpf.length - 2)) { /*6272*/
							var _9a = $s(2); /*6244*/
							var _9d = $get($1.gpf, $1.i); /*6245*/
							$k[$j++] = _9a; /*6245*/
							$k[$j++] = _9a; /*6245*/
							$k[$j++] = 0; /*6245*/
							$k[$j++] = _9d; /*6245*/
							if (_9d == $1.fnc1) { /*6245*/
								$j--; /*6245*/
								$k[$j++] = 94; /*6245*/
							} /*6245*/
							var _9f = $k[--$j]; /*6245*/
							var _9g = $k[--$j]; /*6245*/
							$put($k[--$j], _9g, _9f); /*6245*/
							var _9i = $k[--$j]; /*6246*/
							var _9l = $get($1.gpf, $1.i + 1); /*6246*/
							$k[$j++] = _9i; /*6246*/
							$k[$j++] = _9i; /*6246*/
							$k[$j++] = 1; /*6246*/
							$k[$j++] = _9l; /*6246*/
							if (_9l == $1.fnc1) { /*6246*/
								$j--; /*6246*/
								$k[$j++] = 94; /*6246*/
							} /*6246*/
							var _9n = $k[--$j]; /*6246*/
							var _9o = $k[--$j]; /*6246*/
							$put($k[--$j], _9o, _9n); /*6246*/
							var _9q = $k[--$j]; /*6247*/
							var _9s = $get($1.numeric, _9q) !== undefined; /*6247*/
							$k[$j++] = _9q; /*6251*/
							if (_9s) { /*6251*/
								$k[$j++] = $1.numeric; /*6248*/
								if ($1.encode() == $b) break; /*6248*/
								$1.i = $1.i + 2; /*6249*/
								break; /*6250*/
							} /*6250*/
							$j--; /*6252*/
							$k[$j++] = $1.lalphanumeric; /*6253*/
							$k[$j++] = $1.numeric; /*6253*/
							if ($1.encode() == $b) break; /*6253*/
							$1.mode = "alphanumeric"; /*6254*/
							break; /*6255*/
						} else { /*6272*/
							var _9z = $get($1.gpf, $1.i); /*6257*/
							if ((_9z < 48) || (_9z > 57)) { /*6261*/
								$k[$j++] = $1.lalphanumeric; /*6258*/
								$k[$j++] = $1.numeric; /*6258*/
								if ($1.encode() == $b) break; /*6258*/
								$1.mode = "alphanumeric"; /*6259*/
								break; /*6260*/
							} /*6260*/
							$k[$j++] = "rem"; /*6262*/
							$k[$j++] = ((((12 + 1) + $1.method.length) + $1.vlf.length) + $1.cdf.length) + $1.j; /*6262*/
							if ($1.rembits() == $b) break; /*6262*/
							var _A6 = $k[--$j]; /*6262*/
							$1[$k[--$j]] = _A6; /*6262*/
							if (($1.rem >= 4) && ($1.rem <= 6)) { /*6272*/
								var _AD = $geti($strcpy($s(6), "000000"), 0, $1.rem); /*6264*/
								var _AI = $cvrs($s(4), $get($1.gpf, $1.i) - 47, 2); /*6265*/
								$puti(_AD, 4 - _AI.length, _AI); /*6266*/
								$k[$j++] = _AD; /*6266*/
								$k[$j++] = "raw"; /*6266*/
								if ($1.encode() == $b) break; /*6266*/
								$1.i = $1.i + 1; /*6267*/
								break; /*6268*/
							} else { /*6272*/
								var _AK = $s(2); /*6270*/
								$put(_AK, 0, $get($1.gpf, $1.i)); /*6270*/
								$put(_AK, 1, 94); /*6270*/
								$k[$j++] = _AK; /*6270*/
								$k[$j++] = $1.numeric; /*6270*/
								if ($1.encode() == $b) break; /*6270*/
								$1.i = $1.i + 1; /*6271*/
								break; /*6272*/
							} /*6272*/
						} /*6272*/
					} /*6272*/
					if ($eq($1.mode, "alphanumeric")) { /*6302*/
						if ($get($1.gpf, $1.i) == $1.fnc1) { /*6283*/
							$k[$j++] = $1.fnc1; /*6279*/
							$k[$j++] = $1.alphanumeric; /*6279*/
							if ($1.encode() == $b) break; /*6279*/
							$1.mode = "numeric"; /*6280*/
							$1.i = $1.i + 1; /*6281*/
							break; /*6282*/
						} /*6282*/
						var _Aa = $get($1.gpf, $1.i); /*6284*/
						var _Ac = $get($1.iso646, _Aa) !== undefined; /*6284*/
						var _Ae = $get($1.alphanumeric, _Aa) !== undefined; /*6284*/
						if (_Ac && (!_Ae)) { /*6288*/
							$k[$j++] = $1.liso646; /*6285*/
							$k[$j++] = $1.alphanumeric; /*6285*/
							if ($1.encode() == $b) break; /*6285*/
							$1.mode = "iso646"; /*6286*/
							break; /*6287*/
						} /*6287*/
						if ($get($1.numericruns, $1.i) >= 6) { /*6293*/
							$k[$j++] = $1.lnumeric; /*6290*/
							$k[$j++] = $1.alphanumeric; /*6290*/
							if ($1.encode() == $b) break; /*6290*/
							$1.mode = "numeric"; /*6291*/
							break; /*6292*/
						} /*6292*/
						var _Ao = $get($1.numericruns, $1.i); /*6294*/
						if ((_Ao >= 4) && ((_Ao + $1.i) == $1.gpf.length)) { /*6298*/
							$k[$j++] = $1.lnumeric; /*6295*/
							$k[$j++] = $1.alphanumeric; /*6295*/
							if ($1.encode() == $b) break; /*6295*/
							$1.mode = "numeric"; /*6296*/
							break; /*6297*/
						} /*6297*/
						$k[$j++] = $get($1.gpf, $1.i); /*6299*/
						$k[$j++] = $1.alphanumeric; /*6299*/
						if ($1.encode() == $b) break; /*6299*/
						$1.i = $1.i + 1; /*6300*/
						break; /*6301*/
					} /*6301*/
					if ($eq($1.mode, "iso646")) { /*6324*/
						if ($get($1.gpf, $1.i) == $1.fnc1) { /*6310*/
							$k[$j++] = $1.fnc1; /*6306*/
							$k[$j++] = $1.iso646; /*6306*/
							if ($1.encode() == $b) break; /*6306*/
							$1.mode = "numeric"; /*6307*/
							$1.i = $1.i + 1; /*6308*/
							break; /*6309*/
						} /*6309*/
						if (($get($1.numericruns, $1.i) >= 4) && ($get($1.nextiso646only, $1.i) >= 10)) { /*6315*/
							$k[$j++] = $1.lnumeric; /*6312*/
							$k[$j++] = $1.iso646; /*6312*/
							if ($1.encode() == $b) break; /*6312*/
							$1.mode = "numeric"; /*6313*/
							break; /*6314*/
						} /*6314*/
						if (($get($1.alphanumericruns, $1.i) >= 5) && ($get($1.nextiso646only, $1.i) >= 10)) { /*6320*/
							$k[$j++] = $1.lalphanumeric; /*6317*/
							$k[$j++] = $1.iso646; /*6317*/
							if ($1.encode() == $b) break; /*6317*/
							$1.mode = "alphanumeric"; /*6318*/
							break; /*6319*/
						} /*6319*/
						$k[$j++] = $get($1.gpf, $1.i); /*6321*/
						$k[$j++] = $1.iso646; /*6321*/
						if ($1.encode() == $b) break; /*6321*/
						$1.i = $1.i + 1; /*6322*/
						break; /*6323*/
					} /*6323*/
				} /*6323*/
			} /*6323*/
			$1.gpf = $geti($1.gpfenc, 0, $1.j); /*6328*/
			var _BY = ((((1 + 12) + $1.method.length) + $1.vlf.length) + $1.cdf.length) + $1.gpf.length; /*6332*/
			$k[$j++] = _BY; /*6332*/
			$k[$j++] = _BY; /*6332*/
			if ($1.rembits() == $b) return $b; /*6332*/
			var _BZ = $k[--$j]; /*6332*/
			$1.pad = $a(_BZ); /*6332*/
			$k[$j++] = _BZ; /*6339*/
			if ($1.vlf.length != 0) { /*6338*/
				var _Bc = $k[--$j]; /*6334*/
				var _Be = ~~(($k[--$j] + _Bc) / 12); /*6335*/
				$put($1.vlf, 0, _Be % 2); /*6335*/
				var _Bg = (_Be <= 14) ? 0 : 1; /*6336*/
				$put($1.vlf, 1, _Bg); /*6336*/
			} else { /*6338*/
				$j -= 2; /*6338*/
			} /*6338*/
			if ($1.pad.length > 0) { /*6348*/
				for (var _Bl = 0, _Bk = $1.pad.length - 1; _Bl <= _Bk; _Bl += 5) { /*6344*/
					$1.i = _Bl; /*6342*/
					var _Bm = $1.pad; /*6343*/
					var _Bn = $1.i; /*6343*/
					var _Bo = $a([0, 0, 1, 0, 0]); /*6343*/
					var _Bp = $1.pad; /*6343*/
					var _Bq = $1.i; /*6343*/
					var _Br = 5; /*6343*/
					var _Bs = _Bp.length - _Bq; /*6343*/
					if ((_Bp.length - _Bq) > 5) { /*6343*/
						var _ = _Br; /*6343*/
						_Br = _Bs; /*6343*/
						_Bs = _; /*6343*/
					} /*6343*/
					$puti(_Bm, _Bn, $geti(_Bo, 0, _Bs)); /*6343*/
				} /*6343*/
				if ($eq($1.mode, "numeric")) { /*6347*/
					$k[$j++] = "pad"; /*6346*/
					$k[$j++] = Infinity; /*6346*/
					$k[$j++] = 0; /*6346*/
					$k[$j++] = 0; /*6346*/
					$k[$j++] = 0; /*6346*/
					$k[$j++] = 0; /*6346*/
					$aload($1.pad); /*6346*/
					var _By = $geti($a(), 0, $1.pad.length); /*6346*/
					$1[$k[--$j]] = _By; /*6346*/
				} /*6346*/
			} /*6346*/
			$k[$j++] = Infinity; /*6358*/
			var _C1 = $1.linkage ? 1 : 0; /*6352*/
			$k[$j++] = _C1; /*6353*/
			$forall($1.method, function() { /*6353*/
				var _C3 = $k[--$j]; /*6353*/
				$k[$j++] = _C3 - 48; /*6353*/
			}); /*6353*/
			$aload($1.vlf); /*6354*/
			$aload($1.cdf); /*6355*/
			$aload($1.gpf); /*6356*/
			$aload($1.pad); /*6357*/
			$1.binval = $a(); /*6358*/
			$1.datalen = ~~($1.binval.length / 12); /*6359*/
			$1.ncr = function() {
				var _CA = $k[--$j]; /*6362*/
				var _CB = $k[--$j]; /*6362*/
				var _CC = _CB - _CA; /*6362*/
				if (_CA < (_CB - _CA)) { /*6362*/
					var _ = _CC; /*6362*/
					_CC = _CA; /*6362*/
					_CA = _; /*6362*/
				} /*6362*/
				$k[$j++] = _CC; /*6369*/
				$k[$j++] = 1; /*6369*/
				$k[$j++] = 1; /*6369*/
				for (var _CE = _CB, _CD = _CA + 1; _CE >= _CD; _CE -= 1) { /*6369*/
					var _CF = $k[--$j]; /*6365*/
					var _CG = $k[--$j]; /*6366*/
					var _CH = $k[--$j]; /*6366*/
					$k[$j++] = _CH; /*6368*/
					$k[$j++] = _CG; /*6368*/
					$k[$j++] = _CF * _CE; /*6368*/
					if ($le(_CG, _CH)) { /*6368*/
						var _CI = $k[--$j]; /*6367*/
						var _CJ = $k[--$j]; /*6367*/
						$k[$j++] = _CJ + 1; /*6367*/
						$k[$j++] = ~~(_CI / _CJ); /*6367*/
					} /*6367*/
				} /*6367*/
				for (;;) { /*6373*/
					var _CK = $k[--$j]; /*6371*/
					var _CL = $k[--$j]; /*6371*/
					var _CM = $k[--$j]; /*6371*/
					$k[$j++] = _CM; /*6371*/
					$k[$j++] = _CL; /*6371*/
					$k[$j++] = _CK; /*6371*/
					if ($gt(_CL, _CM)) { /*6371*/
						break; /*6371*/
					} /*6371*/
					var _CN = $k[--$j]; /*6372*/
					var _CO = $k[--$j]; /*6372*/
					$k[$j++] = _CO + 1; /*6372*/
					$k[$j++] = ~~(_CN / _CO); /*6372*/
				} /*6372*/
				var _CP = $k[--$j]; /*6374*/
				var _CQ = $k[--$j]; /*6374*/
				var _CR = $k[--$j]; /*6374*/
				$k[$j++] = _CP; /*6374*/
			}; /*6375*/
			$1.getRSSwidths = function() {
				$1.oe = $k[--$j]; /*6378*/
				$1.el = $k[--$j]; /*6379*/
				$1.mw = $k[--$j]; /*6380*/
				$1.nm = $k[--$j]; /*6381*/
				$1.val = $k[--$j]; /*6382*/
				$1.out = $a($1.el); /*6383*/
				$1.mask = 0; /*6384*/
				for (var _Cb = 0, _Ca = $1.el - 2; _Cb <= _Ca; _Cb += 1) { /*6411*/
					$1.bar = _Cb; /*6386*/
					$1.ew = 1; /*6387*/
					var _Cd = $1.bar; /*6388*/
					$1.mask = $1.mask | ((_Cd < 0 ? 1 >>> -_Cd : 1 << _Cd)); /*6388*/
					for (;;) { /*6407*/
						$k[$j++] = "sval"; /*6389*/
						$k[$j++] = ($1.nm - $1.ew) - 1; /*6389*/
						$k[$j++] = ($1.el - $1.bar) - 2; /*6389*/
						if ($1.ncr() == $b) break; /*6389*/
						var _Ci = $k[--$j]; /*6389*/
						$1[$k[--$j]] = _Ci; /*6389*/
						if (($1.oe && ($1.mask == 0)) && (((($1.nm - $1.ew) - ($1.el * 2)) + ($1.bar * 2)) >= -2)) { /*6392*/
							$k[$j++] = "sval"; /*6391*/
							$k[$j++] = $1.sval; /*6391*/
							$k[$j++] = (($1.nm - $1.ew) - $1.el) + $1.bar; /*6391*/
							$k[$j++] = ($1.el - $1.bar) - 2; /*6391*/
							if ($1.ncr() == $b) break; /*6391*/
							var _Cx = $k[--$j]; /*6391*/
							var _Cy = $k[--$j]; /*6391*/
							$1[$k[--$j]] = _Cy - _Cx; /*6391*/
						} /*6391*/
						if (($1.el - $1.bar) > 2) { /*6401*/
							$1.lval = 0; /*6394*/
							for (var _D8 = ((($1.nm - $1.ew) - $1.el) + $1.bar) + 2, _D7 = $1.mw + 1; _D8 >= _D7; _D8 -= 1) { /*6398*/
								$k[$j++] = (($1.nm - _D8) - $1.ew) - 1; /*6396*/
								$k[$j++] = ($1.el - $1.bar) - 3; /*6396*/
								if ($1.ncr() == $b) break; /*6396*/
								$1.lval = $k[--$j] + $1.lval; /*6397*/
							} /*6397*/
							$1.sval = $1.sval - ($1.lval * (($1.el - $1.bar) - 1)); /*6399*/
						} else { /*6401*/
							if (($1.nm - $1.ew) > $1.mw) { /*6401*/
								$1.sval = $1.sval - 1; /*6401*/
							} /*6401*/
						} /*6401*/
						$1.val = $1.val - $1.sval; /*6403*/
						if ($1.val < 0) { /*6404*/
							break; /*6404*/
						} /*6404*/
						$1.ew = $1.ew + 1; /*6405*/
						var _DS = $1.bar; /*6406*/
						$1.mask = $1.mask & (~((_DS < 0 ? 1 >>> -_DS : 1 << _DS))); /*6406*/
					} /*6406*/
					$1.val = $1.val + $1.sval; /*6408*/
					$1.nm = $1.nm - $1.ew; /*6409*/
					$put($1.out, $1.bar, $1.ew); /*6410*/
				} /*6410*/
				$put($1.out, $1.el - 1, $1.nm); /*6412*/
				$k[$j++] = $1.out; /*6413*/
			}; /*6414*/
			$1.tab174 = $a([347, 0, 12, 5, 7, 2, 87, 4, 1387, 348, 10, 7, 5, 4, 52, 20, 2947, 1388, 8, 9, 4, 5, 30, 52, 3987, 2948, 6, 11, 3, 6, 10, 104, 4191, 3988, 4, 13, 1, 8, 1, 204]); /*6422*/
			$1.dxw = $a($1.datalen); /*6424*/
			for (var _Dj = 0, _Di = $1.datalen - 1; _Dj <= _Di; _Dj += 1) { /*6465*/
				$1.x = _Dj; /*6428*/
				$1.d = $geti($1.binval, $1.x * 12, 12); /*6430*/
				$k[$j++] = "d"; /*6431*/
				$k[$j++] = 0; /*6431*/
				for (var _Dn = 0; _Dn <= 11; _Dn += 1) { /*6431*/
					$1.j = _Dn; /*6431*/
					var _Ds = $k[--$j]; /*6431*/
					$k[$j++] = _Ds + ((~~Math.pow(2, 11 - $1.j)) * $get($1.d, $1.j)); /*6431*/
				} /*6431*/
				var _Dt = $k[--$j]; /*6431*/
				$1[$k[--$j]] = _Dt; /*6431*/
				$1.j = 0; /*6433*/
				for (;;) { /*6443*/
					if ($le($1.d, $get($1.tab174, $1.j))) { /*6441*/
						$forall($geti($1.tab174, $1.j + 1, 7)); /*6435*/
						$1.dte = $k[--$j]; /*6436*/
						$1.dto = $k[--$j]; /*6436*/
						$1.dmwe = $k[--$j]; /*6437*/
						$1.dmwo = $k[--$j]; /*6437*/
						$1.dele = $k[--$j]; /*6438*/
						$1.delo = $k[--$j]; /*6438*/
						$1.dgs = $k[--$j]; /*6439*/
						break; /*6440*/
					} /*6440*/
					$1.j = $1.j + 8; /*6442*/
				} /*6442*/
				$k[$j++] = "dwo"; /*6445*/
				$k[$j++] = ~~(($1.d - $1.dgs) / $1.dte); /*6445*/
				$k[$j++] = $1.delo; /*6445*/
				$k[$j++] = $1.dmwo; /*6445*/
				$k[$j++] = 4; /*6445*/
				$k[$j++] = true; /*6445*/
				if ($1.getRSSwidths() == $b) break; /*6445*/
				var _EF = $k[--$j]; /*6445*/
				$1[$k[--$j]] = _EF; /*6445*/
				$k[$j++] = "dwe"; /*6446*/
				$k[$j++] = ($1.d - $1.dgs) % $1.dte; /*6446*/
				$k[$j++] = $1.dele; /*6446*/
				$k[$j++] = $1.dmwe; /*6446*/
				$k[$j++] = 4; /*6446*/
				$k[$j++] = false; /*6446*/
				if ($1.getRSSwidths() == $b) break; /*6446*/
				var _EM = $k[--$j]; /*6446*/
				$1[$k[--$j]] = _EM; /*6446*/
				$1.dw = $a(8); /*6448*/
				if (($1.x % 2) == 0) { /*6459*/
					for (var _EQ = 0; _EQ <= 3; _EQ += 1) { /*6454*/
						$1.j = _EQ; /*6451*/
						$put($1.dw, 7 - ($1.j * 2), $get($1.dwo, $1.j)); /*6452*/
						$put($1.dw, 6 - ($1.j * 2), $get($1.dwe, $1.j)); /*6453*/
					} /*6453*/
				} else { /*6459*/
					for (var _Eb = 0; _Eb <= 3; _Eb += 1) { /*6460*/
						$1.j = _Eb; /*6457*/
						$put($1.dw, $1.j * 2, $get($1.dwo, $1.j)); /*6458*/
						$put($1.dw, ($1.j * 2) + 1, $get($1.dwe, $1.j)); /*6459*/
					} /*6459*/
				} /*6459*/
				$put($1.dxw, $1.x, $1.dw); /*6463*/
			} /*6463*/
			$1.finderwidths = $a([1, 8, 4, 1, 1, 1, 1, 4, 8, 1, 3, 6, 4, 1, 1, 1, 1, 4, 6, 3, 3, 4, 6, 1, 1, 1, 1, 6, 4, 3, 3, 2, 8, 1, 1, 1, 1, 8, 2, 3, 2, 6, 5, 1, 1, 1, 1, 5, 6, 2, 2, 2, 9, 1, 1, 1, 1, 9, 2, 2]); /*6474*/
			$1.finderseq = $a([$a([0, 1]), $a([0, 3, 2]), $a([0, 5, 2, 7]), $a([0, 9, 2, 7, 4]), $a([0, 9, 2, 7, 6, 11]), $a([0, 9, 2, 7, 8, 11, 10]), $a([0, 1, 2, 3, 4, 5, 6, 7]), $a([0, 1, 2, 3, 4, 5, 6, 9, 8]), $a([0, 1, 2, 3, 4, 5, 6, 9, 10, 11]), $a([0, 1, 2, 3, 4, 7, 6, 9, 8, 11, 10])]); /*6487*/
			$1.seq = $get($1.finderseq, ~~(($1.datalen - 2) / 2)); /*6489*/
			$1.fxw = $a($1.seq.length); /*6490*/
			for (var _F8 = 0, _F7 = $1.seq.length - 1; _F8 <= _F7; _F8 += 1) { /*6494*/
				$1.x = _F8; /*6492*/
				$put($1.fxw, $1.x, $geti($1.finderwidths, $get($1.seq, $1.x) * 5, 5)); /*6493*/
			} /*6493*/
			$1.checkweights = $a([-1, -1, -1, -1, -1, -1, -1, -1, 77, 96, 32, 81, 27, 9, 3, 1, 20, 60, 180, 118, 143, 7, 21, 63, 205, 209, 140, 117, 39, 13, 145, 189, 193, 157, 49, 147, 19, 57, 171, 91, 132, 44, 85, 169, 197, 136, 186, 62, 185, 133, 188, 142, 4, 12, 36, 108, 50, 87, 29, 80, 97, 173, 128, 113, 150, 28, 84, 41, 123, 158, 52, 156, 166, 196, 206, 139, 187, 203, 138, 46, 76, 17, 51, 153, 37, 111, 122, 155, 146, 119, 110, 107, 106, 176, 129, 43, 16, 48, 144, 10, 30, 90, 59, 177, 164, 125, 112, 178, 200, 137, 116, 109, 70, 210, 208, 202, 184, 130, 179, 115, 190, 204, 68, 93, 31, 151, 191, 134, 148, 22, 66, 198, 172, 94, 71, 2, 40, 154, 192, 64, 162, 54, 18, 6, 120, 149, 25, 75, 14, 42, 126, 167, 175, 199, 207, 69, 23, 78, 26, 79, 103, 98, 83, 38, 114, 131, 182, 124, 159, 53, 88, 170, 127, 183, 61, 161, 55, 165, 73, 8, 24, 72, 5, 15, 89, 100, 174, 58, 160, 194, 135, 45]); /*6521*/
			$k[$j++] = "checkweightseq"; /*6525*/
			$k[$j++] = Infinity; /*6525*/
			$forall($1.seq, function() { /*6524*/
				$aload($geti($1.checkweights, $k[--$j] * 16, 16)); /*6524*/
			}); /*6524*/
			var _FL = $a(); /*6525*/
			$1[$k[--$j]] = $geti(_FL, 8, _FL.length - 8); /*6525*/
			$k[$j++] = Infinity; /*6529*/
			var _FO = $1.dxw; /*6528*/
			for (var _FP = 0, _FQ = _FO.length; _FP < _FQ; _FP++) { /*6528*/
				$forall($get(_FO, _FP)); /*6528*/
			} /*6528*/
			$1.widths = $a(); /*6529*/
			$1.checksum = 0; /*6531*/
			for (var _FV = 0, _FU = $1.widths.length - 1; _FV <= _FU; _FV += 1) { /*6535*/
				$1.i = _FV; /*6533*/
				$1.checksum = $1.checksum + ($get($1.widths, $1.i) * $get($1.checkweightseq, $1.i)); /*6534*/
			} /*6534*/
			$1.checksum = ($1.checksum % 211) + (($1.datalen - 3) * 211); /*6536*/
			$1.i = 0; /*6538*/
			for (;;) { /*6548*/
				if ($1.checksum <= $get($1.tab174, $1.i)) { /*6546*/
					$forall($geti($1.tab174, $1.i + 1, 7)); /*6540*/
					$1.cte = $k[--$j]; /*6541*/
					$1.cto = $k[--$j]; /*6541*/
					$1.cmwe = $k[--$j]; /*6542*/
					$1.cmwo = $k[--$j]; /*6542*/
					$1.cele = $k[--$j]; /*6543*/
					$1.celo = $k[--$j]; /*6543*/
					$1.cgs = $k[--$j]; /*6544*/
					break; /*6545*/
				} /*6545*/
				$1.i = $1.i + 8; /*6547*/
			} /*6547*/
			$k[$j++] = "cwo"; /*6550*/
			$k[$j++] = ~~(($1.checksum - $1.cgs) / $1.cte); /*6550*/
			$k[$j++] = $1.celo; /*6550*/
			$k[$j++] = $1.cmwo; /*6550*/
			$k[$j++] = 4; /*6550*/
			$k[$j++] = true; /*6550*/
			if ($1.getRSSwidths() == $b) return $b; /*6550*/
			var _Fz = $k[--$j]; /*6550*/
			$1[$k[--$j]] = _Fz; /*6550*/
			$k[$j++] = "cwe"; /*6551*/
			$k[$j++] = ($1.checksum - $1.cgs) % $1.cte; /*6551*/
			$k[$j++] = $1.cele; /*6551*/
			$k[$j++] = $1.cmwe; /*6551*/
			$k[$j++] = 4; /*6551*/
			$k[$j++] = false; /*6551*/
			if ($1.getRSSwidths() == $b) return $b; /*6551*/
			var _G6 = $k[--$j]; /*6551*/
			$1[$k[--$j]] = _G6; /*6551*/
			$1.cw = $a(8); /*6553*/
			for (var _G9 = 0; _G9 <= 3; _G9 += 1) { /*6558*/
				$1.i = _G9; /*6555*/
				$put($1.cw, $1.i * 2, $get($1.cwo, $1.i)); /*6556*/
				$put($1.cw, ($1.i * 2) + 1, $get($1.cwe, $1.i)); /*6557*/
			} /*6557*/
			var _GK = $a(22); /*6560*/
			$put(_GK, 0, $1.cw); /*6561*/
			$puti(_GK, 1, $1.dxw); /*6561*/
			$1.dxw = $geti(_GK, 0, $1.datalen + 1); /*6562*/
			$1.datalen = $1.dxw.length; /*6563*/
			$1.rows = $a(~~Math.ceil($1.datalen / $1.segments)); /*6566*/
			$1.numrows = $1.rows.length; /*6567*/
			for (var _GW = 0, _GV = $1.numrows - 1; _GW <= _GV; _GW += 1) { /*6582*/
				$1.r = _GW; /*6569*/
				$k[$j++] = Infinity; /*6570*/
				if ((($1.segments % 4) != 0) && (($1.r % 2) == 1)) { /*6571*/
					$k[$j++] = 0; /*6571*/
				} /*6571*/
				$k[$j++] = 1; /*6579*/
				$k[$j++] = 1; /*6579*/
				for (var _Gb = 0, _Ga = $1.segments - 1; _Gb <= _Ga; _Gb += 1) { /*6579*/
					$1.pos = _Gb + ($1.r * $1.segments); /*6574*/
					if ($1.pos < $1.datalen) { /*6578*/
						$forall($get($1.dxw, $1.pos)); /*6576*/
						if (($1.pos % 2) == 0) { /*6577*/
							$forall($get($1.fxw, ~~($1.pos / 2))); /*6577*/
						} /*6577*/
					} /*6577*/
				} /*6577*/
				var _Gn = $counttomark() + 2; /*6581*/
				$k[$j++] = 1; /*6581*/
				$k[$j++] = 1; /*6581*/
				$astore($a(_Gn)); /*6581*/
				$put($1.rows, $1.r, $k[--$j]); /*6581*/
				$j--; /*6581*/
			} /*6581*/
			if ($ne($1.format, "expandedstacked")) { /*6706*/
				var _Gu = $get($1.rows, 0); /*6587*/
				$1.sbs = $geti(_Gu, 1, _Gu.length - 1); /*6587*/
				$k[$j++] = Infinity; /*6597*/
				$k[$j++] = 1; /*6595*/
				for (var _Gy = 0, _Gx = $1.datalen - 1; _Gy <= _Gx; _Gy += 1) { /*6595*/
					$1.i = _Gy; /*6592*/
					$forall($get($1.dxw, $1.i)); /*6593*/
					if (($1.i % 2) == 0) { /*6594*/
						$forall($get($1.fxw, ~~($1.i / 2))); /*6594*/
					} /*6594*/
				} /*6594*/
				$k[$j++] = 1; /*6596*/
				$k[$j++] = 1; /*6596*/
				$1.sbs = $a(); /*6597*/
				$k[$j++] = Infinity; /*6604*/
				$k[$j++] = "ren"; /*6603*/
				$k[$j++] = $0.renlinear; /*6603*/
				$k[$j++] = "sbs"; /*6603*/
				$k[$j++] = $1.sbs; /*6603*/
				$k[$j++] = "bhs"; /*6603*/
				$k[$j++] = Infinity; /*6603*/
				for (var _H9 = 0, _HA = ~~(($1.sbs.length + 1) / 2); _H9 < _HA; _H9++) { /*6602*/
					$k[$j++] = $1.height; /*6602*/
				} /*6602*/
				var _HC = $a(); /*6603*/
				$k[$j++] = _HC; /*6604*/
				$k[$j++] = "bbs"; /*6604*/
				$k[$j++] = Infinity; /*6604*/
				for (var _HE = 0, _HF = ~~(($1.sbs.length + 1) / 2); _HE < _HF; _HE++) { /*6603*/
					$k[$j++] = 0; /*6603*/
				} /*6603*/
				var _HG = $a(); /*6604*/
				$k[$j++] = _HG; /*6604*/
				$k[$j++] = "opt"; /*6604*/
				$k[$j++] = $1.options; /*6604*/
				var _HI = $d(); /*6604*/
				$k[$j++] = _HI; /*6607*/
				if (!$1.dontdraw) { /*6607*/
					$0.renlinear(); /*6607*/
				} /*6607*/
			} else { /*6706*/
				$1.seps = $a($1.numrows); /*6611*/
				for (var _HO = 0, _HN = $1.numrows - 1; _HO <= _HN; _HO += 1) { /*6667*/
					$1.r = _HO; /*6614*/
					$1.row = $get($1.rows, $1.r); /*6615*/
					$k[$j++] = Infinity; /*6618*/
					for (var _HU = 0, _HT = $1.row.length - 1; _HU <= _HT; _HU += 2) { /*6623*/
						$1.i = _HU; /*6620*/
						for (var _HY = 0, _HZ = $get($1.row, $1.i); _HY < _HZ; _HY++) { /*6621*/
							$k[$j++] = 0; /*6621*/
						} /*6621*/
						if ($1.i < ($1.row.length - 1)) { /*6622*/
							for (var _Hf = 0, _Hg = $get($1.row, $1.i + 1); _Hf < _Hg; _Hf++) { /*6622*/
								$k[$j++] = 1; /*6622*/
							} /*6622*/
						} /*6622*/
					} /*6622*/
					$astore($a($counttomark())); /*6624*/
					$1.row = $k[--$j]; /*6624*/
					$j--; /*6624*/
					$k[$j++] = Infinity; /*6627*/
					$forall($1.row, function() { /*6627*/
						var _Hl = $k[--$j]; /*6627*/
						$k[$j++] = 1 - _Hl; /*6627*/
					}); /*6627*/
					$1.sep = $a(); /*6627*/
					$puti($1.sep, 0, $a([0, 0, 0, 0])); /*6628*/
					$puti($1.sep, $1.row.length - 4, $a([0, 0, 0, 0])); /*6629*/
					$k[$j++] = Infinity; /*6633*/
					for (var _Hu = 19, _Ht = $1.row.length - 13; _Hu <= _Ht; _Hu += 98) { /*6631*/
						$k[$j++] = _Hu; /*6631*/
					} /*6631*/
					for (var _Hx = 68, _Hw = $1.row.length - 13; _Hx <= _Hw; _Hx += 98) { /*6632*/
						$k[$j++] = _Hx; /*6632*/
					} /*6632*/
					$1.finderpos = $a(); /*6633*/
					var _Hz = $1.finderpos; /*6634*/
					for (var _I0 = 0, _I1 = _Hz.length; _I0 < _I1; _I0++) { /*6648*/
						var _I2 = $get(_Hz, _I0); /*6648*/
						for (var _I4 = _I2, _I3 = _I2 + 14; _I4 <= _I3; _I4 += 1) { /*6647*/
							$1.i = _I4; /*6636*/
							if ($get($1.row, $1.i) == 0) { /*6644*/
								if ($get($1.row, $1.i - 1) == 1) { /*6641*/
									$k[$j++] = 1; /*6639*/
								} else { /*6641*/
									var _IE = ($get($1.sep, $1.i - 1) == 0) ? 1 : 0; /*6641*/
									$k[$j++] = _IE; /*6641*/
								} /*6641*/
							} else { /*6644*/
								$k[$j++] = 0; /*6644*/
							} /*6644*/
							$put($1.sep, $1.i, $k[--$j]); /*6646*/
						} /*6646*/
					} /*6646*/
					if ((($1.segments % 4) == 0) && (($1.r % 2) == 1)) { /*6662*/
						if (($get($1.rows, $1.r).length != $get($1.rows, 0).length) && (($1.finderpos.length % 2) == 1)) { /*6660*/
							$k[$j++] = Infinity; /*6654*/
							$k[$j++] = 0; /*6654*/
							$aload($1.row); /*6654*/
							$1.row = $a(); /*6654*/
							$k[$j++] = Infinity; /*6655*/
							$k[$j++] = 0; /*6655*/
							$aload($1.sep); /*6655*/
							$1.sep = $a(); /*6655*/
						} else { /*6660*/
							for (var _IV = $1.row.length - 1; _IV >= 0; _IV -= 1) { /*6657*/
								$k[$j++] = $get($1.row, _IV); /*6657*/
							} /*6657*/
							$astore($1.row); /*6658*/
							$j--; /*6658*/
							for (var _Ia = $1.sep.length - 1; _Ia >= 0; _Ia -= 1) { /*6659*/
								$k[$j++] = $get($1.sep, _Ia); /*6659*/
							} /*6659*/
							$astore($1.sep); /*6660*/
							$j--; /*6660*/
						} /*6660*/
					} /*6660*/
					$put($1.rows, $1.r, $1.row); /*6664*/
					$put($1.seps, $1.r, $1.sep); /*6665*/
				} /*6665*/
				$1.pixx = $get($1.rows, 0).length; /*6670*/
				$k[$j++] = Infinity; /*6671*/
				for (var _In = 0, _Io = $1.pixx; _In < _Io; _In++) { /*6671*/
					$k[$j++] = 0; /*6671*/
				} /*6671*/
				var _Ip = $a(); /*6671*/
				$puti(_Ip, 0, $get($1.rows, $1.numrows - 1)); /*6671*/
				$put($1.rows, $1.numrows - 1, _Ip); /*6672*/
				$k[$j++] = Infinity; /*6673*/
				for (var _Iw = 0, _Ix = $1.pixx; _Iw < _Ix; _Iw++) { /*6673*/
					$k[$j++] = 0; /*6673*/
				} /*6673*/
				var _Iy = $a(); /*6673*/
				$puti(_Iy, 0, $get($1.seps, $1.numrows - 1)); /*6673*/
				$put($1.seps, $1.numrows - 1, _Iy); /*6674*/
				$k[$j++] = "sep"; /*6677*/
				$k[$j++] = Infinity; /*6677*/
				for (var _J5 = 0, _J6 = (~~($1.pixx / 2)) + 1; _J5 < _J6; _J5++) { /*6677*/
					$k[$j++] = 0; /*6677*/
					$k[$j++] = 1; /*6677*/
				} /*6677*/
				var _J9 = $geti($a(), 0, $1.pixx); /*6677*/
				$1[$k[--$j]] = _J9; /*6677*/
				$puti($1.sep, 0, $a([0, 0, 0, 0])); /*6678*/
				$puti($1.sep, $1.pixx - 4, $a([0, 0, 0, 0])); /*6679*/
				$k[$j++] = Infinity; /*6694*/
				for (var _JI = 0, _JH = $1.numrows - 1; _JI <= _JH; _JI += 1) { /*6693*/
					$1.r = _JI; /*6684*/
					if ($1.r != 0) { /*6687*/
						$aload($get($1.seps, $1.r)); /*6686*/
					} /*6686*/
					for (var _JO = 0, _JP = $1.barxmult; _JO < _JP; _JO++) { /*6688*/
						$aload($get($1.rows, $1.r)); /*6688*/
					} /*6688*/
					if ($1.r != ($1.numrows - 1)) { /*6692*/
						$aload($get($1.seps, $1.r)); /*6690*/
						$aload($1.sep); /*6691*/
					} /*6691*/
				} /*6691*/
				$1.pixs = $a(); /*6694*/
				var _Ji = {
					ren: $0.renmatrix,
					pixs: $1.pixs,
					pixx: $1.pixx,
					pixy: ~~($1.pixs.length / $1.pixx),
					height: (~~($1.pixs.length / $1.pixx)) / 72,
					width: $1.pixx / 72,
					opt: $1.options
				}; /*6703*/
				$k[$j++] = _Ji; /*6706*/
				if (!$1.dontdraw) { /*6706*/
					$0.renmatrix(); /*6706*/
				} /*6706*/
			} /*6706*/
		};
		$0.databarexpandedstacked = function() {
			var $1 = {}; /*6736*/
			$1.options = $k[--$j]; /*6738*/
			$1.barcode = $k[--$j]; /*6739*/
			$1.dontdraw = false; /*6741*/
			$forall($1.options, function() { /*6752*/
				var _3 = $k[--$j]; /*6752*/
				$1[$k[--$j]] = _3; /*6752*/
			}); /*6752*/
			$1.options.dontdraw = true; /*6755*/
			$1.options.format = "expandedstacked"; /*6756*/
			$k[$j++] = "args"; /*6758*/
			$k[$j++] = $1.barcode; /*6758*/
			$k[$j++] = $1.options; /*6758*/
			$0.databarexpanded(); /*6758*/
			var _9 = $k[--$j]; /*6758*/
			$1[$k[--$j]] = _9; /*6758*/
			$1.args.opt = $1.options; /*6760*/
			$k[$j++] = $1.args; /*6763*/
			if (!$1.dontdraw) { /*6763*/
				$0.renmatrix(); /*6763*/
			} /*6763*/
		};
		$0.gs1northamericancoupon = function() {
			var $1 = {}; /*6791*/
			$1.options = $k[--$j]; /*6793*/
			$1.barcode = $k[--$j]; /*6794*/
			$1.dontdraw = false; /*6796*/
			$1.includetext = false; /*6798*/
			$1.coupontextfont = "Helvetica"; /*6799*/
			$1.coupontextsize = 9; /*6800*/
			$1.coupontextxoffset = "unset"; /*6801*/
			$1.coupontextyoffset = "unset"; /*6802*/
			$forall($1.options, function() { /*6813*/
				var _3 = $k[--$j]; /*6813*/
				$1[$k[--$j]] = _3; /*6813*/
			}); /*6813*/
			$1.coupontextfont = "" + $1.coupontextfont; /*6815*/
			$1.coupontextsize = +$1.coupontextsize; /*6816*/
			if ($ne($1.coupontextxoffset, "unset")) { /*6817*/
				$1.coupontextxoffset = +$1.coupontextxoffset; /*6817*/
			} /*6817*/
			if ($ne($1.coupontextyoffset, "unset")) { /*6818*/
				$1.coupontextyoffset = +$1.coupontextyoffset; /*6818*/
			} /*6818*/
			$1.expand = function() {
				$1.in = $k[--$j]; /*6822*/
				$1.out = $s($1.in.length); /*6823*/
				$1.j = 0; /*6824*/
				$k[$j++] = $1.in; /*6838*/
				for (;;) { /*6838*/
					$search($k[--$j], "^"); /*6827*/
					if ($k[--$j]) { /*6836*/
						var _H = $k[--$j]; /*6828*/
						$puti($1.out, $1.j, _H); /*6828*/
						$1.j = (_H.length + $1.j) + 1; /*6829*/
						$j--; /*6830*/
						var _L = $k[--$j]; /*6831*/
						$put($1.out, $1.j - 1, ~~$z($geti(_L, 0, 3))); /*6831*/
						$k[$j++] = $geti(_L, 3, _L.length - 3); /*6832*/
					} else { /*6836*/
						var _Q = $k[--$j]; /*6834*/
						$puti($1.out, $1.j, _Q); /*6834*/
						$1.j = _Q.length + $1.j; /*6835*/
						$k[$j++] = $geti($1.out, 0, $1.j); /*6836*/
						break; /*6836*/
					} /*6836*/
				} /*6836*/
			}; /*6839*/
			$1.ais = $a([]); /*6842*/
			$1.vals = $a([]); /*6843*/
			var _Z = $1.barcode; /*6844*/
			$k[$j++] = $geti(_Z, 1, _Z.length - 1); /*6857*/
			for (;;) { /*6857*/
				var _b = $k[--$j]; /*6846*/
				$k[$j++] = _b; /*6846*/
				if ($eq(_b, "")) { /*6846*/
					break; /*6846*/
				} /*6846*/
				$search($k[--$j], ")"); /*6847*/
				$j--; /*6847*/
				var _d = $k[--$j]; /*6848*/
				var _e = $k[--$j]; /*6848*/
				var _f = $k[--$j]; /*6849*/
				$k[$j++] = _d; /*6849*/
				$search(_f, "("); /*6849*/
				if ($k[--$j]) { /*6852*/
					var _h = $k[--$j]; /*6850*/
					var _i = $k[--$j]; /*6850*/
					var _j = $k[--$j]; /*6850*/
					var _k = $k[--$j]; /*6850*/
					$k[$j++] = _j; /*6850*/
					$k[$j++] = _k; /*6850*/
					$k[$j++] = _h; /*6850*/
				} else { /*6852*/
					var _l = $k[--$j]; /*6852*/
					var _m = $k[--$j]; /*6852*/
					$k[$j++] = ""; /*6852*/
					$k[$j++] = _m; /*6852*/
					$k[$j++] = _l; /*6852*/
				} /*6852*/
				$k[$j++] = Infinity; /*6854*/
				$aload($1.ais); /*6854*/
				var _p = $k[$j - 1 - ($counttomark() + 2)]; /*6854*/
				$k[$j++] = _p; /*6854*/
				$1.ais = $a(); /*6854*/
				$k[$j++] = Infinity; /*6855*/
				$aload($1.vals); /*6855*/
				var _t = $k[$j - 1 - ($counttomark() + 1)]; /*6855*/
				$k[$j++] = _t; /*6855*/
				if ($1.expand() == $b) break; /*6855*/
				$1.vals = $a(); /*6855*/
				$j -= 2; /*6856*/
			} /*6856*/
			$j--; /*6858*/
			if ($1.ais.length != 1) { /*6863*/
				$k[$j++] = "bwipp.gs1northamericancouponBadAIStructure"; /*6862*/
				$k[$j++] = "A GS1 North American Coupon should consist of a single AI (8110)"; /*6862*/
				$0.raiseerror(); /*6862*/
			} /*6862*/
			if ($ne($get($1.ais, 0), "8110")) { /*6866*/
				$k[$j++] = "bwipp.gs1northamericancouponBadAIStructure"; /*6865*/
				$k[$j++] = "A GS1 North American Coupon should consist of a single AI (8110)"; /*6865*/
				$0.raiseerror(); /*6865*/
			} /*6865*/
			$1.val = $get($1.vals, 0); /*6869*/
			$1.vli = $get($1.val, 0) - 48; /*6870*/
			if (($1.vli < 0) || ($1.vli > 6)) { /*6873*/
				$k[$j++] = "bwipp.gs1northamericancouponBadVLI"; /*6872*/
				$k[$j++] = "The AI (8110) data should start with a Company Prefix length indicator in the range 0 to 6"; /*6872*/
				$0.raiseerror(); /*6872*/
			} /*6872*/
			$1.gcp = $geti($1.val, 1, $1.vli + 6); /*6874*/
			$1.cod = $geti($1.val, $1.vli + 7, 6); /*6875*/
			$1.coupontext = $s($1.gcp.length + 7); /*6876*/
			$puti($1.coupontext, 0, $1.gcp); /*6877*/
			$puti($1.coupontext, $1.gcp.length, "-"); /*6878*/
			$puti($1.coupontext, $1.gcp.length + 1, $1.cod); /*6879*/
			$1.options.dontdraw = true; /*6882*/
			$k[$j++] = "args"; /*6884*/
			$k[$j++] = $1.barcode; /*6884*/
			$k[$j++] = $1.options; /*6884*/
			$0.databarexpandedstacked(); /*6884*/
			var _1M = $k[--$j]; /*6884*/
			$1[$k[--$j]] = _1M; /*6884*/
			if ($1.includetext) { /*6903*/
				if ($1.coupontextxoffset == "unset") { /*6890*/
					$1.coupontextxoffset = 0; /*6889*/
				} /*6889*/
				if ($1.coupontextyoffset == "unset") { /*6893*/
					$1.coupontextyoffset = ($1.args.height * 72) + 3; /*6892*/
				} /*6892*/
				var _1U = $1.args.txt !== undefined; /*6894*/
				if (_1U) { /*6901*/
					$1.txt = $1.args.txt; /*6895*/
					$1.newtxt = $a($1.txt.length + 1); /*6896*/
					$puti($1.newtxt, 0, $1.txt); /*6897*/
					$put($1.newtxt, $1.newtxt.length - 1, $a([$1.coupontext, $1.coupontextxoffset, $1.coupontextyoffset, $1.coupontextfont, $1.coupontextsize])); /*6898*/
					$1.args.txt = $1.newtxt; /*6899*/
				} else { /*6901*/
					$1.args.txt = $a([$a([$1.coupontext, $1.coupontextxoffset, $1.coupontextyoffset, $1.coupontextfont, $1.coupontextsize])]); /*6901*/
				} /*6901*/
			} /*6901*/
			$1.args.opt = $1.options; /*6905*/
			$k[$j++] = $1.args; /*6908*/
			if (!$1.dontdraw) { /*6908*/
				$0.renmatrix(); /*6908*/
			} /*6908*/
		};
		$0.pharmacode = function() {
			var $1 = {}; /*6935*/
			$1.options = $k[--$j]; /*6937*/
			$1.barcode = $k[--$j]; /*6938*/
			$1.dontdraw = false; /*6940*/
			$1.height = (8 * 2.835) / 72; /*6941*/
			$1.nwidth = 0.5 * 2.835; /*6942*/
			$1.wwidth = 1.5 * 2.835; /*6943*/
			$1.swidth = 1 * 2.835; /*6944*/
			$forall($1.options, function() { /*6955*/
				var _3 = $k[--$j]; /*6955*/
				$1[$k[--$j]] = _3; /*6955*/
			}); /*6955*/
			$1.height = +$1.height; /*6957*/
			$1.nwidth = +$1.nwidth; /*6958*/
			$1.wwidth = +$1.wwidth; /*6959*/
			$1.swidth = +$1.swidth; /*6960*/
			if (($1.barcode.length < 1) || ($1.barcode.length > 6)) { /*6965*/
				$k[$j++] = "bwipp.pharmacodeBadLength"; /*6964*/
				$k[$j++] = "Pharmacode must be 1 to 6 digits"; /*6964*/
				$0.raiseerror(); /*6964*/
			} /*6964*/
			$forall($1.barcode, function() { /*6970*/
				var _C = $k[--$j]; /*6967*/
				if ((_C < 48) || (_C > 57)) { /*6969*/
					$k[$j++] = "bwipp.pharmacodeBadCharacter"; /*6968*/
					$k[$j++] = "Pharmacode must contain only digits"; /*6968*/
					$0.raiseerror(); /*6968*/
				} /*6968*/
			}); /*6968*/
			var _E = ~~$z($1.barcode); /*6971*/
			if ((_E < 3) || (_E > 131070)) { /*6973*/
				$k[$j++] = "bwipp.pharmacodeBadValue"; /*6972*/
				$k[$j++] = "Pharmacode value must be between 3 and 131070"; /*6972*/
				$0.raiseerror(); /*6972*/
			} /*6972*/
			$1.txt = $a($1.barcode.length); /*6976*/
			for (var _J = 0, _I = $1.barcode.length - 1; _J <= _I; _J += 1) { /*6980*/
				$1.i = _J; /*6978*/
				$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), 0, 0, "", 0])); /*6979*/
			} /*6979*/
			$1.barcode = $cvrs($s(17), (~~$z($1.barcode)) + 1, 2); /*6983*/
			$1.barcode = $geti($1.barcode, 1, $1.barcode.length - 1); /*6984*/
			$1.barlen = $1.barcode.length; /*6986*/
			$1.sbs = $a($1.barlen * 2); /*6987*/
			for (var _b = 0, _a = $1.barlen - 1; _b <= _a; _b += 1) { /*6998*/
				$1.i = _b; /*6990*/
				$1.enc = $geti($1.barcode, $1.i, 1); /*6991*/
				if ($eq($1.enc, "0")) { /*6995*/
					$put($1.sbs, $1.i * 2, $1.nwidth); /*6993*/
				} else { /*6995*/
					$put($1.sbs, $1.i * 2, $1.wwidth); /*6995*/
				} /*6995*/
				$put($1.sbs, ($1.i * 2) + 1, $1.swidth); /*6997*/
			} /*6997*/
			$k[$j++] = Infinity; /*7008*/
			$k[$j++] = "ren"; /*7005*/
			$k[$j++] = $0.renlinear; /*7005*/
			$k[$j++] = "sbs"; /*7005*/
			$k[$j++] = $1.sbs; /*7005*/
			$k[$j++] = "bhs"; /*7005*/
			$k[$j++] = Infinity; /*7005*/
			for (var _r = 0, _s = ~~(($1.sbs.length + 1) / 2); _r < _s; _r++) { /*7004*/
				$k[$j++] = $1.height; /*7004*/
			} /*7004*/
			var _u = $a(); /*7005*/
			$k[$j++] = _u; /*7006*/
			$k[$j++] = "bbs"; /*7006*/
			$k[$j++] = Infinity; /*7006*/
			for (var _w = 0, _x = ~~(($1.sbs.length + 1) / 2); _w < _x; _w++) { /*7005*/
				$k[$j++] = 0; /*7005*/
			} /*7005*/
			var _y = $a(); /*7006*/
			$k[$j++] = _y; /*7008*/
			$k[$j++] = "txt"; /*7008*/
			$k[$j++] = $1.txt; /*7008*/
			$k[$j++] = "textxalign"; /*7008*/
			$k[$j++] = "center"; /*7008*/
			$k[$j++] = "opt"; /*7008*/
			$k[$j++] = $1.options; /*7008*/
			var _11 = $d(); /*7008*/
			$k[$j++] = _11; /*7011*/
			if (!$1.dontdraw) { /*7011*/
				$0.renlinear(); /*7011*/
			} /*7011*/
		};
		$0.pharmacode2 = function() {
			var $1 = {}; /*7038*/
			$1.options = $k[--$j]; /*7040*/
			$1.barcode = $k[--$j]; /*7041*/
			$1.dontdraw = false; /*7043*/
			$1.includetext = false; /*7044*/
			$1.height = 4; /*7045*/
			$forall($1.options, function() { /*7056*/
				var _3 = $k[--$j]; /*7056*/
				$1[$k[--$j]] = _3; /*7056*/
			}); /*7056*/
			$1.height = +$1.height; /*7058*/
			if (($1.barcode.length < 1) || ($1.barcode.length > 8)) { /*7063*/
				$k[$j++] = "bwipp.pharmacode2BadLength"; /*7062*/
				$k[$j++] = "Two-track Pharmacode must be 1 to 6 digits"; /*7062*/
				$0.raiseerror(); /*7062*/
			} /*7062*/
			$forall($1.barcode, function() { /*7068*/
				var _9 = $k[--$j]; /*7065*/
				if ((_9 < 48) || (_9 > 57)) { /*7067*/
					$k[$j++] = "bwipp.pharmacode2badCharacter"; /*7066*/
					$k[$j++] = "Two-track Pharmacode must contain only digits"; /*7066*/
					$0.raiseerror(); /*7066*/
				} /*7066*/
			}); /*7066*/
			var _B = ~~$z($1.barcode); /*7069*/
			if ((_B < 4) || (_B > 64570080)) { /*7071*/
				$k[$j++] = "bwipp.pharmacode2badValue"; /*7070*/
				$k[$j++] = "Two-track Pharmacode value must be between 4 and 64570080"; /*7070*/
				$0.raiseerror(); /*7070*/
			} /*7070*/
			$1.txt = $a($1.barcode.length); /*7074*/
			for (var _G = 0, _F = $1.barcode.length - 1; _G <= _F; _G += 1) { /*7078*/
				$1.i = _G; /*7076*/
				$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), 0, 0, "", 0])); /*7077*/
			} /*7077*/
			$1.encstr = $s(16); /*7080*/
			$1.bhs = $a(16); /*7081*/
			$1.bbs = $a(16); /*7082*/
			$1.sbs = $a(32); /*7083*/
			$1.bar = (1 / 25.4) * $1.height; /*7084*/
			$1.spc = (1 / 25.4) * 72; /*7085*/
			$1.i = 15; /*7088*/
			$1.val = ~~$z($1.barcode); /*7089*/
			for (;;) { /*7096*/
				if ($1.val == 0) { /*7091*/
					break; /*7091*/
				} /*7091*/
				var _V = $1.val % 3; /*7092*/
				$1.val = ~~(($1.val - $get($a([3, 1, 2]), _V)) / 3); /*7093*/
				$put($1.encstr, $1.i, $get($a([2, 0, 1]), _V)); /*7094*/
				$1.i = $1.i - 1; /*7095*/
			} /*7095*/
			$1.encstr = $geti($1.encstr, $1.i + 1, 15 - $1.i); /*7097*/
			for (var _k = 0, _j = $1.encstr.length - 1; _k <= _j; _k += 1) { /*7105*/
				$1.i = _k; /*7101*/
				var _n = $get($1.encstr, $1.i); /*7102*/
				$put($1.bhs, $1.i, $1.bar * $get($a([1, 1, 2]), _n)); /*7103*/
				$put($1.bbs, $1.i, $get($a([0, $1.bar, 0]), _n)); /*7104*/
			} /*7104*/
			$k[$j++] = Infinity; /*7116*/
			$k[$j++] = "ren"; /*7113*/
			$k[$j++] = $0.renlinear; /*7113*/
			$k[$j++] = "bhs"; /*7113*/
			$k[$j++] = $1.bhs; /*7113*/
			$k[$j++] = "bbs"; /*7113*/
			$k[$j++] = $1.bbs; /*7113*/
			$k[$j++] = "sbs"; /*7113*/
			$k[$j++] = Infinity; /*7113*/
			for (var _11 = 0, _12 = $1.encstr.length * 2; _11 < _12; _11++) { /*7112*/
				$k[$j++] = $1.spc; /*7112*/
			} /*7112*/
			var _14 = $a(); /*7113*/
			$k[$j++] = _14; /*7116*/
			$k[$j++] = "txt"; /*7116*/
			$k[$j++] = $1.txt; /*7116*/
			$k[$j++] = "textxalign"; /*7116*/
			$k[$j++] = "center"; /*7116*/
			$k[$j++] = "textyoffset"; /*7116*/
			$k[$j++] = 4; /*7116*/
			$k[$j++] = "opt"; /*7116*/
			$k[$j++] = $1.options; /*7116*/
			var _17 = $d(); /*7116*/
			$k[$j++] = _17; /*7119*/
			if (!$1.dontdraw) { /*7119*/
				$0.renlinear(); /*7119*/
			} /*7119*/
		};
		$0.code2of5 = function() {
			var $1 = {}; /*7146*/
			$1.options = $k[--$j]; /*7148*/
			$1.barcode = $k[--$j]; /*7149*/
			$1.dontdraw = false; /*7151*/
			$1.includecheck = false; /*7152*/
			$1.validatecheck = false; /*7153*/
			$1.includetext = false; /*7154*/
			$1.includecheckintext = false; /*7155*/
			$1.textfont = "Courier"; /*7156*/
			$1.textsize = 10; /*7157*/
			$1.textyoffset = -8.5; /*7158*/
			$1.height = 1; /*7159*/
			$1.version = "industrial"; /*7160*/
			$forall($1.options, function() { /*7171*/
				var _3 = $k[--$j]; /*7171*/
				$1[$k[--$j]] = _3; /*7171*/
			}); /*7171*/
			$1.textfont = "" + $1.textfont; /*7173*/
			$1.textsize = +$1.textsize; /*7174*/
			$1.textyoffset = +$1.textyoffset; /*7175*/
			$1.height = +$1.height; /*7176*/
			$forall($1.barcode, function() { /*7183*/
				var _A = $k[--$j]; /*7180*/
				if ((_A < 48) || (_A > 57)) { /*7182*/
					$k[$j++] = "bwipp.code2of5badCharacter"; /*7181*/
					$k[$j++] = "Code 25 must contain only digits"; /*7181*/
					$0.raiseerror(); /*7181*/
				} /*7181*/
			}); /*7181*/
			$k[$j++] = "barlen"; /*7185*/
			$k[$j++] = $1.barcode.length; /*7185*/
			if ($1.validatecheck) { /*7185*/
				var _D = $k[--$j]; /*7185*/
				$k[$j++] = _D - 1; /*7185*/
			} /*7185*/
			var _E = $k[--$j]; /*7185*/
			$1[$k[--$j]] = _E; /*7185*/
			$1.checksum = 0; /*7187*/
			for (var _I = 0, _H = $1.barlen - 1; _I <= _H; _I += 1) { /*7191*/
				$1.i = _I; /*7189*/
				$k[$j++] = "checksum"; /*7190*/
				$k[$j++] = $1.checksum; /*7190*/
				$k[$j++] = $get($1.barcode, $1.i) - 48; /*7190*/
				if ((($1.barlen - $1.i) % 2) != 0) { /*7190*/
					var _P = $k[--$j]; /*7190*/
					$k[$j++] = _P * 3; /*7190*/
				} /*7190*/
				var _Q = $k[--$j]; /*7190*/
				var _R = $k[--$j]; /*7190*/
				$1[$k[--$j]] = _R + _Q; /*7190*/
			} /*7190*/
			$1.checksum = (10 - ($1.checksum % 10)) % 10; /*7192*/
			if ($1.validatecheck) { /*7199*/
				if ($get($1.barcode, $1.barlen) != ($1.checksum + 48)) { /*7196*/
					$k[$j++] = "bwipp.code2of5badCheckDigit"; /*7195*/
					$k[$j++] = "Incorrect Code 25 check digit provided"; /*7195*/
					$0.raiseerror(); /*7195*/
				} /*7195*/
				$1.barcode = $geti($1.barcode, 0, $1.barlen); /*7197*/
				$1.includecheck = true; /*7198*/
			} /*7198*/
			var _h = {
				industrial: $a(["1111313111", "3111111131", "1131111131", "3131111111", "1111311131", "3111311111", "1131311111", "1111113131", "3111113111", "1131113111", "313111", "31113"]),
				iata: $a(["1111313111", "3111111131", "1131111131", "3131111111", "1111311131", "3111311111", "1131311111", "1111113131", "3111113111", "1131113111", "1111", "311"]),
				matrix: $a(["113311", "311131", "131131", "331111", "113131", "313111", "133111", "111331", "311311", "131311", "311111", "31111"]),
				coop: $a(["331111", "111331", "113131", "113311", "131131", "131311", "133111", "311131", "311311", "313111", "3131", "133"]),
				datalogic: $a(["113311", "311131", "131131", "331111", "113131", "313111", "133111", "111331", "311311", "131311", "1111", "311"])
			}; /*7223*/
			$1.versions = _h; /*7225*/
			var _k = $get($1.versions, $1.version) !== undefined; /*7226*/
			if (!_k) { /*7228*/
				$k[$j++] = "bwipp.code2of5badVersion"; /*7227*/
				$k[$j++] = "Unrecognised Code 25 version"; /*7227*/
				$0.raiseerror(); /*7227*/
			} /*7227*/
			$1.encs = $get($1.versions, $1.version); /*7229*/
			$1.cs = $get($1.encs, 0).length; /*7231*/
			$k[$j++] = "cw"; /*7232*/
			$k[$j++] = 0; /*7232*/
			$forall($get($1.encs, 0), function() { /*7232*/
				var _s = $k[--$j]; /*7232*/
				var _t = $k[--$j]; /*7232*/
				$k[$j++] = _t + (_s - 48); /*7232*/
			}); /*7232*/
			var _u = $k[--$j]; /*7232*/
			$1[$k[--$j]] = _u; /*7232*/
			var _w = $1.encs; /*7233*/
			$1.ss = $get(_w, _w.length - 2).length; /*7233*/
			var _y = $1.encs; /*7234*/
			$k[$j++] = "sw"; /*7234*/
			$k[$j++] = 0; /*7234*/
			$forall($get(_y, _y.length - 2), function() { /*7234*/
				var _10 = $k[--$j]; /*7234*/
				var _11 = $k[--$j]; /*7234*/
				$k[$j++] = _11 + (_10 - 48); /*7234*/
			}); /*7234*/
			var _12 = $k[--$j]; /*7234*/
			$1[$k[--$j]] = _12; /*7234*/
			$1.barchars = "0123456789"; /*7237*/
			$k[$j++] = "sbs"; /*7239*/
			$k[$j++] = $1.barlen; /*7239*/
			if ($1.includecheck) { /*7239*/
				var _16 = $k[--$j]; /*7239*/
				$k[$j++] = _16 + 1; /*7239*/
			} /*7239*/
			var _1B = $s((($k[--$j] * $1.cs) + $1.ss) + $1.ss); /*7239*/
			$1[$k[--$j]] = _1B; /*7239*/
			$k[$j++] = "txt"; /*7240*/
			$k[$j++] = $1.barlen; /*7240*/
			if ($1.includecheck) { /*7240*/
				var _1F = $k[--$j]; /*7240*/
				$k[$j++] = _1F + 1; /*7240*/
			} /*7240*/
			var _1H = $a($k[--$j]); /*7240*/
			$1[$k[--$j]] = _1H; /*7240*/
			$puti($1.sbs, 0, $get($1.encs, 10)); /*7243*/
			for (var _1O = 0, _1N = $1.barlen - 1; _1O <= _1N; _1O += 1) { /*7254*/
				$1.i = _1O; /*7245*/
				$search($1.barchars, $geti($1.barcode, $1.i, 1)); /*7247*/
				$j--; /*7248*/
				$1.indx = $k[--$j].length; /*7249*/
				$j -= 2; /*7250*/
				$1.enc = $get($1.encs, $1.indx); /*7251*/
				$puti($1.sbs, ($1.i * $1.cs) + $1.ss, $1.enc); /*7252*/
				$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), ($1.i * $1.cw) + $1.sw, $1.textyoffset, $1.textfont, $1.textsize])); /*7253*/
			} /*7253*/
			if ($1.includecheck) { /*7266*/
				$puti($1.sbs, ($1.barlen * $1.cs) + $1.ss, $get($1.encs, $1.checksum)); /*7258*/
				$puti($1.sbs, (($1.barlen * $1.cs) + $1.cs) + $1.ss, $get($1.encs, 11)); /*7259*/
				if ($1.includecheckintext) { /*7263*/
					$put($1.txt, $1.barlen, $a([$geti($1.barchars, $1.checksum, 1), ($1.barlen * $1.cw) + $1.sw, $1.textyoffset, $1.textfont, $1.textsize])); /*7261*/
				} else { /*7263*/
					$put($1.txt, $1.barlen, $a([" ", ($1.barlen * $1.cw) + $1.sw, $1.textyoffset, $1.textfont, $1.textsize])); /*7263*/
				} /*7263*/
			} else { /*7266*/
				$puti($1.sbs, ($1.barlen * $1.cs) + $1.ss, $get($1.encs, 11)); /*7266*/
			} /*7266*/
			$k[$j++] = Infinity; /*7278*/
			$k[$j++] = "ren"; /*7273*/
			$k[$j++] = $0.renlinear; /*7273*/
			$k[$j++] = "sbs"; /*7273*/
			$k[$j++] = Infinity; /*7273*/
			$forall($1.sbs, function() { /*7272*/
				var _2W = $k[--$j]; /*7272*/
				$k[$j++] = _2W - 48; /*7272*/
			}); /*7272*/
			var _2X = $a(); /*7273*/
			$k[$j++] = _2X; /*7274*/
			$k[$j++] = "bhs"; /*7274*/
			$k[$j++] = Infinity; /*7274*/
			for (var _2Z = 0, _2a = ~~(($1.sbs.length + 1) / 2); _2Z < _2a; _2Z++) { /*7273*/
				$k[$j++] = $1.height; /*7273*/
			} /*7273*/
			var _2c = $a(); /*7274*/
			$k[$j++] = _2c; /*7275*/
			$k[$j++] = "bbs"; /*7275*/
			$k[$j++] = Infinity; /*7275*/
			for (var _2e = 0, _2f = ~~(($1.sbs.length + 1) / 2); _2e < _2f; _2e++) { /*7274*/
				$k[$j++] = 0; /*7274*/
			} /*7274*/
			var _2g = $a(); /*7275*/
			$k[$j++] = _2g; /*7277*/
			if ($1.includetext) { /*7277*/
				$k[$j++] = "txt"; /*7276*/
				$k[$j++] = $1.txt; /*7276*/
			} /*7276*/
			$k[$j++] = "opt"; /*7278*/
			$k[$j++] = $1.options; /*7278*/
			var _2k = $d(); /*7278*/
			$k[$j++] = _2k; /*7281*/
			if (!$1.dontdraw) { /*7281*/
				$0.renlinear(); /*7281*/
			} /*7281*/
		};
		$0.industrial2of5 = function() {
			var $1 = {}; /*7309*/
			$1.options = $k[--$j]; /*7311*/
			$1.barcode = $k[--$j]; /*7312*/
			$1.dontdraw = false; /*7314*/
			$1.includetext = false; /*7315*/
			$1.textfont = "Courier"; /*7316*/
			$1.textsize = 10; /*7317*/
			$1.textxoffset = 0; /*7318*/
			$1.textyoffset = -8.5; /*7319*/
			$1.height = 1; /*7320*/
			$forall($1.options, function() { /*7331*/
				var _3 = $k[--$j]; /*7331*/
				$1[$k[--$j]] = _3; /*7331*/
			}); /*7331*/
			$1.textfont = "" + $1.textfont; /*7333*/
			$1.textsize = +$1.textsize; /*7334*/
			$1.textxoffset = +$1.textxoffset; /*7335*/
			$1.textyoffset = +$1.textyoffset; /*7336*/
			$1.height = +$1.height; /*7337*/
			$1.options.dontdraw = true; /*7340*/
			$1.options.version = "industrial"; /*7341*/
			$k[$j++] = "args"; /*7343*/
			$k[$j++] = $1.barcode; /*7343*/
			$k[$j++] = $1.options; /*7343*/
			$0.code2of5(); /*7343*/
			var _E = $k[--$j]; /*7343*/
			$1[$k[--$j]] = _E; /*7343*/
			$1.args.opt = $1.options; /*7345*/
			$k[$j++] = $1.args; /*7348*/
			if (!$1.dontdraw) { /*7348*/
				$0.renlinear(); /*7348*/
			} /*7348*/
		};
		$0.iata2of5 = function() {
			var $1 = {}; /*7376*/
			$1.options = $k[--$j]; /*7378*/
			$1.barcode = $k[--$j]; /*7379*/
			$1.dontdraw = false; /*7381*/
			$1.includetext = false; /*7382*/
			$1.textfont = "Courier"; /*7383*/
			$1.textsize = 10; /*7384*/
			$1.textxoffset = 0; /*7385*/
			$1.textyoffset = -8.5; /*7386*/
			$1.height = 1; /*7387*/
			$forall($1.options, function() { /*7398*/
				var _3 = $k[--$j]; /*7398*/
				$1[$k[--$j]] = _3; /*7398*/
			}); /*7398*/
			$1.textfont = "" + $1.textfont; /*7400*/
			$1.textsize = +$1.textsize; /*7401*/
			$1.textxoffset = +$1.textxoffset; /*7402*/
			$1.textyoffset = +$1.textyoffset; /*7403*/
			$1.height = +$1.height; /*7404*/
			$1.options.dontdraw = true; /*7407*/
			$1.options.version = "iata"; /*7408*/
			$k[$j++] = "args"; /*7410*/
			$k[$j++] = $1.barcode; /*7410*/
			$k[$j++] = $1.options; /*7410*/
			$0.code2of5(); /*7410*/
			var _E = $k[--$j]; /*7410*/
			$1[$k[--$j]] = _E; /*7410*/
			$1.args.opt = $1.options; /*7412*/
			$k[$j++] = $1.args; /*7415*/
			if (!$1.dontdraw) { /*7415*/
				$0.renlinear(); /*7415*/
			} /*7415*/
		};
		$0.matrix2of5 = function() {
			var $1 = {}; /*7443*/
			$1.options = $k[--$j]; /*7445*/
			$1.barcode = $k[--$j]; /*7446*/
			$1.dontdraw = false; /*7448*/
			$1.includetext = false; /*7449*/
			$1.textfont = "Courier"; /*7450*/
			$1.textsize = 10; /*7451*/
			$1.textxoffset = 0; /*7452*/
			$1.textyoffset = -8.5; /*7453*/
			$1.height = 1; /*7454*/
			$forall($1.options, function() { /*7465*/
				var _3 = $k[--$j]; /*7465*/
				$1[$k[--$j]] = _3; /*7465*/
			}); /*7465*/
			$1.textfont = "" + $1.textfont; /*7467*/
			$1.textsize = +$1.textsize; /*7468*/
			$1.textxoffset = +$1.textxoffset; /*7469*/
			$1.textyoffset = +$1.textyoffset; /*7470*/
			$1.height = +$1.height; /*7471*/
			$1.options.dontdraw = true; /*7474*/
			$1.options.version = "matrix"; /*7475*/
			$k[$j++] = "args"; /*7477*/
			$k[$j++] = $1.barcode; /*7477*/
			$k[$j++] = $1.options; /*7477*/
			$0.code2of5(); /*7477*/
			var _E = $k[--$j]; /*7477*/
			$1[$k[--$j]] = _E; /*7477*/
			$1.args.opt = $1.options; /*7479*/
			$k[$j++] = $1.args; /*7482*/
			if (!$1.dontdraw) { /*7482*/
				$0.renlinear(); /*7482*/
			} /*7482*/
		};
		$0.coop2of5 = function() {
			var $1 = {}; /*7510*/
			$1.options = $k[--$j]; /*7512*/
			$1.barcode = $k[--$j]; /*7513*/
			$1.dontdraw = false; /*7515*/
			$1.includetext = false; /*7516*/
			$1.textfont = "Courier"; /*7517*/
			$1.textsize = 10; /*7518*/
			$1.textxoffset = 0; /*7519*/
			$1.textyoffset = -8.5; /*7520*/
			$1.height = 1; /*7521*/
			$forall($1.options, function() { /*7532*/
				var _3 = $k[--$j]; /*7532*/
				$1[$k[--$j]] = _3; /*7532*/
			}); /*7532*/
			$1.textfont = "" + $1.textfont; /*7534*/
			$1.textsize = +$1.textsize; /*7535*/
			$1.textxoffset = +$1.textxoffset; /*7536*/
			$1.textyoffset = +$1.textyoffset; /*7537*/
			$1.height = +$1.height; /*7538*/
			$1.options.dontdraw = true; /*7541*/
			$1.options.version = "coop"; /*7542*/
			$k[$j++] = "args"; /*7544*/
			$k[$j++] = $1.barcode; /*7544*/
			$k[$j++] = $1.options; /*7544*/
			$0.code2of5(); /*7544*/
			var _E = $k[--$j]; /*7544*/
			$1[$k[--$j]] = _E; /*7544*/
			$1.args.opt = $1.options; /*7546*/
			$k[$j++] = $1.args; /*7549*/
			if (!$1.dontdraw) { /*7549*/
				$0.renlinear(); /*7549*/
			} /*7549*/
		};
		$0.datalogic2of5 = function() {
			var $1 = {}; /*7577*/
			$1.options = $k[--$j]; /*7579*/
			$1.barcode = $k[--$j]; /*7580*/
			$1.dontdraw = false; /*7582*/
			$1.includetext = false; /*7583*/
			$1.textfont = "Courier"; /*7584*/
			$1.textsize = 10; /*7585*/
			$1.textxoffset = 0; /*7586*/
			$1.textyoffset = -8.5; /*7587*/
			$1.height = 1; /*7588*/
			$forall($1.options, function() { /*7599*/
				var _3 = $k[--$j]; /*7599*/
				$1[$k[--$j]] = _3; /*7599*/
			}); /*7599*/
			$1.textfont = "" + $1.textfont; /*7601*/
			$1.textsize = +$1.textsize; /*7602*/
			$1.textxoffset = +$1.textxoffset; /*7603*/
			$1.textyoffset = +$1.textyoffset; /*7604*/
			$1.height = +$1.height; /*7605*/
			$1.options.dontdraw = true; /*7608*/
			$1.options.version = "datalogic"; /*7609*/
			$k[$j++] = "args"; /*7611*/
			$k[$j++] = $1.barcode; /*7611*/
			$k[$j++] = $1.options; /*7611*/
			$0.code2of5(); /*7611*/
			var _E = $k[--$j]; /*7611*/
			$1[$k[--$j]] = _E; /*7611*/
			$1.args.opt = $1.options; /*7613*/
			$k[$j++] = $1.args; /*7616*/
			if (!$1.dontdraw) { /*7616*/
				$0.renlinear(); /*7616*/
			} /*7616*/
		};
		$0.code11 = function() {
			var $1 = {}; /*7643*/
			$1.options = $k[--$j]; /*7645*/
			$1.barcode = $k[--$j]; /*7646*/
			$1.dontdraw = false; /*7648*/
			$1.includecheck = false; /*7649*/
			$1.validatecheck = false; /*7650*/
			$1.includetext = false; /*7651*/
			$1.includecheckintext = false; /*7652*/
			$1.textfont = "Courier"; /*7653*/
			$1.textsize = 10; /*7654*/
			$1.textyoffset = -8.5; /*7655*/
			$1.height = 1; /*7656*/
			$forall($1.options, function() { /*7667*/
				var _3 = $k[--$j]; /*7667*/
				$1[$k[--$j]] = _3; /*7667*/
			}); /*7667*/
			$1.textfont = "" + $1.textfont; /*7669*/
			$1.textsize = +$1.textsize; /*7670*/
			$1.textyoffset = +$1.textyoffset; /*7671*/
			$1.height = +$1.height; /*7672*/
			$1.encs = $a(["111131", "311131", "131131", "331111", "113131", "313111", "133111", "111331", "311311", "311111", "113111", "113311"]); /*7679*/
			$1.barchars = "0123456789-"; /*7682*/
			$1.charvals = {}; /*7683*/
			for (var _A = 0; _A <= 10; _A += 1) { /*7684*/
				$put($1.charvals, $geti($1.barchars, _A, 1), _A); /*7684*/
			} /*7684*/
			for (var _G = 0, _F = $1.barcode.length - 1; _G <= _F; _G += 1) { /*7691*/
				var _K = $get($1.charvals, $geti($1.barcode, _G, 1)) !== undefined; /*7688*/
				if (!_K) { /*7690*/
					$k[$j++] = "bwipp.code11badCharacter"; /*7689*/
					$k[$j++] = "Code 11 must contain only digits and dashes"; /*7689*/
					$0.raiseerror(); /*7689*/
				} /*7689*/
			} /*7689*/
			$1.barlen = $1.barcode.length; /*7693*/
			if ($1.validatecheck) { /*7699*/
				if ($1.barlen == 11) { /*7697*/
					$k[$j++] = "bwipp.code11badLength"; /*7696*/
					$k[$j++] = "Code 11 cannot be 11 characters using check digits"; /*7696*/
					$0.raiseerror(); /*7696*/
				} /*7696*/
				var _Q = ($1.barlen <= 10) ? 1 : 2; /*7698*/
				$1.barlen = $1.barlen - _Q; /*7698*/
			} /*7698*/
			$k[$j++] = "numchecks"; /*7701*/
			if ($1.includecheck || $1.validatecheck) { /*7701*/
				var _U = ($1.barlen >= 10) ? 2 : 1; /*7701*/
				$k[$j++] = _U; /*7701*/
			} else { /*7701*/
				$k[$j++] = 0; /*7701*/
			} /*7701*/
			var _V = $k[--$j]; /*7701*/
			$1[$k[--$j]] = _V; /*7701*/
			$1.checksum1 = 0; /*7702*/
			$1.checksum2 = 0; /*7702*/
			for (var _Z = 0, _Y = $1.barlen - 1; _Z <= _Y; _Z += 1) { /*7708*/
				$1.i = _Z; /*7704*/
				$1.indx = $get($1.charvals, $geti($1.barcode, $1.i, 1)); /*7705*/
				$1.checksum1 = $1.checksum1 + ((((($1.barlen - $1.i) - 1) % 10) + 1) * $1.indx); /*7706*/
				$1.checksum2 = $1.checksum2 + (((($1.barlen - $1.i) % 9) + 1) * $1.indx); /*7707*/
			} /*7707*/
			$1.checksum1 = $1.checksum1 % 11; /*7709*/
			$1.checksum2 = ($1.checksum2 + $1.checksum1) % 11; /*7710*/
			if ($1.validatecheck) { /*7724*/
				if ($1.numchecks == 1) { /*7719*/
					if ($get($1.barcode, $1.barlen) != $get($1.barchars, $1.checksum1)) { /*7715*/
						$k[$j++] = "bwipp.code11badCheckDigit"; /*7714*/
						$k[$j++] = "Incorrect Code 11 check digit provided"; /*7714*/
						$0.raiseerror(); /*7714*/
					} /*7714*/
				} else { /*7719*/
					if (($get($1.barcode, $1.barlen) != $get($1.barchars, $1.checksum1)) || ($get($1.barcode, $1.barlen + 1) != $get($1.barchars, $1.checksum2))) { /*7720*/
						$k[$j++] = "bwipp.code11badCheckDigits"; /*7719*/
						$k[$j++] = "Incorrect Code 11 check digits provided"; /*7719*/
						$0.raiseerror(); /*7719*/
					} /*7719*/
				} /*7719*/
				$1.barcode = $geti($1.barcode, 0, $1.barlen); /*7722*/
				$1.includecheck = true; /*7723*/
			} /*7723*/
			$1.sbs = $s((($1.barlen + $1.numchecks) * 6) + 12); /*7726*/
			$1.txt = $a($1.barlen + $1.numchecks); /*7727*/
			$puti($1.sbs, 0, $get($1.encs, 11)); /*7730*/
			$1.xpos = 8; /*7732*/
			for (var _1O = 0, _1N = $1.barlen - 1; _1O <= _1N; _1O += 1) { /*7742*/
				$1.i = _1O; /*7734*/
				$1.indx = $get($1.charvals, $geti($1.barcode, $1.i, 1)); /*7735*/
				$1.enc = $get($1.encs, $1.indx); /*7736*/
				$puti($1.sbs, ($1.i * 6) + 6, $1.enc); /*7737*/
				$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), $1.xpos, $1.textyoffset, $1.textfont, $1.textsize])); /*7738*/
				for (var _1k = 0; _1k <= 5; _1k += 1) { /*7741*/
					$1.xpos = ($get($1.enc, _1k) - 48) + $1.xpos; /*7740*/
				} /*7740*/
			} /*7740*/
			if ($1.includecheck) { /*7771*/
				if ($1.barlen >= 10) { /*7768*/
					$puti($1.sbs, ($1.barlen * 6) + 6, $get($1.encs, $1.checksum1)); /*7747*/
					$puti($1.sbs, ($1.barlen * 6) + 12, $get($1.encs, $1.checksum2)); /*7748*/
					if ($1.includecheckintext) { /*7758*/
						$put($1.txt, $1.barlen, $a([$geti($1.barchars, $1.checksum1, 1), $1.xpos, $1.textyoffset, $1.textfont, $1.textsize])); /*7750*/
						$1.enc = $get($1.encs, $1.checksum1); /*7751*/
						for (var _2E = 0; _2E <= 5; _2E += 1) { /*7754*/
							$1.xpos = ($get($1.enc, _2E) - 48) + $1.xpos; /*7753*/
						} /*7753*/
						$put($1.txt, $1.barlen + 1, $a([$geti($1.barchars, $1.checksum2, 1), $1.xpos, $1.textyoffset, $1.textfont, $1.textsize])); /*7755*/
					} else { /*7758*/
						$put($1.txt, $1.barlen, $a(["", $1.xpos, $1.textyoffset, $1.textfont, $1.textsize])); /*7757*/
						$put($1.txt, $1.barlen + 1, $a(["", $1.xpos, $1.textyoffset, $1.textfont, $1.textsize])); /*7758*/
					} /*7758*/
					$puti($1.sbs, ($1.barlen * 6) + 18, $get($1.encs, 11)); /*7760*/
				} else { /*7768*/
					$puti($1.sbs, ($1.barlen * 6) + 6, $get($1.encs, $1.checksum1)); /*7762*/
					if ($1.includecheckintext) { /*7766*/
						$put($1.txt, $1.barlen, $a([$geti($1.barchars, $1.checksum1, 1), $1.xpos, $1.textyoffset, $1.textfont, $1.textsize])); /*7764*/
					} else { /*7766*/
						$put($1.txt, $1.barlen, $a(["", $1.xpos, $1.textyoffset, $1.textfont, $1.textsize])); /*7766*/
					} /*7766*/
					$puti($1.sbs, ($1.barlen * 6) + 12, $get($1.encs, 11)); /*7768*/
				} /*7768*/
			} else { /*7771*/
				$puti($1.sbs, ($1.barlen * 6) + 6, $get($1.encs, 11)); /*7771*/
			} /*7771*/
			$k[$j++] = Infinity; /*7783*/
			$k[$j++] = "ren"; /*7778*/
			$k[$j++] = $0.renlinear; /*7778*/
			$k[$j++] = "sbs"; /*7778*/
			$k[$j++] = Infinity; /*7778*/
			var _3F = $1.sbs; /*7777*/
			for (var _3G = 0, _3H = _3F.length; _3G < _3H; _3G++) { /*7777*/
				$k[$j++] = $get(_3F, _3G) - 48; /*7777*/
			} /*7777*/
			var _3J = $a(); /*7778*/
			$k[$j++] = _3J; /*7779*/
			$k[$j++] = "bhs"; /*7779*/
			$k[$j++] = Infinity; /*7779*/
			for (var _3L = 0, _3M = ~~(($1.sbs.length + 1) / 2); _3L < _3M; _3L++) { /*7778*/
				$k[$j++] = $1.height; /*7778*/
			} /*7778*/
			var _3O = $a(); /*7779*/
			$k[$j++] = _3O; /*7780*/
			$k[$j++] = "bbs"; /*7780*/
			$k[$j++] = Infinity; /*7780*/
			for (var _3Q = 0, _3R = ~~(($1.sbs.length + 1) / 2); _3Q < _3R; _3Q++) { /*7779*/
				$k[$j++] = 0; /*7779*/
			} /*7779*/
			var _3S = $a(); /*7780*/
			$k[$j++] = _3S; /*7782*/
			if ($1.includetext) { /*7782*/
				$k[$j++] = "txt"; /*7781*/
				$k[$j++] = $1.txt; /*7781*/
			} /*7781*/
			$k[$j++] = "opt"; /*7783*/
			$k[$j++] = $1.options; /*7783*/
			var _3W = $d(); /*7783*/
			$k[$j++] = _3W; /*7786*/
			if (!$1.dontdraw) { /*7786*/
				$0.renlinear(); /*7786*/
			} /*7786*/
		};
		$0.bc412 = function() {
			var $1 = {}; /*7813*/
			$1.options = $k[--$j]; /*7815*/
			$1.barcode = $k[--$j]; /*7816*/
			$1.dontdraw = false; /*7818*/
			$1.includecheck = false; /*7819*/
			$1.validatecheck = false; /*7820*/
			$1.includetext = false; /*7821*/
			$1.includecheckintext = false; /*7822*/
			$1.includestartstop = false; /*7823*/
			$1.semi = false; /*7824*/
			$1.textfont = "Courier"; /*7825*/
			$1.textsize = 10; /*7826*/
			$1.textyoffset = -8.5; /*7827*/
			$1.height = 1; /*7828*/
			$forall($1.options, function() { /*7839*/
				var _3 = $k[--$j]; /*7839*/
				$1[$k[--$j]] = _3; /*7839*/
			}); /*7839*/
			$1.textfont = "" + $1.textfont; /*7841*/
			$1.textsize = +$1.textsize; /*7842*/
			$1.textyoffset = +$1.textyoffset; /*7843*/
			$1.height = +$1.height; /*7844*/
			if ($1.semi) { /*7849*/
				$1.includecheck = true; /*7847*/
				$1.includestartstop = true; /*7848*/
			} /*7848*/
			$1.barchars = "0R9GLVHA8EZ4NTS1J2Q6C7DYKBUIX3FWP5M"; /*7852*/
			$1.charvals = {}; /*7853*/
			for (var _A = 0; _A <= 34; _A += 1) { /*7854*/
				$put($1.charvals, $geti($1.barchars, _A, 1), _A); /*7854*/
			} /*7854*/
			for (var _G = 0, _F = $1.barcode.length - 1; _G <= _F; _G += 1) { /*7861*/
				var _K = $get($1.charvals, $geti($1.barcode, _G, 1)) !== undefined; /*7858*/
				if (!_K) { /*7860*/
					$k[$j++] = "bwipp.bc412badCharacter"; /*7859*/
					$k[$j++] = "BC412 must contain only digits and capital letters except O"; /*7859*/
					$0.raiseerror(); /*7859*/
				} /*7859*/
			} /*7859*/
			$k[$j++] = "barlen"; /*7863*/
			$k[$j++] = $1.barcode.length; /*7863*/
			if ($1.validatecheck) { /*7863*/
				var _N = $k[--$j]; /*7863*/
				$k[$j++] = _N - 1; /*7863*/
			} /*7863*/
			var _O = $k[--$j]; /*7863*/
			$1[$k[--$j]] = _O; /*7863*/
			$1.checksum = 0; /*7865*/
			for (var _S = 0, _R = $1.barlen - 1; _S <= _R; _S += 1) { /*7869*/
				$1.checksum = $get($1.charvals, $geti($1.barcode, _S, 1)) + $1.checksum; /*7868*/
			} /*7868*/
			$1.checksum = $1.checksum % 35; /*7870*/
			if ($1.validatecheck) { /*7877*/
				if ($get($1.barcode, $1.barlen) != $get($1.barchars, $1.checksum)) { /*7874*/
					$k[$j++] = "bwipp.bc412badCheckDigit"; /*7873*/
					$k[$j++] = "Incorrect BC412 check digit provided"; /*7873*/
					$0.raiseerror(); /*7873*/
				} /*7873*/
				$1.barcode = $geti($1.barcode, 0, $1.barlen); /*7875*/
				$1.includecheck = true; /*7876*/
			} /*7876*/
			$1.encs = $a(["11111115", "13111212", "11131113", "12111213", "12121311", "13131111", "12111312", "11131212", "11121411", "11151111", "15111111", "11111511", "12131211", "13121112", "13111212", "11111214", "12121113", "11111313", "13111113", "11121213", "11141112", "11121312", "11141211", "14121111", "12121212", "11131311", "13121211", "12111411", "14111211", "11111412", "12111114", "14111112", "12141111", "11121114", "12131112", "12", "111"]); /*7889*/
			$1.sbs = $s((($1.barlen + 1) * 8) + 5); /*7891*/
			if ($1.includecheck) { /*7895*/
				$1.txt = $a($1.barlen + 1); /*7893*/
			} else { /*7895*/
				$1.txt = $a($1.barlen); /*7895*/
			} /*7895*/
			if ($1.includestartstop) { /*7905*/
				$puti($1.sbs, 0, $get($1.encs, 35)); /*7900*/
				$1.pos = 2; /*7901*/
				$1.txtpos = 3; /*7902*/
			} else { /*7905*/
				$1.pos = 0; /*7904*/
				$1.txtpos = 0; /*7905*/
			} /*7905*/
			for (var _x = 0, _w = $1.barlen - 1; _x <= _w; _x += 1) { /*7914*/
				$1.i = _x; /*7909*/
				$1.indx = $get($1.charvals, $geti($1.barcode, $1.i, 1)); /*7910*/
				$puti($1.sbs, $1.pos, $get($1.encs, $1.indx)); /*7911*/
				$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), ($1.i * 12) + $1.txtpos, $1.textyoffset, $1.textfont, $1.textsize])); /*7912*/
				$1.pos = $1.pos + 8; /*7913*/
			} /*7913*/
			if ($1.includecheck) { /*7925*/
				$puti($1.sbs, $1.pos, $get($1.encs, $1.checksum)); /*7918*/
				if ($1.includecheckintext) { /*7922*/
					$put($1.txt, $1.barlen, $a([$geti($1.barchars, $1.checksum, 1), ($1.barlen * 12) + $1.txtpos, $1.textyoffset, $1.textfont, $1.textsize])); /*7920*/
				} else { /*7922*/
					$put($1.txt, $1.barlen, $a(["", ($1.barlen * 12) + $1.txtpos, $1.textyoffset, $1.textfont, $1.textsize])); /*7922*/
				} /*7922*/
				$1.pos = $1.pos + 8; /*7924*/
			} /*7924*/
			if ($1.includestartstop) { /*7931*/
				$puti($1.sbs, $1.pos, $get($1.encs, 36)); /*7929*/
				$1.pos = $1.pos + 2; /*7930*/
			} /*7930*/
			$1.sbs = $geti($1.sbs, 0, $1.pos); /*7934*/
			$k[$j++] = Infinity; /*7943*/
			$k[$j++] = "ren"; /*7938*/
			$k[$j++] = $0.renlinear; /*7938*/
			$k[$j++] = "sbs"; /*7938*/
			$k[$j++] = Infinity; /*7938*/
			$forall($1.sbs, function() { /*7937*/
				var _1v = $k[--$j]; /*7937*/
				$k[$j++] = _1v - 48; /*7937*/
			}); /*7937*/
			var _1w = $a(); /*7938*/
			$k[$j++] = _1w; /*7939*/
			$k[$j++] = "bhs"; /*7939*/
			$k[$j++] = Infinity; /*7939*/
			for (var _1y = 0, _1z = ~~(($1.sbs.length + 1) / 2); _1y < _1z; _1y++) { /*7938*/
				$k[$j++] = $1.height; /*7938*/
			} /*7938*/
			var _21 = $a(); /*7939*/
			$k[$j++] = _21; /*7940*/
			$k[$j++] = "bbs"; /*7940*/
			$k[$j++] = Infinity; /*7940*/
			for (var _23 = 0, _24 = ~~(($1.sbs.length + 1) / 2); _23 < _24; _23++) { /*7939*/
				$k[$j++] = 0; /*7939*/
			} /*7939*/
			var _25 = $a(); /*7940*/
			$k[$j++] = _25; /*7942*/
			if ($1.includetext) { /*7942*/
				$k[$j++] = "txt"; /*7941*/
				$k[$j++] = $1.txt; /*7941*/
			} /*7941*/
			$k[$j++] = "opt"; /*7943*/
			$k[$j++] = $1.options; /*7943*/
			var _29 = $d(); /*7943*/
			$k[$j++] = _29; /*7946*/
			if (!$1.dontdraw) { /*7946*/
				$0.renlinear(); /*7946*/
			} /*7946*/
		};
		$0.rationalizedCodabar = function() {
			var $1 = {}; /*7973*/
			$1.options = $k[--$j]; /*7975*/
			$1.barcode = $k[--$j]; /*7976*/
			$1.dontdraw = false; /*7978*/
			$1.altstartstop = false; /*7979*/
			$1.includecheck = false; /*7980*/
			$1.validatecheck = false; /*7981*/
			$1.includetext = false; /*7982*/
			$1.includecheckintext = false; /*7983*/
			$1.textfont = "Courier"; /*7984*/
			$1.textsize = 10; /*7985*/
			$1.textyoffset = -8.5; /*7986*/
			$1.height = 1; /*7987*/
			$forall($1.options, function() { /*7998*/
				var _3 = $k[--$j]; /*7998*/
				$1[$k[--$j]] = _3; /*7998*/
			}); /*7998*/
			$1.textfont = "" + $1.textfont; /*8000*/
			$1.textsize = +$1.textsize; /*8001*/
			$1.textyoffset = +$1.textyoffset; /*8002*/
			$1.height = +$1.height; /*8003*/
			$1.encs = $a(["11111331", "11113311", "11131131", "33111111", "11311311", "31111311", "13111131", "13113111", "13311111", "31131111", "11133111", "11331111", "31113131", "31311131", "31313111", "11313131", "11331311", "13131131", "11131331", "11133311"]); /*8011*/
			if ($1.altstartstop) { /*8017*/
				$1.barchars = "0123456789-$:/.+TN*E"; /*8015*/
			} else { /*8017*/
				$1.barchars = "0123456789-$:/.+ABCD"; /*8017*/
			} /*8017*/
			$1.charvals = {}; /*8019*/
			for (var _B = 0; _B <= 19; _B += 1) { /*8020*/
				$put($1.charvals, $geti($1.barchars, _B, 1), _B); /*8020*/
			} /*8020*/
			$1.bodyvals = {}; /*8021*/
			for (var _F = 0; _F <= 15; _F += 1) { /*8022*/
				$put($1.bodyvals, $geti($1.barchars, _F, 1), _F); /*8022*/
			} /*8022*/
			$1.ssvals = {}; /*8023*/
			for (var _J = 16; _J <= 19; _J += 1) { /*8024*/
				$put($1.ssvals, $geti($1.barchars, _J, 1), _J); /*8024*/
			} /*8024*/
			var _Q = $get($1.ssvals, $geti($1.barcode, 0, 1)) !== undefined; /*8027*/
			var _V = $get($1.ssvals, $geti($1.barcode, $1.barcode.length - 1, 1)) !== undefined; /*8028*/
			if ((!_Q) || (!_V)) { /*8034*/
				if ($1.altstartstop) { /*8032*/
					$k[$j++] = "bwipp.rationalizedCodabarBadAltStartStop"; /*8030*/
					$k[$j++] = "Codabar start and stop characters must be one of E N T or *"; /*8030*/
					$0.raiseerror(); /*8030*/
				} else { /*8032*/
					$k[$j++] = "bwipp.rationalizedCodabarBadStartStop"; /*8032*/
					$k[$j++] = "Codabar start and stop characters must be one of A B C or D"; /*8032*/
					$0.raiseerror(); /*8032*/
				} /*8032*/
			} /*8032*/
			for (var _Z = 1, _Y = $1.barcode.length - 2; _Z <= _Y; _Z += 1) { /*8039*/
				var _d = $get($1.bodyvals, $geti($1.barcode, _Z, 1)) !== undefined; /*8036*/
				if (!_d) { /*8038*/
					$k[$j++] = "bwipp.rationalizedCodabarBadCharacter"; /*8037*/
					$k[$j++] = "Codabar body must contain only digits and symbols - $ : / . +"; /*8037*/
					$0.raiseerror(); /*8037*/
				} /*8037*/
			} /*8037*/
			$k[$j++] = "barlen"; /*8041*/
			$k[$j++] = $1.barcode.length; /*8041*/
			if ($1.validatecheck) { /*8041*/
				var _g = $k[--$j]; /*8041*/
				$k[$j++] = _g - 1; /*8041*/
			} /*8041*/
			var _h = $k[--$j]; /*8041*/
			$1[$k[--$j]] = _h; /*8041*/
			$1.checksum = 0; /*8043*/
			for (var _l = 0, _k = $1.barlen - 2; _l <= _k; _l += 1) { /*8047*/
				$1.checksum = $get($1.charvals, $geti($1.barcode, _l, 1)) + $1.checksum; /*8046*/
			} /*8046*/
			$1.checksum = $get($1.charvals, $geti($1.barcode, $1.barcode.length - 1, 1)) + $1.checksum; /*8049*/
			$1.checksum = (16 - ($1.checksum % 16)) % 16; /*8050*/
			if ($1.validatecheck) { /*8060*/
				if ($get($1.barcode, $1.barlen - 1) != $get($1.barchars, $1.checksum)) { /*8054*/
					$k[$j++] = "bwipp.rationalizedCodabarBadCheckDigit"; /*8053*/
					$k[$j++] = "Incorrect Codabar check digit provided"; /*8053*/
					$0.raiseerror(); /*8053*/
				} /*8053*/
				var _16 = $s($1.barlen); /*8055*/
				$puti(_16, 0, $geti($1.barcode, 0, $1.barlen - 1)); /*8056*/
				$puti(_16, $1.barlen - 1, $geti($1.barcode, $1.barlen, 1)); /*8057*/
				$1.barcode = _16; /*8058*/
				$1.includecheck = true; /*8059*/
			} /*8059*/
			$k[$j++] = "sbs"; /*8062*/
			$k[$j++] = $1.barlen; /*8062*/
			if ($1.includecheck) { /*8062*/
				var _1G = $k[--$j]; /*8062*/
				$k[$j++] = _1G + 1; /*8062*/
			} /*8062*/
			var _1I = $s($k[--$j] * 8); /*8062*/
			$1[$k[--$j]] = _1I; /*8062*/
			$k[$j++] = "txt"; /*8063*/
			$k[$j++] = $1.barlen; /*8063*/
			if ($1.includecheck) { /*8063*/
				var _1M = $k[--$j]; /*8063*/
				$k[$j++] = _1M + 1; /*8063*/
			} /*8063*/
			var _1O = $a($k[--$j]); /*8063*/
			$1[$k[--$j]] = _1O; /*8063*/
			$1.xpos = 0; /*8065*/
			for (var _1S = 0, _1R = $1.barlen - 2; _1S <= _1R; _1S += 1) { /*8075*/
				$1.i = _1S; /*8067*/
				$1.indx = $get($1.charvals, $geti($1.barcode, $1.i, 1)); /*8068*/
				$1.enc = $get($1.encs, $1.indx); /*8069*/
				$puti($1.sbs, $1.i * 8, $1.enc); /*8070*/
				$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), $1.xpos, $1.textyoffset, $1.textfont, $1.textsize])); /*8071*/
				for (var _1o = 0; _1o <= 7; _1o += 1) { /*8074*/
					$1.xpos = ($get($1.enc, _1o) - 48) + $1.xpos; /*8073*/
				} /*8073*/
			} /*8073*/
			if ($1.includecheck) { /*8099*/
				$puti($1.sbs, ($1.barlen * 8) - 8, $get($1.encs, $1.checksum)); /*8080*/
				if ($1.includecheckintext) { /*8084*/
					$put($1.txt, $1.barlen - 1, $a([$geti($1.barchars, $1.checksum, 1), $1.xpos, $1.textyoffset, $1.textfont, $1.textsize])); /*8082*/
				} else { /*8084*/
					$put($1.txt, $1.barlen - 1, $a([" ", $1.xpos, $1.textyoffset, $1.textfont, $1.textsize])); /*8084*/
				} /*8084*/
				for (var _2G = 0; _2G <= 7; _2G += 1) { /*8088*/
					$1.xpos = ($get($get($1.encs, $1.checksum), _2G) - 48) + $1.xpos; /*8087*/
				} /*8087*/
				$1.indx = $get($1.charvals, $geti($1.barcode, $1.barlen - 1, 1)); /*8090*/
				$1.enc = $get($1.encs, $1.indx); /*8091*/
				$puti($1.sbs, $1.barlen * 8, $1.enc); /*8092*/
				$put($1.txt, $1.barlen, $a([$geti($1.barcode, $1.barlen - 1, 1), $1.xpos, $1.textyoffset, $1.textfont, $1.textsize])); /*8093*/
			} else { /*8099*/
				$1.indx = $get($1.charvals, $geti($1.barcode, $1.barlen - 1, 1)); /*8096*/
				$1.enc = $get($1.encs, $1.indx); /*8097*/
				$puti($1.sbs, ($1.barlen * 8) - 8, $1.enc); /*8098*/
				$put($1.txt, $1.barlen - 1, $a([$geti($1.barcode, $1.barlen - 1, 1), $1.xpos, $1.textyoffset, $1.textfont, $1.textsize])); /*8099*/
			} /*8099*/
			$k[$j++] = Infinity; /*8111*/
			$k[$j++] = "ren"; /*8106*/
			$k[$j++] = $0.renlinear; /*8106*/
			$k[$j++] = "sbs"; /*8106*/
			$k[$j++] = Infinity; /*8106*/
			$forall($1.sbs, function() { /*8105*/
				var _33 = $k[--$j]; /*8105*/
				$k[$j++] = _33 - 48; /*8105*/
			}); /*8105*/
			var _34 = $a(); /*8106*/
			$k[$j++] = _34; /*8107*/
			$k[$j++] = "bhs"; /*8107*/
			$k[$j++] = Infinity; /*8107*/
			for (var _36 = 0, _37 = ~~(($1.sbs.length + 1) / 2); _36 < _37; _36++) { /*8106*/
				$k[$j++] = $1.height; /*8106*/
			} /*8106*/
			var _39 = $a(); /*8107*/
			$k[$j++] = _39; /*8108*/
			$k[$j++] = "bbs"; /*8108*/
			$k[$j++] = Infinity; /*8108*/
			for (var _3B = 0, _3C = ~~(($1.sbs.length + 1) / 2); _3B < _3C; _3B++) { /*8107*/
				$k[$j++] = 0; /*8107*/
			} /*8107*/
			var _3D = $a(); /*8108*/
			$k[$j++] = _3D; /*8110*/
			if ($1.includetext) { /*8110*/
				$k[$j++] = "txt"; /*8109*/
				$k[$j++] = $1.txt; /*8109*/
			} /*8109*/
			$k[$j++] = "opt"; /*8111*/
			$k[$j++] = $1.options; /*8111*/
			var _3H = $d(); /*8111*/
			$k[$j++] = _3H; /*8114*/
			if (!$1.dontdraw) { /*8114*/
				$0.renlinear(); /*8114*/
			} /*8114*/
		};
		$0.onecode = function() {
			var $1 = {}; /*8141*/
			$1.options = $k[--$j]; /*8143*/
			$1.barcode = $k[--$j]; /*8144*/
			$1.dontdraw = false; /*8146*/
			$1.height = 0.15; /*8147*/
			$forall($1.options, function() { /*8158*/
				var _3 = $k[--$j]; /*8158*/
				$1[$k[--$j]] = _3; /*8158*/
			}); /*8158*/
			$1.height = +$1.height; /*8160*/
			$1.barlen = $1.barcode.length; /*8162*/
			$k[$j++] = "txtdict"; /*8171*/
			$k[$j++] = Infinity; /*8171*/
			var _9 = $eq($geti($1.barcode, 5, 1), "9") ? 14 : 11; /*8168*/
			$k[$j++] = 2; /*8171*/
			$k[$j++] = 2; /*8171*/
			$k[$j++] = 5; /*8171*/
			$k[$j++] = 5; /*8171*/
			$k[$j++] = _9; /*8171*/
			$k[$j++] = _9; /*8171*/
			$k[$j++] = 20; /*8171*/
			$k[$j++] = 20; /*8171*/
			$k[$j++] = 25; /*8171*/
			$k[$j++] = 25; /*8171*/
			$k[$j++] = 29; /*8171*/
			$k[$j++] = 29; /*8171*/
			var _A = $d(); /*8171*/
			$1[$k[--$j]] = _A; /*8172*/
			$1.txt = $a($1.barlen + 6); /*8173*/
			$1.spacecnt = 0; /*8174*/
			for (var _G = 0, _F = $1.barlen - 1; _G <= _F; _G += 1) { /*8182*/
				$1.i = _G; /*8176*/
				var _J = $get($1.txtdict, $1.i) !== undefined; /*8177*/
				if (_J) { /*8180*/
					$put($1.txt, $1.i + $1.spacecnt, $a([" ", 0, 0, "", 0])); /*8178*/
					$1.spacecnt = $1.spacecnt + 1; /*8179*/
				} /*8179*/
				$put($1.txt, $1.i + $1.spacecnt, $a([$geti($1.barcode, $1.i, 1), 0, 0, "", 0])); /*8181*/
			} /*8181*/
			$1.txt = $geti($1.txt, 0, $1.barcode.length + $1.spacecnt); /*8183*/
			$1.normalize = function() {
				$1.base = $k[--$j]; /*8186*/
				$1.num = $k[--$j]; /*8187*/
				for (var _d = $1.num.length - 1; _d >= 1; _d -= 1) { /*8192*/
					$1.i = _d; /*8189*/
					var _e = $1.num; /*8190*/
					var _f = $1.i; /*8190*/
					$put(_e, _f - 1, $get(_e, _f - 1) + (~~($get($1.num, $1.i) / $1.base))); /*8190*/
					$put($1.num, $1.i, $get($1.num, $1.i) % $1.base); /*8191*/
				} /*8191*/
				for (;;) { /*8198*/
					if ($lt($get($1.num, 0), $1.base)) { /*8194*/
						break; /*8194*/
					} /*8194*/
					$k[$j++] = Infinity; /*8195*/
					$k[$j++] = 0; /*8195*/
					$forall($1.num); /*8195*/
					$1.num = $a(); /*8195*/
					$put($1.num, 0, $get($1.num, 0) + (~~($get($1.num, 1) / $1.base))); /*8196*/
					$put($1.num, 1, $get($1.num, 1) % $1.base); /*8197*/
				} /*8197*/
				$k[$j++] = Infinity; /*8200*/
				$1.i = true; /*8200*/
				var _16 = $1.num; /*8200*/
				for (var _17 = 0, _18 = _16.length; _17 < _18; _17++) { /*8200*/
					var _19 = $get(_16, _17); /*8200*/
					$k[$j++] = _19; /*8200*/
					if ((_19 == 0) && $1.i) { /*8200*/
						$j--; /*8200*/
					} else { /*8200*/
						$1.i = false; /*8200*/
					} /*8200*/
				} /*8200*/
				$1.num = $a(); /*8200*/
				if ($1.num.length == 0) { /*8201*/
					$1.num = $a([0]); /*8201*/
				} /*8201*/
				$k[$j++] = $1.num; /*8202*/
			}; /*8203*/
			$1.bigadd = function() {
				var _1F = $k[--$j]; /*8206*/
				var _1G = $k[--$j]; /*8206*/
				$1.offset = Math.abs(_1F.length - _1G.length); /*8207*/
				if (_1F.length < _1G.length) { /*8208*/
					var _ = _1F; /*8208*/
					_1F = _1G; /*8208*/
					_1G = _; /*8208*/
				} /*8208*/
				$1.a = _1F; /*8209*/
				$1.b = _1G; /*8209*/
				for (var _1J = 0, _1I = $1.b.length - 1; _1J <= _1I; _1J += 1) { /*8212*/
					var _1K = $1.a; /*8211*/
					var _1L = $1.offset; /*8211*/
					$put(_1K, _1J + _1L, $get(_1K, _1J + _1L) + $get($1.b, _1J)); /*8211*/
				} /*8211*/
				$k[$j++] = $1.a; /*8213*/
			}; /*8214*/
			if ($1.barlen == 20) { /*8217*/
				$k[$j++] = $a([0]); /*8217*/
			} /*8217*/
			if ($1.barlen == 25) { /*8218*/
				$k[$j++] = $a([1]); /*8218*/
			} /*8218*/
			if ($1.barlen == 29) { /*8219*/
				$k[$j++] = $a([1, 0, 0, 0, 0, 1]); /*8219*/
			} /*8219*/
			if ($1.barlen == 31) { /*8220*/
				$k[$j++] = $a([1, 0, 0, 0, 1, 0, 0, 0, 0, 1]); /*8220*/
			} /*8220*/
			var _1Y = $k[--$j]; /*8221*/
			$k[$j++] = "binval"; /*8221*/
			$k[$j++] = _1Y; /*8221*/
			$k[$j++] = Infinity; /*8221*/
			$forall($geti($1.barcode, 20, $1.barlen - 20), function() { /*8221*/
				var _1c = $k[--$j]; /*8221*/
				$k[$j++] = _1c - 48; /*8221*/
			}); /*8221*/
			var _1d = $a(); /*8221*/
			$k[$j++] = _1d; /*8221*/
			if ($1.bigadd() == $b) return $b; /*8221*/
			var _1e = $k[--$j]; /*8221*/
			$1[$k[--$j]] = _1e; /*8221*/
			$k[$j++] = Infinity; /*8222*/
			var _1g = $1.binval; /*8222*/
			for (var _1h = 0, _1i = _1g.length; _1h < _1i; _1h++) { /*8222*/
				$k[$j++] = $get(_1g, _1h); /*8222*/
			} /*8222*/
			$k[$j++] = $get($1.barcode, 0) - 48; /*8222*/
			$1.binval = $a(); /*8222*/
			$k[$j++] = "binval"; /*8223*/
			$k[$j++] = Infinity; /*8223*/
			var _1n = $1.binval; /*8223*/
			for (var _1o = 0, _1p = _1n.length; _1o < _1p; _1o++) { /*8223*/
				$k[$j++] = $get(_1n, _1o) * 5; /*8223*/
			} /*8223*/
			var _1r = $a(); /*8223*/
			$k[$j++] = _1r; /*8223*/
			$k[$j++] = $a([$get($1.barcode, 1) - 48]); /*8223*/
			if ($1.bigadd() == $b) return $b; /*8223*/
			$k[$j++] = 10; /*8223*/
			if ($1.normalize() == $b) return $b; /*8223*/
			var _1v = $k[--$j]; /*8223*/
			$1[$k[--$j]] = _1v; /*8223*/
			$k[$j++] = Infinity; /*8224*/
			var _1x = $1.binval; /*8224*/
			for (var _1y = 0, _1z = _1x.length; _1y < _1z; _1y++) { /*8224*/
				$k[$j++] = $get(_1x, _1y); /*8224*/
			} /*8224*/
			$forall($geti($1.barcode, 2, 18), function() { /*8224*/
				var _23 = $k[--$j]; /*8224*/
				$k[$j++] = _23 - 48; /*8224*/
			}); /*8224*/
			$1.binval = $a(); /*8224*/
			$1.bytes = $a(13); /*8227*/
			$k[$j++] = Infinity; /*8228*/
			var _26 = $1.binval; /*8228*/
			for (var _27 = 0, _28 = _26.length; _27 < _28; _27++) { /*8228*/
				$k[$j++] = $get(_26, _27); /*8228*/
			} /*8228*/
			$1.bintmp = $a(); /*8228*/
			for (var _2B = 12; _2B >= 0; _2B -= 1) { /*8238*/
				$1.i = _2B; /*8230*/
				for (var _2E = 0, _2D = $1.bintmp.length - 2; _2E <= _2D; _2E += 1) { /*8235*/
					$1.j = _2E; /*8232*/
					var _2F = $1.bintmp; /*8233*/
					var _2G = $1.j; /*8233*/
					$put(_2F, _2G + 1, $get(_2F, _2G + 1) + (($get($1.bintmp, $1.j) % 256) * 10)); /*8233*/
					$put($1.bintmp, $1.j, ~~($get($1.bintmp, $1.j) / 256)); /*8234*/
				} /*8234*/
				$put($1.bytes, $1.i, $get($1.bintmp, $1.bintmp.length - 1) % 256); /*8236*/
				var _2V = $1.bintmp; /*8237*/
				var _2W = $1.bintmp; /*8237*/
				$put(_2V, _2W.length - 1, ~~($get(_2V, _2W.length - 1) / 256)); /*8237*/
			} /*8237*/
			$1.fcs = 2047; /*8241*/
			$1.dat = $get($1.bytes, 0) << 5; /*8242*/
			for (var _2a = 0, _2b = 6; _2a < _2b; _2a++) { /*8251*/
				if ((($1.fcs ^ $1.dat) & 1024) != 0) { /*8247*/
					$1.fcs = ($1.fcs << 1) ^ 3893; /*8245*/
				} else { /*8247*/
					$1.fcs = $1.fcs << 1; /*8247*/
				} /*8247*/
				$1.fcs = $1.fcs & 2047; /*8249*/
				$1.dat = $1.dat << 1; /*8250*/
			} /*8250*/
			for (var _2i = 1; _2i <= 12; _2i += 1) { /*8263*/
				$1.dat = $get($1.bytes, _2i) << 3; /*8253*/
				for (var _2l = 0, _2m = 8; _2l < _2m; _2l++) { /*8262*/
					if ((($1.fcs ^ $1.dat) & 1024) != 0) { /*8258*/
						$1.fcs = ($1.fcs << 1) ^ 3893; /*8256*/
					} else { /*8258*/
						$1.fcs = $1.fcs << 1; /*8258*/
					} /*8258*/
					$1.fcs = $1.fcs & 2047; /*8260*/
					$1.dat = $1.dat << 1; /*8261*/
				} /*8261*/
			} /*8261*/
			$1.codewords = $a(10); /*8266*/
			for (var _2u = 9; _2u >= 0; _2u -= 1) { /*8281*/
				$1.i = _2u; /*8268*/
				if ($1.i == 9) { /*8272*/
					$1.b = 636; /*8270*/
				} else { /*8272*/
					$1.b = 1365; /*8272*/
				} /*8272*/
				for (var _2y = 0, _2x = $1.binval.length - 2; _2y <= _2x; _2y += 1) { /*8278*/
					$1.j = _2y; /*8275*/
					var _2z = $1.binval; /*8276*/
					var _30 = $1.j; /*8276*/
					$put(_2z, _30 + 1, $get(_2z, _30 + 1) + (($get($1.binval, $1.j) % $1.b) * 10)); /*8276*/
					$put($1.binval, $1.j, ~~($get($1.binval, $1.j) / $1.b)); /*8277*/
				} /*8277*/
				$put($1.codewords, $1.i, $get($1.binval, $1.binval.length - 1) % $1.b); /*8279*/
				var _3I = $1.binval; /*8280*/
				var _3J = $1.binval; /*8280*/
				$put(_3I, _3J.length - 1, ~~($get(_3I, _3J.length - 1) / $1.b)); /*8280*/
			} /*8280*/
			$put($1.codewords, 9, $get($1.codewords, 9) * 2); /*8284*/
			if (($1.fcs & 1024) != 0) { /*8287*/
				$put($1.codewords, 0, $get($1.codewords, 0) + 659); /*8286*/
			} /*8286*/
			$1.tab513 = $a([31, 7936, 47, 7808, 55, 7552, 59, 7040, 61, 6016, 62, 3968, 79, 7744, 87, 7488, 91, 6976, 93, 5952, 94, 3904, 103, 7360, 107, 6848, 109, 5824, 110, 3776, 115, 6592, 117, 5568, 118, 3520, 121, 5056, 122, 3008, 124, 1984, 143, 7712, 151, 7456, 155, 6944, 157, 5920, 158, 3872, 167, 7328, 171, 6816, 173, 5792, 174, 3744, 179, 6560, 181, 5536, 182, 3488, 185, 5024, 186, 2976, 188, 1952, 199, 7264, 203, 6752, 205, 5728, 206, 3680, 211, 6496, 213, 5472, 214, 3424, 217, 4960, 218, 2912, 220, 1888, 227, 6368, 229, 5344, 230, 3296, 233, 4832, 234, 2784, 236, 1760, 241, 4576, 242, 2528, 244, 1504, 248, 992, 271, 7696, 279, 7440, 283, 6928, 285, 5904, 286, 3856, 295, 7312, 299, 6800, 301, 5776, 302, 3728, 307, 6544, 309, 5520, 310, 3472, 313, 5008, 314, 2960, 316, 1936, 327, 7248, 331, 6736, 333, 5712, 334, 3664, 339, 6480, 341, 5456, 342, 3408, 345, 4944, 346, 2896, 348, 1872, 355, 6352, 357, 5328, 358, 3280, 361, 4816, 362, 2768, 364, 1744, 369, 4560, 370, 2512, 372, 1488, 376, 976, 391, 7216, 395, 6704, 397, 5680, 398, 3632, 403, 6448, 405, 5424, 406, 3376, 409, 4912, 410, 2864, 412, 1840, 419, 6320, 421, 5296, 422, 3248, 425, 4784, 426, 2736, 428, 1712, 433, 4528, 434, 2480, 436, 1456, 440, 944, 451, 6256, 453, 5232, 454, 3184, 457, 4720, 458, 2672, 460, 1648, 465, 4464, 466, 2416, 468, 1392, 472, 880, 481, 4336, 482, 2288, 484, 1264, 488, 752, 527, 7688, 535, 7432, 539, 6920, 541, 5896, 542, 3848, 551, 7304, 555, 6792, 557, 5768, 558, 3720, 563, 6536, 565, 5512, 566, 3464, 569, 5000, 570, 2952, 572, 1928, 583, 7240, 587, 6728, 589, 5704, 590, 3656, 595, 6472, 597, 5448, 598, 3400, 601, 4936, 602, 2888, 604, 1864, 611, 6344, 613, 5320, 614, 3272, 617, 4808, 618, 2760, 620, 1736, 625, 4552, 626, 2504, 628, 1480, 632, 968, 647, 7208, 651, 6696, 653, 5672, 654, 3624, 659, 6440, 661, 5416, 662, 3368, 665, 4904, 666, 2856, 668, 1832, 675, 6312, 677, 5288, 678, 3240, 681, 4776, 682, 2728, 684, 1704, 689, 4520, 690, 2472, 692, 1448, 696, 936, 707, 6248, 709, 5224, 710, 3176, 713, 4712, 714, 2664, 716, 1640, 721, 4456, 722, 2408, 724, 1384, 728, 872, 737, 4328, 738, 2280, 740, 1256, 775, 7192, 779, 6680, 781, 5656, 782, 3608, 787, 6424, 789, 5400, 790, 3352, 793, 4888, 794, 2840, 796, 1816, 803, 6296, 805, 5272, 806, 3224, 809, 4760, 810, 2712, 812, 1688, 817, 4504, 818, 2456, 820, 1432, 824, 920, 835, 6232, 837, 5208, 838, 3160, 841, 4696, 842, 2648, 844, 1624, 849, 4440, 850, 2392, 852, 1368, 865, 4312, 866, 2264, 868, 1240, 899, 6200, 901, 5176, 902, 3128, 905, 4664, 906, 2616, 908, 1592, 913, 4408, 914, 2360, 916, 1336, 929, 4280, 930, 2232, 932, 1208, 961, 4216, 962, 2168, 964, 1144, 1039, 7684, 1047, 7428, 1051, 6916, 1053, 5892, 1054, 3844, 1063, 7300, 1067, 6788, 1069, 5764, 1070, 3716, 1075, 6532, 1077, 5508, 1078, 3460, 1081, 4996, 1082, 2948, 1084, 1924, 1095, 7236, 1099, 6724, 1101, 5700, 1102, 3652, 1107, 6468, 1109, 5444, 1110, 3396, 1113, 4932, 1114, 2884, 1116, 1860, 1123, 6340, 1125, 5316, 1126, 3268, 1129, 4804, 1130, 2756, 1132, 1732, 1137, 4548, 1138, 2500, 1140, 1476, 1159, 7204, 1163, 6692, 1165, 5668, 1166, 3620, 1171, 6436, 1173, 5412, 1174, 3364, 1177, 4900, 1178, 2852, 1180, 1828, 1187, 6308, 1189, 5284, 1190, 3236, 1193, 4772, 1194, 2724, 1196, 1700, 1201, 4516, 1202, 2468, 1204, 1444, 1219, 6244, 1221, 5220, 1222, 3172, 1225, 4708, 1226, 2660, 1228, 1636, 1233, 4452, 1234, 2404, 1236, 1380, 1249, 4324, 1250, 2276, 1287, 7188, 1291, 6676, 1293, 5652, 1294, 3604, 1299, 6420, 1301, 5396, 1302, 3348, 1305, 4884, 1306, 2836, 1308, 1812, 1315, 6292, 1317, 5268, 1318, 3220, 1321, 4756, 1322, 2708, 1324, 1684, 1329, 4500, 1330, 2452, 1332, 1428, 1347, 6228, 1349, 5204, 1350, 3156, 1353, 4692, 1354, 2644, 1356, 1620, 1361, 4436, 1362, 2388, 1377, 4308, 1378, 2260, 1411, 6196, 1413, 5172, 1414, 3124, 1417, 4660, 1418, 2612, 1420, 1588, 1425, 4404, 1426, 2356, 1441, 4276, 1442, 2228, 1473, 4212, 1474, 2164, 1543, 7180, 1547, 6668, 1549, 5644, 1550, 3596, 1555, 6412, 1557, 5388, 1558, 3340, 1561, 4876, 1562, 2828, 1564, 1804, 1571, 6284, 1573, 5260, 1574, 3212, 1577, 4748, 1578, 2700, 1580, 1676, 1585, 4492, 1586, 2444, 1603, 6220, 1605, 5196, 1606, 3148, 1609, 4684, 1610, 2636, 1617, 4428, 1618, 2380, 1633, 4300, 1634, 2252, 1667, 6188, 1669, 5164, 1670, 3116, 1673, 4652, 1674, 2604, 1681, 4396, 1682, 2348, 1697, 4268, 1698, 2220, 1729, 4204, 1730, 2156, 1795, 6172, 1797, 5148, 1798, 3100, 1801, 4636, 1802, 2588, 1809, 4380, 1810, 2332, 1825, 4252, 1826, 2204, 1857, 4188, 1858, 2140, 1921, 4156, 1922, 2108, 2063, 7682, 2071, 7426, 2075, 6914, 2077, 5890, 2078, 3842, 2087, 7298, 2091, 6786, 2093, 5762, 2094, 3714, 2099, 6530, 2101, 5506, 2102, 3458, 2105, 4994, 2106, 2946, 2119, 7234, 2123, 6722, 2125, 5698, 2126, 3650, 2131, 6466, 2133, 5442, 2134, 3394, 2137, 4930, 2138, 2882, 2147, 6338, 2149, 5314, 2150, 3266, 2153, 4802, 2154, 2754, 2161, 4546, 2162, 2498, 2183, 7202, 2187, 6690, 2189, 5666, 2190, 3618, 2195, 6434, 2197, 5410, 2198, 3362, 2201, 4898, 2202, 2850, 2211, 6306, 2213, 5282, 2214, 3234, 2217, 4770, 2218, 2722, 2225, 4514, 2226, 2466, 2243, 6242, 2245, 5218, 2246, 3170, 2249, 4706, 2250, 2658, 2257, 4450, 2258, 2402, 2273, 4322, 2311, 7186, 2315, 6674, 2317, 5650, 2318, 3602, 2323, 6418, 2325, 5394, 2326, 3346, 2329, 4882, 2330, 2834, 2339, 6290, 2341, 5266, 2342, 3218, 2345, 4754, 2346, 2706, 2353, 4498, 2354, 2450, 2371, 6226, 2373, 5202, 2374, 3154, 2377, 4690, 2378, 2642, 2385, 4434, 2401, 4306, 2435, 6194, 2437, 5170, 2438, 3122, 2441, 4658, 2442, 2610, 2449, 4402, 2465, 4274, 2497, 4210, 2567, 7178, 2571, 6666, 2573, 5642, 2574, 3594, 2579, 6410, 2581, 5386, 2582, 3338, 2585, 4874, 2586, 2826, 2595, 6282, 2597, 5258, 2598, 3210, 2601, 4746, 2602, 2698, 2609, 4490, 2627, 6218, 2629, 5194, 2630, 3146, 2633, 4682, 2641, 4426, 2657, 4298, 2691, 6186, 2693, 5162, 2694, 3114, 2697, 4650, 2705, 4394, 2721, 4266, 2753, 4202, 2819, 6170, 2821, 5146, 2822, 3098, 2825, 4634, 2833, 4378, 2849, 4250, 2881, 4186, 2945, 4154, 3079, 7174, 3083, 6662, 3085, 5638, 3086, 3590, 3091, 6406, 3093, 5382, 3094, 3334, 3097, 4870, 3107, 6278, 3109, 5254, 3110, 3206, 3113, 4742, 3121, 4486, 3139, 6214, 3141, 5190, 3145, 4678, 3153, 4422, 3169, 4294, 3203, 6182, 3205, 5158, 3209, 4646, 3217, 4390, 3233, 4262, 3265, 4198, 3331, 6166, 3333, 5142, 3337, 4630, 3345, 4374, 3361, 4246, 3393, 4182, 3457, 4150, 3587, 6158, 3589, 5134, 3593, 4622, 3601, 4366, 3617, 4238, 3649, 4174, 3713, 4142, 3841, 4126, 4111, 7681, 4119, 7425, 4123, 6913, 4125, 5889, 4135, 7297, 4139, 6785, 4141, 5761, 4147, 6529, 4149, 5505, 4153, 4993, 4167, 7233, 4171, 6721, 4173, 5697, 4179, 6465, 4181, 5441, 4185, 4929, 4195, 6337, 4197, 5313, 4201, 4801, 4209, 4545, 4231, 7201, 4235, 6689, 4237, 5665, 4243, 6433, 4245, 5409, 4249, 4897, 4259, 6305, 4261, 5281, 4265, 4769, 4273, 4513, 4291, 6241, 4293, 5217, 4297, 4705, 4305, 4449, 4359, 7185, 4363, 6673, 4365, 5649, 4371, 6417, 4373, 5393, 4377, 4881, 4387, 6289, 4389, 5265, 4393, 4753, 4401, 4497, 4419, 6225, 4421, 5201, 4425, 4689, 4483, 6193, 4485, 5169, 4489, 4657, 4615, 7177, 4619, 6665, 4621, 5641, 4627, 6409, 4629, 5385, 4633, 4873, 4643, 6281, 4645, 5257, 4649, 4745, 4675, 6217, 4677, 5193, 4739, 6185, 4741, 5161, 4867, 6169, 4869, 5145, 5127, 7173, 5131, 6661, 5133, 5637, 5139, 6405, 5141, 5381, 5155, 6277, 5157, 5253, 5187, 6213, 5251, 6181, 5379, 6165, 5635, 6157, 6151, 7171, 6155, 6659, 6163, 6403, 6179, 6275, 6211, 5189, 4681, 4433, 4321, 3142, 2634, 2386, 2274, 1612, 1364, 1252, 856, 744, 496]); /*8377*/
			$1.tab213 = $a([3, 6144, 5, 5120, 6, 3072, 9, 4608, 10, 2560, 12, 1536, 17, 4352, 18, 2304, 20, 1280, 24, 768, 33, 4224, 34, 2176, 36, 1152, 40, 640, 48, 384, 65, 4160, 66, 2112, 68, 1088, 72, 576, 80, 320, 96, 192, 129, 4128, 130, 2080, 132, 1056, 136, 544, 144, 288, 257, 4112, 258, 2064, 260, 1040, 264, 528, 513, 4104, 514, 2056, 516, 1032, 1025, 4100, 1026, 2052, 2049, 4098, 4097, 2050, 1028, 520, 272, 160]); /*8386*/
			$1.chars = $a(10); /*8388*/
			for (var _3W = 0; _3W <= 9; _3W += 1) { /*8397*/
				$1.i = _3W; /*8390*/
				var _3Z = $get($1.codewords, $1.i); /*8391*/
				$k[$j++] = _3Z; /*8395*/
				if (_3Z <= 1286) { /*8394*/
					var _3c = $get($1.tab513, $k[--$j]); /*8392*/
					$k[$j++] = _3c; /*8392*/
				} else { /*8394*/
					var _3f = $get($1.tab213, $k[--$j] - 1287); /*8394*/
					$k[$j++] = _3f; /*8394*/
				} /*8394*/
				$put($1.chars, $1.i, $k[--$j]); /*8396*/
			} /*8396*/
			for (var _3j = 9; _3j >= 0; _3j -= 1) { /*8404*/
				$1.i = _3j; /*8400*/
				if (((~~Math.pow(2, $1.i)) & $1.fcs) != 0) { /*8403*/
					$put($1.chars, $1.i, $get($1.chars, $1.i) ^ 8191); /*8402*/
				} /*8402*/
			} /*8402*/
			$1.barmap = $a([7, 2, 4, 3, 1, 10, 0, 0, 9, 12, 2, 8, 5, 5, 6, 11, 8, 9, 3, 1, 0, 1, 5, 12, 2, 5, 1, 8, 4, 4, 9, 11, 6, 3, 8, 10, 3, 9, 7, 6, 5, 11, 1, 4, 8, 5, 2, 12, 9, 10, 0, 2, 7, 1, 6, 7, 3, 6, 4, 9, 0, 3, 8, 6, 6, 4, 2, 7, 1, 1, 9, 9, 7, 10, 5, 2, 4, 0, 3, 8, 6, 2, 0, 4, 8, 11, 1, 0, 9, 8, 3, 12, 2, 6, 7, 7, 5, 1, 4, 10, 1, 12, 6, 9, 7, 3, 8, 0, 5, 8, 9, 7, 4, 6, 2, 10, 3, 4, 0, 5, 8, 4, 5, 7, 7, 11, 1, 9, 6, 0, 9, 6, 0, 6, 4, 8, 2, 1, 3, 2, 5, 9, 8, 12, 4, 11, 6, 1, 9, 5, 7, 4, 3, 3, 1, 2, 0, 7, 2, 0, 1, 3, 4, 1, 6, 10, 3, 5, 8, 7, 9, 4, 2, 11, 5, 6, 0, 8, 7, 12, 4, 2, 8, 1, 5, 10, 3, 0, 9, 3, 0, 9, 6, 5, 2, 4, 7, 8, 1, 7, 5, 0, 4, 5, 2, 3, 0, 10, 6, 12, 9, 2, 3, 11, 1, 6, 8, 8, 7, 9, 5, 4, 0, 11, 1, 5, 2, 2, 9, 1, 4, 12, 8, 3, 6, 6, 7, 0, 3, 7, 4, 7, 7, 5, 0, 12, 1, 11, 2, 9, 9, 0, 6, 8, 5, 3, 3, 10, 8, 2]); /*8421*/
			$1.bbs = $a(65); /*8423*/
			$1.bhs = $a(65); /*8424*/
			for (var _3u = 0; _3u <= 64; _3u += 1) { /*8445*/
				$1.i = _3u; /*8426*/
				$1.dec = ($get($1.chars, $get($1.barmap, $1.i * 4)) & (~~Math.pow(2, $get($1.barmap, ($1.i * 4) + 1)))) != 0; /*8427*/
				$1.asc = ($get($1.chars, $get($1.barmap, ($1.i * 4) + 2)) & (~~Math.pow(2, $get($1.barmap, ($1.i * 4) + 3)))) != 0; /*8428*/
				if ((!$1.dec) && (!$1.asc)) { /*8432*/
					$put($1.bbs, $1.i, (3 * $1.height) / 8); /*8430*/
					$put($1.bhs, $1.i, (2 * $1.height) / 8); /*8431*/
				} /*8431*/
				if ((!$1.dec) && $1.asc) { /*8436*/
					$put($1.bbs, $1.i, (3 * $1.height) / 8); /*8434*/
					$put($1.bhs, $1.i, (5 * $1.height) / 8); /*8435*/
				} /*8435*/
				if ($1.dec && (!$1.asc)) { /*8440*/
					$put($1.bbs, $1.i, (0 * $1.height) / 8); /*8438*/
					$put($1.bhs, $1.i, (5 * $1.height) / 8); /*8439*/
				} /*8439*/
				if ($1.dec && $1.asc) { /*8444*/
					$put($1.bbs, $1.i, (0 * $1.height) / 8); /*8442*/
					$put($1.bhs, $1.i, (8 * $1.height) / 8); /*8443*/
				} /*8443*/
			} /*8443*/
			$k[$j++] = Infinity; /*8458*/
			$k[$j++] = "ren"; /*8453*/
			$k[$j++] = $0.renlinear; /*8453*/
			$k[$j++] = "bbs"; /*8453*/
			$k[$j++] = $1.bbs; /*8453*/
			$k[$j++] = "bhs"; /*8453*/
			$k[$j++] = $1.bhs; /*8453*/
			$k[$j++] = "sbs"; /*8453*/
			$k[$j++] = Infinity; /*8453*/
			for (var _4k = 0, _4l = $1.bhs.length - 1; _4k < _4l; _4k++) { /*8452*/
				$k[$j++] = 1.44; /*8452*/
				$k[$j++] = 1.872; /*8452*/
			} /*8452*/
			$k[$j++] = 1.44; /*8452*/
			var _4m = $a(); /*8453*/
			$k[$j++] = _4m; /*8458*/
			$k[$j++] = "txt"; /*8458*/
			$k[$j++] = $1.txt; /*8458*/
			$k[$j++] = "textxalign"; /*8458*/
			$k[$j++] = "left"; /*8458*/
			$k[$j++] = "textfont"; /*8458*/
			$k[$j++] = "Helvetica"; /*8458*/
			$k[$j++] = "textyoffset"; /*8458*/
			$k[$j++] = 1; /*8458*/
			$k[$j++] = "textxoffset"; /*8458*/
			$k[$j++] = -0.3; /*8458*/
			$k[$j++] = "opt"; /*8458*/
			$k[$j++] = $1.options; /*8458*/
			var _4p = $d(); /*8458*/
			$k[$j++] = _4p; /*8461*/
			if (!$1.dontdraw) { /*8461*/
				$0.renlinear(); /*8461*/
			} /*8461*/
		};
		$0.postnet = function() {
			var $1 = {}; /*8488*/
			$1.options = $k[--$j]; /*8490*/
			$1.barcode = $k[--$j]; /*8491*/
			$1.dontdraw = false; /*8493*/
			$1.includetext = false; /*8494*/
			$1.validatecheck = false; /*8495*/
			$1.includecheckintext = false; /*8496*/
			$1.textfont = "Courier"; /*8497*/
			$1.textsize = 10; /*8498*/
			$1.textyoffset = -8.5; /*8499*/
			$1.height = 0.125; /*8500*/
			$forall($1.options, function() { /*8511*/
				var _3 = $k[--$j]; /*8511*/
				$1[$k[--$j]] = _3; /*8511*/
			}); /*8511*/
			$1.textfont = "" + $1.textfont; /*8513*/
			$1.textsize = +$1.textsize; /*8514*/
			$1.textyoffset = +$1.textyoffset; /*8515*/
			$1.height = +$1.height; /*8516*/
			$k[$j++] = "barlen"; /*8518*/
			$k[$j++] = $1.barcode.length; /*8518*/
			if ($1.validatecheck) { /*8518*/
				var _B = $k[--$j]; /*8518*/
				$k[$j++] = _B - 1; /*8518*/
			} /*8518*/
			var _C = $k[--$j]; /*8518*/
			$1[$k[--$j]] = _C; /*8518*/
			if ((($1.barlen != 5) && ($1.barlen != 9)) && ($1.barlen != 11)) { /*8523*/
				$k[$j++] = "bwipp.postnetBadLength"; /*8522*/
				$k[$j++] = "USPS POSTNET must be 5, 9 or 11 digits excluding check digit"; /*8522*/
				$0.raiseerror(); /*8522*/
			} /*8522*/
			$forall($1.barcode, function() { /*8528*/
				var _I = $k[--$j]; /*8525*/
				if ((_I < 48) || (_I > 57)) { /*8527*/
					$k[$j++] = "bwipp.postnetBadCharacter"; /*8526*/
					$k[$j++] = "USPS POSTNET must contain only digits"; /*8526*/
					$0.raiseerror(); /*8526*/
				} /*8526*/
			}); /*8526*/
			$1.barchars = "0123456789"; /*8531*/
			$1.checksum = 0; /*8533*/
			for (var _L = 0, _K = $1.barlen - 1; _L <= _K; _L += 1) { /*8537*/
				$1.i = _L; /*8535*/
				$1.checksum = $1.checksum + ($get($1.barcode, $1.i) - 48); /*8536*/
			} /*8536*/
			$1.checksum = (10 - ($1.checksum % 10)) % 10; /*8538*/
			if ($1.validatecheck) { /*8544*/
				if ($get($1.barcode, $1.barlen) != $get($1.barchars, $1.checksum)) { /*8542*/
					$k[$j++] = "bwipp.postnetBadCheckDigit"; /*8541*/
					$k[$j++] = "Incorrect USPS POSTNET check digit provided"; /*8541*/
					$0.raiseerror(); /*8541*/
				} /*8541*/
				$1.barcode = $geti($1.barcode, 0, $1.barlen); /*8543*/
			} /*8543*/
			$1.encs = $a(["55222", "22255", "22525", "22552", "25225", "25252", "25522", "52225", "52252", "52522", "5", "5"]); /*8551*/
			$1.bhs = $a(($1.barlen * 5) + 7); /*8553*/
			$1.txt = $a($1.barlen + 1); /*8554*/
			$1.enc = $get($1.encs, 10); /*8557*/
			$1.heights = $a($1.enc.length); /*8558*/
			for (var _m = 0, _l = $1.enc.length - 1; _m <= _l; _m += 1) { /*8562*/
				$1.j = _m; /*8560*/
				$put($1.heights, $1.j, ((~~$z($geti($1.enc, $1.j, 1))) * $1.height) / 5); /*8561*/
			} /*8561*/
			$puti($1.bhs, 0, $1.heights); /*8563*/
			for (var _x = 0, _w = $1.barlen - 1; _x <= _w; _x += 1) { /*8575*/
				$1.i = _x; /*8566*/
				$1.enc = $get($1.encs, $get($1.barcode, $1.i) - 48); /*8567*/
				$1.heights = $a($1.enc.length); /*8568*/
				for (var _17 = 0, _16 = $1.enc.length - 1; _17 <= _16; _17 += 1) { /*8572*/
					$1.j = _17; /*8570*/
					$put($1.heights, $1.j, ((~~$z($geti($1.enc, $1.j, 1))) * $1.height) / 5); /*8571*/
				} /*8571*/
				$puti($1.bhs, ($1.i * 5) + 1, $1.heights); /*8573*/
				$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), (($1.i * 5) + 1) * 3.312, $1.textyoffset, $1.textfont, $1.textsize])); /*8574*/
			} /*8574*/
			$1.enc = $get($1.encs, $1.checksum); /*8578*/
			$1.heights = $a($1.enc.length); /*8579*/
			for (var _1Y = 0, _1X = $1.enc.length - 1; _1Y <= _1X; _1Y += 1) { /*8583*/
				$1.j = _1Y; /*8581*/
				$put($1.heights, $1.j, ((~~$z($geti($1.enc, $1.j, 1))) * $1.height) / 5); /*8582*/
			} /*8582*/
			$puti($1.bhs, ($1.barlen * 5) + 1, $1.heights); /*8584*/
			if ($1.includecheckintext) { /*8589*/
				$put($1.txt, $1.barlen, $a([$geti($1.barchars, $1.checksum, 1), (($1.barlen * 5) + 1) * 3.312, $1.textyoffset, $1.textfont, $1.textsize])); /*8587*/
			} else { /*8589*/
				$put($1.txt, $1.barlen, $a([" ", ((($1.barlen * 5) + 1) * 72) / 25, $1.textyoffset, $1.textfont, $1.textsize])); /*8589*/
			} /*8589*/
			$1.enc = $get($1.encs, 11); /*8593*/
			$1.heights = $a($1.enc.length); /*8594*/
			for (var _26 = 0, _25 = $1.enc.length - 1; _26 <= _25; _26 += 1) { /*8598*/
				$1.j = _26; /*8596*/
				$put($1.heights, $1.j, ((~~$z($geti($1.enc, $1.j, 1))) * $1.height) / 5); /*8597*/
			} /*8597*/
			$puti($1.bhs, ($1.barlen * 5) + 6, $1.heights); /*8599*/
			$k[$j++] = Infinity; /*8610*/
			$k[$j++] = "ren"; /*8606*/
			$k[$j++] = $0.renlinear; /*8606*/
			$k[$j++] = "bhs"; /*8606*/
			$k[$j++] = $1.bhs; /*8606*/
			$k[$j++] = "bbs"; /*8606*/
			$k[$j++] = Infinity; /*8606*/
			for (var _2I = 0, _2J = $1.bhs.length; _2I < _2J; _2I++) { /*8605*/
				$k[$j++] = 0; /*8605*/
			} /*8605*/
			var _2K = $a(); /*8606*/
			$k[$j++] = _2K; /*8607*/
			$k[$j++] = "sbs"; /*8607*/
			$k[$j++] = Infinity; /*8607*/
			for (var _2M = 0, _2N = $1.bhs.length - 1; _2M < _2N; _2M++) { /*8606*/
				$k[$j++] = 1.44; /*8606*/
				$k[$j++] = 1.872; /*8606*/
			} /*8606*/
			$k[$j++] = 1.44; /*8606*/
			var _2O = $a(); /*8607*/
			$k[$j++] = _2O; /*8609*/
			if ($1.includetext) { /*8609*/
				$k[$j++] = "txt"; /*8608*/
				$k[$j++] = $1.txt; /*8608*/
			} /*8608*/
			$k[$j++] = "opt"; /*8610*/
			$k[$j++] = $1.options; /*8610*/
			var _2S = $d(); /*8610*/
			$k[$j++] = _2S; /*8613*/
			if (!$1.dontdraw) { /*8613*/
				$0.renlinear(); /*8613*/
			} /*8613*/
		};
		$0.planet = function() {
			var $1 = {}; /*8640*/
			$1.options = $k[--$j]; /*8642*/
			$1.barcode = $k[--$j]; /*8643*/
			$1.dontdraw = false; /*8645*/
			$1.includetext = false; /*8646*/
			$1.validatecheck = false; /*8647*/
			$1.includecheckintext = false; /*8648*/
			$1.textfont = "Courier"; /*8649*/
			$1.textsize = 10; /*8650*/
			$1.textyoffset = -8.5; /*8651*/
			$1.height = 0.125; /*8652*/
			$forall($1.options, function() { /*8663*/
				var _3 = $k[--$j]; /*8663*/
				$1[$k[--$j]] = _3; /*8663*/
			}); /*8663*/
			$1.textfont = "" + $1.textfont; /*8665*/
			$1.textsize = +$1.textsize; /*8666*/
			$1.textyoffset = +$1.textyoffset; /*8667*/
			$1.height = +$1.height; /*8668*/
			$k[$j++] = "barlen"; /*8670*/
			$k[$j++] = $1.barcode.length; /*8670*/
			if ($1.validatecheck) { /*8670*/
				var _B = $k[--$j]; /*8670*/
				$k[$j++] = _B - 1; /*8670*/
			} /*8670*/
			var _C = $k[--$j]; /*8670*/
			$1[$k[--$j]] = _C; /*8670*/
			if (($1.barlen != 11) && ($1.barlen != 13)) { /*8675*/
				$k[$j++] = "bwipp.planetBadLength"; /*8674*/
				$k[$j++] = "USPS PLANET must be 11 or 13 digits excluding check digit"; /*8674*/
				$0.raiseerror(); /*8674*/
			} /*8674*/
			$forall($1.barcode, function() { /*8680*/
				var _H = $k[--$j]; /*8677*/
				if ((_H < 48) || (_H > 57)) { /*8679*/
					$k[$j++] = "bwipp.planetBadCharacter"; /*8678*/
					$k[$j++] = "USPS PLANET must contain only digits"; /*8678*/
					$0.raiseerror(); /*8678*/
				} /*8678*/
			}); /*8678*/
			$1.barchars = "0123456789"; /*8683*/
			$1.checksum = 0; /*8686*/
			for (var _K = 0, _J = $1.barlen - 1; _K <= _J; _K += 1) { /*8690*/
				$1.i = _K; /*8688*/
				$1.checksum = $1.checksum + ($get($1.barcode, $1.i) - 48); /*8689*/
			} /*8689*/
			$1.checksum = (10 - ($1.checksum % 10)) % 10; /*8691*/
			if ($1.validatecheck) { /*8697*/
				if ($get($1.barcode, $1.barlen) != $get($1.barchars, $1.checksum)) { /*8695*/
					$k[$j++] = "bwipp.planetBadCheckDigit"; /*8694*/
					$k[$j++] = "Incorrect USPS PLANET check digit provided"; /*8694*/
					$0.raiseerror(); /*8694*/
				} /*8694*/
				$1.barcode = $geti($1.barcode, 0, $1.barlen); /*8696*/
			} /*8696*/
			$1.encs = $a(["22555", "55522", "55252", "55225", "52552", "52525", "52255", "25552", "25525", "25255", "5", "5"]); /*8704*/
			$1.bhs = $a(($1.barlen * 5) + 7); /*8706*/
			$1.txt = $a($1.barlen + 1); /*8707*/
			$1.enc = $get($1.encs, 10); /*8710*/
			$1.heights = $a($1.enc.length); /*8711*/
			for (var _l = 0, _k = $1.enc.length - 1; _l <= _k; _l += 1) { /*8715*/
				$1.j = _l; /*8713*/
				$put($1.heights, $1.j, ((~~$z($geti($1.enc, $1.j, 1))) * $1.height) / 5); /*8714*/
			} /*8714*/
			$puti($1.bhs, 0, $1.heights); /*8716*/
			for (var _w = 0, _v = $1.barlen - 1; _w <= _v; _w += 1) { /*8728*/
				$1.i = _w; /*8719*/
				$1.enc = $get($1.encs, $get($1.barcode, $1.i) - 48); /*8720*/
				$1.heights = $a($1.enc.length); /*8721*/
				for (var _16 = 0, _15 = $1.enc.length - 1; _16 <= _15; _16 += 1) { /*8725*/
					$1.j = _16; /*8723*/
					$put($1.heights, $1.j, ((~~$z($geti($1.enc, $1.j, 1))) * $1.height) / 5); /*8724*/
				} /*8724*/
				$puti($1.bhs, ($1.i * 5) + 1, $1.heights); /*8726*/
				$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), (($1.i * 5) + 1) * 3.312, $1.textyoffset, $1.textfont, $1.textsize])); /*8727*/
			} /*8727*/
			$1.enc = $get($1.encs, $1.checksum); /*8731*/
			$1.heights = $a($1.enc.length); /*8732*/
			for (var _1X = 0, _1W = $1.enc.length - 1; _1X <= _1W; _1X += 1) { /*8736*/
				$1.j = _1X; /*8734*/
				$put($1.heights, $1.j, ((~~$z($geti($1.enc, $1.j, 1))) * $1.height) / 5); /*8735*/
			} /*8735*/
			$puti($1.bhs, ($1.barlen * 5) + 1, $1.heights); /*8737*/
			if ($1.includecheckintext) { /*8742*/
				$put($1.txt, $1.barlen, $a([$geti($1.barchars, $1.checksum, 1), (($1.barlen * 5) + 1) * 3.312, $1.textyoffset, $1.textfont, $1.textsize])); /*8740*/
			} else { /*8742*/
				$put($1.txt, $1.barlen, $a([" ", ((($1.barlen * 5) + 1) * 72) / 25, $1.textyoffset, $1.textfont, $1.textsize])); /*8742*/
			} /*8742*/
			$1.enc = $get($1.encs, 11); /*8746*/
			$1.heights = $a($1.enc.length); /*8747*/
			for (var _25 = 0, _24 = $1.enc.length - 1; _25 <= _24; _25 += 1) { /*8751*/
				$1.j = _25; /*8749*/
				$put($1.heights, $1.j, ((~~$z($geti($1.enc, $1.j, 1))) * $1.height) / 5); /*8750*/
			} /*8750*/
			$puti($1.bhs, ($1.barlen * 5) + 6, $1.heights); /*8752*/
			$k[$j++] = Infinity; /*8763*/
			$k[$j++] = "ren"; /*8759*/
			$k[$j++] = $0.renlinear; /*8759*/
			$k[$j++] = "bhs"; /*8759*/
			$k[$j++] = $1.bhs; /*8759*/
			$k[$j++] = "bbs"; /*8759*/
			$k[$j++] = Infinity; /*8759*/
			for (var _2H = 0, _2I = $1.bhs.length; _2H < _2I; _2H++) { /*8758*/
				$k[$j++] = 0; /*8758*/
			} /*8758*/
			var _2J = $a(); /*8759*/
			$k[$j++] = _2J; /*8760*/
			$k[$j++] = "sbs"; /*8760*/
			$k[$j++] = Infinity; /*8760*/
			for (var _2L = 0, _2M = $1.bhs.length - 1; _2L < _2M; _2L++) { /*8759*/
				$k[$j++] = 1.44; /*8759*/
				$k[$j++] = 1.872; /*8759*/
			} /*8759*/
			$k[$j++] = 1.44; /*8759*/
			var _2N = $a(); /*8760*/
			$k[$j++] = _2N; /*8762*/
			if ($1.includetext) { /*8762*/
				$k[$j++] = "txt"; /*8761*/
				$k[$j++] = $1.txt; /*8761*/
			} /*8761*/
			$k[$j++] = "opt"; /*8763*/
			$k[$j++] = $1.options; /*8763*/
			var _2R = $d(); /*8763*/
			$k[$j++] = _2R; /*8766*/
			if (!$1.dontdraw) { /*8766*/
				$0.renlinear(); /*8766*/
			} /*8766*/
		};
		$0.royalmail = function() {
			var $1 = {}; /*8793*/
			$1.options = $k[--$j]; /*8795*/
			$1.barcode = $k[--$j]; /*8796*/
			$1.dontdraw = false; /*8798*/
			$1.includetext = false; /*8799*/
			$1.validatecheck = false; /*8800*/
			$1.includecheckintext = false; /*8801*/
			$1.textfont = "Courier"; /*8802*/
			$1.textsize = 10; /*8803*/
			$1.textyoffset = -8.5; /*8804*/
			$1.height = 0.175; /*8805*/
			$forall($1.options, function() { /*8816*/
				var _3 = $k[--$j]; /*8816*/
				$1[$k[--$j]] = _3; /*8816*/
			}); /*8816*/
			$1.textfont = "" + $1.textfont; /*8818*/
			$1.textsize = +$1.textsize; /*8819*/
			$1.textyoffset = +$1.textyoffset; /*8820*/
			$1.height = +$1.height; /*8821*/
			$1.barchars = "ZUVWXY501234B6789AHCDEFGNIJKLMTOPQRS"; /*8824*/
			$1.charvals = {}; /*8825*/
			for (var _9 = 0; _9 <= 35; _9 += 1) { /*8826*/
				$put($1.charvals, $geti($1.barchars, _9, 1), _9); /*8826*/
			} /*8826*/
			for (var _F = 0, _E = $1.barcode.length - 1; _F <= _E; _F += 1) { /*8833*/
				var _J = $get($1.charvals, $geti($1.barcode, _F, 1)) !== undefined; /*8830*/
				if (!_J) { /*8832*/
					$k[$j++] = "bwipp.royalmailBadCharacter"; /*8831*/
					$k[$j++] = "RM4SCC must contain only capital letters and digits"; /*8831*/
					$0.raiseerror(); /*8831*/
				} /*8831*/
			} /*8831*/
			$k[$j++] = "barlen"; /*8835*/
			$k[$j++] = $1.barcode.length; /*8835*/
			if ($1.validatecheck) { /*8835*/
				var _M = $k[--$j]; /*8835*/
				$k[$j++] = _M - 1; /*8835*/
			} /*8835*/
			var _N = $k[--$j]; /*8835*/
			$1[$k[--$j]] = _N; /*8835*/
			$1.checksumrow = 0; /*8837*/
			$1.checksumcol = 0; /*8838*/
			for (var _R = 0, _Q = $1.barlen - 1; _R <= _Q; _R += 1) { /*8844*/
				$1.i = _R; /*8840*/
				$1.indx = $get($1.charvals, $geti($1.barcode, $1.i, 1)); /*8841*/
				$1.checksumrow = $1.checksumrow + (~~($1.indx / 6)); /*8842*/
				$1.checksumcol = $1.checksumcol + ($1.indx % 6); /*8843*/
			} /*8843*/
			$1.checksum = (($1.checksumrow % 6) * 6) + ($1.checksumcol % 6); /*8845*/
			if ($1.validatecheck) { /*8851*/
				if ($get($1.barcode, $1.barlen) != $get($1.barchars, $1.checksum)) { /*8849*/
					$k[$j++] = "bwipp.royalmailBadCheckDigit"; /*8848*/
					$k[$j++] = "Incorrect RM4SCC check digit provided"; /*8848*/
					$0.raiseerror(); /*8848*/
				} /*8848*/
				$1.barcode = $geti($1.barcode, 0, $1.barlen); /*8850*/
			} /*8850*/
			$1.encs = $a(["3300", "2211", "2301", "2310", "3201", "3210", "1122", "0033", "0123", "0132", "1023", "1032", "1302", "0213", "0303", "0312", "1203", "1212", "1320", "0231", "0321", "0330", "1221", "1230", "3102", "2013", "2103", "2112", "3003", "3012", "3120", "2031", "2121", "2130", "3021", "3030", "2", "3"]); /*8862*/
			$1.encstr = $s(($1.barlen * 4) + 6); /*8864*/
			$1.txt = $a($1.barlen + 1); /*8865*/
			$puti($1.encstr, 0, $get($1.encs, 36)); /*8868*/
			for (var _x = 0, _w = $1.barlen - 1; _x <= _w; _x += 1) { /*8875*/
				$1.i = _x; /*8871*/
				$1.indx = $get($1.charvals, $geti($1.barcode, $1.i, 1)); /*8872*/
				$puti($1.encstr, ($1.i * 4) + 1, $get($1.encs, $1.indx)); /*8873*/
				$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), (($1.i * 4) + 1) * 3.312, $1.textyoffset, $1.textfont, $1.textsize])); /*8874*/
			} /*8874*/
			$puti($1.encstr, ($1.barlen * 4) + 1, $get($1.encs, $1.checksum)); /*8878*/
			if ($1.includecheckintext) { /*8882*/
				$put($1.txt, $1.barlen, $a([$geti($1.barchars, $1.checksum, 1), (($1.barlen * 4) + 1) * 3.312, $1.textyoffset, $1.textfont, $1.textsize])); /*8880*/
			} else { /*8882*/
				$put($1.txt, $1.barlen, $a([" ", (($1.barlen * 4) + 1) * 3.312, $1.textyoffset, $1.textfont, $1.textsize])); /*8882*/
			} /*8882*/
			$puti($1.encstr, ($1.barlen * 4) + 5, $get($1.encs, 37)); /*8886*/
			$1.bbs = $a($1.encstr.length); /*8888*/
			$1.bhs = $a($1.encstr.length); /*8889*/
			for (var _1p = 0, _1o = $1.encstr.length - 1; _1p <= _1o; _1p += 1) { /*8909*/
				$1.i = _1p; /*8891*/
				$1.enc = $geti($1.encstr, $1.i, 1); /*8892*/
				if ($eq($1.enc, "0")) { /*8896*/
					$put($1.bbs, $1.i, (3 * $1.height) / 8); /*8894*/
					$put($1.bhs, $1.i, (2 * $1.height) / 8); /*8895*/
				} /*8895*/
				if ($eq($1.enc, "1")) { /*8900*/
					$put($1.bbs, $1.i, (0 * $1.height) / 8); /*8898*/
					$put($1.bhs, $1.i, (5 * $1.height) / 8); /*8899*/
				} /*8899*/
				if ($eq($1.enc, "2")) { /*8904*/
					$put($1.bbs, $1.i, (3 * $1.height) / 8); /*8902*/
					$put($1.bhs, $1.i, (5 * $1.height) / 8); /*8903*/
				} /*8903*/
				if ($eq($1.enc, "3")) { /*8908*/
					$put($1.bbs, $1.i, (0 * $1.height) / 8); /*8906*/
					$put($1.bhs, $1.i, (8 * $1.height) / 8); /*8907*/
				} /*8907*/
			} /*8907*/
			$k[$j++] = Infinity; /*8920*/
			$k[$j++] = "ren"; /*8917*/
			$k[$j++] = $0.renlinear; /*8917*/
			$k[$j++] = "bbs"; /*8917*/
			$k[$j++] = $1.bbs; /*8917*/
			$k[$j++] = "bhs"; /*8917*/
			$k[$j++] = $1.bhs; /*8917*/
			$k[$j++] = "sbs"; /*8917*/
			$k[$j++] = Infinity; /*8917*/
			for (var _2O = 0, _2P = $1.bhs.length - 1; _2O < _2P; _2O++) { /*8916*/
				$k[$j++] = 1.44; /*8916*/
				$k[$j++] = 1.872; /*8916*/
			} /*8916*/
			$k[$j++] = 1.44; /*8916*/
			var _2Q = $a(); /*8917*/
			$k[$j++] = _2Q; /*8919*/
			if ($1.includetext) { /*8919*/
				$k[$j++] = "txt"; /*8918*/
				$k[$j++] = $1.txt; /*8918*/
			} /*8918*/
			$k[$j++] = "opt"; /*8920*/
			$k[$j++] = $1.options; /*8920*/
			var _2U = $d(); /*8920*/
			$k[$j++] = _2U; /*8923*/
			if (!$1.dontdraw) { /*8923*/
				$0.renlinear(); /*8923*/
			} /*8923*/
		};
		$0.auspost = function() {
			var $1 = {}; /*8950*/
			$1.options = $k[--$j]; /*8952*/
			$1.barcode = $k[--$j]; /*8953*/
			$1.dontdraw = false; /*8955*/
			$1.includetext = false; /*8956*/
			$1.textfont = "Courier"; /*8957*/
			$1.textsize = 10; /*8958*/
			$1.textyoffset = -8.5; /*8959*/
			$1.height = 0.175; /*8960*/
			$1.custinfoenc = "character"; /*8961*/
			$forall($1.options, function() { /*8972*/
				var _3 = $k[--$j]; /*8972*/
				$1[$k[--$j]] = _3; /*8972*/
			}); /*8972*/
			$1.textfont = "" + $1.textfont; /*8974*/
			$1.textsize = +$1.textsize; /*8975*/
			$1.textyoffset = +$1.textyoffset; /*8976*/
			$1.height = +$1.height; /*8977*/
			$1.encs = $a(["000", "001", "002", "010", "011", "012", "020", "021", "022", "100", "101", "102", "110", "111", "112", "120", "121", "122", "200", "201", "202", "210", "211", "212", "220", "221", "222", "300", "301", "302", "310", "311", "312", "320", "321", "322", "023", "030", "031", "032", "033", "103", "113", "123", "130", "131", "132", "133", "203", "213", "223", "230", "231", "232", "233", "303", "313", "323", "330", "331", "332", "333", "003", "013", "00", "01", "02", "10", "11", "12", "20", "21", "22", "30", "13", "3"]); /*8991*/
			$1.barchars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789abcdefghijklmnopqrstuvwxyz #"; /*8994*/
			$1.barlen = $1.barcode.length; /*8996*/
			if ($eq($geti($1.barcode, 0, 2), "11")) { /*8997*/
				$k[$j++] = 37; /*8997*/
			} /*8997*/
			if ($eq($geti($1.barcode, 0, 2), "45")) { /*8998*/
				$k[$j++] = 37; /*8998*/
			} /*8998*/
			if ($eq($geti($1.barcode, 0, 2), "59")) { /*8999*/
				$k[$j++] = 52; /*8999*/
			} /*8999*/
			if ($eq($geti($1.barcode, 0, 2), "62")) { /*9000*/
				$k[$j++] = 67; /*9000*/
			} /*9000*/
			$1.encstr = $s($k[--$j]); /*9001*/
			$1.txt = $a($1.barlen - 2); /*9002*/
			$puti($1.encstr, 0, $get($1.encs, 74)); /*9005*/
			for (var _Q = 0; _Q <= 1; _Q += 1) { /*9012*/
				$1.i = _Q; /*9009*/
				$puti($1.encstr, ($1.i * 2) + 2, $get($1.encs, (~~$z($geti($1.barcode, $1.i, 1))) + 64)); /*9011*/
			} /*9011*/
			for (var _Y = 2; _Y <= 9; _Y += 1) { /*9020*/
				$1.i = _Y; /*9016*/
				$puti($1.encstr, ($1.i * 2) + 2, $get($1.encs, (~~$z($geti($1.barcode, $1.i, 1))) + 64)); /*9018*/
				$put($1.txt, $1.i - 2, $a([$geti($1.barcode, $1.i, 1), ((($1.i - 2) * 2) + 6) * 3.312, $1.textyoffset, $1.textfont, $1.textsize])); /*9019*/
			} /*9019*/
			if ($eq($1.custinfoenc, "numeric")) { /*9042*/
				for (var _t = 0, _s = $1.barlen - 11; _t <= _s; _t += 1) { /*9029*/
					$1.i = _t; /*9025*/
					$puti($1.encstr, ($1.i * 2) + 22, $get($1.encs, (~~$z($geti($1.barcode, $1.i + 10, 1))) + 64)); /*9027*/
					$put($1.txt, $1.i + 8, $a([$geti($1.barcode, $1.i + 10, 1), (($1.i * 2) + 22) * 3.312, $1.textyoffset, $1.textfont, $1.textsize])); /*9028*/
				} /*9028*/
				$1.ciflen = ($1.barlen - 10) * 2; /*9030*/
			} else { /*9042*/
				for (var _1E = 0, _1D = $1.barlen - 11; _1E <= _1D; _1E += 1) { /*9041*/
					$1.i = _1E; /*9033*/
					$search($1.barchars, $geti($1.barcode, $1.i + 10, 1)); /*9034*/
					$j--; /*9035*/
					$1.indx = $k[--$j].length; /*9036*/
					$j -= 2; /*9037*/
					$1.enc = $get($1.encs, $1.indx); /*9038*/
					$puti($1.encstr, ($1.i * 3) + 22, $1.enc); /*9039*/
					$put($1.txt, $1.i + 8, $a([$geti($1.barcode, $1.i + 10, 1), (($1.i * 3) + 22) * 3.312, $1.textyoffset, $1.textfont, $1.textsize])); /*9040*/
				} /*9040*/
				$1.ciflen = ($1.barlen - 10) * 3; /*9042*/
			} /*9042*/
			for (var _1e = 22 + $1.ciflen, _1d = $1.encstr.length - 14; _1e <= _1d; _1e += 1) { /*9048*/
				$puti($1.encstr, _1e, $get($1.encs, 75)); /*9047*/
			} /*9047*/
			$1.rstable = $a(64 * 64); /*9051*/
			$k[$j++] = $1.rstable; /*9052*/
			$k[$j++] = 0; /*9052*/
			$k[$j++] = Infinity; /*9052*/
			for (var _1k = 0, _1l = 64; _1k < _1l; _1k++) { /*9052*/
				$k[$j++] = 0; /*9052*/
			} /*9052*/
			var _1m = $a(); /*9052*/
			var _1n = $k[--$j]; /*9052*/
			$puti($k[--$j], _1n, _1m); /*9052*/
			$k[$j++] = $1.rstable; /*9053*/
			$k[$j++] = 64; /*9053*/
			$k[$j++] = Infinity; /*9053*/
			for (var _1q = 0; _1q <= 63; _1q += 1) { /*9053*/
				$k[$j++] = _1q; /*9053*/
			} /*9053*/
			var _1r = $a(); /*9053*/
			var _1s = $k[--$j]; /*9053*/
			$puti($k[--$j], _1s, _1r); /*9053*/
			$1.prev = 1; /*9054*/
			for (var _1u = 0, _1v = 64; _1u < _1v; _1u++) { /*9069*/
				$1.next = $1.prev << 1; /*9056*/
				if (($1.next & 64) != 0) { /*9059*/
					$1.next = $1.next ^ 67; /*9058*/
				} /*9058*/
				for (var _1z = 0; _1z <= 63; _1z += 1) { /*9067*/
					$1.j = _1z; /*9061*/
					$1.nextcell = function() {
						$k[$j++] = $1.rstable; /*9062*/
						$k[$j++] = (64 * $1.next) + $1.j; /*9062*/
					}; /*9062*/
					if ($1.nextcell() == $b) break; /*9063*/
					var _27 = $k[--$j]; /*9063*/
					$put($k[--$j], _27, $get($1.rstable, (64 * $1.prev) + $1.j) << 1); /*9063*/
					if ($1.nextcell() == $b) break; /*9064*/
					var _29 = $k[--$j]; /*9064*/
					if (($get($k[--$j], _29) & 64) != 0) { /*9066*/
						if ($1.nextcell() == $b) break; /*9065*/
						if ($1.nextcell() == $b) break; /*9065*/
						var _2C = $k[--$j]; /*9065*/
						var _2E = $get($k[--$j], _2C); /*9065*/
						var _2F = $k[--$j]; /*9065*/
						$put($k[--$j], _2F, _2E ^ 67); /*9065*/
					} /*9065*/
				} /*9065*/
				$1.prev = $1.next; /*9068*/
			} /*9068*/
			$1.rscodes = $a((~~(($1.encstr.length - 16) / 3)) + 4); /*9072*/
			$k[$j++] = $1.rscodes; /*9073*/
			$k[$j++] = 0; /*9073*/
			$k[$j++] = Infinity; /*9073*/
			for (var _2L = 0, _2M = 4; _2L < _2M; _2L++) { /*9073*/
				$k[$j++] = 0; /*9073*/
			} /*9073*/
			var _2N = $a(); /*9073*/
			var _2O = $k[--$j]; /*9073*/
			$puti($k[--$j], _2O, _2N); /*9073*/
			for (var _2S = 2, _2R = $1.encstr.length - 16; _2S <= _2R; _2S += 3) { /*9081*/
				$1.i = _2S; /*9075*/
				$put($1.rscodes, ($1.rscodes.length - (~~(($1.i - 2) / 3))) - 1, (((~~$z($geti($1.encstr, $1.i, 1))) * 16) + ((~~$z($geti($1.encstr, $1.i + 1, 1))) * 4)) + (~~$z($geti($1.encstr, $1.i + 2, 1)))); /*9080*/
			} /*9080*/
			for (var _2g = $1.rscodes.length - 5; _2g >= 0; _2g -= 1) { /*9090*/
				$1.i = _2g; /*9083*/
				for (var _2h = 0; _2h <= 4; _2h += 1) { /*9089*/
					$1.j = _2h; /*9085*/
					$put($1.rscodes, $1.i + $1.j, $xo($get($1.rscodes, $1.i + $1.j), $get($1.rstable, (64 * $get($a([48, 17, 29, 30, 1]), $1.j)) + $get($1.rscodes, $1.i + 4)))); /*9088*/
				} /*9088*/
			} /*9088*/
			$1.checkcode = $strcpy($s(12), "000000000000"); /*9091*/
			for (var _2z = 0; _2z <= 3; _2z += 1) { /*9096*/
				$1.i = _2z; /*9093*/
				$1.enc = $cvrs($s(3), $get($1.rscodes, 3 - $1.i), 4); /*9094*/
				$puti($1.checkcode, ($1.i * 3) + (3 - $1.enc.length), $1.enc); /*9095*/
			} /*9095*/
			$puti($1.encstr, $1.encstr.length - 14, $1.checkcode); /*9099*/
			$puti($1.encstr, $1.encstr.length - 2, $get($1.encs, 74)); /*9100*/
			$1.bbs = $a($1.encstr.length); /*9102*/
			$1.bhs = $a($1.encstr.length); /*9103*/
			for (var _3M = 0, _3L = $1.encstr.length - 1; _3M <= _3L; _3M += 1) { /*9123*/
				$1.i = _3M; /*9105*/
				$1.enc = $geti($1.encstr, $1.i, 1); /*9106*/
				if ($eq($1.enc, "0")) { /*9110*/
					$put($1.bbs, $1.i, (0 * $1.height) / 8); /*9108*/
					$put($1.bhs, $1.i, (8 * $1.height) / 8); /*9109*/
				} /*9109*/
				if ($eq($1.enc, "1")) { /*9114*/
					$put($1.bbs, $1.i, (3 * $1.height) / 8); /*9112*/
					$put($1.bhs, $1.i, (5 * $1.height) / 8); /*9113*/
				} /*9113*/
				if ($eq($1.enc, "2")) { /*9118*/
					$put($1.bbs, $1.i, (0 * $1.height) / 8); /*9116*/
					$put($1.bhs, $1.i, (5 * $1.height) / 8); /*9117*/
				} /*9117*/
				if ($eq($1.enc, "3")) { /*9122*/
					$put($1.bbs, $1.i, (3 * $1.height) / 8); /*9120*/
					$put($1.bhs, $1.i, (2 * $1.height) / 8); /*9121*/
				} /*9121*/
			} /*9121*/
			$k[$j++] = Infinity; /*9134*/
			$k[$j++] = "ren"; /*9131*/
			$k[$j++] = $0.renlinear; /*9131*/
			$k[$j++] = "bbs"; /*9131*/
			$k[$j++] = $1.bbs; /*9131*/
			$k[$j++] = "bhs"; /*9131*/
			$k[$j++] = $1.bhs; /*9131*/
			$k[$j++] = "sbs"; /*9131*/
			$k[$j++] = Infinity; /*9131*/
			for (var _3v = 0, _3w = $1.bhs.length - 1; _3v < _3w; _3v++) { /*9130*/
				$k[$j++] = 1.44; /*9130*/
				$k[$j++] = 1.872; /*9130*/
			} /*9130*/
			$k[$j++] = 1.44; /*9130*/
			var _3x = $a(); /*9131*/
			$k[$j++] = _3x; /*9133*/
			if ($1.includetext) { /*9133*/
				$k[$j++] = "txt"; /*9132*/
				$k[$j++] = $1.txt; /*9132*/
			} /*9132*/
			$k[$j++] = "opt"; /*9134*/
			$k[$j++] = $1.options; /*9134*/
			var _41 = $d(); /*9134*/
			$k[$j++] = _41; /*9137*/
			if (!$1.dontdraw) { /*9137*/
				$0.renlinear(); /*9137*/
			} /*9137*/
		};
		$0.kix = function() {
			var $1 = {}; /*9164*/
			$1.options = $k[--$j]; /*9166*/
			$1.barcode = $k[--$j]; /*9167*/
			$1.dontdraw = false; /*9169*/
			$1.includetext = false; /*9170*/
			$1.textfont = "Courier"; /*9171*/
			$1.textsize = 10; /*9172*/
			$1.textyoffset = -8.5; /*9173*/
			$1.height = 0.175; /*9174*/
			$forall($1.options, function() { /*9185*/
				var _3 = $k[--$j]; /*9185*/
				$1[$k[--$j]] = _3; /*9185*/
			}); /*9185*/
			$1.textfont = "" + $1.textfont; /*9187*/
			$1.textsize = +$1.textsize; /*9188*/
			$1.textyoffset = +$1.textyoffset; /*9189*/
			$1.height = +$1.height; /*9190*/
			$1.encs = $a(["0033", "0123", "0132", "1023", "1032", "1122", "0213", "0303", "0312", "1203", "1212", "1302", "0231", "0321", "0330", "1221", "1230", "1320", "2013", "2103", "2112", "3003", "3012", "3102", "2031", "2121", "2130", "3021", "3030", "3120", "2211", "2301", "2310", "3201", "3210", "3300"]); /*9200*/
			$1.barchars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"; /*9203*/
			$1.charvals = {}; /*9204*/
			for (var _A = 0; _A <= 35; _A += 1) { /*9205*/
				$put($1.charvals, $geti($1.barchars, _A, 1), _A); /*9205*/
			} /*9205*/
			for (var _G = 0, _F = $1.barcode.length - 1; _G <= _F; _G += 1) { /*9212*/
				var _K = $get($1.charvals, $geti($1.barcode, _G, 1)) !== undefined; /*9209*/
				if (!_K) { /*9211*/
					$k[$j++] = "bwipp.kixBadCharacter"; /*9210*/
					$k[$j++] = "KIX must contain only capital letters and digits"; /*9210*/
					$0.raiseerror(); /*9210*/
				} /*9210*/
			} /*9210*/
			$1.barlen = $1.barcode.length; /*9214*/
			$1.encstr = $s($1.barlen * 4); /*9215*/
			$1.txt = $a($1.barlen); /*9216*/
			for (var _S = 0, _R = $1.barlen - 1; _S <= _R; _S += 1) { /*9223*/
				$1.i = _S; /*9219*/
				$1.indx = $get($1.charvals, $geti($1.barcode, $1.i, 1)); /*9220*/
				$puti($1.encstr, $1.i * 4, $get($1.encs, $1.indx)); /*9221*/
				$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), ($1.i * 4) * 3.312, $1.textyoffset, $1.textfont, $1.textsize])); /*9222*/
			} /*9222*/
			$1.bbs = $a($1.encstr.length); /*9225*/
			$1.bhs = $a($1.encstr.length); /*9226*/
			for (var _t = 0, _s = $1.encstr.length - 1; _t <= _s; _t += 1) { /*9246*/
				$1.i = _t; /*9228*/
				$1.enc = $geti($1.encstr, $1.i, 1); /*9229*/
				if ($eq($1.enc, "0")) { /*9233*/
					$put($1.bbs, $1.i, (3 * $1.height) / 8); /*9231*/
					$put($1.bhs, $1.i, (2 * $1.height) / 8); /*9232*/
				} /*9232*/
				if ($eq($1.enc, "1")) { /*9237*/
					$put($1.bbs, $1.i, (0 * $1.height) / 8); /*9235*/
					$put($1.bhs, $1.i, (5 * $1.height) / 8); /*9236*/
				} /*9236*/
				if ($eq($1.enc, "2")) { /*9241*/
					$put($1.bbs, $1.i, (3 * $1.height) / 8); /*9239*/
					$put($1.bhs, $1.i, (5 * $1.height) / 8); /*9240*/
				} /*9240*/
				if ($eq($1.enc, "3")) { /*9245*/
					$put($1.bbs, $1.i, (0 * $1.height) / 8); /*9243*/
					$put($1.bhs, $1.i, (8 * $1.height) / 8); /*9244*/
				} /*9244*/
			} /*9244*/
			$k[$j++] = Infinity; /*9257*/
			$k[$j++] = "ren"; /*9254*/
			$k[$j++] = $0.renlinear; /*9254*/
			$k[$j++] = "bbs"; /*9254*/
			$k[$j++] = $1.bbs; /*9254*/
			$k[$j++] = "bhs"; /*9254*/
			$k[$j++] = $1.bhs; /*9254*/
			$k[$j++] = "sbs"; /*9254*/
			$k[$j++] = Infinity; /*9254*/
			for (var _1S = 0, _1T = $1.bhs.length - 1; _1S < _1T; _1S++) { /*9253*/
				$k[$j++] = 1.44; /*9253*/
				$k[$j++] = 1.872; /*9253*/
			} /*9253*/
			$k[$j++] = 1.44; /*9253*/
			var _1U = $a(); /*9254*/
			$k[$j++] = _1U; /*9256*/
			if ($1.includetext) { /*9256*/
				$k[$j++] = "txt"; /*9255*/
				$k[$j++] = $1.txt; /*9255*/
			} /*9255*/
			$k[$j++] = "opt"; /*9257*/
			$k[$j++] = $1.options; /*9257*/
			var _1Y = $d(); /*9257*/
			$k[$j++] = _1Y; /*9260*/
			if (!$1.dontdraw) { /*9260*/
				$0.renlinear(); /*9260*/
			} /*9260*/
		};
		$0.japanpost = function() {
			var $1 = {}; /*9287*/
			$1.options = $k[--$j]; /*9289*/
			$1.barcode = $k[--$j]; /*9290*/
			$1.dontdraw = false; /*9292*/
			$1.includetext = false; /*9293*/
			$1.includecheckintext = false; /*9294*/
			$1.textfont = "Courier"; /*9295*/
			$1.textsize = 10; /*9296*/
			$1.textyoffset = -8.5; /*9297*/
			$1.height = 0.175; /*9298*/
			$forall($1.options, function() { /*9309*/
				var _3 = $k[--$j]; /*9309*/
				$1[$k[--$j]] = _3; /*9309*/
			}); /*9309*/
			$1.textfont = "" + $1.textfont; /*9311*/
			$1.textsize = +$1.textsize; /*9312*/
			$1.textyoffset = +$1.textyoffset; /*9313*/
			$1.height = +$1.height; /*9314*/
			$1.encs = $a(["300", "330", "312", "132", "321", "303", "123", "231", "213", "033", "030", "120", "102", "210", "012", "201", "021", "003", "333", "31", "13"]); /*9322*/
			$1.barchars = "0123456789-ABCDEFGHIJKLMNOPQRSTUVWXYZ"; /*9325*/
			$1.barlen = $1.barcode.length; /*9326*/
			$1.encstr = $s(((20 + 1) * 3) + 4); /*9328*/
			$1.digits = $a(20); /*9329*/
			$1.txt = $a($1.barlen + 1); /*9330*/
			$puti($1.encstr, 0, $get($1.encs, 19)); /*9333*/
			$1.checksum = 0; /*9335*/
			$1.j = 0; /*9336*/
			$1.i = 0; /*9336*/
			for (var _K = 0, _J = $1.barlen - 1; _K <= _J; _K += 1) { /*9370*/
				$1.i = _K; /*9338*/
				$search($1.barchars, $geti($1.barcode, $1.i, 1)); /*9339*/
				$j--; /*9340*/
				$1.indx = $k[--$j].length; /*9341*/
				$j -= 2; /*9342*/
				if (($1.indx >= 11) && ($1.indx < 37)) { /*9353*/
					if ($1.j > 18) { /*9344*/
						break; /*9344*/
					} /*9344*/
					$1.digit = (~~(($1.indx - 1) / 10)) + 10; /*9348*/
					$puti($1.encstr, ($1.j * 3) + 2, $get($1.encs, $1.digit)); /*9349*/
					$1.checksum = $1.checksum + $1.digit; /*9350*/
					$put($1.digits, $1.j, $1.digit); /*9351*/
					$1.j = $1.j + 1; /*9352*/
				} /*9352*/
				if ($1.j > 19) { /*9354*/
					break; /*9354*/
				} /*9354*/
				$1.digit = 0; /*9355*/
				if ($1.indx == 37) { /*9358*/
					$1.digit = 14; /*9357*/
				} /*9357*/
				if (($1.indx >= 11) && ($1.indx < 37)) { /*9361*/
					$1.digit = ($1.indx - 1) % 10; /*9360*/
				} /*9360*/
				if ($1.indx < 11) { /*9364*/
					$1.digit = $1.indx; /*9363*/
				} /*9363*/
				$puti($1.encstr, ($1.j * 3) + 2, $get($1.encs, $1.digit)); /*9365*/
				$1.checksum = $1.checksum + $1.digit; /*9366*/
				$put($1.digits, $1.j, $1.digit); /*9367*/
				$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), (($1.j * 3) + 2) * 3.312, $1.textyoffset, $1.textfont, $1.textsize])); /*9368*/
				$1.j = $1.j + 1; /*9369*/
			} /*9369*/
			for (var _19 = $1.j, _18 = 20 - 1; _19 <= _18; _19 += 1) { /*9378*/
				$1.k = _19; /*9374*/
				$puti($1.encstr, ($1.k * 3) + 2, $get($1.encs, 14)); /*9375*/
				$1.checksum = $1.checksum + 14; /*9376*/
				$put($1.digits, $1.k, 14); /*9377*/
			} /*9377*/
			$1.checksum = 19 - ($1.checksum % 19); /*9381*/
			$puti($1.encstr, 2 + (20 * 3), $get($1.encs, $1.checksum)); /*9382*/
			$puti($1.encstr, 2 + (21 * 3), $get($1.encs, 20)); /*9385*/
			$1.checkdigit = " "; /*9386*/
			if ($1.includecheckintext) { /*9389*/
				$1.checkdigit = $geti($1.barchars, $1.checksum, 1); /*9388*/
			} /*9388*/
			$put($1.txt, $1.i + 1, $a([$1.checkdigit, ((20 * 3) + 2) * 3.312, $1.textyoffset, $1.textfont, $1.textsize])); /*9390*/
			$puti($1.encstr, ((20 + 1) * 3) + 2, $get($1.encs, 20)); /*9393*/
			$1.bbs = $a((21 * 3) + 4); /*9395*/
			$1.bhs = $a($1.bbs.length); /*9396*/
			for (var _1i = 0, _1h = $1.bbs.length - 1; _1i <= _1h; _1i += 1) { /*9420*/
				$1.i = _1i; /*9398*/
				$1.enc = $geti($1.encstr, $1.i, 1); /*9399*/
				$1.bunit = 0; /*9400*/
				$1.hunit = 0; /*9401*/
				if ($eq($1.enc, "0")) { /*9405*/
					$1.bunit = 3; /*9403*/
					$1.hunit = 2; /*9404*/
				} /*9404*/
				if ($eq($1.enc, "1")) { /*9409*/
					$1.bunit = 0; /*9407*/
					$1.hunit = 5; /*9408*/
				} /*9408*/
				if ($eq($1.enc, "2")) { /*9413*/
					$1.bunit = 3; /*9411*/
					$1.hunit = 5; /*9412*/
				} /*9412*/
				if ($eq($1.enc, "3")) { /*9417*/
					$1.bunit = 0; /*9415*/
					$1.hunit = 8; /*9416*/
				} /*9416*/
				$put($1.bbs, $1.i, ($1.bunit * $1.height) / 8); /*9418*/
				$put($1.bhs, $1.i, ($1.hunit * $1.height) / 8); /*9419*/
			} /*9419*/
			$k[$j++] = Infinity; /*9431*/
			$k[$j++] = "ren"; /*9428*/
			$k[$j++] = $0.renlinear; /*9428*/
			$k[$j++] = "bbs"; /*9428*/
			$k[$j++] = $1.bbs; /*9428*/
			$k[$j++] = "bhs"; /*9428*/
			$k[$j++] = $1.bhs; /*9428*/
			$k[$j++] = "sbs"; /*9428*/
			$k[$j++] = Infinity; /*9428*/
			for (var _21 = 0, _22 = $1.bhs.length - 1; _21 < _22; _21++) { /*9427*/
				$k[$j++] = 1.44; /*9427*/
				$k[$j++] = 1.872; /*9427*/
			} /*9427*/
			$k[$j++] = 1.44; /*9427*/
			var _23 = $a(); /*9428*/
			$k[$j++] = _23; /*9430*/
			if ($1.includetext) { /*9430*/
				$k[$j++] = "txt"; /*9429*/
				$k[$j++] = $1.txt; /*9429*/
			} /*9429*/
			$k[$j++] = "opt"; /*9431*/
			$k[$j++] = $1.options; /*9431*/
			var _27 = $d(); /*9431*/
			$k[$j++] = _27; /*9434*/
			if (!$1.dontdraw) { /*9434*/
				$0.renlinear(); /*9434*/
			} /*9434*/
		};
		$0.msi = function() {
			var $1 = {}; /*9461*/
			$1.options = $k[--$j]; /*9463*/
			$1.barcode = $k[--$j]; /*9464*/
			$1.dontdraw = false; /*9466*/
			$1.includecheck = false; /*9467*/
			$1.includetext = false; /*9468*/
			$1.includecheckintext = false; /*9469*/
			$1.checktype = "mod10"; /*9470*/
			$1.badmod11 = false; /*9471*/
			$1.textfont = "Courier"; /*9472*/
			$1.textsize = 10; /*9473*/
			$1.textyoffset = -8.5; /*9474*/
			$1.height = 1; /*9475*/
			$forall($1.options, function() { /*9486*/
				var _3 = $k[--$j]; /*9486*/
				$1[$k[--$j]] = _3; /*9486*/
			}); /*9486*/
			$1.textfont = "" + $1.textfont; /*9488*/
			$1.textsize = +$1.textsize; /*9489*/
			$1.textyoffset = +$1.textyoffset; /*9490*/
			$1.height = +$1.height; /*9491*/
			$1.encs = $a(["12121212", "12121221", "12122112", "12122121", "12211212", "12211221", "12212112", "12212121", "21121212", "21121221", "21", "121"]); /*9498*/
			$1.barchars = "0123456789"; /*9501*/
			$1.barlen = $1.barcode.length; /*9503*/
			$1.txtlen = $1.barlen; /*9504*/
			$1.mod10 = function() {
				$1.code = $k[--$j]; /*9507*/
				$k[$j++] = 0; /*9508*/
				$k[$j++] = 0; /*9508*/
				$forall($1.code, function() { /*9508*/
					var _E = $k[--$j]; /*9508*/
					var _F = $k[--$j]; /*9508*/
					var _G = $k[--$j]; /*9508*/
					$k[$j++] = (_E - 48) + (_F * 10); /*9508*/
					$k[$j++] = _G; /*9508*/
				}); /*9508*/
				$j--; /*9508*/
				var _H = $k[--$j]; /*9508*/
				$k[$j++] = _H * 2; /*9509*/
				$k[$j++] = 0; /*9509*/
				for (;;) { /*9509*/
					var _I = $k[--$j]; /*9509*/
					var _J = $k[--$j]; /*9509*/
					var _K = ~~(_J / 10); /*9509*/
					$k[$j++] = _I + (_J % 10); /*9509*/
					$k[$j++] = _K; /*9509*/
					if (_K == 0) { /*9509*/
						$j--; /*9509*/
						break; /*9509*/
					} /*9509*/
					var _L = $k[--$j]; /*9509*/
					var _M = $k[--$j]; /*9509*/
					$k[$j++] = _L; /*9509*/
					$k[$j++] = _M; /*9509*/
				} /*9509*/
				$k[$j++] = 0; /*9510*/
				$k[$j++] = 0; /*9510*/
				$forall($1.code, function() { /*9510*/
					var _O = $k[--$j]; /*9510*/
					var _P = $k[--$j]; /*9510*/
					var _Q = $k[--$j]; /*9510*/
					$k[$j++] = _P + (_O - 48); /*9510*/
					$k[$j++] = _Q; /*9510*/
				}); /*9510*/
				var _R = $k[--$j]; /*9510*/
				var _S = $k[--$j]; /*9510*/
				var _V = $s($1.code.length + 1); /*9512*/
				$puti(_V, 0, $1.code); /*9512*/
				$put(_V, $1.code.length, ((10 - (($k[--$j] + _R) % 10)) % 10) + 48); /*9512*/
				$k[$j++] = _V; /*9512*/
			}; /*9513*/
			$1.mod11 = function() {
				$1.code = $k[--$j]; /*9516*/
				$k[$j++] = $1.code.length - 1; /*9517*/
				$forall($1.code, function() { /*9517*/
					var _b = $k[--$j]; /*9517*/
					var _c = $k[--$j]; /*9517*/
					$k[$j++] = _b - 48; /*9517*/
					$k[$j++] = (_c % 6) + 2; /*9517*/
					$k[$j++] = _c - 1; /*9517*/
				}); /*9517*/
				$j--; /*9517*/
				$k[$j++] = 0; /*9518*/
				for (var _e = 0, _f = $1.code.length; _e < _f; _e++) { /*9518*/
					var _g = $k[--$j]; /*9518*/
					var _h = $k[--$j]; /*9518*/
					var _i = $k[--$j]; /*9518*/
					$k[$j++] = _g + (_i * _h); /*9518*/
				} /*9518*/
				var _k = (11 - ($k[--$j] % 11)) % 11; /*9520*/
				$k[$j++] = _k; /*9524*/
				if ((_k == 10) && $1.badmod11) { /*9523*/
					$j--; /*9521*/
					var _n = $s($1.code.length + 2); /*9521*/
					$puti(_n, 0, $1.code); /*9521*/
					$puti(_n, $1.code.length, "10"); /*9521*/
					$k[$j++] = _n; /*9521*/
				} else { /*9523*/
					var _r = $s($1.code.length + 1); /*9523*/
					$puti(_r, 0, $1.code); /*9523*/
					$put(_r, $1.code.length, $k[--$j] + 48); /*9523*/
					$k[$j++] = _r; /*9523*/
				} /*9523*/
			}; /*9525*/
			$1.ncrmod11 = function() {
				$1.code = $k[--$j]; /*9528*/
				$k[$j++] = $1.code.length - 1; /*9529*/
				$forall($1.code, function() { /*9529*/
					var _y = $k[--$j]; /*9529*/
					var _z = $k[--$j]; /*9529*/
					$k[$j++] = _y - 48; /*9529*/
					$k[$j++] = (_z % 8) + 2; /*9529*/
					$k[$j++] = _z - 1; /*9529*/
				}); /*9529*/
				$j--; /*9529*/
				$k[$j++] = 0; /*9530*/
				for (var _11 = 0, _12 = $1.code.length; _11 < _12; _11++) { /*9530*/
					var _13 = $k[--$j]; /*9530*/
					var _14 = $k[--$j]; /*9530*/
					var _15 = $k[--$j]; /*9530*/
					$k[$j++] = _13 + (_15 * _14); /*9530*/
				} /*9530*/
				var _17 = (11 - ($k[--$j] % 11)) % 11; /*9532*/
				$k[$j++] = _17; /*9536*/
				if ((_17 == 10) && $1.badmod11) { /*9535*/
					$j--; /*9533*/
					var _1A = $s($1.code.length + 2); /*9533*/
					$puti(_1A, 0, $1.code); /*9533*/
					$puti(_1A, $1.code.length, "10"); /*9533*/
					$k[$j++] = _1A; /*9533*/
				} else { /*9535*/
					var _1E = $s($1.code.length + 1); /*9535*/
					$puti(_1E, 0, $1.code); /*9535*/
					$put(_1E, $1.code.length, $k[--$j] + 48); /*9535*/
					$k[$j++] = _1E; /*9535*/
				} /*9535*/
			}; /*9537*/
			if ($1.includecheck) { /*9550*/
				if ($eq($1.checktype, "mod10")) { /*9541*/
					$k[$j++] = $1.barcode; /*9541*/
					if ($1.mod10() == $b) return $b; /*9541*/
				} /*9541*/
				if ($eq($1.checktype, "mod1010")) { /*9542*/
					$k[$j++] = $1.barcode; /*9542*/
					if ($1.mod10() == $b) return $b; /*9542*/
					if ($1.mod10() == $b) return $b; /*9542*/
				} /*9542*/
				if ($eq($1.checktype, "mod11")) { /*9543*/
					$k[$j++] = $1.barcode; /*9543*/
					if ($1.mod11() == $b) return $b; /*9543*/
				} /*9543*/
				if ($eq($1.checktype, "ncrmod11")) { /*9544*/
					$k[$j++] = $1.barcode; /*9544*/
					if ($1.ncrmod11() == $b) return $b; /*9544*/
				} /*9544*/
				if ($eq($1.checktype, "mod1110")) { /*9545*/
					$k[$j++] = $1.barcode; /*9545*/
					if ($1.mod11() == $b) return $b; /*9545*/
					if ($1.mod10() == $b) return $b; /*9545*/
				} /*9545*/
				if ($eq($1.checktype, "ncrmod1110")) { /*9546*/
					$k[$j++] = $1.barcode; /*9546*/
					if ($1.ncrmod11() == $b) return $b; /*9546*/
					if ($1.mod10() == $b) return $b; /*9546*/
				} /*9546*/
				$1.barcode = $k[--$j]; /*9547*/
				$1.barlen = $1.barcode.length; /*9548*/
				if ($1.includecheckintext) { /*9549*/
					$1.txtlen = $1.barlen; /*9549*/
				} /*9549*/
			} /*9549*/
			$1.sbs = $s(($1.barlen * 8) + 5); /*9552*/
			$1.txt = $a($1.barlen); /*9553*/
			$puti($1.sbs, 0, $get($1.encs, 10)); /*9556*/
			for (var _1i = 0, _1h = $1.barlen - 1; _1i <= _1h; _1i += 1) { /*9568*/
				$1.i = _1i; /*9559*/
				$search($1.barchars, $geti($1.barcode, $1.i, 1)); /*9561*/
				$j--; /*9562*/
				$1.indx = $k[--$j].length; /*9563*/
				$j -= 2; /*9564*/
				$1.enc = $get($1.encs, $1.indx); /*9565*/
				$puti($1.sbs, ($1.i * 8) + 2, $1.enc); /*9566*/
				$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), ($1.i * 12) + 3, $1.textyoffset, $1.textfont, $1.textsize])); /*9567*/
			} /*9567*/
			$puti($1.sbs, ($1.barlen * 8) + 2, $get($1.encs, 11)); /*9571*/
			$k[$j++] = Infinity; /*9582*/
			$k[$j++] = "ren"; /*9577*/
			$k[$j++] = $0.renlinear; /*9577*/
			$k[$j++] = "sbs"; /*9577*/
			$k[$j++] = Infinity; /*9577*/
			var _28 = $1.sbs; /*9576*/
			for (var _29 = 0, _2A = _28.length; _29 < _2A; _29++) { /*9576*/
				$k[$j++] = $get(_28, _29) - 48; /*9576*/
			} /*9576*/
			var _2C = $a(); /*9577*/
			$k[$j++] = _2C; /*9578*/
			$k[$j++] = "bhs"; /*9578*/
			$k[$j++] = Infinity; /*9578*/
			for (var _2E = 0, _2F = ~~(($1.sbs.length + 1) / 2); _2E < _2F; _2E++) { /*9577*/
				$k[$j++] = $1.height; /*9577*/
			} /*9577*/
			var _2H = $a(); /*9578*/
			$k[$j++] = _2H; /*9579*/
			$k[$j++] = "bbs"; /*9579*/
			$k[$j++] = Infinity; /*9579*/
			for (var _2J = 0, _2K = ~~(($1.sbs.length + 1) / 2); _2J < _2K; _2J++) { /*9578*/
				$k[$j++] = 0; /*9578*/
			} /*9578*/
			var _2L = $a(); /*9579*/
			$k[$j++] = _2L; /*9581*/
			if ($1.includetext) { /*9581*/
				$k[$j++] = "txt"; /*9580*/
				$k[$j++] = $geti($1.txt, 0, $1.txtlen); /*9580*/
			} /*9580*/
			$k[$j++] = "opt"; /*9582*/
			$k[$j++] = $1.options; /*9582*/
			var _2R = $d(); /*9582*/
			$k[$j++] = _2R; /*9585*/
			if (!$1.dontdraw) { /*9585*/
				$0.renlinear(); /*9585*/
			} /*9585*/
		};
		$0.plessey = function() {
			var $1 = {}; /*9612*/
			$1.options = $k[--$j]; /*9614*/
			$1.barcode = $k[--$j]; /*9615*/
			$1.dontdraw = false; /*9617*/
			$1.includetext = false; /*9618*/
			$1.validatecheck = false; /*9619*/
			$1.includecheckintext = false; /*9620*/
			$1.unidirectional = false; /*9621*/
			$1.textfont = "Courier"; /*9622*/
			$1.textsize = 10; /*9623*/
			$1.textyoffset = -8.5; /*9624*/
			$1.height = 1; /*9625*/
			$forall($1.options, function() { /*9636*/
				var _3 = $k[--$j]; /*9636*/
				$1[$k[--$j]] = _3; /*9636*/
			}); /*9636*/
			$1.textfont = "" + $1.textfont; /*9638*/
			$1.textsize = +$1.textsize; /*9639*/
			$1.textyoffset = +$1.textyoffset; /*9640*/
			$1.height = +$1.height; /*9641*/
			$1.barchars = "0123456789ABCDEF"; /*9644*/
			$1.charvals = {}; /*9645*/
			for (var _9 = 0; _9 <= 15; _9 += 1) { /*9646*/
				$put($1.charvals, $geti($1.barchars, _9, 1), _9); /*9646*/
			} /*9646*/
			for (var _F = 0, _E = $1.barcode.length - 1; _F <= _E; _F += 1) { /*9653*/
				var _J = $get($1.charvals, $geti($1.barcode, _F, 1)) !== undefined; /*9650*/
				if (!_J) { /*9652*/
					$k[$j++] = "bwipp.plesseyBadCharacter"; /*9651*/
					$k[$j++] = "Plessey must contain only digits and letters A B C D E F"; /*9651*/
					$0.raiseerror(); /*9651*/
				} /*9651*/
			} /*9651*/
			$k[$j++] = "barlen"; /*9655*/
			$k[$j++] = $1.barcode.length; /*9655*/
			if ($1.validatecheck) { /*9655*/
				var _M = $k[--$j]; /*9655*/
				$k[$j++] = _M - 2; /*9655*/
			} /*9655*/
			var _N = $k[--$j]; /*9655*/
			$1[$k[--$j]] = _N; /*9655*/
			$1.checkbits = $a(($1.barlen * 4) + 8); /*9658*/
			$puti($1.checkbits, $1.barlen * 4, $a([0, 0, 0, 0, 0, 0, 0, 0])); /*9659*/
			for (var _W = 0, _V = $1.barlen - 1; _W <= _V; _W += 1) { /*9669*/
				$1.i = _W; /*9661*/
				$1.indx = $get($1.charvals, $geti($1.barcode, $1.i, 1)); /*9662*/
				$puti($1.checkbits, $1.i * 4, $a([$1.indx & 1, ($1.indx >>> 1) & 1, ($1.indx >>> 2) & 1, $1.indx >>> 3])); /*9668*/
			} /*9668*/
			$1.checksalt = $a([1, 1, 1, 1, 0, 1, 0, 0, 1]); /*9670*/
			for (var _m = 0, _l = ($1.barlen * 4) - 1; _m <= _l; _m += 1) { /*9679*/
				$1.i = _m; /*9672*/
				if ($get($1.checkbits, $1.i) == 1) { /*9678*/
					for (var _q = 0; _q <= 8; _q += 1) { /*9677*/
						$1.j = _q; /*9675*/
						$put($1.checkbits, $1.i + $1.j, $xo($get($1.checkbits, $1.i + $1.j), $get($1.checksalt, $1.j))); /*9676*/
					} /*9676*/
				} /*9676*/
			} /*9676*/
			$1.checkval = 0; /*9680*/
			for (var _11 = 0; _11 <= 7; _11 += 1) { /*9684*/
				$1.i = _11; /*9682*/
				$1.checkval = $1.checkval + ((~~Math.pow(2, $1.i)) * $get($1.checkbits, ($1.barlen * 4) + $1.i)); /*9683*/
			} /*9683*/
			$1.checksum1 = $1.checkval & 15; /*9685*/
			$1.checksum2 = $1.checkval >>> 4; /*9686*/
			if ($1.validatecheck) { /*9693*/
				if (($get($1.barcode, $1.barlen) != $get($1.barchars, $1.checksum1)) || ($get($1.barcode, $1.barlen + 1) != $get($1.barchars, $1.checksum2))) { /*9691*/
					$k[$j++] = "bwipp.plesseyBadCheckDigits"; /*9690*/
					$k[$j++] = "Incorrect Plessey check digits provided"; /*9690*/
					$0.raiseerror(); /*9690*/
				} /*9690*/
				$1.barcode = $geti($1.barcode, 0, $1.barlen); /*9692*/
			} /*9692*/
			$1.encs = $a(["14141414", "32141414", "14321414", "32321414", "14143214", "32143214", "14323214", "32323214", "14141432", "32141432", "14321432", "32321432", "14143232", "32143232", "14323232", "32323232", "32321432", "541412323", "323"]); /*9702*/
			var _1T = $1.unidirectional ? 27 : 33; /*9704*/
			$1.sbs = $s(($1.barlen * 8) + _1T); /*9704*/
			$1.txt = $a($1.barlen + 2); /*9705*/
			$puti($1.sbs, 0, $get($1.encs, 16)); /*9708*/
			for (var _1c = 0, _1b = $1.barlen - 1; _1c <= _1b; _1c += 1) { /*9715*/
				$1.i = _1c; /*9711*/
				$1.indx = $get($1.charvals, $geti($1.barcode, $1.i, 1)); /*9712*/
				$puti($1.sbs, ($1.i * 8) + 8, $get($1.encs, $1.indx)); /*9713*/
				$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), ($1.i * 20) + 20, $1.textyoffset, $1.textfont, $1.textsize])); /*9714*/
			} /*9714*/
			$puti($1.sbs, ($1.barlen * 8) + 8, $get($1.encs, $1.checksum1)); /*9718*/
			$puti($1.sbs, ($1.barlen * 8) + 16, $get($1.encs, $1.checksum2)); /*9719*/
			if ($1.includecheckintext) { /*9725*/
				$put($1.txt, $1.barlen, $a([$geti($1.barchars, $1.checksum1, 1), ($1.barlen * 20) + 20, $1.textyoffset, $1.textfont, $1.textsize])); /*9721*/
				$put($1.txt, $1.barlen + 1, $a([$geti($1.barchars, $1.checksum2, 1), (($1.barlen + 1) * 20) + 20, $1.textyoffset, $1.textfont, $1.textsize])); /*9722*/
			} else { /*9725*/
				$put($1.txt, $1.barlen, $a([" ", ($1.barlen * 20) + 20, $1.textyoffset, $1.textfont, $1.textsize])); /*9724*/
				$put($1.txt, $1.barlen + 1, $a([" ", (($1.barlen + 1) * 20) + 20, $1.textyoffset, $1.textfont, $1.textsize])); /*9725*/
			} /*9725*/
			var _2k = $1.unidirectional ? 18 : 17; /*9729*/
			$puti($1.sbs, ($1.barlen * 8) + 24, $get($1.encs, _2k)); /*9729*/
			$k[$j++] = Infinity; /*9740*/
			$k[$j++] = "ren"; /*9735*/
			$k[$j++] = $0.renlinear; /*9735*/
			$k[$j++] = "sbs"; /*9735*/
			$k[$j++] = Infinity; /*9735*/
			var _2m = $1.sbs; /*9734*/
			for (var _2n = 0, _2o = _2m.length; _2n < _2o; _2n++) { /*9734*/
				$k[$j++] = $get(_2m, _2n) - 48; /*9734*/
			} /*9734*/
			var _2q = $a(); /*9735*/
			$k[$j++] = _2q; /*9736*/
			$k[$j++] = "bhs"; /*9736*/
			$k[$j++] = Infinity; /*9736*/
			for (var _2s = 0, _2t = ~~(($1.sbs.length + 1) / 2); _2s < _2t; _2s++) { /*9735*/
				$k[$j++] = $1.height; /*9735*/
			} /*9735*/
			var _2v = $a(); /*9736*/
			$k[$j++] = _2v; /*9737*/
			$k[$j++] = "bbs"; /*9737*/
			$k[$j++] = Infinity; /*9737*/
			for (var _2x = 0, _2y = ~~(($1.sbs.length + 1) / 2); _2x < _2y; _2x++) { /*9736*/
				$k[$j++] = 0; /*9736*/
			} /*9736*/
			var _2z = $a(); /*9737*/
			$k[$j++] = _2z; /*9739*/
			if ($1.includetext) { /*9739*/
				$k[$j++] = "txt"; /*9738*/
				$k[$j++] = $1.txt; /*9738*/
			} /*9738*/
			$k[$j++] = "opt"; /*9740*/
			$k[$j++] = $1.options; /*9740*/
			var _33 = $d(); /*9740*/
			$k[$j++] = _33; /*9743*/
			if (!$1.dontdraw) { /*9743*/
				$0.renlinear(); /*9743*/
			} /*9743*/
		};
		$0.telepen = function() {
			var $1 = {}; /*9770*/
			$1.options = $k[--$j]; /*9772*/
			$1.barcode = $k[--$j]; /*9773*/
			$1.numeric = false; /*9775*/
			$1.dontdraw = false; /*9776*/
			$1.includetext = false; /*9777*/
			$1.textfont = "Courier"; /*9778*/
			$1.textsize = 10; /*9779*/
			$1.textyoffset = -8.5; /*9780*/
			$1.height = 1; /*9781*/
			$1.parse = false; /*9782*/
			$forall($1.options, function() { /*9793*/
				var _3 = $k[--$j]; /*9793*/
				$1[$k[--$j]] = _3; /*9793*/
			}); /*9793*/
			$1.textfont = "" + $1.textfont; /*9795*/
			$1.textsize = +$1.textsize; /*9796*/
			$1.textyoffset = +$1.textyoffset; /*9797*/
			$1.height = +$1.height; /*9798*/
			$1.encs = $a(["31313131", "1131313111", "33313111", "1111313131", "3111313111", "11333131", "13133131", "111111313111", "31333111", "1131113131", "33113131", "1111333111", "3111113131", "1113133111", "1311133111", "111111113131", "3131113111", "11313331", "333331", "111131113111", "31113331", "1133113111", "1313113111", "1111113331", "31131331", "113111113111", "3311113111", "1111131331", "311111113111", "1113111331", "1311111331", "11111111113111", "31313311", "1131311131", "33311131", "1111313311", "3111311131", "11333311", "13133311", "111111311131", "31331131", "1131113311", "33113311", "1111331131", "3111113311", "1113131131", "1311131131", "111111113311", "3131111131", "1131131311", "33131311", "111131111131", "3111131311", "1133111131", "1313111131", "111111131311", "3113111311", "113111111131", "3311111131", "111113111311", "311111111131", "111311111311", "131111111311", "11111111111131", "3131311111", "11313133", "333133", "111131311111", "31113133", "1133311111", "1313311111", "1111113133", "313333", "113111311111", "3311311111", "11113333", "311111311111", "11131333", "13111333", "11111111311111", "31311133", "1131331111", "33331111", "1111311133", "3111331111", "11331133", "13131133", "111111331111", "3113131111", "1131111133", "33111133", "111113131111", "3111111133", "111311131111", "131111131111", "111111111133", "31311313", "113131111111", "3331111111", "1111311313", "311131111111", "11331313", "13131313", "11111131111111", "3133111111", "1131111313", "33111313", "111133111111", "3111111313", "111313111111", "131113111111", "111111111313", "313111111111", "1131131113", "33131113", "11113111111111", "3111131113", "113311111111", "131311111111", "111111131113", "3113111113", "11311111111111", "331111111111", "111113111113", "31111111111111", "111311111113", "131111111113", "1111111111111111"]); /*9855*/
			$1.barlen = $1.barcode.length; /*9857*/
			$1.sbs = $s(($1.barlen * 16) + 48); /*9858*/
			$1.txt = $a($1.barlen); /*9859*/
			$1.enc = $get($1.encs, 95); /*9862*/
			$puti($1.sbs, 0, $1.enc); /*9863*/
			$1.l = $1.enc.length; /*9864*/
			$1.checksum = 0; /*9866*/
			$1.i = 0; /*9867*/
			$1.j = 0; /*9867*/
			for (;;) { /*9899*/
				if ($1.i == $1.barlen) { /*9869*/
					break; /*9869*/
				} /*9869*/
				if ($1.numeric) { /*9892*/
					if ($get($1.barcode, $1.i) > 16) { /*9883*/
						$1.np = $geti($1.barcode, $1.i, 2); /*9872*/
						if ($eq($geti($1.np, 1, 1), "X")) { /*9876*/
							$1.indx = (~~$z($geti($1.np, 0, 1))) + 17; /*9874*/
						} else { /*9876*/
							$1.indx = (~~$z($1.np)) + 27; /*9876*/
						} /*9876*/
						$put($1.txt, $1.j, $a([$1.np, ($1.j * 16) + 16, $1.textyoffset, $1.textfont, $1.textsize])); /*9878*/
						$1.i = $1.i + 2; /*9879*/
					} else { /*9883*/
						$1.indx = $get($1.barcode, $1.i); /*9881*/
						$put($1.txt, $1.j, $a([" ", ($1.j * 16) + 16, $1.textyoffset, $1.textfont, $1.textsize])); /*9882*/
						$1.i = $1.i + 1; /*9883*/
					} /*9883*/
				} else { /*9892*/
					$1.indx = $get($1.barcode, $1.i); /*9886*/
					if (($1.indx >= 32) && ($1.indx <= 126)) { /*9890*/
						$put($1.txt, $1.j, $a([$geti($1.barcode, $1.i, 1), ($1.j * 16) + 16, $1.textyoffset, $1.textfont, $1.textsize])); /*9888*/
					} else { /*9890*/
						$put($1.txt, $1.j, $a([" ", ($1.j * 16) + 16, $1.textyoffset, $1.textfont, $1.textsize])); /*9890*/
					} /*9890*/
					$1.i = $1.i + 1; /*9892*/
				} /*9892*/
				$1.checksum = $1.checksum + $1.indx; /*9894*/
				$1.enc = $get($1.encs, $1.indx); /*9895*/
				$puti($1.sbs, $1.l, $1.enc); /*9896*/
				$1.l = $1.l + $1.enc.length; /*9897*/
				$1.j = $1.j + 1; /*9898*/
			} /*9898*/
			$1.checksum = (127 - ($1.checksum % 127)) % 127; /*9902*/
			$1.enc = $get($1.encs, $1.checksum); /*9903*/
			$puti($1.sbs, $1.l, $1.enc); /*9904*/
			$1.l = $1.l + $1.enc.length; /*9905*/
			$1.enc = $get($1.encs, 122); /*9908*/
			$puti($1.sbs, $1.l, $1.enc); /*9909*/
			$1.l = $1.l + $1.enc.length; /*9910*/
			$1.sbs = $geti($1.sbs, 0, $1.l); /*9913*/
			$1.txt = $geti($1.txt, 0, $1.j); /*9914*/
			$k[$j++] = Infinity; /*9925*/
			$k[$j++] = "ren"; /*9920*/
			$k[$j++] = $0.renlinear; /*9920*/
			$k[$j++] = "sbs"; /*9920*/
			$k[$j++] = Infinity; /*9920*/
			$forall($1.sbs, function() { /*9919*/
				var _1n = $k[--$j]; /*9919*/
				$k[$j++] = _1n - 48; /*9919*/
			}); /*9919*/
			var _1o = $a(); /*9920*/
			$k[$j++] = _1o; /*9921*/
			$k[$j++] = "bhs"; /*9921*/
			$k[$j++] = Infinity; /*9921*/
			for (var _1q = 0, _1r = ~~(($1.sbs.length + 1) / 2); _1q < _1r; _1q++) { /*9920*/
				$k[$j++] = $1.height; /*9920*/
			} /*9920*/
			var _1t = $a(); /*9921*/
			$k[$j++] = _1t; /*9922*/
			$k[$j++] = "bbs"; /*9922*/
			$k[$j++] = Infinity; /*9922*/
			for (var _1v = 0, _1w = ~~(($1.sbs.length + 1) / 2); _1v < _1w; _1v++) { /*9921*/
				$k[$j++] = 0; /*9921*/
			} /*9921*/
			var _1x = $a(); /*9922*/
			$k[$j++] = _1x; /*9924*/
			if ($1.includetext) { /*9924*/
				$k[$j++] = "txt"; /*9923*/
				$k[$j++] = $1.txt; /*9923*/
			} /*9923*/
			$k[$j++] = "opt"; /*9925*/
			$k[$j++] = $1.options; /*9925*/
			var _21 = $d(); /*9925*/
			$k[$j++] = _21; /*9928*/
			if (!$1.dontdraw) { /*9928*/
				$0.renlinear(); /*9928*/
			} /*9928*/
		};
		$0.telepennumeric = function() {
			var $1 = {}; /*9956*/
			$1.options = $k[--$j]; /*9958*/
			$1.barcode = $k[--$j]; /*9959*/
			$1.dontdraw = false; /*9961*/
			$1.includetext = false; /*9962*/
			$1.textfont = "Courier"; /*9963*/
			$1.textsize = 10; /*9964*/
			$1.textxoffset = 0; /*9965*/
			$1.textyoffset = -8.5; /*9966*/
			$1.height = 1; /*9967*/
			$forall($1.options, function() { /*9978*/
				var _3 = $k[--$j]; /*9978*/
				$1[$k[--$j]] = _3; /*9978*/
			}); /*9978*/
			$1.textfont = "" + $1.textfont; /*9980*/
			$1.textsize = +$1.textsize; /*9981*/
			$1.textxoffset = +$1.textxoffset; /*9982*/
			$1.textyoffset = +$1.textyoffset; /*9983*/
			$1.height = +$1.height; /*9984*/
			$1.options.dontdraw = true; /*9987*/
			$1.options.numeric = true; /*9988*/
			$k[$j++] = "args"; /*9990*/
			$k[$j++] = $1.barcode; /*9990*/
			$k[$j++] = $1.options; /*9990*/
			$0.telepen(); /*9990*/
			var _E = $k[--$j]; /*9990*/
			$1[$k[--$j]] = _E; /*9990*/
			$1.args.opt = $1.options; /*9992*/
			$k[$j++] = $1.args; /*9995*/
			if (!$1.dontdraw) { /*9995*/
				$0.renlinear(); /*9995*/
			} /*9995*/
		};
		$0.posicode = function() {
			var $1 = {}; /*10022*/
			$1.options = $k[--$j]; /*10024*/
			$1.barcode = $k[--$j]; /*10025*/
			$1.dontdraw = false; /*10027*/
			$1.includetext = false; /*10028*/
			$1.textfont = "Courier"; /*10029*/
			$1.textsize = 10; /*10030*/
			$1.textxoffset = 0; /*10031*/
			$1.textyoffset = -8.5; /*10032*/
			$1.height = 1; /*10033*/
			$1.encoding = "auto"; /*10034*/
			$1.version = "a"; /*10035*/
			$1.checkoffset = 0; /*10036*/
			$1.raw = false; /*10037*/
			$1.parse = false; /*10038*/
			$1.parsefnc = false; /*10039*/
			$forall($1.options, function() { /*10050*/
				var _3 = $k[--$j]; /*10050*/
				$1[$k[--$j]] = _3; /*10050*/
			}); /*10050*/
			$1.textfont = "" + $1.textfont; /*10052*/
			$1.textsize = +$1.textsize; /*10053*/
			$1.textxoffset = +$1.textxoffset; /*10054*/
			$1.textyoffset = +$1.textyoffset; /*10055*/
			$1.encoding = "" + $1.encoding; /*10056*/
			$1.version = "" + $1.version; /*10057*/
			$1.checkoffset = ~~$1.checkoffset; /*10058*/
			$1.height = +$1.height; /*10059*/
			$1.barlen = $1.barcode.length; /*10082*/
			$1.la0 = -1; /*10085*/
			$1.la1 = -2; /*10085*/
			$1.la2 = -3; /*10085*/
			$1.sf0 = -4; /*10086*/
			$1.sf1 = -5; /*10086*/
			$1.sf2 = -6; /*10086*/
			$1.fn1 = -7; /*10087*/
			$1.fn2 = -8; /*10087*/
			$1.fn3 = -9; /*10087*/
			$1.fn4 = -10; /*10087*/
			var _1m = {
				normal: $a([$a(["0", "^", "'"]), $a(["1", ";", 27]), $a(["2", "<", 28]), $a(["3", "=", 29]), $a(["4", ">", 30]), $a(["5", "?", 31]), $a(["6", "@", "!"]), $a(["7", "[", "\""]), $a(["8", 92, "#"]), $a(["9", "]", "&"]), $a(["A", "a", 1]), $a(["B", "b", 2]), $a(["C", "c", 3]), $a(["D", "d", 4]), $a(["E", "e", 5]), $a(["F", "f", 6]), $a(["G", "g", 7]), $a(["H", "h", 8]), $a(["I", "i", 9]), $a(["J", "j", 10]), $a(["K", "k", 11]), $a(["L", "l", 12]), $a(["M", "m", 13]), $a(["N", "n", 14]), $a(["O", "o", 15]), $a(["P", "p", 16]), $a(["Q", "q", 17]), $a(["R", "r", 18]), $a(["S", "s", 19]), $a(["T", "t", 20]), $a(["U", "u", 21]), $a(["V", "v", 22]), $a(["W", "w", 23]), $a(["X", "x", 24]), $a(["Y", "y", 25]), $a(["Z", "z", 26]), $a(["-", "_", 40]), $a([".", "`", 41]), $a([" ", 127, 0]), $a(["$", "{", "*"]), $a(["/", "|", ","]), $a(["+", "}", ":"]), $a(["%", "~", $1.fn1]), $a([$1.la1, $1.la0, $1.fn2]), $a([$1.sf1, $1.sf0, $1.fn3]), $a([$1.sf2, $1.sf2, $1.fn4])]),
				limited: $a([$a(["0", -98, -98]), $a(["1", -98, -98]), $a(["2", -98, -98]), $a(["3", -98, -98]), $a(["4", -98, -98]), $a(["5", -98, -98]), $a(["6", -98, -98]), $a(["7", -98, -98]), $a(["8", -98, -98]), $a(["9", -98, -98]), $a(["A", -98, -98]), $a(["B", -98, -98]), $a(["C", -98, -98]), $a(["D", -98, -98]), $a(["E", -98, -98]), $a(["F", -98, -98]), $a(["G", -98, -98]), $a(["H", -98, -98]), $a(["I", -98, -98]), $a(["J", -98, -98]), $a(["K", -98, -98]), $a(["L", -98, -98]), $a(["M", -98, -98]), $a(["N", -98, -98]), $a(["O", -98, -98]), $a(["P", -98, -98]), $a(["Q", -98, -98]), $a(["R", -98, -98]), $a(["S", -98, -98]), $a(["T", -98, -98]), $a(["U", -98, -98]), $a(["V", -98, -98]), $a(["W", -98, -98]), $a(["X", -98, -98]), $a(["Y", -98, -98]), $a(["Z", -98, -98]), $a(["-", -98, -98]), $a([".", -98, -98])])
			}; /*10125*/
			$k[$j++] = _1m; /*10128*/
			if ($eq($1.version, "a") || $eq($1.version, "b")) { /*10128*/
				$k[$j++] = "normal"; /*10128*/
			} else { /*10128*/
				$k[$j++] = "limited"; /*10128*/
			} /*10128*/
			var _1p = $k[--$j]; /*10128*/
			$1.charmaps = $get($k[--$j], _1p); /*10129*/
			var _1s = $1.charmaps; /*10133*/
			var _1t = $1.charmaps; /*10133*/
			var _1u = $1.charmaps; /*10133*/
			$1.charvals = $a([{}, {}, {}]); /*10134*/
			for (var _1y = 0, _1x = $1.charmaps.length - 1; _1y <= _1x; _1y += 1) { /*10143*/
				$1.i = _1y; /*10136*/
				$1.encs = $get($1.charmaps, $1.i); /*10137*/
				for (var _22 = 0; _22 <= 2; _22 += 1) { /*10142*/
					$1.j = _22; /*10139*/
					var _25 = $get($1.encs, $1.j); /*10140*/
					$k[$j++] = _25; /*10140*/
					if ($eq($type(_25), "stringtype")) { /*10140*/
						var _28 = $get($k[--$j], 0); /*10140*/
						$k[$j++] = _28; /*10140*/
					} /*10140*/
					$put($get($1.charvals, $1.j), $k[--$j], $1.i); /*10141*/
				} /*10141*/
			} /*10141*/
			$1.set0 = $get($1.charvals, 0); /*10144*/
			$1.set1 = $get($1.charvals, 1); /*10145*/
			$1.set2 = $get($1.charvals, 2); /*10146*/
			if ($1.raw) { /*10148*/
				$1.encoding = "raw"; /*10148*/
			} /*10148*/
			if ($eq($1.encoding, "raw")) { /*10162*/
				$1.cws = $a($1.barlen); /*10151*/
				$1.i = 0; /*10152*/
				$1.j = 0; /*10152*/
				for (;;) { /*10159*/
					if ($1.i == $1.barlen) { /*10154*/
						break; /*10154*/
					} /*10154*/
					$1.cw = ~~$z($geti($1.barcode, $1.i + 1, 3)); /*10155*/
					$put($1.cws, $1.j, $1.cw); /*10156*/
					$1.i = $1.i + 4; /*10157*/
					$1.j = $1.j + 1; /*10158*/
				} /*10158*/
				$1.cws = $geti($1.cws, 0, $1.j); /*10160*/
				$1.text = ""; /*10161*/
			} /*10161*/
			if ($eq($1.encoding, "auto")) { /*10290*/
				var _2f = {
					FNC1: $1.fn1,
					FNC2: $1.fn2,
					FNC3: $1.fn3
				}; /*10169*/
				$1.fncvals = _2f; /*10171*/
				$1.msg = $a($1.barlen); /*10174*/
				$1.text = $s($1.barlen); /*10175*/
				$1.i = 0; /*10176*/
				$1.j = 0; /*10176*/
				for (;;) { /*10192*/
					if ($1.i == $1.barlen) { /*10177*/
						break; /*10177*/
					} /*10177*/
					$1.char = $get($1.barcode, $1.i); /*10178*/
					$put($1.text, $1.j, $1.char); /*10179*/
					if (($1.parsefnc && ($1.char == 94)) && ($1.i < ($1.barlen - 4))) { /*10188*/
						if ($get($1.barcode, $1.i + 1) != 94) { /*10186*/
							$1.char = $get($1.fncvals, $geti($1.barcode, $1.i + 1, 4)); /*10182*/
							$puti($1.text, $1.j, " "); /*10183*/
							$1.i = $1.i + 4; /*10184*/
						} else { /*10186*/
							$1.i = $1.i + 1; /*10186*/
						} /*10186*/
					} /*10186*/
					$put($1.msg, $1.j, $1.char); /*10189*/
					$1.i = $1.i + 1; /*10190*/
					$1.j = $1.j + 1; /*10191*/
				} /*10191*/
				$1.msg = $geti($1.msg, 0, $1.j); /*10193*/
				$1.msglen = $1.msg.length; /*10194*/
				$1.text = $geti($1.text, 0, $1.j); /*10195*/
				$k[$j++] = Infinity; /*10198*/
				for (var _3L = 0, _3M = $1.msglen; _3L < _3M; _3L++) { /*10198*/
					$k[$j++] = 0; /*10198*/
				} /*10198*/
				$k[$j++] = 0; /*10198*/
				$1.numSA = $a(); /*10198*/
				$k[$j++] = Infinity; /*10199*/
				for (var _3P = 0, _3Q = $1.msglen; _3P < _3Q; _3P++) { /*10199*/
					$k[$j++] = 0; /*10199*/
				} /*10199*/
				$k[$j++] = 0; /*10199*/
				$1.numEA = $a(); /*10199*/
				for (var _3T = $1.msglen - 1; _3T >= 0; _3T -= 1) { /*10209*/
					$1.i = _3T; /*10201*/
					if ($get($1.msg, $1.i) >= 0) { /*10208*/
						if ($get($1.msg, $1.i) >= 128) { /*10206*/
							$put($1.numEA, $1.i, $get($1.numEA, $1.i + 1) + 1); /*10204*/
						} else { /*10206*/
							$put($1.numSA, $1.i, $get($1.numSA, $1.i + 1) + 1); /*10206*/
						} /*10206*/
					} /*10206*/
				} /*10206*/
				$1.ea = false; /*10212*/
				$1.msgtmp = $a([]); /*10212*/
				for (var _3n = 0, _3m = $1.msglen - 1; _3n <= _3m; _3n += 1) { /*10227*/
					$1.i = _3n; /*10214*/
					$1.c = $get($1.msg, $1.i); /*10215*/
					if ((!$xo($1.ea, $1.c < 128)) && ($1.c >= 0)) { /*10225*/
						if ($1.ea) { /*10217*/
							$k[$j++] = $1.numSA; /*10217*/
						} else { /*10217*/
							$k[$j++] = $1.numEA; /*10217*/
						} /*10217*/
						var _3z = $get($k[--$j], $1.i); /*10217*/
						var _42 = ((_3z + $1.i) == $1.msglen) ? 3 : 5; /*10218*/
						if (_3z < _42) { /*10223*/
							$k[$j++] = Infinity; /*10220*/
							$aload($1.msgtmp); /*10220*/
							$k[$j++] = $1.fn4; /*10220*/
							$1.msgtmp = $a(); /*10220*/
						} else { /*10223*/
							$k[$j++] = Infinity; /*10222*/
							$aload($1.msgtmp); /*10222*/
							$k[$j++] = $1.fn4; /*10222*/
							$k[$j++] = $1.fn4; /*10222*/
							$1.msgtmp = $a(); /*10222*/
							$1.ea = !$1.ea; /*10223*/
						} /*10223*/
					} /*10223*/
					$k[$j++] = Infinity; /*10226*/
					$aload($1.msgtmp); /*10226*/
					if ($1.c >= 0) { /*10226*/
						$k[$j++] = $1.c & 127; /*10226*/
					} else { /*10226*/
						$k[$j++] = $1.c; /*10226*/
					} /*10226*/
					$1.msgtmp = $a(); /*10226*/
				} /*10226*/
				$1.msg = $1.msgtmp; /*10228*/
				$1.msglen = $1.msg.length; /*10229*/
				$1.enc = function() {
					var _4I = $k[--$j]; /*10233*/
					$put($1.cws, $1.j, $get(_4I, $k[--$j])); /*10233*/
					$1.j = $1.j + 1; /*10234*/
				}; /*10235*/
				$1.cws = $a($1.msglen * 2); /*10237*/
				$1.i = 0; /*10238*/
				$1.j = 0; /*10238*/
				$1.cset = "set0"; /*10238*/
				for (;;) { /*10288*/
					if ($1.i == $1.msglen) { /*10240*/
						break; /*10240*/
					} /*10240*/
					for (;;) { /*10286*/
						$1.char1 = $get($1.msg, $1.i); /*10245*/
						$k[$j++] = "char2"; /*10246*/
						if (($1.i + 1) < $1.msglen) { /*10246*/
							$k[$j++] = $get($1.msg, $1.i + 1); /*10246*/
						} else { /*10246*/
							$k[$j++] = -99; /*10246*/
						} /*10246*/
						var _4a = $k[--$j]; /*10246*/
						$1[$k[--$j]] = _4a; /*10246*/
						var _4f = $get($1[$1.cset], $1.char1) !== undefined; /*10249*/
						if (_4f) { /*10253*/
							$k[$j++] = $1.char1; /*10250*/
							$k[$j++] = $1[$1.cset]; /*10250*/
							if ($1.enc() == $b) break; /*10250*/
							$1.i = $1.i + 1; /*10251*/
							break; /*10252*/
						} /*10252*/
						var _4m = $get($1.set2, $1.char1) !== undefined; /*10256*/
						if (_4m) { /*10261*/
							$k[$j++] = $1.sf2; /*10257*/
							$k[$j++] = $1[$1.cset]; /*10257*/
							if ($1.enc() == $b) break; /*10257*/
							$k[$j++] = $1.char1; /*10258*/
							$k[$j++] = $1.set2; /*10258*/
							if ($1.enc() == $b) break; /*10258*/
							$1.i = $1.i + 1; /*10259*/
							break; /*10260*/
						} /*10260*/
						var _4w = $get($1[$1.cset], $1.char2) !== undefined; /*10264*/
						if (!_4w) { /*10282*/
							if ($eq($1.cset, "set0")) { /*10270*/
								$k[$j++] = $1.la1; /*10266*/
								$k[$j++] = $1[$1.cset]; /*10266*/
								if ($1.enc() == $b) break; /*10266*/
								$1.cset = "set1"; /*10267*/
							} else { /*10270*/
								$k[$j++] = $1.la0; /*10269*/
								$k[$j++] = $1[$1.cset]; /*10269*/
								if ($1.enc() == $b) break; /*10269*/
								$1.cset = "set0"; /*10270*/
							} /*10270*/
							break; /*10272*/
						} else { /*10282*/
							if ($eq($1.cset, "set0")) { /*10279*/
								$k[$j++] = $1.sf1; /*10275*/
								$k[$j++] = $1[$1.cset]; /*10275*/
								if ($1.enc() == $b) break; /*10275*/
								$k[$j++] = $1.char1; /*10276*/
								$k[$j++] = $1.set1; /*10276*/
								if ($1.enc() == $b) break; /*10276*/
							} else { /*10279*/
								$k[$j++] = $1.sf0; /*10278*/
								$k[$j++] = $1[$1.cset]; /*10278*/
								if ($1.enc() == $b) break; /*10278*/
								$k[$j++] = $1.char1; /*10279*/
								$k[$j++] = $1.set0; /*10279*/
								if ($1.enc() == $b) break; /*10279*/
							} /*10279*/
							$1.i = $1.i + 1; /*10281*/
							break; /*10282*/
						} /*10282*/
						break; /*10285*/
					} /*10285*/
				} /*10285*/
				$1.cws = $geti($1.cws, 0, $1.j); /*10289*/
			} /*10289*/
			var _5N = {
				a: $a(["141112", "131212", "121312", "111412", "131113", "121213", "111313", "121114", "111214", "111115", "181111", "171211", "161311", "151411", "141511", "131611", "121711", "111811", "171112", "161212", "151312", "141412", "131512", "121612", "111712", "161113", "151213", "141313", "131413", "121513", "111613", "151114", "141214", "131314", "121414", "111514", "141115", "131215", "121315", "111415", "131116", "121216", "111316", "121117", "111217", "111118", "1<111112", "111111111;1"]),
				b: $a(["151213", "141313", "131413", "121513", "141214", "131314", "121414", "131215", "121315", "121216", "191212", "181312", "171412", "161512", "151612", "141712", "131812", "121912", "181213", "171313", "161413", "151513", "141613", "131713", "121813", "171214", "161314", "151414", "141514", "131614", "121714", "161215", "151315", "141415", "131515", "121615", "151216", "141316", "131416", "121516", "141217", "131317", "121417", "131218", "121318", "121219", "1<121312", "121212121<1"]),
				limiteda: $a(["111411", "111312", "111213", "111114", "121311", "121212", "121113", "141111", "131211", "131112", "171111", "161211", "151311", "141411", "131511", "121611", "111711", "161112", "151212", "141312", "131412", "121512", "111612", "151113", "141213", "131313", "121413", "111513", "141114", "131214", "121314", "111414", "131115", "121215", "111315", "121116", "111216", "111117", "151111", "1"]),
				limitedb: $a(["121512", "121413", "121314", "121215", "131412", "131313", "131214", "151212", "141312", "141213", "181212", "171312", "161412", "151512", "141612", "131712", "121812", "171213", "161313", "151413", "141513", "131613", "121713", "161214", "151314", "141414", "131514", "121614", "151215", "141315", "131415", "121515", "141216", "131316", "121416", "131217", "121317", "121218", "141212", "1"])
			}; /*10336*/
			$1.encs = $get(_5N, $1.version); /*10339*/
			$1.c2w = $a([$a([495, 330, 210, 126, 70, 35, 15, 5]), $a([165, 120, 84, 56, 35, 20, 10, 4]), $a([45, 36, 28, 21, 15, 10, 6, 3]), $a([9, 8, 7, 6, 5, 4, 3, 2]), $a([1, 1, 1, 1, 1, 1, 1, 1])]); /*10347*/
			$1.v = 0; /*10348*/
			$forall($1.cws, function() { /*10358*/
				$1.cw = $k[--$j]; /*10350*/
				for (var _5Y = 0, _5Z = 6; _5Y < _5Z; _5Y++) { /*10357*/
					if ((($1.cw ^ $1.v) & 1) != 0) { /*10354*/
						$1.v = $1.v ^ 7682; /*10353*/
					} /*10353*/
					$1.v = $1.v >>> 1; /*10355*/
					$1.cw = $1.cw >>> 1; /*10356*/
				} /*10356*/
			}); /*10356*/
			$1.v = $1.v + $1.checkoffset; /*10359*/
			if ($eq($1.version, "limiteda") || $eq($1.version, "limitedb")) { /*10367*/
				$1.v = $1.v & 1023; /*10362*/
				if (($1.v > 824) && ($1.v < 853)) { /*10365*/
					$1.v = $1.v + 292; /*10364*/
				} /*10364*/
			} else { /*10367*/
				$1.v = ($1.v & 1023) + 45; /*10367*/
			} /*10367*/
			$1.d = $a([2, 2, 2, 2, 2, 2]); /*10370*/
			$1.r = 0; /*10371*/
			$1.c = 0; /*10371*/
			$1.w = 0; /*10371*/
			$1.sum = 0; /*10371*/
			for (;;) { /*10390*/
				if ($1.sum == $1.v) { /*10373*/
					break; /*10373*/
				} /*10373*/
				$1.t = $1.sum + $get($get($1.c2w, $1.r), $1.c); /*10374*/
				if ($1.t == $1.v) { /*10379*/
					$1.w = $1.w + 1; /*10376*/
					$put($1.d, $1.r, $1.w + 2); /*10377*/
					$1.sum = $1.t; /*10378*/
				} /*10378*/
				if ($1.t > $1.v) { /*10384*/
					$put($1.d, $1.r, $1.w + 2); /*10381*/
					$1.r = $1.r + 1; /*10382*/
					$1.w = 0; /*10383*/
				} /*10383*/
				if ($1.t < $1.v) { /*10389*/
					$1.c = $1.c + 1; /*10386*/
					$1.w = $1.w + 1; /*10387*/
					$1.sum = $1.t; /*10388*/
				} /*10388*/
			} /*10388*/
			$k[$j++] = 20; /*10391*/
			for (var _6F = 0; _6F <= 4; _6F += 1) { /*10391*/
				var _6I = $k[--$j]; /*10391*/
				$k[$j++] = _6I - $get($1.d, _6F); /*10391*/
			} /*10391*/
			$put($1.d, 5, $k[--$j]); /*10392*/
			if ($eq($1.version, "b") || $eq($1.version, "limitedb")) { /*10395*/
				$k[$j++] = Infinity; /*10394*/
				var _6N = $1.d; /*10394*/
				for (var _6O = 0, _6P = _6N.length; _6O < _6P; _6O++) { /*10394*/
					$k[$j++] = $get(_6N, _6O) + 1; /*10394*/
				} /*10394*/
				$1.d = $a(); /*10394*/
			} /*10394*/
			$1.cbs = $strcpy($s(12), "111111111111"); /*10396*/
			for (var _6U = 5; _6U >= 0; _6U -= 1) { /*10400*/
				$1.i = _6U; /*10398*/
				$put($1.cbs, ((5 - $1.i) * 2) + 1, $get($1.d, $1.i) + 47); /*10399*/
			} /*10399*/
			$1.sbs = $s(($1.cws.length * 6) + 31); /*10403*/
			var _6e = $get($1.encs, $1.encs.length - 2); /*10404*/
			$puti($1.sbs, 0, _6e); /*10405*/
			$1.j = _6e.length; /*10406*/
			for (var _6i = 0, _6h = $1.cws.length - 1; _6i <= _6h; _6i += 1) { /*10411*/
				$1.i = _6i; /*10408*/
				$puti($1.sbs, $1.j, $get($1.encs, $get($1.cws, $1.i))); /*10409*/
				$1.j = $1.j + 6; /*10410*/
			} /*10410*/
			$puti($1.sbs, $1.j, $1.cbs); /*10412*/
			$1.j = $1.j + 12; /*10413*/
			var _6x = $get($1.encs, $1.encs.length - 1); /*10414*/
			$puti($1.sbs, $1.j, _6x); /*10415*/
			$1.j = _6x.length + $1.j; /*10416*/
			$1.sbs = $geti($1.sbs, 0, $1.j); /*10417*/
			$k[$j++] = Infinity; /*10427*/
			$k[$j++] = "ren"; /*10423*/
			$k[$j++] = $0.renlinear; /*10423*/
			$k[$j++] = "sbs"; /*10423*/
			$k[$j++] = Infinity; /*10423*/
			$forall($1.sbs, function() { /*10422*/
				var _75 = $k[--$j]; /*10422*/
				$k[$j++] = _75 - 48; /*10422*/
			}); /*10422*/
			var _76 = $a(); /*10423*/
			$k[$j++] = _76; /*10424*/
			$k[$j++] = "bhs"; /*10424*/
			$k[$j++] = Infinity; /*10424*/
			for (var _78 = 0, _79 = ~~(($1.sbs.length + 1) / 2); _78 < _79; _78++) { /*10423*/
				$k[$j++] = $1.height; /*10423*/
			} /*10423*/
			var _7B = $a(); /*10424*/
			$k[$j++] = _7B; /*10425*/
			$k[$j++] = "bbs"; /*10425*/
			$k[$j++] = Infinity; /*10425*/
			for (var _7D = 0, _7E = ~~(($1.sbs.length + 1) / 2); _7D < _7E; _7D++) { /*10424*/
				$k[$j++] = 0; /*10424*/
			} /*10424*/
			var _7F = $a(); /*10425*/
			$k[$j++] = _7F; /*10427*/
			$k[$j++] = "txt"; /*10427*/
			$k[$j++] = $a([$a([$1.text, $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])]); /*10427*/
			$k[$j++] = "textxalign"; /*10427*/
			$k[$j++] = "center"; /*10427*/
			$k[$j++] = "opt"; /*10427*/
			$k[$j++] = $1.options; /*10427*/
			var _7O = $d(); /*10427*/
			$k[$j++] = _7O; /*10430*/
			if (!$1.dontdraw) { /*10430*/
				$0.renlinear(); /*10430*/
			} /*10430*/
		};
		$0.codablockf = function() {
			var $1 = {}; /*10457*/
			$1.options = $k[--$j]; /*10459*/
			$1.barcode = $k[--$j]; /*10460*/
			$1.dontdraw = false; /*10462*/
			$1.rows = -1; /*10463*/
			$1.columns = 8; /*10464*/
			$1.rowheight = 10; /*10465*/
			$1.sepheight = 1; /*10466*/
			$1.parse = false; /*10467*/
			$1.parsefnc = false; /*10468*/
			$forall($1.options, function() { /*10479*/
				var _3 = $k[--$j]; /*10479*/
				$1[$k[--$j]] = _3; /*10479*/
			}); /*10479*/
			$1.rows = ~~$1.rows; /*10481*/
			$1.columns = ~~$1.columns; /*10482*/
			$1.rowheight = ~~$1.rowheight; /*10483*/
			$1.sepheight = ~~$1.sepheight; /*10484*/
			if ((($1.columns >= 4) && ($1.columns <= 62)) && ((($1.rows >= 2) && ($1.rows <= 44)) || ($1.rows == -1))) { /*10487*/
				$1.c = $1.columns; /*10487*/
			} /*10487*/
			$1.barlen = $1.barcode.length; /*10510*/
			$1.swa = -1; /*10513*/
			$1.swb = -2; /*10513*/
			$1.swc = -3; /*10513*/
			$1.sft = -4; /*10513*/
			$1.fn1 = -5; /*10514*/
			$1.fn2 = -6; /*10514*/
			$1.fn3 = -7; /*10514*/
			$1.fn4 = -8; /*10514*/
			$1.sta = -9; /*10515*/
			$1.stp = -10; /*10515*/
			$1.charmaps = $a([$a([32, 32, "00"]), $a(["!", "!", "01"]), $a(["\"", "\"", "02"]), $a(["#", "#", "03"]), $a(["$", "$", "04"]), $a(["%", "%", "05"]), $a(["&", "&", "06"]), $a(["'", "'", "07"]), $a([40, 40, "08"]), $a([41, 41, "09"]), $a(["*", "*", "10"]), $a(["+", "+", "11"]), $a([",", ",", "12"]), $a(["-", "-", "13"]), $a([".", ".", "14"]), $a(["/", "/", "15"]), $a(["0", "0", "16"]), $a(["1", "1", "17"]), $a(["2", "2", "18"]), $a(["3", "3", "19"]), $a(["4", "4", "20"]), $a(["5", "5", "21"]), $a(["6", "6", "22"]), $a(["7", "7", "23"]), $a(["8", "8", "24"]), $a(["9", "9", "25"]), $a([":", ":", "26"]), $a([";", ";", "27"]), $a(["<", "<", "28"]), $a(["=", "=", "29"]), $a([">", ">", "30"]), $a(["?", "?", "31"]), $a(["@", "@", "32"]), $a(["A", "A", "33"]), $a(["B", "B", "34"]), $a(["C", "C", "35"]), $a(["D", "D", "36"]), $a(["E", "E", "37"]), $a(["F", "F", "38"]), $a(["G", "G", "39"]), $a(["H", "H", "40"]), $a(["I", "I", "41"]), $a(["J", "J", "42"]), $a(["K", "K", "43"]), $a(["L", "L", "44"]), $a(["M", "M", "45"]), $a(["N", "N", "46"]), $a(["O", "O", "47"]), $a(["P", "P", "48"]), $a(["Q", "Q", "49"]), $a(["R", "R", "50"]), $a(["S", "S", "51"]), $a(["T", "T", "52"]), $a(["U", "U", "53"]), $a(["V", "V", "54"]), $a(["W", "W", "55"]), $a(["X", "X", "56"]), $a(["Y", "Y", "57"]), $a(["Z", "Z", "58"]), $a(["[", "[", "59"]), $a([92, 92, "60"]), $a(["]", "]", "61"]), $a(["^", "^", "62"]), $a(["_", "_", "63"]), $a([0, "`", "64"]), $a([1, "a", "65"]), $a([2, "b", "66"]), $a([3, "c", "67"]), $a([4, "d", "68"]), $a([5, "e", "69"]), $a([6, "f", "70"]), $a([7, "g", "71"]), $a([8, "h", "72"]), $a([9, "i", "73"]), $a([10, "j", "74"]), $a([11, "k", "75"]), $a([12, "l", "76"]), $a([13, "m", "77"]), $a([14, "n", "78"]), $a([15, "o", "79"]), $a([16, "p", "80"]), $a([17, "q", "81"]), $a([18, "r", "82"]), $a([19, "s", "83"]), $a([20, "t", "84"]), $a([21, "u", "85"]), $a([22, "v", "86"]), $a([23, "w", "87"]), $a([24, "x", "88"]), $a([25, "y", "89"]), $a([26, "z", "90"]), $a([27, "{", "91"]), $a([28, "|", "92"]), $a([29, "}", "93"]), $a([30, "~", "94"]), $a([31, 127, "95"]), $a([$1.fn3, $1.fn3, "96"]), $a([$1.fn2, $1.fn2, "97"]), $a([$1.sft, $1.sft, "98"]), $a([$1.swc, $1.swc, "99"]), $a([$1.swb, $1.fn4, $1.swb]), $a([$1.fn4, $1.swa, $1.swa]), $a([$1.fn1, $1.fn1, $1.fn1]), $a([$1.sta, $1.sta, $1.sta]), $a([$1.stp, $1.stp, $1.stp])]); /*10555*/
			$1.charvals = $a([{}, {}, {}]); /*10558*/
			for (var _2O = 0, _2N = $1.charmaps.length - 1; _2O <= _2N; _2O += 1) { /*10567*/
				$1.i = _2O; /*10560*/
				$1.encs = $get($1.charmaps, $1.i); /*10561*/
				for (var _2S = 0; _2S <= 2; _2S += 1) { /*10566*/
					$1.j = _2S; /*10563*/
					var _2V = $get($1.encs, $1.j); /*10564*/
					$k[$j++] = _2V; /*10564*/
					if ($eq($type(_2V), "stringtype")) { /*10564*/
						var _2Y = $get($k[--$j], 0); /*10564*/
						$k[$j++] = _2Y; /*10564*/
					} /*10564*/
					$put($get($1.charvals, $1.j), $k[--$j], $1.i); /*10565*/
				} /*10565*/
			} /*10565*/
			$1.seta = $get($1.charvals, 0); /*10568*/
			$1.setb = $get($1.charvals, 1); /*10569*/
			$1.setc = $get($1.charvals, 2); /*10570*/
			var _2m = {
				FNC1: $1.fn1,
				FNC3: $1.fn3
			}; /*10575*/
			$1.fncvals = _2m; /*10577*/
			$1.msg = $a($1.barlen); /*10578*/
			$1.i = 0; /*10579*/
			$1.j = 0; /*10579*/
			for (;;) { /*10593*/
				if ($1.i == $1.barlen) { /*10580*/
					break; /*10580*/
				} /*10580*/
				$1.char = $get($1.barcode, $1.i); /*10581*/
				if (($1.parsefnc && ($1.char == 94)) && ($1.i < ($1.barlen - 4))) { /*10589*/
					if ($get($1.barcode, $1.i + 1) != 94) { /*10587*/
						$1.char = $get($1.fncvals, $geti($1.barcode, $1.i + 1, 4)); /*10584*/
						$1.i = $1.i + 4; /*10585*/
					} else { /*10587*/
						$1.i = $1.i + 1; /*10587*/
					} /*10587*/
				} /*10587*/
				$put($1.msg, $1.j, $1.char); /*10590*/
				$1.i = $1.i + 1; /*10591*/
				$1.j = $1.j + 1; /*10592*/
			} /*10592*/
			$1.msg = $geti($1.msg, 0, $1.j); /*10594*/
			$1.msglen = $1.msg.length; /*10595*/
			$1.msgtmp = $a([]); /*10598*/
			$forall($1.msg, function() { /*10602*/
				$1.char = $k[--$j]; /*10600*/
				$k[$j++] = Infinity; /*10601*/
				$aload($1.msgtmp); /*10601*/
				if ($1.char < 128) { /*10601*/
					$k[$j++] = $1.char; /*10601*/
				} else { /*10601*/
					$k[$j++] = $1.fn4; /*10601*/
					$k[$j++] = $1.char & 127; /*10601*/
				} /*10601*/
				$1.msgtmp = $a(); /*10601*/
			}); /*10601*/
			$1.msg = $1.msgtmp; /*10603*/
			$1.msglen = $1.msg.length; /*10604*/
			$1.numsscr = function() {
				$1.n = 0; /*10608*/
				$1.s = 0; /*10608*/
				$1.p = $k[--$j]; /*10609*/
				for (;;) { /*10620*/
					if ($1.p >= $1.msglen) { /*10610*/
						break; /*10610*/
					} /*10610*/
					var _3X = $get($1.msg, $1.p); /*10611*/
					var _3Z = $get($1.setc, _3X) !== undefined; /*10612*/
					$k[$j++] = _3X; /*10612*/
					if (!_3Z) { /*10612*/
						$j--; /*10612*/
						break; /*10612*/
					} /*10612*/
					if ($k[--$j] == $1.fn1) { /*10616*/
						if (($1.s % 2) == 0) { /*10615*/
							$1.s = $1.s + 1; /*10615*/
						} else { /*10615*/
							break; /*10615*/
						} /*10615*/
					} /*10615*/
					$1.n = $1.n + 1; /*10617*/
					$1.s = $1.s + 1; /*10618*/
					$1.p = $1.p + 1; /*10619*/
				} /*10619*/
				$k[$j++] = $1.n; /*10621*/
				$k[$j++] = $1.s; /*10621*/
			}; /*10622*/
			$1.enca = function() {
				$put($1.cws, $1.j, $get($1.seta, $k[--$j])); /*10626*/
				$1.j = $1.j + 1; /*10627*/
			}; /*10628*/
			$1.encb = function() {
				$put($1.cws, $1.j, $get($1.setb, $k[--$j])); /*10630*/
				$1.j = $1.j + 1; /*10631*/
			}; /*10632*/
			$1.encc = function() {
				var _3v = $k[--$j]; /*10634*/
				$k[$j++] = _3v; /*10638*/
				if ($ne($type(_3v), "arraytype")) { /*10637*/
					var _3z = $get($1.setc, $k[--$j]); /*10635*/
					$k[$j++] = _3z; /*10635*/
				} else { /*10637*/
					$aload($k[--$j]); /*10637*/
					var _41 = $k[--$j]; /*10637*/
					var _42 = $k[--$j]; /*10637*/
					$k[$j++] = (_41 - 48) + ((_42 - 48) * 10); /*10637*/
				} /*10637*/
				$put($1.cws, $1.j, $k[--$j]); /*10639*/
				$1.j = $1.j + 1; /*10640*/
			}; /*10641*/
			$1.anotb = function() {
				var _47 = $k[--$j]; /*10644*/
				var _49 = $get($1.seta, _47) !== undefined; /*10644*/
				var _4B = $get($1.setb, _47) !== undefined; /*10644*/
				$k[$j++] = _49 && (!_4B); /*10644*/
			}; /*10644*/
			$1.bnota = function() {
				var _4C = $k[--$j]; /*10645*/
				var _4E = $get($1.setb, _4C) !== undefined; /*10645*/
				var _4G = $get($1.seta, _4C) !== undefined; /*10645*/
				$k[$j++] = _4E && (!_4G); /*10645*/
			}; /*10645*/
			$k[$j++] = Infinity; /*10648*/
			for (var _4I = 0, _4J = $1.msg.length; _4I < _4J; _4I++) { /*10648*/
				$k[$j++] = 0; /*10648*/
			} /*10648*/
			$k[$j++] = 9999; /*10648*/
			$1.nextanotb = $a(); /*10648*/
			$k[$j++] = Infinity; /*10649*/
			for (var _4M = 0, _4N = $1.msg.length; _4M < _4N; _4M++) { /*10649*/
				$k[$j++] = 0; /*10649*/
			} /*10649*/
			$k[$j++] = 9999; /*10649*/
			$1.nextbnota = $a(); /*10649*/
			for (var _4Q = $1.msg.length - 1; _4Q >= 0; _4Q -= 1) { /*10662*/
				$1.i = _4Q; /*10651*/
				$k[$j++] = $get($1.msg, $1.i); /*10652*/
				if ($1.anotb() == $b) break; /*10652*/
				if ($k[--$j]) { /*10655*/
					$put($1.nextanotb, $1.i, 0); /*10653*/
				} else { /*10655*/
					$put($1.nextanotb, $1.i, $get($1.nextanotb, $1.i + 1) + 1); /*10655*/
				} /*10655*/
				$k[$j++] = $get($1.msg, $1.i); /*10657*/
				if ($1.bnota() == $b) break; /*10657*/
				if ($k[--$j]) { /*10660*/
					$put($1.nextbnota, $1.i, 0); /*10658*/
				} else { /*10660*/
					$put($1.nextbnota, $1.i, $get($1.nextbnota, $1.i + 1) + 1); /*10660*/
				} /*10660*/
			} /*10660*/
			$1.abeforeb = function() {
				var _4n = $k[--$j]; /*10665*/
				$k[$j++] = $lt($get($1.nextanotb, _4n), $get($1.nextbnota, _4n)); /*10665*/
			}; /*10665*/
			$1.bbeforea = function() {
				var _4s = $k[--$j]; /*10666*/
				$k[$j++] = $lt($get($1.nextbnota, _4s), $get($1.nextanotb, _4s)); /*10666*/
			}; /*10666*/
			$1.padrow = function() {
				for (var _4y = 0, _4z = $k[--$j]; _4y < _4z; _4y++) { /*10676*/
					for (;;) { /*10675*/
						if ($eq($1.cset, "seta")) { /*10672*/
							$k[$j++] = $1.swc; /*10672*/
							if ($1.enca() == $b) break; /*10672*/
							$1.cset = "setc"; /*10672*/
							break; /*10672*/
						} /*10672*/
						if ($eq($1.cset, "setb")) { /*10673*/
							$k[$j++] = $1.swc; /*10673*/
							if ($1.encb() == $b) break; /*10673*/
							$1.cset = "setc"; /*10673*/
							break; /*10673*/
						} /*10673*/
						if ($eq($1.cset, "setc")) { /*10674*/
							$k[$j++] = $1.swb; /*10674*/
							if ($1.encc() == $b) break; /*10674*/
							$1.cset = "setb"; /*10674*/
							break; /*10674*/
						} /*10674*/
					} /*10674*/
				} /*10674*/
			}; /*10677*/
			$k[$j++] = "cws"; /*10680*/
			$k[$j++] = $1.c + 5; /*10680*/
			if ($1.rows != -1) { /*10680*/
				$k[$j++] = $1.rows; /*10680*/
			} else { /*10680*/
				$k[$j++] = 44; /*10680*/
			} /*10680*/
			var _59 = $k[--$j]; /*10680*/
			var _5B = $a($k[--$j] * _59); /*10680*/
			$1[$k[--$j]] = _5B; /*10680*/
			$1.i = 0; /*10682*/
			$1.j = 0; /*10682*/
			$1.r = 1; /*10682*/
			$1.lastrow = false; /*10683*/
			for (;;) { /*10851*/
				if ($1.lastrow) { /*10685*/
					break; /*10685*/
				} /*10685*/
				$k[$j++] = $1.sta; /*10688*/
				if ($1.enca() == $b) break; /*10688*/
				if ($1.i < $1.msglen) { /*10689*/
					$k[$j++] = $1.i; /*10689*/
					if ($1.numsscr() == $b) break; /*10689*/
				} else { /*10689*/
					$k[$j++] = -1; /*10689*/
					$k[$j++] = -1; /*10689*/
				} /*10689*/
				$1.nums = $k[--$j]; /*10689*/
				$1.nchars = $k[--$j]; /*10689*/
				for (;;) { /*10709*/
					if ($1.msglen == 0) { /*10695*/
						$k[$j++] = $1.swb; /*10692*/
						if ($1.enca() == $b) break; /*10692*/
						$1.cset = "setb"; /*10693*/
						break; /*10694*/
					} /*10694*/
					if ($1.nums >= 2) { /*10700*/
						$k[$j++] = $1.swc; /*10697*/
						if ($1.enca() == $b) break; /*10697*/
						$1.cset = "setc"; /*10698*/
						break; /*10699*/
					} /*10699*/
					$k[$j++] = $1.i; /*10701*/
					if ($1.abeforeb() == $b) break; /*10701*/
					if ($k[--$j]) { /*10705*/
						$k[$j++] = $1.sft; /*10702*/
						if ($1.enca() == $b) break; /*10702*/
						$1.cset = "seta"; /*10703*/
						break; /*10704*/
					} /*10704*/
					$k[$j++] = $1.swb; /*10706*/
					if ($1.enca() == $b) break; /*10706*/
					$1.cset = "setb"; /*10707*/
					break; /*10708*/
				} /*10708*/
				$1.j = $1.j + 1; /*10710*/
				$1.endofrow = false; /*10713*/
				for (;;) { /*10836*/
					$1.rem = ($1.c + 3) - ($1.j % ($1.c + 5)); /*10714*/
					if (($1.i == $1.msglen) || $1.endofrow) { /*10716*/
						break; /*10716*/
					} /*10716*/
					$k[$j++] = $1.i; /*10718*/
					if ($1.numsscr() == $b) break; /*10718*/
					$1.nums = $k[--$j]; /*10718*/
					$1.nchars = $k[--$j]; /*10718*/
					for (;;) { /*10834*/
						if ((($eq($1.cset, "seta") || $eq($1.cset, "setb")) && ($1.nums >= 4)) && ($get($1.msg, $1.i) != $1.fn1)) { /*10756*/
							if ((($1.nums % 2) == 0) && ($1.rem >= 3)) { /*10738*/
								$k[$j++] = $1.swc; /*10726*/
								if ($eq($1.cset, "seta")) { /*10726*/
									if ($1.enca() == $b) break; /*10726*/
								} else { /*10726*/
									if ($1.encb() == $b) break; /*10726*/
								} /*10726*/
								$1.cset = "setc"; /*10727*/
								for (var _5n = 0, _5o = 2; _5n < _5o; _5n++) { /*10736*/
									if ($get($1.msg, $1.i) == $1.fn1) { /*10734*/
										$k[$j++] = $1.fn1; /*10730*/
										if ($1.encc() == $b) break; /*10730*/
										$1.i = $1.i + 1; /*10731*/
									} else { /*10734*/
										$k[$j++] = $geti($1.msg, $1.i, 2); /*10733*/
										if ($1.encc() == $b) break; /*10733*/
										$1.i = $1.i + 2; /*10734*/
									} /*10734*/
								} /*10734*/
								break; /*10737*/
							} /*10737*/
							if ((($1.nums % 2) != 0) && ($1.rem >= 4)) { /*10755*/
								$k[$j++] = $get($1.msg, $1.i); /*10741*/
								if ($eq($1.cset, "seta")) { /*10741*/
									if ($1.enca() == $b) break; /*10741*/
								} else { /*10741*/
									if ($1.encb() == $b) break; /*10741*/
								} /*10741*/
								$1.i = $1.i + 1; /*10742*/
								$k[$j++] = $1.swc; /*10743*/
								if ($eq($1.cset, "seta")) { /*10743*/
									if ($1.enca() == $b) break; /*10743*/
								} else { /*10743*/
									if ($1.encb() == $b) break; /*10743*/
								} /*10743*/
								$1.cset = "setc"; /*10744*/
								for (var _68 = 0, _69 = 2; _68 < _69; _68++) { /*10753*/
									if ($get($1.msg, $1.i) == $1.fn1) { /*10751*/
										$k[$j++] = $1.fn1; /*10747*/
										if ($1.encc() == $b) break; /*10747*/
										$1.i = $1.i + 1; /*10748*/
									} else { /*10751*/
										$k[$j++] = $geti($1.msg, $1.i, 2); /*10750*/
										if ($1.encc() == $b) break; /*10750*/
										$1.i = $1.i + 2; /*10751*/
									} /*10751*/
								} /*10751*/
								break; /*10754*/
							} /*10754*/
						} /*10754*/
						$k[$j++] = $eq($1.cset, "setb"); /*10757*/
						$k[$j++] = $get($1.msg, $1.i); /*10757*/
						if ($1.anotb() == $b) break; /*10757*/
						var _6O = $k[--$j]; /*10757*/
						if (($k[--$j] && _6O) && ($1.rem >= 2)) { /*10772*/
							if ($1.i < ($1.msglen - 1)) { /*10766*/
								$k[$j++] = $1.i + 1; /*10760*/
								if ($1.bbeforea() == $b) break; /*10760*/
								if ($k[--$j]) { /*10765*/
									$k[$j++] = $1.sft; /*10761*/
									if ($1.encb() == $b) break; /*10761*/
									$k[$j++] = $get($1.msg, $1.i); /*10762*/
									if ($1.enca() == $b) break; /*10762*/
									$1.i = $1.i + 1; /*10763*/
									break; /*10764*/
								} /*10764*/
							} /*10764*/
							$k[$j++] = $1.swa; /*10767*/
							if ($1.encb() == $b) break; /*10767*/
							$1.cset = "seta"; /*10768*/
							$k[$j++] = $get($1.msg, $1.i); /*10769*/
							if ($1.enca() == $b) break; /*10769*/
							$1.i = $1.i + 1; /*10770*/
							break; /*10771*/
						} /*10771*/
						$k[$j++] = $eq($1.cset, "seta"); /*10773*/
						$k[$j++] = $get($1.msg, $1.i); /*10773*/
						if ($1.bnota() == $b) break; /*10773*/
						var _6j = $k[--$j]; /*10773*/
						if (($k[--$j] && _6j) && ($1.rem >= 2)) { /*10788*/
							if ($1.i < ($1.msglen - 1)) { /*10782*/
								$k[$j++] = $1.i + 1; /*10776*/
								if ($1.abeforeb() == $b) break; /*10776*/
								if ($k[--$j]) { /*10781*/
									$k[$j++] = $1.sft; /*10777*/
									if ($1.enca() == $b) break; /*10777*/
									$k[$j++] = $get($1.msg, $1.i); /*10778*/
									if ($1.encb() == $b) break; /*10778*/
									$1.i = $1.i + 1; /*10779*/
									break; /*10780*/
								} /*10780*/
							} /*10780*/
							$k[$j++] = $1.swb; /*10783*/
							if ($1.enca() == $b) break; /*10783*/
							$1.cset = "setb"; /*10784*/
							$k[$j++] = $get($1.msg, $1.i); /*10785*/
							if ($1.encb() == $b) break; /*10785*/
							$1.i = $1.i + 1; /*10786*/
							break; /*10787*/
						} /*10787*/
						if (($eq($1.cset, "setc") && ($1.nums < 2)) && ($1.rem >= 2)) { /*10803*/
							$k[$j++] = $1.i; /*10791*/
							if ($1.abeforeb() == $b) break; /*10791*/
							if ($k[--$j]) { /*10797*/
								$k[$j++] = $1.swa; /*10792*/
								if ($1.encc() == $b) break; /*10792*/
								$1.cset = "seta"; /*10793*/
								$k[$j++] = $get($1.msg, $1.i); /*10794*/
								if ($1.enca() == $b) break; /*10794*/
								$1.i = $1.i + 1; /*10795*/
								break; /*10796*/
							} /*10796*/
							$k[$j++] = $1.swb; /*10798*/
							if ($1.encc() == $b) break; /*10798*/
							$1.cset = "setb"; /*10799*/
							$k[$j++] = $get($1.msg, $1.i); /*10800*/
							if ($1.encb() == $b) break; /*10800*/
							$1.i = $1.i + 1; /*10801*/
							break; /*10802*/
						} /*10802*/
						var _7K = $get($1.seta, $get($1.msg, $1.i)) !== undefined; /*10806*/
						if (($eq($1.cset, "seta") && _7K) && ($1.rem >= 1)) { /*10811*/
							$k[$j++] = $get($1.msg, $1.i); /*10808*/
							if ($1.enca() == $b) break; /*10808*/
							$1.i = $1.i + 1; /*10809*/
							break; /*10810*/
						} /*10810*/
						var _7V = $get($1.setb, $get($1.msg, $1.i)) !== undefined; /*10812*/
						if (($eq($1.cset, "setb") && _7V) && ($1.rem >= 1)) { /*10817*/
							$k[$j++] = $get($1.msg, $1.i); /*10814*/
							if ($1.encb() == $b) break; /*10814*/
							$1.i = $1.i + 1; /*10815*/
							break; /*10816*/
						} /*10816*/
						if (($eq($1.cset, "setc") && ($1.nums >= 2)) && ($1.rem >= 1)) { /*10828*/
							if ($get($1.msg, $1.i) == $1.fn1) { /*10825*/
								$k[$j++] = $1.fn1; /*10821*/
								if ($1.encc() == $b) break; /*10821*/
								$1.i = $1.i + 1; /*10822*/
							} else { /*10825*/
								$k[$j++] = $geti($1.msg, $1.i, 2); /*10824*/
								if ($1.encc() == $b) break; /*10824*/
								$1.i = $1.i + 2; /*10825*/
							} /*10825*/
							break; /*10827*/
						} /*10827*/
						$1.endofrow = true; /*10831*/
						break; /*10832*/
					} /*10832*/
				} /*10832*/
				if ((((($1.r == $1.rows) || ($1.rows == -1)) && ($1.r > 1)) && ($1.i == $1.msglen)) && ($1.rem >= 2)) { /*10848*/
					$k[$j++] = $1.rem - 2; /*10840*/
					if ($1.padrow() == $b) break; /*10840*/
					$1.j = $1.j + 3; /*10841*/
					$k[$j++] = $1.stp; /*10842*/
					if ($1.enca() == $b) break; /*10842*/
					$1.lastrow = true; /*10843*/
				} else { /*10848*/
					$k[$j++] = $1.rem; /*10845*/
					if ($1.padrow() == $b) break; /*10845*/
					$1.j = $1.j + 1; /*10846*/
					$k[$j++] = $1.stp; /*10847*/
					if ($1.enca() == $b) break; /*10847*/
					$1.r = $1.r + 1; /*10848*/
				} /*10848*/
			} /*10848*/
			$1.cws = $geti($1.cws, 0, $1.j); /*10852*/
			$k[$j++] = Infinity; /*10859*/
			for (var _85 = 64; _85 <= 95; _85 += 1) { /*10856*/
				$k[$j++] = _85; /*10856*/
			} /*10856*/
			for (var _86 = 0; _86 <= 15; _86 += 1) { /*10857*/
				$k[$j++] = _86; /*10857*/
			} /*10857*/
			for (var _87 = 26; _87 <= 63; _87 += 1) { /*10858*/
				$k[$j++] = _87; /*10858*/
			} /*10858*/
			$1.abmap = $a(); /*10859*/
			$k[$j++] = Infinity; /*10860*/
			for (var _89 = 0; _89 <= 85; _89 += 1) { /*10860*/
				$k[$j++] = _89; /*10860*/
			} /*10860*/
			$1.cmap = $a(); /*10860*/
			$1.chkmsg = $a($1.msglen); /*10863*/
			$1.j = 0; /*10864*/
			for (var _8F = 0, _8E = $1.msglen - 1; _8F <= _8E; _8F += 1) { /*10870*/
				$1.i = _8F; /*10866*/
				$1.char = $get($1.msg, $1.i); /*10867*/
				if ($1.char >= 0) { /*10868*/
					$put($1.chkmsg, $1.j, $1.char); /*10868*/
					$1.j = $1.j + 1; /*10868*/
				} /*10868*/
				if (($1.char == $1.fn1) && ($1.i != 0)) { /*10869*/
					$put($1.chkmsg, $1.j, 29); /*10869*/
					$1.j = $1.j + 1; /*10869*/
				} /*10869*/
			} /*10869*/
			$1.t1 = 0; /*10871*/
			$1.t2 = 0; /*10871*/
			$1.k1 = 0; /*10871*/
			$1.k2 = 0; /*10871*/
			for (var _8W = 0, _8V = $1.j - 1; _8W <= _8V; _8W += 1) { /*10878*/
				$1.i = _8W; /*10873*/
				$1.t1 = ($get($1.chkmsg, $1.i) * $1.i) % 86; /*10874*/
				$1.t2 = ($1.t1 + $get($1.chkmsg, $1.i)) % 86; /*10875*/
				$1.k1 = ($1.k1 + $1.t2) % 86; /*10876*/
				$1.k2 = ($1.k2 + $1.t1) % 86; /*10877*/
			} /*10877*/
			$k[$j++] = $1.cws; /*10879*/
			$k[$j++] = $1.cws.length - 4; /*10879*/
			if ($ne($1.cset, "setc")) { /*10879*/
				$k[$j++] = $1.abmap; /*10879*/
			} else { /*10879*/
				$k[$j++] = $1.cmap; /*10879*/
			} /*10879*/
			var _8q = $get($k[--$j], $1.k1); /*10879*/
			var _8r = $k[--$j]; /*10879*/
			$put($k[--$j], _8r, _8q); /*10879*/
			$k[$j++] = $1.cws; /*10880*/
			$k[$j++] = $1.cws.length - 3; /*10880*/
			if ($ne($1.cset, "setc")) { /*10880*/
				$k[$j++] = $1.abmap; /*10880*/
			} else { /*10880*/
				$k[$j++] = $1.cmap; /*10880*/
			} /*10880*/
			var _90 = $get($k[--$j], $1.k2); /*10880*/
			var _91 = $k[--$j]; /*10880*/
			$put($k[--$j], _91, _90); /*10880*/
			var _93 = $1.cws; /*10883*/
			$k[$j++] = _93; /*10883*/
			$k[$j++] = 2; /*10883*/
			if ($get(_93, 2 - 1) != 99) { /*10883*/
				$k[$j++] = $1.abmap; /*10883*/
			} else { /*10883*/
				$k[$j++] = $1.cmap; /*10883*/
			} /*10883*/
			var _99 = $get($k[--$j], $1.r - 2); /*10883*/
			var _9A = $k[--$j]; /*10883*/
			$put($k[--$j], _9A, _99); /*10883*/
			for (var _9E = 1, _9D = $1.r - 1; _9E <= _9D; _9E += 1) { /*10887*/
				$1.i = _9E; /*10885*/
				var _9F = $1.cws; /*10886*/
				var _9G = $1.i; /*10886*/
				var _9H = $1.c; /*10886*/
				$k[$j++] = _9F; /*10886*/
				$k[$j++] = (_9G * (_9H + 5)) + 2; /*10886*/
				if ($get(_9F, ((_9G * (_9H + 5)) + 2) - 1) != 99) { /*10886*/
					$k[$j++] = $1.abmap; /*10886*/
				} else { /*10886*/
					$k[$j++] = $1.cmap; /*10886*/
				} /*10886*/
				var _9N = $get($k[--$j], $1.i + 42); /*10886*/
				var _9O = $k[--$j]; /*10886*/
				$put($k[--$j], _9O, _9N); /*10886*/
			} /*10886*/
			for (var _9S = 0, _9R = $1.r - 1; _9S <= _9R; _9S += 1) { /*10898*/
				$1.rcws = $geti($1.cws, _9S * ($1.c + 5), $1.c + 4); /*10891*/
				$1.csum = $get($1.rcws, 0); /*10892*/
				for (var _9b = 1, _9a = $1.rcws.length - 2; _9b <= _9a; _9b += 1) { /*10896*/
					$1.i = _9b; /*10894*/
					$1.csum = $1.csum + ($get($1.rcws, $1.i) * $1.i); /*10895*/
				} /*10895*/
				$put($1.rcws, $1.rcws.length - 1, $1.csum % 103); /*10897*/
			} /*10897*/
			$1.encs = $a(["212222", "222122", "222221", "121223", "121322", "131222", "122213", "122312", "132212", "221213", "221312", "231212", "112232", "122132", "122231", "113222", "123122", "123221", "223211", "221132", "221231", "213212", "223112", "312131", "311222", "321122", "321221", "312212", "322112", "322211", "212123", "212321", "232121", "111323", "131123", "131321", "112313", "132113", "132311", "211313", "231113", "231311", "112133", "112331", "132131", "113123", "113321", "133121", "313121", "211331", "231131", "213113", "213311", "213131", "311123", "311321", "331121", "312113", "312311", "332111", "314111", "221411", "431111", "111224", "111422", "121124", "121421", "141122", "141221", "112214", "112412", "122114", "122411", "142112", "142211", "241211", "221114", "413111", "241112", "134111", "111242", "121142", "121241", "114212", "124112", "124211", "411212", "421112", "421211", "212141", "214121", "412121", "111143", "111341", "131141", "114113", "114311", "411113", "411311", "113141", "114131", "311141", "411131", "211412", "2331112"]); /*10917*/
			$1.rowbits = $a($1.r); /*10920*/
			for (var _9p = 0, _9o = $1.r - 1; _9p <= _9o; _9p += 1) { /*10932*/
				$1.i = _9p; /*10922*/
				$k[$j++] = Infinity; /*10927*/
				$forall($geti($1.cws, $1.i * ($1.c + 5), $1.c + 5), function() { /*10926*/
					$forall($get($1.encs, $k[--$j]), function() { /*10925*/
						var _9y = $k[--$j]; /*10925*/
						$k[$j++] = _9y - 48; /*10925*/
					}); /*10925*/
				}); /*10925*/
				$1.sbs = $a(); /*10927*/
				$k[$j++] = Infinity; /*10928*/
				var _A0 = $1.sbs; /*10929*/
				$k[$j++] = 0; /*10929*/
				for (var _A1 = 0, _A2 = _A0.length; _A1 < _A2; _A1++) { /*10929*/
					var _A4 = $k[--$j]; /*10929*/
					var _A5 = (_A4 == 1) ? 0 : 1; /*10929*/
					$k[$j++] = _A4; /*10929*/
					for (var _A6 = 0, _A7 = $get(_A0, _A1); _A6 < _A7; _A6++) { /*10929*/
						$k[$j++] = _A5 /*10929*/
					} /*10929*/
				} /*10929*/
				$astore($a($counttomark() - 1)); /*10930*/
				var _AA = $k[--$j]; /*10930*/
				var _AB = $k[--$j]; /*10930*/
				var _AC = $k[--$j]; /*10930*/
				$put($1.rowbits, $1.i, _AA); /*10931*/
			} /*10931*/
			$1.symwid = ($1.c * 11) + 57; /*10935*/
			$k[$j++] = Infinity; /*10949*/
			for (var _AI = 0, _AJ = $1.symwid * $1.sepheight; _AI < _AJ; _AI++) { /*10937*/
				$k[$j++] = 1; /*10937*/
			} /*10937*/
			for (var _AM = 0, _AL = $1.r - 2; _AM <= _AL; _AM += 1) { /*10946*/
				$1.i = _AM; /*10939*/
				for (var _AO = 0, _AP = $1.rowheight; _AO < _AP; _AO++) { /*10940*/
					$aload($get($1.rowbits, $1.i)); /*10940*/
				} /*10940*/
				for (var _AU = 0, _AV = $1.sepheight; _AU < _AV; _AU++) { /*10945*/
					$k[$j++] = 1; /*10943*/
					$k[$j++] = 1; /*10943*/
					$k[$j++] = 0; /*10943*/
					$k[$j++] = 1; /*10943*/
					$k[$j++] = 0; /*10943*/
					$k[$j++] = 0; /*10943*/
					$k[$j++] = 0; /*10943*/
					$k[$j++] = 0; /*10943*/
					$k[$j++] = 1; /*10943*/
					$k[$j++] = 0; /*10943*/
					$k[$j++] = 0; /*10943*/
					for (var _AX = 0, _AY = $1.symwid - 24; _AX < _AY; _AX++) { /*10943*/
						$k[$j++] = 1; /*10943*/
					} /*10943*/
					$k[$j++] = 1; /*10944*/
					$k[$j++] = 1; /*10944*/
					$k[$j++] = 0; /*10944*/
					$k[$j++] = 0; /*10944*/
					$k[$j++] = 0; /*10944*/
					$k[$j++] = 1; /*10944*/
					$k[$j++] = 1; /*10944*/
					$k[$j++] = 1; /*10944*/
					$k[$j++] = 0; /*10944*/
					$k[$j++] = 1; /*10944*/
					$k[$j++] = 0; /*10944*/
					$k[$j++] = 1; /*10944*/
					$k[$j++] = 1; /*10944*/
				} /*10944*/
			} /*10944*/
			for (var _Aa = 0, _Ab = $1.rowheight; _Aa < _Ab; _Aa++) { /*10947*/
				$aload($get($1.rowbits, $1.r - 1)); /*10947*/
			} /*10947*/
			for (var _Ah = 0, _Ai = $1.symwid * $1.sepheight; _Ah < _Ai; _Ah++) { /*10948*/
				$k[$j++] = 1; /*10948*/
			} /*10948*/
			$1.pixs = $a(); /*10949*/
			var _As = {
				ren: $0.renmatrix,
				pixs: $1.pixs,
				pixx: $1.symwid,
				pixy: ~~($1.pixs.length / $1.symwid),
				height: (~~($1.pixs.length / $1.symwid)) / 72,
				width: $1.symwid / 72,
				opt: $1.options
			}; /*10959*/
			$k[$j++] = _As; /*10962*/
			if (!$1.dontdraw) { /*10962*/
				$0.renmatrix(); /*10962*/
			} /*10962*/
		};
		$0.code16k = function() {
			var $1 = {}; /*10989*/
			$1.options = $k[--$j]; /*10991*/
			$1.barcode = $k[--$j]; /*10992*/
			$1.dontdraw = false; /*10994*/
			$1.mode = -1; /*10995*/
			$1.pos = -1; /*10996*/
			$1.rows = 0; /*10997*/
			$1.rowheight = 8; /*10998*/
			$1.sepheight = 1; /*10999*/
			$1.encoding = "auto"; /*11000*/
			$1.raw = false; /*11001*/
			$1.parse = false; /*11002*/
			$1.parsefnc = false; /*11003*/
			$forall($1.options, function() { /*11014*/
				var _3 = $k[--$j]; /*11014*/
				$1[$k[--$j]] = _3; /*11014*/
			}); /*11014*/
			$1.mode = ~~$1.mode; /*11016*/
			$1.pos = ~~$1.pos; /*11017*/
			$1.rows = ~~$1.rows; /*11018*/
			$1.rowheight = ~~$1.rowheight; /*11019*/
			$1.sepheight = ~~$1.sepheight; /*11020*/
			if ($1.pos != -1) { /*11022*/
				$1.rows = 16; /*11022*/
			} /*11022*/
			$1.barlen = $1.barcode.length; /*11045*/
			$1.swa = -1; /*11048*/
			$1.swb = -2; /*11048*/
			$1.swc = -3; /*11048*/
			$1.sa1 = -4; /*11049*/
			$1.sb1 = -5; /*11049*/
			$1.sc1 = -6; /*11049*/
			$1.sa2 = -7; /*11050*/
			$1.sb2 = -8; /*11050*/
			$1.sc2 = -9; /*11050*/
			$1.pad = -10; /*11051*/
			$1.sb3 = -11; /*11051*/
			$1.sc3 = -12; /*11051*/
			$1.fn1 = -13; /*11052*/
			$1.fn2 = -14; /*11052*/
			$1.fn3 = -15; /*11052*/
			$1.fn4 = -16; /*11052*/
			$1.charmaps = $a([$a([32, 32, "00"]), $a(["!", "!", "01"]), $a(["\"", "\"", "02"]), $a(["#", "#", "03"]), $a(["$", "$", "04"]), $a(["%", "%", "05"]), $a(["&", "&", "06"]), $a(["'", "'", "07"]), $a([40, 40, "08"]), $a([41, 41, "09"]), $a(["*", "*", "10"]), $a(["+", "+", "11"]), $a([",", ",", "12"]), $a(["-", "-", "13"]), $a([".", ".", "14"]), $a(["/", "/", "15"]), $a(["0", "0", "16"]), $a(["1", "1", "17"]), $a(["2", "2", "18"]), $a(["3", "3", "19"]), $a(["4", "4", "20"]), $a(["5", "5", "21"]), $a(["6", "6", "22"]), $a(["7", "7", "23"]), $a(["8", "8", "24"]), $a(["9", "9", "25"]), $a([":", ":", "26"]), $a([";", ";", "27"]), $a(["<", "<", "28"]), $a(["=", "=", "29"]), $a([">", ">", "30"]), $a(["?", "?", "31"]), $a(["@", "@", "32"]), $a(["A", "A", "33"]), $a(["B", "B", "34"]), $a(["C", "C", "35"]), $a(["D", "D", "36"]), $a(["E", "E", "37"]), $a(["F", "F", "38"]), $a(["G", "G", "39"]), $a(["H", "H", "40"]), $a(["I", "I", "41"]), $a(["J", "J", "42"]), $a(["K", "K", "43"]), $a(["L", "L", "44"]), $a(["M", "M", "45"]), $a(["N", "N", "46"]), $a(["O", "O", "47"]), $a(["P", "P", "48"]), $a(["Q", "Q", "49"]), $a(["R", "R", "50"]), $a(["S", "S", "51"]), $a(["T", "T", "52"]), $a(["U", "U", "53"]), $a(["V", "V", "54"]), $a(["W", "W", "55"]), $a(["X", "X", "56"]), $a(["Y", "Y", "57"]), $a(["Z", "Z", "58"]), $a(["[", "[", "59"]), $a([92, 92, "60"]), $a(["]", "]", "61"]), $a(["^", "^", "62"]), $a(["_", "_", "63"]), $a([0, "`", "64"]), $a([1, "a", "65"]), $a([2, "b", "66"]), $a([3, "c", "67"]), $a([4, "d", "68"]), $a([5, "e", "69"]), $a([6, "f", "70"]), $a([7, "g", "71"]), $a([8, "h", "72"]), $a([9, "i", "73"]), $a([10, "j", "74"]), $a([11, "k", "75"]), $a([12, "l", "76"]), $a([13, "m", "77"]), $a([14, "n", "78"]), $a([15, "o", "79"]), $a([16, "p", "80"]), $a([17, "q", "81"]), $a([18, "r", "82"]), $a([19, "s", "83"]), $a([20, "t", "84"]), $a([21, "u", "85"]), $a([22, "v", "86"]), $a([23, "w", "87"]), $a([24, "x", "88"]), $a([25, "y", "89"]), $a([26, "z", "90"]), $a([27, "{", "91"]), $a([28, "|", "92"]), $a([29, "}", "93"]), $a([30, "~", "94"]), $a([31, 127, "95"]), $a([$1.fn3, $1.fn3, "96"]), $a([$1.fn2, $1.fn2, "97"]), $a([$1.sb1, $1.sa1, "98"]), $a([$1.swc, $1.swc, "99"]), $a([$1.swb, $1.fn4, $1.swb]), $a([$1.fn4, $1.swa, $1.swa]), $a([$1.fn1, $1.fn1, $1.fn1]), $a([$1.pad, $1.pad, $1.pad]), $a([$1.sb2, $1.sa2, $1.sb1]), $a([$1.sc2, $1.sc2, $1.sb2]), $a([$1.sc3, $1.sc3, $1.sb3])]); /*11093*/
			$1.charvals = $a([{}, {}, {}]); /*11096*/
			for (var _2S = 0, _2R = $1.charmaps.length - 1; _2S <= _2R; _2S += 1) { /*11105*/
				$1.i = _2S; /*11098*/
				$1.encs = $get($1.charmaps, $1.i); /*11099*/
				for (var _2W = 0; _2W <= 2; _2W += 1) { /*11104*/
					$1.j = _2W; /*11101*/
					var _2Z = $get($1.encs, $1.j); /*11102*/
					$k[$j++] = _2Z; /*11102*/
					if ($eq($type(_2Z), "stringtype")) { /*11102*/
						var _2c = $get($k[--$j], 0); /*11102*/
						$k[$j++] = _2c; /*11102*/
					} /*11102*/
					$put($get($1.charvals, $1.j), $k[--$j], $1.i); /*11103*/
				} /*11103*/
			} /*11103*/
			$1.seta = $get($1.charvals, 0); /*11106*/
			$1.setb = $get($1.charvals, 1); /*11107*/
			$1.setc = $get($1.charvals, 2); /*11108*/
			if ($1.raw) { /*11110*/
				$1.encoding = "raw"; /*11110*/
			} /*11110*/
			if ($eq($1.encoding, "raw")) { /*11124*/
				$1.cws = $a($1.barlen); /*11113*/
				$1.i = 0; /*11114*/
				$1.j = 0; /*11114*/
				for (;;) { /*11121*/
					if ($1.i == $1.barlen) { /*11116*/
						break; /*11116*/
					} /*11116*/
					$1.cw = ~~$z($geti($1.barcode, $1.i + 1, 3)); /*11117*/
					$put($1.cws, $1.j, $1.cw); /*11118*/
					$1.i = $1.i + 4; /*11119*/
					$1.j = $1.j + 1; /*11120*/
				} /*11120*/
				$1.cws = $geti($1.cws, 0, $1.j); /*11122*/
				$1.text = ""; /*11123*/
			} /*11123*/
			if ($eq($1.encoding, "auto")) { /*11587*/
				var _39 = {
					FNC1: $1.fn1,
					FNC2: $1.fn2,
					FNC3: $1.fn3
				}; /*11131*/
				$1.fncvals = _39; /*11133*/
				$1.msg = $a($1.barlen); /*11134*/
				$1.i = 0; /*11135*/
				$1.j = 0; /*11135*/
				for (;;) { /*11149*/
					if ($1.i == $1.barlen) { /*11136*/
						break; /*11136*/
					} /*11136*/
					$1.char = $get($1.barcode, $1.i); /*11137*/
					if (($1.parsefnc && ($1.char == 94)) && ($1.i < ($1.barlen - 4))) { /*11145*/
						if ($get($1.barcode, $1.i + 1) != 94) { /*11143*/
							$1.char = $get($1.fncvals, $geti($1.barcode, $1.i + 1, 4)); /*11140*/
							$1.i = $1.i + 4; /*11141*/
						} else { /*11143*/
							$1.i = $1.i + 1; /*11143*/
						} /*11143*/
					} /*11143*/
					$put($1.msg, $1.j, $1.char); /*11146*/
					$1.i = $1.i + 1; /*11147*/
					$1.j = $1.j + 1; /*11148*/
				} /*11148*/
				$1.msg = $geti($1.msg, 0, $1.j); /*11150*/
				$1.msglen = $1.msg.length; /*11151*/
				$k[$j++] = Infinity; /*11154*/
				for (var _3f = 0, _3g = $1.msglen; _3f < _3g; _3f++) { /*11154*/
					$k[$j++] = 0; /*11154*/
				} /*11154*/
				$k[$j++] = 0; /*11154*/
				$1.numSA = $a(); /*11154*/
				$k[$j++] = Infinity; /*11155*/
				for (var _3j = 0, _3k = $1.msglen; _3j < _3k; _3j++) { /*11155*/
					$k[$j++] = 0; /*11155*/
				} /*11155*/
				$k[$j++] = 0; /*11155*/
				$1.numEA = $a(); /*11155*/
				for (var _3n = $1.msglen - 1; _3n >= 0; _3n -= 1) { /*11165*/
					$1.i = _3n; /*11157*/
					if ($get($1.msg, $1.i) >= 0) { /*11164*/
						if ($get($1.msg, $1.i) >= 128) { /*11162*/
							$put($1.numEA, $1.i, $get($1.numEA, $1.i + 1) + 1); /*11160*/
						} else { /*11162*/
							$put($1.numSA, $1.i, $get($1.numSA, $1.i + 1) + 1); /*11162*/
						} /*11162*/
					} /*11162*/
				} /*11162*/
				$1.ea = false; /*11168*/
				$1.msgtmp = $a([]); /*11168*/
				for (var _47 = 0, _46 = $1.msglen - 1; _47 <= _46; _47 += 1) { /*11183*/
					$1.i = _47; /*11170*/
					$1.c = $get($1.msg, $1.i); /*11171*/
					if ((!$xo($1.ea, $1.c < 128)) && ($1.c >= 0)) { /*11181*/
						if ($1.ea) { /*11173*/
							$k[$j++] = $1.numSA; /*11173*/
						} else { /*11173*/
							$k[$j++] = $1.numEA; /*11173*/
						} /*11173*/
						var _4J = $get($k[--$j], $1.i); /*11173*/
						var _4M = ((_4J + $1.i) == $1.msglen) ? 3 : 5; /*11174*/
						if (_4J < _4M) { /*11179*/
							$k[$j++] = Infinity; /*11176*/
							$aload($1.msgtmp); /*11176*/
							$k[$j++] = $1.fn4; /*11176*/
							$1.msgtmp = $a(); /*11176*/
						} else { /*11179*/
							$k[$j++] = Infinity; /*11178*/
							$aload($1.msgtmp); /*11178*/
							$k[$j++] = $1.fn4; /*11178*/
							$k[$j++] = $1.fn4; /*11178*/
							$1.msgtmp = $a(); /*11178*/
							$1.ea = !$1.ea; /*11179*/
						} /*11179*/
					} /*11179*/
					$k[$j++] = Infinity; /*11182*/
					$aload($1.msgtmp); /*11182*/
					if ($1.c >= 0) { /*11182*/
						$k[$j++] = $1.c & 127; /*11182*/
					} else { /*11182*/
						$k[$j++] = $1.c; /*11182*/
					} /*11182*/
					$1.msgtmp = $a(); /*11182*/
				} /*11182*/
				$1.msg = $1.msgtmp; /*11184*/
				$1.msglen = $1.msg.length; /*11185*/
				$1.numsscr = function() {
					$1.n = 0; /*11189*/
					$1.s = 0; /*11189*/
					$1.p = $k[--$j]; /*11190*/
					for (;;) { /*11201*/
						if ($1.p >= $1.msglen) { /*11191*/
							break; /*11191*/
						} /*11191*/
						var _4h = $get($1.msg, $1.p); /*11192*/
						var _4j = $get($1.setc, _4h) !== undefined; /*11193*/
						$k[$j++] = _4h; /*11193*/
						if (!_4j) { /*11193*/
							$j--; /*11193*/
							break; /*11193*/
						} /*11193*/
						if ($k[--$j] == $1.fn1) { /*11197*/
							if (($1.s % 2) == 0) { /*11196*/
								$1.s = $1.s + 1; /*11196*/
							} else { /*11196*/
								break; /*11196*/
							} /*11196*/
						} /*11196*/
						$1.n = $1.n + 1; /*11198*/
						$1.s = $1.s + 1; /*11199*/
						$1.p = $1.p + 1; /*11200*/
					} /*11200*/
					$k[$j++] = $1.n; /*11202*/
					$k[$j++] = $1.s; /*11202*/
				}; /*11203*/
				$1.enca = function() {
					$put($1.cws, $1.j, $get($1.seta, $k[--$j])); /*11207*/
					$1.j = $1.j + 1; /*11208*/
				}; /*11209*/
				$1.encb = function() {
					$put($1.cws, $1.j, $get($1.setb, $k[--$j])); /*11211*/
					$1.j = $1.j + 1; /*11212*/
				}; /*11213*/
				$1.encc = function() {
					var _55 = $k[--$j]; /*11215*/
					$k[$j++] = _55; /*11219*/
					if ($ne($type(_55), "arraytype")) { /*11218*/
						var _59 = $get($1.setc, $k[--$j]); /*11216*/
						$k[$j++] = _59; /*11216*/
					} else { /*11218*/
						$aload($k[--$j]); /*11218*/
						var _5B = $k[--$j]; /*11218*/
						var _5C = $k[--$j]; /*11218*/
						$k[$j++] = (_5B - 48) + ((_5C - 48) * 10); /*11218*/
					} /*11218*/
					$put($1.cws, $1.j, $k[--$j]); /*11220*/
					$1.j = $1.j + 1; /*11221*/
				}; /*11222*/
				$1.anotb = function() {
					var _5H = $k[--$j]; /*11225*/
					var _5J = $get($1.seta, _5H) !== undefined; /*11225*/
					var _5L = $get($1.setb, _5H) !== undefined; /*11225*/
					$k[$j++] = _5J && (!_5L); /*11225*/
				}; /*11225*/
				$1.bnota = function() {
					var _5M = $k[--$j]; /*11226*/
					var _5O = $get($1.setb, _5M) !== undefined; /*11226*/
					var _5Q = $get($1.seta, _5M) !== undefined; /*11226*/
					$k[$j++] = _5O && (!_5Q); /*11226*/
				}; /*11226*/
				$k[$j++] = Infinity; /*11229*/
				for (var _5S = 0, _5T = $1.msg.length; _5S < _5T; _5S++) { /*11229*/
					$k[$j++] = 0; /*11229*/
				} /*11229*/
				$k[$j++] = 9999; /*11229*/
				$1.nextanotb = $a(); /*11229*/
				$k[$j++] = Infinity; /*11230*/
				for (var _5W = 0, _5X = $1.msg.length; _5W < _5X; _5W++) { /*11230*/
					$k[$j++] = 0; /*11230*/
				} /*11230*/
				$k[$j++] = 9999; /*11230*/
				$1.nextbnota = $a(); /*11230*/
				for (var _5a = $1.msg.length - 1; _5a >= 0; _5a -= 1) { /*11243*/
					$1.i = _5a; /*11232*/
					$k[$j++] = $get($1.msg, $1.i); /*11233*/
					if ($1.anotb() == $b) break; /*11233*/
					if ($k[--$j]) { /*11236*/
						$put($1.nextanotb, $1.i, 0); /*11234*/
					} else { /*11236*/
						$put($1.nextanotb, $1.i, $get($1.nextanotb, $1.i + 1) + 1); /*11236*/
					} /*11236*/
					$k[$j++] = $get($1.msg, $1.i); /*11238*/
					if ($1.bnota() == $b) break; /*11238*/
					if ($k[--$j]) { /*11241*/
						$put($1.nextbnota, $1.i, 0); /*11239*/
					} else { /*11241*/
						$put($1.nextbnota, $1.i, $get($1.nextbnota, $1.i + 1) + 1); /*11241*/
					} /*11241*/
				} /*11241*/
				$1.abeforeb = function() {
					var _5x = $k[--$j]; /*11246*/
					$k[$j++] = $lt($get($1.nextanotb, _5x), $get($1.nextbnota, _5x)); /*11246*/
				}; /*11246*/
				$1.bbeforea = function() {
					var _62 = $k[--$j]; /*11247*/
					$k[$j++] = $lt($get($1.nextbnota, _62), $get($1.nextanotb, _62)); /*11247*/
				}; /*11247*/
				$1.cws = $a(($1.barcode.length * 2) + 3); /*11249*/
				$1.i = 0; /*11252*/
				$1.j = 0; /*11252*/
				for (;;) { /*11342*/
					if ($1.pos != -1) { /*11263*/
						$put($1.cws, 0, (~~($1.pos / 10)) - 1); /*11257*/
						$put($1.cws, 1, ($1.pos % 10) - 1); /*11258*/
						$1.j = 2; /*11259*/
						$1.cset = "setb"; /*11260*/
						$1.mode = 7; /*11261*/
						break; /*11262*/
					} /*11262*/
					if ($1.msglen == 0) { /*11269*/
						$1.cset = "setb"; /*11266*/
						$1.mode = 1; /*11267*/
						break; /*11268*/
					} /*11268*/
					if ($1.msglen >= 2) { /*11278*/
						$k[$j++] = $get($1.msg, 0) == $1.fn1; /*11272*/
						$k[$j++] = 1; /*11272*/
						if ($1.numsscr() == $b) break; /*11272*/
						var _6J = $k[--$j]; /*11272*/
						var _6K = $k[--$j]; /*11272*/
						if ($k[--$j] && (_6J >= 2)) { /*11277*/
							$1.cset = "setc"; /*11273*/
							$1.mode = 4; /*11274*/
							$1.i = 1; /*11275*/
							break; /*11276*/
						} /*11276*/
					} /*11276*/
					if ($get($1.msg, 0) == $1.fn1) { /*11285*/
						$1.cset = "setb"; /*11281*/
						$1.mode = 3; /*11282*/
						$1.i = 1; /*11283*/
						break; /*11284*/
					} /*11284*/
					if ($1.msglen >= 2) { /*11331*/
						$k[$j++] = 0; /*11288*/
						if ($1.numsscr() == $b) break; /*11288*/
						var _6Q = $k[--$j]; /*11288*/
						var _6R = $k[--$j]; /*11288*/
						if ((_6Q >= 2) && ((_6Q % 2) == 0)) { /*11292*/
							$1.cset = "setc"; /*11289*/
							$1.mode = 2; /*11290*/
							break; /*11291*/
						} /*11291*/
						$k[$j++] = 0; /*11294*/
						if ($1.numsscr() == $b) break; /*11294*/
						var _6S = $k[--$j]; /*11294*/
						var _6T = $k[--$j]; /*11294*/
						if ((_6S >= 3) && ((_6S % 2) == 1)) { /*11300*/
							$k[$j++] = $get($1.msg, 0); /*11295*/
							if ($1.encb() == $b) break; /*11295*/
							$1.cset = "setc"; /*11296*/
							$1.mode = 5; /*11297*/
							$1.i = 1; /*11298*/
							break; /*11299*/
						} /*11299*/
						var _6Z = $get($1.setb, $get($1.msg, 0)) !== undefined; /*11302*/
						$k[$j++] = _6Z; /*11303*/
						$k[$j++] = 1; /*11303*/
						if ($1.numsscr() == $b) break; /*11303*/
						var _6a = $k[--$j]; /*11303*/
						var _6b = $k[--$j]; /*11303*/
						if ($k[--$j] && ((_6a >= 2) && ((_6a % 2) == 0))) { /*11309*/
							$k[$j++] = $get($1.msg, 0); /*11304*/
							if ($1.encb() == $b) break; /*11304*/
							$1.cset = "setc"; /*11305*/
							$1.mode = 5; /*11306*/
							$1.i = 1; /*11307*/
							break; /*11308*/
						} /*11308*/
						var _6i = $get($1.setb, $get($1.msg, 0)) !== undefined; /*11311*/
						$k[$j++] = _6i; /*11312*/
						$k[$j++] = 1; /*11312*/
						if ($1.numsscr() == $b) break; /*11312*/
						var _6j = $k[--$j]; /*11312*/
						var _6k = $k[--$j]; /*11312*/
						if ($k[--$j] && ((_6j >= 3) && ((_6j % 2) == 1))) { /*11319*/
							$k[$j++] = $get($1.msg, 0); /*11313*/
							if ($1.encb() == $b) break; /*11313*/
							$k[$j++] = $get($1.msg, 1); /*11314*/
							if ($1.encb() == $b) break; /*11314*/
							$1.cset = "setc"; /*11315*/
							$1.mode = 6; /*11316*/
							$1.i = 2; /*11317*/
							break; /*11318*/
						} /*11318*/
						var _6t = $get($1.setb, $get($1.msg, 0)) !== undefined; /*11321*/
						var _6x = $get($1.setb, $get($1.msg, 1)) !== undefined; /*11322*/
						$k[$j++] = _6t && _6x; /*11323*/
						$k[$j++] = 2; /*11323*/
						if ($1.numsscr() == $b) break; /*11323*/
						var _6y = $k[--$j]; /*11323*/
						var _6z = $k[--$j]; /*11323*/
						if ($k[--$j] && ((_6y >= 2) && ((_6y % 2) == 0))) { /*11330*/
							$k[$j++] = $get($1.msg, 0); /*11324*/
							if ($1.encb() == $b) break; /*11324*/
							$k[$j++] = $get($1.msg, 1); /*11325*/
							if ($1.encb() == $b) break; /*11325*/
							$1.cset = "setc"; /*11326*/
							$1.mode = 6; /*11327*/
							$1.i = 2; /*11328*/
							break; /*11329*/
						} /*11329*/
					} /*11329*/
					$k[$j++] = 0; /*11333*/
					if ($1.abeforeb() == $b) break; /*11333*/
					if ($k[--$j]) { /*11337*/
						$1.cset = "seta"; /*11334*/
						$1.mode = 0; /*11335*/
						break; /*11336*/
					} /*11336*/
					$1.cset = "setb"; /*11339*/
					$1.mode = 1; /*11340*/
					break; /*11341*/
				} /*11341*/
				for (;;) { /*11585*/
					if ($1.i == $1.msglen) { /*11345*/
						break; /*11345*/
					} /*11345*/
					$k[$j++] = $1.i; /*11347*/
					if ($1.numsscr() == $b) break; /*11347*/
					$1.nums = $k[--$j]; /*11347*/
					$1.nchars = $k[--$j]; /*11347*/
					for (;;) { /*11583*/
						if ($eq($1.cset, "seta")) { /*11424*/
							if ($1.i < ($1.msglen - 1)) { /*11361*/
								$k[$j++] = $get($1.msg, $1.i); /*11354*/
								if ($1.bnota() == $b) break; /*11354*/
								$k[$j++] = $1.i + 1; /*11355*/
								if ($1.abeforeb() == $b) break; /*11355*/
								var _7I = $k[--$j]; /*11355*/
								if (($k[--$j] && _7I)) { /*11360*/
									$k[$j++] = $1.sb1; /*11356*/
									if ($1.enca() == $b) break; /*11356*/
									$k[$j++] = $get($1.msg, $1.i); /*11357*/
									if ($1.encb() == $b) break; /*11357*/
									$1.i = $1.i + 1; /*11358*/
									break; /*11359*/
								} /*11359*/
							} /*11359*/
							if ($1.i < ($1.msglen - 2)) { /*11373*/
								$k[$j++] = $get($1.msg, $1.i); /*11364*/
								if ($1.bnota() == $b) break; /*11364*/
								$k[$j++] = $get($1.msg, $1.i + 1); /*11365*/
								if ($1.bnota() == $b) break; /*11365*/
								var _7X = $k[--$j]; /*11365*/
								var _7Y = $k[--$j]; /*11365*/
								$k[$j++] = $an(_7Y, _7X); /*11366*/
								$k[$j++] = $1.i + 2; /*11366*/
								if ($1.abeforeb() == $b) break; /*11366*/
								var _7a = $k[--$j]; /*11366*/
								if (($k[--$j] && _7a)) { /*11372*/
									$k[$j++] = $1.sb2; /*11367*/
									if ($1.enca() == $b) break; /*11367*/
									$k[$j++] = $get($1.msg, $1.i); /*11368*/
									if ($1.encb() == $b) break; /*11368*/
									$k[$j++] = $get($1.msg, $1.i + 1); /*11369*/
									if ($1.encb() == $b) break; /*11369*/
									$1.i = $1.i + 2; /*11370*/
									break; /*11371*/
								} /*11371*/
							} /*11371*/
							$k[$j++] = $get($1.msg, $1.i); /*11375*/
							if ($1.bnota() == $b) break; /*11375*/
							if ($k[--$j]) { /*11379*/
								$k[$j++] = $1.swb; /*11376*/
								if ($1.enca() == $b) break; /*11376*/
								$1.cset = "setb"; /*11377*/
								break; /*11378*/
							} /*11378*/
							if ($1.i < ($1.msglen - 4)) { /*11396*/
								var _7w = $get($1.seta, $get($1.msg, $1.i + 4)) !== undefined; /*11383*/
								if (($1.nums == 4) && _7w) { /*11395*/
									$k[$j++] = $1.sc2; /*11384*/
									if ($1.enca() == $b) break; /*11384*/
									for (var _7y = 0, _7z = 2; _7y < _7z; _7y++) { /*11393*/
										if ($get($1.msg, $1.i) == $1.fn1) { /*11391*/
											$k[$j++] = $1.fn1; /*11387*/
											if ($1.encc() == $b) break; /*11387*/
											$1.i = $1.i + 1; /*11388*/
										} else { /*11391*/
											$k[$j++] = $geti($1.msg, $1.i, 2); /*11390*/
											if ($1.encc() == $b) break; /*11390*/
											$1.i = $1.i + 2; /*11391*/
										} /*11391*/
									} /*11391*/
									break; /*11394*/
								} /*11394*/
							} /*11394*/
							if ($1.i < ($1.msglen - 6)) { /*11413*/
								var _8H = $get($1.seta, $get($1.msg, $1.i + 6)) !== undefined; /*11400*/
								if (($1.nums == 6) && _8H) { /*11412*/
									$k[$j++] = $1.sc3; /*11401*/
									if ($1.enca() == $b) break; /*11401*/
									for (var _8J = 0, _8K = 3; _8J < _8K; _8J++) { /*11410*/
										if ($get($1.msg, $1.i) == $1.fn1) { /*11408*/
											$k[$j++] = $1.fn1; /*11404*/
											if ($1.encc() == $b) break; /*11404*/
											$1.i = $1.i + 1; /*11405*/
										} else { /*11408*/
											$k[$j++] = $geti($1.msg, $1.i, 2); /*11407*/
											if ($1.encc() == $b) break; /*11407*/
											$1.i = $1.i + 2; /*11408*/
										} /*11408*/
									} /*11408*/
									break; /*11411*/
								} /*11411*/
							} /*11411*/
							if (($1.nums >= 4) && (($1.nums % 2) == 0)) { /*11419*/
								$k[$j++] = $1.swc; /*11416*/
								if ($1.enca() == $b) break; /*11416*/
								$1.cset = "setc"; /*11417*/
								break; /*11418*/
							} /*11418*/
							$k[$j++] = $get($1.msg, $1.i); /*11421*/
							if ($1.enca() == $b) break; /*11421*/
							$1.i = $1.i + 1; /*11422*/
							break; /*11423*/
						} /*11423*/
						if ($eq($1.cset, "setb")) { /*11498*/
							if ($1.i < ($1.msglen - 1)) { /*11435*/
								$k[$j++] = $get($1.msg, $1.i); /*11428*/
								if ($1.anotb() == $b) break; /*11428*/
								$k[$j++] = $1.i + 1; /*11429*/
								if ($1.bbeforea() == $b) break; /*11429*/
								var _8j = $k[--$j]; /*11429*/
								if (($k[--$j] && _8j)) { /*11434*/
									$k[$j++] = $1.sa1; /*11430*/
									if ($1.encb() == $b) break; /*11430*/
									$k[$j++] = $get($1.msg, $1.i); /*11431*/
									if ($1.enca() == $b) break; /*11431*/
									$1.i = $1.i + 1; /*11432*/
									break; /*11433*/
								} /*11433*/
							} /*11433*/
							if ($1.i < ($1.msglen - 2)) { /*11447*/
								$k[$j++] = $get($1.msg, $1.i); /*11438*/
								if ($1.anotb() == $b) break; /*11438*/
								$k[$j++] = $get($1.msg, $1.i + 1); /*11439*/
								if ($1.anotb() == $b) break; /*11439*/
								var _8y = $k[--$j]; /*11439*/
								var _8z = $k[--$j]; /*11439*/
								$k[$j++] = $an(_8z, _8y); /*11440*/
								$k[$j++] = $1.i + 2; /*11440*/
								if ($1.bbeforea() == $b) break; /*11440*/
								var _91 = $k[--$j]; /*11440*/
								if (($k[--$j] && _91)) { /*11446*/
									$k[$j++] = $1.sa2; /*11441*/
									if ($1.encb() == $b) break; /*11441*/
									$k[$j++] = $get($1.msg, $1.i); /*11442*/
									if ($1.enca() == $b) break; /*11442*/
									$k[$j++] = $get($1.msg, $1.i + 1); /*11443*/
									if ($1.enca() == $b) break; /*11443*/
									$1.i = $1.i + 2; /*11444*/
									break; /*11445*/
								} /*11445*/
							} /*11445*/
							$k[$j++] = $get($1.msg, $1.i); /*11449*/
							if ($1.anotb() == $b) break; /*11449*/
							if ($k[--$j]) { /*11453*/
								$k[$j++] = $1.swa; /*11450*/
								if ($1.encb() == $b) break; /*11450*/
								$1.cset = "seta"; /*11451*/
								break; /*11452*/
							} /*11452*/
							if ($1.i < ($1.msglen - 4)) { /*11470*/
								var _9N = $get($1.setb, $get($1.msg, $1.i + 4)) !== undefined; /*11457*/
								if (($1.nums == 4) && _9N) { /*11469*/
									$k[$j++] = $1.sc2; /*11458*/
									if ($1.encb() == $b) break; /*11458*/
									for (var _9P = 0, _9Q = 2; _9P < _9Q; _9P++) { /*11467*/
										if ($get($1.msg, $1.i) == $1.fn1) { /*11465*/
											$k[$j++] = $1.fn1; /*11461*/
											if ($1.encc() == $b) break; /*11461*/
											$1.i = $1.i + 1; /*11462*/
										} else { /*11465*/
											$k[$j++] = $geti($1.msg, $1.i, 2); /*11464*/
											if ($1.encc() == $b) break; /*11464*/
											$1.i = $1.i + 2; /*11465*/
										} /*11465*/
									} /*11465*/
									break; /*11468*/
								} /*11468*/
							} /*11468*/
							if ($1.i < ($1.msglen - 6)) { /*11487*/
								var _9i = $get($1.setb, $get($1.msg, $1.i + 6)) !== undefined; /*11474*/
								if (($1.nums == 6) && _9i) { /*11486*/
									$k[$j++] = $1.sc3; /*11475*/
									if ($1.encb() == $b) break; /*11475*/
									for (var _9k = 0, _9l = 3; _9k < _9l; _9k++) { /*11484*/
										if ($get($1.msg, $1.i) == $1.fn1) { /*11482*/
											$k[$j++] = $1.fn1; /*11478*/
											if ($1.encc() == $b) break; /*11478*/
											$1.i = $1.i + 1; /*11479*/
										} else { /*11482*/
											$k[$j++] = $geti($1.msg, $1.i, 2); /*11481*/
											if ($1.encc() == $b) break; /*11481*/
											$1.i = $1.i + 2; /*11482*/
										} /*11482*/
									} /*11482*/
									break; /*11485*/
								} /*11485*/
							} /*11485*/
							if (($1.nums >= 4) && (($1.nums % 2) == 0)) { /*11493*/
								$k[$j++] = $1.swc; /*11490*/
								if ($1.encb() == $b) break; /*11490*/
								$1.cset = "setc"; /*11491*/
								break; /*11492*/
							} /*11492*/
							$k[$j++] = $get($1.msg, $1.i); /*11495*/
							if ($1.encb() == $b) break; /*11495*/
							$1.i = $1.i + 1; /*11496*/
							break; /*11497*/
						} /*11497*/
						if ($eq($1.cset, "setc")) { /*11581*/
							if ($1.nums >= 2) { /*11510*/
								if ($get($1.msg, $1.i) == $1.fn1) { /*11507*/
									$k[$j++] = $1.fn1; /*11503*/
									if ($1.encc() == $b) break; /*11503*/
									$1.i = $1.i + 1; /*11504*/
								} else { /*11507*/
									$k[$j++] = $geti($1.msg, $1.i, 2); /*11506*/
									if ($1.encc() == $b) break; /*11506*/
									$1.i = $1.i + 2; /*11507*/
								} /*11507*/
								break; /*11509*/
							} /*11509*/
							if ($1.i < ($1.msglen - 1)) { /*11520*/
								var _AL = $get($1.setb, $get($1.msg, $1.i)) !== undefined; /*11513*/
								$k[$j++] = _AL; /*11514*/
								$k[$j++] = $1.i + 1; /*11514*/
								if ($1.numsscr() == $b) break; /*11514*/
								var _AN = $k[--$j]; /*11514*/
								var _AO = $k[--$j]; /*11514*/
								if ($k[--$j] && ((_AN >= 2) && ((_AN % 2) == 0))) { /*11519*/
									$k[$j++] = $1.sb1; /*11515*/
									if ($1.encc() == $b) break; /*11515*/
									$k[$j++] = $get($1.msg, $1.i); /*11516*/
									if ($1.encb() == $b) break; /*11516*/
									$1.i = $1.i + 1; /*11517*/
									break; /*11518*/
								} /*11518*/
							} /*11518*/
							if ($1.i < ($1.msglen - 1)) { /*11531*/
								var _Ab = $get($1.setb, $get($1.msg, $1.i)) !== undefined; /*11523*/
								$k[$j++] = _Ab; /*11524*/
								$k[$j++] = $1.i + 1; /*11524*/
								if ($1.numsscr() == $b) break; /*11524*/
								var _Ad = $k[--$j]; /*11524*/
								var _Ae = $k[--$j]; /*11524*/
								if ($k[--$j] && ((_Ad >= 3) && ((_Ad % 2) == 1))) { /*11530*/
									$k[$j++] = $1.sb2; /*11525*/
									if ($1.encc() == $b) break; /*11525*/
									$k[$j++] = $get($1.msg, $1.i); /*11526*/
									if ($1.encb() == $b) break; /*11526*/
									$k[$j++] = $get($1.msg, $1.i + 1); /*11527*/
									if ($1.encb() == $b) break; /*11527*/
									$1.i = $1.i + 2; /*11528*/
									break; /*11529*/
								} /*11529*/
							} /*11529*/
							if ($1.i < ($1.msglen - 2)) { /*11543*/
								var _Au = $get($1.setb, $get($1.msg, $1.i)) !== undefined; /*11534*/
								var _Az = $get($1.setb, $get($1.msg, $1.i + 1)) !== undefined; /*11535*/
								$k[$j++] = _Au && _Az; /*11536*/
								$k[$j++] = $1.i + 2; /*11536*/
								if ($1.numsscr() == $b) break; /*11536*/
								var _B1 = $k[--$j]; /*11536*/
								var _B2 = $k[--$j]; /*11536*/
								if ($k[--$j] && ((_B1 >= 2) && ((_B1 % 2) == 0))) { /*11542*/
									$k[$j++] = $1.sb2; /*11537*/
									if ($1.encc() == $b) break; /*11537*/
									$k[$j++] = $get($1.msg, $1.i); /*11538*/
									if ($1.encb() == $b) break; /*11538*/
									$k[$j++] = $get($1.msg, $1.i + 1); /*11539*/
									if ($1.encb() == $b) break; /*11539*/
									$1.i = $1.i + 2; /*11540*/
									break; /*11541*/
								} /*11541*/
							} /*11541*/
							if ($1.i < ($1.msglen - 3)) { /*11556*/
								var _BI = $get($1.setb, $get($1.msg, $1.i)) !== undefined; /*11546*/
								var _BN = $get($1.setb, $get($1.msg, $1.i + 1)) !== undefined; /*11547*/
								$k[$j++] = _BI && _BN; /*11548*/
								$k[$j++] = $1.i + 2; /*11548*/
								if ($1.numsscr() == $b) break; /*11548*/
								var _BP = $k[--$j]; /*11548*/
								var _BQ = $k[--$j]; /*11548*/
								if ($k[--$j] && ((_BP >= 3) && ((_BP % 2) == 1))) { /*11555*/
									$k[$j++] = $1.sb3; /*11549*/
									if ($1.encc() == $b) break; /*11549*/
									$k[$j++] = $get($1.msg, $1.i); /*11550*/
									if ($1.encb() == $b) break; /*11550*/
									$k[$j++] = $get($1.msg, $1.i + 1); /*11551*/
									if ($1.encb() == $b) break; /*11551*/
									$k[$j++] = $get($1.msg, $1.i + 2); /*11552*/
									if ($1.encb() == $b) break; /*11552*/
									$1.i = $1.i + 3; /*11553*/
									break; /*11554*/
								} /*11554*/
							} /*11554*/
							if ($1.i < ($1.msglen - 3)) { /*11570*/
								var _Bj = $get($1.setb, $get($1.msg, $1.i)) !== undefined; /*11559*/
								var _Bo = $get($1.setb, $get($1.msg, $1.i + 1)) !== undefined; /*11560*/
								var _Bt = $get($1.setb, $get($1.msg, $1.i + 2)) !== undefined; /*11561*/
								$k[$j++] = (_Bj && _Bo) && _Bt; /*11562*/
								$k[$j++] = $1.i + 3; /*11562*/
								if ($1.numsscr() == $b) break; /*11562*/
								var _Bv = $k[--$j]; /*11562*/
								var _Bw = $k[--$j]; /*11562*/
								if ($k[--$j] && ((_Bv >= 2) && ((_Bv % 2) == 0))) { /*11569*/
									$k[$j++] = $1.sb3; /*11563*/
									if ($1.encc() == $b) break; /*11563*/
									$k[$j++] = $get($1.msg, $1.i); /*11564*/
									if ($1.encb() == $b) break; /*11564*/
									$k[$j++] = $get($1.msg, $1.i + 1); /*11565*/
									if ($1.encb() == $b) break; /*11565*/
									$k[$j++] = $get($1.msg, $1.i + 2); /*11566*/
									if ($1.encb() == $b) break; /*11566*/
									$1.i = $1.i + 3; /*11567*/
									break; /*11568*/
								} /*11568*/
							} /*11568*/
							$k[$j++] = $1.i; /*11572*/
							if ($1.abeforeb() == $b) break; /*11572*/
							if ($k[--$j]) { /*11576*/
								$k[$j++] = $1.swa; /*11573*/
								if ($1.encc() == $b) break; /*11573*/
								$1.cset = "seta"; /*11574*/
								break; /*11575*/
							} /*11575*/
							$k[$j++] = $1.swb; /*11578*/
							if ($1.encc() == $b) break; /*11578*/
							$1.cset = "setb"; /*11579*/
							break; /*11580*/
						} /*11580*/
						break; /*11582*/
					} /*11582*/
				} /*11582*/
				$1.cws = $geti($1.cws, 0, $1.j); /*11586*/
			} /*11586*/
			$1.metrics = $a([$a([2, 7]), $a([3, 12]), $a([4, 17]), $a([5, 22]), $a([6, 27]), $a([7, 32]), $a([8, 37]), $a([9, 42]), $a([10, 47]), $a([11, 52]), $a([12, 57]), $a([13, 62]), $a([14, 67]), $a([15, 72]), $a([16, 77])]); /*11607*/
			$1.urows = $1.rows; /*11610*/
			$1.i = 0; /*11611*/
			for (;;) { /*11621*/
				$1.m = $get($1.metrics, $1.i); /*11613*/
				$1.r = $get($1.m, 0); /*11614*/
				$1.dcws = $get($1.m, 1); /*11615*/
				$1.okay = true; /*11616*/
				if (($1.urows != 0) && ($1.urows != $1.r)) { /*11617*/
					$1.okay = false; /*11617*/
				} /*11617*/
				if ($1.cws.length > $1.dcws) { /*11618*/
					$1.okay = false; /*11618*/
				} /*11618*/
				if ($1.okay) { /*11619*/
					break; /*11619*/
				} /*11619*/
				$1.i = $1.i + 1; /*11620*/
			} /*11620*/
			$k[$j++] = Infinity; /*11624*/
			$aload($1.cws); /*11624*/
			for (var _Co = 0, _Cp = $1.dcws - $1.cws.length; _Co < _Cp; _Co++) { /*11624*/
				$k[$j++] = 103; /*11624*/
			} /*11624*/
			$1.cws = $a(); /*11624*/
			$k[$j++] = Infinity; /*11627*/
			$k[$j++] = (($1.r - 2) * 7) + $1.mode; /*11627*/
			$aload($1.cws); /*11627*/
			$1.cws = $a(); /*11627*/
			$k[$j++] = 0; /*11630*/
			for (var _Cx = 0, _Cw = $1.dcws; _Cx <= _Cw; _Cx += 1) { /*11630*/
				var _D0 = $k[--$j]; /*11630*/
				$k[$j++] = _D0 + ((_Cx + 2) * $get($1.cws, _Cx)); /*11630*/
			} /*11630*/
			$1.c1 = $k[--$j] % 107; /*11631*/
			$k[$j++] = 0; /*11632*/
			for (var _D4 = 0, _D3 = $1.dcws; _D4 <= _D3; _D4 += 1) { /*11632*/
				var _D7 = $k[--$j]; /*11632*/
				$k[$j++] = _D7 + ((_D4 + 1) * $get($1.cws, _D4)); /*11632*/
			} /*11632*/
			$1.c2 = ($k[--$j] + ($1.c1 * ($1.dcws + 2))) % 107; /*11633*/
			$k[$j++] = Infinity; /*11634*/
			$aload($1.cws); /*11634*/
			$k[$j++] = $1.c1; /*11634*/
			$k[$j++] = $1.c2; /*11634*/
			$1.cws = $a(); /*11634*/
			$1.encs = $a(["212222", "222122", "222221", "121223", "121322", "131222", "122213", "122312", "132212", "221213", "221312", "231212", "112232", "122132", "122231", "113222", "123122", "123221", "223211", "221132", "221231", "213212", "223112", "312131", "311222", "321122", "321221", "312212", "322112", "322211", "212123", "212321", "232121", "111323", "131123", "131321", "112313", "132113", "132311", "211313", "231113", "231311", "112133", "112331", "132131", "113123", "113321", "133121", "313121", "211331", "231131", "213113", "213311", "213131", "311123", "311321", "331121", "312113", "312311", "332111", "314111", "221411", "431111", "111224", "111422", "121124", "121421", "141122", "141221", "112214", "112412", "122114", "122411", "142112", "142211", "241211", "221114", "413111", "241112", "134111", "111242", "121142", "121241", "114212", "124112", "124211", "411212", "421112", "421211", "212141", "214121", "412121", "111143", "111341", "131141", "114113", "114311", "411113", "411311", "113141", "114131", "311141", "411131", "211412", "211214", "211232", "211133"]); /*11654*/
			$1.startencs = $a(["3211", "2221", "2122", "1411", "1132", "1231", "1114", "3112", "3211", "2221", "2122", "1411", "1132", "1231", "1114", "3112"]); /*11660*/
			$1.stopencsodd = $a(["3211", "2221", "2122", "1411", "1132", "1231", "1114", "3112", "1132", "1231", "1114", "3112", "3211", "2221", "2122", "1411"]); /*11664*/
			$1.stopencseven = $a(["2122", "1411", "1132", "1231", "1114", "3112", "1132", "1231", "1114", "3112", "3211", "2221", "2122", "1411", "3211", "2221"]); /*11668*/
			if (($1.pos == -1) || (((~~($1.pos / 10)) % 2) == 1)) { /*11672*/
				$1.stopencs = $1.stopencsodd; /*11670*/
			} else { /*11672*/
				$1.stopencs = $1.stopencseven; /*11672*/
			} /*11672*/
			$1.rowbits = $a($1.r); /*11676*/
			for (var _DR = 0, _DQ = $1.r - 1; _DR <= _DQ; _DR += 1) { /*11693*/
				$1.i = _DR; /*11678*/
				$k[$j++] = Infinity; /*11688*/
				$k[$j++] = 10; /*11681*/
				$forall($get($1.startencs, $1.i), function() { /*11681*/
					var _DV = $k[--$j]; /*11681*/
					$k[$j++] = _DV - 48; /*11681*/
				}); /*11681*/
				$k[$j++] = 1; /*11685*/
				$forall($geti($1.cws, $1.i * 5, 5), function() { /*11685*/
					$forall($get($1.encs, $k[--$j]), function() { /*11684*/
						var _Dc = $k[--$j]; /*11684*/
						$k[$j++] = _Dc - 48; /*11684*/
					}); /*11684*/
				}); /*11684*/
				$forall($get($1.stopencs, $1.i), function() { /*11686*/
					var _Dg = $k[--$j]; /*11686*/
					$k[$j++] = _Dg - 48; /*11686*/
				}); /*11686*/
				$k[$j++] = 1; /*11687*/
				$1.sbs = $a(); /*11688*/
				$k[$j++] = Infinity; /*11689*/
				var _Di = $1.sbs; /*11690*/
				$k[$j++] = 1; /*11690*/
				for (var _Dj = 0, _Dk = _Di.length; _Dj < _Dk; _Dj++) { /*11690*/
					var _Dm = $k[--$j]; /*11690*/
					var _Dn = (_Dm == 0) ? 1 : 0; /*11690*/
					$k[$j++] = _Dm; /*11690*/
					for (var _Do = 0, _Dp = $get(_Di, _Dj); _Do < _Dp; _Do++) { /*11690*/
						$k[$j++] = _Dn /*11690*/
					} /*11690*/
				} /*11690*/
				$astore($a($counttomark() - 1)); /*11691*/
				var _Ds = $k[--$j]; /*11691*/
				var _Dt = $k[--$j]; /*11691*/
				var _Du = $k[--$j]; /*11691*/
				$put($1.rowbits, $1.i, _Ds); /*11692*/
			} /*11692*/
			$k[$j++] = Infinity; /*11705*/
			for (var _Dy = 0, _Dz = 81 * $1.sepheight; _Dy < _Dz; _Dy++) { /*11697*/
				$k[$j++] = 1; /*11697*/
			} /*11697*/
			for (var _E2 = 0, _E1 = $1.r - 2; _E2 <= _E1; _E2 += 1) { /*11702*/
				$1.i = _E2; /*11699*/
				for (var _E4 = 0, _E5 = $1.rowheight; _E4 < _E5; _E4++) { /*11700*/
					$aload($get($1.rowbits, $1.i)); /*11700*/
				} /*11700*/
				for (var _EA = 0, _EB = $1.sepheight; _EA < _EB; _EA++) { /*11701*/
					for (var _EC = 0, _ED = 10; _EC < _ED; _EC++) { /*11701*/
						$k[$j++] = 0; /*11701*/
					} /*11701*/
					for (var _EE = 0, _EF = 70; _EE < _EF; _EE++) { /*11701*/
						$k[$j++] = 1; /*11701*/
					} /*11701*/
					$k[$j++] = 0; /*11701*/
				} /*11701*/
			} /*11701*/
			for (var _EH = 0, _EI = $1.rowheight; _EH < _EI; _EH++) { /*11703*/
				$aload($get($1.rowbits, $1.r - 1)); /*11703*/
			} /*11703*/
			for (var _EN = 0, _EO = 81 * $1.sepheight; _EN < _EO; _EN++) { /*11704*/
				$k[$j++] = 1; /*11704*/
			} /*11704*/
			$1.pixs = $a(); /*11705*/
			var _EU = {
				ren: $0.renmatrix,
				pixs: $1.pixs,
				pixx: 81,
				pixy: ~~($1.pixs.length / 81),
				height: (~~($1.pixs.length / 81)) / 72,
				width: 81 / 72,
				opt: $1.options
			}; /*11715*/
			$k[$j++] = _EU; /*11718*/
			if (!$1.dontdraw) { /*11718*/
				$0.renmatrix(); /*11718*/
			} /*11718*/
		};
		$0.code49 = function() {
			var $1 = {}; /*11745*/
			$1.options = $k[--$j]; /*11747*/
			$1.barcode = $k[--$j]; /*11748*/
			$1.dontdraw = false; /*11750*/
			$1.mode = -1; /*11751*/
			$1.pos = -1; /*11752*/
			$1.rows = 0; /*11753*/
			$1.rowheight = 8; /*11754*/
			$1.sepheight = 1; /*11755*/
			$1.parse = false; /*11756*/
			$1.parsefnc = false; /*11757*/
			$forall($1.options, function() { /*11768*/
				var _3 = $k[--$j]; /*11768*/
				$1[$k[--$j]] = _3; /*11768*/
			}); /*11768*/
			$1.mode = ~~$1.mode; /*11770*/
			$1.pos = ~~$1.pos; /*11771*/
			$1.rows = ~~$1.rows; /*11772*/
			$1.rowheight = ~~$1.rowheight; /*11773*/
			$1.sepheight = ~~$1.sepheight; /*11774*/
			$1.barlen = $1.barcode.length; /*11797*/
			$1.s1 = -1; /*11800*/
			$1.s2 = -2; /*11800*/
			$1.fn1 = -3; /*11800*/
			$1.fn2 = -4; /*11800*/
			$1.fn3 = -5; /*11800*/
			$1.ns = -6; /*11800*/
			var _E = {
				FNC1: $1.fn1,
				FNC2: $1.fn2,
				FNC3: $1.fn3
			}; /*11804*/
			$1.fncvals = _E; /*11805*/
			$1.msg = $a($1.barlen); /*11806*/
			$1.i = 0; /*11807*/
			$1.j = 0; /*11807*/
			for (;;) { /*11821*/
				if ($1.i == $1.barlen) { /*11808*/
					break; /*11808*/
				} /*11808*/
				$1.char = $get($1.barcode, $1.i); /*11809*/
				if (($1.parsefnc && ($1.char == 94)) && ($1.i < ($1.barlen - 4))) { /*11817*/
					if ($get($1.barcode, $1.i + 1) != 94) { /*11815*/
						$1.char = $get($1.fncvals, $geti($1.barcode, $1.i + 1, 4)); /*11812*/
						$1.i = $1.i + 4; /*11813*/
					} else { /*11815*/
						$1.i = $1.i + 1; /*11815*/
					} /*11815*/
				} /*11815*/
				$put($1.msg, $1.j, $1.char); /*11818*/
				$1.i = $1.i + 1; /*11819*/
				$1.j = $1.j + 1; /*11820*/
			} /*11820*/
			$1.msg = $geti($1.msg, 0, $1.j); /*11822*/
			$1.msglen = $1.msg.length; /*11823*/
			$1.charmap = $a(["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "-", ".", " ", "$", "/", "+", "%", $1.s1, $1.s2, $1.fn1, $1.fn2, $1.fn3, $1.ns]); /*11832*/
			$1.charvals = {}; /*11835*/
			for (var _q = 0; _q <= 48; _q += 1) { /*11841*/
				$1.i = _q; /*11837*/
				var _t = $get($1.charmap, $1.i); /*11838*/
				$k[$j++] = _t; /*11839*/
				if ($eq($type(_t), "stringtype")) { /*11839*/
					var _w = $get($k[--$j], 0); /*11839*/
					$k[$j++] = _w; /*11839*/
				} /*11839*/
				$put($1.charvals, $k[--$j], $1.i); /*11840*/
			} /*11840*/
			$1.combos = $a(["1 ", "1A", "1B", "1C", "1D", "1E", "1F", "1G", "1H", "1I", "1J", "1K", "1L", "1M", "1N", "1O", "1P", "1Q", "1R", "1S", "1T", "1U", "1V", "1W", "1X", "1Y", "1Z", "11", "12", "13", "14", "15", "  ", "16", "17", "18", " $", " %", "19", "10", "1-", "1.", "1$", " +", "1/", " -", " .", " /", " 0", " 1", " 2", " 3", " 4", " 5", " 6", " 7", " 8", " 9", "1+", "21", "22", "23", "24", "25", "26", " A", " B", " C", " D", " E", " F", " G", " H", " I", " J", " K", " L", " M", " N", " O", " P", " Q", " R", " S", " T", " U", " V", " W", " X", " Y", " Z", "27", "28", "29", "20", "2-", "2.", "2A", "2B", "2C", "2D", "2E", "2F", "2G", "2H", "2I", "2J", "2K", "2L", "2M", "2N", "2O", "2P", "2Q", "2R", "2S", "2T", "2U", "2V", "2W", "2X", "2Y", "2Z", "2$", "2/", "2+", "2%", "2 "]); /*11853*/
			for (var _11 = 0; _11 <= 127; _11 += 1) { /*11863*/
				$1.i = _11; /*11855*/
				var _14 = $get($1.combos, $1.i); /*11856*/
				$1.c1 = $get(_14, 0); /*11856*/
				$1.c2 = $get(_14, 1); /*11856*/
				if ($1.c1 == 49) { /*11859*/
					$put($1.charvals, $1.i, $a([$get($1.charvals, $1.s1), $get($1.charvals, $1.c2)])); /*11858*/
				} /*11858*/
				if ($1.c1 == 50) { /*11862*/
					$put($1.charvals, $1.i, $a([$get($1.charvals, $1.s2), $get($1.charvals, $1.c2)])); /*11861*/
				} /*11861*/
			} /*11861*/
			$1.encodealpha = function() {
				var _1T = $get($1.charvals, $k[--$j]); /*11866*/
				$k[$j++] = _1T; /*11867*/
				if ($ne($type(_1T), "arraytype")) { /*11867*/
					$astore($a(1)); /*11867*/
				} /*11867*/
				var _1W = $k[--$j]; /*11868*/
				$puti($1.cws, $1.j, _1W); /*11868*/
				$1.j = _1W.length + $1.j; /*11869*/
			}; /*11870*/
			$1.base48 = function() {
				var _1a = $k[--$j]; /*11873*/
				$k[$j++] = 0; /*11873*/
				$forall(_1a, function() { /*11873*/
					var _1b = $k[--$j]; /*11873*/
					var _1c = $k[--$j]; /*11873*/
					$k[$j++] = (_1b - 48) + (_1c * 10); /*11873*/
				}); /*11873*/
				$k[$j++] = Infinity; /*11874*/
				var _1d = $k[--$j]; /*11874*/
				var _1e = $k[--$j]; /*11874*/
				var _1f = $k[--$j]; /*11874*/
				$k[$j++] = _1d; /*11874*/
				$k[$j++] = _1e; /*11874*/
				for (var _1g = 0, _1h = _1f - 1; _1g < _1h; _1g++) { /*11874*/
					var _1i = $k[--$j]; /*11874*/
					$k[$j++] = _1i % 48; /*11874*/
					$k[$j++] = ~~(_1i / 48); /*11874*/
				} /*11874*/
				var _1j = $a(); /*11874*/
				$k[$j++] = _1j; /*11875*/
				$k[$j++] = Infinity; /*11875*/
				var _1k = $k[--$j]; /*11875*/
				var _1l = $k[--$j]; /*11875*/
				$k[$j++] = _1k; /*11875*/
				$k[$j++] = _1l; /*11875*/
				for (var _1m = _1l.length - 1; _1m >= 0; _1m -= 1) { /*11875*/
					var _1n = $k[--$j]; /*11875*/
					$k[$j++] = $get(_1n, _1m); /*11875*/
					$k[$j++] = _1n; /*11875*/
				} /*11875*/
				$j--; /*11875*/
				var _1p = $a(); /*11875*/
				$puti($1.cws, $1.j, _1p); /*11876*/
				$1.j = _1p.length + $1.j; /*11877*/
			}; /*11878*/
			$1.encodenumeric = function() {
				$1.nums = $k[--$j]; /*11881*/
				var _1v = $1.nums.length; /*11882*/
				var _1w = _1v % 5; /*11882*/
				$k[$j++] = "pre"; /*11882*/
				$k[$j++] = _1v; /*11882*/
				$k[$j++] = _1w; /*11882*/
				if (_1w != 2) { /*11882*/
					var _1x = $k[--$j]; /*11882*/
					var _1y = $k[--$j]; /*11882*/
					$k[$j++] = _1y - _1x; /*11882*/
				} else { /*11882*/
					var _1z = $k[--$j]; /*11882*/
					var _20 = $k[--$j]; /*11882*/
					$k[$j++] = (_20 - _1z) - 5; /*11882*/
				} /*11882*/
				var _21 = $k[--$j]; /*11882*/
				$1[$k[--$j]] = _21; /*11882*/
				for (var _25 = 0, _24 = $1.pre - 1; _25 <= _24; _25 += 5) { /*11883*/
					$k[$j++] = 3; /*11883*/
					$k[$j++] = $geti($1.nums, _25, 5); /*11883*/
					if ($1.base48() == $b) break; /*11883*/
				} /*11883*/
				$1.nums = $geti($1.nums, $1.pre, $1.nums.length - $1.pre); /*11884*/
				var _2E = $1.nums.length; /*11886*/
				$k[$j++] = _2E; /*11886*/
				if (_2E == 1) { /*11886*/
					$k[$j++] = $get($1.nums, $1.i); /*11886*/
					if ($1.encodealpha() == $b) return $b; /*11886*/
				} /*11886*/
				var _2I = $k[--$j]; /*11887*/
				$k[$j++] = _2I; /*11887*/
				if (_2I == 3) { /*11887*/
					$k[$j++] = 2; /*11887*/
					$k[$j++] = $1.nums; /*11887*/
					if ($1.base48() == $b) return $b; /*11887*/
				} /*11887*/
				var _2K = $k[--$j]; /*11888*/
				$k[$j++] = _2K; /*11888*/
				if (_2K == 4) { /*11888*/
					$k[$j++] = 3; /*11888*/
					$k[$j++] = Infinity; /*11888*/
					$k[$j++] = 49; /*11888*/
					$k[$j++] = 48; /*11888*/
					$aload($1.nums); /*11888*/
					var _2M = $a(); /*11888*/
					$k[$j++] = _2M; /*11888*/
					if ($1.base48() == $b) return $b; /*11888*/
				} /*11888*/
				if ($k[--$j] == 7) { /*11892*/
					$k[$j++] = 3; /*11890*/
					$k[$j++] = Infinity; /*11890*/
					$k[$j++] = 49; /*11890*/
					$k[$j++] = 48; /*11890*/
					$aload($geti($1.nums, 0, 4)); /*11890*/
					var _2Q = $a(); /*11890*/
					$k[$j++] = _2Q; /*11890*/
					if ($1.base48() == $b) return $b; /*11890*/
					$k[$j++] = 2; /*11891*/
					$k[$j++] = $geti($1.nums, 4, 3); /*11891*/
					if ($1.base48() == $b) return $b; /*11891*/
				} /*11891*/
			}; /*11893*/
			$k[$j++] = Infinity; /*11896*/
			for (var _2U = 0, _2V = $1.msglen; _2U < _2V; _2U++) { /*11896*/
				$k[$j++] = 0; /*11896*/
			} /*11896*/
			$k[$j++] = 0; /*11896*/
			$1.numericruns = $a(); /*11896*/
			for (var _2Y = $1.msglen - 1; _2Y >= 0; _2Y -= 1) { /*11905*/
				$1.i = _2Y; /*11898*/
				var _2b = $get($1.msg, $1.i); /*11899*/
				if ((_2b >= 48) && (_2b <= 57)) { /*11903*/
					$put($1.numericruns, $1.i, $get($1.numericruns, $1.i + 1) + 1); /*11901*/
				} else { /*11903*/
					$put($1.numericruns, $1.i, 0); /*11903*/
				} /*11903*/
			} /*11903*/
			if ($1.mode == -1) { /*11917*/
				for (;;) { /*11916*/
					if ($1.pos != -1) { /*11910*/
						$1.mode = 3; /*11910*/
						break; /*11910*/
					} /*11910*/
					if ($get($1.numericruns, 0) >= 5) { /*11911*/
						$1.mode = 2; /*11911*/
						break; /*11911*/
					} /*11911*/
					var _2q = $get($1.charvals, $get($1.msg, 0)); /*11912*/
					$k[$j++] = _2q; /*11913*/
					if ($ne($type(_2q), "arraytype")) { /*11913*/
						$j--; /*11913*/
						$1.mode = 0; /*11913*/
						break; /*11913*/
					} /*11913*/
					var _2u = ($get($k[--$j], 0) == 43) ? 4 : 5; /*11914*/
					$1.mode = _2u; /*11914*/
					break; /*11915*/
				} /*11915*/
			} /*11915*/
			$1.cws = $a(($1.msglen * 2) + 1); /*11919*/
			$1.method = "alpha"; /*11920*/
			$1.i = -1; /*11920*/
			$1.j = -1; /*11920*/
			if (($1.mode == 0) || ($1.mode == 1)) { /*11923*/
				$1.method = "alpha"; /*11923*/
				$1.i = 0; /*11923*/
				$1.j = 0; /*11923*/
			} /*11923*/
			if ($1.mode == 2) { /*11924*/
				$1.method = "numeric"; /*11924*/
				$1.i = 0; /*11924*/
				$1.j = 0; /*11924*/
			} /*11924*/
			if ($1.mode == 3) { /*11938*/
				$1.posval = $a([12, 22, 13, 23, 33, 14, 24, 34, 44, 15, 25, 35, 45, 55, 16, 26, 36, 46, 56, 66, 17, 27, 37, 47, 57, 67, 77, 18, 28, 38, 48, 58, 68, 78, 88, 19, 29, 39, 49, 59, 69, 79, 89, 99]); /*11935*/
				$k[$j++] = $1.cws; /*11936*/
				$k[$j++] = 0; /*11936*/
				for (var _33 = 0; _33 <= 43; _33 += 1) { /*11936*/
					$k[$j++] = _33; /*11936*/
					if ($get($1.posval, _33) != $1.pos) { /*11936*/
						$j--; /*11936*/
					} /*11936*/
				} /*11936*/
				var _37 = $k[--$j]; /*11936*/
				var _38 = $k[--$j]; /*11936*/
				$put($k[--$j], _38, _37 + 1); /*11936*/
				$1.method = "alpha"; /*11937*/
				$1.i = 0; /*11937*/
				$1.j = 1; /*11937*/
			} /*11937*/
			if (($1.mode == 4) || ($1.mode == 5)) { /*11942*/
				$put($1.cws, 0, $get($get($1.charvals, $get($1.msg, 0)), 1)); /*11940*/
				$1.method = "alpha"; /*11941*/
				$1.i = 1; /*11941*/
				$1.j = 1; /*11941*/
			} /*11941*/
			for (;;) { /*11969*/
				if ($1.i == $1.msglen) { /*11946*/
					break; /*11946*/
				} /*11946*/
				for (;;) { /*11968*/
					if ($eq($1.method, "alpha")) { /*11957*/
						if ($get($1.numericruns, $1.i) >= 5) { /*11953*/
							$k[$j++] = $1.ns; /*11950*/
							if ($1.encodealpha() == $b) break; /*11950*/
							$1.method = "numeric"; /*11951*/
							break; /*11952*/
						} /*11952*/
						$k[$j++] = $get($1.msg, $1.i); /*11954*/
						if ($1.encodealpha() == $b) break; /*11954*/
						$1.i = $1.i + 1; /*11955*/
						break; /*11956*/
					} /*11956*/
					if ($eq($1.method, "numeric")) { /*11967*/
						if ($get($1.numericruns, $1.i) < 5) { /*11963*/
							$k[$j++] = $1.ns; /*11960*/
							if ($1.encodealpha() == $b) break; /*11960*/
							$1.method = "alpha"; /*11961*/
							break; /*11962*/
						} /*11962*/
						$k[$j++] = $geti($1.msg, $1.i, $get($1.numericruns, $1.i)); /*11964*/
						if ($1.encodenumeric() == $b) break; /*11964*/
						$1.i = $1.i + $get($1.numericruns, $1.i); /*11965*/
						break; /*11966*/
					} /*11966*/
				} /*11966*/
			} /*11966*/
			$1.cws = $geti($1.cws, 0, $1.j); /*11970*/
			$1.metrics = $a([$a([2, 9]), $a([3, 16]), $a([4, 23]), $a([5, 30]), $a([6, 37]), $a([7, 42]), $a([8, 49])]); /*11982*/
			$1.urows = $1.rows; /*11985*/
			$1.i = 0; /*11986*/
			for (;;) { /*11996*/
				$1.m = $get($1.metrics, $1.i); /*11988*/
				$1.r = $get($1.m, 0); /*11989*/
				$1.dcws = $get($1.m, 1); /*11990*/
				$1.okay = true; /*11991*/
				if (($1.urows != 0) && ($1.urows != $1.r)) { /*11992*/
					$1.okay = false; /*11992*/
				} /*11992*/
				if ($1.cws.length > $1.dcws) { /*11993*/
					$1.okay = false; /*11993*/
				} /*11993*/
				if ($1.okay) { /*11994*/
					break; /*11994*/
				} /*11994*/
				$1.i = $1.i + 1; /*11995*/
			} /*11995*/
			$k[$j++] = Infinity; /*11999*/
			$aload($1.cws); /*11999*/
			for (var _4B = 0, _4C = $1.dcws - $1.cws.length; _4B < _4C; _4B++) { /*11999*/
				$k[$j++] = 48; /*11999*/
			} /*11999*/
			$1.cws = $a(); /*11999*/
			$1.ccs = $a($1.r * 8); /*12002*/
			$1.j = 0; /*12003*/
			for (var _4I = 0, _4H = $1.r - 2; _4I <= _4H; _4I += 1) { /*12010*/
				$1.i = _4I; /*12005*/
				$1.cc = $geti($1.cws, $1.j, 7); /*12006*/
				$puti($1.ccs, $1.i * 8, $1.cc); /*12007*/
				$k[$j++] = $1.ccs; /*12008*/
				$k[$j++] = ($1.i * 8) + 7; /*12008*/
				$k[$j++] = 0; /*12008*/
				$forall($1.cc, function() { /*12008*/
					var _4S = $k[--$j]; /*12008*/
					var _4T = $k[--$j]; /*12008*/
					$k[$j++] = _4T + _4S; /*12008*/
				}); /*12008*/
				var _4U = $k[--$j]; /*12008*/
				var _4V = $k[--$j]; /*12008*/
				$put($k[--$j], _4V, _4U % 49); /*12008*/
				$1.j = $1.j + 7; /*12009*/
			} /*12009*/
			if ($1.j < $1.dcws) { /*12013*/
				$puti($1.ccs, $1.ccs.length - 8, $geti($1.cws, $1.j, $1.dcws - $1.j)); /*12012*/
			} /*12012*/
			$1.cr7 = (($1.r - 2) * 7) + $1.mode; /*12016*/
			$put($1.ccs, $1.ccs.length - 2, $1.cr7); /*12017*/
			var _4m = $a([1, 9, 31, 26, 2, 12, 17, 23, 37, 18, 22, 6, 27, 44, 15, 43, 39, 11, 13, 5, 41, 33, 36, 8, 4, 32, 3, 19, 40, 25, 29, 10, 24, 30]); /*12021*/
			$k[$j++] = _4m; /*12022*/
			$k[$j++] = _4m; /*12022*/
			$k[$j++] = Infinity; /*12022*/
			var _4n = $k[--$j]; /*12022*/
			var _4p = $geti($k[--$j], 0, 32); /*12022*/
			$k[$j++] = _4n; /*12022*/
			$k[$j++] = 20; /*12022*/
			$aload(_4p); /*12022*/
			$1.weightx = $a(); /*12022*/
			var _4r = $k[--$j]; /*12023*/
			$k[$j++] = _4r; /*12023*/
			$k[$j++] = _4r; /*12023*/
			$k[$j++] = Infinity; /*12023*/
			var _4s = $k[--$j]; /*12023*/
			var _4u = $geti($k[--$j], 1, 32); /*12023*/
			$k[$j++] = _4s; /*12023*/
			$k[$j++] = 16; /*12023*/
			$aload(_4u); /*12023*/
			$1.weighty = $a(); /*12023*/
			$k[$j++] = Infinity; /*12024*/
			var _4w = $k[--$j]; /*12024*/
			var _4y = $geti($k[--$j], 2, 32); /*12024*/
			$k[$j++] = _4w; /*12024*/
			$k[$j++] = 38; /*12024*/
			$aload(_4y); /*12024*/
			$1.weightz = $a(); /*12024*/
			$1.calccheck = function() {
				$1.weights = $k[--$j]; /*12026*/
				$1.score = 0; /*12027*/
				for (var _53 = 0, _52 = (~~((($1.r - 1) * 8) / 2)) - 1; _53 <= _52; _53 += 1) { /*12032*/
					$1.i = _53; /*12029*/
					$1.score = ((($get($1.ccs, $1.i * 2) * 49) + $get($1.ccs, ($1.i * 2) + 1)) * $get($1.weights, $1.i + 1)) + $1.score; /*12031*/
				} /*12031*/
				$k[$j++] = $1.score; /*12033*/
			}; /*12034*/
			$1.lastrow = $geti($1.ccs, $1.ccs.length - 8, 8); /*12035*/
			if ($1.r >= 7) { /*12042*/
				$k[$j++] = $1.cr7 * $get($1.weightz, 0); /*12039*/
				$k[$j++] = $1.weightz; /*12039*/
				if ($1.calccheck() == $b) return $b; /*12039*/
				var _5N = $k[--$j]; /*12039*/
				var _5P = ($k[--$j] + _5N) % 2401; /*12040*/
				$k[$j++] = ~~(_5P / 49); /*12040*/
				$k[$j++] = _5P % 49; /*12040*/
				$astore($a(2)); /*12040*/
				$puti($1.lastrow, 0, $k[--$j]); /*12041*/
			} /*12041*/
			$1.wr1 = ($get($1.lastrow, 0) * 49) + $get($1.lastrow, 1); /*12043*/
			$k[$j++] = $1.cr7 * $get($1.weighty, 0); /*12046*/
			$k[$j++] = $1.weighty; /*12046*/
			if ($1.calccheck() == $b) return $b; /*12046*/
			var _5b = $k[--$j]; /*12046*/
			var _5h = (($k[--$j] + _5b) + ($1.wr1 * $get($1.weighty, ($1.r * 4) - 3))) % 2401; /*12048*/
			$1.wr2 = _5h; /*12048*/
			$k[$j++] = ~~(_5h / 49); /*12049*/
			$k[$j++] = _5h % 49; /*12049*/
			$astore($a(2)); /*12049*/
			$puti($1.lastrow, 2, $k[--$j]); /*12050*/
			$k[$j++] = $1.cr7 * $get($1.weightx, 0); /*12053*/
			$k[$j++] = $1.weightx; /*12053*/
			if ($1.calccheck() == $b) return $b; /*12053*/
			var _5p = $k[--$j]; /*12053*/
			var _5z = ((($k[--$j] + _5p) + ($1.wr1 * $get($1.weightx, ($1.r * 4) - 3))) + ($1.wr2 * $get($1.weightx, ($1.r * 4) - 2))) % 2401; /*12057*/
			$k[$j++] = ~~(_5z / 49); /*12057*/
			$k[$j++] = _5z % 49; /*12057*/
			$astore($a(2)); /*12057*/
			$puti($1.lastrow, 4, $k[--$j]); /*12058*/
			$k[$j++] = 0; /*12061*/
			$forall($geti($1.ccs, $1.ccs.length - 8, 7), function() { /*12061*/
				var _66 = $k[--$j]; /*12061*/
				var _67 = $k[--$j]; /*12061*/
				$k[$j++] = _67 + _66; /*12061*/
			}); /*12061*/
			$put($1.ccs, $1.ccs.length - 1, $k[--$j] % 49); /*12062*/
			$1.patterns = $a([$a(["11521132", "25112131", "14212132", "25121221", "14221222", "12412132", "23321221", "12421222", "21521221", "15112222", "15121312", "13312222", "24221311", "13321312", "11512222", "22421311", "11521312", "25112311", "14212312", "23312311", "12412312", "21512311", "16121131", "14321131", "12521131", "15212131", "15221221", "13412131", "13421221", "11612131", "16112221", "16121311", "14312221", "14321311", "12512221", "12521311", "15212311", "13412311", "11612311", "11131135", "31131133", "51131131", "21122134", "41122132", "21131224", "41131222", "11113135", "31113133", "51113131", "11122225", "31122223", "51122221", "11131315", "31131313", "51131311", "21113224", "41113222", "21122314", "41122312", "11113315", "31113313", "51113311", "12131134", "32131132", "21231133", "41231131", "22122133", "42122131", "11222134", "22131223", "42131221", "11231224", "31231222", "12113134", "32113132", "12122224", "32122222", "12131314", "32131312", "21231313", "41231311", "22113223", "42113221", "11213224", "22122313", "42122311", "11222314", "31222312", "12113314", "32113312", "21213313", "41213311", "13131133", "33131131", "22231132", "11331133", "31331131", "23122132", "12222133", "23131222", "12231223", "32231221", "21331222", "13113133", "33113131", "13122223", "33122221", "11313133", "13131313", "33131311", "11322223", "22231312", "11331313", "31331311", "23113222", "12213223", "23122312", "12222313", "32222311", "21322312", "13113313", "33113311", "22213312", "11313313", "31313311", "14131132", "23231131", "12331132", "21431131", "24122131", "13222132", "24131221", "13231222", "11422132", "22331221", "11431222", "14113132", "14122222", "12313132", "14131312", "12322222", "23231311", "12331312", "21431311", "24113221", "13213222", "24122311", "13222312", "11413222", "22322311", "11422312", "14113312", "23213311", "12313312", "21413311", "15131131", "13331131", "14222131", "14231221", "12422131", "12431221", "15113131", "15122221", "13313131", "15131311", "13322221", "11513131", "13331311", "11522221", "14213221", "14222311", "12413221", "12422311", "15113311", "13313311", "11513311", "11141134", "31141132", "21132133", "41132131", "21141223", "41141221", "11123134", "31123132", "11132224", "31132222", "11141314", "31141312", "21114133", "41114131", "21123223", "41123221", "21132313", "41132311", "11114224", "31114222", "11123314", "31123312", "21114313", "41114311", "12141133", "32141131", "21241132", "22132132", "11232133", "22141222", "11241223", "31241221", "12123133", "32123131", "12132223", "32132221", "12141313", "32141311", "21241312", "22114132", "11214133", "22123222", "11223223", "22132312", "11232313", "31232311", "12114223", "32114221", "12123313", "32123311", "21223312", "22114312", "11214313", "31214311", "13141132", "22241131", "11341132", "23132131", "12232132", "23141221", "12241222", "21341221", "13123132", "13132222", "11323132", "13141312", "11332222", "22241311", "11341312", "23114131", "12214132", "23123221", "12223222", "23132311", "12232312", "21332311", "13114222", "13123312", "11314222", "22223311", "11323312", "23114311", "12214312", "21314311", "14141131", "12341131", "13232131", "13241221", "11432131", "14123131", "14132221", "12323131", "14141311", "12332221", "12341311", "13214131", "13223221", "11414131", "13232311", "11423221", "11432311", "14114221", "14123311", "12314221", "12323311", "13214311", "11414311", "11151133", "31151131", "21142132", "21151222", "11133133", "31133131", "11142223", "31142221", "11151313", "31151311", "21124132", "21133222", "21142312", "11115133", "31115131", "11124223", "31124221", "11133313", "31133311", "21115222", "21124312", "12151132", "21251131", "22142131", "11242132", "22151221", "11251222", "12133132", "12142222", "12151312", "21251311", "22124131", "11224132", "22133221", "11233222", "22142311", "11242312", "12115132", "12124222", "12133312", "21233311", "22115221", "11215222", "22124311", "11224312", "13151131", "12242131", "12251221", "13133131", "13142221", "11333131", "13151311", "11342221", "12224131", "12233221", "12242311", "13115131", "13124221", "11315131", "13133311", "11324221", "11333311", "12215221", "12224311", "11161132", "21152131", "21161221", "11143132", "11152222", "11161312", "21134131", "21143221", "21152311", "11125132", "11134222", "11143312", "21116131", "21125221", "21134311", "12161131", "11252131", "12143131", "12152221", "12161311", "11234131", "11243221", "11252311", "12125131", "12134221", "12143311", "11216131", "11225221", "11234311", "11111236", "31111234", "51111232", "21111325", "41111323", "61111321", "11111416", "31111414", "51111412", "31211143", "51211141", "12111235", "32111233", "52111231", "21211234", "41211232", "22111324", "42111322", "11211325", "31211323", "51211321", "12111415", "32111413", "52111411", "21211414", "41211412", "12211144", "32211142", "21311143", "41311141", "13111234", "33111232", "22211233", "42211231", "11311234", "31311232", "23111323", "43111321", "12211324", "32211322", "21311323", "41311321", "13111414", "33111412", "22211413", "42211411", "11311414", "31311412", "13211143", "33211141", "22311142", "11411143", "31411141", "14111233", "34111231", "23211232", "12311233", "32311231", "21411232", "24111322", "13211323", "33211321", "22311322", "11411323", "31411321", "14111413", "34111411", "23211412", "12311413", "32311411", "21411412", "14211142", "23311141", "12411142", "21511141", "15111232", "24211231", "13311232", "22411231", "11511232", "25111321", "14211322", "23311321", "12411322", "21511321", "15111412", "24211411", "13311412", "22411411", "11511412", "15211141", "13411141", "11611141", "16111231", "14311231", "12511231", "15211321", "13411321", "11611321", "16111411", "14311411", "12511411", "21121144", "41121142", "11112145", "31112143", "51112141", "11121235", "31121233", "51121231", "21112234", "41112232", "21121324", "41121322", "11112325", "31112323", "51112321", "11121415", "31121413", "51121411", "21112414", "41112412", "22121143", "42121141", "11221144", "31221142", "12112144", "32112142", "12121234", "32121232", "21221233", "41221231", "22112233", "42112231", "11212234", "22121323", "42121321", "11221324", "31221322", "12112324", "32112322", "12121414", "32121412", "21221413", "41221411", "22112413", "42112411", "11212414", "31212412", "23121142", "12221143", "32221141", "21321142", "13112143", "33112141", "13121233", "33121231", "11312143", "22221232", "11321233", "31321231", "23112232", "12212233", "23121322", "12221323", "32221321", "21321322", "13112323", "33112321", "13121413", "33121411", "11312323", "22221412", "11321413", "31321411", "23112412", "12212413", "32212411", "21312412", "24121141", "13221142", "22321141", "11421142", "14112142", "14121232", "12312142", "23221231", "12321232", "21421231", "24112231", "13212232", "24121321", "13221322", "11412232", "22321321", "11421322", "14112322", "14121412", "12312322", "23221411", "12321412", "21421411", "24112411", "13212412", "22312411", "11412412", "14221141", "12421141", "15112141", "15121231", "13312141", "13321231", "11512141", "11521231", "14212231", "14221321", "12412231", "12421321", "15112321", "15121411", "13312321", "13321411", "11512321", "11521411", "14212411", "12412411", "21131143", "41131141", "11122144", "31122142", "11131234", "31131232", "21113143", "41113141", "21122233", "41122231", "21131323", "41131321", "11113234", "31113232", "11122324", "31122322", "11131414", "31131412", "21113323", "41113321", "21122413", "41122411", "11113414", "31113412", "22131142", "11231143", "31231141", "12122143", "32122141", "12131233", "32131231", "21231232", "22113142", "11213143", "22122232", "11222233", "22131322", "11231323", "31231321", "12113233", "32113231", "12122323", "32122321", "12131413", "32131411", "21231412", "22113322", "11213323", "22122412", "11222413", "31222411", "12113413", "32113411", "21213412", "23131141", "12231142", "21331141", "13122142", "13131232", "11322142", "22231231", "11331232", "23113141", "12213142", "23122231", "12222232", "23131321", "12231322", "21331321", "13113232", "13122322", "11313232", "13131412", "11322322", "22231411", "11331412", "23113321", "12213322", "23122411", "12222412", "21322411", "13113412", "22213411", "11313412", "13231141", "11431141", "14122141", "14131231", "12322141", "12331231", "13213141", "13222231", "11413141", "13231321", "11422231", "11431321", "14113231", "14122321", "12313231", "14131411", "12322321", "12331411", "13213321", "13222411", "11413321", "11422411", "14113411", "12313411", "21141142", "11132143", "31132141", "11141233", "31141231", "21123142", "21132232", "21141322", "11114143", "31114141", "11123233", "31123231", "11132323", "31132321", "11141413", "31141411", "21114232", "21123322", "21132412", "11114323", "31114321", "11123413", "31123411", "22141141", "11241142", "12132142", "12141232", "21241231", "22123141", "11223142", "22132231", "11232232", "22141321", "11241322", "12114142", "12123232", "12132322", "12141412", "21241411", "22114231", "11214232", "22123321", "11223322", "22132411", "11232412", "12114322", "12123412", "21223411", "12241141", "13132141", "13141231", "11332141", "11341231", "12223141", "12232231", "12241321", "13114141", "13123231", "11314141", "13132321", "11323231", "13141411", "11332321", "11341411", "12214231", "12223321", "12232411", "13114321", "13123411", "11314321", "11323411", "21151141", "11142142", "11151232", "21133141", "21142231", "21151321", "11124142", "11133232", "11142322", "11151412", "21115141", "21124231", "21133321", "21142411", "11115232", "11124322", "11133412", "11251141", "12142141", "12151231", "11233141", "11242231", "11251321", "12124141", "12133231", "12142321", "12151411", "11215141", "11224231", "11233321", "11242411", "12115231", "12124321", "12133411", "11152141", "11161231", "11134141", "11143231", "11152321", "11161411", "11116141", "11125231", "11134321", "11143411", "21111244", "41111242", "11111335", "31111333", "51111331", "21111424", "41111422", "11111515", "31111513", "51111511", "21211153", "41211151", "22111243", "42111241", "11211244", "31211242", "12111334", "32111332", "21211333", "41211331", "22111423", "42111421", "11211424", "31211422", "12111514", "32111512", "21211513", "41211511", "22211152", "11311153", "31311151", "23111242", "12211243", "32211241", "21311242", "13111333", "33111331", "22211332", "11311333", "31311331", "23111422", "12211423", "32211421", "21311422", "13111513", "33111511", "22211512", "11311513", "31311511", "23211151", "12311152", "21411151", "24111241", "13211242", "22311241", "11411242", "14111332", "23211331", "12311332", "21411331", "24111421", "13211422", "22311421", "11411422", "14111512", "23211511", "12311512", "21411511", "13311151", "11511151", "14211241", "12411241", "15111331", "13311331", "11511331", "14211421", "12411421", "15111511", "13311511", "11511511", "31121152", "21112153", "41112151", "21121243", "41121241", "11112244", "31112242", "11121334", "31121332", "21112333", "41112331", "21121423", "41121421", "11112424", "31112422", "11121514", "31121512", "21112513", "41112511", "12121153", "32121151", "21221152", "22112152", "11212153", "22121242", "11221243", "31221241", "12112243", "32112241", "12121333", "32121331", "21221332", "22112332", "11212333", "22121422", "11221423", "31221421", "12112423", "32112421", "12121513", "32121511", "21221512", "22112512", "11212513", "31212511", "13121152", "22221151", "11321152", "23112151", "12212152", "23121241", "12221242", "21321241", "13112242", "13121332", "11312242", "22221331", "11321332", "23112331", "12212332", "23121421", "12221422", "21321421", "13112422", "13121512", "11312422", "22221511", "11321512", "23112511", "12212512", "21312511", "14121151", "12321151", "13212151", "13221241", "11412151", "11421241", "14112241", "14121331", "12312241", "12321331", "13212331", "13221421", "11412331", "11421421", "14112421", "14121511", "12312421", "12321511", "13212511", "11412511", "11131153", "31131151", "21122152", "21131242", "11113153", "31113151", "11122243", "31122241", "11131333", "31131331", "21113242", "21122332", "21131422", "11113333", "31113331", "11122423", "31122421", "11131513", "31131511", "21113422", "21122512", "12131152", "21231151", "22122151", "11222152", "22131241", "11231242", "12113152", "12122242", "12131332", "21231331", "22113241", "11213242", "22122331", "11222332", "22131421", "11231422", "12113332", "12122422", "12131512", "21231511", "22113421", "11213422", "22122511", "11222512", "13131151", "11331151", "12222151", "12231241", "13113151", "13122241", "11313151", "13131331", "11322241", "11331331", "12213241", "12222331", "12231421", "13113331", "13122421", "11313331", "13131511", "11322421", "11331511", "12213421", "12222511", "11141152", "21132151", "21141241", "11123152", "11132242", "11141332", "21114151", "21123241", "21132331", "21141421", "11114242", "11123332", "11132422", "11141512", "21114331", "21123421", "21132511", "12141151", "11232151", "11241241", "12123151", "12132241", "12141331", "11214151", "11223241", "11232331", "11241421", "12114241", "12123331", "12132421", "12141511", "11214331", "11223421", "11232511", "11151151", "11133151", "11142241", "11151331", "11115151", "11124241", "11133331", "11142421", "11151511", "11111254", "31111252", "21111343", "41111341", "11111434", "31111432", "21111523", "41111521", "11111614", "31111612", "31211161", "12111253", "32111251", "21211252", "22111342", "11211343", "31211341", "12111433", "32111431", "21211432", "22111522", "11211523", "31211521", "12111613", "32111611", "21211612", "12211162", "21311161", "13111252", "22211251", "11311252", "23111341", "12211342", "21311341", "13111432", "22211431", "11311432", "23111521", "12211522", "21311521", "13111612", "22211611", "11311612", "13211161", "11411161", "14111251", "12311251", "13211341", "11411341", "14111431", "12311431", "13211521", "11411521", "14111611", "12311611", "21121162", "11112163", "31112161", "11121253", "31121251", "21112252", "21121342", "11112343", "31112341", "11121433", "31121431", "21112432", "21121522", "11112523", "31112521", "11121613", "31121611", "22121161", "11221162", "12112162", "12121252", "21221251", "22112251", "11212252", "22121341", "11221342", "12112342", "12121432", "21221431", "22112431", "11212432", "22121521", "11221522", "12112522", "12121612", "21221611", "12221161", "13112161", "13121251", "11312161", "11321251", "32121115", "52121113", "21221116", "41221114", "61221112", "22112116", "42112114", "31212115", "51212113", "13121116", "33121114", "22221115", "42221113", "11321116", "31321114", "51321112", "23112115", "43112113", "12212116", "32212114", "52212112", "21312115", "41312113", "61312111", "14121115", "34121113", "23221114", "43221112", "12321115", "32321113", "52321111", "21421114", "41421112", "24112114", "13212115", "33212113", "22312114", "42312112", "11412115", "31412113", "51412111", "15121114", "24221113", "13321114", "33321112", "22421113", "42421111", "11521114", "31521112", "25112113", "14212114", "34212112", "23312113", "43312111", "12412114", "32412112", "21512113", "41512111", "16121113", "25221112", "14321113", "34321111", "23421112", "12521113", "32521111", "15212113", "24312112", "13412113", "33412111", "22512112", "11612113", "31612111", "31131115", "51131113", "21122116", "41122114", "61122112", "31113115", "51113113", "12131116", "32131114", "52131112", "21231115", "41231113", "61231111", "22122115", "42122113", "11222116", "31222114", "51222112", "12113116", "32113114", "52113112", "21213115", "41213113", "61213111", "13131115", "33131113", "22231114", "42231112", "11331115", "31331113", "51331111", "23122114", "43122112", "12222115", "32222113", "52222111", "21322114", "41322112", "13113115", "33113113", "22213114", "42213112", "11313115", "31313113", "51313111", "14131114", "34131112", "23231113", "43231111", "12331114", "32331112", "21431113", "41431111", "24122113", "13222114", "33222112", "22322113", "42322111", "11422114", "31422112", "14113114", "34113112", "23213113", "43213111", "12313114", "32313112", "21413113", "41413111", "15131113", "24231112", "13331113", "33331111", "22431112", "25122112", "14222113", "34222111", "23322112", "12422113", "32422111", "21522112", "15113113", "24213112", "13313113", "33313111", "22413112", "11513113", "31513111", "16131112", "25231111", "14331112", "23431111", "15222112", "24322111", "13422112", "22522111", "16113112", "25213111", "14313112", "23413111", "12513112", "21613111", "11141116", "31141114", "51141112", "21132115", "41132113", "61132111", "11123116", "31123114", "51123112", "21114115", "41114113", "61114111", "12141115", "32141113", "52141111", "21241114", "41241112", "22132114", "42132112", "11232115", "31232113", "51232111", "12123115", "32123113", "52123111", "21223114", "41223112", "22114114", "42114112", "11214115", "31214113", "51214111", "13141114", "33141112", "22241113", "42241111", "11341114", "31341112", "23132113", "43132111", "12232114", "32232112", "21332113", "41332111", "13123114", "33123112", "22223113", "42223111", "11323114", "31323112", "23114113", "43114111", "12214114", "32214112", "21314113", "41314111", "14141113", "34141111", "23241112", "12341113", "32341111", "24132112", "13232113", "33232111", "22332112", "11432113", "31432111", "14123113", "34123111", "23223112", "12323113", "32323111", "21423112", "24114112", "13214113", "33214111", "22314112", "11414113", "31414111", "15141112", "24241111", "13341112", "25132111", "14232112", "23332111", "12432112", "15123112", "24223111", "13323112", "22423111", "11523112", "25114111", "14214112", "23314111", "12414112", "21514111", "16141111", "14341111", "15232111", "13432111", "16123111", "14323111", "12523111", "15214111", "13414111", "11614111", "11151115", "31151113", "51151111", "21142114", "41142112", "11133115", "31133113", "51133111", "21124114", "41124112", "11115115", "31115113", "51115111", "12151114", "32151112", "21251113", "41251111", "22142113", "42142111", "11242114", "31242112", "12133114", "32133112", "21233113", "41233111", "22124113", "42124111", "11224114", "31224112", "12115114", "32115112", "21215113", "41215111", "13151113", "33151111", "22251112", "23142112", "12242113", "32242111", "21342112", "13133113", "33133111", "22233112", "11333113", "31333111", "23124112", "12224113", "32224111", "21324112", "13115113", "33115111", "22215112", "11315113", "31315111", "14151112", "23251111", "24142111", "13242112", "22342111", "14133112", "23233111", "12333112", "21433111", "24124111", "13224112", "22324111", "11424112", "14115112", "23215111", "12315112", "21415111", "15151111", "14242111", "15133111", "13333111", "14224111", "12424111", "15115111", "13315111", "11515111", "11161114", "31161112", "21152113", "41152111", "11143114", "31143112", "21134113", "41134111", "11125114", "31125112", "21116113", "41116111", "12161113", "32161111", "22152112", "11252113", "31252111", "12143113", "32143111", "21243112", "22134112", "11234113", "31234111", "12125113", "32125111", "21225112", "22116112", "11216113", "31216111", "13161112", "23152111", "12252112", "13143112", "22243111", "11343112", "23134111", "12234112", "21334111", "13125112", "22225111", "11325112", "23116111", "12216112", "21316111", "14161111", "13252111", "14143111", "12343111", "13234111", "11434111", "14125111", "12325111", "13216111", "11416111", "31111216", "51111214", "31211125", "51211123", "32111215", "52111213", "21211216", "41211214", "61211212", "12211126", "32211124", "52211122", "21311125", "41311123", "61311121", "13111216", "33111214", "22211215", "42211213", "11311216", "31311214", "51311212", "13211125", "33211123", "22311124", "42311122", "11411125", "31411123", "51411121", "14111215", "34111213", "23211214", "43211212", "12311215", "32311213", "52311211", "21411214", "41411212", "14211124", "34211122", "23311123", "43311121", "12411124", "32411122", "21511123", "41511121", "15111214", "24211213", "13311214", "33311212", "22411213", "42411211", "11511214", "31511212", "15211123", "24311122", "13411123", "33411121", "22511122", "11611123", "31611121", "16111213", "25211212", "14311213", "34311211", "23411212", "12511213", "32511211", "21611212", "21121126", "41121124", "61121122", "31112125", "51112123", "31121215", "51121213", "21112216", "41112214", "61112212", "22121125", "42121123", "11221126", "31221124", "51221122", "12112126", "32112124", "52112122", "12121216", "32121214", "52121212", "21221215", "41221213", "61221211", "22112215", "42112213", "11212216", "31212214", "51212212", "23121124", "43121122", "12221125", "32221123", "52221121", "21321124", "41321122", "13112125", "33112123", "13121215", "33121213", "11312125", "22221214", "42221212", "11321215", "31321213", "51321211", "23112214", "43112212", "12212215", "32212213", "52212211", "21312214", "41312212", "24121123", "13221124", "33221122", "22321123", "42321121", "11421124", "31421122", "14112124", "34112122", "14121214", "34121212", "12312124", "23221213", "43221211", "12321214", "32321212", "21421213", "41421211", "24112213", "13212214", "33212212", "22312213", "42312211", "11412214", "31412212", "25121122", "14221123", "34221121", "23321122", "12421123", "32421121", "21521122", "15112123", "15121213", "13312123", "24221212", "13321213", "33321211", "11512123", "22421212", "11521213", "31521211", "25112212", "14212213", "34212211", "23312212", "12412213", "32412211", "21512212", "15221122", "24321121", "13421122", "22521121", "16112122", "16121212", "14312122", "25221211", "14321212", "12512122", "23421211", "12521212", "15212212", "24312211", "13412212", "22512211", "11612212", "21131125", "41131123", "61131121", "11122126", "31122124", "51122122", "11131216", "31131214", "51131212", "21113125", "41113123", "61113121", "21122215", "41122213", "61122211", "11113216", "31113214", "51113212", "22131124", "42131122", "11231125", "31231123", "51231121", "12122125", "32122123", "52122121", "12131215", "32131213", "52131211", "21231214", "41231212", "22113124", "42113122", "11213125", "22122214", "42122212", "11222215", "31222213", "51222211", "12113215", "32113213", "52113211", "21213214", "41213212", "23131123", "43131121", "12231124", "32231122", "21331123", "41331121", "13122124", "33122122", "13131214", "33131212", "11322124", "22231213", "42231211", "11331214", "31331212", "23113123", "43113121", "12213124", "23122213", "43122211", "12222214", "32222212", "21322213", "41322211", "13113214", "33113212", "22213213", "42213211", "11313214", "31313212", "24131122", "13231123", "33231121", "22331122", "11431123", "31431121", "14122123", "34122121", "14131213", "34131211", "12322123", "23231212", "12331213", "32331211", "21431212", "24113122", "13213123", "24122212", "13222213", "33222211", "11413123", "22322212", "11422213", "31422211", "14113213", "34113211", "23213212", "12313213", "32313211", "21413212", "25131121", "14231122", "23331121", "12431122", "15122122", "15131212", "13322122", "24231211", "13331212", "11522122", "22431211", "25113121", "14213122", "25122211", "14222212", "12413122", "23322211", "12422212", "21522211", "15113212", "24213211", "13313212", "22413211", "11513212", "15231121", "13431121", "16122121", "16131211", "14322121", "14331211", "12522121", "15213121", "15222211", "13413121", "13422211", "11613121", "16113211", "14313211", "12513211", "21141124", "41141122", "11132125", "31132123", "51132121", "11141215", "31141213", "51141211", "21123124", "41123122", "21132214", "41132212", "11114125", "31114123", "51114121", "11123215", "31123213", "51123211", "21114214", "41114212", "22141123", "42141121", "11241124", "31241122", "12132124", "32132122", "12141214", "32141212", "21241213", "41241211", "22123123", "42123121", "11223124", "22132213", "42132211", "11232214", "31232212", "12114124", "32114122", "12123214", "32123212", "21223213", "41223211", "22114213", "42114211", "11214214", "31214212", "23141122", "12241123", "32241121", "21341122", "13132123", "33132121", "13141213", "33141211", "11332123", "22241212", "11341213", "31341211", "23123122", "12223123", "23132212", "12232213", "32232211", "21332212", "13114123", "33114121", "13123213", "33123211", "11314123", "22223212", "11323213", "31323211", "23114212", "12214213", "32214211", "21314212", "24141121", "13241122", "22341121", "14132122", "14141212", "12332122", "23241211", "12341212", "24123121", "13223122", "24132211", "13232212", "11423122", "22332211", "11432212", "14114122", "14123212", "12314122", "23223211", "12323212", "21423211", "24114211", "13214212", "22314211", "11414212", "14241121", "15132121", "15141211", "13332121", "13341211", "14223121", "14232211", "12423121", "12432211", "15114121", "15123211", "13314121", "13323211", "11514121", "11523211", "14214211", "12414211", "21151123", "41151121", "11142124", "31142122", "11151214", "31151212", "21133123", "41133121", "21142213", "41142211", "11124124", "31124122", "11133214", "31133212", "21115123", "41115121", "21124213", "41124211", "11115214", "31115212", "22151122", "11251123", "31251121", "12142123", "32142121", "12151213", "32151211", "21251212", "22133122", "11233123", "22142212", "11242213", "31242211", "12124123", "32124121", "12133213", "32133211", "21233212", "22115122", "11215123", "22124212", "11224213", "31224211", "12115213", "32115211", "21215212", "23151121", "12251122", "13142122", "13151212", "11342122", "22251211", "23133121", "12233122", "23142211", "12242212", "21342211", "13124122", "13133212", "11324122", "22233211", "11333212", "23115121", "12215122", "23124211", "12224212", "21324211", "13115212", "22215211", "11315212", "13251121", "14142121", "14151211", "12342121", "13233121", "13242211", "11433121", "14124121", "14133211", "12324121", "12333211", "13215121", "13224211", "11415121", "11424211", "14115211", "12315211", "21161122", "11152123", "31152121", "11161213", "31161211", "21143122", "21152212", "11134123", "31134121", "11143213", "31143211", "21125122", "21134212", "11116123", "31116121", "11125213", "31125211", "22161121", "12152122", "12161212", "22143121", "11243122", "22152211", "11252212", "12134122", "12143212", "21243211", "22125121", "11225122", "22134211", "11234212", "12116122", "12125212", "21225211", "13152121", "13161211", "12243121", "12252211", "13134121", "13143211", "11334121", "11343211", "12225121", "12234211", "13116121", "13125211", "11316121", "11325211", "21111226", "41111224", "61111222", "31111315", "51111313", "21211135", "41211133", "61211131", "22111225", "42111223", "11211226", "31211224", "51211222", "12111316", "32111314", "52111312", "21211315", "41211313", "61211311", "22211134", "42211132", "11311135", "31311133", "51311131", "23111224", "43111222", "12211225", "32211223", "52211221", "21311224", "41311222", "13111315", "33111313", "22211314", "42211312", "11311315", "31311313", "51311311", "23211133", "43211131", "12311134", "32311132", "21411133", "41411131", "24111223", "13211224", "33211222", "22311223", "42311221", "11411224", "31411222", "14111314", "34111312", "23211313", "43211311", "12311314", "32311312", "21411313", "41411311", "24211132", "13311133", "33311131", "22411132", "11511133", "31511131", "25111222", "14211223", "34211221", "23311222", "12411223", "32411221", "21511222", "15111313", "24211312", "13311313", "33311311", "22411312", "11511313", "31511311", "25211131", "14311132", "23411131", "12511132", "21611131", "15211222", "24311221", "13411222", "22511221", "11611222", "16111312", "25211311", "14311312", "23411311", "12511312", "21611311", "31121134", "51121132", "21112135", "41112133", "61112131", "21121225", "41121223", "61121221", "11112226", "31112224", "51112222", "11121316", "31121314", "51121312", "21112315", "41112313", "61112311", "12121135", "32121133", "52121131", "21221134", "41221132", "22112134", "42112132", "11212135", "22121224", "42121222", "11221225", "31221223", "51221221", "12112225", "32112223", "52112221", "12121315", "32121313", "52121311", "21221314", "41221312", "22112314", "42112312", "11212315", "31212313", "51212311", "13121134", "33121132", "22221133", "42221131", "11321134", "31321132", "23112133", "43112131", "12212134", "23121223", "43121221", "12221224", "32221222", "21321223", "41321221", "13112224", "33112222", "13121314", "33121312", "11312224", "22221313", "42221311", "11321314", "31321312", "23112313", "43112311", "12212314", "32212312", "21312313", "41312311", "14121133", "34121131", "23221132", "12321133", "32321131", "21421132", "24112132", "13212133", "24121222", "13221223", "33221221", "11412133", "22321222", "11421223", "31421221", "14112223", "34112221", "14121313", "34121311", "12312223", "23221312", "12321313", "32321311", "21421312", "24112312", "13212313", "33212311", "22312312", "11412313", "31412311", "15121132", "24221131", "13321132", "22421131"]), $a(["22121116", "42121114", "31221115", "51221113", "32112115", "52112113", "21212116", "41212114", "61212112", "23121115", "43121113", "12221116", "32221114", "52221112", "21321115", "41321113", "61321111", "13112116", "33112114", "22212115", "42212113", "11312116", "31312114", "51312112", "24121114", "13221115", "33221113", "22321114", "42321112", "11421115", "31421113", "51421111", "14112115", "34112113", "23212114", "43212112", "12312115", "32312113", "52312111", "21412114", "41412112", "25121113", "14221114", "34221112", "23321113", "43321111", "12421114", "32421112", "21521113", "41521111", "15112114", "24212113", "13312114", "33312112", "22412113", "42412111", "11512114", "31512112", "15221113", "24321112", "13421113", "33421111", "22521112", "16112113", "25212112", "14312113", "34312111", "23412112", "12512113", "32512111", "21612112", "21131116", "41131114", "61131112", "31122115", "51122113", "21113116", "41113114", "61113112", "22131115", "42131113", "11231116", "31231114", "51231112", "12122116", "32122114", "52122112", "21222115", "41222113", "61222111", "22113115", "42113113", "11213116", "31213114", "51213112", "23131114", "43131112", "12231115", "32231113", "52231111", "21331114", "41331112", "13122115", "33122113", "22222114", "42222112", "11322115", "31322113", "51322111", "23113114", "43113112", "12213115", "32213113", "52213111", "21313114", "41313112", "24131113", "13231114", "33231112", "22331113", "42331111", "11431114", "31431112", "14122114", "34122112", "23222113", "43222111", "12322114", "32322112", "21422113", "41422111", "24113113", "13213114", "33213112", "22313113", "42313111", "11413114", "31413112", "25131112", "14231113", "34231111", "23331112", "12431113", "32431111", "15122113", "24222112", "13322113", "33322111", "22422112", "11522113", "31522111", "25113112", "14213113", "34213111", "23313112", "12413113", "32413111", "21513112", "15231112", "24331111", "13431112", "16122112", "25222111", "14322112", "23422111", "12522112", "15213112", "24313111", "13413112", "22513111", "11613112", "21141115", "41141113", "61141111", "11132116", "31132114", "51132112", "21123115", "41123113", "61123111", "11114116", "31114114", "51114112", "22141114", "42141112", "11241115", "31241113", "51241111", "12132115", "32132113", "52132111", "21232114", "41232112", "22123114", "42123112", "11223115", "31223113", "51223111", "12114115", "32114113", "52114111", "21214114", "41214112", "23141113", "43141111", "12241114", "32241112", "21341113", "41341111", "13132114", "33132112", "22232113", "42232111", "11332114", "31332112", "23123113", "43123111", "12223114", "32223112", "21323113", "41323111", "13114114", "33114112", "22214113", "42214111", "11314114", "31314112", "24141112", "13241113", "33241111", "22341112", "14132113", "34132111", "23232112", "12332113", "32332111", "21432112", "24123112", "13223113", "33223111", "22323112", "11423113", "31423111", "14114113", "34114111", "23214112", "12314113", "32314111", "21414112", "25141111", "14241112", "23341111", "15132112", "24232111", "13332112", "22432111", "25123111", "14223112", "23323111", "12423112", "21523111", "15114112", "24214111", "13314112", "22414111", "11514112", "15241111", "16132111", "14332111", "15223111", "13423111", "16114111", "14314111", "12514111", "21151114", "41151112", "11142115", "31142113", "51142111", "21133114", "41133112", "11124115", "31124113", "51124111", "21115114", "41115112", "22151113", "42151111", "11251114", "31251112", "12142114", "32142112", "21242113", "41242111", "22133113", "42133111", "11233114", "31233112", "12124114", "32124112", "21224113", "41224111", "22115113", "42115111", "11215114", "31215112", "23151112", "12251113", "32251111", "13142113", "33142111", "22242112", "11342113", "31342111", "23133112", "12233113", "32233111", "21333112", "13124113", "33124111", "22224112", "11324113", "31324111", "23115112", "12215113", "32215111", "21315112", "24151111", "13251112", "14142112", "23242111", "12342112", "24133111", "13233112", "22333111", "11433112", "14124112", "23224111", "12324112", "21424111", "24115111", "13215112", "22315111", "11415112", "14251111", "15142111", "13342111", "14233111", "12433111", "15124111", "13324111", "11524111", "14215111", "12415111", "21161113", "41161111", "11152114", "31152112", "21143113", "41143111", "11134114", "31134112", "21125113", "41125111", "11116114", "31116112", "22161112", "12152113", "32152111", "21252112", "22143112", "11243113", "31243111", "12134113", "32134111", "21234112", "22125112", "11225113", "31225111", "12116113", "32116111", "21216112", "23161111", "13152112", "22252111", "23143111", "12243112", "21343111", "13134112", "22234111", "11334112", "23125111", "12225112", "21325111", "13116112", "22216111", "11316112", "14152111", "13243111", "14134111", "12334111", "13225111", "11425111", "14116111", "12316111", "41111215", "61111213", "21211126", "41211124", "61211122", "22111216", "42111214", "31211215", "51211213", "22211125", "42211123", "11311126", "31311124", "51311122", "23111215", "43111213", "12211216", "32211214", "52211212", "21311215", "41311213", "61311211", "23211124", "43211122", "12311125", "32311123", "52311121", "21411124", "41411122", "24111214", "13211215", "33211213", "22311214", "42311212", "11411215", "31411213", "51411211", "24211123", "13311124", "33311122", "22411123", "42411121", "11511124", "31511122", "25111213", "14211214", "34211212", "23311213", "43311211", "12411214", "32411212", "21511213", "41511211", "25211122", "14311123", "34311121", "23411122", "12511123", "32511121", "21611122", "15211213", "24311212", "13411213", "33411211", "22511212", "11611213", "31611211", "31121125", "51121123", "21112126", "41112124", "61112122", "21121216", "41121214", "61121212", "31112215", "51112213", "12121126", "32121124", "52121122", "21221125", "41221123", "61221121", "22112125", "42112123", "11212126", "22121215", "42121213", "11221216", "31221214", "51221212", "12112216", "32112214", "52112212", "21212215", "41212213", "61212211", "13121125", "33121123", "22221124", "42221122", "11321125", "31321123", "51321121", "23112124", "43112122", "12212125", "23121214", "43121212", "12221215", "32221213", "52221211", "21321214", "41321212", "13112215", "33112213", "22212214", "42212212", "11312215", "31312213", "51312211", "14121124", "34121122", "23221123", "43221121", "12321124", "32321122", "21421123", "41421121", "24112123", "13212124", "24121213", "13221214", "33221212", "11412124", "22321213", "42321211", "11421214", "31421212", "14112214", "34112212", "23212213", "43212211", "12312214", "32312212", "21412213", "41412211", "15121123", "24221122", "13321123", "33321121", "22421122", "11521123", "31521121", "25112122", "14212123", "25121212", "14221213", "34221211", "12412123", "23321212", "12421213", "32421211", "21521212", "15112213", "24212212", "13312213", "33312211", "22412212", "11512213", "31512211", "16121122", "25221121", "14321122", "23421121", "12521122", "15212122", "15221212", "13412122", "24321211", "13421212", "11612122", "22521211", "16112212", "25212211", "14312212", "23412211", "12512212", "21612211", "11131126", "31131124", "51131122", "21122125", "41122123", "61122121", "21131215", "41131213", "61131211", "11113126", "31113124", "51113122", "11122216", "31122214", "51122212", "21113215", "41113213", "61113211", "12131125", "32131123", "52131121", "21231124", "41231122", "22122124", "42122122", "11222125", "22131214", "42131212", "11231215", "31231213", "51231211", "12113125", "32113123", "52113121", "12122215", "32122213", "52122211", "21222214", "41222212", "22113214", "42113212", "11213215", "31213213", "51213211", "13131124", "33131122", "22231123", "42231121", "11331124", "31331122", "23122123", "43122121", "12222124", "23131213", "43131211", "12231214", "32231212", "21331213", "41331211", "13113124", "33113122", "13122214", "33122212", "11313124", "22222213", "42222211", "11322214", "31322212", "23113213", "43113211", "12213214", "32213212", "21313213", "41313211", "14131123", "34131121", "23231122", "12331123", "32331121", "21431122", "24122122", "13222123", "24131212", "13231213", "33231211", "11422123", "22331212", "11431213", "31431211", "14113123", "34113121", "14122213", "34122211", "12313123", "23222212", "12322213", "32322211", "21422212", "24113212", "13213213", "33213211", "22313212", "11413213", "31413211", "15131122", "24231121", "13331122", "22431121", "25122121", "14222122", "25131211", "14231212", "12422122", "23331211", "12431212", "15113122", "15122212", "13313122", "24222211", "13322212", "11513122", "22422211", "11522212", "25113211", "14213212", "23313211", "12413212", "21513211", "16131121", "14331121", "15222121", "15231211", "13422121", "13431211", "16113121", "16122211", "14313121", "14322211", "12513121", "12522211", "15213211", "13413211", "11613211", "11141125", "31141123", "51141121", "21132124", "41132122", "21141214", "41141212", "11123125", "31123123", "51123121", "11132215", "31132213", "51132211", "21114124", "41114122", "21123214", "41123212", "11114215", "31114213", "51114211", "12141124", "32141122", "21241123", "41241121", "22132123", "42132121", "11232124", "22141213", "42141211", "11241214", "31241212", "12123124", "32123122", "12132214", "32132212", "21232213", "41232211", "22114123", "42114121", "11214124", "22123213", "42123211", "11223214", "31223212", "12114214", "32114212", "21214213", "41214211", "13141123", "33141121", "22241122", "11341123", "31341121", "23132122", "12232123", "23141212", "12241213", "32241211", "21341212", "13123123", "33123121", "13132213", "33132211", "11323123", "22232212", "11332213", "31332211", "23114122", "12214123", "23123212", "12223213", "32223211", "21323212", "13114213", "33114211", "22214212", "11314213", "31314211", "14141122", "23241121", "12341122", "24132121", "13232122", "24141211", "13241212", "11432122", "22341211", "14123122", "14132212", "12323122", "23232211", "12332212", "21432211", "24114121", "13214122", "24123211", "13223212", "11414122", "22323211", "11423212", "14114212", "23214211", "12314212", "21414211", "15141121", "13341121", "14232121", "14241211", "12432121", "15123121", "15132211", "13323121", "13332211", "11523121", "14214121", "14223211", "12414121", "12423211", "15114211", "13314211", "11514211", "11151124", "31151122", "21142123", "41142121", "21151213", "41151211", "11133124", "31133122", "11142214", "31142212", "21124123", "41124121", "21133213", "41133211", "11115124", "31115122", "11124214", "31124212", "21115213", "41115211", "12151123", "32151121", "21251122", "22142122", "11242123", "22151212", "11251213", "31251211", "12133123", "32133121", "12142213", "32142211", "21242212", "22124122", "11224123", "22133212", "11233213", "31233211", "12115123", "32115121", "12124213", "32124211", "21224212", "22115212", "11215213", "31215211", "13151122", "22251121", "23142121", "12242122", "23151211", "12251212", "13133122", "13142212", "11333122", "22242211", "11342212", "23124121", "12224122", "23133211", "12233212", "21333211", "13115122", "13124212", "11315122", "22224211", "11324212", "23115211", "12215212", "21315211", "14151121", "13242121", "13251211", "14133121", "14142211", "12333121", "12342211", "13224121", "13233211", "11424121", "11433211", "14115121", "14124211", "12315121", "12324211", "13215211", "11415211", "11161123", "31161121", "21152122", "21161212", "11143123", "31143121", "11152213", "31152211", "21134122", "21143212", "11125123", "31125121", "11134213", "31134211", "21116122", "21125212", "12161122", "22152121", "11252122", "22161211", "12143122", "12152212", "21252211", "22134121", "11234122", "22143211", "11243212", "12125122", "12134212", "21234211", "22116121", "11216122", "22125211", "11225212", "13161121", "12252121", "13143121", "13152211", "11343121", "12234121", "12243211", "13125121", "13134211", "11325121", "11334211", "12216121", "12225211", "31111225", "51111223", "21111316", "41111314", "61111312", "31211134", "51211132", "12111226", "32111224", "52111222", "21211225", "41211223", "61211221", "22111315", "42111313", "11211316", "31211314", "51211312", "12211135", "32211133", "52211131", "21311134", "41311132", "13111225", "33111223", "22211224", "42211222", "11311225", "31311223", "51311221", "23111314", "43111312", "12211315", "32211313", "52211311", "21311314", "41311312", "13211134", "33211132", "22311133", "42311131", "11411134", "31411132", "14111224", "34111222", "23211223", "43211221", "12311224", "32311222", "21411223", "41411221", "24111313", "13211314", "33211312", "22311313", "42311311", "11411314", "31411312", "14211133", "34211131", "23311132", "12411133", "32411131", "21511132", "15111223", "24211222", "13311223", "33311221", "22411222", "11511223", "31511221", "25111312", "14211313", "34211311", "23311312", "12411313", "32411311", "21511312", "15211132", "24311131", "13411132", "22511131", "11611132", "16111222", "25211221", "14311222", "23411221", "12511222", "21611221", "15211312", "24311311", "13411312", "22511311", "11611312", "21121135", "41121133", "61121131", "11112136", "31112134", "51112132", "11121226", "31121224", "51121222", "21112225", "41112223", "61112221", "21121315", "41121313", "61121311", "11112316", "31112314", "51112312", "22121134", "42121132", "11221135", "31221133", "51221131", "12112135", "32112133", "52112131", "12121225", "32121223", "52121221", "21221224", "41221222", "22112224", "42112222", "11212225", "22121314", "42121312", "11221315", "31221313", "51221311", "12112315", "32112313", "52112311", "21212314", "41212312", "23121133", "43121131", "12221134", "32221132", "21321133", "41321131", "13112134", "33112132", "13121224", "33121222", "11312134", "22221223", "42221221", "11321224", "31321222", "23112223", "43112221", "12212224", "23121313", "43121311", "12221314", "32221312", "21321313", "41321311", "13112314", "33112312", "22212313", "42212311", "11312314", "31312312", "24121132", "13221133", "33221131", "22321132", "11421133", "31421131", "14112133", "34112131", "14121223", "34121221", "12312133", "23221222", "12321223", "32321221", "21421222", "24112222", "13212223", "24121312", "13221313", "33221311", "11412223", "22321312", "11421313", "31421311", "14112313", "34112311", "23212312", "12312313", "32312311", "21412312", "25121131", "14221132", "23321131", "12421132", "21521131", "15112132", "15121222", "13312132", "24221221", "13321222", "11512132", "22421221", "11521222", "25112221", "14212222", "25121311", "14221312", "12412222", "23321311", "12421312", "21521311", "15112312", "24212311", "13312312", "22412311", "11512312", "15221131", "13421131", "16112131", "16121221", "14312131", "14321221", "12512131", "12521221", "15212221", "15221311", "13412221", "13421311", "11612221", "16112311", "14312311", "12512311", "21131134", "41131132", "11122135", "31122133", "51122131", "11131225", "31131223", "51131221", "21113134", "41113132", "21122224", "41122222", "21131314", "41131312", "11113225", "31113223", "51113221", "11122315", "31122313", "51122311", "21113314", "41113312", "22131133", "42131131", "11231134", "31231132", "12122134", "32122132", "12131224", "32131222", "21231223", "41231221", "22113133", "42113131", "11213134", "22122223", "42122221", "11222224", "22131313", "42131311", "11231314", "31231312", "12113224", "32113222", "12122314", "32122312", "21222313", "41222311", "22113313", "42113311", "11213314", "31213312", "23131132", "12231133", "32231131", "21331132", "13122133", "33122131", "13131223", "33131221", "11322133", "22231222", "11331223", "31331221", "23113132", "12213133", "23122222", "12222223", "23131312", "12231313", "32231311", "21331312", "13113223", "33113221", "13122313", "33122311", "11313223", "22222312", "11322313", "31322311", "23113312", "12213313", "32213311", "21313312", "24131131", "13231132", "22331131", "11431132", "14122132", "14131222", "12322132", "23231221", "12331222", "21431221", "24113131", "13213132", "24122221", "13222222", "24131311", "11413132", "13231312", "11422222", "22331311", "11431312", "14113222", "14122312", "12313222", "23222311", "12322312", "21422311", "24113311", "13213312", "22313311", "11413312", "14231131", "12431131", "15122131", "15131221", "13322131", "13331221", "11522131", "14213131", "14222221", "12413131", "14231311", "12422221", "12431311", "15113221", "15122311", "13313221", "13322311", "11513221", "11522311", "14213311", "12413311", "21141133", "41141131", "11132134", "31132132", "11141224", "31141222", "21123133", "41123131", "21132223", "41132221", "21141313", "41141311", "11114134", "31114132", "11123224", "31123222", "11132314", "31132312", "21114223", "41114221", "21123313", "41123311", "11114314", "31114312", "22141132", "11241133", "31241131", "12132133", "32132131", "12141223", "32141221", "21241222", "22123132", "11223133", "22132222", "11232223", "22141312", "11241313", "31241311", "12114133", "32114131", "12123223", "32123221", "12132313", "32132311", "21232312", "22114222", "11214223", "22123312", "11223313", "31223311", "12114313", "32114311", "21214312", "23141131", "12241132", "21341131", "13132132", "13141222", "11332132", "22241221", "11341222", "23123131", "12223132", "23132221", "12232222", "23141311", "12241312", "21341311", "13114132", "13123222", "11314132", "13132312", "11323222", "22232311", "11332312", "23114221", "12214222", "23123311", "12223312", "21323311", "13114312", "22214311", "11314312", "13241131", "14132131", "14141221", "12332131", "12341221", "13223131", "13232221", "11423131", "13241311", "11432221", "14114131", "14123221", "12314131", "14132311", "12323221", "12332311", "13214221", "13223311", "11414221", "11423311", "14114311", "12314311", "21151132", "11142133", "31142131", "11151223", "31151221", "21133132", "21142222", "21151312", "11124133", "31124131", "11133223", "31133221", "11142313", "31142311", "21115132", "21124222", "21133312", "11115223", "31115221", "11124313", "31124311", "22151131", "11251132", "12142132", "12151222", "21251221", "22133131", "11233132", "22142221", "11242222", "22151311", "11251312", "12124132", "12133222", "12142312", "21242311", "22115131", "11215132", "22124221", "11224222", "22133311", "11233312", "12115222", "12124312", "21224311", "12251131", "13142131", "13151221", "11342131", "12233131", "12242221", "12251311", "13124131", "13133221", "11324131", "13142311", "11333221", "11342311", "12215131", "12224221", "12233311", "13115221", "13124311", "11315221", "11324311", "21161131", "11152132", "11161222", "21143131", "21152221", "21161311", "11134132", "11143222", "11152312", "21125131", "21134221", "21143311", "11116132", "11125222", "11134312", "12152131", "12161221", "11243131", "11252221", "12134131", "12143221", "12152311", "11225131", "11234221", "11243311", "12116131", "12125221", "12134311", "21111235", "41111233", "61111231", "11111326", "31111324", "51111322", "21111415", "41111413", "61111411", "21211144", "41211142", "22111234", "42111232", "11211235", "31211233", "51211231", "12111325", "32111323", "52111321", "21211324", "41211322", "22111414", "42111412", "11211415", "31211413", "51211411", "22211143", "42211141", "11311144", "31311142", "23111233", "43111231", "12211234", "32211232", "21311233", "41311231", "13111324", "33111322", "22211323", "42211321", "11311324", "31311322", "23111413", "43111411", "12211414", "32211412", "21311413", "41311411", "23211142", "12311143", "32311141", "21411142", "24111232", "13211233", "33211231", "22311232", "11411233", "31411231", "14111323", "34111321", "23211322", "12311323", "32311321", "21411322", "24111412", "13211413", "33211411", "22311412", "11411413", "31411411", "24211141", "13311142", "22411141", "11511142", "25111231", "14211232", "23311231", "12411232", "21511231", "15111322", "24211321", "13311322", "22411321", "11511322", "25111411", "14211412", "23311411", "12411412", "21511411", "14311141", "12511141", "15211231", "13411231", "11611231", "16111321", "14311321", "12511321", "15211411", "13411411", "11611411", "31121143", "51121141", "21112144", "41112142", "21121234", "41121232", "11112235", "31112233", "51112231", "11121325", "31121323", "51121321", "21112324", "41112322", "21121414", "41121412", "11112415", "31112413", "51112411", "12121144", "32121142", "21221143", "41221141", "22112143", "42112141", "11212144", "22121233", "42121231", "11221234", "31221232", "12112234", "32112232", "12121324", "32121322", "21221323", "41221321", "22112323", "42112321", "11212324", "22121413", "42121411", "11221414", "31221412", "12112414", "32112412", "21212413", "41212411", "13121143", "33121141", "22221142", "11321143", "31321141", "23112142", "12212143", "23121232", "12221233", "32221231", "21321232", "13112233", "33112231", "13121323", "33121321", "11312233", "22221322", "11321323", "31321321", "23112322", "12212323", "23121412", "12221413", "32221411", "21321412", "13112413", "33112411", "22212412", "11312413", "31312411", "14121142", "23221141", "12321142", "21421141", "24112141", "13212142", "24121231", "13221232", "11412142", "22321231", "11421232", "14112232", "14121322", "12312232", "23221321", "12321322", "21421321", "24112321", "13212322", "24121411", "13221412", "11412322", "22321411", "11421412", "14112412", "23212411", "12312412", "21412411", "15121141", "13321141", "11521141", "14212141", "14221231", "12412141", "12421231", "15112231", "15121321", "13312231", "13321321", "11512231", "11521321", "14212321", "14221411", "12412321", "12421411", "15112411", "13312411", "11512411", "11131144", "31131142", "21122143", "41122141", "21131233", "41131231", "11113144", "31113142", "11122234", "31122232", "11131324", "31131322", "21113233", "41113231", "21122323", "41122321", "21131413", "41131411", "11113324", "31113322", "11122414", "31122412", "21113413", "41113411", "12131143", "32131141", "21231142", "22122142", "11222143", "22131232", "11231233", "31231231", "12113143", "32113141", "12122233", "32122231", "12131323", "32131321", "21231322", "22113232", "11213233", "22122322", "11222323", "22131412", "11231413", "31231411", "12113323", "32113321", "12122413", "32122411", "21222412", "22113412", "11213413", "31213411", "13131142", "22231141", "11331142", "23122141", "12222142", "23131231", "12231232", "21331231", "13113142", "13122232", "11313142", "13131322", "11322232", "22231321", "11331322", "23113231", "12213232", "23122321", "12222322", "23131411", "12231412", "21331411", "13113322", "13122412", "11313322", "22222411", "11322412", "23113411", "12213412", "21313411", "14131141", "12331141", "13222141", "13231231", "11422141", "11431231", "14113141", "14122231", "12313141", "14131321", "12322231", "12331321", "13213231", "13222321", "11413231", "13231411", "11422321", "11431411", "14113321", "14122411", "12313321", "12322411", "13213411", "11413411", "11141143", "31141141", "21132142", "21141232", "11123143", "31123141", "11132233", "31132231", "11141323", "31141321", "21114142", "21123232", "21132322", "21141412", "11114233", "31114231", "11123323", "31123321", "11132413", "31132411", "21114322", "21123412", "12141142", "21241141", "22132141", "11232142", "22141231", "11241232", "12123142", "12132232", "12141322", "21241321", "22114141", "11214142", "22123231", "11223232", "22132321", "11232322", "22141411", "11241412", "12114232", "12123322", "12132412", "21232411", "22114321", "11214322", "22123411", "11223412", "13141141", "11341141", "12232141", "12241231", "13123141", "13132231", "11323141", "13141321", "11332231", "11341321", "12214141", "12223231", "12232321", "12241411", "13114231", "13123321", "11314231", "13132411", "11323321", "11332411", "12214321", "12223411", "11151142", "21142141", "21151231", "11133142", "11142232", "11151322", "21124141", "21133231", "21142321", "21151411", "11115142", "11124232", "11133322", "11142412", "21115231", "21124321", "21133411", "12151141", "11242141", "11251231", "12133141", "12142231", "12151321", "11224141", "11233231", "11242321", "11251411", "12115141", "12124231", "12133321", "12142411", "11215231", "11224321", "11233411", "11161141", "11143141", "11152231", "11161321", "11125141", "11134231", "11143321", "11152411", "11111245", "31111243", "51111241", "21111334", "41111332", "11111425", "31111423", "51111421", "21111514", "41111512", "31211152", "12111244", "32111242", "21211243", "41211241", "22111333", "42111331", "11211334", "31211332", "12111424", "32111422", "21211423", "41211421", "22111513", "42111511", "11211514", "31211512", "12211153", "32211151", "21311152", "13111243", "33111241", "22211242", "11311243", "31311241", "23111332", "12211333", "32211331", "21311332", "13111423", "33111421", "22211422", "11311423", "31311421", "23111512", "12211513", "32211511", "21311512", "13211152", "22311151", "11411152", "14111242", "23211241", "12311242", "21411241", "24111331", "13211332", "22311331", "11411332", "14111422", "23211421", "12311422", "21411421", "24111511", "13211512", "22311511", "11411512", "14211151", "12411151", "15111241", "13311241", "11511241", "14211331", "12411331", "15111421", "13311421", "11511421", "14211511", "12411511", "21121153", "41121151", "11112154", "31112152", "11121244", "31121242", "21112243", "41112241", "21121333", "41121331", "11112334", "31112332", "11121424", "31121422", "21112423", "41112421", "21121513", "41121511", "11112514", "31112512", "22121152", "11221153", "31221151", "12112153", "32112151", "12121243", "32121241", "21221242", "22112242", "11212243", "22121332", "11221333", "31221331", "12112333", "32112331", "12121423", "32121421", "21221422", "22112422", "11212423", "22121512", "11221513", "31221511", "12112513", "32112511", "21212512", "23121151", "12221152", "21321151", "13112152", "13121242", "11312152", "22221241", "11321242", "23112241", "12212242", "23121331", "12221332", "21321331", "13112332", "13121422", "11312332", "22221421", "11321422", "23112421", "12212422", "23121511", "12221512", "21321511", "13112512", "22212511", "11312512", "13221151", "11421151", "14112151", "14121241", "12312151", "12321241", "13212241", "13221331", "11412241", "11421331", "14112331", "14121421", "12312331", "12321421", "13212421", "13221511", "11412421", "11421511", "14112511", "12312511", "21131152", "11122153", "31122151", "11131243", "31131241", "21113152", "21122242", "21131332", "11113243", "31113241", "11122333", "31122331", "11131423", "31131421", "21113332", "21122422", "21131512", "11113423", "31113421", "11122513", "31122511", "22131151", "11231152", "12122152", "12131242", "21231241", "22113151", "11213152", "22122241", "11222242", "22131331", "11231332", "12113242", "12122332", "12131422", "21231421", "22113331", "11213332", "22122421", "11222422", "22131511", "11231512", "12113422", "12122512", "21222511", "12231151", "13122151", "13131241", "11322151", "11331241", "12213151", "12222241", "12231331", "13113241", "13122331", "11313241", "13131421", "11322331", "11331421", "12213331", "12222421", "12231511", "13113421", "13122511", "11313421", "11322511", "21141151", "11132152", "11141242", "21123151", "21132241", "21141331", "11114152", "11123242", "11132332", "11141422", "21114241", "21123331", "21132421", "21141511", "11114332", "11123422", "11132512", "11241151", "12132151", "12141241", "11223151", "11232241", "11241331", "12114151", "12123241", "12132331", "12141421", "11214241", "11223331", "11232421", "11241511", "12114331", "12123421", "12132511", "11142151", "11151241", "11124151", "11133241", "11142331", "11151421", "11115241", "11124331", "11133421", "11142511", "21111253", "41111251", "11111344", "31111342", "21111433", "41111431", "11111524", "31111522", "21111613", "41111611", "21211162", "22111252", "11211253", "31211251", "12111343", "32111341", "21211342", "22111432", "11211433", "31211431", "12111523", "32111521", "21211522", "22111612", "11211613", "31211611", "22211161", "11311162", "23111251", "12211252", "21311251", "13111342", "22211341", "11311342", "23111431", "12211432", "21311431", "13111522", "22211521", "11311522", "23111611", "12211612", "21311611", "12311161", "13211251", "11411251", "14111341", "12311341", "13211431", "11411431", "14111521", "12311521", "13211611", "11411611", "31121161", "21112162", "21121252", "11112253", "31112251", "11121343", "31121341", "21112342", "21121432", "11112433", "31112431", "11121523", "31121521", "21112522", "21121612", "12121162", "21221161", "22112161", "11212162", "22121251", "11221252", "12112252", "12121342", "21221341", "22112341", "11212342", "22121431", "11221432", "12112432", "12121522", "21221521", "22112521", "11212522", "22121611", "11221612", "13121161", "11321161", "12212161", "12221251", "13112251", "13121341", "11312251", "11321341", "12212341", "12221431", "13112431", "13121521", "11312431", "11321521", "12212521", "12221611", "11131162", "21122161", "21131251", "11113162"])]); /*12754*/
			$1.parity = $a(["1001", "0101", "1100", "0011", "1010", "0110", "1111", "0000"]); /*12758*/
			$1.rowbits = $a($1.r); /*12761*/
			for (var _6J = 0, _6I = $1.r - 1; _6J <= _6I; _6J += 1) { /*12781*/
				$1.i = _6J; /*12763*/
				$k[$j++] = "p"; /*12764*/
				if ($1.i != ($1.r - 1)) { /*12764*/
					$k[$j++] = $get($1.parity, $1.i); /*12764*/
				} else { /*12764*/
					$k[$j++] = "0000"; /*12764*/
				} /*12764*/
				var _6P = $k[--$j]; /*12764*/
				$1[$k[--$j]] = _6P; /*12764*/
				$1.ccrow = $geti($1.ccs, $1.i * 8, 8); /*12765*/
				$k[$j++] = Infinity; /*12768*/
				for (var _6U = 0; _6U <= 7; _6U += 2) { /*12767*/
					$aload($geti($1.ccrow, _6U, 2)); /*12767*/
					var _6X = $k[--$j]; /*12767*/
					var _6Y = $k[--$j]; /*12767*/
					$k[$j++] = _6X + (_6Y * 49); /*12767*/
				} /*12767*/
				$1.scrow = $a(); /*12768*/
				$k[$j++] = Infinity; /*12776*/
				$k[$j++] = 10; /*12774*/
				$k[$j++] = 1; /*12774*/
				$k[$j++] = 1; /*12774*/
				for (var _6a = 0; _6a <= 3; _6a += 1) { /*12774*/
					$1.j = _6a; /*12772*/
					$forall($get($get($1.patterns, $get($1.p, $1.j) - 48), $get($1.scrow, $1.j)), function() { /*12773*/
						var _6k = $k[--$j]; /*12773*/
						$k[$j++] = _6k - 48; /*12773*/
					}); /*12773*/
				} /*12773*/
				$k[$j++] = 4; /*12775*/
				$k[$j++] = 1; /*12775*/
				$1.sbs = $a(); /*12776*/
				$k[$j++] = Infinity; /*12777*/
				var _6m = $1.sbs; /*12778*/
				$k[$j++] = 1; /*12778*/
				for (var _6n = 0, _6o = _6m.length; _6n < _6o; _6n++) { /*12778*/
					var _6q = $k[--$j]; /*12778*/
					var _6r = (_6q == 0) ? 1 : 0; /*12778*/
					$k[$j++] = _6q; /*12778*/
					for (var _6s = 0, _6t = $get(_6m, _6n); _6s < _6t; _6s++) { /*12778*/
						$k[$j++] = _6r /*12778*/
					} /*12778*/
				} /*12778*/
				$astore($a($counttomark() - 1)); /*12779*/
				var _6w = $k[--$j]; /*12779*/
				var _6x = $k[--$j]; /*12779*/
				var _6y = $k[--$j]; /*12779*/
				$put($1.rowbits, $1.i, _6w); /*12780*/
			} /*12780*/
			$k[$j++] = Infinity; /*12793*/
			for (var _72 = 0, _73 = 81 * $1.sepheight; _72 < _73; _72++) { /*12785*/
				$k[$j++] = 1; /*12785*/
			} /*12785*/
			for (var _76 = 0, _75 = $1.r - 2; _76 <= _75; _76 += 1) { /*12790*/
				$1.i = _76; /*12787*/
				for (var _78 = 0, _79 = $1.rowheight; _78 < _79; _78++) { /*12788*/
					$aload($get($1.rowbits, $1.i)); /*12788*/
				} /*12788*/
				for (var _7E = 0, _7F = $1.sepheight; _7E < _7F; _7E++) { /*12789*/
					for (var _7G = 0, _7H = 10; _7G < _7H; _7G++) { /*12789*/
						$k[$j++] = 0; /*12789*/
					} /*12789*/
					for (var _7I = 0, _7J = 70; _7I < _7J; _7I++) { /*12789*/
						$k[$j++] = 1; /*12789*/
					} /*12789*/
					$k[$j++] = 0; /*12789*/
				} /*12789*/
			} /*12789*/
			for (var _7L = 0, _7M = $1.rowheight; _7L < _7M; _7L++) { /*12791*/
				$aload($get($1.rowbits, $1.r - 1)); /*12791*/
			} /*12791*/
			for (var _7R = 0, _7S = 81 * $1.sepheight; _7R < _7S; _7R++) { /*12792*/
				$k[$j++] = 1; /*12792*/
			} /*12792*/
			$1.pixs = $a(); /*12793*/
			var _7Y = {
				ren: $0.renmatrix,
				pixs: $1.pixs,
				pixx: 81,
				pixy: ~~($1.pixs.length / 81),
				height: (~~($1.pixs.length / 81)) / 72,
				width: 81 / 72,
				opt: $1.options
			}; /*12803*/
			$k[$j++] = _7Y; /*12806*/
			if (!$1.dontdraw) { /*12806*/
				$0.renmatrix(); /*12806*/
			} /*12806*/
		};
		$0.flattermarken = function() {
			var $1 = {}; /*13093*/
			$1.options = $k[--$j]; /*13095*/
			$1.barcode = $k[--$j]; /*13096*/
			$1.dontdraw = false; /*13098*/
			$1.includetext = false; /*13099*/
			$1.textfont = "Courier"; /*13100*/
			$1.textsize = 10; /*13101*/
			$1.textyoffset = -8.5; /*13102*/
			$1.height = 0.3; /*13103*/
			$forall($1.barcode, function() { /*13110*/
				var _3 = $k[--$j]; /*13107*/
				if ((_3 < 48) || (_3 > 57)) { /*13109*/
					$k[$j++] = "bwipp.flattermarkenBadCharacter"; /*13108*/
					$k[$j++] = "Flattermarken must contain only digits"; /*13108*/
					$0.raiseerror(); /*13108*/
				} /*13108*/
			}); /*13108*/
			$forall($1.options, function() { /*13121*/
				var _5 = $k[--$j]; /*13121*/
				$1[$k[--$j]] = _5; /*13121*/
			}); /*13121*/
			$1.textfont = "" + $1.textfont; /*13123*/
			$1.textsize = +$1.textsize; /*13124*/
			$1.textyoffset = +$1.textyoffset; /*13125*/
			$1.height = +$1.height; /*13126*/
			$forall($1.barcode, function() { /*13133*/
				var _C = $k[--$j]; /*13130*/
				if ((_C < 48) || (_C > 57)) { /*13132*/
					$k[$j++] = "bwipp.flattermarkenBadCharacter"; /*13131*/
					$k[$j++] = "Flattermarken must contain only digits"; /*13131*/
					$0.raiseerror(); /*13131*/
				} /*13131*/
			}); /*13131*/
			$1.encs = $a(["0018", "0117", "0216", "0315", "0414", "0513", "0612", "0711", "0810", "0900"]); /*13139*/
			$1.barchars = "1234567890"; /*13142*/
			$1.barlen = $1.barcode.length; /*13144*/
			$1.sbs = $s($1.barlen * 4); /*13146*/
			$1.txt = $a($1.barlen); /*13147*/
			for (var _L = 0, _K = $1.barlen - 1; _L <= _K; _L += 1) { /*13159*/
				$1.i = _L; /*13150*/
				$search($1.barchars, $geti($1.barcode, $1.i, 1)); /*13152*/
				$j--; /*13153*/
				$1.indx = $k[--$j].length; /*13154*/
				$j -= 2; /*13155*/
				$1.enc = $get($1.encs, $1.indx); /*13156*/
				$puti($1.sbs, $1.i * 4, $1.enc); /*13157*/
				$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), $1.i * 9, $1.textyoffset, $1.textfont, $1.textsize])); /*13158*/
			} /*13158*/
			$k[$j++] = Infinity; /*13168*/
			$k[$j++] = "ren"; /*13165*/
			$k[$j++] = $0.renlinear; /*13165*/
			$k[$j++] = "sbs"; /*13165*/
			$k[$j++] = Infinity; /*13165*/
			var _h = $1.sbs; /*13164*/
			for (var _i = 0, _j = _h.length; _i < _j; _i++) { /*13164*/
				$k[$j++] = $get(_h, _i) - 48; /*13164*/
			} /*13164*/
			var _l = $a(); /*13165*/
			$k[$j++] = _l; /*13166*/
			$k[$j++] = "bhs"; /*13166*/
			$k[$j++] = Infinity; /*13166*/
			for (var _n = 0, _o = ~~(($1.sbs.length + 1) / 2); _n < _o; _n++) { /*13165*/
				$k[$j++] = $1.height; /*13165*/
			} /*13165*/
			var _q = $a(); /*13166*/
			$k[$j++] = _q; /*13167*/
			$k[$j++] = "bbs"; /*13167*/
			$k[$j++] = Infinity; /*13167*/
			for (var _s = 0, _t = ~~(($1.sbs.length + 1) / 2); _s < _t; _s++) { /*13166*/
				$k[$j++] = 0; /*13166*/
			} /*13166*/
			var _u = $a(); /*13167*/
			$k[$j++] = _u; /*13168*/
			$k[$j++] = "txt"; /*13168*/
			$k[$j++] = $1.txt; /*13168*/
			$k[$j++] = "opt"; /*13168*/
			$k[$j++] = $1.options; /*13168*/
			var _x = $d(); /*13168*/
			$k[$j++] = _x; /*13171*/
			if (!$1.dontdraw) { /*13171*/
				$0.renlinear(); /*13171*/
			} /*13171*/
		};
		$0.raw = function() {
			var $1 = {}; /*13198*/
			$1.options = $k[--$j]; /*13200*/
			$1.barcode = $k[--$j]; /*13201*/
			$1.dontdraw = false; /*13203*/
			$1.height = 1; /*13204*/
			$forall($1.options, function() { /*13215*/
				var _3 = $k[--$j]; /*13215*/
				$1[$k[--$j]] = _3; /*13215*/
			}); /*13215*/
			$1.height = +$1.height; /*13217*/
			$forall($1.barcode, function() { /*13224*/
				var _7 = $k[--$j]; /*13221*/
				if ((_7 < 49) || (_7 > 57)) { /*13223*/
					$k[$j++] = "bwipp.rawBadCharacter"; /*13222*/
					$k[$j++] = "Raw must contain only digits 1 to 9"; /*13222*/
					$0.raiseerror(); /*13222*/
				} /*13222*/
			}); /*13222*/
			$k[$j++] = Infinity; /*13232*/
			$k[$j++] = "ren"; /*13230*/
			$k[$j++] = $0.renlinear; /*13230*/
			$k[$j++] = "sbs"; /*13230*/
			$k[$j++] = Infinity; /*13230*/
			$forall($1.barcode, function() { /*13229*/
				var _9 = $k[--$j]; /*13229*/
				$k[$j++] = _9 - 48; /*13229*/
			}); /*13229*/
			var _A = $a(); /*13230*/
			$k[$j++] = _A; /*13231*/
			$k[$j++] = "bhs"; /*13231*/
			$k[$j++] = Infinity; /*13231*/
			for (var _C = 0, _D = ~~(($1.barcode.length + 1) / 2); _C < _D; _C++) { /*13230*/
				$k[$j++] = $1.height; /*13230*/
			} /*13230*/
			var _F = $a(); /*13231*/
			$k[$j++] = _F; /*13232*/
			$k[$j++] = "bbs"; /*13232*/
			$k[$j++] = Infinity; /*13232*/
			for (var _H = 0, _I = ~~(($1.barcode.length + 1) / 2); _H < _I; _H++) { /*13231*/
				$k[$j++] = 0; /*13231*/
			} /*13231*/
			var _J = $a(); /*13232*/
			$k[$j++] = _J; /*13232*/
			$k[$j++] = "opt"; /*13232*/
			$k[$j++] = $1.options; /*13232*/
			var _L = $d(); /*13232*/
			$k[$j++] = _L; /*13235*/
			if (!$1.dontdraw) { /*13235*/
				$0.renlinear(); /*13235*/
			} /*13235*/
		};
		$0.daft = function() {
			var $1 = {}; /*13262*/
			$1.options = $k[--$j]; /*13264*/
			$1.barcode = $k[--$j]; /*13265*/
			$1.dontdraw = false; /*13267*/
			$1.height = 0.175; /*13268*/
			$forall($1.options, function() { /*13279*/
				var _3 = $k[--$j]; /*13279*/
				$1[$k[--$j]] = _3; /*13279*/
			}); /*13279*/
			$1.height = +$1.height; /*13281*/
			$forall($1.barcode, function() { /*13287*/
				var _7 = $k[--$j]; /*13284*/
				if ((_7 != 68) && ((_7 != 65) && ((_7 != 70) && (_7 != 84)))) { /*13286*/
					$k[$j++] = "bwipp.daftBadCharacter"; /*13285*/
					$k[$j++] = "DAFT must contain only characters D, A, F and T"; /*13285*/
					$0.raiseerror(); /*13285*/
				} /*13285*/
			}); /*13285*/
			$1.barlen = $1.barcode.length; /*13289*/
			$1.bbs = $a($1.barlen); /*13291*/
			$1.bhs = $a($1.barlen); /*13292*/
			for (var _F = 0, _E = $1.barlen - 1; _F <= _E; _F += 1) { /*13312*/
				$1.i = _F; /*13294*/
				$1.enc = $geti($1.barcode, $1.i, 1); /*13295*/
				if ($eq($1.enc, "D")) { /*13299*/
					$put($1.bbs, $1.i, (0 * $1.height) / 8); /*13297*/
					$put($1.bhs, $1.i, (5 * $1.height) / 8); /*13298*/
				} /*13298*/
				if ($eq($1.enc, "A")) { /*13303*/
					$put($1.bbs, $1.i, (3 * $1.height) / 8); /*13301*/
					$put($1.bhs, $1.i, (5 * $1.height) / 8); /*13302*/
				} /*13302*/
				if ($eq($1.enc, "F")) { /*13307*/
					$put($1.bbs, $1.i, (0 * $1.height) / 8); /*13305*/
					$put($1.bhs, $1.i, (8 * $1.height) / 8); /*13306*/
				} /*13306*/
				if ($eq($1.enc, "T")) { /*13311*/
					$put($1.bbs, $1.i, (3 * $1.height) / 8); /*13309*/
					$put($1.bhs, $1.i, (2 * $1.height) / 8); /*13310*/
				} /*13310*/
			} /*13310*/
			$k[$j++] = Infinity; /*13320*/
			$k[$j++] = "ren"; /*13320*/
			$k[$j++] = $0.renlinear; /*13320*/
			$k[$j++] = "bbs"; /*13320*/
			$k[$j++] = $1.bbs; /*13320*/
			$k[$j++] = "bhs"; /*13320*/
			$k[$j++] = $1.bhs; /*13320*/
			$k[$j++] = "sbs"; /*13320*/
			$k[$j++] = Infinity; /*13320*/
			for (var _o = 0, _p = $1.bhs.length - 1; _o < _p; _o++) { /*13319*/
				$k[$j++] = 1.44; /*13319*/
				$k[$j++] = 1.872; /*13319*/
			} /*13319*/
			$k[$j++] = 1.44; /*13319*/
			var _q = $a(); /*13320*/
			$k[$j++] = _q; /*13320*/
			$k[$j++] = "opt"; /*13320*/
			$k[$j++] = $1.options; /*13320*/
			var _s = $d(); /*13320*/
			$k[$j++] = _s; /*13323*/
			if (!$1.dontdraw) { /*13323*/
				$0.renlinear(); /*13323*/
			} /*13323*/
		};
		$0.symbol = function() {
			var $1 = {}; /*13350*/
			$1.options = $k[--$j]; /*13352*/
			$1.barcode = $k[--$j]; /*13353*/
			$1.dontdraw = false; /*13355*/
			$forall($1.options, function() { /*13366*/
				var _3 = $k[--$j]; /*13366*/
				$1[$k[--$j]] = _3; /*13366*/
			}); /*13366*/
			var _H = {
				fima: function() {
					$1.sbs = $a([2.25, 2.25, 2.25, 11.25, 2.25, 11.25, 2.25, 2.25, 2.25]); /*13370*/
					$1.bhs = $a([0.625, 0.625, 0.625, 0.625, 0.625]); /*13371*/
					$1.bbs = $a([0, 0, 0, 0, 0]); /*13372*/
				},
				fimb: function() {
					$1.sbs = $a([2.25, 6.75, 2.25, 2.25, 2.25, 6.25, 2.25, 2.25, 2.25, 6.75, 2.25]); /*13375*/
					$1.bhs = $a([0.625, 0.625, 0.625, 0.625, 0.625, 0.625]); /*13376*/
					$1.bbs = $a([0, 0, 0, 0, 0, 0]); /*13377*/
				},
				fimc: function() {
					$1.sbs = $a([2.25, 2.25, 2.25, 6.75, 2.25, 6.75, 2.25, 6.75, 2.25, 2.25, 2.25]); /*13380*/
					$1.bhs = $a([0.625, 0.625, 0.625, 0.625, 0.625, 0.625]); /*13381*/
					$1.bbs = $a([0, 0, 0, 0, 0, 0]); /*13382*/
				},
				fimd: function() {
					$1.sbs = $a([2.25, 2.25, 2.25, 2.25, 2.25, 6.75, 2.25, 6.75, 2.25, 2.25, 2.25, 2.25, 2.25]); /*13385*/
					$1.bhs = $a([0.625, 0.625, 0.625, 0.625, 0.625, 0.625, 0.625]); /*13386*/
					$1.bbs = $a([0, 0, 0, 0, 0, 0, 0]); /*13387*/
				}
			}; /*13387*/
			$1.symbols = _H; /*13389*/
			var _K = $get($1.symbols, $1.barcode) !== undefined; /*13392*/
			if (!_K) { /*13394*/
				$k[$j++] = "bwipp.symbolUnknownSymbol"; /*13393*/
				$k[$j++] = "Unknown symbol name provided"; /*13393*/
				$0.raiseerror(); /*13393*/
			} /*13393*/
			$get($1.symbols, $1.barcode)(); /*13396*/
			var _S = {
				ren: $0.renlinear,
				sbs: $1.sbs,
				bhs: $1.bhs,
				bbs: $1.bbs,
				opt: $1.options
			}; /*13404*/
			$k[$j++] = _S; /*13407*/
			if (!$1.dontdraw) { /*13407*/
				$0.renlinear(); /*13407*/
			} /*13407*/
		};
		$0.pdf417 = function() {
			var $1 = {}; /*13434*/
			$1.options = $k[--$j]; /*13436*/
			$1.barcode = $k[--$j]; /*13437*/
			$1.dontdraw = false; /*13439*/
			$1.compact = false; /*13440*/
			$1.eclevel = -1; /*13441*/
			$1.columns = 0; /*13442*/
			$1.rows = 0; /*13443*/
			$1.rowmult = 3; /*13444*/
			$1.encoding = "auto"; /*13445*/
			$1.ccc = false; /*13446*/
			$1.raw = false; /*13447*/
			$1.parse = false; /*13448*/
			$forall($1.options, function() { /*13459*/
				var _3 = $k[--$j]; /*13459*/
				$1[$k[--$j]] = _3; /*13459*/
			}); /*13459*/
			$1.eclevel = ~~$1.eclevel; /*13461*/
			$1.columns = ~~$1.columns; /*13462*/
			$1.rows = ~~$1.rows; /*13463*/
			$1.rowmult = +$1.rowmult; /*13464*/
			if ($1.raw) { /*13487*/
				$1.encoding = "raw"; /*13487*/
			} /*13487*/
			if ($eq($1.encoding, "raw")) { /*13501*/
				$1.datcws = $a($1.barcode.length); /*13491*/
				$1.i = 0; /*13492*/
				$1.j = 0; /*13492*/
				for (;;) { /*13499*/
					if ($1.i == $1.barcode.length) { /*13494*/
						break; /*13494*/
					} /*13494*/
					$1.cw = ~~$z($geti($1.barcode, $1.i + 1, 3)); /*13495*/
					$put($1.datcws, $1.j, $1.cw); /*13496*/
					$1.i = $1.i + 4; /*13497*/
					$1.j = $1.j + 1; /*13498*/
				} /*13498*/
				$1.datcws = $geti($1.datcws, 0, $1.j); /*13500*/
			} /*13500*/
			$k[$j++] = Infinity; /*13503*/
			$forall($1.barcode); /*13503*/
			$1.barcode = $a(); /*13503*/
			$1.barlen = $1.barcode.length; /*13504*/
			if ($1.ccc) { /*13506*/
				$1.encoding = "ccc"; /*13506*/
			} /*13506*/
			$1.encb = function() {
				$1.in = $k[--$j]; /*13509*/
				$1.inlen = $1.in.length; /*13510*/
				$1.out = $a(((~~($1.inlen / 6)) * 5) + ($1.inlen % 6)); /*13511*/
				for (var _b = 0, _a = (~~($1.inlen / 6)) - 1; _b <= _a; _b += 1) { /*13534*/
					$1.k = _b; /*13513*/
					$k[$j++] = Infinity; /*13514*/
					$aload($geti($1.in, $1.k * 6, 3)); /*13514*/
					$1.msbs = $a(); /*13514*/
					$k[$j++] = Infinity; /*13518*/
					$aload($1.msbs); /*13516*/
					var _h = $k[--$j]; /*13516*/
					var _i = $k[--$j]; /*13516*/
					var _j = $k[--$j]; /*13516*/
					$k[$j++] = (_h + (_i * 256)) + (_j * 65536); /*13517*/
					for (var _k = 0, _l = 3; _k < _l; _k++) { /*13517*/
						var _m = $k[--$j]; /*13517*/
						$k[$j++] = _m % 900; /*13517*/
						$k[$j++] = ~~(_m / 900); /*13517*/
					} /*13517*/
					$1.mscs = $a(); /*13518*/
					$k[$j++] = Infinity; /*13519*/
					$aload($geti($1.in, ($1.k * 6) + 3, 3)); /*13519*/
					$1.lsbs = $a(); /*13519*/
					$k[$j++] = Infinity; /*13523*/
					$aload($1.lsbs); /*13521*/
					var _t = $k[--$j]; /*13521*/
					var _u = $k[--$j]; /*13521*/
					var _v = $k[--$j]; /*13521*/
					$k[$j++] = (_t + (_u * 256)) + (_v * 65536); /*13522*/
					for (var _w = 0, _x = 3; _w < _x; _w++) { /*13522*/
						var _y = $k[--$j]; /*13522*/
						$k[$j++] = _y % 900; /*13522*/
						$k[$j++] = ~~(_y / 900); /*13522*/
					} /*13522*/
					$1.lscs = $a(); /*13523*/
					var _11 = $get($1.lscs, 0); /*13524*/
					var _13 = $get($1.mscs, 0); /*13524*/
					$put($1.out, ($1.k * 5) + 4, (_11 + (_13 * 316)) % 900); /*13525*/
					var _17 = $get($1.lscs, 1); /*13526*/
					var _19 = $get($1.mscs, 0); /*13526*/
					var _1B = $get($1.mscs, 1); /*13526*/
					$put($1.out, ($1.k * 5) + 3, ((((~~((_11 + (_13 * 316)) / 900)) + _17) + (_19 * 641)) + (_1B * 316)) % 900); /*13527*/
					var _1F = $get($1.lscs, 2); /*13528*/
					var _1H = $get($1.mscs, 0); /*13528*/
					var _1J = $get($1.mscs, 1); /*13528*/
					var _1L = $get($1.mscs, 2); /*13528*/
					$put($1.out, ($1.k * 5) + 2, (((((~~(((((~~((_11 + (_13 * 316)) / 900)) + _17) + (_19 * 641)) + (_1B * 316)) / 900)) + _1F) + (_1H * 20)) + (_1J * 641)) + (_1L * 316)) % 900); /*13529*/
					var _1P = $get($1.lscs, 3); /*13530*/
					var _1R = $get($1.mscs, 1); /*13530*/
					var _1T = $get($1.mscs, 2); /*13530*/
					$put($1.out, ($1.k * 5) + 1, ((((~~((((((~~(((((~~((_11 + (_13 * 316)) / 900)) + _17) + (_19 * 641)) + (_1B * 316)) / 900)) + _1F) + (_1H * 20)) + (_1J * 641)) + (_1L * 316)) / 900)) + _1P) + (_1R * 20)) + (_1T * 641)) % 900); /*13531*/
					$put($1.out, $1.k * 5, ((~~(((((~~((((((~~(((((~~((_11 + (_13 * 316)) / 900)) + _17) + (_19 * 641)) + (_1B * 316)) / 900)) + _1F) + (_1H * 20)) + (_1J * 641)) + (_1L * 316)) / 900)) + _1P) + (_1R * 20)) + (_1T * 641)) / 900)) + ($get($1.mscs, 2) * 20)) % 900); /*13533*/
				} /*13533*/
				$1.rem = $1.inlen % 6; /*13535*/
				if ($1.rem != 0) { /*13540*/
					$k[$j++] = $1.out; /*13538*/
					$k[$j++] = $1.out.length - $1.rem; /*13538*/
					$k[$j++] = Infinity; /*13538*/
					$aload($geti($1.in, $1.inlen - $1.rem, $1.rem)); /*13538*/
					var _1k = $a(); /*13538*/
					var _1l = $k[--$j]; /*13539*/
					$puti($k[--$j], _1l, _1k); /*13539*/
				} /*13539*/
				$k[$j++] = $1.out; /*13541*/
			}; /*13542*/
			if ($eq($1.encoding, "byte") || $eq($1.encoding, "ccc")) { /*13549*/
				$1.datcws = $a((((~~($1.barlen / 6)) * 5) + ($1.barlen % 6)) + 1); /*13545*/
				var _1v = (($1.barlen % 6) == 0) ? 924 : 901; /*13546*/
				$put($1.datcws, 0, _1v); /*13546*/
				$k[$j++] = $1.datcws; /*13547*/
				$k[$j++] = 1; /*13547*/
				$k[$j++] = $1.barcode; /*13547*/
				if ($1.encb() == $b) return $b; /*13547*/
				var _1y = $k[--$j]; /*13547*/
				var _1z = $k[--$j]; /*13547*/
				$puti($k[--$j], _1z, _1y); /*13547*/
				if ($eq($1.encoding, "ccc")) { /*13548*/
					$k[$j++] = Infinity; /*13548*/
					$k[$j++] = 920; /*13548*/
					$aload($1.datcws); /*13548*/
					$1.datcws = $a(); /*13548*/
				} /*13548*/
			} /*13548*/
			if ($eq($1.encoding, "auto")) { /*13913*/
				$1.T = 0; /*13554*/
				$1.N = 1; /*13554*/
				$1.B = 2; /*13554*/
				$1.A = 0; /*13555*/
				$1.L = 1; /*13555*/
				$1.M = 2; /*13555*/
				$1.P = 3; /*13555*/
				$1.tl = -1; /*13558*/
				$1.nl = -2; /*13558*/
				$1.bl = -3; /*13558*/
				$1.bl6 = -4; /*13558*/
				$1.bs = -5; /*13558*/
				$1.al = -6; /*13561*/
				$1.ll = -7; /*13561*/
				$1.ml = -8; /*13561*/
				$1.pl = -9; /*13561*/
				$1.as = -10; /*13561*/
				$1.ps = -11; /*13561*/
				$1.charmaps = $a([$a(["A", "a", "0", ";"]), $a(["B", "b", "1", "<"]), $a(["C", "c", "2", ">"]), $a(["D", "d", "3", "@"]), $a(["E", "e", "4", "["]), $a(["F", "f", "5", 92]), $a(["G", "g", "6", "]"]), $a(["H", "h", "7", "_"]), $a(["I", "i", "8", "`"]), $a(["J", "j", "9", "~"]), $a(["K", "k", "&", "!"]), $a(["L", "l", 13, 13]), $a(["M", "m", 9, 9]), $a(["N", "n", ",", ","]), $a(["O", "o", ":", ":"]), $a(["P", "p", "#", 10]), $a(["Q", "q", "-", "-"]), $a(["R", "r", ".", "."]), $a(["S", "s", "$", "$"]), $a(["T", "t", "/", "/"]), $a(["U", "u", "+", "\""]), $a(["V", "v", "%", "|"]), $a(["W", "w", "*", "*"]), $a(["X", "x", "=", 40]), $a(["Y", "y", "^", 41]), $a(["Z", "z", $1.pl, "?"]), $a([" ", " ", " ", "{"]), $a([$1.ll, $1.as, $1.ll, "}"]), $a([$1.ml, $1.ml, $1.al, "'"]), $a([$1.ps, $1.ps, $1.ps, $1.al])]); /*13596*/
				$1.charvals = $a([{}, {}, {}, {}]); /*13599*/
				$1.alltext = {}; /*13600*/
				for (var _2o = 0, _2n = $1.charmaps.length - 1; _2o <= _2n; _2o += 1) { /*13610*/
					$1.i = _2o; /*13602*/
					$1.encs = $get($1.charmaps, $1.i); /*13603*/
					for (var _2s = 0; _2s <= 3; _2s += 1) { /*13609*/
						$1.j = _2s; /*13605*/
						var _2v = $get($1.encs, $1.j); /*13606*/
						$k[$j++] = _2v; /*13606*/
						if ($eq($type(_2v), "stringtype")) { /*13606*/
							var _2y = $get($k[--$j], 0); /*13606*/
							$k[$j++] = _2y; /*13606*/
						} /*13606*/
						var _2z = $k[--$j]; /*13607*/
						$put($get($1.charvals, $1.j), _2z, $1.i); /*13607*/
						$put($1.alltext, _2z, -1); /*13608*/
					} /*13608*/
				} /*13608*/
				$1.e = 10000; /*13612*/
				$1.latlen = $a([$a([0, 1, 1, 2]), $a([2, 0, 1, 2]), $a([1, 1, 0, 1]), $a([1, 2, 2, 0])]); /*13620*/
				$1.latseq = $a([$a([$a([]), $a([$1.ll]), $a([$1.ml]), $a([$1.ml, $1.pl])]), $a([$a([$1.ml, $1.al]), $a([]), $a([$1.ml]), $a([$1.ml, $1.pl])]), $a([$a([$1.al]), $a([$1.ll]), $a([]), $a([$1.pl])]), $a([$a([$1.al]), $a([$1.al, $1.ll]), $a([$1.al, $1.ml]), $a([])])]); /*13628*/
				$1.shftlen = $a([$a([$1.e, $1.e, $1.e, 1]), $a([1, $1.e, $1.e, 1]), $a([$1.e, $1.e, $1.e, 1]), $a([$1.e, $1.e, $1.e, $1.e])]); /*13636*/
				$k[$j++] = Infinity; /*13639*/
				for (var _44 = 0, _45 = $1.barlen; _44 < _45; _44++) { /*13639*/
					$k[$j++] = 0; /*13639*/
				} /*13639*/
				$k[$j++] = 0; /*13639*/
				$1.numdigits = $a(); /*13639*/
				$k[$j++] = Infinity; /*13640*/
				for (var _48 = 0, _49 = $1.barlen; _48 < _49; _48++) { /*13640*/
					$k[$j++] = 0; /*13640*/
				} /*13640*/
				$k[$j++] = 0; /*13640*/
				$1.numtext = $a(); /*13640*/
				$k[$j++] = Infinity; /*13641*/
				for (var _4C = 0, _4D = $1.barlen; _4C < _4D; _4C++) { /*13641*/
					$k[$j++] = 0; /*13641*/
				} /*13641*/
				$k[$j++] = 0; /*13641*/
				$1.numbytes = $a(); /*13641*/
				for (var _4G = $1.barlen - 1; _4G >= 0; _4G -= 1) { /*13653*/
					$1.i = _4G; /*13643*/
					var _4J = $get($1.barcode, $1.i); /*13644*/
					if ((_4J >= 48) && (_4J <= 57)) { /*13646*/
						$put($1.numdigits, $1.i, $get($1.numdigits, $1.i + 1) + 1); /*13645*/
					} /*13645*/
					var _4T = $get($1.alltext, $get($1.barcode, $1.i)) !== undefined; /*13647*/
					if (_4T && ($get($1.numdigits, $1.i) < 13)) { /*13649*/
						$put($1.numtext, $1.i, $get($1.numtext, $1.i + 1) + 1); /*13648*/
					} /*13648*/
					if (($get($1.numtext, $1.i) < 5) && ($get($1.numdigits, $1.i) < 13)) { /*13652*/
						$put($1.numbytes, $1.i, $get($1.numbytes, $1.i + 1) + 1); /*13651*/
					} /*13651*/
				} /*13651*/
				$1.numdigits = $geti($1.numdigits, 0, $1.barlen); /*13654*/
				$1.numtext = $geti($1.numtext, 0, $1.barlen); /*13655*/
				$1.numbytes = $geti($1.numbytes, 0, $1.barlen); /*13656*/
				$1.seq = $a([]); /*13658*/
				$1.seqlen = 0; /*13658*/
				$1.state = $1.T; /*13658*/
				$1.p = 0; /*13658*/
				for (;;) { /*13701*/
					if ($1.p == $1.barlen) { /*13659*/
						break; /*13659*/
					} /*13659*/
					$1.n = $get($1.numdigits, $1.p); /*13660*/
					if ($1.n >= 13) { /*13699*/
						$k[$j++] = Infinity; /*13666*/
						$aload($1.seq); /*13663*/
						$k[$j++] = $1.nl; /*13665*/
						$k[$j++] = Infinity; /*13665*/
						$aload($geti($1.barcode, $1.p, $1.n)); /*13665*/
						var _5A = $a(); /*13665*/
						$k[$j++] = _5A; /*13665*/
						$1.seq = $a(); /*13666*/
						$1.state = $1.N; /*13667*/
						$1.p = $1.p + $1.n; /*13668*/
						$1.seqlen = ($1.seqlen + 1) + $1.n; /*13669*/
					} else { /*13699*/
						$1.t = $get($1.numtext, $1.p); /*13671*/
						if ($1.t >= 5) { /*13699*/
							$k[$j++] = Infinity; /*13677*/
							$aload($1.seq); /*13674*/
							if ($1.state != $1.T) { /*13675*/
								$k[$j++] = $1.tl; /*13675*/
							} /*13675*/
							$k[$j++] = Infinity; /*13676*/
							$aload($geti($1.barcode, $1.p, $1.t)); /*13676*/
							var _5T = $a(); /*13676*/
							$k[$j++] = _5T; /*13676*/
							$1.seq = $a(); /*13677*/
							$1.state = $1.T; /*13678*/
							$1.p = $1.p + $1.t; /*13679*/
							$1.seqlen = ($1.seqlen + 1) + $1.t; /*13680*/
						} else { /*13699*/
							$1.b = $get($1.numbytes, $1.p); /*13682*/
							if (($1.b == 1) && ($1.state == $1.T)) { /*13699*/
								$k[$j++] = Infinity; /*13688*/
								$aload($1.seq); /*13685*/
								$k[$j++] = $1.bs; /*13687*/
								$k[$j++] = $a([$get($1.barcode, $1.p)]); /*13687*/
								$1.seq = $a(); /*13688*/
								$1.p = $1.p + $1.b; /*13689*/
								$1.seqlen = $1.seqlen + 2; /*13690*/
							} else { /*13699*/
								$k[$j++] = Infinity; /*13696*/
								$aload($1.seq); /*13693*/
								var _5s = (($1.b % 6) != 0) ? $1.bl : $1.bl6; /*13694*/
								$k[$j++] = _5s; /*13695*/
								$k[$j++] = Infinity; /*13695*/
								$aload($geti($1.barcode, $1.p, $1.b)); /*13695*/
								var _5x = $a(); /*13695*/
								$k[$j++] = _5x; /*13695*/
								$1.seq = $a(); /*13696*/
								$1.state = $1.B; /*13697*/
								$1.p = $1.p + $1.b; /*13698*/
								$1.seqlen = ($1.seqlen + 1) + $1.b; /*13699*/
							} /*13699*/
						} /*13699*/
					} /*13699*/
				} /*13699*/
				$k[$j++] = "latchcws"; /*13704*/
				$k[$j++] = Infinity; /*13704*/
				$k[$j++] = $1.tl; /*13704*/
				$k[$j++] = 900; /*13704*/
				$k[$j++] = $1.bl; /*13704*/
				$k[$j++] = 901; /*13704*/
				$k[$j++] = $1.bl6; /*13704*/
				$k[$j++] = 924; /*13704*/
				$k[$j++] = $1.nl; /*13704*/
				$k[$j++] = 902; /*13704*/
				$k[$j++] = $1.bs; /*13704*/
				$k[$j++] = 913; /*13704*/
				var _69 = $d(); /*13704*/
				$1[$k[--$j]] = _69; /*13705*/
				$1.enca = function() {
					var _6F = $get($get($1.charvals, $1.A), $k[--$j]); /*13708*/
					$k[$j++] = _6F; /*13708*/
				}; /*13708*/
				$1.encl = function() {
					var _6K = $get($get($1.charvals, $1.L), $k[--$j]); /*13709*/
					$k[$j++] = _6K; /*13709*/
				}; /*13709*/
				$1.encm = function() {
					var _6P = $get($get($1.charvals, $1.M), $k[--$j]); /*13710*/
					$k[$j++] = _6P; /*13710*/
				}; /*13710*/
				$1.encp = function() {
					var _6U = $get($get($1.charvals, $1.P), $k[--$j]); /*13711*/
					$k[$j++] = _6U; /*13711*/
				}; /*13711*/
				$1.textencfuncs = $a(["enca", "encl", "encm", "encp"]); /*13712*/
				$1.addtotext = function() {
					$put($1.text, $1.l, $k[--$j]); /*13715*/
					$1.l = $1.l + 1; /*13716*/
				}; /*13717*/
				$1.enct = function() {
					$1.in = $k[--$j]; /*13721*/
					$1.curlen = $a([$1.e, $1.e, $1.e, $1.e]); /*13723*/
					$put($1.curlen, $1.submode, 0); /*13724*/
					$1.curseq = $a([$a([]), $a([]), $a([]), $a([])]); /*13725*/
					$forall($1.in, function() { /*13795*/
						$1.char = $k[--$j]; /*13730*/
						for (;;) { /*13751*/
							$1.imp = false; /*13734*/
							var _6t = $a([$1.A, $1.L, $1.M, $1.P]); /*13735*/
							for (var _6u = 0, _6v = _6t.length; _6u < _6v; _6u++) { /*13749*/
								$1.x = $get(_6t, _6u); /*13736*/
								var _71 = $a([$1.A, $1.L, $1.M, $1.P]); /*13737*/
								for (var _72 = 0, _73 = _71.length; _72 < _73; _72++) { /*13748*/
									$1.y = $get(_71, _72); /*13738*/
									$1.cost = $get($1.curlen, $1.x) + $get($get($1.latlen, $1.x), $1.y); /*13739*/
									if ($1.cost < $get($1.curlen, $1.y)) { /*13747*/
										$put($1.curlen, $1.y, $1.cost); /*13741*/
										$k[$j++] = $1.curseq; /*13744*/
										$k[$j++] = $1.y; /*13744*/
										$k[$j++] = Infinity; /*13744*/
										$aload($get($1.curseq, $1.x)); /*13743*/
										$aload($get($get($1.latseq, $1.x), $1.y)); /*13744*/
										var _7U = $a(); /*13744*/
										var _7V = $k[--$j]; /*13745*/
										$put($k[--$j], _7V, _7U); /*13745*/
										$1.imp = true; /*13746*/
									} /*13746*/
								} /*13746*/
							} /*13746*/
							if (!$1.imp) { /*13750*/
								break; /*13750*/
							} /*13750*/
						} /*13750*/
						$1.nxtlen = $a([$1.e, $1.e, $1.e, $1.e]); /*13754*/
						$1.nxtseq = $a(4); /*13755*/
						var _7i = $a([$1.A, $1.L, $1.M, $1.P]); /*13757*/
						for (var _7j = 0, _7k = _7i.length; _7j < _7k; _7j++) { /*13790*/
							$1.x = $get(_7i, _7j); /*13758*/
							for (;;) { /*13788*/
								var _7q = $get($get($1.charvals, $1.x), $1.char) !== undefined; /*13762*/
								if (!_7q) { /*13762*/
									break; /*13762*/
								} /*13762*/
								$1.cost = $get($1.curlen, $1.x) + 1; /*13765*/
								if ($1.cost < $get($1.nxtlen, $1.x)) { /*13769*/
									$put($1.nxtlen, $1.x, $1.cost); /*13767*/
									$k[$j++] = $1.nxtseq; /*13768*/
									$k[$j++] = $1.x; /*13768*/
									$k[$j++] = Infinity; /*13768*/
									$aload($get($1.curseq, $1.x)); /*13768*/
									$k[$j++] = $1.char; /*13768*/
									var _87 = $a(); /*13768*/
									var _88 = $k[--$j]; /*13768*/
									$put($k[--$j], _88, _87); /*13768*/
								} /*13768*/
								var _8E = $a([$1.A, $1.L, $1.M, $1.P]); /*13772*/
								for (var _8F = 0, _8G = _8E.length; _8F < _8G; _8F++) { /*13785*/
									$1.y = $get(_8E, _8F); /*13773*/
									if ($ne($1.x, $1.y)) { /*13784*/
										$1.cost = ($get($1.curlen, $1.y) + $get($get($1.shftlen, $1.y), $1.x)) + 1; /*13775*/
										if ($1.cost < $get($1.nxtlen, $1.y)) { /*13783*/
											$put($1.nxtlen, $1.y, $1.cost); /*13777*/
											$k[$j++] = $1.nxtseq; /*13781*/
											$k[$j++] = $1.y; /*13781*/
											$k[$j++] = Infinity; /*13781*/
											$aload($get($1.curseq, $1.y)); /*13779*/
											var _8g = ($1.x == $1.A) ? $1.as : $1.ps; /*13780*/
											$k[$j++] = _8g; /*13781*/
											$k[$j++] = $1.char; /*13781*/
											var _8i = $a(); /*13781*/
											var _8j = $k[--$j]; /*13782*/
											$put($k[--$j], _8j, _8i); /*13782*/
										} /*13782*/
									} /*13782*/
								} /*13782*/
								break; /*13787*/
							} /*13787*/
						} /*13787*/
						$1.curlen = $1.nxtlen; /*13792*/
						$1.curseq = $1.nxtseq; /*13793*/
					}); /*13793*/
					$1.minseq = $1.e; /*13798*/
					var _8s = $a([$1.A, $1.L, $1.M, $1.P]); /*13799*/
					for (var _8t = 0, _8u = _8s.length; _8t < _8u; _8t++) { /*13805*/
						$1.k = $get(_8s, _8t); /*13800*/
						if ($get($1.curlen, $1.k) < $1.minseq) { /*13804*/
							$1.minseq = $get($1.curlen, $1.k); /*13802*/
							$1.txtseq = $get($1.curseq, $1.k); /*13803*/
						} /*13803*/
					} /*13803*/
					$1.text = $a($1.minseq); /*13808*/
					$1.k = 0; /*13809*/
					$1.l = 0; /*13809*/
					for (;;) { /*13829*/
						if ($1.k >= $1.txtseq.length) { /*13810*/
							break; /*13810*/
						} /*13810*/
						$1.char = $get($1.txtseq, $1.k); /*13812*/
						$k[$j++] = $1.char; /*13815*/
						$1[$get($1.textencfuncs, $1.submode)](); /*13815*/
						if ($1.addtotext() == $b) break; /*13815*/
						$1.k = $1.k + 1; /*13816*/
						if (($1.char == $1.as) || ($1.char == $1.ps)) { /*13822*/
							$k[$j++] = $get($1.txtseq, $1.k); /*13820*/
							if ($1.char == $1.as) { /*13820*/
								if ($1.enca() == $b) break; /*13820*/
							} else { /*13820*/
								if ($1.encp() == $b) break; /*13820*/
							} /*13820*/
							if ($1.addtotext() == $b) break; /*13820*/
							$1.k = $1.k + 1; /*13821*/
						} /*13821*/
						if ($1.char == $1.al) { /*13825*/
							$1.submode = $1.A; /*13825*/
						} /*13825*/
						if ($1.char == $1.ll) { /*13826*/
							$1.submode = $1.L; /*13826*/
						} /*13826*/
						if ($1.char == $1.ml) { /*13827*/
							$1.submode = $1.M; /*13827*/
						} /*13827*/
						if ($1.char == $1.pl) { /*13828*/
							$1.submode = $1.P; /*13828*/
						} /*13828*/
					} /*13828*/
					if (($1.text.length % 2) == 1) { /*13839*/
						if ($1.submode == $1.P) { /*13836*/
							$k[$j++] = "pad"; /*13833*/
							$k[$j++] = $1.al; /*13833*/
							if ($1.encp() == $b) return $b; /*13833*/
							var _9j = $k[--$j]; /*13833*/
							$1[$k[--$j]] = _9j; /*13833*/
							$1.submode = $1.A; /*13834*/
						} else { /*13836*/
							$k[$j++] = "pad"; /*13836*/
							$k[$j++] = $1.ps; /*13836*/
							$1[$get($1.textencfuncs, $1.submode)](); /*13836*/
							var _9r = $k[--$j]; /*13836*/
							$1[$k[--$j]] = _9r; /*13836*/
						} /*13836*/
						$k[$j++] = Infinity; /*13838*/
						$aload($1.text); /*13838*/
						$k[$j++] = $1.pad; /*13838*/
						$1.text = $a(); /*13838*/
					} /*13838*/
					$1.out = $a(~~($1.text.length / 2)); /*13841*/
					for (var _A0 = 0, _9z = $1.out.length - 1; _A0 <= _9z; _A0 += 1) { /*13845*/
						$1.k = _A0; /*13843*/
						$put($1.out, $1.k, ($get($1.text, $1.k * 2) * 30) + $get($1.text, ($1.k * 2) + 1)); /*13844*/
					} /*13844*/
					$k[$j++] = $1.out; /*13847*/
				}; /*13849*/
				$1.encn = function() {
					$1.in = $k[--$j]; /*13852*/
					$1.out = $a([]); /*13853*/
					for (var _AE = 0, _AD = $1.in.length - 1; _AE <= _AD; _AE += 44) { /*13881*/
						$1.k = _AE; /*13855*/
						$k[$j++] = Infinity; /*13859*/
						var _AJ = $1.in.length - $1.k; /*13857*/
						$k[$j++] = 1; /*13857*/
						$k[$j++] = $1.in; /*13857*/
						$k[$j++] = $1.k; /*13857*/
						$k[$j++] = _AJ; /*13857*/
						if (_AJ > 44) { /*13857*/
							$j--; /*13857*/
							$k[$j++] = 44; /*13857*/
						} /*13857*/
						var _AK = $k[--$j]; /*13857*/
						var _AL = $k[--$j]; /*13857*/
						$forall($geti($k[--$j], _AL, _AK), function() { /*13858*/
							var _AO = $k[--$j]; /*13858*/
							$k[$j++] = _AO - 48; /*13858*/
						}); /*13858*/
						$1.gmod = $a(); /*13859*/
						$1.cwn = $a([]); /*13860*/
						for (;;) { /*13879*/
							$1.dv = 900; /*13861*/
							$1.gmul = $a([]); /*13862*/
							$1.val = 0; /*13862*/
							for (;;) { /*13874*/
								if ($1.gmod.length == 0) { /*13863*/
									break; /*13863*/
								} /*13863*/
								$1.val = ($1.val * 10) + $get($1.gmod, 0); /*13864*/
								$1.gmod = $geti($1.gmod, 1, $1.gmod.length - 1); /*13865*/
								if ($1.val < $1.dv) { /*13871*/
									if ($1.gmul.length != 0) { /*13869*/
										$k[$j++] = Infinity; /*13868*/
										$aload($1.gmul); /*13868*/
										$k[$j++] = 0; /*13868*/
										$1.gmul = $a(); /*13868*/
									} /*13868*/
								} else { /*13871*/
									$k[$j++] = Infinity; /*13871*/
									$aload($1.gmul); /*13871*/
									$k[$j++] = ~~($1.val / $1.dv); /*13871*/
									$1.gmul = $a(); /*13871*/
								} /*13871*/
								$1.val = $1.val % $1.dv; /*13873*/
							} /*13873*/
							$1.dv = $1.val; /*13875*/
							$k[$j++] = Infinity; /*13876*/
							$k[$j++] = $1.dv; /*13876*/
							$aload($1.cwn); /*13876*/
							$1.cwn = $a(); /*13876*/
							$1.gmod = $1.gmul; /*13877*/
							if ($1.gmul.length == 0) { /*13878*/
								break; /*13878*/
							} /*13878*/
						} /*13878*/
						$k[$j++] = Infinity; /*13880*/
						$aload($1.out); /*13880*/
						$aload($1.cwn); /*13880*/
						$1.out = $a(); /*13880*/
					} /*13880*/
					$k[$j++] = $1.out; /*13882*/
				}; /*13883*/
				$1.encfuncs = $a(["enct", "encn", "encb"]); /*13885*/
				$1.addtocws = function() {
					var _Av = $k[--$j]; /*13888*/
					$puti($1.datcws, $1.j, _Av); /*13888*/
					$1.j = _Av.length + $1.j; /*13889*/
				}; /*13890*/
				$1.state = $1.T; /*13893*/
				$1.submode = $1.A; /*13893*/
				$1.datcws = $a($1.seqlen); /*13894*/
				$1.i = 0; /*13895*/
				$1.j = 0; /*13895*/
				for (;;) { /*13911*/
					if ($1.i >= $1.seq.length) { /*13896*/
						break; /*13896*/
					} /*13896*/
					$1.chars = $get($1.seq, $1.i); /*13897*/
					if ($eq($type($1.chars), "arraytype")) { /*13907*/
						$k[$j++] = $1.chars; /*13899*/
						$1[$get($1.encfuncs, $1.state)](); /*13899*/
						if ($1.addtocws() == $b) break; /*13899*/
					} else { /*13907*/
						$k[$j++] = $a([$get($1.latchcws, $1.chars)]); /*13901*/
						if ($1.addtocws() == $b) break; /*13901*/
						if ($1.chars == $1.tl) { /*13902*/
							$1.state = $1.T; /*13902*/
							$1.submode = $1.A; /*13902*/
						} /*13902*/
						if ($1.chars == $1.nl) { /*13903*/
							$1.state = $1.N; /*13903*/
						} /*13903*/
						if (($1.chars == $1.bl) || ($1.chars == $1.bl6)) { /*13904*/
							$1.state = $1.B; /*13904*/
						} /*13904*/
						if ($1.chars == $1.bs) { /*13908*/
							$1.i = $1.i + 1; /*13906*/
							$k[$j++] = $get($1.seq, $1.i); /*13907*/
							if ($1.encb() == $b) break; /*13907*/
							if ($1.addtocws() == $b) break; /*13907*/
						} /*13907*/
					} /*13907*/
					$1.i = $1.i + 1; /*13910*/
				} /*13910*/
				$1.datcws = $geti($1.datcws, 0, $1.j); /*13912*/
			} /*13912*/
			$1.m = $1.datcws.length; /*13916*/
			if ($1.eclevel == -1) { /*13922*/
				if ($1.m <= 40) { /*13918*/
					$1.eclevel = 2; /*13918*/
				} /*13918*/
				if (($1.m >= 41) && ($1.m <= 160)) { /*13919*/
					$1.eclevel = 3; /*13919*/
				} /*13919*/
				if (($1.m >= 161) && ($1.m <= 320)) { /*13920*/
					$1.eclevel = 4; /*13920*/
				} /*13920*/
				if ($1.m >= 321) { /*13921*/
					$1.eclevel = 5; /*13921*/
				} /*13921*/
			} /*13921*/
			$1.maxeclevel = (~~((Math.log((928 - 1) - $1.m)) / Math.log(2))) - 1; /*13925*/
			if ($1.eclevel > $1.maxeclevel) { /*13926*/
				$1.eclevel = $1.maxeclevel; /*13926*/
			} /*13926*/
			$1.k = ~~Math.pow(2, $1.eclevel + 1); /*13927*/
			if ($1.columns == 0) { /*13930*/
				$1.columns = ~~(Math.round(Math.sqrt(($1.m + $1.k) / 3))); /*13930*/
			} /*13930*/
			if (($1.columns >= 1) && ($1.columns <= 30)) { /*13931*/
				$1.c = $1.columns; /*13931*/
			} /*13931*/
			$1.r = ~~(Math.ceil((($1.m + $1.k) + 1) / $1.columns)); /*13934*/
			if (($1.r < $1.rows) && ($1.rows <= 90)) { /*13935*/
				$1.r = $1.rows; /*13935*/
			} /*13935*/
			if ($1.r < 3) { /*13936*/
				$1.r = 3; /*13936*/
			} /*13936*/
			var _C6 = $1.c; /*13939*/
			var _C7 = $1.r; /*13939*/
			var _C8 = $1.m; /*13939*/
			var _C9 = 8; /*13939*/
			var _CA = (~~((Math.log(((_C6 * _C7) - 1) - _C8)) / Math.log(2))) - 1; /*13939*/
			if (((~~((Math.log(((_C6 * _C7) - 1) - _C8)) / Math.log(2))) - 1) > 8) { /*13939*/
				var _ = _C9; /*13939*/
				_C9 = _CA; /*13939*/
				_CA = _; /*13939*/
			} /*13939*/
			$1.maxeclevel = _CA; /*13939*/
			if ($1.maxeclevel > $1.eclevel) { /*13943*/
				$1.eclevel = $1.maxeclevel; /*13941*/
				$1.k = ~~Math.pow(2, $1.eclevel + 1); /*13942*/
			} /*13942*/
			$1.n = ($1.c * $1.r) - $1.k; /*13946*/
			$1.cws = $a(($1.c * $1.r) + 1); /*13947*/
			$put($1.cws, 0, $1.n); /*13948*/
			$puti($1.cws, 1, $1.datcws); /*13949*/
			$k[$j++] = $1.cws; /*13950*/
			$k[$j++] = $1.m + 1; /*13950*/
			$k[$j++] = Infinity; /*13950*/
			for (var _CT = 0, _CU = ($1.n - $1.m) - 1; _CT < _CU; _CT++) { /*13950*/
				$k[$j++] = 900; /*13950*/
			} /*13950*/
			var _CV = $a(); /*13950*/
			var _CW = $k[--$j]; /*13950*/
			$puti($k[--$j], _CW, _CV); /*13950*/
			$k[$j++] = $1.cws; /*13951*/
			$k[$j++] = $1.n; /*13951*/
			$k[$j++] = Infinity; /*13951*/
			for (var _Cb = 0, _Cc = $1.k; _Cb < _Cc; _Cb++) { /*13951*/
				$k[$j++] = 0; /*13951*/
			} /*13951*/
			$k[$j++] = 0; /*13951*/
			var _Cd = $a(); /*13951*/
			var _Ce = $k[--$j]; /*13951*/
			$puti($k[--$j], _Ce, _Cd); /*13951*/
			$k[$j++] = Infinity; /*13954*/
			$k[$j++] = 1; /*13954*/
			for (var _Cg = 0, _Ch = 928; _Cg < _Ch; _Cg++) { /*13954*/
				var _Ci = $k[--$j]; /*13954*/
				$k[$j++] = _Ci; /*13954*/
				$k[$j++] = (_Ci * 3) % 929; /*13954*/
			} /*13954*/
			$1.rsalog = $a(); /*13954*/
			$1.rslog = $a(929); /*13955*/
			for (var _Cl = 1; _Cl <= 928; _Cl += 1) { /*13956*/
				$put($1.rslog, $get($1.rsalog, _Cl), _Cl); /*13956*/
			} /*13956*/
			$1.rsprod = function() {
				var _Cp = $k[--$j]; /*13960*/
				var _Cq = $k[--$j]; /*13960*/
				$k[$j++] = _Cq; /*13964*/
				$k[$j++] = _Cp; /*13964*/
				if ((_Cp != 0) && (_Cq != 0)) { /*13963*/
					var _Ct = $get($1.rslog, $k[--$j]); /*13961*/
					var _Cy = $get($1.rsalog, (_Ct + $get($1.rslog, $k[--$j])) % 928); /*13961*/
					$k[$j++] = _Cy; /*13961*/
				} else { /*13963*/
					$j -= 2; /*13963*/
					$k[$j++] = 0; /*13963*/
				} /*13963*/
			}; /*13965*/
			$k[$j++] = Infinity; /*13968*/
			$k[$j++] = 1; /*13968*/
			for (var _D0 = 0, _D1 = $1.k; _D0 < _D1; _D0++) { /*13968*/
				$k[$j++] = 0; /*13968*/
			} /*13968*/
			$1.coeffs = $a(); /*13968*/
			for (var _D5 = 1, _D4 = $1.k; _D5 <= _D4; _D5 += 1) { /*13977*/
				$1.i = _D5; /*13970*/
				$put($1.coeffs, $1.i, $get($1.coeffs, $1.i - 1)); /*13971*/
				for (var _DC = $1.i - 1; _DC >= 1; _DC -= 1) { /*13975*/
					$1.j = _DC; /*13973*/
					$k[$j++] = $1.coeffs; /*13974*/
					$k[$j++] = $1.j; /*13974*/
					$k[$j++] = $get($1.coeffs, $1.j - 1); /*13974*/
					$k[$j++] = $get($1.coeffs, $1.j); /*13974*/
					$k[$j++] = $get($1.rsalog, $1.i); /*13974*/
					if ($1.rsprod() == $b) break; /*13974*/
					var _DO = $k[--$j]; /*13974*/
					var _DP = $k[--$j]; /*13974*/
					var _DQ = $k[--$j]; /*13974*/
					$put($k[--$j], _DQ, (_DP + _DO) % 929); /*13974*/
				} /*13974*/
				$k[$j++] = $1.coeffs; /*13976*/
				$k[$j++] = 0; /*13976*/
				$k[$j++] = $get($1.coeffs, 0); /*13976*/
				$k[$j++] = $get($1.rsalog, $1.i); /*13976*/
				if ($1.rsprod() == $b) break; /*13976*/
				var _DY = $k[--$j]; /*13976*/
				var _DZ = $k[--$j]; /*13976*/
				$put($k[--$j], _DZ, _DY); /*13976*/
			} /*13976*/
			$1.coeffs = $geti($1.coeffs, 0, $1.coeffs.length - 1); /*13978*/
			for (var _Df = $1.coeffs.length - 1; _Df >= 0; _Df -= 2) { /*13979*/
				var _Dg = $1.coeffs; /*13979*/
				$put(_Dg, _Df, 929 - $get(_Dg, _Df)); /*13979*/
			} /*13979*/
			for (var _Dk = 0, _Dj = $1.n - 1; _Dk <= _Dj; _Dk += 1) { /*13988*/
				$1.t = ($get($1.cws, _Dk) + $get($1.cws, $1.n)) % 929; /*13983*/
				for (var _Ds = 0, _Dr = $1.k - 1; _Ds <= _Dr; _Ds += 1) { /*13987*/
					$1.j = _Ds; /*13985*/
					$put($1.cws, $1.n + $1.j, ($get($1.cws, ($1.n + $1.j) + 1) + (929 - (($1.t * $get($1.coeffs, ($1.k - $1.j) - 1)) % 929))) % 929); /*13986*/
				} /*13986*/
			} /*13986*/
			for (var _E9 = $1.n, _E8 = $1.n + $1.k; _E9 <= _E8; _E9 += 1) { /*13989*/
				$put($1.cws, _E9, (929 - $get($1.cws, _E9)) % 929); /*13989*/
			} /*13989*/
			$1.cws = $geti($1.cws, 0, $1.cws.length - 1); /*13992*/
			$1.clusters = $a([$a([120256, 125680, 128380, 120032, 125560, 128318, 108736, 119920, 108640, 86080, 108592, 86048, 110016, 120560, 125820, 109792, 120440, 125758, 88256, 109680, 88160, 89536, 110320, 120700, 89312, 110200, 120638, 89200, 110140, 89840, 110460, 89720, 110398, 89980, 128506, 119520, 125304, 128190, 107712, 119408, 125244, 107616, 119352, 84032, 107568, 119324, 84000, 107544, 83984, 108256, 119672, 125374, 85184, 108144, 119612, 85088, 108088, 119582, 85040, 108060, 85728, 108408, 119742, 85616, 108348, 85560, 108318, 85880, 108478, 85820, 85790, 107200, 119152, 125116, 107104, 119096, 125086, 83008, 107056, 119068, 82976, 107032, 82960, 82952, 83648, 107376, 119228, 83552, 107320, 119198, 83504, 107292, 83480, 83468, 83824, 107452, 83768, 107422, 83740, 83900, 106848, 118968, 125022, 82496, 106800, 118940, 82464, 106776, 118926, 82448, 106764, 82440, 106758, 82784, 106936, 119006, 82736, 106908, 82712, 106894, 82700, 82694, 106974, 82830, 82240, 106672, 118876, 82208, 106648, 118862, 82192, 106636, 82184, 106630, 82180, 82352, 82328, 82316, 82080, 118830, 106572, 106566, 82050, 117472, 124280, 127678, 103616, 117360, 124220, 103520, 117304, 124190, 75840, 103472, 75808, 104160, 117624, 124350, 76992, 104048, 117564, 76896, 103992, 76848, 76824, 77536, 104312, 117694, 77424, 104252, 77368, 77340, 77688, 104382, 77628, 77758, 121536, 126320, 128700, 121440, 126264, 128670, 111680, 121392, 126236, 111648, 121368, 126222, 111632, 121356, 103104, 117104, 124092, 112320, 103008, 117048, 124062, 112224, 121656, 126366, 93248, 74784, 102936, 117006, 93216, 112152, 93200, 75456, 103280, 117180, 93888, 75360, 103224, 117150, 93792, 112440, 121758, 93744, 75288, 93720, 75632, 103356, 94064, 75576, 103326, 94008, 112542, 93980, 75708, 94140, 75678, 94110, 121184, 126136, 128606, 111168, 121136, 126108, 111136, 121112, 126094, 111120, 121100, 111112, 111108, 102752, 116920, 123998, 111456, 102704, 116892, 91712, 74272, 121244, 116878, 91680, 74256, 102668, 91664, 111372, 102662, 74244, 74592, 102840, 116958, 92000, 74544, 102812, 91952, 111516, 102798, 91928, 74508, 74502, 74680, 102878, 92088, 74652, 92060, 74638, 92046, 92126, 110912, 121008, 126044, 110880, 120984, 126030, 110864, 120972, 110856, 120966, 110852, 110850, 74048, 102576, 116828, 90944, 74016, 102552, 116814, 90912, 111000, 121038, 90896, 73992, 102534, 90888, 110982, 90884, 74160, 102620, 91056, 74136, 102606, 91032, 111054, 91020, 74118, 91014, 91100, 91086, 110752, 120920, 125998, 110736, 120908, 110728, 120902, 110724, 110722, 73888, 102488, 116782, 90528, 73872, 102476, 90512, 110796, 102470, 90504, 73860, 90500, 73858, 73944, 90584, 90572, 90566, 120876, 120870, 110658, 102444, 73800, 90312, 90308, 90306, 101056, 116080, 123580, 100960, 116024, 70720, 100912, 115996, 70688, 100888, 70672, 70664, 71360, 101232, 116156, 71264, 101176, 116126, 71216, 101148, 71192, 71180, 71536, 101308, 71480, 101278, 71452, 71612, 71582, 118112, 124600, 127838, 105024, 118064, 124572, 104992, 118040, 124558, 104976, 118028, 104968, 118022, 100704, 115896, 123486, 105312, 100656, 115868, 79424, 70176, 118172, 115854, 79392, 105240, 100620, 79376, 70152, 79368, 70496, 100792, 115934, 79712, 70448, 118238, 79664, 105372, 100750, 79640, 70412, 79628, 70584, 100830, 79800, 70556, 79772, 70542, 70622, 79838, 122176, 126640, 128860, 122144, 126616, 128846, 122128, 126604, 122120, 126598, 122116, 104768, 117936, 124508, 113472, 104736, 126684, 124494, 113440, 122264, 126670, 113424, 104712, 117894, 113416, 122246, 104706, 69952, 100528, 115804, 78656, 69920, 100504, 115790, 96064, 78624, 104856, 117966, 96032, 113560, 122318, 100486, 96016, 78600, 104838, 96008, 69890, 70064, 100572, 78768, 70040, 100558, 96176, 78744, 104910, 96152, 113614, 70022, 78726, 70108, 78812, 70094, 96220, 78798, 122016, 126552, 128814, 122000, 126540, 121992, 126534, 121988, 121986, 104608, 117848, 124462, 113056, 104592, 126574, 113040, 122060, 117830, 113032, 104580, 113028, 104578, 113026, 69792, 100440, 115758, 78240, 69776, 100428, 95136, 78224, 104652, 100422, 95120, 113100, 69764, 95112, 78212, 69762, 78210, 69848, 100462, 78296, 69836, 95192, 78284, 69830, 95180, 78278, 69870, 95214, 121936, 126508, 121928, 126502, 121924, 121922, 104528, 117804, 112848, 104520, 117798, 112840, 121958, 112836, 104514, 112834, 69712, 100396, 78032, 69704, 100390, 94672, 78024, 104550, 94664, 112870, 69698, 94660, 78018, 94658, 78060, 94700, 94694, 126486, 121890, 117782, 104484, 104482, 69672, 77928, 94440, 69666, 77922, 99680, 68160, 99632, 68128, 99608, 115342, 68112, 99596, 68104, 99590, 68448, 99768, 115422, 68400, 99740, 68376, 99726, 68364, 68358, 68536, 99806, 68508, 68494, 68574, 101696, 116400, 123740, 101664, 116376, 101648, 116364, 101640, 116358, 101636, 67904, 99504, 115292, 72512, 67872, 116444, 115278, 72480, 101784, 116430, 72464, 67848, 99462, 72456, 101766, 67842, 68016, 99548, 72624, 67992, 99534, 72600, 101838, 72588, 67974, 68060, 72668, 68046, 72654, 118432, 124760, 127918, 118416, 124748, 118408, 124742, 118404, 118402, 101536, 116312, 105888, 101520, 116300, 105872, 118476, 116294, 105864, 101508, 105860, 101506, 105858, 67744, 99416, 72096, 67728, 116334, 80800, 72080, 101580, 99398, 80784, 105932, 67716, 80776, 72068, 67714, 72066, 67800, 99438, 72152, 67788, 80856, 72140, 67782, 80844, 72134, 67822, 72174, 80878, 126800, 128940, 126792, 128934, 126788, 126786, 118352, 124716, 122576, 126828, 124710, 122568, 126822, 122564, 118338, 122562, 101456, 116268, 105680, 101448, 116262, 114128, 105672, 118374, 114120, 122598, 101442, 114116, 105666, 114114, 67664, 99372, 71888, 67656, 99366, 80336, 71880, 101478, 97232, 80328, 105702, 67650, 97224, 114150, 71874, 97220, 67692, 71916, 67686, 80364, 71910, 97260, 80358, 97254, 126760, 128918, 126756, 126754, 118312, 124694, 122472, 126774, 122468, 118306, 122466, 101416, 116246, 105576, 101412, 113896, 105572, 101410, 113892, 105570, 113890, 67624, 99350, 71784, 101430, 80104, 71780, 67618, 96744, 80100, 71778, 96740, 80098, 96738, 71798, 96758, 126738, 122420, 122418, 105524, 113780, 113778, 71732, 79988, 96500, 96498, 66880, 66848, 98968, 66832, 66824, 66820, 66992, 66968, 66956, 66950, 67036, 67022, 100000, 99984, 115532, 99976, 115526, 99972, 99970, 66720, 98904, 69024, 100056, 98892, 69008, 100044, 69000, 100038, 68996, 66690, 68994, 66776, 98926, 69080, 100078, 69068, 66758, 69062, 66798, 69102, 116560, 116552, 116548, 116546, 99920, 102096, 116588, 115494, 102088, 116582, 102084, 99906, 102082, 66640, 68816, 66632, 98854, 73168, 68808, 66628, 73160, 68804, 66626, 73156, 68802, 66668, 68844, 66662, 73196, 68838, 73190, 124840, 124836, 124834, 116520, 118632, 124854, 118628, 116514, 118626, 99880, 115478, 101992, 116534, 106216, 101988, 99874, 106212, 101986, 106210, 66600, 98838, 68712, 99894, 72936, 68708, 66594, 81384, 72932, 68706, 81380, 72930, 66614, 68726, 72950, 81398, 128980, 128978, 124820, 126900, 124818, 126898, 116500, 118580, 116498, 122740, 118578, 122738, 99860, 101940, 99858, 106100, 101938, 114420]), $a([128352, 129720, 125504, 128304, 129692, 125472, 128280, 129678, 125456, 128268, 125448, 128262, 125444, 125792, 128440, 129758, 120384, 125744, 128412, 120352, 125720, 128398, 120336, 125708, 120328, 125702, 120324, 120672, 125880, 128478, 110144, 120624, 125852, 110112, 120600, 125838, 110096, 120588, 110088, 120582, 110084, 110432, 120760, 125918, 89664, 110384, 120732, 89632, 110360, 120718, 89616, 110348, 89608, 110342, 89952, 110520, 120798, 89904, 110492, 89880, 110478, 89868, 90040, 110558, 90012, 89998, 125248, 128176, 129628, 125216, 128152, 129614, 125200, 128140, 125192, 128134, 125188, 125186, 119616, 125360, 128220, 119584, 125336, 128206, 119568, 125324, 119560, 125318, 119556, 119554, 108352, 119728, 125404, 108320, 119704, 125390, 108304, 119692, 108296, 119686, 108292, 108290, 85824, 108464, 119772, 85792, 108440, 119758, 85776, 108428, 85768, 108422, 85764, 85936, 108508, 85912, 108494, 85900, 85894, 85980, 85966, 125088, 128088, 129582, 125072, 128076, 125064, 128070, 125060, 125058, 119200, 125144, 128110, 119184, 125132, 119176, 125126, 119172, 119170, 107424, 119256, 125166, 107408, 119244, 107400, 119238, 107396, 107394, 83872, 107480, 119278, 83856, 107468, 83848, 107462, 83844, 83842, 83928, 107502, 83916, 83910, 83950, 125008, 128044, 125000, 128038, 124996, 124994, 118992, 125036, 118984, 125030, 118980, 118978, 106960, 119020, 106952, 119014, 106948, 106946, 82896, 106988, 82888, 106982, 82884, 82882, 82924, 82918, 124968, 128022, 124964, 124962, 118888, 124982, 118884, 118882, 106728, 118902, 106724, 106722, 82408, 106742, 82404, 82402, 124948, 124946, 118836, 118834, 106612, 106610, 124224, 127664, 129372, 124192, 127640, 129358, 124176, 127628, 124168, 127622, 124164, 124162, 117568, 124336, 127708, 117536, 124312, 127694, 117520, 124300, 117512, 124294, 117508, 117506, 104256, 117680, 124380, 104224, 117656, 124366, 104208, 117644, 104200, 117638, 104196, 104194, 77632, 104368, 117724, 77600, 104344, 117710, 77584, 104332, 77576, 104326, 77572, 77744, 104412, 77720, 104398, 77708, 77702, 77788, 77774, 128672, 129880, 93168, 128656, 129868, 92664, 128648, 129862, 92412, 128644, 128642, 124064, 127576, 129326, 126368, 124048, 129902, 126352, 128716, 127558, 126344, 124036, 126340, 124034, 126338, 117152, 124120, 127598, 121760, 117136, 124108, 121744, 126412, 124102, 121736, 117124, 121732, 117122, 121730, 103328, 117208, 124142, 112544, 103312, 117196, 112528, 121804, 117190, 112520, 103300, 112516, 103298, 112514, 75680, 103384, 117230, 94112, 75664, 103372, 94096, 112588, 103366, 94088, 75652, 94084, 75650, 75736, 103406, 94168, 75724, 94156, 75718, 94150, 75758, 128592, 129836, 91640, 128584, 129830, 91388, 128580, 91262, 128578, 123984, 127532, 126160, 123976, 127526, 126152, 128614, 126148, 123970, 126146, 116944, 124012, 121296, 116936, 124006, 121288, 126182, 121284, 116930, 121282, 102864, 116972, 111568, 102856, 116966, 111560, 121318, 111556, 102850, 111554, 74704, 102892, 92112, 74696, 102886, 92104, 111590, 92100, 74690, 92098, 74732, 92140, 74726, 92134, 128552, 129814, 90876, 128548, 90750, 128546, 123944, 127510, 126056, 128566, 126052, 123938, 126050, 116840, 123958, 121064, 116836, 121060, 116834, 121058, 102632, 116854, 111080, 121078, 111076, 102626, 111074, 74216, 102646, 91112, 74212, 91108, 74210, 91106, 74230, 91126, 128532, 90494, 128530, 123924, 126004, 123922, 126002, 116788, 120948, 116786, 120946, 102516, 110836, 102514, 110834, 73972, 90612, 73970, 90610, 128522, 123914, 125978, 116762, 120890, 102458, 110714, 123552, 127320, 129198, 123536, 127308, 123528, 127302, 123524, 123522, 116128, 123608, 127342, 116112, 123596, 116104, 123590, 116100, 116098, 101280, 116184, 123630, 101264, 116172, 101256, 116166, 101252, 101250, 71584, 101336, 116206, 71568, 101324, 71560, 101318, 71556, 71554, 71640, 101358, 71628, 71622, 71662, 127824, 129452, 79352, 127816, 129446, 79100, 127812, 78974, 127810, 123472, 127276, 124624, 123464, 127270, 124616, 127846, 124612, 123458, 124610, 115920, 123500, 118224, 115912, 123494, 118216, 124646, 118212, 115906, 118210, 100816, 115948, 105424, 100808, 115942, 105416, 118246, 105412, 100802, 105410, 70608, 100844, 79824, 70600, 100838, 79816, 105446, 79812, 70594, 79810, 70636, 79852, 70630, 79846, 129960, 95728, 113404, 129956, 95480, 113278, 129954, 95356, 95294, 127784, 129430, 78588, 128872, 129974, 95996, 78462, 128868, 127778, 95870, 128866, 123432, 127254, 124520, 123428, 126696, 128886, 123426, 126692, 124514, 126690, 115816, 123446, 117992, 115812, 122344, 117988, 115810, 122340, 117986, 122338, 100584, 115830, 104936, 100580, 113640, 104932, 100578, 113636, 104930, 113634, 70120, 100598, 78824, 70116, 96232, 78820, 70114, 96228, 78818, 96226, 70134, 78838, 129940, 94968, 113022, 129938, 94844, 94782, 127764, 78206, 128820, 127762, 95102, 128818, 123412, 124468, 123410, 126580, 124466, 126578, 115764, 117876, 115762, 122100, 117874, 122098, 100468, 104692, 100466, 113140, 104690, 113138, 69876, 78324, 69874, 95220, 78322, 95218, 129930, 94588, 94526, 127754, 128794, 123402, 124442, 126522, 115738, 117818, 121978, 100410, 104570, 112890, 69754, 78074, 94714, 94398, 123216, 127148, 123208, 127142, 123204, 123202, 115408, 123244, 115400, 123238, 115396, 115394, 99792, 115436, 99784, 115430, 99780, 99778, 68560, 99820, 68552, 99814, 68548, 68546, 68588, 68582, 127400, 129238, 72444, 127396, 72318, 127394, 123176, 127126, 123752, 123172, 123748, 123170, 123746, 115304, 123190, 116456, 115300, 116452, 115298, 116450, 99560, 115318, 101864, 99556, 101860, 99554, 101858, 68072, 99574, 72680, 68068, 72676, 68066, 72674, 68086, 72694, 129492, 80632, 105854, 129490, 80508, 80446, 127380, 72062, 127924, 127378, 80766, 127922, 123156, 123700, 123154, 124788, 123698, 124786, 115252, 116340, 115250, 118516, 116338, 118514, 99444, 101620, 99442, 105972, 101618, 105970, 67828, 72180, 67826, 80884, 72178, 80882, 97008, 114044, 96888, 113982, 96828, 96798, 129482, 80252, 130010, 97148, 80190, 97086, 127370, 127898, 128954, 123146, 123674, 124730, 126842, 115226, 116282, 118394, 122618, 99386, 101498, 105722, 114170, 67706, 71930, 80378, 96632, 113854, 96572, 96542, 80062, 96702, 96444, 96414, 96350, 123048, 123044, 123042, 115048, 123062, 115044, 115042, 99048, 115062, 99044, 99042, 67048, 99062, 67044, 67042, 67062, 127188, 68990, 127186, 123028, 123316, 123026, 123314, 114996, 115572, 114994, 115570, 98932, 100084, 98930, 100082, 66804, 69108, 66802, 69106, 129258, 73084, 73022, 127178, 127450, 123018, 123290, 123834, 114970, 115514, 116602, 98874, 99962, 102138, 66682, 68858, 73210, 81272, 106174, 81212, 81182, 72894, 81342, 97648, 114364, 97592, 114334, 97564, 97550, 81084, 97724, 81054, 97694, 97464, 114270, 97436, 97422, 80990, 97502, 97372, 97358, 97326, 114868, 114866, 98676, 98674, 66292, 66290, 123098, 114842, 115130, 98618, 99194, 66170, 67322, 69310, 73404, 73374, 81592, 106334, 81564, 81550, 73310, 81630, 97968, 114524, 97944, 114510, 97932, 97926, 81500, 98012, 81486, 97998, 97880, 114478, 97868, 97862, 81454, 97902, 97836, 97830, 69470, 73564, 73550, 81752, 106414, 81740, 81734, 73518, 81774, 81708, 81702]), $a([109536, 120312, 86976, 109040, 120060, 86496, 108792, 119934, 86256, 108668, 86136, 129744, 89056, 110072, 129736, 88560, 109820, 129732, 88312, 109694, 129730, 88188, 128464, 129772, 89592, 128456, 129766, 89340, 128452, 89214, 128450, 125904, 128492, 125896, 128486, 125892, 125890, 120784, 125932, 120776, 125926, 120772, 120770, 110544, 120812, 110536, 120806, 110532, 84928, 108016, 119548, 84448, 107768, 119422, 84208, 107644, 84088, 107582, 84028, 129640, 85488, 108284, 129636, 85240, 108158, 129634, 85116, 85054, 128232, 129654, 85756, 128228, 85630, 128226, 125416, 128246, 125412, 125410, 119784, 125430, 119780, 119778, 108520, 119798, 108516, 108514, 83424, 107256, 119166, 83184, 107132, 83064, 107070, 83004, 82974, 129588, 83704, 107390, 129586, 83580, 83518, 128116, 83838, 128114, 125172, 125170, 119284, 119282, 107508, 107506, 82672, 106876, 82552, 106814, 82492, 82462, 129562, 82812, 82750, 128058, 125050, 119034, 82296, 106686, 82236, 82206, 82366, 82108, 82078, 76736, 103920, 117500, 76256, 103672, 117374, 76016, 103548, 75896, 103486, 75836, 129384, 77296, 104188, 129380, 77048, 104062, 129378, 76924, 76862, 127720, 129398, 77564, 127716, 77438, 127714, 124392, 127734, 124388, 124386, 117736, 124406, 117732, 117730, 104424, 117750, 104420, 104418, 112096, 121592, 126334, 92608, 111856, 121468, 92384, 111736, 121406, 92272, 111676, 92216, 111646, 92188, 75232, 103160, 117118, 93664, 74992, 103036, 93424, 112252, 102974, 93304, 74812, 93244, 74782, 93214, 129332, 75512, 103294, 129908, 129330, 93944, 75388, 129906, 93820, 75326, 93758, 127604, 75646, 128756, 127602, 94078, 128754, 124148, 126452, 124146, 126450, 117236, 121844, 117234, 121842, 103412, 103410, 91584, 111344, 121212, 91360, 111224, 121150, 91248, 111164, 91192, 111134, 91164, 91150, 74480, 102780, 91888, 74360, 102718, 91768, 111422, 91708, 74270, 91678, 129306, 74620, 129850, 92028, 74558, 91966, 127546, 128634, 124026, 126202, 116986, 121338, 102906, 90848, 110968, 121022, 90736, 110908, 90680, 110878, 90652, 90638, 74104, 102590, 91000, 74044, 90940, 74014, 90910, 74174, 91070, 90480, 110780, 90424, 110750, 90396, 90382, 73916, 90556, 73886, 90526, 90296, 110686, 90268, 90254, 73822, 90334, 90204, 90190, 71136, 101112, 116094, 70896, 100988, 70776, 100926, 70716, 70686, 129204, 71416, 101246, 129202, 71292, 71230, 127348, 71550, 127346, 123636, 123634, 116212, 116210, 101364, 101362, 79296, 105200, 118140, 79072, 105080, 118078, 78960, 105020, 78904, 104990, 78876, 78862, 70384, 100732, 79600, 70264, 100670, 79480, 105278, 79420, 70174, 79390, 129178, 70524, 129466, 79740, 70462, 79678, 127290, 127866, 123514, 124666, 115962, 118266, 100858, 113376, 122232, 126654, 95424, 113264, 122172, 95328, 113208, 122142, 95280, 113180, 95256, 113166, 95244, 78560, 104824, 117950, 95968, 78448, 104764, 95856, 113468, 104734, 95800, 78364, 95772, 78350, 95758, 70008, 100542, 78712, 69948, 96120, 78652, 69918, 96060, 78622, 96030, 70078, 78782, 96190, 94912, 113008, 122044, 94816, 112952, 122014, 94768, 112924, 94744, 112910, 94732, 94726, 78192, 104636, 95088, 78136, 104606, 95032, 113054, 95004, 78094, 94990, 69820, 78268, 69790, 95164, 78238, 95134, 94560, 112824, 121950, 94512, 112796, 94488, 112782, 94476, 94470, 78008, 104542, 94648, 77980, 94620, 77966, 94606, 69726, 78046, 94686, 94384, 112732, 94360, 112718, 94348, 94342, 77916, 94428, 77902, 94414, 94296, 112686, 94284, 94278, 77870, 94318, 94252, 94246, 68336, 99708, 68216, 99646, 68156, 68126, 68476, 68414, 127162, 123258, 115450, 99834, 72416, 101752, 116414, 72304, 101692, 72248, 101662, 72220, 72206, 67960, 99518, 72568, 67900, 72508, 67870, 72478, 68030, 72638, 80576, 105840, 118460, 80480, 105784, 118430, 80432, 105756, 80408, 105742, 80396, 80390, 72048, 101564, 80752, 71992, 101534, 80696, 71964, 80668, 71950, 80654, 67772, 72124, 67742, 80828, 72094, 80798, 114016, 122552, 126814, 96832, 113968, 122524, 96800, 113944, 122510, 96784, 113932, 96776, 113926, 96772, 80224, 105656, 118366, 97120, 80176, 105628, 97072, 114076, 105614, 97048, 80140, 97036, 80134, 97030, 71864, 101470, 80312, 71836, 97208, 80284, 71822, 97180, 80270, 97166, 67678, 71902, 80350, 97246, 96576, 113840, 122460, 96544, 113816, 122446, 96528, 113804, 96520, 113798, 96516, 96514, 80048, 105564, 96688, 80024, 105550, 96664, 113870, 96652, 80006, 96646, 71772, 80092, 71758, 96732, 80078, 96718, 96416, 113752, 122414, 96400, 113740, 96392, 113734, 96388, 96386, 79960, 105518, 96472, 79948, 96460, 79942, 96454, 71726, 79982, 96494, 96336, 113708, 96328, 113702, 96324, 96322, 79916, 96364, 79910, 96358, 96296, 113686, 96292, 96290, 79894, 96310, 66936, 99006, 66876, 66846, 67006, 68976, 100028, 68920, 99998, 68892, 68878, 66748, 69052, 66718, 69022, 73056, 102072, 116574, 73008, 102044, 72984, 102030, 72972, 72966, 68792, 99934, 73144, 68764, 73116, 68750, 73102, 66654, 68830, 73182, 81216, 106160, 118620, 81184, 106136, 118606, 81168, 106124, 81160, 106118, 81156, 81154, 72880, 101980, 81328, 72856, 101966, 81304, 106190, 81292, 72838, 81286, 68700, 72924, 68686, 81372, 72910, 81358, 114336, 122712, 126894, 114320, 122700, 114312, 122694, 114308, 114306, 81056, 106072, 118574, 97696, 81040, 106060, 97680, 114380, 106054, 97672, 81028, 97668, 81026, 97666, 72792, 101934, 81112, 72780, 97752, 81100, 72774, 97740, 81094, 97734, 68654, 72814, 81134, 97774, 114256, 122668, 114248, 122662, 114244, 114242, 80976, 106028, 97488, 80968, 106022, 97480, 114278, 97476, 80962, 97474, 72748, 81004, 72742, 97516, 80998, 97510, 114216, 122646, 114212, 114210, 80936, 106006, 97384, 80932, 97380, 80930, 97378, 72726, 80950, 97398, 114196, 114194, 80916, 97332, 80914, 97330, 66236, 66206, 67256, 99166, 67228, 67214, 66142, 67294, 69296, 100188, 69272, 100174, 69260, 69254, 67164, 69340, 67150, 69326, 73376, 102232, 116654, 73360, 102220, 73352, 102214, 73348, 73346, 69208, 100142, 73432, 102254, 73420, 69190, 73414, 67118, 69230, 73454, 106320, 118700, 106312, 118694, 106308, 106306, 73296, 102188, 81616, 106348, 102182, 81608, 73284, 81604, 73282, 81602, 69164, 73324, 69158, 81644, 73318, 81638, 122792, 126934, 122788, 122786, 106280, 118678, 114536, 106276, 114532, 106274, 114530, 73256, 102166, 81512, 73252, 98024, 81508, 73250, 98020, 81506, 98018, 69142, 73270, 81526, 98038, 122772, 122770, 106260, 114484, 106258, 114482, 73236, 81460, 73234, 97908, 81458, 97906, 122762, 106250, 114458, 73226, 81434, 97850, 66396, 66382, 67416, 99246, 67404, 67398, 66350, 67438, 69456, 100268, 69448, 100262, 69444, 69442, 67372, 69484, 67366, 69478, 102312, 116694, 102308, 102306, 69416, 100246, 73576, 102326, 73572, 69410, 73570, 67350, 69430, 73590, 118740, 118738, 102292, 106420, 102290, 106418, 69396, 73524, 69394, 81780, 73522, 81778, 118730, 102282, 106394, 69386, 73498, 81722, 66476, 66470, 67496, 99286, 67492, 67490, 66454, 67510, 100308, 100306, 67476, 69556, 67474, 69554, 116714])]); /*14234*/
			$1.cwtobits = function() {
				var _EM = $get($1.clusters, $k[--$j]); /*14238*/
				$1.v = $get(_EM, $k[--$j]); /*14238*/
				$k[$j++] = Infinity; /*14239*/
				for (var _EP = 0, _EQ = 17; _EP < _EQ; _EP++) { /*14239*/
					$k[$j++] = 0; /*14239*/
				} /*14239*/
				var _ET = $cvrs($s(17), $1.v, 2); /*14239*/
				for (var _EU = 0, _EV = _ET.length; _EU < _EV; _EU++) { /*14239*/
					$k[$j++] = $get(_ET, _EU) - 48; /*14239*/
				} /*14239*/
				var _EX = $a(); /*14239*/
				$k[$j++] = $geti(_EX, _EX.length - 17, 17); /*14240*/
			}; /*14241*/
			if ($1.compact) { /*14247*/
				$1.rwid = (((17 * $1.c) + 17) + 17) + 1; /*14245*/
			} else { /*14247*/
				$1.rwid = ((((17 * $1.c) + 17) + 17) + 17) + 18; /*14247*/
			} /*14247*/
			$1.pixs = $a($1.rwid * $1.r); /*14249*/
			for (var _Eh = 0, _Eg = $1.r - 1; _Eh <= _Eg; _Eh += 1) { /*14279*/
				$1.i = _Eh; /*14252*/
				if (($1.i % 3) == 0) { /*14257*/
					$1.lcw = ((~~($1.i / 3)) * 30) + (~~(($1.r - 1) / 3)); /*14255*/
					$1.rcw = (((~~($1.i / 3)) * 30) + $1.c) - 1; /*14256*/
				} /*14256*/
				if (($1.i % 3) == 1) { /*14261*/
					$1.lcw = (((~~($1.i / 3)) * 30) + ($1.eclevel * 3)) + (($1.r - 1) % 3); /*14259*/
					$1.rcw = ((~~($1.i / 3)) * 30) + (~~(($1.r - 1) / 3)); /*14260*/
				} /*14260*/
				if (($1.i % 3) == 2) { /*14265*/
					$1.lcw = (((~~($1.i / 3)) * 30) + $1.c) - 1; /*14263*/
					$1.rcw = (((~~($1.i / 3)) * 30) + ($1.eclevel * 3)) + (($1.r - 1) % 3); /*14264*/
				} /*14264*/
				$k[$j++] = $1.pixs; /*14275*/
				$k[$j++] = $1.rwid * $1.i; /*14275*/
				$k[$j++] = Infinity; /*14275*/
				$k[$j++] = 1; /*14269*/
				$k[$j++] = 1; /*14269*/
				$k[$j++] = 1; /*14269*/
				$k[$j++] = 1; /*14269*/
				$k[$j++] = 1; /*14269*/
				$k[$j++] = 1; /*14269*/
				$k[$j++] = 1; /*14269*/
				$k[$j++] = 1; /*14269*/
				$k[$j++] = 0; /*14269*/
				$k[$j++] = 1; /*14269*/
				$k[$j++] = 0; /*14269*/
				$k[$j++] = 1; /*14269*/
				$k[$j++] = 0; /*14269*/
				$k[$j++] = 1; /*14269*/
				$k[$j++] = 0; /*14269*/
				$k[$j++] = 0; /*14269*/
				$k[$j++] = 0; /*14269*/
				$k[$j++] = $1.lcw; /*14269*/
				$k[$j++] = $1.i % 3; /*14269*/
				if ($1.cwtobits() == $b) break; /*14269*/
				$forall($k[--$j]); /*14269*/
				$forall($geti($1.cws, $1.c * $1.i, $1.c), function() { /*14270*/
					$k[$j++] = $1.i % 3; /*14270*/
					if ($1.cwtobits() == $b) return $b; /*14270*/
					$forall($k[--$j]); /*14270*/
				}); /*14270*/
				if ($1.compact) { /*14275*/
					$k[$j++] = 1; /*14272*/
				} else { /*14275*/
					$k[$j++] = $1.rcw; /*14274*/
					$k[$j++] = $1.i % 3; /*14274*/
					if ($1.cwtobits() == $b) break; /*14274*/
					$forall($k[--$j]); /*14274*/
					$k[$j++] = 1; /*14275*/
					$k[$j++] = 1; /*14275*/
					$k[$j++] = 1; /*14275*/
					$k[$j++] = 1; /*14275*/
					$k[$j++] = 1; /*14275*/
					$k[$j++] = 1; /*14275*/
					$k[$j++] = 1; /*14275*/
					$k[$j++] = 0; /*14275*/
					$k[$j++] = 1; /*14275*/
					$k[$j++] = 0; /*14275*/
					$k[$j++] = 0; /*14275*/
					$k[$j++] = 0; /*14275*/
					$k[$j++] = 1; /*14275*/
					$k[$j++] = 0; /*14275*/
					$k[$j++] = 1; /*14275*/
					$k[$j++] = 0; /*14275*/
					$k[$j++] = 0; /*14275*/
					$k[$j++] = 1; /*14275*/
				} /*14275*/
				var _FG = $a(); /*14275*/
				var _FH = $k[--$j]; /*14277*/
				$puti($k[--$j], _FH, _FG); /*14277*/
			} /*14277*/
			var _FQ = {
				ren: $0.renmatrix,
				pixs: $1.pixs,
				pixx: $1.rwid,
				pixy: $1.r,
				height: ($1.r / 72) * $1.rowmult,
				width: $1.rwid / 72,
				opt: $1.options
			}; /*14289*/
			$k[$j++] = _FQ; /*14292*/
			if (!$1.dontdraw) { /*14292*/
				$0.renmatrix(); /*14292*/
			} /*14292*/
		};
		$0.pdf417compact = function() {
			var $1 = {}; /*14320*/
			$1.options = $k[--$j]; /*14322*/
			$1.barcode = $k[--$j]; /*14323*/
			$1.dontdraw = false; /*14325*/
			$forall($1.options, function() { /*14336*/
				var _3 = $k[--$j]; /*14336*/
				$1[$k[--$j]] = _3; /*14336*/
			}); /*14336*/
			$1.options.dontdraw = true; /*14339*/
			$1.options.compact = true; /*14340*/
			$k[$j++] = "args"; /*14342*/
			$k[$j++] = $1.barcode; /*14342*/
			$k[$j++] = $1.options; /*14342*/
			$0.pdf417(); /*14342*/
			var _9 = $k[--$j]; /*14342*/
			$1[$k[--$j]] = _9; /*14342*/
			$1.args.opt = $1.options; /*14344*/
			$k[$j++] = $1.args; /*14347*/
			if (!$1.dontdraw) { /*14347*/
				$0.renmatrix(); /*14347*/
			} /*14347*/
		};
		$0.micropdf417 = function() {
			var $1 = {}; /*14374*/
			$1.options = $k[--$j]; /*14376*/
			$1.barcode = $k[--$j]; /*14377*/
			$1.dontdraw = false; /*14379*/
			$1.version = "unset"; /*14380*/
			$1.columns = 0; /*14381*/
			$1.rows = 0; /*14382*/
			$1.rowmult = 2; /*14383*/
			$1.encoding = "auto"; /*14384*/
			$1.cca = false; /*14385*/
			$1.ccb = false; /*14386*/
			$1.raw = false; /*14387*/
			$1.parse = false; /*14388*/
			$forall($1.options, function() { /*14399*/
				var _3 = $k[--$j]; /*14399*/
				$1[$k[--$j]] = _3; /*14399*/
			}); /*14399*/
			if ($ne($1.version, "unset")) { /*14405*/
				$search($1.version, "x"); /*14402*/
				$j--; /*14403*/
				$1.columns = $k[--$j]; /*14403*/
				$j--; /*14404*/
				$1.rows = $k[--$j]; /*14404*/
			} /*14404*/
			$1.columns = ~~$z($1.columns); /*14407*/
			$1.rows = ~~$z($1.rows); /*14408*/
			$1.rowmult = +$1.rowmult; /*14409*/
			if ($1.raw) { /*14432*/
				$1.encoding = "raw"; /*14432*/
			} /*14432*/
			if ($1.cca) { /*14433*/
				$1.encoding = "cca"; /*14433*/
			} /*14433*/
			if ($eq($1.encoding, "raw") || $eq($1.encoding, "cca")) { /*14447*/
				$1.datcws = $a($1.barcode.length); /*14437*/
				$1.i = 0; /*14438*/
				$1.j = 0; /*14438*/
				for (;;) { /*14445*/
					if ($1.i == $1.barcode.length) { /*14440*/
						break; /*14440*/
					} /*14440*/
					$1.cw = ~~$z($geti($1.barcode, $1.i + 1, 3)); /*14441*/
					$put($1.datcws, $1.j, $1.cw); /*14442*/
					$1.i = $1.i + 4; /*14443*/
					$1.j = $1.j + 1; /*14444*/
				} /*14444*/
				$1.datcws = $geti($1.datcws, 0, $1.j); /*14446*/
			} /*14446*/
			$k[$j++] = Infinity; /*14449*/
			$forall($1.barcode); /*14449*/
			$1.barcode = $a(); /*14449*/
			$1.barlen = $1.barcode.length; /*14450*/
			if ($1.ccb) { /*14452*/
				$1.encoding = "ccb"; /*14452*/
			} /*14452*/
			$1.encb = function() {
				$1.in = $k[--$j]; /*14455*/
				$1.inlen = $1.in.length; /*14456*/
				$1.out = $a(((~~($1.inlen / 6)) * 5) + ($1.inlen % 6)); /*14457*/
				for (var _g = 0, _f = (~~($1.inlen / 6)) - 1; _g <= _f; _g += 1) { /*14480*/
					$1.k = _g; /*14459*/
					$k[$j++] = Infinity; /*14460*/
					$aload($geti($1.in, $1.k * 6, 3)); /*14460*/
					$1.msbs = $a(); /*14460*/
					$k[$j++] = Infinity; /*14464*/
					$aload($1.msbs); /*14462*/
					var _m = $k[--$j]; /*14462*/
					var _n = $k[--$j]; /*14462*/
					var _o = $k[--$j]; /*14462*/
					$k[$j++] = (_m + (_n * 256)) + (_o * 65536); /*14463*/
					for (var _p = 0, _q = 3; _p < _q; _p++) { /*14463*/
						var _r = $k[--$j]; /*14463*/
						$k[$j++] = _r % 900; /*14463*/
						$k[$j++] = ~~(_r / 900); /*14463*/
					} /*14463*/
					$1.mscs = $a(); /*14464*/
					$k[$j++] = Infinity; /*14465*/
					$aload($geti($1.in, ($1.k * 6) + 3, 3)); /*14465*/
					$1.lsbs = $a(); /*14465*/
					$k[$j++] = Infinity; /*14469*/
					$aload($1.lsbs); /*14467*/
					var _y = $k[--$j]; /*14467*/
					var _z = $k[--$j]; /*14467*/
					var _10 = $k[--$j]; /*14467*/
					$k[$j++] = (_y + (_z * 256)) + (_10 * 65536); /*14468*/
					for (var _11 = 0, _12 = 3; _11 < _12; _11++) { /*14468*/
						var _13 = $k[--$j]; /*14468*/
						$k[$j++] = _13 % 900; /*14468*/
						$k[$j++] = ~~(_13 / 900); /*14468*/
					} /*14468*/
					$1.lscs = $a(); /*14469*/
					var _16 = $get($1.lscs, 0); /*14470*/
					var _18 = $get($1.mscs, 0); /*14470*/
					$put($1.out, ($1.k * 5) + 4, (_16 + (_18 * 316)) % 900); /*14471*/
					var _1C = $get($1.lscs, 1); /*14472*/
					var _1E = $get($1.mscs, 0); /*14472*/
					var _1G = $get($1.mscs, 1); /*14472*/
					$put($1.out, ($1.k * 5) + 3, ((((~~((_16 + (_18 * 316)) / 900)) + _1C) + (_1E * 641)) + (_1G * 316)) % 900); /*14473*/
					var _1K = $get($1.lscs, 2); /*14474*/
					var _1M = $get($1.mscs, 0); /*14474*/
					var _1O = $get($1.mscs, 1); /*14474*/
					var _1Q = $get($1.mscs, 2); /*14474*/
					$put($1.out, ($1.k * 5) + 2, (((((~~(((((~~((_16 + (_18 * 316)) / 900)) + _1C) + (_1E * 641)) + (_1G * 316)) / 900)) + _1K) + (_1M * 20)) + (_1O * 641)) + (_1Q * 316)) % 900); /*14475*/
					var _1U = $get($1.lscs, 3); /*14476*/
					var _1W = $get($1.mscs, 1); /*14476*/
					var _1Y = $get($1.mscs, 2); /*14476*/
					$put($1.out, ($1.k * 5) + 1, ((((~~((((((~~(((((~~((_16 + (_18 * 316)) / 900)) + _1C) + (_1E * 641)) + (_1G * 316)) / 900)) + _1K) + (_1M * 20)) + (_1O * 641)) + (_1Q * 316)) / 900)) + _1U) + (_1W * 20)) + (_1Y * 641)) % 900); /*14477*/
					$put($1.out, $1.k * 5, ((~~(((((~~((((((~~(((((~~((_16 + (_18 * 316)) / 900)) + _1C) + (_1E * 641)) + (_1G * 316)) / 900)) + _1K) + (_1M * 20)) + (_1O * 641)) + (_1Q * 316)) / 900)) + _1U) + (_1W * 20)) + (_1Y * 641)) / 900)) + ($get($1.mscs, 2) * 20)) % 900); /*14479*/
				} /*14479*/
				$1.rem = $1.inlen % 6; /*14481*/
				if ($1.rem != 0) { /*14486*/
					$k[$j++] = $1.out; /*14484*/
					$k[$j++] = $1.out.length - $1.rem; /*14484*/
					$k[$j++] = Infinity; /*14484*/
					$aload($geti($1.in, $1.inlen - $1.rem, $1.rem)); /*14484*/
					var _1p = $a(); /*14484*/
					var _1q = $k[--$j]; /*14485*/
					$puti($k[--$j], _1q, _1p); /*14485*/
				} /*14485*/
				$k[$j++] = $1.out; /*14487*/
			}; /*14488*/
			if ($eq($1.encoding, "byte") || $eq($1.encoding, "ccb")) { /*14495*/
				$1.datcws = $a((((~~($1.barlen / 6)) * 5) + ($1.barlen % 6)) + 1); /*14491*/
				var _20 = (($1.barlen % 6) == 0) ? 924 : 901; /*14492*/
				$put($1.datcws, 0, _20); /*14492*/
				$k[$j++] = $1.datcws; /*14493*/
				$k[$j++] = 1; /*14493*/
				$k[$j++] = $1.barcode; /*14493*/
				if ($1.encb() == $b) return $b; /*14493*/
				var _23 = $k[--$j]; /*14493*/
				var _24 = $k[--$j]; /*14493*/
				$puti($k[--$j], _24, _23); /*14493*/
				if ($eq($1.encoding, "ccb")) { /*14494*/
					$k[$j++] = Infinity; /*14494*/
					$k[$j++] = 920; /*14494*/
					$aload($1.datcws); /*14494*/
					$1.datcws = $a(); /*14494*/
				} /*14494*/
			} /*14494*/
			if ($eq($1.encoding, "auto")) { /*14859*/
				$1.T = 0; /*14500*/
				$1.N = 1; /*14500*/
				$1.B = 2; /*14500*/
				$1.A = 0; /*14501*/
				$1.L = 1; /*14501*/
				$1.M = 2; /*14501*/
				$1.P = 3; /*14501*/
				$1.tl = -1; /*14504*/
				$1.nl = -2; /*14504*/
				$1.bl = -3; /*14504*/
				$1.bl6 = -4; /*14504*/
				$1.bs = -5; /*14504*/
				$1.al = -6; /*14507*/
				$1.ll = -7; /*14507*/
				$1.ml = -8; /*14507*/
				$1.pl = -9; /*14507*/
				$1.as = -10; /*14507*/
				$1.ps = -11; /*14507*/
				$1.charmaps = $a([$a(["A", "a", "0", ";"]), $a(["B", "b", "1", "<"]), $a(["C", "c", "2", ">"]), $a(["D", "d", "3", "@"]), $a(["E", "e", "4", "["]), $a(["F", "f", "5", 92]), $a(["G", "g", "6", "]"]), $a(["H", "h", "7", "_"]), $a(["I", "i", "8", "`"]), $a(["J", "j", "9", "~"]), $a(["K", "k", "&", "!"]), $a(["L", "l", 13, 13]), $a(["M", "m", 9, 9]), $a(["N", "n", ",", ","]), $a(["O", "o", ":", ":"]), $a(["P", "p", "#", 10]), $a(["Q", "q", "-", "-"]), $a(["R", "r", ".", "."]), $a(["S", "s", "$", "$"]), $a(["T", "t", "/", "/"]), $a(["U", "u", "+", "\""]), $a(["V", "v", "%", "|"]), $a(["W", "w", "*", "*"]), $a(["X", "x", "=", 40]), $a(["Y", "y", "^", 41]), $a(["Z", "z", $1.pl, "?"]), $a([" ", " ", " ", "{"]), $a([$1.ll, $1.as, $1.ll, "}"]), $a([$1.ml, $1.ml, $1.al, "'"]), $a([$1.ps, $1.ps, $1.ps, $1.al])]); /*14542*/
				$1.charvals = $a([{}, {}, {}, {}]); /*14545*/
				$1.alltext = {}; /*14546*/
				for (var _2t = 0, _2s = $1.charmaps.length - 1; _2t <= _2s; _2t += 1) { /*14556*/
					$1.i = _2t; /*14548*/
					$1.encs = $get($1.charmaps, $1.i); /*14549*/
					for (var _2x = 0; _2x <= 3; _2x += 1) { /*14555*/
						$1.j = _2x; /*14551*/
						var _30 = $get($1.encs, $1.j); /*14552*/
						$k[$j++] = _30; /*14552*/
						if ($eq($type(_30), "stringtype")) { /*14552*/
							var _33 = $get($k[--$j], 0); /*14552*/
							$k[$j++] = _33; /*14552*/
						} /*14552*/
						var _34 = $k[--$j]; /*14553*/
						$put($get($1.charvals, $1.j), _34, $1.i); /*14553*/
						$put($1.alltext, _34, -1); /*14554*/
					} /*14554*/
				} /*14554*/
				$1.e = 10000; /*14558*/
				$1.latlen = $a([$a([0, 1, 1, 2]), $a([2, 0, 1, 2]), $a([1, 1, 0, 1]), $a([1, 2, 2, 0])]); /*14566*/
				$1.latseq = $a([$a([$a([]), $a([$1.ll]), $a([$1.ml]), $a([$1.ml, $1.pl])]), $a([$a([$1.ml, $1.al]), $a([]), $a([$1.ml]), $a([$1.ml, $1.pl])]), $a([$a([$1.al]), $a([$1.ll]), $a([]), $a([$1.pl])]), $a([$a([$1.al]), $a([$1.al, $1.ll]), $a([$1.al, $1.ml]), $a([])])]); /*14574*/
				$1.shftlen = $a([$a([$1.e, $1.e, $1.e, 1]), $a([1, $1.e, $1.e, 1]), $a([$1.e, $1.e, $1.e, 1]), $a([$1.e, $1.e, $1.e, $1.e])]); /*14582*/
				$k[$j++] = Infinity; /*14585*/
				for (var _49 = 0, _4A = $1.barlen; _49 < _4A; _49++) { /*14585*/
					$k[$j++] = 0; /*14585*/
				} /*14585*/
				$k[$j++] = 0; /*14585*/
				$1.numdigits = $a(); /*14585*/
				$k[$j++] = Infinity; /*14586*/
				for (var _4D = 0, _4E = $1.barlen; _4D < _4E; _4D++) { /*14586*/
					$k[$j++] = 0; /*14586*/
				} /*14586*/
				$k[$j++] = 0; /*14586*/
				$1.numtext = $a(); /*14586*/
				$k[$j++] = Infinity; /*14587*/
				for (var _4H = 0, _4I = $1.barlen; _4H < _4I; _4H++) { /*14587*/
					$k[$j++] = 0; /*14587*/
				} /*14587*/
				$k[$j++] = 0; /*14587*/
				$1.numbytes = $a(); /*14587*/
				for (var _4L = $1.barlen - 1; _4L >= 0; _4L -= 1) { /*14599*/
					$1.i = _4L; /*14589*/
					var _4O = $get($1.barcode, $1.i); /*14590*/
					if ((_4O >= 48) && (_4O <= 57)) { /*14592*/
						$put($1.numdigits, $1.i, $get($1.numdigits, $1.i + 1) + 1); /*14591*/
					} /*14591*/
					var _4Y = $get($1.alltext, $get($1.barcode, $1.i)) !== undefined; /*14593*/
					if (_4Y && ($get($1.numdigits, $1.i) < 13)) { /*14595*/
						$put($1.numtext, $1.i, $get($1.numtext, $1.i + 1) + 1); /*14594*/
					} /*14594*/
					if (($get($1.numtext, $1.i) < 5) && ($get($1.numdigits, $1.i) < 13)) { /*14598*/
						$put($1.numbytes, $1.i, $get($1.numbytes, $1.i + 1) + 1); /*14597*/
					} /*14597*/
				} /*14597*/
				$1.numdigits = $geti($1.numdigits, 0, $1.barlen); /*14600*/
				$1.numtext = $geti($1.numtext, 0, $1.barlen); /*14601*/
				$1.numbytes = $geti($1.numbytes, 0, $1.barlen); /*14602*/
				$1.seq = $a([]); /*14604*/
				$1.seqlen = 0; /*14604*/
				$1.state = $1.B; /*14604*/
				$1.p = 0; /*14604*/
				for (;;) { /*14647*/
					if ($1.p == $1.barlen) { /*14605*/
						break; /*14605*/
					} /*14605*/
					$1.n = $get($1.numdigits, $1.p); /*14606*/
					if ($1.n >= 13) { /*14645*/
						$k[$j++] = Infinity; /*14612*/
						$aload($1.seq); /*14609*/
						$k[$j++] = $1.nl; /*14611*/
						$k[$j++] = Infinity; /*14611*/
						$aload($geti($1.barcode, $1.p, $1.n)); /*14611*/
						var _5F = $a(); /*14611*/
						$k[$j++] = _5F; /*14611*/
						$1.seq = $a(); /*14612*/
						$1.state = $1.N; /*14613*/
						$1.p = $1.p + $1.n; /*14614*/
						$1.seqlen = ($1.seqlen + 1) + $1.n; /*14615*/
					} else { /*14645*/
						$1.t = $get($1.numtext, $1.p); /*14617*/
						if ($1.t >= 5) { /*14645*/
							$k[$j++] = Infinity; /*14623*/
							$aload($1.seq); /*14620*/
							if ($1.state != $1.T) { /*14621*/
								$k[$j++] = $1.tl; /*14621*/
							} /*14621*/
							$k[$j++] = Infinity; /*14622*/
							$aload($geti($1.barcode, $1.p, $1.t)); /*14622*/
							var _5Y = $a(); /*14622*/
							$k[$j++] = _5Y; /*14622*/
							$1.seq = $a(); /*14623*/
							$1.state = $1.T; /*14624*/
							$1.p = $1.p + $1.t; /*14625*/
							$1.seqlen = ($1.seqlen + 1) + $1.t; /*14626*/
						} else { /*14645*/
							$1.b = $get($1.numbytes, $1.p); /*14628*/
							if (($1.b == 1) && ($1.state == $1.T)) { /*14645*/
								$k[$j++] = Infinity; /*14634*/
								$aload($1.seq); /*14631*/
								$k[$j++] = $1.bs; /*14633*/
								$k[$j++] = $a([$get($1.barcode, $1.p)]); /*14633*/
								$1.seq = $a(); /*14634*/
								$1.p = $1.p + $1.b; /*14635*/
								$1.seqlen = $1.seqlen + 2; /*14636*/
							} else { /*14645*/
								$k[$j++] = Infinity; /*14642*/
								$aload($1.seq); /*14639*/
								var _5x = (($1.b % 6) != 0) ? $1.bl : $1.bl6; /*14640*/
								$k[$j++] = _5x; /*14641*/
								$k[$j++] = Infinity; /*14641*/
								$aload($geti($1.barcode, $1.p, $1.b)); /*14641*/
								var _62 = $a(); /*14641*/
								$k[$j++] = _62; /*14641*/
								$1.seq = $a(); /*14642*/
								$1.state = $1.B; /*14643*/
								$1.p = $1.p + $1.b; /*14644*/
								$1.seqlen = ($1.seqlen + 1) + $1.b; /*14645*/
							} /*14645*/
						} /*14645*/
					} /*14645*/
				} /*14645*/
				$k[$j++] = "latchcws"; /*14650*/
				$k[$j++] = Infinity; /*14650*/
				$k[$j++] = $1.tl; /*14650*/
				$k[$j++] = 900; /*14650*/
				$k[$j++] = $1.bl; /*14650*/
				$k[$j++] = 901; /*14650*/
				$k[$j++] = $1.bl6; /*14650*/
				$k[$j++] = 924; /*14650*/
				$k[$j++] = $1.nl; /*14650*/
				$k[$j++] = 902; /*14650*/
				$k[$j++] = $1.bs; /*14650*/
				$k[$j++] = 913; /*14650*/
				var _6E = $d(); /*14650*/
				$1[$k[--$j]] = _6E; /*14651*/
				$1.enca = function() {
					var _6K = $get($get($1.charvals, $1.A), $k[--$j]); /*14654*/
					$k[$j++] = _6K; /*14654*/
				}; /*14654*/
				$1.encl = function() {
					var _6P = $get($get($1.charvals, $1.L), $k[--$j]); /*14655*/
					$k[$j++] = _6P; /*14655*/
				}; /*14655*/
				$1.encm = function() {
					var _6U = $get($get($1.charvals, $1.M), $k[--$j]); /*14656*/
					$k[$j++] = _6U; /*14656*/
				}; /*14656*/
				$1.encp = function() {
					var _6Z = $get($get($1.charvals, $1.P), $k[--$j]); /*14657*/
					$k[$j++] = _6Z; /*14657*/
				}; /*14657*/
				$1.textencfuncs = $a(["enca", "encl", "encm", "encp"]); /*14658*/
				$1.addtotext = function() {
					$put($1.text, $1.l, $k[--$j]); /*14661*/
					$1.l = $1.l + 1; /*14662*/
				}; /*14663*/
				$1.enct = function() {
					$1.in = $k[--$j]; /*14667*/
					$1.curlen = $a([$1.e, $1.e, $1.e, $1.e]); /*14669*/
					$put($1.curlen, $1.submode, 0); /*14670*/
					$1.curseq = $a([$a([]), $a([]), $a([]), $a([])]); /*14671*/
					$forall($1.in, function() { /*14741*/
						$1.char = $k[--$j]; /*14676*/
						for (;;) { /*14697*/
							$1.imp = false; /*14680*/
							var _6y = $a([$1.A, $1.L, $1.M, $1.P]); /*14681*/
							for (var _6z = 0, _70 = _6y.length; _6z < _70; _6z++) { /*14695*/
								$1.x = $get(_6y, _6z); /*14682*/
								var _76 = $a([$1.A, $1.L, $1.M, $1.P]); /*14683*/
								for (var _77 = 0, _78 = _76.length; _77 < _78; _77++) { /*14694*/
									$1.y = $get(_76, _77); /*14684*/
									$1.cost = $get($1.curlen, $1.x) + $get($get($1.latlen, $1.x), $1.y); /*14685*/
									if ($1.cost < $get($1.curlen, $1.y)) { /*14693*/
										$put($1.curlen, $1.y, $1.cost); /*14687*/
										$k[$j++] = $1.curseq; /*14690*/
										$k[$j++] = $1.y; /*14690*/
										$k[$j++] = Infinity; /*14690*/
										$aload($get($1.curseq, $1.x)); /*14689*/
										$aload($get($get($1.latseq, $1.x), $1.y)); /*14690*/
										var _7Z = $a(); /*14690*/
										var _7a = $k[--$j]; /*14691*/
										$put($k[--$j], _7a, _7Z); /*14691*/
										$1.imp = true; /*14692*/
									} /*14692*/
								} /*14692*/
							} /*14692*/
							if (!$1.imp) { /*14696*/
								break; /*14696*/
							} /*14696*/
						} /*14696*/
						$1.nxtlen = $a([$1.e, $1.e, $1.e, $1.e]); /*14700*/
						$1.nxtseq = $a(4); /*14701*/
						var _7n = $a([$1.A, $1.L, $1.M, $1.P]); /*14703*/
						for (var _7o = 0, _7p = _7n.length; _7o < _7p; _7o++) { /*14736*/
							$1.x = $get(_7n, _7o); /*14704*/
							for (;;) { /*14734*/
								var _7v = $get($get($1.charvals, $1.x), $1.char) !== undefined; /*14708*/
								if (!_7v) { /*14708*/
									break; /*14708*/
								} /*14708*/
								$1.cost = $get($1.curlen, $1.x) + 1; /*14711*/
								if ($1.cost < $get($1.nxtlen, $1.x)) { /*14715*/
									$put($1.nxtlen, $1.x, $1.cost); /*14713*/
									$k[$j++] = $1.nxtseq; /*14714*/
									$k[$j++] = $1.x; /*14714*/
									$k[$j++] = Infinity; /*14714*/
									$aload($get($1.curseq, $1.x)); /*14714*/
									$k[$j++] = $1.char; /*14714*/
									var _8C = $a(); /*14714*/
									var _8D = $k[--$j]; /*14714*/
									$put($k[--$j], _8D, _8C); /*14714*/
								} /*14714*/
								var _8J = $a([$1.A, $1.L, $1.M, $1.P]); /*14718*/
								for (var _8K = 0, _8L = _8J.length; _8K < _8L; _8K++) { /*14731*/
									$1.y = $get(_8J, _8K); /*14719*/
									if ($ne($1.x, $1.y)) { /*14730*/
										$1.cost = ($get($1.curlen, $1.y) + $get($get($1.shftlen, $1.y), $1.x)) + 1; /*14721*/
										if ($1.cost < $get($1.nxtlen, $1.y)) { /*14729*/
											$put($1.nxtlen, $1.y, $1.cost); /*14723*/
											$k[$j++] = $1.nxtseq; /*14727*/
											$k[$j++] = $1.y; /*14727*/
											$k[$j++] = Infinity; /*14727*/
											$aload($get($1.curseq, $1.y)); /*14725*/
											var _8l = ($1.x == $1.A) ? $1.as : $1.ps; /*14726*/
											$k[$j++] = _8l; /*14727*/
											$k[$j++] = $1.char; /*14727*/
											var _8n = $a(); /*14727*/
											var _8o = $k[--$j]; /*14728*/
											$put($k[--$j], _8o, _8n); /*14728*/
										} /*14728*/
									} /*14728*/
								} /*14728*/
								break; /*14733*/
							} /*14733*/
						} /*14733*/
						$1.curlen = $1.nxtlen; /*14738*/
						$1.curseq = $1.nxtseq; /*14739*/
					}); /*14739*/
					$1.minseq = $1.e; /*14744*/
					var _8x = $a([$1.A, $1.L, $1.M, $1.P]); /*14745*/
					for (var _8y = 0, _8z = _8x.length; _8y < _8z; _8y++) { /*14751*/
						$1.k = $get(_8x, _8y); /*14746*/
						if ($get($1.curlen, $1.k) < $1.minseq) { /*14750*/
							$1.minseq = $get($1.curlen, $1.k); /*14748*/
							$1.txtseq = $get($1.curseq, $1.k); /*14749*/
						} /*14749*/
					} /*14749*/
					$1.text = $a($1.minseq); /*14754*/
					$1.k = 0; /*14755*/
					$1.l = 0; /*14755*/
					for (;;) { /*14775*/
						if ($1.k >= $1.txtseq.length) { /*14756*/
							break; /*14756*/
						} /*14756*/
						$1.char = $get($1.txtseq, $1.k); /*14758*/
						$k[$j++] = $1.char; /*14761*/
						$1[$get($1.textencfuncs, $1.submode)](); /*14761*/
						if ($1.addtotext() == $b) break; /*14761*/
						$1.k = $1.k + 1; /*14762*/
						if (($1.char == $1.as) || ($1.char == $1.ps)) { /*14768*/
							$k[$j++] = $get($1.txtseq, $1.k); /*14766*/
							if ($1.char == $1.as) { /*14766*/
								if ($1.enca() == $b) break; /*14766*/
							} else { /*14766*/
								if ($1.encp() == $b) break; /*14766*/
							} /*14766*/
							if ($1.addtotext() == $b) break; /*14766*/
							$1.k = $1.k + 1; /*14767*/
						} /*14767*/
						if ($1.char == $1.al) { /*14771*/
							$1.submode = $1.A; /*14771*/
						} /*14771*/
						if ($1.char == $1.ll) { /*14772*/
							$1.submode = $1.L; /*14772*/
						} /*14772*/
						if ($1.char == $1.ml) { /*14773*/
							$1.submode = $1.M; /*14773*/
						} /*14773*/
						if ($1.char == $1.pl) { /*14774*/
							$1.submode = $1.P; /*14774*/
						} /*14774*/
					} /*14774*/
					if (($1.text.length % 2) == 1) { /*14785*/
						if ($1.submode == $1.P) { /*14782*/
							$k[$j++] = "pad"; /*14779*/
							$k[$j++] = $1.al; /*14779*/
							if ($1.encp() == $b) return $b; /*14779*/
							var _9o = $k[--$j]; /*14779*/
							$1[$k[--$j]] = _9o; /*14779*/
							$1.submode = $1.A; /*14780*/
						} else { /*14782*/
							$k[$j++] = "pad"; /*14782*/
							$k[$j++] = $1.ps; /*14782*/
							$1[$get($1.textencfuncs, $1.submode)](); /*14782*/
							var _9w = $k[--$j]; /*14782*/
							$1[$k[--$j]] = _9w; /*14782*/
						} /*14782*/
						$k[$j++] = Infinity; /*14784*/
						$aload($1.text); /*14784*/
						$k[$j++] = $1.pad; /*14784*/
						$1.text = $a(); /*14784*/
					} /*14784*/
					$1.out = $a(~~($1.text.length / 2)); /*14787*/
					for (var _A5 = 0, _A4 = $1.out.length - 1; _A5 <= _A4; _A5 += 1) { /*14791*/
						$1.k = _A5; /*14789*/
						$put($1.out, $1.k, ($get($1.text, $1.k * 2) * 30) + $get($1.text, ($1.k * 2) + 1)); /*14790*/
					} /*14790*/
					$k[$j++] = $1.out; /*14793*/
				}; /*14795*/
				$1.encn = function() {
					$1.in = $k[--$j]; /*14798*/
					$1.out = $a([]); /*14799*/
					for (var _AJ = 0, _AI = $1.in.length - 1; _AJ <= _AI; _AJ += 44) { /*14827*/
						$1.k = _AJ; /*14801*/
						$k[$j++] = Infinity; /*14805*/
						var _AO = $1.in.length - $1.k; /*14803*/
						$k[$j++] = 1; /*14803*/
						$k[$j++] = $1.in; /*14803*/
						$k[$j++] = $1.k; /*14803*/
						$k[$j++] = _AO; /*14803*/
						if (_AO > 44) { /*14803*/
							$j--; /*14803*/
							$k[$j++] = 44; /*14803*/
						} /*14803*/
						var _AP = $k[--$j]; /*14803*/
						var _AQ = $k[--$j]; /*14803*/
						$forall($geti($k[--$j], _AQ, _AP), function() { /*14804*/
							var _AT = $k[--$j]; /*14804*/
							$k[$j++] = _AT - 48; /*14804*/
						}); /*14804*/
						$1.gmod = $a(); /*14805*/
						$1.cwn = $a([]); /*14806*/
						for (;;) { /*14825*/
							$1.dv = 900; /*14807*/
							$1.gmul = $a([]); /*14808*/
							$1.val = 0; /*14808*/
							for (;;) { /*14820*/
								if ($1.gmod.length == 0) { /*14809*/
									break; /*14809*/
								} /*14809*/
								$1.val = ($1.val * 10) + $get($1.gmod, 0); /*14810*/
								$1.gmod = $geti($1.gmod, 1, $1.gmod.length - 1); /*14811*/
								if ($1.val < $1.dv) { /*14817*/
									if ($1.gmul.length != 0) { /*14815*/
										$k[$j++] = Infinity; /*14814*/
										$aload($1.gmul); /*14814*/
										$k[$j++] = 0; /*14814*/
										$1.gmul = $a(); /*14814*/
									} /*14814*/
								} else { /*14817*/
									$k[$j++] = Infinity; /*14817*/
									$aload($1.gmul); /*14817*/
									$k[$j++] = ~~($1.val / $1.dv); /*14817*/
									$1.gmul = $a(); /*14817*/
								} /*14817*/
								$1.val = $1.val % $1.dv; /*14819*/
							} /*14819*/
							$1.dv = $1.val; /*14821*/
							$k[$j++] = Infinity; /*14822*/
							$k[$j++] = $1.dv; /*14822*/
							$aload($1.cwn); /*14822*/
							$1.cwn = $a(); /*14822*/
							$1.gmod = $1.gmul; /*14823*/
							if ($1.gmul.length == 0) { /*14824*/
								break; /*14824*/
							} /*14824*/
						} /*14824*/
						$k[$j++] = Infinity; /*14826*/
						$aload($1.out); /*14826*/
						$aload($1.cwn); /*14826*/
						$1.out = $a(); /*14826*/
					} /*14826*/
					$k[$j++] = $1.out; /*14828*/
				}; /*14829*/
				$1.encfuncs = $a(["enct", "encn", "encb"]); /*14831*/
				$1.addtocws = function() {
					var _B0 = $k[--$j]; /*14834*/
					$puti($1.datcws, $1.j, _B0); /*14834*/
					$1.j = _B0.length + $1.j; /*14835*/
				}; /*14836*/
				$1.state = $1.T; /*14839*/
				$1.submode = $1.A; /*14839*/
				$1.datcws = $a($1.seqlen); /*14840*/
				$1.i = 0; /*14841*/
				$1.j = 0; /*14841*/
				for (;;) { /*14857*/
					if ($1.i >= $1.seq.length) { /*14842*/
						break; /*14842*/
					} /*14842*/
					$1.chars = $get($1.seq, $1.i); /*14843*/
					if ($eq($type($1.chars), "arraytype")) { /*14853*/
						$k[$j++] = $1.chars; /*14845*/
						$1[$get($1.encfuncs, $1.state)](); /*14845*/
						if ($1.addtocws() == $b) break; /*14845*/
					} else { /*14853*/
						$k[$j++] = $a([$get($1.latchcws, $1.chars)]); /*14847*/
						if ($1.addtocws() == $b) break; /*14847*/
						if ($1.chars == $1.tl) { /*14848*/
							$1.state = $1.T; /*14848*/
							$1.submode = $1.A; /*14848*/
						} /*14848*/
						if ($1.chars == $1.nl) { /*14849*/
							$1.state = $1.N; /*14849*/
						} /*14849*/
						if (($1.chars == $1.bl) || ($1.chars == $1.bl6)) { /*14850*/
							$1.state = $1.B; /*14850*/
						} /*14850*/
						if ($1.chars == $1.bs) { /*14854*/
							$1.i = $1.i + 1; /*14852*/
							$k[$j++] = $get($1.seq, $1.i); /*14853*/
							if ($1.encb() == $b) break; /*14853*/
							if ($1.addtocws() == $b) break; /*14853*/
						} /*14853*/
					} /*14853*/
					$1.i = $1.i + 1; /*14856*/
				} /*14856*/
				$1.datcws = $geti($1.datcws, 0, $1.j); /*14858*/
			} /*14858*/
			$1.metrics = $a([$a([1, 11, 7, 1, 0, 9]), $a([1, 14, 7, 8, 0, 8]), $a([1, 17, 7, 36, 0, 36]), $a([1, 20, 8, 19, 0, 19]), $a([1, 24, 8, 9, 0, 17]), $a([1, 28, 8, 25, 0, 33]), $a([2, 8, 8, 1, 0, 1]), $a([2, 11, 9, 1, 0, 9]), $a([2, 14, 9, 8, 0, 8]), $a([2, 17, 10, 36, 0, 36]), $a([2, 20, 11, 19, 0, 19]), $a([2, 23, 13, 9, 0, 17]), $a([2, 26, 15, 27, 0, 35]), $a([3, 6, 12, 1, 1, 1]), $a([3, 8, 14, 7, 7, 7]), $a([3, 10, 16, 15, 15, 15]), $a([3, 12, 18, 25, 25, 25]), $a([3, 15, 21, 37, 37, 37]), $a([3, 20, 26, 1, 17, 33]), $a([3, 26, 32, 1, 9, 17]), $a([3, 32, 38, 21, 29, 37]), $a([3, 38, 44, 15, 31, 47]), $a([3, 44, 50, 1, 25, 49]), $a([4, 4, 8, 47, 19, 43]), $a([4, 6, 12, 1, 1, 1]), $a([4, 8, 14, 7, 7, 7]), $a([4, 10, 16, 15, 15, 15]), $a([4, 12, 18, 25, 25, 25]), $a([4, 15, 21, 37, 37, 37]), $a([4, 20, 26, 1, 17, 33]), $a([4, 26, 32, 1, 9, 17]), $a([4, 32, 38, 21, 29, 37]), $a([4, 38, 44, 15, 31, 47]), $a([4, 44, 50, 1, 25, 49])]); /*14898*/
			$1.ccametrics = $a([$a([2, 5, 4, 39, 0, 19]), $a([2, 6, 4, 1, 0, 33]), $a([2, 7, 5, 32, 0, 12]), $a([2, 8, 5, 8, 0, 40]), $a([2, 9, 6, 14, 0, 46]), $a([2, 10, 6, 43, 0, 23]), $a([2, 12, 7, 20, 0, 52]), $a([3, 4, 4, 11, 43, 23]), $a([3, 5, 5, 1, 33, 13]), $a([3, 6, 6, 5, 37, 17]), $a([3, 7, 7, 15, 47, 27]), $a([3, 8, 7, 21, 1, 33]), $a([4, 3, 4, 40, 20, 52]), $a([4, 4, 5, 43, 23, 3]), $a([4, 5, 6, 46, 26, 6]), $a([4, 6, 7, 34, 14, 46]), $a([4, 7, 8, 29, 9, 41])]); /*14920*/
			if ($1.cca) { /*14921*/
				$1.metrics = $1.ccametrics; /*14921*/
			} /*14921*/
			$1.urows = $1.rows; /*14924*/
			$1.ucols = $1.columns; /*14925*/
			$1.i = 0; /*14926*/
			for (;;) { /*14942*/
				$1.m = $get($1.metrics, $1.i); /*14928*/
				$1.c = $get($1.m, 0); /*14929*/
				$1.r = $get($1.m, 1); /*14930*/
				$1.k = $get($1.m, 2); /*14931*/
				$1.rapl = $get($1.m, 3); /*14932*/
				$1.rapc = $get($1.m, 4); /*14933*/
				$1.rapr = $get($1.m, 5); /*14934*/
				$1.ncws = ($1.r * $1.c) - $1.k; /*14935*/
				$1.okay = true; /*14936*/
				if ($1.datcws.length > $1.ncws) { /*14937*/
					$1.okay = false; /*14937*/
				} /*14937*/
				if (($1.urows != 0) && ($1.urows != $1.r)) { /*14938*/
					$1.okay = false; /*14938*/
				} /*14938*/
				if (($1.ucols != 0) && ($1.ucols != $1.c)) { /*14939*/
					$1.okay = false; /*14939*/
				} /*14939*/
				if ($1.okay) { /*14940*/
					break; /*14940*/
				} /*14940*/
				$1.i = $1.i + 1; /*14941*/
			} /*14941*/
			$1.m = $1.datcws.length; /*14943*/
			$1.n = ($1.c * $1.r) - $1.k; /*14946*/
			$1.cws = $a(($1.c * $1.r) + 1); /*14947*/
			$puti($1.cws, 0, $1.datcws); /*14948*/
			$k[$j++] = $1.cws; /*14949*/
			$k[$j++] = $1.m; /*14949*/
			$k[$j++] = Infinity; /*14949*/
			for (var _DK = 0, _DL = $1.n - $1.m; _DK < _DL; _DK++) { /*14949*/
				$k[$j++] = 900; /*14949*/
			} /*14949*/
			var _DM = $a(); /*14949*/
			var _DN = $k[--$j]; /*14949*/
			$puti($k[--$j], _DN, _DM); /*14949*/
			$k[$j++] = $1.cws; /*14950*/
			$k[$j++] = $1.n; /*14950*/
			$k[$j++] = Infinity; /*14950*/
			for (var _DS = 0, _DT = $1.k; _DS < _DT; _DS++) { /*14950*/
				$k[$j++] = 0; /*14950*/
			} /*14950*/
			$k[$j++] = 0; /*14950*/
			var _DU = $a(); /*14950*/
			var _DV = $k[--$j]; /*14950*/
			$puti($k[--$j], _DV, _DU); /*14950*/
			$k[$j++] = Infinity; /*14953*/
			$k[$j++] = 1; /*14953*/
			for (var _DX = 0, _DY = 928; _DX < _DY; _DX++) { /*14953*/
				var _DZ = $k[--$j]; /*14953*/
				$k[$j++] = _DZ; /*14953*/
				$k[$j++] = (_DZ * 3) % 929; /*14953*/
			} /*14953*/
			$1.rsalog = $a(); /*14953*/
			$1.rslog = $a(929); /*14954*/
			for (var _Dc = 1; _Dc <= 928; _Dc += 1) { /*14955*/
				$put($1.rslog, $get($1.rsalog, _Dc), _Dc); /*14955*/
			} /*14955*/
			$1.rsprod = function() {
				var _Dg = $k[--$j]; /*14959*/
				var _Dh = $k[--$j]; /*14959*/
				$k[$j++] = _Dh; /*14963*/
				$k[$j++] = _Dg; /*14963*/
				if ((_Dg != 0) && (_Dh != 0)) { /*14962*/
					var _Dk = $get($1.rslog, $k[--$j]); /*14960*/
					var _Dp = $get($1.rsalog, (_Dk + $get($1.rslog, $k[--$j])) % 928); /*14960*/
					$k[$j++] = _Dp; /*14960*/
				} else { /*14962*/
					$j -= 2; /*14962*/
					$k[$j++] = 0; /*14962*/
				} /*14962*/
			}; /*14964*/
			$k[$j++] = Infinity; /*14967*/
			$k[$j++] = 1; /*14967*/
			for (var _Dr = 0, _Ds = $1.k; _Dr < _Ds; _Dr++) { /*14967*/
				$k[$j++] = 0; /*14967*/
			} /*14967*/
			$1.coeffs = $a(); /*14967*/
			for (var _Dw = 1, _Dv = $1.k; _Dw <= _Dv; _Dw += 1) { /*14976*/
				$1.i = _Dw; /*14969*/
				$put($1.coeffs, $1.i, $get($1.coeffs, $1.i - 1)); /*14970*/
				for (var _E3 = $1.i - 1; _E3 >= 1; _E3 -= 1) { /*14974*/
					$1.j = _E3; /*14972*/
					$k[$j++] = $1.coeffs; /*14973*/
					$k[$j++] = $1.j; /*14973*/
					$k[$j++] = $get($1.coeffs, $1.j - 1); /*14973*/
					$k[$j++] = $get($1.coeffs, $1.j); /*14973*/
					$k[$j++] = $get($1.rsalog, $1.i); /*14973*/
					if ($1.rsprod() == $b) break; /*14973*/
					var _EF = $k[--$j]; /*14973*/
					var _EG = $k[--$j]; /*14973*/
					var _EH = $k[--$j]; /*14973*/
					$put($k[--$j], _EH, (_EG + _EF) % 929); /*14973*/
				} /*14973*/
				$k[$j++] = $1.coeffs; /*14975*/
				$k[$j++] = 0; /*14975*/
				$k[$j++] = $get($1.coeffs, 0); /*14975*/
				$k[$j++] = $get($1.rsalog, $1.i); /*14975*/
				if ($1.rsprod() == $b) break; /*14975*/
				var _EP = $k[--$j]; /*14975*/
				var _EQ = $k[--$j]; /*14975*/
				$put($k[--$j], _EQ, _EP); /*14975*/
			} /*14975*/
			$1.coeffs = $geti($1.coeffs, 0, $1.coeffs.length - 1); /*14977*/
			for (var _EW = $1.coeffs.length - 1; _EW >= 0; _EW -= 2) { /*14978*/
				var _EX = $1.coeffs; /*14978*/
				$put(_EX, _EW, 929 - $get(_EX, _EW)); /*14978*/
			} /*14978*/
			for (var _Eb = 0, _Ea = $1.n - 1; _Eb <= _Ea; _Eb += 1) { /*14987*/
				$1.t = ($get($1.cws, _Eb) + $get($1.cws, $1.n)) % 929; /*14982*/
				for (var _Ej = 0, _Ei = $1.k - 1; _Ej <= _Ei; _Ej += 1) { /*14986*/
					$1.j = _Ej; /*14984*/
					$put($1.cws, $1.n + $1.j, ($get($1.cws, ($1.n + $1.j) + 1) + (929 - (($1.t * $get($1.coeffs, ($1.k - $1.j) - 1)) % 929))) % 929); /*14985*/
				} /*14985*/
			} /*14985*/
			for (var _F0 = $1.n, _Ez = $1.n + $1.k; _F0 <= _Ez; _F0 += 1) { /*14988*/
				$put($1.cws, _F0, (929 - $get($1.cws, _F0)) % 929); /*14988*/
			} /*14988*/
			$1.cws = $geti($1.cws, 0, $1.cws.length - 1); /*14991*/
			$1.clusters = $a([$a([120256, 125680, 128380, 120032, 125560, 128318, 108736, 119920, 108640, 86080, 108592, 86048, 110016, 120560, 125820, 109792, 120440, 125758, 88256, 109680, 88160, 89536, 110320, 120700, 89312, 110200, 120638, 89200, 110140, 89840, 110460, 89720, 110398, 89980, 128506, 119520, 125304, 128190, 107712, 119408, 125244, 107616, 119352, 84032, 107568, 119324, 84000, 107544, 83984, 108256, 119672, 125374, 85184, 108144, 119612, 85088, 108088, 119582, 85040, 108060, 85728, 108408, 119742, 85616, 108348, 85560, 108318, 85880, 108478, 85820, 85790, 107200, 119152, 125116, 107104, 119096, 125086, 83008, 107056, 119068, 82976, 107032, 82960, 82952, 83648, 107376, 119228, 83552, 107320, 119198, 83504, 107292, 83480, 83468, 83824, 107452, 83768, 107422, 83740, 83900, 106848, 118968, 125022, 82496, 106800, 118940, 82464, 106776, 118926, 82448, 106764, 82440, 106758, 82784, 106936, 119006, 82736, 106908, 82712, 106894, 82700, 82694, 106974, 82830, 82240, 106672, 118876, 82208, 106648, 118862, 82192, 106636, 82184, 106630, 82180, 82352, 82328, 82316, 82080, 118830, 106572, 106566, 82050, 117472, 124280, 127678, 103616, 117360, 124220, 103520, 117304, 124190, 75840, 103472, 75808, 104160, 117624, 124350, 76992, 104048, 117564, 76896, 103992, 76848, 76824, 77536, 104312, 117694, 77424, 104252, 77368, 77340, 77688, 104382, 77628, 77758, 121536, 126320, 128700, 121440, 126264, 128670, 111680, 121392, 126236, 111648, 121368, 126222, 111632, 121356, 103104, 117104, 124092, 112320, 103008, 117048, 124062, 112224, 121656, 126366, 93248, 74784, 102936, 117006, 93216, 112152, 93200, 75456, 103280, 117180, 93888, 75360, 103224, 117150, 93792, 112440, 121758, 93744, 75288, 93720, 75632, 103356, 94064, 75576, 103326, 94008, 112542, 93980, 75708, 94140, 75678, 94110, 121184, 126136, 128606, 111168, 121136, 126108, 111136, 121112, 126094, 111120, 121100, 111112, 111108, 102752, 116920, 123998, 111456, 102704, 116892, 91712, 74272, 121244, 116878, 91680, 74256, 102668, 91664, 111372, 102662, 74244, 74592, 102840, 116958, 92000, 74544, 102812, 91952, 111516, 102798, 91928, 74508, 74502, 74680, 102878, 92088, 74652, 92060, 74638, 92046, 92126, 110912, 121008, 126044, 110880, 120984, 126030, 110864, 120972, 110856, 120966, 110852, 110850, 74048, 102576, 116828, 90944, 74016, 102552, 116814, 90912, 111000, 121038, 90896, 73992, 102534, 90888, 110982, 90884, 74160, 102620, 91056, 74136, 102606, 91032, 111054, 91020, 74118, 91014, 91100, 91086, 110752, 120920, 125998, 110736, 120908, 110728, 120902, 110724, 110722, 73888, 102488, 116782, 90528, 73872, 102476, 90512, 110796, 102470, 90504, 73860, 90500, 73858, 73944, 90584, 90572, 90566, 120876, 120870, 110658, 102444, 73800, 90312, 90308, 90306, 101056, 116080, 123580, 100960, 116024, 70720, 100912, 115996, 70688, 100888, 70672, 70664, 71360, 101232, 116156, 71264, 101176, 116126, 71216, 101148, 71192, 71180, 71536, 101308, 71480, 101278, 71452, 71612, 71582, 118112, 124600, 127838, 105024, 118064, 124572, 104992, 118040, 124558, 104976, 118028, 104968, 118022, 100704, 115896, 123486, 105312, 100656, 115868, 79424, 70176, 118172, 115854, 79392, 105240, 100620, 79376, 70152, 79368, 70496, 100792, 115934, 79712, 70448, 118238, 79664, 105372, 100750, 79640, 70412, 79628, 70584, 100830, 79800, 70556, 79772, 70542, 70622, 79838, 122176, 126640, 128860, 122144, 126616, 128846, 122128, 126604, 122120, 126598, 122116, 104768, 117936, 124508, 113472, 104736, 126684, 124494, 113440, 122264, 126670, 113424, 104712, 117894, 113416, 122246, 104706, 69952, 100528, 115804, 78656, 69920, 100504, 115790, 96064, 78624, 104856, 117966, 96032, 113560, 122318, 100486, 96016, 78600, 104838, 96008, 69890, 70064, 100572, 78768, 70040, 100558, 96176, 78744, 104910, 96152, 113614, 70022, 78726, 70108, 78812, 70094, 96220, 78798, 122016, 126552, 128814, 122000, 126540, 121992, 126534, 121988, 121986, 104608, 117848, 124462, 113056, 104592, 126574, 113040, 122060, 117830, 113032, 104580, 113028, 104578, 113026, 69792, 100440, 115758, 78240, 69776, 100428, 95136, 78224, 104652, 100422, 95120, 113100, 69764, 95112, 78212, 69762, 78210, 69848, 100462, 78296, 69836, 95192, 78284, 69830, 95180, 78278, 69870, 95214, 121936, 126508, 121928, 126502, 121924, 121922, 104528, 117804, 112848, 104520, 117798, 112840, 121958, 112836, 104514, 112834, 69712, 100396, 78032, 69704, 100390, 94672, 78024, 104550, 94664, 112870, 69698, 94660, 78018, 94658, 78060, 94700, 94694, 126486, 121890, 117782, 104484, 104482, 69672, 77928, 94440, 69666, 77922, 99680, 68160, 99632, 68128, 99608, 115342, 68112, 99596, 68104, 99590, 68448, 99768, 115422, 68400, 99740, 68376, 99726, 68364, 68358, 68536, 99806, 68508, 68494, 68574, 101696, 116400, 123740, 101664, 116376, 101648, 116364, 101640, 116358, 101636, 67904, 99504, 115292, 72512, 67872, 116444, 115278, 72480, 101784, 116430, 72464, 67848, 99462, 72456, 101766, 67842, 68016, 99548, 72624, 67992, 99534, 72600, 101838, 72588, 67974, 68060, 72668, 68046, 72654, 118432, 124760, 127918, 118416, 124748, 118408, 124742, 118404, 118402, 101536, 116312, 105888, 101520, 116300, 105872, 118476, 116294, 105864, 101508, 105860, 101506, 105858, 67744, 99416, 72096, 67728, 116334, 80800, 72080, 101580, 99398, 80784, 105932, 67716, 80776, 72068, 67714, 72066, 67800, 99438, 72152, 67788, 80856, 72140, 67782, 80844, 72134, 67822, 72174, 80878, 126800, 128940, 126792, 128934, 126788, 126786, 118352, 124716, 122576, 126828, 124710, 122568, 126822, 122564, 118338, 122562, 101456, 116268, 105680, 101448, 116262, 114128, 105672, 118374, 114120, 122598, 101442, 114116, 105666, 114114, 67664, 99372, 71888, 67656, 99366, 80336, 71880, 101478, 97232, 80328, 105702, 67650, 97224, 114150, 71874, 97220, 67692, 71916, 67686, 80364, 71910, 97260, 80358, 97254, 126760, 128918, 126756, 126754, 118312, 124694, 122472, 126774, 122468, 118306, 122466, 101416, 116246, 105576, 101412, 113896, 105572, 101410, 113892, 105570, 113890, 67624, 99350, 71784, 101430, 80104, 71780, 67618, 96744, 80100, 71778, 96740, 80098, 96738, 71798, 96758, 126738, 122420, 122418, 105524, 113780, 113778, 71732, 79988, 96500, 96498, 66880, 66848, 98968, 66832, 66824, 66820, 66992, 66968, 66956, 66950, 67036, 67022, 100000, 99984, 115532, 99976, 115526, 99972, 99970, 66720, 98904, 69024, 100056, 98892, 69008, 100044, 69000, 100038, 68996, 66690, 68994, 66776, 98926, 69080, 100078, 69068, 66758, 69062, 66798, 69102, 116560, 116552, 116548, 116546, 99920, 102096, 116588, 115494, 102088, 116582, 102084, 99906, 102082, 66640, 68816, 66632, 98854, 73168, 68808, 66628, 73160, 68804, 66626, 73156, 68802, 66668, 68844, 66662, 73196, 68838, 73190, 124840, 124836, 124834, 116520, 118632, 124854, 118628, 116514, 118626, 99880, 115478, 101992, 116534, 106216, 101988, 99874, 106212, 101986, 106210, 66600, 98838, 68712, 99894, 72936, 68708, 66594, 81384, 72932, 68706, 81380, 72930, 66614, 68726, 72950, 81398, 128980, 128978, 124820, 126900, 124818, 126898, 116500, 118580, 116498, 122740, 118578, 122738, 99860, 101940, 99858, 106100, 101938, 114420]), $a([128352, 129720, 125504, 128304, 129692, 125472, 128280, 129678, 125456, 128268, 125448, 128262, 125444, 125792, 128440, 129758, 120384, 125744, 128412, 120352, 125720, 128398, 120336, 125708, 120328, 125702, 120324, 120672, 125880, 128478, 110144, 120624, 125852, 110112, 120600, 125838, 110096, 120588, 110088, 120582, 110084, 110432, 120760, 125918, 89664, 110384, 120732, 89632, 110360, 120718, 89616, 110348, 89608, 110342, 89952, 110520, 120798, 89904, 110492, 89880, 110478, 89868, 90040, 110558, 90012, 89998, 125248, 128176, 129628, 125216, 128152, 129614, 125200, 128140, 125192, 128134, 125188, 125186, 119616, 125360, 128220, 119584, 125336, 128206, 119568, 125324, 119560, 125318, 119556, 119554, 108352, 119728, 125404, 108320, 119704, 125390, 108304, 119692, 108296, 119686, 108292, 108290, 85824, 108464, 119772, 85792, 108440, 119758, 85776, 108428, 85768, 108422, 85764, 85936, 108508, 85912, 108494, 85900, 85894, 85980, 85966, 125088, 128088, 129582, 125072, 128076, 125064, 128070, 125060, 125058, 119200, 125144, 128110, 119184, 125132, 119176, 125126, 119172, 119170, 107424, 119256, 125166, 107408, 119244, 107400, 119238, 107396, 107394, 83872, 107480, 119278, 83856, 107468, 83848, 107462, 83844, 83842, 83928, 107502, 83916, 83910, 83950, 125008, 128044, 125000, 128038, 124996, 124994, 118992, 125036, 118984, 125030, 118980, 118978, 106960, 119020, 106952, 119014, 106948, 106946, 82896, 106988, 82888, 106982, 82884, 82882, 82924, 82918, 124968, 128022, 124964, 124962, 118888, 124982, 118884, 118882, 106728, 118902, 106724, 106722, 82408, 106742, 82404, 82402, 124948, 124946, 118836, 118834, 106612, 106610, 124224, 127664, 129372, 124192, 127640, 129358, 124176, 127628, 124168, 127622, 124164, 124162, 117568, 124336, 127708, 117536, 124312, 127694, 117520, 124300, 117512, 124294, 117508, 117506, 104256, 117680, 124380, 104224, 117656, 124366, 104208, 117644, 104200, 117638, 104196, 104194, 77632, 104368, 117724, 77600, 104344, 117710, 77584, 104332, 77576, 104326, 77572, 77744, 104412, 77720, 104398, 77708, 77702, 77788, 77774, 128672, 129880, 93168, 128656, 129868, 92664, 128648, 129862, 92412, 128644, 128642, 124064, 127576, 129326, 126368, 124048, 129902, 126352, 128716, 127558, 126344, 124036, 126340, 124034, 126338, 117152, 124120, 127598, 121760, 117136, 124108, 121744, 126412, 124102, 121736, 117124, 121732, 117122, 121730, 103328, 117208, 124142, 112544, 103312, 117196, 112528, 121804, 117190, 112520, 103300, 112516, 103298, 112514, 75680, 103384, 117230, 94112, 75664, 103372, 94096, 112588, 103366, 94088, 75652, 94084, 75650, 75736, 103406, 94168, 75724, 94156, 75718, 94150, 75758, 128592, 129836, 91640, 128584, 129830, 91388, 128580, 91262, 128578, 123984, 127532, 126160, 123976, 127526, 126152, 128614, 126148, 123970, 126146, 116944, 124012, 121296, 116936, 124006, 121288, 126182, 121284, 116930, 121282, 102864, 116972, 111568, 102856, 116966, 111560, 121318, 111556, 102850, 111554, 74704, 102892, 92112, 74696, 102886, 92104, 111590, 92100, 74690, 92098, 74732, 92140, 74726, 92134, 128552, 129814, 90876, 128548, 90750, 128546, 123944, 127510, 126056, 128566, 126052, 123938, 126050, 116840, 123958, 121064, 116836, 121060, 116834, 121058, 102632, 116854, 111080, 121078, 111076, 102626, 111074, 74216, 102646, 91112, 74212, 91108, 74210, 91106, 74230, 91126, 128532, 90494, 128530, 123924, 126004, 123922, 126002, 116788, 120948, 116786, 120946, 102516, 110836, 102514, 110834, 73972, 90612, 73970, 90610, 128522, 123914, 125978, 116762, 120890, 102458, 110714, 123552, 127320, 129198, 123536, 127308, 123528, 127302, 123524, 123522, 116128, 123608, 127342, 116112, 123596, 116104, 123590, 116100, 116098, 101280, 116184, 123630, 101264, 116172, 101256, 116166, 101252, 101250, 71584, 101336, 116206, 71568, 101324, 71560, 101318, 71556, 71554, 71640, 101358, 71628, 71622, 71662, 127824, 129452, 79352, 127816, 129446, 79100, 127812, 78974, 127810, 123472, 127276, 124624, 123464, 127270, 124616, 127846, 124612, 123458, 124610, 115920, 123500, 118224, 115912, 123494, 118216, 124646, 118212, 115906, 118210, 100816, 115948, 105424, 100808, 115942, 105416, 118246, 105412, 100802, 105410, 70608, 100844, 79824, 70600, 100838, 79816, 105446, 79812, 70594, 79810, 70636, 79852, 70630, 79846, 129960, 95728, 113404, 129956, 95480, 113278, 129954, 95356, 95294, 127784, 129430, 78588, 128872, 129974, 95996, 78462, 128868, 127778, 95870, 128866, 123432, 127254, 124520, 123428, 126696, 128886, 123426, 126692, 124514, 126690, 115816, 123446, 117992, 115812, 122344, 117988, 115810, 122340, 117986, 122338, 100584, 115830, 104936, 100580, 113640, 104932, 100578, 113636, 104930, 113634, 70120, 100598, 78824, 70116, 96232, 78820, 70114, 96228, 78818, 96226, 70134, 78838, 129940, 94968, 113022, 129938, 94844, 94782, 127764, 78206, 128820, 127762, 95102, 128818, 123412, 124468, 123410, 126580, 124466, 126578, 115764, 117876, 115762, 122100, 117874, 122098, 100468, 104692, 100466, 113140, 104690, 113138, 69876, 78324, 69874, 95220, 78322, 95218, 129930, 94588, 94526, 127754, 128794, 123402, 124442, 126522, 115738, 117818, 121978, 100410, 104570, 112890, 69754, 78074, 94714, 94398, 123216, 127148, 123208, 127142, 123204, 123202, 115408, 123244, 115400, 123238, 115396, 115394, 99792, 115436, 99784, 115430, 99780, 99778, 68560, 99820, 68552, 99814, 68548, 68546, 68588, 68582, 127400, 129238, 72444, 127396, 72318, 127394, 123176, 127126, 123752, 123172, 123748, 123170, 123746, 115304, 123190, 116456, 115300, 116452, 115298, 116450, 99560, 115318, 101864, 99556, 101860, 99554, 101858, 68072, 99574, 72680, 68068, 72676, 68066, 72674, 68086, 72694, 129492, 80632, 105854, 129490, 80508, 80446, 127380, 72062, 127924, 127378, 80766, 127922, 123156, 123700, 123154, 124788, 123698, 124786, 115252, 116340, 115250, 118516, 116338, 118514, 99444, 101620, 99442, 105972, 101618, 105970, 67828, 72180, 67826, 80884, 72178, 80882, 97008, 114044, 96888, 113982, 96828, 96798, 129482, 80252, 130010, 97148, 80190, 97086, 127370, 127898, 128954, 123146, 123674, 124730, 126842, 115226, 116282, 118394, 122618, 99386, 101498, 105722, 114170, 67706, 71930, 80378, 96632, 113854, 96572, 96542, 80062, 96702, 96444, 96414, 96350, 123048, 123044, 123042, 115048, 123062, 115044, 115042, 99048, 115062, 99044, 99042, 67048, 99062, 67044, 67042, 67062, 127188, 68990, 127186, 123028, 123316, 123026, 123314, 114996, 115572, 114994, 115570, 98932, 100084, 98930, 100082, 66804, 69108, 66802, 69106, 129258, 73084, 73022, 127178, 127450, 123018, 123290, 123834, 114970, 115514, 116602, 98874, 99962, 102138, 66682, 68858, 73210, 81272, 106174, 81212, 81182, 72894, 81342, 97648, 114364, 97592, 114334, 97564, 97550, 81084, 97724, 81054, 97694, 97464, 114270, 97436, 97422, 80990, 97502, 97372, 97358, 97326, 114868, 114866, 98676, 98674, 66292, 66290, 123098, 114842, 115130, 98618, 99194, 66170, 67322, 69310, 73404, 73374, 81592, 106334, 81564, 81550, 73310, 81630, 97968, 114524, 97944, 114510, 97932, 97926, 81500, 98012, 81486, 97998, 97880, 114478, 97868, 97862, 81454, 97902, 97836, 97830, 69470, 73564, 73550, 81752, 106414, 81740, 81734, 73518, 81774, 81708, 81702]), $a([109536, 120312, 86976, 109040, 120060, 86496, 108792, 119934, 86256, 108668, 86136, 129744, 89056, 110072, 129736, 88560, 109820, 129732, 88312, 109694, 129730, 88188, 128464, 129772, 89592, 128456, 129766, 89340, 128452, 89214, 128450, 125904, 128492, 125896, 128486, 125892, 125890, 120784, 125932, 120776, 125926, 120772, 120770, 110544, 120812, 110536, 120806, 110532, 84928, 108016, 119548, 84448, 107768, 119422, 84208, 107644, 84088, 107582, 84028, 129640, 85488, 108284, 129636, 85240, 108158, 129634, 85116, 85054, 128232, 129654, 85756, 128228, 85630, 128226, 125416, 128246, 125412, 125410, 119784, 125430, 119780, 119778, 108520, 119798, 108516, 108514, 83424, 107256, 119166, 83184, 107132, 83064, 107070, 83004, 82974, 129588, 83704, 107390, 129586, 83580, 83518, 128116, 83838, 128114, 125172, 125170, 119284, 119282, 107508, 107506, 82672, 106876, 82552, 106814, 82492, 82462, 129562, 82812, 82750, 128058, 125050, 119034, 82296, 106686, 82236, 82206, 82366, 82108, 82078, 76736, 103920, 117500, 76256, 103672, 117374, 76016, 103548, 75896, 103486, 75836, 129384, 77296, 104188, 129380, 77048, 104062, 129378, 76924, 76862, 127720, 129398, 77564, 127716, 77438, 127714, 124392, 127734, 124388, 124386, 117736, 124406, 117732, 117730, 104424, 117750, 104420, 104418, 112096, 121592, 126334, 92608, 111856, 121468, 92384, 111736, 121406, 92272, 111676, 92216, 111646, 92188, 75232, 103160, 117118, 93664, 74992, 103036, 93424, 112252, 102974, 93304, 74812, 93244, 74782, 93214, 129332, 75512, 103294, 129908, 129330, 93944, 75388, 129906, 93820, 75326, 93758, 127604, 75646, 128756, 127602, 94078, 128754, 124148, 126452, 124146, 126450, 117236, 121844, 117234, 121842, 103412, 103410, 91584, 111344, 121212, 91360, 111224, 121150, 91248, 111164, 91192, 111134, 91164, 91150, 74480, 102780, 91888, 74360, 102718, 91768, 111422, 91708, 74270, 91678, 129306, 74620, 129850, 92028, 74558, 91966, 127546, 128634, 124026, 126202, 116986, 121338, 102906, 90848, 110968, 121022, 90736, 110908, 90680, 110878, 90652, 90638, 74104, 102590, 91000, 74044, 90940, 74014, 90910, 74174, 91070, 90480, 110780, 90424, 110750, 90396, 90382, 73916, 90556, 73886, 90526, 90296, 110686, 90268, 90254, 73822, 90334, 90204, 90190, 71136, 101112, 116094, 70896, 100988, 70776, 100926, 70716, 70686, 129204, 71416, 101246, 129202, 71292, 71230, 127348, 71550, 127346, 123636, 123634, 116212, 116210, 101364, 101362, 79296, 105200, 118140, 79072, 105080, 118078, 78960, 105020, 78904, 104990, 78876, 78862, 70384, 100732, 79600, 70264, 100670, 79480, 105278, 79420, 70174, 79390, 129178, 70524, 129466, 79740, 70462, 79678, 127290, 127866, 123514, 124666, 115962, 118266, 100858, 113376, 122232, 126654, 95424, 113264, 122172, 95328, 113208, 122142, 95280, 113180, 95256, 113166, 95244, 78560, 104824, 117950, 95968, 78448, 104764, 95856, 113468, 104734, 95800, 78364, 95772, 78350, 95758, 70008, 100542, 78712, 69948, 96120, 78652, 69918, 96060, 78622, 96030, 70078, 78782, 96190, 94912, 113008, 122044, 94816, 112952, 122014, 94768, 112924, 94744, 112910, 94732, 94726, 78192, 104636, 95088, 78136, 104606, 95032, 113054, 95004, 78094, 94990, 69820, 78268, 69790, 95164, 78238, 95134, 94560, 112824, 121950, 94512, 112796, 94488, 112782, 94476, 94470, 78008, 104542, 94648, 77980, 94620, 77966, 94606, 69726, 78046, 94686, 94384, 112732, 94360, 112718, 94348, 94342, 77916, 94428, 77902, 94414, 94296, 112686, 94284, 94278, 77870, 94318, 94252, 94246, 68336, 99708, 68216, 99646, 68156, 68126, 68476, 68414, 127162, 123258, 115450, 99834, 72416, 101752, 116414, 72304, 101692, 72248, 101662, 72220, 72206, 67960, 99518, 72568, 67900, 72508, 67870, 72478, 68030, 72638, 80576, 105840, 118460, 80480, 105784, 118430, 80432, 105756, 80408, 105742, 80396, 80390, 72048, 101564, 80752, 71992, 101534, 80696, 71964, 80668, 71950, 80654, 67772, 72124, 67742, 80828, 72094, 80798, 114016, 122552, 126814, 96832, 113968, 122524, 96800, 113944, 122510, 96784, 113932, 96776, 113926, 96772, 80224, 105656, 118366, 97120, 80176, 105628, 97072, 114076, 105614, 97048, 80140, 97036, 80134, 97030, 71864, 101470, 80312, 71836, 97208, 80284, 71822, 97180, 80270, 97166, 67678, 71902, 80350, 97246, 96576, 113840, 122460, 96544, 113816, 122446, 96528, 113804, 96520, 113798, 96516, 96514, 80048, 105564, 96688, 80024, 105550, 96664, 113870, 96652, 80006, 96646, 71772, 80092, 71758, 96732, 80078, 96718, 96416, 113752, 122414, 96400, 113740, 96392, 113734, 96388, 96386, 79960, 105518, 96472, 79948, 96460, 79942, 96454, 71726, 79982, 96494, 96336, 113708, 96328, 113702, 96324, 96322, 79916, 96364, 79910, 96358, 96296, 113686, 96292, 96290, 79894, 96310, 66936, 99006, 66876, 66846, 67006, 68976, 100028, 68920, 99998, 68892, 68878, 66748, 69052, 66718, 69022, 73056, 102072, 116574, 73008, 102044, 72984, 102030, 72972, 72966, 68792, 99934, 73144, 68764, 73116, 68750, 73102, 66654, 68830, 73182, 81216, 106160, 118620, 81184, 106136, 118606, 81168, 106124, 81160, 106118, 81156, 81154, 72880, 101980, 81328, 72856, 101966, 81304, 106190, 81292, 72838, 81286, 68700, 72924, 68686, 81372, 72910, 81358, 114336, 122712, 126894, 114320, 122700, 114312, 122694, 114308, 114306, 81056, 106072, 118574, 97696, 81040, 106060, 97680, 114380, 106054, 97672, 81028, 97668, 81026, 97666, 72792, 101934, 81112, 72780, 97752, 81100, 72774, 97740, 81094, 97734, 68654, 72814, 81134, 97774, 114256, 122668, 114248, 122662, 114244, 114242, 80976, 106028, 97488, 80968, 106022, 97480, 114278, 97476, 80962, 97474, 72748, 81004, 72742, 97516, 80998, 97510, 114216, 122646, 114212, 114210, 80936, 106006, 97384, 80932, 97380, 80930, 97378, 72726, 80950, 97398, 114196, 114194, 80916, 97332, 80914, 97330, 66236, 66206, 67256, 99166, 67228, 67214, 66142, 67294, 69296, 100188, 69272, 100174, 69260, 69254, 67164, 69340, 67150, 69326, 73376, 102232, 116654, 73360, 102220, 73352, 102214, 73348, 73346, 69208, 100142, 73432, 102254, 73420, 69190, 73414, 67118, 69230, 73454, 106320, 118700, 106312, 118694, 106308, 106306, 73296, 102188, 81616, 106348, 102182, 81608, 73284, 81604, 73282, 81602, 69164, 73324, 69158, 81644, 73318, 81638, 122792, 126934, 122788, 122786, 106280, 118678, 114536, 106276, 114532, 106274, 114530, 73256, 102166, 81512, 73252, 98024, 81508, 73250, 98020, 81506, 98018, 69142, 73270, 81526, 98038, 122772, 122770, 106260, 114484, 106258, 114482, 73236, 81460, 73234, 97908, 81458, 97906, 122762, 106250, 114458, 73226, 81434, 97850, 66396, 66382, 67416, 99246, 67404, 67398, 66350, 67438, 69456, 100268, 69448, 100262, 69444, 69442, 67372, 69484, 67366, 69478, 102312, 116694, 102308, 102306, 69416, 100246, 73576, 102326, 73572, 69410, 73570, 67350, 69430, 73590, 118740, 118738, 102292, 106420, 102290, 106418, 69396, 73524, 69394, 81780, 73522, 81778, 118730, 102282, 106394, 69386, 73498, 81722, 66476, 66470, 67496, 99286, 67492, 67490, 66454, 67510, 100308, 100306, 67476, 69556, 67474, 69554, 116714])]); /*15233*/
			$1.raps = $a([$a([802, 930, 946, 818, 882, 890, 826, 954, 922, 986, 970, 906, 778, 794, 786, 914, 978, 982, 980, 916, 948, 932, 934, 942, 940, 936, 808, 812, 814, 806, 822, 950, 918, 790, 788, 820, 884, 868, 870, 878, 876, 872, 840, 856, 860, 862, 846, 844, 836, 838, 834, 866]), $a([718, 590, 622, 558, 550, 566, 534, 530, 538, 570, 562, 546, 610, 626, 634, 762, 754, 758, 630, 628, 612, 614, 582, 578, 706, 738, 742, 740, 748, 620, 556, 552, 616, 744, 712, 716, 708, 710, 646, 654, 652, 668, 664, 696, 688, 656, 720, 592, 600, 604, 732, 734])]); /*15248*/
			$1.cwtobits = function() {
				var _FG = $get($1.clusters, $k[--$j]); /*15252*/
				$1.v = $get(_FG, $k[--$j]); /*15252*/
				$k[$j++] = Infinity; /*15253*/
				for (var _FJ = 0, _FK = 17; _FJ < _FK; _FJ++) { /*15253*/
					$k[$j++] = 0; /*15253*/
				} /*15253*/
				var _FN = $cvrs($s(17), $1.v, 2); /*15253*/
				for (var _FO = 0, _FP = _FN.length; _FO < _FP; _FO++) { /*15253*/
					$k[$j++] = $get(_FN, _FO) - 48; /*15253*/
				} /*15253*/
				var _FR = $a(); /*15253*/
				$k[$j++] = $geti(_FR, _FR.length - 17, 17); /*15254*/
			}; /*15255*/
			$1.raptobits = function() {
				var _FV = $get($1.raps, $k[--$j]); /*15259*/
				$1.v = $get(_FV, $k[--$j]); /*15259*/
				$k[$j++] = Infinity; /*15260*/
				for (var _FY = 0, _FZ = 10; _FY < _FZ; _FY++) { /*15260*/
					$k[$j++] = 0; /*15260*/
				} /*15260*/
				var _Fc = $cvrs($s(10), $1.v, 2); /*15260*/
				for (var _Fd = 0, _Fe = _Fc.length; _Fd < _Fe; _Fd++) { /*15260*/
					$k[$j++] = $get(_Fc, _Fd) - 48; /*15260*/
				} /*15260*/
				var _Fg = $a(); /*15260*/
				$k[$j++] = $geti(_Fg, _Fg.length - 10, 10); /*15261*/
			}; /*15262*/
			$1.rwid = $get($a([38, 55, 82, 99]), $1.c - 1); /*15265*/
			if (($1.c == 3) && $1.cca) { /*15266*/
				$1.rwid = 72; /*15266*/
			} /*15266*/
			$1.pixs = $a($1.rwid * $1.r); /*15267*/
			for (var _Fs = 0, _Fr = $1.r - 1; _Fs <= _Fr; _Fs += 1) { /*15305*/
				$1.i = _Fs; /*15270*/
				$1.clst = (($1.i + $1.rapl) - 1) % 3; /*15271*/
				$k[$j++] = $1.pixs; /*15303*/
				$k[$j++] = $1.rwid * $1.i; /*15303*/
				$k[$j++] = Infinity; /*15303*/
				if ($1.c == 1) { /*15277*/
					$k[$j++] = (($1.i + $1.rapl) - 1) % 52; /*15274*/
					$k[$j++] = 0; /*15274*/
					if ($1.raptobits() == $b) break; /*15274*/
					$aload($k[--$j]); /*15274*/
					$k[$j++] = $get($1.cws, $1.i); /*15275*/
					$k[$j++] = $1.clst; /*15275*/
					if ($1.cwtobits() == $b) break; /*15275*/
					$aload($k[--$j]); /*15275*/
					$k[$j++] = (($1.i + $1.rapr) - 1) % 52; /*15276*/
					$k[$j++] = 0; /*15276*/
					if ($1.raptobits() == $b) break; /*15276*/
					$aload($k[--$j]); /*15276*/
				} /*15276*/
				if ($1.c == 2) { /*15283*/
					$k[$j++] = (($1.i + $1.rapl) - 1) % 52; /*15279*/
					$k[$j++] = 0; /*15279*/
					if ($1.raptobits() == $b) break; /*15279*/
					$aload($k[--$j]); /*15279*/
					$k[$j++] = $get($1.cws, $1.i * 2); /*15280*/
					$k[$j++] = $1.clst; /*15280*/
					if ($1.cwtobits() == $b) break; /*15280*/
					$aload($k[--$j]); /*15280*/
					$k[$j++] = $get($1.cws, ($1.i * 2) + 1); /*15281*/
					$k[$j++] = $1.clst; /*15281*/
					if ($1.cwtobits() == $b) break; /*15281*/
					$aload($k[--$j]); /*15281*/
					$k[$j++] = (($1.i + $1.rapr) - 1) % 52; /*15282*/
					$k[$j++] = 0; /*15282*/
					if ($1.raptobits() == $b) break; /*15282*/
					$aload($k[--$j]); /*15282*/
				} /*15282*/
				if ($1.c == 3) { /*15293*/
					if (!$1.cca) { /*15287*/
						$k[$j++] = (($1.i + $1.rapl) - 1) % 52; /*15286*/
						$k[$j++] = 0; /*15286*/
						if ($1.raptobits() == $b) break; /*15286*/
						$aload($k[--$j]); /*15286*/
					} /*15286*/
					$k[$j++] = $get($1.cws, $1.i * 3); /*15288*/
					$k[$j++] = $1.clst; /*15288*/
					if ($1.cwtobits() == $b) break; /*15288*/
					$aload($k[--$j]); /*15288*/
					$k[$j++] = (($1.i + $1.rapc) - 1) % 52; /*15289*/
					$k[$j++] = 1; /*15289*/
					if ($1.raptobits() == $b) break; /*15289*/
					$aload($k[--$j]); /*15289*/
					$k[$j++] = $get($1.cws, ($1.i * 3) + 1); /*15290*/
					$k[$j++] = $1.clst; /*15290*/
					if ($1.cwtobits() == $b) break; /*15290*/
					$aload($k[--$j]); /*15290*/
					$k[$j++] = $get($1.cws, ($1.i * 3) + 2); /*15291*/
					$k[$j++] = $1.clst; /*15291*/
					if ($1.cwtobits() == $b) break; /*15291*/
					$aload($k[--$j]); /*15291*/
					$k[$j++] = (($1.i + $1.rapr) - 1) % 52; /*15292*/
					$k[$j++] = 0; /*15292*/
					if ($1.raptobits() == $b) break; /*15292*/
					$aload($k[--$j]); /*15292*/
				} /*15292*/
				if ($1.c == 4) { /*15302*/
					$k[$j++] = (($1.i + $1.rapl) - 1) % 52; /*15295*/
					$k[$j++] = 0; /*15295*/
					if ($1.raptobits() == $b) break; /*15295*/
					$aload($k[--$j]); /*15295*/
					$k[$j++] = $get($1.cws, $1.i * 4); /*15296*/
					$k[$j++] = $1.clst; /*15296*/
					if ($1.cwtobits() == $b) break; /*15296*/
					$aload($k[--$j]); /*15296*/
					$k[$j++] = $get($1.cws, ($1.i * 4) + 1); /*15297*/
					$k[$j++] = $1.clst; /*15297*/
					if ($1.cwtobits() == $b) break; /*15297*/
					$aload($k[--$j]); /*15297*/
					$k[$j++] = (($1.i + $1.rapc) - 1) % 52; /*15298*/
					$k[$j++] = 1; /*15298*/
					if ($1.raptobits() == $b) break; /*15298*/
					$aload($k[--$j]); /*15298*/
					$k[$j++] = $get($1.cws, ($1.i * 4) + 2); /*15299*/
					$k[$j++] = $1.clst; /*15299*/
					if ($1.cwtobits() == $b) break; /*15299*/
					$aload($k[--$j]); /*15299*/
					$k[$j++] = $get($1.cws, ($1.i * 4) + 3); /*15300*/
					$k[$j++] = $1.clst; /*15300*/
					if ($1.cwtobits() == $b) break; /*15300*/
					$aload($k[--$j]); /*15300*/
					$k[$j++] = (($1.i + $1.rapr) - 1) % 52; /*15301*/
					$k[$j++] = 0; /*15301*/
					if ($1.raptobits() == $b) break; /*15301*/
					$aload($k[--$j]); /*15301*/
				} /*15301*/
				$k[$j++] = 1; /*15303*/
				var _HL = $a(); /*15303*/
				var _HM = $k[--$j]; /*15304*/
				$puti($k[--$j], _HM, _HL); /*15304*/
			} /*15304*/
			var _HV = {
				ren: $0.renmatrix,
				pixs: $1.pixs,
				pixx: $1.rwid,
				pixy: $1.r,
				height: ($1.r / 72) * $1.rowmult,
				width: $1.rwid / 72,
				opt: $1.options
			}; /*15315*/
			$k[$j++] = _HV; /*15318*/
			if (!$1.dontdraw) { /*15318*/
				$0.renmatrix(); /*15318*/
			} /*15318*/
		};
		$0.datamatrix = function() {
			var $1 = {}; /*15343*/
			$1.options = $k[--$j]; /*15345*/
			$1.barcode = $k[--$j]; /*15346*/
			$1.dontdraw = false; /*15348*/
			$1.columns = 0; /*15349*/
			$1.rows = 0; /*15350*/
			$1.format = "square"; /*15351*/
			$1.version = "unset"; /*15352*/
			$1.parse = false; /*15353*/
			$1.parsefnc = false; /*15354*/
			$1.encoding = "auto"; /*15355*/
			$1.raw = false; /*15356*/
			$1.dmre = false; /*15357*/
			$forall($1.options, function() { /*15368*/
				var _3 = $k[--$j]; /*15368*/
				$1[$k[--$j]] = _3; /*15368*/
			}); /*15368*/
			if ($ne($1.version, "unset")) { /*15374*/
				$search($1.version, "x"); /*15371*/
				$j--; /*15372*/
				$1.rows = $k[--$j]; /*15372*/
				$j--; /*15373*/
				$1.columns = $k[--$j]; /*15373*/
			} /*15373*/
			$1.columns = ~~$z($1.columns); /*15376*/
			$1.rows = ~~$z($1.rows); /*15377*/
			$k[$j++] = Infinity; /*15447*/
			$k[$j++] = $a([10, 10, 1, 1, 5, 1]); /*15431*/
			$k[$j++] = $a([12, 12, 1, 1, 7, 1]); /*15431*/
			$k[$j++] = $a([14, 14, 1, 1, 10, 1]); /*15431*/
			$k[$j++] = $a([16, 16, 1, 1, 12, 1]); /*15431*/
			$k[$j++] = $a([18, 18, 1, 1, 14, 1]); /*15431*/
			$k[$j++] = $a([20, 20, 1, 1, 18, 1]); /*15431*/
			$k[$j++] = $a([22, 22, 1, 1, 20, 1]); /*15431*/
			$k[$j++] = $a([24, 24, 1, 1, 24, 1]); /*15431*/
			$k[$j++] = $a([26, 26, 1, 1, 28, 1]); /*15431*/
			$k[$j++] = $a([32, 32, 2, 2, 36, 1]); /*15431*/
			$k[$j++] = $a([36, 36, 2, 2, 42, 1]); /*15431*/
			$k[$j++] = $a([40, 40, 2, 2, 48, 1]); /*15431*/
			$k[$j++] = $a([44, 44, 2, 2, 56, 1]); /*15431*/
			$k[$j++] = $a([48, 48, 2, 2, 68, 1]); /*15431*/
			$k[$j++] = $a([52, 52, 2, 2, 84, 2]); /*15431*/
			$k[$j++] = $a([64, 64, 4, 4, 112, 2]); /*15431*/
			$k[$j++] = $a([72, 72, 4, 4, 144, 4]); /*15431*/
			$k[$j++] = $a([80, 80, 4, 4, 192, 4]); /*15431*/
			$k[$j++] = $a([88, 88, 4, 4, 224, 4]); /*15431*/
			$k[$j++] = $a([96, 96, 4, 4, 272, 4]); /*15431*/
			$k[$j++] = $a([104, 104, 4, 4, 336, 6]); /*15431*/
			$k[$j++] = $a([120, 120, 6, 6, 408, 6]); /*15431*/
			$k[$j++] = $a([132, 132, 6, 6, 496, 8]); /*15431*/
			$k[$j++] = $a([144, 144, 6, 6, 620, 10]); /*15431*/
			$k[$j++] = $a([8, 18, 1, 1, 7, 1]); /*15431*/
			$k[$j++] = $a([8, 32, 1, 2, 11, 1]); /*15431*/
			if ($1.dmre) { /*15431*/
				$k[$j++] = $a([8, 48, 1, 2, 15, 1]); /*15431*/
			} /*15431*/
			if ($1.dmre) { /*15432*/
				$k[$j++] = $a([8, 64, 1, 4, 18, 1]); /*15432*/
			} /*15432*/
			$k[$j++] = $a([12, 26, 1, 1, 14, 1]); /*15435*/
			$k[$j++] = $a([12, 36, 1, 2, 18, 1]); /*15435*/
			if ($1.dmre) { /*15435*/
				$k[$j++] = $a([12, 64, 1, 4, 27, 1]); /*15435*/
			} /*15435*/
			$k[$j++] = $a([16, 36, 1, 2, 24, 1]); /*15438*/
			$k[$j++] = $a([16, 48, 1, 2, 28, 1]); /*15438*/
			if ($1.dmre) { /*15438*/
				$k[$j++] = $a([16, 64, 1, 4, 36, 1]); /*15438*/
			} /*15438*/
			if ($1.dmre) { /*15439*/
				$k[$j++] = $a([24, 32, 1, 2, 28, 1]); /*15439*/
			} /*15439*/
			if ($1.dmre) { /*15440*/
				$k[$j++] = $a([24, 36, 1, 2, 33, 1]); /*15440*/
			} /*15440*/
			if ($1.dmre) { /*15441*/
				$k[$j++] = $a([24, 48, 1, 2, 41, 1]); /*15441*/
			} /*15441*/
			if ($1.dmre) { /*15442*/
				$k[$j++] = $a([24, 64, 1, 4, 46, 1]); /*15442*/
			} /*15442*/
			if ($1.dmre) { /*15443*/
				$k[$j++] = $a([26, 32, 1, 2, 32, 1]); /*15443*/
			} /*15443*/
			if ($1.dmre) { /*15444*/
				$k[$j++] = $a([26, 40, 1, 2, 38, 1]); /*15444*/
			} /*15444*/
			if ($1.dmre) { /*15445*/
				$k[$j++] = $a([26, 48, 1, 2, 42, 1]); /*15445*/
			} /*15445*/
			if ($1.dmre) { /*15446*/
				$k[$j++] = $a([26, 64, 1, 4, 50, 1]); /*15446*/
			} /*15446*/
			$1.metrics = $a(); /*15447*/
			$1.urows = $1.rows; /*15450*/
			$1.ucols = $1.columns; /*15451*/
			$1.fullcws = $a([]); /*15452*/
			var _17 = $1.metrics; /*15453*/
			for (var _18 = 0, _19 = _17.length; _18 < _19; _18++) { /*15470*/
				$1.m = $get(_17, _18); /*15454*/
				$1.rows = $get($1.m, 0); /*15455*/
				$1.cols = $get($1.m, 1); /*15456*/
				$1.regh = $get($1.m, 2); /*15457*/
				$1.regv = $get($1.m, 3); /*15458*/
				$1.rscw = $get($1.m, 4); /*15459*/
				$1.rsbl = $get($1.m, 5); /*15460*/
				$1.mrows = $1.rows - (2 * $1.regh); /*15461*/
				$1.mcols = $1.cols - (2 * $1.regv); /*15462*/
				$1.ncws = (~~(($1.mrows * $1.mcols) / 8)) - $1.rscw; /*15463*/
				$1.okay = true; /*15464*/
				if (($1.urows != 0) && ($1.urows != $1.rows)) { /*15465*/
					$1.okay = false; /*15465*/
				} /*15465*/
				if (($1.ucols != 0) && ($1.ucols != $1.cols)) { /*15466*/
					$1.okay = false; /*15466*/
				} /*15466*/
				if ($eq($1.format, "square") && $ne($1.rows, $1.cols)) { /*15467*/
					$1.okay = false; /*15467*/
				} /*15467*/
				if ($eq($1.format, "rectangle") && $eq($1.rows, $1.cols)) { /*15468*/
					$1.okay = false; /*15468*/
				} /*15468*/
				if ($1.okay) { /*15469*/
					$k[$j++] = Infinity; /*15469*/
					$aload($1.fullcws); /*15469*/
					$k[$j++] = $1.ncws; /*15469*/
					$1.fullcws = $a(); /*15469*/
				} /*15469*/
			} /*15469*/
			$k[$j++] = Infinity; /*15471*/
			for (var _1k = 0, _1l = 1558; _1k < _1l; _1k++) { /*15471*/
				$k[$j++] = 10000; /*15471*/
			} /*15471*/
			$1.numremcws = $a(); /*15471*/
			var _1n = $1.fullcws; /*15472*/
			for (var _1o = 0, _1p = _1n.length; _1o < _1p; _1o++) { /*15472*/
				$put($1.numremcws, $get(_1n, _1o) - 1, 1); /*15472*/
			} /*15472*/
			for (var _1s = 1556; _1s >= 0; _1s -= 1) { /*15478*/
				$1.i = _1s; /*15474*/
				if ($get($1.numremcws, $1.i) != 1) { /*15477*/
					$put($1.numremcws, $1.i, $get($1.numremcws, $1.i + 1) + 1); /*15476*/
				} /*15476*/
			} /*15476*/
			if ($1.raw) { /*15480*/
				$1.encoding = "raw"; /*15480*/
			} /*15480*/
			if ($eq($1.encoding, "raw")) { /*15493*/
				$1.cws = $a($1.barcode.length); /*15483*/
				$1.i = 0; /*15484*/
				$1.j = 0; /*15484*/
				for (;;) { /*15491*/
					if ($1.i == $1.barcode.length) { /*15486*/
						break; /*15486*/
					} /*15486*/
					$1.cw = ~~$z($geti($1.barcode, $1.i + 1, 3)); /*15487*/
					$put($1.cws, $1.j, $1.cw); /*15488*/
					$1.i = $1.i + 4; /*15489*/
					$1.j = $1.j + 1; /*15490*/
				} /*15490*/
				$1.cws = $geti($1.cws, 0, $1.j); /*15492*/
			} /*15492*/
			if ($eq($1.encoding, "auto")) { /*15978*/
				$1.mac05comp = false; /*15498*/
				$1.mac06comp = false; /*15499*/
				if ($1.barcode.length >= 9) { /*15508*/
					var _2L = $geti($1.barcode, 0, 7); /*15501*/
					if ((($eq(_2L, "[)>03605035")) || ($eq(_2L, "[)>03606035"))) && $eq($geti($1.barcode, $1.barcode.length - 2, 2), "036004")) { /*15507*/
						if ($get($1.barcode, 5) == 53) { /*15505*/
							$k[$j++] = "mac05comp"; /*15505*/
						} else { /*15505*/
							$k[$j++] = "mac06comp"; /*15505*/
						} /*15505*/
						$1[$k[--$j]] = true; /*15505*/
						$1.barcode = $geti($1.barcode, 7, $1.barcode.length - 9); /*15506*/
					} /*15506*/
				} /*15506*/
				$1.barlen = $1.barcode.length; /*15509*/
				$1.fnc1 = -1; /*15512*/
				$1.prog = -2; /*15512*/
				$1.m05 = -3; /*15512*/
				$1.m06 = -4; /*15512*/
				var _2a = {
					FNC1: $1.fnc1,
					PROG: $1.prog,
					MAC5: $1.m05,
					MAC6: $1.m06
				}; /*15517*/
				$1.fncvals = _2a; /*15518*/
				$1.msg = $a($1.barlen); /*15519*/
				$1.i = 0; /*15520*/
				$1.j = 0; /*15520*/
				for (;;) { /*15534*/
					if ($1.i == $1.barlen) { /*15521*/
						break; /*15521*/
					} /*15521*/
					$1.char = $get($1.barcode, $1.i); /*15522*/
					if (($1.parsefnc && ($1.char == 94)) && ($1.i < ($1.barlen - 4))) { /*15530*/
						if ($get($1.barcode, $1.i + 1) != 94) { /*15528*/
							$1.char = $get($1.fncvals, $geti($1.barcode, $1.i + 1, 4)); /*15525*/
							$1.i = $1.i + 4; /*15526*/
						} else { /*15528*/
							$1.i = $1.i + 1; /*15528*/
						} /*15528*/
					} /*15528*/
					$put($1.msg, $1.j, $1.char); /*15531*/
					$1.i = $1.i + 1; /*15532*/
					$1.j = $1.j + 1; /*15533*/
				} /*15533*/
				$1.msg = $geti($1.msg, 0, $1.j); /*15535*/
				if ($1.mac05comp) { /*15538*/
					$k[$j++] = Infinity; /*15538*/
					$k[$j++] = $1.m05; /*15538*/
					$aload($1.msg); /*15538*/
					$1.msg = $a(); /*15538*/
				} /*15538*/
				if ($1.mac06comp) { /*15539*/
					$k[$j++] = Infinity; /*15539*/
					$k[$j++] = $1.m06; /*15539*/
					$aload($1.msg); /*15539*/
					$1.msg = $a(); /*15539*/
				} /*15539*/
				$1.msglen = $1.msg.length; /*15541*/
				$1.lC = -5; /*15544*/
				$1.lB = -6; /*15544*/
				$1.lX = -7; /*15544*/
				$1.lT = -8; /*15544*/
				$1.lE = -9; /*15544*/
				$1.unl = -10; /*15544*/
				$1.sapp = -11; /*15545*/
				$1.usft = -12; /*15545*/
				$1.sft1 = -13; /*15545*/
				$1.sft2 = -14; /*15545*/
				$1.sft3 = -15; /*15545*/
				$1.eci = -16; /*15545*/
				$1.pad = -17; /*15545*/
				$1.unlcw = 254; /*15546*/
				$k[$j++] = "Avals"; /*15555*/
				$k[$j++] = Infinity; /*15555*/
				for (var _3D = 0; _3D <= 128; _3D += 1) { /*15549*/
					$k[$j++] = _3D; /*15549*/
					$k[$j++] = _3D + 1; /*15549*/
				} /*15549*/
				$k[$j++] = $1.pad; /*15554*/
				$k[$j++] = 129; /*15554*/
				for (var _3F = 0; _3F <= 99; _3F += 1) { /*15554*/
					var _3H = $cvrs($s(2), _3F, 10); /*15552*/
					var _3J = $strcpy($s(2), "00"); /*15552*/
					$puti(_3J, 2 - _3H.length, _3H); /*15552*/
					$k[$j++] = _3J; /*15553*/
					$k[$j++] = _3F + 130; /*15553*/
				} /*15553*/
				var _3W = $a([$1.lC, $1.lB, $1.fnc1, $1.sapp, $1.prog, $1.usft, $1.m05, $1.m06, $1.lX, $1.lT, $1.lE, $1.eci]); /*15555*/
				$k[$j++] = 229; /*15555*/
				for (var _3X = 0, _3Y = _3W.length; _3X < _3Y; _3X++) { /*15555*/
					var _3b = $k[--$j] + 1; /*15555*/
					$k[$j++] = $get(_3W, _3X); /*15555*/
					$k[$j++] = _3b; /*15555*/
					$k[$j++] = _3b; /*15555*/
				} /*15555*/
				$j--; /*15555*/
				var _3c = $d(); /*15555*/
				$1[$k[--$j]] = _3c; /*15556*/
				$k[$j++] = "Avals"; /*15558*/
				$k[$j++] = Infinity; /*15558*/
				$forall($1.Avals, function() { /*15558*/
					$k[$j++] = Infinity; /*15558*/
					var _3f = $k[--$j]; /*15558*/
					var _3g = $k[--$j]; /*15558*/
					$k[$j++] = _3f; /*15558*/
					$k[$j++] = _3g; /*15558*/
					var _3h = $a(); /*15558*/
					$k[$j++] = _3h; /*15558*/
				}); /*15558*/
				var _3i = $d(); /*15558*/
				$1[$k[--$j]] = _3i; /*15559*/
				$k[$j++] = "CNvals"; /*15567*/
				$k[$j++] = Infinity; /*15567*/
				$k[$j++] = $1.sft1; /*15566*/
				$k[$j++] = 0; /*15566*/
				$k[$j++] = $1.sft2; /*15566*/
				$k[$j++] = 1; /*15566*/
				$k[$j++] = $1.sft3; /*15566*/
				$k[$j++] = 2; /*15566*/
				$k[$j++] = 32; /*15566*/
				$k[$j++] = 3; /*15566*/
				for (var _3n = 48; _3n <= 57; _3n += 1) { /*15566*/
					$k[$j++] = _3n; /*15566*/
					$k[$j++] = _3n - 44; /*15566*/
				} /*15566*/
				for (var _3o = 65; _3o <= 90; _3o += 1) { /*15567*/
					$k[$j++] = _3o; /*15567*/
					$k[$j++] = _3o - 51; /*15567*/
				} /*15567*/
				var _3p = $d(); /*15567*/
				$1[$k[--$j]] = _3p; /*15568*/
				$k[$j++] = "C1vals"; /*15569*/
				$k[$j++] = Infinity; /*15569*/
				for (var _3r = 0; _3r <= 31; _3r += 1) { /*15569*/
					$k[$j++] = _3r; /*15569*/
					$k[$j++] = _3r; /*15569*/
				} /*15569*/
				var _3s = $d(); /*15569*/
				$1[$k[--$j]] = _3s; /*15569*/
				$k[$j++] = "C2vals"; /*15575*/
				$k[$j++] = Infinity; /*15575*/
				for (var _3u = 33; _3u <= 47; _3u += 1) { /*15571*/
					$k[$j++] = _3u; /*15571*/
					$k[$j++] = _3u - 33; /*15571*/
				} /*15571*/
				for (var _3v = 58; _3v <= 64; _3v += 1) { /*15572*/
					$k[$j++] = _3v; /*15572*/
					$k[$j++] = _3v - 43; /*15572*/
				} /*15572*/
				for (var _3w = 91; _3w <= 95; _3w += 1) { /*15573*/
					$k[$j++] = _3w; /*15573*/
					$k[$j++] = _3w - 69; /*15573*/
				} /*15573*/
				$k[$j++] = $1.fnc1; /*15575*/
				$k[$j++] = 27; /*15575*/
				$k[$j++] = $1.usft; /*15575*/
				$k[$j++] = 30; /*15575*/
				var _3z = $d(); /*15575*/
				$1[$k[--$j]] = _3z; /*15576*/
				$k[$j++] = "C3vals"; /*15577*/
				$k[$j++] = Infinity; /*15577*/
				for (var _41 = 96; _41 <= 127; _41 += 1) { /*15577*/
					$k[$j++] = _41; /*15577*/
					$k[$j++] = _41 - 96; /*15577*/
				} /*15577*/
				var _42 = $d(); /*15577*/
				$1[$k[--$j]] = _42; /*15577*/
				$k[$j++] = "Cvals"; /*15582*/
				$k[$j++] = Infinity; /*15582*/
				$forall($1.CNvals, function() { /*15579*/
					$k[$j++] = Infinity; /*15579*/
					var _45 = $k[--$j]; /*15579*/
					var _46 = $k[--$j]; /*15579*/
					$k[$j++] = _45; /*15579*/
					$k[$j++] = _46; /*15579*/
					var _47 = $a(); /*15579*/
					$k[$j++] = _47; /*15579*/
				}); /*15579*/
				$forall($1.C1vals, function() { /*15580*/
					$k[$j++] = Infinity; /*15580*/
					var _49 = $k[--$j]; /*15580*/
					var _4A = $k[--$j]; /*15580*/
					$k[$j++] = _49; /*15580*/
					$k[$j++] = $get($1.CNvals, $1.sft1); /*15580*/
					$k[$j++] = _4A; /*15580*/
					var _4E = $a(); /*15580*/
					$k[$j++] = _4E; /*15580*/
				}); /*15580*/
				$forall($1.C2vals, function() { /*15581*/
					$k[$j++] = Infinity; /*15581*/
					var _4G = $k[--$j]; /*15581*/
					var _4H = $k[--$j]; /*15581*/
					$k[$j++] = _4G; /*15581*/
					$k[$j++] = $get($1.CNvals, $1.sft2); /*15581*/
					$k[$j++] = _4H; /*15581*/
					var _4L = $a(); /*15581*/
					$k[$j++] = _4L; /*15581*/
				}); /*15581*/
				$forall($1.C3vals, function() { /*15582*/
					$k[$j++] = Infinity; /*15582*/
					var _4N = $k[--$j]; /*15582*/
					var _4O = $k[--$j]; /*15582*/
					$k[$j++] = _4N; /*15582*/
					$k[$j++] = $get($1.CNvals, $1.sft3); /*15582*/
					$k[$j++] = _4O; /*15582*/
					var _4S = $a(); /*15582*/
					$k[$j++] = _4S; /*15582*/
				}); /*15582*/
				var _4T = $d(); /*15582*/
				$1[$k[--$j]] = _4T; /*15583*/
				$k[$j++] = "TNvals"; /*15591*/
				$k[$j++] = Infinity; /*15591*/
				$k[$j++] = $1.sft1; /*15590*/
				$k[$j++] = 0; /*15590*/
				$k[$j++] = $1.sft2; /*15590*/
				$k[$j++] = 1; /*15590*/
				$k[$j++] = $1.sft3; /*15590*/
				$k[$j++] = 2; /*15590*/
				$k[$j++] = 32; /*15590*/
				$k[$j++] = 3; /*15590*/
				for (var _4Y = 48; _4Y <= 57; _4Y += 1) { /*15590*/
					$k[$j++] = _4Y; /*15590*/
					$k[$j++] = _4Y - 44; /*15590*/
				} /*15590*/
				for (var _4Z = 97; _4Z <= 122; _4Z += 1) { /*15591*/
					$k[$j++] = _4Z; /*15591*/
					$k[$j++] = _4Z - 83; /*15591*/
				} /*15591*/
				var _4a = $d(); /*15591*/
				$1[$k[--$j]] = _4a; /*15592*/
				$k[$j++] = "T1vals"; /*15593*/
				$k[$j++] = Infinity; /*15593*/
				for (var _4c = 0; _4c <= 31; _4c += 1) { /*15593*/
					$k[$j++] = _4c; /*15593*/
					$k[$j++] = _4c; /*15593*/
				} /*15593*/
				var _4d = $d(); /*15593*/
				$1[$k[--$j]] = _4d; /*15593*/
				$k[$j++] = "T2vals"; /*15599*/
				$k[$j++] = Infinity; /*15599*/
				for (var _4f = 33; _4f <= 47; _4f += 1) { /*15595*/
					$k[$j++] = _4f; /*15595*/
					$k[$j++] = _4f - 33; /*15595*/
				} /*15595*/
				for (var _4g = 58; _4g <= 64; _4g += 1) { /*15596*/
					$k[$j++] = _4g; /*15596*/
					$k[$j++] = _4g - 43; /*15596*/
				} /*15596*/
				for (var _4h = 91; _4h <= 95; _4h += 1) { /*15597*/
					$k[$j++] = _4h; /*15597*/
					$k[$j++] = _4h - 69; /*15597*/
				} /*15597*/
				$k[$j++] = $1.fnc1; /*15599*/
				$k[$j++] = 27; /*15599*/
				$k[$j++] = $1.usft; /*15599*/
				$k[$j++] = 30; /*15599*/
				var _4k = $d(); /*15599*/
				$1[$k[--$j]] = _4k; /*15600*/
				$k[$j++] = "T3vals"; /*15604*/
				$k[$j++] = Infinity; /*15604*/
				$k[$j++] = 96; /*15603*/
				$k[$j++] = 0; /*15603*/
				for (var _4m = 65; _4m <= 90; _4m += 1) { /*15603*/
					$k[$j++] = _4m; /*15603*/
					$k[$j++] = _4m - 64; /*15603*/
				} /*15603*/
				for (var _4n = 123; _4n <= 127; _4n += 1) { /*15604*/
					$k[$j++] = _4n; /*15604*/
					$k[$j++] = _4n - 96; /*15604*/
				} /*15604*/
				var _4o = $d(); /*15604*/
				$1[$k[--$j]] = _4o; /*15605*/
				$k[$j++] = "Tvals"; /*15610*/
				$k[$j++] = Infinity; /*15610*/
				$forall($1.TNvals, function() { /*15607*/
					$k[$j++] = Infinity; /*15607*/
					var _4r = $k[--$j]; /*15607*/
					var _4s = $k[--$j]; /*15607*/
					$k[$j++] = _4r; /*15607*/
					$k[$j++] = _4s; /*15607*/
					var _4t = $a(); /*15607*/
					$k[$j++] = _4t; /*15607*/
				}); /*15607*/
				$forall($1.T1vals, function() { /*15608*/
					$k[$j++] = Infinity; /*15608*/
					var _4v = $k[--$j]; /*15608*/
					var _4w = $k[--$j]; /*15608*/
					$k[$j++] = _4v; /*15608*/
					$k[$j++] = $get($1.TNvals, $1.sft1); /*15608*/
					$k[$j++] = _4w; /*15608*/
					var _50 = $a(); /*15608*/
					$k[$j++] = _50; /*15608*/
				}); /*15608*/
				$forall($1.T2vals, function() { /*15609*/
					$k[$j++] = Infinity; /*15609*/
					var _52 = $k[--$j]; /*15609*/
					var _53 = $k[--$j]; /*15609*/
					$k[$j++] = _52; /*15609*/
					$k[$j++] = $get($1.TNvals, $1.sft2); /*15609*/
					$k[$j++] = _53; /*15609*/
					var _57 = $a(); /*15609*/
					$k[$j++] = _57; /*15609*/
				}); /*15609*/
				$forall($1.T3vals, function() { /*15610*/
					$k[$j++] = Infinity; /*15610*/
					var _59 = $k[--$j]; /*15610*/
					var _5A = $k[--$j]; /*15610*/
					$k[$j++] = _59; /*15610*/
					$k[$j++] = $get($1.TNvals, $1.sft3); /*15610*/
					$k[$j++] = _5A; /*15610*/
					var _5E = $a(); /*15610*/
					$k[$j++] = _5E; /*15610*/
				}); /*15610*/
				var _5F = $d(); /*15610*/
				$1[$k[--$j]] = _5F; /*15611*/
				for (var _5H = 128; _5H <= 255; _5H += 1) { /*15619*/
					$1.i = _5H; /*15615*/
					$k[$j++] = $1.Avals; /*15616*/
					$k[$j++] = $1.i; /*15616*/
					$k[$j++] = Infinity; /*15616*/
					$aload($get($1.Avals, $1.usft)); /*15616*/
					$aload($get($1.Avals, $1.i - 128)); /*15616*/
					var _5Q = $a(); /*15616*/
					var _5R = $k[--$j]; /*15616*/
					$put($k[--$j], _5R, _5Q); /*15616*/
					$k[$j++] = $1.Cvals; /*15617*/
					$k[$j++] = $1.i; /*15617*/
					$k[$j++] = Infinity; /*15617*/
					$aload($get($1.Cvals, $1.usft)); /*15617*/
					$aload($get($1.Cvals, $1.i - 128)); /*15617*/
					var _5b = $a(); /*15617*/
					var _5c = $k[--$j]; /*15617*/
					$put($k[--$j], _5c, _5b); /*15617*/
					$k[$j++] = $1.Tvals; /*15618*/
					$k[$j++] = $1.i; /*15618*/
					$k[$j++] = Infinity; /*15618*/
					$aload($get($1.Tvals, $1.usft)); /*15618*/
					$aload($get($1.Tvals, $1.i - 128)); /*15618*/
					var _5m = $a(); /*15618*/
					var _5n = $k[--$j]; /*15618*/
					$put($k[--$j], _5n, _5m); /*15618*/
				} /*15618*/
				$k[$j++] = "Xvals"; /*15627*/
				$k[$j++] = Infinity; /*15627*/
				$k[$j++] = 13; /*15626*/
				$k[$j++] = 0; /*15626*/
				$k[$j++] = 42; /*15626*/
				$k[$j++] = 1; /*15626*/
				$k[$j++] = 62; /*15626*/
				$k[$j++] = 2; /*15626*/
				$k[$j++] = 32; /*15626*/
				$k[$j++] = 3; /*15626*/
				for (var _5p = 48; _5p <= 57; _5p += 1) { /*15626*/
					$k[$j++] = _5p; /*15626*/
					$k[$j++] = _5p - 44; /*15626*/
				} /*15626*/
				for (var _5q = 65; _5q <= 90; _5q += 1) { /*15627*/
					$k[$j++] = _5q; /*15627*/
					$k[$j++] = _5q - 51; /*15627*/
				} /*15627*/
				var _5r = $d(); /*15627*/
				$1[$k[--$j]] = _5r; /*15628*/
				$k[$j++] = "Xvals"; /*15630*/
				$k[$j++] = Infinity; /*15630*/
				$forall($1.Xvals, function() { /*15630*/
					$k[$j++] = Infinity; /*15630*/
					var _5u = $k[--$j]; /*15630*/
					var _5v = $k[--$j]; /*15630*/
					$k[$j++] = _5u; /*15630*/
					$k[$j++] = _5v; /*15630*/
					var _5w = $a(); /*15630*/
					$k[$j++] = _5w; /*15630*/
				}); /*15630*/
				var _5x = $d(); /*15630*/
				$1[$k[--$j]] = _5x; /*15631*/
				$k[$j++] = "Evals"; /*15636*/
				$k[$j++] = Infinity; /*15636*/
				for (var _5z = 64; _5z <= 94; _5z += 1) { /*15634*/
					$k[$j++] = _5z; /*15634*/
					$k[$j++] = _5z - 64; /*15634*/
				} /*15634*/
				$k[$j++] = $1.unl; /*15636*/
				$k[$j++] = 31; /*15636*/
				for (var _61 = 32; _61 <= 63; _61 += 1) { /*15636*/
					$k[$j++] = _61; /*15636*/
					$k[$j++] = _61; /*15636*/
				} /*15636*/
				var _62 = $d(); /*15636*/
				$1[$k[--$j]] = _62; /*15637*/
				$k[$j++] = "Evals"; /*15639*/
				$k[$j++] = Infinity; /*15639*/
				$forall($1.Evals, function() { /*15639*/
					$k[$j++] = Infinity; /*15639*/
					var _65 = $k[--$j]; /*15639*/
					var _66 = $k[--$j]; /*15639*/
					$k[$j++] = _65; /*15639*/
					$k[$j++] = _66; /*15639*/
					var _67 = $a(); /*15639*/
					$k[$j++] = _67; /*15639*/
				}); /*15639*/
				var _68 = $d(); /*15639*/
				$1[$k[--$j]] = _68; /*15640*/
				$k[$j++] = "Bvals"; /*15643*/
				$k[$j++] = Infinity; /*15643*/
				for (var _6A = 0; _6A <= 255; _6A += 1) { /*15643*/
					$k[$j++] = _6A; /*15643*/
					$k[$j++] = _6A; /*15643*/
				} /*15643*/
				var _6B = $d(); /*15643*/
				$1[$k[--$j]] = _6B; /*15644*/
				$k[$j++] = "Bvals"; /*15646*/
				$k[$j++] = Infinity; /*15646*/
				$forall($1.Bvals, function() { /*15646*/
					$k[$j++] = Infinity; /*15646*/
					var _6E = $k[--$j]; /*15646*/
					var _6F = $k[--$j]; /*15646*/
					$k[$j++] = _6E; /*15646*/
					$k[$j++] = _6F; /*15646*/
					var _6G = $a(); /*15646*/
					$k[$j++] = _6G; /*15646*/
				}); /*15646*/
				var _6H = $d(); /*15646*/
				$1[$k[--$j]] = _6H; /*15647*/
				$1.encvals = $a([$1.Avals, $1.Cvals, $1.Tvals, $1.Xvals, $1.Evals, $1.Bvals]); /*15649*/
				$k[$j++] = Infinity; /*15651*/
				for (var _6R = 0, _6S = $1.msglen; _6R < _6S; _6R++) { /*15651*/
					$k[$j++] = 0; /*15651*/
				} /*15651*/
				$k[$j++] = 0; /*15651*/
				$1.numD = $a(); /*15651*/
				$k[$j++] = Infinity; /*15652*/
				for (var _6V = 0, _6W = $1.msglen; _6V < _6W; _6V++) { /*15652*/
					$k[$j++] = 0; /*15652*/
				} /*15652*/
				$k[$j++] = 9999; /*15652*/
				$1.nextXterm = $a(); /*15652*/
				$k[$j++] = Infinity; /*15653*/
				for (var _6Z = 0, _6a = $1.msglen; _6Z < _6a; _6Z++) { /*15653*/
					$k[$j++] = 0; /*15653*/
				} /*15653*/
				$k[$j++] = 9999; /*15653*/
				$1.nextNonX = $a(); /*15653*/
				for (var _6d = $1.msglen - 1; _6d >= 0; _6d -= 1) { /*15670*/
					$1.i = _6d; /*15655*/
					$1.barchar = $get($1.msg, $1.i); /*15656*/
					if (($1.barchar >= 48) && ($1.barchar <= 57)) { /*15659*/
						$put($1.numD, $1.i, $get($1.numD, $1.i + 1) + 1); /*15658*/
					} /*15658*/
					if ((($1.barchar == 13) || ($1.barchar == 42)) || ($1.barchar == 62)) { /*15663*/
						$put($1.nextXterm, $1.i, 0); /*15661*/
					} else { /*15663*/
						$put($1.nextXterm, $1.i, $get($1.nextXterm, $1.i + 1) + 1); /*15663*/
					} /*15663*/
					var _70 = $get($1.Xvals, $1.barchar) !== undefined; /*15665*/
					if (!_70) { /*15668*/
						$put($1.nextNonX, $1.i, 0); /*15666*/
					} else { /*15668*/
						$put($1.nextNonX, $1.i, $get($1.nextNonX, $1.i + 1) + 1); /*15668*/
					} /*15668*/
				} /*15668*/
				$k[$j++] = Infinity; /*15671*/
				var _78 = $1.nextXterm; /*15671*/
				for (var _79 = 0, _7A = _78.length; _79 < _7A; _79++) { /*15671*/
					var _7B = $get(_78, _79); /*15671*/
					$k[$j++] = _7B; /*15671*/
					if (_7B > 10000) { /*15671*/
						$j--; /*15671*/
						$k[$j++] = 10000; /*15671*/
					} /*15671*/
				} /*15671*/
				$1.nextXterm = $a(); /*15671*/
				$k[$j++] = Infinity; /*15672*/
				var _7D = $1.nextNonX; /*15672*/
				for (var _7E = 0, _7F = _7D.length; _7E < _7F; _7E++) { /*15672*/
					var _7G = $get(_7D, _7E); /*15672*/
					$k[$j++] = _7G; /*15672*/
					if (_7G > 10000) { /*15672*/
						$j--; /*15672*/
						$k[$j++] = 10000; /*15672*/
					} /*15672*/
				} /*15672*/
				$1.nextNonX = $a(); /*15672*/
				$1.isD = function() {
					$k[$j++] = ($1.char >= 48) && ($1.char <= 57); /*15674*/
				}; /*15674*/
				$1.isC = function() {
					var _7M = $get($1.CNvals, $1.char) !== undefined; /*15675*/
					$k[$j++] = _7M; /*15675*/
				}; /*15675*/
				$1.isT = function() {
					var _7P = $get($1.TNvals, $1.char) !== undefined; /*15676*/
					$k[$j++] = _7P; /*15676*/
				}; /*15676*/
				$1.isX = function() {
					var _7S = $get($1.Xvals, $1.char) !== undefined; /*15677*/
					$k[$j++] = _7S; /*15677*/
				}; /*15677*/
				$1.isE = function() {
					var _7V = $get($1.Evals, $1.char) !== undefined; /*15678*/
					$k[$j++] = _7V; /*15678*/
				}; /*15678*/
				$1.isEA = function() {
					$k[$j++] = $1.char > 127; /*15679*/
				}; /*15679*/
				$1.isFN = function() {
					$k[$j++] = $1.char < 0; /*15680*/
				}; /*15680*/
				$1.XtermFirst = function() {
					var _7Y = $k[--$j]; /*15681*/
					$k[$j++] = $lt($get($1.nextXterm, _7Y), $get($1.nextNonX, _7Y)); /*15681*/
				}; /*15681*/
				$1.A = 0; /*15683*/
				$1.C = 1; /*15683*/
				$1.T = 2; /*15683*/
				$1.X = 3; /*15683*/
				$1.E = 4; /*15683*/
				$1.B = 5; /*15683*/
				$1.lookup = function() {
					$1.ac = 1; /*15686*/
					$1.cc = 2; /*15686*/
					$1.tc = 2; /*15686*/
					$1.xc = 2; /*15686*/
					$1.ec = 2; /*15686*/
					$1.bc = 2.25; /*15686*/
					if ($1.mode == $1.A) { /*15687*/
						$1.ac = 0; /*15687*/
						$1.cc = 1; /*15687*/
						$1.tc = 1; /*15687*/
						$1.xc = 1; /*15687*/
						$1.ec = 1; /*15687*/
						$1.bc = 1.25; /*15687*/
					} /*15687*/
					if ($1.mode == $1.C) { /*15688*/
						$1.cc = 0; /*15688*/
					} /*15688*/
					if ($1.mode == $1.T) { /*15689*/
						$1.tc = 0; /*15689*/
					} /*15689*/
					if ($1.mode == $1.X) { /*15690*/
						$1.xc = 0; /*15690*/
					} /*15690*/
					if ($1.mode == $1.E) { /*15691*/
						$1.ec = 0; /*15691*/
					} /*15691*/
					if ($1.mode == $1.B) { /*15692*/
						$1.bc = 0; /*15692*/
					} /*15692*/
					for (var _7p = 0, _7q = 1; _7p < _7q; _7p++) { /*15725*/
						$1.k = 0; /*15694*/
						for (;;) { /*15724*/
							if (($1.i + $1.k) == $1.msglen) { /*15703*/
								var _7u = $a(["ac", "cc", "tc", "xc", "ec", "bc"]); /*15696*/
								for (var _7v = 0, _7w = _7u.length; _7v < _7w; _7v++) { /*15696*/
									var _7x = $get(_7u, _7v); /*15696*/
									$1[_7x] = Math.ceil($1[_7x]); /*15696*/
								} /*15696*/
								var _84 = $a([$1.cc, $1.tc, $1.xc, $1.ec, $1.bc]); /*15697*/
								$k[$j++] = true; /*15697*/
								for (var _85 = 0, _86 = _84.length; _85 < _86; _85++) { /*15697*/
									var _89 = $k[--$j]; /*15697*/
									$k[$j++] = _89 && ($1.ac <= $get(_84, _85)); /*15697*/
								} /*15697*/
								if ($k[--$j]) { /*15697*/
									$k[$j++] = $1.A; /*15697*/
									break; /*15697*/
								} /*15697*/
								var _8H = $a([$1.ac, $1.cc, $1.tc, $1.xc, $1.ec]); /*15698*/
								$k[$j++] = true; /*15698*/
								for (var _8I = 0, _8J = _8H.length; _8I < _8J; _8I++) { /*15698*/
									var _8M = $k[--$j]; /*15698*/
									$k[$j++] = _8M && ($1.bc < $get(_8H, _8I)); /*15698*/
								} /*15698*/
								if ($k[--$j]) { /*15698*/
									$k[$j++] = $1.B; /*15698*/
									break; /*15698*/
								} /*15698*/
								var _8U = $a([$1.ac, $1.cc, $1.tc, $1.xc, $1.bc]); /*15699*/
								$k[$j++] = true; /*15699*/
								for (var _8V = 0, _8W = _8U.length; _8V < _8W; _8V++) { /*15699*/
									var _8Z = $k[--$j]; /*15699*/
									$k[$j++] = _8Z && ($1.ec < $get(_8U, _8V)); /*15699*/
								} /*15699*/
								if ($k[--$j]) { /*15699*/
									$k[$j++] = $1.E; /*15699*/
									break; /*15699*/
								} /*15699*/
								var _8h = $a([$1.ac, $1.cc, $1.xc, $1.ec, $1.bc]); /*15700*/
								$k[$j++] = true; /*15700*/
								for (var _8i = 0, _8j = _8h.length; _8i < _8j; _8i++) { /*15700*/
									var _8m = $k[--$j]; /*15700*/
									$k[$j++] = _8m && ($1.tc < $get(_8h, _8i)); /*15700*/
								} /*15700*/
								if ($k[--$j]) { /*15700*/
									$k[$j++] = $1.T; /*15700*/
									break; /*15700*/
								} /*15700*/
								var _8u = $a([$1.ac, $1.cc, $1.tc, $1.ec, $1.bc]); /*15701*/
								$k[$j++] = true; /*15701*/
								for (var _8v = 0, _8w = _8u.length; _8v < _8w; _8v++) { /*15701*/
									var _8z = $k[--$j]; /*15701*/
									$k[$j++] = _8z && ($1.xc < $get(_8u, _8v)); /*15701*/
								} /*15701*/
								if ($k[--$j]) { /*15701*/
									$k[$j++] = $1.X; /*15701*/
									break; /*15701*/
								} /*15701*/
								$k[$j++] = $1.C; /*15702*/
								break; /*15702*/
							} /*15702*/
							$1.char = $get($1.msg, $1.i + $1.k); /*15704*/
							$k[$j++] = "ac"; /*15705*/
							$k[$j++] = $1.ac; /*15705*/
							if ($1.isD() == $b) break; /*15705*/
							if ($k[--$j]) { /*15705*/
								var _99 = $k[--$j]; /*15705*/
								$k[$j++] = _99 + (1 / 2); /*15705*/
							} else { /*15705*/
								if ($1.isEA() == $b) break; /*15705*/
								if ($k[--$j]) { /*15705*/
									var _9B = $k[--$j]; /*15705*/
									$k[$j++] = Math.ceil(_9B) + 2; /*15705*/
								} else { /*15705*/
									var _9C = $k[--$j]; /*15705*/
									$k[$j++] = Math.ceil(_9C) + 1; /*15705*/
								} /*15705*/
							} /*15705*/
							var _9D = $k[--$j]; /*15705*/
							$1[$k[--$j]] = _9D; /*15705*/
							$k[$j++] = "cc"; /*15706*/
							$k[$j++] = $1.cc; /*15706*/
							if ($1.isC() == $b) break; /*15706*/
							if ($k[--$j]) { /*15706*/
								var _9H = $k[--$j]; /*15706*/
								$k[$j++] = _9H + (2 / 3); /*15706*/
							} else { /*15706*/
								if ($1.isEA() == $b) break; /*15706*/
								if ($k[--$j]) { /*15706*/
									var _9J = $k[--$j]; /*15706*/
									$k[$j++] = _9J + (8 / 3); /*15706*/
								} else { /*15706*/
									var _9K = $k[--$j]; /*15706*/
									$k[$j++] = _9K + (4 / 3); /*15706*/
								} /*15706*/
							} /*15706*/
							var _9L = $k[--$j]; /*15706*/
							$1[$k[--$j]] = _9L; /*15706*/
							$k[$j++] = "tc"; /*15707*/
							$k[$j++] = $1.tc; /*15707*/
							if ($1.isT() == $b) break; /*15707*/
							if ($k[--$j]) { /*15707*/
								var _9P = $k[--$j]; /*15707*/
								$k[$j++] = _9P + (2 / 3); /*15707*/
							} else { /*15707*/
								if ($1.isEA() == $b) break; /*15707*/
								if ($k[--$j]) { /*15707*/
									var _9R = $k[--$j]; /*15707*/
									$k[$j++] = _9R + (8 / 3); /*15707*/
								} else { /*15707*/
									var _9S = $k[--$j]; /*15707*/
									$k[$j++] = _9S + (4 / 3); /*15707*/
								} /*15707*/
							} /*15707*/
							var _9T = $k[--$j]; /*15707*/
							$1[$k[--$j]] = _9T; /*15707*/
							$k[$j++] = "xc"; /*15708*/
							$k[$j++] = $1.xc; /*15708*/
							if ($1.isX() == $b) break; /*15708*/
							if ($k[--$j]) { /*15708*/
								var _9X = $k[--$j]; /*15708*/
								$k[$j++] = _9X + (2 / 3); /*15708*/
							} else { /*15708*/
								if ($1.isEA() == $b) break; /*15708*/
								if ($k[--$j]) { /*15708*/
									var _9Z = $k[--$j]; /*15708*/
									$k[$j++] = _9Z + (13 / 3); /*15708*/
								} else { /*15708*/
									var _9a = $k[--$j]; /*15708*/
									$k[$j++] = _9a + (10 / 3); /*15708*/
								} /*15708*/
							} /*15708*/
							var _9b = $k[--$j]; /*15708*/
							$1[$k[--$j]] = _9b; /*15708*/
							$k[$j++] = "ec"; /*15709*/
							$k[$j++] = $1.ec; /*15709*/
							if ($1.isE() == $b) break; /*15709*/
							if ($k[--$j]) { /*15709*/
								var _9f = $k[--$j]; /*15709*/
								$k[$j++] = _9f + (3 / 4); /*15709*/
							} else { /*15709*/
								if ($1.isEA() == $b) break; /*15709*/
								if ($k[--$j]) { /*15709*/
									var _9h = $k[--$j]; /*15709*/
									$k[$j++] = _9h + (17 / 4); /*15709*/
								} else { /*15709*/
									var _9i = $k[--$j]; /*15709*/
									$k[$j++] = _9i + (13 / 4); /*15709*/
								} /*15709*/
							} /*15709*/
							var _9j = $k[--$j]; /*15709*/
							$1[$k[--$j]] = _9j; /*15709*/
							$k[$j++] = "bc"; /*15710*/
							$k[$j++] = $1.bc; /*15710*/
							if ($1.isFN() == $b) break; /*15710*/
							if ($k[--$j]) { /*15710*/
								var _9n = $k[--$j]; /*15710*/
								$k[$j++] = _9n + 4; /*15710*/
							} else { /*15710*/
								var _9o = $k[--$j]; /*15710*/
								$k[$j++] = _9o + 1; /*15710*/
							} /*15710*/
							var _9p = $k[--$j]; /*15710*/
							$1[$k[--$j]] = _9p; /*15710*/
							if ($1.k >= 4) { /*15722*/
								var _9x = $a([$1.cc, $1.tc, $1.xc, $1.ec, $1.bc]); /*15712*/
								$k[$j++] = true; /*15712*/
								for (var _9y = 0, _9z = _9x.length; _9y < _9z; _9y++) { /*15712*/
									var _A2 = $k[--$j]; /*15712*/
									$k[$j++] = _A2 && (($1.ac + 1) <= $get(_9x, _9y)); /*15712*/
								} /*15712*/
								if ($k[--$j]) { /*15712*/
									$k[$j++] = $1.A; /*15712*/
									break; /*15712*/
								} /*15712*/
								if (($1.bc + 1) <= $1.ac) { /*15713*/
									$k[$j++] = $1.B; /*15713*/
									break; /*15713*/
								} /*15713*/
								var _AC = $a([$1.cc, $1.tc, $1.xc, $1.ec]); /*15714*/
								$k[$j++] = true; /*15714*/
								for (var _AD = 0, _AE = _AC.length; _AD < _AE; _AD++) { /*15714*/
									var _AH = $k[--$j]; /*15714*/
									$k[$j++] = _AH && (($1.bc + 1) < $get(_AC, _AD)); /*15714*/
								} /*15714*/
								if ($k[--$j]) { /*15714*/
									$k[$j++] = $1.B; /*15714*/
									break; /*15714*/
								} /*15714*/
								var _AP = $a([$1.ac, $1.cc, $1.tc, $1.xc, $1.bc]); /*15715*/
								$k[$j++] = true; /*15715*/
								for (var _AQ = 0, _AR = _AP.length; _AQ < _AR; _AQ++) { /*15715*/
									var _AU = $k[--$j]; /*15715*/
									$k[$j++] = _AU && (($1.ec + 1) < $get(_AP, _AQ)); /*15715*/
								} /*15715*/
								if ($k[--$j]) { /*15715*/
									$k[$j++] = $1.E; /*15715*/
									break; /*15715*/
								} /*15715*/
								var _Ac = $a([$1.ac, $1.cc, $1.xc, $1.ec, $1.bc]); /*15716*/
								$k[$j++] = true; /*15716*/
								for (var _Ad = 0, _Ae = _Ac.length; _Ad < _Ae; _Ad++) { /*15716*/
									var _Ah = $k[--$j]; /*15716*/
									$k[$j++] = _Ah && (($1.tc + 1) < $get(_Ac, _Ad)); /*15716*/
								} /*15716*/
								if ($k[--$j]) { /*15716*/
									$k[$j++] = $1.T; /*15716*/
									break; /*15716*/
								} /*15716*/
								var _Ap = $a([$1.ac, $1.cc, $1.tc, $1.ec, $1.bc]); /*15717*/
								$k[$j++] = true; /*15717*/
								for (var _Aq = 0, _Ar = _Ap.length; _Aq < _Ar; _Aq++) { /*15717*/
									var _Au = $k[--$j]; /*15717*/
									$k[$j++] = _Au && (($1.xc + 1) < $get(_Ap, _Aq)); /*15717*/
								} /*15717*/
								if ($k[--$j]) { /*15717*/
									$k[$j++] = $1.X; /*15717*/
									break; /*15717*/
								} /*15717*/
								var _B1 = $a([$1.ac, $1.tc, $1.ec, $1.bc]); /*15718*/
								$k[$j++] = true; /*15718*/
								for (var _B2 = 0, _B3 = _B1.length; _B2 < _B3; _B2++) { /*15718*/
									var _B6 = $k[--$j]; /*15718*/
									$k[$j++] = _B6 && (($1.cc + 1) < $get(_B1, _B2)); /*15718*/
								} /*15718*/
								if ($k[--$j]) { /*15721*/
									if ($1.cc < $1.xc) { /*15719*/
										$k[$j++] = $1.C; /*15719*/
										break; /*15719*/
									} /*15719*/
									if ($1.cc == $1.xc) { /*15720*/
										$k[$j++] = ($1.i + $1.k) + 1; /*15720*/
										if ($1.XtermFirst() == $b) break; /*15720*/
										if ($k[--$j]) { /*15720*/
											$k[$j++] = $1.X; /*15720*/
											break; /*15720*/
										} else { /*15720*/
											$k[$j++] = $1.C; /*15720*/
											break; /*15720*/
										} /*15720*/
									} /*15720*/
								} /*15720*/
							} /*15720*/
							$1.k = $1.k + 1; /*15723*/
						} /*15723*/
					} /*15723*/
				}; /*15726*/
				$1.addtocws = function() {
					var _BJ = $k[--$j]; /*15729*/
					$puti($1.cws, $1.j, _BJ); /*15729*/
					$1.j = _BJ.length + $1.j; /*15730*/
				}; /*15731*/
				$1.encA = function() {
					for (var _BN = 0, _BO = 1; _BN < _BO; _BN++) { /*15749*/
						if ($get($1.numD, $1.i) >= 2) { /*15739*/
							var _BS = $s(2); /*15736*/
							$put(_BS, 0, $get($1.msg, $1.i)); /*15736*/
							$put(_BS, 1, $get($1.msg, $1.i + 1)); /*15736*/
							$k[$j++] = $get($1.Avals, _BS); /*15736*/
							if ($1.addtocws() == $b) break; /*15736*/
							$1.i = $1.i + 2; /*15737*/
							break; /*15738*/
						} /*15738*/
						$k[$j++] = "newmode"; /*15740*/
						if ($1.lookup() == $b) break; /*15740*/
						var _Bc = $k[--$j]; /*15740*/
						$1[$k[--$j]] = _Bc; /*15740*/
						if ($1.newmode != $1.mode) { /*15745*/
							$k[$j++] = $get($1.Avals, $get($a([-1, $1.lC, $1.lT, $1.lX, $1.lE, $1.lB]), $1.newmode)); /*15742*/
							if ($1.addtocws() == $b) break; /*15742*/
							$1.mode = $1.newmode; /*15743*/
							break; /*15744*/
						} /*15744*/
						$k[$j++] = $get($1.Avals, $get($1.msg, $1.i)); /*15746*/
						if ($1.addtocws() == $b) break; /*15746*/
						$1.i = $1.i + 1; /*15747*/
						break; /*15748*/
					} /*15748*/
				}; /*15750*/
				$1.CTXvalstocws = function() {
					$1.in = $k[--$j]; /*15753*/
					$k[$j++] = Infinity; /*15754*/
					for (var _C0 = 0, _Bz = $1.in.length - 1; _C0 <= _Bz; _C0 += 3) { /*15758*/
						$k[$j++] = 0; /*15756*/
						$forall($geti($1.in, _C0, 3), function() { /*15756*/
							var _C3 = $k[--$j]; /*15756*/
							var _C4 = $k[--$j]; /*15756*/
							$k[$j++] = (_C4 + _C3) * 40; /*15756*/
						}); /*15756*/
						var _C6 = (~~($k[--$j] / 40)) + 1; /*15757*/
						$k[$j++] = ~~(_C6 / 256); /*15757*/
						$k[$j++] = _C6 % 256; /*15757*/
					} /*15757*/
					$astore($a($counttomark())); /*15759*/
					var _C9 = $k[--$j]; /*15759*/
					var _CA = $k[--$j]; /*15759*/
					$k[$j++] = _C9; /*15759*/
				}; /*15760*/
				$1.encCTX = function() {
					$1.p = 0; /*15763*/
					$1.ctxvals = $a(2500); /*15764*/
					$1.done = false; /*15765*/
					for (;;) { /*15842*/
						if ($1.i == $1.msglen) { /*15769*/
							break; /*15769*/
						} /*15769*/
						var _CK = $get($get($1.encvals, $1.mode), $get($1.msg, $1.i)) !== undefined; /*15770*/
						if (!_CK) { /*15770*/
							break; /*15770*/
						} /*15770*/
						if (($1.p % 3) == 0) { /*15837*/
							$k[$j++] = "newmode"; /*15772*/
							if ($1.lookup() == $b) break; /*15772*/
							var _CM = $k[--$j]; /*15772*/
							$1[$k[--$j]] = _CM; /*15772*/
							if ($ne($1.newmode, $1.mode)) { /*15782*/
								$k[$j++] = $geti($1.ctxvals, 0, $1.p); /*15774*/
								if ($1.CTXvalstocws() == $b) break; /*15774*/
								if ($1.addtocws() == $b) break; /*15774*/
								$k[$j++] = $a([$1.unlcw]); /*15775*/
								if ($1.addtocws() == $b) break; /*15775*/
								if ($1.newmode != $1.A) { /*15778*/
									$k[$j++] = $get($1.Avals, $get($a([-1, $1.lC, $1.lT, $1.lX, $1.lE, $1.lB]), $1.newmode)); /*15777*/
									if ($1.addtocws() == $b) break; /*15777*/
								} /*15777*/
								$1.mode = $1.newmode; /*15779*/
								$1.done = true; /*15780*/
								break; /*15781*/
							} /*15781*/
							if (($1.msglen - $1.i) <= 3) { /*15836*/
								$1.remcws = $get($1.numremcws, $1.j + ((~~($1.p / 3)) * 2)); /*15784*/
								$k[$j++] = Infinity; /*15793*/
								$forall($geti($1.msg, $1.i, $1.msglen - $1.i), function() { /*15792*/
									var _Ct = $k[--$j]; /*15787*/
									var _Cx = $get($get($1.encvals, $1.mode), _Ct) !== undefined; /*15787*/
									$k[$j++] = _Ct; /*15791*/
									if (_Cx) { /*15790*/
										$aload($get($get($1.encvals, $1.mode), $k[--$j])); /*15788*/
									} else { /*15790*/
										$j--; /*15790*/
										$k[$j++] = -1; /*15790*/
										$k[$j++] = -1; /*15790*/
										$k[$j++] = -1; /*15790*/
										$k[$j++] = -1; /*15790*/
									} /*15790*/
								}); /*15790*/
								$1.remvals = $a(); /*15793*/
								if (($1.remcws == 2) && ($1.remvals.length == 3)) { /*15804*/
									$k[$j++] = Infinity; /*15798*/
									$aload($geti($1.ctxvals, 0, $1.p)); /*15797*/
									$aload($1.remvals); /*15798*/
									var _DA = $a(); /*15798*/
									$k[$j++] = _DA; /*15799*/
									if ($1.CTXvalstocws() == $b) break; /*15799*/
									if ($1.addtocws() == $b) break; /*15799*/
									$1.mode = $1.A; /*15800*/
									$1.i = $1.msglen; /*15801*/
									$1.done = true; /*15802*/
									break; /*15803*/
								} /*15803*/
								if ((($1.remcws == 2) && ($1.remvals.length == 2)) && ($1.mode != $1.X)) { /*15816*/
									$k[$j++] = Infinity; /*15810*/
									$aload($geti($1.ctxvals, 0, $1.p)); /*15808*/
									$aload($1.remvals); /*15809*/
									$aload($get($get($1.encvals, $1.mode), $1.sft1)); /*15810*/
									var _DQ = $a(); /*15810*/
									$k[$j++] = _DQ; /*15811*/
									if ($1.CTXvalstocws() == $b) break; /*15811*/
									if ($1.addtocws() == $b) break; /*15811*/
									$1.mode = $1.A; /*15812*/
									$1.i = $1.msglen; /*15813*/
									$1.done = true; /*15814*/
									break; /*15815*/
								} /*15815*/
								if (($1.remcws == 2) && ($1.remvals.length == 1)) { /*15826*/
									$k[$j++] = $geti($1.ctxvals, 0, $1.p); /*15819*/
									if ($1.CTXvalstocws() == $b) break; /*15819*/
									if ($1.addtocws() == $b) break; /*15819*/
									$k[$j++] = $a([$1.unlcw]); /*15820*/
									if ($1.addtocws() == $b) break; /*15820*/
									$k[$j++] = $get($1.Avals, $get($1.msg, $1.i)); /*15821*/
									if ($1.addtocws() == $b) break; /*15821*/
									$1.mode = $1.A; /*15822*/
									$1.i = $1.msglen; /*15823*/
									$1.done = true; /*15824*/
									break; /*15825*/
								} /*15825*/
								if (($1.remcws == 1) && ($1.remvals.length == 1)) { /*15835*/
									$k[$j++] = $geti($1.ctxvals, 0, $1.p); /*15829*/
									if ($1.CTXvalstocws() == $b) break; /*15829*/
									if ($1.addtocws() == $b) break; /*15829*/
									$k[$j++] = $get($1.Avals, $get($1.msg, $1.i)); /*15830*/
									if ($1.addtocws() == $b) break; /*15830*/
									$1.mode = $1.A; /*15831*/
									$1.i = $1.msglen; /*15832*/
									$1.done = true; /*15833*/
									break; /*15834*/
								} /*15834*/
							} /*15834*/
						} /*15834*/
						var _Dz = $get($get($1.encvals, $1.mode), $get($1.msg, $1.i)); /*15838*/
						$puti($1.ctxvals, $1.p, _Dz); /*15839*/
						$1.p = _Dz.length + $1.p; /*15840*/
						$1.i = $1.i + 1; /*15841*/
					} /*15841*/
					if (!$1.done) { /*15866*/
						for (;;) { /*15850*/
							if (($1.p % 3) == 0) { /*15847*/
								break; /*15847*/
							} /*15847*/
							$1.i = $1.i - 1; /*15848*/
							$1.p = $1.p - $get($get($1.encvals, $1.mode), $get($1.msg, $1.i)).length; /*15849*/
						} /*15849*/
						$k[$j++] = Infinity; /*15852*/
						$aload($geti($1.ctxvals, 0, $1.p)); /*15852*/
						var _EI = $a(); /*15852*/
						$k[$j++] = _EI; /*15853*/
						if ($1.CTXvalstocws() == $b) return $b; /*15853*/
						if ($1.addtocws() == $b) return $b; /*15853*/
						$k[$j++] = $a([$1.unlcw]); /*15854*/
						if ($1.addtocws() == $b) return $b; /*15854*/
						$1.mode = $1.A; /*15855*/
						if ($1.i != $1.msglen) { /*15865*/
							if ($get($1.numD, $1.i) >= 2) { /*15863*/
								var _ER = $s(2); /*15859*/
								$put(_ER, 0, $get($1.msg, $1.i)); /*15859*/
								$put(_ER, 1, $get($1.msg, $1.i + 1)); /*15859*/
								$k[$j++] = $get($1.Avals, _ER); /*15859*/
								if ($1.addtocws() == $b) return $b; /*15859*/
								$1.i = $1.i + 2; /*15860*/
							} else { /*15863*/
								$k[$j++] = $get($1.Avals, $get($1.msg, $1.i)); /*15862*/
								if ($1.addtocws() == $b) return $b; /*15862*/
								$1.i = $1.i + 1; /*15863*/
							} /*15863*/
						} /*15863*/
					} /*15863*/
				}; /*15868*/
				$1.Evalstocws = function() {
					$1.in = $k[--$j]; /*15871*/
					$1.inlen = $1.in.length; /*15872*/
					$1.outlen = ~~(Math.ceil(($1.in.length / 4) * 3)); /*15873*/
					$k[$j++] = Infinity; /*15874*/
					$aload($1.in); /*15874*/
					$k[$j++] = 0; /*15874*/
					$k[$j++] = 0; /*15874*/
					$k[$j++] = 0; /*15874*/
					$1.in = $a(); /*15874*/
					$k[$j++] = Infinity; /*15875*/
					for (var _Eo = 0, _En = $1.inlen - 1; _Eo <= _En; _Eo += 4) { /*15881*/
						$k[$j++] = 0; /*15877*/
						$forall($geti($1.in, _Eo, 4), function() { /*15877*/
							var _Er = $k[--$j]; /*15877*/
							var _Es = $k[--$j]; /*15877*/
							$k[$j++] = $or(_Es, _Er) << 6; /*15877*/
						}); /*15877*/
						var _Eu = $k[--$j] >>> 6; /*15878*/
						$k[$j++] = (_Eu >>> 16) & 255; /*15880*/
						$k[$j++] = (_Eu >>> 8) & 255; /*15880*/
						$k[$j++] = _Eu & 255; /*15880*/
					} /*15880*/
					$astore($a($counttomark())); /*15882*/
					var _Ex = $k[--$j]; /*15882*/
					var _Ey = $k[--$j]; /*15882*/
					$k[$j++] = $geti(_Ex, 0, $1.outlen); /*15883*/
				}; /*15884*/
				$1.encE = function() {
					$1.p = 0; /*15887*/
					$1.edifactvals = $a(2100); /*15888*/
					for (;;) { /*15917*/
						if ($1.i == $1.msglen) { /*15892*/
							break; /*15892*/
						} /*15892*/
						var _F8 = $get($1.Evals, $get($1.msg, $1.i)) !== undefined; /*15893*/
						if (!_F8) { /*15893*/
							break; /*15893*/
						} /*15893*/
						if (($1.p % 4) == 0) { /*15912*/
							if (($1.msglen - $1.i) <= 2) { /*15910*/
								$1.remcws = $get($1.numremcws, $1.j + ((~~($1.p / 4)) * 3)); /*15896*/
								$k[$j++] = Infinity; /*15901*/
								$forall($geti($1.msg, $1.i, $1.msglen - $1.i), function() { /*15900*/
									$aload($get($1.Avals, $k[--$j])); /*15899*/
								}); /*15899*/
								$1.remvals = $a(); /*15901*/
								if ((($1.remcws == 1) || ($1.remcws == 2)) && ($1.remvals.length <= $1.remcws)) { /*15909*/
									$k[$j++] = $geti($1.edifactvals, 0, $1.p); /*15904*/
									if ($1.Evalstocws() == $b) break; /*15904*/
									if ($1.addtocws() == $b) break; /*15904*/
									$k[$j++] = $1.remvals; /*15905*/
									if ($1.addtocws() == $b) break; /*15905*/
									$1.mode = $1.A; /*15906*/
									$1.i = $1.msglen; /*15907*/
									break; /*15908*/
								} /*15908*/
							} /*15908*/
							if ($1.lookup() == $b) break; /*15911*/
							if ($k[--$j] != $1.mode) { /*15911*/
								break; /*15911*/
							} /*15911*/
						} /*15911*/
						var _Ff = $get($1.Evals, $get($1.msg, $1.i)); /*15913*/
						$puti($1.edifactvals, $1.p, _Ff); /*15914*/
						$1.p = _Ff.length + $1.p; /*15915*/
						$1.i = $1.i + 1; /*15916*/
					} /*15916*/
					if ($1.mode != $1.A) { /*15939*/
						$1.remcws = $get($1.numremcws, ($1.j + ((~~($1.p / 4)) * 3)) - 1) - 1; /*15921*/
						if (((($1.p % 4) != 0) || ($1.i != $1.msglen)) || ($1.remcws >= 3)) { /*15926*/
							var _Fw = $get($1.Evals, $1.unl); /*15923*/
							$puti($1.edifactvals, $1.p, _Fw); /*15924*/
							$1.p = _Fw.length + $1.p; /*15925*/
						} /*15925*/
						$k[$j++] = $geti($1.edifactvals, 0, $1.p); /*15927*/
						if ($1.Evalstocws() == $b) return $b; /*15927*/
						if ($1.addtocws() == $b) return $b; /*15927*/
						$1.mode = $1.A; /*15928*/
						if ($1.i != $1.msglen) { /*15938*/
							if ($get($1.numD, $1.i) >= 2) { /*15936*/
								var _G9 = $s(2); /*15932*/
								$put(_G9, 0, $get($1.msg, $1.i)); /*15932*/
								$put(_G9, 1, $get($1.msg, $1.i + 1)); /*15932*/
								$k[$j++] = $get($1.Avals, _G9); /*15932*/
								if ($1.addtocws() == $b) return $b; /*15932*/
								$1.i = $1.i + 2; /*15933*/
							} else { /*15936*/
								$k[$j++] = $get($1.Avals, $get($1.msg, $1.i)); /*15935*/
								if ($1.addtocws() == $b) return $b; /*15935*/
								$1.i = $1.i + 1; /*15936*/
							} /*15936*/
						} /*15936*/
					} /*15936*/
				}; /*15941*/
				$1.encB = function() {
					$1.p = 0; /*15944*/
					$1.bvals = $a(1558); /*15944*/
					for (;;) { /*15950*/
						if ($1.i == $1.msglen) { /*15945*/
							break; /*15945*/
						} /*15945*/
						if ($1.lookup() == $b) break; /*15946*/
						if ($k[--$j] != $1.mode) { /*15946*/
							break; /*15946*/
						} /*15946*/
						$put($1.bvals, $1.p, $get($1.msg, $1.i)); /*15947*/
						$1.p = $1.p + 1; /*15948*/
						$1.i = $1.i + 1; /*15949*/
					} /*15949*/
					$1.remcws = $get($1.numremcws, $1.j + $1.p) - 1; /*15951*/
					$k[$j++] = Infinity; /*15959*/
					if (($1.remcws == 0) && ($1.i == $1.msglen)) { /*15956*/
						$k[$j++] = 0; /*15954*/
					} else { /*15956*/
						if ($1.p < 250) { /*15956*/
							$k[$j++] = $1.p; /*15956*/
						} else { /*15956*/
							$k[$j++] = (~~($1.p / 250)) + 249; /*15956*/
							$k[$j++] = $1.p % 250; /*15956*/
						} /*15956*/
					} /*15956*/
					$aload($geti($1.bvals, 0, $1.p)); /*15958*/
					$1.bvals = $a(); /*15959*/
					for (var _Gs = 0, _Gr = $1.bvals.length - 1; _Gs <= _Gr; _Gs += 1) { /*15965*/
						$1.p = _Gs; /*15961*/
						var _Gy = ((((($1.j + $1.p) + 1) * 149) % 255) + 1) + $get($1.bvals, $1.p); /*15963*/
						$k[$j++] = _Gy; /*15963*/
						if (_Gy >= 256) { /*15963*/
							var _Gz = $k[--$j]; /*15963*/
							$k[$j++] = _Gz - 256; /*15963*/
						} /*15963*/
						$put($1.bvals, $1.p, $k[--$j]); /*15964*/
					} /*15964*/
					$k[$j++] = $1.bvals; /*15966*/
					if ($1.addtocws() == $b) return $b; /*15966*/
					$1.mode = $1.A; /*15967*/
				}; /*15968*/
				$1.cws = $a(1558); /*15971*/
				$1.mode = $1.A; /*15972*/
				$1.i = 0; /*15972*/
				$1.j = 0; /*15972*/
				for (;;) { /*15975*/
					if ($1.i >= $1.msglen) { /*15973*/
						break; /*15973*/
					} /*15973*/
					$1[$get($a(["encA", "encCTX", "encCTX", "encCTX", "encE", "encB"]), $1.mode)](); /*15974*/
				} /*15974*/
				$1.cws = $geti($1.cws, 0, $1.j); /*15976*/
			} /*15976*/
			$1.datlen = $1.cws.length; /*15981*/
			$1.remcws = $get($1.numremcws, $1.j - 1) - 1; /*15982*/
			if ($1.remcws > 0) { /*15991*/
				$k[$j++] = Infinity; /*15984*/
				$aload($1.cws); /*15984*/
				for (var _HN = 0, _HO = $1.remcws; _HN < _HO; _HN++) { /*15984*/
					$k[$j++] = 129; /*15984*/
				} /*15984*/
				$1.cws = $a(); /*15984*/
				for (var _HU = $1.datlen + 1, _HT = ($1.datlen + $1.remcws) - 1; _HU <= _HT; _HU += 1) { /*15990*/
					$1.i = _HU; /*15986*/
					var _HW = (((($1.i + 1) * 149) % 253) + 1) + 129; /*15988*/
					$k[$j++] = _HW; /*15988*/
					if (_HW > 254) { /*15988*/
						var _HX = $k[--$j]; /*15988*/
						$k[$j++] = _HX - 254; /*15988*/
					} /*15988*/
					$put($1.cws, $1.i, $k[--$j]); /*15989*/
				} /*15989*/
			} /*15989*/
			$1.i = 0; /*15994*/
			for (;;) { /*16015*/
				$1.m = $get($1.metrics, $1.i); /*15995*/
				$1.rows = $get($1.m, 0); /*15996*/
				$1.cols = $get($1.m, 1); /*15997*/
				$1.regh = $get($1.m, 2); /*15998*/
				$1.regv = $get($1.m, 3); /*15999*/
				$1.rscw = $get($1.m, 4); /*16000*/
				$1.rsbl = $get($1.m, 5); /*16001*/
				$1.mrows = $1.rows - (2 * $1.regh); /*16002*/
				$1.mcols = $1.cols - (2 * $1.regv); /*16003*/
				$1.rrows = ~~($1.mrows / $1.regh); /*16004*/
				$1.rcols = ~~($1.mcols / $1.regv); /*16005*/
				$1.ncws = (~~(($1.mrows * $1.mcols) / 8)) - $1.rscw; /*16006*/
				$1.okay = true; /*16007*/
				if ($1.cws.length != $1.ncws) { /*16008*/
					$1.okay = false; /*16008*/
				} /*16008*/
				if (($1.urows != 0) && ($1.urows != $1.rows)) { /*16009*/
					$1.okay = false; /*16009*/
				} /*16009*/
				if (($1.ucols != 0) && ($1.ucols != $1.cols)) { /*16010*/
					$1.okay = false; /*16010*/
				} /*16010*/
				if ($eq($1.format, "square") && $ne($1.rows, $1.cols)) { /*16011*/
					$1.okay = false; /*16011*/
				} /*16011*/
				if ($eq($1.format, "rectangle") && $eq($1.rows, $1.cols)) { /*16012*/
					$1.okay = false; /*16012*/
				} /*16012*/
				if ($1.okay) { /*16013*/
					break; /*16013*/
				} /*16013*/
				$1.i = $1.i + 1; /*16014*/
			} /*16014*/
			$1.cwbs = $a($1.rsbl); /*16018*/
			$1.ecbs = $a($1.rsbl); /*16019*/
			for (var _IN = 0, _IM = $1.rsbl - 1; _IN <= _IM; _IN += 1) { /*16034*/
				$1.i = _IN; /*16021*/
				if ($1.cws.length != 1558) { /*16025*/
					$1.cwbsize = ~~($1.cws.length / $1.rsbl); /*16023*/
				} else { /*16025*/
					if ($1.i <= 7) { /*16025*/
						$1.cwbsize = 156; /*16025*/
					} else { /*16025*/
						$1.cwbsize = 155; /*16025*/
					} /*16025*/
				} /*16025*/
				$1.cwb = $a($1.cwbsize); /*16027*/
				for (var _IW = 0, _IV = $1.cwbsize - 1; _IW <= _IV; _IW += 1) { /*16031*/
					$1.j = _IW; /*16029*/
					$put($1.cwb, $1.j, $get($1.cws, ($1.j * $1.rsbl) + $1.i)); /*16030*/
				} /*16030*/
				$put($1.cwbs, $1.i, $1.cwb); /*16032*/
				$k[$j++] = $1.ecbs; /*16033*/
				$k[$j++] = $1.i; /*16033*/
				$k[$j++] = Infinity; /*16033*/
				for (var _Il = 0, _Im = ~~($1.rscw / $1.rsbl); _Il < _Im; _Il++) { /*16033*/
					$k[$j++] = 0; /*16033*/
				} /*16033*/
				var _In = $a(); /*16033*/
				var _Io = $k[--$j]; /*16033*/
				$put($k[--$j], _Io, _In); /*16033*/
			} /*16033*/
			$k[$j++] = Infinity; /*16037*/
			$k[$j++] = 1; /*16037*/
			for (var _Iq = 0, _Ir = 255; _Iq < _Ir; _Iq++) { /*16037*/
				var _Is = $k[--$j]; /*16037*/
				var _It = _Is * 2; /*16037*/
				$k[$j++] = _Is; /*16037*/
				$k[$j++] = _It; /*16037*/
				if (_It >= 256) { /*16037*/
					var _Iu = $k[--$j]; /*16037*/
					$k[$j++] = _Iu ^ 301; /*16037*/
				} /*16037*/
			} /*16037*/
			$1.rsalog = $a(); /*16037*/
			$1.rslog = $a(256); /*16038*/
			for (var _Ix = 1; _Ix <= 255; _Ix += 1) { /*16039*/
				$put($1.rslog, $get($1.rsalog, _Ix), _Ix); /*16039*/
			} /*16039*/
			$1.rsprod = function() {
				var _J1 = $k[--$j]; /*16043*/
				var _J2 = $k[--$j]; /*16043*/
				$k[$j++] = _J2; /*16047*/
				$k[$j++] = _J1; /*16047*/
				if ((_J1 != 0) && (_J2 != 0)) { /*16046*/
					var _J5 = $get($1.rslog, $k[--$j]); /*16044*/
					var _JA = $get($1.rsalog, (_J5 + $get($1.rslog, $k[--$j])) % 255); /*16044*/
					$k[$j++] = _JA; /*16044*/
				} else { /*16046*/
					$j -= 2; /*16046*/
					$k[$j++] = 0; /*16046*/
				} /*16046*/
			}; /*16048*/
			$k[$j++] = Infinity; /*16051*/
			$k[$j++] = 1; /*16051*/
			for (var _JD = 0, _JE = ~~($1.rscw / $1.rsbl); _JD < _JE; _JD++) { /*16051*/
				$k[$j++] = 0; /*16051*/
			} /*16051*/
			$1.coeffs = $a(); /*16051*/
			for (var _JJ = 1, _JI = ~~($1.rscw / $1.rsbl); _JJ <= _JI; _JJ += 1) { /*16060*/
				$1.i = _JJ; /*16053*/
				$put($1.coeffs, $1.i, $get($1.coeffs, $1.i - 1)); /*16054*/
				for (var _JQ = $1.i - 1; _JQ >= 1; _JQ -= 1) { /*16058*/
					$1.j = _JQ; /*16056*/
					$k[$j++] = $1.coeffs; /*16057*/
					$k[$j++] = $1.j; /*16057*/
					$k[$j++] = $get($1.coeffs, $1.j - 1); /*16057*/
					$k[$j++] = $get($1.coeffs, $1.j); /*16057*/
					$k[$j++] = $get($1.rsalog, $1.i); /*16057*/
					if ($1.rsprod() == $b) break; /*16057*/
					var _Jc = $k[--$j]; /*16057*/
					var _Jd = $k[--$j]; /*16057*/
					var _Je = $k[--$j]; /*16057*/
					$put($k[--$j], _Je, $xo(_Jd, _Jc)); /*16057*/
				} /*16057*/
				$k[$j++] = $1.coeffs; /*16059*/
				$k[$j++] = 0; /*16059*/
				$k[$j++] = $get($1.coeffs, 0); /*16059*/
				$k[$j++] = $get($1.rsalog, $1.i); /*16059*/
				if ($1.rsprod() == $b) break; /*16059*/
				var _Jm = $k[--$j]; /*16059*/
				var _Jn = $k[--$j]; /*16059*/
				$put($k[--$j], _Jn, _Jm); /*16059*/
			} /*16059*/
			$1.coeffs = $geti($1.coeffs, 0, $1.coeffs.length - 1); /*16061*/
			for (var _Ju = 0, _Jt = $1.cwbs.length - 1; _Ju <= _Jt; _Ju += 1) { /*16077*/
				$1.i = _Ju; /*16065*/
				$1.cwb = $get($1.cwbs, $1.i); /*16066*/
				$1.ecb = $get($1.ecbs, $1.i); /*16067*/
				for (var _K3 = 0, _K2 = $1.cwb.length - 1; _K3 <= _K2; _K3 += 1) { /*16076*/
					$1.t = $xo($get($1.cwb, _K3), $get($1.ecb, 0)); /*16069*/
					for (var _K9 = $1.ecb.length - 1; _K9 >= 0; _K9 -= 1) { /*16075*/
						$1.j = _K9; /*16071*/
						$1.p = ($1.ecb.length - $1.j) - 1; /*16072*/
						$k[$j++] = $1.ecb; /*16073*/
						$k[$j++] = $1.p; /*16073*/
						$k[$j++] = $1.t; /*16073*/
						$k[$j++] = $get($1.coeffs, $1.j); /*16073*/
						if ($1.rsprod() == $b) break; /*16073*/
						var _KI = $k[--$j]; /*16073*/
						var _KJ = $k[--$j]; /*16073*/
						$put($k[--$j], _KJ, _KI); /*16073*/
						if ($1.j > 0) { /*16074*/
							$put($1.ecb, $1.p, $xo($get($1.ecb, $1.p + 1), $get($1.ecb, $1.p))); /*16074*/
						} /*16074*/
					} /*16074*/
				} /*16074*/
			} /*16074*/
			if ($1.ncws == 1558) { /*16082*/
				$k[$j++] = Infinity; /*16081*/
				$forall($geti($1.ecbs, 8, 2)); /*16081*/
				$forall($geti($1.ecbs, 0, 8)); /*16081*/
				$1.ecbs = $a(); /*16081*/
			} /*16081*/
			$k[$j++] = Infinity; /*16085*/
			var _Ka = $1.cws; /*16085*/
			for (var _Kb = 0, _Kc = _Ka.length; _Kb < _Kc; _Kb++) { /*16085*/
				$k[$j++] = $get(_Ka, _Kb); /*16085*/
			} /*16085*/
			for (var _Kf = 0, _Kg = $1.rscw; _Kf < _Kg; _Kf++) { /*16085*/
				$k[$j++] = 0; /*16085*/
			} /*16085*/
			$1.cws = $a(); /*16085*/
			for (var _Kk = 0, _Kj = $1.rscw - 1; _Kk <= _Kj; _Kk += 1) { /*16089*/
				$1.i = _Kk; /*16087*/
				$put($1.cws, $1.ncws + $1.i, $get($get($1.ecbs, $1.i % $1.rsbl), ~~($1.i / $1.rsbl))); /*16088*/
			} /*16088*/
			$1.module = function() {
				var _Kv = $k[--$j]; /*16094*/
				var _Kw = $k[--$j]; /*16094*/
				var _Kx = $k[--$j]; /*16094*/
				var _L0 = $strcpy($s(8), "00000000"); /*16095*/
				var _L2 = $cvrs($s(8), $k[--$j], 2); /*16095*/
				$puti(_L0, 8 - _L2.length, _L2); /*16096*/
				$k[$j++] = _Kx; /*16097*/
				$k[$j++] = _Kw; /*16097*/
				$k[$j++] = _Kv; /*16097*/
				$k[$j++] = _L0; /*16097*/
				for (var _L3 = 7; _L3 >= 0; _L3 -= 1) { /*16097*/
					var _L4 = $k[--$j]; /*16097*/
					$k[$j++] = $get(_L4, _L3) - 48; /*16097*/
					$k[$j++] = _L4; /*16097*/
				} /*16097*/
				$j--; /*16097*/
				var _L6 = $k[--$j]; /*16098*/
				var _L7 = $k[--$j]; /*16098*/
				var _L8 = $k[--$j]; /*16098*/
				var _L9 = $k[--$j]; /*16098*/
				var _LA = $k[--$j]; /*16098*/
				var _LB = $k[--$j]; /*16098*/
				var _LC = $k[--$j]; /*16098*/
				var _LD = $k[--$j]; /*16098*/
				var _LE = $k[--$j]; /*16098*/
				var _LF = $k[--$j]; /*16098*/
				var _LG = $k[--$j]; /*16098*/
				$k[$j++] = _LD; /*16115*/
				$k[$j++] = _LC; /*16115*/
				$k[$j++] = _LB; /*16115*/
				$k[$j++] = _LA; /*16115*/
				$k[$j++] = _L9; /*16115*/
				$k[$j++] = _L8; /*16115*/
				$k[$j++] = _L7; /*16115*/
				$k[$j++] = _L6; /*16115*/
				$k[$j++] = _LG; /*16115*/
				$k[$j++] = _LF; /*16115*/
				$forall(_LE, function() { /*16115*/
					$k[--$j](); /*16101*/
					var _LI = $k[--$j]; /*16102*/
					var _LJ = $k[--$j]; /*16102*/
					$k[$j++] = _LJ; /*16105*/
					$k[$j++] = _LI; /*16105*/
					if (_LJ < 0) { /*16105*/
						var _LK = $k[--$j]; /*16103*/
						var _LL = $k[--$j]; /*16103*/
						$k[$j++] = _LL + $1.mrows; /*16104*/
						$k[$j++] = _LK + (4 - (($1.mrows + 4) % 8)); /*16104*/
					} /*16104*/
					var _LO = $k[--$j]; /*16106*/
					$k[$j++] = _LO; /*16109*/
					if (_LO < 0) { /*16109*/
						var _LQ = $k[--$j]; /*16107*/
						var _LR = $k[--$j]; /*16107*/
						$k[$j++] = _LR + (4 - (($1.mcols + 4) % 8)); /*16108*/
						$k[$j++] = _LQ + $1.mcols; /*16108*/
					} /*16108*/
					var _LT = $k[--$j]; /*16110*/
					var _LU = $k[--$j]; /*16110*/
					$k[$j++] = _LU; /*16112*/
					$k[$j++] = _LT; /*16112*/
					if (_LU >= $1.mrows) { /*16112*/
						var _LW = $k[--$j]; /*16111*/
						var _LX = $k[--$j]; /*16111*/
						$k[$j++] = _LX - $1.mrows; /*16111*/
						$k[$j++] = _LW; /*16111*/
					} /*16111*/
					var _LZ = $k[--$j]; /*16113*/
					var _La = $k[--$j]; /*16113*/
					var _Ld = $k[--$j]; /*16114*/
					var _Le = $k[--$j]; /*16114*/
					$put($1.mmat, _LZ + (_La * $1.mcols), $k[--$j]); /*16114*/
					$k[$j++] = _Le; /*16114*/
					$k[$j++] = _Ld; /*16114*/
				}); /*16114*/
			}; /*16116*/
			var _Lw = $a([function() {
				var _Lg = $k[--$j]; /*16120*/
				var _Lh = $k[--$j]; /*16120*/
				$k[$j++] = _Lh; /*16120*/
				$k[$j++] = _Lg; /*16120*/
				$k[$j++] = _Lh - 2; /*16120*/
				$k[$j++] = _Lg - 2; /*16120*/
			}, function() {
				var _Li = $k[--$j]; /*16120*/
				var _Lj = $k[--$j]; /*16120*/
				$k[$j++] = _Lj; /*16120*/
				$k[$j++] = _Li; /*16120*/
				$k[$j++] = _Lj - 2; /*16120*/
				$k[$j++] = _Li - 1; /*16120*/
			}, function() {
				var _Lk = $k[--$j]; /*16121*/
				var _Ll = $k[--$j]; /*16121*/
				$k[$j++] = _Ll; /*16121*/
				$k[$j++] = _Lk; /*16121*/
				$k[$j++] = _Ll - 1; /*16121*/
				$k[$j++] = _Lk - 2; /*16121*/
			}, function() {
				var _Lm = $k[--$j]; /*16121*/
				var _Ln = $k[--$j]; /*16121*/
				$k[$j++] = _Ln; /*16121*/
				$k[$j++] = _Lm; /*16121*/
				$k[$j++] = _Ln - 1; /*16121*/
				$k[$j++] = _Lm - 1; /*16121*/
			}, function() {
				var _Lo = $k[--$j]; /*16122*/
				var _Lp = $k[--$j]; /*16122*/
				$k[$j++] = _Lp; /*16122*/
				$k[$j++] = _Lo; /*16122*/
				$k[$j++] = _Lp - 1; /*16122*/
				$k[$j++] = _Lo; /*16122*/
			}, function() {
				var _Lq = $k[--$j]; /*16122*/
				var _Lr = $k[--$j]; /*16122*/
				$k[$j++] = _Lr; /*16122*/
				$k[$j++] = _Lq; /*16122*/
				$k[$j++] = _Lr; /*16122*/
				$k[$j++] = _Lq - 2; /*16122*/
			}, function() {
				var _Ls = $k[--$j]; /*16123*/
				var _Lt = $k[--$j]; /*16123*/
				$k[$j++] = _Lt; /*16123*/
				$k[$j++] = _Ls; /*16123*/
				$k[$j++] = _Lt; /*16123*/
				$k[$j++] = _Ls - 1; /*16123*/
			}, function() {
				var _Lu = $k[--$j]; /*16123*/
				var _Lv = $k[--$j]; /*16123*/
				$k[$j++] = _Lv; /*16123*/
				$k[$j++] = _Lu; /*16123*/
				$k[$j++] = _Lv; /*16123*/
				$k[$j++] = _Lu; /*16123*/
			}]); /*16123*/
			$1.dmn = _Lw; /*16124*/
			var _M5 = $a([function() {
				$k[$j++] = $1.mrows - 1; /*16127*/
				$k[$j++] = 0; /*16127*/
			}, function() {
				$k[$j++] = $1.mrows - 1; /*16127*/
				$k[$j++] = 1; /*16127*/
			}, function() {
				$k[$j++] = $1.mrows - 1; /*16128*/
				$k[$j++] = 2; /*16128*/
			}, function() {
				$k[$j++] = 0; /*16128*/
				$k[$j++] = $1.mcols - 2; /*16128*/
			}, function() {
				$k[$j++] = 0; /*16129*/
				$k[$j++] = $1.mcols - 1; /*16129*/
			}, function() {
				$k[$j++] = 1; /*16129*/
				$k[$j++] = $1.mcols - 1; /*16129*/
			}, function() {
				$k[$j++] = 2; /*16130*/
				$k[$j++] = $1.mcols - 1; /*16130*/
			}, function() {
				$k[$j++] = 3; /*16130*/
				$k[$j++] = $1.mcols - 1; /*16130*/
			}]); /*16130*/
			$1.dmc1 = _M5; /*16131*/
			var _ME = $a([function() {
				$k[$j++] = $1.mrows - 3; /*16134*/
				$k[$j++] = 0; /*16134*/
			}, function() {
				$k[$j++] = $1.mrows - 2; /*16134*/
				$k[$j++] = 0; /*16134*/
			}, function() {
				$k[$j++] = $1.mrows - 1; /*16135*/
				$k[$j++] = 0; /*16135*/
			}, function() {
				$k[$j++] = 0; /*16135*/
				$k[$j++] = $1.mcols - 4; /*16135*/
			}, function() {
				$k[$j++] = 0; /*16136*/
				$k[$j++] = $1.mcols - 3; /*16136*/
			}, function() {
				$k[$j++] = 0; /*16136*/
				$k[$j++] = $1.mcols - 2; /*16136*/
			}, function() {
				$k[$j++] = 0; /*16137*/
				$k[$j++] = $1.mcols - 1; /*16137*/
			}, function() {
				$k[$j++] = 1; /*16137*/
				$k[$j++] = $1.mcols - 1; /*16137*/
			}]); /*16137*/
			$1.dmc2 = _ME; /*16138*/
			var _MN = $a([function() {
				$k[$j++] = $1.mrows - 3; /*16141*/
				$k[$j++] = 0; /*16141*/
			}, function() {
				$k[$j++] = $1.mrows - 2; /*16141*/
				$k[$j++] = 0; /*16141*/
			}, function() {
				$k[$j++] = $1.mrows - 1; /*16142*/
				$k[$j++] = 0; /*16142*/
			}, function() {
				$k[$j++] = 0; /*16142*/
				$k[$j++] = $1.mcols - 2; /*16142*/
			}, function() {
				$k[$j++] = 0; /*16143*/
				$k[$j++] = $1.mcols - 1; /*16143*/
			}, function() {
				$k[$j++] = 1; /*16143*/
				$k[$j++] = $1.mcols - 1; /*16143*/
			}, function() {
				$k[$j++] = 2; /*16144*/
				$k[$j++] = $1.mcols - 1; /*16144*/
			}, function() {
				$k[$j++] = 3; /*16144*/
				$k[$j++] = $1.mcols - 1; /*16144*/
			}]); /*16144*/
			$1.dmc3 = _MN; /*16145*/
			var _MX = $a([function() {
				$k[$j++] = $1.mrows - 1; /*16148*/
				$k[$j++] = 0; /*16148*/
			}, function() {
				$k[$j++] = $1.mrows - 1; /*16148*/
				$k[$j++] = $1.mcols - 1; /*16148*/
			}, function() {
				$k[$j++] = 0; /*16149*/
				$k[$j++] = $1.mcols - 3; /*16149*/
			}, function() {
				$k[$j++] = 0; /*16149*/
				$k[$j++] = $1.mcols - 2; /*16149*/
			}, function() {
				$k[$j++] = 0; /*16150*/
				$k[$j++] = $1.mcols - 1; /*16150*/
			}, function() {
				$k[$j++] = 1; /*16150*/
				$k[$j++] = $1.mcols - 3; /*16150*/
			}, function() {
				$k[$j++] = 1; /*16151*/
				$k[$j++] = $1.mcols - 2; /*16151*/
			}, function() {
				$k[$j++] = 1; /*16151*/
				$k[$j++] = $1.mcols - 1; /*16151*/
			}]); /*16151*/
			$1.dmc4 = _MX; /*16152*/
			$k[$j++] = Infinity; /*16154*/
			for (var _Ma = 0, _Mb = $1.mrows * $1.mcols; _Ma < _Mb; _Ma++) { /*16154*/
				$k[$j++] = -1; /*16154*/
			} /*16154*/
			$1.mmat = $a(); /*16154*/
			for (var _Me = $1.cws.length - 1; _Me >= 0; _Me -= 1) { /*16155*/
				$k[$j++] = $get($1.cws, _Me); /*16155*/
			} /*16155*/
			$k[$j++] = 4; /*16195*/
			$k[$j++] = 0; /*16195*/
			for (;;) { /*16195*/
				var _Mh = $k[--$j]; /*16158*/
				var _Mi = $k[--$j]; /*16158*/
				$k[$j++] = _Mi; /*16160*/
				$k[$j++] = _Mh; /*16160*/
				if ((_Mh == 0) && (_Mi == $1.mrows)) { /*16160*/
					$k[$j++] = $1.dmc1; /*16159*/
					if ($1.module() == $b) break; /*16159*/
				} /*16159*/
				var _Ml = $k[--$j]; /*16161*/
				var _Mm = $k[--$j]; /*16161*/
				$k[$j++] = _Mm; /*16163*/
				$k[$j++] = _Ml; /*16163*/
				if (((_Ml == 0) && (_Mm == ($1.mrows - 2))) && (($1.mcols % 4) != 0)) { /*16163*/
					$k[$j++] = $1.dmc2; /*16162*/
					if ($1.module() == $b) break; /*16162*/
				} /*16162*/
				var _Mq = $k[--$j]; /*16164*/
				var _Mr = $k[--$j]; /*16164*/
				$k[$j++] = _Mr; /*16166*/
				$k[$j++] = _Mq; /*16166*/
				if (((_Mq == 0) && (_Mr == ($1.mrows - 2))) && (($1.mcols % 8) == 4)) { /*16166*/
					$k[$j++] = $1.dmc3; /*16165*/
					if ($1.module() == $b) break; /*16165*/
				} /*16165*/
				var _Mv = $k[--$j]; /*16167*/
				var _Mw = $k[--$j]; /*16167*/
				$k[$j++] = _Mw; /*16169*/
				$k[$j++] = _Mv; /*16169*/
				if (((_Mv == 2) && (_Mw == ($1.mrows + 4))) && (($1.mcols % 8) == 0)) { /*16169*/
					$k[$j++] = $1.dmc4; /*16168*/
					if ($1.module() == $b) break; /*16168*/
				} /*16168*/
				for (;;) { /*16179*/
					var _N0 = $k[--$j]; /*16172*/
					var _N1 = $k[--$j]; /*16172*/
					$k[$j++] = _N1; /*16176*/
					$k[$j++] = _N0; /*16176*/
					if ((_N0 >= 0) && (_N1 < $1.mrows)) { /*16176*/
						var _N3 = $k[--$j]; /*16173*/
						var _N4 = $k[--$j]; /*16173*/
						$k[$j++] = _N4; /*16175*/
						$k[$j++] = _N3; /*16175*/
						if ($get($1.mmat, _N3 + (_N4 * $1.mcols)) == -1) { /*16175*/
							$k[$j++] = $1.dmn; /*16174*/
							if ($1.module() == $b) break; /*16174*/
						} /*16174*/
					} /*16174*/
					var _N9 = $k[--$j]; /*16177*/
					var _NA = $k[--$j]; /*16177*/
					$k[$j++] = _NA - 2; /*16178*/
					$k[$j++] = _N9 + 2; /*16178*/
					if (!(((_N9 + 2) < $1.mcols) && ((_NA - 2) >= 0))) { /*16178*/
						break; /*16178*/
					} /*16178*/
				} /*16178*/
				var _NC = $k[--$j]; /*16180*/
				var _ND = $k[--$j]; /*16180*/
				$k[$j++] = _ND + 1; /*16190*/
				$k[$j++] = _NC + 3; /*16190*/
				for (;;) { /*16190*/
					var _NE = $k[--$j]; /*16183*/
					var _NF = $k[--$j]; /*16183*/
					$k[$j++] = _NF; /*16187*/
					$k[$j++] = _NE; /*16187*/
					if ((_NE < $1.mcols) && (_NF >= 0)) { /*16187*/
						var _NH = $k[--$j]; /*16184*/
						var _NI = $k[--$j]; /*16184*/
						$k[$j++] = _NI; /*16186*/
						$k[$j++] = _NH; /*16186*/
						if ($get($1.mmat, _NH + (_NI * $1.mcols)) == -1) { /*16186*/
							$k[$j++] = $1.dmn; /*16185*/
							if ($1.module() == $b) break; /*16185*/
						} /*16185*/
					} /*16185*/
					var _NN = $k[--$j]; /*16188*/
					var _NO = $k[--$j]; /*16188*/
					$k[$j++] = _NO + 2; /*16189*/
					$k[$j++] = _NN - 2; /*16189*/
					if (!(((_NN - 2) >= 0) && ((_NO + 2) < $1.mrows))) { /*16189*/
						break; /*16189*/
					} /*16189*/
				} /*16189*/
				var _NQ = $k[--$j]; /*16191*/
				var _NR = $k[--$j]; /*16191*/
				$k[$j++] = _NR + 3; /*16193*/
				$k[$j++] = _NQ + 1; /*16193*/
				if (!(((_NQ + 1) < $1.mcols) || ((_NR + 3) < $1.mrows))) { /*16193*/
					$j -= 2; /*16193*/
					break; /*16193*/
				} /*16193*/
			} /*16193*/
			if ($get($1.mmat, ($1.mrows * $1.mcols) - 1) == -1) { /*16201*/
				$puti($1.mmat, ($1.mrows * ($1.mcols - 1)) - 2, $a([1, 0])); /*16199*/
				$puti($1.mmat, ($1.mrows * $1.mcols) - 2, $a([0, 1])); /*16200*/
			} /*16200*/
			$1.pixs = $a($1.rows * $1.cols); /*16204*/
			$1.cwpos = 0; /*16205*/
			for (var _Nl = 0, _Nk = $1.rows - 1; _Nl <= _Nk; _Nl += 1) { /*16221*/
				$1.i = _Nl; /*16207*/
				if (($1.i % ($1.rrows + 2)) == 0) { /*16208*/
					$k[$j++] = $1.pixs; /*16208*/
					$k[$j++] = $1.i * $1.cols; /*16208*/
					$k[$j++] = Infinity; /*16208*/
					for (var _Ns = 0, _Nt = ~~($1.cols / 2); _Ns < _Nt; _Ns++) { /*16208*/
						$k[$j++] = 1; /*16208*/
						$k[$j++] = 0; /*16208*/
					} /*16208*/
					var _Nu = $a(); /*16208*/
					var _Nv = $k[--$j]; /*16208*/
					$puti($k[--$j], _Nv, _Nu); /*16208*/
				} /*16208*/
				if (($1.i % ($1.rrows + 2)) == ($1.rrows + 1)) { /*16209*/
					$k[$j++] = $1.pixs; /*16209*/
					$k[$j++] = $1.i * $1.cols; /*16209*/
					$k[$j++] = Infinity; /*16209*/
					for (var _O4 = 0, _O5 = $1.cols; _O4 < _O5; _O4++) { /*16209*/
						$k[$j++] = 1; /*16209*/
					} /*16209*/
					var _O6 = $a(); /*16209*/
					var _O7 = $k[--$j]; /*16209*/
					$puti($k[--$j], _O7, _O6); /*16209*/
				} /*16209*/
				if ((($1.i % ($1.rrows + 2)) != 0) && (($1.i % ($1.rrows + 2)) != ($1.rrows + 1))) { /*16220*/
					for (var _OG = 0, _OF = $1.cols - 1; _OG <= _OF; _OG += 1) { /*16219*/
						$1.j = _OG; /*16212*/
						if (($1.j % ($1.rcols + 2)) == 0) { /*16213*/
							$put($1.pixs, ($1.i * $1.cols) + $1.j, 1); /*16213*/
						} /*16213*/
						if (($1.j % ($1.rcols + 2)) == ($1.rcols + 1)) { /*16214*/
							$put($1.pixs, ($1.i * $1.cols) + $1.j, $1.i % 2); /*16214*/
						} /*16214*/
						if ((($1.j % ($1.rcols + 2)) != 0) && (($1.j % ($1.rcols + 2)) != ($1.rcols + 1))) { /*16218*/
							$put($1.pixs, ($1.i * $1.cols) + $1.j, $get($1.mmat, $1.cwpos)); /*16216*/
							$1.cwpos = $1.cwpos + 1; /*16217*/
						} /*16217*/
					} /*16217*/
				} /*16217*/
			} /*16217*/
			var _Oo = {
				ren: $0.renmatrix,
				pixs: $1.pixs,
				pixx: $1.cols,
				pixy: $1.rows,
				height: ($1.rows * 2) / 72,
				width: ($1.cols * 2) / 72,
				opt: $1.options
			}; /*16231*/
			$k[$j++] = _Oo; /*16234*/
			if (!$1.dontdraw) { /*16234*/
				$0.renmatrix(); /*16234*/
			} /*16234*/
		};
		$0.datamatrixrectangular = function() {
			var $1 = {}; /*16260*/
			$1.options = $k[--$j]; /*16262*/
			$1.barcode = $k[--$j]; /*16263*/
			$1.dontdraw = false; /*16265*/
			$forall($1.options, function() { /*16276*/
				var _3 = $k[--$j]; /*16276*/
				$1[$k[--$j]] = _3; /*16276*/
			}); /*16276*/
			$1.options.dontdraw = true; /*16279*/
			$1.options.format = "rectangle"; /*16280*/
			$k[$j++] = "args"; /*16282*/
			$k[$j++] = $1.barcode; /*16282*/
			$k[$j++] = $1.options; /*16282*/
			$0.datamatrix(); /*16282*/
			var _9 = $k[--$j]; /*16282*/
			$1[$k[--$j]] = _9; /*16282*/
			$1.args.opt = $1.options; /*16284*/
			$k[$j++] = $1.args; /*16287*/
			if (!$1.dontdraw) { /*16287*/
				$0.renmatrix(); /*16287*/
			} /*16287*/
		};
		$0.qrcode = function() {
			var $1 = {}; /*16314*/
			$1.options = $k[--$j]; /*16316*/
			$1.barcode = $k[--$j]; /*16317*/
			$1.dontdraw = false; /*16319*/
			$1.format = "full"; /*16320*/
			$1.version = "unset"; /*16321*/
			$1.eclevel = "unset"; /*16322*/
			$1.parse = false; /*16323*/
			$1.parsefnc = false; /*16324*/
			$1.mask = -1; /*16325*/
			$forall($1.options, function() { /*16336*/
				var _3 = $k[--$j]; /*16336*/
				$1[$k[--$j]] = _3; /*16336*/
			}); /*16336*/
			$1.mask = ~~$1.mask; /*16338*/
			$1.barlen = $1.barcode.length; /*16361*/
			$1.fn1 = -1; /*16364*/
			var _8 = {
				FNC1: $1.fn1
			}; /*16366*/
			$1.fncvals = _8; /*16367*/
			$1.msg = $a($1.barlen); /*16368*/
			$1.i = 0; /*16369*/
			$1.j = 0; /*16369*/
			for (;;) { /*16383*/
				if ($1.i == $1.barlen) { /*16370*/
					break; /*16370*/
				} /*16370*/
				$1.char = $get($1.barcode, $1.i); /*16371*/
				if (($1.parsefnc && ($1.char == 94)) && ($1.i < ($1.barlen - 4))) { /*16379*/
					if ($get($1.barcode, $1.i + 1) != 94) { /*16377*/
						$1.char = $get($1.fncvals, $geti($1.barcode, $1.i + 1, 4)); /*16374*/
						$1.i = $1.i + 4; /*16375*/
					} else { /*16377*/
						$1.i = $1.i + 1; /*16377*/
					} /*16377*/
				} /*16377*/
				$put($1.msg, $1.j, $1.char); /*16380*/
				$1.i = $1.i + 1; /*16381*/
				$1.j = $1.j + 1; /*16382*/
			} /*16382*/
			$1.msg = $geti($1.msg, 0, $1.j); /*16384*/
			$1.msglen = $1.msg.length; /*16385*/
			$1.fnc1first = false; /*16388*/
			if ($1.msglen > 0) { /*16395*/
				if ($get($1.msg, 0) == $1.fn1) { /*16394*/
					$1.fnc1first = true; /*16391*/
					$k[$j++] = Infinity; /*16392*/
					$forall($geti($1.msg, 1, $1.msglen - 1), function() { /*16392*/
						var _k = $k[--$j]; /*16392*/
						$k[$j++] = _k; /*16392*/
						if (_k == 37) { /*16392*/
							var _l = $k[--$j]; /*16392*/
							$k[$j++] = _l; /*16392*/
							$k[$j++] = _l; /*16392*/
						} /*16392*/
					}); /*16392*/
					$1.msg = $a(); /*16392*/
					$1.msglen = $1.msg.length; /*16393*/
				} /*16393*/
			} /*16393*/
			if ($eq($1.eclevel, "unset")) { /*16398*/
				$k[$j++] = "eclevel"; /*16398*/
				if ($eq($1.format, "full")) { /*16398*/
					$k[$j++] = "M"; /*16398*/
				} else { /*16398*/
					$k[$j++] = "L"; /*16398*/
				} /*16398*/
				var _q = $k[--$j]; /*16398*/
				$1[$k[--$j]] = _q; /*16398*/
			} /*16398*/
			$1.N = 0; /*16401*/
			$1.A = 1; /*16401*/
			$1.B = 2; /*16401*/
			$1.K = 3; /*16401*/
			$k[$j++] = "Nexcl"; /*16406*/
			$k[$j++] = Infinity; /*16406*/
			$k[$j++] = Infinity; /*16405*/
			for (var _s = 48; _s <= 57; _s += 1) { /*16405*/
				$k[$j++] = _s; /*16405*/
			} /*16405*/
			var _t = $a(); /*16405*/
			for (var _u = 0, _v = _t.length; _u < _v; _u++) { /*16406*/
				$k[$j++] = $get(_t, _u); /*16406*/
				$k[$j++] = -1; /*16406*/
			} /*16406*/
			var _x = $d(); /*16406*/
			$1[$k[--$j]] = _x; /*16407*/
			$k[$j++] = "Aexcl"; /*16414*/
			$k[$j++] = Infinity; /*16414*/
			$k[$j++] = Infinity; /*16413*/
			$k[$j++] = 32; /*16412*/
			$k[$j++] = 36; /*16412*/
			$k[$j++] = 37; /*16412*/
			$k[$j++] = 42; /*16412*/
			$k[$j++] = 43; /*16412*/
			$k[$j++] = 45; /*16412*/
			$k[$j++] = 46; /*16412*/
			$k[$j++] = 47; /*16412*/
			$k[$j++] = 58; /*16412*/
			for (var _z = 65; _z <= 90; _z += 1) { /*16412*/
				$k[$j++] = _z; /*16412*/
			} /*16412*/
			$k[$j++] = $1.fn1; /*16413*/
			var _11 = $a(); /*16413*/
			for (var _12 = 0, _13 = _11.length; _12 < _13; _12++) { /*16414*/
				$k[$j++] = $get(_11, _12); /*16414*/
				$k[$j++] = -1; /*16414*/
			} /*16414*/
			var _15 = $d(); /*16414*/
			$1[$k[--$j]] = _15; /*16415*/
			$k[$j++] = "Bexcl"; /*16424*/
			$k[$j++] = Infinity; /*16424*/
			$k[$j++] = Infinity; /*16423*/
			for (var _17 = 0; _17 <= 31; _17 += 1) { /*16419*/
				$k[$j++] = _17; /*16419*/
			} /*16419*/
			$k[$j++] = 33; /*16421*/
			$k[$j++] = 34; /*16421*/
			$k[$j++] = 35; /*16421*/
			$k[$j++] = 38; /*16421*/
			$k[$j++] = 39; /*16421*/
			$k[$j++] = 40; /*16421*/
			$k[$j++] = 41; /*16421*/
			$k[$j++] = 44; /*16421*/
			for (var _18 = 59; _18 <= 64; _18 += 1) { /*16421*/
				$k[$j++] = _18; /*16421*/
			} /*16421*/
			for (var _19 = 91; _19 <= 127; _19 += 1) { /*16422*/
				$k[$j++] = _19; /*16422*/
			} /*16422*/
			for (var _1A = 160; _1A <= 223; _1A += 1) { /*16423*/
				$k[$j++] = _1A; /*16423*/
			} /*16423*/
			var _1B = $a(); /*16423*/
			for (var _1C = 0, _1D = _1B.length; _1C < _1D; _1C++) { /*16424*/
				$k[$j++] = $get(_1B, _1C); /*16424*/
				$k[$j++] = -1; /*16424*/
			} /*16424*/
			var _1F = $d(); /*16424*/
			$1[$k[--$j]] = _1F; /*16425*/
			$k[$j++] = "Kexcl"; /*16431*/
			$k[$j++] = Infinity; /*16431*/
			$k[$j++] = Infinity; /*16430*/
			for (var _1H = 129; _1H <= 159; _1H += 1) { /*16429*/
				$k[$j++] = _1H; /*16429*/
			} /*16429*/
			for (var _1I = 224; _1I <= 235; _1I += 1) { /*16430*/
				$k[$j++] = _1I; /*16430*/
			} /*16430*/
			var _1J = $a(); /*16430*/
			for (var _1K = 0, _1L = _1J.length; _1K < _1L; _1K++) { /*16431*/
				$k[$j++] = $get(_1J, _1K); /*16431*/
				$k[$j++] = -1; /*16431*/
			} /*16431*/
			var _1N = $d(); /*16431*/
			$1[$k[--$j]] = _1N; /*16432*/
			$1.mids = $a([$a(["0001", "0010", "0100", "1000"]), $a(["0001", "0010", "0100", "1000"]), $a(["0001", "0010", "0100", "1000"]), $a(["", -1, -1, -1]), $a(["0", "1", -1, -1]), $a(["00", "01", "10", "11"]), $a(["000", "001", "010", "011"])]); /*16442*/
			$1.cclens = $a([$a([10, 9, 8, 8]), $a([12, 11, 16, 10]), $a([14, 13, 16, 12]), $a([3, -1, -1, -1]), $a([4, 3, -1, -1]), $a([5, 4, 4, 3]), $a([6, 5, 5, 4])]); /*16452*/
			$1.termlens = $a([4, 4, 4, 3, 5, 7, 9]); /*16454*/
			$1.tobin = function() {
				var _1h = $s($k[--$j]); /*16458*/
				$k[$j++] = _1h; /*16458*/
				for (var _1j = 0, _1i = _1h.length - 1; _1j <= _1i; _1j += 1) { /*16458*/
					var _1k = $k[--$j]; /*16458*/
					$put(_1k, _1j, 48); /*16458*/
					$k[$j++] = _1k; /*16458*/
				} /*16458*/
				var _1l = $k[--$j]; /*16459*/
				var _1o = $cvrs($s(_1l.length), $k[--$j], 2); /*16459*/
				$puti(_1l, _1l.length - _1o.length, _1o); /*16459*/
				$k[$j++] = _1l; /*16459*/
			}; /*16460*/
			$1.charmap = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:"; /*16463*/
			$1.charvals = {}; /*16464*/
			for (var _1p = 0; _1p <= 44; _1p += 1) { /*16465*/
				$put($1.charvals, $get($1.charmap, _1p), _1p); /*16465*/
			} /*16465*/
			$1.encA = function() {
				$1.in = $k[--$j]; /*16468*/
				if ($1.fnc1first) { /*16471*/
					$k[$j++] = Infinity; /*16470*/
					$forall($1.in, function() { /*16470*/
						var _1w = $k[--$j]; /*16470*/
						$k[$j++] = _1w; /*16470*/
						if (_1w == -1) { /*16470*/
							$j--; /*16470*/
							$k[$j++] = 37; /*16470*/
						} /*16470*/
					}); /*16470*/
					$1.in = $a(); /*16470*/
				} /*16470*/
				$1.out = $s((~~(($1.in.length * 11) / 2)) + 1); /*16472*/
				$1.k = 0; /*16473*/
				$1.m = 0; /*16473*/
				for (;;) { /*16484*/
					if ($1.k == $1.in.length) { /*16474*/
						break; /*16474*/
					} /*16474*/
					if ($1.k < ($1.in.length - 1)) { /*16480*/
						$k[$j++] = ($get($1.charvals, $get($1.in, $1.k)) * 45) + $get($1.charvals, $get($1.in, $1.k + 1)); /*16476*/
						$k[$j++] = 11; /*16476*/
						if ($1.tobin() == $b) break; /*16476*/
						$1.k = $1.k + 2; /*16477*/
					} else { /*16480*/
						$k[$j++] = $get($1.charvals, $get($1.in, $1.k)); /*16479*/
						$k[$j++] = 6; /*16479*/
						if ($1.tobin() == $b) break; /*16479*/
						$1.k = $1.k + 1; /*16480*/
					} /*16480*/
					var _2L = $k[--$j]; /*16482*/
					$puti($1.out, $1.m, _2L); /*16482*/
					$1.m = _2L.length + $1.m; /*16483*/
				} /*16483*/
				$k[$j++] = $geti($1.out, 0, $1.m); /*16485*/
			}; /*16486*/
			$1.encN = function() {
				$1.in = $k[--$j]; /*16489*/
				$1.out = $s((~~(($1.in.length * 10) / 3)) + 1); /*16490*/
				$1.k = 0; /*16491*/
				$1.m = 0; /*16491*/
				for (;;) { /*16507*/
					if ($1.k == $1.in.length) { /*16492*/
						break; /*16492*/
					} /*16492*/
					if ($1.k < ($1.in.length - 2)) { /*16502*/
						$k[$j++] = 0; /*16494*/
						$forall($geti($1.in, $1.k, 3), function() { /*16494*/
							var _2c = $k[--$j]; /*16494*/
							var _2d = $k[--$j]; /*16494*/
							$k[$j++] = _2c + ((_2d * 10) - 48); /*16494*/
						}); /*16494*/
						$k[$j++] = 10; /*16494*/
						if ($1.tobin() == $b) break; /*16494*/
						$1.k = $1.k + 3; /*16495*/
					} else { /*16502*/
						if ($1.k == ($1.in.length - 2)) { /*16502*/
							$k[$j++] = 0; /*16498*/
							$forall($geti($1.in, $1.k, 2), function() { /*16498*/
								var _2k = $k[--$j]; /*16498*/
								var _2l = $k[--$j]; /*16498*/
								$k[$j++] = _2k + ((_2l * 10) - 48); /*16498*/
							}); /*16498*/
							$k[$j++] = 7; /*16498*/
							if ($1.tobin() == $b) break; /*16498*/
							$1.k = $1.k + 2; /*16499*/
						} else { /*16502*/
							$k[$j++] = 0; /*16501*/
							$forall($geti($1.in, $1.k, 1), function() { /*16501*/
								var _2q = $k[--$j]; /*16501*/
								var _2r = $k[--$j]; /*16501*/
								$k[$j++] = _2q + ((_2r * 10) - 48); /*16501*/
							}); /*16501*/
							$k[$j++] = 4; /*16501*/
							if ($1.tobin() == $b) break; /*16501*/
							$1.k = $1.k + 1; /*16502*/
						} /*16502*/
					} /*16502*/
					var _2t = $k[--$j]; /*16505*/
					$puti($1.out, $1.m, _2t); /*16505*/
					$1.m = _2t.length + $1.m; /*16506*/
				} /*16506*/
				$k[$j++] = $geti($1.out, 0, $1.m); /*16508*/
			}; /*16509*/
			$1.encB = function() {
				$1.in = $k[--$j]; /*16512*/
				if ($1.fnc1first) { /*16515*/
					$k[$j++] = Infinity; /*16514*/
					$forall($1.in, function() { /*16514*/
						var _33 = $k[--$j]; /*16514*/
						$k[$j++] = _33; /*16514*/
						if (_33 == -1) { /*16514*/
							$j--; /*16514*/
							$k[$j++] = 29; /*16514*/
						} /*16514*/
					}); /*16514*/
					$1.in = $a(); /*16514*/
				} /*16514*/
				$1.out = $s($1.in.length * 8); /*16516*/
				for (var _39 = 0, _38 = $1.in.length - 1; _39 <= _38; _39 += 1) { /*16521*/
					$1.k = _39; /*16518*/
					$k[$j++] = ~~$z($get($1.in, $1.k)); /*16519*/
					$k[$j++] = 8; /*16519*/
					if ($1.tobin() == $b) break; /*16519*/
					$puti($1.out, $1.k * 8, $k[--$j]); /*16520*/
				} /*16520*/
				$k[$j++] = $1.out; /*16522*/
			}; /*16523*/
			$1.encK = function() {
				$1.in = $k[--$j]; /*16526*/
				$1.out = $s((~~($1.in.length / 2)) * 13); /*16527*/
				$1.k = 0; /*16528*/
				$1.m = 0; /*16528*/
				for (;;) { /*16536*/
					if ($1.k == $1.in.length) { /*16529*/
						break; /*16529*/
					} /*16529*/
					var _3S = ($get($1.in, $1.k) * 256) + $get($1.in, $1.k + 1); /*16531*/
					$k[$j++] = _3S; /*16531*/
					if (_3S < 57408) { /*16531*/
						$k[$j++] = 33088; /*16531*/
					} else { /*16531*/
						$k[$j++] = 49472; /*16531*/
					} /*16531*/
					var _3T = $k[--$j]; /*16531*/
					var _3V = $k[--$j] - _3T; /*16532*/
					$k[$j++] = ((_3V >>> 8) * 192) + (_3V & 255); /*16533*/
					$k[$j++] = 13; /*16533*/
					if ($1.tobin() == $b) break; /*16533*/
					var _3W = $k[--$j]; /*16533*/
					$puti($1.out, $1.m, _3W); /*16533*/
					$1.m = _3W.length + $1.m; /*16534*/
					$1.k = $1.k + 2; /*16535*/
				} /*16535*/
				$k[$j++] = $1.out; /*16537*/
			}; /*16538*/
			$1.encfuncs = $a(["encN", "encA", "encB", "encK"]); /*16540*/
			$1.addtobits = function() {
				var _3d = $k[--$j]; /*16543*/
				$puti($1.bits, $1.j, _3d); /*16543*/
				$1.j = _3d.length + $1.j; /*16544*/
			}; /*16545*/
			$k[$j++] = Infinity; /*16547*/
			for (var _3i = 0, _3j = $1.msglen; _3i < _3j; _3i++) { /*16547*/
				$k[$j++] = 0; /*16547*/
			} /*16547*/
			$k[$j++] = 0; /*16547*/
			$1.numNs = $a(); /*16547*/
			$k[$j++] = Infinity; /*16548*/
			for (var _3m = 0, _3n = $1.msglen; _3m < _3n; _3m++) { /*16548*/
				$k[$j++] = 0; /*16548*/
			} /*16548*/
			$k[$j++] = 0; /*16548*/
			$1.numAs = $a(); /*16548*/
			$k[$j++] = Infinity; /*16549*/
			for (var _3q = 0, _3r = $1.msglen; _3q < _3r; _3q++) { /*16549*/
				$k[$j++] = 0; /*16549*/
			} /*16549*/
			$k[$j++] = 0; /*16549*/
			$1.numBs = $a(); /*16549*/
			$k[$j++] = Infinity; /*16550*/
			for (var _3u = 0, _3v = $1.msglen; _3u < _3v; _3u++) { /*16550*/
				$k[$j++] = 0; /*16550*/
			} /*16550*/
			$k[$j++] = -1; /*16550*/
			$1.numKs = $a(); /*16550*/
			$k[$j++] = Infinity; /*16551*/
			for (var _3y = 0, _3z = $1.msglen; _3y < _3z; _3y++) { /*16551*/
				$k[$j++] = 0; /*16551*/
			} /*16551*/
			$k[$j++] = 9999; /*16551*/
			$1.nextNs = $a(); /*16551*/
			$k[$j++] = Infinity; /*16552*/
			for (var _42 = 0, _43 = $1.msglen; _42 < _43; _42++) { /*16552*/
				$k[$j++] = 0; /*16552*/
			} /*16552*/
			$k[$j++] = 9999; /*16552*/
			$1.nextBs = $a(); /*16552*/
			$k[$j++] = Infinity; /*16553*/
			for (var _46 = 0, _47 = $1.msglen; _46 < _47; _46++) { /*16553*/
				$k[$j++] = 0; /*16553*/
			} /*16553*/
			$k[$j++] = 9999; /*16553*/
			$1.nextAs = $a(); /*16553*/
			$k[$j++] = Infinity; /*16554*/
			for (var _4A = 0, _4B = $1.msglen; _4A < _4B; _4A++) { /*16554*/
				$k[$j++] = 0; /*16554*/
			} /*16554*/
			$k[$j++] = 9999; /*16554*/
			$1.nextKs = $a(); /*16554*/
			for (var _4E = $1.msglen - 1; _4E >= 0; _4E -= 1) { /*16582*/
				$1.i = _4E; /*16556*/
				$1.barchar = $get($1.msg, $1.i); /*16557*/
				var _4K = $get($1.Kexcl, $1.barchar) !== undefined; /*16558*/
				if (_4K) { /*16562*/
					$put($1.nextKs, $1.i, 0); /*16559*/
					$put($1.numKs, $1.i, $get($1.numKs, $1.i + 1) + 1); /*16560*/
				} else { /*16562*/
					$put($1.nextKs, $1.i, $get($1.nextKs, $1.i + 1) + 1); /*16562*/
				} /*16562*/
				var _4Z = $get($1.Nexcl, $1.barchar) !== undefined; /*16564*/
				if (_4Z) { /*16568*/
					$put($1.nextNs, $1.i, 0); /*16565*/
					$put($1.numNs, $1.i, $get($1.numNs, $1.i + 1) + 1); /*16566*/
				} else { /*16568*/
					$put($1.nextNs, $1.i, $get($1.nextNs, $1.i + 1) + 1); /*16568*/
				} /*16568*/
				var _4o = $get($1.Bexcl, $1.barchar) !== undefined; /*16570*/
				if (_4o) { /*16574*/
					$put($1.nextBs, $1.i, 0); /*16571*/
					$put($1.numBs, $1.i, $get($1.numBs, $1.i + 1) + 1); /*16572*/
				} else { /*16574*/
					$put($1.nextBs, $1.i, $get($1.nextBs, $1.i + 1) + 1); /*16574*/
				} /*16574*/
				var _53 = $get($1.Aexcl, $1.barchar) !== undefined; /*16576*/
				if (_53) { /*16580*/
					$put($1.nextAs, $1.i, 0); /*16577*/
					$put($1.numAs, $1.i, $get($1.numAs, $1.i + 1) + 1); /*16578*/
				} else { /*16580*/
					$put($1.nextAs, $1.i, $get($1.nextAs, $1.i + 1) + 1); /*16580*/
				} /*16580*/
			} /*16580*/
			$k[$j++] = Infinity; /*16583*/
			var _5G = $1.numKs; /*16583*/
			for (var _5H = 0, _5I = _5G.length; _5H < _5I; _5H++) { /*16583*/
				$k[$j++] = ~~(($get(_5G, _5H) + 1) / 2); /*16583*/
			} /*16583*/
			$1.numKs = $a(); /*16583*/
			$1.KbeforeB = function() {
				var _5O = $get($k[--$j], $1.ver); /*16585*/
				$k[$j++] = $ge($1.numK, _5O) && ($get($1.nextBs, ($1.numK * 2) + $1.i) == 0); /*16585*/
			}; /*16585*/
			$1.KbeforeA = function() {
				var _5W = $get($k[--$j], $1.ver); /*16586*/
				$k[$j++] = $ge($1.numK, _5W) && ($get($1.nextAs, ($1.numK * 2) + $1.i) == 0); /*16586*/
			}; /*16586*/
			$1.KbeforeN = function() {
				var _5e = $get($k[--$j], $1.ver); /*16587*/
				$k[$j++] = $ge($1.numK, _5e) && ($get($1.nextNs, ($1.numK * 2) + $1.i) == 0); /*16587*/
			}; /*16587*/
			$1.KbeforeE = function() {
				var _5m = $get($k[--$j], $1.ver); /*16588*/
				$k[$j++] = $ge($1.numK, _5m) && ((($1.numK * 2) + $1.i) == $1.msglen); /*16588*/
			}; /*16588*/
			$1.AbeforeK = function() {
				var _5t = $get($k[--$j], $1.ver); /*16589*/
				$k[$j++] = $ge($1.numA, _5t) && ($get($1.nextKs, $1.numA + $1.i) == 0); /*16589*/
			}; /*16589*/
			$1.AbeforeB = function() {
				var _61 = $get($k[--$j], $1.ver); /*16590*/
				$k[$j++] = $ge($1.numA, _61) && ($get($1.nextBs, $1.numA + $1.i) == 0); /*16590*/
			}; /*16590*/
			$1.AbeforeN = function() {
				var _69 = $get($k[--$j], $1.ver); /*16591*/
				$k[$j++] = $ge($1.numA, _69) && ($get($1.nextNs, $1.numA + $1.i) == 0); /*16591*/
			}; /*16591*/
			$1.AbeforeE = function() {
				var _6H = $get($k[--$j], $1.ver); /*16592*/
				$k[$j++] = $ge($1.numA, _6H) && (($1.numA + $1.i) == $1.msglen); /*16592*/
			}; /*16592*/
			$1.NbeforeK = function() {
				var _6O = $get($k[--$j], $1.ver); /*16593*/
				$k[$j++] = $ge($1.numN, _6O) && ($get($1.nextKs, $1.numN + $1.i) == 0); /*16593*/
			}; /*16593*/
			$1.NbeforeB = function() {
				var _6W = $get($k[--$j], $1.ver); /*16594*/
				$k[$j++] = $ge($1.numN, _6W) && ($get($1.nextBs, $1.numN + $1.i) == 0); /*16594*/
			}; /*16594*/
			$1.NbeforeA = function() {
				var _6e = $get($k[--$j], $1.ver); /*16595*/
				$k[$j++] = $ge($1.numN, _6e) && ($get($1.nextAs, $1.numN + $1.i) == 0); /*16595*/
			}; /*16595*/
			$1.NbeforeE = function() {
				var _6m = $get($k[--$j], $1.ver); /*16596*/
				$k[$j++] = $ge($1.numN, _6m) && (($1.numN + $1.i) == $1.msglen); /*16596*/
			}; /*16596*/
			$1.msgbits = $a([-1, -1, -1, -1, -1, -1, -1]); /*16599*/
			$1.v1to9 = 0; /*16600*/
			$1.v10to26 = 1; /*16600*/
			$1.v27to40 = 2; /*16600*/
			$1.vM1 = 3; /*16600*/
			$1.vM2 = 4; /*16600*/
			$1.vM3 = 5; /*16600*/
			$1.vM4 = 6; /*16600*/
			$1.e = 10000; /*16601*/
			var _6y = $a([$1.v1to9, $1.v10to26, $1.v27to40, $1.vM1, $1.vM2, $1.vM3, $1.vM4]); /*16602*/
			for (var _6z = 0, _70 = _6y.length; _6z < _70; _6z++) { /*16719*/
				$1.ver = $get(_6y, _6z); /*16603*/
				$1.mode = -1; /*16606*/
				$1.seq = $a([]); /*16606*/
				$1.i = 0; /*16606*/
				for (;;) { /*16693*/
					if ($1.i >= $1.msglen) { /*16607*/
						break; /*16607*/
					} /*16607*/
					$1.numK = $get($1.numKs, $1.i); /*16608*/
					$1.numB = $get($1.numBs, $1.i); /*16609*/
					$1.numA = $get($1.numAs, $1.i); /*16610*/
					$1.numN = $get($1.numNs, $1.i); /*16611*/
					if (($1.ver == $1.vM1) && ($1.numA >= 1)) { /*16612*/
						$1.seq = -1; /*16612*/
						break; /*16612*/
					} /*16612*/
					if (($1.ver == $1.vM1) && ($1.numB >= 1)) { /*16613*/
						$1.seq = -1; /*16613*/
						break; /*16613*/
					} /*16613*/
					if (($1.ver == $1.vM1) && ($1.numK >= 1)) { /*16614*/
						$1.seq = -1; /*16614*/
						break; /*16614*/
					} /*16614*/
					if (($1.ver == $1.vM2) && ($1.numB >= 1)) { /*16615*/
						$1.seq = -1; /*16615*/
						break; /*16615*/
					} /*16615*/
					if (($1.ver == $1.vM2) && ($1.numK >= 1)) { /*16616*/
						$1.seq = -1; /*16616*/
						break; /*16616*/
					} /*16616*/
					for (;;) { /*16674*/
						if ($1.mode == -1) { /*16635*/
							$k[$j++] = $a([1, 1, 1, $1.e, $1.e, 1, 1]); /*16619*/
							if ($1.KbeforeA() == $b) break; /*16619*/
							if ($k[--$j]) { /*16619*/
								$k[$j++] = $1.K; /*16619*/
								break; /*16619*/
							} /*16619*/
							$k[$j++] = $a([1, 1, 1, $1.e, $1.e, 1, 1]); /*16620*/
							if ($1.KbeforeN() == $b) break; /*16620*/
							if ($k[--$j]) { /*16620*/
								$k[$j++] = $1.K; /*16620*/
								break; /*16620*/
							} /*16620*/
							$k[$j++] = $a([5, 5, 6, $1.e, $1.e, 2, 3]); /*16621*/
							if ($1.KbeforeB() == $b) break; /*16621*/
							if ($k[--$j]) { /*16621*/
								$k[$j++] = $1.K; /*16621*/
								break; /*16621*/
							} /*16621*/
							$k[$j++] = $a([1, 1, 1, $1.e, $1.e, 1, 1]); /*16622*/
							if ($1.KbeforeE() == $b) break; /*16622*/
							if ($k[--$j]) { /*16622*/
								$k[$j++] = $1.K; /*16622*/
								break; /*16622*/
							} /*16622*/
							if ($1.numK >= 1) { /*16623*/
								$k[$j++] = $1.B; /*16623*/
								break; /*16623*/
							} /*16623*/
							$k[$j++] = $a([6, 7, 8, $1.e, $1.e, 3, 4]); /*16624*/
							if ($1.AbeforeB() == $b) break; /*16624*/
							if ($k[--$j]) { /*16624*/
								$k[$j++] = $1.A; /*16624*/
								break; /*16624*/
							} /*16624*/
							$k[$j++] = $a([1, 1, 1, $1.e, 1, 1, 1]); /*16625*/
							if ($1.AbeforeE() == $b) break; /*16625*/
							if ($k[--$j]) { /*16625*/
								$k[$j++] = $1.A; /*16625*/
								break; /*16625*/
							} /*16625*/
							if ($1.numA >= 1) { /*16628*/
								var _85 = ($1.ver != $1.vM2) ? $1.B : $1.A; /*16627*/
								$k[$j++] = _85; /*16627*/
								break; /*16627*/
							} /*16627*/
							$k[$j++] = $a([4, 4, 5, $1.e, $1.e, 2, 3]); /*16629*/
							if ($1.NbeforeB() == $b) break; /*16629*/
							if ($k[--$j]) { /*16629*/
								$k[$j++] = $1.N; /*16629*/
								break; /*16629*/
							} /*16629*/
							$k[$j++] = $a([1, 1, 1, $1.e, $1.e, 1, 1]); /*16630*/
							if ($1.NbeforeB() == $b) break; /*16630*/
							if ($k[--$j]) { /*16630*/
								$k[$j++] = $1.B; /*16630*/
								break; /*16630*/
							} /*16630*/
							$k[$j++] = $a([7, 8, 9, $1.e, 3, 4, 5]); /*16631*/
							if ($1.NbeforeA() == $b) break; /*16631*/
							if ($k[--$j]) { /*16631*/
								$k[$j++] = $1.N; /*16631*/
								break; /*16631*/
							} /*16631*/
							$k[$j++] = $a([1, 1, 1, $1.e, 1, 1, 1]); /*16632*/
							if ($1.NbeforeA() == $b) break; /*16632*/
							if ($k[--$j]) { /*16632*/
								$k[$j++] = $1.A; /*16632*/
								break; /*16632*/
							} /*16632*/
							if ($1.numN >= 1) { /*16633*/
								$k[$j++] = $1.N; /*16633*/
								break; /*16633*/
							} /*16633*/
							$k[$j++] = $1.B; /*16634*/
							break; /*16634*/
						} /*16634*/
						if ($1.mode == $1.B) { /*16650*/
							$k[$j++] = $a([9, 12, 13, $1.e, $1.e, 4, 5]); /*16637*/
							if ($1.KbeforeB() == $b) break; /*16637*/
							if ($k[--$j]) { /*16637*/
								$k[$j++] = $1.K; /*16637*/
								break; /*16637*/
							} /*16637*/
							$k[$j++] = $a([9, 10, 12, $1.e, $1.e, 4, 5]); /*16638*/
							if ($1.KbeforeA() == $b) break; /*16638*/
							if ($k[--$j]) { /*16638*/
								$k[$j++] = $1.K; /*16638*/
								break; /*16638*/
							} /*16638*/
							$k[$j++] = $a([9, 10, 11, $1.e, $1.e, 5, 6]); /*16639*/
							if ($1.KbeforeN() == $b) break; /*16639*/
							if ($k[--$j]) { /*16639*/
								$k[$j++] = $1.K; /*16639*/
								break; /*16639*/
							} /*16639*/
							$k[$j++] = $a([4, 5, 6, $1.e, $1.e, 2, 3]); /*16640*/
							if ($1.KbeforeE() == $b) break; /*16640*/
							if ($k[--$j]) { /*16640*/
								$k[$j++] = $1.K; /*16640*/
								break; /*16640*/
							} /*16640*/
							$k[$j++] = $a([11, 12, 14, $1.e, $1.e, 5, 7]); /*16641*/
							if ($1.AbeforeK() == $b) break; /*16641*/
							if ($k[--$j]) { /*16641*/
								$k[$j++] = $1.A; /*16641*/
								break; /*16641*/
							} /*16641*/
							$k[$j++] = $a([11, 15, 16, $1.e, $1.e, 6, 7]); /*16642*/
							if ($1.AbeforeB() == $b) break; /*16642*/
							if ($k[--$j]) { /*16642*/
								$k[$j++] = $1.A; /*16642*/
								break; /*16642*/
							} /*16642*/
							$k[$j++] = $a([12, 13, 15, $1.e, $1.e, 6, 8]); /*16643*/
							if ($1.AbeforeN() == $b) break; /*16643*/
							if ($k[--$j]) { /*16643*/
								$k[$j++] = $1.A; /*16643*/
								break; /*16643*/
							} /*16643*/
							$k[$j++] = $a([6, 7, 8, $1.e, $1.e, 3, 4]); /*16644*/
							if ($1.AbeforeE() == $b) break; /*16644*/
							if ($k[--$j]) { /*16644*/
								$k[$j++] = $1.A; /*16644*/
								break; /*16644*/
							} /*16644*/
							$k[$j++] = $a([6, 7, 8, $1.e, $1.e, 3, 4]); /*16645*/
							if ($1.NbeforeK() == $b) break; /*16645*/
							if ($k[--$j]) { /*16645*/
								$k[$j++] = $1.N; /*16645*/
								break; /*16645*/
							} /*16645*/
							$k[$j++] = $a([6, 8, 9, $1.e, $1.e, 3, 4]); /*16646*/
							if ($1.NbeforeB() == $b) break; /*16646*/
							if ($k[--$j]) { /*16646*/
								$k[$j++] = $1.N; /*16646*/
								break; /*16646*/
							} /*16646*/
							$k[$j++] = $a([6, 7, 8, $1.e, $1.e, 3, 4]); /*16647*/
							if ($1.NbeforeA() == $b) break; /*16647*/
							if ($k[--$j]) { /*16647*/
								$k[$j++] = $1.N; /*16647*/
								break; /*16647*/
							} /*16647*/
							$k[$j++] = $a([3, 4, 5, $1.e, $1.e, 2, 3]); /*16648*/
							if ($1.NbeforeE() == $b) break; /*16648*/
							if ($k[--$j]) { /*16648*/
								$k[$j++] = $1.N; /*16648*/
								break; /*16648*/
							} /*16648*/
							$k[$j++] = $1.B; /*16649*/
							break; /*16649*/
						} /*16649*/
						if ($1.mode == $1.A) { /*16659*/
							if ($1.numK >= 1) { /*16652*/
								$k[$j++] = $1.K; /*16652*/
								break; /*16652*/
							} /*16652*/
							if ($1.numB >= 1) { /*16653*/
								$k[$j++] = $1.B; /*16653*/
								break; /*16653*/
							} /*16653*/
							$k[$j++] = $a([13, 15, 17, $1.e, 5, 7, 9]); /*16654*/
							if ($1.NbeforeA() == $b) break; /*16654*/
							if ($k[--$j]) { /*16654*/
								$k[$j++] = $1.N; /*16654*/
								break; /*16654*/
							} /*16654*/
							$k[$j++] = $a([13, 17, 18, $1.e, $1.e, 7, 9]); /*16655*/
							if ($1.NbeforeB() == $b) break; /*16655*/
							if ($k[--$j]) { /*16655*/
								$k[$j++] = $1.N; /*16655*/
								break; /*16655*/
							} /*16655*/
							$k[$j++] = $a([7, 8, 9, $1.e, 3, 4, 5]); /*16656*/
							if ($1.NbeforeE() == $b) break; /*16656*/
							if ($k[--$j]) { /*16656*/
								$k[$j++] = $1.N; /*16656*/
								break; /*16656*/
							} /*16656*/
							if (($1.numA >= 1) || ($1.numN >= 1)) { /*16657*/
								$k[$j++] = $1.A; /*16657*/
								break; /*16657*/
							} /*16657*/
							$k[$j++] = $1.B; /*16658*/
							break; /*16658*/
						} /*16658*/
						if ($1.mode == $1.N) { /*16666*/
							if ($1.numK >= 1) { /*16661*/
								$k[$j++] = $1.K; /*16661*/
								break; /*16661*/
							} /*16661*/
							if ($1.numB >= 1) { /*16662*/
								$k[$j++] = $1.B; /*16662*/
								break; /*16662*/
							} /*16662*/
							if ($1.numA >= 1) { /*16663*/
								$k[$j++] = $1.A; /*16663*/
								break; /*16663*/
							} /*16663*/
							if ($1.numN >= 1) { /*16664*/
								$k[$j++] = $1.N; /*16664*/
								break; /*16664*/
							} /*16664*/
							$k[$j++] = $1.B; /*16665*/
							break; /*16665*/
						} /*16665*/
						if ($1.mode == $1.K) { /*16673*/
							if ($1.numB >= 1) { /*16668*/
								$k[$j++] = $1.B; /*16668*/
								break; /*16668*/
							} /*16668*/
							if ($1.numA >= 1) { /*16669*/
								$k[$j++] = $1.A; /*16669*/
								break; /*16669*/
							} /*16669*/
							if ($1.numN >= 1) { /*16670*/
								$k[$j++] = $1.N; /*16670*/
								break; /*16670*/
							} /*16670*/
							if ($1.numK >= 1) { /*16671*/
								$k[$j++] = $1.K; /*16671*/
								break; /*16671*/
							} /*16671*/
							$k[$j++] = $1.B; /*16672*/
							break; /*16672*/
						} /*16672*/
					} /*16672*/
					var _AB = $k[--$j]; /*16675*/
					$k[$j++] = _AB; /*16675*/
					if ((_AB == $1.K) && $1.fnc1first) { /*16675*/
						$j--; /*16675*/
						$k[$j++] = $1.B; /*16675*/
					} /*16675*/
					var _AF = $k[--$j]; /*16676*/
					$k[$j++] = _AF; /*16691*/
					if (_AF == $1.mode) { /*16690*/
						$j--; /*16677*/
						var _AL = ($1.mode == $1.K) ? 2 : 1; /*16678*/
						$1.dat = $geti($1.msg, $1.i, _AL); /*16678*/
						$k[$j++] = Infinity; /*16682*/
						$aload($1.seq); /*16680*/
						$k[$j++] = Infinity; /*16681*/
						var _AO = $k[--$j]; /*16681*/
						var _AP = $k[--$j]; /*16681*/
						$k[$j++] = _AO; /*16681*/
						$aload(_AP); /*16681*/
						$aload($1.dat); /*16681*/
						var _AR = $a(); /*16681*/
						$k[$j++] = _AR; /*16681*/
						$1.seq = $a(); /*16682*/
					} else { /*16690*/
						$1.mode = $k[--$j]; /*16684*/
						if ($1.mode == $1.K) { /*16685*/
							$k[$j++] = $1.K; /*16685*/
							$k[$j++] = $geti($1.msg, $1.i, $1.numK * 2); /*16685*/
						} /*16685*/
						if ($1.mode == $1.B) { /*16686*/
							$k[$j++] = $1.B; /*16686*/
							$k[$j++] = $geti($1.msg, $1.i, $1.numB); /*16686*/
						} /*16686*/
						if ($1.mode == $1.A) { /*16687*/
							$k[$j++] = $1.A; /*16687*/
							$k[$j++] = $geti($1.msg, $1.i, $1.numA); /*16687*/
						} /*16687*/
						if ($1.mode == $1.N) { /*16688*/
							$k[$j++] = $1.N; /*16688*/
							$k[$j++] = $geti($1.msg, $1.i, $1.numN); /*16688*/
						} /*16688*/
						$1.dat = $k[--$j]; /*16689*/
						$1.sw = $k[--$j]; /*16689*/
						$k[$j++] = Infinity; /*16690*/
						$aload($1.seq); /*16690*/
						$k[$j++] = $1.sw; /*16690*/
						$k[$j++] = $1.dat; /*16690*/
						$1.seq = $a(); /*16690*/
					} /*16690*/
					$1.i = $1.i + $1.dat.length; /*16692*/
				} /*16692*/
				for (;;) { /*16718*/
					if ($1.seq == -1) { /*16697*/
						break; /*16697*/
					} /*16697*/
					$1.bits = $s(23648); /*16698*/
					$1.j = 0; /*16699*/
					if ($1.fnc1first) { /*16700*/
						$k[$j++] = "0101"; /*16700*/
						if ($1.addtobits() == $b) break; /*16700*/
					} /*16700*/
					$1.abort = false; /*16701*/
					for (var _B9 = 0, _B8 = $1.seq.length - 1; _B9 <= _B8; _B9 += 2) { /*16713*/
						$1.i = _B9; /*16703*/
						$1.mode = $get($1.seq, $1.i); /*16704*/
						$k[$j++] = $get($get($1.mids, $1.ver), $1.mode); /*16705*/
						if ($1.addtobits() == $b) break; /*16705*/
						$1.cclen = $get($get($1.cclens, $1.ver), $1.mode); /*16706*/
						$1.chars = $get($1.seq, $1.i + 1); /*16707*/
						if ($1.chars.length >= (~~Math.pow(2, $1.cclen))) { /*16710*/
							$1.abort = true; /*16709*/
							break; /*16709*/
						} /*16709*/
						$k[$j++] = $1.chars.length; /*16711*/
						if ($1.mode == $1.K) { /*16711*/
							var _BV = $k[--$j]; /*16711*/
							$k[$j++] = ~~(_BV / 2); /*16711*/
						} /*16711*/
						$k[$j++] = $1.cclen; /*16711*/
						if ($1.tobin() == $b) break; /*16711*/
						if ($1.addtobits() == $b) break; /*16711*/
						$k[$j++] = $1.chars; /*16712*/
						$1[$get($1.encfuncs, $1.mode)](); /*16712*/
						if ($1.addtobits() == $b) break; /*16712*/
					} /*16712*/
					if ($1.abort) { /*16714*/
						break; /*16714*/
					} /*16714*/
					$1.bits = $geti($1.bits, 0, $1.j); /*16715*/
					$put($1.msgbits, $1.ver, $1.bits); /*16716*/
					break; /*16717*/
				} /*16717*/
			} /*16717*/
			$1.metrics = $a([$a(["micro", "M1", $1.vM1, 11, 98, 99, 36, $a([2, 99, 99, 99]), $a([1, 0, -1, -1, -1, -1, -1, -1])]), $a(["micro", "M2", $1.vM2, 13, 98, 99, 80, $a([5, 6, 99, 99]), $a([1, 0, 1, 0, -1, -1, -1, -1])]), $a(["micro", "M3", $1.vM3, 15, 98, 99, 132, $a([6, 8, 99, 99]), $a([1, 0, 1, 0, -1, -1, -1, -1])]), $a(["micro", "M4", $1.vM4, 17, 98, 99, 192, $a([8, 10, 14, 99]), $a([1, 0, 1, 0, 1, 0, -1, -1])]), $a(["full", "1", $1.v1to9, 21, 98, 99, 208, $a([7, 10, 13, 17]), $a([1, 0, 1, 0, 1, 0, 1, 0])]), $a(["full", "2", $1.v1to9, 25, 18, 99, 359, $a([10, 16, 22, 28]), $a([1, 0, 1, 0, 1, 0, 1, 0])]), $a(["full", "3", $1.v1to9, 29, 22, 99, 567, $a([15, 26, 36, 44]), $a([1, 0, 1, 0, 2, 0, 2, 0])]), $a(["full", "4", $1.v1to9, 33, 26, 99, 807, $a([20, 36, 52, 64]), $a([1, 0, 2, 0, 2, 0, 4, 0])]), $a(["full", "5", $1.v1to9, 37, 30, 99, 1079, $a([26, 48, 72, 88]), $a([1, 0, 2, 0, 2, 2, 2, 2])]), $a(["full", "6", $1.v1to9, 41, 34, 99, 1383, $a([36, 64, 96, 112]), $a([2, 0, 4, 0, 4, 0, 4, 0])]), $a(["full", "7", $1.v1to9, 45, 22, 38, 1568, $a([40, 72, 108, 130]), $a([2, 0, 4, 0, 2, 4, 4, 1])]), $a(["full", "8", $1.v1to9, 49, 24, 42, 1936, $a([48, 88, 132, 156]), $a([2, 0, 2, 2, 4, 2, 4, 2])]), $a(["full", "9", $1.v1to9, 53, 26, 46, 2336, $a([60, 110, 160, 192]), $a([2, 0, 3, 2, 4, 4, 4, 4])]), $a(["full", "10", $1.v10to26, 57, 28, 50, 2768, $a([72, 130, 192, 224]), $a([2, 2, 4, 1, 6, 2, 6, 2])]), $a(["full", "11", $1.v10to26, 61, 30, 54, 3232, $a([80, 150, 224, 264]), $a([4, 0, 1, 4, 4, 4, 3, 8])]), $a(["full", "12", $1.v10to26, 65, 32, 58, 3728, $a([96, 176, 260, 308]), $a([2, 2, 6, 2, 4, 6, 7, 4])]), $a(["full", "13", $1.v10to26, 69, 34, 62, 4256, $a([104, 198, 288, 352]), $a([4, 0, 8, 1, 8, 4, 12, 4])]), $a(["full", "14", $1.v10to26, 73, 26, 46, 4651, $a([120, 216, 320, 384]), $a([3, 1, 4, 5, 11, 5, 11, 5])]), $a(["full", "15", $1.v10to26, 77, 26, 48, 5243, $a([132, 240, 360, 432]), $a([5, 1, 5, 5, 5, 7, 11, 7])]), $a(["full", "16", $1.v10to26, 81, 26, 50, 5867, $a([144, 280, 408, 480]), $a([5, 1, 7, 3, 15, 2, 3, 13])]), $a(["full", "17", $1.v10to26, 85, 30, 54, 6523, $a([168, 308, 448, 532]), $a([1, 5, 10, 1, 1, 15, 2, 17])]), $a(["full", "18", $1.v10to26, 89, 30, 56, 7211, $a([180, 338, 504, 588]), $a([5, 1, 9, 4, 17, 1, 2, 19])]), $a(["full", "19", $1.v10to26, 93, 30, 58, 7931, $a([196, 364, 546, 650]), $a([3, 4, 3, 11, 17, 4, 9, 16])]), $a(["full", "20", $1.v10to26, 97, 34, 62, 8683, $a([224, 416, 600, 700]), $a([3, 5, 3, 13, 15, 5, 15, 10])]), $a(["full", "21", $1.v10to26, 101, 28, 50, 9252, $a([224, 442, 644, 750]), $a([4, 4, 17, 0, 17, 6, 19, 6])]), $a(["full", "22", $1.v10to26, 105, 26, 50, 10068, $a([252, 476, 690, 816]), $a([2, 7, 17, 0, 7, 16, 34, 0])]), $a(["full", "23", $1.v10to26, 109, 30, 54, 10916, $a([270, 504, 750, 900]), $a([4, 5, 4, 14, 11, 14, 16, 14])]), $a(["full", "24", $1.v10to26, 113, 28, 54, 11796, $a([300, 560, 810, 960]), $a([6, 4, 6, 14, 11, 16, 30, 2])]), $a(["full", "25", $1.v10to26, 117, 32, 58, 12708, $a([312, 588, 870, 1050]), $a([8, 4, 8, 13, 7, 22, 22, 13])]), $a(["full", "26", $1.v10to26, 121, 30, 58, 13652, $a([336, 644, 952, 1110]), $a([10, 2, 19, 4, 28, 6, 33, 4])]), $a(["full", "27", $1.v27to40, 125, 34, 62, 14628, $a([360, 700, 1020, 1200]), $a([8, 4, 22, 3, 8, 26, 12, 28])]), $a(["full", "28", $1.v27to40, 129, 26, 50, 15371, $a([390, 728, 1050, 1260]), $a([3, 10, 3, 23, 4, 31, 11, 31])]), $a(["full", "29", $1.v27to40, 133, 30, 54, 16411, $a([420, 784, 1140, 1350]), $a([7, 7, 21, 7, 1, 37, 19, 26])]), $a(["full", "30", $1.v27to40, 137, 26, 52, 17483, $a([450, 812, 1200, 1440]), $a([5, 10, 19, 10, 15, 25, 23, 25])]), $a(["full", "31", $1.v27to40, 141, 30, 56, 18587, $a([480, 868, 1290, 1530]), $a([13, 3, 2, 29, 42, 1, 23, 28])]), $a(["full", "32", $1.v27to40, 145, 34, 60, 19723, $a([510, 924, 1350, 1620]), $a([17, 0, 10, 23, 10, 35, 19, 35])]), $a(["full", "33", $1.v27to40, 149, 30, 58, 20891, $a([540, 980, 1440, 1710]), $a([17, 1, 14, 21, 29, 19, 11, 46])]), $a(["full", "34", $1.v27to40, 153, 34, 62, 22091, $a([570, 1036, 1530, 1800]), $a([13, 6, 14, 23, 44, 7, 59, 1])]), $a(["full", "35", $1.v27to40, 157, 30, 54, 23008, $a([570, 1064, 1590, 1890]), $a([12, 7, 12, 26, 39, 14, 22, 41])]), $a(["full", "36", $1.v27to40, 161, 24, 50, 24272, $a([600, 1120, 1680, 1980]), $a([6, 14, 6, 34, 46, 10, 2, 64])]), $a(["full", "37", $1.v27to40, 165, 28, 54, 25568, $a([630, 1204, 1770, 2100]), $a([17, 4, 29, 14, 49, 10, 24, 46])]), $a(["full", "38", $1.v27to40, 169, 32, 58, 26896, $a([660, 1260, 1860, 2220]), $a([4, 18, 13, 32, 48, 14, 42, 32])]), $a(["full", "39", $1.v27to40, 173, 26, 54, 28256, $a([720, 1316, 1950, 2310]), $a([20, 4, 40, 7, 43, 22, 10, 67])]), $a(["full", "40", $1.v27to40, 177, 30, 58, 29648, $a([750, 1372, 2040, 2430]), $a([19, 6, 18, 31, 34, 34, 20, 61])])]); /*16769*/
			$k[$j++] = "eclval"; /*16770*/
			$search("LMQH", $1.eclevel); /*16770*/
			$j--; /*16770*/
			var _Eb = $k[--$j]; /*16770*/
			var _Ec = $k[--$j]; /*16770*/
			var _Ed = $k[--$j]; /*16770*/
			$1[$k[--$j]] = _Eb.length; /*16770*/
			for (var _Ef = 0; _Ef <= 43; _Ef += 1) { /*16807*/
				$1.i = _Ef; /*16772*/
				$1.m = $get($1.metrics, $1.i); /*16773*/
				$1.frmt = $get($1.m, 0); /*16774*/
				$1.vers = $get($1.m, 1); /*16775*/
				$1.vergrp = $get($1.m, 2); /*16776*/
				$1.size = $get($1.m, 3); /*16777*/
				$1.asp2 = $get($1.m, 4); /*16778*/
				$1.asp3 = $get($1.m, 5); /*16779*/
				$1.nmod = $get($1.m, 6); /*16780*/
				$1.ncws = ~~($1.nmod / 8); /*16781*/
				$1.rbit = $1.nmod % 8; /*16782*/
				$1.lc4b = false; /*16783*/
				if (($1.size == 11) || ($1.size == 15)) { /*16788*/
					$1.ncws = $1.ncws + 1; /*16785*/
					$1.rbit = 0; /*16786*/
					$1.lc4b = true; /*16787*/
				} /*16787*/
				$1.ecws = $get($get($1.m, 7), $1.eclval); /*16789*/
				$1.dcws = $1.ncws - $1.ecws; /*16790*/
				var _FA = $1.lc4b ? 4 : 0; /*16791*/
				$1.dmod = ($1.dcws * 8) - _FA; /*16791*/
				$1.ecb1 = $get($get($1.m, 8), $1.eclval * 2); /*16792*/
				$1.ecb2 = $get($get($1.m, 8), ($1.eclval * 2) + 1); /*16793*/
				$1.okay = true; /*16794*/
				if ($ne($1.format, "any") && $ne($1.format, $1.frmt)) { /*16795*/
					$1.okay = false; /*16795*/
				} /*16795*/
				if ($eq($1.frmt, "micro") && $1.fnc1first) { /*16796*/
					$1.okay = false; /*16796*/
				} /*16796*/
				if ($ne($1.version, "unset") && $ne($1.version, $1.vers)) { /*16797*/
					$1.okay = false; /*16797*/
				} /*16797*/
				if (($1.ecb1 == -1) || ($1.ecb2 == -1)) { /*16798*/
					$1.okay = false; /*16798*/
				} /*16798*/
				$1.verbits = $get($1.msgbits, $1.vergrp); /*16799*/
				if ($1.verbits == -1) { /*16803*/
					$1.okay = false; /*16801*/
				} else { /*16803*/
					if ($1.verbits.length > $1.dmod) { /*16803*/
						$1.okay = false; /*16803*/
					} /*16803*/
				} /*16803*/
				$1.term = $geti("000000000", 0, $get($1.termlens, $1.vergrp)); /*16805*/
				if ($1.okay) { /*16806*/
					break; /*16806*/
				} /*16806*/
			} /*16806*/
			if (!$1.okay) { /*16811*/
				$k[$j++] = "bwipp.qrcodeNoValidSymbol"; /*16810*/
				$k[$j++] = "No valid symbol available"; /*16810*/
				$0.raiseerror(); /*16810*/
			} /*16810*/
			$1.format = $1.frmt; /*16813*/
			$1.version = $1.vers; /*16814*/
			$1.msgbits = $1.verbits; /*16815*/
			$1.dcpb = ~~($1.dcws / ($1.ecb1 + $1.ecb2)); /*16816*/
			$1.ecpb = (~~($1.ncws / ($1.ecb1 + $1.ecb2))) - $1.dcpb; /*16817*/
			var _Fp = $1.term; /*16820*/
			var _Fq = $1.dmod; /*16820*/
			var _Fr = $1.msgbits; /*16820*/
			var _Fs = $1.term; /*16820*/
			var _Ft = _Fs.length; /*16820*/
			var _Fu = _Fq - _Fr.length; /*16820*/
			if ((_Fq - _Fr.length) > _Fs.length) { /*16820*/
				var _ = _Ft; /*16820*/
				_Ft = _Fu; /*16820*/
				_Fu = _; /*16820*/
			} /*16820*/
			$1.term = $geti(_Fp, 0, _Fu); /*16820*/
			var _Fy = $s($1.msgbits.length + $1.term.length); /*16821*/
			$puti(_Fy, 0, $1.msgbits); /*16822*/
			$puti(_Fy, $1.msgbits.length, $1.term); /*16823*/
			$1.msgbits = _Fy; /*16824*/
			$1.pad = $s($1.dmod); /*16827*/
			for (var _G6 = 0, _G5 = $1.pad.length - 1; _G6 <= _G5; _G6 += 1) { /*16828*/
				$put($1.pad, _G6, 48); /*16828*/
			} /*16828*/
			$puti($1.pad, 0, $1.msgbits); /*16829*/
			$1.padstrs = $a(["11101100", "00010001"]); /*16830*/
			$1.padnum = 0; /*16831*/
			var _GE = $1.lc4b ? 5 : 1; /*16832*/
			for (var _GG = ~~(Math.ceil($1.msgbits.length / 8) * 8), _GF = $1.dmod - _GE; _GG <= _GF; _GG += 8) { /*16835*/
				$puti($1.pad, _GG, $get($1.padstrs, $1.padnum)); /*16833*/
				$1.padnum = ($1.padnum + 1) % 2; /*16834*/
			} /*16834*/
			$1.cws = $a($1.dcws); /*16838*/
			for (var _GQ = 0, _GP = $1.cws.length - 1; _GQ <= _GP; _GQ += 1) { /*16850*/
				$1.c = _GQ; /*16840*/
				$1.bpcw = 8; /*16841*/
				if ($1.lc4b && ($1.c == ($1.cws.length - 1))) { /*16842*/
					$1.bpcw = 4; /*16842*/
				} /*16842*/
				$1.cwb = $geti($1.pad, $1.c * 8, $1.bpcw); /*16843*/
				$1.cw = 0; /*16844*/
				for (var _Ga = 0, _GZ = $1.bpcw - 1; _Ga <= _GZ; _Ga += 1) { /*16848*/
					$1.i = _Ga; /*16846*/
					$1.cw = $1.cw + ((~~(Math.pow(2, ($1.bpcw - $1.i) - 1))) * ($get($1.cwb, $1.i) - 48)); /*16847*/
				} /*16847*/
				$put($1.cws, $1.c, $1.cw); /*16849*/
			} /*16849*/
			if ($1.lc4b) { /*16853*/
				var _Gl = $1.cws; /*16853*/
				var _Gm = $1.cws; /*16853*/
				$put(_Gl, _Gm.length - 1, $get(_Gl, _Gm.length - 1) << 4); /*16853*/
			} /*16853*/
			$k[$j++] = Infinity; /*16856*/
			$k[$j++] = 1; /*16856*/
			for (var _Go = 0, _Gp = 255; _Go < _Gp; _Go++) { /*16856*/
				var _Gq = $k[--$j]; /*16856*/
				var _Gr = _Gq * 2; /*16856*/
				$k[$j++] = _Gq; /*16856*/
				$k[$j++] = _Gr; /*16856*/
				if (_Gr >= 256) { /*16856*/
					var _Gs = $k[--$j]; /*16856*/
					$k[$j++] = _Gs ^ 285; /*16856*/
				} /*16856*/
			} /*16856*/
			$1.rsalog = $a(); /*16856*/
			$1.rslog = $a(256); /*16857*/
			for (var _Gv = 1; _Gv <= 255; _Gv += 1) { /*16858*/
				$put($1.rslog, $get($1.rsalog, _Gv), _Gv); /*16858*/
			} /*16858*/
			$1.rsprod = function() {
				var _Gz = $k[--$j]; /*16862*/
				var _H0 = $k[--$j]; /*16862*/
				$k[$j++] = _H0; /*16866*/
				$k[$j++] = _Gz; /*16866*/
				if ((_Gz != 0) && (_H0 != 0)) { /*16865*/
					var _H3 = $get($1.rslog, $k[--$j]); /*16863*/
					var _H8 = $get($1.rsalog, (_H3 + $get($1.rslog, $k[--$j])) % 255); /*16863*/
					$k[$j++] = _H8; /*16863*/
				} else { /*16865*/
					$j -= 2; /*16865*/
					$k[$j++] = 0; /*16865*/
				} /*16865*/
			}; /*16867*/
			$k[$j++] = Infinity; /*16870*/
			$k[$j++] = 1; /*16870*/
			for (var _HA = 0, _HB = $1.ecpb; _HA < _HB; _HA++) { /*16870*/
				$k[$j++] = 0; /*16870*/
			} /*16870*/
			$1.coeffs = $a(); /*16870*/
			for (var _HF = 0, _HE = $1.ecpb - 1; _HF <= _HE; _HF += 1) { /*16879*/
				$1.i = _HF; /*16872*/
				$put($1.coeffs, $1.i + 1, $get($1.coeffs, $1.i)); /*16873*/
				for (var _HM = $1.i; _HM >= 1; _HM -= 1) { /*16877*/
					$1.j = _HM; /*16875*/
					$k[$j++] = $1.coeffs; /*16876*/
					$k[$j++] = $1.j; /*16876*/
					$k[$j++] = $get($1.coeffs, $1.j - 1); /*16876*/
					$k[$j++] = $get($1.coeffs, $1.j); /*16876*/
					$k[$j++] = $get($1.rsalog, $1.i); /*16876*/
					if ($1.rsprod() == $b) break; /*16876*/
					var _HY = $k[--$j]; /*16876*/
					var _HZ = $k[--$j]; /*16876*/
					var _Ha = $k[--$j]; /*16876*/
					$put($k[--$j], _Ha, $xo(_HZ, _HY)); /*16876*/
				} /*16876*/
				$k[$j++] = $1.coeffs; /*16878*/
				$k[$j++] = 0; /*16878*/
				$k[$j++] = $get($1.coeffs, 0); /*16878*/
				$k[$j++] = $get($1.rsalog, $1.i); /*16878*/
				if ($1.rsprod() == $b) break; /*16878*/
				var _Hi = $k[--$j]; /*16878*/
				var _Hj = $k[--$j]; /*16878*/
				$put($k[--$j], _Hj, _Hi); /*16878*/
			} /*16878*/
			$1.coeffs = $geti($1.coeffs, 0, $1.coeffs.length - 1); /*16880*/
			$1.rscodes = function() {
				$1.rscws = $k[--$j]; /*16884*/
				$1.rsnd = $1.rscws.length; /*16885*/
				$k[$j++] = Infinity; /*16886*/
				$forall($1.rscws); /*16886*/
				for (var _Hs = 0, _Ht = $1.ecpb; _Hs < _Ht; _Hs++) { /*16886*/
					$k[$j++] = 0; /*16886*/
				} /*16886*/
				$1.rscws = $a(); /*16886*/
				for (var _Hx = 0, _Hw = $1.rsnd - 1; _Hx <= _Hw; _Hx += 1) { /*16894*/
					$1.m = _Hx; /*16888*/
					$1.k = $get($1.rscws, $1.m); /*16889*/
					for (var _I3 = 0, _I2 = $1.ecpb - 1; _I3 <= _I2; _I3 += 1) { /*16893*/
						$1.j = _I3; /*16891*/
						$k[$j++] = $1.rscws; /*16892*/
						$k[$j++] = ($1.m + $1.j) + 1; /*16892*/
						$k[$j++] = $get($1.coeffs, ($1.ecpb - $1.j) - 1); /*16892*/
						$k[$j++] = $1.k; /*16892*/
						if ($1.rsprod() == $b) break; /*16892*/
						var _IG = $k[--$j]; /*16892*/
						var _IH = $k[--$j]; /*16892*/
						$put($k[--$j], _IH, $xo(_IG, $get($1.rscws, ($1.m + $1.j) + 1))); /*16892*/
					} /*16892*/
				} /*16892*/
				$k[$j++] = $geti($1.rscws, $1.rsnd, $1.ecpb); /*16895*/
			}; /*16896*/
			$1.dcwsb = $a($1.ecb1 + $1.ecb2); /*16899*/
			$1.ecwsb = $a($1.ecb1 + $1.ecb2); /*16900*/
			for (var _IV = 0, _IU = $1.ecb1 - 1; _IV <= _IU; _IV += 1) { /*16905*/
				$1.i = _IV; /*16902*/
				$put($1.dcwsb, $1.i, $geti($1.cws, $1.i * $1.dcpb, $1.dcpb)); /*16903*/
				$k[$j++] = $1.ecwsb; /*16904*/
				$k[$j++] = $1.i; /*16904*/
				$k[$j++] = $get($1.dcwsb, $1.i); /*16904*/
				if ($1.rscodes() == $b) break; /*16904*/
				var _Ii = $k[--$j]; /*16904*/
				var _Ij = $k[--$j]; /*16904*/
				$put($k[--$j], _Ij, _Ii); /*16904*/
			} /*16904*/
			for (var _In = 0, _Im = $1.ecb2 - 1; _In <= _Im; _In += 1) { /*16910*/
				$1.i = _In; /*16907*/
				$put($1.dcwsb, $1.ecb1 + $1.i, $geti($1.cws, ($1.ecb1 * $1.dcpb) + ($1.i * ($1.dcpb + 1)), $1.dcpb + 1)); /*16908*/
				$k[$j++] = $1.ecwsb; /*16909*/
				$k[$j++] = $1.ecb1 + $1.i; /*16909*/
				$k[$j++] = $get($1.dcwsb, $1.ecb1 + $1.i); /*16909*/
				if ($1.rscodes() == $b) break; /*16909*/
				var _J5 = $k[--$j]; /*16909*/
				var _J6 = $k[--$j]; /*16909*/
				$put($k[--$j], _J6, _J5); /*16909*/
			} /*16909*/
			$1.cws = $a($1.ncws); /*16913*/
			$1.cw = 0; /*16914*/
			for (var _JC = 0, _JB = $1.dcpb; _JC <= _JB; _JC += 1) { /*16924*/
				$1.i = _JC; /*16916*/
				for (var _JG = 0, _JF = ($1.ecb1 + $1.ecb2) - 1; _JG <= _JF; _JG += 1) { /*16923*/
					$1.j = _JG; /*16918*/
					if ($1.i < $get($1.dcwsb, $1.j).length) { /*16922*/
						$put($1.cws, $1.cw, $get($get($1.dcwsb, $1.j), $1.i)); /*16920*/
						$1.cw = $1.cw + 1; /*16921*/
					} /*16921*/
				} /*16921*/
			} /*16921*/
			for (var _JV = 0, _JU = $1.ecpb - 1; _JV <= _JU; _JV += 1) { /*16932*/
				$1.i = _JV; /*16926*/
				for (var _JZ = 0, _JY = ($1.ecb1 + $1.ecb2) - 1; _JZ <= _JY; _JZ += 1) { /*16931*/
					$1.j = _JZ; /*16928*/
					$put($1.cws, $1.cw, $get($get($1.ecwsb, $1.j), $1.i)); /*16929*/
					$1.cw = $1.cw + 1; /*16930*/
				} /*16930*/
			} /*16930*/
			if ($1.rbit > 0) { /*16940*/
				$1.pad = $a($1.cws.length + 1); /*16936*/
				$puti($1.pad, 0, $1.cws); /*16937*/
				$put($1.pad, $1.pad.length - 1, 0); /*16938*/
				$1.cws = $1.pad; /*16939*/
			} /*16939*/
			if ($1.lc4b) { /*16951*/
				var _Jr = $1.cws; /*16944*/
				var _Js = $1.dcws; /*16944*/
				$put(_Jr, _Js - 1, $get(_Jr, _Js - 1) >>> 4); /*16944*/
				for (var _Jx = $1.dcws - 1, _Jw = $1.ncws - 2; _Jx <= _Jw; _Jx += 1) { /*16949*/
					$1.i = _Jx; /*16946*/
					$put($1.cws, $1.i, ($get($1.cws, $1.i) & 15) << 4); /*16947*/
					$put($1.cws, $1.i, (($get($1.cws, $1.i + 1) >>> 4) & 15) | $get($1.cws, $1.i)); /*16948*/
				} /*16948*/
				$put($1.cws, $1.ncws - 1, ($get($1.cws, $1.ncws - 1) & 15) << 4); /*16950*/
			} /*16950*/
			$k[$j++] = Infinity; /*16954*/
			for (var _KI = 0, _KJ = $1.size * $1.size; _KI < _KJ; _KI++) { /*16954*/
				$k[$j++] = -1; /*16954*/
			} /*16954*/
			$1.pixs = $a(); /*16954*/
			$1.qmv = function() {
				var _KM = $k[--$j]; /*16955*/
				var _KN = $k[--$j]; /*16955*/
				$k[$j++] = _KN + (_KM * $1.size); /*16955*/
			}; /*16955*/
			$1.fpat = $a([$a([1, 1, 1, 1, 1, 1, 1, 0]), $a([1, 0, 0, 0, 0, 0, 1, 0]), $a([1, 0, 1, 1, 1, 0, 1, 0]), $a([1, 0, 1, 1, 1, 0, 1, 0]), $a([1, 0, 1, 1, 1, 0, 1, 0]), $a([1, 0, 0, 0, 0, 0, 1, 0]), $a([1, 1, 1, 1, 1, 1, 1, 0]), $a([0, 0, 0, 0, 0, 0, 0, 0])]); /*16967*/
			for (var _KZ = 0, _KY = $1.fpat.length - 1; _KZ <= _KY; _KZ += 1) { /*16979*/
				$1.y = _KZ; /*16969*/
				for (var _Kd = 0, _Kc = $get($1.fpat, 0).length - 1; _Kd <= _Kc; _Kd += 1) { /*16978*/
					$1.x = _Kd; /*16971*/
					$1.fpb = $get($get($1.fpat, $1.y), $1.x); /*16972*/
					$k[$j++] = $1.pixs; /*16973*/
					$k[$j++] = $1.x; /*16973*/
					$k[$j++] = $1.y; /*16973*/
					if ($1.qmv() == $b) break; /*16973*/
					var _Kn = $k[--$j]; /*16973*/
					$put($k[--$j], _Kn, $1.fpb); /*16973*/
					if ($eq($1.format, "full")) { /*16977*/
						$k[$j++] = $1.pixs; /*16975*/
						$k[$j++] = ($1.size - $1.x) - 1; /*16975*/
						$k[$j++] = $1.y; /*16975*/
						if ($1.qmv() == $b) break; /*16975*/
						var _Kv = $k[--$j]; /*16975*/
						$put($k[--$j], _Kv, $1.fpb); /*16975*/
						$k[$j++] = $1.pixs; /*16976*/
						$k[$j++] = $1.x; /*16976*/
						$k[$j++] = ($1.size - $1.y) - 1; /*16976*/
						if ($1.qmv() == $b) break; /*16976*/
						var _L2 = $k[--$j]; /*16976*/
						$put($k[--$j], _L2, $1.fpb); /*16976*/
					} /*16976*/
				} /*16976*/
			} /*16976*/
			$1.algnpat = $a([$a([1, 1, 1, 1, 1]), $a([1, 0, 0, 0, 1]), $a([1, 0, 1, 0, 1]), $a([1, 0, 0, 0, 1]), $a([1, 1, 1, 1, 1])]); /*16988*/
			$1.putalgnpat = function() {
				$1.py = $k[--$j]; /*16990*/
				$1.px = $k[--$j]; /*16991*/
				for (var _LC = 0; _LC <= 4; _LC += 1) { /*16998*/
					$1.pb = _LC; /*16993*/
					for (var _LD = 0; _LD <= 4; _LD += 1) { /*16997*/
						$1.pa = _LD; /*16995*/
						$k[$j++] = $1.pixs; /*16996*/
						$k[$j++] = $1.px + $1.pa; /*16996*/
						$k[$j++] = $1.py + $1.pb; /*16996*/
						if ($1.qmv() == $b) break; /*16996*/
						var _LO = $k[--$j]; /*16996*/
						$put($k[--$j], _LO, $get($get($1.algnpat, $1.pb), $1.pa)); /*16996*/
					} /*16996*/
				} /*16996*/
			}; /*16999*/
			for (var _LV = $1.asp2 - 2, _LW = $1.asp3 - $1.asp2, _LU = $1.size - 13; _LW < 0 ? _LV >= _LU : _LV <= _LU; _LV += _LW) { /*17004*/
				$1.i = _LV; /*17001*/
				$k[$j++] = $1.i; /*17002*/
				$k[$j++] = 4; /*17002*/
				if ($1.putalgnpat() == $b) break; /*17002*/
				$k[$j++] = 4; /*17003*/
				$k[$j++] = $1.i; /*17003*/
				if ($1.putalgnpat() == $b) break; /*17003*/
			} /*17003*/
			for (var _Le = $1.asp2 - 2, _Lf = $1.asp3 - $1.asp2, _Ld = $1.size - 9; _Lf < 0 ? _Le >= _Ld : _Le <= _Ld; _Le += _Lf) { /*17011*/
				$1.x = _Le; /*17006*/
				for (var _Ll = $1.asp2 - 2, _Lm = $1.asp3 - $1.asp2, _Lk = $1.size - 9; _Lm < 0 ? _Ll >= _Lk : _Ll <= _Lk; _Ll += _Lm) { /*17010*/
					$1.y = _Ll; /*17008*/
					$k[$j++] = $1.x; /*17009*/
					$k[$j++] = $1.y; /*17009*/
					if ($1.putalgnpat() == $b) break; /*17009*/
				} /*17009*/
			} /*17009*/
			if ($eq($1.format, "full")) { /*17024*/
				for (var _Ls = 8, _Lr = $1.size - 9; _Ls <= _Lr; _Ls += 1) { /*17019*/
					$1.i = _Ls; /*17016*/
					$k[$j++] = $1.pixs; /*17017*/
					$k[$j++] = $1.i; /*17017*/
					$k[$j++] = 6; /*17017*/
					if ($1.qmv() == $b) break; /*17017*/
					var _Lw = $k[--$j]; /*17017*/
					$put($k[--$j], _Lw, ($1.i + 1) % 2); /*17017*/
					$k[$j++] = $1.pixs; /*17018*/
					$k[$j++] = 6; /*17018*/
					$k[$j++] = $1.i; /*17018*/
					if ($1.qmv() == $b) break; /*17018*/
					var _M1 = $k[--$j]; /*17018*/
					$put($k[--$j], _M1, ($1.i + 1) % 2); /*17018*/
				} /*17018*/
			} else { /*17024*/
				for (var _M5 = 8, _M4 = $1.size - 1; _M5 <= _M4; _M5 += 1) { /*17025*/
					$1.i = _M5; /*17022*/
					$k[$j++] = $1.pixs; /*17023*/
					$k[$j++] = $1.i; /*17023*/
					$k[$j++] = 0; /*17023*/
					if ($1.qmv() == $b) break; /*17023*/
					var _M9 = $k[--$j]; /*17023*/
					$put($k[--$j], _M9, ($1.i + 1) % 2); /*17023*/
					$k[$j++] = $1.pixs; /*17024*/
					$k[$j++] = 0; /*17024*/
					$k[$j++] = $1.i; /*17024*/
					if ($1.qmv() == $b) break; /*17024*/
					var _ME = $k[--$j]; /*17024*/
					$put($k[--$j], _ME, ($1.i + 1) % 2); /*17024*/
				} /*17024*/
			} /*17024*/
			if ($eq($1.format, "full")) { /*17042*/
				$1.formatmap = $a([$a([$a([0, 8]), $a([8, $1.size - 1])]), $a([$a([1, 8]), $a([8, $1.size - 2])]), $a([$a([2, 8]), $a([8, $1.size - 3])]), $a([$a([3, 8]), $a([8, $1.size - 4])]), $a([$a([4, 8]), $a([8, $1.size - 5])]), $a([$a([5, 8]), $a([8, $1.size - 6])]), $a([$a([7, 8]), $a([8, $1.size - 7])]), $a([$a([8, 8]), $a([$1.size - 8, 8])]), $a([$a([8, 7]), $a([$1.size - 7, 8])]), $a([$a([8, 5]), $a([$1.size - 6, 8])]), $a([$a([8, 4]), $a([$1.size - 5, 8])]), $a([$a([8, 3]), $a([$1.size - 4, 8])]), $a([$a([8, 2]), $a([$1.size - 3, 8])]), $a([$a([8, 1]), $a([$1.size - 2, 8])]), $a([$a([8, 0]), $a([$1.size - 1, 8])])]); /*17036*/
			} else { /*17042*/
				$1.formatmap = $a([$a([$a([1, 8])]), $a([$a([2, 8])]), $a([$a([3, 8])]), $a([$a([4, 8])]), $a([$a([5, 8])]), $a([$a([6, 8])]), $a([$a([7, 8])]), $a([$a([8, 8])]), $a([$a([8, 7])]), $a([$a([8, 6])]), $a([$a([8, 5])]), $a([$a([8, 4])]), $a([$a([8, 3])]), $a([$a([8, 2])]), $a([$a([8, 1])])]); /*17042*/
			} /*17042*/
			var _Nl = $1.formatmap; /*17044*/
			for (var _Nm = 0, _Nn = _Nl.length; _Nm < _Nn; _Nm++) { /*17046*/
				$forall($get(_Nl, _Nm), function() { /*17045*/
					$forall($k[--$j]); /*17045*/
					if ($1.qmv() == $b) return $b; /*17045*/
					$put($1.pixs, $k[--$j], 0); /*17045*/
				}); /*17045*/
			} /*17045*/
			if ($1.size >= 45) { /*17062*/
				$1.versionmap = $a([$a([$a([$1.size - 9, 5]), $a([5, $1.size - 9])]), $a([$a([$1.size - 10, 5]), $a([5, $1.size - 10])]), $a([$a([$1.size - 11, 5]), $a([5, $1.size - 11])]), $a([$a([$1.size - 9, 4]), $a([4, $1.size - 9])]), $a([$a([$1.size - 10, 4]), $a([4, $1.size - 10])]), $a([$a([$1.size - 11, 4]), $a([4, $1.size - 11])]), $a([$a([$1.size - 9, 3]), $a([3, $1.size - 9])]), $a([$a([$1.size - 10, 3]), $a([3, $1.size - 10])]), $a([$a([$1.size - 11, 3]), $a([3, $1.size - 11])]), $a([$a([$1.size - 9, 2]), $a([2, $1.size - 9])]), $a([$a([$1.size - 10, 2]), $a([2, $1.size - 10])]), $a([$a([$1.size - 11, 2]), $a([2, $1.size - 11])]), $a([$a([$1.size - 9, 1]), $a([1, $1.size - 9])]), $a([$a([$1.size - 10, 1]), $a([1, $1.size - 10])]), $a([$a([$1.size - 11, 1]), $a([1, $1.size - 11])]), $a([$a([$1.size - 9, 0]), $a([0, $1.size - 9])]), $a([$a([$1.size - 10, 0]), $a([0, $1.size - 10])]), $a([$a([$1.size - 11, 0]), $a([0, $1.size - 11])])]); /*17060*/
			} else { /*17062*/
				$1.versionmap = $a([]); /*17062*/
			} /*17062*/
			var _PN = $1.versionmap; /*17064*/
			for (var _PO = 0, _PP = _PN.length; _PO < _PP; _PO++) { /*17066*/
				$forall($get(_PN, _PO), function() { /*17065*/
					$forall($k[--$j]); /*17065*/
					if ($1.qmv() == $b) return $b; /*17065*/
					$put($1.pixs, $k[--$j], 0); /*17065*/
				}); /*17065*/
			} /*17065*/
			if ($eq($1.format, "full")) { /*17071*/
				$k[$j++] = $1.pixs; /*17070*/
				$k[$j++] = 8; /*17070*/
				$k[$j++] = $1.size - 8; /*17070*/
				if ($1.qmv() == $b) return $b; /*17070*/
				var _PX = $k[--$j]; /*17070*/
				$put($k[--$j], _PX, 0); /*17070*/
			} /*17070*/
			if ($eq($1.format, "full")) { /*17091*/
				var _Pr = $a([function() {
					var _Pa = $k[--$j]; /*17076*/
					var _Pb = $k[--$j]; /*17076*/
					$k[$j++] = (_Pb + _Pa) % 2; /*17076*/
				}, function() {
					var _Pc = $k[--$j]; /*17077*/
					var _Pd = $k[--$j]; /*17077*/
					$k[$j++] = _Pc % 2; /*17077*/
				}, function() {
					$j--; /*17078*/
					var _Pe = $k[--$j]; /*17078*/
					$k[$j++] = _Pe % 3; /*17078*/
				}, function() {
					var _Pf = $k[--$j]; /*17079*/
					var _Pg = $k[--$j]; /*17079*/
					$k[$j++] = (_Pg + _Pf) % 3; /*17079*/
				}, function() {
					var _Ph = $k[--$j]; /*17080*/
					var _Pi = $k[--$j]; /*17080*/
					$k[$j++] = ((~~(_Ph / 2)) + (~~(_Pi / 3))) % 2; /*17080*/
				}, function() {
					var _Pj = $k[--$j]; /*17081*/
					var _Pl = $k[--$j] * _Pj; /*17081*/
					$k[$j++] = (_Pl % 2) + (_Pl % 3); /*17081*/
				}, function() {
					var _Pm = $k[--$j]; /*17082*/
					var _Po = $k[--$j] * _Pm; /*17082*/
					$k[$j++] = ((_Po % 2) + (_Po % 3)) % 2; /*17082*/
				}, function() {
					var _Pp = $k[--$j]; /*17083*/
					var _Pq = $k[--$j]; /*17083*/
					$k[$j++] = (((_Pq * _Pp) % 3) + ((_Pq + _Pp) % 2)) % 2; /*17083*/
				}]); /*17083*/
				$1.maskfuncs = _Pr; /*17084*/
			} else { /*17091*/
				var _Q1 = $a([function() {
					var _Ps = $k[--$j]; /*17087*/
					var _Pt = $k[--$j]; /*17087*/
					$k[$j++] = _Ps % 2; /*17087*/
				}, function() {
					var _Pu = $k[--$j]; /*17088*/
					var _Pv = $k[--$j]; /*17088*/
					$k[$j++] = ((~~(_Pu / 2)) + (~~(_Pv / 3))) % 2; /*17088*/
				}, function() {
					var _Pw = $k[--$j]; /*17089*/
					var _Py = $k[--$j] * _Pw; /*17089*/
					$k[$j++] = ((_Py % 2) + (_Py % 3)) % 2; /*17089*/
				}, function() {
					var _Pz = $k[--$j]; /*17090*/
					var _Q0 = $k[--$j]; /*17090*/
					$k[$j++] = (((_Q0 * _Pz) % 3) + ((_Q0 + _Pz) % 2)) % 2; /*17090*/
				}]); /*17090*/
				$1.maskfuncs = _Q1; /*17091*/
			} /*17091*/
			if ($1.mask != -1) { /*17096*/
				$1.maskfuncs = $a([$get($1.maskfuncs, $1.mask - 1)]); /*17094*/
				$1.bestmaskval = $1.mask - 1; /*17095*/
			} /*17095*/
			$1.masks = $a($1.maskfuncs.length); /*17097*/
			for (var _QC = 0, _QB = $1.masks.length - 1; _QC <= _QB; _QC += 1) { /*17111*/
				$1.m = _QC; /*17099*/
				$1.mask = $a($1.size * $1.size); /*17100*/
				for (var _QI = 0, _QH = $1.size - 1; _QI <= _QH; _QI += 1) { /*17109*/
					$1.j = _QI; /*17102*/
					for (var _QL = 0, _QK = $1.size - 1; _QL <= _QK; _QL += 1) { /*17108*/
						$1.i = _QL; /*17104*/
						$k[$j++] = $1.i; /*17105*/
						$k[$j++] = $1.j; /*17105*/
						$get($1.maskfuncs, $1.m)(); /*17105*/
						var _QR = $k[--$j]; /*17105*/
						$k[$j++] = _QR == 0; /*17106*/
						$k[$j++] = $1.pixs; /*17106*/
						$k[$j++] = $1.i; /*17106*/
						$k[$j++] = $1.j; /*17106*/
						if ($1.qmv() == $b) break; /*17106*/
						var _QV = $k[--$j]; /*17106*/
						var _QX = $get($k[--$j], _QV); /*17106*/
						var _QZ = ($k[--$j] && (_QX == -1)) ? 1 : 0; /*17106*/
						$k[$j++] = _QZ; /*17107*/
						$k[$j++] = $1.mask; /*17107*/
						$k[$j++] = $1.i; /*17107*/
						$k[$j++] = $1.j; /*17107*/
						if ($1.qmv() == $b) break; /*17107*/
						var _Qd = $k[--$j]; /*17107*/
						var _Qe = $k[--$j]; /*17107*/
						$put(_Qe, _Qd, $k[--$j]); /*17107*/
					} /*17107*/
				} /*17107*/
				$put($1.masks, $1.m, $1.mask); /*17110*/
			} /*17110*/
			$1.posx = $1.size - 1; /*17114*/
			$1.posy = $1.size - 1; /*17115*/
			$1.dir = -1; /*17116*/
			$1.col = 1; /*17117*/
			$1.num = 0; /*17118*/
			for (;;) { /*17141*/
				if ($1.posx < 0) { /*17120*/
					break; /*17120*/
				} /*17120*/
				$k[$j++] = $1.pixs; /*17121*/
				$k[$j++] = $1.posx; /*17121*/
				$k[$j++] = $1.posy; /*17121*/
				if ($1.qmv() == $b) break; /*17121*/
				var _Qp = $k[--$j]; /*17121*/
				if ($get($k[--$j], _Qp) == -1) { /*17125*/
					var _Qu = $get($1.cws, ~~($1.num / 8)); /*17122*/
					var _Qw = -(7 - ($1.num % 8)); /*17122*/
					$k[$j++] = ((_Qw < 0 ? _Qu >>> -_Qw : _Qu << _Qw)) & 1; /*17123*/
					$k[$j++] = $1.pixs; /*17123*/
					$k[$j++] = $1.posx; /*17123*/
					$k[$j++] = $1.posy; /*17123*/
					if ($1.qmv() == $b) break; /*17123*/
					var _R0 = $k[--$j]; /*17123*/
					var _R1 = $k[--$j]; /*17123*/
					$put(_R1, _R0, $k[--$j]); /*17123*/
					$1.num = $1.num + 1; /*17124*/
				} /*17124*/
				if ($1.col == 1) { /*17138*/
					$1.col = 0; /*17127*/
					$1.posx = $1.posx - 1; /*17128*/
				} else { /*17138*/
					$1.col = 1; /*17130*/
					$1.posx = $1.posx + 1; /*17131*/
					$1.posy = $1.posy + $1.dir; /*17132*/
					if (($1.posy < 0) || ($1.posy >= $1.size)) { /*17139*/
						$1.dir = $1.dir * -1; /*17134*/
						$1.posy = $1.posy + $1.dir; /*17135*/
						$1.posx = $1.posx - 2; /*17136*/
						if ($eq($1.format, "full") && ($1.posx == 6)) { /*17138*/
							$1.posx = $1.posx - 1; /*17138*/
						} /*17138*/
					} /*17138*/
				} /*17138*/
			} /*17138*/
			$1.evalfulln1n3 = function() {
				$1.scrle = $k[--$j]; /*17145*/
				$k[$j++] = "scr1"; /*17147*/
				$k[$j++] = 0; /*17147*/
				$forall($1.scrle, function() { /*17147*/
					var _RL = $k[--$j]; /*17147*/
					$k[$j++] = _RL; /*17147*/
					if (_RL >= 5) { /*17147*/
						var _RM = $k[--$j]; /*17147*/
						var _RO = ($k[--$j] + _RM) - 2; /*17147*/
						$k[$j++] = _RO; /*17147*/
						$k[$j++] = _RO; /*17147*/
					} /*17147*/
					$j--; /*17147*/
				}); /*17147*/
				var _RP = $k[--$j]; /*17147*/
				$1[$k[--$j]] = _RP; /*17147*/
				$1.scr3 = 0; /*17149*/
				for (var _RT = 3, _RS = $1.scrle.length - 3; _RT <= _RS; _RT += 2) { /*17164*/
					$1.j = _RT; /*17151*/
					if (($get($1.scrle, $1.j) % 3) == 0) { /*17163*/
						$1.fact = ~~($get($1.scrle, $1.j) / 3); /*17153*/
						$forall($geti($1.scrle, $1.j - 2, 5), function() { /*17154*/
							var _Re = $k[--$j]; /*17154*/
							$k[$j++] = _Re == $1.fact; /*17154*/
						}); /*17154*/
						var _Rf = $k[--$j]; /*17154*/
						var _Rg = $k[--$j]; /*17154*/
						var _Rh = $k[--$j]; /*17154*/
						var _Ri = $k[--$j]; /*17154*/
						if ($k[--$j] && (_Ri && (_Rg && _Rf))) { /*17162*/
							if (($1.j == 3) || (($1.j + 4) >= $1.scrle.length)) { /*17159*/
								$1.scr3 = $1.scr3 + 40; /*17156*/
							} else { /*17159*/
								if (($get($1.scrle, $1.j - 3) >= 4) || ($get($1.scrle, $1.j + 3) >= 4)) { /*17160*/
									$1.scr3 = $1.scr3 + 40; /*17159*/
								} /*17159*/
							} /*17159*/
						} /*17159*/
					} /*17159*/
				} /*17159*/
				$k[$j++] = $1.scr1; /*17165*/
				$k[$j++] = $1.scr3; /*17165*/
			}; /*17166*/
			$1.evalfull = function() {
				$1.sym = $k[--$j]; /*17170*/
				$1.n1 = 0; /*17172*/
				$1.n2 = 0; /*17172*/
				$1.n3 = 0; /*17172*/
				$1.rle = $a($1.size + 1); /*17173*/
				$1.lastpairs = $a($1.size); /*17174*/
				$1.thispairs = $a($1.size); /*17175*/
				$1.sizeadd1 = $1.size + 1; /*17176*/
				for (var _S7 = 0, _S6 = $1.size - 1; _S7 <= _S6; _S7 += 1) { /*17215*/
					$1.i = _S7; /*17178*/
					$k[$j++] = Infinity; /*17181*/
					var _S9 = $1.size; /*17182*/
					$k[$j++] = 0; /*17184*/
					$k[$j++] = 0; /*17184*/
					for (var _SB = $1.i, _SC = _S9, _SA = (_S9 * _S9) - 1; _SC < 0 ? _SB >= _SA : _SB <= _SA; _SB += _SC) { /*17184*/
						var _SE = $get($1.sym, _SB); /*17183*/
						var _SF = $k[--$j]; /*17183*/
						$k[$j++] = _SE; /*17183*/
						if ($eq(_SF, _SE)) { /*17183*/
							var _SG = $k[--$j]; /*17183*/
							var _SH = $k[--$j]; /*17183*/
							$k[$j++] = _SH + 1; /*17183*/
							$k[$j++] = _SG; /*17183*/
						} else { /*17183*/
							var _SI = $k[--$j]; /*17183*/
							$k[$j++] = 1; /*17183*/
							$k[$j++] = _SI; /*17183*/
						} /*17183*/
					} /*17183*/
					$j--; /*17185*/
					var _SK = $counttomark() + 2; /*17186*/
					$astore($geti($1.rle, 0, _SK - 2)); /*17186*/
					if ($1.evalfulln1n3() == $b) break; /*17187*/
					$1.n3 = $k[--$j] + $1.n3; /*17187*/
					$1.n1 = $k[--$j] + $1.n1; /*17187*/
					$j--; /*17188*/
					$1.symrow = $geti($1.sym, $1.i * $1.size, $1.size); /*17191*/
					$k[$j++] = Infinity; /*17192*/
					$k[$j++] = 0; /*17195*/
					$k[$j++] = 0; /*17195*/
					$forall($1.symrow, function() { /*17195*/
						var _SW = $k[--$j]; /*17194*/
						var _SX = $k[--$j]; /*17194*/
						$k[$j++] = _SW; /*17194*/
						if ($eq(_SX, _SW)) { /*17194*/
							var _SY = $k[--$j]; /*17194*/
							var _SZ = $k[--$j]; /*17194*/
							$k[$j++] = _SZ + 1; /*17194*/
							$k[$j++] = _SY; /*17194*/
						} else { /*17194*/
							var _Sa = $k[--$j]; /*17194*/
							$k[$j++] = 1; /*17194*/
							$k[$j++] = _Sa; /*17194*/
						} /*17194*/
					}); /*17194*/
					$j--; /*17196*/
					var _Sc = $counttomark() + 2; /*17197*/
					$astore($geti($1.rle, 0, _Sc - 2)); /*17197*/
					if ($1.evalfulln1n3() == $b) break; /*17198*/
					$1.n3 = $k[--$j] + $1.n3; /*17198*/
					$1.n1 = $k[--$j] + $1.n1; /*17198*/
					$j--; /*17199*/
					var _Si = $1.thispairs; /*17202*/
					$1.thispairs = $1.lastpairs; /*17202*/
					$1.lastpairs = _Si; /*17202*/
					var _Sm = ($get($1.symrow, 0) == 1) ? 0 : 1; /*17203*/
					$k[$j++] = _Sm; /*17204*/
					$forall($1.symrow, function() { /*17204*/
						var _So = $k[--$j]; /*17204*/
						var _Sp = $k[--$j]; /*17204*/
						$k[$j++] = _Sp + _So; /*17204*/
						$k[$j++] = _So; /*17204*/
					}); /*17204*/
					$j--; /*17205*/
					$astore($1.thispairs); /*17206*/
					$j--; /*17206*/
					if ($1.i > 0) { /*17213*/
						$k[$j++] = Infinity; /*17208*/
						$aload($1.lastpairs); /*17209*/
						$aload($1.thispairs); /*17209*/
						$k[$j++] = $1.n2; /*17210*/
						for (var _Sw = 0, _Sx = $1.size; _Sw < _Sx; _Sw++) { /*17210*/
							var _Sy = $k[--$j]; /*17210*/
							var _Sz = $k[--$j]; /*17210*/
							$k[$j++] = _Sy; /*17210*/
							$k[$j++] = _Sz; /*17210*/
							var _T1 = $k[$j - 1 - $1.sizeadd1]; /*17210*/
							if ((($k[--$j] + _T1) & 3) == 0) { /*17210*/
								var _T3 = $k[--$j]; /*17210*/
								$k[$j++] = _T3 + 3; /*17210*/
							} /*17210*/
						} /*17210*/
						$1.n2 = $k[--$j]; /*17211*/
						$cleartomark(); /*17212*/
					} /*17212*/
				} /*17212*/
				$k[$j++] = "dark"; /*17218*/
				$k[$j++] = 0; /*17218*/
				$forall($1.sym, function() { /*17218*/
					var _T6 = $k[--$j]; /*17218*/
					var _T7 = $k[--$j]; /*17218*/
					$k[$j++] = _T7 + _T6; /*17218*/
				}); /*17218*/
				var _T8 = $k[--$j]; /*17218*/
				$1[$k[--$j]] = _T8; /*17218*/
				var _TB = $1.size; /*17219*/
				$1.n4 = (~~((Math.abs((($1.dark * 100) / (_TB * _TB)) - 50)) / 5)) * 10; /*17219*/
				$k[$j++] = (($1.n1 + $1.n2) + $1.n3) + $1.n4; /*17221*/
			}; /*17222*/
			$1.evalmicro = function() {
				$1.sym = $k[--$j]; /*17226*/
				$1.dkrhs = 0; /*17227*/
				$1.dkbot = 0; /*17227*/
				for (var _TJ = 1, _TI = $1.size - 1; _TJ <= _TI; _TJ += 1) { /*17232*/
					$1.i = _TJ; /*17229*/
					$k[$j++] = "dkrhs"; /*17230*/
					$k[$j++] = $1.dkrhs; /*17230*/
					$k[$j++] = $1.sym; /*17230*/
					$k[$j++] = $1.size - 1; /*17230*/
					$k[$j++] = $1.i; /*17230*/
					if ($1.qmv() == $b) break; /*17230*/
					var _TO = $k[--$j]; /*17230*/
					var _TQ = $get($k[--$j], _TO); /*17230*/
					var _TR = $k[--$j]; /*17230*/
					$1[$k[--$j]] = _TR + _TQ; /*17230*/
					$k[$j++] = "dkbot"; /*17231*/
					$k[$j++] = $1.dkbot; /*17231*/
					$k[$j++] = $1.sym; /*17231*/
					$k[$j++] = $1.i; /*17231*/
					$k[$j++] = $1.size - 1; /*17231*/
					if ($1.qmv() == $b) break; /*17231*/
					var _TX = $k[--$j]; /*17231*/
					var _TZ = $get($k[--$j], _TX); /*17231*/
					var _Ta = $k[--$j]; /*17231*/
					$1[$k[--$j]] = _Ta + _TZ; /*17231*/
				} /*17231*/
				if ($1.dkrhs <= $1.dkbot) { /*17236*/
					$k[$j++] = -(($1.dkrhs * 16) + $1.dkbot); /*17234*/
				} else { /*17236*/
					$k[$j++] = -(($1.dkbot * 16) + $1.dkrhs); /*17236*/
				} /*17236*/
			}; /*17238*/
			$1.bestscore = 999999999; /*17241*/
			for (var _Tk = 0, _Tj = $1.masks.length - 1; _Tk <= _Tj; _Tk += 1) { /*17263*/
				$1.m = _Tk; /*17243*/
				$1.masksym = $a($1.size * $1.size); /*17244*/
				for (var _Tr = 0, _Tq = ($1.size * $1.size) - 1; _Tr <= _Tq; _Tr += 1) { /*17248*/
					$1.i = _Tr; /*17246*/
					$put($1.masksym, $1.i, $xo($get($1.pixs, $1.i), $get($get($1.masks, $1.m), $1.i))); /*17247*/
				} /*17247*/
				if ($1.masks.length != 1) { /*17261*/
					if ($eq($1.format, "full")) { /*17253*/
						$k[$j++] = $1.masksym; /*17251*/
						if ($1.evalfull() == $b) break; /*17251*/
						$1.score = $k[--$j]; /*17251*/
					} else { /*17253*/
						$k[$j++] = $1.masksym; /*17253*/
						if ($1.evalmicro() == $b) break; /*17253*/
						$1.score = $k[--$j]; /*17253*/
					} /*17253*/
					if ($1.score < $1.bestscore) { /*17259*/
						$1.bestsym = $1.masksym; /*17256*/
						$1.bestmaskval = $1.m; /*17257*/
						$1.bestscore = $1.score; /*17258*/
					} /*17258*/
				} else { /*17261*/
					$1.bestsym = $1.masksym; /*17261*/
				} /*17261*/
			} /*17261*/
			$1.pixs = $1.bestsym; /*17264*/
			if ($eq($1.format, "full")) { /*17269*/
				$k[$j++] = $1.pixs; /*17268*/
				$k[$j++] = 8; /*17268*/
				$k[$j++] = $1.size - 8; /*17268*/
				if ($1.qmv() == $b) return $b; /*17268*/
				var _UI = $k[--$j]; /*17268*/
				$put($k[--$j], _UI, 1); /*17268*/
			} /*17268*/
			if ($eq($1.format, "full")) { /*17289*/
				$1.fmtvals = $a([21522, 20773, 24188, 23371, 17913, 16590, 20375, 19104, 30660, 29427, 32170, 30877, 26159, 25368, 27713, 26998, 5769, 5054, 7399, 6608, 1890, 597, 3340, 2107, 13663, 12392, 16177, 14854, 9396, 8579, 11994, 11245]); /*17278*/
				$k[$j++] = "ecid"; /*17279*/
				$search("MLHQ", $1.eclevel); /*17279*/
				$j--; /*17279*/
				var _UN = $k[--$j]; /*17279*/
				var _UO = $k[--$j]; /*17279*/
				var _UP = $k[--$j]; /*17279*/
				$1[$k[--$j]] = _UN.length; /*17279*/
				$1.fmtval = $get($1.fmtvals, ($1.ecid << 3) + $1.bestmaskval); /*17280*/
			} else { /*17289*/
				$1.fmtvals = $a([17477, 16754, 20011, 19228, 21934, 20633, 24512, 23287, 26515, 25252, 28157, 26826, 30328, 29519, 31766, 31009, 1758, 1001, 3248, 2439, 5941, 4610, 7515, 6252, 9480, 8255, 12134, 10833, 13539, 12756, 16013, 15290]); /*17287*/
				$1.symid = $get($get($a([$a([0]), $a([1, 2]), $a([3, 4]), $a([5, 6, 7])]), ~~(($1.size - 11) / 2)), $1.eclval); /*17288*/
				$1.fmtval = $get($1.fmtvals, ($1.symid << 2) + $1.bestmaskval); /*17289*/
			} /*17289*/
			for (var _Ul = 0, _Uk = $1.formatmap.length - 1; _Ul <= _Uk; _Ul += 1) { /*17296*/
				$1.i = _Ul; /*17292*/
				$forall($get($1.formatmap, $1.i), function() { /*17295*/
					var _Uq = $k[--$j]; /*17294*/
					$k[$j++] = $1.pixs; /*17294*/
					$forall(_Uq); /*17294*/
					if ($1.qmv() == $b) return $b; /*17294*/
					var _Ur = $1.fmtval; /*17294*/
					var _Ut = -(14 - $1.i); /*17294*/
					var _Uu = $k[--$j]; /*17294*/
					$put($k[--$j], _Uu, ((_Ut < 0 ? _Ur >>> -_Ut : _Ur << _Ut)) & 1); /*17294*/
				}); /*17294*/
			} /*17294*/
			if ($1.size >= 45) { /*17314*/
				$1.vervals = $a([31892, 34236, 39577, 42195, 48118, 51042, 55367, 58893, 63784, 68472, 70749, 76311, 79154, 84390, 87683, 92361, 96236, 102084, 102881, 110507, 110734, 117786, 119615, 126325, 127568, 133589, 136957, 141498, 145311, 150283, 152622, 158308, 161089, 167017]); /*17306*/
				$1.verval = $get($1.vervals, (~~(($1.size - 17) / 4)) - 7); /*17307*/
				for (var _V3 = 0, _V2 = $1.versionmap.length - 1; _V3 <= _V2; _V3 += 1) { /*17313*/
					$1.i = _V3; /*17309*/
					$forall($get($1.versionmap, $1.i), function() { /*17312*/
						var _V8 = $k[--$j]; /*17311*/
						$k[$j++] = $1.pixs; /*17311*/
						$forall(_V8); /*17311*/
						if ($1.qmv() == $b) return $b; /*17311*/
						var _V9 = $1.verval; /*17311*/
						var _VB = -(17 - $1.i); /*17311*/
						var _VC = $k[--$j]; /*17311*/
						$put($k[--$j], _VC, ((_VB < 0 ? _V9 >>> -_VB : _V9 << _VB)) & 1); /*17311*/
					}); /*17311*/
				} /*17311*/
			} /*17311*/
			var _VK = {
				ren: $0.renmatrix,
				pixs: $1.pixs,
				pixx: $1.size,
				pixy: $1.size,
				height: ($1.size * 2) / 72,
				width: ($1.size * 2) / 72,
				opt: $1.options
			}; /*17324*/
			$k[$j++] = _VK; /*17327*/
			if (!$1.dontdraw) { /*17327*/
				$0.renmatrix(); /*17327*/
			} /*17327*/
		};
		$0.microqrcode = function() {
			var $1 = {}; /*17355*/
			$1.options = $k[--$j]; /*17357*/
			$1.barcode = $k[--$j]; /*17358*/
			$1.dontdraw = false; /*17360*/
			$forall($1.options, function() { /*17371*/
				var _3 = $k[--$j]; /*17371*/
				$1[$k[--$j]] = _3; /*17371*/
			}); /*17371*/
			$1.options.dontdraw = true; /*17374*/
			$1.options.format = "micro"; /*17375*/
			$k[$j++] = "args"; /*17377*/
			$k[$j++] = $1.barcode; /*17377*/
			$k[$j++] = $1.options; /*17377*/
			$0.qrcode(); /*17377*/
			var _9 = $k[--$j]; /*17377*/
			$1[$k[--$j]] = _9; /*17377*/
			$1.args.opt = $1.options; /*17379*/
			$k[$j++] = $1.args; /*17382*/
			if (!$1.dontdraw) { /*17382*/
				$0.renmatrix(); /*17382*/
			} /*17382*/
		};
		$0.maxicode = function() {
			var $1 = {}; /*17409*/
			$1.options = $k[--$j]; /*17411*/
			$1.barcode = $k[--$j]; /*17412*/
			$1.dontdraw = false; /*17414*/
			$1.mode = -1; /*17415*/
			$1.sam = -1; /*17416*/
			$1.parse = false; /*17417*/
			$forall($1.options, function() { /*17428*/
				var _3 = $k[--$j]; /*17428*/
				$1[$k[--$j]] = _3; /*17428*/
			}); /*17428*/
			$1.mode = ~~$1.mode; /*17430*/
			$1.sam = ~~$1.sam; /*17431*/
			$1.msg = $1.barcode; /*17454*/
			$1.msglen = $1.msg.length; /*17455*/
			if (($1.mode == 2) || ($1.mode == 3)) { /*17481*/
				if ($eq($geti($1.msg, 0, 7), "\x5b\x29\x3e\x1e\x30\x31\x1d")) { /*17465*/
					$1.fid = $geti($1.msg, 0, 9); /*17462*/
					$1.msg = $geti($1.msg, 9, $1.msglen - 9); /*17463*/
				} else { /*17465*/
					$1.fid = ""; /*17465*/
				} /*17465*/
				$search($1.msg, "\x1d"); /*17469*/
				$j--; /*17469*/
				$1.pcode = $k[--$j]; /*17469*/
				$j--; /*17470*/
				$search($k[--$j], "\x1d"); /*17470*/
				$j--; /*17470*/
				$1.ccode = $k[--$j]; /*17470*/
				$j--; /*17471*/
				$search($k[--$j], "\x1d"); /*17471*/
				$j--; /*17471*/
				$1.scode = $k[--$j]; /*17471*/
				$j--; /*17472*/
				$1.msg = $k[--$j]; /*17472*/
				var _R = $s($1.msg.length + $1.fid.length); /*17475*/
				$puti(_R, 0, $1.fid); /*17476*/
				$puti(_R, $1.fid.length, $1.msg); /*17477*/
				$1.msg = _R; /*17478*/
				$1.msglen = $1.msg.length; /*17479*/
			} /*17479*/
			$1.eci = -1; /*17484*/
			$1.pad = -2; /*17484*/
			$1.ns = -3; /*17484*/
			$1.la = -4; /*17485*/
			$1.lb = -5; /*17485*/
			$1.sa = -6; /*17486*/
			$1.sb = -7; /*17486*/
			$1.sc = -8; /*17486*/
			$1.sd = -9; /*17486*/
			$1.se = -10; /*17486*/
			$1.sa2 = -11; /*17487*/
			$1.sa3 = -12; /*17487*/
			$1.lkc = -13; /*17488*/
			$1.lkd = -14; /*17488*/
			$1.lke = -15; /*17488*/
			$1.pd2 = -16; /*17489*/
			$1.pd3 = -17; /*17489*/
			$1.charmaps = $a([$a([13, "`", 192, 224, 0]), $a(["A", "a", 193, 225, 1]), $a(["B", "b", 194, 226, 2]), $a(["C", "c", 195, 227, 3]), $a(["D", "d", 196, 228, 4]), $a(["E", "e", 197, 229, 5]), $a(["F", "f", 198, 230, 6]), $a(["G", "g", 199, 231, 7]), $a(["H", "h", 200, 232, 8]), $a(["I", "i", 201, 233, 9]), $a(["J", "j", 202, 234, 10]), $a(["K", "k", 203, 235, 11]), $a(["L", "l", 204, 236, 12]), $a(["M", "m", 205, 237, 13]), $a(["N", "n", 206, 238, 14]), $a(["O", "o", 207, 239, 15]), $a(["P", "p", 208, 240, 16]), $a(["Q", "q", 209, 241, 17]), $a(["R", "r", 210, 242, 18]), $a(["S", "s", 211, 243, 19]), $a(["T", "t", 212, 244, 20]), $a(["U", "u", 213, 245, 21]), $a(["V", "v", 214, 246, 22]), $a(["W", "w", 215, 247, 23]), $a(["X", "x", 216, 248, 24]), $a(["Y", "y", 217, 249, 25]), $a(["Z", "z", 218, 250, 26]), $a([$1.eci, $1.eci, $1.eci, $1.eci, $1.eci]), $a([28, 28, 28, 28, $1.pad]), $a([29, 29, 29, 29, $1.pad]), $a([30, 30, 30, 30, 27]), $a([$1.ns, $1.ns, $1.ns, $1.ns, $1.ns]), $a([" ", "{", 219, 251, 28]), $a([$1.pad, $1.pad, 220, 252, 29]), $a(["\"", "}", 221, 253, 30]), $a(["#", "~", 222, 254, 31]), $a(["$", 127, 223, 255, 159]), $a(["%", ";", 170, 161, 160]), $a(["&", "<", 172, 168, 162]), $a(["'", "=", 177, 171, 163]), $a([40, ">", 178, 175, 164]), $a([41, "?", 179, 176, 165]), $a(["*", "[", 181, 180, 166]), $a(["+", 92, 185, 183, 167]), $a([",", "]", 186, 184, 169]), $a(["-", "^", 188, 187, 173]), $a([".", "_", 189, 191, 174]), $a(["/", " ", 190, 138, 182]), $a(["0", ",", 128, 139, 149]), $a(["1", ".", 129, 140, 150]), $a(["2", "/", 130, 141, 151]), $a(["3", ":", 131, 142, 152]), $a(["4", "@", 132, 143, 153]), $a(["5", "!", 133, 144, 154]), $a(["6", "|", 134, 145, 155]), $a(["7", $1.pd2, 135, 146, 156]), $a(["8", $1.sa2, 136, 147, 157]), $a(["9", $1.sa3, 137, 148, 158]), $a([":", $1.pd3, $1.la, $1.la, $1.la]), $a([$1.sb, $1.sa, " ", " ", " "]), $a([$1.sc, $1.sc, $1.lkc, $1.sc, $1.sc]), $a([$1.sd, $1.sd, $1.sd, $1.lkd, $1.sd]), $a([$1.se, $1.se, $1.se, $1.se, $1.lke]), $a([$1.lb, $1.la, $1.lb, $1.lb, $1.lb])]); /*17558*/
			$1.charvals = $a([{}, {}, {}, {}, {}]); /*17561*/
			for (var _2J = 0, _2I = $1.charmaps.length - 1; _2J <= _2I; _2J += 1) { /*17570*/
				$1.i = _2J; /*17563*/
				$1.encs = $get($1.charmaps, $1.i); /*17564*/
				for (var _2N = 0; _2N <= 4; _2N += 1) { /*17569*/
					$1.j = _2N; /*17566*/
					var _2Q = $get($1.encs, $1.j); /*17567*/
					$k[$j++] = _2Q; /*17567*/
					if ($eq($type(_2Q), "stringtype")) { /*17567*/
						var _2T = $get($k[--$j], 0); /*17567*/
						$k[$j++] = _2T; /*17567*/
					} /*17567*/
					$put($get($1.charvals, $1.j), $k[--$j], $1.i); /*17568*/
				} /*17568*/
			} /*17568*/
			$1.seta = $get($1.charvals, 0); /*17571*/
			$1.setb = $get($1.charvals, 1); /*17572*/
			$1.setc = $get($1.charvals, 2); /*17573*/
			$1.setd = $get($1.charvals, 3); /*17574*/
			$1.sete = $get($1.charvals, 4); /*17575*/
			$k[$j++] = Infinity; /*17578*/
			for (var _2k = 0, _2l = $1.msglen + 1; _2k < _2l; _2k++) { /*17578*/
				$k[$j++] = 0; /*17578*/
			} /*17578*/
			$1.nseq = $a(); /*17578*/
			for (var _2o = $1.msglen - 1; _2o >= 0; _2o -= 1) { /*17586*/
				$1.i = _2o; /*17580*/
				var _2r = $get($1.msg, $1.i); /*17581*/
				if ((_2r >= 48) && (_2r <= 57)) { /*17584*/
					$put($1.nseq, $1.i, $get($1.nseq, $1.i + 1) + 1); /*17582*/
				} else { /*17584*/
					$put($1.nseq, $1.i, 0); /*17584*/
				} /*17584*/
			} /*17584*/
			$1.nseq = $geti($1.nseq, 0, $1.msglen); /*17587*/
			$1.prefixinset = function() {
				$k[$j++] = 0; /*17594*/
				for (;;) { /*17594*/
					var _32 = $k[--$j]; /*17592*/
					var _33 = $k[--$j]; /*17592*/
					$k[$j++] = _33; /*17592*/
					$k[$j++] = _32; /*17592*/
					if (_32 >= _33.length) { /*17592*/
						break; /*17592*/
					} /*17592*/
					var _34 = $k[--$j]; /*17593*/
					var _35 = $k[--$j]; /*17593*/
					var _37 = $k[--$j]; /*17593*/
					var _38 = $get(_37, $get(_35, _34)) !== undefined; /*17593*/
					$k[$j++] = _37; /*17593*/
					$k[$j++] = _35; /*17593*/
					$k[$j++] = _34; /*17593*/
					if (_38) { /*17593*/
						var _39 = $k[--$j]; /*17593*/
						$k[$j++] = _39 + 1; /*17593*/
					} else { /*17593*/
						break; /*17593*/
					} /*17593*/
				} /*17593*/
				var _3A = $k[--$j]; /*17595*/
				var _3B = $k[--$j]; /*17595*/
				var _3C = $k[--$j]; /*17595*/
				$k[$j++] = _3A; /*17595*/
			}; /*17596*/
			$1.enc = function() {
				var _3D = $k[--$j]; /*17599*/
				$put($1.out, $1.j, $get(_3D, $k[--$j])); /*17599*/
				$1.j = $1.j + 1; /*17600*/
			}; /*17601*/
			$1.out = $a(144); /*17603*/
			$1.i = 0; /*17604*/
			$1.j = 0; /*17604*/
			$1.cset = "seta"; /*17604*/
			for (;;) { /*17727*/
				if ($1.i == $1.msglen) { /*17613*/
					if ($ne($1.cset, "seta") && $ne($1.cset, "setb")) { /*17611*/
						$k[$j++] = $1.la; /*17609*/
						$k[$j++] = $1[$1.cset]; /*17609*/
						if ($1.enc() == $b) break; /*17609*/
						$1.cset = "seta"; /*17610*/
					} /*17610*/
					break; /*17612*/
				} /*17612*/
				for (;;) { /*17726*/
					if ($get($1.nseq, $1.i) >= 9) { /*17624*/
						$k[$j++] = ~~$z($geti($1.msg, $1.i, 9)); /*17618*/
						for (var _3X = 0, _3Y = 4; _3X < _3Y; _3X++) { /*17618*/
							var _3Z = $k[--$j]; /*17618*/
							$k[$j++] = _3Z & 63; /*17618*/
							$k[$j++] = _3Z >>> 6; /*17618*/
						} /*17618*/
						$k[$j++] = $get($1[$1.cset], $1.ns); /*17619*/
						for (var _3e = 0; _3e <= 10; _3e += 2) { /*17619*/
							var _3f = $k[$j - 1 - _3e]; /*17619*/
							$k[$j++] = _3f; /*17619*/
						} /*17619*/
						$astore($a(6)); /*17619*/
						var _3h = $k[--$j]; /*17619*/
						var _3i = $k[--$j]; /*17619*/
						var _3j = $k[--$j]; /*17619*/
						var _3k = $k[--$j]; /*17619*/
						var _3l = $k[--$j]; /*17619*/
						var _3m = $k[--$j]; /*17619*/
						var _3n = $k[--$j]; /*17619*/
						$k[$j++] = _3h; /*17619*/
						$k[$j++] = _3n; /*17619*/
						$k[$j++] = _3m; /*17619*/
						$k[$j++] = _3l; /*17619*/
						$k[$j++] = _3k; /*17619*/
						$k[$j++] = _3j; /*17619*/
						$k[$j++] = _3i; /*17619*/
						for (var _3o = 0, _3p = 6; _3o < _3p; _3o++) { /*17619*/
							$j--; /*17619*/
						} /*17619*/
						$puti($1.out, $1.j, $k[--$j]); /*17620*/
						$1.i = $1.i + 9; /*17621*/
						$1.j = $1.j + 6; /*17622*/
						break; /*17623*/
					} /*17623*/
					$1.char1 = $get($1.msg, $1.i); /*17627*/
					$k[$j++] = "char2"; /*17628*/
					if (($1.i + 1) < $1.msglen) { /*17628*/
						$k[$j++] = $get($1.msg, $1.i + 1); /*17628*/
					} else { /*17628*/
						$k[$j++] = -99; /*17628*/
					} /*17628*/
					var _43 = $k[--$j]; /*17628*/
					$1[$k[--$j]] = _43; /*17628*/
					$k[$j++] = "char3"; /*17629*/
					if (($1.i + 2) < $1.msglen) { /*17629*/
						$k[$j++] = $get($1.msg, $1.i + 2); /*17629*/
					} else { /*17629*/
						$k[$j++] = -99; /*17629*/
					} /*17629*/
					var _4A = $k[--$j]; /*17629*/
					$1[$k[--$j]] = _4A; /*17629*/
					var _4F = $get($1[$1.cset], $1.char1) !== undefined; /*17632*/
					if (_4F) { /*17636*/
						$k[$j++] = $1.char1; /*17633*/
						$k[$j++] = $1[$1.cset]; /*17633*/
						if ($1.enc() == $b) break; /*17633*/
						$1.i = $1.i + 1; /*17634*/
						break; /*17635*/
					} /*17635*/
					var _4N = $get($1.setb, $1.char1) !== undefined; /*17639*/
					if ($eq($1.cset, "seta") && _4N) { /*17649*/
						var _4Q = $get($1.setb, $1.char2) !== undefined; /*17640*/
						if (_4Q) { /*17646*/
							$k[$j++] = $1.lb; /*17641*/
							$k[$j++] = $1.seta; /*17641*/
							if ($1.enc() == $b) break; /*17641*/
							$1.cset = "setb"; /*17642*/
						} else { /*17646*/
							$k[$j++] = $1.sb; /*17644*/
							$k[$j++] = $1.seta; /*17644*/
							if ($1.enc() == $b) break; /*17644*/
							$k[$j++] = $1.char1; /*17645*/
							$k[$j++] = $1.setb; /*17645*/
							if ($1.enc() == $b) break; /*17645*/
							$1.i = $1.i + 1; /*17646*/
						} /*17646*/
						break; /*17648*/
					} /*17648*/
					var _4b = $get($1.seta, $1.char1) !== undefined; /*17652*/
					if ($eq($1.cset, "setb") && _4b) { /*17677*/
						var _4c = $1.seta; /*17653*/
						var _4d = $1.msg; /*17653*/
						var _4e = $1.i; /*17653*/
						var _4f = $1.msglen; /*17653*/
						var _4g = $1.i; /*17653*/
						var _4h = _4f - _4g; /*17653*/
						var _4i = 4; /*17653*/
						if (4 > (_4f - _4g)) { /*17653*/
							var _ = _4h; /*17653*/
							_4h = _4i; /*17653*/
							_4i = _; /*17653*/
						} /*17653*/
						$k[$j++] = "p"; /*17653*/
						$k[$j++] = _4c; /*17653*/
						$k[$j++] = $geti(_4d, _4e, _4i); /*17653*/
						if ($1.prefixinset() == $b) break; /*17653*/
						var _4k = $k[--$j]; /*17653*/
						$1[$k[--$j]] = _4k; /*17653*/
						if ($1.p == 1) { /*17658*/
							$k[$j++] = $1.sa; /*17655*/
							$k[$j++] = $1.setb; /*17655*/
							if ($1.enc() == $b) break; /*17655*/
							$k[$j++] = $1.char1; /*17656*/
							$k[$j++] = $1.seta; /*17656*/
							if ($1.enc() == $b) break; /*17656*/
							$1.i = $1.i + 1; /*17657*/
						} /*17657*/
						if ($1.p == 2) { /*17664*/
							$k[$j++] = $1.sa2; /*17660*/
							$k[$j++] = $1.setb; /*17660*/
							if ($1.enc() == $b) break; /*17660*/
							$k[$j++] = $1.char1; /*17661*/
							$k[$j++] = $1.seta; /*17661*/
							if ($1.enc() == $b) break; /*17661*/
							$k[$j++] = $1.char2; /*17662*/
							$k[$j++] = $1.seta; /*17662*/
							if ($1.enc() == $b) break; /*17662*/
							$1.i = $1.i + 2; /*17663*/
						} /*17663*/
						if ($1.p == 3) { /*17671*/
							$k[$j++] = $1.sa3; /*17666*/
							$k[$j++] = $1.setb; /*17666*/
							if ($1.enc() == $b) break; /*17666*/
							$k[$j++] = $1.char1; /*17667*/
							$k[$j++] = $1.seta; /*17667*/
							if ($1.enc() == $b) break; /*17667*/
							$k[$j++] = $1.char2; /*17668*/
							$k[$j++] = $1.seta; /*17668*/
							if ($1.enc() == $b) break; /*17668*/
							$k[$j++] = $1.char3; /*17669*/
							$k[$j++] = $1.seta; /*17669*/
							if ($1.enc() == $b) break; /*17669*/
							$1.i = $1.i + 3; /*17670*/
						} /*17670*/
						if ($1.p >= 4) { /*17675*/
							$k[$j++] = $1.la; /*17673*/
							$k[$j++] = $1.setb; /*17673*/
							if ($1.enc() == $b) break; /*17673*/
							$1.cset = "seta"; /*17674*/
						} /*17674*/
						break; /*17676*/
					} /*17676*/
					var _5F = $get($1.seta, $1.char1) !== undefined; /*17680*/
					if (_5F) { /*17684*/
						$k[$j++] = $1.la; /*17681*/
						$k[$j++] = $1[$1.cset]; /*17681*/
						if ($1.enc() == $b) break; /*17681*/
						$1.cset = "seta"; /*17682*/
						break; /*17683*/
					} /*17683*/
					var _5L = $get($1.setb, $1.char1) !== undefined; /*17685*/
					if (_5L) { /*17689*/
						$k[$j++] = $1.lb; /*17686*/
						$k[$j++] = $1[$1.cset]; /*17686*/
						if ($1.enc() == $b) break; /*17686*/
						$1.cset = "setb"; /*17687*/
						break; /*17688*/
					} /*17688*/
					var _5R = $get($1.setc, $1.char1) !== undefined; /*17692*/
					if (_5R) { /*17692*/
						$1.setx = "setc"; /*17692*/
						$1.sx = $1.sc; /*17692*/
						$1.lkx = $1.lkc; /*17692*/
					} /*17692*/
					var _5W = $get($1.setd, $1.char1) !== undefined; /*17693*/
					if (_5W) { /*17693*/
						$1.setx = "setd"; /*17693*/
						$1.sx = $1.sd; /*17693*/
						$1.lkx = $1.lkd; /*17693*/
					} /*17693*/
					var _5b = $get($1.sete, $1.char1) !== undefined; /*17694*/
					if (_5b) { /*17694*/
						$1.setx = "sete"; /*17694*/
						$1.sx = $1.se; /*17694*/
						$1.lkx = $1.lke; /*17694*/
					} /*17694*/
					var _5f = $1[$1.setx]; /*17697*/
					var _5g = $1.msg; /*17697*/
					var _5h = $1.i; /*17697*/
					var _5i = $1.msglen; /*17697*/
					var _5j = $1.i; /*17697*/
					var _5k = _5i - _5j; /*17697*/
					var _5l = 4; /*17697*/
					if (4 > (_5i - _5j)) { /*17697*/
						var _ = _5k; /*17697*/
						_5k = _5l; /*17697*/
						_5l = _; /*17697*/
					} /*17697*/
					$k[$j++] = "p"; /*17697*/
					$k[$j++] = _5f; /*17697*/
					$k[$j++] = $geti(_5g, _5h, _5l); /*17697*/
					if ($1.prefixinset() == $b) break; /*17697*/
					var _5n = $k[--$j]; /*17697*/
					$1[$k[--$j]] = _5n; /*17697*/
					if ($1.p == 1) { /*17702*/
						$k[$j++] = $1.sx; /*17699*/
						$k[$j++] = $1[$1.cset]; /*17699*/
						if ($1.enc() == $b) break; /*17699*/
						$k[$j++] = $1.char1; /*17700*/
						$k[$j++] = $1[$1.setx]; /*17700*/
						if ($1.enc() == $b) break; /*17700*/
						$1.i = $1.i + 1; /*17701*/
					} /*17701*/
					if ($1.p == 2) { /*17709*/
						$k[$j++] = $1.sx; /*17704*/
						$k[$j++] = $1[$1.cset]; /*17704*/
						if ($1.enc() == $b) break; /*17704*/
						$k[$j++] = $1.char1; /*17705*/
						$k[$j++] = $1[$1.setx]; /*17705*/
						if ($1.enc() == $b) break; /*17705*/
						$k[$j++] = $1.sx; /*17706*/
						$k[$j++] = $1[$1.cset]; /*17706*/
						if ($1.enc() == $b) break; /*17706*/
						$k[$j++] = $1.char2; /*17707*/
						$k[$j++] = $1[$1.setx]; /*17707*/
						if ($1.enc() == $b) break; /*17707*/
						$1.i = $1.i + 2; /*17708*/
					} /*17708*/
					if ($1.p == 3) { /*17718*/
						$k[$j++] = $1.sx; /*17711*/
						$k[$j++] = $1[$1.cset]; /*17711*/
						if ($1.enc() == $b) break; /*17711*/
						$k[$j++] = $1.char1; /*17712*/
						$k[$j++] = $1[$1.setx]; /*17712*/
						if ($1.enc() == $b) break; /*17712*/
						$k[$j++] = $1.sx; /*17713*/
						$k[$j++] = $1[$1.cset]; /*17713*/
						if ($1.enc() == $b) break; /*17713*/
						$k[$j++] = $1.char2; /*17714*/
						$k[$j++] = $1[$1.setx]; /*17714*/
						if ($1.enc() == $b) break; /*17714*/
						$k[$j++] = $1.sx; /*17715*/
						$k[$j++] = $1[$1.cset]; /*17715*/
						if ($1.enc() == $b) break; /*17715*/
						$k[$j++] = $1.char3; /*17716*/
						$k[$j++] = $1[$1.setx]; /*17716*/
						if ($1.enc() == $b) break; /*17716*/
						$1.i = $1.i + 3; /*17717*/
					} /*17717*/
					if ($1.p >= 4) { /*17723*/
						$k[$j++] = $1.sx; /*17720*/
						$k[$j++] = $1[$1.cset]; /*17720*/
						if ($1.enc() == $b) break; /*17720*/
						$k[$j++] = $1.lkx; /*17721*/
						$k[$j++] = $1[$1.setx]; /*17721*/
						if ($1.enc() == $b) break; /*17721*/
						$1.cset = $1.setx; /*17722*/
					} /*17722*/
					break; /*17725*/
				} /*17725*/
			} /*17725*/
			$1.encmsg = $geti($1.out, 0, $1.j); /*17728*/
			$1.padval = $get($1[$1.cset], $1.pad); /*17729*/
			$1.sami = $a([]); /*17732*/
			if ($1.sam != -1) { /*17737*/
				$1.sami = $a(2); /*17734*/
				$put($1.sami, 0, $get($1.seta, $1.pad)); /*17735*/
				$put($1.sami, 1, (((~~($1.sam / 10)) - 1) * 8) + (($1.sam % 10) - 1)); /*17736*/
			} /*17736*/
			$k[$j++] = Infinity; /*17738*/
			$aload($1.sami); /*17738*/
			$aload($1.encmsg); /*17738*/
			$1.encmsg = $a(); /*17738*/
			if (($1.mode == 2) || ($1.mode == 3)) { /*17793*/
				var _70 = $strcpy($s(4), "0000"); /*17744*/
				var _73 = $cvrs($s(4), ~~$1.mode, 2); /*17744*/
				$puti(_70, 4 - _73.length, _73); /*17744*/
				$1.mdb = _70; /*17744*/
				var _75 = $strcpy($s(10), "0000000000"); /*17745*/
				var _78 = $cvrs($s(10), ~~$z($1.ccode), 2); /*17745*/
				$puti(_75, 10 - _78.length, _78); /*17745*/
				$1.ccb = _75; /*17745*/
				var _7A = $strcpy($s(10), "0000000000"); /*17746*/
				var _7D = $cvrs($s(10), ~~$z($1.scode), 2); /*17746*/
				$puti(_7A, 10 - _7D.length, _7D); /*17746*/
				$1.scb = _7A; /*17746*/
				$1.pcb = $strcpy($s(36), "000000000000000000000000000000000000"); /*17747*/
				if ($1.mode == 2) { /*17760*/
					var _7K = $cvrs($s(6), $1.pcode.length, 2); /*17750*/
					$puti($1.pcb, 6 - _7K.length, _7K); /*17750*/
					var _7O = $cvrs($s(30), ~~$z($1.pcode), 2); /*17751*/
					$puti($1.pcb, 36 - _7O.length, _7O); /*17751*/
				} else { /*17760*/
					$k[$j++] = Infinity; /*17757*/
					var _7Q = $strcpy($s(6), "      "); /*17755*/
					$k[$j++] = _7Q; /*17755*/
					$k[$j++] = _7Q; /*17755*/
					$k[$j++] = 0; /*17755*/
					if ($1.pcode.length > 6) { /*17755*/
						$k[$j++] = $geti($1.pcode, 0, 6); /*17755*/
					} else { /*17755*/
						$k[$j++] = $1.pcode; /*17755*/
					} /*17755*/
					var _7V = $k[--$j]; /*17755*/
					var _7W = $k[--$j]; /*17755*/
					$puti($k[--$j], _7W, _7V); /*17755*/
					$forall($k[--$j], function() { /*17756*/
						var _7b = $get($1.seta, $k[--$j]); /*17756*/
						$k[$j++] = _7b; /*17756*/
					}); /*17756*/
					$1.pccw = $a(); /*17757*/
					for (var _7d = 0; _7d <= 5; _7d += 1) { /*17761*/
						$1.i = _7d; /*17759*/
						var _7j = $cvrs($s(6), $get($1.pccw, $1.i), 2); /*17760*/
						$puti($1.pcb, ((6 * $1.i) + 6) - _7j.length, _7j); /*17760*/
					} /*17760*/
				} /*17760*/
				$1.scm = $s(60); /*17765*/
				$puti($1.scm, 2, $1.mdb); /*17766*/
				$puti($1.scm, 38, $geti($1.pcb, 0, 4)); /*17767*/
				$puti($1.scm, 30, $geti($1.pcb, 4, 6)); /*17768*/
				$puti($1.scm, 24, $geti($1.pcb, 10, 6)); /*17769*/
				$puti($1.scm, 18, $geti($1.pcb, 16, 6)); /*17770*/
				$puti($1.scm, 12, $geti($1.pcb, 22, 6)); /*17771*/
				$puti($1.scm, 6, $geti($1.pcb, 28, 6)); /*17772*/
				$puti($1.scm, 0, $geti($1.pcb, 34, 2)); /*17773*/
				$puti($1.scm, 52, $geti($1.ccb, 0, 2)); /*17774*/
				$puti($1.scm, 42, $geti($1.ccb, 2, 6)); /*17775*/
				$puti($1.scm, 36, $geti($1.ccb, 8, 2)); /*17776*/
				$puti($1.scm, 54, $geti($1.scb, 0, 6)); /*17777*/
				$puti($1.scm, 48, $geti($1.scb, 6, 4)); /*17778*/
				$1.pri = $a([0, 0, 0, 0, 0, 0, 0, 0, 0, 0]); /*17781*/
				for (var _8P = 0; _8P <= 59; _8P += 1) { /*17787*/
					$1.i = _8P; /*17783*/
					$1.ps = ~~($1.i / 6); /*17784*/
					$1.ep = (~~(Math.pow(2, 5 - ($1.i % 6)))) * ($get($1.scm, $1.i) - 48); /*17785*/
					$put($1.pri, $1.ps, $get($1.pri, $1.ps) + $1.ep); /*17786*/
				} /*17786*/
				$k[$j++] = Infinity; /*17790*/
				for (var _8b = 0, _8c = 84; _8b < _8c; _8b++) { /*17790*/
					$k[$j++] = $1.padval; /*17790*/
				} /*17790*/
				$1.sec = $a(); /*17790*/
				$puti($1.sec, 0, $1.encmsg); /*17791*/
			} /*17791*/
			if (((($1.mode == 4) || ($1.mode == 5)) || ($1.mode == 6)) || ($1.mode == -1)) { /*17812*/
				if ($1.mode == -1) { /*17801*/
					var _8n = ($1.encmsg.length <= 77) ? 5 : 4; /*17800*/
					$1.mode = _8n; /*17800*/
				} /*17800*/
				$k[$j++] = Infinity; /*17804*/
				var _8p = ($1.mode == 5) ? 78 : 94; /*17804*/
				for (var _8q = 0, _8r = _8p; _8q < _8r; _8q++) { /*17804*/
					$k[$j++] = $1.padval; /*17804*/
				} /*17804*/
				$1.cws = $a(); /*17804*/
				$put($1.cws, 0, $1.mode); /*17805*/
				$puti($1.cws, 1, $1.encmsg); /*17806*/
				$1.pri = $geti($1.cws, 0, 10); /*17809*/
				$1.sec = $geti($1.cws, 10, $1.cws.length - 10); /*17810*/
			} /*17810*/
			$k[$j++] = Infinity; /*17815*/
			$k[$j++] = 1; /*17815*/
			for (var _93 = 0, _94 = 63; _93 < _94; _93++) { /*17815*/
				var _95 = $k[--$j]; /*17815*/
				var _96 = _95 * 2; /*17815*/
				$k[$j++] = _95; /*17815*/
				$k[$j++] = _96; /*17815*/
				if (_96 >= 64) { /*17815*/
					var _97 = $k[--$j]; /*17815*/
					$k[$j++] = _97 ^ 67; /*17815*/
				} /*17815*/
			} /*17815*/
			$1.rsalog = $a(); /*17815*/
			$1.rslog = $a(64); /*17816*/
			for (var _9A = 1; _9A <= 63; _9A += 1) { /*17817*/
				$put($1.rslog, $get($1.rsalog, _9A), _9A); /*17817*/
			} /*17817*/
			$1.rsprod = function() {
				var _9E = $k[--$j]; /*17821*/
				var _9F = $k[--$j]; /*17821*/
				$k[$j++] = _9F; /*17825*/
				$k[$j++] = _9E; /*17825*/
				if ((_9E != 0) && (_9F != 0)) { /*17824*/
					var _9I = $get($1.rslog, $k[--$j]); /*17822*/
					var _9N = $get($1.rsalog, (_9I + $get($1.rslog, $k[--$j])) % 63); /*17822*/
					$k[$j++] = _9N; /*17822*/
				} else { /*17824*/
					$j -= 2; /*17824*/
					$k[$j++] = 0; /*17824*/
				} /*17824*/
			}; /*17826*/
			$1.rscodes = function() {
				$1.rsnum = $k[--$j]; /*17831*/
				$1.cwb = $k[--$j]; /*17832*/
				$k[$j++] = Infinity; /*17835*/
				$k[$j++] = 1; /*17835*/
				for (var _9R = 0, _9S = $1.rsnum; _9R < _9S; _9R++) { /*17835*/
					$k[$j++] = 0; /*17835*/
				} /*17835*/
				$1.coeffs = $a(); /*17835*/
				for (var _9W = 1, _9V = $1.rsnum; _9W <= _9V; _9W += 1) { /*17844*/
					$1.i = _9W; /*17837*/
					$put($1.coeffs, $1.i, $get($1.coeffs, $1.i - 1)); /*17838*/
					for (var _9d = $1.i - 1; _9d >= 1; _9d -= 1) { /*17842*/
						$1.j = _9d; /*17840*/
						$k[$j++] = $1.coeffs; /*17841*/
						$k[$j++] = $1.j; /*17841*/
						$k[$j++] = $get($1.coeffs, $1.j - 1); /*17841*/
						$k[$j++] = $get($1.coeffs, $1.j); /*17841*/
						$k[$j++] = $get($1.rsalog, $1.i); /*17841*/
						if ($1.rsprod() == $b) break; /*17841*/
						var _9p = $k[--$j]; /*17841*/
						var _9q = $k[--$j]; /*17841*/
						var _9r = $k[--$j]; /*17841*/
						$put($k[--$j], _9r, $xo(_9q, _9p)); /*17841*/
					} /*17841*/
					$k[$j++] = $1.coeffs; /*17843*/
					$k[$j++] = 0; /*17843*/
					$k[$j++] = $get($1.coeffs, 0); /*17843*/
					$k[$j++] = $get($1.rsalog, $1.i); /*17843*/
					if ($1.rsprod() == $b) break; /*17843*/
					var _9z = $k[--$j]; /*17843*/
					var _A0 = $k[--$j]; /*17843*/
					$put($k[--$j], _A0, _9z); /*17843*/
				} /*17843*/
				$1.coeffs = $geti($1.coeffs, 0, $1.coeffs.length - 1); /*17845*/
				$k[$j++] = Infinity; /*17848*/
				for (var _A6 = 0, _A7 = $1.rsnum; _A6 < _A7; _A6++) { /*17848*/
					$k[$j++] = 0; /*17848*/
				} /*17848*/
				$1.ecb = $a(); /*17848*/
				for (var _AB = 0, _AA = $1.cwb.length - 1; _AB <= _AA; _AB += 1) { /*17857*/
					$1.t = $xo($get($1.cwb, _AB), $get($1.ecb, 0)); /*17850*/
					for (var _AH = $1.ecb.length - 1; _AH >= 0; _AH -= 1) { /*17856*/
						$1.i = _AH; /*17852*/
						$1.p = ($1.ecb.length - $1.i) - 1; /*17853*/
						$k[$j++] = $1.ecb; /*17854*/
						$k[$j++] = $1.p; /*17854*/
						$k[$j++] = $1.t; /*17854*/
						$k[$j++] = $get($1.coeffs, $1.i); /*17854*/
						if ($1.rsprod() == $b) break; /*17854*/
						var _AQ = $k[--$j]; /*17854*/
						var _AR = $k[--$j]; /*17854*/
						$put($k[--$j], _AR, _AQ); /*17854*/
						if ($1.i > 0) { /*17855*/
							$put($1.ecb, $1.p, $xo($get($1.ecb, $1.p + 1), $get($1.ecb, $1.p))); /*17855*/
						} /*17855*/
					} /*17855*/
				} /*17855*/
				$k[$j++] = $1.ecb; /*17859*/
			}; /*17861*/
			$k[$j++] = Infinity; /*17864*/
			for (var _Af = 0, _Ae = $1.sec.length - 1; _Af <= _Ae; _Af += 2) { /*17864*/
				$k[$j++] = $get($1.sec, _Af); /*17864*/
			} /*17864*/
			$1.seco = $a(); /*17864*/
			$k[$j++] = Infinity; /*17865*/
			for (var _Al = 1, _Ak = $1.sec.length - 1; _Al <= _Ak; _Al += 2) { /*17865*/
				$k[$j++] = $get($1.sec, _Al); /*17865*/
			} /*17865*/
			$1.sece = $a(); /*17865*/
			var _Aq = ($1.sec.length == 84) ? 20 : 28; /*17868*/
			$1.scodes = _Aq; /*17868*/
			$k[$j++] = "secochk"; /*17869*/
			$k[$j++] = $1.seco; /*17869*/
			$k[$j++] = $1.scodes; /*17869*/
			if ($1.rscodes() == $b) return $b; /*17869*/
			var _At = $k[--$j]; /*17869*/
			$1[$k[--$j]] = _At; /*17869*/
			$k[$j++] = "secechk"; /*17870*/
			$k[$j++] = $1.sece; /*17870*/
			$k[$j++] = $1.scodes; /*17870*/
			if ($1.rscodes() == $b) return $b; /*17870*/
			var _Ax = $k[--$j]; /*17870*/
			$1[$k[--$j]] = _Ax; /*17870*/
			$k[$j++] = Infinity; /*17873*/
			for (var _B1 = 0, _B0 = $1.scodes - 1; _B1 <= _B0; _B1 += 1) { /*17873*/
				$k[$j++] = $get($1.secochk, _B1); /*17873*/
				$k[$j++] = $get($1.secechk, _B1); /*17873*/
			} /*17873*/
			$1.secchk = $a(); /*17873*/
			$k[$j++] = Infinity; /*17881*/
			$aload($1.pri); /*17877*/
			$k[$j++] = $1.pri; /*17878*/
			$k[$j++] = 10; /*17878*/
			if ($1.rscodes() == $b) return $b; /*17878*/
			$aload($k[--$j]); /*17878*/
			$aload($1.sec); /*17879*/
			$aload($1.secchk); /*17880*/
			$1.codewords = $a(); /*17881*/
			$k[$j++] = Infinity; /*17884*/
			for (var _BD = 0, _BE = 864; _BD < _BE; _BD++) { /*17884*/
				$k[$j++] = 0; /*17884*/
			} /*17884*/
			$1.mods = $a(); /*17884*/
			for (var _BG = 0; _BG <= 143; _BG += 1) { /*17889*/
				$1.i = _BG; /*17886*/
				$k[$j++] = Infinity; /*17887*/
				var _BL = $cvrs($s(6), $get($1.codewords, $1.i), 2); /*17887*/
				for (var _BM = 0, _BN = _BL.length; _BM < _BN; _BM++) { /*17887*/
					$k[$j++] = $get(_BL, _BM) - 48; /*17887*/
				} /*17887*/
				$1.cw = $a(); /*17887*/
				$puti($1.mods, (6 * $1.i) + (6 - $1.cw.length), $1.cw); /*17888*/
			} /*17888*/
			$1.modmap = $a([469, 529, 286, 316, 347, 346, 673, 672, 703, 702, 647, 676, 283, 282, 313, 312, 370, 610, 618, 379, 378, 409, 408, 439, 705, 704, 559, 589, 588, 619, 458, 518, 640, 701, 675, 674, 285, 284, 315, 314, 310, 340, 531, 289, 288, 319, 349, 348, 456, 486, 517, 516, 471, 470, 369, 368, 399, 398, 429, 428, 549, 548, 579, 578, 609, 608, 649, 648, 679, 678, 709, 708, 639, 638, 669, 668, 699, 698, 279, 278, 309, 308, 339, 338, 381, 380, 411, 410, 441, 440, 561, 560, 591, 590, 621, 620, 547, 546, 577, 576, 607, 606, 367, 366, 397, 396, 427, 426, 291, 290, 321, 320, 351, 350, 651, 650, 681, 680, 711, 710, 1, 0, 31, 30, 61, 60, 3, 2, 33, 32, 63, 62, 5, 4, 35, 34, 65, 64, 7, 6, 37, 36, 67, 66, 9, 8, 39, 38, 69, 68, 11, 10, 41, 40, 71, 70, 13, 12, 43, 42, 73, 72, 15, 14, 45, 44, 75, 74, 17, 16, 47, 46, 77, 76, 19, 18, 49, 48, 79, 78, 21, 20, 51, 50, 81, 80, 23, 22, 53, 52, 83, 82, 25, 24, 55, 54, 85, 84, 27, 26, 57, 56, 87, 86, 117, 116, 147, 146, 177, 176, 115, 114, 145, 144, 175, 174, 113, 112, 143, 142, 173, 172, 111, 110, 141, 140, 171, 170, 109, 108, 139, 138, 169, 168, 107, 106, 137, 136, 167, 166, 105, 104, 135, 134, 165, 164, 103, 102, 133, 132, 163, 162, 101, 100, 131, 130, 161, 160, 99, 98, 129, 128, 159, 158, 97, 96, 127, 126, 157, 156, 95, 94, 125, 124, 155, 154, 93, 92, 123, 122, 153, 152, 91, 90, 121, 120, 151, 150, 181, 180, 211, 210, 241, 240, 183, 182, 213, 212, 243, 242, 185, 184, 215, 214, 245, 244, 187, 186, 217, 216, 247, 246, 189, 188, 219, 218, 249, 248, 191, 190, 221, 220, 251, 250, 193, 192, 223, 222, 253, 252, 195, 194, 225, 224, 255, 254, 197, 196, 227, 226, 257, 256, 199, 198, 229, 228, 259, 258, 201, 200, 231, 230, 261, 260, 203, 202, 233, 232, 263, 262, 205, 204, 235, 234, 265, 264, 207, 206, 237, 236, 267, 266, 297, 296, 327, 326, 357, 356, 295, 294, 325, 324, 355, 354, 293, 292, 323, 322, 353, 352, 277, 276, 307, 306, 337, 336, 275, 274, 305, 304, 335, 334, 273, 272, 303, 302, 333, 332, 271, 270, 301, 300, 331, 330, 361, 360, 391, 390, 421, 420, 363, 362, 393, 392, 423, 422, 365, 364, 395, 394, 425, 424, 383, 382, 413, 412, 443, 442, 385, 384, 415, 414, 445, 444, 387, 386, 417, 416, 447, 446, 477, 476, 507, 506, 537, 536, 475, 474, 505, 504, 535, 534, 473, 472, 503, 502, 533, 532, 455, 454, 485, 484, 515, 514, 453, 452, 483, 482, 513, 512, 451, 450, 481, 480, 511, 510, 541, 540, 571, 570, 601, 600, 543, 542, 573, 572, 603, 602, 545, 544, 575, 574, 605, 604, 563, 562, 593, 592, 623, 622, 565, 564, 595, 594, 625, 624, 567, 566, 597, 596, 627, 626, 657, 656, 687, 686, 717, 716, 655, 654, 685, 684, 715, 714, 653, 652, 683, 682, 713, 712, 637, 636, 667, 666, 697, 696, 635, 634, 665, 664, 695, 694, 633, 632, 663, 662, 693, 692, 631, 630, 661, 660, 691, 690, 721, 720, 751, 750, 781, 780, 723, 722, 753, 752, 783, 782, 725, 724, 755, 754, 785, 784, 727, 726, 757, 756, 787, 786, 729, 728, 759, 758, 789, 788, 731, 730, 761, 760, 791, 790, 733, 732, 763, 762, 793, 792, 735, 734, 765, 764, 795, 794, 737, 736, 767, 766, 797, 796, 739, 738, 769, 768, 799, 798, 741, 740, 771, 770, 801, 800, 743, 742, 773, 772, 803, 802, 745, 744, 775, 774, 805, 804, 747, 746, 777, 776, 807, 806, 837, 836, 867, 866, 897, 896, 835, 834, 865, 864, 895, 894, 833, 832, 863, 862, 893, 892, 831, 830, 861, 860, 891, 890, 829, 828, 859, 858, 889, 888, 827, 826, 857, 856, 887, 886, 825, 824, 855, 854, 885, 884, 823, 822, 853, 852, 883, 882, 821, 820, 851, 850, 881, 880, 819, 818, 849, 848, 879, 878, 817, 816, 847, 846, 877, 876, 815, 814, 845, 844, 875, 874, 813, 812, 843, 842, 873, 872, 811, 810, 841, 840, 871, 870, 901, 900, 931, 930, 961, 960, 903, 902, 933, 932, 963, 962, 905, 904, 935, 934, 965, 964, 907, 906, 937, 936, 967, 966, 909, 908, 939, 938, 969, 968, 911, 910, 941, 940, 971, 970, 913, 912, 943, 942, 973, 972, 915, 914, 945, 944, 975, 974, 917, 916, 947, 946, 977, 976, 919, 918, 949, 948, 979, 978, 921, 920, 951, 950, 981, 980, 923, 922, 953, 952, 983, 982, 925, 924, 955, 954, 985, 984, 927, 926, 957, 956, 987, 986, 58, 89, 88, 118, 149, 148, 178, 209, 208, 238, 269, 268, 298, 329, 328, 358, 389, 388, 418, 449, 448, 478, 509, 508, 538, 569, 568, 598, 629, 628, 658, 689, 688, 718, 749, 748, 778, 809, 808, 838, 869, 868, 898, 929, 928, 958, 989, 988]); /*17937*/
			$1.pixs = $a(864); /*17940*/
			$1.j = 0; /*17941*/
			for (var _BY = 0, _BX = $1.mods.length - 1; _BY <= _BX; _BY += 1) { /*17948*/
				$1.i = _BY; /*17943*/
				if ($get($1.mods, $1.i) == 1) { /*17947*/
					$put($1.pixs, $1.j, $get($1.modmap, $1.i)); /*17945*/
					$1.j = $1.j + 1; /*17946*/
				} /*17946*/
			} /*17946*/
			$k[$j++] = Infinity; /*17949*/
			$forall($geti($1.pixs, 0, $1.j)); /*17949*/
			$k[$j++] = 28; /*17949*/
			$k[$j++] = 29; /*17949*/
			$k[$j++] = 280; /*17949*/
			$k[$j++] = 281; /*17949*/
			$k[$j++] = 311; /*17949*/
			$k[$j++] = 457; /*17949*/
			$k[$j++] = 488; /*17949*/
			$k[$j++] = 500; /*17949*/
			$k[$j++] = 530; /*17949*/
			$k[$j++] = 670; /*17949*/
			$k[$j++] = 700; /*17949*/
			$k[$j++] = 677; /*17949*/
			$k[$j++] = 707; /*17949*/
			$1.pixs = $a(); /*17949*/
			var _Bo = {
				ren: $0.renmaximatrix,
				pixs: $1.pixs,
				opt: $1.options
			}; /*17955*/
			$k[$j++] = _Bo; /*17958*/
			if (!$1.dontdraw) { /*17958*/
				$0.renmaximatrix(); /*17958*/
			} /*17958*/
		};
		$0.azteccode = function() {
			var $1 = {}; /*17985*/
			$1.options = $k[--$j]; /*17987*/
			$1.barcode = $k[--$j]; /*17988*/
			$1.dontdraw = false; /*17990*/
			$1.format = "unset"; /*17991*/
			$1.readerinit = false; /*17992*/
			$1.layers = -1; /*17993*/
			$1.eclevel = 23; /*17994*/
			$1.ecaddchars = 3; /*17995*/
			$1.raw = false; /*17996*/
			$1.parse = false; /*17997*/
			$forall($1.options, function() { /*18008*/
				var _3 = $k[--$j]; /*18008*/
				$1[$k[--$j]] = _3; /*18008*/
			}); /*18008*/
			$1.layers = ~~$1.layers; /*18010*/
			$1.eclevel = +$1.eclevel; /*18011*/
			$1.ecaddchars = ~~$1.ecaddchars; /*18012*/
			$1.msgbits = ""; /*18036*/
			if ($ne($1.format, "rune") && $1.raw) { /*18037*/
				$1.msgbits = $1.barcode; /*18037*/
			} /*18037*/
			if ($ne($1.format, "rune") && (!$1.raw)) { /*18334*/
				$1.U = 0; /*18041*/
				$1.L = 1; /*18041*/
				$1.M = 2; /*18041*/
				$1.P = 3; /*18041*/
				$1.D = 4; /*18041*/
				$1.B = 5; /*18041*/
				$1.lu = -1; /*18044*/
				$1.ll = -2; /*18044*/
				$1.lm = -3; /*18044*/
				$1.lp = -4; /*18045*/
				$1.ld = -5; /*18045*/
				$1.su = -6; /*18045*/
				$1.sp = -7; /*18046*/
				$1.sb = -8; /*18046*/
				$1.fl = -9; /*18046*/
				$1.p2 = -10; /*18047*/
				$1.p3 = -11; /*18047*/
				$1.p4 = -12; /*18047*/
				$1.p5 = -13; /*18047*/
				$1.charmaps = $a([$a([$1.sp, $1.sp, $1.sp, $1.fl, $1.sp]), $a([32, 32, 32, 13, 32]), $a(["A", "a", 1, $1.p2, "0"]), $a(["B", "b", 2, $1.p3, "1"]), $a(["C", "c", 3, $1.p4, "2"]), $a(["D", "d", 4, $1.p5, "3"]), $a(["E", "e", 5, "!", "4"]), $a(["F", "f", 6, "\"", "5"]), $a(["G", "g", 7, "#", "6"]), $a(["H", "h", 8, "$", "7"]), $a(["I", "i", 9, "%", "8"]), $a(["J", "j", 10, "&", "9"]), $a(["K", "k", 11, "'", ","]), $a(["L", "l", 12, 40, "."]), $a(["M", "m", 13, 41, $1.lu]), $a(["N", "n", 27, "*", $1.su]), $a(["O", "o", 28, "+", -99]), $a(["P", "p", 29, ",", -99]), $a(["Q", "q", 30, "-", -99]), $a(["R", "r", 31, ".", -99]), $a(["S", "s", "@", "/", -99]), $a(["T", "t", 92, ":", -99]), $a(["U", "u", "^", ";", -99]), $a(["V", "v", "_", "<", -99]), $a(["W", "w", "`", "=", -99]), $a(["X", "x", "|", ">", -99]), $a(["Y", "y", "~", "?", -99]), $a(["Z", "z", 127, "[", -99]), $a([$1.ll, $1.su, $1.ll, "]", -99]), $a([$1.lm, $1.lm, $1.lu, "{", -99]), $a([$1.ld, $1.ld, $1.lp, "}", -99]), $a([$1.sb, $1.sb, $1.sb, $1.lu, -99])]); /*18084*/
				$1.charvals = $a([{}, {}, {}, {}, {}]); /*18087*/
				for (var _1B = 0, _1A = $1.charmaps.length - 1; _1B <= _1A; _1B += 1) { /*18096*/
					$1.i = _1B; /*18089*/
					$1.encs = $get($1.charmaps, $1.i); /*18090*/
					for (var _1F = 0; _1F <= 4; _1F += 1) { /*18095*/
						$1.j = _1F; /*18092*/
						var _1I = $get($1.encs, $1.j); /*18093*/
						$k[$j++] = _1I; /*18093*/
						if ($eq($type(_1I), "stringtype")) { /*18093*/
							var _1L = $get($k[--$j], 0); /*18093*/
							$k[$j++] = _1L; /*18093*/
						} /*18093*/
						$put($get($1.charvals, $1.j), $k[--$j], $1.i); /*18094*/
					} /*18094*/
				} /*18094*/
				var _1V = {
					"\x0d\x0a": $1.p2,
					". ": $1.p3,
					", ": $1.p4,
					": ": $1.p5
				}; /*18103*/
				$1.pcomp = _1V; /*18104*/
				$1.e = 10000; /*18106*/
				$1.latlen = $a([$a([0, 5, 5, 10, 5, 10]), $a([9, 0, 5, 10, 5, 10]), $a([5, 5, 0, 5, 10, 10]), $a([5, 10, 10, 0, 10, 15]), $a([4, 9, 9, 14, 0, 14]), $a([0, 0, 0, 0, 0, 0])]); /*18116*/
				$1.latseq = $a([$a([$a([]), $a([$1.ll]), $a([$1.lm]), $a([$1.lm, $1.lp]), $a([$1.ld]), $a([$1.sb])]), $a([$a([$1.ld, $1.lu]), $a([]), $a([$1.lm]), $a([$1.lm, $1.lp]), $a([$1.ld]), $a([$1.sb])]), $a([$a([$1.lu]), $a([$1.ll]), $a([]), $a([$1.lp]), $a([$1.lu, $1.ld]), $a([$1.sb])]), $a([$a([$1.lu]), $a([$1.lu, $1.ll]), $a([$1.lu, $1.lm]), $a([]), $a([$1.lu, $1.ld]), $a([$1.lu, $1.sb])]), $a([$a([$1.lu]), $a([$1.lu, $1.ll]), $a([$1.lu, $1.lm]), $a([$1.lu, $1.lm, $1.lp]), $a([]), $a([$1.lu, $1.sb])]), $a([$a([$1.lu]), $a([$1.ll]), $a([$1.lm]), $a([]), $a([]), $a([])])]); /*18126*/
				$1.shftlen = $a([$a([$1.e, $1.e, $1.e, 5, $1.e]), $a([5, $1.e, $1.e, 5, $1.e]), $a([$1.e, $1.e, $1.e, 5, $1.e]), $a([$1.e, $1.e, $1.e, $1.e, $1.e]), $a([4, $1.e, $1.e, 4, $1.e])]); /*18135*/
				$1.charsize = $a([5, 5, 5, 5, 4, 8]); /*18138*/
				$1.curlen = $a([0, $1.e, $1.e, $1.e, $1.e, $1.e]); /*18141*/
				$1.curseq = $a([$a([]), $a([]), $a([]), $a([]), $a([]), $a([])]); /*18142*/
				$1.backto = $1.U; /*18144*/
				$1.lastchar = ""; /*18145*/
				$forall($1.barcode, function() { /*18241*/
					$1.char = $k[--$j]; /*18150*/
					for (;;) { /*18176*/
						$1.imp = false; /*18154*/
						var _3l = $a([$1.U, $1.L, $1.M, $1.P, $1.D, $1.B]); /*18155*/
						for (var _3m = 0, _3n = _3l.length; _3m < _3n; _3m++) { /*18174*/
							$1.x = $get(_3l, _3m); /*18156*/
							var _3v = $a([$1.U, $1.L, $1.M, $1.P, $1.D, $1.B]); /*18157*/
							for (var _3w = 0, _3x = _3v.length; _3w < _3x; _3w++) { /*18173*/
								$1.y = $get(_3v, _3w); /*18158*/
								if (($1.x != $1.B) || ($1.y == $1.backto)) { /*18172*/
									$1.cost = $get($1.curlen, $1.x) + $get($get($1.latlen, $1.x), $1.y); /*18160*/
									if ($1.cost < $get($1.curlen, $1.y)) { /*18171*/
										$put($1.curlen, $1.y, $1.cost); /*18162*/
										$k[$j++] = $1.curseq; /*18165*/
										$k[$j++] = $1.y; /*18165*/
										$k[$j++] = Infinity; /*18165*/
										$aload($get($1.curseq, $1.x)); /*18164*/
										$aload($get($get($1.latseq, $1.x), $1.y)); /*18165*/
										var _4S = $a(); /*18165*/
										var _4T = $k[--$j]; /*18166*/
										$put($k[--$j], _4T, _4S); /*18166*/
										if ($1.y == $1.B) { /*18169*/
											$k[$j++] = "backto"; /*18168*/
											if (($1.x == $1.P) || ($1.x == $1.D)) { /*18168*/
												$k[$j++] = $1.U; /*18168*/
											} else { /*18168*/
												$k[$j++] = $1.x; /*18168*/
											} /*18168*/
											var _4d = $k[--$j]; /*18168*/
											$1[$k[--$j]] = _4d; /*18168*/
										} /*18168*/
										$1.imp = true; /*18170*/
									} /*18170*/
								} /*18170*/
							} /*18170*/
						} /*18170*/
						if (!$1.imp) { /*18175*/
							break; /*18175*/
						} /*18175*/
					} /*18175*/
					$1.nxtlen = $a([$1.e, $1.e, $1.e, $1.e, $1.e, $1.e]); /*18179*/
					$1.nxtseq = $a(6); /*18180*/
					var _4u = $a([$1.U, $1.L, $1.M, $1.P, $1.D, $1.B]); /*18182*/
					for (var _4v = 0, _4w = _4u.length; _4v < _4w; _4v++) { /*18217*/
						$1.x = $get(_4u, _4v); /*18183*/
						for (;;) { /*18215*/
							if ($1.x != $1.B) { /*18188*/
								var _54 = $get($get($1.charvals, $1.x), $1.char) !== undefined; /*18188*/
								if (!_54) { /*18188*/
									break; /*18188*/
								} /*18188*/
							} /*18188*/
							$1.cost = $get($1.curlen, $1.x) + $get($1.charsize, $1.x); /*18191*/
							if ($1.cost < $get($1.nxtlen, $1.x)) { /*18195*/
								$put($1.nxtlen, $1.x, $1.cost); /*18193*/
								$k[$j++] = $1.nxtseq; /*18194*/
								$k[$j++] = $1.x; /*18194*/
								$k[$j++] = Infinity; /*18194*/
								$aload($get($1.curseq, $1.x)); /*18194*/
								$k[$j++] = $1.char; /*18194*/
								var _5O = $a(); /*18194*/
								var _5P = $k[--$j]; /*18194*/
								$put($k[--$j], _5P, _5O); /*18194*/
							} /*18194*/
							if ($1.x == $1.B) { /*18198*/
								break; /*18198*/
							} /*18198*/
							var _5Y = $a([$1.U, $1.L, $1.M, $1.P, $1.D]); /*18199*/
							for (var _5Z = 0, _5a = _5Y.length; _5Z < _5a; _5Z++) { /*18212*/
								$1.y = $get(_5Y, _5Z); /*18200*/
								if ($ne($1.x, $1.y)) { /*18211*/
									$1.cost = ($get($1.curlen, $1.y) + $get($get($1.shftlen, $1.y), $1.x)) + $get($1.charsize, $1.x); /*18202*/
									if ($1.cost < $get($1.nxtlen, $1.y)) { /*18210*/
										$put($1.nxtlen, $1.y, $1.cost); /*18204*/
										$k[$j++] = $1.nxtseq; /*18208*/
										$k[$j++] = $1.y; /*18208*/
										$k[$j++] = Infinity; /*18208*/
										$aload($get($1.curseq, $1.y)); /*18206*/
										var _63 = ($1.x == $1.U) ? $1.su : $1.sp; /*18207*/
										$k[$j++] = _63; /*18208*/
										$k[$j++] = $1.char; /*18208*/
										var _65 = $a(); /*18208*/
										var _66 = $k[--$j]; /*18209*/
										$put($k[--$j], _66, _65); /*18209*/
									} /*18209*/
								} /*18209*/
							} /*18209*/
							break; /*18214*/
						} /*18214*/
					} /*18214*/
					if ($ne($1.lastchar, "")) { /*18228*/
						var _69 = $s(2); /*18221*/
						$put(_69, 0, $1.lastchar); /*18221*/
						$put(_69, 1, $1.char); /*18221*/
						$1.pchars = _69; /*18221*/
						var _6E = $get($1.pcomp, $1.pchars) !== undefined; /*18222*/
						if (_6E) { /*18227*/
							if ($lt($get($1.curlen, $1.P), $get($1.nxtlen, $1.P))) { /*18226*/
								$put($1.nxtlen, $1.P, $get($1.curlen, $1.P)); /*18224*/
								$k[$j++] = $1.nxtseq; /*18225*/
								$k[$j++] = $1.P; /*18225*/
								$k[$j++] = Infinity; /*18225*/
								$aload($get($1.curseq, $1.P)); /*18225*/
								$j--; /*18225*/
								$k[$j++] = $get($1.pcomp, $1.pchars); /*18225*/
								var _6Y = $a(); /*18225*/
								var _6Z = $k[--$j]; /*18225*/
								$put($k[--$j], _6Z, _6Y); /*18225*/
							} /*18225*/
						} /*18225*/
					} /*18225*/
					$1.numbytes = 0; /*18231*/
					$forall($get($1.nxtseq, $1.B), function() { /*18234*/
						if ($k[--$j] == $1.sb) { /*18233*/
							$k[$j++] = 0; /*18233*/
						} else { /*18233*/
							$k[$j++] = $1.numbytes + 1; /*18233*/
						} /*18233*/
						$1.numbytes = $k[--$j]; /*18233*/
					}); /*18233*/
					if ($1.numbytes == 32) { /*18235*/
						$put($1.nxtlen, $1.B, $get($1.nxtlen, $1.B) + 11); /*18235*/
					} /*18235*/
					$1.curlen = $1.nxtlen; /*18237*/
					$1.curseq = $1.nxtseq; /*18238*/
					$1.lastchar = $1.char; /*18239*/
				}); /*18239*/
				$1.minseq = $1.e; /*18244*/
				var _6y = $a([$1.U, $1.L, $1.M, $1.P, $1.D, $1.B]); /*18245*/
				for (var _6z = 0, _70 = _6y.length; _6z < _70; _6z++) { /*18251*/
					$1.i = $get(_6y, _6z); /*18246*/
					if ($get($1.curlen, $1.i) < $1.minseq) { /*18250*/
						$1.minseq = $get($1.curlen, $1.i); /*18248*/
						$1.seq = $get($1.curseq, $1.i); /*18249*/
					} /*18249*/
				} /*18249*/
				$1.tobin = function() {
					var _7D = $s($k[--$j]); /*18255*/
					$k[$j++] = _7D; /*18255*/
					for (var _7F = 0, _7E = _7D.length - 1; _7F <= _7E; _7F += 1) { /*18255*/
						var _7G = $k[--$j]; /*18255*/
						$put(_7G, _7F, 48); /*18255*/
						$k[$j++] = _7G; /*18255*/
					} /*18255*/
					var _7H = $k[--$j]; /*18256*/
					var _7K = $cvrs($s(_7H.length), $k[--$j], 2); /*18256*/
					$puti(_7H, _7H.length - _7K.length, _7K); /*18256*/
					$k[$j++] = _7H; /*18256*/
				}; /*18257*/
				$1.encu = function() {
					var _7P = $get($get($1.charvals, $1.U), $k[--$j]); /*18258*/
					$k[$j++] = _7P; /*18258*/
					$k[$j++] = 5; /*18258*/
					if ($1.tobin() == $b) return $b; /*18258*/
				}; /*18258*/
				$1.encl = function() {
					var _7U = $get($get($1.charvals, $1.L), $k[--$j]); /*18259*/
					$k[$j++] = _7U; /*18259*/
					$k[$j++] = 5; /*18259*/
					if ($1.tobin() == $b) return $b; /*18259*/
				}; /*18259*/
				$1.encm = function() {
					var _7Z = $get($get($1.charvals, $1.M), $k[--$j]); /*18260*/
					$k[$j++] = _7Z; /*18260*/
					$k[$j++] = 5; /*18260*/
					if ($1.tobin() == $b) return $b; /*18260*/
				}; /*18260*/
				$1.encp = function() {
					var _7e = $get($get($1.charvals, $1.P), $k[--$j]); /*18261*/
					$k[$j++] = _7e; /*18261*/
					$k[$j++] = 5; /*18261*/
					if ($1.tobin() == $b) return $b; /*18261*/
				}; /*18261*/
				$1.encd = function() {
					var _7j = $get($get($1.charvals, $1.D), $k[--$j]); /*18262*/
					$k[$j++] = _7j; /*18262*/
					$k[$j++] = 4; /*18262*/
					if ($1.tobin() == $b) return $b; /*18262*/
				}; /*18262*/
				$1.encfuncs = $a(["encu", "encl", "encm", "encp", "encd"]); /*18263*/
				$1.addtomsgbits = function() {
					$1.v = $k[--$j]; /*18265*/
					$puti($1.msgbits, $1.j, $1.v); /*18266*/
					$1.j = $1.j + $1.v.length; /*18267*/
				}; /*18268*/
				$1.state = $1.U; /*18271*/
				$1.msgbits = $s($1.minseq); /*18272*/
				$1.i = 0; /*18273*/
				$1.j = 0; /*18273*/
				for (;;) { /*18332*/
					if ($1.i >= $1.seq.length) { /*18274*/
						break; /*18274*/
					} /*18274*/
					if ($1.state != $1.B) { /*18327*/
						$1.char = $get($1.seq, $1.i); /*18278*/
						$k[$j++] = $1.char; /*18281*/
						$1[$get($1.encfuncs, $1.state)](); /*18281*/
						if ($1.addtomsgbits() == $b) break; /*18281*/
						$1.i = $1.i + 1; /*18282*/
						if (($1.char == $1.su) || ($1.char == $1.sp)) { /*18288*/
							$k[$j++] = $get($1.seq, $1.i); /*18286*/
							if ($1.char == $1.su) { /*18286*/
								if ($1.encu() == $b) break; /*18286*/
							} else { /*18286*/
								if ($1.encp() == $b) break; /*18286*/
							} /*18286*/
							if ($1.addtomsgbits() == $b) break; /*18286*/
							$1.i = $1.i + 1; /*18287*/
						} /*18287*/
						if ($1.char == $1.lu) { /*18291*/
							$1.state = $1.U; /*18291*/
						} /*18291*/
						if ($1.char == $1.ll) { /*18292*/
							$1.state = $1.L; /*18292*/
						} /*18292*/
						if ($1.char == $1.lm) { /*18293*/
							$1.state = $1.M; /*18293*/
						} /*18293*/
						if ($1.char == $1.lp) { /*18294*/
							$1.state = $1.P; /*18294*/
						} /*18294*/
						if ($1.char == $1.ld) { /*18295*/
							$1.state = $1.D; /*18295*/
						} /*18295*/
						if ($1.char == $1.sb) { /*18296*/
							$1.state = $1.B; /*18296*/
						} /*18296*/
					} else { /*18327*/
						$1.numbytes = 0; /*18301*/
						for (;;) { /*18305*/
							if (($1.i + $1.numbytes) >= $1.seq.length) { /*18302*/
								break; /*18302*/
							} /*18302*/
							if ($get($1.seq, $1.i + $1.numbytes) < 0) { /*18303*/
								break; /*18303*/
							} /*18303*/
							$1.numbytes = $1.numbytes + 1; /*18304*/
						} /*18304*/
						if ($1.numbytes <= 31) { /*18312*/
							$k[$j++] = $1.numbytes; /*18309*/
							$k[$j++] = 5; /*18309*/
							if ($1.tobin() == $b) break; /*18309*/
							if ($1.addtomsgbits() == $b) break; /*18309*/
						} else { /*18312*/
							$k[$j++] = 0; /*18311*/
							$k[$j++] = 5; /*18311*/
							if ($1.tobin() == $b) break; /*18311*/
							if ($1.addtomsgbits() == $b) break; /*18311*/
							$k[$j++] = $1.numbytes - 31; /*18312*/
							$k[$j++] = 11; /*18312*/
							if ($1.tobin() == $b) break; /*18312*/
							if ($1.addtomsgbits() == $b) break; /*18312*/
						} /*18312*/
						for (var _8l = 0, _8m = $1.numbytes; _8l < _8m; _8l++) { /*18319*/
							$k[$j++] = $get($1.seq, $1.i); /*18317*/
							$k[$j++] = 8; /*18317*/
							if ($1.tobin() == $b) break; /*18317*/
							if ($1.addtomsgbits() == $b) break; /*18317*/
							$1.i = $1.i + 1; /*18318*/
						} /*18318*/
						if ($1.i < $1.seq.length) { /*18328*/
							$1.char = $get($1.seq, $1.i); /*18323*/
							$1.i = $1.i + 1; /*18324*/
							if ($1.char == $1.lu) { /*18325*/
								$1.state = $1.U; /*18325*/
							} /*18325*/
							if ($1.char == $1.ll) { /*18326*/
								$1.state = $1.L; /*18326*/
							} /*18326*/
							if ($1.char == $1.lm) { /*18327*/
								$1.state = $1.M; /*18327*/
							} /*18327*/
						} /*18327*/
					} /*18327*/
				} /*18327*/
			} /*18327*/
			$1.metrics = $a([$a(["rune", 0, 0, 0, 6]), $a(["compact", 1, 1, 17, 6]), $a(["full", 1, 1, 21, 6]), $a(["compact", 2, 0, 40, 6]), $a(["full", 2, 1, 48, 6]), $a(["compact", 3, 0, 51, 8]), $a(["full", 3, 1, 60, 8]), $a(["compact", 4, 0, 76, 8]), $a(["full", 4, 1, 88, 8]), $a(["full", 5, 1, 120, 8]), $a(["full", 6, 1, 156, 8]), $a(["full", 7, 1, 196, 8]), $a(["full", 8, 1, 240, 8]), $a(["full", 9, 1, 230, 10]), $a(["full", 10, 1, 272, 10]), $a(["full", 11, 1, 316, 10]), $a(["full", 12, 1, 364, 10]), $a(["full", 13, 1, 416, 10]), $a(["full", 14, 1, 470, 10]), $a(["full", 15, 1, 528, 10]), $a(["full", 16, 1, 588, 10]), $a(["full", 17, 1, 652, 10]), $a(["full", 18, 1, 720, 10]), $a(["full", 19, 1, 790, 10]), $a(["full", 20, 1, 864, 10]), $a(["full", 21, 1, 940, 10]), $a(["full", 22, 1, 1020, 10]), $a(["full", 23, 0, 920, 12]), $a(["full", 24, 0, 992, 12]), $a(["full", 25, 0, 1066, 12]), $a(["full", 26, 0, 1144, 12]), $a(["full", 27, 0, 1224, 12]), $a(["full", 28, 0, 1306, 12]), $a(["full", 29, 0, 1392, 12]), $a(["full", 30, 0, 1480, 12]), $a(["full", 31, 0, 1570, 12]), $a(["full", 32, 0, 1664, 12])]); /*18351*/
			$1.i = 0; /*18353*/
			for (;;) { /*18371*/
				$1.m = $get($1.metrics, $1.i); /*18355*/
				$1.frmt = $get($1.m, 0); /*18356*/
				$1.mlyr = $get($1.m, 1); /*18357*/
				$1.icap = $get($1.m, 2); /*18358*/
				$1.ncws = $get($1.m, 3); /*18359*/
				$1.bpcw = $get($1.m, 4); /*18360*/
				$1.numecw = ~~(Math.ceil((($1.ncws * $1.eclevel) / 100) + $1.ecaddchars)); /*18361*/
				if ($1.msgbits.length == 0) { /*18362*/
					$1.numecw = 0; /*18362*/
				} /*18362*/
				$1.numdcw = $1.ncws - $1.numecw; /*18363*/
				$1.okay = true; /*18364*/
				if ($ne($1.format, "unset") && $ne($1.format, $1.frmt)) { /*18365*/
					$1.okay = false; /*18365*/
				} /*18365*/
				if ($1.readerinit && ($1.icap != 1)) { /*18366*/
					$1.okay = false; /*18366*/
				} /*18366*/
				if (($1.layers != -1) && ($1.layers != $1.mlyr)) { /*18367*/
					$1.okay = false; /*18367*/
				} /*18367*/
				if ((~~Math.ceil($1.msgbits.length / $1.bpcw)) > $1.numdcw) { /*18368*/
					$1.okay = false; /*18368*/
				} /*18368*/
				if ($1.okay) { /*18369*/
					break; /*18369*/
				} /*18369*/
				$1.i = $1.i + 1; /*18370*/
			} /*18370*/
			$1.layers = $1.mlyr; /*18372*/
			$1.format = $1.frmt; /*18373*/
			$1.allzero = function() {
				var _AG = $k[--$j]; /*18376*/
				$k[$j++] = $eq(_AG, $geti("000000000000", 0, _AG.length)); /*18376*/
			}; /*18376*/
			$1.allones = function() {
				var _AI = $k[--$j]; /*18377*/
				$k[$j++] = $eq(_AI, $geti("111111111111", 0, _AI.length)); /*18377*/
			}; /*18377*/
			$1.cws = $a($1.ncws); /*18378*/
			$1.m = 0; /*18379*/
			$1.c = 0; /*18379*/
			for (;;) { /*18406*/
				if ($1.msgbits.length <= $1.m) { /*18381*/
					break; /*18381*/
				} /*18381*/
				if (($1.msgbits.length - $1.m) >= $1.bpcw) { /*18395*/
					$1.cwb = $geti($1.msgbits, $1.m, $1.bpcw - 1); /*18383*/
					$1.cwf = $geti($1.msgbits, ($1.m + $1.bpcw) - 1, 1); /*18384*/
					$k[$j++] = $1.cwb; /*18385*/
					if ($1.allzero() == $b) break; /*18385*/
					if ($k[--$j]) { /*18385*/
						$1.cwf = "1"; /*18385*/
						$1.m = $1.m - 1; /*18385*/
					} /*18385*/
					$k[$j++] = $1.cwb; /*18386*/
					if ($1.allones() == $b) break; /*18386*/
					if ($k[--$j]) { /*18386*/
						$1.cwf = "0"; /*18386*/
						$1.m = $1.m - 1; /*18386*/
					} /*18386*/
					var _Af = $s(12); /*18388*/
					$puti(_Af, 0, $1.cwb); /*18388*/
					$puti(_Af, $1.bpcw - 1, $1.cwf); /*18389*/
					$1.cwb = $geti(_Af, 0, $1.bpcw); /*18391*/
				} else { /*18395*/
					$1.cwb = $geti($1.msgbits, $1.m, $1.msgbits.length - $1.m); /*18393*/
					var _Ar = $strcpy($s(12), "111111111111"); /*18394*/
					$puti(_Ar, 0, $1.cwb); /*18394*/
					$1.cwb = $geti(_Ar, 0, $1.bpcw); /*18394*/
					$k[$j++] = $1.cwb; /*18395*/
					if ($1.allones() == $b) break; /*18395*/
					if ($k[--$j]) { /*18395*/
						$puti($1.cwb, $1.cwb.length - 1, "0"); /*18395*/
					} /*18395*/
				} /*18395*/
				$1.cw = 0; /*18398*/
				for (var _B1 = 0, _B0 = $1.bpcw - 1; _B1 <= _B0; _B1 += 1) { /*18402*/
					$1.i = _B1; /*18400*/
					$1.cw = $1.cw + ((~~(Math.pow(2, ($1.bpcw - $1.i) - 1))) * ($get($1.cwb, $1.i) - 48)); /*18401*/
				} /*18401*/
				$put($1.cws, $1.c, $1.cw); /*18403*/
				$1.m = $1.m + $1.bpcw; /*18404*/
				$1.c = $1.c + 1; /*18405*/
			} /*18405*/
			$1.cws = $geti($1.cws, 0, $1.c); /*18407*/
			$1.rscodes = function() {
				$1.rspm = $k[--$j]; /*18412*/
				$1.rsgf = $k[--$j]; /*18413*/
				$1.rsnc = $k[--$j]; /*18414*/
				$1.rscws = $k[--$j]; /*18415*/
				$k[$j++] = Infinity; /*18418*/
				$k[$j++] = 1; /*18418*/
				for (var _BM = 0, _BN = $1.rsgf - 1; _BM < _BN; _BM++) { /*18418*/
					var _BO = $k[--$j]; /*18418*/
					var _BP = _BO * 2; /*18418*/
					$k[$j++] = _BO; /*18418*/
					$k[$j++] = _BP; /*18418*/
					if (_BP >= $1.rsgf) { /*18418*/
						var _BS = $k[--$j]; /*18418*/
						$k[$j++] = $xo(_BS, $1.rspm); /*18418*/
					} /*18418*/
				} /*18418*/
				$1.rsalog = $a(); /*18418*/
				$1.rslog = $a($1.rsgf); /*18419*/
				for (var _BY = 1, _BX = $1.rsgf - 1; _BY <= _BX; _BY += 1) { /*18420*/
					$put($1.rslog, $get($1.rsalog, _BY), _BY); /*18420*/
				} /*18420*/
				$1.rsprod = function() {
					var _Bc = $k[--$j]; /*18424*/
					var _Bd = $k[--$j]; /*18424*/
					$k[$j++] = _Bd; /*18428*/
					$k[$j++] = _Bc; /*18428*/
					if ((_Bc != 0) && (_Bd != 0)) { /*18427*/
						var _Bg = $get($1.rslog, $k[--$j]); /*18425*/
						var _Bm = $get($1.rsalog, (_Bg + $get($1.rslog, $k[--$j])) % ($1.rsgf - 1)); /*18425*/
						$k[$j++] = _Bm; /*18425*/
					} else { /*18427*/
						$j -= 2; /*18427*/
						$k[$j++] = 0; /*18427*/
					} /*18427*/
				}; /*18429*/
				$k[$j++] = Infinity; /*18432*/
				$k[$j++] = 1; /*18432*/
				for (var _Bo = 0, _Bp = $1.rsnc; _Bo < _Bp; _Bo++) { /*18432*/
					$k[$j++] = 0; /*18432*/
				} /*18432*/
				$1.coeffs = $a(); /*18432*/
				for (var _Bt = 1, _Bs = $1.rsnc; _Bt <= _Bs; _Bt += 1) { /*18441*/
					$1.i = _Bt; /*18434*/
					$put($1.coeffs, $1.i, $get($1.coeffs, $1.i - 1)); /*18435*/
					for (var _C0 = $1.i - 1; _C0 >= 1; _C0 -= 1) { /*18439*/
						$1.j = _C0; /*18437*/
						$k[$j++] = $1.coeffs; /*18438*/
						$k[$j++] = $1.j; /*18438*/
						$k[$j++] = $get($1.coeffs, $1.j - 1); /*18438*/
						$k[$j++] = $get($1.coeffs, $1.j); /*18438*/
						$k[$j++] = $get($1.rsalog, $1.i); /*18438*/
						if ($1.rsprod() == $b) break; /*18438*/
						var _CC = $k[--$j]; /*18438*/
						var _CD = $k[--$j]; /*18438*/
						var _CE = $k[--$j]; /*18438*/
						$put($k[--$j], _CE, $xo(_CD, _CC)); /*18438*/
					} /*18438*/
					$k[$j++] = $1.coeffs; /*18440*/
					$k[$j++] = 0; /*18440*/
					$k[$j++] = $get($1.coeffs, 0); /*18440*/
					$k[$j++] = $get($1.rsalog, $1.i); /*18440*/
					if ($1.rsprod() == $b) break; /*18440*/
					var _CM = $k[--$j]; /*18440*/
					var _CN = $k[--$j]; /*18440*/
					$put($k[--$j], _CN, _CM); /*18440*/
				} /*18440*/
				$1.nd = $1.rscws.length; /*18444*/
				$k[$j++] = Infinity; /*18445*/
				$forall($1.rscws); /*18445*/
				for (var _CS = 0, _CT = $1.rsnc; _CS < _CT; _CS++) { /*18445*/
					$k[$j++] = 0; /*18445*/
				} /*18445*/
				$k[$j++] = 0; /*18445*/
				$1.rscws = $a(); /*18445*/
				for (var _CX = 0, _CW = $1.nd - 1; _CX <= _CW; _CX += 1) { /*18452*/
					$1.k = $xo($get($1.rscws, _CX), $get($1.rscws, $1.nd)); /*18447*/
					for (var _Cf = 0, _Ce = $1.rsnc - 1; _Cf <= _Ce; _Cf += 1) { /*18451*/
						$1.j = _Cf; /*18449*/
						$k[$j++] = $1.rscws; /*18450*/
						$k[$j++] = $1.nd + $1.j; /*18450*/
						$k[$j++] = $get($1.rscws, ($1.nd + $1.j) + 1); /*18450*/
						$k[$j++] = $1.k; /*18450*/
						$k[$j++] = $get($1.coeffs, ($1.rsnc - $1.j) - 1); /*18450*/
						if ($1.rsprod() == $b) break; /*18450*/
						var _Cs = $k[--$j]; /*18450*/
						var _Ct = $k[--$j]; /*18450*/
						var _Cu = $k[--$j]; /*18450*/
						$put($k[--$j], _Cu, $xo(_Ct, _Cs)); /*18450*/
					} /*18450*/
				} /*18450*/
				$k[$j++] = $geti($1.rscws, 0, $1.rscws.length - 1); /*18455*/
			}; /*18457*/
			if ($eq($1.format, "full")) { /*18470*/
				$1.mode = (($1.layers - 1) << 11) + ($1.cws.length - 1); /*18461*/
				if ($1.readerinit) { /*18462*/
					$1.mode = $1.mode | 1024; /*18462*/
				} /*18462*/
				$1.mode = $a([($1.mode & 61440) >>> 12, ($1.mode & 3840) >>> 8, ($1.mode & 240) >>> 4, $1.mode & 15]); /*18468*/
				$k[$j++] = "mode"; /*18469*/
				$k[$j++] = $1.mode; /*18469*/
				$k[$j++] = 6; /*18469*/
				$k[$j++] = 16; /*18469*/
				$k[$j++] = 19; /*18469*/
				if ($1.rscodes() == $b) return $b; /*18469*/
				var _DA = $k[--$j]; /*18469*/
				$1[$k[--$j]] = _DA; /*18469*/
			} /*18469*/
			if ($eq($1.format, "compact")) { /*18479*/
				$1.mode = (($1.layers - 1) << 6) + ($1.cws.length - 1); /*18472*/
				if ($1.readerinit) { /*18473*/
					$1.mode = $1.mode | 32; /*18473*/
				} /*18473*/
				$1.mode = $a([($1.mode & 240) >>> 4, $1.mode & 15]); /*18477*/
				$k[$j++] = "mode"; /*18478*/
				$k[$j++] = $1.mode; /*18478*/
				$k[$j++] = 5; /*18478*/
				$k[$j++] = 16; /*18478*/
				$k[$j++] = 19; /*18478*/
				if ($1.rscodes() == $b) return $b; /*18478*/
				var _DL = $k[--$j]; /*18478*/
				$1[$k[--$j]] = _DL; /*18478*/
			} /*18478*/
			if ($eq($1.format, "rune")) { /*18488*/
				$1.mode = ~~$z($1.barcode); /*18481*/
				$1.mode = $a([($1.mode & 240) >>> 4, $1.mode & 15]); /*18485*/
				$k[$j++] = "mode"; /*18486*/
				$k[$j++] = $1.mode; /*18486*/
				$k[$j++] = 5; /*18486*/
				$k[$j++] = 16; /*18486*/
				$k[$j++] = 19; /*18486*/
				if ($1.rscodes() == $b) return $b; /*18486*/
				var _DT = $k[--$j]; /*18486*/
				$1[$k[--$j]] = _DT; /*18486*/
				$k[$j++] = Infinity; /*18487*/
				var _DV = $1.mode; /*18487*/
				for (var _DW = 0, _DX = _DV.length; _DW < _DX; _DW++) { /*18487*/
					$k[$j++] = $get(_DV, _DW) ^ 10; /*18487*/
				} /*18487*/
				$1.mode = $a(); /*18487*/
			} /*18487*/
			$1.modebits = $s($1.mode.length * 4); /*18489*/
			for (var _De = 0, _Dd = $1.modebits.length - 1; _De <= _Dd; _De += 1) { /*18490*/
				$puti($1.modebits, _De, "0"); /*18490*/
			} /*18490*/
			for (var _Di = 0, _Dh = $1.mode.length - 1; _Di <= _Dh; _Di += 1) { /*18494*/
				$1.i = _Di; /*18492*/
				var _Do = $cvrs($s(4), $get($1.mode, $1.i), 2); /*18493*/
				$puti($1.modebits, (4 - _Do.length) + (4 * $1.i), _Do); /*18493*/
			} /*18493*/
			$1.rsparams = $a([$a([]), $a([]), $a([]), $a([]), $a([]), $a([]), $a([64, 67]), $a([]), $a([256, 301]), $a([]), $a([1024, 1033]), $a([]), $a([4096, 4201])]); /*18506*/
			$k[$j++] = "cws"; /*18507*/
			$k[$j++] = $1.cws; /*18507*/
			$k[$j++] = $1.ncws - $1.cws.length; /*18507*/
			$forall($get($1.rsparams, $1.bpcw)); /*18507*/
			if ($1.rscodes() == $b) return $b; /*18507*/
			var _EA = $k[--$j]; /*18507*/
			$1[$k[--$j]] = _EA; /*18507*/
			if ($eq($1.format, "full")) { /*18511*/
				$1.databits = $s((($1.layers * $1.layers) * 16) + ($1.layers * 112)); /*18509*/
			} else { /*18511*/
				$1.databits = $s((($1.layers * $1.layers) * 16) + ($1.layers * 88)); /*18511*/
			} /*18511*/
			for (var _EN = 0, _EM = $1.databits.length - 1; _EN <= _EM; _EN += 1) { /*18513*/
				$puti($1.databits, _EN, "0"); /*18513*/
			} /*18513*/
			for (var _ER = 0, _EQ = $1.ncws - 1; _ER <= _EQ; _ER += 1) { /*18519*/
				$1.i = _ER; /*18515*/
				var _EY = $cvrs($s($1.bpcw), $get($1.cws, $1.i), 2); /*18516*/
				$puti($1.databits, (($1.bpcw - _EY.length) + ($1.bpcw * $1.i)) + ($1.databits.length - ($1.ncws * $1.bpcw)), _EY); /*18518*/
			} /*18518*/
			$1.cmv = function() {
				var _Eg = $k[--$j]; /*18522*/
				var _Eh = $k[--$j]; /*18522*/
				$k[$j++] = (_Eh - (_Eg * $1.size)) + $1.mid; /*18522*/
			}; /*18522*/
			$1.lmv = function() {
				$1.lbit = $k[--$j]; /*18526*/
				$1.llyr = $k[--$j]; /*18527*/
				$1.lwid = $1.fw + ($1.llyr * 4); /*18528*/
				$1.ldir = ~~((~~($1.lbit / 2)) / $1.lwid); /*18529*/
				if ($1.ldir == 0) { /*18534*/
					$k[$j++] = ((-(~~(($1.lwid - 1) / 2))) + 1) + ((~~($1.lbit / 2)) % $1.lwid); /*18533*/
					$k[$j++] = ((~~(($1.fw - 1) / 2)) + ($1.llyr * 2)) + ($1.lbit % 2); /*18533*/
					if ($1.cmv() == $b) return $b; /*18533*/
				} /*18533*/
				if ($1.ldir == 1) { /*18539*/
					$k[$j++] = ((~~($1.fw / 2)) + ($1.llyr * 2)) + ($1.lbit % 2); /*18538*/
					$k[$j++] = ((~~(($1.lwid - 1) / 2)) - 1) - ((~~($1.lbit / 2)) % $1.lwid); /*18538*/
					if ($1.cmv() == $b) return $b; /*18538*/
				} /*18538*/
				if ($1.ldir == 2) { /*18544*/
					$k[$j++] = -(((-(~~($1.lwid / 2))) + 1) + ((~~($1.lbit / 2)) % $1.lwid)); /*18543*/
					$k[$j++] = -(((~~($1.fw / 2)) + ($1.llyr * 2)) + ($1.lbit % 2)); /*18543*/
					if ($1.cmv() == $b) return $b; /*18543*/
				} /*18543*/
				if ($1.ldir == 3) { /*18549*/
					$k[$j++] = -(((~~(($1.fw - 1) / 2)) + ($1.llyr * 2)) + ($1.lbit % 2)); /*18548*/
					$k[$j++] = -(((~~($1.lwid / 2)) - 1) - ((~~($1.lbit / 2)) % $1.lwid)); /*18548*/
					if ($1.cmv() == $b) return $b; /*18548*/
				} /*18548*/
			}; /*18550*/
			if ($eq($1.format, "full")) { /*18554*/
				$1.fw = 12; /*18554*/
			} else { /*18554*/
				$1.fw = 9; /*18554*/
			} /*18554*/
			$1.size = ($1.fw + ($1.layers * 4)) + 2; /*18555*/
			$k[$j++] = Infinity; /*18556*/
			for (var _FM = 0, _FN = $1.size * $1.size; _FM < _FN; _FM++) { /*18556*/
				$k[$j++] = -1; /*18556*/
			} /*18556*/
			$1.pixs = $a(); /*18556*/
			$1.mid = ((~~(($1.size - 1) / 2)) * $1.size) + (~~(($1.size - 1) / 2)); /*18557*/
			$1.i = 0; /*18560*/
			for (var _FU = 1, _FT = $1.layers; _FU <= _FT; _FU += 1) { /*18568*/
				$1.layer = _FU; /*18562*/
				for (var _FY = 0, _FX = (($1.fw + ($1.layer * 4)) * 8) - 1; _FY <= _FX; _FY += 1) { /*18567*/
					$1.pos = _FY; /*18564*/
					$k[$j++] = $1.pixs; /*18565*/
					$k[$j++] = $1.layer; /*18565*/
					$k[$j++] = $1.pos; /*18565*/
					if ($1.lmv() == $b) break; /*18565*/
					var _Fg = $k[--$j]; /*18565*/
					$put($k[--$j], _Fg, $get($1.databits, ($1.databits.length - $1.i) - 1) - 48); /*18565*/
					$1.i = $1.i + 1; /*18566*/
				} /*18566*/
			} /*18566*/
			if ($eq($1.format, "full")) { /*18595*/
				$1.fw = 13; /*18572*/
				$1.size = (($1.fw + ($1.layers * 4)) + 2) + ((~~((($1.layers + 10.5) / 7.5) - 1)) * 2); /*18573*/
				$1.mid = ~~(($1.size * $1.size) / 2); /*18574*/
				$k[$j++] = Infinity; /*18575*/
				for (var _Fr = 0, _Fs = $1.size * $1.size; _Fr < _Fs; _Fr++) { /*18575*/
					$k[$j++] = -2; /*18575*/
				} /*18575*/
				$1.npixs = $a(); /*18575*/
				for (var _Fw = 0, _Fv = ~~($1.size / 2); _Fw <= _Fv; _Fw += 16) { /*18585*/
					$1.i = _Fw; /*18577*/
					for (var _Fz = 0, _Fy = $1.size - 1; _Fz <= _Fy; _Fz += 1) { /*18584*/
						$1.j = _Fz; /*18579*/
						$k[$j++] = $1.npixs; /*18580*/
						$k[$j++] = (-(~~($1.size / 2))) + $1.j; /*18580*/
						$k[$j++] = $1.i; /*18580*/
						if ($1.cmv() == $b) break; /*18580*/
						var _G8 = $k[--$j]; /*18580*/
						$puti($k[--$j], _G8, $a([((((~~($1.size / 2)) + $1.j) + $1.i) + 1) % 2])); /*18580*/
						$k[$j++] = $1.npixs; /*18581*/
						$k[$j++] = (-(~~($1.size / 2))) + $1.j; /*18581*/
						$k[$j++] = -$1.i; /*18581*/
						if ($1.cmv() == $b) break; /*18581*/
						var _GI = $k[--$j]; /*18581*/
						$puti($k[--$j], _GI, $a([((((~~($1.size / 2)) + $1.j) + $1.i) + 1) % 2])); /*18581*/
						$k[$j++] = $1.npixs; /*18582*/
						$k[$j++] = $1.i; /*18582*/
						$k[$j++] = (-(~~($1.size / 2))) + $1.j; /*18582*/
						if ($1.cmv() == $b) break; /*18582*/
						var _GS = $k[--$j]; /*18582*/
						$puti($k[--$j], _GS, $a([((((~~($1.size / 2)) + $1.j) + $1.i) + 1) % 2])); /*18582*/
						$k[$j++] = $1.npixs; /*18583*/
						$k[$j++] = -$1.i; /*18583*/
						$k[$j++] = (-(~~($1.size / 2))) + $1.j; /*18583*/
						if ($1.cmv() == $b) break; /*18583*/
						var _Gc = $k[--$j]; /*18583*/
						$puti($k[--$j], _Gc, $a([((((~~($1.size / 2)) + $1.j) + $1.i) + 1) % 2])); /*18583*/
					} /*18583*/
				} /*18583*/
				$1.j = 0; /*18586*/
				for (var _Gg = 0, _Gf = $1.npixs.length - 1; _Gg <= _Gf; _Gg += 1) { /*18593*/
					$1.i = _Gg; /*18588*/
					if ($get($1.npixs, $1.i) == -2) { /*18592*/
						$put($1.npixs, $1.i, $get($1.pixs, $1.j)); /*18590*/
						$1.j = $1.j + 1; /*18591*/
					} /*18591*/
				} /*18591*/
				$1.pixs = $1.npixs; /*18594*/
			} /*18594*/
			$1.fw = ~~($1.fw / 2); /*18598*/
			for (var _Gv = -$1.fw, _Gu = $1.fw; _Gv <= _Gu; _Gv += 1) { /*18607*/
				$1.i = _Gv; /*18600*/
				for (var _Gz = -$1.fw, _Gy = $1.fw; _Gz <= _Gy; _Gz += 1) { /*18606*/
					$1.j = _Gz; /*18602*/
					$k[$j++] = $1.pixs; /*18603*/
					$k[$j++] = $1.i; /*18603*/
					$k[$j++] = $1.j; /*18603*/
					if ($1.cmv() == $b) break; /*18603*/
					if (Math.abs($1.i) > Math.abs($1.j)) { /*18604*/
						$k[$j++] = Math.abs($1.i); /*18604*/
					} else { /*18604*/
						$k[$j++] = Math.abs($1.j); /*18604*/
					} /*18604*/
					var _H7 = $k[--$j]; /*18604*/
					var _H8 = $k[--$j]; /*18605*/
					$put($k[--$j], _H8, (_H7 + 1) % 2); /*18605*/
				} /*18605*/
			} /*18605*/
			var _Hk = $a([$a([-($1.fw + 1), $1.fw, 1]), $a([-($1.fw + 1), $1.fw + 1, 1]), $a([-$1.fw, $1.fw + 1, 1]), $a([$1.fw + 1, $1.fw + 1, 1]), $a([$1.fw + 1, $1.fw, 1]), $a([$1.fw + 1, -$1.fw, 1]), $a([$1.fw, $1.fw + 1, 0]), $a([$1.fw + 1, -($1.fw + 1), 0]), $a([$1.fw, -($1.fw + 1), 0]), $a([-$1.fw, -($1.fw + 1), 0]), $a([-($1.fw + 1), -($1.fw + 1), 0]), $a([-($1.fw + 1), -$1.fw, 0])]); /*18615*/
			for (var _Hl = 0, _Hm = _Hk.length; _Hl < _Hm; _Hl++) { /*18616*/
				$k[$j++] = $1.pixs; /*18616*/
				$forall($get(_Hk, _Hl)); /*18616*/
				var _Hp = $k[--$j]; /*18616*/
				var _Hq = $k[--$j]; /*18616*/
				var _Hr = $k[--$j]; /*18616*/
				$k[$j++] = _Hp; /*18616*/
				$k[$j++] = _Hr; /*18616*/
				$k[$j++] = _Hq; /*18616*/
				if ($1.cmv() == $b) return $b; /*18616*/
				var _Hs = $k[--$j]; /*18616*/
				var _Ht = $k[--$j]; /*18616*/
				$put($k[--$j], _Hs, _Ht); /*18616*/
			} /*18616*/
			if ($eq($1.format, "full")) { /*18632*/
				$1.modemap = $a([$a([-5, 7]), $a([-4, 7]), $a([-3, 7]), $a([-2, 7]), $a([-1, 7]), $a([1, 7]), $a([2, 7]), $a([3, 7]), $a([4, 7]), $a([5, 7]), $a([7, 5]), $a([7, 4]), $a([7, 3]), $a([7, 2]), $a([7, 1]), $a([7, -1]), $a([7, -2]), $a([7, -3]), $a([7, -4]), $a([7, -5]), $a([5, -7]), $a([4, -7]), $a([3, -7]), $a([2, -7]), $a([1, -7]), $a([-1, -7]), $a([-2, -7]), $a([-3, -7]), $a([-4, -7]), $a([-5, -7]), $a([-7, -5]), $a([-7, -4]), $a([-7, -3]), $a([-7, -2]), $a([-7, -1]), $a([-7, 1]), $a([-7, 2]), $a([-7, 3]), $a([-7, 4]), $a([-7, 5])]); /*18625*/
			} else { /*18632*/
				$1.modemap = $a([$a([-3, 5]), $a([-2, 5]), $a([-1, 5]), $a([0, 5]), $a([1, 5]), $a([2, 5]), $a([3, 5]), $a([5, 3]), $a([5, 2]), $a([5, 1]), $a([5, 0]), $a([5, -1]), $a([5, -2]), $a([5, -3]), $a([3, -5]), $a([2, -5]), $a([1, -5]), $a([0, -5]), $a([-1, -5]), $a([-2, -5]), $a([-3, -5]), $a([-5, -3]), $a([-5, -2]), $a([-5, -1]), $a([-5, 0]), $a([-5, 1]), $a([-5, 2]), $a([-5, 3])]); /*18632*/
			} /*18632*/
			for (var _J6 = 0, _J5 = $1.modemap.length - 1; _J6 <= _J5; _J6 += 1) { /*18637*/
				$1.i = _J6; /*18635*/
				$k[$j++] = $1.pixs; /*18636*/
				$forall($get($1.modemap, $1.i)); /*18636*/
				if ($1.cmv() == $b) break; /*18636*/
				var _JE = $k[--$j]; /*18636*/
				$put($k[--$j], _JE, $get($1.modebits, $1.i) - 48); /*18636*/
			} /*18636*/
			var _JM = {
				ren: $0.renmatrix,
				pixs: $1.pixs,
				pixx: $1.size,
				pixy: $1.size,
				height: ($1.size * 2) / 72,
				width: ($1.size * 2) / 72,
				opt: $1.options
			}; /*18646*/
			$k[$j++] = _JM; /*18649*/
			if (!$1.dontdraw) { /*18649*/
				$0.renmatrix(); /*18649*/
			} /*18649*/
		};
		$0.azteccodecompact = function() {
			var $1 = {}; /*18677*/
			$1.options = $k[--$j]; /*18679*/
			$1.barcode = $k[--$j]; /*18680*/
			$1.dontdraw = false; /*18682*/
			$forall($1.options, function() { /*18693*/
				var _3 = $k[--$j]; /*18693*/
				$1[$k[--$j]] = _3; /*18693*/
			}); /*18693*/
			$1.options.dontdraw = true; /*18696*/
			$1.options.format = "compact"; /*18697*/
			$k[$j++] = "args"; /*18699*/
			$k[$j++] = $1.barcode; /*18699*/
			$k[$j++] = $1.options; /*18699*/
			$0.azteccode(); /*18699*/
			var _9 = $k[--$j]; /*18699*/
			$1[$k[--$j]] = _9; /*18699*/
			$1.args.opt = $1.options; /*18701*/
			$k[$j++] = $1.args; /*18704*/
			if (!$1.dontdraw) { /*18704*/
				$0.renmatrix(); /*18704*/
			} /*18704*/
		};
		$0.aztecrune = function() {
			var $1 = {}; /*18732*/
			$1.options = $k[--$j]; /*18734*/
			$1.barcode = $k[--$j]; /*18735*/
			$1.dontdraw = false; /*18737*/
			$forall($1.options, function() { /*18748*/
				var _3 = $k[--$j]; /*18748*/
				$1[$k[--$j]] = _3; /*18748*/
			}); /*18748*/
			$1.options.dontdraw = true; /*18751*/
			$1.options.format = "rune"; /*18752*/
			$k[$j++] = "args"; /*18754*/
			$k[$j++] = $1.barcode; /*18754*/
			$k[$j++] = $1.options; /*18754*/
			$0.azteccode(); /*18754*/
			var _9 = $k[--$j]; /*18754*/
			$1[$k[--$j]] = _9; /*18754*/
			$1.args.opt = $1.options; /*18756*/
			$k[$j++] = $1.args; /*18759*/
			if (!$1.dontdraw) { /*18759*/
				$0.renmatrix(); /*18759*/
			} /*18759*/
		};
		$0.codeone = function() {
			var $1 = {}; /*18786*/
			$1.options = $k[--$j]; /*18788*/
			$1.barcode = $k[--$j]; /*18789*/
			$1.dontdraw = false; /*18791*/
			$1.version = "unset"; /*18792*/
			$1.parse = false; /*18793*/
			$1.parsefnc = false; /*18794*/
			$forall($1.options, function() { /*18805*/
				var _3 = $k[--$j]; /*18805*/
				$1[$k[--$j]] = _3; /*18805*/
			}); /*18805*/
			$1.barlen = $1.barcode.length; /*18828*/
			$1.stype = $eq($geti($1.version, 0, 1), "S"); /*18830*/
			if ($1.stype) { /*19420*/
				$1.vals = $a(["1", "1010", "1100100", "1111101000", "10011100010000", "11000011010100000", "11110100001001000000", "100110001001011010000000", "101111101011110000100000000", "111011100110101100101000000000", "1001010100000010111110010000000000", "1011101001000011101101110100000000000", "1110100011010100101001010001000000000000", "10010001100001001110011100101010000000000000", "10110101111001100010000011110100100000000000000", "11100011010111111010100100110001101000000000000000", "100011100001101111001001101111110000010000000000000000", "101100011010001010111100001011101100010100000000000000000"]); /*18852*/
				$1.normalize = function() {
					$1.base = $k[--$j]; /*18855*/
					$1.num = $k[--$j]; /*18856*/
					for (var _D = $1.num.length - 1; _D >= 1; _D -= 1) { /*18861*/
						$1.i = _D; /*18858*/
						var _E = $1.num; /*18859*/
						var _F = $1.i; /*18859*/
						$put(_E, _F - 1, $get(_E, _F - 1) + (~~($get($1.num, $1.i) / $1.base))); /*18859*/
						$put($1.num, $1.i, $get($1.num, $1.i) % $1.base); /*18860*/
					} /*18860*/
					for (;;) { /*18867*/
						if ($lt($get($1.num, 0), $1.base)) { /*18863*/
							break; /*18863*/
						} /*18863*/
						$k[$j++] = Infinity; /*18864*/
						$k[$j++] = 0; /*18864*/
						$forall($1.num); /*18864*/
						$1.num = $a(); /*18864*/
						$put($1.num, 0, $get($1.num, 0) + (~~($get($1.num, 1) / $1.base))); /*18865*/
						$put($1.num, 1, $get($1.num, 1) % $1.base); /*18866*/
					} /*18866*/
					$k[$j++] = Infinity; /*18869*/
					$1.i = true; /*18869*/
					var _g = $1.num; /*18869*/
					for (var _h = 0, _i = _g.length; _h < _i; _h++) { /*18869*/
						var _j = $get(_g, _h); /*18869*/
						$k[$j++] = _j; /*18869*/
						if ((_j == 0) && $1.i) { /*18869*/
							$j--; /*18869*/
						} else { /*18869*/
							$1.i = false; /*18869*/
						} /*18869*/
					} /*18869*/
					$1.num = $a(); /*18869*/
					if ($1.num.length == 0) { /*18870*/
						$1.num = $a([0]); /*18870*/
					} /*18870*/
					$k[$j++] = $1.num; /*18871*/
				}; /*18872*/
				$1.bigadd = function() {
					var _p = $k[--$j]; /*18875*/
					var _q = $k[--$j]; /*18875*/
					$1.offset = Math.abs(_p.length - _q.length); /*18876*/
					if (_p.length < _q.length) { /*18877*/
						var _ = _p; /*18877*/
						_p = _q; /*18877*/
						_q = _; /*18877*/
					} /*18877*/
					$1.a = _p; /*18878*/
					$1.b = _q; /*18878*/
					for (var _t = 0, _s = $1.b.length - 1; _t <= _s; _t += 1) { /*18881*/
						var _u = $1.a; /*18880*/
						var _v = $1.offset; /*18880*/
						$put(_u, _t + _v, $get(_u, _t + _v) + $get($1.b, _t)); /*18880*/
					} /*18880*/
					$k[$j++] = $1.a; /*18882*/
				}; /*18883*/
				$1.v = $a([1]); /*18886*/
				for (var _13 = 0, _12 = $1.barlen - 1; _13 <= _12; _13 += 1) { /*18891*/
					$1.i = _13; /*18888*/
					$k[$j++] = Infinity; /*18889*/
					$forall($get($1.vals, $1.i), function() { /*18889*/
						var _17 = $k[--$j]; /*18889*/
						$k[$j++] = (_17 - 48) * ($get($1.barcode, ($1.barlen - $1.i) - 1) - 48); /*18889*/
					}); /*18889*/
					var _1C = $a(); /*18889*/
					$k[$j++] = _1C; /*18890*/
					$k[$j++] = $1.v; /*18890*/
					if ($1.bigadd() == $b) break; /*18890*/
					$1.v = $k[--$j]; /*18890*/
				} /*18890*/
				$k[$j++] = "v"; /*18892*/
				$k[$j++] = $1.v; /*18892*/
				$k[$j++] = 2; /*18892*/
				if ($1.normalize() == $b) return $b; /*18892*/
				var _1G = $k[--$j]; /*18892*/
				$1[$k[--$j]] = _1G; /*18892*/
				$k[$j++] = Infinity; /*18895*/
				for (var _1J = 0, _1K = (5 - ($1.v.length % 5)) % 5; _1J < _1K; _1J++) { /*18895*/
					$k[$j++] = 0; /*18895*/
				} /*18895*/
				$aload($1.v); /*18895*/
				$1.v = $a(); /*18895*/
				$1.cws = $a(~~($1.v.length / 5)); /*18896*/
				for (var _1R = 0, _1Q = $1.cws.length - 1; _1R <= _1Q; _1R += 1) { /*18902*/
					$1.i = _1R; /*18898*/
					$k[$j++] = 0; /*18900*/
					$forall($geti($1.v, $1.i * 5, 5), function() { /*18900*/
						var _1V = $k[--$j]; /*18900*/
						var _1W = $k[--$j]; /*18900*/
						$k[$j++] = (_1W + _1V) * 2; /*18900*/
					}); /*18900*/
					$put($1.cws, $1.i, ~~($k[--$j] / 2)); /*18901*/
				} /*18901*/
				$1.metrics = $a([$a(["S-10", 8, 11, 10, 4, 4, 1, 99, 99, 99]), $a(["S-20", 8, 21, 20, 8, 8, 1, 99, 99, 99]), $a(["S-30", 8, 31, 30, 12, 12, 1, 99, 99, 99])]); /*18910*/
			} else { /*19420*/
				$1.fnc1 = -1; /*18915*/
				$1.fnc3 = -2; /*18915*/
				var _1g = {
					FNC1: $1.fnc1,
					FNC3: $1.fnc3
				}; /*18918*/
				$1.fncvals = _1g; /*18919*/
				$1.msg = $a($1.barlen); /*18920*/
				$1.i = 0; /*18921*/
				$1.j = 0; /*18921*/
				for (;;) { /*18935*/
					if ($1.i == $1.barlen) { /*18922*/
						break; /*18922*/
					} /*18922*/
					$1.char = $get($1.barcode, $1.i); /*18923*/
					if (($1.parsefnc && ($1.char == 94)) && ($1.i < ($1.barlen - 4))) { /*18931*/
						if ($get($1.barcode, $1.i + 1) != 94) { /*18929*/
							$1.char = $get($1.fncvals, $geti($1.barcode, $1.i + 1, 4)); /*18926*/
							$1.i = $1.i + 4; /*18927*/
						} else { /*18929*/
							$1.i = $1.i + 1; /*18929*/
						} /*18929*/
					} /*18929*/
					$put($1.msg, $1.j, $1.char); /*18932*/
					$1.i = $1.i + 1; /*18933*/
					$1.j = $1.j + 1; /*18934*/
				} /*18934*/
				$1.msg = $geti($1.msg, 0, $1.j); /*18936*/
				$1.msglen = $1.msg.length; /*18937*/
				$1.metrics = $a([$a(["A", 16, 18, 16, 10, 10, 1, 4, 99, 6]), $a(["B", 22, 22, 20, 19, 16, 1, 4, 99, 8]), $a(["C", 28, 32, 28, 44, 26, 1, 4, 22, 11]), $a(["D", 40, 42, 36, 91, 44, 1, 4, 16, 16]), $a(["E", 52, 54, 48, 182, 70, 1, 4, 22, 22]), $a(["F", 70, 76, 68, 370, 140, 2, 4, 22, 31]), $a(["G", 104, 98, 88, 732, 280, 4, 6, 21, 47]), $a(["H", 148, 134, 120, 1480, 560, 8, 6, 20, 69]), $a(["T-16", 16, 17, 16, 10, 10, 1, 99, 99, 99]), $a(["T-32", 16, 33, 32, 24, 16, 1, 99, 99, 99]), $a(["T-48", 16, 49, 48, 38, 22, 1, 99, 99, 99])]); /*18953*/
				$1.fullcws = $a([]); /*18956*/
				var _2O = $1.metrics; /*18957*/
				for (var _2P = 0, _2Q = _2O.length; _2P < _2Q; _2P++) { /*18968*/
					$1.m = $get(_2O, _2P); /*18958*/
					$1.vers = $get($1.m, 0); /*18959*/
					$1.dcws = $get($1.m, 4); /*18960*/
					$1.okay = true; /*18961*/
					if ($eq($1.version, "unset")) { /*18965*/
						if ($1.vers.length != 1) { /*18963*/
							$1.okay = false; /*18963*/
						} /*18963*/
					} else { /*18965*/
						if ($ne($1.version, $1.vers)) { /*18965*/
							$1.okay = false; /*18965*/
						} /*18965*/
					} /*18965*/
					if ($1.okay) { /*18967*/
						$k[$j++] = Infinity; /*18967*/
						$aload($1.fullcws); /*18967*/
						$k[$j++] = $1.dcws; /*18967*/
						$1.fullcws = $a(); /*18967*/
					} /*18967*/
				} /*18967*/
				$k[$j++] = Infinity; /*18969*/
				for (var _2e = 0, _2f = 1480; _2e < _2f; _2e++) { /*18969*/
					$k[$j++] = 10000; /*18969*/
				} /*18969*/
				$1.numremcws = $a(); /*18969*/
				var _2h = $1.fullcws; /*18970*/
				for (var _2i = 0, _2j = _2h.length; _2i < _2j; _2i++) { /*18970*/
					$put($1.numremcws, $get(_2h, _2i) - 1, 1); /*18970*/
				} /*18970*/
				for (var _2m = 1478; _2m >= 0; _2m -= 1) { /*18976*/
					$1.i = _2m; /*18972*/
					if ($get($1.numremcws, $1.i) != 1) { /*18975*/
						$put($1.numremcws, $1.i, $get($1.numremcws, $1.i + 1) + 1); /*18974*/
					} /*18974*/
				} /*18974*/
				$1.lC = -5; /*18979*/
				$1.lB = -6; /*18979*/
				$1.lX = -7; /*18979*/
				$1.lT = -8; /*18979*/
				$1.lD = -9; /*18979*/
				$1.unl = -10; /*18979*/
				$1.fnc2 = -11; /*18980*/
				$1.fnc4 = -12; /*18980*/
				$1.sft1 = -13; /*18980*/
				$1.sft2 = -14; /*18980*/
				$1.sft3 = -15; /*18980*/
				$1.eci = -16; /*18980*/
				$1.pad = -17; /*18980*/
				$1.fnc1lD = -18; /*18980*/
				$1.unlcw = 255; /*18981*/
				$k[$j++] = "Avals"; /*18992*/
				$k[$j++] = Infinity; /*18992*/
				for (var _2v = 0; _2v <= 128; _2v += 1) { /*18984*/
					$k[$j++] = _2v; /*18984*/
					$k[$j++] = _2v + 1; /*18984*/
				} /*18984*/
				$k[$j++] = $1.pad; /*18989*/
				$k[$j++] = 129; /*18989*/
				for (var _2x = 0; _2x <= 99; _2x += 1) { /*18989*/
					var _2z = $cvrs($s(2), _2x, 10); /*18987*/
					var _31 = $strcpy($s(2), "00"); /*18987*/
					$puti(_31, 2 - _2z.length, _2z); /*18987*/
					$k[$j++] = _31; /*18988*/
					$k[$j++] = _2x + 130; /*18988*/
				} /*18988*/
				var _39 = $a([$1.lC, $1.lB, $1.fnc1, $1.fnc2, $1.fnc3, $1.fnc4, $1.fnc1lD]); /*18990*/
				$k[$j++] = 229; /*18990*/
				for (var _3A = 0, _3B = _39.length; _3A < _3B; _3A++) { /*18990*/
					var _3E = $k[--$j] + 1; /*18990*/
					$k[$j++] = $get(_39, _3A); /*18990*/
					$k[$j++] = _3E; /*18990*/
					$k[$j++] = _3E; /*18990*/
				} /*18990*/
				$j--; /*18990*/
				$k[$j++] = $1.lX; /*18992*/
				$k[$j++] = 238; /*18992*/
				$k[$j++] = $1.lT; /*18992*/
				$k[$j++] = 239; /*18992*/
				var _3H = $d(); /*18992*/
				$1[$k[--$j]] = _3H; /*18994*/
				$k[$j++] = "Avals"; /*18996*/
				$k[$j++] = Infinity; /*18996*/
				$forall($1.Avals, function() { /*18996*/
					$k[$j++] = Infinity; /*18996*/
					var _3K = $k[--$j]; /*18996*/
					var _3L = $k[--$j]; /*18996*/
					$k[$j++] = _3K; /*18996*/
					$k[$j++] = _3L; /*18996*/
					var _3M = $a(); /*18996*/
					$k[$j++] = _3M; /*18996*/
				}); /*18996*/
				var _3N = $d(); /*18996*/
				$1[$k[--$j]] = _3N; /*18997*/
				$k[$j++] = "CNvals"; /*19005*/
				$k[$j++] = Infinity; /*19005*/
				$k[$j++] = $1.sft1; /*19004*/
				$k[$j++] = 0; /*19004*/
				$k[$j++] = $1.sft2; /*19004*/
				$k[$j++] = 1; /*19004*/
				$k[$j++] = $1.sft3; /*19004*/
				$k[$j++] = 2; /*19004*/
				$k[$j++] = 32; /*19004*/
				$k[$j++] = 3; /*19004*/
				for (var _3S = 48; _3S <= 57; _3S += 1) { /*19004*/
					$k[$j++] = _3S; /*19004*/
					$k[$j++] = _3S - 44; /*19004*/
				} /*19004*/
				for (var _3T = 65; _3T <= 90; _3T += 1) { /*19005*/
					$k[$j++] = _3T; /*19005*/
					$k[$j++] = _3T - 51; /*19005*/
				} /*19005*/
				var _3U = $d(); /*19005*/
				$1[$k[--$j]] = _3U; /*19006*/
				$k[$j++] = "C1vals"; /*19007*/
				$k[$j++] = Infinity; /*19007*/
				for (var _3W = 0; _3W <= 31; _3W += 1) { /*19007*/
					$k[$j++] = _3W; /*19007*/
					$k[$j++] = _3W; /*19007*/
				} /*19007*/
				var _3X = $d(); /*19007*/
				$1[$k[--$j]] = _3X; /*19007*/
				$k[$j++] = "C2vals"; /*19016*/
				$k[$j++] = Infinity; /*19016*/
				for (var _3Z = 33; _3Z <= 47; _3Z += 1) { /*19009*/
					$k[$j++] = _3Z; /*19009*/
					$k[$j++] = _3Z - 33; /*19009*/
				} /*19009*/
				for (var _3a = 58; _3a <= 64; _3a += 1) { /*19010*/
					$k[$j++] = _3a; /*19010*/
					$k[$j++] = _3a - 43; /*19010*/
				} /*19010*/
				for (var _3b = 91; _3b <= 95; _3b += 1) { /*19011*/
					$k[$j++] = _3b; /*19011*/
					$k[$j++] = _3b - 69; /*19011*/
				} /*19011*/
				$k[$j++] = $1.fnc1; /*19016*/
				$k[$j++] = 27; /*19016*/
				$k[$j++] = $1.fnc2; /*19016*/
				$k[$j++] = 28; /*19016*/
				$k[$j++] = $1.fnc3; /*19016*/
				$k[$j++] = 29; /*19016*/
				$k[$j++] = $1.fnc4; /*19016*/
				$k[$j++] = 30; /*19016*/
				$k[$j++] = $1.pad; /*19016*/
				$k[$j++] = 31; /*19016*/
				var _3h = $d(); /*19016*/
				$1[$k[--$j]] = _3h; /*19017*/
				$k[$j++] = "C3vals"; /*19018*/
				$k[$j++] = Infinity; /*19018*/
				for (var _3j = 96; _3j <= 127; _3j += 1) { /*19018*/
					$k[$j++] = _3j; /*19018*/
					$k[$j++] = _3j - 96; /*19018*/
				} /*19018*/
				var _3k = $d(); /*19018*/
				$1[$k[--$j]] = _3k; /*19018*/
				$k[$j++] = "Cvals"; /*19023*/
				$k[$j++] = Infinity; /*19023*/
				$forall($1.CNvals, function() { /*19020*/
					$k[$j++] = Infinity; /*19020*/
					var _3n = $k[--$j]; /*19020*/
					var _3o = $k[--$j]; /*19020*/
					$k[$j++] = _3n; /*19020*/
					$k[$j++] = _3o; /*19020*/
					var _3p = $a(); /*19020*/
					$k[$j++] = _3p; /*19020*/
				}); /*19020*/
				$forall($1.C1vals, function() { /*19021*/
					$k[$j++] = Infinity; /*19021*/
					var _3r = $k[--$j]; /*19021*/
					var _3s = $k[--$j]; /*19021*/
					$k[$j++] = _3r; /*19021*/
					$k[$j++] = $get($1.CNvals, $1.sft1); /*19021*/
					$k[$j++] = _3s; /*19021*/
					var _3w = $a(); /*19021*/
					$k[$j++] = _3w; /*19021*/
				}); /*19021*/
				$forall($1.C2vals, function() { /*19022*/
					$k[$j++] = Infinity; /*19022*/
					var _3y = $k[--$j]; /*19022*/
					var _3z = $k[--$j]; /*19022*/
					$k[$j++] = _3y; /*19022*/
					$k[$j++] = $get($1.CNvals, $1.sft2); /*19022*/
					$k[$j++] = _3z; /*19022*/
					var _43 = $a(); /*19022*/
					$k[$j++] = _43; /*19022*/
				}); /*19022*/
				$forall($1.C3vals, function() { /*19023*/
					$k[$j++] = Infinity; /*19023*/
					var _45 = $k[--$j]; /*19023*/
					var _46 = $k[--$j]; /*19023*/
					$k[$j++] = _45; /*19023*/
					$k[$j++] = $get($1.CNvals, $1.sft3); /*19023*/
					$k[$j++] = _46; /*19023*/
					var _4A = $a(); /*19023*/
					$k[$j++] = _4A; /*19023*/
				}); /*19023*/
				var _4B = $d(); /*19023*/
				$1[$k[--$j]] = _4B; /*19024*/
				$k[$j++] = "TNvals"; /*19032*/
				$k[$j++] = Infinity; /*19032*/
				$k[$j++] = $1.sft1; /*19031*/
				$k[$j++] = 0; /*19031*/
				$k[$j++] = $1.sft2; /*19031*/
				$k[$j++] = 1; /*19031*/
				$k[$j++] = $1.sft3; /*19031*/
				$k[$j++] = 2; /*19031*/
				$k[$j++] = 32; /*19031*/
				$k[$j++] = 3; /*19031*/
				for (var _4G = 48; _4G <= 57; _4G += 1) { /*19031*/
					$k[$j++] = _4G; /*19031*/
					$k[$j++] = _4G - 44; /*19031*/
				} /*19031*/
				for (var _4H = 97; _4H <= 122; _4H += 1) { /*19032*/
					$k[$j++] = _4H; /*19032*/
					$k[$j++] = _4H - 83; /*19032*/
				} /*19032*/
				var _4I = $d(); /*19032*/
				$1[$k[--$j]] = _4I; /*19033*/
				$k[$j++] = "T1vals"; /*19034*/
				$k[$j++] = Infinity; /*19034*/
				for (var _4K = 0; _4K <= 31; _4K += 1) { /*19034*/
					$k[$j++] = _4K; /*19034*/
					$k[$j++] = _4K; /*19034*/
				} /*19034*/
				var _4L = $d(); /*19034*/
				$1[$k[--$j]] = _4L; /*19034*/
				$k[$j++] = "T2vals"; /*19043*/
				$k[$j++] = Infinity; /*19043*/
				for (var _4N = 33; _4N <= 47; _4N += 1) { /*19036*/
					$k[$j++] = _4N; /*19036*/
					$k[$j++] = _4N - 33; /*19036*/
				} /*19036*/
				for (var _4O = 58; _4O <= 64; _4O += 1) { /*19037*/
					$k[$j++] = _4O; /*19037*/
					$k[$j++] = _4O - 43; /*19037*/
				} /*19037*/
				for (var _4P = 91; _4P <= 95; _4P += 1) { /*19038*/
					$k[$j++] = _4P; /*19038*/
					$k[$j++] = _4P - 69; /*19038*/
				} /*19038*/
				$k[$j++] = $1.fnc1; /*19043*/
				$k[$j++] = 27; /*19043*/
				$k[$j++] = $1.fnc2; /*19043*/
				$k[$j++] = 28; /*19043*/
				$k[$j++] = $1.fnc3; /*19043*/
				$k[$j++] = 29; /*19043*/
				$k[$j++] = $1.fnc4; /*19043*/
				$k[$j++] = 30; /*19043*/
				$k[$j++] = $1.pad; /*19043*/
				$k[$j++] = 31; /*19043*/
				var _4V = $d(); /*19043*/
				$1[$k[--$j]] = _4V; /*19044*/
				$k[$j++] = "T3vals"; /*19048*/
				$k[$j++] = Infinity; /*19048*/
				$k[$j++] = 96; /*19047*/
				$k[$j++] = 0; /*19047*/
				for (var _4X = 65; _4X <= 90; _4X += 1) { /*19047*/
					$k[$j++] = _4X; /*19047*/
					$k[$j++] = _4X - 64; /*19047*/
				} /*19047*/
				for (var _4Y = 123; _4Y <= 127; _4Y += 1) { /*19048*/
					$k[$j++] = _4Y; /*19048*/
					$k[$j++] = _4Y - 96; /*19048*/
				} /*19048*/
				var _4Z = $d(); /*19048*/
				$1[$k[--$j]] = _4Z; /*19049*/
				$k[$j++] = "Tvals"; /*19054*/
				$k[$j++] = Infinity; /*19054*/
				$forall($1.TNvals, function() { /*19051*/
					$k[$j++] = Infinity; /*19051*/
					var _4c = $k[--$j]; /*19051*/
					var _4d = $k[--$j]; /*19051*/
					$k[$j++] = _4c; /*19051*/
					$k[$j++] = _4d; /*19051*/
					var _4e = $a(); /*19051*/
					$k[$j++] = _4e; /*19051*/
				}); /*19051*/
				$forall($1.T1vals, function() { /*19052*/
					$k[$j++] = Infinity; /*19052*/
					var _4g = $k[--$j]; /*19052*/
					var _4h = $k[--$j]; /*19052*/
					$k[$j++] = _4g; /*19052*/
					$k[$j++] = $get($1.TNvals, $1.sft1); /*19052*/
					$k[$j++] = _4h; /*19052*/
					var _4l = $a(); /*19052*/
					$k[$j++] = _4l; /*19052*/
				}); /*19052*/
				$forall($1.T2vals, function() { /*19053*/
					$k[$j++] = Infinity; /*19053*/
					var _4n = $k[--$j]; /*19053*/
					var _4o = $k[--$j]; /*19053*/
					$k[$j++] = _4n; /*19053*/
					$k[$j++] = $get($1.TNvals, $1.sft2); /*19053*/
					$k[$j++] = _4o; /*19053*/
					var _4s = $a(); /*19053*/
					$k[$j++] = _4s; /*19053*/
				}); /*19053*/
				$forall($1.T3vals, function() { /*19054*/
					$k[$j++] = Infinity; /*19054*/
					var _4u = $k[--$j]; /*19054*/
					var _4v = $k[--$j]; /*19054*/
					$k[$j++] = _4u; /*19054*/
					$k[$j++] = $get($1.TNvals, $1.sft3); /*19054*/
					$k[$j++] = _4v; /*19054*/
					var _4z = $a(); /*19054*/
					$k[$j++] = _4z; /*19054*/
				}); /*19054*/
				var _50 = $d(); /*19054*/
				$1[$k[--$j]] = _50; /*19055*/
				for (var _52 = 128; _52 <= 255; _52 += 1) { /*19063*/
					$1.i = _52; /*19059*/
					$k[$j++] = $1.Avals; /*19060*/
					$k[$j++] = $1.i; /*19060*/
					$k[$j++] = Infinity; /*19060*/
					$aload($get($1.Avals, $1.fnc4)); /*19060*/
					$aload($get($1.Avals, $1.i - 128)); /*19060*/
					var _5B = $a(); /*19060*/
					var _5C = $k[--$j]; /*19060*/
					$put($k[--$j], _5C, _5B); /*19060*/
					$k[$j++] = $1.Cvals; /*19061*/
					$k[$j++] = $1.i; /*19061*/
					$k[$j++] = Infinity; /*19061*/
					$aload($get($1.Cvals, $1.fnc4)); /*19061*/
					$aload($get($1.Cvals, $1.i - 128)); /*19061*/
					var _5M = $a(); /*19061*/
					var _5N = $k[--$j]; /*19061*/
					$put($k[--$j], _5N, _5M); /*19061*/
					$k[$j++] = $1.Tvals; /*19062*/
					$k[$j++] = $1.i; /*19062*/
					$k[$j++] = Infinity; /*19062*/
					$aload($get($1.Tvals, $1.fnc4)); /*19062*/
					$aload($get($1.Tvals, $1.i - 128)); /*19062*/
					var _5X = $a(); /*19062*/
					var _5Y = $k[--$j]; /*19062*/
					$put($k[--$j], _5Y, _5X); /*19062*/
				} /*19062*/
				$k[$j++] = "Xvals"; /*19071*/
				$k[$j++] = Infinity; /*19071*/
				$k[$j++] = 13; /*19070*/
				$k[$j++] = 0; /*19070*/
				$k[$j++] = 42; /*19070*/
				$k[$j++] = 1; /*19070*/
				$k[$j++] = 62; /*19070*/
				$k[$j++] = 2; /*19070*/
				$k[$j++] = 32; /*19070*/
				$k[$j++] = 3; /*19070*/
				for (var _5a = 48; _5a <= 57; _5a += 1) { /*19070*/
					$k[$j++] = _5a; /*19070*/
					$k[$j++] = _5a - 44; /*19070*/
				} /*19070*/
				for (var _5b = 65; _5b <= 90; _5b += 1) { /*19071*/
					$k[$j++] = _5b; /*19071*/
					$k[$j++] = _5b - 51; /*19071*/
				} /*19071*/
				var _5c = $d(); /*19071*/
				$1[$k[--$j]] = _5c; /*19072*/
				$k[$j++] = "Xvals"; /*19074*/
				$k[$j++] = Infinity; /*19074*/
				$forall($1.Xvals, function() { /*19074*/
					$k[$j++] = Infinity; /*19074*/
					var _5f = $k[--$j]; /*19074*/
					var _5g = $k[--$j]; /*19074*/
					$k[$j++] = _5f; /*19074*/
					$k[$j++] = _5g; /*19074*/
					var _5h = $a(); /*19074*/
					$k[$j++] = _5h; /*19074*/
				}); /*19074*/
				var _5i = $d(); /*19074*/
				$1[$k[--$j]] = _5i; /*19075*/
				$k[$j++] = "Bvals"; /*19078*/
				$k[$j++] = Infinity; /*19078*/
				for (var _5k = 0; _5k <= 255; _5k += 1) { /*19078*/
					$k[$j++] = _5k; /*19078*/
					$k[$j++] = _5k; /*19078*/
				} /*19078*/
				var _5l = $d(); /*19078*/
				$1[$k[--$j]] = _5l; /*19079*/
				$k[$j++] = "Bvals"; /*19081*/
				$k[$j++] = Infinity; /*19081*/
				$forall($1.Bvals, function() { /*19081*/
					$k[$j++] = Infinity; /*19081*/
					var _5o = $k[--$j]; /*19081*/
					var _5p = $k[--$j]; /*19081*/
					$k[$j++] = _5o; /*19081*/
					$k[$j++] = _5p; /*19081*/
					var _5q = $a(); /*19081*/
					$k[$j++] = _5q; /*19081*/
				}); /*19081*/
				var _5r = $d(); /*19081*/
				$1[$k[--$j]] = _5r; /*19082*/
				$1.encvals = $a([$1.Avals, $1.Cvals, $1.Tvals, $1.Xvals, -1, $1.Bvals]); /*19084*/
				$k[$j++] = Infinity; /*19086*/
				for (var _60 = 0, _61 = $1.msglen; _60 < _61; _60++) { /*19086*/
					$k[$j++] = 0; /*19086*/
				} /*19086*/
				$k[$j++] = 0; /*19086*/
				$1.numD = $a(); /*19086*/
				$k[$j++] = Infinity; /*19087*/
				for (var _64 = 0, _65 = $1.msglen; _64 < _65; _64++) { /*19087*/
					$k[$j++] = 0; /*19087*/
				} /*19087*/
				$k[$j++] = 9999; /*19087*/
				$1.nextXterm = $a(); /*19087*/
				$k[$j++] = Infinity; /*19088*/
				for (var _68 = 0, _69 = $1.msglen; _68 < _69; _68++) { /*19088*/
					$k[$j++] = 0; /*19088*/
				} /*19088*/
				$k[$j++] = 9999; /*19088*/
				$1.nextNonX = $a(); /*19088*/
				for (var _6C = $1.msglen - 1; _6C >= 0; _6C -= 1) { /*19105*/
					$1.i = _6C; /*19090*/
					$1.barchar = $get($1.msg, $1.i); /*19091*/
					if (($1.barchar >= 48) && ($1.barchar <= 57)) { /*19094*/
						$put($1.numD, $1.i, $get($1.numD, $1.i + 1) + 1); /*19093*/
					} /*19093*/
					if ((($1.barchar == 13) || ($1.barchar == 42)) || ($1.barchar == 62)) { /*19098*/
						$put($1.nextXterm, $1.i, 0); /*19096*/
					} else { /*19098*/
						$put($1.nextXterm, $1.i, $get($1.nextXterm, $1.i + 1) + 1); /*19098*/
					} /*19098*/
					var _6Z = $get($1.Xvals, $1.barchar) !== undefined; /*19100*/
					if (!_6Z) { /*19103*/
						$put($1.nextNonX, $1.i, 0); /*19101*/
					} else { /*19103*/
						$put($1.nextNonX, $1.i, $get($1.nextNonX, $1.i + 1) + 1); /*19103*/
					} /*19103*/
				} /*19103*/
				$k[$j++] = Infinity; /*19106*/
				var _6h = $1.nextXterm; /*19106*/
				for (var _6i = 0, _6j = _6h.length; _6i < _6j; _6i++) { /*19106*/
					var _6k = $get(_6h, _6i); /*19106*/
					$k[$j++] = _6k; /*19106*/
					if (_6k > 10000) { /*19106*/
						$j--; /*19106*/
						$k[$j++] = 10000; /*19106*/
					} /*19106*/
				} /*19106*/
				$1.nextXterm = $a(); /*19106*/
				$k[$j++] = Infinity; /*19107*/
				var _6m = $1.nextNonX; /*19107*/
				for (var _6n = 0, _6o = _6m.length; _6n < _6o; _6n++) { /*19107*/
					var _6p = $get(_6m, _6n); /*19107*/
					$k[$j++] = _6p; /*19107*/
					if (_6p > 10000) { /*19107*/
						$j--; /*19107*/
						$k[$j++] = 10000; /*19107*/
					} /*19107*/
				} /*19107*/
				$1.nextNonX = $a(); /*19107*/
				$1.isD = function() {
					$k[$j++] = ($1.char >= 48) && ($1.char <= 57); /*19109*/
				}; /*19109*/
				$1.isC = function() {
					var _6v = $get($1.CNvals, $1.char) !== undefined; /*19110*/
					$k[$j++] = _6v; /*19110*/
				}; /*19110*/
				$1.isT = function() {
					var _6y = $get($1.TNvals, $1.char) !== undefined; /*19111*/
					$k[$j++] = _6y; /*19111*/
				}; /*19111*/
				$1.isX = function() {
					var _71 = $get($1.Xvals, $1.char) !== undefined; /*19112*/
					$k[$j++] = _71; /*19112*/
				}; /*19112*/
				$1.isEA = function() {
					$k[$j++] = $1.char > 127; /*19113*/
				}; /*19113*/
				$1.isFN = function() {
					$k[$j++] = $1.char < 0; /*19114*/
				}; /*19114*/
				$1.XtermFirst = function() {
					var _74 = $k[--$j]; /*19115*/
					$k[$j++] = $lt($get($1.nextXterm, _74), $get($1.nextNonX, _74)); /*19115*/
				}; /*19115*/
				$1.A = 0; /*19117*/
				$1.C = 1; /*19117*/
				$1.T = 2; /*19117*/
				$1.X = 3; /*19117*/
				$1.D = 4; /*19117*/
				$1.B = 5; /*19117*/
				$1.lookup = function() {
					$1.ac = 1; /*19120*/
					$1.cc = 2; /*19120*/
					$1.tc = 2; /*19120*/
					$1.xc = 2; /*19120*/
					$1.bc = 3; /*19120*/
					if ($1.mode == $1.A) { /*19121*/
						$1.ac = 0; /*19121*/
						$1.cc = 1; /*19121*/
						$1.tc = 1; /*19121*/
						$1.xc = 1; /*19121*/
						$1.bc = 2; /*19121*/
					} /*19121*/
					if ($1.mode == $1.C) { /*19122*/
						$1.cc = 0; /*19122*/
					} /*19122*/
					if ($1.mode == $1.T) { /*19123*/
						$1.tc = 0; /*19123*/
					} /*19123*/
					if ($1.mode == $1.X) { /*19124*/
						$1.xc = 0; /*19124*/
					} /*19124*/
					if ($1.mode == $1.B) { /*19125*/
						$1.bc = 0; /*19125*/
					} /*19125*/
					for (var _7J = 0, _7K = 1; _7J < _7K; _7J++) { /*19153*/
						$1.k = 0; /*19127*/
						for (;;) { /*19152*/
							if (($1.i + $1.k) == $1.msglen) { /*19134*/
								var _7S = $a([$1.ac, $1.cc, $1.tc, $1.xc]); /*19129*/
								$k[$j++] = true; /*19129*/
								for (var _7T = 0, _7U = _7S.length; _7T < _7U; _7T++) { /*19129*/
									var _7X = $k[--$j]; /*19129*/
									$k[$j++] = _7X && ($1.bc <= Math.ceil($get(_7S, _7T))); /*19129*/
								} /*19129*/
								if ($k[--$j]) { /*19129*/
									$k[$j++] = $1.B; /*19129*/
									break; /*19129*/
								} /*19129*/
								var _7e = $a([$1.cc, $1.tc, $1.xc, $1.bc]); /*19130*/
								$k[$j++] = true; /*19130*/
								for (var _7f = 0, _7g = _7e.length; _7f < _7g; _7f++) { /*19130*/
									var _7j = $k[--$j]; /*19130*/
									$k[$j++] = _7j && ($1.ac <= Math.ceil($get(_7e, _7f))); /*19130*/
								} /*19130*/
								if ($k[--$j]) { /*19130*/
									$k[$j++] = $1.A; /*19130*/
									break; /*19130*/
								} /*19130*/
								var _7o = $a([$1.tc, $1.xc]); /*19131*/
								$k[$j++] = true; /*19131*/
								for (var _7p = 0, _7q = _7o.length; _7p < _7q; _7p++) { /*19131*/
									var _7t = $k[--$j]; /*19131*/
									$k[$j++] = _7t && (Math.ceil($1.cc) <= Math.ceil($get(_7o, _7p))); /*19131*/
								} /*19131*/
								if ($k[--$j]) { /*19131*/
									$k[$j++] = $1.C; /*19131*/
									break; /*19131*/
								} /*19131*/
								var _7x = $a([$1.xc]); /*19132*/
								$k[$j++] = true; /*19132*/
								for (var _7y = 0, _7z = _7x.length; _7y < _7z; _7y++) { /*19132*/
									var _82 = $k[--$j]; /*19132*/
									$k[$j++] = _82 && (Math.ceil($1.tc) <= Math.ceil($get(_7x, _7y))); /*19132*/
								} /*19132*/
								if ($k[--$j]) { /*19132*/
									$k[$j++] = $1.T; /*19132*/
									break; /*19132*/
								} /*19132*/
								$k[$j++] = $1.X; /*19133*/
								break; /*19133*/
							} /*19133*/
							$1.char = $get($1.msg, $1.i + $1.k); /*19135*/
							$k[$j++] = "ac"; /*19136*/
							$k[$j++] = $1.ac; /*19136*/
							if ($1.isD() == $b) break; /*19136*/
							if ($k[--$j]) { /*19136*/
								var _8C = $k[--$j]; /*19136*/
								$k[$j++] = _8C + (1 / 2); /*19136*/
							} else { /*19136*/
								if ($1.isEA() == $b) break; /*19136*/
								if ($k[--$j]) { /*19136*/
									var _8E = $k[--$j]; /*19136*/
									$k[$j++] = Math.ceil(_8E) + 2; /*19136*/
								} else { /*19136*/
									var _8F = $k[--$j]; /*19136*/
									$k[$j++] = Math.ceil(_8F) + 1; /*19136*/
								} /*19136*/
							} /*19136*/
							var _8G = $k[--$j]; /*19136*/
							$1[$k[--$j]] = _8G; /*19136*/
							$k[$j++] = "cc"; /*19137*/
							$k[$j++] = $1.cc; /*19137*/
							if ($1.isC() == $b) break; /*19137*/
							if ($k[--$j]) { /*19137*/
								var _8K = $k[--$j]; /*19137*/
								$k[$j++] = _8K + (2 / 3); /*19137*/
							} else { /*19137*/
								if ($1.isEA() == $b) break; /*19137*/
								if ($k[--$j]) { /*19137*/
									var _8M = $k[--$j]; /*19137*/
									$k[$j++] = _8M + (8 / 3); /*19137*/
								} else { /*19137*/
									var _8N = $k[--$j]; /*19137*/
									$k[$j++] = _8N + (4 / 3); /*19137*/
								} /*19137*/
							} /*19137*/
							var _8O = $k[--$j]; /*19137*/
							$1[$k[--$j]] = _8O; /*19137*/
							$k[$j++] = "tc"; /*19138*/
							$k[$j++] = $1.tc; /*19138*/
							if ($1.isT() == $b) break; /*19138*/
							if ($k[--$j]) { /*19138*/
								var _8S = $k[--$j]; /*19138*/
								$k[$j++] = _8S + (2 / 3); /*19138*/
							} else { /*19138*/
								if ($1.isEA() == $b) break; /*19138*/
								if ($k[--$j]) { /*19138*/
									var _8U = $k[--$j]; /*19138*/
									$k[$j++] = _8U + (8 / 3); /*19138*/
								} else { /*19138*/
									var _8V = $k[--$j]; /*19138*/
									$k[$j++] = _8V + (4 / 3); /*19138*/
								} /*19138*/
							} /*19138*/
							var _8W = $k[--$j]; /*19138*/
							$1[$k[--$j]] = _8W; /*19138*/
							$k[$j++] = "xc"; /*19139*/
							$k[$j++] = $1.xc; /*19139*/
							if ($1.isX() == $b) break; /*19139*/
							if ($k[--$j]) { /*19139*/
								var _8a = $k[--$j]; /*19139*/
								$k[$j++] = _8a + (2 / 3); /*19139*/
							} else { /*19139*/
								if ($1.isEA() == $b) break; /*19139*/
								if ($k[--$j]) { /*19139*/
									var _8c = $k[--$j]; /*19139*/
									$k[$j++] = _8c + (13 / 3); /*19139*/
								} else { /*19139*/
									var _8d = $k[--$j]; /*19139*/
									$k[$j++] = _8d + (10 / 3); /*19139*/
								} /*19139*/
							} /*19139*/
							var _8e = $k[--$j]; /*19139*/
							$1[$k[--$j]] = _8e; /*19139*/
							$k[$j++] = "bc"; /*19140*/
							$k[$j++] = $1.bc; /*19140*/
							if ($1.isFN() == $b) break; /*19140*/
							if ($k[--$j]) { /*19140*/
								var _8i = $k[--$j]; /*19140*/
								$k[$j++] = _8i + 3; /*19140*/
							} else { /*19140*/
								var _8j = $k[--$j]; /*19140*/
								$k[$j++] = _8j + 1; /*19140*/
							} /*19140*/
							var _8k = $k[--$j]; /*19140*/
							$1[$k[--$j]] = _8k; /*19140*/
							if ($1.k >= 3) { /*19150*/
								var _8r = $a([$1.ac, $1.cc, $1.tc, $1.xc]); /*19142*/
								$k[$j++] = true; /*19142*/
								for (var _8s = 0, _8t = _8r.length; _8s < _8t; _8s++) { /*19142*/
									var _8w = $k[--$j]; /*19142*/
									$k[$j++] = _8w && (($1.bc + 1) <= Math.ceil($get(_8r, _8s))); /*19142*/
								} /*19142*/
								if ($k[--$j]) { /*19142*/
									$k[$j++] = $1.B; /*19142*/
									break; /*19142*/
								} /*19142*/
								var _93 = $a([$1.cc, $1.tc, $1.xc, $1.bc]); /*19143*/
								$k[$j++] = true; /*19143*/
								for (var _94 = 0, _95 = _93.length; _94 < _95; _94++) { /*19143*/
									var _98 = $k[--$j]; /*19143*/
									$k[$j++] = _98 && (($1.ac + 1) <= Math.ceil($get(_93, _94))); /*19143*/
								} /*19143*/
								if ($k[--$j]) { /*19143*/
									$k[$j++] = $1.A; /*19143*/
									break; /*19143*/
								} /*19143*/
								var _9F = $a([$1.ac, $1.cc, $1.xc, $1.bc]); /*19144*/
								$k[$j++] = true; /*19144*/
								for (var _9G = 0, _9H = _9F.length; _9G < _9H; _9G++) { /*19144*/
									var _9K = $k[--$j]; /*19144*/
									$k[$j++] = _9K && (($1.tc + 1) <= Math.ceil($get(_9F, _9G))); /*19144*/
								} /*19144*/
								if ($k[--$j]) { /*19144*/
									$k[$j++] = $1.T; /*19144*/
									break; /*19144*/
								} /*19144*/
								var _9P = $a([$1.ac, $1.tc]); /*19145*/
								$k[$j++] = true; /*19145*/
								for (var _9Q = 0, _9R = _9P.length; _9Q < _9R; _9Q++) { /*19145*/
									var _9U = $k[--$j]; /*19145*/
									$k[$j++] = _9U && (($1.cc + 1) <= Math.ceil($get(_9P, _9Q))); /*19145*/
								} /*19145*/
								if ($k[--$j]) { /*19148*/
									if (Math.ceil($1.cc) < Math.ceil($1.xc)) { /*19146*/
										$k[$j++] = $1.C; /*19146*/
										break; /*19146*/
									} /*19146*/
									if ($1.cc == $1.xc) { /*19147*/
										$k[$j++] = ($1.i + $1.k) + 1; /*19147*/
										if ($1.XtermFirst() == $b) break; /*19147*/
										if ($k[--$j]) { /*19147*/
											$k[$j++] = $1.X; /*19147*/
											break; /*19147*/
										} else { /*19147*/
											$k[$j++] = $1.C; /*19147*/
											break; /*19147*/
										} /*19147*/
									} /*19147*/
								} /*19147*/
								var _9k = $a([$1.ac, $1.cc, $1.tc, $1.bc]); /*19149*/
								$k[$j++] = true; /*19149*/
								for (var _9l = 0, _9m = _9k.length; _9l < _9m; _9l++) { /*19149*/
									var _9p = $k[--$j]; /*19149*/
									$k[$j++] = _9p && (($1.xc + 1) < $get(_9k, _9l)); /*19149*/
								} /*19149*/
								if ($k[--$j]) { /*19149*/
									$k[$j++] = $1.X; /*19149*/
									break; /*19149*/
								} /*19149*/
							} /*19149*/
							$1.k = $1.k + 1; /*19151*/
						} /*19151*/
					} /*19151*/
				}; /*19154*/
				$1.addtocws = function() {
					var _9t = $k[--$j]; /*19157*/
					$puti($1.cws, $1.j, _9t); /*19157*/
					$1.j = _9t.length + $1.j; /*19158*/
				}; /*19159*/
				$1.tobin = function() {
					var _9y = $s($k[--$j]); /*19162*/
					$k[$j++] = _9y; /*19162*/
					for (var _A0 = 0, _9z = _9y.length - 1; _A0 <= _9z; _A0 += 1) { /*19162*/
						var _A1 = $k[--$j]; /*19162*/
						$put(_A1, _A0, 48); /*19162*/
						$k[$j++] = _A1; /*19162*/
					} /*19162*/
					var _A2 = $k[--$j]; /*19163*/
					var _A5 = $cvrs($s(_A2.length), $k[--$j], 2); /*19163*/
					$puti(_A2, _A2.length - _A5.length, _A5); /*19163*/
					$k[$j++] = _A2; /*19164*/
					$k[$j++] = Infinity; /*19164*/
					var _A6 = $k[--$j]; /*19164*/
					var _A7 = $k[--$j]; /*19164*/
					$k[$j++] = _A6; /*19164*/
					$forall(_A7, function() { /*19164*/
						var _A8 = $k[--$j]; /*19164*/
						$k[$j++] = _A8 - 48; /*19164*/
					}); /*19164*/
					var _A9 = $a(); /*19164*/
					$k[$j++] = _A9; /*19164*/
				}; /*19165*/
				$1.encA = function() {
					for (var _AA = 0, _AB = 1; _AA < _AB; _AA++) { /*19209*/
						if ($get($1.numD, $1.i) >= 21) { /*19173*/
							$1.Dbits = $a([1, 1, 1, 1]); /*19170*/
							$1.mode = $1.D; /*19171*/
							break; /*19172*/
						} /*19172*/
						var _AJ = $get($1.numD, $1.i); /*19174*/
						if ((_AJ >= 13) && ((_AJ + $1.i) == $1.msglen)) { /*19178*/
							$1.Dbits = $a([1, 1, 1, 1]); /*19175*/
							$1.mode = $1.D; /*19176*/
							break; /*19177*/
						} /*19177*/
						if ($get($1.numD, $1.i) >= 2) { /*19183*/
							var _AR = $s(2); /*19180*/
							$put(_AR, 0, $get($1.msg, $1.i)); /*19180*/
							$put(_AR, 1, $get($1.msg, $1.i + 1)); /*19180*/
							$k[$j++] = $get($1.Avals, _AR); /*19180*/
							if ($1.addtocws() == $b) break; /*19180*/
							$1.i = $1.i + 2; /*19181*/
							break; /*19182*/
						} /*19182*/
						if ($get($1.msg, $1.i) == $1.fnc1) { /*19199*/
							if ($get($1.numD, $1.i + 1) >= 15) { /*19191*/
								$k[$j++] = $get($1.Avals, $1.fnc1lD); /*19186*/
								if ($1.addtocws() == $b) break; /*19186*/
								$1.i = $1.i + 1; /*19187*/
								$1.Dbits = $a([]); /*19188*/
								$1.mode = $1.D; /*19189*/
								break; /*19190*/
							} /*19190*/
							var _Aq = $get($1.numD, $1.i + 1); /*19192*/
							if ((_Aq >= 7) && (((_Aq + $1.i) + 1) == $1.msglen)) { /*19198*/
								$k[$j++] = $get($1.Avals, $1.fnc1lD); /*19193*/
								if ($1.addtocws() == $b) break; /*19193*/
								$1.i = $1.i + 1; /*19194*/
								$1.Dbits = $a([]); /*19195*/
								$1.mode = $1.D; /*19196*/
								break; /*19197*/
							} /*19197*/
						} /*19197*/
						$k[$j++] = "newmode"; /*19200*/
						if ($1.lookup() == $b) break; /*19200*/
						var _Az = $k[--$j]; /*19200*/
						$1[$k[--$j]] = _Az; /*19200*/
						if ($1.newmode != $1.mode) { /*19205*/
							$k[$j++] = $get($1.Avals, $get($a([-1, $1.lC, $1.lT, $1.lX, $1.lD, $1.lB]), $1.newmode)); /*19202*/
							if ($1.addtocws() == $b) break; /*19202*/
							$1.mode = $1.newmode; /*19203*/
							break; /*19204*/
						} /*19204*/
						$k[$j++] = $get($1.Avals, $get($1.msg, $1.i)); /*19206*/
						if ($1.addtocws() == $b) break; /*19206*/
						$1.i = $1.i + 1; /*19207*/
						break; /*19208*/
					} /*19208*/
				}; /*19210*/
				$1.CTXvalstocws = function() {
					$1.in = $k[--$j]; /*19213*/
					$k[$j++] = Infinity; /*19214*/
					for (var _BN = 0, _BM = $1.in.length - 1; _BN <= _BM; _BN += 3) { /*19218*/
						$k[$j++] = 0; /*19216*/
						$forall($geti($1.in, _BN, 3), function() { /*19216*/
							var _BQ = $k[--$j]; /*19216*/
							var _BR = $k[--$j]; /*19216*/
							$k[$j++] = (_BR + _BQ) * 40; /*19216*/
						}); /*19216*/
						var _BT = (~~($k[--$j] / 40)) + 1; /*19217*/
						$k[$j++] = ~~(_BT / 256); /*19217*/
						$k[$j++] = _BT % 256; /*19217*/
					} /*19217*/
					$astore($a($counttomark())); /*19219*/
					var _BW = $k[--$j]; /*19219*/
					var _BX = $k[--$j]; /*19219*/
					$k[$j++] = _BW; /*19219*/
				}; /*19220*/
				$1.encCTX = function() {
					$1.p = 0; /*19223*/
					$1.ctxvals = $a(2220); /*19224*/
					for (;;) { /*19302*/
						if ($1.i == $1.msglen) { /*19228*/
							break; /*19228*/
						} /*19228*/
						var _Bh = $get($get($1.encvals, $1.mode), $get($1.msg, $1.i)) !== undefined; /*19229*/
						if (!_Bh) { /*19229*/
							break; /*19229*/
						} /*19229*/
						if (($1.p % 3) == 0) { /*19297*/
							if ($get($1.numD, $1.i) >= 12) { /*19235*/
								$k[$j++] = $a([$1.unlcw]); /*19232*/
								if ($1.addtocws() == $b) break; /*19232*/
								$1.mode = $1.A; /*19233*/
								break; /*19234*/
							} /*19234*/
							var _Br = $get($1.numD, $1.i); /*19236*/
							if ((_Br >= 8) && ((_Br + $1.i) == $1.msglen)) { /*19240*/
								$k[$j++] = $a([$1.unlcw]); /*19237*/
								if ($1.addtocws() == $b) break; /*19237*/
								$1.mode = $1.A; /*19238*/
								break; /*19239*/
							} /*19239*/
							if ($1.lookup() == $b) break; /*19241*/
							if ($k[--$j] != $1.mode) { /*19246*/
								$k[$j++] = $geti($1.ctxvals, 0, $1.p); /*19242*/
								if ($1.CTXvalstocws() == $b) break; /*19242*/
								if ($1.addtocws() == $b) break; /*19242*/
								$k[$j++] = $a([$1.unlcw]); /*19243*/
								if ($1.addtocws() == $b) break; /*19243*/
								$1.mode = $1.A; /*19244*/
								break; /*19245*/
							} /*19245*/
							if (($1.msglen - $1.i) <= 3) { /*19296*/
								$1.remcws = $get($1.numremcws, $1.j + ((~~($1.p / 3)) * 2)); /*19248*/
								$k[$j++] = Infinity; /*19257*/
								$forall($geti($1.msg, $1.i, $1.msglen - $1.i), function() { /*19256*/
									var _CG = $k[--$j]; /*19251*/
									var _CK = $get($get($1.encvals, $1.mode), _CG) !== undefined; /*19251*/
									$k[$j++] = _CG; /*19255*/
									if (_CK) { /*19254*/
										$aload($get($get($1.encvals, $1.mode), $k[--$j])); /*19252*/
									} else { /*19254*/
										$j--; /*19254*/
										$k[$j++] = -1; /*19254*/
										$k[$j++] = -1; /*19254*/
										$k[$j++] = -1; /*19254*/
										$k[$j++] = -1; /*19254*/
									} /*19254*/
								}); /*19254*/
								$1.remvals = $a(); /*19257*/
								if (($1.remcws == 2) && ($1.remvals.length == 3)) { /*19267*/
									$k[$j++] = Infinity; /*19262*/
									$aload($geti($1.ctxvals, 0, $1.p)); /*19261*/
									$aload($1.remvals); /*19262*/
									var _CX = $a(); /*19262*/
									$k[$j++] = _CX; /*19263*/
									if ($1.CTXvalstocws() == $b) break; /*19263*/
									if ($1.addtocws() == $b) break; /*19263*/
									$1.mode = $1.A; /*19264*/
									$1.i = $1.msglen; /*19265*/
									break; /*19266*/
								} /*19266*/
								if ((($1.remcws == 2) && ($1.remvals.length == 2)) && ($1.mode != $1.X)) { /*19278*/
									$k[$j++] = Infinity; /*19273*/
									$aload($geti($1.ctxvals, 0, $1.p)); /*19271*/
									$aload($1.remvals); /*19272*/
									$aload($get($get($1.encvals, $1.mode), $1.sft1)); /*19273*/
									var _Cn = $a(); /*19273*/
									$k[$j++] = _Cn; /*19274*/
									if ($1.CTXvalstocws() == $b) break; /*19274*/
									if ($1.addtocws() == $b) break; /*19274*/
									$1.mode = $1.A; /*19275*/
									$1.i = $1.msglen; /*19276*/
									break; /*19277*/
								} /*19277*/
								if (($1.remcws == 2) && ($1.remvals.length == 1)) { /*19287*/
									$k[$j++] = $geti($1.ctxvals, 0, $1.p); /*19281*/
									if ($1.CTXvalstocws() == $b) break; /*19281*/
									if ($1.addtocws() == $b) break; /*19281*/
									$k[$j++] = $a([$1.unlcw]); /*19282*/
									if ($1.addtocws() == $b) break; /*19282*/
									$k[$j++] = $get($1.Avals, $get($1.msg, $1.i)); /*19283*/
									if ($1.addtocws() == $b) break; /*19283*/
									$1.mode = $1.A; /*19284*/
									$1.i = $1.msglen; /*19285*/
									break; /*19286*/
								} /*19286*/
								if (($1.remcws == 1) && ($1.remvals.length == 1)) { /*19295*/
									$k[$j++] = $geti($1.ctxvals, 0, $1.p); /*19290*/
									if ($1.CTXvalstocws() == $b) break; /*19290*/
									if ($1.addtocws() == $b) break; /*19290*/
									$k[$j++] = $get($1.Avals, $get($1.msg, $1.i)); /*19291*/
									if ($1.addtocws() == $b) break; /*19291*/
									$1.mode = $1.A; /*19292*/
									$1.i = $1.msglen; /*19293*/
									break; /*19294*/
								} /*19294*/
							} /*19294*/
						} /*19294*/
						var _DM = $get($get($1.encvals, $1.mode), $get($1.msg, $1.i)); /*19298*/
						$puti($1.ctxvals, $1.p, _DM); /*19299*/
						$1.p = _DM.length + $1.p; /*19300*/
						$1.i = $1.i + 1; /*19301*/
					} /*19301*/
					if ($1.mode != $1.A) { /*19326*/
						for (;;) { /*19310*/
							if (($1.p % 3) == 0) { /*19307*/
								break; /*19307*/
							} /*19307*/
							$1.i = $1.i - 1; /*19308*/
							$1.p = $1.p - $get($get($1.encvals, $1.mode), $get($1.msg, $1.i)).length; /*19309*/
						} /*19309*/
						$k[$j++] = Infinity; /*19312*/
						$aload($geti($1.ctxvals, 0, $1.p)); /*19312*/
						var _Dg = $a(); /*19312*/
						$k[$j++] = _Dg; /*19313*/
						if ($1.CTXvalstocws() == $b) return $b; /*19313*/
						if ($1.addtocws() == $b) return $b; /*19313*/
						$k[$j++] = $a([$1.unlcw]); /*19314*/
						if ($1.addtocws() == $b) return $b; /*19314*/
						$1.mode = $1.A; /*19315*/
						if ($1.i != $1.msglen) { /*19325*/
							if ($get($1.numD, $1.i) >= 2) { /*19323*/
								var _Dp = $s(2); /*19319*/
								$put(_Dp, 0, $get($1.msg, $1.i)); /*19319*/
								$put(_Dp, 1, $get($1.msg, $1.i + 1)); /*19319*/
								$k[$j++] = $get($1.Avals, _Dp); /*19319*/
								if ($1.addtocws() == $b) return $b; /*19319*/
								$1.i = $1.i + 2; /*19320*/
							} else { /*19323*/
								$k[$j++] = $get($1.Avals, $get($1.msg, $1.i)); /*19322*/
								if ($1.addtocws() == $b) return $b; /*19322*/
								$1.i = $1.i + 1; /*19323*/
							} /*19323*/
						} /*19323*/
					} /*19323*/
				}; /*19328*/
				$1.encD = function() {
					for (;;) { /*19381*/
						if ($get($1.numD, $1.i) < 3) { /*19371*/
							$1.Drem = (8 - ($1.Dbits.length % 8)) % 8; /*19336*/
							$1.remcws = $get($1.numremcws, $1.j + (~~($1.Dbits.length / 8))); /*19337*/
							if ((($get($1.numremcws, ($1.j + (~~($1.Dbits.length / 8))) - 1) - 1) == 0) && ($1.i == $1.msglen)) { /*19341*/
								break; /*19341*/
							} /*19341*/
							if (((($1.i == ($1.msglen - 1)) && ($get($1.numD, $1.i) == 1)) && ($1.remcws == 1)) && ($1.Drem == 0)) { /*19345*/
								break; /*19345*/
							} /*19345*/
							if (!(((($1.i == ($1.msglen - 1)) && ($get($1.numD, $1.i) == 1)) && ($1.remcws == 1)) && (($1.Drem == 4) || ($1.Drem == 6)))) { /*19352*/
								$k[$j++] = Infinity; /*19350*/
								$aload($1.Dbits); /*19350*/
								$k[$j++] = 1; /*19350*/
								$k[$j++] = 1; /*19350*/
								$k[$j++] = 1; /*19350*/
								$k[$j++] = 1; /*19350*/
								$k[$j++] = 1; /*19350*/
								$k[$j++] = 1; /*19350*/
								$1.Dbits = $a(); /*19350*/
								$1.Drem = (8 - ($1.Dbits.length % 8)) % 8; /*19351*/
							} /*19351*/
							if (($1.Drem == 4) || ($1.Drem == 6)) { /*19363*/
								if ($get($1.numD, $1.i) >= 1) { /*19360*/
									$k[$j++] = Infinity; /*19357*/
									$aload($1.Dbits); /*19357*/
									$k[$j++] = ($get($1.msg, $1.i) - 48) + 1; /*19357*/
									$k[$j++] = 4; /*19357*/
									if ($1.tobin() == $b) break; /*19357*/
									$aload($k[--$j]); /*19357*/
									$1.Dbits = $a(); /*19357*/
									$1.i = $1.i + 1; /*19358*/
								} else { /*19360*/
									$k[$j++] = Infinity; /*19360*/
									$aload($1.Dbits); /*19360*/
									$k[$j++] = 1; /*19360*/
									$k[$j++] = 1; /*19360*/
									$k[$j++] = 1; /*19360*/
									$k[$j++] = 1; /*19360*/
									$1.Dbits = $a(); /*19360*/
								} /*19360*/
								$1.Drem = $1.Drem - 4; /*19362*/
							} /*19362*/
							if ($1.Drem == 2) { /*19367*/
								$k[$j++] = Infinity; /*19365*/
								$aload($1.Dbits); /*19365*/
								$k[$j++] = 0; /*19365*/
								$k[$j++] = 1; /*19365*/
								$1.Dbits = $a(); /*19365*/
								$1.Drem = 0; /*19366*/
							} /*19366*/
							break; /*19369*/
						} /*19369*/
						$k[$j++] = Infinity; /*19378*/
						$aload($1.Dbits); /*19375*/
						$k[$j++] = 0; /*19376*/
						$forall($geti($1.msg, $1.i, 3), function() { /*19376*/
							var _Ex = $k[--$j]; /*19376*/
							var _Ey = $k[--$j]; /*19376*/
							$k[$j++] = (_Ey + (_Ex - 48)) * 10; /*19376*/
						}); /*19376*/
						var _Ez = $k[--$j]; /*19376*/
						$k[$j++] = (~~(_Ez / 10)) + 1; /*19377*/
						$k[$j++] = 10; /*19377*/
						if ($1.tobin() == $b) break; /*19377*/
						$aload($k[--$j]); /*19377*/
						$1.Dbits = $a(); /*19378*/
						$1.i = $1.i + 3; /*19379*/
					} /*19379*/
					$k[$j++] = Infinity; /*19383*/
					for (var _F5 = 0, _F4 = $1.Dbits.length - 1; _F5 <= _F4; _F5 += 8) { /*19386*/
						$k[$j++] = 0; /*19385*/
						$forall($geti($1.Dbits, _F5, 8), function() { /*19385*/
							var _F8 = $k[--$j]; /*19385*/
							var _F9 = $k[--$j]; /*19385*/
							$k[$j++] = (_F9 + _F8) * 2; /*19385*/
						}); /*19385*/
						var _FA = $k[--$j]; /*19385*/
						$k[$j++] = ~~(_FA / 2); /*19385*/
					} /*19385*/
					$astore($a($counttomark())); /*19387*/
					var _FD = $k[--$j]; /*19387*/
					var _FE = $k[--$j]; /*19387*/
					$k[$j++] = _FD; /*19387*/
					if ($1.addtocws() == $b) return $b; /*19387*/
					$1.mode = $1.A; /*19388*/
				}; /*19390*/
				$1.encB = function() {
					$1.p = 0; /*19393*/
					$1.bvals = $a(1480); /*19393*/
					for (;;) { /*19400*/
						if ($1.i == $1.msglen) { /*19394*/
							break; /*19394*/
						} /*19394*/
						if ($get($1.msg, $1.i) < 0) { /*19395*/
							break; /*19395*/
						} /*19395*/
						if ($1.lookup() == $b) break; /*19396*/
						if ($k[--$j] != $1.mode) { /*19396*/
							break; /*19396*/
						} /*19396*/
						$put($1.bvals, $1.p, $get($1.msg, $1.i)); /*19397*/
						$1.p = $1.p + 1; /*19398*/
						$1.i = $1.i + 1; /*19399*/
					} /*19399*/
					$1.remcws = $get($1.numremcws, $1.j + $1.p) - 1; /*19401*/
					$k[$j++] = Infinity; /*19409*/
					if (($1.remcws == 0) && ($1.i == $1.msglen)) { /*19406*/
						$k[$j++] = 0; /*19404*/
					} else { /*19406*/
						if ($1.p < 250) { /*19406*/
							$k[$j++] = $1.p; /*19406*/
						} else { /*19406*/
							$k[$j++] = (~~($1.p / 250)) + 249; /*19406*/
							$k[$j++] = $1.p % 250; /*19406*/
						} /*19406*/
					} /*19406*/
					$aload($geti($1.bvals, 0, $1.p)); /*19408*/
					$1.bvals = $a(); /*19409*/
					$k[$j++] = $1.bvals; /*19410*/
					if ($1.addtocws() == $b) return $b; /*19410*/
					$1.mode = $1.A; /*19411*/
				}; /*19412*/
				$1.cws = $a(1480); /*19415*/
				$1.mode = $1.A; /*19416*/
				$1.i = 0; /*19416*/
				$1.j = 0; /*19416*/
				for (;;) { /*19419*/
					if ($1.i >= $1.msglen) { /*19417*/
						break; /*19417*/
					} /*19417*/
					$1[$get($a(["encA", "encCTX", "encCTX", "encCTX", "encD", "encB"]), $1.mode)](); /*19418*/
				} /*19418*/
				$1.cws = $geti($1.cws, 0, $1.j); /*19420*/
			} /*19420*/
			$1.i = 0; /*19425*/
			for (;;) { /*19445*/
				$1.m = $get($1.metrics, $1.i); /*19427*/
				$1.vers = $get($1.m, 0); /*19428*/
				$1.rows = $get($1.m, 1); /*19429*/
				$1.cols = $get($1.m, 2); /*19430*/
				$1.dcol = $get($1.m, 3); /*19431*/
				$1.dcws = $get($1.m, 4); /*19432*/
				$1.rscw = $get($1.m, 5); /*19433*/
				$1.rsbl = $get($1.m, 6); /*19434*/
				$1.riso = $get($1.m, 7); /*19435*/
				$1.risi = $get($1.m, 8); /*19436*/
				$1.risl = $get($1.m, 9); /*19437*/
				$1.dcpb = ~~($1.dcws / $1.rsbl); /*19438*/
				$1.ecpb = ~~($1.rscw / $1.rsbl); /*19439*/
				$1.okay = true; /*19440*/
				if ($ne($1.version, "unset") && $ne($1.version, $1.vers)) { /*19441*/
					$1.okay = false; /*19441*/
				} /*19441*/
				if ($1.cws.length > $1.dcws) { /*19442*/
					$1.okay = false; /*19442*/
				} /*19442*/
				if ($1.okay) { /*19443*/
					break; /*19443*/
				} /*19443*/
				$1.i = $1.i + 1; /*19444*/
			} /*19444*/
			if (!$1.stype) { /*19451*/
				$k[$j++] = Infinity; /*19449*/
				$aload($1.cws); /*19449*/
				for (var _GZ = 0, _Ga = $1.dcws - $1.cws.length; _GZ < _Ga; _GZ++) { /*19449*/
					$k[$j++] = 129; /*19449*/
				} /*19449*/
				$1.cws = $a(); /*19449*/
			} else { /*19451*/
				$k[$j++] = Infinity; /*19451*/
				for (var _Ge = 0, _Gf = $1.dcws - $1.cws.length; _Ge < _Gf; _Ge++) { /*19451*/
					$k[$j++] = 0; /*19451*/
				} /*19451*/
				$aload($1.cws); /*19451*/
				$1.cws = $a(); /*19451*/
			} /*19451*/
			$1.cwbs = $a($1.rsbl); /*19455*/
			$1.ecbs = $a($1.rsbl); /*19456*/
			for (var _Go = 0, _Gn = $1.rsbl - 1; _Go <= _Gn; _Go += 1) { /*19465*/
				$1.i = _Go; /*19458*/
				$1.cwb = $a($1.dcpb); /*19459*/
				for (var _Gt = 0, _Gs = $1.dcpb - 1; _Gt <= _Gs; _Gt += 1) { /*19463*/
					$1.j = _Gt; /*19461*/
					$put($1.cwb, $1.j, $get($1.cws, ($1.j * $1.rsbl) + $1.i)); /*19462*/
				} /*19462*/
				$put($1.cwbs, $1.i, $1.cwb); /*19464*/
			} /*19464*/
			var _H5 = $1.stype ? 32 : 256; /*19468*/
			$1.gf = _H5; /*19468*/
			$1["gf-1"] = $1.gf - 1; /*19469*/
			var _H8 = $1.stype ? 37 : 301; /*19470*/
			$1.pm = _H8; /*19470*/
			$k[$j++] = Infinity; /*19471*/
			$k[$j++] = 1; /*19471*/
			for (var _HA = 0, _HB = $1["gf-1"]; _HA < _HB; _HA++) { /*19471*/
				var _HC = $k[--$j]; /*19471*/
				var _HD = _HC * 2; /*19471*/
				$k[$j++] = _HC; /*19471*/
				$k[$j++] = _HD; /*19471*/
				if (_HD >= $1.gf) { /*19471*/
					var _HG = $k[--$j]; /*19471*/
					$k[$j++] = _HG ^ $1.pm; /*19471*/
				} /*19471*/
			} /*19471*/
			$1.rsalog = $a(); /*19471*/
			$1.rslog = $a($1.gf); /*19472*/
			for (var _HM = 1, _HL = $1["gf-1"]; _HM <= _HL; _HM += 1) { /*19473*/
				$put($1.rslog, $get($1.rsalog, _HM), _HM); /*19473*/
			} /*19473*/
			$1.rsprod = function() {
				var _HQ = $k[--$j]; /*19475*/
				var _HR = $k[--$j]; /*19475*/
				$k[$j++] = _HR; /*19479*/
				$k[$j++] = _HQ; /*19479*/
				if ((_HQ != 0) && (_HR != 0)) { /*19478*/
					var _HU = $get($1.rslog, $k[--$j]); /*19476*/
					var _Ha = $get($1.rsalog, (_HU + $get($1.rslog, $k[--$j])) % $1["gf-1"]); /*19476*/
					$k[$j++] = _Ha; /*19476*/
				} else { /*19478*/
					$j -= 2; /*19478*/
					$k[$j++] = 0; /*19478*/
				} /*19478*/
			}; /*19480*/
			$k[$j++] = Infinity; /*19483*/
			$k[$j++] = 1; /*19483*/
			for (var _Hc = 0, _Hd = $1.ecpb; _Hc < _Hd; _Hc++) { /*19483*/
				$k[$j++] = 0; /*19483*/
			} /*19483*/
			$1.coeffs = $a(); /*19483*/
			for (var _Hh = 0, _Hg = $1.ecpb - 1; _Hh <= _Hg; _Hh += 1) { /*19492*/
				$1.i = _Hh; /*19485*/
				$put($1.coeffs, $1.i + 1, $get($1.coeffs, $1.i)); /*19486*/
				for (var _Ho = $1.i; _Ho >= 1; _Ho -= 1) { /*19490*/
					$1.j = _Ho; /*19488*/
					$k[$j++] = $1.coeffs; /*19489*/
					$k[$j++] = $1.j; /*19489*/
					$k[$j++] = $get($1.coeffs, $1.j - 1); /*19489*/
					$k[$j++] = $get($1.coeffs, $1.j); /*19489*/
					$k[$j++] = $get($1.rsalog, $1.i); /*19489*/
					if ($1.rsprod() == $b) break; /*19489*/
					var _I0 = $k[--$j]; /*19489*/
					var _I1 = $k[--$j]; /*19489*/
					var _I2 = $k[--$j]; /*19489*/
					$put($k[--$j], _I2, $xo(_I1, _I0)); /*19489*/
				} /*19489*/
				$k[$j++] = $1.coeffs; /*19491*/
				$k[$j++] = 0; /*19491*/
				$k[$j++] = $get($1.coeffs, 0); /*19491*/
				$k[$j++] = $get($1.rsalog, $1.i); /*19491*/
				if ($1.rsprod() == $b) break; /*19491*/
				var _IA = $k[--$j]; /*19491*/
				var _IB = $k[--$j]; /*19491*/
				$put($k[--$j], _IB, _IA); /*19491*/
			} /*19491*/
			$1.coeffs = $geti($1.coeffs, 0, $1.coeffs.length - 1); /*19493*/
			for (var _II = 0, _IH = $1.cwbs.length - 1; _II <= _IH; _II += 1) { /*19508*/
				$1.i = _II; /*19497*/
				$k[$j++] = Infinity; /*19498*/
				$aload($get($1.cwbs, $1.i)); /*19498*/
				for (var _IN = 0, _IO = $1.ecpb; _IN < _IO; _IN++) { /*19498*/
					$k[$j++] = 0; /*19498*/
				} /*19498*/
				$1.rscws = $a(); /*19498*/
				for (var _IS = 0, _IR = $1.dcpb - 1; _IS <= _IR; _IS += 1) { /*19506*/
					$1.m = _IS; /*19500*/
					$1.k = $get($1.rscws, $1.m); /*19501*/
					for (var _IY = 0, _IX = $1.ecpb - 1; _IY <= _IX; _IY += 1) { /*19505*/
						$1.j = _IY; /*19503*/
						$k[$j++] = $1.rscws; /*19504*/
						$k[$j++] = ($1.m + $1.j) + 1; /*19504*/
						$k[$j++] = $get($1.coeffs, ($1.ecpb - $1.j) - 1); /*19504*/
						$k[$j++] = $1.k; /*19504*/
						if ($1.rsprod() == $b) break; /*19504*/
						var _Il = $k[--$j]; /*19504*/
						var _Im = $k[--$j]; /*19504*/
						$put($k[--$j], _Im, $xo(_Il, $get($1.rscws, ($1.m + $1.j) + 1))); /*19504*/
					} /*19504*/
				} /*19504*/
				$put($1.ecbs, $1.i, $geti($1.rscws, $1.dcpb, $1.ecpb)); /*19507*/
			} /*19507*/
			$k[$j++] = Infinity; /*19511*/
			$aload($1.cws); /*19511*/
			for (var _Iw = 0, _Ix = $1.rscw; _Iw < _Ix; _Iw++) { /*19511*/
				$k[$j++] = 0; /*19511*/
			} /*19511*/
			$1.cws = $a(); /*19511*/
			for (var _J1 = 0, _J0 = $1.rscw - 1; _J1 <= _J0; _J1 += 1) { /*19515*/
				$1.i = _J1; /*19513*/
				$put($1.cws, $1.dcws + $1.i, $get($get($1.ecbs, $1.i % $1.rsbl), ~~($1.i / $1.rsbl))); /*19514*/
			} /*19514*/
			var _JF = $1.stype ? 5 : 8; /*19518*/
			$1.mmat = $a(($1.dcws + $1.rscw) * _JF); /*19518*/
			$1.r = 0; /*19519*/
			$1.c = 0; /*19519*/
			var _JI = $1.stype ? 2 : 1; /*19520*/
			for (var _JL = 0, _JM = _JI, _JK = $1.cws.length - 1; _JM < 0 ? _JL >= _JK : _JL <= _JK; _JL += _JM) { /*19541*/
				$1.i = _JL; /*19521*/
				if (!$1.stype) { /*19535*/
					var _JP = $strcpy($s(8), "00000000"); /*19523*/
					var _JU = $cvrs($s(8), $get($1.cws, $1.i), 2); /*19523*/
					$puti(_JP, 8 - _JU.length, _JU); /*19524*/
					$k[$j++] = _JP; /*19524*/
					$k[$j++] = Infinity; /*19524*/
					var _JV = $k[--$j]; /*19524*/
					var _JW = $k[--$j]; /*19524*/
					$k[$j++] = _JV; /*19524*/
					$forall(_JW, function() { /*19524*/
						var _JX = $k[--$j]; /*19524*/
						$k[$j++] = _JX - 48; /*19524*/
					}); /*19524*/
					var _JY = $a(); /*19524*/
					$1.top = $geti(_JY, 0, 4); /*19525*/
					$1.bot = $geti(_JY, 4, 4); /*19526*/
				} else { /*19535*/
					var _Jc = $strcpy($s(5), "00000"); /*19528*/
					var _Jh = $cvrs($s(5), $get($1.cws, $1.i), 2); /*19528*/
					$puti(_Jc, 5 - _Jh.length, _Jh); /*19529*/
					$k[$j++] = _Jc; /*19529*/
					$k[$j++] = Infinity; /*19529*/
					var _Ji = $k[--$j]; /*19529*/
					var _Jj = $k[--$j]; /*19529*/
					$k[$j++] = _Ji; /*19529*/
					$forall(_Jj, function() { /*19529*/
						var _Jk = $k[--$j]; /*19529*/
						$k[$j++] = _Jk - 48; /*19529*/
					}); /*19529*/
					$1.c1 = $a(); /*19530*/
					var _Jn = $strcpy($s(5), "00000"); /*19531*/
					var _Js = $cvrs($s(5), $get($1.cws, $1.i + 1), 2); /*19531*/
					$puti(_Jn, 5 - _Js.length, _Js); /*19532*/
					$k[$j++] = _Jn; /*19532*/
					$k[$j++] = Infinity; /*19532*/
					var _Jt = $k[--$j]; /*19532*/
					var _Ju = $k[--$j]; /*19532*/
					$k[$j++] = _Jt; /*19532*/
					$forall(_Ju, function() { /*19532*/
						var _Jv = $k[--$j]; /*19532*/
						$k[$j++] = _Jv - 48; /*19532*/
					}); /*19532*/
					$1.c2 = $a(); /*19533*/
					$k[$j++] = Infinity; /*19534*/
					$aload($geti($1.c1, 0, 3)); /*19534*/
					$aload($geti($1.c2, 0, 2)); /*19534*/
					$1.top = $a(); /*19534*/
					$k[$j++] = Infinity; /*19535*/
					$aload($geti($1.c1, 3, 2)); /*19535*/
					$aload($geti($1.c2, 2, 3)); /*19535*/
					$1.bot = $a(); /*19535*/
				} /*19535*/
				$puti($1.mmat, ($1.r * $1.dcol) + $1.c, $1.top); /*19537*/
				$puti($1.mmat, (($1.r + 1) * $1.dcol) + $1.c, $1.bot); /*19538*/
				$1.c = $1.c + $1.top.length; /*19539*/
				if ($1.c == $1.dcol) { /*19540*/
					$1.c = 0; /*19540*/
					$1.r = $1.r + 2; /*19540*/
				} /*19540*/
			} /*19540*/
			$1.mmv = function() {
				var _KN = $k[--$j]; /*19544*/
				var _KO = $k[--$j]; /*19544*/
				$k[$j++] = _KO + (_KN * $1.cols); /*19544*/
			}; /*19544*/
			$k[$j++] = Infinity; /*19545*/
			for (var _KR = 0, _KS = $1.rows * $1.cols; _KR < _KS; _KR++) { /*19545*/
				$k[$j++] = -1; /*19545*/
			} /*19545*/
			$1.pixs = $a(); /*19545*/
			var _Ky = $a([function() {
				for (var _KV = 0, _KW = $1.cols; _KV < _KW; _KV++) { /*19549*/
					$k[$j++] = 0; /*19549*/
				} /*19549*/
			}, function() {
				for (var _KY = 0, _KZ = $1.cols; _KY < _KZ; _KY++) { /*19550*/
					$k[$j++] = 1; /*19550*/
				} /*19550*/
			}, function() {
				$k[$j++] = 0; /*19551*/
				for (var _Kb = 0, _Kc = $1.cols - 2; _Kb < _Kc; _Kb++) { /*19551*/
					$k[$j++] = 1; /*19551*/
				} /*19551*/
				$k[$j++] = 0; /*19551*/
			}, function() {
				$k[$j++] = 0; /*19552*/
				$k[$j++] = 1; /*19552*/
				for (var _Ke = 0, _Kf = $1.cols - 4; _Ke < _Kf; _Ke++) { /*19552*/
					$k[$j++] = 0; /*19552*/
				} /*19552*/
				$k[$j++] = 1; /*19552*/
				$k[$j++] = 0; /*19552*/
			}, function() {
				for (var _Kh = 0, _Ki = ~~(($1.cols - 1) / 2); _Kh < _Ki; _Kh++) { /*19553*/
					$k[$j++] = -1; /*19553*/
				} /*19553*/
				$k[$j++] = 1; /*19553*/
				for (var _Kk = 0, _Kl = ~~(($1.cols - 1) / 2); _Kk < _Kl; _Kk++) { /*19553*/
					$k[$j++] = -1; /*19553*/
				} /*19553*/
			}, function() {
				for (var _Kn = 0, _Ko = ~~(($1.cols - 1) / 2); _Kn < _Ko; _Kn++) { /*19554*/
					$k[$j++] = -1; /*19554*/
				} /*19554*/
				$k[$j++] = 0; /*19554*/
				for (var _Kq = 0, _Kr = ~~(($1.cols - 1) / 2); _Kq < _Kr; _Kq++) { /*19554*/
					$k[$j++] = -1; /*19554*/
				} /*19554*/
			}, function() {
				$k[$j++] = 1; /*19555*/
				for (var _Kt = 0, _Ku = $1.cols - 2; _Kt < _Ku; _Kt++) { /*19555*/
					$k[$j++] = 0; /*19555*/
				} /*19555*/
				$k[$j++] = 1; /*19555*/
			}, function() {
				$k[$j++] = 1; /*19556*/
				$k[$j++] = 0; /*19556*/
				for (var _Kw = 0, _Kx = $1.cols - 4; _Kw < _Kx; _Kw++) { /*19556*/
					$k[$j++] = 1; /*19556*/
				} /*19556*/
				$k[$j++] = 0; /*19556*/
				$k[$j++] = 1; /*19556*/
			}]); /*19556*/
			$1.artifact = _Ky; /*19557*/
			var _Kz = {
				A: "121343",
				B: "12134343",
				C: "12121343",
				D: "1213434343",
				E: "1212134343",
				F: "1212121343",
				G: "121213434343",
				H: "121212134343",
				S: "56661278",
				T: "5666666666127878"
			}; /*19568*/
			$1.cpat = $get(_Kz, $geti($1.vers, 0, 1)); /*19569*/
			$k[$j++] = $1.pixs; /*19570*/
			$k[$j++] = 0; /*19570*/
			$k[$j++] = ~~(($1.rows - $1.cpat.length) / 2); /*19570*/
			if ($1.mmv() == $b) return $b; /*19570*/
			$k[$j++] = Infinity; /*19571*/
			$forall($1.cpat, function() { /*19571*/
				$get($1.artifact, $k[--$j] - 49)(); /*19571*/
			}); /*19571*/
			var _LA = $a(); /*19571*/
			var _LB = $k[--$j]; /*19571*/
			$puti($k[--$j], _LB, _LA); /*19571*/
			for (var _LF = 0, _LE = $1.risl - 1; _LF <= _LE; _LF += 1) { /*19586*/
				$1.i = _LF; /*19575*/
				for (var _LK = $1.riso, _LL = $1.risi, _LJ = $1.cols - 1; _LL < 0 ? _LK >= _LJ : _LK <= _LJ; _LK += _LL) { /*19585*/
					$1.j = _LK; /*19577*/
					var _LN = (($1.i % 12) == 0) ? 1 : 0; /*19578*/
					var _LO = $a([1, _LN]); /*19578*/
					$k[$j++] = _LO; /*19579*/
					$k[$j++] = _LO; /*19579*/
					$k[$j++] = $1.pixs; /*19579*/
					$k[$j++] = $1.j; /*19579*/
					$k[$j++] = $1.i; /*19579*/
					if ($1.mmv() == $b) break; /*19579*/
					var _LS = $k[--$j]; /*19580*/
					var _LT = $k[--$j]; /*19580*/
					$puti(_LT, _LS, $k[--$j]); /*19580*/
					if ($1.i != ($1.risl - 1)) { /*19584*/
						$k[$j++] = $1.pixs; /*19582*/
						$k[$j++] = ($1.cols - $1.j) - 2; /*19582*/
						$k[$j++] = ($1.rows - $1.i) - 1; /*19582*/
						if ($1.mmv() == $b) break; /*19582*/
						var _Lc = $k[--$j]; /*19583*/
						var _Ld = $k[--$j]; /*19583*/
						$puti(_Ld, _Lc, $k[--$j]); /*19583*/
					} else { /*19584*/
						$j--; /*19584*/
					} /*19584*/
				} /*19584*/
			} /*19584*/
			var _MI = {
				A: $a([$a([12, 5])]),
				B: $a([$a([16, 7])]),
				C: $a([$a([26, 12])]),
				D: $a([]),
				E: $a([$a([26, 23])]),
				F: $a([$a([26, 32]), $a([70, 32]), $a([26, 34]), $a([70, 34])]),
				G: $a([$a([27, 48]), $a([69, 48])]),
				H: $a([$a([26, 70]), $a([66, 70]), $a([106, 70]), $a([26, 72]), $a([66, 72]), $a([106, 72])]),
				"S-10": $a([]),
				"S-20": $a([$a([10, 4])]),
				"S-30": $a([$a([15, 4]), $a([15, 6])]),
				"T-16": $a([$a([8, 10])]),
				"T-32": $a([$a([16, 10]), $a([16, 12])]),
				"T-48": $a([$a([24, 10]), $a([24, 12]), $a([24, 14])])
			}; /*19603*/
			$forall($get(_MI, $1.vers), function() { /*19604*/
				var _MM = $k[--$j]; /*19604*/
				$k[$j++] = $1.pixs; /*19604*/
				$aload(_MM); /*19604*/
				if ($1.mmv() == $b) return $b; /*19604*/
				var _MN = $k[--$j]; /*19604*/
				$put($k[--$j], _MN, 1); /*19604*/
			}); /*19604*/
			$1.j = 0; /*19607*/
			for (var _MR = 0, _MQ = $1.pixs.length - 1; _MR <= _MQ; _MR += 1) { /*19614*/
				$1.i = _MR; /*19609*/
				if ($get($1.pixs, $1.i) == -1) { /*19613*/
					$put($1.pixs, $1.i, $get($1.mmat, $1.j)); /*19611*/
					$1.j = $1.j + 1; /*19612*/
				} /*19612*/
			} /*19612*/
			var _Mh = {
				ren: $0.renmatrix,
				pixs: $1.pixs,
				pixx: $1.cols,
				pixy: $1.rows,
				height: ($1.rows / 72) * 2,
				width: ($1.cols / 72) * 2,
				opt: $1.options
			}; /*19624*/
			$k[$j++] = _Mh; /*19627*/
			if (!$1.dontdraw) { /*19627*/
				$0.renmatrix(); /*19627*/
			} /*19627*/
		};
		$0.hanxin = function() {
			var $1 = {}; /*19654*/
			$1.options = $k[--$j]; /*19656*/
			$1.barcode = $k[--$j]; /*19657*/
			$1.dontdraw = false; /*19659*/
			$1.version = "unset"; /*19660*/
			$1.eclevel = "unset"; /*19661*/
			$1.parse = false; /*19662*/
			$1.parsefnc = false; /*19663*/
			$1.mask = -1; /*19664*/
			$forall($1.options, function() { /*19675*/
				var _3 = $k[--$j]; /*19675*/
				$1[$k[--$j]] = _3; /*19675*/
			}); /*19675*/
			$1.mask = ~~$1.mask; /*19677*/
			$1.barlen = $1.barcode.length; /*19700*/
			var _7 = {
	
			}; /*19705*/
			$1.fncvals = _7; /*19705*/
			$1.msg = $a($1.barlen); /*19706*/
			$1.i = 0; /*19707*/
			$1.j = 0; /*19707*/
			for (;;) { /*19721*/
				if ($1.i == $1.barlen) { /*19708*/
					break; /*19708*/
				} /*19708*/
				$1.char = $get($1.barcode, $1.i); /*19709*/
				if (($1.parsefnc && ($1.char == 94)) && ($1.i < ($1.barlen - 4))) { /*19717*/
					if ($get($1.barcode, $1.i + 1) != 94) { /*19715*/
						$1.char = $get($1.fncvals, $geti($1.barcode, $1.i + 1, 4)); /*19712*/
						$1.i = $1.i + 4; /*19713*/
					} else { /*19715*/
						$1.i = $1.i + 1; /*19715*/
					} /*19715*/
				} /*19715*/
				$put($1.msg, $1.j, $1.char); /*19718*/
				$1.i = $1.i + 1; /*19719*/
				$1.j = $1.j + 1; /*19720*/
			} /*19720*/
			$1.msg = $geti($1.msg, 0, $1.j); /*19722*/
			$1.msglen = $1.msg.length; /*19723*/
			if ($eq($1.eclevel, "unset")) { /*19726*/
				$1.eclevel = "L2"; /*19726*/
			} /*19726*/
			$1.tobin = function() {
				var _e = $s($k[--$j]); /*19729*/
				$k[$j++] = _e; /*19729*/
				for (var _g = 0, _f = _e.length - 1; _g <= _f; _g += 1) { /*19729*/
					var _h = $k[--$j]; /*19729*/
					$put(_h, _g, 48); /*19729*/
					$k[$j++] = _h; /*19729*/
				} /*19729*/
				var _i = $k[--$j]; /*19730*/
				var _l = $cvrs($s(_i.length), $k[--$j], 2); /*19730*/
				$puti(_i, _i.length - _l.length, _l); /*19731*/
				$k[$j++] = _i; /*19731*/
			}; /*19732*/
			$1.bits = $s((4 + 13) + ($1.msglen * 8)); /*19735*/
			$puti($1.bits, 0, "0011"); /*19736*/
			$k[$j++] = $1.bits; /*19737*/
			$k[$j++] = 4; /*19737*/
			$k[$j++] = $1.msglen; /*19737*/
			$k[$j++] = 13; /*19737*/
			if ($1.tobin() == $b) return $b; /*19737*/
			var _r = $k[--$j]; /*19737*/
			var _s = $k[--$j]; /*19737*/
			$puti($k[--$j], _s, _r); /*19737*/
			for (var _w = 0, _v = $1.msglen - 1; _w <= _v; _w += 1) { /*19741*/
				$1.i = _w; /*19739*/
				$k[$j++] = $1.bits; /*19740*/
				$k[$j++] = 17 + ($1.i * 8); /*19740*/
				$k[$j++] = $get($1.msg, $1.i); /*19740*/
				$k[$j++] = 8; /*19740*/
				if ($1.tobin() == $b) break; /*19740*/
				var _12 = $k[--$j]; /*19740*/
				var _13 = $k[--$j]; /*19740*/
				$puti($k[--$j], _13, _12); /*19740*/
			} /*19740*/
			$1.metrics = $a([$a(["1", 23, -1, 0, 205, $a([1, 21, 4]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 17, 8]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 13, 12]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 9, 16]), $a([0, -1, -1]), $a([0, -1, -1])]), $a(["2", 25, -1, 0, 301, $a([1, 31, 6]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 25, 12]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 19, 18]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 15, 22]), $a([0, -1, -1]), $a([0, -1, -1])]), $a(["3", 27, -1, 0, 405, $a([1, 42, 8]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 34, 16]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 26, 24]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 20, 30]), $a([0, -1, -1]), $a([0, -1, -1])]), $a(["4", 29, 14, 1, 439, $a([1, 46, 8]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 38, 16]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 30, 24]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 22, 32]), $a([0, -1, -1]), $a([0, -1, -1])]), $a(["5", 31, 16, 1, 555, $a([1, 57, 12]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 49, 20]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 37, 32]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 14, 20]), $a([1, 13, 22]), $a([0, -1, -1])]), $a(["6", 33, 16, 1, 675, $a([1, 70, 14]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 58, 26]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 24, 20]), $a([1, 22, 18]), $a([0, -1, -1]), $a([1, 16, 24]), $a([1, 18, 26]), $a([0, -1, -1])]), $a(["7", 35, 17, 1, 805, $a([1, 84, 16]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 70, 30]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 26, 22]), $a([1, 28, 24]), $a([0, -1, -1]), $a([2, 14, 20]), $a([1, 12, 20]), $a([0, -1, -1])]), $a(["8", 37, 18, 1, 943, $a([1, 99, 18]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 40, 18]), $a([1, 41, 18]), $a([0, -1, -1]), $a([1, 31, 26]), $a([1, 32, 28]), $a([0, -1, -1]), $a([2, 16, 24]), $a([1, 15, 22]), $a([0, -1, -1])]), $a(["9", 39, 19, 1, 1089, $a([1, 114, 22]), $a([0, -1, -1]), $a([0, -1, -1]), $a([2, 48, 20]), $a([0, -1, -1]), $a([0, -1, -1]), $a([2, 24, 20]), $a([1, 26, 22]), $a([0, -1, -1]), $a([2, 18, 28]), $a([1, 18, 26]), $a([0, -1, -1])]), $a(["10", 41, 20, 1, 1243, $a([1, 131, 24]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 52, 22]), $a([1, 57, 24]), $a([0, -1, -1]), $a([2, 27, 24]), $a([1, 29, 24]), $a([0, -1, -1]), $a([2, 21, 32]), $a([1, 19, 30]), $a([0, -1, -1])]), $a(["11", 43, 14, 2, 1289, $a([1, 135, 26]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 56, 24]), $a([1, 57, 24]), $a([0, -1, -1]), $a([2, 28, 24]), $a([1, 31, 26]), $a([0, -1, -1]), $a([2, 22, 32]), $a([1, 21, 32]), $a([0, -1, -1])]), $a(["12", 45, 15, 2, 1455, $a([1, 153, 28]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 62, 26]), $a([1, 65, 28]), $a([0, -1, -1]), $a([2, 32, 28]), $a([1, 33, 28]), $a([0, -1, -1]), $a([3, 17, 26]), $a([1, 22, 30]), $a([0, -1, -1])]), $a(["13", 47, 16, 2, 1629, $a([1, 86, 16]), $a([1, 85, 16]), $a([0, -1, -1]), $a([1, 71, 30]), $a([1, 72, 30]), $a([0, -1, -1]), $a([2, 37, 32]), $a([1, 35, 30]), $a([0, -1, -1]), $a([3, 20, 30]), $a([1, 21, 32]), $a([0, -1, -1])]), $a(["14", 49, 16, 2, 1805, $a([1, 94, 18]), $a([1, 95, 18]), $a([0, -1, -1]), $a([2, 51, 22]), $a([1, 55, 24]), $a([0, -1, -1]), $a([3, 30, 26]), $a([1, 31, 26]), $a([0, -1, -1]), $a([4, 18, 28]), $a([1, 17, 24]), $a([0, -1, -1])]), $a(["15", 51, 17, 2, 1995, $a([1, 104, 20]), $a([1, 105, 20]), $a([0, -1, -1]), $a([2, 57, 24]), $a([1, 61, 26]), $a([0, -1, -1]), $a([3, 33, 28]), $a([1, 36, 30]), $a([0, -1, -1]), $a([4, 20, 30]), $a([1, 19, 30]), $a([0, -1, -1])]), $a(["16", 53, 17, 2, 2187, $a([1, 115, 22]), $a([1, 114, 22]), $a([0, -1, -1]), $a([2, 65, 28]), $a([1, 61, 26]), $a([0, -1, -1]), $a([3, 38, 32]), $a([1, 33, 30]), $a([0, -1, -1]), $a([5, 19, 28]), $a([1, 14, 24]), $a([0, -1, -1])]), $a(["17", 55, 18, 2, 2393, $a([1, 126, 24]), $a([1, 125, 24]), $a([0, -1, -1]), $a([2, 70, 30]), $a([1, 69, 30]), $a([0, -1, -1]), $a([4, 33, 28]), $a([1, 29, 26]), $a([0, -1, -1]), $a([5, 20, 30]), $a([1, 19, 30]), $a([0, -1, -1])]), $a(["18", 57, 19, 2, 2607, $a([1, 136, 26]), $a([1, 137, 26]), $a([0, -1, -1]), $a([3, 56, 24]), $a([1, 59, 26]), $a([0, -1, -1]), $a([5, 35, 30]), $a([0, -1, -1]), $a([0, -1, -1]), $a([6, 18, 28]), $a([1, 21, 28]), $a([0, -1, -1])]), $a(["19", 59, 20, 2, 2829, $a([1, 148, 28]), $a([1, 149, 28]), $a([0, -1, -1]), $a([3, 61, 26]), $a([1, 64, 28]), $a([0, -1, -1]), $a([7, 24, 20]), $a([1, 23, 22]), $a([0, -1, -1]), $a([6, 20, 30]), $a([1, 21, 32]), $a([0, -1, -1])]), $a(["20", 61, 20, 2, 3053, $a([3, 107, 20]), $a([0, -1, -1]), $a([0, -1, -1]), $a([3, 65, 28]), $a([1, 72, 30]), $a([0, -1, -1]), $a([7, 26, 22]), $a([1, 23, 22]), $a([0, -1, -1]), $a([7, 19, 28]), $a([1, 20, 32]), $a([0, -1, -1])]), $a(["21", 63, 21, 2, 3291, $a([3, 115, 22]), $a([0, -1, -1]), $a([0, -1, -1]), $a([4, 56, 24]), $a([1, 63, 28]), $a([0, -1, -1]), $a([7, 28, 24]), $a([1, 25, 22]), $a([0, -1, -1]), $a([8, 18, 28]), $a([1, 21, 22]), $a([0, -1, -1])]), $a(["22", 65, 16, 3, 3383, $a([2, 116, 22]), $a([1, 122, 24]), $a([0, -1, -1]), $a([4, 56, 24]), $a([1, 72, 30]), $a([0, -1, -1]), $a([7, 28, 24]), $a([1, 32, 26]), $a([0, -1, -1]), $a([8, 18, 28]), $a([1, 24, 30]), $a([0, -1, -1])]), $a(["23", 67, 17, 3, 3631, $a([3, 127, 24]), $a([0, -1, -1]), $a([0, -1, -1]), $a([5, 51, 22]), $a([1, 62, 26]), $a([0, -1, -1]), $a([7, 30, 26]), $a([1, 35, 26]), $a([0, -1, -1]), $a([8, 20, 30]), $a([1, 21, 32]), $a([0, -1, -1])]), $a(["24", 69, 17, 3, 3887, $a([2, 135, 26]), $a([1, 137, 26]), $a([0, -1, -1]), $a([5, 56, 24]), $a([1, 59, 26]), $a([0, -1, -1]), $a([7, 33, 28]), $a([1, 30, 28]), $a([0, -1, -1]), $a([11, 16, 24]), $a([1, 19, 26]), $a([0, -1, -1])]), $a(["25", 71, 18, 3, 4151, $a([3, 105, 20]), $a([1, 121, 22]), $a([0, -1, -1]), $a([5, 61, 26]), $a([1, 57, 26]), $a([0, -1, -1]), $a([9, 28, 24]), $a([1, 28, 22]), $a([0, -1, -1]), $a([10, 19, 28]), $a([1, 18, 30]), $a([0, -1, -1])]), $a(["26", 73, 18, 3, 4423, $a([2, 157, 30]), $a([1, 150, 28]), $a([0, -1, -1]), $a([5, 65, 28]), $a([1, 61, 26]), $a([0, -1, -1]), $a([8, 33, 28]), $a([1, 34, 30]), $a([0, -1, -1]), $a([10, 19, 28]), $a([2, 15, 26]), $a([0, -1, -1])]), $a(["27", 75, 19, 3, 4703, $a([3, 126, 24]), $a([1, 115, 22]), $a([0, -1, -1]), $a([7, 51, 22]), $a([1, 54, 22]), $a([0, -1, -1]), $a([8, 35, 30]), $a([1, 37, 30]), $a([0, -1, -1]), $a([15, 15, 22]), $a([1, 10, 22]), $a([0, -1, -1])]), $a(["28", 77, 19, 3, 4991, $a([4, 105, 20]), $a([1, 103, 20]), $a([0, -1, -1]), $a([7, 56, 24]), $a([1, 45, 18]), $a([0, -1, -1]), $a([10, 31, 26]), $a([1, 27, 26]), $a([0, -1, -1]), $a([10, 17, 26]), $a([3, 20, 28]), $a([1, 21, 28])]), $a(["29", 79, 20, 3, 5287, $a([3, 139, 26]), $a([1, 137, 28]), $a([0, -1, -1]), $a([6, 66, 28]), $a([1, 66, 30]), $a([0, -1, -1]), $a([9, 36, 30]), $a([1, 34, 32]), $a([0, -1, -1]), $a([13, 19, 28]), $a([1, 17, 32]), $a([0, -1, -1])]), $a(["30", 81, 20, 3, 5591, $a([6, 84, 16]), $a([1, 82, 16]), $a([0, -1, -1]), $a([6, 70, 30]), $a([1, 68, 30]), $a([0, -1, -1]), $a([7, 35, 30]), $a([3, 33, 28]), $a([1, 32, 28]), $a([13, 20, 30]), $a([1, 20, 28]), $a([0, -1, -1])]), $a(["31", 83, 21, 3, 5903, $a([5, 105, 20]), $a([1, 94, 18]), $a([0, -1, -1]), $a([6, 74, 32]), $a([1, 71, 30]), $a([0, -1, -1]), $a([11, 33, 28]), $a([1, 34, 32]), $a([0, -1, -1]), $a([13, 19, 28]), $a([3, 16, 26]), $a([0, -1, -1])]), $a(["32", 85, 17, 4, 6033, $a([4, 127, 24]), $a([1, 126, 24]), $a([0, -1, -1]), $a([7, 66, 28]), $a([1, 66, 30]), $a([0, -1, -1]), $a([12, 30, 24]), $a([1, 24, 28]), $a([1, 24, 30]), $a([15, 19, 28]), $a([1, 17, 32]), $a([0, -1, -1])]), $a(["33", 87, 17, 4, 6353, $a([7, 84, 16]), $a([1, 78, 16]), $a([0, -1, -1]), $a([7, 70, 30]), $a([1, 66, 28]), $a([0, -1, -1]), $a([12, 33, 28]), $a([1, 32, 30]), $a([0, -1, -1]), $a([14, 21, 32]), $a([1, 24, 28]), $a([0, -1, -1])]), $a(["34", 89, 18, 4, 6689, $a([5, 117, 22]), $a([1, 117, 24]), $a([0, -1, -1]), $a([8, 66, 28]), $a([1, 58, 26]), $a([0, -1, -1]), $a([11, 38, 32]), $a([1, 34, 32]), $a([0, -1, -1]), $a([15, 20, 30]), $a([2, 17, 26]), $a([0, -1, -1])]), $a(["35", 91, 18, 4, 7025, $a([4, 148, 28]), $a([1, 146, 28]), $a([0, -1, -1]), $a([8, 68, 30]), $a([1, 70, 24]), $a([0, -1, -1]), $a([10, 36, 32]), $a([3, 38, 28]), $a([0, -1, -1]), $a([16, 19, 28]), $a([3, 16, 26]), $a([0, -1, -1])]), $a(["36", 93, 19, 4, 7377, $a([4, 126, 24]), $a([2, 135, 26]), $a([0, -1, -1]), $a([8, 70, 28]), $a([2, 43, 26]), $a([0, -1, -1]), $a([13, 32, 28]), $a([2, 41, 30]), $a([0, -1, -1]), $a([17, 19, 28]), $a([3, 15, 26]), $a([0, -1, -1])]), $a(["37", 95, 19, 4, 7729, $a([5, 136, 26]), $a([1, 132, 24]), $a([0, -1, -1]), $a([5, 67, 30]), $a([4, 68, 28]), $a([1, 69, 28]), $a([14, 35, 30]), $a([1, 32, 24]), $a([0, -1, -1]), $a([18, 18, 26]), $a([3, 16, 28]), $a([1, 14, 28])]), $a(["38", 97, 19, 4, 8089, $a([3, 142, 26]), $a([3, 141, 28]), $a([0, -1, -1]), $a([8, 70, 30]), $a([1, 73, 32]), $a([1, 74, 32]), $a([12, 34, 30]), $a([3, 34, 26]), $a([1, 35, 28]), $a([18, 21, 32]), $a([1, 27, 30]), $a([0, -1, -1])]), $a(["39", 99, 20, 4, 8465, $a([5, 116, 22]), $a([2, 103, 20]), $a([1, 102, 20]), $a([9, 74, 32]), $a([1, 74, 30]), $a([0, -1, -1]), $a([14, 34, 28]), $a([2, 32, 32]), $a([1, 32, 30]), $a([19, 21, 32]), $a([1, 25, 26]), $a([0, -1, -1])]), $a(["40", 101, 20, 4, 8841, $a([7, 116, 22]), $a([1, 117, 22]), $a([0, -1, -1]), $a([11, 65, 28]), $a([1, 58, 24]), $a([0, -1, -1]), $a([15, 38, 32]), $a([1, 27, 28]), $a([0, -1, -1]), $a([20, 20, 30]), $a([1, 20, 32]), $a([1, 21, 32])]), $a(["41", 103, 17, 5, 9009, $a([6, 136, 26]), $a([1, 130, 24]), $a([0, -1, -1]), $a([11, 66, 28]), $a([1, 62, 30]), $a([0, -1, -1]), $a([14, 34, 28]), $a([3, 34, 32]), $a([1, 30, 30]), $a([18, 20, 30]), $a([3, 20, 28]), $a([2, 15, 26])]), $a(["42", 105, 17, 5, 9401, $a([5, 105, 20]), $a([2, 115, 22]), $a([2, 116, 22]), $a([10, 75, 32]), $a([1, 73, 32]), $a([0, -1, -1]), $a([16, 38, 32]), $a([1, 27, 28]), $a([0, -1, -1]), $a([22, 19, 28]), $a([2, 16, 30]), $a([1, 19, 30])]), $a(["43", 107, 18, 5, 9799, $a([6, 147, 28]), $a([1, 146, 28]), $a([0, -1, -1]), $a([11, 66, 28]), $a([2, 65, 30]), $a([0, -1, -1]), $a([18, 33, 28]), $a([2, 33, 30]), $a([0, -1, -1]), $a([22, 21, 32]), $a([1, 28, 30]), $a([0, -1, -1])]), $a(["44", 109, 18, 5, 10207, $a([6, 116, 22]), $a([3, 125, 24]), $a([0, -1, -1]), $a([11, 75, 32]), $a([1, 68, 30]), $a([0, -1, -1]), $a([13, 35, 28]), $a([6, 34, 32]), $a([1, 30, 30]), $a([23, 21, 32]), $a([1, 26, 30]), $a([0, -1, -1])]), $a(["45", 111, 18, 5, 10623, $a([7, 105, 20]), $a([4, 95, 18]), $a([0, -1, -1]), $a([12, 67, 28]), $a([1, 63, 30]), $a([1, 62, 32]), $a([21, 31, 26]), $a([2, 33, 32]), $a([0, -1, -1]), $a([23, 21, 32]), $a([2, 24, 30]), $a([0, -1, -1])]), $a(["46", 113, 19, 5, 11045, $a([10, 116, 22]), $a([0, -1, -1]), $a([0, -1, -1]), $a([12, 74, 32]), $a([1, 78, 30]), $a([0, -1, -1]), $a([18, 37, 32]), $a([1, 39, 30]), $a([1, 41, 28]), $a([25, 21, 32]), $a([1, 27, 28]), $a([0, -1, -1])]), $a(["47", 115, 19, 5, 11477, $a([5, 126, 24]), $a([4, 115, 22]), $a([1, 114, 22]), $a([12, 67, 28]), $a([2, 66, 32]), $a([1, 68, 30]), $a([21, 35, 30]), $a([1, 39, 30]), $a([0, -1, -1]), $a([26, 21, 32]), $a([1, 28, 28]), $a([0, -1, -1])]), $a(["48", 117, 19, 5, 11917, $a([9, 126, 24]), $a([1, 117, 22]), $a([0, -1, -1]), $a([13, 75, 32]), $a([1, 68, 30]), $a([0, -1, -1]), $a([20, 35, 30]), $a([3, 35, 28]), $a([0, -1, -1]), $a([27, 21, 32]), $a([1, 28, 30]), $a([0, -1, -1])]), $a(["49", 119, 17, 6, 12111, $a([9, 126, 24]), $a([1, 137, 26]), $a([0, -1, -1]), $a([13, 71, 30]), $a([2, 68, 32]), $a([0, -1, -1]), $a([20, 37, 32]), $a([1, 39, 28]), $a([1, 38, 28]), $a([24, 20, 32]), $a([5, 25, 28]), $a([0, -1, -1])]), $a(["50", 121, 17, 6, 12559, $a([8, 147, 28]), $a([1, 141, 28]), $a([0, -1, -1]), $a([10, 73, 32]), $a([4, 74, 30]), $a([1, 73, 30]), $a([16, 36, 32]), $a([6, 39, 30]), $a([1, 37, 30]), $a([27, 21, 32]), $a([3, 20, 26]), $a([0, -1, -1])]), $a(["51", 123, 18, 6, 13025, $a([9, 137, 26]), $a([1, 135, 26]), $a([0, -1, -1]), $a([12, 70, 30]), $a([4, 75, 32]), $a([0, -1, -1]), $a([24, 35, 30]), $a([1, 40, 28]), $a([0, -1, -1]), $a([23, 20, 32]), $a([8, 24, 30]), $a([0, -1, -1])]), $a(["52", 125, 18, 6, 13489, $a([14, 95, 18]), $a([1, 86, 18]), $a([0, -1, -1]), $a([13, 73, 32]), $a([3, 77, 30]), $a([0, -1, -1]), $a([24, 35, 30]), $a([2, 35, 28]), $a([0, -1, -1]), $a([26, 21, 32]), $a([5, 21, 30]), $a([1, 23, 30])]), $a(["53", 127, 18, 6, 13961, $a([9, 147, 28]), $a([1, 142, 28]), $a([0, -1, -1]), $a([10, 73, 30]), $a([6, 70, 32]), $a([1, 71, 32]), $a([25, 35, 30]), $a([2, 34, 26]), $a([0, -1, -1]), $a([29, 21, 32]), $a([4, 22, 30]), $a([0, -1, -1])]), $a(["54", 129, 18, 6, 14441, $a([11, 126, 24]), $a([1, 131, 24]), $a([0, -1, -1]), $a([16, 74, 32]), $a([1, 79, 30]), $a([0, -1, -1]), $a([25, 38, 32]), $a([1, 25, 30]), $a([0, -1, -1]), $a([33, 21, 32]), $a([1, 28, 28]), $a([0, -1, -1])]), $a(["55", 131, 19, 6, 14939, $a([14, 105, 20]), $a([1, 99, 18]), $a([0, -1, -1]), $a([19, 65, 28]), $a([1, 72, 28]), $a([0, -1, -1]), $a([24, 37, 32]), $a([2, 40, 30]), $a([1, 41, 30]), $a([31, 21, 32]), $a([4, 24, 32]), $a([0, -1, -1])]), $a(["56", 133, 19, 6, 15435, $a([10, 147, 28]), $a([1, 151, 28]), $a([0, -1, -1]), $a([15, 71, 30]), $a([3, 71, 32]), $a([1, 73, 32]), $a([24, 37, 32]), $a([3, 38, 30]), $a([1, 39, 30]), $a([36, 19, 30]), $a([3, 29, 26]), $a([0, -1, -1])]), $a(["57", 135, 19, 6, 15939, $a([15, 105, 20]), $a([1, 99, 18]), $a([0, -1, -1]), $a([19, 70, 30]), $a([1, 64, 28]), $a([0, -1, -1]), $a([27, 38, 32]), $a([2, 25, 26]), $a([0, -1, -1]), $a([38, 20, 30]), $a([2, 18, 28]), $a([0, -1, -1])]), $a(["58", 137, 17, 7, 16171, $a([14, 105, 20]), $a([1, 113, 22]), $a([1, 114, 22]), $a([17, 67, 30]), $a([3, 92, 32]), $a([0, -1, -1]), $a([30, 35, 30]), $a([1, 41, 30]), $a([0, -1, -1]), $a([36, 21, 32]), $a([1, 26, 30]), $a([1, 27, 30])]), $a(["59", 139, 17, 7, 16691, $a([11, 146, 28]), $a([1, 146, 26]), $a([0, -1, -1]), $a([20, 70, 30]), $a([1, 60, 26]), $a([0, -1, -1]), $a([29, 38, 32]), $a([1, 24, 32]), $a([0, -1, -1]), $a([40, 20, 30]), $a([2, 17, 26]), $a([0, -1, -1])]), $a(["60", 141, 18, 7, 17215, $a([3, 137, 26]), $a([1, 136, 26]), $a([10, 126, 24]), $a([22, 65, 28]), $a([1, 75, 30]), $a([0, -1, -1]), $a([30, 37, 32]), $a([1, 51, 30]), $a([0, -1, -1]), $a([42, 20, 30]), $a([1, 21, 30]), $a([0, -1, -1])]), $a(["61", 143, 18, 7, 17751, $a([12, 126, 24]), $a([2, 118, 22]), $a([1, 116, 22]), $a([19, 74, 32]), $a([1, 74, 30]), $a([1, 72, 28]), $a([30, 38, 32]), $a([2, 29, 30]), $a([0, -1, -1]), $a([39, 20, 32]), $a([2, 37, 26]), $a([1, 38, 26])]), $a(["62", 145, 18, 7, 18295, $a([12, 126, 24]), $a([3, 136, 26]), $a([0, -1, -1]), $a([21, 70, 30]), $a([2, 65, 28]), $a([0, -1, -1]), $a([34, 35, 30]), $a([1, 44, 32]), $a([0, -1, -1]), $a([42, 20, 30]), $a([2, 19, 28]), $a([2, 18, 28])]), $a(["63", 147, 18, 7, 18847, $a([12, 126, 24]), $a([3, 117, 22]), $a([1, 116, 22]), $a([25, 61, 26]), $a([2, 62, 28]), $a([0, -1, -1]), $a([34, 35, 30]), $a([1, 40, 32]), $a([1, 41, 32]), $a([45, 20, 30]), $a([1, 20, 32]), $a([1, 21, 32])]), $a(["64", 149, 19, 7, 19403, $a([15, 105, 20]), $a([2, 115, 22]), $a([2, 116, 22]), $a([25, 65, 28]), $a([1, 72, 28]), $a([0, -1, -1]), $a([18, 35, 30]), $a([17, 37, 32]), $a([1, 50, 32]), $a([42, 20, 30]), $a([6, 19, 28]), $a([1, 15, 28])]), $a(["65", 151, 19, 7, 19971, $a([19, 105, 20]), $a([1, 101, 20]), $a([0, -1, -1]), $a([33, 51, 22]), $a([1, 65, 22]), $a([0, -1, -1]), $a([40, 33, 28]), $a([1, 28, 28]), $a([0, -1, -1]), $a([49, 20, 30]), $a([1, 18, 28]), $a([0, -1, -1])]), $a(["66", 153, 17, 8, 20229, $a([18, 105, 20]), $a([2, 117, 22]), $a([0, -1, -1]), $a([26, 65, 28]), $a([1, 80, 30]), $a([0, -1, -1]), $a([35, 35, 30]), $a([3, 35, 28]), $a([1, 36, 28]), $a([52, 18, 28]), $a([2, 38, 30]), $a([0, -1, -1])]), $a(["67", 155, 17, 8, 20805, $a([26, 84, 16]), $a([0, -1, -1]), $a([0, -1, -1]), $a([26, 70, 30]), $a([0, -1, -1]), $a([0, -1, -1]), $a([45, 31, 26]), $a([1, 9, 26]), $a([0, -1, -1]), $a([52, 20, 30]), $a([0, -1, -1]), $a([0, -1, -1])]), $a(["68", 157, 17, 8, 21389, $a([16, 126, 24]), $a([1, 114, 22]), $a([1, 115, 22]), $a([23, 70, 30]), $a([3, 65, 28]), $a([1, 66, 28]), $a([40, 35, 30]), $a([1, 43, 30]), $a([0, -1, -1]), $a([46, 20, 30]), $a([7, 19, 28]), $a([1, 16, 28])]), $a(["69", 159, 18, 8, 21993, $a([19, 116, 22]), $a([1, 105, 22]), $a([0, -1, -1]), $a([20, 70, 30]), $a([7, 66, 28]), $a([1, 63, 28]), $a([40, 35, 30]), $a([1, 42, 32]), $a([1, 43, 32]), $a([54, 20, 30]), $a([1, 19, 30]), $a([0, -1, -1])]), $a(["70", 161, 18, 8, 22593, $a([17, 126, 24]), $a([2, 115, 22]), $a([0, -1, -1]), $a([24, 70, 30]), $a([4, 74, 32]), $a([0, -1, -1]), $a([48, 31, 26]), $a([2, 18, 26]), $a([0, -1, -1]), $a([54, 19, 28]), $a([6, 15, 26]), $a([1, 14, 26])]), $a(["71", 163, 18, 8, 23201, $a([29, 84, 16]), $a([0, -1, -1]), $a([0, -1, -1]), $a([29, 70, 30]), $a([0, -1, -1]), $a([0, -1, -1]), $a([6, 34, 30]), $a([3, 36, 30]), $a([38, 33, 28]), $a([58, 20, 30]), $a([0, -1, -1]), $a([0, -1, -1])]), $a(["72", 165, 18, 8, 23817, $a([16, 147, 28]), $a([1, 149, 28]), $a([0, -1, -1]), $a([31, 66, 28]), $a([1, 37, 26]), $a([0, -1, -1]), $a([48, 33, 28]), $a([1, 23, 26]), $a([0, -1, -1]), $a([53, 20, 30]), $a([6, 19, 28]), $a([1, 17, 28])]), $a(["73", 167, 19, 8, 24453, $a([20, 115, 22]), $a([2, 134, 24]), $a([0, -1, -1]), $a([29, 66, 28]), $a([2, 56, 26]), $a([2, 57, 26]), $a([45, 36, 30]), $a([2, 15, 28]), $a([0, -1, -1]), $a([59, 20, 30]), $a([2, 21, 32]), $a([0, -1, -1])]), $a(["74", 169, 19, 8, 25085, $a([17, 147, 28]), $a([1, 134, 26]), $a([0, -1, -1]), $a([26, 70, 30]), $a([5, 75, 32]), $a([0, -1, -1]), $a([47, 35, 30]), $a([1, 48, 32]), $a([0, -1, -1]), $a([64, 18, 28]), $a([2, 33, 30]), $a([1, 35, 30])]), $a(["75", 171, 17, 9, 25373, $a([22, 115, 22]), $a([1, 133, 24]), $a([0, -1, -1]), $a([33, 65, 28]), $a([1, 74, 28]), $a([0, -1, -1]), $a([43, 36, 30]), $a([5, 27, 28]), $a([1, 30, 28]), $a([57, 20, 30]), $a([5, 21, 32]), $a([1, 24, 32])]), $a(["76", 173, 17, 9, 26021, $a([18, 136, 26]), $a([2, 142, 26]), $a([0, -1, -1]), $a([33, 66, 28]), $a([2, 49, 26]), $a([0, -1, -1]), $a([48, 35, 30]), $a([2, 38, 28]), $a([0, -1, -1]), $a([64, 20, 30]), $a([1, 20, 32]), $a([0, -1, -1])]), $a(["77", 175, 17, 9, 26677, $a([19, 126, 24]), $a([2, 135, 26]), $a([1, 136, 26]), $a([32, 66, 28]), $a([2, 55, 26]), $a([2, 56, 26]), $a([49, 36, 30]), $a([2, 18, 32]), $a([0, -1, -1]), $a([65, 18, 28]), $a([5, 27, 30]), $a([1, 29, 30])]), $a(["78", 177, 18, 9, 27335, $a([20, 137, 26]), $a([1, 130, 26]), $a([0, -1, -1]), $a([30, 75, 32]), $a([2, 71, 32]), $a([0, -1, -1]), $a([46, 35, 30]), $a([6, 39, 32]), $a([0, -1, -1]), $a([3, 12, 30]), $a([70, 19, 28]), $a([0, -1, -1])]), $a(["79", 179, 18, 9, 28007, $a([20, 147, 28]), $a([0, -1, -1]), $a([0, -1, -1]), $a([35, 70, 30]), $a([0, -1, -1]), $a([0, -1, -1]), $a([49, 35, 30]), $a([5, 35, 28]), $a([0, -1, -1]), $a([70, 20, 30]), $a([0, -1, -1]), $a([0, -1, -1])]), $a(["80", 181, 18, 9, 28687, $a([21, 136, 26]), $a([1, 155, 28]), $a([0, -1, -1]), $a([34, 70, 30]), $a([1, 64, 28]), $a([1, 65, 28]), $a([54, 35, 30]), $a([1, 45, 30]), $a([0, -1, -1]), $a([68, 20, 30]), $a([3, 18, 28]), $a([1, 19, 28])]), $a(["81", 183, 18, 9, 29375, $a([19, 126, 24]), $a([5, 115, 22]), $a([1, 114, 22]), $a([33, 70, 30]), $a([3, 65, 28]), $a([1, 64, 28]), $a([52, 35, 30]), $a([3, 41, 32]), $a([1, 40, 32]), $a([67, 20, 30]), $a([5, 21, 32]), $a([1, 24, 32])]), $a(["82", 185, 18, 9, 30071, $a([2, 150, 28]), $a([21, 136, 26]), $a([0, -1, -1]), $a([32, 70, 30]), $a([6, 65, 28]), $a([0, -1, -1]), $a([52, 38, 32]), $a([2, 27, 32]), $a([0, -1, -1]), $a([73, 20, 30]), $a([2, 22, 32]), $a([0, -1, -1])]), $a(["83", 187, 17, 10, 30387, $a([21, 126, 24]), $a([4, 136, 26]), $a([0, -1, -1]), $a([30, 74, 32]), $a([6, 73, 30]), $a([0, -1, -1]), $a([54, 35, 30]), $a([4, 40, 32]), $a([0, -1, -1]), $a([75, 20, 30]), $a([1, 20, 28]), $a([0, -1, -1])]), $a(["84", 189, 17, 10, 31091, $a([30, 105, 20]), $a([1, 114, 22]), $a([0, -1, -1]), $a([3, 45, 22]), $a([55, 47, 20]), $a([0, -1, -1]), $a([2, 26, 26]), $a([62, 33, 28]), $a([0, -1, -1]), $a([79, 18, 28]), $a([4, 33, 30]), $a([0, -1, -1])])]); /*20082*/
			$1.eclval = $get($1.eclevel, 1) - 49; /*20084*/
			for (var _Ik = 0; _Ik <= 83; _Ik += 1) { /*20104*/
				$1.i = _Ik; /*20086*/
				$1.m = $get($1.metrics, $1.i); /*20087*/
				$1.vers = $get($1.m, 0); /*20088*/
				$1.size = $get($1.m, 1); /*20089*/
				$1.alnk = $get($1.m, 2); /*20090*/
				$1.alnn = $get($1.m, 3); /*20091*/
				$1.alnr = $1.size - ($1.alnk * $1.alnn); /*20092*/
				$1.nmod = $get($1.m, 4); /*20093*/
				$1.ncws = ~~($1.nmod / 8); /*20094*/
				$1.rbit = $1.nmod % 8; /*20095*/
				$1.ecbs = $geti($1.m, 5 + ($1.eclval * 3), 3); /*20096*/
				$k[$j++] = "ecws"; /*20097*/
				$k[$j++] = 0; /*20097*/
				$forall($1.ecbs, function() { /*20097*/
					var _J7 = $k[--$j]; /*20097*/
					var _JA = $k[--$j]; /*20097*/
					$k[$j++] = _JA + ($get(_J7, 0) * $get(_J7, 2)); /*20097*/
				}); /*20097*/
				var _JB = $k[--$j]; /*20097*/
				$1[$k[--$j]] = _JB; /*20097*/
				$1.dcws = $1.ncws - $1.ecws; /*20098*/
				$1.dmod = $1.dcws * 8; /*20099*/
				$1.okay = true; /*20100*/
				if ($ne($1.version, "unset") && $ne($1.version, $1.vers)) { /*20101*/
					$1.okay = false; /*20101*/
				} /*20101*/
				if ($1.bits.length > $1.dmod) { /*20102*/
					$1.okay = false; /*20102*/
				} /*20102*/
				if ($1.okay) { /*20103*/
					break; /*20103*/
				} /*20103*/
			} /*20103*/
			if (!$1.okay) { /*20108*/
				$k[$j++] = "bwipp.hanxinNoValidSymbol"; /*20107*/
				$k[$j++] = "No valid symbol available"; /*20107*/
				$0.raiseerror(); /*20107*/
			} /*20107*/
			$1.version = $1.vers; /*20110*/
			$1.msgbits = $1.bits; /*20111*/
			$1.e1nb = $get($get($1.ecbs, 0), 0); /*20112*/
			$1.e2nb = $get($get($1.ecbs, 1), 0); /*20112*/
			$1.e3nb = $get($get($1.ecbs, 2), 0); /*20112*/
			$1.e1dcws = $get($get($1.ecbs, 0), 1); /*20113*/
			$1.e2dcws = $get($get($1.ecbs, 1), 1); /*20113*/
			$1.e3dcws = $get($get($1.ecbs, 2), 1); /*20113*/
			$1.e1ecws = $get($get($1.ecbs, 0), 2); /*20114*/
			$1.e2ecws = $get($get($1.ecbs, 1), 2); /*20114*/
			$1.e3ecws = $get($get($1.ecbs, 2), 2); /*20114*/
			$1.pad = $s($1.dmod); /*20117*/
			for (var _Ju = 0, _Jt = $1.pad.length - 1; _Ju <= _Jt; _Ju += 1) { /*20118*/
				$put($1.pad, _Ju, 48); /*20118*/
			} /*20118*/
			$puti($1.pad, 0, $1.msgbits); /*20119*/
			$1.cws = $a($1.dcws); /*20122*/
			for (var _K2 = 0, _K1 = $1.cws.length - 1; _K2 <= _K1; _K2 += 1) { /*20132*/
				$1.c = _K2; /*20124*/
				$1.cwb = $geti($1.pad, $1.c * 8, 8); /*20125*/
				$1.cw = 0; /*20126*/
				for (var _K6 = 0; _K6 <= 7; _K6 += 1) { /*20130*/
					$1.i = _K6; /*20128*/
					$1.cw = $1.cw + ((~~(Math.pow(2, (8 - $1.i) - 1))) * ($get($1.cwb, $1.i) - 48)); /*20129*/
				} /*20129*/
				$put($1.cws, $1.c, $1.cw); /*20131*/
			} /*20131*/
			$1.rscodes = function() {
				$1.rspm = $k[--$j]; /*20136*/
				$1.rsgf = $k[--$j]; /*20137*/
				$1.rsnc = $k[--$j]; /*20138*/
				$1.rscws = $k[--$j]; /*20139*/
				$k[$j++] = Infinity; /*20142*/
				$k[$j++] = 1; /*20142*/
				for (var _KK = 0, _KL = $1.rsgf - 1; _KK < _KL; _KK++) { /*20142*/
					var _KM = $k[--$j]; /*20142*/
					var _KN = _KM * 2; /*20142*/
					$k[$j++] = _KM; /*20142*/
					$k[$j++] = _KN; /*20142*/
					if (_KN >= $1.rsgf) { /*20142*/
						var _KQ = $k[--$j]; /*20142*/
						$k[$j++] = $xo(_KQ, $1.rspm); /*20142*/
					} /*20142*/
				} /*20142*/
				$1.rsalog = $a(); /*20142*/
				$1.rslog = $a($1.rsgf); /*20143*/
				for (var _KW = 1, _KV = $1.rsgf - 1; _KW <= _KV; _KW += 1) { /*20144*/
					$put($1.rslog, $get($1.rsalog, _KW), _KW); /*20144*/
				} /*20144*/
				$1.rsprod = function() {
					var _Ka = $k[--$j]; /*20148*/
					var _Kb = $k[--$j]; /*20148*/
					$k[$j++] = _Kb; /*20152*/
					$k[$j++] = _Ka; /*20152*/
					if ((_Ka != 0) && (_Kb != 0)) { /*20151*/
						var _Ke = $get($1.rslog, $k[--$j]); /*20149*/
						var _Kk = $get($1.rsalog, (_Ke + $get($1.rslog, $k[--$j])) % ($1.rsgf - 1)); /*20149*/
						$k[$j++] = _Kk; /*20149*/
					} else { /*20151*/
						$j -= 2; /*20151*/
						$k[$j++] = 0; /*20151*/
					} /*20151*/
				}; /*20153*/
				$k[$j++] = Infinity; /*20156*/
				$k[$j++] = 1; /*20156*/
				for (var _Km = 0, _Kn = $1.rsnc; _Km < _Kn; _Km++) { /*20156*/
					$k[$j++] = 0; /*20156*/
				} /*20156*/
				$1.coeffs = $a(); /*20156*/
				for (var _Kr = 1, _Kq = $1.rsnc; _Kr <= _Kq; _Kr += 1) { /*20165*/
					$1.i = _Kr; /*20158*/
					$put($1.coeffs, $1.i, $get($1.coeffs, $1.i - 1)); /*20159*/
					for (var _Ky = $1.i - 1; _Ky >= 1; _Ky -= 1) { /*20163*/
						$1.j = _Ky; /*20161*/
						$k[$j++] = $1.coeffs; /*20162*/
						$k[$j++] = $1.j; /*20162*/
						$k[$j++] = $get($1.coeffs, $1.j - 1); /*20162*/
						$k[$j++] = $get($1.coeffs, $1.j); /*20162*/
						$k[$j++] = $get($1.rsalog, $1.i); /*20162*/
						if ($1.rsprod() == $b) break; /*20162*/
						var _LA = $k[--$j]; /*20162*/
						var _LB = $k[--$j]; /*20162*/
						var _LC = $k[--$j]; /*20162*/
						$put($k[--$j], _LC, $xo(_LB, _LA)); /*20162*/
					} /*20162*/
					$k[$j++] = $1.coeffs; /*20164*/
					$k[$j++] = 0; /*20164*/
					$k[$j++] = $get($1.coeffs, 0); /*20164*/
					$k[$j++] = $get($1.rsalog, $1.i); /*20164*/
					if ($1.rsprod() == $b) break; /*20164*/
					var _LK = $k[--$j]; /*20164*/
					var _LL = $k[--$j]; /*20164*/
					$put($k[--$j], _LL, _LK); /*20164*/
				} /*20164*/
				$1.nd = $1.rscws.length; /*20168*/
				$k[$j++] = Infinity; /*20169*/
				$forall($1.rscws); /*20169*/
				for (var _LQ = 0, _LR = $1.rsnc; _LQ < _LR; _LQ++) { /*20169*/
					$k[$j++] = 0; /*20169*/
				} /*20169*/
				$k[$j++] = 0; /*20169*/
				$1.rscws = $a(); /*20169*/
				for (var _LV = 0, _LU = $1.nd - 1; _LV <= _LU; _LV += 1) { /*20176*/
					$1.k = $xo($get($1.rscws, _LV), $get($1.rscws, $1.nd)); /*20171*/
					for (var _Ld = 0, _Lc = $1.rsnc - 1; _Ld <= _Lc; _Ld += 1) { /*20175*/
						$1.j = _Ld; /*20173*/
						$k[$j++] = $1.rscws; /*20174*/
						$k[$j++] = $1.nd + $1.j; /*20174*/
						$k[$j++] = $get($1.rscws, ($1.nd + $1.j) + 1); /*20174*/
						$k[$j++] = $1.k; /*20174*/
						$k[$j++] = $get($1.coeffs, ($1.rsnc - $1.j) - 1); /*20174*/
						if ($1.rsprod() == $b) break; /*20174*/
						var _Lq = $k[--$j]; /*20174*/
						var _Lr = $k[--$j]; /*20174*/
						var _Ls = $k[--$j]; /*20174*/
						$put($k[--$j], _Ls, $xo(_Lr, _Lq)); /*20174*/
					} /*20174*/
				} /*20174*/
				$k[$j++] = $geti($1.rscws, 0, $1.rscws.length - 1); /*20179*/
			}; /*20181*/
			$1.dcwsb = $a(($1.e1nb + $1.e2nb) + $1.e3nb); /*20184*/
			$1.ecwsb = $a($1.dcwsb.length); /*20185*/
			$1.in = 0; /*20186*/
			$1.out = 0; /*20186*/
			for (var _M4 = 0, _M5 = $1.e1nb; _M4 < _M5; _M4++) { /*20192*/
				$k[$j++] = $geti($1.cws, $1.in, $1.e1dcws); /*20188*/
				$k[$j++] = $1.e1ecws; /*20188*/
				$k[$j++] = 256; /*20188*/
				$k[$j++] = 355; /*20188*/
				if ($1.rscodes() == $b) break; /*20188*/
				var _MB = $k[--$j]; /*20189*/
				$put($1.dcwsb, $1.out, $geti(_MB, 0, $1.e1dcws)); /*20189*/
				$put($1.ecwsb, $1.out, $geti(_MB, $1.e1dcws, $1.e1ecws)); /*20190*/
				$1.in = $1.in + $1.e1dcws; /*20191*/
				$1.out = $1.out + 1; /*20191*/
			} /*20191*/
			for (var _MP = 0, _MQ = $1.e2nb; _MP < _MQ; _MP++) { /*20198*/
				$k[$j++] = $geti($1.cws, $1.in, $1.e2dcws); /*20194*/
				$k[$j++] = $1.e2ecws; /*20194*/
				$k[$j++] = 256; /*20194*/
				$k[$j++] = 355; /*20194*/
				if ($1.rscodes() == $b) break; /*20194*/
				var _MW = $k[--$j]; /*20195*/
				$put($1.dcwsb, $1.out, $geti(_MW, 0, $1.e2dcws)); /*20195*/
				$put($1.ecwsb, $1.out, $geti(_MW, $1.e2dcws, $1.e2ecws)); /*20196*/
				$1.in = $1.in + $1.e2dcws; /*20197*/
				$1.out = $1.out + 1; /*20197*/
			} /*20197*/
			for (var _Mk = 0, _Ml = $1.e3nb; _Mk < _Ml; _Mk++) { /*20204*/
				$k[$j++] = $geti($1.cws, $1.in, $1.e3dcws); /*20200*/
				$k[$j++] = $1.e3ecws; /*20200*/
				$k[$j++] = 256; /*20200*/
				$k[$j++] = 355; /*20200*/
				if ($1.rscodes() == $b) break; /*20200*/
				var _Mr = $k[--$j]; /*20201*/
				$put($1.dcwsb, $1.out, $geti(_Mr, 0, $1.e3dcws)); /*20201*/
				$put($1.ecwsb, $1.out, $geti(_Mr, $1.e3dcws, $1.e3ecws)); /*20202*/
				$1.in = $1.in + $1.e3dcws; /*20203*/
				$1.out = $1.out + 1; /*20203*/
			} /*20203*/
			$1.cws = $a($1.ncws); /*20207*/
			$1.cw = 0; /*20208*/
			for (var _N8 = 0, _N7 = $1.dcwsb.length - 1; _N8 <= _N7; _N8 += 1) { /*20213*/
				$1.i = _N8; /*20210*/
				var _NB = $get($1.dcwsb, $1.i); /*20211*/
				$puti($1.cws, $1.cw, _NB); /*20211*/
				$1.cw = _NB.length + $1.cw; /*20211*/
				var _NH = $get($1.ecwsb, $1.i); /*20212*/
				$puti($1.cws, $1.cw, _NH); /*20212*/
				$1.cw = _NH.length + $1.cw; /*20212*/
			} /*20212*/
			$k[$j++] = Infinity; /*20220*/
			var _NL = $1.ncws; /*20217*/
			var _NM = 12; /*20217*/
			var _NN = _NL - 1; /*20217*/
			if ((_NL - 1) > 12) { /*20217*/
				var _ = _NM; /*20217*/
				_NM = _NN; /*20217*/
				_NN = _; /*20217*/
			} /*20217*/
			for (var _NP = 0, _NO = _NN; _NP <= _NO; _NP += 1) { /*20219*/
				for (var _NS = _NP, _NR = $1.ncws - 1; _NS <= _NR; _NS += 13) { /*20218*/
					$k[$j++] = _NS; /*20218*/
					if (_NS < $1.ncws) { /*20218*/
						var _NW = $get($1.cws, $k[--$j]); /*20218*/
						$k[$j++] = _NW; /*20218*/
					} else { /*20218*/
						$j--; /*20218*/
					} /*20218*/
				} /*20218*/
			} /*20218*/
			$1.cws = $a(); /*20220*/
			if ($1.rbit > 0) { /*20228*/
				$1.pad = $a($1.cws.length + 1); /*20224*/
				$puti($1.pad, 0, $1.cws); /*20225*/
				$put($1.pad, $1.pad.length - 1, 0); /*20226*/
				$1.cws = $1.pad; /*20227*/
			} /*20227*/
			$k[$j++] = Infinity; /*20231*/
			for (var _Ni = 0, _Nj = $1.size * $1.size; _Ni < _Nj; _Ni++) { /*20231*/
				$k[$j++] = -1; /*20231*/
			} /*20231*/
			$1.pixs = $a(); /*20231*/
			$1.qmv = function() {
				var _Nm = $k[--$j]; /*20232*/
				var _Nn = $k[--$j]; /*20232*/
				$k[$j++] = _Nn + (_Nm * $1.size); /*20232*/
			}; /*20232*/
			if ($1.alnn != 0) { /*20291*/
				$1.trmv = function() {
					var _Nq = $k[--$j]; /*20236*/
					var _Ns = $k[--$j]; /*20236*/
					$k[$j++] = (((_Nq * $1.size) + $1.size) - 1) - _Ns; /*20236*/
				}; /*20236*/
				$1.aplot = function() {
					var _Nt = $k[--$j]; /*20238*/
					var _Nu = $k[--$j]; /*20238*/
					var _Nv = $k[--$j]; /*20238*/
					$k[$j++] = _Nt; /*20238*/
					$k[$j++] = _Nv; /*20238*/
					$k[$j++] = _Nu; /*20238*/
					$k[$j++] = _Nt; /*20238*/
					$k[$j++] = _Nu; /*20238*/
					$k[$j++] = _Nv; /*20238*/
					if ($1.trmv() == $b) return $b; /*20238*/
					var _Nx = $k[--$j]; /*20238*/
					$put($1.pixs, _Nx, $k[--$j]); /*20238*/
					if ($1.trmv() == $b) return $b; /*20239*/
					var _O0 = $k[--$j]; /*20239*/
					$put($1.pixs, _O0, $k[--$j]); /*20239*/
				}; /*20240*/
				$1.i = 0; /*20241*/
				$1.stag = 0; /*20241*/
				for (;;) { /*20263*/
					if ($1.i >= $1.size) { /*20242*/
						break; /*20242*/
					} /*20242*/
					for (var _O6 = 0, _O5 = $1.size - 1; _O6 <= _O5; _O6 += 1) { /*20256*/
						$1.j = _O6; /*20244*/
						if (($1.j + $1.alnr) < $1.size) { /*20250*/
							$k[$j++] = (((((~~($1.j / $1.alnk)) + $1.stag) % 2) == 0) && (!(($1.i == 0) && ($1.j < $1.alnk)))) || (($1.j % $1.alnk) == 0); /*20248*/
						} else { /*20250*/
							$k[$j++] = (($1.alnn + $1.stag) % 2) == 0; /*20250*/
						} /*20250*/
						if ($k[--$j]) { /*20255*/
							$k[$j++] = $1.j; /*20253*/
							$k[$j++] = $1.i; /*20253*/
							$k[$j++] = 1; /*20253*/
							if ($1.aplot() == $b) break; /*20253*/
							var _ON = $1.j; /*20254*/
							var _OO = $1.i; /*20254*/
							$k[$j++] = _ON + 1; /*20254*/
							$k[$j++] = _OO + 1; /*20254*/
							if (((_OO + 1) < $1.size) && ((_ON + 1) < $1.size)) { /*20254*/
								$k[$j++] = 0; /*20254*/
								if ($1.aplot() == $b) break; /*20254*/
							} else { /*20254*/
								$j -= 2; /*20254*/
							} /*20254*/
						} /*20254*/
					} /*20254*/
					if (($1.i + $1.alnr) == $1.size) { /*20260*/
						$1.i = ($1.i + $1.alnr) - 1; /*20258*/
					} else { /*20260*/
						$1.i = $1.i + $1.alnk; /*20260*/
					} /*20260*/
					$1.stag = 1 - $1.stag; /*20262*/
				} /*20262*/
				for (var _Od = $1.alnk, _Oe = $1.alnk, _Oc = $1.size - 2; _Oe < 0 ? _Od >= _Oc : _Od <= _Oc; _Od += _Oe) { /*20290*/
					$1.i = _Od; /*20265*/
					if (((~~($1.i / $1.alnk)) % 2) != 0) { /*20277*/
						$k[$j++] = $1.pixs; /*20267*/
						$k[$j++] = 0; /*20267*/
						$k[$j++] = $1.i - 1; /*20267*/
						if ($1.trmv() == $b) break; /*20267*/
						var _Oj = $k[--$j]; /*20267*/
						$put($k[--$j], _Oj, 0); /*20267*/
						$k[$j++] = $1.pixs; /*20268*/
						$k[$j++] = 0; /*20268*/
						$k[$j++] = $1.i + 1; /*20268*/
						if ($1.trmv() == $b) break; /*20268*/
						var _On = $k[--$j]; /*20268*/
						$put($k[--$j], _On, 0); /*20268*/
						$k[$j++] = $1.pixs; /*20269*/
						$k[$j++] = 1; /*20269*/
						$k[$j++] = $1.i - 1; /*20269*/
						if ($1.trmv() == $b) break; /*20269*/
						var _Or = $k[--$j]; /*20269*/
						$put($k[--$j], _Or, 0); /*20269*/
						$k[$j++] = $1.pixs; /*20270*/
						$k[$j++] = 1; /*20270*/
						$k[$j++] = $1.i; /*20270*/
						if ($1.trmv() == $b) break; /*20270*/
						var _Ov = $k[--$j]; /*20270*/
						$put($k[--$j], _Ov, 0); /*20270*/
						$k[$j++] = $1.pixs; /*20271*/
						$k[$j++] = 1; /*20271*/
						$k[$j++] = $1.i + 1; /*20271*/
						if ($1.trmv() == $b) break; /*20271*/
						var _Oz = $k[--$j]; /*20271*/
						$put($k[--$j], _Oz, 0); /*20271*/
						$k[$j++] = $1.pixs; /*20272*/
						$k[$j++] = $1.i - 1; /*20272*/
						$k[$j++] = 0; /*20272*/
						if ($1.trmv() == $b) break; /*20272*/
						var _P3 = $k[--$j]; /*20272*/
						$put($k[--$j], _P3, 0); /*20272*/
						$k[$j++] = $1.pixs; /*20273*/
						$k[$j++] = $1.i + 1; /*20273*/
						$k[$j++] = 0; /*20273*/
						if ($1.trmv() == $b) break; /*20273*/
						var _P7 = $k[--$j]; /*20273*/
						$put($k[--$j], _P7, 0); /*20273*/
						$k[$j++] = $1.pixs; /*20274*/
						$k[$j++] = $1.i - 1; /*20274*/
						$k[$j++] = 1; /*20274*/
						if ($1.trmv() == $b) break; /*20274*/
						var _PB = $k[--$j]; /*20274*/
						$put($k[--$j], _PB, 0); /*20274*/
						$k[$j++] = $1.pixs; /*20275*/
						$k[$j++] = $1.i; /*20275*/
						$k[$j++] = 1; /*20275*/
						if ($1.trmv() == $b) break; /*20275*/
						var _PF = $k[--$j]; /*20275*/
						$put($k[--$j], _PF, 0); /*20275*/
						$k[$j++] = $1.pixs; /*20276*/
						$k[$j++] = $1.i + 1; /*20276*/
						$k[$j++] = 1; /*20276*/
						if ($1.trmv() == $b) break; /*20276*/
						var _PJ = $k[--$j]; /*20276*/
						$put($k[--$j], _PJ, 0); /*20276*/
					} /*20276*/
					$k[$j++] = $1.pixs; /*20278*/
					$k[$j++] = $1.size - 1; /*20278*/
					$k[$j++] = $1.i - 1; /*20278*/
					if ($1.trmv() == $b) break; /*20278*/
					var _PO = $k[--$j]; /*20278*/
					if ($get($k[--$j], _PO) != 1) { /*20289*/
						$k[$j++] = $1.pixs; /*20279*/
						$k[$j++] = $1.size - 1; /*20279*/
						$k[$j++] = $1.i - 1; /*20279*/
						if ($1.trmv() == $b) break; /*20279*/
						var _PU = $k[--$j]; /*20279*/
						$put($k[--$j], _PU, 0); /*20279*/
						$k[$j++] = $1.pixs; /*20280*/
						$k[$j++] = $1.size - 2; /*20280*/
						$k[$j++] = $1.i - 1; /*20280*/
						if ($1.trmv() == $b) break; /*20280*/
						var _PZ = $k[--$j]; /*20280*/
						$put($k[--$j], _PZ, 0); /*20280*/
						$k[$j++] = $1.pixs; /*20281*/
						$k[$j++] = $1.size - 2; /*20281*/
						$k[$j++] = $1.i; /*20281*/
						if ($1.trmv() == $b) break; /*20281*/
						var _Pe = $k[--$j]; /*20281*/
						$put($k[--$j], _Pe, 0); /*20281*/
						$k[$j++] = $1.pixs; /*20282*/
						$k[$j++] = $1.size - 2; /*20282*/
						$k[$j++] = $1.i + 1; /*20282*/
						if ($1.trmv() == $b) break; /*20282*/
						var _Pj = $k[--$j]; /*20282*/
						$put($k[--$j], _Pj, 0); /*20282*/
						$k[$j++] = $1.pixs; /*20283*/
						$k[$j++] = $1.size - 1; /*20283*/
						$k[$j++] = $1.i + 1; /*20283*/
						if ($1.trmv() == $b) break; /*20283*/
						var _Po = $k[--$j]; /*20283*/
						$put($k[--$j], _Po, 0); /*20283*/
						$k[$j++] = $1.pixs; /*20284*/
						$k[$j++] = $1.i - 1; /*20284*/
						$k[$j++] = $1.size - 1; /*20284*/
						if ($1.trmv() == $b) break; /*20284*/
						var _Pt = $k[--$j]; /*20284*/
						$put($k[--$j], _Pt, 0); /*20284*/
						$k[$j++] = $1.pixs; /*20285*/
						$k[$j++] = $1.i - 1; /*20285*/
						$k[$j++] = $1.size - 2; /*20285*/
						if ($1.trmv() == $b) break; /*20285*/
						var _Py = $k[--$j]; /*20285*/
						$put($k[--$j], _Py, 0); /*20285*/
						$k[$j++] = $1.pixs; /*20286*/
						$k[$j++] = $1.i; /*20286*/
						$k[$j++] = $1.size - 2; /*20286*/
						if ($1.trmv() == $b) break; /*20286*/
						var _Q3 = $k[--$j]; /*20286*/
						$put($k[--$j], _Q3, 0); /*20286*/
						$k[$j++] = $1.pixs; /*20287*/
						$k[$j++] = $1.i + 1; /*20287*/
						$k[$j++] = $1.size - 2; /*20287*/
						if ($1.trmv() == $b) break; /*20287*/
						var _Q8 = $k[--$j]; /*20287*/
						$put($k[--$j], _Q8, 0); /*20287*/
						$k[$j++] = $1.pixs; /*20288*/
						$k[$j++] = $1.i + 1; /*20288*/
						$k[$j++] = $1.size - 1; /*20288*/
						if ($1.trmv() == $b) break; /*20288*/
						var _QD = $k[--$j]; /*20288*/
						$put($k[--$j], _QD, 0); /*20288*/
					} /*20288*/
				} /*20288*/
			} /*20288*/
			$1.fpat = $a([$a([1, 1, 1, 1, 1, 1, 1, 0]), $a([1, 0, 0, 0, 0, 0, 0, 0]), $a([1, 0, 1, 1, 1, 1, 1, 0]), $a([1, 0, 1, 0, 0, 0, 0, 0]), $a([1, 0, 1, 0, 1, 1, 1, 0]), $a([1, 0, 1, 0, 1, 1, 1, 0]), $a([1, 0, 1, 0, 1, 1, 1, 0]), $a([0, 0, 0, 0, 0, 0, 0, 0])]); /*20303*/
			$1.fpat2 = $a([$a([1, 1, 1, 0, 1, 0, 1, 0]), $a([1, 1, 1, 0, 1, 0, 1, 0]), $a([1, 1, 1, 0, 1, 0, 1, 0]), $a([0, 0, 0, 0, 1, 0, 1, 0]), $a([1, 1, 1, 1, 1, 0, 1, 0]), $a([0, 0, 0, 0, 0, 0, 1, 0]), $a([1, 1, 1, 1, 1, 1, 1, 0]), $a([0, 0, 0, 0, 0, 0, 0, 0])]); /*20313*/
			for (var _QZ = 0, _QY = $1.fpat.length - 1; _QZ <= _QY; _QZ += 1) { /*20325*/
				$1.y = _QZ; /*20315*/
				for (var _Qd = 0, _Qc = $get($1.fpat, 0).length - 1; _Qd <= _Qc; _Qd += 1) { /*20324*/
					$1.x = _Qd; /*20317*/
					$1.fpb = $get($get($1.fpat, $1.y), $1.x); /*20318*/
					$1.fpb2 = $get($get($1.fpat2, $1.y), $1.x); /*20319*/
					$k[$j++] = $1.pixs; /*20320*/
					$k[$j++] = $1.x; /*20320*/
					$k[$j++] = $1.y; /*20320*/
					if ($1.qmv() == $b) break; /*20320*/
					var _Qs = $k[--$j]; /*20320*/
					$put($k[--$j], _Qs, $1.fpb); /*20320*/
					$k[$j++] = $1.pixs; /*20321*/
					$k[$j++] = ($1.size - $1.x) - 1; /*20321*/
					$k[$j++] = $1.y; /*20321*/
					if ($1.qmv() == $b) break; /*20321*/
					var _Qz = $k[--$j]; /*20321*/
					$put($k[--$j], _Qz, $1.fpb); /*20321*/
					$k[$j++] = $1.pixs; /*20322*/
					$k[$j++] = ($1.size - $1.x) - 1; /*20322*/
					$k[$j++] = ($1.size - $1.y) - 1; /*20322*/
					if ($1.qmv() == $b) break; /*20322*/
					var _R7 = $k[--$j]; /*20322*/
					$put($k[--$j], _R7, $1.fpb); /*20322*/
					$k[$j++] = $1.pixs; /*20323*/
					$k[$j++] = $1.x; /*20323*/
					$k[$j++] = ($1.size - $1.y) - 1; /*20323*/
					if ($1.qmv() == $b) break; /*20323*/
					var _RE = $k[--$j]; /*20323*/
					$put($k[--$j], _RE, $1.fpb2); /*20323*/
				} /*20323*/
			} /*20323*/
			$1.functionmap = $a([$a([$a([0, 8]), $a([$1.size - 1, $1.size - 9])]), $a([$a([1, 8]), $a([$1.size - 2, $1.size - 9])]), $a([$a([2, 8]), $a([$1.size - 3, $1.size - 9])]), $a([$a([3, 8]), $a([$1.size - 4, $1.size - 9])]), $a([$a([4, 8]), $a([$1.size - 5, $1.size - 9])]), $a([$a([5, 8]), $a([$1.size - 6, $1.size - 9])]), $a([$a([6, 8]), $a([$1.size - 7, $1.size - 9])]), $a([$a([7, 8]), $a([$1.size - 8, $1.size - 9])]), $a([$a([8, 8]), $a([$1.size - 9, $1.size - 9])]), $a([$a([8, 7]), $a([$1.size - 9, $1.size - 8])]), $a([$a([8, 6]), $a([$1.size - 9, $1.size - 7])]), $a([$a([8, 5]), $a([$1.size - 9, $1.size - 6])]), $a([$a([8, 4]), $a([$1.size - 9, $1.size - 5])]), $a([$a([8, 3]), $a([$1.size - 9, $1.size - 4])]), $a([$a([8, 2]), $a([$1.size - 9, $1.size - 3])]), $a([$a([8, 1]), $a([$1.size - 9, $1.size - 2])]), $a([$a([8, 0]), $a([$1.size - 9, $1.size - 1])]), $a([$a([$1.size - 9, 0]), $a([8, $1.size - 1])]), $a([$a([$1.size - 9, 1]), $a([8, $1.size - 2])]), $a([$a([$1.size - 9, 2]), $a([8, $1.size - 3])]), $a([$a([$1.size - 9, 3]), $a([8, $1.size - 4])]), $a([$a([$1.size - 9, 4]), $a([8, $1.size - 5])]), $a([$a([$1.size - 9, 5]), $a([8, $1.size - 6])]), $a([$a([$1.size - 9, 6]), $a([8, $1.size - 7])]), $a([$a([$1.size - 9, 7]), $a([8, $1.size - 8])]), $a([$a([$1.size - 9, 8]), $a([8, $1.size - 9])]), $a([$a([$1.size - 8, 8]), $a([7, $1.size - 9])]), $a([$a([$1.size - 7, 8]), $a([6, $1.size - 9])]), $a([$a([$1.size - 6, 8]), $a([5, $1.size - 9])]), $a([$a([$1.size - 5, 8]), $a([4, $1.size - 9])]), $a([$a([$1.size - 4, 8]), $a([3, $1.size - 9])]), $a([$a([$1.size - 3, 8]), $a([2, $1.size - 9])]), $a([$a([$1.size - 2, 8]), $a([1, $1.size - 9])]), $a([$a([$1.size - 1, 8]), $a([0, $1.size - 9])])]); /*20347*/
			var _U1 = $1.functionmap; /*20348*/
			for (var _U2 = 0, _U3 = _U1.length; _U2 < _U3; _U2++) { /*20350*/
				$forall($get(_U1, _U2), function() { /*20349*/
					$forall($k[--$j]); /*20349*/
					if ($1.qmv() == $b) return $b; /*20349*/
					$put($1.pixs, $k[--$j], 0); /*20349*/
				}); /*20349*/
			} /*20349*/
			var _UE = $a([function() {
				$j -= 2; /*20353*/
				$k[$j++] = 1; /*20353*/
			}, function() {
				var _U8 = $k[--$j]; /*20354*/
				var _U9 = $k[--$j]; /*20354*/
				$k[$j++] = (_U9 + _U8) % 2; /*20354*/
			}, function() {
				var _UA = $k[--$j]; /*20355*/
				var _UB = $k[--$j]; /*20355*/
				$k[$j++] = (((_UA + _UB) % 3) + (_UB % 3)) % 2; /*20355*/
			}, function() {
				var _UC = $k[--$j]; /*20356*/
				var _UD = $k[--$j]; /*20356*/
				$k[$j++] = ((_UD % _UC) + ((_UC % _UD) + ((_UC % 3) + (_UD % 3)))) % 2; /*20357*/
			}]); /*20357*/
			$1.maskfuncs = _UE; /*20358*/
			if ($1.mask != -1) { /*20362*/
				$1.maskfuncs = $a([$get($1.maskfuncs, $1.mask - 1)]); /*20360*/
				$1.bestmaskval = $1.mask - 1; /*20361*/
			} /*20361*/
			$1.masks = $a($1.maskfuncs.length); /*20363*/
			for (var _UP = 0, _UO = $1.masks.length - 1; _UP <= _UO; _UP += 1) { /*20377*/
				$1.m = _UP; /*20365*/
				$1.mask = $a($1.size * $1.size); /*20366*/
				for (var _UV = 0, _UU = $1.size - 1; _UV <= _UU; _UV += 1) { /*20375*/
					$1.j = _UV; /*20368*/
					for (var _UY = 0, _UX = $1.size - 1; _UY <= _UX; _UY += 1) { /*20374*/
						$1.i = _UY; /*20370*/
						$k[$j++] = $1.i + 1; /*20371*/
						$k[$j++] = $1.j + 1; /*20371*/
						$get($1.maskfuncs, $1.m)(); /*20371*/
						var _Ue = $k[--$j]; /*20371*/
						$k[$j++] = _Ue == 0; /*20372*/
						$k[$j++] = $1.pixs; /*20372*/
						$k[$j++] = $1.i; /*20372*/
						$k[$j++] = $1.j; /*20372*/
						if ($1.qmv() == $b) break; /*20372*/
						var _Ui = $k[--$j]; /*20372*/
						var _Uk = $get($k[--$j], _Ui); /*20372*/
						var _Um = ($k[--$j] && (_Uk == -1)) ? 1 : 0; /*20372*/
						$k[$j++] = _Um; /*20373*/
						$k[$j++] = $1.mask; /*20373*/
						$k[$j++] = $1.i; /*20373*/
						$k[$j++] = $1.j; /*20373*/
						if ($1.qmv() == $b) break; /*20373*/
						var _Uq = $k[--$j]; /*20373*/
						var _Ur = $k[--$j]; /*20373*/
						$put(_Ur, _Uq, $k[--$j]); /*20373*/
					} /*20373*/
				} /*20373*/
				$put($1.masks, $1.m, $1.mask); /*20376*/
			} /*20376*/
			$1.posx = 0; /*20380*/
			$1.posy = 0; /*20381*/
			$1.num = 0; /*20382*/
			for (;;) { /*20392*/
				if ($1.posy == $1.size) { /*20384*/
					break; /*20384*/
				} /*20384*/
				$k[$j++] = $1.pixs; /*20385*/
				$k[$j++] = $1.posx; /*20385*/
				$k[$j++] = $1.posy; /*20385*/
				if ($1.qmv() == $b) break; /*20385*/
				var _V1 = $k[--$j]; /*20385*/
				if ($get($k[--$j], _V1) == -1) { /*20389*/
					var _V6 = $get($1.cws, ~~($1.num / 8)); /*20386*/
					var _V8 = -(7 - ($1.num % 8)); /*20386*/
					$k[$j++] = ((_V8 < 0 ? _V6 >>> -_V8 : _V6 << _V8)) & 1; /*20387*/
					$k[$j++] = $1.pixs; /*20387*/
					$k[$j++] = $1.posx; /*20387*/
					$k[$j++] = $1.posy; /*20387*/
					if ($1.qmv() == $b) break; /*20387*/
					var _VC = $k[--$j]; /*20387*/
					var _VD = $k[--$j]; /*20387*/
					$put(_VD, _VC, $k[--$j]); /*20387*/
					$1.num = $1.num + 1; /*20388*/
				} /*20388*/
				$1.posx = $1.posx + 1; /*20390*/
				if ($1.posx == $1.size) { /*20391*/
					$1.posx = 0; /*20391*/
					$1.posy = $1.posy + 1; /*20391*/
				} /*20391*/
			} /*20391*/
			$1.evalfulln1n3 = function() {
				$1.scrle = $k[--$j]; /*20396*/
				$k[$j++] = "scr1"; /*20398*/
				$k[$j++] = 0; /*20398*/
				$forall($1.scrle, function() { /*20398*/
					var _VM = $k[--$j]; /*20398*/
					$k[$j++] = _VM; /*20398*/
					if (_VM >= 3) { /*20398*/
						var _VN = $k[--$j]; /*20398*/
						var _VP = $k[--$j] + (_VN * 4); /*20398*/
						$k[$j++] = _VP; /*20398*/
						$k[$j++] = _VP; /*20398*/
					} /*20398*/
					$j--; /*20398*/
				}); /*20398*/
				var _VQ = $k[--$j]; /*20398*/
				$1[$k[--$j]] = _VQ; /*20398*/
				$1.scr3 = 0; /*20399*/
				for (var _VU = 5, _VT = $1.scrle.length - 1; _VU <= _VT; _VU += 2) { /*20415*/
					$1.j = _VU; /*20402*/
					if (($get($1.scrle, $1.j) % 3) == 0) { /*20414*/
						$1.fact = ~~($get($1.scrle, $1.j) / 3); /*20404*/
						$forall($geti($1.scrle, $1.j - 4, 4), function() { /*20405*/
							var _Vf = $k[--$j]; /*20405*/
							$k[$j++] = _Vf == $1.fact; /*20405*/
						}); /*20405*/
						var _Vg = $k[--$j]; /*20405*/
						var _Vh = $k[--$j]; /*20405*/
						var _Vi = $k[--$j]; /*20405*/
						if ($k[--$j] && (_Vi && (_Vh && _Vg))) { /*20413*/
							if (($1.j == 5) || (($1.j + 2) >= $1.scrle.length)) { /*20410*/
								$1.scr3 = $1.scr3 + 50; /*20407*/
							} else { /*20410*/
								if (($get($1.scrle, $1.j - 5) >= 3) || ($get($1.scrle, $1.j + 1) >= 3)) { /*20411*/
									$1.scr3 = $1.scr3 + 50; /*20410*/
								} /*20410*/
							} /*20410*/
						} /*20410*/
					} /*20410*/
				} /*20410*/
				for (var _Vx = 1, _Vw = $1.scrle.length - 5; _Vx <= _Vw; _Vx += 2) { /*20431*/
					$1.j = _Vx; /*20418*/
					if (($get($1.scrle, $1.j) % 3) == 0) { /*20430*/
						$1.fact = ~~($get($1.scrle, $1.j) / 3); /*20420*/
						$forall($geti($1.scrle, $1.j + 1, 4), function() { /*20421*/
							var _W8 = $k[--$j]; /*20421*/
							$k[$j++] = _W8 == $1.fact; /*20421*/
						}); /*20421*/
						var _W9 = $k[--$j]; /*20421*/
						var _WA = $k[--$j]; /*20421*/
						var _WB = $k[--$j]; /*20421*/
						if ($k[--$j] && (_WB && (_WA && _W9))) { /*20429*/
							if (($1.j == 1) || (($1.j + 6) >= $1.scrle.length)) { /*20426*/
								$1.scr3 = $1.scr3 + 50; /*20423*/
							} else { /*20426*/
								if (($get($1.scrle, $1.j - 1) >= 3) || ($get($1.scrle, $1.j + 5) >= 3)) { /*20427*/
									$1.scr3 = $1.scr3 + 50; /*20426*/
								} /*20426*/
							} /*20426*/
						} /*20426*/
					} /*20426*/
				} /*20426*/
				$k[$j++] = $1.scr1; /*20432*/
				$k[$j++] = $1.scr3; /*20432*/
			}; /*20433*/
			$1.evalfull = function() {
				$1.sym = $k[--$j]; /*20437*/
				$1.n1 = 0; /*20439*/
				$1.n3 = 0; /*20439*/
				$1.rle = $a($1.size + 1); /*20440*/
				$1.lastpairs = $a($1.size); /*20441*/
				$1.thispairs = $a($1.size); /*20442*/
				$1.sizeadd1 = $1.size + 1; /*20443*/
				for (var _Wa = 0, _WZ = $1.size - 1; _Wa <= _WZ; _Wa += 1) { /*20468*/
					$1.i = _Wa; /*20445*/
					$k[$j++] = Infinity; /*20448*/
					var _Wc = $1.size; /*20449*/
					$k[$j++] = 0; /*20451*/
					$k[$j++] = 0; /*20451*/
					for (var _We = $1.i, _Wf = _Wc, _Wd = (_Wc * _Wc) - 1; _Wf < 0 ? _We >= _Wd : _We <= _Wd; _We += _Wf) { /*20451*/
						var _Wh = $get($1.sym, _We); /*20450*/
						var _Wi = $k[--$j]; /*20450*/
						$k[$j++] = _Wh; /*20450*/
						if ($eq(_Wi, _Wh)) { /*20450*/
							var _Wj = $k[--$j]; /*20450*/
							var _Wk = $k[--$j]; /*20450*/
							$k[$j++] = _Wk + 1; /*20450*/
							$k[$j++] = _Wj; /*20450*/
						} else { /*20450*/
							var _Wl = $k[--$j]; /*20450*/
							$k[$j++] = 1; /*20450*/
							$k[$j++] = _Wl; /*20450*/
						} /*20450*/
					} /*20450*/
					$j--; /*20452*/
					var _Wn = $counttomark() + 2; /*20453*/
					$astore($geti($1.rle, 0, _Wn - 2)); /*20453*/
					if ($1.evalfulln1n3() == $b) break; /*20454*/
					$1.n3 = $k[--$j] + $1.n3; /*20454*/
					$1.n1 = $k[--$j] + $1.n1; /*20454*/
					$j--; /*20455*/
					$1.symrow = $geti($1.sym, $1.i * $1.size, $1.size); /*20458*/
					$k[$j++] = Infinity; /*20459*/
					$k[$j++] = 0; /*20462*/
					$k[$j++] = 0; /*20462*/
					$forall($1.symrow, function() { /*20462*/
						var _Wz = $k[--$j]; /*20461*/
						var _X0 = $k[--$j]; /*20461*/
						$k[$j++] = _Wz; /*20461*/
						if ($eq(_X0, _Wz)) { /*20461*/
							var _X1 = $k[--$j]; /*20461*/
							var _X2 = $k[--$j]; /*20461*/
							$k[$j++] = _X2 + 1; /*20461*/
							$k[$j++] = _X1; /*20461*/
						} else { /*20461*/
							var _X3 = $k[--$j]; /*20461*/
							$k[$j++] = 1; /*20461*/
							$k[$j++] = _X3; /*20461*/
						} /*20461*/
					}); /*20461*/
					$j--; /*20463*/
					var _X5 = $counttomark() + 2; /*20464*/
					$astore($geti($1.rle, 0, _X5 - 2)); /*20464*/
					if ($1.evalfulln1n3() == $b) break; /*20465*/
					$1.n3 = $k[--$j] + $1.n3; /*20465*/
					$1.n1 = $k[--$j] + $1.n1; /*20465*/
					$j--; /*20466*/
				} /*20466*/
				$k[$j++] = $1.n1 + $1.n3; /*20470*/
			}; /*20471*/
			$1.bestscore = 999999999; /*20474*/
			for (var _XF = 0, _XE = $1.masks.length - 1; _XF <= _XE; _XF += 1) { /*20492*/
				$1.m = _XF; /*20476*/
				$1.masksym = $a($1.size * $1.size); /*20477*/
				for (var _XM = 0, _XL = ($1.size * $1.size) - 1; _XM <= _XL; _XM += 1) { /*20481*/
					$1.i = _XM; /*20479*/
					$put($1.masksym, $1.i, $xo($get($1.pixs, $1.i), $get($get($1.masks, $1.m), $1.i))); /*20480*/
				} /*20480*/
				if ($1.masks.length != 1) { /*20490*/
					$k[$j++] = $1.masksym; /*20483*/
					if ($1.evalfull() == $b) break; /*20483*/
					$1.score = $k[--$j]; /*20483*/
					if ($1.score < $1.bestscore) { /*20488*/
						$1.bestsym = $1.masksym; /*20485*/
						$1.bestmaskval = $1.m; /*20486*/
						$1.bestscore = $1.score; /*20487*/
					} /*20487*/
				} else { /*20490*/
					$1.bestsym = $1.masksym; /*20490*/
				} /*20490*/
			} /*20490*/
			$1.pixs = $1.bestsym; /*20493*/
			$1.funval = (((((~~(($1.size - 21) / 2)) + 20) * 4) + $1.eclval) * 4) + $1.bestmaskval; /*20496*/
			$k[$j++] = $a([($1.funval & 3840) >>> 8, ($1.funval & 240) >>> 4, $1.funval & 15]); /*20500*/
			$k[$j++] = 4; /*20500*/
			$k[$j++] = 16; /*20500*/
			$k[$j++] = 19; /*20500*/
			if ($1.rscodes() == $b) return $b; /*20500*/
			$1.funvals = $k[--$j]; /*20500*/
			$k[$j++] = Infinity; /*20506*/
			$forall($1.funvals, function() { /*20504*/
				$k[$j++] = 4; /*20503*/
				if ($1.tobin() == $b) return $b; /*20503*/
				$forall($k[--$j], function() { /*20503*/
					var _Xr = $k[--$j]; /*20503*/
					$k[$j++] = _Xr - 48; /*20503*/
				}); /*20503*/
			}); /*20503*/
			$k[$j++] = 0; /*20505*/
			$k[$j++] = 1; /*20505*/
			$k[$j++] = 0; /*20505*/
			$k[$j++] = 1; /*20505*/
			$k[$j++] = 0; /*20505*/
			$k[$j++] = 1; /*20505*/
			$1.funbits = $a(); /*20506*/
			for (var _Xv = 0, _Xu = $1.functionmap.length - 1; _Xv <= _Xu; _Xv += 1) { /*20512*/
				$1.i = _Xv; /*20508*/
				$forall($get($1.functionmap, $1.i), function() { /*20511*/
					var _Y0 = $k[--$j]; /*20510*/
					$k[$j++] = $1.pixs; /*20510*/
					$aload(_Y0); /*20510*/
					if ($1.qmv() == $b) return $b; /*20510*/
					var _Y4 = $k[--$j]; /*20510*/
					$put($k[--$j], _Y4, $get($1.funbits, $1.i)); /*20510*/
				}); /*20510*/
			} /*20510*/
			var _YC = {
				ren: $0.renmatrix,
				pixs: $1.pixs,
				pixx: $1.size,
				pixy: $1.size,
				height: ($1.size * 2) / 72,
				width: ($1.size * 2) / 72,
				opt: $1.options
			}; /*20522*/
			$k[$j++] = _YC; /*20525*/
			if (!$1.dontdraw) { /*20525*/
				$0.renmatrix(); /*20525*/
			} /*20525*/
		};
		$0.dotcode = function() {
			var $1 = {}; /*20552*/
			$1.options = $k[--$j]; /*20554*/
			$1.barcode = $k[--$j]; /*20555*/
			$1.dontdraw = false; /*20557*/
			$1.rows = -1; /*20558*/
			$1.columns = -1; /*20559*/
			$1.ratio = -1; /*20560*/
			$1.parse = false; /*20561*/
			$1.parsefnc = false; /*20562*/
			$1.raw = false; /*20563*/
			$1.fast = false; /*20564*/
			$1.mask = -1; /*20565*/
			$forall($1.options, function() { /*20576*/
				var _3 = $k[--$j]; /*20576*/
				$1[$k[--$j]] = _3; /*20576*/
			}); /*20576*/
			$1.rows = ~~$1.rows; /*20578*/
			$1.columns = ~~$1.columns; /*20579*/
			$1.ratio = +$1.ratio; /*20580*/
			$1.mask = ~~$1.mask; /*20581*/
			if ((($1.ratio == -1) && ($1.rows == -1)) && ($1.columns == -1)) { /*20586*/
				$1.ratio = 3 / 2; /*20585*/
			} /*20585*/
			$1.barlen = $1.barcode.length; /*20609*/
			$1.laa = -1; /*20612*/
			$1.lab = -2; /*20612*/
			$1.lac = -3; /*20612*/
			$1.bin = -4; /*20612*/
			$1.sfa = -5; /*20613*/
			$1.sfb = -6; /*20613*/
			$1.sb2 = -7; /*20613*/
			$1.sb3 = -8; /*20613*/
			$1.sb4 = -9; /*20614*/
			$1.sb5 = -10; /*20614*/
			$1.sb6 = -11; /*20614*/
			$1.sfc = -12; /*20614*/
			$1.sc2 = -13; /*20615*/
			$1.sc3 = -14; /*20615*/
			$1.sc4 = -15; /*20615*/
			$1.sc5 = -16; /*20615*/
			$1.sc6 = -17; /*20616*/
			$1.sc7 = -18; /*20616*/
			$1.bsa = -19; /*20616*/
			$1.bsb = -20; /*20616*/
			$1.tma = -21; /*20617*/
			$1.tmb = -22; /*20617*/
			$1.tmc = -23; /*20617*/
			$1.tms = -24; /*20617*/
			$1.fn1 = -25; /*20618*/
			$1.fn2 = -26; /*20618*/
			$1.fn3 = -27; /*20618*/
			$1.crl = -28; /*20618*/
			$1.aim = -29; /*20619*/
			$1.m05 = -30; /*20619*/
			$1.m06 = -31; /*20619*/
			$1.m12 = -32; /*20619*/
			$1.mac = -33; /*20620*/
			$1.charmaps = $a([$a([32, 32, "00"]), $a(["!", "!", "01"]), $a(["\"", "\"", "02"]), $a(["#", "#", "03"]), $a(["$", "$", "04"]), $a(["%", "%", "05"]), $a(["&", "&", "06"]), $a(["'", "'", "07"]), $a([40, 40, "08"]), $a([41, 41, "09"]), $a(["*", "*", "10"]), $a(["+", "+", "11"]), $a([",", ",", "12"]), $a(["-", "-", "13"]), $a([".", ".", "14"]), $a(["/", "/", "15"]), $a(["0", "0", "16"]), $a(["1", "1", "17"]), $a(["2", "2", "18"]), $a(["3", "3", "19"]), $a(["4", "4", "20"]), $a(["5", "5", "21"]), $a(["6", "6", "22"]), $a(["7", "7", "23"]), $a(["8", "8", "24"]), $a(["9", "9", "25"]), $a([":", ":", "26"]), $a([";", ";", "27"]), $a(["<", "<", "28"]), $a(["=", "=", "29"]), $a([">", ">", "30"]), $a(["?", "?", "31"]), $a(["@", "@", "32"]), $a(["A", "A", "33"]), $a(["B", "B", "34"]), $a(["C", "C", "35"]), $a(["D", "D", "36"]), $a(["E", "E", "37"]), $a(["F", "F", "38"]), $a(["G", "G", "39"]), $a(["H", "H", "40"]), $a(["I", "I", "41"]), $a(["J", "J", "42"]), $a(["K", "K", "43"]), $a(["L", "L", "44"]), $a(["M", "M", "45"]), $a(["N", "N", "46"]), $a(["O", "O", "47"]), $a(["P", "P", "48"]), $a(["Q", "Q", "49"]), $a(["R", "R", "50"]), $a(["S", "S", "51"]), $a(["T", "T", "52"]), $a(["U", "U", "53"]), $a(["V", "V", "54"]), $a(["W", "W", "55"]), $a(["X", "X", "56"]), $a(["Y", "Y", "57"]), $a(["Z", "Z", "58"]), $a(["[", "[", "59"]), $a([92, 92, "60"]), $a(["]", "]", "61"]), $a(["^", "^", "62"]), $a(["_", "_", "63"]), $a([0, "`", "64"]), $a([1, "a", "65"]), $a([2, "b", "66"]), $a([3, "c", "67"]), $a([4, "d", "68"]), $a([5, "e", "69"]), $a([6, "f", "70"]), $a([7, "g", "71"]), $a([8, "h", "72"]), $a([9, "i", "73"]), $a([10, "j", "74"]), $a([11, "k", "75"]), $a([12, "l", "76"]), $a([13, "m", "77"]), $a([14, "n", "78"]), $a([15, "o", "79"]), $a([16, "p", "80"]), $a([17, "q", "81"]), $a([18, "r", "82"]), $a([19, "s", "83"]), $a([20, "t", "84"]), $a([21, "u", "85"]), $a([22, "v", "86"]), $a([23, "w", "87"]), $a([24, "x", "88"]), $a([25, "y", "89"]), $a([26, "z", "90"]), $a([27, "{", "91"]), $a([28, "|", "92"]), $a([29, "}", "93"]), $a([30, "~", "94"]), $a([31, 127, "95"]), $a([$1.sfb, $1.crl, "96"]), $a([$1.sb2, 9, "97"]), $a([$1.sb3, 28, "98"]), $a([$1.sb4, 29, "99"]), $a([$1.sb5, 30, $1.aim]), $a([$1.sb6, $1.sfa, $1.laa]), $a([$1.lab, $1.laa, $1.sfb]), $a([$1.sc2, $1.sc2, $1.sb2]), $a([$1.sc3, $1.sc3, $1.sb3]), $a([$1.sc4, $1.sc4, $1.sb4]), $a([$1.lac, $1.lac, $1.lab]), $a([$1.fn1, $1.fn1, $1.fn1]), $a([$1.fn2, $1.fn2, $1.fn2]), $a([$1.fn3, $1.fn3, $1.fn3]), $a([$1.bsa, $1.bsa, $1.bsa]), $a([$1.bsb, $1.bsb, $1.bsb]), $a([$1.bin, $1.bin, $1.bin])]); /*20663*/
			$1.charvals = $a([{}, {}, {}]); /*20666*/
			for (var _2n = 0, _2m = $1.charmaps.length - 1; _2n <= _2m; _2n += 1) { /*20675*/
				$1.i = _2n; /*20668*/
				$1.encs = $get($1.charmaps, $1.i); /*20669*/
				for (var _2r = 0; _2r <= 2; _2r += 1) { /*20674*/
					$1.j = _2r; /*20671*/
					var _2u = $get($1.encs, $1.j); /*20672*/
					$k[$j++] = _2u; /*20672*/
					if ($eq($type(_2u), "stringtype")) { /*20672*/
						var _2x = $get($k[--$j], 0); /*20672*/
						$k[$j++] = _2x; /*20672*/
					} /*20672*/
					$put($get($1.charvals, $1.j), $k[--$j], $1.i); /*20673*/
				} /*20673*/
			} /*20673*/
			$1.Avals = $get($1.charvals, 0); /*20676*/
			$1.Bvals = $get($1.charvals, 1); /*20677*/
			$put($1.Bvals, $1.m05, 97); /*20678*/
			$put($1.Bvals, $1.m06, 98); /*20679*/
			$put($1.Bvals, $1.m12, 99); /*20680*/
			$put($1.Bvals, $1.mac, 100); /*20681*/
			$1.Cvals = $get($1.charvals, 2); /*20682*/
			$k[$j++] = "BINvals"; /*20684*/
			$k[$j++] = Infinity; /*20684*/
			var _3R = $a([$1.sc2, $1.sc3, $1.sc4, $1.sc5, $1.sc6, $1.sc7, $1.tma, $1.tmb, $1.tmc, $1.tms]); /*20684*/
			$k[$j++] = 102; /*20684*/
			for (var _3S = 0, _3T = _3R.length; _3S < _3T; _3S++) { /*20684*/
				var _3W = $k[--$j] + 1; /*20684*/
				$k[$j++] = $get(_3R, _3S); /*20684*/
				$k[$j++] = _3W; /*20684*/
				$k[$j++] = _3W; /*20684*/
			} /*20684*/
			$j--; /*20684*/
			var _3X = $d(); /*20684*/
			$1[$k[--$j]] = _3X; /*20685*/
			var _3c = {
				FNC1: $1.fn1,
				FNC2: $1.fn2,
				FNC3: $1.fn3
			}; /*20690*/
			$1.fncvals = _3c; /*20691*/
			$1.msg = $a($1.barlen); /*20692*/
			$1.i = 0; /*20693*/
			$1.j = 0; /*20693*/
			for (;;) { /*20707*/
				if ($1.i == $1.barlen) { /*20694*/
					break; /*20694*/
				} /*20694*/
				$1.char = $get($1.barcode, $1.i); /*20695*/
				if (($1.parsefnc && ($1.char == 94)) && ($1.i < ($1.barlen - 4))) { /*20703*/
					if ($get($1.barcode, $1.i + 1) != 94) { /*20701*/
						$1.char = $get($1.fncvals, $geti($1.barcode, $1.i + 1, 4)); /*20698*/
						$1.i = $1.i + 4; /*20699*/
					} else { /*20701*/
						$1.i = $1.i + 1; /*20701*/
					} /*20701*/
				} /*20701*/
				$put($1.msg, $1.j, $1.char); /*20704*/
				$1.i = $1.i + 1; /*20705*/
				$1.j = $1.j + 1; /*20706*/
			} /*20706*/
			$1.msg = $geti($1.msg, 0, $1.j); /*20708*/
			$1.msglen = $1.msg.length; /*20709*/
			$k[$j++] = Infinity; /*20712*/
			for (var _48 = 0, _49 = $1.msglen + 1; _48 < _49; _48++) { /*20712*/
				$k[$j++] = 0; /*20712*/
			} /*20712*/
			$1.nDigits = $a(); /*20712*/
			$k[$j++] = Infinity; /*20713*/
			for (var _4C = 0, _4D = $1.msglen + 1; _4C < _4D; _4C++) { /*20713*/
				$k[$j++] = false; /*20713*/
			} /*20713*/
			$1.SeventeenTen = $a(); /*20713*/
			$k[$j++] = Infinity; /*20714*/
			for (var _4G = 0, _4H = $1.msglen + 1; _4G < _4H; _4G++) { /*20714*/
				$k[$j++] = false; /*20714*/
			} /*20714*/
			$1.ECI = $a(); /*20714*/
			$k[$j++] = Infinity; /*20715*/
			for (var _4K = 0, _4L = $1.msglen + 1; _4K < _4L; _4K++) { /*20715*/
				$k[$j++] = false; /*20715*/
			} /*20715*/
			$1.DatumA = $a(); /*20715*/
			$k[$j++] = Infinity; /*20716*/
			for (var _4O = 0, _4P = $1.msglen + 1; _4O < _4P; _4O++) { /*20716*/
				$k[$j++] = false; /*20716*/
			} /*20716*/
			$1.DatumB = $a(); /*20716*/
			$k[$j++] = Infinity; /*20717*/
			for (var _4S = 0, _4T = $1.msglen + 1; _4S < _4T; _4S++) { /*20717*/
				$k[$j++] = false; /*20717*/
			} /*20717*/
			$1.DatumC = $a(); /*20717*/
			$k[$j++] = Infinity; /*20718*/
			for (var _4W = 0, _4X = $1.msglen + 8; _4W < _4X; _4W++) { /*20718*/
				$k[$j++] = false; /*20718*/
			} /*20718*/
			$1.Binary = $a(); /*20718*/
			$k[$j++] = Infinity; /*20719*/
			for (var _4a = 0, _4b = $1.msglen + 1; _4a < _4b; _4a++) { /*20719*/
				$k[$j++] = 0; /*20719*/
			} /*20719*/
			$1.AheadC = $a(); /*20719*/
			$k[$j++] = Infinity; /*20720*/
			for (var _4e = 0, _4f = $1.msglen + 1; _4e < _4f; _4e++) { /*20720*/
				$k[$j++] = 0; /*20720*/
			} /*20720*/
			$1.TryC = $a(); /*20720*/
			$k[$j++] = Infinity; /*20721*/
			for (var _4i = 0, _4j = $1.msglen + 1; _4i < _4j; _4i++) { /*20721*/
				$k[$j++] = 0; /*20721*/
			} /*20721*/
			$1.AheadA = $a(); /*20721*/
			$k[$j++] = Infinity; /*20722*/
			for (var _4m = 0, _4n = $1.msglen + 1; _4m < _4n; _4m++) { /*20722*/
				$k[$j++] = 0; /*20722*/
			} /*20722*/
			$1.AheadB = $a(); /*20722*/
			$k[$j++] = Infinity; /*20723*/
			for (var _4q = 0, _4r = $1.msglen + 1; _4q < _4r; _4q++) { /*20723*/
				$k[$j++] = 0; /*20723*/
			} /*20723*/
			$1.UntilEndSeg = $a(); /*20723*/
			for (var _4u = $1.msglen - 1; _4u >= 0; _4u -= 1) { /*20778*/
				$1.i = _4u; /*20725*/
				$1.barchar = $get($1.msg, $1.i); /*20726*/
				if (($1.barchar >= 48) && ($1.barchar <= 57)) { /*20729*/
					$put($1.nDigits, $1.i, $get($1.nDigits, $1.i + 1) + 1); /*20728*/
				} /*20728*/
				var _57 = $get($1.Avals, $1.barchar) !== undefined; /*20730*/
				if (_57) { /*20730*/
					$put($1.DatumA, $1.i, true); /*20730*/
				} /*20730*/
				var _5C = $get($1.Bvals, $1.barchar) !== undefined; /*20731*/
				if (_5C) { /*20731*/
					$put($1.DatumB, $1.i, true); /*20731*/
				} /*20731*/
				$1.CRLF = false; /*20732*/
				if (($1.barchar == 13) && ($1.i < ($1.msglen - 1))) { /*20735*/
					if ($get($1.msg, $1.i + 1) == 10) { /*20734*/
						$1.CRLF = true; /*20734*/
					} /*20734*/
				} /*20734*/
				if ($1.CRLF) { /*20736*/
					$put($1.DatumB, $1.i, true); /*20736*/
				} /*20736*/
				if ($get($1.nDigits, $1.i) >= 2) { /*20737*/
					$put($1.DatumC, $1.i, true); /*20737*/
				} /*20737*/
				if ($1.barchar < 0) { /*20738*/
					$put($1.DatumC, $1.i, true); /*20738*/
				} /*20738*/
				if ($1.barchar >= 128) { /*20739*/
					$put($1.Binary, $1.i, true); /*20739*/
				} /*20739*/
				if ($get($1.nDigits, $1.i) >= 10) { /*20753*/
					$k[$j++] = Infinity; /*20741*/
					$aload($geti($1.msg, $1.i, 10)); /*20742*/
					for (var _5f = 0, _5g = 1; _5f < _5g; _5f++) { /*20750*/
						if ($k[--$j] != 48) { /*20744*/
							$k[$j++] = false; /*20744*/
							break; /*20744*/
						} /*20744*/
						if ($k[--$j] != 49) { /*20745*/
							$k[$j++] = false; /*20745*/
							break; /*20745*/
						} /*20745*/
						$j -= 6; /*20746*/
						if ($k[--$j] != 55) { /*20747*/
							$k[$j++] = false; /*20747*/
							break; /*20747*/
						} /*20747*/
						if ($k[--$j] != 49) { /*20748*/
							$k[$j++] = false; /*20748*/
							break; /*20748*/
						} /*20748*/
						$k[$j++] = true; /*20749*/
					} /*20749*/
					$put($1.SeventeenTen, $1.i, $k[--$j]); /*20751*/
					$cleartomark(); /*20752*/
				} /*20752*/
				if (($get($1.nDigits, $1.i + 1) >= 6) && ($get($1.msg, $1.i) == $1.fn2)) { /*20756*/
					$put($1.ECI, $1.i, true); /*20755*/
				} /*20755*/
				if ($1.barchar < 0) { /*20763*/
					$put($1.AheadC, $1.i, $get($1.AheadC, $1.i + 1) + 1); /*20758*/
				} else { /*20763*/
					if ($get($1.nDigits, $1.i) <= 1) { /*20763*/
						$put($1.AheadC, $1.i, 0); /*20761*/
					} else { /*20763*/
						$put($1.AheadC, $1.i, $get($1.AheadC, $1.i + 2) + 1); /*20763*/
					} /*20763*/
				} /*20763*/
				if (($get($1.nDigits, $1.i) > 0) && $gt($get($1.AheadC, $1.i), $get($1.AheadC, $1.i + 1))) { /*20768*/
					$put($1.TryC, $1.i, $get($1.AheadC, $1.i)); /*20767*/
				} /*20767*/
				if ($get($1.DatumA, $1.i) && ($get($1.TryC, $1.i) < 2)) { /*20771*/
					$put($1.AheadA, $1.i, $get($1.AheadA, $1.i + 1) + 1); /*20770*/
				} /*20770*/
				if ($get($1.DatumB, $1.i) && ($get($1.TryC, $1.i) < 2)) { /*20774*/
					$k[$j++] = $1.AheadB; /*20773*/
					$k[$j++] = $1.i; /*20773*/
					$k[$j++] = $1.AheadB; /*20773*/
					$k[$j++] = $1.i + 1; /*20773*/
					if ($1.CRLF) { /*20773*/
						var _6n = $k[--$j]; /*20773*/
						$k[$j++] = _6n + 1; /*20773*/
					} /*20773*/
					var _6o = $k[--$j]; /*20773*/
					var _6q = $get($k[--$j], _6o); /*20773*/
					var _6r = $k[--$j]; /*20773*/
					$put($k[--$j], _6r, _6q + 1); /*20773*/
				} /*20773*/
				if ($1.barchar != $1.fn3) { /*20777*/
					$put($1.UntilEndSeg, $1.i, $get($1.UntilEndSeg, $1.i + 1) + 1); /*20776*/
				} /*20776*/
			} /*20776*/
			$1.A = 0; /*20780*/
			$1.B = 1; /*20780*/
			$1.C = 2; /*20780*/
			$1.BIN = 3; /*20780*/
			$1.addtocws = function() {
				var _70 = $k[--$j]; /*20783*/
				$puti($1.cws, $1.j, _70); /*20783*/
				$1.j = _70.length + $1.j; /*20784*/
			}; /*20785*/
			$1.base259to103 = function() {
				$1.in = $k[--$j]; /*20789*/
				$1.inlen = $1.in.length; /*20790*/
				$k[$j++] = Infinity; /*20791*/
				for (var _77 = 0, _78 = 5 - $1.inlen; _77 < _78; _77++) { /*20791*/
					$k[$j++] = 0; /*20791*/
				} /*20791*/
				$aload($1.in); /*20791*/
				$1.in = $a(); /*20791*/
				$1.out = $a(6); /*20792*/
				$k[$j++] = Infinity; /*20793*/
				$aload($geti($1.in, 0, 2)); /*20793*/
				$1.msbs = $a(); /*20793*/
				$k[$j++] = Infinity; /*20797*/
				$aload($1.msbs); /*20795*/
				var _7G = $k[--$j]; /*20795*/
				var _7H = $k[--$j]; /*20795*/
				$k[$j++] = _7G + (_7H * 259); /*20796*/
				for (var _7I = 0, _7J = 2; _7I < _7J; _7I++) { /*20796*/
					var _7K = $k[--$j]; /*20796*/
					$k[$j++] = _7K % 103; /*20796*/
					$k[$j++] = ~~(_7K / 103); /*20796*/
				} /*20796*/
				$1.mscs = $a(); /*20797*/
				$k[$j++] = Infinity; /*20798*/
				$aload($geti($1.in, 2, 3)); /*20798*/
				$1.lsbs = $a(); /*20798*/
				$k[$j++] = Infinity; /*20802*/
				$aload($1.lsbs); /*20800*/
				var _7Q = $k[--$j]; /*20800*/
				var _7R = $k[--$j]; /*20800*/
				var _7S = $k[--$j]; /*20800*/
				$k[$j++] = (_7Q + (_7R * 259)) + (_7S * 67081); /*20801*/
				for (var _7T = 0, _7U = 3; _7T < _7U; _7T++) { /*20801*/
					var _7V = $k[--$j]; /*20801*/
					$k[$j++] = _7V % 103; /*20801*/
					$k[$j++] = ~~(_7V / 103); /*20801*/
				} /*20801*/
				$1.lscs = $a(); /*20802*/
				var _7Y = $get($1.lscs, 0); /*20803*/
				var _7a = $get($1.mscs, 0); /*20803*/
				$put($1.out, 5, (_7Y + (_7a * 42)) % 103); /*20804*/
				var _7d = $get($1.lscs, 1); /*20805*/
				var _7f = $get($1.mscs, 0); /*20805*/
				var _7h = $get($1.mscs, 1); /*20805*/
				$put($1.out, 4, ((((~~((_7Y + (_7a * 42)) / 103)) + _7d) + (_7f * 68)) + (_7h * 42)) % 103); /*20806*/
				var _7k = $get($1.lscs, 2); /*20807*/
				var _7m = $get($1.mscs, 0); /*20807*/
				var _7o = $get($1.mscs, 1); /*20807*/
				var _7q = $get($1.mscs, 2); /*20807*/
				$put($1.out, 3, (((((~~(((((~~((_7Y + (_7a * 42)) / 103)) + _7d) + (_7f * 68)) + (_7h * 42)) / 103)) + _7k) + (_7m * 92)) + (_7o * 68)) + (_7q * 42)) % 103); /*20808*/
				var _7t = $get($1.lscs, 3); /*20809*/
				var _7v = $get($1.mscs, 0); /*20809*/
				var _7x = $get($1.mscs, 1); /*20809*/
				var _7z = $get($1.mscs, 2); /*20809*/
				$put($1.out, 2, (((((~~((((((~~(((((~~((_7Y + (_7a * 42)) / 103)) + _7d) + (_7f * 68)) + (_7h * 42)) / 103)) + _7k) + (_7m * 92)) + (_7o * 68)) + (_7q * 42)) / 103)) + _7t) + (_7v * 15)) + (_7x * 92)) + (_7z * 68)) % 103); /*20810*/
				var _82 = $get($1.mscs, 1); /*20811*/
				var _84 = $get($1.mscs, 2); /*20811*/
				$put($1.out, 1, (((~~((((((~~((((((~~(((((~~((_7Y + (_7a * 42)) / 103)) + _7d) + (_7f * 68)) + (_7h * 42)) / 103)) + _7k) + (_7m * 92)) + (_7o * 68)) + (_7q * 42)) / 103)) + _7t) + (_7v * 15)) + (_7x * 92)) + (_7z * 68)) / 103)) + (_82 * 15)) + (_84 * 92)) % 103); /*20812*/
				$put($1.out, 0, ((~~((((~~((((((~~((((((~~(((((~~((_7Y + (_7a * 42)) / 103)) + _7d) + (_7f * 68)) + (_7h * 42)) / 103)) + _7k) + (_7m * 92)) + (_7o * 68)) + (_7q * 42)) / 103)) + _7t) + (_7v * 15)) + (_7x * 92)) + (_7z * 68)) / 103)) + (_82 * 15)) + (_84 * 92)) / 103)) + ($get($1.mscs, 2) * 15)) % 103); /*20814*/
				$k[$j++] = $geti($1.out, (6 - $1.inlen) - 1, $1.inlen + 1); /*20815*/
			}; /*20816*/
			$1.finaliseBIN = function() {
				if ($1.bpos != 0) { /*20822*/
					$k[$j++] = $geti($1.bvals, 0, $1.bpos); /*20820*/
					if ($1.base259to103() == $b) return $b; /*20820*/
					$aload($k[--$j]); /*20820*/
					$1.bpos = 0; /*20821*/
				} /*20821*/
			}; /*20823*/
			$1.addtobin = function() {
				$put($1.bvals, $1.bpos, $k[--$j]); /*20826*/
				$1.bpos = $1.bpos + 1; /*20827*/
				if ($1.bpos == 5) { /*20828*/
					if ($1.finaliseBIN() == $b) return $b; /*20828*/
				} /*20828*/
			}; /*20829*/
			$1.ECIabc = function() {
				$k[$j++] = 0; /*20832*/
				$forall($geti($1.msg, $1.i + 1, 6), function() { /*20832*/
					var _8Q = $k[--$j]; /*20832*/
					var _8R = $k[--$j]; /*20832*/
					$k[$j++] = (_8R + (_8Q - 48)) * 10; /*20832*/
				}); /*20832*/
				var _8T = ~~($k[--$j] / 10); /*20833*/
				$k[$j++] = _8T; /*20837*/
				if (_8T >= 40) { /*20837*/
					var _8V = $k[--$j] - 40; /*20835*/
					var _8W = _8V % 12769; /*20836*/
					$k[$j++] = (~~(_8V / 12769)) + 40; /*20836*/
					$k[$j++] = ~~(_8W / 113); /*20836*/
					$k[$j++] = _8W % 113; /*20836*/
				} /*20836*/
			}; /*20838*/
			$1.ECIbin = function() {
				$k[$j++] = Infinity; /*20849*/
				$k[$j++] = 0; /*20842*/
				$forall($geti($1.msg, $1.i + 1, 6), function() { /*20842*/
					var _8a = $k[--$j]; /*20842*/
					var _8b = $k[--$j]; /*20842*/
					$k[$j++] = (_8b + (_8a - 48)) * 10; /*20842*/
				}); /*20842*/
				var _8d = ~~($k[--$j] / 10); /*20843*/
				$k[$j++] = _8d; /*20851*/
				if (_8d >= 65536) { /*20849*/
					var _8e = $k[--$j]; /*20844*/
					var _8f = _8e % 65536; /*20844*/
					$k[$j++] = 258; /*20844*/
					$k[$j++] = ~~(_8e / 65536); /*20844*/
					$k[$j++] = ~~(_8f / 256); /*20844*/
					$k[$j++] = _8f % 256; /*20844*/
				} else { /*20849*/
					var _8g = $k[--$j]; /*20846*/
					$k[$j++] = _8g; /*20850*/
					if (_8g >= 256) { /*20849*/
						var _8h = $k[--$j]; /*20847*/
						$k[$j++] = 257; /*20847*/
						$k[$j++] = ~~(_8h / 256); /*20847*/
						$k[$j++] = _8h % 256; /*20847*/
					} else { /*20849*/
						var _8i = $k[--$j]; /*20849*/
						$k[$j++] = 256; /*20849*/
						$k[$j++] = _8i; /*20849*/
					} /*20849*/
				} /*20849*/
				var _8j = $a(); /*20849*/
				for (var _8k = 0, _8l = _8j.length; _8k < _8l; _8k++) { /*20854*/
					$k[$j++] = $get(_8j, _8k); /*20853*/
					if ($1.addtobin() == $b) return $b; /*20853*/
				} /*20853*/
			}; /*20855*/
			$1.encC = function() {
				for (var _8n = 0, _8o = 1; _8n < _8o; _8n++) { /*20955*/
					if ($1.i == $1.segstart) { /*20884*/
						for (var _8r = 0, _8s = 1; _8r < _8s; _8r++) { /*20876*/
							if ($1.i > ($1.segend - 7)) { /*20861*/
								$k[$j++] = 0; /*20861*/
								break; /*20861*/
							} /*20861*/
							if ($get($1.msg, $1.segstart) != 91) { /*20862*/
								$k[$j++] = 0; /*20862*/
								break; /*20862*/
							} /*20862*/
							if ($get($1.msg, $1.segstart + 1) != 41) { /*20863*/
								$k[$j++] = 0; /*20863*/
								break; /*20863*/
							} /*20863*/
							if ($get($1.msg, $1.segstart + 2) != 62) { /*20864*/
								$k[$j++] = 0; /*20864*/
								break; /*20864*/
							} /*20864*/
							if ($get($1.msg, $1.segstart + 3) != 30) { /*20865*/
								$k[$j++] = 0; /*20865*/
								break; /*20865*/
							} /*20865*/
							var _99 = $get($1.msg, $1.segstart + 4); /*20866*/
							if ((_99 < 48) || (_99 > 57)) { /*20866*/
								$k[$j++] = 0; /*20866*/
								break; /*20866*/
							} /*20866*/
							var _9C = $get($1.msg, $1.segstart + 5); /*20867*/
							if ((_9C < 48) || (_9C > 57)) { /*20867*/
								$k[$j++] = 0; /*20867*/
								break; /*20867*/
							} /*20867*/
							if ($get($1.msg, $1.segend - 1) != 4) { /*20868*/
								$k[$j++] = 0; /*20868*/
								break; /*20868*/
							} /*20868*/
							var _9M = (($get($1.msg, $1.segstart + 4) - 48) * 10) + ($get($1.msg, $1.segstart + 5) - 48); /*20870*/
							$k[$j++] = _9M; /*20870*/
							if ((_9M != 5) && ((_9M != 6) && (_9M != 12))) { /*20870*/
								$j--; /*20870*/
								$k[$j++] = $1.mac; /*20870*/
								break; /*20870*/
							} /*20870*/
							if ($get($1.msg, $1.segstart + 6) != 29) { /*20871*/
								$j--; /*20871*/
								$k[$j++] = 0; /*20871*/
								break; /*20871*/
							} /*20871*/
							if ($get($1.msg, $1.segend - 2) != 30) { /*20872*/
								$j--; /*20872*/
								$k[$j++] = 0; /*20872*/
								break; /*20872*/
							} /*20872*/
							var _9U = $k[--$j]; /*20873*/
							$k[$j++] = _9U; /*20873*/
							if (_9U == 5) { /*20873*/
								$j--; /*20873*/
								$k[$j++] = $1.m05; /*20873*/
								break; /*20873*/
							} /*20873*/
							if ($k[--$j] == 6) { /*20874*/
								$k[$j++] = $1.m06; /*20874*/
								break; /*20874*/
							} /*20874*/
							$k[$j++] = $1.m12; /*20875*/
							break; /*20875*/
						} /*20875*/
						$1.inmac = $k[--$j]; /*20877*/
						if ($1.inmac != 0) { /*20883*/
							$1.mode = $1.B; /*20879*/
							$k[$j++] = $a([$get($1.Bvals, $1.inmac)]); /*20880*/
							if ($1.addtocws() == $b) break; /*20880*/
							var _9j = ($1.inmac != $1.mac) ? 7 : 6; /*20881*/
							$1.i = $1.i + _9j; /*20881*/
							break; /*20882*/
						} /*20882*/
					} /*20882*/
					if ($get($1.SeventeenTen, $1.i)) { /*20894*/
						$k[$j++] = $a([$get($1.Cvals, $1.aim), (($get($1.msg, $1.i + 2) - 48) * 10) + ($get($1.msg, $1.i + 3) - 48), (($get($1.msg, $1.i + 4) - 48) * 10) + ($get($1.msg, $1.i + 5) - 48), (($get($1.msg, $1.i + 6) - 48) * 10) + ($get($1.msg, $1.i + 7) - 48)]); /*20891*/
						if ($1.addtocws() == $b) break; /*20891*/
						$1.i = $1.i + 10; /*20892*/
						break; /*20893*/
					} /*20893*/
					if ($get($1.DatumC, $1.i)) { /*20916*/
						var _AF = $get($1.msg, $1.i); /*20896*/
						if ((_AF == $1.fn1) || ((_AF == $1.fn2) || (_AF == $1.fn3))) { /*20912*/
							$k[$j++] = $a([$get($1.Cvals, $get($1.msg, $1.i))]); /*20897*/
							if ($1.addtocws() == $b) break; /*20897*/
							if ($get($1.ECI, $1.i)) { /*20902*/
								$k[$j++] = Infinity; /*20899*/
								if ($1.ECIabc() == $b) break; /*20899*/
								var _AS = $a(); /*20899*/
								$k[$j++] = _AS; /*20899*/
								if ($1.addtocws() == $b) break; /*20899*/
								$1.i = $1.i + 7; /*20900*/
								break; /*20901*/
							} /*20901*/
							if (($get($1.msg, $1.i) == $1.fn3) && ($1.segstart != $1.i)) { /*20909*/
								$1.i = $1.i + 1; /*20904*/
								$1.inmac = 0; /*20905*/
								$1.segstart = $1.i; /*20906*/
								$1.segend = $1.i + $get($1.UntilEndSeg, $1.i); /*20907*/
								break; /*20908*/
							} /*20908*/
							$1.i = $1.i + 1; /*20910*/
							break; /*20911*/
						} /*20911*/
						$k[$j++] = $a([(($get($1.msg, $1.i) - 48) * 10) + ($get($1.msg, $1.i + 1) - 48)]); /*20913*/
						if ($1.addtocws() == $b) break; /*20913*/
						$1.i = $1.i + 2; /*20914*/
						break; /*20915*/
					} /*20915*/
					if ($get($1.Binary, $1.i)) { /*20930*/
						if ($get($1.nDigits, $1.i + 1) > 0) { /*20926*/
							if ($get($1.msg, $1.i) < 160) { /*20922*/
								$k[$j++] = $a([$get($1.Cvals, $1.bsa), $get($1.Avals, $get($1.msg, $1.i) - 128)]); /*20920*/
								if ($1.addtocws() == $b) break; /*20920*/
							} else { /*20922*/
								$k[$j++] = $a([$get($1.Cvals, $1.bsb), $get($1.Bvals, $get($1.msg, $1.i) - 128)]); /*20922*/
								if ($1.addtocws() == $b) break; /*20922*/
							} /*20922*/
							$1.i = $1.i + 1; /*20924*/
							break; /*20925*/
						} /*20925*/
						$k[$j++] = $a([$get($1.Cvals, $1.bin)]); /*20927*/
						if ($1.addtocws() == $b) break; /*20927*/
						$1.mode = $1.BIN; /*20928*/
						break; /*20929*/
					} /*20929*/
					$1.m = $get($1.AheadA, $1.i); /*20931*/
					$1.n = $get($1.AheadB, $1.i); /*20931*/
					if ($gt($1.m, $1.n)) { /*20936*/
						$k[$j++] = $a([$get($1.Cvals, $1.laa)]); /*20933*/
						if ($1.addtocws() == $b) break; /*20933*/
						$1.mode = $1.A; /*20934*/
						break; /*20935*/
					} /*20935*/
					if ($1.i == $1.segstart) { /*20943*/
						var _Bd = $get($1.msg, $1.i); /*20938*/
						if ((_Bd == 9) || ((_Bd == 28) || ((_Bd == 29) || (_Bd == 30)))) { /*20942*/
							$k[$j++] = $a([$get($1.Cvals, $1.laa)]); /*20939*/
							if ($1.addtocws() == $b) break; /*20939*/
							$1.mode = $1.A; /*20940*/
							break; /*20941*/
						} /*20941*/
					} /*20941*/
					if ($1.n > 4) { /*20948*/
						$k[$j++] = $a([$get($1.Cvals, $1.lab)]); /*20945*/
						if ($1.addtocws() == $b) break; /*20945*/
						$1.mode = $1.B; /*20946*/
						break; /*20947*/
					} /*20947*/
					$k[$j++] = $a([$get($1.Cvals, $get($a([$1.sfb, $1.sb2, $1.sb3, $1.sb4]), $1.n - 1))]); /*20949*/
					if ($1.addtocws() == $b) break; /*20949*/
					for (var _C0 = 0, _C1 = $1.n; _C0 < _C1; _C0++) { /*20953*/
						$k[$j++] = $a([$get($1.Bvals, $get($1.msg, $1.i))]); /*20951*/
						if ($1.addtocws() == $b) break; /*20951*/
						$1.i = $1.i + 1; /*20952*/
					} /*20952*/
					break; /*20954*/
				} /*20954*/
			}; /*20956*/
			$1.encB = function() {
				for (var _C9 = 0, _CA = 1; _C9 < _CA; _C9++) { /*21031*/
					$1.n = $get($1.TryC, $1.i); /*20960*/
					if ($1.n >= 2) { /*20978*/
						if ($1.n > 4) { /*20966*/
							$k[$j++] = $a([$get($1.Bvals, $1.lac)]); /*20963*/
							if ($1.addtocws() == $b) break; /*20963*/
							$1.mode = $1.C; /*20964*/
							break; /*20965*/
						} /*20965*/
						$k[$j++] = $a([$get($1.Bvals, $get($a([$1.sfc, $1.sc2, $1.sc3, $1.sc4]), $1.n - 1))]); /*20967*/
						if ($1.addtocws() == $b) break; /*20967*/
						for (var _CW = 0, _CX = $1.n; _CW < _CX; _CW++) { /*20976*/
							if ($get($1.msg, $1.i) < 0) { /*20974*/
								$k[$j++] = $a([$get($1.Cvals, $get($1.msg, $1.i))]); /*20970*/
								if ($1.addtocws() == $b) break; /*20970*/
								$1.i = $1.i + 1; /*20971*/
							} else { /*20974*/
								$k[$j++] = $a([(($get($1.msg, $1.i) - 48) * 10) + ($get($1.msg, $1.i + 1) - 48)]); /*20973*/
								if ($1.addtocws() == $b) break; /*20973*/
								$1.i = $1.i + 2; /*20974*/
							} /*20974*/
						} /*20974*/
						break; /*20977*/
					} /*20977*/
					if ($get($1.DatumB, $1.i)) { /*21008*/
						var _Cv = $get($1.msg, $1.i); /*20980*/
						if ((_Cv == $1.fn1) || ((_Cv == $1.fn2) || (_Cv == $1.fn3))) { /*20997*/
							$k[$j++] = $a([$get($1.Bvals, $get($1.msg, $1.i))]); /*20981*/
							if ($1.addtocws() == $b) break; /*20981*/
							if ($get($1.ECI, $1.i)) { /*20986*/
								$k[$j++] = Infinity; /*20983*/
								if ($1.ECIabc() == $b) break; /*20983*/
								var _D8 = $a(); /*20983*/
								$k[$j++] = _D8; /*20983*/
								if ($1.addtocws() == $b) break; /*20983*/
								$1.i = $1.i + 7; /*20984*/
								break; /*20985*/
							} /*20985*/
							if (($get($1.msg, $1.i) == $1.fn3) && ($1.i != $1.segstart)) { /*20994*/
								$1.i = $1.i + 1; /*20988*/
								$1.mode = $1.C; /*20989*/
								$1.inmac = 0; /*20990*/
								$1.segstart = $1.i; /*20991*/
								$1.segend = $1.i + $get($1.UntilEndSeg, $1.i); /*20992*/
								break; /*20993*/
							} /*20993*/
							$1.i = $1.i + 1; /*20995*/
							break; /*20996*/
						} /*20996*/
						if (($get($1.msg, $1.i) == 13) && ($1.i < ($1.msglen - 1))) { /*21004*/
							if ($get($1.msg, $1.i + 1) == 10) { /*21003*/
								$k[$j++] = $a([$get($1.Bvals, $1.crl)]); /*21000*/
								if ($1.addtocws() == $b) break; /*21000*/
								$1.i = $1.i + 2; /*21001*/
								break; /*21002*/
							} /*21002*/
						} /*21002*/
						$k[$j++] = $a([$get($1.Bvals, $get($1.msg, $1.i))]); /*21005*/
						if ($1.addtocws() == $b) break; /*21005*/
						$1.i = $1.i + 1; /*21006*/
						break; /*21007*/
					} /*21007*/
					if ($get($1.Binary, $1.i)) { /*21022*/
						if ($get($1.DatumB, $1.i + 1)) { /*21018*/
							if ($get($1.msg, $1.i) < 160) { /*21014*/
								$k[$j++] = $a([$get($1.Bvals, $1.bsa), $get($1.Avals, $get($1.msg, $1.i) - 128)]); /*21012*/
								if ($1.addtocws() == $b) break; /*21012*/
							} else { /*21014*/
								$k[$j++] = $a([$get($1.Bvals, $1.bsb), $get($1.Bvals, $get($1.msg, $1.i) - 128)]); /*21014*/
								if ($1.addtocws() == $b) break; /*21014*/
							} /*21014*/
							$1.i = $1.i + 1; /*21016*/
							break; /*21017*/
						} /*21017*/
						$k[$j++] = $a([$get($1.Bvals, $1.bin)]); /*21019*/
						if ($1.addtocws() == $b) break; /*21019*/
						$1.mode = $1.BIN; /*21020*/
						break; /*21021*/
					} /*21021*/
					if ($get($1.AheadA, $1.i) == 1) { /*21027*/
						$k[$j++] = $a([$get($1.Bvals, $1.sfa), $get($1.Avals, $get($1.msg, $1.i))]); /*21024*/
						if ($1.addtocws() == $b) break; /*21024*/
						$1.i = $1.i + 1; /*21025*/
						break; /*21026*/
					} /*21026*/
					$k[$j++] = $a([$get($1.Bvals, $1.laa)]); /*21028*/
					if ($1.addtocws() == $b) break; /*21028*/
					$1.mode = $1.A; /*21029*/
					break; /*21030*/
				} /*21030*/
			}; /*21032*/
			$1.encA = function() {
				for (var _EX = 0, _EY = 1; _EX < _EY; _EX++) { /*21103*/
					$1.n = $get($1.TryC, $1.i); /*21036*/
					if ($1.n >= 2) { /*21054*/
						if ($1.n > 4) { /*21042*/
							$k[$j++] = $a([$get($1.Avals, $1.lac)]); /*21039*/
							if ($1.addtocws() == $b) break; /*21039*/
							$1.mode = $1.C; /*21040*/
							break; /*21041*/
						} /*21041*/
						$k[$j++] = $a([$get($1.Avals, $get($a([$1.sfc, $1.sc2, $1.sc3, $1.sc4]), $1.n - 1))]); /*21043*/
						if ($1.addtocws() == $b) break; /*21043*/
						for (var _Eu = 0, _Ev = $1.n; _Eu < _Ev; _Eu++) { /*21052*/
							if ($get($1.msg, $1.i) < 0) { /*21050*/
								$k[$j++] = $a([$get($1.Cvals, $get($1.msg, $1.i))]); /*21046*/
								if ($1.addtocws() == $b) break; /*21046*/
								$1.i = $1.i + 1; /*21047*/
							} else { /*21050*/
								$k[$j++] = $a([(($get($1.msg, $1.i) - 48) * 10) + ($get($1.msg, $1.i + 1) - 48)]); /*21049*/
								if ($1.addtocws() == $b) break; /*21049*/
								$1.i = $1.i + 2; /*21050*/
							} /*21050*/
						} /*21050*/
						break; /*21053*/
					} /*21053*/
					if ($get($1.DatumA, $1.i)) { /*21076*/
						var _FJ = $get($1.msg, $1.i); /*21056*/
						if ((_FJ == $1.fn1) || ((_FJ == $1.fn2) || (_FJ == $1.fn3))) { /*21072*/
							$k[$j++] = $a([$get($1.Avals, $get($1.msg, $1.i))]); /*21057*/
							if ($1.addtocws() == $b) break; /*21057*/
							if ($get($1.ECI, $1.i)) { /*21062*/
								$k[$j++] = Infinity; /*21059*/
								if ($1.ECIabc() == $b) break; /*21059*/
								var _FW = $a(); /*21059*/
								$k[$j++] = _FW; /*21059*/
								if ($1.addtocws() == $b) break; /*21059*/
								$1.i = $1.i + 7; /*21060*/
								break; /*21061*/
							} /*21061*/
							if (($get($1.msg, $1.i) == $1.fn3) && ($1.i != $1.segstart)) { /*21069*/
								$1.i = $1.i + 1; /*21064*/
								$1.mode = $1.C; /*21065*/
								$1.inmac = 0; /*21066*/
								$1.segstart = $1.i; /*21067*/
								$1.segend = $1.i + $get($1.UntilEndSeg, $1.i); /*21068*/
							} /*21068*/
							$1.i = $1.i + 1; /*21070*/
							break; /*21071*/
						} /*21071*/
						$k[$j++] = $a([$get($1.Avals, $get($1.msg, $1.i))]); /*21073*/
						if ($1.addtocws() == $b) break; /*21073*/
						$1.i = $1.i + 1; /*21074*/
						break; /*21075*/
					} /*21075*/
					if ($get($1.Binary, $1.i)) { /*21090*/
						if ($get($1.DatumA, $1.i + 1)) { /*21086*/
							if ($get($1.msg, $1.i) < 160) { /*21082*/
								$k[$j++] = $a([$get($1.Avals, $1.bsa), $get($1.Avals, $get($1.msg, $1.i) - 128)]); /*21080*/
								if ($1.addtocws() == $b) break; /*21080*/
							} else { /*21082*/
								$k[$j++] = $a([$get($1.Avals, $1.bsb), $get($1.Bvals, $get($1.msg, $1.i) - 128)]); /*21082*/
								if ($1.addtocws() == $b) break; /*21082*/
							} /*21082*/
							$1.i = $1.i + 1; /*21084*/
							break; /*21085*/
						} /*21085*/
						$k[$j++] = $a([$get($1.Avals, $1.bin)]); /*21087*/
						if ($1.addtocws() == $b) break; /*21087*/
						$1.mode = $1.BIN; /*21088*/
						break; /*21089*/
					} /*21089*/
					$1.n = $get($1.AheadB, $1.i); /*21091*/
					if ($1.n > 6) { /*21096*/
						$k[$j++] = $a([$get($1.Avals, $1.lab)]); /*21093*/
						if ($1.addtocws() == $b) break; /*21093*/
						$1.mode = $1.B; /*21094*/
						break; /*21095*/
					} /*21095*/
					$k[$j++] = $a([$get($1.Avals, $get($a([$1.sfb, $1.sb2, $1.sb3, $1.sb4, $1.sb5, $1.sb6]), $1.n - 1))]); /*21097*/
					if ($1.addtocws() == $b) break; /*21097*/
					for (var _Gm = 0, _Gn = $1.n; _Gm < _Gn; _Gm++) { /*21101*/
						$k[$j++] = $a([$get($1.Bvals, $get($1.msg, $1.i))]); /*21099*/
						if ($1.addtocws() == $b) break; /*21099*/
						$1.i = $1.i + 1; /*21100*/
					} /*21100*/
					break; /*21102*/
				} /*21102*/
			}; /*21104*/
			$1.encBIN = function() {
				for (var _Gv = 0, _Gw = 1; _Gv < _Gw; _Gv++) { /*21165*/
					$1.n = $get($1.TryC, $1.i); /*21108*/
					if ($1.n >= 2) { /*21127*/
						$k[$j++] = Infinity; /*21110*/
						if ($1.finaliseBIN() == $b) break; /*21110*/
						var _H1 = $a(); /*21110*/
						$k[$j++] = _H1; /*21110*/
						if ($1.addtocws() == $b) break; /*21110*/
						if ($1.n > 7) { /*21115*/
							var _H7 = $k[--$j]; /*21112*/
							$1.mode = $1.C; /*21113*/
							$k[$j++] = _H7 + $a([$get($1.BINvals, $1.tmc)]); /*21114*/
							break; /*21114*/
						} /*21114*/
						$k[$j++] = $a([$get($1.BINvals, $get($a([$1.sc2, $1.sc3, $1.sc4, $1.sc5, $1.sc6, $1.sc7]), $1.n - 2))]); /*21116*/
						if ($1.addtocws() == $b) break; /*21116*/
						for (var _HM = 0, _HN = $1.n; _HM < _HN; _HM++) { /*21125*/
							if ($get($1.msg, $1.i) < 0) { /*21123*/
								$k[$j++] = $a([$get($1.Cvals, $get($1.msg, $1.i))]); /*21119*/
								if ($1.addtocws() == $b) break; /*21119*/
								$1.i = $1.i + 1; /*21120*/
							} else { /*21123*/
								$k[$j++] = $a([(($get($1.msg, $1.i) - 48) * 10) + ($get($1.msg, $1.i + 1) - 48)]); /*21122*/
								if ($1.addtocws() == $b) break; /*21122*/
								$1.i = $1.i + 2; /*21123*/
							} /*21123*/
						} /*21123*/
						break; /*21126*/
					} /*21126*/
					if (($get($1.ECI, $1.i) && $get($1.Binary, $1.i + 7))) { /*21133*/
						$k[$j++] = Infinity; /*21129*/
						if ($1.ECIbin() == $b) break; /*21129*/
						var _Hm = $a(); /*21129*/
						$k[$j++] = _Hm; /*21129*/
						if ($1.addtocws() == $b) break; /*21129*/
						$1.i = $1.i + 7; /*21130*/
						if ($1.i == $1.msglen) { /*21131*/
							$k[$j++] = Infinity; /*21131*/
							if ($1.finaliseBIN() == $b) break; /*21131*/
							var _Hq = $a(); /*21131*/
							$k[$j++] = _Hq; /*21131*/
							if ($1.addtocws() == $b) break; /*21131*/
						} /*21131*/
						break; /*21132*/
					} /*21132*/
					if ($get($1.msg, $1.i) >= 0) { /*21143*/
						if (((($get($1.Binary, $1.i) || $get($1.Binary, $1.i + 1)) || $get($1.Binary, $1.i + 2)) || $get($1.Binary, $1.i + 3)) || ($get($1.ECI, $1.i + 1) && $get($1.Binary, $1.i + 8))) { /*21142*/
							$k[$j++] = Infinity; /*21138*/
							$k[$j++] = $get($1.msg, $1.i); /*21138*/
							if ($1.addtobin() == $b) break; /*21138*/
							var _IF = $a(); /*21138*/
							$k[$j++] = _IF; /*21138*/
							if ($1.addtocws() == $b) break; /*21138*/
							$1.i = $1.i + 1; /*21139*/
							if ($1.i == $1.msglen) { /*21140*/
								$k[$j++] = Infinity; /*21140*/
								if ($1.finaliseBIN() == $b) break; /*21140*/
								var _IJ = $a(); /*21140*/
								$k[$j++] = _IJ; /*21140*/
								if ($1.addtocws() == $b) break; /*21140*/
							} /*21140*/
							break; /*21141*/
						} /*21141*/
					} /*21141*/
					$k[$j++] = Infinity; /*21144*/
					if ($1.finaliseBIN() == $b) break; /*21144*/
					var _IK = $a(); /*21144*/
					$k[$j++] = _IK; /*21144*/
					if ($1.addtocws() == $b) break; /*21144*/
					if ($1.i != ($1.msglen - 1)) { /*21163*/
						if (($get($1.msg, $1.i) == $1.fn3) && ($1.i != $1.segstart)) { /*21154*/
							$k[$j++] = $a([$get($1.BINvals, $1.tms)]); /*21147*/
							if ($1.addtocws() == $b) break; /*21147*/
							$1.i = $1.i + 1; /*21148*/
							$1.mode = $1.C; /*21149*/
							$1.inmac = 0; /*21150*/
							$1.segstart = $1.i; /*21151*/
							$1.segend = $1.i + $get($1.UntilEndSeg, $1.i); /*21152*/
							break; /*21153*/
						} /*21153*/
						if ($gt($get($1.AheadA, $1.i), $get($1.AheadB, $1.i))) { /*21160*/
							$k[$j++] = $a([$get($1.BINvals, $1.tma)]); /*21156*/
							if ($1.addtocws() == $b) break; /*21156*/
							$1.mode = $1.A; /*21157*/
						} else { /*21160*/
							$k[$j++] = $a([$get($1.BINvals, $1.tmb)]); /*21159*/
							if ($1.addtocws() == $b) break; /*21159*/
							$1.mode = $1.B; /*21160*/
						} /*21160*/
						break; /*21162*/
					} /*21162*/
					break; /*21164*/
				} /*21164*/
			}; /*21166*/
			$1.cws = $a(($1.barlen * 2) + 1); /*21168*/
			$1.mode = $1.C; /*21169*/
			$1.bvals = $a(5); /*21170*/
			$1.bpos = 0; /*21170*/
			$1.inmac = 0; /*21171*/
			$1.segstart = 0; /*21171*/
			$1.segend = $get($1.UntilEndSeg, 0); /*21171*/
			$1.i = 0; /*21172*/
			$1.j = 0; /*21172*/
			for (;;) { /*21185*/
				if ($1.i >= $1.msglen) { /*21173*/
					break; /*21173*/
				} /*21173*/
				if ($1.inmac != 0) { /*21183*/
					if (($1.inmac != $1.mac) && ($1.i == ($1.segend - 2))) { /*21178*/
						$1.i = $1.i + 2; /*21176*/
						if ($1.i >= $1.msglen) { /*21177*/
							break; /*21177*/
						} /*21177*/
					} /*21177*/
					if (($1.inmac == $1.mac) && ($1.i == ($1.segend - 1))) { /*21182*/
						$1.i = $1.i + 1; /*21180*/
						if ($1.i >= $1.msglen) { /*21181*/
							break; /*21181*/
						} /*21181*/
					} /*21181*/
				} /*21181*/
				$1[$get($a(["encA", "encB", "encC", "encBIN"]), $1.mode)](); /*21184*/
			} /*21184*/
			$1.cws = $geti($1.cws, 0, $1.j); /*21186*/
			$1.nd = $1.cws.length; /*21189*/
			$1.minarea = (((($1.nd + 3) + (~~($1.nd / 2))) * 9) + 2) * 2; /*21190*/
			if ($1.ratio != -1) { /*21218*/
				$1.hgt = Math.sqrt($1.minarea / $1.ratio); /*21192*/
				$1.wid = Math.sqrt($1.minarea * $1.ratio); /*21193*/
				$1.h = ~~$1.hgt; /*21194*/
				$1.w = ~~$1.wid; /*21194*/
				if ((($1.h + $1.w) % 2) == 1) { /*21208*/
					if (($1.h * $1.w) < $1.minarea) { /*21196*/
						$1.h = $1.h + 1; /*21196*/
						$1.w = $1.w + 1; /*21196*/
					} /*21196*/
				} else { /*21208*/
					if (($1.hgt * $1.w) < ($1.wid * $1.h)) { /*21208*/
						$1.w = $1.w + 1; /*21199*/
						if (($1.h * $1.w) < $1.minarea) { /*21203*/
							$1.w = $1.w - 1; /*21201*/
							$1.h = $1.h + 1; /*21201*/
							if (($1.h * $1.w) < $1.minarea) { /*21202*/
								$1.w = $1.w + 2; /*21202*/
							} /*21202*/
						} /*21202*/
					} else { /*21208*/
						$1.h = $1.h + 1; /*21205*/
						if (($1.h * $1.w) < $1.minarea) { /*21209*/
							$1.h = $1.h - 1; /*21207*/
							$1.w = $1.w + 1; /*21207*/
							if (($1.h * $1.w) < $1.minarea) { /*21208*/
								$1.h = $1.h + 2; /*21208*/
							} /*21208*/
						} /*21208*/
					} /*21208*/
				} /*21208*/
				$1.rows = $1.h; /*21212*/
				$1.columns = $1.w; /*21212*/
			} else { /*21218*/
				if ($1.columns == -1) { /*21216*/
					var _K9 = ~~((($1.minarea + $1.rows) - 1) / $1.rows); /*21215*/
					$k[$j++] = "columns"; /*21215*/
					$k[$j++] = _K9; /*21215*/
					if (((_K9 + $1.rows) % 2) == 0) { /*21215*/
						var _KB = $k[--$j]; /*21215*/
						$k[$j++] = _KB + 1; /*21215*/
					} /*21215*/
					var _KC = $k[--$j]; /*21215*/
					$1[$k[--$j]] = _KC; /*21215*/
				} /*21215*/
				if ($1.rows == -1) { /*21219*/
					var _KI = ~~((($1.minarea + $1.columns) - 1) / $1.columns); /*21218*/
					$k[$j++] = "rows"; /*21218*/
					$k[$j++] = _KI; /*21218*/
					if (((_KI + $1.columns) % 2) == 0) { /*21218*/
						var _KK = $k[--$j]; /*21218*/
						$k[$j++] = _KK + 1; /*21218*/
					} /*21218*/
					var _KL = $k[--$j]; /*21218*/
					$1[$k[--$j]] = _KL; /*21218*/
				} /*21218*/
			} /*21218*/
			$1.ndots = ~~(($1.rows * $1.columns) / 2); /*21223*/
			for (;;) { /*21227*/
				var _KQ = $1.nd + 1; /*21225*/
				if ((((_KQ + ((~~(_KQ / 2)) + 3)) * 9) + 2) > $1.ndots) { /*21225*/
					break; /*21225*/
				} /*21225*/
				$1.nd = $1.nd + 1; /*21226*/
			} /*21226*/
			$1.nc = (~~($1.nd / 2)) + 3; /*21228*/
			$1.nw = $1.nd + $1.nc; /*21229*/
			$1.rembits = $1.ndots - (($1.nw * 9) + 2); /*21230*/
			if ($1.nd > $1.cws.length) { /*21237*/
				$k[$j++] = Infinity; /*21236*/
				$aload($1.cws); /*21233*/
				var _Kd = ($1.mode == $1.BIN) ? 109 : 106; /*21234*/
				$k[$j++] = _Kd; /*21235*/
				for (var _Kg = 0, _Kh = ($1.nd - $1.cws.length) - 1; _Kg < _Kh; _Kg++) { /*21235*/
					$k[$j++] = 106; /*21235*/
				} /*21235*/
				$1.cws = $a(); /*21236*/
			} /*21236*/
			$1.encs = $a(["101010101", "010101011", "010101101", "010110101", "011010101", "101010110", "101011010", "101101010", "110101010", "010101110", "010110110", "010111010", "011010110", "011011010", "011101010", "100101011", "100101101", "100110101", "101001011", "101001101", "101010011", "101011001", "101100101", "101101001", "110010101", "110100101", "110101001", "001010111", "001011011", "001011101", "001101011", "001101101", "001110101", "010010111", "010011011", "010011101", "010100111", "010110011", "010111001", "011001011", "011001101", "011010011", "011011001", "011100101", "011101001", "100101110", "100110110", "100111010", "101001110", "101011100", "101100110", "101101100", "101110010", "101110100", "110010110", "110011010", "110100110", "110101100", "110110010", "110110100", "111001010", "111010010", "111010100", "001011110", "001101110", "001110110", "001111010", "010011110", "010111100", "011001110", "011011100", "011100110", "011101100", "011110010", "011110100", "100010111", "100011011", "100011101", "100100111", "100110011", "100111001", "101000111", "101100011", "101110001", "110001011", "110001101", "110010011", "110011001", "110100011", "110110001", "111000101", "111001001", "111010001", "000101111", "000110111", "000111011", "000111101", "001001111", "001100111", "001110011", "001111001", "010001111", "011000111", "011100011", "011110001", "100011110", "100111100", "101111000", "110001110", "110011100", "110111000", "111000110", "111001100"]); /*21264*/
			if (($1.rows % 2) == 0) { /*21284*/
				$1.sixedges = $a([$a([$1.columns - 1, $1.rows - 2]), $a([0, $1.rows - 2]), $a([$1.columns - 2, $1.rows - 1]), $a([1, $1.rows - 1]), $a([$1.columns - 1, 0]), $a([0, 0])]); /*21275*/
			} else { /*21284*/
				$1.sixedges = $a([$a([$1.columns - 2, 0]), $a([$1.columns - 2, $1.rows - 1]), $a([$1.columns - 1, 1]), $a([$1.columns - 1, $1.rows - 2]), $a([0, 0]), $a([0, $1.rows - 1])]); /*21284*/
			} /*21284*/
			$1.dmv = function() {
				var _LE = $k[--$j]; /*21287*/
				var _LF = $k[--$j]; /*21287*/
				$k[$j++] = _LF + (_LE * $1.columns); /*21287*/
			}; /*21287*/
			$1.outline = $a($1.rows * $1.columns); /*21290*/
			for (var _LL = 0, _LK = $1.rows - 1; _LL <= _LK; _LL += 1) { /*21297*/
				$1.y = _LL; /*21292*/
				for (var _LO = 0, _LN = $1.columns - 1; _LO <= _LN; _LO += 1) { /*21296*/
					$1.x = _LO; /*21294*/
					$k[$j++] = $1.outline; /*21295*/
					$k[$j++] = $1.x; /*21295*/
					$k[$j++] = $1.y; /*21295*/
					if ($1.dmv() == $b) break; /*21295*/
					var _LU = $k[--$j]; /*21295*/
					$put($k[--$j], _LU, (($1.x + $1.y) % 2) - 1); /*21295*/
				} /*21295*/
			} /*21295*/
			var _LW = $1.sixedges; /*21298*/
			for (var _LX = 0, _LY = _LW.length; _LX < _LY; _LX++) { /*21300*/
				$k[$j++] = $1.outline; /*21299*/
				$aload($get(_LW, _LX)); /*21299*/
				if ($1.dmv() == $b) return $b; /*21299*/
				var _Lb = $k[--$j]; /*21299*/
				$put($k[--$j], _Lb, 1); /*21299*/
			} /*21299*/
			$1.clearcol = function() {
				$1.x = $k[--$j]; /*21303*/
				$k[$j++] = true; /*21307*/
				for (var _Lh = $1.x & 1, _Lg = $1.rows - 1; _Lh <= _Lg; _Lh += 2) { /*21307*/
					$k[$j++] = $1.x; /*21306*/
					$k[$j++] = _Lh; /*21306*/
					if ($1.dmv() == $b) break; /*21306*/
					if ($get($1.sym, $k[--$j]) == 1) { /*21306*/
						$j--; /*21306*/
						$k[$j++] = false; /*21306*/
						break; /*21306*/
					} /*21306*/
				} /*21306*/
			}; /*21308*/
			$1.clearrow = function() {
				$1.y = $k[--$j]; /*21311*/
				$k[$j++] = true; /*21315*/
				for (var _Lq = $1.y & 1, _Lp = $1.columns - 1; _Lq <= _Lp; _Lq += 2) { /*21315*/
					$k[$j++] = _Lq; /*21314*/
					$k[$j++] = $1.y; /*21314*/
					if ($1.dmv() == $b) break; /*21314*/
					if ($get($1.sym, $k[--$j]) == 1) { /*21314*/
						$j--; /*21314*/
						$k[$j++] = false; /*21314*/
						break; /*21314*/
					} /*21314*/
				} /*21314*/
			}; /*21316*/
			$1.evalsymbol = function() {
				$1.sym = $k[--$j]; /*21320*/
				$1.worst = 9999999; /*21323*/
				var _M0 = $a([$a(["x", 0]), $a(["x", 1]), $a(["y", 0]), $a(["y", 1])]); /*21324*/
				for (var _M1 = 0, _M2 = _M0.length; _M1 < _M2; _M1++) { /*21342*/
					$aload($get(_M0, _M1)); /*21325*/
					$1.fl = $k[--$j]; /*21325*/
					$1.dir = $k[--$j]; /*21325*/
					$1.sum = 0; /*21326*/
					$1.first = -1; /*21326*/
					$1.last = -1; /*21326*/
					var _M7 = $eq($1.dir, "x") ? $1.columns : $1.rows; /*21327*/
					for (var _M9 = 0, _M8 = _M7 - 1; _M9 <= _M8; _M9 += 1) { /*21338*/
						$1[$1.dir] = _M9; /*21328*/
						var _MB = $1.sym; /*21329*/
						var _MD = $1[$1.dir]; /*21330*/
						var _MF = $eq($1.dir, "x") ? $1.rows : $1.columns; /*21331*/
						var _MI = (_MF - 1) * $1.fl; /*21332*/
						if ($eq($1.dir, "y")) { /*21332*/
							var _ = _MI; /*21332*/
							_MI = _MD; /*21332*/
							_MD = _; /*21332*/
						} /*21332*/
						$k[$j++] = _MB; /*21333*/
						$k[$j++] = _MD; /*21333*/
						$k[$j++] = _MI; /*21333*/
						if ($1.dmv() == $b) break; /*21333*/
						var _MJ = $k[--$j]; /*21333*/
						if ($get($k[--$j], _MJ) == 1) { /*21337*/
							if ($1.first == -1) { /*21334*/
								$1.first = $1[$1.dir]; /*21334*/
							} /*21334*/
							$1.last = $1[$1.dir]; /*21335*/
							$1.sum = $1.sum + 1; /*21336*/
						} /*21336*/
					} /*21336*/
					var _MW = $eq($1.dir, "x") ? $1.rows : $1.columns; /*21340*/
					var _MX = (($1.sum + $1.last) - $1.first) * _MW; /*21341*/
					$k[$j++] = _MX; /*21341*/
					if (_MX < $1.worst) { /*21341*/
						$1.worst = $k[--$j]; /*21341*/
					} else { /*21341*/
						$j--; /*21341*/
					} /*21341*/
				} /*21341*/
				$1.pen = 0; /*21344*/
				if ((($1.rows % 2) == 1) || ($1.rows <= 12)) { /*21362*/
					$1.sum = 0; /*21350*/
					$1.p = 0; /*21350*/
					for (var _Me = 1, _Md = $1.columns - 2; _Me <= _Md; _Me += 1) { /*21360*/
						$k[$j++] = _Me; /*21352*/
						if ($1.clearcol() == $b) break; /*21352*/
						if ($k[--$j]) { /*21358*/
							$1.sum = $1.sum + 1; /*21353*/
							$k[$j++] = "p"; /*21354*/
							if ($1.sum == 1) { /*21354*/
								$k[$j++] = $1.rows; /*21354*/
							} else { /*21354*/
								$k[$j++] = $1.p * $1.rows; /*21354*/
							} /*21354*/
							var _Ml = $k[--$j]; /*21354*/
							$1[$k[--$j]] = _Ml; /*21354*/
						} else { /*21358*/
							$1.sum = 0; /*21356*/
							$1.pen = $1.pen + $1.p; /*21357*/
							$1.p = 0; /*21358*/
						} /*21358*/
					} /*21358*/
					$1.pen = $1.pen + $1.p; /*21361*/
				} /*21361*/
				if ((($1.rows % 2) == 0) || ($1.columns <= 12)) { /*21380*/
					$1.sum = 0; /*21368*/
					$1.p = 0; /*21368*/
					for (var _Mv = 1, _Mu = $1.rows - 2; _Mv <= _Mu; _Mv += 1) { /*21378*/
						$k[$j++] = _Mv; /*21370*/
						if ($1.clearrow() == $b) break; /*21370*/
						if ($k[--$j]) { /*21376*/
							$1.sum = $1.sum + 1; /*21371*/
							$k[$j++] = "p"; /*21372*/
							if ($1.sum == 1) { /*21372*/
								$k[$j++] = $1.columns; /*21372*/
							} else { /*21372*/
								$k[$j++] = $1.p * $1.columns; /*21372*/
							} /*21372*/
							var _N2 = $k[--$j]; /*21372*/
							$1[$k[--$j]] = _N2; /*21372*/
						} else { /*21376*/
							$1.sum = 0; /*21374*/
							$1.pen = $1.pen + $1.p; /*21375*/
							$1.p = 0; /*21376*/
						} /*21376*/
					} /*21376*/
					$1.pen = $1.pen + $1.p; /*21379*/
				} /*21379*/
				$k[$j++] = Infinity; /*21391*/
				for (var _N9 = 0, _NA = ($1.columns + 4) * 2; _N9 < _NA; _N9++) { /*21384*/
					$k[$j++] = 0; /*21384*/
				} /*21384*/
				for (var _NE = 0, _NF = $1.columns, _ND = $1.sym.length - 1; _NF < 0 ? _NE >= _ND : _NE <= _ND; _NE += _NF) { /*21389*/
					$k[$j++] = 0; /*21387*/
					$k[$j++] = 0; /*21387*/
					$aload($geti($1.sym, _NE, $1.columns)); /*21387*/
					$k[$j++] = 0; /*21388*/
					$k[$j++] = 0; /*21388*/
				} /*21388*/
				for (var _NK = 0, _NL = ($1.columns + 4) * 2; _NK < _NL; _NK++) { /*21390*/
					$k[$j++] = 0; /*21390*/
				} /*21390*/
				$1.symp = $a(); /*21391*/
				$1.columns = $1.columns + 4; /*21394*/
				$1.rows = $1.rows + 4; /*21395*/
				$1.sum = 0; /*21396*/
				for (var _NR = 2, _NQ = $1.rows - 3; _NR <= _NQ; _NR += 1) { /*21414*/
					$1.y = _NR; /*21398*/
					for (var _NV = ($1.y & 1) + 2, _NU = $1.columns - 3; _NV <= _NU; _NV += 2) { /*21413*/
						$1.x = _NV; /*21400*/
						for (var _NW = 0, _NX = 1; _NW < _NX; _NW++) { /*21412*/
							$k[$j++] = $1.symp; /*21402*/
							$k[$j++] = $1.x - 1; /*21402*/
							$k[$j++] = $1.y - 1; /*21402*/
							if ($1.dmv() == $b) break; /*21402*/
							var _Nb = $k[--$j]; /*21402*/
							if ($get($k[--$j], _Nb) == 1) { /*21402*/
								break; /*21402*/
							} /*21402*/
							$k[$j++] = $1.symp; /*21403*/
							$k[$j++] = $1.x + 1; /*21403*/
							$k[$j++] = $1.y - 1; /*21403*/
							if ($1.dmv() == $b) break; /*21403*/
							var _Nh = $k[--$j]; /*21403*/
							if ($get($k[--$j], _Nh) == 1) { /*21403*/
								break; /*21403*/
							} /*21403*/
							$k[$j++] = $1.symp; /*21404*/
							$k[$j++] = $1.x - 1; /*21404*/
							$k[$j++] = $1.y + 1; /*21404*/
							if ($1.dmv() == $b) break; /*21404*/
							var _Nn = $k[--$j]; /*21404*/
							if ($get($k[--$j], _Nn) == 1) { /*21404*/
								break; /*21404*/
							} /*21404*/
							$k[$j++] = $1.symp; /*21405*/
							$k[$j++] = $1.x + 1; /*21405*/
							$k[$j++] = $1.y + 1; /*21405*/
							if ($1.dmv() == $b) break; /*21405*/
							var _Nt = $k[--$j]; /*21405*/
							if ($get($k[--$j], _Nt) == 1) { /*21405*/
								break; /*21405*/
							} /*21405*/
							$k[$j++] = $1.symp; /*21406*/
							$k[$j++] = $1.x; /*21406*/
							$k[$j++] = $1.y; /*21406*/
							if ($1.dmv() == $b) break; /*21406*/
							var _Nz = $k[--$j]; /*21406*/
							if ($get($k[--$j], _Nz) == 0) { /*21406*/
								$1.sum = $1.sum + 1; /*21406*/
								break; /*21406*/
							} /*21406*/
							$k[$j++] = $1.symp; /*21407*/
							$k[$j++] = $1.x - 2; /*21407*/
							$k[$j++] = $1.y; /*21407*/
							if ($1.dmv() == $b) break; /*21407*/
							var _O6 = $k[--$j]; /*21407*/
							if ($get($k[--$j], _O6) == 1) { /*21407*/
								break; /*21407*/
							} /*21407*/
							$k[$j++] = $1.symp; /*21408*/
							$k[$j++] = $1.x; /*21408*/
							$k[$j++] = $1.y - 2; /*21408*/
							if ($1.dmv() == $b) break; /*21408*/
							var _OC = $k[--$j]; /*21408*/
							if ($get($k[--$j], _OC) == 1) { /*21408*/
								break; /*21408*/
							} /*21408*/
							$k[$j++] = $1.symp; /*21409*/
							$k[$j++] = $1.x + 2; /*21409*/
							$k[$j++] = $1.y; /*21409*/
							if ($1.dmv() == $b) break; /*21409*/
							var _OI = $k[--$j]; /*21409*/
							if ($get($k[--$j], _OI) == 1) { /*21409*/
								break; /*21409*/
							} /*21409*/
							$k[$j++] = $1.symp; /*21410*/
							$k[$j++] = $1.x; /*21410*/
							$k[$j++] = $1.y + 2; /*21410*/
							if ($1.dmv() == $b) break; /*21410*/
							var _OO = $k[--$j]; /*21410*/
							if ($get($k[--$j], _OO) == 1) { /*21410*/
								break; /*21410*/
							} /*21410*/
							$1.sum = $1.sum + 1; /*21411*/
						} /*21411*/
					} /*21411*/
				} /*21411*/
				$1.columns = $1.columns - 4; /*21415*/
				$1.rows = $1.rows - 4; /*21416*/
				$1.epen = 0; /*21419*/
				if ($1.worst == 0) { /*21425*/
					$k[$j++] = 0; /*21421*/
					$forall($geti($1.sym, 0, $1.columns), function() { /*21421*/
						var _OY = $k[--$j]; /*21421*/
						var _OZ = $k[--$j]; /*21421*/
						$k[$j++] = _OZ + _OY; /*21421*/
					}); /*21421*/
					if ($k[--$j] == 0) { /*21421*/
						$1.epen = $1.epen + 100000; /*21421*/
					} /*21421*/
					$k[$j++] = 0; /*21422*/
					$forall($geti($1.sym, $1.sym.length - $1.columns, $1.columns), function() { /*21422*/
						var _Oh = $k[--$j]; /*21422*/
						var _Oi = $k[--$j]; /*21422*/
						$k[$j++] = _Oi + _Oh; /*21422*/
					}); /*21422*/
					if ($k[--$j] == 0) { /*21422*/
						$1.epen = $1.epen + 200000; /*21422*/
					} /*21422*/
					$k[$j++] = 0; /*21423*/
					for (var _Oo = 0, _Op = $1.columns, _On = $1.sym.length - 1; _Op < 0 ? _Oo >= _On : _Oo <= _On; _Oo += _Op) { /*21423*/
						var _Os = $k[--$j]; /*21423*/
						$k[$j++] = _Os + $get($1.sym, _Oo); /*21423*/
					} /*21423*/
					if ($k[--$j] == 0) { /*21423*/
						$1.epen = $1.epen + 400000; /*21423*/
					} /*21423*/
					$k[$j++] = 0; /*21424*/
					for (var _Oz = $1.columns - 1, _P0 = $1.columns, _Oy = $1.sym.length - 1; _P0 < 0 ? _Oz >= _Oy : _Oz <= _Oy; _Oz += _P0) { /*21424*/
						var _P3 = $k[--$j]; /*21424*/
						$k[$j++] = _P3 + $get($1.sym, _Oz); /*21424*/
					} /*21424*/
					if ($k[--$j] == 0) { /*21424*/
						$1.epen = $1.epen + 800000; /*21424*/
					} /*21424*/
				} /*21424*/
				$k[$j++] = (($1.worst - ($1.sum * $1.sum)) - $1.pen) - $1.epen; /*21427*/
			}; /*21429*/
			$k[$j++] = Infinity; /*21432*/
			$k[$j++] = 1; /*21432*/
			for (var _PB = 0, _PC = 112; _PB < _PC; _PB++) { /*21432*/
				var _PD = $k[--$j]; /*21432*/
				$k[$j++] = _PD; /*21432*/
				$k[$j++] = (_PD * 3) % 113; /*21432*/
			} /*21432*/
			$1.rsalog = $a(); /*21432*/
			$1.step = (~~($1.nw / 112)) + 1; /*21433*/
			$1.offset = function() {
				var _PH = $k[--$j]; /*21434*/
				$k[$j++] = (_PH * $1.step) + $1.start; /*21434*/
			}; /*21434*/
			$1.bestscore = -99999999; /*21442*/
			$k[$j++] = "masks"; /*21447*/
			if ($1.mask != -1) { /*21446*/
				$k[$j++] = $a([$1.mask]); /*21444*/
			} else { /*21446*/
				if ($1.fast) { /*21446*/
					$k[$j++] = $a([3, 2, 1, 0]); /*21446*/
				} else { /*21446*/
					$k[$j++] = $a([0, 1, 2, 3]); /*21446*/
				} /*21446*/
			} /*21446*/
			var _PP = $k[--$j]; /*21447*/
			$1[$k[--$j]] = _PP; /*21447*/
			$1.litmasks = $a(4); /*21448*/
			$forall($1.masks, function() { /*21550*/
				$1.mask = $k[--$j]; /*21451*/
				$k[$j++] = Infinity; /*21458*/
				var _PY = $1.cws; /*21456*/
				$k[$j++] = $1.mask; /*21456*/
				$k[$j++] = $get($a([0, 3, 7, 17]), $1.mask); /*21456*/
				$k[$j++] = 0; /*21456*/
				for (var _PZ = 0, _Pa = _PY.length; _PZ < _Pa; _PZ++) { /*21456*/
					var _Pc = $k[--$j]; /*21456*/
					var _Pd = $k[--$j]; /*21456*/
					$k[$j++] = ($get(_PY, _PZ) + _Pc) % 113; /*21456*/
					$k[$j++] = _Pd; /*21456*/
					$k[$j++] = _Pc + _Pd; /*21456*/
				} /*21456*/
				$j -= 2; /*21456*/
				for (var _Pf = 0, _Pg = $1.nc; _Pf < _Pg; _Pf++) { /*21457*/
					$k[$j++] = 0; /*21457*/
				} /*21457*/
				$1.rscws = $a(); /*21458*/
				for (var _Pk = 0, _Pj = $1.step - 1; _Pk <= _Pj; _Pk += 1) { /*21481*/
					$1.start = _Pk; /*21460*/
					$1.ND = ~~((((($1.nd + 1) - $1.start) + $1.step) - 1) / $1.step); /*21461*/
					$1.NW = ~~((((($1.nw + 1) - $1.start) + $1.step) - 1) / $1.step); /*21462*/
					$1.NC = $1.NW - $1.ND; /*21463*/
					$k[$j++] = Infinity; /*21464*/
					$k[$j++] = 1; /*21464*/
					for (var _Pw = 0, _Px = $1.NC; _Pw < _Px; _Pw++) { /*21464*/
						$k[$j++] = 0; /*21464*/
					} /*21464*/
					$1.coeffs = $a(); /*21464*/
					for (var _Q1 = 1, _Q0 = $1.NC; _Q1 <= _Q0; _Q1 += 1) { /*21471*/
						$1.i = _Q1; /*21466*/
						for (var _Q3 = $1.NC; _Q3 >= 1; _Q3 -= 1) { /*21470*/
							$1.j = _Q3; /*21468*/
							$put($1.coeffs, $1.j, (($get($1.coeffs, $1.j) + 113) - (($get($1.rsalog, $1.i) * $get($1.coeffs, $1.j - 1)) % 113)) % 113); /*21469*/
						} /*21469*/
					} /*21469*/
					for (var _QH = 0, _QG = $1.ND - 1; _QH <= _QG; _QH += 1) { /*21479*/
						$k[$j++] = "t"; /*21473*/
						$k[$j++] = $1.rscws; /*21473*/
						$k[$j++] = _QH; /*21473*/
						if ($1.offset() == $b) break; /*21473*/
						var _QJ = $k[--$j]; /*21473*/
						var _QL = $get($k[--$j], _QJ); /*21473*/
						$k[$j++] = _QL; /*21473*/
						$k[$j++] = $1.rscws; /*21473*/
						$k[$j++] = $1.ND; /*21473*/
						if ($1.offset() == $b) break; /*21473*/
						var _QO = $k[--$j]; /*21473*/
						var _QQ = $get($k[--$j], _QO); /*21473*/
						var _QR = $k[--$j]; /*21473*/
						$1[$k[--$j]] = (_QR + _QQ) % 113; /*21473*/
						for (var _QV = 0, _QU = $1.NC - 2; _QV <= _QU; _QV += 1) { /*21477*/
							$1.j = _QV; /*21475*/
							$k[$j++] = $1.rscws; /*21476*/
							$k[$j++] = $1.ND + $1.j; /*21476*/
							if ($1.offset() == $b) break; /*21476*/
							$k[$j++] = $1.rscws; /*21476*/
							$k[$j++] = ($1.ND + $1.j) + 1; /*21476*/
							if ($1.offset() == $b) break; /*21476*/
							var _Qc = $k[--$j]; /*21476*/
							var _Qe = $get($k[--$j], _Qc); /*21476*/
							var _Qj = $k[--$j]; /*21476*/
							$put($k[--$j], _Qj, ((_Qe + 113) - (($1.t * $get($1.coeffs, $1.j + 1)) % 113)) % 113); /*21476*/
						} /*21476*/
						$k[$j++] = $1.rscws; /*21478*/
						$k[$j++] = ($1.ND + $1.NC) - 1; /*21478*/
						if ($1.offset() == $b) break; /*21478*/
						var _Qs = $k[--$j]; /*21478*/
						$put($k[--$j], _Qs, (113 - (($1.t * $get($1.coeffs, $1.NC)) % 113)) % 113); /*21478*/
					} /*21478*/
					for (var _Qx = $1.ND, _Qw = $1.NW - 1; _Qx <= _Qw; _Qx += 1) { /*21480*/
						$k[$j++] = _Qx; /*21480*/
						$k[$j++] = $1.rscws; /*21480*/
						$k[$j++] = _Qx; /*21480*/
						if ($1.offset() == $b) break; /*21480*/
						var _R0 = $k[--$j]; /*21480*/
						var _R1 = $k[--$j]; /*21480*/
						var _R2 = $k[--$j]; /*21480*/
						$k[$j++] = _R1; /*21480*/
						$k[$j++] = _R0; /*21480*/
						$k[$j++] = 113; /*21480*/
						$k[$j++] = $1.rscws; /*21480*/
						$k[$j++] = _R2; /*21480*/
						if ($1.offset() == $b) break; /*21480*/
						var _R3 = $k[--$j]; /*21480*/
						var _R5 = $get($k[--$j], _R3); /*21480*/
						var _R6 = $k[--$j]; /*21480*/
						var _R7 = $k[--$j]; /*21480*/
						$put($k[--$j], _R7, (_R6 - _R5) % 113); /*21480*/
					} /*21480*/
				} /*21480*/
				$1.bits = $s($1.ndots); /*21484*/
				$puti($1.bits, 0, $get($a(["00", "01", "10", "11"]), $1.mask)); /*21485*/
				for (var _RH = 1, _RG = $1.nw; _RH <= _RG; _RH += 1) { /*21489*/
					$1.i = _RH; /*21487*/
					$puti($1.bits, (($1.i - 1) * 9) + 2, $get($1.encs, $get($1.rscws, $1.i))); /*21488*/
				} /*21488*/
				if ($1.rembits > 0) { /*21492*/
					$puti($1.bits, ($1.nw * 9) + 2, $geti("11111111111111111", 0, $1.rembits)); /*21491*/
				} /*21491*/
				var _RU = $1.outline; /*21495*/
				$1.pixs = $arrcpy($a(_RU.length), _RU); /*21495*/
				$1.posx = 0; /*21496*/
				$k[$j++] = "posy"; /*21497*/
				if (($1.rows % 2) == 0) { /*21497*/
					$k[$j++] = 0; /*21497*/
				} else { /*21497*/
					$k[$j++] = $1.rows - 1; /*21497*/
				} /*21497*/
				var _RZ = $k[--$j]; /*21497*/
				$1[$k[--$j]] = _RZ; /*21497*/
				$forall($geti($1.bits, 0, $1.bits.length - 6), function() { /*21516*/
					for (;;) { /*21514*/
						$k[$j++] = $1.pixs; /*21500*/
						$k[$j++] = $1.posx; /*21500*/
						$k[$j++] = $1.posy; /*21500*/
						if ($1.dmv() == $b) break; /*21500*/
						var _Rh = $k[--$j]; /*21500*/
						if ($get($k[--$j], _Rh) == -1) { /*21500*/
							break; /*21500*/
						} /*21500*/
						if (($1.rows % 2) == 0) { /*21511*/
							$1.posy = $1.posy + 1; /*21502*/
							if ($1.posy == $1.rows) { /*21506*/
								$1.posy = 0; /*21504*/
								$1.posx = $1.posx + 1; /*21505*/
							} /*21505*/
						} else { /*21511*/
							$1.posx = $1.posx + 1; /*21508*/
							if ($1.posx == $1.columns) { /*21512*/
								$1.posx = 0; /*21510*/
								$1.posy = $1.posy - 1; /*21511*/
							} /*21511*/
						} /*21511*/
					} /*21511*/
					$k[$j++] = $1.pixs; /*21515*/
					$k[$j++] = $1.posx; /*21515*/
					$k[$j++] = $1.posy; /*21515*/
					if ($1.dmv() == $b) return $b; /*21515*/
					var _Rw = $k[--$j]; /*21515*/
					var _Rx = $k[--$j]; /*21515*/
					$put(_Rx, _Rw, $k[--$j] - 48); /*21515*/
				}); /*21515*/
				for (var _Rz = 0; _Rz <= 5; _Rz += 1) { /*21521*/
					$1.i = _Rz; /*21518*/
					$k[$j++] = $1.pixs; /*21519*/
					$aload($get($1.sixedges, $1.i)); /*21519*/
					if ($1.dmv() == $b) break; /*21519*/
					var _S8 = $k[--$j]; /*21520*/
					$put($k[--$j], _S8, $get($1.bits, ($1.bits.length - 6) + $1.i) - 48); /*21520*/
				} /*21520*/
				$k[$j++] = "score"; /*21524*/
				$k[$j++] = $1.pixs; /*21524*/
				if ($1.evalsymbol() == $b) return $b; /*21524*/
				var _SB = $k[--$j]; /*21524*/
				$1[$k[--$j]] = _SB; /*21524*/
				if ($1.score > $1.bestscore) { /*21529*/
					$1.bestsym = $1.pixs; /*21526*/
					$1.bestscore = $1.score; /*21527*/
					if ($1.fast && ($1.bestscore > (~~(($1.rows * $1.columns) / 2)))) { /*21528*/
						return $b; /*21528*/
					} /*21528*/
				} /*21528*/
				var _SL = $1.pixs; /*21532*/
				$1.litmask = $arrcpy($a(_SL.length), _SL); /*21532*/
				for (var _SO = 0; _SO <= 5; _SO += 1) { /*21537*/
					$1.i = _SO; /*21534*/
					$k[$j++] = $1.litmask; /*21535*/
					$aload($get($1.sixedges, $1.i)); /*21535*/
					if ($1.dmv() == $b) break; /*21535*/
					var _ST = $k[--$j]; /*21536*/
					$put($k[--$j], _ST, 1); /*21536*/
				} /*21536*/
				$put($1.litmasks, $1.mask, $1.litmask); /*21538*/
				if ($1.fast) { /*21548*/
					$k[$j++] = "score"; /*21542*/
					$k[$j++] = $1.litmask; /*21542*/
					if ($1.evalsymbol() == $b) return $b; /*21542*/
					var _Sa = $k[--$j]; /*21542*/
					$1[$k[--$j]] = _Sa; /*21542*/
					if ($gt($1.score, $1.bestscore)) { /*21547*/
						$1.bestsym = $1.litmask; /*21544*/
						$1.bestscore = $1.score; /*21545*/
						if ($1.bestscore > (~~(($1.rows * $1.columns) / 2))) { /*21546*/
							return $b; /*21546*/
						} /*21546*/
					} /*21546*/
				} /*21546*/
			}); /*21546*/
			$1.pixs = $1.bestsym; /*21551*/
			if ((!$1.fast) && ($1.bestscore <= (~~(($1.rows * $1.columns) / 2)))) { /*21565*/
				$1.bestscore = -99999999; /*21555*/
				$forall($1.masks, function() { /*21563*/
					$1.litmask = $get($1.litmasks, $k[--$j]); /*21557*/
					$k[$j++] = "score"; /*21558*/
					$k[$j++] = $1.litmask; /*21558*/
					if ($1.evalsymbol() == $b) return $b; /*21558*/
					var _St = $k[--$j]; /*21558*/
					$1[$k[--$j]] = _St; /*21558*/
					if ($1.score > $1.bestscore) { /*21562*/
						$1.bestsym = $1.litmask; /*21560*/
						$1.bestscore = $1.score; /*21561*/
					} /*21561*/
				}); /*21561*/
				$1.pixs = $1.bestsym; /*21564*/
			} /*21564*/
			var _T6 = {
				ren: $0.renmatrix,
				pixs: $1.pixs,
				pixx: $1.columns,
				pixy: $1.rows,
				height: ($1.rows * 2) / 72,
				width: ($1.columns * 2) / 72,
				opt: $1.options
			}; /*21575*/
			$k[$j++] = _T6; /*21578*/
			if (!$1.dontdraw) { /*21578*/
				$0.renmatrix(); /*21578*/
			} /*21578*/
		};
		$0.ultracode = function() {
			var $1 = {}; /*21605*/
			$1.options = $k[--$j]; /*21607*/
			$1.barcode = $k[--$j]; /*21608*/
			$1.dontdraw = false; /*21610*/
			$1.eclevel = "EC2"; /*21611*/
			$1.parse = false; /*21612*/
			$1.parsefnc = false; /*21613*/
			$forall($1.options, function() { /*21624*/
				var _3 = $k[--$j]; /*21624*/
				$1[$k[--$j]] = _3; /*21624*/
			}); /*21624*/
			$1.barlen = $1.barcode.length; /*21647*/
			$1.fn1 = -1; /*21650*/
			$1.fn3 = -2; /*21650*/
			var _8 = {
				FNC1: $1.fn1,
				FNC3: $1.fn3
			}; /*21653*/
			$1.fncvals = _8; /*21654*/
			$1.msg = $a($1.barlen); /*21655*/
			$1.i = 0; /*21656*/
			$1.j = 0; /*21656*/
			for (;;) { /*21670*/
				if ($1.i == $1.barlen) { /*21657*/
					break; /*21657*/
				} /*21657*/
				$1.char = $get($1.barcode, $1.i); /*21658*/
				if (($1.parsefnc && ($1.char == 94)) && ($1.i < ($1.barlen - 4))) { /*21666*/
					if ($get($1.barcode, $1.i + 1) != 94) { /*21664*/
						$1.char = $get($1.fncvals, $geti($1.barcode, $1.i + 1, 4)); /*21661*/
						$1.i = $1.i + 4; /*21662*/
					} else { /*21664*/
						$1.i = $1.i + 1; /*21664*/
					} /*21664*/
				} /*21664*/
				$put($1.msg, $1.j, $1.char); /*21667*/
				$1.i = $1.i + 1; /*21668*/
				$1.j = $1.j + 1; /*21669*/
			} /*21669*/
			$1.msg = $geti($1.msg, 0, $1.j); /*21671*/
			$1.msglen = $1.msg.length; /*21672*/
			$1.start = 257; /*21675*/
			$1.scr = $a([]); /*21676*/
			$1.link1 = 0; /*21677*/
			$1.scp = $a([]); /*21678*/
			$k[$j++] = Infinity; /*21686*/
			$aload($1.scr); /*21680*/
			$aload($1.scp); /*21681*/
			$forall($1.msg, function() { /*21685*/
				var _i = $k[--$j]; /*21683*/
				$k[$j++] = _i; /*21683*/
				if (_i == $1.fn1) { /*21683*/
					$j--; /*21683*/
					$k[$j++] = 268; /*21683*/
				} /*21683*/
				var _k = $k[--$j]; /*21684*/
				$k[$j++] = _k; /*21684*/
				if (_k == $1.fn3) { /*21684*/
					$j--; /*21684*/
					$k[$j++] = 269; /*21684*/
				} /*21684*/
			}); /*21684*/
			$1.dcws = $a(); /*21686*/
			$1.mcc = $1.dcws.length + 3; /*21687*/
			$1.eclval = $get($1.eclevel, 2) - 48; /*21689*/
			if ($1.eclval != 0) { /*21693*/
				$k[$j++] = "qcc"; /*21691*/
				$k[$j++] = $get($a([0, 1, 2, 4, 6, 8]), $1.eclval); /*21691*/
				$k[$j++] = ~~($1.mcc / 25); /*21691*/
				if (($1.mcc % 25) != 0) { /*21691*/
					var _w = $k[--$j]; /*21691*/
					$k[$j++] = _w + 1; /*21691*/
				} /*21691*/
				var _x = $k[--$j]; /*21691*/
				var _y = $k[--$j]; /*21691*/
				$1[$k[--$j]] = (_y * _x) + 5; /*21691*/
			} else { /*21693*/
				$1.qcc = 3; /*21693*/
			} /*21693*/
			$1.acc = ($1.qcc - 3) + (78 * $1.link1); /*21695*/
			$1.tcc = $1.mcc + $1.qcc; /*21696*/
			$1.metrics = $a([$a([2, 4, 34, 5]), $a([3, 33, 82, 13]), $a([4, 82, 158, 23]), $a([5, 134, 282, 30])]); /*21706*/
			for (var _19 = 0; _19 <= 3; _19 += 1) { /*21717*/
				$1.i = _19; /*21708*/
				$1.m = $get($1.metrics, $1.i); /*21709*/
				$1.rows = $get($1.m, 0); /*21710*/
				$1.minc = $get($1.m, 1); /*21711*/
				$1.maxc = $get($1.m, 2); /*21712*/
				$1.mcol = $get($1.m, 3); /*21713*/
				$1.okay = true; /*21714*/
				if (($1.tcc < $1.minc) || ($1.tcc > $1.maxc)) { /*21715*/
					$1.okay = false; /*21715*/
				} /*21715*/
				if ($1.okay) { /*21716*/
					break; /*21716*/
				} /*21716*/
			} /*21716*/
			if (!$1.okay) { /*21721*/
				$k[$j++] = "bwipp.ultracodeNoValidSymbol"; /*21720*/
				$k[$j++] = "No valid symbol available"; /*21720*/
				$0.raiseerror(); /*21720*/
			} /*21720*/
			for (var _1S = $1.mcol; _1S <= 61; _1S += 1) { /*21735*/
				$1.columns = _1S; /*21725*/
				$k[$j++] = $1.columns; /*21727*/
				if ($1.columns >= 15) { /*21727*/
					var _1V = $k[--$j]; /*21727*/
					$k[$j++] = _1V - 1; /*21727*/
				} /*21727*/
				if ($1.columns >= 31) { /*21728*/
					var _1X = $k[--$j]; /*21728*/
					$k[$j++] = _1X - 1; /*21728*/
				} /*21728*/
				if ($1.columns >= 47) { /*21729*/
					var _1Z = $k[--$j]; /*21729*/
					$k[$j++] = _1Z - 1; /*21729*/
				} /*21729*/
				var _1d = (($k[--$j] * $1.rows) - 3) - $1.tcc; /*21730*/
				$k[$j++] = _1d; /*21733*/
				if (_1d >= 0) { /*21733*/
					$1.pads = $k[--$j]; /*21731*/
					break; /*21732*/
				} /*21732*/
				$j--; /*21734*/
			} /*21734*/
			$1.dcc = $1.columns - $1.mcol; /*21736*/
			$k[$j++] = Infinity; /*21747*/
			$k[$j++] = $1.start; /*21743*/
			$k[$j++] = $1.mcc; /*21743*/
			$k[$j++] = $1.acc; /*21743*/
			$aload($1.scr); /*21743*/
			$aload($1.dcws); /*21744*/
			for (var _1n = 0, _1o = $1.qcc; _1n < _1o; _1n++) { /*21745*/
				$k[$j++] = 0; /*21745*/
			} /*21745*/
			$k[$j++] = 0; /*21746*/
			$1.rsseq = $a(); /*21747*/
			$k[$j++] = Infinity; /*21750*/
			$k[$j++] = 1; /*21750*/
			for (var _1q = 0, _1r = 282; _1q < _1r; _1q++) { /*21750*/
				var _1s = $k[--$j]; /*21750*/
				$k[$j++] = _1s; /*21750*/
				$k[$j++] = (_1s * 3) % 283; /*21750*/
			} /*21750*/
			$1.rsalog = $a(); /*21750*/
			$1.rslog = $a(283); /*21751*/
			for (var _1v = 1; _1v <= 282; _1v += 1) { /*21752*/
				$put($1.rslog, $get($1.rsalog, _1v), _1v); /*21752*/
			} /*21752*/
			$1.rsprod = function() {
				var _1z = $k[--$j]; /*21756*/
				var _20 = $k[--$j]; /*21756*/
				$k[$j++] = _20; /*21760*/
				$k[$j++] = _1z; /*21760*/
				if ((_1z != 0) && (_20 != 0)) { /*21759*/
					var _23 = $get($1.rslog, $k[--$j]); /*21757*/
					var _28 = $get($1.rsalog, (_23 + $get($1.rslog, $k[--$j])) % 282); /*21757*/
					$k[$j++] = _28; /*21757*/
				} else { /*21759*/
					$j -= 2; /*21759*/
					$k[$j++] = 0; /*21759*/
				} /*21759*/
			}; /*21761*/
			$1.n = $1.mcc; /*21764*/
			$1.k = $1.qcc; /*21764*/
			$k[$j++] = Infinity; /*21765*/
			$k[$j++] = 1; /*21765*/
			for (var _2C = 0, _2D = $1.k; _2C < _2D; _2C++) { /*21765*/
				$k[$j++] = 0; /*21765*/
			} /*21765*/
			$1.coeffs = $a(); /*21765*/
			for (var _2H = 1, _2G = $1.k; _2H <= _2G; _2H += 1) { /*21774*/
				$1.i = _2H; /*21767*/
				$put($1.coeffs, $1.i, $get($1.coeffs, $1.i - 1)); /*21768*/
				for (var _2O = $1.i - 1; _2O >= 1; _2O -= 1) { /*21772*/
					$1.j = _2O; /*21770*/
					$k[$j++] = $1.coeffs; /*21771*/
					$k[$j++] = $1.j; /*21771*/
					$k[$j++] = $get($1.coeffs, $1.j - 1); /*21771*/
					$k[$j++] = $get($1.coeffs, $1.j); /*21771*/
					$k[$j++] = $get($1.rsalog, $1.i); /*21771*/
					if ($1.rsprod() == $b) break; /*21771*/
					var _2a = $k[--$j]; /*21771*/
					var _2b = $k[--$j]; /*21771*/
					var _2c = $k[--$j]; /*21771*/
					$put($k[--$j], _2c, (_2b + _2a) % 283); /*21771*/
				} /*21771*/
				$k[$j++] = $1.coeffs; /*21773*/
				$k[$j++] = 0; /*21773*/
				$k[$j++] = $get($1.coeffs, 0); /*21773*/
				$k[$j++] = $get($1.rsalog, $1.i); /*21773*/
				if ($1.rsprod() == $b) break; /*21773*/
				var _2k = $k[--$j]; /*21773*/
				var _2l = $k[--$j]; /*21773*/
				$put($k[--$j], _2l, _2k); /*21773*/
			} /*21773*/
			$1.coeffs = $geti($1.coeffs, 0, $1.coeffs.length - 1); /*21775*/
			for (var _2r = $1.coeffs.length - 1; _2r >= 0; _2r -= 2) { /*21776*/
				var _2s = $1.coeffs; /*21776*/
				$put(_2s, _2r, 283 - $get(_2s, _2r)); /*21776*/
			} /*21776*/
			for (var _2w = 0, _2v = $1.n - 1; _2w <= _2v; _2w += 1) { /*21785*/
				$1.t = ($get($1.rsseq, _2w) + $get($1.rsseq, $1.n)) % 283; /*21780*/
				for (var _34 = 0, _33 = $1.k - 1; _34 <= _33; _34 += 1) { /*21784*/
					$1.j = _34; /*21782*/
					$put($1.rsseq, $1.n + $1.j, ($get($1.rsseq, ($1.n + $1.j) + 1) + (283 - (($1.t * $get($1.coeffs, ($1.k - $1.j) - 1)) % 283))) % 283); /*21783*/
				} /*21783*/
			} /*21783*/
			for (var _3L = $1.n, _3K = $1.n + $1.k; _3L <= _3K; _3L += 1) { /*21786*/
				$put($1.rsseq, _3L, (283 - $get($1.rsseq, _3L)) % 283); /*21786*/
			} /*21786*/
			$1.ecws = $geti($1.rsseq, $1.n, $1.k); /*21787*/
			$1.dccu = $a([51363, 51563, 51653, 53153, 53163, 53513, 53563, 53613, 53653, 56153, 56163, 56313, 56353, 56363, 56513, 56563, 51316, 51356, 51536, 51616, 53156, 53516, 53536, 53616, 53636, 53656, 56136, 56156, 56316, 56356, 56516, 56536]); /*21794*/
			$1.dccl = $a([61351, 61361, 61531, 61561, 61631, 61651, 63131, 63151, 63161, 63531, 63561, 63631, 65131, 65161, 65351, 65631, 31351, 31361, 31531, 31561, 31631, 31651, 35131, 35151, 35161, 35361, 35631, 35651, 36131, 36151, 36351, 36531]); /*21801*/
			$1.tiles = $a([13135, 13136, 13153, 13156, 13163, 13165, 13513, 13515, 13516, 13531, 13535, 13536, 13561, 13563, 13565, 13613, 13615, 13616, 13631, 13635, 13636, 13651, 13653, 13656, 15135, 15136, 15153, 15163, 15165, 15313, 15315, 15316, 15351, 15353, 15356, 15361, 15363, 15365, 15613, 15615, 15616, 15631, 15635, 15636, 15651, 15653, 15656, 16135, 16136, 16153, 16156, 16165, 16313, 16315, 16316, 16351, 16353, 16356, 16361, 16363, 16365, 16513, 16515, 16516, 16531, 16535, 16536, 16561, 16563, 16565, 31315, 31316, 31351, 31356, 31361, 31365, 31513, 31515, 31516, 31531, 31535, 31536, 31561, 31563, 31565, 31613, 31615, 31631, 31635, 31636, 31651, 31653, 31656, 35131, 35135, 35136, 35151, 35153, 35156, 35161, 35163, 35165, 35315, 35316, 35351, 35356, 35361, 35365, 35613, 35615, 35616, 35631, 35635, 35636, 35651, 35653, 35656, 36131, 36135, 36136, 36151, 36153, 36156, 36163, 36165, 36315, 36316, 36351, 36356, 36361, 36365, 36513, 36515, 36516, 36531, 36535, 36536, 36561, 36563, 36565, 51313, 51315, 51316, 51351, 51353, 51356, 51361, 51363, 51365, 51513, 51516, 51531, 51536, 51561, 51563, 51613, 51615, 51616, 51631, 51635, 51636, 51651, 51653, 51656, 53131, 53135, 53136, 53151, 53153, 53156, 53161, 53163, 53165, 53513, 53516, 53531, 53536, 53561, 53563, 53613, 53615, 53616, 53631, 53635, 53636, 53651, 53653, 53656, 56131, 56135, 56136, 56151, 56153, 56156, 56161, 56163, 56165, 56313, 56315, 56316, 56351, 56353, 56356, 56361, 56363, 56365, 56513, 56516, 56531, 56536, 56561, 56563, 61313, 61315, 61316, 61351, 61353, 61356, 61361, 61363, 61365, 61513, 61515, 61516, 61531, 61535, 61536, 61561, 61563, 61565, 61615, 61631, 61635, 61651, 61653, 63131, 63135, 63136, 63151, 63153, 63156, 63161, 63163, 63165, 63513, 63515, 63516, 63531, 63535, 63536, 63561, 63563, 63565, 63613, 63615, 63631, 63635, 63651, 63653, 65131, 65135, 65136, 65151, 65153, 65156, 65161, 65163, 65165, 65313, 65315, 65316, 65351, 65353, 65356, 65361, 65363, 65365, 65613, 65615, 65631, 65635, 65651, 65653, 56565, 51515]); /*21833*/
			$1.rows = ($1.rows * 6) + 1; /*21836*/
			$1.columns = $1.columns + 6; /*21837*/
			$k[$j++] = Infinity; /*21838*/
			for (var _3a = 0, _3b = $1.rows * $1.columns; _3a < _3b; _3a++) { /*21838*/
				$k[$j++] = -1; /*21838*/
			} /*21838*/
			$1.pixs = $a(); /*21838*/
			$1.qmv = function() {
				var _3e = $k[--$j]; /*21839*/
				var _3f = $k[--$j]; /*21839*/
				$k[$j++] = _3f + (_3e * $1.columns); /*21839*/
			}; /*21839*/
			for (var _3i = 0, _3h = $1.columns - 1; _3i <= _3h; _3i += 1) { /*21848*/
				$1.i = _3i; /*21841*/
				for (var _3l = 0, _3k = $1.rows - 1; _3l <= _3k; _3l += 6) { /*21845*/
					$1.j = _3l; /*21843*/
					if ($1.i >= 5) { /*21844*/
						$k[$j++] = $1.pixs; /*21844*/
						$k[$j++] = $1.i; /*21844*/
						$k[$j++] = $1.j; /*21844*/
						if ($1.qmv() == $b) break; /*21844*/
						var _3r = $k[--$j]; /*21844*/
						$put($k[--$j], _3r, ($1.i % 2) * 9); /*21844*/
					} /*21844*/
				} /*21844*/
				$k[$j++] = $1.pixs; /*21846*/
				$k[$j++] = $1.i; /*21846*/
				$k[$j++] = 0; /*21846*/
				if ($1.qmv() == $b) break; /*21846*/
				var _3v = $k[--$j]; /*21846*/
				$put($k[--$j], _3v, 9); /*21846*/
				$k[$j++] = $1.pixs; /*21847*/
				$k[$j++] = $1.i; /*21847*/
				$k[$j++] = $1.rows - 1; /*21847*/
				if ($1.qmv() == $b) break; /*21847*/
				var _40 = $k[--$j]; /*21847*/
				$put($k[--$j], _40, 9); /*21847*/
			} /*21847*/
			for (var _44 = 1, _43 = $1.rows - 2; _44 <= _43; _44 += 1) { /*21861*/
				$1.i = _44; /*21850*/
				for (var _47 = 3, _46 = $1.columns - 1; _47 <= _46; _47 += 16) { /*21854*/
					$1.j = _47; /*21852*/
					$k[$j++] = $1.pixs; /*21853*/
					$k[$j++] = $1.j; /*21853*/
					$k[$j++] = $1.i; /*21853*/
					if ($1.qmv() == $b) break; /*21853*/
					var _4C = $k[--$j]; /*21853*/
					$put($k[--$j], _4C, (1 - ($1.i % 2)) * 9); /*21853*/
				} /*21853*/
				$k[$j++] = $1.pixs; /*21855*/
				$k[$j++] = 0; /*21855*/
				$k[$j++] = $1.i; /*21855*/
				if ($1.qmv() == $b) break; /*21855*/
				var _4G = $k[--$j]; /*21855*/
				$put($k[--$j], _4G, 9); /*21855*/
				$k[$j++] = $1.pixs; /*21856*/
				$k[$j++] = 1; /*21856*/
				$k[$j++] = $1.i; /*21856*/
				if ($1.qmv() == $b) break; /*21856*/
				var _4L = $k[--$j]; /*21856*/
				$put($k[--$j], _4L, (1 - ($1.i % 2)) * 9); /*21856*/
				$k[$j++] = $1.pixs; /*21857*/
				$k[$j++] = 2; /*21857*/
				$k[$j++] = $1.i; /*21857*/
				if ($1.qmv() == $b) break; /*21857*/
				var _4P = $k[--$j]; /*21857*/
				$put($k[--$j], _4P, 0); /*21857*/
				$k[$j++] = $1.pixs; /*21858*/
				$k[$j++] = 3; /*21858*/
				$k[$j++] = $1.i; /*21858*/
				if ($1.qmv() == $b) break; /*21858*/
				var _4T = $k[--$j]; /*21858*/
				$put($k[--$j], _4T, 9); /*21858*/
				$k[$j++] = $1.pixs; /*21859*/
				$k[$j++] = 4; /*21859*/
				$k[$j++] = $1.i; /*21859*/
				if ($1.qmv() == $b) break; /*21859*/
				var _4X = $k[--$j]; /*21859*/
				$put($k[--$j], _4X, 0); /*21859*/
				$k[$j++] = $1.pixs; /*21860*/
				$k[$j++] = $1.columns - 1; /*21860*/
				$k[$j++] = $1.i; /*21860*/
				if ($1.qmv() == $b) break; /*21860*/
				var _4c = $k[--$j]; /*21860*/
				$put($k[--$j], _4c, 9); /*21860*/
			} /*21860*/
			$1.i = (~~($1.rows / 2)) - 5; /*21864*/
			$k[$j++] = Infinity; /*21868*/
			var _4j = $cvrs($s(5), $get($1.dccu, $1.dcc), 10); /*21866*/
			for (var _4k = 0, _4l = _4j.length; _4k < _4l; _4k++) { /*21866*/
				$k[$j++] = $get(_4j, _4k) - 48; /*21866*/
			} /*21866*/
			var _4r = $cvrs($s(5), $get($1.dccl, $1.dcc), 10); /*21868*/
			$k[$j++] = 0; /*21868*/
			for (var _4s = 0, _4t = _4r.length; _4s < _4t; _4s++) { /*21868*/
				$k[$j++] = $get(_4r, _4s) - 48; /*21868*/
			} /*21868*/
			var _4v = $a(); /*21868*/
			for (var _4w = 0, _4x = _4v.length; _4w < _4x; _4w++) { /*21872*/
				$k[$j++] = $get(_4v, _4w); /*21870*/
				$k[$j++] = $1.pixs; /*21870*/
				$k[$j++] = 2; /*21870*/
				$k[$j++] = $1.i; /*21870*/
				if ($1.qmv() == $b) return $b; /*21870*/
				var _51 = $k[--$j]; /*21870*/
				var _52 = $k[--$j]; /*21870*/
				$put(_52, _51, $k[--$j]); /*21870*/
				$1.i = $1.i + 1; /*21871*/
			} /*21871*/
			$k[$j++] = Infinity; /*21886*/
			$k[$j++] = $1.start; /*21878*/
			$k[$j++] = $1.mcc; /*21878*/
			$aload($1.ecws); /*21878*/
			$k[$j++] = $1.tcc; /*21882*/
			$k[$j++] = 283; /*21882*/
			$k[$j++] = $1.acc; /*21882*/
			$aload($1.scr); /*21882*/
			$aload($1.dcws); /*21883*/
			for (var _5D = 0, _5E = $1.pads; _5D < _5E; _5D++) { /*21884*/
				$k[$j++] = 284; /*21884*/
			} /*21884*/
			$k[$j++] = $1.qcc; /*21885*/
			$1.tileseq = $a(); /*21886*/
			$1.x = 5; /*21888*/
			$1.y = 1; /*21888*/
			var _5H = $1.tileseq; /*21889*/
			for (var _5I = 0, _5J = _5H.length; _5I < _5J; _5I++) { /*21902*/
				var _5O = $cvrs($s(5), $get($1.tiles, $get(_5H, _5I)), 10); /*21890*/
				for (var _5P = 0, _5Q = _5O.length; _5P < _5Q; _5P++) { /*21893*/
					$k[$j++] = $get(_5O, _5P); /*21891*/
					$k[$j++] = $1.pixs; /*21891*/
					$k[$j++] = $1.x; /*21891*/
					$k[$j++] = $1.y; /*21891*/
					if ($1.qmv() == $b) return $b; /*21891*/
					var _5V = $k[--$j]; /*21891*/
					var _5W = $k[--$j]; /*21891*/
					$put(_5W, _5V, $k[--$j] - 48); /*21891*/
					$1.y = $1.y + 1; /*21892*/
				} /*21892*/
				if ($1.y != ($1.rows - 1)) { /*21899*/
					$1.y = $1.y + 1; /*21895*/
				} else { /*21899*/
					$1.x = $1.x + 1; /*21897*/
					$1.y = 1; /*21897*/
					$k[$j++] = $1.pixs; /*21898*/
					$k[$j++] = $1.x; /*21898*/
					$k[$j++] = $1.y; /*21898*/
					if ($1.qmv() == $b) return $b; /*21898*/
					var _5g = $k[--$j]; /*21898*/
					if ($get($k[--$j], _5g) != -1) { /*21900*/
						$1.x = $1.x + 1; /*21899*/
					} /*21899*/
				} /*21899*/
			} /*21899*/
			$k[$j++] = Infinity; /*21920*/
			$k[$j++] = "ren"; /*21918*/
			$k[$j++] = $0.renmatrix; /*21918*/
			$k[$j++] = "pixs"; /*21918*/
			$k[$j++] = $1.pixs; /*21918*/
			$k[$j++] = "pixx"; /*21918*/
			$k[$j++] = $1.columns; /*21918*/
			$k[$j++] = "pixy"; /*21918*/
			$k[$j++] = $1.rows; /*21918*/
			$k[$j++] = "height"; /*21918*/
			$k[$j++] = $1.rows / 72; /*21918*/
			$k[$j++] = "width"; /*21918*/
			$k[$j++] = $1.columns / 72; /*21918*/
			$k[$j++] = "colormap"; /*21918*/
			$k[$j++] = Infinity; /*21918*/
			$k[$j++] = 0; /*21918*/
			$k[$j++] = "00000000"; /*21918*/
			$k[$j++] = 9; /*21918*/
			$k[$j++] = "000000FF"; /*21918*/
			$k[$j++] = 1; /*21918*/
			$k[$j++] = "FF000000"; /*21918*/
			$k[$j++] = 3; /*21918*/
			$k[$j++] = "00FF0000"; /*21918*/
			$k[$j++] = 5; /*21918*/
			$k[$j++] = "0000FF00"; /*21918*/
			$k[$j++] = 6; /*21918*/
			$k[$j++] = "7F00FF00"; /*21918*/
			var _5p = $d(); /*21918*/
			$k[$j++] = _5p; /*21920*/
			$k[$j++] = "opt"; /*21920*/
			$k[$j++] = $1.options; /*21920*/
			var _5r = $d(); /*21920*/
			$k[$j++] = _5r; /*21923*/
			if (!$1.dontdraw) { /*21923*/
				$0.renmatrix(); /*21923*/
			} /*21923*/
		};
		$0["gs1-cc"] = function() {
			var $1 = {}; /*21952*/
			$1.options = $k[--$j]; /*21954*/
			$1.barcode = $k[--$j]; /*21955*/
			$1.dontdraw = false; /*21957*/
			$1.ccversion = "a"; /*21958*/
			$1.cccolumns = -1; /*21959*/
			$1.lintype = ""; /*21960*/
			$1.linwidth = -1; /*21961*/
			$forall($1.options, function() { /*21972*/
				var _3 = $k[--$j]; /*21972*/
				$1[$k[--$j]] = _3; /*21972*/
			}); /*21972*/
			$1.cccolumns = ~~$1.cccolumns; /*21974*/
			$1.linwidth = ~~$1.linwidth; /*21975*/
			if ($1.cccolumns == -1) { /*21994*/
				$k[$j++] = Infinity; /*21992*/
				$k[$j++] = "ean13"; /*21985*/
				$k[$j++] = 4; /*21985*/
				$k[$j++] = "upca"; /*21985*/
				$k[$j++] = 4; /*21985*/
				$k[$j++] = "ean8"; /*21985*/
				$k[$j++] = 3; /*21985*/
				$k[$j++] = "upce"; /*21985*/
				$k[$j++] = 2; /*21985*/
				$k[$j++] = "gs1-128"; /*21985*/
				if ($ne($1.ccversion, "c")) { /*21985*/
					$k[$j++] = 4; /*21985*/
				} else { /*21985*/
					$k[$j++] = ~~(($1.linwidth - 52) / 17); /*21985*/
				} /*21985*/
				$k[$j++] = "databaromni"; /*21992*/
				$k[$j++] = 4; /*21992*/
				$k[$j++] = "databarstacked"; /*21992*/
				$k[$j++] = 2; /*21992*/
				$k[$j++] = "databarstackedomni"; /*21992*/
				$k[$j++] = 2; /*21992*/
				$k[$j++] = "databartruncated"; /*21992*/
				$k[$j++] = 4; /*21992*/
				$k[$j++] = "databarlimited"; /*21992*/
				$k[$j++] = 3; /*21992*/
				$k[$j++] = "databarexpanded"; /*21992*/
				$k[$j++] = 4; /*21992*/
				$k[$j++] = "databarexpandedstacked"; /*21992*/
				$k[$j++] = 4; /*21992*/
				$1.cccolumns = $get($d(), $1.lintype); /*21993*/
			} /*21993*/
			$1.expand = function() {
				$1.in = $k[--$j]; /*21998*/
				$1.out = $s($1.in.length); /*21999*/
				$1.j = 0; /*22000*/
				$k[$j++] = $1.in; /*22014*/
				for (;;) { /*22014*/
					$search($k[--$j], "^"); /*22003*/
					if ($k[--$j]) { /*22012*/
						var _J = $k[--$j]; /*22004*/
						$puti($1.out, $1.j, _J); /*22004*/
						$1.j = (_J.length + $1.j) + 1; /*22005*/
						$j--; /*22006*/
						var _N = $k[--$j]; /*22007*/
						$put($1.out, $1.j - 1, ~~$z($geti(_N, 0, 3))); /*22007*/
						$k[$j++] = $geti(_N, 3, _N.length - 3); /*22008*/
					} else { /*22012*/
						var _S = $k[--$j]; /*22010*/
						$puti($1.out, $1.j, _S); /*22010*/
						$1.j = _S.length + $1.j; /*22011*/
						$k[$j++] = $geti($1.out, 0, $1.j); /*22012*/
						break; /*22012*/
					} /*22012*/
				} /*22012*/
			}; /*22015*/
			$1.ais = $a([]); /*22018*/
			$1.vals = $a([]); /*22019*/
			var _b = $1.barcode; /*22020*/
			$k[$j++] = $geti(_b, 1, _b.length - 1); /*22033*/
			for (;;) { /*22033*/
				var _d = $k[--$j]; /*22022*/
				$k[$j++] = _d; /*22022*/
				if ($eq(_d, "")) { /*22022*/
					break; /*22022*/
				} /*22022*/
				$search($k[--$j], ")"); /*22023*/
				$j--; /*22023*/
				var _f = $k[--$j]; /*22024*/
				var _g = $k[--$j]; /*22024*/
				var _h = $k[--$j]; /*22025*/
				$k[$j++] = _f; /*22025*/
				$search(_h, "("); /*22025*/
				if ($k[--$j]) { /*22028*/
					var _j = $k[--$j]; /*22026*/
					var _k = $k[--$j]; /*22026*/
					var _l = $k[--$j]; /*22026*/
					var _m = $k[--$j]; /*22026*/
					$k[$j++] = _l; /*22026*/
					$k[$j++] = _m; /*22026*/
					$k[$j++] = _j; /*22026*/
				} else { /*22028*/
					var _n = $k[--$j]; /*22028*/
					var _o = $k[--$j]; /*22028*/
					$k[$j++] = ""; /*22028*/
					$k[$j++] = _o; /*22028*/
					$k[$j++] = _n; /*22028*/
				} /*22028*/
				$k[$j++] = Infinity; /*22030*/
				$aload($1.ais); /*22030*/
				var _r = $k[$j - 1 - ($counttomark() + 2)]; /*22030*/
				$k[$j++] = _r; /*22030*/
				$1.ais = $a(); /*22030*/
				$k[$j++] = Infinity; /*22031*/
				$aload($1.vals); /*22031*/
				var _v = $k[$j - 1 - ($counttomark() + 1)]; /*22031*/
				$k[$j++] = _v; /*22031*/
				if ($1.expand() == $b) break; /*22031*/
				$1.vals = $a(); /*22031*/
				$j -= 2; /*22032*/
			} /*22032*/
			$j--; /*22034*/
			$1.isupper = function() {
				var _x = $k[--$j]; /*22037*/
				$k[$j++] = (_x >= 65) && (_x <= 90); /*22037*/
			}; /*22037*/
			$1.isnum0 = function() {
				var _y = $k[--$j]; /*22038*/
				$k[$j++] = (_y >= 48) && (_y <= 57); /*22038*/
			}; /*22038*/
			$1.isnum1 = function() {
				var _z = $k[--$j]; /*22039*/
				$k[$j++] = (_z >= 49) && (_z <= 57); /*22039*/
			}; /*22039*/
			for (;;) { /*22085*/
				if ($1.ais.length >= 1) { /*22047*/
					if (($eq($get($1.ais, 0), "10") || $eq($get($1.ais, 0), "11")) || $eq($get($1.ais, 0), "17")) { /*22046*/
						$k[$j++] = -1; /*22045*/
						$k[$j++] = "10"; /*22045*/
						break; /*22045*/
					} /*22045*/
				} /*22045*/
				if ($1.ais.length >= 1) { /*22080*/
					if ($eq($get($1.ais, 0), "90")) { /*22079*/
						$1.v = $get($1.vals, 0); /*22052*/
						if ($1.v.length >= 1) { /*22057*/
							$k[$j++] = $get($1.v, 0); /*22054*/
							if ($1.isupper() == $b) break; /*22054*/
							if ($k[--$j]) { /*22056*/
								$k[$j++] = 0; /*22055*/
								$k[$j++] = "11"; /*22055*/
								break; /*22055*/
							} /*22055*/
						} /*22055*/
						if ($1.v.length >= 2) { /*22063*/
							$k[$j++] = $get($1.v, 0); /*22059*/
							if ($1.isnum1() == $b) break; /*22059*/
							$k[$j++] = $get($1.v, 1); /*22060*/
							if ($1.isupper() == $b) break; /*22060*/
							var _1L = $k[--$j]; /*22060*/
							if (($k[--$j] && _1L)) { /*22062*/
								$k[$j++] = 1; /*22061*/
								$k[$j++] = "11"; /*22061*/
								break; /*22061*/
							} /*22061*/
						} /*22061*/
						if ($1.v.length >= 3) { /*22070*/
							$k[$j++] = $get($1.v, 0); /*22065*/
							if ($1.isnum1() == $b) break; /*22065*/
							$k[$j++] = $get($1.v, 1); /*22066*/
							if ($1.isnum0() == $b) break; /*22066*/
							var _1S = $k[--$j]; /*22066*/
							var _1T = $k[--$j]; /*22066*/
							$k[$j++] = $an(_1T, _1S); /*22067*/
							$k[$j++] = $get($1.v, 2); /*22067*/
							if ($1.isupper() == $b) break; /*22067*/
							var _1W = $k[--$j]; /*22067*/
							if (($k[--$j] && _1W)) { /*22069*/
								$k[$j++] = 2; /*22068*/
								$k[$j++] = "11"; /*22068*/
								break; /*22068*/
							} /*22068*/
						} /*22068*/
						if ($1.v.length >= 4) { /*22078*/
							$k[$j++] = $get($1.v, 0); /*22072*/
							if ($1.isnum1() == $b) break; /*22072*/
							$k[$j++] = $get($1.v, 1); /*22073*/
							if ($1.isnum0() == $b) break; /*22073*/
							var _1d = $k[--$j]; /*22073*/
							var _1e = $k[--$j]; /*22073*/
							$k[$j++] = $an(_1e, _1d); /*22074*/
							$k[$j++] = $get($1.v, 2); /*22074*/
							if ($1.isnum0() == $b) break; /*22074*/
							var _1h = $k[--$j]; /*22074*/
							var _1i = $k[--$j]; /*22074*/
							$k[$j++] = $an(_1i, _1h); /*22075*/
							$k[$j++] = $get($1.v, 3); /*22075*/
							if ($1.isupper() == $b) break; /*22075*/
							var _1l = $k[--$j]; /*22075*/
							if (($k[--$j] && _1l)) { /*22077*/
								$k[$j++] = 3; /*22076*/
								$k[$j++] = "11"; /*22076*/
								break; /*22076*/
							} /*22076*/
						} /*22076*/
					} /*22076*/
				} /*22076*/
				$k[$j++] = -1; /*22083*/
				$k[$j++] = "0"; /*22083*/
				break; /*22083*/
			} /*22083*/
			$1.method = $k[--$j]; /*22086*/
			$1.npre = $k[--$j]; /*22087*/
			$1.fnc1 = -1; /*22089*/
			$1.lnumeric = -2; /*22089*/
			$1.lalphanumeric = -3; /*22089*/
			$1.liso646 = -4; /*22089*/
			$1.tobin = function() {
				var _1q = $s($k[--$j]); /*22092*/
				$k[$j++] = _1q; /*22092*/
				for (var _1s = 0, _1r = _1q.length - 1; _1s <= _1r; _1s += 1) { /*22092*/
					var _1t = $k[--$j]; /*22092*/
					$put(_1t, _1s, 48); /*22092*/
					$k[$j++] = _1t; /*22092*/
				} /*22092*/
				var _1u = $k[--$j]; /*22093*/
				var _1x = $cvrs($s(_1u.length), $k[--$j], 2); /*22093*/
				$puti(_1u, _1u.length - _1x.length, _1x); /*22093*/
				$k[$j++] = _1u; /*22093*/
			}; /*22094*/
			$k[$j++] = "alpha"; /*22099*/
			$k[$j++] = Infinity; /*22099*/
			for (var _1y = 65; _1y <= 90; _1y += 1) { /*22097*/
				$k[$j++] = _1y; /*22097*/
				$k[$j++] = _1y - 65; /*22097*/
				$k[$j++] = 5; /*22097*/
				if ($1.tobin() == $b) break; /*22097*/
			} /*22097*/
			for (var _1z = 48; _1z <= 57; _1z += 1) { /*22098*/
				$k[$j++] = _1z; /*22098*/
				$k[$j++] = _1z + 4; /*22098*/
				$k[$j++] = 6; /*22098*/
				if ($1.tobin() == $b) break; /*22098*/
			} /*22098*/
			$k[$j++] = $1.fnc1; /*22099*/
			$k[$j++] = "11111"; /*22099*/
			var _21 = $d(); /*22099*/
			$1[$k[--$j]] = _21; /*22100*/
			$k[$j++] = "numeric"; /*22112*/
			$k[$j++] = Infinity; /*22112*/
			for (var _23 = 0; _23 <= 119; _23 += 1) { /*22111*/
				var _25 = $strcpy($s(2), "00"); /*22104*/
				var _27 = $cvrs($s(2), _23, 11); /*22104*/
				$puti(_25, 2 - _27.length, _27); /*22105*/
				$k[$j++] = _23; /*22106*/
				$k[$j++] = _25; /*22106*/
				if ($get(_25, 0) == 65) { /*22106*/
					var _29 = $k[--$j]; /*22106*/
					$put(_29, 0, 94); /*22106*/
					$k[$j++] = _29; /*22106*/
				} /*22106*/
				var _2A = $k[--$j]; /*22107*/
				$k[$j++] = _2A; /*22107*/
				if ($get(_2A, 1) == 65) { /*22107*/
					var _2C = $k[--$j]; /*22107*/
					$put(_2C, 1, 94); /*22107*/
					$k[$j++] = _2C; /*22107*/
				} /*22107*/
				var _2D = $k[--$j]; /*22108*/
				var _2G = $strcpy($s(7), "0000000"); /*22109*/
				var _2I = $cvrs($s(7), $k[--$j] + 8, 2); /*22109*/
				$puti(_2G, 7 - _2I.length, _2I); /*22110*/
				$k[$j++] = _2D; /*22110*/
				$k[$j++] = _2G; /*22110*/
			} /*22110*/
			$k[$j++] = $1.lalphanumeric; /*22112*/
			$k[$j++] = "0000"; /*22112*/
			var _2K = $d(); /*22112*/
			$1[$k[--$j]] = _2K; /*22113*/
			$k[$j++] = "alphanumeric"; /*22122*/
			$k[$j++] = Infinity; /*22122*/
			for (var _2M = 48; _2M <= 57; _2M += 1) { /*22116*/
				$k[$j++] = _2M; /*22116*/
				$k[$j++] = _2M - 43; /*22116*/
				$k[$j++] = 5; /*22116*/
				if ($1.tobin() == $b) break; /*22116*/
			} /*22116*/
			$k[$j++] = $1.fnc1; /*22118*/
			$k[$j++] = "01111"; /*22118*/
			for (var _2O = 65; _2O <= 90; _2O += 1) { /*22118*/
				$k[$j++] = _2O; /*22118*/
				$k[$j++] = _2O - 33; /*22118*/
				$k[$j++] = 6; /*22118*/
				if ($1.tobin() == $b) break; /*22118*/
			} /*22118*/
			$k[$j++] = 42; /*22120*/
			$k[$j++] = "111010"; /*22120*/
			for (var _2P = 44; _2P <= 47; _2P += 1) { /*22120*/
				$k[$j++] = _2P; /*22120*/
				$k[$j++] = _2P + 15; /*22120*/
				$k[$j++] = 6; /*22120*/
				if ($1.tobin() == $b) break; /*22120*/
			} /*22120*/
			$k[$j++] = $1.lnumeric; /*22122*/
			$k[$j++] = "000"; /*22122*/
			$k[$j++] = $1.liso646; /*22122*/
			$k[$j++] = "00100"; /*22122*/
			var _2S = $d(); /*22122*/
			$1[$k[--$j]] = _2S; /*22123*/
			$k[$j++] = "iso646"; /*22137*/
			$k[$j++] = Infinity; /*22137*/
			for (var _2U = 48; _2U <= 57; _2U += 1) { /*22126*/
				$k[$j++] = _2U; /*22126*/
				$k[$j++] = _2U - 43; /*22126*/
				$k[$j++] = 5; /*22126*/
				if ($1.tobin() == $b) break; /*22126*/
			} /*22126*/
			$k[$j++] = $1.fnc1; /*22128*/
			$k[$j++] = "01111"; /*22128*/
			for (var _2W = 65; _2W <= 90; _2W += 1) { /*22128*/
				$k[$j++] = _2W; /*22128*/
				$k[$j++] = _2W - 1; /*22128*/
				$k[$j++] = 7; /*22128*/
				if ($1.tobin() == $b) break; /*22128*/
			} /*22128*/
			for (var _2X = 97; _2X <= 122; _2X += 1) { /*22129*/
				$k[$j++] = _2X; /*22129*/
				$k[$j++] = _2X - 7; /*22129*/
				$k[$j++] = 7; /*22129*/
				if ($1.tobin() == $b) break; /*22129*/
			} /*22129*/
			$k[$j++] = 33; /*22132*/
			$k[$j++] = "11101000"; /*22132*/
			$k[$j++] = 34; /*22132*/
			$k[$j++] = "11101001"; /*22132*/
			for (var _2Y = 37; _2Y <= 47; _2Y += 1) { /*22132*/
				$k[$j++] = _2Y; /*22132*/
				$k[$j++] = _2Y + 197; /*22132*/
				$k[$j++] = 8; /*22132*/
				if ($1.tobin() == $b) break; /*22132*/
			} /*22132*/
			for (var _2Z = 58; _2Z <= 63; _2Z += 1) { /*22133*/
				$k[$j++] = _2Z; /*22133*/
				$k[$j++] = _2Z + 187; /*22133*/
				$k[$j++] = 8; /*22133*/
				if ($1.tobin() == $b) break; /*22133*/
			} /*22133*/
			$k[$j++] = 95; /*22137*/
			$k[$j++] = "11111011"; /*22137*/
			$k[$j++] = 32; /*22137*/
			$k[$j++] = "11111100"; /*22137*/
			$k[$j++] = $1.lnumeric; /*22137*/
			$k[$j++] = "000"; /*22137*/
			$k[$j++] = $1.lalphanumeric; /*22137*/
			$k[$j++] = "00100"; /*22137*/
			var _2c = $d(); /*22137*/
			$1[$k[--$j]] = _2c; /*22138*/
			if ($eq($1.method, "10")) { /*22171*/
				if ($eq($get($1.ais, 0), "11") || $eq($get($1.ais, 0), "17")) { /*22155*/
					var _2k = $get($1.vals, 0); /*22142*/
					var _2p = $strcpy($s(16), "0000000000000000"); /*22146*/
					var _2r = $cvrs($s(16), ((~~$z($geti(_2k, 0, 2))) * 384) + ((((~~$z($geti(_2k, 2, 2))) - 1) * 32) + (~~$z($geti(_2k, 4, 2)))), 2); /*22146*/
					$puti(_2p, 16 - _2r.length, _2r); /*22147*/
					$k[$j++] = _2p; /*22150*/
					$k[$j++] = Infinity; /*22150*/
					var _2s = $k[--$j]; /*22149*/
					var _2t = $k[--$j]; /*22149*/
					$k[$j++] = _2s; /*22149*/
					$k[$j++] = 1; /*22149*/
					$k[$j++] = 0; /*22149*/
					$forall(_2t, function() { /*22149*/
						var _2u = $k[--$j]; /*22149*/
						$k[$j++] = _2u - 48; /*22149*/
					}); /*22149*/
					var _2x = $eq($get($1.ais, 0), "11") ? 0 : 1; /*22150*/
					$k[$j++] = _2x; /*22150*/
					$1.cdf = $a(); /*22151*/
					$1.ais = $geti($1.ais, 1, $1.ais.length - 1); /*22152*/
					$1.vals = $geti($1.vals, 1, $1.vals.length - 1); /*22153*/
				} else { /*22155*/
					$1.cdf = $a([1, 0, 1, 1]); /*22155*/
				} /*22155*/
				if ($1.ais.length != 0) { /*22168*/
					if ($eq($get($1.ais, 0), "10")) { /*22164*/
						$k[$j++] = Infinity; /*22159*/
						$forall($get($1.vals, 0)); /*22159*/
						$1.gpf = $a(); /*22159*/
						if ($1.ais.length > 1) { /*22160*/
							$k[$j++] = Infinity; /*22160*/
							$aload($1.gpf); /*22160*/
							$k[$j++] = $1.fnc1; /*22160*/
							$1.gpf = $a(); /*22160*/
						} /*22160*/
						$1.ais = $geti($1.ais, 1, $1.ais.length - 1); /*22161*/
						$1.vals = $geti($1.vals, 1, $1.vals.length - 1); /*22162*/
					} else { /*22164*/
						$1.gpf = $a([$1.fnc1]); /*22164*/
					} /*22164*/
				} else { /*22168*/
					$k[$j++] = Infinity; /*22167*/
					$aload($1.cdf); /*22167*/
					$k[$j++] = 0; /*22167*/
					$k[$j++] = 0; /*22167*/
					$k[$j++] = 0; /*22167*/
					$k[$j++] = 0; /*22167*/
					$k[$j++] = 0; /*22167*/
					$k[$j++] = 1; /*22167*/
					$k[$j++] = 1; /*22167*/
					$k[$j++] = 1; /*22167*/
					$k[$j++] = 1; /*22167*/
					$1.cdf = $a(); /*22167*/
					$1.gpf = $a([]); /*22168*/
				} /*22168*/
				$1.mode = "numeric"; /*22170*/
			} /*22170*/
			if ($eq($1.method, "11")) { /*22264*/
				$1.cdf = $a([1, 1]); /*22174*/
				$1.ai90 = $get($1.vals, 0); /*22175*/
				if (($1.npre + 1) != $1.ai90.length) { /*22179*/
					$k[$j++] = $geti($1.ai90, $1.npre + 1, ($1.ai90.length - $1.npre) - 1); /*22177*/
				} else { /*22179*/
					$k[$j++] = ""; /*22179*/
				} /*22179*/
				$1.ai90rem = $k[--$j]; /*22181*/
				$k[$j++] = "nalpha"; /*22182*/
				$k[$j++] = 0; /*22182*/
				$forall($1.ai90rem, function() { /*22182*/
					var _3e = $k[--$j]; /*22182*/
					if ((_3e >= 65) && (_3e <= 90)) { /*22182*/
						var _3f = $k[--$j]; /*22182*/
						$k[$j++] = _3f + 1; /*22182*/
					} /*22182*/
				}); /*22182*/
				var _3g = $k[--$j]; /*22182*/
				$1[$k[--$j]] = _3g; /*22182*/
				$k[$j++] = "nnums"; /*22183*/
				$k[$j++] = 0; /*22183*/
				$forall($1.ai90rem, function() { /*22183*/
					var _3j = $k[--$j]; /*22183*/
					if ((_3j >= 48) && (_3j <= 57)) { /*22183*/
						var _3k = $k[--$j]; /*22183*/
						$k[$j++] = _3k + 1; /*22183*/
					} /*22183*/
				}); /*22183*/
				var _3l = $k[--$j]; /*22183*/
				$1[$k[--$j]] = _3l; /*22183*/
				$k[$j++] = "mode"; /*22184*/
				if ($gt($1.nalpha, $1.nnums)) { /*22184*/
					$k[$j++] = "alpha"; /*22184*/
				} else { /*22184*/
					$k[$j++] = "numeric"; /*22184*/
				} /*22184*/
				var _3p = $k[--$j]; /*22184*/
				$1[$k[--$j]] = _3p; /*22184*/
				if (($1.nalpha + $1.nnums) != $1.ai90rem.length) { /*22185*/
					$1.mode = "alphanumeric"; /*22185*/
				} /*22185*/
				$k[$j++] = Infinity; /*22191*/
				$aload($1.cdf); /*22187*/
				if ($eq($1.mode, "alphanumeric")) { /*22188*/
					$k[$j++] = 0; /*22188*/
				} /*22188*/
				if ($eq($1.mode, "numeric")) { /*22189*/
					$k[$j++] = 1; /*22189*/
					$k[$j++] = 0; /*22189*/
				} /*22189*/
				if ($eq($1.mode, "alpha")) { /*22190*/
					$k[$j++] = 1; /*22190*/
					$k[$j++] = 1; /*22190*/
				} /*22190*/
				$1.cdf = $a(); /*22191*/
				$k[$j++] = "ais1"; /*22192*/
				if ($1.ais.length > 1) { /*22192*/
					$k[$j++] = $get($1.ais, 1); /*22192*/
				} else { /*22192*/
					$k[$j++] = -1; /*22192*/
				} /*22192*/
				var _42 = $k[--$j]; /*22192*/
				$1[$k[--$j]] = _42; /*22192*/
				$k[$j++] = "vals1"; /*22193*/
				if ($1.vals.length > 1) { /*22193*/
					$k[$j++] = $get($1.vals, 1); /*22193*/
				} else { /*22193*/
					$k[$j++] = -1; /*22193*/
				} /*22193*/
				var _47 = $k[--$j]; /*22193*/
				$1[$k[--$j]] = _47; /*22193*/
				if ($eq($1.ais1, "21") || $eq($1.ais1, "8004")) { /*22197*/
					$k[$j++] = Infinity; /*22195*/
					$aload($1.cdf); /*22195*/
					if ($eq($1.ais1, "21")) { /*22195*/
						$k[$j++] = 1; /*22195*/
						$k[$j++] = 0; /*22195*/
					} else { /*22195*/
						$k[$j++] = 1; /*22195*/
						$k[$j++] = 1; /*22195*/
					} /*22195*/
					$1.cdf = $a(); /*22195*/
				} else { /*22197*/
					$k[$j++] = Infinity; /*22197*/
					$aload($1.cdf); /*22197*/
					$k[$j++] = 0; /*22197*/
					$1.cdf = $a(); /*22197*/
				} /*22197*/
				$k[$j++] = "nval"; /*22199*/
				if ($1.npre != 0) { /*22199*/
					$k[$j++] = ~~$z($geti($1.ai90, 0, $1.npre)); /*22199*/
				} else { /*22199*/
					$k[$j++] = 0; /*22199*/
				} /*22199*/
				var _4K = $k[--$j]; /*22199*/
				$1[$k[--$j]] = _4K; /*22199*/
				$search("BDHIJKLNPQRSTVXZ", $geti($1.ai90, $1.npre, 1)); /*22200*/
				if ($k[--$j]) { /*22204*/
					var _4Q = $k[--$j]; /*22201*/
					var _4R = $k[--$j]; /*22201*/
					var _4S = $k[--$j]; /*22201*/
					$1.aval = _4Q.length; /*22202*/
				} else { /*22204*/
					$j--; /*22204*/
					$1.aval = -1; /*22204*/
				} /*22204*/
				if (($1.nval < 31) && ($1.aval != -1)) { /*22230*/
					var _4W = $strcpy($s(5), "00000"); /*22207*/
					var _4Z = $cvrs($s(5), $1.nval, 2); /*22207*/
					$puti(_4W, 5 - _4Z.length, _4Z); /*22208*/
					$k[$j++] = _4W; /*22209*/
					$k[$j++] = Infinity; /*22209*/
					var _4a = $k[--$j]; /*22209*/
					var _4b = $k[--$j]; /*22209*/
					$k[$j++] = _4a; /*22209*/
					$forall(_4b, function() { /*22209*/
						var _4c = $k[--$j]; /*22209*/
						$k[$j++] = _4c - 48; /*22209*/
					}); /*22209*/
					$1.nbits = $a(); /*22209*/
					var _4f = $strcpy($s(4), "0000"); /*22210*/
					var _4i = $cvrs($s(4), $1.aval, 2); /*22210*/
					$puti(_4f, 4 - _4i.length, _4i); /*22211*/
					$k[$j++] = _4f; /*22212*/
					$k[$j++] = Infinity; /*22212*/
					var _4j = $k[--$j]; /*22212*/
					var _4k = $k[--$j]; /*22212*/
					$k[$j++] = _4j; /*22212*/
					$forall(_4k, function() { /*22212*/
						var _4l = $k[--$j]; /*22212*/
						$k[$j++] = _4l - 48; /*22212*/
					}); /*22212*/
					$1.abits = $a(); /*22212*/
					$k[$j++] = Infinity; /*22217*/
					$aload($1.cdf); /*22214*/
					$aload($1.nbits); /*22215*/
					$aload($1.abits); /*22216*/
					$1.cdf = $a(); /*22217*/
				} else { /*22230*/
					var _4s = $strcpy($s(10), "0000000000"); /*22219*/
					var _4v = $cvrs($s(10), $1.nval, 2); /*22219*/
					$puti(_4s, 10 - _4v.length, _4v); /*22220*/
					$k[$j++] = _4s; /*22221*/
					$k[$j++] = Infinity; /*22221*/
					var _4w = $k[--$j]; /*22221*/
					var _4x = $k[--$j]; /*22221*/
					$k[$j++] = _4w; /*22221*/
					$forall(_4x, function() { /*22221*/
						var _4y = $k[--$j]; /*22221*/
						$k[$j++] = _4y - 48; /*22221*/
					}); /*22221*/
					$1.nbits = $a(); /*22221*/
					var _51 = $strcpy($s(5), "00000"); /*22222*/
					var _56 = $cvrs($s(5), $get($1.ai90, $1.npre) - 65, 2); /*22222*/
					$puti(_51, 5 - _56.length, _56); /*22223*/
					$k[$j++] = _51; /*22224*/
					$k[$j++] = Infinity; /*22224*/
					var _57 = $k[--$j]; /*22224*/
					var _58 = $k[--$j]; /*22224*/
					$k[$j++] = _57; /*22224*/
					$forall(_58, function() { /*22224*/
						var _59 = $k[--$j]; /*22224*/
						$k[$j++] = _59 - 48; /*22224*/
					}); /*22224*/
					$1.abits = $a(); /*22224*/
					$k[$j++] = Infinity; /*22230*/
					$aload($1.cdf); /*22226*/
					$k[$j++] = 1; /*22228*/
					$k[$j++] = 1; /*22228*/
					$k[$j++] = 1; /*22228*/
					$k[$j++] = 1; /*22228*/
					$k[$j++] = 1; /*22228*/
					$aload($1.nbits); /*22228*/
					$aload($1.abits); /*22229*/
					$1.cdf = $a(); /*22230*/
				} /*22230*/
				if ($eq($1.mode, "numeric")) { /*22249*/
					$k[$j++] = Infinity; /*22233*/
					$forall($1.ai90rem); /*22233*/
					if ($1.ais.length > 1) { /*22233*/
						$k[$j++] = $1.fnc1; /*22233*/
					} /*22233*/
					$1.gpf = $a(); /*22233*/
				} else { /*22249*/
					$k[$j++] = "encs"; /*22235*/
					if ($eq($1.mode, "alpha")) { /*22235*/
						$k[$j++] = $1.alpha; /*22235*/
					} else { /*22235*/
						$k[$j++] = $1.alphanumeric; /*22235*/
					} /*22235*/
					var _5N = $k[--$j]; /*22235*/
					$1[$k[--$j]] = _5N; /*22235*/
					$k[$j++] = Infinity; /*22236*/
					$forall($1.ai90rem); /*22236*/
					if ($1.ais.length > 1) { /*22236*/
						$k[$j++] = $1.fnc1; /*22236*/
					} /*22236*/
					$1.in = $a(); /*22236*/
					$1.out = $a($1.in.length * 6); /*22237*/
					$1.j = 0; /*22238*/
					for (var _5X = 0, _5W = $1.in.length - 1; _5X <= _5W; _5X += 1) { /*22243*/
						var _5b = $get($1.encs, $get($1.in, _5X)); /*22240*/
						$k[$j++] = _5b; /*22241*/
						$k[$j++] = _5b; /*22241*/
						$k[$j++] = Infinity; /*22241*/
						var _5c = $k[--$j]; /*22241*/
						var _5d = $k[--$j]; /*22241*/
						$k[$j++] = _5c; /*22241*/
						$forall(_5d, function() { /*22241*/
							var _5e = $k[--$j]; /*22241*/
							$k[$j++] = _5e - 48; /*22241*/
						}); /*22241*/
						$puti($1.out, $1.j, $a()); /*22241*/
						$1.j = $k[--$j].length + $1.j; /*22242*/
					} /*22242*/
					$k[$j++] = Infinity; /*22247*/
					$aload($1.cdf); /*22245*/
					$aload($geti($1.out, 0, $1.j)); /*22246*/
					$1.cdf = $a(); /*22247*/
					$1.gpf = $a([]); /*22248*/
					if (($1.ais.length > 1) || $ne($1.mode, "alpha")) { /*22249*/
						$1.mode = "numeric"; /*22249*/
					} /*22249*/
				} /*22249*/
				$1.ais = $geti($1.ais, 1, $1.ais.length - 1); /*22251*/
				$1.vals = $geti($1.vals, 1, $1.vals.length - 1); /*22252*/
				if ($1.ais.length != 0) { /*22263*/
					if ($eq($1.ais1, "21") || $eq($1.ais1, "8004")) { /*22262*/
						$k[$j++] = Infinity; /*22258*/
						$aload($1.gpf); /*22256*/
						$forall($1.vals1); /*22257*/
						$1.gpf = $a(); /*22258*/
						$1.ais = $geti($1.ais, 1, $1.ais.length - 1); /*22259*/
						$1.vals = $geti($1.vals, 1, $1.vals.length - 1); /*22260*/
						if ($1.ais.length != 0) { /*22261*/
							$k[$j++] = Infinity; /*22261*/
							$aload($1.gpf); /*22261*/
							$k[$j++] = $1.fnc1; /*22261*/
							$1.gpf = $a(); /*22261*/
						} /*22261*/
					} /*22261*/
				} /*22261*/
			} /*22261*/
			if ($eq($1.method, "0")) { /*22270*/
				$1.cdf = $a([0]); /*22267*/
				$1.gpf = $a([]); /*22268*/
				$1.mode = "numeric"; /*22269*/
			} /*22269*/
			$1.aifixed = {}; /*22275*/
			$k[$j++] = Infinity; /*22277*/
			for (var _6H = 0; _6H <= 4; _6H += 1) { /*22277*/
				$k[$j++] = _6H; /*22277*/
			} /*22277*/
			var _6I = $a(); /*22277*/
			for (var _6J = 0, _6K = _6I.length; _6J < _6K; _6J++) { /*22280*/
				var _6N = $strcpy($s(2), "00"); /*22279*/
				$put(_6N, 1, $get(_6I, _6J) + 48); /*22279*/
				$put($1.aifixed, _6N, _6N); /*22279*/
			} /*22279*/
			$k[$j++] = Infinity; /*22285*/
			for (var _6P = 11; _6P <= 20; _6P += 1) { /*22282*/
				$k[$j++] = _6P; /*22282*/
			} /*22282*/
			$k[$j++] = 23; /*22284*/
			for (var _6Q = 31; _6Q <= 36; _6Q += 1) { /*22284*/
				$k[$j++] = _6Q; /*22284*/
			} /*22284*/
			$k[$j++] = 41; /*22285*/
			var _6R = $a(); /*22285*/
			for (var _6S = 0, _6T = _6R.length; _6S < _6T; _6S++) { /*22288*/
				var _6W = $cvrs($s(2), $get(_6R, _6S), 10); /*22287*/
				$put($1.aifixed, _6W, _6W); /*22287*/
			} /*22287*/
			for (var _6a = 0, _6Z = $1.ais.length - 1; _6a <= _6Z; _6a += 1) { /*22306*/
				$1.i = _6a; /*22292*/
				$1.ai = $get($1.ais, $1.i); /*22293*/
				$1.val = $get($1.vals, $1.i); /*22294*/
				var _6k = $a(($1.gpf.length + $1.ai.length) + $1.val.length); /*22295*/
				$puti(_6k, 0, $1.gpf); /*22296*/
				$k[$j++] = _6k; /*22297*/
				$k[$j++] = _6k; /*22297*/
				$k[$j++] = $1.gpf.length; /*22297*/
				$k[$j++] = $1.ai; /*22297*/
				$k[$j++] = Infinity; /*22297*/
				var _6o = $k[--$j]; /*22297*/
				var _6p = $k[--$j]; /*22297*/
				$k[$j++] = _6o; /*22297*/
				$forall(_6p); /*22297*/
				var _6q = $a(); /*22297*/
				var _6r = $k[--$j]; /*22297*/
				$puti($k[--$j], _6r, _6q); /*22297*/
				var _6t = $k[--$j]; /*22298*/
				$k[$j++] = _6t; /*22298*/
				$k[$j++] = _6t; /*22298*/
				$k[$j++] = $1.gpf.length + $1.ai.length; /*22298*/
				$k[$j++] = $1.val; /*22298*/
				$k[$j++] = Infinity; /*22298*/
				var _6x = $k[--$j]; /*22298*/
				var _6y = $k[--$j]; /*22298*/
				$k[$j++] = _6x; /*22298*/
				$forall(_6y); /*22298*/
				var _6z = $a(); /*22298*/
				var _70 = $k[--$j]; /*22298*/
				$puti($k[--$j], _70, _6z); /*22298*/
				$1.gpf = $k[--$j]; /*22299*/
				var _78 = $get($1.aifixed, $geti($1.ai, 0, 2)) !== undefined; /*22300*/
				if (($1.i != ($1.ais.length - 1)) && (!_78)) { /*22305*/
					var _7A = $a($1.gpf.length + 1); /*22301*/
					$puti(_7A, 0, $1.gpf); /*22302*/
					$put(_7A, $1.gpf.length, $1.fnc1); /*22303*/
					$1.gpf = _7A; /*22304*/
				} /*22304*/
			} /*22304*/
			$1.rembits = function() {
				$1.used = $k[--$j]; /*22310*/
				if ($ne($1.ccversion, "c")) { /*22339*/
					var _7O = {
						a: $a([$a([167, 138, 118, 108, 88, 78, 59]), $a([167, 138, 118, 98, 78]), $a([197, 167, 138, 108, 78])]),
						b: $a([$a([336, 296, 256, 208, 160, 104, 56]), $a([768, 648, 536, 416, 304, 208, 152, 112, 72, 32]), $a([1184, 1016, 840, 672, 496, 352, 264, 208, 152, 96, 56])])
					}; /*22321*/
					$1.bitcaps = $get($get(_7O, $1.ccversion), $1.cccolumns - 2); /*22323*/
					$k[$j++] = -1; /*22324*/
					$forall($1.bitcaps, function() { /*22324*/
						var _7U = $k[--$j]; /*22324*/
						$k[$j++] = _7U; /*22324*/
						if ($ge(_7U, $1.used)) { /*22324*/
							var _7W = $k[--$j]; /*22324*/
							var _7X = $k[--$j]; /*22324*/
							$k[$j++] = _7W; /*22324*/
							$k[$j++] = _7X; /*22324*/
						} /*22324*/
						$j--; /*22324*/
					}); /*22324*/
					var _7Y = $k[--$j]; /*22325*/
					$k[$j++] = _7Y; /*22325*/
					if (_7Y != -1) { /*22325*/
						var _7a = $k[--$j]; /*22325*/
						$k[$j++] = _7a - $1.used; /*22325*/
					} /*22325*/
				} else { /*22339*/
					var _7b = {
						c: -1
					}; /*22327*/
					var _7d = $get(_7b, $1.ccversion); /*22327*/
					var _7f = ~~Math.ceil($1.used / 8); /*22328*/
					$1.m = ((~~(_7f / 6)) * 5) + (_7f % 6); /*22328*/
					if ($1.m <= 40) { /*22329*/
						$k[$j++] = 8; /*22329*/
					} /*22329*/
					if (($1.m >= 41) && ($1.m <= 160)) { /*22330*/
						$k[$j++] = 16; /*22330*/
					} /*22330*/
					if (($1.m >= 161) && ($1.m <= 320)) { /*22331*/
						$k[$j++] = 32; /*22331*/
					} /*22331*/
					if ($1.m >= 321) { /*22332*/
						$k[$j++] = 64; /*22332*/
					} /*22332*/
					$1.eccws = $k[--$j]; /*22333*/
					$1.m = ($1.m + $1.eccws) + 3; /*22334*/
					$1.c = ~~(($1.linwidth - 52) / 17); /*22335*/
					if ((~~($1.m / $1.c)) > 90) { /*22336*/
						$1.c = $1.c + 1; /*22336*/
					} /*22336*/
					$1.r = ~~Math.ceil($1.m / $1.c); /*22337*/
					var _7y = (($1.c * $1.r) - $1.eccws) - 3; /*22338*/
					$1.tgt = (((~~(_7y / 5)) * 6) + (_7y % 5)) * 8; /*22338*/
					if ($1.used <= 8296) { /*22339*/
						$k[$j++] = $1.tgt - $1.used; /*22339*/
					} else { /*22339*/
						$k[$j++] = -1; /*22339*/
					} /*22339*/
				} /*22339*/
				var _82 = $k[--$j]; /*22341*/
				$k[$j++] = _82; /*22354*/
				if (_82 == -1) { /*22354*/
					$j--; /*22342*/
					if ($eq($1.ccversion, "a")) { /*22350*/
						$1.ccversion = "b"; /*22344*/
					} else { /*22350*/
						if ($eq($1.ccversion, "b") && $eq($1.lintype, "gs1-128")) { /*22350*/
							$1.ccversion = "c"; /*22347*/
							$1.cccolumns = ~~(($1.linwidth - 52) / 17); /*22348*/
						} else { /*22350*/
							$1.ccversion = -1; /*22350*/
						} /*22350*/
					} /*22350*/
					$k[$j++] = $1.used; /*22353*/
					if ($1.rembits() == $b) return $b; /*22353*/
				} /*22353*/
			}; /*22355*/
			$1.encode = function() {
				var _88 = $k[--$j]; /*22358*/
				$k[$j++] = _88; /*22358*/
				if ($ne(_88, "raw")) { /*22358*/
					var _89 = $k[--$j]; /*22358*/
					var _8B = $get(_89, $k[--$j]); /*22358*/
					$k[$j++] = _8B; /*22358*/
				} else { /*22358*/
					$j--; /*22358*/
				} /*22358*/
				$k[$j++] = Infinity; /*22359*/
				var _8C = $k[--$j]; /*22359*/
				var _8D = $k[--$j]; /*22359*/
				$k[$j++] = _8C; /*22359*/
				$forall(_8D, function() { /*22359*/
					var _8E = $k[--$j]; /*22359*/
					$k[$j++] = _8E - 48; /*22359*/
				}); /*22359*/
				var _8F = $a(); /*22359*/
				$puti($1.gpfenc, $1.j, _8F); /*22361*/
				$1.j = _8F.length + $1.j; /*22362*/
			}; /*22363*/
			$k[$j++] = Infinity; /*22366*/
			for (var _8K = 0, _8L = $1.gpf.length; _8K < _8L; _8K++) { /*22366*/
				$k[$j++] = 0; /*22366*/
			} /*22366*/
			$k[$j++] = 0; /*22366*/
			$k[$j++] = -1; /*22366*/
			$1.numericruns = $a(); /*22366*/
			$k[$j++] = Infinity; /*22367*/
			for (var _8O = 0, _8P = $1.gpf.length; _8O < _8P; _8O++) { /*22367*/
				$k[$j++] = 0; /*22367*/
			} /*22367*/
			$k[$j++] = 0; /*22367*/
			$1.alphanumericruns = $a(); /*22367*/
			$k[$j++] = Infinity; /*22368*/
			for (var _8S = 0, _8T = $1.gpf.length; _8S < _8T; _8S++) { /*22368*/
				$k[$j++] = 0; /*22368*/
			} /*22368*/
			$k[$j++] = 9999; /*22368*/
			$1.nextiso646only = $a(); /*22368*/
			for (var _8W = $1.gpf.length - 1; _8W >= 0; _8W -= 1) { /*22390*/
				$1.i = _8W; /*22370*/
				var _8b = $strcpy($s(2), "00"); /*22372*/
				var _8e = $get($1.gpf, $1.i); /*22373*/
				$k[$j++] = $get($1.gpf, $1.i); /*22373*/
				$k[$j++] = _8b; /*22373*/
				$k[$j++] = _8b; /*22373*/
				$k[$j++] = 0; /*22373*/
				$k[$j++] = _8e; /*22373*/
				if (_8e == $1.fnc1) { /*22373*/
					$j--; /*22373*/
					$k[$j++] = 94; /*22373*/
				} /*22373*/
				var _8g = $k[--$j]; /*22373*/
				var _8h = $k[--$j]; /*22373*/
				$put($k[--$j], _8h, _8g); /*22373*/
				if ($1.i < ($1.gpf.length - 1)) { /*22374*/
					var _8l = $k[--$j]; /*22374*/
					var _8o = $get($1.gpf, $1.i + 1); /*22374*/
					$k[$j++] = _8l; /*22374*/
					$k[$j++] = _8l; /*22374*/
					$k[$j++] = 1; /*22374*/
					$k[$j++] = _8o; /*22374*/
					if (_8o == $1.fnc1) { /*22374*/
						$j--; /*22374*/
						$k[$j++] = 94; /*22374*/
					} /*22374*/
					var _8q = $k[--$j]; /*22374*/
					var _8r = $k[--$j]; /*22374*/
					$put($k[--$j], _8r, _8q); /*22374*/
				} /*22374*/
				var _8v = $get($1.numeric, $k[--$j]) !== undefined; /*22375*/
				if (_8v) { /*22378*/
					$put($1.numericruns, $1.i, $get($1.numericruns, $1.i + 2) + 2); /*22376*/
				} else { /*22378*/
					$put($1.numericruns, $1.i, 0); /*22378*/
				} /*22378*/
				var _93 = $k[--$j]; /*22380*/
				var _95 = $get($1.alphanumeric, _93) !== undefined; /*22380*/
				$k[$j++] = _93; /*22384*/
				if (_95) { /*22383*/
					$put($1.alphanumericruns, $1.i, $get($1.alphanumericruns, $1.i + 1) + 1); /*22381*/
				} else { /*22383*/
					$put($1.alphanumericruns, $1.i, 0); /*22383*/
				} /*22383*/
				var _9D = $k[--$j]; /*22385*/
				var _9F = $get($1.iso646, _9D) !== undefined; /*22385*/
				var _9H = $get($1.alphanumeric, _9D) !== undefined; /*22385*/
				if (_9F && (!_9H)) { /*22388*/
					$put($1.nextiso646only, $1.i, 0); /*22386*/
				} else { /*22388*/
					$put($1.nextiso646only, $1.i, $get($1.nextiso646only, $1.i + 1) + 1); /*22388*/
				} /*22388*/
			} /*22388*/
			$1.gpfenc = $a(8296); /*22393*/
			$1.i = 0; /*22394*/
			$1.j = 0; /*22394*/
			for (;;) { /*22484*/
				if ($1.i == $1.gpf.length) { /*22396*/
					break; /*22396*/
				} /*22396*/
				for (;;) { /*22483*/
					if ($eq($1.mode, "numeric")) { /*22432*/
						if ($1.i <= ($1.gpf.length - 2)) { /*22429*/
							var _9V = $s(2); /*22401*/
							var _9Y = $get($1.gpf, $1.i); /*22402*/
							$k[$j++] = _9V; /*22402*/
							$k[$j++] = _9V; /*22402*/
							$k[$j++] = 0; /*22402*/
							$k[$j++] = _9Y; /*22402*/
							if (_9Y == $1.fnc1) { /*22402*/
								$j--; /*22402*/
								$k[$j++] = 94; /*22402*/
							} /*22402*/
							var _9a = $k[--$j]; /*22402*/
							var _9b = $k[--$j]; /*22402*/
							$put($k[--$j], _9b, _9a); /*22402*/
							var _9d = $k[--$j]; /*22403*/
							var _9g = $get($1.gpf, $1.i + 1); /*22403*/
							$k[$j++] = _9d; /*22403*/
							$k[$j++] = _9d; /*22403*/
							$k[$j++] = 1; /*22403*/
							$k[$j++] = _9g; /*22403*/
							if (_9g == $1.fnc1) { /*22403*/
								$j--; /*22403*/
								$k[$j++] = 94; /*22403*/
							} /*22403*/
							var _9i = $k[--$j]; /*22403*/
							var _9j = $k[--$j]; /*22403*/
							$put($k[--$j], _9j, _9i); /*22403*/
							var _9l = $k[--$j]; /*22404*/
							var _9n = $get($1.numeric, _9l) !== undefined; /*22404*/
							$k[$j++] = _9l; /*22408*/
							if (_9n) { /*22408*/
								$k[$j++] = $1.numeric; /*22405*/
								if ($1.encode() == $b) break; /*22405*/
								$1.i = $1.i + 2; /*22406*/
								break; /*22407*/
							} /*22407*/
							$j--; /*22409*/
							$k[$j++] = $1.lalphanumeric; /*22410*/
							$k[$j++] = $1.numeric; /*22410*/
							if ($1.encode() == $b) break; /*22410*/
							$1.mode = "alphanumeric"; /*22411*/
							break; /*22412*/
						} else { /*22429*/
							var _9u = $get($1.gpf, $1.i); /*22414*/
							if ((_9u < 48) || (_9u > 57)) { /*22418*/
								$k[$j++] = $1.lalphanumeric; /*22415*/
								$k[$j++] = $1.numeric; /*22415*/
								if ($1.encode() == $b) break; /*22415*/
								$1.mode = "alphanumeric"; /*22416*/
								break; /*22417*/
							} /*22417*/
							$k[$j++] = "rem"; /*22419*/
							$k[$j++] = $1.cdf.length + $1.j; /*22419*/
							if ($1.rembits() == $b) break; /*22419*/
							var _9z = $k[--$j]; /*22419*/
							$1[$k[--$j]] = _9z; /*22419*/
							if (($1.rem >= 4) && ($1.rem <= 6)) { /*22429*/
								var _A6 = $geti($strcpy($s(6), "000000"), 0, $1.rem); /*22421*/
								var _AB = $cvrs($s(4), $get($1.gpf, $1.i) - 47, 2); /*22422*/
								$puti(_A6, 4 - _AB.length, _AB); /*22423*/
								$k[$j++] = _A6; /*22423*/
								$k[$j++] = "raw"; /*22423*/
								if ($1.encode() == $b) break; /*22423*/
								$1.i = $1.i + 1; /*22424*/
								break; /*22425*/
							} else { /*22429*/
								var _AD = $s(2); /*22427*/
								$put(_AD, 0, $get($1.gpf, $1.i)); /*22427*/
								$put(_AD, 1, 94); /*22427*/
								$k[$j++] = _AD; /*22427*/
								$k[$j++] = $1.numeric; /*22427*/
								if ($1.encode() == $b) break; /*22427*/
								$1.i = $1.i + 1; /*22428*/
								break; /*22429*/
							} /*22429*/
						} /*22429*/
					} /*22429*/
					if ($eq($1.mode, "alphanumeric")) { /*22459*/
						if ($get($1.gpf, $1.i) == $1.fnc1) { /*22440*/
							$k[$j++] = $1.fnc1; /*22436*/
							$k[$j++] = $1.alphanumeric; /*22436*/
							if ($1.encode() == $b) break; /*22436*/
							$1.mode = "numeric"; /*22437*/
							$1.i = $1.i + 1; /*22438*/
							break; /*22439*/
						} /*22439*/
						var _AT = $get($1.gpf, $1.i); /*22441*/
						var _AV = $get($1.iso646, _AT) !== undefined; /*22441*/
						var _AX = $get($1.alphanumeric, _AT) !== undefined; /*22441*/
						if (_AV && (!_AX)) { /*22445*/
							$k[$j++] = $1.liso646; /*22442*/
							$k[$j++] = $1.alphanumeric; /*22442*/
							if ($1.encode() == $b) break; /*22442*/
							$1.mode = "iso646"; /*22443*/
							break; /*22444*/
						} /*22444*/
						if ($get($1.numericruns, $1.i) >= 6) { /*22450*/
							$k[$j++] = $1.lnumeric; /*22447*/
							$k[$j++] = $1.alphanumeric; /*22447*/
							if ($1.encode() == $b) break; /*22447*/
							$1.mode = "numeric"; /*22448*/
							break; /*22449*/
						} /*22449*/
						var _Ah = $get($1.numericruns, $1.i); /*22451*/
						if ((_Ah >= 4) && ((_Ah + $1.i) == $1.gpf.length)) { /*22455*/
							$k[$j++] = $1.lnumeric; /*22452*/
							$k[$j++] = $1.alphanumeric; /*22452*/
							if ($1.encode() == $b) break; /*22452*/
							$1.mode = "numeric"; /*22453*/
							break; /*22454*/
						} /*22454*/
						$k[$j++] = $get($1.gpf, $1.i); /*22456*/
						$k[$j++] = $1.alphanumeric; /*22456*/
						if ($1.encode() == $b) break; /*22456*/
						$1.i = $1.i + 1; /*22457*/
						break; /*22458*/
					} /*22458*/
					if ($eq($1.mode, "iso646")) { /*22481*/
						if ($get($1.gpf, $1.i) == $1.fnc1) { /*22467*/
							$k[$j++] = $1.fnc1; /*22463*/
							$k[$j++] = $1.iso646; /*22463*/
							if ($1.encode() == $b) break; /*22463*/
							$1.mode = "numeric"; /*22464*/
							$1.i = $1.i + 1; /*22465*/
							break; /*22466*/
						} /*22466*/
						if (($get($1.numericruns, $1.i) >= 4) && ($get($1.nextiso646only, $1.i) >= 10)) { /*22472*/
							$k[$j++] = $1.lnumeric; /*22469*/
							$k[$j++] = $1.iso646; /*22469*/
							if ($1.encode() == $b) break; /*22469*/
							$1.mode = "numeric"; /*22470*/
							break; /*22471*/
						} /*22471*/
						if (($get($1.alphanumericruns, $1.i) >= 5) && ($get($1.nextiso646only, $1.i) >= 10)) { /*22477*/
							$k[$j++] = $1.lalphanumeric; /*22474*/
							$k[$j++] = $1.iso646; /*22474*/
							if ($1.encode() == $b) break; /*22474*/
							$1.mode = "alphanumeric"; /*22475*/
							break; /*22476*/
						} /*22476*/
						$k[$j++] = $get($1.gpf, $1.i); /*22478*/
						$k[$j++] = $1.iso646; /*22478*/
						if ($1.encode() == $b) break; /*22478*/
						$1.i = $1.i + 1; /*22479*/
						break; /*22480*/
					} /*22480*/
				} /*22480*/
			} /*22480*/
			$1.gpf = $geti($1.gpfenc, 0, $1.j); /*22485*/
			$k[$j++] = "pad"; /*22488*/
			$k[$j++] = $1.cdf.length + $1.gpf.length; /*22488*/
			if ($1.rembits() == $b) return $b; /*22488*/
			var _BQ = $a($k[--$j]); /*22488*/
			$1[$k[--$j]] = _BQ; /*22488*/
			if ($1.pad.length > 0) { /*22500*/
				for (var _BV = 0, _BU = $1.pad.length - 1; _BV <= _BU; _BV += 5) { /*22493*/
					$1.i = _BV; /*22491*/
					var _BW = $1.pad; /*22492*/
					var _BX = $1.i; /*22492*/
					var _BY = $a([0, 0, 1, 0, 0]); /*22492*/
					var _BZ = $1.pad; /*22492*/
					var _Ba = $1.i; /*22492*/
					var _Bb = 5; /*22492*/
					var _Bc = _BZ.length - _Ba; /*22492*/
					if ((_BZ.length - _Ba) > 5) { /*22492*/
						var _ = _Bb; /*22492*/
						_Bb = _Bc; /*22492*/
						_Bc = _; /*22492*/
					} /*22492*/
					$puti(_BW, _BX, $geti(_BY, 0, _Bc)); /*22492*/
				} /*22492*/
				if ($eq($1.mode, "numeric")) { /*22496*/
					$k[$j++] = "pad"; /*22495*/
					$k[$j++] = Infinity; /*22495*/
					$k[$j++] = 0; /*22495*/
					$k[$j++] = 0; /*22495*/
					$k[$j++] = 0; /*22495*/
					$k[$j++] = 0; /*22495*/
					$aload($1.pad); /*22495*/
					var _Bi = $geti($a(), 0, $1.pad.length); /*22495*/
					$1[$k[--$j]] = _Bi; /*22495*/
				} /*22495*/
				if ($eq($1.mode, "alpha")) { /*22499*/
					$k[$j++] = "pad"; /*22498*/
					$k[$j++] = Infinity; /*22498*/
					$k[$j++] = 1; /*22498*/
					$k[$j++] = 1; /*22498*/
					$k[$j++] = 1; /*22498*/
					$k[$j++] = 1; /*22498*/
					$k[$j++] = 1; /*22498*/
					$aload($1.pad); /*22498*/
					var _Bo = $geti($a(), 0, $1.pad.length); /*22498*/
					$1[$k[--$j]] = _Bo; /*22498*/
				} /*22498*/
			} /*22498*/
			$k[$j++] = Infinity; /*22507*/
			$aload($1.cdf); /*22504*/
			$aload($1.gpf); /*22505*/
			$aload($1.pad); /*22506*/
			$1.bits = $a(); /*22507*/
			if ($1.ccversion == "a") { /*22562*/
				$k[$j++] = Infinity; /*22513*/
				$k[$j++] = $a([0, 0, 0, 0, 0, 0, 1]); /*22512*/
				for (var _Bw = 0, _Bx = 68; _Bw < _Bx; _Bw++) { /*22512*/
					$k[$j++] = $a(7); /*22512*/
				} /*22512*/
				$1.pwr928 = $a(); /*22513*/
				for (var _C0 = 1; _C0 <= 68; _C0 += 1) { /*22523*/
					$1.j = _C0; /*22515*/
					$1.v = 0; /*22516*/
					for (var _C1 = 6; _C1 >= 1; _C1 -= 1) { /*22521*/
						$1.i = _C1; /*22518*/
						$1.v = ($get($get($1.pwr928, $1.j - 1), $1.i) * 2) + (~~($1.v / 928)); /*22519*/
						$put($get($1.pwr928, $1.j), $1.i, $1.v % 928); /*22520*/
					} /*22520*/
					$put($get($1.pwr928, $1.j), 0, ($get($get($1.pwr928, $1.j - 1), 0) * 2) + (~~($1.v / 928))); /*22522*/
				} /*22522*/
				$k[$j++] = Infinity; /*22524*/
				for (var _CL = 0, _CM = 28; _CL < _CM; _CL++) { /*22524*/
					$k[$j++] = 0; /*22524*/
				} /*22524*/
				$1.cws = $a(); /*22524*/
				$1.b = 0; /*22525*/
				$1.c = 0; /*22525*/
				for (;;) { /*22549*/
					if ($1.b == $1.bits.length) { /*22527*/
						break; /*22527*/
					} /*22527*/
					var _CQ = $1.bits; /*22528*/
					var _CR = $1.b; /*22528*/
					var _CS = $1.bits; /*22528*/
					var _CT = $1.b; /*22528*/
					var _CU = _CS.length - _CT; /*22528*/
					var _CV = 69; /*22528*/
					if (69 > (_CS.length - _CT)) { /*22528*/
						var _ = _CU; /*22528*/
						_CU = _CV; /*22528*/
						_CV = _; /*22528*/
					} /*22528*/
					$1.bs = $geti(_CQ, _CR, _CV); /*22528*/
					$1.bsl = $1.bs.length; /*22529*/
					$1.cs = $geti($1.cws, $1.c, (~~($1.bsl / 10)) + 1); /*22530*/
					$1.csl = $1.cs.length; /*22531*/
					for (var _Cf = 0, _Ce = $1.bsl - 1; _Cf <= _Ce; _Cf += 1) { /*22541*/
						$1.i = _Cf; /*22533*/
						for (var _Ci = 0, _Ch = $1.csl - 1; _Ci <= _Ch; _Ci += 1) { /*22540*/
							$1.j = _Ci; /*22535*/
							var _Cj = $1.cs; /*22536*/
							var _Ck = $1.j; /*22536*/
							$put(_Cj, _Ck, $get(_Cj, _Ck) + ($get($get($1.pwr928, $1.i), ($1.j + 7) - $1.csl) * $get($1.bs, ($1.bsl - $1.i) - 1))); /*22539*/
						} /*22539*/
					} /*22539*/
					for (var _Cx = $1.csl - 1; _Cx >= 1; _Cx -= 1) { /*22546*/
						$1.i = _Cx; /*22543*/
						var _Cy = $1.cs; /*22544*/
						var _Cz = $1.i; /*22544*/
						$put(_Cy, _Cz - 1, $get(_Cy, _Cz - 1) + (~~($get($1.cs, $1.i) / 928))); /*22544*/
						var _D4 = $1.cs; /*22545*/
						var _D5 = $1.i; /*22545*/
						$put(_D4, _D5, $get(_D4, _D5) % 928); /*22545*/
					} /*22545*/
					$1.b = $1.b + $1.bsl; /*22547*/
					$1.c = $1.c + $1.csl; /*22548*/
				} /*22548*/
				$1.cws = $geti($1.cws, 0, $1.c); /*22550*/
				$1.barcode = $s($1.cws.length * 4); /*22551*/
				for (var _DI = 0, _DH = $1.cws.length - 1; _DI <= _DH; _DI += 1) { /*22557*/
					$1.i = _DI; /*22553*/
					var _DK = $strcpy($s(4), "^   "); /*22554*/
					var _DP = $cvrs($s(4), $get($1.cws, $1.i), 10); /*22554*/
					$puti(_DK, 4 - _DP.length, _DP); /*22555*/
					$puti($1.barcode, $1.i * 4, _DK); /*22556*/
				} /*22556*/
				$1.options.dontdraw = true; /*22558*/
				$1.options.cca = true; /*22559*/
				$1.options.columns = $1.cccolumns; /*22560*/
				$k[$j++] = "args"; /*22561*/
				$k[$j++] = $1.barcode; /*22561*/
				$k[$j++] = $1.options; /*22561*/
				$0.micropdf417(); /*22561*/
				var _DY = $k[--$j]; /*22561*/
				$1[$k[--$j]] = _DY; /*22561*/
			} /*22561*/
			if ($1.ccversion == "b") { /*22575*/
				$1.barcode = $s(~~($1.bits.length / 8)); /*22565*/
				for (var _Df = 0, _De = $1.barcode.length - 1; _Df <= _De; _Df += 1) { /*22570*/
					$1.i = _Df; /*22567*/
					$k[$j++] = 0; /*22568*/
					$forall($geti($1.bits, $1.i * 8, 8), function() { /*22568*/
						var _Dj = $k[--$j]; /*22568*/
						var _Dk = $k[--$j]; /*22568*/
						$k[$j++] = (_Dk + _Dj) * 2; /*22568*/
					}); /*22568*/
					$put($1.barcode, $1.i, ~~($k[--$j] / 2)); /*22569*/
				} /*22569*/
				$1.options.dontdraw = true; /*22571*/
				$1.options.ccb = true; /*22572*/
				$1.options.columns = $1.cccolumns; /*22573*/
				$k[$j++] = "args"; /*22574*/
				$k[$j++] = $1.barcode; /*22574*/
				$k[$j++] = $1.options; /*22574*/
				$0.micropdf417(); /*22574*/
				var _Du = $k[--$j]; /*22574*/
				$1[$k[--$j]] = _Du; /*22574*/
			} /*22574*/
			if ($1.ccversion == "c") { /*22588*/
				$1.barcode = $s(~~($1.bits.length / 8)); /*22578*/
				for (var _E1 = 0, _E0 = $1.barcode.length - 1; _E1 <= _E0; _E1 += 1) { /*22583*/
					$1.i = _E1; /*22580*/
					$k[$j++] = 0; /*22581*/
					$forall($geti($1.bits, $1.i * 8, 8), function() { /*22581*/
						var _E5 = $k[--$j]; /*22581*/
						var _E6 = $k[--$j]; /*22581*/
						$k[$j++] = (_E6 + _E5) * 2; /*22581*/
					}); /*22581*/
					$put($1.barcode, $1.i, ~~($k[--$j] / 2)); /*22582*/
				} /*22582*/
				$1.options.dontdraw = true; /*22584*/
				$1.options.ccc = true; /*22585*/
				$1.options.columns = $1.cccolumns; /*22586*/
				$k[$j++] = "args"; /*22587*/
				$k[$j++] = $1.barcode; /*22587*/
				$k[$j++] = $1.options; /*22587*/
				$0.pdf417(); /*22587*/
				var _EG = $k[--$j]; /*22587*/
				$1[$k[--$j]] = _EG; /*22587*/
			} /*22587*/
			$k[$j++] = $1.args; /*22591*/
			if (!$1.dontdraw) { /*22591*/
				$0.renmatrix(); /*22591*/
			} /*22591*/
		};
		$0.ean13composite = function() {
			var $1 = {}; /*22621*/
			$1.options = $k[--$j]; /*22623*/
			$1.barcode = $k[--$j]; /*22624*/
			$1.dontdraw = false; /*22626*/
			$forall($1.options, function() { /*22637*/
				var _3 = $k[--$j]; /*22637*/
				$1[$k[--$j]] = _3; /*22637*/
			}); /*22637*/
			$search($1.barcode, "|"); /*22640*/
			if ($k[--$j]) { /*22645*/
				$1.linear = $k[--$j]; /*22641*/
				$j--; /*22642*/
				$1.comp = $k[--$j]; /*22643*/
			} else { /*22645*/
				$j--; /*22645*/
			} /*22645*/
			$$.save(); /*22648*/
			$1.options.lintype = "ean13"; /*22650*/
			$1.options.inkspread = "0"; /*22651*/
			$1.options.dontdraw = true; /*22652*/
			$k[$j++] = $1.linear; /*22655*/
			$k[$j++] = $1.options; /*22655*/
			$0.ean13(); /*22655*/
			$0.renlinear(); /*22655*/
			$$.rmoveto(-1, 72); /*22658*/
			$k[$j++] = Infinity; /*22669*/
			$k[$j++] = "ren"; /*22665*/
			$k[$j++] = $0.renmatrix; /*22665*/
			$k[$j++] = "pixs"; /*22665*/
			$k[$j++] = Infinity; /*22665*/
			$k[$j++] = 0; /*22661*/
			$k[$j++] = 1; /*22661*/
			for (var _E = 0, _F = 93; _E < _F; _E++) { /*22661*/
				$k[$j++] = 0; /*22661*/
			} /*22661*/
			$k[$j++] = 1; /*22662*/
			$k[$j++] = 0; /*22662*/
			$k[$j++] = 1; /*22662*/
			$k[$j++] = 0; /*22662*/
			for (var _G = 0, _H = 93; _G < _H; _G++) { /*22662*/
				$k[$j++] = 0; /*22662*/
			} /*22662*/
			$k[$j++] = 0; /*22663*/
			$k[$j++] = 1; /*22663*/
			$k[$j++] = 0; /*22663*/
			$k[$j++] = 1; /*22663*/
			for (var _I = 0, _J = 93; _I < _J; _I++) { /*22663*/
				$k[$j++] = 0; /*22663*/
			} /*22663*/
			$k[$j++] = 1; /*22663*/
			$k[$j++] = 0; /*22663*/
			var _K = $a(); /*22665*/
			$k[$j++] = _K; /*22669*/
			$k[$j++] = "pixx"; /*22669*/
			$k[$j++] = 97; /*22669*/
			$k[$j++] = "pixy"; /*22669*/
			$k[$j++] = 3; /*22669*/
			$k[$j++] = "height"; /*22669*/
			$k[$j++] = 6 / 72; /*22669*/
			$k[$j++] = "width"; /*22669*/
			$k[$j++] = 97 / 72; /*22669*/
			$k[$j++] = "opt"; /*22669*/
			$k[$j++] = $1.options; /*22669*/
			var _M = $d(); /*22669*/
			$k[$j++] = _M; /*22670*/
			$0.renmatrix(); /*22670*/
			$$.rmoveto(-2, 6); /*22673*/
			$k[$j++] = $1.comp; /*22673*/
			$k[$j++] = $1.options; /*22673*/
			$0["gs1-cc"](); /*22673*/
			$0.renmatrix(); /*22673*/
			$$.restore(); /*22675*/
		};
		$0.ean8composite = function() {
			var $1 = {}; /*22705*/
			$1.options = $k[--$j]; /*22707*/
			$1.barcode = $k[--$j]; /*22708*/
			$1.dontdraw = false; /*22710*/
			$forall($1.options, function() { /*22721*/
				var _3 = $k[--$j]; /*22721*/
				$1[$k[--$j]] = _3; /*22721*/
			}); /*22721*/
			$search($1.barcode, "|"); /*22724*/
			if ($k[--$j]) { /*22729*/
				$1.linear = $k[--$j]; /*22725*/
				$j--; /*22726*/
				$1.comp = $k[--$j]; /*22727*/
			} else { /*22729*/
				$j--; /*22729*/
			} /*22729*/
			$$.save(); /*22732*/
			$1.options.lintype = "ean8"; /*22735*/
			$1.options.inkspread = "0"; /*22736*/
			$1.options.dontdraw = true; /*22737*/
			$k[$j++] = $1.linear; /*22740*/
			$k[$j++] = $1.options; /*22740*/
			$0.ean8(); /*22740*/
			$0.renlinear(); /*22740*/
			$$.rmoveto(-1, 72); /*22743*/
			$k[$j++] = Infinity; /*22754*/
			$k[$j++] = "ren"; /*22750*/
			$k[$j++] = $0.renmatrix; /*22750*/
			$k[$j++] = "pixs"; /*22750*/
			$k[$j++] = Infinity; /*22750*/
			$k[$j++] = 0; /*22746*/
			$k[$j++] = 1; /*22746*/
			for (var _E = 0, _F = 65; _E < _F; _E++) { /*22746*/
				$k[$j++] = 0; /*22746*/
			} /*22746*/
			$k[$j++] = 1; /*22747*/
			$k[$j++] = 0; /*22747*/
			$k[$j++] = 1; /*22747*/
			$k[$j++] = 0; /*22747*/
			for (var _G = 0, _H = 65; _G < _H; _G++) { /*22747*/
				$k[$j++] = 0; /*22747*/
			} /*22747*/
			$k[$j++] = 0; /*22748*/
			$k[$j++] = 1; /*22748*/
			$k[$j++] = 0; /*22748*/
			$k[$j++] = 1; /*22748*/
			for (var _I = 0, _J = 65; _I < _J; _I++) { /*22748*/
				$k[$j++] = 0; /*22748*/
			} /*22748*/
			$k[$j++] = 1; /*22748*/
			$k[$j++] = 0; /*22748*/
			var _K = $a(); /*22750*/
			$k[$j++] = _K; /*22754*/
			$k[$j++] = "pixx"; /*22754*/
			$k[$j++] = 69; /*22754*/
			$k[$j++] = "pixy"; /*22754*/
			$k[$j++] = 3; /*22754*/
			$k[$j++] = "height"; /*22754*/
			$k[$j++] = 6 / 72; /*22754*/
			$k[$j++] = "width"; /*22754*/
			$k[$j++] = 69 / 72; /*22754*/
			$k[$j++] = "opt"; /*22754*/
			$k[$j++] = $1.options; /*22754*/
			var _M = $d(); /*22754*/
			$k[$j++] = _M; /*22755*/
			$0.renmatrix(); /*22755*/
			$k[$j++] = $1.comp; /*22758*/
			$k[$j++] = $1.options; /*22758*/
			$0["gs1-cc"](); /*22758*/
			var _P = $k[--$j]; /*22759*/
			$$.rmoveto(69 - _P.pixx, 6); /*22759*/
			$k[$j++] = _P; /*22760*/
			$0.renmatrix(); /*22760*/
			$$.restore(); /*22762*/
		};
		$0.upcacomposite = function() {
			var $1 = {}; /*22792*/
			$1.options = $k[--$j]; /*22794*/
			$1.barcode = $k[--$j]; /*22795*/
			$1.dontdraw = false; /*22797*/
			$forall($1.options, function() { /*22808*/
				var _3 = $k[--$j]; /*22808*/
				$1[$k[--$j]] = _3; /*22808*/
			}); /*22808*/
			$search($1.barcode, "|"); /*22811*/
			if ($k[--$j]) { /*22816*/
				$1.linear = $k[--$j]; /*22812*/
				$j--; /*22813*/
				$1.comp = $k[--$j]; /*22814*/
			} else { /*22816*/
				$j--; /*22816*/
			} /*22816*/
			$$.save(); /*22819*/
			$1.options.lintype = "ean13"; /*22821*/
			$1.options.inkspread = "0"; /*22822*/
			$1.options.dontdraw = true; /*22823*/
			$k[$j++] = $1.linear; /*22826*/
			$k[$j++] = $1.options; /*22826*/
			$0.upca(); /*22826*/
			$0.renlinear(); /*22826*/
			$$.rmoveto(-1, 72); /*22829*/
			$k[$j++] = Infinity; /*22840*/
			$k[$j++] = "ren"; /*22836*/
			$k[$j++] = $0.renmatrix; /*22836*/
			$k[$j++] = "pixs"; /*22836*/
			$k[$j++] = Infinity; /*22836*/
			$k[$j++] = 0; /*22832*/
			$k[$j++] = 1; /*22832*/
			for (var _E = 0, _F = 93; _E < _F; _E++) { /*22832*/
				$k[$j++] = 0; /*22832*/
			} /*22832*/
			$k[$j++] = 1; /*22833*/
			$k[$j++] = 0; /*22833*/
			$k[$j++] = 1; /*22833*/
			$k[$j++] = 0; /*22833*/
			for (var _G = 0, _H = 93; _G < _H; _G++) { /*22833*/
				$k[$j++] = 0; /*22833*/
			} /*22833*/
			$k[$j++] = 0; /*22834*/
			$k[$j++] = 1; /*22834*/
			$k[$j++] = 0; /*22834*/
			$k[$j++] = 1; /*22834*/
			for (var _I = 0, _J = 93; _I < _J; _I++) { /*22834*/
				$k[$j++] = 0; /*22834*/
			} /*22834*/
			$k[$j++] = 1; /*22834*/
			$k[$j++] = 0; /*22834*/
			var _K = $a(); /*22836*/
			$k[$j++] = _K; /*22840*/
			$k[$j++] = "pixx"; /*22840*/
			$k[$j++] = 97; /*22840*/
			$k[$j++] = "pixy"; /*22840*/
			$k[$j++] = 3; /*22840*/
			$k[$j++] = "height"; /*22840*/
			$k[$j++] = 6 / 72; /*22840*/
			$k[$j++] = "width"; /*22840*/
			$k[$j++] = 97 / 72; /*22840*/
			$k[$j++] = "opt"; /*22840*/
			$k[$j++] = $1.options; /*22840*/
			var _M = $d(); /*22840*/
			$k[$j++] = _M; /*22841*/
			$0.renmatrix(); /*22841*/
			$$.rmoveto(-2, 6); /*22844*/
			$k[$j++] = $1.comp; /*22844*/
			$k[$j++] = $1.options; /*22844*/
			$0["gs1-cc"](); /*22844*/
			$0.renmatrix(); /*22844*/
			$$.restore(); /*22846*/
		};
		$0.upcecomposite = function() {
			var $1 = {}; /*22876*/
			$1.options = $k[--$j]; /*22878*/
			$1.barcode = $k[--$j]; /*22879*/
			$1.dontdraw = false; /*22881*/
			$forall($1.options, function() { /*22892*/
				var _3 = $k[--$j]; /*22892*/
				$1[$k[--$j]] = _3; /*22892*/
			}); /*22892*/
			$search($1.barcode, "|"); /*22895*/
			if ($k[--$j]) { /*22900*/
				$1.linear = $k[--$j]; /*22896*/
				$j--; /*22897*/
				$1.comp = $k[--$j]; /*22898*/
			} else { /*22900*/
				$j--; /*22900*/
			} /*22900*/
			$k[$j++] = "sep"; /*22915*/
			$k[$j++] = Infinity; /*22915*/
			$k[$j++] = "ren"; /*22911*/
			$k[$j++] = $0.renmatrix; /*22911*/
			$k[$j++] = "pixs"; /*22911*/
			$k[$j++] = Infinity; /*22911*/
			$k[$j++] = 0; /*22907*/
			$k[$j++] = 1; /*22907*/
			for (var _9 = 0, _A = 49; _9 < _A; _9++) { /*22907*/
				$k[$j++] = 0; /*22907*/
			} /*22907*/
			$k[$j++] = 1; /*22908*/
			$k[$j++] = 0; /*22908*/
			$k[$j++] = 1; /*22908*/
			$k[$j++] = 0; /*22908*/
			for (var _B = 0, _C = 49; _B < _C; _B++) { /*22908*/
				$k[$j++] = 0; /*22908*/
			} /*22908*/
			$k[$j++] = 0; /*22909*/
			$k[$j++] = 1; /*22909*/
			$k[$j++] = 0; /*22909*/
			$k[$j++] = 1; /*22909*/
			for (var _D = 0, _E = 49; _D < _E; _D++) { /*22909*/
				$k[$j++] = 0; /*22909*/
			} /*22909*/
			$k[$j++] = 1; /*22909*/
			$k[$j++] = 0; /*22909*/
			var _F = $a(); /*22911*/
			$k[$j++] = _F; /*22915*/
			$k[$j++] = "pixx"; /*22915*/
			$k[$j++] = 53; /*22915*/
			$k[$j++] = "pixy"; /*22915*/
			$k[$j++] = 3; /*22915*/
			$k[$j++] = "height"; /*22915*/
			$k[$j++] = 6 / 72; /*22915*/
			$k[$j++] = "width"; /*22915*/
			$k[$j++] = 53 / 72; /*22915*/
			$k[$j++] = "opt"; /*22915*/
			$k[$j++] = $1.options; /*22915*/
			var _H = $d(); /*22915*/
			$1[$k[--$j]] = _H; /*22916*/
			$$.save(); /*22918*/
			$1.options.lintype = "upce"; /*22920*/
			$1.options.inkspread = "0"; /*22921*/
			$1.options.dontdraw = true; /*22922*/
			$k[$j++] = $1.linear; /*22925*/
			$k[$j++] = $1.options; /*22925*/
			$0.upce(); /*22925*/
			$0.renlinear(); /*22925*/
			$$.rmoveto(-1, 72); /*22928*/
			$k[$j++] = Infinity; /*22939*/
			$k[$j++] = "ren"; /*22935*/
			$k[$j++] = $0.renmatrix; /*22935*/
			$k[$j++] = "pixs"; /*22935*/
			$k[$j++] = Infinity; /*22935*/
			$k[$j++] = 0; /*22931*/
			$k[$j++] = 1; /*22931*/
			for (var _O = 0, _P = 49; _O < _P; _O++) { /*22931*/
				$k[$j++] = 0; /*22931*/
			} /*22931*/
			$k[$j++] = 1; /*22932*/
			$k[$j++] = 0; /*22932*/
			$k[$j++] = 1; /*22932*/
			$k[$j++] = 0; /*22932*/
			for (var _Q = 0, _R = 49; _Q < _R; _Q++) { /*22932*/
				$k[$j++] = 0; /*22932*/
			} /*22932*/
			$k[$j++] = 0; /*22933*/
			$k[$j++] = 1; /*22933*/
			$k[$j++] = 0; /*22933*/
			$k[$j++] = 1; /*22933*/
			for (var _S = 0, _T = 49; _S < _T; _S++) { /*22933*/
				$k[$j++] = 0; /*22933*/
			} /*22933*/
			$k[$j++] = 1; /*22933*/
			$k[$j++] = 0; /*22933*/
			var _U = $a(); /*22935*/
			$k[$j++] = _U; /*22939*/
			$k[$j++] = "pixx"; /*22939*/
			$k[$j++] = 53; /*22939*/
			$k[$j++] = "pixy"; /*22939*/
			$k[$j++] = 3; /*22939*/
			$k[$j++] = "height"; /*22939*/
			$k[$j++] = 6 / 72; /*22939*/
			$k[$j++] = "width"; /*22939*/
			$k[$j++] = 53 / 72; /*22939*/
			$k[$j++] = "opt"; /*22939*/
			$k[$j++] = $1.options; /*22939*/
			var _W = $d(); /*22939*/
			$k[$j++] = _W; /*22940*/
			$0.renmatrix(); /*22940*/
			$$.rmoveto(-2, 6); /*22943*/
			$k[$j++] = $1.comp; /*22943*/
			$k[$j++] = $1.options; /*22943*/
			$0["gs1-cc"](); /*22943*/
			$0.renmatrix(); /*22943*/
			$$.restore(); /*22945*/
		};
		$0.databaromnicomposite = function() {
			var $1 = {}; /*22975*/
			$1.options = $k[--$j]; /*22977*/
			$1.barcode = $k[--$j]; /*22978*/
			$1.dontdraw = false; /*22980*/
			$forall($1.options, function() { /*22991*/
				var _3 = $k[--$j]; /*22991*/
				$1[$k[--$j]] = _3; /*22991*/
			}); /*22991*/
			$search($1.barcode, "|"); /*22994*/
			if ($k[--$j]) { /*22999*/
				$1.linear = $k[--$j]; /*22995*/
				$j--; /*22996*/
				$1.comp = $k[--$j]; /*22997*/
			} else { /*22999*/
				$j--; /*22999*/
			} /*22999*/
			$$.save(); /*23002*/
			$1.options.lintype = "databaromni"; /*23004*/
			$1.options.linkage = true; /*23005*/
			$1.options.inkspread = "0"; /*23006*/
			$1.options.dontdraw = true; /*23007*/
			$k[$j++] = $1.linear; /*23010*/
			$k[$j++] = $1.options; /*23010*/
			$0.databaromni(); /*23010*/
			var _F = $k[--$j]; /*23011*/
			$1.linsbs = _F.sbs; /*23011*/
			$1.linheight = $get(_F.bhs, 0) * 72; /*23012*/
			$k[$j++] = _F; /*23013*/
			$0.renlinear(); /*23013*/
			$1.sepfinder = function() {
				$1.fp = $k[--$j]; /*23017*/
				for (var _N = $1.fp, _M = $1.fp + 12; _N <= _M; _N += 1) { /*23030*/
					$1.i = _N; /*23019*/
					if ($get($1.bot, $1.i) == 0) { /*23027*/
						if ($get($1.bot, $1.i - 1) == 1) { /*23024*/
							$k[$j++] = 1; /*23022*/
						} else { /*23024*/
							var _X = ($get($1.sep, $1.i - 1) == 0) ? 1 : 0; /*23024*/
							$k[$j++] = _X; /*23024*/
						} /*23024*/
					} else { /*23027*/
						$k[$j++] = 0; /*23027*/
					} /*23027*/
					$put($1.sep, $1.i, $k[--$j]); /*23029*/
				} /*23029*/
				$1.f3 = $a([1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1]); /*23031*/
				$k[$j++] = true; /*23032*/
				for (var _c = 0; _c <= 12; _c += 1) { /*23032*/
					var _i = $k[--$j]; /*23032*/
					$k[$j++] = _i && $eq($get($1.bot, _c + $1.fp), $get($1.f3, _c)); /*23032*/
				} /*23032*/
				if ($k[--$j]) { /*23035*/
					$puti($1.sep, $1.fp, $a([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0])); /*23034*/
				} /*23034*/
			}; /*23036*/
			$k[$j++] = Infinity; /*23037*/
			$k[$j++] = 0; /*23038*/
			$forall($1.linsbs, function() { /*23038*/
				var _o = $k[--$j]; /*23038*/
				var _p = $k[--$j]; /*23038*/
				var _q = (_p == 1) ? 0 : 1; /*23038*/
				$k[$j++] = _p; /*23038*/
				for (var _r = 0, _s = _o; _r < _s; _r++) { /*23038*/
					$k[$j++] = _q /*23038*/
				} /*23038*/
			}); /*23038*/
			$astore($a($counttomark() - 1)); /*23039*/
			$1.bot = $k[--$j]; /*23039*/
			$j -= 2; /*23039*/
			$k[$j++] = Infinity; /*23040*/
			$forall($1.bot, function() { /*23040*/
				var _x = $k[--$j]; /*23040*/
				$k[$j++] = 1 - _x; /*23040*/
			}); /*23040*/
			$1.sep = $a(); /*23040*/
			$puti($1.sep, 0, $a([0, 0, 0])); /*23041*/
			$puti($1.sep, $1.sep.length - 4, $a([0, 0, 0, 0])); /*23042*/
			$k[$j++] = 18; /*23043*/
			if ($1.sepfinder() == $b) return $b; /*23043*/
			$k[$j++] = 64; /*23043*/
			if ($1.sepfinder() == $b) return $b; /*23043*/
			$$.rmoveto(0, $1.linheight); /*23044*/
			var _19 = {
				ren: $0.renmatrix,
				pixs: $1.sep,
				pixx: $1.sep.length,
				pixy: 1,
				height: 1 / 72,
				width: $1.sep.length / 72,
				opt: $1.options
			}; /*23051*/
			$k[$j++] = _19; /*23052*/
			$0.renmatrix(); /*23052*/
			$$.rmoveto(-5, 1); /*23055*/
			$k[$j++] = $1.comp; /*23055*/
			$k[$j++] = $1.options; /*23055*/
			$0["gs1-cc"](); /*23055*/
			$0.renmatrix(); /*23055*/
			$$.restore(); /*23057*/
		};
		$0.databarstackedcomposite = function() {
			var $1 = {}; /*23086*/
			$1.options = $k[--$j]; /*23088*/
			$1.barcode = $k[--$j]; /*23089*/
			$1.dontdraw = false; /*23091*/
			$forall($1.options, function() { /*23102*/
				var _3 = $k[--$j]; /*23102*/
				$1[$k[--$j]] = _3; /*23102*/
			}); /*23102*/
			$search($1.barcode, "|"); /*23105*/
			if ($k[--$j]) { /*23110*/
				$1.linear = $k[--$j]; /*23106*/
				$j--; /*23107*/
				$1.comp = $k[--$j]; /*23108*/
			} else { /*23110*/
				$j--; /*23110*/
			} /*23110*/
			$$.save(); /*23113*/
			$1.options.lintype = "databarstacked"; /*23115*/
			$1.options.linkage = true; /*23116*/
			$1.options.inkspread = "0"; /*23117*/
			$1.options.dontdraw = true; /*23118*/
			$k[$j++] = $1.linear; /*23121*/
			$k[$j++] = $1.options; /*23121*/
			$0.databarstacked(); /*23121*/
			var _F = $k[--$j]; /*23122*/
			$1.bot = $geti(_F.pixs, 0, _F.pixx); /*23122*/
			$1.linheight = _F.pixy; /*23123*/
			$k[$j++] = _F; /*23124*/
			$0.renmatrix(); /*23124*/
			$1.sepfinder = function() {
				$1.fp = $k[--$j]; /*23128*/
				for (var _O = $1.fp, _N = $1.fp + 12; _O <= _N; _O += 1) { /*23141*/
					$1.i = _O; /*23130*/
					if ($get($1.bot, $1.i) == 0) { /*23138*/
						if ($get($1.bot, $1.i - 1) == 1) { /*23135*/
							$k[$j++] = 1; /*23133*/
						} else { /*23135*/
							var _Y = ($get($1.sep, $1.i - 1) == 0) ? 1 : 0; /*23135*/
							$k[$j++] = _Y; /*23135*/
						} /*23135*/
					} else { /*23138*/
						$k[$j++] = 0; /*23138*/
					} /*23138*/
					$put($1.sep, $1.i, $k[--$j]); /*23140*/
				} /*23140*/
				$1.f3 = $a([1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1]); /*23142*/
				$k[$j++] = true; /*23143*/
				for (var _d = 0; _d <= 12; _d += 1) { /*23143*/
					var _j = $k[--$j]; /*23143*/
					$k[$j++] = _j && $eq($get($1.bot, _d + $1.fp), $get($1.f3, _d)); /*23143*/
				} /*23143*/
				if ($k[--$j]) { /*23146*/
					$puti($1.sep, $1.fp, $a([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0])); /*23145*/
				} /*23145*/
			}; /*23147*/
			$k[$j++] = Infinity; /*23148*/
			$forall($1.bot, function() { /*23148*/
				var _p = $k[--$j]; /*23148*/
				$k[$j++] = 1 - _p; /*23148*/
			}); /*23148*/
			$1.sep = $a(); /*23148*/
			$puti($1.sep, 0, $a([0, 0, 0, 0])); /*23149*/
			$puti($1.sep, $1.sep.length - 4, $a([0, 0, 0, 0])); /*23150*/
			$k[$j++] = 18; /*23151*/
			if ($1.sepfinder() == $b) return $b; /*23151*/
			$$.rmoveto(0, $1.linheight); /*23152*/
			var _11 = {
				ren: $0.renmatrix,
				pixs: $1.sep,
				pixx: $1.sep.length,
				pixy: 1,
				height: 1 / 72,
				width: $1.sep.length / 72,
				opt: $1.options
			}; /*23159*/
			$k[$j++] = _11; /*23160*/
			$0.renmatrix(); /*23160*/
			$$.rmoveto(1, 1); /*23163*/
			$k[$j++] = $1.comp; /*23163*/
			$k[$j++] = $1.options; /*23163*/
			$0["gs1-cc"](); /*23163*/
			$0.renmatrix(); /*23163*/
			$$.restore(); /*23165*/
		};
		$0.databarstackedomnicomposite = function() {
			var $1 = {}; /*23194*/
			$1.options = $k[--$j]; /*23196*/
			$1.barcode = $k[--$j]; /*23197*/
			$1.dontdraw = false; /*23199*/
			$forall($1.options, function() { /*23210*/
				var _3 = $k[--$j]; /*23210*/
				$1[$k[--$j]] = _3; /*23210*/
			}); /*23210*/
			$search($1.barcode, "|"); /*23213*/
			if ($k[--$j]) { /*23218*/
				$1.linear = $k[--$j]; /*23214*/
				$j--; /*23215*/
				$1.comp = $k[--$j]; /*23216*/
			} else { /*23218*/
				$j--; /*23218*/
			} /*23218*/
			$$.save(); /*23221*/
			$1.options.lintype = "databarstackedomni"; /*23223*/
			$1.options.linkage = true; /*23224*/
			$1.options.inkspread = "0"; /*23225*/
			$1.options.dontdraw = true; /*23226*/
			$k[$j++] = $1.linear; /*23229*/
			$k[$j++] = $1.options; /*23229*/
			$0.databarstackedomni(); /*23229*/
			var _F = $k[--$j]; /*23230*/
			$1.bot = $geti(_F.pixs, 0, _F.pixx); /*23230*/
			$1.linheight = _F.pixy; /*23231*/
			$k[$j++] = _F; /*23232*/
			$0.renmatrix(); /*23232*/
			$1.sepfinder = function() {
				$1.fp = $k[--$j]; /*23236*/
				for (var _O = $1.fp, _N = $1.fp + 12; _O <= _N; _O += 1) { /*23249*/
					$1.i = _O; /*23238*/
					if ($get($1.bot, $1.i) == 0) { /*23246*/
						if ($get($1.bot, $1.i - 1) == 1) { /*23243*/
							$k[$j++] = 1; /*23241*/
						} else { /*23243*/
							var _Y = ($get($1.sep, $1.i - 1) == 0) ? 1 : 0; /*23243*/
							$k[$j++] = _Y; /*23243*/
						} /*23243*/
					} else { /*23246*/
						$k[$j++] = 0; /*23246*/
					} /*23246*/
					$put($1.sep, $1.i, $k[--$j]); /*23248*/
				} /*23248*/
				$1.f3 = $a([1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1]); /*23250*/
				$k[$j++] = true; /*23251*/
				for (var _d = 0; _d <= 12; _d += 1) { /*23251*/
					var _j = $k[--$j]; /*23251*/
					$k[$j++] = _j && $eq($get($1.bot, _d + $1.fp), $get($1.f3, _d)); /*23251*/
				} /*23251*/
				if ($k[--$j]) { /*23254*/
					$puti($1.sep, $1.fp, $a([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0])); /*23253*/
				} /*23253*/
			}; /*23255*/
			$k[$j++] = Infinity; /*23256*/
			$forall($1.bot, function() { /*23256*/
				var _p = $k[--$j]; /*23256*/
				$k[$j++] = 1 - _p; /*23256*/
			}); /*23256*/
			$1.sep = $a(); /*23256*/
			$puti($1.sep, 0, $a([0, 0, 0])); /*23257*/
			$puti($1.sep, $1.sep.length - 4, $a([0, 0, 0, 0])); /*23258*/
			$k[$j++] = 18; /*23259*/
			if ($1.sepfinder() == $b) return $b; /*23259*/
			$$.rmoveto(0, $1.linheight); /*23260*/
			var _11 = {
				ren: $0.renmatrix,
				pixs: $1.sep,
				pixx: $1.sep.length,
				pixy: 1,
				height: 1 / 72,
				width: $1.sep.length / 72,
				opt: $1.options
			}; /*23267*/
			$k[$j++] = _11; /*23268*/
			$0.renmatrix(); /*23268*/
			$$.rmoveto(1, 1); /*23271*/
			$k[$j++] = $1.comp; /*23271*/
			$k[$j++] = $1.options; /*23271*/
			$0["gs1-cc"](); /*23271*/
			$0.renmatrix(); /*23271*/
			$$.restore(); /*23273*/
		};
		$0.databartruncatedcomposite = function() {
			var $1 = {}; /*23303*/
			$1.options = $k[--$j]; /*23305*/
			$1.barcode = $k[--$j]; /*23306*/
			$1.dontdraw = false; /*23308*/
			$forall($1.options, function() { /*23319*/
				var _3 = $k[--$j]; /*23319*/
				$1[$k[--$j]] = _3; /*23319*/
			}); /*23319*/
			$search($1.barcode, "|"); /*23322*/
			if ($k[--$j]) { /*23327*/
				$1.linear = $k[--$j]; /*23323*/
				$j--; /*23324*/
				$1.comp = $k[--$j]; /*23325*/
			} else { /*23327*/
				$j--; /*23327*/
			} /*23327*/
			$$.save(); /*23330*/
			$1.options.lintype = "databartruncated"; /*23332*/
			$1.options.linkage = true; /*23333*/
			$1.options.inkspread = "0"; /*23334*/
			$1.options.dontdraw = true; /*23335*/
			$k[$j++] = $1.linear; /*23338*/
			$k[$j++] = $1.options; /*23338*/
			$0.databartruncated(); /*23338*/
			var _F = $k[--$j]; /*23339*/
			$1.linsbs = _F.sbs; /*23339*/
			$1.linheight = $get(_F.bhs, 0) * 72; /*23340*/
			$k[$j++] = _F; /*23341*/
			$0.renlinear(); /*23341*/
			$1.sepfinder = function() {
				$1.fp = $k[--$j]; /*23345*/
				for (var _N = $1.fp, _M = $1.fp + 12; _N <= _M; _N += 1) { /*23358*/
					$1.i = _N; /*23347*/
					if ($get($1.bot, $1.i) == 0) { /*23355*/
						if ($get($1.bot, $1.i - 1) == 1) { /*23352*/
							$k[$j++] = 1; /*23350*/
						} else { /*23352*/
							var _X = ($get($1.sep, $1.i - 1) == 0) ? 1 : 0; /*23352*/
							$k[$j++] = _X; /*23352*/
						} /*23352*/
					} else { /*23355*/
						$k[$j++] = 0; /*23355*/
					} /*23355*/
					$put($1.sep, $1.i, $k[--$j]); /*23357*/
				} /*23357*/
				$1.f3 = $a([1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1]); /*23359*/
				$k[$j++] = true; /*23360*/
				for (var _c = 0; _c <= 12; _c += 1) { /*23360*/
					var _i = $k[--$j]; /*23360*/
					$k[$j++] = _i && $eq($get($1.bot, _c + $1.fp), $get($1.f3, _c)); /*23360*/
				} /*23360*/
				if ($k[--$j]) { /*23363*/
					$puti($1.sep, $1.fp, $a([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0])); /*23362*/
				} /*23362*/
			}; /*23364*/
			$k[$j++] = Infinity; /*23365*/
			$k[$j++] = 0; /*23366*/
			$forall($1.linsbs, function() { /*23366*/
				var _o = $k[--$j]; /*23366*/
				var _p = $k[--$j]; /*23366*/
				var _q = (_p == 1) ? 0 : 1; /*23366*/
				$k[$j++] = _p; /*23366*/
				for (var _r = 0, _s = _o; _r < _s; _r++) { /*23366*/
					$k[$j++] = _q /*23366*/
				} /*23366*/
			}); /*23366*/
			$astore($a($counttomark() - 1)); /*23367*/
			$1.bot = $k[--$j]; /*23367*/
			$j -= 2; /*23367*/
			$k[$j++] = Infinity; /*23368*/
			$forall($1.bot, function() { /*23368*/
				var _x = $k[--$j]; /*23368*/
				$k[$j++] = 1 - _x; /*23368*/
			}); /*23368*/
			$1.sep = $a(); /*23368*/
			$puti($1.sep, 0, $a([0, 0, 0])); /*23369*/
			$puti($1.sep, $1.sep.length - 4, $a([0, 0, 0, 0])); /*23370*/
			$k[$j++] = 18; /*23371*/
			if ($1.sepfinder() == $b) return $b; /*23371*/
			$k[$j++] = 64; /*23371*/
			if ($1.sepfinder() == $b) return $b; /*23371*/
			$$.rmoveto(0, $1.linheight); /*23372*/
			var _19 = {
				ren: $0.renmatrix,
				pixs: $1.sep,
				pixx: $1.sep.length,
				pixy: 1,
				height: 1 / 72,
				width: $1.sep.length / 72,
				opt: $1.options
			}; /*23379*/
			$k[$j++] = _19; /*23380*/
			$0.renmatrix(); /*23380*/
			$$.rmoveto(-5, 1); /*23383*/
			$k[$j++] = $1.comp; /*23383*/
			$k[$j++] = $1.options; /*23383*/
			$0["gs1-cc"](); /*23383*/
			$0.renmatrix(); /*23383*/
			$$.restore(); /*23385*/
		};
		$0.databarlimitedcomposite = function() {
			var $1 = {}; /*23415*/
			$1.options = $k[--$j]; /*23417*/
			$1.barcode = $k[--$j]; /*23418*/
			$1.dontdraw = false; /*23420*/
			$forall($1.options, function() { /*23431*/
				var _3 = $k[--$j]; /*23431*/
				$1[$k[--$j]] = _3; /*23431*/
			}); /*23431*/
			$search($1.barcode, "|"); /*23434*/
			if ($k[--$j]) { /*23439*/
				$1.linear = $k[--$j]; /*23435*/
				$j--; /*23436*/
				$1.comp = $k[--$j]; /*23437*/
			} else { /*23439*/
				$j--; /*23439*/
			} /*23439*/
			$$.save(); /*23442*/
			$1.options.lintype = "databarlimited"; /*23444*/
			$1.options.linkage = true; /*23445*/
			$1.options.inkspread = "0"; /*23446*/
			$1.options.dontdraw = true; /*23447*/
			$k[$j++] = $1.linear; /*23450*/
			$k[$j++] = $1.options; /*23450*/
			$0.databarlimited(); /*23450*/
			var _F = $k[--$j]; /*23451*/
			$1.linsbs = _F.sbs; /*23451*/
			$1.linheight = $get(_F.bhs, 0) * 72; /*23452*/
			$k[$j++] = _F; /*23453*/
			$0.renlinear(); /*23453*/
			$k[$j++] = Infinity; /*23456*/
			$k[$j++] = 1; /*23457*/
			$forall($1.linsbs, function() { /*23457*/
				var _K = $k[--$j]; /*23457*/
				var _L = $k[--$j]; /*23457*/
				var _M = (_L == 0) ? 1 : 0; /*23457*/
				$k[$j++] = _L; /*23457*/
				for (var _N = 0, _O = _K; _N < _O; _N++) { /*23457*/
					$k[$j++] = _M /*23457*/
				} /*23457*/
			}); /*23457*/
			$astore($a($counttomark() - 1)); /*23458*/
			$1.sep = $k[--$j]; /*23458*/
			$j -= 2; /*23458*/
			$puti($1.sep, 0, $a([0, 0, 0])); /*23459*/
			$puti($1.sep, $1.sep.length - 4, $a([0, 0, 0, 0])); /*23460*/
			$$.rmoveto(0, $1.linheight); /*23461*/
			var _c = {
				ren: $0.renmatrix,
				pixs: $1.sep,
				pixx: $1.sep.length,
				pixy: 1,
				height: 1 / 72,
				width: $1.sep.length / 72,
				opt: $1.options
			}; /*23468*/
			$k[$j++] = _c; /*23469*/
			$0.renmatrix(); /*23469*/
			$k[$j++] = $1.comp; /*23472*/
			$k[$j++] = $1.options; /*23472*/
			$0["gs1-cc"](); /*23472*/
			var _f = $k[--$j]; /*23473*/
			$$.rmoveto(72 - _f.pixx, 1); /*23473*/
			$k[$j++] = _f; /*23474*/
			$0.renmatrix(); /*23474*/
			$$.restore(); /*23476*/
		};
		$0.databarexpandedcomposite = function() {
			var $1 = {}; /*23506*/
			$1.options = $k[--$j]; /*23508*/
			$1.barcode = $k[--$j]; /*23509*/
			$1.dontdraw = false; /*23511*/
			$forall($1.options, function() { /*23522*/
				var _3 = $k[--$j]; /*23522*/
				$1[$k[--$j]] = _3; /*23522*/
			}); /*23522*/
			$search($1.barcode, "|"); /*23525*/
			if ($k[--$j]) { /*23530*/
				$1.linear = $k[--$j]; /*23526*/
				$j--; /*23527*/
				$1.comp = $k[--$j]; /*23528*/
			} else { /*23530*/
				$j--; /*23530*/
			} /*23530*/
			$$.save(); /*23533*/
			$1.options.lintype = "databarexpanded"; /*23535*/
			$1.options.linkage = true; /*23536*/
			$1.options.inkspread = "0"; /*23537*/
			$1.options.dontdraw = true; /*23538*/
			$k[$j++] = $1.linear; /*23541*/
			$k[$j++] = $1.options; /*23541*/
			$0.databarexpanded(); /*23541*/
			var _F = $k[--$j]; /*23542*/
			$1.linsbs = _F.sbs; /*23542*/
			$1.linheight = $get(_F.bhs, 0) * 72; /*23543*/
			$k[$j++] = _F; /*23544*/
			$0.renlinear(); /*23544*/
			$1.sepfinder = function() {
				$1.fp = $k[--$j]; /*23548*/
				for (var _N = $1.fp, _M = $1.fp + 12; _N <= _M; _N += 1) { /*23561*/
					$1.i = _N; /*23550*/
					if ($get($1.bot, $1.i) == 0) { /*23558*/
						if ($get($1.bot, $1.i - 1) == 1) { /*23555*/
							$k[$j++] = 1; /*23553*/
						} else { /*23555*/
							var _X = ($get($1.sep, $1.i - 1) == 0) ? 1 : 0; /*23555*/
							$k[$j++] = _X; /*23555*/
						} /*23555*/
					} else { /*23558*/
						$k[$j++] = 0; /*23558*/
					} /*23558*/
					$put($1.sep, $1.i, $k[--$j]); /*23560*/
				} /*23560*/
			}; /*23562*/
			$k[$j++] = Infinity; /*23563*/
			$k[$j++] = 0; /*23564*/
			$forall($1.linsbs, function() { /*23564*/
				var _c = $k[--$j]; /*23564*/
				var _d = $k[--$j]; /*23564*/
				var _e = (_d == 1) ? 0 : 1; /*23564*/
				$k[$j++] = _d; /*23564*/
				for (var _f = 0, _g = _c; _f < _g; _f++) { /*23564*/
					$k[$j++] = _e /*23564*/
				} /*23564*/
			}); /*23564*/
			$astore($a($counttomark() - 1)); /*23565*/
			$1.bot = $k[--$j]; /*23565*/
			$j -= 2; /*23565*/
			$k[$j++] = Infinity; /*23566*/
			$forall($1.bot, function() { /*23566*/
				var _l = $k[--$j]; /*23566*/
				$k[$j++] = 1 - _l; /*23566*/
			}); /*23566*/
			$1.sep = $a(); /*23566*/
			$puti($1.sep, 0, $a([0, 0, 0])); /*23567*/
			$puti($1.sep, $1.sep.length - 4, $a([0, 0, 0, 0])); /*23568*/
			$k[$j++] = Infinity; /*23571*/
			for (var _u = 18, _t = $1.bot.length - 13; _u <= _t; _u += 98) { /*23570*/
				$k[$j++] = _u; /*23570*/
			} /*23570*/
			for (var _x = 69, _w = $1.bot.length - 13; _x <= _w; _x += 98) { /*23571*/
				$k[$j++] = _x; /*23571*/
			} /*23571*/
			var _y = $a(); /*23571*/
			for (var _z = 0, _10 = _y.length; _z < _10; _z++) { /*23572*/
				$k[$j++] = $get(_y, _z); /*23572*/
				if ($1.sepfinder() == $b) return $b; /*23572*/
			} /*23572*/
			$$.rmoveto(0, $1.linheight); /*23573*/
			var _17 = {
				ren: $0.renmatrix,
				pixs: $1.sep,
				pixx: $1.sep.length,
				pixy: 1,
				height: 1 / 72,
				width: $1.sep.length / 72,
				opt: $1.options
			}; /*23580*/
			$k[$j++] = _17; /*23581*/
			$0.renmatrix(); /*23581*/
			$$.rmoveto(1, 1); /*23584*/
			$k[$j++] = $1.comp; /*23584*/
			$k[$j++] = $1.options; /*23584*/
			$0["gs1-cc"](); /*23584*/
			$0.renmatrix(); /*23584*/
			$$.restore(); /*23586*/
		};
		$0.databarexpandedstackedcomposite = function() {
			var $1 = {}; /*23615*/
			$1.options = $k[--$j]; /*23617*/
			$1.barcode = $k[--$j]; /*23618*/
			$1.dontdraw = false; /*23620*/
			$forall($1.options, function() { /*23631*/
				var _3 = $k[--$j]; /*23631*/
				$1[$k[--$j]] = _3; /*23631*/
			}); /*23631*/
			$search($1.barcode, "|"); /*23634*/
			if ($k[--$j]) { /*23639*/
				$1.linear = $k[--$j]; /*23635*/
				$j--; /*23636*/
				$1.comp = $k[--$j]; /*23637*/
			} else { /*23639*/
				$j--; /*23639*/
			} /*23639*/
			$$.save(); /*23642*/
			$1.options.lintype = "databarexpandedstacked"; /*23644*/
			$1.options.linkage = true; /*23645*/
			$1.options.inkspread = "0"; /*23646*/
			$1.options.dontdraw = true; /*23647*/
			$k[$j++] = $1.linear; /*23650*/
			$k[$j++] = $1.options; /*23650*/
			$0.databarexpandedstacked(); /*23650*/
			var _F = $k[--$j]; /*23651*/
			$1.bot = $geti(_F.pixs, 0, _F.pixx); /*23651*/
			$1.linheight = _F.pixy; /*23652*/
			$k[$j++] = _F; /*23653*/
			$0.renmatrix(); /*23653*/
			$1.sepfinder = function() {
				$1.fp = $k[--$j]; /*23657*/
				for (var _O = $1.fp, _N = $1.fp + 12; _O <= _N; _O += 1) { /*23670*/
					$1.i = _O; /*23659*/
					if ($get($1.bot, $1.i) == 0) { /*23667*/
						if ($get($1.bot, $1.i - 1) == 1) { /*23664*/
							$k[$j++] = 1; /*23662*/
						} else { /*23664*/
							var _Y = ($get($1.sep, $1.i - 1) == 0) ? 1 : 0; /*23664*/
							$k[$j++] = _Y; /*23664*/
						} /*23664*/
					} else { /*23667*/
						$k[$j++] = 0; /*23667*/
					} /*23667*/
					$put($1.sep, $1.i, $k[--$j]); /*23669*/
				} /*23669*/
			}; /*23671*/
			$k[$j++] = Infinity; /*23672*/
			$forall($1.bot, function() { /*23672*/
				var _d = $k[--$j]; /*23672*/
				$k[$j++] = 1 - _d; /*23672*/
			}); /*23672*/
			$1.sep = $a(); /*23672*/
			$puti($1.sep, 0, $a([0, 0, 0])); /*23673*/
			$puti($1.sep, $1.sep.length - 4, $a([0, 0, 0, 0])); /*23674*/
			$k[$j++] = Infinity; /*23677*/
			for (var _m = 19, _l = $1.bot.length - 13; _m <= _l; _m += 98) { /*23676*/
				$k[$j++] = _m; /*23676*/
			} /*23676*/
			for (var _p = 70, _o = $1.bot.length - 13; _p <= _o; _p += 98) { /*23677*/
				$k[$j++] = _p; /*23677*/
			} /*23677*/
			var _q = $a(); /*23677*/
			for (var _r = 0, _s = _q.length; _r < _s; _r++) { /*23678*/
				$k[$j++] = $get(_q, _r); /*23678*/
				if ($1.sepfinder() == $b) return $b; /*23678*/
			} /*23678*/
			$$.rmoveto(0, $1.linheight); /*23679*/
			var _z = {
				ren: $0.renmatrix,
				pixs: $1.sep,
				pixx: $1.sep.length,
				pixy: 1,
				height: 1 / 72,
				width: $1.sep.length / 72,
				opt: $1.options
			}; /*23686*/
			$k[$j++] = _z; /*23687*/
			$0.renmatrix(); /*23687*/
			var _12 = ($get($1.bot, 0) == 0) ? 2 : 0; /*23690*/
			$$.rmoveto(_12, 1); /*23690*/
			$k[$j++] = $1.comp; /*23691*/
			$k[$j++] = $1.options; /*23691*/
			$0["gs1-cc"](); /*23691*/
			$0.renmatrix(); /*23691*/
			$$.restore(); /*23693*/
		};
		$0["gs1-128composite"] = function() {
			var $1 = {}; /*23723*/
			$1.options = $k[--$j]; /*23725*/
			$1.barcode = $k[--$j]; /*23726*/
			$1.dontdraw = false; /*23728*/
			$forall($1.options, function() { /*23739*/
				var _3 = $k[--$j]; /*23739*/
				$1[$k[--$j]] = _3; /*23739*/
			}); /*23739*/
			$search($1.barcode, "|"); /*23742*/
			if ($k[--$j]) { /*23747*/
				$1.linear = $k[--$j]; /*23743*/
				$j--; /*23744*/
				$1.comp = $k[--$j]; /*23745*/
			} else { /*23747*/
				$j--; /*23747*/
			} /*23747*/
			$$.save(); /*23750*/
			$1.options.inkspread = "0"; /*23752*/
			$1.options.dontdraw = true; /*23753*/
			$1.options.linkagea = true; /*23756*/
			$k[$j++] = $1.linear; /*23757*/
			$k[$j++] = Infinity; /*23757*/
			$forall($1.options); /*23757*/
			var _E = $d(); /*23757*/
			$k[$j++] = _E; /*23757*/
			$0["gs1-128"](); /*23757*/
			var _G = $k[--$j].sbs; /*23758*/
			$k[$j++] = 0; /*23758*/
			$forall(_G, function() { /*23758*/
				var _H = $k[--$j]; /*23758*/
				var _I = $k[--$j]; /*23758*/
				$k[$j++] = _I + _H; /*23758*/
			}); /*23758*/
			$1.linwidth = $k[--$j]; /*23758*/
			$1.options.lintype = "gs1-128"; /*23761*/
			$1.options.linwidth = $1.linwidth; /*23762*/
			$k[$j++] = $1.comp; /*23763*/
			$k[$j++] = $1.options; /*23763*/
			$0["gs1-cc"](); /*23763*/
			$1.compsym = $k[--$j]; /*23763*/
			if ($1.compsym.pixx == 99) { /*23764*/
				$k[$j++] = "a"; /*23764*/
			} else { /*23764*/
				$k[$j++] = "c"; /*23764*/
			} /*23764*/
			$1.linktype = $k[--$j]; /*23764*/
			if ($eq($1.linktype, "a")) { /*23772*/
				$1.options.linkagea = true; /*23768*/
				$1.options.linkagec = false; /*23769*/
			} else { /*23772*/
				$1.options.linkagea = false; /*23771*/
				$1.options.linkagec = true; /*23772*/
			} /*23772*/
			$k[$j++] = $1.linear; /*23774*/
			$k[$j++] = Infinity; /*23774*/
			$forall($1.options); /*23774*/
			var _a = $d(); /*23774*/
			$k[$j++] = _a; /*23774*/
			$0["gs1-128"](); /*23774*/
			var _b = $k[--$j]; /*23775*/
			$1.linsbs = _b.sbs; /*23775*/
			$1.linheight = $get(_b.bhs, 0) * 72; /*23776*/
			$k[$j++] = _b; /*23777*/
			$0.renlinear(); /*23777*/
			$k[$j++] = Infinity; /*23780*/
			$k[$j++] = 1; /*23781*/
			$forall($1.linsbs, function() { /*23781*/
				var _g = $k[--$j]; /*23781*/
				var _h = $k[--$j]; /*23781*/
				var _i = (_h == 0) ? 1 : 0; /*23781*/
				$k[$j++] = _h; /*23781*/
				for (var _j = 0, _k = _g; _j < _k; _j++) { /*23781*/
					$k[$j++] = _i /*23781*/
				} /*23781*/
			}); /*23781*/
			$astore($a($counttomark() - 1)); /*23782*/
			$1.sep = $k[--$j]; /*23782*/
			$j -= 2; /*23782*/
			$$.rmoveto(0, $1.linheight); /*23783*/
			var _t = {
				ren: $0.renmatrix,
				pixs: $1.sep,
				pixx: $1.sep.length,
				pixy: 1,
				height: 1 / 72,
				width: $1.sep.length / 72,
				opt: $1.options
			}; /*23790*/
			$k[$j++] = _t; /*23791*/
			$0.renmatrix(); /*23791*/
			if ($eq($1.linktype, "a")) { /*23800*/
				$1.s = ~~(($1.linwidth - 2) / 11); /*23795*/
				$1.p = ~~(($1.s - 9) / 2); /*23796*/
				$k[$j++] = "x"; /*23797*/
				$k[$j++] = ((($1.s - $1.p) - 1) * 11) + 10; /*23797*/
				if ($1.p == 0) { /*23797*/
					var _10 = $k[--$j]; /*23797*/
					$k[$j++] = _10 + 2; /*23797*/
				} /*23797*/
				var _11 = $k[--$j]; /*23797*/
				$1[$k[--$j]] = _11 - 99; /*23797*/
				$$.rmoveto($1.x, 1); /*23798*/
			} else { /*23800*/
				$$.rmoveto(-7, 1); /*23800*/
			} /*23800*/
			$k[$j++] = $1.compsym; /*23803*/
			$0.renmatrix(); /*23803*/
			$$.restore(); /*23805*/
		};
		$0.gs1datamatrix = function() {
			var $1 = {}; /*23833*/
			$1.options = $k[--$j]; /*23835*/
			$1.barcode = $k[--$j]; /*23836*/
			$1.dontdraw = false; /*23838*/
			$forall($1.options, function() { /*23849*/
				var _3 = $k[--$j]; /*23849*/
				$1[$k[--$j]] = _3; /*23849*/
			}); /*23849*/
			$1.expand = function() {
				$1.in = $k[--$j]; /*23853*/
				$1.out = $s($1.in.length); /*23854*/
				$1.j = 0; /*23855*/
				$k[$j++] = $1.in; /*23869*/
				for (;;) { /*23869*/
					$search($k[--$j], "^"); /*23858*/
					if ($k[--$j]) { /*23867*/
						var _B = $k[--$j]; /*23859*/
						$puti($1.out, $1.j, _B); /*23859*/
						$1.j = (_B.length + $1.j) + 1; /*23860*/
						$j--; /*23861*/
						var _F = $k[--$j]; /*23862*/
						$put($1.out, $1.j - 1, ~~$z($geti(_F, 0, 3))); /*23862*/
						$k[$j++] = $geti(_F, 3, _F.length - 3); /*23863*/
					} else { /*23867*/
						var _K = $k[--$j]; /*23865*/
						$puti($1.out, $1.j, _K); /*23865*/
						$1.j = _K.length + $1.j; /*23866*/
						$k[$j++] = $geti($1.out, 0, $1.j); /*23867*/
						break; /*23867*/
					} /*23867*/
				} /*23867*/
			}; /*23870*/
			$1.ais = $a([]); /*23873*/
			$1.vals = $a([]); /*23874*/
			var _T = $1.barcode; /*23875*/
			$k[$j++] = $geti(_T, 1, _T.length - 1); /*23888*/
			for (;;) { /*23888*/
				var _V = $k[--$j]; /*23877*/
				$k[$j++] = _V; /*23877*/
				if ($eq(_V, "")) { /*23877*/
					break; /*23877*/
				} /*23877*/
				$search($k[--$j], ")"); /*23878*/
				$j--; /*23878*/
				var _X = $k[--$j]; /*23879*/
				var _Y = $k[--$j]; /*23879*/
				var _Z = $k[--$j]; /*23880*/
				$k[$j++] = _X; /*23880*/
				$search(_Z, "("); /*23880*/
				if ($k[--$j]) { /*23883*/
					var _b = $k[--$j]; /*23881*/
					var _c = $k[--$j]; /*23881*/
					var _d = $k[--$j]; /*23881*/
					var _e = $k[--$j]; /*23881*/
					$k[$j++] = _d; /*23881*/
					$k[$j++] = _e; /*23881*/
					$k[$j++] = _b; /*23881*/
				} else { /*23883*/
					var _f = $k[--$j]; /*23883*/
					var _g = $k[--$j]; /*23883*/
					$k[$j++] = ""; /*23883*/
					$k[$j++] = _g; /*23883*/
					$k[$j++] = _f; /*23883*/
				} /*23883*/
				$k[$j++] = Infinity; /*23885*/
				$aload($1.ais); /*23885*/
				var _j = $k[$j - 1 - ($counttomark() + 2)]; /*23885*/
				$k[$j++] = _j; /*23885*/
				$1.ais = $a(); /*23885*/
				$k[$j++] = Infinity; /*23886*/
				$aload($1.vals); /*23886*/
				var _n = $k[$j - 1 - ($counttomark() + 1)]; /*23886*/
				$k[$j++] = _n; /*23886*/
				if ($1.expand() == $b) break; /*23886*/
				$1.vals = $a(); /*23886*/
				$j -= 2; /*23887*/
			} /*23887*/
			$j--; /*23889*/
			$1.aifixed = {}; /*23894*/
			$k[$j++] = Infinity; /*23896*/
			for (var _p = 0; _p <= 4; _p += 1) { /*23896*/
				$k[$j++] = _p; /*23896*/
			} /*23896*/
			var _q = $a(); /*23896*/
			for (var _r = 0, _s = _q.length; _r < _s; _r++) { /*23899*/
				var _v = $strcpy($s(2), "00"); /*23898*/
				$put(_v, 1, $get(_q, _r) + 48); /*23898*/
				$put($1.aifixed, _v, _v); /*23898*/
			} /*23898*/
			$k[$j++] = Infinity; /*23904*/
			for (var _x = 11; _x <= 20; _x += 1) { /*23901*/
				$k[$j++] = _x; /*23901*/
			} /*23901*/
			$k[$j++] = 23; /*23903*/
			for (var _y = 31; _y <= 36; _y += 1) { /*23903*/
				$k[$j++] = _y; /*23903*/
			} /*23903*/
			$k[$j++] = 41; /*23904*/
			var _z = $a(); /*23904*/
			for (var _10 = 0, _11 = _z.length; _10 < _11; _10++) { /*23907*/
				var _14 = $cvrs($s(2), $get(_z, _10), 10); /*23906*/
				$put($1.aifixed, _14, _14); /*23906*/
			} /*23906*/
			$1.fnc1 = -1; /*23910*/
			$1.dmtx = $a([$1.fnc1]); /*23911*/
			for (var _1A = 0, _19 = $1.ais.length - 1; _1A <= _19; _1A += 1) { /*23927*/
				$1.i = _1A; /*23913*/
				$1.ai = $get($1.ais, $1.i); /*23914*/
				$1.val = $get($1.vals, $1.i); /*23915*/
				var _1K = $a(($1.dmtx.length + $1.ai.length) + $1.val.length); /*23916*/
				$puti(_1K, 0, $1.dmtx); /*23917*/
				$k[$j++] = _1K; /*23918*/
				$k[$j++] = _1K; /*23918*/
				$k[$j++] = $1.dmtx.length; /*23918*/
				$k[$j++] = $1.ai; /*23918*/
				$k[$j++] = Infinity; /*23918*/
				var _1O = $k[--$j]; /*23918*/
				var _1P = $k[--$j]; /*23918*/
				$k[$j++] = _1O; /*23918*/
				$forall(_1P); /*23918*/
				var _1Q = $a(); /*23918*/
				var _1R = $k[--$j]; /*23918*/
				$puti($k[--$j], _1R, _1Q); /*23918*/
				var _1T = $k[--$j]; /*23919*/
				$k[$j++] = _1T; /*23919*/
				$k[$j++] = _1T; /*23919*/
				$k[$j++] = $1.dmtx.length + $1.ai.length; /*23919*/
				$k[$j++] = $1.val; /*23919*/
				$k[$j++] = Infinity; /*23919*/
				var _1X = $k[--$j]; /*23919*/
				var _1Y = $k[--$j]; /*23919*/
				$k[$j++] = _1X; /*23919*/
				$forall(_1Y); /*23919*/
				var _1Z = $a(); /*23919*/
				var _1a = $k[--$j]; /*23919*/
				$puti($k[--$j], _1a, _1Z); /*23919*/
				$1.dmtx = $k[--$j]; /*23920*/
				var _1i = $get($1.aifixed, $geti($1.ai, 0, 2)) !== undefined; /*23921*/
				if (($1.i != ($1.ais.length - 1)) && (!_1i)) { /*23926*/
					var _1k = $a($1.dmtx.length + 1); /*23922*/
					$puti(_1k, 0, $1.dmtx); /*23923*/
					$put(_1k, $1.dmtx.length, $1.fnc1); /*23924*/
					$1.dmtx = _1k; /*23925*/
				} /*23925*/
			} /*23925*/
			$1.barcode = $s(($1.dmtx.length + 1) * 5); /*23930*/
			$1.i = 0; /*23931*/
			$1.j = 0; /*23931*/
			for (;;) { /*23941*/
				if ($1.i == $1.dmtx.length) { /*23932*/
					break; /*23932*/
				} /*23932*/
				var _1u = $get($1.dmtx, $1.i); /*23933*/
				$k[$j++] = _1u; /*23938*/
				if (_1u == $1.fnc1) { /*23937*/
					$j--; /*23934*/
					$puti($1.barcode, $1.j, "^FNC1"); /*23934*/
					$1.j = $1.j + 4; /*23935*/
				} else { /*23937*/
					$put($1.barcode, $1.j, $k[--$j]); /*23937*/
				} /*23937*/
				$1.i = $1.i + 1; /*23939*/
				$1.j = $1.j + 1; /*23940*/
			} /*23940*/
			$1.barcode = $geti($1.barcode, 0, $1.j); /*23942*/
			$1.options.dontdraw = true; /*23945*/
			$1.options.parsefnc = true; /*23946*/
			$k[$j++] = "args"; /*23947*/
			$k[$j++] = $1.barcode; /*23947*/
			$k[$j++] = $1.options; /*23947*/
			$0.datamatrix(); /*23947*/
			var _2B = $k[--$j]; /*23947*/
			$1[$k[--$j]] = _2B; /*23947*/
			$1.args.opt = $1.options; /*23949*/
			$k[$j++] = $1.args; /*23952*/
			if (!$1.dontdraw) { /*23952*/
				$0.renmatrix(); /*23952*/
			} /*23952*/
		};
		$0.gs1datamatrixrectangular = function() {
			var $1 = {}; /*23980*/
			$1.options = $k[--$j]; /*23982*/
			$1.barcode = $k[--$j]; /*23983*/
			$1.dontdraw = false; /*23985*/
			$forall($1.options, function() { /*23996*/
				var _3 = $k[--$j]; /*23996*/
				$1[$k[--$j]] = _3; /*23996*/
			}); /*23996*/
			$1.expand = function() {
				$1.in = $k[--$j]; /*24000*/
				$1.out = $s($1.in.length); /*24001*/
				$1.j = 0; /*24002*/
				$k[$j++] = $1.in; /*24016*/
				for (;;) { /*24016*/
					$search($k[--$j], "^"); /*24005*/
					if ($k[--$j]) { /*24014*/
						var _B = $k[--$j]; /*24006*/
						$puti($1.out, $1.j, _B); /*24006*/
						$1.j = (_B.length + $1.j) + 1; /*24007*/
						$j--; /*24008*/
						var _F = $k[--$j]; /*24009*/
						$put($1.out, $1.j - 1, ~~$z($geti(_F, 0, 3))); /*24009*/
						$k[$j++] = $geti(_F, 3, _F.length - 3); /*24010*/
					} else { /*24014*/
						var _K = $k[--$j]; /*24012*/
						$puti($1.out, $1.j, _K); /*24012*/
						$1.j = _K.length + $1.j; /*24013*/
						$k[$j++] = $geti($1.out, 0, $1.j); /*24014*/
						break; /*24014*/
					} /*24014*/
				} /*24014*/
			}; /*24017*/
			$1.ais = $a([]); /*24020*/
			$1.vals = $a([]); /*24021*/
			var _T = $1.barcode; /*24022*/
			$k[$j++] = $geti(_T, 1, _T.length - 1); /*24035*/
			for (;;) { /*24035*/
				var _V = $k[--$j]; /*24024*/
				$k[$j++] = _V; /*24024*/
				if ($eq(_V, "")) { /*24024*/
					break; /*24024*/
				} /*24024*/
				$search($k[--$j], ")"); /*24025*/
				$j--; /*24025*/
				var _X = $k[--$j]; /*24026*/
				var _Y = $k[--$j]; /*24026*/
				var _Z = $k[--$j]; /*24027*/
				$k[$j++] = _X; /*24027*/
				$search(_Z, "("); /*24027*/
				if ($k[--$j]) { /*24030*/
					var _b = $k[--$j]; /*24028*/
					var _c = $k[--$j]; /*24028*/
					var _d = $k[--$j]; /*24028*/
					var _e = $k[--$j]; /*24028*/
					$k[$j++] = _d; /*24028*/
					$k[$j++] = _e; /*24028*/
					$k[$j++] = _b; /*24028*/
				} else { /*24030*/
					var _f = $k[--$j]; /*24030*/
					var _g = $k[--$j]; /*24030*/
					$k[$j++] = ""; /*24030*/
					$k[$j++] = _g; /*24030*/
					$k[$j++] = _f; /*24030*/
				} /*24030*/
				$k[$j++] = Infinity; /*24032*/
				$aload($1.ais); /*24032*/
				var _j = $k[$j - 1 - ($counttomark() + 2)]; /*24032*/
				$k[$j++] = _j; /*24032*/
				$1.ais = $a(); /*24032*/
				$k[$j++] = Infinity; /*24033*/
				$aload($1.vals); /*24033*/
				var _n = $k[$j - 1 - ($counttomark() + 1)]; /*24033*/
				$k[$j++] = _n; /*24033*/
				if ($1.expand() == $b) break; /*24033*/
				$1.vals = $a(); /*24033*/
				$j -= 2; /*24034*/
			} /*24034*/
			$j--; /*24036*/
			$1.aifixed = {}; /*24041*/
			$k[$j++] = Infinity; /*24043*/
			for (var _p = 0; _p <= 4; _p += 1) { /*24043*/
				$k[$j++] = _p; /*24043*/
			} /*24043*/
			var _q = $a(); /*24043*/
			for (var _r = 0, _s = _q.length; _r < _s; _r++) { /*24046*/
				var _v = $strcpy($s(2), "00"); /*24045*/
				$put(_v, 1, $get(_q, _r) + 48); /*24045*/
				$put($1.aifixed, _v, _v); /*24045*/
			} /*24045*/
			$k[$j++] = Infinity; /*24051*/
			for (var _x = 11; _x <= 20; _x += 1) { /*24048*/
				$k[$j++] = _x; /*24048*/
			} /*24048*/
			$k[$j++] = 23; /*24050*/
			for (var _y = 31; _y <= 36; _y += 1) { /*24050*/
				$k[$j++] = _y; /*24050*/
			} /*24050*/
			$k[$j++] = 41; /*24051*/
			var _z = $a(); /*24051*/
			for (var _10 = 0, _11 = _z.length; _10 < _11; _10++) { /*24054*/
				var _14 = $cvrs($s(2), $get(_z, _10), 10); /*24053*/
				$put($1.aifixed, _14, _14); /*24053*/
			} /*24053*/
			$1.fnc1 = -1; /*24057*/
			$1.dmtx = $a([$1.fnc1]); /*24058*/
			for (var _1A = 0, _19 = $1.ais.length - 1; _1A <= _19; _1A += 1) { /*24074*/
				$1.i = _1A; /*24060*/
				$1.ai = $get($1.ais, $1.i); /*24061*/
				$1.val = $get($1.vals, $1.i); /*24062*/
				var _1K = $a(($1.dmtx.length + $1.ai.length) + $1.val.length); /*24063*/
				$puti(_1K, 0, $1.dmtx); /*24064*/
				$k[$j++] = _1K; /*24065*/
				$k[$j++] = _1K; /*24065*/
				$k[$j++] = $1.dmtx.length; /*24065*/
				$k[$j++] = $1.ai; /*24065*/
				$k[$j++] = Infinity; /*24065*/
				var _1O = $k[--$j]; /*24065*/
				var _1P = $k[--$j]; /*24065*/
				$k[$j++] = _1O; /*24065*/
				$forall(_1P); /*24065*/
				var _1Q = $a(); /*24065*/
				var _1R = $k[--$j]; /*24065*/
				$puti($k[--$j], _1R, _1Q); /*24065*/
				var _1T = $k[--$j]; /*24066*/
				$k[$j++] = _1T; /*24066*/
				$k[$j++] = _1T; /*24066*/
				$k[$j++] = $1.dmtx.length + $1.ai.length; /*24066*/
				$k[$j++] = $1.val; /*24066*/
				$k[$j++] = Infinity; /*24066*/
				var _1X = $k[--$j]; /*24066*/
				var _1Y = $k[--$j]; /*24066*/
				$k[$j++] = _1X; /*24066*/
				$forall(_1Y); /*24066*/
				var _1Z = $a(); /*24066*/
				var _1a = $k[--$j]; /*24066*/
				$puti($k[--$j], _1a, _1Z); /*24066*/
				$1.dmtx = $k[--$j]; /*24067*/
				var _1i = $get($1.aifixed, $geti($1.ai, 0, 2)) !== undefined; /*24068*/
				if (($1.i != ($1.ais.length - 1)) && (!_1i)) { /*24073*/
					var _1k = $a($1.dmtx.length + 1); /*24069*/
					$puti(_1k, 0, $1.dmtx); /*24070*/
					$put(_1k, $1.dmtx.length, $1.fnc1); /*24071*/
					$1.dmtx = _1k; /*24072*/
				} /*24072*/
			} /*24072*/
			$1.barcode = $s(($1.dmtx.length + 1) * 5); /*24077*/
			$1.i = 0; /*24078*/
			$1.j = 0; /*24078*/
			for (;;) { /*24088*/
				if ($1.i == $1.dmtx.length) { /*24079*/
					break; /*24079*/
				} /*24079*/
				var _1u = $get($1.dmtx, $1.i); /*24080*/
				$k[$j++] = _1u; /*24085*/
				if (_1u == $1.fnc1) { /*24084*/
					$j--; /*24081*/
					$puti($1.barcode, $1.j, "^FNC1"); /*24081*/
					$1.j = $1.j + 4; /*24082*/
				} else { /*24084*/
					$put($1.barcode, $1.j, $k[--$j]); /*24084*/
				} /*24084*/
				$1.i = $1.i + 1; /*24086*/
				$1.j = $1.j + 1; /*24087*/
			} /*24087*/
			$1.barcode = $geti($1.barcode, 0, $1.j); /*24089*/
			$1.options.dontdraw = true; /*24092*/
			$1.options.parsefnc = true; /*24093*/
			$1.options.format = "rectangle"; /*24094*/
			$k[$j++] = "args"; /*24095*/
			$k[$j++] = $1.barcode; /*24095*/
			$k[$j++] = $1.options; /*24095*/
			$0.datamatrix(); /*24095*/
			var _2C = $k[--$j]; /*24095*/
			$1[$k[--$j]] = _2C; /*24095*/
			$1.args.opt = $1.options; /*24097*/
			$k[$j++] = $1.args; /*24100*/
			if (!$1.dontdraw) { /*24100*/
				$0.renmatrix(); /*24100*/
			} /*24100*/
		};
		$0.gs1qrcode = function() {
			var $1 = {}; /*24127*/
			$1.options = $k[--$j]; /*24129*/
			$1.barcode = $k[--$j]; /*24130*/
			$1.dontdraw = false; /*24132*/
			$forall($1.options, function() { /*24143*/
				var _3 = $k[--$j]; /*24143*/
				$1[$k[--$j]] = _3; /*24143*/
			}); /*24143*/
			$1.expand = function() {
				$1.in = $k[--$j]; /*24147*/
				$1.out = $s($1.in.length); /*24148*/
				$1.j = 0; /*24149*/
				$k[$j++] = $1.in; /*24163*/
				for (;;) { /*24163*/
					$search($k[--$j], "^"); /*24152*/
					if ($k[--$j]) { /*24161*/
						var _B = $k[--$j]; /*24153*/
						$puti($1.out, $1.j, _B); /*24153*/
						$1.j = (_B.length + $1.j) + 1; /*24154*/
						$j--; /*24155*/
						var _F = $k[--$j]; /*24156*/
						$put($1.out, $1.j - 1, ~~$z($geti(_F, 0, 3))); /*24156*/
						$k[$j++] = $geti(_F, 3, _F.length - 3); /*24157*/
					} else { /*24161*/
						var _K = $k[--$j]; /*24159*/
						$puti($1.out, $1.j, _K); /*24159*/
						$1.j = _K.length + $1.j; /*24160*/
						$k[$j++] = $geti($1.out, 0, $1.j); /*24161*/
						break; /*24161*/
					} /*24161*/
				} /*24161*/
			}; /*24164*/
			$1.ais = $a([]); /*24167*/
			$1.vals = $a([]); /*24168*/
			var _T = $1.barcode; /*24169*/
			$k[$j++] = $geti(_T, 1, _T.length - 1); /*24182*/
			for (;;) { /*24182*/
				var _V = $k[--$j]; /*24171*/
				$k[$j++] = _V; /*24171*/
				if ($eq(_V, "")) { /*24171*/
					break; /*24171*/
				} /*24171*/
				$search($k[--$j], ")"); /*24172*/
				$j--; /*24172*/
				var _X = $k[--$j]; /*24173*/
				var _Y = $k[--$j]; /*24173*/
				var _Z = $k[--$j]; /*24174*/
				$k[$j++] = _X; /*24174*/
				$search(_Z, "("); /*24174*/
				if ($k[--$j]) { /*24177*/
					var _b = $k[--$j]; /*24175*/
					var _c = $k[--$j]; /*24175*/
					var _d = $k[--$j]; /*24175*/
					var _e = $k[--$j]; /*24175*/
					$k[$j++] = _d; /*24175*/
					$k[$j++] = _e; /*24175*/
					$k[$j++] = _b; /*24175*/
				} else { /*24177*/
					var _f = $k[--$j]; /*24177*/
					var _g = $k[--$j]; /*24177*/
					$k[$j++] = ""; /*24177*/
					$k[$j++] = _g; /*24177*/
					$k[$j++] = _f; /*24177*/
				} /*24177*/
				$k[$j++] = Infinity; /*24179*/
				$aload($1.ais); /*24179*/
				var _j = $k[$j - 1 - ($counttomark() + 2)]; /*24179*/
				$k[$j++] = _j; /*24179*/
				$1.ais = $a(); /*24179*/
				$k[$j++] = Infinity; /*24180*/
				$aload($1.vals); /*24180*/
				var _n = $k[$j - 1 - ($counttomark() + 1)]; /*24180*/
				$k[$j++] = _n; /*24180*/
				if ($1.expand() == $b) break; /*24180*/
				$1.vals = $a(); /*24180*/
				$j -= 2; /*24181*/
			} /*24181*/
			$j--; /*24183*/
			$1.aifixed = {}; /*24188*/
			$k[$j++] = Infinity; /*24190*/
			for (var _p = 0; _p <= 4; _p += 1) { /*24190*/
				$k[$j++] = _p; /*24190*/
			} /*24190*/
			var _q = $a(); /*24190*/
			for (var _r = 0, _s = _q.length; _r < _s; _r++) { /*24193*/
				var _v = $strcpy($s(2), "00"); /*24192*/
				$put(_v, 1, $get(_q, _r) + 48); /*24192*/
				$put($1.aifixed, _v, _v); /*24192*/
			} /*24192*/
			$k[$j++] = Infinity; /*24198*/
			for (var _x = 11; _x <= 20; _x += 1) { /*24195*/
				$k[$j++] = _x; /*24195*/
			} /*24195*/
			$k[$j++] = 23; /*24197*/
			for (var _y = 31; _y <= 36; _y += 1) { /*24197*/
				$k[$j++] = _y; /*24197*/
			} /*24197*/
			$k[$j++] = 41; /*24198*/
			var _z = $a(); /*24198*/
			for (var _10 = 0, _11 = _z.length; _10 < _11; _10++) { /*24201*/
				var _14 = $cvrs($s(2), $get(_z, _10), 10); /*24200*/
				$put($1.aifixed, _14, _14); /*24200*/
			} /*24200*/
			$1.fnc1 = -1; /*24204*/
			$1.qrc = $a([$1.fnc1]); /*24205*/
			for (var _1A = 0, _19 = $1.ais.length - 1; _1A <= _19; _1A += 1) { /*24221*/
				$1.i = _1A; /*24207*/
				$1.ai = $get($1.ais, $1.i); /*24208*/
				$1.val = $get($1.vals, $1.i); /*24209*/
				var _1K = $a(($1.qrc.length + $1.ai.length) + $1.val.length); /*24210*/
				$puti(_1K, 0, $1.qrc); /*24211*/
				$k[$j++] = _1K; /*24212*/
				$k[$j++] = _1K; /*24212*/
				$k[$j++] = $1.qrc.length; /*24212*/
				$k[$j++] = $1.ai; /*24212*/
				$k[$j++] = Infinity; /*24212*/
				var _1O = $k[--$j]; /*24212*/
				var _1P = $k[--$j]; /*24212*/
				$k[$j++] = _1O; /*24212*/
				$forall(_1P); /*24212*/
				var _1Q = $a(); /*24212*/
				var _1R = $k[--$j]; /*24212*/
				$puti($k[--$j], _1R, _1Q); /*24212*/
				var _1T = $k[--$j]; /*24213*/
				$k[$j++] = _1T; /*24213*/
				$k[$j++] = _1T; /*24213*/
				$k[$j++] = $1.qrc.length + $1.ai.length; /*24213*/
				$k[$j++] = $1.val; /*24213*/
				$k[$j++] = Infinity; /*24213*/
				var _1X = $k[--$j]; /*24213*/
				var _1Y = $k[--$j]; /*24213*/
				$k[$j++] = _1X; /*24213*/
				$forall(_1Y); /*24213*/
				var _1Z = $a(); /*24213*/
				var _1a = $k[--$j]; /*24213*/
				$puti($k[--$j], _1a, _1Z); /*24213*/
				$1.qrc = $k[--$j]; /*24214*/
				var _1i = $get($1.aifixed, $geti($1.ai, 0, 2)) !== undefined; /*24215*/
				if (($1.i != ($1.ais.length - 1)) && (!_1i)) { /*24220*/
					var _1k = $a($1.qrc.length + 1); /*24216*/
					$puti(_1k, 0, $1.qrc); /*24217*/
					$put(_1k, $1.qrc.length, $1.fnc1); /*24218*/
					$1.qrc = _1k; /*24219*/
				} /*24219*/
			} /*24219*/
			$1.barcode = $s(($1.qrc.length + 1) * 5); /*24224*/
			$1.i = 0; /*24225*/
			$1.j = 0; /*24225*/
			for (;;) { /*24235*/
				if ($1.i == $1.qrc.length) { /*24226*/
					break; /*24226*/
				} /*24226*/
				var _1u = $get($1.qrc, $1.i); /*24227*/
				$k[$j++] = _1u; /*24232*/
				if (_1u == $1.fnc1) { /*24231*/
					$j--; /*24228*/
					$puti($1.barcode, $1.j, "^FNC1"); /*24228*/
					$1.j = $1.j + 4; /*24229*/
				} else { /*24231*/
					$put($1.barcode, $1.j, $k[--$j]); /*24231*/
				} /*24231*/
				$1.i = $1.i + 1; /*24233*/
				$1.j = $1.j + 1; /*24234*/
			} /*24234*/
			$1.barcode = $geti($1.barcode, 0, $1.j); /*24236*/
			$1.options.dontdraw = true; /*24239*/
			$1.options.parsefnc = true; /*24240*/
			$k[$j++] = "args"; /*24241*/
			$k[$j++] = $1.barcode; /*24241*/
			$k[$j++] = $1.options; /*24241*/
			$0.qrcode(); /*24241*/
			var _2B = $k[--$j]; /*24241*/
			$1[$k[--$j]] = _2B; /*24241*/
			$1.args.opt = $1.options; /*24243*/
			$k[$j++] = $1.args; /*24246*/
			if (!$1.dontdraw) { /*24246*/
				$0.renmatrix(); /*24246*/
			} /*24246*/
		};
		$0.hibccode39 = function() {
			var $1 = {}; /*24274*/
			$1.options = $k[--$j]; /*24276*/
			$1.barcode = $k[--$j]; /*24277*/
			$1.dontdraw = false; /*24279*/
			$1.textfont = "Courier"; /*24280*/
			$1.textsize = 10; /*24281*/
			$1.textyoffset = -8.5; /*24282*/
			$1.textxoffset = 0; /*24283*/
			$1.validatecheck = false; /*24284*/
			$forall($1.options, function() { /*24295*/
				var _3 = $k[--$j]; /*24295*/
				$1[$k[--$j]] = _3; /*24295*/
			}); /*24295*/
			$1.textfont = "" + $1.textfont; /*24297*/
			$1.textsize = +$1.textsize; /*24298*/
			$1.textyoffset = +$1.textyoffset; /*24299*/
			$1.textxoffset = +$1.textxoffset; /*24300*/
			$1.barchars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%"; /*24303*/
			$1.charvals = {}; /*24304*/
			for (var _9 = 0; _9 <= 42; _9 += 1) { /*24305*/
				$put($1.charvals, $geti($1.barchars, _9, 1), _9); /*24305*/
			} /*24305*/
			for (var _F = 0, _E = $1.barcode.length - 1; _F <= _E; _F += 1) { /*24312*/
				var _J = $get($1.charvals, $geti($1.barcode, _F, 1)) !== undefined; /*24309*/
				if (!_J) { /*24311*/
					$k[$j++] = "bwipp.hibccode39badCharacter"; /*24310*/
					$k[$j++] = "HIBC Code 39 must contain only digits, capital letters, spaces and the symbols -.$/+%"; /*24310*/
					$0.raiseerror(); /*24310*/
				} /*24310*/
			} /*24310*/
			$k[$j++] = "barlen"; /*24314*/
			$k[$j++] = $1.barcode.length; /*24314*/
			if ($1.validatecheck) { /*24314*/
				var _M = $k[--$j]; /*24314*/
				$k[$j++] = _M - 1; /*24314*/
			} /*24314*/
			var _N = $k[--$j]; /*24314*/
			$1[$k[--$j]] = _N; /*24314*/
			$1.checksum = 41; /*24316*/
			for (var _R = 0, _Q = $1.barlen - 1; _R <= _Q; _R += 1) { /*24320*/
				$1.checksum = $get($1.charvals, $geti($1.barcode, _R, 1)) + $1.checksum; /*24319*/
			} /*24319*/
			$1.checksum = $1.checksum % 43; /*24321*/
			if ($1.validatecheck) { /*24327*/
				if ($get($1.barcode, $1.barlen) != $get($1.barchars, $1.checksum)) { /*24325*/
					$k[$j++] = "bwipp.hibccode39badCheckDigit"; /*24324*/
					$k[$j++] = "Incorrect HIBC Code 39 check digit provided"; /*24324*/
					$0.raiseerror(); /*24324*/
				} /*24324*/
				$1.barcode = $geti($1.barcode, 0, $1.barlen); /*24326*/
			} /*24326*/
			var _j = $s($1.barlen + 2); /*24329*/
			$puti(_j, 1, $1.barcode); /*24329*/
			$1.barcode = _j; /*24329*/
			$put($1.barcode, 0, 43); /*24330*/
			$put($1.barcode, $1.barlen + 1, $get($1.barchars, $1.checksum)); /*24331*/
			$1.text = $s($1.barlen + 4); /*24333*/
			$put($1.text, 0, 42); /*24334*/
			$puti($1.text, 1, $1.barcode); /*24335*/
			var _10 = $get($1.barcode, $1.barlen + 1); /*24336*/
			$k[$j++] = $1.text; /*24336*/
			$k[$j++] = $1.barlen + 2; /*24336*/
			$k[$j++] = _10; /*24336*/
			if (_10 == 32) { /*24336*/
				$j--; /*24336*/
				$k[$j++] = 95; /*24336*/
			} /*24336*/
			var _11 = $k[--$j]; /*24336*/
			var _12 = $k[--$j]; /*24336*/
			$put($k[--$j], _12, _11); /*24336*/
			$put($1.text, $1.barlen + 3, 42); /*24337*/
			$1.options.dontdraw = true; /*24340*/
			$1.options.includecheck = false; /*24341*/
			$1.options.validatecheck = false; /*24342*/
			$k[$j++] = "args"; /*24343*/
			$k[$j++] = $1.barcode; /*24343*/
			$k[$j++] = $1.options; /*24343*/
			$0.code39(); /*24343*/
			var _1B = $k[--$j]; /*24343*/
			$1[$k[--$j]] = _1B; /*24343*/
			$1.args.txt = $a([$a([$1.text, $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])]); /*24345*/
			$1.args.textxalign = "center"; /*24346*/
			$1.args.opt = $1.options; /*24347*/
			$k[$j++] = $1.args; /*24350*/
			if (!$1.dontdraw) { /*24350*/
				$0.renlinear(); /*24350*/
			} /*24350*/
		};
		$0.hibccode128 = function() {
			var $1 = {}; /*24378*/
			$1.options = $k[--$j]; /*24380*/
			$1.barcode = $k[--$j]; /*24381*/
			$1.dontdraw = false; /*24383*/
			$1.textfont = "Courier"; /*24384*/
			$1.textsize = 10; /*24385*/
			$1.textyoffset = -8.5; /*24386*/
			$1.textxoffset = 0; /*24387*/
			$1.validatecheck = false; /*24388*/
			$forall($1.options, function() { /*24399*/
				var _3 = $k[--$j]; /*24399*/
				$1[$k[--$j]] = _3; /*24399*/
			}); /*24399*/
			$1.textfont = "" + $1.textfont; /*24401*/
			$1.textsize = +$1.textsize; /*24402*/
			$1.textyoffset = +$1.textyoffset; /*24403*/
			$1.textxoffset = +$1.textxoffset; /*24404*/
			$1.barchars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%"; /*24407*/
			$1.charvals = {}; /*24408*/
			for (var _9 = 0; _9 <= 42; _9 += 1) { /*24409*/
				$put($1.charvals, $geti($1.barchars, _9, 1), _9); /*24409*/
			} /*24409*/
			for (var _F = 0, _E = $1.barcode.length - 1; _F <= _E; _F += 1) { /*24416*/
				var _J = $get($1.charvals, $geti($1.barcode, _F, 1)) !== undefined; /*24413*/
				if (!_J) { /*24415*/
					$k[$j++] = "bwipp.hibccode128badCharacter"; /*24414*/
					$k[$j++] = "HIBC Code 128 must contain only digits, capital letters, spaces and the symbols -.$/+%"; /*24414*/
					$0.raiseerror(); /*24414*/
				} /*24414*/
			} /*24414*/
			$k[$j++] = "barlen"; /*24418*/
			$k[$j++] = $1.barcode.length; /*24418*/
			if ($1.validatecheck) { /*24418*/
				var _M = $k[--$j]; /*24418*/
				$k[$j++] = _M - 1; /*24418*/
			} /*24418*/
			var _N = $k[--$j]; /*24418*/
			$1[$k[--$j]] = _N; /*24418*/
			$1.checksum = 41; /*24420*/
			for (var _R = 0, _Q = $1.barlen - 1; _R <= _Q; _R += 1) { /*24424*/
				$1.checksum = $get($1.charvals, $geti($1.barcode, _R, 1)) + $1.checksum; /*24423*/
			} /*24423*/
			$1.checksum = $1.checksum % 43; /*24425*/
			if ($1.validatecheck) { /*24431*/
				if ($get($1.barcode, $1.barlen) != $get($1.barchars, $1.checksum)) { /*24429*/
					$k[$j++] = "bwipp.hibccode128badCheckDigit"; /*24428*/
					$k[$j++] = "Incorrect HIBC Code 128 check digit provided"; /*24428*/
					$0.raiseerror(); /*24428*/
				} /*24428*/
				$1.barcode = $geti($1.barcode, 0, $1.barlen); /*24430*/
			} /*24430*/
			var _j = $s($1.barlen + 2); /*24433*/
			$puti(_j, 1, $1.barcode); /*24433*/
			$1.barcode = _j; /*24433*/
			$put($1.barcode, 0, 43); /*24434*/
			$put($1.barcode, $1.barlen + 1, $get($1.barchars, $1.checksum)); /*24435*/
			$1.text = $s($1.barlen + 4); /*24437*/
			$put($1.text, 0, 42); /*24438*/
			$puti($1.text, 1, $1.barcode); /*24439*/
			var _10 = $get($1.barcode, $1.barlen + 1); /*24440*/
			$k[$j++] = $1.text; /*24440*/
			$k[$j++] = $1.barlen + 2; /*24440*/
			$k[$j++] = _10; /*24440*/
			if (_10 == 32) { /*24440*/
				$j--; /*24440*/
				$k[$j++] = 95; /*24440*/
			} /*24440*/
			var _11 = $k[--$j]; /*24440*/
			var _12 = $k[--$j]; /*24440*/
			$put($k[--$j], _12, _11); /*24440*/
			$put($1.text, $1.barlen + 3, 42); /*24441*/
			$1.options.dontdraw = true; /*24444*/
			$1.options.validatecheck = false; /*24445*/
			$k[$j++] = "args"; /*24446*/
			$k[$j++] = $1.barcode; /*24446*/
			$k[$j++] = $1.options; /*24446*/
			$0.code128(); /*24446*/
			var _1A = $k[--$j]; /*24446*/
			$1[$k[--$j]] = _1A; /*24446*/
			$1.args.txt = $a([$a([$1.text, $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])]); /*24448*/
			$1.args.textxalign = "center"; /*24449*/
			$1.args.opt = $1.options; /*24450*/
			$k[$j++] = $1.args; /*24453*/
			if (!$1.dontdraw) { /*24453*/
				$0.renlinear(); /*24453*/
			} /*24453*/
		};
		$0.hibcdatamatrix = function() {
			var $1 = {}; /*24481*/
			$1.options = $k[--$j]; /*24483*/
			$1.barcode = $k[--$j]; /*24484*/
			$1.dontdraw = false; /*24486*/
			$1.validatecheck = false; /*24487*/
			$forall($1.options, function() { /*24498*/
				var _3 = $k[--$j]; /*24498*/
				$1[$k[--$j]] = _3; /*24498*/
			}); /*24498*/
			$1.barchars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%"; /*24501*/
			$1.charvals = {}; /*24502*/
			for (var _5 = 0; _5 <= 42; _5 += 1) { /*24503*/
				$put($1.charvals, $geti($1.barchars, _5, 1), _5); /*24503*/
			} /*24503*/
			for (var _B = 0, _A = $1.barcode.length - 1; _B <= _A; _B += 1) { /*24510*/
				var _F = $get($1.charvals, $geti($1.barcode, _B, 1)) !== undefined; /*24507*/
				if (!_F) { /*24509*/
					$k[$j++] = "bwipp.hibcdatamatrixBadCharacter"; /*24508*/
					$k[$j++] = "HIBC Data Matrix must contain only digits, capital letters, spaces and the symbols -.$/+%"; /*24508*/
					$0.raiseerror(); /*24508*/
				} /*24508*/
			} /*24508*/
			$k[$j++] = "barlen"; /*24512*/
			$k[$j++] = $1.barcode.length; /*24512*/
			if ($1.validatecheck) { /*24512*/
				var _I = $k[--$j]; /*24512*/
				$k[$j++] = _I - 1; /*24512*/
			} /*24512*/
			var _J = $k[--$j]; /*24512*/
			$1[$k[--$j]] = _J; /*24512*/
			$1.checksum = 41; /*24514*/
			for (var _N = 0, _M = $1.barlen - 1; _N <= _M; _N += 1) { /*24518*/
				$1.checksum = $get($1.charvals, $geti($1.barcode, _N, 1)) + $1.checksum; /*24517*/
			} /*24517*/
			$1.checksum = $1.checksum % 43; /*24519*/
			if ($1.validatecheck) { /*24525*/
				if ($get($1.barcode, $1.barlen) != $get($1.barchars, $1.checksum)) { /*24523*/
					$k[$j++] = "bwipp.hibcdatamatrixBadCheckDigit"; /*24522*/
					$k[$j++] = "Incorrect HIBC Data Matrix check digit provided"; /*24522*/
					$0.raiseerror(); /*24522*/
				} /*24522*/
				$1.barcode = $geti($1.barcode, 0, $1.barlen); /*24524*/
			} /*24524*/
			var _f = $s($1.barlen + 2); /*24527*/
			$puti(_f, 1, $1.barcode); /*24527*/
			$1.barcode = _f; /*24527*/
			$put($1.barcode, 0, 43); /*24528*/
			$put($1.barcode, $1.barlen + 1, $get($1.barchars, $1.checksum)); /*24529*/
			$1.options.dontdraw = true; /*24532*/
			$1.options.validatecheck = false; /*24533*/
			$k[$j++] = "args"; /*24534*/
			$k[$j++] = $1.barcode; /*24534*/
			$k[$j++] = $1.options; /*24534*/
			$0.datamatrix(); /*24534*/
			var _r = $k[--$j]; /*24534*/
			$1[$k[--$j]] = _r; /*24534*/
			$1.args.opt = $1.options; /*24536*/
			$k[$j++] = $1.args; /*24539*/
			if (!$1.dontdraw) { /*24539*/
				$0.renmatrix(); /*24539*/
			} /*24539*/
		};
		$0.hibcdatamatrixrectangular = function() {
			var $1 = {}; /*24567*/
			$1.options = $k[--$j]; /*24569*/
			$1.barcode = $k[--$j]; /*24570*/
			$1.dontdraw = false; /*24572*/
			$1.validatecheck = false; /*24573*/
			$forall($1.options, function() { /*24584*/
				var _3 = $k[--$j]; /*24584*/
				$1[$k[--$j]] = _3; /*24584*/
			}); /*24584*/
			$1.barchars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%"; /*24587*/
			$1.charvals = {}; /*24588*/
			for (var _5 = 0; _5 <= 42; _5 += 1) { /*24589*/
				$put($1.charvals, $geti($1.barchars, _5, 1), _5); /*24589*/
			} /*24589*/
			for (var _B = 0, _A = $1.barcode.length - 1; _B <= _A; _B += 1) { /*24596*/
				var _F = $get($1.charvals, $geti($1.barcode, _B, 1)) !== undefined; /*24593*/
				if (!_F) { /*24595*/
					$k[$j++] = "bwipp.hibcdatamatrixrectangularBadCharacter"; /*24594*/
					$k[$j++] = "HIBC Data Matrix Rectangular must contain only digits, capital letters, spaces and the symbols -.$/+%"; /*24594*/
					$0.raiseerror(); /*24594*/
				} /*24594*/
			} /*24594*/
			$k[$j++] = "barlen"; /*24598*/
			$k[$j++] = $1.barcode.length; /*24598*/
			if ($1.validatecheck) { /*24598*/
				var _I = $k[--$j]; /*24598*/
				$k[$j++] = _I - 1; /*24598*/
			} /*24598*/
			var _J = $k[--$j]; /*24598*/
			$1[$k[--$j]] = _J; /*24598*/
			$1.checksum = 41; /*24600*/
			for (var _N = 0, _M = $1.barlen - 1; _N <= _M; _N += 1) { /*24604*/
				$1.checksum = $get($1.charvals, $geti($1.barcode, _N, 1)) + $1.checksum; /*24603*/
			} /*24603*/
			$1.checksum = $1.checksum % 43; /*24605*/
			if ($1.validatecheck) { /*24611*/
				if ($get($1.barcode, $1.barlen) != $get($1.barchars, $1.checksum)) { /*24609*/
					$k[$j++] = "bwipp.hibcdatamatrixrectangularBadCheckDigit"; /*24608*/
					$k[$j++] = "Incorrect HIBC Data Matrix Rectangular check digit provided"; /*24608*/
					$0.raiseerror(); /*24608*/
				} /*24608*/
				$1.barcode = $geti($1.barcode, 0, $1.barlen); /*24610*/
			} /*24610*/
			var _f = $s($1.barlen + 2); /*24613*/
			$puti(_f, 1, $1.barcode); /*24613*/
			$1.barcode = _f; /*24613*/
			$put($1.barcode, 0, 43); /*24614*/
			$put($1.barcode, $1.barlen + 1, $get($1.barchars, $1.checksum)); /*24615*/
			$1.options.dontdraw = true; /*24618*/
			$1.options.validatecheck = false; /*24619*/
			$1.options.format = "rectangle"; /*24620*/
			$k[$j++] = "args"; /*24621*/
			$k[$j++] = $1.barcode; /*24621*/
			$k[$j++] = $1.options; /*24621*/
			$0.datamatrix(); /*24621*/
			var _s = $k[--$j]; /*24621*/
			$1[$k[--$j]] = _s; /*24621*/
			$1.args.opt = $1.options; /*24623*/
			$k[$j++] = $1.args; /*24626*/
			if (!$1.dontdraw) { /*24626*/
				$0.renmatrix(); /*24626*/
			} /*24626*/
		};
		$0.hibcpdf417 = function() {
			var $1 = {}; /*24654*/
			$1.options = $k[--$j]; /*24656*/
			$1.barcode = $k[--$j]; /*24657*/
			$1.dontdraw = false; /*24659*/
			$1.columns = 2; /*24660*/
			$1.validatecheck = false; /*24661*/
			$forall($1.options, function() { /*24672*/
				var _3 = $k[--$j]; /*24672*/
				$1[$k[--$j]] = _3; /*24672*/
			}); /*24672*/
			$1.columns = ~~$1.columns; /*24674*/
			$1.barchars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%"; /*24677*/
			$1.charvals = {}; /*24678*/
			for (var _6 = 0; _6 <= 42; _6 += 1) { /*24679*/
				$put($1.charvals, $geti($1.barchars, _6, 1), _6); /*24679*/
			} /*24679*/
			for (var _C = 0, _B = $1.barcode.length - 1; _C <= _B; _C += 1) { /*24686*/
				var _G = $get($1.charvals, $geti($1.barcode, _C, 1)) !== undefined; /*24683*/
				if (!_G) { /*24685*/
					$k[$j++] = "bwipp.hibcpdf417BadCharacter"; /*24684*/
					$k[$j++] = "HIBC PDF417 must contain only digits, capital letters, spaces and the symbols -.$/+%"; /*24684*/
					$0.raiseerror(); /*24684*/
				} /*24684*/
			} /*24684*/
			$k[$j++] = "barlen"; /*24688*/
			$k[$j++] = $1.barcode.length; /*24688*/
			if ($1.validatecheck) { /*24688*/
				var _J = $k[--$j]; /*24688*/
				$k[$j++] = _J - 1; /*24688*/
			} /*24688*/
			var _K = $k[--$j]; /*24688*/
			$1[$k[--$j]] = _K; /*24688*/
			$1.checksum = 41; /*24690*/
			for (var _O = 0, _N = $1.barlen - 1; _O <= _N; _O += 1) { /*24694*/
				$1.checksum = $get($1.charvals, $geti($1.barcode, _O, 1)) + $1.checksum; /*24693*/
			} /*24693*/
			$1.checksum = $1.checksum % 43; /*24695*/
			if ($1.validatecheck) { /*24701*/
				if ($get($1.barcode, $1.barlen) != $get($1.barchars, $1.checksum)) { /*24699*/
					$k[$j++] = "bwipp.hibcpdf417BadCheckDigit"; /*24698*/
					$k[$j++] = "Incorrect HIBC PDF417 check digit provided"; /*24698*/
					$0.raiseerror(); /*24698*/
				} /*24698*/
				$1.barcode = $geti($1.barcode, 0, $1.barlen); /*24700*/
			} /*24700*/
			var _g = $s($1.barlen + 2); /*24703*/
			$puti(_g, 1, $1.barcode); /*24703*/
			$1.barcode = _g; /*24703*/
			$put($1.barcode, 0, 43); /*24704*/
			$put($1.barcode, $1.barlen + 1, $get($1.barchars, $1.checksum)); /*24705*/
			$1.options.dontdraw = true; /*24708*/
			$1.options.columns = $1.columns; /*24709*/
			$1.options.validatecheck = false; /*24710*/
			$k[$j++] = "args"; /*24711*/
			$k[$j++] = $1.barcode; /*24711*/
			$k[$j++] = $1.options; /*24711*/
			$0.pdf417(); /*24711*/
			var _u = $k[--$j]; /*24711*/
			$1[$k[--$j]] = _u; /*24711*/
			$1.args.opt = $1.options; /*24713*/
			$k[$j++] = $1.args; /*24716*/
			if (!$1.dontdraw) { /*24716*/
				$0.renmatrix(); /*24716*/
			} /*24716*/
		};
		$0.hibcmicropdf417 = function() {
			var $1 = {}; /*24744*/
			$1.options = $k[--$j]; /*24746*/
			$1.barcode = $k[--$j]; /*24747*/
			$1.dontdraw = false; /*24749*/
			$1.columns = 2; /*24750*/
			$1.validatecheck = false; /*24751*/
			$forall($1.options, function() { /*24762*/
				var _3 = $k[--$j]; /*24762*/
				$1[$k[--$j]] = _3; /*24762*/
			}); /*24762*/
			$1.columns = ~~$1.columns; /*24764*/
			$1.barchars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%"; /*24767*/
			$1.charvals = {}; /*24768*/
			for (var _6 = 0; _6 <= 42; _6 += 1) { /*24769*/
				$put($1.charvals, $geti($1.barchars, _6, 1), _6); /*24769*/
			} /*24769*/
			for (var _C = 0, _B = $1.barcode.length - 1; _C <= _B; _C += 1) { /*24776*/
				var _G = $get($1.charvals, $geti($1.barcode, _C, 1)) !== undefined; /*24773*/
				if (!_G) { /*24775*/
					$k[$j++] = "bwipp.hibcmicropdf417BadCharacter"; /*24774*/
					$k[$j++] = "HIBC MicroPDF417 must contain only digits, capital letters, spaces and the symbols -.$/+%"; /*24774*/
					$0.raiseerror(); /*24774*/
				} /*24774*/
			} /*24774*/
			$k[$j++] = "barlen"; /*24778*/
			$k[$j++] = $1.barcode.length; /*24778*/
			if ($1.validatecheck) { /*24778*/
				var _J = $k[--$j]; /*24778*/
				$k[$j++] = _J - 1; /*24778*/
			} /*24778*/
			var _K = $k[--$j]; /*24778*/
			$1[$k[--$j]] = _K; /*24778*/
			$1.checksum = 41; /*24780*/
			for (var _O = 0, _N = $1.barlen - 1; _O <= _N; _O += 1) { /*24784*/
				$1.checksum = $get($1.charvals, $geti($1.barcode, _O, 1)) + $1.checksum; /*24783*/
			} /*24783*/
			$1.checksum = $1.checksum % 43; /*24785*/
			if ($1.validatecheck) { /*24791*/
				if ($get($1.barcode, $1.barlen) != $get($1.barchars, $1.checksum)) { /*24789*/
					$k[$j++] = "bwipp.hibcmicropdf417BadCheckDigit"; /*24788*/
					$k[$j++] = "Incorrect HIBC MicroPDF417 check digit provided"; /*24788*/
					$0.raiseerror(); /*24788*/
				} /*24788*/
				$1.barcode = $geti($1.barcode, 0, $1.barlen); /*24790*/
			} /*24790*/
			var _g = $s($1.barlen + 2); /*24793*/
			$puti(_g, 1, $1.barcode); /*24793*/
			$1.barcode = _g; /*24793*/
			$put($1.barcode, 0, 43); /*24794*/
			$put($1.barcode, $1.barlen + 1, $get($1.barchars, $1.checksum)); /*24795*/
			$1.options.dontdraw = true; /*24798*/
			$1.options.columns = $1.columns; /*24799*/
			$1.options.validatecheck = false; /*24800*/
			$k[$j++] = "args"; /*24801*/
			$k[$j++] = $1.barcode; /*24801*/
			$k[$j++] = $1.options; /*24801*/
			$0.micropdf417(); /*24801*/
			var _u = $k[--$j]; /*24801*/
			$1[$k[--$j]] = _u; /*24801*/
			$1.args.opt = $1.options; /*24803*/
			$k[$j++] = $1.args; /*24806*/
			if (!$1.dontdraw) { /*24806*/
				$0.renmatrix(); /*24806*/
			} /*24806*/
		};
		$0.hibcqrcode = function() {
			var $1 = {}; /*24834*/
			$1.options = $k[--$j]; /*24836*/
			$1.barcode = $k[--$j]; /*24837*/
			$1.dontdraw = false; /*24839*/
			$1.validatecheck = false; /*24840*/
			$forall($1.options, function() { /*24851*/
				var _3 = $k[--$j]; /*24851*/
				$1[$k[--$j]] = _3; /*24851*/
			}); /*24851*/
			$1.barchars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%"; /*24854*/
			$1.charvals = {}; /*24855*/
			for (var _5 = 0; _5 <= 42; _5 += 1) { /*24856*/
				$put($1.charvals, $geti($1.barchars, _5, 1), _5); /*24856*/
			} /*24856*/
			for (var _B = 0, _A = $1.barcode.length - 1; _B <= _A; _B += 1) { /*24863*/
				var _F = $get($1.charvals, $geti($1.barcode, _B, 1)) !== undefined; /*24860*/
				if (!_F) { /*24862*/
					$k[$j++] = "bwipp.hibcqrcodeBadCharacter"; /*24861*/
					$k[$j++] = "HIBC QR Code must contain only digits, capital letters, spaces and the symbols -.$/+%"; /*24861*/
					$0.raiseerror(); /*24861*/
				} /*24861*/
			} /*24861*/
			$k[$j++] = "barlen"; /*24865*/
			$k[$j++] = $1.barcode.length; /*24865*/
			if ($1.validatecheck) { /*24865*/
				var _I = $k[--$j]; /*24865*/
				$k[$j++] = _I - 1; /*24865*/
			} /*24865*/
			var _J = $k[--$j]; /*24865*/
			$1[$k[--$j]] = _J; /*24865*/
			$1.checksum = 41; /*24867*/
			for (var _N = 0, _M = $1.barlen - 1; _N <= _M; _N += 1) { /*24871*/
				$1.checksum = $get($1.charvals, $geti($1.barcode, _N, 1)) + $1.checksum; /*24870*/
			} /*24870*/
			$1.checksum = $1.checksum % 43; /*24872*/
			if ($1.validatecheck) { /*24878*/
				if ($get($1.barcode, $1.barlen) != $get($1.barchars, $1.checksum)) { /*24876*/
					$k[$j++] = "bwipp.hibcqrcodeBadCheckDigit"; /*24875*/
					$k[$j++] = "Incorrect HIBC QR Code check digit provided"; /*24875*/
					$0.raiseerror(); /*24875*/
				} /*24875*/
				$1.barcode = $geti($1.barcode, 0, $1.barlen); /*24877*/
			} /*24877*/
			var _f = $s($1.barlen + 2); /*24880*/
			$puti(_f, 1, $1.barcode); /*24880*/
			$1.barcode = _f; /*24880*/
			$put($1.barcode, 0, 43); /*24881*/
			$put($1.barcode, $1.barlen + 1, $get($1.barchars, $1.checksum)); /*24882*/
			$1.options.dontdraw = true; /*24885*/
			$1.options.validatecheck = false; /*24886*/
			$k[$j++] = "args"; /*24887*/
			$k[$j++] = $1.barcode; /*24887*/
			$k[$j++] = $1.options; /*24887*/
			$0.qrcode(); /*24887*/
			var _r = $k[--$j]; /*24887*/
			$1[$k[--$j]] = _r; /*24887*/
			$1.args.opt = $1.options; /*24889*/
			$k[$j++] = $1.args; /*24892*/
			if (!$1.dontdraw) { /*24892*/
				$0.renmatrix(); /*24892*/
			} /*24892*/
		};
		$0.hibccodablockf = function() {
			var $1 = {}; /*24920*/
			$1.options = $k[--$j]; /*24922*/
			$1.barcode = $k[--$j]; /*24923*/
			$1.dontdraw = false; /*24925*/
			$1.validatecheck = false; /*24926*/
			$forall($1.options, function() { /*24937*/
				var _3 = $k[--$j]; /*24937*/
				$1[$k[--$j]] = _3; /*24937*/
			}); /*24937*/
			$1.barchars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%"; /*24940*/
			$1.charvals = {}; /*24941*/
			for (var _5 = 0; _5 <= 42; _5 += 1) { /*24942*/
				$put($1.charvals, $geti($1.barchars, _5, 1), _5); /*24942*/
			} /*24942*/
			for (var _B = 0, _A = $1.barcode.length - 1; _B <= _A; _B += 1) { /*24949*/
				var _F = $get($1.charvals, $geti($1.barcode, _B, 1)) !== undefined; /*24946*/
				if (!_F) { /*24948*/
					$k[$j++] = "bwipp.codablockfBadCharacter"; /*24947*/
					$k[$j++] = "HIBC Codablock F must contain only digits, capital letters, spaces and the symbols -.$/+%"; /*24947*/
					$0.raiseerror(); /*24947*/
				} /*24947*/
			} /*24947*/
			$k[$j++] = "barlen"; /*24951*/
			$k[$j++] = $1.barcode.length; /*24951*/
			if ($1.validatecheck) { /*24951*/
				var _I = $k[--$j]; /*24951*/
				$k[$j++] = _I - 1; /*24951*/
			} /*24951*/
			var _J = $k[--$j]; /*24951*/
			$1[$k[--$j]] = _J; /*24951*/
			$1.checksum = 41; /*24953*/
			for (var _N = 0, _M = $1.barlen - 1; _N <= _M; _N += 1) { /*24957*/
				$1.checksum = $get($1.charvals, $geti($1.barcode, _N, 1)) + $1.checksum; /*24956*/
			} /*24956*/
			$1.checksum = $1.checksum % 43; /*24958*/
			if ($1.validatecheck) { /*24964*/
				if ($get($1.barcode, $1.barlen) != $get($1.barchars, $1.checksum)) { /*24962*/
					$k[$j++] = "bwipp.hibccodablockfBadCheckDigit"; /*24961*/
					$k[$j++] = "Incorrect HIBC Codablock F check digit provided"; /*24961*/
					$0.raiseerror(); /*24961*/
				} /*24961*/
				$1.barcode = $geti($1.barcode, 0, $1.barlen); /*24963*/
			} /*24963*/
			var _f = $s($1.barlen + 2); /*24966*/
			$puti(_f, 1, $1.barcode); /*24966*/
			$1.barcode = _f; /*24966*/
			$put($1.barcode, 0, 43); /*24967*/
			$put($1.barcode, $1.barlen + 1, $get($1.barchars, $1.checksum)); /*24968*/
			$1.options.dontdraw = true; /*24971*/
			$1.options.validatecheck = false; /*24972*/
			$k[$j++] = "args"; /*24973*/
			$k[$j++] = $1.barcode; /*24973*/
			$k[$j++] = $1.options; /*24973*/
			$0.codablockf(); /*24973*/
			var _r = $k[--$j]; /*24973*/
			$1[$k[--$j]] = _r; /*24973*/
			$1.args.opt = $1.options; /*24975*/
			$k[$j++] = $1.args; /*24978*/
			if (!$1.dontdraw) { /*24978*/
				$0.renmatrix(); /*24978*/
			} /*24978*/
		};
		$0.hibcazteccode = function() {
			var $1 = {}; /*25006*/
			$1.options = $k[--$j]; /*25008*/
			$1.barcode = $k[--$j]; /*25009*/
			$1.dontdraw = false; /*25011*/
			$1.validatecheck = false; /*25012*/
			$forall($1.options, function() { /*25023*/
				var _3 = $k[--$j]; /*25023*/
				$1[$k[--$j]] = _3; /*25023*/
			}); /*25023*/
			$1.barchars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%"; /*25026*/
			$1.charvals = {}; /*25027*/
			for (var _5 = 0; _5 <= 42; _5 += 1) { /*25028*/
				$put($1.charvals, $geti($1.barchars, _5, 1), _5); /*25028*/
			} /*25028*/
			for (var _B = 0, _A = $1.barcode.length - 1; _B <= _A; _B += 1) { /*25035*/
				var _F = $get($1.charvals, $geti($1.barcode, _B, 1)) !== undefined; /*25032*/
				if (!_F) { /*25034*/
					$k[$j++] = "bwipp.hibcazteccodeBadCharacter"; /*25033*/
					$k[$j++] = "HIBC Aztec Code must contain only digits, capital letters, spaces and the symbols -.$/+%"; /*25033*/
					$0.raiseerror(); /*25033*/
				} /*25033*/
			} /*25033*/
			$k[$j++] = "barlen"; /*25037*/
			$k[$j++] = $1.barcode.length; /*25037*/
			if ($1.validatecheck) { /*25037*/
				var _I = $k[--$j]; /*25037*/
				$k[$j++] = _I - 1; /*25037*/
			} /*25037*/
			var _J = $k[--$j]; /*25037*/
			$1[$k[--$j]] = _J; /*25037*/
			$1.checksum = 41; /*25039*/
			for (var _N = 0, _M = $1.barlen - 1; _N <= _M; _N += 1) { /*25043*/
				$1.checksum = $get($1.charvals, $geti($1.barcode, _N, 1)) + $1.checksum; /*25042*/
			} /*25042*/
			$1.checksum = $1.checksum % 43; /*25044*/
			if ($1.validatecheck) { /*25050*/
				if ($get($1.barcode, $1.barlen) != $get($1.barchars, $1.checksum)) { /*25048*/
					$k[$j++] = "bwipp.hibcazteccodeBadCheckDigit"; /*25047*/
					$k[$j++] = "Incorrect HIBC Aztec Code check digit provided"; /*25047*/
					$0.raiseerror(); /*25047*/
				} /*25047*/
				$1.barcode = $geti($1.barcode, 0, $1.barlen); /*25049*/
			} /*25049*/
			var _f = $s($1.barlen + 2); /*25052*/
			$puti(_f, 1, $1.barcode); /*25052*/
			$1.barcode = _f; /*25052*/
			$put($1.barcode, 0, 43); /*25053*/
			$put($1.barcode, $1.barlen + 1, $get($1.barchars, $1.checksum)); /*25054*/
			$1.options.dontdraw = true; /*25057*/
			$1.options.validatecheck = false; /*25058*/
			$k[$j++] = "args"; /*25059*/
			$k[$j++] = $1.barcode; /*25059*/
			$k[$j++] = $1.options; /*25059*/
			$0.azteccode(); /*25059*/
			var _r = $k[--$j]; /*25059*/
			$1[$k[--$j]] = _r; /*25059*/
			$1.args.opt = $1.options; /*25061*/
			$k[$j++] = $1.args; /*25064*/
			if (!$1.dontdraw) { /*25064*/
				$0.renmatrix(); /*25064*/
			} /*25064*/
		};
		$0.channelcode = function() {
			var $1 = {}; /*25092*/
			$1.options = $k[--$j]; /*25094*/
			$1.barcode = $k[--$j]; /*25095*/
			$1.dontdraw = false; /*25097*/
			$1.shortfinder = false; /*25098*/
			$1.includetext = false; /*25099*/
			$1.includecheck = false; /*25100*/
			$1.height = 1; /*25101*/
			$forall($1.options, function() { /*25112*/
				var _3 = $k[--$j]; /*25112*/
				$1[$k[--$j]] = _3; /*25112*/
			}); /*25112*/
			$1.height = +$1.height; /*25114*/
			if (($1.barcode.length < 2) || ($1.barcode.length > 7)) { /*25119*/
				$k[$j++] = "bwipp.channelcodeBadLength"; /*25118*/
				$k[$j++] = "Channel Code must be 2 to 7 digits"; /*25118*/
				$0.raiseerror(); /*25118*/
			} /*25118*/
			$forall($1.barcode, function() { /*25124*/
				var _9 = $k[--$j]; /*25121*/
				if ((_9 < 48) || (_9 > 57)) { /*25123*/
					$k[$j++] = "bwipp.channelcodeBadCharacter"; /*25122*/
					$k[$j++] = "Channel Code must contain only digits"; /*25122*/
					$0.raiseerror(); /*25122*/
				} /*25122*/
			}); /*25122*/
			if ((~~$z($1.barcode)) > $get($a([26, 292, 3493, 44072, 576688, 7742862]), $1.barcode.length - 2)) { /*25127*/
				$k[$j++] = "bwipp.channelcodeTooBig"; /*25126*/
				$k[$j++] = "The Channel Code value is too big for the number of channels"; /*25126*/
				$0.raiseerror(); /*25126*/
			} /*25126*/
			$1.nextb = function() {
				var _E = $k[--$j]; /*25130*/
				var _N = (($get($1.s, _E) + ($get($1.b, _E - 1) + ($get($1.b, _E - 2) + $get($1.s, _E - 1)))) > 4) ? 1 : 2; /*25135*/
				$k[$j++] = _E; /*25151*/
				$k[$j++] = _N; /*25151*/
				if (_E < ($1.chan + 2)) { /*25149*/
					var _P = $k[--$j]; /*25137*/
					var _Q = $k[--$j]; /*25137*/
					var _R = $k[--$j]; /*25137*/
					$k[$j++] = _R; /*25140*/
					$k[$j++] = _Q; /*25140*/
					$k[$j++] = _P; /*25140*/
					for (var _T = _P, _S = _R; _T <= _S; _T += 1) { /*25140*/
						var _V = $k[--$j]; /*25138*/
						var _W = $k[--$j]; /*25138*/
						$put($1.b, _W, _T); /*25138*/
						var _X = $k[--$j]; /*25139*/
						var _Y = $k[--$j]; /*25139*/
						$k[$j++] = _Y; /*25139*/
						$k[$j++] = _X; /*25139*/
						$k[$j++] = _W; /*25139*/
						$k[$j++] = _V; /*25139*/
						$k[$j++] = (_X - _T) + 1; /*25139*/
						$k[$j++] = _Y; /*25139*/
						$k[$j++] = _W + 1; /*25139*/
						if ($1.nexts() == $b) break; /*25139*/
					} /*25139*/
				} else { /*25149*/
					var _Z = $k[--$j]; /*25142*/
					var _a = $k[--$j]; /*25142*/
					var _b = $k[--$j]; /*25142*/
					$k[$j++] = _b; /*25150*/
					$k[$j++] = _a; /*25150*/
					$k[$j++] = _Z; /*25150*/
					if ($le(_Z, _b)) { /*25150*/
						var _d = $k[--$j]; /*25143*/
						var _e = $k[--$j]; /*25143*/
						var _f = $k[--$j]; /*25143*/
						$put($1.b, _e, _f); /*25143*/
						$k[$j++] = _f; /*25148*/
						$k[$j++] = _e; /*25148*/
						$k[$j++] = _d; /*25148*/
						if ($1.value == $1.target) { /*25148*/
							$k[$j++] = "out"; /*25147*/
							$k[$j++] = Infinity; /*25147*/
							for (var _i = 3; _i <= 10; _i += 1) { /*25146*/
								$k[$j++] = $get($1.s, _i); /*25146*/
								$k[$j++] = $get($1.b, _i); /*25146*/
							} /*25146*/
							var _p = $geti($a(), 0, $1.chan * 2); /*25147*/
							$1[$k[--$j]] = _p; /*25147*/
						} /*25147*/
						$1.value = $1.value + 1; /*25149*/
					} /*25149*/
				} /*25149*/
				$j -= 4; /*25152*/
			}; /*25153*/
			$1.nexts = function() {
				var _s = $k[--$j]; /*25156*/
				$k[$j++] = _s; /*25156*/
				if (_s < ($1.chan + 2)) { /*25156*/
					$k[$j++] = 1; /*25156*/
				} else { /*25156*/
					var _u = $k[--$j]; /*25156*/
					var _v = $k[--$j]; /*25156*/
					$k[$j++] = _v; /*25156*/
					$k[$j++] = _u; /*25156*/
					$k[$j++] = _v; /*25156*/
				} /*25156*/
				var _w = $k[--$j]; /*25156*/
				var _x = $k[--$j]; /*25156*/
				var _y = $k[--$j]; /*25156*/
				$k[$j++] = _y; /*25159*/
				$k[$j++] = _x; /*25159*/
				for (var _10 = _w, _z = _y; _10 <= _z; _10 += 1) { /*25159*/
					var _12 = $k[--$j]; /*25157*/
					$put($1.s, _12, _10); /*25157*/
					var _13 = $k[--$j]; /*25158*/
					var _14 = $k[--$j]; /*25158*/
					$k[$j++] = _14; /*25158*/
					$k[$j++] = _13; /*25158*/
					$k[$j++] = _12; /*25158*/
					$k[$j++] = (_13 - _10) + 1; /*25158*/
					$k[$j++] = _14; /*25158*/
					$k[$j++] = _12; /*25158*/
					if ($1.nextb() == $b) break; /*25158*/
				} /*25158*/
				$j -= 3; /*25160*/
			}; /*25161*/
			$1.encode = function() {
				$1.chan = $k[--$j]; /*25164*/
				$1.target = $k[--$j]; /*25165*/
				$1.value = 0; /*25166*/
				$1.out = -1; /*25167*/
				$1.b = $a([1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0]); /*25168*/
				$1.s = $a([0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0]); /*25169*/
				var _19 = $1.chan; /*25170*/
				$k[$j++] = _19; /*25170*/
				$k[$j++] = _19; /*25170*/
				$k[$j++] = 3; /*25170*/
				if ($1.nexts() == $b) return $b; /*25170*/
				$k[$j++] = $1.out; /*25171*/
			}; /*25172*/
			$1.barlen = $1.barcode.length; /*25174*/
			$k[$j++] = "finder"; /*25177*/
			if ($1.shortfinder) { /*25177*/
				$k[$j++] = $a([1, 1, 1, 1, 1]); /*25177*/
			} else { /*25177*/
				$k[$j++] = $a([1, 1, 1, 1, 1, 1, 1, 1, 1]); /*25177*/
			} /*25177*/
			var _1F = $k[--$j]; /*25177*/
			$1[$k[--$j]] = _1F; /*25177*/
			$k[$j++] = "data"; /*25180*/
			$k[$j++] = ~~$z($1.barcode); /*25180*/
			$k[$j++] = $1.barlen + 1; /*25180*/
			if ($1.encode() == $b) return $b; /*25180*/
			var _1J = $k[--$j]; /*25180*/
			$1[$k[--$j]] = _1J; /*25180*/
			$1.check = $a([]); /*25183*/
			if ($1.includecheck) { /*25199*/
				$1.mod23 = $get($a([$a([]), $a([]), $a([13, 12, 4, 9, 3, 1]), $a([13, 2, 12, 3, 18, 16, 4, 1]), $a([11, 16, 17, 8, 20, 4, 10, 2, 5, 1]), $a([1, 4, 16, 18, 3, 12, 2, 8, 9, 13, 6, 1]), $a([20, 16, 22, 13, 15, 12, 5, 4, 8, 9, 21, 3, 7, 1]), $a([2, 6, 18, 8, 1, 3, 9, 4, 12, 13, 16, 2, 6, 18, 8, 1])]), $1.barlen); /*25193*/
				$k[$j++] = 0; /*25197*/
				for (var _1a = 0, _1Z = $1.data.length - 1; _1a <= _1Z; _1a += 1) { /*25197*/
					var _1f = $k[--$j]; /*25196*/
					$k[$j++] = _1f + (($get($1.data, _1a) - 1) * $get($1.mod23, _1a)); /*25196*/
				} /*25196*/
				var _1g = $k[--$j]; /*25198*/
				$k[$j++] = _1g % 23; /*25198*/
				$k[$j++] = 3; /*25198*/
				if ($1.encode() == $b) return $b; /*25198*/
				$1.check = $k[--$j]; /*25198*/
			} /*25198*/
			$k[$j++] = Infinity; /*25206*/
			$aload($1.finder); /*25203*/
			$aload($1.data); /*25204*/
			$aload($1.check); /*25205*/
			$1.sbs = $a(); /*25206*/
			$1.txt = $a($1.barlen); /*25209*/
			for (var _1q = 0, _1p = $1.barlen - 1; _1q <= _1p; _1q += 1) { /*25213*/
				$1.i = _1q; /*25211*/
				$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), 0, 0, "", 0])); /*25212*/
			} /*25212*/
			$k[$j++] = Infinity; /*25223*/
			$k[$j++] = "ren"; /*25220*/
			$k[$j++] = $0.renlinear; /*25220*/
			$k[$j++] = "sbs"; /*25220*/
			$k[$j++] = $1.sbs; /*25220*/
			$k[$j++] = "bhs"; /*25220*/
			$k[$j++] = Infinity; /*25220*/
			for (var _1z = 0, _20 = ~~(($1.sbs.length + 1) / 2); _1z < _20; _1z++) { /*25219*/
				$k[$j++] = $1.height; /*25219*/
			} /*25219*/
			var _22 = $a(); /*25220*/
			$k[$j++] = _22; /*25221*/
			$k[$j++] = "bbs"; /*25221*/
			$k[$j++] = Infinity; /*25221*/
			for (var _24 = 0, _25 = ~~(($1.sbs.length + 1) / 2); _24 < _25; _24++) { /*25220*/
				$k[$j++] = 0; /*25220*/
			} /*25220*/
			var _26 = $a(); /*25221*/
			$k[$j++] = _26; /*25223*/
			$k[$j++] = "txt"; /*25223*/
			$k[$j++] = $1.txt; /*25223*/
			$k[$j++] = "textxalign"; /*25223*/
			$k[$j++] = "center"; /*25223*/
			$k[$j++] = "opt"; /*25223*/
			$k[$j++] = $1.options; /*25223*/
			var _29 = $d(); /*25223*/
			$k[$j++] = _29; /*25226*/
			if (!$1.dontdraw) { /*25226*/
				$0.renlinear(); /*25226*/
			} /*25226*/
		};
		$0.renlinear = function() {
			if ($0.bwipjs_dontdraw) { /*25248*/
				return; /*25248*/
			} /*25248*/
			var $1 = {}; /*25250*/
			$1.args = $k[--$j]; /*25252*/
			$1.sbs = $a([]); /*25255*/
			$1.bhs = $a([]); /*25256*/
			$1.bbs = $a([]); /*25257*/
			$1.txt = $a([]); /*25258*/
			$1.barcolor = "unset"; /*25259*/
			$1.includetext = false; /*25260*/
			$1.textcolor = "unset"; /*25261*/
			$1.textxalign = "unset"; /*25262*/
			$1.textyalign = "unset"; /*25263*/
			$1.textfont = "Courier"; /*25264*/
			$1.textsize = 10; /*25265*/
			$1.textxoffset = 0; /*25266*/
			$1.textyoffset = 0; /*25267*/
			$1.textgaps = 0; /*25268*/
			$1.alttext = ""; /*25269*/
			$1.bordercolor = "unset"; /*25270*/
			$1.backgroundcolor = "unset"; /*25271*/
			$1.inkspread = 0; /*25272*/
			$1.width = 0; /*25273*/
			$1.barratio = 1; /*25274*/
			$1.spaceratio = 1; /*25275*/
			$1.showborder = false; /*25276*/
			$1.borderleft = 10; /*25277*/
			$1.borderright = 10; /*25278*/
			$1.bordertop = 1; /*25279*/
			$1.borderbottom = 1; /*25280*/
			$1.borderwidth = 0.5; /*25281*/
			$1.guardwhitespace = false; /*25282*/
			$1.guardleftpos = 0; /*25283*/
			$1.guardleftypos = 0; /*25284*/
			$1.guardrightpos = 0; /*25285*/
			$1.guardrightypos = 0; /*25286*/
			$1.guardwidth = 7; /*25287*/
			$1.guardheight = 7; /*25288*/
			$forall($1.args, function() { /*25291*/
				var _7 = $k[--$j]; /*25291*/
				$1[$k[--$j]] = _7; /*25291*/
			}); /*25291*/
			var _9 = $1.opt; /*25292*/
			for (var _A in _9) { /*25292*/
				$1[_A] = _9[_A]; /*25292*/
			} /*25292*/
			$1.barcolor = "" + $1.barcolor; /*25294*/
			$1.textcolor = "" + $1.textcolor; /*25295*/
			$1.textxalign = "" + $1.textxalign; /*25296*/
			$1.textyalign = "" + $1.textyalign; /*25297*/
			$1.textfont = "" + $1.textfont; /*25298*/
			$1.textsize = +$1.textsize; /*25299*/
			$1.textxoffset = +$1.textxoffset; /*25300*/
			$1.textyoffset = +$1.textyoffset; /*25301*/
			$1.textgaps = +$1.textgaps; /*25302*/
			$1.alttext = "" + $1.alttext; /*25303*/
			$1.bordercolor = "" + $1.bordercolor; /*25304*/
			$1.backgroundcolor = "" + $1.backgroundcolor; /*25305*/
			$1.inkspread = +$1.inkspread; /*25306*/
			$1.width = +$1.width; /*25307*/
			$1.barratio = +$1.barratio; /*25308*/
			$1.spaceratio = +$1.spaceratio; /*25309*/
			$1.borderleft = +$1.borderleft; /*25310*/
			$1.borderright = +$1.borderright; /*25311*/
			$1.bordertop = +$1.bordertop; /*25312*/
			$1.borderbottom = +$1.borderbottom; /*25313*/
			$1.borderwidth = +$1.borderwidth; /*25314*/
			$1.guardleftpos = +$1.guardleftpos; /*25315*/
			$1.guardleftypos = +$1.guardleftypos; /*25316*/
			$1.guardrightpos = +$1.guardrightpos; /*25317*/
			$1.guardrightypos = +$1.guardrightypos; /*25318*/
			$1.guardwidth = +$1.guardwidth; /*25319*/
			$1.guardheight = +$1.guardheight; /*25320*/
			$1.bars = $a(~~(($1.sbs.length + 1) / 2)); /*25323*/
			$1.x = 0; /*25324*/
			$1.maxh = 0; /*25324*/
			for (var _h = 0, _g = ((~~(($1.sbs.length + 1) / 2)) * 2) - 2; _h <= _g; _h += 1) { /*25343*/
				$1.i = _h; /*25326*/
				if (($1.i % 2) == 0) { /*25340*/
					$1.d = (($get($1.sbs, $1.i) * $1.barratio) - $1.barratio) + 1; /*25328*/
					if ($get($1.sbs, $1.i) != 0) { /*25337*/
						$1.h = $get($1.bhs, ~~($1.i / 2)) * 72; /*25330*/
						$1.c = ($1.d / 2) + $1.x; /*25331*/
						$1.y = $get($1.bbs, ~~($1.i / 2)) * 72; /*25332*/
						$1.w = $1.d - $1.inkspread; /*25333*/
						$put($1.bars, ~~($1.i / 2), $a([$1.h, $1.c, $1.y, $1.w])); /*25334*/
						if (($1.h + $1.y) > $1.maxh) { /*25335*/
							$1.maxh = $1.h + $1.y; /*25335*/
						} /*25335*/
					} else { /*25337*/
						$put($1.bars, ~~($1.i / 2), -1); /*25337*/
					} /*25337*/
				} else { /*25340*/
					$1.d = (($get($1.sbs, $1.i) * $1.spaceratio) - $1.spaceratio) + 1; /*25340*/
				} /*25340*/
				$1.x = $1.x + $1.d; /*25342*/
			} /*25342*/
			$$.save(); /*25345*/
			var _1M = $$.currpos(); /*25347*/
			$$.translate(_1M.x, _1M.y); /*25347*/
			if ($1.width != 0) { /*25352*/
				$$.scale(($1.width * 72) / $1.x, 1); /*25351*/
			} /*25351*/
			$$.floorscale(); /*25355*/
			$$.newpath(); /*25358*/
			$$.moveto(-$1.borderleft, -$1.borderbottom); /*25359*/
			$$.rlineto(($1.x + $1.borderleft) + $1.borderright, 0); /*25360*/
			$$.rlineto(0, ($1.maxh + $1.borderbottom) + $1.bordertop); /*25361*/
			$$.rlineto(-(($1.x + $1.borderleft) + $1.borderright), 0); /*25362*/
			$$.rlineto(0, -(($1.maxh + $1.borderbottom) + $1.bordertop)); /*25363*/
			$$.closepath(); /*25364*/
			if ($1.showborder) { /*25372*/
				$$.save(); /*25368*/
				if ($ne($1.bordercolor, "unset")) { /*25369*/
					$$.setcolor($1.bordercolor); /*25369*/
				} /*25369*/
				$$.setlinewidth($1.borderwidth); /*25370*/
				$$.stroke(); /*25370*/
				$$.restore(); /*25371*/
			} /*25371*/
			$$.save(); /*25375*/
			if ($ne($1.barcolor, "unset")) { /*25377*/
				$$.setcolor($1.barcolor); /*25377*/
			} /*25377*/
			var _1k = $1.bars; /*25378*/
			for (var _1l = 0, _1m = _1k.length; _1l < _1m; _1l++) { /*25384*/
				var _1n = $get(_1k, _1l); /*25384*/
				$k[$j++] = _1n; /*25383*/
				if (_1n != -1) { /*25382*/
					$aload($k[--$j]); /*25380*/
					$$.newpath(); /*25380*/
					$$.setlinewidth($k[--$j]); /*25380*/
					var _1q = $k[--$j]; /*25380*/
					$$.moveto($k[--$j], _1q); /*25380*/
					$$.rlineto(0, $k[--$j]); /*25380*/
					$$.stroke(); /*25380*/
				} else { /*25382*/
					$j--; /*25382*/
				} /*25382*/
			} /*25382*/
			$$.restore(); /*25385*/
			if ($ne($1.textcolor, "unset")) { /*25388*/
				$$.setcolor($1.textcolor); /*25388*/
			} /*25388*/
			if ($1.includetext) { /*25445*/
				if (($eq($1.textxalign, "unset") && $eq($1.textyalign, "unset")) && $eq($1.alttext, "")) { /*25443*/
					$1.s = 0; /*25391*/
					$1.fn = ""; /*25391*/
					var _1z = $1.txt; /*25392*/
					for (var _20 = 0, _21 = _1z.length; _20 < _21; _20++) { /*25401*/
						$forall($get(_1z, _20)); /*25393*/
						var _23 = $k[--$j]; /*25394*/
						var _24 = $k[--$j]; /*25394*/
						$k[$j++] = _24; /*25399*/
						$k[$j++] = _23; /*25399*/
						if ((_23 != $1.s) || $ne(_24, $1.fn)) { /*25398*/
							var _27 = $k[--$j]; /*25395*/
							var _28 = $k[--$j]; /*25395*/
							$1.s = _27; /*25395*/
							$1.fn = _28; /*25395*/
							var _29 = $$.findfont(_28); /*25396*/
							_29.FontSize = _27; /*25396*/
							$$.setfont(_29); /*25396*/
						} else { /*25398*/
							$j -= 2; /*25398*/
						} /*25398*/
						var _2A = $k[--$j]; /*25400*/
						$$.moveto($k[--$j], _2A); /*25400*/
						$$.show($k[--$j], 0, 0); /*25400*/
					} /*25400*/
				} else { /*25443*/
					var _2E = $$.findfont($1.textfont); /*25403*/
					_2E.FontSize = $1.textsize; /*25403*/
					$$.setfont(_2E); /*25403*/
					if ($eq($1.alttext, "")) { /*25409*/
						$k[$j++] = Infinity; /*25405*/
						var _2H = $1.txt; /*25405*/
						for (var _2I = 0, _2J = _2H.length; _2I < _2J; _2I++) { /*25405*/
							$forall($get($get(_2H, _2I), 0)); /*25405*/
						} /*25405*/
						$1.txt = $a(); /*25405*/
						$1.tstr = $s($1.txt.length); /*25406*/
						for (var _2R = 0, _2Q = $1.txt.length - 1; _2R <= _2Q; _2R += 1) { /*25407*/
							$put($1.tstr, _2R, $get($1.txt, _2R)); /*25407*/
						} /*25407*/
					} else { /*25409*/
						$1.tstr = $1.alttext; /*25409*/
					} /*25409*/
					if ($1.tstr.length == 0) { /*25425*/
						$k[$j++] = 0; /*25414*/
					} else { /*25425*/
						$$.save(); /*25416*/
						$$.newpath(); /*25417*/
						$$.moveto(0, 0); /*25417*/
						$$.charpath("0", false); /*25417*/
						var _2X = $$.pathbbox(); /*25417*/
						$$.restore(); /*25419*/
						var _2Y = $$.currfont(); /*25420*/
						var _2Z = _2Y.PaintType !== undefined; /*25420*/
						$k[$j++] = _2X.ury; /*25420*/
						if (_2Z) { /*25420*/
							var _2a = $$.currfont(); /*25420*/
							$k[$j++] = _2a.PaintType == 2; /*25420*/
						} else { /*25420*/
							$k[$j++] = false; /*25420*/
						} /*25420*/
						var _2c = $$.currfont(); /*25421*/
						var _2d = _2c.StrokeWidth !== undefined; /*25421*/
						if ($k[--$j] && _2d) { /*25426*/
							var _2f = $$.currfont(); /*25422*/
							var _2h = $$.currfont(); /*25423*/
							var _2i = _2h.FontMatrix; /*25423*/
							var _2j = _2f.StrokeWidth / 2; /*25424*/
							var _2k = $k[--$j]; /*25425*/
							$k[$j++] = _2k + (Math.sqrt((_2j * _2j) + (0 * 0))); /*25425*/
						} /*25425*/
					} /*25425*/
					$1.textascent = $k[--$j]; /*25428*/
					var _2n = $$.stringwidth($1.tstr); /*25429*/
					$1.textwidth = _2n.w + (($1.tstr.length - 1) * $1.textgaps); /*25429*/
					$1.textxpos = $1.textxoffset + (($1.x - $1.textwidth) / 2); /*25431*/
					if ($eq($1.textxalign, "left")) { /*25432*/
						$1.textxpos = $1.textxoffset; /*25432*/
					} /*25432*/
					if ($eq($1.textxalign, "right")) { /*25433*/
						$1.textxpos = ($1.x - $1.textxoffset) - $1.textwidth; /*25433*/
					} /*25433*/
					if ($eq($1.textxalign, "offleft")) { /*25434*/
						$1.textxpos = -($1.textwidth + $1.textxoffset); /*25434*/
					} /*25434*/
					if ($eq($1.textxalign, "offright")) { /*25435*/
						$1.textxpos = $1.x + $1.textxoffset; /*25435*/
					} /*25435*/
					if ($eq($1.textxalign, "justify") && ($1.textwidth < $1.x)) { /*25439*/
						$1.textxpos = 0; /*25437*/
						$1.textgaps = ($1.x - $1.textwidth) / ($1.tstr.length - 1); /*25438*/
					} /*25438*/
					$1.textypos = -(($1.textyoffset + $1.textascent) + 1); /*25440*/
					if ($eq($1.textyalign, "above")) { /*25441*/
						$1.textypos = ($1.textyoffset + $1.maxh) + 1; /*25441*/
					} /*25441*/
					if ($eq($1.textyalign, "center")) { /*25442*/
						$1.textypos = $1.textyoffset + (($1.maxh - $1.textascent) / 2); /*25442*/
					} /*25442*/
					$$.moveto($1.textxpos, $1.textypos); /*25443*/
					$$.show($1.tstr, $1.textgaps, 0); /*25443*/
				} /*25443*/
			} /*25443*/
			if ($1.guardwhitespace) { /*25458*/
				var _3P = $$.findfont("OCR-B"); /*25449*/
				_3P.FontSize = ($1.guardheight * 2) - 1; /*25449*/
				$$.setfont(_3P); /*25449*/
				if ($1.guardleftpos != 0) { /*25453*/
					$$.moveto((-$1.guardleftpos) - 1.5, ($1.guardleftypos - ($1.guardheight / 2)) - 1); /*25451*/
					$$.show("<", 0, 0); /*25452*/
				} /*25452*/
				if ($1.guardrightpos != 0) { /*25457*/
					$$.moveto(($1.guardrightpos + $1.x) - $1.guardwidth, ($1.guardrightypos - ($1.guardheight / 2)) - 1); /*25455*/
					$$.show(">", 0, 0); /*25456*/
				} /*25456*/
			} /*25456*/
			$$.restore(); /*25460*/
		};
		$0.renmatrix = function() {
			if ($0.bwipjs_dontdraw) { /*25478*/
				return; /*25478*/
			} /*25478*/
			var $1 = {}; /*25480*/
			$1.args = $k[--$j]; /*25482*/
			$1.width = 1; /*25485*/
			$1.height = 1; /*25486*/
			$1.barcolor = "unset"; /*25487*/
			$1.backgroundcolor = "unset"; /*25488*/
			$1.includetext = false; /*25489*/
			$1.txt = $a([]); /*25490*/
			$1.textcolor = "unset"; /*25491*/
			$1.textxalign = "unset"; /*25492*/
			$1.textyalign = "unset"; /*25493*/
			$1.textfont = "Courier"; /*25494*/
			$1.textsize = 10; /*25495*/
			$1.textxoffset = 0; /*25496*/
			$1.textyoffset = 0; /*25497*/
			$1.textgaps = 0; /*25498*/
			$1.alttext = ""; /*25499*/
			$forall($1.args, function() { /*25502*/
				var _4 = $k[--$j]; /*25502*/
				$1[$k[--$j]] = _4; /*25502*/
			}); /*25502*/
			var _6 = $1.opt; /*25503*/
			for (var _7 in _6) { /*25503*/
				$1[_7] = _6[_7]; /*25503*/
			} /*25503*/
			$1.width = +$1.width; /*25505*/
			$1.height = +$1.height; /*25506*/
			$1.barcolor = "" + $1.barcolor; /*25507*/
			$1.backgroundcolor = "" + $1.backgroundcolor; /*25508*/
			$1.inkspread = +$1.inkspread; /*25509*/
			$1.inkspreadh = +$1.inkspreadh; /*25510*/
			$1.inkspreadv = +$1.inkspreadv; /*25511*/
			$1.textcolor = "" + $1.textcolor; /*25512*/
			$1.textxalign = "" + $1.textxalign; /*25513*/
			$1.textyalign = "" + $1.textyalign; /*25514*/
			$1.textfont = "" + $1.textfont; /*25515*/
			$1.textsize = +$1.textsize; /*25516*/
			$1.textxoffset = +$1.textxoffset; /*25517*/
			$1.textyoffset = +$1.textyoffset; /*25518*/
			$1.textgaps = +$1.textgaps; /*25519*/
			$1.alttext = "" + $1.alttext; /*25520*/
			$1.pixx8 = (~~Math.ceil($1.pixx / 8)) * 8; /*25523*/
			$k[$j++] = Infinity; /*25524*/
			for (var _S = 0, _T = $1.pixx8 * $1.pixy; _S < _T; _S++) { /*25524*/
				$k[$j++] = 0; /*25524*/
			} /*25524*/
			$1.pixs8 = $a(); /*25524*/
			for (var _X = 0, _W = $1.pixy - 1; _X <= _W; _X += 1) { /*25528*/
				$1.i = _X; /*25526*/
				$puti($1.pixs8, $1.pixx8 * $1.i, $geti($1.pixs, $1.pixx * $1.i, $1.pixx)); /*25527*/
			} /*25527*/
			$1.pixs = $1.pixs8; /*25529*/
			$1.imgstr = $s(~~($1.pixs.length / 8)); /*25532*/
			for (var _l = 0, _k = $1.pixs.length - 1; _l <= _k; _l += 1) { /*25536*/
				$1.i = _l; /*25534*/
				var _m = $1.imgstr; /*25535*/
				var _n = $1.i; /*25535*/
				$put(_m, ~~(_n / 8), $get(_m, ~~(_n / 8)) + ((~~(Math.pow(2, 7 - ($1.i % 8)))) * $get($1.pixs, $1.i))); /*25535*/
			} /*25535*/
			$$.save(); /*25539*/
			$$.floorscale(); /*25543*/
			var _t = $$.currpos(); /*25545*/
			$$.translate(_t.x, _t.y); /*25545*/
			$$.scale(72 * $1.width, 72 * $1.height); /*25546*/
			$$.moveto(0.0001, 0.0001); /*25547*/
			$$.lineto(0.9999, 0.0001); /*25547*/
			$$.lineto(0.9999, 0.9999); /*25547*/
			$$.lineto(0.0001, 0.9999); /*25547*/
			$$.closepath(); /*25547*/
			if ($ne($1.barcolor, "unset")) { /*25549*/
				$$.setcolor($1.barcolor); /*25549*/
			} /*25549*/
			$$.imagemask($1.pixx, $1.pixy, $1.imgstr); /*25554*/
			$$.restore(); /*25555*/
			if ($1.includetext) { /*25623*/
				$$.save(); /*25559*/
				$$.floorscale(); /*25563*/
				if ($ne($1.textcolor, "unset")) { /*25565*/
					$$.setcolor($1.textcolor); /*25565*/
				} /*25565*/
				if (($eq($1.textxalign, "unset") && $eq($1.textyalign, "unset")) && $eq($1.alttext, "")) { /*25620*/
					$1.s = 0; /*25567*/
					$1.fn = ""; /*25567*/
					var _17 = $1.txt; /*25568*/
					for (var _18 = 0, _19 = _17.length; _18 < _19; _18++) { /*25578*/
						$forall($get(_17, _18)); /*25569*/
						var _1B = $k[--$j]; /*25570*/
						var _1C = $k[--$j]; /*25570*/
						$k[$j++] = _1C; /*25576*/
						$k[$j++] = _1B; /*25576*/
						if ((_1B != $1.s) || $ne(_1C, $1.fn)) { /*25575*/
							var _1F = $k[--$j]; /*25571*/
							var _1G = $k[--$j]; /*25571*/
							$1.s = _1F; /*25571*/
							$1.fn = _1G; /*25571*/
							var _1H = $$.findfont(_1G); /*25573*/
							_1H.FontSize = _1F; /*25573*/
							$$.setfont(_1H); /*25573*/
						} else { /*25575*/
							$j -= 2; /*25575*/
						} /*25575*/
						var _1I = $k[--$j]; /*25577*/
						$$.moveto($k[--$j], _1I); /*25577*/
						$$.show($k[--$j], 0, 0); /*25577*/
					} /*25577*/
				} else { /*25620*/
					var _1N = $$.findfont($1.textfont); /*25580*/
					_1N.FontSize = $1.textsize; /*25580*/
					$$.setfont(_1N); /*25580*/
					if ($eq($1.alttext, "")) { /*25586*/
						$k[$j++] = Infinity; /*25582*/
						var _1P = $1.txt; /*25582*/
						for (var _1Q = 0, _1R = _1P.length; _1Q < _1R; _1Q++) { /*25582*/
							$forall($get($get(_1P, _1Q), 0)); /*25582*/
						} /*25582*/
						$1.txt = $a(); /*25582*/
						$1.tstr = $s($1.txt.length); /*25583*/
						for (var _1Z = 0, _1Y = $1.txt.length - 1; _1Z <= _1Y; _1Z += 1) { /*25584*/
							$put($1.tstr, _1Z, $get($1.txt, _1Z)); /*25584*/
						} /*25584*/
					} else { /*25586*/
						$1.tstr = $1.alttext; /*25586*/
					} /*25586*/
					if ($1.tstr.length == 0) { /*25602*/
						$k[$j++] = 0; /*25591*/
					} else { /*25602*/
						$$.save(); /*25593*/
						$$.newpath(); /*25594*/
						$$.moveto(0, 0); /*25594*/
						$$.charpath("0", false); /*25594*/
						var _1f = $$.pathbbox(); /*25594*/
						$$.restore(); /*25596*/
						var _1g = $$.currfont(); /*25597*/
						var _1h = _1g.PaintType !== undefined; /*25597*/
						$k[$j++] = _1f.ury; /*25597*/
						if (_1h) { /*25597*/
							var _1i = $$.currfont(); /*25597*/
							$k[$j++] = _1i.PaintType == 2; /*25597*/
						} else { /*25597*/
							$k[$j++] = false; /*25597*/
						} /*25597*/
						var _1k = $$.currfont(); /*25598*/
						var _1l = _1k.StrokeWidth !== undefined; /*25598*/
						if ($k[--$j] && _1l) { /*25603*/
							var _1n = $$.currfont(); /*25599*/
							var _1p = $$.currfont(); /*25600*/
							var _1q = _1p.FontMatrix; /*25600*/
							var _1r = _1n.StrokeWidth / 2; /*25601*/
							var _1s = $k[--$j]; /*25602*/
							$k[$j++] = _1s + (Math.sqrt((_1r * _1r) + (0 * 0))); /*25602*/
						} /*25602*/
					} /*25602*/
					$1.textascent = $k[--$j]; /*25605*/
					var _1v = $$.stringwidth($1.tstr); /*25606*/
					$1.textwidth = _1v.w + (($1.tstr.length - 1) * $1.textgaps); /*25606*/
					$1.textxpos = $1.textxoffset + (($1.pixx - $1.textwidth) / 2); /*25608*/
					if ($eq($1.textxalign, "left")) { /*25609*/
						$1.textxpos = $1.textxoffset; /*25609*/
					} /*25609*/
					if ($eq($1.textxalign, "right")) { /*25610*/
						$1.textxpos = ($1.pixx - $1.textxoffset) - $1.textwidth; /*25610*/
					} /*25610*/
					if ($eq($1.textxalign, "offleft")) { /*25611*/
						$1.textxpos = -($1.textwidth + $1.textxoffset); /*25611*/
					} /*25611*/
					if ($eq($1.textxalign, "offright")) { /*25612*/
						$1.textxpos = $1.pixx + $1.textxoffset; /*25612*/
					} /*25612*/
					if ($eq($1.textxalign, "justify") && ($1.textwidth < $1.pixx)) { /*25616*/
						$1.textxpos = 0; /*25614*/
						$1.textgaps = ($1.pixx - $1.textwidth) / ($1.tstr.length - 1); /*25615*/
					} /*25615*/
					$1.textypos = -(($1.textyoffset + $1.textascent) + 1); /*25617*/
					if ($eq($1.textyalign, "above")) { /*25618*/
						$1.textypos = ($1.textyoffset + $1.pixy) + 1; /*25618*/
					} /*25618*/
					if ($eq($1.textyalign, "center")) { /*25619*/
						$1.textypos = $1.textyoffset + (($1.pixy - $1.textascent) / 2); /*25619*/
					} /*25619*/
					$$.moveto($1.textxpos, $1.textypos); /*25620*/
					$$.show($1.tstr, $1.textgaps, 0); /*25620*/
				} /*25620*/
				$$.restore(); /*25622*/
			} /*25622*/
		};
		$0.renmaximatrix = function() {
			if ($0.bwipjs_dontdraw) { /*25643*/
				return; /*25643*/
			} /*25643*/
			var $1 = {}; /*25645*/
			$1.args = $k[--$j]; /*25647*/
			$1.barcolor = "unset"; /*25650*/
			$1.backgroundcolor = "unset"; /*25651*/
			$forall($1.args, function() { /*25654*/
				var _3 = $k[--$j]; /*25654*/
				$1[$k[--$j]] = _3; /*25654*/
			}); /*25654*/
			var _5 = $1.opt; /*25655*/
			for (var _6 in _5) { /*25655*/
				$1[_6] = _5[_6]; /*25655*/
			} /*25655*/
			$1.barcolor = "" + $1.barcolor; /*25657*/
			$1.backgroundcolor = "" + $1.backgroundcolor; /*25658*/
			$$.save(); /*25660*/
			var _A = $$.currpos(); /*25662*/
			$$.translate(_A.x, _A.y); /*25662*/
			$$.moveto(0, 0); /*25667*/
			$$.lineto(30, 0); /*25667*/
			$$.lineto(30, 29); /*25667*/
			$$.lineto(0, 29); /*25667*/
			$$.closepath(); /*25667*/
			if ($ne($1.barcolor, "unset")) { /*25669*/
				$$.setcolor($1.barcolor); /*25669*/
			} /*25669*/
			var _D = $$.findfont("Symbol"); /*25675*/
			_D.FontSize = 10; /*25675*/
			$$.setfont(_D); /*25675*/
			$1.chars = $a(["0", "1", "2", "3"]); /*25677*/
			$$.newpath(); /*25678*/
			var _F = $1.pixs; /*25679*/
			for (var _G = 0, _H = _F.length; _G < _H; _G++) { /*25690*/
				var _I = $get(_F, _G); /*25690*/
				$1.x = _I % 30; /*25681*/
				$1.y = ~~(_I / 30); /*25682*/
				var _L = (($1.y % 2) == 0) ? 0 : 2; /*25684*/
				var _N = (($1.x % 2) == 0) ? 0 : 1; /*25685*/
				$k[$j++] = $get($1.chars, _L + _N); /*25687*/
				$k[$j++] = $1.x * 3.5; /*25687*/
				if (($1.y % 2) == 1) { /*25687*/
					var _R = $k[--$j]; /*25687*/
					$k[$j++] = _R + 1.75; /*25687*/
				} /*25687*/
				$$.moveto($k[--$j], (32 - $1.y) * 3); /*25689*/
				$$.show($k[--$j], 0, 0); /*25689*/
			} /*25689*/
			var _V = $$.findfont("Symbol"); /*25693*/
			_V.FontSize = 10; /*25693*/
			$$.setfont(_V); /*25693*/
			$$.moveto(36, 35); /*25694*/
			$$.show("4", 0, 0); /*25694*/
			$$.restore(); /*25696*/
		};
		// bwip-js/barcode-ftr.js
		//
		// This code is injected below the cross-compiled barcode.ps.
	
		// The BWIPP symbol is a factory object.  When called, it returns this
		// function, which is a re-usable postscript emulation for BWIPP.
		return function(bwipjs, encoder, text, opts, dontdraw) {
			if (!$0[encoder]) {
				throw new Error('bwipp.unknownEncoder: ' + encoder);
			}
			if (typeof text !== 'string') {
				throw new Error('bwipp.typeError: barcode text not a string (' +
					text + ')');
			}
			opts = opts || {};
			if (typeof opts === 'string') {
				var tmp = opts.split(' ');
				opts = {};
				for (var i = 0; i < tmp.length; i++) {
					if (!tmp[i]) {
						continue;
					}
					var eq = tmp[i].indexOf('=');
					if (eq == -1) {
						opts[tmp[i]] = true;
					} else {
						opts[tmp[i].substr(0, eq)] = tmp[i].substr(eq + 1);
					}
				}
			} else if (typeof opts !== 'object' || opts.constructor !== Object) {
				throw new Error('bwipp.typeError: options not an object');
			}
	
			// Convert utf-16 to utf-8 but leave binary (8-bit) strings untouched.
			if (/[\u0100-\uffff]/.test(text)) {
				text = unescape(encodeURIComponent(text));
			}
	
			// Handle the `parse` option here rather than in BWIPP - eliminates
			// conflict with the parsefnc option and allows removing the parsing
			// code from BWIPP.
			if (opts.parse) {
				text = text.replace(/\^(\d\d\d)/g, function($0, $1) {
					var v = +$1;
					if (v > 255) {
						throw new Error('bwipp.rangeError:' +
							' ^NNN out-of-range (' + $0 + ')');
					}
					return String.fromCharCode(v);
				});
				delete opts.parse;
			}
	
			// Don't draw? (See file runtest)
			$0.bwipjs_dontdraw = dontdraw || false;
	
			// Invoke the encoder
			$$ = bwipjs;
			$k = [text, opts];
			$j = 2;
			$0[encoder]();
	
			// Return what is left on the stack.  This branch should only be taken
			// when running tests with the dontdraw option.
			if ($j) {
				return $k.splice(0, $j);
			}
	
			return true;
		}
	}
	BWIPP.VERSION = '2018-02-04';
	if (typeof module === 'object' && module.exports) {
		module.exports = BWIPP;
	}


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * clipboard.js v2.0.4
	 * https://zenorocha.github.io/clipboard.js
	 * 
	 * Licensed MIT © Zeno Rocha
	 */
	!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.ClipboardJS=e():t.ClipboardJS=e()}(this,function(){return function(n){var o={};function r(t){if(o[t])return o[t].exports;var e=o[t]={i:t,l:!1,exports:{}};return n[t].call(e.exports,e,e.exports,r),e.l=!0,e.exports}return r.m=n,r.c=o,r.d=function(t,e,n){r.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:n})},r.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},r.t=function(e,t){if(1&t&&(e=r(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var n=Object.create(null);if(r.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)r.d(n,o,function(t){return e[t]}.bind(null,o));return n},r.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return r.d(e,"a",e),e},r.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},r.p="",r(r.s=0)}([function(t,e,n){"use strict";var r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},i=function(){function o(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}return function(t,e,n){return e&&o(t.prototype,e),n&&o(t,n),t}}(),a=o(n(1)),c=o(n(3)),u=o(n(4));function o(t){return t&&t.__esModule?t:{default:t}}var l=function(t){function o(t,e){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,o);var n=function(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}(this,(o.__proto__||Object.getPrototypeOf(o)).call(this));return n.resolveOptions(e),n.listenClick(t),n}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(o,c.default),i(o,[{key:"resolveOptions",value:function(){var t=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{};this.action="function"==typeof t.action?t.action:this.defaultAction,this.target="function"==typeof t.target?t.target:this.defaultTarget,this.text="function"==typeof t.text?t.text:this.defaultText,this.container="object"===r(t.container)?t.container:document.body}},{key:"listenClick",value:function(t){var e=this;this.listener=(0,u.default)(t,"click",function(t){return e.onClick(t)})}},{key:"onClick",value:function(t){var e=t.delegateTarget||t.currentTarget;this.clipboardAction&&(this.clipboardAction=null),this.clipboardAction=new a.default({action:this.action(e),target:this.target(e),text:this.text(e),container:this.container,trigger:e,emitter:this})}},{key:"defaultAction",value:function(t){return s("action",t)}},{key:"defaultTarget",value:function(t){var e=s("target",t);if(e)return document.querySelector(e)}},{key:"defaultText",value:function(t){return s("text",t)}},{key:"destroy",value:function(){this.listener.destroy(),this.clipboardAction&&(this.clipboardAction.destroy(),this.clipboardAction=null)}}],[{key:"isSupported",value:function(){var t=0<arguments.length&&void 0!==arguments[0]?arguments[0]:["copy","cut"],e="string"==typeof t?[t]:t,n=!!document.queryCommandSupported;return e.forEach(function(t){n=n&&!!document.queryCommandSupported(t)}),n}}]),o}();function s(t,e){var n="data-clipboard-"+t;if(e.hasAttribute(n))return e.getAttribute(n)}t.exports=l},function(t,e,n){"use strict";var o,r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},i=function(){function o(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}return function(t,e,n){return e&&o(t.prototype,e),n&&o(t,n),t}}(),a=n(2),c=(o=a)&&o.__esModule?o:{default:o};var u=function(){function e(t){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),this.resolveOptions(t),this.initSelection()}return i(e,[{key:"resolveOptions",value:function(){var t=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{};this.action=t.action,this.container=t.container,this.emitter=t.emitter,this.target=t.target,this.text=t.text,this.trigger=t.trigger,this.selectedText=""}},{key:"initSelection",value:function(){this.text?this.selectFake():this.target&&this.selectTarget()}},{key:"selectFake",value:function(){var t=this,e="rtl"==document.documentElement.getAttribute("dir");this.removeFake(),this.fakeHandlerCallback=function(){return t.removeFake()},this.fakeHandler=this.container.addEventListener("click",this.fakeHandlerCallback)||!0,this.fakeElem=document.createElement("textarea"),this.fakeElem.style.fontSize="12pt",this.fakeElem.style.border="0",this.fakeElem.style.padding="0",this.fakeElem.style.margin="0",this.fakeElem.style.position="absolute",this.fakeElem.style[e?"right":"left"]="-9999px";var n=window.pageYOffset||document.documentElement.scrollTop;this.fakeElem.style.top=n+"px",this.fakeElem.setAttribute("readonly",""),this.fakeElem.value=this.text,this.container.appendChild(this.fakeElem),this.selectedText=(0,c.default)(this.fakeElem),this.copyText()}},{key:"removeFake",value:function(){this.fakeHandler&&(this.container.removeEventListener("click",this.fakeHandlerCallback),this.fakeHandler=null,this.fakeHandlerCallback=null),this.fakeElem&&(this.container.removeChild(this.fakeElem),this.fakeElem=null)}},{key:"selectTarget",value:function(){this.selectedText=(0,c.default)(this.target),this.copyText()}},{key:"copyText",value:function(){var e=void 0;try{e=document.execCommand(this.action)}catch(t){e=!1}this.handleResult(e)}},{key:"handleResult",value:function(t){this.emitter.emit(t?"success":"error",{action:this.action,text:this.selectedText,trigger:this.trigger,clearSelection:this.clearSelection.bind(this)})}},{key:"clearSelection",value:function(){this.trigger&&this.trigger.focus(),window.getSelection().removeAllRanges()}},{key:"destroy",value:function(){this.removeFake()}},{key:"action",set:function(){var t=0<arguments.length&&void 0!==arguments[0]?arguments[0]:"copy";if(this._action=t,"copy"!==this._action&&"cut"!==this._action)throw new Error('Invalid "action" value, use either "copy" or "cut"')},get:function(){return this._action}},{key:"target",set:function(t){if(void 0!==t){if(!t||"object"!==(void 0===t?"undefined":r(t))||1!==t.nodeType)throw new Error('Invalid "target" value, use a valid Element');if("copy"===this.action&&t.hasAttribute("disabled"))throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');if("cut"===this.action&&(t.hasAttribute("readonly")||t.hasAttribute("disabled")))throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');this._target=t}},get:function(){return this._target}}]),e}();t.exports=u},function(t,e){t.exports=function(t){var e;if("SELECT"===t.nodeName)t.focus(),e=t.value;else if("INPUT"===t.nodeName||"TEXTAREA"===t.nodeName){var n=t.hasAttribute("readonly");n||t.setAttribute("readonly",""),t.select(),t.setSelectionRange(0,t.value.length),n||t.removeAttribute("readonly"),e=t.value}else{t.hasAttribute("contenteditable")&&t.focus();var o=window.getSelection(),r=document.createRange();r.selectNodeContents(t),o.removeAllRanges(),o.addRange(r),e=o.toString()}return e}},function(t,e){function n(){}n.prototype={on:function(t,e,n){var o=this.e||(this.e={});return(o[t]||(o[t]=[])).push({fn:e,ctx:n}),this},once:function(t,e,n){var o=this;function r(){o.off(t,r),e.apply(n,arguments)}return r._=e,this.on(t,r,n)},emit:function(t){for(var e=[].slice.call(arguments,1),n=((this.e||(this.e={}))[t]||[]).slice(),o=0,r=n.length;o<r;o++)n[o].fn.apply(n[o].ctx,e);return this},off:function(t,e){var n=this.e||(this.e={}),o=n[t],r=[];if(o&&e)for(var i=0,a=o.length;i<a;i++)o[i].fn!==e&&o[i].fn._!==e&&r.push(o[i]);return r.length?n[t]=r:delete n[t],this}},t.exports=n},function(t,e,n){var d=n(5),h=n(6);t.exports=function(t,e,n){if(!t&&!e&&!n)throw new Error("Missing required arguments");if(!d.string(e))throw new TypeError("Second argument must be a String");if(!d.fn(n))throw new TypeError("Third argument must be a Function");if(d.node(t))return s=e,f=n,(l=t).addEventListener(s,f),{destroy:function(){l.removeEventListener(s,f)}};if(d.nodeList(t))return a=t,c=e,u=n,Array.prototype.forEach.call(a,function(t){t.addEventListener(c,u)}),{destroy:function(){Array.prototype.forEach.call(a,function(t){t.removeEventListener(c,u)})}};if(d.string(t))return o=t,r=e,i=n,h(document.body,o,r,i);throw new TypeError("First argument must be a String, HTMLElement, HTMLCollection, or NodeList");var o,r,i,a,c,u,l,s,f}},function(t,n){n.node=function(t){return void 0!==t&&t instanceof HTMLElement&&1===t.nodeType},n.nodeList=function(t){var e=Object.prototype.toString.call(t);return void 0!==t&&("[object NodeList]"===e||"[object HTMLCollection]"===e)&&"length"in t&&(0===t.length||n.node(t[0]))},n.string=function(t){return"string"==typeof t||t instanceof String},n.fn=function(t){return"[object Function]"===Object.prototype.toString.call(t)}},function(t,e,n){var a=n(7);function i(t,e,n,o,r){var i=function(e,n,t,o){return function(t){t.delegateTarget=a(t.target,n),t.delegateTarget&&o.call(e,t)}}.apply(this,arguments);return t.addEventListener(n,i,r),{destroy:function(){t.removeEventListener(n,i,r)}}}t.exports=function(t,e,n,o,r){return"function"==typeof t.addEventListener?i.apply(null,arguments):"function"==typeof n?i.bind(null,document).apply(null,arguments):("string"==typeof t&&(t=document.querySelectorAll(t)),Array.prototype.map.call(t,function(t){return i(t,e,n,o,r)}))}},function(t,e){if("undefined"!=typeof Element&&!Element.prototype.matches){var n=Element.prototype;n.matches=n.matchesSelector||n.mozMatchesSelector||n.msMatchesSelector||n.oMatchesSelector||n.webkitMatchesSelector}t.exports=function(t,e){for(;t&&9!==t.nodeType;){if("function"==typeof t.matches&&t.matches(e))return t;t=t.parentNode}}}])});

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(43);
	__webpack_require__(387);
	module.exports = __webpack_require__(14).Array.from;


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(64);
	__webpack_require__(43);
	module.exports = __webpack_require__(385);


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(64);
	__webpack_require__(43);
	module.exports = __webpack_require__(386);


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(14);
	var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
	module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
	  return $JSON.stringify.apply($JSON, arguments);
	};


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(389);
	module.exports = __webpack_require__(14).Math.sign;


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(390);
	module.exports = __webpack_require__(14).Number.isInteger;


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(391);
	module.exports = __webpack_require__(14).Object.assign;


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(392);
	var $Object = __webpack_require__(14).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(395);
	module.exports = __webpack_require__(14).Object.entries;


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(396);
	module.exports = __webpack_require__(14).Object.values;


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(393);
	__webpack_require__(43);
	__webpack_require__(64);
	__webpack_require__(394);
	__webpack_require__(397);
	__webpack_require__(398);
	module.exports = __webpack_require__(14).Promise;


/***/ }),
/* 360 */
/***/ (function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ }),
/* 361 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(42);
	var toLength = __webpack_require__(61);
	var toAbsoluteIndex = __webpack_require__(382);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(34);
	var createDesc = __webpack_require__(57);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(37);
	var call = __webpack_require__(81);
	var isArrayIter = __webpack_require__(80);
	var anObject = __webpack_require__(25);
	var toLength = __webpack_require__(61);
	var getIterFn = __webpack_require__(63);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(30) && !__webpack_require__(53)(function () {
	  return Object.defineProperty(__webpack_require__(52)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 366 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(32);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(373);
	var descriptor = __webpack_require__(57);
	var setToStringTag = __webpack_require__(58);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(31)(IteratorPrototype, __webpack_require__(19)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 369 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 370 */
/***/ (function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(18);
	var macrotask = __webpack_require__(90).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(40)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(56);
	var gOPS = __webpack_require__(375);
	var pIE = __webpack_require__(84);
	var toObject = __webpack_require__(62);
	var IObject = __webpack_require__(79);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(53)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(25);
	var dPs = __webpack_require__(374);
	var enumBugKeys = __webpack_require__(77);
	var IE_PROTO = __webpack_require__(59)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(52)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(78).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(34);
	var anObject = __webpack_require__(25);
	var getKeys = __webpack_require__(56);
	
	module.exports = __webpack_require__(30) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 375 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(41);
	var toObject = __webpack_require__(62);
	var IE_PROTO = __webpack_require__(59)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(41);
	var toIObject = __webpack_require__(42);
	var arrayIndexOf = __webpack_require__(362)(false);
	var IE_PROTO = __webpack_require__(59)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	var hide = __webpack_require__(31);
	module.exports = function (target, src, safe) {
	  for (var key in src) {
	    if (safe && target[key]) target[key] = src[key];
	    else hide(target, key, src[key]);
	  } return target;
	};


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(31);


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(18);
	var core = __webpack_require__(14);
	var dP = __webpack_require__(34);
	var DESCRIPTORS = __webpack_require__(30);
	var SPECIES = __webpack_require__(19)('species');
	
	module.exports = function (KEY) {
	  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(60);
	var defined = __webpack_require__(51);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(60);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(32);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(18);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(25);
	var get = __webpack_require__(63);
	module.exports = __webpack_require__(14).getIterator = function (it) {
	  var iterFn = get(it);
	  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
	  return anObject(iterFn.call(it));
	};


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(50);
	var ITERATOR = __webpack_require__(19)('iterator');
	var Iterators = __webpack_require__(33);
	module.exports = __webpack_require__(14).isIterable = function (it) {
	  var O = Object(it);
	  return O[ITERATOR] !== undefined
	    || '@@iterator' in O
	    // eslint-disable-next-line no-prototype-builtins
	    || Iterators.hasOwnProperty(classof(O));
	};


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(37);
	var $export = __webpack_require__(20);
	var toObject = __webpack_require__(62);
	var call = __webpack_require__(81);
	var isArrayIter = __webpack_require__(80);
	var toLength = __webpack_require__(61);
	var createProperty = __webpack_require__(363);
	var getIterFn = __webpack_require__(63);
	
	$export($export.S + $export.F * !__webpack_require__(83)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(360);
	var step = __webpack_require__(369);
	var Iterators = __webpack_require__(33);
	var toIObject = __webpack_require__(42);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(82)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(20);
	
	$export($export.S, 'Math', { sign: __webpack_require__(370) });


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(20);
	
	$export($export.S, 'Number', { isInteger: __webpack_require__(367) });


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(20);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(372) });


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(20);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(30), 'Object', { defineProperty: __webpack_require__(34).f });


/***/ }),
/* 393 */
/***/ (function(module, exports) {



/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(54);
	var global = __webpack_require__(18);
	var ctx = __webpack_require__(37);
	var classof = __webpack_require__(50);
	var $export = __webpack_require__(20);
	var isObject = __webpack_require__(32);
	var aFunction = __webpack_require__(39);
	var anInstance = __webpack_require__(361);
	var forOf = __webpack_require__(364);
	var speciesConstructor = __webpack_require__(89);
	var task = __webpack_require__(90).set;
	var microtask = __webpack_require__(371)();
	var newPromiseCapabilityModule = __webpack_require__(55);
	var perform = __webpack_require__(86);
	var userAgent = __webpack_require__(384);
	var promiseResolve = __webpack_require__(87);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(19)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(378)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(58)($Promise, PROMISE);
	__webpack_require__(380)(PROMISE);
	Wrapper = __webpack_require__(14)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(83)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(20);
	var $entries = __webpack_require__(85)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(20);
	var $values = __webpack_require__(85)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(20);
	var core = __webpack_require__(14);
	var global = __webpack_require__(18);
	var speciesConstructor = __webpack_require__(89);
	var promiseResolve = __webpack_require__(87);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(20);
	var newPromiseCapability = __webpack_require__(55);
	var perform = __webpack_require__(86);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	var require;var require;/* WEBPACK VAR INJECTION */(function(global) {/*!
	    localForage -- Offline Storage, Improved
	    Version 1.7.3
	    https://localforage.github.io/localForage
	    (c) 2013-2017 Mozilla, Apache License 2.0
	*/
	(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.localforage = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw (f.code="MODULE_NOT_FOUND", f)}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
	(function (global){
	'use strict';
	var Mutation = global.MutationObserver || global.WebKitMutationObserver;
	
	var scheduleDrain;
	
	{
	  if (Mutation) {
	    var called = 0;
	    var observer = new Mutation(nextTick);
	    var element = global.document.createTextNode('');
	    observer.observe(element, {
	      characterData: true
	    });
	    scheduleDrain = function () {
	      element.data = (called = ++called % 2);
	    };
	  } else if (!global.setImmediate && typeof global.MessageChannel !== 'undefined') {
	    var channel = new global.MessageChannel();
	    channel.port1.onmessage = nextTick;
	    scheduleDrain = function () {
	      channel.port2.postMessage(0);
	    };
	  } else if ('document' in global && 'onreadystatechange' in global.document.createElement('script')) {
	    scheduleDrain = function () {
	
	      // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	      // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	      var scriptEl = global.document.createElement('script');
	      scriptEl.onreadystatechange = function () {
	        nextTick();
	
	        scriptEl.onreadystatechange = null;
	        scriptEl.parentNode.removeChild(scriptEl);
	        scriptEl = null;
	      };
	      global.document.documentElement.appendChild(scriptEl);
	    };
	  } else {
	    scheduleDrain = function () {
	      setTimeout(nextTick, 0);
	    };
	  }
	}
	
	var draining;
	var queue = [];
	//named nextTick for less confusing stack traces
	function nextTick() {
	  draining = true;
	  var i, oldQueue;
	  var len = queue.length;
	  while (len) {
	    oldQueue = queue;
	    queue = [];
	    i = -1;
	    while (++i < len) {
	      oldQueue[i]();
	    }
	    len = queue.length;
	  }
	  draining = false;
	}
	
	module.exports = immediate;
	function immediate(task) {
	  if (queue.push(task) === 1 && !draining) {
	    scheduleDrain();
	  }
	}
	
	}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	},{}],2:[function(_dereq_,module,exports){
	'use strict';
	var immediate = _dereq_(1);
	
	/* istanbul ignore next */
	function INTERNAL() {}
	
	var handlers = {};
	
	var REJECTED = ['REJECTED'];
	var FULFILLED = ['FULFILLED'];
	var PENDING = ['PENDING'];
	
	module.exports = Promise;
	
	function Promise(resolver) {
	  if (typeof resolver !== 'function') {
	    throw new TypeError('resolver must be a function');
	  }
	  this.state = PENDING;
	  this.queue = [];
	  this.outcome = void 0;
	  if (resolver !== INTERNAL) {
	    safelyResolveThenable(this, resolver);
	  }
	}
	
	Promise.prototype["catch"] = function (onRejected) {
	  return this.then(null, onRejected);
	};
	Promise.prototype.then = function (onFulfilled, onRejected) {
	  if (typeof onFulfilled !== 'function' && this.state === FULFILLED ||
	    typeof onRejected !== 'function' && this.state === REJECTED) {
	    return this;
	  }
	  var promise = new this.constructor(INTERNAL);
	  if (this.state !== PENDING) {
	    var resolver = this.state === FULFILLED ? onFulfilled : onRejected;
	    unwrap(promise, resolver, this.outcome);
	  } else {
	    this.queue.push(new QueueItem(promise, onFulfilled, onRejected));
	  }
	
	  return promise;
	};
	function QueueItem(promise, onFulfilled, onRejected) {
	  this.promise = promise;
	  if (typeof onFulfilled === 'function') {
	    this.onFulfilled = onFulfilled;
	    this.callFulfilled = this.otherCallFulfilled;
	  }
	  if (typeof onRejected === 'function') {
	    this.onRejected = onRejected;
	    this.callRejected = this.otherCallRejected;
	  }
	}
	QueueItem.prototype.callFulfilled = function (value) {
	  handlers.resolve(this.promise, value);
	};
	QueueItem.prototype.otherCallFulfilled = function (value) {
	  unwrap(this.promise, this.onFulfilled, value);
	};
	QueueItem.prototype.callRejected = function (value) {
	  handlers.reject(this.promise, value);
	};
	QueueItem.prototype.otherCallRejected = function (value) {
	  unwrap(this.promise, this.onRejected, value);
	};
	
	function unwrap(promise, func, value) {
	  immediate(function () {
	    var returnValue;
	    try {
	      returnValue = func(value);
	    } catch (e) {
	      return handlers.reject(promise, e);
	    }
	    if (returnValue === promise) {
	      handlers.reject(promise, new TypeError('Cannot resolve promise with itself'));
	    } else {
	      handlers.resolve(promise, returnValue);
	    }
	  });
	}
	
	handlers.resolve = function (self, value) {
	  var result = tryCatch(getThen, value);
	  if (result.status === 'error') {
	    return handlers.reject(self, result.value);
	  }
	  var thenable = result.value;
	
	  if (thenable) {
	    safelyResolveThenable(self, thenable);
	  } else {
	    self.state = FULFILLED;
	    self.outcome = value;
	    var i = -1;
	    var len = self.queue.length;
	    while (++i < len) {
	      self.queue[i].callFulfilled(value);
	    }
	  }
	  return self;
	};
	handlers.reject = function (self, error) {
	  self.state = REJECTED;
	  self.outcome = error;
	  var i = -1;
	  var len = self.queue.length;
	  while (++i < len) {
	    self.queue[i].callRejected(error);
	  }
	  return self;
	};
	
	function getThen(obj) {
	  // Make sure we only access the accessor once as required by the spec
	  var then = obj && obj.then;
	  if (obj && (typeof obj === 'object' || typeof obj === 'function') && typeof then === 'function') {
	    return function appyThen() {
	      then.apply(obj, arguments);
	    };
	  }
	}
	
	function safelyResolveThenable(self, thenable) {
	  // Either fulfill, reject or reject with error
	  var called = false;
	  function onError(value) {
	    if (called) {
	      return;
	    }
	    called = true;
	    handlers.reject(self, value);
	  }
	
	  function onSuccess(value) {
	    if (called) {
	      return;
	    }
	    called = true;
	    handlers.resolve(self, value);
	  }
	
	  function tryToUnwrap() {
	    thenable(onSuccess, onError);
	  }
	
	  var result = tryCatch(tryToUnwrap);
	  if (result.status === 'error') {
	    onError(result.value);
	  }
	}
	
	function tryCatch(func, value) {
	  var out = {};
	  try {
	    out.value = func(value);
	    out.status = 'success';
	  } catch (e) {
	    out.status = 'error';
	    out.value = e;
	  }
	  return out;
	}
	
	Promise.resolve = resolve;
	function resolve(value) {
	  if (value instanceof this) {
	    return value;
	  }
	  return handlers.resolve(new this(INTERNAL), value);
	}
	
	Promise.reject = reject;
	function reject(reason) {
	  var promise = new this(INTERNAL);
	  return handlers.reject(promise, reason);
	}
	
	Promise.all = all;
	function all(iterable) {
	  var self = this;
	  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
	    return this.reject(new TypeError('must be an array'));
	  }
	
	  var len = iterable.length;
	  var called = false;
	  if (!len) {
	    return this.resolve([]);
	  }
	
	  var values = new Array(len);
	  var resolved = 0;
	  var i = -1;
	  var promise = new this(INTERNAL);
	
	  while (++i < len) {
	    allResolver(iterable[i], i);
	  }
	  return promise;
	  function allResolver(value, i) {
	    self.resolve(value).then(resolveFromAll, function (error) {
	      if (!called) {
	        called = true;
	        handlers.reject(promise, error);
	      }
	    });
	    function resolveFromAll(outValue) {
	      values[i] = outValue;
	      if (++resolved === len && !called) {
	        called = true;
	        handlers.resolve(promise, values);
	      }
	    }
	  }
	}
	
	Promise.race = race;
	function race(iterable) {
	  var self = this;
	  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
	    return this.reject(new TypeError('must be an array'));
	  }
	
	  var len = iterable.length;
	  var called = false;
	  if (!len) {
	    return this.resolve([]);
	  }
	
	  var i = -1;
	  var promise = new this(INTERNAL);
	
	  while (++i < len) {
	    resolver(iterable[i]);
	  }
	  return promise;
	  function resolver(value) {
	    self.resolve(value).then(function (response) {
	      if (!called) {
	        called = true;
	        handlers.resolve(promise, response);
	      }
	    }, function (error) {
	      if (!called) {
	        called = true;
	        handlers.reject(promise, error);
	      }
	    });
	  }
	}
	
	},{"1":1}],3:[function(_dereq_,module,exports){
	(function (global){
	'use strict';
	if (typeof global.Promise !== 'function') {
	  global.Promise = _dereq_(2);
	}
	
	}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	},{"2":2}],4:[function(_dereq_,module,exports){
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function getIDB() {
	    /* global indexedDB,webkitIndexedDB,mozIndexedDB,OIndexedDB,msIndexedDB */
	    try {
	        if (typeof indexedDB !== 'undefined') {
	            return indexedDB;
	        }
	        if (typeof webkitIndexedDB !== 'undefined') {
	            return webkitIndexedDB;
	        }
	        if (typeof mozIndexedDB !== 'undefined') {
	            return mozIndexedDB;
	        }
	        if (typeof OIndexedDB !== 'undefined') {
	            return OIndexedDB;
	        }
	        if (typeof msIndexedDB !== 'undefined') {
	            return msIndexedDB;
	        }
	    } catch (e) {
	        return;
	    }
	}
	
	var idb = getIDB();
	
	function isIndexedDBValid() {
	    try {
	        // Initialize IndexedDB; fall back to vendor-prefixed versions
	        // if needed.
	        if (!idb) {
	            return false;
	        }
	        // We mimic PouchDB here;
	        //
	        // We test for openDatabase because IE Mobile identifies itself
	        // as Safari. Oh the lulz...
	        var isSafari = typeof openDatabase !== 'undefined' && /(Safari|iPhone|iPad|iPod)/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent) && !/BlackBerry/.test(navigator.platform);
	
	        var hasFetch = typeof fetch === 'function' && fetch.toString().indexOf('[native code') !== -1;
	
	        // Safari <10.1 does not meet our requirements for IDB support (#5572)
	        // since Safari 10.1 shipped with fetch, we can use that to detect it
	        return (!isSafari || hasFetch) && typeof indexedDB !== 'undefined' &&
	        // some outdated implementations of IDB that appear on Samsung
	        // and HTC Android devices <4.4 are missing IDBKeyRange
	        // See: https://github.com/mozilla/localForage/issues/128
	        // See: https://github.com/mozilla/localForage/issues/272
	        typeof IDBKeyRange !== 'undefined';
	    } catch (e) {
	        return false;
	    }
	}
	
	// Abstracts constructing a Blob object, so it also works in older
	// browsers that don't support the native Blob constructor. (i.e.
	// old QtWebKit versions, at least).
	// Abstracts constructing a Blob object, so it also works in older
	// browsers that don't support the native Blob constructor. (i.e.
	// old QtWebKit versions, at least).
	function createBlob(parts, properties) {
	    /* global BlobBuilder,MSBlobBuilder,MozBlobBuilder,WebKitBlobBuilder */
	    parts = parts || [];
	    properties = properties || {};
	    try {
	        return new Blob(parts, properties);
	    } catch (e) {
	        if (e.name !== 'TypeError') {
	            throw e;
	        }
	        var Builder = typeof BlobBuilder !== 'undefined' ? BlobBuilder : typeof MSBlobBuilder !== 'undefined' ? MSBlobBuilder : typeof MozBlobBuilder !== 'undefined' ? MozBlobBuilder : WebKitBlobBuilder;
	        var builder = new Builder();
	        for (var i = 0; i < parts.length; i += 1) {
	            builder.append(parts[i]);
	        }
	        return builder.getBlob(properties.type);
	    }
	}
	
	// This is CommonJS because lie is an external dependency, so Rollup
	// can just ignore it.
	if (typeof Promise === 'undefined') {
	    // In the "nopromises" build this will just throw if you don't have
	    // a global promise object, but it would throw anyway later.
	    _dereq_(3);
	}
	var Promise$1 = Promise;
	
	function executeCallback(promise, callback) {
	    if (callback) {
	        promise.then(function (result) {
	            callback(null, result);
	        }, function (error) {
	            callback(error);
	        });
	    }
	}
	
	function executeTwoCallbacks(promise, callback, errorCallback) {
	    if (typeof callback === 'function') {
	        promise.then(callback);
	    }
	
	    if (typeof errorCallback === 'function') {
	        promise["catch"](errorCallback);
	    }
	}
	
	function normalizeKey(key) {
	    // Cast the key to a string, as that's all we can set as a key.
	    if (typeof key !== 'string') {
	        console.warn(key + ' used as a key, but it is not a string.');
	        key = String(key);
	    }
	
	    return key;
	}
	
	function getCallback() {
	    if (arguments.length && typeof arguments[arguments.length - 1] === 'function') {
	        return arguments[arguments.length - 1];
	    }
	}
	
	// Some code originally from async_storage.js in
	// [Gaia](https://github.com/mozilla-b2g/gaia).
	
	var DETECT_BLOB_SUPPORT_STORE = 'local-forage-detect-blob-support';
	var supportsBlobs = void 0;
	var dbContexts = {};
	var toString = Object.prototype.toString;
	
	// Transaction Modes
	var READ_ONLY = 'readonly';
	var READ_WRITE = 'readwrite';
	
	// Transform a binary string to an array buffer, because otherwise
	// weird stuff happens when you try to work with the binary string directly.
	// It is known.
	// From http://stackoverflow.com/questions/14967647/ (continues on next line)
	// encode-decode-image-with-base64-breaks-image (2013-04-21)
	function _binStringToArrayBuffer(bin) {
	    var length = bin.length;
	    var buf = new ArrayBuffer(length);
	    var arr = new Uint8Array(buf);
	    for (var i = 0; i < length; i++) {
	        arr[i] = bin.charCodeAt(i);
	    }
	    return buf;
	}
	
	//
	// Blobs are not supported in all versions of IndexedDB, notably
	// Chrome <37 and Android <5. In those versions, storing a blob will throw.
	//
	// Various other blob bugs exist in Chrome v37-42 (inclusive).
	// Detecting them is expensive and confusing to users, and Chrome 37-42
	// is at very low usage worldwide, so we do a hacky userAgent check instead.
	//
	// content-type bug: https://code.google.com/p/chromium/issues/detail?id=408120
	// 404 bug: https://code.google.com/p/chromium/issues/detail?id=447916
	// FileReader bug: https://code.google.com/p/chromium/issues/detail?id=447836
	//
	// Code borrowed from PouchDB. See:
	// https://github.com/pouchdb/pouchdb/blob/master/packages/node_modules/pouchdb-adapter-idb/src/blobSupport.js
	//
	function _checkBlobSupportWithoutCaching(idb) {
	    return new Promise$1(function (resolve) {
	        var txn = idb.transaction(DETECT_BLOB_SUPPORT_STORE, READ_WRITE);
	        var blob = createBlob(['']);
	        txn.objectStore(DETECT_BLOB_SUPPORT_STORE).put(blob, 'key');
	
	        txn.onabort = function (e) {
	            // If the transaction aborts now its due to not being able to
	            // write to the database, likely due to the disk being full
	            e.preventDefault();
	            e.stopPropagation();
	            resolve(false);
	        };
	
	        txn.oncomplete = function () {
	            var matchedChrome = navigator.userAgent.match(/Chrome\/(\d+)/);
	            var matchedEdge = navigator.userAgent.match(/Edge\//);
	            // MS Edge pretends to be Chrome 42:
	            // https://msdn.microsoft.com/en-us/library/hh869301%28v=vs.85%29.aspx
	            resolve(matchedEdge || !matchedChrome || parseInt(matchedChrome[1], 10) >= 43);
	        };
	    })["catch"](function () {
	        return false; // error, so assume unsupported
	    });
	}
	
	function _checkBlobSupport(idb) {
	    if (typeof supportsBlobs === 'boolean') {
	        return Promise$1.resolve(supportsBlobs);
	    }
	    return _checkBlobSupportWithoutCaching(idb).then(function (value) {
	        supportsBlobs = value;
	        return supportsBlobs;
	    });
	}
	
	function _deferReadiness(dbInfo) {
	    var dbContext = dbContexts[dbInfo.name];
	
	    // Create a deferred object representing the current database operation.
	    var deferredOperation = {};
	
	    deferredOperation.promise = new Promise$1(function (resolve, reject) {
	        deferredOperation.resolve = resolve;
	        deferredOperation.reject = reject;
	    });
	
	    // Enqueue the deferred operation.
	    dbContext.deferredOperations.push(deferredOperation);
	
	    // Chain its promise to the database readiness.
	    if (!dbContext.dbReady) {
	        dbContext.dbReady = deferredOperation.promise;
	    } else {
	        dbContext.dbReady = dbContext.dbReady.then(function () {
	            return deferredOperation.promise;
	        });
	    }
	}
	
	function _advanceReadiness(dbInfo) {
	    var dbContext = dbContexts[dbInfo.name];
	
	    // Dequeue a deferred operation.
	    var deferredOperation = dbContext.deferredOperations.pop();
	
	    // Resolve its promise (which is part of the database readiness
	    // chain of promises).
	    if (deferredOperation) {
	        deferredOperation.resolve();
	        return deferredOperation.promise;
	    }
	}
	
	function _rejectReadiness(dbInfo, err) {
	    var dbContext = dbContexts[dbInfo.name];
	
	    // Dequeue a deferred operation.
	    var deferredOperation = dbContext.deferredOperations.pop();
	
	    // Reject its promise (which is part of the database readiness
	    // chain of promises).
	    if (deferredOperation) {
	        deferredOperation.reject(err);
	        return deferredOperation.promise;
	    }
	}
	
	function _getConnection(dbInfo, upgradeNeeded) {
	    return new Promise$1(function (resolve, reject) {
	        dbContexts[dbInfo.name] = dbContexts[dbInfo.name] || createDbContext();
	
	        if (dbInfo.db) {
	            if (upgradeNeeded) {
	                _deferReadiness(dbInfo);
	                dbInfo.db.close();
	            } else {
	                return resolve(dbInfo.db);
	            }
	        }
	
	        var dbArgs = [dbInfo.name];
	
	        if (upgradeNeeded) {
	            dbArgs.push(dbInfo.version);
	        }
	
	        var openreq = idb.open.apply(idb, dbArgs);
	
	        if (upgradeNeeded) {
	            openreq.onupgradeneeded = function (e) {
	                var db = openreq.result;
	                try {
	                    db.createObjectStore(dbInfo.storeName);
	                    if (e.oldVersion <= 1) {
	                        // Added when support for blob shims was added
	                        db.createObjectStore(DETECT_BLOB_SUPPORT_STORE);
	                    }
	                } catch (ex) {
	                    if (ex.name === 'ConstraintError') {
	                        console.warn('The database "' + dbInfo.name + '"' + ' has been upgraded from version ' + e.oldVersion + ' to version ' + e.newVersion + ', but the storage "' + dbInfo.storeName + '" already exists.');
	                    } else {
	                        throw ex;
	                    }
	                }
	            };
	        }
	
	        openreq.onerror = function (e) {
	            e.preventDefault();
	            reject(openreq.error);
	        };
	
	        openreq.onsuccess = function () {
	            resolve(openreq.result);
	            _advanceReadiness(dbInfo);
	        };
	    });
	}
	
	function _getOriginalConnection(dbInfo) {
	    return _getConnection(dbInfo, false);
	}
	
	function _getUpgradedConnection(dbInfo) {
	    return _getConnection(dbInfo, true);
	}
	
	function _isUpgradeNeeded(dbInfo, defaultVersion) {
	    if (!dbInfo.db) {
	        return true;
	    }
	
	    var isNewStore = !dbInfo.db.objectStoreNames.contains(dbInfo.storeName);
	    var isDowngrade = dbInfo.version < dbInfo.db.version;
	    var isUpgrade = dbInfo.version > dbInfo.db.version;
	
	    if (isDowngrade) {
	        // If the version is not the default one
	        // then warn for impossible downgrade.
	        if (dbInfo.version !== defaultVersion) {
	            console.warn('The database "' + dbInfo.name + '"' + " can't be downgraded from version " + dbInfo.db.version + ' to version ' + dbInfo.version + '.');
	        }
	        // Align the versions to prevent errors.
	        dbInfo.version = dbInfo.db.version;
	    }
	
	    if (isUpgrade || isNewStore) {
	        // If the store is new then increment the version (if needed).
	        // This will trigger an "upgradeneeded" event which is required
	        // for creating a store.
	        if (isNewStore) {
	            var incVersion = dbInfo.db.version + 1;
	            if (incVersion > dbInfo.version) {
	                dbInfo.version = incVersion;
	            }
	        }
	
	        return true;
	    }
	
	    return false;
	}
	
	// encode a blob for indexeddb engines that don't support blobs
	function _encodeBlob(blob) {
	    return new Promise$1(function (resolve, reject) {
	        var reader = new FileReader();
	        reader.onerror = reject;
	        reader.onloadend = function (e) {
	            var base64 = btoa(e.target.result || '');
	            resolve({
	                __local_forage_encoded_blob: true,
	                data: base64,
	                type: blob.type
	            });
	        };
	        reader.readAsBinaryString(blob);
	    });
	}
	
	// decode an encoded blob
	function _decodeBlob(encodedBlob) {
	    var arrayBuff = _binStringToArrayBuffer(atob(encodedBlob.data));
	    return createBlob([arrayBuff], { type: encodedBlob.type });
	}
	
	// is this one of our fancy encoded blobs?
	function _isEncodedBlob(value) {
	    return value && value.__local_forage_encoded_blob;
	}
	
	// Specialize the default `ready()` function by making it dependent
	// on the current database operations. Thus, the driver will be actually
	// ready when it's been initialized (default) *and* there are no pending
	// operations on the database (initiated by some other instances).
	function _fullyReady(callback) {
	    var self = this;
	
	    var promise = self._initReady().then(function () {
	        var dbContext = dbContexts[self._dbInfo.name];
	
	        if (dbContext && dbContext.dbReady) {
	            return dbContext.dbReady;
	        }
	    });
	
	    executeTwoCallbacks(promise, callback, callback);
	    return promise;
	}
	
	// Try to establish a new db connection to replace the
	// current one which is broken (i.e. experiencing
	// InvalidStateError while creating a transaction).
	function _tryReconnect(dbInfo) {
	    _deferReadiness(dbInfo);
	
	    var dbContext = dbContexts[dbInfo.name];
	    var forages = dbContext.forages;
	
	    for (var i = 0; i < forages.length; i++) {
	        var forage = forages[i];
	        if (forage._dbInfo.db) {
	            forage._dbInfo.db.close();
	            forage._dbInfo.db = null;
	        }
	    }
	    dbInfo.db = null;
	
	    return _getOriginalConnection(dbInfo).then(function (db) {
	        dbInfo.db = db;
	        if (_isUpgradeNeeded(dbInfo)) {
	            // Reopen the database for upgrading.
	            return _getUpgradedConnection(dbInfo);
	        }
	        return db;
	    }).then(function (db) {
	        // store the latest db reference
	        // in case the db was upgraded
	        dbInfo.db = dbContext.db = db;
	        for (var i = 0; i < forages.length; i++) {
	            forages[i]._dbInfo.db = db;
	        }
	    })["catch"](function (err) {
	        _rejectReadiness(dbInfo, err);
	        throw err;
	    });
	}
	
	// FF doesn't like Promises (micro-tasks) and IDDB store operations,
	// so we have to do it with callbacks
	function createTransaction(dbInfo, mode, callback, retries) {
	    if (retries === undefined) {
	        retries = 1;
	    }
	
	    try {
	        var tx = dbInfo.db.transaction(dbInfo.storeName, mode);
	        callback(null, tx);
	    } catch (err) {
	        if (retries > 0 && (!dbInfo.db || err.name === 'InvalidStateError' || err.name === 'NotFoundError')) {
	            return Promise$1.resolve().then(function () {
	                if (!dbInfo.db || err.name === 'NotFoundError' && !dbInfo.db.objectStoreNames.contains(dbInfo.storeName) && dbInfo.version <= dbInfo.db.version) {
	                    // increase the db version, to create the new ObjectStore
	                    if (dbInfo.db) {
	                        dbInfo.version = dbInfo.db.version + 1;
	                    }
	                    // Reopen the database for upgrading.
	                    return _getUpgradedConnection(dbInfo);
	                }
	            }).then(function () {
	                return _tryReconnect(dbInfo).then(function () {
	                    createTransaction(dbInfo, mode, callback, retries - 1);
	                });
	            })["catch"](callback);
	        }
	
	        callback(err);
	    }
	}
	
	function createDbContext() {
	    return {
	        // Running localForages sharing a database.
	        forages: [],
	        // Shared database.
	        db: null,
	        // Database readiness (promise).
	        dbReady: null,
	        // Deferred operations on the database.
	        deferredOperations: []
	    };
	}
	
	// Open the IndexedDB database (automatically creates one if one didn't
	// previously exist), using any options set in the config.
	function _initStorage(options) {
	    var self = this;
	    var dbInfo = {
	        db: null
	    };
	
	    if (options) {
	        for (var i in options) {
	            dbInfo[i] = options[i];
	        }
	    }
	
	    // Get the current context of the database;
	    var dbContext = dbContexts[dbInfo.name];
	
	    // ...or create a new context.
	    if (!dbContext) {
	        dbContext = createDbContext();
	        // Register the new context in the global container.
	        dbContexts[dbInfo.name] = dbContext;
	    }
	
	    // Register itself as a running localForage in the current context.
	    dbContext.forages.push(self);
	
	    // Replace the default `ready()` function with the specialized one.
	    if (!self._initReady) {
	        self._initReady = self.ready;
	        self.ready = _fullyReady;
	    }
	
	    // Create an array of initialization states of the related localForages.
	    var initPromises = [];
	
	    function ignoreErrors() {
	        // Don't handle errors here,
	        // just makes sure related localForages aren't pending.
	        return Promise$1.resolve();
	    }
	
	    for (var j = 0; j < dbContext.forages.length; j++) {
	        var forage = dbContext.forages[j];
	        if (forage !== self) {
	            // Don't wait for itself...
	            initPromises.push(forage._initReady()["catch"](ignoreErrors));
	        }
	    }
	
	    // Take a snapshot of the related localForages.
	    var forages = dbContext.forages.slice(0);
	
	    // Initialize the connection process only when
	    // all the related localForages aren't pending.
	    return Promise$1.all(initPromises).then(function () {
	        dbInfo.db = dbContext.db;
	        // Get the connection or open a new one without upgrade.
	        return _getOriginalConnection(dbInfo);
	    }).then(function (db) {
	        dbInfo.db = db;
	        if (_isUpgradeNeeded(dbInfo, self._defaultConfig.version)) {
	            // Reopen the database for upgrading.
	            return _getUpgradedConnection(dbInfo);
	        }
	        return db;
	    }).then(function (db) {
	        dbInfo.db = dbContext.db = db;
	        self._dbInfo = dbInfo;
	        // Share the final connection amongst related localForages.
	        for (var k = 0; k < forages.length; k++) {
	            var forage = forages[k];
	            if (forage !== self) {
	                // Self is already up-to-date.
	                forage._dbInfo.db = dbInfo.db;
	                forage._dbInfo.version = dbInfo.version;
	            }
	        }
	    });
	}
	
	function getItem(key, callback) {
	    var self = this;
	
	    key = normalizeKey(key);
	
	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
	                if (err) {
	                    return reject(err);
	                }
	
	                try {
	                    var store = transaction.objectStore(self._dbInfo.storeName);
	                    var req = store.get(key);
	
	                    req.onsuccess = function () {
	                        var value = req.result;
	                        if (value === undefined) {
	                            value = null;
	                        }
	                        if (_isEncodedBlob(value)) {
	                            value = _decodeBlob(value);
	                        }
	                        resolve(value);
	                    };
	
	                    req.onerror = function () {
	                        reject(req.error);
	                    };
	                } catch (e) {
	                    reject(e);
	                }
	            });
	        })["catch"](reject);
	    });
	
	    executeCallback(promise, callback);
	    return promise;
	}
	
	// Iterate over all items stored in database.
	function iterate(iterator, callback) {
	    var self = this;
	
	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
	                if (err) {
	                    return reject(err);
	                }
	
	                try {
	                    var store = transaction.objectStore(self._dbInfo.storeName);
	                    var req = store.openCursor();
	                    var iterationNumber = 1;
	
	                    req.onsuccess = function () {
	                        var cursor = req.result;
	
	                        if (cursor) {
	                            var value = cursor.value;
	                            if (_isEncodedBlob(value)) {
	                                value = _decodeBlob(value);
	                            }
	                            var result = iterator(value, cursor.key, iterationNumber++);
	
	                            // when the iterator callback retuns any
	                            // (non-`undefined`) value, then we stop
	                            // the iteration immediately
	                            if (result !== void 0) {
	                                resolve(result);
	                            } else {
	                                cursor["continue"]();
	                            }
	                        } else {
	                            resolve();
	                        }
	                    };
	
	                    req.onerror = function () {
	                        reject(req.error);
	                    };
	                } catch (e) {
	                    reject(e);
	                }
	            });
	        })["catch"](reject);
	    });
	
	    executeCallback(promise, callback);
	
	    return promise;
	}
	
	function setItem(key, value, callback) {
	    var self = this;
	
	    key = normalizeKey(key);
	
	    var promise = new Promise$1(function (resolve, reject) {
	        var dbInfo;
	        self.ready().then(function () {
	            dbInfo = self._dbInfo;
	            if (toString.call(value) === '[object Blob]') {
	                return _checkBlobSupport(dbInfo.db).then(function (blobSupport) {
	                    if (blobSupport) {
	                        return value;
	                    }
	                    return _encodeBlob(value);
	                });
	            }
	            return value;
	        }).then(function (value) {
	            createTransaction(self._dbInfo, READ_WRITE, function (err, transaction) {
	                if (err) {
	                    return reject(err);
	                }
	
	                try {
	                    var store = transaction.objectStore(self._dbInfo.storeName);
	
	                    // The reason we don't _save_ null is because IE 10 does
	                    // not support saving the `null` type in IndexedDB. How
	                    // ironic, given the bug below!
	                    // See: https://github.com/mozilla/localForage/issues/161
	                    if (value === null) {
	                        value = undefined;
	                    }
	
	                    var req = store.put(value, key);
	
	                    transaction.oncomplete = function () {
	                        // Cast to undefined so the value passed to
	                        // callback/promise is the same as what one would get out
	                        // of `getItem()` later. This leads to some weirdness
	                        // (setItem('foo', undefined) will return `null`), but
	                        // it's not my fault localStorage is our baseline and that
	                        // it's weird.
	                        if (value === undefined) {
	                            value = null;
	                        }
	
	                        resolve(value);
	                    };
	                    transaction.onabort = transaction.onerror = function () {
	                        var err = req.error ? req.error : req.transaction.error;
	                        reject(err);
	                    };
	                } catch (e) {
	                    reject(e);
	                }
	            });
	        })["catch"](reject);
	    });
	
	    executeCallback(promise, callback);
	    return promise;
	}
	
	function removeItem(key, callback) {
	    var self = this;
	
	    key = normalizeKey(key);
	
	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            createTransaction(self._dbInfo, READ_WRITE, function (err, transaction) {
	                if (err) {
	                    return reject(err);
	                }
	
	                try {
	                    var store = transaction.objectStore(self._dbInfo.storeName);
	                    // We use a Grunt task to make this safe for IE and some
	                    // versions of Android (including those used by Cordova).
	                    // Normally IE won't like `.delete()` and will insist on
	                    // using `['delete']()`, but we have a build step that
	                    // fixes this for us now.
	                    var req = store["delete"](key);
	                    transaction.oncomplete = function () {
	                        resolve();
	                    };
	
	                    transaction.onerror = function () {
	                        reject(req.error);
	                    };
	
	                    // The request will be also be aborted if we've exceeded our storage
	                    // space.
	                    transaction.onabort = function () {
	                        var err = req.error ? req.error : req.transaction.error;
	                        reject(err);
	                    };
	                } catch (e) {
	                    reject(e);
	                }
	            });
	        })["catch"](reject);
	    });
	
	    executeCallback(promise, callback);
	    return promise;
	}
	
	function clear(callback) {
	    var self = this;
	
	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            createTransaction(self._dbInfo, READ_WRITE, function (err, transaction) {
	                if (err) {
	                    return reject(err);
	                }
	
	                try {
	                    var store = transaction.objectStore(self._dbInfo.storeName);
	                    var req = store.clear();
	
	                    transaction.oncomplete = function () {
	                        resolve();
	                    };
	
	                    transaction.onabort = transaction.onerror = function () {
	                        var err = req.error ? req.error : req.transaction.error;
	                        reject(err);
	                    };
	                } catch (e) {
	                    reject(e);
	                }
	            });
	        })["catch"](reject);
	    });
	
	    executeCallback(promise, callback);
	    return promise;
	}
	
	function length(callback) {
	    var self = this;
	
	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
	                if (err) {
	                    return reject(err);
	                }
	
	                try {
	                    var store = transaction.objectStore(self._dbInfo.storeName);
	                    var req = store.count();
	
	                    req.onsuccess = function () {
	                        resolve(req.result);
	                    };
	
	                    req.onerror = function () {
	                        reject(req.error);
	                    };
	                } catch (e) {
	                    reject(e);
	                }
	            });
	        })["catch"](reject);
	    });
	
	    executeCallback(promise, callback);
	    return promise;
	}
	
	function key(n, callback) {
	    var self = this;
	
	    var promise = new Promise$1(function (resolve, reject) {
	        if (n < 0) {
	            resolve(null);
	
	            return;
	        }
	
	        self.ready().then(function () {
	            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
	                if (err) {
	                    return reject(err);
	                }
	
	                try {
	                    var store = transaction.objectStore(self._dbInfo.storeName);
	                    var advanced = false;
	                    var req = store.openCursor();
	
	                    req.onsuccess = function () {
	                        var cursor = req.result;
	                        if (!cursor) {
	                            // this means there weren't enough keys
	                            resolve(null);
	
	                            return;
	                        }
	
	                        if (n === 0) {
	                            // We have the first key, return it if that's what they
	                            // wanted.
	                            resolve(cursor.key);
	                        } else {
	                            if (!advanced) {
	                                // Otherwise, ask the cursor to skip ahead n
	                                // records.
	                                advanced = true;
	                                cursor.advance(n);
	                            } else {
	                                // When we get here, we've got the nth key.
	                                resolve(cursor.key);
	                            }
	                        }
	                    };
	
	                    req.onerror = function () {
	                        reject(req.error);
	                    };
	                } catch (e) {
	                    reject(e);
	                }
	            });
	        })["catch"](reject);
	    });
	
	    executeCallback(promise, callback);
	    return promise;
	}
	
	function keys(callback) {
	    var self = this;
	
	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
	                if (err) {
	                    return reject(err);
	                }
	
	                try {
	                    var store = transaction.objectStore(self._dbInfo.storeName);
	                    var req = store.openCursor();
	                    var keys = [];
	
	                    req.onsuccess = function () {
	                        var cursor = req.result;
	
	                        if (!cursor) {
	                            resolve(keys);
	                            return;
	                        }
	
	                        keys.push(cursor.key);
	                        cursor["continue"]();
	                    };
	
	                    req.onerror = function () {
	                        reject(req.error);
	                    };
	                } catch (e) {
	                    reject(e);
	                }
	            });
	        })["catch"](reject);
	    });
	
	    executeCallback(promise, callback);
	    return promise;
	}
	
	function dropInstance(options, callback) {
	    callback = getCallback.apply(this, arguments);
	
	    var currentConfig = this.config();
	    options = typeof options !== 'function' && options || {};
	    if (!options.name) {
	        options.name = options.name || currentConfig.name;
	        options.storeName = options.storeName || currentConfig.storeName;
	    }
	
	    var self = this;
	    var promise;
	    if (!options.name) {
	        promise = Promise$1.reject('Invalid arguments');
	    } else {
	        var isCurrentDb = options.name === currentConfig.name && self._dbInfo.db;
	
	        var dbPromise = isCurrentDb ? Promise$1.resolve(self._dbInfo.db) : _getOriginalConnection(options).then(function (db) {
	            var dbContext = dbContexts[options.name];
	            var forages = dbContext.forages;
	            dbContext.db = db;
	            for (var i = 0; i < forages.length; i++) {
	                forages[i]._dbInfo.db = db;
	            }
	            return db;
	        });
	
	        if (!options.storeName) {
	            promise = dbPromise.then(function (db) {
	                _deferReadiness(options);
	
	                var dbContext = dbContexts[options.name];
	                var forages = dbContext.forages;
	
	                db.close();
	                for (var i = 0; i < forages.length; i++) {
	                    var forage = forages[i];
	                    forage._dbInfo.db = null;
	                }
	
	                var dropDBPromise = new Promise$1(function (resolve, reject) {
	                    var req = idb.deleteDatabase(options.name);
	
	                    req.onerror = req.onblocked = function (err) {
	                        var db = req.result;
	                        if (db) {
	                            db.close();
	                        }
	                        reject(err);
	                    };
	
	                    req.onsuccess = function () {
	                        var db = req.result;
	                        if (db) {
	                            db.close();
	                        }
	                        resolve(db);
	                    };
	                });
	
	                return dropDBPromise.then(function (db) {
	                    dbContext.db = db;
	                    for (var i = 0; i < forages.length; i++) {
	                        var _forage = forages[i];
	                        _advanceReadiness(_forage._dbInfo);
	                    }
	                })["catch"](function (err) {
	                    (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function () {});
	                    throw err;
	                });
	            });
	        } else {
	            promise = dbPromise.then(function (db) {
	                if (!db.objectStoreNames.contains(options.storeName)) {
	                    return;
	                }
	
	                var newVersion = db.version + 1;
	
	                _deferReadiness(options);
	
	                var dbContext = dbContexts[options.name];
	                var forages = dbContext.forages;
	
	                db.close();
	                for (var i = 0; i < forages.length; i++) {
	                    var forage = forages[i];
	                    forage._dbInfo.db = null;
	                    forage._dbInfo.version = newVersion;
	                }
	
	                var dropObjectPromise = new Promise$1(function (resolve, reject) {
	                    var req = idb.open(options.name, newVersion);
	
	                    req.onerror = function (err) {
	                        var db = req.result;
	                        db.close();
	                        reject(err);
	                    };
	
	                    req.onupgradeneeded = function () {
	                        var db = req.result;
	                        db.deleteObjectStore(options.storeName);
	                    };
	
	                    req.onsuccess = function () {
	                        var db = req.result;
	                        db.close();
	                        resolve(db);
	                    };
	                });
	
	                return dropObjectPromise.then(function (db) {
	                    dbContext.db = db;
	                    for (var j = 0; j < forages.length; j++) {
	                        var _forage2 = forages[j];
	                        _forage2._dbInfo.db = db;
	                        _advanceReadiness(_forage2._dbInfo);
	                    }
	                })["catch"](function (err) {
	                    (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function () {});
	                    throw err;
	                });
	            });
	        }
	    }
	
	    executeCallback(promise, callback);
	    return promise;
	}
	
	var asyncStorage = {
	    _driver: 'asyncStorage',
	    _initStorage: _initStorage,
	    _support: isIndexedDBValid(),
	    iterate: iterate,
	    getItem: getItem,
	    setItem: setItem,
	    removeItem: removeItem,
	    clear: clear,
	    length: length,
	    key: key,
	    keys: keys,
	    dropInstance: dropInstance
	};
	
	function isWebSQLValid() {
	    return typeof openDatabase === 'function';
	}
	
	// Sadly, the best way to save binary data in WebSQL/localStorage is serializing
	// it to Base64, so this is how we store it to prevent very strange errors with less
	// verbose ways of binary <-> string data storage.
	var BASE_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
	
	var BLOB_TYPE_PREFIX = '~~local_forage_type~';
	var BLOB_TYPE_PREFIX_REGEX = /^~~local_forage_type~([^~]+)~/;
	
	var SERIALIZED_MARKER = '__lfsc__:';
	var SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER.length;
	
	// OMG the serializations!
	var TYPE_ARRAYBUFFER = 'arbf';
	var TYPE_BLOB = 'blob';
	var TYPE_INT8ARRAY = 'si08';
	var TYPE_UINT8ARRAY = 'ui08';
	var TYPE_UINT8CLAMPEDARRAY = 'uic8';
	var TYPE_INT16ARRAY = 'si16';
	var TYPE_INT32ARRAY = 'si32';
	var TYPE_UINT16ARRAY = 'ur16';
	var TYPE_UINT32ARRAY = 'ui32';
	var TYPE_FLOAT32ARRAY = 'fl32';
	var TYPE_FLOAT64ARRAY = 'fl64';
	var TYPE_SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER_LENGTH + TYPE_ARRAYBUFFER.length;
	
	var toString$1 = Object.prototype.toString;
	
	function stringToBuffer(serializedString) {
	    // Fill the string into a ArrayBuffer.
	    var bufferLength = serializedString.length * 0.75;
	    var len = serializedString.length;
	    var i;
	    var p = 0;
	    var encoded1, encoded2, encoded3, encoded4;
	
	    if (serializedString[serializedString.length - 1] === '=') {
	        bufferLength--;
	        if (serializedString[serializedString.length - 2] === '=') {
	            bufferLength--;
	        }
	    }
	
	    var buffer = new ArrayBuffer(bufferLength);
	    var bytes = new Uint8Array(buffer);
	
	    for (i = 0; i < len; i += 4) {
	        encoded1 = BASE_CHARS.indexOf(serializedString[i]);
	        encoded2 = BASE_CHARS.indexOf(serializedString[i + 1]);
	        encoded3 = BASE_CHARS.indexOf(serializedString[i + 2]);
	        encoded4 = BASE_CHARS.indexOf(serializedString[i + 3]);
	
	        /*jslint bitwise: true */
	        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
	        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
	        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
	    }
	    return buffer;
	}
	
	// Converts a buffer to a string to store, serialized, in the backend
	// storage library.
	function bufferToString(buffer) {
	    // base64-arraybuffer
	    var bytes = new Uint8Array(buffer);
	    var base64String = '';
	    var i;
	
	    for (i = 0; i < bytes.length; i += 3) {
	        /*jslint bitwise: true */
	        base64String += BASE_CHARS[bytes[i] >> 2];
	        base64String += BASE_CHARS[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
	        base64String += BASE_CHARS[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
	        base64String += BASE_CHARS[bytes[i + 2] & 63];
	    }
	
	    if (bytes.length % 3 === 2) {
	        base64String = base64String.substring(0, base64String.length - 1) + '=';
	    } else if (bytes.length % 3 === 1) {
	        base64String = base64String.substring(0, base64String.length - 2) + '==';
	    }
	
	    return base64String;
	}
	
	// Serialize a value, afterwards executing a callback (which usually
	// instructs the `setItem()` callback/promise to be executed). This is how
	// we store binary data with localStorage.
	function serialize(value, callback) {
	    var valueType = '';
	    if (value) {
	        valueType = toString$1.call(value);
	    }
	
	    // Cannot use `value instanceof ArrayBuffer` or such here, as these
	    // checks fail when running the tests using casper.js...
	    //
	    // TODO: See why those tests fail and use a better solution.
	    if (value && (valueType === '[object ArrayBuffer]' || value.buffer && toString$1.call(value.buffer) === '[object ArrayBuffer]')) {
	        // Convert binary arrays to a string and prefix the string with
	        // a special marker.
	        var buffer;
	        var marker = SERIALIZED_MARKER;
	
	        if (value instanceof ArrayBuffer) {
	            buffer = value;
	            marker += TYPE_ARRAYBUFFER;
	        } else {
	            buffer = value.buffer;
	
	            if (valueType === '[object Int8Array]') {
	                marker += TYPE_INT8ARRAY;
	            } else if (valueType === '[object Uint8Array]') {
	                marker += TYPE_UINT8ARRAY;
	            } else if (valueType === '[object Uint8ClampedArray]') {
	                marker += TYPE_UINT8CLAMPEDARRAY;
	            } else if (valueType === '[object Int16Array]') {
	                marker += TYPE_INT16ARRAY;
	            } else if (valueType === '[object Uint16Array]') {
	                marker += TYPE_UINT16ARRAY;
	            } else if (valueType === '[object Int32Array]') {
	                marker += TYPE_INT32ARRAY;
	            } else if (valueType === '[object Uint32Array]') {
	                marker += TYPE_UINT32ARRAY;
	            } else if (valueType === '[object Float32Array]') {
	                marker += TYPE_FLOAT32ARRAY;
	            } else if (valueType === '[object Float64Array]') {
	                marker += TYPE_FLOAT64ARRAY;
	            } else {
	                callback(new Error('Failed to get type for BinaryArray'));
	            }
	        }
	
	        callback(marker + bufferToString(buffer));
	    } else if (valueType === '[object Blob]') {
	        // Conver the blob to a binaryArray and then to a string.
	        var fileReader = new FileReader();
	
	        fileReader.onload = function () {
	            // Backwards-compatible prefix for the blob type.
	            var str = BLOB_TYPE_PREFIX + value.type + '~' + bufferToString(this.result);
	
	            callback(SERIALIZED_MARKER + TYPE_BLOB + str);
	        };
	
	        fileReader.readAsArrayBuffer(value);
	    } else {
	        try {
	            callback(JSON.stringify(value));
	        } catch (e) {
	            console.error("Couldn't convert value into a JSON string: ", value);
	
	            callback(null, e);
	        }
	    }
	}
	
	// Deserialize data we've inserted into a value column/field. We place
	// special markers into our strings to mark them as encoded; this isn't
	// as nice as a meta field, but it's the only sane thing we can do whilst
	// keeping localStorage support intact.
	//
	// Oftentimes this will just deserialize JSON content, but if we have a
	// special marker (SERIALIZED_MARKER, defined above), we will extract
	// some kind of arraybuffer/binary data/typed array out of the string.
	function deserialize(value) {
	    // If we haven't marked this string as being specially serialized (i.e.
	    // something other than serialized JSON), we can just return it and be
	    // done with it.
	    if (value.substring(0, SERIALIZED_MARKER_LENGTH) !== SERIALIZED_MARKER) {
	        return JSON.parse(value);
	    }
	
	    // The following code deals with deserializing some kind of Blob or
	    // TypedArray. First we separate out the type of data we're dealing
	    // with from the data itself.
	    var serializedString = value.substring(TYPE_SERIALIZED_MARKER_LENGTH);
	    var type = value.substring(SERIALIZED_MARKER_LENGTH, TYPE_SERIALIZED_MARKER_LENGTH);
	
	    var blobType;
	    // Backwards-compatible blob type serialization strategy.
	    // DBs created with older versions of localForage will simply not have the blob type.
	    if (type === TYPE_BLOB && BLOB_TYPE_PREFIX_REGEX.test(serializedString)) {
	        var matcher = serializedString.match(BLOB_TYPE_PREFIX_REGEX);
	        blobType = matcher[1];
	        serializedString = serializedString.substring(matcher[0].length);
	    }
	    var buffer = stringToBuffer(serializedString);
	
	    // Return the right type based on the code/type set during
	    // serialization.
	    switch (type) {
	        case TYPE_ARRAYBUFFER:
	            return buffer;
	        case TYPE_BLOB:
	            return createBlob([buffer], { type: blobType });
	        case TYPE_INT8ARRAY:
	            return new Int8Array(buffer);
	        case TYPE_UINT8ARRAY:
	            return new Uint8Array(buffer);
	        case TYPE_UINT8CLAMPEDARRAY:
	            return new Uint8ClampedArray(buffer);
	        case TYPE_INT16ARRAY:
	            return new Int16Array(buffer);
	        case TYPE_UINT16ARRAY:
	            return new Uint16Array(buffer);
	        case TYPE_INT32ARRAY:
	            return new Int32Array(buffer);
	        case TYPE_UINT32ARRAY:
	            return new Uint32Array(buffer);
	        case TYPE_FLOAT32ARRAY:
	            return new Float32Array(buffer);
	        case TYPE_FLOAT64ARRAY:
	            return new Float64Array(buffer);
	        default:
	            throw new Error('Unkown type: ' + type);
	    }
	}
	
	var localforageSerializer = {
	    serialize: serialize,
	    deserialize: deserialize,
	    stringToBuffer: stringToBuffer,
	    bufferToString: bufferToString
	};
	
	/*
	 * Includes code from:
	 *
	 * base64-arraybuffer
	 * https://github.com/niklasvh/base64-arraybuffer
	 *
	 * Copyright (c) 2012 Niklas von Hertzen
	 * Licensed under the MIT license.
	 */
	
	function createDbTable(t, dbInfo, callback, errorCallback) {
	    t.executeSql('CREATE TABLE IF NOT EXISTS ' + dbInfo.storeName + ' ' + '(id INTEGER PRIMARY KEY, key unique, value)', [], callback, errorCallback);
	}
	
	// Open the WebSQL database (automatically creates one if one didn't
	// previously exist), using any options set in the config.
	function _initStorage$1(options) {
	    var self = this;
	    var dbInfo = {
	        db: null
	    };
	
	    if (options) {
	        for (var i in options) {
	            dbInfo[i] = typeof options[i] !== 'string' ? options[i].toString() : options[i];
	        }
	    }
	
	    var dbInfoPromise = new Promise$1(function (resolve, reject) {
	        // Open the database; the openDatabase API will automatically
	        // create it for us if it doesn't exist.
	        try {
	            dbInfo.db = openDatabase(dbInfo.name, String(dbInfo.version), dbInfo.description, dbInfo.size);
	        } catch (e) {
	            return reject(e);
	        }
	
	        // Create our key/value table if it doesn't exist.
	        dbInfo.db.transaction(function (t) {
	            createDbTable(t, dbInfo, function () {
	                self._dbInfo = dbInfo;
	                resolve();
	            }, function (t, error) {
	                reject(error);
	            });
	        }, reject);
	    });
	
	    dbInfo.serializer = localforageSerializer;
	    return dbInfoPromise;
	}
	
	function tryExecuteSql(t, dbInfo, sqlStatement, args, callback, errorCallback) {
	    t.executeSql(sqlStatement, args, callback, function (t, error) {
	        if (error.code === error.SYNTAX_ERR) {
	            t.executeSql('SELECT name FROM sqlite_master ' + "WHERE type='table' AND name = ?", [dbInfo.storeName], function (t, results) {
	                if (!results.rows.length) {
	                    // if the table is missing (was deleted)
	                    // re-create it table and retry
	                    createDbTable(t, dbInfo, function () {
	                        t.executeSql(sqlStatement, args, callback, errorCallback);
	                    }, errorCallback);
	                } else {
	                    errorCallback(t, error);
	                }
	            }, errorCallback);
	        } else {
	            errorCallback(t, error);
	        }
	    }, errorCallback);
	}
	
	function getItem$1(key, callback) {
	    var self = this;
	
	    key = normalizeKey(key);
	
	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            var dbInfo = self._dbInfo;
	            dbInfo.db.transaction(function (t) {
	                tryExecuteSql(t, dbInfo, 'SELECT * FROM ' + dbInfo.storeName + ' WHERE key = ? LIMIT 1', [key], function (t, results) {
	                    var result = results.rows.length ? results.rows.item(0).value : null;
	
	                    // Check to see if this is serialized content we need to
	                    // unpack.
	                    if (result) {
	                        result = dbInfo.serializer.deserialize(result);
	                    }
	
	                    resolve(result);
	                }, function (t, error) {
	                    reject(error);
	                });
	            });
	        })["catch"](reject);
	    });
	
	    executeCallback(promise, callback);
	    return promise;
	}
	
	function iterate$1(iterator, callback) {
	    var self = this;
	
	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            var dbInfo = self._dbInfo;
	
	            dbInfo.db.transaction(function (t) {
	                tryExecuteSql(t, dbInfo, 'SELECT * FROM ' + dbInfo.storeName, [], function (t, results) {
	                    var rows = results.rows;
	                    var length = rows.length;
	
	                    for (var i = 0; i < length; i++) {
	                        var item = rows.item(i);
	                        var result = item.value;
	
	                        // Check to see if this is serialized content
	                        // we need to unpack.
	                        if (result) {
	                            result = dbInfo.serializer.deserialize(result);
	                        }
	
	                        result = iterator(result, item.key, i + 1);
	
	                        // void(0) prevents problems with redefinition
	                        // of `undefined`.
	                        if (result !== void 0) {
	                            resolve(result);
	                            return;
	                        }
	                    }
	
	                    resolve();
	                }, function (t, error) {
	                    reject(error);
	                });
	            });
	        })["catch"](reject);
	    });
	
	    executeCallback(promise, callback);
	    return promise;
	}
	
	function _setItem(key, value, callback, retriesLeft) {
	    var self = this;
	
	    key = normalizeKey(key);
	
	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            // The localStorage API doesn't return undefined values in an
	            // "expected" way, so undefined is always cast to null in all
	            // drivers. See: https://github.com/mozilla/localForage/pull/42
	            if (value === undefined) {
	                value = null;
	            }
	
	            // Save the original value to pass to the callback.
	            var originalValue = value;
	
	            var dbInfo = self._dbInfo;
	            dbInfo.serializer.serialize(value, function (value, error) {
	                if (error) {
	                    reject(error);
	                } else {
	                    dbInfo.db.transaction(function (t) {
	                        tryExecuteSql(t, dbInfo, 'INSERT OR REPLACE INTO ' + dbInfo.storeName + ' ' + '(key, value) VALUES (?, ?)', [key, value], function () {
	                            resolve(originalValue);
	                        }, function (t, error) {
	                            reject(error);
	                        });
	                    }, function (sqlError) {
	                        // The transaction failed; check
	                        // to see if it's a quota error.
	                        if (sqlError.code === sqlError.QUOTA_ERR) {
	                            // We reject the callback outright for now, but
	                            // it's worth trying to re-run the transaction.
	                            // Even if the user accepts the prompt to use
	                            // more storage on Safari, this error will
	                            // be called.
	                            //
	                            // Try to re-run the transaction.
	                            if (retriesLeft > 0) {
	                                resolve(_setItem.apply(self, [key, originalValue, callback, retriesLeft - 1]));
	                                return;
	                            }
	                            reject(sqlError);
	                        }
	                    });
	                }
	            });
	        })["catch"](reject);
	    });
	
	    executeCallback(promise, callback);
	    return promise;
	}
	
	function setItem$1(key, value, callback) {
	    return _setItem.apply(this, [key, value, callback, 1]);
	}
	
	function removeItem$1(key, callback) {
	    var self = this;
	
	    key = normalizeKey(key);
	
	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            var dbInfo = self._dbInfo;
	            dbInfo.db.transaction(function (t) {
	                tryExecuteSql(t, dbInfo, 'DELETE FROM ' + dbInfo.storeName + ' WHERE key = ?', [key], function () {
	                    resolve();
	                }, function (t, error) {
	                    reject(error);
	                });
	            });
	        })["catch"](reject);
	    });
	
	    executeCallback(promise, callback);
	    return promise;
	}
	
	// Deletes every item in the table.
	// TODO: Find out if this resets the AUTO_INCREMENT number.
	function clear$1(callback) {
	    var self = this;
	
	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            var dbInfo = self._dbInfo;
	            dbInfo.db.transaction(function (t) {
	                tryExecuteSql(t, dbInfo, 'DELETE FROM ' + dbInfo.storeName, [], function () {
	                    resolve();
	                }, function (t, error) {
	                    reject(error);
	                });
	            });
	        })["catch"](reject);
	    });
	
	    executeCallback(promise, callback);
	    return promise;
	}
	
	// Does a simple `COUNT(key)` to get the number of items stored in
	// localForage.
	function length$1(callback) {
	    var self = this;
	
	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            var dbInfo = self._dbInfo;
	            dbInfo.db.transaction(function (t) {
	                // Ahhh, SQL makes this one soooooo easy.
	                tryExecuteSql(t, dbInfo, 'SELECT COUNT(key) as c FROM ' + dbInfo.storeName, [], function (t, results) {
	                    var result = results.rows.item(0).c;
	                    resolve(result);
	                }, function (t, error) {
	                    reject(error);
	                });
	            });
	        })["catch"](reject);
	    });
	
	    executeCallback(promise, callback);
	    return promise;
	}
	
	// Return the key located at key index X; essentially gets the key from a
	// `WHERE id = ?`. This is the most efficient way I can think to implement
	// this rarely-used (in my experience) part of the API, but it can seem
	// inconsistent, because we do `INSERT OR REPLACE INTO` on `setItem()`, so
	// the ID of each key will change every time it's updated. Perhaps a stored
	// procedure for the `setItem()` SQL would solve this problem?
	// TODO: Don't change ID on `setItem()`.
	function key$1(n, callback) {
	    var self = this;
	
	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            var dbInfo = self._dbInfo;
	            dbInfo.db.transaction(function (t) {
	                tryExecuteSql(t, dbInfo, 'SELECT key FROM ' + dbInfo.storeName + ' WHERE id = ? LIMIT 1', [n + 1], function (t, results) {
	                    var result = results.rows.length ? results.rows.item(0).key : null;
	                    resolve(result);
	                }, function (t, error) {
	                    reject(error);
	                });
	            });
	        })["catch"](reject);
	    });
	
	    executeCallback(promise, callback);
	    return promise;
	}
	
	function keys$1(callback) {
	    var self = this;
	
	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            var dbInfo = self._dbInfo;
	            dbInfo.db.transaction(function (t) {
	                tryExecuteSql(t, dbInfo, 'SELECT key FROM ' + dbInfo.storeName, [], function (t, results) {
	                    var keys = [];
	
	                    for (var i = 0; i < results.rows.length; i++) {
	                        keys.push(results.rows.item(i).key);
	                    }
	
	                    resolve(keys);
	                }, function (t, error) {
	                    reject(error);
	                });
	            });
	        })["catch"](reject);
	    });
	
	    executeCallback(promise, callback);
	    return promise;
	}
	
	// https://www.w3.org/TR/webdatabase/#databases
	// > There is no way to enumerate or delete the databases available for an origin from this API.
	function getAllStoreNames(db) {
	    return new Promise$1(function (resolve, reject) {
	        db.transaction(function (t) {
	            t.executeSql('SELECT name FROM sqlite_master ' + "WHERE type='table' AND name <> '__WebKitDatabaseInfoTable__'", [], function (t, results) {
	                var storeNames = [];
	
	                for (var i = 0; i < results.rows.length; i++) {
	                    storeNames.push(results.rows.item(i).name);
	                }
	
	                resolve({
	                    db: db,
	                    storeNames: storeNames
	                });
	            }, function (t, error) {
	                reject(error);
	            });
	        }, function (sqlError) {
	            reject(sqlError);
	        });
	    });
	}
	
	function dropInstance$1(options, callback) {
	    callback = getCallback.apply(this, arguments);
	
	    var currentConfig = this.config();
	    options = typeof options !== 'function' && options || {};
	    if (!options.name) {
	        options.name = options.name || currentConfig.name;
	        options.storeName = options.storeName || currentConfig.storeName;
	    }
	
	    var self = this;
	    var promise;
	    if (!options.name) {
	        promise = Promise$1.reject('Invalid arguments');
	    } else {
	        promise = new Promise$1(function (resolve) {
	            var db;
	            if (options.name === currentConfig.name) {
	                // use the db reference of the current instance
	                db = self._dbInfo.db;
	            } else {
	                db = openDatabase(options.name, '', '', 0);
	            }
	
	            if (!options.storeName) {
	                // drop all database tables
	                resolve(getAllStoreNames(db));
	            } else {
	                resolve({
	                    db: db,
	                    storeNames: [options.storeName]
	                });
	            }
	        }).then(function (operationInfo) {
	            return new Promise$1(function (resolve, reject) {
	                operationInfo.db.transaction(function (t) {
	                    function dropTable(storeName) {
	                        return new Promise$1(function (resolve, reject) {
	                            t.executeSql('DROP TABLE IF EXISTS ' + storeName, [], function () {
	                                resolve();
	                            }, function (t, error) {
	                                reject(error);
	                            });
	                        });
	                    }
	
	                    var operations = [];
	                    for (var i = 0, len = operationInfo.storeNames.length; i < len; i++) {
	                        operations.push(dropTable(operationInfo.storeNames[i]));
	                    }
	
	                    Promise$1.all(operations).then(function () {
	                        resolve();
	                    })["catch"](function (e) {
	                        reject(e);
	                    });
	                }, function (sqlError) {
	                    reject(sqlError);
	                });
	            });
	        });
	    }
	
	    executeCallback(promise, callback);
	    return promise;
	}
	
	var webSQLStorage = {
	    _driver: 'webSQLStorage',
	    _initStorage: _initStorage$1,
	    _support: isWebSQLValid(),
	    iterate: iterate$1,
	    getItem: getItem$1,
	    setItem: setItem$1,
	    removeItem: removeItem$1,
	    clear: clear$1,
	    length: length$1,
	    key: key$1,
	    keys: keys$1,
	    dropInstance: dropInstance$1
	};
	
	function isLocalStorageValid() {
	    try {
	        return typeof localStorage !== 'undefined' && 'setItem' in localStorage &&
	        // in IE8 typeof localStorage.setItem === 'object'
	        !!localStorage.setItem;
	    } catch (e) {
	        return false;
	    }
	}
	
	function _getKeyPrefix(options, defaultConfig) {
	    var keyPrefix = options.name + '/';
	
	    if (options.storeName !== defaultConfig.storeName) {
	        keyPrefix += options.storeName + '/';
	    }
	    return keyPrefix;
	}
	
	// Check if localStorage throws when saving an item
	function checkIfLocalStorageThrows() {
	    var localStorageTestKey = '_localforage_support_test';
	
	    try {
	        localStorage.setItem(localStorageTestKey, true);
	        localStorage.removeItem(localStorageTestKey);
	
	        return false;
	    } catch (e) {
	        return true;
	    }
	}
	
	// Check if localStorage is usable and allows to save an item
	// This method checks if localStorage is usable in Safari Private Browsing
	// mode, or in any other case where the available quota for localStorage
	// is 0 and there wasn't any saved items yet.
	function _isLocalStorageUsable() {
	    return !checkIfLocalStorageThrows() || localStorage.length > 0;
	}
	
	// Config the localStorage backend, using options set in the config.
	function _initStorage$2(options) {
	    var self = this;
	    var dbInfo = {};
	    if (options) {
	        for (var i in options) {
	            dbInfo[i] = options[i];
	        }
	    }
	
	    dbInfo.keyPrefix = _getKeyPrefix(options, self._defaultConfig);
	
	    if (!_isLocalStorageUsable()) {
	        return Promise$1.reject();
	    }
	
	    self._dbInfo = dbInfo;
	    dbInfo.serializer = localforageSerializer;
	
	    return Promise$1.resolve();
	}
	
	// Remove all keys from the datastore, effectively destroying all data in
	// the app's key/value store!
	function clear$2(callback) {
	    var self = this;
	    var promise = self.ready().then(function () {
	        var keyPrefix = self._dbInfo.keyPrefix;
	
	        for (var i = localStorage.length - 1; i >= 0; i--) {
	            var key = localStorage.key(i);
	
	            if (key.indexOf(keyPrefix) === 0) {
	                localStorage.removeItem(key);
	            }
	        }
	    });
	
	    executeCallback(promise, callback);
	    return promise;
	}
	
	// Retrieve an item from the store. Unlike the original async_storage
	// library in Gaia, we don't modify return values at all. If a key's value
	// is `undefined`, we pass that value to the callback function.
	function getItem$2(key, callback) {
	    var self = this;
	
	    key = normalizeKey(key);
	
	    var promise = self.ready().then(function () {
	        var dbInfo = self._dbInfo;
	        var result = localStorage.getItem(dbInfo.keyPrefix + key);
	
	        // If a result was found, parse it from the serialized
	        // string into a JS object. If result isn't truthy, the key
	        // is likely undefined and we'll pass it straight to the
	        // callback.
	        if (result) {
	            result = dbInfo.serializer.deserialize(result);
	        }
	
	        return result;
	    });
	
	    executeCallback(promise, callback);
	    return promise;
	}
	
	// Iterate over all items in the store.
	function iterate$2(iterator, callback) {
	    var self = this;
	
	    var promise = self.ready().then(function () {
	        var dbInfo = self._dbInfo;
	        var keyPrefix = dbInfo.keyPrefix;
	        var keyPrefixLength = keyPrefix.length;
	        var length = localStorage.length;
	
	        // We use a dedicated iterator instead of the `i` variable below
	        // so other keys we fetch in localStorage aren't counted in
	        // the `iterationNumber` argument passed to the `iterate()`
	        // callback.
	        //
	        // See: github.com/mozilla/localForage/pull/435#discussion_r38061530
	        var iterationNumber = 1;
	
	        for (var i = 0; i < length; i++) {
	            var key = localStorage.key(i);
	            if (key.indexOf(keyPrefix) !== 0) {
	                continue;
	            }
	            var value = localStorage.getItem(key);
	
	            // If a result was found, parse it from the serialized
	            // string into a JS object. If result isn't truthy, the
	            // key is likely undefined and we'll pass it straight
	            // to the iterator.
	            if (value) {
	                value = dbInfo.serializer.deserialize(value);
	            }
	
	            value = iterator(value, key.substring(keyPrefixLength), iterationNumber++);
	
	            if (value !== void 0) {
	                return value;
	            }
	        }
	    });
	
	    executeCallback(promise, callback);
	    return promise;
	}
	
	// Same as localStorage's key() method, except takes a callback.
	function key$2(n, callback) {
	    var self = this;
	    var promise = self.ready().then(function () {
	        var dbInfo = self._dbInfo;
	        var result;
	        try {
	            result = localStorage.key(n);
	        } catch (error) {
	            result = null;
	        }
	
	        // Remove the prefix from the key, if a key is found.
	        if (result) {
	            result = result.substring(dbInfo.keyPrefix.length);
	        }
	
	        return result;
	    });
	
	    executeCallback(promise, callback);
	    return promise;
	}
	
	function keys$2(callback) {
	    var self = this;
	    var promise = self.ready().then(function () {
	        var dbInfo = self._dbInfo;
	        var length = localStorage.length;
	        var keys = [];
	
	        for (var i = 0; i < length; i++) {
	            var itemKey = localStorage.key(i);
	            if (itemKey.indexOf(dbInfo.keyPrefix) === 0) {
	                keys.push(itemKey.substring(dbInfo.keyPrefix.length));
	            }
	        }
	
	        return keys;
	    });
	
	    executeCallback(promise, callback);
	    return promise;
	}
	
	// Supply the number of keys in the datastore to the callback function.
	function length$2(callback) {
	    var self = this;
	    var promise = self.keys().then(function (keys) {
	        return keys.length;
	    });
	
	    executeCallback(promise, callback);
	    return promise;
	}
	
	// Remove an item from the store, nice and simple.
	function removeItem$2(key, callback) {
	    var self = this;
	
	    key = normalizeKey(key);
	
	    var promise = self.ready().then(function () {
	        var dbInfo = self._dbInfo;
	        localStorage.removeItem(dbInfo.keyPrefix + key);
	    });
	
	    executeCallback(promise, callback);
	    return promise;
	}
	
	// Set a key's value and run an optional callback once the value is set.
	// Unlike Gaia's implementation, the callback function is passed the value,
	// in case you want to operate on that value only after you're sure it
	// saved, or something like that.
	function setItem$2(key, value, callback) {
	    var self = this;
	
	    key = normalizeKey(key);
	
	    var promise = self.ready().then(function () {
	        // Convert undefined values to null.
	        // https://github.com/mozilla/localForage/pull/42
	        if (value === undefined) {
	            value = null;
	        }
	
	        // Save the original value to pass to the callback.
	        var originalValue = value;
	
	        return new Promise$1(function (resolve, reject) {
	            var dbInfo = self._dbInfo;
	            dbInfo.serializer.serialize(value, function (value, error) {
	                if (error) {
	                    reject(error);
	                } else {
	                    try {
	                        localStorage.setItem(dbInfo.keyPrefix + key, value);
	                        resolve(originalValue);
	                    } catch (e) {
	                        // localStorage capacity exceeded.
	                        // TODO: Make this a specific error/event.
	                        if (e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
	                            reject(e);
	                        }
	                        reject(e);
	                    }
	                }
	            });
	        });
	    });
	
	    executeCallback(promise, callback);
	    return promise;
	}
	
	function dropInstance$2(options, callback) {
	    callback = getCallback.apply(this, arguments);
	
	    options = typeof options !== 'function' && options || {};
	    if (!options.name) {
	        var currentConfig = this.config();
	        options.name = options.name || currentConfig.name;
	        options.storeName = options.storeName || currentConfig.storeName;
	    }
	
	    var self = this;
	    var promise;
	    if (!options.name) {
	        promise = Promise$1.reject('Invalid arguments');
	    } else {
	        promise = new Promise$1(function (resolve) {
	            if (!options.storeName) {
	                resolve(options.name + '/');
	            } else {
	                resolve(_getKeyPrefix(options, self._defaultConfig));
	            }
	        }).then(function (keyPrefix) {
	            for (var i = localStorage.length - 1; i >= 0; i--) {
	                var key = localStorage.key(i);
	
	                if (key.indexOf(keyPrefix) === 0) {
	                    localStorage.removeItem(key);
	                }
	            }
	        });
	    }
	
	    executeCallback(promise, callback);
	    return promise;
	}
	
	var localStorageWrapper = {
	    _driver: 'localStorageWrapper',
	    _initStorage: _initStorage$2,
	    _support: isLocalStorageValid(),
	    iterate: iterate$2,
	    getItem: getItem$2,
	    setItem: setItem$2,
	    removeItem: removeItem$2,
	    clear: clear$2,
	    length: length$2,
	    key: key$2,
	    keys: keys$2,
	    dropInstance: dropInstance$2
	};
	
	var sameValue = function sameValue(x, y) {
	    return x === y || typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y);
	};
	
	var includes = function includes(array, searchElement) {
	    var len = array.length;
	    var i = 0;
	    while (i < len) {
	        if (sameValue(array[i], searchElement)) {
	            return true;
	        }
	        i++;
	    }
	
	    return false;
	};
	
	var isArray = Array.isArray || function (arg) {
	    return Object.prototype.toString.call(arg) === '[object Array]';
	};
	
	// Drivers are stored here when `defineDriver()` is called.
	// They are shared across all instances of localForage.
	var DefinedDrivers = {};
	
	var DriverSupport = {};
	
	var DefaultDrivers = {
	    INDEXEDDB: asyncStorage,
	    WEBSQL: webSQLStorage,
	    LOCALSTORAGE: localStorageWrapper
	};
	
	var DefaultDriverOrder = [DefaultDrivers.INDEXEDDB._driver, DefaultDrivers.WEBSQL._driver, DefaultDrivers.LOCALSTORAGE._driver];
	
	var OptionalDriverMethods = ['dropInstance'];
	
	var LibraryMethods = ['clear', 'getItem', 'iterate', 'key', 'keys', 'length', 'removeItem', 'setItem'].concat(OptionalDriverMethods);
	
	var DefaultConfig = {
	    description: '',
	    driver: DefaultDriverOrder.slice(),
	    name: 'localforage',
	    // Default DB size is _JUST UNDER_ 5MB, as it's the highest size
	    // we can use without a prompt.
	    size: 4980736,
	    storeName: 'keyvaluepairs',
	    version: 1.0
	};
	
	function callWhenReady(localForageInstance, libraryMethod) {
	    localForageInstance[libraryMethod] = function () {
	        var _args = arguments;
	        return localForageInstance.ready().then(function () {
	            return localForageInstance[libraryMethod].apply(localForageInstance, _args);
	        });
	    };
	}
	
	function extend() {
	    for (var i = 1; i < arguments.length; i++) {
	        var arg = arguments[i];
	
	        if (arg) {
	            for (var _key in arg) {
	                if (arg.hasOwnProperty(_key)) {
	                    if (isArray(arg[_key])) {
	                        arguments[0][_key] = arg[_key].slice();
	                    } else {
	                        arguments[0][_key] = arg[_key];
	                    }
	                }
	            }
	        }
	    }
	
	    return arguments[0];
	}
	
	var LocalForage = function () {
	    function LocalForage(options) {
	        _classCallCheck(this, LocalForage);
	
	        for (var driverTypeKey in DefaultDrivers) {
	            if (DefaultDrivers.hasOwnProperty(driverTypeKey)) {
	                var driver = DefaultDrivers[driverTypeKey];
	                var driverName = driver._driver;
	                this[driverTypeKey] = driverName;
	
	                if (!DefinedDrivers[driverName]) {
	                    // we don't need to wait for the promise,
	                    // since the default drivers can be defined
	                    // in a blocking manner
	                    this.defineDriver(driver);
	                }
	            }
	        }
	
	        this._defaultConfig = extend({}, DefaultConfig);
	        this._config = extend({}, this._defaultConfig, options);
	        this._driverSet = null;
	        this._initDriver = null;
	        this._ready = false;
	        this._dbInfo = null;
	
	        this._wrapLibraryMethodsWithReady();
	        this.setDriver(this._config.driver)["catch"](function () {});
	    }
	
	    // Set any config values for localForage; can be called anytime before
	    // the first API call (e.g. `getItem`, `setItem`).
	    // We loop through options so we don't overwrite existing config
	    // values.
	
	
	    LocalForage.prototype.config = function config(options) {
	        // If the options argument is an object, we use it to set values.
	        // Otherwise, we return either a specified config value or all
	        // config values.
	        if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
	            // If localforage is ready and fully initialized, we can't set
	            // any new configuration values. Instead, we return an error.
	            if (this._ready) {
	                return new Error("Can't call config() after localforage " + 'has been used.');
	            }
	
	            for (var i in options) {
	                if (i === 'storeName') {
	                    options[i] = options[i].replace(/\W/g, '_');
	                }
	
	                if (i === 'version' && typeof options[i] !== 'number') {
	                    return new Error('Database version must be a number.');
	                }
	
	                this._config[i] = options[i];
	            }
	
	            // after all config options are set and
	            // the driver option is used, try setting it
	            if ('driver' in options && options.driver) {
	                return this.setDriver(this._config.driver);
	            }
	
	            return true;
	        } else if (typeof options === 'string') {
	            return this._config[options];
	        } else {
	            return this._config;
	        }
	    };
	
	    // Used to define a custom driver, shared across all instances of
	    // localForage.
	
	
	    LocalForage.prototype.defineDriver = function defineDriver(driverObject, callback, errorCallback) {
	        var promise = new Promise$1(function (resolve, reject) {
	            try {
	                var driverName = driverObject._driver;
	                var complianceError = new Error('Custom driver not compliant; see ' + 'https://mozilla.github.io/localForage/#definedriver');
	
	                // A driver name should be defined and not overlap with the
	                // library-defined, default drivers.
	                if (!driverObject._driver) {
	                    reject(complianceError);
	                    return;
	                }
	
	                var driverMethods = LibraryMethods.concat('_initStorage');
	                for (var i = 0, len = driverMethods.length; i < len; i++) {
	                    var driverMethodName = driverMethods[i];
	
	                    // when the property is there,
	                    // it should be a method even when optional
	                    var isRequired = !includes(OptionalDriverMethods, driverMethodName);
	                    if ((isRequired || driverObject[driverMethodName]) && typeof driverObject[driverMethodName] !== 'function') {
	                        reject(complianceError);
	                        return;
	                    }
	                }
	
	                var configureMissingMethods = function configureMissingMethods() {
	                    var methodNotImplementedFactory = function methodNotImplementedFactory(methodName) {
	                        return function () {
	                            var error = new Error('Method ' + methodName + ' is not implemented by the current driver');
	                            var promise = Promise$1.reject(error);
	                            executeCallback(promise, arguments[arguments.length - 1]);
	                            return promise;
	                        };
	                    };
	
	                    for (var _i = 0, _len = OptionalDriverMethods.length; _i < _len; _i++) {
	                        var optionalDriverMethod = OptionalDriverMethods[_i];
	                        if (!driverObject[optionalDriverMethod]) {
	                            driverObject[optionalDriverMethod] = methodNotImplementedFactory(optionalDriverMethod);
	                        }
	                    }
	                };
	
	                configureMissingMethods();
	
	                var setDriverSupport = function setDriverSupport(support) {
	                    if (DefinedDrivers[driverName]) {
	                        console.info('Redefining LocalForage driver: ' + driverName);
	                    }
	                    DefinedDrivers[driverName] = driverObject;
	                    DriverSupport[driverName] = support;
	                    // don't use a then, so that we can define
	                    // drivers that have simple _support methods
	                    // in a blocking manner
	                    resolve();
	                };
	
	                if ('_support' in driverObject) {
	                    if (driverObject._support && typeof driverObject._support === 'function') {
	                        driverObject._support().then(setDriverSupport, reject);
	                    } else {
	                        setDriverSupport(!!driverObject._support);
	                    }
	                } else {
	                    setDriverSupport(true);
	                }
	            } catch (e) {
	                reject(e);
	            }
	        });
	
	        executeTwoCallbacks(promise, callback, errorCallback);
	        return promise;
	    };
	
	    LocalForage.prototype.driver = function driver() {
	        return this._driver || null;
	    };
	
	    LocalForage.prototype.getDriver = function getDriver(driverName, callback, errorCallback) {
	        var getDriverPromise = DefinedDrivers[driverName] ? Promise$1.resolve(DefinedDrivers[driverName]) : Promise$1.reject(new Error('Driver not found.'));
	
	        executeTwoCallbacks(getDriverPromise, callback, errorCallback);
	        return getDriverPromise;
	    };
	
	    LocalForage.prototype.getSerializer = function getSerializer(callback) {
	        var serializerPromise = Promise$1.resolve(localforageSerializer);
	        executeTwoCallbacks(serializerPromise, callback);
	        return serializerPromise;
	    };
	
	    LocalForage.prototype.ready = function ready(callback) {
	        var self = this;
	
	        var promise = self._driverSet.then(function () {
	            if (self._ready === null) {
	                self._ready = self._initDriver();
	            }
	
	            return self._ready;
	        });
	
	        executeTwoCallbacks(promise, callback, callback);
	        return promise;
	    };
	
	    LocalForage.prototype.setDriver = function setDriver(drivers, callback, errorCallback) {
	        var self = this;
	
	        if (!isArray(drivers)) {
	            drivers = [drivers];
	        }
	
	        var supportedDrivers = this._getSupportedDrivers(drivers);
	
	        function setDriverToConfig() {
	            self._config.driver = self.driver();
	        }
	
	        function extendSelfWithDriver(driver) {
	            self._extend(driver);
	            setDriverToConfig();
	
	            self._ready = self._initStorage(self._config);
	            return self._ready;
	        }
	
	        function initDriver(supportedDrivers) {
	            return function () {
	                var currentDriverIndex = 0;
	
	                function driverPromiseLoop() {
	                    while (currentDriverIndex < supportedDrivers.length) {
	                        var driverName = supportedDrivers[currentDriverIndex];
	                        currentDriverIndex++;
	
	                        self._dbInfo = null;
	                        self._ready = null;
	
	                        return self.getDriver(driverName).then(extendSelfWithDriver)["catch"](driverPromiseLoop);
	                    }
	
	                    setDriverToConfig();
	                    var error = new Error('No available storage method found.');
	                    self._driverSet = Promise$1.reject(error);
	                    return self._driverSet;
	                }
	
	                return driverPromiseLoop();
	            };
	        }
	
	        // There might be a driver initialization in progress
	        // so wait for it to finish in order to avoid a possible
	        // race condition to set _dbInfo
	        var oldDriverSetDone = this._driverSet !== null ? this._driverSet["catch"](function () {
	            return Promise$1.resolve();
	        }) : Promise$1.resolve();
	
	        this._driverSet = oldDriverSetDone.then(function () {
	            var driverName = supportedDrivers[0];
	            self._dbInfo = null;
	            self._ready = null;
	
	            return self.getDriver(driverName).then(function (driver) {
	                self._driver = driver._driver;
	                setDriverToConfig();
	                self._wrapLibraryMethodsWithReady();
	                self._initDriver = initDriver(supportedDrivers);
	            });
	        })["catch"](function () {
	            setDriverToConfig();
	            var error = new Error('No available storage method found.');
	            self._driverSet = Promise$1.reject(error);
	            return self._driverSet;
	        });
	
	        executeTwoCallbacks(this._driverSet, callback, errorCallback);
	        return this._driverSet;
	    };
	
	    LocalForage.prototype.supports = function supports(driverName) {
	        return !!DriverSupport[driverName];
	    };
	
	    LocalForage.prototype._extend = function _extend(libraryMethodsAndProperties) {
	        extend(this, libraryMethodsAndProperties);
	    };
	
	    LocalForage.prototype._getSupportedDrivers = function _getSupportedDrivers(drivers) {
	        var supportedDrivers = [];
	        for (var i = 0, len = drivers.length; i < len; i++) {
	            var driverName = drivers[i];
	            if (this.supports(driverName)) {
	                supportedDrivers.push(driverName);
	            }
	        }
	        return supportedDrivers;
	    };
	
	    LocalForage.prototype._wrapLibraryMethodsWithReady = function _wrapLibraryMethodsWithReady() {
	        // Add a stub for each driver API method that delays the call to the
	        // corresponding driver method until localForage is ready. These stubs
	        // will be replaced by the driver methods as soon as the driver is
	        // loaded, so there is no performance impact.
	        for (var i = 0, len = LibraryMethods.length; i < len; i++) {
	            callWhenReady(this, LibraryMethods[i]);
	        }
	    };
	
	    LocalForage.prototype.createInstance = function createInstance(options) {
	        return new LocalForage(options);
	    };
	
	    return LocalForage;
	}();
	
	// The actual localForage object that we expose as a module or via a
	// global. It's extended by pulling in one of our other libraries.
	
	
	var localforage_js = new LocalForage();
	
	module.exports = localforage_js;
	
	},{"3":3}]},{},[4])(4)
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 446 */,
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
	            (typeof self !== "undefined" && self) ||
	            window;
	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(scope, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(450);
	// On some exotic environments, it's not clear which object `setimmediate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g = (function() { return this })() || Function("return this")();
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(449);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}


/***/ }),
/* 449 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // In sloppy mode, unbound `this` refers to the global object, fallback to
	  // Function constructor if we're in global strict mode. That is sadly a form
	  // of indirect eval which violates Content Security Policy.
	  (function() { return this })() || Function("return this")()
	);


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(66)))

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * tiny-cookie - A tiny cookie manipulation plugin
	 * https://github.com/Alex1990/tiny-cookie
	 * Under the MIT license | (c) Alex Chao
	 */
	
	!(function(root, factory) {
	
	  // Uses CommonJS, AMD or browser global to create a jQuery plugin.
	  // See: https://github.com/umdjs/umd
	  if (true) {
	    // Expose this plugin as an AMD module. Register an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    // Node/CommonJS module
	    module.exports = factory();
	  } else {
	    // Browser globals 
	    root.Cookie = factory();
	  }
	
	}(this, function() {
	
	  'use strict';
	
	  // The public function which can get/set/remove cookie.
	  function Cookie(key, value, opts) {
	    if (value === void 0) {
	      return Cookie.get(key);
	    } else if (value === null) {
	      Cookie.remove(key);
	    } else {
	      Cookie.set(key, value, opts);
	    }
	  }
	
	  // Check if the cookie is enabled.
	  Cookie.enabled = function() {
	    var key = '__test_key';
	    var enabled;
	
	    document.cookie = key + '=1';
	    enabled = !!document.cookie;
	
	    if (enabled) Cookie.remove(key);
	
	    return enabled;
	  };
	
	  // Get the cookie value by the key.
	  Cookie.get = function(key, raw) {
	    if (typeof key !== 'string' || !key) return null;
	
	    key = '(?:^|; )' + escapeRe(key) + '(?:=([^;]*?))?(?:;|$)';
	
	    var reKey = new RegExp(key);
	    var res = reKey.exec(document.cookie);
	
	    return res !== null ? (raw ? res[1] : decodeURIComponent(res[1])) : null;
	  };
	
	  // Get the cookie's value without decoding.
	  Cookie.getRaw = function(key) {
	    return Cookie.get(key, true);
	  };
	
	  // Set a cookie.
	  Cookie.set = function(key, value, raw, opts) {
	    if (raw !== true) {
	      opts = raw;
	      raw = false;
	    }
	    opts = opts ? convert(opts) : convert({});
	    var cookie = key + '=' + (raw ? value : encodeURIComponent(value)) + opts;
	    document.cookie = cookie;
	  };
	
	  // Set a cookie without encoding the value.
	  Cookie.setRaw = function(key, value, opts) {
	    Cookie.set(key, value, true, opts);
	  };
	
	  // Remove a cookie by the specified key.
	  Cookie.remove = function(key) {
	    Cookie.set(key, 'a', { expires: new Date() });
	  };
	
	  // Helper function
	  // ---------------
	
	  // Escape special characters.
	  function escapeRe(str) {
	    return str.replace(/[.*+?^$|[\](){}\\-]/g, '\\$&');
	  }
	
	  // Convert an object to a cookie option string.
	  function convert(opts) {
	    var res = '';
	
	    for (var p in opts) {
	      if (opts.hasOwnProperty(p)) {
	
	        if (p === 'expires') {
	          var expires = opts[p];
	          if (typeof expires !== 'object') {
	            expires += typeof expires === 'number' ? 'D' : '';
	            expires = computeExpires(expires);
	          }
	          opts[p] = expires.toUTCString();
	        }
	
	        if (p === 'secure') {
	          if (opts[p]) {
	            res += ';' + p;
	          }
	
	          continue;
	        }
	
	        res += ';' + p + '=' + opts[p];
	      }
	    }
	
	    if (!opts.hasOwnProperty('path')) {
	      res += ';path=/';
	    }
	
	    return res;
	  }
	
	  // Return a future date by the given string.
	  function computeExpires(str) {
	    var expires = new Date();
	    var lastCh = str.charAt(str.length - 1);
	    var value = parseInt(str, 10);
	
	    switch (lastCh) {
	      case 'Y': expires.setFullYear(expires.getFullYear() + value); break;
	      case 'M': expires.setMonth(expires.getMonth() + value); break;
	      case 'D': expires.setDate(expires.getDate() + value); break;
	      case 'h': expires.setHours(expires.getHours() + value); break;
	      case 'm': expires.setMinutes(expires.getMinutes() + value); break;
	      case 's': expires.setSeconds(expires.getSeconds() + value); break;
	      default: expires = new Date(str);
	    }
	
	    return expires;
	  }
	
	  return Cookie;
	
	}));


/***/ }),
/* 452 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	if (!window.FileReader) {
	  console.error('Your browser does not support FileReader API!');
	}
	
	exports.default = {
	  name: 'vue-base64-file-upload',
	
	  props: {
	    imageClass: {
	      type: String,
	      default: ''
	    },
	    inputClass: {
	      type: String,
	      default: ''
	    },
	    accept: {
	      type: String,
	      default: 'image/png,image/gif,image/jpeg'
	    },
	    maxSize: {
	      type: Number,
	      default: 10 // megabytes
	    },
	    disablePreview: {
	      type: Boolean,
	      default: false
	    },
	    fileName: {
	      type: String,
	      default: ''
	    },
	    placeholder: {
	      type: String,
	      default: 'Click here to upload image'
	    },
	    defaultPreview: {
	      type: String,
	      default: ''
	    }
	  },
	
	  data: function data() {
	    return {
	      file: null,
	      preview: null,
	      visiblePreview: false
	    };
	  },
	
	
	  computed: {
	    wrapperStyles: function wrapperStyles() {
	      return {
	        'position': 'relative',
	        'width': '100%'
	      };
	    },
	    fileInputStyles: function fileInputStyles() {
	      return {
	        'width': '100%',
	        'position': 'absolute',
	        'top': 0,
	        'left': 0,
	        'right': 0,
	        'bottom': 0,
	        'opacity': 0,
	        'overflow': 'hidden',
	        'outline': 'none',
	        'cursor': 'pointer'
	      };
	    },
	    textInputStyles: function textInputStyles() {
	      return {
	        'width': '100%',
	        'cursor': 'pointer'
	      };
	    },
	    previewImage: function previewImage() {
	      return this.preview || this.defaultPreview;
	    }
	  },
	
	  methods: {
	    onChange: function onChange(e) {
	      var _this = this;
	
	      var files = e.target.files || e.dataTransfer.files;
	
	      if (!files.length) {
	        return;
	      }
	
	      var file = files[0];
	      var size = file.size && file.size / Math.pow(1000, 2);
	
	      // check file max size
	      if (size > this.maxSize) {
	        this.$emit('size-exceeded', size);
	        return;
	      }
	
	      // update file
	      this.file = file;
	      this.$emit('file', file);
	
	      var reader = new FileReader();
	
	      reader.onload = function (e) {
	        var dataURI = e.target.result;
	
	        if (dataURI) {
	          _this.$emit('load', dataURI);
	
	          _this.preview = dataURI;
	        }
	      };
	
	      // read blob url from file data
	      reader.readAsDataURL(file);
	    }
	  },
	
	  template: '\n    <div class="vue-base64-file-upload">\n      <img\n        v-show="previewImage && !disablePreview"\n        :src="previewImage"\n        :class="imageClass" />\n      <div class="vue-base64-file-upload-wrapper" :style="wrapperStyles">\n        <input\n          type="file"\n          @change="onChange"\n          :style="fileInputStyles"\n          :accept=accept />\n        <input\n          type="text"\n          :class="inputClass"\n          :style="textInputStyles"\n          :value="fileName || file && file.name"\n          :placeholder="placeholder"\n          disabled />\n      </div>\n    </div>\n  '
	};


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	var Clipboard = __webpack_require__(348) // FIXME: workaround for browserify
	
	var VueClipboardConfig = {
	  autoSetContainer: false
	};
	
	var VueClipboard = {
	  install: function (Vue) {
	    Vue.prototype.$clipboardConfig = VueClipboardConfig;
	    Vue.prototype.$copyText = function (text, container) {
	      return new Promise(function (resolve, reject) {
	        var fake_el = document.createElement('button');
	        var clipboard = new Clipboard(fake_el, {
	          text: function () { return text },
	          action: function () { return 'copy' },
	          container: typeof container === 'object' ? container : document.body
	        });
	        clipboard.on('success', function (e) {
	          clipboard.destroy();
	          resolve(e);
	        });
	        clipboard.on('error', function (e) {
	          clipboard.destroy();
	          reject(e);
	        });
	        fake_el.click();
	      });
	    };
	
	    Vue.directive('clipboard', {
	      bind: function (el, binding, vnode) {
	        if(binding.arg === 'success') {
	          el._v_clipboard_success = binding.value
	        } else if(binding.arg === 'error') {
	          el._v_clipboard_error = binding.value
	        } else {
	          var clipboard = new Clipboard(el, {
	            text: function () { return binding.value },
	            action: function () { return binding.arg === 'cut' ? 'cut' : 'copy' },
	            container: VueClipboardConfig.autoSetContainer ? el : undefined
	          })
	          clipboard.on('success', function (e) {
	            var callback = el._v_clipboard_success
	            callback && callback(e)
	          })
	          clipboard.on('error', function (e) {
	            var callback = el._v_clipboard_error
	            callback && callback(e)
	          })
	          el._v_clipboard = clipboard
	        }
	      },
	      update: function (el, binding) {
	        if(binding.arg === 'success') {
	          el._v_clipboard_success = binding.value
	        } else if(binding.arg === 'error') {
	          el._v_clipboard_error = binding.value
	        } else {
	          el._v_clipboard.text = function () { return binding.value }
	          el._v_clipboard.action = function () { return binding.arg === 'cut' ? 'cut' : 'copy' }
	        }
	      },
	      unbind: function (el, binding) {
	        if(binding.arg === 'success') {
	          delete el._v_clipboard_success
	        } else if(binding.arg === 'error') {
	          delete el._v_clipboard_error
	        } else {
	          el._v_clipboard.destroy()
	          delete el._v_clipboard
	        }
	      }
	    })
	  },
	  config: VueClipboardConfig
	}
	
	if (true) {
	  module.exports = VueClipboard
	} else if (typeof define == "function" && define.amd) {
	  define([], function() {
	    return VueClipboard
	  })
	}


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	(function () {
	    Number.isInteger = Number.isInteger || function (value) {
	        return typeof value === 'number' &&
	            isFinite(value) &&
	            Math.floor(value) === value;
	    };
	    var Cookie = __webpack_require__(451);
	
	    var VueCookie = {
	
	        install: function (Vue) {
	            Vue.prototype.$cookie = this;
	            Vue.cookie = this;
	        },
	        set: function (name, value, daysOrOptions) {
	            var opts = daysOrOptions;
	            if(Number.isInteger(daysOrOptions)) {
	                opts = {expires: daysOrOptions};
	            }
	            return Cookie.set(name, value, opts);
	        },
	
	        get: function (name) {
	            return Cookie.get(name);
	        },
	
	        delete: function (name, options) {
	            var opts = {expires: -1};
	            if(options !== undefined) {
	                opts = Object.assign(options, opts);
	            }
	            this.set(name, '', opts);
	        }
	    };
	
	    if (true) {
	        module.exports = VueCookie;
	    } else if (typeof define == "function" && define.amd) {
	        define([], function(){ return VueCookie; })
	    } else if (window.Vue) {
	        window.VueCookie = VueCookie;
	        Vue.use(VueCookie);
	    }
	
	})();


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define([], factory);
		else {
			var a = factory();
			for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
		}
	})(this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1);
	
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var config = {
		  debug: false,
		  excludes: []
		};
	
		var standardEvents = ['addpaymentinfo', 'addtocart', 'addtowishlist', 'completeregistration', 'contact', 'customizeproduct', 'donate', 'findlocation', 'initiatecheckout', 'lead', 'pageview', 'purchase', 'schedule', 'search', 'starttrial', 'submitapplication', 'subscribe', 'viewcontent'];
	
		var _fbqEnabled = function _fbqEnabled() {
		  if (typeof window.fbq === 'undefined') {
		    if (config.debug) {
		      console.log('[Vue Facebook Pixel]: `window.fbq` is not defined, skipping');
		    }
	
		    return false;
		  }
	
		  return true;
		};
	
		var init = function init(appId) {
		  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
		  if (!_fbqEnabled()) return;
	
		  if (config.debug) {
		    console.log('[Vue Facebook Pixel] Initializing app ' + appId);
		  }
	
		  query('init', appId, data);
		};
	
		var event = function event(name) {
		  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
		  if (!_fbqEnabled()) return;
	
		  if (config.debug) {
		    console.groupCollapsed('[Vue Facebook Pixel] Track event "' + name + '"');
		    console.log('With data: ' + data);
		    console.groupEnd();
		  }
	
		  if (!standardEvents.includes(name.toLowerCase())) query('trackCustom', name, data);else query('track', name, data);
		};
	
		var query = function query() {
		  var _window;
	
		  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
		    args[_key] = arguments[_key];
		  }
	
		  if (!_fbqEnabled()) return;
	
		  if (config.debug) {
		    var _console;
	
		    console.groupCollapsed('[Vue Facebook Pixel] Raw query');
		    (_console = console).log.apply(_console, ['With data: '].concat(args));
		    console.groupEnd();
		  }
	
		  (_window = window).fbq.apply(_window, args);
		};
	
		var install = function install(Vue) {
		  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
		  var router = options.router,
		      debug = options.debug,
		      excludeRoutes = options.excludeRoutes;
	
	
		  config.excludes = excludeRoutes || config.excludes;
		  config.debug = !!debug;
	
		  if (!Vue.analytics) {
		    Vue.analytics = {};
		  }
	
		  if (!Vue.prototype.$analytics) {
		    Vue.prototype.$analytics = {};
		  }
	
		  Vue.analytics.fbq = { init: init, event: event, query: query };
		  Vue.prototype.$analytics.fbq = { init: init, event: event, query: query };
	
		  if (router) {
		    var excludes = config.excludes;
	
	
		    router.afterEach(function (_ref) {
		      var path = _ref.path,
		          name = _ref.name;
	
		      if (excludes.length && excludes.indexOf(name) !== -1) {
		        return;
		      }
	
		      Vue.analytics.fbq.event('PageView');
		    });
		  }
		};
	
		exports.default = { install: install };
	
	/***/ })
	/******/ ])
	});
	;

/***/ }),
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	  * vue-router v2.8.1
	  * (c) 2017 Evan You
	  * @license MIT
	  */
	'use strict';
	
	/*  */
	
	function assert (condition, message) {
	  if (!condition) {
	    throw new Error(("[vue-router] " + message))
	  }
	}
	
	function warn (condition, message) {
	  if (false) {
	    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
	  }
	}
	
	function isError (err) {
	  return Object.prototype.toString.call(err).indexOf('Error') > -1
	}
	
	var View = {
	  name: 'router-view',
	  functional: true,
	  props: {
	    name: {
	      type: String,
	      default: 'default'
	    }
	  },
	  render: function render (_, ref) {
	    var props = ref.props;
	    var children = ref.children;
	    var parent = ref.parent;
	    var data = ref.data;
	
	    data.routerView = true;
	
	    // directly use parent context's createElement() function
	    // so that components rendered by router-view can resolve named slots
	    var h = parent.$createElement;
	    var name = props.name;
	    var route = parent.$route;
	    var cache = parent._routerViewCache || (parent._routerViewCache = {});
	
	    // determine current view depth, also check to see if the tree
	    // has been toggled inactive but kept-alive.
	    var depth = 0;
	    var inactive = false;
	    while (parent && parent._routerRoot !== parent) {
	      if (parent.$vnode && parent.$vnode.data.routerView) {
	        depth++;
	      }
	      if (parent._inactive) {
	        inactive = true;
	      }
	      parent = parent.$parent;
	    }
	    data.routerViewDepth = depth;
	
	    // render previous view if the tree is inactive and kept-alive
	    if (inactive) {
	      return h(cache[name], data, children)
	    }
	
	    var matched = route.matched[depth];
	    // render empty node if no matched route
	    if (!matched) {
	      cache[name] = null;
	      return h()
	    }
	
	    var component = cache[name] = matched.components[name];
	
	    // attach instance registration hook
	    // this will be called in the instance's injected lifecycle hooks
	    data.registerRouteInstance = function (vm, val) {
	      // val could be undefined for unregistration
	      var current = matched.instances[name];
	      if (
	        (val && current !== vm) ||
	        (!val && current === vm)
	      ) {
	        matched.instances[name] = val;
	      }
	    }
	
	    // also register instance in prepatch hook
	    // in case the same component instance is reused across different routes
	    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
	      matched.instances[name] = vnode.componentInstance;
	    };
	
	    // resolve props
	    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
	    if (propsToPass) {
	      // clone to prevent mutation
	      propsToPass = data.props = extend({}, propsToPass);
	      // pass non-declared props as attrs
	      var attrs = data.attrs = data.attrs || {};
	      for (var key in propsToPass) {
	        if (!component.props || !(key in component.props)) {
	          attrs[key] = propsToPass[key];
	          delete propsToPass[key];
	        }
	      }
	    }
	
	    return h(component, data, children)
	  }
	};
	
	function resolveProps (route, config) {
	  switch (typeof config) {
	    case 'undefined':
	      return
	    case 'object':
	      return config
	    case 'function':
	      return config(route)
	    case 'boolean':
	      return config ? route.params : undefined
	    default:
	      if (false) {
	        warn(
	          false,
	          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
	          "expecting an object, function or boolean."
	        );
	      }
	  }
	}
	
	function extend (to, from) {
	  for (var key in from) {
	    to[key] = from[key];
	  }
	  return to
	}
	
	/*  */
	
	var encodeReserveRE = /[!'()*]/g;
	var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
	var commaRE = /%2C/g;
	
	// fixed encodeURIComponent which is more conformant to RFC3986:
	// - escapes [!'()*]
	// - preserve commas
	var encode = function (str) { return encodeURIComponent(str)
	  .replace(encodeReserveRE, encodeReserveReplacer)
	  .replace(commaRE, ','); };
	
	var decode = decodeURIComponent;
	
	function resolveQuery (
	  query,
	  extraQuery,
	  _parseQuery
	) {
	  if ( extraQuery === void 0 ) extraQuery = {};
	
	  var parse = _parseQuery || parseQuery;
	  var parsedQuery;
	  try {
	    parsedQuery = parse(query || '');
	  } catch (e) {
	    ("production") !== 'production' && warn(false, e.message);
	    parsedQuery = {};
	  }
	  for (var key in extraQuery) {
	    parsedQuery[key] = extraQuery[key];
	  }
	  return parsedQuery
	}
	
	function parseQuery (query) {
	  var res = {};
	
	  query = query.trim().replace(/^(\?|#|&)/, '');
	
	  if (!query) {
	    return res
	  }
	
	  query.split('&').forEach(function (param) {
	    var parts = param.replace(/\+/g, ' ').split('=');
	    var key = decode(parts.shift());
	    var val = parts.length > 0
	      ? decode(parts.join('='))
	      : null;
	
	    if (res[key] === undefined) {
	      res[key] = val;
	    } else if (Array.isArray(res[key])) {
	      res[key].push(val);
	    } else {
	      res[key] = [res[key], val];
	    }
	  });
	
	  return res
	}
	
	function stringifyQuery (obj) {
	  var res = obj ? Object.keys(obj).map(function (key) {
	    var val = obj[key];
	
	    if (val === undefined) {
	      return ''
	    }
	
	    if (val === null) {
	      return encode(key)
	    }
	
	    if (Array.isArray(val)) {
	      var result = [];
	      val.forEach(function (val2) {
	        if (val2 === undefined) {
	          return
	        }
	        if (val2 === null) {
	          result.push(encode(key));
	        } else {
	          result.push(encode(key) + '=' + encode(val2));
	        }
	      });
	      return result.join('&')
	    }
	
	    return encode(key) + '=' + encode(val)
	  }).filter(function (x) { return x.length > 0; }).join('&') : null;
	  return res ? ("?" + res) : ''
	}
	
	/*  */
	
	
	var trailingSlashRE = /\/?$/;
	
	function createRoute (
	  record,
	  location,
	  redirectedFrom,
	  router
	) {
	  var stringifyQuery$$1 = router && router.options.stringifyQuery;
	
	  var query = location.query || {};
	  try {
	    query = clone(query);
	  } catch (e) {}
	
	  var route = {
	    name: location.name || (record && record.name),
	    meta: (record && record.meta) || {},
	    path: location.path || '/',
	    hash: location.hash || '',
	    query: query,
	    params: location.params || {},
	    fullPath: getFullPath(location, stringifyQuery$$1),
	    matched: record ? formatMatch(record) : []
	  };
	  if (redirectedFrom) {
	    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
	  }
	  return Object.freeze(route)
	}
	
	function clone (value) {
	  if (Array.isArray(value)) {
	    return value.map(clone)
	  } else if (value && typeof value === 'object') {
	    var res = {};
	    for (var key in value) {
	      res[key] = clone(value[key]);
	    }
	    return res
	  } else {
	    return value
	  }
	}
	
	// the starting route that represents the initial state
	var START = createRoute(null, {
	  path: '/'
	});
	
	function formatMatch (record) {
	  var res = [];
	  while (record) {
	    res.unshift(record);
	    record = record.parent;
	  }
	  return res
	}
	
	function getFullPath (
	  ref,
	  _stringifyQuery
	) {
	  var path = ref.path;
	  var query = ref.query; if ( query === void 0 ) query = {};
	  var hash = ref.hash; if ( hash === void 0 ) hash = '';
	
	  var stringify = _stringifyQuery || stringifyQuery;
	  return (path || '/') + stringify(query) + hash
	}
	
	function isSameRoute (a, b) {
	  if (b === START) {
	    return a === b
	  } else if (!b) {
	    return false
	  } else if (a.path && b.path) {
	    return (
	      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
	      a.hash === b.hash &&
	      isObjectEqual(a.query, b.query)
	    )
	  } else if (a.name && b.name) {
	    return (
	      a.name === b.name &&
	      a.hash === b.hash &&
	      isObjectEqual(a.query, b.query) &&
	      isObjectEqual(a.params, b.params)
	    )
	  } else {
	    return false
	  }
	}
	
	function isObjectEqual (a, b) {
	  if ( a === void 0 ) a = {};
	  if ( b === void 0 ) b = {};
	
	  // handle null value #1566
	  if (!a || !b) { return a === b }
	  var aKeys = Object.keys(a);
	  var bKeys = Object.keys(b);
	  if (aKeys.length !== bKeys.length) {
	    return false
	  }
	  return aKeys.every(function (key) {
	    var aVal = a[key];
	    var bVal = b[key];
	    // check nested equality
	    if (typeof aVal === 'object' && typeof bVal === 'object') {
	      return isObjectEqual(aVal, bVal)
	    }
	    return String(aVal) === String(bVal)
	  })
	}
	
	function isIncludedRoute (current, target) {
	  return (
	    current.path.replace(trailingSlashRE, '/').indexOf(
	      target.path.replace(trailingSlashRE, '/')
	    ) === 0 &&
	    (!target.hash || current.hash === target.hash) &&
	    queryIncludes(current.query, target.query)
	  )
	}
	
	function queryIncludes (current, target) {
	  for (var key in target) {
	    if (!(key in current)) {
	      return false
	    }
	  }
	  return true
	}
	
	/*  */
	
	// work around weird flow bug
	var toTypes = [String, Object];
	var eventTypes = [String, Array];
	
	var Link = {
	  name: 'router-link',
	  props: {
	    to: {
	      type: toTypes,
	      required: true
	    },
	    tag: {
	      type: String,
	      default: 'a'
	    },
	    exact: Boolean,
	    append: Boolean,
	    replace: Boolean,
	    activeClass: String,
	    exactActiveClass: String,
	    event: {
	      type: eventTypes,
	      default: 'click'
	    }
	  },
	  render: function render (h) {
	    var this$1 = this;
	
	    var router = this.$router;
	    var current = this.$route;
	    var ref = router.resolve(this.to, current, this.append);
	    var location = ref.location;
	    var route = ref.route;
	    var href = ref.href;
	
	    var classes = {};
	    var globalActiveClass = router.options.linkActiveClass;
	    var globalExactActiveClass = router.options.linkExactActiveClass;
	    // Support global empty active class
	    var activeClassFallback = globalActiveClass == null
	            ? 'router-link-active'
	            : globalActiveClass;
	    var exactActiveClassFallback = globalExactActiveClass == null
	            ? 'router-link-exact-active'
	            : globalExactActiveClass;
	    var activeClass = this.activeClass == null
	            ? activeClassFallback
	            : this.activeClass;
	    var exactActiveClass = this.exactActiveClass == null
	            ? exactActiveClassFallback
	            : this.exactActiveClass;
	    var compareTarget = location.path
	      ? createRoute(null, location, null, router)
	      : route;
	
	    classes[exactActiveClass] = isSameRoute(current, compareTarget);
	    classes[activeClass] = this.exact
	      ? classes[exactActiveClass]
	      : isIncludedRoute(current, compareTarget);
	
	    var handler = function (e) {
	      if (guardEvent(e)) {
	        if (this$1.replace) {
	          router.replace(location);
	        } else {
	          router.push(location);
	        }
	      }
	    };
	
	    var on = { click: guardEvent };
	    if (Array.isArray(this.event)) {
	      this.event.forEach(function (e) { on[e] = handler; });
	    } else {
	      on[this.event] = handler;
	    }
	
	    var data = {
	      class: classes
	    };
	
	    if (this.tag === 'a') {
	      data.on = on;
	      data.attrs = { href: href };
	    } else {
	      // find the first <a> child and apply listener and href
	      var a = findAnchor(this.$slots.default);
	      if (a) {
	        // in case the <a> is a static node
	        a.isStatic = false;
	        var extend = _Vue.util.extend;
	        var aData = a.data = extend({}, a.data);
	        aData.on = on;
	        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
	        aAttrs.href = href;
	      } else {
	        // doesn't have <a> child, apply listener to self
	        data.on = on;
	      }
	    }
	
	    return h(this.tag, data, this.$slots.default)
	  }
	};
	
	function guardEvent (e) {
	  // don't redirect with control keys
	  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
	  // don't redirect when preventDefault called
	  if (e.defaultPrevented) { return }
	  // don't redirect on right click
	  if (e.button !== undefined && e.button !== 0) { return }
	  // don't redirect if `target="_blank"`
	  if (e.currentTarget && e.currentTarget.getAttribute) {
	    var target = e.currentTarget.getAttribute('target');
	    if (/\b_blank\b/i.test(target)) { return }
	  }
	  // this may be a Weex event which doesn't have this method
	  if (e.preventDefault) {
	    e.preventDefault();
	  }
	  return true
	}
	
	function findAnchor (children) {
	  if (children) {
	    var child;
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      if (child.tag === 'a') {
	        return child
	      }
	      if (child.children && (child = findAnchor(child.children))) {
	        return child
	      }
	    }
	  }
	}
	
	var _Vue;
	
	function install (Vue) {
	  if (install.installed && _Vue === Vue) { return }
	  install.installed = true;
	
	  _Vue = Vue;
	
	  var isDef = function (v) { return v !== undefined; };
	
	  var registerInstance = function (vm, callVal) {
	    var i = vm.$options._parentVnode;
	    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
	      i(vm, callVal);
	    }
	  };
	
	  Vue.mixin({
	    beforeCreate: function beforeCreate () {
	      if (isDef(this.$options.router)) {
	        this._routerRoot = this;
	        this._router = this.$options.router;
	        this._router.init(this);
	        Vue.util.defineReactive(this, '_route', this._router.history.current);
	      } else {
	        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
	      }
	      registerInstance(this, this);
	    },
	    destroyed: function destroyed () {
	      registerInstance(this);
	    }
	  });
	
	  Object.defineProperty(Vue.prototype, '$router', {
	    get: function get () { return this._routerRoot._router }
	  });
	
	  Object.defineProperty(Vue.prototype, '$route', {
	    get: function get () { return this._routerRoot._route }
	  });
	
	  Vue.component('router-view', View);
	  Vue.component('router-link', Link);
	
	  var strats = Vue.config.optionMergeStrategies;
	  // use the same hook merging strategy for route hooks
	  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
	}
	
	/*  */
	
	var inBrowser = typeof window !== 'undefined';
	
	/*  */
	
	function resolvePath (
	  relative,
	  base,
	  append
	) {
	  var firstChar = relative.charAt(0);
	  if (firstChar === '/') {
	    return relative
	  }
	
	  if (firstChar === '?' || firstChar === '#') {
	    return base + relative
	  }
	
	  var stack = base.split('/');
	
	  // remove trailing segment if:
	  // - not appending
	  // - appending to trailing slash (last segment is empty)
	  if (!append || !stack[stack.length - 1]) {
	    stack.pop();
	  }
	
	  // resolve relative path
	  var segments = relative.replace(/^\//, '').split('/');
	  for (var i = 0; i < segments.length; i++) {
	    var segment = segments[i];
	    if (segment === '..') {
	      stack.pop();
	    } else if (segment !== '.') {
	      stack.push(segment);
	    }
	  }
	
	  // ensure leading slash
	  if (stack[0] !== '') {
	    stack.unshift('');
	  }
	
	  return stack.join('/')
	}
	
	function parsePath (path) {
	  var hash = '';
	  var query = '';
	
	  var hashIndex = path.indexOf('#');
	  if (hashIndex >= 0) {
	    hash = path.slice(hashIndex);
	    path = path.slice(0, hashIndex);
	  }
	
	  var queryIndex = path.indexOf('?');
	  if (queryIndex >= 0) {
	    query = path.slice(queryIndex + 1);
	    path = path.slice(0, queryIndex);
	  }
	
	  return {
	    path: path,
	    query: query,
	    hash: hash
	  }
	}
	
	function cleanPath (path) {
	  return path.replace(/\/\//g, '/')
	}
	
	var isarray = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};
	
	/**
	 * Expose `pathToRegexp`.
	 */
	var pathToRegexp_1 = pathToRegexp;
	var parse_1 = parse;
	var compile_1 = compile;
	var tokensToFunction_1 = tokensToFunction;
	var tokensToRegExp_1 = tokensToRegExp;
	
	/**
	 * The main path matching regexp utility.
	 *
	 * @type {RegExp}
	 */
	var PATH_REGEXP = new RegExp([
	  // Match escaped characters that would otherwise appear in future matches.
	  // This allows the user to escape special characters that won't transform.
	  '(\\\\.)',
	  // Match Express-style parameters and un-named parameters with a prefix
	  // and optional suffixes. Matches appear as:
	  //
	  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
	  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
	  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
	  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
	].join('|'), 'g');
	
	/**
	 * Parse a string for the raw tokens.
	 *
	 * @param  {string}  str
	 * @param  {Object=} options
	 * @return {!Array}
	 */
	function parse (str, options) {
	  var tokens = [];
	  var key = 0;
	  var index = 0;
	  var path = '';
	  var defaultDelimiter = options && options.delimiter || '/';
	  var res;
	
	  while ((res = PATH_REGEXP.exec(str)) != null) {
	    var m = res[0];
	    var escaped = res[1];
	    var offset = res.index;
	    path += str.slice(index, offset);
	    index = offset + m.length;
	
	    // Ignore already escaped sequences.
	    if (escaped) {
	      path += escaped[1];
	      continue
	    }
	
	    var next = str[index];
	    var prefix = res[2];
	    var name = res[3];
	    var capture = res[4];
	    var group = res[5];
	    var modifier = res[6];
	    var asterisk = res[7];
	
	    // Push the current path onto the tokens.
	    if (path) {
	      tokens.push(path);
	      path = '';
	    }
	
	    var partial = prefix != null && next != null && next !== prefix;
	    var repeat = modifier === '+' || modifier === '*';
	    var optional = modifier === '?' || modifier === '*';
	    var delimiter = res[2] || defaultDelimiter;
	    var pattern = capture || group;
	
	    tokens.push({
	      name: name || key++,
	      prefix: prefix || '',
	      delimiter: delimiter,
	      optional: optional,
	      repeat: repeat,
	      partial: partial,
	      asterisk: !!asterisk,
	      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
	    });
	  }
	
	  // Match any characters still remaining.
	  if (index < str.length) {
	    path += str.substr(index);
	  }
	
	  // If the path exists, push it onto the end.
	  if (path) {
	    tokens.push(path);
	  }
	
	  return tokens
	}
	
	/**
	 * Compile a string to a template function for the path.
	 *
	 * @param  {string}             str
	 * @param  {Object=}            options
	 * @return {!function(Object=, Object=)}
	 */
	function compile (str, options) {
	  return tokensToFunction(parse(str, options))
	}
	
	/**
	 * Prettier encoding of URI path segments.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeURIComponentPretty (str) {
	  return encodeURI(str).replace(/[\/?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeAsterisk (str) {
	  return encodeURI(str).replace(/[?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Expose a method for transforming tokens into the path function.
	 */
	function tokensToFunction (tokens) {
	  // Compile all the tokens into regexps.
	  var matches = new Array(tokens.length);
	
	  // Compile all the patterns before compilation.
	  for (var i = 0; i < tokens.length; i++) {
	    if (typeof tokens[i] === 'object') {
	      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
	    }
	  }
	
	  return function (obj, opts) {
	    var path = '';
	    var data = obj || {};
	    var options = opts || {};
	    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;
	
	    for (var i = 0; i < tokens.length; i++) {
	      var token = tokens[i];
	
	      if (typeof token === 'string') {
	        path += token;
	
	        continue
	      }
	
	      var value = data[token.name];
	      var segment;
	
	      if (value == null) {
	        if (token.optional) {
	          // Prepend partial segment prefixes.
	          if (token.partial) {
	            path += token.prefix;
	          }
	
	          continue
	        } else {
	          throw new TypeError('Expected "' + token.name + '" to be defined')
	        }
	      }
	
	      if (isarray(value)) {
	        if (!token.repeat) {
	          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
	        }
	
	        if (value.length === 0) {
	          if (token.optional) {
	            continue
	          } else {
	            throw new TypeError('Expected "' + token.name + '" to not be empty')
	          }
	        }
	
	        for (var j = 0; j < value.length; j++) {
	          segment = encode(value[j]);
	
	          if (!matches[i].test(segment)) {
	            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
	          }
	
	          path += (j === 0 ? token.prefix : token.delimiter) + segment;
	        }
	
	        continue
	      }
	
	      segment = token.asterisk ? encodeAsterisk(value) : encode(value);
	
	      if (!matches[i].test(segment)) {
	        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
	      }
	
	      path += token.prefix + segment;
	    }
	
	    return path
	  }
	}
	
	/**
	 * Escape a regular expression string.
	 *
	 * @param  {string} str
	 * @return {string}
	 */
	function escapeString (str) {
	  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
	}
	
	/**
	 * Escape the capturing group by escaping special characters and meaning.
	 *
	 * @param  {string} group
	 * @return {string}
	 */
	function escapeGroup (group) {
	  return group.replace(/([=!:$\/()])/g, '\\$1')
	}
	
	/**
	 * Attach the keys as a property of the regexp.
	 *
	 * @param  {!RegExp} re
	 * @param  {Array}   keys
	 * @return {!RegExp}
	 */
	function attachKeys (re, keys) {
	  re.keys = keys;
	  return re
	}
	
	/**
	 * Get the flags for a regexp from the options.
	 *
	 * @param  {Object} options
	 * @return {string}
	 */
	function flags (options) {
	  return options.sensitive ? '' : 'i'
	}
	
	/**
	 * Pull out keys from a regexp.
	 *
	 * @param  {!RegExp} path
	 * @param  {!Array}  keys
	 * @return {!RegExp}
	 */
	function regexpToRegexp (path, keys) {
	  // Use a negative lookahead to match only capturing groups.
	  var groups = path.source.match(/\((?!\?)/g);
	
	  if (groups) {
	    for (var i = 0; i < groups.length; i++) {
	      keys.push({
	        name: i,
	        prefix: null,
	        delimiter: null,
	        optional: false,
	        repeat: false,
	        partial: false,
	        asterisk: false,
	        pattern: null
	      });
	    }
	  }
	
	  return attachKeys(path, keys)
	}
	
	/**
	 * Transform an array into a regexp.
	 *
	 * @param  {!Array}  path
	 * @param  {Array}   keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function arrayToRegexp (path, keys, options) {
	  var parts = [];
	
	  for (var i = 0; i < path.length; i++) {
	    parts.push(pathToRegexp(path[i], keys, options).source);
	  }
	
	  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));
	
	  return attachKeys(regexp, keys)
	}
	
	/**
	 * Create a path regexp from string input.
	 *
	 * @param  {string}  path
	 * @param  {!Array}  keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function stringToRegexp (path, keys, options) {
	  return tokensToRegExp(parse(path, options), keys, options)
	}
	
	/**
	 * Expose a function for taking tokens and returning a RegExp.
	 *
	 * @param  {!Array}          tokens
	 * @param  {(Array|Object)=} keys
	 * @param  {Object=}         options
	 * @return {!RegExp}
	 */
	function tokensToRegExp (tokens, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options);
	    keys = [];
	  }
	
	  options = options || {};
	
	  var strict = options.strict;
	  var end = options.end !== false;
	  var route = '';
	
	  // Iterate over the tokens and create our regexp string.
	  for (var i = 0; i < tokens.length; i++) {
	    var token = tokens[i];
	
	    if (typeof token === 'string') {
	      route += escapeString(token);
	    } else {
	      var prefix = escapeString(token.prefix);
	      var capture = '(?:' + token.pattern + ')';
	
	      keys.push(token);
	
	      if (token.repeat) {
	        capture += '(?:' + prefix + capture + ')*';
	      }
	
	      if (token.optional) {
	        if (!token.partial) {
	          capture = '(?:' + prefix + '(' + capture + '))?';
	        } else {
	          capture = prefix + '(' + capture + ')?';
	        }
	      } else {
	        capture = prefix + '(' + capture + ')';
	      }
	
	      route += capture;
	    }
	  }
	
	  var delimiter = escapeString(options.delimiter || '/');
	  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
	
	  // In non-strict mode we allow a slash at the end of match. If the path to
	  // match already ends with a slash, we remove it for consistency. The slash
	  // is valid at the end of a path match, not in the middle. This is important
	  // in non-ending mode, where "/test/" shouldn't match "/test//route".
	  if (!strict) {
	    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
	  }
	
	  if (end) {
	    route += '$';
	  } else {
	    // In non-ending mode, we need the capturing groups to match as much as
	    // possible by using a positive lookahead to the end or next path segment.
	    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
	  }
	
	  return attachKeys(new RegExp('^' + route, flags(options)), keys)
	}
	
	/**
	 * Normalize the given path string, returning a regular expression.
	 *
	 * An empty array can be passed in for the keys, which will hold the
	 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
	 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
	 *
	 * @param  {(string|RegExp|Array)} path
	 * @param  {(Array|Object)=}       keys
	 * @param  {Object=}               options
	 * @return {!RegExp}
	 */
	function pathToRegexp (path, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options);
	    keys = [];
	  }
	
	  options = options || {};
	
	  if (path instanceof RegExp) {
	    return regexpToRegexp(path, /** @type {!Array} */ (keys))
	  }
	
	  if (isarray(path)) {
	    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
	  }
	
	  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
	}
	
	pathToRegexp_1.parse = parse_1;
	pathToRegexp_1.compile = compile_1;
	pathToRegexp_1.tokensToFunction = tokensToFunction_1;
	pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;
	
	/*  */
	
	// $flow-disable-line
	var regexpCompileCache = Object.create(null);
	
	function fillParams (
	  path,
	  params,
	  routeMsg
	) {
	  try {
	    var filler =
	      regexpCompileCache[path] ||
	      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
	    return filler(params || {}, { pretty: true })
	  } catch (e) {
	    if (false) {
	      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
	    }
	    return ''
	  }
	}
	
	/*  */
	
	function createRouteMap (
	  routes,
	  oldPathList,
	  oldPathMap,
	  oldNameMap
	) {
	  // the path list is used to control path matching priority
	  var pathList = oldPathList || [];
	  // $flow-disable-line
	  var pathMap = oldPathMap || Object.create(null);
	  // $flow-disable-line
	  var nameMap = oldNameMap || Object.create(null);
	
	  routes.forEach(function (route) {
	    addRouteRecord(pathList, pathMap, nameMap, route);
	  });
	
	  // ensure wildcard routes are always at the end
	  for (var i = 0, l = pathList.length; i < l; i++) {
	    if (pathList[i] === '*') {
	      pathList.push(pathList.splice(i, 1)[0]);
	      l--;
	      i--;
	    }
	  }
	
	  return {
	    pathList: pathList,
	    pathMap: pathMap,
	    nameMap: nameMap
	  }
	}
	
	function addRouteRecord (
	  pathList,
	  pathMap,
	  nameMap,
	  route,
	  parent,
	  matchAs
	) {
	  var path = route.path;
	  var name = route.name;
	  if (false) {
	    assert(path != null, "\"path\" is required in a route configuration.");
	    assert(
	      typeof route.component !== 'string',
	      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
	      "string id. Use an actual component instead."
	    );
	  }
	
	  var pathToRegexpOptions = route.pathToRegexpOptions || {};
	  var normalizedPath = normalizePath(
	    path,
	    parent,
	    pathToRegexpOptions.strict
	  );
	
	  if (typeof route.caseSensitive === 'boolean') {
	    pathToRegexpOptions.sensitive = route.caseSensitive;
	  }
	
	  var record = {
	    path: normalizedPath,
	    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
	    components: route.components || { default: route.component },
	    instances: {},
	    name: name,
	    parent: parent,
	    matchAs: matchAs,
	    redirect: route.redirect,
	    beforeEnter: route.beforeEnter,
	    meta: route.meta || {},
	    props: route.props == null
	      ? {}
	      : route.components
	        ? route.props
	        : { default: route.props }
	  };
	
	  if (route.children) {
	    // Warn if route is named, does not redirect and has a default child route.
	    // If users navigate to this route by name, the default child will
	    // not be rendered (GH Issue #629)
	    if (false) {
	      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
	        warn(
	          false,
	          "Named Route '" + (route.name) + "' has a default child route. " +
	          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
	          "the default child route will not be rendered. Remove the name from " +
	          "this route and use the name of the default child route for named " +
	          "links instead."
	        );
	      }
	    }
	    route.children.forEach(function (child) {
	      var childMatchAs = matchAs
	        ? cleanPath((matchAs + "/" + (child.path)))
	        : undefined;
	      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
	    });
	  }
	
	  if (route.alias !== undefined) {
	    var aliases = Array.isArray(route.alias)
	      ? route.alias
	      : [route.alias];
	
	    aliases.forEach(function (alias) {
	      var aliasRoute = {
	        path: alias,
	        children: route.children
	      };
	      addRouteRecord(
	        pathList,
	        pathMap,
	        nameMap,
	        aliasRoute,
	        parent,
	        record.path || '/' // matchAs
	      );
	    });
	  }
	
	  if (!pathMap[record.path]) {
	    pathList.push(record.path);
	    pathMap[record.path] = record;
	  }
	
	  if (name) {
	    if (!nameMap[name]) {
	      nameMap[name] = record;
	    } else if (false) {
	      warn(
	        false,
	        "Duplicate named routes definition: " +
	        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
	      );
	    }
	  }
	}
	
	function compileRouteRegex (path, pathToRegexpOptions) {
	  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
	  if (false) {
	    var keys = Object.create(null);
	    regex.keys.forEach(function (key) {
	      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
	      keys[key.name] = true;
	    });
	  }
	  return regex
	}
	
	function normalizePath (path, parent, strict) {
	  if (!strict) { path = path.replace(/\/$/, ''); }
	  if (path[0] === '/') { return path }
	  if (parent == null) { return path }
	  return cleanPath(((parent.path) + "/" + path))
	}
	
	/*  */
	
	
	function normalizeLocation (
	  raw,
	  current,
	  append,
	  router
	) {
	  var next = typeof raw === 'string' ? { path: raw } : raw;
	  // named target
	  if (next.name || next._normalized) {
	    return next
	  }
	
	  // relative params
	  if (!next.path && next.params && current) {
	    next = assign({}, next);
	    next._normalized = true;
	    var params = assign(assign({}, current.params), next.params);
	    if (current.name) {
	      next.name = current.name;
	      next.params = params;
	    } else if (current.matched.length) {
	      var rawPath = current.matched[current.matched.length - 1].path;
	      next.path = fillParams(rawPath, params, ("path " + (current.path)));
	    } else if (false) {
	      warn(false, "relative params navigation requires a current route.");
	    }
	    return next
	  }
	
	  var parsedPath = parsePath(next.path || '');
	  var basePath = (current && current.path) || '/';
	  var path = parsedPath.path
	    ? resolvePath(parsedPath.path, basePath, append || next.append)
	    : basePath;
	
	  var query = resolveQuery(
	    parsedPath.query,
	    next.query,
	    router && router.options.parseQuery
	  );
	
	  var hash = next.hash || parsedPath.hash;
	  if (hash && hash.charAt(0) !== '#') {
	    hash = "#" + hash;
	  }
	
	  return {
	    _normalized: true,
	    path: path,
	    query: query,
	    hash: hash
	  }
	}
	
	function assign (a, b) {
	  for (var key in b) {
	    a[key] = b[key];
	  }
	  return a
	}
	
	/*  */
	
	
	function createMatcher (
	  routes,
	  router
	) {
	  var ref = createRouteMap(routes);
	  var pathList = ref.pathList;
	  var pathMap = ref.pathMap;
	  var nameMap = ref.nameMap;
	
	  function addRoutes (routes) {
	    createRouteMap(routes, pathList, pathMap, nameMap);
	  }
	
	  function match (
	    raw,
	    currentRoute,
	    redirectedFrom
	  ) {
	    var location = normalizeLocation(raw, currentRoute, false, router);
	    var name = location.name;
	
	    if (name) {
	      var record = nameMap[name];
	      if (false) {
	        warn(record, ("Route with name '" + name + "' does not exist"));
	      }
	      if (!record) { return _createRoute(null, location) }
	      var paramNames = record.regex.keys
	        .filter(function (key) { return !key.optional; })
	        .map(function (key) { return key.name; });
	
	      if (typeof location.params !== 'object') {
	        location.params = {};
	      }
	
	      if (currentRoute && typeof currentRoute.params === 'object') {
	        for (var key in currentRoute.params) {
	          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
	            location.params[key] = currentRoute.params[key];
	          }
	        }
	      }
	
	      if (record) {
	        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
	        return _createRoute(record, location, redirectedFrom)
	      }
	    } else if (location.path) {
	      location.params = {};
	      for (var i = 0; i < pathList.length; i++) {
	        var path = pathList[i];
	        var record$1 = pathMap[path];
	        if (matchRoute(record$1.regex, location.path, location.params)) {
	          return _createRoute(record$1, location, redirectedFrom)
	        }
	      }
	    }
	    // no match
	    return _createRoute(null, location)
	  }
	
	  function redirect (
	    record,
	    location
	  ) {
	    var originalRedirect = record.redirect;
	    var redirect = typeof originalRedirect === 'function'
	        ? originalRedirect(createRoute(record, location, null, router))
	        : originalRedirect;
	
	    if (typeof redirect === 'string') {
	      redirect = { path: redirect };
	    }
	
	    if (!redirect || typeof redirect !== 'object') {
	      if (false) {
	        warn(
	          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
	        );
	      }
	      return _createRoute(null, location)
	    }
	
	    var re = redirect;
	    var name = re.name;
	    var path = re.path;
	    var query = location.query;
	    var hash = location.hash;
	    var params = location.params;
	    query = re.hasOwnProperty('query') ? re.query : query;
	    hash = re.hasOwnProperty('hash') ? re.hash : hash;
	    params = re.hasOwnProperty('params') ? re.params : params;
	
	    if (name) {
	      // resolved named direct
	      var targetRecord = nameMap[name];
	      if (false) {
	        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
	      }
	      return match({
	        _normalized: true,
	        name: name,
	        query: query,
	        hash: hash,
	        params: params
	      }, undefined, location)
	    } else if (path) {
	      // 1. resolve relative redirect
	      var rawPath = resolveRecordPath(path, record);
	      // 2. resolve params
	      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
	      // 3. rematch with existing query and hash
	      return match({
	        _normalized: true,
	        path: resolvedPath,
	        query: query,
	        hash: hash
	      }, undefined, location)
	    } else {
	      if (false) {
	        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
	      }
	      return _createRoute(null, location)
	    }
	  }
	
	  function alias (
	    record,
	    location,
	    matchAs
	  ) {
	    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
	    var aliasedMatch = match({
	      _normalized: true,
	      path: aliasedPath
	    });
	    if (aliasedMatch) {
	      var matched = aliasedMatch.matched;
	      var aliasedRecord = matched[matched.length - 1];
	      location.params = aliasedMatch.params;
	      return _createRoute(aliasedRecord, location)
	    }
	    return _createRoute(null, location)
	  }
	
	  function _createRoute (
	    record,
	    location,
	    redirectedFrom
	  ) {
	    if (record && record.redirect) {
	      return redirect(record, redirectedFrom || location)
	    }
	    if (record && record.matchAs) {
	      return alias(record, location, record.matchAs)
	    }
	    return createRoute(record, location, redirectedFrom, router)
	  }
	
	  return {
	    match: match,
	    addRoutes: addRoutes
	  }
	}
	
	function matchRoute (
	  regex,
	  path,
	  params
	) {
	  var m = path.match(regex);
	
	  if (!m) {
	    return false
	  } else if (!params) {
	    return true
	  }
	
	  for (var i = 1, len = m.length; i < len; ++i) {
	    var key = regex.keys[i - 1];
	    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
	    if (key) {
	      params[key.name] = val;
	    }
	  }
	
	  return true
	}
	
	function resolveRecordPath (path, record) {
	  return resolvePath(path, record.parent ? record.parent.path : '/', true)
	}
	
	/*  */
	
	
	var positionStore = Object.create(null);
	
	function setupScroll () {
	  // Fix for #1585 for Firefox
	  window.history.replaceState({ key: getStateKey() }, '');
	  window.addEventListener('popstate', function (e) {
	    saveScrollPosition();
	    if (e.state && e.state.key) {
	      setStateKey(e.state.key);
	    }
	  });
	}
	
	function handleScroll (
	  router,
	  to,
	  from,
	  isPop
	) {
	  if (!router.app) {
	    return
	  }
	
	  var behavior = router.options.scrollBehavior;
	  if (!behavior) {
	    return
	  }
	
	  if (false) {
	    assert(typeof behavior === 'function', "scrollBehavior must be a function");
	  }
	
	  // wait until re-render finishes before scrolling
	  router.app.$nextTick(function () {
	    var position = getScrollPosition();
	    var shouldScroll = behavior(to, from, isPop ? position : null);
	
	    if (!shouldScroll) {
	      return
	    }
	
	    if (typeof shouldScroll.then === 'function') {
	      shouldScroll.then(function (shouldScroll) {
	        scrollToPosition((shouldScroll), position);
	      }).catch(function (err) {
	        if (false) {
	          assert(false, err.toString());
	        }
	      });
	    } else {
	      scrollToPosition(shouldScroll, position);
	    }
	  });
	}
	
	function saveScrollPosition () {
	  var key = getStateKey();
	  if (key) {
	    positionStore[key] = {
	      x: window.pageXOffset,
	      y: window.pageYOffset
	    };
	  }
	}
	
	function getScrollPosition () {
	  var key = getStateKey();
	  if (key) {
	    return positionStore[key]
	  }
	}
	
	function getElementPosition (el, offset) {
	  var docEl = document.documentElement;
	  var docRect = docEl.getBoundingClientRect();
	  var elRect = el.getBoundingClientRect();
	  return {
	    x: elRect.left - docRect.left - offset.x,
	    y: elRect.top - docRect.top - offset.y
	  }
	}
	
	function isValidPosition (obj) {
	  return isNumber(obj.x) || isNumber(obj.y)
	}
	
	function normalizePosition (obj) {
	  return {
	    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
	    y: isNumber(obj.y) ? obj.y : window.pageYOffset
	  }
	}
	
	function normalizeOffset (obj) {
	  return {
	    x: isNumber(obj.x) ? obj.x : 0,
	    y: isNumber(obj.y) ? obj.y : 0
	  }
	}
	
	function isNumber (v) {
	  return typeof v === 'number'
	}
	
	function scrollToPosition (shouldScroll, position) {
	  var isObject = typeof shouldScroll === 'object';
	  if (isObject && typeof shouldScroll.selector === 'string') {
	    var el = document.querySelector(shouldScroll.selector);
	    if (el) {
	      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
	      offset = normalizeOffset(offset);
	      position = getElementPosition(el, offset);
	    } else if (isValidPosition(shouldScroll)) {
	      position = normalizePosition(shouldScroll);
	    }
	  } else if (isObject && isValidPosition(shouldScroll)) {
	    position = normalizePosition(shouldScroll);
	  }
	
	  if (position) {
	    window.scrollTo(position.x, position.y);
	  }
	}
	
	/*  */
	
	var supportsPushState = inBrowser && (function () {
	  var ua = window.navigator.userAgent;
	
	  if (
	    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
	    ua.indexOf('Mobile Safari') !== -1 &&
	    ua.indexOf('Chrome') === -1 &&
	    ua.indexOf('Windows Phone') === -1
	  ) {
	    return false
	  }
	
	  return window.history && 'pushState' in window.history
	})();
	
	// use User Timing api (if present) for more accurate key precision
	var Time = inBrowser && window.performance && window.performance.now
	  ? window.performance
	  : Date;
	
	var _key = genKey();
	
	function genKey () {
	  return Time.now().toFixed(3)
	}
	
	function getStateKey () {
	  return _key
	}
	
	function setStateKey (key) {
	  _key = key;
	}
	
	function pushState (url, replace) {
	  saveScrollPosition();
	  // try...catch the pushState call to get around Safari
	  // DOM Exception 18 where it limits to 100 pushState calls
	  var history = window.history;
	  try {
	    if (replace) {
	      history.replaceState({ key: _key }, '', url);
	    } else {
	      _key = genKey();
	      history.pushState({ key: _key }, '', url);
	    }
	  } catch (e) {
	    window.location[replace ? 'replace' : 'assign'](url);
	  }
	}
	
	function replaceState (url) {
	  pushState(url, true);
	}
	
	/*  */
	
	function runQueue (queue, fn, cb) {
	  var step = function (index) {
	    if (index >= queue.length) {
	      cb();
	    } else {
	      if (queue[index]) {
	        fn(queue[index], function () {
	          step(index + 1);
	        });
	      } else {
	        step(index + 1);
	      }
	    }
	  };
	  step(0);
	}
	
	/*  */
	
	function resolveAsyncComponents (matched) {
	  return function (to, from, next) {
	    var hasAsync = false;
	    var pending = 0;
	    var error = null;
	
	    flatMapComponents(matched, function (def, _, match, key) {
	      // if it's a function and doesn't have cid attached,
	      // assume it's an async component resolve function.
	      // we are not using Vue's default async resolving mechanism because
	      // we want to halt the navigation until the incoming component has been
	      // resolved.
	      if (typeof def === 'function' && def.cid === undefined) {
	        hasAsync = true;
	        pending++;
	
	        var resolve = once(function (resolvedDef) {
	          if (isESModule(resolvedDef)) {
	            resolvedDef = resolvedDef.default;
	          }
	          // save resolved on async factory in case it's used elsewhere
	          def.resolved = typeof resolvedDef === 'function'
	            ? resolvedDef
	            : _Vue.extend(resolvedDef);
	          match.components[key] = resolvedDef;
	          pending--;
	          if (pending <= 0) {
	            next();
	          }
	        });
	
	        var reject = once(function (reason) {
	          var msg = "Failed to resolve async component " + key + ": " + reason;
	          ("production") !== 'production' && warn(false, msg);
	          if (!error) {
	            error = isError(reason)
	              ? reason
	              : new Error(msg);
	            next(error);
	          }
	        });
	
	        var res;
	        try {
	          res = def(resolve, reject);
	        } catch (e) {
	          reject(e);
	        }
	        if (res) {
	          if (typeof res.then === 'function') {
	            res.then(resolve, reject);
	          } else {
	            // new syntax in Vue 2.3
	            var comp = res.component;
	            if (comp && typeof comp.then === 'function') {
	              comp.then(resolve, reject);
	            }
	          }
	        }
	      }
	    });
	
	    if (!hasAsync) { next(); }
	  }
	}
	
	function flatMapComponents (
	  matched,
	  fn
	) {
	  return flatten(matched.map(function (m) {
	    return Object.keys(m.components).map(function (key) { return fn(
	      m.components[key],
	      m.instances[key],
	      m, key
	    ); })
	  }))
	}
	
	function flatten (arr) {
	  return Array.prototype.concat.apply([], arr)
	}
	
	var hasSymbol =
	  typeof Symbol === 'function' &&
	  typeof Symbol.toStringTag === 'symbol';
	
	function isESModule (obj) {
	  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
	}
	
	// in Webpack 2, require.ensure now also returns a Promise
	// so the resolve/reject functions may get called an extra time
	// if the user uses an arrow function shorthand that happens to
	// return that Promise.
	function once (fn) {
	  var called = false;
	  return function () {
	    var args = [], len = arguments.length;
	    while ( len-- ) args[ len ] = arguments[ len ];
	
	    if (called) { return }
	    called = true;
	    return fn.apply(this, args)
	  }
	}
	
	/*  */
	
	var History = function History (router, base) {
	  this.router = router;
	  this.base = normalizeBase(base);
	  // start with a route object that stands for "nowhere"
	  this.current = START;
	  this.pending = null;
	  this.ready = false;
	  this.readyCbs = [];
	  this.readyErrorCbs = [];
	  this.errorCbs = [];
	};
	
	History.prototype.listen = function listen (cb) {
	  this.cb = cb;
	};
	
	History.prototype.onReady = function onReady (cb, errorCb) {
	  if (this.ready) {
	    cb();
	  } else {
	    this.readyCbs.push(cb);
	    if (errorCb) {
	      this.readyErrorCbs.push(errorCb);
	    }
	  }
	};
	
	History.prototype.onError = function onError (errorCb) {
	  this.errorCbs.push(errorCb);
	};
	
	History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
	    var this$1 = this;
	
	  var route = this.router.match(location, this.current);
	  this.confirmTransition(route, function () {
	    this$1.updateRoute(route);
	    onComplete && onComplete(route);
	    this$1.ensureURL();
	
	    // fire ready cbs once
	    if (!this$1.ready) {
	      this$1.ready = true;
	      this$1.readyCbs.forEach(function (cb) { cb(route); });
	    }
	  }, function (err) {
	    if (onAbort) {
	      onAbort(err);
	    }
	    if (err && !this$1.ready) {
	      this$1.ready = true;
	      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
	    }
	  });
	};
	
	History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
	    var this$1 = this;
	
	  var current = this.current;
	  var abort = function (err) {
	    if (isError(err)) {
	      if (this$1.errorCbs.length) {
	        this$1.errorCbs.forEach(function (cb) { cb(err); });
	      } else {
	        warn(false, 'uncaught error during route navigation:');
	        console.error(err);
	      }
	    }
	    onAbort && onAbort(err);
	  };
	  if (
	    isSameRoute(route, current) &&
	    // in the case the route map has been dynamically appended to
	    route.matched.length === current.matched.length
	  ) {
	    this.ensureURL();
	    return abort()
	  }
	
	  var ref = resolveQueue(this.current.matched, route.matched);
	    var updated = ref.updated;
	    var deactivated = ref.deactivated;
	    var activated = ref.activated;
	
	  var queue = [].concat(
	    // in-component leave guards
	    extractLeaveGuards(deactivated),
	    // global before hooks
	    this.router.beforeHooks,
	    // in-component update hooks
	    extractUpdateHooks(updated),
	    // in-config enter guards
	    activated.map(function (m) { return m.beforeEnter; }),
	    // async components
	    resolveAsyncComponents(activated)
	  );
	
	  this.pending = route;
	  var iterator = function (hook, next) {
	    if (this$1.pending !== route) {
	      return abort()
	    }
	    try {
	      hook(route, current, function (to) {
	        if (to === false || isError(to)) {
	          // next(false) -> abort navigation, ensure current URL
	          this$1.ensureURL(true);
	          abort(to);
	        } else if (
	          typeof to === 'string' ||
	          (typeof to === 'object' && (
	            typeof to.path === 'string' ||
	            typeof to.name === 'string'
	          ))
	        ) {
	          // next('/') or next({ path: '/' }) -> redirect
	          abort();
	          if (typeof to === 'object' && to.replace) {
	            this$1.replace(to);
	          } else {
	            this$1.push(to);
	          }
	        } else {
	          // confirm transition and pass on the value
	          next(to);
	        }
	      });
	    } catch (e) {
	      abort(e);
	    }
	  };
	
	  runQueue(queue, iterator, function () {
	    var postEnterCbs = [];
	    var isValid = function () { return this$1.current === route; };
	    // wait until async components are resolved before
	    // extracting in-component enter guards
	    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
	    var queue = enterGuards.concat(this$1.router.resolveHooks);
	    runQueue(queue, iterator, function () {
	      if (this$1.pending !== route) {
	        return abort()
	      }
	      this$1.pending = null;
	      onComplete(route);
	      if (this$1.router.app) {
	        this$1.router.app.$nextTick(function () {
	          postEnterCbs.forEach(function (cb) { cb(); });
	        });
	      }
	    });
	  });
	};
	
	History.prototype.updateRoute = function updateRoute (route) {
	  var prev = this.current;
	  this.current = route;
	  this.cb && this.cb(route);
	  this.router.afterHooks.forEach(function (hook) {
	    hook && hook(route, prev);
	  });
	};
	
	function normalizeBase (base) {
	  if (!base) {
	    if (inBrowser) {
	      // respect <base> tag
	      var baseEl = document.querySelector('base');
	      base = (baseEl && baseEl.getAttribute('href')) || '/';
	      // strip full URL origin
	      base = base.replace(/^https?:\/\/[^\/]+/, '');
	    } else {
	      base = '/';
	    }
	  }
	  // make sure there's the starting slash
	  if (base.charAt(0) !== '/') {
	    base = '/' + base;
	  }
	  // remove trailing slash
	  return base.replace(/\/$/, '')
	}
	
	function resolveQueue (
	  current,
	  next
	) {
	  var i;
	  var max = Math.max(current.length, next.length);
	  for (i = 0; i < max; i++) {
	    if (current[i] !== next[i]) {
	      break
	    }
	  }
	  return {
	    updated: next.slice(0, i),
	    activated: next.slice(i),
	    deactivated: current.slice(i)
	  }
	}
	
	function extractGuards (
	  records,
	  name,
	  bind,
	  reverse
	) {
	  var guards = flatMapComponents(records, function (def, instance, match, key) {
	    var guard = extractGuard(def, name);
	    if (guard) {
	      return Array.isArray(guard)
	        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
	        : bind(guard, instance, match, key)
	    }
	  });
	  return flatten(reverse ? guards.reverse() : guards)
	}
	
	function extractGuard (
	  def,
	  key
	) {
	  if (typeof def !== 'function') {
	    // extend now so that global mixins are applied.
	    def = _Vue.extend(def);
	  }
	  return def.options[key]
	}
	
	function extractLeaveGuards (deactivated) {
	  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
	}
	
	function extractUpdateHooks (updated) {
	  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
	}
	
	function bindGuard (guard, instance) {
	  if (instance) {
	    return function boundRouteGuard () {
	      return guard.apply(instance, arguments)
	    }
	  }
	}
	
	function extractEnterGuards (
	  activated,
	  cbs,
	  isValid
	) {
	  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
	    return bindEnterGuard(guard, match, key, cbs, isValid)
	  })
	}
	
	function bindEnterGuard (
	  guard,
	  match,
	  key,
	  cbs,
	  isValid
	) {
	  return function routeEnterGuard (to, from, next) {
	    return guard(to, from, function (cb) {
	      next(cb);
	      if (typeof cb === 'function') {
	        cbs.push(function () {
	          // #750
	          // if a router-view is wrapped with an out-in transition,
	          // the instance may not have been registered at this time.
	          // we will need to poll for registration until current route
	          // is no longer valid.
	          poll(cb, match.instances, key, isValid);
	        });
	      }
	    })
	  }
	}
	
	function poll (
	  cb, // somehow flow cannot infer this is a function
	  instances,
	  key,
	  isValid
	) {
	  if (instances[key]) {
	    cb(instances[key]);
	  } else if (isValid()) {
	    setTimeout(function () {
	      poll(cb, instances, key, isValid);
	    }, 16);
	  }
	}
	
	/*  */
	
	
	var HTML5History = (function (History$$1) {
	  function HTML5History (router, base) {
	    var this$1 = this;
	
	    History$$1.call(this, router, base);
	
	    var expectScroll = router.options.scrollBehavior;
	
	    if (expectScroll) {
	      setupScroll();
	    }
	
	    var initLocation = getLocation(this.base);
	    window.addEventListener('popstate', function (e) {
	      var current = this$1.current;
	
	      // Avoiding first `popstate` event dispatched in some browsers but first
	      // history route not updated since async guard at the same time.
	      var location = getLocation(this$1.base);
	      if (this$1.current === START && location === initLocation) {
	        return
	      }
	
	      this$1.transitionTo(location, function (route) {
	        if (expectScroll) {
	          handleScroll(router, route, current, true);
	        }
	      });
	    });
	  }
	
	  if ( History$$1 ) HTML5History.__proto__ = History$$1;
	  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
	  HTML5History.prototype.constructor = HTML5History;
	
	  HTML5History.prototype.go = function go (n) {
	    window.history.go(n);
	  };
	
	  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    var ref = this;
	    var fromRoute = ref.current;
	    this.transitionTo(location, function (route) {
	      pushState(cleanPath(this$1.base + route.fullPath));
	      handleScroll(this$1.router, route, fromRoute, false);
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    var ref = this;
	    var fromRoute = ref.current;
	    this.transitionTo(location, function (route) {
	      replaceState(cleanPath(this$1.base + route.fullPath));
	      handleScroll(this$1.router, route, fromRoute, false);
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  HTML5History.prototype.ensureURL = function ensureURL (push) {
	    if (getLocation(this.base) !== this.current.fullPath) {
	      var current = cleanPath(this.base + this.current.fullPath);
	      push ? pushState(current) : replaceState(current);
	    }
	  };
	
	  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
	    return getLocation(this.base)
	  };
	
	  return HTML5History;
	}(History));
	
	function getLocation (base) {
	  var path = window.location.pathname;
	  if (base && path.indexOf(base) === 0) {
	    path = path.slice(base.length);
	  }
	  return (path || '/') + window.location.search + window.location.hash
	}
	
	/*  */
	
	
	var HashHistory = (function (History$$1) {
	  function HashHistory (router, base, fallback) {
	    History$$1.call(this, router, base);
	    // check history fallback deeplinking
	    if (fallback && checkFallback(this.base)) {
	      return
	    }
	    ensureSlash();
	  }
	
	  if ( History$$1 ) HashHistory.__proto__ = History$$1;
	  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
	  HashHistory.prototype.constructor = HashHistory;
	
	  // this is delayed until the app mounts
	  // to avoid the hashchange listener being fired too early
	  HashHistory.prototype.setupListeners = function setupListeners () {
	    var this$1 = this;
	
	    var router = this.router;
	    var expectScroll = router.options.scrollBehavior;
	    var supportsScroll = supportsPushState && expectScroll;
	
	    if (supportsScroll) {
	      setupScroll();
	    }
	
	    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
	      var current = this$1.current;
	      if (!ensureSlash()) {
	        return
	      }
	      this$1.transitionTo(getHash(), function (route) {
	        if (supportsScroll) {
	          handleScroll(this$1.router, route, current, true);
	        }
	        if (!supportsPushState) {
	          replaceHash(route.fullPath);
	        }
	      });
	    });
	  };
	
	  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    var ref = this;
	    var fromRoute = ref.current;
	    this.transitionTo(location, function (route) {
	      pushHash(route.fullPath);
	      handleScroll(this$1.router, route, fromRoute, false);
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    var ref = this;
	    var fromRoute = ref.current;
	    this.transitionTo(location, function (route) {
	      replaceHash(route.fullPath);
	      handleScroll(this$1.router, route, fromRoute, false);
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  HashHistory.prototype.go = function go (n) {
	    window.history.go(n);
	  };
	
	  HashHistory.prototype.ensureURL = function ensureURL (push) {
	    var current = this.current.fullPath;
	    if (getHash() !== current) {
	      push ? pushHash(current) : replaceHash(current);
	    }
	  };
	
	  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
	    return getHash()
	  };
	
	  return HashHistory;
	}(History));
	
	function checkFallback (base) {
	  var location = getLocation(base);
	  if (!/^\/#/.test(location)) {
	    window.location.replace(
	      cleanPath(base + '/#' + location)
	    );
	    return true
	  }
	}
	
	function ensureSlash () {
	  var path = getHash();
	  if (path.charAt(0) === '/') {
	    return true
	  }
	  replaceHash('/' + path);
	  return false
	}
	
	function getHash () {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var index = href.indexOf('#');
	  return index === -1 ? '' : href.slice(index + 1)
	}
	
	function getUrl (path) {
	  var href = window.location.href;
	  var i = href.indexOf('#');
	  var base = i >= 0 ? href.slice(0, i) : href;
	  return (base + "#" + path)
	}
	
	function pushHash (path) {
	  if (supportsPushState) {
	    pushState(getUrl(path));
	  } else {
	    window.location.hash = path;
	  }
	}
	
	function replaceHash (path) {
	  if (supportsPushState) {
	    replaceState(getUrl(path));
	  } else {
	    window.location.replace(getUrl(path));
	  }
	}
	
	/*  */
	
	
	var AbstractHistory = (function (History$$1) {
	  function AbstractHistory (router, base) {
	    History$$1.call(this, router, base);
	    this.stack = [];
	    this.index = -1;
	  }
	
	  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
	  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
	  AbstractHistory.prototype.constructor = AbstractHistory;
	
	  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    this.transitionTo(location, function (route) {
	      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
	      this$1.index++;
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    this.transitionTo(location, function (route) {
	      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  AbstractHistory.prototype.go = function go (n) {
	    var this$1 = this;
	
	    var targetIndex = this.index + n;
	    if (targetIndex < 0 || targetIndex >= this.stack.length) {
	      return
	    }
	    var route = this.stack[targetIndex];
	    this.confirmTransition(route, function () {
	      this$1.index = targetIndex;
	      this$1.updateRoute(route);
	    });
	  };
	
	  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
	    var current = this.stack[this.stack.length - 1];
	    return current ? current.fullPath : '/'
	  };
	
	  AbstractHistory.prototype.ensureURL = function ensureURL () {
	    // noop
	  };
	
	  return AbstractHistory;
	}(History));
	
	/*  */
	
	var VueRouter = function VueRouter (options) {
	  if ( options === void 0 ) options = {};
	
	  this.app = null;
	  this.apps = [];
	  this.options = options;
	  this.beforeHooks = [];
	  this.resolveHooks = [];
	  this.afterHooks = [];
	  this.matcher = createMatcher(options.routes || [], this);
	
	  var mode = options.mode || 'hash';
	  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
	  if (this.fallback) {
	    mode = 'hash';
	  }
	  if (!inBrowser) {
	    mode = 'abstract';
	  }
	  this.mode = mode;
	
	  switch (mode) {
	    case 'history':
	      this.history = new HTML5History(this, options.base);
	      break
	    case 'hash':
	      this.history = new HashHistory(this, options.base, this.fallback);
	      break
	    case 'abstract':
	      this.history = new AbstractHistory(this, options.base);
	      break
	    default:
	      if (false) {
	        assert(false, ("invalid mode: " + mode));
	      }
	  }
	};
	
	var prototypeAccessors = { currentRoute: { configurable: true } };
	
	VueRouter.prototype.match = function match (
	  raw,
	  current,
	  redirectedFrom
	) {
	  return this.matcher.match(raw, current, redirectedFrom)
	};
	
	prototypeAccessors.currentRoute.get = function () {
	  return this.history && this.history.current
	};
	
	VueRouter.prototype.init = function init (app /* Vue component instance */) {
	    var this$1 = this;
	
	  ("production") !== 'production' && assert(
	    install.installed,
	    "not installed. Make sure to call `Vue.use(VueRouter)` " +
	    "before creating root instance."
	  );
	
	  this.apps.push(app);
	
	  // main app already initialized.
	  if (this.app) {
	    return
	  }
	
	  this.app = app;
	
	  var history = this.history;
	
	  if (history instanceof HTML5History) {
	    history.transitionTo(history.getCurrentLocation());
	  } else if (history instanceof HashHistory) {
	    var setupHashListener = function () {
	      history.setupListeners();
	    };
	    history.transitionTo(
	      history.getCurrentLocation(),
	      setupHashListener,
	      setupHashListener
	    );
	  }
	
	  history.listen(function (route) {
	    this$1.apps.forEach(function (app) {
	      app._route = route;
	    });
	  });
	};
	
	VueRouter.prototype.beforeEach = function beforeEach (fn) {
	  return registerHook(this.beforeHooks, fn)
	};
	
	VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
	  return registerHook(this.resolveHooks, fn)
	};
	
	VueRouter.prototype.afterEach = function afterEach (fn) {
	  return registerHook(this.afterHooks, fn)
	};
	
	VueRouter.prototype.onReady = function onReady (cb, errorCb) {
	  this.history.onReady(cb, errorCb);
	};
	
	VueRouter.prototype.onError = function onError (errorCb) {
	  this.history.onError(errorCb);
	};
	
	VueRouter.prototype.push = function push (location, onComplete, onAbort) {
	  this.history.push(location, onComplete, onAbort);
	};
	
	VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
	  this.history.replace(location, onComplete, onAbort);
	};
	
	VueRouter.prototype.go = function go (n) {
	  this.history.go(n);
	};
	
	VueRouter.prototype.back = function back () {
	  this.go(-1);
	};
	
	VueRouter.prototype.forward = function forward () {
	  this.go(1);
	};
	
	VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
	  var route = to
	    ? to.matched
	      ? to
	      : this.resolve(to).route
	    : this.currentRoute;
	  if (!route) {
	    return []
	  }
	  return [].concat.apply([], route.matched.map(function (m) {
	    return Object.keys(m.components).map(function (key) {
	      return m.components[key]
	    })
	  }))
	};
	
	VueRouter.prototype.resolve = function resolve (
	  to,
	  current,
	  append
	) {
	  var location = normalizeLocation(
	    to,
	    current || this.history.current,
	    append,
	    this
	  );
	  var route = this.match(location, current);
	  var fullPath = route.redirectedFrom || route.fullPath;
	  var base = this.history.base;
	  var href = createHref(base, fullPath, this.mode);
	  return {
	    location: location,
	    route: route,
	    href: href,
	    // for backwards compat
	    normalizedTo: location,
	    resolved: route
	  }
	};
	
	VueRouter.prototype.addRoutes = function addRoutes (routes) {
	  this.matcher.addRoutes(routes);
	  if (this.history.current !== START) {
	    this.history.transitionTo(this.history.getCurrentLocation());
	  }
	};
	
	Object.defineProperties( VueRouter.prototype, prototypeAccessors );
	
	function registerHook (list, fn) {
	  list.push(fn);
	  return function () {
	    var i = list.indexOf(fn);
	    if (i > -1) { list.splice(i, 1); }
	  }
	}
	
	function createHref (base, fullPath, mode) {
	  var path = mode === 'hash' ? '#' + fullPath : fullPath;
	  return base ? cleanPath(base + '/' + path) : path
	}
	
	VueRouter.install = install;
	VueRouter.version = '2.8.1';
	
	if (inBrowser && window.Vue) {
	  window.Vue.use(VueRouter);
	}
	
	module.exports = VueRouter;


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	  * vue-scrollto v2.15.0
	  * (c) 2019 Randjelovic Igor
	  * @license MIT
	  */
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global = global || self, global['vue-scrollto'] = factory());
	}(this, function () { 'use strict';
	
	  function _typeof(obj) {
	    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	      _typeof = function (obj) {
	        return typeof obj;
	      };
	    } else {
	      _typeof = function (obj) {
	        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	      };
	    }
	
	    return _typeof(obj);
	  }
	
	  function _extends() {
	    _extends = Object.assign || function (target) {
	      for (var i = 1; i < arguments.length; i++) {
	        var source = arguments[i];
	
	        for (var key in source) {
	          if (Object.prototype.hasOwnProperty.call(source, key)) {
	            target[key] = source[key];
	          }
	        }
	      }
	
	      return target;
	    };
	
	    return _extends.apply(this, arguments);
	  }
	
	  /**
	   * https://github.com/gre/bezier-easing
	   * BezierEasing - use bezier curve for transition easing function
	   * by Gaëtan Renaudeau 2014 - 2015 – MIT License
	   */
	
	  // These values are established by empiricism with tests (tradeoff: performance VS precision)
	  var NEWTON_ITERATIONS = 4;
	  var NEWTON_MIN_SLOPE = 0.001;
	  var SUBDIVISION_PRECISION = 0.0000001;
	  var SUBDIVISION_MAX_ITERATIONS = 10;
	
	  var kSplineTableSize = 11;
	  var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
	
	  var float32ArraySupported = typeof Float32Array === 'function';
	
	  function A (aA1, aA2) { return 1.0 - 3.0 * aA2 + 3.0 * aA1; }
	  function B (aA1, aA2) { return 3.0 * aA2 - 6.0 * aA1; }
	  function C (aA1)      { return 3.0 * aA1; }
	
	  // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
	  function calcBezier (aT, aA1, aA2) { return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT; }
	
	  // Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
	  function getSlope (aT, aA1, aA2) { return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1); }
	
	  function binarySubdivide (aX, aA, aB, mX1, mX2) {
	    var currentX, currentT, i = 0;
	    do {
	      currentT = aA + (aB - aA) / 2.0;
	      currentX = calcBezier(currentT, mX1, mX2) - aX;
	      if (currentX > 0.0) {
	        aB = currentT;
	      } else {
	        aA = currentT;
	      }
	    } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
	    return currentT;
	  }
	
	  function newtonRaphsonIterate (aX, aGuessT, mX1, mX2) {
	   for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
	     var currentSlope = getSlope(aGuessT, mX1, mX2);
	     if (currentSlope === 0.0) {
	       return aGuessT;
	     }
	     var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
	     aGuessT -= currentX / currentSlope;
	   }
	   return aGuessT;
	  }
	
	  function LinearEasing (x) {
	    return x;
	  }
	
	  var src = function bezier (mX1, mY1, mX2, mY2) {
	    if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) {
	      throw new Error('bezier x values must be in [0, 1] range');
	    }
	
	    if (mX1 === mY1 && mX2 === mY2) {
	      return LinearEasing;
	    }
	
	    // Precompute samples table
	    var sampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
	    for (var i = 0; i < kSplineTableSize; ++i) {
	      sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
	    }
	
	    function getTForX (aX) {
	      var intervalStart = 0.0;
	      var currentSample = 1;
	      var lastSample = kSplineTableSize - 1;
	
	      for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
	        intervalStart += kSampleStepSize;
	      }
	      --currentSample;
	
	      // Interpolate to provide an initial guess for t
	      var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
	      var guessForT = intervalStart + dist * kSampleStepSize;
	
	      var initialSlope = getSlope(guessForT, mX1, mX2);
	      if (initialSlope >= NEWTON_MIN_SLOPE) {
	        return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
	      } else if (initialSlope === 0.0) {
	        return guessForT;
	      } else {
	        return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
	      }
	    }
	
	    return function BezierEasing (x) {
	      // Because JavaScript number are imprecise, we should guarantee the extremes are right.
	      if (x === 0) {
	        return 0;
	      }
	      if (x === 1) {
	        return 1;
	      }
	      return calcBezier(getTForX(x), mY1, mY2);
	    };
	  };
	
	  var easings = {
	    ease: [0.25, 0.1, 0.25, 1.0],
	    linear: [0.00, 0.0, 1.00, 1.0],
	    "ease-in": [0.42, 0.0, 1.00, 1.0],
	    "ease-out": [0.00, 0.0, 0.58, 1.0],
	    "ease-in-out": [0.42, 0.0, 0.58, 1.0]
	  };
	
	  // https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md#feature-detection
	  var supportsPassive = false;
	
	  try {
	    var opts = Object.defineProperty({}, "passive", {
	      get: function get() {
	        supportsPassive = true;
	      }
	    });
	    window.addEventListener("test", null, opts);
	  } catch (e) {}
	
	  var _ = {
	    $: function $(selector) {
	      if (typeof selector !== "string") {
	        return selector;
	      }
	
	      return document.querySelector(selector);
	    },
	    on: function on(element, events, handler) {
	      var opts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
	        passive: false
	      };
	
	      if (!(events instanceof Array)) {
	        events = [events];
	      }
	
	      for (var i = 0; i < events.length; i++) {
	        element.addEventListener(events[i], handler, supportsPassive ? opts : false);
	      }
	    },
	    off: function off(element, events, handler) {
	      if (!(events instanceof Array)) {
	        events = [events];
	      }
	
	      for (var i = 0; i < events.length; i++) {
	        element.removeEventListener(events[i], handler);
	      }
	    },
	    cumulativeOffset: function cumulativeOffset(element) {
	      var top = 0;
	      var left = 0;
	
	      do {
	        top += element.offsetTop || 0;
	        left += element.offsetLeft || 0;
	        element = element.offsetParent;
	      } while (element);
	
	      return {
	        top: top,
	        left: left
	      };
	    }
	  };
	
	  var abortEvents = ["mousedown", "wheel", "DOMMouseScroll", "mousewheel", "keyup", "touchmove"];
	  var defaults = {
	    container: "body",
	    duration: 500,
	    easing: "ease",
	    offset: 0,
	    force: true,
	    cancelable: true,
	    onStart: false,
	    onDone: false,
	    onCancel: false,
	    x: false,
	    y: true
	  };
	  function setDefaults(options) {
	    defaults = _extends({}, defaults, options);
	  }
	  var scroller = function scroller() {
	    var element; // element to scroll to
	
	    var container; // container to scroll
	
	    var duration; // duration of the scrolling
	
	    var easing; // easing to be used when scrolling
	
	    var offset; // offset to be added (subtracted)
	
	    var force; // force scroll, even if element is visible
	
	    var cancelable; // indicates if user can cancel the scroll or not.
	
	    var onStart; // callback when scrolling is started
	
	    var onDone; // callback when scrolling is done
	
	    var onCancel; // callback when scrolling is canceled / aborted
	
	    var x; // scroll on x axis
	
	    var y; // scroll on y axis
	
	    var initialX; // initial X of container
	
	    var targetX; // target X of container
	
	    var initialY; // initial Y of container
	
	    var targetY; // target Y of container
	
	    var diffX; // difference
	
	    var diffY; // difference
	
	    var abort; // is scrolling aborted
	
	    var abortEv; // event that aborted scrolling
	
	    var abortFn = function abortFn(e) {
	      if (!cancelable) return;
	      abortEv = e;
	      abort = true;
	    };
	
	    var easingFn;
	    var timeStart; // time when scrolling started
	
	    var timeElapsed; // time elapsed since scrolling started
	
	    var progress; // progress
	
	    function scrollTop(container) {
	      var scrollTop = container.scrollTop;
	
	      if (container.tagName.toLowerCase() === "body") {
	        // in firefox body.scrollTop always returns 0
	        // thus if we are trying to get scrollTop on a body tag
	        // we need to get it from the documentElement
	        scrollTop = scrollTop || document.documentElement.scrollTop;
	      }
	
	      return scrollTop;
	    }
	
	    function scrollLeft(container) {
	      var scrollLeft = container.scrollLeft;
	
	      if (container.tagName.toLowerCase() === "body") {
	        // in firefox body.scrollLeft always returns 0
	        // thus if we are trying to get scrollLeft on a body tag
	        // we need to get it from the documentElement
	        scrollLeft = scrollLeft || document.documentElement.scrollLeft;
	      }
	
	      return scrollLeft;
	    }
	
	    function step(timestamp) {
	      if (abort) return done();
	      if (!timeStart) timeStart = timestamp;
	      timeElapsed = timestamp - timeStart;
	      progress = Math.min(timeElapsed / duration, 1);
	      progress = easingFn(progress);
	      topLeft(container, initialY + diffY * progress, initialX + diffX * progress);
	      timeElapsed < duration ? window.requestAnimationFrame(step) : done();
	    }
	
	    function done() {
	      if (!abort) topLeft(container, targetY, targetX);
	      timeStart = false;
	
	      _.off(container, abortEvents, abortFn);
	
	      if (abort && onCancel) onCancel(abortEv, element);
	      if (!abort && onDone) onDone(element);
	    }
	
	    function topLeft(element, top, left) {
	      if (y) element.scrollTop = top;
	      if (x) element.scrollLeft = left;
	
	      if (element.tagName.toLowerCase() === "body") {
	        // in firefox body.scrollTop doesn't scroll the page
	        // thus if we are trying to scrollTop on a body tag
	        // we need to scroll on the documentElement
	        if (y) document.documentElement.scrollTop = top;
	        if (x) document.documentElement.scrollLeft = left;
	      }
	    }
	
	    function scrollTo(target, _duration) {
	      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      if (_typeof(_duration) === "object") {
	        options = _duration;
	      } else if (typeof _duration === "number") {
	        options.duration = _duration;
	      }
	
	      element = _.$(target);
	
	      if (!element) {
	        return console.warn("[vue-scrollto warn]: Trying to scroll to an element that is not on the page: " + target);
	      }
	
	      container = _.$(options.container || defaults.container);
	      duration = options.duration || defaults.duration;
	      easing = options.easing || defaults.easing;
	      offset = options.offset || defaults.offset;
	      force = options.hasOwnProperty("force") ? options.force !== false : defaults.force;
	      cancelable = options.hasOwnProperty("cancelable") ? options.cancelable !== false : defaults.cancelable;
	      onStart = options.onStart || defaults.onStart;
	      onDone = options.onDone || defaults.onDone;
	      onCancel = options.onCancel || defaults.onCancel;
	      x = options.x === undefined ? defaults.x : options.x;
	      y = options.y === undefined ? defaults.y : options.y;
	
	      var cumulativeOffsetContainer = _.cumulativeOffset(container);
	
	      var cumulativeOffsetElement = _.cumulativeOffset(element);
	
	      if (typeof offset === "function") {
	        offset = offset();
	      }
	
	      initialY = scrollTop(container);
	      targetY = cumulativeOffsetElement.top - cumulativeOffsetContainer.top + offset;
	      initialX = scrollLeft(container);
	      targetX = cumulativeOffsetElement.left - cumulativeOffsetContainer.left + offset;
	      abort = false;
	      diffY = targetY - initialY;
	      diffX = targetX - initialX;
	
	      if (!force) {
	        var containerTop = initialY;
	        var containerBottom = containerTop + container.offsetHeight;
	        var elementTop = targetY;
	        var elementBottom = elementTop + element.offsetHeight;
	
	        if (elementTop >= containerTop && elementBottom <= containerBottom) {
	          // make sure to call the onDone callback even if there is no need to
	          // scroll the container. Fixes #111 (ref #118)
	          onDone(element);
	          return;
	        }
	      }
	
	      if (typeof easing === "string") {
	        easing = easings[easing] || easings["ease"];
	      }
	
	      easingFn = src.apply(src, easing);
	      if (!diffY && !diffX) return;
	      if (onStart) onStart(element);
	
	      _.on(container, abortEvents, abortFn, {
	        passive: true
	      });
	
	      window.requestAnimationFrame(step);
	      return function () {
	        abortEv = null;
	        abort = true;
	      };
	    }
	
	    return scrollTo;
	  };
	
	  var _scroller = scroller();
	
	  var bindings = []; // store binding data
	
	  function deleteBinding(el) {
	    for (var i = 0; i < bindings.length; ++i) {
	      if (bindings[i].el === el) {
	        bindings.splice(i, 1);
	        return true;
	      }
	    }
	
	    return false;
	  }
	
	  function findBinding(el) {
	    for (var i = 0; i < bindings.length; ++i) {
	      if (bindings[i].el === el) {
	        return bindings[i];
	      }
	    }
	  }
	
	  function getBinding(el) {
	    var binding = findBinding(el);
	
	    if (binding) {
	      return binding;
	    }
	
	    bindings.push(binding = {
	      el: el,
	      binding: {}
	    });
	    return binding;
	  }
	
	  function handleClick(e) {
	    e.preventDefault();
	    var ctx = getBinding(this).binding;
	
	    if (typeof ctx.value === "string") {
	      return _scroller(ctx.value);
	    }
	
	    _scroller(ctx.value.el || ctx.value.element, ctx.value);
	  }
	
	  var VueScrollTo = {
	    bind: function bind(el, binding) {
	      getBinding(el).binding = binding;
	
	      _.on(el, "click", handleClick);
	    },
	    unbind: function unbind(el) {
	      deleteBinding(el);
	
	      _.off(el, "click", handleClick);
	    },
	    update: function update(el, binding) {
	      getBinding(el).binding = binding;
	    },
	    scrollTo: _scroller,
	    bindings: bindings
	  };
	
	  var install = function install(Vue, options) {
	    if (options) setDefaults(options);
	    Vue.directive("scroll-to", VueScrollTo);
	    Vue.prototype.$scrollTo = VueScrollTo.scrollTo;
	  };
	
	  if (typeof window !== "undefined" && window.Vue) {
	    window.VueScrollTo = VueScrollTo;
	    window.VueScrollTo.setDefaults = setDefaults;
	    window.Vue.use(install);
	  }
	
	  VueScrollTo.install = install;
	
	  return VueScrollTo;
	
	}));


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.VueSweetAlert=t():e.VueSweetAlert=t()}(this,function(){return function(e){function t(o){if(n[o])return n[o].exports;var a=n[o]={exports:{},id:o,loaded:!1};return e[o].call(a.exports,a,a.exports,t),a.loaded=!0,a.exports}var n={};return t.m=e,t.c=n,t.p="/build/",t(0)}([function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var a=n(1),r=o(a);t.default=r.default},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var a=n(6),r=o(a);n(5);var i={};i.install=function(e){e.prototype.$swal=r.default},t.default=i},function(e,t,n){t=e.exports=n(3)(),t.push([e.id,'body.swal2-shown{overflow-y:hidden}.swal2-container,body.swal2-iosfix{position:fixed;left:0;right:0}.swal2-container{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;top:0;bottom:0;padding:10px;background-color:transparent;z-index:1060}.swal2-container.swal2-fade{transition:background-color .1s}.swal2-container.swal2-shown{background-color:rgba(0,0,0,.4)}.swal2-modal{background-color:#fff;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;border-radius:5px;box-sizing:border-box;text-align:center;margin:auto;overflow-x:hidden;overflow-y:auto;display:none;position:relative;max-width:100%}.swal2-modal:focus{outline:none}.swal2-modal.swal2-loading{overflow-y:hidden}.swal2-modal .swal2-title{color:#595959;font-size:30px;text-align:center;font-weight:600;text-transform:none;position:relative;margin:0 0 .4em;padding:0;display:block;word-wrap:break-word}.swal2-modal .swal2-buttonswrapper{margin-top:15px}.swal2-modal .swal2-buttonswrapper:not(.swal2-loading) .swal2-styled[disabled]{opacity:.4;cursor:no-drop}.swal2-modal .swal2-buttonswrapper.swal2-loading .swal2-styled.swal2-confirm{box-sizing:border-box;border:4px solid transparent;border-color:transparent;width:40px;height:40px;padding:0;margin:7.5px;vertical-align:top;background-color:transparent!important;color:transparent;cursor:default;border-radius:100%;-webkit-animation:rotate-loading 1.5s linear 0s infinite normal;animation:rotate-loading 1.5s linear 0s infinite normal;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.swal2-modal .swal2-buttonswrapper.swal2-loading .swal2-styled.swal2-cancel{margin-left:30px;margin-right:30px}.swal2-modal .swal2-buttonswrapper.swal2-loading :not(.swal2-styled).swal2-confirm:after{display:inline-block;content:"";margin-left:5px 0 15px;vertical-align:-1px;height:15px;width:15px;border:3px solid #999;box-shadow:1px 1px 1px #fff;border-right-color:transparent;border-radius:50%;-webkit-animation:rotate-loading 1.5s linear 0s infinite normal;animation:rotate-loading 1.5s linear 0s infinite normal}.swal2-modal .swal2-styled{border:0;border-radius:3px;box-shadow:none;color:#fff;cursor:pointer;font-size:17px;font-weight:500;margin:15px 5px 0;padding:10px 32px}.swal2-modal .swal2-image{margin:20px auto;max-width:100%}.swal2-modal .swal2-close{background:transparent;border:0;margin:0;padding:0;width:38px;height:40px;font-size:36px;line-height:40px;font-family:serif;position:absolute;top:5px;right:8px;cursor:pointer;color:#ccc;transition:color .1s ease}.swal2-modal .swal2-close:hover{color:#d55}.swal2-modal>.swal2-checkbox,.swal2-modal>.swal2-file,.swal2-modal>.swal2-input,.swal2-modal>.swal2-radio,.swal2-modal>.swal2-select,.swal2-modal>.swal2-textarea{display:none}.swal2-modal .swal2-content{font-size:18px;text-align:center;font-weight:300;position:relative;float:none;margin:0;padding:0;line-height:normal;color:#545454;word-wrap:break-word}.swal2-modal .swal2-checkbox,.swal2-modal .swal2-file,.swal2-modal .swal2-input,.swal2-modal .swal2-radio,.swal2-modal .swal2-select,.swal2-modal .swal2-textarea{margin:20px auto}.swal2-modal .swal2-file,.swal2-modal .swal2-input,.swal2-modal .swal2-textarea{width:100%;box-sizing:border-box;font-size:18px;border-radius:3px;border:1px solid #d9d9d9;box-shadow:inset 0 1px 1px rgba(0,0,0,.06);transition:border-color box-shadow .3s}.swal2-modal .swal2-file.swal2-inputerror,.swal2-modal .swal2-input.swal2-inputerror,.swal2-modal .swal2-textarea.swal2-inputerror{border-color:#f27474!important;box-shadow:0 0 2px #f27474!important}.swal2-modal .swal2-file:focus,.swal2-modal .swal2-input:focus,.swal2-modal .swal2-textarea:focus{outline:none;border:1px solid #b4dbed;box-shadow:0 0 3px #c4e6f5}.swal2-modal .swal2-file:focus::-webkit-input-placeholder,.swal2-modal .swal2-input:focus::-webkit-input-placeholder,.swal2-modal .swal2-textarea:focus::-webkit-input-placeholder{transition:opacity .3s ease .03s;opacity:.8}.swal2-modal .swal2-file:focus:-ms-input-placeholder,.swal2-modal .swal2-input:focus:-ms-input-placeholder,.swal2-modal .swal2-textarea:focus:-ms-input-placeholder{transition:opacity .3s ease .03s;opacity:.8}.swal2-modal .swal2-file:focus::placeholder,.swal2-modal .swal2-input:focus::placeholder,.swal2-modal .swal2-textarea:focus::placeholder{transition:opacity .3s ease .03s;opacity:.8}.swal2-modal .swal2-file::-webkit-input-placeholder,.swal2-modal .swal2-input::-webkit-input-placeholder,.swal2-modal .swal2-textarea::-webkit-input-placeholder{color:#e6e6e6}.swal2-modal .swal2-file:-ms-input-placeholder,.swal2-modal .swal2-input:-ms-input-placeholder,.swal2-modal .swal2-textarea:-ms-input-placeholder{color:#e6e6e6}.swal2-modal .swal2-file::placeholder,.swal2-modal .swal2-input::placeholder,.swal2-modal .swal2-textarea::placeholder{color:#e6e6e6}.swal2-modal .swal2-range input{float:left;width:80%}.swal2-modal .swal2-range output{float:right;width:20%;font-size:20px;font-weight:600;text-align:center}.swal2-modal .swal2-range input,.swal2-modal .swal2-range output{height:43px;line-height:43px;vertical-align:middle;margin:20px auto;padding:0}.swal2-modal .swal2-input{height:43px;padding:0 12px}.swal2-modal .swal2-input[type=number]{max-width:150px}.swal2-modal .swal2-file{font-size:20px}.swal2-modal .swal2-textarea{height:108px;padding:12px}.swal2-modal .swal2-select{color:#545454;font-size:inherit;padding:5px 10px;min-width:40%;max-width:100%}.swal2-modal .swal2-radio{border:0}.swal2-modal .swal2-radio label:not(:first-child){margin-left:20px}.swal2-modal .swal2-radio input,.swal2-modal .swal2-radio span{vertical-align:middle}.swal2-modal .swal2-radio input{margin:0 3px 0 0}.swal2-modal .swal2-checkbox{color:#545454}.swal2-modal .swal2-checkbox input,.swal2-modal .swal2-checkbox span{vertical-align:middle}.swal2-modal .swal2-validationerror{background-color:#f0f0f0;margin:0 -20px;overflow:hidden;padding:10px;color:gray;font-size:16px;font-weight:300;display:none}.swal2-modal .swal2-validationerror:before{content:"!";display:inline-block;width:24px;height:24px;border-radius:50%;background-color:#ea7d7d;color:#fff;line-height:24px;text-align:center;margin-right:10px}@supports (-ms-accelerator:true){.swal2-range input{width:100%!important}.swal2-range output{display:none}}@media (-ms-high-contrast:active),(-ms-high-contrast:none){.swal2-range input{width:100%!important}.swal2-range output{display:none}}.swal2-icon{width:80px;height:80px;border:4px solid transparent;border-radius:50%;margin:20px auto 30px;padding:0;position:relative;box-sizing:content-box;cursor:default;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.swal2-icon.swal2-error{border-color:#f27474}.swal2-icon.swal2-error .swal2-x-mark{position:relative;display:block}.swal2-icon.swal2-error [class^=swal2-x-mark-line]{position:absolute;height:5px;width:47px;background-color:#f27474;display:block;top:37px;border-radius:2px}.swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=left]{-webkit-transform:rotate(45deg);transform:rotate(45deg);left:17px}.swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=right]{-webkit-transform:rotate(-45deg);transform:rotate(-45deg);right:16px}.swal2-icon.swal2-warning{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;color:#f8bb86;border-color:#facea8}.swal2-icon.swal2-info,.swal2-icon.swal2-warning{font-size:60px;line-height:80px;text-align:center}.swal2-icon.swal2-info{font-family:Open Sans,sans-serif;color:#3fc3ee;border-color:#9de0f6}.swal2-icon.swal2-question{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;color:#87adbd;border-color:#c9dae1;font-size:60px;line-height:80px;text-align:center}.swal2-icon.swal2-success{border-color:#a5dc86}.swal2-icon.swal2-success [class^=swal2-success-circular-line]{border-radius:50%;position:absolute;width:60px;height:120px;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.swal2-icon.swal2-success [class^=swal2-success-circular-line][class$=left]{border-radius:120px 0 0 120px;top:-7px;left:-33px;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);-webkit-transform-origin:60px 60px;transform-origin:60px 60px}.swal2-icon.swal2-success [class^=swal2-success-circular-line][class$=right]{border-radius:0 120px 120px 0;top:-11px;left:30px;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);-webkit-transform-origin:0 60px;transform-origin:0 60px}.swal2-icon.swal2-success .swal2-success-ring{width:80px;height:80px;border:4px solid hsla(98,55%,69%,.2);border-radius:50%;box-sizing:content-box;position:absolute;left:-4px;top:-4px;z-index:2}.swal2-icon.swal2-success .swal2-success-fix{width:7px;height:90px;position:absolute;left:28px;top:8px;z-index:1;-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}.swal2-icon.swal2-success [class^=swal2-success-line]{height:5px;background-color:#a5dc86;display:block;border-radius:2px;position:absolute;z-index:2}.swal2-icon.swal2-success [class^=swal2-success-line][class$=tip]{width:25px;left:14px;top:46px;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.swal2-icon.swal2-success [class^=swal2-success-line][class$=long]{width:47px;right:8px;top:38px;-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}.swal2-progresssteps{font-weight:600;margin:0 0 20px;padding:0}.swal2-progresssteps li{display:inline-block;position:relative}.swal2-progresssteps .swal2-progresscircle{background:#3085d6;border-radius:2em;color:#fff;height:2em;line-height:2em;text-align:center;width:2em;z-index:20}.swal2-progresssteps .swal2-progresscircle:first-child{margin-left:0}.swal2-progresssteps .swal2-progresscircle:last-child{margin-right:0}.swal2-progresssteps .swal2-progresscircle.swal2-activeprogressstep{background:#3085d6}.swal2-progresssteps .swal2-progresscircle.swal2-activeprogressstep~.swal2-progresscircle,.swal2-progresssteps .swal2-progresscircle.swal2-activeprogressstep~.swal2-progressline{background:#add8e6}.swal2-progresssteps .swal2-progressline{background:#3085d6;height:.4em;margin:0 -1px;z-index:10}[class^=swal2]{-webkit-tap-highlight-color:transparent}@-webkit-keyframes showSweetAlert{0%{-webkit-transform:scale(.7);transform:scale(.7)}45%{-webkit-transform:scale(1.05);transform:scale(1.05)}80%{-webkit-transform:scale(.95);transform:scale(.95)}to{-webkit-transform:scale(1);transform:scale(1)}}@keyframes showSweetAlert{0%{-webkit-transform:scale(.7);transform:scale(.7)}45%{-webkit-transform:scale(1.05);transform:scale(1.05)}80%{-webkit-transform:scale(.95);transform:scale(.95)}to{-webkit-transform:scale(1);transform:scale(1)}}@-webkit-keyframes hideSweetAlert{0%{-webkit-transform:scale(1);transform:scale(1);opacity:1}to{-webkit-transform:scale(.5);transform:scale(.5);opacity:0}}@keyframes hideSweetAlert{0%{-webkit-transform:scale(1);transform:scale(1);opacity:1}to{-webkit-transform:scale(.5);transform:scale(.5);opacity:0}}.swal2-show{-webkit-animation:showSweetAlert .3s;animation:showSweetAlert .3s}.swal2-show.swal2-noanimation{-webkit-animation:none;animation:none}.swal2-hide{-webkit-animation:hideSweetAlert .15s forwards;animation:hideSweetAlert .15s forwards}.swal2-hide.swal2-noanimation{-webkit-animation:none;animation:none}@-webkit-keyframes animate-success-tip{0%{width:0;left:1px;top:19px}54%{width:0;left:1px;top:19px}70%{width:50px;left:-8px;top:37px}84%{width:17px;left:21px;top:48px}to{width:25px;left:14px;top:45px}}@keyframes animate-success-tip{0%{width:0;left:1px;top:19px}54%{width:0;left:1px;top:19px}70%{width:50px;left:-8px;top:37px}84%{width:17px;left:21px;top:48px}to{width:25px;left:14px;top:45px}}@-webkit-keyframes animate-success-long{0%{width:0;right:46px;top:54px}65%{width:0;right:46px;top:54px}84%{width:55px;right:0;top:35px}to{width:47px;right:8px;top:38px}}@keyframes animate-success-long{0%{width:0;right:46px;top:54px}65%{width:0;right:46px;top:54px}84%{width:55px;right:0;top:35px}to{width:47px;right:8px;top:38px}}@-webkit-keyframes rotatePlaceholder{0%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}5%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}12%{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}to{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}}@keyframes rotatePlaceholder{0%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}5%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}12%{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}to{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}}.swal2-animate-success-line-tip{-webkit-animation:animate-success-tip .75s;animation:animate-success-tip .75s}.swal2-animate-success-line-long{-webkit-animation:animate-success-long .75s;animation:animate-success-long .75s}.swal2-success.swal2-animate-success-icon .swal2-success-circular-line-right{-webkit-animation:rotatePlaceholder 4.25s ease-in;animation:rotatePlaceholder 4.25s ease-in}@-webkit-keyframes animate-error-icon{0%{-webkit-transform:rotateX(100deg);transform:rotateX(100deg);opacity:0}to{-webkit-transform:rotateX(0deg);transform:rotateX(0deg);opacity:1}}@keyframes animate-error-icon{0%{-webkit-transform:rotateX(100deg);transform:rotateX(100deg);opacity:0}to{-webkit-transform:rotateX(0deg);transform:rotateX(0deg);opacity:1}}.swal2-animate-error-icon{-webkit-animation:animate-error-icon .5s;animation:animate-error-icon .5s}@-webkit-keyframes animate-x-mark{0%{-webkit-transform:scale(.4);transform:scale(.4);margin-top:26px;opacity:0}50%{-webkit-transform:scale(.4);transform:scale(.4);margin-top:26px;opacity:0}80%{-webkit-transform:scale(1.15);transform:scale(1.15);margin-top:-6px}to{-webkit-transform:scale(1);transform:scale(1);margin-top:0;opacity:1}}@keyframes animate-x-mark{0%{-webkit-transform:scale(.4);transform:scale(.4);margin-top:26px;opacity:0}50%{-webkit-transform:scale(.4);transform:scale(.4);margin-top:26px;opacity:0}80%{-webkit-transform:scale(1.15);transform:scale(1.15);margin-top:-6px}to{-webkit-transform:scale(1);transform:scale(1);margin-top:0;opacity:1}}.swal2-animate-x-mark{-webkit-animation:animate-x-mark .5s;animation:animate-x-mark .5s}@-webkit-keyframes rotate-loading{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes rotate-loading{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}',""])},function(e,t){e.exports=function(){var e=[];return e.toString=function(){for(var e=[],t=0;t<this.length;t++){var n=this[t];n[2]?e.push("@media "+n[2]+"{"+n[1]+"}"):e.push(n[1])}return e.join("")},e.i=function(t,n){"string"==typeof t&&(t=[[null,t,""]]);for(var o={},a=0;a<this.length;a++){var r=this[a][0];"number"==typeof r&&(o[r]=!0)}for(a=0;a<t.length;a++){var i=t[a];"number"==typeof i[0]&&o[i[0]]||(n&&!i[2]?i[2]=n:n&&(i[2]="("+i[2]+") and ("+n+")"),e.push(i))}},e}},function(e,t,n){function o(e,t){for(var n=0;n<e.length;n++){var o=e[n],a=f[o.id];if(a){a.refs++;for(var r=0;r<a.parts.length;r++)a.parts[r](o.parts[r]);for(;r<o.parts.length;r++)a.parts.push(c(o.parts[r],t))}else{for(var i=[],r=0;r<o.parts.length;r++)i.push(c(o.parts[r],t));f[o.id]={id:o.id,refs:1,parts:i}}}}function a(e){for(var t=[],n={},o=0;o<e.length;o++){var a=e[o],r=a[0],i=a[1],s=a[2],l=a[3],c={css:i,media:s,sourceMap:l};n[r]?n[r].parts.push(c):t.push(n[r]={id:r,parts:[c]})}return t}function r(e,t){var n=g(),o=x[x.length-1];if("top"===e.insertAt)o?o.nextSibling?n.insertBefore(t,o.nextSibling):n.appendChild(t):n.insertBefore(t,n.firstChild),x.push(t);else{if("bottom"!==e.insertAt)throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");n.appendChild(t)}}function i(e){e.parentNode.removeChild(e);var t=x.indexOf(e);t>=0&&x.splice(t,1)}function s(e){var t=document.createElement("style");return t.type="text/css",r(e,t),t}function l(e){var t=document.createElement("link");return t.rel="stylesheet",r(e,t),t}function c(e,t){var n,o,a;if(t.singleton){var r=b++;n=h||(h=s(t)),o=u.bind(null,n,r,!1),a=u.bind(null,n,r,!0)}else e.sourceMap&&"function"==typeof URL&&"function"==typeof URL.createObjectURL&&"function"==typeof URL.revokeObjectURL&&"function"==typeof Blob&&"function"==typeof btoa?(n=l(t),o=p.bind(null,n),a=function(){i(n),n.href&&URL.revokeObjectURL(n.href)}):(n=s(t),o=d.bind(null,n),a=function(){i(n)});return o(e),function(t){if(t){if(t.css===e.css&&t.media===e.media&&t.sourceMap===e.sourceMap)return;o(e=t)}else a()}}function u(e,t,n,o){var a=n?"":o.css;if(e.styleSheet)e.styleSheet.cssText=v(t,a);else{var r=document.createTextNode(a),i=e.childNodes;i[t]&&e.removeChild(i[t]),i.length?e.insertBefore(r,i[t]):e.appendChild(r)}}function d(e,t){var n=t.css,o=t.media;if(o&&e.setAttribute("media",o),e.styleSheet)e.styleSheet.cssText=n;else{for(;e.firstChild;)e.removeChild(e.firstChild);e.appendChild(document.createTextNode(n))}}function p(e,t){var n=t.css,o=t.sourceMap;o&&(n+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(o))))+" */");var a=new Blob([n],{type:"text/css"}),r=e.href;e.href=URL.createObjectURL(a),r&&URL.revokeObjectURL(r)}var f={},m=function(e){var t;return function(){return"undefined"==typeof t&&(t=e.apply(this,arguments)),t}},w=m(function(){return/msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase())}),g=m(function(){return document.head||document.getElementsByTagName("head")[0]}),h=null,b=0,x=[];e.exports=function(e,t){t=t||{},"undefined"==typeof t.singleton&&(t.singleton=w()),"undefined"==typeof t.insertAt&&(t.insertAt="bottom");var n=a(e);return o(n,t),function(e){for(var r=[],i=0;i<n.length;i++){var s=n[i],l=f[s.id];l.refs--,r.push(l)}if(e){var c=a(e);o(c,t)}for(var i=0;i<r.length;i++){var l=r[i];if(0===l.refs){for(var u=0;u<l.parts.length;u++)l.parts[u]();delete f[l.id]}}}};var v=function(){var e=[];return function(t,n){return e[t]=n,e.filter(Boolean).join("\n")}}()},function(e,t,n){var o=n(2);"string"==typeof o&&(o=[[e.id,o,""]]);n(4)(o,{});o.locals&&(e.exports=o.locals)},function(e,t,n){/*!
		 * sweetalert2 v6.6.6
		 * Released under the MIT License.
		 */
	!function(t,n){e.exports=n()}(this,function(){"use strict";var e={title:"",titleText:"",text:"",html:"",type:null,customClass:"",target:"body",animation:!0,allowOutsideClick:!0,allowEscapeKey:!0,allowEnterKey:!0,showConfirmButton:!0,showCancelButton:!1,preConfirm:null,confirmButtonText:"OK",confirmButtonColor:"#3085d6",confirmButtonClass:null,cancelButtonText:"Cancel",cancelButtonColor:"#aaa",cancelButtonClass:null,buttonsStyling:!0,reverseButtons:!1,focusCancel:!1,showCloseButton:!1,showLoaderOnConfirm:!1,imageUrl:null,imageWidth:null,imageHeight:null,imageClass:null,timer:null,width:500,padding:20,background:"#fff",input:null,inputPlaceholder:"",inputValue:"",inputOptions:{},inputAutoTrim:!0,inputClass:null,inputAttributes:{},inputValidator:null,progressSteps:[],currentProgressStep:null,progressStepsDistance:"40px",onOpen:null,onClose:null,useRejections:!0},t="swal2-",n=function(e){var n={};for(var o in e)n[e[o]]=t+e[o];return n},o=n(["container","shown","iosfix","modal","overlay","fade","show","hide","noanimation","close","title","content","buttonswrapper","confirm","cancel","icon","image","input","file","range","select","radio","checkbox","textarea","inputerror","validationerror","progresssteps","activeprogressstep","progresscircle","progressline","loading","styled"]),a=n(["success","warning","info","question","error"]),r=function(e,t){e=String(e).replace(/[^0-9a-f]/gi,""),e.length<6&&(e=e[0]+e[0]+e[1]+e[1]+e[2]+e[2]),t=t||0;for(var n="#",o=0;o<3;o++){var a=parseInt(e.substr(2*o,2),16);a=Math.round(Math.min(Math.max(0,a+a*t),255)).toString(16),n+=("00"+a).substr(a.length)}return n},i=function(e){var t=[];for(var n in e)t.indexOf(e[n])===-1&&t.push(e[n]);return t},s={previousWindowKeyDown:null,previousActiveElement:null,previousBodyPadding:null},l=function(e){if("undefined"==typeof document)return void console.error("SweetAlert2 requires document to initialize");var t=document.createElement("div");t.className=o.container,t.innerHTML=c;var n=document.querySelector(e.target);n||(console.warn("SweetAlert2: Can't find the target \""+e.target+'"'),n=document.body),n.appendChild(t);var a=d(),r=P(a,o.input),i=P(a,o.file),s=a.querySelector("."+o.range+" input"),l=a.querySelector("."+o.range+" output"),u=P(a,o.select),p=a.querySelector("."+o.checkbox+" input"),f=P(a,o.textarea);return r.oninput=function(){Y.resetValidationError()},r.onkeydown=function(t){setTimeout(function(){13===t.keyCode&&e.allowEnterKey&&(t.stopPropagation(),Y.clickConfirm())},0)},i.onchange=function(){Y.resetValidationError()},s.oninput=function(){Y.resetValidationError(),l.value=s.value},s.onchange=function(){Y.resetValidationError(),s.previousSibling.value=s.value},u.onchange=function(){Y.resetValidationError()},p.onchange=function(){Y.resetValidationError()},f.oninput=function(){Y.resetValidationError()},a},c=('\n <div role="dialog" aria-labelledby="'+o.title+'" aria-describedby="'+o.content+'" class="'+o.modal+'" tabindex="-1">\n   <ul class="'+o.progresssteps+'"></ul>\n   <div class="'+o.icon+" "+a.error+'">\n     <span class="swal2-x-mark"><span class="swal2-x-mark-line-left"></span><span class="swal2-x-mark-line-right"></span></span>\n   </div>\n   <div class="'+o.icon+" "+a.question+'">?</div>\n   <div class="'+o.icon+" "+a.warning+'">!</div>\n   <div class="'+o.icon+" "+a.info+'">i</div>\n   <div class="'+o.icon+" "+a.success+'">\n     <div class="swal2-success-circular-line-left"></div>\n     <span class="swal2-success-line-tip"></span> <span class="swal2-success-line-long"></span>\n     <div class="swal2-success-ring"></div> <div class="swal2-success-fix"></div>\n     <div class="swal2-success-circular-line-right"></div>\n   </div>\n   <img class="'+o.image+'" />\n   <h2 class="'+o.title+'" id="'+o.title+'"></h2>\n   <div id="'+o.content+'" class="'+o.content+'"></div>\n   <input class="'+o.input+'" />\n   <input type="file" class="'+o.file+'" />\n   <div class="'+o.range+'">\n     <output></output>\n     <input type="range" />\n   </div>\n   <select class="'+o.select+'"></select>\n   <div class="'+o.radio+'"></div>\n   <label for="'+o.checkbox+'" class="'+o.checkbox+'">\n     <input type="checkbox" />\n   </label>\n   <textarea class="'+o.textarea+'"></textarea>\n   <div class="'+o.validationerror+'"></div>\n   <div class="'+o.buttonswrapper+'">\n     <button type="button" class="'+o.confirm+'">OK</button>\n     <button type="button" class="'+o.cancel+'">Cancel</button>\n   </div>\n   <button type="button" class="'+o.close+'" aria-label="Close this dialog">×</button>\n </div>\n').replace(/(^|\n)\s*/g,""),u=function(){return document.body.querySelector("."+o.container)},d=function(){return u()?u().querySelector("."+o.modal):null},p=function(){var e=d();return e.querySelectorAll("."+o.icon)},f=function(e){return u()?u().querySelector("."+e):null},m=function(){return f(o.title)},w=function(){return f(o.content)},g=function(){return f(o.image)},h=function(){return f(o.buttonswrapper)},b=function(){return f(o.progresssteps)},x=function(){return f(o.validationerror)},v=function(){return f(o.confirm)},y=function(){return f(o.cancel)},k=function(){return f(o.close)},C=function(e){var t=[v(),y()];e&&t.reverse();var n=t.concat(Array.prototype.slice.call(d().querySelectorAll('button, input:not([type=hidden]), textarea, select, a, *[tabindex]:not([tabindex="-1"])')));return i(n)},S=function(e,t){return!!e.classList&&e.classList.contains(t)},A=function(e){if(e.focus(),"file"!==e.type){var t=e.value;e.value="",e.value=t}},E=function(e,t){if(e&&t){var n=t.split(/\s+/).filter(Boolean);n.forEach(function(t){e.classList.add(t)})}},B=function(e,t){if(e&&t){var n=t.split(/\s+/).filter(Boolean);n.forEach(function(t){e.classList.remove(t)})}},P=function(e,t){for(var n=0;n<e.childNodes.length;n++)if(S(e.childNodes[n],t))return e.childNodes[n]},L=function(e,t){t||(t="block"),e.style.opacity="",e.style.display=t},M=function(e){e.style.opacity="",e.style.display="none"},T=function(e){for(;e.firstChild;)e.removeChild(e.firstChild)},O=function(e){return e.offsetWidth||e.offsetHeight||e.getClientRects().length},q=function(e,t){e.style.removeProperty?e.style.removeProperty(t):e.style.removeAttribute(t)},H=function(e){if(!O(e))return!1;if("function"==typeof MouseEvent){var t=new MouseEvent("click",{view:window,bubbles:!1,cancelable:!0});e.dispatchEvent(t)}else if(document.createEvent){var n=document.createEvent("MouseEvents");n.initEvent("click",!1,!1),e.dispatchEvent(n)}else document.createEventObject?e.fireEvent("onclick"):"function"==typeof e.onclick&&e.onclick()},V=function(){var e=document.createElement("div"),t={WebkitAnimation:"webkitAnimationEnd",OAnimation:"oAnimationEnd oanimationend",msAnimation:"MSAnimationEnd",animation:"animationend"};for(var n in t)if(t.hasOwnProperty(n)&&void 0!==e.style[n])return t[n];return!1}(),j=function(){if(window.onkeydown=s.previousWindowKeyDown,s.previousActiveElement&&s.previousActiveElement.focus){var e=window.scrollX,t=window.scrollY;s.previousActiveElement.focus(),e&&t&&window.scrollTo(e,t)}},z=function(){var e="ontouchstart"in window||navigator.msMaxTouchPoints;if(e)return 0;var t=document.createElement("div");t.style.width="50px",t.style.height="50px",t.style.overflow="scroll",document.body.appendChild(t);var n=t.offsetWidth-t.clientWidth;return document.body.removeChild(t),n},N=function(e,t){var n=void 0;return function(){var o=function(){n=null,e()};clearTimeout(n),n=setTimeout(o,t)}},R="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},U=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(e[o]=n[o])}return e},I=U({},e),K=[],D=void 0,W=function(t){var n=d()||l(t);for(var r in t)e.hasOwnProperty(r)||"extraParams"===r||console.warn('SweetAlert2: Unknown parameter "'+r+'"');n.style.width="number"==typeof t.width?t.width+"px":t.width,n.style.padding=t.padding+"px",n.style.background=t.background;for(var i=n.querySelectorAll("[class^=swal2-success-circular-line], .swal2-success-fix"),s=0;s<i.length;s++)i[s].style.background=t.background;var c=m(),u=w(),f=h(),x=v(),C=y(),S=k();if(t.titleText?c.innerText=t.titleText:c.innerHTML=t.title.split("\n").join("<br />"),t.text||t.html){if("object"===R(t.html))if(u.innerHTML="",0 in t.html)for(var A=0;A in t.html;A++)u.appendChild(t.html[A].cloneNode(!0));else u.appendChild(t.html.cloneNode(!0));else t.html?u.innerHTML=t.html:t.text&&(u.textContent=t.text);L(u)}else M(u);t.showCloseButton?L(S):M(S),n.className=o.modal,t.customClass&&E(n,t.customClass);var P=b(),O=parseInt(null===t.currentProgressStep?Y.getQueueStep():t.currentProgressStep,10);t.progressSteps.length?(L(P),T(P),O>=t.progressSteps.length&&console.warn("SweetAlert2: Invalid currentProgressStep parameter, it should be less than progressSteps.length (currentProgressStep like JS arrays starts from 0)"),t.progressSteps.forEach(function(e,n){var a=document.createElement("li");if(E(a,o.progresscircle),a.innerHTML=e,n===O&&E(a,o.activeprogressstep),P.appendChild(a),n!==t.progressSteps.length-1){var r=document.createElement("li");E(r,o.progressline),r.style.width=t.progressStepsDistance,P.appendChild(r)}})):M(P);for(var H=p(),V=0;V<H.length;V++)M(H[V]);if(t.type){var j=!1;for(var z in a)if(t.type===z){j=!0;break}if(!j)return console.error("SweetAlert2: Unknown alert type: "+t.type),!1;var N=n.querySelector("."+o.icon+"."+a[t.type]);if(L(N),t.animation)switch(t.type){case"success":E(N,"swal2-animate-success-icon"),E(N.querySelector(".swal2-success-line-tip"),"swal2-animate-success-line-tip"),E(N.querySelector(".swal2-success-line-long"),"swal2-animate-success-line-long");break;case"error":E(N,"swal2-animate-error-icon"),E(N.querySelector(".swal2-x-mark"),"swal2-animate-x-mark")}}var U=g();t.imageUrl?(U.setAttribute("src",t.imageUrl),L(U),t.imageWidth?U.setAttribute("width",t.imageWidth):U.removeAttribute("width"),t.imageHeight?U.setAttribute("height",t.imageHeight):U.removeAttribute("height"),U.className=o.image,t.imageClass&&E(U,t.imageClass)):M(U),t.showCancelButton?C.style.display="inline-block":M(C),t.showConfirmButton?q(x,"display"):M(x),t.showConfirmButton||t.showCancelButton?L(f):M(f),x.innerHTML=t.confirmButtonText,C.innerHTML=t.cancelButtonText,t.buttonsStyling&&(x.style.backgroundColor=t.confirmButtonColor,C.style.backgroundColor=t.cancelButtonColor),x.className=o.confirm,E(x,t.confirmButtonClass),C.className=o.cancel,E(C,t.cancelButtonClass),t.buttonsStyling?(E(x,o.styled),E(C,o.styled)):(B(x,o.styled),B(C,o.styled),x.style.backgroundColor=x.style.borderLeftColor=x.style.borderRightColor="",C.style.backgroundColor=C.style.borderLeftColor=C.style.borderRightColor=""),t.animation===!0?B(n,o.noanimation):E(n,o.noanimation)},_=function(e,t){var n=u(),a=d();e?(E(a,o.show),E(n,o.fade),B(a,o.hide)):B(a,o.fade),L(a),n.style.overflowY="hidden",V&&!S(a,o.noanimation)?a.addEventListener(V,function e(){a.removeEventListener(V,e),n.style.overflowY="auto"}):n.style.overflowY="auto",E(document.documentElement,o.shown),E(document.body,o.shown),E(n,o.shown),X(),Z(),s.previousActiveElement=document.activeElement,null!==t&&"function"==typeof t&&setTimeout(function(){t(a)})},X=function(){null===s.previousBodyPadding&&document.body.scrollHeight>window.innerHeight&&(s.previousBodyPadding=document.body.style.paddingRight,document.body.style.paddingRight=z()+"px")},$=function(){null!==s.previousBodyPadding&&(document.body.style.paddingRight=s.previousBodyPadding,s.previousBodyPadding=null)},Z=function(){var e=/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream;if(e&&!S(document.body,o.iosfix)){var t=document.body.scrollTop;document.body.style.top=t*-1+"px",E(document.body,o.iosfix)}},Q=function(){if(S(document.body,o.iosfix)){var e=parseInt(document.body.style.top,10);B(document.body,o.iosfix),document.body.style.top="",document.body.scrollTop=e*-1}},Y=function e(){for(var t=arguments.length,n=Array(t),a=0;a<t;a++)n[a]=arguments[a];if(void 0===n[0])return console.error("SweetAlert2 expects at least 1 attribute!"),!1;var i=U({},I);switch(R(n[0])){case"string":i.title=n[0],i.html=n[1],i.type=n[2];break;case"object":U(i,n[0]),i.extraParams=n[0].extraParams,"email"===i.input&&null===i.inputValidator&&(i.inputValidator=function(e){return new Promise(function(t,n){var o=/^[a-zA-Z0-9.+_-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;o.test(e)?t():n("Invalid email address")})}),"url"===i.input&&null===i.inputValidator&&(i.inputValidator=function(e){return new Promise(function(t,n){var o=/^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&\/\/=]*)$/;o.test(e)?t():n("Invalid URL")})});break;default:return console.error('SweetAlert2: Unexpected type of argument! Expected "string" or "object", got '+R(n[0])),!1}W(i);var l=u(),c=d();return new Promise(function(t,n){i.timer&&(c.timeout=setTimeout(function(){e.closeModal(i.onClose),i.useRejections?n("timer"):t({dismiss:"timer"})},i.timer));var a=function(e){if(e=e||i.input,!e)return null;switch(e){case"select":case"textarea":case"file":return P(c,o[e]);case"checkbox":return c.querySelector("."+o.checkbox+" input");case"radio":return c.querySelector("."+o.radio+" input:checked")||c.querySelector("."+o.radio+" input:first-child");case"range":return c.querySelector("."+o.range+" input");default:return P(c,o.input)}},p=function(){var e=a();if(!e)return null;switch(i.input){case"checkbox":return e.checked?1:0;case"radio":return e.checked?e.value:null;case"file":return e.files.length?e.files[0]:null;default:return i.inputAutoTrim?e.value.trim():e.value}};i.input&&setTimeout(function(){var e=a();e&&A(e)},0);for(var f=function(n){i.showLoaderOnConfirm&&e.showLoading(),i.preConfirm?i.preConfirm(n,i.extraParams).then(function(o){e.closeModal(i.onClose),t(o||n)},function(t){e.hideLoading(),t&&e.showValidationError(t)}):(e.closeModal(i.onClose),t(i.useRejections?n:{value:n}))},S=function(o){var a=o||window.event,s=a.target||a.srcElement,l=v(),c=y(),u=l&&(l===s||l.contains(s)),d=c&&(c===s||c.contains(s));switch(a.type){case"mouseover":case"mouseup":i.buttonsStyling&&(u?l.style.backgroundColor=r(i.confirmButtonColor,-.1):d&&(c.style.backgroundColor=r(i.cancelButtonColor,-.1)));break;case"mouseout":i.buttonsStyling&&(u?l.style.backgroundColor=i.confirmButtonColor:d&&(c.style.backgroundColor=i.cancelButtonColor));break;case"mousedown":i.buttonsStyling&&(u?l.style.backgroundColor=r(i.confirmButtonColor,-.2):d&&(c.style.backgroundColor=r(i.cancelButtonColor,-.2)));break;case"click":if(u&&e.isVisible())if(e.disableButtons(),i.input){var m=p();i.inputValidator?(e.disableInput(),i.inputValidator(m,i.extraParams).then(function(){e.enableButtons(),e.enableInput(),f(m)},function(t){e.enableButtons(),e.enableInput(),t&&e.showValidationError(t)})):f(m)}else f(!0);else d&&e.isVisible()&&(e.disableButtons(),e.closeModal(i.onClose),i.useRejections?n("cancel"):t({dismiss:"cancel"}))}},T=c.querySelectorAll("button"),q=0;q<T.length;q++)T[q].onclick=S,T[q].onmouseover=S,T[q].onmouseout=S,T[q].onmousedown=S;k().onclick=function(){e.closeModal(i.onClose),i.useRejections?n("close"):t({dismiss:"close"})},l.onclick=function(o){o.target===l&&i.allowOutsideClick&&(e.closeModal(i.onClose),i.useRejections?n("overlay"):t({dismiss:"overlay"}))};var V=h(),j=v(),z=y();i.reverseButtons?j.parentNode.insertBefore(z,j):j.parentNode.insertBefore(j,z);var U=function(e,t){for(var n=C(i.focusCancel),o=0;o<n.length;o++){e+=t,e===n.length?e=0:e===-1&&(e=n.length-1);var a=n[e];if(O(a))return a.focus()}},I=function(o){var a=o||window.event,r=a.keyCode||a.which;if([9,13,32,27,37,38,39,40].indexOf(r)!==-1){for(var s=a.target||a.srcElement,l=C(i.focusCancel),c=-1,u=0;u<l.length;u++)if(s===l[u]){c=u;break}9===r?(a.shiftKey?U(c,-1):U(c,1),a.stopPropagation(),a.preventDefault()):37===r||38===r||39===r||40===r?document.activeElement===j&&O(z)?z.focus():document.activeElement===z&&O(j)&&j.focus():13===r||32===r?c===-1&&i.allowEnterKey&&(i.focusCancel?H(z,a):H(j,a),a.stopPropagation(),a.preventDefault()):27===r&&i.allowEscapeKey===!0&&(e.closeModal(i.onClose),i.useRejections?n("esc"):t({dismiss:"esc"}))}};window.onkeydown&&window.onkeydown.toString()===I.toString()||(s.previousWindowKeyDown=window.onkeydown,window.onkeydown=I),i.buttonsStyling&&(j.style.borderLeftColor=i.confirmButtonColor,j.style.borderRightColor=i.confirmButtonColor),e.hideLoading=e.disableLoading=function(){i.showConfirmButton||(M(j),i.showCancelButton||M(h())),B(V,o.loading),B(c,o.loading),j.disabled=!1,z.disabled=!1},e.getTitle=function(){return m()},e.getContent=function(){return w()},e.getInput=function(){return a()},e.getImage=function(){return g()},e.getButtonsWrapper=function(){return h()},e.getConfirmButton=function(){return v()},e.getCancelButton=function(){return y()},e.enableButtons=function(){j.disabled=!1,z.disabled=!1},e.disableButtons=function(){j.disabled=!0,z.disabled=!0},e.enableConfirmButton=function(){j.disabled=!1},e.disableConfirmButton=function(){j.disabled=!0},e.enableInput=function(){var e=a();if(!e)return!1;if("radio"===e.type)for(var t=e.parentNode.parentNode,n=t.querySelectorAll("input"),o=0;o<n.length;o++)n[o].disabled=!1;else e.disabled=!1},e.disableInput=function(){var e=a();if(!e)return!1;if(e&&"radio"===e.type)for(var t=e.parentNode.parentNode,n=t.querySelectorAll("input"),o=0;o<n.length;o++)n[o].disabled=!0;else e.disabled=!0},e.recalculateHeight=N(function(){var e=d();if(e){var t=e.style.display;e.style.minHeight="",L(e),e.style.minHeight=e.scrollHeight+1+"px",e.style.display=t}},50),e.showValidationError=function(e){var t=x();t.innerHTML=e,L(t);var n=a();n&&(A(n),E(n,o.inputerror))},e.resetValidationError=function(){var t=x();M(t),e.recalculateHeight();var n=a();n&&B(n,o.inputerror)},e.getProgressSteps=function(){return i.progressSteps},e.setProgressSteps=function(e){i.progressSteps=e,W(i)},e.showProgressSteps=function(){L(b())},e.hideProgressSteps=function(){M(b())},e.enableButtons(),e.hideLoading(),e.resetValidationError();for(var K=["input","file","range","select","radio","checkbox","textarea"],X=void 0,$=0;$<K.length;$++){var Z=o[K[$]],Q=P(c,Z);if(X=a(K[$])){for(var Y in X.attributes)if(X.attributes.hasOwnProperty(Y)){var J=X.attributes[Y].name;"type"!==J&&"value"!==J&&X.removeAttribute(J)}for(var F in i.inputAttributes)X.setAttribute(F,i.inputAttributes[F])}Q.className=Z,i.inputClass&&E(Q,i.inputClass),M(Q)}var G=void 0;switch(i.input){case"text":case"email":case"password":case"number":case"tel":case"url":X=P(c,o.input),X.value=i.inputValue,X.placeholder=i.inputPlaceholder,X.type=i.input,L(X);break;case"file":X=P(c,o.file),X.placeholder=i.inputPlaceholder,X.type=i.input,L(X);break;case"range":var ee=P(c,o.range),te=ee.querySelector("input"),ne=ee.querySelector("output");te.value=i.inputValue,te.type=i.input,ne.value=i.inputValue,L(ee);break;case"select":var oe=P(c,o.select);if(oe.innerHTML="",i.inputPlaceholder){var ae=document.createElement("option");ae.innerHTML=i.inputPlaceholder,ae.value="",ae.disabled=!0,ae.selected=!0,oe.appendChild(ae)}G=function(e){for(var t in e){var n=document.createElement("option");n.value=t,n.innerHTML=e[t],i.inputValue===t&&(n.selected=!0),oe.appendChild(n)}L(oe),oe.focus()};break;case"radio":var re=P(c,o.radio);re.innerHTML="",G=function(e){for(var t in e){var n=document.createElement("input"),a=document.createElement("label"),r=document.createElement("span");n.type="radio",n.name=o.radio,n.value=t,i.inputValue===t&&(n.checked=!0),r.innerHTML=e[t],a.appendChild(n),a.appendChild(r),a.for=n.id,re.appendChild(a)}L(re);var s=re.querySelectorAll("input");s.length&&s[0].focus()};break;case"checkbox":var ie=P(c,o.checkbox),se=a("checkbox");se.type="checkbox",se.value=1,se.id=o.checkbox,se.checked=Boolean(i.inputValue);var le=ie.getElementsByTagName("span");le.length&&ie.removeChild(le[0]),le=document.createElement("span"),le.innerHTML=i.inputPlaceholder,ie.appendChild(le),L(ie);break;case"textarea":var ce=P(c,o.textarea);ce.value=i.inputValue,ce.placeholder=i.inputPlaceholder,L(ce);break;case null:break;default:console.error('SweetAlert2: Unexpected type of input! Expected "text", "email", "password", "number", "tel", "select", "radio", "checkbox", "textarea", "file" or "url", got "'+i.input+'"')}"select"!==i.input&&"radio"!==i.input||(i.inputOptions instanceof Promise?(e.showLoading(),i.inputOptions.then(function(t){e.hideLoading(),G(t)})):"object"===R(i.inputOptions)?G(i.inputOptions):console.error("SweetAlert2: Unexpected type of inputOptions! Expected object or Promise, got "+R(i.inputOptions))),_(i.animation,i.onOpen),i.allowEnterKey?U(-1,1):document.activeElement&&document.activeElement.blur(),u().scrollTop=0,"undefined"==typeof MutationObserver||D||(D=new MutationObserver(e.recalculateHeight),D.observe(c,{childList:!0,characterData:!0,subtree:!0}))})};return Y.isVisible=function(){return!!d()},Y.queue=function(e){K=e;var t=function(){K=[],document.body.removeAttribute("data-swal2-queue-step")},n=[];return new Promise(function(e,o){!function a(r,i){r<K.length?(document.body.setAttribute("data-swal2-queue-step",r),Y(K[r]).then(function(e){n.push(e),a(r+1,i)},function(e){t(),o(e)})):(t(),e(n))}(0)})},Y.getQueueStep=function(){return document.body.getAttribute("data-swal2-queue-step")},Y.insertQueueStep=function(e,t){return t&&t<K.length?K.splice(t,0,e):K.push(e)},Y.deleteQueueStep=function(e){"undefined"!=typeof K[e]&&K.splice(e,1)},Y.close=Y.closeModal=function(e){var t=u(),n=d();if(n){B(n,o.show),E(n,o.hide),clearTimeout(n.timeout),j();var a=function(){t.parentNode&&t.parentNode.removeChild(t),B(document.documentElement,o.shown),B(document.body,o.shown),$(),Q()};V&&!S(n,o.noanimation)?n.addEventListener(V,function e(){n.removeEventListener(V,e),S(n,o.hide)&&a()}):a(),null!==e&&"function"==typeof e&&setTimeout(function(){e(n)})}},Y.clickConfirm=function(){return v().click()},Y.clickCancel=function(){return y().click()},Y.showLoading=Y.enableLoading=function(){var e=d();e||Y("");var t=h(),n=v(),a=y();L(t),L(n,"inline-block"),E(t,o.loading),E(e,o.loading),n.disabled=!0,a.disabled=!0},Y.setDefaults=function(t){if(!t||"object"!==("undefined"==typeof t?"undefined":R(t)))return console.error("SweetAlert2: the argument for setDefaults() is required and has to be a object");for(var n in t)e.hasOwnProperty(n)||"extraParams"===n||(console.warn('SweetAlert2: Unknown parameter "'+n+'"'),delete t[n]);U(I,t)},Y.resetDefaults=function(){I=U({},e)},Y.noop=function(){},Y.version="6.6.6",Y.default=Y,Y}),window.Sweetalert2&&(window.sweetAlert=window.swal=window.Sweetalert2)}])});
	//# sourceMappingURL=vue-sweetalert.js.map

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	(function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.VueTheMask=t():e.VueTheMask=t()})(this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var a=n[r]={i:r,l:!1,exports:{}};return e[r].call(a.exports,a,a.exports,t),a.l=!0,a.exports}var n={};return t.m=e,t.c=n,t.i=function(e){return e},t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p=".",t(t.s=10)}([function(e,t){e.exports={"#":{pattern:/\d/},X:{pattern:/[0-9a-zA-Z]/},S:{pattern:/[a-zA-Z]/},A:{pattern:/[a-zA-Z]/,transform:function(e){return e.toLocaleUpperCase()}},a:{pattern:/[a-zA-Z]/,transform:function(e){return e.toLocaleLowerCase()}},"!":{escape:!0}}},function(e,t,n){"use strict";function r(e){var t=document.createEvent("Event");return t.initEvent(e,!0,!0),t}var a=n(2),o=n(0),i=n.n(o);t.a=function(e,t){var o=t.value;if((Array.isArray(o)||"string"==typeof o)&&(o={mask:o,tokens:i.a}),"INPUT"!==e.tagName.toLocaleUpperCase()){var u=e.getElementsByTagName("input");if(1!==u.length)throw new Error("v-mask directive requires 1 input, found "+u.length);e=u[0]}e.oninput=function(t){if(t.isTrusted){var i=e.selectionEnd,u=e.value[i-1];for(e.value=n.i(a.a)(e.value,o.mask,!0,o.tokens);i<e.value.length&&e.value.charAt(i-1)!==u;)i++;e===document.activeElement&&(e.setSelectionRange(i,i),setTimeout(function(){e.setSelectionRange(i,i)},0)),e.dispatchEvent(r("input"))}};var s=n.i(a.a)(e.value,o.mask,!0,o.tokens);s!==e.value&&(e.value=s,e.dispatchEvent(r("input")))}},function(e,t,n){"use strict";var r=n(6),a=n(5);t.a=function(e,t){var o=!(arguments.length>2&&void 0!==arguments[2])||arguments[2],i=arguments[3];return Array.isArray(t)?n.i(a.a)(r.a,t,i)(e,t,o,i):n.i(r.a)(e,t,o,i)}},function(e,t,n){"use strict";function r(e){e.component(s.a.name,s.a),e.directive("mask",i.a)}Object.defineProperty(t,"__esModule",{value:!0});var a=n(0),o=n.n(a),i=n(1),u=n(7),s=n.n(u);n.d(t,"TheMask",function(){return s.a}),n.d(t,"mask",function(){return i.a}),n.d(t,"tokens",function(){return o.a}),n.d(t,"version",function(){return c});var c="0.11.1";t.default=r,"undefined"!=typeof window&&window.Vue&&window.Vue.use(r)},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=n(1),a=n(0),o=n.n(a),i=n(2);t.default={name:"TheMask",props:{value:[String,Number],mask:{type:[String,Array],required:!0},masked:{type:Boolean,default:!1},tokens:{type:Object,default:function(){return o.a}}},directives:{mask:r.a},data:function(){return{lastValue:null,display:this.value}},watch:{value:function(e){e!==this.lastValue&&(this.display=e)},masked:function(){this.refresh(this.display)}},computed:{config:function(){return{mask:this.mask,tokens:this.tokens,masked:this.masked}}},methods:{onInput:function(e){e.isTrusted||this.refresh(e.target.value)},refresh:function(e){this.display=e;var e=n.i(i.a)(e,this.mask,this.masked,this.tokens);e!==this.lastValue&&(this.lastValue=e,this.$emit("input",e))}}}},function(e,t,n){"use strict";function r(e,t,n){return t=t.sort(function(e,t){return e.length-t.length}),function(r,a){for(var o=!(arguments.length>2&&void 0!==arguments[2])||arguments[2],i=0;i<t.length;){var u=t[i];i++;var s=t[i];if(!(s&&e(r,s,!0,n).length>u.length))return e(r,u,o,n)}return""}}t.a=r},function(e,t,n){"use strict";function r(e,t){var n=!(arguments.length>2&&void 0!==arguments[2])||arguments[2],r=arguments[3];e=e||"",t=t||"";for(var a=0,o=0,i="";a<t.length&&o<e.length;){var u=t[a],s=r[u],c=e[o];s&&!s.escape?(s.pattern.test(c)&&(i+=s.transform?s.transform(c):c,a++),o++):(s&&s.escape&&(a++,u=t[a]),n&&(i+=u),c===u&&o++,a++)}for(var f="";a<t.length&&n;){var u=t[a];if(r[u]){f="";break}f+=u,a++}return i+f}t.a=r},function(e,t,n){var r=n(8)(n(4),n(9),null,null);e.exports=r.exports},function(e,t){e.exports=function(e,t,n,r){var a,o=e=e||{},i=typeof e.default;"object"!==i&&"function"!==i||(a=e,o=e.default);var u="function"==typeof o?o.options:o;if(t&&(u.render=t.render,u.staticRenderFns=t.staticRenderFns),n&&(u._scopeId=n),r){var s=u.computed||(u.computed={});Object.keys(r).forEach(function(e){var t=r[e];s[e]=function(){return t}})}return{esModule:a,exports:o,options:u}}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement;return(e._self._c||t)("input",{directives:[{name:"mask",rawName:"v-mask",value:e.config,expression:"config"}],attrs:{type:"text"},domProps:{value:e.display},on:{input:e.onInput}})},staticRenderFns:[]}},function(e,t,n){e.exports=n(3)}])});

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
	 * Vue.js v2.6.10
	 * (c) 2014-2019 Evan You
	 * Released under the MIT License.
	 */
	"use strict";var e=Object.freeze({});function t(e){return null==e}function n(e){return null!=e}function r(e){return!0===e}function i(e){return"string"==typeof e||"number"==typeof e||"symbol"==typeof e||"boolean"==typeof e}function o(e){return null!==e&&"object"==typeof e}var a=Object.prototype.toString;function s(e){return"[object Object]"===a.call(e)}function c(e){var t=parseFloat(String(e));return t>=0&&Math.floor(t)===t&&isFinite(e)}function u(e){return n(e)&&"function"==typeof e.then&&"function"==typeof e.catch}function l(e){return null==e?"":Array.isArray(e)||s(e)&&e.toString===a?JSON.stringify(e,null,2):String(e)}function f(e){var t=parseFloat(e);return isNaN(t)?e:t}function p(e,t){for(var n=Object.create(null),r=e.split(","),i=0;i<r.length;i++)n[r[i]]=!0;return t?function(e){return n[e.toLowerCase()]}:function(e){return n[e]}}var d=p("slot,component",!0),v=p("key,ref,slot,slot-scope,is");function h(e,t){if(e.length){var n=e.indexOf(t);if(n>-1)return e.splice(n,1)}}var m=Object.prototype.hasOwnProperty;function y(e,t){return m.call(e,t)}function g(e){var t=Object.create(null);return function(n){return t[n]||(t[n]=e(n))}}var _=/-(\w)/g,b=g(function(e){return e.replace(_,function(e,t){return t?t.toUpperCase():""})}),$=g(function(e){return e.charAt(0).toUpperCase()+e.slice(1)}),w=/\B([A-Z])/g,C=g(function(e){return e.replace(w,"-$1").toLowerCase()});var x=Function.prototype.bind?function(e,t){return e.bind(t)}:function(e,t){function n(n){var r=arguments.length;return r?r>1?e.apply(t,arguments):e.call(t,n):e.call(t)}return n._length=e.length,n};function k(e,t){t=t||0;for(var n=e.length-t,r=new Array(n);n--;)r[n]=e[n+t];return r}function A(e,t){for(var n in t)e[n]=t[n];return e}function O(e){for(var t={},n=0;n<e.length;n++)e[n]&&A(t,e[n]);return t}function S(e,t,n){}var T=function(e,t,n){return!1},E=function(e){return e};function N(e,t){if(e===t)return!0;var n=o(e),r=o(t);if(!n||!r)return!n&&!r&&String(e)===String(t);try{var i=Array.isArray(e),a=Array.isArray(t);if(i&&a)return e.length===t.length&&e.every(function(e,n){return N(e,t[n])});if(e instanceof Date&&t instanceof Date)return e.getTime()===t.getTime();if(i||a)return!1;var s=Object.keys(e),c=Object.keys(t);return s.length===c.length&&s.every(function(n){return N(e[n],t[n])})}catch(e){return!1}}function j(e,t){for(var n=0;n<e.length;n++)if(N(e[n],t))return n;return-1}function D(e){var t=!1;return function(){t||(t=!0,e.apply(this,arguments))}}var L="data-server-rendered",M=["component","directive","filter"],I=["beforeCreate","created","beforeMount","mounted","beforeUpdate","updated","beforeDestroy","destroyed","activated","deactivated","errorCaptured","serverPrefetch"],F={optionMergeStrategies:Object.create(null),silent:!1,productionTip:!1,devtools:!1,performance:!1,errorHandler:null,warnHandler:null,ignoredElements:[],keyCodes:Object.create(null),isReservedTag:T,isReservedAttr:T,isUnknownElement:T,getTagNamespace:S,parsePlatformTagName:E,mustUseProp:T,async:!0,_lifecycleHooks:I},P=/a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;function R(e,t,n,r){Object.defineProperty(e,t,{value:n,enumerable:!!r,writable:!0,configurable:!0})}var H=new RegExp("[^"+P.source+".$_\\d]");var B,U="__proto__"in{},z="undefined"!=typeof window,V="undefined"!=typeof WXEnvironment&&!!WXEnvironment.platform,K=V&&WXEnvironment.platform.toLowerCase(),J=z&&window.navigator.userAgent.toLowerCase(),q=J&&/msie|trident/.test(J),W=J&&J.indexOf("msie 9.0")>0,Z=J&&J.indexOf("edge/")>0,G=(J&&J.indexOf("android"),J&&/iphone|ipad|ipod|ios/.test(J)||"ios"===K),X=(J&&/chrome\/\d+/.test(J),J&&/phantomjs/.test(J),J&&J.match(/firefox\/(\d+)/)),Y={}.watch,Q=!1;if(z)try{var ee={};Object.defineProperty(ee,"passive",{get:function(){Q=!0}}),window.addEventListener("test-passive",null,ee)}catch(e){}var te=function(){return void 0===B&&(B=!z&&!V&&"undefined"!=typeof global&&(global.process&&"server"===global.process.env.VUE_ENV)),B},ne=z&&window.__VUE_DEVTOOLS_GLOBAL_HOOK__;function re(e){return"function"==typeof e&&/native code/.test(e.toString())}var ie,oe="undefined"!=typeof Symbol&&re(Symbol)&&"undefined"!=typeof Reflect&&re(Reflect.ownKeys);ie="undefined"!=typeof Set&&re(Set)?Set:function(){function e(){this.set=Object.create(null)}return e.prototype.has=function(e){return!0===this.set[e]},e.prototype.add=function(e){this.set[e]=!0},e.prototype.clear=function(){this.set=Object.create(null)},e}();var ae=S,se=0,ce=function(){this.id=se++,this.subs=[]};ce.prototype.addSub=function(e){this.subs.push(e)},ce.prototype.removeSub=function(e){h(this.subs,e)},ce.prototype.depend=function(){ce.target&&ce.target.addDep(this)},ce.prototype.notify=function(){for(var e=this.subs.slice(),t=0,n=e.length;t<n;t++)e[t].update()},ce.target=null;var ue=[];function le(e){ue.push(e),ce.target=e}function fe(){ue.pop(),ce.target=ue[ue.length-1]}var pe=function(e,t,n,r,i,o,a,s){this.tag=e,this.data=t,this.children=n,this.text=r,this.elm=i,this.ns=void 0,this.context=o,this.fnContext=void 0,this.fnOptions=void 0,this.fnScopeId=void 0,this.key=t&&t.key,this.componentOptions=a,this.componentInstance=void 0,this.parent=void 0,this.raw=!1,this.isStatic=!1,this.isRootInsert=!0,this.isComment=!1,this.isCloned=!1,this.isOnce=!1,this.asyncFactory=s,this.asyncMeta=void 0,this.isAsyncPlaceholder=!1},de={child:{configurable:!0}};de.child.get=function(){return this.componentInstance},Object.defineProperties(pe.prototype,de);var ve=function(e){void 0===e&&(e="");var t=new pe;return t.text=e,t.isComment=!0,t};function he(e){return new pe(void 0,void 0,void 0,String(e))}function me(e){var t=new pe(e.tag,e.data,e.children&&e.children.slice(),e.text,e.elm,e.context,e.componentOptions,e.asyncFactory);return t.ns=e.ns,t.isStatic=e.isStatic,t.key=e.key,t.isComment=e.isComment,t.fnContext=e.fnContext,t.fnOptions=e.fnOptions,t.fnScopeId=e.fnScopeId,t.asyncMeta=e.asyncMeta,t.isCloned=!0,t}var ye=Array.prototype,ge=Object.create(ye);["push","pop","shift","unshift","splice","sort","reverse"].forEach(function(e){var t=ye[e];R(ge,e,function(){for(var n=[],r=arguments.length;r--;)n[r]=arguments[r];var i,o=t.apply(this,n),a=this.__ob__;switch(e){case"push":case"unshift":i=n;break;case"splice":i=n.slice(2)}return i&&a.observeArray(i),a.dep.notify(),o})});var _e=Object.getOwnPropertyNames(ge),be=!0;function $e(e){be=e}var we=function(e){var t;this.value=e,this.dep=new ce,this.vmCount=0,R(e,"__ob__",this),Array.isArray(e)?(U?(t=ge,e.__proto__=t):function(e,t,n){for(var r=0,i=n.length;r<i;r++){var o=n[r];R(e,o,t[o])}}(e,ge,_e),this.observeArray(e)):this.walk(e)};function Ce(e,t){var n;if(o(e)&&!(e instanceof pe))return y(e,"__ob__")&&e.__ob__ instanceof we?n=e.__ob__:be&&!te()&&(Array.isArray(e)||s(e))&&Object.isExtensible(e)&&!e._isVue&&(n=new we(e)),t&&n&&n.vmCount++,n}function xe(e,t,n,r,i){var o=new ce,a=Object.getOwnPropertyDescriptor(e,t);if(!a||!1!==a.configurable){var s=a&&a.get,c=a&&a.set;s&&!c||2!==arguments.length||(n=e[t]);var u=!i&&Ce(n);Object.defineProperty(e,t,{enumerable:!0,configurable:!0,get:function(){var t=s?s.call(e):n;return ce.target&&(o.depend(),u&&(u.dep.depend(),Array.isArray(t)&&function e(t){for(var n=void 0,r=0,i=t.length;r<i;r++)(n=t[r])&&n.__ob__&&n.__ob__.dep.depend(),Array.isArray(n)&&e(n)}(t))),t},set:function(t){var r=s?s.call(e):n;t===r||t!=t&&r!=r||s&&!c||(c?c.call(e,t):n=t,u=!i&&Ce(t),o.notify())}})}}function ke(e,t,n){if(Array.isArray(e)&&c(t))return e.length=Math.max(e.length,t),e.splice(t,1,n),n;if(t in e&&!(t in Object.prototype))return e[t]=n,n;var r=e.__ob__;return e._isVue||r&&r.vmCount?n:r?(xe(r.value,t,n),r.dep.notify(),n):(e[t]=n,n)}function Ae(e,t){if(Array.isArray(e)&&c(t))e.splice(t,1);else{var n=e.__ob__;e._isVue||n&&n.vmCount||y(e,t)&&(delete e[t],n&&n.dep.notify())}}we.prototype.walk=function(e){for(var t=Object.keys(e),n=0;n<t.length;n++)xe(e,t[n])},we.prototype.observeArray=function(e){for(var t=0,n=e.length;t<n;t++)Ce(e[t])};var Oe=F.optionMergeStrategies;function Se(e,t){if(!t)return e;for(var n,r,i,o=oe?Reflect.ownKeys(t):Object.keys(t),a=0;a<o.length;a++)"__ob__"!==(n=o[a])&&(r=e[n],i=t[n],y(e,n)?r!==i&&s(r)&&s(i)&&Se(r,i):ke(e,n,i));return e}function Te(e,t,n){return n?function(){var r="function"==typeof t?t.call(n,n):t,i="function"==typeof e?e.call(n,n):e;return r?Se(r,i):i}:t?e?function(){return Se("function"==typeof t?t.call(this,this):t,"function"==typeof e?e.call(this,this):e)}:t:e}function Ee(e,t){var n=t?e?e.concat(t):Array.isArray(t)?t:[t]:e;return n?function(e){for(var t=[],n=0;n<e.length;n++)-1===t.indexOf(e[n])&&t.push(e[n]);return t}(n):n}function Ne(e,t,n,r){var i=Object.create(e||null);return t?A(i,t):i}Oe.data=function(e,t,n){return n?Te(e,t,n):t&&"function"!=typeof t?e:Te(e,t)},I.forEach(function(e){Oe[e]=Ee}),M.forEach(function(e){Oe[e+"s"]=Ne}),Oe.watch=function(e,t,n,r){if(e===Y&&(e=void 0),t===Y&&(t=void 0),!t)return Object.create(e||null);if(!e)return t;var i={};for(var o in A(i,e),t){var a=i[o],s=t[o];a&&!Array.isArray(a)&&(a=[a]),i[o]=a?a.concat(s):Array.isArray(s)?s:[s]}return i},Oe.props=Oe.methods=Oe.inject=Oe.computed=function(e,t,n,r){if(!e)return t;var i=Object.create(null);return A(i,e),t&&A(i,t),i},Oe.provide=Te;var je=function(e,t){return void 0===t?e:t};function De(e,t,n){if("function"==typeof t&&(t=t.options),function(e,t){var n=e.props;if(n){var r,i,o={};if(Array.isArray(n))for(r=n.length;r--;)"string"==typeof(i=n[r])&&(o[b(i)]={type:null});else if(s(n))for(var a in n)i=n[a],o[b(a)]=s(i)?i:{type:i};e.props=o}}(t),function(e,t){var n=e.inject;if(n){var r=e.inject={};if(Array.isArray(n))for(var i=0;i<n.length;i++)r[n[i]]={from:n[i]};else if(s(n))for(var o in n){var a=n[o];r[o]=s(a)?A({from:o},a):{from:a}}}}(t),function(e){var t=e.directives;if(t)for(var n in t){var r=t[n];"function"==typeof r&&(t[n]={bind:r,update:r})}}(t),!t._base&&(t.extends&&(e=De(e,t.extends,n)),t.mixins))for(var r=0,i=t.mixins.length;r<i;r++)e=De(e,t.mixins[r],n);var o,a={};for(o in e)c(o);for(o in t)y(e,o)||c(o);function c(r){var i=Oe[r]||je;a[r]=i(e[r],t[r],n,r)}return a}function Le(e,t,n,r){if("string"==typeof n){var i=e[t];if(y(i,n))return i[n];var o=b(n);if(y(i,o))return i[o];var a=$(o);return y(i,a)?i[a]:i[n]||i[o]||i[a]}}function Me(e,t,n,r){var i=t[e],o=!y(n,e),a=n[e],s=Pe(Boolean,i.type);if(s>-1)if(o&&!y(i,"default"))a=!1;else if(""===a||a===C(e)){var c=Pe(String,i.type);(c<0||s<c)&&(a=!0)}if(void 0===a){a=function(e,t,n){if(!y(t,"default"))return;var r=t.default;if(e&&e.$options.propsData&&void 0===e.$options.propsData[n]&&void 0!==e._props[n])return e._props[n];return"function"==typeof r&&"Function"!==Ie(t.type)?r.call(e):r}(r,i,e);var u=be;$e(!0),Ce(a),$e(u)}return a}function Ie(e){var t=e&&e.toString().match(/^\s*function (\w+)/);return t?t[1]:""}function Fe(e,t){return Ie(e)===Ie(t)}function Pe(e,t){if(!Array.isArray(t))return Fe(t,e)?0:-1;for(var n=0,r=t.length;n<r;n++)if(Fe(t[n],e))return n;return-1}function Re(e,t,n){le();try{if(t)for(var r=t;r=r.$parent;){var i=r.$options.errorCaptured;if(i)for(var o=0;o<i.length;o++)try{if(!1===i[o].call(r,e,t,n))return}catch(e){Be(e,r,"errorCaptured hook")}}Be(e,t,n)}finally{fe()}}function He(e,t,n,r,i){var o;try{(o=n?e.apply(t,n):e.call(t))&&!o._isVue&&u(o)&&!o._handled&&(o.catch(function(e){return Re(e,r,i+" (Promise/async)")}),o._handled=!0)}catch(e){Re(e,r,i)}return o}function Be(e,t,n){if(F.errorHandler)try{return F.errorHandler.call(null,e,t,n)}catch(t){t!==e&&Ue(t,null,"config.errorHandler")}Ue(e,t,n)}function Ue(e,t,n){if(!z&&!V||"undefined"==typeof console)throw e;console.error(e)}var ze,Ve=!1,Ke=[],Je=!1;function qe(){Je=!1;var e=Ke.slice(0);Ke.length=0;for(var t=0;t<e.length;t++)e[t]()}if("undefined"!=typeof Promise&&re(Promise)){var We=Promise.resolve();ze=function(){We.then(qe),G&&setTimeout(S)},Ve=!0}else if(q||"undefined"==typeof MutationObserver||!re(MutationObserver)&&"[object MutationObserverConstructor]"!==MutationObserver.toString())ze="undefined"!=typeof setImmediate&&re(setImmediate)?function(){setImmediate(qe)}:function(){setTimeout(qe,0)};else{var Ze=1,Ge=new MutationObserver(qe),Xe=document.createTextNode(String(Ze));Ge.observe(Xe,{characterData:!0}),ze=function(){Ze=(Ze+1)%2,Xe.data=String(Ze)},Ve=!0}function Ye(e,t){var n;if(Ke.push(function(){if(e)try{e.call(t)}catch(e){Re(e,t,"nextTick")}else n&&n(t)}),Je||(Je=!0,ze()),!e&&"undefined"!=typeof Promise)return new Promise(function(e){n=e})}var Qe=new ie;function et(e){!function e(t,n){var r,i;var a=Array.isArray(t);if(!a&&!o(t)||Object.isFrozen(t)||t instanceof pe)return;if(t.__ob__){var s=t.__ob__.dep.id;if(n.has(s))return;n.add(s)}if(a)for(r=t.length;r--;)e(t[r],n);else for(i=Object.keys(t),r=i.length;r--;)e(t[i[r]],n)}(e,Qe),Qe.clear()}var tt=g(function(e){var t="&"===e.charAt(0),n="~"===(e=t?e.slice(1):e).charAt(0),r="!"===(e=n?e.slice(1):e).charAt(0);return{name:e=r?e.slice(1):e,once:n,capture:r,passive:t}});function nt(e,t){function n(){var e=arguments,r=n.fns;if(!Array.isArray(r))return He(r,null,arguments,t,"v-on handler");for(var i=r.slice(),o=0;o<i.length;o++)He(i[o],null,e,t,"v-on handler")}return n.fns=e,n}function rt(e,n,i,o,a,s){var c,u,l,f;for(c in e)u=e[c],l=n[c],f=tt(c),t(u)||(t(l)?(t(u.fns)&&(u=e[c]=nt(u,s)),r(f.once)&&(u=e[c]=a(f.name,u,f.capture)),i(f.name,u,f.capture,f.passive,f.params)):u!==l&&(l.fns=u,e[c]=l));for(c in n)t(e[c])&&o((f=tt(c)).name,n[c],f.capture)}function it(e,i,o){var a;e instanceof pe&&(e=e.data.hook||(e.data.hook={}));var s=e[i];function c(){o.apply(this,arguments),h(a.fns,c)}t(s)?a=nt([c]):n(s.fns)&&r(s.merged)?(a=s).fns.push(c):a=nt([s,c]),a.merged=!0,e[i]=a}function ot(e,t,r,i,o){if(n(t)){if(y(t,r))return e[r]=t[r],o||delete t[r],!0;if(y(t,i))return e[r]=t[i],o||delete t[i],!0}return!1}function at(e){return i(e)?[he(e)]:Array.isArray(e)?function e(o,a){var s=[];var c,u,l,f;for(c=0;c<o.length;c++)t(u=o[c])||"boolean"==typeof u||(l=s.length-1,f=s[l],Array.isArray(u)?u.length>0&&(st((u=e(u,(a||"")+"_"+c))[0])&&st(f)&&(s[l]=he(f.text+u[0].text),u.shift()),s.push.apply(s,u)):i(u)?st(f)?s[l]=he(f.text+u):""!==u&&s.push(he(u)):st(u)&&st(f)?s[l]=he(f.text+u.text):(r(o._isVList)&&n(u.tag)&&t(u.key)&&n(a)&&(u.key="__vlist"+a+"_"+c+"__"),s.push(u)));return s}(e):void 0}function st(e){return n(e)&&n(e.text)&&!1===e.isComment}function ct(e,t){if(e){for(var n=Object.create(null),r=oe?Reflect.ownKeys(e):Object.keys(e),i=0;i<r.length;i++){var o=r[i];if("__ob__"!==o){for(var a=e[o].from,s=t;s;){if(s._provided&&y(s._provided,a)){n[o]=s._provided[a];break}s=s.$parent}if(!s&&"default"in e[o]){var c=e[o].default;n[o]="function"==typeof c?c.call(t):c}}}return n}}function ut(e,t){if(!e||!e.length)return{};for(var n={},r=0,i=e.length;r<i;r++){var o=e[r],a=o.data;if(a&&a.attrs&&a.attrs.slot&&delete a.attrs.slot,o.context!==t&&o.fnContext!==t||!a||null==a.slot)(n.default||(n.default=[])).push(o);else{var s=a.slot,c=n[s]||(n[s]=[]);"template"===o.tag?c.push.apply(c,o.children||[]):c.push(o)}}for(var u in n)n[u].every(lt)&&delete n[u];return n}function lt(e){return e.isComment&&!e.asyncFactory||" "===e.text}function ft(t,n,r){var i,o=Object.keys(n).length>0,a=t?!!t.$stable:!o,s=t&&t.$key;if(t){if(t._normalized)return t._normalized;if(a&&r&&r!==e&&s===r.$key&&!o&&!r.$hasNormal)return r;for(var c in i={},t)t[c]&&"$"!==c[0]&&(i[c]=pt(n,c,t[c]))}else i={};for(var u in n)u in i||(i[u]=dt(n,u));return t&&Object.isExtensible(t)&&(t._normalized=i),R(i,"$stable",a),R(i,"$key",s),R(i,"$hasNormal",o),i}function pt(e,t,n){var r=function(){var e=arguments.length?n.apply(null,arguments):n({});return(e=e&&"object"==typeof e&&!Array.isArray(e)?[e]:at(e))&&(0===e.length||1===e.length&&e[0].isComment)?void 0:e};return n.proxy&&Object.defineProperty(e,t,{get:r,enumerable:!0,configurable:!0}),r}function dt(e,t){return function(){return e[t]}}function vt(e,t){var r,i,a,s,c;if(Array.isArray(e)||"string"==typeof e)for(r=new Array(e.length),i=0,a=e.length;i<a;i++)r[i]=t(e[i],i);else if("number"==typeof e)for(r=new Array(e),i=0;i<e;i++)r[i]=t(i+1,i);else if(o(e))if(oe&&e[Symbol.iterator]){r=[];for(var u=e[Symbol.iterator](),l=u.next();!l.done;)r.push(t(l.value,r.length)),l=u.next()}else for(s=Object.keys(e),r=new Array(s.length),i=0,a=s.length;i<a;i++)c=s[i],r[i]=t(e[c],c,i);return n(r)||(r=[]),r._isVList=!0,r}function ht(e,t,n,r){var i,o=this.$scopedSlots[e];o?(n=n||{},r&&(n=A(A({},r),n)),i=o(n)||t):i=this.$slots[e]||t;var a=n&&n.slot;return a?this.$createElement("template",{slot:a},i):i}function mt(e){return Le(this.$options,"filters",e)||E}function yt(e,t){return Array.isArray(e)?-1===e.indexOf(t):e!==t}function gt(e,t,n,r,i){var o=F.keyCodes[t]||n;return i&&r&&!F.keyCodes[t]?yt(i,r):o?yt(o,e):r?C(r)!==t:void 0}function _t(e,t,n,r,i){if(n)if(o(n)){var a;Array.isArray(n)&&(n=O(n));var s=function(o){if("class"===o||"style"===o||v(o))a=e;else{var s=e.attrs&&e.attrs.type;a=r||F.mustUseProp(t,s,o)?e.domProps||(e.domProps={}):e.attrs||(e.attrs={})}var c=b(o),u=C(o);c in a||u in a||(a[o]=n[o],i&&((e.on||(e.on={}))["update:"+o]=function(e){n[o]=e}))};for(var c in n)s(c)}else;return e}function bt(e,t){var n=this._staticTrees||(this._staticTrees=[]),r=n[e];return r&&!t?r:(wt(r=n[e]=this.$options.staticRenderFns[e].call(this._renderProxy,null,this),"__static__"+e,!1),r)}function $t(e,t,n){return wt(e,"__once__"+t+(n?"_"+n:""),!0),e}function wt(e,t,n){if(Array.isArray(e))for(var r=0;r<e.length;r++)e[r]&&"string"!=typeof e[r]&&Ct(e[r],t+"_"+r,n);else Ct(e,t,n)}function Ct(e,t,n){e.isStatic=!0,e.key=t,e.isOnce=n}function xt(e,t){if(t)if(s(t)){var n=e.on=e.on?A({},e.on):{};for(var r in t){var i=n[r],o=t[r];n[r]=i?[].concat(i,o):o}}else;return e}function kt(e,t,n,r){t=t||{$stable:!n};for(var i=0;i<e.length;i++){var o=e[i];Array.isArray(o)?kt(o,t,n):o&&(o.proxy&&(o.fn.proxy=!0),t[o.key]=o.fn)}return r&&(t.$key=r),t}function At(e,t){for(var n=0;n<t.length;n+=2){var r=t[n];"string"==typeof r&&r&&(e[t[n]]=t[n+1])}return e}function Ot(e,t){return"string"==typeof e?t+e:e}function St(e){e._o=$t,e._n=f,e._s=l,e._l=vt,e._t=ht,e._q=N,e._i=j,e._m=bt,e._f=mt,e._k=gt,e._b=_t,e._v=he,e._e=ve,e._u=kt,e._g=xt,e._d=At,e._p=Ot}function Tt(t,n,i,o,a){var s,c=this,u=a.options;y(o,"_uid")?(s=Object.create(o))._original=o:(s=o,o=o._original);var l=r(u._compiled),f=!l;this.data=t,this.props=n,this.children=i,this.parent=o,this.listeners=t.on||e,this.injections=ct(u.inject,o),this.slots=function(){return c.$slots||ft(t.scopedSlots,c.$slots=ut(i,o)),c.$slots},Object.defineProperty(this,"scopedSlots",{enumerable:!0,get:function(){return ft(t.scopedSlots,this.slots())}}),l&&(this.$options=u,this.$slots=this.slots(),this.$scopedSlots=ft(t.scopedSlots,this.$slots)),u._scopeId?this._c=function(e,t,n,r){var i=Pt(s,e,t,n,r,f);return i&&!Array.isArray(i)&&(i.fnScopeId=u._scopeId,i.fnContext=o),i}:this._c=function(e,t,n,r){return Pt(s,e,t,n,r,f)}}function Et(e,t,n,r,i){var o=me(e);return o.fnContext=n,o.fnOptions=r,t.slot&&((o.data||(o.data={})).slot=t.slot),o}function Nt(e,t){for(var n in t)e[b(n)]=t[n]}St(Tt.prototype);var jt={init:function(e,t){if(e.componentInstance&&!e.componentInstance._isDestroyed&&e.data.keepAlive){var r=e;jt.prepatch(r,r)}else{(e.componentInstance=function(e,t){var r={_isComponent:!0,_parentVnode:e,parent:t},i=e.data.inlineTemplate;n(i)&&(r.render=i.render,r.staticRenderFns=i.staticRenderFns);return new e.componentOptions.Ctor(r)}(e,Wt)).$mount(t?e.elm:void 0,t)}},prepatch:function(t,n){var r=n.componentOptions;!function(t,n,r,i,o){var a=i.data.scopedSlots,s=t.$scopedSlots,c=!!(a&&!a.$stable||s!==e&&!s.$stable||a&&t.$scopedSlots.$key!==a.$key),u=!!(o||t.$options._renderChildren||c);t.$options._parentVnode=i,t.$vnode=i,t._vnode&&(t._vnode.parent=i);if(t.$options._renderChildren=o,t.$attrs=i.data.attrs||e,t.$listeners=r||e,n&&t.$options.props){$e(!1);for(var l=t._props,f=t.$options._propKeys||[],p=0;p<f.length;p++){var d=f[p],v=t.$options.props;l[d]=Me(d,v,n,t)}$e(!0),t.$options.propsData=n}r=r||e;var h=t.$options._parentListeners;t.$options._parentListeners=r,qt(t,r,h),u&&(t.$slots=ut(o,i.context),t.$forceUpdate())}(n.componentInstance=t.componentInstance,r.propsData,r.listeners,n,r.children)},insert:function(e){var t,n=e.context,r=e.componentInstance;r._isMounted||(r._isMounted=!0,Yt(r,"mounted")),e.data.keepAlive&&(n._isMounted?((t=r)._inactive=!1,en.push(t)):Xt(r,!0))},destroy:function(e){var t=e.componentInstance;t._isDestroyed||(e.data.keepAlive?function e(t,n){if(n&&(t._directInactive=!0,Gt(t)))return;if(!t._inactive){t._inactive=!0;for(var r=0;r<t.$children.length;r++)e(t.$children[r]);Yt(t,"deactivated")}}(t,!0):t.$destroy())}},Dt=Object.keys(jt);function Lt(i,a,s,c,l){if(!t(i)){var f=s.$options._base;if(o(i)&&(i=f.extend(i)),"function"==typeof i){var p;if(t(i.cid)&&void 0===(i=function(e,i){if(r(e.error)&&n(e.errorComp))return e.errorComp;if(n(e.resolved))return e.resolved;var a=Ht;a&&n(e.owners)&&-1===e.owners.indexOf(a)&&e.owners.push(a);if(r(e.loading)&&n(e.loadingComp))return e.loadingComp;if(a&&!n(e.owners)){var s=e.owners=[a],c=!0,l=null,f=null;a.$on("hook:destroyed",function(){return h(s,a)});var p=function(e){for(var t=0,n=s.length;t<n;t++)s[t].$forceUpdate();e&&(s.length=0,null!==l&&(clearTimeout(l),l=null),null!==f&&(clearTimeout(f),f=null))},d=D(function(t){e.resolved=Bt(t,i),c?s.length=0:p(!0)}),v=D(function(t){n(e.errorComp)&&(e.error=!0,p(!0))}),m=e(d,v);return o(m)&&(u(m)?t(e.resolved)&&m.then(d,v):u(m.component)&&(m.component.then(d,v),n(m.error)&&(e.errorComp=Bt(m.error,i)),n(m.loading)&&(e.loadingComp=Bt(m.loading,i),0===m.delay?e.loading=!0:l=setTimeout(function(){l=null,t(e.resolved)&&t(e.error)&&(e.loading=!0,p(!1))},m.delay||200)),n(m.timeout)&&(f=setTimeout(function(){f=null,t(e.resolved)&&v(null)},m.timeout)))),c=!1,e.loading?e.loadingComp:e.resolved}}(p=i,f)))return function(e,t,n,r,i){var o=ve();return o.asyncFactory=e,o.asyncMeta={data:t,context:n,children:r,tag:i},o}(p,a,s,c,l);a=a||{},$n(i),n(a.model)&&function(e,t){var r=e.model&&e.model.prop||"value",i=e.model&&e.model.event||"input";(t.attrs||(t.attrs={}))[r]=t.model.value;var o=t.on||(t.on={}),a=o[i],s=t.model.callback;n(a)?(Array.isArray(a)?-1===a.indexOf(s):a!==s)&&(o[i]=[s].concat(a)):o[i]=s}(i.options,a);var d=function(e,r,i){var o=r.options.props;if(!t(o)){var a={},s=e.attrs,c=e.props;if(n(s)||n(c))for(var u in o){var l=C(u);ot(a,c,u,l,!0)||ot(a,s,u,l,!1)}return a}}(a,i);if(r(i.options.functional))return function(t,r,i,o,a){var s=t.options,c={},u=s.props;if(n(u))for(var l in u)c[l]=Me(l,u,r||e);else n(i.attrs)&&Nt(c,i.attrs),n(i.props)&&Nt(c,i.props);var f=new Tt(i,c,a,o,t),p=s.render.call(null,f._c,f);if(p instanceof pe)return Et(p,i,f.parent,s);if(Array.isArray(p)){for(var d=at(p)||[],v=new Array(d.length),h=0;h<d.length;h++)v[h]=Et(d[h],i,f.parent,s);return v}}(i,d,a,s,c);var v=a.on;if(a.on=a.nativeOn,r(i.options.abstract)){var m=a.slot;a={},m&&(a.slot=m)}!function(e){for(var t=e.hook||(e.hook={}),n=0;n<Dt.length;n++){var r=Dt[n],i=t[r],o=jt[r];i===o||i&&i._merged||(t[r]=i?Mt(o,i):o)}}(a);var y=i.options.name||l;return new pe("vue-component-"+i.cid+(y?"-"+y:""),a,void 0,void 0,void 0,s,{Ctor:i,propsData:d,listeners:v,tag:l,children:c},p)}}}function Mt(e,t){var n=function(n,r){e(n,r),t(n,r)};return n._merged=!0,n}var It=1,Ft=2;function Pt(e,a,s,c,u,l){return(Array.isArray(s)||i(s))&&(u=c,c=s,s=void 0),r(l)&&(u=Ft),function(e,i,a,s,c){if(n(a)&&n(a.__ob__))return ve();n(a)&&n(a.is)&&(i=a.is);if(!i)return ve();Array.isArray(s)&&"function"==typeof s[0]&&((a=a||{}).scopedSlots={default:s[0]},s.length=0);c===Ft?s=at(s):c===It&&(s=function(e){for(var t=0;t<e.length;t++)if(Array.isArray(e[t]))return Array.prototype.concat.apply([],e);return e}(s));var u,l;if("string"==typeof i){var f;l=e.$vnode&&e.$vnode.ns||F.getTagNamespace(i),u=F.isReservedTag(i)?new pe(F.parsePlatformTagName(i),a,s,void 0,void 0,e):a&&a.pre||!n(f=Le(e.$options,"components",i))?new pe(i,a,s,void 0,void 0,e):Lt(f,a,e,s,i)}else u=Lt(i,a,e,s);return Array.isArray(u)?u:n(u)?(n(l)&&function e(i,o,a){i.ns=o;"foreignObject"===i.tag&&(o=void 0,a=!0);if(n(i.children))for(var s=0,c=i.children.length;s<c;s++){var u=i.children[s];n(u.tag)&&(t(u.ns)||r(a)&&"svg"!==u.tag)&&e(u,o,a)}}(u,l),n(a)&&function(e){o(e.style)&&et(e.style);o(e.class)&&et(e.class)}(a),u):ve()}(e,a,s,c,u)}var Rt,Ht=null;function Bt(e,t){return(e.__esModule||oe&&"Module"===e[Symbol.toStringTag])&&(e=e.default),o(e)?t.extend(e):e}function Ut(e){return e.isComment&&e.asyncFactory}function zt(e){if(Array.isArray(e))for(var t=0;t<e.length;t++){var r=e[t];if(n(r)&&(n(r.componentOptions)||Ut(r)))return r}}function Vt(e,t){Rt.$on(e,t)}function Kt(e,t){Rt.$off(e,t)}function Jt(e,t){var n=Rt;return function r(){null!==t.apply(null,arguments)&&n.$off(e,r)}}function qt(e,t,n){Rt=e,rt(t,n||{},Vt,Kt,Jt,e),Rt=void 0}var Wt=null;function Zt(e){var t=Wt;return Wt=e,function(){Wt=t}}function Gt(e){for(;e&&(e=e.$parent);)if(e._inactive)return!0;return!1}function Xt(e,t){if(t){if(e._directInactive=!1,Gt(e))return}else if(e._directInactive)return;if(e._inactive||null===e._inactive){e._inactive=!1;for(var n=0;n<e.$children.length;n++)Xt(e.$children[n]);Yt(e,"activated")}}function Yt(e,t){le();var n=e.$options[t],r=t+" hook";if(n)for(var i=0,o=n.length;i<o;i++)He(n[i],e,null,e,r);e._hasHookEvent&&e.$emit("hook:"+t),fe()}var Qt=[],en=[],tn={},nn=!1,rn=!1,on=0;var an=0,sn=Date.now;if(z&&!q){var cn=window.performance;cn&&"function"==typeof cn.now&&sn()>document.createEvent("Event").timeStamp&&(sn=function(){return cn.now()})}function un(){var e,t;for(an=sn(),rn=!0,Qt.sort(function(e,t){return e.id-t.id}),on=0;on<Qt.length;on++)(e=Qt[on]).before&&e.before(),t=e.id,tn[t]=null,e.run();var n=en.slice(),r=Qt.slice();on=Qt.length=en.length=0,tn={},nn=rn=!1,function(e){for(var t=0;t<e.length;t++)e[t]._inactive=!0,Xt(e[t],!0)}(n),function(e){var t=e.length;for(;t--;){var n=e[t],r=n.vm;r._watcher===n&&r._isMounted&&!r._isDestroyed&&Yt(r,"updated")}}(r),ne&&F.devtools&&ne.emit("flush")}var ln=0,fn=function(e,t,n,r,i){this.vm=e,i&&(e._watcher=this),e._watchers.push(this),r?(this.deep=!!r.deep,this.user=!!r.user,this.lazy=!!r.lazy,this.sync=!!r.sync,this.before=r.before):this.deep=this.user=this.lazy=this.sync=!1,this.cb=n,this.id=++ln,this.active=!0,this.dirty=this.lazy,this.deps=[],this.newDeps=[],this.depIds=new ie,this.newDepIds=new ie,this.expression="","function"==typeof t?this.getter=t:(this.getter=function(e){if(!H.test(e)){var t=e.split(".");return function(e){for(var n=0;n<t.length;n++){if(!e)return;e=e[t[n]]}return e}}}(t),this.getter||(this.getter=S)),this.value=this.lazy?void 0:this.get()};fn.prototype.get=function(){var e;le(this);var t=this.vm;try{e=this.getter.call(t,t)}catch(e){if(!this.user)throw e;Re(e,t,'getter for watcher "'+this.expression+'"')}finally{this.deep&&et(e),fe(),this.cleanupDeps()}return e},fn.prototype.addDep=function(e){var t=e.id;this.newDepIds.has(t)||(this.newDepIds.add(t),this.newDeps.push(e),this.depIds.has(t)||e.addSub(this))},fn.prototype.cleanupDeps=function(){for(var e=this.deps.length;e--;){var t=this.deps[e];this.newDepIds.has(t.id)||t.removeSub(this)}var n=this.depIds;this.depIds=this.newDepIds,this.newDepIds=n,this.newDepIds.clear(),n=this.deps,this.deps=this.newDeps,this.newDeps=n,this.newDeps.length=0},fn.prototype.update=function(){this.lazy?this.dirty=!0:this.sync?this.run():function(e){var t=e.id;if(null==tn[t]){if(tn[t]=!0,rn){for(var n=Qt.length-1;n>on&&Qt[n].id>e.id;)n--;Qt.splice(n+1,0,e)}else Qt.push(e);nn||(nn=!0,Ye(un))}}(this)},fn.prototype.run=function(){if(this.active){var e=this.get();if(e!==this.value||o(e)||this.deep){var t=this.value;if(this.value=e,this.user)try{this.cb.call(this.vm,e,t)}catch(e){Re(e,this.vm,'callback for watcher "'+this.expression+'"')}else this.cb.call(this.vm,e,t)}}},fn.prototype.evaluate=function(){this.value=this.get(),this.dirty=!1},fn.prototype.depend=function(){for(var e=this.deps.length;e--;)this.deps[e].depend()},fn.prototype.teardown=function(){if(this.active){this.vm._isBeingDestroyed||h(this.vm._watchers,this);for(var e=this.deps.length;e--;)this.deps[e].removeSub(this);this.active=!1}};var pn={enumerable:!0,configurable:!0,get:S,set:S};function dn(e,t,n){pn.get=function(){return this[t][n]},pn.set=function(e){this[t][n]=e},Object.defineProperty(e,n,pn)}function vn(e){e._watchers=[];var t=e.$options;t.props&&function(e,t){var n=e.$options.propsData||{},r=e._props={},i=e.$options._propKeys=[];e.$parent&&$e(!1);var o=function(o){i.push(o);var a=Me(o,t,n,e);xe(r,o,a),o in e||dn(e,"_props",o)};for(var a in t)o(a);$e(!0)}(e,t.props),t.methods&&function(e,t){e.$options.props;for(var n in t)e[n]="function"!=typeof t[n]?S:x(t[n],e)}(e,t.methods),t.data?function(e){var t=e.$options.data;s(t=e._data="function"==typeof t?function(e,t){le();try{return e.call(t,t)}catch(e){return Re(e,t,"data()"),{}}finally{fe()}}(t,e):t||{})||(t={});var n=Object.keys(t),r=e.$options.props,i=(e.$options.methods,n.length);for(;i--;){var o=n[i];r&&y(r,o)||(a=void 0,36!==(a=(o+"").charCodeAt(0))&&95!==a&&dn(e,"_data",o))}var a;Ce(t,!0)}(e):Ce(e._data={},!0),t.computed&&function(e,t){var n=e._computedWatchers=Object.create(null),r=te();for(var i in t){var o=t[i],a="function"==typeof o?o:o.get;r||(n[i]=new fn(e,a||S,S,hn)),i in e||mn(e,i,o)}}(e,t.computed),t.watch&&t.watch!==Y&&function(e,t){for(var n in t){var r=t[n];if(Array.isArray(r))for(var i=0;i<r.length;i++)_n(e,n,r[i]);else _n(e,n,r)}}(e,t.watch)}var hn={lazy:!0};function mn(e,t,n){var r=!te();"function"==typeof n?(pn.get=r?yn(t):gn(n),pn.set=S):(pn.get=n.get?r&&!1!==n.cache?yn(t):gn(n.get):S,pn.set=n.set||S),Object.defineProperty(e,t,pn)}function yn(e){return function(){var t=this._computedWatchers&&this._computedWatchers[e];if(t)return t.dirty&&t.evaluate(),ce.target&&t.depend(),t.value}}function gn(e){return function(){return e.call(this,this)}}function _n(e,t,n,r){return s(n)&&(r=n,n=n.handler),"string"==typeof n&&(n=e[n]),e.$watch(t,n,r)}var bn=0;function $n(e){var t=e.options;if(e.super){var n=$n(e.super);if(n!==e.superOptions){e.superOptions=n;var r=function(e){var t,n=e.options,r=e.sealedOptions;for(var i in n)n[i]!==r[i]&&(t||(t={}),t[i]=n[i]);return t}(e);r&&A(e.extendOptions,r),(t=e.options=De(n,e.extendOptions)).name&&(t.components[t.name]=e)}}return t}function wn(e){this._init(e)}function Cn(e){e.cid=0;var t=1;e.extend=function(e){e=e||{};var n=this,r=n.cid,i=e._Ctor||(e._Ctor={});if(i[r])return i[r];var o=e.name||n.options.name,a=function(e){this._init(e)};return(a.prototype=Object.create(n.prototype)).constructor=a,a.cid=t++,a.options=De(n.options,e),a.super=n,a.options.props&&function(e){var t=e.options.props;for(var n in t)dn(e.prototype,"_props",n)}(a),a.options.computed&&function(e){var t=e.options.computed;for(var n in t)mn(e.prototype,n,t[n])}(a),a.extend=n.extend,a.mixin=n.mixin,a.use=n.use,M.forEach(function(e){a[e]=n[e]}),o&&(a.options.components[o]=a),a.superOptions=n.options,a.extendOptions=e,a.sealedOptions=A({},a.options),i[r]=a,a}}function xn(e){return e&&(e.Ctor.options.name||e.tag)}function kn(e,t){return Array.isArray(e)?e.indexOf(t)>-1:"string"==typeof e?e.split(",").indexOf(t)>-1:(n=e,"[object RegExp]"===a.call(n)&&e.test(t));var n}function An(e,t){var n=e.cache,r=e.keys,i=e._vnode;for(var o in n){var a=n[o];if(a){var s=xn(a.componentOptions);s&&!t(s)&&On(n,o,r,i)}}}function On(e,t,n,r){var i=e[t];!i||r&&i.tag===r.tag||i.componentInstance.$destroy(),e[t]=null,h(n,t)}!function(t){t.prototype._init=function(t){var n=this;n._uid=bn++,n._isVue=!0,t&&t._isComponent?function(e,t){var n=e.$options=Object.create(e.constructor.options),r=t._parentVnode;n.parent=t.parent,n._parentVnode=r;var i=r.componentOptions;n.propsData=i.propsData,n._parentListeners=i.listeners,n._renderChildren=i.children,n._componentTag=i.tag,t.render&&(n.render=t.render,n.staticRenderFns=t.staticRenderFns)}(n,t):n.$options=De($n(n.constructor),t||{},n),n._renderProxy=n,n._self=n,function(e){var t=e.$options,n=t.parent;if(n&&!t.abstract){for(;n.$options.abstract&&n.$parent;)n=n.$parent;n.$children.push(e)}e.$parent=n,e.$root=n?n.$root:e,e.$children=[],e.$refs={},e._watcher=null,e._inactive=null,e._directInactive=!1,e._isMounted=!1,e._isDestroyed=!1,e._isBeingDestroyed=!1}(n),function(e){e._events=Object.create(null),e._hasHookEvent=!1;var t=e.$options._parentListeners;t&&qt(e,t)}(n),function(t){t._vnode=null,t._staticTrees=null;var n=t.$options,r=t.$vnode=n._parentVnode,i=r&&r.context;t.$slots=ut(n._renderChildren,i),t.$scopedSlots=e,t._c=function(e,n,r,i){return Pt(t,e,n,r,i,!1)},t.$createElement=function(e,n,r,i){return Pt(t,e,n,r,i,!0)};var o=r&&r.data;xe(t,"$attrs",o&&o.attrs||e,null,!0),xe(t,"$listeners",n._parentListeners||e,null,!0)}(n),Yt(n,"beforeCreate"),function(e){var t=ct(e.$options.inject,e);t&&($e(!1),Object.keys(t).forEach(function(n){xe(e,n,t[n])}),$e(!0))}(n),vn(n),function(e){var t=e.$options.provide;t&&(e._provided="function"==typeof t?t.call(e):t)}(n),Yt(n,"created"),n.$options.el&&n.$mount(n.$options.el)}}(wn),function(e){var t={get:function(){return this._data}},n={get:function(){return this._props}};Object.defineProperty(e.prototype,"$data",t),Object.defineProperty(e.prototype,"$props",n),e.prototype.$set=ke,e.prototype.$delete=Ae,e.prototype.$watch=function(e,t,n){if(s(t))return _n(this,e,t,n);(n=n||{}).user=!0;var r=new fn(this,e,t,n);if(n.immediate)try{t.call(this,r.value)}catch(e){Re(e,this,'callback for immediate watcher "'+r.expression+'"')}return function(){r.teardown()}}}(wn),function(e){var t=/^hook:/;e.prototype.$on=function(e,n){var r=this;if(Array.isArray(e))for(var i=0,o=e.length;i<o;i++)r.$on(e[i],n);else(r._events[e]||(r._events[e]=[])).push(n),t.test(e)&&(r._hasHookEvent=!0);return r},e.prototype.$once=function(e,t){var n=this;function r(){n.$off(e,r),t.apply(n,arguments)}return r.fn=t,n.$on(e,r),n},e.prototype.$off=function(e,t){var n=this;if(!arguments.length)return n._events=Object.create(null),n;if(Array.isArray(e)){for(var r=0,i=e.length;r<i;r++)n.$off(e[r],t);return n}var o,a=n._events[e];if(!a)return n;if(!t)return n._events[e]=null,n;for(var s=a.length;s--;)if((o=a[s])===t||o.fn===t){a.splice(s,1);break}return n},e.prototype.$emit=function(e){var t=this._events[e];if(t){t=t.length>1?k(t):t;for(var n=k(arguments,1),r='event handler for "'+e+'"',i=0,o=t.length;i<o;i++)He(t[i],this,n,this,r)}return this}}(wn),function(e){e.prototype._update=function(e,t){var n=this,r=n.$el,i=n._vnode,o=Zt(n);n._vnode=e,n.$el=i?n.__patch__(i,e):n.__patch__(n.$el,e,t,!1),o(),r&&(r.__vue__=null),n.$el&&(n.$el.__vue__=n),n.$vnode&&n.$parent&&n.$vnode===n.$parent._vnode&&(n.$parent.$el=n.$el)},e.prototype.$forceUpdate=function(){this._watcher&&this._watcher.update()},e.prototype.$destroy=function(){var e=this;if(!e._isBeingDestroyed){Yt(e,"beforeDestroy"),e._isBeingDestroyed=!0;var t=e.$parent;!t||t._isBeingDestroyed||e.$options.abstract||h(t.$children,e),e._watcher&&e._watcher.teardown();for(var n=e._watchers.length;n--;)e._watchers[n].teardown();e._data.__ob__&&e._data.__ob__.vmCount--,e._isDestroyed=!0,e.__patch__(e._vnode,null),Yt(e,"destroyed"),e.$off(),e.$el&&(e.$el.__vue__=null),e.$vnode&&(e.$vnode.parent=null)}}}(wn),function(e){St(e.prototype),e.prototype.$nextTick=function(e){return Ye(e,this)},e.prototype._render=function(){var e,t=this,n=t.$options,r=n.render,i=n._parentVnode;i&&(t.$scopedSlots=ft(i.data.scopedSlots,t.$slots,t.$scopedSlots)),t.$vnode=i;try{Ht=t,e=r.call(t._renderProxy,t.$createElement)}catch(n){Re(n,t,"render"),e=t._vnode}finally{Ht=null}return Array.isArray(e)&&1===e.length&&(e=e[0]),e instanceof pe||(e=ve()),e.parent=i,e}}(wn);var Sn=[String,RegExp,Array],Tn={KeepAlive:{name:"keep-alive",abstract:!0,props:{include:Sn,exclude:Sn,max:[String,Number]},created:function(){this.cache=Object.create(null),this.keys=[]},destroyed:function(){for(var e in this.cache)On(this.cache,e,this.keys)},mounted:function(){var e=this;this.$watch("include",function(t){An(e,function(e){return kn(t,e)})}),this.$watch("exclude",function(t){An(e,function(e){return!kn(t,e)})})},render:function(){var e=this.$slots.default,t=zt(e),n=t&&t.componentOptions;if(n){var r=xn(n),i=this.include,o=this.exclude;if(i&&(!r||!kn(i,r))||o&&r&&kn(o,r))return t;var a=this.cache,s=this.keys,c=null==t.key?n.Ctor.cid+(n.tag?"::"+n.tag:""):t.key;a[c]?(t.componentInstance=a[c].componentInstance,h(s,c),s.push(c)):(a[c]=t,s.push(c),this.max&&s.length>parseInt(this.max)&&On(a,s[0],s,this._vnode)),t.data.keepAlive=!0}return t||e&&e[0]}}};!function(e){var t={get:function(){return F}};Object.defineProperty(e,"config",t),e.util={warn:ae,extend:A,mergeOptions:De,defineReactive:xe},e.set=ke,e.delete=Ae,e.nextTick=Ye,e.observable=function(e){return Ce(e),e},e.options=Object.create(null),M.forEach(function(t){e.options[t+"s"]=Object.create(null)}),e.options._base=e,A(e.options.components,Tn),function(e){e.use=function(e){var t=this._installedPlugins||(this._installedPlugins=[]);if(t.indexOf(e)>-1)return this;var n=k(arguments,1);return n.unshift(this),"function"==typeof e.install?e.install.apply(e,n):"function"==typeof e&&e.apply(null,n),t.push(e),this}}(e),function(e){e.mixin=function(e){return this.options=De(this.options,e),this}}(e),Cn(e),function(e){M.forEach(function(t){e[t]=function(e,n){return n?("component"===t&&s(n)&&(n.name=n.name||e,n=this.options._base.extend(n)),"directive"===t&&"function"==typeof n&&(n={bind:n,update:n}),this.options[t+"s"][e]=n,n):this.options[t+"s"][e]}})}(e)}(wn),Object.defineProperty(wn.prototype,"$isServer",{get:te}),Object.defineProperty(wn.prototype,"$ssrContext",{get:function(){return this.$vnode&&this.$vnode.ssrContext}}),Object.defineProperty(wn,"FunctionalRenderContext",{value:Tt}),wn.version="2.6.10";var En=p("style,class"),Nn=p("input,textarea,option,select,progress"),jn=function(e,t,n){return"value"===n&&Nn(e)&&"button"!==t||"selected"===n&&"option"===e||"checked"===n&&"input"===e||"muted"===n&&"video"===e},Dn=p("contenteditable,draggable,spellcheck"),Ln=p("events,caret,typing,plaintext-only"),Mn=function(e,t){return Hn(t)||"false"===t?"false":"contenteditable"===e&&Ln(t)?t:"true"},In=p("allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,default,defaultchecked,defaultmuted,defaultselected,defer,disabled,enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,required,reversed,scoped,seamless,selected,sortable,translate,truespeed,typemustmatch,visible"),Fn="http://www.w3.org/1999/xlink",Pn=function(e){return":"===e.charAt(5)&&"xlink"===e.slice(0,5)},Rn=function(e){return Pn(e)?e.slice(6,e.length):""},Hn=function(e){return null==e||!1===e};function Bn(e){for(var t=e.data,r=e,i=e;n(i.componentInstance);)(i=i.componentInstance._vnode)&&i.data&&(t=Un(i.data,t));for(;n(r=r.parent);)r&&r.data&&(t=Un(t,r.data));return function(e,t){if(n(e)||n(t))return zn(e,Vn(t));return""}(t.staticClass,t.class)}function Un(e,t){return{staticClass:zn(e.staticClass,t.staticClass),class:n(e.class)?[e.class,t.class]:t.class}}function zn(e,t){return e?t?e+" "+t:e:t||""}function Vn(e){return Array.isArray(e)?function(e){for(var t,r="",i=0,o=e.length;i<o;i++)n(t=Vn(e[i]))&&""!==t&&(r&&(r+=" "),r+=t);return r}(e):o(e)?function(e){var t="";for(var n in e)e[n]&&(t&&(t+=" "),t+=n);return t}(e):"string"==typeof e?e:""}var Kn={svg:"http://www.w3.org/2000/svg",math:"http://www.w3.org/1998/Math/MathML"},Jn=p("html,body,base,head,link,meta,style,title,address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,menuitem,summary,content,element,shadow,template,blockquote,iframe,tfoot"),qn=p("svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view",!0),Wn=function(e){return Jn(e)||qn(e)};function Zn(e){return qn(e)?"svg":"math"===e?"math":void 0}var Gn=Object.create(null);var Xn=p("text,number,password,search,email,tel,url");function Yn(e){if("string"==typeof e){var t=document.querySelector(e);return t||document.createElement("div")}return e}var Qn=Object.freeze({createElement:function(e,t){var n=document.createElement(e);return"select"!==e?n:(t.data&&t.data.attrs&&void 0!==t.data.attrs.multiple&&n.setAttribute("multiple","multiple"),n)},createElementNS:function(e,t){return document.createElementNS(Kn[e],t)},createTextNode:function(e){return document.createTextNode(e)},createComment:function(e){return document.createComment(e)},insertBefore:function(e,t,n){e.insertBefore(t,n)},removeChild:function(e,t){e.removeChild(t)},appendChild:function(e,t){e.appendChild(t)},parentNode:function(e){return e.parentNode},nextSibling:function(e){return e.nextSibling},tagName:function(e){return e.tagName},setTextContent:function(e,t){e.textContent=t},setStyleScope:function(e,t){e.setAttribute(t,"")}}),er={create:function(e,t){tr(t)},update:function(e,t){e.data.ref!==t.data.ref&&(tr(e,!0),tr(t))},destroy:function(e){tr(e,!0)}};function tr(e,t){var r=e.data.ref;if(n(r)){var i=e.context,o=e.componentInstance||e.elm,a=i.$refs;t?Array.isArray(a[r])?h(a[r],o):a[r]===o&&(a[r]=void 0):e.data.refInFor?Array.isArray(a[r])?a[r].indexOf(o)<0&&a[r].push(o):a[r]=[o]:a[r]=o}}var nr=new pe("",{},[]),rr=["create","activate","update","remove","destroy"];function ir(e,i){return e.key===i.key&&(e.tag===i.tag&&e.isComment===i.isComment&&n(e.data)===n(i.data)&&function(e,t){if("input"!==e.tag)return!0;var r,i=n(r=e.data)&&n(r=r.attrs)&&r.type,o=n(r=t.data)&&n(r=r.attrs)&&r.type;return i===o||Xn(i)&&Xn(o)}(e,i)||r(e.isAsyncPlaceholder)&&e.asyncFactory===i.asyncFactory&&t(i.asyncFactory.error))}function or(e,t,r){var i,o,a={};for(i=t;i<=r;++i)n(o=e[i].key)&&(a[o]=i);return a}var ar={create:sr,update:sr,destroy:function(e){sr(e,nr)}};function sr(e,t){(e.data.directives||t.data.directives)&&function(e,t){var n,r,i,o=e===nr,a=t===nr,s=ur(e.data.directives,e.context),c=ur(t.data.directives,t.context),u=[],l=[];for(n in c)r=s[n],i=c[n],r?(i.oldValue=r.value,i.oldArg=r.arg,fr(i,"update",t,e),i.def&&i.def.componentUpdated&&l.push(i)):(fr(i,"bind",t,e),i.def&&i.def.inserted&&u.push(i));if(u.length){var f=function(){for(var n=0;n<u.length;n++)fr(u[n],"inserted",t,e)};o?it(t,"insert",f):f()}l.length&&it(t,"postpatch",function(){for(var n=0;n<l.length;n++)fr(l[n],"componentUpdated",t,e)});if(!o)for(n in s)c[n]||fr(s[n],"unbind",e,e,a)}(e,t)}var cr=Object.create(null);function ur(e,t){var n,r,i=Object.create(null);if(!e)return i;for(n=0;n<e.length;n++)(r=e[n]).modifiers||(r.modifiers=cr),i[lr(r)]=r,r.def=Le(t.$options,"directives",r.name);return i}function lr(e){return e.rawName||e.name+"."+Object.keys(e.modifiers||{}).join(".")}function fr(e,t,n,r,i){var o=e.def&&e.def[t];if(o)try{o(n.elm,e,n,r,i)}catch(r){Re(r,n.context,"directive "+e.name+" "+t+" hook")}}var pr=[er,ar];function dr(e,r){var i=r.componentOptions;if(!(n(i)&&!1===i.Ctor.options.inheritAttrs||t(e.data.attrs)&&t(r.data.attrs))){var o,a,s=r.elm,c=e.data.attrs||{},u=r.data.attrs||{};for(o in n(u.__ob__)&&(u=r.data.attrs=A({},u)),u)a=u[o],c[o]!==a&&vr(s,o,a);for(o in(q||Z)&&u.value!==c.value&&vr(s,"value",u.value),c)t(u[o])&&(Pn(o)?s.removeAttributeNS(Fn,Rn(o)):Dn(o)||s.removeAttribute(o))}}function vr(e,t,n){e.tagName.indexOf("-")>-1?hr(e,t,n):In(t)?Hn(n)?e.removeAttribute(t):(n="allowfullscreen"===t&&"EMBED"===e.tagName?"true":t,e.setAttribute(t,n)):Dn(t)?e.setAttribute(t,Mn(t,n)):Pn(t)?Hn(n)?e.removeAttributeNS(Fn,Rn(t)):e.setAttributeNS(Fn,t,n):hr(e,t,n)}function hr(e,t,n){if(Hn(n))e.removeAttribute(t);else{if(q&&!W&&"TEXTAREA"===e.tagName&&"placeholder"===t&&""!==n&&!e.__ieph){var r=function(t){t.stopImmediatePropagation(),e.removeEventListener("input",r)};e.addEventListener("input",r),e.__ieph=!0}e.setAttribute(t,n)}}var mr={create:dr,update:dr};function yr(e,r){var i=r.elm,o=r.data,a=e.data;if(!(t(o.staticClass)&&t(o.class)&&(t(a)||t(a.staticClass)&&t(a.class)))){var s=Bn(r),c=i._transitionClasses;n(c)&&(s=zn(s,Vn(c))),s!==i._prevClass&&(i.setAttribute("class",s),i._prevClass=s)}}var gr,_r,br,$r,wr,Cr,xr={create:yr,update:yr},kr=/[\w).+\-_$\]]/;function Ar(e){var t,n,r,i,o,a=!1,s=!1,c=!1,u=!1,l=0,f=0,p=0,d=0;for(r=0;r<e.length;r++)if(n=t,t=e.charCodeAt(r),a)39===t&&92!==n&&(a=!1);else if(s)34===t&&92!==n&&(s=!1);else if(c)96===t&&92!==n&&(c=!1);else if(u)47===t&&92!==n&&(u=!1);else if(124!==t||124===e.charCodeAt(r+1)||124===e.charCodeAt(r-1)||l||f||p){switch(t){case 34:s=!0;break;case 39:a=!0;break;case 96:c=!0;break;case 40:p++;break;case 41:p--;break;case 91:f++;break;case 93:f--;break;case 123:l++;break;case 125:l--}if(47===t){for(var v=r-1,h=void 0;v>=0&&" "===(h=e.charAt(v));v--);h&&kr.test(h)||(u=!0)}}else void 0===i?(d=r+1,i=e.slice(0,r).trim()):m();function m(){(o||(o=[])).push(e.slice(d,r).trim()),d=r+1}if(void 0===i?i=e.slice(0,r).trim():0!==d&&m(),o)for(r=0;r<o.length;r++)i=Or(i,o[r]);return i}function Or(e,t){var n=t.indexOf("(");if(n<0)return'_f("'+t+'")('+e+")";var r=t.slice(0,n),i=t.slice(n+1);return'_f("'+r+'")('+e+(")"!==i?","+i:i)}function Sr(e,t){console.error("[Vue compiler]: "+e)}function Tr(e,t){return e?e.map(function(e){return e[t]}).filter(function(e){return e}):[]}function Er(e,t,n,r,i){(e.props||(e.props=[])).push(Rr({name:t,value:n,dynamic:i},r)),e.plain=!1}function Nr(e,t,n,r,i){(i?e.dynamicAttrs||(e.dynamicAttrs=[]):e.attrs||(e.attrs=[])).push(Rr({name:t,value:n,dynamic:i},r)),e.plain=!1}function jr(e,t,n,r){e.attrsMap[t]=n,e.attrsList.push(Rr({name:t,value:n},r))}function Dr(e,t,n,r,i,o,a,s){(e.directives||(e.directives=[])).push(Rr({name:t,rawName:n,value:r,arg:i,isDynamicArg:o,modifiers:a},s)),e.plain=!1}function Lr(e,t,n){return n?"_p("+t+',"'+e+'")':e+t}function Mr(t,n,r,i,o,a,s,c){var u;(i=i||e).right?c?n="("+n+")==='click'?'contextmenu':("+n+")":"click"===n&&(n="contextmenu",delete i.right):i.middle&&(c?n="("+n+")==='click'?'mouseup':("+n+")":"click"===n&&(n="mouseup")),i.capture&&(delete i.capture,n=Lr("!",n,c)),i.once&&(delete i.once,n=Lr("~",n,c)),i.passive&&(delete i.passive,n=Lr("&",n,c)),i.native?(delete i.native,u=t.nativeEvents||(t.nativeEvents={})):u=t.events||(t.events={});var l=Rr({value:r.trim(),dynamic:c},s);i!==e&&(l.modifiers=i);var f=u[n];Array.isArray(f)?o?f.unshift(l):f.push(l):u[n]=f?o?[l,f]:[f,l]:l,t.plain=!1}function Ir(e,t,n){var r=Fr(e,":"+t)||Fr(e,"v-bind:"+t);if(null!=r)return Ar(r);if(!1!==n){var i=Fr(e,t);if(null!=i)return JSON.stringify(i)}}function Fr(e,t,n){var r;if(null!=(r=e.attrsMap[t]))for(var i=e.attrsList,o=0,a=i.length;o<a;o++)if(i[o].name===t){i.splice(o,1);break}return n&&delete e.attrsMap[t],r}function Pr(e,t){for(var n=e.attrsList,r=0,i=n.length;r<i;r++){var o=n[r];if(t.test(o.name))return n.splice(r,1),o}}function Rr(e,t){return t&&(null!=t.start&&(e.start=t.start),null!=t.end&&(e.end=t.end)),e}function Hr(e,t,n){var r=n||{},i=r.number,o="$$v";r.trim&&(o="(typeof $$v === 'string'? $$v.trim(): $$v)"),i&&(o="_n("+o+")");var a=Br(t,o);e.model={value:"("+t+")",expression:JSON.stringify(t),callback:"function ($$v) {"+a+"}"}}function Br(e,t){var n=function(e){if(e=e.trim(),gr=e.length,e.indexOf("[")<0||e.lastIndexOf("]")<gr-1)return($r=e.lastIndexOf("."))>-1?{exp:e.slice(0,$r),key:'"'+e.slice($r+1)+'"'}:{exp:e,key:null};_r=e,$r=wr=Cr=0;for(;!zr();)Vr(br=Ur())?Jr(br):91===br&&Kr(br);return{exp:e.slice(0,wr),key:e.slice(wr+1,Cr)}}(e);return null===n.key?e+"="+t:"$set("+n.exp+", "+n.key+", "+t+")"}function Ur(){return _r.charCodeAt(++$r)}function zr(){return $r>=gr}function Vr(e){return 34===e||39===e}function Kr(e){var t=1;for(wr=$r;!zr();)if(Vr(e=Ur()))Jr(e);else if(91===e&&t++,93===e&&t--,0===t){Cr=$r;break}}function Jr(e){for(var t=e;!zr()&&(e=Ur())!==t;);}var qr,Wr="__r",Zr="__c";function Gr(e,t,n){var r=qr;return function i(){null!==t.apply(null,arguments)&&Qr(e,i,n,r)}}var Xr=Ve&&!(X&&Number(X[1])<=53);function Yr(e,t,n,r){if(Xr){var i=an,o=t;t=o._wrapper=function(e){if(e.target===e.currentTarget||e.timeStamp>=i||e.timeStamp<=0||e.target.ownerDocument!==document)return o.apply(this,arguments)}}qr.addEventListener(e,t,Q?{capture:n,passive:r}:n)}function Qr(e,t,n,r){(r||qr).removeEventListener(e,t._wrapper||t,n)}function ei(e,r){if(!t(e.data.on)||!t(r.data.on)){var i=r.data.on||{},o=e.data.on||{};qr=r.elm,function(e){if(n(e[Wr])){var t=q?"change":"input";e[t]=[].concat(e[Wr],e[t]||[]),delete e[Wr]}n(e[Zr])&&(e.change=[].concat(e[Zr],e.change||[]),delete e[Zr])}(i),rt(i,o,Yr,Qr,Gr,r.context),qr=void 0}}var ti,ni={create:ei,update:ei};function ri(e,r){if(!t(e.data.domProps)||!t(r.data.domProps)){var i,o,a=r.elm,s=e.data.domProps||{},c=r.data.domProps||{};for(i in n(c.__ob__)&&(c=r.data.domProps=A({},c)),s)i in c||(a[i]="");for(i in c){if(o=c[i],"textContent"===i||"innerHTML"===i){if(r.children&&(r.children.length=0),o===s[i])continue;1===a.childNodes.length&&a.removeChild(a.childNodes[0])}if("value"===i&&"PROGRESS"!==a.tagName){a._value=o;var u=t(o)?"":String(o);ii(a,u)&&(a.value=u)}else if("innerHTML"===i&&qn(a.tagName)&&t(a.innerHTML)){(ti=ti||document.createElement("div")).innerHTML="<svg>"+o+"</svg>";for(var l=ti.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;l.firstChild;)a.appendChild(l.firstChild)}else if(o!==s[i])try{a[i]=o}catch(e){}}}}function ii(e,t){return!e.composing&&("OPTION"===e.tagName||function(e,t){var n=!0;try{n=document.activeElement!==e}catch(e){}return n&&e.value!==t}(e,t)||function(e,t){var r=e.value,i=e._vModifiers;if(n(i)){if(i.number)return f(r)!==f(t);if(i.trim)return r.trim()!==t.trim()}return r!==t}(e,t))}var oi={create:ri,update:ri},ai=g(function(e){var t={},n=/:(.+)/;return e.split(/;(?![^(]*\))/g).forEach(function(e){if(e){var r=e.split(n);r.length>1&&(t[r[0].trim()]=r[1].trim())}}),t});function si(e){var t=ci(e.style);return e.staticStyle?A(e.staticStyle,t):t}function ci(e){return Array.isArray(e)?O(e):"string"==typeof e?ai(e):e}var ui,li=/^--/,fi=/\s*!important$/,pi=function(e,t,n){if(li.test(t))e.style.setProperty(t,n);else if(fi.test(n))e.style.setProperty(C(t),n.replace(fi,""),"important");else{var r=vi(t);if(Array.isArray(n))for(var i=0,o=n.length;i<o;i++)e.style[r]=n[i];else e.style[r]=n}},di=["Webkit","Moz","ms"],vi=g(function(e){if(ui=ui||document.createElement("div").style,"filter"!==(e=b(e))&&e in ui)return e;for(var t=e.charAt(0).toUpperCase()+e.slice(1),n=0;n<di.length;n++){var r=di[n]+t;if(r in ui)return r}});function hi(e,r){var i=r.data,o=e.data;if(!(t(i.staticStyle)&&t(i.style)&&t(o.staticStyle)&&t(o.style))){var a,s,c=r.elm,u=o.staticStyle,l=o.normalizedStyle||o.style||{},f=u||l,p=ci(r.data.style)||{};r.data.normalizedStyle=n(p.__ob__)?A({},p):p;var d=function(e,t){var n,r={};if(t)for(var i=e;i.componentInstance;)(i=i.componentInstance._vnode)&&i.data&&(n=si(i.data))&&A(r,n);(n=si(e.data))&&A(r,n);for(var o=e;o=o.parent;)o.data&&(n=si(o.data))&&A(r,n);return r}(r,!0);for(s in f)t(d[s])&&pi(c,s,"");for(s in d)(a=d[s])!==f[s]&&pi(c,s,null==a?"":a)}}var mi={create:hi,update:hi},yi=/\s+/;function gi(e,t){if(t&&(t=t.trim()))if(e.classList)t.indexOf(" ")>-1?t.split(yi).forEach(function(t){return e.classList.add(t)}):e.classList.add(t);else{var n=" "+(e.getAttribute("class")||"")+" ";n.indexOf(" "+t+" ")<0&&e.setAttribute("class",(n+t).trim())}}function _i(e,t){if(t&&(t=t.trim()))if(e.classList)t.indexOf(" ")>-1?t.split(yi).forEach(function(t){return e.classList.remove(t)}):e.classList.remove(t),e.classList.length||e.removeAttribute("class");else{for(var n=" "+(e.getAttribute("class")||"")+" ",r=" "+t+" ";n.indexOf(r)>=0;)n=n.replace(r," ");(n=n.trim())?e.setAttribute("class",n):e.removeAttribute("class")}}function bi(e){if(e){if("object"==typeof e){var t={};return!1!==e.css&&A(t,$i(e.name||"v")),A(t,e),t}return"string"==typeof e?$i(e):void 0}}var $i=g(function(e){return{enterClass:e+"-enter",enterToClass:e+"-enter-to",enterActiveClass:e+"-enter-active",leaveClass:e+"-leave",leaveToClass:e+"-leave-to",leaveActiveClass:e+"-leave-active"}}),wi=z&&!W,Ci="transition",xi="animation",ki="transition",Ai="transitionend",Oi="animation",Si="animationend";wi&&(void 0===window.ontransitionend&&void 0!==window.onwebkittransitionend&&(ki="WebkitTransition",Ai="webkitTransitionEnd"),void 0===window.onanimationend&&void 0!==window.onwebkitanimationend&&(Oi="WebkitAnimation",Si="webkitAnimationEnd"));var Ti=z?window.requestAnimationFrame?window.requestAnimationFrame.bind(window):setTimeout:function(e){return e()};function Ei(e){Ti(function(){Ti(e)})}function Ni(e,t){var n=e._transitionClasses||(e._transitionClasses=[]);n.indexOf(t)<0&&(n.push(t),gi(e,t))}function ji(e,t){e._transitionClasses&&h(e._transitionClasses,t),_i(e,t)}function Di(e,t,n){var r=Mi(e,t),i=r.type,o=r.timeout,a=r.propCount;if(!i)return n();var s=i===Ci?Ai:Si,c=0,u=function(){e.removeEventListener(s,l),n()},l=function(t){t.target===e&&++c>=a&&u()};setTimeout(function(){c<a&&u()},o+1),e.addEventListener(s,l)}var Li=/\b(transform|all)(,|$)/;function Mi(e,t){var n,r=window.getComputedStyle(e),i=(r[ki+"Delay"]||"").split(", "),o=(r[ki+"Duration"]||"").split(", "),a=Ii(i,o),s=(r[Oi+"Delay"]||"").split(", "),c=(r[Oi+"Duration"]||"").split(", "),u=Ii(s,c),l=0,f=0;return t===Ci?a>0&&(n=Ci,l=a,f=o.length):t===xi?u>0&&(n=xi,l=u,f=c.length):f=(n=(l=Math.max(a,u))>0?a>u?Ci:xi:null)?n===Ci?o.length:c.length:0,{type:n,timeout:l,propCount:f,hasTransform:n===Ci&&Li.test(r[ki+"Property"])}}function Ii(e,t){for(;e.length<t.length;)e=e.concat(e);return Math.max.apply(null,t.map(function(t,n){return Fi(t)+Fi(e[n])}))}function Fi(e){return 1e3*Number(e.slice(0,-1).replace(",","."))}function Pi(e,r){var i=e.elm;n(i._leaveCb)&&(i._leaveCb.cancelled=!0,i._leaveCb());var a=bi(e.data.transition);if(!t(a)&&!n(i._enterCb)&&1===i.nodeType){for(var s=a.css,c=a.type,u=a.enterClass,l=a.enterToClass,p=a.enterActiveClass,d=a.appearClass,v=a.appearToClass,h=a.appearActiveClass,m=a.beforeEnter,y=a.enter,g=a.afterEnter,_=a.enterCancelled,b=a.beforeAppear,$=a.appear,w=a.afterAppear,C=a.appearCancelled,x=a.duration,k=Wt,A=Wt.$vnode;A&&A.parent;)k=A.context,A=A.parent;var O=!k._isMounted||!e.isRootInsert;if(!O||$||""===$){var S=O&&d?d:u,T=O&&h?h:p,E=O&&v?v:l,N=O&&b||m,j=O&&"function"==typeof $?$:y,L=O&&w||g,M=O&&C||_,I=f(o(x)?x.enter:x),F=!1!==s&&!W,P=Bi(j),R=i._enterCb=D(function(){F&&(ji(i,E),ji(i,T)),R.cancelled?(F&&ji(i,S),M&&M(i)):L&&L(i),i._enterCb=null});e.data.show||it(e,"insert",function(){var t=i.parentNode,n=t&&t._pending&&t._pending[e.key];n&&n.tag===e.tag&&n.elm._leaveCb&&n.elm._leaveCb(),j&&j(i,R)}),N&&N(i),F&&(Ni(i,S),Ni(i,T),Ei(function(){ji(i,S),R.cancelled||(Ni(i,E),P||(Hi(I)?setTimeout(R,I):Di(i,c,R)))})),e.data.show&&(r&&r(),j&&j(i,R)),F||P||R()}}}function Ri(e,r){var i=e.elm;n(i._enterCb)&&(i._enterCb.cancelled=!0,i._enterCb());var a=bi(e.data.transition);if(t(a)||1!==i.nodeType)return r();if(!n(i._leaveCb)){var s=a.css,c=a.type,u=a.leaveClass,l=a.leaveToClass,p=a.leaveActiveClass,d=a.beforeLeave,v=a.leave,h=a.afterLeave,m=a.leaveCancelled,y=a.delayLeave,g=a.duration,_=!1!==s&&!W,b=Bi(v),$=f(o(g)?g.leave:g),w=i._leaveCb=D(function(){i.parentNode&&i.parentNode._pending&&(i.parentNode._pending[e.key]=null),_&&(ji(i,l),ji(i,p)),w.cancelled?(_&&ji(i,u),m&&m(i)):(r(),h&&h(i)),i._leaveCb=null});y?y(C):C()}function C(){w.cancelled||(!e.data.show&&i.parentNode&&((i.parentNode._pending||(i.parentNode._pending={}))[e.key]=e),d&&d(i),_&&(Ni(i,u),Ni(i,p),Ei(function(){ji(i,u),w.cancelled||(Ni(i,l),b||(Hi($)?setTimeout(w,$):Di(i,c,w)))})),v&&v(i,w),_||b||w())}}function Hi(e){return"number"==typeof e&&!isNaN(e)}function Bi(e){if(t(e))return!1;var r=e.fns;return n(r)?Bi(Array.isArray(r)?r[0]:r):(e._length||e.length)>1}function Ui(e,t){!0!==t.data.show&&Pi(t)}var zi=function(e){var o,a,s={},c=e.modules,u=e.nodeOps;for(o=0;o<rr.length;++o)for(s[rr[o]]=[],a=0;a<c.length;++a)n(c[a][rr[o]])&&s[rr[o]].push(c[a][rr[o]]);function l(e){var t=u.parentNode(e);n(t)&&u.removeChild(t,e)}function f(e,t,i,o,a,c,l){if(n(e.elm)&&n(c)&&(e=c[l]=me(e)),e.isRootInsert=!a,!function(e,t,i,o){var a=e.data;if(n(a)){var c=n(e.componentInstance)&&a.keepAlive;if(n(a=a.hook)&&n(a=a.init)&&a(e,!1),n(e.componentInstance))return d(e,t),v(i,e.elm,o),r(c)&&function(e,t,r,i){for(var o,a=e;a.componentInstance;)if(a=a.componentInstance._vnode,n(o=a.data)&&n(o=o.transition)){for(o=0;o<s.activate.length;++o)s.activate[o](nr,a);t.push(a);break}v(r,e.elm,i)}(e,t,i,o),!0}}(e,t,i,o)){var f=e.data,p=e.children,m=e.tag;n(m)?(e.elm=e.ns?u.createElementNS(e.ns,m):u.createElement(m,e),g(e),h(e,p,t),n(f)&&y(e,t),v(i,e.elm,o)):r(e.isComment)?(e.elm=u.createComment(e.text),v(i,e.elm,o)):(e.elm=u.createTextNode(e.text),v(i,e.elm,o))}}function d(e,t){n(e.data.pendingInsert)&&(t.push.apply(t,e.data.pendingInsert),e.data.pendingInsert=null),e.elm=e.componentInstance.$el,m(e)?(y(e,t),g(e)):(tr(e),t.push(e))}function v(e,t,r){n(e)&&(n(r)?u.parentNode(r)===e&&u.insertBefore(e,t,r):u.appendChild(e,t))}function h(e,t,n){if(Array.isArray(t))for(var r=0;r<t.length;++r)f(t[r],n,e.elm,null,!0,t,r);else i(e.text)&&u.appendChild(e.elm,u.createTextNode(String(e.text)))}function m(e){for(;e.componentInstance;)e=e.componentInstance._vnode;return n(e.tag)}function y(e,t){for(var r=0;r<s.create.length;++r)s.create[r](nr,e);n(o=e.data.hook)&&(n(o.create)&&o.create(nr,e),n(o.insert)&&t.push(e))}function g(e){var t;if(n(t=e.fnScopeId))u.setStyleScope(e.elm,t);else for(var r=e;r;)n(t=r.context)&&n(t=t.$options._scopeId)&&u.setStyleScope(e.elm,t),r=r.parent;n(t=Wt)&&t!==e.context&&t!==e.fnContext&&n(t=t.$options._scopeId)&&u.setStyleScope(e.elm,t)}function _(e,t,n,r,i,o){for(;r<=i;++r)f(n[r],o,e,t,!1,n,r)}function b(e){var t,r,i=e.data;if(n(i))for(n(t=i.hook)&&n(t=t.destroy)&&t(e),t=0;t<s.destroy.length;++t)s.destroy[t](e);if(n(t=e.children))for(r=0;r<e.children.length;++r)b(e.children[r])}function $(e,t,r,i){for(;r<=i;++r){var o=t[r];n(o)&&(n(o.tag)?(w(o),b(o)):l(o.elm))}}function w(e,t){if(n(t)||n(e.data)){var r,i=s.remove.length+1;for(n(t)?t.listeners+=i:t=function(e,t){function n(){0==--n.listeners&&l(e)}return n.listeners=t,n}(e.elm,i),n(r=e.componentInstance)&&n(r=r._vnode)&&n(r.data)&&w(r,t),r=0;r<s.remove.length;++r)s.remove[r](e,t);n(r=e.data.hook)&&n(r=r.remove)?r(e,t):t()}else l(e.elm)}function C(e,t,r,i){for(var o=r;o<i;o++){var a=t[o];if(n(a)&&ir(e,a))return o}}function x(e,i,o,a,c,l){if(e!==i){n(i.elm)&&n(a)&&(i=a[c]=me(i));var p=i.elm=e.elm;if(r(e.isAsyncPlaceholder))n(i.asyncFactory.resolved)?O(e.elm,i,o):i.isAsyncPlaceholder=!0;else if(r(i.isStatic)&&r(e.isStatic)&&i.key===e.key&&(r(i.isCloned)||r(i.isOnce)))i.componentInstance=e.componentInstance;else{var d,v=i.data;n(v)&&n(d=v.hook)&&n(d=d.prepatch)&&d(e,i);var h=e.children,y=i.children;if(n(v)&&m(i)){for(d=0;d<s.update.length;++d)s.update[d](e,i);n(d=v.hook)&&n(d=d.update)&&d(e,i)}t(i.text)?n(h)&&n(y)?h!==y&&function(e,r,i,o,a){for(var s,c,l,p=0,d=0,v=r.length-1,h=r[0],m=r[v],y=i.length-1,g=i[0],b=i[y],w=!a;p<=v&&d<=y;)t(h)?h=r[++p]:t(m)?m=r[--v]:ir(h,g)?(x(h,g,o,i,d),h=r[++p],g=i[++d]):ir(m,b)?(x(m,b,o,i,y),m=r[--v],b=i[--y]):ir(h,b)?(x(h,b,o,i,y),w&&u.insertBefore(e,h.elm,u.nextSibling(m.elm)),h=r[++p],b=i[--y]):ir(m,g)?(x(m,g,o,i,d),w&&u.insertBefore(e,m.elm,h.elm),m=r[--v],g=i[++d]):(t(s)&&(s=or(r,p,v)),t(c=n(g.key)?s[g.key]:C(g,r,p,v))?f(g,o,e,h.elm,!1,i,d):ir(l=r[c],g)?(x(l,g,o,i,d),r[c]=void 0,w&&u.insertBefore(e,l.elm,h.elm)):f(g,o,e,h.elm,!1,i,d),g=i[++d]);p>v?_(e,t(i[y+1])?null:i[y+1].elm,i,d,y,o):d>y&&$(0,r,p,v)}(p,h,y,o,l):n(y)?(n(e.text)&&u.setTextContent(p,""),_(p,null,y,0,y.length-1,o)):n(h)?$(0,h,0,h.length-1):n(e.text)&&u.setTextContent(p,""):e.text!==i.text&&u.setTextContent(p,i.text),n(v)&&n(d=v.hook)&&n(d=d.postpatch)&&d(e,i)}}}function k(e,t,i){if(r(i)&&n(e.parent))e.parent.data.pendingInsert=t;else for(var o=0;o<t.length;++o)t[o].data.hook.insert(t[o])}var A=p("attrs,class,staticClass,staticStyle,key");function O(e,t,i,o){var a,s=t.tag,c=t.data,u=t.children;if(o=o||c&&c.pre,t.elm=e,r(t.isComment)&&n(t.asyncFactory))return t.isAsyncPlaceholder=!0,!0;if(n(c)&&(n(a=c.hook)&&n(a=a.init)&&a(t,!0),n(a=t.componentInstance)))return d(t,i),!0;if(n(s)){if(n(u))if(e.hasChildNodes())if(n(a=c)&&n(a=a.domProps)&&n(a=a.innerHTML)){if(a!==e.innerHTML)return!1}else{for(var l=!0,f=e.firstChild,p=0;p<u.length;p++){if(!f||!O(f,u[p],i,o)){l=!1;break}f=f.nextSibling}if(!l||f)return!1}else h(t,u,i);if(n(c)){var v=!1;for(var m in c)if(!A(m)){v=!0,y(t,i);break}!v&&c.class&&et(c.class)}}else e.data!==t.text&&(e.data=t.text);return!0}return function(e,i,o,a){if(!t(i)){var c,l=!1,p=[];if(t(e))l=!0,f(i,p);else{var d=n(e.nodeType);if(!d&&ir(e,i))x(e,i,p,null,null,a);else{if(d){if(1===e.nodeType&&e.hasAttribute(L)&&(e.removeAttribute(L),o=!0),r(o)&&O(e,i,p))return k(i,p,!0),e;c=e,e=new pe(u.tagName(c).toLowerCase(),{},[],void 0,c)}var v=e.elm,h=u.parentNode(v);if(f(i,p,v._leaveCb?null:h,u.nextSibling(v)),n(i.parent))for(var y=i.parent,g=m(i);y;){for(var _=0;_<s.destroy.length;++_)s.destroy[_](y);if(y.elm=i.elm,g){for(var w=0;w<s.create.length;++w)s.create[w](nr,y);var C=y.data.hook.insert;if(C.merged)for(var A=1;A<C.fns.length;A++)C.fns[A]()}else tr(y);y=y.parent}n(h)?$(0,[e],0,0):n(e.tag)&&b(e)}}return k(i,p,l),i.elm}n(e)&&b(e)}}({nodeOps:Qn,modules:[mr,xr,ni,oi,mi,z?{create:Ui,activate:Ui,remove:function(e,t){!0!==e.data.show?Ri(e,t):t()}}:{}].concat(pr)});W&&document.addEventListener("selectionchange",function(){var e=document.activeElement;e&&e.vmodel&&Xi(e,"input")});var Vi={inserted:function(e,t,n,r){"select"===n.tag?(r.elm&&!r.elm._vOptions?it(n,"postpatch",function(){Vi.componentUpdated(e,t,n)}):Ki(e,t,n.context),e._vOptions=[].map.call(e.options,Wi)):("textarea"===n.tag||Xn(e.type))&&(e._vModifiers=t.modifiers,t.modifiers.lazy||(e.addEventListener("compositionstart",Zi),e.addEventListener("compositionend",Gi),e.addEventListener("change",Gi),W&&(e.vmodel=!0)))},componentUpdated:function(e,t,n){if("select"===n.tag){Ki(e,t,n.context);var r=e._vOptions,i=e._vOptions=[].map.call(e.options,Wi);if(i.some(function(e,t){return!N(e,r[t])}))(e.multiple?t.value.some(function(e){return qi(e,i)}):t.value!==t.oldValue&&qi(t.value,i))&&Xi(e,"change")}}};function Ki(e,t,n){Ji(e,t,n),(q||Z)&&setTimeout(function(){Ji(e,t,n)},0)}function Ji(e,t,n){var r=t.value,i=e.multiple;if(!i||Array.isArray(r)){for(var o,a,s=0,c=e.options.length;s<c;s++)if(a=e.options[s],i)o=j(r,Wi(a))>-1,a.selected!==o&&(a.selected=o);else if(N(Wi(a),r))return void(e.selectedIndex!==s&&(e.selectedIndex=s));i||(e.selectedIndex=-1)}}function qi(e,t){return t.every(function(t){return!N(t,e)})}function Wi(e){return"_value"in e?e._value:e.value}function Zi(e){e.target.composing=!0}function Gi(e){e.target.composing&&(e.target.composing=!1,Xi(e.target,"input"))}function Xi(e,t){var n=document.createEvent("HTMLEvents");n.initEvent(t,!0,!0),e.dispatchEvent(n)}function Yi(e){return!e.componentInstance||e.data&&e.data.transition?e:Yi(e.componentInstance._vnode)}var Qi={model:Vi,show:{bind:function(e,t,n){var r=t.value,i=(n=Yi(n)).data&&n.data.transition,o=e.__vOriginalDisplay="none"===e.style.display?"":e.style.display;r&&i?(n.data.show=!0,Pi(n,function(){e.style.display=o})):e.style.display=r?o:"none"},update:function(e,t,n){var r=t.value;!r!=!t.oldValue&&((n=Yi(n)).data&&n.data.transition?(n.data.show=!0,r?Pi(n,function(){e.style.display=e.__vOriginalDisplay}):Ri(n,function(){e.style.display="none"})):e.style.display=r?e.__vOriginalDisplay:"none")},unbind:function(e,t,n,r,i){i||(e.style.display=e.__vOriginalDisplay)}}},eo={name:String,appear:Boolean,css:Boolean,mode:String,type:String,enterClass:String,leaveClass:String,enterToClass:String,leaveToClass:String,enterActiveClass:String,leaveActiveClass:String,appearClass:String,appearActiveClass:String,appearToClass:String,duration:[Number,String,Object]};function to(e){var t=e&&e.componentOptions;return t&&t.Ctor.options.abstract?to(zt(t.children)):e}function no(e){var t={},n=e.$options;for(var r in n.propsData)t[r]=e[r];var i=n._parentListeners;for(var o in i)t[b(o)]=i[o];return t}function ro(e,t){if(/\d-keep-alive$/.test(t.tag))return e("keep-alive",{props:t.componentOptions.propsData})}var io=function(e){return e.tag||Ut(e)},oo=function(e){return"show"===e.name},ao={name:"transition",props:eo,abstract:!0,render:function(e){var t=this,n=this.$slots.default;if(n&&(n=n.filter(io)).length){var r=this.mode,o=n[0];if(function(e){for(;e=e.parent;)if(e.data.transition)return!0}(this.$vnode))return o;var a=to(o);if(!a)return o;if(this._leaving)return ro(e,o);var s="__transition-"+this._uid+"-";a.key=null==a.key?a.isComment?s+"comment":s+a.tag:i(a.key)?0===String(a.key).indexOf(s)?a.key:s+a.key:a.key;var c=(a.data||(a.data={})).transition=no(this),u=this._vnode,l=to(u);if(a.data.directives&&a.data.directives.some(oo)&&(a.data.show=!0),l&&l.data&&!function(e,t){return t.key===e.key&&t.tag===e.tag}(a,l)&&!Ut(l)&&(!l.componentInstance||!l.componentInstance._vnode.isComment)){var f=l.data.transition=A({},c);if("out-in"===r)return this._leaving=!0,it(f,"afterLeave",function(){t._leaving=!1,t.$forceUpdate()}),ro(e,o);if("in-out"===r){if(Ut(a))return u;var p,d=function(){p()};it(c,"afterEnter",d),it(c,"enterCancelled",d),it(f,"delayLeave",function(e){p=e})}}return o}}},so=A({tag:String,moveClass:String},eo);function co(e){e.elm._moveCb&&e.elm._moveCb(),e.elm._enterCb&&e.elm._enterCb()}function uo(e){e.data.newPos=e.elm.getBoundingClientRect()}function lo(e){var t=e.data.pos,n=e.data.newPos,r=t.left-n.left,i=t.top-n.top;if(r||i){e.data.moved=!0;var o=e.elm.style;o.transform=o.WebkitTransform="translate("+r+"px,"+i+"px)",o.transitionDuration="0s"}}delete so.mode;var fo={Transition:ao,TransitionGroup:{props:so,beforeMount:function(){var e=this,t=this._update;this._update=function(n,r){var i=Zt(e);e.__patch__(e._vnode,e.kept,!1,!0),e._vnode=e.kept,i(),t.call(e,n,r)}},render:function(e){for(var t=this.tag||this.$vnode.data.tag||"span",n=Object.create(null),r=this.prevChildren=this.children,i=this.$slots.default||[],o=this.children=[],a=no(this),s=0;s<i.length;s++){var c=i[s];c.tag&&null!=c.key&&0!==String(c.key).indexOf("__vlist")&&(o.push(c),n[c.key]=c,(c.data||(c.data={})).transition=a)}if(r){for(var u=[],l=[],f=0;f<r.length;f++){var p=r[f];p.data.transition=a,p.data.pos=p.elm.getBoundingClientRect(),n[p.key]?u.push(p):l.push(p)}this.kept=e(t,null,u),this.removed=l}return e(t,null,o)},updated:function(){var e=this.prevChildren,t=this.moveClass||(this.name||"v")+"-move";e.length&&this.hasMove(e[0].elm,t)&&(e.forEach(co),e.forEach(uo),e.forEach(lo),this._reflow=document.body.offsetHeight,e.forEach(function(e){if(e.data.moved){var n=e.elm,r=n.style;Ni(n,t),r.transform=r.WebkitTransform=r.transitionDuration="",n.addEventListener(Ai,n._moveCb=function e(r){r&&r.target!==n||r&&!/transform$/.test(r.propertyName)||(n.removeEventListener(Ai,e),n._moveCb=null,ji(n,t))})}}))},methods:{hasMove:function(e,t){if(!wi)return!1;if(this._hasMove)return this._hasMove;var n=e.cloneNode();e._transitionClasses&&e._transitionClasses.forEach(function(e){_i(n,e)}),gi(n,t),n.style.display="none",this.$el.appendChild(n);var r=Mi(n);return this.$el.removeChild(n),this._hasMove=r.hasTransform}}}};wn.config.mustUseProp=jn,wn.config.isReservedTag=Wn,wn.config.isReservedAttr=En,wn.config.getTagNamespace=Zn,wn.config.isUnknownElement=function(e){if(!z)return!0;if(Wn(e))return!1;if(e=e.toLowerCase(),null!=Gn[e])return Gn[e];var t=document.createElement(e);return e.indexOf("-")>-1?Gn[e]=t.constructor===window.HTMLUnknownElement||t.constructor===window.HTMLElement:Gn[e]=/HTMLUnknownElement/.test(t.toString())},A(wn.options.directives,Qi),A(wn.options.components,fo),wn.prototype.__patch__=z?zi:S,wn.prototype.$mount=function(e,t){return function(e,t,n){var r;return e.$el=t,e.$options.render||(e.$options.render=ve),Yt(e,"beforeMount"),r=function(){e._update(e._render(),n)},new fn(e,r,S,{before:function(){e._isMounted&&!e._isDestroyed&&Yt(e,"beforeUpdate")}},!0),n=!1,null==e.$vnode&&(e._isMounted=!0,Yt(e,"mounted")),e}(this,e=e&&z?Yn(e):void 0,t)},z&&setTimeout(function(){F.devtools&&ne&&ne.emit("init",wn)},0);var po=/\{\{((?:.|\r?\n)+?)\}\}/g,vo=/[-.*+?^${}()|[\]\/\\]/g,ho=g(function(e){var t=e[0].replace(vo,"\\$&"),n=e[1].replace(vo,"\\$&");return new RegExp(t+"((?:.|\\n)+?)"+n,"g")});var mo={staticKeys:["staticClass"],transformNode:function(e,t){t.warn;var n=Fr(e,"class");n&&(e.staticClass=JSON.stringify(n));var r=Ir(e,"class",!1);r&&(e.classBinding=r)},genData:function(e){var t="";return e.staticClass&&(t+="staticClass:"+e.staticClass+","),e.classBinding&&(t+="class:"+e.classBinding+","),t}};var yo,go={staticKeys:["staticStyle"],transformNode:function(e,t){t.warn;var n=Fr(e,"style");n&&(e.staticStyle=JSON.stringify(ai(n)));var r=Ir(e,"style",!1);r&&(e.styleBinding=r)},genData:function(e){var t="";return e.staticStyle&&(t+="staticStyle:"+e.staticStyle+","),e.styleBinding&&(t+="style:("+e.styleBinding+"),"),t}},_o=function(e){return(yo=yo||document.createElement("div")).innerHTML=e,yo.textContent},bo=p("area,base,br,col,embed,frame,hr,img,input,isindex,keygen,link,meta,param,source,track,wbr"),$o=p("colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source"),wo=p("address,article,aside,base,blockquote,body,caption,col,colgroup,dd,details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,title,tr,track"),Co=/^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/,xo=/^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/,ko="[a-zA-Z_][\\-\\.0-9_a-zA-Z"+P.source+"]*",Ao="((?:"+ko+"\\:)?"+ko+")",Oo=new RegExp("^<"+Ao),So=/^\s*(\/?)>/,To=new RegExp("^<\\/"+Ao+"[^>]*>"),Eo=/^<!DOCTYPE [^>]+>/i,No=/^<!\--/,jo=/^<!\[/,Do=p("script,style,textarea",!0),Lo={},Mo={"&lt;":"<","&gt;":">","&quot;":'"',"&amp;":"&","&#10;":"\n","&#9;":"\t","&#39;":"'"},Io=/&(?:lt|gt|quot|amp|#39);/g,Fo=/&(?:lt|gt|quot|amp|#39|#10|#9);/g,Po=p("pre,textarea",!0),Ro=function(e,t){return e&&Po(e)&&"\n"===t[0]};function Ho(e,t){var n=t?Fo:Io;return e.replace(n,function(e){return Mo[e]})}var Bo,Uo,zo,Vo,Ko,Jo,qo,Wo,Zo=/^@|^v-on:/,Go=/^v-|^@|^:/,Xo=/([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/,Yo=/,([^,\}\]]*)(?:,([^,\}\]]*))?$/,Qo=/^\(|\)$/g,ea=/^\[.*\]$/,ta=/:(.*)$/,na=/^:|^\.|^v-bind:/,ra=/\.[^.\]]+(?=[^\]]*$)/g,ia=/^v-slot(:|$)|^#/,oa=/[\r\n]/,aa=/\s+/g,sa=g(_o),ca="_empty_";function ua(e,t,n){return{type:1,tag:e,attrsList:t,attrsMap:ma(t),rawAttrsMap:{},parent:n,children:[]}}function la(e,t){Bo=t.warn||Sr,Jo=t.isPreTag||T,qo=t.mustUseProp||T,Wo=t.getTagNamespace||T;t.isReservedTag;zo=Tr(t.modules,"transformNode"),Vo=Tr(t.modules,"preTransformNode"),Ko=Tr(t.modules,"postTransformNode"),Uo=t.delimiters;var n,r,i=[],o=!1!==t.preserveWhitespace,a=t.whitespace,s=!1,c=!1;function u(e){if(l(e),s||e.processed||(e=fa(e,t)),i.length||e===n||n.if&&(e.elseif||e.else)&&da(n,{exp:e.elseif,block:e}),r&&!e.forbidden)if(e.elseif||e.else)a=e,(u=function(e){var t=e.length;for(;t--;){if(1===e[t].type)return e[t];e.pop()}}(r.children))&&u.if&&da(u,{exp:a.elseif,block:a});else{if(e.slotScope){var o=e.slotTarget||'"default"';(r.scopedSlots||(r.scopedSlots={}))[o]=e}r.children.push(e),e.parent=r}var a,u;e.children=e.children.filter(function(e){return!e.slotScope}),l(e),e.pre&&(s=!1),Jo(e.tag)&&(c=!1);for(var f=0;f<Ko.length;f++)Ko[f](e,t)}function l(e){if(!c)for(var t;(t=e.children[e.children.length-1])&&3===t.type&&" "===t.text;)e.children.pop()}return function(e,t){for(var n,r,i=[],o=t.expectHTML,a=t.isUnaryTag||T,s=t.canBeLeftOpenTag||T,c=0;e;){if(n=e,r&&Do(r)){var u=0,l=r.toLowerCase(),f=Lo[l]||(Lo[l]=new RegExp("([\\s\\S]*?)(</"+l+"[^>]*>)","i")),p=e.replace(f,function(e,n,r){return u=r.length,Do(l)||"noscript"===l||(n=n.replace(/<!\--([\s\S]*?)-->/g,"$1").replace(/<!\[CDATA\[([\s\S]*?)]]>/g,"$1")),Ro(l,n)&&(n=n.slice(1)),t.chars&&t.chars(n),""});c+=e.length-p.length,e=p,A(l,c-u,c)}else{var d=e.indexOf("<");if(0===d){if(No.test(e)){var v=e.indexOf("--\x3e");if(v>=0){t.shouldKeepComment&&t.comment(e.substring(4,v),c,c+v+3),C(v+3);continue}}if(jo.test(e)){var h=e.indexOf("]>");if(h>=0){C(h+2);continue}}var m=e.match(Eo);if(m){C(m[0].length);continue}var y=e.match(To);if(y){var g=c;C(y[0].length),A(y[1],g,c);continue}var _=x();if(_){k(_),Ro(_.tagName,e)&&C(1);continue}}var b=void 0,$=void 0,w=void 0;if(d>=0){for($=e.slice(d);!(To.test($)||Oo.test($)||No.test($)||jo.test($)||(w=$.indexOf("<",1))<0);)d+=w,$=e.slice(d);b=e.substring(0,d)}d<0&&(b=e),b&&C(b.length),t.chars&&b&&t.chars(b,c-b.length,c)}if(e===n){t.chars&&t.chars(e);break}}function C(t){c+=t,e=e.substring(t)}function x(){var t=e.match(Oo);if(t){var n,r,i={tagName:t[1],attrs:[],start:c};for(C(t[0].length);!(n=e.match(So))&&(r=e.match(xo)||e.match(Co));)r.start=c,C(r[0].length),r.end=c,i.attrs.push(r);if(n)return i.unarySlash=n[1],C(n[0].length),i.end=c,i}}function k(e){var n=e.tagName,c=e.unarySlash;o&&("p"===r&&wo(n)&&A(r),s(n)&&r===n&&A(n));for(var u=a(n)||!!c,l=e.attrs.length,f=new Array(l),p=0;p<l;p++){var d=e.attrs[p],v=d[3]||d[4]||d[5]||"",h="a"===n&&"href"===d[1]?t.shouldDecodeNewlinesForHref:t.shouldDecodeNewlines;f[p]={name:d[1],value:Ho(v,h)}}u||(i.push({tag:n,lowerCasedTag:n.toLowerCase(),attrs:f,start:e.start,end:e.end}),r=n),t.start&&t.start(n,f,u,e.start,e.end)}function A(e,n,o){var a,s;if(null==n&&(n=c),null==o&&(o=c),e)for(s=e.toLowerCase(),a=i.length-1;a>=0&&i[a].lowerCasedTag!==s;a--);else a=0;if(a>=0){for(var u=i.length-1;u>=a;u--)t.end&&t.end(i[u].tag,n,o);i.length=a,r=a&&i[a-1].tag}else"br"===s?t.start&&t.start(e,[],!0,n,o):"p"===s&&(t.start&&t.start(e,[],!1,n,o),t.end&&t.end(e,n,o))}A()}(e,{warn:Bo,expectHTML:t.expectHTML,isUnaryTag:t.isUnaryTag,canBeLeftOpenTag:t.canBeLeftOpenTag,shouldDecodeNewlines:t.shouldDecodeNewlines,shouldDecodeNewlinesForHref:t.shouldDecodeNewlinesForHref,shouldKeepComment:t.comments,outputSourceRange:t.outputSourceRange,start:function(e,o,a,l,f){var p=r&&r.ns||Wo(e);q&&"svg"===p&&(o=function(e){for(var t=[],n=0;n<e.length;n++){var r=e[n];ya.test(r.name)||(r.name=r.name.replace(ga,""),t.push(r))}return t}(o));var d,v=ua(e,o,r);p&&(v.ns=p),"style"!==(d=v).tag&&("script"!==d.tag||d.attrsMap.type&&"text/javascript"!==d.attrsMap.type)||te()||(v.forbidden=!0);for(var h=0;h<Vo.length;h++)v=Vo[h](v,t)||v;s||(!function(e){null!=Fr(e,"v-pre")&&(e.pre=!0)}(v),v.pre&&(s=!0)),Jo(v.tag)&&(c=!0),s?function(e){var t=e.attrsList,n=t.length;if(n)for(var r=e.attrs=new Array(n),i=0;i<n;i++)r[i]={name:t[i].name,value:JSON.stringify(t[i].value)},null!=t[i].start&&(r[i].start=t[i].start,r[i].end=t[i].end);else e.pre||(e.plain=!0)}(v):v.processed||(pa(v),function(e){var t=Fr(e,"v-if");if(t)e.if=t,da(e,{exp:t,block:e});else{null!=Fr(e,"v-else")&&(e.else=!0);var n=Fr(e,"v-else-if");n&&(e.elseif=n)}}(v),function(e){null!=Fr(e,"v-once")&&(e.once=!0)}(v)),n||(n=v),a?u(v):(r=v,i.push(v))},end:function(e,t,n){var o=i[i.length-1];i.length-=1,r=i[i.length-1],u(o)},chars:function(e,t,n){if(r&&(!q||"textarea"!==r.tag||r.attrsMap.placeholder!==e)){var i,u,l,f=r.children;if(e=c||e.trim()?"script"===(i=r).tag||"style"===i.tag?e:sa(e):f.length?a?"condense"===a&&oa.test(e)?"":" ":o?" ":"":"")c||"condense"!==a||(e=e.replace(aa," ")),!s&&" "!==e&&(u=function(e,t){var n=t?ho(t):po;if(n.test(e)){for(var r,i,o,a=[],s=[],c=n.lastIndex=0;r=n.exec(e);){(i=r.index)>c&&(s.push(o=e.slice(c,i)),a.push(JSON.stringify(o)));var u=Ar(r[1].trim());a.push("_s("+u+")"),s.push({"@binding":u}),c=i+r[0].length}return c<e.length&&(s.push(o=e.slice(c)),a.push(JSON.stringify(o))),{expression:a.join("+"),tokens:s}}}(e,Uo))?l={type:2,expression:u.expression,tokens:u.tokens,text:e}:" "===e&&f.length&&" "===f[f.length-1].text||(l={type:3,text:e}),l&&f.push(l)}},comment:function(e,t,n){if(r){var i={type:3,text:e,isComment:!0};r.children.push(i)}}}),n}function fa(e,t){var n,r;(r=Ir(n=e,"key"))&&(n.key=r),e.plain=!e.key&&!e.scopedSlots&&!e.attrsList.length,function(e){var t=Ir(e,"ref");t&&(e.ref=t,e.refInFor=function(e){var t=e;for(;t;){if(void 0!==t.for)return!0;t=t.parent}return!1}(e))}(e),function(e){var t;"template"===e.tag?(t=Fr(e,"scope"),e.slotScope=t||Fr(e,"slot-scope")):(t=Fr(e,"slot-scope"))&&(e.slotScope=t);var n=Ir(e,"slot");n&&(e.slotTarget='""'===n?'"default"':n,e.slotTargetDynamic=!(!e.attrsMap[":slot"]&&!e.attrsMap["v-bind:slot"]),"template"===e.tag||e.slotScope||Nr(e,"slot",n,function(e,t){return e.rawAttrsMap[":"+t]||e.rawAttrsMap["v-bind:"+t]||e.rawAttrsMap[t]}(e,"slot")));if("template"===e.tag){var r=Pr(e,ia);if(r){var i=va(r),o=i.name,a=i.dynamic;e.slotTarget=o,e.slotTargetDynamic=a,e.slotScope=r.value||ca}}else{var s=Pr(e,ia);if(s){var c=e.scopedSlots||(e.scopedSlots={}),u=va(s),l=u.name,f=u.dynamic,p=c[l]=ua("template",[],e);p.slotTarget=l,p.slotTargetDynamic=f,p.children=e.children.filter(function(e){if(!e.slotScope)return e.parent=p,!0}),p.slotScope=s.value||ca,e.children=[],e.plain=!1}}}(e),function(e){"slot"===e.tag&&(e.slotName=Ir(e,"name"))}(e),function(e){var t;(t=Ir(e,"is"))&&(e.component=t);null!=Fr(e,"inline-template")&&(e.inlineTemplate=!0)}(e);for(var i=0;i<zo.length;i++)e=zo[i](e,t)||e;return function(e){var t,n,r,i,o,a,s,c,u=e.attrsList;for(t=0,n=u.length;t<n;t++)if(r=i=u[t].name,o=u[t].value,Go.test(r))if(e.hasBindings=!0,(a=ha(r.replace(Go,"")))&&(r=r.replace(ra,"")),na.test(r))r=r.replace(na,""),o=Ar(o),(c=ea.test(r))&&(r=r.slice(1,-1)),a&&(a.prop&&!c&&"innerHtml"===(r=b(r))&&(r="innerHTML"),a.camel&&!c&&(r=b(r)),a.sync&&(s=Br(o,"$event"),c?Mr(e,'"update:"+('+r+")",s,null,!1,0,u[t],!0):(Mr(e,"update:"+b(r),s,null,!1,0,u[t]),C(r)!==b(r)&&Mr(e,"update:"+C(r),s,null,!1,0,u[t])))),a&&a.prop||!e.component&&qo(e.tag,e.attrsMap.type,r)?Er(e,r,o,u[t],c):Nr(e,r,o,u[t],c);else if(Zo.test(r))r=r.replace(Zo,""),(c=ea.test(r))&&(r=r.slice(1,-1)),Mr(e,r,o,a,!1,0,u[t],c);else{var l=(r=r.replace(Go,"")).match(ta),f=l&&l[1];c=!1,f&&(r=r.slice(0,-(f.length+1)),ea.test(f)&&(f=f.slice(1,-1),c=!0)),Dr(e,r,i,o,f,c,a,u[t])}else Nr(e,r,JSON.stringify(o),u[t]),!e.component&&"muted"===r&&qo(e.tag,e.attrsMap.type,r)&&Er(e,r,"true",u[t])}(e),e}function pa(e){var t;if(t=Fr(e,"v-for")){var n=function(e){var t=e.match(Xo);if(!t)return;var n={};n.for=t[2].trim();var r=t[1].trim().replace(Qo,""),i=r.match(Yo);i?(n.alias=r.replace(Yo,"").trim(),n.iterator1=i[1].trim(),i[2]&&(n.iterator2=i[2].trim())):n.alias=r;return n}(t);n&&A(e,n)}}function da(e,t){e.ifConditions||(e.ifConditions=[]),e.ifConditions.push(t)}function va(e){var t=e.name.replace(ia,"");return t||"#"!==e.name[0]&&(t="default"),ea.test(t)?{name:t.slice(1,-1),dynamic:!0}:{name:'"'+t+'"',dynamic:!1}}function ha(e){var t=e.match(ra);if(t){var n={};return t.forEach(function(e){n[e.slice(1)]=!0}),n}}function ma(e){for(var t={},n=0,r=e.length;n<r;n++)t[e[n].name]=e[n].value;return t}var ya=/^xmlns:NS\d+/,ga=/^NS\d+:/;function _a(e){return ua(e.tag,e.attrsList.slice(),e.parent)}var ba=[mo,go,{preTransformNode:function(e,t){if("input"===e.tag){var n,r=e.attrsMap;if(!r["v-model"])return;if((r[":type"]||r["v-bind:type"])&&(n=Ir(e,"type")),r.type||n||!r["v-bind"]||(n="("+r["v-bind"]+").type"),n){var i=Fr(e,"v-if",!0),o=i?"&&("+i+")":"",a=null!=Fr(e,"v-else",!0),s=Fr(e,"v-else-if",!0),c=_a(e);pa(c),jr(c,"type","checkbox"),fa(c,t),c.processed=!0,c.if="("+n+")==='checkbox'"+o,da(c,{exp:c.if,block:c});var u=_a(e);Fr(u,"v-for",!0),jr(u,"type","radio"),fa(u,t),da(c,{exp:"("+n+")==='radio'"+o,block:u});var l=_a(e);return Fr(l,"v-for",!0),jr(l,":type",n),fa(l,t),da(c,{exp:i,block:l}),a?c.else=!0:s&&(c.elseif=s),c}}}}];var $a,wa,Ca={expectHTML:!0,modules:ba,directives:{model:function(e,t,n){var r=t.value,i=t.modifiers,o=e.tag,a=e.attrsMap.type;if(e.component)return Hr(e,r,i),!1;if("select"===o)!function(e,t,n){var r='var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return '+(n&&n.number?"_n(val)":"val")+"});";r=r+" "+Br(t,"$event.target.multiple ? $$selectedVal : $$selectedVal[0]"),Mr(e,"change",r,null,!0)}(e,r,i);else if("input"===o&&"checkbox"===a)!function(e,t,n){var r=n&&n.number,i=Ir(e,"value")||"null",o=Ir(e,"true-value")||"true",a=Ir(e,"false-value")||"false";Er(e,"checked","Array.isArray("+t+")?_i("+t+","+i+")>-1"+("true"===o?":("+t+")":":_q("+t+","+o+")")),Mr(e,"change","var $$a="+t+",$$el=$event.target,$$c=$$el.checked?("+o+"):("+a+");if(Array.isArray($$a)){var $$v="+(r?"_n("+i+")":i)+",$$i=_i($$a,$$v);if($$el.checked){$$i<0&&("+Br(t,"$$a.concat([$$v])")+")}else{$$i>-1&&("+Br(t,"$$a.slice(0,$$i).concat($$a.slice($$i+1))")+")}}else{"+Br(t,"$$c")+"}",null,!0)}(e,r,i);else if("input"===o&&"radio"===a)!function(e,t,n){var r=n&&n.number,i=Ir(e,"value")||"null";Er(e,"checked","_q("+t+","+(i=r?"_n("+i+")":i)+")"),Mr(e,"change",Br(t,i),null,!0)}(e,r,i);else if("input"===o||"textarea"===o)!function(e,t,n){var r=e.attrsMap.type,i=n||{},o=i.lazy,a=i.number,s=i.trim,c=!o&&"range"!==r,u=o?"change":"range"===r?Wr:"input",l="$event.target.value";s&&(l="$event.target.value.trim()"),a&&(l="_n("+l+")");var f=Br(t,l);c&&(f="if($event.target.composing)return;"+f),Er(e,"value","("+t+")"),Mr(e,u,f,null,!0),(s||a)&&Mr(e,"blur","$forceUpdate()")}(e,r,i);else if(!F.isReservedTag(o))return Hr(e,r,i),!1;return!0},text:function(e,t){t.value&&Er(e,"textContent","_s("+t.value+")",t)},html:function(e,t){t.value&&Er(e,"innerHTML","_s("+t.value+")",t)}},isPreTag:function(e){return"pre"===e},isUnaryTag:bo,mustUseProp:jn,canBeLeftOpenTag:$o,isReservedTag:Wn,getTagNamespace:Zn,staticKeys:function(e){return e.reduce(function(e,t){return e.concat(t.staticKeys||[])},[]).join(",")}(ba)},xa=g(function(e){return p("type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap"+(e?","+e:""))});function ka(e,t){e&&($a=xa(t.staticKeys||""),wa=t.isReservedTag||T,function e(t){t.static=function(e){if(2===e.type)return!1;if(3===e.type)return!0;return!(!e.pre&&(e.hasBindings||e.if||e.for||d(e.tag)||!wa(e.tag)||function(e){for(;e.parent;){if("template"!==(e=e.parent).tag)return!1;if(e.for)return!0}return!1}(e)||!Object.keys(e).every($a)))}(t);if(1===t.type){if(!wa(t.tag)&&"slot"!==t.tag&&null==t.attrsMap["inline-template"])return;for(var n=0,r=t.children.length;n<r;n++){var i=t.children[n];e(i),i.static||(t.static=!1)}if(t.ifConditions)for(var o=1,a=t.ifConditions.length;o<a;o++){var s=t.ifConditions[o].block;e(s),s.static||(t.static=!1)}}}(e),function e(t,n){if(1===t.type){if((t.static||t.once)&&(t.staticInFor=n),t.static&&t.children.length&&(1!==t.children.length||3!==t.children[0].type))return void(t.staticRoot=!0);if(t.staticRoot=!1,t.children)for(var r=0,i=t.children.length;r<i;r++)e(t.children[r],n||!!t.for);if(t.ifConditions)for(var o=1,a=t.ifConditions.length;o<a;o++)e(t.ifConditions[o].block,n)}}(e,!1))}var Aa=/^([\w$_]+|\([^)]*?\))\s*=>|^function\s*(?:[\w$]+)?\s*\(/,Oa=/\([^)]*?\);*$/,Sa=/^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/,Ta={esc:27,tab:9,enter:13,space:32,up:38,left:37,right:39,down:40,delete:[8,46]},Ea={esc:["Esc","Escape"],tab:"Tab",enter:"Enter",space:[" ","Spacebar"],up:["Up","ArrowUp"],left:["Left","ArrowLeft"],right:["Right","ArrowRight"],down:["Down","ArrowDown"],delete:["Backspace","Delete","Del"]},Na=function(e){return"if("+e+")return null;"},ja={stop:"$event.stopPropagation();",prevent:"$event.preventDefault();",self:Na("$event.target !== $event.currentTarget"),ctrl:Na("!$event.ctrlKey"),shift:Na("!$event.shiftKey"),alt:Na("!$event.altKey"),meta:Na("!$event.metaKey"),left:Na("'button' in $event && $event.button !== 0"),middle:Na("'button' in $event && $event.button !== 1"),right:Na("'button' in $event && $event.button !== 2")};function Da(e,t){var n=t?"nativeOn:":"on:",r="",i="";for(var o in e){var a=La(e[o]);e[o]&&e[o].dynamic?i+=o+","+a+",":r+='"'+o+'":'+a+","}return r="{"+r.slice(0,-1)+"}",i?n+"_d("+r+",["+i.slice(0,-1)+"])":n+r}function La(e){if(!e)return"function(){}";if(Array.isArray(e))return"["+e.map(function(e){return La(e)}).join(",")+"]";var t=Sa.test(e.value),n=Aa.test(e.value),r=Sa.test(e.value.replace(Oa,""));if(e.modifiers){var i="",o="",a=[];for(var s in e.modifiers)if(ja[s])o+=ja[s],Ta[s]&&a.push(s);else if("exact"===s){var c=e.modifiers;o+=Na(["ctrl","shift","alt","meta"].filter(function(e){return!c[e]}).map(function(e){return"$event."+e+"Key"}).join("||"))}else a.push(s);return a.length&&(i+=function(e){return"if(!$event.type.indexOf('key')&&"+e.map(Ma).join("&&")+")return null;"}(a)),o&&(i+=o),"function($event){"+i+(t?"return "+e.value+"($event)":n?"return ("+e.value+")($event)":r?"return "+e.value:e.value)+"}"}return t||n?e.value:"function($event){"+(r?"return "+e.value:e.value)+"}"}function Ma(e){var t=parseInt(e,10);if(t)return"$event.keyCode!=="+t;var n=Ta[e],r=Ea[e];return"_k($event.keyCode,"+JSON.stringify(e)+","+JSON.stringify(n)+",$event.key,"+JSON.stringify(r)+")"}var Ia={on:function(e,t){e.wrapListeners=function(e){return"_g("+e+","+t.value+")"}},bind:function(e,t){e.wrapData=function(n){return"_b("+n+",'"+e.tag+"',"+t.value+","+(t.modifiers&&t.modifiers.prop?"true":"false")+(t.modifiers&&t.modifiers.sync?",true":"")+")"}},cloak:S},Fa=function(e){this.options=e,this.warn=e.warn||Sr,this.transforms=Tr(e.modules,"transformCode"),this.dataGenFns=Tr(e.modules,"genData"),this.directives=A(A({},Ia),e.directives);var t=e.isReservedTag||T;this.maybeComponent=function(e){return!!e.component||!t(e.tag)},this.onceId=0,this.staticRenderFns=[],this.pre=!1};function Pa(e,t){var n=new Fa(t);return{render:"with(this){return "+(e?Ra(e,n):'_c("div")')+"}",staticRenderFns:n.staticRenderFns}}function Ra(e,t){if(e.parent&&(e.pre=e.pre||e.parent.pre),e.staticRoot&&!e.staticProcessed)return Ha(e,t);if(e.once&&!e.onceProcessed)return Ba(e,t);if(e.for&&!e.forProcessed)return za(e,t);if(e.if&&!e.ifProcessed)return Ua(e,t);if("template"!==e.tag||e.slotTarget||t.pre){if("slot"===e.tag)return function(e,t){var n=e.slotName||'"default"',r=qa(e,t),i="_t("+n+(r?","+r:""),o=e.attrs||e.dynamicAttrs?Ga((e.attrs||[]).concat(e.dynamicAttrs||[]).map(function(e){return{name:b(e.name),value:e.value,dynamic:e.dynamic}})):null,a=e.attrsMap["v-bind"];!o&&!a||r||(i+=",null");o&&(i+=","+o);a&&(i+=(o?"":",null")+","+a);return i+")"}(e,t);var n;if(e.component)n=function(e,t,n){var r=t.inlineTemplate?null:qa(t,n,!0);return"_c("+e+","+Va(t,n)+(r?","+r:"")+")"}(e.component,e,t);else{var r;(!e.plain||e.pre&&t.maybeComponent(e))&&(r=Va(e,t));var i=e.inlineTemplate?null:qa(e,t,!0);n="_c('"+e.tag+"'"+(r?","+r:"")+(i?","+i:"")+")"}for(var o=0;o<t.transforms.length;o++)n=t.transforms[o](e,n);return n}return qa(e,t)||"void 0"}function Ha(e,t){e.staticProcessed=!0;var n=t.pre;return e.pre&&(t.pre=e.pre),t.staticRenderFns.push("with(this){return "+Ra(e,t)+"}"),t.pre=n,"_m("+(t.staticRenderFns.length-1)+(e.staticInFor?",true":"")+")"}function Ba(e,t){if(e.onceProcessed=!0,e.if&&!e.ifProcessed)return Ua(e,t);if(e.staticInFor){for(var n="",r=e.parent;r;){if(r.for){n=r.key;break}r=r.parent}return n?"_o("+Ra(e,t)+","+t.onceId+++","+n+")":Ra(e,t)}return Ha(e,t)}function Ua(e,t,n,r){return e.ifProcessed=!0,function e(t,n,r,i){if(!t.length)return i||"_e()";var o=t.shift();return o.exp?"("+o.exp+")?"+a(o.block)+":"+e(t,n,r,i):""+a(o.block);function a(e){return r?r(e,n):e.once?Ba(e,n):Ra(e,n)}}(e.ifConditions.slice(),t,n,r)}function za(e,t,n,r){var i=e.for,o=e.alias,a=e.iterator1?","+e.iterator1:"",s=e.iterator2?","+e.iterator2:"";return e.forProcessed=!0,(r||"_l")+"(("+i+"),function("+o+a+s+"){return "+(n||Ra)(e,t)+"})"}function Va(e,t){var n="{",r=function(e,t){var n=e.directives;if(!n)return;var r,i,o,a,s="directives:[",c=!1;for(r=0,i=n.length;r<i;r++){o=n[r],a=!0;var u=t.directives[o.name];u&&(a=!!u(e,o,t.warn)),a&&(c=!0,s+='{name:"'+o.name+'",rawName:"'+o.rawName+'"'+(o.value?",value:("+o.value+"),expression:"+JSON.stringify(o.value):"")+(o.arg?",arg:"+(o.isDynamicArg?o.arg:'"'+o.arg+'"'):"")+(o.modifiers?",modifiers:"+JSON.stringify(o.modifiers):"")+"},")}if(c)return s.slice(0,-1)+"]"}(e,t);r&&(n+=r+","),e.key&&(n+="key:"+e.key+","),e.ref&&(n+="ref:"+e.ref+","),e.refInFor&&(n+="refInFor:true,"),e.pre&&(n+="pre:true,"),e.component&&(n+='tag:"'+e.tag+'",');for(var i=0;i<t.dataGenFns.length;i++)n+=t.dataGenFns[i](e);if(e.attrs&&(n+="attrs:"+Ga(e.attrs)+","),e.props&&(n+="domProps:"+Ga(e.props)+","),e.events&&(n+=Da(e.events,!1)+","),e.nativeEvents&&(n+=Da(e.nativeEvents,!0)+","),e.slotTarget&&!e.slotScope&&(n+="slot:"+e.slotTarget+","),e.scopedSlots&&(n+=function(e,t,n){var r=e.for||Object.keys(t).some(function(e){var n=t[e];return n.slotTargetDynamic||n.if||n.for||Ka(n)}),i=!!e.if;if(!r)for(var o=e.parent;o;){if(o.slotScope&&o.slotScope!==ca||o.for){r=!0;break}o.if&&(i=!0),o=o.parent}var a=Object.keys(t).map(function(e){return Ja(t[e],n)}).join(",");return"scopedSlots:_u(["+a+"]"+(r?",null,true":"")+(!r&&i?",null,false,"+function(e){var t=5381,n=e.length;for(;n;)t=33*t^e.charCodeAt(--n);return t>>>0}(a):"")+")"}(e,e.scopedSlots,t)+","),e.model&&(n+="model:{value:"+e.model.value+",callback:"+e.model.callback+",expression:"+e.model.expression+"},"),e.inlineTemplate){var o=function(e,t){var n=e.children[0];if(n&&1===n.type){var r=Pa(n,t.options);return"inlineTemplate:{render:function(){"+r.render+"},staticRenderFns:["+r.staticRenderFns.map(function(e){return"function(){"+e+"}"}).join(",")+"]}"}}(e,t);o&&(n+=o+",")}return n=n.replace(/,$/,"")+"}",e.dynamicAttrs&&(n="_b("+n+',"'+e.tag+'",'+Ga(e.dynamicAttrs)+")"),e.wrapData&&(n=e.wrapData(n)),e.wrapListeners&&(n=e.wrapListeners(n)),n}function Ka(e){return 1===e.type&&("slot"===e.tag||e.children.some(Ka))}function Ja(e,t){var n=e.attrsMap["slot-scope"];if(e.if&&!e.ifProcessed&&!n)return Ua(e,t,Ja,"null");if(e.for&&!e.forProcessed)return za(e,t,Ja);var r=e.slotScope===ca?"":String(e.slotScope),i="function("+r+"){return "+("template"===e.tag?e.if&&n?"("+e.if+")?"+(qa(e,t)||"undefined")+":undefined":qa(e,t)||"undefined":Ra(e,t))+"}",o=r?"":",proxy:true";return"{key:"+(e.slotTarget||'"default"')+",fn:"+i+o+"}"}function qa(e,t,n,r,i){var o=e.children;if(o.length){var a=o[0];if(1===o.length&&a.for&&"template"!==a.tag&&"slot"!==a.tag){var s=n?t.maybeComponent(a)?",1":",0":"";return""+(r||Ra)(a,t)+s}var c=n?function(e,t){for(var n=0,r=0;r<e.length;r++){var i=e[r];if(1===i.type){if(Wa(i)||i.ifConditions&&i.ifConditions.some(function(e){return Wa(e.block)})){n=2;break}(t(i)||i.ifConditions&&i.ifConditions.some(function(e){return t(e.block)}))&&(n=1)}}return n}(o,t.maybeComponent):0,u=i||Za;return"["+o.map(function(e){return u(e,t)}).join(",")+"]"+(c?","+c:"")}}function Wa(e){return void 0!==e.for||"template"===e.tag||"slot"===e.tag}function Za(e,t){return 1===e.type?Ra(e,t):3===e.type&&e.isComment?(r=e,"_e("+JSON.stringify(r.text)+")"):"_v("+(2===(n=e).type?n.expression:Xa(JSON.stringify(n.text)))+")";var n,r}function Ga(e){for(var t="",n="",r=0;r<e.length;r++){var i=e[r],o=Xa(i.value);i.dynamic?n+=i.name+","+o+",":t+='"'+i.name+'":'+o+","}return t="{"+t.slice(0,-1)+"}",n?"_d("+t+",["+n.slice(0,-1)+"])":t}function Xa(e){return e.replace(/\u2028/g,"\\u2028").replace(/\u2029/g,"\\u2029")}new RegExp("\\b"+"do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,super,throw,while,yield,delete,export,import,return,switch,default,extends,finally,continue,debugger,function,arguments".split(",").join("\\b|\\b")+"\\b");function Ya(e,t){try{return new Function(e)}catch(n){return t.push({err:n,code:e}),S}}function Qa(e){var t=Object.create(null);return function(n,r,i){(r=A({},r)).warn;delete r.warn;var o=r.delimiters?String(r.delimiters)+n:n;if(t[o])return t[o];var a=e(n,r),s={},c=[];return s.render=Ya(a.render,c),s.staticRenderFns=a.staticRenderFns.map(function(e){return Ya(e,c)}),t[o]=s}}var es,ts,ns=(es=function(e,t){var n=la(e.trim(),t);!1!==t.optimize&&ka(n,t);var r=Pa(n,t);return{ast:n,render:r.render,staticRenderFns:r.staticRenderFns}},function(e){function t(t,n){var r=Object.create(e),i=[],o=[];if(n)for(var a in n.modules&&(r.modules=(e.modules||[]).concat(n.modules)),n.directives&&(r.directives=A(Object.create(e.directives||null),n.directives)),n)"modules"!==a&&"directives"!==a&&(r[a]=n[a]);r.warn=function(e,t,n){(n?o:i).push(e)};var s=es(t.trim(),r);return s.errors=i,s.tips=o,s}return{compile:t,compileToFunctions:Qa(t)}})(Ca),rs=(ns.compile,ns.compileToFunctions);function is(e){return(ts=ts||document.createElement("div")).innerHTML=e?'<a href="\n"/>':'<div a="\n"/>',ts.innerHTML.indexOf("&#10;")>0}var os=!!z&&is(!1),as=!!z&&is(!0),ss=g(function(e){var t=Yn(e);return t&&t.innerHTML}),cs=wn.prototype.$mount;wn.prototype.$mount=function(e,t){if((e=e&&Yn(e))===document.body||e===document.documentElement)return this;var n=this.$options;if(!n.render){var r=n.template;if(r)if("string"==typeof r)"#"===r.charAt(0)&&(r=ss(r));else{if(!r.nodeType)return this;r=r.innerHTML}else e&&(r=function(e){if(e.outerHTML)return e.outerHTML;var t=document.createElement("div");return t.appendChild(e.cloneNode(!0)),t.innerHTML}(e));if(r){var i=rs(r,{outputSourceRange:!1,shouldDecodeNewlines:os,shouldDecodeNewlinesForHref:as,delimiters:n.delimiters,comments:n.comments},this),o=i.render,a=i.staticRenderFns;n.render=o,n.staticRenderFns=a}}return cs.call(this,e,t)},wn.compile=rs,module.exports=wn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(447).setImmediate))

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.withParams = exports.validationMixin = exports.Vuelidate = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vval = __webpack_require__(610);
	
	var _params = __webpack_require__(223);
	
	var NUL = function NUL() {
	  return null;
	};
	
	var buildFromKeys = function buildFromKeys(keys, fn, keyFn) {
	  return keys.reduce(function (build, key) {
	    build[keyFn ? keyFn(key) : key] = fn(key);
	    return build;
	  }, {});
	};
	
	function isFunction(val) {
	  return typeof val === 'function';
	}
	
	function isObject(val) {
	  return val !== null && (typeof val === 'object' || isFunction(val));
	}
	
	function isPromise(object) {
	  return isObject(object) && isFunction(object.then);
	}
	
	var getPath = function getPath(ctx, obj, path, fallback) {
	  if (typeof path === 'function') {
	    return path.call(ctx, obj, fallback);
	  }
	
	  path = Array.isArray(path) ? path : path.split('.');
	  for (var i = 0; i < path.length; i++) {
	    if (obj && typeof obj === 'object') {
	      obj = obj[path[i]];
	    } else {
	      return fallback;
	    }
	  }
	
	  return typeof obj === 'undefined' ? fallback : obj;
	};
	
	var __isVuelidateAsyncVm = '__isVuelidateAsyncVm';
	function makePendingAsyncVm(Vue, promise) {
	  var asyncVm = new Vue({
	    data: {
	      p: true, // pending
	      v: false // value
	    }
	  });
	
	  promise.then(function (value) {
	    asyncVm.p = false;
	    asyncVm.v = value;
	  }, function (error) {
	    asyncVm.p = false;
	    asyncVm.v = false;
	    throw error;
	  });
	
	  asyncVm[__isVuelidateAsyncVm] = true;
	  return asyncVm;
	}
	
	var validationGetters = {
	  $invalid: function $invalid() {
	    var _this = this;
	
	    var proxy = this.proxy;
	    return this.nestedKeys.some(function (nested) {
	      return _this.refProxy(nested).$invalid;
	    }) || this.ruleKeys.some(function (rule) {
	      return !proxy[rule];
	    });
	  },
	  $dirty: function $dirty() {
	    var _this2 = this;
	
	    if (this.dirty) {
	      return true;
	    }
	    if (this.nestedKeys.length === 0) {
	      return false;
	    }
	
	    return this.nestedKeys.every(function (key) {
	      return _this2.refProxy(key).$dirty;
	    });
	  },
	  $error: function $error() {
	    return this.$dirty && !this.$pending && this.$invalid;
	  },
	  $pending: function $pending() {
	    var _this3 = this;
	
	    return this.ruleKeys.some(function (key) {
	      return _this3.getRef(key).$pending;
	    }) || this.nestedKeys.some(function (key) {
	      return _this3.refProxy(key).$pending;
	    });
	  },
	  $params: function $params() {
	    var _this4 = this;
	
	    var vals = this.validations;
	    return _extends({}, buildFromKeys(this.nestedKeys, function (key) {
	      return vals[key] && vals[key].$params || null;
	    }), buildFromKeys(this.ruleKeys, function (key) {
	      return _this4.getRef(key).$params;
	    }));
	  }
	};
	
	function setDirtyRecursive(newState) {
	  this.dirty = newState;
	  var proxy = this.proxy;
	  var method = newState ? '$touch' : '$reset';
	  this.nestedKeys.forEach(function (key) {
	    proxy[key][method]();
	  });
	}
	
	var validationMethods = {
	  $touch: function $touch() {
	    setDirtyRecursive.call(this, true);
	  },
	  $reset: function $reset() {
	    setDirtyRecursive.call(this, false);
	  },
	  $flattenParams: function $flattenParams() {
	    var proxy = this.proxy;
	    var params = [];
	    for (var key in this.$params) {
	      if (this.isNested(key)) {
	        var childParams = proxy[key].$flattenParams();
	        for (var j = 0; j < childParams.length; j++) {
	          childParams[j].path.unshift(key);
	        }
	        params = params.concat(childParams);
	      } else {
	        params.push({ path: [], name: key, params: this.$params[key] });
	      }
	    }
	    return params;
	  }
	};
	
	var getterNames = Object.keys(validationGetters);
	var methodNames = Object.keys(validationMethods);
	
	var _cachedComponent = null;
	var getComponent = function getComponent(Vue) {
	  if (_cachedComponent) {
	    return _cachedComponent;
	  }
	
	  var VBase = Vue.extend({
	    beforeCreate: function beforeCreate() {
	      this._vval = null;
	    },
	    beforeDestroy: function beforeDestroy() {
	      if (this._vval) {
	        (0, _vval.patchChildren)(this._vval);
	      }
	    },
	
	    methods: {
	      getModel: function getModel() {
	        return this.lazyModel ? this.lazyModel(this.prop) : this.model;
	      },
	      getModelKey: function getModelKey(key) {
	        var model = this.getModel();
	        if (model) {
	          return model[key];
	        }
	      }
	    },
	    computed: {
	      refs: function refs() {
	        var oldVval = this._vval;
	        this._vval = this.children;
	        (0, _vval.patchChildren)(oldVval, this._vval);
	        var refs = {};
	        this._vval.forEach(function (c) {
	          refs[c.key] = c.vm;
	        });
	        return refs;
	      }
	    }
	  });
	
	  var ValidationRule = VBase.extend({
	    data: function data() {
	      return {
	        rule: null,
	        lazyModel: null,
	        model: null,
	        lazyParentModel: null,
	        rootModel: null
	      };
	    },
	
	    methods: {
	      runRule: function runRule(parent) {
	        // Avoid using this.lazyParentModel to not get dependent on it.
	        // Passed as an argument for workaround
	        var model = this.getModel();
	        (0, _params.pushParams)();
	        var rawOutput = this.rule.call(this.rootModel, model, parent);
	        var output = isPromise(rawOutput) ? makePendingAsyncVm(Vue, rawOutput) : rawOutput;
	
	        var rawParams = (0, _params.popParams)();
	        var params = rawParams && rawParams.$sub ? rawParams.$sub.length > 1 ? rawParams : rawParams.$sub[0] : null;
	
	        return { output: output, params: params };
	      }
	    },
	    computed: {
	      run: function run() {
	        return this.runRule(this.lazyParentModel());
	      },
	      $params: function $params() {
	        return this.run.params;
	      },
	      proxy: function proxy() {
	        var output = this.run.output;
	        if (output[__isVuelidateAsyncVm]) {
	          return !!output.v;
	        }
	        return !!output;
	      },
	      $pending: function $pending() {
	        var output = this.run.output;
	        if (output[__isVuelidateAsyncVm]) {
	          return output.p;
	        }
	        return false;
	      }
	    }
	  });
	
	  var Validation = VBase.extend({
	    data: function data() {
	      return {
	        dirty: false,
	        validations: null,
	        lazyModel: null,
	        model: null,
	        prop: null,
	        lazyParentModel: null,
	        rootModel: null
	      };
	    },
	
	    methods: _extends({}, validationMethods, {
	      refProxy: function refProxy(key) {
	        return this.getRef(key).proxy;
	      },
	      getRef: function getRef(key) {
	        return this.refs[key];
	      },
	      isNested: function isNested(key) {
	        return typeof this.validations[key] !== 'function';
	      }
	    }),
	    computed: _extends({}, validationGetters, {
	      nestedKeys: function nestedKeys() {
	        return this.keys.filter(this.isNested);
	      },
	      ruleKeys: function ruleKeys() {
	        var _this5 = this;
	
	        return this.keys.filter(function (k) {
	          return !_this5.isNested(k);
	        });
	      },
	      keys: function keys() {
	        return Object.keys(this.validations).filter(function (k) {
	          return k !== '$params';
	        });
	      },
	      proxy: function proxy() {
	        var _this6 = this;
	
	        var keyDefs = buildFromKeys(this.keys, function (key) {
	          return {
	            enumerable: true,
	            configurable: true, // allow mocking lib calls
	            get: function get() {
	              return _this6.refProxy(key);
	            }
	          };
	        });
	
	        var getterDefs = buildFromKeys(getterNames, function (key) {
	          return {
	            enumerable: true,
	            configurable: true,
	            get: function get() {
	              return _this6[key];
	            }
	          };
	        });
	
	        var methodDefs = buildFromKeys(methodNames, function (key) {
	          return {
	            enumerable: false,
	            configurable: true,
	            get: function get() {
	              return _this6[key];
	            }
	          };
	        });
	
	        return Object.defineProperties({}, _extends({}, keyDefs, getterDefs, methodDefs));
	      },
	      children: function children() {
	        var _this7 = this;
	
	        return [].concat(this.nestedKeys.map(function (key) {
	          return renderNested(_this7, key);
	        }), this.ruleKeys.map(function (key) {
	          return renderRule(_this7, key);
	        })).filter(Boolean);
	      }
	    })
	  });
	
	  var GroupValidation = Validation.extend({
	    methods: {
	      isNested: function isNested(key) {
	        return typeof this.validations[key]() !== 'undefined';
	      },
	      getRef: function getRef(key) {
	        var vm = this;
	        return {
	          get proxy() {
	            // default to invalid
	            return vm.validations[key]() || false;
	          }
	        };
	      }
	    }
	  });
	
	  var EachValidation = Validation.extend({
	    computed: {
	      keys: function keys() {
	        var model = this.getModel();
	        if (isObject(model)) {
	          return Object.keys(model);
	        } else {
	          return [];
	        }
	      },
	      tracker: function tracker() {
	        var _this8 = this;
	
	        var trackBy = this.validations.$trackBy;
	        return trackBy ? function (key) {
	          return '' + getPath(_this8.rootModel, _this8.getModelKey(key), trackBy);
	        } : function (x) {
	          return '' + x;
	        };
	      },
	      eagerParentModel: function eagerParentModel() {
	        var parent = this.lazyParentModel();
	        return function () {
	          return parent;
	        };
	      },
	      children: function children() {
	        var _this9 = this;
	
	        var def = this.validations;
	        var model = this.getModel();
	
	        var validations = _extends({}, def);
	        delete validations['$trackBy'];
	
	        var usedTracks = {};
	
	        return this.keys.map(function (key) {
	          var track = _this9.tracker(key);
	          if (usedTracks.hasOwnProperty(track)) {
	            return null;
	          }
	          usedTracks[track] = true;
	          return (0, _vval.h)(Validation, track, {
	            validations: validations,
	            prop: key,
	            lazyParentModel: _this9.eagerParentModel,
	            model: model[key],
	            rootModel: _this9.rootModel
	          });
	        }).filter(Boolean);
	      }
	    },
	    methods: {
	      isNested: function isNested() {
	        return true;
	      },
	      getRef: function getRef(key) {
	        return this.refs[this.tracker(key)];
	      }
	    }
	  });
	
	  var renderNested = function renderNested(vm, key) {
	    if (key === '$each') {
	      return (0, _vval.h)(EachValidation, key, {
	        validations: vm.validations[key],
	        lazyParentModel: vm.lazyParentModel,
	        prop: key,
	        lazyModel: vm.getModel,
	        rootModel: vm.rootModel
	      });
	    }
	    var validations = vm.validations[key];
	    if (Array.isArray(validations)) {
	      var root = vm.rootModel;
	      var refVals = buildFromKeys(validations, function (path) {
	        return function () {
	          return getPath(root, root.$v, path);
	        };
	      }, function (v) {
	        return Array.isArray(v) ? v.join('.') : v;
	      });
	      return (0, _vval.h)(GroupValidation, key, {
	        validations: refVals,
	        lazyParentModel: NUL,
	        prop: key,
	        lazyModel: NUL,
	        rootModel: root
	      });
	    }
	    return (0, _vval.h)(Validation, key, {
	      validations: validations,
	      lazyParentModel: vm.getModel,
	      prop: key,
	      lazyModel: vm.getModelKey,
	      rootModel: vm.rootModel
	    });
	  };
	
	  var renderRule = function renderRule(vm, key) {
	    return (0, _vval.h)(ValidationRule, key, {
	      rule: vm.validations[key],
	      lazyParentModel: vm.lazyParentModel,
	      lazyModel: vm.getModel,
	      rootModel: vm.rootModel
	    });
	  };
	
	  _cachedComponent = { VBase: VBase, Validation: Validation };
	  return _cachedComponent;
	};
	
	var _cachedVue = null;
	function getVue(rootVm) {
	  if (_cachedVue) return _cachedVue;
	  var Vue = rootVm.constructor;
	  /* istanbul ignore next */
	  while (Vue.super) {
	    Vue = Vue.super;
	  }_cachedVue = Vue;
	  return Vue;
	}
	
	var validateModel = function validateModel(model, validations) {
	  var Vue = getVue(model);
	
	  var _getComponent = getComponent(Vue),
	      Validation = _getComponent.Validation,
	      VBase = _getComponent.VBase;
	
	  var root = new VBase({
	    computed: {
	      children: function children() {
	        var vals = typeof validations === 'function' ? validations.call(model) : validations;
	
	        return [(0, _vval.h)(Validation, '$v', {
	          validations: vals,
	          lazyParentModel: NUL,
	          prop: '$v',
	          model: model,
	          rootModel: model
	        })];
	      }
	    }
	  });
	  return root;
	};
	
	var validationMixin = {
	  data: function data() {
	    var vals = this.$options.validations;
	    if (vals) {
	      this._vuelidate = validateModel(this, vals);
	    }
	    return {};
	  },
	  beforeCreate: function beforeCreate() {
	    var options = this.$options;
	    var vals = options.validations;
	    if (!vals) return;
	    if (!options.computed) options.computed = {};
	    if (options.computed.$v) return;
	    options.computed.$v = function () {
	      return this._vuelidate ? this._vuelidate.refs.$v.proxy : null;
	    };
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this._vuelidate) {
	      this._vuelidate.$destroy();
	      this._vuelidate = null;
	    }
	  }
	};
	
	function Vuelidate(Vue) {
	  Vue.mixin(validationMixin);
	}
	
	exports.Vuelidate = Vuelidate;
	exports.validationMixin = validationMixin;
	exports.withParams = _params.withParams;
	exports.default = Vuelidate;

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _common = __webpack_require__(12);
	
	exports.default = (0, _common.regex)('alpha', /^[a-zA-Z]*$/);

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _common = __webpack_require__(12);
	
	exports.default = (0, _common.regex)('alphaNum', /^[a-zA-Z0-9]*$/);

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _common = __webpack_require__(12);
	
	exports.default = function () {
	  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
	    validators[_key] = arguments[_key];
	  }
	
	  return (0, _common.withParams)({ type: 'and' }, function () {
	    var _this = this;
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return validators.length > 0 && validators.reduce(function (valid, fn) {
	      return valid && fn.apply(_this, args);
	    }, true);
	  });
	};

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _common = __webpack_require__(12);
	
	exports.default = function (min, max) {
	  return (0, _common.withParams)({ type: 'between', min: min, max: max }, function (value) {
	    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +min <= +value && +max >= +value;
	  });
	};

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _common = __webpack_require__(12);
	
	var emailRegex = /(^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/;
	
	exports.default = (0, _common.regex)('email', emailRegex);

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _common = __webpack_require__(12);
	
	exports.default = (0, _common.withParams)({ type: 'ipAddress' }, function (value) {
	  if (!(0, _common.req)(value)) {
	    return true;
	  }
	
	  if (typeof value !== 'string') {
	    return false;
	  }
	
	  var nibbles = value.split('.');
	  return nibbles.length === 4 && nibbles.every(nibbleValid);
	});
	
	
	var nibbleValid = function nibbleValid(nibble) {
	  if (nibble.length > 3 || nibble.length === 0) {
	    return false;
	  }
	
	  if (nibble[0] === '0' && nibble !== '0') {
	    return false;
	  }
	
	  if (!nibble.match(/^\d+$/)) {
	    return false;
	  }
	
	  var numeric = +nibble | 0;
	  return numeric >= 0 && numeric <= 255;
	};

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _common = __webpack_require__(12);
	
	exports.default = function () {
	  var separator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ':';
	  return (0, _common.withParams)({ type: 'macAddress' }, function (value) {
	    if (!(0, _common.req)(value)) {
	      return true;
	    }
	
	    if (typeof value !== 'string') {
	      return false;
	    }
	
	    var parts = typeof separator === 'string' && separator !== '' ? value.split(separator) : value.length === 12 || value.length === 16 ? value.match(/.{2}/g) : null;
	
	    return parts !== null && (parts.length === 6 || parts.length === 8) && parts.every(hexValid);
	  });
	};
	
	var hexValid = function hexValid(hex) {
	  return hex.toLowerCase().match(/^[0-9a-f]{2}$/);
	};

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _common = __webpack_require__(12);
	
	exports.default = function (length) {
	  return (0, _common.withParams)({ type: 'maxLength', max: length }, function (value) {
	    return !(0, _common.req)(value) || (0, _common.len)(value) <= length;
	  });
	};

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _common = __webpack_require__(12);
	
	exports.default = function (max) {
	  return (0, _common.withParams)({ type: 'maxValue', max: max }, function (value) {
	    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value <= +max;
	  });
	};

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _common = __webpack_require__(12);
	
	exports.default = function (length) {
	  return (0, _common.withParams)({ type: 'minLength', min: length }, function (value) {
	    return !(0, _common.req)(value) || (0, _common.len)(value) >= length;
	  });
	};

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _common = __webpack_require__(12);
	
	exports.default = function (min) {
	  return (0, _common.withParams)({ type: 'minValue', min: min }, function (value) {
	    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value >= +min;
	  });
	};

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _common = __webpack_require__(12);
	
	exports.default = (0, _common.regex)('numeric', /^[0-9]*$/);

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _common = __webpack_require__(12);
	
	exports.default = function () {
	  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
	    validators[_key] = arguments[_key];
	  }
	
	  return (0, _common.withParams)({ type: 'or' }, function () {
	    var _this = this;
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return validators.length > 0 && validators.reduce(function (valid, fn) {
	      return valid || fn.apply(_this, args);
	    }, false);
	  });
	};

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _common = __webpack_require__(12);
	
	exports.default = (0, _common.withParams)({ type: 'required' }, _common.req);

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _common = __webpack_require__(12);
	
	exports.default = function (prop) {
	  return (0, _common.withParams)({ type: 'requiredIf', prop: prop }, function (value, parentVm) {
	    return (0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
	  });
	};

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _common = __webpack_require__(12);
	
	exports.default = function (prop) {
	  return (0, _common.withParams)({ type: 'requiredUnless', prop: prop }, function (value, parentVm) {
	    return !(0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
	  });
	};

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _common = __webpack_require__(12);
	
	exports.default = function (equalTo) {
	  return (0, _common.withParams)({ type: 'sameAs', eq: equalTo }, function (value, parentVm) {
	    return value === (0, _common.ref)(equalTo, this, parentVm);
	  });
	};

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _common = __webpack_require__(12);
	
	var urlRegex = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;
	
	exports.default = (0, _common.regex)('url', urlRegex);

/***/ }),
/* 610 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.patchChildren = patchChildren;
	exports.h = h;
	// a minimial single-layer implementation
	// of virtual-validation patching,
	// based on Vue's snabbdom clone
	
	function isUndef(v) {
	  return v === null || v === undefined;
	}
	
	function isDef(v) {
	  return v !== null && v !== undefined;
	}
	
	function sameVval(oldVval, vval) {
	  return vval.tag === oldVval.tag && vval.key === oldVval.key;
	}
	
	function createVm(vval) {
	  var Vm = vval.tag;
	  vval.vm = new Vm({ data: vval.args });
	}
	
	function updateVval(vval) {
	  var keys = Object.keys(vval.args);
	  for (var i = 0; i < keys.length; i++) {
	    keys.forEach(function (k) {
	      vval.vm[k] = vval.args[k];
	    });
	  }
	}
	
	function createKeyToOldIdx(children, beginIdx, endIdx) {
	  var i = void 0,
	      key = void 0;
	  var map = {};
	  for (i = beginIdx; i <= endIdx; ++i) {
	    key = children[i].key;
	    if (isDef(key)) map[key] = i;
	  }
	  return map;
	}
	
	function updateChildren(oldCh, newCh) {
	  var oldStartIdx = 0;
	  var newStartIdx = 0;
	  var oldEndIdx = oldCh.length - 1;
	  var oldStartVval = oldCh[0];
	  var oldEndVval = oldCh[oldEndIdx];
	  var newEndIdx = newCh.length - 1;
	  var newStartVval = newCh[0];
	  var newEndVval = newCh[newEndIdx];
	  var oldKeyToIdx = void 0,
	      idxInOld = void 0,
	      elmToMove = void 0;
	
	  while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
	    if (isUndef(oldStartVval)) {
	      oldStartVval = oldCh[++oldStartIdx]; // Vval has been moved left
	    } else if (isUndef(oldEndVval)) {
	      oldEndVval = oldCh[--oldEndIdx];
	    } else if (sameVval(oldStartVval, newStartVval)) {
	      patchVval(oldStartVval, newStartVval);
	      oldStartVval = oldCh[++oldStartIdx];
	      newStartVval = newCh[++newStartIdx];
	    } else if (sameVval(oldEndVval, newEndVval)) {
	      patchVval(oldEndVval, newEndVval);
	      oldEndVval = oldCh[--oldEndIdx];
	      newEndVval = newCh[--newEndIdx];
	    } else if (sameVval(oldStartVval, newEndVval)) {
	      // Vval moved right
	      patchVval(oldStartVval, newEndVval);
	      oldStartVval = oldCh[++oldStartIdx];
	      newEndVval = newCh[--newEndIdx];
	    } else if (sameVval(oldEndVval, newStartVval)) {
	      // Vval moved left
	      patchVval(oldEndVval, newStartVval);
	      oldEndVval = oldCh[--oldEndIdx];
	      newStartVval = newCh[++newStartIdx];
	    } else {
	      if (isUndef(oldKeyToIdx)) oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx);
	      idxInOld = isDef(newStartVval.key) ? oldKeyToIdx[newStartVval.key] : null;
	      if (isUndef(idxInOld)) {
	        // New element
	        createVm(newStartVval);
	        newStartVval = newCh[++newStartIdx];
	      } else {
	        elmToMove = oldCh[idxInOld];
	        if (sameVval(elmToMove, newStartVval)) {
	          patchVval(elmToMove, newStartVval);
	          oldCh[idxInOld] = undefined;
	          newStartVval = newCh[++newStartIdx];
	        } else {
	          // same key but different element. treat as new element
	          createVm(newStartVval);
	          newStartVval = newCh[++newStartIdx];
	        }
	      }
	    }
	  }
	  if (oldStartIdx > oldEndIdx) {
	    addVvals(newCh, newStartIdx, newEndIdx);
	  } else if (newStartIdx > newEndIdx) {
	    removeVvals(oldCh, oldStartIdx, oldEndIdx);
	  }
	}
	
	function addVvals(vvals, startIdx, endIdx) {
	  for (; startIdx <= endIdx; ++startIdx) {
	    createVm(vvals[startIdx]);
	  }
	}
	
	function removeVvals(vvals, startIdx, endIdx) {
	  for (; startIdx <= endIdx; ++startIdx) {
	    var ch = vvals[startIdx];
	    if (isDef(ch)) {
	      ch.vm.$destroy();
	      ch.vm = null;
	    }
	  }
	}
	
	function patchVval(oldVval, vval) {
	  if (oldVval === vval) {
	    return;
	  }
	  vval.vm = oldVval.vm;
	  updateVval(vval);
	}
	
	function patchChildren(oldCh, ch) {
	  if (isDef(oldCh) && isDef(ch)) {
	    if (oldCh !== ch) updateChildren(oldCh, ch);
	  } else if (isDef(ch)) {
	    addVvals(ch, 0, ch.length - 1);
	  } else if (isDef(oldCh)) {
	    removeVvals(oldCh, 0, oldCh.length - 1);
	  }
	}
	
	function h(tag, key, args) {
	  return { tag: tag, key: key, args: args };
	}

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* istanbul ignore next */
	var withParams =  false ? require('./withParamsBrowser').withParams : __webpack_require__(223).withParams;
	
	exports.default = withParams;

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(26));
		else if(typeof define === 'function' && define.amd)
			define(["vue"], factory);
		else if(typeof exports === 'object')
			exports["Vuetify"] = factory(require("vue"));
		else
			root["Vuetify"] = factory(root["Vue"]);
	})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_vue__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = "./src/index.ts");
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ "./src/components/VAlert/VAlert.ts":
	/*!*****************************************!*\
	  !*** ./src/components/VAlert/VAlert.ts ***!
	  \*****************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_alerts_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_alerts.styl */ "./src/stylus/components/_alerts.styl");
	/* harmony import */ var _stylus_components_alerts_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_alerts_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _VIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../VIcon */ "./src/components/VIcon/index.ts");
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _mixins_toggleable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/toggleable */ "./src/mixins/toggleable.ts");
	/* harmony import */ var _mixins_transitionable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mixins/transitionable */ "./src/mixins/transitionable.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	// Styles
	
	// Components
	
	// Mixins
	
	
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_5__["default"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_2__["default"], _mixins_toggleable__WEBPACK_IMPORTED_MODULE_3__["default"], _mixins_transitionable__WEBPACK_IMPORTED_MODULE_4__["default"]).extend({
	    name: 'v-alert',
	    props: {
	        dismissible: Boolean,
	        icon: String,
	        outline: Boolean,
	        type: {
	            type: String,
	            validator: function validator(val) {
	                return ['info', 'error', 'success', 'warning'].includes(val);
	            }
	        }
	    },
	    computed: {
	        computedColor: function computedColor() {
	            return this.type && !this.color ? this.type : this.color || 'error';
	        },
	        computedIcon: function computedIcon() {
	            if (this.icon || !this.type) return this.icon;
	            switch (this.type) {
	                case 'info':
	                    return '$vuetify.icons.info';
	                case 'error':
	                    return '$vuetify.icons.error';
	                case 'success':
	                    return '$vuetify.icons.success';
	                case 'warning':
	                    return '$vuetify.icons.warning';
	            }
	        }
	    },
	    methods: {
	        genIcon: function genIcon() {
	            if (!this.computedIcon) return null;
	            return this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_1__["default"], {
	                'class': 'v-alert__icon'
	            }, this.computedIcon);
	        },
	        genDismissible: function genDismissible() {
	            var _this = this;
	            if (!this.dismissible) return null;
	            return this.$createElement('a', {
	                'class': 'v-alert__dismissible',
	                on: { click: function click() {
	                        _this.isActive = false;
	                    } }
	            }, [this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_1__["default"], {
	                props: {
	                    right: true
	                }
	            }, '$vuetify.icons.cancel')]);
	        }
	    },
	    render: function render(h) {
	        var children = [this.genIcon(), h('div', this.$slots.default), this.genDismissible()];
	        var setColor = this.outline ? this.setTextColor : this.setBackgroundColor;
	        var alert = h('div', setColor(this.computedColor, {
	            staticClass: 'v-alert',
	            'class': {
	                'v-alert--outline': this.outline
	            },
	            directives: [{
	                name: 'show',
	                value: this.isActive
	            }],
	            on: this.$listeners
	        }), children);
	        if (!this.transition) return alert;
	        return h('transition', {
	            props: {
	                name: this.transition,
	                origin: this.origin,
	                mode: this.mode
	            }
	        }, [alert]);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VAlert/index.ts":
	/*!****************************************!*\
	  !*** ./src/components/VAlert/index.ts ***!
	  \****************************************/
	/*! exports provided: VAlert, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VAlert__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VAlert */ "./src/components/VAlert/VAlert.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VAlert", function() { return _VAlert__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VAlert__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VApp/VApp.js":
	/*!*************************************!*\
	  !*** ./src/components/VApp/VApp.js ***!
	  \*************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_app_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_app.styl */ "./src/stylus/components/_app.styl");
	/* harmony import */ var _stylus_components_app_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_app_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_app_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./mixins/app-theme */ "./src/components/VApp/mixins/app-theme.js");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _directives_resize__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../directives/resize */ "./src/directives/resize.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	
	// Component level mixins
	
	
	// Directives
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-app',
	    directives: {
	        Resize: _directives_resize__WEBPACK_IMPORTED_MODULE_3__["default"]
	    },
	    mixins: [_mixins_app_theme__WEBPACK_IMPORTED_MODULE_1__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__["default"]],
	    props: {
	        id: {
	            type: String,
	            default: 'app'
	        },
	        dark: Boolean
	    },
	    computed: {
	        classes: function classes() {
	            return __assign({ 'application--is-rtl': this.$vuetify.rtl }, this.themeClasses);
	        }
	    },
	    watch: {
	        dark: function dark() {
	            this.$vuetify.dark = this.dark;
	        }
	    },
	    mounted: function mounted() {
	        this.$vuetify.dark = this.dark;
	    },
	    render: function render(h) {
	        var data = {
	            staticClass: 'application',
	            'class': this.classes,
	            attrs: { 'data-app': true },
	            domProps: { id: this.id }
	        };
	        var wrapper = h('div', { staticClass: 'application--wrap' }, this.$slots.default);
	        return h('div', data, [wrapper]);
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VApp/index.js":
	/*!**************************************!*\
	  !*** ./src/components/VApp/index.js ***!
	  \**************************************/
	/*! exports provided: VApp, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VApp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VApp */ "./src/components/VApp/VApp.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VApp", function() { return _VApp__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VApp__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VApp/mixins/app-theme.js":
	/*!*************************************************!*\
	  !*** ./src/components/VApp/mixins/app-theme.js ***!
	  \*************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _util_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../util/theme */ "./src/util/theme.ts");
	
	/* harmony default export */ __webpack_exports__["default"] = ({
	    data: function data() {
	        return {
	            style: null
	        };
	    },
	    computed: {
	        parsedTheme: function parsedTheme() {
	            return _util_theme__WEBPACK_IMPORTED_MODULE_0__["parse"](this.$vuetify.theme);
	        },
	        /** @return string */
	        generatedStyles: function generatedStyles() {
	            var theme = this.parsedTheme;
	            var css;
	            if (this.$vuetify.options.themeCache != null) {
	                css = this.$vuetify.options.themeCache.get(theme);
	                if (css != null) return css;
	            }
	            css = _util_theme__WEBPACK_IMPORTED_MODULE_0__["genStyles"](theme, this.$vuetify.options.customProperties);
	            if (this.$vuetify.options.minifyTheme != null) {
	                css = this.$vuetify.options.minifyTheme(css);
	            }
	            if (this.$vuetify.options.themeCache != null) {
	                this.$vuetify.options.themeCache.set(theme, css);
	            }
	            return css;
	        },
	        vueMeta: function vueMeta() {
	            if (this.$vuetify.theme === false) return {};
	            var options = {
	                cssText: this.generatedStyles,
	                id: 'vuetify-theme-stylesheet',
	                type: 'text/css'
	            };
	            if (this.$vuetify.options.cspNonce) {
	                options.nonce = this.$vuetify.options.cspNonce;
	            }
	            return {
	                style: [options]
	            };
	        }
	    },
	    // Regular vue-meta
	    metaInfo: function metaInfo() {
	        return this.vueMeta;
	    },
	    // Nuxt
	    head: function head() {
	        return this.vueMeta;
	    },
	    watch: {
	        generatedStyles: function generatedStyles() {
	            !this.meta && this.applyTheme();
	        }
	    },
	    created: function created() {
	        if (this.$vuetify.theme === false) return;
	        if (this.$meta) {
	            // Vue-meta
	            // Handled by metaInfo()/nuxt()
	        } else if (typeof document === 'undefined' && this.$ssrContext) {
	            // SSR
	            var nonce = this.$vuetify.options.cspNonce ? " nonce=\"" + this.$vuetify.options.cspNonce + "\"" : '';
	            this.$ssrContext.head = this.$ssrContext.head || '';
	            this.$ssrContext.head += "<style type=\"text/css\" id=\"vuetify-theme-stylesheet\"" + nonce + ">" + this.generatedStyles + "</style>";
	        } else if (typeof document !== 'undefined') {
	            // Client-side
	            this.genStyle();
	            this.applyTheme();
	        }
	    },
	    methods: {
	        applyTheme: function applyTheme() {
	            if (this.style) this.style.innerHTML = this.generatedStyles;
	        },
	        genStyle: function genStyle() {
	            var style = document.getElementById('vuetify-theme-stylesheet');
	            if (!style) {
	                style = document.createElement('style');
	                style.type = 'text/css';
	                style.id = 'vuetify-theme-stylesheet';
	                if (this.$vuetify.options.cspNonce) {
	                    style.setAttribute('nonce', this.$vuetify.options.cspNonce);
	                }
	                document.head.appendChild(style);
	            }
	            this.style = style;
	        }
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VAutocomplete/VAutocomplete.js":
	/*!*******************************************************!*\
	  !*** ./src/components/VAutocomplete/VAutocomplete.js ***!
	  \*******************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_autocompletes_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_autocompletes.styl */ "./src/stylus/components/_autocompletes.styl");
	/* harmony import */ var _stylus_components_autocompletes_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_autocompletes_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../VSelect/VSelect */ "./src/components/VSelect/VSelect.js");
	/* harmony import */ var _VTextField_VTextField__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../VTextField/VTextField */ "./src/components/VTextField/VTextField.js");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	// Styles
	
	// Extensions
	
	
	// Utils
	
	var defaultMenuProps = __assign({}, _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["defaultMenuProps"], { offsetY: true, offsetOverflow: true, transition: false });
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (_VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].extend({
	    name: 'v-autocomplete',
	    props: {
	        allowOverflow: {
	            type: Boolean,
	            default: true
	        },
	        browserAutocomplete: {
	            type: String,
	            default: 'off'
	        },
	        filter: {
	            type: Function,
	            default: function _default(item, queryText, itemText) {
	                return itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1;
	            }
	        },
	        hideNoData: Boolean,
	        noFilter: Boolean,
	        searchInput: {
	            default: undefined
	        },
	        menuProps: {
	            type: _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].options.props.menuProps.type,
	            default: function _default() {
	                return defaultMenuProps;
	            }
	        },
	        autoSelectFirst: {
	            type: Boolean,
	            default: false
	        }
	    },
	    data: function data(vm) {
	        return {
	            attrsInput: null,
	            lazySearch: vm.searchInput
	        };
	    },
	    computed: {
	        classes: function classes() {
	            return Object.assign({}, _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].options.computed.classes.call(this), {
	                'v-autocomplete': true,
	                'v-autocomplete--is-selecting-index': this.selectedIndex > -1
	            });
	        },
	        computedItems: function computedItems() {
	            return this.filteredItems;
	        },
	        selectedValues: function selectedValues() {
	            var _this = this;
	            return this.selectedItems.map(function (item) {
	                return _this.getValue(item);
	            });
	        },
	        hasDisplayedItems: function hasDisplayedItems() {
	            var _this = this;
	            return this.hideSelected ? this.filteredItems.some(function (item) {
	                return !_this.hasItem(item);
	            }) : this.filteredItems.length > 0;
	        },
	        /**
	         * The range of the current input text
	         *
	         * @return {Number}
	         */
	        currentRange: function currentRange() {
	            if (this.selectedItem == null) return 0;
	            return this.getText(this.selectedItem).toString().length;
	        },
	        filteredItems: function filteredItems() {
	            var _this = this;
	            if (!this.isSearching || this.noFilter || this.internalSearch == null) return this.allItems;
	            return this.allItems.filter(function (item) {
	                return _this.filter(item, _this.internalSearch.toString(), _this.getText(item).toString());
	            });
	        },
	        internalSearch: {
	            get: function get() {
	                return this.lazySearch;
	            },
	            set: function set(val) {
	                this.lazySearch = val;
	                this.$emit('update:searchInput', val);
	            }
	        },
	        isAnyValueAllowed: function isAnyValueAllowed() {
	            return false;
	        },
	        isDirty: function isDirty() {
	            return this.searchIsDirty || this.selectedItems.length > 0;
	        },
	        isSearching: function isSearching() {
	            if (this.multiple) return this.searchIsDirty;
	            return this.searchIsDirty && this.internalSearch !== this.getText(this.selectedItem);
	        },
	        menuCanShow: function menuCanShow() {
	            if (!this.isFocused) return false;
	            return this.hasDisplayedItems || !this.hideNoData;
	        },
	        $_menuProps: function $_menuProps() {
	            var props = _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].options.computed.$_menuProps.call(this);
	            props.contentClass = ("v-autocomplete__content " + (props.contentClass || '')).trim();
	            return __assign({}, defaultMenuProps, props);
	        },
	        searchIsDirty: function searchIsDirty() {
	            return this.internalSearch != null && this.internalSearch !== '';
	        },
	        selectedItem: function selectedItem() {
	            var _this = this;
	            if (this.multiple) return null;
	            return this.selectedItems.find(function (i) {
	                return _this.valueComparator(_this.getValue(i), _this.getValue(_this.internalValue));
	            });
	        },
	        listData: function listData() {
	            var data = _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].options.computed.listData.call(this);
	            Object.assign(data.props, {
	                items: this.virtualizedItems,
	                noFilter: this.noFilter || !this.isSearching || !this.filteredItems.length,
	                searchInput: this.internalSearch
	            });
	            return data;
	        }
	    },
	    watch: {
	        filteredItems: function filteredItems(val) {
	            this.onFilteredItemsChanged(val);
	        },
	        internalValue: function internalValue() {
	            this.setSearch();
	        },
	        isFocused: function isFocused(val) {
	            if (val) {
	                this.$refs.input && this.$refs.input.select();
	            } else {
	                this.updateSelf();
	            }
	        },
	        isMenuActive: function isMenuActive(val) {
	            if (val || !this.hasSlot) return;
	            this.lazySearch = null;
	        },
	        items: function items(val, oldVal) {
	            // If we are focused, the menu
	            // is not active, hide no data is enabled,
	            // and items change
	            // User is probably async loading
	            // items, try to activate the menu
	            if (!(oldVal && oldVal.length) && this.hideNoData && this.isFocused && !this.isMenuActive && val.length) this.activateMenu();
	        },
	        searchInput: function searchInput(val) {
	            this.lazySearch = val;
	        },
	        internalSearch: function internalSearch(val) {
	            this.onInternalSearchChanged(val);
	        },
	        itemText: function itemText() {
	            this.updateSelf();
	        }
	    },
	    created: function created() {
	        this.setSearch();
	    },
	    methods: {
	        onFilteredItemsChanged: function onFilteredItemsChanged(val) {
	            var _this = this;
	            this.setMenuIndex(-1);
	            this.$nextTick(function () {
	                _this.setMenuIndex(val.length > 0 && (val.length === 1 || _this.autoSelectFirst) ? 0 : -1);
	            });
	        },
	        onInternalSearchChanged: function onInternalSearchChanged(val) {
	            this.updateMenuDimensions();
	        },
	        updateMenuDimensions: function updateMenuDimensions() {
	            if (this.isMenuActive && this.$refs.menu) {
	                this.$refs.menu.updateDimensions();
	            }
	        },
	        changeSelectedIndex: function changeSelectedIndex(keyCode) {
	            // Do not allow changing of selectedIndex
	            // when search is dirty
	            if (this.searchIsDirty) return;
	            if (![_util_helpers__WEBPACK_IMPORTED_MODULE_3__["keyCodes"].backspace, _util_helpers__WEBPACK_IMPORTED_MODULE_3__["keyCodes"].left, _util_helpers__WEBPACK_IMPORTED_MODULE_3__["keyCodes"].right, _util_helpers__WEBPACK_IMPORTED_MODULE_3__["keyCodes"].delete].includes(keyCode)) return;
	            var indexes = this.selectedItems.length - 1;
	            if (keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_3__["keyCodes"].left) {
	                this.selectedIndex = this.selectedIndex === -1 ? indexes : this.selectedIndex - 1;
	            } else if (keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_3__["keyCodes"].right) {
	                this.selectedIndex = this.selectedIndex >= indexes ? -1 : this.selectedIndex + 1;
	            } else if (this.selectedIndex === -1) {
	                this.selectedIndex = indexes;
	                return;
	            }
	            var currentItem = this.selectedItems[this.selectedIndex];
	            if ([_util_helpers__WEBPACK_IMPORTED_MODULE_3__["keyCodes"].backspace, _util_helpers__WEBPACK_IMPORTED_MODULE_3__["keyCodes"].delete].includes(keyCode) && !this.getDisabled(currentItem)) {
	                var newIndex = this.selectedIndex === indexes ? this.selectedIndex - 1 : this.selectedItems[this.selectedIndex + 1] ? this.selectedIndex : -1;
	                if (newIndex === -1) {
	                    this.setValue(this.multiple ? [] : undefined);
	                } else {
	                    this.selectItem(currentItem);
	                }
	                this.selectedIndex = newIndex;
	            }
	        },
	        clearableCallback: function clearableCallback() {
	            this.internalSearch = undefined;
	            _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.clearableCallback.call(this);
	        },
	        genInput: function genInput() {
	            var input = _VTextField_VTextField__WEBPACK_IMPORTED_MODULE_2__["default"].options.methods.genInput.call(this);
	            input.data.attrs.role = 'combobox';
	            input.data.domProps.value = this.internalSearch;
	            return input;
	        },
	        genSelections: function genSelections() {
	            return this.hasSlot || this.multiple ? _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.genSelections.call(this) : [];
	        },
	        onClick: function onClick() {
	            if (this.isDisabled) return;
	            this.selectedIndex > -1 ? this.selectedIndex = -1 : this.onFocus();
	            this.activateMenu();
	        },
	        onEnterDown: function onEnterDown() {
	            // Avoid invoking this method
	            // will cause updateSelf to
	            // be called emptying search
	        },
	        onInput: function onInput(e) {
	            if (this.selectedIndex > -1) return;
	            // If typing and menu is not currently active
	            if (e.target.value) {
	                this.activateMenu();
	                if (!this.isAnyValueAllowed) this.setMenuIndex(0);
	            }
	            this.mask && this.resetSelections(e.target);
	            this.internalSearch = e.target.value;
	            this.badInput = e.target.validity && e.target.validity.badInput;
	        },
	        onKeyDown: function onKeyDown(e) {
	            var keyCode = e.keyCode;
	            _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.onKeyDown.call(this, e);
	            // The ordering is important here
	            // allows new value to be updated
	            // and then moves the index to the
	            // proper location
	            this.changeSelectedIndex(keyCode);
	        },
	        onTabDown: function onTabDown(e) {
	            _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.onTabDown.call(this, e);
	            this.updateSelf();
	        },
	        setSelectedItems: function setSelectedItems() {
	            _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.setSelectedItems.call(this);
	            // #4273 Don't replace if searching
	            // #4403 Don't replace if focused
	            if (!this.isFocused) this.setSearch();
	        },
	        setSearch: function setSearch() {
	            var _this = this;
	            // Wait for nextTick so selectedItem
	            // has had time to update
	            this.$nextTick(function () {
	                _this.internalSearch = _this.multiple && _this.internalSearch && _this.isMenuActive ? _this.internalSearch : !_this.selectedItems.length || _this.multiple || _this.hasSlot ? null : _this.getText(_this.selectedItem);
	            });
	        },
	        updateSelf: function updateSelf() {
	            this.updateAutocomplete();
	        },
	        updateAutocomplete: function updateAutocomplete() {
	            if (!this.searchIsDirty && !this.internalValue) return;
	            if (!this.valueComparator(this.internalSearch, this.getValue(this.internalValue))) {
	                this.setSearch();
	            }
	        },
	        hasItem: function hasItem(item) {
	            return this.selectedValues.indexOf(this.getValue(item)) > -1;
	        }
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VAutocomplete/index.js":
	/*!***********************************************!*\
	  !*** ./src/components/VAutocomplete/index.js ***!
	  \***********************************************/
	/*! exports provided: VAutocomplete, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VAutocomplete__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VAutocomplete */ "./src/components/VAutocomplete/VAutocomplete.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VAutocomplete", function() { return _VAutocomplete__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VAutocomplete__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VAvatar/VAvatar.ts":
	/*!*******************************************!*\
	  !*** ./src/components/VAvatar/VAvatar.ts ***!
	  \*******************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_avatars_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_avatars.styl */ "./src/stylus/components/_avatars.styl");
	/* harmony import */ var _stylus_components_avatars_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_avatars_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	
	// Mixins
	
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_3__["default"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_1__["default"]).extend({
	    name: 'v-avatar',
	    functional: true,
	    props: {
	        // TODO: inherit these
	        color: String,
	        size: {
	            type: [Number, String],
	            default: 48
	        },
	        tile: Boolean
	    },
	    render: function render(h, _a) {
	        var data = _a.data,
	            props = _a.props,
	            children = _a.children;
	        data.staticClass = ("v-avatar " + (data.staticClass || '')).trim();
	        if (props.tile) data.staticClass += ' v-avatar--tile';
	        var size = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_2__["convertToUnit"])(props.size);
	        data.style = __assign({ height: size, width: size }, data.style);
	        return h('div', _mixins_colorable__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.setBackgroundColor(props.color, data), children);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VAvatar/index.ts":
	/*!*****************************************!*\
	  !*** ./src/components/VAvatar/index.ts ***!
	  \*****************************************/
	/*! exports provided: VAvatar, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VAvatar__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VAvatar */ "./src/components/VAvatar/VAvatar.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VAvatar", function() { return _VAvatar__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VAvatar__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VBadge/VBadge.ts":
	/*!*****************************************!*\
	  !*** ./src/components/VBadge/VBadge.ts ***!
	  \*****************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_badges_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_badges.styl */ "./src/stylus/components/_badges.styl");
	/* harmony import */ var _stylus_components_badges_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_badges_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _mixins_toggleable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/toggleable */ "./src/mixins/toggleable.ts");
	/* harmony import */ var _mixins_positionable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/positionable */ "./src/mixins/positionable.ts");
	/* harmony import */ var _mixins_transitionable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mixins/transitionable */ "./src/mixins/transitionable.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	// Styles
	
	// Mixins
	
	
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_5__["default"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_1__["default"], _mixins_toggleable__WEBPACK_IMPORTED_MODULE_2__["default"], Object(_mixins_positionable__WEBPACK_IMPORTED_MODULE_3__["factory"])(['left', 'bottom']), _mixins_transitionable__WEBPACK_IMPORTED_MODULE_4__["default"]
	/* @vue/component */
	).extend({
	    name: 'v-badge',
	    props: {
	        color: {
	            type: String,
	            default: 'primary'
	        },
	        overlap: Boolean,
	        transition: {
	            type: String,
	            default: 'fab-transition'
	        },
	        value: {
	            default: true
	        }
	    },
	    computed: {
	        classes: function classes() {
	            return {
	                'v-badge--bottom': this.bottom,
	                'v-badge--left': this.left,
	                'v-badge--overlap': this.overlap
	            };
	        }
	    },
	    render: function render(h) {
	        var badge = this.$slots.badge && [h('span', this.setBackgroundColor(this.color, {
	            staticClass: 'v-badge__badge',
	            attrs: this.$attrs,
	            directives: [{
	                name: 'show',
	                value: this.isActive
	            }]
	        }), this.$slots.badge)];
	        return h('span', {
	            staticClass: 'v-badge',
	            'class': this.classes
	        }, [this.$slots.default, h('transition', {
	            props: {
	                name: this.transition,
	                origin: this.origin,
	                mode: this.mode
	            }
	        }, badge)]);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VBadge/index.ts":
	/*!****************************************!*\
	  !*** ./src/components/VBadge/index.ts ***!
	  \****************************************/
	/*! exports provided: VBadge, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VBadge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VBadge */ "./src/components/VBadge/VBadge.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VBadge", function() { return _VBadge__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VBadge__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VBottomNav/VBottomNav.ts":
	/*!*************************************************!*\
	  !*** ./src/components/VBottomNav/VBottomNav.ts ***!
	  \*************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_bottom_navs_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_bottom-navs.styl */ "./src/stylus/components/_bottom-navs.styl");
	/* harmony import */ var _stylus_components_bottom_navs_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_bottom_navs_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_applicationable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/applicationable */ "./src/mixins/applicationable.ts");
	/* harmony import */ var _mixins_button_group__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/button-group */ "./src/mixins/button-group.ts");
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	// Styles
	
	// Mixins
	
	
	
	
	// Util
	
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_5__["default"])(Object(_mixins_applicationable__WEBPACK_IMPORTED_MODULE_1__["default"])('bottom', ['height', 'value']), _mixins_colorable__WEBPACK_IMPORTED_MODULE_3__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_4__["default"]
	/* @vue/component */
	).extend({
	    name: 'v-bottom-nav',
	    props: {
	        active: [Number, String],
	        mandatory: Boolean,
	        height: {
	            default: 56,
	            type: [Number, String],
	            validator: function validator(v) {
	                return !isNaN(parseInt(v));
	            }
	        },
	        shift: Boolean,
	        value: null
	    },
	    computed: {
	        classes: function classes() {
	            return {
	                'v-bottom-nav--absolute': this.absolute,
	                'v-bottom-nav--fixed': !this.absolute && (this.app || this.fixed),
	                'v-bottom-nav--shift': this.shift,
	                'v-bottom-nav--active': this.value
	            };
	        },
	        computedHeight: function computedHeight() {
	            return parseInt(this.height);
	        }
	    },
	    methods: {
	        updateApplication: function updateApplication() {
	            return !this.value ? 0 : this.computedHeight;
	        },
	        updateValue: function updateValue(val) {
	            this.$emit('update:active', val);
	        }
	    },
	    render: function render(h) {
	        return h(_mixins_button_group__WEBPACK_IMPORTED_MODULE_2__["default"], this.setBackgroundColor(this.color, {
	            staticClass: 'v-bottom-nav',
	            class: this.classes,
	            style: {
	                height: parseInt(this.computedHeight) + "px"
	            },
	            props: {
	                mandatory: Boolean(this.mandatory || this.active !== undefined),
	                value: this.active
	            },
	            on: { change: this.updateValue }
	        }), this.$slots.default);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VBottomNav/index.ts":
	/*!********************************************!*\
	  !*** ./src/components/VBottomNav/index.ts ***!
	  \********************************************/
	/*! exports provided: VBottomNav, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VBottomNav__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VBottomNav */ "./src/components/VBottomNav/VBottomNav.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VBottomNav", function() { return _VBottomNav__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VBottomNav__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VBottomSheet/VBottomSheet.js":
	/*!*****************************************************!*\
	  !*** ./src/components/VBottomSheet/VBottomSheet.js ***!
	  \*****************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_bottom_sheets_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_bottom-sheets.styl */ "./src/stylus/components/_bottom-sheets.styl");
	/* harmony import */ var _stylus_components_bottom_sheets_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_bottom_sheets_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _VDialog_VDialog__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../VDialog/VDialog */ "./src/components/VDialog/VDialog.js");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-bottom-sheet',
	    props: {
	        disabled: Boolean,
	        fullWidth: Boolean,
	        hideOverlay: Boolean,
	        inset: Boolean,
	        lazy: Boolean,
	        maxWidth: {
	            type: [String, Number],
	            default: 'auto'
	        },
	        persistent: Boolean,
	        value: null
	    },
	    render: function render(h) {
	        var activator = h('template', {
	            slot: 'activator'
	        }, this.$slots.activator);
	        var contentClass = ['v-bottom-sheet', this.inset ? 'v-bottom-sheet--inset' : ''].join(' ');
	        return h(_VDialog_VDialog__WEBPACK_IMPORTED_MODULE_1__["default"], {
	            attrs: __assign({}, this.$props),
	            on: __assign({}, this.$listeners),
	            props: {
	                contentClass: contentClass,
	                noClickAnimation: true,
	                transition: 'bottom-sheet-transition',
	                value: this.value
	            }
	        }, [activator, this.$slots.default]);
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VBottomSheet/index.js":
	/*!**********************************************!*\
	  !*** ./src/components/VBottomSheet/index.js ***!
	  \**********************************************/
	/*! exports provided: VBottomSheet, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VBottomSheet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VBottomSheet */ "./src/components/VBottomSheet/VBottomSheet.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VBottomSheet", function() { return _VBottomSheet__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VBottomSheet__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VBreadcrumbs/VBreadcrumbs.ts":
	/*!*****************************************************!*\
	  !*** ./src/components/VBreadcrumbs/VBreadcrumbs.ts ***!
	  \*****************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_breadcrumbs_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_breadcrumbs.styl */ "./src/stylus/components/_breadcrumbs.styl");
	/* harmony import */ var _stylus_components_breadcrumbs_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_breadcrumbs_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! . */ "./src/components/VBreadcrumbs/index.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../util/console */ "./src/util/console.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	// Styles
	
	// Components
	
	// Mixins
	
	// Utils
	
	
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_4__["default"])(_mixins_themeable__WEBPACK_IMPORTED_MODULE_2__["default"]
	/* @vue/component */
	).extend({
	    name: 'v-breadcrumbs',
	    props: {
	        divider: {
	            type: String,
	            default: '/'
	        },
	        items: {
	            type: Array,
	            default: function _default() {
	                return [];
	            }
	        },
	        large: Boolean,
	        justifyCenter: Boolean,
	        justifyEnd: Boolean
	    },
	    computed: {
	        classes: function classes() {
	            return __assign({ 'v-breadcrumbs--large': this.large, 'justify-center': this.justifyCenter, 'justify-end': this.justifyEnd }, this.themeClasses);
	        }
	    },
	    mounted: function mounted() {
	        if (this.justifyCenter) Object(_util_console__WEBPACK_IMPORTED_MODULE_3__["deprecate"])('justify-center', 'class="justify-center"', this);
	        if (this.justifyEnd) Object(_util_console__WEBPACK_IMPORTED_MODULE_3__["deprecate"])('justify-end', 'class="justify-end"', this);
	        if (this.$slots.default) Object(_util_console__WEBPACK_IMPORTED_MODULE_3__["deprecate"])('default slot', ':items and scoped slot "item"', this);
	    },
	    methods: {
	        /* @deprecated */
	        genChildren /* istanbul ignore next */: function genChildren() {
	            if (!this.$slots.default) return undefined;
	            var children = [];
	            var createDividers = false;
	            for (var i = 0; i < this.$slots.default.length; i++) {
	                var elm = this.$slots.default[i];
	                if (!elm.componentOptions || elm.componentOptions.Ctor.options.name !== 'v-breadcrumbs-item') {
	                    children.push(elm);
	                } else {
	                    if (createDividers) {
	                        children.push(this.genDivider());
	                    }
	                    children.push(elm);
	                    createDividers = true;
	                }
	            }
	            return children;
	        },
	        genDivider: function genDivider() {
	            return this.$createElement(___WEBPACK_IMPORTED_MODULE_1__["VBreadcrumbsDivider"], this.$slots.divider ? this.$slots.divider : this.divider);
	        },
	        genItems: function genItems() {
	            var items = [];
	            var hasSlot = !!this.$scopedSlots.item;
	            var keys = [];
	            for (var i = 0; i < this.items.length; i++) {
	                var item = this.items[i];
	                keys.push(item.text);
	                if (hasSlot) items.push(this.$scopedSlots.item({ item: item }));else items.push(this.$createElement(___WEBPACK_IMPORTED_MODULE_1__["VBreadcrumbsItem"], { key: keys.join('.'), props: item }, [item.text]));
	                if (i < this.items.length - 1) items.push(this.genDivider());
	            }
	            return items;
	        }
	    },
	    render: function render(h) {
	        var children = this.$slots.default ? this.genChildren() : this.genItems();
	        return h('ul', {
	            staticClass: 'v-breadcrumbs',
	            'class': this.classes
	        }, children);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VBreadcrumbs/VBreadcrumbsItem.ts":
	/*!*********************************************************!*\
	  !*** ./src/components/VBreadcrumbs/VBreadcrumbsItem.ts ***!
	  \*********************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _mixins_routable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mixins/routable */ "./src/mixins/routable.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_1__["default"])(_mixins_routable__WEBPACK_IMPORTED_MODULE_0__["default"]).extend({
	    name: 'v-breadcrumbs-item',
	    props: {
	        // In a breadcrumb, the currently
	        // active item should be dimmed
	        activeClass: {
	            type: String,
	            default: 'v-breadcrumbs__item--disabled'
	        }
	    },
	    computed: {
	        classes: function classes() {
	            var _a;
	            return _a = {
	                'v-breadcrumbs__item': true
	            }, _a[this.activeClass] = this.disabled, _a;
	        }
	    },
	    render: function render(h) {
	        var _a = this.generateRouteLink(this.classes),
	            tag = _a.tag,
	            data = _a.data;
	        return h('li', [h(tag, data, this.$slots.default)]);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VBreadcrumbs/index.ts":
	/*!**********************************************!*\
	  !*** ./src/components/VBreadcrumbs/index.ts ***!
	  \**********************************************/
	/*! exports provided: VBreadcrumbs, VBreadcrumbsItem, VBreadcrumbsDivider, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VBreadcrumbsDivider", function() { return VBreadcrumbsDivider; });
	/* harmony import */ var _VBreadcrumbs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VBreadcrumbs */ "./src/components/VBreadcrumbs/VBreadcrumbs.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VBreadcrumbs", function() { return _VBreadcrumbs__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	/* harmony import */ var _VBreadcrumbsItem__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./VBreadcrumbsItem */ "./src/components/VBreadcrumbs/VBreadcrumbsItem.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VBreadcrumbsItem", function() { return _VBreadcrumbsItem__WEBPACK_IMPORTED_MODULE_1__["default"]; });
	
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	
	
	
	var VBreadcrumbsDivider = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_2__["createSimpleFunctional"])('v-breadcrumbs__divider', 'li');
	
	/* harmony default export */ __webpack_exports__["default"] = ({
	    $_vuetify_subcomponents: {
	        VBreadcrumbs: _VBreadcrumbs__WEBPACK_IMPORTED_MODULE_0__["default"],
	        VBreadcrumbsItem: _VBreadcrumbsItem__WEBPACK_IMPORTED_MODULE_1__["default"],
	        VBreadcrumbsDivider: VBreadcrumbsDivider
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VBtn/VBtn.ts":
	/*!*************************************!*\
	  !*** ./src/components/VBtn/VBtn.ts ***!
	  \*************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_buttons_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_buttons.styl */ "./src/stylus/components/_buttons.styl");
	/* harmony import */ var _stylus_components_buttons_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_buttons_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	/* harmony import */ var _VProgressCircular__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../VProgressCircular */ "./src/components/VProgressCircular/index.ts");
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _mixins_groupable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mixins/groupable */ "./src/mixins/groupable.ts");
	/* harmony import */ var _mixins_positionable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mixins/positionable */ "./src/mixins/positionable.ts");
	/* harmony import */ var _mixins_routable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mixins/routable */ "./src/mixins/routable.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _mixins_toggleable__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mixins/toggleable */ "./src/mixins/toggleable.ts");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	// Styles
	
	
	// Components
	
	// Mixins
	
	
	
	
	
	
	// Utilities
	
	var baseMixins = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_1__["default"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_3__["default"], _mixins_routable__WEBPACK_IMPORTED_MODULE_6__["default"], _mixins_positionable__WEBPACK_IMPORTED_MODULE_5__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_7__["default"], Object(_mixins_groupable__WEBPACK_IMPORTED_MODULE_4__["factory"])('btnToggle'), Object(_mixins_toggleable__WEBPACK_IMPORTED_MODULE_8__["factory"])('inputValue')
	/* @vue/component */
	);
	/* harmony default export */ __webpack_exports__["default"] = (baseMixins.extend().extend({
	    name: 'v-btn',
	    props: {
	        activeClass: {
	            type: String,
	            default: 'v-btn--active'
	        },
	        block: Boolean,
	        depressed: Boolean,
	        fab: Boolean,
	        flat: Boolean,
	        icon: Boolean,
	        large: Boolean,
	        loading: Boolean,
	        outline: Boolean,
	        ripple: {
	            type: [Boolean, Object],
	            default: null
	        },
	        round: Boolean,
	        small: Boolean,
	        tag: {
	            type: String,
	            default: 'button'
	        },
	        type: {
	            type: String,
	            default: 'button'
	        },
	        value: null
	    },
	    computed: {
	        classes: function classes() {
	            var _a;
	            return __assign((_a = { 'v-btn': true }, _a[this.activeClass] = this.isActive, _a['v-btn--absolute'] = this.absolute, _a['v-btn--block'] = this.block, _a['v-btn--bottom'] = this.bottom, _a['v-btn--disabled'] = this.disabled, _a['v-btn--flat'] = this.flat, _a['v-btn--floating'] = this.fab, _a['v-btn--fixed'] = this.fixed, _a['v-btn--icon'] = this.icon, _a['v-btn--large'] = this.large, _a['v-btn--left'] = this.left, _a['v-btn--loader'] = this.loading, _a['v-btn--outline'] = this.outline, _a['v-btn--depressed'] = this.depressed && !this.flat || this.outline, _a['v-btn--right'] = this.right, _a['v-btn--round'] = this.round, _a['v-btn--router'] = this.to, _a['v-btn--small'] = this.small, _a['v-btn--top'] = this.top, _a), this.themeClasses);
	        },
	        computedRipple: function computedRipple() {
	            var defaultRipple = this.icon || this.fab ? { circle: true } : true;
	            if (this.disabled) return false;else return this.ripple !== null ? this.ripple : defaultRipple;
	        }
	    },
	    watch: {
	        '$route': 'onRouteChange'
	    },
	    methods: {
	        // Prevent focus to match md spec
	        click: function click(e) {
	            !this.fab && e.detail && this.$el.blur();
	            this.$emit('click', e);
	            this.btnToggle && this.toggle();
	        },
	        genContent: function genContent() {
	            return this.$createElement('div', { 'class': 'v-btn__content' }, this.$slots.default);
	        },
	        genLoader: function genLoader() {
	            return this.$createElement('span', {
	                class: 'v-btn__loading'
	            }, this.$slots.loader || [this.$createElement(_VProgressCircular__WEBPACK_IMPORTED_MODULE_2__["default"], {
	                props: {
	                    indeterminate: true,
	                    size: 23,
	                    width: 2
	                }
	            })]);
	        },
	        onRouteChange: function onRouteChange() {
	            var _this = this;
	            if (!this.to || !this.$refs.link) return;
	            var path = "_vnode.data.class." + this.activeClass;
	            this.$nextTick(function () {
	                if (Object(_util_helpers__WEBPACK_IMPORTED_MODULE_9__["getObjectValueByPath"])(_this.$refs.link, path)) {
	                    _this.toggle();
	                }
	            });
	        }
	    },
	    render: function render(h) {
	        var setColor = !this.outline && !this.flat && !this.disabled ? this.setBackgroundColor : this.setTextColor;
	        var _a = this.generateRouteLink(this.classes),
	            tag = _a.tag,
	            data = _a.data;
	        var children = [this.genContent(), this.loading && this.genLoader()];
	        if (tag === 'button') data.attrs.type = this.type;
	        data.attrs.value = ['string', 'number'].includes(_typeof(this.value)) ? this.value : JSON.stringify(this.value);
	        if (this.btnToggle) {
	            data.ref = 'link';
	        }
	        return h(tag, setColor(this.color, data), children);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VBtn/index.ts":
	/*!**************************************!*\
	  !*** ./src/components/VBtn/index.ts ***!
	  \**************************************/
	/*! exports provided: VBtn, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VBtn__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VBtn */ "./src/components/VBtn/VBtn.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VBtn", function() { return _VBtn__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VBtn__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VBtnToggle/VBtnToggle.ts":
	/*!*************************************************!*\
	  !*** ./src/components/VBtnToggle/VBtnToggle.ts ***!
	  \*************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_button_toggle_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_button-toggle.styl */ "./src/stylus/components/_button-toggle.styl");
	/* harmony import */ var _stylus_components_button_toggle_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_button_toggle_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_button_group__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/button-group */ "./src/mixins/button-group.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	// Styles
	
	// Mixins
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (_mixins_button_group__WEBPACK_IMPORTED_MODULE_1__["default"].extend({
	    name: 'v-btn-toggle',
	    props: {
	        activeClass: {
	            type: String,
	            default: 'v-btn--active'
	        }
	    },
	    computed: {
	        classes: function classes() {
	            return __assign({}, _mixins_button_group__WEBPACK_IMPORTED_MODULE_1__["default"].options.computed.classes.call(this), { 'v-btn-toggle': true, 'v-btn-toggle--only-child': this.selectedItems.length === 1, 'v-btn-toggle--selected': this.selectedItems.length > 0 });
	        }
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VBtnToggle/index.ts":
	/*!********************************************!*\
	  !*** ./src/components/VBtnToggle/index.ts ***!
	  \********************************************/
	/*! exports provided: VBtnToggle, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VBtnToggle__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VBtnToggle */ "./src/components/VBtnToggle/VBtnToggle.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VBtnToggle", function() { return _VBtnToggle__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VBtnToggle__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VCalendar/VCalendar.ts":
	/*!***********************************************!*\
	  !*** ./src/components/VCalendar/VCalendar.ts ***!
	  \***********************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _mixins_calendar_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./mixins/calendar-base */ "./src/components/VCalendar/mixins/calendar-base.ts");
	/* harmony import */ var _util_props__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./util/props */ "./src/components/VCalendar/util/props.ts");
	/* harmony import */ var _util_timestamp__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./util/timestamp */ "./src/components/VCalendar/util/timestamp.ts");
	/* harmony import */ var _VCalendarMonthly__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./VCalendarMonthly */ "./src/components/VCalendar/VCalendarMonthly.ts");
	/* harmony import */ var _VCalendarDaily__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./VCalendarDaily */ "./src/components/VCalendar/VCalendarDaily.ts");
	/* harmony import */ var _VCalendarWeekly__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./VCalendarWeekly */ "./src/components/VCalendar/VCalendarWeekly.ts");
	// Styles
	// import '../../stylus/components/_calendar-daily.styl'
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	// Mixins
	
	// Util
	
	
	// Calendars
	
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (_mixins_calendar_base__WEBPACK_IMPORTED_MODULE_0__["default"].extend({
	    name: 'v-calendar',
	    props: __assign({}, _util_props__WEBPACK_IMPORTED_MODULE_1__["default"].calendar, _util_props__WEBPACK_IMPORTED_MODULE_1__["default"].weeks, _util_props__WEBPACK_IMPORTED_MODULE_1__["default"].intervals),
	    data: function data() {
	        return {
	            lastStart: null,
	            lastEnd: null
	        };
	    },
	    computed: {
	        parsedValue: function parsedValue() {
	            return Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_2__["parseTimestamp"])(this.value) || this.parsedStart || this.times.today;
	        },
	        renderProps: function renderProps() {
	            var around = this.parsedValue;
	            var component = 'div';
	            var maxDays = this.maxDays;
	            var start = around;
	            var end = around;
	            switch (this.type) {
	                case 'month':
	                    component = _VCalendarMonthly__WEBPACK_IMPORTED_MODULE_3__["default"];
	                    start = Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_2__["getStartOfMonth"])(around);
	                    end = Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_2__["getEndOfMonth"])(around);
	                    break;
	                case 'week':
	                    component = _VCalendarDaily__WEBPACK_IMPORTED_MODULE_4__["default"];
	                    start = this.getStartOfWeek(around);
	                    end = this.getEndOfWeek(around);
	                    maxDays = 7;
	                    break;
	                case 'day':
	                    component = _VCalendarDaily__WEBPACK_IMPORTED_MODULE_4__["default"];
	                    maxDays = 1;
	                    break;
	                case '4day':
	                    component = _VCalendarDaily__WEBPACK_IMPORTED_MODULE_4__["default"];
	                    end = Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_2__["relativeDays"])(Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_2__["copyTimestamp"])(end), _util_timestamp__WEBPACK_IMPORTED_MODULE_2__["nextDay"], 4);
	                    Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_2__["updateFormatted"])(end);
	                    maxDays = 4;
	                    break;
	                case 'custom-weekly':
	                    component = _VCalendarWeekly__WEBPACK_IMPORTED_MODULE_5__["default"];
	                    start = this.parsedStart || around;
	                    end = this.parsedEnd;
	                    break;
	                case 'custom-daily':
	                    component = _VCalendarDaily__WEBPACK_IMPORTED_MODULE_4__["default"];
	                    start = this.parsedStart || around;
	                    end = this.parsedEnd;
	                    break;
	            }
	            return { component: component, start: start, end: end, maxDays: maxDays };
	        }
	    },
	    watch: {
	        renderProps: 'checkChange'
	    },
	    methods: {
	        checkChange: function checkChange() {
	            var _a = this.renderProps,
	                start = _a.start,
	                end = _a.end;
	            if (start !== this.lastStart || end !== this.lastEnd) {
	                this.lastStart = start;
	                this.lastEnd = end;
	                this.$emit('change', { start: start, end: end });
	            }
	        },
	        move: function move(amount) {
	            if (amount === void 0) {
	                amount = 1;
	            }
	            var moved = Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_2__["copyTimestamp"])(this.parsedValue);
	            var forward = amount > 0;
	            var mover = forward ? _util_timestamp__WEBPACK_IMPORTED_MODULE_2__["nextDay"] : _util_timestamp__WEBPACK_IMPORTED_MODULE_2__["prevDay"];
	            var limit = forward ? _util_timestamp__WEBPACK_IMPORTED_MODULE_2__["DAYS_IN_MONTH_MAX"] : _util_timestamp__WEBPACK_IMPORTED_MODULE_2__["DAY_MIN"];
	            var times = forward ? amount : -amount;
	            while (--times >= 0) {
	                switch (this.type) {
	                    case 'month':
	                        moved.day = limit;
	                        mover(moved);
	                        break;
	                    case 'week':
	                        Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_2__["relativeDays"])(moved, mover, _util_timestamp__WEBPACK_IMPORTED_MODULE_2__["DAYS_IN_WEEK"]);
	                        break;
	                    case 'day':
	                        mover(moved);
	                        break;
	                    case '4day':
	                        Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_2__["relativeDays"])(moved, mover, 4);
	                        break;
	                }
	            }
	            Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_2__["updateWeekday"])(moved);
	            Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_2__["updateFormatted"])(moved);
	            Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_2__["updateRelative"])(moved, this.times.now);
	            this.$emit('input', moved.date);
	            this.$emit('moved', moved);
	        },
	        next: function next(amount) {
	            if (amount === void 0) {
	                amount = 1;
	            }
	            this.move(amount);
	        },
	        prev: function prev(amount) {
	            if (amount === void 0) {
	                amount = 1;
	            }
	            this.move(-amount);
	        },
	        timeToY: function timeToY(time, clamp) {
	            if (clamp === void 0) {
	                clamp = true;
	            }
	            var c = this.$children[0];
	            if (c && c.timeToY) {
	                return c.timeToY(time, clamp);
	            } else {
	                return false;
	            }
	        },
	        minutesToPixels: function minutesToPixels(minutes) {
	            var c = this.$children[0];
	            if (c && c.minutesToPixels) {
	                return c.minutesToPixels(minutes);
	            } else {
	                return -1;
	            }
	        },
	        scrollToTime: function scrollToTime(time) {
	            var c = this.$children[0];
	            if (c && c.scrollToTime) {
	                return c.scrollToTime(time);
	            } else {
	                return false;
	            }
	        }
	    },
	    render: function render(h) {
	        var _this = this;
	        var _a = this.renderProps,
	            start = _a.start,
	            end = _a.end,
	            maxDays = _a.maxDays,
	            component = _a.component;
	        return h(component, {
	            staticClass: 'v-calendar',
	            props: __assign({}, this.$props, { start: start.date, end: end.date, maxDays: maxDays }),
	            on: __assign({}, this.$listeners, { 'click:date': function clickDate(day) {
	                    if (_this.$listeners['input']) {
	                        _this.$emit('input', day.date);
	                    }
	                    if (_this.$listeners['click:date']) {
	                        _this.$emit('click:date', day);
	                    }
	                } }),
	            scopedSlots: this.$scopedSlots
	        });
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VCalendar/VCalendarDaily.ts":
	/*!****************************************************!*\
	  !*** ./src/components/VCalendar/VCalendarDaily.ts ***!
	  \****************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_calendar_daily_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_calendar-daily.styl */ "./src/stylus/components/_calendar-daily.styl");
	/* harmony import */ var _stylus_components_calendar_daily_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_calendar_daily_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _directives_resize__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../directives/resize */ "./src/directives/resize.ts");
	/* harmony import */ var _mixins_calendar_with_intervals__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./mixins/calendar-with-intervals */ "./src/components/VCalendar/mixins/calendar-with-intervals.ts");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var __read = undefined && undefined.__read || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o),
	        r,
	        ar = [],
	        e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
	            ar.push(r.value);
	        }
	    } catch (error) {
	        e = { error: error };
	    } finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        } finally {
	            if (e) throw e.error;
	        }
	    }
	    return ar;
	};
	var __spread = undefined && undefined.__spread || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) {
	        ar = ar.concat(__read(arguments[i]));
	    }return ar;
	};
	// Styles
	
	// Directives
	
	// Mixins
	
	// Util
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (_mixins_calendar_with_intervals__WEBPACK_IMPORTED_MODULE_2__["default"].extend({
	    name: 'v-calendar-daily',
	    directives: { Resize: _directives_resize__WEBPACK_IMPORTED_MODULE_1__["default"] },
	    data: function data() {
	        return {
	            scrollPush: 0
	        };
	    },
	    computed: {
	        classes: function classes() {
	            return __assign({ 'v-calendar-daily': true }, this.themeClasses);
	        }
	    },
	    mounted: function mounted() {
	        this.init();
	    },
	    methods: {
	        init: function init() {
	            this.$nextTick(this.onResize);
	        },
	        onResize: function onResize() {
	            this.scrollPush = this.getScrollPush();
	        },
	        getScrollPush: function getScrollPush() {
	            var area = this.$refs.scrollArea;
	            var pane = this.$refs.pane;
	            return area && pane ? area.offsetWidth - pane.offsetWidth : 0;
	        },
	        genHead: function genHead() {
	            return this.$createElement('div', {
	                staticClass: 'v-calendar-daily__head',
	                style: {
	                    marginRight: this.scrollPush + 'px'
	                }
	            }, __spread([this.genHeadIntervals()], this.genHeadDays()));
	        },
	        genHeadIntervals: function genHeadIntervals() {
	            return this.$createElement('div', {
	                staticClass: 'v-calendar-daily__intervals-head'
	            });
	        },
	        genHeadDays: function genHeadDays() {
	            return this.days.map(this.genHeadDay);
	        },
	        genHeadDay: function genHeadDay(day) {
	            var _this = this;
	            var slot = this.$scopedSlots.dayHeader;
	            return this.$createElement('div', {
	                key: day.date,
	                staticClass: 'v-calendar-daily_head-day',
	                class: this.getRelativeClasses(day),
	                on: this.getDefaultMouseEventHandlers(':day', function (_e) {
	                    return _this.getSlotScope(day);
	                })
	            }, [this.genHeadWeekday(day), this.genHeadDayLabel(day), slot ? slot(day) : '']);
	        },
	        genHeadWeekday: function genHeadWeekday(day) {
	            var color = day.present ? this.color : undefined;
	            return this.$createElement('div', this.setTextColor(color, {
	                staticClass: 'v-calendar-daily_head-weekday'
	            }), this.weekdayFormatter(day, this.shortWeekdays));
	        },
	        genHeadDayLabel: function genHeadDayLabel(day) {
	            var color = day.present ? this.color : undefined;
	            return this.$createElement('div', this.setTextColor(color, {
	                staticClass: 'v-calendar-daily_head-day-label',
	                on: this.getMouseEventHandlers({
	                    'click:date': { event: 'click', stop: true },
	                    'contextmenu:date': { event: 'contextmenu', stop: true, prevent: true, result: false }
	                }, function (_e) {
	                    return day;
	                })
	            }), this.dayFormatter(day, false));
	        },
	        genBody: function genBody() {
	            return this.$createElement('div', {
	                staticClass: 'v-calendar-daily__body'
	            }, [this.genScrollArea()]);
	        },
	        genScrollArea: function genScrollArea() {
	            return this.$createElement('div', {
	                ref: 'scrollArea',
	                staticClass: 'v-calendar-daily__scroll-area'
	            }, [this.genPane()]);
	        },
	        genPane: function genPane() {
	            return this.$createElement('div', {
	                ref: 'pane',
	                staticClass: 'v-calendar-daily__pane',
	                style: {
	                    height: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["convertToUnit"])(this.bodyHeight)
	                }
	            }, [this.genDayContainer()]);
	        },
	        genDayContainer: function genDayContainer() {
	            return this.$createElement('div', {
	                staticClass: 'v-calendar-daily__day-container'
	            }, __spread([this.genBodyIntervals()], this.genDays()));
	        },
	        genDays: function genDays() {
	            return this.days.map(this.genDay);
	        },
	        genDay: function genDay(day, index) {
	            var _this = this;
	            var slot = this.$scopedSlots.dayBody;
	            var scope = this.getSlotScope(day);
	            return this.$createElement('div', {
	                key: day.date,
	                staticClass: 'v-calendar-daily__day',
	                class: this.getRelativeClasses(day),
	                on: this.getDefaultMouseEventHandlers(':time', function (e) {
	                    return _this.getSlotScope(_this.getTimestampAtEvent(e, day));
	                })
	            }, __spread(this.genDayIntervals(index), [slot ? slot(scope) : '']));
	        },
	        genDayIntervals: function genDayIntervals(index) {
	            return this.intervals[index].map(this.genDayInterval);
	        },
	        genDayInterval: function genDayInterval(interval) {
	            var height = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["convertToUnit"])(this.intervalHeight);
	            var styler = this.intervalStyle || this.intervalStyleDefault;
	            var slot = this.$scopedSlots.interval;
	            var scope = this.getSlotScope(interval);
	            var data = {
	                key: interval.time,
	                staticClass: 'v-calendar-daily__day-interval',
	                style: __assign({ height: height }, styler(interval))
	            };
	            var children = slot ? slot(scope) : undefined;
	            return this.$createElement('div', data, children);
	        },
	        genBodyIntervals: function genBodyIntervals() {
	            var _this = this;
	            var data = {
	                staticClass: 'v-calendar-daily__intervals-body',
	                on: this.getDefaultMouseEventHandlers(':interval', function (e) {
	                    return _this.getTimestampAtEvent(e, _this.parsedStart);
	                })
	            };
	            return this.$createElement('div', data, this.genIntervalLabels());
	        },
	        genIntervalLabels: function genIntervalLabels() {
	            return this.intervals[0].map(this.genIntervalLabel);
	        },
	        genIntervalLabel: function genIntervalLabel(interval) {
	            var height = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["convertToUnit"])(this.intervalHeight);
	            var short = this.shortIntervals;
	            var shower = this.showIntervalLabel || this.showIntervalLabelDefault;
	            var show = shower(interval);
	            var label = show ? this.intervalFormatter(interval, short) : undefined;
	            return this.$createElement('div', {
	                key: interval.time,
	                staticClass: 'v-calendar-daily__interval',
	                style: {
	                    height: height
	                }
	            }, [this.$createElement('div', {
	                staticClass: 'v-calendar-daily__interval-text'
	            }, label)]);
	        }
	    },
	    render: function render(h) {
	        return h('div', {
	            class: this.classes,
	            nativeOn: {
	                dragstart: function dragstart(e) {
	                    e.preventDefault();
	                }
	            },
	            directives: [{
	                modifiers: { quiet: true },
	                name: 'resize',
	                value: this.onResize
	            }]
	        }, [!this.hideHeader ? this.genHead() : '', this.genBody()]);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VCalendar/VCalendarMonthly.ts":
	/*!******************************************************!*\
	  !*** ./src/components/VCalendar/VCalendarMonthly.ts ***!
	  \******************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_calendar_weekly_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_calendar-weekly.styl */ "./src/stylus/components/_calendar-weekly.styl");
	/* harmony import */ var _stylus_components_calendar_weekly_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_calendar_weekly_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _VCalendarWeekly__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./VCalendarWeekly */ "./src/components/VCalendar/VCalendarWeekly.ts");
	/* harmony import */ var _util_timestamp__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./util/timestamp */ "./src/components/VCalendar/util/timestamp.ts");
	// Styles
	
	// Mixins
	
	// Util
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (_VCalendarWeekly__WEBPACK_IMPORTED_MODULE_1__["default"].extend({
	    name: 'v-calendar-monthly',
	    computed: {
	        staticClass: function staticClass() {
	            return 'v-calendar-monthly v-calendar-weekly';
	        },
	        parsedStart: function parsedStart() {
	            return Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_2__["getStartOfMonth"])(Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_2__["parseTimestamp"])(this.start));
	        },
	        parsedEnd: function parsedEnd() {
	            return Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_2__["getEndOfMonth"])(Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_2__["parseTimestamp"])(this.end));
	        }
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VCalendar/VCalendarWeekly.ts":
	/*!*****************************************************!*\
	  !*** ./src/components/VCalendar/VCalendarWeekly.ts ***!
	  \*****************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_calendar_weekly_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_calendar-weekly.styl */ "./src/stylus/components/_calendar-weekly.styl");
	/* harmony import */ var _stylus_components_calendar_weekly_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_calendar_weekly_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_calendar_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./mixins/calendar-base */ "./src/components/VCalendar/mixins/calendar-base.ts");
	/* harmony import */ var _util_props__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./util/props */ "./src/components/VCalendar/util/props.ts");
	/* harmony import */ var _util_timestamp__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./util/timestamp */ "./src/components/VCalendar/util/timestamp.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var __read = undefined && undefined.__read || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o),
	        r,
	        ar = [],
	        e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
	            ar.push(r.value);
	        }
	    } catch (error) {
	        e = { error: error };
	    } finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        } finally {
	            if (e) throw e.error;
	        }
	    }
	    return ar;
	};
	var __spread = undefined && undefined.__spread || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) {
	        ar = ar.concat(__read(arguments[i]));
	    }return ar;
	};
	// Styles
	
	// Mixins
	
	// Util
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (_mixins_calendar_base__WEBPACK_IMPORTED_MODULE_1__["default"].extend({
	    name: 'v-calendar-weekly',
	    props: _util_props__WEBPACK_IMPORTED_MODULE_2__["default"].weeks,
	    computed: {
	        staticClass: function staticClass() {
	            return 'v-calendar-weekly';
	        },
	        classes: function classes() {
	            return this.themeClasses;
	        },
	        parsedMinWeeks: function parsedMinWeeks() {
	            return parseInt(this.minWeeks);
	        },
	        days: function days() {
	            var minDays = this.parsedMinWeeks * this.weekdays.length;
	            var start = this.getStartOfWeek(this.parsedStart);
	            var end = this.getEndOfWeek(this.parsedEnd);
	            return Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_3__["createDayList"])(start, end, this.times.today, this.weekdaySkips, Number.MAX_SAFE_INTEGER, minDays);
	        },
	        todayWeek: function todayWeek() {
	            var today = this.times.today;
	            var start = this.getStartOfWeek(today);
	            var end = this.getEndOfWeek(today);
	            return Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_3__["createDayList"])(start, end, today, this.weekdaySkips, this.weekdays.length, this.weekdays.length);
	        },
	        monthFormatter: function monthFormatter() {
	            if (this.monthFormat) {
	                return this.monthFormat;
	            }
	            var longOptions = { timeZone: 'UTC', month: 'long' };
	            var shortOptions = { timeZone: 'UTC', month: 'short' };
	            return Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_3__["createNativeLocaleFormatter"])(this.locale, function (_tms, short) {
	                return short ? shortOptions : longOptions;
	            });
	        }
	    },
	    methods: {
	        isOutside: function isOutside(day) {
	            var dayIdentifier = Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_3__["getDayIdentifier"])(day);
	            return dayIdentifier < Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_3__["getDayIdentifier"])(this.parsedStart) || dayIdentifier > Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_3__["getDayIdentifier"])(this.parsedEnd);
	        },
	        genHead: function genHead() {
	            return this.$createElement('div', {
	                staticClass: 'v-calendar-weekly__head'
	            }, this.genHeadDays());
	        },
	        genHeadDays: function genHeadDays() {
	            return this.todayWeek.map(this.genHeadDay);
	        },
	        genHeadDay: function genHeadDay(day, index) {
	            var outside = this.isOutside(this.days[index]);
	            var color = day.present ? this.color : undefined;
	            return this.$createElement('div', this.setTextColor(color, {
	                key: day.date,
	                staticClass: 'v-calendar-weekly__head-weekday',
	                class: this.getRelativeClasses(day, outside)
	            }), this.weekdayFormatter(day, this.shortWeekdays));
	        },
	        genWeeks: function genWeeks() {
	            var days = this.days;
	            var weekDays = this.weekdays.length;
	            var weeks = [];
	            for (var i = 0; i < days.length; i += weekDays) {
	                weeks.push(this.genWeek(days.slice(i, i + weekDays)));
	            }
	            return weeks;
	        },
	        genWeek: function genWeek(week) {
	            return this.$createElement('div', {
	                key: week[0].date,
	                staticClass: 'v-calendar-weekly__week'
	            }, week.map(this.genDay));
	        },
	        genDay: function genDay(day) {
	            var outside = this.isOutside(day);
	            var slot = this.$scopedSlots.day;
	            var slotData = __assign({ outside: outside }, day);
	            var hasMonth = day.day === 1 && this.showMonthOnFirst;
	            return this.$createElement('div', {
	                key: day.date,
	                staticClass: 'v-calendar-weekly__day',
	                class: this.getRelativeClasses(day, outside),
	                on: this.getDefaultMouseEventHandlers(':day', function (_e) {
	                    return day;
	                })
	            }, [this.genDayLabel(day), hasMonth ? this.genDayMonth(day) : '', slot ? slot(slotData) : '']);
	        },
	        genDayLabel: function genDayLabel(day) {
	            var color = day.present ? this.color : undefined;
	            var slot = this.$scopedSlots.dayLabel;
	            return this.$createElement('div', this.setTextColor(color, {
	                staticClass: 'v-calendar-weekly__day-label',
	                on: this.getMouseEventHandlers({
	                    'click:date': { event: 'click', stop: true },
	                    'contextmenu:date': { event: 'contextmenu', stop: true, prevent: true, result: false }
	                }, function (_e) {
	                    return day;
	                })
	            }), slot ? slot(day) : this.dayFormatter(day, false));
	        },
	        genDayMonth: function genDayMonth(day) {
	            var color = day.present ? this.color : undefined;
	            var slot = this.$scopedSlots.dayMonth;
	            return this.$createElement('div', this.setTextColor(color, {
	                staticClass: 'v-calendar-weekly__day-month'
	            }), slot ? slot(day) : this.monthFormatter(day, this.shortMonths));
	        }
	    },
	    render: function render(h) {
	        return h('div', {
	            staticClass: this.staticClass,
	            class: this.classes,
	            nativeOn: {
	                dragstart: function dragstart(e) {
	                    e.preventDefault();
	                }
	            }
	        }, __spread([!this.hideHeader ? this.genHead() : ''], this.genWeeks()));
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VCalendar/index.ts":
	/*!*******************************************!*\
	  !*** ./src/components/VCalendar/index.ts ***!
	  \*******************************************/
	/*! exports provided: VCalendar, VCalendarDaily, VCalendarWeekly, VCalendarMonthly, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VCalendar__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VCalendar */ "./src/components/VCalendar/VCalendar.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VCalendar", function() { return _VCalendar__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	/* harmony import */ var _VCalendarDaily__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./VCalendarDaily */ "./src/components/VCalendar/VCalendarDaily.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VCalendarDaily", function() { return _VCalendarDaily__WEBPACK_IMPORTED_MODULE_1__["default"]; });
	
	/* harmony import */ var _VCalendarWeekly__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./VCalendarWeekly */ "./src/components/VCalendar/VCalendarWeekly.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VCalendarWeekly", function() { return _VCalendarWeekly__WEBPACK_IMPORTED_MODULE_2__["default"]; });
	
	/* harmony import */ var _VCalendarMonthly__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./VCalendarMonthly */ "./src/components/VCalendar/VCalendarMonthly.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VCalendarMonthly", function() { return _VCalendarMonthly__WEBPACK_IMPORTED_MODULE_3__["default"]; });
	
	
	
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = ({
	    $_vuetify_subcomponents: {
	        VCalendar: _VCalendar__WEBPACK_IMPORTED_MODULE_0__["default"],
	        VCalendarDaily: _VCalendarDaily__WEBPACK_IMPORTED_MODULE_1__["default"],
	        VCalendarWeekly: _VCalendarWeekly__WEBPACK_IMPORTED_MODULE_2__["default"],
	        VCalendarMonthly: _VCalendarMonthly__WEBPACK_IMPORTED_MODULE_3__["default"]
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VCalendar/mixins/calendar-base.ts":
	/*!**********************************************************!*\
	  !*** ./src/components/VCalendar/mixins/calendar-base.ts ***!
	  \**********************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../util/mixins */ "./src/util/mixins.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _times__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./times */ "./src/components/VCalendar/mixins/times.ts");
	/* harmony import */ var _mouse__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./mouse */ "./src/components/VCalendar/mixins/mouse.ts");
	/* harmony import */ var _util_props__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../util/props */ "./src/components/VCalendar/util/props.ts");
	/* harmony import */ var _util_timestamp__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../util/timestamp */ "./src/components/VCalendar/util/timestamp.ts");
	// Mixins
	
	
	
	
	
	// Util
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_0__["default"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_2__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_1__["default"], _times__WEBPACK_IMPORTED_MODULE_3__["default"], _mouse__WEBPACK_IMPORTED_MODULE_4__["default"]).extend({
	    name: 'calendar-base',
	    props: _util_props__WEBPACK_IMPORTED_MODULE_5__["default"].base,
	    computed: {
	        weekdaySkips: function weekdaySkips() {
	            return Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_6__["getWeekdaySkips"])(this.weekdays);
	        },
	        parsedStart: function parsedStart() {
	            return Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_6__["parseTimestamp"])(this.start);
	        },
	        parsedEnd: function parsedEnd() {
	            return Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_6__["parseTimestamp"])(this.end);
	        },
	        days: function days() {
	            return Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_6__["createDayList"])(this.parsedStart, this.parsedEnd, this.times.today, this.weekdaySkips);
	        },
	        dayFormatter: function dayFormatter() {
	            if (this.dayFormat) {
	                return this.dayFormat;
	            }
	            var options = { timeZone: 'UTC', day: 'numeric' };
	            return Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_6__["createNativeLocaleFormatter"])(this.locale, function (_tms, _short) {
	                return options;
	            });
	        },
	        weekdayFormatter: function weekdayFormatter() {
	            if (this.weekdayFormat) {
	                return this.weekdayFormat;
	            }
	            var longOptions = { timeZone: 'UTC', weekday: 'long' };
	            var shortOptions = { timeZone: 'UTC', weekday: 'short' };
	            return Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_6__["createNativeLocaleFormatter"])(this.locale, function (_tms, short) {
	                return short ? shortOptions : longOptions;
	            });
	        }
	    },
	    methods: {
	        getRelativeClasses: function getRelativeClasses(timestamp, outside) {
	            if (outside === void 0) {
	                outside = false;
	            }
	            return {
	                'v-present': timestamp.present,
	                'v-past': timestamp.past,
	                'v-future': timestamp.future,
	                'v-outside': outside
	            };
	        },
	        getStartOfWeek: function getStartOfWeek(timestamp) {
	            return Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_6__["getStartOfWeek"])(timestamp, this.weekdays, this.times.today);
	        },
	        getEndOfWeek: function getEndOfWeek(timestamp) {
	            return Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_6__["getEndOfWeek"])(timestamp, this.weekdays, this.times.today);
	        }
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VCalendar/mixins/calendar-with-intervals.ts":
	/*!********************************************************************!*\
	  !*** ./src/components/VCalendar/mixins/calendar-with-intervals.ts ***!
	  \********************************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _calendar_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./calendar-base */ "./src/components/VCalendar/mixins/calendar-base.ts");
	/* harmony import */ var _util_props__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/props */ "./src/components/VCalendar/util/props.ts");
	/* harmony import */ var _util_timestamp__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../util/timestamp */ "./src/components/VCalendar/util/timestamp.ts");
	// Mixins
	
	// Util
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (_calendar_base__WEBPACK_IMPORTED_MODULE_0__["default"].extend({
	    name: 'calendar-with-intervals',
	    props: _util_props__WEBPACK_IMPORTED_MODULE_1__["default"].intervals,
	    computed: {
	        parsedFirstInterval: function parsedFirstInterval() {
	            return parseInt(this.firstInterval);
	        },
	        parsedIntervalMinutes: function parsedIntervalMinutes() {
	            return parseInt(this.intervalMinutes);
	        },
	        parsedIntervalCount: function parsedIntervalCount() {
	            return parseInt(this.intervalCount);
	        },
	        parsedIntervalHeight: function parsedIntervalHeight() {
	            return parseFloat(this.intervalHeight);
	        },
	        firstMinute: function firstMinute() {
	            return this.parsedFirstInterval * this.parsedIntervalMinutes;
	        },
	        bodyHeight: function bodyHeight() {
	            return this.parsedIntervalCount * this.parsedIntervalHeight;
	        },
	        days: function days() {
	            return Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_2__["createDayList"])(this.parsedStart, this.parsedEnd, this.times.today, this.weekdaySkips, this.maxDays);
	        },
	        intervals: function intervals() {
	            var days = this.days;
	            var first = this.parsedFirstInterval;
	            var minutes = this.parsedIntervalMinutes;
	            var count = this.parsedIntervalCount;
	            var now = this.times.now;
	            return days.map(function (d) {
	                return Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_2__["createIntervalList"])(d, first, minutes, count, now);
	            });
	        },
	        intervalFormatter: function intervalFormatter() {
	            if (this.intervalFormat) {
	                return this.intervalFormat;
	            }
	            var longOptions = { timeZone: 'UTC', hour12: true, hour: '2-digit', minute: '2-digit' };
	            var shortOptions = { timeZone: 'UTC', hour12: true, hour: 'numeric', minute: '2-digit' };
	            var shortHourOptions = { timeZone: 'UTC', hour12: true, hour: 'numeric' };
	            return Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_2__["createNativeLocaleFormatter"])(this.locale, function (tms, short) {
	                return short ? tms.minute === 0 ? shortHourOptions : shortOptions : longOptions;
	            });
	        }
	    },
	    methods: {
	        showIntervalLabelDefault: function showIntervalLabelDefault(interval) {
	            var first = this.intervals[0][0];
	            var isFirst = first.hour === interval.hour && first.minute === interval.minute;
	            return !isFirst && interval.minute === 0;
	        },
	        intervalStyleDefault: function intervalStyleDefault(_interval) {
	            return undefined;
	        },
	        getTimestampAtEvent: function getTimestampAtEvent(e, day) {
	            var timestamp = Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_2__["copyTimestamp"])(day);
	            var bounds = e.currentTarget.getBoundingClientRect();
	            var baseMinutes = this.firstMinute;
	            var touchEvent = e;
	            var mouseEvent = e;
	            var touches = touchEvent.changedTouches || touchEvent.touches;
	            var clientY = touches && touches[0] ? touches[0].clientY : mouseEvent.clientY;
	            var addIntervals = (clientY - bounds.top) / this.parsedIntervalHeight;
	            var addMinutes = Math.floor(addIntervals * this.parsedIntervalMinutes);
	            var minutes = baseMinutes + addMinutes;
	            return Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_2__["updateMinutes"])(timestamp, minutes, this.times.now);
	        },
	        getSlotScope: function getSlotScope(timestamp) {
	            var scope = Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_2__["copyTimestamp"])(timestamp);
	            scope.timeToY = this.timeToY;
	            scope.minutesToPixels = this.minutesToPixels;
	            return scope;
	        },
	        scrollToTime: function scrollToTime(time) {
	            var y = this.timeToY(time);
	            var pane = this.$refs.scrollArea;
	            if (y === false || !pane) {
	                return false;
	            }
	            pane.scrollTop = y;
	            return true;
	        },
	        minutesToPixels: function minutesToPixels(minutes) {
	            return minutes / this.parsedIntervalMinutes * this.parsedIntervalHeight;
	        },
	        timeToY: function timeToY(time, clamp) {
	            if (clamp === void 0) {
	                clamp = true;
	            }
	            var minutes = Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_2__["parseTime"])(time);
	            if (minutes === false) {
	                return false;
	            }
	            var min = this.firstMinute;
	            var gap = this.parsedIntervalCount * this.parsedIntervalMinutes;
	            var delta = (minutes - min) / gap;
	            var y = delta * this.bodyHeight;
	            if (clamp) {
	                if (y < 0) {
	                    y = 0;
	                }
	                if (y > this.bodyHeight) {
	                    y = this.bodyHeight;
	                }
	            }
	            return y;
	        }
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VCalendar/mixins/mouse.ts":
	/*!**************************************************!*\
	  !*** ./src/components/VCalendar/mixins/mouse.ts ***!
	  \**************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
	
	/* harmony default export */ __webpack_exports__["default"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
	    name: 'mouse',
	    methods: {
	        getDefaultMouseEventHandlers: function getDefaultMouseEventHandlers(suffix, getEvent) {
	            var _a;
	            return this.getMouseEventHandlers((_a = {}, _a['click' + suffix] = { event: 'click' }, _a['contextmenu' + suffix] = { event: 'contextmenu', prevent: true, result: false }, _a['mousedown' + suffix] = { event: 'mousedown' }, _a['mousemove' + suffix] = { event: 'mousemove' }, _a['mouseup' + suffix] = { event: 'mouseup' }, _a['mouseenter' + suffix] = { event: 'mouseenter' }, _a['mouseleave' + suffix] = { event: 'mouseleave' }, _a['touchstart' + suffix] = { event: 'touchstart' }, _a['touchmove' + suffix] = { event: 'touchmove' }, _a['touchend' + suffix] = { event: 'touchend' }, _a), getEvent);
	        },
	        getMouseEventHandlers: function getMouseEventHandlers(events, getEvent) {
	            var _this = this;
	            var on = {};
	            var _loop_1 = function _loop_1(event) {
	                var eventOptions = events[event];
	                if (!this_1.$listeners[event]) return "continue";
	                // TODO somehow pull in modifiers
	                var prefix = eventOptions.passive ? '&' : (eventOptions.once ? '~' : '') + (eventOptions.capture ? '!' : '');
	                var key = prefix + eventOptions.event;
	                var handler = function handler(e) {
	                    var mouseEvent = e;
	                    if (eventOptions.button === undefined || mouseEvent.buttons > 0 && mouseEvent.button === eventOptions.button) {
	                        if (eventOptions.prevent) {
	                            e.preventDefault();
	                        }
	                        if (eventOptions.stop) {
	                            e.stopPropagation();
	                        }
	                        _this.$emit(event, getEvent(e));
	                    }
	                    return eventOptions.result;
	                };
	                if (key in on) {
	                    if (Array.isArray(on[key])) {
	                        on[key].push(handler);
	                    } else {
	                        on[key] = [on[key], handler];
	                    }
	                } else {
	                    on[key] = handler;
	                }
	            };
	            var this_1 = this;
	            for (var event in events) {
	                _loop_1(event);
	            }
	            return on;
	        }
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VCalendar/mixins/times.ts":
	/*!**************************************************!*\
	  !*** ./src/components/VCalendar/mixins/times.ts ***!
	  \**************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _util_timestamp__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/timestamp */ "./src/components/VCalendar/util/timestamp.ts");
	
	
	/* harmony default export */ __webpack_exports__["default"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
	    name: 'times',
	    props: {
	        now: {
	            type: String,
	            validator: _util_timestamp__WEBPACK_IMPORTED_MODULE_1__["validateTimestamp"]
	        }
	    },
	    data: function data() {
	        return {
	            times: {
	                now: Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_1__["parseTimestamp"])('0000-00-00 00:00'),
	                today: Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_1__["parseTimestamp"])('0000-00-00')
	            }
	        };
	    },
	    computed: {
	        parsedNow: function parsedNow() {
	            return this.now ? Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_1__["parseTimestamp"])(this.now) : null;
	        }
	    },
	    watch: {
	        parsedNow: 'updateTimes'
	    },
	    created: function created() {
	        this.updateTimes();
	        this.setPresent();
	    },
	    methods: {
	        setPresent: function setPresent() {
	            this.times.now.present = this.times.today.present = true;
	            this.times.now.past = this.times.today.past = false;
	            this.times.now.future = this.times.today.future = false;
	        },
	        updateTimes: function updateTimes() {
	            var now = this.parsedNow || this.getNow();
	            this.updateDay(now, this.times.now);
	            this.updateTime(now, this.times.now);
	            this.updateDay(now, this.times.today);
	        },
	        getNow: function getNow() {
	            return Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_1__["parseDate"])(new Date());
	        },
	        updateDay: function updateDay(now, target) {
	            if (now.date !== target.date) {
	                target.year = now.year;
	                target.month = now.month;
	                target.day = now.day;
	                target.weekday = now.weekday;
	                target.date = now.date;
	            }
	        },
	        updateTime: function updateTime(now, target) {
	            if (now.time !== target.time) {
	                target.hour = now.hour;
	                target.minute = now.minute;
	                target.time = now.time;
	            }
	        }
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VCalendar/util/props.ts":
	/*!************************************************!*\
	  !*** ./src/components/VCalendar/util/props.ts ***!
	  \************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _timestamp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./timestamp */ "./src/components/VCalendar/util/timestamp.ts");
	
	/* harmony default export */ __webpack_exports__["default"] = ({
	    base: {
	        start: {
	            type: String,
	            validate: _timestamp__WEBPACK_IMPORTED_MODULE_0__["validateTimestamp"],
	            default: function _default() {
	                return Object(_timestamp__WEBPACK_IMPORTED_MODULE_0__["parseDate"])(new Date()).date;
	            }
	        },
	        end: {
	            type: String,
	            validate: _timestamp__WEBPACK_IMPORTED_MODULE_0__["validateTimestamp"],
	            default: '0000-00-00'
	        },
	        weekdays: {
	            type: Array,
	            default: function _default() {
	                return [0, 1, 2, 3, 4, 5, 6];
	            }
	        },
	        hideHeader: {
	            type: Boolean,
	            default: false
	        },
	        shortWeekdays: {
	            type: Boolean,
	            default: true
	        },
	        weekdayFormat: {
	            type: Function,
	            default: null
	        },
	        dayFormat: {
	            type: Function,
	            default: null
	        },
	        locale: {
	            type: String,
	            default: 'en-us'
	        }
	    },
	    intervals: {
	        maxDays: {
	            type: Number,
	            default: 7
	        },
	        shortIntervals: {
	            type: Boolean,
	            default: true
	        },
	        intervalHeight: {
	            type: [Number, String],
	            default: 40,
	            validate: validateNumber
	        },
	        intervalMinutes: {
	            type: [Number, String],
	            default: 60,
	            validate: validateNumber
	        },
	        firstInterval: {
	            type: [Number, String],
	            default: 0,
	            validate: validateNumber
	        },
	        intervalCount: {
	            type: [Number, String],
	            default: 24,
	            validate: validateNumber
	        },
	        intervalFormat: {
	            type: Function,
	            default: null
	        },
	        intervalStyle: {
	            type: Function,
	            default: null
	        },
	        showIntervalLabel: {
	            type: Function,
	            default: null
	        }
	    },
	    weeks: {
	        minWeeks: {
	            validate: validateNumber,
	            default: 1
	        },
	        shortMonths: {
	            type: Boolean,
	            default: true
	        },
	        showMonthOnFirst: {
	            type: Boolean,
	            default: true
	        },
	        monthFormat: {
	            type: Function,
	            default: null
	        }
	    },
	    calendar: {
	        type: {
	            type: String,
	            default: 'month'
	        },
	        value: {
	            type: String,
	            validate: _timestamp__WEBPACK_IMPORTED_MODULE_0__["validateTimestamp"]
	        }
	    }
	});
	function validateNumber(input) {
	    return isFinite(parseInt(input));
	}
	
	/***/ }),
	
	/***/ "./src/components/VCalendar/util/timestamp.ts":
	/*!****************************************************!*\
	  !*** ./src/components/VCalendar/util/timestamp.ts ***!
	  \****************************************************/
	/*! exports provided: PARSE_REGEX, PARSE_TIME, DAYS_IN_MONTH, DAYS_IN_MONTH_LEAP, DAYS_IN_MONTH_MIN, DAYS_IN_MONTH_MAX, MONTH_MAX, MONTH_MIN, DAY_MIN, DAYS_IN_WEEK, MINUTES_IN_HOUR, HOURS_IN_DAY, FIRST_HOUR, getStartOfWeek, getEndOfWeek, getStartOfMonth, getEndOfMonth, parseTime, validateTimestamp, parseTimestamp, parseDate, getDayIdentifier, getTimeIdentifier, updateRelative, updateMinutes, updateWeekday, updateFormatted, getWeekday, isLeapYear, daysInMonth, copyTimestamp, padNumber, getDate, getTime, nextMinutes, nextDay, prevDay, relativeDays, findWeekday, getWeekdaySkips, createDayList, createIntervalList, createNativeLocaleFormatter */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PARSE_REGEX", function() { return PARSE_REGEX; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PARSE_TIME", function() { return PARSE_TIME; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DAYS_IN_MONTH", function() { return DAYS_IN_MONTH; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DAYS_IN_MONTH_LEAP", function() { return DAYS_IN_MONTH_LEAP; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DAYS_IN_MONTH_MIN", function() { return DAYS_IN_MONTH_MIN; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DAYS_IN_MONTH_MAX", function() { return DAYS_IN_MONTH_MAX; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MONTH_MAX", function() { return MONTH_MAX; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MONTH_MIN", function() { return MONTH_MIN; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DAY_MIN", function() { return DAY_MIN; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DAYS_IN_WEEK", function() { return DAYS_IN_WEEK; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MINUTES_IN_HOUR", function() { return MINUTES_IN_HOUR; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HOURS_IN_DAY", function() { return HOURS_IN_DAY; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FIRST_HOUR", function() { return FIRST_HOUR; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getStartOfWeek", function() { return getStartOfWeek; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEndOfWeek", function() { return getEndOfWeek; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getStartOfMonth", function() { return getStartOfMonth; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEndOfMonth", function() { return getEndOfMonth; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseTime", function() { return parseTime; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validateTimestamp", function() { return validateTimestamp; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseTimestamp", function() { return parseTimestamp; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseDate", function() { return parseDate; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDayIdentifier", function() { return getDayIdentifier; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTimeIdentifier", function() { return getTimeIdentifier; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateRelative", function() { return updateRelative; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateMinutes", function() { return updateMinutes; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateWeekday", function() { return updateWeekday; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateFormatted", function() { return updateFormatted; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getWeekday", function() { return getWeekday; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isLeapYear", function() { return isLeapYear; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "daysInMonth", function() { return daysInMonth; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "copyTimestamp", function() { return copyTimestamp; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "padNumber", function() { return padNumber; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDate", function() { return getDate; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTime", function() { return getTime; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nextMinutes", function() { return nextMinutes; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nextDay", function() { return nextDay; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "prevDay", function() { return prevDay; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "relativeDays", function() { return relativeDays; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findWeekday", function() { return findWeekday; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getWeekdaySkips", function() { return getWeekdaySkips; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createDayList", function() { return createDayList; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createIntervalList", function() { return createIntervalList; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createNativeLocaleFormatter", function() { return createNativeLocaleFormatter; });
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var PARSE_REGEX = /^(\d{4})-(\d{1,2})(-(\d{1,2}))?([^\d]+(\d{1,2}))?(:(\d{1,2}))?(:(\d{1,2}))?$/;
	var PARSE_TIME = /(\d\d?)(:(\d\d?)|)(:(\d\d?)|)/;
	var DAYS_IN_MONTH = [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	var DAYS_IN_MONTH_LEAP = [0, 31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	var DAYS_IN_MONTH_MIN = 28;
	var DAYS_IN_MONTH_MAX = 31;
	var MONTH_MAX = 12;
	var MONTH_MIN = 1;
	var DAY_MIN = 1;
	var DAYS_IN_WEEK = 7;
	var MINUTES_IN_HOUR = 60;
	var HOURS_IN_DAY = 24;
	var FIRST_HOUR = 0;
	function getStartOfWeek(timestamp, weekdays, today) {
	    var start = copyTimestamp(timestamp);
	    findWeekday(start, weekdays[0], prevDay);
	    updateFormatted(start);
	    if (today) {
	        updateRelative(start, today, start.hasTime);
	    }
	    return start;
	}
	function getEndOfWeek(timestamp, weekdays, today) {
	    var end = copyTimestamp(timestamp);
	    findWeekday(end, weekdays[weekdays.length - 1]);
	    updateFormatted(end);
	    if (today) {
	        updateRelative(end, today, end.hasTime);
	    }
	    return end;
	}
	function getStartOfMonth(timestamp) {
	    var start = copyTimestamp(timestamp);
	    start.day = DAY_MIN;
	    updateWeekday(start);
	    updateFormatted(start);
	    return start;
	}
	function getEndOfMonth(timestamp) {
	    var end = copyTimestamp(timestamp);
	    end.day = daysInMonth(end.year, end.month);
	    updateWeekday(end);
	    updateFormatted(end);
	    return end;
	}
	function parseTime(input) {
	    if (typeof input === 'number') {
	        // when a number is given, it's minutes since 12:00am
	        return input;
	    } else if (typeof input === 'string') {
	        // when a string is given, it's a hh:mm:ss format where seconds are optional
	        var parts = PARSE_TIME.exec(input);
	        if (!parts) {
	            return false;
	        }
	        return parseInt(parts[1]) * 60 + parseInt(parts[3] || 0);
	    } else if ((typeof input === 'undefined' ? 'undefined' : _typeof(input)) === 'object') {
	        // when an object is given, it must have hour and minute
	        if (typeof input.hour !== 'number' || typeof input.minute !== 'number') {
	            return false;
	        }
	        return input.hour * 60 + input.minute;
	    } else {
	        // unsupported type
	        return false;
	    }
	}
	function validateTimestamp(input) {
	    return !!PARSE_REGEX.exec(input);
	}
	function parseTimestamp(input, now) {
	    // YYYY-MM-DD hh:mm:ss
	    var parts = PARSE_REGEX.exec(input);
	    if (!parts) return null;
	    var timestamp = {
	        date: input,
	        time: '',
	        year: parseInt(parts[1]),
	        month: parseInt(parts[2]),
	        day: parseInt(parts[4]) || 1,
	        hour: parseInt(parts[6]) || 0,
	        minute: parseInt(parts[8]) || 0,
	        weekday: 0,
	        hasDay: !!parts[4],
	        hasTime: !!(parts[6] && parts[8]),
	        past: false,
	        present: false,
	        future: false
	    };
	    updateWeekday(timestamp);
	    updateFormatted(timestamp);
	    if (now) {
	        updateRelative(timestamp, now, timestamp.hasTime);
	    }
	    return timestamp;
	}
	function parseDate(date) {
	    return updateFormatted({
	        date: '',
	        time: '',
	        year: date.getFullYear(),
	        month: date.getMonth() + 1,
	        day: date.getDate(),
	        weekday: date.getDay(),
	        hour: date.getHours(),
	        minute: date.getMinutes(),
	        hasDay: true,
	        hasTime: true,
	        past: false,
	        present: true,
	        future: false
	    });
	}
	function getDayIdentifier(timestamp) {
	    return timestamp.year * 10000 + timestamp.month * 100 + timestamp.day;
	}
	function getTimeIdentifier(timestamp) {
	    return timestamp.hour * 100 + timestamp.minute;
	}
	function updateRelative(timestamp, now, time) {
	    if (time === void 0) {
	        time = false;
	    }
	    var a = getDayIdentifier(now);
	    var b = getDayIdentifier(timestamp);
	    var present = a === b;
	    if (timestamp.hasTime && time && present) {
	        a = getTimeIdentifier(now);
	        b = getTimeIdentifier(timestamp);
	        present = a === b;
	    }
	    timestamp.past = b < a;
	    timestamp.present = present;
	    timestamp.future = b > a;
	    return timestamp;
	}
	function updateMinutes(timestamp, minutes, now) {
	    timestamp.hasTime = true;
	    timestamp.hour = Math.floor(minutes / MINUTES_IN_HOUR);
	    timestamp.minute = minutes % MINUTES_IN_HOUR;
	    timestamp.time = getTime(timestamp);
	    if (now) {
	        updateRelative(timestamp, now, true);
	    }
	    return timestamp;
	}
	function updateWeekday(timestamp) {
	    timestamp.weekday = getWeekday(timestamp);
	    return timestamp;
	}
	function updateFormatted(timestamp) {
	    timestamp.time = getTime(timestamp);
	    timestamp.date = getDate(timestamp);
	    return timestamp;
	}
	function getWeekday(timestamp) {
	    if (timestamp.hasDay) {
	        var _ = Math.floor;
	        var k = timestamp.day;
	        var m = (timestamp.month + 9) % MONTH_MAX + 1;
	        var C = _(timestamp.year / 100);
	        var Y = timestamp.year % 100 - (timestamp.month <= 2 ? 1 : 0);
	        return ((k + _(2.6 * m - 0.2) - 2 * C + Y + _(Y / 4) + _(C / 4)) % 7 + 7) % 7;
	    }
	    return timestamp.weekday;
	}
	function isLeapYear(year) {
	    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
	}
	function daysInMonth(year, month) {
	    return isLeapYear(year) ? DAYS_IN_MONTH_LEAP[month] : DAYS_IN_MONTH[month];
	}
	function copyTimestamp(timestamp) {
	    var date = timestamp.date,
	        time = timestamp.time,
	        year = timestamp.year,
	        month = timestamp.month,
	        day = timestamp.day,
	        weekday = timestamp.weekday,
	        hour = timestamp.hour,
	        minute = timestamp.minute,
	        hasDay = timestamp.hasDay,
	        hasTime = timestamp.hasTime,
	        past = timestamp.past,
	        present = timestamp.present,
	        future = timestamp.future;
	    return { date: date, time: time, year: year, month: month, day: day, weekday: weekday, hour: hour, minute: minute, hasDay: hasDay, hasTime: hasTime, past: past, present: present, future: future };
	}
	function padNumber(x, length) {
	    var padded = String(x);
	    while (padded.length < length) {
	        padded = '0' + padded;
	    }
	    return padded;
	}
	function getDate(timestamp) {
	    var str = padNumber(timestamp.year, 4) + "-" + padNumber(timestamp.month, 2);
	    if (timestamp.hasDay) str += "-" + padNumber(timestamp.day, 2);
	    return str;
	}
	function getTime(timestamp) {
	    if (!timestamp.hasTime) {
	        return '';
	    }
	    return padNumber(timestamp.hour, 2) + ":" + padNumber(timestamp.minute, 2);
	}
	function nextMinutes(timestamp, minutes) {
	    timestamp.minute += minutes;
	    while (timestamp.minute > MINUTES_IN_HOUR) {
	        timestamp.minute -= MINUTES_IN_HOUR;
	        timestamp.hour++;
	        if (timestamp.hour >= HOURS_IN_DAY) {
	            nextDay(timestamp);
	            timestamp.hour = FIRST_HOUR;
	        }
	    }
	    return timestamp;
	}
	function nextDay(timestamp) {
	    timestamp.day++;
	    timestamp.weekday = (timestamp.weekday + 1) % DAYS_IN_WEEK;
	    if (timestamp.day > DAYS_IN_MONTH_MIN && timestamp.day > daysInMonth(timestamp.year, timestamp.month)) {
	        timestamp.day = DAY_MIN;
	        timestamp.month++;
	        if (timestamp.month > MONTH_MAX) {
	            timestamp.month = MONTH_MIN;
	            timestamp.year++;
	        }
	    }
	    return timestamp;
	}
	function prevDay(timestamp) {
	    timestamp.day--;
	    timestamp.weekday = (timestamp.weekday + 6) % DAYS_IN_WEEK;
	    if (timestamp.day < DAY_MIN) {
	        timestamp.month--;
	        if (timestamp.month < MONTH_MIN) {
	            timestamp.year--;
	            timestamp.month = MONTH_MAX;
	        }
	        timestamp.day = daysInMonth(timestamp.year, timestamp.month);
	    }
	    return timestamp;
	}
	function relativeDays(timestamp, mover, days) {
	    if (mover === void 0) {
	        mover = nextDay;
	    }
	    if (days === void 0) {
	        days = 1;
	    }
	    while (--days >= 0) {
	        mover(timestamp);
	    }return timestamp;
	}
	function findWeekday(timestamp, weekday, mover, maxDays) {
	    if (mover === void 0) {
	        mover = nextDay;
	    }
	    if (maxDays === void 0) {
	        maxDays = 6;
	    }
	    while (timestamp.weekday !== weekday && --maxDays >= 0) {
	        mover(timestamp);
	    }return timestamp;
	}
	function getWeekdaySkips(weekdays) {
	    var skips = [1, 1, 1, 1, 1, 1, 1];
	    var filled = [0, 0, 0, 0, 0, 0, 0];
	    for (var i = 0; i < weekdays.length; i++) {
	        filled[weekdays[i]] = 1;
	    }
	    for (var k = 0; k < DAYS_IN_WEEK; k++) {
	        var skip = 1;
	        for (var j = 1; j < DAYS_IN_WEEK; j++) {
	            var next = (k + j) % DAYS_IN_WEEK;
	            if (filled[next]) {
	                break;
	            }
	            skip++;
	        }
	        skips[k] = filled[k] * skip;
	    }
	    return skips;
	}
	function createDayList(start, end, now, weekdaySkips, max, min) {
	    if (max === void 0) {
	        max = 42;
	    }
	    if (min === void 0) {
	        min = 0;
	    }
	    var stop = getDayIdentifier(end);
	    var days = [];
	    var current = copyTimestamp(start);
	    var currentIdentifier = 0;
	    var stopped = currentIdentifier === stop;
	    if (stop < getDayIdentifier(start)) {
	        return days;
	    }
	    while ((!stopped || days.length < min) && days.length < max) {
	        currentIdentifier = getDayIdentifier(current);
	        stopped = stopped || currentIdentifier === stop;
	        if (weekdaySkips[current.weekday] === 0) {
	            current = nextDay(current);
	            continue;
	        }
	        var day = copyTimestamp(current);
	        updateFormatted(day);
	        updateRelative(day, now);
	        days.push(day);
	        current = relativeDays(current, nextDay, weekdaySkips[current.weekday]);
	    }
	    return days;
	}
	function createIntervalList(timestamp, first, minutes, count, now) {
	    var intervals = [];
	    for (var i = 0; i < count; i++) {
	        var mins = (first + i) * minutes;
	        var int = copyTimestamp(timestamp);
	        intervals.push(updateMinutes(int, mins, now));
	    }
	    return intervals;
	}
	function createNativeLocaleFormatter(locale, getOptions) {
	    var emptyFormatter = function emptyFormatter(_t, _s) {
	        return '';
	    };
	    if (typeof Intl === 'undefined' || typeof Intl.DateTimeFormat === 'undefined') {
	        return emptyFormatter;
	    }
	    return function (timestamp, short) {
	        try {
	            var intlFormatter = new Intl.DateTimeFormat(locale || undefined, getOptions(timestamp, short));
	            var time = padNumber(timestamp.hour, 2) + ":" + padNumber(timestamp.minute, 2);
	            var date = timestamp.date;
	            return intlFormatter.format(new Date(date + "T" + time + ":00+00:00"));
	        } catch (e) {
	            return '';
	        }
	    };
	}
	
	/***/ }),
	
	/***/ "./src/components/VCard/VCard.ts":
	/*!***************************************!*\
	  !*** ./src/components/VCard/VCard.ts ***!
	  \***************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_cards_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_cards.styl */ "./src/stylus/components/_cards.styl");
	/* harmony import */ var _stylus_components_cards_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_cards_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _VSheet__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../VSheet */ "./src/components/VSheet/index.ts");
	/* harmony import */ var _mixins_routable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/routable */ "./src/mixins/routable.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	// Styles
	
	// Extensions
	
	// Mixins
	
	// Helpers
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_3__["default"])(_mixins_routable__WEBPACK_IMPORTED_MODULE_2__["default"], _VSheet__WEBPACK_IMPORTED_MODULE_1__["default"]).extend({
	    name: 'v-card',
	    props: {
	        flat: Boolean,
	        hover: Boolean,
	        img: String,
	        raised: Boolean
	    },
	    computed: {
	        classes: function classes() {
	            return __assign({ 'v-card': true, 'v-card--flat': this.flat, 'v-card--hover': this.hover }, _VSheet__WEBPACK_IMPORTED_MODULE_1__["default"].options.computed.classes.call(this));
	        },
	        styles: function styles() {
	            var style = __assign({}, _VSheet__WEBPACK_IMPORTED_MODULE_1__["default"].options.computed.styles.call(this));
	            if (this.img) {
	                style.background = "url(\"" + this.img + "\") center center / cover no-repeat";
	            }
	            return style;
	        }
	    },
	    render: function render(h) {
	        var _a = this.generateRouteLink(this.classes),
	            tag = _a.tag,
	            data = _a.data;
	        data.style = this.styles;
	        return h(tag, this.setBackgroundColor(this.color, data), this.$slots.default);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VCard/VCardMedia.ts":
	/*!********************************************!*\
	  !*** ./src/components/VCard/VCardMedia.ts ***!
	  \********************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VImg_VImg__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../VImg/VImg */ "./src/components/VImg/VImg.ts");
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../util/console */ "./src/util/console.ts");
	// Components
	
	// Utils
	
	/* istanbul ignore next */
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (_VImg_VImg__WEBPACK_IMPORTED_MODULE_0__["default"].extend({
	    name: 'v-card-media',
	    mounted: function mounted() {
	        Object(_util_console__WEBPACK_IMPORTED_MODULE_1__["deprecate"])('v-card-media', this.src ? 'v-img' : 'v-responsive', this);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VCard/VCardTitle.ts":
	/*!********************************************!*\
	  !*** ./src/components/VCard/VCardTitle.ts ***!
	  \********************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
	// Types
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
	    name: 'v-card-title',
	    functional: true,
	    props: {
	        primaryTitle: Boolean
	    },
	    render: function render(h, _a) {
	        var data = _a.data,
	            props = _a.props,
	            children = _a.children;
	        data.staticClass = ("v-card__title " + (data.staticClass || '')).trim();
	        if (props.primaryTitle) data.staticClass += ' v-card__title--primary';
	        return h('div', data, children);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VCard/index.ts":
	/*!***************************************!*\
	  !*** ./src/components/VCard/index.ts ***!
	  \***************************************/
	/*! exports provided: VCard, VCardMedia, VCardTitle, VCardActions, VCardText, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VCardActions", function() { return VCardActions; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VCardText", function() { return VCardText; });
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var _VCard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./VCard */ "./src/components/VCard/VCard.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VCard", function() { return _VCard__WEBPACK_IMPORTED_MODULE_1__["default"]; });
	
	/* harmony import */ var _VCardMedia__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./VCardMedia */ "./src/components/VCard/VCardMedia.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VCardMedia", function() { return _VCardMedia__WEBPACK_IMPORTED_MODULE_2__["default"]; });
	
	/* harmony import */ var _VCardTitle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./VCardTitle */ "./src/components/VCard/VCardTitle.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VCardTitle", function() { return _VCardTitle__WEBPACK_IMPORTED_MODULE_3__["default"]; });
	
	
	
	
	
	var VCardActions = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleFunctional"])('v-card__actions');
	var VCardText = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleFunctional"])('v-card__text');
	
	/* harmony default export */ __webpack_exports__["default"] = ({
	    $_vuetify_subcomponents: {
	        VCard: _VCard__WEBPACK_IMPORTED_MODULE_1__["default"],
	        VCardMedia: _VCardMedia__WEBPACK_IMPORTED_MODULE_2__["default"],
	        VCardTitle: _VCardTitle__WEBPACK_IMPORTED_MODULE_3__["default"],
	        VCardActions: VCardActions,
	        VCardText: VCardText
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VCarousel/VCarousel.ts":
	/*!***********************************************!*\
	  !*** ./src/components/VCarousel/VCarousel.ts ***!
	  \***********************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_carousel_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_carousel.styl */ "./src/stylus/components/_carousel.styl");
	/* harmony import */ var _stylus_components_carousel_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_carousel_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _VWindow_VWindow__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../VWindow/VWindow */ "./src/components/VWindow/VWindow.ts");
	/* harmony import */ var _VBtn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../VBtn */ "./src/components/VBtn/index.ts");
	/* harmony import */ var _VIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../VIcon */ "./src/components/VIcon/index.ts");
	/* harmony import */ var _mixins_button_group__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mixins/button-group */ "./src/mixins/button-group.ts");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../util/console */ "./src/util/console.ts");
	// Styles
	
	// Extensions
	
	// Components
	
	
	// Mixins
	// TODO: Move this into core components v2.0
	
	// Utilities
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VWindow_VWindow__WEBPACK_IMPORTED_MODULE_1__["default"].extend({
	    name: 'v-carousel',
	    props: {
	        cycle: {
	            type: Boolean,
	            default: true
	        },
	        delimiterIcon: {
	            type: String,
	            default: '$vuetify.icons.delimiter'
	        },
	        height: {
	            type: [Number, String],
	            default: 500
	        },
	        hideControls: Boolean,
	        hideDelimiters: Boolean,
	        interval: {
	            type: [Number, String],
	            default: 6000,
	            validator: function validator(value) {
	                return value > 0;
	            }
	        },
	        mandatory: {
	            type: Boolean,
	            default: true
	        },
	        nextIcon: {
	            type: [Boolean, String],
	            default: '$vuetify.icons.next'
	        },
	        prevIcon: {
	            type: [Boolean, String],
	            default: '$vuetify.icons.prev'
	        }
	    },
	    data: function data() {
	        return {
	            changedByDelimiters: false,
	            internalHeight: this.height,
	            slideTimeout: undefined
	        };
	    },
	    computed: {
	        isDark: function isDark() {
	            return this.dark || !this.light;
	        }
	    },
	    watch: {
	        internalValue: function internalValue(val) {
	            this.restartTimeout();
	            /* @deprecate */
	            /* istanbul ignore else */
	            if (!this.$listeners['input']) return;
	            this.$emit('input', val);
	        },
	        interval: 'restartTimeout',
	        height: function height(val, oldVal) {
	            if (val === oldVal || !val) return;
	            this.internalHeight = val;
	        },
	        cycle: function cycle(val) {
	            if (val) {
	                this.restartTimeout();
	            } else {
	                clearTimeout(this.slideTimeout);
	                this.slideTimeout = undefined;
	            }
	        }
	    },
	    mounted: function mounted() {
	        /* @deprecate */
	        /* istanbul ignore next */
	        if (this.$listeners['input']) {
	            Object(_util_console__WEBPACK_IMPORTED_MODULE_6__["deprecate"])('@input', '@change', this);
	        }
	        this.startTimeout();
	    },
	    methods: {
	        genDelimiters: function genDelimiters() {
	            return this.$createElement('div', {
	                staticClass: 'v-carousel__controls'
	            }, [this.genItems()]);
	        },
	        genIcon: function genIcon(direction, icon, fn) {
	            var _this = this;
	            return this.$createElement('div', {
	                staticClass: "v-carousel__" + direction
	            }, [this.$createElement(_VBtn__WEBPACK_IMPORTED_MODULE_2__["default"], {
	                props: {
	                    icon: true
	                },
	                attrs: {
	                    'aria-label': this.$vuetify.t("$vuetify.carousel." + direction)
	                },
	                on: {
	                    click: function click() {
	                        _this.changedByDelimiters = true;
	                        fn();
	                    }
	                }
	            }, [this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_3__["default"], {
	                props: { 'size': '46px' }
	            }, icon)])]);
	        },
	        genIcons: function genIcons() {
	            var icons = [];
	            var prevIcon = this.$vuetify.rtl ? this.nextIcon : this.prevIcon;
	            if (prevIcon && typeof prevIcon === 'string') {
	                icons.push(this.genIcon('prev', prevIcon, this.prev));
	            }
	            var nextIcon = this.$vuetify.rtl ? this.prevIcon : this.nextIcon;
	            if (nextIcon && typeof nextIcon === 'string') {
	                icons.push(this.genIcon('next', nextIcon, this.next));
	            }
	            return icons;
	        },
	        genItems: function genItems() {
	            var _this = this;
	            var length = this.items.length;
	            var children = [];
	            for (var i = 0; i < length; i++) {
	                var child = this.$createElement(_VBtn__WEBPACK_IMPORTED_MODULE_2__["default"], {
	                    class: {
	                        'v-carousel__controls__item': true
	                    },
	                    props: {
	                        icon: true,
	                        small: true,
	                        value: this.getValue(this.items[i], i)
	                    }
	                }, [this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_3__["default"], {
	                    props: { size: 18 }
	                }, this.delimiterIcon)]);
	                children.push(child);
	            }
	            return this.$createElement(_mixins_button_group__WEBPACK_IMPORTED_MODULE_4__["default"], {
	                props: {
	                    value: this.internalValue
	                },
	                on: {
	                    change: function change(val) {
	                        _this.internalValue = val;
	                    }
	                }
	            }, children);
	        },
	        restartTimeout: function restartTimeout() {
	            this.slideTimeout && clearTimeout(this.slideTimeout);
	            this.slideTimeout = undefined;
	            var raf = requestAnimationFrame || setTimeout;
	            raf(this.startTimeout);
	        },
	        startTimeout: function startTimeout() {
	            if (!this.cycle) return;
	            this.slideTimeout = window.setTimeout(this.next, +this.interval > 0 ? +this.interval : 6000);
	        },
	        updateReverse: function updateReverse(val, oldVal) {
	            if (this.changedByDelimiters) {
	                this.changedByDelimiters = false;
	                return;
	            }
	            _VWindow_VWindow__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.updateReverse.call(this, val, oldVal);
	        }
	    },
	    render: function render(h) {
	        var children = [];
	        var data = {
	            staticClass: 'v-window v-carousel',
	            style: {
	                height: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["convertToUnit"])(this.height)
	            },
	            directives: []
	        };
	        if (!this.touchless) {
	            data.directives.push({
	                name: 'touch',
	                value: {
	                    left: this.next,
	                    right: this.prev
	                }
	            });
	        }
	        if (!this.hideControls) {
	            children.push(this.genIcons());
	        }
	        if (!this.hideDelimiters) {
	            children.push(this.genDelimiters());
	        }
	        return h('div', data, [this.genContainer(), children]);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VCarousel/VCarouselItem.ts":
	/*!***************************************************!*\
	  !*** ./src/components/VCarousel/VCarouselItem.ts ***!
	  \***************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VWindow_VWindowItem__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../VWindow/VWindowItem */ "./src/components/VWindow/VWindowItem.ts");
	/* harmony import */ var _VImg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../VImg */ "./src/components/VImg/index.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	// Extensions
	
	// Components
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (_VWindow_VWindowItem__WEBPACK_IMPORTED_MODULE_0__["default"].extend({
	    name: 'v-carousel-item',
	    inheritAttrs: false,
	    methods: {
	        genDefaultSlot: function genDefaultSlot() {
	            return [this.$createElement(_VImg__WEBPACK_IMPORTED_MODULE_1__["VImg"], {
	                staticClass: 'v-carousel__item',
	                props: __assign({}, this.$attrs, { height: this.windowGroup.internalHeight }),
	                on: this.$listeners
	            }, this.$slots.default)];
	        },
	        onBeforeEnter: function onBeforeEnter() {},
	        onEnter: function onEnter() {},
	        onAfterEnter: function onAfterEnter() {},
	        onBeforeLeave: function onBeforeLeave() {},
	        onEnterCancelled: function onEnterCancelled() {}
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VCarousel/index.ts":
	/*!*******************************************!*\
	  !*** ./src/components/VCarousel/index.ts ***!
	  \*******************************************/
	/*! exports provided: VCarousel, VCarouselItem, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VCarousel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VCarousel */ "./src/components/VCarousel/VCarousel.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VCarousel", function() { return _VCarousel__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	/* harmony import */ var _VCarouselItem__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./VCarouselItem */ "./src/components/VCarousel/VCarouselItem.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VCarouselItem", function() { return _VCarouselItem__WEBPACK_IMPORTED_MODULE_1__["default"]; });
	
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = ({
	    $_vuetify_subcomponents: {
	        VCarousel: _VCarousel__WEBPACK_IMPORTED_MODULE_0__["default"],
	        VCarouselItem: _VCarouselItem__WEBPACK_IMPORTED_MODULE_1__["default"]
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VCheckbox/VCheckbox.js":
	/*!***********************************************!*\
	  !*** ./src/components/VCheckbox/VCheckbox.js ***!
	  \***********************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_selection_controls_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_selection-controls.styl */ "./src/stylus/components/_selection-controls.styl");
	/* harmony import */ var _stylus_components_selection_controls_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_selection_controls_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _VIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../VIcon */ "./src/components/VIcon/index.ts");
	/* harmony import */ var _mixins_selectable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/selectable */ "./src/mixins/selectable.js");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	// Styles
	
	// Components
	
	// import { VFadeTransition } from '../transitions'
	// Mixins
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-checkbox',
	    mixins: [_mixins_selectable__WEBPACK_IMPORTED_MODULE_2__["default"]],
	    props: {
	        indeterminate: Boolean,
	        indeterminateIcon: {
	            type: String,
	            default: '$vuetify.icons.checkboxIndeterminate'
	        },
	        onIcon: {
	            type: String,
	            default: '$vuetify.icons.checkboxOn'
	        },
	        offIcon: {
	            type: String,
	            default: '$vuetify.icons.checkboxOff'
	        }
	    },
	    data: function data(vm) {
	        return {
	            inputIndeterminate: vm.indeterminate
	        };
	    },
	    computed: {
	        classes: function classes() {
	            return {
	                'v-input--selection-controls': true,
	                'v-input--checkbox': true
	            };
	        },
	        computedIcon: function computedIcon() {
	            if (this.inputIndeterminate) {
	                return this.indeterminateIcon;
	            } else if (this.isActive) {
	                return this.onIcon;
	            } else {
	                return this.offIcon;
	            }
	        }
	    },
	    watch: {
	        indeterminate: function indeterminate(val) {
	            this.inputIndeterminate = val;
	        }
	    },
	    methods: {
	        genCheckbox: function genCheckbox() {
	            return this.$createElement('div', {
	                staticClass: 'v-input--selection-controls__input'
	            }, [this.genInput('checkbox', __assign({}, this.$attrs, { 'aria-checked': this.inputIndeterminate ? 'mixed' : this.isActive.toString() })), this.genRipple(this.setTextColor(this.computedColor)), this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_1__["default"], this.setTextColor(this.computedColor, {
	                props: {
	                    dark: this.dark,
	                    light: this.light
	                }
	            }), this.computedIcon)]);
	        },
	        genDefaultSlot: function genDefaultSlot() {
	            return [this.genCheckbox(), this.genLabel()];
	        }
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VCheckbox/index.js":
	/*!*******************************************!*\
	  !*** ./src/components/VCheckbox/index.js ***!
	  \*******************************************/
	/*! exports provided: VCheckbox, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VCheckbox__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VCheckbox */ "./src/components/VCheckbox/VCheckbox.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VCheckbox", function() { return _VCheckbox__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VCheckbox__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VChip/VChip.ts":
	/*!***************************************!*\
	  !*** ./src/components/VChip/VChip.ts ***!
	  \***************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_chips_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_chips.styl */ "./src/stylus/components/_chips.styl");
	/* harmony import */ var _stylus_components_chips_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_chips_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	/* harmony import */ var _VIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../VIcon */ "./src/components/VIcon/index.ts");
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _mixins_toggleable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mixins/toggleable */ "./src/mixins/toggleable.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	
	
	// Components
	
	// Mixins
	
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_1__["default"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_3__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_4__["default"], _mixins_toggleable__WEBPACK_IMPORTED_MODULE_5__["default"]).extend({
	    name: 'v-chip',
	    props: {
	        close: Boolean,
	        disabled: Boolean,
	        label: Boolean,
	        outline: Boolean,
	        // Used for selects/tagging
	        selected: Boolean,
	        small: Boolean,
	        textColor: String,
	        value: {
	            type: Boolean,
	            default: true
	        }
	    },
	    computed: {
	        classes: function classes() {
	            return __assign({ 'v-chip--disabled': this.disabled, 'v-chip--selected': this.selected && !this.disabled, 'v-chip--label': this.label, 'v-chip--outline': this.outline, 'v-chip--small': this.small, 'v-chip--removable': this.close }, this.themeClasses);
	        }
	    },
	    methods: {
	        genClose: function genClose(h) {
	            var _this = this;
	            var data = {
	                staticClass: 'v-chip__close',
	                on: {
	                    click: function click(e) {
	                        e.stopPropagation();
	                        _this.$emit('input', false);
	                    }
	                }
	            };
	            return h('div', data, [h(_VIcon__WEBPACK_IMPORTED_MODULE_2__["default"], '$vuetify.icons.delete')]);
	        },
	        genContent: function genContent(h) {
	            return h('span', {
	                staticClass: 'v-chip__content'
	            }, [this.$slots.default, this.close && this.genClose(h)]);
	        }
	    },
	    render: function render(h) {
	        var data = this.setBackgroundColor(this.color, {
	            staticClass: 'v-chip',
	            'class': this.classes,
	            attrs: { tabindex: this.disabled ? -1 : 0 },
	            directives: [{
	                name: 'show',
	                value: this.isActive
	            }],
	            on: this.$listeners
	        });
	        var color = this.textColor || this.outline && this.color;
	        return h('span', this.setTextColor(color, data), [this.genContent(h)]);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VChip/index.ts":
	/*!***************************************!*\
	  !*** ./src/components/VChip/index.ts ***!
	  \***************************************/
	/*! exports provided: VChip, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VChip__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VChip */ "./src/components/VChip/VChip.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VChip", function() { return _VChip__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VChip__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VCombobox/VCombobox.js":
	/*!***********************************************!*\
	  !*** ./src/components/VCombobox/VCombobox.js ***!
	  \***********************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_autocompletes_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_autocompletes.styl */ "./src/stylus/components/_autocompletes.styl");
	/* harmony import */ var _stylus_components_autocompletes_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_autocompletes_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../VSelect/VSelect */ "./src/components/VSelect/VSelect.js");
	/* harmony import */ var _VAutocomplete_VAutocomplete__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../VAutocomplete/VAutocomplete */ "./src/components/VAutocomplete/VAutocomplete.js");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	// Styles
	
	// Extensions
	
	
	// Utils
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-combobox',
	    extends: _VAutocomplete_VAutocomplete__WEBPACK_IMPORTED_MODULE_2__["default"],
	    props: {
	        delimiters: {
	            type: Array,
	            default: function _default() {
	                return [];
	            }
	        },
	        returnObject: {
	            type: Boolean,
	            default: true
	        }
	    },
	    data: function data() {
	        return {
	            editingIndex: -1
	        };
	    },
	    computed: {
	        counterValue: function counterValue() {
	            return this.multiple ? this.selectedItems.length : (this.internalSearch || '').toString().length;
	        },
	        hasSlot: function hasSlot() {
	            return _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].options.computed.hasSlot.call(this) || this.multiple;
	        },
	        isAnyValueAllowed: function isAnyValueAllowed() {
	            return true;
	        },
	        menuCanShow: function menuCanShow() {
	            if (!this.isFocused) return false;
	            return this.hasDisplayedItems || !!this.$slots['no-data'] && !this.hideNoData;
	        }
	    },
	    methods: {
	        onFilteredItemsChanged: function onFilteredItemsChanged() {
	            // nop
	        },
	        onInternalSearchChanged: function onInternalSearchChanged(val) {
	            if (val && this.multiple && this.delimiters.length) {
	                var delimiter = this.delimiters.find(function (d) {
	                    return val.endsWith(d);
	                });
	                if (delimiter != null) {
	                    this.internalSearch = val.slice(0, val.length - delimiter.length);
	                    this.updateTags();
	                }
	            }
	            this.updateMenuDimensions();
	        },
	        genChipSelection: function genChipSelection(item, index) {
	            var _this = this;
	            var chip = _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.genChipSelection.call(this, item, index);
	            // Allow user to update an existing value
	            if (this.multiple) {
	                chip.componentOptions.listeners.dblclick = function () {
	                    _this.editingIndex = index;
	                    _this.internalSearch = _this.getText(item);
	                    _this.selectedIndex = -1;
	                };
	            }
	            return chip;
	        },
	        onChipInput: function onChipInput(item) {
	            _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.onChipInput.call(this, item);
	            this.editingIndex = -1;
	        },
	        // Requires a manual definition
	        // to overwrite removal in v-autocomplete
	        onEnterDown: function onEnterDown(e) {
	            e.preventDefault();
	            _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.onEnterDown.call(this);
	            // If has menu index, let v-select-list handle
	            if (this.getMenuIndex() > -1) return;
	            this.updateSelf();
	        },
	        onKeyDown: function onKeyDown(e) {
	            var keyCode = e.keyCode;
	            _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.onKeyDown.call(this, e);
	            // If user is at selection index of 0
	            // create a new tag
	            if (this.multiple && keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_3__["keyCodes"].left && this.$refs.input.selectionStart === 0) {
	                this.updateSelf();
	            }
	            // The ordering is important here
	            // allows new value to be updated
	            // and then moves the index to the
	            // proper location
	            this.changeSelectedIndex(keyCode);
	        },
	        onTabDown: function onTabDown(e) {
	            // When adding tags, if searching and
	            // there is not a filtered options,
	            // add the value to the tags list
	            if (this.multiple && this.internalSearch && this.getMenuIndex() === -1) {
	                e.preventDefault();
	                e.stopPropagation();
	                return this.updateTags();
	            }
	            _VAutocomplete_VAutocomplete__WEBPACK_IMPORTED_MODULE_2__["default"].options.methods.onTabDown.call(this, e);
	        },
	        selectItem: function selectItem(item) {
	            // Currently only supports items:<string[]>
	            if (this.editingIndex > -1) {
	                this.updateEditing();
	            } else {
	                _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.selectItem.call(this, item);
	            }
	        },
	        setSelectedItems: function setSelectedItems() {
	            if (this.internalValue == null || this.internalValue === '') {
	                this.selectedItems = [];
	            } else {
	                this.selectedItems = this.multiple ? this.internalValue : [this.internalValue];
	            }
	        },
	        setValue: function setValue(value) {
	            if (value === void 0) {
	                value = this.internalSearch;
	            }
	            _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.setValue.call(this, value);
	        },
	        updateEditing: function updateEditing() {
	            var value = this.internalValue.slice();
	            value[this.editingIndex] = this.internalSearch;
	            this.setValue(value);
	            this.editingIndex = -1;
	        },
	        updateCombobox: function updateCombobox() {
	            var isUsingSlot = Boolean(this.$scopedSlots.selection) || this.hasChips;
	            // If search is not dirty and is
	            // using slot, do nothing
	            if (isUsingSlot && !this.searchIsDirty) return;
	            // The internal search is not matching
	            // the internal value, update the input
	            if (this.internalSearch !== this.getText(this.internalValue)) this.setValue();
	            // Reset search if using slot
	            // to avoid a double input
	            if (isUsingSlot) this.internalSearch = undefined;
	        },
	        updateSelf: function updateSelf() {
	            this.multiple ? this.updateTags() : this.updateCombobox();
	        },
	        updateTags: function updateTags() {
	            var menuIndex = this.getMenuIndex();
	            // If the user is not searching
	            // and no menu item is selected
	            // do nothing
	            if (menuIndex < 0 && !this.searchIsDirty) return;
	            if (this.editingIndex > -1) {
	                return this.updateEditing();
	            }
	            var index = this.selectedItems.indexOf(this.internalSearch);
	            // If it already exists, do nothing
	            // this might need to change to bring
	            // the duplicated item to the last entered
	            if (index > -1) {
	                var internalValue = this.internalValue.slice();
	                internalValue.splice(index, 1);
	                this.setValue(internalValue);
	            }
	            // If menu index is greater than 1
	            // the selection is handled elsewhere
	            // TODO: find out where
	            if (menuIndex > -1) return this.internalSearch = null;
	            this.selectItem(this.internalSearch);
	            this.internalSearch = null;
	        }
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VCombobox/index.js":
	/*!*******************************************!*\
	  !*** ./src/components/VCombobox/index.js ***!
	  \*******************************************/
	/*! exports provided: VCombobox, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VCombobox__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VCombobox */ "./src/components/VCombobox/VCombobox.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VCombobox", function() { return _VCombobox__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VCombobox__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VCounter/VCounter.ts":
	/*!*********************************************!*\
	  !*** ./src/components/VCounter/VCounter.ts ***!
	  \*********************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_counters_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_counters.styl */ "./src/stylus/components/_counters.styl");
	/* harmony import */ var _stylus_components_counters_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_counters_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	// Styles
	
	// Mixins
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_2__["default"])(_mixins_themeable__WEBPACK_IMPORTED_MODULE_1__["default"]).extend({
	    name: 'v-counter',
	    functional: true,
	    props: {
	        value: {
	            type: [Number, String],
	            default: ''
	        },
	        max: [Number, String]
	    },
	    render: function render(h, ctx) {
	        var props = ctx.props;
	        var max = parseInt(props.max, 10);
	        var value = parseInt(props.value, 10);
	        var content = max ? value + " / " + max : String(props.value);
	        var isGreater = max && value > max;
	        return h('div', {
	            staticClass: 'v-counter',
	            class: __assign({ 'error--text': isGreater }, Object(_mixins_themeable__WEBPACK_IMPORTED_MODULE_1__["functionalThemeClasses"])(ctx))
	        }, content);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VCounter/index.ts":
	/*!******************************************!*\
	  !*** ./src/components/VCounter/index.ts ***!
	  \******************************************/
	/*! exports provided: VCounter, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VCounter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VCounter */ "./src/components/VCounter/VCounter.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VCounter", function() { return _VCounter__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VCounter__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VDataIterator/VDataIterator.js":
	/*!*******************************************************!*\
	  !*** ./src/components/VDataIterator/VDataIterator.js ***!
	  \*******************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_data_iterator_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_data-iterator.styl */ "./src/stylus/components/_data-iterator.styl");
	/* harmony import */ var _stylus_components_data_iterator_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_data_iterator_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_data_iterable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/data-iterable */ "./src/mixins/data-iterable.js");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-data-iterator',
	    mixins: [_mixins_data_iterable__WEBPACK_IMPORTED_MODULE_1__["default"]],
	    inheritAttrs: false,
	    props: {
	        contentTag: {
	            type: String,
	            default: 'div'
	        },
	        contentProps: {
	            type: Object,
	            required: false
	        },
	        contentClass: {
	            type: String,
	            required: false
	        }
	    },
	    computed: {
	        classes: function classes() {
	            return __assign({ 'v-data-iterator': true, 'v-data-iterator--select-all': this.selectAll !== false }, this.themeClasses);
	        }
	    },
	    created: function created() {
	        this.initPagination();
	    },
	    methods: {
	        genContent: function genContent() {
	            var children = this.genItems();
	            var data = {
	                'class': this.contentClass,
	                attrs: this.$attrs,
	                on: this.$listeners,
	                props: this.contentProps
	            };
	            return this.$createElement(this.contentTag, data, children);
	        },
	        genEmptyItems: function genEmptyItems(content) {
	            return [this.$createElement('div', {
	                'class': 'text-xs-center',
	                style: 'width: 100%'
	            }, content)];
	        },
	        genFilteredItems: function genFilteredItems() {
	            if (!this.$scopedSlots.item) {
	                return null;
	            }
	            var items = [];
	            for (var index = 0, len = this.filteredItems.length; index < len; ++index) {
	                var item = this.filteredItems[index];
	                var props = this.createProps(item, index);
	                items.push(this.$scopedSlots.item(props));
	            }
	            return items;
	        },
	        genFooter: function genFooter() {
	            var children = [];
	            if (this.$slots.footer) {
	                children.push(this.$slots.footer);
	            }
	            if (!this.hideActions) {
	                children.push(this.genActions());
	            }
	            if (!children.length) return null;
	            return this.$createElement('div', children);
	        },
	        genHeader: function genHeader() {
	            var children = [];
	            if (this.$slots.header) {
	                children.push(this.$slots.header);
	            }
	            if (!children.length) return null;
	            return this.$createElement('div', children);
	        }
	    },
	    render: function render(h) {
	        return h('div', {
	            'class': this.classes
	        }, [this.genHeader(), this.genContent(), this.genFooter()]);
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VDataIterator/index.js":
	/*!***********************************************!*\
	  !*** ./src/components/VDataIterator/index.js ***!
	  \***********************************************/
	/*! exports provided: VDataIterator, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VDataIterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VDataIterator */ "./src/components/VDataIterator/VDataIterator.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VDataIterator", function() { return _VDataIterator__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VDataIterator__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VDataTable/VDataTable.js":
	/*!*************************************************!*\
	  !*** ./src/components/VDataTable/VDataTable.js ***!
	  \*************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_tables_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_tables.styl */ "./src/stylus/components/_tables.styl");
	/* harmony import */ var _stylus_components_tables_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_tables_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _stylus_components_data_table_styl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../stylus/components/_data-table.styl */ "./src/stylus/components/_data-table.styl");
	/* harmony import */ var _stylus_components_data_table_styl__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_data_table_styl__WEBPACK_IMPORTED_MODULE_1__);
	/* harmony import */ var _mixins_data_iterable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/data-iterable */ "./src/mixins/data-iterable.js");
	/* harmony import */ var _mixins_head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./mixins/head */ "./src/components/VDataTable/mixins/head.js");
	/* harmony import */ var _mixins_body__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./mixins/body */ "./src/components/VDataTable/mixins/body.js");
	/* harmony import */ var _mixins_foot__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./mixins/foot */ "./src/components/VDataTable/mixins/foot.js");
	/* harmony import */ var _mixins_progress__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./mixins/progress */ "./src/components/VDataTable/mixins/progress.js");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	
	
	
	
	
	
	
	
	// Importing does not work properly
	var VTableOverflow = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["createSimpleFunctional"])('v-table__overflow');
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-data-table',
	    mixins: [_mixins_data_iterable__WEBPACK_IMPORTED_MODULE_2__["default"], _mixins_head__WEBPACK_IMPORTED_MODULE_3__["default"], _mixins_body__WEBPACK_IMPORTED_MODULE_4__["default"], _mixins_foot__WEBPACK_IMPORTED_MODULE_5__["default"], _mixins_progress__WEBPACK_IMPORTED_MODULE_6__["default"]],
	    props: {
	        headers: {
	            type: Array,
	            default: function _default() {
	                return [];
	            }
	        },
	        headersLength: {
	            type: Number
	        },
	        headerText: {
	            type: String,
	            default: 'text'
	        },
	        headerKey: {
	            type: String,
	            default: null
	        },
	        hideHeaders: Boolean,
	        rowsPerPageText: {
	            type: String,
	            default: '$vuetify.dataTable.rowsPerPageText'
	        },
	        customFilter: {
	            type: Function,
	            default: function _default(items, search, filter, headers) {
	                search = search.toString().toLowerCase();
	                if (search.trim() === '') return items;
	                var props = headers.map(function (h) {
	                    return h.value;
	                });
	                return items.filter(function (item) {
	                    return props.some(function (prop) {
	                        return filter(Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["getObjectValueByPath"])(item, prop, item[prop]), search);
	                    });
	                });
	            }
	        }
	    },
	    data: function data() {
	        return {
	            actionsClasses: 'v-datatable__actions',
	            actionsRangeControlsClasses: 'v-datatable__actions__range-controls',
	            actionsSelectClasses: 'v-datatable__actions__select',
	            actionsPaginationClasses: 'v-datatable__actions__pagination'
	        };
	    },
	    computed: {
	        classes: function classes() {
	            return __assign({ 'v-datatable v-table': true, 'v-datatable--select-all': this.selectAll !== false }, this.themeClasses);
	        },
	        filteredItems: function filteredItems() {
	            return this.filteredItemsImpl(this.headers);
	        },
	        headerColumns: function headerColumns() {
	            return this.headersLength || this.headers.length + (this.selectAll !== false);
	        }
	    },
	    created: function created() {
	        var firstSortable = this.headers.find(function (h) {
	            return !('sortable' in h) || h.sortable;
	        });
	        this.defaultPagination.sortBy = !this.disableInitialSort && firstSortable ? firstSortable.value : null;
	        this.initPagination();
	    },
	    methods: {
	        hasTag: function hasTag(elements, tag) {
	            return Array.isArray(elements) && elements.find(function (e) {
	                return e.tag === tag;
	            });
	        },
	        genTR: function genTR(children, data) {
	            if (data === void 0) {
	                data = {};
	            }
	            return this.$createElement('tr', data, children);
	        }
	    },
	    render: function render(h) {
	        var tableOverflow = h(VTableOverflow, {}, [h('table', {
	            'class': this.classes
	        }, [this.genTHead(), this.genTBody(), this.genTFoot()])]);
	        return h('div', [tableOverflow, this.genActionsFooter()]);
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VDataTable/VEditDialog.js":
	/*!**************************************************!*\
	  !*** ./src/components/VDataTable/VEditDialog.js ***!
	  \**************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_small_dialog_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_small-dialog.styl */ "./src/stylus/components/_small-dialog.styl");
	/* harmony import */ var _stylus_components_small_dialog_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_small_dialog_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_returnable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/returnable */ "./src/mixins/returnable.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var _VBtn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../VBtn */ "./src/components/VBtn/index.ts");
	/* harmony import */ var _VMenu__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../VMenu */ "./src/components/VMenu/index.js");
	
	// Mixins
	
	
	// Utils
	
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-edit-dialog',
	    mixins: [_mixins_returnable__WEBPACK_IMPORTED_MODULE_1__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__["default"]],
	    props: {
	        cancelText: {
	            default: 'Cancel'
	        },
	        large: Boolean,
	        lazy: Boolean,
	        persistent: Boolean,
	        saveText: {
	            default: 'Save'
	        },
	        transition: {
	            type: String,
	            default: 'slide-x-reverse-transition'
	        }
	    },
	    data: function data() {
	        return {
	            isActive: false
	        };
	    },
	    watch: {
	        isActive: function isActive(val) {
	            if (val) {
	                this.$emit('open');
	                setTimeout(this.focus, 50); // Give DOM time to paint
	            } else {
	                this.$emit('close');
	            }
	        }
	    },
	    methods: {
	        cancel: function cancel() {
	            this.isActive = false;
	            this.$emit('cancel');
	        },
	        focus: function focus() {
	            var input = this.$refs.content.querySelector('input');
	            input && input.focus();
	        },
	        genButton: function genButton(fn, text) {
	            return this.$createElement(_VBtn__WEBPACK_IMPORTED_MODULE_4__["default"], {
	                props: {
	                    flat: true,
	                    color: 'primary',
	                    light: true
	                },
	                on: { click: fn }
	            }, text);
	        },
	        genActions: function genActions() {
	            var _this = this;
	            return this.$createElement('div', {
	                'class': 'v-small-dialog__actions'
	            }, [this.genButton(this.cancel, this.cancelText), this.genButton(function () {
	                _this.save(_this.returnValue);
	                _this.$emit('save');
	            }, this.saveText)]);
	        },
	        genContent: function genContent() {
	            var _this = this;
	            return this.$createElement('div', {
	                on: {
	                    keydown: function keydown(e) {
	                        var input = _this.$refs.content.querySelector('input');
	                        e.keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_3__["keyCodes"].esc && _this.cancel();
	                        if (e.keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_3__["keyCodes"].enter && input) {
	                            _this.save(input.value);
	                            _this.$emit('save');
	                        }
	                    }
	                },
	                ref: 'content'
	            }, [this.$slots.input]);
	        }
	    },
	    render: function render(h) {
	        var _this = this;
	        return h(_VMenu__WEBPACK_IMPORTED_MODULE_5__["default"], {
	            staticClass: 'v-small-dialog',
	            class: this.themeClasses,
	            props: {
	                contentClass: 'v-small-dialog__content',
	                transition: this.transition,
	                origin: 'top right',
	                right: true,
	                value: this.isActive,
	                closeOnClick: !this.persistent,
	                closeOnContentClick: false,
	                lazy: this.lazy,
	                light: this.light,
	                dark: this.dark
	            },
	            on: {
	                input: function input(val) {
	                    return _this.isActive = val;
	                }
	            }
	        }, [h('a', {
	            slot: 'activator'
	        }, this.$slots.default), this.genContent(), this.large ? this.genActions() : null]);
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VDataTable/index.js":
	/*!********************************************!*\
	  !*** ./src/components/VDataTable/index.js ***!
	  \********************************************/
	/*! exports provided: VDataTable, VEditDialog, VTableOverflow, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VTableOverflow", function() { return VTableOverflow; });
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var _VDataTable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./VDataTable */ "./src/components/VDataTable/VDataTable.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VDataTable", function() { return _VDataTable__WEBPACK_IMPORTED_MODULE_1__["default"]; });
	
	/* harmony import */ var _VEditDialog__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./VEditDialog */ "./src/components/VDataTable/VEditDialog.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VEditDialog", function() { return _VEditDialog__WEBPACK_IMPORTED_MODULE_2__["default"]; });
	
	
	
	
	var VTableOverflow = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleFunctional"])('v-table__overflow');
	
	/* harmony default export */ __webpack_exports__["default"] = ({
	    $_vuetify_subcomponents: {
	        VDataTable: _VDataTable__WEBPACK_IMPORTED_MODULE_1__["default"],
	        VEditDialog: _VEditDialog__WEBPACK_IMPORTED_MODULE_2__["default"],
	        VTableOverflow: VTableOverflow
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VDataTable/mixins/body.js":
	/*!**************************************************!*\
	  !*** ./src/components/VDataTable/mixins/body.js ***!
	  \**************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _transitions_expand_transition__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../transitions/expand-transition */ "./src/components/transitions/expand-transition.js");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../util/helpers */ "./src/util/helpers.ts");
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    methods: {
	        genTBody: function genTBody() {
	            var children = this.genItems();
	            return this.$createElement('tbody', children);
	        },
	        genExpandedRow: function genExpandedRow(props) {
	            var children = [];
	            if (this.isExpanded(props.item)) {
	                var expand = this.$createElement('div', {
	                    class: 'v-datatable__expand-content',
	                    key: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__["getObjectValueByPath"])(props.item, this.itemKey)
	                }, [this.$scopedSlots.expand(props)]);
	                children.push(expand);
	            }
	            var transition = this.$createElement('transition-group', {
	                class: 'v-datatable__expand-col',
	                attrs: { colspan: this.headerColumns },
	                props: {
	                    tag: 'td'
	                },
	                on: Object(_transitions_expand_transition__WEBPACK_IMPORTED_MODULE_0__["default"])('v-datatable__expand-col--expanded')
	            }, children);
	            return this.genTR([transition], { class: 'v-datatable__expand-row' });
	        },
	        genFilteredItems: function genFilteredItems() {
	            if (!this.$scopedSlots.items) {
	                return null;
	            }
	            var rows = [];
	            for (var index = 0, len = this.filteredItems.length; index < len; ++index) {
	                var item = this.filteredItems[index];
	                var props = this.createProps(item, index);
	                var row = this.$scopedSlots.items(props);
	                rows.push(this.hasTag(row, 'td') ? this.genTR(row, {
	                    key: this.itemKey ? Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__["getObjectValueByPath"])(props.item, this.itemKey) : index,
	                    attrs: { active: this.isSelected(item) }
	                }) : row);
	                if (this.$scopedSlots.expand) {
	                    var expandRow = this.genExpandedRow(props);
	                    rows.push(expandRow);
	                }
	            }
	            return rows;
	        },
	        genEmptyItems: function genEmptyItems(content) {
	            if (this.hasTag(content, 'tr')) {
	                return content;
	            } else if (this.hasTag(content, 'td')) {
	                return this.genTR(content);
	            } else {
	                return this.genTR([this.$createElement('td', {
	                    class: {
	                        'text-xs-center': typeof content === 'string'
	                    },
	                    attrs: { colspan: this.headerColumns }
	                }, content)]);
	            }
	        }
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VDataTable/mixins/foot.js":
	/*!**************************************************!*\
	  !*** ./src/components/VDataTable/mixins/foot.js ***!
	  \**************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    methods: {
	        genTFoot: function genTFoot() {
	            if (!this.$slots.footer) {
	                return null;
	            }
	            var footer = this.$slots.footer;
	            var row = this.hasTag(footer, 'td') ? this.genTR(footer) : footer;
	            return this.$createElement('tfoot', [row]);
	        },
	        genActionsFooter: function genActionsFooter() {
	            if (this.hideActions) {
	                return null;
	            }
	            return this.$createElement('div', {
	                'class': this.classes
	            }, this.genActions());
	        }
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VDataTable/mixins/head.js":
	/*!**************************************************!*\
	  !*** ./src/components/VDataTable/mixins/head.js ***!
	  \**************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../util/console */ "./src/util/console.ts");
	/* harmony import */ var _VCheckbox__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../VCheckbox */ "./src/components/VCheckbox/index.js");
	/* harmony import */ var _VIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../VIcon */ "./src/components/VIcon/index.ts");
	var __read = undefined && undefined.__read || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o),
	        r,
	        ar = [],
	        e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
	            ar.push(r.value);
	        }
	    } catch (error) {
	        e = { error: error };
	    } finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        } finally {
	            if (e) throw e.error;
	        }
	    }
	    return ar;
	};
	var __spread = undefined && undefined.__spread || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) {
	        ar = ar.concat(__read(arguments[i]));
	    }return ar;
	};
	
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    props: {
	        sortIcon: {
	            type: String,
	            default: '$vuetify.icons.sort'
	        }
	    },
	    methods: {
	        genTHead: function genTHead() {
	            var _this = this;
	            if (this.hideHeaders) return; // Exit Early since no headers are needed.
	            var children = [];
	            if (this.$scopedSlots.headers) {
	                var row = this.$scopedSlots.headers({
	                    headers: this.headers,
	                    indeterminate: this.indeterminate,
	                    all: this.everyItem
	                });
	                children = [this.hasTag(row, 'th') ? this.genTR(row) : row, this.genTProgress()];
	            } else {
	                var row = this.headers.map(function (o, i) {
	                    return _this.genHeader(o, _this.headerKey ? o[_this.headerKey] : i);
	                });
	                var checkbox = this.$createElement(_VCheckbox__WEBPACK_IMPORTED_MODULE_1__["default"], {
	                    props: {
	                        dark: this.dark,
	                        light: this.light,
	                        color: this.selectAll === true ? '' : this.selectAll,
	                        hideDetails: true,
	                        inputValue: this.everyItem,
	                        indeterminate: this.indeterminate
	                    },
	                    on: { change: this.toggle }
	                });
	                this.hasSelectAll && row.unshift(this.$createElement('th', [checkbox]));
	                children = [this.genTR(row), this.genTProgress()];
	            }
	            return this.$createElement('thead', [children]);
	        },
	        genHeader: function genHeader(header, key) {
	            var array = [this.$scopedSlots.headerCell ? this.$scopedSlots.headerCell({ header: header }) : header[this.headerText]];
	            return this.$createElement.apply(this, __spread(['th'], this.genHeaderData(header, array, key)));
	        },
	        genHeaderData: function genHeaderData(header, children, key) {
	            var classes = ['column'];
	            var data = {
	                key: key,
	                attrs: {
	                    role: 'columnheader',
	                    scope: 'col',
	                    width: header.width || null,
	                    'aria-label': header[this.headerText] || '',
	                    'aria-sort': 'none'
	                }
	            };
	            if (header.sortable == null || header.sortable) {
	                this.genHeaderSortingData(header, children, data, classes);
	            } else {
	                data.attrs['aria-label'] += ': Not sorted.'; // TODO: Localization
	            }
	            classes.push("text-xs-" + (header.align || 'left'));
	            if (Array.isArray(header.class)) {
	                classes.push.apply(classes, __spread(header.class));
	            } else if (header.class) {
	                classes.push(header.class);
	            }
	            data.class = classes;
	            return [data, children];
	        },
	        genHeaderSortingData: function genHeaderSortingData(header, children, data, classes) {
	            var _this = this;
	            if (!('value' in header)) {
	                Object(_util_console__WEBPACK_IMPORTED_MODULE_0__["consoleWarn"])('Headers must have a value property that corresponds to a value in the v-model array', this);
	            }
	            data.attrs.tabIndex = 0;
	            data.on = {
	                click: function click() {
	                    _this.expanded = {};
	                    _this.sort(header.value);
	                },
	                keydown: function keydown(e) {
	                    // check for space
	                    if (e.keyCode === 32) {
	                        e.preventDefault();
	                        _this.sort(header.value);
	                    }
	                }
	            };
	            classes.push('sortable');
	            var icon = this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_2__["default"], {
	                props: {
	                    small: true
	                }
	            }, this.sortIcon);
	            if (!header.align || header.align === 'left') {
	                children.push(icon);
	            } else {
	                children.unshift(icon);
	            }
	            var pagination = this.computedPagination;
	            var beingSorted = pagination.sortBy === header.value;
	            if (beingSorted) {
	                classes.push('active');
	                if (pagination.descending) {
	                    classes.push('desc');
	                    data.attrs['aria-sort'] = 'descending';
	                    data.attrs['aria-label'] += ': Sorted descending. Activate to remove sorting.'; // TODO: Localization
	                } else {
	                    classes.push('asc');
	                    data.attrs['aria-sort'] = 'ascending';
	                    data.attrs['aria-label'] += ': Sorted ascending. Activate to sort descending.'; // TODO: Localization
	                }
	            } else {
	                data.attrs['aria-label'] += ': Not sorted. Activate to sort ascending.'; // TODO: Localization
	            }
	        }
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VDataTable/mixins/progress.js":
	/*!******************************************************!*\
	  !*** ./src/components/VDataTable/mixins/progress.js ***!
	  \******************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    methods: {
	        genTProgress: function genTProgress() {
	            var col = this.$createElement('th', {
	                staticClass: 'column',
	                attrs: {
	                    colspan: this.headerColumns
	                }
	            }, [this.genProgress()]);
	            return this.genTR([col], {
	                staticClass: 'v-datatable__progress'
	            });
	        }
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VDatePicker/VDatePicker.ts":
	/*!***************************************************!*\
	  !*** ./src/components/VDatePicker/VDatePicker.ts ***!
	  \***************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VDatePickerTitle__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VDatePickerTitle */ "./src/components/VDatePicker/VDatePickerTitle.ts");
	/* harmony import */ var _VDatePickerHeader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./VDatePickerHeader */ "./src/components/VDatePicker/VDatePickerHeader.ts");
	/* harmony import */ var _VDatePickerDateTable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./VDatePickerDateTable */ "./src/components/VDatePicker/VDatePickerDateTable.ts");
	/* harmony import */ var _VDatePickerMonthTable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./VDatePickerMonthTable */ "./src/components/VDatePicker/VDatePickerMonthTable.ts");
	/* harmony import */ var _VDatePickerYears__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./VDatePickerYears */ "./src/components/VDatePicker/VDatePickerYears.ts");
	/* harmony import */ var _mixins_picker__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mixins/picker */ "./src/mixins/picker.ts");
	/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./util */ "./src/components/VDatePicker/util/index.ts");
	/* harmony import */ var _util_isDateAllowed__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./util/isDateAllowed */ "./src/components/VDatePicker/util/isDateAllowed.ts");
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../util/console */ "./src/util/console.ts");
	/* harmony import */ var _VCalendar_util_timestamp__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../VCalendar/util/timestamp */ "./src/components/VCalendar/util/timestamp.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	var __read = undefined && undefined.__read || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o),
	        r,
	        ar = [],
	        e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
	            ar.push(r.value);
	        }
	    } catch (error) {
	        e = { error: error };
	    } finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        } finally {
	            if (e) throw e.error;
	        }
	    }
	    return ar;
	};
	// Components
	
	
	
	
	
	// Mixins
	
	// Utils
	
	
	
	
	
	// Adds leading zero to month/day if necessary, returns 'YYYY' if type = 'year',
	// 'YYYY-MM' if 'month' and 'YYYY-MM-DD' if 'date'
	function sanitizeDateString(dateString, type) {
	    var _a = __read(dateString.split('-'), 3),
	        year = _a[0],
	        _b = _a[1],
	        month = _b === void 0 ? 1 : _b,
	        _c = _a[2],
	        date = _c === void 0 ? 1 : _c;
	    return (year + "-" + Object(_util__WEBPACK_IMPORTED_MODULE_6__["pad"])(month) + "-" + Object(_util__WEBPACK_IMPORTED_MODULE_6__["pad"])(date)).substr(0, { date: 10, month: 7, year: 4 }[type]);
	}
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_10__["default"])(_mixins_picker__WEBPACK_IMPORTED_MODULE_5__["default"]
	/* @vue/component */
	).extend({
	    name: 'v-date-picker',
	    props: {
	        allowedDates: Function,
	        // Function formatting the day in date picker table
	        dayFormat: Function,
	        disabled: Boolean,
	        events: {
	            type: [Array, Function, Object],
	            default: function _default() {
	                return null;
	            }
	        },
	        eventColor: {
	            type: [Array, Function, Object, String],
	            default: function _default() {
	                return 'warning';
	            }
	        },
	        firstDayOfWeek: {
	            type: [String, Number],
	            default: 0
	        },
	        // Function formatting the tableDate in the day/month table header
	        headerDateFormat: Function,
	        locale: {
	            type: String,
	            default: 'en-us'
	        },
	        max: String,
	        min: String,
	        // Function formatting month in the months table
	        monthFormat: Function,
	        multiple: Boolean,
	        nextIcon: {
	            type: String,
	            default: '$vuetify.icons.next'
	        },
	        pickerDate: String,
	        prevIcon: {
	            type: String,
	            default: '$vuetify.icons.prev'
	        },
	        reactive: Boolean,
	        readonly: Boolean,
	        scrollable: Boolean,
	        showCurrent: {
	            type: [Boolean, String],
	            default: true
	        },
	        showWeek: Boolean,
	        // Function formatting currently selected date in the picker title
	        titleDateFormat: Function,
	        type: {
	            type: String,
	            default: 'date',
	            validator: function validator(type) {
	                return ['date', 'month'].includes(type);
	            } // TODO: year
	        },
	        value: [Array, String],
	        weekdayFormat: Function,
	        // Function formatting the year in table header and pickup title
	        yearFormat: Function,
	        yearIcon: String
	    },
	    data: function data() {
	        var _this = this;
	        var now = new Date();
	        return {
	            activePicker: this.type.toUpperCase(),
	            inputDay: null,
	            inputMonth: null,
	            inputYear: null,
	            isReversing: false,
	            now: now,
	            // tableDate is a string in 'YYYY' / 'YYYY-M' format (leading zero for month is not required)
	            tableDate: function () {
	                if (_this.pickerDate) {
	                    return _this.pickerDate;
	                }
	                var date = (_this.multiple ? _this.value[_this.value.length - 1] : _this.value) || now.getFullYear() + "-" + (now.getMonth() + 1);
	                return sanitizeDateString(date, _this.type === 'date' ? 'month' : 'year');
	            }()
	        };
	    },
	    computed: {
	        lastValue: function lastValue() {
	            return this.multiple ? this.value[this.value.length - 1] : this.value;
	        },
	        selectedMonths: function selectedMonths() {
	            if (!this.value || !this.value.length || this.type === 'month') {
	                return this.value;
	            } else if (this.multiple) {
	                return this.value.map(function (val) {
	                    return val.substr(0, 7);
	                });
	            } else {
	                return this.value.substr(0, 7);
	            }
	        },
	        current: function current() {
	            if (this.showCurrent === true) {
	                return sanitizeDateString(this.now.getFullYear() + "-" + (this.now.getMonth() + 1) + "-" + this.now.getDate(), this.type);
	            }
	            return this.showCurrent || null;
	        },
	        inputDate: function inputDate() {
	            return this.type === 'date' ? this.inputYear + "-" + Object(_util__WEBPACK_IMPORTED_MODULE_6__["pad"])(this.inputMonth + 1) + "-" + Object(_util__WEBPACK_IMPORTED_MODULE_6__["pad"])(this.inputDay) : this.inputYear + "-" + Object(_util__WEBPACK_IMPORTED_MODULE_6__["pad"])(this.inputMonth + 1);
	        },
	        tableMonth: function tableMonth() {
	            return Number((this.pickerDate || this.tableDate).split('-')[1]) - 1;
	        },
	        tableYear: function tableYear() {
	            return Number((this.pickerDate || this.tableDate).split('-')[0]);
	        },
	        minMonth: function minMonth() {
	            return this.min ? sanitizeDateString(this.min, 'month') : null;
	        },
	        maxMonth: function maxMonth() {
	            return this.max ? sanitizeDateString(this.max, 'month') : null;
	        },
	        minYear: function minYear() {
	            return this.min ? sanitizeDateString(this.min, 'year') : null;
	        },
	        maxYear: function maxYear() {
	            return this.max ? sanitizeDateString(this.max, 'year') : null;
	        },
	        formatters: function formatters() {
	            return {
	                year: this.yearFormat || Object(_util__WEBPACK_IMPORTED_MODULE_6__["createNativeLocaleFormatter"])(this.locale, { year: 'numeric', timeZone: 'UTC' }, { length: 4 }),
	                titleDate: this.titleDateFormat || (this.multiple ? this.defaultTitleMultipleDateFormatter : this.defaultTitleDateFormatter)
	            };
	        },
	        defaultTitleMultipleDateFormatter: function defaultTitleMultipleDateFormatter() {
	            var _this = this;
	            if (this.value.length < 2) {
	                return function (dates) {
	                    return dates.length ? _this.defaultTitleDateFormatter(dates[0]) : '0 selected';
	                };
	            }
	            return function (dates) {
	                return dates.length + " selected";
	            };
	        },
	        defaultTitleDateFormatter: function defaultTitleDateFormatter() {
	            var titleFormats = {
	                year: { year: 'numeric', timeZone: 'UTC' },
	                month: { month: 'long', timeZone: 'UTC' },
	                date: { weekday: 'short', month: 'short', day: 'numeric', timeZone: 'UTC' }
	            };
	            var titleDateFormatter = Object(_util__WEBPACK_IMPORTED_MODULE_6__["createNativeLocaleFormatter"])(this.locale, titleFormats[this.type], {
	                start: 0,
	                length: { date: 10, month: 7, year: 4 }[this.type]
	            });
	            var landscapeFormatter = function landscapeFormatter(date) {
	                return titleDateFormatter(date).replace(/([^\d\s])([\d])/g, function (match, nonDigit, digit) {
	                    return nonDigit + " " + digit;
	                }).replace(', ', ',<br>');
	            };
	            return this.landscape ? landscapeFormatter : titleDateFormatter;
	        }
	    },
	    watch: {
	        tableDate: function tableDate(val, prev) {
	            // Make a ISO 8601 strings from val and prev for comparision, otherwise it will incorrectly
	            // compare for example '2000-9' and '2000-10'
	            var sanitizeType = this.type === 'month' ? 'year' : 'month';
	            this.isReversing = sanitizeDateString(val, sanitizeType) < sanitizeDateString(prev, sanitizeType);
	            this.$emit('update:pickerDate', val);
	        },
	        pickerDate: function pickerDate(val) {
	            if (val) {
	                this.tableDate = val;
	            } else if (this.lastValue && this.type === 'date') {
	                this.tableDate = sanitizeDateString(this.lastValue, 'month');
	            } else if (this.lastValue && this.type === 'month') {
	                this.tableDate = sanitizeDateString(this.lastValue, 'year');
	            }
	        },
	        value: function value(newValue, oldValue) {
	            this.checkMultipleProp();
	            this.setInputDate();
	            if (!this.multiple && this.value && !this.pickerDate) {
	                this.tableDate = sanitizeDateString(this.inputDate, this.type === 'month' ? 'year' : 'month');
	            } else if (this.multiple && this.value.length && !oldValue.length && !this.pickerDate) {
	                this.tableDate = sanitizeDateString(this.inputDate, this.type === 'month' ? 'year' : 'month');
	            }
	        },
	        type: function type(_type) {
	            this.activePicker = _type.toUpperCase();
	            if (this.value && this.value.length) {
	                var output = (this.multiple ? this.value : [this.value]).map(function (val) {
	                    return sanitizeDateString(val, _type);
	                }).filter(this.isDateAllowed);
	                this.$emit('input', this.multiple ? output : output[0]);
	            }
	        }
	    },
	    created: function created() {
	        this.checkMultipleProp();
	        if (this.pickerDate !== this.tableDate) {
	            this.$emit('update:pickerDate', this.tableDate);
	        }
	        this.setInputDate();
	    },
	    methods: {
	        emitInput: function emitInput(newInput) {
	            var output = this.multiple ? this.value.indexOf(newInput) === -1 ? this.value.concat([newInput]) : this.value.filter(function (x) {
	                return x !== newInput;
	            }) : newInput;
	            this.$emit('input', output);
	            this.multiple || this.$emit('change', newInput);
	        },
	        checkMultipleProp: function checkMultipleProp() {
	            if (this.value == null) return;
	            var valueType = this.value.constructor.name;
	            var expected = this.multiple ? 'Array' : 'String';
	            if (valueType !== expected) {
	                Object(_util_console__WEBPACK_IMPORTED_MODULE_8__["consoleWarn"])("Value must be " + (this.multiple ? 'an' : 'a') + " " + expected + ", got " + valueType, this);
	            }
	        },
	        isDateAllowed: function isDateAllowed(value) {
	            return Object(_util_isDateAllowed__WEBPACK_IMPORTED_MODULE_7__["default"])(value, this.min, this.max, this.allowedDates);
	        },
	        yearClick: function yearClick(value) {
	            this.inputYear = value;
	            if (this.type === 'month') {
	                this.tableDate = "" + value;
	            } else {
	                this.tableDate = value + "-" + Object(_util__WEBPACK_IMPORTED_MODULE_6__["pad"])((this.tableMonth || 0) + 1);
	            }
	            this.activePicker = 'MONTH';
	            if (this.reactive && !this.readonly && !this.multiple && this.isDateAllowed(this.inputDate)) {
	                this.$emit('input', this.inputDate);
	            }
	        },
	        monthClick: function monthClick(value) {
	            this.inputYear = parseInt(value.split('-')[0], 10);
	            this.inputMonth = parseInt(value.split('-')[1], 10) - 1;
	            if (this.type === 'date') {
	                if (this.inputDay) {
	                    this.inputDay = Math.min(this.inputDay, Object(_VCalendar_util_timestamp__WEBPACK_IMPORTED_MODULE_9__["daysInMonth"])(this.inputYear, this.inputMonth + 1));
	                }
	                this.tableDate = value;
	                this.activePicker = 'DATE';
	                if (this.reactive && !this.readonly && !this.multiple && this.isDateAllowed(this.inputDate)) {
	                    this.$emit('input', this.inputDate);
	                }
	            } else {
	                this.emitInput(this.inputDate);
	            }
	        },
	        dateClick: function dateClick(value) {
	            this.inputYear = parseInt(value.split('-')[0], 10);
	            this.inputMonth = parseInt(value.split('-')[1], 10) - 1;
	            this.inputDay = parseInt(value.split('-')[2], 10);
	            this.emitInput(this.inputDate);
	        },
	        genPickerTitle: function genPickerTitle() {
	            var _this = this;
	            return this.$createElement(_VDatePickerTitle__WEBPACK_IMPORTED_MODULE_0__["default"], {
	                props: {
	                    date: this.value ? this.formatters.titleDate(this.value) : '',
	                    disabled: this.disabled,
	                    readonly: this.readonly,
	                    selectingYear: this.activePicker === 'YEAR',
	                    year: this.formatters.year(this.value ? "" + this.inputYear : this.tableDate),
	                    yearIcon: this.yearIcon,
	                    value: this.multiple ? this.value[0] : this.value
	                },
	                slot: 'title',
	                on: {
	                    'update:selectingYear': function updateSelectingYear(value) {
	                        return _this.activePicker = value ? 'YEAR' : _this.type.toUpperCase();
	                    }
	                }
	            });
	        },
	        genTableHeader: function genTableHeader() {
	            var _this = this;
	            return this.$createElement(_VDatePickerHeader__WEBPACK_IMPORTED_MODULE_1__["default"], {
	                props: {
	                    nextIcon: this.nextIcon,
	                    color: this.color,
	                    dark: this.dark,
	                    disabled: this.disabled,
	                    format: this.headerDateFormat,
	                    light: this.light,
	                    locale: this.locale,
	                    min: this.activePicker === 'DATE' ? this.minMonth : this.minYear,
	                    max: this.activePicker === 'DATE' ? this.maxMonth : this.maxYear,
	                    prevIcon: this.prevIcon,
	                    readonly: this.readonly,
	                    value: this.activePicker === 'DATE' ? Object(_util__WEBPACK_IMPORTED_MODULE_6__["pad"])(this.tableYear, 4) + "-" + Object(_util__WEBPACK_IMPORTED_MODULE_6__["pad"])(this.tableMonth + 1) : "" + Object(_util__WEBPACK_IMPORTED_MODULE_6__["pad"])(this.tableYear, 4)
	                },
	                on: {
	                    toggle: function toggle() {
	                        return _this.activePicker = _this.activePicker === 'DATE' ? 'MONTH' : 'YEAR';
	                    },
	                    input: function input(value) {
	                        return _this.tableDate = value;
	                    }
	                }
	            });
	        },
	        genDateTable: function genDateTable() {
	            var _this = this;
	            return this.$createElement(_VDatePickerDateTable__WEBPACK_IMPORTED_MODULE_2__["default"], {
	                props: {
	                    allowedDates: this.allowedDates,
	                    color: this.color,
	                    current: this.current,
	                    dark: this.dark,
	                    disabled: this.disabled,
	                    events: this.events,
	                    eventColor: this.eventColor,
	                    firstDayOfWeek: this.firstDayOfWeek,
	                    format: this.dayFormat,
	                    light: this.light,
	                    locale: this.locale,
	                    min: this.min,
	                    max: this.max,
	                    readonly: this.readonly,
	                    scrollable: this.scrollable,
	                    showWeek: this.showWeek,
	                    tableDate: Object(_util__WEBPACK_IMPORTED_MODULE_6__["pad"])(this.tableYear, 4) + "-" + Object(_util__WEBPACK_IMPORTED_MODULE_6__["pad"])(this.tableMonth + 1),
	                    value: this.value,
	                    weekdayFormat: this.weekdayFormat
	                },
	                ref: 'table',
	                on: {
	                    input: this.dateClick,
	                    tableDate: function tableDate(value) {
	                        return _this.tableDate = value;
	                    },
	                    'click:date': function clickDate(value) {
	                        return _this.$emit('click:date', value);
	                    },
	                    'dblclick:date': function dblclickDate(value) {
	                        return _this.$emit('dblclick:date', value);
	                    }
	                }
	            });
	        },
	        genMonthTable: function genMonthTable() {
	            var _this = this;
	            return this.$createElement(_VDatePickerMonthTable__WEBPACK_IMPORTED_MODULE_3__["default"], {
	                props: {
	                    allowedDates: this.type === 'month' ? this.allowedDates : null,
	                    color: this.color,
	                    current: this.current ? sanitizeDateString(this.current, 'month') : null,
	                    dark: this.dark,
	                    disabled: this.disabled,
	                    events: this.type === 'month' ? this.events : null,
	                    eventColor: this.type === 'month' ? this.eventColor : null,
	                    format: this.monthFormat,
	                    light: this.light,
	                    locale: this.locale,
	                    min: this.minMonth,
	                    max: this.maxMonth,
	                    readonly: this.readonly && this.type === 'month',
	                    scrollable: this.scrollable,
	                    value: this.selectedMonths,
	                    tableDate: "" + Object(_util__WEBPACK_IMPORTED_MODULE_6__["pad"])(this.tableYear, 4)
	                },
	                ref: 'table',
	                on: {
	                    input: this.monthClick,
	                    tableDate: function tableDate(value) {
	                        return _this.tableDate = value;
	                    },
	                    'click:month': function clickMonth(value) {
	                        return _this.$emit('click:month', value);
	                    },
	                    'dblclick:month': function dblclickMonth(value) {
	                        return _this.$emit('dblclick:month', value);
	                    }
	                }
	            });
	        },
	        genYears: function genYears() {
	            return this.$createElement(_VDatePickerYears__WEBPACK_IMPORTED_MODULE_4__["default"], {
	                props: {
	                    color: this.color,
	                    format: this.yearFormat,
	                    locale: this.locale,
	                    min: this.minYear,
	                    max: this.maxYear,
	                    value: this.tableYear
	                },
	                on: {
	                    input: this.yearClick
	                }
	            });
	        },
	        genPickerBody: function genPickerBody() {
	            var children = this.activePicker === 'YEAR' ? [this.genYears()] : [this.genTableHeader(), this.activePicker === 'DATE' ? this.genDateTable() : this.genMonthTable()];
	            return this.$createElement('div', {
	                key: this.activePicker
	            }, children);
	        },
	        setInputDate: function setInputDate() {
	            if (this.lastValue) {
	                var array = this.lastValue.split('-');
	                this.inputYear = parseInt(array[0], 10);
	                this.inputMonth = parseInt(array[1], 10) - 1;
	                if (this.type === 'date') {
	                    this.inputDay = parseInt(array[2], 10);
	                }
	            } else {
	                this.inputYear = this.inputYear || this.now.getFullYear();
	                this.inputMonth = this.inputMonth == null ? this.inputMonth : this.now.getMonth();
	                this.inputDay = this.inputDay || this.now.getDate();
	            }
	        }
	    },
	    render: function render() {
	        return this.genPicker('v-picker--date');
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VDatePicker/VDatePickerDateTable.ts":
	/*!************************************************************!*\
	  !*** ./src/components/VDatePicker/VDatePickerDateTable.ts ***!
	  \************************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _mixins_date_picker_table__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./mixins/date-picker-table */ "./src/components/VDatePicker/mixins/date-picker-table.ts");
	/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./util */ "./src/components/VDatePicker/util/index.ts");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	// Mixins
	
	// Utils
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_3__["default"])(_mixins_date_picker_table__WEBPACK_IMPORTED_MODULE_0__["default"]
	/* @vue/component */
	).extend({
	    name: 'v-date-picker-date-table',
	    props: {
	        firstDayOfWeek: {
	            type: [String, Number],
	            default: 0
	        },
	        showWeek: Boolean,
	        weekdayFormat: Function
	    },
	    computed: {
	        formatter: function formatter() {
	            return this.format || Object(_util__WEBPACK_IMPORTED_MODULE_1__["createNativeLocaleFormatter"])(this.locale, { day: 'numeric', timeZone: 'UTC' }, { start: 8, length: 2 });
	        },
	        weekdayFormatter: function weekdayFormatter() {
	            return this.weekdayFormat || Object(_util__WEBPACK_IMPORTED_MODULE_1__["createNativeLocaleFormatter"])(this.locale, { weekday: 'narrow', timeZone: 'UTC' });
	        },
	        weekDays: function weekDays() {
	            var _this = this;
	            var first = parseInt(this.firstDayOfWeek, 10);
	            return this.weekdayFormatter ? Object(_util_helpers__WEBPACK_IMPORTED_MODULE_2__["createRange"])(7).map(function (i) {
	                return _this.weekdayFormatter("2017-01-" + (first + i + 15));
	            }) // 2017-01-15 is Sunday
	            : Object(_util_helpers__WEBPACK_IMPORTED_MODULE_2__["createRange"])(7).map(function (i) {
	                return ['S', 'M', 'T', 'W', 'T', 'F', 'S'][(i + first) % 7];
	            });
	        }
	    },
	    methods: {
	        calculateTableDate: function calculateTableDate(delta) {
	            return Object(_util__WEBPACK_IMPORTED_MODULE_1__["monthChange"])(this.tableDate, Math.sign(delta || 1));
	        },
	        genTHead: function genTHead() {
	            var _this = this;
	            var days = this.weekDays.map(function (day) {
	                return _this.$createElement('th', day);
	            });
	            this.showWeek && days.unshift(this.$createElement('th'));
	            return this.$createElement('thead', this.genTR(days));
	        },
	        // Returns number of the days from the firstDayOfWeek to the first day of the current month
	        weekDaysBeforeFirstDayOfTheMonth: function weekDaysBeforeFirstDayOfTheMonth() {
	            var firstDayOfTheMonth = new Date(this.displayedYear + "-" + Object(_util__WEBPACK_IMPORTED_MODULE_1__["pad"])(this.displayedMonth + 1) + "-01T00:00:00+00:00");
	            var weekDay = firstDayOfTheMonth.getUTCDay();
	            return (weekDay - parseInt(this.firstDayOfWeek) + 7) % 7;
	        },
	        getWeekNumber: function getWeekNumber() {
	            var dayOfYear = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334][this.displayedMonth];
	            if (this.displayedMonth > 1 && (this.displayedYear % 4 === 0 && this.displayedYear % 100 !== 0 || this.displayedYear % 400 === 0)) {
	                dayOfYear++;
	            }
	            var offset = (this.displayedYear + (this.displayedYear - 1 >> 2) - Math.floor((this.displayedYear - 1) / 100) + Math.floor((this.displayedYear - 1) / 400) - Number(this.firstDayOfWeek)) % 7; // https://en.wikipedia.org/wiki/Zeller%27s_congruence
	            return Math.floor((dayOfYear + offset) / 7) + 1;
	        },
	        genWeekNumber: function genWeekNumber(weekNumber) {
	            return this.$createElement('td', [this.$createElement('small', {
	                staticClass: 'v-date-picker-table--date__week'
	            }, String(weekNumber).padStart(2, '0'))]);
	        },
	        genTBody: function genTBody() {
	            var children = [];
	            var daysInMonth = new Date(this.displayedYear, this.displayedMonth + 1, 0).getDate();
	            var rows = [];
	            var day = this.weekDaysBeforeFirstDayOfTheMonth();
	            var weekNumber = this.getWeekNumber();
	            this.showWeek && rows.push(this.genWeekNumber(weekNumber++));
	            while (day--) {
	                rows.push(this.$createElement('td'));
	            }for (day = 1; day <= daysInMonth; day++) {
	                var date = this.displayedYear + "-" + Object(_util__WEBPACK_IMPORTED_MODULE_1__["pad"])(this.displayedMonth + 1) + "-" + Object(_util__WEBPACK_IMPORTED_MODULE_1__["pad"])(day);
	                rows.push(this.$createElement('td', [this.genButton(date, true, 'date', this.formatter)]));
	                if (rows.length % (this.showWeek ? 8 : 7) === 0) {
	                    children.push(this.genTR(rows));
	                    rows = [];
	                    day < daysInMonth && this.showWeek && rows.push(this.genWeekNumber(weekNumber++));
	                }
	            }
	            if (rows.length) {
	                children.push(this.genTR(rows));
	            }
	            return this.$createElement('tbody', children);
	        },
	        genTR: function genTR(children) {
	            return [this.$createElement('tr', children)];
	        }
	    },
	    render: function render() {
	        return this.genTable('v-date-picker-table v-date-picker-table--date', [this.genTHead(), this.genTBody()], this.calculateTableDate);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VDatePicker/VDatePickerHeader.ts":
	/*!*********************************************************!*\
	  !*** ./src/components/VDatePicker/VDatePickerHeader.ts ***!
	  \*********************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_date_picker_header_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_date-picker-header.styl */ "./src/stylus/components/_date-picker-header.styl");
	/* harmony import */ var _stylus_components_date_picker_header_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_date_picker_header_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _VBtn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../VBtn */ "./src/components/VBtn/index.ts");
	/* harmony import */ var _VIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../VIcon */ "./src/components/VIcon/index.ts");
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./util */ "./src/components/VDatePicker/util/index.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var __read = undefined && undefined.__read || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o),
	        r,
	        ar = [],
	        e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
	            ar.push(r.value);
	        }
	    } catch (error) {
	        e = { error: error };
	    } finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        } finally {
	            if (e) throw e.error;
	        }
	    }
	    return ar;
	};
	
	// Components
	
	
	// Mixins
	
	
	// Utils
	
	
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_6__["default"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_3__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_4__["default"]
	/* @vue/component */
	).extend({
	    name: 'v-date-picker-header',
	    props: {
	        disabled: Boolean,
	        format: Function,
	        locale: {
	            type: String,
	            default: 'en-us'
	        },
	        min: String,
	        max: String,
	        nextIcon: {
	            type: String,
	            default: '$vuetify.icons.next'
	        },
	        prevIcon: {
	            type: String,
	            default: '$vuetify.icons.prev'
	        },
	        readonly: Boolean,
	        value: {
	            type: [Number, String],
	            required: true
	        }
	    },
	    data: function data() {
	        return {
	            isReversing: false
	        };
	    },
	    computed: {
	        formatter: function formatter() {
	            if (this.format) {
	                return this.format;
	            } else if (String(this.value).split('-')[1]) {
	                return Object(_util__WEBPACK_IMPORTED_MODULE_5__["createNativeLocaleFormatter"])(this.locale, { month: 'long', year: 'numeric', timeZone: 'UTC' }, { length: 7 });
	            } else {
	                return Object(_util__WEBPACK_IMPORTED_MODULE_5__["createNativeLocaleFormatter"])(this.locale, { year: 'numeric', timeZone: 'UTC' }, { length: 4 });
	            }
	        }
	    },
	    watch: {
	        value: function value(newVal, oldVal) {
	            this.isReversing = newVal < oldVal;
	        }
	    },
	    methods: {
	        genBtn: function genBtn(change) {
	            var _this = this;
	            var disabled = this.disabled || change < 0 && this.min && this.calculateChange(change) < this.min || change > 0 && this.max && this.calculateChange(change) > this.max;
	            return this.$createElement(_VBtn__WEBPACK_IMPORTED_MODULE_1__["default"], {
	                props: {
	                    dark: this.dark,
	                    disabled: disabled,
	                    icon: true,
	                    light: this.light
	                },
	                nativeOn: {
	                    click: function click(e) {
	                        e.stopPropagation();
	                        _this.$emit('input', _this.calculateChange(change));
	                    }
	                }
	            }, [this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_2__["default"], change < 0 === !this.$vuetify.rtl ? this.prevIcon : this.nextIcon)]);
	        },
	        calculateChange: function calculateChange(sign) {
	            var _a = __read(String(this.value).split('-').map(Number), 2),
	                year = _a[0],
	                month = _a[1];
	            if (month == null) {
	                return "" + (year + sign);
	            } else {
	                return Object(_util__WEBPACK_IMPORTED_MODULE_5__["monthChange"])(String(this.value), sign);
	            }
	        },
	        genHeader: function genHeader() {
	            var _this = this;
	            var color = !this.disabled && (this.color || 'accent');
	            var header = this.$createElement('div', this.setTextColor(color, {
	                key: String(this.value)
	            }), [this.$createElement('button', {
	                attrs: {
	                    type: 'button'
	                },
	                on: {
	                    click: function click() {
	                        return _this.$emit('toggle');
	                    }
	                }
	            }, [this.$slots.default || this.formatter(String(this.value))])]);
	            var transition = this.$createElement('transition', {
	                props: {
	                    name: this.isReversing === !this.$vuetify.rtl ? 'tab-reverse-transition' : 'tab-transition'
	                }
	            }, [header]);
	            return this.$createElement('div', {
	                staticClass: 'v-date-picker-header__value',
	                class: {
	                    'v-date-picker-header__value--disabled': this.disabled
	                }
	            }, [transition]);
	        }
	    },
	    render: function render() {
	        return this.$createElement('div', {
	            staticClass: 'v-date-picker-header',
	            class: __assign({ 'v-date-picker-header--disabled': this.disabled }, this.themeClasses)
	        }, [this.genBtn(-1), this.genHeader(), this.genBtn(+1)]);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VDatePicker/VDatePickerMonthTable.ts":
	/*!*************************************************************!*\
	  !*** ./src/components/VDatePicker/VDatePickerMonthTable.ts ***!
	  \*************************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _mixins_date_picker_table__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./mixins/date-picker-table */ "./src/components/VDatePicker/mixins/date-picker-table.ts");
	/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./util */ "./src/components/VDatePicker/util/index.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	// Mixins
	
	// Utils
	
	
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_2__["default"])(_mixins_date_picker_table__WEBPACK_IMPORTED_MODULE_0__["default"]
	/* @vue/component */
	).extend({
	    name: 'v-date-picker-month-table',
	    computed: {
	        formatter: function formatter() {
	            return this.format || Object(_util__WEBPACK_IMPORTED_MODULE_1__["createNativeLocaleFormatter"])(this.locale, { month: 'short', timeZone: 'UTC' }, { start: 5, length: 2 });
	        }
	    },
	    methods: {
	        calculateTableDate: function calculateTableDate(delta) {
	            return "" + (parseInt(this.tableDate, 10) + Math.sign(delta || 1));
	        },
	        genTBody: function genTBody() {
	            var _this = this;
	            var children = [];
	            var cols = Array(3).fill(null);
	            var rows = 12 / cols.length;
	            var _loop_1 = function _loop_1(row) {
	                var tds = cols.map(function (_, col) {
	                    var month = row * cols.length + col;
	                    var date = _this.displayedYear + "-" + Object(_util__WEBPACK_IMPORTED_MODULE_1__["pad"])(month + 1);
	                    return _this.$createElement('td', {
	                        key: month
	                    }, [_this.genButton(date, false, 'month', _this.formatter)]);
	                });
	                children.push(this_1.$createElement('tr', {
	                    key: row
	                }, tds));
	            };
	            var this_1 = this;
	            for (var row = 0; row < rows; row++) {
	                _loop_1(row);
	            }
	            return this.$createElement('tbody', children);
	        }
	    },
	    render: function render() {
	        return this.genTable('v-date-picker-table v-date-picker-table--month', [this.genTBody()], this.calculateTableDate);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VDatePicker/VDatePickerTitle.ts":
	/*!********************************************************!*\
	  !*** ./src/components/VDatePicker/VDatePickerTitle.ts ***!
	  \********************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_date_picker_title_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_date-picker-title.styl */ "./src/stylus/components/_date-picker-title.styl");
	/* harmony import */ var _stylus_components_date_picker_title_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_date_picker_title_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _VIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../VIcon */ "./src/components/VIcon/index.ts");
	/* harmony import */ var _mixins_picker_button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/picker-button */ "./src/mixins/picker-button.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	
	// Components
	
	// Mixins
	
	// Utils
	
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_3__["default"])(_mixins_picker_button__WEBPACK_IMPORTED_MODULE_2__["default"]
	/* @vue/component */
	).extend({
	    name: 'v-date-picker-title',
	    props: {
	        date: {
	            type: String,
	            default: ''
	        },
	        disabled: Boolean,
	        readonly: Boolean,
	        selectingYear: Boolean,
	        value: {
	            type: String
	        },
	        year: {
	            type: [Number, String],
	            default: ''
	        },
	        yearIcon: {
	            type: String
	        }
	    },
	    data: function data() {
	        return {
	            isReversing: false
	        };
	    },
	    computed: {
	        computedTransition: function computedTransition() {
	            return this.isReversing ? 'picker-reverse-transition' : 'picker-transition';
	        }
	    },
	    watch: {
	        value: function value(val, prev) {
	            this.isReversing = val < prev;
	        }
	    },
	    methods: {
	        genYearIcon: function genYearIcon() {
	            return this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_1__["default"], {
	                props: {
	                    dark: true
	                }
	            }, this.yearIcon);
	        },
	        getYearBtn: function getYearBtn() {
	            return this.genPickerButton('selectingYear', true, [String(this.year), this.yearIcon ? this.genYearIcon() : null], false, 'v-date-picker-title__year');
	        },
	        genTitleText: function genTitleText() {
	            return this.$createElement('transition', {
	                props: {
	                    name: this.computedTransition
	                }
	            }, [this.$createElement('div', {
	                domProps: { innerHTML: this.date || '&nbsp;' },
	                key: this.value
	            })]);
	        },
	        genTitleDate: function genTitleDate() {
	            return this.genPickerButton('selectingYear', false, [this.genTitleText()], false, 'v-date-picker-title__date');
	        }
	    },
	    render: function render(h) {
	        return h('div', {
	            staticClass: 'v-date-picker-title',
	            'class': {
	                'v-date-picker-title--disabled': this.disabled
	            }
	        }, [this.getYearBtn(), this.genTitleDate()]);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VDatePicker/VDatePickerYears.ts":
	/*!********************************************************!*\
	  !*** ./src/components/VDatePicker/VDatePickerYears.ts ***!
	  \********************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_date_picker_years_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_date-picker-years.styl */ "./src/stylus/components/_date-picker-years.styl");
	/* harmony import */ var _stylus_components_date_picker_years_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_date_picker_years_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./util */ "./src/components/VDatePicker/util/index.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	
	// Mixins
	
	// Utils
	
	
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_3__["default"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_1__["default"]
	/* @vue/component */
	).extend({
	    name: 'v-date-picker-years',
	    props: {
	        format: Function,
	        locale: {
	            type: String,
	            default: 'en-us'
	        },
	        min: [Number, String],
	        max: [Number, String],
	        readonly: Boolean,
	        value: [Number, String]
	    },
	    data: function data() {
	        return {
	            defaultColor: 'primary'
	        };
	    },
	    computed: {
	        formatter: function formatter() {
	            return this.format || Object(_util__WEBPACK_IMPORTED_MODULE_2__["createNativeLocaleFormatter"])(this.locale, { year: 'numeric', timeZone: 'UTC' }, { length: 4 });
	        }
	    },
	    mounted: function mounted() {
	        var _this = this;
	        setTimeout(function () {
	            var activeItem = _this.$el.getElementsByClassName('active')[0];
	            if (activeItem) {
	                _this.$el.scrollTop = activeItem.offsetTop - _this.$el.offsetHeight / 2 + activeItem.offsetHeight / 2;
	            } else {
	                _this.$el.scrollTop = _this.$el.scrollHeight / 2 - _this.$el.offsetHeight / 2;
	            }
	        });
	    },
	    methods: {
	        genYearItem: function genYearItem(year) {
	            var _this = this;
	            var formatted = this.formatter("" + year);
	            var active = parseInt(this.value, 10) === year;
	            var color = active && (this.color || 'primary');
	            return this.$createElement('li', this.setTextColor(color, {
	                key: year,
	                'class': { active: active },
	                on: {
	                    click: function click() {
	                        return _this.$emit('input', year);
	                    }
	                }
	            }), formatted);
	        },
	        genYearItems: function genYearItems() {
	            var children = [];
	            var selectedYear = this.value ? parseInt(this.value, 10) : new Date().getFullYear();
	            var maxYear = this.max ? parseInt(this.max, 10) : selectedYear + 100;
	            var minYear = Math.min(maxYear, this.min ? parseInt(this.min, 10) : selectedYear - 100);
	            for (var year = maxYear; year >= minYear; year--) {
	                children.push(this.genYearItem(year));
	            }
	            return children;
	        }
	    },
	    render: function render() {
	        return this.$createElement('ul', {
	            staticClass: 'v-date-picker-years',
	            ref: 'years'
	        }, this.genYearItems());
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VDatePicker/index.js":
	/*!*********************************************!*\
	  !*** ./src/components/VDatePicker/index.js ***!
	  \*********************************************/
	/*! exports provided: VDatePicker, VDatePickerTitle, VDatePickerHeader, VDatePickerDateTable, VDatePickerMonthTable, VDatePickerYears, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VDatePicker__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VDatePicker */ "./src/components/VDatePicker/VDatePicker.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VDatePicker", function() { return _VDatePicker__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	/* harmony import */ var _VDatePickerTitle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./VDatePickerTitle */ "./src/components/VDatePicker/VDatePickerTitle.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VDatePickerTitle", function() { return _VDatePickerTitle__WEBPACK_IMPORTED_MODULE_1__["default"]; });
	
	/* harmony import */ var _VDatePickerHeader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./VDatePickerHeader */ "./src/components/VDatePicker/VDatePickerHeader.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VDatePickerHeader", function() { return _VDatePickerHeader__WEBPACK_IMPORTED_MODULE_2__["default"]; });
	
	/* harmony import */ var _VDatePickerDateTable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./VDatePickerDateTable */ "./src/components/VDatePicker/VDatePickerDateTable.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VDatePickerDateTable", function() { return _VDatePickerDateTable__WEBPACK_IMPORTED_MODULE_3__["default"]; });
	
	/* harmony import */ var _VDatePickerMonthTable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./VDatePickerMonthTable */ "./src/components/VDatePicker/VDatePickerMonthTable.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VDatePickerMonthTable", function() { return _VDatePickerMonthTable__WEBPACK_IMPORTED_MODULE_4__["default"]; });
	
	/* harmony import */ var _VDatePickerYears__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./VDatePickerYears */ "./src/components/VDatePicker/VDatePickerYears.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VDatePickerYears", function() { return _VDatePickerYears__WEBPACK_IMPORTED_MODULE_5__["default"]; });
	
	
	
	
	
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = ({
	    $_vuetify_subcomponents: {
	        VDatePicker: _VDatePicker__WEBPACK_IMPORTED_MODULE_0__["default"],
	        VDatePickerTitle: _VDatePickerTitle__WEBPACK_IMPORTED_MODULE_1__["default"],
	        VDatePickerHeader: _VDatePickerHeader__WEBPACK_IMPORTED_MODULE_2__["default"],
	        VDatePickerDateTable: _VDatePickerDateTable__WEBPACK_IMPORTED_MODULE_3__["default"],
	        VDatePickerMonthTable: _VDatePickerMonthTable__WEBPACK_IMPORTED_MODULE_4__["default"],
	        VDatePickerYears: _VDatePickerYears__WEBPACK_IMPORTED_MODULE_5__["default"]
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VDatePicker/mixins/date-picker-table.ts":
	/*!****************************************************************!*\
	  !*** ./src/components/VDatePicker/mixins/date-picker-table.ts ***!
	  \****************************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_date_picker_table_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../stylus/components/_date-picker-table.styl */ "./src/stylus/components/_date-picker-table.styl");
	/* harmony import */ var _stylus_components_date_picker_table_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_date_picker_table_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _directives_touch__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../directives/touch */ "./src/directives/touch.ts");
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _util_isDateAllowed__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../util/isDateAllowed */ "./src/components/VDatePicker/util/isDateAllowed.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../util/mixins */ "./src/util/mixins.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	
	// Directives
	
	// Mixins
	
	
	// Utils
	
	
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_5__["default"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_2__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_3__["default"]
	/* @vue/component */
	).extend({
	    directives: { Touch: _directives_touch__WEBPACK_IMPORTED_MODULE_1__["default"] },
	    props: {
	        allowedDates: Function,
	        current: String,
	        disabled: Boolean,
	        format: Function,
	        events: {
	            type: [Array, Function, Object],
	            default: function _default() {
	                return null;
	            }
	        },
	        eventColor: {
	            type: [Array, Function, Object, String],
	            default: function _default() {
	                return 'warning';
	            }
	        },
	        locale: {
	            type: String,
	            default: 'en-us'
	        },
	        min: String,
	        max: String,
	        readonly: Boolean,
	        scrollable: Boolean,
	        tableDate: {
	            type: String,
	            required: true
	        },
	        value: [String, Array]
	    },
	    data: function data() {
	        return {
	            isReversing: false
	        };
	    },
	    computed: {
	        computedTransition: function computedTransition() {
	            return this.isReversing === !this.$vuetify.rtl ? 'tab-reverse-transition' : 'tab-transition';
	        },
	        displayedMonth: function displayedMonth() {
	            return Number(this.tableDate.split('-')[1]) - 1;
	        },
	        displayedYear: function displayedYear() {
	            return Number(this.tableDate.split('-')[0]);
	        }
	    },
	    watch: {
	        tableDate: function tableDate(newVal, oldVal) {
	            this.isReversing = newVal < oldVal;
	        }
	    },
	    methods: {
	        genButtonClasses: function genButtonClasses(isAllowed, isFloating, isSelected, isCurrent) {
	            return __assign({ 'v-btn--active': isSelected, 'v-btn--flat': !isSelected, 'v-btn--icon': isSelected && isAllowed && isFloating, 'v-btn--floating': isFloating, 'v-btn--depressed': !isFloating && isSelected, 'v-btn--disabled': !isAllowed || this.disabled && isSelected, 'v-btn--outline': isCurrent && !isSelected }, this.themeClasses);
	        },
	        genButtonEvents: function genButtonEvents(value, isAllowed, mouseEventType) {
	            var _this = this;
	            if (this.disabled) return undefined;
	            return {
	                click: function click() {
	                    isAllowed && !_this.readonly && _this.$emit('input', value);
	                    _this.$emit("click:" + mouseEventType, value);
	                },
	                dblclick: function dblclick() {
	                    return _this.$emit("dblclick:" + mouseEventType, value);
	                }
	            };
	        },
	        genButton: function genButton(value, isFloating, mouseEventType, formatter) {
	            var isAllowed = Object(_util_isDateAllowed__WEBPACK_IMPORTED_MODULE_4__["default"])(value, this.min, this.max, this.allowedDates);
	            var isSelected = value === this.value || Array.isArray(this.value) && this.value.indexOf(value) !== -1;
	            var isCurrent = value === this.current;
	            var setColor = isSelected ? this.setBackgroundColor : this.setTextColor;
	            var color = (isSelected || isCurrent) && (this.color || 'accent');
	            return this.$createElement('button', setColor(color, {
	                staticClass: 'v-btn',
	                'class': this.genButtonClasses(isAllowed, isFloating, isSelected, isCurrent),
	                attrs: {
	                    type: 'button'
	                },
	                domProps: {
	                    disabled: this.disabled || !isAllowed
	                },
	                on: this.genButtonEvents(value, isAllowed, mouseEventType)
	            }), [this.$createElement('div', {
	                staticClass: 'v-btn__content'
	            }, [formatter(value)]), this.genEvents(value)]);
	        },
	        getEventColors: function getEventColors(date) {
	            var arrayize = function arrayize(v) {
	                return Array.isArray(v) ? v : [v];
	            };
	            var eventData;
	            var eventColors = [];
	            if (Array.isArray(this.events)) {
	                eventData = this.events.includes(date);
	            } else if (this.events instanceof Function) {
	                eventData = this.events(date) || false;
	            } else if (this.events) {
	                eventData = this.events[date] || false;
	            } else {
	                eventData = false;
	            }
	            if (!eventData) {
	                return [];
	            } else if (eventData !== true) {
	                eventColors = arrayize(eventData);
	            } else if (typeof this.eventColor === 'string') {
	                eventColors = [this.eventColor];
	            } else if (typeof this.eventColor === 'function') {
	                eventColors = arrayize(this.eventColor(date));
	            } else if (Array.isArray(this.eventColor)) {
	                eventColors = this.eventColor;
	            } else {
	                eventColors = arrayize(this.eventColor[date]);
	            }
	            return eventColors.filter(function (v) {
	                return v;
	            });
	        },
	        genEvents: function genEvents(date) {
	            var _this = this;
	            var eventColors = this.getEventColors(date);
	            return eventColors.length ? this.$createElement('div', {
	                staticClass: 'v-date-picker-table__events'
	            }, eventColors.map(function (color) {
	                return _this.$createElement('div', _this.setBackgroundColor(color));
	            })) : null;
	        },
	        wheel: function wheel(e, calculateTableDate) {
	            e.preventDefault();
	            this.$emit('tableDate', calculateTableDate(e.deltaY));
	        },
	        touch: function touch(value, calculateTableDate) {
	            this.$emit('tableDate', calculateTableDate(value));
	        },
	        genTable: function genTable(staticClass, children, calculateTableDate) {
	            var _this = this;
	            var transition = this.$createElement('transition', {
	                props: { name: this.computedTransition }
	            }, [this.$createElement('table', { key: this.tableDate }, children)]);
	            var touchDirective = {
	                name: 'touch',
	                value: {
	                    left: function left(e) {
	                        return e.offsetX < -15 && _this.touch(1, calculateTableDate);
	                    },
	                    right: function right(e) {
	                        return e.offsetX > 15 && _this.touch(-1, calculateTableDate);
	                    }
	                }
	            };
	            return this.$createElement('div', {
	                staticClass: staticClass,
	                class: __assign({ 'v-date-picker-table--disabled': this.disabled }, this.themeClasses),
	                on: !this.disabled && this.scrollable ? {
	                    wheel: function wheel(e) {
	                        return _this.wheel(e, calculateTableDate);
	                    }
	                } : undefined,
	                directives: [touchDirective]
	            }, [transition]);
	        }
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VDatePicker/util/createNativeLocaleFormatter.ts":
	/*!************************************************************************!*\
	  !*** ./src/components/VDatePicker/util/createNativeLocaleFormatter.ts ***!
	  \************************************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _pad__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./pad */ "./src/components/VDatePicker/util/pad.ts");
	var __read = undefined && undefined.__read || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o),
	        r,
	        ar = [],
	        e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
	            ar.push(r.value);
	        }
	    } catch (error) {
	        e = { error: error };
	    } finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        } finally {
	            if (e) throw e.error;
	        }
	    }
	    return ar;
	};
	
	function createNativeLocaleFormatter(locale, options, substrOptions) {
	    if (substrOptions === void 0) {
	        substrOptions = { start: 0, length: 0 };
	    }
	    var makeIsoString = function makeIsoString(dateString) {
	        var _a = __read(dateString.trim().split(' ')[0].split('-'), 3),
	            year = _a[0],
	            month = _a[1],
	            date = _a[2];
	        return [Object(_pad__WEBPACK_IMPORTED_MODULE_0__["default"])(year, 4), Object(_pad__WEBPACK_IMPORTED_MODULE_0__["default"])(month || 1), Object(_pad__WEBPACK_IMPORTED_MODULE_0__["default"])(date || 1)].join('-');
	    };
	    try {
	        var intlFormatter_1 = new Intl.DateTimeFormat(locale || undefined, options);
	        return function (dateString) {
	            return intlFormatter_1.format(new Date(makeIsoString(dateString) + "T00:00:00+00:00"));
	        };
	    } catch (e) {
	        return substrOptions.start || substrOptions.length ? function (dateString) {
	            return makeIsoString(dateString).substr(substrOptions.start || 0, substrOptions.length);
	        } : undefined;
	    }
	}
	/* harmony default export */ __webpack_exports__["default"] = (createNativeLocaleFormatter);
	
	/***/ }),
	
	/***/ "./src/components/VDatePicker/util/index.ts":
	/*!**************************************************!*\
	  !*** ./src/components/VDatePicker/util/index.ts ***!
	  \**************************************************/
	/*! exports provided: createNativeLocaleFormatter, monthChange, pad */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _createNativeLocaleFormatter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./createNativeLocaleFormatter */ "./src/components/VDatePicker/util/createNativeLocaleFormatter.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "createNativeLocaleFormatter", function() { return _createNativeLocaleFormatter__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	/* harmony import */ var _monthChange__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./monthChange */ "./src/components/VDatePicker/util/monthChange.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "monthChange", function() { return _monthChange__WEBPACK_IMPORTED_MODULE_1__["default"]; });
	
	/* harmony import */ var _pad__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./pad */ "./src/components/VDatePicker/util/pad.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "pad", function() { return _pad__WEBPACK_IMPORTED_MODULE_2__["default"]; });
	
	
	
	
	
	
	/***/ }),
	
	/***/ "./src/components/VDatePicker/util/isDateAllowed.ts":
	/*!**********************************************************!*\
	  !*** ./src/components/VDatePicker/util/isDateAllowed.ts ***!
	  \**********************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return isDateAllowed; });
	function isDateAllowed(date, min, max, allowedFn) {
	    return (!allowedFn || allowedFn(date)) && (!min || date >= min) && (!max || date <= max);
	}
	
	/***/ }),
	
	/***/ "./src/components/VDatePicker/util/monthChange.ts":
	/*!********************************************************!*\
	  !*** ./src/components/VDatePicker/util/monthChange.ts ***!
	  \********************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _pad__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./pad */ "./src/components/VDatePicker/util/pad.ts");
	var __read = undefined && undefined.__read || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o),
	        r,
	        ar = [],
	        e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
	            ar.push(r.value);
	        }
	    } catch (error) {
	        e = { error: error };
	    } finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        } finally {
	            if (e) throw e.error;
	        }
	    }
	    return ar;
	};
	
	/**
	 * @param {String} value YYYY-MM format
	 * @param {Number} sign -1 or +1
	 */
	/* harmony default export */ __webpack_exports__["default"] = (function (value, sign) {
	    var _a = __read(value.split('-').map(Number), 2),
	        year = _a[0],
	        month = _a[1];
	    if (month + sign === 0) {
	        return year - 1 + "-12";
	    } else if (month + sign === 13) {
	        return year + 1 + "-01";
	    } else {
	        return year + "-" + Object(_pad__WEBPACK_IMPORTED_MODULE_0__["default"])(month + sign);
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VDatePicker/util/pad.ts":
	/*!************************************************!*\
	  !*** ./src/components/VDatePicker/util/pad.ts ***!
	  \************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	var padStart = function padStart(string, targetLength, padString) {
	    targetLength = targetLength >> 0;
	    string = String(string);
	    padString = String(padString);
	    if (string.length > targetLength) {
	        return String(string);
	    }
	    targetLength = targetLength - string.length;
	    if (targetLength > padString.length) {
	        padString += padString.repeat(targetLength / padString.length);
	    }
	    return padString.slice(0, targetLength) + String(string);
	};
	/* harmony default export */ __webpack_exports__["default"] = (function (n, length) {
	    if (length === void 0) {
	        length = 2;
	    }
	    return padStart(n, length, '0');
	});
	
	/***/ }),
	
	/***/ "./src/components/VDialog/VDialog.js":
	/*!*******************************************!*\
	  !*** ./src/components/VDialog/VDialog.js ***!
	  \*******************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_dialogs_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_dialogs.styl */ "./src/stylus/components/_dialogs.styl");
	/* harmony import */ var _stylus_components_dialogs_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_dialogs_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_dependent__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/dependent */ "./src/mixins/dependent.ts");
	/* harmony import */ var _mixins_detachable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/detachable */ "./src/mixins/detachable.js");
	/* harmony import */ var _mixins_overlayable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/overlayable */ "./src/mixins/overlayable.ts");
	/* harmony import */ var _mixins_returnable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mixins/returnable */ "./src/mixins/returnable.ts");
	/* harmony import */ var _mixins_stackable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mixins/stackable */ "./src/mixins/stackable.ts");
	/* harmony import */ var _mixins_toggleable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mixins/toggleable */ "./src/mixins/toggleable.ts");
	/* harmony import */ var _directives_click_outside__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../directives/click-outside */ "./src/directives/click-outside.ts");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var _util_ThemeProvider__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../util/ThemeProvider */ "./src/util/ThemeProvider.ts");
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../util/console */ "./src/util/console.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	
	// Mixins
	
	
	
	
	
	
	// Directives
	
	// Helpers
	
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-dialog',
	    directives: {
	        ClickOutside: _directives_click_outside__WEBPACK_IMPORTED_MODULE_7__["default"]
	    },
	    mixins: [_mixins_dependent__WEBPACK_IMPORTED_MODULE_1__["default"], _mixins_detachable__WEBPACK_IMPORTED_MODULE_2__["default"], _mixins_overlayable__WEBPACK_IMPORTED_MODULE_3__["default"], _mixins_returnable__WEBPACK_IMPORTED_MODULE_4__["default"], _mixins_stackable__WEBPACK_IMPORTED_MODULE_5__["default"], _mixins_toggleable__WEBPACK_IMPORTED_MODULE_6__["default"]],
	    props: {
	        disabled: Boolean,
	        persistent: Boolean,
	        fullscreen: Boolean,
	        fullWidth: Boolean,
	        noClickAnimation: Boolean,
	        light: Boolean,
	        dark: Boolean,
	        maxWidth: {
	            type: [String, Number],
	            default: 'none'
	        },
	        origin: {
	            type: String,
	            default: 'center center'
	        },
	        width: {
	            type: [String, Number],
	            default: 'auto'
	        },
	        scrollable: Boolean,
	        transition: {
	            type: [String, Boolean],
	            default: 'dialog-transition'
	        }
	    },
	    data: function data() {
	        return {
	            animate: false,
	            animateTimeout: null,
	            stackClass: 'v-dialog__content--active',
	            stackMinZIndex: 200
	        };
	    },
	    computed: {
	        classes: function classes() {
	            var _a;
	            return _a = {}, _a[("v-dialog " + this.contentClass).trim()] = true, _a['v-dialog--active'] = this.isActive, _a['v-dialog--persistent'] = this.persistent, _a['v-dialog--fullscreen'] = this.fullscreen, _a['v-dialog--scrollable'] = this.scrollable, _a['v-dialog--animated'] = this.animate, _a;
	        },
	        contentClasses: function contentClasses() {
	            return {
	                'v-dialog__content': true,
	                'v-dialog__content--active': this.isActive
	            };
	        },
	        hasActivator: function hasActivator() {
	            return Boolean(!!this.$slots.activator || !!this.$scopedSlots.activator);
	        }
	    },
	    watch: {
	        isActive: function isActive(val) {
	            if (val) {
	                this.show();
	                this.hideScroll();
	            } else {
	                this.removeOverlay();
	                this.unbind();
	            }
	        },
	        fullscreen: function fullscreen(val) {
	            if (!this.isActive) return;
	            if (val) {
	                this.hideScroll();
	                this.removeOverlay(false);
	            } else {
	                this.showScroll();
	                this.genOverlay();
	            }
	        }
	    },
	    beforeMount: function beforeMount() {
	        var _this = this;
	        this.$nextTick(function () {
	            _this.isBooted = _this.isActive;
	            _this.isActive && _this.show();
	        });
	    },
	    mounted: function mounted() {
	        if (Object(_util_helpers__WEBPACK_IMPORTED_MODULE_8__["getSlotType"])(this, 'activator', true) === 'v-slot') {
	            Object(_util_console__WEBPACK_IMPORTED_MODULE_10__["consoleError"])("v-dialog's activator slot must be bound, try '<template #activator=\"data\"><v-btn v-on=\"data.on>'", this);
	        }
	    },
	    beforeDestroy: function beforeDestroy() {
	        if (typeof window !== 'undefined') this.unbind();
	    },
	    methods: {
	        animateClick: function animateClick() {
	            var _this = this;
	            this.animate = false;
	            // Needed for when clicking very fast
	            // outside of the dialog
	            this.$nextTick(function () {
	                _this.animate = true;
	                clearTimeout(_this.animateTimeout);
	                _this.animateTimeout = setTimeout(function () {
	                    return _this.animate = false;
	                }, 150);
	            });
	        },
	        closeConditional: function closeConditional(e) {
	            // If the dialog content contains
	            // the click event, or if the
	            // dialog is not active
	            if (!this.isActive || this.$refs.content.contains(e.target)) return false;
	            // If we made it here, the click is outside
	            // and is active. If persistent, and the
	            // click is on the overlay, animate
	            if (this.persistent) {
	                if (!this.noClickAnimation && this.overlay === e.target) this.animateClick();
	                return false;
	            }
	            // close dialog if !persistent, clicked outside and we're the topmost dialog.
	            // Since this should only be called in a capture event (bottom up), we shouldn't need to stop propagation
	            return this.activeZIndex >= this.getMaxZIndex();
	        },
	        hideScroll: function hideScroll() {
	            if (this.fullscreen) {
	                document.documentElement.classList.add('overflow-y-hidden');
	            } else {
	                _mixins_overlayable__WEBPACK_IMPORTED_MODULE_3__["default"].options.methods.hideScroll.call(this);
	            }
	        },
	        show: function show() {
	            !this.fullscreen && !this.hideOverlay && this.genOverlay();
	            this.$refs.content.focus();
	            this.bind();
	        },
	        bind: function bind() {
	            window.addEventListener('focusin', this.onFocusin);
	        },
	        unbind: function unbind() {
	            window.removeEventListener('focusin', this.onFocusin);
	        },
	        onKeydown: function onKeydown(e) {
	            if (e.keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_8__["keyCodes"].esc && !this.getOpenDependents().length) {
	                if (!this.persistent) {
	                    this.isActive = false;
	                    var activator_1 = this.getActivator();
	                    this.$nextTick(function () {
	                        return activator_1 && activator_1.focus();
	                    });
	                } else if (!this.noClickAnimation) {
	                    this.animateClick();
	                }
	            }
	            this.$emit('keydown', e);
	        },
	        onFocusin: function onFocusin(e) {
	            var target = event.target;
	            if (
	            // It isn't the document or the dialog body
	            ![document, this.$refs.content].includes(target) &&
	            // It isn't inside the dialog body
	            !this.$refs.content.contains(target) &&
	            // We're the topmost dialog
	            this.activeZIndex >= this.getMaxZIndex() &&
	            // It isn't inside a dependent element (like a menu)
	            !this.getOpenDependentElements().some(function (el) {
	                return el.contains(target);
	            })
	            // So we must have focused something outside the dialog and its children
	            ) {
	                    // Find and focus the first available element inside the dialog
	                    var focusable = this.$refs.content.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
	                    focusable.length && focusable[0].focus();
	                }
	        },
	        getActivator: function getActivator(e) {
	            if (this.$refs.activator) {
	                return this.$refs.activator.children.length > 0 ? this.$refs.activator.children[0] : this.$refs.activator;
	            }
	            if (e) {
	                this.activatedBy = e.currentTarget || e.target;
	            }
	            if (this.activatedBy) return this.activatedBy;
	            if (this.activatorNode) {
	                var activator = Array.isArray(this.activatorNode) ? this.activatorNode[0] : this.activatorNode;
	                var el = activator && activator.elm;
	                if (el) return el;
	            }
	            return null;
	        },
	        genActivator: function genActivator() {
	            var _this = this;
	            if (!this.hasActivator) return null;
	            var listeners = this.disabled ? {} : {
	                click: function click(e) {
	                    e.stopPropagation();
	                    _this.getActivator(e);
	                    if (!_this.disabled) _this.isActive = !_this.isActive;
	                }
	            };
	            if (Object(_util_helpers__WEBPACK_IMPORTED_MODULE_8__["getSlotType"])(this, 'activator') === 'scoped') {
	                var activator = this.$scopedSlots.activator({ on: listeners });
	                this.activatorNode = activator;
	                return activator;
	            }
	            return this.$createElement('div', {
	                staticClass: 'v-dialog__activator',
	                class: {
	                    'v-dialog__activator--disabled': this.disabled
	                },
	                ref: 'activator',
	                on: listeners
	            }, this.$slots.activator);
	        }
	    },
	    render: function render(h) {
	        var _this = this;
	        var children = [];
	        var data = {
	            'class': this.classes,
	            ref: 'dialog',
	            directives: [{
	                name: 'click-outside',
	                value: function value() {
	                    _this.isActive = false;
	                },
	                args: {
	                    closeConditional: this.closeConditional,
	                    include: this.getOpenDependentElements
	                }
	            }, { name: 'show', value: this.isActive }],
	            on: {
	                click: function click(e) {
	                    e.stopPropagation();
	                }
	            }
	        };
	        if (!this.fullscreen) {
	            data.style = {
	                maxWidth: this.maxWidth === 'none' ? undefined : Object(_util_helpers__WEBPACK_IMPORTED_MODULE_8__["convertToUnit"])(this.maxWidth),
	                width: this.width === 'auto' ? undefined : Object(_util_helpers__WEBPACK_IMPORTED_MODULE_8__["convertToUnit"])(this.width)
	            };
	        }
	        children.push(this.genActivator());
	        var dialog = h('div', data, this.showLazyContent(this.$slots.default));
	        if (this.transition) {
	            dialog = h('transition', {
	                props: {
	                    name: this.transition,
	                    origin: this.origin
	                }
	            }, [dialog]);
	        }
	        children.push(h('div', {
	            'class': this.contentClasses,
	            attrs: __assign({ tabIndex: '-1' }, this.getScopeIdAttrs()),
	            on: {
	                keydown: this.onKeydown
	            },
	            style: { zIndex: this.activeZIndex },
	            ref: 'content'
	        }, [this.$createElement(_util_ThemeProvider__WEBPACK_IMPORTED_MODULE_9__["default"], {
	            props: {
	                root: true,
	                light: this.light,
	                dark: this.dark
	            }
	        }, [dialog])]));
	        return h('div', {
	            staticClass: 'v-dialog__container',
	            style: {
	                display: !this.hasActivator || this.fullWidth ? 'block' : 'inline-block'
	            }
	        }, children);
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VDialog/index.js":
	/*!*****************************************!*\
	  !*** ./src/components/VDialog/index.js ***!
	  \*****************************************/
	/*! exports provided: VDialog, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VDialog__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VDialog */ "./src/components/VDialog/VDialog.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VDialog", function() { return _VDialog__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VDialog__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VDivider/VDivider.ts":
	/*!*********************************************!*\
	  !*** ./src/components/VDivider/VDivider.ts ***!
	  \*********************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_dividers_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_dividers.styl */ "./src/stylus/components/_dividers.styl");
	/* harmony import */ var _stylus_components_dividers_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_dividers_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	// Styles
	
	// Mixins
	
	/* harmony default export */ __webpack_exports__["default"] = (_mixins_themeable__WEBPACK_IMPORTED_MODULE_1__["default"].extend({
	    name: 'v-divider',
	    props: {
	        inset: Boolean,
	        vertical: Boolean
	    },
	    render: function render(h) {
	        return h('hr', {
	            class: __assign({ 'v-divider': true, 'v-divider--inset': this.inset, 'v-divider--vertical': this.vertical }, this.themeClasses),
	            attrs: this.$attrs,
	            on: this.$listeners
	        });
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VDivider/index.ts":
	/*!******************************************!*\
	  !*** ./src/components/VDivider/index.ts ***!
	  \******************************************/
	/*! exports provided: VDivider, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VDivider__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VDivider */ "./src/components/VDivider/VDivider.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VDivider", function() { return _VDivider__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VDivider__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VExpansionPanel/VExpansionPanel.ts":
	/*!***********************************************************!*\
	  !*** ./src/components/VExpansionPanel/VExpansionPanel.ts ***!
	  \***********************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_expansion_panel_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_expansion-panel.styl */ "./src/stylus/components/_expansion-panel.styl");
	/* harmony import */ var _stylus_components_expansion_panel_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_expansion_panel_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _mixins_registrable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/registrable */ "./src/mixins/registrable.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	
	
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_3__["default"])(_mixins_themeable__WEBPACK_IMPORTED_MODULE_1__["default"], Object(_mixins_registrable__WEBPACK_IMPORTED_MODULE_2__["provide"])('expansionPanel')).extend({
	    name: 'v-expansion-panel',
	    provide: function provide() {
	        return {
	            expansionPanel: this
	        };
	    },
	    props: {
	        disabled: Boolean,
	        readonly: Boolean,
	        expand: Boolean,
	        focusable: Boolean,
	        inset: Boolean,
	        popout: Boolean,
	        value: {
	            type: [Number, Array],
	            default: function _default() {
	                return null;
	            }
	        }
	    },
	    data: function data() {
	        return {
	            items: [],
	            open: []
	        };
	    },
	    computed: {
	        classes: function classes() {
	            return __assign({ 'v-expansion-panel--focusable': this.focusable, 'v-expansion-panel--popout': this.popout, 'v-expansion-panel--inset': this.inset }, this.themeClasses);
	        }
	    },
	    watch: {
	        expand: function expand(v) {
	            var openIndex = -1;
	            if (!v) {
	                // Close all panels unless only one is open
	                var openCount = this.open.reduce(function (acc, val) {
	                    return val ? acc + 1 : acc;
	                }, 0);
	                var open = Array(this.items.length).fill(false);
	                if (openCount === 1) {
	                    openIndex = this.open.indexOf(true);
	                }
	                if (openIndex > -1) {
	                    open[openIndex] = true;
	                }
	                this.open = open;
	            }
	            this.$emit('input', v ? this.open : openIndex > -1 ? openIndex : null);
	        },
	        value: function value(v) {
	            this.updateFromValue(v);
	        }
	    },
	    mounted: function mounted() {
	        this.value !== null && this.updateFromValue(this.value);
	    },
	    methods: {
	        updateFromValue: function updateFromValue(v) {
	            if (Array.isArray(v) && !this.expand) return;
	            var open = Array(this.items.length).fill(false);
	            if (typeof v === 'number') {
	                open[v] = true;
	            } else if (v !== null) {
	                open = v;
	            }
	            this.updatePanels(open);
	        },
	        updatePanels: function updatePanels(open) {
	            this.open = open;
	            for (var i = 0; i < this.items.length; i++) {
	                this.items[i].toggle(open && open[i]);
	            }
	        },
	        panelClick: function panelClick(uid) {
	            var open = this.expand ? this.open.slice() : Array(this.items.length).fill(false);
	            for (var i = 0; i < this.items.length; i++) {
	                if (this.items[i]._uid === uid) {
	                    open[i] = !this.open[i];
	                    !this.expand && this.$emit('input', open[i] ? i : null);
	                }
	            }
	            this.updatePanels(open);
	            if (this.expand) this.$emit('input', open);
	        },
	        register: function register(content) {
	            var i = this.items.push(content) - 1;
	            this.value !== null && this.updateFromValue(this.value);
	            content.toggle(!!this.open[i]);
	        },
	        unregister: function unregister(content) {
	            var index = this.items.findIndex(function (i) {
	                return i._uid === content._uid;
	            });
	            this.items.splice(index, 1);
	            this.open.splice(index, 1);
	        }
	    },
	    render: function render(h) {
	        return h('ul', {
	            staticClass: 'v-expansion-panel',
	            class: this.classes
	        }, this.$slots.default);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VExpansionPanel/VExpansionPanelContent.ts":
	/*!******************************************************************!*\
	  !*** ./src/components/VExpansionPanel/VExpansionPanelContent.ts ***!
	  \******************************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _transitions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../transitions */ "./src/components/transitions/index.js");
	/* harmony import */ var _mixins_bootable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/bootable */ "./src/mixins/bootable.ts");
	/* harmony import */ var _mixins_toggleable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/toggleable */ "./src/mixins/toggleable.ts");
	/* harmony import */ var _mixins_rippleable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/rippleable */ "./src/mixins/rippleable.ts");
	/* harmony import */ var _mixins_registrable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mixins/registrable */ "./src/mixins/registrable.ts");
	/* harmony import */ var _VIcon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../VIcon */ "./src/components/VIcon/index.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../util/console */ "./src/util/console.ts");
	var __read = undefined && undefined.__read || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o),
	        r,
	        ar = [],
	        e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
	            ar.push(r.value);
	        }
	    } catch (error) {
	        e = { error: error };
	    } finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        } finally {
	            if (e) throw e.error;
	        }
	    }
	    return ar;
	};
	var __spread = undefined && undefined.__spread || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) {
	        ar = ar.concat(__read(arguments[i]));
	    }return ar;
	};
	
	
	
	
	
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_6__["default"])(_mixins_bootable__WEBPACK_IMPORTED_MODULE_1__["default"], _mixins_toggleable__WEBPACK_IMPORTED_MODULE_2__["default"], _mixins_rippleable__WEBPACK_IMPORTED_MODULE_3__["default"], Object(_mixins_registrable__WEBPACK_IMPORTED_MODULE_4__["inject"])('expansionPanel', 'v-expansion-panel-content', 'v-expansion-panel')
	/* @vue/component */
	).extend({
	    name: 'v-expansion-panel-content',
	    props: {
	        disabled: Boolean,
	        readonly: Boolean,
	        expandIcon: {
	            type: String,
	            default: '$vuetify.icons.expand'
	        },
	        hideActions: Boolean,
	        ripple: {
	            type: [Boolean, Object],
	            default: false
	        }
	    },
	    data: function data() {
	        return {
	            height: 'auto'
	        };
	    },
	    computed: {
	        containerClasses: function containerClasses() {
	            return {
	                'v-expansion-panel__container--active': this.isActive,
	                'v-expansion-panel__container--disabled': this.isDisabled
	            };
	        },
	        isDisabled: function isDisabled() {
	            return this.expansionPanel.disabled || this.disabled;
	        },
	        isReadonly: function isReadonly() {
	            return this.expansionPanel.readonly || this.readonly;
	        }
	    },
	    beforeMount: function beforeMount() {
	        this.expansionPanel.register(this);
	        // Can be removed once fully deprecated
	        if (typeof this.value !== 'undefined') Object(_util_console__WEBPACK_IMPORTED_MODULE_7__["consoleWarn"])('v-model has been deprecated', this);
	    },
	    beforeDestroy: function beforeDestroy() {
	        this.expansionPanel.unregister(this);
	    },
	    methods: {
	        onKeydown: function onKeydown(e) {
	            // Ensure element is the activeElement
	            if (e.keyCode === 13 && this.$el === document.activeElement) this.expansionPanel.panelClick(this._uid);
	        },
	        onHeaderClick: function onHeaderClick() {
	            this.isReadonly || this.expansionPanel.panelClick(this._uid);
	        },
	        genBody: function genBody() {
	            return this.$createElement('div', {
	                ref: 'body',
	                class: 'v-expansion-panel__body',
	                directives: [{
	                    name: 'show',
	                    value: this.isActive
	                }]
	            }, this.showLazyContent(this.$slots.default));
	        },
	        genHeader: function genHeader() {
	            var children = __spread(this.$slots.header || []);
	            if (!this.hideActions) children.push(this.genIcon());
	            return this.$createElement('div', {
	                staticClass: 'v-expansion-panel__header',
	                directives: [{
	                    name: 'ripple',
	                    value: this.ripple
	                }],
	                on: {
	                    click: this.onHeaderClick
	                }
	            }, children);
	        },
	        genIcon: function genIcon() {
	            var icon = this.$slots.actions || [this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_5__["default"], this.expandIcon)];
	            return this.$createElement('transition', {
	                attrs: { name: 'fade-transition' }
	            }, [this.$createElement('div', {
	                staticClass: 'v-expansion-panel__header__icon',
	                directives: [{
	                    name: 'show',
	                    value: !this.isDisabled
	                }]
	            }, icon)]);
	        },
	        toggle: function toggle(active) {
	            var _this = this;
	            if (active) this.isBooted = true;
	            this.$nextTick(function () {
	                return _this.isActive = active;
	            });
	        }
	    },
	    render: function render(h) {
	        return h('li', {
	            staticClass: 'v-expansion-panel__container',
	            class: this.containerClasses,
	            attrs: {
	                tabindex: this.isReadonly || this.isDisabled ? null : 0,
	                'aria-expanded': Boolean(this.isActive)
	            },
	            on: {
	                keydown: this.onKeydown
	            }
	        }, [this.$slots.header && this.genHeader(), h(_transitions__WEBPACK_IMPORTED_MODULE_0__["VExpandTransition"], [this.genBody()])]);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VExpansionPanel/index.ts":
	/*!*************************************************!*\
	  !*** ./src/components/VExpansionPanel/index.ts ***!
	  \*************************************************/
	/*! exports provided: VExpansionPanel, VExpansionPanelContent, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VExpansionPanel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VExpansionPanel */ "./src/components/VExpansionPanel/VExpansionPanel.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VExpansionPanel", function() { return _VExpansionPanel__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	/* harmony import */ var _VExpansionPanelContent__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./VExpansionPanelContent */ "./src/components/VExpansionPanel/VExpansionPanelContent.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VExpansionPanelContent", function() { return _VExpansionPanelContent__WEBPACK_IMPORTED_MODULE_1__["default"]; });
	
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = ({
	    $_vuetify_subcomponents: {
	        VExpansionPanel: _VExpansionPanel__WEBPACK_IMPORTED_MODULE_0__["default"],
	        VExpansionPanelContent: _VExpansionPanelContent__WEBPACK_IMPORTED_MODULE_1__["default"]
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VFooter/VFooter.js":
	/*!*******************************************!*\
	  !*** ./src/components/VFooter/VFooter.js ***!
	  \*******************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_footer_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_footer.styl */ "./src/stylus/components/_footer.styl");
	/* harmony import */ var _stylus_components_footer_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_footer_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_applicationable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/applicationable */ "./src/mixins/applicationable.ts");
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	// Styles
	
	// Mixins
	
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-footer',
	    mixins: [Object(_mixins_applicationable__WEBPACK_IMPORTED_MODULE_1__["default"])(null, ['height', 'inset']), _mixins_colorable__WEBPACK_IMPORTED_MODULE_2__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_3__["default"]],
	    props: {
	        height: {
	            default: 32,
	            type: [Number, String]
	        },
	        inset: Boolean
	    },
	    computed: {
	        applicationProperty: function applicationProperty() {
	            return this.inset ? 'insetFooter' : 'footer';
	        },
	        computedMarginBottom: function computedMarginBottom() {
	            if (!this.app) return;
	            return this.$vuetify.application.bottom;
	        },
	        computedPaddingLeft: function computedPaddingLeft() {
	            return !this.app || !this.inset ? 0 : this.$vuetify.application.left;
	        },
	        computedPaddingRight: function computedPaddingRight() {
	            return !this.app || !this.inset ? 0 : this.$vuetify.application.right;
	        },
	        styles: function styles() {
	            var styles = {
	                height: isNaN(this.height) ? this.height : this.height + "px"
	            };
	            if (this.computedPaddingLeft) {
	                styles.paddingLeft = this.computedPaddingLeft + "px";
	            }
	            if (this.computedPaddingRight) {
	                styles.paddingRight = this.computedPaddingRight + "px";
	            }
	            if (this.computedMarginBottom) {
	                styles.marginBottom = this.computedMarginBottom + "px";
	            }
	            return styles;
	        }
	    },
	    methods: {
	        /**
	         * Update the application layout
	         *
	         * @return {number}
	         */
	        updateApplication: function updateApplication() {
	            var height = parseInt(this.height);
	            return isNaN(height) ? this.$el ? this.$el.clientHeight : 0 : height;
	        }
	    },
	    render: function render(h) {
	        var data = this.setBackgroundColor(this.color, {
	            staticClass: 'v-footer',
	            'class': __assign({ 'v-footer--absolute': this.absolute, 'v-footer--fixed': !this.absolute && (this.app || this.fixed), 'v-footer--inset': this.inset }, this.themeClasses),
	            style: this.styles,
	            ref: 'content'
	        });
	        return h('footer', data, this.$slots.default);
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VFooter/index.js":
	/*!*****************************************!*\
	  !*** ./src/components/VFooter/index.js ***!
	  \*****************************************/
	/*! exports provided: VFooter, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VFooter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VFooter */ "./src/components/VFooter/VFooter.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VFooter", function() { return _VFooter__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VFooter__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VForm/VForm.js":
	/*!***************************************!*\
	  !*** ./src/components/VForm/VForm.js ***!
	  \***************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_forms_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_forms.styl */ "./src/stylus/components/_forms.styl");
	/* harmony import */ var _stylus_components_forms_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_forms_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_registrable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/registrable */ "./src/mixins/registrable.ts");
	// Styles
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-form',
	    mixins: [Object(_mixins_registrable__WEBPACK_IMPORTED_MODULE_1__["provide"])('form')],
	    inheritAttrs: false,
	    props: {
	        value: Boolean,
	        lazyValidation: Boolean
	    },
	    data: function data() {
	        return {
	            inputs: [],
	            watchers: [],
	            errorBag: {}
	        };
	    },
	    watch: {
	        errorBag: {
	            handler: function handler() {
	                var errors = Object.values(this.errorBag).includes(true);
	                this.$emit('input', !errors);
	            },
	            deep: true,
	            immediate: true
	        }
	    },
	    methods: {
	        watchInput: function watchInput(input) {
	            var _this = this;
	            var watcher = function watcher(input) {
	                return input.$watch('hasError', function (val) {
	                    _this.$set(_this.errorBag, input._uid, val);
	                }, { immediate: true });
	            };
	            var watchers = {
	                _uid: input._uid,
	                valid: undefined,
	                shouldValidate: undefined
	            };
	            if (this.lazyValidation) {
	                // Only start watching inputs if we need to
	                watchers.shouldValidate = input.$watch('shouldValidate', function (val) {
	                    if (!val) return;
	                    // Only watch if we're not already doing it
	                    if (_this.errorBag.hasOwnProperty(input._uid)) return;
	                    watchers.valid = watcher(input);
	                });
	            } else {
	                watchers.valid = watcher(input);
	            }
	            return watchers;
	        },
	        /** @public */
	        validate: function validate() {
	            var errors = this.inputs.filter(function (input) {
	                return !input.validate(true);
	            }).length;
	            return !errors;
	        },
	        /** @public */
	        reset: function reset() {
	            var _this = this;
	            for (var i = this.inputs.length; i--;) {
	                this.inputs[i].reset();
	            }
	            if (this.lazyValidation) {
	                // Account for timeout in validatable
	                setTimeout(function () {
	                    _this.errorBag = {};
	                }, 0);
	            }
	        },
	        /** @public */
	        resetValidation: function resetValidation() {
	            var _this = this;
	            for (var i = this.inputs.length; i--;) {
	                this.inputs[i].resetValidation();
	            }
	            if (this.lazyValidation) {
	                // Account for timeout in validatable
	                setTimeout(function () {
	                    _this.errorBag = {};
	                }, 0);
	            }
	        },
	        register: function register(input) {
	            var unwatch = this.watchInput(input);
	            this.inputs.push(input);
	            this.watchers.push(unwatch);
	        },
	        unregister: function unregister(input) {
	            var found = this.inputs.find(function (i) {
	                return i._uid === input._uid;
	            });
	            if (!found) return;
	            var unwatch = this.watchers.find(function (i) {
	                return i._uid === found._uid;
	            });
	            unwatch.valid && unwatch.valid();
	            unwatch.shouldValidate && unwatch.shouldValidate();
	            this.watchers = this.watchers.filter(function (i) {
	                return i._uid !== found._uid;
	            });
	            this.inputs = this.inputs.filter(function (i) {
	                return i._uid !== found._uid;
	            });
	            this.$delete(this.errorBag, found._uid);
	        }
	    },
	    render: function render(h) {
	        var _this = this;
	        return h('form', {
	            staticClass: 'v-form',
	            attrs: Object.assign({
	                novalidate: true
	            }, this.$attrs),
	            on: {
	                submit: function submit(e) {
	                    return _this.$emit('submit', e);
	                }
	            }
	        }, this.$slots.default);
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VForm/index.js":
	/*!***************************************!*\
	  !*** ./src/components/VForm/index.js ***!
	  \***************************************/
	/*! exports provided: VForm, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VForm__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VForm */ "./src/components/VForm/VForm.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VForm", function() { return _VForm__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VForm__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VGrid/VContainer.js":
	/*!********************************************!*\
	  !*** ./src/components/VGrid/VContainer.js ***!
	  \********************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_grid_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_grid.styl */ "./src/stylus/components/_grid.styl");
	/* harmony import */ var _stylus_components_grid_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_grid_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _grid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./grid */ "./src/components/VGrid/grid.js");
	
	
	/* harmony default export */ __webpack_exports__["default"] = (Object(_grid__WEBPACK_IMPORTED_MODULE_1__["default"])('container'));
	
	/***/ }),
	
	/***/ "./src/components/VGrid/VContent.js":
	/*!******************************************!*\
	  !*** ./src/components/VGrid/VContent.js ***!
	  \******************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_content_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_content.styl */ "./src/stylus/components/_content.styl");
	/* harmony import */ var _stylus_components_content_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_content_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_ssr_bootable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/ssr-bootable */ "./src/mixins/ssr-bootable.ts");
	// Styles
	
	// Mixins
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-content',
	    mixins: [_mixins_ssr_bootable__WEBPACK_IMPORTED_MODULE_1__["default"]],
	    props: {
	        tag: {
	            type: String,
	            default: 'main'
	        }
	    },
	    computed: {
	        styles: function styles() {
	            var _a = this.$vuetify.application,
	                bar = _a.bar,
	                top = _a.top,
	                right = _a.right,
	                footer = _a.footer,
	                insetFooter = _a.insetFooter,
	                bottom = _a.bottom,
	                left = _a.left;
	            return {
	                paddingTop: top + bar + "px",
	                paddingRight: right + "px",
	                paddingBottom: footer + insetFooter + bottom + "px",
	                paddingLeft: left + "px"
	            };
	        }
	    },
	    render: function render(h) {
	        var data = {
	            staticClass: 'v-content',
	            style: this.styles,
	            ref: 'content'
	        };
	        return h(this.tag, data, [h('div', { staticClass: 'v-content__wrap' }, this.$slots.default)]);
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VGrid/VFlex.js":
	/*!***************************************!*\
	  !*** ./src/components/VGrid/VFlex.js ***!
	  \***************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_grid_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_grid.styl */ "./src/stylus/components/_grid.styl");
	/* harmony import */ var _stylus_components_grid_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_grid_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _grid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./grid */ "./src/components/VGrid/grid.js");
	
	
	/* harmony default export */ __webpack_exports__["default"] = (Object(_grid__WEBPACK_IMPORTED_MODULE_1__["default"])('flex'));
	
	/***/ }),
	
	/***/ "./src/components/VGrid/VLayout.js":
	/*!*****************************************!*\
	  !*** ./src/components/VGrid/VLayout.js ***!
	  \*****************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_grid_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_grid.styl */ "./src/stylus/components/_grid.styl");
	/* harmony import */ var _stylus_components_grid_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_grid_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _grid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./grid */ "./src/components/VGrid/grid.js");
	
	
	/* harmony default export */ __webpack_exports__["default"] = (Object(_grid__WEBPACK_IMPORTED_MODULE_1__["default"])('layout'));
	
	/***/ }),
	
	/***/ "./src/components/VGrid/grid.js":
	/*!**************************************!*\
	  !*** ./src/components/VGrid/grid.js ***!
	  \**************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Grid; });
	function Grid(name) {
	    /* @vue/component */
	    return {
	        name: "v-" + name,
	        functional: true,
	        props: {
	            id: String,
	            tag: {
	                type: String,
	                default: 'div'
	            }
	        },
	        render: function render(h, _a) {
	            var props = _a.props,
	                data = _a.data,
	                children = _a.children;
	            data.staticClass = (name + " " + (data.staticClass || '')).trim();
	            var attrs = data.attrs;
	            if (attrs) {
	                // reset attrs to extract utility clases like pa-3
	                data.attrs = {};
	                var classes = Object.keys(attrs).filter(function (key) {
	                    // TODO: Remove once resolved
	                    // https://github.com/vuejs/vue/issues/7841
	                    if (key === 'slot') return false;
	                    var value = attrs[key];
	                    // add back data attributes like data-test="foo" but do not
	                    // add them as classes
	                    if (key.startsWith('data-')) {
	                        data.attrs[key] = value;
	                        return false;
	                    }
	                    return value || typeof value === 'string';
	                });
	                if (classes.length) data.staticClass += " " + classes.join(' ');
	            }
	            if (props.id) {
	                data.domProps = data.domProps || {};
	                data.domProps.id = props.id;
	            }
	            return h(props.tag, data, children);
	        }
	    };
	}
	
	/***/ }),
	
	/***/ "./src/components/VGrid/index.js":
	/*!***************************************!*\
	  !*** ./src/components/VGrid/index.js ***!
	  \***************************************/
	/*! exports provided: VContainer, VContent, VFlex, VLayout, VSpacer, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VSpacer", function() { return VSpacer; });
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var _VContainer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./VContainer */ "./src/components/VGrid/VContainer.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VContainer", function() { return _VContainer__WEBPACK_IMPORTED_MODULE_1__["default"]; });
	
	/* harmony import */ var _VContent__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./VContent */ "./src/components/VGrid/VContent.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VContent", function() { return _VContent__WEBPACK_IMPORTED_MODULE_2__["default"]; });
	
	/* harmony import */ var _VFlex__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./VFlex */ "./src/components/VGrid/VFlex.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VFlex", function() { return _VFlex__WEBPACK_IMPORTED_MODULE_3__["default"]; });
	
	/* harmony import */ var _VLayout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./VLayout */ "./src/components/VGrid/VLayout.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VLayout", function() { return _VLayout__WEBPACK_IMPORTED_MODULE_4__["default"]; });
	
	
	
	
	
	
	var VSpacer = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleFunctional"])('spacer', 'div', 'v-spacer');
	
	/* harmony default export */ __webpack_exports__["default"] = ({
	    $_vuetify_subcomponents: {
	        VContainer: _VContainer__WEBPACK_IMPORTED_MODULE_1__["default"],
	        VContent: _VContent__WEBPACK_IMPORTED_MODULE_2__["default"],
	        VFlex: _VFlex__WEBPACK_IMPORTED_MODULE_3__["default"],
	        VLayout: _VLayout__WEBPACK_IMPORTED_MODULE_4__["default"],
	        VSpacer: VSpacer
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VHover/VHover.ts":
	/*!*****************************************!*\
	  !*** ./src/components/VHover/VHover.ts ***!
	  \*****************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _mixins_delayable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mixins/delayable */ "./src/mixins/delayable.ts");
	/* harmony import */ var _mixins_toggleable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/toggleable */ "./src/mixins/toggleable.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../util/console */ "./src/util/console.ts");
	// Mixins
	
	
	// Utilities
	
	
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_2__["default"])(_mixins_delayable__WEBPACK_IMPORTED_MODULE_0__["default"], _mixins_toggleable__WEBPACK_IMPORTED_MODULE_1__["default"]
	/* @vue/component */
	).extend({
	    name: 'v-hover',
	    props: {
	        disabled: {
	            type: Boolean,
	            default: false
	        },
	        value: {
	            type: Boolean,
	            default: undefined
	        }
	    },
	    methods: {
	        onMouseEnter: function onMouseEnter() {
	            this.runDelay('open');
	        },
	        onMouseLeave: function onMouseLeave() {
	            this.runDelay('close');
	        }
	    },
	    render: function render() {
	        if (!this.$scopedSlots.default && this.value === undefined) {
	            Object(_util_console__WEBPACK_IMPORTED_MODULE_3__["consoleWarn"])('v-hover is missing a default scopedSlot or bound value', this);
	            return null;
	        }
	        var element;
	        if (this.$scopedSlots.default) {
	            element = this.$scopedSlots.default({ hover: this.isActive });
	        } else if (this.$slots.default && this.$slots.default.length === 1) {
	            element = this.$slots.default[0];
	        }
	        if (Array.isArray(element) && element.length === 1) {
	            element = element[0];
	        }
	        if (!element || Array.isArray(element) || !element.tag) {
	            Object(_util_console__WEBPACK_IMPORTED_MODULE_3__["consoleWarn"])('v-hover should only contain a single element', this);
	            return element;
	        }
	        if (!this.disabled) {
	            element.data = element.data || {};
	            this._g(element.data, {
	                mouseenter: this.onMouseEnter,
	                mouseleave: this.onMouseLeave
	            });
	        }
	        return element;
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VHover/index.ts":
	/*!****************************************!*\
	  !*** ./src/components/VHover/index.ts ***!
	  \****************************************/
	/*! exports provided: VHover, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VHover__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VHover */ "./src/components/VHover/VHover.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VHover", function() { return _VHover__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VHover__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VIcon/VIcon.ts":
	/*!***************************************!*\
	  !*** ./src/components/VIcon/VIcon.ts ***!
	  \***************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_icons_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_icons.styl */ "./src/stylus/components/_icons.styl");
	/* harmony import */ var _stylus_components_icons_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_icons_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _mixins_sizeable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/sizeable */ "./src/mixins/sizeable.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_5__);
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	
	// Mixins
	
	
	
	// Util
	
	// Types
	
	
	var SIZE_MAP;
	(function (SIZE_MAP) {
	    SIZE_MAP["small"] = "16px";
	    SIZE_MAP["default"] = "24px";
	    SIZE_MAP["medium"] = "28px";
	    SIZE_MAP["large"] = "36px";
	    SIZE_MAP["xLarge"] = "40px";
	})(SIZE_MAP || (SIZE_MAP = {}));
	function isFontAwesome5(iconType) {
	    return ['fas', 'far', 'fal', 'fab'].some(function (val) {
	        return iconType.includes(val);
	    });
	}
	var VIcon = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_6__["default"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_1__["default"], _mixins_sizeable__WEBPACK_IMPORTED_MODULE_2__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_3__["default"]
	/* @vue/component */
	).extend({
	    name: 'v-icon',
	    props: {
	        disabled: Boolean,
	        left: Boolean,
	        right: Boolean
	    },
	    methods: {
	        getIcon: function getIcon() {
	            var iconName = '';
	            if (this.$slots.default) iconName = this.$slots.default[0].text.trim();
	            return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["remapInternalIcon"])(this, iconName);
	        },
	        getSize: function getSize() {
	            var sizes = {
	                small: this.small,
	                medium: this.medium,
	                large: this.large,
	                xLarge: this.xLarge
	            };
	            var explicitSize = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["keys"])(sizes).find(function (key) {
	                return sizes[key];
	            });
	            return explicitSize && SIZE_MAP[explicitSize] || Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["convertToUnit"])(this.size);
	        },
	        // Component data for both font and svg icon.
	        getDefaultData: function getDefaultData() {
	            var data = {
	                staticClass: 'v-icon',
	                class: {
	                    'v-icon--disabled': this.disabled,
	                    'v-icon--left': this.left,
	                    'v-icon--link': this.$listeners.click || this.$listeners['!click'],
	                    'v-icon--right': this.right
	                },
	                attrs: __assign({ 'aria-hidden': true }, this.$attrs),
	                on: this.$listeners
	            };
	            return data;
	        },
	        applyColors: function applyColors(data) {
	            data.class = __assign({}, data.class, this.themeClasses);
	            this.setTextColor(this.color, data);
	        },
	        renderFontIcon: function renderFontIcon(icon, h) {
	            var newChildren = [];
	            var data = this.getDefaultData();
	            var iconType = 'material-icons';
	            // Material Icon delimiter is _
	            // https://material.io/icons/
	            var delimiterIndex = icon.indexOf('-');
	            var isMaterialIcon = delimiterIndex <= -1;
	            if (isMaterialIcon) {
	                // Material icon uses ligatures.
	                newChildren.push(icon);
	            } else {
	                iconType = icon.slice(0, delimiterIndex);
	                if (isFontAwesome5(iconType)) iconType = '';
	            }
	            data.class[iconType] = true;
	            data.class[icon] = !isMaterialIcon;
	            var fontSize = this.getSize();
	            if (fontSize) data.style = { fontSize: fontSize };
	            this.applyColors(data);
	            return h('i', data, newChildren);
	        },
	        renderSvgIcon: function renderSvgIcon(icon, h) {
	            var data = this.getDefaultData();
	            data.class['v-icon--is-component'] = true;
	            var size = this.getSize();
	            if (size) {
	                data.style = {
	                    fontSize: size,
	                    height: size
	                };
	            }
	            this.applyColors(data);
	            var component = icon.component;
	            data.props = icon.props;
	            data.nativeOn = data.on;
	            return h(component, data);
	        }
	    },
	    render: function render(h) {
	        var icon = this.getIcon();
	        if (typeof icon === 'string') {
	            return this.renderFontIcon(icon, h);
	        }
	        return this.renderSvgIcon(icon, h);
	    }
	});
	/* harmony default export */ __webpack_exports__["default"] = (vue__WEBPACK_IMPORTED_MODULE_5___default.a.extend({
	    name: 'v-icon',
	    $_wrapperFor: VIcon,
	    functional: true,
	    render: function render(h, _a) {
	        var data = _a.data,
	            children = _a.children;
	        var iconName = '';
	        // Support usage of v-text and v-html
	        if (data.domProps) {
	            iconName = data.domProps.textContent || data.domProps.innerHTML || iconName;
	            // Remove nodes so it doesn't
	            // overwrite our changes
	            delete data.domProps.textContent;
	            delete data.domProps.innerHTML;
	        }
	        return h(VIcon, data, iconName ? [iconName] : children);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VIcon/index.ts":
	/*!***************************************!*\
	  !*** ./src/components/VIcon/index.ts ***!
	  \***************************************/
	/*! exports provided: VIcon, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VIcon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VIcon */ "./src/components/VIcon/VIcon.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VIcon", function() { return _VIcon__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VIcon__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VImg/VImg.ts":
	/*!*************************************!*\
	  !*** ./src/components/VImg/VImg.ts ***!
	  \*************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_images_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_images.styl */ "./src/stylus/components/_images.styl");
	/* harmony import */ var _stylus_components_images_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_images_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _VResponsive__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../VResponsive */ "./src/components/VResponsive/index.ts");
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../util/console */ "./src/util/console.ts");
	
	// Components
	
	// Utils
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (_VResponsive__WEBPACK_IMPORTED_MODULE_1__["default"].extend({
	    name: 'v-img',
	    props: {
	        alt: String,
	        contain: Boolean,
	        src: {
	            type: [String, Object],
	            default: ''
	        },
	        gradient: String,
	        lazySrc: String,
	        srcset: String,
	        sizes: String,
	        position: {
	            type: String,
	            default: 'center center'
	        },
	        transition: {
	            type: [Boolean, String],
	            default: 'fade-transition'
	        }
	    },
	    data: function data() {
	        return {
	            currentSrc: '',
	            image: null,
	            isLoading: true,
	            calculatedAspectRatio: undefined
	        };
	    },
	    computed: {
	        computedAspectRatio: function computedAspectRatio() {
	            return this.normalisedSrc.aspect;
	        },
	        normalisedSrc: function normalisedSrc() {
	            return typeof this.src === 'string' ? {
	                src: this.src,
	                srcset: this.srcset,
	                lazySrc: this.lazySrc,
	                aspect: Number(this.aspectRatio || this.calculatedAspectRatio)
	            } : {
	                src: this.src.src,
	                srcset: this.srcset || this.src.srcset,
	                lazySrc: this.lazySrc || this.src.lazySrc,
	                aspect: Number(this.aspectRatio || this.src.aspect || this.calculatedAspectRatio)
	            };
	        },
	        __cachedImage: function __cachedImage() {
	            if (!(this.normalisedSrc.src || this.normalisedSrc.lazySrc)) return [];
	            var backgroundImage = [];
	            var src = this.isLoading ? this.normalisedSrc.lazySrc : this.currentSrc;
	            if (this.gradient) backgroundImage.push("linear-gradient(" + this.gradient + ")");
	            if (src) backgroundImage.push("url(\"" + src + "\")");
	            var image = this.$createElement('div', {
	                staticClass: 'v-image__image',
	                class: {
	                    'v-image__image--preload': this.isLoading,
	                    'v-image__image--contain': this.contain,
	                    'v-image__image--cover': !this.contain
	                },
	                style: {
	                    backgroundImage: backgroundImage.join(', '),
	                    backgroundPosition: this.position
	                },
	                key: +this.isLoading
	            });
	            if (!this.transition) return image;
	            return this.$createElement('transition', {
	                attrs: {
	                    name: this.transition,
	                    mode: 'in-out'
	                }
	            }, [image]);
	        }
	    },
	    watch: {
	        src: function src() {
	            if (!this.isLoading) this.init();else this.loadImage();
	        },
	        '$vuetify.breakpoint.width': 'getSrc'
	    },
	    mounted: function mounted() {
	        this.init();
	    },
	    methods: {
	        init: function init() {
	            if (this.normalisedSrc.lazySrc) {
	                var lazyImg = new Image();
	                lazyImg.src = this.normalisedSrc.lazySrc;
	                this.pollForSize(lazyImg, null);
	            }
	            /* istanbul ignore else */
	            if (this.normalisedSrc.src) this.loadImage();
	        },
	        onLoad: function onLoad() {
	            this.getSrc();
	            this.isLoading = false;
	            this.$emit('load', this.src);
	        },
	        onError: function onError() {
	            Object(_util_console__WEBPACK_IMPORTED_MODULE_2__["consoleError"])("Image load failed\n\n" + ("src: " + this.normalisedSrc.src), this);
	            this.$emit('error', this.src);
	        },
	        getSrc: function getSrc() {
	            /* istanbul ignore else */
	            if (this.image) this.currentSrc = this.image.currentSrc || this.image.src;
	        },
	        loadImage: function loadImage() {
	            var _this = this;
	            var image = new Image();
	            this.image = image;
	            image.onload = function () {
	                /* istanbul ignore if */
	                if (image.decode) {
	                    image.decode().catch(function (err) {
	                        Object(_util_console__WEBPACK_IMPORTED_MODULE_2__["consoleWarn"])("Failed to decode image, trying to render anyway\n\n" + ("src: " + _this.normalisedSrc.src) + (err.message ? "\nOriginal error: " + err.message : ''), _this);
	                    }).then(_this.onLoad);
	                } else {
	                    _this.onLoad();
	                }
	            };
	            image.onerror = this.onError;
	            image.src = this.normalisedSrc.src;
	            this.sizes && (image.sizes = this.sizes);
	            this.normalisedSrc.srcset && (image.srcset = this.normalisedSrc.srcset);
	            this.aspectRatio || this.pollForSize(image);
	            this.getSrc();
	        },
	        pollForSize: function pollForSize(img, timeout) {
	            var _this = this;
	            if (timeout === void 0) {
	                timeout = 100;
	            }
	            var poll = function poll() {
	                var naturalHeight = img.naturalHeight,
	                    naturalWidth = img.naturalWidth;
	                if (naturalHeight || naturalWidth) {
	                    _this.calculatedAspectRatio = naturalWidth / naturalHeight;
	                } else {
	                    timeout != null && setTimeout(poll, timeout);
	                }
	            };
	            poll();
	        },
	        __genPlaceholder: function __genPlaceholder() {
	            if (this.$slots.placeholder) {
	                var placeholder = this.isLoading ? [this.$createElement('div', {
	                    staticClass: 'v-image__placeholder'
	                }, this.$slots.placeholder)] : [];
	                if (!this.transition) return placeholder[0];
	                return this.$createElement('transition', {
	                    attrs: { name: this.transition }
	                }, placeholder);
	            }
	        }
	    },
	    render: function render(h) {
	        var node = _VResponsive__WEBPACK_IMPORTED_MODULE_1__["default"].options.render.call(this, h);
	        node.data.staticClass += ' v-image';
	        node.data.attrs = {
	            role: this.alt ? 'img' : undefined,
	            'aria-label': this.alt
	        };
	        node.children = [this.__cachedSizer, this.__cachedImage, this.__genPlaceholder(), this.genContent()];
	        return h(node.tag, node.data, node.children);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VImg/index.ts":
	/*!**************************************!*\
	  !*** ./src/components/VImg/index.ts ***!
	  \**************************************/
	/*! exports provided: VImg, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VImg__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VImg */ "./src/components/VImg/VImg.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VImg", function() { return _VImg__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VImg__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VInput/VInput.ts":
	/*!*****************************************!*\
	  !*** ./src/components/VInput/VInput.ts ***!
	  \*****************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_inputs_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_inputs.styl */ "./src/stylus/components/_inputs.styl");
	/* harmony import */ var _stylus_components_inputs_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_inputs_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _VIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../VIcon */ "./src/components/VIcon/index.ts");
	/* harmony import */ var _VLabel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../VLabel */ "./src/components/VLabel/index.ts");
	/* harmony import */ var _VMessages__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../VMessages */ "./src/components/VMessages/index.ts");
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _mixins_validatable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mixins/validatable */ "./src/mixins/validatable.ts");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../util/console */ "./src/util/console.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	// Styles
	
	// Components
	
	
	
	// Mixins
	
	
	
	// Utilities
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_9__["default"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_4__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_5__["default"], _mixins_validatable__WEBPACK_IMPORTED_MODULE_6__["default"]
	/* @vue/component */
	).extend({
	    name: 'v-input',
	    props: {
	        appendIcon: String,
	        /** @deprecated */
	        appendIconCb: Function,
	        backgroundColor: {
	            type: String,
	            default: ''
	        },
	        height: [Number, String],
	        hideDetails: Boolean,
	        hint: String,
	        label: String,
	        loading: Boolean,
	        persistentHint: Boolean,
	        prependIcon: String,
	        /** @deprecated */
	        prependIconCb: Function,
	        value: { required: false }
	    },
	    data: function data() {
	        return {
	            attrsInput: {},
	            lazyValue: this.value,
	            hasMouseDown: false
	        };
	    },
	    computed: {
	        classes: function classes() {
	            return {};
	        },
	        classesInput: function classesInput() {
	            return __assign({}, this.classes, { 'v-input--has-state': this.hasState, 'v-input--hide-details': this.hideDetails, 'v-input--is-label-active': this.isLabelActive, 'v-input--is-dirty': this.isDirty, 'v-input--is-disabled': this.disabled, 'v-input--is-focused': this.isFocused, 'v-input--is-loading': this.loading !== false && this.loading !== undefined, 'v-input--is-readonly': this.readonly }, this.themeClasses);
	        },
	        directivesInput: function directivesInput() {
	            return [];
	        },
	        hasHint: function hasHint() {
	            return !this.hasMessages && this.hint && (this.persistentHint || this.isFocused);
	        },
	        hasLabel: function hasLabel() {
	            return Boolean(this.$slots.label || this.label);
	        },
	        // Proxy for `lazyValue`
	        // This allows an input
	        // to function without
	        // a provided model
	        internalValue: {
	            get: function get() {
	                return this.lazyValue;
	            },
	            set: function set(val) {
	                this.lazyValue = val;
	                this.$emit(this.$_modelEvent, val);
	            }
	        },
	        isDirty: function isDirty() {
	            return !!this.lazyValue;
	        },
	        isDisabled: function isDisabled() {
	            return Boolean(this.disabled || this.readonly);
	        },
	        isLabelActive: function isLabelActive() {
	            return this.isDirty;
	        }
	    },
	    watch: {
	        value: function value(val) {
	            this.lazyValue = val;
	        }
	    },
	    beforeCreate: function beforeCreate() {
	        // v-radio-group needs to emit a different event
	        // https://github.com/vuetifyjs/vuetify/issues/4752
	        this.$_modelEvent = this.$options.model && this.$options.model.event || 'input';
	    },
	    methods: {
	        genContent: function genContent() {
	            return [this.genPrependSlot(), this.genControl(), this.genAppendSlot()];
	        },
	        genControl: function genControl() {
	            return this.$createElement('div', {
	                staticClass: 'v-input__control'
	            }, [this.genInputSlot(), this.genMessages()]);
	        },
	        genDefaultSlot: function genDefaultSlot() {
	            return [this.genLabel(), this.$slots.default];
	        },
	        // TODO: remove shouldDeprecate (2.0), used for clearIcon
	        genIcon: function genIcon(type, cb, shouldDeprecate) {
	            var _this = this;
	            if (shouldDeprecate === void 0) {
	                shouldDeprecate = true;
	            }
	            var icon = this[type + "Icon"];
	            var eventName = "click:" + Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["kebabCase"])(type);
	            cb = cb || this[type + "IconCb"];
	            if (shouldDeprecate && type && cb) {
	                Object(_util_console__WEBPACK_IMPORTED_MODULE_8__["deprecate"])(":" + type + "-icon-cb", "@" + eventName, this);
	            }
	            var data = {
	                props: {
	                    color: this.validationState,
	                    dark: this.dark,
	                    disabled: this.disabled,
	                    light: this.light
	                },
	                on: !(this.$listeners[eventName] || cb) ? undefined : {
	                    click: function click(e) {
	                        e.preventDefault();
	                        e.stopPropagation();
	                        _this.$emit(eventName, e);
	                        cb && cb(e);
	                    },
	                    // Container has mouseup event that will
	                    // trigger menu open if enclosed
	                    mouseup: function mouseup(e) {
	                        e.preventDefault();
	                        e.stopPropagation();
	                    }
	                }
	            };
	            return this.$createElement('div', {
	                staticClass: "v-input__icon v-input__icon--" + Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["kebabCase"])(type),
	                key: "" + type + icon
	            }, [this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_1__["default"], data, icon)]);
	        },
	        genInputSlot: function genInputSlot() {
	            return this.$createElement('div', this.setBackgroundColor(this.backgroundColor, {
	                staticClass: 'v-input__slot',
	                style: { height: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["convertToUnit"])(this.height) },
	                directives: this.directivesInput,
	                on: {
	                    click: this.onClick,
	                    mousedown: this.onMouseDown,
	                    mouseup: this.onMouseUp
	                },
	                ref: 'input-slot'
	            }), [this.genDefaultSlot()]);
	        },
	        genLabel: function genLabel() {
	            if (!this.hasLabel) return null;
	            return this.$createElement(_VLabel__WEBPACK_IMPORTED_MODULE_2__["default"], {
	                props: {
	                    color: this.validationState,
	                    dark: this.dark,
	                    focused: this.hasState,
	                    for: this.$attrs.id,
	                    light: this.light
	                }
	            }, this.$slots.label || this.label);
	        },
	        genMessages: function genMessages() {
	            if (this.hideDetails) return null;
	            var messages = this.hasHint ? [this.hint] : this.validations;
	            return this.$createElement(_VMessages__WEBPACK_IMPORTED_MODULE_3__["default"], {
	                props: {
	                    color: this.hasHint ? '' : this.validationState,
	                    dark: this.dark,
	                    light: this.light,
	                    value: this.hasMessages || this.hasHint ? messages : []
	                }
	            });
	        },
	        genSlot: function genSlot(type, location, slot) {
	            if (!slot.length) return null;
	            var ref = type + "-" + location;
	            return this.$createElement('div', {
	                staticClass: "v-input__" + ref,
	                ref: ref
	            }, slot);
	        },
	        genPrependSlot: function genPrependSlot() {
	            var slot = [];
	            if (this.$slots.prepend) {
	                slot.push(this.$slots.prepend);
	            } else if (this.prependIcon) {
	                slot.push(this.genIcon('prepend'));
	            }
	            return this.genSlot('prepend', 'outer', slot);
	        },
	        genAppendSlot: function genAppendSlot() {
	            var slot = [];
	            // Append icon for text field was really
	            // an appended inner icon, v-text-field
	            // will overwrite this method in order to obtain
	            // backwards compat
	            if (this.$slots.append) {
	                slot.push(this.$slots.append);
	            } else if (this.appendIcon) {
	                slot.push(this.genIcon('append'));
	            }
	            return this.genSlot('append', 'outer', slot);
	        },
	        onClick: function onClick(e) {
	            this.$emit('click', e);
	        },
	        onMouseDown: function onMouseDown(e) {
	            this.hasMouseDown = true;
	            this.$emit('mousedown', e);
	        },
	        onMouseUp: function onMouseUp(e) {
	            this.hasMouseDown = false;
	            this.$emit('mouseup', e);
	        }
	    },
	    render: function render(h) {
	        return h('div', this.setTextColor(this.validationState, {
	            staticClass: 'v-input',
	            attrs: this.attrsInput,
	            'class': this.classesInput
	        }), this.genContent());
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VInput/index.ts":
	/*!****************************************!*\
	  !*** ./src/components/VInput/index.ts ***!
	  \****************************************/
	/*! exports provided: VInput, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VInput__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VInput */ "./src/components/VInput/VInput.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VInput", function() { return _VInput__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VInput__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VItemGroup/VItem.ts":
	/*!********************************************!*\
	  !*** ./src/components/VItemGroup/VItem.ts ***!
	  \********************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _mixins_groupable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mixins/groupable */ "./src/mixins/groupable.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../util/console */ "./src/util/console.ts");
	// Mixins
	
	// Utilities
	
	
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_1__["default"])(Object(_mixins_groupable__WEBPACK_IMPORTED_MODULE_0__["factory"])('itemGroup', 'v-item', 'v-item-group')
	/* @vue/component */
	).extend({
	    name: 'v-item',
	    props: {
	        value: {
	            required: false
	        }
	    },
	    render: function render() {
	        var _a;
	        if (!this.$scopedSlots.default) {
	            Object(_util_console__WEBPACK_IMPORTED_MODULE_2__["consoleWarn"])('v-item is missing a default scopedSlot', this);
	            return null;
	        }
	        var element;
	        /* istanbul ignore else */
	        if (this.$scopedSlots.default) {
	            element = this.$scopedSlots.default({
	                active: this.isActive,
	                toggle: this.toggle
	            });
	        }
	        if (Array.isArray(element) && element.length === 1) {
	            element = element[0];
	        }
	        if (!element || Array.isArray(element) || !element.tag) {
	            Object(_util_console__WEBPACK_IMPORTED_MODULE_2__["consoleWarn"])('v-item should only contain a single element', this);
	            return element;
	        }
	        element.data = this._b(element.data || {}, element.tag, {
	            class: (_a = {}, _a[this.activeClass] = this.isActive, _a)
	        });
	        return element;
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VItemGroup/VItemGroup.ts":
	/*!*************************************************!*\
	  !*** ./src/components/VItemGroup/VItemGroup.ts ***!
	  \*************************************************/
	/*! exports provided: BaseItemGroup, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BaseItemGroup", function() { return BaseItemGroup; });
	/* harmony import */ var _stylus_components_item_group_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_item-group.styl */ "./src/stylus/components/_item-group.styl");
	/* harmony import */ var _stylus_components_item_group_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_item_group_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_proxyable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/proxyable */ "./src/mixins/proxyable.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../util/console */ "./src/util/console.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	// Styles
	
	
	
	// Utilities
	
	
	var BaseItemGroup = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_3__["default"])(_mixins_proxyable__WEBPACK_IMPORTED_MODULE_1__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__["default"]).extend({
	    name: 'base-item-group',
	    props: {
	        activeClass: {
	            type: String,
	            default: 'v-item--active'
	        },
	        mandatory: Boolean,
	        max: {
	            type: [Number, String],
	            default: null
	        },
	        multiple: Boolean
	    },
	    data: function data() {
	        return {
	            // As long as a value is defined, show it
	            // Otherwise, check if multiple
	            // to determine which default to provide
	            internalLazyValue: this.value !== undefined ? this.value : this.multiple ? [] : undefined,
	            items: []
	        };
	    },
	    computed: {
	        classes: function classes() {
	            return __assign({}, this.themeClasses);
	        },
	        selectedItems: function selectedItems() {
	            var _this = this;
	            return this.items.filter(function (item, index) {
	                return _this.toggleMethod(_this.getValue(item, index));
	            });
	        },
	        selectedValues: function selectedValues() {
	            return Array.isArray(this.internalValue) ? this.internalValue : [this.internalValue];
	        },
	        toggleMethod: function toggleMethod() {
	            var _this = this;
	            if (!this.multiple) {
	                return function (v) {
	                    return _this.internalValue === v;
	                };
	            }
	            var internalValue = this.internalValue;
	            if (Array.isArray(internalValue)) {
	                return function (v) {
	                    return internalValue.includes(v);
	                };
	            }
	            return function () {
	                return false;
	            };
	        }
	    },
	    watch: {
	        internalValue: function internalValue() {
	            // https://github.com/vuetifyjs/vuetify/issues/5352
	            this.$nextTick(this.updateItemsState);
	        }
	    },
	    created: function created() {
	        if (this.multiple && !Array.isArray(this.internalValue)) {
	            Object(_util_console__WEBPACK_IMPORTED_MODULE_4__["consoleWarn"])('Model must be bound to an array if the multiple property is true.', this);
	        }
	    },
	    methods: {
	        getValue: function getValue(item, i) {
	            return item.value == null || item.value === '' ? i : item.value;
	        },
	        onClick: function onClick(item, index) {
	            this.updateInternalValue(this.getValue(item, index));
	        },
	        register: function register(item) {
	            var _this = this;
	            var index = this.items.push(item) - 1;
	            item.$on('change', function () {
	                return _this.onClick(item, index);
	            });
	            // If no value provided and mandatory,
	            // assign first registered item
	            if (this.mandatory && this.internalLazyValue == null) {
	                this.updateMandatory();
	            }
	            this.updateItem(item, index);
	        },
	        unregister: function unregister(item) {
	            if (this._isDestroyed) return;
	            var index = this.items.indexOf(item);
	            var value = this.getValue(item, index);
	            this.items.splice(index, 1);
	            var valueIndex = this.selectedValues.indexOf(value);
	            // Items is not selected, do nothing
	            if (valueIndex < 0) return;
	            // If not mandatory, use regular update process
	            if (!this.mandatory) {
	                return this.updateInternalValue(value);
	            }
	            // Remove the value
	            if (this.multiple && Array.isArray(this.internalValue)) {
	                this.internalValue = this.internalValue.filter(function (v) {
	                    return v !== value;
	                });
	            } else {
	                this.internalValue = undefined;
	            }
	            // If mandatory and we have no selection
	            // add the last item as value
	            /* istanbul ignore else */
	            if (!this.selectedItems.length) {
	                this.updateMandatory(true);
	            }
	        },
	        updateItem: function updateItem(item, index) {
	            var value = this.getValue(item, index);
	            item.isActive = this.toggleMethod(value);
	        },
	        updateItemsState: function updateItemsState() {
	            if (this.mandatory && !this.selectedItems.length) {
	                return this.updateMandatory();
	            }
	            // TODO: Make this smarter so it
	            // doesn't have to iterate every
	            // child in an update
	            this.items.forEach(this.updateItem);
	        },
	        updateInternalValue: function updateInternalValue(value) {
	            this.multiple ? this.updateMultiple(value) : this.updateSingle(value);
	        },
	        updateMandatory: function updateMandatory(last) {
	            if (!this.items.length) return;
	            var index = last ? this.items.length - 1 : 0;
	            this.updateInternalValue(this.getValue(this.items[index], index));
	        },
	        updateMultiple: function updateMultiple(value) {
	            var defaultValue = Array.isArray(this.internalValue) ? this.internalValue : [];
	            var internalValue = defaultValue.slice();
	            var index = internalValue.findIndex(function (val) {
	                return val === value;
	            });
	            if (this.mandatory &&
	            // Item already exists
	            index > -1 &&
	            // value would be reduced below min
	            internalValue.length - 1 < 1) return;
	            if (
	            // Max is set
	            this.max != null &&
	            // Item doesn't exist
	            index < 0 &&
	            // value would be increased above max
	            internalValue.length + 1 > this.max) return;
	            index > -1 ? internalValue.splice(index, 1) : internalValue.push(value);
	            this.internalValue = internalValue;
	        },
	        updateSingle: function updateSingle(value) {
	            var isSame = value === this.internalValue;
	            if (this.mandatory && isSame) return;
	            this.internalValue = isSame ? undefined : value;
	        }
	    },
	    render: function render(h) {
	        return h('div', {
	            staticClass: 'v-item-group',
	            class: this.classes
	        }, this.$slots.default);
	    }
	});
	/* harmony default export */ __webpack_exports__["default"] = (BaseItemGroup.extend({
	    name: 'v-item-group',
	    provide: function provide() {
	        return {
	            itemGroup: this
	        };
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VItemGroup/index.ts":
	/*!********************************************!*\
	  !*** ./src/components/VItemGroup/index.ts ***!
	  \********************************************/
	/*! exports provided: VItem, VItemGroup, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VItem__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VItem */ "./src/components/VItemGroup/VItem.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VItem", function() { return _VItem__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	/* harmony import */ var _VItemGroup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./VItemGroup */ "./src/components/VItemGroup/VItemGroup.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VItemGroup", function() { return _VItemGroup__WEBPACK_IMPORTED_MODULE_1__["default"]; });
	
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = ({
	    $_vuetify_subcomponents: {
	        VItem: _VItem__WEBPACK_IMPORTED_MODULE_0__["default"],
	        VItemGroup: _VItemGroup__WEBPACK_IMPORTED_MODULE_1__["default"]
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VJumbotron/VJumbotron.js":
	/*!*************************************************!*\
	  !*** ./src/components/VJumbotron/VJumbotron.js ***!
	  \*************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_jumbotrons_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_jumbotrons.styl */ "./src/stylus/components/_jumbotrons.styl");
	/* harmony import */ var _stylus_components_jumbotrons_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_jumbotrons_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _mixins_routable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/routable */ "./src/mixins/routable.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../util/console */ "./src/util/console.ts");
	
	// Mixins
	
	
	
	// Utils
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-jumbotron',
	    mixins: [_mixins_colorable__WEBPACK_IMPORTED_MODULE_1__["default"], _mixins_routable__WEBPACK_IMPORTED_MODULE_2__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_3__["default"]],
	    props: {
	        gradient: String,
	        height: {
	            type: [Number, String],
	            default: '400px'
	        },
	        src: String,
	        tag: {
	            type: String,
	            default: 'div'
	        }
	    },
	    computed: {
	        backgroundStyles: function backgroundStyles() {
	            var styles = {};
	            if (this.gradient) {
	                styles.background = "linear-gradient(" + this.gradient + ")";
	            }
	            return styles;
	        },
	        classes: function classes() {
	            return this.themeClasses;
	        },
	        styles: function styles() {
	            return {
	                height: this.height
	            };
	        }
	    },
	    mounted: function mounted() {
	        Object(_util_console__WEBPACK_IMPORTED_MODULE_4__["deprecate"])('v-jumbotron', this.src ? 'v-img' : 'v-responsive', this);
	    },
	    methods: {
	        genBackground: function genBackground() {
	            return this.$createElement('div', this.setBackgroundColor(this.color, {
	                staticClass: 'v-jumbotron__background',
	                style: this.backgroundStyles
	            }));
	        },
	        genContent: function genContent() {
	            return this.$createElement('div', {
	                staticClass: 'v-jumbotron__content'
	            }, this.$slots.default);
	        },
	        genImage: function genImage() {
	            if (!this.src) return null;
	            if (this.$slots.img) return this.$slots.img({ src: this.src });
	            return this.$createElement('img', {
	                staticClass: 'v-jumbotron__image',
	                attrs: { src: this.src }
	            });
	        },
	        genWrapper: function genWrapper() {
	            return this.$createElement('div', {
	                staticClass: 'v-jumbotron__wrapper'
	            }, [this.genImage(), this.genBackground(), this.genContent()]);
	        }
	    },
	    render: function render(h) {
	        var _a = this.generateRouteLink(this.classes),
	            tag = _a.tag,
	            data = _a.data;
	        data.staticClass = 'v-jumbotron';
	        data.style = this.styles;
	        return h(tag, data, [this.genWrapper()]);
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VJumbotron/index.js":
	/*!********************************************!*\
	  !*** ./src/components/VJumbotron/index.js ***!
	  \********************************************/
	/*! exports provided: VJumbotron, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VJumbotron__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VJumbotron */ "./src/components/VJumbotron/VJumbotron.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VJumbotron", function() { return _VJumbotron__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VJumbotron__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VLabel/VLabel.ts":
	/*!*****************************************!*\
	  !*** ./src/components/VLabel/VLabel.ts ***!
	  \*****************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_labels_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_labels.styl */ "./src/stylus/components/_labels.styl");
	/* harmony import */ var _stylus_components_labels_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_labels_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	// Styles
	
	// Mixins
	
	
	
	// Helpers
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_3__["default"])(_mixins_themeable__WEBPACK_IMPORTED_MODULE_2__["default"]).extend({
	    name: 'v-label',
	    functional: true,
	    props: {
	        absolute: Boolean,
	        color: {
	            type: String,
	            default: 'primary'
	        },
	        disabled: Boolean,
	        focused: Boolean,
	        for: String,
	        left: {
	            type: [Number, String],
	            default: 0
	        },
	        right: {
	            type: [Number, String],
	            default: 'auto'
	        },
	        value: Boolean
	    },
	    render: function render(h, ctx) {
	        var children = ctx.children,
	            listeners = ctx.listeners,
	            props = ctx.props;
	        var data = {
	            staticClass: 'v-label',
	            'class': __assign({ 'v-label--active': props.value, 'v-label--is-disabled': props.disabled }, Object(_mixins_themeable__WEBPACK_IMPORTED_MODULE_2__["functionalThemeClasses"])(ctx)),
	            attrs: {
	                for: props.for,
	                'aria-hidden': !props.for
	            },
	            on: listeners,
	            style: {
	                left: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["convertToUnit"])(props.left),
	                right: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["convertToUnit"])(props.right),
	                position: props.absolute ? 'absolute' : 'relative'
	            }
	        };
	        return h('label', _mixins_colorable__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.setTextColor(props.focused && props.color, data), children);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VLabel/index.ts":
	/*!****************************************!*\
	  !*** ./src/components/VLabel/index.ts ***!
	  \****************************************/
	/*! exports provided: VLabel, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VLabel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VLabel */ "./src/components/VLabel/VLabel.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VLabel", function() { return _VLabel__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VLabel__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VList/VList.ts":
	/*!***************************************!*\
	  !*** ./src/components/VList/VList.ts ***!
	  \***************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_lists_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_lists.styl */ "./src/stylus/components/_lists.styl");
	/* harmony import */ var _stylus_components_lists_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_lists_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _mixins_registrable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/registrable */ "./src/mixins/registrable.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var __values = undefined && undefined.__values || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator],
	        i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function next() {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	// Styles
	
	// Mixins
	
	
	// Types
	
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_3__["default"])(Object(_mixins_registrable__WEBPACK_IMPORTED_MODULE_2__["provide"])('list'), _mixins_themeable__WEBPACK_IMPORTED_MODULE_1__["default"]
	/* @vue/component */
	).extend({
	    name: 'v-list',
	    provide: function provide() {
	        return {
	            listClick: this.listClick
	        };
	    },
	    props: {
	        dense: Boolean,
	        expand: Boolean,
	        subheader: Boolean,
	        threeLine: Boolean,
	        twoLine: Boolean
	    },
	    data: function data() {
	        return {
	            groups: []
	        };
	    },
	    computed: {
	        classes: function classes() {
	            return __assign({ 'v-list--dense': this.dense, 'v-list--subheader': this.subheader, 'v-list--two-line': this.twoLine, 'v-list--three-line': this.threeLine }, this.themeClasses);
	        }
	    },
	    methods: {
	        register: function register(content) {
	            this.groups.push(content);
	        },
	        unregister: function unregister(content) {
	            var index = this.groups.findIndex(function (g) {
	                return g._uid === content._uid;
	            });
	            if (index > -1) this.groups.splice(index, 1);
	        },
	        listClick: function listClick(uid) {
	            var e_1, _a;
	            if (this.expand) return;
	            try {
	                for (var _b = __values(this.groups), _c = _b.next(); !_c.done; _c = _b.next()) {
	                    var group = _c.value;
	                    group.toggle(uid);
	                }
	            } catch (e_1_1) {
	                e_1 = { error: e_1_1 };
	            } finally {
	                try {
	                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	                } finally {
	                    if (e_1) throw e_1.error;
	                }
	            }
	        }
	    },
	    render: function render(h) {
	        var data = {
	            staticClass: 'v-list',
	            class: this.classes,
	            attrs: {
	                role: 'list'
	            }
	        };
	        return h('div', data, [this.$slots.default]);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VList/VListGroup.ts":
	/*!********************************************!*\
	  !*** ./src/components/VList/VListGroup.ts ***!
	  \********************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VIcon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../VIcon */ "./src/components/VIcon/index.ts");
	/* harmony import */ var _mixins_bootable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/bootable */ "./src/mixins/bootable.ts");
	/* harmony import */ var _mixins_toggleable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/toggleable */ "./src/mixins/toggleable.ts");
	/* harmony import */ var _mixins_registrable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/registrable */ "./src/mixins/registrable.ts");
	/* harmony import */ var _transitions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../transitions */ "./src/components/transitions/index.js");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	// Components
	
	// Mixins
	
	
	
	// Transitions
	
	// Utils
	
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_5__["default"])(_mixins_bootable__WEBPACK_IMPORTED_MODULE_1__["default"], Object(_mixins_registrable__WEBPACK_IMPORTED_MODULE_3__["inject"])('list', 'v-list-group', 'v-list'), _mixins_toggleable__WEBPACK_IMPORTED_MODULE_2__["default"]
	/* @vue/component */
	).extend({
	    name: 'v-list-group',
	    inject: ['listClick'],
	    props: {
	        activeClass: {
	            type: String,
	            default: 'primary--text'
	        },
	        appendIcon: {
	            type: String,
	            default: '$vuetify.icons.expand'
	        },
	        disabled: Boolean,
	        group: String,
	        noAction: Boolean,
	        prependIcon: String,
	        subGroup: Boolean
	    },
	    data: function data() {
	        return {
	            groups: []
	        };
	    },
	    computed: {
	        groupClasses: function groupClasses() {
	            return {
	                'v-list__group--active': this.isActive,
	                'v-list__group--disabled': this.disabled
	            };
	        },
	        headerClasses: function headerClasses() {
	            return {
	                'v-list__group__header--active': this.isActive,
	                'v-list__group__header--sub-group': this.subGroup
	            };
	        },
	        itemsClasses: function itemsClasses() {
	            return {
	                'v-list__group__items--no-action': this.noAction
	            };
	        }
	    },
	    watch: {
	        isActive: function isActive(val) {
	            if (!this.subGroup && val) {
	                this.listClick(this._uid);
	            }
	        },
	        $route: function $route(to) {
	            var isActive = this.matchRoute(to.path);
	            if (this.group) {
	                if (isActive && this.isActive !== isActive) {
	                    this.listClick(this._uid);
	                }
	                this.isActive = isActive;
	            }
	        }
	    },
	    mounted: function mounted() {
	        this.list.register(this);
	        if (this.group && this.$route && this.value == null) {
	            this.isActive = this.matchRoute(this.$route.path);
	        }
	    },
	    beforeDestroy: function beforeDestroy() {
	        this.list.unregister(this._uid);
	    },
	    methods: {
	        click: function click(e) {
	            if (this.disabled) return;
	            this.$emit('click', e);
	            this.isActive = !this.isActive;
	        },
	        genIcon: function genIcon(icon) {
	            return this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_0__["default"], icon);
	        },
	        genAppendIcon: function genAppendIcon() {
	            var icon = !this.subGroup ? this.appendIcon : false;
	            if (!icon && !this.$slots.appendIcon) return null;
	            return this.$createElement('div', {
	                staticClass: 'v-list__group__header__append-icon'
	            }, [this.$slots.appendIcon || this.genIcon(icon)]);
	        },
	        genGroup: function genGroup() {
	            return this.$createElement('div', {
	                staticClass: 'v-list__group__header',
	                class: this.headerClasses,
	                on: __assign({}, this.$listeners, { click: this.click }),
	                ref: 'item'
	            }, [this.genPrependIcon(), this.$slots.activator, this.genAppendIcon()]);
	        },
	        genItems: function genItems() {
	            return this.$createElement('div', {
	                staticClass: 'v-list__group__items',
	                class: this.itemsClasses,
	                directives: [{
	                    name: 'show',
	                    value: this.isActive
	                }],
	                ref: 'group'
	            }, this.showLazyContent(this.$slots.default));
	        },
	        genPrependIcon: function genPrependIcon() {
	            var _a;
	            var icon = this.prependIcon ? this.prependIcon : this.subGroup ? '$vuetify.icons.subgroup' : false;
	            if (!icon && !this.$slots.prependIcon) return null;
	            return this.$createElement('div', {
	                staticClass: 'v-list__group__header__prepend-icon',
	                'class': (_a = {}, _a[this.activeClass] = this.isActive, _a)
	            }, [this.$slots.prependIcon || this.genIcon(icon)]);
	        },
	        toggle: function toggle(uid) {
	            this.isActive = this._uid === uid;
	        },
	        matchRoute: function matchRoute(to) {
	            if (!this.group) return false;
	            return to.match(this.group) !== null;
	        }
	    },
	    render: function render(h) {
	        return h('div', {
	            staticClass: 'v-list__group',
	            class: this.groupClasses
	        }, [this.genGroup(), h(_transitions__WEBPACK_IMPORTED_MODULE_4__["VExpandTransition"], [this.genItems()])]);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VList/VListTile.ts":
	/*!*******************************************!*\
	  !*** ./src/components/VList/VListTile.ts ***!
	  \*******************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _mixins_routable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/routable */ "./src/mixins/routable.ts");
	/* harmony import */ var _mixins_toggleable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/toggleable */ "./src/mixins/toggleable.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _directives_ripple__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../directives/ripple */ "./src/directives/ripple.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	// Mixins
	
	
	
	
	// Directives
	
	// Types
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_5__["default"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_0__["default"], _mixins_routable__WEBPACK_IMPORTED_MODULE_1__["default"], _mixins_toggleable__WEBPACK_IMPORTED_MODULE_2__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_3__["default"]).extend({
	    name: 'v-list-tile',
	    directives: {
	        Ripple: _directives_ripple__WEBPACK_IMPORTED_MODULE_4__["default"]
	    },
	    inheritAttrs: false,
	    props: {
	        activeClass: {
	            type: String,
	            default: 'primary--text'
	        },
	        avatar: Boolean,
	        inactive: Boolean,
	        tag: String
	    },
	    data: function data() {
	        return {
	            proxyClass: 'v-list__tile--active'
	        };
	    },
	    computed: {
	        listClasses: function listClasses() {
	            return this.disabled ? { 'v-list--disabled': true } : undefined;
	        },
	        classes: function classes() {
	            var _a;
	            return __assign({ 'v-list__tile': true, 'v-list__tile--link': this.isLink && !this.inactive, 'v-list__tile--avatar': this.avatar, 'v-list__tile--disabled': this.disabled, 'v-list__tile--active': !this.to && this.isActive }, this.themeClasses, (_a = {}, _a[this.activeClass] = this.isActive, _a));
	        },
	        isLink: function isLink() {
	            var hasClick = this.$listeners && (this.$listeners.click || this.$listeners['!click']);
	            return Boolean(this.href || this.to || hasClick);
	        }
	    },
	    render: function render(h) {
	        var isRouteLink = !this.inactive && this.isLink;
	        var _a = isRouteLink ? this.generateRouteLink(this.classes) : {
	            tag: this.tag || 'div',
	            data: {
	                class: this.classes
	            }
	        },
	            tag = _a.tag,
	            data = _a.data;
	        data.attrs = Object.assign({}, data.attrs, this.$attrs);
	        return h('div', this.setTextColor(!this.disabled && this.isActive && this.color, {
	            class: this.listClasses,
	            attrs: {
	                disabled: this.disabled,
	                role: 'listitem'
	            }
	        }), [h(tag, data, this.$slots.default)]);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VList/VListTileAction.ts":
	/*!*************************************************!*\
	  !*** ./src/components/VList/VListTileAction.ts ***!
	  \*************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
	// Types
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
	    name: 'v-list-tile-action',
	    functional: true,
	    render: function render(h, _a) {
	        var data = _a.data,
	            _b = _a.children,
	            children = _b === void 0 ? [] : _b;
	        data.staticClass = data.staticClass ? "v-list__tile__action " + data.staticClass : 'v-list__tile__action';
	        var filteredChild = children.filter(function (VNode) {
	            return VNode.isComment === false && VNode.text !== ' ';
	        });
	        if (filteredChild.length > 1) data.staticClass += ' v-list__tile__action--stack';
	        return h('div', data, children);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VList/VListTileAvatar.ts":
	/*!*************************************************!*\
	  !*** ./src/components/VList/VListTileAvatar.ts ***!
	  \*************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VAvatar__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../VAvatar */ "./src/components/VAvatar/index.ts");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
	// Components
	
	// Types
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (vue__WEBPACK_IMPORTED_MODULE_1___default.a.extend({
	    name: 'v-list-tile-avatar',
	    functional: true,
	    props: {
	        color: String,
	        size: {
	            type: [Number, String],
	            default: 40
	        },
	        tile: Boolean
	    },
	    render: function render(h, _a) {
	        var data = _a.data,
	            children = _a.children,
	            props = _a.props;
	        data.staticClass = ("v-list__tile__avatar " + (data.staticClass || '')).trim();
	        var avatar = h(_VAvatar__WEBPACK_IMPORTED_MODULE_0__["default"], {
	            props: {
	                color: props.color,
	                size: props.size,
	                tile: props.tile
	            }
	        }, [children]);
	        return h('div', data, [avatar]);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VList/index.ts":
	/*!***************************************!*\
	  !*** ./src/components/VList/index.ts ***!
	  \***************************************/
	/*! exports provided: VList, VListGroup, VListTile, VListTileAction, VListTileAvatar, VListTileActionText, VListTileContent, VListTileTitle, VListTileSubTitle, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VListTileActionText", function() { return VListTileActionText; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VListTileContent", function() { return VListTileContent; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VListTileTitle", function() { return VListTileTitle; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VListTileSubTitle", function() { return VListTileSubTitle; });
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var _VList__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./VList */ "./src/components/VList/VList.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VList", function() { return _VList__WEBPACK_IMPORTED_MODULE_1__["default"]; });
	
	/* harmony import */ var _VListGroup__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./VListGroup */ "./src/components/VList/VListGroup.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VListGroup", function() { return _VListGroup__WEBPACK_IMPORTED_MODULE_2__["default"]; });
	
	/* harmony import */ var _VListTile__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./VListTile */ "./src/components/VList/VListTile.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VListTile", function() { return _VListTile__WEBPACK_IMPORTED_MODULE_3__["default"]; });
	
	/* harmony import */ var _VListTileAction__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./VListTileAction */ "./src/components/VList/VListTileAction.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VListTileAction", function() { return _VListTileAction__WEBPACK_IMPORTED_MODULE_4__["default"]; });
	
	/* harmony import */ var _VListTileAvatar__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./VListTileAvatar */ "./src/components/VList/VListTileAvatar.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VListTileAvatar", function() { return _VListTileAvatar__WEBPACK_IMPORTED_MODULE_5__["default"]; });
	
	
	
	
	
	
	
	
	var VListTileActionText = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleFunctional"])('v-list__tile__action-text', 'span');
	var VListTileContent = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleFunctional"])('v-list__tile__content', 'div');
	var VListTileTitle = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleFunctional"])('v-list__tile__title', 'div');
	var VListTileSubTitle = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleFunctional"])('v-list__tile__sub-title', 'div');
	/* harmony default export */ __webpack_exports__["default"] = ({
	    $_vuetify_subcomponents: {
	        VList: _VList__WEBPACK_IMPORTED_MODULE_1__["default"],
	        VListGroup: _VListGroup__WEBPACK_IMPORTED_MODULE_2__["default"],
	        VListTile: _VListTile__WEBPACK_IMPORTED_MODULE_3__["default"],
	        VListTileAction: _VListTileAction__WEBPACK_IMPORTED_MODULE_4__["default"],
	        VListTileActionText: VListTileActionText,
	        VListTileAvatar: _VListTileAvatar__WEBPACK_IMPORTED_MODULE_5__["default"],
	        VListTileContent: VListTileContent,
	        VListTileSubTitle: VListTileSubTitle,
	        VListTileTitle: VListTileTitle
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VMenu/VMenu.js":
	/*!***************************************!*\
	  !*** ./src/components/VMenu/VMenu.js ***!
	  \***************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_menus_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_menus.styl */ "./src/stylus/components/_menus.styl");
	/* harmony import */ var _stylus_components_menus_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_menus_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
	/* harmony import */ var _mixins_delayable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/delayable */ "./src/mixins/delayable.ts");
	/* harmony import */ var _mixins_dependent__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/dependent */ "./src/mixins/dependent.ts");
	/* harmony import */ var _mixins_detachable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mixins/detachable */ "./src/mixins/detachable.js");
	/* harmony import */ var _mixins_menuable_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mixins/menuable.js */ "./src/mixins/menuable.js");
	/* harmony import */ var _mixins_returnable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mixins/returnable */ "./src/mixins/returnable.ts");
	/* harmony import */ var _mixins_toggleable__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mixins/toggleable */ "./src/mixins/toggleable.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _mixins_menu_activator__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./mixins/menu-activator */ "./src/components/VMenu/mixins/menu-activator.js");
	/* harmony import */ var _mixins_menu_generators__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./mixins/menu-generators */ "./src/components/VMenu/mixins/menu-generators.js");
	/* harmony import */ var _mixins_menu_keyable__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./mixins/menu-keyable */ "./src/components/VMenu/mixins/menu-keyable.js");
	/* harmony import */ var _mixins_menu_position__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./mixins/menu-position */ "./src/components/VMenu/mixins/menu-position.js");
	/* harmony import */ var _directives_click_outside__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../directives/click-outside */ "./src/directives/click-outside.ts");
	/* harmony import */ var _directives_resize__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../directives/resize */ "./src/directives/resize.ts");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var _util_ThemeProvider__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../util/ThemeProvider */ "./src/util/ThemeProvider.ts");
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../util/console */ "./src/util/console.ts");
	
	
	// Mixins
	
	
	
	
	
	
	
	// Component level mixins
	
	
	
	
	// Directives
	
	
	// Helpers
	
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (vue__WEBPACK_IMPORTED_MODULE_1___default.a.extend({
	    name: 'v-menu',
	    provide: function provide() {
	        return {
	            // Pass theme through to default slot
	            theme: this.theme
	        };
	    },
	    directives: {
	        ClickOutside: _directives_click_outside__WEBPACK_IMPORTED_MODULE_13__["default"],
	        Resize: _directives_resize__WEBPACK_IMPORTED_MODULE_14__["default"]
	    },
	    mixins: [_mixins_menu_activator__WEBPACK_IMPORTED_MODULE_9__["default"], _mixins_dependent__WEBPACK_IMPORTED_MODULE_3__["default"], _mixins_delayable__WEBPACK_IMPORTED_MODULE_2__["default"], _mixins_detachable__WEBPACK_IMPORTED_MODULE_4__["default"], _mixins_menu_generators__WEBPACK_IMPORTED_MODULE_10__["default"], _mixins_menu_keyable__WEBPACK_IMPORTED_MODULE_11__["default"], _mixins_menuable_js__WEBPACK_IMPORTED_MODULE_5__["default"], _mixins_menu_position__WEBPACK_IMPORTED_MODULE_12__["default"], _mixins_returnable__WEBPACK_IMPORTED_MODULE_6__["default"], _mixins_toggleable__WEBPACK_IMPORTED_MODULE_7__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_8__["default"]],
	    props: {
	        auto: Boolean,
	        closeOnClick: {
	            type: Boolean,
	            default: true
	        },
	        closeOnContentClick: {
	            type: Boolean,
	            default: true
	        },
	        disabled: Boolean,
	        fullWidth: Boolean,
	        maxHeight: { default: 'auto' },
	        openOnClick: {
	            type: Boolean,
	            default: true
	        },
	        offsetX: Boolean,
	        offsetY: Boolean,
	        openOnHover: Boolean,
	        origin: {
	            type: String,
	            default: 'top left'
	        },
	        transition: {
	            type: [Boolean, String],
	            default: 'v-menu-transition'
	        }
	    },
	    data: function data() {
	        return {
	            defaultOffset: 8,
	            hasJustFocused: false,
	            resizeTimeout: null
	        };
	    },
	    computed: {
	        calculatedLeft: function calculatedLeft() {
	            var menuWidth = Math.max(this.dimensions.content.width, parseFloat(this.calculatedMinWidth));
	            if (!this.auto) return this.calcLeft(menuWidth);
	            return this.calcXOverflow(this.calcLeftAuto(), menuWidth) + "px";
	        },
	        calculatedMaxHeight: function calculatedMaxHeight() {
	            return this.auto ? '200px' : Object(_util_helpers__WEBPACK_IMPORTED_MODULE_15__["convertToUnit"])(this.maxHeight);
	        },
	        calculatedMaxWidth: function calculatedMaxWidth() {
	            return isNaN(this.maxWidth) ? this.maxWidth : this.maxWidth + "px";
	        },
	        calculatedMinWidth: function calculatedMinWidth() {
	            if (this.minWidth) {
	                return isNaN(this.minWidth) ? this.minWidth : this.minWidth + "px";
	            }
	            var minWidth = Math.min(this.dimensions.activator.width + this.nudgeWidth + (this.auto ? 16 : 0), Math.max(this.pageWidth - 24, 0));
	            var calculatedMaxWidth = isNaN(parseInt(this.calculatedMaxWidth)) ? minWidth : parseInt(this.calculatedMaxWidth);
	            return Math.min(calculatedMaxWidth, minWidth) + "px";
	        },
	        calculatedTop: function calculatedTop() {
	            if (!this.auto || this.isAttached) return this.calcTop();
	            return this.calcYOverflow(this.calculatedTopAuto) + "px";
	        },
	        styles: function styles() {
	            return {
	                maxHeight: this.calculatedMaxHeight,
	                minWidth: this.calculatedMinWidth,
	                maxWidth: this.calculatedMaxWidth,
	                top: this.calculatedTop,
	                left: this.calculatedLeft,
	                transformOrigin: this.origin,
	                zIndex: this.zIndex || this.activeZIndex
	            };
	        }
	    },
	    watch: {
	        activator: function activator(newActivator, oldActivator) {
	            this.removeActivatorEvents(oldActivator);
	            this.addActivatorEvents(newActivator);
	        },
	        disabled: function disabled(_disabled) {
	            if (!this.activator) return;
	            if (_disabled) {
	                this.removeActivatorEvents(this.activator);
	            } else {
	                this.addActivatorEvents(this.activator);
	            }
	        },
	        isContentActive: function isContentActive(val) {
	            this.hasJustFocused = val;
	        }
	    },
	    mounted: function mounted() {
	        this.isActive && this.activate();
	        if (Object(_util_helpers__WEBPACK_IMPORTED_MODULE_15__["getSlotType"])(this, 'activator', true) === 'v-slot') {
	            Object(_util_console__WEBPACK_IMPORTED_MODULE_17__["consoleError"])("v-tooltip's activator slot must be bound, try '<template #activator=\"data\"><v-btn v-on=\"data.on>'", this);
	        }
	    },
	    methods: {
	        activate: function activate() {
	            var _this = this;
	            // This exists primarily for v-select
	            // helps determine which tiles to activate
	            this.getTiles();
	            // Update coordinates and dimensions of menu
	            // and its activator
	            this.updateDimensions();
	            // Start the transition
	            requestAnimationFrame(function () {
	                // Once transitioning, calculate scroll and top position
	                _this.startTransition().then(function () {
	                    if (_this.$refs.content) {
	                        _this.calculatedTopAuto = _this.calcTopAuto();
	                        _this.auto && (_this.$refs.content.scrollTop = _this.calcScrollPosition());
	                    }
	                });
	            });
	        },
	        closeConditional: function closeConditional(e) {
	            return this.isActive && this.closeOnClick && !this.$refs.content.contains(e.target);
	        },
	        onResize: function onResize() {
	            if (!this.isActive) return;
	            // Account for screen resize
	            // and orientation change
	            // eslint-disable-next-line no-unused-expressions
	            this.$refs.content.offsetWidth;
	            this.updateDimensions();
	            // When resizing to a smaller width
	            // content width is evaluated before
	            // the new activator width has been
	            // set, causing it to not size properly
	            // hacky but will revisit in the future
	            clearTimeout(this.resizeTimeout);
	            this.resizeTimeout = setTimeout(this.updateDimensions, 100);
	        }
	    },
	    render: function render(h) {
	        var data = {
	            staticClass: 'v-menu',
	            class: { 'v-menu--inline': !this.fullWidth && this.$slots.activator },
	            directives: [{
	                arg: 500,
	                name: 'resize',
	                value: this.onResize
	            }],
	            on: this.disableKeys ? undefined : {
	                keydown: this.onKeyDown
	            }
	        };
	        return h('div', data, [this.genActivator(), this.$createElement(_util_ThemeProvider__WEBPACK_IMPORTED_MODULE_16__["default"], {
	            props: {
	                root: true,
	                light: this.light,
	                dark: this.dark
	            }
	        }, [this.genTransition()])]);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VMenu/index.js":
	/*!***************************************!*\
	  !*** ./src/components/VMenu/index.js ***!
	  \***************************************/
	/*! exports provided: VMenu, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VMenu__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VMenu */ "./src/components/VMenu/VMenu.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VMenu", function() { return _VMenu__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VMenu__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VMenu/mixins/menu-activator.js":
	/*!*******************************************************!*\
	  !*** ./src/components/VMenu/mixins/menu-activator.js ***!
	  \*******************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/**
	 * Menu activator
	 *
	 * @mixin
	 *
	 * Handles the click and hover activation
	 * Supports slotted and detached activators
	 */
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    methods: {
	        activatorClickHandler: function activatorClickHandler(e) {
	            if (this.openOnClick && !this.isActive) {
	                this.getActivator(e).focus();
	                this.isActive = true;
	                this.absoluteX = e.clientX;
	                this.absoluteY = e.clientY;
	            } else if (this.closeOnClick && this.isActive) {
	                this.getActivator(e).blur();
	                this.isActive = false;
	            }
	        },
	        mouseEnterHandler: function mouseEnterHandler() {
	            var _this = this;
	            this.runDelay('open', function () {
	                if (_this.hasJustFocused) return;
	                _this.hasJustFocused = true;
	                _this.isActive = true;
	            });
	        },
	        mouseLeaveHandler: function mouseLeaveHandler(e) {
	            var _this = this;
	            // Prevent accidental re-activation
	            this.runDelay('close', function () {
	                if (_this.$refs.content.contains(e.relatedTarget)) return;
	                requestAnimationFrame(function () {
	                    _this.isActive = false;
	                    _this.callDeactivate();
	                });
	            });
	        },
	        addActivatorEvents: function addActivatorEvents(activator) {
	            if (activator === void 0) {
	                activator = null;
	            }
	            if (!activator || this.disabled) return;
	            activator.addEventListener('click', this.activatorClickHandler);
	        },
	        removeActivatorEvents: function removeActivatorEvents(activator) {
	            if (activator === void 0) {
	                activator = null;
	            }
	            if (!activator) return;
	            activator.removeEventListener('click', this.activatorClickHandler);
	        }
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VMenu/mixins/menu-generators.js":
	/*!********************************************************!*\
	  !*** ./src/components/VMenu/mixins/menu-generators.js ***!
	  \********************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../util/helpers */ "./src/util/helpers.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var __read = undefined && undefined.__read || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o),
	        r,
	        ar = [],
	        e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
	            ar.push(r.value);
	        }
	    } catch (error) {
	        e = { error: error };
	    } finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        } finally {
	            if (e) throw e.error;
	        }
	    }
	    return ar;
	};
	var __spread = undefined && undefined.__spread || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) {
	        ar = ar.concat(__read(arguments[i]));
	    }return ar;
	};
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    methods: {
	        genActivator: function genActivator() {
	            if (!this.$slots.activator && !this.$scopedSlots.activator) return null;
	            var listeners = {};
	            if (!this.disabled) {
	                if (this.openOnHover) {
	                    listeners.mouseenter = this.mouseEnterHandler;
	                    listeners.mouseleave = this.mouseLeaveHandler;
	                } else if (this.openOnClick) {
	                    listeners.click = this.activatorClickHandler;
	                }
	            }
	            if (Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["getSlotType"])(this, 'activator') === 'scoped') {
	                listeners.keydown = this.onKeyDown;
	                var activator = this.$scopedSlots.activator({ on: listeners });
	                this.activatorNode = activator;
	                return activator;
	            }
	            return this.$createElement('div', {
	                staticClass: 'v-menu__activator',
	                'class': {
	                    'v-menu__activator--active': this.hasJustFocused || this.isActive,
	                    'v-menu__activator--disabled': this.disabled
	                },
	                ref: 'activator',
	                on: listeners
	            }, this.$slots.activator);
	        },
	        genTransition: function genTransition() {
	            if (!this.transition) return this.genContent();
	            return this.$createElement('transition', {
	                props: {
	                    name: this.transition
	                }
	            }, [this.genContent()]);
	        },
	        genDirectives: function genDirectives() {
	            var _this = this;
	            // Do not add click outside for hover menu
	            var directives = !this.openOnHover && this.closeOnClick ? [{
	                name: 'click-outside',
	                value: function value() {
	                    _this.isActive = false;
	                },
	                args: {
	                    closeConditional: this.closeConditional,
	                    include: function include() {
	                        return __spread([_this.$el], _this.getOpenDependentElements());
	                    }
	                }
	            }] : [];
	            directives.push({
	                name: 'show',
	                value: this.isContentActive
	            });
	            return directives;
	        },
	        genContent: function genContent() {
	            var _this = this;
	            var _a;
	            var options = {
	                attrs: this.getScopeIdAttrs(),
	                staticClass: 'v-menu__content',
	                'class': __assign({}, this.rootThemeClasses, (_a = { 'v-menu__content--auto': this.auto, 'v-menu__content--fixed': this.activatorFixed, 'menuable__content__active': this.isActive }, _a[this.contentClass.trim()] = true, _a)),
	                style: this.styles,
	                directives: this.genDirectives(),
	                ref: 'content',
	                on: {
	                    click: function click(e) {
	                        e.stopPropagation();
	                        if (e.target.getAttribute('disabled')) return;
	                        if (_this.closeOnContentClick) _this.isActive = false;
	                    },
	                    keydown: this.onKeyDown
	                }
	            };
	            !this.disabled && this.openOnHover && (options.on.mouseenter = this.mouseEnterHandler);
	            this.openOnHover && (options.on.mouseleave = this.mouseLeaveHandler);
	            return this.$createElement('div', options, this.showLazyContent(this.$slots.default));
	        }
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VMenu/mixins/menu-keyable.js":
	/*!*****************************************************!*\
	  !*** ./src/components/VMenu/mixins/menu-keyable.js ***!
	  \*****************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../util/helpers */ "./src/util/helpers.ts");
	/**
	 * Menu keyable
	 *
	 * @mixin
	 *
	 * Primarily used to support VSelect
	 * Handles opening and closing of VMenu from keystrokes
	 * Will conditionally highlight VListTiles for VSelect
	 */
	// Utils
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    props: {
	        disableKeys: Boolean
	    },
	    data: function data() {
	        return {
	            listIndex: -1,
	            tiles: []
	        };
	    },
	    watch: {
	        isActive: function isActive(val) {
	            if (!val) this.listIndex = -1;
	        },
	        listIndex: function listIndex(next, prev) {
	            if (next in this.tiles) {
	                var tile = this.tiles[next];
	                tile.classList.add('v-list__tile--highlighted');
	                this.$refs.content.scrollTop = tile.offsetTop - tile.clientHeight;
	            }
	            prev in this.tiles && this.tiles[prev].classList.remove('v-list__tile--highlighted');
	        }
	    },
	    methods: {
	        onKeyDown: function onKeyDown(e) {
	            var _this = this;
	            if (e.keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_0__["keyCodes"].esc) {
	                // Wait for dependent elements to close first
	                setTimeout(function () {
	                    _this.isActive = false;
	                });
	                var activator_1 = this.getActivator();
	                this.$nextTick(function () {
	                    return activator_1 && activator_1.focus();
	                });
	            } else if (e.keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_0__["keyCodes"].tab) {
	                setTimeout(function () {
	                    if (!_this.$refs.content.contains(document.activeElement)) {
	                        _this.isActive = false;
	                    }
	                });
	            } else {
	                this.changeListIndex(e);
	            }
	        },
	        changeListIndex: function changeListIndex(e) {
	            // For infinite scroll and autocomplete, re-evaluate children
	            this.getTiles();
	            if (e.keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_0__["keyCodes"].down && this.listIndex < this.tiles.length - 1) {
	                this.listIndex++;
	                // Allow user to set listIndex to -1 so
	                // that the list can be un-highlighted
	            } else if (e.keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_0__["keyCodes"].up && this.listIndex > -1) {
	                this.listIndex--;
	            } else if (e.keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_0__["keyCodes"].enter && this.listIndex !== -1) {
	                this.tiles[this.listIndex].click();
	            } else {
	                return;
	            }
	            // One of the conditions was met, prevent default action (#2988)
	            e.preventDefault();
	        },
	        getTiles: function getTiles() {
	            this.tiles = this.$refs.content.querySelectorAll('.v-list__tile');
	        }
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VMenu/mixins/menu-position.js":
	/*!******************************************************!*\
	  !*** ./src/components/VMenu/mixins/menu-position.js ***!
	  \******************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/**
	 * Menu position
	 *
	 * @mixin
	 *
	 * Used for calculating an automatic position (used for VSelect)
	 * Will position the VMenu content properly over the VSelect
	 */
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    data: function data() {
	        return {
	            calculatedTopAuto: 0
	        };
	    },
	    methods: {
	        calcScrollPosition: function calcScrollPosition() {
	            var $el = this.$refs.content;
	            var activeTile = $el.querySelector('.v-list__tile--active');
	            var maxScrollTop = $el.scrollHeight - $el.offsetHeight;
	            return activeTile ? Math.min(maxScrollTop, Math.max(0, activeTile.offsetTop - $el.offsetHeight / 2 + activeTile.offsetHeight / 2)) : $el.scrollTop;
	        },
	        calcLeftAuto: function calcLeftAuto() {
	            if (this.isAttached) return 0;
	            return parseInt(this.dimensions.activator.left - this.defaultOffset * 2);
	        },
	        calcTopAuto: function calcTopAuto() {
	            var $el = this.$refs.content;
	            var activeTile = $el.querySelector('.v-list__tile--active');
	            if (!activeTile) {
	                this.selectedIndex = null;
	            }
	            if (this.offsetY || !activeTile) {
	                return this.computedTop;
	            }
	            this.selectedIndex = Array.from(this.tiles).indexOf(activeTile);
	            var tileDistanceFromMenuTop = activeTile.offsetTop - this.calcScrollPosition();
	            var firstTileOffsetTop = $el.querySelector('.v-list__tile').offsetTop;
	            return this.computedTop - tileDistanceFromMenuTop - firstTileOffsetTop;
	        }
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VMessages/VMessages.ts":
	/*!***********************************************!*\
	  !*** ./src/components/VMessages/VMessages.ts ***!
	  \***********************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_messages_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_messages.styl */ "./src/stylus/components/_messages.styl");
	/* harmony import */ var _stylus_components_messages_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_messages_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	// Styles
	
	// Mixins
	
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_3__["default"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_1__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__["default"]).extend({
	    name: 'v-messages',
	    props: {
	        value: {
	            type: Array,
	            default: function _default() {
	                return [];
	            }
	        }
	    },
	    methods: {
	        genChildren: function genChildren() {
	            return this.$createElement('transition-group', {
	                staticClass: 'v-messages__wrapper',
	                attrs: {
	                    name: 'message-transition',
	                    tag: 'div'
	                }
	            }, this.value.map(this.genMessage));
	        },
	        genMessage: function genMessage(message, key) {
	            return this.$createElement('div', {
	                staticClass: 'v-messages__message',
	                key: key,
	                domProps: {
	                    innerHTML: message
	                }
	            });
	        }
	    },
	    render: function render(h) {
	        return h('div', this.setTextColor(this.color, {
	            staticClass: 'v-messages',
	            class: this.themeClasses
	        }), [this.genChildren()]);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VMessages/index.ts":
	/*!*******************************************!*\
	  !*** ./src/components/VMessages/index.ts ***!
	  \*******************************************/
	/*! exports provided: VMessages, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VMessages__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VMessages */ "./src/components/VMessages/VMessages.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VMessages", function() { return _VMessages__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VMessages__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VNavigationDrawer/VNavigationDrawer.ts":
	/*!***************************************************************!*\
	  !*** ./src/components/VNavigationDrawer/VNavigationDrawer.ts ***!
	  \***************************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_navigation_drawer_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_navigation-drawer.styl */ "./src/stylus/components/_navigation-drawer.styl");
	/* harmony import */ var _stylus_components_navigation_drawer_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_navigation_drawer_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_applicationable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/applicationable */ "./src/mixins/applicationable.ts");
	/* harmony import */ var _mixins_dependent__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/dependent */ "./src/mixins/dependent.ts");
	/* harmony import */ var _mixins_overlayable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/overlayable */ "./src/mixins/overlayable.ts");
	/* harmony import */ var _mixins_ssr_bootable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mixins/ssr-bootable */ "./src/mixins/ssr-bootable.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _directives_click_outside__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../directives/click-outside */ "./src/directives/click-outside.ts");
	/* harmony import */ var _directives_resize__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../directives/resize */ "./src/directives/resize.ts");
	/* harmony import */ var _directives_touch__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../directives/touch */ "./src/directives/touch.ts");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	// Styles
	
	// Mixins
	
	
	
	
	
	// Directives
	
	
	
	// Utilities
	
	
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_10__["default"])(Object(_mixins_applicationable__WEBPACK_IMPORTED_MODULE_1__["default"])('left', ['miniVariant', 'right', 'width']), _mixins_dependent__WEBPACK_IMPORTED_MODULE_2__["default"], _mixins_overlayable__WEBPACK_IMPORTED_MODULE_3__["default"], _mixins_ssr_bootable__WEBPACK_IMPORTED_MODULE_4__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_5__["default"]
	/* @vue/component */
	).extend({
	    name: 'v-navigation-drawer',
	    directives: {
	        ClickOutside: _directives_click_outside__WEBPACK_IMPORTED_MODULE_6__["default"],
	        Resize: _directives_resize__WEBPACK_IMPORTED_MODULE_7__["default"],
	        Touch: _directives_touch__WEBPACK_IMPORTED_MODULE_8__["default"]
	    },
	    props: {
	        clipped: Boolean,
	        disableRouteWatcher: Boolean,
	        disableResizeWatcher: Boolean,
	        height: {
	            type: [Number, String],
	            default: '100%'
	        },
	        floating: Boolean,
	        miniVariant: Boolean,
	        miniVariantWidth: {
	            type: [Number, String],
	            default: 80
	        },
	        mobileBreakPoint: {
	            type: [Number, String],
	            default: 1264
	        },
	        permanent: Boolean,
	        right: Boolean,
	        stateless: Boolean,
	        temporary: Boolean,
	        touchless: Boolean,
	        width: {
	            type: [Number, String],
	            default: 300
	        },
	        value: { required: false }
	    },
	    data: function data() {
	        return {
	            isActive: false,
	            touchArea: {
	                left: 0,
	                right: 0
	            }
	        };
	    },
	    computed: {
	        /**
	         * Used for setting an app value from a dynamic
	         * property. Called from applicationable.js
	         */
	        applicationProperty: function applicationProperty() {
	            return this.right ? 'right' : 'left';
	        },
	        calculatedTransform: function calculatedTransform() {
	            if (this.isActive) return 0;
	            return this.right ? this.calculatedWidth : -this.calculatedWidth;
	        },
	        calculatedWidth: function calculatedWidth() {
	            return parseInt(this.miniVariant ? this.miniVariantWidth : this.width);
	        },
	        classes: function classes() {
	            return __assign({ 'v-navigation-drawer': true, 'v-navigation-drawer--absolute': this.absolute, 'v-navigation-drawer--clipped': this.clipped, 'v-navigation-drawer--close': !this.isActive, 'v-navigation-drawer--fixed': !this.absolute && (this.app || this.fixed), 'v-navigation-drawer--floating': this.floating, 'v-navigation-drawer--is-mobile': this.isMobile, 'v-navigation-drawer--mini-variant': this.miniVariant, 'v-navigation-drawer--open': this.isActive, 'v-navigation-drawer--right': this.right, 'v-navigation-drawer--temporary': this.temporary }, this.themeClasses);
	        },
	        hasApp: function hasApp() {
	            return this.app && !this.isMobile && !this.temporary;
	        },
	        isMobile: function isMobile() {
	            return !this.stateless && !this.permanent && !this.temporary && this.$vuetify.breakpoint.width < parseInt(this.mobileBreakPoint, 10);
	        },
	        marginTop: function marginTop() {
	            if (!this.hasApp) return 0;
	            var marginTop = this.$vuetify.application.bar;
	            marginTop += this.clipped ? this.$vuetify.application.top : 0;
	            return marginTop;
	        },
	        maxHeight: function maxHeight() {
	            if (!this.hasApp) return null;
	            var maxHeight = this.$vuetify.application.bottom + this.$vuetify.application.footer + this.$vuetify.application.bar;
	            if (!this.clipped) return maxHeight;
	            return maxHeight + this.$vuetify.application.top;
	        },
	        reactsToClick: function reactsToClick() {
	            return !this.stateless && !this.permanent && (this.isMobile || this.temporary);
	        },
	        reactsToMobile: function reactsToMobile() {
	            return !this.disableResizeWatcher && !this.stateless && !this.permanent && !this.temporary;
	        },
	        reactsToRoute: function reactsToRoute() {
	            return !this.disableRouteWatcher && !this.stateless && (this.temporary || this.isMobile);
	        },
	        resizeIsDisabled: function resizeIsDisabled() {
	            return this.disableResizeWatcher || this.stateless;
	        },
	        showOverlay: function showOverlay() {
	            return this.isActive && (this.isMobile || this.temporary);
	        },
	        styles: function styles() {
	            var styles = {
	                height: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_9__["convertToUnit"])(this.height),
	                marginTop: this.marginTop + "px",
	                maxHeight: this.maxHeight != null ? "calc(100% - " + +this.maxHeight + "px)" : undefined,
	                transform: "translateX(" + this.calculatedTransform + "px)",
	                width: this.calculatedWidth + "px"
	            };
	            return styles;
	        }
	    },
	    watch: {
	        $route: function $route() {
	            if (this.reactsToRoute && this.closeConditional()) {
	                this.isActive = false;
	            }
	        },
	        isActive: function isActive(val) {
	            this.$emit('input', val);
	            this.callUpdate();
	        },
	        /**
	         * When mobile changes, adjust the active state
	         * only when there has been a previous value
	         */
	        isMobile: function isMobile(val, prev) {
	            !val && this.isActive && !this.temporary && this.removeOverlay();
	            if (prev == null || this.resizeIsDisabled || !this.reactsToMobile) return;
	            this.isActive = !val;
	            this.callUpdate();
	        },
	        permanent: function permanent(val) {
	            // If enabling prop enable the drawer
	            if (val) {
	                this.isActive = true;
	            }
	            this.callUpdate();
	        },
	        showOverlay: function showOverlay(val) {
	            if (val) this.genOverlay();else this.removeOverlay();
	        },
	        temporary: function temporary() {
	            this.callUpdate();
	        },
	        value: function value(val) {
	            if (this.permanent) return;
	            // TODO: referring to this directly causes type errors
	            // all over the place for some reason
	            var _this = this;
	            if (val == null) return _this.init();
	            if (val !== this.isActive) this.isActive = val;
	        }
	    },
	    beforeMount: function beforeMount() {
	        this.init();
	    },
	    methods: {
	        calculateTouchArea: function calculateTouchArea() {
	            if (!this.$el.parentNode) return;
	            var parentRect = this.$el.parentNode.getBoundingClientRect();
	            this.touchArea = {
	                left: parentRect.left + 50,
	                right: parentRect.right - 50
	            };
	        },
	        closeConditional: function closeConditional() {
	            return this.isActive && this.reactsToClick;
	        },
	        genDirectives: function genDirectives() {
	            var _this_1 = this;
	            var directives = [{
	                name: 'click-outside',
	                value: function value() {
	                    return _this_1.isActive = false;
	                },
	                args: {
	                    closeConditional: this.closeConditional,
	                    include: this.getOpenDependentElements
	                }
	            }];
	            !this.touchless && directives.push({
	                name: 'touch',
	                value: {
	                    parent: true,
	                    left: this.swipeLeft,
	                    right: this.swipeRight
	                }
	            });
	            return directives;
	        },
	        /**
	         * Sets state before mount to avoid
	         * entry transitions in SSR
	         */
	        init: function init() {
	            if (this.permanent) {
	                this.isActive = true;
	            } else if (this.stateless || this.value != null) {
	                this.isActive = this.value;
	            } else if (!this.temporary) {
	                this.isActive = !this.isMobile;
	            }
	        },
	        swipeRight: function swipeRight(e) {
	            if (this.isActive && !this.right) return;
	            this.calculateTouchArea();
	            if (Math.abs(e.touchendX - e.touchstartX) < 100) return;
	            if (!this.right && e.touchstartX <= this.touchArea.left) this.isActive = true;else if (this.right && this.isActive) this.isActive = false;
	        },
	        swipeLeft: function swipeLeft(e) {
	            if (this.isActive && this.right) return;
	            this.calculateTouchArea();
	            if (Math.abs(e.touchendX - e.touchstartX) < 100) return;
	            if (this.right && e.touchstartX >= this.touchArea.right) this.isActive = true;else if (!this.right && this.isActive) this.isActive = false;
	        },
	        /**
	         * Update the application layout
	         */
	        updateApplication: function updateApplication() {
	            return !this.isActive || this.temporary || this.isMobile ? 0 : this.calculatedWidth;
	        }
	    },
	    render: function render(h) {
	        var _this_1 = this;
	        var data = {
	            'class': this.classes,
	            style: this.styles,
	            directives: this.genDirectives(),
	            on: {
	                click: function click() {
	                    if (!_this_1.miniVariant) return;
	                    _this_1.$emit('update:miniVariant', false);
	                },
	                transitionend: function transitionend(e) {
	                    if (e.target !== e.currentTarget) return;
	                    _this_1.$emit('transitionend', e);
	                    // IE11 does not support new Event('resize')
	                    var resizeEvent = document.createEvent('UIEvents');
	                    resizeEvent.initUIEvent('resize', true, false, window, 0);
	                    window.dispatchEvent(resizeEvent);
	                }
	            }
	        };
	        return h('aside', data, [this.$slots.default, h('div', { 'class': 'v-navigation-drawer__border' })]);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VNavigationDrawer/index.ts":
	/*!***************************************************!*\
	  !*** ./src/components/VNavigationDrawer/index.ts ***!
	  \***************************************************/
	/*! exports provided: VNavigationDrawer, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VNavigationDrawer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VNavigationDrawer */ "./src/components/VNavigationDrawer/VNavigationDrawer.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VNavigationDrawer", function() { return _VNavigationDrawer__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VNavigationDrawer__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VOverflowBtn/VOverflowBtn.js":
	/*!*****************************************************!*\
	  !*** ./src/components/VOverflowBtn/VOverflowBtn.js ***!
	  \*****************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_overflow_buttons_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_overflow-buttons.styl */ "./src/stylus/components/_overflow-buttons.styl");
	/* harmony import */ var _stylus_components_overflow_buttons_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_overflow_buttons_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../VSelect/VSelect */ "./src/components/VSelect/VSelect.js");
	/* harmony import */ var _VAutocomplete__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../VAutocomplete */ "./src/components/VAutocomplete/index.js");
	/* harmony import */ var _VTextField_VTextField__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../VTextField/VTextField */ "./src/components/VTextField/VTextField.js");
	/* harmony import */ var _VBtn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../VBtn */ "./src/components/VBtn/index.ts");
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../util/console */ "./src/util/console.ts");
	// Styles
	
	// Extensions
	
	
	
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (_VAutocomplete__WEBPACK_IMPORTED_MODULE_2__["default"].extend({
	    name: 'v-overflow-btn',
	    props: {
	        segmented: Boolean,
	        editable: Boolean,
	        transition: _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].options.props.transition
	    },
	    computed: {
	        classes: function classes() {
	            return Object.assign(_VAutocomplete__WEBPACK_IMPORTED_MODULE_2__["default"].options.computed.classes.call(this), {
	                'v-overflow-btn': true,
	                'v-overflow-btn--segmented': this.segmented,
	                'v-overflow-btn--editable': this.editable
	            });
	        },
	        isAnyValueAllowed: function isAnyValueAllowed() {
	            return this.editable || _VAutocomplete__WEBPACK_IMPORTED_MODULE_2__["default"].options.computed.isAnyValueAllowed.call(this);
	        },
	        isSingle: function isSingle() {
	            return true;
	        },
	        computedItems: function computedItems() {
	            return this.segmented ? this.allItems : this.filteredItems;
	        },
	        $_menuProps: function $_menuProps() {
	            var props = _VAutocomplete__WEBPACK_IMPORTED_MODULE_2__["default"].options.computed.$_menuProps.call(this);
	            props.transition = props.transition || 'v-menu-transition';
	            return props;
	        }
	    },
	    methods: {
	        genSelections: function genSelections() {
	            return this.editable ? _VAutocomplete__WEBPACK_IMPORTED_MODULE_2__["default"].options.methods.genSelections.call(this) : _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.genSelections.call(this); // Override v-autocomplete's override
	        },
	        genCommaSelection: function genCommaSelection(item, index, last) {
	            return this.segmented ? this.genSegmentedBtn(item) : _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.genCommaSelection.call(this, item, index, last);
	        },
	        genInput: function genInput() {
	            var input = _VTextField_VTextField__WEBPACK_IMPORTED_MODULE_3__["default"].options.methods.genInput.call(this);
	            input.data.domProps.value = this.editable ? this.internalSearch : '';
	            input.data.attrs.readonly = !this.isAnyValueAllowed;
	            return input;
	        },
	        genLabel: function genLabel() {
	            if (this.editable && this.isFocused) return null;
	            var label = _VTextField_VTextField__WEBPACK_IMPORTED_MODULE_3__["default"].options.methods.genLabel.call(this);
	            if (!label) return label;
	            // Reset previously set styles from parent
	            label.data.style = {};
	            return label;
	        },
	        genSegmentedBtn: function genSegmentedBtn(item) {
	            var _this = this;
	            var itemValue = this.getValue(item);
	            var itemObj = this.computedItems.find(function (i) {
	                return _this.getValue(i) === itemValue;
	            }) || item;
	            if (!itemObj.text || !itemObj.callback) {
	                Object(_util_console__WEBPACK_IMPORTED_MODULE_5__["consoleWarn"])('When using \'segmented\' prop without a selection slot, items must contain both a text and callback property', this);
	                return null;
	            }
	            return this.$createElement(_VBtn__WEBPACK_IMPORTED_MODULE_4__["default"], {
	                props: { flat: true },
	                on: {
	                    click: function click(e) {
	                        e.stopPropagation();
	                        itemObj.callback(e);
	                    }
	                }
	            }, [itemObj.text]);
	        }
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VOverflowBtn/index.js":
	/*!**********************************************!*\
	  !*** ./src/components/VOverflowBtn/index.js ***!
	  \**********************************************/
	/*! exports provided: VOverflowBtn, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VOverflowBtn__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VOverflowBtn */ "./src/components/VOverflowBtn/VOverflowBtn.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VOverflowBtn", function() { return _VOverflowBtn__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VOverflowBtn__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VPagination/VPagination.ts":
	/*!***************************************************!*\
	  !*** ./src/components/VPagination/VPagination.ts ***!
	  \***************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_pagination_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_pagination.styl */ "./src/stylus/components/_pagination.styl");
	/* harmony import */ var _stylus_components_pagination_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_pagination_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _VIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../VIcon */ "./src/components/VIcon/index.ts");
	/* harmony import */ var _directives_resize__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../directives/resize */ "./src/directives/resize.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var __read = undefined && undefined.__read || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o),
	        r,
	        ar = [],
	        e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
	            ar.push(r.value);
	        }
	    } catch (error) {
	        e = { error: error };
	    } finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        } finally {
	            if (e) throw e.error;
	        }
	    }
	    return ar;
	};
	var __spread = undefined && undefined.__spread || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) {
	        ar = ar.concat(__read(arguments[i]));
	    }return ar;
	};
	
	
	// Directives
	
	// Mixins
	
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_3__["default"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_4__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_5__["default"]).extend({
	    name: 'v-pagination',
	    directives: { Resize: _directives_resize__WEBPACK_IMPORTED_MODULE_2__["default"] },
	    props: {
	        circle: Boolean,
	        disabled: Boolean,
	        length: {
	            type: Number,
	            default: 0,
	            validator: function validator(val) {
	                return val % 1 === 0;
	            }
	        },
	        totalVisible: [Number, String],
	        nextIcon: {
	            type: String,
	            default: '$vuetify.icons.next'
	        },
	        prevIcon: {
	            type: String,
	            default: '$vuetify.icons.prev'
	        },
	        value: {
	            type: Number,
	            default: 0
	        }
	    },
	    data: function data() {
	        return {
	            maxButtons: 0,
	            selected: null
	        };
	    },
	    computed: {
	        classes: function classes() {
	            return __assign({ 'v-pagination': true, 'v-pagination--circle': this.circle, 'v-pagination--disabled': this.disabled }, this.themeClasses);
	        },
	        items: function items() {
	            var maxLength = parseInt(this.totalVisible, 10) || this.maxButtons;
	            if (this.length <= maxLength) {
	                return this.range(1, this.length);
	            }
	            var even = maxLength % 2 === 0 ? 1 : 0;
	            var left = Math.floor(maxLength / 2);
	            var right = this.length - left + 1 + even;
	            if (this.value > left && this.value < right) {
	                var start = this.value - left + 2;
	                var end = this.value + left - 2 - even;
	                return __spread([1, '...'], this.range(start, end), ['...', this.length]);
	            } else if (this.value === left) {
	                var end = this.value + left - 1 - even;
	                return __spread(this.range(1, end), ['...', this.length]);
	            } else if (this.value === right) {
	                var start = this.value - left + 1;
	                return __spread([1, '...'], this.range(start, this.length));
	            } else {
	                return __spread(this.range(1, left), ['...'], this.range(right, this.length));
	            }
	        }
	    },
	    watch: {
	        value: function value() {
	            this.init();
	        }
	    },
	    mounted: function mounted() {
	        this.init();
	    },
	    methods: {
	        init: function init() {
	            var _this = this;
	            this.selected = null;
	            this.$nextTick(this.onResize);
	            // TODO: Change this (f75dee3a, cbdf7caa)
	            setTimeout(function () {
	                return _this.selected = _this.value;
	            }, 100);
	        },
	        onResize: function onResize() {
	            var width = this.$el && this.$el.parentElement ? this.$el.parentElement.clientWidth : window.innerWidth;
	            this.maxButtons = Math.floor((width - 96) / 42);
	        },
	        next: function next(e) {
	            e.preventDefault();
	            this.$emit('input', this.value + 1);
	            this.$emit('next');
	        },
	        previous: function previous(e) {
	            e.preventDefault();
	            this.$emit('input', this.value - 1);
	            this.$emit('previous');
	        },
	        range: function range(from, to) {
	            var range = [];
	            from = from > 0 ? from : 1;
	            for (var i = from; i <= to; i++) {
	                range.push(i);
	            }
	            return range;
	        },
	        genIcon: function genIcon(h, icon, disabled, fn) {
	            return h('li', [h('button', {
	                staticClass: 'v-pagination__navigation',
	                class: {
	                    'v-pagination__navigation--disabled': disabled
	                },
	                attrs: {
	                    type: 'button'
	                },
	                on: disabled ? {} : { click: fn }
	            }, [h(_VIcon__WEBPACK_IMPORTED_MODULE_1__["default"], [icon])])]);
	        },
	        genItem: function genItem(h, i) {
	            var _this = this;
	            var color = i === this.value && (this.color || 'primary');
	            return h('button', this.setBackgroundColor(color, {
	                staticClass: 'v-pagination__item',
	                class: {
	                    'v-pagination__item--active': i === this.value
	                },
	                attrs: {
	                    type: 'button'
	                },
	                on: {
	                    click: function click() {
	                        return _this.$emit('input', i);
	                    }
	                }
	            }), [i.toString()]);
	        },
	        genItems: function genItems(h) {
	            var _this = this;
	            return this.items.map(function (i, index) {
	                return h('li', { key: index }, [isNaN(Number(i)) ? h('span', { class: 'v-pagination__more' }, [i.toString()]) : _this.genItem(h, i)]);
	            });
	        }
	    },
	    render: function render(h) {
	        var children = [this.genIcon(h, this.$vuetify.rtl ? this.nextIcon : this.prevIcon, this.value <= 1, this.previous), this.genItems(h), this.genIcon(h, this.$vuetify.rtl ? this.prevIcon : this.nextIcon, this.value >= this.length, this.next)];
	        return h('ul', {
	            directives: [{
	                modifiers: { quiet: true },
	                name: 'resize',
	                value: this.onResize
	            }],
	            class: this.classes
	        }, children);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VPagination/index.ts":
	/*!*********************************************!*\
	  !*** ./src/components/VPagination/index.ts ***!
	  \*********************************************/
	/*! exports provided: VPagination, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VPagination__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VPagination */ "./src/components/VPagination/VPagination.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VPagination", function() { return _VPagination__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VPagination__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VParallax/VParallax.ts":
	/*!***********************************************!*\
	  !*** ./src/components/VParallax/VParallax.ts ***!
	  \***********************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_parallax_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_parallax.styl */ "./src/stylus/components/_parallax.styl");
	/* harmony import */ var _stylus_components_parallax_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_parallax_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_translatable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/translatable */ "./src/mixins/translatable.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	// Style
	
	// Mixins
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_2__["default"])(_mixins_translatable__WEBPACK_IMPORTED_MODULE_1__["default"]).extend({
	    name: 'v-parallax',
	    props: {
	        alt: {
	            type: String,
	            default: ''
	        },
	        height: {
	            type: [String, Number],
	            default: 500
	        },
	        src: String
	    },
	    data: function data() {
	        return {
	            isBooted: false
	        };
	    },
	    computed: {
	        styles: function styles() {
	            return {
	                display: 'block',
	                opacity: this.isBooted ? 1 : 0,
	                transform: "translate(-50%, " + this.parallax + "px)"
	            };
	        }
	    },
	    watch: {
	        parallax: function parallax() {
	            this.isBooted = true;
	        }
	    },
	    mounted: function mounted() {
	        this.init();
	    },
	    methods: {
	        init: function init() {
	            var _this = this;
	            var img = this.$refs.img;
	            if (!img) return;
	            if (img.complete) {
	                this.translate();
	                this.listeners();
	            } else {
	                img.addEventListener('load', function () {
	                    _this.translate();
	                    _this.listeners();
	                }, false);
	            }
	        },
	        objHeight: function objHeight() {
	            return this.$refs.img.naturalHeight;
	        }
	    },
	    render: function render(h) {
	        var imgData = {
	            staticClass: 'v-parallax__image',
	            style: this.styles,
	            attrs: {
	                src: this.src,
	                alt: this.alt
	            },
	            ref: 'img'
	        };
	        var container = h('div', {
	            staticClass: 'v-parallax__image-container'
	        }, [h('img', imgData)]);
	        var content = h('div', {
	            staticClass: 'v-parallax__content'
	        }, this.$slots.default);
	        return h('div', {
	            staticClass: 'v-parallax',
	            style: {
	                height: this.height + "px"
	            },
	            on: this.$listeners
	        }, [container, content]);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VParallax/index.ts":
	/*!*******************************************!*\
	  !*** ./src/components/VParallax/index.ts ***!
	  \*******************************************/
	/*! exports provided: VParallax, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VParallax__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VParallax */ "./src/components/VParallax/VParallax.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VParallax", function() { return _VParallax__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VParallax__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VPicker/VPicker.ts":
	/*!*******************************************!*\
	  !*** ./src/components/VPicker/VPicker.ts ***!
	  \*******************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_pickers_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_pickers.styl */ "./src/stylus/components/_pickers.styl");
	/* harmony import */ var _stylus_components_pickers_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_pickers_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _stylus_components_cards_styl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../stylus/components/_cards.styl */ "./src/stylus/components/_cards.styl");
	/* harmony import */ var _stylus_components_cards_styl__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_cards_styl__WEBPACK_IMPORTED_MODULE_1__);
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	
	
	// Mixins
	
	
	// Helpers
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_5__["default"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_2__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_3__["default"]).extend({
	    name: 'v-picker',
	    props: {
	        fullWidth: Boolean,
	        landscape: Boolean,
	        transition: {
	            type: String,
	            default: 'fade-transition'
	        },
	        width: {
	            type: [Number, String],
	            default: 290
	        }
	    },
	    computed: {
	        computedTitleColor: function computedTitleColor() {
	            var defaultTitleColor = this.isDark ? false : this.color || 'primary';
	            return this.color || defaultTitleColor;
	        }
	    },
	    methods: {
	        genTitle: function genTitle() {
	            return this.$createElement('div', this.setBackgroundColor(this.computedTitleColor, {
	                staticClass: 'v-picker__title',
	                'class': {
	                    'v-picker__title--landscape': this.landscape
	                }
	            }), this.$slots.title);
	        },
	        genBodyTransition: function genBodyTransition() {
	            return this.$createElement('transition', {
	                props: {
	                    name: this.transition
	                }
	            }, this.$slots.default);
	        },
	        genBody: function genBody() {
	            return this.$createElement('div', {
	                staticClass: 'v-picker__body',
	                'class': this.themeClasses,
	                style: this.fullWidth ? undefined : {
	                    width: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["convertToUnit"])(this.width)
	                }
	            }, [this.genBodyTransition()]);
	        },
	        genActions: function genActions() {
	            return this.$createElement('div', {
	                staticClass: 'v-picker__actions v-card__actions'
	            }, this.$slots.actions);
	        }
	    },
	    render: function render(h) {
	        return h('div', {
	            staticClass: 'v-picker v-card',
	            'class': __assign({ 'v-picker--landscape': this.landscape, 'v-picker--full-width': this.fullWidth }, this.themeClasses)
	        }, [this.$slots.title ? this.genTitle() : null, this.genBody(), this.$slots.actions ? this.genActions() : null]);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VPicker/index.ts":
	/*!*****************************************!*\
	  !*** ./src/components/VPicker/index.ts ***!
	  \*****************************************/
	/*! exports provided: VPicker, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VPicker__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VPicker */ "./src/components/VPicker/VPicker.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VPicker", function() { return _VPicker__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VPicker__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VProgressCircular/VProgressCircular.ts":
	/*!***************************************************************!*\
	  !*** ./src/components/VProgressCircular/VProgressCircular.ts ***!
	  \***************************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_progress_circular_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_progress-circular.styl */ "./src/stylus/components/_progress-circular.styl");
	/* harmony import */ var _stylus_components_progress_circular_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_progress_circular_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	
	// Mixins
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_2__["default"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_1__["default"]).extend({
	    name: 'v-progress-circular',
	    props: {
	        button: Boolean,
	        indeterminate: Boolean,
	        rotate: {
	            type: [Number, String],
	            default: 0
	        },
	        size: {
	            type: [Number, String],
	            default: 32
	        },
	        width: {
	            type: [Number, String],
	            default: 4
	        },
	        value: {
	            type: [Number, String],
	            default: 0
	        }
	    },
	    computed: {
	        calculatedSize: function calculatedSize() {
	            return Number(this.size) + (this.button ? 8 : 0);
	        },
	        circumference: function circumference() {
	            return 2 * Math.PI * this.radius;
	        },
	        classes: function classes() {
	            return {
	                'v-progress-circular--indeterminate': this.indeterminate,
	                'v-progress-circular--button': this.button
	            };
	        },
	        normalizedValue: function normalizedValue() {
	            if (this.value < 0) {
	                return 0;
	            }
	            if (this.value > 100) {
	                return 100;
	            }
	            return parseFloat(this.value);
	        },
	        radius: function radius() {
	            return 20;
	        },
	        strokeDashArray: function strokeDashArray() {
	            return Math.round(this.circumference * 1000) / 1000;
	        },
	        strokeDashOffset: function strokeDashOffset() {
	            return (100 - this.normalizedValue) / 100 * this.circumference + 'px';
	        },
	        strokeWidth: function strokeWidth() {
	            return Number(this.width) / +this.size * this.viewBoxSize * 2;
	        },
	        styles: function styles() {
	            return {
	                height: this.calculatedSize + "px",
	                width: this.calculatedSize + "px"
	            };
	        },
	        svgStyles: function svgStyles() {
	            return {
	                transform: "rotate(" + Number(this.rotate) + "deg)"
	            };
	        },
	        viewBoxSize: function viewBoxSize() {
	            return this.radius / (1 - Number(this.width) / +this.size);
	        }
	    },
	    methods: {
	        genCircle: function genCircle(h, name, offset) {
	            return h('circle', {
	                class: "v-progress-circular__" + name,
	                attrs: {
	                    fill: 'transparent',
	                    cx: 2 * this.viewBoxSize,
	                    cy: 2 * this.viewBoxSize,
	                    r: this.radius,
	                    'stroke-width': this.strokeWidth,
	                    'stroke-dasharray': this.strokeDashArray,
	                    'stroke-dashoffset': offset
	                }
	            });
	        },
	        genSvg: function genSvg(h) {
	            var children = [this.indeterminate || this.genCircle(h, 'underlay', 0), this.genCircle(h, 'overlay', this.strokeDashOffset)];
	            return h('svg', {
	                style: this.svgStyles,
	                attrs: {
	                    xmlns: 'http://www.w3.org/2000/svg',
	                    viewBox: this.viewBoxSize + " " + this.viewBoxSize + " " + 2 * this.viewBoxSize + " " + 2 * this.viewBoxSize
	                }
	            }, children);
	        }
	    },
	    render: function render(h) {
	        var info = h('div', { staticClass: 'v-progress-circular__info' }, this.$slots.default);
	        var svg = this.genSvg(h);
	        return h('div', this.setTextColor(this.color, {
	            staticClass: 'v-progress-circular',
	            attrs: {
	                'role': 'progressbar',
	                'aria-valuemin': 0,
	                'aria-valuemax': 100,
	                'aria-valuenow': this.indeterminate ? undefined : this.normalizedValue
	            },
	            class: this.classes,
	            style: this.styles,
	            on: this.$listeners
	        }), [svg, info]);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VProgressCircular/index.ts":
	/*!***************************************************!*\
	  !*** ./src/components/VProgressCircular/index.ts ***!
	  \***************************************************/
	/*! exports provided: VProgressCircular, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VProgressCircular__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VProgressCircular */ "./src/components/VProgressCircular/VProgressCircular.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VProgressCircular", function() { return _VProgressCircular__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VProgressCircular__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VProgressLinear/VProgressLinear.ts":
	/*!***********************************************************!*\
	  !*** ./src/components/VProgressLinear/VProgressLinear.ts ***!
	  \***********************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_progress_linear_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_progress-linear.styl */ "./src/stylus/components/_progress-linear.styl");
	/* harmony import */ var _stylus_components_progress_linear_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_progress_linear_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	/* harmony import */ var _transitions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../transitions */ "./src/components/transitions/index.js");
	
	// Mixins
	
	// Helpers
	
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_3__["default"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_1__["default"]).extend({
	    name: 'v-progress-linear',
	    props: {
	        active: {
	            type: Boolean,
	            default: true
	        },
	        backgroundColor: {
	            type: String,
	            default: null
	        },
	        backgroundOpacity: {
	            type: [Number, String],
	            default: null
	        },
	        bufferValue: {
	            type: [Number, String],
	            default: 100
	        },
	        color: {
	            type: String,
	            default: 'primary'
	        },
	        height: {
	            type: [Number, String],
	            default: 7
	        },
	        indeterminate: Boolean,
	        query: Boolean,
	        value: {
	            type: [Number, String],
	            default: 0
	        }
	    },
	    computed: {
	        backgroundStyle: function backgroundStyle() {
	            var backgroundOpacity = this.backgroundOpacity == null ? this.backgroundColor ? 1 : 0.3 : parseFloat(this.backgroundOpacity);
	            return {
	                height: this.active ? Object(_util_helpers__WEBPACK_IMPORTED_MODULE_2__["convertToUnit"])(this.height) : 0,
	                opacity: backgroundOpacity,
	                width: this.normalizedBufer + "%"
	            };
	        },
	        effectiveWidth: function effectiveWidth() {
	            if (!this.normalizedBufer) {
	                return 0;
	            }
	            return +this.normalizedValue * 100 / +this.normalizedBufer;
	        },
	        normalizedBufer: function normalizedBufer() {
	            if (this.bufferValue < 0) {
	                return 0;
	            }
	            if (this.bufferValue > 100) {
	                return 100;
	            }
	            return parseFloat(this.bufferValue);
	        },
	        normalizedValue: function normalizedValue() {
	            if (this.value < 0) {
	                return 0;
	            }
	            if (this.value > 100) {
	                return 100;
	            }
	            return parseFloat(this.value);
	        },
	        styles: function styles() {
	            var styles = {};
	            if (!this.active) {
	                styles.height = 0;
	            }
	            if (!this.indeterminate && parseFloat(this.normalizedBufer) !== 100) {
	                styles.width = this.normalizedBufer + "%";
	            }
	            return styles;
	        }
	    },
	    methods: {
	        genDeterminate: function genDeterminate(h) {
	            return h('div', this.setBackgroundColor(this.color, {
	                ref: 'front',
	                staticClass: "v-progress-linear__bar__determinate",
	                style: {
	                    width: this.effectiveWidth + "%"
	                }
	            }));
	        },
	        genBar: function genBar(h, name) {
	            var _a;
	            return h('div', this.setBackgroundColor(this.color, {
	                staticClass: 'v-progress-linear__bar__indeterminate',
	                class: (_a = {}, _a[name] = true, _a)
	            }));
	        },
	        genIndeterminate: function genIndeterminate(h) {
	            return h('div', {
	                ref: 'front',
	                staticClass: 'v-progress-linear__bar__indeterminate',
	                class: {
	                    'v-progress-linear__bar__indeterminate--active': this.active
	                }
	            }, [this.genBar(h, 'long'), this.genBar(h, 'short')]);
	        }
	    },
	    render: function render(h) {
	        var fade = h(_transitions__WEBPACK_IMPORTED_MODULE_4__["VFadeTransition"], this.indeterminate ? [this.genIndeterminate(h)] : []);
	        var slide = h(_transitions__WEBPACK_IMPORTED_MODULE_4__["VSlideXTransition"], this.indeterminate ? [] : [this.genDeterminate(h)]);
	        var bar = h('div', {
	            staticClass: 'v-progress-linear__bar',
	            style: this.styles
	        }, [fade, slide]);
	        var background = h('div', this.setBackgroundColor(this.backgroundColor || this.color, {
	            staticClass: 'v-progress-linear__background',
	            style: this.backgroundStyle
	        }));
	        var content = this.$slots.default && h('div', {
	            staticClass: 'v-progress-linear__content'
	        }, this.$slots.default);
	        return h('div', {
	            staticClass: 'v-progress-linear',
	            attrs: {
	                'role': 'progressbar',
	                'aria-valuemin': 0,
	                'aria-valuemax': this.normalizedBufer,
	                'aria-valuenow': this.indeterminate ? undefined : this.normalizedValue
	            },
	            class: {
	                'v-progress-linear--query': this.query
	            },
	            style: {
	                height: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_2__["convertToUnit"])(this.height)
	            },
	            on: this.$listeners
	        }, [background, bar, content]);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VProgressLinear/index.ts":
	/*!*************************************************!*\
	  !*** ./src/components/VProgressLinear/index.ts ***!
	  \*************************************************/
	/*! exports provided: VProgressLinear, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VProgressLinear__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VProgressLinear */ "./src/components/VProgressLinear/VProgressLinear.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VProgressLinear", function() { return _VProgressLinear__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VProgressLinear__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VRadioGroup/VRadio.js":
	/*!**********************************************!*\
	  !*** ./src/components/VRadioGroup/VRadio.js ***!
	  \**********************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_radios_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_radios.styl */ "./src/stylus/components/_radios.styl");
	/* harmony import */ var _stylus_components_radios_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_radios_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _VIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../VIcon */ "./src/components/VIcon/index.ts");
	/* harmony import */ var _VLabel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../VLabel */ "./src/components/VLabel/index.ts");
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _mixins_rippleable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mixins/rippleable */ "./src/mixins/rippleable.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _mixins_selectable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mixins/selectable */ "./src/mixins/selectable.js");
	/* harmony import */ var _mixins_registrable__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mixins/registrable */ "./src/mixins/registrable.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var __read = undefined && undefined.__read || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o),
	        r,
	        ar = [],
	        e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
	            ar.push(r.value);
	        }
	    } catch (error) {
	        e = { error: error };
	    } finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        } finally {
	            if (e) throw e.error;
	        }
	    }
	    return ar;
	};
	var __spread = undefined && undefined.__spread || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) {
	        ar = ar.concat(__read(arguments[i]));
	    }return ar;
	};
	// Styles
	
	// Components
	
	
	// Mixins
	
	
	
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-radio',
	    mixins: [_mixins_colorable__WEBPACK_IMPORTED_MODULE_3__["default"], _mixins_rippleable__WEBPACK_IMPORTED_MODULE_4__["default"], Object(_mixins_registrable__WEBPACK_IMPORTED_MODULE_7__["inject"])('radio', 'v-radio', 'v-radio-group'), _mixins_themeable__WEBPACK_IMPORTED_MODULE_5__["default"]],
	    inheritAttrs: false,
	    props: {
	        color: {
	            type: String,
	            default: 'accent'
	        },
	        disabled: Boolean,
	        label: String,
	        onIcon: {
	            type: String,
	            default: '$vuetify.icons.radioOn'
	        },
	        offIcon: {
	            type: String,
	            default: '$vuetify.icons.radioOff'
	        },
	        readonly: Boolean,
	        value: null
	    },
	    data: function data() {
	        return {
	            isActive: false,
	            isFocused: false,
	            parentError: false
	        };
	    },
	    computed: {
	        computedData: function computedData() {
	            return this.setTextColor(!this.parentError && this.isActive && this.color, {
	                staticClass: 'v-radio',
	                'class': __assign({ 'v-radio--is-disabled': this.isDisabled, 'v-radio--is-focused': this.isFocused }, this.themeClasses)
	            });
	        },
	        computedColor: function computedColor() {
	            return this.isActive ? this.color : this.radio.validationState || false;
	        },
	        computedIcon: function computedIcon() {
	            return this.isActive ? this.onIcon : this.offIcon;
	        },
	        hasState: function hasState() {
	            return this.isActive || !!this.radio.validationState;
	        },
	        isDisabled: function isDisabled() {
	            return this.disabled || !!this.radio.disabled;
	        },
	        isReadonly: function isReadonly() {
	            return this.readonly || !!this.radio.readonly;
	        }
	    },
	    mounted: function mounted() {
	        this.radio.register(this);
	    },
	    beforeDestroy: function beforeDestroy() {
	        this.radio.unregister(this);
	    },
	    methods: {
	        genInput: function genInput() {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            var _a;
	            // We can't actually use the mixin directly because
	            // it's made for standalone components, but its
	            // genInput method is exactly what we need
	            return (_a = _mixins_selectable__WEBPACK_IMPORTED_MODULE_6__["default"].options.methods.genInput).call.apply(_a, __spread([this], args));
	        },
	        genLabel: function genLabel() {
	            return this.$createElement(_VLabel__WEBPACK_IMPORTED_MODULE_2__["default"], {
	                on: { click: this.onChange },
	                attrs: {
	                    for: this.id
	                },
	                props: {
	                    color: this.radio.validationState || '',
	                    dark: this.dark,
	                    focused: this.hasState,
	                    light: this.light
	                }
	            }, this.$slots.label || this.label);
	        },
	        genRadio: function genRadio() {
	            return this.$createElement('div', {
	                staticClass: 'v-input--selection-controls__input'
	            }, [this.genInput('radio', __assign({ name: this.radio.name || (this.radio._uid ? 'v-radio-' + this.radio._uid : false), value: this.value }, this.$attrs)), this.genRipple(this.setTextColor(this.computedColor)), this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_1__["default"], this.setTextColor(this.computedColor, {
	                props: {
	                    dark: this.dark,
	                    light: this.light
	                }
	            }), this.computedIcon)]);
	        },
	        onFocus: function onFocus(e) {
	            this.isFocused = true;
	            this.$emit('focus', e);
	        },
	        onBlur: function onBlur(e) {
	            this.isFocused = false;
	            this.$emit('blur', e);
	        },
	        onChange: function onChange() {
	            if (this.isDisabled || this.isReadonly) return;
	            if (!this.isDisabled && (!this.isActive || !this.radio.mandatory)) {
	                this.$emit('change', this.value);
	            }
	        },
	        onKeydown: function onKeydown() {}
	    },
	    render: function render(h) {
	        return h('div', this.computedData, [this.genRadio(), this.genLabel()]);
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VRadioGroup/VRadioGroup.js":
	/*!***************************************************!*\
	  !*** ./src/components/VRadioGroup/VRadioGroup.js ***!
	  \***************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_selection_controls_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_selection-controls.styl */ "./src/stylus/components/_selection-controls.styl");
	/* harmony import */ var _stylus_components_selection_controls_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_selection_controls_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _stylus_components_radio_group_styl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../stylus/components/_radio-group.styl */ "./src/stylus/components/_radio-group.styl");
	/* harmony import */ var _stylus_components_radio_group_styl__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_radio_group_styl__WEBPACK_IMPORTED_MODULE_1__);
	/* harmony import */ var _VInput__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../VInput */ "./src/components/VInput/index.ts");
	/* harmony import */ var _mixins_comparable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/comparable */ "./src/mixins/comparable.ts");
	/* harmony import */ var _mixins_registrable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mixins/registrable */ "./src/mixins/registrable.ts");
	// Styles
	
	
	// Components
	
	// Mixins
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (_VInput__WEBPACK_IMPORTED_MODULE_2__["default"].extend({
	    name: 'v-radio-group',
	    mixins: [_mixins_comparable__WEBPACK_IMPORTED_MODULE_3__["default"], Object(_mixins_registrable__WEBPACK_IMPORTED_MODULE_4__["provide"])('radio')],
	    model: {
	        prop: 'value',
	        event: 'change'
	    },
	    provide: function provide() {
	        return {
	            radio: this
	        };
	    },
	    props: {
	        column: {
	            type: Boolean,
	            default: true
	        },
	        height: {
	            type: [Number, String],
	            default: 'auto'
	        },
	        mandatory: {
	            type: Boolean,
	            default: true
	        },
	        name: String,
	        row: Boolean,
	        // If no value set on VRadio
	        // will match valueComparator
	        // force default to null
	        value: {
	            default: null
	        }
	    },
	    data: function data() {
	        return {
	            internalTabIndex: -1,
	            radios: []
	        };
	    },
	    computed: {
	        classes: function classes() {
	            return {
	                'v-input--selection-controls v-input--radio-group': true,
	                'v-input--radio-group--column': this.column && !this.row,
	                'v-input--radio-group--row': this.row
	            };
	        }
	    },
	    watch: {
	        hasError: 'setErrorState',
	        internalValue: 'setActiveRadio'
	    },
	    mounted: function mounted() {
	        this.setErrorState(this.hasError);
	        this.setActiveRadio();
	    },
	    methods: {
	        genDefaultSlot: function genDefaultSlot() {
	            return this.$createElement('div', {
	                staticClass: 'v-input--radio-group__input',
	                attrs: {
	                    role: 'radiogroup'
	                }
	            }, _VInput__WEBPACK_IMPORTED_MODULE_2__["default"].options.methods.genDefaultSlot.call(this));
	        },
	        onRadioChange: function onRadioChange(value) {
	            if (this.disabled) return;
	            this.hasInput = true;
	            this.internalValue = value;
	            this.setActiveRadio();
	            this.$nextTick(this.validate);
	        },
	        onRadioBlur: function onRadioBlur(e) {
	            if (!e.relatedTarget || !e.relatedTarget.classList.contains('v-radio')) {
	                this.hasInput = true;
	                this.$emit('blur', e);
	            }
	        },
	        register: function register(radio) {
	            radio.isActive = this.valueComparator(this.internalValue, radio.value);
	            radio.$on('change', this.onRadioChange);
	            radio.$on('blur', this.onRadioBlur);
	            this.radios.push(radio);
	        },
	        setErrorState: function setErrorState(val) {
	            for (var index = this.radios.length; --index >= 0;) {
	                this.radios[index].parentError = val;
	            }
	        },
	        setActiveRadio: function setActiveRadio() {
	            for (var index = this.radios.length; --index >= 0;) {
	                var radio = this.radios[index];
	                radio.isActive = this.valueComparator(this.internalValue, radio.value);
	            }
	        },
	        unregister: function unregister(radio) {
	            radio.$off('change', this.onRadioChange);
	            radio.$off('blur', this.onRadioBlur);
	            var index = this.radios.findIndex(function (r) {
	                return r === radio;
	            });
	            /* istanbul ignore else */
	            if (index > -1) this.radios.splice(index, 1);
	        }
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VRadioGroup/index.js":
	/*!*********************************************!*\
	  !*** ./src/components/VRadioGroup/index.js ***!
	  \*********************************************/
	/*! exports provided: VRadioGroup, VRadio, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VRadioGroup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VRadioGroup */ "./src/components/VRadioGroup/VRadioGroup.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VRadioGroup", function() { return _VRadioGroup__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	/* harmony import */ var _VRadio__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./VRadio */ "./src/components/VRadioGroup/VRadio.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VRadio", function() { return _VRadio__WEBPACK_IMPORTED_MODULE_1__["default"]; });
	
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = ({
	    $_vuetify_subcomponents: {
	        VRadioGroup: _VRadioGroup__WEBPACK_IMPORTED_MODULE_0__["default"],
	        VRadio: _VRadio__WEBPACK_IMPORTED_MODULE_1__["default"]
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VRangeSlider/VRangeSlider.js":
	/*!*****************************************************!*\
	  !*** ./src/components/VRangeSlider/VRangeSlider.js ***!
	  \*****************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_range_sliders_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_range-sliders.styl */ "./src/stylus/components/_range-sliders.styl");
	/* harmony import */ var _stylus_components_range_sliders_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_range_sliders_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _VSlider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../VSlider */ "./src/components/VSlider/index.js");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	// Styles
	
	// Extensions
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-range-slider',
	    extends: _VSlider__WEBPACK_IMPORTED_MODULE_1__["default"],
	    props: {
	        value: {
	            type: Array,
	            default: function _default() {
	                return [];
	            }
	        }
	    },
	    data: function data(vm) {
	        return {
	            activeThumb: null,
	            lazyValue: !vm.value.length ? [0, 0] : vm.value
	        };
	    },
	    computed: {
	        classes: function classes() {
	            return Object.assign({}, {
	                'v-input--range-slider': true
	            }, _VSlider__WEBPACK_IMPORTED_MODULE_1__["default"].options.computed.classes.call(this));
	        },
	        internalValue: {
	            get: function get() {
	                return this.lazyValue;
	            },
	            set: function set(val) {
	                var _this = this;
	                var _a = this,
	                    min = _a.min,
	                    max = _a.max;
	                // Round value to ensure the
	                // entire slider range can
	                // be selected with step
	                var value = val.map(function (v) {
	                    return _this.roundValue(Math.min(Math.max(v, min), max));
	                });
	                // Switch values if range and wrong order
	                if (value[0] > value[1] || value[1] < value[0]) {
	                    if (this.activeThumb !== null) this.activeThumb = this.activeThumb === 1 ? 0 : 1;
	                    value = [value[1], value[0]];
	                }
	                this.lazyValue = value;
	                if (!Object(_util_helpers__WEBPACK_IMPORTED_MODULE_2__["deepEqual"])(value, this.value)) this.$emit('input', value);
	                this.validate();
	            }
	        },
	        inputWidth: function inputWidth() {
	            var _this = this;
	            return this.internalValue.map(function (v) {
	                return (_this.roundValue(v) - _this.min) / (_this.max - _this.min) * 100;
	            });
	        },
	        isDirty: function isDirty() {
	            var _this = this;
	            return this.internalValue.some(function (v) {
	                return v !== _this.min;
	            }) || this.alwaysDirty;
	        },
	        trackFillStyles: function trackFillStyles() {
	            var styles = _VSlider__WEBPACK_IMPORTED_MODULE_1__["default"].options.computed.trackFillStyles.call(this);
	            var fillPercent = Math.abs(this.inputWidth[0] - this.inputWidth[1]);
	            styles.width = "calc(" + fillPercent + "% - " + this.trackPadding + "px)";
	            styles[this.$vuetify.rtl ? 'right' : 'left'] = this.inputWidth[0] + "%";
	            return styles;
	        },
	        trackPadding: function trackPadding() {
	            if (this.isDirty || this.internalValue[0]) return 0;
	            return _VSlider__WEBPACK_IMPORTED_MODULE_1__["default"].options.computed.trackPadding.call(this);
	        }
	    },
	    methods: {
	        getIndexOfClosestValue: function getIndexOfClosestValue(arr, v) {
	            if (Math.abs(arr[0] - v) < Math.abs(arr[1] - v)) return 0;else return 1;
	        },
	        genInput: function genInput() {
	            var _this = this;
	            return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_2__["createRange"])(2).map(function (i) {
	                var input = _VSlider__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.genInput.call(_this);
	                input.data.attrs.value = _this.internalValue[i];
	                input.data.on.focus = function (e) {
	                    _this.activeThumb = i;
	                    _VSlider__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.onFocus.call(_this, e);
	                };
	                return input;
	            });
	        },
	        genChildren: function genChildren() {
	            var _this = this;
	            return [this.genInput(), this.genTrackContainer(), this.genSteps(), Object(_util_helpers__WEBPACK_IMPORTED_MODULE_2__["createRange"])(2).map(function (i) {
	                var value = _this.internalValue[i];
	                var onDrag = function onDrag(e) {
	                    _this.isActive = true;
	                    _this.activeThumb = i;
	                    _this.onThumbMouseDown(e);
	                };
	                var valueWidth = _this.inputWidth[i];
	                var isActive = (_this.isFocused || _this.isActive) && _this.activeThumb === i;
	                return _this.genThumbContainer(value, valueWidth, isActive, onDrag);
	            })];
	        },
	        onSliderClick: function onSliderClick(e) {
	            if (!this.isActive) {
	                this.isFocused = true;
	                this.onMouseMove(e, true);
	                this.$emit('change', this.internalValue);
	            }
	        },
	        onMouseMove: function onMouseMove(e, trackClick) {
	            if (trackClick === void 0) {
	                trackClick = false;
	            }
	            var _a = this.parseMouseMove(e),
	                value = _a.value,
	                isInsideTrack = _a.isInsideTrack;
	            if (isInsideTrack) {
	                if (trackClick) this.activeThumb = this.getIndexOfClosestValue(this.internalValue, value);
	                this.setInternalValue(value);
	            }
	        },
	        onKeyDown: function onKeyDown(e) {
	            var value = this.parseKeyDown(e, this.internalValue[this.activeThumb]);
	            if (value == null) return;
	            this.setInternalValue(value);
	        },
	        setInternalValue: function setInternalValue(value) {
	            var _this = this;
	            this.internalValue = this.internalValue.map(function (v, i) {
	                if (i === _this.activeThumb) return value;else return Number(v);
	            });
	        }
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VRangeSlider/index.js":
	/*!**********************************************!*\
	  !*** ./src/components/VRangeSlider/index.js ***!
	  \**********************************************/
	/*! exports provided: VRangeSlider, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VRangeSlider__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VRangeSlider */ "./src/components/VRangeSlider/VRangeSlider.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VRangeSlider", function() { return _VRangeSlider__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VRangeSlider__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VRating/VRating.ts":
	/*!*******************************************!*\
	  !*** ./src/components/VRating/VRating.ts ***!
	  \*******************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_rating_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_rating.styl */ "./src/stylus/components/_rating.styl");
	/* harmony import */ var _stylus_components_rating_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_rating_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _VIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../VIcon */ "./src/components/VIcon/index.ts");
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _mixins_delayable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/delayable */ "./src/mixins/delayable.ts");
	/* harmony import */ var _mixins_sizeable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mixins/sizeable */ "./src/mixins/sizeable.ts");
	/* harmony import */ var _mixins_rippleable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mixins/rippleable */ "./src/mixins/rippleable.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	// Styles
	
	// Components
	
	// Mixins
	
	
	
	
	
	// Utilities
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_8__["default"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_2__["default"], _mixins_delayable__WEBPACK_IMPORTED_MODULE_3__["default"], _mixins_rippleable__WEBPACK_IMPORTED_MODULE_5__["default"], _mixins_sizeable__WEBPACK_IMPORTED_MODULE_4__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_6__["default"]).extend({
	    name: 'v-rating',
	    props: {
	        backgroundColor: {
	            type: String,
	            default: 'accent'
	        },
	        color: {
	            type: String,
	            default: 'primary'
	        },
	        dense: Boolean,
	        emptyIcon: {
	            type: String,
	            default: '$vuetify.icons.ratingEmpty'
	        },
	        fullIcon: {
	            type: String,
	            default: '$vuetify.icons.ratingFull'
	        },
	        halfIcon: {
	            type: String,
	            default: '$vuetify.icons.ratingHalf'
	        },
	        halfIncrements: Boolean,
	        length: {
	            type: [Number, String],
	            default: 5
	        },
	        clearable: Boolean,
	        readonly: Boolean,
	        hover: Boolean,
	        value: {
	            type: Number,
	            default: 0
	        }
	    },
	    data: function data() {
	        return {
	            hoverIndex: -1,
	            internalValue: this.value
	        };
	    },
	    computed: {
	        directives: function directives() {
	            if (this.readonly || !this.ripple) return [];
	            return [{
	                name: 'ripple',
	                value: { circle: true }
	            }];
	        },
	        iconProps: function iconProps() {
	            var _a = this.$props,
	                dark = _a.dark,
	                medium = _a.medium,
	                large = _a.large,
	                light = _a.light,
	                small = _a.small,
	                size = _a.size,
	                xLarge = _a.xLarge;
	            return {
	                dark: dark,
	                medium: medium,
	                large: large,
	                light: light,
	                size: size,
	                small: small,
	                xLarge: xLarge
	            };
	        },
	        isHovering: function isHovering() {
	            return this.hover && this.hoverIndex >= 0;
	        }
	    },
	    watch: {
	        internalValue: function internalValue(val) {
	            val !== this.value && this.$emit('input', val);
	        },
	        value: function value(val) {
	            this.internalValue = val;
	        }
	    },
	    methods: {
	        createClickFn: function createClickFn(i) {
	            var _this = this;
	            return function (e) {
	                if (_this.readonly) return;
	                var newValue = _this.genHoverIndex(e, i);
	                if (_this.clearable && _this.internalValue === newValue) {
	                    _this.internalValue = 0;
	                } else {
	                    _this.internalValue = newValue;
	                }
	            };
	        },
	        createProps: function createProps(i) {
	            var props = {
	                index: i,
	                value: this.internalValue,
	                click: this.createClickFn(i),
	                isFilled: Math.floor(this.internalValue) > i,
	                isHovered: Math.floor(this.hoverIndex) > i
	            };
	            if (this.halfIncrements) {
	                props.isHalfHovered = !props.isHovered && (this.hoverIndex - i) % 1 > 0;
	                props.isHalfFilled = !props.isFilled && (this.internalValue - i) % 1 > 0;
	            }
	            return props;
	        },
	        genHoverIndex: function genHoverIndex(e, i) {
	            return i + (this.isHalfEvent(e) ? 0.5 : 1);
	        },
	        getIconName: function getIconName(props) {
	            var isFull = this.isHovering ? props.isHovered : props.isFilled;
	            var isHalf = this.isHovering ? props.isHalfHovered : props.isHalfFilled;
	            return isFull ? this.fullIcon : isHalf ? this.halfIcon : this.emptyIcon;
	        },
	        getColor: function getColor(props) {
	            if (this.isHovering) {
	                if (props.isHovered || props.isHalfHovered) return this.color;
	            } else {
	                if (props.isFilled || props.isHalfFilled) return this.color;
	            }
	            return this.backgroundColor;
	        },
	        isHalfEvent: function isHalfEvent(e) {
	            if (this.halfIncrements) {
	                var rect = e.target && e.target.getBoundingClientRect();
	                if (rect && e.pageX - rect.left < rect.width / 2) return true;
	            }
	            return false;
	        },
	        onMouseEnter: function onMouseEnter(e, i) {
	            var _this = this;
	            this.runDelay('open', function () {
	                _this.hoverIndex = _this.genHoverIndex(e, i);
	            });
	        },
	        onMouseLeave: function onMouseLeave() {
	            var _this = this;
	            this.runDelay('close', function () {
	                return _this.hoverIndex = -1;
	            });
	        },
	        genItem: function genItem(i) {
	            var _this = this;
	            var props = this.createProps(i);
	            if (this.$scopedSlots.item) return this.$scopedSlots.item(props);
	            var listeners = {
	                click: props.click
	            };
	            if (this.hover) {
	                listeners.mouseenter = function (e) {
	                    return _this.onMouseEnter(e, i);
	                };
	                listeners.mouseleave = this.onMouseLeave;
	                if (this.halfIncrements) {
	                    listeners.mousemove = function (e) {
	                        return _this.onMouseEnter(e, i);
	                    };
	                }
	            }
	            return this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_1__["default"], this.setTextColor(this.getColor(props), {
	                directives: this.directives,
	                props: this.iconProps,
	                on: listeners
	            }), [this.getIconName(props)]);
	        }
	    },
	    render: function render(h) {
	        var _this = this;
	        var children = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["createRange"])(Number(this.length)).map(function (i) {
	            return _this.genItem(i);
	        });
	        return h('div', {
	            staticClass: 'v-rating',
	            class: {
	                'v-rating--readonly': this.readonly,
	                'v-rating--dense': this.dense
	            }
	        }, children);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VRating/index.ts":
	/*!*****************************************!*\
	  !*** ./src/components/VRating/index.ts ***!
	  \*****************************************/
	/*! exports provided: VRating, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VRating__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VRating */ "./src/components/VRating/VRating.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VRating", function() { return _VRating__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VRating__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VResponsive/VResponsive.ts":
	/*!***************************************************!*\
	  !*** ./src/components/VResponsive/VResponsive.ts ***!
	  \***************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_responsive_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_responsive.styl */ "./src/stylus/components/_responsive.styl");
	/* harmony import */ var _stylus_components_responsive_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_responsive_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_measurable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/measurable */ "./src/mixins/measurable.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	
	// Mixins
	
	// Utils
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_2__["default"])(_mixins_measurable__WEBPACK_IMPORTED_MODULE_1__["default"]).extend({
	    name: 'v-responsive',
	    props: {
	        aspectRatio: [String, Number]
	    },
	    computed: {
	        computedAspectRatio: function computedAspectRatio() {
	            return Number(this.aspectRatio);
	        },
	        aspectStyle: function aspectStyle() {
	            return this.computedAspectRatio ? { paddingBottom: 1 / this.computedAspectRatio * 100 + '%' } : undefined;
	        },
	        __cachedSizer: function __cachedSizer() {
	            if (!this.aspectStyle) return [];
	            return this.$createElement('div', {
	                style: this.aspectStyle,
	                staticClass: 'v-responsive__sizer'
	            });
	        }
	    },
	    methods: {
	        genContent: function genContent() {
	            return this.$createElement('div', {
	                staticClass: 'v-responsive__content'
	            }, this.$slots.default);
	        }
	    },
	    render: function render(h) {
	        return h('div', {
	            staticClass: 'v-responsive',
	            style: this.measurableStyles,
	            on: this.$listeners
	        }, [this.__cachedSizer, this.genContent()]);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VResponsive/index.ts":
	/*!*********************************************!*\
	  !*** ./src/components/VResponsive/index.ts ***!
	  \*********************************************/
	/*! exports provided: VResponsive, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VResponsive__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VResponsive */ "./src/components/VResponsive/VResponsive.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VResponsive", function() { return _VResponsive__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VResponsive__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VSelect/VSelect.js":
	/*!*******************************************!*\
	  !*** ./src/components/VSelect/VSelect.js ***!
	  \*******************************************/
	/*! exports provided: defaultMenuProps, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultMenuProps", function() { return defaultMenuProps; });
	/* harmony import */ var _stylus_components_text_fields_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_text-fields.styl */ "./src/stylus/components/_text-fields.styl");
	/* harmony import */ var _stylus_components_text_fields_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_text_fields_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _stylus_components_select_styl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../stylus/components/_select.styl */ "./src/stylus/components/_select.styl");
	/* harmony import */ var _stylus_components_select_styl__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_select_styl__WEBPACK_IMPORTED_MODULE_1__);
	/* harmony import */ var _VChip__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../VChip */ "./src/components/VChip/index.ts");
	/* harmony import */ var _VMenu__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../VMenu */ "./src/components/VMenu/index.js");
	/* harmony import */ var _VSelectList__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./VSelectList */ "./src/components/VSelect/VSelectList.js");
	/* harmony import */ var _VTextField_VTextField__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../VTextField/VTextField */ "./src/components/VTextField/VTextField.js");
	/* harmony import */ var _mixins_comparable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mixins/comparable */ "./src/mixins/comparable.ts");
	/* harmony import */ var _mixins_filterable__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mixins/filterable */ "./src/mixins/filterable.ts");
	/* harmony import */ var _directives_click_outside__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../directives/click-outside */ "./src/directives/click-outside.ts");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../util/console */ "./src/util/console.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var __values = undefined && undefined.__values || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator],
	        i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function next() {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	// Styles
	
	
	// Components
	
	
	
	// Extensions
	
	// Mixins
	
	
	// Directives
	
	// Helpers
	
	
	var defaultMenuProps = {
	    closeOnClick: false,
	    closeOnContentClick: false,
	    openOnClick: false,
	    maxHeight: 300
	};
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (_VTextField_VTextField__WEBPACK_IMPORTED_MODULE_5__["default"].extend({
	    name: 'v-select',
	    directives: {
	        ClickOutside: _directives_click_outside__WEBPACK_IMPORTED_MODULE_8__["default"]
	    },
	    mixins: [_mixins_comparable__WEBPACK_IMPORTED_MODULE_6__["default"], _mixins_filterable__WEBPACK_IMPORTED_MODULE_7__["default"]],
	    props: {
	        appendIcon: {
	            type: String,
	            default: '$vuetify.icons.dropdown'
	        },
	        appendIconCb: Function,
	        attach: {
	            type: null,
	            default: false
	        },
	        browserAutocomplete: {
	            type: String,
	            default: 'on'
	        },
	        cacheItems: Boolean,
	        chips: Boolean,
	        clearable: Boolean,
	        deletableChips: Boolean,
	        dense: Boolean,
	        hideSelected: Boolean,
	        items: {
	            type: Array,
	            default: function _default() {
	                return [];
	            }
	        },
	        itemAvatar: {
	            type: [String, Array, Function],
	            default: 'avatar'
	        },
	        itemDisabled: {
	            type: [String, Array, Function],
	            default: 'disabled'
	        },
	        itemText: {
	            type: [String, Array, Function],
	            default: 'text'
	        },
	        itemValue: {
	            type: [String, Array, Function],
	            default: 'value'
	        },
	        menuProps: {
	            type: [String, Array, Object],
	            default: function _default() {
	                return defaultMenuProps;
	            }
	        },
	        multiple: Boolean,
	        openOnClear: Boolean,
	        returnObject: Boolean,
	        searchInput: {
	            default: null
	        },
	        smallChips: Boolean
	    },
	    data: function data(vm) {
	        return {
	            attrsInput: { role: 'combobox' },
	            cachedItems: vm.cacheItems ? vm.items : [],
	            content: null,
	            isBooted: false,
	            isMenuActive: false,
	            lastItem: 20,
	            // As long as a value is defined, show it
	            // Otherwise, check if multiple
	            // to determine which default to provide
	            lazyValue: vm.value !== undefined ? vm.value : vm.multiple ? [] : undefined,
	            selectedIndex: -1,
	            selectedItems: [],
	            keyboardLookupPrefix: '',
	            keyboardLookupLastTime: 0
	        };
	    },
	    computed: {
	        /* All items that the select has */
	        allItems: function allItems() {
	            return this.filterDuplicates(this.cachedItems.concat(this.items));
	        },
	        classes: function classes() {
	            return Object.assign({}, _VTextField_VTextField__WEBPACK_IMPORTED_MODULE_5__["default"].options.computed.classes.call(this), {
	                'v-select': true,
	                'v-select--chips': this.hasChips,
	                'v-select--chips--small': this.smallChips,
	                'v-select--is-menu-active': this.isMenuActive
	            });
	        },
	        /* Used by other components to overwrite */
	        computedItems: function computedItems() {
	            return this.allItems;
	        },
	        counterValue: function counterValue() {
	            return this.multiple ? this.selectedItems.length : (this.getText(this.selectedItems[0]) || '').toString().length;
	        },
	        directives: function directives() {
	            return this.isFocused ? [{
	                name: 'click-outside',
	                value: this.blur,
	                args: {
	                    closeConditional: this.closeConditional
	                }
	            }] : undefined;
	        },
	        dynamicHeight: function dynamicHeight() {
	            return 'auto';
	        },
	        hasChips: function hasChips() {
	            return this.chips || this.smallChips;
	        },
	        hasSlot: function hasSlot() {
	            return Boolean(this.hasChips || this.$scopedSlots.selection);
	        },
	        isDirty: function isDirty() {
	            return this.selectedItems.length > 0;
	        },
	        listData: function listData() {
	            var _a;
	            var scopeId = this.$vnode && this.$vnode.context.$options._scopeId;
	            return {
	                attrs: scopeId ? (_a = {}, _a[scopeId] = true, _a) : null,
	                props: {
	                    action: this.multiple && !this.isHidingSelected,
	                    color: this.color,
	                    dense: this.dense,
	                    hideSelected: this.hideSelected,
	                    items: this.virtualizedItems,
	                    noDataText: this.$vuetify.t(this.noDataText),
	                    selectedItems: this.selectedItems,
	                    itemAvatar: this.itemAvatar,
	                    itemDisabled: this.itemDisabled,
	                    itemValue: this.itemValue,
	                    itemText: this.itemText
	                },
	                on: {
	                    select: this.selectItem
	                },
	                scopedSlots: {
	                    item: this.$scopedSlots.item
	                }
	            };
	        },
	        staticList: function staticList() {
	            if (this.$slots['no-data'] || this.$slots['prepend-item'] || this.$slots['append-item']) {
	                Object(_util_console__WEBPACK_IMPORTED_MODULE_10__["consoleError"])('assert: staticList should not be called if slots are used');
	            }
	            return this.$createElement(_VSelectList__WEBPACK_IMPORTED_MODULE_4__["default"], this.listData);
	        },
	        virtualizedItems: function virtualizedItems() {
	            return this.$_menuProps.auto ? this.computedItems : this.computedItems.slice(0, this.lastItem);
	        },
	        menuCanShow: function menuCanShow() {
	            return true;
	        },
	        $_menuProps: function $_menuProps() {
	            var normalisedProps;
	            normalisedProps = typeof this.menuProps === 'string' ? this.menuProps.split(',') : this.menuProps;
	            if (Array.isArray(normalisedProps)) {
	                normalisedProps = normalisedProps.reduce(function (acc, p) {
	                    acc[p.trim()] = true;
	                    return acc;
	                }, {});
	            }
	            return __assign({}, defaultMenuProps, { value: this.menuCanShow && this.isMenuActive, nudgeBottom: this.nudgeBottom ? this.nudgeBottom : normalisedProps.offsetY ? 1 : 0 }, normalisedProps);
	        }
	    },
	    watch: {
	        internalValue: function internalValue(val) {
	            this.initialValue = val;
	            this.setSelectedItems();
	        },
	        isBooted: function isBooted() {
	            var _this = this;
	            this.$nextTick(function () {
	                if (_this.content && _this.content.addEventListener) {
	                    _this.content.addEventListener('scroll', _this.onScroll, false);
	                }
	            });
	        },
	        isMenuActive: function isMenuActive(val) {
	            if (!val) return;
	            this.isBooted = true;
	        },
	        items: {
	            immediate: true,
	            handler: function handler(val) {
	                if (this.cacheItems) {
	                    this.cachedItems = this.filterDuplicates(this.cachedItems.concat(val));
	                }
	                this.setSelectedItems();
	            }
	        }
	    },
	    mounted: function mounted() {
	        this.content = this.$refs.menu && this.$refs.menu.$refs.content;
	    },
	    methods: {
	        /** @public */
	        blur: function blur(e) {
	            this.isMenuActive = false;
	            this.isFocused = false;
	            this.$refs.input && this.$refs.input.blur();
	            this.selectedIndex = -1;
	            this.onBlur(e);
	        },
	        /** @public */
	        activateMenu: function activateMenu() {
	            this.isMenuActive = true;
	        },
	        clearableCallback: function clearableCallback() {
	            var _this = this;
	            this.setValue(this.multiple ? [] : undefined);
	            this.$nextTick(function () {
	                return _this.$refs.input.focus();
	            });
	            if (this.openOnClear) this.isMenuActive = true;
	        },
	        closeConditional: function closeConditional(e) {
	            return (
	                // Click originates from outside the menu content
	                !!this.content && !this.content.contains(e.target) &&
	                // Click originates from outside the element
	                !!this.$el && !this.$el.contains(e.target) && e.target !== this.$el
	            );
	        },
	        filterDuplicates: function filterDuplicates(arr) {
	            var uniqueValues = new Map();
	            for (var index = 0; index < arr.length; ++index) {
	                var item = arr[index];
	                var val = this.getValue(item);
	                // TODO: comparator
	                !uniqueValues.has(val) && uniqueValues.set(val, item);
	            }
	            return Array.from(uniqueValues.values());
	        },
	        findExistingIndex: function findExistingIndex(item) {
	            var _this = this;
	            var itemValue = this.getValue(item);
	            return (this.internalValue || []).findIndex(function (i) {
	                return _this.valueComparator(_this.getValue(i), itemValue);
	            });
	        },
	        genChipSelection: function genChipSelection(item, index) {
	            var _this = this;
	            var isDisabled = this.disabled || this.readonly || this.getDisabled(item);
	            return this.$createElement(_VChip__WEBPACK_IMPORTED_MODULE_2__["default"], {
	                staticClass: 'v-chip--select-multi',
	                attrs: { tabindex: -1 },
	                props: {
	                    close: this.deletableChips && !isDisabled,
	                    disabled: isDisabled,
	                    selected: index === this.selectedIndex,
	                    small: this.smallChips
	                },
	                on: {
	                    click: function click(e) {
	                        if (isDisabled) return;
	                        e.stopPropagation();
	                        _this.selectedIndex = index;
	                    },
	                    input: function input() {
	                        return _this.onChipInput(item);
	                    }
	                },
	                key: this.getValue(item)
	            }, this.getText(item));
	        },
	        genCommaSelection: function genCommaSelection(item, index, last) {
	            // Item may be an object
	            // TODO: Remove JSON.stringify
	            var key = JSON.stringify(this.getValue(item));
	            var color = index === this.selectedIndex && this.color;
	            var isDisabled = this.disabled || this.getDisabled(item);
	            return this.$createElement('div', this.setTextColor(color, {
	                staticClass: 'v-select__selection v-select__selection--comma',
	                'class': {
	                    'v-select__selection--disabled': isDisabled
	                },
	                key: key
	            }), "" + this.getText(item) + (last ? '' : ', '));
	        },
	        genDefaultSlot: function genDefaultSlot() {
	            var selections = this.genSelections();
	            var input = this.genInput();
	            // If the return is an empty array
	            // push the input
	            if (Array.isArray(selections)) {
	                selections.push(input);
	                // Otherwise push it into children
	            } else {
	                selections.children = selections.children || [];
	                selections.children.push(input);
	            }
	            return [this.$createElement('div', {
	                staticClass: 'v-select__slot',
	                directives: this.directives
	            }, [this.genLabel(), this.prefix ? this.genAffix('prefix') : null, selections, this.suffix ? this.genAffix('suffix') : null, this.genClearIcon(), this.genIconSlot()]), this.genMenu(), this.genProgress()];
	        },
	        genInput: function genInput() {
	            var input = _VTextField_VTextField__WEBPACK_IMPORTED_MODULE_5__["default"].options.methods.genInput.call(this);
	            input.data.domProps.value = null;
	            input.data.attrs.readonly = true;
	            input.data.attrs['aria-readonly'] = String(this.readonly);
	            input.data.on.keypress = this.onKeyPress;
	            return input;
	        },
	        genList: function genList() {
	            // If there's no slots, we can use a cached VNode to improve performance
	            if (this.$slots['no-data'] || this.$slots['prepend-item'] || this.$slots['append-item']) {
	                return this.genListWithSlot();
	            } else {
	                return this.staticList;
	            }
	        },
	        genListWithSlot: function genListWithSlot() {
	            var _this = this;
	            var slots = ['prepend-item', 'no-data', 'append-item'].filter(function (slotName) {
	                return _this.$slots[slotName];
	            }).map(function (slotName) {
	                return _this.$createElement('template', {
	                    slot: slotName
	                }, _this.$slots[slotName]);
	            });
	            // Requires destructuring due to Vue
	            // modifying the `on` property when passed
	            // as a referenced object
	            return this.$createElement(_VSelectList__WEBPACK_IMPORTED_MODULE_4__["default"], __assign({}, this.listData), slots);
	        },
	        genMenu: function genMenu() {
	            var _this = this;
	            var e_1, _a;
	            var props = this.$_menuProps;
	            props.activator = this.$refs['input-slot'];
	            // Deprecate using menu props directly
	            // TODO: remove (2.0)
	            var inheritedProps = Object.keys(_VMenu__WEBPACK_IMPORTED_MODULE_3__["default"].options.props);
	            var deprecatedProps = Object.keys(this.$attrs).reduce(function (acc, attr) {
	                if (inheritedProps.includes(Object(_util_helpers__WEBPACK_IMPORTED_MODULE_9__["camelize"])(attr))) acc.push(attr);
	                return acc;
	            }, []);
	            try {
	                for (var deprecatedProps_1 = __values(deprecatedProps), deprecatedProps_1_1 = deprecatedProps_1.next(); !deprecatedProps_1_1.done; deprecatedProps_1_1 = deprecatedProps_1.next()) {
	                    var prop = deprecatedProps_1_1.value;
	                    props[Object(_util_helpers__WEBPACK_IMPORTED_MODULE_9__["camelize"])(prop)] = this.$attrs[prop];
	                }
	            } catch (e_1_1) {
	                e_1 = { error: e_1_1 };
	            } finally {
	                try {
	                    if (deprecatedProps_1_1 && !deprecatedProps_1_1.done && (_a = deprecatedProps_1.return)) _a.call(deprecatedProps_1);
	                } finally {
	                    if (e_1) throw e_1.error;
	                }
	            }
	            if (true) {
	                if (deprecatedProps.length) {
	                    var multiple = deprecatedProps.length > 1;
	                    var replacement_1 = deprecatedProps.reduce(function (acc, p) {
	                        acc[Object(_util_helpers__WEBPACK_IMPORTED_MODULE_9__["camelize"])(p)] = _this.$attrs[p];
	                        return acc;
	                    }, {});
	                    var props_1 = deprecatedProps.map(function (p) {
	                        return "'" + p + "'";
	                    }).join(', ');
	                    var separator = multiple ? '\n' : '\'';
	                    var onlyBools = Object.keys(replacement_1).every(function (prop) {
	                        var propType = _VMenu__WEBPACK_IMPORTED_MODULE_3__["default"].options.props[prop];
	                        var value = replacement_1[prop];
	                        return value === true || (propType.type || propType) === Boolean && value === '';
	                    });
	                    if (onlyBools) {
	                        replacement_1 = Object.keys(replacement_1).join(', ');
	                    } else {
	                        replacement_1 = JSON.stringify(replacement_1, null, multiple ? 2 : 0).replace(/"([^(")"]+)":/g, '$1:').replace(/"/g, '\'');
	                    }
	                    Object(_util_console__WEBPACK_IMPORTED_MODULE_10__["consoleWarn"])(props_1 + " " + (multiple ? 'are' : 'is') + " deprecated, use " + ("" + separator + (onlyBools ? '' : ':') + "menu-props=\"" + replacement_1 + "\"" + separator + " instead"), this);
	                }
	            }
	            // Attach to root el so that
	            // menu covers prepend/append icons
	            if (
	            // TODO: make this a computed property or helper or something
	            this.attach === '' || // If used as a boolean prop (<v-menu attach>)
	            this.attach === true || // If bound to a boolean (<v-menu :attach="true">)
	            this.attach === 'attach' // If bound as boolean prop in pug (v-menu(attach))
	            ) {
	                    props.attach = this.$el;
	                } else {
	                props.attach = this.attach;
	            }
	            return this.$createElement(_VMenu__WEBPACK_IMPORTED_MODULE_3__["default"], {
	                props: props,
	                on: {
	                    input: function input(val) {
	                        _this.isMenuActive = val;
	                        _this.isFocused = val;
	                    }
	                },
	                ref: 'menu'
	            }, [this.genList()]);
	        },
	        genSelections: function genSelections() {
	            var length = this.selectedItems.length;
	            var children = new Array(length);
	            var genSelection;
	            if (this.$scopedSlots.selection) {
	                genSelection = this.genSlotSelection;
	            } else if (this.hasChips) {
	                genSelection = this.genChipSelection;
	            } else {
	                genSelection = this.genCommaSelection;
	            }
	            while (length--) {
	                children[length] = genSelection(this.selectedItems[length], length, length === children.length - 1);
	            }
	            return this.$createElement('div', {
	                staticClass: 'v-select__selections'
	            }, children);
	        },
	        genSlotSelection: function genSlotSelection(item, index) {
	            return this.$scopedSlots.selection({
	                parent: this,
	                item: item,
	                index: index,
	                selected: index === this.selectedIndex,
	                disabled: this.disabled || this.readonly
	            });
	        },
	        getMenuIndex: function getMenuIndex() {
	            return this.$refs.menu ? this.$refs.menu.listIndex : -1;
	        },
	        getDisabled: function getDisabled(item) {
	            return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_9__["getPropertyFromItem"])(item, this.itemDisabled, false);
	        },
	        getText: function getText(item) {
	            return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_9__["getPropertyFromItem"])(item, this.itemText, item);
	        },
	        getValue: function getValue(item) {
	            return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_9__["getPropertyFromItem"])(item, this.itemValue, this.getText(item));
	        },
	        onBlur: function onBlur(e) {
	            this.$emit('blur', e);
	        },
	        onChipInput: function onChipInput(item) {
	            if (this.multiple) this.selectItem(item);else this.setValue(null);
	            // If all items have been deleted,
	            // open `v-menu`
	            if (this.selectedItems.length === 0) {
	                this.isMenuActive = true;
	            } else {
	                this.isMenuActive = false;
	            }
	            this.selectedIndex = -1;
	        },
	        onClick: function onClick() {
	            if (this.isDisabled) return;
	            this.isMenuActive = true;
	            if (!this.isFocused) {
	                this.isFocused = true;
	                this.$emit('focus');
	            }
	        },
	        onEnterDown: function onEnterDown() {
	            this.onBlur();
	        },
	        onEscDown: function onEscDown(e) {
	            e.preventDefault();
	            if (this.isMenuActive) {
	                e.stopPropagation();
	                this.isMenuActive = false;
	            }
	        },
	        onKeyPress: function onKeyPress(e) {
	            var _this = this;
	            if (this.multiple) return;
	            var KEYBOARD_LOOKUP_THRESHOLD = 1000; // milliseconds
	            var now = performance.now();
	            if (now - this.keyboardLookupLastTime > KEYBOARD_LOOKUP_THRESHOLD) {
	                this.keyboardLookupPrefix = '';
	            }
	            this.keyboardLookupPrefix += e.key.toLowerCase();
	            this.keyboardLookupLastTime = now;
	            var index = this.allItems.findIndex(function (item) {
	                return _this.getText(item).toLowerCase().startsWith(_this.keyboardLookupPrefix);
	            });
	            var item = this.allItems[index];
	            if (index !== -1) {
	                this.setValue(this.returnObject ? item : this.getValue(item));
	                setTimeout(function () {
	                    return _this.setMenuIndex(index);
	                });
	            }
	        },
	        onKeyDown: function onKeyDown(e) {
	            var keyCode = e.keyCode;
	            // If enter, space, up, or down is pressed, open menu
	            if (!this.readonly && !this.isMenuActive && [_util_helpers__WEBPACK_IMPORTED_MODULE_9__["keyCodes"].enter, _util_helpers__WEBPACK_IMPORTED_MODULE_9__["keyCodes"].space, _util_helpers__WEBPACK_IMPORTED_MODULE_9__["keyCodes"].up, _util_helpers__WEBPACK_IMPORTED_MODULE_9__["keyCodes"].down].includes(keyCode)) this.activateMenu();
	            if (this.isMenuActive && this.$refs.menu) this.$refs.menu.changeListIndex(e);
	            // This should do something different
	            if (keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_9__["keyCodes"].enter) return this.onEnterDown(e);
	            // If escape deactivate the menu
	            if (keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_9__["keyCodes"].esc) return this.onEscDown(e);
	            // If tab - select item or close menu
	            if (keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_9__["keyCodes"].tab) return this.onTabDown(e);
	        },
	        onMouseUp: function onMouseUp(e) {
	            var _this = this;
	            if (this.hasMouseDown) {
	                var appendInner = this.$refs['append-inner'];
	                // If append inner is present
	                // and the target is itself
	                // or inside, toggle menu
	                if (this.isMenuActive && appendInner && (appendInner === e.target || appendInner.contains(e.target))) {
	                    this.$nextTick(function () {
	                        return _this.isMenuActive = !_this.isMenuActive;
	                    });
	                    // If user is clicking in the container
	                    // and field is enclosed, activate it
	                } else if (this.isEnclosed && !this.isDisabled) {
	                    this.isMenuActive = true;
	                }
	            }
	            _VTextField_VTextField__WEBPACK_IMPORTED_MODULE_5__["default"].options.methods.onMouseUp.call(this, e);
	        },
	        onScroll: function onScroll() {
	            var _this = this;
	            if (!this.isMenuActive) {
	                requestAnimationFrame(function () {
	                    return _this.content.scrollTop = 0;
	                });
	            } else {
	                if (this.lastItem >= this.computedItems.length) return;
	                var showMoreItems = this.content.scrollHeight - (this.content.scrollTop + this.content.clientHeight) < 200;
	                if (showMoreItems) {
	                    this.lastItem += 20;
	                }
	            }
	        },
	        onTabDown: function onTabDown(e) {
	            var menuIndex = this.getMenuIndex();
	            var listTile = this.$refs.menu.tiles[menuIndex];
	            // An item that is selected by
	            // menu-index should toggled
	            if (listTile && listTile.className.indexOf('v-list__tile--highlighted') > -1 && this.isMenuActive && menuIndex > -1) {
	                e.preventDefault();
	                e.stopPropagation();
	                listTile.click();
	            } else {
	                // If we make it here,
	                // the user has no selected indexes
	                // and is probably tabbing out
	                this.blur(e);
	            }
	        },
	        selectItem: function selectItem(item) {
	            var _this = this;
	            if (!this.multiple) {
	                this.setValue(this.returnObject ? item : this.getValue(item));
	                this.isMenuActive = false;
	            } else {
	                var internalValue = (this.internalValue || []).slice();
	                var i = this.findExistingIndex(item);
	                i !== -1 ? internalValue.splice(i, 1) : internalValue.push(item);
	                this.setValue(internalValue.map(function (i) {
	                    return _this.returnObject ? i : _this.getValue(i);
	                }));
	                // When selecting multiple
	                // adjust menu after each
	                // selection
	                this.$nextTick(function () {
	                    _this.$refs.menu && _this.$refs.menu.updateDimensions();
	                });
	            }
	        },
	        setMenuIndex: function setMenuIndex(index) {
	            this.$refs.menu && (this.$refs.menu.listIndex = index);
	        },
	        setSelectedItems: function setSelectedItems() {
	            var _this = this;
	            var e_2, _a;
	            var selectedItems = [];
	            var values = !this.multiple || !Array.isArray(this.internalValue) ? [this.internalValue] : this.internalValue;
	            var _loop_1 = function _loop_1(value) {
	                var index = this_1.allItems.findIndex(function (v) {
	                    return _this.valueComparator(_this.getValue(v), _this.getValue(value));
	                });
	                if (index > -1) {
	                    selectedItems.push(this_1.allItems[index]);
	                }
	            };
	            var this_1 = this;
	            try {
	                for (var values_1 = __values(values), values_1_1 = values_1.next(); !values_1_1.done; values_1_1 = values_1.next()) {
	                    var value = values_1_1.value;
	                    _loop_1(value);
	                }
	            } catch (e_2_1) {
	                e_2 = { error: e_2_1 };
	            } finally {
	                try {
	                    if (values_1_1 && !values_1_1.done && (_a = values_1.return)) _a.call(values_1);
	                } finally {
	                    if (e_2) throw e_2.error;
	                }
	            }
	            this.selectedItems = selectedItems;
	        },
	        setValue: function setValue(value) {
	            var oldValue = this.internalValue;
	            this.internalValue = value;
	            value !== oldValue && this.$emit('change', value);
	        }
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VSelect/VSelectList.js":
	/*!***********************************************!*\
	  !*** ./src/components/VSelect/VSelectList.js ***!
	  \***********************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_cards_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_cards.styl */ "./src/stylus/components/_cards.styl");
	/* harmony import */ var _stylus_components_cards_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_cards_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _VCheckbox__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../VCheckbox */ "./src/components/VCheckbox/index.js");
	/* harmony import */ var _VDivider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../VDivider */ "./src/components/VDivider/index.ts");
	/* harmony import */ var _VSubheader__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../VSubheader */ "./src/components/VSubheader/index.ts");
	/* harmony import */ var _VList__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../VList */ "./src/components/VList/index.ts");
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	var __values = undefined && undefined.__values || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator],
	        i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function next() {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	
	// Components
	
	
	
	
	// Mixins
	
	
	// Helpers
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-select-list',
	    mixins: [_mixins_colorable__WEBPACK_IMPORTED_MODULE_5__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_6__["default"]],
	    props: {
	        action: Boolean,
	        dense: Boolean,
	        hideSelected: Boolean,
	        items: {
	            type: Array,
	            default: function _default() {
	                return [];
	            }
	        },
	        itemAvatar: {
	            type: [String, Array, Function],
	            default: 'avatar'
	        },
	        itemDisabled: {
	            type: [String, Array, Function],
	            default: 'disabled'
	        },
	        itemText: {
	            type: [String, Array, Function],
	            default: 'text'
	        },
	        itemValue: {
	            type: [String, Array, Function],
	            default: 'value'
	        },
	        noDataText: String,
	        noFilter: Boolean,
	        searchInput: {
	            default: null
	        },
	        selectedItems: {
	            type: Array,
	            default: function _default() {
	                return [];
	            }
	        }
	    },
	    computed: {
	        parsedItems: function parsedItems() {
	            var _this = this;
	            return this.selectedItems.map(function (item) {
	                return _this.getValue(item);
	            });
	        },
	        tileActiveClass: function tileActiveClass() {
	            return Object.keys(this.setTextColor(this.color).class || {}).join(' ');
	        },
	        staticNoDataTile: function staticNoDataTile() {
	            var tile = {
	                on: {
	                    mousedown: function mousedown(e) {
	                        return e.preventDefault();
	                    } // Prevent onBlur from being called
	                }
	            };
	            return this.$createElement(_VList__WEBPACK_IMPORTED_MODULE_4__["VListTile"], tile, [this.genTileContent(this.noDataText)]);
	        }
	    },
	    methods: {
	        genAction: function genAction(item, inputValue) {
	            var _this = this;
	            var data = {
	                on: {
	                    click: function click(e) {
	                        e.stopPropagation();
	                        _this.$emit('select', item);
	                    }
	                }
	            };
	            return this.$createElement(_VList__WEBPACK_IMPORTED_MODULE_4__["VListTileAction"], data, [this.$createElement(_VCheckbox__WEBPACK_IMPORTED_MODULE_1__["default"], {
	                props: {
	                    color: this.color,
	                    inputValue: inputValue
	                }
	            })]);
	        },
	        genDivider: function genDivider(props) {
	            return this.$createElement(_VDivider__WEBPACK_IMPORTED_MODULE_2__["default"], { props: props });
	        },
	        genFilteredText: function genFilteredText(text) {
	            text = (text || '').toString();
	            if (!this.searchInput || this.noFilter) return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["escapeHTML"])(text);
	            var _a = this.getMaskedCharacters(text),
	                start = _a.start,
	                middle = _a.middle,
	                end = _a.end;
	            return "" + Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["escapeHTML"])(start) + this.genHighlight(middle) + Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["escapeHTML"])(end);
	        },
	        genHeader: function genHeader(props) {
	            return this.$createElement(_VSubheader__WEBPACK_IMPORTED_MODULE_3__["default"], { props: props }, props.header);
	        },
	        genHighlight: function genHighlight(text) {
	            return "<span class=\"v-list__tile__mask\">" + Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["escapeHTML"])(text) + "</span>";
	        },
	        getMaskedCharacters: function getMaskedCharacters(text) {
	            var searchInput = (this.searchInput || '').toString().toLocaleLowerCase();
	            var index = text.toLocaleLowerCase().indexOf(searchInput);
	            if (index < 0) return { start: '', middle: text, end: '' };
	            var start = text.slice(0, index);
	            var middle = text.slice(index, index + searchInput.length);
	            var end = text.slice(index + searchInput.length);
	            return { start: start, middle: middle, end: end };
	        },
	        genTile: function genTile(item, disabled, avatar, value) {
	            var _this = this;
	            if (disabled === void 0) {
	                disabled = null;
	            }
	            if (avatar === void 0) {
	                avatar = false;
	            }
	            if (value === void 0) {
	                value = this.hasItem(item);
	            }
	            if (item === Object(item)) {
	                avatar = this.getAvatar(item);
	                disabled = disabled !== null ? disabled : this.getDisabled(item);
	            }
	            var tile = {
	                on: {
	                    mousedown: function mousedown(e) {
	                        // Prevent onBlur from being called
	                        e.preventDefault();
	                    },
	                    click: function click() {
	                        return disabled || _this.$emit('select', item);
	                    }
	                },
	                props: {
	                    activeClass: this.tileActiveClass,
	                    avatar: avatar,
	                    disabled: disabled,
	                    ripple: true,
	                    value: value,
	                    color: this.color
	                }
	            };
	            if (!this.$scopedSlots.item) {
	                return this.$createElement(_VList__WEBPACK_IMPORTED_MODULE_4__["VListTile"], tile, [this.action && !this.hideSelected && this.items.length > 0 ? this.genAction(item, value) : null, this.genTileContent(item)]);
	            }
	            var parent = this;
	            var scopedSlot = this.$scopedSlots.item({ parent: parent, item: item, tile: tile });
	            return this.needsTile(scopedSlot) ? this.$createElement(_VList__WEBPACK_IMPORTED_MODULE_4__["VListTile"], tile, scopedSlot) : scopedSlot;
	        },
	        genTileContent: function genTileContent(item) {
	            var innerHTML = this.genFilteredText(this.getText(item));
	            return this.$createElement(_VList__WEBPACK_IMPORTED_MODULE_4__["VListTileContent"], [this.$createElement(_VList__WEBPACK_IMPORTED_MODULE_4__["VListTileTitle"], {
	                domProps: { innerHTML: innerHTML }
	            })]);
	        },
	        hasItem: function hasItem(item) {
	            return this.parsedItems.indexOf(this.getValue(item)) > -1;
	        },
	        needsTile: function needsTile(slot) {
	            return slot.length !== 1 || slot[0].componentOptions == null || slot[0].componentOptions.Ctor.options.name !== 'v-list-tile';
	        },
	        getAvatar: function getAvatar(item) {
	            return Boolean(Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["getPropertyFromItem"])(item, this.itemAvatar, false));
	        },
	        getDisabled: function getDisabled(item) {
	            return Boolean(Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["getPropertyFromItem"])(item, this.itemDisabled, false));
	        },
	        getText: function getText(item) {
	            return String(Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["getPropertyFromItem"])(item, this.itemText, item));
	        },
	        getValue: function getValue(item) {
	            return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["getPropertyFromItem"])(item, this.itemValue, this.getText(item));
	        }
	    },
	    render: function render() {
	        var e_1, _a;
	        var children = [];
	        try {
	            for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
	                var item = _c.value;
	                if (this.hideSelected && this.hasItem(item)) continue;
	                if (item == null) children.push(this.genTile(item));else if (item.header) children.push(this.genHeader(item));else if (item.divider) children.push(this.genDivider(item));else children.push(this.genTile(item));
	            }
	        } catch (e_1_1) {
	            e_1 = { error: e_1_1 };
	        } finally {
	            try {
	                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	            } finally {
	                if (e_1) throw e_1.error;
	            }
	        }
	        children.length || children.push(this.$slots['no-data'] || this.staticNoDataTile);
	        this.$slots['prepend-item'] && children.unshift(this.$slots['prepend-item']);
	        this.$slots['append-item'] && children.push(this.$slots['append-item']);
	        return this.$createElement('div', {
	            staticClass: 'v-select-list v-card',
	            'class': this.themeClasses
	        }, [this.$createElement(_VList__WEBPACK_IMPORTED_MODULE_4__["VList"], {
	            props: {
	                dense: this.dense
	            }
	        }, children)]);
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VSelect/index.js":
	/*!*****************************************!*\
	  !*** ./src/components/VSelect/index.js ***!
	  \*****************************************/
	/*! exports provided: VSelect, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VSelect", function() { return wrapper; });
	/* harmony import */ var _VSelect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VSelect */ "./src/components/VSelect/VSelect.js");
	/* harmony import */ var _VOverflowBtn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../VOverflowBtn */ "./src/components/VOverflowBtn/index.js");
	/* harmony import */ var _VAutocomplete__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../VAutocomplete */ "./src/components/VAutocomplete/index.js");
	/* harmony import */ var _VCombobox__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../VCombobox */ "./src/components/VCombobox/index.js");
	/* harmony import */ var _util_rebuildFunctionalSlots__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../util/rebuildFunctionalSlots */ "./src/util/rebuildFunctionalSlots.ts");
	/* harmony import */ var _util_dedupeModelListeners__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../util/dedupeModelListeners */ "./src/util/dedupeModelListeners.ts");
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../util/console */ "./src/util/console.ts");
	
	
	
	
	
	
	
	/* @vue/component */
	var wrapper = {
	    functional: true,
	    $_wrapperFor: _VSelect__WEBPACK_IMPORTED_MODULE_0__["default"],
	    props: {
	        // VAutoComplete
	        /** @deprecated */
	        autocomplete: Boolean,
	        /** @deprecated */
	        combobox: Boolean,
	        multiple: Boolean,
	        /** @deprecated */
	        tags: Boolean,
	        // VOverflowBtn
	        /** @deprecated */
	        editable: Boolean,
	        /** @deprecated */
	        overflow: Boolean,
	        /** @deprecated */
	        segmented: Boolean
	    },
	    render: function render(h, _a) {
	        var props = _a.props,
	            data = _a.data,
	            slots = _a.slots,
	            parent = _a.parent;
	        Object(_util_dedupeModelListeners__WEBPACK_IMPORTED_MODULE_5__["default"])(data);
	        var children = Object(_util_rebuildFunctionalSlots__WEBPACK_IMPORTED_MODULE_4__["default"])(slots(), h);
	        if (props.autocomplete) {
	            Object(_util_console__WEBPACK_IMPORTED_MODULE_6__["deprecate"])('<v-select autocomplete>', '<v-autocomplete>', wrapper, parent);
	        }
	        if (props.combobox) {
	            Object(_util_console__WEBPACK_IMPORTED_MODULE_6__["deprecate"])('<v-select combobox>', '<v-combobox>', wrapper, parent);
	        }
	        if (props.tags) {
	            Object(_util_console__WEBPACK_IMPORTED_MODULE_6__["deprecate"])('<v-select tags>', '<v-combobox multiple>', wrapper, parent);
	        }
	        if (props.overflow) {
	            Object(_util_console__WEBPACK_IMPORTED_MODULE_6__["deprecate"])('<v-select overflow>', '<v-overflow-btn>', wrapper, parent);
	        }
	        if (props.segmented) {
	            Object(_util_console__WEBPACK_IMPORTED_MODULE_6__["deprecate"])('<v-select segmented>', '<v-overflow-btn segmented>', wrapper, parent);
	        }
	        if (props.editable) {
	            Object(_util_console__WEBPACK_IMPORTED_MODULE_6__["deprecate"])('<v-select editable>', '<v-overflow-btn editable>', wrapper, parent);
	        }
	        data.attrs = data.attrs || {};
	        if (props.combobox || props.tags) {
	            data.attrs.multiple = props.tags;
	            return h(_VCombobox__WEBPACK_IMPORTED_MODULE_3__["default"], data, children);
	        } else if (props.autocomplete) {
	            data.attrs.multiple = props.multiple;
	            return h(_VAutocomplete__WEBPACK_IMPORTED_MODULE_2__["default"], data, children);
	        } else if (props.overflow || props.segmented || props.editable) {
	            data.attrs.segmented = props.segmented;
	            data.attrs.editable = props.editable;
	            return h(_VOverflowBtn__WEBPACK_IMPORTED_MODULE_1__["default"], data, children);
	        } else {
	            data.attrs.multiple = props.multiple;
	            return h(_VSelect__WEBPACK_IMPORTED_MODULE_0__["default"], data, children);
	        }
	    }
	};
	
	/* harmony default export */ __webpack_exports__["default"] = (wrapper);
	
	/***/ }),
	
	/***/ "./src/components/VSheet/VSheet.ts":
	/*!*****************************************!*\
	  !*** ./src/components/VSheet/VSheet.ts ***!
	  \*****************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_sheet_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_sheet.styl */ "./src/stylus/components/_sheet.styl");
	/* harmony import */ var _stylus_components_sheet_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_sheet_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _mixins_elevatable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/elevatable */ "./src/mixins/elevatable.ts");
	/* harmony import */ var _mixins_measurable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/measurable */ "./src/mixins/measurable.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	// Styles
	
	// Mixins
	
	
	
	
	// Helpers
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_5__["default"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_1__["default"], _mixins_elevatable__WEBPACK_IMPORTED_MODULE_2__["default"], _mixins_measurable__WEBPACK_IMPORTED_MODULE_3__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_4__["default"]).extend({
	    name: 'v-sheet',
	    props: {
	        tag: {
	            type: String,
	            default: 'div'
	        },
	        tile: Boolean
	    },
	    computed: {
	        classes: function classes() {
	            return __assign({ 'v-sheet': true, 'v-sheet--tile': this.tile }, this.themeClasses, this.elevationClasses);
	        },
	        styles: function styles() {
	            return this.measurableStyles;
	        }
	    },
	    render: function render(h) {
	        var data = {
	            class: this.classes,
	            style: this.styles,
	            on: this.$listeners
	        };
	        return h(this.tag, this.setBackgroundColor(this.color, data), this.$slots.default);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VSheet/index.ts":
	/*!****************************************!*\
	  !*** ./src/components/VSheet/index.ts ***!
	  \****************************************/
	/*! exports provided: VSheet, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VSheet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VSheet */ "./src/components/VSheet/VSheet.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VSheet", function() { return _VSheet__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VSheet__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VSlider/VSlider.js":
	/*!*******************************************!*\
	  !*** ./src/components/VSlider/VSlider.js ***!
	  \*******************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_sliders_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_sliders.styl */ "./src/stylus/components/_sliders.styl");
	/* harmony import */ var _stylus_components_sliders_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_sliders_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _transitions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../transitions */ "./src/components/transitions/index.js");
	/* harmony import */ var _VInput__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../VInput */ "./src/components/VInput/index.ts");
	/* harmony import */ var _directives_click_outside__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../directives/click-outside */ "./src/directives/click-outside.ts");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../util/console */ "./src/util/console.ts");
	/* harmony import */ var _mixins_loadable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mixins/loadable */ "./src/mixins/loadable.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	// Styles
	
	// Components
	
	// Extensions
	
	// Directives
	
	// Utilities
	
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (_VInput__WEBPACK_IMPORTED_MODULE_2__["default"].extend({
	    name: 'v-slider',
	    directives: { ClickOutside: _directives_click_outside__WEBPACK_IMPORTED_MODULE_3__["default"] },
	    mixins: [_mixins_loadable__WEBPACK_IMPORTED_MODULE_6__["default"]],
	    props: {
	        alwaysDirty: Boolean,
	        inverseLabel: Boolean,
	        label: String,
	        min: {
	            type: [Number, String],
	            default: 0
	        },
	        max: {
	            type: [Number, String],
	            default: 100
	        },
	        step: {
	            type: [Number, String],
	            default: 1
	        },
	        ticks: {
	            type: [Boolean, String],
	            default: false,
	            validator: function validator(v) {
	                return typeof v === 'boolean' || v === 'always';
	            }
	        },
	        tickLabels: {
	            type: Array,
	            default: function _default() {
	                return [];
	            }
	        },
	        tickSize: {
	            type: [Number, String],
	            default: 1
	        },
	        thumbColor: {
	            type: String,
	            default: null
	        },
	        thumbLabel: {
	            type: [Boolean, String],
	            default: null,
	            validator: function validator(v) {
	                return typeof v === 'boolean' || v === 'always';
	            }
	        },
	        thumbSize: {
	            type: [Number, String],
	            default: 32
	        },
	        trackColor: {
	            type: String,
	            default: null
	        },
	        value: [Number, String]
	    },
	    data: function data(vm) {
	        return {
	            app: {},
	            isActive: false,
	            keyPressed: 0,
	            lazyValue: typeof vm.value !== 'undefined' ? vm.value : Number(vm.min),
	            oldValue: null
	        };
	    },
	    computed: {
	        classes: function classes() {
	            return {
	                'v-input--slider': true,
	                'v-input--slider--ticks': this.showTicks,
	                'v-input--slider--inverse-label': this.inverseLabel,
	                'v-input--slider--ticks-labels': this.tickLabels.length > 0,
	                'v-input--slider--thumb-label': this.thumbLabel || this.$scopedSlots.thumbLabel
	            };
	        },
	        showTicks: function showTicks() {
	            return this.tickLabels.length > 0 || !this.disabled && this.stepNumeric && !!this.ticks;
	        },
	        showThumbLabel: function showThumbLabel() {
	            return !this.disabled && (!!this.thumbLabel || this.thumbLabel === '' || this.$scopedSlots['thumb-label']);
	        },
	        computedColor: function computedColor() {
	            if (this.disabled) return null;
	            return this.validationState || this.color || 'primary';
	        },
	        computedTrackColor: function computedTrackColor() {
	            return this.disabled ? null : this.trackColor || null;
	        },
	        computedThumbColor: function computedThumbColor() {
	            if (this.disabled || !this.isDirty) return null;
	            return this.validationState || this.thumbColor || this.color || 'primary';
	        },
	        internalValue: {
	            get: function get() {
	                return this.lazyValue;
	            },
	            set: function set(val) {
	                var _a = this,
	                    min = _a.min,
	                    max = _a.max;
	                // Round value to ensure the
	                // entire slider range can
	                // be selected with step
	                var value = this.roundValue(Math.min(Math.max(val, min), max));
	                if (value === this.lazyValue) return;
	                this.lazyValue = value;
	                this.$emit('input', value);
	                this.validate();
	            }
	        },
	        stepNumeric: function stepNumeric() {
	            return this.step > 0 ? parseFloat(this.step) : 0;
	        },
	        trackFillStyles: function trackFillStyles() {
	            var left = this.$vuetify.rtl ? 'auto' : 0;
	            var right = this.$vuetify.rtl ? 0 : 'auto';
	            var width = this.inputWidth + "%";
	            if (this.disabled) width = "calc(" + this.inputWidth + "% - 8px)";
	            return {
	                transition: this.trackTransition,
	                left: left,
	                right: right,
	                width: width
	            };
	        },
	        trackPadding: function trackPadding() {
	            return this.isActive || this.inputWidth > 0 || this.disabled ? 0 : 7;
	        },
	        trackStyles: function trackStyles() {
	            var trackPadding = this.disabled ? "calc(" + this.inputWidth + "% + 8px)" : this.trackPadding + "px";
	            var left = this.$vuetify.rtl ? 'auto' : trackPadding;
	            var right = this.$vuetify.rtl ? trackPadding : 'auto';
	            var width = this.disabled ? "calc(" + (100 - this.inputWidth) + "% - 8px)" : '100%';
	            return {
	                transition: this.trackTransition,
	                left: left,
	                right: right,
	                width: width
	            };
	        },
	        tickStyles: function tickStyles() {
	            var size = Number(this.tickSize);
	            return {
	                'border-width': size + "px",
	                'border-radius': size > 1 ? '50%' : null,
	                transform: size > 1 ? "translateX(-" + size + "px) translateY(-" + (size - 1) + "px)" : null
	            };
	        },
	        trackTransition: function trackTransition() {
	            return this.keyPressed >= 2 ? 'none' : '';
	        },
	        numTicks: function numTicks() {
	            return Math.ceil((this.max - this.min) / this.stepNumeric);
	        },
	        inputWidth: function inputWidth() {
	            return (this.roundValue(this.internalValue) - this.min) / (this.max - this.min) * 100;
	        },
	        isDirty: function isDirty() {
	            return this.internalValue > this.min || this.alwaysDirty;
	        }
	    },
	    watch: {
	        min: function min(val) {
	            val > this.internalValue && this.$emit('input', parseFloat(val));
	        },
	        max: function max(val) {
	            val < this.internalValue && this.$emit('input', parseFloat(val));
	        },
	        value: function value(val) {
	            this.internalValue = val;
	        }
	    },
	    mounted: function mounted() {
	        // Without a v-app, iOS does not work with body selectors
	        this.app = document.querySelector('[data-app]') || Object(_util_console__WEBPACK_IMPORTED_MODULE_5__["consoleWarn"])('Missing v-app or a non-body wrapping element with the [data-app] attribute', this);
	    },
	    methods: {
	        genDefaultSlot: function genDefaultSlot() {
	            var children = [this.genLabel()];
	            var slider = this.genSlider();
	            this.inverseLabel ? children.unshift(slider) : children.push(slider);
	            children.push(this.genProgress());
	            return children;
	        },
	        genListeners: function genListeners() {
	            return {
	                blur: this.onBlur,
	                click: this.onSliderClick,
	                focus: this.onFocus,
	                keydown: this.onKeyDown,
	                keyup: this.onKeyUp
	            };
	        },
	        genInput: function genInput() {
	            return this.$createElement('input', {
	                attrs: __assign({ 'aria-label': this.label, name: this.name, role: 'slider', tabindex: this.disabled ? -1 : this.$attrs.tabindex, value: this.internalValue, readonly: true, 'aria-readonly': String(this.readonly), 'aria-valuemin': this.min, 'aria-valuemax': this.max, 'aria-valuenow': this.internalValue }, this.$attrs),
	                on: this.genListeners(),
	                ref: 'input'
	            });
	        },
	        genSlider: function genSlider() {
	            return this.$createElement('div', {
	                staticClass: 'v-slider',
	                'class': {
	                    'v-slider--is-active': this.isActive
	                },
	                directives: [{
	                    name: 'click-outside',
	                    value: this.onBlur
	                }]
	            }, this.genChildren());
	        },
	        genChildren: function genChildren() {
	            return [this.genInput(), this.genTrackContainer(), this.genSteps(), this.genThumbContainer(this.internalValue, this.inputWidth, this.isFocused || this.isActive, this.onThumbMouseDown)];
	        },
	        genSteps: function genSteps() {
	            var _this = this;
	            if (!this.step || !this.showTicks) return null;
	            var ticks = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["createRange"])(this.numTicks + 1).map(function (i) {
	                var children = [];
	                if (_this.tickLabels[i]) {
	                    children.push(_this.$createElement('span', _this.tickLabels[i]));
	                }
	                return _this.$createElement('span', {
	                    key: i,
	                    staticClass: 'v-slider__ticks',
	                    class: {
	                        'v-slider__ticks--always-show': _this.ticks === 'always' || _this.tickLabels.length > 0
	                    },
	                    style: __assign({}, _this.tickStyles, { left: i * (100 / _this.numTicks) + "%" })
	                }, children);
	            });
	            return this.$createElement('div', {
	                staticClass: 'v-slider__ticks-container'
	            }, ticks);
	        },
	        genThumb: function genThumb() {
	            return this.$createElement('div', this.setBackgroundColor(this.computedThumbColor, {
	                staticClass: 'v-slider__thumb'
	            }));
	        },
	        genThumbContainer: function genThumbContainer(value, valueWidth, isActive, onDrag) {
	            var children = [this.genThumb()];
	            var thumbLabelContent = this.getLabel(value);
	            this.showThumbLabel && children.push(this.genThumbLabel(thumbLabelContent));
	            return this.$createElement('div', this.setTextColor(this.computedThumbColor, {
	                staticClass: 'v-slider__thumb-container',
	                'class': {
	                    'v-slider__thumb-container--is-active': isActive,
	                    'v-slider__thumb-container--show-label': this.showThumbLabel
	                },
	                style: {
	                    transition: this.trackTransition,
	                    left: (this.$vuetify.rtl ? 100 - valueWidth : valueWidth) + "%"
	                },
	                on: {
	                    touchstart: onDrag,
	                    mousedown: onDrag
	                }
	            }), children);
	        },
	        genThumbLabel: function genThumbLabel(content) {
	            var size = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["convertToUnit"])(this.thumbSize);
	            return this.$createElement(_transitions__WEBPACK_IMPORTED_MODULE_1__["VScaleTransition"], {
	                props: { origin: 'bottom center' }
	            }, [this.$createElement('div', {
	                staticClass: 'v-slider__thumb-label__container',
	                directives: [{
	                    name: 'show',
	                    value: this.isFocused || this.isActive || this.thumbLabel === 'always'
	                }]
	            }, [this.$createElement('div', this.setBackgroundColor(this.computedThumbColor, {
	                staticClass: 'v-slider__thumb-label',
	                style: {
	                    height: size,
	                    width: size
	                }
	            }), [content])])]);
	        },
	        genTrackContainer: function genTrackContainer() {
	            var children = [this.$createElement('div', this.setBackgroundColor(this.computedTrackColor, {
	                staticClass: 'v-slider__track',
	                style: this.trackStyles
	            })), this.$createElement('div', this.setBackgroundColor(this.computedColor, {
	                staticClass: 'v-slider__track-fill',
	                style: this.trackFillStyles
	            }))];
	            return this.$createElement('div', {
	                staticClass: 'v-slider__track__container',
	                ref: 'track'
	            }, children);
	        },
	        getLabel: function getLabel(value) {
	            return this.$scopedSlots['thumb-label'] ? this.$scopedSlots['thumb-label']({ value: value }) : this.$createElement('span', value);
	        },
	        onBlur: function onBlur(e) {
	            if (this.keyPressed === 2) return;
	            this.isActive = false;
	            this.isFocused = false;
	            this.$emit('blur', e);
	        },
	        onFocus: function onFocus(e) {
	            this.isFocused = true;
	            this.$emit('focus', e);
	        },
	        onThumbMouseDown: function onThumbMouseDown(e) {
	            this.oldValue = this.internalValue;
	            this.keyPressed = 2;
	            var options = { passive: true };
	            this.isActive = true;
	            this.isFocused = false;
	            if ('touches' in e) {
	                this.app.addEventListener('touchmove', this.onMouseMove, options);
	                Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["addOnceEventListener"])(this.app, 'touchend', this.onSliderMouseUp);
	            } else {
	                this.app.addEventListener('mousemove', this.onMouseMove, options);
	                Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["addOnceEventListener"])(this.app, 'mouseup', this.onSliderMouseUp);
	            }
	            this.$emit('start', this.internalValue);
	        },
	        onSliderMouseUp: function onSliderMouseUp() {
	            this.keyPressed = 0;
	            var options = { passive: true };
	            this.isActive = false;
	            this.isFocused = false;
	            this.app.removeEventListener('touchmove', this.onMouseMove, options);
	            this.app.removeEventListener('mousemove', this.onMouseMove, options);
	            this.$emit('end', this.internalValue);
	            if (!Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["deepEqual"])(this.oldValue, this.internalValue)) {
	                this.$emit('change', this.internalValue);
	            }
	        },
	        onMouseMove: function onMouseMove(e) {
	            var _a = this.parseMouseMove(e),
	                value = _a.value,
	                isInsideTrack = _a.isInsideTrack;
	            if (isInsideTrack) {
	                this.setInternalValue(value);
	            }
	        },
	        onKeyDown: function onKeyDown(e) {
	            if (this.disabled || this.readonly) return;
	            var value = this.parseKeyDown(e);
	            if (value == null) return;
	            this.setInternalValue(value);
	            this.$emit('change', value);
	        },
	        onKeyUp: function onKeyUp() {
	            this.keyPressed = 0;
	        },
	        onSliderClick: function onSliderClick(e) {
	            this.isFocused = true;
	            this.onMouseMove(e);
	            this.$emit('change', this.internalValue);
	        },
	        parseMouseMove: function parseMouseMove(e) {
	            var _a = this.$refs.track.getBoundingClientRect(),
	                offsetLeft = _a.left,
	                trackWidth = _a.width;
	            var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
	            // It is possible for left to be NaN, force to number
	            var left = Math.min(Math.max((clientX - offsetLeft) / trackWidth, 0), 1) || 0;
	            if (this.$vuetify.rtl) left = 1 - left;
	            var isInsideTrack = clientX >= offsetLeft - 8 && clientX <= offsetLeft + trackWidth + 8;
	            var value = parseFloat(this.min) + left * (this.max - this.min);
	            return { value: value, isInsideTrack: isInsideTrack };
	        },
	        parseKeyDown: function parseKeyDown(e, value) {
	            if (value === void 0) {
	                value = this.internalValue;
	            }
	            if (this.disabled) return;
	            var pageup = _util_helpers__WEBPACK_IMPORTED_MODULE_4__["keyCodes"].pageup,
	                pagedown = _util_helpers__WEBPACK_IMPORTED_MODULE_4__["keyCodes"].pagedown,
	                end = _util_helpers__WEBPACK_IMPORTED_MODULE_4__["keyCodes"].end,
	                home = _util_helpers__WEBPACK_IMPORTED_MODULE_4__["keyCodes"].home,
	                left = _util_helpers__WEBPACK_IMPORTED_MODULE_4__["keyCodes"].left,
	                right = _util_helpers__WEBPACK_IMPORTED_MODULE_4__["keyCodes"].right,
	                down = _util_helpers__WEBPACK_IMPORTED_MODULE_4__["keyCodes"].down,
	                up = _util_helpers__WEBPACK_IMPORTED_MODULE_4__["keyCodes"].up;
	            if (![pageup, pagedown, end, home, left, right, down, up].includes(e.keyCode)) return;
	            e.preventDefault();
	            var step = this.stepNumeric || 1;
	            var steps = (this.max - this.min) / step;
	            if ([left, right, down, up].includes(e.keyCode)) {
	                this.keyPressed += 1;
	                var increase = this.$vuetify.rtl ? [left, up] : [right, up];
	                var direction = increase.includes(e.keyCode) ? 1 : -1;
	                var multiplier = e.shiftKey ? 3 : e.ctrlKey ? 2 : 1;
	                value = value + direction * step * multiplier;
	            } else if (e.keyCode === home) {
	                value = parseFloat(this.min);
	            } else if (e.keyCode === end) {
	                value = parseFloat(this.max);
	            } else /* if (e.keyCode === keyCodes.pageup || e.keyCode === pagedown) */{
	                    // Page up/down
	                    var direction = e.keyCode === pagedown ? 1 : -1;
	                    value = value - direction * step * (steps > 100 ? steps / 10 : 10);
	                }
	            return value;
	        },
	        roundValue: function roundValue(value) {
	            if (!this.stepNumeric) return value;
	            // Format input value using the same number
	            // of decimals places as in the step prop
	            var trimmedStep = this.step.toString().trim();
	            var decimals = trimmedStep.indexOf('.') > -1 ? trimmedStep.length - trimmedStep.indexOf('.') - 1 : 0;
	            var offset = this.min % this.stepNumeric;
	            var newValue = Math.round((value - offset) / this.stepNumeric) * this.stepNumeric + offset;
	            return parseFloat(Math.max(Math.min(newValue, this.max), this.min).toFixed(decimals));
	        },
	        setInternalValue: function setInternalValue(value) {
	            this.internalValue = value;
	        }
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VSlider/index.js":
	/*!*****************************************!*\
	  !*** ./src/components/VSlider/index.js ***!
	  \*****************************************/
	/*! exports provided: VSlider, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VSlider__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VSlider */ "./src/components/VSlider/VSlider.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VSlider", function() { return _VSlider__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VSlider__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VSnackbar/VSnackbar.ts":
	/*!***********************************************!*\
	  !*** ./src/components/VSnackbar/VSnackbar.ts ***!
	  \***********************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_snackbars_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_snackbars.styl */ "./src/stylus/components/_snackbars.styl");
	/* harmony import */ var _stylus_components_snackbars_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_snackbars_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _mixins_toggleable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/toggleable */ "./src/mixins/toggleable.ts");
	/* harmony import */ var _mixins_positionable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/positionable */ "./src/mixins/positionable.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	
	
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_4__["default"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_1__["default"], _mixins_toggleable__WEBPACK_IMPORTED_MODULE_2__["default"], Object(_mixins_positionable__WEBPACK_IMPORTED_MODULE_3__["factory"])(['absolute', 'top', 'bottom', 'left', 'right'])
	/* @vue/component */
	).extend({
	    name: 'v-snackbar',
	    props: {
	        autoHeight: Boolean,
	        multiLine: Boolean,
	        // TODO: change this to closeDelay to match other API in delayable.js
	        timeout: {
	            type: Number,
	            default: 6000
	        },
	        vertical: Boolean
	    },
	    data: function data() {
	        return {
	            activeTimeout: -1
	        };
	    },
	    computed: {
	        classes: function classes() {
	            return {
	                'v-snack--active': this.isActive,
	                'v-snack--absolute': this.absolute,
	                'v-snack--auto-height': this.autoHeight,
	                'v-snack--bottom': this.bottom || !this.top,
	                'v-snack--left': this.left,
	                'v-snack--multi-line': this.multiLine && !this.vertical,
	                'v-snack--right': this.right,
	                'v-snack--top': this.top,
	                'v-snack--vertical': this.vertical
	            };
	        }
	    },
	    watch: {
	        isActive: function isActive() {
	            this.setTimeout();
	        }
	    },
	    mounted: function mounted() {
	        this.setTimeout();
	    },
	    methods: {
	        setTimeout: function setTimeout() {
	            var _this = this;
	            window.clearTimeout(this.activeTimeout);
	            if (this.isActive && this.timeout) {
	                this.activeTimeout = window.setTimeout(function () {
	                    _this.isActive = false;
	                }, this.timeout);
	            }
	        }
	    },
	    render: function render(h) {
	        return h('transition', {
	            attrs: { name: 'v-snack-transition' }
	        }, this.isActive && [h('div', {
	            staticClass: 'v-snack',
	            class: this.classes,
	            on: this.$listeners
	        }, [h('div', this.setBackgroundColor(this.color, {
	            staticClass: 'v-snack__wrapper'
	        }), [h('div', {
	            staticClass: 'v-snack__content'
	        }, this.$slots.default)])])]);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VSnackbar/index.ts":
	/*!*******************************************!*\
	  !*** ./src/components/VSnackbar/index.ts ***!
	  \*******************************************/
	/*! exports provided: VSnackbar, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VSnackbar__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VSnackbar */ "./src/components/VSnackbar/VSnackbar.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VSnackbar", function() { return _VSnackbar__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VSnackbar__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VSparkline/VSparkline.ts":
	/*!*************************************************!*\
	  !*** ./src/components/VSparkline/VSparkline.ts ***!
	  \*************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	/* harmony import */ var _helpers_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./helpers/core */ "./src/components/VSparkline/helpers/core.ts");
	/* harmony import */ var _helpers_path__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./helpers/path */ "./src/components/VSparkline/helpers/path.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	// Mixins
	
	// Utilities
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_1__["default"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_0__["default"]).extend({
	    name: 'VSparkline',
	    props: {
	        autoDraw: Boolean,
	        autoDrawDuration: {
	            type: Number,
	            default: 2000
	        },
	        autoDrawEasing: {
	            type: String,
	            default: 'ease'
	        },
	        autoLineWidth: {
	            type: Boolean,
	            default: false
	        },
	        color: {
	            type: String,
	            default: 'primary'
	        },
	        fill: {
	            type: Boolean,
	            default: false
	        },
	        gradient: {
	            type: Array,
	            default: function _default() {
	                return [];
	            }
	        },
	        gradientDirection: {
	            type: String,
	            validator: function validator(val) {
	                return ['top', 'bottom', 'left', 'right'].includes(val);
	            },
	            default: 'top'
	        },
	        height: {
	            type: [String, Number],
	            default: 75
	        },
	        labels: {
	            type: Array,
	            default: function _default() {
	                return [];
	            }
	        },
	        lineWidth: {
	            type: [String, Number],
	            default: 4
	        },
	        padding: {
	            type: [String, Number],
	            default: 8
	        },
	        smooth: {
	            type: [Boolean, Number, String],
	            default: false
	        },
	        showLabels: Boolean,
	        type: {
	            type: String,
	            default: 'trend',
	            validator: function validator(val) {
	                return ['trend', 'bar'].includes(val);
	            }
	        },
	        value: {
	            type: Array,
	            default: function _default() {
	                return [];
	            }
	        },
	        width: {
	            type: [Number, String],
	            default: 300
	        },
	        labelSize: {
	            type: [Number, String],
	            default: 7
	        }
	    },
	    data: function data() {
	        return {
	            lastLength: 0
	        };
	    },
	    computed: {
	        parsedPadding: function parsedPadding() {
	            return Number(this.padding);
	        },
	        parsedWidth: function parsedWidth() {
	            return Number(this.width);
	        },
	        totalBars: function totalBars() {
	            return this.value.length;
	        },
	        _lineWidth: function _lineWidth() {
	            if (this.autoLineWidth && this.type !== 'trend') {
	                var totalPadding = this.parsedPadding * (this.totalBars + 1);
	                return (this.parsedWidth - totalPadding) / this.totalBars;
	            } else {
	                return Number(this.lineWidth) || 4;
	            }
	        },
	        boundary: function boundary() {
	            var height = Number(this.height);
	            return {
	                minX: this.parsedPadding,
	                minY: this.parsedPadding,
	                maxX: this.parsedWidth - this.parsedPadding,
	                maxY: height - this.parsedPadding
	            };
	        },
	        hasLabels: function hasLabels() {
	            return Boolean(this.showLabels || this.labels.length > 0 || this.$scopedSlots.label);
	        },
	        parsedLabels: function parsedLabels() {
	            var labels = [];
	            var points = this.points;
	            var len = points.length;
	            for (var i = 0; labels.length < len; i++) {
	                var item = points[i];
	                var value = this.labels[i];
	                if (!value) {
	                    value = item === Object(item) ? item.value : item;
	                }
	                labels.push(__assign({}, item, { value: String(value) }));
	            }
	            return labels;
	        },
	        points: function points() {
	            return Object(_helpers_core__WEBPACK_IMPORTED_MODULE_2__["genPoints"])(this.value.slice(), this.boundary, this.type);
	        },
	        textY: function textY() {
	            return this.boundary.maxY + 6;
	        }
	    },
	    watch: {
	        value: {
	            immediate: true,
	            handler: function handler() {
	                var _this = this;
	                this.$nextTick(function () {
	                    if (!_this.autoDraw || _this.type === 'bar') return;
	                    var path = _this.$refs.path;
	                    var length = path.getTotalLength();
	                    if (!_this.fill) {
	                        path.style.transition = 'none';
	                        path.style.strokeDasharray = length + ' ' + length;
	                        path.style.strokeDashoffset = Math.abs(length - (_this.lastLength || 0)).toString();
	                        path.getBoundingClientRect();
	                        path.style.transition = "stroke-dashoffset " + _this.autoDrawDuration + "ms " + _this.autoDrawEasing;
	                        path.style.strokeDashoffset = '0';
	                    } else {
	                        path.style.transformOrigin = 'bottom center';
	                        path.style.transition = 'none';
	                        path.style.transform = "scaleY(0)";
	                        path.getBoundingClientRect();
	                        path.style.transition = "transform " + _this.autoDrawDuration + "ms " + _this.autoDrawEasing;
	                        path.style.transform = "scaleY(1)";
	                    }
	                    _this.lastLength = length;
	                });
	            }
	        }
	    },
	    methods: {
	        genGradient: function genGradient() {
	            var _this = this;
	            var gradientDirection = this.gradientDirection;
	            var gradient = this.gradient.slice();
	            // Pushes empty string to force
	            // a fallback to currentColor
	            if (!gradient.length) gradient.push('');
	            var len = Math.max(gradient.length - 1, 1);
	            var stops = gradient.reverse().map(function (color, index) {
	                return _this.$createElement('stop', {
	                    attrs: {
	                        offset: index / len,
	                        'stop-color': color || _this.color || 'currentColor'
	                    }
	                });
	            });
	            return this.$createElement('defs', [this.$createElement('linearGradient', {
	                attrs: {
	                    id: this._uid,
	                    x1: +(gradientDirection === 'left'),
	                    y1: +(gradientDirection === 'top'),
	                    x2: +(gradientDirection === 'right'),
	                    y2: +(gradientDirection === 'bottom')
	                }
	            }, stops)]);
	        },
	        genG: function genG(children) {
	            return this.$createElement('g', {
	                style: {
	                    fontSize: '8',
	                    textAnchor: 'middle',
	                    dominantBaseline: 'mathematical',
	                    fill: this.color || 'currentColor'
	                }
	            }, children);
	        },
	        genLabels: function genLabels() {
	            if (!this.hasLabels) return undefined;
	            return this.genG(this.parsedLabels.map(this.genText));
	        },
	        genPath: function genPath() {
	            var radius = this.smooth === true ? 8 : Number(this.smooth);
	            return this.$createElement('path', {
	                attrs: {
	                    id: this._uid,
	                    d: Object(_helpers_path__WEBPACK_IMPORTED_MODULE_3__["genPath"])(this.points.slice(), radius, this.fill, Number(this.height)),
	                    fill: this.fill ? "url(#" + this._uid + ")" : 'none',
	                    stroke: this.fill ? 'none' : "url(#" + this._uid + ")"
	                },
	                ref: 'path'
	            });
	        },
	        genText: function genText(item, index) {
	            var children = this.$scopedSlots.label ? this.$scopedSlots.label({ index: index, value: item.value }) : item.value;
	            return this.$createElement('text', {
	                attrs: {
	                    x: item.x,
	                    y: this.textY
	                }
	            }, [children]);
	        },
	        genBar: function genBar() {
	            if (!this.value || this.totalBars < 2) return undefined;
	            var _a = this,
	                width = _a.width,
	                height = _a.height,
	                parsedPadding = _a.parsedPadding,
	                _lineWidth = _a._lineWidth;
	            var viewWidth = width || this.totalBars * parsedPadding * 2;
	            var viewHeight = height || 75;
	            var boundary = {
	                minX: parsedPadding,
	                minY: parsedPadding,
	                maxX: Number(viewWidth) - parsedPadding,
	                maxY: Number(viewHeight) - parsedPadding
	            };
	            var props = __assign({}, this.$props);
	            props.points = Object(_helpers_core__WEBPACK_IMPORTED_MODULE_2__["genPoints"])(this.value, boundary, this.type);
	            var totalWidth = boundary.maxX / (props.points.length - 1);
	            props.boundary = boundary;
	            props.lineWidth = _lineWidth || totalWidth - Number(parsedPadding || 5);
	            props.offsetX = 0;
	            if (!this.autoLineWidth) {
	                props.offsetX = boundary.maxX / this.totalBars / 2 - boundary.minX;
	            }
	            return this.$createElement('svg', {
	                attrs: {
	                    width: '100%',
	                    height: '25%',
	                    viewBox: "0 0 " + viewWidth + " " + viewHeight
	                }
	            }, [this.genGradient(), this.genClipPath(props.offsetX, props.lineWidth, 'sparkline-bar-' + this._uid), this.hasLabels ? this.genBarLabels(props) : undefined, this.$createElement('g', {
	                attrs: {
	                    transform: "scale(1,-1) translate(0,-" + boundary.maxY + ")",
	                    'clip-path': "url(#sparkline-bar-" + this._uid + "-clip)",
	                    fill: "url(#" + this._uid + ")"
	                }
	            }, [this.$createElement('rect', {
	                attrs: {
	                    x: 0,
	                    y: 0,
	                    width: viewWidth,
	                    height: viewHeight
	                }
	            })])]);
	        },
	        genClipPath: function genClipPath(offsetX, lineWidth, id) {
	            var _this = this;
	            var maxY = this.boundary.maxY;
	            var rounding = typeof this.smooth === 'number' ? this.smooth : this.smooth ? 2 : 0;
	            return this.$createElement('clipPath', {
	                attrs: {
	                    id: id + "-clip"
	                }
	            }, this.points.map(function (item) {
	                return _this.$createElement('rect', {
	                    attrs: {
	                        x: item.x + offsetX,
	                        y: 0,
	                        width: lineWidth,
	                        height: Math.max(maxY - item.y, 0),
	                        rx: rounding,
	                        ry: rounding
	                    }
	                }, [_this.autoDraw ? _this.$createElement('animate', {
	                    attrs: {
	                        attributeName: 'height',
	                        from: 0,
	                        to: maxY - item.y,
	                        dur: _this.autoDrawDuration + "ms",
	                        fill: 'freeze'
	                    }
	                }) : undefined]);
	            }));
	        },
	        genBarLabels: function genBarLabels(props) {
	            var _this = this;
	            var offsetX = props.offsetX || 0;
	            var children = props.points.map(function (item) {
	                return _this.$createElement('text', {
	                    attrs: {
	                        x: item.x + offsetX + _this._lineWidth / 2,
	                        y: props.boundary.maxY + (Number(_this.labelSize) || 7),
	                        'font-size': Number(_this.labelSize) || 7
	                    }
	                }, item.value.toString());
	            });
	            return this.genG(children);
	        },
	        genTrend: function genTrend() {
	            return this.$createElement('svg', this.setTextColor(this.color, {
	                attrs: {
	                    'stroke-width': this._lineWidth || 1,
	                    width: '100%',
	                    height: '25%',
	                    viewBox: "0 0 " + this.width + " " + this.height
	                }
	            }), [this.genGradient(), this.genLabels(), this.genPath()]);
	        }
	    },
	    render: function render(h) {
	        if (this.totalBars < 2) return undefined;
	        return this.type === 'trend' ? this.genTrend() : this.genBar();
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VSparkline/helpers/core.ts":
	/*!***************************************************!*\
	  !*** ./src/components/VSparkline/helpers/core.ts ***!
	  \***************************************************/
	/*! exports provided: genPoints */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "genPoints", function() { return genPoints; });
	var __read = undefined && undefined.__read || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o),
	        r,
	        ar = [],
	        e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
	            ar.push(r.value);
	        }
	    } catch (error) {
	        e = { error: error };
	    } finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        } finally {
	            if (e) throw e.error;
	        }
	    }
	    return ar;
	};
	var __spread = undefined && undefined.__spread || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) {
	        ar = ar.concat(__read(arguments[i]));
	    }return ar;
	};
	function genPoints(points, boundary, type) {
	    var minX = boundary.minX,
	        minY = boundary.minY,
	        maxX = boundary.maxX,
	        maxY = boundary.maxY;
	    var normalisedPoints = points.map(function (item) {
	        return typeof item === 'number' ? item : item.value;
	    });
	    var totalPoints = normalisedPoints.length;
	    var maxValue = Math.max.apply(Math, __spread(normalisedPoints)) + 1;
	    var minValue = Math.min.apply(Math, __spread(normalisedPoints));
	    if (minValue) minValue -= 1;
	    var gridX = (maxX - minX) / (totalPoints - 1);
	    if (type === 'bar') gridX = maxX / totalPoints;
	    var gridY = (maxY - minY) / (maxValue - minValue);
	    return normalisedPoints.map(function (value, index) {
	        return {
	            x: minX + index * gridX,
	            y: maxY - (value - minValue) * gridY + +(index === totalPoints - 1) * 0.00001 - +(index === 0) * 0.00001,
	            value: value
	        };
	    });
	}
	
	/***/ }),
	
	/***/ "./src/components/VSparkline/helpers/math.ts":
	/*!***************************************************!*\
	  !*** ./src/components/VSparkline/helpers/math.ts ***!
	  \***************************************************/
	/*! exports provided: checkCollinear, getDistance, moveTo */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "checkCollinear", function() { return checkCollinear; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDistance", function() { return getDistance; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "moveTo", function() { return moveTo; });
	function int(value) {
	    return parseInt(value, 10);
	}
	/**
	 * https://en.wikipedia.org/wiki/Collinearity
	 * x=(x1+x2)/2
	 * y=(y1+y2)/2
	 */
	function checkCollinear(p0, p1, p2) {
	    return int(p0.x + p2.x) === int(2 * p1.x) && int(p0.y + p2.y) === int(2 * p1.y);
	}
	function getDistance(p1, p2) {
	    return Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2));
	}
	function moveTo(to, from, radius) {
	    var vector = { x: to.x - from.x, y: to.y - from.y };
	    var length = Math.sqrt(vector.x * vector.x + vector.y * vector.y);
	    var unitVector = { x: vector.x / length, y: vector.y / length };
	    return {
	        x: from.x + unitVector.x * radius,
	        y: from.y + unitVector.y * radius
	    };
	}
	
	/***/ }),
	
	/***/ "./src/components/VSparkline/helpers/path.ts":
	/*!***************************************************!*\
	  !*** ./src/components/VSparkline/helpers/path.ts ***!
	  \***************************************************/
	/*! exports provided: genPath */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "genPath", function() { return genPath; });
	/* harmony import */ var _math__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./math */ "./src/components/VSparkline/helpers/math.ts");
	
	/**
	 * From https://github.com/unsplash/react-trend/blob/master/src/helpers/DOM.helpers.js#L18
	 */
	function genPath(points, radius, fill, height) {
	    if (fill === void 0) {
	        fill = false;
	    }
	    if (height === void 0) {
	        height = 75;
	    }
	    var start = points.shift();
	    var end = points[points.length - 1];
	    return (fill ? "M" + start.x + " " + height + " L" + start.x + " " + start.y : "M" + start.x + " " + start.y) + points.map(function (point, index) {
	        var next = points[index + 1];
	        var prev = points[index - 1] || start;
	        var isCollinear = next && Object(_math__WEBPACK_IMPORTED_MODULE_0__["checkCollinear"])(next, point, prev);
	        if (!next || isCollinear) {
	            return "L" + point.x + " " + point.y;
	        }
	        var threshold = Math.min(Object(_math__WEBPACK_IMPORTED_MODULE_0__["getDistance"])(prev, point), Object(_math__WEBPACK_IMPORTED_MODULE_0__["getDistance"])(next, point));
	        var isTooCloseForRadius = threshold / 2 < radius;
	        var radiusForPoint = isTooCloseForRadius ? threshold / 2 : radius;
	        var before = Object(_math__WEBPACK_IMPORTED_MODULE_0__["moveTo"])(prev, point, radiusForPoint);
	        var after = Object(_math__WEBPACK_IMPORTED_MODULE_0__["moveTo"])(next, point, radiusForPoint);
	        return "L" + before.x + " " + before.y + "S" + point.x + " " + point.y + " " + after.x + " " + after.y;
	    }).join('') + (fill ? "L" + end.x + " " + height + " Z" : '');
	}
	
	/***/ }),
	
	/***/ "./src/components/VSparkline/index.ts":
	/*!********************************************!*\
	  !*** ./src/components/VSparkline/index.ts ***!
	  \********************************************/
	/*! exports provided: VSparkline, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VSparkline__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VSparkline */ "./src/components/VSparkline/VSparkline.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VSparkline", function() { return _VSparkline__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VSparkline__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VSpeedDial/VSpeedDial.js":
	/*!*************************************************!*\
	  !*** ./src/components/VSpeedDial/VSpeedDial.js ***!
	  \*************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_speed_dial_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_speed-dial.styl */ "./src/stylus/components/_speed-dial.styl");
	/* harmony import */ var _stylus_components_speed_dial_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_speed_dial_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_toggleable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/toggleable */ "./src/mixins/toggleable.ts");
	/* harmony import */ var _mixins_positionable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/positionable */ "./src/mixins/positionable.ts");
	/* harmony import */ var _mixins_transitionable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/transitionable */ "./src/mixins/transitionable.ts");
	/* harmony import */ var _directives_click_outside__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../directives/click-outside */ "./src/directives/click-outside.ts");
	
	
	
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-speed-dial',
	    directives: { ClickOutside: _directives_click_outside__WEBPACK_IMPORTED_MODULE_4__["default"] },
	    mixins: [_mixins_positionable__WEBPACK_IMPORTED_MODULE_2__["default"], _mixins_toggleable__WEBPACK_IMPORTED_MODULE_1__["default"], _mixins_transitionable__WEBPACK_IMPORTED_MODULE_3__["default"]],
	    props: {
	        direction: {
	            type: String,
	            default: 'top',
	            validator: function validator(val) {
	                return ['top', 'right', 'bottom', 'left'].includes(val);
	            }
	        },
	        openOnHover: Boolean,
	        transition: {
	            type: String,
	            default: 'scale-transition'
	        }
	    },
	    computed: {
	        classes: function classes() {
	            var _a;
	            return _a = {
	                'v-speed-dial': true,
	                'v-speed-dial--top': this.top,
	                'v-speed-dial--right': this.right,
	                'v-speed-dial--bottom': this.bottom,
	                'v-speed-dial--left': this.left,
	                'v-speed-dial--absolute': this.absolute,
	                'v-speed-dial--fixed': this.fixed
	            }, _a["v-speed-dial--direction-" + this.direction] = true, _a;
	        }
	    },
	    render: function render(h) {
	        var _this = this;
	        var children = [];
	        var data = {
	            'class': this.classes,
	            directives: [{
	                name: 'click-outside',
	                value: function value() {
	                    return _this.isActive = false;
	                }
	            }],
	            on: {
	                click: function click() {
	                    return _this.isActive = !_this.isActive;
	                }
	            }
	        };
	        if (this.openOnHover) {
	            data.on.mouseenter = function () {
	                return _this.isActive = true;
	            };
	            data.on.mouseleave = function () {
	                return _this.isActive = false;
	            };
	        }
	        if (this.isActive) {
	            var btnCount_1 = 0;
	            children = (this.$slots.default || []).map(function (b, i) {
	                if (b.tag && typeof b.componentOptions !== 'undefined' && b.componentOptions.Ctor.options.name === 'v-btn') {
	                    btnCount_1++;
	                    return h('div', {
	                        style: {
	                            transitionDelay: btnCount_1 * 0.05 + 's'
	                        },
	                        key: i
	                    }, [b]);
	                } else {
	                    b.key = i;
	                    return b;
	                }
	            });
	        }
	        var list = h('transition-group', {
	            'class': 'v-speed-dial__list',
	            props: {
	                name: this.transition,
	                mode: this.mode,
	                origin: this.origin,
	                tag: 'div'
	            }
	        }, children);
	        return h('div', data, [this.$slots.activator, list]);
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VSpeedDial/index.js":
	/*!********************************************!*\
	  !*** ./src/components/VSpeedDial/index.js ***!
	  \********************************************/
	/*! exports provided: VSpeedDial, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VSpeedDial__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VSpeedDial */ "./src/components/VSpeedDial/VSpeedDial.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VSpeedDial", function() { return _VSpeedDial__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VSpeedDial__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VStepper/VStepper.ts":
	/*!*********************************************!*\
	  !*** ./src/components/VStepper/VStepper.ts ***!
	  \*********************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_steppers_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_steppers.styl */ "./src/stylus/components/_steppers.styl");
	/* harmony import */ var _stylus_components_steppers_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_steppers_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_registrable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/registrable */ "./src/mixins/registrable.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	// Styles
	
	// Mixins
	
	
	// Util
	
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_3__["default"])(Object(_mixins_registrable__WEBPACK_IMPORTED_MODULE_1__["provide"])('stepper'), _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__["default"]
	/* @vue/component */
	).extend({
	    name: 'v-stepper',
	    provide: function provide() {
	        return {
	            stepClick: this.stepClick,
	            isVertical: this.vertical
	        };
	    },
	    props: {
	        nonLinear: Boolean,
	        altLabels: Boolean,
	        vertical: Boolean,
	        value: [Number, String]
	    },
	    data: function data() {
	        return {
	            inputValue: null,
	            isBooted: false,
	            steps: [],
	            content: [],
	            isReverse: false
	        };
	    },
	    computed: {
	        classes: function classes() {
	            return __assign({ 'v-stepper': true, 'v-stepper--is-booted': this.isBooted, 'v-stepper--vertical': this.vertical, 'v-stepper--alt-labels': this.altLabels, 'v-stepper--non-linear': this.nonLinear }, this.themeClasses);
	        }
	    },
	    watch: {
	        inputValue: function inputValue(val, prev) {
	            this.isReverse = Number(val) < Number(prev);
	            for (var index = this.steps.length; --index >= 0;) {
	                this.steps[index].toggle(this.inputValue);
	            }
	            for (var index = this.content.length; --index >= 0;) {
	                this.content[index].toggle(this.inputValue, this.isReverse);
	            }
	            this.$emit('input', this.inputValue);
	            prev && (this.isBooted = true);
	        },
	        value: function value() {
	            var _this = this;
	            this.$nextTick(function () {
	                return _this.inputValue = _this.value;
	            });
	        }
	    },
	    mounted: function mounted() {
	        this.inputValue = this.value || this.steps[0].step || 1;
	    },
	    methods: {
	        register: function register(item) {
	            if (item.$options.name === 'v-stepper-step') {
	                this.steps.push(item);
	            } else if (item.$options.name === 'v-stepper-content') {
	                item.isVertical = this.vertical;
	                this.content.push(item);
	            }
	        },
	        unregister: function unregister(item) {
	            if (item.$options.name === 'v-stepper-step') {
	                this.steps = this.steps.filter(function (i) {
	                    return i !== item;
	                });
	            } else if (item.$options.name === 'v-stepper-content') {
	                item.isVertical = this.vertical;
	                this.content = this.content.filter(function (i) {
	                    return i !== item;
	                });
	            }
	        },
	        stepClick: function stepClick(step) {
	            var _this = this;
	            this.$nextTick(function () {
	                return _this.inputValue = step;
	            });
	        }
	    },
	    render: function render(h) {
	        return h('div', {
	            'class': this.classes
	        }, this.$slots.default);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VStepper/VStepperContent.ts":
	/*!****************************************************!*\
	  !*** ./src/components/VStepper/VStepperContent.ts ***!
	  \****************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _transitions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../transitions */ "./src/components/transitions/index.js");
	/* harmony import */ var _mixins_registrable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/registrable */ "./src/mixins/registrable.ts");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	// Components
	
	// Mixins
	
	// Helpers
	
	// Util
	
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_3__["default"])(Object(_mixins_registrable__WEBPACK_IMPORTED_MODULE_1__["inject"])('stepper', 'v-stepper-content', 'v-stepper')
	/* @vue/component */
	).extend({
	    name: 'v-stepper-content',
	    inject: {
	        isVerticalProvided: {
	            from: 'isVertical'
	        }
	    },
	    props: {
	        step: {
	            type: [Number, String],
	            required: true
	        }
	    },
	    data: function data() {
	        return {
	            height: 0,
	            // Must be null to allow
	            // previous comparison
	            isActive: null,
	            isReverse: false,
	            isVertical: this.isVerticalProvided
	        };
	    },
	    computed: {
	        classes: function classes() {
	            return {
	                'v-stepper__content': true
	            };
	        },
	        computedTransition: function computedTransition() {
	            return this.isReverse ? _transitions__WEBPACK_IMPORTED_MODULE_0__["VTabReverseTransition"] : _transitions__WEBPACK_IMPORTED_MODULE_0__["VTabTransition"];
	        },
	        styles: function styles() {
	            if (!this.isVertical) return {};
	            return {
	                height: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_2__["convertToUnit"])(this.height)
	            };
	        },
	        wrapperClasses: function wrapperClasses() {
	            return {
	                'v-stepper__wrapper': true
	            };
	        }
	    },
	    watch: {
	        isActive: function isActive(current, previous) {
	            // If active and the previous state
	            // was null, is just booting up
	            if (current && previous == null) {
	                this.height = 'auto';
	                return;
	            }
	            if (!this.isVertical) return;
	            if (this.isActive) this.enter();else this.leave();
	        }
	    },
	    mounted: function mounted() {
	        this.$refs.wrapper.addEventListener('transitionend', this.onTransition, false);
	        this.stepper && this.stepper.register(this);
	    },
	    beforeDestroy: function beforeDestroy() {
	        this.$refs.wrapper.removeEventListener('transitionend', this.onTransition, false);
	        this.stepper && this.stepper.unregister(this);
	    },
	    methods: {
	        onTransition: function onTransition(e) {
	            if (!this.isActive || e.propertyName !== 'height') return;
	            this.height = 'auto';
	        },
	        enter: function enter() {
	            var _this = this;
	            var scrollHeight = 0;
	            // Render bug with height
	            requestAnimationFrame(function () {
	                scrollHeight = _this.$refs.wrapper.scrollHeight;
	            });
	            this.height = 0;
	            // Give the collapsing element time to collapse
	            setTimeout(function () {
	                return _this.isActive && (_this.height = scrollHeight || 'auto');
	            }, 450);
	        },
	        leave: function leave() {
	            var _this = this;
	            this.height = this.$refs.wrapper.clientHeight;
	            setTimeout(function () {
	                return _this.height = 0;
	            }, 10);
	        },
	        toggle: function toggle(step, reverse) {
	            this.isActive = step.toString() === this.step.toString();
	            this.isReverse = reverse;
	        }
	    },
	    render: function render(h) {
	        var contentData = {
	            'class': this.classes
	        };
	        var wrapperData = {
	            'class': this.wrapperClasses,
	            style: this.styles,
	            ref: 'wrapper'
	        };
	        if (!this.isVertical) {
	            contentData.directives = [{
	                name: 'show',
	                value: this.isActive
	            }];
	        }
	        var wrapper = h('div', wrapperData, [this.$slots.default]);
	        var content = h('div', contentData, [wrapper]);
	        return h(this.computedTransition, {
	            on: this.$listeners
	        }, [content]);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VStepper/VStepperStep.ts":
	/*!*************************************************!*\
	  !*** ./src/components/VStepper/VStepperStep.ts ***!
	  \*************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VIcon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../VIcon */ "./src/components/VIcon/index.ts");
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _mixins_registrable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/registrable */ "./src/mixins/registrable.ts");
	/* harmony import */ var _directives_ripple__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../directives/ripple */ "./src/directives/ripple.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	// Components
	
	// Mixins
	
	
	// Directives
	
	// Util
	
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_4__["default"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_1__["default"], Object(_mixins_registrable__WEBPACK_IMPORTED_MODULE_2__["inject"])('stepper', 'v-stepper-step', 'v-stepper')
	/* @vue/component */
	).extend({
	    name: 'v-stepper-step',
	    directives: { Ripple: _directives_ripple__WEBPACK_IMPORTED_MODULE_3__["default"] },
	    inject: ['stepClick'],
	    props: {
	        color: {
	            type: String,
	            default: 'primary'
	        },
	        complete: Boolean,
	        completeIcon: {
	            type: String,
	            default: '$vuetify.icons.complete'
	        },
	        editIcon: {
	            type: String,
	            default: '$vuetify.icons.edit'
	        },
	        errorIcon: {
	            type: String,
	            default: '$vuetify.icons.error'
	        },
	        editable: Boolean,
	        rules: {
	            type: Array,
	            default: function _default() {
	                return [];
	            }
	        },
	        step: [Number, String]
	    },
	    data: function data() {
	        return {
	            isActive: false,
	            isInactive: true
	        };
	    },
	    computed: {
	        classes: function classes() {
	            return {
	                'v-stepper__step': true,
	                'v-stepper__step--active': this.isActive,
	                'v-stepper__step--editable': this.editable,
	                'v-stepper__step--inactive': this.isInactive,
	                'v-stepper__step--error': this.hasError,
	                'v-stepper__step--complete': this.complete,
	                'error--text': this.hasError
	            };
	        },
	        hasError: function hasError() {
	            return this.rules.some(function (validate) {
	                return validate() !== true;
	            });
	        }
	    },
	    mounted: function mounted() {
	        this.stepper && this.stepper.register(this);
	    },
	    beforeDestroy: function beforeDestroy() {
	        this.stepper && this.stepper.unregister(this);
	    },
	    methods: {
	        click: function click(e) {
	            e.stopPropagation();
	            this.$emit('click', e);
	            if (this.editable) {
	                this.stepClick(this.step);
	            }
	        },
	        toggle: function toggle(step) {
	            this.isActive = step.toString() === this.step.toString();
	            this.isInactive = Number(step) < Number(this.step);
	        }
	    },
	    render: function render(h) {
	        var data = {
	            'class': this.classes,
	            directives: [{
	                name: 'ripple',
	                value: this.editable
	            }],
	            on: { click: this.click }
	        };
	        var stepContent;
	        if (this.hasError) {
	            stepContent = [h(_VIcon__WEBPACK_IMPORTED_MODULE_0__["default"], {}, this.errorIcon)];
	        } else if (this.complete) {
	            if (this.editable) {
	                stepContent = [h(_VIcon__WEBPACK_IMPORTED_MODULE_0__["default"], {}, this.editIcon)];
	            } else {
	                stepContent = [h(_VIcon__WEBPACK_IMPORTED_MODULE_0__["default"], {}, this.completeIcon)];
	            }
	        } else {
	            stepContent = String(this.step);
	        }
	        var color = !this.hasError && (this.complete || this.isActive) ? this.color : false;
	        var step = h('span', this.setBackgroundColor(color, {
	            staticClass: 'v-stepper__step__step'
	        }), stepContent);
	        var label = h('div', {
	            staticClass: 'v-stepper__label'
	        }, this.$slots.default);
	        return h('div', data, [step, label]);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VStepper/index.ts":
	/*!******************************************!*\
	  !*** ./src/components/VStepper/index.ts ***!
	  \******************************************/
	/*! exports provided: VStepper, VStepperContent, VStepperStep, VStepperHeader, VStepperItems, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VStepperHeader", function() { return VStepperHeader; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VStepperItems", function() { return VStepperItems; });
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var _VStepper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./VStepper */ "./src/components/VStepper/VStepper.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VStepper", function() { return _VStepper__WEBPACK_IMPORTED_MODULE_1__["default"]; });
	
	/* harmony import */ var _VStepperStep__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./VStepperStep */ "./src/components/VStepper/VStepperStep.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VStepperStep", function() { return _VStepperStep__WEBPACK_IMPORTED_MODULE_2__["default"]; });
	
	/* harmony import */ var _VStepperContent__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./VStepperContent */ "./src/components/VStepper/VStepperContent.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VStepperContent", function() { return _VStepperContent__WEBPACK_IMPORTED_MODULE_3__["default"]; });
	
	
	
	
	
	var VStepperHeader = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleFunctional"])('v-stepper__header');
	var VStepperItems = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleFunctional"])('v-stepper__items');
	
	/* harmony default export */ __webpack_exports__["default"] = ({
	    $_vuetify_subcomponents: {
	        VStepper: _VStepper__WEBPACK_IMPORTED_MODULE_1__["default"],
	        VStepperContent: _VStepperContent__WEBPACK_IMPORTED_MODULE_3__["default"],
	        VStepperStep: _VStepperStep__WEBPACK_IMPORTED_MODULE_2__["default"],
	        VStepperHeader: VStepperHeader,
	        VStepperItems: VStepperItems
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VSubheader/VSubheader.ts":
	/*!*************************************************!*\
	  !*** ./src/components/VSubheader/VSubheader.ts ***!
	  \*************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_subheaders_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_subheaders.styl */ "./src/stylus/components/_subheaders.styl");
	/* harmony import */ var _stylus_components_subheaders_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_subheaders_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	// Styles
	
	// Mixins
	
	
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_2__["default"])(_mixins_themeable__WEBPACK_IMPORTED_MODULE_1__["default"]
	/* @vue/component */
	).extend({
	    name: 'v-subheader',
	    props: {
	        inset: Boolean
	    },
	    render: function render(h) {
	        return h('div', {
	            staticClass: 'v-subheader',
	            class: __assign({ 'v-subheader--inset': this.inset }, this.themeClasses),
	            attrs: this.$attrs,
	            on: this.$listeners
	        }, this.$slots.default);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VSubheader/index.ts":
	/*!********************************************!*\
	  !*** ./src/components/VSubheader/index.ts ***!
	  \********************************************/
	/*! exports provided: VSubheader, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VSubheader__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VSubheader */ "./src/components/VSubheader/VSubheader.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VSubheader", function() { return _VSubheader__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VSubheader__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VSwitch/VSwitch.js":
	/*!*******************************************!*\
	  !*** ./src/components/VSwitch/VSwitch.js ***!
	  \*******************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_selection_controls_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_selection-controls.styl */ "./src/stylus/components/_selection-controls.styl");
	/* harmony import */ var _stylus_components_selection_controls_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_selection_controls_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _stylus_components_switch_styl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../stylus/components/_switch.styl */ "./src/stylus/components/_switch.styl");
	/* harmony import */ var _stylus_components_switch_styl__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_switch_styl__WEBPACK_IMPORTED_MODULE_1__);
	/* harmony import */ var _mixins_selectable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/selectable */ "./src/mixins/selectable.js");
	/* harmony import */ var _directives_touch__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../directives/touch */ "./src/directives/touch.ts");
	/* harmony import */ var _transitions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../transitions */ "./src/components/transitions/index.js");
	/* harmony import */ var _VProgressCircular_VProgressCircular__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../VProgressCircular/VProgressCircular */ "./src/components/VProgressCircular/VProgressCircular.ts");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	
	
	// Mixins
	
	// Directives
	
	// Components
	
	
	// Helpers
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-switch',
	    directives: { Touch: _directives_touch__WEBPACK_IMPORTED_MODULE_3__["default"] },
	    mixins: [_mixins_selectable__WEBPACK_IMPORTED_MODULE_2__["default"]],
	    props: {
	        loading: {
	            type: [Boolean, String],
	            default: false
	        }
	    },
	    computed: {
	        classes: function classes() {
	            return {
	                'v-input--selection-controls v-input--switch': true
	            };
	        },
	        switchData: function switchData() {
	            return this.setTextColor(this.loading ? undefined : this.computedColor, {
	                class: this.themeClasses
	            });
	        }
	    },
	    methods: {
	        genDefaultSlot: function genDefaultSlot() {
	            return [this.genSwitch(), this.genLabel()];
	        },
	        genSwitch: function genSwitch() {
	            return this.$createElement('div', {
	                staticClass: 'v-input--selection-controls__input'
	            }, [this.genInput('checkbox', this.$attrs), this.genRipple(this.setTextColor(this.computedColor, {
	                directives: [{
	                    name: 'touch',
	                    value: {
	                        left: this.onSwipeLeft,
	                        right: this.onSwipeRight
	                    }
	                }]
	            })), this.$createElement('div', __assign({ staticClass: 'v-input--switch__track' }, this.switchData)), this.$createElement('div', __assign({ staticClass: 'v-input--switch__thumb' }, this.switchData), [this.genProgress()])]);
	        },
	        genProgress: function genProgress() {
	            return this.$createElement(_transitions__WEBPACK_IMPORTED_MODULE_4__["VFabTransition"], {}, [this.loading === false ? null : this.$slots.progress || this.$createElement(_VProgressCircular_VProgressCircular__WEBPACK_IMPORTED_MODULE_5__["default"], {
	                props: {
	                    color: this.loading === true || this.loading === '' ? this.color || 'primary' : this.loading,
	                    size: 16,
	                    width: 2,
	                    indeterminate: true
	                }
	            })]);
	        },
	        onSwipeLeft: function onSwipeLeft() {
	            if (this.isActive) this.onChange();
	        },
	        onSwipeRight: function onSwipeRight() {
	            if (!this.isActive) this.onChange();
	        },
	        onKeydown: function onKeydown(e) {
	            if (e.keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_6__["keyCodes"].left && this.isActive || e.keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_6__["keyCodes"].right && !this.isActive) this.onChange();
	        }
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VSwitch/index.js":
	/*!*****************************************!*\
	  !*** ./src/components/VSwitch/index.js ***!
	  \*****************************************/
	/*! exports provided: VSwitch, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VSwitch__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VSwitch */ "./src/components/VSwitch/VSwitch.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VSwitch", function() { return _VSwitch__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VSwitch__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VSystemBar/VSystemBar.ts":
	/*!*************************************************!*\
	  !*** ./src/components/VSystemBar/VSystemBar.ts ***!
	  \*************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_system_bars_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_system-bars.styl */ "./src/stylus/components/_system-bars.styl");
	/* harmony import */ var _stylus_components_system_bars_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_system_bars_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_applicationable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/applicationable */ "./src/mixins/applicationable.ts");
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	
	
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_4__["default"])(Object(_mixins_applicationable__WEBPACK_IMPORTED_MODULE_1__["default"])('bar', ['height', 'window']), _mixins_colorable__WEBPACK_IMPORTED_MODULE_2__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_3__["default"]
	/* @vue/component */
	).extend({
	    name: 'v-system-bar',
	    props: {
	        height: {
	            type: [Number, String],
	            validator: function validator(v) {
	                return !isNaN(parseInt(v));
	            }
	        },
	        lightsOut: Boolean,
	        status: Boolean,
	        window: Boolean
	    },
	    computed: {
	        classes: function classes() {
	            return __assign({ 'v-system-bar--lights-out': this.lightsOut, 'v-system-bar--absolute': this.absolute, 'v-system-bar--fixed': !this.absolute && (this.app || this.fixed), 'v-system-bar--status': this.status, 'v-system-bar--window': this.window }, this.themeClasses);
	        },
	        computedHeight: function computedHeight() {
	            if (this.height) return parseInt(this.height);
	            return this.window ? 32 : 24;
	        }
	    },
	    methods: {
	        /**
	         * Update the application layout
	         *
	         * @return {number}
	         */
	        updateApplication: function updateApplication() {
	            return this.computedHeight;
	        }
	    },
	    render: function render(h) {
	        var data = {
	            staticClass: 'v-system-bar',
	            'class': this.classes,
	            style: {
	                height: this.computedHeight + "px"
	            }
	        };
	        return h('div', this.setBackgroundColor(this.color, data), this.$slots.default);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VSystemBar/index.ts":
	/*!********************************************!*\
	  !*** ./src/components/VSystemBar/index.ts ***!
	  \********************************************/
	/*! exports provided: VSystemBar, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VSystemBar__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VSystemBar */ "./src/components/VSystemBar/VSystemBar.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VSystemBar", function() { return _VSystemBar__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VSystemBar__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VTabs/VTab.js":
	/*!**************************************!*\
	  !*** ./src/components/VTabs/VTab.js ***!
	  \**************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _mixins_groupable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mixins/groupable */ "./src/mixins/groupable.ts");
	/* harmony import */ var _mixins_routable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/routable */ "./src/mixins/routable.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	// Mixins
	
	
	
	// Utilities
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-tab',
	    mixins: [_mixins_routable__WEBPACK_IMPORTED_MODULE_1__["default"],
	    // Must be after routable
	    // to overwrite activeClass
	    Object(_mixins_groupable__WEBPACK_IMPORTED_MODULE_0__["factory"])('tabGroup'), _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__["default"]],
	    props: {
	        ripple: {
	            type: [Boolean, Object],
	            default: true
	        }
	    },
	    computed: {
	        classes: function classes() {
	            return __assign({ 'v-tabs__item': true, 'v-tabs__item--disabled': this.disabled }, this.groupClasses);
	        },
	        value: function value() {
	            var to = this.to || this.href || '';
	            if (this.$router && this.to === Object(this.to)) {
	                var resolve = this.$router.resolve(this.to, this.$route, this.append);
	                to = resolve.href;
	            }
	            return to.replace('#', '');
	        }
	    },
	    watch: {
	        $route: 'onRouteChange'
	    },
	    mounted: function mounted() {
	        this.onRouteChange();
	    },
	    methods: {
	        click: function click(e) {
	            // If user provides an
	            // actual link, do not
	            // prevent default
	            if (this.href && this.href.indexOf('#') > -1) e.preventDefault();
	            this.$emit('click', e);
	            this.to || this.toggle();
	        },
	        onRouteChange: function onRouteChange() {
	            var _this = this;
	            if (!this.to || !this.$refs.link) return;
	            var path = "_vnode.data.class." + this.activeClass;
	            this.$nextTick(function () {
	                if (Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["getObjectValueByPath"])(_this.$refs.link, path)) {
	                    _this.toggle();
	                }
	            });
	        }
	    },
	    render: function render(h) {
	        var link = this.generateRouteLink(this.classes);
	        var data = link.data;
	        // If disabled, use div as anchor tags do not support
	        // being disabled
	        var tag = this.disabled ? 'div' : link.tag;
	        data.ref = 'link';
	        return h('div', {
	            staticClass: 'v-tabs__div'
	        }, [h(tag, data, this.$slots.default)]);
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VTabs/VTabItem.js":
	/*!******************************************!*\
	  !*** ./src/components/VTabs/VTabItem.js ***!
	  \******************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VWindow_VWindowItem__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../VWindow/VWindowItem */ "./src/components/VWindow/VWindowItem.ts");
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../util/console */ "./src/util/console.ts");
	// Extensions
	
	// Mixins
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (_VWindow_VWindowItem__WEBPACK_IMPORTED_MODULE_0__["default"].extend({
	    name: 'v-tab-item',
	    props: {
	        id: String
	    },
	    render: function render(h) {
	        var render = _VWindow_VWindowItem__WEBPACK_IMPORTED_MODULE_0__["default"].options.render.call(this, h);
	        // For backwards compatibility with v1.2
	        /* istanbul ignore next */
	        if (this.id) {
	            Object(_util_console__WEBPACK_IMPORTED_MODULE_1__["deprecate"])('id', 'value', this);
	            render.data.domProps = render.data.domProps || {};
	            render.data.domProps.id = this.id;
	        }
	        return render;
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VTabs/VTabs.js":
	/*!***************************************!*\
	  !*** ./src/components/VTabs/VTabs.js ***!
	  \***************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_tabs_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_tabs.styl */ "./src/stylus/components/_tabs.styl");
	/* harmony import */ var _stylus_components_tabs_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_tabs_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _VItemGroup_VItemGroup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../VItemGroup/VItemGroup */ "./src/components/VItemGroup/VItemGroup.ts");
	/* harmony import */ var _mixins_tabs_computed__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./mixins/tabs-computed */ "./src/components/VTabs/mixins/tabs-computed.js");
	/* harmony import */ var _mixins_tabs_generators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./mixins/tabs-generators */ "./src/components/VTabs/mixins/tabs-generators.js");
	/* harmony import */ var _mixins_tabs_props__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./mixins/tabs-props */ "./src/components/VTabs/mixins/tabs-props.js");
	/* harmony import */ var _mixins_tabs_touch__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./mixins/tabs-touch */ "./src/components/VTabs/mixins/tabs-touch.js");
	/* harmony import */ var _mixins_tabs_watchers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./mixins/tabs-watchers */ "./src/components/VTabs/mixins/tabs-watchers.js");
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _mixins_ssr_bootable__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mixins/ssr-bootable */ "./src/mixins/ssr-bootable.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _directives_resize__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../directives/resize */ "./src/directives/resize.ts");
	/* harmony import */ var _directives_touch__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../directives/touch */ "./src/directives/touch.ts");
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../util/console */ "./src/util/console.ts");
	/* harmony import */ var _util_ThemeProvider__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../util/ThemeProvider */ "./src/util/ThemeProvider.ts");
	// Styles
	
	// Extensions
	
	// Component level mixins
	
	
	
	
	
	// Mixins
	
	
	
	// Directives
	
	
	
	// Utils
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (_VItemGroup_VItemGroup__WEBPACK_IMPORTED_MODULE_1__["BaseItemGroup"].extend({
	    name: 'v-tabs',
	    directives: {
	        Resize: _directives_resize__WEBPACK_IMPORTED_MODULE_10__["default"],
	        Touch: _directives_touch__WEBPACK_IMPORTED_MODULE_11__["default"]
	    },
	    mixins: [_mixins_colorable__WEBPACK_IMPORTED_MODULE_7__["default"], _mixins_ssr_bootable__WEBPACK_IMPORTED_MODULE_8__["default"], _mixins_tabs_computed__WEBPACK_IMPORTED_MODULE_2__["default"], _mixins_tabs_props__WEBPACK_IMPORTED_MODULE_4__["default"], _mixins_tabs_generators__WEBPACK_IMPORTED_MODULE_3__["default"], _mixins_tabs_touch__WEBPACK_IMPORTED_MODULE_5__["default"], _mixins_tabs_watchers__WEBPACK_IMPORTED_MODULE_6__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_9__["default"]],
	    provide: function provide() {
	        return {
	            tabGroup: this,
	            tabProxy: this.tabProxy,
	            registerItems: this.registerItems,
	            unregisterItems: this.unregisterItems
	        };
	    },
	    data: function data() {
	        return {
	            bar: [],
	            content: [],
	            isOverflowing: false,
	            nextIconVisible: false,
	            prevIconVisible: false,
	            resizeTimeout: null,
	            scrollOffset: 0,
	            sliderWidth: null,
	            sliderLeft: null,
	            startX: 0,
	            tabItems: null,
	            transitionTime: 300,
	            widths: {
	                bar: 0,
	                container: 0,
	                wrapper: 0
	            }
	        };
	    },
	    watch: {
	        items: 'onResize',
	        tabs: 'onResize'
	    },
	    mounted: function mounted() {
	        this.init();
	    },
	    methods: {
	        checkIcons: function checkIcons() {
	            this.prevIconVisible = this.checkPrevIcon();
	            this.nextIconVisible = this.checkNextIcon();
	        },
	        checkPrevIcon: function checkPrevIcon() {
	            return this.scrollOffset > 0;
	        },
	        checkNextIcon: function checkNextIcon() {
	            // Check one scroll ahead to know the width of right-most item
	            return this.widths.container > this.scrollOffset + this.widths.wrapper;
	        },
	        callSlider: function callSlider() {
	            var _this = this;
	            if (this.hideSlider || !this.activeTab) return false;
	            // Give screen time to paint
	            var activeTab = this.activeTab;
	            this.$nextTick(function () {
	                /* istanbul ignore if */
	                if (!activeTab || !activeTab.$el) return;
	                _this.sliderWidth = activeTab.$el.scrollWidth;
	                _this.sliderLeft = activeTab.$el.offsetLeft;
	            });
	        },
	        // Do not process
	        // until DOM is
	        // painted
	        init: function init() {
	            /* istanbul ignore next */
	            if (this.$listeners['input']) {
	                Object(_util_console__WEBPACK_IMPORTED_MODULE_12__["deprecate"])('@input', '@change', this);
	            }
	        },
	        /**
	         * When v-navigation-drawer changes the
	         * width of the container, call resize
	         * after the transition is complete
	         */
	        onResize: function onResize() {
	            if (this._isDestroyed) return;
	            this.setWidths();
	            var delay = this.isBooted ? this.transitionTime : 0;
	            clearTimeout(this.resizeTimeout);
	            this.resizeTimeout = setTimeout(this.updateTabsView, delay);
	        },
	        overflowCheck: function overflowCheck(e, fn) {
	            this.isOverflowing && fn(e);
	        },
	        scrollTo: function scrollTo(direction) {
	            this.scrollOffset = this.newOffset(direction);
	        },
	        setOverflow: function setOverflow() {
	            this.isOverflowing = this.widths.bar < this.widths.container;
	        },
	        setWidths: function setWidths() {
	            var bar = this.$refs.bar ? this.$refs.bar.clientWidth : 0;
	            var container = this.$refs.container ? this.$refs.container.clientWidth : 0;
	            var wrapper = this.$refs.wrapper ? this.$refs.wrapper.clientWidth : 0;
	            this.widths = { bar: bar, container: container, wrapper: wrapper };
	            this.setOverflow();
	        },
	        parseNodes: function parseNodes() {
	            var item = [];
	            var items = [];
	            var slider = [];
	            var tab = [];
	            var length = (this.$slots.default || []).length;
	            for (var i = 0; i < length; i++) {
	                var vnode = this.$slots.default[i];
	                if (vnode.componentOptions) {
	                    switch (vnode.componentOptions.Ctor.options.name) {
	                        case 'v-tabs-slider':
	                            slider.push(vnode);
	                            break;
	                        case 'v-tabs-items':
	                            items.push(vnode);
	                            break;
	                        case 'v-tab-item':
	                            item.push(vnode);
	                            break;
	                        // case 'v-tab' - intentionally omitted
	                        default:
	                            tab.push(vnode);
	                    }
	                } else {
	                    tab.push(vnode);
	                }
	            }
	            return { tab: tab, slider: slider, items: items, item: item };
	        },
	        registerItems: function registerItems(fn) {
	            this.tabItems = fn;
	            fn(this.internalValue);
	        },
	        unregisterItems: function unregisterItems() {
	            this.tabItems = null;
	        },
	        updateTabsView: function updateTabsView() {
	            this.callSlider();
	            this.scrollIntoView();
	            this.checkIcons();
	        },
	        scrollIntoView: function scrollIntoView() {
	            /* istanbul ignore next */
	            if (!this.activeTab) return;
	            if (!this.isOverflowing) return this.scrollOffset = 0;
	            var totalWidth = this.widths.wrapper + this.scrollOffset;
	            var _a = this.activeTab.$el,
	                clientWidth = _a.clientWidth,
	                offsetLeft = _a.offsetLeft;
	            var itemOffset = clientWidth + offsetLeft;
	            var additionalOffset = clientWidth * 0.3;
	            if (this.activeTab === this.items[this.items.length - 1]) {
	                additionalOffset = 0; // don't add an offset if selecting the last tab
	            }
	            /* istanbul ignore else */
	            if (offsetLeft < this.scrollOffset) {
	                this.scrollOffset = Math.max(offsetLeft - additionalOffset, 0);
	            } else if (totalWidth < itemOffset) {
	                this.scrollOffset -= totalWidth - itemOffset - additionalOffset;
	            }
	        },
	        tabProxy: function tabProxy(val) {
	            this.internalValue = val;
	        }
	    },
	    render: function render(h) {
	        var _a = this.parseNodes(),
	            tab = _a.tab,
	            slider = _a.slider,
	            items = _a.items,
	            item = _a.item;
	        return h('div', {
	            staticClass: 'v-tabs',
	            directives: [{
	                name: 'resize',
	                modifiers: { quiet: true },
	                value: this.onResize
	            }]
	        }, [this.genBar([this.hideSlider ? null : this.genSlider(slider), tab]), h(_util_ThemeProvider__WEBPACK_IMPORTED_MODULE_13__["default"], {
	            props: { dark: this.theme.isDark, light: !this.theme.isDark }
	        }, [this.genItems(items, item)])]);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VTabs/VTabsItems.js":
	/*!********************************************!*\
	  !*** ./src/components/VTabs/VTabsItems.js ***!
	  \********************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VWindow_VWindow__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../VWindow/VWindow */ "./src/components/VWindow/VWindow.ts");
	// Extensions
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (_VWindow_VWindow__WEBPACK_IMPORTED_MODULE_0__["default"].extend({
	    name: 'v-tabs-items',
	    inject: {
	        registerItems: {
	            default: null
	        },
	        tabProxy: {
	            default: null
	        },
	        unregisterItems: {
	            default: null
	        }
	    },
	    props: {
	        cycle: Boolean
	    },
	    watch: {
	        internalValue: function internalValue(val) {
	            /* istanbul ignore else */
	            if (this.tabProxy) this.tabProxy(val);
	        }
	    },
	    created: function created() {
	        this.registerItems && this.registerItems(this.changeModel);
	    },
	    beforeDestroy: function beforeDestroy() {
	        this.unregisterItems && this.unregisterItems();
	    },
	    methods: {
	        changeModel: function changeModel(val) {
	            this.internalValue = val;
	        },
	        // For backwards compatability with v1.2
	        getValue: function getValue(item, i) {
	            /* istanbul ignore if */
	            if (item.id) return item.id;
	            return _VWindow_VWindow__WEBPACK_IMPORTED_MODULE_0__["default"].options.methods.getValue.call(this, item, i);
	        },
	        next: function next() {
	            if (!this.cycle && this.internalIndex === this.items.length - 1) {
	                return;
	            }
	            _VWindow_VWindow__WEBPACK_IMPORTED_MODULE_0__["default"].options.methods.next.call(this);
	        },
	        prev: function prev() {
	            if (!this.cycle && this.internalIndex === 0) {
	                return;
	            }
	            _VWindow_VWindow__WEBPACK_IMPORTED_MODULE_0__["default"].options.methods.prev.call(this);
	        }
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VTabs/VTabsSlider.js":
	/*!*********************************************!*\
	  !*** ./src/components/VTabs/VTabsSlider.js ***!
	  \*********************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-tabs-slider',
	    mixins: [_mixins_colorable__WEBPACK_IMPORTED_MODULE_0__["default"]],
	    render: function render(h) {
	        return h('div', this.setBackgroundColor(this.color || 'accent', {
	            staticClass: 'v-tabs__slider'
	        }));
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VTabs/index.js":
	/*!***************************************!*\
	  !*** ./src/components/VTabs/index.js ***!
	  \***************************************/
	/*! exports provided: VTabs, VTab, VTabItem, VTabsItems, VTabsSlider, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VTabs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VTabs */ "./src/components/VTabs/VTabs.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTabs", function() { return _VTabs__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	/* harmony import */ var _VTab__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./VTab */ "./src/components/VTabs/VTab.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTab", function() { return _VTab__WEBPACK_IMPORTED_MODULE_1__["default"]; });
	
	/* harmony import */ var _VTabsItems__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./VTabsItems */ "./src/components/VTabs/VTabsItems.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTabsItems", function() { return _VTabsItems__WEBPACK_IMPORTED_MODULE_2__["default"]; });
	
	/* harmony import */ var _VTabItem__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./VTabItem */ "./src/components/VTabs/VTabItem.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTabItem", function() { return _VTabItem__WEBPACK_IMPORTED_MODULE_3__["default"]; });
	
	/* harmony import */ var _VTabsSlider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./VTabsSlider */ "./src/components/VTabs/VTabsSlider.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTabsSlider", function() { return _VTabsSlider__WEBPACK_IMPORTED_MODULE_4__["default"]; });
	
	
	
	
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = ({
	    $_vuetify_subcomponents: {
	        VTabs: _VTabs__WEBPACK_IMPORTED_MODULE_0__["default"],
	        VTab: _VTab__WEBPACK_IMPORTED_MODULE_1__["default"],
	        VTabsItems: _VTabsItems__WEBPACK_IMPORTED_MODULE_2__["default"],
	        VTabItem: _VTabItem__WEBPACK_IMPORTED_MODULE_3__["default"],
	        VTabsSlider: _VTabsSlider__WEBPACK_IMPORTED_MODULE_4__["default"]
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VTabs/mixins/tabs-computed.js":
	/*!******************************************************!*\
	  !*** ./src/components/VTabs/mixins/tabs-computed.js ***!
	  \******************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/**
	 * Tabs computed
	 *
	 * @mixin
	 */
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    computed: {
	        activeTab: function activeTab() {
	            if (!this.selectedItems.length) return undefined;
	            return this.selectedItems[0];
	        },
	        containerStyles: function containerStyles() {
	            return this.height ? {
	                height: parseInt(this.height, 10) + "px"
	            } : null;
	        },
	        hasArrows: function hasArrows() {
	            return (this.showArrows || !this.isMobile) && this.isOverflowing;
	        },
	        isMobile: function isMobile() {
	            return this.$vuetify.breakpoint.width < this.mobileBreakPoint;
	        },
	        sliderStyles: function sliderStyles() {
	            return {
	                left: this.sliderLeft + "px",
	                transition: this.sliderLeft != null ? null : 'none',
	                width: this.sliderWidth + "px"
	            };
	        }
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VTabs/mixins/tabs-generators.js":
	/*!********************************************************!*\
	  !*** ./src/components/VTabs/mixins/tabs-generators.js ***!
	  \********************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VTabsItems__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../VTabsItems */ "./src/components/VTabs/VTabsItems.js");
	/* harmony import */ var _VTabsSlider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../VTabsSlider */ "./src/components/VTabs/VTabsSlider.js");
	/* harmony import */ var _VIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../VIcon */ "./src/components/VIcon/index.ts");
	
	
	
	/**
	 * Tabs generators
	 *
	 * @mixin
	 */
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    methods: {
	        genBar: function genBar(items) {
	            return this.$createElement('div', this.setBackgroundColor(this.color, {
	                staticClass: 'v-tabs__bar',
	                'class': this.themeClasses,
	                ref: 'bar'
	            }), [this.genTransition('prev'), this.genWrapper(this.genContainer(items)), this.genTransition('next')]);
	        },
	        genContainer: function genContainer(items) {
	            return this.$createElement('div', {
	                staticClass: 'v-tabs__container',
	                class: {
	                    'v-tabs__container--align-with-title': this.alignWithTitle,
	                    'v-tabs__container--centered': this.centered,
	                    'v-tabs__container--fixed-tabs': this.fixedTabs,
	                    'v-tabs__container--grow': this.grow,
	                    'v-tabs__container--icons-and-text': this.iconsAndText,
	                    'v-tabs__container--overflow': this.isOverflowing,
	                    'v-tabs__container--right': this.right
	                },
	                style: this.containerStyles,
	                ref: 'container'
	            }, items);
	        },
	        genIcon: function genIcon(direction) {
	            var _this = this;
	            if (!this.hasArrows || !this[direction + "IconVisible"]) return null;
	            return this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_2__["default"], {
	                staticClass: "v-tabs__icon v-tabs__icon--" + direction,
	                props: {
	                    disabled: !this[direction + "IconVisible"]
	                },
	                on: {
	                    click: function click() {
	                        return _this.scrollTo(direction);
	                    }
	                }
	            }, this[direction + "Icon"]);
	        },
	        genItems: function genItems(items, item) {
	            if (items.length > 0) return items;
	            if (!item.length) return null;
	            return this.$createElement(_VTabsItems__WEBPACK_IMPORTED_MODULE_0__["default"], item);
	        },
	        genTransition: function genTransition(direction) {
	            return this.$createElement('transition', {
	                props: { name: 'fade-transition' }
	            }, [this.genIcon(direction)]);
	        },
	        genWrapper: function genWrapper(items) {
	            var _this = this;
	            return this.$createElement('div', {
	                staticClass: 'v-tabs__wrapper',
	                class: {
	                    'v-tabs__wrapper--show-arrows': this.hasArrows
	                },
	                ref: 'wrapper',
	                directives: [{
	                    name: 'touch',
	                    value: {
	                        start: function start(e) {
	                            return _this.overflowCheck(e, _this.onTouchStart);
	                        },
	                        move: function move(e) {
	                            return _this.overflowCheck(e, _this.onTouchMove);
	                        },
	                        end: function end(e) {
	                            return _this.overflowCheck(e, _this.onTouchEnd);
	                        }
	                    }
	                }]
	            }, [items]);
	        },
	        genSlider: function genSlider(items) {
	            if (!items.length) {
	                items = [this.$createElement(_VTabsSlider__WEBPACK_IMPORTED_MODULE_1__["default"], {
	                    props: { color: this.sliderColor }
	                })];
	            }
	            return this.$createElement('div', {
	                staticClass: 'v-tabs__slider-wrapper',
	                style: this.sliderStyles
	            }, items);
	        }
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VTabs/mixins/tabs-props.js":
	/*!***************************************************!*\
	  !*** ./src/components/VTabs/mixins/tabs-props.js ***!
	  \***************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/**
	 * Tabs props
	 *
	 * @mixin
	 */
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    props: {
	        activeClass: {
	            type: String,
	            default: 'v-tabs__item--active'
	        },
	        alignWithTitle: Boolean,
	        centered: Boolean,
	        fixedTabs: Boolean,
	        grow: Boolean,
	        height: {
	            type: [Number, String],
	            default: undefined,
	            validator: function validator(v) {
	                return !isNaN(parseInt(v));
	            }
	        },
	        hideSlider: Boolean,
	        iconsAndText: Boolean,
	        mandatory: {
	            type: Boolean,
	            default: true
	        },
	        mobileBreakPoint: {
	            type: [Number, String],
	            default: 1264,
	            validator: function validator(v) {
	                return !isNaN(parseInt(v));
	            }
	        },
	        nextIcon: {
	            type: String,
	            default: '$vuetify.icons.next'
	        },
	        prevIcon: {
	            type: String,
	            default: '$vuetify.icons.prev'
	        },
	        right: Boolean,
	        showArrows: Boolean,
	        sliderColor: {
	            type: String,
	            default: 'accent'
	        },
	        value: [Number, String]
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VTabs/mixins/tabs-touch.js":
	/*!***************************************************!*\
	  !*** ./src/components/VTabs/mixins/tabs-touch.js ***!
	  \***************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/**
	 * Tabs touch
	 *
	 * @mixin
	 */
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    methods: {
	        newOffset: function newOffset(direction) {
	            var clientWidth = this.$refs.wrapper.clientWidth;
	            if (direction === 'prev') {
	                return Math.max(this.scrollOffset - clientWidth, 0);
	            } else {
	                return Math.min(this.scrollOffset + clientWidth, this.$refs.container.clientWidth - clientWidth);
	            }
	        },
	        onTouchStart: function onTouchStart(e) {
	            this.startX = this.scrollOffset + e.touchstartX;
	            this.$refs.container.style.transition = 'none';
	            this.$refs.container.style.willChange = 'transform';
	        },
	        onTouchMove: function onTouchMove(e) {
	            this.scrollOffset = this.startX - e.touchmoveX;
	        },
	        onTouchEnd: function onTouchEnd() {
	            var container = this.$refs.container;
	            var wrapper = this.$refs.wrapper;
	            var maxScrollOffset = container.clientWidth - wrapper.clientWidth;
	            container.style.transition = null;
	            container.style.willChange = null;
	            /* istanbul ignore else */
	            if (this.scrollOffset < 0 || !this.isOverflowing) {
	                this.scrollOffset = 0;
	            } else if (this.scrollOffset >= maxScrollOffset) {
	                this.scrollOffset = maxScrollOffset;
	            }
	        }
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VTabs/mixins/tabs-watchers.js":
	/*!******************************************************!*\
	  !*** ./src/components/VTabs/mixins/tabs-watchers.js ***!
	  \******************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/**
	 * Tabs watchers
	 *
	 * @mixin
	 */
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    watch: {
	        activeTab: function activeTab(val, oldVal) {
	            this.setOverflow();
	            if (!val) return;
	            this.tabItems && this.tabItems(this.getValue(val, this.items.indexOf(val)));
	            // Do nothing for first tab
	            // is handled from isBooted
	            // watcher
	            if (oldVal == null) return;
	            this.updateTabsView();
	        },
	        alignWithTitle: 'callSlider',
	        centered: 'callSlider',
	        fixedTabs: 'callSlider',
	        hasArrows: function hasArrows(val) {
	            if (!val) this.scrollOffset = 0;
	        },
	        /* @deprecate */
	        internalValue: function internalValue(val) {
	            /* istanbul ignore else */
	            if (!this.$listeners['input']) return;
	            this.$emit('input', val);
	        },
	        lazyValue: 'updateTabs',
	        right: 'callSlider',
	        '$vuetify.application.left': 'onResize',
	        '$vuetify.application.right': 'onResize',
	        scrollOffset: function scrollOffset(val) {
	            this.$refs.container.style.transform = "translateX(" + -val + "px)";
	            if (this.hasArrows) {
	                this.prevIconVisible = this.checkPrevIcon();
	                this.nextIconVisible = this.checkNextIcon();
	            }
	        }
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VTextField/VTextField.js":
	/*!*************************************************!*\
	  !*** ./src/components/VTextField/VTextField.js ***!
	  \*************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_text_fields_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_text-fields.styl */ "./src/stylus/components/_text-fields.styl");
	/* harmony import */ var _stylus_components_text_fields_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_text_fields_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _VInput__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../VInput */ "./src/components/VInput/index.ts");
	/* harmony import */ var _VCounter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../VCounter */ "./src/components/VCounter/index.ts");
	/* harmony import */ var _VLabel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../VLabel */ "./src/components/VLabel/index.ts");
	/* harmony import */ var _mixins_maskable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mixins/maskable */ "./src/mixins/maskable.js");
	/* harmony import */ var _mixins_loadable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mixins/loadable */ "./src/mixins/loadable.ts");
	/* harmony import */ var _directives_ripple__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../directives/ripple */ "./src/directives/ripple.ts");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../util/console */ "./src/util/console.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	// Styles
	
	// Extensions
	
	// Components
	
	
	// Mixins
	
	
	// Directives
	
	// Utilities
	
	
	var dirtyTypes = ['color', 'file', 'time', 'date', 'datetime-local', 'week', 'month'];
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (_VInput__WEBPACK_IMPORTED_MODULE_1__["default"].extend({
	    name: 'v-text-field',
	    directives: { Ripple: _directives_ripple__WEBPACK_IMPORTED_MODULE_6__["default"] },
	    mixins: [_mixins_maskable__WEBPACK_IMPORTED_MODULE_4__["default"], _mixins_loadable__WEBPACK_IMPORTED_MODULE_5__["default"]],
	    inheritAttrs: false,
	    props: {
	        appendOuterIcon: String,
	        /** @deprecated */
	        appendOuterIconCb: Function,
	        autofocus: Boolean,
	        box: Boolean,
	        browserAutocomplete: String,
	        clearable: Boolean,
	        clearIcon: {
	            type: String,
	            default: '$vuetify.icons.clear'
	        },
	        clearIconCb: Function,
	        color: {
	            type: String,
	            default: 'primary'
	        },
	        counter: [Boolean, Number, String],
	        flat: Boolean,
	        fullWidth: Boolean,
	        label: String,
	        outline: Boolean,
	        placeholder: String,
	        prefix: String,
	        prependInnerIcon: String,
	        /** @deprecated */
	        prependInnerIconCb: Function,
	        reverse: Boolean,
	        singleLine: Boolean,
	        solo: Boolean,
	        soloInverted: Boolean,
	        suffix: String,
	        type: {
	            type: String,
	            default: 'text'
	        }
	    },
	    data: function data() {
	        return {
	            badInput: false,
	            initialValue: null,
	            internalChange: false,
	            isClearing: false
	        };
	    },
	    computed: {
	        classes: function classes() {
	            return {
	                'v-text-field': true,
	                'v-text-field--full-width': this.fullWidth,
	                'v-text-field--prefix': this.prefix,
	                'v-text-field--single-line': this.isSingle,
	                'v-text-field--solo': this.isSolo,
	                'v-text-field--solo-inverted': this.soloInverted,
	                'v-text-field--solo-flat': this.flat,
	                'v-text-field--box': this.box,
	                'v-text-field--enclosed': this.isEnclosed,
	                'v-text-field--reverse': this.reverse,
	                'v-text-field--outline': this.hasOutline,
	                'v-text-field--placeholder': this.placeholder
	            };
	        },
	        counterValue: function counterValue() {
	            return (this.internalValue || '').toString().length;
	        },
	        directivesInput: function directivesInput() {
	            return [];
	        },
	        // TODO: Deprecate
	        hasOutline: function hasOutline() {
	            return this.outline || this.textarea;
	        },
	        internalValue: {
	            get: function get() {
	                return this.lazyValue;
	            },
	            set: function set(val) {
	                if (this.mask && val !== this.lazyValue) {
	                    this.lazyValue = this.unmaskText(this.maskText(this.unmaskText(val)));
	                    this.setSelectionRange();
	                } else {
	                    this.lazyValue = val;
	                    this.$emit('input', this.lazyValue);
	                }
	            }
	        },
	        isDirty: function isDirty() {
	            return this.lazyValue != null && this.lazyValue.toString().length > 0 || this.badInput;
	        },
	        isEnclosed: function isEnclosed() {
	            return this.box || this.isSolo || this.hasOutline || this.fullWidth;
	        },
	        isLabelActive: function isLabelActive() {
	            return this.isDirty || dirtyTypes.includes(this.type);
	        },
	        isSingle: function isSingle() {
	            return this.isSolo || this.singleLine;
	        },
	        isSolo: function isSolo() {
	            return this.solo || this.soloInverted;
	        },
	        labelPosition: function labelPosition() {
	            var offset = this.prefix && !this.labelValue ? this.prefixWidth : 0;
	            return !this.$vuetify.rtl !== !this.reverse ? {
	                left: 'auto',
	                right: offset
	            } : {
	                left: offset,
	                right: 'auto'
	            };
	        },
	        showLabel: function showLabel() {
	            return this.hasLabel && (!this.isSingle || !this.isLabelActive && !this.placeholder && !this.prefixLabel);
	        },
	        labelValue: function labelValue() {
	            return !this.isSingle && Boolean(this.isFocused || this.isLabelActive || this.placeholder || this.prefixLabel);
	        },
	        prefixWidth: function prefixWidth() {
	            if (!this.prefix && !this.$refs.prefix) return;
	            return this.$refs.prefix.offsetWidth;
	        },
	        prefixLabel: function prefixLabel() {
	            return this.prefix && !this.value;
	        }
	    },
	    watch: {
	        isFocused: function isFocused(val) {
	            // Sets validationState from validatable
	            this.hasColor = val;
	            if (val) {
	                this.initialValue = this.lazyValue;
	            } else if (this.initialValue !== this.lazyValue) {
	                this.$emit('change', this.lazyValue);
	            }
	        },
	        value: function value(val) {
	            var _this = this;
	            if (this.mask && !this.internalChange) {
	                var masked_1 = this.maskText(this.unmaskText(val));
	                this.lazyValue = this.unmaskText(masked_1);
	                // Emit when the externally set value was modified internally
	                String(val) !== this.lazyValue && this.$nextTick(function () {
	                    _this.$refs.input.value = masked_1;
	                    _this.$emit('input', _this.lazyValue);
	                });
	            } else this.lazyValue = val;
	        }
	    },
	    mounted: function mounted() {
	        this.autofocus && this.onFocus();
	    },
	    methods: {
	        /** @public */
	        focus: function focus() {
	            this.onFocus();
	        },
	        /** @public */
	        blur: function blur() {
	            this.$refs.input ? this.$refs.input.blur() : this.onBlur();
	        },
	        clearableCallback: function clearableCallback() {
	            var _this = this;
	            this.internalValue = null;
	            this.$nextTick(function () {
	                return _this.$refs.input.focus();
	            });
	        },
	        genAppendSlot: function genAppendSlot() {
	            var slot = [];
	            if (this.$slots['append-outer']) {
	                slot.push(this.$slots['append-outer']);
	            } else if (this.appendOuterIcon) {
	                slot.push(this.genIcon('appendOuter'));
	            }
	            return this.genSlot('append', 'outer', slot);
	        },
	        genPrependInnerSlot: function genPrependInnerSlot() {
	            var slot = [];
	            if (this.$slots['prepend-inner']) {
	                slot.push(this.$slots['prepend-inner']);
	            } else if (this.prependInnerIcon) {
	                slot.push(this.genIcon('prependInner'));
	            }
	            return this.genSlot('prepend', 'inner', slot);
	        },
	        genIconSlot: function genIconSlot() {
	            var slot = [];
	            if (this.$slots['append']) {
	                slot.push(this.$slots['append']);
	            } else if (this.appendIcon) {
	                slot.push(this.genIcon('append'));
	            }
	            return this.genSlot('append', 'inner', slot);
	        },
	        genInputSlot: function genInputSlot() {
	            var input = _VInput__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.genInputSlot.call(this);
	            var prepend = this.genPrependInnerSlot();
	            prepend && input.children.unshift(prepend);
	            return input;
	        },
	        genClearIcon: function genClearIcon() {
	            if (!this.clearable) return null;
	            var icon = !this.isDirty ? false : 'clear';
	            if (this.clearIconCb) Object(_util_console__WEBPACK_IMPORTED_MODULE_8__["deprecate"])(':clear-icon-cb', '@click:clear', this);
	            return this.genSlot('append', 'inner', [this.genIcon(icon, !this.$listeners['click:clear'] && this.clearIconCb || this.clearableCallback, false)]);
	        },
	        genCounter: function genCounter() {
	            if (this.counter === false || this.counter == null) return null;
	            var max = this.counter === true ? this.$attrs.maxlength : this.counter;
	            return this.$createElement(_VCounter__WEBPACK_IMPORTED_MODULE_2__["default"], {
	                props: {
	                    dark: this.dark,
	                    light: this.light,
	                    max: max,
	                    value: this.counterValue
	                }
	            });
	        },
	        genDefaultSlot: function genDefaultSlot() {
	            return [this.genTextFieldSlot(), this.genClearIcon(), this.genIconSlot(), this.genProgress()];
	        },
	        genLabel: function genLabel() {
	            if (!this.showLabel) return null;
	            var data = {
	                props: {
	                    absolute: true,
	                    color: this.validationState,
	                    dark: this.dark,
	                    disabled: this.disabled,
	                    focused: !this.isSingle && (this.isFocused || !!this.validationState),
	                    left: this.labelPosition.left,
	                    light: this.light,
	                    right: this.labelPosition.right,
	                    value: this.labelValue
	                }
	            };
	            if (this.$attrs.id) data.props.for = this.$attrs.id;
	            return this.$createElement(_VLabel__WEBPACK_IMPORTED_MODULE_3__["default"], data, this.$slots.label || this.label);
	        },
	        genInput: function genInput() {
	            var listeners = Object.assign({}, this.$listeners);
	            delete listeners['change']; // Change should not be bound externally
	            var data = {
	                style: {},
	                domProps: {
	                    value: this.maskText(this.lazyValue)
	                },
	                attrs: __assign({ 'aria-label': (!this.$attrs || !this.$attrs.id) && this.label }, this.$attrs, { autofocus: this.autofocus, disabled: this.disabled, readonly: this.readonly, type: this.type }),
	                on: Object.assign(listeners, {
	                    blur: this.onBlur,
	                    input: this.onInput,
	                    focus: this.onFocus,
	                    keydown: this.onKeyDown
	                }),
	                ref: 'input'
	            };
	            if (this.placeholder) data.attrs.placeholder = this.placeholder;
	            if (this.mask) data.attrs.maxlength = this.masked.length;
	            if (this.browserAutocomplete) data.attrs.autocomplete = this.browserAutocomplete;
	            return this.$createElement('input', data);
	        },
	        genMessages: function genMessages() {
	            if (this.hideDetails) return null;
	            return this.$createElement('div', {
	                staticClass: 'v-text-field__details'
	            }, [_VInput__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.genMessages.call(this), this.genCounter()]);
	        },
	        genTextFieldSlot: function genTextFieldSlot() {
	            return this.$createElement('div', {
	                staticClass: 'v-text-field__slot'
	            }, [this.genLabel(), this.prefix ? this.genAffix('prefix') : null, this.genInput(), this.suffix ? this.genAffix('suffix') : null]);
	        },
	        genAffix: function genAffix(type) {
	            return this.$createElement('div', {
	                'class': "v-text-field__" + type,
	                ref: type
	            }, this[type]);
	        },
	        onBlur: function onBlur(e) {
	            this.isFocused = false;
	            // Reset internalChange state
	            // to allow external change
	            // to persist
	            this.internalChange = false;
	            this.$emit('blur', e);
	        },
	        onClick: function onClick() {
	            if (this.isFocused || this.disabled) return;
	            this.$refs.input.focus();
	        },
	        onFocus: function onFocus(e) {
	            if (!this.$refs.input) return;
	            if (document.activeElement !== this.$refs.input) {
	                return this.$refs.input.focus();
	            }
	            if (!this.isFocused) {
	                this.isFocused = true;
	                this.$emit('focus', e);
	            }
	        },
	        onInput: function onInput(e) {
	            this.internalChange = true;
	            this.mask && this.resetSelections(e.target);
	            this.internalValue = e.target.value;
	            this.badInput = e.target.validity && e.target.validity.badInput;
	        },
	        onKeyDown: function onKeyDown(e) {
	            this.internalChange = true;
	            if (e.keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_7__["keyCodes"].enter) this.$emit('change', this.internalValue);
	            this.$emit('keydown', e);
	        },
	        onMouseDown: function onMouseDown(e) {
	            // Prevent input from being blurred
	            if (e.target !== this.$refs.input) {
	                e.preventDefault();
	                e.stopPropagation();
	            }
	            _VInput__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.onMouseDown.call(this, e);
	        },
	        onMouseUp: function onMouseUp(e) {
	            if (this.hasMouseDown) this.focus();
	            _VInput__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.onMouseUp.call(this, e);
	        }
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VTextField/index.js":
	/*!********************************************!*\
	  !*** ./src/components/VTextField/index.js ***!
	  \********************************************/
	/*! exports provided: VTextField, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VTextField", function() { return wrapper; });
	/* harmony import */ var _VTextField__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VTextField */ "./src/components/VTextField/VTextField.js");
	/* harmony import */ var _VTextarea_VTextarea__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../VTextarea/VTextarea */ "./src/components/VTextarea/VTextarea.js");
	/* harmony import */ var _util_rebuildFunctionalSlots__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../util/rebuildFunctionalSlots */ "./src/util/rebuildFunctionalSlots.ts");
	/* harmony import */ var _util_dedupeModelListeners__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../util/dedupeModelListeners */ "./src/util/dedupeModelListeners.ts");
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../util/console */ "./src/util/console.ts");
	
	
	
	
	
	// TODO: remove this in v2.0
	/* @vue/component */
	var wrapper = {
	    functional: true,
	    $_wrapperFor: _VTextField__WEBPACK_IMPORTED_MODULE_0__["default"],
	    props: {
	        textarea: Boolean,
	        multiLine: Boolean
	    },
	    render: function render(h, _a) {
	        var props = _a.props,
	            data = _a.data,
	            slots = _a.slots,
	            parent = _a.parent;
	        Object(_util_dedupeModelListeners__WEBPACK_IMPORTED_MODULE_3__["default"])(data);
	        var children = Object(_util_rebuildFunctionalSlots__WEBPACK_IMPORTED_MODULE_2__["default"])(slots(), h);
	        if (props.textarea) {
	            Object(_util_console__WEBPACK_IMPORTED_MODULE_4__["deprecate"])('<v-text-field textarea>', '<v-textarea outline>', wrapper, parent);
	        }
	        if (props.multiLine) {
	            Object(_util_console__WEBPACK_IMPORTED_MODULE_4__["deprecate"])('<v-text-field multi-line>', '<v-textarea>', wrapper, parent);
	        }
	        if (props.textarea || props.multiLine) {
	            data.attrs.outline = props.textarea;
	            return h(_VTextarea_VTextarea__WEBPACK_IMPORTED_MODULE_1__["default"], data, children);
	        } else {
	            return h(_VTextField__WEBPACK_IMPORTED_MODULE_0__["default"], data, children);
	        }
	    }
	};
	
	/* harmony default export */ __webpack_exports__["default"] = (wrapper);
	
	/***/ }),
	
	/***/ "./src/components/VTextarea/VTextarea.js":
	/*!***********************************************!*\
	  !*** ./src/components/VTextarea/VTextarea.js ***!
	  \***********************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_textarea_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_textarea.styl */ "./src/stylus/components/_textarea.styl");
	/* harmony import */ var _stylus_components_textarea_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_textarea_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _VTextField_VTextField__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../VTextField/VTextField */ "./src/components/VTextField/VTextField.js");
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../util/console */ "./src/util/console.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	// Styles
	
	// Extensions
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-textarea',
	    extends: _VTextField_VTextField__WEBPACK_IMPORTED_MODULE_1__["default"],
	    props: {
	        autoGrow: Boolean,
	        noResize: Boolean,
	        outline: Boolean,
	        rowHeight: {
	            type: [Number, String],
	            default: 24,
	            validator: function validator(v) {
	                return !isNaN(parseFloat(v));
	            }
	        },
	        rows: {
	            type: [Number, String],
	            default: 5,
	            validator: function validator(v) {
	                return !isNaN(parseInt(v, 10));
	            }
	        }
	    },
	    computed: {
	        classes: function classes() {
	            return __assign({ 'v-textarea': true, 'v-textarea--auto-grow': this.autoGrow, 'v-textarea--no-resize': this.noResizeHandle }, _VTextField_VTextField__WEBPACK_IMPORTED_MODULE_1__["default"].options.computed.classes.call(this, null));
	        },
	        dynamicHeight: function dynamicHeight() {
	            return this.autoGrow ? this.inputHeight : 'auto';
	        },
	        isEnclosed: function isEnclosed() {
	            return this.textarea || _VTextField_VTextField__WEBPACK_IMPORTED_MODULE_1__["default"].options.computed.isEnclosed.call(this);
	        },
	        noResizeHandle: function noResizeHandle() {
	            return this.noResize || this.autoGrow;
	        }
	    },
	    watch: {
	        lazyValue: function lazyValue() {
	            !this.internalChange && this.autoGrow && this.$nextTick(this.calculateInputHeight);
	        }
	    },
	    mounted: function mounted() {
	        var _this = this;
	        setTimeout(function () {
	            _this.autoGrow && _this.calculateInputHeight();
	        }, 0);
	        // TODO: remove (2.0)
	        if (this.autoGrow && this.noResize) {
	            Object(_util_console__WEBPACK_IMPORTED_MODULE_2__["consoleInfo"])('"no-resize" is now implied when using "auto-grow", and can be removed', this);
	        }
	    },
	    methods: {
	        calculateInputHeight: function calculateInputHeight() {
	            var input = this.$refs.input;
	            if (input) {
	                input.style.height = 0;
	                var height = input.scrollHeight;
	                var minHeight = parseInt(this.rows, 10) * parseFloat(this.rowHeight);
	                // This has to be done ASAP, waiting for Vue
	                // to update the DOM causes ugly layout jumping
	                input.style.height = Math.max(minHeight, height) + 'px';
	            }
	        },
	        genInput: function genInput() {
	            var input = _VTextField_VTextField__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.genInput.call(this);
	            input.tag = 'textarea';
	            delete input.data.attrs.type;
	            input.data.attrs.rows = this.rows;
	            return input;
	        },
	        onInput: function onInput(e) {
	            _VTextField_VTextField__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.onInput.call(this, e);
	            this.autoGrow && this.calculateInputHeight();
	        },
	        onKeyDown: function onKeyDown(e) {
	            // Prevents closing of a
	            // dialog when pressing
	            // enter
	            if (this.isFocused && e.keyCode === 13) {
	                e.stopPropagation();
	            }
	            this.internalChange = true;
	            this.$emit('keydown', e);
	        }
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VTextarea/index.js":
	/*!*******************************************!*\
	  !*** ./src/components/VTextarea/index.js ***!
	  \*******************************************/
	/*! exports provided: VTextarea, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VTextarea__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VTextarea */ "./src/components/VTextarea/VTextarea.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTextarea", function() { return _VTextarea__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VTextarea__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VTimePicker/VTimePicker.ts":
	/*!***************************************************!*\
	  !*** ./src/components/VTimePicker/VTimePicker.ts ***!
	  \***************************************************/
	/*! exports provided: selectingTimes, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectingTimes", function() { return selectingTimes; });
	/* harmony import */ var _VTimePickerTitle__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VTimePickerTitle */ "./src/components/VTimePicker/VTimePickerTitle.ts");
	/* harmony import */ var _VTimePickerClock__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./VTimePickerClock */ "./src/components/VTimePicker/VTimePickerClock.ts");
	/* harmony import */ var _mixins_picker__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/picker */ "./src/mixins/picker.ts");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var _VDatePicker_util_pad__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../VDatePicker/util/pad */ "./src/components/VDatePicker/util/pad.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	var __read = undefined && undefined.__read || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o),
	        r,
	        ar = [],
	        e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
	            ar.push(r.value);
	        }
	    } catch (error) {
	        e = { error: error };
	    } finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        } finally {
	            if (e) throw e.error;
	        }
	    }
	    return ar;
	};
	// Components
	
	
	// Mixins
	
	// Utils
	
	
	
	var rangeHours24 = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["createRange"])(24);
	var rangeHours12am = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["createRange"])(12);
	var rangeHours12pm = rangeHours12am.map(function (v) {
	    return v + 12;
	});
	var range60 = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["createRange"])(60);
	var selectingTimes = { hour: 1, minute: 2, second: 3 };
	var selectingNames = { 1: 'hour', 2: 'minute', 3: 'second' };
	
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_5__["default"])(_mixins_picker__WEBPACK_IMPORTED_MODULE_2__["default"]
	/* @vue/component */
	).extend({
	    name: 'v-time-picker',
	    props: {
	        allowedHours: Function,
	        allowedMinutes: Function,
	        allowedSeconds: Function,
	        disabled: Boolean,
	        format: {
	            type: String,
	            default: 'ampm',
	            validator: function validator(val) {
	                return ['ampm', '24hr'].includes(val);
	            }
	        },
	        min: String,
	        max: String,
	        readonly: Boolean,
	        scrollable: Boolean,
	        useSeconds: Boolean,
	        value: null
	    },
	    data: function data() {
	        return {
	            inputHour: null,
	            inputMinute: null,
	            inputSecond: null,
	            lazyInputHour: null,
	            lazyInputMinute: null,
	            lazyInputSecond: null,
	            period: 'am',
	            selecting: selectingTimes.hour
	        };
	    },
	    computed: {
	        selectingHour: {
	            get: function get() {
	                return this.selecting === selectingTimes.hour;
	            },
	            set: function set(v) {
	                this.selecting = selectingTimes.hour;
	            }
	        },
	        selectingMinute: {
	            get: function get() {
	                return this.selecting === selectingTimes.minute;
	            },
	            set: function set(v) {
	                this.selecting = selectingTimes.minute;
	            }
	        },
	        selectingSecond: {
	            get: function get() {
	                return this.selecting === selectingTimes.second;
	            },
	            set: function set(v) {
	                this.selecting = selectingTimes.second;
	            }
	        },
	        isAllowedHourCb: function isAllowedHourCb() {
	            var _this = this;
	            if (!this.min && !this.max) return this.allowedHours;
	            var minHour = this.min ? Number(this.min.split(':')[0]) : 0;
	            var maxHour = this.max ? Number(this.max.split(':')[0]) : 23;
	            return function (val) {
	                return val >= minHour * 1 && val <= maxHour * 1 && (!_this.allowedHours || _this.allowedHours(val));
	            };
	        },
	        isAllowedMinuteCb: function isAllowedMinuteCb() {
	            var _this = this;
	            var isHourAllowed = !this.allowedHours || this.allowedHours(this.inputHour);
	            if (!this.min && !this.max) {
	                return isHourAllowed ? this.allowedMinutes : function () {
	                    return false;
	                };
	            }
	            var _a = __read(this.min ? this.min.split(':').map(Number) : [0, 0], 2),
	                minHour = _a[0],
	                minMinute = _a[1];
	            var _b = __read(this.max ? this.max.split(':').map(Number) : [23, 59], 2),
	                maxHour = _b[0],
	                maxMinute = _b[1];
	            var minTime = minHour * 60 + minMinute * 1;
	            var maxTime = maxHour * 60 + maxMinute * 1;
	            return function (val) {
	                var time = 60 * _this.inputHour + val;
	                return time >= minTime && time <= maxTime && isHourAllowed && (!_this.allowedMinutes || _this.allowedMinutes(val));
	            };
	        },
	        isAllowedSecondCb: function isAllowedSecondCb() {
	            var _this = this;
	            var isHourAllowed = !this.allowedHours || this.allowedHours(this.inputHour);
	            var isMinuteAllowed = !this.allowedMinutes || this.allowedMinutes(this.inputMinute);
	            if (!this.min && !this.max) {
	                return isHourAllowed && isMinuteAllowed ? this.allowedSeconds : function () {
	                    return false;
	                };
	            }
	            var _a = __read(this.min ? this.min.split(':').map(Number) : [0, 0, 0], 3),
	                minHour = _a[0],
	                minMinute = _a[1],
	                minSecond = _a[2];
	            var _b = __read(this.max ? this.max.split(':').map(Number) : [23, 59, 59], 3),
	                maxHour = _b[0],
	                maxMinute = _b[1],
	                maxSecond = _b[2];
	            var minTime = minHour * 3600 + minMinute * 60 + (minSecond || 0) * 1;
	            var maxTime = maxHour * 3600 + maxMinute * 60 + (maxSecond || 0) * 1;
	            return function (val) {
	                var time = 3600 * _this.inputHour + 60 * _this.inputMinute + val;
	                return time >= minTime && time <= maxTime && isHourAllowed && isMinuteAllowed && (!_this.allowedSeconds || _this.allowedSeconds(val));
	            };
	        },
	        isAmPm: function isAmPm() {
	            return this.format === 'ampm';
	        }
	    },
	    watch: {
	        value: 'setInputData'
	    },
	    mounted: function mounted() {
	        this.setInputData(this.value);
	    },
	    methods: {
	        genValue: function genValue() {
	            if (this.inputHour != null && this.inputMinute != null && (!this.useSeconds || this.inputSecond != null)) {
	                return Object(_VDatePicker_util_pad__WEBPACK_IMPORTED_MODULE_4__["default"])(this.inputHour) + ":" + Object(_VDatePicker_util_pad__WEBPACK_IMPORTED_MODULE_4__["default"])(this.inputMinute) + (this.useSeconds ? ":" + Object(_VDatePicker_util_pad__WEBPACK_IMPORTED_MODULE_4__["default"])(this.inputSecond) : '');
	            }
	            return null;
	        },
	        emitValue: function emitValue() {
	            var value = this.genValue();
	            if (value !== null) this.$emit('input', value);
	        },
	        setPeriod: function setPeriod(period) {
	            this.period = period;
	            if (this.inputHour != null) {
	                var newHour = this.inputHour + (period === 'am' ? -12 : 12);
	                this.inputHour = this.firstAllowed('hour', newHour);
	                this.emitValue();
	            }
	        },
	        setInputData: function setInputData(value) {
	            if (value == null || value === '') {
	                this.inputHour = null;
	                this.inputMinute = null;
	                this.inputSecond = null;
	            } else if (value instanceof Date) {
	                this.inputHour = value.getHours();
	                this.inputMinute = value.getMinutes();
	                this.inputSecond = value.getSeconds();
	            } else {
	                var _a = __read(value.trim().toLowerCase().match(/^(\d+):(\d+)(:(\d+))?([ap]m)?$/) || new Array(6), 6),
	                    hour = _a[1],
	                    minute = _a[2],
	                    second = _a[4],
	                    period = _a[5];
	                this.inputHour = period ? this.convert12to24(parseInt(hour, 10), period) : parseInt(hour, 10);
	                this.inputMinute = parseInt(minute, 10);
	                this.inputSecond = parseInt(second || 0, 10);
	            }
	            this.period = this.inputHour == null || this.inputHour < 12 ? 'am' : 'pm';
	        },
	        convert24to12: function convert24to12(hour) {
	            return hour ? (hour - 1) % 12 + 1 : 12;
	        },
	        convert12to24: function convert12to24(hour, period) {
	            return hour % 12 + (period === 'pm' ? 12 : 0);
	        },
	        onInput: function onInput(value) {
	            if (this.selecting === selectingTimes.hour) {
	                this.inputHour = this.isAmPm ? this.convert12to24(value, this.period) : value;
	            } else if (this.selecting === selectingTimes.minute) {
	                this.inputMinute = value;
	            } else {
	                this.inputSecond = value;
	            }
	            this.emitValue();
	        },
	        onChange: function onChange(value) {
	            this.$emit("click:" + selectingNames[this.selecting], value);
	            var emitChange = this.selecting === (this.useSeconds ? selectingTimes.second : selectingTimes.minute);
	            if (this.selecting === selectingTimes.hour) {
	                this.selecting = selectingTimes.minute;
	            } else if (this.useSeconds && this.selecting === selectingTimes.minute) {
	                this.selecting = selectingTimes.second;
	            }
	            if (this.inputHour === this.lazyInputHour && this.inputMinute === this.lazyInputMinute && (!this.useSeconds || this.inputSecond === this.lazyInputSecond)) return;
	            var time = this.genValue();
	            if (time === null) return;
	            this.lazyInputHour = this.inputHour;
	            this.lazyInputMinute = this.inputMinute;
	            this.useSeconds && (this.lazyInputSecond = this.inputSecond);
	            emitChange && this.$emit('change', time);
	        },
	        firstAllowed: function firstAllowed(type, value) {
	            var allowedFn = type === 'hour' ? this.isAllowedHourCb : type === 'minute' ? this.isAllowedMinuteCb : this.isAllowedSecondCb;
	            if (!allowedFn) return value;
	            // TODO: clean up
	            var range = type === 'minute' ? range60 : type === 'second' ? range60 : this.isAmPm ? value < 12 ? rangeHours12am : rangeHours12pm : rangeHours24;
	            var first = range.find(function (v) {
	                return allowedFn((v + value) % range.length + range[0]);
	            });
	            return ((first || 0) + value) % range.length + range[0];
	        },
	        genClock: function genClock() {
	            return this.$createElement(_VTimePickerClock__WEBPACK_IMPORTED_MODULE_1__["default"], {
	                props: {
	                    allowedValues: this.selecting === selectingTimes.hour ? this.isAllowedHourCb : this.selecting === selectingTimes.minute ? this.isAllowedMinuteCb : this.isAllowedSecondCb,
	                    color: this.color,
	                    dark: this.dark,
	                    disabled: this.disabled,
	                    double: this.selecting === selectingTimes.hour && !this.isAmPm,
	                    format: this.selecting === selectingTimes.hour ? this.isAmPm ? this.convert24to12 : function (val) {
	                        return val;
	                    } : function (val) {
	                        return Object(_VDatePicker_util_pad__WEBPACK_IMPORTED_MODULE_4__["default"])(val, 2);
	                    },
	                    light: this.light,
	                    max: this.selecting === selectingTimes.hour ? this.isAmPm && this.period === 'am' ? 11 : 23 : 59,
	                    min: this.selecting === selectingTimes.hour && this.isAmPm && this.period === 'pm' ? 12 : 0,
	                    readonly: this.readonly,
	                    scrollable: this.scrollable,
	                    size: Number(this.width) - (!this.fullWidth && this.landscape ? 80 : 20),
	                    step: this.selecting === selectingTimes.hour ? 1 : 5,
	                    value: this.selecting === selectingTimes.hour ? this.inputHour : this.selecting === selectingTimes.minute ? this.inputMinute : this.inputSecond
	                },
	                on: {
	                    input: this.onInput,
	                    change: this.onChange
	                },
	                ref: 'clock'
	            });
	        },
	        genPickerBody: function genPickerBody() {
	            return this.$createElement('div', {
	                staticClass: 'v-time-picker-clock__container',
	                key: this.selecting
	            }, [this.genClock()]);
	        },
	        genPickerTitle: function genPickerTitle() {
	            var _this = this;
	            return this.$createElement(_VTimePickerTitle__WEBPACK_IMPORTED_MODULE_0__["default"], {
	                props: {
	                    ampm: this.isAmPm,
	                    disabled: this.disabled,
	                    hour: this.inputHour,
	                    minute: this.inputMinute,
	                    second: this.inputSecond,
	                    period: this.period,
	                    readonly: this.readonly,
	                    useSeconds: this.useSeconds,
	                    selecting: this.selecting
	                },
	                on: {
	                    'update:selecting': function updateSelecting(value) {
	                        return _this.selecting = value;
	                    },
	                    'update:period': this.setPeriod
	                },
	                ref: 'title',
	                slot: 'title'
	            });
	        }
	    },
	    render: function render() {
	        return this.genPicker('v-picker--time');
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VTimePicker/VTimePickerClock.ts":
	/*!********************************************************!*\
	  !*** ./src/components/VTimePicker/VTimePickerClock.ts ***!
	  \********************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_time_picker_clock_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_time-picker-clock.styl */ "./src/stylus/components/_time-picker-clock.styl");
	/* harmony import */ var _stylus_components_time_picker_clock_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_time_picker_clock_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	
	// Mixins
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_3__["default"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_1__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__["default"]
	/* @vue/component */
	).extend({
	    name: 'v-time-picker-clock',
	    props: {
	        allowedValues: Function,
	        disabled: Boolean,
	        double: Boolean,
	        format: {
	            type: Function,
	            default: function _default(val) {
	                return val;
	            }
	        },
	        max: {
	            type: Number,
	            required: true
	        },
	        min: {
	            type: Number,
	            required: true
	        },
	        scrollable: Boolean,
	        readonly: Boolean,
	        rotate: {
	            type: Number,
	            default: 0
	        },
	        step: {
	            type: Number,
	            default: 1
	        },
	        value: Number
	    },
	    data: function data() {
	        return {
	            inputValue: this.value,
	            isDragging: false,
	            valueOnMouseDown: null,
	            valueOnMouseUp: null
	        };
	    },
	    computed: {
	        count: function count() {
	            return this.max - this.min + 1;
	        },
	        degreesPerUnit: function degreesPerUnit() {
	            return 360 / this.roundCount;
	        },
	        degrees: function degrees() {
	            return this.degreesPerUnit * Math.PI / 180;
	        },
	        displayedValue: function displayedValue() {
	            return this.value == null ? this.min : this.value;
	        },
	        innerRadiusScale: function innerRadiusScale() {
	            return 0.62;
	        },
	        roundCount: function roundCount() {
	            return this.double ? this.count / 2 : this.count;
	        }
	    },
	    watch: {
	        value: function value(_value) {
	            this.inputValue = _value;
	        }
	    },
	    methods: {
	        wheel: function wheel(e) {
	            e.preventDefault();
	            var delta = Math.sign(-e.deltaY || 1);
	            var value = this.displayedValue;
	            do {
	                value = value + delta;
	                value = (value - this.min + this.count) % this.count + this.min;
	            } while (!this.isAllowed(value) && value !== this.displayedValue);
	            if (value !== this.displayedValue) {
	                this.update(value);
	            }
	        },
	        isInner: function isInner(value) {
	            return this.double && value - this.min >= this.roundCount;
	        },
	        handScale: function handScale(value) {
	            return this.isInner(value) ? this.innerRadiusScale : 1;
	        },
	        isAllowed: function isAllowed(value) {
	            return !this.allowedValues || this.allowedValues(value);
	        },
	        genValues: function genValues() {
	            var children = [];
	            for (var value = this.min; value <= this.max; value = value + this.step) {
	                var color = value === this.value && (this.color || 'accent');
	                children.push(this.$createElement('span', this.setBackgroundColor(color, {
	                    staticClass: 'v-time-picker-clock__item',
	                    'class': {
	                        'v-time-picker-clock__item--active': value === this.displayedValue,
	                        'v-time-picker-clock__item--disabled': this.disabled || !this.isAllowed(value)
	                    },
	                    style: this.getTransform(value),
	                    domProps: { innerHTML: "<span>" + this.format(value) + "</span>" }
	                })));
	            }
	            return children;
	        },
	        genHand: function genHand() {
	            var scale = "scaleY(" + this.handScale(this.displayedValue) + ")";
	            var angle = this.rotate + this.degreesPerUnit * (this.displayedValue - this.min);
	            var color = this.value != null && (this.color || 'accent');
	            return this.$createElement('div', this.setBackgroundColor(color, {
	                staticClass: 'v-time-picker-clock__hand',
	                'class': {
	                    'v-time-picker-clock__hand--inner': this.isInner(this.value)
	                },
	                style: {
	                    transform: "rotate(" + angle + "deg) " + scale
	                }
	            }));
	        },
	        getTransform: function getTransform(i) {
	            var _a = this.getPosition(i),
	                x = _a.x,
	                y = _a.y;
	            return {
	                left: 50 + x * 50 + "%",
	                top: 50 + y * 50 + "%"
	            };
	        },
	        getPosition: function getPosition(value) {
	            var rotateRadians = this.rotate * Math.PI / 180;
	            return {
	                x: Math.sin((value - this.min) * this.degrees + rotateRadians) * this.handScale(value),
	                y: -Math.cos((value - this.min) * this.degrees + rotateRadians) * this.handScale(value)
	            };
	        },
	        onMouseDown: function onMouseDown(e) {
	            e.preventDefault();
	            this.valueOnMouseDown = null;
	            this.valueOnMouseUp = null;
	            this.isDragging = true;
	            this.onDragMove(e);
	        },
	        onMouseUp: function onMouseUp() {
	            this.isDragging = false;
	            if (this.valueOnMouseUp !== null && this.isAllowed(this.valueOnMouseUp)) {
	                this.$emit('change', this.valueOnMouseUp);
	            }
	        },
	        onDragMove: function onDragMove(e) {
	            e.preventDefault();
	            if (!this.isDragging && e.type !== 'click') return;
	            var _a = this.$refs.clock.getBoundingClientRect(),
	                width = _a.width,
	                top = _a.top,
	                left = _a.left;
	            var innerWidth = this.$refs.innerClock.getBoundingClientRect().width;
	            var _b = 'touches' in e ? e.touches[0] : e,
	                clientX = _b.clientX,
	                clientY = _b.clientY;
	            var center = { x: width / 2, y: -width / 2 };
	            var coords = { x: clientX - left, y: top - clientY };
	            var handAngle = Math.round(this.angle(center, coords) - this.rotate + 360) % 360;
	            var insideClick = this.double && this.euclidean(center, coords) < (innerWidth + innerWidth * this.innerRadiusScale) / 4;
	            var value = (Math.round(handAngle / this.degreesPerUnit) + (insideClick ? this.roundCount : 0)) % this.count + this.min;
	            // Necessary to fix edge case when selecting left part of the value(s) at 12 o'clock
	            var newValue;
	            if (handAngle >= 360 - this.degreesPerUnit / 2) {
	                newValue = insideClick ? this.max - this.roundCount + 1 : this.min;
	            } else {
	                newValue = value;
	            }
	            if (this.isAllowed(value)) {
	                if (this.valueOnMouseDown === null) {
	                    this.valueOnMouseDown = newValue;
	                }
	                this.valueOnMouseUp = newValue;
	                this.update(newValue);
	            }
	        },
	        update: function update(value) {
	            if (this.inputValue !== value) {
	                this.inputValue = value;
	                this.$emit('input', value);
	            }
	        },
	        euclidean: function euclidean(p0, p1) {
	            var dx = p1.x - p0.x;
	            var dy = p1.y - p0.y;
	            return Math.sqrt(dx * dx + dy * dy);
	        },
	        angle: function angle(center, p1) {
	            var value = 2 * Math.atan2(p1.y - center.y - this.euclidean(center, p1), p1.x - center.x);
	            return Math.abs(value * 180 / Math.PI);
	        }
	    },
	    render: function render(h) {
	        var _this = this;
	        var data = {
	            staticClass: 'v-time-picker-clock',
	            class: __assign({ 'v-time-picker-clock--indeterminate': this.value == null }, this.themeClasses),
	            on: this.readonly || this.disabled ? undefined : Object.assign({
	                mousedown: this.onMouseDown,
	                mouseup: this.onMouseUp,
	                mouseleave: function mouseleave() {
	                    return _this.isDragging && _this.onMouseUp();
	                },
	                touchstart: this.onMouseDown,
	                touchend: this.onMouseUp,
	                mousemove: this.onDragMove,
	                touchmove: this.onDragMove
	            }, this.scrollable ? {
	                wheel: this.wheel
	            } : {}),
	            ref: 'clock'
	        };
	        return h('div', data, [h('div', {
	            staticClass: 'v-time-picker-clock__inner',
	            ref: 'innerClock'
	        }, [this.genHand(), this.genValues()])]);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VTimePicker/VTimePickerTitle.ts":
	/*!********************************************************!*\
	  !*** ./src/components/VTimePicker/VTimePickerTitle.ts ***!
	  \********************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_time_picker_title_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_time-picker-title.styl */ "./src/stylus/components/_time-picker-title.styl");
	/* harmony import */ var _stylus_components_time_picker_title_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_time_picker_title_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_picker_button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/picker-button */ "./src/mixins/picker-button.ts");
	/* harmony import */ var _VDatePicker_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../VDatePicker/util */ "./src/components/VDatePicker/util/index.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	/* harmony import */ var _VTimePicker__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./VTimePicker */ "./src/components/VTimePicker/VTimePicker.ts");
	
	// Mixins
	
	// Utils
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_3__["default"])(_mixins_picker_button__WEBPACK_IMPORTED_MODULE_1__["default"]
	/* @vue/component */
	).extend({
	    name: 'v-time-picker-title',
	    props: {
	        ampm: Boolean,
	        disabled: Boolean,
	        hour: Number,
	        minute: Number,
	        second: Number,
	        period: {
	            type: String,
	            validator: function validator(period) {
	                return period === 'am' || period === 'pm';
	            }
	        },
	        readonly: Boolean,
	        useSeconds: Boolean,
	        selecting: Number
	    },
	    methods: {
	        genTime: function genTime() {
	            var hour = this.hour;
	            if (this.ampm) {
	                hour = hour ? (hour - 1) % 12 + 1 : 12;
	            }
	            var displayedHour = this.hour == null ? '--' : this.ampm ? String(hour) : Object(_VDatePicker_util__WEBPACK_IMPORTED_MODULE_2__["pad"])(hour);
	            var displayedMinute = this.minute == null ? '--' : Object(_VDatePicker_util__WEBPACK_IMPORTED_MODULE_2__["pad"])(this.minute);
	            var titleContent = [this.genPickerButton('selecting', _VTimePicker__WEBPACK_IMPORTED_MODULE_4__["selectingTimes"].hour, displayedHour, this.disabled), this.$createElement('span', ':'), this.genPickerButton('selecting', _VTimePicker__WEBPACK_IMPORTED_MODULE_4__["selectingTimes"].minute, displayedMinute, this.disabled)];
	            if (this.useSeconds) {
	                var displayedSecond = this.second == null ? '--' : Object(_VDatePicker_util__WEBPACK_IMPORTED_MODULE_2__["pad"])(this.second);
	                titleContent.push(this.$createElement('span', ':'));
	                titleContent.push(this.genPickerButton('selecting', _VTimePicker__WEBPACK_IMPORTED_MODULE_4__["selectingTimes"].second, displayedSecond, this.disabled));
	            }
	            return this.$createElement('div', {
	                'class': 'v-time-picker-title__time'
	            }, titleContent);
	        },
	        genAmPm: function genAmPm() {
	            return this.$createElement('div', {
	                staticClass: 'v-time-picker-title__ampm'
	            }, [this.genPickerButton('period', 'am', 'am', this.disabled || this.readonly), this.genPickerButton('period', 'pm', 'pm', this.disabled || this.readonly)]);
	        }
	    },
	    render: function render(h) {
	        var children = [this.genTime()];
	        this.ampm && children.push(this.genAmPm());
	        return h('div', {
	            staticClass: 'v-time-picker-title'
	        }, children);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VTimePicker/index.ts":
	/*!*********************************************!*\
	  !*** ./src/components/VTimePicker/index.ts ***!
	  \*********************************************/
	/*! exports provided: VTimePicker, VTimePickerClock, VTimePickerTitle, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VTimePicker__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VTimePicker */ "./src/components/VTimePicker/VTimePicker.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTimePicker", function() { return _VTimePicker__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	/* harmony import */ var _VTimePickerClock__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./VTimePickerClock */ "./src/components/VTimePicker/VTimePickerClock.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTimePickerClock", function() { return _VTimePickerClock__WEBPACK_IMPORTED_MODULE_1__["default"]; });
	
	/* harmony import */ var _VTimePickerTitle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./VTimePickerTitle */ "./src/components/VTimePicker/VTimePickerTitle.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTimePickerTitle", function() { return _VTimePickerTitle__WEBPACK_IMPORTED_MODULE_2__["default"]; });
	
	
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = ({
	    $_vuetify_subcomponents: {
	        VTimePicker: _VTimePicker__WEBPACK_IMPORTED_MODULE_0__["default"],
	        VTimePickerClock: _VTimePickerClock__WEBPACK_IMPORTED_MODULE_1__["default"],
	        VTimePickerTitle: _VTimePickerTitle__WEBPACK_IMPORTED_MODULE_2__["default"]
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VTimeline/VTimeline.ts":
	/*!***********************************************!*\
	  !*** ./src/components/VTimeline/VTimeline.ts ***!
	  \***********************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_timeline_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_timeline.styl */ "./src/stylus/components/_timeline.styl");
	/* harmony import */ var _stylus_components_timeline_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_timeline_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	// Styles
	
	
	// Mixins
	
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_1__["default"])(_mixins_themeable__WEBPACK_IMPORTED_MODULE_2__["default"]
	/* @vue/component */
	).extend({
	    name: 'v-timeline',
	    props: {
	        alignTop: Boolean,
	        dense: Boolean
	    },
	    computed: {
	        classes: function classes() {
	            return __assign({ 'v-timeline--align-top': this.alignTop, 'v-timeline--dense': this.dense }, this.themeClasses);
	        }
	    },
	    render: function render(h) {
	        return h('div', {
	            staticClass: 'v-timeline',
	            'class': this.classes
	        }, this.$slots.default);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VTimeline/VTimelineItem.ts":
	/*!***************************************************!*\
	  !*** ./src/components/VTimeline/VTimelineItem.ts ***!
	  \***************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	/* harmony import */ var _VIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../VIcon */ "./src/components/VIcon/index.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	// Types
	
	// Components
	
	// Mixins
	
	
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_0__["default"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_3__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__["default"]
	/* @vue/component */
	).extend({
	    name: 'v-timeline-item',
	    props: {
	        color: {
	            type: String,
	            default: 'primary'
	        },
	        fillDot: Boolean,
	        hideDot: Boolean,
	        icon: String,
	        iconColor: String,
	        large: Boolean,
	        left: Boolean,
	        right: Boolean,
	        small: Boolean
	    },
	    computed: {
	        hasIcon: function hasIcon() {
	            return !!this.icon || !!this.$slots.icon;
	        }
	    },
	    methods: {
	        genBody: function genBody() {
	            return this.$createElement('div', {
	                staticClass: 'v-timeline-item__body'
	            }, this.$slots.default);
	        },
	        genIcon: function genIcon() {
	            if (this.$slots.icon) {
	                return this.$slots.icon;
	            }
	            return this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_1__["default"], {
	                props: {
	                    color: this.iconColor,
	                    dark: !this.theme.isDark,
	                    small: this.small
	                }
	            }, this.icon);
	        },
	        genInnerDot: function genInnerDot() {
	            var data = this.setBackgroundColor(this.color);
	            return this.$createElement('div', __assign({ staticClass: 'v-timeline-item__inner-dot' }, data), [this.hasIcon && this.genIcon()]);
	        },
	        genDot: function genDot() {
	            return this.$createElement('div', {
	                staticClass: 'v-timeline-item__dot',
	                class: {
	                    'v-timeline-item__dot--small': this.small,
	                    'v-timeline-item__dot--large': this.large
	                }
	            }, [this.genInnerDot()]);
	        },
	        genOpposite: function genOpposite() {
	            return this.$createElement('div', {
	                staticClass: 'v-timeline-item__opposite'
	            }, this.$slots.opposite);
	        }
	    },
	    render: function render(h) {
	        var children = [this.genBody()];
	        if (!this.hideDot) children.unshift(this.genDot());
	        if (this.$slots.opposite) children.push(this.genOpposite());
	        return h('div', {
	            staticClass: 'v-timeline-item',
	            class: __assign({ 'v-timeline-item--fill-dot': this.fillDot, 'v-timeline-item--left': this.left, 'v-timeline-item--right': this.right }, this.themeClasses)
	        }, children);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VTimeline/index.ts":
	/*!*******************************************!*\
	  !*** ./src/components/VTimeline/index.ts ***!
	  \*******************************************/
	/*! exports provided: VTimeline, VTimelineItem, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VTimeline__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VTimeline */ "./src/components/VTimeline/VTimeline.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTimeline", function() { return _VTimeline__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	/* harmony import */ var _VTimelineItem__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./VTimelineItem */ "./src/components/VTimeline/VTimelineItem.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTimelineItem", function() { return _VTimelineItem__WEBPACK_IMPORTED_MODULE_1__["default"]; });
	
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = ({
	    $_vuetify_subcomponents: {
	        VTimeline: _VTimeline__WEBPACK_IMPORTED_MODULE_0__["default"],
	        VTimelineItem: _VTimelineItem__WEBPACK_IMPORTED_MODULE_1__["default"]
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VToolbar/VToolbar.ts":
	/*!*********************************************!*\
	  !*** ./src/components/VToolbar/VToolbar.ts ***!
	  \*********************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_toolbar_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_toolbar.styl */ "./src/stylus/components/_toolbar.styl");
	/* harmony import */ var _stylus_components_toolbar_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_toolbar_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_applicationable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/applicationable */ "./src/mixins/applicationable.ts");
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _mixins_ssr_bootable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mixins/ssr-bootable */ "./src/mixins/ssr-bootable.ts");
	/* harmony import */ var _directives_scroll__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../directives/scroll */ "./src/directives/scroll.ts");
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../util/console */ "./src/util/console.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	// Styles
	
	// Mixins
	
	
	
	
	// Directives
	
	
	// Types
	
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_7__["default"])(Object(_mixins_applicationable__WEBPACK_IMPORTED_MODULE_1__["default"])('top', ['clippedLeft', 'clippedRight', 'computedHeight', 'invertedScroll', 'manualScroll']), _mixins_colorable__WEBPACK_IMPORTED_MODULE_2__["default"], _mixins_ssr_bootable__WEBPACK_IMPORTED_MODULE_4__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_3__["default"]
	/* @vue/component */
	).extend({
	    name: 'v-toolbar',
	    directives: { Scroll: _directives_scroll__WEBPACK_IMPORTED_MODULE_5__["default"] },
	    props: {
	        card: Boolean,
	        clippedLeft: Boolean,
	        clippedRight: Boolean,
	        dense: Boolean,
	        extended: Boolean,
	        extensionHeight: {
	            type: [Number, String],
	            validator: function validator(v) {
	                return !isNaN(parseInt(v));
	            }
	        },
	        flat: Boolean,
	        floating: Boolean,
	        height: {
	            type: [Number, String],
	            validator: function validator(v) {
	                return !isNaN(parseInt(v));
	            }
	        },
	        invertedScroll: Boolean,
	        manualScroll: Boolean,
	        prominent: Boolean,
	        scrollOffScreen: Boolean,
	        /* @deprecated */
	        scrollToolbarOffScreen: Boolean,
	        scrollTarget: String,
	        scrollThreshold: {
	            type: Number,
	            default: 300
	        },
	        tabs: Boolean
	    },
	    data: function data() {
	        return {
	            activeTimeout: null,
	            currentScroll: 0,
	            heights: {
	                mobileLandscape: 48,
	                mobile: 56,
	                desktop: 64,
	                dense: 48
	            },
	            isActive: true,
	            isExtended: false,
	            isScrollingUp: false,
	            previousScroll: 0,
	            savedScroll: 0,
	            target: null
	        };
	    },
	    computed: {
	        canScroll: function canScroll() {
	            // TODO: remove
	            if (this.scrollToolbarOffScreen) {
	                Object(_util_console__WEBPACK_IMPORTED_MODULE_6__["deprecate"])('scrollToolbarOffScreen', 'scrollOffScreen', this);
	                return true;
	            }
	            return this.scrollOffScreen || this.invertedScroll;
	        },
	        computedContentHeight: function computedContentHeight() {
	            if (this.height) return parseInt(this.height);
	            if (this.dense) return this.heights.dense;
	            if (this.prominent || this.$vuetify.breakpoint.mdAndUp) return this.heights.desktop;
	            if (this.$vuetify.breakpoint.smAndDown && this.$vuetify.breakpoint.width > this.$vuetify.breakpoint.height) return this.heights.mobileLandscape;
	            return this.heights.mobile;
	        },
	        computedExtensionHeight: function computedExtensionHeight() {
	            if (this.tabs) return 48;
	            if (this.extensionHeight) return parseInt(this.extensionHeight);
	            return this.computedContentHeight;
	        },
	        computedHeight: function computedHeight() {
	            if (!this.isExtended) return this.computedContentHeight;
	            return this.computedContentHeight + this.computedExtensionHeight;
	        },
	        computedMarginTop: function computedMarginTop() {
	            if (!this.app) return 0;
	            return this.$vuetify.application.bar;
	        },
	        classes: function classes() {
	            return __assign({ 'v-toolbar': true, 'elevation-0': this.flat || !this.isActive && !this.tabs && this.canScroll, 'v-toolbar--absolute': this.absolute, 'v-toolbar--card': this.card, 'v-toolbar--clipped': this.clippedLeft || this.clippedRight, 'v-toolbar--dense': this.dense, 'v-toolbar--extended': this.isExtended, 'v-toolbar--fixed': !this.absolute && (this.app || this.fixed), 'v-toolbar--floating': this.floating, 'v-toolbar--prominent': this.prominent }, this.themeClasses);
	        },
	        computedPaddingLeft: function computedPaddingLeft() {
	            if (!this.app || this.clippedLeft) return 0;
	            return this.$vuetify.application.left;
	        },
	        computedPaddingRight: function computedPaddingRight() {
	            if (!this.app || this.clippedRight) return 0;
	            return this.$vuetify.application.right;
	        },
	        computedTransform: function computedTransform() {
	            return !this.isActive ? this.canScroll ? -this.computedContentHeight : -this.computedHeight : 0;
	        },
	        currentThreshold: function currentThreshold() {
	            return Math.abs(this.currentScroll - this.savedScroll);
	        },
	        styles: function styles() {
	            return {
	                marginTop: this.computedMarginTop + "px",
	                paddingRight: this.computedPaddingRight + "px",
	                paddingLeft: this.computedPaddingLeft + "px",
	                transform: "translateY(" + this.computedTransform + "px)"
	            };
	        }
	    },
	    watch: {
	        currentThreshold: function currentThreshold(val) {
	            if (this.invertedScroll) {
	                this.isActive = this.currentScroll > this.scrollThreshold;
	                return;
	            }
	            if (val < this.scrollThreshold || !this.isBooted) return;
	            this.isActive = this.isScrollingUp;
	            this.savedScroll = this.currentScroll;
	        },
	        isActive: function isActive() {
	            this.savedScroll = 0;
	        },
	        invertedScroll: function invertedScroll(val) {
	            this.isActive = !val;
	        },
	        manualScroll: function manualScroll(val) {
	            this.isActive = !val;
	        },
	        isScrollingUp: function isScrollingUp() {
	            this.savedScroll = this.savedScroll || this.currentScroll;
	        }
	    },
	    created: function created() {
	        if (this.invertedScroll || this.manualScroll) this.isActive = false;
	    },
	    mounted: function mounted() {
	        if (this.scrollTarget) {
	            this.target = document.querySelector(this.scrollTarget);
	        }
	    },
	    methods: {
	        onScroll: function onScroll() {
	            if (!this.canScroll || this.manualScroll || typeof window === 'undefined') return;
	            this.currentScroll = this.target ? this.target.scrollTop : window.pageYOffset;
	            this.isScrollingUp = this.currentScroll < this.previousScroll;
	            this.previousScroll = this.currentScroll;
	        },
	        updateApplication: function updateApplication() {
	            return this.invertedScroll || this.manualScroll ? 0 : this.computedHeight;
	        }
	    },
	    render: function render(h) {
	        this.isExtended = this.extended || !!this.$slots.extension;
	        var children = [];
	        var data = this.setBackgroundColor(this.color, {
	            'class': this.classes,
	            style: this.styles,
	            on: this.$listeners
	        });
	        data.directives = [{
	            arg: this.scrollTarget,
	            name: 'scroll',
	            value: this.onScroll
	        }];
	        children.push(h('div', {
	            staticClass: 'v-toolbar__content',
	            style: { height: this.computedContentHeight + "px" },
	            ref: 'content'
	        }, this.$slots.default));
	        if (this.isExtended) {
	            children.push(h('div', {
	                staticClass: 'v-toolbar__extension',
	                style: { height: this.computedExtensionHeight + "px" }
	            }, this.$slots.extension));
	        }
	        return h('nav', data, children);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VToolbar/VToolbarSideIcon.ts":
	/*!*****************************************************!*\
	  !*** ./src/components/VToolbar/VToolbarSideIcon.ts ***!
	  \*****************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VBtn__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../VBtn */ "./src/components/VBtn/index.ts");
	/* harmony import */ var _VIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../VIcon */ "./src/components/VIcon/index.ts");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_2__);
	
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (vue__WEBPACK_IMPORTED_MODULE_2___default.a.extend({
	    name: 'v-toolbar-side-icon',
	    functional: true,
	    render: function render(h, _a) {
	        var slots = _a.slots,
	            listeners = _a.listeners,
	            props = _a.props,
	            data = _a.data;
	        var classes = data.staticClass ? data.staticClass + " v-toolbar__side-icon" : 'v-toolbar__side-icon';
	        var d = Object.assign(data, {
	            staticClass: classes,
	            props: Object.assign(props, {
	                icon: true
	            }),
	            on: listeners
	        });
	        var defaultSlot = slots().default;
	        return h(_VBtn__WEBPACK_IMPORTED_MODULE_0__["default"], d, defaultSlot || [h(_VIcon__WEBPACK_IMPORTED_MODULE_1__["default"], '$vuetify.icons.menu')]);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VToolbar/index.ts":
	/*!******************************************!*\
	  !*** ./src/components/VToolbar/index.ts ***!
	  \******************************************/
	/*! exports provided: VToolbar, VToolbarSideIcon, VToolbarTitle, VToolbarItems, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VToolbarTitle", function() { return VToolbarTitle; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VToolbarItems", function() { return VToolbarItems; });
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var _VToolbar__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./VToolbar */ "./src/components/VToolbar/VToolbar.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VToolbar", function() { return _VToolbar__WEBPACK_IMPORTED_MODULE_1__["default"]; });
	
	/* harmony import */ var _VToolbarSideIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./VToolbarSideIcon */ "./src/components/VToolbar/VToolbarSideIcon.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VToolbarSideIcon", function() { return _VToolbarSideIcon__WEBPACK_IMPORTED_MODULE_2__["default"]; });
	
	
	
	
	var VToolbarTitle = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleFunctional"])('v-toolbar__title');
	var VToolbarItems = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleFunctional"])('v-toolbar__items');
	
	/* harmony default export */ __webpack_exports__["default"] = ({
	    $_vuetify_subcomponents: {
	        VToolbar: _VToolbar__WEBPACK_IMPORTED_MODULE_1__["default"],
	        VToolbarItems: VToolbarItems,
	        VToolbarTitle: VToolbarTitle,
	        VToolbarSideIcon: _VToolbarSideIcon__WEBPACK_IMPORTED_MODULE_2__["default"]
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VTooltip/VTooltip.js":
	/*!*********************************************!*\
	  !*** ./src/components/VTooltip/VTooltip.js ***!
	  \*********************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_tooltips_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_tooltips.styl */ "./src/stylus/components/_tooltips.styl");
	/* harmony import */ var _stylus_components_tooltips_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_tooltips_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _mixins_delayable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/delayable */ "./src/mixins/delayable.ts");
	/* harmony import */ var _mixins_dependent__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/dependent */ "./src/mixins/dependent.ts");
	/* harmony import */ var _mixins_detachable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mixins/detachable */ "./src/mixins/detachable.js");
	/* harmony import */ var _mixins_menuable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mixins/menuable */ "./src/mixins/menuable.js");
	/* harmony import */ var _mixins_toggleable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mixins/toggleable */ "./src/mixins/toggleable.ts");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../util/console */ "./src/util/console.ts");
	
	// Mixins
	
	
	
	
	
	
	// Helpers
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-tooltip',
	    mixins: [_mixins_colorable__WEBPACK_IMPORTED_MODULE_1__["default"], _mixins_delayable__WEBPACK_IMPORTED_MODULE_2__["default"], _mixins_dependent__WEBPACK_IMPORTED_MODULE_3__["default"], _mixins_detachable__WEBPACK_IMPORTED_MODULE_4__["default"], _mixins_menuable__WEBPACK_IMPORTED_MODULE_5__["default"], _mixins_toggleable__WEBPACK_IMPORTED_MODULE_6__["default"]],
	    props: {
	        closeDelay: {
	            type: [Number, String],
	            default: 200
	        },
	        debounce: {
	            type: [Number, String],
	            default: 0
	        },
	        disabled: Boolean,
	        fixed: {
	            type: Boolean,
	            default: true
	        },
	        openDelay: {
	            type: [Number, String],
	            default: 200
	        },
	        tag: {
	            type: String,
	            default: 'span'
	        },
	        transition: String,
	        zIndex: {
	            default: null
	        }
	    },
	    data: function data() {
	        return {
	            calculatedMinWidth: 0,
	            closeDependents: false
	        };
	    },
	    computed: {
	        calculatedLeft: function calculatedLeft() {
	            var _a = this.dimensions,
	                activator = _a.activator,
	                content = _a.content;
	            var unknown = !this.bottom && !this.left && !this.top && !this.right;
	            var activatorLeft = this.isAttached ? activator.offsetLeft : activator.left;
	            var left = 0;
	            if (this.top || this.bottom || unknown) {
	                left = activatorLeft + activator.width / 2 - content.width / 2;
	            } else if (this.left || this.right) {
	                left = activatorLeft + (this.right ? activator.width : -content.width) + (this.right ? 10 : -10);
	            }
	            if (this.nudgeLeft) left -= parseInt(this.nudgeLeft);
	            if (this.nudgeRight) left += parseInt(this.nudgeRight);
	            return this.calcXOverflow(left, this.dimensions.content.width) + "px";
	        },
	        calculatedTop: function calculatedTop() {
	            var _a = this.dimensions,
	                activator = _a.activator,
	                content = _a.content;
	            var activatorTop = this.isAttached ? activator.offsetTop : activator.top;
	            var top = 0;
	            if (this.top || this.bottom) {
	                top = activatorTop + (this.bottom ? activator.height : -content.height) + (this.bottom ? 10 : -10);
	            } else if (this.left || this.right) {
	                top = activatorTop + activator.height / 2 - content.height / 2;
	            }
	            if (this.nudgeTop) top -= parseInt(this.nudgeTop);
	            if (this.nudgeBottom) top += parseInt(this.nudgeBottom);
	            return this.calcYOverflow(top + this.pageYOffset) + "px";
	        },
	        classes: function classes() {
	            return {
	                'v-tooltip--top': this.top,
	                'v-tooltip--right': this.right,
	                'v-tooltip--bottom': this.bottom,
	                'v-tooltip--left': this.left
	            };
	        },
	        computedTransition: function computedTransition() {
	            if (this.transition) return this.transition;
	            if (this.top) return 'slide-y-reverse-transition';
	            if (this.right) return 'slide-x-transition';
	            if (this.bottom) return 'slide-y-transition';
	            if (this.left) return 'slide-x-reverse-transition';
	            return '';
	        },
	        offsetY: function offsetY() {
	            return this.top || this.bottom;
	        },
	        offsetX: function offsetX() {
	            return this.left || this.right;
	        },
	        styles: function styles() {
	            return {
	                left: this.calculatedLeft,
	                maxWidth: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["convertToUnit"])(this.maxWidth),
	                minWidth: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["convertToUnit"])(this.minWidth),
	                opacity: this.isActive ? 0.9 : 0,
	                top: this.calculatedTop,
	                zIndex: this.zIndex || this.activeZIndex
	            };
	        }
	    },
	    beforeMount: function beforeMount() {
	        var _this = this;
	        this.$nextTick(function () {
	            _this.value && _this.callActivate();
	        });
	    },
	    mounted: function mounted() {
	        if (Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["getSlotType"])(this, 'activator', true) === 'v-slot') {
	            Object(_util_console__WEBPACK_IMPORTED_MODULE_8__["consoleError"])("v-tooltip's activator slot must be bound, try '<template #activator=\"data\"><v-btn v-on=\"data.on>'", this);
	        }
	    },
	    methods: {
	        activate: function activate() {
	            // Update coordinates and dimensions of menu
	            // and its activator
	            this.updateDimensions();
	            // Start the transition
	            requestAnimationFrame(this.startTransition);
	        },
	        genActivator: function genActivator() {
	            var _this = this;
	            var listeners = this.disabled ? {} : {
	                mouseenter: function mouseenter(e) {
	                    _this.getActivator(e);
	                    _this.runDelay('open');
	                },
	                mouseleave: function mouseleave(e) {
	                    _this.getActivator(e);
	                    _this.runDelay('close');
	                }
	            };
	            if (Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["getSlotType"])(this, 'activator') === 'scoped') {
	                var activator = this.$scopedSlots.activator({ on: listeners });
	                this.activatorNode = activator;
	                return activator;
	            }
	            return this.$createElement('span', {
	                on: listeners,
	                ref: 'activator'
	            }, this.$slots.activator);
	        }
	    },
	    render: function render(h) {
	        var _a;
	        var tooltip = h('div', this.setBackgroundColor(this.color, {
	            staticClass: 'v-tooltip__content',
	            'class': (_a = {}, _a[this.contentClass] = true, _a['menuable__content__active'] = this.isActive, _a['v-tooltip__content--fixed'] = this.activatorFixed, _a),
	            style: this.styles,
	            attrs: this.getScopeIdAttrs(),
	            directives: [{
	                name: 'show',
	                value: this.isContentActive
	            }],
	            ref: 'content'
	        }), this.showLazyContent(this.$slots.default));
	        return h(this.tag, {
	            staticClass: 'v-tooltip',
	            'class': this.classes
	        }, [h('transition', {
	            props: {
	                name: this.computedTransition
	            }
	        }, [tooltip]), this.genActivator()]);
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VTooltip/index.js":
	/*!******************************************!*\
	  !*** ./src/components/VTooltip/index.js ***!
	  \******************************************/
	/*! exports provided: VTooltip, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VTooltip__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VTooltip */ "./src/components/VTooltip/VTooltip.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTooltip", function() { return _VTooltip__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VTooltip__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VTreeview/VTreeview.ts":
	/*!***********************************************!*\
	  !*** ./src/components/VTreeview/VTreeview.ts ***!
	  \***********************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_treeview_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_treeview.styl */ "./src/stylus/components/_treeview.styl");
	/* harmony import */ var _stylus_components_treeview_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_treeview_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _VTreeviewNode__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./VTreeviewNode */ "./src/components/VTreeview/VTreeviewNode.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _mixins_registrable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/registrable */ "./src/mixins/registrable.ts");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../util/console */ "./src/util/console.ts");
	/* harmony import */ var _util_filterTreeItems__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./util/filterTreeItems */ "./src/components/VTreeview/util/filterTreeItems.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var __read = undefined && undefined.__read || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o),
	        r,
	        ar = [],
	        e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
	            ar.push(r.value);
	        }
	    } catch (error) {
	        e = { error: error };
	    } finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        } finally {
	            if (e) throw e.error;
	        }
	    }
	    return ar;
	};
	var __spread = undefined && undefined.__spread || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) {
	        ar = ar.concat(__read(arguments[i]));
	    }return ar;
	};
	var __values = undefined && undefined.__values || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator],
	        i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function next() {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	// Styles
	
	// Components
	
	// Mixins
	
	
	// Utils
	
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_5__["default"])(Object(_mixins_registrable__WEBPACK_IMPORTED_MODULE_3__["provide"])('treeview'), _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__["default"]
	/* @vue/component */
	).extend({
	    name: 'v-treeview',
	    provide: function provide() {
	        return { treeview: this };
	    },
	    props: __assign({ active: {
	            type: Array,
	            default: function _default() {
	                return [];
	            }
	        }, items: {
	            type: Array,
	            default: function _default() {
	                return [];
	            }
	        }, hoverable: Boolean, multipleActive: Boolean, open: {
	            type: Array,
	            default: function _default() {
	                return [];
	            }
	        }, openAll: Boolean, returnObject: {
	            type: Boolean,
	            default: false // TODO: Should be true in next major
	        }, value: {
	            type: Array,
	            default: function _default() {
	                return [];
	            }
	        }, search: String, filter: Function }, _VTreeviewNode__WEBPACK_IMPORTED_MODULE_1__["VTreeviewNodeProps"]),
	    data: function data() {
	        return {
	            nodes: {},
	            selectedCache: new Set(),
	            activeCache: new Set(),
	            openCache: new Set()
	        };
	    },
	    computed: {
	        excludedItems: function excludedItems() {
	            var excluded = new Set();
	            if (!this.search) return excluded;
	            for (var i = 0; i < this.items.length; i++) {
	                Object(_util_filterTreeItems__WEBPACK_IMPORTED_MODULE_7__["filterTreeItems"])(this.filter || _util_filterTreeItems__WEBPACK_IMPORTED_MODULE_7__["filterTreeItem"], this.items[i], this.search, this.itemKey, this.itemText, this.itemChildren, excluded);
	            }
	            return excluded;
	        }
	    },
	    watch: {
	        items: {
	            handler: function handler() {
	                var _this = this;
	                var oldKeys = Object.keys(this.nodes).map(function (k) {
	                    return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["getObjectValueByPath"])(_this.nodes[k].item, _this.itemKey);
	                });
	                var newKeys = this.getKeys(this.items);
	                var diff = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["arrayDiff"])(newKeys, oldKeys);
	                // We only want to do stuff if items have changed
	                if (!diff.length && newKeys.length < oldKeys.length) return;
	                // If nodes are removed we need to clear them from this.nodes
	                diff.forEach(function (k) {
	                    return delete _this.nodes[k];
	                });
	                var oldSelectedCache = __spread(this.selectedCache);
	                this.selectedCache = new Set();
	                this.activeCache = new Set();
	                this.openCache = new Set();
	                this.buildTree(this.items);
	                // Only emit selected if selection has changed
	                // as a result of items changing. This fixes a
	                // potential double emit when selecting a node
	                // with dynamic children
	                if (!Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["deepEqual"])(oldSelectedCache, __spread(this.selectedCache))) this.emitSelected();
	            },
	            deep: true
	        },
	        active: function active(value) {
	            this.handleNodeCacheWatcher(value, this.activeCache, this.updateActive, this.emitActive);
	        },
	        value: function value(_value) {
	            this.handleNodeCacheWatcher(_value, this.selectedCache, this.updateSelected, this.emitSelected);
	        },
	        open: function open(value) {
	            this.handleNodeCacheWatcher(value, this.openCache, this.updateOpen, this.emitOpen);
	        }
	    },
	    created: function created() {
	        var _this = this;
	        this.buildTree(this.items);
	        this.value.forEach(function (key) {
	            return _this.updateSelected(key, true);
	        });
	        this.emitSelected();
	        this.active.forEach(function (key) {
	            return _this.updateActive(key, true);
	        });
	        this.emitActive();
	    },
	    mounted: function mounted() {
	        var _this = this;
	        // Save the developer from themselves
	        if (this.$slots.prepend || this.$slots.append) {
	            Object(_util_console__WEBPACK_IMPORTED_MODULE_6__["consoleWarn"])('The prepend and append slots require a slot-scope attribute', this);
	        }
	        if (this.openAll) {
	            this.updateAll(true);
	        } else {
	            this.open.forEach(function (key) {
	                return _this.updateOpen(key, true);
	            });
	            this.emitOpen();
	        }
	    },
	    methods: {
	        /** @public */
	        updateAll: function updateAll(value) {
	            var _this = this;
	            Object.keys(this.nodes).forEach(function (key) {
	                return _this.updateOpen(Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["getObjectValueByPath"])(_this.nodes[key].item, _this.itemKey), value);
	            });
	            this.emitOpen();
	        },
	        getKeys: function getKeys(items, keys) {
	            if (keys === void 0) {
	                keys = [];
	            }
	            for (var i = 0; i < items.length; i++) {
	                var key = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["getObjectValueByPath"])(items[i], this.itemKey);
	                keys.push(key);
	                var children = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["getObjectValueByPath"])(items[i], this.itemChildren);
	                if (children) {
	                    keys.push.apply(keys, __spread(this.getKeys(children)));
	                }
	            }
	            return keys;
	        },
	        buildTree: function buildTree(items, parent) {
	            var _this = this;
	            if (parent === void 0) {
	                parent = null;
	            }
	            for (var i = 0; i < items.length; i++) {
	                var item = items[i];
	                var key = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["getObjectValueByPath"])(item, this.itemKey);
	                var children = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["getObjectValueByPath"])(item, this.itemChildren, []);
	                var oldNode = this.nodes.hasOwnProperty(key) ? this.nodes[key] : {
	                    isSelected: false, isIndeterminate: false, isActive: false, isOpen: false, vnode: null
	                };
	                var node = {
	                    vnode: oldNode.vnode,
	                    parent: parent,
	                    children: children.map(function (c) {
	                        return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["getObjectValueByPath"])(c, _this.itemKey);
	                    }),
	                    item: item
	                };
	                this.buildTree(children, key);
	                // This fixed bug with dynamic children resetting selected parent state
	                if (!this.nodes.hasOwnProperty(key) && parent !== null && this.nodes.hasOwnProperty(parent)) {
	                    node.isSelected = this.nodes[parent].isSelected;
	                    node.isIndeterminate = this.nodes[parent].isIndeterminate;
	                } else {
	                    node.isSelected = oldNode.isSelected;
	                    node.isIndeterminate = oldNode.isIndeterminate;
	                }
	                node.isActive = oldNode.isActive;
	                node.isOpen = oldNode.isOpen;
	                this.nodes[key] = !children.length ? node : this.calculateState(node, this.nodes);
	                // Don't forget to rebuild cache
	                if (this.nodes[key].isSelected) this.selectedCache.add(key);
	                if (this.nodes[key].isActive) this.activeCache.add(key);
	                if (this.nodes[key].isOpen) this.openCache.add(key);
	                this.updateVnodeState(key);
	            }
	        },
	        calculateState: function calculateState(node, state) {
	            var counts = node.children.reduce(function (counts, child) {
	                counts[0] += +Boolean(state[child].isSelected);
	                counts[1] += +Boolean(state[child].isIndeterminate);
	                return counts;
	            }, [0, 0]);
	            node.isSelected = !!node.children.length && counts[0] === node.children.length;
	            node.isIndeterminate = !node.isSelected && (counts[0] > 0 || counts[1] > 0);
	            return node;
	        },
	        emitOpen: function emitOpen() {
	            this.emitNodeCache('update:open', this.openCache);
	        },
	        emitSelected: function emitSelected() {
	            this.emitNodeCache('input', this.selectedCache);
	        },
	        emitActive: function emitActive() {
	            this.emitNodeCache('update:active', this.activeCache);
	        },
	        emitNodeCache: function emitNodeCache(event, cache) {
	            var _this = this;
	            this.$emit(event, this.returnObject ? __spread(cache).map(function (key) {
	                return _this.nodes[key].item;
	            }) : __spread(cache));
	        },
	        handleNodeCacheWatcher: function handleNodeCacheWatcher(value, cache, updateFn, emitFn) {
	            var _this = this;
	            value = this.returnObject ? value.map(function (v) {
	                return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["getObjectValueByPath"])(v, _this.itemKey);
	            }) : value;
	            var old = __spread(cache);
	            if (Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["deepEqual"])(old, value)) return;
	            old.forEach(function (key) {
	                return updateFn(key, false);
	            });
	            value.forEach(function (key) {
	                return updateFn(key, true);
	            });
	            emitFn();
	        },
	        getDescendants: function getDescendants(key, descendants) {
	            if (descendants === void 0) {
	                descendants = [];
	            }
	            var children = this.nodes[key].children;
	            descendants.push.apply(descendants, __spread(children));
	            for (var i = 0; i < children.length; i++) {
	                descendants = this.getDescendants(children[i], descendants);
	            }
	            return descendants;
	        },
	        getParents: function getParents(key) {
	            var parent = this.nodes[key].parent;
	            var parents = [];
	            while (parent !== null) {
	                parents.push(parent);
	                parent = this.nodes[parent].parent;
	            }
	            return parents;
	        },
	        register: function register(node) {
	            var key = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["getObjectValueByPath"])(node.item, this.itemKey);
	            this.nodes[key].vnode = node;
	            this.updateVnodeState(key);
	        },
	        unregister: function unregister(node) {
	            var key = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["getObjectValueByPath"])(node.item, this.itemKey);
	            if (this.nodes[key]) this.nodes[key].vnode = null;
	        },
	        updateActive: function updateActive(key, isActive) {
	            var _this = this;
	            if (!this.nodes.hasOwnProperty(key)) return;
	            if (!this.multipleActive) {
	                this.activeCache.forEach(function (active) {
	                    _this.nodes[active].isActive = false;
	                    _this.updateVnodeState(active);
	                    _this.activeCache.delete(active);
	                });
	            }
	            var node = this.nodes[key];
	            if (!node) return;
	            if (isActive) this.activeCache.add(key);else this.activeCache.delete(key);
	            node.isActive = isActive;
	            this.updateVnodeState(key);
	        },
	        updateSelected: function updateSelected(key, isSelected) {
	            var _this = this;
	            var e_1, _a;
	            if (!this.nodes.hasOwnProperty(key)) return;
	            var changed = new Map();
	            var descendants = __spread([key], this.getDescendants(key));
	            descendants.forEach(function (descendant) {
	                _this.nodes[descendant].isSelected = isSelected;
	                _this.nodes[descendant].isIndeterminate = false;
	                changed.set(descendant, isSelected);
	            });
	            var parents = this.getParents(key);
	            parents.forEach(function (parent) {
	                _this.nodes[parent] = _this.calculateState(_this.nodes[parent], _this.nodes);
	                changed.set(parent, _this.nodes[parent].isSelected);
	            });
	            var all = __spread([key], descendants, parents);
	            all.forEach(this.updateVnodeState);
	            try {
	                for (var _b = __values(changed.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
	                    var _d = __read(_c.value, 2),
	                        key_1 = _d[0],
	                        value = _d[1];
	                    value === true ? this.selectedCache.add(key_1) : this.selectedCache.delete(key_1);
	                }
	            } catch (e_1_1) {
	                e_1 = { error: e_1_1 };
	            } finally {
	                try {
	                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	                } finally {
	                    if (e_1) throw e_1.error;
	                }
	            }
	        },
	        updateOpen: function updateOpen(key, isOpen) {
	            var _this = this;
	            if (!this.nodes.hasOwnProperty(key)) return;
	            var node = this.nodes[key];
	            var children = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["getObjectValueByPath"])(node.item, this.itemChildren);
	            if (children && !children.length && node.vnode && !node.vnode.hasLoaded) {
	                node.vnode.checkChildren().then(function () {
	                    return _this.updateOpen(key, isOpen);
	                });
	            } else if (children && children.length) {
	                node.isOpen = isOpen;
	                node.isOpen ? this.openCache.add(key) : this.openCache.delete(key);
	                this.updateVnodeState(key);
	            }
	        },
	        updateVnodeState: function updateVnodeState(key) {
	            var node = this.nodes[key];
	            if (node && node.vnode) {
	                node.vnode.isSelected = node.isSelected;
	                node.vnode.isIndeterminate = node.isIndeterminate;
	                node.vnode.isActive = node.isActive;
	                node.vnode.isOpen = node.isOpen;
	            }
	        },
	        isExcluded: function isExcluded(key) {
	            return !!this.search && this.excludedItems.has(key);
	        }
	    },
	    render: function render(h) {
	        var children = this.items.length ? this.items.map(_VTreeviewNode__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.genChild.bind(this))
	        /* istanbul ignore next */
	        : this.$slots.default; // TODO: remove type annotation with TS 3.2
	        return h('div', {
	            staticClass: 'v-treeview',
	            class: __assign({ 'v-treeview--hoverable': this.hoverable }, this.themeClasses)
	        }, children);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VTreeview/VTreeviewNode.ts":
	/*!***************************************************!*\
	  !*** ./src/components/VTreeview/VTreeviewNode.ts ***!
	  \***************************************************/
	/*! exports provided: VTreeviewNodeProps, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VTreeviewNodeProps", function() { return VTreeviewNodeProps; });
	/* harmony import */ var _transitions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../transitions */ "./src/components/transitions/index.js");
	/* harmony import */ var _VIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../VIcon */ "./src/components/VIcon/index.ts");
	/* harmony import */ var _VTreeviewNode__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./VTreeviewNode */ "./src/components/VTreeview/VTreeviewNode.ts");
	/* harmony import */ var _mixins_registrable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/registrable */ "./src/mixins/registrable.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	// Components
	
	
	
	// Mixins
	
	// Utils
	
	
	var VTreeviewNodeProps = {
	    activatable: Boolean,
	    activeClass: {
	        type: String,
	        default: 'v-treeview-node--active'
	    },
	    selectable: Boolean,
	    selectedColor: {
	        type: String,
	        default: 'accent'
	    },
	    indeterminateIcon: {
	        type: String,
	        default: '$vuetify.icons.checkboxIndeterminate'
	    },
	    onIcon: {
	        type: String,
	        default: '$vuetify.icons.checkboxOn'
	    },
	    offIcon: {
	        type: String,
	        default: '$vuetify.icons.checkboxOff'
	    },
	    expandIcon: {
	        type: String,
	        default: '$vuetify.icons.subgroup'
	    },
	    loadingIcon: {
	        type: String,
	        default: '$vuetify.icons.loading'
	    },
	    itemKey: {
	        type: String,
	        default: 'id'
	    },
	    itemText: {
	        type: String,
	        default: 'name'
	    },
	    itemChildren: {
	        type: String,
	        default: 'children'
	    },
	    loadChildren: Function,
	    openOnClick: Boolean,
	    transition: Boolean
	};
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_4__["default"])(Object(_mixins_registrable__WEBPACK_IMPORTED_MODULE_3__["inject"])('treeview')
	/* @vue/component */
	).extend({
	    name: 'v-treeview-node',
	    inject: {
	        treeview: {
	            default: null
	        }
	    },
	    props: __assign({ item: {
	            type: Object,
	            default: function _default() {
	                return null;
	            }
	        } }, VTreeviewNodeProps),
	    data: function data() {
	        return {
	            isOpen: false,
	            isSelected: false,
	            isIndeterminate: false,
	            isActive: false,
	            isLoading: false,
	            hasLoaded: false
	        };
	    },
	    computed: {
	        key: function key() {
	            return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["getObjectValueByPath"])(this.item, this.itemKey);
	        },
	        children: function children() {
	            return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["getObjectValueByPath"])(this.item, this.itemChildren);
	        },
	        text: function text() {
	            return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["getObjectValueByPath"])(this.item, this.itemText);
	        },
	        scopedProps: function scopedProps() {
	            return {
	                item: this.item,
	                leaf: !this.children,
	                selected: this.isSelected,
	                indeterminate: this.isIndeterminate,
	                active: this.isActive,
	                open: this.isOpen
	            };
	        },
	        computedIcon: function computedIcon() {
	            if (this.isIndeterminate) return this.indeterminateIcon;else if (this.isSelected) return this.onIcon;else return this.offIcon;
	        },
	        hasChildren: function hasChildren() {
	            return !!this.children && (!!this.children.length || !!this.loadChildren);
	        }
	    },
	    created: function created() {
	        this.treeview.register(this);
	    },
	    beforeDestroy: function beforeDestroy() {
	        this.treeview.unregister(this);
	    },
	    methods: {
	        checkChildren: function checkChildren() {
	            var _this = this;
	            return new Promise(function (resolve) {
	                // TODO: Potential issue with always trying
	                // to load children if response is empty?
	                if (!_this.children || _this.children.length || !_this.loadChildren || _this.hasLoaded) return resolve();
	                _this.isLoading = true;
	                resolve(_this.loadChildren(_this.item));
	            }).then(function () {
	                _this.isLoading = false;
	                _this.hasLoaded = true;
	            });
	        },
	        open: function open() {
	            this.isOpen = !this.isOpen;
	            this.treeview.updateOpen(this.key, this.isOpen);
	            this.treeview.emitOpen();
	        },
	        genLabel: function genLabel() {
	            var children = [];
	            if (this.$scopedSlots.label) children.push(this.$scopedSlots.label(this.scopedProps));else children.push(this.text);
	            return this.$createElement('div', {
	                slot: 'label',
	                staticClass: 'v-treeview-node__label'
	            }, children);
	        },
	        genContent: function genContent() {
	            var children = [this.$scopedSlots.prepend && this.$scopedSlots.prepend(this.scopedProps), this.genLabel(), this.$scopedSlots.append && this.$scopedSlots.append(this.scopedProps)];
	            return this.$createElement('div', {
	                staticClass: 'v-treeview-node__content'
	            }, children);
	        },
	        genToggle: function genToggle() {
	            var _this = this;
	            return this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_1__["VIcon"], {
	                staticClass: 'v-treeview-node__toggle',
	                class: {
	                    'v-treeview-node__toggle--open': this.isOpen,
	                    'v-treeview-node__toggle--loading': this.isLoading
	                },
	                slot: 'prepend',
	                on: {
	                    click: function click(e) {
	                        e.stopPropagation();
	                        if (_this.isLoading) return;
	                        _this.checkChildren().then(function () {
	                            return _this.open();
	                        });
	                    }
	                }
	            }, [this.isLoading ? this.loadingIcon : this.expandIcon]);
	        },
	        genCheckbox: function genCheckbox() {
	            var _this = this;
	            return this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_1__["VIcon"], {
	                staticClass: 'v-treeview-node__checkbox',
	                props: {
	                    color: this.isSelected ? this.selectedColor : undefined
	                },
	                on: {
	                    click: function click(e) {
	                        e.stopPropagation();
	                        if (_this.isLoading) return;
	                        _this.checkChildren().then(function () {
	                            // We nextTick here so that items watch in VTreeview has a chance to run first
	                            _this.$nextTick(function () {
	                                _this.isSelected = !_this.isSelected;
	                                _this.isIndeterminate = false;
	                                _this.treeview.updateSelected(_this.key, _this.isSelected);
	                                _this.treeview.emitSelected();
	                            });
	                        });
	                    }
	                }
	            }, [this.computedIcon]);
	        },
	        genNode: function genNode() {
	            var _this = this;
	            var _a;
	            var children = [this.genContent()];
	            if (this.selectable) children.unshift(this.genCheckbox());
	            if (this.hasChildren) children.unshift(this.genToggle());
	            return this.$createElement('div', {
	                staticClass: 'v-treeview-node__root',
	                class: (_a = {}, _a[this.activeClass] = this.isActive, _a),
	                on: {
	                    click: function click() {
	                        if (_this.openOnClick && _this.children) {
	                            _this.open();
	                        } else if (_this.activatable) {
	                            _this.isActive = !_this.isActive;
	                            _this.treeview.updateActive(_this.key, _this.isActive);
	                            _this.treeview.emitActive();
	                        }
	                    }
	                }
	            }, children);
	        },
	        genChild: function genChild(item) {
	            return this.$createElement(_VTreeviewNode__WEBPACK_IMPORTED_MODULE_2__["default"], {
	                key: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["getObjectValueByPath"])(item, this.itemKey),
	                props: {
	                    activatable: this.activatable,
	                    activeClass: this.activeClass,
	                    item: item,
	                    selectable: this.selectable,
	                    selectedColor: this.selectedColor,
	                    expandIcon: this.expandIcon,
	                    indeterminateIcon: this.indeterminateIcon,
	                    offIcon: this.offIcon,
	                    onIcon: this.onIcon,
	                    loadingIcon: this.loadingIcon,
	                    itemKey: this.itemKey,
	                    itemText: this.itemText,
	                    itemChildren: this.itemChildren,
	                    loadChildren: this.loadChildren,
	                    transition: this.transition,
	                    openOnClick: this.openOnClick
	                },
	                scopedSlots: this.$scopedSlots
	            });
	        },
	        genChildrenWrapper: function genChildrenWrapper() {
	            if (!this.isOpen || !this.children) return null;
	            var children = [this.children.map(this.genChild)];
	            return this.$createElement('div', {
	                staticClass: 'v-treeview-node__children'
	            }, children);
	        },
	        genTransition: function genTransition() {
	            return this.$createElement(_transitions__WEBPACK_IMPORTED_MODULE_0__["VExpandTransition"], [this.genChildrenWrapper()]);
	        }
	    },
	    render: function render(h) {
	        var children = [this.genNode()];
	        if (this.transition) children.push(this.genTransition());else children.push(this.genChildrenWrapper());
	        return h('div', {
	            staticClass: 'v-treeview-node',
	            class: {
	                'v-treeview-node--leaf': !this.hasChildren,
	                'v-treeview-node--click': this.openOnClick,
	                'v-treeview-node--selected': this.isSelected,
	                'v-treeview-node--excluded': this.treeview.isExcluded(this.key)
	            }
	        }, children);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VTreeview/index.ts":
	/*!*******************************************!*\
	  !*** ./src/components/VTreeview/index.ts ***!
	  \*******************************************/
	/*! exports provided: VTreeview, VTreeviewNode, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VTreeview__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VTreeview */ "./src/components/VTreeview/VTreeview.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTreeview", function() { return _VTreeview__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	/* harmony import */ var _VTreeviewNode__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./VTreeviewNode */ "./src/components/VTreeview/VTreeviewNode.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTreeviewNode", function() { return _VTreeviewNode__WEBPACK_IMPORTED_MODULE_1__["default"]; });
	
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = ({
	    $_vuetify_subcomponents: {
	        VTreeview: _VTreeview__WEBPACK_IMPORTED_MODULE_0__["default"],
	        VTreeviewNode: _VTreeviewNode__WEBPACK_IMPORTED_MODULE_1__["default"]
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VTreeview/util/filterTreeItems.ts":
	/*!**********************************************************!*\
	  !*** ./src/components/VTreeview/util/filterTreeItems.ts ***!
	  \**********************************************************/
	/*! exports provided: filterTreeItem, filterTreeItems */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "filterTreeItem", function() { return filterTreeItem; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "filterTreeItems", function() { return filterTreeItems; });
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../util/helpers */ "./src/util/helpers.ts");
	
	function filterTreeItem(item, search, textKey) {
	    var text = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["getObjectValueByPath"])(item, textKey);
	    return text.toLocaleLowerCase().indexOf(search.toLocaleLowerCase()) > -1;
	}
	function filterTreeItems(filter, item, search, idKey, textKey, childrenKey, excluded) {
	    if (filter(item, search, textKey)) {
	        return true;
	    }
	    var children = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["getObjectValueByPath"])(item, childrenKey);
	    if (children) {
	        var match = false;
	        for (var i = 0; i < children.length; i++) {
	            if (filterTreeItems(filter, children[i], search, idKey, textKey, childrenKey, excluded)) {
	                match = true;
	            }
	        }
	        if (match) return true;
	    }
	    excluded.add(Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["getObjectValueByPath"])(item, idKey));
	    return false;
	}
	
	/***/ }),
	
	/***/ "./src/components/VWindow/VWindow.ts":
	/*!*******************************************!*\
	  !*** ./src/components/VWindow/VWindow.ts ***!
	  \*******************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_windows_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_windows.styl */ "./src/stylus/components/_windows.styl");
	/* harmony import */ var _stylus_components_windows_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_windows_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _VItemGroup_VItemGroup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../VItemGroup/VItemGroup */ "./src/components/VItemGroup/VItemGroup.ts");
	/* harmony import */ var _directives_touch__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../directives/touch */ "./src/directives/touch.ts");
	// Styles
	
	// Components
	
	// Directives
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (_VItemGroup_VItemGroup__WEBPACK_IMPORTED_MODULE_1__["BaseItemGroup"].extend({
	    name: 'v-window',
	    provide: function provide() {
	        return {
	            windowGroup: this
	        };
	    },
	    directives: { Touch: _directives_touch__WEBPACK_IMPORTED_MODULE_2__["default"] },
	    props: {
	        mandatory: {
	            type: Boolean,
	            default: true
	        },
	        reverse: {
	            type: Boolean,
	            default: undefined
	        },
	        touch: Object,
	        touchless: Boolean,
	        value: {
	            required: false
	        },
	        vertical: Boolean
	    },
	    data: function data() {
	        return {
	            internalHeight: undefined,
	            isActive: false,
	            isBooted: false,
	            isReverse: false
	        };
	    },
	    computed: {
	        computedTransition: function computedTransition() {
	            if (!this.isBooted) return '';
	            var axis = this.vertical ? 'y' : 'x';
	            var direction = this.internalReverse === !this.$vuetify.rtl ? '-reverse' : '';
	            return "v-window-" + axis + direction + "-transition";
	        },
	        internalIndex: function internalIndex() {
	            var _this = this;
	            return this.items.findIndex(function (item, i) {
	                return _this.internalValue === _this.getValue(item, i);
	            });
	        },
	        internalReverse: function internalReverse() {
	            if (this.reverse !== undefined) return this.reverse;
	            return this.isReverse;
	        }
	    },
	    watch: {
	        internalIndex: 'updateReverse'
	    },
	    mounted: function mounted() {
	        var _this = this;
	        this.$nextTick(function () {
	            return _this.isBooted = true;
	        });
	    },
	    methods: {
	        genContainer: function genContainer() {
	            return this.$createElement('div', {
	                staticClass: 'v-window__container',
	                class: {
	                    'v-window__container--is-active': this.isActive
	                },
	                style: {
	                    height: this.internalHeight
	                }
	            }, this.$slots.default);
	        },
	        next: function next() {
	            this.isReverse = false;
	            var nextIndex = (this.internalIndex + 1) % this.items.length;
	            var item = this.items[nextIndex];
	            this.internalValue = this.getValue(item, nextIndex);
	        },
	        prev: function prev() {
	            this.isReverse = true;
	            var lastIndex = (this.internalIndex + this.items.length - 1) % this.items.length;
	            var item = this.items[lastIndex];
	            this.internalValue = this.getValue(item, lastIndex);
	        },
	        updateReverse: function updateReverse(val, oldVal) {
	            this.isReverse = val < oldVal;
	        }
	    },
	    render: function render(h) {
	        var data = {
	            staticClass: 'v-window',
	            directives: []
	        };
	        if (!this.touchless) {
	            var value = this.touch || {
	                left: this.next,
	                right: this.prev
	            };
	            data.directives.push({
	                name: 'touch',
	                value: value
	            });
	        }
	        return h('div', data, [this.genContainer()]);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VWindow/VWindowItem.ts":
	/*!***********************************************!*\
	  !*** ./src/components/VWindow/VWindowItem.ts ***!
	  \***********************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _mixins_bootable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mixins/bootable */ "./src/mixins/bootable.ts");
	/* harmony import */ var _mixins_groupable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/groupable */ "./src/mixins/groupable.ts");
	/* harmony import */ var _directives_touch__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../directives/touch */ "./src/directives/touch.ts");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	// Mixins
	
	
	// Directives
	
	// Utilities
	
	
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_4__["default"])(_mixins_bootable__WEBPACK_IMPORTED_MODULE_0__["default"], Object(_mixins_groupable__WEBPACK_IMPORTED_MODULE_1__["factory"])('windowGroup', 'v-window-item', 'v-window')
	/* @vue/component */
	).extend({
	    name: 'v-window-item',
	    directives: {
	        Touch: _directives_touch__WEBPACK_IMPORTED_MODULE_2__["default"]
	    },
	    props: {
	        reverseTransition: {
	            type: [Boolean, String],
	            default: undefined
	        },
	        transition: {
	            type: [Boolean, String],
	            default: undefined
	        },
	        value: {
	            required: false
	        }
	    },
	    data: function data() {
	        return {
	            done: null,
	            isActive: false,
	            wasCancelled: false
	        };
	    },
	    computed: {
	        computedTransition: function computedTransition() {
	            if (!this.windowGroup.internalReverse) {
	                return typeof this.transition !== 'undefined' ? this.transition || '' : this.windowGroup.computedTransition;
	            }
	            return typeof this.reverseTransition !== 'undefined' ? this.reverseTransition || '' : this.windowGroup.computedTransition;
	        }
	    },
	    mounted: function mounted() {
	        this.$el.addEventListener('transitionend', this.onTransitionEnd, false);
	    },
	    beforeDestroy: function beforeDestroy() {
	        this.$el.removeEventListener('transitionend', this.onTransitionEnd, false);
	    },
	    methods: {
	        genDefaultSlot: function genDefaultSlot() {
	            return this.$slots.default;
	        },
	        onAfterEnter: function onAfterEnter() {
	            var _this = this;
	            if (this.wasCancelled) {
	                this.wasCancelled = false;
	                return;
	            }
	            requestAnimationFrame(function () {
	                _this.windowGroup.internalHeight = undefined;
	                _this.windowGroup.isActive = false;
	            });
	        },
	        onBeforeEnter: function onBeforeEnter() {
	            this.windowGroup.isActive = true;
	        },
	        onLeave: function onLeave(el) {
	            this.windowGroup.internalHeight = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["convertToUnit"])(el.clientHeight);
	        },
	        onEnterCancelled: function onEnterCancelled() {
	            this.wasCancelled = true;
	        },
	        onEnter: function onEnter(el, done) {
	            var _this = this;
	            var isBooted = this.windowGroup.isBooted;
	            if (isBooted) this.done = done;
	            requestAnimationFrame(function () {
	                if (!_this.computedTransition) return done();
	                _this.windowGroup.internalHeight = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["convertToUnit"])(el.clientHeight);
	                // On initial render, there is no transition
	                // Vue leaves a `enter` transition class
	                // if done is called too fast
	                !isBooted && setTimeout(done, 100);
	            });
	        },
	        onTransitionEnd: function onTransitionEnd(e) {
	            // This ensures we only call done
	            // when the element transform
	            // completes
	            if (e.propertyName !== 'transform' || e.target !== this.$el || !this.done) return;
	            this.done();
	            this.done = null;
	        }
	    },
	    render: function render(h) {
	        var div = h('div', {
	            staticClass: 'v-window-item',
	            directives: [{
	                name: 'show',
	                value: this.isActive
	            }],
	            on: this.$listeners
	        }, this.showLazyContent(this.genDefaultSlot()));
	        return h('transition', {
	            props: {
	                name: this.computedTransition
	            },
	            on: {
	                afterEnter: this.onAfterEnter,
	                beforeEnter: this.onBeforeEnter,
	                leave: this.onLeave,
	                enter: this.onEnter,
	                enterCancelled: this.onEnterCancelled
	            }
	        }, [div]);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VWindow/index.ts":
	/*!*****************************************!*\
	  !*** ./src/components/VWindow/index.ts ***!
	  \*****************************************/
	/*! exports provided: VWindow, VWindowItem, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VWindow__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VWindow */ "./src/components/VWindow/VWindow.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VWindow", function() { return _VWindow__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	/* harmony import */ var _VWindowItem__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./VWindowItem */ "./src/components/VWindow/VWindowItem.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VWindowItem", function() { return _VWindowItem__WEBPACK_IMPORTED_MODULE_1__["default"]; });
	
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = ({
	    $_vuetify_subcomponents: {
	        VWindow: _VWindow__WEBPACK_IMPORTED_MODULE_0__["default"],
	        VWindowItem: _VWindowItem__WEBPACK_IMPORTED_MODULE_1__["default"]
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/Vuetify/goTo/easing-patterns.ts":
	/*!********************************************************!*\
	  !*** ./src/components/Vuetify/goTo/easing-patterns.ts ***!
	  \********************************************************/
	/*! exports provided: linear, easeInQuad, easeOutQuad, easeInOutQuad, easeInCubic, easeOutCubic, easeInOutCubic, easeInQuart, easeOutQuart, easeInOutQuart, easeInQuint, easeOutQuint, easeInOutQuint */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linear", function() { return linear; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "easeInQuad", function() { return easeInQuad; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "easeOutQuad", function() { return easeOutQuad; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "easeInOutQuad", function() { return easeInOutQuad; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "easeInCubic", function() { return easeInCubic; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "easeOutCubic", function() { return easeOutCubic; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "easeInOutCubic", function() { return easeInOutCubic; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "easeInQuart", function() { return easeInQuart; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "easeOutQuart", function() { return easeOutQuart; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "easeInOutQuart", function() { return easeInOutQuart; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "easeInQuint", function() { return easeInQuint; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "easeOutQuint", function() { return easeOutQuint; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "easeInOutQuint", function() { return easeInOutQuint; });
	// linear
	var linear = function linear(t) {
	  return t;
	};
	// accelerating from zero velocity
	var easeInQuad = function easeInQuad(t) {
	  return t * t;
	};
	// decelerating to zero velocity
	var easeOutQuad = function easeOutQuad(t) {
	  return t * (2 - t);
	};
	// acceleration until halfway, then deceleration
	var easeInOutQuad = function easeInOutQuad(t) {
	  return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
	};
	// accelerating from zero velocity
	var easeInCubic = function easeInCubic(t) {
	  return t * t * t;
	};
	// decelerating to zero velocity
	var easeOutCubic = function easeOutCubic(t) {
	  return --t * t * t + 1;
	};
	// acceleration until halfway, then deceleration
	var easeInOutCubic = function easeInOutCubic(t) {
	  return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
	};
	// accelerating from zero velocity
	var easeInQuart = function easeInQuart(t) {
	  return t * t * t * t;
	};
	// decelerating to zero velocity
	var easeOutQuart = function easeOutQuart(t) {
	  return 1 - --t * t * t * t;
	};
	// acceleration until halfway, then deceleration
	var easeInOutQuart = function easeInOutQuart(t) {
	  return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
	};
	// accelerating from zero velocity
	var easeInQuint = function easeInQuint(t) {
	  return t * t * t * t * t;
	};
	// decelerating to zero velocity
	var easeOutQuint = function easeOutQuint(t) {
	  return 1 + --t * t * t * t * t;
	};
	// acceleration until halfway, then deceleration
	var easeInOutQuint = function easeInOutQuint(t) {
	  return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
	};
	
	/***/ }),
	
	/***/ "./src/components/Vuetify/goTo/index.ts":
	/*!**********************************************!*\
	  !*** ./src/components/Vuetify/goTo/index.ts ***!
	  \**********************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return goTo; });
	/* harmony import */ var _easing_patterns__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./easing-patterns */ "./src/components/Vuetify/goTo/easing-patterns.ts");
	/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./util */ "./src/components/Vuetify/goTo/util.ts");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_2__);
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	
	
	
	function goTo(_target, _settings) {
	    if (_settings === void 0) {
	        _settings = {};
	    }
	    var settings = __assign({ container: document.scrollingElement || document.body || document.documentElement, duration: 500, offset: 0, easing: 'easeInOutCubic', appOffset: true }, _settings);
	    var container = Object(_util__WEBPACK_IMPORTED_MODULE_1__["getContainer"])(settings.container);
	    if (settings.appOffset) {
	        var isDrawer = container.classList.contains('v-navigation-drawer');
	        var isClipped = container.classList.contains('v-navigation-drawer--clipped');
	        settings.offset += vue__WEBPACK_IMPORTED_MODULE_2___default.a.prototype.$vuetify.application.bar;
	        if (!isDrawer || isClipped) settings.offset += vue__WEBPACK_IMPORTED_MODULE_2___default.a.prototype.$vuetify.application.top;
	    }
	    var startTime = performance.now();
	    var targetLocation = Object(_util__WEBPACK_IMPORTED_MODULE_1__["getOffset"])(_target) - settings.offset;
	    var startLocation = container.scrollTop;
	    if (targetLocation === startLocation) return Promise.resolve(targetLocation);
	    var ease = typeof settings.easing === 'function' ? settings.easing : _easing_patterns__WEBPACK_IMPORTED_MODULE_0__[settings.easing];
	    if (!ease) throw new TypeError("Easing function \"" + settings.easing + "\" not found.");
	    // tslint:disable-next-line:promise-must-complete
	    return new Promise(function (resolve) {
	        return requestAnimationFrame(function step(currentTime) {
	            var timeElapsed = currentTime - startTime;
	            var progress = Math.abs(settings.duration ? Math.min(timeElapsed / settings.duration, 1) : 1);
	            container.scrollTop = Math.floor(startLocation + (targetLocation - startLocation) * ease(progress));
	            if (progress === 1 || container.clientHeight + container.scrollTop === container.scrollHeight) {
	                return resolve(targetLocation);
	            }
	            requestAnimationFrame(step);
	        });
	    });
	}
	
	/***/ }),
	
	/***/ "./src/components/Vuetify/goTo/util.ts":
	/*!*********************************************!*\
	  !*** ./src/components/Vuetify/goTo/util.ts ***!
	  \*********************************************/
	/*! exports provided: getOffset, getContainer */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOffset", function() { return getOffset; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getContainer", function() { return getContainer; });
	// Return target's cumulative offset from the top
	function getOffset(target) {
	    if (typeof target === 'number') {
	        return target;
	    }
	    var el = $(target);
	    if (!el) {
	        throw typeof target === 'string' ? new Error("Target element \"" + target + "\" not found.") : new TypeError("Target must be a Number/Selector/HTMLElement/VueComponent, received " + type(target) + " instead.");
	    }
	    var totalOffset = 0;
	    while (el) {
	        totalOffset += el.offsetTop;
	        el = el.offsetParent;
	    }
	    return totalOffset;
	}
	function getContainer(container) {
	    var el = $(container);
	    if (el) return el;
	    throw typeof container === 'string' ? new Error("Container element \"" + container + "\" not found.") : new TypeError("Container must be a Selector/HTMLElement/VueComponent, received " + type(container) + " instead.");
	}
	function type(el) {
	    return el == null ? el : el.constructor.name;
	}
	function $(el) {
	    if (typeof el === 'string') {
	        return document.querySelector(el);
	    } else if (el && el._isVue) {
	        return el.$el;
	    } else if (el instanceof HTMLElement) {
	        return el;
	    } else {
	        return null;
	    }
	}
	
	/***/ }),
	
	/***/ "./src/components/Vuetify/index.ts":
	/*!*****************************************!*\
	  !*** ./src/components/Vuetify/index.ts ***!
	  \*****************************************/
	/*! exports provided: checkVueVersion, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "checkVueVersion", function() { return checkVueVersion; });
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_application__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./mixins/application */ "./src/components/Vuetify/mixins/application.ts");
	/* harmony import */ var _mixins_breakpoint__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./mixins/breakpoint */ "./src/components/Vuetify/mixins/breakpoint.ts");
	/* harmony import */ var _mixins_theme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./mixins/theme */ "./src/components/Vuetify/mixins/theme.ts");
	/* harmony import */ var _mixins_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./mixins/icons */ "./src/components/Vuetify/mixins/icons.ts");
	/* harmony import */ var _mixins_options__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./mixins/options */ "./src/components/Vuetify/mixins/options.ts");
	/* harmony import */ var _mixins_lang__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./mixins/lang */ "./src/components/Vuetify/mixins/lang.ts");
	/* harmony import */ var _goTo__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./goTo */ "./src/components/Vuetify/goTo/index.ts");
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../util/console */ "./src/util/console.ts");
	
	
	
	
	
	
	
	
	// Utils
	
	var Vuetify = {
	    install: function install(Vue, opts) {
	        if (opts === void 0) {
	            opts = {};
	        }
	        if (this.installed) return;
	        this.installed = true;
	        if (vue__WEBPACK_IMPORTED_MODULE_0___default.a !== Vue) {
	            Object(_util_console__WEBPACK_IMPORTED_MODULE_8__["consoleError"])('Multiple instances of Vue detected\nSee https://github.com/vuetifyjs/vuetify/issues/4068\n\nIf you\'re seeing "$attrs is readonly", it\'s caused by this');
	        }
	        checkVueVersion(Vue);
	        var lang = Object(_mixins_lang__WEBPACK_IMPORTED_MODULE_6__["default"])(opts.lang);
	        Vue.prototype.$vuetify = new Vue({
	            mixins: [Object(_mixins_breakpoint__WEBPACK_IMPORTED_MODULE_2__["default"])(opts.breakpoint)],
	            data: {
	                application: _mixins_application__WEBPACK_IMPORTED_MODULE_1__["default"],
	                dark: false,
	                icons: Object(_mixins_icons__WEBPACK_IMPORTED_MODULE_4__["default"])(opts.iconfont, opts.icons),
	                lang: lang,
	                options: Object(_mixins_options__WEBPACK_IMPORTED_MODULE_5__["default"])(opts.options),
	                rtl: opts.rtl,
	                theme: Object(_mixins_theme__WEBPACK_IMPORTED_MODULE_3__["default"])(opts.theme)
	            },
	            methods: {
	                goTo: _goTo__WEBPACK_IMPORTED_MODULE_7__["default"],
	                t: lang.t.bind(lang)
	            }
	        });
	        if (opts.directives) {
	            for (var name in opts.directives) {
	                Vue.directive(name, opts.directives[name]);
	            }
	        }
	        (function registerComponents(components) {
	            if (components) {
	                for (var key in components) {
	                    var component = components[key];
	                    if (component && !registerComponents(component.$_vuetify_subcomponents)) {
	                        Vue.component(key, component);
	                    }
	                }
	                return true;
	            }
	            return false;
	        })(opts.components);
	    },
	    version: '1.5.14'
	};
	function checkVueVersion(Vue, requiredVue) {
	    var vueDep = requiredVue || '^2.5.18';
	    var required = vueDep.split('.', 3).map(function (v) {
	        return v.replace(/\D/g, '');
	    }).map(Number);
	    var actual = Vue.version.split('.', 3).map(function (n) {
	        return parseInt(n, 10);
	    });
	    // Simple semver caret range comparison
	    var passes = actual[0] === required[0] && ( // major matches
	    actual[1] > required[1] || // minor is greater
	    actual[1] === required[1] && actual[2] >= required[2] // or minor is eq and patch is >=
	    );
	    if (!passes) {
	        Object(_util_console__WEBPACK_IMPORTED_MODULE_8__["consoleWarn"])("Vuetify requires Vue version " + vueDep);
	    }
	}
	/* harmony default export */ __webpack_exports__["default"] = (Vuetify);
	
	/***/ }),
	
	/***/ "./src/components/Vuetify/mixins/application.ts":
	/*!******************************************************!*\
	  !*** ./src/components/Vuetify/mixins/application.ts ***!
	  \******************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony default export */ __webpack_exports__["default"] = ({
	    bar: 0,
	    bottom: 0,
	    footer: 0,
	    insetFooter: 0,
	    left: 0,
	    right: 0,
	    top: 0,
	    components: {
	        bar: {},
	        bottom: {},
	        footer: {},
	        insetFooter: {},
	        left: {},
	        right: {},
	        top: {}
	    },
	    bind: function bind(uid, target, value) {
	        var _a;
	        if (!this.components[target]) return;
	        this.components[target] = (_a = {}, _a[uid] = value, _a);
	        this.update(target);
	    },
	    unbind: function unbind(uid, target) {
	        if (this.components[target][uid] == null) return;
	        delete this.components[target][uid];
	        this.update(target);
	    },
	    update: function update(target) {
	        this[target] = Object.values(this.components[target]).reduce(function (acc, cur) {
	            return acc + cur;
	        }, 0);
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/Vuetify/mixins/breakpoint.ts":
	/*!*****************************************************!*\
	  !*** ./src/components/Vuetify/mixins/breakpoint.ts ***!
	  \*****************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return breakpoint; });
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	
	var BREAKPOINTS_DEFAULTS = {
	    thresholds: {
	        xs: 600,
	        sm: 960,
	        md: 1280,
	        lg: 1920
	    },
	    scrollbarWidth: 16
	};
	/**
	 * Factory function for the breakpoint mixin.
	 */
	function breakpoint(opts) {
	    if (opts === void 0) {
	        opts = {};
	    }
	    if (!opts) {
	        opts = {};
	    }
	    return vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
	        data: function data() {
	            return __assign({ clientHeight: getClientHeight(), clientWidth: getClientWidth(), resizeTimeout: undefined }, BREAKPOINTS_DEFAULTS, opts);
	        },
	        computed: {
	            breakpoint: function breakpoint() {
	                var xs = this.clientWidth < this.thresholds.xs;
	                var sm = this.clientWidth < this.thresholds.sm && !xs;
	                var md = this.clientWidth < this.thresholds.md - this.scrollbarWidth && !(sm || xs);
	                var lg = this.clientWidth < this.thresholds.lg - this.scrollbarWidth && !(md || sm || xs);
	                var xl = this.clientWidth >= this.thresholds.lg - this.scrollbarWidth;
	                var xsOnly = xs;
	                var smOnly = sm;
	                var smAndDown = (xs || sm) && !(md || lg || xl);
	                var smAndUp = !xs && (sm || md || lg || xl);
	                var mdOnly = md;
	                var mdAndDown = (xs || sm || md) && !(lg || xl);
	                var mdAndUp = !(xs || sm) && (md || lg || xl);
	                var lgOnly = lg;
	                var lgAndDown = (xs || sm || md || lg) && !xl;
	                var lgAndUp = !(xs || sm || md) && (lg || xl);
	                var xlOnly = xl;
	                var name;
	                switch (true) {
	                    case xs:
	                        name = 'xs';
	                        break;
	                    case sm:
	                        name = 'sm';
	                        break;
	                    case md:
	                        name = 'md';
	                        break;
	                    case lg:
	                        name = 'lg';
	                        break;
	                    default:
	                        name = 'xl';
	                        break;
	                }
	                return {
	                    // Definite breakpoint.
	                    xs: xs,
	                    sm: sm,
	                    md: md,
	                    lg: lg,
	                    xl: xl,
	                    // Useful e.g. to construct CSS class names dynamically.
	                    name: name,
	                    // Breakpoint ranges.
	                    xsOnly: xsOnly,
	                    smOnly: smOnly,
	                    smAndDown: smAndDown,
	                    smAndUp: smAndUp,
	                    mdOnly: mdOnly,
	                    mdAndDown: mdAndDown,
	                    mdAndUp: mdAndUp,
	                    lgOnly: lgOnly,
	                    lgAndDown: lgAndDown,
	                    lgAndUp: lgAndUp,
	                    xlOnly: xlOnly,
	                    // For custom breakpoint logic.
	                    width: this.clientWidth,
	                    height: this.clientHeight,
	                    thresholds: this.thresholds,
	                    scrollbarWidth: this.scrollbarWidth
	                };
	            }
	        },
	        created: function created() {
	            if (typeof window === 'undefined') return;
	            window.addEventListener('resize', this.onResize, { passive: true });
	        },
	        beforeDestroy: function beforeDestroy() {
	            if (typeof window === 'undefined') return;
	            window.removeEventListener('resize', this.onResize);
	        },
	        methods: {
	            onResize: function onResize() {
	                clearTimeout(this.resizeTimeout);
	                // Added debounce to match what
	                // v-resize used to do but was
	                // removed due to a memory leak
	                // https://github.com/vuetifyjs/vuetify/pull/2997
	                this.resizeTimeout = window.setTimeout(this.setDimensions, 200);
	            },
	            setDimensions: function setDimensions() {
	                this.clientHeight = getClientHeight();
	                this.clientWidth = getClientWidth();
	            }
	        }
	    });
	}
	// Cross-browser support as described in:
	// https://stackoverflow.com/questions/1248081
	function getClientWidth() {
	    if (typeof document === 'undefined') return 0; // SSR
	    return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
	}
	function getClientHeight() {
	    if (typeof document === 'undefined') return 0; // SSR
	    return Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
	}
	
	/***/ }),
	
	/***/ "./src/components/Vuetify/mixins/icons.ts":
	/*!************************************************!*\
	  !*** ./src/components/Vuetify/mixins/icons.ts ***!
	  \************************************************/
	/*! exports provided: convertToComponentDeclarations, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "convertToComponentDeclarations", function() { return convertToComponentDeclarations; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return icons; });
	// Maps internal Vuetify icon names to actual Material Design icon names.
	var ICONS_MATERIAL = {
	    'complete': 'check',
	    'cancel': 'cancel',
	    'close': 'close',
	    'delete': 'cancel',
	    'clear': 'clear',
	    'success': 'check_circle',
	    'info': 'info',
	    'warning': 'priority_high',
	    'error': 'warning',
	    'prev': 'chevron_left',
	    'next': 'chevron_right',
	    'checkboxOn': 'check_box',
	    'checkboxOff': 'check_box_outline_blank',
	    'checkboxIndeterminate': 'indeterminate_check_box',
	    'delimiter': 'fiber_manual_record',
	    'sort': 'arrow_upward',
	    'expand': 'keyboard_arrow_down',
	    'menu': 'menu',
	    'subgroup': 'arrow_drop_down',
	    'dropdown': 'arrow_drop_down',
	    'radioOn': 'radio_button_checked',
	    'radioOff': 'radio_button_unchecked',
	    'edit': 'edit',
	    'ratingEmpty': 'star_border',
	    'ratingFull': 'star',
	    'ratingHalf': 'star_half',
	    'loading': 'cached'
	};
	// Maps internal Vuetify icon names to actual icons from materialdesignicons.com
	var ICONS_MDI = {
	    'complete': 'mdi-check',
	    'cancel': 'mdi-close-circle',
	    'close': 'mdi-close',
	    'delete': 'mdi-close-circle',
	    'clear': 'mdi-close',
	    'success': 'mdi-check-circle',
	    'info': 'mdi-information',
	    'warning': 'mdi-exclamation',
	    'error': 'mdi-alert',
	    'prev': 'mdi-chevron-left',
	    'next': 'mdi-chevron-right',
	    'checkboxOn': 'mdi-checkbox-marked',
	    'checkboxOff': 'mdi-checkbox-blank-outline',
	    'checkboxIndeterminate': 'mdi-minus-box',
	    'delimiter': 'mdi-circle',
	    'sort': 'mdi-arrow-up',
	    'expand': 'mdi-chevron-down',
	    'menu': 'mdi-menu',
	    'subgroup': 'mdi-menu-down',
	    'dropdown': 'mdi-menu-down',
	    'radioOn': 'mdi-radiobox-marked',
	    'radioOff': 'mdi-radiobox-blank',
	    'edit': 'mdi-pencil',
	    'ratingEmpty': 'mdi-star-outline',
	    'ratingFull': 'mdi-star',
	    'ratingHalf': 'mdi-star-half'
	};
	// Maps internal Vuetify icon names to actual Font-Awesome 4 icon names.
	var ICONS_FONTAWESOME4 = {
	    'complete': 'fa fa-check',
	    'cancel': 'fa fa-times-circle',
	    'close': 'fa fa-times',
	    'delete': 'fa fa-times-circle',
	    'clear': 'fa fa-times-circle',
	    'success': 'fa fa-check-circle',
	    'info': 'fa fa-info-circle',
	    'warning': 'fa fa-exclamation',
	    'error': 'fa fa-exclamation-triangle',
	    'prev': 'fa fa-chevron-left',
	    'next': 'fa fa-chevron-right',
	    'checkboxOn': 'fa fa-check-square',
	    'checkboxOff': 'fa fa-square-o',
	    'checkboxIndeterminate': 'fa fa-minus-square',
	    'delimiter': 'fa fa-circle',
	    'sort': 'fa fa-sort-up',
	    'expand': 'fa fa-chevron-down',
	    'menu': 'fa fa-bars',
	    'subgroup': 'fa fa-caret-down',
	    'dropdown': 'fa fa-caret-down',
	    'radioOn': 'fa fa-dot-circle',
	    'radioOff': 'fa fa-circle-o',
	    'edit': 'fa fa-pencil',
	    'ratingEmpty': 'fa fa-star-o',
	    'ratingFull': 'fa fa-star',
	    'ratingHalf': 'fa fa-star-half-o'
	};
	// Maps internal Vuetify icon names to actual Font-Awesome 5+ icon names.
	var ICONS_FONTAWESOME = {
	    'complete': 'fas fa-check',
	    'cancel': 'fas fa-times-circle',
	    'close': 'fas fa-times',
	    'delete': 'fas fa-times-circle',
	    'clear': 'fas fa-times-circle',
	    'success': 'fas fa-check-circle',
	    'info': 'fas fa-info-circle',
	    'warning': 'fas fa-exclamation',
	    'error': 'fas fa-exclamation-triangle',
	    'prev': 'fas fa-chevron-left',
	    'next': 'fas fa-chevron-right',
	    'checkboxOn': 'fas fa-check-square',
	    'checkboxOff': 'far fa-square',
	    'checkboxIndeterminate': 'fas fa-minus-square',
	    'delimiter': 'fas fa-circle',
	    'sort': 'fas fa-sort-up',
	    'expand': 'fas fa-chevron-down',
	    'menu': 'fas fa-bars',
	    'subgroup': 'fas fa-caret-down',
	    'dropdown': 'fas fa-caret-down',
	    'radioOn': 'far fa-dot-circle',
	    'radioOff': 'far fa-circle',
	    'edit': 'fas fa-edit',
	    'ratingEmpty': 'far fa-star',
	    'ratingFull': 'fas fa-star',
	    'ratingHalf': 'fas fa-star-half'
	};
	function convertToComponentDeclarations(component, iconSet) {
	    var result = {};
	    for (var key in iconSet) {
	        result[key] = {
	            component: component,
	            props: {
	                icon: iconSet[key].split(' fa-')
	            }
	        };
	    }
	    return result;
	}
	var iconSets = {
	    md: ICONS_MATERIAL,
	    mdi: ICONS_MDI,
	    fa: ICONS_FONTAWESOME,
	    fa4: ICONS_FONTAWESOME4,
	    faSvg: convertToComponentDeclarations('font-awesome-icon', ICONS_FONTAWESOME)
	};
	function icons(iconfont, icons) {
	    if (iconfont === void 0) {
	        iconfont = 'md';
	    }
	    if (icons === void 0) {
	        icons = {};
	    }
	    return Object.assign({}, iconSets[iconfont] || iconSets.md, icons);
	}
	
	/***/ }),
	
	/***/ "./src/components/Vuetify/mixins/lang.ts":
	/*!***********************************************!*\
	  !*** ./src/components/Vuetify/mixins/lang.ts ***!
	  \***********************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return lang; });
	/* harmony import */ var _locale_en__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../locale/en */ "./src/locale/en.ts");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../util/console */ "./src/util/console.ts");
	var __read = undefined && undefined.__read || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o),
	        r,
	        ar = [],
	        e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
	            ar.push(r.value);
	        }
	    } catch (error) {
	        e = { error: error };
	    } finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        } finally {
	            if (e) throw e.error;
	        }
	    }
	    return ar;
	};
	var __spread = undefined && undefined.__spread || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) {
	        ar = ar.concat(__read(arguments[i]));
	    }return ar;
	};
	
	
	
	var LANG_PREFIX = '$vuetify.';
	var fallback = Symbol('Lang fallback');
	function getTranslation(locale, key, usingFallback) {
	    if (usingFallback === void 0) {
	        usingFallback = false;
	    }
	    var shortKey = key.replace(LANG_PREFIX, '');
	    var translation = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__["getObjectValueByPath"])(locale, shortKey, fallback);
	    if (translation === fallback) {
	        if (usingFallback) {
	            Object(_util_console__WEBPACK_IMPORTED_MODULE_2__["consoleError"])("Translation key \"" + shortKey + "\" not found in fallback");
	            translation = key;
	        } else {
	            Object(_util_console__WEBPACK_IMPORTED_MODULE_2__["consoleWarn"])("Translation key \"" + shortKey + "\" not found, falling back to default");
	            translation = getTranslation(_locale_en__WEBPACK_IMPORTED_MODULE_0__["default"], key, true);
	        }
	    }
	    return translation;
	}
	function lang(config) {
	    if (config === void 0) {
	        config = {};
	    }
	    return {
	        locales: Object.assign({ en: _locale_en__WEBPACK_IMPORTED_MODULE_0__["default"] }, config.locales),
	        current: config.current || 'en',
	        t: function t(key) {
	            var params = [];
	            for (var _i = 1; _i < arguments.length; _i++) {
	                params[_i - 1] = arguments[_i];
	            }
	            if (!key.startsWith(LANG_PREFIX)) return key;
	            if (config.t) return config.t.apply(config, __spread([key], params));
	            var translation = getTranslation(this.locales[this.current], key);
	            return translation.replace(/\{(\d+)\}/g, function (match, index) {
	                return String(params[+index]);
	            });
	        }
	    };
	}
	
	/***/ }),
	
	/***/ "./src/components/Vuetify/mixins/options.ts":
	/*!**************************************************!*\
	  !*** ./src/components/Vuetify/mixins/options.ts ***!
	  \**************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return options; });
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var OPTIONS_DEFAULTS = {
	    minifyTheme: null,
	    themeCache: null,
	    customProperties: false,
	    cspNonce: null
	};
	function options(options) {
	    if (options === void 0) {
	        options = {};
	    }
	    return __assign({}, OPTIONS_DEFAULTS, options);
	}
	
	/***/ }),
	
	/***/ "./src/components/Vuetify/mixins/theme.ts":
	/*!************************************************!*\
	  !*** ./src/components/Vuetify/mixins/theme.ts ***!
	  \************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return theme; });
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	/* eslint-disable no-multi-spaces */
	var THEME_DEFAULTS = {
	    primary: '#1976D2',
	    secondary: '#424242',
	    accent: '#82B1FF',
	    error: '#FF5252',
	    info: '#2196F3',
	    success: '#4CAF50',
	    warning: '#FB8C00' // orange.darken1
	};
	function theme(theme) {
	    if (theme === void 0) {
	        theme = {};
	    }
	    if (theme === false) return false;
	    return __assign({}, THEME_DEFAULTS, theme);
	}
	
	/***/ }),
	
	/***/ "./src/components/index.ts":
	/*!*********************************!*\
	  !*** ./src/components/index.ts ***!
	  \*********************************/
	/*! exports provided: VApp, VAlert, VAutocomplete, VAvatar, VBadge, VBottomNav, VBottomSheet, VBreadcrumbs, VBreadcrumbsItem, VBreadcrumbsDivider, VBtn, VBtnToggle, VCalendar, VCalendarDaily, VCalendarWeekly, VCalendarMonthly, VCard, VCardMedia, VCardTitle, VCardActions, VCardText, VCarousel, VCarouselItem, VCheckbox, VChip, VCombobox, VCounter, VDataIterator, VDataTable, VEditDialog, VTableOverflow, VDatePicker, VDatePickerTitle, VDatePickerHeader, VDatePickerDateTable, VDatePickerMonthTable, VDatePickerYears, VDialog, VDivider, VExpansionPanel, VExpansionPanelContent, VFooter, VForm, VContainer, VContent, VFlex, VLayout, VSpacer, VHover, VIcon, VImg, VInput, VItem, VItemGroup, VJumbotron, VLabel, VList, VListGroup, VListTile, VListTileAction, VListTileAvatar, VListTileActionText, VListTileContent, VListTileTitle, VListTileSubTitle, VMenu, VMessages, VNavigationDrawer, VOverflowBtn, VPagination, VSheet, VParallax, VPicker, VProgressCircular, VProgressLinear, VRadioGroup, VRadio, VRangeSlider, VRating, VResponsive, VSelect, VSlider, VSnackbar, VSparkline, VSpeedDial, VStepper, VStepperContent, VStepperStep, VStepperHeader, VStepperItems, VSubheader, VSwitch, VSystemBar, VTabs, VTab, VTabItem, VTabsItems, VTabsSlider, VTextarea, VTextField, VTimeline, VTimelineItem, VTimePicker, VTimePickerClock, VTimePickerTitle, VToolbar, VToolbarSideIcon, VToolbarTitle, VToolbarItems, VTooltip, VTreeview, VTreeviewNode, VWindow, VWindowItem, VBottomSheetTransition, VCarouselTransition, VCarouselReverseTransition, VTabTransition, VTabReverseTransition, VMenuTransition, VFabTransition, VDialogTransition, VDialogBottomTransition, VFadeTransition, VScaleTransition, VScrollXTransition, VScrollXReverseTransition, VScrollYTransition, VScrollYReverseTransition, VSlideXTransition, VSlideXReverseTransition, VSlideYTransition, VSlideYReverseTransition, VExpandTransition, VExpandXTransition, VRowExpandTransition */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VApp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VApp */ "./src/components/VApp/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VApp", function() { return _VApp__WEBPACK_IMPORTED_MODULE_0__["VApp"]; });
	
	/* harmony import */ var _VAlert__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./VAlert */ "./src/components/VAlert/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VAlert", function() { return _VAlert__WEBPACK_IMPORTED_MODULE_1__["VAlert"]; });
	
	/* harmony import */ var _VAutocomplete__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./VAutocomplete */ "./src/components/VAutocomplete/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VAutocomplete", function() { return _VAutocomplete__WEBPACK_IMPORTED_MODULE_2__["VAutocomplete"]; });
	
	/* harmony import */ var _VAvatar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./VAvatar */ "./src/components/VAvatar/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VAvatar", function() { return _VAvatar__WEBPACK_IMPORTED_MODULE_3__["VAvatar"]; });
	
	/* harmony import */ var _VBadge__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./VBadge */ "./src/components/VBadge/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VBadge", function() { return _VBadge__WEBPACK_IMPORTED_MODULE_4__["VBadge"]; });
	
	/* harmony import */ var _VBottomNav__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./VBottomNav */ "./src/components/VBottomNav/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VBottomNav", function() { return _VBottomNav__WEBPACK_IMPORTED_MODULE_5__["VBottomNav"]; });
	
	/* harmony import */ var _VBottomSheet__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./VBottomSheet */ "./src/components/VBottomSheet/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VBottomSheet", function() { return _VBottomSheet__WEBPACK_IMPORTED_MODULE_6__["VBottomSheet"]; });
	
	/* harmony import */ var _VBreadcrumbs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./VBreadcrumbs */ "./src/components/VBreadcrumbs/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VBreadcrumbs", function() { return _VBreadcrumbs__WEBPACK_IMPORTED_MODULE_7__["VBreadcrumbs"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VBreadcrumbsItem", function() { return _VBreadcrumbs__WEBPACK_IMPORTED_MODULE_7__["VBreadcrumbsItem"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VBreadcrumbsDivider", function() { return _VBreadcrumbs__WEBPACK_IMPORTED_MODULE_7__["VBreadcrumbsDivider"]; });
	
	/* harmony import */ var _VBtn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./VBtn */ "./src/components/VBtn/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VBtn", function() { return _VBtn__WEBPACK_IMPORTED_MODULE_8__["VBtn"]; });
	
	/* harmony import */ var _VBtnToggle__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./VBtnToggle */ "./src/components/VBtnToggle/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VBtnToggle", function() { return _VBtnToggle__WEBPACK_IMPORTED_MODULE_9__["VBtnToggle"]; });
	
	/* harmony import */ var _VCalendar__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./VCalendar */ "./src/components/VCalendar/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VCalendar", function() { return _VCalendar__WEBPACK_IMPORTED_MODULE_10__["VCalendar"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VCalendarDaily", function() { return _VCalendar__WEBPACK_IMPORTED_MODULE_10__["VCalendarDaily"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VCalendarWeekly", function() { return _VCalendar__WEBPACK_IMPORTED_MODULE_10__["VCalendarWeekly"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VCalendarMonthly", function() { return _VCalendar__WEBPACK_IMPORTED_MODULE_10__["VCalendarMonthly"]; });
	
	/* harmony import */ var _VCard__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./VCard */ "./src/components/VCard/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VCard", function() { return _VCard__WEBPACK_IMPORTED_MODULE_11__["VCard"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VCardMedia", function() { return _VCard__WEBPACK_IMPORTED_MODULE_11__["VCardMedia"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VCardTitle", function() { return _VCard__WEBPACK_IMPORTED_MODULE_11__["VCardTitle"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VCardActions", function() { return _VCard__WEBPACK_IMPORTED_MODULE_11__["VCardActions"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VCardText", function() { return _VCard__WEBPACK_IMPORTED_MODULE_11__["VCardText"]; });
	
	/* harmony import */ var _VCarousel__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./VCarousel */ "./src/components/VCarousel/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VCarousel", function() { return _VCarousel__WEBPACK_IMPORTED_MODULE_12__["VCarousel"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VCarouselItem", function() { return _VCarousel__WEBPACK_IMPORTED_MODULE_12__["VCarouselItem"]; });
	
	/* harmony import */ var _VCheckbox__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./VCheckbox */ "./src/components/VCheckbox/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VCheckbox", function() { return _VCheckbox__WEBPACK_IMPORTED_MODULE_13__["VCheckbox"]; });
	
	/* harmony import */ var _VChip__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./VChip */ "./src/components/VChip/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VChip", function() { return _VChip__WEBPACK_IMPORTED_MODULE_14__["VChip"]; });
	
	/* harmony import */ var _VCombobox__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./VCombobox */ "./src/components/VCombobox/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VCombobox", function() { return _VCombobox__WEBPACK_IMPORTED_MODULE_15__["VCombobox"]; });
	
	/* harmony import */ var _VCounter__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./VCounter */ "./src/components/VCounter/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VCounter", function() { return _VCounter__WEBPACK_IMPORTED_MODULE_16__["VCounter"]; });
	
	/* harmony import */ var _VDataIterator__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./VDataIterator */ "./src/components/VDataIterator/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VDataIterator", function() { return _VDataIterator__WEBPACK_IMPORTED_MODULE_17__["VDataIterator"]; });
	
	/* harmony import */ var _VDataTable__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./VDataTable */ "./src/components/VDataTable/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VDataTable", function() { return _VDataTable__WEBPACK_IMPORTED_MODULE_18__["VDataTable"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VEditDialog", function() { return _VDataTable__WEBPACK_IMPORTED_MODULE_18__["VEditDialog"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTableOverflow", function() { return _VDataTable__WEBPACK_IMPORTED_MODULE_18__["VTableOverflow"]; });
	
	/* harmony import */ var _VDatePicker__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./VDatePicker */ "./src/components/VDatePicker/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VDatePicker", function() { return _VDatePicker__WEBPACK_IMPORTED_MODULE_19__["VDatePicker"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VDatePickerTitle", function() { return _VDatePicker__WEBPACK_IMPORTED_MODULE_19__["VDatePickerTitle"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VDatePickerHeader", function() { return _VDatePicker__WEBPACK_IMPORTED_MODULE_19__["VDatePickerHeader"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VDatePickerDateTable", function() { return _VDatePicker__WEBPACK_IMPORTED_MODULE_19__["VDatePickerDateTable"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VDatePickerMonthTable", function() { return _VDatePicker__WEBPACK_IMPORTED_MODULE_19__["VDatePickerMonthTable"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VDatePickerYears", function() { return _VDatePicker__WEBPACK_IMPORTED_MODULE_19__["VDatePickerYears"]; });
	
	/* harmony import */ var _VDialog__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./VDialog */ "./src/components/VDialog/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VDialog", function() { return _VDialog__WEBPACK_IMPORTED_MODULE_20__["VDialog"]; });
	
	/* harmony import */ var _VDivider__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./VDivider */ "./src/components/VDivider/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VDivider", function() { return _VDivider__WEBPACK_IMPORTED_MODULE_21__["VDivider"]; });
	
	/* harmony import */ var _VExpansionPanel__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./VExpansionPanel */ "./src/components/VExpansionPanel/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VExpansionPanel", function() { return _VExpansionPanel__WEBPACK_IMPORTED_MODULE_22__["VExpansionPanel"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VExpansionPanelContent", function() { return _VExpansionPanel__WEBPACK_IMPORTED_MODULE_22__["VExpansionPanelContent"]; });
	
	/* harmony import */ var _VFooter__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./VFooter */ "./src/components/VFooter/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VFooter", function() { return _VFooter__WEBPACK_IMPORTED_MODULE_23__["VFooter"]; });
	
	/* harmony import */ var _VForm__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./VForm */ "./src/components/VForm/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VForm", function() { return _VForm__WEBPACK_IMPORTED_MODULE_24__["VForm"]; });
	
	/* harmony import */ var _VGrid__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./VGrid */ "./src/components/VGrid/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VContainer", function() { return _VGrid__WEBPACK_IMPORTED_MODULE_25__["VContainer"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VContent", function() { return _VGrid__WEBPACK_IMPORTED_MODULE_25__["VContent"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VFlex", function() { return _VGrid__WEBPACK_IMPORTED_MODULE_25__["VFlex"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VLayout", function() { return _VGrid__WEBPACK_IMPORTED_MODULE_25__["VLayout"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VSpacer", function() { return _VGrid__WEBPACK_IMPORTED_MODULE_25__["VSpacer"]; });
	
	/* harmony import */ var _VHover__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./VHover */ "./src/components/VHover/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VHover", function() { return _VHover__WEBPACK_IMPORTED_MODULE_26__["VHover"]; });
	
	/* harmony import */ var _VIcon__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./VIcon */ "./src/components/VIcon/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VIcon", function() { return _VIcon__WEBPACK_IMPORTED_MODULE_27__["VIcon"]; });
	
	/* harmony import */ var _VImg__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ./VImg */ "./src/components/VImg/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VImg", function() { return _VImg__WEBPACK_IMPORTED_MODULE_28__["VImg"]; });
	
	/* harmony import */ var _VInput__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ./VInput */ "./src/components/VInput/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VInput", function() { return _VInput__WEBPACK_IMPORTED_MODULE_29__["VInput"]; });
	
	/* harmony import */ var _VItemGroup__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ./VItemGroup */ "./src/components/VItemGroup/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VItem", function() { return _VItemGroup__WEBPACK_IMPORTED_MODULE_30__["VItem"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VItemGroup", function() { return _VItemGroup__WEBPACK_IMPORTED_MODULE_30__["VItemGroup"]; });
	
	/* harmony import */ var _VJumbotron__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ./VJumbotron */ "./src/components/VJumbotron/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VJumbotron", function() { return _VJumbotron__WEBPACK_IMPORTED_MODULE_31__["VJumbotron"]; });
	
	/* harmony import */ var _VLabel__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ./VLabel */ "./src/components/VLabel/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VLabel", function() { return _VLabel__WEBPACK_IMPORTED_MODULE_32__["VLabel"]; });
	
	/* harmony import */ var _VList__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ./VList */ "./src/components/VList/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VList", function() { return _VList__WEBPACK_IMPORTED_MODULE_33__["VList"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VListGroup", function() { return _VList__WEBPACK_IMPORTED_MODULE_33__["VListGroup"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VListTile", function() { return _VList__WEBPACK_IMPORTED_MODULE_33__["VListTile"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VListTileAction", function() { return _VList__WEBPACK_IMPORTED_MODULE_33__["VListTileAction"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VListTileAvatar", function() { return _VList__WEBPACK_IMPORTED_MODULE_33__["VListTileAvatar"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VListTileActionText", function() { return _VList__WEBPACK_IMPORTED_MODULE_33__["VListTileActionText"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VListTileContent", function() { return _VList__WEBPACK_IMPORTED_MODULE_33__["VListTileContent"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VListTileTitle", function() { return _VList__WEBPACK_IMPORTED_MODULE_33__["VListTileTitle"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VListTileSubTitle", function() { return _VList__WEBPACK_IMPORTED_MODULE_33__["VListTileSubTitle"]; });
	
	/* harmony import */ var _VMenu__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ./VMenu */ "./src/components/VMenu/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VMenu", function() { return _VMenu__WEBPACK_IMPORTED_MODULE_34__["VMenu"]; });
	
	/* harmony import */ var _VMessages__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ./VMessages */ "./src/components/VMessages/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VMessages", function() { return _VMessages__WEBPACK_IMPORTED_MODULE_35__["VMessages"]; });
	
	/* harmony import */ var _VNavigationDrawer__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ./VNavigationDrawer */ "./src/components/VNavigationDrawer/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VNavigationDrawer", function() { return _VNavigationDrawer__WEBPACK_IMPORTED_MODULE_36__["VNavigationDrawer"]; });
	
	/* harmony import */ var _VOverflowBtn__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ./VOverflowBtn */ "./src/components/VOverflowBtn/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VOverflowBtn", function() { return _VOverflowBtn__WEBPACK_IMPORTED_MODULE_37__["VOverflowBtn"]; });
	
	/* harmony import */ var _VPagination__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! ./VPagination */ "./src/components/VPagination/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VPagination", function() { return _VPagination__WEBPACK_IMPORTED_MODULE_38__["VPagination"]; });
	
	/* harmony import */ var _VSheet__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! ./VSheet */ "./src/components/VSheet/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VSheet", function() { return _VSheet__WEBPACK_IMPORTED_MODULE_39__["VSheet"]; });
	
	/* harmony import */ var _VParallax__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! ./VParallax */ "./src/components/VParallax/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VParallax", function() { return _VParallax__WEBPACK_IMPORTED_MODULE_40__["VParallax"]; });
	
	/* harmony import */ var _VPicker__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! ./VPicker */ "./src/components/VPicker/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VPicker", function() { return _VPicker__WEBPACK_IMPORTED_MODULE_41__["VPicker"]; });
	
	/* harmony import */ var _VProgressCircular__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! ./VProgressCircular */ "./src/components/VProgressCircular/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VProgressCircular", function() { return _VProgressCircular__WEBPACK_IMPORTED_MODULE_42__["VProgressCircular"]; });
	
	/* harmony import */ var _VProgressLinear__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! ./VProgressLinear */ "./src/components/VProgressLinear/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VProgressLinear", function() { return _VProgressLinear__WEBPACK_IMPORTED_MODULE_43__["VProgressLinear"]; });
	
	/* harmony import */ var _VRadioGroup__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! ./VRadioGroup */ "./src/components/VRadioGroup/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VRadioGroup", function() { return _VRadioGroup__WEBPACK_IMPORTED_MODULE_44__["VRadioGroup"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VRadio", function() { return _VRadioGroup__WEBPACK_IMPORTED_MODULE_44__["VRadio"]; });
	
	/* harmony import */ var _VRangeSlider__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! ./VRangeSlider */ "./src/components/VRangeSlider/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VRangeSlider", function() { return _VRangeSlider__WEBPACK_IMPORTED_MODULE_45__["VRangeSlider"]; });
	
	/* harmony import */ var _VRating__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! ./VRating */ "./src/components/VRating/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VRating", function() { return _VRating__WEBPACK_IMPORTED_MODULE_46__["VRating"]; });
	
	/* harmony import */ var _VResponsive__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! ./VResponsive */ "./src/components/VResponsive/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VResponsive", function() { return _VResponsive__WEBPACK_IMPORTED_MODULE_47__["VResponsive"]; });
	
	/* harmony import */ var _VSelect__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! ./VSelect */ "./src/components/VSelect/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VSelect", function() { return _VSelect__WEBPACK_IMPORTED_MODULE_48__["VSelect"]; });
	
	/* harmony import */ var _VSlider__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(/*! ./VSlider */ "./src/components/VSlider/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VSlider", function() { return _VSlider__WEBPACK_IMPORTED_MODULE_49__["VSlider"]; });
	
	/* harmony import */ var _VSnackbar__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(/*! ./VSnackbar */ "./src/components/VSnackbar/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VSnackbar", function() { return _VSnackbar__WEBPACK_IMPORTED_MODULE_50__["VSnackbar"]; });
	
	/* harmony import */ var _VSparkline__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(/*! ./VSparkline */ "./src/components/VSparkline/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VSparkline", function() { return _VSparkline__WEBPACK_IMPORTED_MODULE_51__["VSparkline"]; });
	
	/* harmony import */ var _VSpeedDial__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(/*! ./VSpeedDial */ "./src/components/VSpeedDial/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VSpeedDial", function() { return _VSpeedDial__WEBPACK_IMPORTED_MODULE_52__["VSpeedDial"]; });
	
	/* harmony import */ var _VStepper__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(/*! ./VStepper */ "./src/components/VStepper/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VStepper", function() { return _VStepper__WEBPACK_IMPORTED_MODULE_53__["VStepper"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VStepperContent", function() { return _VStepper__WEBPACK_IMPORTED_MODULE_53__["VStepperContent"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VStepperStep", function() { return _VStepper__WEBPACK_IMPORTED_MODULE_53__["VStepperStep"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VStepperHeader", function() { return _VStepper__WEBPACK_IMPORTED_MODULE_53__["VStepperHeader"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VStepperItems", function() { return _VStepper__WEBPACK_IMPORTED_MODULE_53__["VStepperItems"]; });
	
	/* harmony import */ var _VSubheader__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(/*! ./VSubheader */ "./src/components/VSubheader/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VSubheader", function() { return _VSubheader__WEBPACK_IMPORTED_MODULE_54__["VSubheader"]; });
	
	/* harmony import */ var _VSwitch__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(/*! ./VSwitch */ "./src/components/VSwitch/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VSwitch", function() { return _VSwitch__WEBPACK_IMPORTED_MODULE_55__["VSwitch"]; });
	
	/* harmony import */ var _VSystemBar__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(/*! ./VSystemBar */ "./src/components/VSystemBar/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VSystemBar", function() { return _VSystemBar__WEBPACK_IMPORTED_MODULE_56__["VSystemBar"]; });
	
	/* harmony import */ var _VTabs__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__(/*! ./VTabs */ "./src/components/VTabs/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTabs", function() { return _VTabs__WEBPACK_IMPORTED_MODULE_57__["VTabs"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTab", function() { return _VTabs__WEBPACK_IMPORTED_MODULE_57__["VTab"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTabItem", function() { return _VTabs__WEBPACK_IMPORTED_MODULE_57__["VTabItem"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTabsItems", function() { return _VTabs__WEBPACK_IMPORTED_MODULE_57__["VTabsItems"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTabsSlider", function() { return _VTabs__WEBPACK_IMPORTED_MODULE_57__["VTabsSlider"]; });
	
	/* harmony import */ var _VTextarea__WEBPACK_IMPORTED_MODULE_58__ = __webpack_require__(/*! ./VTextarea */ "./src/components/VTextarea/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTextarea", function() { return _VTextarea__WEBPACK_IMPORTED_MODULE_58__["VTextarea"]; });
	
	/* harmony import */ var _VTextField__WEBPACK_IMPORTED_MODULE_59__ = __webpack_require__(/*! ./VTextField */ "./src/components/VTextField/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTextField", function() { return _VTextField__WEBPACK_IMPORTED_MODULE_59__["VTextField"]; });
	
	/* harmony import */ var _VTimeline__WEBPACK_IMPORTED_MODULE_60__ = __webpack_require__(/*! ./VTimeline */ "./src/components/VTimeline/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTimeline", function() { return _VTimeline__WEBPACK_IMPORTED_MODULE_60__["VTimeline"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTimelineItem", function() { return _VTimeline__WEBPACK_IMPORTED_MODULE_60__["VTimelineItem"]; });
	
	/* harmony import */ var _VTimePicker__WEBPACK_IMPORTED_MODULE_61__ = __webpack_require__(/*! ./VTimePicker */ "./src/components/VTimePicker/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTimePicker", function() { return _VTimePicker__WEBPACK_IMPORTED_MODULE_61__["VTimePicker"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTimePickerClock", function() { return _VTimePicker__WEBPACK_IMPORTED_MODULE_61__["VTimePickerClock"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTimePickerTitle", function() { return _VTimePicker__WEBPACK_IMPORTED_MODULE_61__["VTimePickerTitle"]; });
	
	/* harmony import */ var _VToolbar__WEBPACK_IMPORTED_MODULE_62__ = __webpack_require__(/*! ./VToolbar */ "./src/components/VToolbar/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VToolbar", function() { return _VToolbar__WEBPACK_IMPORTED_MODULE_62__["VToolbar"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VToolbarSideIcon", function() { return _VToolbar__WEBPACK_IMPORTED_MODULE_62__["VToolbarSideIcon"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VToolbarTitle", function() { return _VToolbar__WEBPACK_IMPORTED_MODULE_62__["VToolbarTitle"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VToolbarItems", function() { return _VToolbar__WEBPACK_IMPORTED_MODULE_62__["VToolbarItems"]; });
	
	/* harmony import */ var _VTooltip__WEBPACK_IMPORTED_MODULE_63__ = __webpack_require__(/*! ./VTooltip */ "./src/components/VTooltip/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTooltip", function() { return _VTooltip__WEBPACK_IMPORTED_MODULE_63__["VTooltip"]; });
	
	/* harmony import */ var _VTreeview__WEBPACK_IMPORTED_MODULE_64__ = __webpack_require__(/*! ./VTreeview */ "./src/components/VTreeview/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTreeview", function() { return _VTreeview__WEBPACK_IMPORTED_MODULE_64__["VTreeview"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTreeviewNode", function() { return _VTreeview__WEBPACK_IMPORTED_MODULE_64__["VTreeviewNode"]; });
	
	/* harmony import */ var _VWindow__WEBPACK_IMPORTED_MODULE_65__ = __webpack_require__(/*! ./VWindow */ "./src/components/VWindow/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VWindow", function() { return _VWindow__WEBPACK_IMPORTED_MODULE_65__["VWindow"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VWindowItem", function() { return _VWindow__WEBPACK_IMPORTED_MODULE_65__["VWindowItem"]; });
	
	/* harmony import */ var _transitions__WEBPACK_IMPORTED_MODULE_66__ = __webpack_require__(/*! ./transitions */ "./src/components/transitions/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VBottomSheetTransition", function() { return _transitions__WEBPACK_IMPORTED_MODULE_66__["VBottomSheetTransition"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VCarouselTransition", function() { return _transitions__WEBPACK_IMPORTED_MODULE_66__["VCarouselTransition"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VCarouselReverseTransition", function() { return _transitions__WEBPACK_IMPORTED_MODULE_66__["VCarouselReverseTransition"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTabTransition", function() { return _transitions__WEBPACK_IMPORTED_MODULE_66__["VTabTransition"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTabReverseTransition", function() { return _transitions__WEBPACK_IMPORTED_MODULE_66__["VTabReverseTransition"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VMenuTransition", function() { return _transitions__WEBPACK_IMPORTED_MODULE_66__["VMenuTransition"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VFabTransition", function() { return _transitions__WEBPACK_IMPORTED_MODULE_66__["VFabTransition"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VDialogTransition", function() { return _transitions__WEBPACK_IMPORTED_MODULE_66__["VDialogTransition"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VDialogBottomTransition", function() { return _transitions__WEBPACK_IMPORTED_MODULE_66__["VDialogBottomTransition"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VFadeTransition", function() { return _transitions__WEBPACK_IMPORTED_MODULE_66__["VFadeTransition"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VScaleTransition", function() { return _transitions__WEBPACK_IMPORTED_MODULE_66__["VScaleTransition"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VScrollXTransition", function() { return _transitions__WEBPACK_IMPORTED_MODULE_66__["VScrollXTransition"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VScrollXReverseTransition", function() { return _transitions__WEBPACK_IMPORTED_MODULE_66__["VScrollXReverseTransition"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VScrollYTransition", function() { return _transitions__WEBPACK_IMPORTED_MODULE_66__["VScrollYTransition"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VScrollYReverseTransition", function() { return _transitions__WEBPACK_IMPORTED_MODULE_66__["VScrollYReverseTransition"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VSlideXTransition", function() { return _transitions__WEBPACK_IMPORTED_MODULE_66__["VSlideXTransition"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VSlideXReverseTransition", function() { return _transitions__WEBPACK_IMPORTED_MODULE_66__["VSlideXReverseTransition"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VSlideYTransition", function() { return _transitions__WEBPACK_IMPORTED_MODULE_66__["VSlideYTransition"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VSlideYReverseTransition", function() { return _transitions__WEBPACK_IMPORTED_MODULE_66__["VSlideYReverseTransition"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VExpandTransition", function() { return _transitions__WEBPACK_IMPORTED_MODULE_66__["VExpandTransition"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VExpandXTransition", function() { return _transitions__WEBPACK_IMPORTED_MODULE_66__["VExpandXTransition"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VRowExpandTransition", function() { return _transitions__WEBPACK_IMPORTED_MODULE_66__["VRowExpandTransition"]; });
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	/***/ }),
	
	/***/ "./src/components/transitions/expand-transition.js":
	/*!*********************************************************!*\
	  !*** ./src/components/transitions/expand-transition.js ***!
	  \*********************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	
	/* harmony default export */ __webpack_exports__["default"] = (function (expandedParentClass, x) {
	    if (expandedParentClass === void 0) {
	        expandedParentClass = '';
	    }
	    if (x === void 0) {
	        x = false;
	    }
	    var sizeProperty = x ? 'width' : 'height';
	    return {
	        beforeEnter: function beforeEnter(el) {
	            var _a;
	            el._parent = el.parentNode;
	            el._initialStyle = (_a = {
	                transition: el.style.transition,
	                visibility: el.style.visibility,
	                overflow: el.style.overflow
	            }, _a[sizeProperty] = el.style[sizeProperty], _a);
	        },
	        enter: function enter(el) {
	            var initialStyle = el._initialStyle;
	            el.style.setProperty('transition', 'none', 'important');
	            el.style.visibility = 'hidden';
	            var size = el['offset' + Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["upperFirst"])(sizeProperty)] + "px";
	            el.style.visibility = initialStyle.visibility;
	            el.style.overflow = 'hidden';
	            el.style[sizeProperty] = 0;
	            void el.offsetHeight; // force reflow
	            el.style.transition = initialStyle.transition;
	            expandedParentClass && el._parent && el._parent.classList.add(expandedParentClass);
	            requestAnimationFrame(function () {
	                el.style[sizeProperty] = size;
	            });
	        },
	        afterEnter: resetStyles,
	        enterCancelled: resetStyles,
	        leave: function leave(el) {
	            var _a;
	            el._initialStyle = (_a = {
	                overflow: el.style.overflow
	            }, _a[sizeProperty] = el.style[sizeProperty], _a);
	            el.style.overflow = 'hidden';
	            el.style[sizeProperty] = el['offset' + Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["upperFirst"])(sizeProperty)] + "px";
	            void el.offsetHeight; // force reflow
	            requestAnimationFrame(function () {
	                return el.style[sizeProperty] = 0;
	            });
	        },
	        afterLeave: afterLeave,
	        leaveCancelled: afterLeave
	    };
	    function afterLeave(el) {
	        expandedParentClass && el._parent && el._parent.classList.remove(expandedParentClass);
	        resetStyles(el);
	    }
	    function resetStyles(el) {
	        el.style.overflow = el._initialStyle.overflow;
	        el.style[sizeProperty] = el._initialStyle[sizeProperty];
	        delete el._initialStyle;
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/transitions/index.js":
	/*!*********************************************!*\
	  !*** ./src/components/transitions/index.js ***!
	  \*********************************************/
	/*! exports provided: VBottomSheetTransition, VCarouselTransition, VCarouselReverseTransition, VTabTransition, VTabReverseTransition, VMenuTransition, VFabTransition, VDialogTransition, VDialogBottomTransition, VFadeTransition, VScaleTransition, VScrollXTransition, VScrollXReverseTransition, VScrollYTransition, VScrollYReverseTransition, VSlideXTransition, VSlideXReverseTransition, VSlideYTransition, VSlideYReverseTransition, VExpandTransition, VExpandXTransition, VRowExpandTransition, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VBottomSheetTransition", function() { return VBottomSheetTransition; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VCarouselTransition", function() { return VCarouselTransition; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VCarouselReverseTransition", function() { return VCarouselReverseTransition; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VTabTransition", function() { return VTabTransition; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VTabReverseTransition", function() { return VTabReverseTransition; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VMenuTransition", function() { return VMenuTransition; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VFabTransition", function() { return VFabTransition; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VDialogTransition", function() { return VDialogTransition; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VDialogBottomTransition", function() { return VDialogBottomTransition; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VFadeTransition", function() { return VFadeTransition; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VScaleTransition", function() { return VScaleTransition; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VScrollXTransition", function() { return VScrollXTransition; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VScrollXReverseTransition", function() { return VScrollXReverseTransition; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VScrollYTransition", function() { return VScrollYTransition; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VScrollYReverseTransition", function() { return VScrollYReverseTransition; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VSlideXTransition", function() { return VSlideXTransition; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VSlideXReverseTransition", function() { return VSlideXReverseTransition; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VSlideYTransition", function() { return VSlideYTransition; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VSlideYReverseTransition", function() { return VSlideYReverseTransition; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VExpandTransition", function() { return VExpandTransition; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VExpandXTransition", function() { return VExpandXTransition; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VRowExpandTransition", function() { return VRowExpandTransition; });
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var _expand_transition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./expand-transition */ "./src/components/transitions/expand-transition.js");
	
	
	// Component specific transitions
	var VBottomSheetTransition = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleTransition"])('bottom-sheet-transition');
	var VCarouselTransition = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleTransition"])('carousel-transition');
	var VCarouselReverseTransition = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleTransition"])('carousel-reverse-transition');
	var VTabTransition = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleTransition"])('tab-transition');
	var VTabReverseTransition = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleTransition"])('tab-reverse-transition');
	var VMenuTransition = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleTransition"])('menu-transition');
	var VFabTransition = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleTransition"])('fab-transition', 'center center', 'out-in');
	// Generic transitions
	var VDialogTransition = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleTransition"])('dialog-transition');
	var VDialogBottomTransition = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleTransition"])('dialog-bottom-transition');
	var VFadeTransition = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleTransition"])('fade-transition');
	var VScaleTransition = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleTransition"])('scale-transition');
	var VScrollXTransition = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleTransition"])('scroll-x-transition');
	var VScrollXReverseTransition = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleTransition"])('scroll-x-reverse-transition');
	var VScrollYTransition = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleTransition"])('scroll-y-transition');
	var VScrollYReverseTransition = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleTransition"])('scroll-y-reverse-transition');
	var VSlideXTransition = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleTransition"])('slide-x-transition');
	var VSlideXReverseTransition = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleTransition"])('slide-x-reverse-transition');
	var VSlideYTransition = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleTransition"])('slide-y-transition');
	var VSlideYReverseTransition = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleTransition"])('slide-y-reverse-transition');
	// JavaScript transitions
	var VExpandTransition = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createJavaScriptTransition"])('expand-transition', Object(_expand_transition__WEBPACK_IMPORTED_MODULE_1__["default"])());
	var VExpandXTransition = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createJavaScriptTransition"])('expand-x-transition', Object(_expand_transition__WEBPACK_IMPORTED_MODULE_1__["default"])('', true));
	var VRowExpandTransition = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createJavaScriptTransition"])('row-expand-transition', Object(_expand_transition__WEBPACK_IMPORTED_MODULE_1__["default"])('datatable__expand-col--expanded'));
	/* harmony default export */ __webpack_exports__["default"] = ({
	    $_vuetify_subcomponents: {
	        VBottomSheetTransition: VBottomSheetTransition,
	        VCarouselTransition: VCarouselTransition,
	        VCarouselReverseTransition: VCarouselReverseTransition,
	        VDialogTransition: VDialogTransition,
	        VDialogBottomTransition: VDialogBottomTransition,
	        VFabTransition: VFabTransition,
	        VFadeTransition: VFadeTransition,
	        VMenuTransition: VMenuTransition,
	        VScaleTransition: VScaleTransition,
	        VScrollXTransition: VScrollXTransition,
	        VScrollXReverseTransition: VScrollXReverseTransition,
	        VScrollYTransition: VScrollYTransition,
	        VScrollYReverseTransition: VScrollYReverseTransition,
	        VSlideXTransition: VSlideXTransition,
	        VSlideXReverseTransition: VSlideXReverseTransition,
	        VSlideYTransition: VSlideYTransition,
	        VSlideYReverseTransition: VSlideYReverseTransition,
	        VTabReverseTransition: VTabReverseTransition,
	        VTabTransition: VTabTransition,
	        VExpandTransition: VExpandTransition,
	        VExpandXTransition: VExpandXTransition,
	        VRowExpandTransition: VRowExpandTransition
	    }
	});
	
	/***/ }),
	
	/***/ "./src/directives/click-outside.ts":
	/*!*****************************************!*\
	  !*** ./src/directives/click-outside.ts ***!
	  \*****************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	function closeConditional() {
	    return false;
	}
	function directive(e, el, binding) {
	    // Args may not always be supplied
	    binding.args = binding.args || {};
	    // If no closeConditional was supplied assign a default
	    var isActive = binding.args.closeConditional || closeConditional;
	    // The include element callbacks below can be expensive
	    // so we should avoid calling them when we're not active.
	    // Explicitly check for false to allow fallback compatibility
	    // with non-toggleable components
	    if (!e || isActive(e) === false) return;
	    // If click was triggered programmaticaly (domEl.click()) then
	    // it shouldn't be treated as click-outside
	    // Chrome/Firefox support isTrusted property
	    // IE/Edge support pointerType property (empty if not triggered
	    // by pointing device)
	    if ('isTrusted' in e && !e.isTrusted || 'pointerType' in e && !e.pointerType) return;
	    // Check if additional elements were passed to be included in check
	    // (click must be outside all included elements, if any)
	    var elements = (binding.args.include || function () {
	        return [];
	    })();
	    // Add the root element for the component this directive was defined on
	    elements.push(el);
	    // Check if it's a click outside our elements, and then if our callback returns true.
	    // Non-toggleable components should take action in their callback and return falsy.
	    // Toggleable can return true if it wants to deactivate.
	    // Note that, because we're in the capture phase, this callback will occur before
	    // the bubbling click event on any outside elements.
	    !elements.some(function (el) {
	        return el.contains(e.target);
	    }) && setTimeout(function () {
	        isActive(e) && binding.value && binding.value(e);
	    }, 0);
	}
	/* harmony default export */ __webpack_exports__["default"] = ({
	    // [data-app] may not be found
	    // if using bind, inserted makes
	    // sure that the root element is
	    // available, iOS does not support
	    // clicks on body
	    inserted: function inserted(el, binding) {
	        var onClick = function onClick(e) {
	            return directive(e, el, binding);
	        };
	        // iOS does not recognize click events on document
	        // or body, this is the entire purpose of the v-app
	        // component and [data-app], stop removing this
	        var app = document.querySelector('[data-app]') || document.body; // This is only for unit tests
	        app.addEventListener('click', onClick, true);
	        el._clickOutside = onClick;
	    },
	    unbind: function unbind(el) {
	        if (!el._clickOutside) return;
	        var app = document.querySelector('[data-app]') || document.body; // This is only for unit tests
	        app && app.removeEventListener('click', el._clickOutside, true);
	        delete el._clickOutside;
	    }
	});
	
	/***/ }),
	
	/***/ "./src/directives/index.ts":
	/*!*********************************!*\
	  !*** ./src/directives/index.ts ***!
	  \*********************************/
	/*! exports provided: ClickOutside, Ripple, Resize, Scroll, Touch, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _click_outside__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./click-outside */ "./src/directives/click-outside.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ClickOutside", function() { return _click_outside__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	/* harmony import */ var _resize__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./resize */ "./src/directives/resize.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Resize", function() { return _resize__WEBPACK_IMPORTED_MODULE_1__["default"]; });
	
	/* harmony import */ var _ripple__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./ripple */ "./src/directives/ripple.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Ripple", function() { return _ripple__WEBPACK_IMPORTED_MODULE_2__["default"]; });
	
	/* harmony import */ var _scroll__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./scroll */ "./src/directives/scroll.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Scroll", function() { return _scroll__WEBPACK_IMPORTED_MODULE_3__["default"]; });
	
	/* harmony import */ var _touch__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./touch */ "./src/directives/touch.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Touch", function() { return _touch__WEBPACK_IMPORTED_MODULE_4__["default"]; });
	
	
	
	
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = ({
	    ClickOutside: _click_outside__WEBPACK_IMPORTED_MODULE_0__["default"],
	    Ripple: _ripple__WEBPACK_IMPORTED_MODULE_2__["default"],
	    Resize: _resize__WEBPACK_IMPORTED_MODULE_1__["default"],
	    Scroll: _scroll__WEBPACK_IMPORTED_MODULE_3__["default"],
	    Touch: _touch__WEBPACK_IMPORTED_MODULE_4__["default"]
	});
	
	/***/ }),
	
	/***/ "./src/directives/resize.ts":
	/*!**********************************!*\
	  !*** ./src/directives/resize.ts ***!
	  \**********************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	function inserted(el, binding) {
	    var callback = binding.value;
	    var options = binding.options || { passive: true };
	    window.addEventListener('resize', callback, options);
	    el._onResize = {
	        callback: callback,
	        options: options
	    };
	    if (!binding.modifiers || !binding.modifiers.quiet) {
	        callback();
	    }
	}
	function unbind(el) {
	    if (!el._onResize) return;
	    var _a = el._onResize,
	        callback = _a.callback,
	        options = _a.options;
	    window.removeEventListener('resize', callback, options);
	    delete el._onResize;
	}
	/* harmony default export */ __webpack_exports__["default"] = ({
	    inserted: inserted,
	    unbind: unbind
	});
	
	/***/ }),
	
	/***/ "./src/directives/ripple.ts":
	/*!**********************************!*\
	  !*** ./src/directives/ripple.ts ***!
	  \**********************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../util/console */ "./src/util/console.ts");
	var __read = undefined && undefined.__read || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o),
	        r,
	        ar = [],
	        e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
	            ar.push(r.value);
	        }
	    } catch (error) {
	        e = { error: error };
	    } finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        } finally {
	            if (e) throw e.error;
	        }
	    }
	    return ar;
	};
	var __spread = undefined && undefined.__spread || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) {
	        ar = ar.concat(__read(arguments[i]));
	    }return ar;
	};
	
	function transform(el, value) {
	    el.style['transform'] = value;
	    el.style['webkitTransform'] = value;
	}
	function opacity(el, value) {
	    el.style['opacity'] = value.toString();
	}
	function isTouchEvent(e) {
	    return e.constructor.name === 'TouchEvent';
	}
	var calculate = function calculate(e, el, value) {
	    if (value === void 0) {
	        value = {};
	    }
	    var offset = el.getBoundingClientRect();
	    var target = isTouchEvent(e) ? e.touches[e.touches.length - 1] : e;
	    var localX = target.clientX - offset.left;
	    var localY = target.clientY - offset.top;
	    var radius = 0;
	    var scale = 0.3;
	    if (el._ripple && el._ripple.circle) {
	        scale = 0.15;
	        radius = el.clientWidth / 2;
	        radius = value.center ? radius : radius + Math.sqrt(Math.pow(localX - radius, 2) + Math.pow(localY - radius, 2)) / 4;
	    } else {
	        radius = Math.sqrt(Math.pow(el.clientWidth, 2) + Math.pow(el.clientHeight, 2)) / 2;
	    }
	    var centerX = (el.clientWidth - radius * 2) / 2 + "px";
	    var centerY = (el.clientHeight - radius * 2) / 2 + "px";
	    var x = value.center ? centerX : localX - radius + "px";
	    var y = value.center ? centerY : localY - radius + "px";
	    return { radius: radius, scale: scale, x: x, y: y, centerX: centerX, centerY: centerY };
	};
	var ripple = {
	    /* eslint-disable max-statements */
	    show: function show(e, el, value) {
	        if (value === void 0) {
	            value = {};
	        }
	        if (!el._ripple || !el._ripple.enabled) {
	            return;
	        }
	        var container = document.createElement('span');
	        var animation = document.createElement('span');
	        container.appendChild(animation);
	        container.className = 'v-ripple__container';
	        if (value.class) {
	            container.className += " " + value.class;
	        }
	        var _a = calculate(e, el, value),
	            radius = _a.radius,
	            scale = _a.scale,
	            x = _a.x,
	            y = _a.y,
	            centerX = _a.centerX,
	            centerY = _a.centerY;
	        var size = radius * 2 + "px";
	        animation.className = 'v-ripple__animation';
	        animation.style.width = size;
	        animation.style.height = size;
	        el.appendChild(container);
	        var computed = window.getComputedStyle(el);
	        if (computed && computed.position === 'static') {
	            el.style.position = 'relative';
	            el.dataset.previousPosition = 'static';
	        }
	        animation.classList.add('v-ripple__animation--enter');
	        animation.classList.add('v-ripple__animation--visible');
	        transform(animation, "translate(" + x + ", " + y + ") scale3d(" + scale + "," + scale + "," + scale + ")");
	        opacity(animation, 0);
	        animation.dataset.activated = String(performance.now());
	        setTimeout(function () {
	            animation.classList.remove('v-ripple__animation--enter');
	            animation.classList.add('v-ripple__animation--in');
	            transform(animation, "translate(" + centerX + ", " + centerY + ") scale3d(1,1,1)");
	            opacity(animation, 0.25);
	        }, 0);
	    },
	    hide: function hide(el) {
	        if (!el || !el._ripple || !el._ripple.enabled) return;
	        var ripples = el.getElementsByClassName('v-ripple__animation');
	        if (ripples.length === 0) return;
	        var animation = ripples[ripples.length - 1];
	        if (animation.dataset.isHiding) return;else animation.dataset.isHiding = 'true';
	        var diff = performance.now() - Number(animation.dataset.activated);
	        var delay = Math.max(250 - diff, 0);
	        setTimeout(function () {
	            animation.classList.remove('v-ripple__animation--in');
	            animation.classList.add('v-ripple__animation--out');
	            opacity(animation, 0);
	            setTimeout(function () {
	                var ripples = el.getElementsByClassName('v-ripple__animation');
	                if (ripples.length === 1 && el.dataset.previousPosition) {
	                    el.style.position = el.dataset.previousPosition;
	                    delete el.dataset.previousPosition;
	                }
	                animation.parentNode && el.removeChild(animation.parentNode);
	            }, 300);
	        }, delay);
	    }
	};
	function isRippleEnabled(value) {
	    return typeof value === 'undefined' || !!value;
	}
	function rippleShow(e) {
	    var value = {};
	    var element = e.currentTarget;
	    if (!element || !element._ripple || element._ripple.touched) return;
	    if (isTouchEvent(e)) {
	        element._ripple.touched = true;
	    }
	    value.center = element._ripple.centered;
	    if (element._ripple.class) {
	        value.class = element._ripple.class;
	    }
	    ripple.show(e, element, value);
	}
	function rippleHide(e) {
	    var element = e.currentTarget;
	    if (!element) return;
	    window.setTimeout(function () {
	        if (element._ripple) {
	            element._ripple.touched = false;
	        }
	    });
	    ripple.hide(element);
	}
	function updateRipple(el, binding, wasEnabled) {
	    var enabled = isRippleEnabled(binding.value);
	    if (!enabled) {
	        ripple.hide(el);
	    }
	    el._ripple = el._ripple || {};
	    el._ripple.enabled = enabled;
	    var value = binding.value || {};
	    if (value.center) {
	        el._ripple.centered = true;
	    }
	    if (value.class) {
	        el._ripple.class = binding.value.class;
	    }
	    if (value.circle) {
	        el._ripple.circle = value.circle;
	    }
	    if (enabled && !wasEnabled) {
	        el.addEventListener('touchstart', rippleShow, { passive: true });
	        el.addEventListener('touchend', rippleHide, { passive: true });
	        el.addEventListener('touchcancel', rippleHide);
	        el.addEventListener('mousedown', rippleShow);
	        el.addEventListener('mouseup', rippleHide);
	        el.addEventListener('mouseleave', rippleHide);
	        // Anchor tags can be dragged, causes other hides to fail - #1537
	        el.addEventListener('dragstart', rippleHide, { passive: true });
	    } else if (!enabled && wasEnabled) {
	        removeListeners(el);
	    }
	}
	function removeListeners(el) {
	    el.removeEventListener('mousedown', rippleShow);
	    el.removeEventListener('touchstart', rippleHide);
	    el.removeEventListener('touchend', rippleHide);
	    el.removeEventListener('touchcancel', rippleHide);
	    el.removeEventListener('mouseup', rippleHide);
	    el.removeEventListener('mouseleave', rippleHide);
	    el.removeEventListener('dragstart', rippleHide);
	}
	function directive(el, binding, node) {
	    updateRipple(el, binding, false);
	    // warn if an inline element is used, waiting for el to be in the DOM first
	    node.context && node.context.$nextTick(function () {
	        var computed = window.getComputedStyle(el);
	        if (computed && computed.display === 'inline') {
	            var context = node.fnOptions ? [node.fnOptions, node.context] : [node.componentInstance];
	            _util_console__WEBPACK_IMPORTED_MODULE_0__["consoleWarn"].apply(void 0, __spread(['v-ripple can only be used on block-level elements'], context));
	        }
	    });
	}
	function unbind(el) {
	    delete el._ripple;
	    removeListeners(el);
	}
	function update(el, binding) {
	    if (binding.value === binding.oldValue) {
	        return;
	    }
	    var wasEnabled = isRippleEnabled(binding.oldValue);
	    updateRipple(el, binding, wasEnabled);
	}
	/* harmony default export */ __webpack_exports__["default"] = ({
	    bind: directive,
	    unbind: unbind,
	    update: update
	});
	
	/***/ }),
	
	/***/ "./src/directives/scroll.ts":
	/*!**********************************!*\
	  !*** ./src/directives/scroll.ts ***!
	  \**********************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	function inserted(el, binding) {
	    var callback = binding.value;
	    var options = binding.options || { passive: true };
	    var target = binding.arg ? document.querySelector(binding.arg) : window;
	    if (!target) return;
	    target.addEventListener('scroll', callback, options);
	    el._onScroll = {
	        callback: callback,
	        options: options,
	        target: target
	    };
	}
	function unbind(el) {
	    if (!el._onScroll) return;
	    var _a = el._onScroll,
	        callback = _a.callback,
	        options = _a.options,
	        target = _a.target;
	    target.removeEventListener('scroll', callback, options);
	    delete el._onScroll;
	}
	/* harmony default export */ __webpack_exports__["default"] = ({
	    inserted: inserted,
	    unbind: unbind
	});
	
	/***/ }),
	
	/***/ "./src/directives/touch.ts":
	/*!*********************************!*\
	  !*** ./src/directives/touch.ts ***!
	  \*********************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../util/helpers */ "./src/util/helpers.ts");
	
	var handleGesture = function handleGesture(wrapper) {
	    var touchstartX = wrapper.touchstartX,
	        touchendX = wrapper.touchendX,
	        touchstartY = wrapper.touchstartY,
	        touchendY = wrapper.touchendY;
	    var dirRatio = 0.5;
	    var minDistance = 16;
	    wrapper.offsetX = touchendX - touchstartX;
	    wrapper.offsetY = touchendY - touchstartY;
	    if (Math.abs(wrapper.offsetY) < dirRatio * Math.abs(wrapper.offsetX)) {
	        wrapper.left && touchendX < touchstartX - minDistance && wrapper.left(wrapper);
	        wrapper.right && touchendX > touchstartX + minDistance && wrapper.right(wrapper);
	    }
	    if (Math.abs(wrapper.offsetX) < dirRatio * Math.abs(wrapper.offsetY)) {
	        wrapper.up && touchendY < touchstartY - minDistance && wrapper.up(wrapper);
	        wrapper.down && touchendY > touchstartY + minDistance && wrapper.down(wrapper);
	    }
	};
	function _touchstart(event, wrapper) {
	    var touch = event.changedTouches[0];
	    wrapper.touchstartX = touch.clientX;
	    wrapper.touchstartY = touch.clientY;
	    wrapper.start && wrapper.start(Object.assign(event, wrapper));
	}
	function _touchend(event, wrapper) {
	    var touch = event.changedTouches[0];
	    wrapper.touchendX = touch.clientX;
	    wrapper.touchendY = touch.clientY;
	    wrapper.end && wrapper.end(Object.assign(event, wrapper));
	    handleGesture(wrapper);
	}
	function _touchmove(event, wrapper) {
	    var touch = event.changedTouches[0];
	    wrapper.touchmoveX = touch.clientX;
	    wrapper.touchmoveY = touch.clientY;
	    wrapper.move && wrapper.move(Object.assign(event, wrapper));
	}
	function createHandlers(value) {
	    var wrapper = {
	        touchstartX: 0,
	        touchstartY: 0,
	        touchendX: 0,
	        touchendY: 0,
	        touchmoveX: 0,
	        touchmoveY: 0,
	        offsetX: 0,
	        offsetY: 0,
	        left: value.left,
	        right: value.right,
	        up: value.up,
	        down: value.down,
	        start: value.start,
	        move: value.move,
	        end: value.end
	    };
	    return {
	        touchstart: function touchstart(e) {
	            return _touchstart(e, wrapper);
	        },
	        touchend: function touchend(e) {
	            return _touchend(e, wrapper);
	        },
	        touchmove: function touchmove(e) {
	            return _touchmove(e, wrapper);
	        }
	    };
	}
	function inserted(el, binding, vnode) {
	    var value = binding.value;
	    var target = value.parent ? el.parentElement : el;
	    var options = value.options || { passive: true };
	    // Needed to pass unit tests
	    if (!target) return;
	    var handlers = createHandlers(binding.value);
	    target._touchHandlers = Object(target._touchHandlers);
	    target._touchHandlers[vnode.context._uid] = handlers;
	    Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["keys"])(handlers).forEach(function (eventName) {
	        target.addEventListener(eventName, handlers[eventName], options);
	    });
	}
	function unbind(el, binding, vnode) {
	    var target = binding.value.parent ? el.parentElement : el;
	    if (!target || !target._touchHandlers) return;
	    var handlers = target._touchHandlers[vnode.context._uid];
	    Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["keys"])(handlers).forEach(function (eventName) {
	        target.removeEventListener(eventName, handlers[eventName]);
	    });
	    delete target._touchHandlers[vnode.context._uid];
	}
	/* harmony default export */ __webpack_exports__["default"] = ({
	    inserted: inserted,
	    unbind: unbind
	});
	
	/***/ }),
	
	/***/ "./src/index.ts":
	/*!**********************!*\
	  !*** ./src/index.ts ***!
	  \**********************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_app_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./stylus/app.styl */ "./src/stylus/app.styl");
	/* harmony import */ var _stylus_app_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_app_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _components_Vuetify__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./components/Vuetify */ "./src/components/Vuetify/index.ts");
	/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./components */ "./src/components/index.ts");
	/* harmony import */ var _directives__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./directives */ "./src/directives/index.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	
	
	
	
	var Vuetify = {
	    install: function install(Vue, args) {
	        Vue.use(_components_Vuetify__WEBPACK_IMPORTED_MODULE_1__["default"], __assign({ components: _components__WEBPACK_IMPORTED_MODULE_2__,
	            directives: _directives__WEBPACK_IMPORTED_MODULE_3__["default"] }, args));
	    },
	    version: '1.5.14'
	};
	if (typeof window !== 'undefined' && window.Vue) {
	    window.Vue.use(Vuetify);
	}
	/* harmony default export */ __webpack_exports__["default"] = (Vuetify);
	
	/***/ }),
	
	/***/ "./src/locale/en.ts":
	/*!**************************!*\
	  !*** ./src/locale/en.ts ***!
	  \**************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony default export */ __webpack_exports__["default"] = ({
	    dataIterator: {
	        rowsPerPageText: 'Items per page:',
	        rowsPerPageAll: 'All',
	        pageText: '{0}-{1} of {2}',
	        noResultsText: 'No matching records found',
	        nextPage: 'Next page',
	        prevPage: 'Previous page'
	    },
	    dataTable: {
	        rowsPerPageText: 'Rows per page:'
	    },
	    noDataText: 'No data available',
	    carousel: {
	        prev: 'Previous visual',
	        next: 'Next visual'
	    }
	});
	
	/***/ }),
	
	/***/ "./src/mixins/applicationable.ts":
	/*!***************************************!*\
	  !*** ./src/mixins/applicationable.ts ***!
	  \***************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return applicationable; });
	/* harmony import */ var _positionable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./positionable */ "./src/mixins/positionable.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/mixins */ "./src/util/mixins.ts");
	
	// Util
	
	function applicationable(value, events) {
	    if (events === void 0) {
	        events = [];
	    }
	    /* @vue/component */
	    return Object(_util_mixins__WEBPACK_IMPORTED_MODULE_1__["default"])(Object(_positionable__WEBPACK_IMPORTED_MODULE_0__["factory"])(['absolute', 'fixed'])).extend({
	        name: 'applicationable',
	        props: {
	            app: Boolean
	        },
	        computed: {
	            applicationProperty: function applicationProperty() {
	                return value;
	            }
	        },
	        watch: {
	            // If previous value was app
	            // reset the provided prop
	            app: function app(x, prev) {
	                prev ? this.removeApplication(true) : this.callUpdate();
	            },
	            applicationProperty: function applicationProperty(newVal, oldVal) {
	                this.$vuetify.application.unbind(this._uid, oldVal);
	            }
	        },
	        activated: function activated() {
	            this.callUpdate();
	        },
	        created: function created() {
	            for (var i = 0, length = events.length; i < length; i++) {
	                this.$watch(events[i], this.callUpdate);
	            }
	            this.callUpdate();
	        },
	        mounted: function mounted() {
	            this.callUpdate();
	        },
	        deactivated: function deactivated() {
	            this.removeApplication();
	        },
	        destroyed: function destroyed() {
	            this.removeApplication();
	        },
	        methods: {
	            callUpdate: function callUpdate() {
	                if (!this.app) return;
	                this.$vuetify.application.bind(this._uid, this.applicationProperty, this.updateApplication());
	            },
	            removeApplication: function removeApplication(force) {
	                if (force === void 0) {
	                    force = false;
	                }
	                if (!force && !this.app) return;
	                this.$vuetify.application.unbind(this._uid, this.applicationProperty);
	            },
	            updateApplication: function updateApplication() {
	                return 0;
	            }
	        }
	    });
	}
	
	/***/ }),
	
	/***/ "./src/mixins/bootable.ts":
	/*!********************************!*\
	  !*** ./src/mixins/bootable.ts ***!
	  \********************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
	
	/**
	 * Bootable
	 * @mixin
	 *
	 * Used to add lazy content functionality to components
	 * Looks for change in "isActive" to automatically boot
	 * Otherwise can be set manually
	 */
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend().extend({
	    name: 'bootable',
	    props: {
	        lazy: Boolean
	    },
	    data: function data() {
	        return {
	            isBooted: false
	        };
	    },
	    computed: {
	        hasContent: function hasContent() {
	            return this.isBooted || !this.lazy || this.isActive;
	        }
	    },
	    watch: {
	        isActive: function isActive() {
	            this.isBooted = true;
	        }
	    },
	    methods: {
	        showLazyContent: function showLazyContent(content) {
	            return this.hasContent ? content : undefined;
	        }
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/mixins/button-group.ts":
	/*!************************************!*\
	  !*** ./src/mixins/button-group.ts ***!
	  \************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _components_VItemGroup_VItemGroup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../components/VItemGroup/VItemGroup */ "./src/components/VItemGroup/VItemGroup.ts");
	// Extensions
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (_components_VItemGroup_VItemGroup__WEBPACK_IMPORTED_MODULE_0__["BaseItemGroup"].extend({
	    name: 'button-group',
	    provide: function provide() {
	        return {
	            btnToggle: this
	        };
	    },
	    props: {
	        activeClass: {
	            type: String,
	            default: 'v-btn--active'
	        }
	    },
	    computed: {
	        classes: function classes() {
	            return _components_VItemGroup_VItemGroup__WEBPACK_IMPORTED_MODULE_0__["BaseItemGroup"].options.computed.classes.call(this);
	        }
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/mixins/colorable.ts":
	/*!*********************************!*\
	  !*** ./src/mixins/colorable.ts ***!
	  \*********************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var __read = undefined && undefined.__read || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o),
	        r,
	        ar = [],
	        e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
	            ar.push(r.value);
	        }
	    } catch (error) {
	        e = { error: error };
	    } finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        } finally {
	            if (e) throw e.error;
	        }
	    }
	    return ar;
	};
	
	function isCssColor(color) {
	    return !!color && !!color.match(/^(#|(rgb|hsl)a?\()/);
	}
	/* harmony default export */ __webpack_exports__["default"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
	    name: 'colorable',
	    props: {
	        color: String
	    },
	    methods: {
	        setBackgroundColor: function setBackgroundColor(color, data) {
	            if (data === void 0) {
	                data = {};
	            }
	            var _a;
	            if (isCssColor(color)) {
	                data.style = __assign({}, data.style, { 'background-color': "" + color, 'border-color': "" + color });
	            } else if (color) {
	                data.class = __assign({}, data.class, (_a = {}, _a[color] = true, _a));
	            }
	            return data;
	        },
	        setTextColor: function setTextColor(color, data) {
	            if (data === void 0) {
	                data = {};
	            }
	            var _a;
	            if (isCssColor(color)) {
	                data.style = __assign({}, data.style, { 'color': "" + color, 'caret-color': "" + color });
	            } else if (color) {
	                var _b = __read(color.toString().trim().split(' ', 2), 2),
	                    colorName = _b[0],
	                    colorModifier = _b[1];
	                data.class = __assign({}, data.class, (_a = {}, _a[colorName + '--text'] = true, _a));
	                if (colorModifier) {
	                    data.class['text--' + colorModifier] = true;
	                }
	            }
	            return data;
	        }
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/mixins/comparable.ts":
	/*!**********************************!*\
	  !*** ./src/mixins/comparable.ts ***!
	  \**********************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/helpers */ "./src/util/helpers.ts");
	
	
	/* harmony default export */ __webpack_exports__["default"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
	    name: 'comparable',
	    props: {
	        valueComparator: {
	            type: Function,
	            default: _util_helpers__WEBPACK_IMPORTED_MODULE_1__["deepEqual"]
	        }
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/mixins/data-iterable.js":
	/*!*************************************!*\
	  !*** ./src/mixins/data-iterable.js ***!
	  \*************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _components_VBtn__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../components/VBtn */ "./src/components/VBtn/index.ts");
	/* harmony import */ var _components_VIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../components/VIcon */ "./src/components/VIcon/index.ts");
	/* harmony import */ var _components_VSelect__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../components/VSelect */ "./src/components/VSelect/index.js");
	/* harmony import */ var _filterable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./filterable */ "./src/mixins/filterable.ts");
	/* harmony import */ var _themeable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _loadable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./loadable */ "./src/mixins/loadable.ts");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../util/console */ "./src/util/console.ts");
	var __read = undefined && undefined.__read || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o),
	        r,
	        ar = [],
	        e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
	            ar.push(r.value);
	        }
	    } catch (error) {
	        e = { error: error };
	    } finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        } finally {
	            if (e) throw e.error;
	        }
	    }
	    return ar;
	};
	var __spread = undefined && undefined.__spread || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) {
	        ar = ar.concat(__read(arguments[i]));
	    }return ar;
	};
	
	
	
	
	
	
	
	
	/**
	 * DataIterable
	 *
	 * @mixin
	 *
	 * Base behavior for data table and data iterator
	 * providing selection, pagination, sorting and filtering.
	 *
	 */
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'data-iterable',
	    mixins: [_filterable__WEBPACK_IMPORTED_MODULE_3__["default"], _loadable__WEBPACK_IMPORTED_MODULE_5__["default"], _themeable__WEBPACK_IMPORTED_MODULE_4__["default"]],
	    props: {
	        expand: Boolean,
	        hideActions: Boolean,
	        disableInitialSort: Boolean,
	        mustSort: Boolean,
	        noResultsText: {
	            type: String,
	            default: '$vuetify.dataIterator.noResultsText'
	        },
	        nextIcon: {
	            type: String,
	            default: '$vuetify.icons.next'
	        },
	        prevIcon: {
	            type: String,
	            default: '$vuetify.icons.prev'
	        },
	        rowsPerPageItems: {
	            type: Array,
	            default: function _default() {
	                return [5, 10, 25, {
	                    text: '$vuetify.dataIterator.rowsPerPageAll',
	                    value: -1
	                }];
	            }
	        },
	        rowsPerPageText: {
	            type: String,
	            default: '$vuetify.dataIterator.rowsPerPageText'
	        },
	        selectAll: [Boolean, String],
	        search: {
	            required: false
	        },
	        filter: {
	            type: Function,
	            default: function _default(val, search) {
	                return val != null && typeof val !== 'boolean' && val.toString().toLowerCase().indexOf(search) !== -1;
	            }
	        },
	        customFilter: {
	            type: Function,
	            default: function _default(items, search, filter) {
	                search = search.toString().toLowerCase();
	                if (search.trim() === '') return items;
	                return items.filter(function (i) {
	                    return Object.keys(i).some(function (j) {
	                        return filter(i[j], search);
	                    });
	                });
	            }
	        },
	        customSort: {
	            type: Function,
	            default: function _default(items, index, isDescending) {
	                if (index === null) return items;
	                return items.sort(function (a, b) {
	                    var _a, _b;
	                    var sortA = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_6__["getObjectValueByPath"])(a, index);
	                    var sortB = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_6__["getObjectValueByPath"])(b, index);
	                    if (isDescending) {
	                        _a = __read([sortB, sortA], 2), sortA = _a[0], sortB = _a[1];
	                    }
	                    // Check if both are numbers
	                    if (!isNaN(sortA) && !isNaN(sortB)) {
	                        return sortA - sortB;
	                    }
	                    // Check if both cannot be evaluated
	                    if (sortA === null && sortB === null) {
	                        return 0;
	                    }
	                    _b = __read([sortA, sortB].map(function (s) {
	                        return (s || '').toString().toLocaleLowerCase();
	                    }), 2), sortA = _b[0], sortB = _b[1];
	                    if (sortA > sortB) return 1;
	                    if (sortA < sortB) return -1;
	                    return 0;
	                });
	            }
	        },
	        value: {
	            type: Array,
	            default: function _default() {
	                return [];
	            }
	        },
	        items: {
	            type: Array,
	            required: true,
	            default: function _default() {
	                return [];
	            }
	        },
	        totalItems: {
	            type: Number,
	            default: null
	        },
	        itemKey: {
	            type: String,
	            default: 'id'
	        },
	        pagination: {
	            type: Object,
	            default: function _default() {}
	        }
	    },
	    data: function data() {
	        return {
	            searchLength: 0,
	            defaultPagination: {
	                descending: false,
	                page: 1,
	                rowsPerPage: 5,
	                sortBy: null,
	                totalItems: 0
	            },
	            expanded: {},
	            actionsClasses: 'v-data-iterator__actions',
	            actionsRangeControlsClasses: 'v-data-iterator__actions__range-controls',
	            actionsSelectClasses: 'v-data-iterator__actions__select',
	            actionsPaginationClasses: 'v-data-iterator__actions__pagination'
	        };
	    },
	    computed: {
	        computedPagination: function computedPagination() {
	            return this.hasPagination ? this.pagination : this.defaultPagination;
	        },
	        computedRowsPerPageItems: function computedRowsPerPageItems() {
	            var _this = this;
	            return this.rowsPerPageItems.map(function (item) {
	                return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_6__["isObject"])(item) ? Object.assign({}, item, {
	                    text: _this.$vuetify.t(item.text)
	                }) : { value: item, text: Number(item).toLocaleString(_this.$vuetify.lang.current) };
	            });
	        },
	        hasPagination: function hasPagination() {
	            var pagination = this.pagination || {};
	            return Object.keys(pagination).length > 0;
	        },
	        hasSelectAll: function hasSelectAll() {
	            return this.selectAll !== undefined && this.selectAll !== false;
	        },
	        itemsLength: function itemsLength() {
	            if (this.hasSearch) return this.searchLength;
	            return this.totalItems || this.items.length;
	        },
	        indeterminate: function indeterminate() {
	            return this.hasSelectAll && this.someItems && !this.everyItem;
	        },
	        everyItem: function everyItem() {
	            var _this = this;
	            return this.filteredItems.length && this.filteredItems.every(function (i) {
	                return _this.isSelected(i);
	            });
	        },
	        someItems: function someItems() {
	            var _this = this;
	            return this.filteredItems.some(function (i) {
	                return _this.isSelected(i);
	            });
	        },
	        getPage: function getPage() {
	            var rowsPerPage = this.computedPagination.rowsPerPage;
	            return rowsPerPage === Object(rowsPerPage) ? rowsPerPage.value : rowsPerPage;
	        },
	        pageStart: function pageStart() {
	            return this.getPage === -1 ? 0 : (this.computedPagination.page - 1) * this.getPage;
	        },
	        pageStop: function pageStop() {
	            return this.getPage === -1 ? this.itemsLength : this.computedPagination.page * this.getPage;
	        },
	        filteredItems: function filteredItems() {
	            return this.filteredItemsImpl();
	        },
	        selected: function selected() {
	            var selected = {};
	            for (var index = 0; index < this.value.length; index++) {
	                var key = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_6__["getObjectValueByPath"])(this.value[index], this.itemKey);
	                selected[key] = true;
	            }
	            return selected;
	        },
	        hasSearch: function hasSearch() {
	            return this.search != null;
	        }
	    },
	    watch: {
	        items: function items() {
	            var _this = this;
	            if (this.pageStart >= this.itemsLength) {
	                this.resetPagination();
	            }
	            var newItemKeys = new Set(this.items.map(function (item) {
	                return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_6__["getObjectValueByPath"])(item, _this.itemKey);
	            }));
	            var selection = this.value.filter(function (item) {
	                return newItemKeys.has(Object(_util_helpers__WEBPACK_IMPORTED_MODULE_6__["getObjectValueByPath"])(item, _this.itemKey));
	            });
	            if (selection.length !== this.value.length) {
	                this.$emit('input', selection);
	            }
	        },
	        search: function search() {
	            var _this = this;
	            this.$nextTick(function () {
	                _this.updatePagination({ page: 1, totalItems: _this.itemsLength });
	            });
	        },
	        'computedPagination.sortBy': 'resetPagination',
	        'computedPagination.descending': 'resetPagination'
	    },
	    methods: {
	        initPagination: function initPagination() {
	            if (!this.rowsPerPageItems.length) {
	                Object(_util_console__WEBPACK_IMPORTED_MODULE_7__["consoleWarn"])("The prop 'rows-per-page-items' can not be empty", this);
	            } else {
	                this.defaultPagination.rowsPerPage = this.rowsPerPageItems[0];
	            }
	            this.defaultPagination.totalItems = this.items.length;
	            this.updatePagination(Object.assign({}, this.defaultPagination, this.pagination));
	        },
	        updatePagination: function updatePagination(val) {
	            var pagination = this.hasPagination ? this.pagination : this.defaultPagination;
	            var updatedPagination = Object.assign({}, pagination, val);
	            this.$emit('update:pagination', updatedPagination);
	            if (!this.hasPagination) {
	                this.defaultPagination = updatedPagination;
	            }
	        },
	        isSelected: function isSelected(item) {
	            return this.selected[Object(_util_helpers__WEBPACK_IMPORTED_MODULE_6__["getObjectValueByPath"])(item, this.itemKey)];
	        },
	        isExpanded: function isExpanded(item) {
	            return this.expanded[Object(_util_helpers__WEBPACK_IMPORTED_MODULE_6__["getObjectValueByPath"])(item, this.itemKey)];
	        },
	        filteredItemsImpl: function filteredItemsImpl() {
	            var additionalFilterArgs = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                additionalFilterArgs[_i] = arguments[_i];
	            }
	            if (this.totalItems) return this.items;
	            var items = this.items.slice();
	            if (this.hasSearch) {
	                items = this.customFilter.apply(this, __spread([items, this.search, this.filter], additionalFilterArgs));
	                this.searchLength = items.length;
	            }
	            items = this.customSort(items, this.computedPagination.sortBy, this.computedPagination.descending);
	            return this.hideActions && !this.hasPagination ? items : items.slice(this.pageStart, this.pageStop);
	        },
	        resetPagination: function resetPagination() {
	            this.computedPagination.page !== 1 && this.updatePagination({ page: 1 });
	        },
	        sort: function sort(index) {
	            var _a = this.computedPagination,
	                sortBy = _a.sortBy,
	                descending = _a.descending;
	            if (sortBy === null) {
	                this.updatePagination({ sortBy: index, descending: false });
	            } else if (sortBy === index && !descending) {
	                this.updatePagination({ descending: true });
	            } else if (sortBy !== index) {
	                this.updatePagination({ sortBy: index, descending: false });
	            } else if (!this.mustSort) {
	                this.updatePagination({ sortBy: null, descending: null });
	            } else {
	                this.updatePagination({ sortBy: index, descending: false });
	            }
	        },
	        toggle: function toggle(value) {
	            var _this = this;
	            var selected = Object.assign({}, this.selected);
	            for (var index = 0; index < this.filteredItems.length; index++) {
	                var key = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_6__["getObjectValueByPath"])(this.filteredItems[index], this.itemKey);
	                selected[key] = value;
	            }
	            this.$emit('input', this.items.filter(function (i) {
	                var key = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_6__["getObjectValueByPath"])(i, _this.itemKey);
	                return selected[key];
	            }));
	        },
	        createProps: function createProps(item, index) {
	            var _this = this;
	            var props = { item: item, index: index };
	            var keyProp = this.itemKey;
	            var itemKey = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_6__["getObjectValueByPath"])(item, keyProp);
	            Object.defineProperty(props, 'selected', {
	                get: function get() {
	                    return _this.selected[itemKey];
	                },
	                set: function set(value) {
	                    if (itemKey == null) {
	                        Object(_util_console__WEBPACK_IMPORTED_MODULE_7__["consoleWarn"])("\"" + keyProp + "\" attribute must be defined for item", _this);
	                    }
	                    var selected = _this.value.slice();
	                    if (value) selected.push(item);else selected = selected.filter(function (i) {
	                        return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_6__["getObjectValueByPath"])(i, keyProp) !== itemKey;
	                    });
	                    _this.$emit('input', selected);
	                }
	            });
	            Object.defineProperty(props, 'expanded', {
	                get: function get() {
	                    return _this.expanded[itemKey];
	                },
	                set: function set(value) {
	                    if (itemKey == null) {
	                        Object(_util_console__WEBPACK_IMPORTED_MODULE_7__["consoleWarn"])("\"" + keyProp + "\" attribute must be defined for item", _this);
	                    }
	                    if (!_this.expand) {
	                        for (var key in _this.expanded) {
	                            _this.expanded.hasOwnProperty(key) && _this.$set(_this.expanded, key, false);
	                        }
	                    }
	                    _this.$set(_this.expanded, itemKey, value);
	                }
	            });
	            return props;
	        },
	        genItems: function genItems() {
	            if (!this.itemsLength && !this.items.length) {
	                var noData = this.$slots['no-data'] || this.$vuetify.t(this.noDataText);
	                return [this.genEmptyItems(noData)];
	            }
	            if (!this.filteredItems.length) {
	                var noResults = this.$slots['no-results'] || this.$vuetify.t(this.noResultsText);
	                return [this.genEmptyItems(noResults)];
	            }
	            return this.genFilteredItems();
	        },
	        genPrevIcon: function genPrevIcon() {
	            var _this = this;
	            return this.$createElement(_components_VBtn__WEBPACK_IMPORTED_MODULE_0__["default"], {
	                props: {
	                    disabled: this.computedPagination.page === 1,
	                    icon: true,
	                    flat: true
	                },
	                on: {
	                    click: function click() {
	                        var page = _this.computedPagination.page;
	                        _this.updatePagination({ page: page - 1 });
	                    }
	                },
	                attrs: {
	                    'aria-label': this.$vuetify.t('$vuetify.dataIterator.prevPage')
	                }
	            }, [this.$createElement(_components_VIcon__WEBPACK_IMPORTED_MODULE_1__["default"], this.$vuetify.rtl ? this.nextIcon : this.prevIcon)]);
	        },
	        genNextIcon: function genNextIcon() {
	            var _this = this;
	            var pagination = this.computedPagination;
	            var disabled = pagination.rowsPerPage < 0 || pagination.page * pagination.rowsPerPage >= this.itemsLength || this.pageStop < 0;
	            return this.$createElement(_components_VBtn__WEBPACK_IMPORTED_MODULE_0__["default"], {
	                props: {
	                    disabled: disabled,
	                    icon: true,
	                    flat: true
	                },
	                on: {
	                    click: function click() {
	                        var page = _this.computedPagination.page;
	                        _this.updatePagination({ page: page + 1 });
	                    }
	                },
	                attrs: {
	                    'aria-label': this.$vuetify.t('$vuetify.dataIterator.nextPage')
	                }
	            }, [this.$createElement(_components_VIcon__WEBPACK_IMPORTED_MODULE_1__["default"], this.$vuetify.rtl ? this.prevIcon : this.nextIcon)]);
	        },
	        genSelect: function genSelect() {
	            var _this = this;
	            return this.$createElement('div', {
	                'class': this.actionsSelectClasses
	            }, [this.$vuetify.t(this.rowsPerPageText), this.$createElement(_components_VSelect__WEBPACK_IMPORTED_MODULE_2__["default"], {
	                attrs: {
	                    'aria-label': this.$vuetify.t(this.rowsPerPageText)
	                },
	                props: {
	                    items: this.computedRowsPerPageItems,
	                    value: this.computedPagination.rowsPerPage,
	                    hideDetails: true,
	                    menuProps: {
	                        auto: true,
	                        dark: this.dark,
	                        light: this.light,
	                        minWidth: '75px'
	                    }
	                },
	                on: {
	                    input: function input(val) {
	                        _this.updatePagination({
	                            page: 1,
	                            rowsPerPage: val
	                        });
	                    }
	                }
	            })]);
	        },
	        genPagination: function genPagination() {
	            var _this = this;
	            var _a;
	            var pagination = '–';
	            if (this.itemsLength) {
	                var stop = this.itemsLength < this.pageStop || this.pageStop < 0 ? this.itemsLength : this.pageStop;
	                pagination = this.$scopedSlots.pageText ? this.$scopedSlots.pageText({
	                    pageStart: this.pageStart + 1,
	                    pageStop: stop,
	                    itemsLength: this.itemsLength
	                }) : (_a = this.$vuetify).t.apply(_a, __spread(['$vuetify.dataIterator.pageText'], [this.pageStart + 1, stop, this.itemsLength].map(function (n) {
	                    return Number(n).toLocaleString(_this.$vuetify.lang.current);
	                })));
	            }
	            return this.$createElement('div', {
	                'class': this.actionsPaginationClasses
	            }, [pagination]);
	        },
	        genActions: function genActions() {
	            var rangeControls = this.$createElement('div', {
	                'class': this.actionsRangeControlsClasses
	            }, [this.genPagination(), this.genPrevIcon(), this.genNextIcon()]);
	            return [this.$createElement('div', {
	                'class': this.actionsClasses
	            }, [this.$slots['actions-prepend'] ? this.$createElement('div', {}, this.$slots['actions-prepend']) : null, this.rowsPerPageItems.length > 1 ? this.genSelect() : null, rangeControls, this.$slots['actions-append'] ? this.$createElement('div', {}, this.$slots['actions-append']) : null])];
	        }
	    }
	});
	
	/***/ }),
	
	/***/ "./src/mixins/delayable.ts":
	/*!*********************************!*\
	  !*** ./src/mixins/delayable.ts ***!
	  \*********************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
	
	/**
	 * Delayable
	 *
	 * @mixin
	 *
	 * Changes the open or close delay time for elements
	 */
	/* harmony default export */ __webpack_exports__["default"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend().extend({
	    name: 'delayable',
	    props: {
	        openDelay: {
	            type: [Number, String],
	            default: 0
	        },
	        closeDelay: {
	            type: [Number, String],
	            default: 0
	        }
	    },
	    data: function data() {
	        return {
	            openTimeout: undefined,
	            closeTimeout: undefined
	        };
	    },
	    methods: {
	        /**
	         * Clear any pending delay timers from executing
	         */
	        clearDelay: function clearDelay() {
	            clearTimeout(this.openTimeout);
	            clearTimeout(this.closeTimeout);
	        },
	        /**
	         * Runs callback after a specified delay
	         */
	        runDelay: function runDelay(type, cb) {
	            var _this = this;
	            this.clearDelay();
	            var delay = parseInt(this[type + "Delay"], 10);
	            this[type + "Timeout"] = setTimeout(cb || function () {
	                _this.isActive = { open: true, close: false }[type];
	            }, delay);
	        }
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/mixins/dependent.ts":
	/*!*********************************!*\
	  !*** ./src/mixins/dependent.ts ***!
	  \*********************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../util/mixins */ "./src/util/mixins.ts");
	var __read = undefined && undefined.__read || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o),
	        r,
	        ar = [],
	        e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
	            ar.push(r.value);
	        }
	    } catch (error) {
	        e = { error: error };
	    } finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        } finally {
	            if (e) throw e.error;
	        }
	    }
	    return ar;
	};
	var __spread = undefined && undefined.__spread || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) {
	        ar = ar.concat(__read(arguments[i]));
	    }return ar;
	};
	
	function searchChildren(children) {
	    var results = [];
	    for (var index = 0; index < children.length; index++) {
	        var child = children[index];
	        if (child.isActive && child.isDependent) {
	            results.push(child);
	        } else {
	            results.push.apply(results, __spread(searchChildren(child.$children)));
	        }
	    }
	    return results;
	}
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_0__["default"])().extend({
	    name: 'dependent',
	    data: function data() {
	        return {
	            closeDependents: true,
	            isActive: false,
	            isDependent: true
	        };
	    },
	    watch: {
	        isActive: function isActive(val) {
	            if (val) return;
	            var openDependents = this.getOpenDependents();
	            for (var index = 0; index < openDependents.length; index++) {
	                openDependents[index].isActive = false;
	            }
	        }
	    },
	    methods: {
	        getOpenDependents: function getOpenDependents() {
	            if (this.closeDependents) return searchChildren(this.$children);
	            return [];
	        },
	        getOpenDependentElements: function getOpenDependentElements() {
	            var result = [];
	            var openDependents = this.getOpenDependents();
	            for (var index = 0; index < openDependents.length; index++) {
	                result.push.apply(result, __spread(openDependents[index].getClickableDependentElements()));
	            }
	            return result;
	        },
	        getClickableDependentElements: function getClickableDependentElements() {
	            var result = [this.$el];
	            if (this.$refs.content) result.push(this.$refs.content);
	            if (this.overlay) result.push(this.overlay);
	            result.push.apply(result, __spread(this.getOpenDependentElements()));
	            return result;
	        }
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/mixins/detachable.js":
	/*!**********************************!*\
	  !*** ./src/mixins/detachable.js ***!
	  \**********************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _bootable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./bootable */ "./src/mixins/bootable.ts");
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/console */ "./src/util/console.ts");
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	
	
	function validateAttachTarget(val) {
	    var type = typeof val === 'undefined' ? 'undefined' : _typeof(val);
	    if (type === 'boolean' || type === 'string') return true;
	    return val.nodeType === Node.ELEMENT_NODE;
	}
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'detachable',
	    mixins: [_bootable__WEBPACK_IMPORTED_MODULE_0__["default"]],
	    props: {
	        attach: {
	            type: null,
	            default: false,
	            validator: validateAttachTarget
	        },
	        contentClass: {
	            default: ''
	        }
	    },
	    data: function data() {
	        return {
	            hasDetached: false
	        };
	    },
	    watch: {
	        attach: function attach() {
	            this.hasDetached = false;
	            this.initDetach();
	        },
	        hasContent: 'initDetach'
	    },
	    beforeMount: function beforeMount() {
	        var _this = this;
	        this.$nextTick(function () {
	            if (_this.activatorNode) {
	                var activator = Array.isArray(_this.activatorNode) ? _this.activatorNode : [_this.activatorNode];
	                activator.forEach(function (node) {
	                    node.elm && _this.$el.parentNode.insertBefore(node.elm, _this.$el);
	                });
	            }
	        });
	    },
	    mounted: function mounted() {
	        !this.lazy && this.initDetach();
	    },
	    deactivated: function deactivated() {
	        this.isActive = false;
	    },
	    beforeDestroy: function beforeDestroy() {
	        // IE11 Fix
	        try {
	            if (this.$refs.content) {
	                this.$refs.content.parentNode.removeChild(this.$refs.content);
	            }
	            if (this.activatorNode) {
	                var activator = Array.isArray(this.activatorNode) ? this.activatorNode : [this.activatorNode];
	                activator.forEach(function (node) {
	                    node.elm && node.elm.parentNode.removeChild(node.elm);
	                });
	            }
	        } catch (e) {
	            console.log(e);
	        }
	    },
	    methods: {
	        getScopeIdAttrs: function getScopeIdAttrs() {
	            var _a;
	            var scopeId = this.$vnode && this.$vnode.context.$options._scopeId;
	            return scopeId && (_a = {}, _a[scopeId] = '', _a);
	        },
	        initDetach: function initDetach() {
	            if (this._isDestroyed || !this.$refs.content || this.hasDetached ||
	            // Leave menu in place if attached
	            // and dev has not changed target
	            this.attach === '' || // If used as a boolean prop (<v-menu attach>)
	            this.attach === true || // If bound to a boolean (<v-menu :attach="true">)
	            this.attach === 'attach' // If bound as boolean prop in pug (v-menu(attach))
	            ) return;
	            var target;
	            if (this.attach === false) {
	                // Default, detach to app
	                target = document.querySelector('[data-app]');
	            } else if (typeof this.attach === 'string') {
	                // CSS selector
	                target = document.querySelector(this.attach);
	            } else {
	                // DOM Element
	                target = this.attach;
	            }
	            if (!target) {
	                Object(_util_console__WEBPACK_IMPORTED_MODULE_1__["consoleWarn"])("Unable to locate target " + (this.attach || '[data-app]'), this);
	                return;
	            }
	            target.insertBefore(this.$refs.content, target.firstChild);
	            this.hasDetached = true;
	        }
	    }
	});
	
	/***/ }),
	
	/***/ "./src/mixins/elevatable.ts":
	/*!**********************************!*\
	  !*** ./src/mixins/elevatable.ts ***!
	  \**********************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
	
	/* harmony default export */ __webpack_exports__["default"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
	    name: 'elevatable',
	    props: {
	        elevation: [Number, String]
	    },
	    computed: {
	        computedElevation: function computedElevation() {
	            return this.elevation;
	        },
	        elevationClasses: function elevationClasses() {
	            var _a;
	            if (!this.computedElevation) return {};
	            return _a = {}, _a["elevation-" + this.computedElevation] = true, _a;
	        }
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/mixins/filterable.ts":
	/*!**********************************!*\
	  !*** ./src/mixins/filterable.ts ***!
	  \**********************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
	    name: 'filterable',
	    props: {
	        noDataText: {
	            type: String,
	            default: '$vuetify.noDataText'
	        }
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/mixins/groupable.ts":
	/*!*********************************!*\
	  !*** ./src/mixins/groupable.ts ***!
	  \*********************************/
	/*! exports provided: factory, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "factory", function() { return factory; });
	/* harmony import */ var _registrable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./registrable */ "./src/mixins/registrable.ts");
	// Mixins
	
	function factory(namespace, child, parent) {
	    return Object(_registrable__WEBPACK_IMPORTED_MODULE_0__["inject"])(namespace, child, parent).extend({
	        name: 'groupable',
	        props: {
	            activeClass: {
	                type: String,
	                default: function _default() {
	                    if (!this[namespace]) return undefined;
	                    return this[namespace].activeClass;
	                }
	            },
	            disabled: Boolean
	        },
	        data: function data() {
	            return {
	                isActive: false
	            };
	        },
	        computed: {
	            groupClasses: function groupClasses() {
	                var _a;
	                if (!this.activeClass) return {};
	                return _a = {}, _a[this.activeClass] = this.isActive, _a;
	            }
	        },
	        created: function created() {
	            this[namespace] && this[namespace].register(this);
	        },
	        beforeDestroy: function beforeDestroy() {
	            this[namespace] && this[namespace].unregister(this);
	        },
	        methods: {
	            toggle: function toggle() {
	                this.$emit('change');
	            }
	        }
	    });
	}
	/* eslint-disable-next-line no-redeclare */
	var Groupable = factory('itemGroup');
	/* harmony default export */ __webpack_exports__["default"] = (Groupable);
	
	/***/ }),
	
	/***/ "./src/mixins/loadable.ts":
	/*!********************************!*\
	  !*** ./src/mixins/loadable.ts ***!
	  \********************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _components_VProgressLinear__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../components/VProgressLinear */ "./src/components/VProgressLinear/index.ts");
	
	
	/**
	 * Loadable
	 *
	 * @mixin
	 *
	 * Used to add linear progress bar to components
	 * Can use a default bar with a specific color
	 * or designate a custom progress linear bar
	 */
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend().extend({
	    name: 'loadable',
	    props: {
	        loading: {
	            type: [Boolean, String],
	            default: false
	        }
	    },
	    methods: {
	        genProgress: function genProgress() {
	            if (this.loading === false) return null;
	            return this.$slots.progress || this.$createElement(_components_VProgressLinear__WEBPACK_IMPORTED_MODULE_1__["default"], {
	                props: {
	                    color: this.loading === true || this.loading === '' ? this.color || 'primary' : this.loading,
	                    height: 2,
	                    indeterminate: true
	                }
	            });
	        }
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/mixins/maskable.js":
	/*!********************************!*\
	  !*** ./src/mixins/maskable.js ***!
	  \********************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _util_mask__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../util/mask */ "./src/util/mask.ts");
	/**
	 * Maskable
	 *
	 * @mixin
	 *
	 * Creates an input mask that is
	 * generated from a masked str
	 *
	 * Example: mask="#### #### #### ####"
	 */
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'maskable',
	    props: {
	        dontFillMaskBlanks: Boolean,
	        mask: {
	            type: [Object, String],
	            default: null
	        },
	        returnMaskedValue: Boolean,
	        value: { required: false }
	    },
	    data: function data(vm) {
	        return {
	            selection: 0,
	            lazySelection: 0,
	            lazyValue: vm.value,
	            preDefined: {
	                'credit-card': '#### - #### - #### - ####',
	                'date': '##/##/####',
	                'date-with-time': '##/##/#### ##:##',
	                'phone': '(###) ### - ####',
	                'social': '###-##-####',
	                'time': '##:##',
	                'time-with-seconds': '##:##:##'
	            }
	        };
	    },
	    computed: {
	        masked: function masked() {
	            var preDefined = this.preDefined[this.mask];
	            var mask = preDefined || this.mask || '';
	            return mask.split('');
	        }
	    },
	    watch: {
	        /**
	         * Make sure the cursor is in the correct
	         * location when the mask changes
	         */
	        mask: function mask() {
	            var _this = this;
	            if (!this.$refs.input) return;
	            var oldValue = this.$refs.input.value;
	            var newValue = this.maskText(Object(_util_mask__WEBPACK_IMPORTED_MODULE_0__["unmaskText"])(this.lazyValue));
	            var position = 0;
	            var selection = this.selection;
	            for (var index = 0; index < selection; index++) {
	                Object(_util_mask__WEBPACK_IMPORTED_MODULE_0__["isMaskDelimiter"])(oldValue[index]) || position++;
	            }
	            selection = 0;
	            if (newValue) {
	                for (var index = 0; index < newValue.length; index++) {
	                    Object(_util_mask__WEBPACK_IMPORTED_MODULE_0__["isMaskDelimiter"])(newValue[index]) || position--;
	                    selection++;
	                    if (position <= 0) break;
	                }
	            }
	            this.$nextTick(function () {
	                _this.$refs.input.value = newValue;
	                _this.setCaretPosition(selection);
	            });
	        }
	    },
	    beforeMount: function beforeMount() {
	        if (!this.mask || this.value == null || !this.returnMaskedValue) return;
	        var value = this.maskText(this.value);
	        // See if masked value does not
	        // match the user given value
	        if (value === this.value) return;
	        this.$emit('input', value);
	    },
	    methods: {
	        setCaretPosition: function setCaretPosition(selection) {
	            var _this = this;
	            this.selection = selection;
	            window.setTimeout(function () {
	                _this.$refs.input && _this.$refs.input.setSelectionRange(_this.selection, _this.selection);
	            }, 0);
	        },
	        updateRange: function updateRange() {
	            /* istanbul ignore next */
	            if (!this.$refs.input) return;
	            var newValue = this.maskText(this.lazyValue);
	            var selection = 0;
	            this.$refs.input.value = newValue;
	            if (newValue) {
	                for (var index = 0; index < newValue.length; index++) {
	                    if (this.lazySelection <= 0) break;
	                    Object(_util_mask__WEBPACK_IMPORTED_MODULE_0__["isMaskDelimiter"])(newValue[index]) || this.lazySelection--;
	                    selection++;
	                }
	            }
	            this.setCaretPosition(selection);
	            // this.$emit() must occur only when all internal values are correct
	            this.$emit('input', this.returnMaskedValue ? this.$refs.input.value : this.lazyValue);
	        },
	        maskText: function maskText(text) {
	            return this.mask ? Object(_util_mask__WEBPACK_IMPORTED_MODULE_0__["maskText"])(text, this.masked, this.dontFillMaskBlanks) : text;
	        },
	        unmaskText: function unmaskText(text) {
	            return this.mask && !this.returnMaskedValue ? Object(_util_mask__WEBPACK_IMPORTED_MODULE_0__["unmaskText"])(text) : text;
	        },
	        // When the input changes and is
	        // re-created, ensure that the
	        // caret location is correct
	        setSelectionRange: function setSelectionRange() {
	            this.$nextTick(this.updateRange);
	        },
	        resetSelections: function resetSelections(input) {
	            if (!input.selectionEnd) return;
	            this.selection = input.selectionEnd;
	            this.lazySelection = 0;
	            for (var index = 0; index < this.selection; index++) {
	                Object(_util_mask__WEBPACK_IMPORTED_MODULE_0__["isMaskDelimiter"])(input.value[index]) || this.lazySelection++;
	            }
	        }
	    }
	});
	
	/***/ }),
	
	/***/ "./src/mixins/measurable.ts":
	/*!**********************************!*\
	  !*** ./src/mixins/measurable.ts ***!
	  \**********************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
	// Helpers
	
	// Types
	
	/* harmony default export */ __webpack_exports__["default"] = (vue__WEBPACK_IMPORTED_MODULE_1___default.a.extend({
	    name: 'measurable',
	    props: {
	        height: [Number, String],
	        maxHeight: [Number, String],
	        maxWidth: [Number, String],
	        minHeight: [Number, String],
	        minWidth: [Number, String],
	        width: [Number, String]
	    },
	    computed: {
	        measurableStyles: function measurableStyles() {
	            var styles = {};
	            var height = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["convertToUnit"])(this.height);
	            var minHeight = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["convertToUnit"])(this.minHeight);
	            var minWidth = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["convertToUnit"])(this.minWidth);
	            var maxHeight = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["convertToUnit"])(this.maxHeight);
	            var maxWidth = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["convertToUnit"])(this.maxWidth);
	            var width = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["convertToUnit"])(this.width);
	            if (height) styles.height = height;
	            if (minHeight) styles.minHeight = minHeight;
	            if (minWidth) styles.minWidth = minWidth;
	            if (maxHeight) styles.maxHeight = maxHeight;
	            if (maxWidth) styles.maxWidth = maxWidth;
	            if (width) styles.width = width;
	            return styles;
	        }
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/mixins/menuable.js":
	/*!********************************!*\
	  !*** ./src/mixins/menuable.js ***!
	  \********************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _positionable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./positionable */ "./src/mixins/positionable.ts");
	/* harmony import */ var _stackable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./stackable */ "./src/mixins/stackable.ts");
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	
	
	
	/* eslint-disable object-property-newline */
	var dimensions = {
	    activator: {
	        top: 0, left: 0,
	        bottom: 0, right: 0,
	        width: 0, height: 0,
	        offsetTop: 0, scrollHeight: 0
	    },
	    content: {
	        top: 0, left: 0,
	        bottom: 0, right: 0,
	        width: 0, height: 0,
	        offsetTop: 0, scrollHeight: 0
	    },
	    hasWindow: false
	};
	/* eslint-enable object-property-newline */
	/**
	 * Menuable
	 *
	 * @mixin
	 *
	 * Used for fixed or absolutely positioning
	 * elements within the DOM
	 * Can calculate X and Y axis overflows
	 * As well as be manually positioned
	 */
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
	    name: 'menuable',
	    mixins: [_positionable__WEBPACK_IMPORTED_MODULE_1__["default"], _stackable__WEBPACK_IMPORTED_MODULE_2__["default"]],
	    props: {
	        activator: {
	            default: null,
	            validator: function validator(val) {
	                return ['string', 'object'].includes(typeof val === 'undefined' ? 'undefined' : _typeof(val));
	            }
	        },
	        allowOverflow: Boolean,
	        inputActivator: Boolean,
	        light: Boolean,
	        dark: Boolean,
	        maxWidth: {
	            type: [Number, String],
	            default: 'auto'
	        },
	        minWidth: [Number, String],
	        nudgeBottom: {
	            type: [Number, String],
	            default: 0
	        },
	        nudgeLeft: {
	            type: [Number, String],
	            default: 0
	        },
	        nudgeRight: {
	            type: [Number, String],
	            default: 0
	        },
	        nudgeTop: {
	            type: [Number, String],
	            default: 0
	        },
	        nudgeWidth: {
	            type: [Number, String],
	            default: 0
	        },
	        offsetOverflow: Boolean,
	        positionX: {
	            type: Number,
	            default: null
	        },
	        positionY: {
	            type: Number,
	            default: null
	        },
	        zIndex: {
	            type: [Number, String],
	            default: null
	        }
	    },
	    data: function data() {
	        return {
	            absoluteX: 0,
	            absoluteY: 0,
	            activatorFixed: false,
	            dimensions: Object.assign({}, dimensions),
	            isContentActive: false,
	            pageWidth: 0,
	            pageYOffset: 0,
	            stackClass: 'v-menu__content--active',
	            stackMinZIndex: 6
	        };
	    },
	    computed: {
	        computedLeft: function computedLeft() {
	            var a = this.dimensions.activator;
	            var c = this.dimensions.content;
	            var activatorLeft = (this.isAttached ? a.offsetLeft : a.left) || 0;
	            var minWidth = Math.max(a.width, c.width);
	            var left = 0;
	            left += this.left ? activatorLeft - (minWidth - a.width) : activatorLeft;
	            if (this.offsetX) {
	                var maxWidth = isNaN(this.maxWidth) ? a.width : Math.min(a.width, this.maxWidth);
	                left += this.left ? -maxWidth : a.width;
	            }
	            if (this.nudgeLeft) left -= parseInt(this.nudgeLeft);
	            if (this.nudgeRight) left += parseInt(this.nudgeRight);
	            return left;
	        },
	        computedTop: function computedTop() {
	            var a = this.dimensions.activator;
	            var c = this.dimensions.content;
	            var top = 0;
	            if (this.top) top += a.height - c.height;
	            if (this.isAttached) top += a.offsetTop;else top += a.top + this.pageYOffset;
	            if (this.offsetY) top += this.top ? -a.height : a.height;
	            if (this.nudgeTop) top -= parseInt(this.nudgeTop);
	            if (this.nudgeBottom) top += parseInt(this.nudgeBottom);
	            return top;
	        },
	        hasActivator: function hasActivator() {
	            return !!this.$slots.activator || !!this.$scopedSlots.activator || this.activator || this.inputActivator;
	        },
	        isAttached: function isAttached() {
	            return this.attach !== false;
	        }
	    },
	    watch: {
	        disabled: function disabled(val) {
	            val && this.callDeactivate();
	        },
	        isActive: function isActive(val) {
	            if (this.disabled) return;
	            val ? this.callActivate() : this.callDeactivate();
	        },
	        positionX: 'updateDimensions',
	        positionY: 'updateDimensions'
	    },
	    beforeMount: function beforeMount() {
	        this.checkForWindow();
	    },
	    methods: {
	        absolutePosition: function absolutePosition() {
	            return {
	                offsetTop: 0,
	                offsetLeft: 0,
	                scrollHeight: 0,
	                top: this.positionY || this.absoluteY,
	                bottom: this.positionY || this.absoluteY,
	                left: this.positionX || this.absoluteX,
	                right: this.positionX || this.absoluteX,
	                height: 0,
	                width: 0
	            };
	        },
	        activate: function activate() {},
	        calcLeft: function calcLeft(menuWidth) {
	            return (this.isAttached ? this.computedLeft : this.calcXOverflow(this.computedLeft, menuWidth)) + "px";
	        },
	        calcTop: function calcTop() {
	            return (this.isAttached ? this.computedTop : this.calcYOverflow(this.computedTop)) + "px";
	        },
	        calcXOverflow: function calcXOverflow(left, menuWidth) {
	            var xOverflow = left + menuWidth - this.pageWidth + 12;
	            if ((!this.left || this.right) && xOverflow > 0) {
	                left = Math.max(left - xOverflow, 0);
	            } else {
	                left = Math.max(left, 12);
	            }
	            return left + this.getOffsetLeft();
	        },
	        calcYOverflow: function calcYOverflow(top) {
	            var documentHeight = this.getInnerHeight();
	            var toTop = this.pageYOffset + documentHeight;
	            var activator = this.dimensions.activator;
	            var contentHeight = this.dimensions.content.height;
	            var totalHeight = top + contentHeight;
	            var isOverflowing = toTop < totalHeight;
	            // If overflowing bottom and offset
	            // TODO: set 'bottom' position instead of 'top'
	            if (isOverflowing && this.offsetOverflow &&
	            // If we don't have enough room to offset
	            // the overflow, don't offset
	            activator.top > contentHeight) {
	                top = this.pageYOffset + (activator.top - contentHeight);
	                // If overflowing bottom
	            } else if (isOverflowing && !this.allowOverflow) {
	                top = toTop - contentHeight - 12;
	                // If overflowing top
	            } else if (top < this.pageYOffset && !this.allowOverflow) {
	                top = this.pageYOffset + 12;
	            }
	            return top < 12 ? 12 : top;
	        },
	        callActivate: function callActivate() {
	            if (!this.hasWindow) return;
	            this.activate();
	        },
	        callDeactivate: function callDeactivate() {
	            this.isContentActive = false;
	            this.deactivate();
	        },
	        checkForWindow: function checkForWindow() {
	            if (!this.hasWindow) {
	                this.hasWindow = typeof window !== 'undefined';
	            }
	        },
	        checkForPageYOffset: function checkForPageYOffset() {
	            if (this.hasWindow) {
	                this.pageYOffset = this.activatorFixed ? 0 : this.getOffsetTop();
	            }
	        },
	        checkActivatorFixed: function checkActivatorFixed() {
	            if (this.attach !== false) return;
	            var el = this.getActivator();
	            while (el) {
	                if (window.getComputedStyle(el).position === 'fixed') {
	                    this.activatorFixed = true;
	                    return;
	                }
	                el = el.offsetParent;
	            }
	            this.activatorFixed = false;
	        },
	        deactivate: function deactivate() {},
	        getActivator: function getActivator(e) {
	            if (this.inputActivator) {
	                return this.$el.querySelector('.v-input__slot');
	            }
	            if (this.activator) {
	                return typeof this.activator === 'string' ? document.querySelector(this.activator) : this.activator;
	            }
	            if (this.$refs.activator) {
	                return this.$refs.activator.children.length > 0 ? this.$refs.activator.children[0] : this.$refs.activator;
	            }
	            if (e) {
	                this.activatedBy = e.currentTarget || e.target;
	                return this.activatedBy;
	            }
	            if (this.activatedBy) return this.activatedBy;
	            if (this.activatorNode) {
	                var activator = Array.isArray(this.activatorNode) ? this.activatorNode[0] : this.activatorNode;
	                var el = activator && activator.elm;
	                if (el) return el;
	            }
	        },
	        getInnerHeight: function getInnerHeight() {
	            if (!this.hasWindow) return 0;
	            return window.innerHeight || document.documentElement.clientHeight;
	        },
	        getOffsetLeft: function getOffsetLeft() {
	            if (!this.hasWindow) return 0;
	            return window.pageXOffset || document.documentElement.scrollLeft;
	        },
	        getOffsetTop: function getOffsetTop() {
	            if (!this.hasWindow) return 0;
	            return window.pageYOffset || document.documentElement.scrollTop;
	        },
	        getRoundedBoundedClientRect: function getRoundedBoundedClientRect(el) {
	            var rect = el.getBoundingClientRect();
	            return {
	                top: Math.round(rect.top),
	                left: Math.round(rect.left),
	                bottom: Math.round(rect.bottom),
	                right: Math.round(rect.right),
	                width: Math.round(rect.width),
	                height: Math.round(rect.height)
	            };
	        },
	        measure: function measure(el) {
	            if (!el || !this.hasWindow) return null;
	            var rect = this.getRoundedBoundedClientRect(el);
	            // Account for activator margin
	            if (this.isAttached) {
	                var style = window.getComputedStyle(el);
	                rect.left = parseInt(style.marginLeft);
	                rect.top = parseInt(style.marginTop);
	            }
	            return rect;
	        },
	        sneakPeek: function sneakPeek(cb) {
	            var _this = this;
	            requestAnimationFrame(function () {
	                var el = _this.$refs.content;
	                if (!el || _this.isShown(el)) return cb();
	                el.style.display = 'inline-block';
	                cb();
	                el.style.display = 'none';
	            });
	        },
	        startTransition: function startTransition() {
	            var _this = this;
	            return new Promise(function (resolve) {
	                return requestAnimationFrame(function () {
	                    _this.isContentActive = _this.hasJustFocused = _this.isActive;
	                    resolve();
	                });
	            });
	        },
	        isShown: function isShown(el) {
	            return el.style.display !== 'none';
	        },
	        updateDimensions: function updateDimensions() {
	            var _this = this;
	            this.checkForWindow();
	            this.checkActivatorFixed();
	            this.checkForPageYOffset();
	            this.pageWidth = document.documentElement.clientWidth;
	            var dimensions = {};
	            // Activator should already be shown
	            if (!this.hasActivator || this.absolute) {
	                dimensions.activator = this.absolutePosition();
	            } else {
	                var activator = this.getActivator();
	                dimensions.activator = this.measure(activator);
	                dimensions.activator.offsetLeft = activator.offsetLeft;
	                if (this.isAttached) {
	                    // account for css padding causing things to not line up
	                    // this is mostly for v-autocomplete, hopefully it won't break anything
	                    dimensions.activator.offsetTop = activator.offsetTop;
	                } else {
	                    dimensions.activator.offsetTop = 0;
	                }
	            }
	            // Display and hide to get dimensions
	            this.sneakPeek(function () {
	                dimensions.content = _this.measure(_this.$refs.content);
	                _this.dimensions = dimensions;
	            });
	        }
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/mixins/overlayable.ts":
	/*!***********************************!*\
	  !*** ./src/mixins/overlayable.ts ***!
	  \***********************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_overlay_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../stylus/components/_overlay.styl */ "./src/stylus/components/_overlay.styl");
	/* harmony import */ var _stylus_components_overlay_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_overlay_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_2__);
	// Styles
	
	// Utilities
	
	// Types
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (vue__WEBPACK_IMPORTED_MODULE_2___default.a.extend().extend({
	    name: 'overlayable',
	    props: {
	        hideOverlay: Boolean
	    },
	    data: function data() {
	        return {
	            overlay: null,
	            overlayOffset: 0,
	            overlayTimeout: undefined,
	            overlayTransitionDuration: 500 + 150 // transition + delay
	        };
	    },
	    watch: {
	        hideOverlay: function hideOverlay(value) {
	            if (value) this.removeOverlay();else this.genOverlay();
	        }
	    },
	    beforeDestroy: function beforeDestroy() {
	        this.removeOverlay();
	    },
	    methods: {
	        genOverlay: function genOverlay() {
	            var _this = this;
	            // If fn is called and timeout is active
	            // or overlay already exists
	            // cancel removal of overlay and re-add active
	            if (!this.isActive || this.hideOverlay || this.isActive && this.overlayTimeout || this.overlay) {
	                clearTimeout(this.overlayTimeout);
	                return this.overlay && this.overlay.classList.add('v-overlay--active');
	            }
	            this.overlay = document.createElement('div');
	            this.overlay.className = 'v-overlay';
	            if (this.absolute) this.overlay.className += ' v-overlay--absolute';
	            this.hideScroll();
	            var parent = this.absolute ? this.$el.parentNode : document.querySelector('[data-app]');
	            parent && parent.insertBefore(this.overlay, parent.firstChild);
	            // eslint-disable-next-line no-unused-expressions
	            this.overlay.clientHeight; // Force repaint
	            requestAnimationFrame(function () {
	                // https://github.com/vuetifyjs/vuetify/issues/4678
	                if (!_this.overlay) return;
	                _this.overlay.className += ' v-overlay--active';
	                if (_this.activeZIndex !== undefined) {
	                    _this.overlay.style.zIndex = String(_this.activeZIndex - 1);
	                }
	            });
	            return true;
	        },
	        /** removeOverlay(false) will not restore the scollbar afterwards */
	        removeOverlay: function removeOverlay(showScroll) {
	            var _this = this;
	            if (showScroll === void 0) {
	                showScroll = true;
	            }
	            if (!this.overlay) {
	                return showScroll && this.showScroll();
	            }
	            this.overlay.classList.remove('v-overlay--active');
	            this.overlayTimeout = window.setTimeout(function () {
	                // IE11 Fix
	                try {
	                    if (_this.overlay && _this.overlay.parentNode) {
	                        _this.overlay.parentNode.removeChild(_this.overlay);
	                    }
	                    _this.overlay = null;
	                    showScroll && _this.showScroll();
	                } catch (e) {
	                    console.log(e);
	                }
	                clearTimeout(_this.overlayTimeout);
	                _this.overlayTimeout = undefined;
	            }, this.overlayTransitionDuration);
	        },
	        scrollListener: function scrollListener(e) {
	            if (e.type === 'keydown') {
	                if (['INPUT', 'TEXTAREA', 'SELECT'].includes(e.target.tagName) ||
	                // https://github.com/vuetifyjs/vuetify/issues/4715
	                e.target.isContentEditable) return;
	                var up = [_util_helpers__WEBPACK_IMPORTED_MODULE_1__["keyCodes"].up, _util_helpers__WEBPACK_IMPORTED_MODULE_1__["keyCodes"].pageup];
	                var down = [_util_helpers__WEBPACK_IMPORTED_MODULE_1__["keyCodes"].down, _util_helpers__WEBPACK_IMPORTED_MODULE_1__["keyCodes"].pagedown];
	                if (up.includes(e.keyCode)) {
	                    e.deltaY = -1;
	                } else if (down.includes(e.keyCode)) {
	                    e.deltaY = 1;
	                } else {
	                    return;
	                }
	            }
	            if (e.target === this.overlay || e.type !== 'keydown' && e.target === document.body || this.checkPath(e)) e.preventDefault();
	        },
	        hasScrollbar: function hasScrollbar(el) {
	            if (!el || el.nodeType !== Node.ELEMENT_NODE) return false;
	            var style = window.getComputedStyle(el);
	            return ['auto', 'scroll'].includes(style.overflowY) && el.scrollHeight > el.clientHeight;
	        },
	        shouldScroll: function shouldScroll(el, delta) {
	            if (el.scrollTop === 0 && delta < 0) return true;
	            return el.scrollTop + el.clientHeight === el.scrollHeight && delta > 0;
	        },
	        isInside: function isInside(el, parent) {
	            if (el === parent) {
	                return true;
	            } else if (el === null || el === document.body) {
	                return false;
	            } else {
	                return this.isInside(el.parentNode, parent);
	            }
	        },
	        checkPath: function checkPath(e) {
	            var path = e.path || this.composedPath(e);
	            var delta = e.deltaY;
	            if (e.type === 'keydown' && path[0] === document.body) {
	                var dialog = this.$refs.dialog;
	                var selected = window.getSelection().anchorNode;
	                if (dialog && this.hasScrollbar(dialog) && this.isInside(selected, dialog)) {
	                    return this.shouldScroll(dialog, delta);
	                }
	                return true;
	            }
	            for (var index = 0; index < path.length; index++) {
	                var el = path[index];
	                if (el === document) return true;
	                if (el === document.documentElement) return true;
	                if (el === this.$refs.content) return true;
	                if (this.hasScrollbar(el)) return this.shouldScroll(el, delta);
	            }
	            return true;
	        },
	        /**
	         * Polyfill for Event.prototype.composedPath
	         */
	        composedPath: function composedPath(e) {
	            if (e.composedPath) return e.composedPath();
	            var path = [];
	            var el = e.target;
	            while (el) {
	                path.push(el);
	                if (el.tagName === 'HTML') {
	                    path.push(document);
	                    path.push(window);
	                    return path;
	                }
	                el = el.parentElement;
	            }
	            return path;
	        },
	        hideScroll: function hideScroll() {
	            if (this.$vuetify.breakpoint.smAndDown) {
	                document.documentElement.classList.add('overflow-y-hidden');
	            } else {
	                Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__["addPassiveEventListener"])(window, 'wheel', this.scrollListener, { passive: false });
	                window.addEventListener('keydown', this.scrollListener);
	            }
	        },
	        showScroll: function showScroll() {
	            document.documentElement.classList.remove('overflow-y-hidden');
	            window.removeEventListener('wheel', this.scrollListener);
	            window.removeEventListener('keydown', this.scrollListener);
	        }
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/mixins/picker-button.ts":
	/*!*************************************!*\
	  !*** ./src/mixins/picker-button.ts ***!
	  \*************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _colorable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/mixins */ "./src/util/mixins.ts");
	// Mixins
	
	// Utilities
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_1__["default"])(_colorable__WEBPACK_IMPORTED_MODULE_0__["default"]).extend({
	    methods: {
	        genPickerButton: function genPickerButton(prop, value, content, readonly, staticClass) {
	            var _this = this;
	            if (readonly === void 0) {
	                readonly = false;
	            }
	            if (staticClass === void 0) {
	                staticClass = '';
	            }
	            var active = this[prop] === value;
	            var click = function click(event) {
	                event.stopPropagation();
	                _this.$emit("update:" + prop, value);
	            };
	            return this.$createElement('div', {
	                staticClass: ("v-picker__title__btn " + staticClass).trim(),
	                'class': {
	                    'v-picker__title__btn--active': active,
	                    'v-picker__title__btn--readonly': readonly
	                },
	                on: active || readonly ? undefined : { click: click }
	            }, Array.isArray(content) ? content : [content]);
	        }
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/mixins/picker.ts":
	/*!******************************!*\
	  !*** ./src/mixins/picker.ts ***!
	  \******************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _components_VPicker__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../components/VPicker */ "./src/components/VPicker/index.ts");
	/* harmony import */ var _colorable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _themeable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../util/mixins */ "./src/util/mixins.ts");
	// Components
	
	// Mixins
	
	
	// Utils
	
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_3__["default"])(_colorable__WEBPACK_IMPORTED_MODULE_1__["default"], _themeable__WEBPACK_IMPORTED_MODULE_2__["default"]
	/* @vue/component */
	).extend({
	    name: 'picker',
	    props: {
	        fullWidth: Boolean,
	        headerColor: String,
	        landscape: Boolean,
	        noTitle: Boolean,
	        width: {
	            type: [Number, String],
	            default: 290
	        }
	    },
	    methods: {
	        genPickerTitle: function genPickerTitle() {
	            return null;
	        },
	        genPickerBody: function genPickerBody() {
	            return null;
	        },
	        genPickerActionsSlot: function genPickerActionsSlot() {
	            return this.$scopedSlots.default ? this.$scopedSlots.default({
	                save: this.save,
	                cancel: this.cancel
	            }) : this.$slots.default;
	        },
	        genPicker: function genPicker(staticClass) {
	            var children = [];
	            if (!this.noTitle) {
	                var title = this.genPickerTitle();
	                title && children.push(title);
	            }
	            var body = this.genPickerBody();
	            body && children.push(body);
	            children.push(this.$createElement('template', { slot: 'actions' }, [this.genPickerActionsSlot()]));
	            return this.$createElement(_components_VPicker__WEBPACK_IMPORTED_MODULE_0__["default"], {
	                staticClass: staticClass,
	                props: {
	                    color: this.headerColor || this.color,
	                    dark: this.dark,
	                    fullWidth: this.fullWidth,
	                    landscape: this.landscape,
	                    light: this.light,
	                    width: this.width
	                }
	            }, children);
	        }
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/mixins/positionable.ts":
	/*!************************************!*\
	  !*** ./src/mixins/positionable.ts ***!
	  \************************************/
	/*! exports provided: factory, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "factory", function() { return factory; });
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/helpers */ "./src/util/helpers.ts");
	
	
	var availableProps = {
	  absolute: Boolean,
	  bottom: Boolean,
	  fixed: Boolean,
	  left: Boolean,
	  right: Boolean,
	  top: Boolean
	};
	function factory(selected) {
	  if (selected === void 0) {
	    selected = [];
	  }
	  return vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
	    name: 'positionable',
	    props: selected.length ? Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__["filterObjectOnKeys"])(availableProps, selected) : availableProps
	  });
	}
	/* harmony default export */ __webpack_exports__["default"] = (factory());
	// Add a `*` before the second `/`
	/* Tests /
	let single = factory(['top']).extend({
	  created () {
	    this.top
	    this.bottom
	    this.absolute
	  }
	})
	
	let some = factory(['top', 'bottom']).extend({
	  created () {
	    this.top
	    this.bottom
	    this.absolute
	  }
	})
	
	let all = factory().extend({
	  created () {
	    this.top
	    this.bottom
	    this.absolute
	    this.foobar
	  }
	})
	/**/
	
	/***/ }),
	
	/***/ "./src/mixins/proxyable.ts":
	/*!*********************************!*\
	  !*** ./src/mixins/proxyable.ts ***!
	  \*********************************/
	/*! exports provided: factory, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "factory", function() { return factory; });
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
	
	function factory(prop, event) {
	    if (prop === void 0) {
	        prop = 'value';
	    }
	    if (event === void 0) {
	        event = 'change';
	    }
	    var _a, _b;
	    return vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
	        name: 'proxyable',
	        model: {
	            prop: prop,
	            event: event
	        },
	        props: (_a = {}, _a[prop] = {
	            required: false
	        }, _a),
	        data: function data() {
	            return {
	                internalLazyValue: this[prop]
	            };
	        },
	        computed: {
	            internalValue: {
	                get: function get() {
	                    return this.internalLazyValue;
	                },
	                set: function set(val) {
	                    if (val === this.internalLazyValue) return;
	                    this.internalLazyValue = val;
	                    this.$emit(event, val);
	                }
	            }
	        },
	        watch: (_b = {}, _b[prop] = function (val) {
	            this.internalLazyValue = val;
	        }, _b)
	    });
	}
	/* eslint-disable-next-line no-redeclare */
	var Proxyable = factory();
	/* harmony default export */ __webpack_exports__["default"] = (Proxyable);
	
	/***/ }),
	
	/***/ "./src/mixins/registrable.ts":
	/*!***********************************!*\
	  !*** ./src/mixins/registrable.ts ***!
	  \***********************************/
	/*! exports provided: inject, provide */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "inject", function() { return inject; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "provide", function() { return provide; });
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/console */ "./src/util/console.ts");
	
	
	function generateWarning(child, parent) {
	    return function () {
	        return Object(_util_console__WEBPACK_IMPORTED_MODULE_1__["consoleWarn"])("The " + child + " component must be used inside a " + parent);
	    };
	}
	function inject(namespace, child, parent) {
	    var _a;
	    var defaultImpl = child && parent ? {
	        register: generateWarning(child, parent),
	        unregister: generateWarning(child, parent)
	    } : null;
	    return vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
	        name: 'registrable-inject',
	        inject: (_a = {}, _a[namespace] = {
	            default: defaultImpl
	        }, _a)
	    });
	}
	function provide(namespace) {
	    return vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
	        name: 'registrable-provide',
	        methods: {
	            register: null,
	            unregister: null
	        },
	        provide: function provide() {
	            var _a;
	            return _a = {}, _a[namespace] = {
	                register: this.register,
	                unregister: this.unregister
	            }, _a;
	        }
	    });
	}
	
	/***/ }),
	
	/***/ "./src/mixins/returnable.ts":
	/*!**********************************!*\
	  !*** ./src/mixins/returnable.ts ***!
	  \**********************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
	    name: 'returnable',
	    props: {
	        returnValue: null
	    },
	    data: function data() {
	        return {
	            isActive: false,
	            originalValue: null
	        };
	    },
	    watch: {
	        isActive: function isActive(val) {
	            if (val) {
	                this.originalValue = this.returnValue;
	            } else {
	                this.$emit('update:returnValue', this.originalValue);
	            }
	        }
	    },
	    methods: {
	        save: function save(value) {
	            var _this = this;
	            this.originalValue = value;
	            setTimeout(function () {
	                _this.isActive = false;
	            });
	        }
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/mixins/rippleable.ts":
	/*!**********************************!*\
	  !*** ./src/mixins/rippleable.ts ***!
	  \**********************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _directives_ripple__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../directives/ripple */ "./src/directives/ripple.ts");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
	// Directives
	
	// Types
	
	/* harmony default export */ __webpack_exports__["default"] = (vue__WEBPACK_IMPORTED_MODULE_1___default.a.extend({
	    name: 'rippleable',
	    directives: { Ripple: _directives_ripple__WEBPACK_IMPORTED_MODULE_0__["default"] },
	    props: {
	        ripple: {
	            type: [Boolean, Object],
	            default: true
	        }
	    },
	    methods: {
	        genRipple: function genRipple(data) {
	            if (data === void 0) {
	                data = {};
	            }
	            if (!this.ripple) return null;
	            data.staticClass = 'v-input--selection-controls__ripple';
	            data.directives = data.directives || [];
	            data.directives.push({
	                name: 'ripple',
	                value: { center: true }
	            });
	            data.on = Object.assign({
	                click: this.onChange
	            }, this.$listeners);
	            return this.$createElement('div', data);
	        },
	        onChange: function onChange() {}
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/mixins/routable.ts":
	/*!********************************!*\
	  !*** ./src/mixins/routable.ts ***!
	  \********************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _directives_ripple__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../directives/ripple */ "./src/directives/ripple.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	
	
	/* harmony default export */ __webpack_exports__["default"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
	    name: 'routable',
	    directives: {
	        Ripple: _directives_ripple__WEBPACK_IMPORTED_MODULE_1__["default"]
	    },
	    props: {
	        activeClass: String,
	        append: Boolean,
	        disabled: Boolean,
	        exact: {
	            type: Boolean,
	            default: undefined
	        },
	        exactActiveClass: String,
	        href: [String, Object],
	        to: [String, Object],
	        nuxt: Boolean,
	        replace: Boolean,
	        ripple: [Boolean, Object],
	        tag: String,
	        target: String
	    },
	    computed: {
	        computedRipple: function computedRipple() {
	            return this.ripple && !this.disabled ? this.ripple : false;
	        }
	    },
	    methods: {
	        click: function click(e) {
	            this.$emit('click', e);
	        },
	        generateRouteLink: function generateRouteLink(classes) {
	            var _a;
	            var exact = this.exact;
	            var tag;
	            var data = (_a = {
	                attrs: { disabled: this.disabled },
	                class: classes,
	                props: {},
	                directives: [{
	                    name: 'ripple',
	                    value: this.computedRipple
	                }]
	            }, _a[this.to ? 'nativeOn' : 'on'] = __assign({}, this.$listeners, { click: this.click }), _a);
	            if (typeof this.exact === 'undefined') {
	                exact = this.to === '/' || this.to === Object(this.to) && this.to.path === '/';
	            }
	            if (this.to) {
	                // Add a special activeClass hook
	                // for component level styles
	                var activeClass = this.activeClass;
	                var exactActiveClass = this.exactActiveClass || activeClass;
	                // TODO: apply only in VListTile
	                if (this.proxyClass) {
	                    activeClass += ' ' + this.proxyClass;
	                    exactActiveClass += ' ' + this.proxyClass;
	                }
	                tag = this.nuxt ? 'nuxt-link' : 'router-link';
	                Object.assign(data.props, {
	                    to: this.to,
	                    exact: exact,
	                    activeClass: activeClass,
	                    exactActiveClass: exactActiveClass,
	                    append: this.append,
	                    replace: this.replace
	                });
	            } else {
	                tag = this.href && 'a' || this.tag || 'a';
	                if (tag === 'a' && this.href) data.attrs.href = this.href;
	            }
	            if (this.target) data.attrs.target = this.target;
	            return { tag: tag, data: data };
	        }
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/mixins/selectable.js":
	/*!**********************************!*\
	  !*** ./src/mixins/selectable.js ***!
	  \**********************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _components_VInput__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../components/VInput */ "./src/components/VInput/index.ts");
	/* harmony import */ var _rippleable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./rippleable */ "./src/mixins/rippleable.ts");
	/* harmony import */ var _comparable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./comparable */ "./src/mixins/comparable.ts");
	// Components
	
	// Mixins
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (_components_VInput__WEBPACK_IMPORTED_MODULE_0__["default"].extend({
	    name: 'selectable',
	    mixins: [_rippleable__WEBPACK_IMPORTED_MODULE_1__["default"], _comparable__WEBPACK_IMPORTED_MODULE_2__["default"]],
	    model: {
	        prop: 'inputValue',
	        event: 'change'
	    },
	    props: {
	        color: {
	            type: String,
	            default: 'accent'
	        },
	        id: String,
	        inputValue: null,
	        falseValue: null,
	        trueValue: null,
	        multiple: {
	            type: Boolean,
	            default: null
	        },
	        label: String
	    },
	    data: function data(vm) {
	        return {
	            lazyValue: vm.inputValue
	        };
	    },
	    computed: {
	        computedColor: function computedColor() {
	            return this.isActive ? this.color : this.validationState;
	        },
	        isMultiple: function isMultiple() {
	            return this.multiple === true || this.multiple === null && Array.isArray(this.internalValue);
	        },
	        isActive: function isActive() {
	            var _this = this;
	            var value = this.value;
	            var input = this.internalValue;
	            if (this.isMultiple) {
	                if (!Array.isArray(input)) return false;
	                return input.some(function (item) {
	                    return _this.valueComparator(item, value);
	                });
	            }
	            if (this.trueValue === undefined || this.falseValue === undefined) {
	                return value ? this.valueComparator(value, input) : Boolean(input);
	            }
	            return this.valueComparator(input, this.trueValue);
	        },
	        isDirty: function isDirty() {
	            return this.isActive;
	        }
	    },
	    watch: {
	        inputValue: function inputValue(val) {
	            this.lazyValue = val;
	        }
	    },
	    methods: {
	        genLabel: function genLabel() {
	            if (!this.hasLabel) return null;
	            var label = _components_VInput__WEBPACK_IMPORTED_MODULE_0__["default"].options.methods.genLabel.call(this);
	            label.data.on = { click: this.onChange };
	            return label;
	        },
	        genInput: function genInput(type, attrs) {
	            return this.$createElement('input', {
	                attrs: Object.assign({
	                    'aria-label': this.label,
	                    'aria-checked': this.isActive.toString(),
	                    disabled: this.isDisabled,
	                    id: this.id,
	                    role: type,
	                    type: type
	                }, attrs),
	                domProps: {
	                    value: this.value,
	                    checked: this.isActive
	                },
	                on: {
	                    blur: this.onBlur,
	                    change: this.onChange,
	                    focus: this.onFocus,
	                    keydown: this.onKeydown
	                },
	                ref: 'input'
	            });
	        },
	        onBlur: function onBlur() {
	            this.isFocused = false;
	        },
	        onChange: function onChange() {
	            var _this = this;
	            if (this.isDisabled) return;
	            var value = this.value;
	            var input = this.internalValue;
	            if (this.isMultiple) {
	                if (!Array.isArray(input)) {
	                    input = [];
	                }
	                var length = input.length;
	                input = input.filter(function (item) {
	                    return !_this.valueComparator(item, value);
	                });
	                if (input.length === length) {
	                    input.push(value);
	                }
	            } else if (this.trueValue !== undefined && this.falseValue !== undefined) {
	                input = this.valueComparator(input, this.trueValue) ? this.falseValue : this.trueValue;
	            } else if (value) {
	                input = this.valueComparator(input, value) ? null : value;
	            } else {
	                input = !input;
	            }
	            this.validate(true, input);
	            this.internalValue = input;
	        },
	        onFocus: function onFocus() {
	            this.isFocused = true;
	        },
	        /** @abstract */
	        onKeydown: function onKeydown(e) {}
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/mixins/sizeable.ts":
	/*!********************************!*\
	  !*** ./src/mixins/sizeable.ts ***!
	  \********************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
	
	/* harmony default export */ __webpack_exports__["default"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
	    name: 'sizeable',
	    props: {
	        large: Boolean,
	        medium: Boolean,
	        size: {
	            type: [Number, String]
	        },
	        small: Boolean,
	        xLarge: Boolean
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/mixins/ssr-bootable.ts":
	/*!************************************!*\
	  !*** ./src/mixins/ssr-bootable.ts ***!
	  \************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
	
	/**
	 * SSRBootable
	 *
	 * @mixin
	 *
	 * Used in layout components (drawer, toolbar, content)
	 * to avoid an entry animation when using SSR
	 */
	/* harmony default export */ __webpack_exports__["default"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
	    name: 'ssr-bootable',
	    data: function data() {
	        return {
	            isBooted: false
	        };
	    },
	    mounted: function mounted() {
	        var _this = this;
	        // Use setAttribute instead of dataset
	        // because dataset does not work well
	        // with unit tests
	        window.requestAnimationFrame(function () {
	            _this.$el.setAttribute('data-booted', 'true');
	            _this.isBooted = true;
	        });
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/mixins/stackable.ts":
	/*!*********************************!*\
	  !*** ./src/mixins/stackable.ts ***!
	  \*********************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/helpers */ "./src/util/helpers.ts");
	var __read = undefined && undefined.__read || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o),
	        r,
	        ar = [],
	        e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
	            ar.push(r.value);
	        }
	    } catch (error) {
	        e = { error: error };
	    } finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        } finally {
	            if (e) throw e.error;
	        }
	    }
	    return ar;
	};
	var __spread = undefined && undefined.__spread || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) {
	        ar = ar.concat(__read(arguments[i]));
	    }return ar;
	};
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend().extend({
	    name: 'stackable',
	    data: function data() {
	        return {
	            stackClass: 'unpecified',
	            stackElement: null,
	            stackExclude: null,
	            stackMinZIndex: 0,
	            isActive: false
	        };
	    },
	    computed: {
	        activeZIndex: function activeZIndex() {
	            if (typeof window === 'undefined') return 0;
	            var content = this.stackElement || this.$refs.content;
	            // Return current zindex if not active
	            var index = !this.isActive ? Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__["getZIndex"])(content) : this.getMaxZIndex(this.stackExclude || [content]) + 2;
	            if (index == null) return index;
	            // Return max current z-index (excluding self) + 2
	            // (2 to leave room for an overlay below, if needed)
	            return parseInt(index);
	        }
	    },
	    methods: {
	        getMaxZIndex: function getMaxZIndex(exclude) {
	            if (exclude === void 0) {
	                exclude = [];
	            }
	            var base = this.$el;
	            // Start with lowest allowed z-index or z-index of
	            // base component's element, whichever is greater
	            var zis = [this.stackMinZIndex, Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__["getZIndex"])(base)];
	            // Convert the NodeList to an array to
	            // prevent an Edge bug with Symbol.iterator
	            // https://github.com/vuetifyjs/vuetify/issues/2146
	            var activeElements = __spread(document.getElementsByClassName(this.stackClass));
	            // Get z-index for all active dialogs
	            for (var index = 0; index < activeElements.length; index++) {
	                if (!exclude.includes(activeElements[index])) {
	                    zis.push(Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__["getZIndex"])(activeElements[index]));
	                }
	            }
	            return Math.max.apply(Math, __spread(zis));
	        }
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/mixins/themeable.ts":
	/*!*********************************!*\
	  !*** ./src/mixins/themeable.ts ***!
	  \*********************************/
	/*! exports provided: functionalThemeClasses, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "functionalThemeClasses", function() { return functionalThemeClasses; });
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	
	function functionalThemeClasses(context) {
	    var vm = __assign({}, context.props, context.injections);
	    var isDark = Themeable.options.computed.isDark.call(vm);
	    return Themeable.options.computed.themeClasses.call({ isDark: isDark });
	}
	/* @vue/component */
	var Themeable = vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend().extend({
	    name: 'themeable',
	    provide: function provide() {
	        return {
	            theme: this.themeableProvide
	        };
	    },
	    inject: {
	        theme: {
	            default: {
	                isDark: false
	            }
	        }
	    },
	    props: {
	        dark: {
	            type: Boolean,
	            default: null
	        },
	        light: {
	            type: Boolean,
	            default: null
	        }
	    },
	    data: function data() {
	        return {
	            themeableProvide: {
	                isDark: false
	            }
	        };
	    },
	    computed: {
	        isDark: function isDark() {
	            if (this.dark === true) {
	                // explicitly dark
	                return true;
	            } else if (this.light === true) {
	                // explicitly light
	                return false;
	            } else {
	                // inherit from parent, or default false if there is none
	                return this.theme.isDark;
	            }
	        },
	        themeClasses: function themeClasses() {
	            return {
	                'theme--dark': this.isDark,
	                'theme--light': !this.isDark
	            };
	        },
	        /** Used by menus and dialogs, inherits from v-app instead of the parent */
	        rootIsDark: function rootIsDark() {
	            if (this.dark === true) {
	                // explicitly dark
	                return true;
	            } else if (this.light === true) {
	                // explicitly light
	                return false;
	            } else {
	                // inherit from v-app
	                return this.$vuetify.dark;
	            }
	        },
	        rootThemeClasses: function rootThemeClasses() {
	            return {
	                'theme--dark': this.rootIsDark,
	                'theme--light': !this.rootIsDark
	            };
	        }
	    },
	    watch: {
	        isDark: {
	            handler: function handler(newVal, oldVal) {
	                if (newVal !== oldVal) {
	                    this.themeableProvide.isDark = this.isDark;
	                }
	            },
	            immediate: true
	        }
	    }
	});
	/* harmony default export */ __webpack_exports__["default"] = (Themeable);
	
	/***/ }),
	
	/***/ "./src/mixins/toggleable.ts":
	/*!**********************************!*\
	  !*** ./src/mixins/toggleable.ts ***!
	  \**********************************/
	/*! exports provided: factory, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "factory", function() { return factory; });
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
	
	function factory(prop, event) {
	    if (prop === void 0) {
	        prop = 'value';
	    }
	    if (event === void 0) {
	        event = 'input';
	    }
	    var _a, _b;
	    return vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
	        name: 'toggleable',
	        model: { prop: prop, event: event },
	        props: (_a = {}, _a[prop] = { required: false }, _a),
	        data: function data() {
	            return {
	                isActive: !!this[prop]
	            };
	        },
	        watch: (_b = {}, _b[prop] = function (val) {
	            this.isActive = !!val;
	        }, _b.isActive = function (val) {
	            !!val !== this[prop] && this.$emit(event, val);
	        }, _b)
	    });
	}
	/* eslint-disable-next-line no-redeclare */
	var Toggleable = factory();
	/* harmony default export */ __webpack_exports__["default"] = (Toggleable);
	
	/***/ }),
	
	/***/ "./src/mixins/transitionable.ts":
	/*!**************************************!*\
	  !*** ./src/mixins/transitionable.ts ***!
	  \**************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
	
	/* harmony default export */ __webpack_exports__["default"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
	    name: 'transitionable',
	    props: {
	        mode: String,
	        origin: String,
	        transition: String
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/mixins/translatable.ts":
	/*!************************************!*\
	  !*** ./src/mixins/translatable.ts ***!
	  \************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
	
	/* harmony default export */ __webpack_exports__["default"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
	    name: 'translatable',
	    props: {
	        height: Number
	    },
	    data: function data() {
	        return {
	            elOffsetTop: 0,
	            parallax: 0,
	            parallaxDist: 0,
	            percentScrolled: 0,
	            scrollTop: 0,
	            windowHeight: 0,
	            windowBottom: 0
	        };
	    },
	    computed: {
	        imgHeight: function imgHeight() {
	            return this.objHeight();
	        }
	    },
	    beforeDestroy: function beforeDestroy() {
	        window.removeEventListener('scroll', this.translate, false);
	        window.removeEventListener('resize', this.translate, false);
	    },
	    methods: {
	        calcDimensions: function calcDimensions() {
	            var offset = this.$el.getBoundingClientRect();
	            this.scrollTop = window.pageYOffset;
	            this.parallaxDist = this.imgHeight - this.height;
	            this.elOffsetTop = offset.top + this.scrollTop;
	            this.windowHeight = window.innerHeight;
	            this.windowBottom = this.scrollTop + this.windowHeight;
	        },
	        listeners: function listeners() {
	            window.addEventListener('scroll', this.translate, false);
	            window.addEventListener('resize', this.translate, false);
	        },
	        /** @abstract **/
	        objHeight: function objHeight() {
	            throw new Error('Not implemented !');
	        },
	        translate: function translate() {
	            this.calcDimensions();
	            this.percentScrolled = (this.windowBottom - this.elOffsetTop) / (parseInt(this.height) + this.windowHeight);
	            this.parallax = Math.round(this.parallaxDist * this.percentScrolled);
	        }
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/mixins/validatable.ts":
	/*!***********************************!*\
	  !*** ./src/mixins/validatable.ts ***!
	  \***********************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _colorable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _registrable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./registrable */ "./src/mixins/registrable.ts");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../util/console */ "./src/util/console.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../util/mixins */ "./src/util/mixins.ts");
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// Mixins
	
	
	// Utilities
	
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_4__["default"])(_colorable__WEBPACK_IMPORTED_MODULE_0__["default"], Object(_registrable__WEBPACK_IMPORTED_MODULE_1__["inject"])('form')).extend({
	    name: 'validatable',
	    props: {
	        disabled: Boolean,
	        error: Boolean,
	        errorCount: {
	            type: [Number, String],
	            default: 1
	        },
	        errorMessages: {
	            type: [String, Array],
	            default: function _default() {
	                return [];
	            }
	        },
	        messages: {
	            type: [String, Array],
	            default: function _default() {
	                return [];
	            }
	        },
	        readonly: Boolean,
	        rules: {
	            type: Array,
	            default: function _default() {
	                return [];
	            }
	        },
	        success: Boolean,
	        successMessages: {
	            type: [String, Array],
	            default: function _default() {
	                return [];
	            }
	        },
	        validateOnBlur: Boolean,
	        value: { required: false }
	    },
	    data: function data() {
	        return {
	            errorBucket: [],
	            hasColor: false,
	            hasFocused: false,
	            hasInput: false,
	            isFocused: false,
	            isResetting: false,
	            lazyValue: this.value,
	            valid: false
	        };
	    },
	    computed: {
	        hasError: function hasError() {
	            return this.internalErrorMessages.length > 0 || this.errorBucket.length > 0 || this.error;
	        },
	        // TODO: Add logic that allows the user to enable based
	        // upon a good validation
	        hasSuccess: function hasSuccess() {
	            return this.internalSuccessMessages.length > 0 || this.success;
	        },
	        externalError: function externalError() {
	            return this.internalErrorMessages.length > 0 || this.error;
	        },
	        hasMessages: function hasMessages() {
	            return this.validationTarget.length > 0;
	        },
	        hasState: function hasState() {
	            return this.hasSuccess || this.shouldValidate && this.hasError;
	        },
	        internalErrorMessages: function internalErrorMessages() {
	            return this.genInternalMessages(this.errorMessages);
	        },
	        internalMessages: function internalMessages() {
	            return this.genInternalMessages(this.messages);
	        },
	        internalSuccessMessages: function internalSuccessMessages() {
	            return this.genInternalMessages(this.successMessages);
	        },
	        internalValue: {
	            get: function get() {
	                return this.lazyValue;
	            },
	            set: function set(val) {
	                this.lazyValue = val;
	                this.$emit('input', val);
	            }
	        },
	        shouldValidate: function shouldValidate() {
	            if (this.externalError) return true;
	            if (this.isResetting) return false;
	            return this.validateOnBlur ? this.hasFocused && !this.isFocused : this.hasInput || this.hasFocused;
	        },
	        validations: function validations() {
	            return this.validationTarget.slice(0, Number(this.errorCount));
	        },
	        validationState: function validationState() {
	            if (this.hasError && this.shouldValidate) return 'error';
	            if (this.hasSuccess) return 'success';
	            if (this.hasColor) return this.color;
	            return undefined;
	        },
	        validationTarget: function validationTarget() {
	            if (this.internalErrorMessages.length > 0) {
	                return this.internalErrorMessages;
	            } else if (this.successMessages.length > 0) {
	                return this.internalSuccessMessages;
	            } else if (this.messages.length > 0) {
	                return this.internalMessages;
	            } else if (this.shouldValidate) {
	                return this.errorBucket;
	            } else return [];
	        }
	    },
	    watch: {
	        rules: {
	            handler: function handler(newVal, oldVal) {
	                if (Object(_util_helpers__WEBPACK_IMPORTED_MODULE_2__["deepEqual"])(newVal, oldVal)) return;
	                this.validate();
	            },
	            deep: true
	        },
	        internalValue: function internalValue() {
	            // If it's the first time we're setting input,
	            // mark it with hasInput
	            this.hasInput = true;
	            this.validateOnBlur || this.$nextTick(this.validate);
	        },
	        isFocused: function isFocused(val) {
	            // Should not check validation
	            // if disabled or readonly
	            if (!val && !this.disabled && !this.readonly) {
	                this.hasFocused = true;
	                this.validateOnBlur && this.validate();
	            }
	        },
	        isResetting: function isResetting() {
	            var _this = this;
	            setTimeout(function () {
	                _this.hasInput = false;
	                _this.hasFocused = false;
	                _this.isResetting = false;
	                _this.validate();
	            }, 0);
	        },
	        hasError: function hasError(val) {
	            if (this.shouldValidate) {
	                this.$emit('update:error', val);
	            }
	        },
	        value: function value(val) {
	            this.lazyValue = val;
	        }
	    },
	    beforeMount: function beforeMount() {
	        this.validate();
	    },
	    created: function created() {
	        this.form && this.form.register(this);
	    },
	    beforeDestroy: function beforeDestroy() {
	        this.form && this.form.unregister(this);
	    },
	    methods: {
	        genInternalMessages: function genInternalMessages(messages) {
	            if (!messages) return [];else if (Array.isArray(messages)) return messages;else return [messages];
	        },
	        /** @public */
	        reset: function reset() {
	            this.isResetting = true;
	            this.internalValue = Array.isArray(this.internalValue) ? [] : undefined;
	        },
	        /** @public */
	        resetValidation: function resetValidation() {
	            this.isResetting = true;
	        },
	        /** @public */
	        validate: function validate(force, value) {
	            if (force === void 0) {
	                force = false;
	            }
	            var errorBucket = [];
	            value = value || this.internalValue;
	            if (force) this.hasInput = this.hasFocused = true;
	            for (var index = 0; index < this.rules.length; index++) {
	                var rule = this.rules[index];
	                var valid = typeof rule === 'function' ? rule(value) : rule;
	                if (typeof valid === 'string') {
	                    errorBucket.push(valid);
	                } else if (typeof valid !== 'boolean') {
	                    Object(_util_console__WEBPACK_IMPORTED_MODULE_3__["consoleError"])("Rules should return a string or boolean, received '" + (typeof valid === 'undefined' ? 'undefined' : _typeof(valid)) + "' instead", this);
	                }
	            }
	            this.errorBucket = errorBucket;
	            this.valid = errorBucket.length === 0;
	            return this.valid;
	        }
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/stylus/app.styl":
	/*!*****************************!*\
	  !*** ./src/stylus/app.styl ***!
	  \*****************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_alerts.styl":
	/*!********************************************!*\
	  !*** ./src/stylus/components/_alerts.styl ***!
	  \********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_app.styl":
	/*!*****************************************!*\
	  !*** ./src/stylus/components/_app.styl ***!
	  \*****************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_autocompletes.styl":
	/*!***************************************************!*\
	  !*** ./src/stylus/components/_autocompletes.styl ***!
	  \***************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_avatars.styl":
	/*!*********************************************!*\
	  !*** ./src/stylus/components/_avatars.styl ***!
	  \*********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_badges.styl":
	/*!********************************************!*\
	  !*** ./src/stylus/components/_badges.styl ***!
	  \********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_bottom-navs.styl":
	/*!*************************************************!*\
	  !*** ./src/stylus/components/_bottom-navs.styl ***!
	  \*************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_bottom-sheets.styl":
	/*!***************************************************!*\
	  !*** ./src/stylus/components/_bottom-sheets.styl ***!
	  \***************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_breadcrumbs.styl":
	/*!*************************************************!*\
	  !*** ./src/stylus/components/_breadcrumbs.styl ***!
	  \*************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_button-toggle.styl":
	/*!***************************************************!*\
	  !*** ./src/stylus/components/_button-toggle.styl ***!
	  \***************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_buttons.styl":
	/*!*********************************************!*\
	  !*** ./src/stylus/components/_buttons.styl ***!
	  \*********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_calendar-daily.styl":
	/*!****************************************************!*\
	  !*** ./src/stylus/components/_calendar-daily.styl ***!
	  \****************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_calendar-weekly.styl":
	/*!*****************************************************!*\
	  !*** ./src/stylus/components/_calendar-weekly.styl ***!
	  \*****************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_cards.styl":
	/*!*******************************************!*\
	  !*** ./src/stylus/components/_cards.styl ***!
	  \*******************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_carousel.styl":
	/*!**********************************************!*\
	  !*** ./src/stylus/components/_carousel.styl ***!
	  \**********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_chips.styl":
	/*!*******************************************!*\
	  !*** ./src/stylus/components/_chips.styl ***!
	  \*******************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_content.styl":
	/*!*********************************************!*\
	  !*** ./src/stylus/components/_content.styl ***!
	  \*********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_counters.styl":
	/*!**********************************************!*\
	  !*** ./src/stylus/components/_counters.styl ***!
	  \**********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_data-iterator.styl":
	/*!***************************************************!*\
	  !*** ./src/stylus/components/_data-iterator.styl ***!
	  \***************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_data-table.styl":
	/*!************************************************!*\
	  !*** ./src/stylus/components/_data-table.styl ***!
	  \************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_date-picker-header.styl":
	/*!********************************************************!*\
	  !*** ./src/stylus/components/_date-picker-header.styl ***!
	  \********************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_date-picker-table.styl":
	/*!*******************************************************!*\
	  !*** ./src/stylus/components/_date-picker-table.styl ***!
	  \*******************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_date-picker-title.styl":
	/*!*******************************************************!*\
	  !*** ./src/stylus/components/_date-picker-title.styl ***!
	  \*******************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_date-picker-years.styl":
	/*!*******************************************************!*\
	  !*** ./src/stylus/components/_date-picker-years.styl ***!
	  \*******************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_dialogs.styl":
	/*!*********************************************!*\
	  !*** ./src/stylus/components/_dialogs.styl ***!
	  \*********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_dividers.styl":
	/*!**********************************************!*\
	  !*** ./src/stylus/components/_dividers.styl ***!
	  \**********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_expansion-panel.styl":
	/*!*****************************************************!*\
	  !*** ./src/stylus/components/_expansion-panel.styl ***!
	  \*****************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_footer.styl":
	/*!********************************************!*\
	  !*** ./src/stylus/components/_footer.styl ***!
	  \********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_forms.styl":
	/*!*******************************************!*\
	  !*** ./src/stylus/components/_forms.styl ***!
	  \*******************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_grid.styl":
	/*!******************************************!*\
	  !*** ./src/stylus/components/_grid.styl ***!
	  \******************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_icons.styl":
	/*!*******************************************!*\
	  !*** ./src/stylus/components/_icons.styl ***!
	  \*******************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_images.styl":
	/*!********************************************!*\
	  !*** ./src/stylus/components/_images.styl ***!
	  \********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_inputs.styl":
	/*!********************************************!*\
	  !*** ./src/stylus/components/_inputs.styl ***!
	  \********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_item-group.styl":
	/*!************************************************!*\
	  !*** ./src/stylus/components/_item-group.styl ***!
	  \************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_jumbotrons.styl":
	/*!************************************************!*\
	  !*** ./src/stylus/components/_jumbotrons.styl ***!
	  \************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_labels.styl":
	/*!********************************************!*\
	  !*** ./src/stylus/components/_labels.styl ***!
	  \********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_lists.styl":
	/*!*******************************************!*\
	  !*** ./src/stylus/components/_lists.styl ***!
	  \*******************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_menus.styl":
	/*!*******************************************!*\
	  !*** ./src/stylus/components/_menus.styl ***!
	  \*******************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_messages.styl":
	/*!**********************************************!*\
	  !*** ./src/stylus/components/_messages.styl ***!
	  \**********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_navigation-drawer.styl":
	/*!*******************************************************!*\
	  !*** ./src/stylus/components/_navigation-drawer.styl ***!
	  \*******************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_overflow-buttons.styl":
	/*!******************************************************!*\
	  !*** ./src/stylus/components/_overflow-buttons.styl ***!
	  \******************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_overlay.styl":
	/*!*********************************************!*\
	  !*** ./src/stylus/components/_overlay.styl ***!
	  \*********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_pagination.styl":
	/*!************************************************!*\
	  !*** ./src/stylus/components/_pagination.styl ***!
	  \************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_parallax.styl":
	/*!**********************************************!*\
	  !*** ./src/stylus/components/_parallax.styl ***!
	  \**********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_pickers.styl":
	/*!*********************************************!*\
	  !*** ./src/stylus/components/_pickers.styl ***!
	  \*********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_progress-circular.styl":
	/*!*******************************************************!*\
	  !*** ./src/stylus/components/_progress-circular.styl ***!
	  \*******************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_progress-linear.styl":
	/*!*****************************************************!*\
	  !*** ./src/stylus/components/_progress-linear.styl ***!
	  \*****************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_radio-group.styl":
	/*!*************************************************!*\
	  !*** ./src/stylus/components/_radio-group.styl ***!
	  \*************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_radios.styl":
	/*!********************************************!*\
	  !*** ./src/stylus/components/_radios.styl ***!
	  \********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_range-sliders.styl":
	/*!***************************************************!*\
	  !*** ./src/stylus/components/_range-sliders.styl ***!
	  \***************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_rating.styl":
	/*!********************************************!*\
	  !*** ./src/stylus/components/_rating.styl ***!
	  \********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_responsive.styl":
	/*!************************************************!*\
	  !*** ./src/stylus/components/_responsive.styl ***!
	  \************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_select.styl":
	/*!********************************************!*\
	  !*** ./src/stylus/components/_select.styl ***!
	  \********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_selection-controls.styl":
	/*!********************************************************!*\
	  !*** ./src/stylus/components/_selection-controls.styl ***!
	  \********************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_sheet.styl":
	/*!*******************************************!*\
	  !*** ./src/stylus/components/_sheet.styl ***!
	  \*******************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_sliders.styl":
	/*!*********************************************!*\
	  !*** ./src/stylus/components/_sliders.styl ***!
	  \*********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_small-dialog.styl":
	/*!**************************************************!*\
	  !*** ./src/stylus/components/_small-dialog.styl ***!
	  \**************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_snackbars.styl":
	/*!***********************************************!*\
	  !*** ./src/stylus/components/_snackbars.styl ***!
	  \***********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_speed-dial.styl":
	/*!************************************************!*\
	  !*** ./src/stylus/components/_speed-dial.styl ***!
	  \************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_steppers.styl":
	/*!**********************************************!*\
	  !*** ./src/stylus/components/_steppers.styl ***!
	  \**********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_subheaders.styl":
	/*!************************************************!*\
	  !*** ./src/stylus/components/_subheaders.styl ***!
	  \************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_switch.styl":
	/*!********************************************!*\
	  !*** ./src/stylus/components/_switch.styl ***!
	  \********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_system-bars.styl":
	/*!*************************************************!*\
	  !*** ./src/stylus/components/_system-bars.styl ***!
	  \*************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_tables.styl":
	/*!********************************************!*\
	  !*** ./src/stylus/components/_tables.styl ***!
	  \********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_tabs.styl":
	/*!******************************************!*\
	  !*** ./src/stylus/components/_tabs.styl ***!
	  \******************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_text-fields.styl":
	/*!*************************************************!*\
	  !*** ./src/stylus/components/_text-fields.styl ***!
	  \*************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_textarea.styl":
	/*!**********************************************!*\
	  !*** ./src/stylus/components/_textarea.styl ***!
	  \**********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_time-picker-clock.styl":
	/*!*******************************************************!*\
	  !*** ./src/stylus/components/_time-picker-clock.styl ***!
	  \*******************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_time-picker-title.styl":
	/*!*******************************************************!*\
	  !*** ./src/stylus/components/_time-picker-title.styl ***!
	  \*******************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_timeline.styl":
	/*!**********************************************!*\
	  !*** ./src/stylus/components/_timeline.styl ***!
	  \**********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_toolbar.styl":
	/*!*********************************************!*\
	  !*** ./src/stylus/components/_toolbar.styl ***!
	  \*********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_tooltips.styl":
	/*!**********************************************!*\
	  !*** ./src/stylus/components/_tooltips.styl ***!
	  \**********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_treeview.styl":
	/*!**********************************************!*\
	  !*** ./src/stylus/components/_treeview.styl ***!
	  \**********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_windows.styl":
	/*!*********************************************!*\
	  !*** ./src/stylus/components/_windows.styl ***!
	  \*********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/util/ThemeProvider.ts":
	/*!***********************************!*\
	  !*** ./src/util/ThemeProvider.ts ***!
	  \***********************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _mixins__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./mixins */ "./src/util/mixins.ts");
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (Object(_mixins__WEBPACK_IMPORTED_MODULE_1__["default"])(_mixins_themeable__WEBPACK_IMPORTED_MODULE_0__["default"]).extend({
	    name: 'theme-provider',
	    props: {
	        root: Boolean
	    },
	    computed: {
	        isDark: function isDark() {
	            return this.root ? this.rootIsDark : _mixins_themeable__WEBPACK_IMPORTED_MODULE_0__["default"].options.computed.isDark.call(this);
	        }
	    },
	    render: function render() {
	        return this.$slots.default && this.$slots.default.find(function (node) {
	            return !node.isComment && node.text !== ' ';
	        });
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/util/color/transformCIELAB.ts":
	/*!*******************************************!*\
	  !*** ./src/util/color/transformCIELAB.ts ***!
	  \*******************************************/
	/*! exports provided: fromXYZ, toXYZ */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fromXYZ", function() { return fromXYZ; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toXYZ", function() { return toXYZ; });
	var delta = 0.20689655172413793; // 6÷29
	var cielabForwardTransform = function cielabForwardTransform(t) {
	    return t > Math.pow(delta, 3) ? Math.cbrt(t) : t / (3 * Math.pow(delta, 2)) + 4 / 29;
	};
	var cielabReverseTransform = function cielabReverseTransform(t) {
	    return t > delta ? Math.pow(t, 3) : 3 * Math.pow(delta, 2) * (t - 4 / 29);
	};
	function fromXYZ(xyz) {
	    var transform = cielabForwardTransform;
	    var transformedY = transform(xyz[1]);
	    return [116 * transformedY - 16, 500 * (transform(xyz[0] / 0.95047) - transformedY), 200 * (transformedY - transform(xyz[2] / 1.08883))];
	}
	function toXYZ(lab) {
	    var transform = cielabReverseTransform;
	    var Ln = (lab[0] + 16) / 116;
	    return [transform(Ln + lab[1] / 500) * 0.95047, transform(Ln), transform(Ln - lab[2] / 200) * 1.08883];
	}
	
	/***/ }),
	
	/***/ "./src/util/color/transformSRGB.ts":
	/*!*****************************************!*\
	  !*** ./src/util/color/transformSRGB.ts ***!
	  \*****************************************/
	/*! exports provided: fromXYZ, toXYZ */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fromXYZ", function() { return fromXYZ; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toXYZ", function() { return toXYZ; });
	// For converting XYZ to sRGB
	var srgbForwardMatrix = [[3.2406, -1.5372, -0.4986], [-0.9689, 1.8758, 0.0415], [0.0557, -0.2040, 1.0570]];
	// Forward gamma adjust
	var srgbForwardTransform = function srgbForwardTransform(C) {
	    return C <= 0.0031308 ? C * 12.92 : 1.055 * Math.pow(C, 1 / 2.4) - 0.055;
	};
	// For converting sRGB to XYZ
	var srgbReverseMatrix = [[0.4124, 0.3576, 0.1805], [0.2126, 0.7152, 0.0722], [0.0193, 0.1192, 0.9505]];
	// Reverse gamma adjust
	var srgbReverseTransform = function srgbReverseTransform(C) {
	    return C <= 0.04045 ? C / 12.92 : Math.pow((C + 0.055) / 1.055, 2.4);
	};
	function clamp(value) {
	    return Math.max(0, Math.min(1, value));
	}
	function fromXYZ(xyz) {
	    var rgb = Array(3);
	    var transform = srgbForwardTransform;
	    var matrix = srgbForwardMatrix;
	    // Matrix transform, then gamma adjustment
	    for (var i = 0; i < 3; ++i) {
	        rgb[i] = Math.round(clamp(transform(matrix[i][0] * xyz[0] + matrix[i][1] * xyz[1] + matrix[i][2] * xyz[2])) * 255);
	    }
	    // Rescale back to [0, 255]
	    return (rgb[0] << 16) + (rgb[1] << 8) + (rgb[2] << 0);
	}
	function toXYZ(rgb) {
	    var xyz = [0, 0, 0];
	    var transform = srgbReverseTransform;
	    var matrix = srgbReverseMatrix;
	    // Rescale from [0, 255] to [0, 1] then adjust sRGB gamma to linear RGB
	    var r = transform((rgb >> 16 & 0xff) / 255);
	    var g = transform((rgb >> 8 & 0xff) / 255);
	    var b = transform((rgb >> 0 & 0xff) / 255);
	    // Matrix color space transform
	    for (var i = 0; i < 3; ++i) {
	        xyz[i] = matrix[i][0] * r + matrix[i][1] * g + matrix[i][2] * b;
	    }
	    return xyz;
	}
	
	/***/ }),
	
	/***/ "./src/util/colorUtils.ts":
	/*!********************************!*\
	  !*** ./src/util/colorUtils.ts ***!
	  \********************************/
	/*! exports provided: colorToInt, intToHex, colorToHex */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorToInt", function() { return colorToInt; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "intToHex", function() { return intToHex; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorToHex", function() { return colorToHex; });
	/* harmony import */ var _console__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./console */ "./src/util/console.ts");
	
	function colorToInt(color) {
	    var rgb;
	    if (typeof color === 'number') {
	        rgb = color;
	    } else if (typeof color === 'string') {
	        var c = color[0] === '#' ? color.substring(1) : color;
	        if (c.length === 3) {
	            c = c.split('').map(function (char) {
	                return char + char;
	            }).join('');
	        }
	        if (c.length !== 6) {
	            Object(_console__WEBPACK_IMPORTED_MODULE_0__["consoleWarn"])("'" + color + "' is not a valid rgb color");
	        }
	        rgb = parseInt(c, 16);
	    } else {
	        throw new TypeError("Colors can only be numbers or strings, recieved " + (color == null ? color : color.constructor.name) + " instead");
	    }
	    if (rgb < 0) {
	        Object(_console__WEBPACK_IMPORTED_MODULE_0__["consoleWarn"])("Colors cannot be negative: '" + color + "'");
	        rgb = 0;
	    } else if (rgb > 0xffffff || isNaN(rgb)) {
	        Object(_console__WEBPACK_IMPORTED_MODULE_0__["consoleWarn"])("'" + color + "' is not a valid rgb color");
	        rgb = 0xffffff;
	    }
	    return rgb;
	}
	function intToHex(color) {
	    var hexColor = color.toString(16);
	    if (hexColor.length < 6) hexColor = '0'.repeat(6 - hexColor.length) + hexColor;
	    return '#' + hexColor;
	}
	function colorToHex(color) {
	    return intToHex(colorToInt(color));
	}
	
	/***/ }),
	
	/***/ "./src/util/console.ts":
	/*!*****************************!*\
	  !*** ./src/util/console.ts ***!
	  \*****************************/
	/*! exports provided: consoleInfo, consoleWarn, consoleError, deprecate */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "consoleInfo", function() { return consoleInfo; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "consoleWarn", function() { return consoleWarn; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "consoleError", function() { return consoleError; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deprecate", function() { return deprecate; });
	function createMessage(message, vm, parent) {
	    if (parent) {
	        vm = {
	            _isVue: true,
	            $parent: parent,
	            $options: vm
	        };
	    }
	    if (vm) {
	        // Only show each message once per instance
	        vm.$_alreadyWarned = vm.$_alreadyWarned || [];
	        if (vm.$_alreadyWarned.includes(message)) return;
	        vm.$_alreadyWarned.push(message);
	    }
	    return "[Vuetify] " + message + (vm ? generateComponentTrace(vm) : '');
	}
	function consoleInfo(message, vm, parent) {
	    var newMessage = createMessage(message, vm, parent);
	    newMessage != null && console.info(newMessage);
	}
	function consoleWarn(message, vm, parent) {
	    var newMessage = createMessage(message, vm, parent);
	    newMessage != null && console.warn(newMessage);
	}
	function consoleError(message, vm, parent) {
	    var newMessage = createMessage(message, vm, parent);
	    newMessage != null && console.error(newMessage);
	}
	function deprecate(original, replacement, vm, parent) {
	    consoleWarn("'" + original + "' is deprecated, use '" + replacement + "' instead", vm, parent);
	}
	/**
	 * Shamelessly stolen from vuejs/vue/blob/dev/src/core/util/debug.js
	 */
	var classifyRE = /(?:^|[-_])(\w)/g;
	var classify = function classify(str) {
	    return str.replace(classifyRE, function (c) {
	        return c.toUpperCase();
	    }).replace(/[-_]/g, '');
	};
	function formatComponentName(vm, includeFile) {
	    if (vm.$root === vm) {
	        return '<Root>';
	    }
	    var options = typeof vm === 'function' && vm.cid != null ? vm.options : vm._isVue ? vm.$options || vm.constructor.options : vm || {};
	    var name = options.name || options._componentTag;
	    var file = options.__file;
	    if (!name && file) {
	        var match = file.match(/([^/\\]+)\.vue$/);
	        name = match && match[1];
	    }
	    return (name ? "<" + classify(name) + ">" : "<Anonymous>") + (file && includeFile !== false ? " at " + file : '');
	}
	function generateComponentTrace(vm) {
	    if (vm._isVue && vm.$parent) {
	        var tree = [];
	        var currentRecursiveSequence = 0;
	        while (vm) {
	            if (tree.length > 0) {
	                var last = tree[tree.length - 1];
	                if (last.constructor === vm.constructor) {
	                    currentRecursiveSequence++;
	                    vm = vm.$parent;
	                    continue;
	                } else if (currentRecursiveSequence > 0) {
	                    tree[tree.length - 1] = [last, currentRecursiveSequence];
	                    currentRecursiveSequence = 0;
	                }
	            }
	            tree.push(vm);
	            vm = vm.$parent;
	        }
	        return '\n\nfound in\n\n' + tree.map(function (vm, i) {
	            return "" + (i === 0 ? '---> ' : ' '.repeat(5 + i * 2)) + (Array.isArray(vm) ? formatComponentName(vm[0]) + "... (" + vm[1] + " recursive calls)" : formatComponentName(vm));
	        }).join('\n');
	    } else {
	        return "\n\n(found in " + formatComponentName(vm) + ")";
	    }
	}
	
	/***/ }),
	
	/***/ "./src/util/dedupeModelListeners.ts":
	/*!******************************************!*\
	  !*** ./src/util/dedupeModelListeners.ts ***!
	  \******************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return dedupeModelListeners; });
	/**
	 * Removes duplicate `@input` listeners when
	 * using v-model with functional components
	 *
	 * @see https://github.com/vuetifyjs/vuetify/issues/4460
	 */
	function dedupeModelListeners(data) {
	    if (data.model && data.on && data.on.input) {
	        if (Array.isArray(data.on.input)) {
	            var i = data.on.input.indexOf(data.model.callback);
	            if (i > -1) data.on.input.splice(i, 1);
	        } else {
	            delete data.on.input;
	        }
	    }
	}
	
	/***/ }),
	
	/***/ "./src/util/helpers.ts":
	/*!*****************************!*\
	  !*** ./src/util/helpers.ts ***!
	  \*****************************/
	/*! exports provided: createSimpleFunctional, createSimpleTransition, createJavaScriptTransition, directiveConfig, addOnceEventListener, passiveSupported, addPassiveEventListener, getNestedValue, deepEqual, getObjectValueByPath, getPropertyFromItem, createRange, getZIndex, escapeHTML, filterObjectOnKeys, filterChildren, convertToUnit, kebabCase, isObject, keyCodes, remapInternalIcon, keys, camelize, arrayDiff, upperFirst, getSlotType */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createSimpleFunctional", function() { return createSimpleFunctional; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createSimpleTransition", function() { return createSimpleTransition; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createJavaScriptTransition", function() { return createJavaScriptTransition; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "directiveConfig", function() { return directiveConfig; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addOnceEventListener", function() { return addOnceEventListener; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "passiveSupported", function() { return passiveSupported; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addPassiveEventListener", function() { return addPassiveEventListener; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getNestedValue", function() { return getNestedValue; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deepEqual", function() { return deepEqual; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getObjectValueByPath", function() { return getObjectValueByPath; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPropertyFromItem", function() { return getPropertyFromItem; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createRange", function() { return createRange; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getZIndex", function() { return getZIndex; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "escapeHTML", function() { return escapeHTML; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "filterObjectOnKeys", function() { return filterObjectOnKeys; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "filterChildren", function() { return filterChildren; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "convertToUnit", function() { return convertToUnit; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "kebabCase", function() { return kebabCase; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isObject", function() { return isObject; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "keyCodes", function() { return keyCodes; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "remapInternalIcon", function() { return remapInternalIcon; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "keys", function() { return keys; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "camelize", function() { return camelize; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arrayDiff", function() { return arrayDiff; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "upperFirst", function() { return upperFirst; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSlotType", function() { return getSlotType; });
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	
	function createSimpleFunctional(c, el, name) {
	    if (el === void 0) {
	        el = 'div';
	    }
	    return vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
	        name: name || c.replace(/__/g, '-'),
	        functional: true,
	        render: function render(h, _a) {
	            var data = _a.data,
	                children = _a.children;
	            data.staticClass = (c + " " + (data.staticClass || '')).trim();
	            return h(el, data, children);
	        }
	    });
	}
	function mergeTransitions(transitions, array) {
	    if (Array.isArray(transitions)) return transitions.concat(array);
	    if (transitions) array.push(transitions);
	    return array;
	}
	function createSimpleTransition(name, origin, mode) {
	    if (origin === void 0) {
	        origin = 'top center 0';
	    }
	    return {
	        name: name,
	        functional: true,
	        props: {
	            group: {
	                type: Boolean,
	                default: false
	            },
	            hideOnLeave: {
	                type: Boolean,
	                default: false
	            },
	            leaveAbsolute: {
	                type: Boolean,
	                default: false
	            },
	            mode: {
	                type: String,
	                default: mode
	            },
	            origin: {
	                type: String,
	                default: origin
	            }
	        },
	        render: function render(h, context) {
	            var tag = "transition" + (context.props.group ? '-group' : '');
	            context.data = context.data || {};
	            context.data.props = {
	                name: name,
	                mode: context.props.mode
	            };
	            context.data.on = context.data.on || {};
	            if (!Object.isExtensible(context.data.on)) {
	                context.data.on = __assign({}, context.data.on);
	            }
	            var ourBeforeEnter = [];
	            var ourLeave = [];
	            var absolute = function absolute(el) {
	                return el.style.position = 'absolute';
	            };
	            ourBeforeEnter.push(function (el) {
	                el.style.transformOrigin = context.props.origin;
	                el.style.webkitTransformOrigin = context.props.origin;
	            });
	            if (context.props.leaveAbsolute) ourLeave.push(absolute);
	            if (context.props.hideOnLeave) {
	                ourLeave.push(function (el) {
	                    return el.style.display = 'none';
	                });
	            }
	            var _a = context.data.on,
	                beforeEnter = _a.beforeEnter,
	                leave = _a.leave;
	            // Type says Function | Function[] but
	            // will only work if provided a function
	            context.data.on.beforeEnter = function () {
	                return mergeTransitions(beforeEnter, ourBeforeEnter);
	            };
	            context.data.on.leave = mergeTransitions(leave, ourLeave);
	            return h(tag, context.data, context.children);
	        }
	    };
	}
	function createJavaScriptTransition(name, functions, mode) {
	    if (mode === void 0) {
	        mode = 'in-out';
	    }
	    return {
	        name: name,
	        functional: true,
	        props: {
	            mode: {
	                type: String,
	                default: mode
	            }
	        },
	        render: function render(h, context) {
	            var data = {
	                props: __assign({}, context.props, { name: name }),
	                on: functions
	            };
	            return h('transition', data, context.children);
	        }
	    };
	}
	function directiveConfig(binding, defaults) {
	    if (defaults === void 0) {
	        defaults = {};
	    }
	    return __assign({}, defaults, binding.modifiers, { value: binding.arg }, binding.value || {});
	}
	function addOnceEventListener(el, event, cb) {
	    var once = function once() {
	        cb();
	        el.removeEventListener(event, once, false);
	    };
	    el.addEventListener(event, once, false);
	}
	var passiveSupported = false;
	try {
	    if (typeof window !== 'undefined') {
	        var testListenerOpts = Object.defineProperty({}, 'passive', {
	            get: function get() {
	                passiveSupported = true;
	            }
	        });
	        window.addEventListener('testListener', testListenerOpts, testListenerOpts);
	        window.removeEventListener('testListener', testListenerOpts, testListenerOpts);
	    }
	} catch (e) {
	    console.warn(e);
	}
	
	function addPassiveEventListener(el, event, cb, options) {
	    el.addEventListener(event, cb, passiveSupported ? options : false);
	}
	function getNestedValue(obj, path, fallback) {
	    var last = path.length - 1;
	    if (last < 0) return obj === undefined ? fallback : obj;
	    for (var i = 0; i < last; i++) {
	        if (obj == null) {
	            return fallback;
	        }
	        obj = obj[path[i]];
	    }
	    if (obj == null) return fallback;
	    return obj[path[last]] === undefined ? fallback : obj[path[last]];
	}
	function deepEqual(a, b) {
	    if (a === b) return true;
	    if (a instanceof Date && b instanceof Date) {
	        // If the values are Date, they were convert to timestamp with getTime and compare it
	        if (a.getTime() !== b.getTime()) return false;
	    }
	    if (a !== Object(a) || b !== Object(b)) {
	        // If the values aren't objects, they were already checked for equality
	        return false;
	    }
	    var props = Object.keys(a);
	    if (props.length !== Object.keys(b).length) {
	        // Different number of props, don't bother to check
	        return false;
	    }
	    return props.every(function (p) {
	        return deepEqual(a[p], b[p]);
	    });
	}
	function getObjectValueByPath(obj, path, fallback) {
	    // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
	    if (!path || path.constructor !== String) return fallback;
	    path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
	    path = path.replace(/^\./, ''); // strip a leading dot
	    return getNestedValue(obj, path.split('.'), fallback);
	}
	function getPropertyFromItem(item, property, fallback) {
	    if (property == null) return item === undefined ? fallback : item;
	    if (item !== Object(item)) return fallback === undefined ? item : fallback;
	    if (typeof property === 'string') return getObjectValueByPath(item, property, fallback);
	    if (Array.isArray(property)) return getNestedValue(item, property, fallback);
	    if (typeof property !== 'function') return fallback;
	    var value = property(item, fallback);
	    return typeof value === 'undefined' ? fallback : value;
	}
	function createRange(length) {
	    return Array.from({ length: length }, function (v, k) {
	        return k;
	    });
	}
	function getZIndex(el) {
	    if (!el || el.nodeType !== Node.ELEMENT_NODE) return 0;
	    var index = +window.getComputedStyle(el).getPropertyValue('z-index');
	    if (isNaN(index)) return getZIndex(el.parentNode);
	    return index;
	}
	var tagsToReplace = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;'
	};
	function escapeHTML(str) {
	    return str.replace(/[&<>]/g, function (tag) {
	        return tagsToReplace[tag] || tag;
	    });
	}
	function filterObjectOnKeys(obj, keys) {
	    var filtered = {};
	    for (var i = 0; i < keys.length; i++) {
	        var key = keys[i];
	        if (typeof obj[key] !== 'undefined') {
	            filtered[key] = obj[key];
	        }
	    }
	    return filtered;
	}
	function filterChildren(array, tag) {
	    if (array === void 0) {
	        array = [];
	    }
	    return array.filter(function (child) {
	        return child.componentOptions && child.componentOptions.Ctor.options.name === tag;
	    });
	}
	function convertToUnit(str, unit) {
	    if (unit === void 0) {
	        unit = 'px';
	    }
	    if (str == null || str === '') {
	        return undefined;
	    } else if (isNaN(+str)) {
	        return String(str);
	    } else {
	        return "" + Number(str) + unit;
	    }
	}
	function kebabCase(str) {
	    return (str || '').replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
	}
	function isObject(obj) {
	    return obj !== null && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
	}
	// KeyboardEvent.keyCode aliases
	var keyCodes = Object.freeze({
	    enter: 13,
	    tab: 9,
	    delete: 46,
	    esc: 27,
	    space: 32,
	    up: 38,
	    down: 40,
	    left: 37,
	    right: 39,
	    end: 35,
	    home: 36,
	    del: 46,
	    backspace: 8,
	    insert: 45,
	    pageup: 33,
	    pagedown: 34
	});
	var ICONS_PREFIX = '$vuetify.icons.';
	// This remaps internal names like '$vuetify.icons.cancel'
	// to the current name or component for that icon.
	function remapInternalIcon(vm, iconName) {
	    if (!iconName.startsWith(ICONS_PREFIX)) {
	        return iconName;
	    }
	    // Now look up icon indirection name, e.g. '$vuetify.icons.cancel'
	    return getObjectValueByPath(vm, iconName, iconName);
	}
	function keys(o) {
	    return Object.keys(o);
	}
	/**
	 * Camelize a hyphen-delimited string.
	 */
	var camelizeRE = /-(\w)/g;
	var camelize = function camelize(str) {
	    return str.replace(camelizeRE, function (_, c) {
	        return c ? c.toUpperCase() : '';
	    });
	};
	/**
	 * Returns the set difference of B and A, i.e. the set of elements in B but not in A
	 */
	function arrayDiff(a, b) {
	    var diff = [];
	    for (var i = 0; i < b.length; i++) {
	        if (a.indexOf(b[i]) < 0) diff.push(b[i]);
	    }
	    return diff;
	}
	/**
	 * Makes the first character of a string uppercase
	 */
	function upperFirst(str) {
	    return str.charAt(0).toUpperCase() + str.slice(1);
	}
	/**
	 * Returns:
	 *  - 'normal' for old style slots - `<template slot="default">`
	 *  - 'scoped' for old style scoped slots (`<template slot="default" slot-scope="data">`) or bound v-slot (`#default="data"`)
	 *  - 'v-slot' for unbound v-slot (`#default`) - only if the third param is true, otherwise counts as scoped
	 */
	function getSlotType(vm, name, split) {
	    if (vm.$slots[name] && vm.$scopedSlots[name] && vm.$scopedSlots[name].name) {
	        return split ? 'v-slot' : 'scoped';
	    }
	    if (vm.$slots[name]) return 'normal';
	    if (vm.$scopedSlots[name]) return 'scoped';
	}
	
	/***/ }),
	
	/***/ "./src/util/mask.ts":
	/*!**************************!*\
	  !*** ./src/util/mask.ts ***!
	  \**************************/
	/*! exports provided: defaultDelimiters, isMaskDelimiter, maskText, unmaskText */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultDelimiters", function() { return defaultDelimiters; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isMaskDelimiter", function() { return isMaskDelimiter; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "maskText", function() { return maskText; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unmaskText", function() { return unmaskText; });
	var defaultDelimiters = /[-!$%^&*()_+|~=`{}[\]:";'<>?,./\\ ]/;
	var isMaskDelimiter = function isMaskDelimiter(char) {
	    return char ? defaultDelimiters.test(char) : false;
	};
	var allowedMasks = {
	    '#': {
	        test: function test(char) {
	            return (/[0-9]/.test(char)
	            );
	        }
	    },
	    'A': {
	        test: function test(char) {
	            return (/[A-Z]/i.test(char)
	            );
	        },
	        convert: function convert(char) {
	            return char.toUpperCase();
	        }
	    },
	    'a': {
	        test: function test(char) {
	            return (/[a-z]/i.test(char)
	            );
	        },
	        convert: function convert(char) {
	            return char.toLowerCase();
	        }
	    },
	    'N': {
	        test: function test(char) {
	            return (/[0-9A-Z]/i.test(char)
	            );
	        },
	        convert: function convert(char) {
	            return char.toUpperCase();
	        }
	    },
	    'n': {
	        test: function test(char) {
	            return (/[0-9a-z]/i.test(char)
	            );
	        },
	        convert: function convert(char) {
	            return char.toLowerCase();
	        }
	    },
	    'X': {
	        test: isMaskDelimiter
	    }
	};
	var isMask = function isMask(char) {
	    return allowedMasks.hasOwnProperty(char);
	};
	var convert = function convert(mask, char) {
	    return allowedMasks[mask].convert ? allowedMasks[mask].convert(char) : char;
	};
	var maskValidates = function maskValidates(mask, char) {
	    if (char == null || !isMask(mask)) return false;
	    return allowedMasks[mask].test(char);
	};
	var maskText = function maskText(text, masked, dontFillMaskBlanks) {
	    if (text == null) return '';
	    text = String(text);
	    if (!masked.length || !text.length) return text;
	    if (!Array.isArray(masked)) masked = masked.split('');
	    var textIndex = 0;
	    var maskIndex = 0;
	    var newText = '';
	    while (maskIndex < masked.length) {
	        var mask = masked[maskIndex];
	        // Assign the next character
	        var char = text[textIndex];
	        // Check if mask is delimiter
	        // and current char matches
	        if (!isMask(mask) && char === mask) {
	            newText += mask;
	            textIndex++;
	            // Check if not mask
	        } else if (!isMask(mask) && !dontFillMaskBlanks) {
	            newText += mask;
	            // Check if is mask and validates
	        } else if (maskValidates(mask, char)) {
	            newText += convert(mask, char);
	            textIndex++;
	        } else {
	            return newText;
	        }
	        maskIndex++;
	    }
	    return newText;
	};
	var unmaskText = function unmaskText(text) {
	    return text ? String(text).replace(new RegExp(defaultDelimiters, 'g'), '') : text;
	};
	
	/***/ }),
	
	/***/ "./src/util/mixins.ts":
	/*!****************************!*\
	  !*** ./src/util/mixins.ts ***!
	  \****************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return mixins; });
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
	/* eslint-disable max-len, import/export, no-use-before-define */
	
	function mixins() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    return vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({ mixins: args });
	}
	
	/***/ }),
	
	/***/ "./src/util/rebuildFunctionalSlots.ts":
	/*!********************************************!*\
	  !*** ./src/util/rebuildFunctionalSlots.ts ***!
	  \********************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return rebuildFunctionalSlots; });
	function rebuildFunctionalSlots(slots, h) {
	    var children = [];
	    for (var slot in slots) {
	        if (slots.hasOwnProperty(slot)) {
	            children.push(h('template', { slot: slot }, slots[slot]));
	        }
	    }
	    return children;
	}
	
	/***/ }),
	
	/***/ "./src/util/theme.ts":
	/*!***************************!*\
	  !*** ./src/util/theme.ts ***!
	  \***************************/
	/*! exports provided: parse, genStyles, genVariations */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parse", function() { return parse; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "genStyles", function() { return genStyles; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "genVariations", function() { return genVariations; });
	/* harmony import */ var _colorUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./colorUtils */ "./src/util/colorUtils.ts");
	/* harmony import */ var _color_transformSRGB__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./color/transformSRGB */ "./src/util/color/transformSRGB.ts");
	/* harmony import */ var _color_transformCIELAB__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./color/transformCIELAB */ "./src/util/color/transformCIELAB.ts");
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var __read = undefined && undefined.__read || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o),
	        r,
	        ar = [],
	        e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
	            ar.push(r.value);
	        }
	    } catch (error) {
	        e = { error: error };
	    } finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        } finally {
	            if (e) throw e.error;
	        }
	    }
	    return ar;
	};
	
	
	
	function parse(theme, isItem) {
	    if (isItem === void 0) {
	        isItem = false;
	    }
	    var colors = Object.keys(theme);
	    var parsedTheme = {};
	    for (var i = 0; i < colors.length; ++i) {
	        var name = colors[i];
	        var value = theme[name];
	        if (isItem) {
	            if (name === 'base' || name.startsWith('lighten') || name.startsWith('darken')) {
	                parsedTheme[name] = Object(_colorUtils__WEBPACK_IMPORTED_MODULE_0__["colorToHex"])(value);
	            }
	        } else if ((typeof value === "undefined" ? "undefined" : _typeof(value)) === 'object') {
	            parsedTheme[name] = parse(value, true);
	        } else {
	            parsedTheme[name] = genVariations(name, Object(_colorUtils__WEBPACK_IMPORTED_MODULE_0__["colorToInt"])(value));
	        }
	    }
	    return parsedTheme;
	}
	/**
	 * Generate the CSS for a base color (.primary)
	 */
	var genBaseColor = function genBaseColor(name, value) {
	    return "\n." + name + " {\n  background-color: " + value + " !important;\n  border-color: " + value + " !important;\n}\n." + name + "--text {\n  color: " + value + " !important;\n  caret-color: " + value + " !important;\n}";
	};
	/**
	 * Generate the CSS for a variant color (.primary.darken-2)
	 */
	var genVariantColor = function genVariantColor(name, variant, value) {
	    var _a = __read(variant.split(/(\d)/, 2), 2),
	        type = _a[0],
	        n = _a[1];
	    return "\n." + name + "." + type + "-" + n + " {\n  background-color: " + value + " !important;\n  border-color: " + value + " !important;\n}\n." + name + "--text.text--" + type + "-" + n + " {\n  color: " + value + " !important;\n  caret-color: " + value + " !important;\n}";
	};
	var genColorVariableName = function genColorVariableName(name, variant) {
	    if (variant === void 0) {
	        variant = 'base';
	    }
	    return "--v-" + name + "-" + variant;
	};
	var genColorVariable = function genColorVariable(name, variant) {
	    if (variant === void 0) {
	        variant = 'base';
	    }
	    return "var(" + genColorVariableName(name, variant) + ")";
	};
	function genStyles(theme, cssVar) {
	    if (cssVar === void 0) {
	        cssVar = false;
	    }
	    var colors = Object.keys(theme);
	    if (!colors.length) return '';
	    var variablesCss = '';
	    var css = '';
	    var aColor = cssVar ? genColorVariable('primary') : theme.primary.base;
	    css += "a { color: " + aColor + "; }";
	    for (var i = 0; i < colors.length; ++i) {
	        var name = colors[i];
	        var value = theme[name];
	        if ((typeof value === "undefined" ? "undefined" : _typeof(value)) !== 'object') continue;
	        css += genBaseColor(name, cssVar ? genColorVariable(name) : value.base);
	        cssVar && (variablesCss += "  " + genColorVariableName(name) + ": " + value.base + ";\n");
	        var variants = Object.keys(value);
	        for (var i_1 = 0; i_1 < variants.length; ++i_1) {
	            var variant = variants[i_1];
	            var variantValue = value[variant];
	            if (variant === 'base') continue;
	            css += genVariantColor(name, variant, cssVar ? genColorVariable(name, variant) : variantValue);
	            cssVar && (variablesCss += "  " + genColorVariableName(name, variant) + ": " + variantValue + ";\n");
	        }
	    }
	    if (cssVar) {
	        variablesCss = ":root {\n" + variablesCss + "}\n\n";
	    }
	    return variablesCss + css;
	}
	function genVariations(name, value) {
	    var values = {
	        base: Object(_colorUtils__WEBPACK_IMPORTED_MODULE_0__["intToHex"])(value)
	    };
	    for (var i = 5; i > 0; --i) {
	        values["lighten" + i] = Object(_colorUtils__WEBPACK_IMPORTED_MODULE_0__["intToHex"])(lighten(value, i));
	    }
	    for (var i = 1; i <= 4; ++i) {
	        values["darken" + i] = Object(_colorUtils__WEBPACK_IMPORTED_MODULE_0__["intToHex"])(darken(value, i));
	    }
	    return values;
	}
	function lighten(value, amount) {
	    var lab = _color_transformCIELAB__WEBPACK_IMPORTED_MODULE_2__["fromXYZ"](_color_transformSRGB__WEBPACK_IMPORTED_MODULE_1__["toXYZ"](value));
	    lab[0] = lab[0] + amount * 10;
	    return _color_transformSRGB__WEBPACK_IMPORTED_MODULE_1__["fromXYZ"](_color_transformCIELAB__WEBPACK_IMPORTED_MODULE_2__["toXYZ"](lab));
	}
	function darken(value, amount) {
	    var lab = _color_transformCIELAB__WEBPACK_IMPORTED_MODULE_2__["fromXYZ"](_color_transformSRGB__WEBPACK_IMPORTED_MODULE_1__["toXYZ"](value));
	    lab[0] = lab[0] - amount * 10;
	    return _color_transformSRGB__WEBPACK_IMPORTED_MODULE_1__["fromXYZ"](_color_transformCIELAB__WEBPACK_IMPORTED_MODULE_2__["toXYZ"](lab));
	}
	
	/***/ }),
	
	/***/ "vue":
	/*!******************************************************************************!*\
	  !*** external {"commonjs":"vue","commonjs2":"vue","amd":"vue","root":"Vue"} ***!
	  \******************************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_vue__;
	
	/***/ })
	
	/******/ })["default"];
	});
	//# sourceMappingURL=vuetify.js.map

/***/ }),
/* 613 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if (media) {
			styleElement.setAttribute("media", media);
		}
	
		if (sourceMap) {
			// https://developer.chrome.com/devtools/docs/javascript-debugging
			// this makes source maps inside style tags work properly in Chrome
			css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */';
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}


/***/ })
]);


// WEBPACK FOOTER //
// static/js/vendor.dbc6450aca292c94ce25.js